/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1772);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(131);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _configuration = __webpack_require__(1471);

var _default = {
  get: _configuration.get,
  set: _configuration.set,
  serialize: _configuration.serialize,
  setEnvironment: _configuration.setEnvironment
};
exports["default"] = _default;

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// Importação do Router



var PropTypes = __webpack_require__(5);

var RequestApi = function (_Component) {
  _inherits(RequestApi, _Component);

  // constructor
  function RequestApi(props, context) {
    _classCallCheck(this, RequestApi);

    var _this = _possibleConstructorReturn(this, (RequestApi.__proto__ || Object.getPrototypeOf(RequestApi)).call(this, props, context));

    _this.state = {
      client_id: __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('client_id'),
      client_secret: __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('client_secret')
    };

    _this.validate = _this.validate.bind(_this);
    _this.handleErrors = _this.handleErrors.bind(_this);
    _this.verifyPermission = _this.verifyPermission.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Faço 4 verificações:
  // 1) Se houve resposta em json. Se não houve, houve erro na api e deve ser informado
  // 2) Se o sistema não está suspenso;
  // 3) se o usuário não está logado;
  // 4) se o usuário tem permissão para acessar a ação;


  _createClass(RequestApi, [{
    key: 'validate',
    value: function validate(responseJson, mode, url) {
      // 1) Verifico se o houve erro
      /*
      if(typeof responseJson === 'undefined') {
          var storage = {
            alert_message: 'Houve um erro ao tentar processar os dados dessa página ou ação',
            alert_type: 'error',
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          this.context.router.history.goBack();
      }
      */

      // 2) Verifico se o usuário está supenso
      if (typeof responseJson.suspended !== 'undefined') {
        this.context.router.history.push('/usuario/suspenso');
      }

      // 3) Verifico se o usuário está logado
      else if (typeof responseJson.error !== 'undefined') {
          this.context.router.history.push('/usuario/login');
        }

        // 4) Verifico se o usuário está logado
        else if (typeof responseJson.redirect_page !== 'undefined') {
            this.context.router.history.push('/usuario/login');
          }

          // 3) Verifico se o usuário não tem permisão
          else if (typeof responseJson.permission_denied !== 'undefined') {
              if (mode === 'url') {
                var storage = {
                  alert_message: this.locale.Miscelania.RequestApi.seuUsuarioNaoTemPermissaoParaAcessarEstaPagina,
                  alert_type: 'error'
                };
                localStorage.setItem("verify_message", JSON.stringify(storage));
                //this.context.router.history.goBack();
              }
              if (mode === 'alert') {
                responseJson['message'] = this.locale.Miscelania.RequestApi.seuUsuarioNaoTemPermissaoParaAcessarEstaFuncionalidade;
                responseJson['status'] = 'error';
              }
            }

      // 5) Verifico se retornou algum bugreport
      if (typeof responseJson.debug !== 'undefined') {
        if (mode === 'url') {
          var storage = {
            alert_message: responseJson.message,
            alert_type: 'error'
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          //this.context.router.history.goBack();
        }
        if (mode === 'alert') {
          responseJson['message'] = responseJson.message;
          responseJson['status'] = 'error';
        }
      }

      // 6) Verifico se retornou algum erro
      else if (responseJson.status === 'error') {
          if (mode === 'url') {
            var storage = {
              alert_message: responseJson.message,
              alert_type: responseJson.status
            };
            localStorage.setItem("verify_message", JSON.stringify(storage));
            //this.context.router.history.push(url);
            throw 'invalida data';
          }
          if (mode === 'alert') {
            //window.history.back();
          }
        }
    }
  }, {
    key: 'handleErrors',
    value: function handleErrors(errors) {}
  }, {
    key: 'verifyPermission',
    value: function verifyPermission(errors) {}
  }, {
    key: 'header',
    value: function header(type) {
      // busco as infos
      var params = JSON.parse(localStorage.getItem("cid"));
      // Verifico se há algum storage setado
      if (params === null || typeof params === 'undefined') {
        this.context.router.history.push('/usuario/login');
      } else {
        // Verifico se o cid acode setado
        if (params.acode === null || typeof params.acode === 'undefined') {
          this.context.router.history.push('/usuario/login');
        } else {
          if (this.props.handleLoaded !== null && typeof this.props.handleLoaded !== 'undefined') {
            this.props.handleLoaded(1);
          }
          var auth = 'Bearer ' + params.acode;
          if (type === null || typeof type === 'undefined') {
            var header = {
              'Authorization': auth
            };
          } else {
            var header = {
              'Accept': type,
              'Content-Type': type,
              'Authorization': auth
            };
          }
          return header;
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', null);
    }
  }]);

  return RequestApi;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

RequestApi.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (RequestApi);

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pt_BR__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__en_US__ = __webpack_require__(983);



var getLocale = function getLocale() {
  var lang = localStorage.getItem("lang");
  var locale = __WEBPACK_IMPORTED_MODULE_0__pt_BR__["a" /* default */];
  switch (lang) {
    case 'pt-BR':
      locale = __WEBPACK_IMPORTED_MODULE_0__pt_BR__["a" /* default */];
      break;
    case 'en-US':
      locale = __WEBPACK_IMPORTED_MODULE_1__en_US__["a" /* default */];
      break;
    default:
      locale = __WEBPACK_IMPORTED_MODULE_0__pt_BR__["a" /* default */];
      break;
  }

  return locale();
};

/* harmony default export */ __webpack_exports__["a"] = (getLocale);

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// https://github.com/sanniassin/react-input-mask

var React = __webpack_require__(0);

var InputElement = function (_React$Component) {
    _inherits(InputElement, _React$Component);

    function InputElement(props) {
        _classCallCheck(this, InputElement);

        var _this = _possibleConstructorReturn(this, (InputElement.__proto__ || Object.getPrototypeOf(InputElement)).call(this, props));

        _initialiseProps.call(_this);

        _this.hasValue = props.value != null;
        _this.charsRules = props.formatChars != null ? props.formatChars : _this.defaultCharsRules;

        var mask = _this.parseMask(props.mask);
        var defaultValue = props.defaultValue != null ? props.defaultValue : '';
        var value = props.value != null ? props.value : defaultValue;

        value = _this.getStringValue(value);

        _this.mask = mask.mask;
        _this.permanents = mask.permanents;
        _this.lastEditablePos = mask.lastEditablePos;
        _this.maskChar = "maskChar" in props ? props.maskChar : _this.defaultMaskChar;

        if (_this.mask && (props.alwaysShowMask || value)) {
            value = _this.formatValue(value);
        }

        _this.state = { value: value };
        return _this;
    }

    return InputElement;
}(React.Component);

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.defaultCharsRules = {
        "9": "[0-9]",
        "a": "[A-Za-z]",
        "*": "[A-Za-z0-9]"
    };
    this.defaultMaskChar = "_";
    this.lastCursorPos = null;

    this.isAndroidBrowser = function () {
        var windows = new RegExp("windows", "i");
        var firefox = new RegExp("firefox", "i");
        var android = new RegExp("android", "i");
        var ua = navigator.userAgent;
        return !windows.test(ua) && !firefox.test(ua) && android.test(ua);
    };

    this.isWindowsPhoneBrowser = function () {
        var windows = new RegExp("windows", "i");
        var phone = new RegExp("phone", "i");
        var ua = navigator.userAgent;
        return windows.test(ua) && phone.test(ua);
    };

    this.isAndroidFirefox = function () {
        var windows = new RegExp("windows", "i");
        var firefox = new RegExp("firefox", "i");
        var android = new RegExp("android", "i");
        var ua = navigator.userAgent;
        return !windows.test(ua) && firefox.test(ua) && android.test(ua);
    };

    this.isDOMElement = function (element) {
        return (typeof HTMLElement === "undefined" ? "undefined" : _typeof(HTMLElement)) === "object" ? element instanceof HTMLElement // DOM2
        : element.nodeType === 1 && typeof element.nodeName === "string";
    };

    this.getInputDOMNode = function () {
        var input = _this2.input;

        if (!input) {
            return null;
        }

        if (_this2.isDOMElement(input)) {
            return input;
        }

        // React 0.13
        return React.findDOMNode(input);
    };

    this.enableValueAccessors = function () {
        if (_this2.canUseAccessors) {
            var input = _this2.getInputDOMNode();
            _this2.valueDescriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(input), 'value');
            Object.defineProperty(input, 'value', {
                configurable: true,
                enumerable: true,
                get: function get() {
                    return _this2.value;
                },
                set: function set(val) {
                    _this2.value = val;
                    _this2.valueDescriptor.set.call(input, val);
                }
            });
        }
    };

    this.disableValueAccessors = function () {
        var valueDescriptor = _this2.valueDescriptor;

        if (!valueDescriptor) {
            return;
        }
        _this2.valueDescriptor = null;
        var input = _this2.getInputDOMNode();
        Object.defineProperty(input, 'value', valueDescriptor);
    };

    this.getInputValue = function () {
        var input = _this2.getInputDOMNode();
        var valueDescriptor = _this2.valueDescriptor;


        var value;
        if (valueDescriptor) {
            value = valueDescriptor.get.call(input);
        } else {
            value = input.value;
        }

        return value;
    };

    this.setInputValue = function (val) {
        var input = _this2.getInputDOMNode();
        _this2.value = val;
        input.value = val;
    };

    this.getPrefix = function () {
        var prefix = "";
        var mask = _this2.mask;

        for (var i = 0; i < mask.length && _this2.isPermanentChar(i); ++i) {
            prefix += mask[i];
        }
        return prefix;
    };

    this.getFilledLength = function () {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.state.value;

        var i;
        var maskChar = _this2.maskChar;


        if (!maskChar) {
            return value.length;
        }

        for (i = value.length - 1; i >= 0; --i) {
            var character = value[i];
            if (!_this2.isPermanentChar(i) && _this2.isAllowedChar(character, i)) {
                break;
            }
        }

        return ++i || _this2.getPrefix().length;
    };

    this.getLeftEditablePos = function (pos) {
        for (var i = pos; i >= 0; --i) {
            if (!_this2.isPermanentChar(i)) {
                return i;
            }
        }
        return null;
    };

    this.getRightEditablePos = function (pos) {
        var mask = _this2.mask;

        for (var i = pos; i < mask.length; ++i) {
            if (!_this2.isPermanentChar(i)) {
                return i;
            }
        }
        return null;
    };

    this.isEmpty = function () {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.state.value;

        return !value.split("").some(function (character, i) {
            return !_this2.isPermanentChar(i) && _this2.isAllowedChar(character, i);
        });
    };

    this.isFilled = function () {
        var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this2.state.value;

        return _this2.getFilledLength(value) === _this2.mask.length;
    };

    this.createFilledArray = function (length, val) {
        var array = [];
        for (var i = 0; i < length; i++) {
            array[i] = val;
        }
        return array;
    };

    this.formatValue = function (value) {
        var maskChar = _this2.maskChar,
            mask = _this2.mask;

        if (!maskChar) {
            var prefix = _this2.getPrefix();
            var prefixLen = prefix.length;
            value = _this2.insertRawSubstr("", value, 0);
            while (value.length > prefixLen && _this2.isPermanentChar(value.length - 1)) {
                value = value.slice(0, value.length - 1);
            }

            if (value.length < prefixLen) {
                value = prefix;
            }

            return value;
        }
        if (value) {
            var emptyValue = _this2.formatValue("");
            return _this2.insertRawSubstr(emptyValue, value, 0);
        }
        return value.split("").concat(_this2.createFilledArray(mask.length - value.length, null)).map(function (character, pos) {
            if (_this2.isAllowedChar(character, pos)) {
                return character;
            } else if (_this2.isPermanentChar(pos)) {
                return mask[pos];
            }
            return maskChar;
        }).join("");
    };

    this.clearRange = function (value, start, len) {
        var end = start + len;
        var maskChar = _this2.maskChar,
            mask = _this2.mask;

        if (!maskChar) {
            var prefixLen = _this2.getPrefix().length;
            value = value.split("").filter(function (character, i) {
                return i < prefixLen || i < start || i >= end;
            }).join("");
            return _this2.formatValue(value);
        }
        return value.split("").map(function (character, i) {
            if (i < start || i >= end) {
                return character;
            }
            if (_this2.isPermanentChar(i)) {
                return mask[i];
            }
            return maskChar;
        }).join("");
    };

    this.replaceSubstr = function (value, newSubstr, pos) {
        return value.slice(0, pos) + newSubstr + value.slice(pos + newSubstr.length);
    };

    this.insertRawSubstr = function (value, substr, pos) {
        var mask = _this2.mask,
            maskChar = _this2.maskChar;

        var isFilled = _this2.isFilled(value);
        var prefixLen = _this2.getPrefix().length;
        substr = substr.split("");

        if (!maskChar && pos > value.length) {
            value += mask.slice(value.length, pos);
        }

        for (var i = pos; i < mask.length && substr.length;) {
            var isPermanent = _this2.isPermanentChar(i);
            if (!isPermanent || mask[i] === substr[0]) {
                var character = substr.shift();
                if (_this2.isAllowedChar(character, i, true)) {
                    if (i < value.length) {
                        if (maskChar || isFilled || i < prefixLen) {
                            value = _this2.replaceSubstr(value, character, i);
                        } else {
                            value = _this2.formatValue(value.substr(0, i) + character + value.substr(i));
                        }
                    } else if (!maskChar) {
                        value += character;
                    }
                    ++i;
                }
            } else {
                if (!maskChar && i >= value.length) {
                    value += mask[i];
                } else if (maskChar && isPermanent && substr[0] === maskChar) {
                    substr.shift();
                }
                ++i;
            }
        }
        return value;
    };

    this.getRawSubstrLength = function (value, substr, pos) {
        var mask = _this2.mask,
            maskChar = _this2.maskChar;

        substr = substr.split("");
        for (var i = pos; i < mask.length && substr.length;) {
            if (!_this2.isPermanentChar(i) || mask[i] === substr[0]) {
                var character = substr.shift();
                if (_this2.isAllowedChar(character, i, true)) {
                    ++i;
                }
            } else {
                ++i;
            }
        }
        return i - pos;
    };

    this.isAllowedChar = function (character, pos) {
        var allowMaskChar = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var mask = _this2.mask,
            maskChar = _this2.maskChar;

        if (_this2.isPermanentChar(pos)) {
            return mask[pos] === character;
        }
        var ruleChar = mask[pos];
        var charRule = _this2.charsRules[ruleChar];
        return new RegExp(charRule).test(character || "") || allowMaskChar && character === maskChar;
    };

    this.isPermanentChar = function (pos) {
        return _this2.permanents.indexOf(pos) !== -1;
    };

    this.setCursorToEnd = function () {
        var filledLen = _this2.getFilledLength();
        var pos = _this2.getRightEditablePos(filledLen);
        if (pos !== null) {
            _this2.setCursorPos(pos);
        }
    };

    this.setSelection = function (start) {
        var len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        var input = _this2.getInputDOMNode();
        if (!input) {
            return;
        }

        var end = start + len;
        if ("selectionStart" in input && "selectionEnd" in input) {
            input.selectionStart = start;
            input.selectionEnd = end;
        } else {
            var range = input.createTextRange();
            range.collapse(true);
            range.moveStart("character", start);
            range.moveEnd("character", end - start);
            range.select();
        }
    };

    this.getSelection = function () {
        var input = _this2.getInputDOMNode();
        var start = 0;
        var end = 0;

        if ("selectionStart" in input && "selectionEnd" in input) {
            start = input.selectionStart;
            end = input.selectionEnd;
        } else {
            var range = document.selection.createRange();
            if (range.parentElement() === input) {
                start = -range.moveStart("character", -input.value.length);
                end = -range.moveEnd("character", -input.value.length);
            }
        }

        return {
            start: start,
            end: end,
            length: end - start
        };
    };

    this.getCursorPos = function () {
        return _this2.getSelection().start;
    };

    this.setCursorPos = function (pos) {
        var raf = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function (fn) {
            return setTimeout(fn, 0);
        };

        var setPos = _this2.setSelection.bind(_this2, pos, 0);

        setPos();
        raf(setPos);

        _this2.lastCursorPos = pos;
    };

    this.isFocused = function () {
        return document.activeElement === _this2.getInputDOMNode();
    };

    this.parseMask = function (mask) {
        if (!mask || typeof mask !== "string") {
            return {
                mask: null,
                lastEditablePos: null,
                permanents: []
            };
        }
        var str = "";
        var permanents = [];
        var isPermanent = false;
        var lastEditablePos = null;

        mask.split("").forEach(function (character) {
            if (!isPermanent && character === "\\") {
                isPermanent = true;
            } else {
                if (isPermanent || !_this2.charsRules[character]) {
                    permanents.push(str.length);
                } else {
                    lastEditablePos = str.length + 1;
                }
                str += character;
                isPermanent = false;
            }
        });

        return {
            mask: str,
            lastEditablePos: lastEditablePos,
            permanents: permanents
        };
    };

    this.getStringValue = function (value) {
        return !value && value !== 0 ? "" : value + "";
    };

    this.componentWillMount = function () {
        var mask = _this2.mask;
        var value = _this2.state.value;

        if (mask && value) {
            _this2.setState({ value: value });
        }
    };

    this.componentWillReceiveProps = function (nextProps) {
        _this2.hasValue = _this2.props.value != null;
        _this2.charsRules = nextProps.formatChars != null ? nextProps.formatChars : _this2.defaultCharsRules;

        var oldMask = _this2.mask;
        var mask = _this2.parseMask(nextProps.mask);
        var isMaskChanged = mask.mask && mask.mask !== _this2.mask;

        _this2.mask = mask.mask;
        _this2.permanents = mask.permanents;
        _this2.lastEditablePos = mask.lastEditablePos;
        _this2.maskChar = "maskChar" in nextProps ? nextProps.maskChar : _this2.defaultMaskChar;

        if (!_this2.mask) {
            _this2.lastCursorPos = null;
            return;
        }

        var newValue = nextProps.value != null ? _this2.getStringValue(nextProps.value) : _this2.state.value;

        if (!oldMask && nextProps.value == null) {
            newValue = _this2.getInputDOMNode().value;
        }

        var showEmpty = nextProps.alwaysShowMask || _this2.isFocused();
        if (isMaskChanged || mask.mask && (newValue || showEmpty)) {
            newValue = _this2.formatValue(newValue);

            if (isMaskChanged) {
                var pos = _this2.lastCursorPos;
                var filledLen = _this2.getFilledLength(newValue);
                if (pos === null || filledLen < pos) {
                    if (_this2.isFilled(newValue)) {
                        pos = filledLen;
                    } else {
                        pos = _this2.getRightEditablePos(filledLen);
                    }
                    _this2.setCursorPos(pos);
                }
            }
        }
        if (mask.mask && _this2.isEmpty(newValue) && !showEmpty && (!_this2.hasValue || !nextProps.value)) {
            newValue = "";
        }
        _this2.value = newValue;
        if (_this2.state.value !== newValue) {
            _this2.setState({ value: newValue });
        }
    };

    this.componentDidUpdate = function (prevProps, prevState) {
        if ((_this2.mask || prevProps.mask) && _this2.props.value == null) {
            _this2.updateUncontrolledInput();
        }
        if (_this2.valueDescriptor && _this2.getInputValue() !== _this2.state.value) {
            _this2.setInputValue(_this2.state.value);
        }
    };

    this.updateUncontrolledInput = function () {
        if (_this2.getInputValue() !== _this2.state.value) {
            _this2.setInputValue(_this2.state.value);
        }
    };

    this.onKeyDown = function (event) {
        var hasHandler = typeof _this2.props.onKeyDown === "function";
        if (event.ctrlKey || event.metaKey) {
            if (hasHandler) {
                _this2.props.onKeyDown(event);
            }
            return;
        }

        var cursorPos = _this2.getCursorPos();
        var value = _this2.state.value;
        var key = event.key;
        var preventDefault = false;
        switch (key) {
            case "Backspace":
            case "Delete":
                var prefixLen = _this2.getPrefix().length;
                var deleteFromRight = key === "Delete";
                var selectionRange = _this2.getSelection();
                if (selectionRange.length) {
                    value = _this2.clearRange(value, selectionRange.start, selectionRange.length);
                } else if (cursorPos < prefixLen || !deleteFromRight && cursorPos === prefixLen) {
                    cursorPos = prefixLen;
                } else {
                    var editablePos = deleteFromRight ? _this2.getRightEditablePos(cursorPos) : _this2.getLeftEditablePos(cursorPos - 1);
                    if (editablePos !== null) {
                        value = _this2.clearRange(value, editablePos, 1);
                        cursorPos = editablePos;
                    }
                }
                preventDefault = true;
                break;
            default:
                break;
        }

        if (hasHandler) {
            _this2.props.onKeyDown(event);
        }

        if (value !== _this2.state.value) {
            _this2.setInputValue(value);
            _this2.setState({
                value: _this2.hasValue ? _this2.state.value : value
            });
            preventDefault = true;
            if (typeof _this2.props.onChange === "function") {
                _this2.props.onChange(event);
            }
        }
        if (preventDefault) {
            event.preventDefault();
            _this2.setCursorPos(cursorPos);
        }
    };

    this.onKeyPress = function (event) {
        var key = event.key;
        var hasHandler = typeof _this2.props.onKeyPress === "function";
        if (key === "Enter" || event.ctrlKey || event.metaKey) {
            if (hasHandler) {
                _this2.props.onKeyPress(event);
            }
            return;
        }

        if (_this2.isWindowsPhoneBrowser) {
            return;
        }

        var cursorPos = _this2.getCursorPos();
        var selection = _this2.getSelection();
        var value = _this2.state.value;
        var mask = _this2.mask,
            maskChar = _this2.maskChar,
            lastEditablePos = _this2.lastEditablePos;

        var maskLen = mask.length;
        var prefixLen = _this2.getPrefix().length;

        if (_this2.isPermanentChar(cursorPos) && mask[cursorPos] === key) {
            value = _this2.insertRawSubstr(value, key, cursorPos);
            ++cursorPos;
        } else {
            var editablePos = _this2.getRightEditablePos(cursorPos);
            if (editablePos !== null && _this2.isAllowedChar(key, editablePos)) {
                value = _this2.clearRange(value, selection.start, selection.length);
                value = _this2.insertRawSubstr(value, key, editablePos);
                cursorPos = editablePos + 1;
            }
        }

        if (value !== _this2.state.value) {
            _this2.setInputValue(value);
            _this2.setState({
                value: _this2.hasValue ? _this2.state.value : value
            });
            if (typeof _this2.props.onChange === "function") {
                _this2.props.onChange(event);
            }
        }
        event.preventDefault();
        if (cursorPos < lastEditablePos && cursorPos > prefixLen) {
            cursorPos = _this2.getRightEditablePos(cursorPos);
        }
        _this2.setCursorPos(cursorPos);
    };

    this.onChange = function (event) {
        var pasteSelection = _this2.pasteSelection,
            mask = _this2.mask,
            maskChar = _this2.maskChar,
            lastEditablePos = _this2.lastEditablePos,
            preventEmptyChange = _this2.preventEmptyChange;

        var target = event.target;
        var value = _this2.getInputValue();
        if (!value && _this2.preventEmptyChange) {
            _this2.disableValueAccessors();
            _this2.preventEmptyChange = false;
            _this2.setInputValue(_this2.state.value);
            return;
        }
        var oldValue = _this2.state.value;
        if (pasteSelection) {
            _this2.pasteSelection = null;
            _this2.pasteText(oldValue, value, pasteSelection, event);
            return;
        }
        var selection = _this2.getSelection();
        var cursorPos = selection.end;
        var maskLen = mask.length;
        var valueLen = value.length;
        var oldValueLen = oldValue.length;
        var prefixLen = _this2.getPrefix().length;
        var clearedValue;

        if (valueLen > oldValueLen) {
            var substrLen = valueLen - oldValueLen;
            var startPos = selection.end - substrLen;
            var enteredSubstr = value.substr(startPos, substrLen);

            if (startPos < lastEditablePos && (substrLen !== 1 || enteredSubstr !== mask[startPos])) {
                cursorPos = _this2.getRightEditablePos(startPos);
            } else {
                cursorPos = startPos;
            }

            value = value.substr(0, startPos) + value.substr(startPos + substrLen);

            clearedValue = _this2.clearRange(value, startPos, maskLen - startPos);
            clearedValue = _this2.insertRawSubstr(clearedValue, enteredSubstr, cursorPos);

            value = _this2.insertRawSubstr(oldValue, enteredSubstr, cursorPos);

            if (substrLen !== 1 || cursorPos >= prefixLen && cursorPos < lastEditablePos) {
                cursorPos = _this2.getFilledLength(clearedValue);
            } else if (cursorPos < lastEditablePos) {
                cursorPos++;
            }
        } else if (valueLen < oldValueLen) {
            var removedLen = maskLen - valueLen;
            clearedValue = _this2.clearRange(oldValue, selection.end, removedLen);
            var substr = value.substr(0, selection.end);
            var clearOnly = substr === oldValue.substr(0, selection.end);

            if (maskChar) {
                value = _this2.insertRawSubstr(clearedValue, substr, 0);
            }

            clearedValue = _this2.clearRange(clearedValue, selection.end, maskLen - selection.end);
            clearedValue = _this2.insertRawSubstr(clearedValue, substr, 0);

            if (!clearOnly) {
                cursorPos = _this2.getFilledLength(clearedValue);
            } else if (cursorPos < prefixLen) {
                cursorPos = prefixLen;
            }
        }
        value = _this2.formatValue(value);

        if (_this2.isWindowsPhoneBrowser) {
            event.persist();
            setTimeout(function () {
                _this2.setInputValue(value);

                if (!_this2.hasValue) {
                    _this2.setState({
                        value: value
                    });
                }

                if (typeof _this2.props.onChange === "function") {
                    _this2.props.onChange(event);
                }

                _this2.setCursorPos(cursorPos);
            }, 0);
        } else {
            // prevent android autocomplete insertion on backspace
            if (!_this2.canUseAccessors || !_this2.isAndroidBrowser) {
                _this2.setInputValue(value);
            }

            if (_this2.canUseAccessors && (_this2.isAndroidFirefox && value && !_this2.getInputValue() || _this2.isAndroidBrowser)) {
                _this2.value = value;
                _this2.enableValueAccessors();
                if (_this2.isAndroidFirefox) {
                    _this2.preventEmptyChange = true;
                }
                setTimeout(function () {
                    _this2.preventEmptyChange = false;
                    _this2.disableValueAccessors();
                }, 0);
            }

            _this2.setState({
                value: _this2.hasValue ? _this2.state.value : value
            });

            if (typeof _this2.props.onChange === "function") {
                _this2.props.onChange(event);
            }

            _this2.setCursorPos(cursorPos);
        }
    };

    this.onFocus = function (event) {
        if (!_this2.state.value) {
            var prefix = _this2.getPrefix();
            var value = _this2.formatValue(prefix);
            var inputValue = _this2.formatValue(value);

            // do not use this.getInputValue and this.setInputValue as this.input
            // can be undefined at this moment if autoFocus attribute is set
            var isInputValueChanged = inputValue !== event.target.value;

            if (isInputValueChanged) {
                event.target.value = inputValue;
            }

            _this2.setState({
                value: _this2.hasValue ? _this2.state.value : inputValue
            }, _this2.setCursorToEnd);

            if (isInputValueChanged && typeof _this2.props.onChange === "function") {
                _this2.props.onChange(event);
            }
        } else if (_this2.getFilledLength() < _this2.mask.length) {
            _this2.setCursorToEnd();
        }

        if (typeof _this2.props.onFocus === "function") {
            _this2.props.onFocus(event);
        }
    };

    this.onBlur = function (event) {
        if (!_this2.props.alwaysShowMask && _this2.isEmpty(_this2.state.value)) {
            var inputValue = "";
            var isInputValueChanged = inputValue !== _this2.getInputValue();
            if (isInputValueChanged) {
                _this2.setInputValue(inputValue);
            }
            _this2.setState({
                value: _this2.hasValue ? _this2.state.value : ""
            });
            if (isInputValueChanged && typeof _this2.props.onChange === "function") {
                _this2.props.onChange(event);
            }
        }

        if (typeof _this2.props.onBlur === "function") {
            _this2.props.onBlur(event);
        }
    };

    this.onPaste = function (event) {
        if (_this2.isAndroidBrowser) {
            _this2.pasteSelection = _this2.getSelection();
            _this2.setInputValue("");
            return;
        }
        var text;
        if (window.clipboardData && window.clipboardData.getData) {
            // IE
            text = window.clipboardData.getData("Text");
        } else if (event.clipboardData && event.clipboardData.getData) {
            text = event.clipboardData.getData("text/plain");
        }
        if (text) {
            var value = _this2.state.value;
            var selection = _this2.getSelection();
            _this2.pasteText(value, text, selection, event);
        }
        event.preventDefault();
    };

    this.pasteText = function (value, text, selection, event) {
        var cursorPos = selection.start;
        if (selection.length) {
            value = _this2.clearRange(value, cursorPos, selection.length);
        }
        var textLen = _this2.getRawSubstrLength(value, text, cursorPos);
        value = _this2.insertRawSubstr(value, text, cursorPos);
        cursorPos += textLen;
        cursorPos = _this2.getRightEditablePos(cursorPos) || cursorPos;
        if (value !== _this2.getInputValue()) {
            if (event) {
                _this2.setInputValue(value);
            }
            _this2.setState({
                value: _this2.hasValue ? _this2.state.value : value
            });
            if (event && typeof _this2.props.onChange === "function") {
                _this2.props.onChange(event);
            }
        }
        _this2.setCursorPos(cursorPos);
    };

    this.componentDidMount = function () {
        _this2.isAndroidBrowser = _this2.isAndroidBrowser();
        _this2.isWindowsPhoneBrowser = _this2.isWindowsPhoneBrowser();
        _this2.isAndroidFirefox = _this2.isAndroidFirefox();

        var input = _this2.getInputDOMNode();

        // workaround for Jest
        // it doesn't mount a real node so input will be null
        if (input && Object.getOwnPropertyDescriptor && Object.getPrototypeOf && Object.defineProperty) {
            var valueDescriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(input), 'value');
            _this2.canUseAccessors = !!(valueDescriptor && valueDescriptor.get && valueDescriptor.set);
        }

        if (_this2.mask && _this2.props.value == null) {
            _this2.updateUncontrolledInput();
        }
    };

    this.render = function () {
        var _props = _this2.props,
            mask = _props.mask,
            alwaysShowMask = _props.alwaysShowMask,
            maskChar = _props.maskChar,
            formatChars = _props.formatChars,
            props = _objectWithoutProperties(_props, ["mask", "alwaysShowMask", "maskChar", "formatChars"]);

        if (_this2.mask) {
            if (!props.disabled && !props.readOnly) {
                var handlersKeys = ["onFocus", "onBlur", "onChange", "onKeyDown", "onKeyPress", "onPaste"];
                handlersKeys.forEach(function (key) {
                    props[key] = _this2[key];
                });
            }

            if (props.value != null) {
                props.value = _this2.state.value;
            }
        }
        return React.createElement("input", _extends({ ref: function ref(_ref) {
                return _this2.input = _ref;
            } }, props));
    };
};

module.exports = InputElement;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1307)();
}


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Async */
/* unused harmony export AsyncCreatable */
/* unused harmony export Creatable */
/* unused harmony export Value */
/* unused harmony export Option */
/* unused harmony export defaultMenuRenderer */
/* unused harmony export defaultArrowRenderer */
/* unused harmony export defaultClearRenderer */
/* unused harmony export defaultFilterOptions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);






var arrowRenderer = function arrowRenderer(_ref) {
	var onMouseDown = _ref.onMouseDown;

	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-arrow',
		onMouseDown: onMouseDown
	});
};

arrowRenderer.propTypes = {
	onMouseDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};

var clearRenderer = function clearRenderer() {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
};

var map = [{ 'base': 'A', 'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { 'base': 'AA', 'letters': /[\uA732]/g }, { 'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g }, { 'base': 'AO', 'letters': /[\uA734]/g }, { 'base': 'AU', 'letters': /[\uA736]/g }, { 'base': 'AV', 'letters': /[\uA738\uA73A]/g }, { 'base': 'AY', 'letters': /[\uA73C]/g }, { 'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { 'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { 'base': 'D', 'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { 'base': 'DZ', 'letters': /[\u01F1\u01C4]/g }, { 'base': 'Dz', 'letters': /[\u01F2\u01C5]/g }, { 'base': 'E', 'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { 'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { 'base': 'G', 'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { 'base': 'H', 'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { 'base': 'I', 'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { 'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { 'base': 'K', 'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { 'base': 'L', 'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { 'base': 'LJ', 'letters': /[\u01C7]/g }, { 'base': 'Lj', 'letters': /[\u01C8]/g }, { 'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { 'base': 'N', 'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { 'base': 'NJ', 'letters': /[\u01CA]/g }, { 'base': 'Nj', 'letters': /[\u01CB]/g }, { 'base': 'O', 'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { 'base': 'OI', 'letters': /[\u01A2]/g }, { 'base': 'OO', 'letters': /[\uA74E]/g }, { 'base': 'OU', 'letters': /[\u0222]/g }, { 'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { 'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { 'base': 'R', 'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { 'base': 'S', 'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { 'base': 'T', 'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { 'base': 'TZ', 'letters': /[\uA728]/g }, { 'base': 'U', 'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { 'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { 'base': 'VY', 'letters': /[\uA760]/g }, { 'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { 'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { 'base': 'Y', 'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { 'base': 'Z', 'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { 'base': 'a', 'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { 'base': 'aa', 'letters': /[\uA733]/g }, { 'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g }, { 'base': 'ao', 'letters': /[\uA735]/g }, { 'base': 'au', 'letters': /[\uA737]/g }, { 'base': 'av', 'letters': /[\uA739\uA73B]/g }, { 'base': 'ay', 'letters': /[\uA73D]/g }, { 'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { 'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { 'base': 'd', 'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { 'base': 'dz', 'letters': /[\u01F3\u01C6]/g }, { 'base': 'e', 'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { 'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { 'base': 'g', 'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { 'base': 'h', 'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { 'base': 'hv', 'letters': /[\u0195]/g }, { 'base': 'i', 'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { 'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { 'base': 'k', 'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { 'base': 'l', 'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { 'base': 'lj', 'letters': /[\u01C9]/g }, { 'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { 'base': 'n', 'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { 'base': 'nj', 'letters': /[\u01CC]/g }, { 'base': 'o', 'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { 'base': 'oi', 'letters': /[\u01A3]/g }, { 'base': 'ou', 'letters': /[\u0223]/g }, { 'base': 'oo', 'letters': /[\uA74F]/g }, { 'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { 'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { 'base': 'r', 'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { 'base': 's', 'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { 'base': 't', 'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { 'base': 'tz', 'letters': /[\uA729]/g }, { 'base': 'u', 'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { 'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { 'base': 'vy', 'letters': /[\uA761]/g }, { 'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { 'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { 'base': 'y', 'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { 'base': 'z', 'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

var stripDiacritics = function stripDiacritics(str) {
	for (var i = 0; i < map.length; i++) {
		str = str.replace(map[i].letters, map[i].base);
	}
	return str;
};

var trim = function trim(str) {
  return str.replace(/^\s+|\s+$/g, '');
};

var isValid = function isValid(value) {
	return typeof value !== 'undefined' && value !== null && value !== '';
};

var filterOptions = function filterOptions(options, filterValue, excludeOptions, props) {
	if (props.ignoreAccents) {
		filterValue = stripDiacritics(filterValue);
	}

	if (props.ignoreCase) {
		filterValue = filterValue.toLowerCase();
	}

	if (props.trimFilter) {
		filterValue = trim(filterValue);
	}

	if (excludeOptions) excludeOptions = excludeOptions.map(function (i) {
		return i[props.valueKey];
	});

	return options.filter(function (option) {
		if (excludeOptions && excludeOptions.indexOf(option[props.valueKey]) > -1) return false;
		if (props.filterOption) return props.filterOption.call(undefined, option, filterValue);
		if (!filterValue) return true;

		var value = option[props.valueKey];
		var label = option[props.labelKey];
		var hasValue = isValid(value);
		var hasLabel = isValid(label);

		if (!hasValue && !hasLabel) {
			return false;
		}

		var valueTest = hasValue ? String(value) : null;
		var labelTest = hasLabel ? String(label) : null;

		if (props.ignoreAccents) {
			if (valueTest && props.matchProp !== 'label') valueTest = stripDiacritics(valueTest);
			if (labelTest && props.matchProp !== 'value') labelTest = stripDiacritics(labelTest);
		}

		if (props.ignoreCase) {
			if (valueTest && props.matchProp !== 'label') valueTest = valueTest.toLowerCase();
			if (labelTest && props.matchProp !== 'value') labelTest = labelTest.toLowerCase();
		}

		return props.matchPos === 'start' ? valueTest && props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || labelTest && props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : valueTest && props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || labelTest && props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
	});
};

var menuRenderer = function menuRenderer(_ref) {
	var focusedOption = _ref.focusedOption,
	    focusOption = _ref.focusOption,
	    inputValue = _ref.inputValue,
	    instancePrefix = _ref.instancePrefix,
	    onFocus = _ref.onFocus,
	    onOptionRef = _ref.onOptionRef,
	    onSelect = _ref.onSelect,
	    optionClassName = _ref.optionClassName,
	    optionComponent = _ref.optionComponent,
	    optionRenderer = _ref.optionRenderer,
	    options = _ref.options,
	    removeValue = _ref.removeValue,
	    selectValue = _ref.selectValue,
	    valueArray = _ref.valueArray,
	    valueKey = _ref.valueKey;

	var Option = optionComponent;

	return options.map(function (option, i) {
		var isSelected = valueArray && valueArray.some(function (x) {
			return x[valueKey] === option[valueKey];
		});
		var isFocused = option === focusedOption;
		var optionClass = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(optionClassName, {
			'Select-option': true,
			'is-selected': isSelected,
			'is-focused': isFocused,
			'is-disabled': option.disabled
		});

		return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
			Option,
			{
				className: optionClass,
				focusOption: focusOption,
				inputValue: inputValue,
				instancePrefix: instancePrefix,
				isDisabled: option.disabled,
				isFocused: isFocused,
				isSelected: isSelected,
				key: 'option-' + i + '-' + option[valueKey],
				onFocus: onFocus,
				onSelect: onSelect,
				option: option,
				optionIndex: i,
				ref: function ref(_ref2) {
					onOptionRef(_ref2, isFocused);
				},
				removeValue: removeValue,
				selectValue: selectValue
			},
			optionRenderer(option, i, inputValue)
		);
	});
};

menuRenderer.propTypes = {
	focusOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	focusedOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
	inputValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onOptionRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	removeValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	selectValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
	valueArray: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
};

var blockEvent = (function (event) {
	event.preventDefault();
	event.stopPropagation();
	if (event.target.tagName !== 'A' || !('href' in event.target)) {
		return;
	}
	if (event.target.target) {
		window.open(event.target.href, event.target.target);
	} else {
		window.location.href = event.target.href;
	}
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};





var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Option = function (_React$Component) {
	inherits(Option, _React$Component);

	function Option(props) {
		classCallCheck(this, Option);

		var _this = possibleConstructorReturn(this, (Option.__proto__ || Object.getPrototypeOf(Option)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
		_this.handleMouseMove = _this.handleMouseMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		_this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.onFocus = _this.onFocus.bind(_this);
		return _this;
	}

	createClass(Option, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onSelect(this.props.option, event);
		}
	}, {
		key: 'handleMouseEnter',
		value: function handleMouseEnter(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleMouseMove',
		value: function handleMouseMove(event) {
			this.onFocus(event);
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'onFocus',
		value: function onFocus(event) {
			if (!this.props.isFocused) {
				this.props.onFocus(this.props.option, event);
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _props = this.props,
			    option = _props.option,
			    instancePrefix = _props.instancePrefix,
			    optionIndex = _props.optionIndex;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(this.props.className, option.className);

			return option.disabled ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					onMouseDown: blockEvent,
					onClick: blockEvent },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className,
					style: option.style,
					role: 'option',
					'aria-label': option.label,
					onMouseDown: this.handleMouseDown,
					onMouseEnter: this.handleMouseEnter,
					onMouseMove: this.handleMouseMove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove,
					onTouchEnd: this.handleTouchEnd,
					id: instancePrefix + '-option-' + optionIndex,
					title: option.title },
				this.props.children
			);
		}
	}]);
	return Option;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Option.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className (based on mouse position)
	instancePrefix: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired, // unique prefix for the ids (used for aria)
	isDisabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is disabled
	isFocused: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is focused
	isSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // the option is selected
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseEnter on option element
	onSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on option element
	onUnfocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle mouseLeave on option element
	option: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, // object that is base for that option
	optionIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number // index of the option, used to generate unique ids for aria
};

var Value = function (_React$Component) {
	inherits(Value, _React$Component);

	function Value(props) {
		classCallCheck(this, Value);

		var _this = possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).call(this, props));

		_this.handleMouseDown = _this.handleMouseDown.bind(_this);
		_this.onRemove = _this.onRemove.bind(_this);
		_this.handleTouchEndRemove = _this.handleTouchEndRemove.bind(_this);
		_this.handleTouchMove = _this.handleTouchMove.bind(_this);
		_this.handleTouchStart = _this.handleTouchStart.bind(_this);
		return _this;
	}

	createClass(Value, [{
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			if (event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			if (this.props.onClick) {
				event.stopPropagation();
				this.props.onClick(this.props.value, event);
				return;
			}
			if (this.props.value.href) {
				event.stopPropagation();
			}
		}
	}, {
		key: 'onRemove',
		value: function onRemove(event) {
			event.preventDefault();
			event.stopPropagation();
			this.props.onRemove(this.props.value);
		}
	}, {
		key: 'handleTouchEndRemove',
		value: function handleTouchEndRemove(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.onRemove(event);
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'renderRemoveIcon',
		value: function renderRemoveIcon() {
			if (this.props.disabled || !this.props.onRemove) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-value-icon',
					'aria-hidden': 'true',
					onMouseDown: this.onRemove,
					onTouchEnd: this.handleTouchEndRemove,
					onTouchStart: this.handleTouchStart,
					onTouchMove: this.handleTouchMove },
				'\xD7'
			);
		}
	}, {
		key: 'renderLabel',
		value: function renderLabel() {
			var className = 'Select-value-label';
			return this.props.onClick || this.props.value.href ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'a',
				{ className: className, href: this.props.value.href, target: this.props.value.target, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
				this.props.children
			) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: className, role: 'option', 'aria-selected': 'true', id: this.props.id },
				this.props.children
			);
		}
	}, {
		key: 'render',
		value: function render() {
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-value', this.props.value.disabled ? 'Select-value-disabled' : '', this.props.value.className),
					style: this.props.value.style,
					title: this.props.value.title
				},
				this.renderRemoveIcon(),
				this.renderLabel()
			);
		}
	}]);
	return Value;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Value.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // disabled prop passed to ReactSelect
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // Unique id for the value - used for aria
	onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle click on value label
	onRemove: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to handle removal of the value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired // the option object for this value
};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/react-select
*/
var stringifyValue = function stringifyValue(value) {
	return typeof value === 'string' ? value : value !== null && JSON.stringify(value) || '';
};

var stringOrNode = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]);
var stringOrNumber = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]);

var instanceId = 1;

var shouldShowValue = function shouldShowValue(state, props) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	if (!inputValue) return true;

	if (!onSelectResetsInput) {
		return !(!isFocused && isPseudoFocused || isFocused && !isPseudoFocused);
	}

	return false;
};

var shouldShowPlaceholder = function shouldShowPlaceholder(state, props, isOpen) {
	var inputValue = state.inputValue,
	    isPseudoFocused = state.isPseudoFocused,
	    isFocused = state.isFocused;
	var onSelectResetsInput = props.onSelectResetsInput;


	return !inputValue || !onSelectResetsInput && !isOpen && !isPseudoFocused && !isFocused;
};

/**
 * Retrieve a value from the given options and valueKey
 * @param {String|Number|Array} value	- the selected value(s)
 * @param {Object}		 props	- the Select component's props (or nextProps)
 */
var expandValue = function expandValue(value, props) {
	var valueType = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	if (valueType !== 'string' && valueType !== 'number' && valueType !== 'boolean') return value;
	var options = props.options,
	    valueKey = props.valueKey;

	if (!options) return;
	for (var i = 0; i < options.length; i++) {
		if (String(options[i][valueKey]) === String(value)) return options[i];
	}
};

var handleRequired = function handleRequired(value, multi) {
	if (!value) return true;
	return multi ? value.length === 0 : Object.keys(value).length === 0;
};

var Select$1 = function (_React$Component) {
	inherits(Select, _React$Component);

	function Select(props) {
		classCallCheck(this, Select);

		var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

		['clearValue', 'focusOption', 'getOptionLabel', 'handleInputBlur', 'handleInputChange', 'handleInputFocus', 'handleInputValueChange', 'handleKeyDown', 'handleMenuScroll', 'handleMouseDown', 'handleMouseDownOnArrow', 'handleMouseDownOnMenu', 'handleTouchEnd', 'handleTouchEndClearValue', 'handleTouchMove', 'handleTouchOutside', 'handleTouchStart', 'handleValueClick', 'onOptionRef', 'removeValue', 'selectValue'].forEach(function (fn) {
			return _this[fn] = _this[fn].bind(_this);
		});

		_this.state = {
			inputValue: '',
			isFocused: false,
			isOpen: false,
			isPseudoFocused: false,
			required: false
		};
		return _this;
	}

	createClass(Select, [{
		key: 'componentWillMount',
		value: function componentWillMount() {
			this._instancePrefix = 'react-select-' + (this.props.instanceId || ++instanceId) + '-';
			var valueArray = this.getValueArray(this.props.value);

			if (this.props.required) {
				this.setState({
					required: handleRequired(valueArray[0], this.props.multi)
				});
			}
		}
	}, {
		key: 'componentDidMount',
		value: function componentDidMount() {
			if (typeof this.props.autofocus !== 'undefined' && typeof console !== 'undefined') {
				console.warn('Warning: The autofocus prop has changed to autoFocus, support will be removed after react-select@1.0');
			}
			if (this.props.autoFocus || this.props.autofocus) {
				this.focus();
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var valueArray = this.getValueArray(nextProps.value, nextProps);

			if (nextProps.required) {
				this.setState({
					required: handleRequired(valueArray[0], nextProps.multi)
				});
			} else if (this.props.required) {
				// Used to be required but it's not any more
				this.setState({ required: false });
			}

			if (this.state.inputValue && this.props.value !== nextProps.value && nextProps.onSelectResetsInput) {
				this.setState({ inputValue: this.handleInputValueChange('') });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			// focus to the selected option
			if (this.menu && this.focused && this.state.isOpen && !this.hasScrolledToOption) {
				var focusedOptionNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);

				var scrollTop = menuNode.scrollTop;
				var scrollBottom = scrollTop + menuNode.offsetHeight;
				var optionTop = focusedOptionNode.offsetTop;
				var optionBottom = optionTop + focusedOptionNode.offsetHeight;

				if (scrollTop > optionTop || scrollBottom < optionBottom) {
					menuNode.scrollTop = focusedOptionNode.offsetTop;
				}

				// We still set hasScrolledToOption to true even if we didn't
				// actually need to scroll, as we've still confirmed that the
				// option is in view.
				this.hasScrolledToOption = true;
			} else if (!this.state.isOpen) {
				this.hasScrolledToOption = false;
			}

			if (this._scrollToFocusedOptionOnUpdate && this.focused && this.menu) {
				this._scrollToFocusedOptionOnUpdate = false;
				var focusedDOM = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.focused);
				var menuDOM = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_dom__["findDOMNode"])(this.menu);
				var focusedRect = focusedDOM.getBoundingClientRect();
				var menuRect = menuDOM.getBoundingClientRect();
				if (focusedRect.bottom > menuRect.bottom) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
				} else if (focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop;
				}
			}
			if (this.props.scrollMenuIntoView && this.menuContainer) {
				var menuContainerRect = this.menuContainer.getBoundingClientRect();
				if (window.innerHeight < menuContainerRect.bottom + this.props.menuBuffer) {
					window.scrollBy(0, menuContainerRect.bottom + this.props.menuBuffer - window.innerHeight);
				}
			}
			if (prevProps.disabled !== this.props.disabled) {
				this.setState({ isFocused: false }); // eslint-disable-line react/no-did-update-set-state
				this.closeMenu();
			}
			if (prevState.isOpen !== this.state.isOpen) {
				this.toggleTouchOutsideEvent(this.state.isOpen);
				var handler = this.state.isOpen ? this.props.onOpen : this.props.onClose;
				handler && handler();
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.toggleTouchOutsideEvent(false);
		}
	}, {
		key: 'toggleTouchOutsideEvent',
		value: function toggleTouchOutsideEvent(enabled) {
			var eventTogglerName = enabled ? document.addEventListener ? 'addEventListener' : 'attachEvent' : document.removeEventListener ? 'removeEventListener' : 'detachEvent';
			var pref = document.addEventListener ? '' : 'on';

			document[eventTogglerName](pref + 'touchstart', this.handleTouchOutside);
			document[eventTogglerName](pref + 'mousedown', this.handleTouchOutside);
		}
	}, {
		key: 'handleTouchOutside',
		value: function handleTouchOutside(event) {
			// handle touch outside on ios to dismiss menu
			if (this.wrapper && !this.wrapper.contains(event.target)) {
				this.closeMenu();
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			if (!this.input) return;
			this.input.focus();
		}
	}, {
		key: 'blurInput',
		value: function blurInput() {
			if (!this.input) return;
			this.input.blur();
		}
	}, {
		key: 'handleTouchMove',
		value: function handleTouchMove() {
			// Set a flag that the view is being dragged
			this.dragging = true;
		}
	}, {
		key: 'handleTouchStart',
		value: function handleTouchStart() {
			// Set a flag that the view is not being dragged
			this.dragging = false;
		}
	}, {
		key: 'handleTouchEnd',
		value: function handleTouchEnd(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Fire the mouse events
			this.handleMouseDown(event);
		}
	}, {
		key: 'handleTouchEndClearValue',
		value: function handleTouchEndClearValue(event) {
			// Check if the view is being dragged, In this case
			// we don't want to fire the click event (because the user only wants to scroll)
			if (this.dragging) return;

			// Clear the value
			this.clearValue(event);
		}
	}, {
		key: 'handleMouseDown',
		value: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (event.target.tagName === 'INPUT') {
				if (!this.state.isFocused) {
					this._openAfterFocus = this.props.openOnClick;
					this.focus();
				} else if (!this.state.isOpen) {
					this.setState({
						isOpen: true,
						isPseudoFocused: false,
						focusedOption: null
					});
				}

				return;
			}

			// prevent default event handlers
			event.preventDefault();

			// for the non-searchable select, toggle the menu
			if (!this.props.searchable) {
				// This code means that if a select is searchable, onClick the options menu will not appear, only on subsequent click will it open.
				this.focus();
				return this.setState({
					isOpen: !this.state.isOpen,
					focusedOption: null
				});
			}

			if (this.state.isFocused) {
				// On iOS, we can get into a state where we think the input is focused but it isn't really,
				// since iOS ignores programmatic calls to input.focus() that weren't triggered by a click event.
				// Call focus() again here to be safe.
				this.focus();

				var input = this.input;
				var toOpen = true;

				if (typeof input.getInput === 'function') {
					// Get the actual DOM input if the ref is an <AutosizeInput /> component
					input = input.getInput();
				}

				// clears the value so that the cursor will be at the end of input when the component re-renders
				input.value = '';

				if (this._focusAfterClear) {
					toOpen = false;
					this._focusAfterClear = false;
				}

				// if the input is focused, ensure the menu is open
				this.setState({
					isOpen: toOpen,
					isPseudoFocused: false,
					focusedOption: null
				});
			} else {
				// otherwise, focus the input and open the menu
				this._openAfterFocus = this.props.openOnClick;
				this.focus();
				this.setState({ focusedOption: null });
			}
		}
	}, {
		key: 'handleMouseDownOnArrow',
		value: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			if (this.state.isOpen) {
				// prevent default event handlers
				event.stopPropagation();
				event.preventDefault();
				// close the menu
				this.closeMenu();
			} else {
				// If the menu isn't open, let the event bubble to the main handleMouseDown
				this.setState({
					isOpen: true
				});
			}
		}
	}, {
		key: 'handleMouseDownOnMenu',
		value: function handleMouseDownOnMenu(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.stopPropagation();
			event.preventDefault();

			this._openAfterFocus = true;
			this.focus();
		}
	}, {
		key: 'closeMenu',
		value: function closeMenu() {
			if (this.props.onCloseResetsInput) {
				this.setState({
					inputValue: this.handleInputValueChange(''),
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			} else {
				this.setState({
					isOpen: false,
					isPseudoFocused: this.state.isFocused && !this.props.multi
				});
			}
			this.hasScrolledToOption = false;
		}
	}, {
		key: 'handleInputFocus',
		value: function handleInputFocus(event) {
			if (this.props.disabled) return;

			var toOpen = this.state.isOpen || this._openAfterFocus || this.props.openOnFocus;
			toOpen = this._focusAfterClear ? false : toOpen; //if focus happens after clear values, don't open dropdown yet.

			if (this.props.onFocus) {
				this.props.onFocus(event);
			}

			this.setState({
				isFocused: true,
				isOpen: !!toOpen
			});

			this._focusAfterClear = false;
			this._openAfterFocus = false;
		}
	}, {
		key: 'handleInputBlur',
		value: function handleInputBlur(event) {
			// The check for menu.contains(activeElement) is necessary to prevent IE11's scrollbar from closing the menu in certain contexts.
			if (this.menu && (this.menu === document.activeElement || this.menu.contains(document.activeElement))) {
				this.focus();
				return;
			}

			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
			var onBlurredState = {
				isFocused: false,
				isOpen: false,
				isPseudoFocused: false
			};
			if (this.props.onBlurResetsInput) {
				onBlurredState.inputValue = this.handleInputValueChange('');
			}
			this.setState(onBlurredState);
		}
	}, {
		key: 'handleInputChange',
		value: function handleInputChange(event) {
			var newInputValue = event.target.value;

			if (this.state.inputValue !== event.target.value) {
				newInputValue = this.handleInputValueChange(newInputValue);
			}

			this.setState({
				inputValue: newInputValue,
				isOpen: true,
				isPseudoFocused: false
			});
		}
	}, {
		key: 'setInputValue',
		value: function setInputValue(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			this.setState({
				inputValue: newValue
			});
		}
	}, {
		key: 'handleInputValueChange',
		value: function handleInputValueChange(newValue) {
			if (this.props.onInputChange) {
				var nextState = this.props.onInputChange(newValue);
				// Note: != used deliberately here to catch undefined and null
				if (nextState != null && (typeof nextState === 'undefined' ? 'undefined' : _typeof(nextState)) !== 'object') {
					newValue = '' + nextState;
				}
			}
			return newValue;
		}
	}, {
		key: 'handleKeyDown',
		value: function handleKeyDown(event) {
			if (this.props.disabled) return;

			if (typeof this.props.onInputKeyDown === 'function') {
				this.props.onInputKeyDown(event);
				if (event.defaultPrevented) {
					return;
				}
			}

			switch (event.keyCode) {
				case 8:
					// backspace
					if (!this.state.inputValue && this.props.backspaceRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.props.tabSelectsValue) {
						break;
					}
					event.preventDefault();
					this.selectFocusedOption();
					break;
				case 13:
					// enter
					event.preventDefault();
					event.stopPropagation();
					if (this.state.isOpen) {
						this.selectFocusedOption();
					} else {
						this.focusNextOption();
					}
					break;
				case 27:
					// escape
					event.preventDefault();
					if (this.state.isOpen) {
						this.closeMenu();
						event.stopPropagation();
					} else if (this.props.clearable && this.props.escapeClearsValue) {
						this.clearValue(event);
						event.stopPropagation();
					}
					break;
				case 32:
					// space
					if (this.props.searchable) {
						break;
					}
					event.preventDefault();
					if (!this.state.isOpen) {
						this.focusNextOption();
						break;
					}
					event.stopPropagation();
					this.selectFocusedOption();
					break;
				case 38:
					// up
					event.preventDefault();
					this.focusPreviousOption();
					break;
				case 40:
					// down
					event.preventDefault();
					this.focusNextOption();
					break;
				case 33:
					// page up
					event.preventDefault();
					this.focusPageUpOption();
					break;
				case 34:
					// page down
					event.preventDefault();
					this.focusPageDownOption();
					break;
				case 35:
					// end key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusEndOption();
					break;
				case 36:
					// home key
					if (event.shiftKey) {
						break;
					}
					event.preventDefault();
					this.focusStartOption();
					break;
				case 46:
					// delete
					if (!this.state.inputValue && this.props.deleteRemoves) {
						event.preventDefault();
						this.popValue();
					}
					break;
			}
		}
	}, {
		key: 'handleValueClick',
		value: function handleValueClick(option, event) {
			if (!this.props.onValueClick) return;
			this.props.onValueClick(option, event);
		}
	}, {
		key: 'handleMenuScroll',
		value: function handleMenuScroll(event) {
			if (!this.props.onMenuScrollToBottom) return;
			var target = event.target;

			if (target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 0) {
				this.props.onMenuScrollToBottom();
			}
		}
	}, {
		key: 'getOptionLabel',
		value: function getOptionLabel(op) {
			return op[this.props.labelKey];
		}

		/**
   * Turns a value into an array from the given options
   * @param {String|Number|Array} value		- the value of the select input
   * @param {Object}		nextProps	- optionally specify the nextProps so the returned array uses the latest configuration
   * @returns	{Array}	the value of the select represented in an array
   */

	}, {
		key: 'getValueArray',
		value: function getValueArray(value) {
			var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

			/** support optionally passing in the `nextProps` so `componentWillReceiveProps` updates will function as expected */
			var props = (typeof nextProps === 'undefined' ? 'undefined' : _typeof(nextProps)) === 'object' ? nextProps : this.props;
			if (props.multi) {
				if (typeof value === 'string') {
					value = value.split(props.delimiter);
				}
				if (!Array.isArray(value)) {
					if (value === null || value === undefined) return [];
					value = [value];
				}
				return value.map(function (value) {
					return expandValue(value, props);
				}).filter(function (i) {
					return i;
				});
			}
			var expandedValue = expandValue(value, props);
			return expandedValue ? [expandedValue] : [];
		}
	}, {
		key: 'setValue',
		value: function setValue(value) {
			var _this2 = this;

			if (this.props.autoBlur) {
				this.blurInput();
			}
			if (this.props.required) {
				var required = handleRequired(value, this.props.multi);
				this.setState({ required: required });
			}
			if (this.props.simpleValue && value) {
				value = this.props.multi ? value.map(function (i) {
					return i[_this2.props.valueKey];
				}).join(this.props.delimiter) : value[this.props.valueKey];
			}
			if (this.props.onChange) {
				this.props.onChange(value);
			}
		}
	}, {
		key: 'selectValue',
		value: function selectValue(value) {
			var _this3 = this;

			// NOTE: we actually add/set the value in a callback to make sure the
			// input value is empty to avoid styling issues in Chrome
			if (this.props.closeOnSelect) {
				this.hasScrolledToOption = false;
			}
			var updatedValue = this.props.onSelectResetsInput ? '' : this.state.inputValue;
			if (this.props.multi) {
				this.setState({
					focusedIndex: null,
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect
				}, function () {
					var valueArray = _this3.getValueArray(_this3.props.value);
					if (valueArray.some(function (i) {
						return i[_this3.props.valueKey] === value[_this3.props.valueKey];
					})) {
						_this3.removeValue(value);
					} else {
						_this3.addValue(value);
					}
				});
			} else {
				this.setState({
					inputValue: this.handleInputValueChange(updatedValue),
					isOpen: !this.props.closeOnSelect,
					isPseudoFocused: this.state.isFocused
				}, function () {
					_this3.setValue(value);
				});
			}
		}
	}, {
		key: 'addValue',
		value: function addValue(value) {
			var valueArray = this.getValueArray(this.props.value);
			var visibleOptions = this._visibleOptions.filter(function (val) {
				return !val.disabled;
			});
			var lastValueIndex = visibleOptions.indexOf(value);
			this.setValue(valueArray.concat(value));
			if (!this.props.closeOnSelect) {
				return;
			}
			if (visibleOptions.length - 1 === lastValueIndex) {
				// the last option was selected; focus the second-last one
				this.focusOption(visibleOptions[lastValueIndex - 1]);
			} else if (visibleOptions.length > lastValueIndex) {
				// focus the option below the selected one
				this.focusOption(visibleOptions[lastValueIndex + 1]);
			}
		}
	}, {
		key: 'popValue',
		value: function popValue() {
			var valueArray = this.getValueArray(this.props.value);
			if (!valueArray.length) return;
			if (valueArray[valueArray.length - 1].clearableValue === false) return;
			this.setValue(this.props.multi ? valueArray.slice(0, valueArray.length - 1) : null);
		}
	}, {
		key: 'removeValue',
		value: function removeValue(value) {
			var _this4 = this;

			var valueArray = this.getValueArray(this.props.value);
			this.setValue(valueArray.filter(function (i) {
				return i[_this4.props.valueKey] !== value[_this4.props.valueKey];
			}));
			this.focus();
		}
	}, {
		key: 'clearValue',
		value: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}

			event.preventDefault();

			this.setValue(this.getResetValue());
			this.setState({
				inputValue: this.handleInputValueChange(''),
				isOpen: false
			}, this.focus);

			this._focusAfterClear = true;
		}
	}, {
		key: 'getResetValue',
		value: function getResetValue() {
			if (this.props.resetValue !== undefined) {
				return this.props.resetValue;
			} else if (this.props.multi) {
				return [];
			} else {
				return null;
			}
		}
	}, {
		key: 'focusOption',
		value: function focusOption(option) {
			this.setState({
				focusedOption: option
			});
		}
	}, {
		key: 'focusNextOption',
		value: function focusNextOption() {
			this.focusAdjacentOption('next');
		}
	}, {
		key: 'focusPreviousOption',
		value: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		}
	}, {
		key: 'focusPageUpOption',
		value: function focusPageUpOption() {
			this.focusAdjacentOption('page_up');
		}
	}, {
		key: 'focusPageDownOption',
		value: function focusPageDownOption() {
			this.focusAdjacentOption('page_down');
		}
	}, {
		key: 'focusStartOption',
		value: function focusStartOption() {
			this.focusAdjacentOption('start');
		}
	}, {
		key: 'focusEndOption',
		value: function focusEndOption() {
			this.focusAdjacentOption('end');
		}
	}, {
		key: 'focusAdjacentOption',
		value: function focusAdjacentOption(dir) {
			var options = this._visibleOptions.map(function (option, index) {
				return { option: option, index: index };
			}).filter(function (option) {
				return !option.option.disabled;
			});
			this._scrollToFocusedOptionOnUpdate = true;
			if (!this.state.isOpen) {
				var newState = {
					focusedOption: this._focusedOption || (options.length ? options[dir === 'next' ? 0 : options.length - 1].option : null),
					isOpen: true
				};
				if (this.props.onSelectResetsInput) {
					newState.inputValue = '';
				}
				this.setState(newState);
				return;
			}
			if (!options.length) return;
			var focusedIndex = -1;
			for (var i = 0; i < options.length; i++) {
				if (this._focusedOption === options[i].option) {
					focusedIndex = i;
					break;
				}
			}
			if (dir === 'next' && focusedIndex !== -1) {
				focusedIndex = (focusedIndex + 1) % options.length;
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedIndex = focusedIndex - 1;
				} else {
					focusedIndex = options.length - 1;
				}
			} else if (dir === 'start') {
				focusedIndex = 0;
			} else if (dir === 'end') {
				focusedIndex = options.length - 1;
			} else if (dir === 'page_up') {
				var potentialIndex = focusedIndex - this.props.pageSize;
				if (potentialIndex < 0) {
					focusedIndex = 0;
				} else {
					focusedIndex = potentialIndex;
				}
			} else if (dir === 'page_down') {
				var _potentialIndex = focusedIndex + this.props.pageSize;
				if (_potentialIndex > options.length - 1) {
					focusedIndex = options.length - 1;
				} else {
					focusedIndex = _potentialIndex;
				}
			}

			if (focusedIndex === -1) {
				focusedIndex = 0;
			}

			this.setState({
				focusedIndex: options[focusedIndex].index,
				focusedOption: options[focusedIndex].option
			});
		}
	}, {
		key: 'getFocusedOption',
		value: function getFocusedOption() {
			return this._focusedOption;
		}
	}, {
		key: 'selectFocusedOption',
		value: function selectFocusedOption() {
			if (this._focusedOption) {
				return this.selectValue(this._focusedOption);
			}
		}
	}, {
		key: 'renderLoading',
		value: function renderLoading() {
			if (!this.props.isLoading) return;
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{ className: 'Select-loading-zone', 'aria-hidden': 'true' },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('span', { className: 'Select-loading' })
			);
		}
	}, {
		key: 'renderValue',
		value: function renderValue(valueArray, isOpen) {
			var _this5 = this;

			var renderLabel = this.props.valueRenderer || this.getOptionLabel;
			var ValueComponent = this.props.valueComponent;
			if (!valueArray.length) {
				var showPlaceholder = shouldShowPlaceholder(this.state, this.props, isOpen);
				return showPlaceholder ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-placeholder' },
					this.props.placeholder
				) : null;
			}
			var onClick = this.props.onValueClick ? this.handleValueClick : null;
			if (this.props.multi) {
				return valueArray.map(function (value, i) {
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						ValueComponent,
						{
							disabled: _this5.props.disabled || value.clearableValue === false,
							id: _this5._instancePrefix + '-value-' + i,
							instancePrefix: _this5._instancePrefix,
							key: 'value-' + i + '-' + value[_this5.props.valueKey],
							onClick: onClick,
							onRemove: _this5.removeValue,
							placeholder: _this5.props.placeholder,
							value: value,
							values: valueArray
						},
						renderLabel(value, i),
						__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
							'span',
							{ className: 'Select-aria-only' },
							'\xA0'
						)
					);
				});
			} else if (shouldShowValue(this.state, this.props)) {
				if (isOpen) onClick = null;
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					ValueComponent,
					{
						disabled: this.props.disabled,
						id: this._instancePrefix + '-value-item',
						instancePrefix: this._instancePrefix,
						onClick: onClick,
						placeholder: this.props.placeholder,
						value: valueArray[0]
					},
					renderLabel(valueArray[0])
				);
			}
		}
	}, {
		key: 'renderInput',
		value: function renderInput(valueArray, focusedOptionIndex) {
			var _classNames,
			    _this6 = this;

			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select-input', this.props.inputProps.className);
			var isOpen = this.state.isOpen;

			var ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()((_classNames = {}, defineProperty(_classNames, this._instancePrefix + '-list', isOpen), defineProperty(_classNames, this._instancePrefix + '-backspace-remove-message', this.props.multi && !this.props.disabled && this.state.isFocused && !this.state.inputValue), _classNames));

			var value = this.state.inputValue;
			if (value && !this.props.onSelectResetsInput && !this.state.isFocused) {
				// it hides input value when it is not focused and was not reset on select
				value = '';
			}

			var inputProps = _extends({}, this.props.inputProps, {
				'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
				'aria-describedby': this.props['aria-describedby'],
				'aria-expanded': '' + isOpen,
				'aria-haspopup': '' + isOpen,
				'aria-label': this.props['aria-label'],
				'aria-labelledby': this.props['aria-labelledby'],
				'aria-owns': ariaOwns,
				onBlur: this.handleInputBlur,
				onChange: this.handleInputChange,
				onFocus: this.handleInputFocus,
				ref: function ref(_ref) {
					return _this6.input = _ref;
				},
				role: 'combobox',
				required: this.state.required,
				tabIndex: this.props.tabIndex,
				value: value
			});

			if (this.props.inputRenderer) {
				return this.props.inputRenderer(inputProps);
			}

			if (this.props.disabled || !this.props.searchable) {
				var divProps = objectWithoutProperties(this.props.inputProps, []);


				var _ariaOwns = __WEBPACK_IMPORTED_MODULE_1_classnames___default()(defineProperty({}, this._instancePrefix + '-list', isOpen));
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div', _extends({}, divProps, {
					'aria-expanded': isOpen,
					'aria-owns': _ariaOwns,
					'aria-activedescendant': isOpen ? this._instancePrefix + '-option-' + focusedOptionIndex : this._instancePrefix + '-value',
					'aria-disabled': '' + this.props.disabled,
					'aria-label': this.props['aria-label'],
					'aria-labelledby': this.props['aria-labelledby'],
					className: className,
					onBlur: this.handleInputBlur,
					onFocus: this.handleInputFocus,
					ref: function ref(_ref2) {
						return _this6.input = _ref2;
					},
					role: 'combobox',
					style: { border: 0, width: 1, display: 'inline-block' },
					tabIndex: this.props.tabIndex || 0
				}));
			}

			if (this.props.autosize) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_input_autosize___default.a, _extends({ id: this.props.id }, inputProps, { className: className, minWidth: '5' }));
			}
			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ className: className, key: 'input-wrap', style: { display: 'inline-block' } },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', _extends({ id: this.props.id }, inputProps))
			);
		}
	}, {
		key: 'renderClear',
		value: function renderClear() {
			var valueArray = this.getValueArray(this.props.value);
			if (!this.props.clearable || !valueArray.length || this.props.disabled || this.props.isLoading) return;
			var ariaLabel = this.props.multi ? this.props.clearAllText : this.props.clearValueText;
			var clear = this.props.clearRenderer();

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					'aria-label': ariaLabel,
					className: 'Select-clear-zone',
					onMouseDown: this.clearValue,
					onTouchEnd: this.handleTouchEndClearValue,
					onTouchMove: this.handleTouchMove,
					onTouchStart: this.handleTouchStart,
					title: ariaLabel
				},
				clear
			);
		}
	}, {
		key: 'renderArrow',
		value: function renderArrow() {
			if (!this.props.arrowRenderer) return;

			var onMouseDown = this.handleMouseDownOnArrow;
			var isOpen = this.state.isOpen;
			var arrow = this.props.arrowRenderer({ onMouseDown: onMouseDown, isOpen: isOpen });

			if (!arrow) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'span',
				{
					className: 'Select-arrow-zone',
					onMouseDown: onMouseDown
				},
				arrow
			);
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1(excludeOptions) {
			var filterValue = this.state.inputValue;
			var options = this.props.options || [];
			if (this.props.filterOptions) {
				// Maintain backwards compatibility with boolean attribute
				var filterOptions$$1 = typeof this.props.filterOptions === 'function' ? this.props.filterOptions : filterOptions;

				return filterOptions$$1(options, filterValue, excludeOptions, {
					filterOption: this.props.filterOption,
					ignoreAccents: this.props.ignoreAccents,
					ignoreCase: this.props.ignoreCase,
					labelKey: this.props.labelKey,
					matchPos: this.props.matchPos,
					matchProp: this.props.matchProp,
					trimFilter: this.props.trimFilter,
					valueKey: this.props.valueKey
				});
			} else {
				return options;
			}
		}
	}, {
		key: 'onOptionRef',
		value: function onOptionRef(ref, isFocused) {
			if (isFocused) {
				this.focused = ref;
			}
		}
	}, {
		key: 'renderMenu',
		value: function renderMenu(options, valueArray, focusedOption) {
			if (options && options.length) {
				return this.props.menuRenderer({
					focusedOption: focusedOption,
					focusOption: this.focusOption,
					inputValue: this.state.inputValue,
					instancePrefix: this._instancePrefix,
					labelKey: this.props.labelKey,
					onFocus: this.focusOption,
					onOptionRef: this.onOptionRef,
					onSelect: this.selectValue,
					optionClassName: this.props.optionClassName,
					optionComponent: this.props.optionComponent,
					optionRenderer: this.props.optionRenderer || this.getOptionLabel,
					options: options,
					removeValue: this.removeValue,
					selectValue: this.selectValue,
					valueArray: valueArray,
					valueKey: this.props.valueKey
				});
			} else if (this.props.noResultsText) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ className: 'Select-noresults' },
					this.props.noResultsText
				);
			} else {
				return null;
			}
		}
	}, {
		key: 'renderHiddenField',
		value: function renderHiddenField(valueArray) {
			var _this7 = this;

			if (!this.props.name) return;
			if (this.props.joinValues) {
				var value = valueArray.map(function (i) {
					return stringifyValue(i[_this7.props.valueKey]);
				}).join(this.props.delimiter);
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: this.props.disabled,
					name: this.props.name,
					ref: function ref(_ref3) {
						return _this7.value = _ref3;
					},
					type: 'hidden',
					value: value
				});
			}
			return valueArray.map(function (item, index) {
				return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('input', {
					disabled: _this7.props.disabled,
					key: 'hidden.' + index,
					name: _this7.props.name,
					ref: 'value' + index,
					type: 'hidden',
					value: stringifyValue(item[_this7.props.valueKey])
				});
			});
		}
	}, {
		key: 'getFocusableOptionIndex',
		value: function getFocusableOptionIndex(selectedOption) {
			var options = this._visibleOptions;
			if (!options.length) return null;

			var valueKey = this.props.valueKey;
			var focusedOption = this.state.focusedOption || selectedOption;
			if (focusedOption && !focusedOption.disabled) {
				var focusedOptionIndex = -1;
				options.some(function (option, index) {
					var isOptionEqual = option[valueKey] === focusedOption[valueKey];
					if (isOptionEqual) {
						focusedOptionIndex = index;
					}
					return isOptionEqual;
				});
				if (focusedOptionIndex !== -1) {
					return focusedOptionIndex;
				}
			}

			for (var i = 0; i < options.length; i++) {
				if (!options[i].disabled) return i;
			}
			return null;
		}
	}, {
		key: 'renderOuter',
		value: function renderOuter(options, valueArray, focusedOption) {
			var _this8 = this;

			var menu = this.renderMenu(options, valueArray, focusedOption);
			if (!menu) {
				return null;
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref5) {
						return _this8.menuContainer = _ref5;
					}, className: 'Select-menu-outer', style: this.props.menuContainerStyle },
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{
						className: 'Select-menu',
						id: this._instancePrefix + '-list',
						onMouseDown: this.handleMouseDownOnMenu,
						onScroll: this.handleMenuScroll,
						ref: function ref(_ref4) {
							return _this8.menu = _ref4;
						},
						role: 'listbox',
						style: this.props.menuStyle,
						tabIndex: -1
					},
					menu
				)
			);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this9 = this;

			var valueArray = this.getValueArray(this.props.value);
			var options = this._visibleOptions = this.filterOptions(this.props.multi && this.props.removeSelected ? valueArray : null);
			var isOpen = this.state.isOpen;
			if (this.props.multi && !options.length && valueArray.length && !this.state.inputValue) isOpen = false;
			var focusedOptionIndex = this.getFocusableOptionIndex(valueArray[0]);

			var focusedOption = null;
			if (focusedOptionIndex !== null) {
				focusedOption = this._focusedOption = options[focusedOptionIndex];
			} else {
				focusedOption = this._focusedOption = null;
			}
			var className = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('Select', this.props.className, {
				'has-value': valueArray.length,
				'is-clearable': this.props.clearable,
				'is-disabled': this.props.disabled,
				'is-focused': this.state.isFocused,
				'is-loading': this.props.isLoading,
				'is-open': isOpen,
				'is-pseudo-focused': this.state.isPseudoFocused,
				'is-searchable': this.props.searchable,
				'Select--multi': this.props.multi,
				'Select--rtl': this.props.rtl,
				'Select--single': !this.props.multi
			});

			var removeMessage = null;
			if (this.props.multi && !this.props.disabled && valueArray.length && !this.state.inputValue && this.state.isFocused && this.props.backspaceRemoves) {
				removeMessage = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'span',
					{ id: this._instancePrefix + '-backspace-remove-message', className: 'Select-aria-only', 'aria-live': 'assertive' },
					this.props.backspaceToRemoveMessage.replace('{label}', valueArray[valueArray.length - 1][this.props.labelKey])
				);
			}

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				'div',
				{ ref: function ref(_ref7) {
						return _this9.wrapper = _ref7;
					},
					className: className,
					style: this.props.wrapperStyle },
				this.renderHiddenField(valueArray),
				__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
					'div',
					{ ref: function ref(_ref6) {
							return _this9.control = _ref6;
						},
						className: 'Select-control',
						onKeyDown: this.handleKeyDown,
						onMouseDown: this.handleMouseDown,
						onTouchEnd: this.handleTouchEnd,
						onTouchMove: this.handleTouchMove,
						onTouchStart: this.handleTouchStart,
						style: this.props.style
					},
					__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						'div',
						{ className: 'Select-multi-value-wrapper', id: this._instancePrefix + '-value' },
						this.renderValue(valueArray, isOpen),
						this.renderInput(valueArray, focusedOptionIndex)
					),
					removeMessage,
					this.renderLoading(),
					this.renderClear(),
					this.renderArrow()
				),
				isOpen ? this.renderOuter(options, valueArray, focusedOption) : null
			);
		}
	}]);
	return Select;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Select$1.propTypes = {
	'aria-describedby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id(s) of element(s) that should be used to describe this input (for assistive tech)
	'aria-label': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // aria label (for assistive tech)
	'aria-labelledby': __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id of an element that should be used as the label (for assistive tech)
	arrowRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create the drop-down caret element
	autoBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // automatically blur the component when an option is selected
	autoFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // autofocus the component on mount
	autofocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // deprecated; use autoFocus instead
	autosize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable autosizing or not
	backspaceRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether backspace removes an item if there is no text input
	backspaceToRemoveMessage: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // message to use for screenreaders to press backspace to remove the current item - {label} is replaced with the item label
	className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // className for the outer element
	clearAllText: stringOrNode, // title for the "clear" control when multi: true
	clearRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // create clearable x element
	clearValueText: stringOrNode, // title for the "clear" control
	clearable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // should it be possible to reset value
	closeOnSelect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to close the menu when a value is selected
	deleteRemoves: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether delete removes an item if there is no text input
	delimiter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // delimiter to use to join multiple values for the hidden field value
	disabled: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is disabled or not
	escapeClearsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether escape clears the value when the menu is closed
	filterOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // method to filter a single option (option, filterString)
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // boolean to enable default filtering or function to filter the options array ([options], filterString, [values])
	id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // html id to set on the input element for accessibility or tests
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to strip diacritics when filtering
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to perform case-insensitive filtering
	inputProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // custom attributes for the Input
	inputRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // returns a custom input component
	instanceId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // set the components instanceId
	isLoading: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the Select is loading externally or not (such as options being loaded)
	joinValues: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // joins multiple values into a single form field with the delimiter (legacy mode)
	labelKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	matchPos: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|start) match the start or entire string when filtering
	matchProp: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // (any|label|value) which option property to filter on
	menuBuffer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // optional buffer (in px) between the bottom of the viewport and the bottom of the menu
	menuContainerStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu container
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // renders a custom menu with options
	menuStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the menu
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // generates a hidden <input /> tag with this field name for html forms
	noResultsText: stringOrNode, // placeholder displayed when there are no matching search results
	onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onBlur handler: function (event) {}
	onBlurResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on blur
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onClose: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is closed
	onCloseResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared when menu is closed through the arrow
	onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onFocus handler: function (event) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onInputChange handler: function (inputValue) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // input keyDown handler: function (event) {}
	onMenuScrollToBottom: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is scrolled to the bottom; can be used to paginate options
	onOpen: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // fires when the menu is opened
	onSelectResetsInput: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether input is cleared on select (works only for multiselect)
	onValueClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onClick handler for value labels: function (value, event) {}
	openOnClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to control opening the menu when the control is clicked
	openOnFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // always open options menu on focus
	optionClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // additional class(es) to apply to the <Option /> elements
	optionComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // option component to render in dropdown
	optionRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optionRenderer: function (option) {}
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, // array of options
	pageSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, // number of entries to page when using page up/down keys
	placeholder: stringOrNode, // field placeholder, displayed when there's no value
	removeSelected: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether the selected option is removed from the dropdown on multi selects
	required: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // applies HTML5 required attribute when needed
	resetValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // value to use when you clear the control
	rtl: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // set to true in order to use react-select in right-to-left direction
	scrollMenuIntoView: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // boolean to enable the viewport to shift so that the full menu fully visible when engaged
	searchable: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to enable searching feature or not
	simpleValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // pass the value to onChange as a simple value (legacy pre 1.0 mode), defaults to false
	style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, // optional style to apply to the control
	tabIndex: stringOrNumber, // optional tab index of the control
	tabSelectsValue: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to treat tabbing out while focused to be value selection
	trimFilter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // whether to trim whitespace around filter value
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // initial field value
	valueComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // value component to render
	valueKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, // path of the label value in option objects
	valueRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // valueRenderer: function (option) {}
	wrapperStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object // optional style to apply to the component wrapper
};

Select$1.defaultProps = {
	arrowRenderer: arrowRenderer,
	autosize: true,
	backspaceRemoves: true,
	backspaceToRemoveMessage: 'Press backspace to remove {label}',
	clearable: true,
	clearAllText: 'Clear all',
	clearRenderer: clearRenderer,
	clearValueText: 'Clear value',
	closeOnSelect: true,
	deleteRemoves: true,
	delimiter: ',',
	disabled: false,
	escapeClearsValue: true,
	filterOptions: filterOptions,
	ignoreAccents: true,
	ignoreCase: true,
	inputProps: {},
	isLoading: false,
	joinValues: false,
	labelKey: 'label',
	matchPos: 'any',
	matchProp: 'any',
	menuBuffer: 0,
	menuRenderer: menuRenderer,
	multi: false,
	noResultsText: 'No results found',
	onBlurResetsInput: true,
	onCloseResetsInput: true,
	onSelectResetsInput: true,
	openOnClick: true,
	optionComponent: Option,
	pageSize: 5,
	placeholder: 'Select...',
	removeSelected: true,
	required: false,
	rtl: false,
	scrollMenuIntoView: true,
	searchable: true,
	simpleValue: false,
	tabSelectsValue: true,
	trimFilter: true,
	valueComponent: Value,
	valueKey: 'value'
};

var propTypes = {
	autoload: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired, // automatically call the `loadOptions` prop on-mount; defaults to true
	cache: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any, // object to use to cache results; set to null/false to disable caching
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
	ignoreAccents: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // strip diacritics when filtering; defaults to true
	ignoreCase: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // perform case-insensitive filtering; defaults to true
	loadOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired, // callback to load options asynchronously; (inputValue: string, callback: Function): ?Promise
	loadingPlaceholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// replaces the placeholder while options are loading
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	multi: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, // multi-value input
	noResultsText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field noResultsText, displayed when no options come back from the server
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // onChange handler: function (newValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, // optional for keeping track of what is being typed
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array.isRequired, // array of options
	placeholder: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// field placeholder, displayed when there's no value (shared with Select)
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	searchPromptText: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([// label to prompt for search input
	__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]),
	value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any // initial field value
};

var defaultCache = {};

var defaultChildren = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var defaultProps = {
	autoload: true,
	cache: defaultCache,
	children: defaultChildren,
	ignoreAccents: true,
	ignoreCase: true,
	loadingPlaceholder: 'Loading...',
	options: [],
	searchPromptText: 'Type to search'
};

var Async = function (_Component) {
	inherits(Async, _Component);

	function Async(props, context) {
		classCallCheck(this, Async);

		var _this = possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this, props, context));

		_this._cache = props.cache === defaultCache ? {} : props.cache;

		_this.state = {
			inputValue: '',
			isLoading: false,
			options: props.options
		};

		_this.onInputChange = _this.onInputChange.bind(_this);
		return _this;
	}

	createClass(Async, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var autoload = this.props.autoload;


			if (autoload) {
				this.loadOptions('');
			}
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			if (nextProps.options !== this.props.options) {
				this.setState({
					options: nextProps.options
				});
			}
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this._callback = null;
		}
	}, {
		key: 'loadOptions',
		value: function loadOptions(inputValue) {
			var _this2 = this;

			var loadOptions = this.props.loadOptions;

			var cache = this._cache;

			if (cache && Object.prototype.hasOwnProperty.call(cache, inputValue)) {
				this._callback = null;

				this.setState({
					isLoading: false,
					options: cache[inputValue]
				});

				return;
			}

			var callback = function callback(error, data) {
				var options = data && data.options || [];

				if (cache) {
					cache[inputValue] = options;
				}

				if (callback === _this2._callback) {
					_this2._callback = null;

					_this2.setState({
						isLoading: false,
						options: options
					});
				}
			};

			// Ignore all but the most recent request
			this._callback = callback;

			var promise = loadOptions(inputValue, callback);
			if (promise) {
				promise.then(function (data) {
					return callback(null, data);
				}, function (error) {
					return callback(error);
				});
			}

			if (this._callback && !this.state.isLoading) {
				this.setState({
					isLoading: true
				});
			}
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(inputValue) {
			var _props = this.props,
			    ignoreAccents = _props.ignoreAccents,
			    ignoreCase = _props.ignoreCase,
			    onInputChange = _props.onInputChange;

			var newInputValue = inputValue;

			if (onInputChange) {
				var value = onInputChange(newInputValue);
				// Note: != used deliberately here to catch undefined and null
				if (value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
					newInputValue = '' + value;
				}
			}

			var transformedInputValue = newInputValue;

			if (ignoreAccents) {
				transformedInputValue = stripDiacritics(transformedInputValue);
			}

			if (ignoreCase) {
				transformedInputValue = transformedInputValue.toLowerCase();
			}

			this.setState({ inputValue: newInputValue });
			this.loadOptions(transformedInputValue);

			// Return new input value, but without applying toLowerCase() to avoid modifying the user's view case of the input while typing.
			return newInputValue;
		}
	}, {
		key: 'noResultsText',
		value: function noResultsText() {
			var _props2 = this.props,
			    loadingPlaceholder = _props2.loadingPlaceholder,
			    noResultsText = _props2.noResultsText,
			    searchPromptText = _props2.searchPromptText;
			var _state = this.state,
			    inputValue = _state.inputValue,
			    isLoading = _state.isLoading;


			if (isLoading) {
				return loadingPlaceholder;
			}
			if (inputValue && noResultsText) {
				return noResultsText;
			}
			return searchPromptText;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props3 = this.props,
			    children = _props3.children,
			    loadingPlaceholder = _props3.loadingPlaceholder,
			    placeholder = _props3.placeholder;
			var _state2 = this.state,
			    isLoading = _state2.isLoading,
			    options = _state2.options;


			var props = {
				noResultsText: this.noResultsText(),
				placeholder: isLoading ? loadingPlaceholder : placeholder,
				options: isLoading && loadingPlaceholder ? [] : options,
				ref: function ref(_ref) {
					return _this3.select = _ref;
				}
			};

			return children(_extends({}, this.props, props, {
				isLoading: isLoading,
				onInputChange: this.onInputChange
			}));
		}
	}]);
	return Async;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Async.propTypes = propTypes;
Async.defaultProps = defaultProps;

var CreatableSelect = function (_React$Component) {
	inherits(CreatableSelect, _React$Component);

	function CreatableSelect(props, context) {
		classCallCheck(this, CreatableSelect);

		var _this = possibleConstructorReturn(this, (CreatableSelect.__proto__ || Object.getPrototypeOf(CreatableSelect)).call(this, props, context));

		_this.filterOptions = _this.filterOptions.bind(_this);
		_this.menuRenderer = _this.menuRenderer.bind(_this);
		_this.onInputKeyDown = _this.onInputKeyDown.bind(_this);
		_this.onInputChange = _this.onInputChange.bind(_this);
		_this.onOptionSelect = _this.onOptionSelect.bind(_this);
		return _this;
	}

	createClass(CreatableSelect, [{
		key: 'createNewOption',
		value: function createNewOption() {
			var _props = this.props,
			    isValidNewOption = _props.isValidNewOption,
			    newOptionCreator = _props.newOptionCreator,
			    onNewOptionClick = _props.onNewOptionClick,
			    _props$options = _props.options,
			    options = _props$options === undefined ? [] : _props$options;


			if (isValidNewOption({ label: this.inputValue })) {
				var option = newOptionCreator({ label: this.inputValue, labelKey: this.labelKey, valueKey: this.valueKey });
				var _isOptionUnique = this.isOptionUnique({ option: option, options: options });

				// Don't add the same option twice.
				if (_isOptionUnique) {
					if (onNewOptionClick) {
						onNewOptionClick(option);
					} else {
						options.unshift(option);

						this.select.selectValue(option);
					}
				}
			}
		}
	}, {
		key: 'filterOptions',
		value: function filterOptions$$1() {
			var _props2 = this.props,
			    filterOptions$$1 = _props2.filterOptions,
			    isValidNewOption = _props2.isValidNewOption,
			    promptTextCreator = _props2.promptTextCreator,
			    showNewOptionAtTop = _props2.showNewOptionAtTop;

			// TRICKY Check currently selected options as well.
			// Don't display a create-prompt for a value that's selected.
			// This covers async edge-cases where a newly-created Option isn't yet in the async-loaded array.

			var excludeOptions = (arguments.length <= 2 ? undefined : arguments[2]) || [];

			var filteredOptions = filterOptions$$1.apply(undefined, arguments) || [];

			if (isValidNewOption({ label: this.inputValue })) {
				var _newOptionCreator = this.props.newOptionCreator;


				var option = _newOptionCreator({
					label: this.inputValue,
					labelKey: this.labelKey,
					valueKey: this.valueKey
				});

				// TRICKY Compare to all options (not just filtered options) in case option has already been selected).
				// For multi-selects, this would remove it from the filtered list.
				var _isOptionUnique2 = this.isOptionUnique({
					option: option,
					options: excludeOptions.concat(filteredOptions)
				});

				if (_isOptionUnique2) {
					var prompt = promptTextCreator(this.inputValue);

					this._createPlaceholderOption = _newOptionCreator({
						label: prompt,
						labelKey: this.labelKey,
						valueKey: this.valueKey
					});

					if (showNewOptionAtTop) {
						filteredOptions.unshift(this._createPlaceholderOption);
					} else {
						filteredOptions.push(this._createPlaceholderOption);
					}
				}
			}

			return filteredOptions;
		}
	}, {
		key: 'isOptionUnique',
		value: function isOptionUnique(_ref) {
			var option = _ref.option,
			    options = _ref.options;
			var isOptionUnique = this.props.isOptionUnique;


			options = options || this.props.options;

			return isOptionUnique({
				labelKey: this.labelKey,
				option: option,
				options: options,
				valueKey: this.valueKey
			});
		}
	}, {
		key: 'menuRenderer',
		value: function menuRenderer$$1(params) {
			var menuRenderer$$1 = this.props.menuRenderer;


			return menuRenderer$$1(_extends({}, params, {
				onSelect: this.onOptionSelect,
				selectValue: this.onOptionSelect
			}));
		}
	}, {
		key: 'onInputChange',
		value: function onInputChange(input) {
			var onInputChange = this.props.onInputChange;

			// This value may be needed in between Select mounts (when this.select is null)

			this.inputValue = input;

			if (onInputChange) {
				this.inputValue = onInputChange(input);
			}

			return this.inputValue;
		}
	}, {
		key: 'onInputKeyDown',
		value: function onInputKeyDown(event) {
			var _props3 = this.props,
			    shouldKeyDownEventCreateNewOption = _props3.shouldKeyDownEventCreateNewOption,
			    onInputKeyDown = _props3.onInputKeyDown;

			var focusedOption = this.select.getFocusedOption();

			if (focusedOption && focusedOption === this._createPlaceholderOption && shouldKeyDownEventCreateNewOption(event)) {
				this.createNewOption();

				// Prevent decorated Select from doing anything additional with this keyDown event
				event.preventDefault();
			} else if (onInputKeyDown) {
				onInputKeyDown(event);
			}
		}
	}, {
		key: 'onOptionSelect',
		value: function onOptionSelect(option) {
			if (option === this._createPlaceholderOption) {
				this.createNewOption();
			} else {
				this.select.selectValue(option);
			}
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props4 = this.props,
			    refProp = _props4.ref,
			    restProps = objectWithoutProperties(_props4, ['ref']);
			var children = this.props.children;

			// We can't use destructuring default values to set the children,
			// because it won't apply work if `children` is null. A falsy check is
			// more reliable in real world use-cases.

			if (!children) {
				children = defaultChildren$2;
			}

			var props = _extends({}, restProps, {
				allowCreate: true,
				filterOptions: this.filterOptions,
				menuRenderer: this.menuRenderer,
				onInputChange: this.onInputChange,
				onInputKeyDown: this.onInputKeyDown,
				ref: function ref(_ref2) {
					_this2.select = _ref2;

					// These values may be needed in between Select mounts (when this.select is null)
					if (_ref2) {
						_this2.labelKey = _ref2.props.labelKey;
						_this2.valueKey = _ref2.props.valueKey;
					}
					if (refProp) {
						refProp(_ref2);
					}
				}
			});

			return children(props);
		}
	}]);
	return CreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$2 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

var isOptionUnique = function isOptionUnique(_ref3) {
	var option = _ref3.option,
	    options = _ref3.options,
	    labelKey = _ref3.labelKey,
	    valueKey = _ref3.valueKey;

	if (!options || !options.length) {
		return true;
	}

	return options.filter(function (existingOption) {
		return existingOption[labelKey] === option[labelKey] || existingOption[valueKey] === option[valueKey];
	}).length === 0;
};

var isValidNewOption = function isValidNewOption(_ref4) {
	var label = _ref4.label;
	return !!label;
};

var newOptionCreator = function newOptionCreator(_ref5) {
	var label = _ref5.label,
	    labelKey = _ref5.labelKey,
	    valueKey = _ref5.valueKey;

	var option = {};
	option[valueKey] = label;
	option[labelKey] = label;
	option.className = 'Select-create-option-placeholder';

	return option;
};

var promptTextCreator = function promptTextCreator(label) {
	return 'Create option "' + label + '"';
};

var shouldKeyDownEventCreateNewOption = function shouldKeyDownEventCreateNewOption(_ref6) {
	var keyCode = _ref6.keyCode;

	switch (keyCode) {
		case 9: // TAB
		case 13: // ENTER
		case 188:
			// COMMA
			return true;
		default:
			return false;
	}
};

// Default prop methods
CreatableSelect.isOptionUnique = isOptionUnique;
CreatableSelect.isValidNewOption = isValidNewOption;
CreatableSelect.newOptionCreator = newOptionCreator;
CreatableSelect.promptTextCreator = promptTextCreator;
CreatableSelect.shouldKeyDownEventCreateNewOption = shouldKeyDownEventCreateNewOption;

CreatableSelect.defaultProps = {
	filterOptions: filterOptions,
	isOptionUnique: isOptionUnique,
	isValidNewOption: isValidNewOption,
	menuRenderer: menuRenderer,
	newOptionCreator: newOptionCreator,
	promptTextCreator: promptTextCreator,
	shouldKeyDownEventCreateNewOption: shouldKeyDownEventCreateNewOption,
	showNewOptionAtTop: true
};

CreatableSelect.propTypes = {
	// Child function responsible for creating the inner Select component
	// This component can be used to compose HOCs (eg Creatable and Async)
	// (props: Object): PropTypes.element
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.filterOptions
	filterOptions: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Searches for any matching option within the set of options.
	// This function prevents duplicate options from being created.
	// ({ option: Object, options: Array, labelKey: string, valueKey: string }): boolean
	isOptionUnique: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Determines if the current input text represents a valid option.
	// ({ label: string }): boolean
	isValidNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.menuRenderer
	menuRenderer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,

	// Factory to create new option.
	// ({ label: string, labelKey: string, valueKey: string }): Object
	newOptionCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input change handler: function (inputValue) {}
	onInputChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// input keyDown handler: function (event) {}
	onInputKeyDown: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// new option click handler: function (option) {}
	onNewOptionClick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// See Select.propTypes.options
	options: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,

	// Creates prompt/placeholder option text.
	// (filterText: string): string
	promptTextCreator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	ref: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Decides if a keyDown event (eg its `keyCode`) should result in the creation of a new option.
	shouldKeyDownEventCreateNewOption: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

	// Where to show prompt/placeholder option text.
	// true: new option prompt at top of list (default)
	// false: new option prompt at bottom of list
	showNewOptionAtTop: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
};

var AsyncCreatableSelect = function (_React$Component) {
	inherits(AsyncCreatableSelect, _React$Component);

	function AsyncCreatableSelect() {
		classCallCheck(this, AsyncCreatableSelect);
		return possibleConstructorReturn(this, (AsyncCreatableSelect.__proto__ || Object.getPrototypeOf(AsyncCreatableSelect)).apply(this, arguments));
	}

	createClass(AsyncCreatableSelect, [{
		key: 'focus',
		value: function focus() {
			this.select.focus();
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
				Async,
				this.props,
				function (_ref) {
					var ref = _ref.ref,
					    asyncProps = objectWithoutProperties(_ref, ['ref']);

					var asyncRef = ref;
					return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
						CreatableSelect,
						asyncProps,
						function (_ref2) {
							var ref = _ref2.ref,
							    creatableProps = objectWithoutProperties(_ref2, ['ref']);

							var creatableRef = ref;
							return _this2.props.children(_extends({}, creatableProps, {
								ref: function ref(select) {
									creatableRef(select);
									asyncRef(select);
									_this2.select = select;
								}
							}));
						}
					);
				}
			);
		}
	}]);
	return AsyncCreatableSelect;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

var defaultChildren$1 = function defaultChildren(props) {
	return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Select$1, props);
};

AsyncCreatableSelect.propTypes = {
	children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired // Child function responsible for creating the inner Select component; (props: Object): PropTypes.element
};

AsyncCreatableSelect.defaultProps = {
	children: defaultChildren$1
};

Select$1.Async = Async;
Select$1.AsyncCreatable = AsyncCreatableSelect;
Select$1.Creatable = CreatableSelect;
Select$1.Value = Value;
Select$1.Option = Option;


/* harmony default export */ __webpack_exports__["a"] = (Select$1);


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var open = { opacity: 1, display: 'block', backgroundImage: "url('" + __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + "/images/modal_background.png')" };
var closed = { opacity: 0, display: 'none' };

var Overlay = function (_Component) {
  _inherits(Overlay, _Component);

  // constructor
  function Overlay(props) {
    _classCallCheck(this, Overlay);

    var _this = _possibleConstructorReturn(this, (Overlay.__proto__ || Object.getPrototypeOf(Overlay)).call(this, props));

    _this.state = {
      style: closed,
      open: open,
      closed: closed,
      status: 'closed',
      mensagem: '',
      tipo: '',
      style_alert: {
        alert: {}, icon: ''
      },
      style_error: {
        alert: {
          color: '#a94442',
          background: '#f2dede'
        },
        icon: 'fa fa-fw fa-times-circle'
      },
      style_success: {
        alert: {
          color: '#3c763d',
          background: '#d6e9c6'
        },
        icon: 'fa fa-fw fa-check'
      },
      style_warning: {
        alert: {
          color: '#8a6d3b',
          background: '#fcf8e3'
        },
        icon: 'fa fa-fw fa-exclamation-triangle'
      },
      style_info: {
        alert: {
          color: '#31708f',
          background: '#d9edf7'
        },
        icon: 'fa fa-fw fa-info-circle'
      }
    };

    _this.fechar = _this.fechar.bind(_this);
    _this.handleProps = _this.handleProps.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  _createClass(Overlay, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.handleProps(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      this.handleProps(newProps);
    }
  }, {
    key: 'handleProps',
    value: function handleProps(props) {
      // Verifico se há mudança sobre estar aberto ou fechado
      if (this.state.status !== props.overlay.status) {
        if (props.overlay.status === 'open') {
          this.setState({ style: this.state.open });
        } else {
          this.setState({ style: this.state.closed });
        }
      }

      // Gravo as informações padrão
      this.setState({ status: props.overlay.status });
      this.setState({ message: props.overlay.message });
      this.setState({ type: props.overlay.type });

      // Verifico qual o estilo da mensagem
      switch (props.overlay.type) {
        case 'error':
          this.setState({ style_alert: this.state.style_error });
          break;
        case 'success':
          this.setState({ style_alert: this.state.style_success });
          break;
        case 'warning':
          this.setState({ style_alert: this.state.style_warning });
          break;
        case 'info':
          this.setState({ style_alert: this.state.style_info });
          break;
      }
    }
  }, {
    key: 'fechar',
    value: function fechar() {
      this.setState({ style: this.state.closed, status: 'closed' });
      this.props.handleAlert('', '', '', 'reset');
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.state.message !== '' || this.state.type !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'loading', style: this.state.style, onClick: this.fechar },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'alerta-container', style: this.state.style_alert.alert },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-11 text-left' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: this.state.style_alert.icon }),
                ' ',
                this.state.message
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-1 text-right' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'fechar-alerta', onClick: this.fechar },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                )
              )
            )
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'loading', style: this.state.style },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'loading-spinning' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-spinner fa-spin' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'loading-text' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                null,
                this.locale.Miscelania.Overlay.paragrafoCarregando
              )
            )
          )
        )
      );
    }
  }]);

  return Overlay;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Overlay);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(1501);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(1502);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(619);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(1503);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(1504);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(1505);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(1506);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(620);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(347);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(1507);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(1508);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(1509);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(1510);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(1511);
/* unused harmony reexport withRouter */





























/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(988);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(987);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(273);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(273);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(438);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Globals__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Miscelania_LocalStorageChecker__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_country_flag_icons_react_3x2__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Calendar_Calendar__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StaffDeslocations_StaffDeslocationsEdit__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FatigueTests_FatigueTestsIndex__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__StaffRfmsReport_StaffRfmsReportAdjustHours__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Users_EmailFatigueQuestions__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Users_EmailDrowsinessScheduleTest__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Users_Login__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Users_RecuperarSenha__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Users_Suspenso__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Users_UsersEditPassword__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Users_LocalStorageIndex__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Tasks_TasksAdd__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Tasks_TasksEdit__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Tasks_TasksIndex__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__DrowsinessSchedules_DrowsinessSchedulesAdd__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__DrowsinessSchedules_DrowsinessSchedulesIndex__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__DrowsinessSchedules_DrowsinessSchedulesEdit__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Fatigue_FatigueIndex__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Fatigue_FatigueAdd__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Fatigue_FatigueEdit__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__FatigueReasons_FatigueReasonsEdit__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__FatigueReasons_FatigueReasonReportsAdd__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__FatigueReasons_FatigueReasonReportsIndex__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__FatigueReasons_FatigueReasonReportsArchived__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__FatigueAuxiliaryReports_SearchAuxiliaryReport__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__FatigueAuxiliaryReports_FatigueAuxiliaryReportsAdd__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__StaffRfmsReport_StaffRfmsReportAdmAdd__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__StaffRfmsReport_StaffRfmsReportAdmEdit__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__StaffRfmsReport_StaffRfmsReportAdd__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__StaffRfmsReport_StaffRfmsReportEdit__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__StaffRfmsReport_StaffRfmsReportIndex__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__StaffRfmsReport_StaffRfmsReportFilter__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__StaffRfmsReport_StaffRfmsReportIncidentFatigueFilter__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__StaffRfmsReport_SimulatorStaffRfmsReport__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__StaffRfmsReport_StaffRfmsReportMissing__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__StaffRfmsReport_StaffRfmsReportSearch__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__FlightReports_FlightReportsOfflineIndex__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__FlightReports_FlightReportLegsFullOffline__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__FlightReports_FlightReportsOfflineEdit__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__FlightReports_FlightReportsIndex__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__FlightReports_FlightReportsEdit__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__FlightReports_FlightReportsAdd__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__FlightReports_Control_FlightReportsMain__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__FlightReports_Control_FlightReportsAircrafts__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__FlightReports_Control_FlightReportsRefuels__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__FlightReports_Control_FlightReportsConsumption__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__FlightReports_Control_FlightReportsConsumptionDisponibility__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__FlightReports_Control_FlightReportsAbnormalOcurrences__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__FlightReports_Control_FlightReportsDestinies__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__FlightReports_Control_FlightReportsPayloads__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__FlightReports_Control_FlightReportsLegDifferences__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__FlightReports_Control_FlightReportsAvailabilities__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__FlightReports_Control_FlightReportsAvailabilitiesSearch__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__FlightReports_Control_FlightReportsHoursReport__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__FlightReports_Control_FlightReportsMeasurementCheck__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__FlightReports_Control_FlightReportsPontuality__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__FlightReports_Control_FlightReportsXMLMultiple__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__FlightReports_Control_FlightReportsDBMultiple__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__FlightReports_Control_FlightReportsMainMultiple__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__AircraftLogbooks_AircraftLogbooksIndex__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__AircraftLogbooks_AircraftLogbooksAdd__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__AircraftLogbooks_AircraftLogbooksEdit__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__AircraftLogbooks_AircraftLogbooksSearch__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__AircraftLogbooks_AircraftLogbooksDashboard__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__AircraftLogbookReportActionDeferredItems_AircraftLogbookReportActionEdit__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__AircraftLogbookReportActionDeferredItems_AircraftLogbookReportActionsIndexOpened__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__AircraftLogbookReportActionDeferredItems_AircraftLogbookReportActionsIndexClosed__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__Schedules_SchedulesIndex__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__Schedules_SchedulePlanningIndex__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__Schedules_SchedulePlanningEdit__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__TrainingCertificationLogbooks_TrainingCertificationLogbooksIndex__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__Staffs_StaffFlightHourSearch__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__StaffDiscrepancies_StaffDiscrepanciesAdd__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__StaffPapers_StaffPapersIndex__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__StaffPapers_StaffPapersManager__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__StaffPapers_StaffPapersDone__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__StaffPapers_StaffPapersEdit__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__StaffPapers_StaffPapersAdd__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__StaffPapers_Control_StaffPapersControl__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__StaffPapers_Control_StaffPapersControleCrew__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__StaffScheduleRequests_StaffScheduleRequestsIndex__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__StaffScheduleRequests_StaffScheduleRequestsAdd__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__StaffScheduleRequests_StaffScheduleRequestsSigmecAdd__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__StaffScheduleRequests_StaffScheduleRequestsSigmecIndex__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__Controls_PaymentMonthControl__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__Controls_PaymentStatementControl__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__Payments_PaymentRequestScheduleDistanceIndex__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__Payments_PaymentRequestScheduleDistanceAdd__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__Payments_PaymentRequestTrainingDistanceIndex__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__Payments_PaymentRequestTrainingDistanceAdd__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__Payments_PaymentRequestScheduleTransportIndex__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__Payments_PaymentRequestScheduleTransportAdd__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__Payments_PaymentRequestTrainingTransportIndex__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__Payments_PaymentRequestTrainingTransportAdd__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__SigtripStaffs_SigtripStaffsQpulse__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__SigtripStaffs_SigtripStaffsPendingPapers__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__SigtripStaffs_SigtripStaffsPendingFlightReport__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__SigtripStaffs_SigtripStaffsPendingTrainings__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__SigmecStaffs_SigmecStaffsPendingTrainings__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__SigtripStaffs_SigtripStaffsPendingSchedules__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__SigtripStaffs_SigtripStaffsEdit__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__SigtripStaffs_SigtripStaffsTrainings__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__SigmecStaffs_SigmecStaffsEdit__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__SigmecStaffs_SigmecStaffsTrainings__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__Settings_SettingsEdit__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__UsefulLinks_UsefulLinksIndex__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__FlightReportRefuels_FlightReportRefuelsAdd__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__FlightReportRefuels_FlightReportRefuelsEdit__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__FlightReportRefuels_FlightReportRefuelsIndex__ = __webpack_require__(820);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







// Importação do Bootstrap


//Importo o componente de conteudo







// Calendar


//StaffDeslocations


// FatigueTestsIndex



// Users








// Tasks




// DrowsinessSchedules




// Fatigue




// FatigueReason & FatigueReasonReport





//FatigueAuxiliaryReport



//  RFMS Reports











// FlightReports







// FlightReports - Controles


















// AircraftLogbooks






// AircraftLogbookReportActionDeferredItems




// Schedules


// SchedulePlanning



// TrainingCertificationLogbooksIndex


// StaffFlights


// StaffDiscrepancies


// StaffPapers








// StaffScheduleRequests





// Payment











// Pendencias







// File Digital





// SettingsEdit


// UsefulLinks





var PropTypes = __webpack_require__(5);

var Topo = function (_Component) {
  _inherits(Topo, _Component);

  function Topo(props, context) {
    _classCallCheck(this, Topo);

    var _this = _possibleConstructorReturn(this, (Topo.__proto__ || Object.getPrototypeOf(Topo)).call(this, props, context));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      loaded: 0,
      user: JSON.parse(localStorage.getItem("data")).email,
      total: 0,
      total_qpulse: 0,
      total_staff_papers: 0,
      total_schedules: 0,
      total_flight_reports: 0,
      total_trainings: 0,
      storage_cleared: 1,
      is_online: true,
      menu_sm: false,
      language: false,
      last_online_status: 'working'
    };

    _this.loadData = _this.loadData.bind(_this);
    _this.changeMenu = _this.changeMenu.bind(_this);
    _this.promptInstallTrigger = _this.promptInstallTrigger.bind(_this);
    _this.logout = _this.logout.bind(_this);
    _this.changeLanguage = _this.changeLanguage.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__["a" /* default */])();
    _this.handleAlert = _this.handleAlert.bind(_this);

    return _this;
  }

  _createClass(Topo, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'changeMenu',
    value: function changeMenu(url) {
      this.context.router.history.push(url);
    }
  }, {
    key: 'promptInstallTrigger',
    value: function promptInstallTrigger() {

      this.props.promptInstall();
    }
  }, {
    key: 'logout',
    value: function logout(e) {
      e.preventDefault();
      localStorage.removeItem("cid");
      this.context.router.history.push('/usuario/login');
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var self = this;

      if (localStorage.getItem("lang") !== null) {
        this.setState({ language: localStorage.getItem("lang") });
      } else {
        var header = this.refs.request_api.header('application/json');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/usuario/idioma', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.setState({ language: responseJson.data.language });
            localStorage.setItem("lang", responseJson.data.language);
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
      if (navigator.onLine) {
        self.loadData();
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/portal/funcionario/pendencias';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              total: responseJson.data.total,
              total_qpulse: responseJson.data.total_qpulse,
              total_staff_papers: responseJson.data.total_staff_papers,
              total_schedules: responseJson.data.total_schedules,
              total_flight_reports: responseJson.data.total_flight_reports,
              total_trainings: responseJson.data.total_trainings,
              storage_cleared: responseJson.data.storage_cleared
            }, function () {
              if (responseJson.data.storage_cleared === 0) {
                //Se storage_cleared for 0, então remove os relatórios de mais de 02 dias do local storage
                self.localStorageCheckerRef.removeOldReportsFromLocalStorage();
              } else if (responseJson.data.storage_cleared === 2) {
                //Se storage_cleared for 2, então zera totalmente o local storage
                self.localStorageCheckerRef.clearLocalStorage();
              }
            });
          }
        }); /* Overlay */
      });
    }
  }, {
    key: 'changeLanguage',
    value: function changeLanguage(e) {
      var current_language = localStorage.getItem("lang");
      var new_language = 'pt-BR';
      if (current_language === 'pt-BR') new_language = 'en-US';
      this.setState({ language: new_language });
      localStorage.setItem("lang", new_language);

      var header = this.refs.request_api.header('application/json');
      var self = this;
      var datasave = {
        language: new_language
      };

      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/usuario/idioma', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          window.location.reload();
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Miscelania_LocalStorageChecker__["a" /* default */], { ref: function ref(_ref) {
            _this2.localStorageCheckerRef = _ref;
          } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { id: 'top' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'container' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-12 col-md-6', id: 'top-infs' },
                this.locale.Layout.Topo.bemvindo,
                ' ',
                this.state.user,
                ' - ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
                  { to: '/usuario/nova/senha' },
                  this.locale.Layout.Topo.botaoMinhaConta
                ),
                '\xA0\xA0\xA0|\xA0\xA0\xA0',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
                  { to: '/usuario/login', onClick: this.logout },
                  this.locale.Layout.Topo.botaoSair
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'col-xs-12 col-md-6 text-right', id: 'top-infs' })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { id: 'header' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["a" /* Navbar */],
            { collapseOnSelect: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["a" /* Navbar */].Header,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["a" /* Navbar */].Brand,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
                  { to: '/' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/images/logo1.png', style: { width: '100%' }, alt: 'PORTAL' })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["a" /* Navbar */].Toggle, null)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["a" /* Navbar */].Collapse,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["b" /* Nav */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["c" /* NavDropdown */],
                  { className: 'hidden-sm', eventKey: 1, title: this.locale.Layout.Topo.menuDadosBasicos.tituloMenu, id: 'menu-cadastro' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { header: true },
                    this.locale.Layout.Topo.menuDadosBasicos.FileDigital
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/portal/file/digital/sigtrip', className: 'menu-links' },
                    this.locale.Layout.Topo.menuDadosBasicos.FileDigital
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["c" /* NavDropdown */],
                  { className: 'hidden-sm', eventKey: 2, title: this.locale.Layout.Topo.menuVoos.tituloMenu, id: 'menu-voos' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { header: true },
                    this.locale.Layout.Topo.menuVoos.Relatorios
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/relatorios/voo', className: 'menu-links' },
                    this.locale.Layout.Topo.menuVoos.ListaDeRelatoriosDeVoo
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/relatorio/voo/cadastrar', className: 'menu-links' },
                    this.locale.Layout.Topo.menuVoos.CadastrarRelatorioDeVoo
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */], { divider: true }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { header: true },
                    this.locale.Layout.Topo.menuVoos.Abastecimentos
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/abastecimentos', className: 'menu-links' },
                    this.locale.Layout.Topo.menuVoos.ListaDeAbastecimentos
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/abastecimento/cadastrar', className: 'menu-links' },
                    this.locale.Layout.Topo.menuVoos.CadastrarAbastecimentoAvulso
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */], { divider: true }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { header: true },
                    this.locale.Layout.Topo.menuVoos.Controle
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/tripulantes/pesquisa/voos', className: 'menu-links' },
                    this.locale.Layout.Topo.menuVoos.VisualizarHoraDeVoo
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/relatorio/voo/pesquisa', className: 'menu-links' },
                    this.locale.Layout.Topo.menuVoos.ControleGeralDeRelatorios
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/relatorio/voo/db/bloco', className: 'menu-links' },
                    this.locale.Layout.Topo.menuVoos.ExtratoDeDBEmBloco
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/relatorio/voo/main/bloco', className: 'menu-links' },
                    this.locale.Layout.Topo.menuVoos.ExtratoDeRelatoriosEmBloco
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["c" /* NavDropdown */],
                  { className: 'hidden-sm', eventKey: 3, title: 'eDB', id: 'menu-diario-bordo' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { header: true },
                    'Di\xE1rio de Bordo'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/aeronave/diario/dashboard', target: '_blank', rel: 'noopener noreferrer', className: 'menu-links' },
                    'Dashboard'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/aeronave/diarios', target: '_blank', rel: 'noopener noreferrer', className: 'menu-links' },
                    'Lista de di\xE1rios de bordo'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/aeronave/diario/cadastrar', target: '_blank', rel: 'noopener noreferrer', className: 'menu-links' },
                    'Cadastrar di\xE1rio de bordo'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */], { divider: true }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { header: true },
                    'ACR'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/aeronave/diario/acrs/abertos', target: '_blank', rel: 'noopener noreferrer', className: 'menu-links' },
                    'Lista de ACRs abertos'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/aeronave/diario/acrs/fechados', target: '_blank', rel: 'noopener noreferrer', className: 'menu-links' },
                    'Lista de ACRs fechados'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["c" /* NavDropdown */],
                  { className: 'hidden-sm', eventKey: 4, title: this.locale.Layout.Topo.menuEscalas.tituloMenu, id: 'menu-escalas' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { header: true },
                    this.locale.Layout.Topo.menuEscalas.EscalaDiaria
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/escalas/programacao', className: 'menu-links' },
                    this.locale.Layout.Topo.menuEscalas.ListaDeEscalasDiaria
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["b" /* Nav */],
                { className: 'visible-sm' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                  { onClick: function onClick() {
                      return _this2.setState({ menu_sm: !_this2.state.menu_sm });
                    }, className: 'menu-links' },
                  !this.state.menu_sm && this.locale.general.abrirMenu,
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: !this.state.menu_sm ? "fa fa-caret-down" : "fa fa-close" })
                ),
                this.state.menu_sm && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["c" /* NavDropdown */],
                  { eventKey: 21, title: this.locale.Layout.Topo.menuDadosBasicos.tituloMenu, id: 'menu-cadastro' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { header: true },
                    this.locale.Layout.Topo.menuDadosBasicos.FileDigital
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/portal/file/digital/sigtrip', className: 'menu-links' },
                    this.locale.Layout.Topo.menuDadosBasicos.FileDigital
                  )
                ),
                this.state.menu_sm && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["c" /* NavDropdown */],
                  { eventKey: 22, title: this.locale.Layout.Topo.menuVoos.tituloMenu, id: 'menu-voos' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { header: true },
                    this.locale.Layout.Topo.menuVoos.Abastecimentos
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/abastecimento/cadastrar', className: 'menu-links' },
                    this.locale.Layout.Topo.menuVoos.CadastrarAbastecimentoAvulso
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */], { divider: true }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { header: true },
                    this.locale.Layout.Topo.menuVoos.Relatorios
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/relatorios/voo', className: 'menu-links' },
                    this.locale.Layout.Topo.menuVoos.ListaDeRelatoriosDeVoo
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/relatorio/voo/cadastrar', className: 'menu-links' },
                    this.locale.Layout.Topo.menuVoos.CadastrarRelatorioDeVoo
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */], { divider: true }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { header: true },
                    this.locale.Layout.Topo.menuVoos.Controle
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/tripulantes/pesquisa/voos', className: 'menu-links' },
                    this.locale.Layout.Topo.menuVoos.VisualizarHoraDeVoo
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/relatorio/voo/pesquisa', className: 'menu-links' },
                    this.locale.Layout.Topo.menuVoos.ControleGeralDeRelatorios
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/relatorio/voo/db/bloco', className: 'menu-links' },
                    this.locale.Layout.Topo.menuVoos.ExtratoDeDBEmBloco
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/relatorio/voo/main/bloco', className: 'menu-links' },
                    this.locale.Layout.Topo.menuVoos.ExtratoDeRelatoriosEmBloco
                  )
                ),
                this.state.menu_sm && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["c" /* NavDropdown */],
                  { eventKey: 25, title: 'eDB', id: 'menu-diario-bordo' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { header: true },
                    'Di\xE1rio de Bordo'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/aeronave/diario/dashboard', target: '_blank', rel: 'noopener noreferrer', className: 'menu-links' },
                    'Dashboard'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/aeronave/diarios', target: '_blank', rel: 'noopener noreferrer', className: 'menu-links' },
                    'Lista de di\xE1rios de bordo'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/aeronave/diario/cadastrar', target: '_blank', rel: 'noopener noreferrer', className: 'menu-links' },
                    'Cadastrar di\xE1rio de bordo'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */], { divider: true }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { header: true },
                    'ACR'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/aeronave/diario/acrs/abertos', target: '_blank', rel: 'noopener noreferrer', className: 'menu-links' },
                    'Lista de ACRs abertos'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/aeronave/diario/acrs/fechados', target: '_blank', rel: 'noopener noreferrer', className: 'menu-links' },
                    'Lista de ACRs fechados'
                  )
                ),
                this.state.menu_sm && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["c" /* NavDropdown */],
                  { eventKey: 23, title: this.locale.Layout.Topo.menuEscalas.tituloMenu, id: 'menu-escalas' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { header: true },
                    this.locale.Layout.Topo.menuEscalas.EscalaDiaria
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/escalas/programacao', className: 'menu-links' },
                    this.locale.Layout.Topo.menuEscalas.ListaDeEscalasDiaria
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["b" /* Nav */],
                { pullRight: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                  { href: '/calendario', className: 'menu-links' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-calendar' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["c" /* NavDropdown */],
                  { eventKey: 8, title: this.state.total > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-bell' }),
                      ' (',
                      this.state.total,
                      ')'
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-bell-o' })
                    ), id: 'menu-pendencias' },
                  this.state.total === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { onSelect: this.changeMenu, href: '#', className: 'menu-links' },
                    this.locale.Layout.Topo.menuPendencias.OUsuarioNaoPossuiPendencias,
                    ' '
                  ) : '',
                  this.state.total_qpulse > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { onSelect: this.changeMenu, href: '/pendencias/qpulse', className: 'menu-links' },
                    this.locale.Layout.Topo.menuPendencias.Documentacao,
                    ' ',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      ' ',
                      this.state.total_qpulse
                    ),
                    ' '
                  ) : '',
                  this.state.total_qpulse > 0 && this.state.total > this.state.total_qpulse ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */], { divider: true }) : '',
                  this.state.total_staff_papers > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { onSelect: this.changeMenu, href: '/pendencias/fira', className: 'menu-links' },
                    this.locale.Layout.Topo.menuPendencias.Papeletas,
                    ' ',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      ' ',
                      this.state.total_staff_papers
                    ),
                    ' '
                  ) : '',
                  this.state.total_staff_papers > 0 && (this.state.total_schedules > 0 || this.state.total_flight_reports > 0 || this.state.total_trainings > 0) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */], { divider: true }) : '',
                  this.state.total_schedules > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { onSelect: this.changeMenu, href: '/pendencias/escalas', className: 'menu-links' },
                    this.locale.Layout.Topo.menuPendencias.Escalas,
                    ' ',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      ' ',
                      this.state.total_schedules
                    ),
                    ' '
                  ) : '',
                  this.state.total_schedules > 0 && (this.state.total_flight_reports > 0 || this.state.total_trainings > 0) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */], { divider: true }) : '',
                  this.state.total_flight_reports > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { onSelect: this.changeMenu, href: '/pendencias/relatorios/voo', className: 'menu-links' },
                    this.locale.Layout.Topo.menuPendencias.Voos,
                    ' ',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      ' ',
                      this.state.total_flight_reports
                    ),
                    ' '
                  ) : '',
                  this.state.total_flight_reports > 0 && this.state.total_trainings > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */], { divider: true }) : '',
                  this.state.total_trainings > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { onSelect: this.changeMenu, href: '/pendencias/treinamento/sigtrip', className: 'menu-links' },
                    this.locale.Layout.Topo.menuPendencias.Treinamentos,
                    ' ',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      ' ',
                      this.state.total_trainings
                    ),
                    ' '
                  ) : ''
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["c" /* NavDropdown */],
                  { eventKey: 9, title: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-cog fa-fw' }), id: 'menu-configuracoes' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { header: true },
                    this.locale.Layout.Topo.menuConfiguracoes.App
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { onSelect: this.promptInstallTrigger, className: 'menu-links' },
                    this.locale.Layout.Topo.menuConfiguracoes.InstalacaoMobile
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/limpar/cache', className: 'menu-links' },
                    'Limpar cache'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */], { divider: true }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { header: true },
                    this.locale.Layout.Topo.menuConfiguracoes.Diversos
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: '/links/uteis', className: 'menu-links' },
                    this.locale.Layout.Topo.menuConfiguracoes.LinksUteis
                  )
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('development') && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { className: 'development', style: { padding: '20px', background: '#ffcccb', color: 'red', width: '100%', marginBottom: '20px', fontSize: '20px' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa fa-warning' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { style: { color: 'red' } },
            ' ',
            this.locale.Layout.Topo.atencaoVoceEstaUtilizandoOAmbienteDeHomologacao,
            ' '
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa fa-warning' })
        ),
        !this.state.is_online && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'section',
          { className: 'development', style: { padding: '20px', background: '#ffcccb', color: 'red', width: '100%', marginBottom: '20px', fontSize: '20px' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa fa-warning' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { style: { color: 'red' } },
            ' ',
            this.locale.general.semConexao,
            ' '
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa fa-warning' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Switch */],
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/calendario', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Calendar_Calendar__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/controle/extrato/geral', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_95__Controls_PaymentStatementControl__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/controle/extrato/mensal', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_94__Controls_PaymentMonthControl__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/cadastrar/solicitacao/pagamento/deslocamento/missao', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_97__Payments_PaymentRequestScheduleDistanceAdd__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/lista/solicitacao/pagamento/deslocamento/missao', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_96__Payments_PaymentRequestScheduleDistanceIndex__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/cadastrar/solicitacao/pagamento/deslocamento/treinamento', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_99__Payments_PaymentRequestTrainingDistanceAdd__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/lista/solicitacao/pagamento/deslocamento/treinamento', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_98__Payments_PaymentRequestTrainingDistanceIndex__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/cadastrar/solicitacao/pagamento/transporte/missao', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_101__Payments_PaymentRequestScheduleTransportAdd__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/lista/solicitacao/pagamento/transporte/missao', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_100__Payments_PaymentRequestScheduleTransportIndex__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/cadastrar/solicitacao/pagamento/transporte/treinamento', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_103__Payments_PaymentRequestTrainingTransportAdd__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/lista/solicitacao/pagamento/transporte/treinamento', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_102__Payments_PaymentRequestTrainingTransportIndex__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/tripulante/deslocamento/editar/:token', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__StaffDeslocations_StaffDeslocationsEdit__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/questionario/pesquisa/repostas', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__FatigueTests_FatigueTestsIndex__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/tripulantes/pesquisa/voos', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_81__Staffs_StaffFlightHourSearch__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/questionario/pesquisa/fadiga/reposta/:token', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Users_EmailFatigueQuestions__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/teste/sonolencia/resposta/:token', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Users_EmailDrowsinessScheduleTest__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/usuario/login', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Users_Login__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/usuario/recuperar_senha', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Users_RecuperarSenha__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/usuario/suspenso', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Users_Suspenso__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/usuario/nova/senha', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Users_UsersEditPassword__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/tarefas/cadastrar', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Tasks_TasksAdd__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/tarefa/editar/:id', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__Tasks_TasksEdit__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/tarefas', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__Tasks_TasksIndex__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/abastecimento/cadastrar', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_116__FlightReportRefuels_FlightReportRefuelsAdd__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/abastecimento/editar/:id', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_117__FlightReportRefuels_FlightReportRefuelsEdit__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/abastecimentos', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_118__FlightReportRefuels_FlightReportRefuelsIndex__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorio/voo/cadastrar', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_51__FlightReports_FlightReportsAdd__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorio/voo/editar/offline/:id', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48__FlightReports_FlightReportsOfflineEdit__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorio/voo/editar/:id', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_50__FlightReports_FlightReportsEdit__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorios/voo/offline', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_46__FlightReports_FlightReportsOfflineIndex__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/trechos/offline', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_47__FlightReports_FlightReportLegsFullOffline__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorios/voo', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_49__FlightReports_FlightReportsIndex__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorio/voo/aeronaves/contratadas', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_53__FlightReports_Control_FlightReportsAircrafts__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorio/voo/pesquisa', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_52__FlightReports_Control_FlightReportsMain__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorio/voo/abastecimento', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_54__FlightReports_Control_FlightReportsRefuels__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorio/voo/consumo/disponibilidade', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_56__FlightReports_Control_FlightReportsConsumptionDisponibility__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorio/voo/consumo', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_55__FlightReports_Control_FlightReportsConsumption__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorio/voo/ocorrencias/anormais', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_57__FlightReports_Control_FlightReportsAbnormalOcurrences__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorio/voo/destinos', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_58__FlightReports_Control_FlightReportsDestinies__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorio/voo/carga/externa', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_59__FlightReports_Control_FlightReportsPayloads__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorio/voo/diferenca/trechos', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_60__FlightReports_Control_FlightReportsLegDifferences__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorio/voo/consulta/indisponibilidade', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_62__FlightReports_Control_FlightReportsAvailabilitiesSearch__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorio/voo/boletim/disponibilidade', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_61__FlightReports_Control_FlightReportsAvailabilities__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorio/voo/apuracao/horas', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_63__FlightReports_Control_FlightReportsHoursReport__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorio/voo/conferencia/medicao', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_64__FlightReports_Control_FlightReportsMeasurementCheck__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorio/voo/xml/bloco', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_66__FlightReports_Control_FlightReportsXMLMultiple__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorio/voo/db/bloco', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_67__FlightReports_Control_FlightReportsDBMultiple__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorio/voo/main/bloco', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_68__FlightReports_Control_FlightReportsMainMultiple__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/aeronave/diario/editar/:id', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_71__AircraftLogbooks_AircraftLogbooksEdit__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/aeronave/diario/cadastrar', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_70__AircraftLogbooks_AircraftLogbooksAdd__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/aeronave/diario/pesquisa', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_72__AircraftLogbooks_AircraftLogbooksSearch__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/aeronave/diario/dashboard', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_73__AircraftLogbooks_AircraftLogbooksDashboard__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/aeronave/diarios', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_69__AircraftLogbooks_AircraftLogbooksIndex__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/aeronave/diario/acr/editar/:id', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_74__AircraftLogbookReportActionDeferredItems_AircraftLogbookReportActionEdit__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/aeronave/diario/acrs/abertos', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_75__AircraftLogbookReportActionDeferredItems_AircraftLogbookReportActionsIndexOpened__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/aeronave/diario/acrs/fechados', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_76__AircraftLogbookReportActionDeferredItems_AircraftLogbookReportActionsIndexClosed__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/escalas/colaborador', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_77__Schedules_SchedulesIndex__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/escala/programacao/editar/:id', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_79__Schedules_SchedulePlanningEdit__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/escalas/programacao', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_78__Schedules_SchedulePlanningIndex__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/logbooks', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_80__TrainingCertificationLogbooks_TrainingCertificationLogbooksIndex__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/sigtrip/treinamentos', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_111__SigtripStaffs_SigtripStaffsTrainings__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/sigmec/treinamentos', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_113__SigmecStaffs_SigmecStaffsTrainings__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/tripulante/discrepancia', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_82__StaffDiscrepancies_StaffDiscrepanciesAdd__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/papeletas/controle', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_88__StaffPapers_Control_StaffPapersControl__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/papeletas', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_83__StaffPapers_StaffPapersIndex__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/papeletas/gestor', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_84__StaffPapers_StaffPapersManager__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/papeletas/aprovadas', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_85__StaffPapers_StaffPapersDone__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/papeleta/editar/:id', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_86__StaffPapers_StaffPapersEdit__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/papeleta/consulta/tripulante', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_89__StaffPapers_Control_StaffPapersControleCrew__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/papeleta/cadastrar', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_87__StaffPapers_StaffPapersAdd__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/funcionario/escala/solicitacoes/sigmec', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_93__StaffScheduleRequests_StaffScheduleRequestsSigmecIndex__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/escala/solicitacao/cadastrar/sigmec', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_92__StaffScheduleRequests_StaffScheduleRequestsSigmecAdd__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/escala/solicitacao/cadastrar', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_91__StaffScheduleRequests_StaffScheduleRequestsAdd__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/escala/solicitacoes', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_90__StaffScheduleRequests_StaffScheduleRequestsIndex__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorios-de-fadiga/faltantes', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_44__StaffRfmsReport_StaffRfmsReportMissing__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorios-de-fadiga/pesquisa', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_45__StaffRfmsReport_StaffRfmsReportSearch__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorios-de-fadiga/incorretos', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StaffRfmsReport_StaffRfmsReportAdjustHours__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/administrativo/relatorio-de-fadiga/cadastrar', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__StaffRfmsReport_StaffRfmsReportAdmAdd__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorio-de-fadiga/cadastrar', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_38__StaffRfmsReport_StaffRfmsReportAdd__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorios-de-fadiga/tripulante', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_40__StaffRfmsReport_StaffRfmsReportIndex__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorios-de-fadiga/monitoramento', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_41__StaffRfmsReport_StaffRfmsReportFilter__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorios-de-fadiga/incidentes', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_42__StaffRfmsReport_StaffRfmsReportIncidentFatigueFilter__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorio-de-fadiga/tripulante/administrativo/editar/:id/:applicability_id/:staff_id', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__StaffRfmsReport_StaffRfmsReportAdmEdit__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorio-de-fadiga/tripulante/editar/:id', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_39__StaffRfmsReport_StaffRfmsReportEdit__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/simular/relatorios-de-fadiga', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_43__StaffRfmsReport_SimulatorStaffRfmsReport__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/escala/sonolencia/editar/:id', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__DrowsinessSchedules_DrowsinessSchedulesEdit__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/escala/sonolencia/cadastrar', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__DrowsinessSchedules_DrowsinessSchedulesAdd__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/escalas/sonolencia', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__DrowsinessSchedules_DrowsinessSchedulesIndex__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/parametro-de-fadiga/cadastrar', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__Fatigue_FatigueAdd__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/parametros-de-fadiga', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27__Fatigue_FatigueIndex__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/parametro-de-fadiga/editar/:id', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__Fatigue_FatigueEdit__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/configuracoes/pontuacao', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_114__Settings_SettingsEdit__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/fadiga/motivos', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__FatigueReasons_FatigueReasonsEdit__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/reporte/voluntario/fadiga/abertos', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__FatigueReasons_FatigueReasonReportsIndex__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/reporte/voluntario/fadiga/fechados', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_33__FatigueReasons_FatigueReasonReportsArchived__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/reporte/voluntario/fadiga', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__FatigueReasons_FatigueReasonReportsAdd__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/relatorios-de-fadiga/autoavaliacao', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_34__FatigueAuxiliaryReports_SearchAuxiliaryReport__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/reporte/auxiliar/fadiga', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_35__FatigueAuxiliaryReports_FatigueAuxiliaryReportsAdd__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/pendencias/qpulse', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_104__SigtripStaffs_SigtripStaffsQpulse__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/pendencias/fira', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_105__SigtripStaffs_SigtripStaffsPendingPapers__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/pendencias/relatorios/voo', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_106__SigtripStaffs_SigtripStaffsPendingFlightReport__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/pendencias/treinamento/sigtrip', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_107__SigtripStaffs_SigtripStaffsPendingTrainings__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/pendencias/treinamento/sigmec', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_108__SigmecStaffs_SigmecStaffsPendingTrainings__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/pendencias/escalas', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_109__SigtripStaffs_SigtripStaffsPendingSchedules__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/limpar/cache', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Users_LocalStorageIndex__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/links/uteis', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_115__UsefulLinks_UsefulLinksIndex__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/portal/file/digital/sigtrip', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_110__SigtripStaffs_SigtripStaffsEdit__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/portal/file/digital/sigmec', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_112__SigmecStaffs_SigmecStaffsEdit__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/', render: function render(props) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Calendar_Calendar__["a" /* default */], Object.assign({}, props, { promptInstall: _this2.promptInstall }));
              } })
          )
        )
      );
    }
  }]);

  return Topo;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Topo.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Topo);

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Accordion__ = __webpack_require__(1333);
/* unused harmony reexport Accordion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Alert__ = __webpack_require__(1334);
/* unused harmony reexport Alert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Badge__ = __webpack_require__(1335);
/* unused harmony reexport Badge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Breadcrumb__ = __webpack_require__(1336);
/* unused harmony reexport Breadcrumb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BreadcrumbItem__ = __webpack_require__(571);
/* unused harmony reexport BreadcrumbItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(169);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_5__Button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonGroup__ = __webpack_require__(324);
/* unused harmony reexport ButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonToolbar__ = __webpack_require__(1337);
/* unused harmony reexport ButtonToolbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Carousel__ = __webpack_require__(1338);
/* unused harmony reexport Carousel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CarouselItem__ = __webpack_require__(572);
/* unused harmony reexport CarouselItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Checkbox__ = __webpack_require__(1340);
/* unused harmony reexport Checkbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Clearfix__ = __webpack_require__(1341);
/* unused harmony reexport Clearfix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CloseButton__ = __webpack_require__(325);
/* unused harmony reexport CloseButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ControlLabel__ = __webpack_require__(1343);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_13__ControlLabel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Col__ = __webpack_require__(1342);
/* unused harmony reexport Col */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Collapse__ = __webpack_require__(326);
/* unused harmony reexport Collapse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Dropdown__ = __webpack_require__(212);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_16__Dropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DropdownButton__ = __webpack_require__(1344);
/* unused harmony reexport DropdownButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Fade__ = __webpack_require__(213);
/* unused harmony reexport Fade */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Form__ = __webpack_require__(1346);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_19__Form__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__FormControl__ = __webpack_require__(1347);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_20__FormControl__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__FormGroup__ = __webpack_require__(1350);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_21__FormGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Glyphicon__ = __webpack_require__(327);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_22__Glyphicon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Grid__ = __webpack_require__(574);
/* unused harmony reexport Grid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__HelpBlock__ = __webpack_require__(1351);
/* unused harmony reexport HelpBlock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Image__ = __webpack_require__(1352);
/* unused harmony reexport Image */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__InputGroup__ = __webpack_require__(1353);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_26__InputGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Jumbotron__ = __webpack_require__(1356);
/* unused harmony reexport Jumbotron */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Label__ = __webpack_require__(1357);
/* unused harmony reexport Label */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ListGroup__ = __webpack_require__(1358);
/* unused harmony reexport ListGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ListGroupItem__ = __webpack_require__(575);
/* unused harmony reexport ListGroupItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Media__ = __webpack_require__(214);
/* unused harmony reexport Media */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__MenuItem__ = __webpack_require__(1365);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_32__MenuItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Modal__ = __webpack_require__(1366);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_33__Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ModalBody__ = __webpack_require__(576);
/* unused harmony reexport ModalBody */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ModalFooter__ = __webpack_require__(577);
/* unused harmony reexport ModalFooter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__ModalHeader__ = __webpack_require__(578);
/* unused harmony reexport ModalHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__ModalTitle__ = __webpack_require__(579);
/* unused harmony reexport ModalTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Nav__ = __webpack_require__(580);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_38__Nav__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Navbar__ = __webpack_require__(1369);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_39__Navbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__NavbarBrand__ = __webpack_require__(582);
/* unused harmony reexport NavbarBrand */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__NavDropdown__ = __webpack_require__(1368);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_41__NavDropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__NavItem__ = __webpack_require__(581);
/* unused harmony reexport NavItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__Overlay__ = __webpack_require__(583);
/* unused harmony reexport Overlay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__OverlayTrigger__ = __webpack_require__(1373);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_44__OverlayTrigger__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__PageHeader__ = __webpack_require__(1374);
/* unused harmony reexport PageHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__PageItem__ = __webpack_require__(1375);
/* unused harmony reexport PageItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__Pager__ = __webpack_require__(1376);
/* unused harmony reexport Pager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Pagination__ = __webpack_require__(1377);
/* unused harmony reexport Pagination */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__PaginationButton__ = __webpack_require__(585);
/* unused harmony reexport PaginationButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Panel__ = __webpack_require__(1378);
/* unused harmony reexport Panel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__PanelGroup__ = __webpack_require__(586);
/* unused harmony reexport PanelGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__Popover__ = __webpack_require__(1379);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_52__Popover__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__ProgressBar__ = __webpack_require__(1380);
/* unused harmony reexport ProgressBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Radio__ = __webpack_require__(1381);
/* unused harmony reexport Radio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__ResponsiveEmbed__ = __webpack_require__(1382);
/* unused harmony reexport ResponsiveEmbed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Row__ = __webpack_require__(1383);
/* unused harmony reexport Row */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__SafeAnchor__ = __webpack_require__(64);
/* unused harmony reexport SafeAnchor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__SplitButton__ = __webpack_require__(1384);
/* unused harmony reexport SplitButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__Tab__ = __webpack_require__(1386);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_59__Tab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__TabContainer__ = __webpack_require__(328);
/* unused harmony reexport TabContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__TabContent__ = __webpack_require__(329);
/* unused harmony reexport TabContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__Table__ = __webpack_require__(1387);
/* unused harmony reexport Table */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__TabPane__ = __webpack_require__(587);
/* unused harmony reexport TabPane */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__Tabs__ = __webpack_require__(1388);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_64__Tabs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Thumbnail__ = __webpack_require__(1389);
/* unused harmony reexport Thumbnail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__ToggleButton__ = __webpack_require__(588);
/* unused harmony reexport ToggleButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__ToggleButtonGroup__ = __webpack_require__(1390);
/* unused harmony reexport ToggleButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Tooltip__ = __webpack_require__(1391);
/* unused harmony reexport Tooltip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__Well__ = __webpack_require__(1392);
/* unused harmony reexport Well */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__utils__ = __webpack_require__(1396);
/* unused harmony reexport utils */















































































































































/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SizePerPageDropDown = exports.ButtonGroup = exports.SearchField = exports.ClearSearchButton = exports.ExportCSVButton = exports.ShowSelectedOnlyButton = exports.DeleteButton = exports.InsertButton = exports.InsertModalFooter = exports.InsertModalBody = exports.InsertModalHeader = exports.TableHeaderColumn = exports.BootstrapTable = undefined;

var _BootstrapTable = __webpack_require__(1309);

var _BootstrapTable2 = _interopRequireDefault(_BootstrapTable);

var _TableHeaderColumn = __webpack_require__(560);

var _TableHeaderColumn2 = _interopRequireDefault(_TableHeaderColumn);

var _InsertModalHeader = __webpack_require__(568);

var _InsertModalHeader2 = _interopRequireDefault(_InsertModalHeader);

var _InsertModalBody = __webpack_require__(566);

var _InsertModalBody2 = _interopRequireDefault(_InsertModalBody);

var _InsertModalFooter = __webpack_require__(567);

var _InsertModalFooter2 = _interopRequireDefault(_InsertModalFooter);

var _InsertButton = __webpack_require__(565);

var _InsertButton2 = _interopRequireDefault(_InsertButton);

var _DeleteButton = __webpack_require__(563);

var _DeleteButton2 = _interopRequireDefault(_DeleteButton);

var _ExportCSVButton = __webpack_require__(564);

var _ExportCSVButton2 = _interopRequireDefault(_ExportCSVButton);

var _ShowSelectedOnlyButton = __webpack_require__(570);

var _ShowSelectedOnlyButton2 = _interopRequireDefault(_ShowSelectedOnlyButton);

var _ClearSearchButton = __webpack_require__(562);

var _ClearSearchButton2 = _interopRequireDefault(_ClearSearchButton);

var _SearchField = __webpack_require__(569);

var _SearchField2 = _interopRequireDefault(_SearchField);

var _ButtonGroup = __webpack_require__(1330);

var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);

var _SizePerPageDropDown = __webpack_require__(561);

var _SizePerPageDropDown2 = _interopRequireDefault(_SizePerPageDropDown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (typeof window !== 'undefined') {
  window.BootstrapTable = _BootstrapTable2.default;
  window.TableHeaderColumn = _TableHeaderColumn2.default;
  window.InsertModalHeader = _InsertModalHeader2.default;
  window.InsertModalBody = _InsertModalBody2.default;
  window.InsertModalFooter = _InsertModalFooter2.default;
  window.InsertButton = _InsertButton2.default;
  window.DeleteButton = _DeleteButton2.default;
  window.ShowSelectedOnlyButton = _ShowSelectedOnlyButton2.default;
  window.ExportCSVButton = _ExportCSVButton2.default;
  window.ClearSearchButton = _ClearSearchButton2.default;
  window.SearchField = _SearchField2.default;
  window.ButtonGroup = _ButtonGroup2.default;
  window.SizePerPageDropDown = _SizePerPageDropDown2.default;
}
exports.BootstrapTable = _BootstrapTable2.default;
exports.TableHeaderColumn = _TableHeaderColumn2.default;
exports.InsertModalHeader = _InsertModalHeader2.default;
exports.InsertModalBody = _InsertModalBody2.default;
exports.InsertModalFooter = _InsertModalFooter2.default;
exports.InsertButton = _InsertButton2.default;
exports.DeleteButton = _DeleteButton2.default;
exports.ShowSelectedOnlyButton = _ShowSelectedOnlyButton2.default;
exports.ExportCSVButton = _ExportCSVButton2.default;
exports.ClearSearchButton = _ClearSearchButton2.default;
exports.SearchField = _SearchField2.default;
exports.ButtonGroup = _ButtonGroup2.default;
exports.SizePerPageDropDown = _SizePerPageDropDown2.default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }
}();

;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _check = __webpack_require__(1529);

var _check2 = _interopRequireDefault(_check);

var _x = __webpack_require__(1531);

var _x2 = _interopRequireDefault(_x);

var _util = __webpack_require__(1530);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Toggle = function (_PureComponent) {
  _inherits(Toggle, _PureComponent);

  function Toggle(props) {
    _classCallCheck(this, Toggle);

    var _this = _possibleConstructorReturn(this, (Toggle.__proto__ || Object.getPrototypeOf(Toggle)).call(this, props));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleTouchStart = _this.handleTouchStart.bind(_this);
    _this.handleTouchMove = _this.handleTouchMove.bind(_this);
    _this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.previouslyChecked = !!(props.checked || props.defaultChecked);
    _this.state = {
      checked: !!(props.checked || props.defaultChecked),
      hasFocus: false
    };
    return _this;
  }

  _createClass(Toggle, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.checked !== this.props.checked) {
        // Disable linting rule here since this usage of setState inside
        // componentDidUpdate is OK; see
        // https://reactjs.org/docs/react-component.html#componentdidupdate
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ checked: !!this.props.checked });
      }
    }
  }, {
    key: 'handleClick',
    value: function handleClick(event) {
      if (this.props.disabled) {
        return;
      }
      var checkbox = this.input;
      if (event.target !== checkbox && !this.moved) {
        this.previouslyChecked = checkbox.checked;
        event.preventDefault();
        checkbox.focus();
        checkbox.click();
        return;
      }

      var checked = this.props.hasOwnProperty('checked') ? this.props.checked : checkbox.checked;

      this.setState({ checked: checked });
    }
  }, {
    key: 'handleTouchStart',
    value: function handleTouchStart(event) {
      if (this.props.disabled) {
        return;
      }
      this.startX = (0, _util.pointerCoord)(event).x;
      this.activated = true;
    }
  }, {
    key: 'handleTouchMove',
    value: function handleTouchMove(event) {
      if (!this.activated) return;
      this.moved = true;

      if (this.startX) {
        var currentX = (0, _util.pointerCoord)(event).x;
        if (this.state.checked && currentX + 15 < this.startX) {
          this.setState({ checked: false });
          this.startX = currentX;
          this.activated = true;
        } else if (currentX - 15 > this.startX) {
          this.setState({ checked: true });
          this.startX = currentX;
          this.activated = currentX < this.startX + 5;
        }
      }
    }
  }, {
    key: 'handleTouchEnd',
    value: function handleTouchEnd(event) {
      if (!this.moved) return;
      var checkbox = this.input;
      event.preventDefault();

      if (this.startX) {
        var endX = (0, _util.pointerCoord)(event).x;
        if (this.previouslyChecked === true && this.startX + 4 > endX) {
          if (this.previouslyChecked !== this.state.checked) {
            this.setState({ checked: false });
            this.previouslyChecked = this.state.checked;
            checkbox.click();
          }
        } else if (this.startX - 4 < endX) {
          if (this.previouslyChecked !== this.state.checked) {
            this.setState({ checked: true });
            this.previouslyChecked = this.state.checked;
            checkbox.click();
          }
        }

        this.activated = false;
        this.startX = null;
        this.moved = false;
      }
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus(event) {
      var onFocus = this.props.onFocus;


      if (onFocus) {
        onFocus(event);
      }

      this.setState({ hasFocus: true });
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur(event) {
      var onBlur = this.props.onBlur;


      if (onBlur) {
        onBlur(event);
      }

      this.setState({ hasFocus: false });
    }
  }, {
    key: 'getIcon',
    value: function getIcon(type) {
      var icons = this.props.icons;

      if (!icons) {
        return null;
      }
      return icons[type] === undefined ? Toggle.defaultProps.icons[type] : icons[type];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          _icons = _props.icons,
          inputProps = _objectWithoutProperties(_props, ['className', 'icons']);

      var classes = (0, _classnames2.default)('react-toggle', {
        'react-toggle--checked': this.state.checked,
        'react-toggle--focus': this.state.hasFocus,
        'react-toggle--disabled': this.props.disabled
      }, className);

      return _react2.default.createElement(
        'div',
        { className: classes,
          onClick: this.handleClick,
          onTouchStart: this.handleTouchStart,
          onTouchMove: this.handleTouchMove,
          onTouchEnd: this.handleTouchEnd },
        _react2.default.createElement(
          'div',
          { className: 'react-toggle-track' },
          _react2.default.createElement(
            'div',
            { className: 'react-toggle-track-check' },
            this.getIcon('checked')
          ),
          _react2.default.createElement(
            'div',
            { className: 'react-toggle-track-x' },
            this.getIcon('unchecked')
          )
        ),
        _react2.default.createElement('div', { className: 'react-toggle-thumb' }),
        _react2.default.createElement('input', _extends({}, inputProps, {
          ref: function ref(_ref) {
            _this2.input = _ref;
          },
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          className: 'react-toggle-screenreader-only',
          type: 'checkbox' }))
      );
    }
  }]);

  return Toggle;
}(_react.PureComponent);

exports.default = Toggle;


Toggle.displayName = 'Toggle';

Toggle.defaultProps = {
  icons: {
    checked: _react2.default.createElement(_check2.default, null),
    unchecked: _react2.default.createElement(_x2.default, null)
  }
};

Toggle.propTypes = {
  checked: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  defaultChecked: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  className: _propTypes2.default.string,
  name: _propTypes2.default.string,
  value: _propTypes2.default.string,
  id: _propTypes2.default.string,
  'aria-labelledby': _propTypes2.default.string,
  'aria-label': _propTypes2.default.string,
  icons: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.shape({
    checked: _propTypes2.default.node,
    unchecked: _propTypes2.default.node
  })])
};

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = prefix;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return bsClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return bsStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return bsSizes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getClassSet;
/* harmony export (immutable) */ __webpack_exports__["a"] = splitBsProps;
/* harmony export (immutable) */ __webpack_exports__["g"] = splitBsPropsAndOmit;
/* unused harmony export addStyle */
/* unused harmony export _curry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StyleConfig__ = __webpack_require__(42);


// TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.






function curry(fn) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var last = args[args.length - 1];
    if (typeof last === 'function') {
      return fn.apply(undefined, args);
    }
    return function (Component) {
      return fn.apply(undefined, args.concat([Component]));
    };
  };
}

function prefix(props, variant) {
  !(props.bsClass != null) ?  false ? invariant(false, 'A `bsClass` prop is required for this component') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  return props.bsClass + (variant ? '-' + variant : '');
}

var bsClass = curry(function (defaultClass, Component) {
  var propTypes = Component.propTypes || (Component.propTypes = {});
  var defaultProps = Component.defaultProps || (Component.defaultProps = {});

  propTypes.bsClass = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
  defaultProps.bsClass = defaultClass;

  return Component;
});

var bsStyles = curry(function (styles, defaultStyle, Component) {
  if (typeof defaultStyle !== 'string') {
    Component = defaultStyle;
    defaultStyle = undefined;
  }

  var existing = Component.STYLES || [];
  var propTypes = Component.propTypes || {};

  styles.forEach(function (style) {
    if (existing.indexOf(style) === -1) {
      existing.push(style);
    }
  });

  var propType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(existing);

  // expose the values on the propType function for documentation
  Component.STYLES = existing;
  propType._values = existing;

  Component.propTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, propTypes, {
    bsStyle: propType
  });

  if (defaultStyle !== undefined) {
    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
    defaultProps.bsStyle = defaultStyle;
  }

  return Component;
});

var bsSizes = curry(function (sizes, defaultSize, Component) {
  if (typeof defaultSize !== 'string') {
    Component = defaultSize;
    defaultSize = undefined;
  }

  var existing = Component.SIZES || [];
  var propTypes = Component.propTypes || {};

  sizes.forEach(function (size) {
    if (existing.indexOf(size) === -1) {
      existing.push(size);
    }
  });

  var values = [];
  existing.forEach(function (size) {
    var mappedSize = __WEBPACK_IMPORTED_MODULE_4__StyleConfig__["a" /* SIZE_MAP */][size];
    if (mappedSize && mappedSize !== size) {
      values.push(mappedSize);
    }

    values.push(size);
  });

  var propType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(values);
  propType._values = values;

  // expose the values on the propType function for documentation
  Component.SIZES = existing;

  Component.propTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, propTypes, {
    bsSize: propType
  });

  if (defaultSize !== undefined) {
    if (!Component.defaultProps) {
      Component.defaultProps = {};
    }
    Component.defaultProps.bsSize = defaultSize;
  }

  return Component;
});

function getClassSet(props) {
  var _classes;

  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);

  if (props.bsSize) {
    var bsSize = __WEBPACK_IMPORTED_MODULE_4__StyleConfig__["a" /* SIZE_MAP */][props.bsSize] || props.bsSize;
    classes[prefix(props, bsSize)] = true;
  }

  if (props.bsStyle) {
    classes[prefix(props, props.bsStyle)] = true;
  }

  return classes;
}

function getBsProps(props) {
  return {
    bsClass: props.bsClass,
    bsSize: props.bsSize,
    bsStyle: props.bsStyle,
    bsRole: props.bsRole
  };
}

function isBsProp(propName) {
  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
}

function splitBsProps(props) {
  var elementProps = {};
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (!isBsProp(propName)) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}

function splitBsPropsAndOmit(props, omittedPropNames) {
  var isOmittedProp = {};
  omittedPropNames.forEach(function (propName) {
    isOmittedProp[propName] = true;
  });

  var elementProps = {};
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(props).forEach(function (_ref2) {
    var propName = _ref2[0],
        propValue = _ref2[1];

    if (!isBsProp(propName) && !isOmittedProp[propName]) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}

/**
 * Add a style variant to a Component. Mutates the propTypes of the component
 * in order to validate the new variant.
 */
function addStyle(Component) {
  for (var _len2 = arguments.length, styleVariant = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    styleVariant[_key2 - 1] = arguments[_key2];
  }

  bsStyles(styleVariant, Component);
}

var _curry = curry;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(37);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PRESENTATION_ATTRIBUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EVENT_ATTRIBUTES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SCALE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LEGEND_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TOOLTIP_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return findAllByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return findChildByType; });
/* unused harmony export withoutType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPresentationAttributes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return filterEventAttributes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return filterEventsOfChild; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return validateWidthHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isSsr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return filterSvgElements; });
/* unused harmony export isSingleChildEqual */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isChildrenEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return renderByOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getReactEventByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return parseChildIndex; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isObject__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isArray__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DataUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ShallowEqual__ = __webpack_require__(232);






function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }





var PRESENTATION_ATTRIBUTES = {
  'aria-current': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  // state
  'aria-details': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-disabled': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  // state
  'aria-hidden': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  // state
  'aria-invalid': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  // state
  'aria-keyshortcuts': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-label': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-roledescription': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  // Widget Attributes
  'aria-autocomplete': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-checked': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-expanded': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-haspopup': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-level': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-modal': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-multiline': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-multiselectable': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-orientation': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-placeholder': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-pressed': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-readonly': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-required': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-selected': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-sort': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-valuemax': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-valuemin': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-valuenow': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-valuetext': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  // Live Region Attributes
  'aria-atomic': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-busy': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-live': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-relevant': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  // Drag-and-Drop Attributes
  'aria-dropeffect': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-grabbed': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  // Relationship Attributes
  'aria-activedescendant': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-colcount': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-colindex': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-colspan': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-controls': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-describedby': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-errormessage': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-flowto': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-labelledby': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-owns': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-posinset': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-rowcount': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-rowindex': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-rowspan': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  'aria-setsize': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  alignmentBaseline: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  angle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  baselineShift: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  clip: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  clipPath: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  clipRule: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  color: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  colorInterpolation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  colorInterpolationFilters: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  colorProfile: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  colorRendering: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  cursor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  direction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['ltr', 'rtl', 'inherit']),
  display: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  dominantBaseline: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  enableBackground: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  fill: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  fillOpacity: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number]),
  fillRule: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['nonzero', 'evenodd', 'inherit']),
  filter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  floodColor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  floodOpacity: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number]),
  font: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  fontFamily: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  fontSize: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  fontSizeAdjust: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  fontStretch: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['normal', 'wider', 'narrower', 'ultra-condensed', 'extra-condensed', 'condensed', 'semi-condensed', 'semi-expanded', 'expanded', 'extra-expanded', 'ultra-expanded', 'inherit']),
  fontStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['normal', 'italic', 'oblique', 'inherit']),
  fontVariant: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['normal', 'small-caps', 'inherit']),
  fontWeight: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['normal', 'bold', 'bolder', 'lighter', 100, 200, 300, 400, 500, 600, 700, 800, 900, 'inherit']),
  glyphOrientationHorizontal: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  glyphOrientationVertical: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  imageRendering: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['auto', 'optimizeSpeed', 'optimizeQuality', 'inherit']),
  kerning: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  letterSpacing: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  lightingColor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  lineHeight: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  markerEnd: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  markerMid: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  markerStart: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  mask: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  opacity: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  overflow: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['visible', 'hidden', 'scroll', 'auto', 'inherit']),
  pointerEvents: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['visiblePainted', 'visibleFill', 'visibleStroke', 'visible', 'painted', 'fill', 'stroke', 'all', 'none', 'inherit']),
  shapeRendering: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['auto', 'optimizeSpeed', 'crispEdges', 'geometricPrecision', 'inherit']),
  stopColor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  stopOpacity: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  stroke: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  strokeDasharray: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  strokeDashoffset: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  strokeLinecap: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['butt', 'round', 'square', 'inherit']),
  strokeLinejoin: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['miter', 'round', 'bevel', 'inherit']),
  strokeMiterlimit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  strokeOpacity: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  strokeWidth: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  textAnchor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['start', 'middle', 'end', 'inherit']),
  textDecoration: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['none', 'underline', 'overline', 'line-through', 'blink', 'inherit']),
  textRendering: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['auto', 'optimizeSpeed', 'optimizeLegibility', 'geometricPrecision', 'inherit']),
  unicodeBidi: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['normal', 'embed', 'bidi-override', 'inherit']),
  visibility: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['visible', 'hidden', 'collapse', 'inherit']),
  wordSpacing: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  writingMode: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['lr-tb', 'rl-tb', 'tb-rl', 'lr', 'rl', 'tb', 'inherit']),
  transform: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  role: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  focusable: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  tabIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  width: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  dx: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  dy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  x: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  r: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  // The radius of Rectangle
  radius: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.array])
};
var EVENT_ATTRIBUTES = {
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseUp: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseOver: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseMove: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseOut: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onTouchEnd: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onTouchMove: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onTouchCancel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};
var REACT_BROWSER_EVENT_MAP = {
  click: 'onClick',
  mousedown: 'onMouseDown',
  mouseup: 'onMouseUp',
  mouseover: 'onMouseOver',
  mousemove: 'onMouseMove',
  mouseout: 'onMouseOut',
  mouseenter: 'onMouseEnter',
  mouseleave: 'onMouseLeave',
  touchcancel: 'onTouchCancel',
  touchend: 'onTouchEnd',
  touchmove: 'onTouchMove',
  touchstart: 'onTouchStart'
};
var SCALE_TYPES = ['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold'];
var LEGEND_TYPES = ['plainline', 'line', 'square', 'rect', 'circle', 'cross', 'diamond', 'star', 'triangle', 'wye', 'none'];
var TOOLTIP_TYPES = ['none'];
/**
 * Get the display name of a component
 * @param  {Object} Comp Specified Component
 * @return {String}      Display name of Component
 */

var getDisplayName = function getDisplayName(Comp) {
  if (typeof Comp === 'string') {
    return Comp;
  }

  if (!Comp) {
    return '';
  }

  return Comp.displayName || Comp.name || 'Component';
};
/*
 * Find and return all matched children by type. `type` can be a React element class or
 * string
 */

var findAllByType = function findAllByType(children, type) {
  var result = [];
  var types = [];

  if (__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(type)) {
    types = type.map(function (t) {
      return getDisplayName(t);
    });
  } else {
    types = [getDisplayName(type)];
  }

  __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.forEach(children, function (child) {
    var childType = child && child.type && (child.type.displayName || child.type.name);

    if (types.indexOf(childType) !== -1) {
      result.push(child);
    }
  });
  return result;
};
/*
 * Return the first matched child by type, return null otherwise.
 * `type` can be a React element class or string.
 */

var findChildByType = function findChildByType(children, type) {
  var result = findAllByType(children, type);
  return result && result[0];
};
/*
 * Create a new array of children excluding the ones matched the type
 */

var withoutType = function withoutType(children, type) {
  var newChildren = [];
  var types;

  if (__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(type)) {
    types = type.map(function (t) {
      return getDisplayName(t);
    });
  } else {
    types = [getDisplayName(type)];
  }

  __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.forEach(children, function (child) {
    if (child && child.type && child.type.displayName && types.indexOf(child.type.displayName) !== -1) {
      return;
    }

    newChildren.push(child);
  });
  return newChildren;
};
/**
 * get all the presentation attribute of svg element
 * @param  {Object} el A react element or the props of a react element
 * @return {Object}    attributes or null
 */

var getPresentationAttributes = function getPresentationAttributes(el) {
  if (!el || __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(el)) {
    return null;
  }

  var props = __WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(el) ? el.props : el;

  if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isObject___default()(props)) {
    return null;
  }

  var out = null; // eslint-disable-next-line no-restricted-syntax

  for (var i in props) {
    if ({}.hasOwnProperty.call(props, i) && PRESENTATION_ATTRIBUTES[i]) {
      if (!out) out = {};
      out[i] = props[i];
    }
  }

  return out;
};

var getEventHandlerOfElement = function getEventHandlerOfElement(originalHandler, props) {
  return function (e) {
    originalHandler(props, e);
    return null;
  };
};
/**
 * get all the event attribute of svg element
 * @param  {Object}   el           A react element or the props of a react element
 * @param  {Function} newHandler   New handler of event
 * @param  {Boolean}  wrapCallback Wrap callback and return more parameters or not
 * @return {Object}                attributes or null
 */


var filterEventAttributes = function filterEventAttributes(el, newHandler) {
  var wrapCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (!el || __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(el)) {
    return null;
  }

  var props = __WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(el) ? el.props : el;

  if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isObject___default()(props)) {
    return null;
  }

  var out = null; // eslint-disable-next-line no-restricted-syntax

  for (var i in props) {
    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i]) {
      if (!out) out = {};
      out[i] = newHandler || (wrapCallback ? getEventHandlerOfElement(props[i], props) : props[i]);
    }
  }

  return out;
};

var getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
  return function (e) {
    originalHandler(data, index, e);
    return null;
  };
};

var filterEventsOfChild = function filterEventsOfChild(props, data, index) {
  if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isObject___default()(props)) {
    return null;
  }

  var out = null; // eslint-disable-next-line no-restricted-syntax

  for (var i in props) {
    if ({}.hasOwnProperty.call(props, i) && EVENT_ATTRIBUTES[i] && __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(props[i])) {
      if (!out) out = {};
      out[i] = getEventHandlerOfChild(props[i], data, index);
    }
  }

  return out;
};
/**
 * validate the width and height props of a chart element
 * @param  {Object} el A chart element
 * @return {Boolean}   true If the props width and height are number, and greater than 0
 */

var validateWidthHeight = function validateWidthHeight(el) {
  if (!el || !el.props) {
    return false;
  }

  var _el$props = el.props,
      width = _el$props.width,
      height = _el$props.height;

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__DataUtils__["a" /* isNumber */])(width) || width <= 0 || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__DataUtils__["a" /* isNumber */])(height) || height <= 0) {
    return false;
  }

  return true;
};
var isSsr = function isSsr() {
  return !(typeof window !== 'undefined' && window.document && window.document.createElement && window.setTimeout);
};
var SVG_TAGS = ['a', 'altGlyph', 'altGlyphDef', 'altGlyphItem', 'animate', 'animateColor', 'animateMotion', 'animateTransform', 'circle', 'clipPath', 'color-profile', 'cursor', 'defs', 'desc', 'ellipse', 'feBlend', 'feColormatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feImage', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence', 'filter', 'font', 'font-face', 'font-face-format', 'font-face-name', 'font-face-url', 'foreignObject', 'g', 'glyph', 'glyphRef', 'hkern', 'image', 'line', 'lineGradient', 'marker', 'mask', 'metadata', 'missing-glyph', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'script', 'set', 'stop', 'style', 'svg', 'switch', 'symbol', 'text', 'textPath', 'title', 'tref', 'tspan', 'use', 'view', 'vkern'];

var isSvgElement = function isSvgElement(child) {
  return child && child.type && __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default()(child.type) && SVG_TAGS.indexOf(child.type) >= 0;
};
/**
 * Filter all the svg elements of children
 * @param  {Array} children The children of a react element
 * @return {Array}          All the svg elements
 */


var filterSvgElements = function filterSvgElements(children) {
  var svgElements = [];
  __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.forEach(children, function (entry) {
    if (entry && entry.type && __WEBPACK_IMPORTED_MODULE_1_lodash_isString___default()(entry.type) && SVG_TAGS.indexOf(entry.type) >= 0) {
      svgElements.push(entry);
    }
  });
  return svgElements;
};
var isSingleChildEqual = function isSingleChildEqual(nextChild, prevChild) {
  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(nextChild) && __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(prevChild)) {
    return true;
  }

  if (!__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(nextChild) && !__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(prevChild)) {
    var _ref = nextChild.props || {},
        nextChildren = _ref.children,
        nextProps = _objectWithoutProperties(_ref, ["children"]);

    var _ref2 = prevChild.props || {},
        prevChildren = _ref2.children,
        prevProps = _objectWithoutProperties(_ref2, ["children"]);

    if (nextChildren && prevChildren) {
      // eslint-disable-next-line no-use-before-define
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__ShallowEqual__["a" /* shallowEqual */])(nextProps, prevProps) && isChildrenEqual(nextChildren, prevChildren);
    }

    if (!nextChildren && !prevChildren) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__ShallowEqual__["a" /* shallowEqual */])(nextProps, prevProps);
    }

    return false;
  }

  return false;
};
/**
 * Wether props of children changed
 * @param  {Object} nextChildren The latest children
 * @param  {Object} prevChildren The prev children
 * @return {Boolean}             equal or not
 */

var isChildrenEqual = function isChildrenEqual(nextChildren, prevChildren) {
  if (nextChildren === prevChildren) {
    return true;
  }

  if (__WEBPACK_IMPORTED_MODULE_5_react__["Children"].count(nextChildren) !== __WEBPACK_IMPORTED_MODULE_5_react__["Children"].count(prevChildren)) {
    return false;
  }

  var count = __WEBPACK_IMPORTED_MODULE_5_react__["Children"].count(nextChildren);

  if (count === 0) {
    return true;
  }

  if (count === 1) {
    return isSingleChildEqual(__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(nextChildren) ? nextChildren[0] : nextChildren, __WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(prevChildren) ? prevChildren[0] : prevChildren);
  }

  for (var _i = 0; _i < count; _i++) {
    var nextChild = nextChildren[_i];
    var prevChild = prevChildren[_i];

    if (__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(nextChild) || __WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(prevChild)) {
      if (!isChildrenEqual(nextChild, prevChild)) {
        return false;
      }
    } else if (!isSingleChildEqual(nextChild, prevChild)) {
      return false;
    }
  }

  return true;
};
var renderByOrder = function renderByOrder(children, renderMap) {
  var elements = [];
  var record = {};
  __WEBPACK_IMPORTED_MODULE_5_react__["Children"].forEach(children, function (child, index) {
    if (child && isSvgElement(child)) {
      elements.push(child);
    } else if (child && renderMap[getDisplayName(child.type)]) {
      var displayName = getDisplayName(child.type);
      var _renderMap$displayNam = renderMap[displayName],
          handler = _renderMap$displayNam.handler,
          once = _renderMap$displayNam.once;

      if (once && !record[displayName] || !once) {
        var results = handler(child, displayName, index);

        if (__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(results)) {
          elements = [elements].concat(_toConsumableArray(results));
        } else {
          elements.push(results);
        }

        record[displayName] = true;
      }
    }
  });
  return elements;
};
var getReactEventByType = function getReactEventByType(e) {
  var type = e && e.type;

  if (type && REACT_BROWSER_EVENT_MAP[type]) {
    return REACT_BROWSER_EVENT_MAP[type];
  }

  return null;
};
var parseChildIndex = function parseChildIndex(child, children) {
  var result = -1;
  __WEBPACK_IMPORTED_MODULE_5_react__["Children"].forEach(children, function (entry, index) {
    if (entry === child) {
      result = index;
    }
  });
  return result;
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.29.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key;
                for (i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i;
            for (i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (
                    matched,
                    p1,
                    p2,
                    p3,
                    p4
                ) {
                    return p1 || p2 || p3 || p4;
                })
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split(
            '_'
        ),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^)]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (
        input,
        array,
        config,
        token
    ) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) {
            getParsingFlags(config).era = era;
        } else {
            getParsingFlags(config).invalidEra = input;
        }
    });

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (
        input,
        week,
        config,
        token
    ) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module)))

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule reactProdInvariant
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return mathSign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isPercent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isNumOrStr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return uniqueId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getPercentValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getAnyElementOfObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return hasDuplicate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return interpolateNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return findEntryInArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getLinearRegression; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isArray__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNaN__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNaN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNaN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNumber__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isString__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isString__);





var mathSign = function mathSign(value) {
  if (value === 0) {
    return 0;
  }

  if (value > 0) {
    return 1;
  }

  return -1;
};
var isPercent = function isPercent(value) {
  return __WEBPACK_IMPORTED_MODULE_4_lodash_isString___default()(value) && value.indexOf('%') === value.length - 1;
};
var isNumber = function isNumber(value) {
  return __WEBPACK_IMPORTED_MODULE_3_lodash_isNumber___default()(value) && !__WEBPACK_IMPORTED_MODULE_2_lodash_isNaN___default()(value);
};
var isNumOrStr = function isNumOrStr(value) {
  return isNumber(value) || __WEBPACK_IMPORTED_MODULE_4_lodash_isString___default()(value);
};
var idCounter = 0;
var uniqueId = function uniqueId(prefix) {
  var id = ++idCounter;
  return "".concat(prefix || '').concat(id);
};
/**
 * Get percent value of a total value
 * @param {Number|String} percent A percent
 * @param {Number} totalValue     Total value
 * @param {NUmber} defaultValue   The value returned when percent is undefined or invalid
 * @param {Boolean} validate      If set to be true, the result will be validated
 * @return {Number} value
 */

var getPercentValue = function getPercentValue(percent, totalValue) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (!isNumber(percent) && !__WEBPACK_IMPORTED_MODULE_4_lodash_isString___default()(percent)) {
    return defaultValue;
  }

  var value;

  if (isPercent(percent)) {
    var index = percent.indexOf('%');
    value = totalValue * parseFloat(percent.slice(0, index)) / 100;
  } else {
    value = +percent;
  }

  if (__WEBPACK_IMPORTED_MODULE_2_lodash_isNaN___default()(value)) {
    value = defaultValue;
  }

  if (validate && value > totalValue) {
    value = totalValue;
  }

  return value;
};
var getAnyElementOfObject = function getAnyElementOfObject(obj) {
  if (!obj) {
    return null;
  }

  var keys = Object.keys(obj);

  if (keys && keys.length) {
    return obj[keys[0]];
  }

  return null;
};
var hasDuplicate = function hasDuplicate(ary) {
  if (!__WEBPACK_IMPORTED_MODULE_1_lodash_isArray___default()(ary)) {
    return false;
  }

  var len = ary.length;
  var cache = {};

  for (var i = 0; i < len; i++) {
    if (!cache[ary[i]]) {
      cache[ary[i]] = true;
    } else {
      return true;
    }
  }

  return false;
};
var interpolateNumber = function interpolateNumber(numberA, numberB) {
  if (isNumber(numberA) && isNumber(numberB)) {
    return function (t) {
      return numberA + t * (numberB - numberA);
    };
  }

  return function () {
    return numberB;
  };
};
var findEntryInArray = function findEntryInArray(ary, specifiedKey, specifiedValue) {
  if (!ary || !ary.length) {
    return null;
  }

  return ary.find(function (entry) {
    return entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(entry, specifiedKey)) === specifiedValue;
  });
};
/**
 * The least square linear regression
 * @param {Array} data The array of points
 * @returns {Object} The domain of x, and the parameter of linear function
 */

var getLinearRegression = function getLinearRegression(data) {
  if (!data || !data.length) {
    return null;
  }

  var len = data.length;
  var xsum = 0;
  var ysum = 0;
  var xysum = 0;
  var xxsum = 0;
  var xmin = Infinity;
  var xmax = -Infinity;

  for (var i = 0; i < len; i++) {
    xsum += data[i].cx;
    ysum += data[i].cy;
    xysum += data[i].cx * data[i].cy;
    xxsum += data[i].cx * data[i].cx;
    xmin = Math.min(xmin, data[i].cx);
    xmax = Math.max(xmax, data[i].cx);
  }

  var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
  return {
    xmin: xmin,
    xmax: xmax,
    a: a,
    b: (ysum - a * xsum) / len
  };
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(76);
var core = __webpack_require__(177);
var hide = __webpack_require__(650);
var redefine = __webpack_require__(657);
var ctx = __webpack_require__(648);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(93),
    isObject = __webpack_require__(48);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIs = __webpack_require__(1474);

var _createChainableTypeChecker = __webpack_require__(211);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`,expected an element type (a string ') + ', component class, or function component).');
  }

  if (!(0, _reactIs.isValidElementType)(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + ', component class, or function component).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);
module.exports = exports['default'];

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(24)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ptBr = moment.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
            '_'
        ),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        invalidDate: 'Data inválida',
    });

    return ptBr;

})));


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1421);


/***/ }),
/* 34 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CONST_VAR = {
  SORT_DESC: 'desc',
  SORT_ASC: 'asc',
  AWAIT_BEFORE_CELL_EDIT: 1,
  SIZE_PER_PAGE: 10,
  NEXT_PAGE: '>',
  NEXT_PAGE_TITLE: 'next page',
  LAST_PAGE: '>>',
  LAST_PAGE_TITLE: 'last page',
  PRE_PAGE: '<',
  PRE_PAGE_TITLE: 'previous page',
  FIRST_PAGE: '<<',
  FIRST_PAGE_TITLE: 'first page',
  PAGE_START_INDEX: 1,
  ROW_SELECT_BG_COLOR: '',
  ROW_SELECT_NONE: 'none',
  ROW_SELECT_SINGLE: 'radio',
  ROW_SELECT_MULTI: 'checkbox',
  CELL_EDIT_NONE: 'none',
  CELL_EDIT_CLICK: 'click',
  CELL_EDIT_DBCLICK: 'dbclick',
  SIZE_PER_PAGE_LIST: [10, 25, 30, 50],
  PAGINATION_SIZE: 5,
  PAGINATION_POS_TOP: 'top',
  PAGINATION_POS_BOTTOM: 'bottom',
  PAGINATION_POS_BOTH: 'both',
  NO_DATA_TEXT: 'There is no data to display',
  SHOW_ONLY_SELECT: 'Show Selected Only',
  SHOW_ALL: 'Show All',
  EXPORT_CSV_TEXT: 'Export to CSV',
  INSERT_BTN_TEXT: 'New',
  DELETE_BTN_TEXT: 'Delete',
  SAVE_BTN_TEXT: 'Save',
  CLOSE_BTN_TEXT: 'Close',
  FILTER_DELAY: 500,
  SCROLL_TOP: 'Top',
  SCROLL_BOTTOM: 'Bottom',
  FILTER_TYPE: {
    TEXT: 'TextFilter',
    REGEX: 'RegexFilter',
    SELECT: 'SelectFilter',
    NUMBER: 'NumberFilter',
    DATE: 'DateFilter',
    CUSTOM: 'CustomFilter'
  },
  FILTER_COND_EQ: 'eq',
  FILTER_COND_LIKE: 'like',
  EXPAND_BY_ROW: 'row',
  EXPAND_BY_COL: 'column',
  CANCEL_TOASTR: 'Pressed ESC can cancel',
  REMOTE_SORT: 'sort',
  REMOTE_PAGE: 'pagination',
  REMOTE_CELL_EDIT: 'cellEdit',
  REMOTE_INSERT_ROW: 'insertRow',
  REMOTE_DROP_ROW: 'dropRow',
  REMOTE_FILTER: 'filter',
  REMOTE_SEARCH: 'search',
  REMOTE_EXPORT_CSV: 'exportCSV',
  DEFAULT_CSV_SEPARATOR: ','
};

CONST_VAR.REMOTE = {};
CONST_VAR.REMOTE[CONST_VAR.REMOTE_SORT] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_PAGE] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_CELL_EDIT] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_INSERT_ROW] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_DROP_ROW] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_FILTER] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_SEARCH] = false;
CONST_VAR.REMOTE[CONST_VAR.REMOTE_EXPORT_CSV] = false;

var _default = CONST_VAR;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(CONST_VAR, 'CONST_VAR', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Const.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Const.js');
}();

;

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @fileOverview Layer
 */



var propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node])
};

function Layer(props) {
  var children = props.children,
      className = props.className,
      others = _objectWithoutProperties(props, ["children", "className"]);

  var layerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-layer', className);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", _extends({
    className: layerClass
  }, others), children);
}

Layer.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Layer);

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(26);

var DOMProperty = __webpack_require__(126);
var ReactDOMComponentFlags = __webpack_require__(594);

var invariant = __webpack_require__(17);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMComponentTree
 */



var _prodInvariant = __webpack_require__(25);

var DOMProperty = __webpack_require__(109);
var ReactDOMComponentFlags = __webpack_require__(396);

var invariant = __webpack_require__(17);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (childNode.nodeType === 1 && childNode.getAttribute(ATTR_NAME) === String(childID) || childNode.nodeType === 8 && childNode.nodeValue === ' react-text: ' + childID + ' ' || childNode.nodeType === 8 && childNode.nodeValue === ' react-empty: ' + childID + ' ') {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 40 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (f) {
    return f != null;
  }).reduce(function (acc, f) {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) {
      return f;
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      f.apply(this, args);
    };
  }, null);
}

/* harmony default export */ __webpack_exports__["a"] = (createChainedFunction);

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Size; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SIZE_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DEVICE_SIZES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return State; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Style; });
var Size = {
  LARGE: 'large',
  SMALL: 'small',
  XSMALL: 'xsmall'
};

var SIZE_MAP = {
  large: 'lg',
  medium: 'md',
  small: 'sm',
  xsmall: 'xs',
  lg: 'lg',
  md: 'md',
  sm: 'sm',
  xs: 'xs'
};

var DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];

var State = {
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info'
};

var Style = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  LINK: 'link',
  INVERSE: 'inverse'
};

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newInterval;
var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
  }

  interval.floor = function(date) {
    return floori(date = new Date(+date)), date;
  };

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getValueByDataKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getDomainOfDataByKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return calculateActiveTickIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getMainColorOfGraphicItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getLegendProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getBarSizeList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getBarPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return appendOffsetOfLegend; });
/* unused harmony export getDomainOfErrorBars */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return parseErrorBarsOfAxis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getDomainOfItemsWithSameAxis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isCategorialAxis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCoordinatesOfGrid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getTicksOfAxis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return combineEventHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return parseScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return checkDomainOfScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return findPositionOfBar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return truncateByDomain; });
/* unused harmony export offsetSign */
/* unused harmony export getStackedData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getStackGroupsByAxisId; });
/* unused harmony export calculateDomainOfTicks */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getTicksOfScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getCateCoordinateOfLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return getCateCoordinateOfBar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return getBaseValueOfBar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getStackedDataOfItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getDomainOfStackGroups; });
/* unused harmony export MIN_VALUE_REG */
/* unused harmony export MAX_VALUE_REG */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return parseSpecifiedDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getBandSizeOfAxis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return parseDomainOfCategoryAxis; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sortBy__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNaN__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNaN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNaN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isString__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isArray__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_max__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_max___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_max__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_min__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_flatMap__ = __webpack_require__(1735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_flatMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_flatMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isFunction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isNil__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_recharts_scale__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_d3_scale__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_d3_shape__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DataUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__cartesian_ErrorBar__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__component_Legend__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ReactUtils__ = __webpack_require__(23);












function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var getValueByDataKey = function getValueByDataKey(obj, dataKey, defaultValue) {
  if (__WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(obj) || __WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(dataKey)) {
    return defaultValue;
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["c" /* isNumOrStr */])(dataKey)) {
    return __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(obj, dataKey, defaultValue);
  }

  if (__WEBPACK_IMPORTED_MODULE_8_lodash_isFunction___default()(dataKey)) {
    return dataKey(obj);
  }

  return defaultValue;
};
/**
 * Get domain of data by key
 * @param  {Array}   data      The data displayed in the chart
 * @param  {String}  key       The unique key of a group of data
 * @param  {String}  type      The type of axis
 * @param  {Boolean} filterNil Whether or not filter nil values
 * @return {Array} Domain of data
 */

var getDomainOfDataByKey = function getDomainOfDataByKey(data, key, type, filterNil) {
  var flattenData = __WEBPACK_IMPORTED_MODULE_7_lodash_flatMap___default()(data, function (entry) {
    return getValueByDataKey(entry, key);
  });

  if (type === 'number') {
    var domain = flattenData.filter(function (entry) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["a" /* isNumber */])(entry) || parseFloat(entry, 10);
    });
    return domain.length ? [__WEBPACK_IMPORTED_MODULE_6_lodash_min___default()(domain), __WEBPACK_IMPORTED_MODULE_5_lodash_max___default()(domain)] : [Infinity, -Infinity];
  }

  var validateData = filterNil ? flattenData.filter(function (entry) {
    return !__WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(entry);
  }) : flattenData;
  return validateData.map(function (entry) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["c" /* isNumOrStr */])(entry) ? entry : '';
  });
};
var calculateActiveTickIndex = function calculateActiveTickIndex(coordinate, ticks, unsortedTicks, axis) {
  var index = -1;
  var len = ticks.length;

  if (len > 1) {
    if (axis && axis.axisType === 'angleAxis' && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
      var range = axis.range; // ticks are distributed in a circle

      for (var i = 0; i < len; i++) {
        var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
        var cur = unsortedTicks[i].coordinate;
        var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
        var sameDirectionCoord = void 0;

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["d" /* mathSign */])(cur - before) !== __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["d" /* mathSign */])(after - cur)) {
          var diffInterval = [];

          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["d" /* mathSign */])(after - cur) === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["d" /* mathSign */])(range[1] - range[0])) {
            sameDirectionCoord = after;
            var curInRange = cur + range[1] - range[0];
            diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
            diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
          } else {
            sameDirectionCoord = before;
            var afterInRange = after + range[1] - range[0];
            diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
            diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
          }

          var sameInterval = [Math.min(cur, (sameDirectionCoord + cur) / 2), Math.max(cur, (sameDirectionCoord + cur) / 2)];

          if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
            index = unsortedTicks[i].index;
            break;
          }
        } else {
          var min = Math.min(before, after);
          var max = Math.max(before, after);

          if (coordinate > (min + cur) / 2 && coordinate <= (max + cur) / 2) {
            index = unsortedTicks[i].index;
            break;
          }
        }
      }
    } else {
      // ticks are distributed in a single direction
      for (var _i = 0; _i < len; _i++) {
        if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
          index = ticks[_i].index;
          break;
        }
      }
    }
  } else {
    index = 0;
  }

  return index;
};
/**
 * Get the main color of each graphic item
 * @param  {ReactElement} item A graphic item
 * @return {String}            Color
 */

var getMainColorOfGraphicItem = function getMainColorOfGraphicItem(item) {
  var displayName = item.type.displayName;
  var _item$props = item.props,
      stroke = _item$props.stroke,
      fill = _item$props.fill;
  var result;

  switch (displayName) {
    case 'Line':
      result = stroke;
      break;

    case 'Area':
    case 'Radar':
      result = stroke && stroke !== 'none' ? stroke : fill;
      break;

    default:
      result = fill;
      break;
  }

  return result;
};
var getLegendProps = function getLegendProps(_ref) {
  var children = _ref.children,
      formatedGraphicalItems = _ref.formatedGraphicalItems,
      legendWidth = _ref.legendWidth,
      legendContent = _ref.legendContent;
  var legendItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__ReactUtils__["j" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_16__component_Legend__["a" /* default */]);

  if (!legendItem) {
    return null;
  }

  var legendData;

  if (legendItem.props && legendItem.props.payload) {
    legendData = legendItem.props && legendItem.props.payload;
  } else if (legendContent === 'children') {
    legendData = (formatedGraphicalItems || []).reduce(function (result, _ref2) {
      var item = _ref2.item,
          props = _ref2.props;
      var data = props.sectors || props.data || [];
      return result.concat(data.map(function (entry) {
        return {
          type: legendItem.props.iconType || item.props.legendType,
          value: entry.name,
          color: entry.fill,
          payload: entry
        };
      }));
    }, []);
  } else {
    legendData = (formatedGraphicalItems || []).map(function (_ref3) {
      var item = _ref3.item;
      var _item$props2 = item.props,
          dataKey = _item$props2.dataKey,
          name = _item$props2.name,
          legendType = _item$props2.legendType,
          hide = _item$props2.hide;
      return {
        inactive: hide,
        dataKey: dataKey,
        type: legendItem.props.iconType || legendType || 'square',
        color: getMainColorOfGraphicItem(item),
        value: name || dataKey,
        payload: item.props
      };
    });
  }

  return _objectSpread({}, legendItem.props, {}, __WEBPACK_IMPORTED_MODULE_16__component_Legend__["a" /* default */].getWithHeight(legendItem, legendWidth), {
    payload: legendData,
    item: legendItem
  });
};
/**
 * Calculate the size of all groups for stacked bar graph
 * @param  {Object} stackGroups The items grouped by axisId and stackId
 * @return {Object} The size of all groups
 */

var getBarSizeList = function getBarSizeList(_ref4) {
  var globalSize = _ref4.barSize,
      _ref4$stackGroups = _ref4.stackGroups,
      stackGroups = _ref4$stackGroups === void 0 ? {} : _ref4$stackGroups;

  if (!stackGroups) {
    return {};
  }

  var result = {};
  var numericAxisIds = Object.keys(stackGroups);

  for (var i = 0, len = numericAxisIds.length; i < len; i++) {
    var sgs = stackGroups[numericAxisIds[i]].stackGroups;
    var stackIds = Object.keys(sgs);

    for (var j = 0, sLen = stackIds.length; j < sLen; j++) {
      var _sgs$stackIds$j = sgs[stackIds[j]],
          items = _sgs$stackIds$j.items,
          cateAxisId = _sgs$stackIds$j.cateAxisId;
      var barItems = items.filter(function (item) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__ReactUtils__["k" /* getDisplayName */])(item.type).indexOf('Bar') >= 0;
      });

      if (barItems && barItems.length) {
        var selfSize = barItems[0].props.barSize;
        var cateId = barItems[0].props[cateAxisId];

        if (!result[cateId]) {
          result[cateId] = [];
        }

        result[cateId].push({
          item: barItems[0],
          stackList: barItems.slice(1),
          barSize: __WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(selfSize) ? globalSize : selfSize
        });
      }
    }
  }

  return result;
};
/**
   * Calculate the size of each bar and the gap between two bars
   * @param  {Number} bandSize  The size of each category
   * @param  {sizeList} sizeList  The size of all groups
   * @param  {maxBarSize} maxBarSize The maximum size of bar
   * @return {Number} The size of each bar and the gap between two bars
   */

var getBarPosition = function getBarPosition(_ref5) {
  var barGap = _ref5.barGap,
      barCategoryGap = _ref5.barCategoryGap,
      bandSize = _ref5.bandSize,
      _ref5$sizeList = _ref5.sizeList,
      sizeList = _ref5$sizeList === void 0 ? [] : _ref5$sizeList,
      maxBarSize = _ref5.maxBarSize;
  var len = sizeList.length;
  if (len < 1) return null;
  var realBarGap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["e" /* getPercentValue */])(barGap, bandSize, 0, true);
  var result; // whether or not is barSize setted by user

  if (sizeList[0].barSize === +sizeList[0].barSize) {
    var useFull = false;
    var fullBarSize = bandSize / len;
    var sum = sizeList.reduce(function (res, entry) {
      return res + entry.barSize || 0;
    }, 0);
    sum += (len - 1) * realBarGap;

    if (sum >= bandSize) {
      sum -= (len - 1) * realBarGap;
      realBarGap = 0;
    }

    if (sum >= bandSize && fullBarSize > 0) {
      useFull = true;
      fullBarSize *= 0.9;
      sum = len * fullBarSize;
    }

    var offset = (bandSize - sum) / 2 >> 0;
    var prev = {
      offset: offset - realBarGap,
      size: 0
    };
    result = sizeList.reduce(function (res, entry) {
      var newRes = [].concat(_toConsumableArray(res), [{
        item: entry.item,
        position: {
          offset: prev.offset + prev.size + realBarGap,
          size: useFull ? fullBarSize : entry.barSize
        }
      }]);
      prev = newRes[newRes.length - 1].position;

      if (entry.stackList && entry.stackList.length) {
        entry.stackList.forEach(function (item) {
          newRes.push({
            item: item,
            position: prev
          });
        });
      }

      return newRes;
    }, []);
  } else {
    var _offset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["e" /* getPercentValue */])(barCategoryGap, bandSize, 0, true);

    if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) {
      realBarGap = 0;
    }

    var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;

    if (originalSize > 1) {
      originalSize >>= 0;
    }

    var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
    result = sizeList.reduce(function (res, entry, i) {
      var newRes = [].concat(_toConsumableArray(res), [{
        item: entry.item,
        position: {
          offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
          size: size
        }
      }]);

      if (entry.stackList && entry.stackList.length) {
        entry.stackList.forEach(function (item) {
          newRes.push({
            item: item,
            position: newRes[newRes.length - 1].position
          });
        });
      }

      return newRes;
    }, []);
  }

  return result;
};
var appendOffsetOfLegend = function appendOffsetOfLegend(offset, items, props, legendBox) {
  var children = props.children,
      width = props.width,
      height = props.height,
      margin = props.margin;
  var legendWidth = width - (margin.left || 0) - (margin.right || 0);
  var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
  var legendProps = getLegendProps({
    children: children,
    items: items,
    legendWidth: legendWidth,
    legendHeight: legendHeight
  });
  var newOffset = offset;

  if (legendProps) {
    var box = legendBox || {};
    var align = legendProps.align,
        verticalAlign = legendProps.verticalAlign,
        layout = legendProps.layout;

    if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'center') && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["a" /* isNumber */])(offset[align])) {
      newOffset = _objectSpread({}, offset, _defineProperty({}, align, newOffset[align] + (box.width || 0)));
    }

    if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["a" /* isNumber */])(offset[verticalAlign])) {
      newOffset = _objectSpread({}, offset, _defineProperty({}, verticalAlign, newOffset[verticalAlign] + (box.height || 0)));
    }
  }

  return newOffset;
};
var getDomainOfErrorBars = function getDomainOfErrorBars(data, item, dataKey, axisType) {
  var children = item.props.children;
  var errorBars = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__ReactUtils__["i" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_15__cartesian_ErrorBar__["a" /* default */]).filter(function (errorBarChild) {
    var direction = errorBarChild.props.direction;
    return __WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(direction) || __WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(axisType) ? true : axisType.indexOf(direction) >= 0;
  });

  if (errorBars && errorBars.length) {
    var keys = errorBars.map(function (errorBarChild) {
      return errorBarChild.props.dataKey;
    });
    return data.reduce(function (result, entry) {
      var entryValue = getValueByDataKey(entry, dataKey, 0);
      var mainValue = __WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(entryValue) ? [__WEBPACK_IMPORTED_MODULE_6_lodash_min___default()(entryValue), __WEBPACK_IMPORTED_MODULE_5_lodash_max___default()(entryValue)] : [entryValue, entryValue];
      var errorDomain = keys.reduce(function (prevErrorArr, k) {
        var errorValue = getValueByDataKey(entry, k, 0);
        var lowerValue = mainValue[0] - Math.abs(__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(errorValue) ? errorValue[0] : errorValue);
        var upperValue = mainValue[1] + Math.abs(__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(errorValue) ? errorValue[1] : errorValue);
        return [Math.min(lowerValue, prevErrorArr[0]), Math.max(upperValue, prevErrorArr[1])];
      }, [Infinity, -Infinity]);
      return [Math.min(errorDomain[0], result[0]), Math.max(errorDomain[1], result[1])];
    }, [Infinity, -Infinity]);
  }

  return null;
};
var parseErrorBarsOfAxis = function parseErrorBarsOfAxis(data, items, dataKey, axisType) {
  var domains = items.map(function (item) {
    return getDomainOfErrorBars(data, item, dataKey, axisType);
  }).filter(function (entry) {
    return !__WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(entry);
  });

  if (domains && domains.length) {
    return domains.reduce(function (result, entry) {
      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
    }, [Infinity, -Infinity]);
  }

  return null;
};
/**
 * Get domain of data by the configuration of item element
 * @param  {Array}   data      The data displayed in the chart
 * @param  {Array}   items     The instances of item
 * @param  {String}  type      The type of axis, number - Number Axis, category - Category Axis
 * @param  {Boolean} filterNil Whether or not filter nil values
 * @return {Array}        Domain
 */

var getDomainOfItemsWithSameAxis = function getDomainOfItemsWithSameAxis(data, items, type, filterNil) {
  var domains = items.map(function (item) {
    var dataKey = item.props.dataKey;

    if (type === 'number' && dataKey) {
      return getDomainOfErrorBars(data, item, dataKey) || getDomainOfDataByKey(data, dataKey, type, filterNil);
    }

    return getDomainOfDataByKey(data, dataKey, type, filterNil);
  });

  if (type === 'number') {
    // Calculate the domain of number axis
    return domains.reduce(function (result, entry) {
      return [Math.min(result[0], entry[0]), Math.max(result[1], entry[1])];
    }, [Infinity, -Infinity]);
  }

  var tag = {}; // Get the union set of category axis

  return domains.reduce(function (result, entry) {
    for (var i = 0, len = entry.length; i < len; i++) {
      if (!tag[entry[i]]) {
        tag[entry[i]] = true;
        result.push(entry[i]);
      }
    }

    return result;
  }, []);
};
var isCategorialAxis = function isCategorialAxis(layout, axisType) {
  return layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
};
/**
 * Calculate the Coordinates of grid
 * @param  {Array} ticks The ticks in axis
 * @param {Number} min   The minimun value of axis
 * @param {Number} max   The maximun value of axis
 * @return {Array}       Coordinates
 */

var getCoordinatesOfGrid = function getCoordinatesOfGrid(ticks, min, max) {
  var hasMin, hasMax;
  var values = ticks.map(function (entry) {
    if (entry.coordinate === min) {
      hasMin = true;
    }

    if (entry.coordinate === max) {
      hasMax = true;
    }

    return entry.coordinate;
  });

  if (!hasMin) {
    values.push(min);
  }

  if (!hasMax) {
    values.push(max);
  }

  return values;
};
/**
 * Get the ticks of an axis
 * @param  {Object}  axis The configuration of an axis
 * @param {Boolean} isGrid Whether or not are the ticks in grid
 * @param {Boolean} isAll Return the ticks of all the points or not
 * @return {Array}  Ticks
 */

var getTicksOfAxis = function getTicksOfAxis(axis, isGrid, isAll) {
  if (!axis) return null;
  var scale = axis.scale;
  var duplicateDomain = axis.duplicateDomain,
      type = axis.type,
      range = axis.range;
  var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / 2 : 0;
  offset = axis.axisType === 'angleAxis' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["d" /* mathSign */])(range[0] - range[1]) * 2 * offset : offset; // The ticks setted by user should only affect the ticks adjacent to axis line

  if (isGrid && (axis.ticks || axis.niceTicks)) {
    return (axis.ticks || axis.niceTicks).map(function (entry) {
      var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
      return {
        coordinate: scale(scaleContent) + offset,
        value: entry,
        offset: offset
      };
    });
  }

  if (axis.isCategorial && axis.categoricalDomain) {
    return axis.categoricalDomain.map(function (entry, index) {
      return {
        coordinate: scale(entry),
        value: entry,
        index: index,
        offset: offset
      };
    });
  }

  if (scale.ticks && !isAll) {
    return scale.ticks(axis.tickCount).map(function (entry) {
      return {
        coordinate: scale(entry) + offset,
        value: entry,
        offset: offset
      };
    });
  } // When axis has duplicated text, serial numbers are used to generate scale


  return scale.domain().map(function (entry, index) {
    return {
      coordinate: scale(entry) + offset,
      value: duplicateDomain ? duplicateDomain[entry] : entry,
      index: index,
      offset: offset
    };
  });
};
/**
 * combine the handlers
 * @param  {Function} defaultHandler Internal private handler
 * @param  {Function} parentHandler  Handler function specified in parent component
 * @param  {Function} childHandler   Handler function specified in child component
 * @return {Function}                The combined handler
 */

var combineEventHandlers = function combineEventHandlers(defaultHandler, parentHandler, childHandler) {
  var customizedHandler;

  if (__WEBPACK_IMPORTED_MODULE_8_lodash_isFunction___default()(childHandler)) {
    customizedHandler = childHandler;
  } else if (__WEBPACK_IMPORTED_MODULE_8_lodash_isFunction___default()(parentHandler)) {
    customizedHandler = parentHandler;
  }

  if (__WEBPACK_IMPORTED_MODULE_8_lodash_isFunction___default()(defaultHandler) || customizedHandler) {
    return function (arg1, arg2, arg3, arg4) {
      if (__WEBPACK_IMPORTED_MODULE_8_lodash_isFunction___default()(defaultHandler)) {
        defaultHandler(arg1, arg2, arg3, arg4);
      }

      if (__WEBPACK_IMPORTED_MODULE_8_lodash_isFunction___default()(customizedHandler)) {
        customizedHandler(arg1, arg2, arg3, arg4);
      }
    };
  }

  return null;
};
/**
 * Parse the scale function of axis
 * @param  {Object}   axis          The option of axis
 * @param  {String}   chartType     The displayName of chart
 * @return {Function}               The scale funcion
 */

var parseScale = function parseScale(axis, chartType) {
  var scale = axis.scale,
      type = axis.type,
      layout = axis.layout,
      axisType = axis.axisType;

  if (scale === 'auto') {
    if (layout === 'radial' && axisType === 'radiusAxis') {
      return {
        scale: __WEBPACK_IMPORTED_MODULE_12_d3_scale__["scaleBand"](),
        realScaleType: 'band'
      };
    }

    if (layout === 'radial' && axisType === 'angleAxis') {
      return {
        scale: __WEBPACK_IMPORTED_MODULE_12_d3_scale__["scaleLinear"](),
        realScaleType: 'linear'
      };
    }

    if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0)) {
      return {
        scale: __WEBPACK_IMPORTED_MODULE_12_d3_scale__["scalePoint"](),
        realScaleType: 'point'
      };
    }

    if (type === 'category') {
      return {
        scale: __WEBPACK_IMPORTED_MODULE_12_d3_scale__["scaleBand"](),
        realScaleType: 'band'
      };
    }

    return {
      scale: __WEBPACK_IMPORTED_MODULE_12_d3_scale__["scaleLinear"](),
      realScaleType: 'linear'
    };
  }

  if (__WEBPACK_IMPORTED_MODULE_3_lodash_isString___default()(scale)) {
    var name = "scale".concat(scale.slice(0, 1).toUpperCase()).concat(scale.slice(1));
    return {
      scale: (__WEBPACK_IMPORTED_MODULE_12_d3_scale__[name] || __WEBPACK_IMPORTED_MODULE_12_d3_scale__["scalePoint"])(),
      realScaleType: __WEBPACK_IMPORTED_MODULE_12_d3_scale__[name] ? name : 'point'
    };
  }

  return __WEBPACK_IMPORTED_MODULE_8_lodash_isFunction___default()(scale) ? {
    scale: scale
  } : {
    scale: __WEBPACK_IMPORTED_MODULE_12_d3_scale__["scalePoint"](),
    realScaleType: 'point'
  };
};
var EPS = 1e-4;
var checkDomainOfScale = function checkDomainOfScale(scale) {
  var domain = scale.domain();

  if (!domain || domain.length <= 2) {
    return;
  }

  var len = domain.length;
  var range = scale.range();
  var min = Math.min(range[0], range[1]) - EPS;
  var max = Math.max(range[0], range[1]) + EPS;
  var first = scale(domain[0]);
  var last = scale(domain[len - 1]);

  if (first < min || first > max || last < min || last > max) {
    scale.domain([domain[0], domain[len - 1]]);
  }
};
var findPositionOfBar = function findPositionOfBar(barPosition, child) {
  if (!barPosition) {
    return null;
  }

  for (var i = 0, len = barPosition.length; i < len; i++) {
    if (barPosition[i].item === child) {
      return barPosition[i].position;
    }
  }

  return null;
};
var truncateByDomain = function truncateByDomain(value, domain) {
  if (!domain || domain.length !== 2 || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["a" /* isNumber */])(domain[0]) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["a" /* isNumber */])(domain[1])) {
    return value;
  }

  var min = Math.min(domain[0], domain[1]);
  var max = Math.max(domain[0], domain[1]);
  var result = [value[0], value[1]];

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["a" /* isNumber */])(value[0]) || value[0] < min) {
    result[0] = min;
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["a" /* isNumber */])(value[1]) || value[1] > max) {
    result[1] = max;
  }

  if (result[0] > max) {
    result[0] = max;
  }

  if (result[1] < min) {
    result[1] = min;
  }

  return result;
};
/* eslint no-param-reassign: 0 */

var offsetSign = function offsetSign(series) {
  var n = series.length;

  if (n <= 0) {
    return;
  }

  for (var j = 0, m = series[0].length; j < m; ++j) {
    var positive = 0;
    var negative = 0;

    for (var i = 0; i < n; ++i) {
      var value = __WEBPACK_IMPORTED_MODULE_2_lodash_isNaN___default()(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
      /* eslint-disable prefer-destructuring */

      if (value >= 0) {
        series[i][j][0] = positive;
        series[i][j][1] = positive + value;
        positive = series[i][j][1];
      } else {
        series[i][j][0] = negative;
        series[i][j][1] = negative + value;
        negative = series[i][j][1];
      }
      /* eslint-enable prefer-destructuring */

    }
  }
};
var STACK_OFFSET_MAP = {
  sign: offsetSign,
  expand: __WEBPACK_IMPORTED_MODULE_13_d3_shape__["a" /* stackOffsetExpand */],
  none: __WEBPACK_IMPORTED_MODULE_13_d3_shape__["b" /* stackOffsetNone */],
  silhouette: __WEBPACK_IMPORTED_MODULE_13_d3_shape__["c" /* stackOffsetSilhouette */],
  wiggle: __WEBPACK_IMPORTED_MODULE_13_d3_shape__["d" /* stackOffsetWiggle */]
};
var getStackedData = function getStackedData(data, stackItems, offsetType) {
  var dataKeys = stackItems.map(function (item) {
    return item.props.dataKey;
  });
  var stack = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_d3_shape__["e" /* stack */])().keys(dataKeys).value(function (d, key) {
    return +getValueByDataKey(d, key, 0);
  }).order(__WEBPACK_IMPORTED_MODULE_13_d3_shape__["f" /* stackOrderNone */]).offset(STACK_OFFSET_MAP[offsetType]);
  return stack(data);
};
var getStackGroupsByAxisId = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
  if (!data) {
    return null;
  } // reversing items to affect render order (for layering)


  var items = reverseStackOrder ? _items.reverse() : _items;
  var stackGroups = items.reduce(function (result, item) {
    var _item$props3 = item.props,
        stackId = _item$props3.stackId,
        hide = _item$props3.hide;

    if (hide) {
      return result;
    }

    var axisId = item.props[numericAxisId];
    var parentGroup = result[axisId] || {
      hasStack: false,
      stackGroups: {}
    };

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["c" /* isNumOrStr */])(stackId)) {
      var childGroup = parentGroup.stackGroups[stackId] || {
        numericAxisId: numericAxisId,
        cateAxisId: cateAxisId,
        items: []
      };
      childGroup.items.push(item);
      parentGroup.hasStack = true;
      parentGroup.stackGroups[stackId] = childGroup;
    } else {
      parentGroup.stackGroups[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["f" /* uniqueId */])('_stackId_')] = {
        numericAxisId: numericAxisId,
        cateAxisId: cateAxisId,
        items: [item]
      };
    }

    return _objectSpread({}, result, _defineProperty({}, axisId, parentGroup));
  }, {});
  return Object.keys(stackGroups).reduce(function (result, axisId) {
    var group = stackGroups[axisId];

    if (group.hasStack) {
      group.stackGroups = Object.keys(group.stackGroups).reduce(function (res, stackId) {
        var g = group.stackGroups[stackId];
        return _objectSpread({}, res, _defineProperty({}, stackId, {
          numericAxisId: numericAxisId,
          cateAxisId: cateAxisId,
          items: g.items,
          stackedData: getStackedData(data, g.items, offsetType)
        }));
      }, {});
    }

    return _objectSpread({}, result, _defineProperty({}, axisId, group));
  }, {});
};
/**
 * get domain of ticks
 * @param  {Array} ticks Ticks of axis
 * @param  {String} type  The type of axis
 * @return {Array} domain
 */

var calculateDomainOfTicks = function calculateDomainOfTicks(ticks, type) {
  if (type === 'number') {
    return [__WEBPACK_IMPORTED_MODULE_6_lodash_min___default()(ticks), __WEBPACK_IMPORTED_MODULE_5_lodash_max___default()(ticks)];
  }

  return ticks;
};
/**
 * Configure the scale function of axis
 * @param {Object} scale The scale function
 * @param {Object} opts  The configuration of axis
 * @return {Object}      null
 */

var getTicksOfScale = function getTicksOfScale(scale, opts) {
  var realScaleType = opts.realScaleType,
      type = opts.type,
      tickCount = opts.tickCount,
      originalDomain = opts.originalDomain,
      allowDecimals = opts.allowDecimals;
  var scaleType = realScaleType || opts.scale;

  if (scaleType !== 'auto' && scaleType !== 'linear') {
    return null;
  }

  if (tickCount && type === 'number' && originalDomain && (originalDomain[0] === 'auto' || originalDomain[1] === 'auto')) {
    // Calculate the ticks by the number of grid when the axis is a number axis
    var domain = scale.domain();
    var tickValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_recharts_scale__["a" /* getNiceTickValues */])(domain, tickCount, allowDecimals);
    scale.domain(calculateDomainOfTicks(tickValues, type));
    return {
      niceTicks: tickValues
    };
  }

  if (tickCount && type === 'number') {
    var _domain = scale.domain();

    var _tickValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_recharts_scale__["b" /* getTickValuesFixedDomain */])(_domain, tickCount, allowDecimals);

    return {
      niceTicks: _tickValues
    };
  }

  return null;
};
var getCateCoordinateOfLine = function getCateCoordinateOfLine(_ref6) {
  var axis = _ref6.axis,
      ticks = _ref6.ticks,
      bandSize = _ref6.bandSize,
      entry = _ref6.entry,
      index = _ref6.index,
      dataKey = _ref6.dataKey;

  if (axis.type === 'category') {
    // find coordinate of category axis by the value of category
    if (!axis.allowDuplicatedCategory && axis.dataKey && !__WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(entry[axis.dataKey])) {
      var matchedTick = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["g" /* findEntryInArray */])(ticks, 'value', entry[axis.dataKey]);

      if (matchedTick) {
        return matchedTick.coordinate + bandSize / 2;
      }
    }

    return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
  }

  var value = getValueByDataKey(entry, !__WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(dataKey) ? dataKey : axis.dataKey);
  return !__WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(value) ? axis.scale(value) : null;
};
var getCateCoordinateOfBar = function getCateCoordinateOfBar(_ref7) {
  var axis = _ref7.axis,
      ticks = _ref7.ticks,
      offset = _ref7.offset,
      bandSize = _ref7.bandSize,
      entry = _ref7.entry,
      index = _ref7.index;

  if (axis.type === 'category') {
    return ticks[index] ? ticks[index].coordinate + offset : null;
  }

  var value = getValueByDataKey(entry, axis.dataKey, axis.domain[index]);
  return !__WEBPACK_IMPORTED_MODULE_10_lodash_isNil___default()(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var getBaseValueOfBar = function getBaseValueOfBar(_ref8) {
  var numericAxis = _ref8.numericAxis;
  var domain = numericAxis.scale.domain();

  if (numericAxis.type === 'number') {
    var min = Math.min(domain[0], domain[1]);
    var max = Math.max(domain[0], domain[1]);

    if (min <= 0 && max >= 0) {
      return 0;
    }

    if (max < 0) {
      return max;
    }

    return min;
  }

  return domain[0];
};
var getStackedDataOfItem = function getStackedDataOfItem(item, stackGroups) {
  var stackId = item.props.stackId;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["c" /* isNumOrStr */])(stackId)) {
    var group = stackGroups[stackId];

    if (group && group.items.length) {
      var itemIndex = -1;

      for (var i = 0, len = group.items.length; i < len; i++) {
        if (group.items[i] === item) {
          itemIndex = i;
          break;
        }
      }

      return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
    }
  }

  return null;
};

var getDomainOfSingle = function getDomainOfSingle(data) {
  return data.reduce(function (result, entry) {
    return [__WEBPACK_IMPORTED_MODULE_6_lodash_min___default()(entry.concat([result[0]]).filter(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["a" /* isNumber */])), __WEBPACK_IMPORTED_MODULE_5_lodash_max___default()(entry.concat([result[1]]).filter(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["a" /* isNumber */]))];
  }, [Infinity, -Infinity]);
};

var getDomainOfStackGroups = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
  return Object.keys(stackGroups).reduce(function (result, stackId) {
    var group = stackGroups[stackId];
    var stackedData = group.stackedData;
    var domain = stackedData.reduce(function (res, entry) {
      var s = getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
      return [Math.min(res[0], s[0]), Math.max(res[1], s[1])];
    }, [Infinity, -Infinity]);
    return [Math.min(domain[0], result[0]), Math.max(domain[1], result[1])];
  }, [Infinity, -Infinity]).map(function (result) {
    return result === Infinity || result === -Infinity ? 0 : result;
  });
};
var MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var parseSpecifiedDomain = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
  if (!__WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(specifiedDomain)) {
    return dataDomain;
  }

  var domain = [];
  /* eslint-disable prefer-destructuring */

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["a" /* isNumber */])(specifiedDomain[0])) {
    domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
  } else if (MIN_VALUE_REG.test(specifiedDomain[0])) {
    var value = +MIN_VALUE_REG.exec(specifiedDomain[0])[1];
    domain[0] = dataDomain[0] - value;
  } else if (__WEBPACK_IMPORTED_MODULE_8_lodash_isFunction___default()(specifiedDomain[0])) {
    domain[0] = specifiedDomain[0](dataDomain[0]);
  } else {
    domain[0] = dataDomain[0];
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__DataUtils__["a" /* isNumber */])(specifiedDomain[1])) {
    domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
  } else if (MAX_VALUE_REG.test(specifiedDomain[1])) {
    var _value = +MAX_VALUE_REG.exec(specifiedDomain[1])[1];

    domain[1] = dataDomain[1] + _value;
  } else if (__WEBPACK_IMPORTED_MODULE_8_lodash_isFunction___default()(specifiedDomain[1])) {
    domain[1] = specifiedDomain[1](dataDomain[1]);
  } else {
    domain[1] = dataDomain[1];
  }
  /* eslint-enable prefer-destructuring */


  return domain;
};
/**
 * Calculate the size between two category
 * @param  {Object} axis  The options of axis
 * @param  {Array}  ticks The ticks of axis
 * @return {Number} Size
 */

var getBandSizeOfAxis = function getBandSizeOfAxis(axis, ticks) {
  if (axis && axis.scale && axis.scale.bandwidth) {
    return axis.scale.bandwidth();
  }

  if (axis && ticks && ticks.length >= 2) {
    var orderedTicks = __WEBPACK_IMPORTED_MODULE_1_lodash_sortBy___default()(ticks, function (o) {
      return o.coordinate;
    });

    var bandSize = Infinity;

    for (var i = 1, len = orderedTicks.length; i < len; i++) {
      var cur = orderedTicks[i];
      var prev = orderedTicks[i - 1];
      bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
    }

    return bandSize === Infinity ? 0 : bandSize;
  }

  return 0;
};
/**
 * parse the domain of a category axis when a domain is specified
 * @param   {Array}        specifiedDomain  The domain specified by users
 * @param   {Array}        calculatedDomain The domain calculated by dateKey
 * @param   {ReactElement} axisChild        The axis element
 * @returns {Array}        domains
 */

var parseDomainOfCategoryAxis = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
  if (!specifiedDomain || !specifiedDomain.length) {
    return calculatedDomain;
  }

  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(specifiedDomain, __WEBPACK_IMPORTED_MODULE_9_lodash_get___default()(axisChild, 'type.defaultProps.domain'))) {
    return calculatedDomain;
  }

  return specifiedDomain;
};

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = initRange;
/* harmony export (immutable) */ __webpack_exports__["a"] = initInterpolator;
function initRange(domain, range) {
  switch (arguments.length) {
    case 0: break;
    case 1: this.range(domain); break;
    default: this.range(range).domain(domain); break;
  }
  return this;
}

function initInterpolator(domain, interpolator) {
  switch (arguments.length) {
    case 0: break;
    case 1: this.interpolator(domain); break;
    default: this.interpolator(interpolator).domain(domain); break;
  }
  return this;
}


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
// TODO: This module should be ElementChildren, and should use named exports.



/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid components".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @return {object} Object containing the ordered map of results.
 */
function map(children, func, context) {
  var index = 0;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return child;
    }

    return func.call(context, child, index++);
  });
}

/**
 * Iterates through children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for context.
 */
function forEach(children, func, context) {
  var index = 0;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    func.call(context, child, index++);
  });
}

/**
 * Count the number of "valid components" in the Children container.
 *
 * @param {?*} children Children tree container.
 * @returns {number}
 */
function count(children) {
  var result = 0;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    ++result;
  });

  return result;
}

/**
 * Finds children that are typically specified as `props.children`,
 * but only iterates over children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @returns {array} of children that meet the func return statement
 */
function filter(children, func, context) {
  var index = 0;
  var result = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result.push(child);
    }
  });

  return result;
}

function find(children, func, context) {
  var index = 0;
  var result = void 0;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (result) {
      return;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = child;
    }
  });

  return result;
}

function every(children, func, context) {
  var index = 0;
  var result = true;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!result) {
      return;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (!func.call(context, child, index++)) {
      result = false;
    }
  });

  return result;
}

function some(children, func, context) {
  var index = 0;
  var result = false;

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (result) {
      return;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = true;
    }
  });

  return result;
}

function toArray(children) {
  var result = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    result.push(child);
  });

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  map: map,
  forEach: forEach,
  count: count,
  find: find,
  filter: filter,
  every: every,
  some: some,
  toArray: toArray
});

/***/ }),
/* 47 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 48 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 49 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Animate__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__easing__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnimateGroup__ = __webpack_require__(1524);
/* unused harmony reexport configSpring */
/* unused harmony reexport configBezier */
/* unused harmony reexport AnimateGroup */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__util__["c"]; });





/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Animate__["a" /* default */]);

/***/ }),
/* 51 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactInstrumentation
 */



var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RADIAN; });
/* unused harmony export degreeToRadian */
/* unused harmony export radianToDegree */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return polarToCartesian; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getMaxRadius; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatAxisMap; });
/* unused harmony export distanceBetweenPoints */
/* unused harmony export getAngleOfPoint */
/* unused harmony export formatAngleOfSector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return inRangeOfSector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DataUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChartUtils__ = __webpack_require__(44);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }



var RADIAN = Math.PI / 180;
var degreeToRadian = function degreeToRadian(angle) {
  return angle * Math.PI / 180;
};
var radianToDegree = function radianToDegree(angleInRadian) {
  return angleInRadian * 180 / Math.PI;
};
var polarToCartesian = function polarToCartesian(cx, cy, radius, angle) {
  return {
    x: cx + Math.cos(-RADIAN * angle) * radius,
    y: cy + Math.sin(-RADIAN * angle) * radius
  };
};
var getMaxRadius = function getMaxRadius(width, height) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
  return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
/**
 * Calculate the scale function, position, width, height of axes
 * @param  {Object} props     Latest props
 * @param  {Object} axisMap   The configuration of axes
 * @param  {Object} offset    The offset of main part in the svg element
 * @param  {Object} axisType  The type of axes, radius-axis or angle-axis
 * @param  {String} chartName The name of chart
 * @return {Object} Configuration
 */

var formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
  var width = props.width,
      height = props.height;
  var startAngle = props.startAngle,
      endAngle = props.endAngle;
  var cx = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__DataUtils__["e" /* getPercentValue */])(props.cx, width, width / 2);
  var cy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__DataUtils__["e" /* getPercentValue */])(props.cy, height, height / 2);
  var maxRadius = getMaxRadius(width, height, offset);
  var innerRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__DataUtils__["e" /* getPercentValue */])(props.innerRadius, maxRadius, 0);
  var outerRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__DataUtils__["e" /* getPercentValue */])(props.outerRadius, maxRadius, maxRadius * 0.8);
  var ids = Object.keys(axisMap);
  return ids.reduce(function (result, id) {
    var axis = axisMap[id];
    var domain = axis.domain,
        reversed = axis.reversed;
    var range;

    if (__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(axis.range)) {
      if (axisType === 'angleAxis') {
        range = [startAngle, endAngle];
      } else if (axisType === 'radiusAxis') {
        range = [innerRadius, outerRadius];
      }

      if (reversed) {
        range = [range[1], range[0]];
      }
    } else {
      range = axis.range;
      var _range = range;

      var _range2 = _slicedToArray(_range, 2);

      startAngle = _range2[0];
      endAngle = _range2[1];
    }

    var _parseScale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__ChartUtils__["b" /* parseScale */])(axis, chartName),
        realScaleType = _parseScale.realScaleType,
        scale = _parseScale.scale;

    scale.domain(domain).range(range);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__ChartUtils__["c" /* checkDomainOfScale */])(scale);
    var ticks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__ChartUtils__["d" /* getTicksOfScale */])(scale, _objectSpread({}, axis, {
      realScaleType: realScaleType
    }));

    var finalAxis = _objectSpread({}, axis, {}, ticks, {
      range: range,
      radius: outerRadius,
      realScaleType: realScaleType,
      scale: scale,
      cx: cx,
      cy: cy,
      innerRadius: innerRadius,
      outerRadius: outerRadius,
      startAngle: startAngle,
      endAngle: endAngle
    });

    return _objectSpread({}, result, _defineProperty({}, id, finalAxis));
  }, {});
};
var distanceBetweenPoints = function distanceBetweenPoints(point, anotherPoint) {
  var x1 = point.x,
      y1 = point.y;
  var x2 = anotherPoint.x,
      y2 = anotherPoint.y;
  return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var getAngleOfPoint = function getAngleOfPoint(_ref, _ref2) {
  var x = _ref.x,
      y = _ref.y;
  var cx = _ref2.cx,
      cy = _ref2.cy;
  var radius = distanceBetweenPoints({
    x: x,
    y: y
  }, {
    x: cx,
    y: cy
  });

  if (radius <= 0) {
    return {
      radius: radius
    };
  }

  var cos = (x - cx) / radius;
  var angleInRadian = Math.acos(cos);

  if (y > cy) {
    angleInRadian = 2 * Math.PI - angleInRadian;
  }

  return {
    radius: radius,
    angle: radianToDegree(angleInRadian),
    angleInRadian: angleInRadian
  };
};
var formatAngleOfSector = function formatAngleOfSector(_ref3) {
  var startAngle = _ref3.startAngle,
      endAngle = _ref3.endAngle;
  var startCnt = Math.floor(startAngle / 360);
  var endCnt = Math.floor(endAngle / 360);
  var min = Math.min(startCnt, endCnt);
  return {
    startAngle: startAngle - min * 360,
    endAngle: endAngle - min * 360
  };
};

var reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
  var startAngle = _ref4.startAngle,
      endAngle = _ref4.endAngle;
  var startCnt = Math.floor(startAngle / 360);
  var endCnt = Math.floor(endAngle / 360);
  var min = Math.min(startCnt, endCnt);
  return angle + min * 360;
};

var inRangeOfSector = function inRangeOfSector(_ref5, sector) {
  var x = _ref5.x,
      y = _ref5.y;

  var _getAngleOfPoint = getAngleOfPoint({
    x: x,
    y: y
  }, sector),
      radius = _getAngleOfPoint.radius,
      angle = _getAngleOfPoint.angle;

  var innerRadius = sector.innerRadius,
      outerRadius = sector.outerRadius;

  if (radius < innerRadius || radius > outerRadius) {
    return false;
  }

  if (radius === 0) {
    return true;
  }

  var _formatAngleOfSector = formatAngleOfSector(sector),
      startAngle = _formatAngleOfSector.startAngle,
      endAngle = _formatAngleOfSector.endAngle;

  var formatAngle = angle;
  var inRange;

  if (startAngle <= endAngle) {
    while (formatAngle > endAngle) {
      formatAngle -= 360;
    }

    while (formatAngle < startAngle) {
      formatAngle += 360;
    }

    inRange = formatAngle >= startAngle && formatAngle <= endAngle;
  } else {
    while (formatAngle > startAngle) {
      formatAngle -= 360;
    }

    while (formatAngle < endAngle) {
      formatAngle += 360;
    }

    inRange = formatAngle >= endAngle && formatAngle <= startAngle;
  }

  if (inRange) {
    return _objectSpread({}, sector, {
      radius: radius,
      angle: reverseFormatAngleOfSetor(formatAngle, sector)
    });
  }

  return null;
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1653),
    baseMatchesProperty = __webpack_require__(1654),
    identity = __webpack_require__(145),
    isArray = __webpack_require__(34),
    property = __webpack_require__(1746);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(676);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactElement
 */



var _assign = __webpack_require__(22);

var ReactCurrentOwner = __webpack_require__(79);

var warning = __webpack_require__(21);
var canDefineProperty = __webpack_require__(409);
var hasOwnProperty = Object.prototype.hasOwnProperty;

// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};
    var shadowChildren = Array.isArray(props.children) ? props.children.slice(0) : props.children;

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      Object.defineProperty(element, '_shadowChildren', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: shadowChildren
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._shadowChildren = shadowChildren;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

ReactElement.REACT_ELEMENT_TYPE = REACT_ELEMENT_TYPE;

module.exports = ReactElement;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactUpdates
 */



var _prodInvariant = __webpack_require__(25),
    _assign = __webpack_require__(22);

var CallbackQueue = __webpack_require__(392);
var PooledClass = __webpack_require__(78);
var ReactFeatureFlags = __webpack_require__(399);
var ReactReconciler = __webpack_require__(110);
var Transaction = __webpack_require__(153);

var invariant = __webpack_require__(17);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.props === component._renderedComponent._currentElement) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 60 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(283)('wks');
var uid = __webpack_require__(186);
var Symbol = __webpack_require__(82).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bisect__ = __webpack_require__(454);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__bisect__["a"]; });
/* unused harmony reexport bisectRight */
/* unused harmony reexport bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(115);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bisector__ = __webpack_require__(455);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__bisector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cross__ = __webpack_require__(1040);
/* unused harmony reexport cross */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__descending__ = __webpack_require__(1041);
/* unused harmony reexport descending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__deviation__ = __webpack_require__(456);
/* unused harmony reexport deviation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__extent__ = __webpack_require__(457);
/* unused harmony reexport extent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__histogram__ = __webpack_require__(1042);
/* unused harmony reexport histogram */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__threshold_freedmanDiaconis__ = __webpack_require__(1052);
/* unused harmony reexport thresholdFreedmanDiaconis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__threshold_scott__ = __webpack_require__(1053);
/* unused harmony reexport thresholdScott */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__threshold_sturges__ = __webpack_require__(461);
/* unused harmony reexport thresholdSturges */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__max__ = __webpack_require__(1044);
/* unused harmony reexport max */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mean__ = __webpack_require__(1045);
/* unused harmony reexport mean */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__median__ = __webpack_require__(1046);
/* unused harmony reexport median */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__merge__ = __webpack_require__(1047);
/* unused harmony reexport merge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__min__ = __webpack_require__(458);
/* unused harmony reexport min */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pairs__ = __webpack_require__(459);
/* unused harmony reexport pairs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__permute__ = __webpack_require__(1048);
/* unused harmony reexport permute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__quantile__ = __webpack_require__(289);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_18__quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__range__ = __webpack_require__(460);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_19__range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__scan__ = __webpack_require__(1049);
/* unused harmony reexport scan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__shuffle__ = __webpack_require__(1050);
/* unused harmony reexport shuffle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__sum__ = __webpack_require__(1051);
/* unused harmony reexport sum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ticks__ = __webpack_require__(462);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_23__ticks__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_23__ticks__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_23__ticks__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__transpose__ = __webpack_require__(463);
/* unused harmony reexport transpose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__variance__ = __webpack_require__(464);
/* unused harmony reexport variance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__zip__ = __webpack_require__(1054);
/* unused harmony reexport zip */





























/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(534);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__ = __webpack_require__(41);











var propTypes = {
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  tabIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  /**
   * this is sort of silly but needed for Button
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'a'
};

function isTrivialHref(href) {
  return !href || href.trim() === '#';
}

/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
 */

var SafeAnchor = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(SafeAnchor, _React$Component);

  function SafeAnchor(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SafeAnchor);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  SafeAnchor.prototype.handleClick = function handleClick(event) {
    var _props = this.props,
        disabled = _props.disabled,
        href = _props.href,
        onClick = _props.onClick;


    if (disabled || isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  };

  SafeAnchor.prototype.handleKeyDown = function handleKeyDown(event) {
    if (event.key === ' ') {
      event.preventDefault();
      this.handleClick(event);
    }
  };

  SafeAnchor.prototype.render = function render() {
    var _props2 = this.props,
        Component = _props2.componentClass,
        disabled = _props2.disabled,
        onKeyDown = _props2.onKeyDown,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['componentClass', 'disabled', 'onKeyDown']);

    if (isTrivialHref(props.href)) {
      props.role = props.role || 'button';
      // we want to make sure there is a href attribute on the node
      // otherwise, the cursor incorrectly styled (except with role='button')
      props.href = props.href || '#';
    }

    if (disabled) {
      props.tabIndex = -1;
      props.style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ pointerEvents: 'none' }, props.style);
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      onClick: this.handleClick,
      onKeyDown: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__["a" /* default */])(this.handleKeyDown, onKeyDown)
    }));
  };

  return SafeAnchor;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

SafeAnchor.propTypes = propTypes;
SafeAnchor.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (SafeAnchor);

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(26),
    _assign = __webpack_require__(22);

var CallbackQueue = __webpack_require__(592);
var PooledClass = __webpack_require__(103);
var ReactFeatureFlags = __webpack_require__(597);
var ReactReconciler = __webpack_require__(127);
var Transaction = __webpack_require__(218);

var invariant = __webpack_require__(17);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 66 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventConstants
 */



var keyMirror = __webpack_require__(200);

var PropagationPhases = keyMirror({ bubbled: null, captured: null });

/**
 * Types of raw signals from the browser caught at the top level.
 */
var topLevelTypes = keyMirror({
  topAbort: null,
  topAnimationEnd: null,
  topAnimationIteration: null,
  topAnimationStart: null,
  topBlur: null,
  topCanPlay: null,
  topCanPlayThrough: null,
  topChange: null,
  topClick: null,
  topCompositionEnd: null,
  topCompositionStart: null,
  topCompositionUpdate: null,
  topContextMenu: null,
  topCopy: null,
  topCut: null,
  topDoubleClick: null,
  topDrag: null,
  topDragEnd: null,
  topDragEnter: null,
  topDragExit: null,
  topDragLeave: null,
  topDragOver: null,
  topDragStart: null,
  topDrop: null,
  topDurationChange: null,
  topEmptied: null,
  topEncrypted: null,
  topEnded: null,
  topError: null,
  topFocus: null,
  topInput: null,
  topInvalid: null,
  topKeyDown: null,
  topKeyPress: null,
  topKeyUp: null,
  topLoad: null,
  topLoadedData: null,
  topLoadedMetadata: null,
  topLoadStart: null,
  topMouseDown: null,
  topMouseMove: null,
  topMouseOut: null,
  topMouseOver: null,
  topMouseUp: null,
  topPaste: null,
  topPause: null,
  topPlay: null,
  topPlaying: null,
  topProgress: null,
  topRateChange: null,
  topReset: null,
  topScroll: null,
  topSeeked: null,
  topSeeking: null,
  topSelectionChange: null,
  topStalled: null,
  topSubmit: null,
  topSuspend: null,
  topTextInput: null,
  topTimeUpdate: null,
  topTouchCancel: null,
  topTouchEnd: null,
  topTouchMove: null,
  topTouchStart: null,
  topTransitionEnd: null,
  topVolumeChange: null,
  topWaiting: null,
  topWheel: null
});

var EventConstants = {
  topLevelTypes: topLevelTypes,
  PropagationPhases: PropagationPhases
};

module.exports = EventConstants;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticEvent
 */



var _assign = __webpack_require__(22);

var PooledClass = __webpack_require__(78);

var emptyFunction = __webpack_require__(37);
var warning = __webpack_require__(21);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {

  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
    } else if (typeof event.returnValue !== 'unknown') {
      // eslint-disable-line valid-typeof
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
    } else if (typeof event.cancelBubble !== 'unknown') {
      // eslint-disable-line valid-typeof
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }

});

SyntheticEvent.Interface = EventInterface;

if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}
/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return durationSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return durationMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return durationHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return durationDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return durationWeek; });
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 71 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(22);

var PooledClass = __webpack_require__(103);

var emptyFunction = __webpack_require__(37);
var warning = __webpack_require__(21);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

/** Proxying after everything set on SyntheticEvent
  * to resolve Proxy issue on some WebKit browsers
  * in which some Event properties are set to undefined (GH#10010)
  */
if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_every__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_every___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_every__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find__ = __webpack_require__(1733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_sortBy__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_range__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_throttle__ = __webpack_require__(1750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNil__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__container_Surface__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__container_Layer__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__component_Tooltip__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__component_Legend__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shape_Curve__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shape_Cross__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shape_Sector__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__shape_Dot__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__shape_Rectangle__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__cartesian_CartesianAxis__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__cartesian_Brush__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_DOMUtils__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__util_DataUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__util_DetectReferenceElementsDomain__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__util_PolarUtils__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__util_ShallowEqual__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__util_Events__ = __webpack_require__(1574);








function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }























var ORIENT_MAP = {
  xAxis: ['bottom', 'top'],
  yAxis: ['left', 'right']
};
var originCoordinate = {
  x: 0,
  y: 0
};

var generateCategoricalChart = function generateCategoricalChart(_ref) {
  var chartName = _ref.chartName,
      GraphicalChild = _ref.GraphicalChild,
      _ref$eventType = _ref.eventType,
      eventType = _ref$eventType === void 0 ? 'axis' : _ref$eventType,
      axisComponents = _ref.axisComponents,
      legendContent = _ref.legendContent,
      formatAxisMap = _ref.formatAxisMap,
      defaultProps = _ref.defaultProps,
      propTypes = _ref.propTypes;

  var CategoricalChartWrapper =
  /*#__PURE__*/
  function (_Component) {
    _inherits(CategoricalChartWrapper, _Component);

    /**
     * Returns default, reset state for the categorical chart.
     * @param {Object} props Props object to use when creating the default state
     * @return {Object} Whole new state
     */
    function CategoricalChartWrapper(_props) {
      var _this;

      _classCallCheck(this, CategoricalChartWrapper);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(CategoricalChartWrapper).call(this, _props));

      _this.handleLegendBBoxUpdate = function (box) {
        if (box && _this.legendInstance) {
          var _this$state = _this.state,
              dataStartIndex = _this$state.dataStartIndex,
              dataEndIndex = _this$state.dataEndIndex,
              updateId = _this$state.updateId;

          _this.setState(_this.updateStateOfAxisMapsOffsetAndStackGroups({
            props: _this.props,
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId
          }));
        }
      };

      _this.handleReceiveSyncEvent = function (cId, chartId, data) {
        var _this$props = _this.props,
            syncId = _this$props.syncId,
            layout = _this$props.layout;
        var updateId = _this.state.updateId;

        if (syncId === cId && chartId !== _this.uniqueChartId) {
          var dataStartIndex = data.dataStartIndex,
              dataEndIndex = data.dataEndIndex;

          if (!__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(data.dataStartIndex) || !__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(data.dataEndIndex)) {
            _this.setState(_objectSpread({
              dataStartIndex: dataStartIndex,
              dataEndIndex: dataEndIndex
            }, _this.updateStateOfAxisMapsOffsetAndStackGroups({
              props: _this.props,
              dataStartIndex: dataStartIndex,
              dataEndIndex: dataEndIndex,
              updateId: updateId
            })));
          } else if (!__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(data.activeTooltipIndex)) {
            var chartX = data.chartX,
                chartY = data.chartY,
                activeTooltipIndex = data.activeTooltipIndex;
            var _this$state2 = _this.state,
                offset = _this$state2.offset,
                tooltipTicks = _this$state2.tooltipTicks;

            if (!offset) {
              return;
            }

            var viewBox = _objectSpread({}, offset, {
              x: offset.left,
              y: offset.top
            }); // When a categotical chart is combined with another chart, the value of chartX
            // and chartY may beyond the boundaries.


            var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
            var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
            var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;

            var activePayload = _this.getTooltipContent(activeTooltipIndex);

            var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
              x: layout === 'horizontal' ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
              y: layout === 'horizontal' ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
            } : originCoordinate;

            _this.setState(_objectSpread({}, data, {
              activeLabel: activeLabel,
              activeCoordinate: activeCoordinate,
              activePayload: activePayload
            }));
          } else {
            _this.setState(data);
          }
        }
      };

      _this.handleBrushChange = function (_ref2) {
        var startIndex = _ref2.startIndex,
            endIndex = _ref2.endIndex;

        // Only trigger changes if the extents of the brush have actually changed
        if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
          var updateId = _this.state.updateId;

          _this.setState(function () {
            return _objectSpread({
              dataStartIndex: startIndex,
              dataEndIndex: endIndex
            }, _this.updateStateOfAxisMapsOffsetAndStackGroups({
              props: _this.props,
              dataStartIndex: startIndex,
              dataEndIndex: endIndex,
              updateId: updateId
            }));
          });

          _this.triggerSyncEvent({
            dataStartIndex: startIndex,
            dataEndIndex: endIndex
          });
        }
      };

      _this.handleMouseEnter = function (e) {
        var onMouseEnter = _this.props.onMouseEnter;

        var mouse = _this.getMouseInfo(e);

        if (mouse) {
          var nextState = _objectSpread({}, mouse, {
            isTooltipActive: true
          });

          _this.setState(nextState);

          _this.triggerSyncEvent(nextState);

          if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(onMouseEnter)) {
            onMouseEnter(nextState, e);
          }
        }
      };

      _this.triggeredAfterMouseMove = function (e) {
        var onMouseMove = _this.props.onMouseMove;

        var mouse = _this.getMouseInfo(e);

        var nextState = mouse ? _objectSpread({}, mouse, {
          isTooltipActive: true
        }) : {
          isTooltipActive: false
        };

        _this.setState(nextState);

        _this.triggerSyncEvent(nextState);

        if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(onMouseMove)) {
          onMouseMove(nextState, e);
        }
      };

      _this.handleItemMouseEnter = function (el) {
        _this.setState(function () {
          return {
            isTooltipActive: true,
            activeItem: el,
            activePayload: el.tooltipPayload,
            activeCoordinate: el.tooltipPosition || {
              x: el.cx,
              y: el.cy
            }
          };
        });
      };

      _this.handleItemMouseLeave = function () {
        _this.setState(function () {
          return {
            isTooltipActive: false
          };
        });
      };

      _this.handleMouseMove = function (e) {
        if (e && __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(e.persist)) {
          e.persist();
        }

        _this.triggeredAfterMouseMove(e);
      };

      _this.handleMouseLeave = function (e) {
        var onMouseLeave = _this.props.onMouseLeave;
        var nextState = {
          isTooltipActive: false
        };

        _this.setState(nextState);

        _this.triggerSyncEvent(nextState);

        if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(onMouseLeave)) {
          onMouseLeave(nextState, e);
        }
      };

      _this.handleOuterEvent = function (e) {
        var eventName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["l" /* getReactEventByType */])(e);

        if (eventName && __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(_this.props[eventName])) {
          var mouse = _this.getMouseInfo(e);

          var handler = _this.props[eventName];
          handler(mouse, e);
        }
      };

      _this.handleClick = function (e) {
        var onClick = _this.props.onClick;

        if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(onClick)) {
          var mouse = _this.getMouseInfo(e);

          onClick(mouse, e);
        }
      };

      _this.handleMouseDown = function (e) {
        var onMouseDown = _this.props.onMouseDown;

        if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(onMouseDown)) {
          var mouse = _this.getMouseInfo(e);

          onMouseDown(mouse, e);
        }
      };

      _this.handleMouseUp = function (e) {
        var onMouseUp = _this.props.onMouseUp;

        if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(onMouseUp)) {
          var mouse = _this.getMouseInfo(e);

          onMouseUp(mouse, e);
        }
      };

      _this.handleTouchMove = function (e) {
        if (e.changedTouches != null && e.changedTouches.length > 0) {
          _this.handleMouseMove(e.changedTouches[0]);
        }
      };

      _this.handleTouchStart = function (e) {
        if (e.changedTouches != null && e.changedTouches.length > 0) {
          _this.handleMouseDown(e.changedTouches[0]);
        }
      };

      _this.handleTouchEnd = function (e) {
        if (e.changedTouches != null && e.changedTouches.length > 0) {
          _this.handleMouseUp(e.changedTouches[0]);
        }
      };

      _this.verticalCoordinatesGenerator = function (_ref3) {
        var xAxis = _ref3.xAxis,
            width = _ref3.width,
            height = _ref3.height,
            offset = _ref3.offset;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["e" /* getCoordinatesOfGrid */])(__WEBPACK_IMPORTED_MODULE_20__cartesian_CartesianAxis__["a" /* default */].getTicks(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_20__cartesian_CartesianAxis__["a" /* default */].defaultProps, {}, xAxis, {
          ticks: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["f" /* getTicksOfAxis */])(xAxis, true),
          viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
          }
        })), offset.left, offset.left + offset.width);
      };

      _this.horizontalCoordinatesGenerator = function (_ref4) {
        var yAxis = _ref4.yAxis,
            width = _ref4.width,
            height = _ref4.height,
            offset = _ref4.offset;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["e" /* getCoordinatesOfGrid */])(__WEBPACK_IMPORTED_MODULE_20__cartesian_CartesianAxis__["a" /* default */].getTicks(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_20__cartesian_CartesianAxis__["a" /* default */].defaultProps, {}, yAxis, {
          ticks: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["f" /* getTicksOfAxis */])(yAxis, true),
          viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
          }
        })), offset.top, offset.top + offset.height);
      };

      _this.axesTicksGenerator = function (axis) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["f" /* getTicksOfAxis */])(axis, true);
      };

      _this.tooltipTicksGenerator = function (axisMap) {
        var axis = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["i" /* getAnyElementOfObject */])(axisMap);
        var tooltipTicks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["f" /* getTicksOfAxis */])(axis, false, true);
        return {
          tooltipTicks: tooltipTicks,
          orderedTooltipTicks: __WEBPACK_IMPORTED_MODULE_2_lodash_sortBy___default()(tooltipTicks, function (o) {
            return o.coordinate;
          }),
          tooltipAxis: axis,
          tooltipAxisBandSize: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["g" /* getBandSizeOfAxis */])(axis)
        };
      };

      _this.renderCursor = function (element) {
        var _this$state3 = _this.state,
            isTooltipActive = _this$state3.isTooltipActive,
            activeCoordinate = _this$state3.activeCoordinate,
            activePayload = _this$state3.activePayload,
            offset = _this$state3.offset;

        if (!element || !element.props.cursor || !isTooltipActive || !activeCoordinate) {
          return null;
        }

        var layout = _this.props.layout;
        var restProps;
        var cursorComp = __WEBPACK_IMPORTED_MODULE_14__shape_Curve__["a" /* default */];

        if (chartName === 'ScatterChart') {
          restProps = activeCoordinate;
          cursorComp = __WEBPACK_IMPORTED_MODULE_15__shape_Cross__["a" /* default */];
        } else if (chartName === 'BarChart') {
          restProps = _this.getCursorRectangle();
          cursorComp = __WEBPACK_IMPORTED_MODULE_18__shape_Rectangle__["a" /* default */];
        } else if (layout === 'radial') {
          var _this$getCursorPoints = _this.getCursorPoints(),
              cx = _this$getCursorPoints.cx,
              cy = _this$getCursorPoints.cy,
              radius = _this$getCursorPoints.radius,
              startAngle = _this$getCursorPoints.startAngle,
              endAngle = _this$getCursorPoints.endAngle;

          restProps = {
            cx: cx,
            cy: cy,
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: radius,
            outerRadius: radius
          };
          cursorComp = __WEBPACK_IMPORTED_MODULE_16__shape_Sector__["a" /* default */];
        } else {
          restProps = {
            points: _this.getCursorPoints()
          };
          cursorComp = __WEBPACK_IMPORTED_MODULE_14__shape_Curve__["a" /* default */];
        }

        var key = element.key || '_recharts-cursor';

        var cursorProps = _objectSpread({
          stroke: '#ccc',
          pointerEvents: 'none'
        }, offset, {}, restProps, {}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["a" /* getPresentationAttributes */])(element.props.cursor), {
          payload: activePayload,
          key: key,
          className: 'recharts-tooltip-cursor'
        });

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["isValidElement"])(element.props.cursor) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(element.props.cursor, cursorProps) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["createElement"])(cursorComp, cursorProps);
      };

      _this.renderPolarAxis = function (element, displayName, index) {
        var axisType = element.type.axisType;

        var axisMap = _this.state["".concat(axisType, "Map")];

        var axisOption = axisMap[element.props["".concat(axisType, "Id")]];
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(element, _objectSpread({}, axisOption, {
          className: axisType,
          key: element.key || "".concat(displayName, "-").concat(index),
          ticks: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["f" /* getTicksOfAxis */])(axisOption, true)
        }));
      };

      _this.renderXAxis = function (element, displayName, index) {
        var xAxisMap = _this.state.xAxisMap;
        var axisObj = xAxisMap[element.props.xAxisId];
        return _this.renderAxis(axisObj, element, displayName, index);
      };

      _this.renderYAxis = function (element, displayName, index) {
        var yAxisMap = _this.state.yAxisMap;
        var axisObj = yAxisMap[element.props.yAxisId];
        return _this.renderAxis(axisObj, element, displayName, index);
      };

      _this.renderGrid = function (element) {
        var _this$state4 = _this.state,
            xAxisMap = _this$state4.xAxisMap,
            yAxisMap = _this$state4.yAxisMap,
            offset = _this$state4.offset;
        var _this$props2 = _this.props,
            width = _this$props2.width,
            height = _this$props2.height;
        var xAxis = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["i" /* getAnyElementOfObject */])(xAxisMap);

        var yAxisWithFiniteDomain = __WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(yAxisMap, function (axis) {
          return __WEBPACK_IMPORTED_MODULE_0_lodash_every___default()(axis.domain, Number.isFinite);
        });

        var yAxis = yAxisWithFiniteDomain || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["i" /* getAnyElementOfObject */])(yAxisMap);
        var props = element.props || {};
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(element, {
          key: element.key || 'grid',
          x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["a" /* isNumber */])(props.x) ? props.x : offset.left,
          y: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["a" /* isNumber */])(props.y) ? props.y : offset.top,
          width: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["a" /* isNumber */])(props.width) ? props.width : offset.width,
          height: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["a" /* isNumber */])(props.height) ? props.height : offset.height,
          xAxis: xAxis,
          yAxis: yAxis,
          offset: offset,
          chartWidth: width,
          chartHeight: height,
          verticalCoordinatesGenerator: props.verticalCoordinatesGenerator || _this.verticalCoordinatesGenerator,
          horizontalCoordinatesGenerator: props.horizontalCoordinatesGenerator || _this.horizontalCoordinatesGenerator
        });
      };

      _this.renderPolarGrid = function (element) {
        var _this$state5 = _this.state,
            radiusAxisMap = _this$state5.radiusAxisMap,
            angleAxisMap = _this$state5.angleAxisMap;
        var radiusAxis = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["i" /* getAnyElementOfObject */])(radiusAxisMap);
        var angleAxis = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["i" /* getAnyElementOfObject */])(angleAxisMap);
        var cx = angleAxis.cx,
            cy = angleAxis.cy,
            innerRadius = angleAxis.innerRadius,
            outerRadius = angleAxis.outerRadius;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(element, {
          polarAngles: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["f" /* getTicksOfAxis */])(angleAxis, true).map(function (entry) {
            return entry.coordinate;
          }),
          polarRadius: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["f" /* getTicksOfAxis */])(radiusAxis, true).map(function (entry) {
            return entry.coordinate;
          }),
          cx: cx,
          cy: cy,
          innerRadius: innerRadius,
          outerRadius: outerRadius,
          key: element.key || 'polar-grid'
        });
      };

      _this.renderBrush = function (element) {
        var _this$props3 = _this.props,
            margin = _this$props3.margin,
            data = _this$props3.data;
        var _this$state6 = _this.state,
            offset = _this$state6.offset,
            dataStartIndex = _this$state6.dataStartIndex,
            dataEndIndex = _this$state6.dataEndIndex,
            updateId = _this$state6.updateId; // TODO: update brush when children update

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(element, {
          key: element.key || '_recharts-brush',
          onChange: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["h" /* combineEventHandlers */])(_this.handleBrushChange, null, element.props.onChange),
          data: data,
          x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["a" /* isNumber */])(element.props.x) ? element.props.x : offset.left,
          y: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["a" /* isNumber */])(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
          width: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["a" /* isNumber */])(element.props.width) ? element.props.width : offset.width,
          startIndex: dataStartIndex,
          endIndex: dataEndIndex,
          updateId: "brush-".concat(updateId)
        });
      };

      _this.renderReferenceElement = function (element, displayName, index) {
        if (!element) {
          return null;
        }

        var _assertThisInitialize = _assertThisInitialized(_this),
            clipPathId = _assertThisInitialize.clipPathId;

        var _this$state7 = _this.state,
            xAxisMap = _this$state7.xAxisMap,
            yAxisMap = _this$state7.yAxisMap,
            offset = _this$state7.offset;
        var _element$props = element.props,
            xAxisId = _element$props.xAxisId,
            yAxisId = _element$props.yAxisId;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(element, {
          key: element.key || "".concat(displayName, "-").concat(index),
          xAxis: xAxisMap[xAxisId],
          yAxis: yAxisMap[yAxisId],
          viewBox: {
            x: offset.left,
            y: offset.top,
            width: offset.width,
            height: offset.height
          },
          clipPathId: clipPathId
        });
      };

      _this.renderGraphicChild = function (element, displayName, index) {
        var item = _this.filterFormatItem(element, displayName, index);

        if (!item) {
          return null;
        }

        var graphicalItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(element, item.props);
        var _this$state8 = _this.state,
            isTooltipActive = _this$state8.isTooltipActive,
            tooltipAxis = _this$state8.tooltipAxis,
            activeTooltipIndex = _this$state8.activeTooltipIndex,
            activeLabel = _this$state8.activeLabel;
        var children = _this.props.children;
        var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["j" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_12__component_Tooltip__["a" /* default */]);
        var _item$props = item.props,
            points = _item$props.points,
            isRange = _item$props.isRange,
            baseLine = _item$props.baseLine;
        var _item$item$props = item.item.props,
            activeDot = _item$item$props.activeDot,
            hide = _item$item$props.hide;
        var hasActive = !hide && isTooltipActive && tooltipItem && activeDot && activeTooltipIndex >= 0;

        function findWithPayload(entry) {
          return tooltipAxis.dataKey(entry.payload);
        }

        if (hasActive) {
          var activePoint, basePoint;

          if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            var specifiedKey = typeof tooltipAxis.dataKey === 'function' ? findWithPayload : 'payload.'.concat(tooltipAxis.dataKey);
            activePoint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["g" /* findEntryInArray */])(points, specifiedKey, activeLabel);
            basePoint = isRange && baseLine && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["g" /* findEntryInArray */])(baseLine, specifiedKey, activeLabel);
          } else {
            activePoint = points[activeTooltipIndex];
            basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
          }

          if (!__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(activePoint)) {
            return [graphicalItem].concat(_toConsumableArray(_this.renderActivePoints({
              item: item,
              activePoint: activePoint,
              basePoint: basePoint,
              childIndex: activeTooltipIndex,
              isRange: isRange
            })));
          }
        }

        if (isRange) {
          return [graphicalItem, null, null];
        }

        return [graphicalItem, null];
      };

      _this.renderCustomized = function (element) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(element, _objectSpread({}, _this.props, {}, _this.state));
      };

      var defaultState = _this.constructor.createDefaultState(_props);

      var _updateId = 0;
      _this.state = _objectSpread({}, defaultState, {
        updateId: 0
      }, _this.updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread({
        props: _props
      }, defaultState, {
        updateId: _updateId
      })));
      _this.uniqueChartId = __WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(_props.id) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["f" /* uniqueId */])('recharts') : _props.id;
      _this.clipPathId = "".concat(_this.uniqueChartId, "-clip");

      if (_props.throttleDelay) {
        _this.triggeredAfterMouseMove = __WEBPACK_IMPORTED_MODULE_5_lodash_throttle___default()(_this.triggeredAfterMouseMove, _props.throttleDelay);
      }

      return _this;
    }
    /* eslint-disable  react/no-did-mount-set-state */


    _createClass(CategoricalChartWrapper, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (!__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(this.props.syncId)) {
          this.addListener();
        }
      } // eslint-disable-next-line camelcase

    }, {
      key: "componentWillReceiveProps",
      value: function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        var _this$props4 = this.props,
            data = _this$props4.data,
            children = _this$props4.children,
            width = _this$props4.width,
            height = _this$props4.height,
            layout = _this$props4.layout,
            stackOffset = _this$props4.stackOffset,
            margin = _this$props4.margin;
        var updateId = this.state.updateId;

        if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || nextProps.layout !== layout || nextProps.stackOffset !== stackOffset || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__util_ShallowEqual__["a" /* shallowEqual */])(nextProps.margin, margin)) {
          var defaultState = this.constructor.createDefaultState(nextProps);
          this.setState(_objectSpread({}, defaultState, {
            updateId: updateId + 1
          }, this.updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread({
            props: nextProps
          }, defaultState, {
            updateId: updateId + 1
          }))));
        } else if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["m" /* isChildrenEqual */])(nextProps.children, children)) {
          // update configuration in chilren
          var hasGlobalData = !__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(nextProps.data);
          var newUpdateId = hasGlobalData ? updateId : updateId + 1;
          this.setState(function (prevState) {
            return _objectSpread({
              updateId: newUpdateId
            }, _this2.updateStateOfAxisMapsOffsetAndStackGroups(_objectSpread({
              props: nextProps
            }, prevState, {
              updateId: newUpdateId
            })));
          });
        } // add syncId


        if (__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(this.props.syncId) && !__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(nextProps.syncId)) {
          this.addListener();
        } // remove syncId


        if (!__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(this.props.syncId) && __WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(nextProps.syncId)) {
          this.removeListener();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (!__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(this.props.syncId)) {
          this.removeListener();
        }

        if (typeof this.triggeredAfterMouseMove.cancel === 'function') {
          this.triggeredAfterMouseMove.cancel();
        }
      }
      /**
      * Get the configuration of all x-axis or y-axis
      * @param  {Object} props          Latest props
      * @param  {String} axisType       The type of axis
      * @param  {Array}  graphicalItems The instances of item
      * @param  {Object} stackGroups    The items grouped by axisId and stackId
      * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
      * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
      * @return {Object}          Configuration
      */

    }, {
      key: "getAxisMap",
      value: function getAxisMap(props, _ref5) {
        var _ref5$axisType = _ref5.axisType,
            axisType = _ref5$axisType === void 0 ? 'xAxis' : _ref5$axisType,
            AxisComp = _ref5.AxisComp,
            graphicalItems = _ref5.graphicalItems,
            stackGroups = _ref5.stackGroups,
            dataStartIndex = _ref5.dataStartIndex,
            dataEndIndex = _ref5.dataEndIndex;
        var children = props.children;
        var axisIdKey = "".concat(axisType, "Id"); // Get all the instance of Axis

        var axes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["i" /* findAllByType */])(children, AxisComp);
        var axisMap = {};

        if (axes && axes.length) {
          axisMap = this.getAxisMapByAxes(props, {
            axes: axes,
            graphicalItems: graphicalItems,
            axisType: axisType,
            axisIdKey: axisIdKey,
            stackGroups: stackGroups,
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
          });
        } else if (graphicalItems && graphicalItems.length) {
          axisMap = this.getAxisMapByItems(props, {
            Axis: AxisComp,
            graphicalItems: graphicalItems,
            axisType: axisType,
            axisIdKey: axisIdKey,
            stackGroups: stackGroups,
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
          });
        }

        return axisMap;
      }
      /**
       * Get the configuration of axis by the options of axis instance
       * @param  {Object} props         Latest props
       * @param {Array}  axes           The instance of axes
       * @param  {Array} graphicalItems The instances of item
       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
       * @param  {String} axisIdKey     The unique id of an axis
       * @param  {Object} stackGroups   The items grouped by axisId and stackId
       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
       * @return {Object}      Configuration
       */

    }, {
      key: "getAxisMapByAxes",
      value: function getAxisMapByAxes(props, _ref6) {
        var _this3 = this;

        var axes = _ref6.axes,
            graphicalItems = _ref6.graphicalItems,
            axisType = _ref6.axisType,
            axisIdKey = _ref6.axisIdKey,
            stackGroups = _ref6.stackGroups,
            dataStartIndex = _ref6.dataStartIndex,
            dataEndIndex = _ref6.dataEndIndex;
        var layout = props.layout,
            children = props.children,
            stackOffset = props.stackOffset;
        var isCategorial = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["i" /* isCategorialAxis */])(layout, axisType); // Eliminate duplicated axes

        var axisMap = axes.reduce(function (result, child) {
          var _child$props = child.props,
              type = _child$props.type,
              dataKey = _child$props.dataKey,
              allowDataOverflow = _child$props.allowDataOverflow,
              allowDuplicatedCategory = _child$props.allowDuplicatedCategory,
              scale = _child$props.scale,
              ticks = _child$props.ticks;
          var axisId = child.props[axisIdKey];

          var displayedData = _this3.constructor.getDisplayedData(props, {
            graphicalItems: graphicalItems.filter(function (item) {
              return item.props[axisIdKey] === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
          });

          var len = displayedData.length;

          if (!result[axisId]) {
            var domain, duplicateDomain, categoricalDomain;

            if (dataKey) {
              domain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["j" /* getDomainOfDataByKey */])(displayedData, dataKey, type);

              if (type === 'category' && isCategorial) {
                var duplicate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["j" /* hasDuplicate */])(domain);

                if (allowDuplicatedCategory && duplicate) {
                  duplicateDomain = domain; // When category axis has duplicated text, serial numbers are used to generate scale

                  domain = __WEBPACK_IMPORTED_MODULE_4_lodash_range___default()(0, len);
                } else if (!allowDuplicatedCategory) {
                  // remove duplicated category
                  domain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["k" /* parseDomainOfCategoryAxis */])(child.props.domain, domain, child).reduce(function (finalDomain, entry) {
                    return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat(_toConsumableArray(finalDomain), [entry]);
                  }, []);
                }
              } else if (type === 'category') {
                if (!allowDuplicatedCategory) {
                  domain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["k" /* parseDomainOfCategoryAxis */])(child.props.domain, domain, child).reduce(function (finalDomain, entry) {
                    return finalDomain.indexOf(entry) >= 0 || entry === '' || __WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(entry) ? finalDomain : [].concat(_toConsumableArray(finalDomain), [entry]);
                  }, []);
                } else {
                  // eliminate undefined or null or empty string
                  domain = domain.filter(function (entry) {
                    return entry !== '' && !__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(entry);
                  });
                }
              } else if (type === 'number') {
                var errorBarsDomain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["l" /* parseErrorBarsOfAxis */])(displayedData, graphicalItems.filter(function (item) {
                  return item.props[axisIdKey] === axisId && !item.props.hide;
                }), dataKey, axisType);

                if (errorBarsDomain) {
                  domain = errorBarsDomain;
                }
              }

              if (isCategorial && (type === 'number' || scale !== 'auto')) {
                categoricalDomain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["j" /* getDomainOfDataByKey */])(displayedData, dataKey, 'category');
              }
            } else if (isCategorial) {
              domain = __WEBPACK_IMPORTED_MODULE_4_lodash_range___default()(0, len);
            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === 'number') {
              // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
              domain = stackOffset === 'expand' ? [0, 1] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["m" /* getDomainOfStackGroups */])(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            } else {
              domain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["n" /* getDomainOfItemsWithSameAxis */])(displayedData, graphicalItems.filter(function (item) {
                return item.props[axisIdKey] === axisId && !item.props.hide;
              }), type, true);
            }

            if (type === 'number') {
              // To detect wether there is any reference lines whose props alwaysShow is true
              domain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__util_DetectReferenceElementsDomain__["a" /* detectReferenceElementsDomain */])(children, domain, axisId, axisType, ticks);

              if (child.props.domain) {
                domain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["o" /* parseSpecifiedDomain */])(child.props.domain, domain, allowDataOverflow);
              }
            }

            return _objectSpread({}, result, _defineProperty({}, axisId, _objectSpread({}, child.props, {
              axisType: axisType,
              domain: domain,
              categoricalDomain: categoricalDomain,
              duplicateDomain: duplicateDomain,
              originalDomain: child.props.domain,
              isCategorial: isCategorial,
              layout: layout
            })));
          }

          return result;
        }, {});
        return axisMap;
      }
      /**
       * Get the configuration of axis by the options of item,
       * this kind of axis does not display in chart
       * @param  {Object} props         Latest props
       * @param  {Array} graphicalItems The instances of item
       * @param  {ReactElement} Axis    Axis Component
       * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
       * @param  {String} axisIdKey     The unique id of an axis
       * @param  {Object} stackGroups   The items grouped by axisId and stackId
       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
       * @return {Object}               Configuration
       */

    }, {
      key: "getAxisMapByItems",
      value: function getAxisMapByItems(props, _ref7) {
        var graphicalItems = _ref7.graphicalItems,
            Axis = _ref7.Axis,
            axisType = _ref7.axisType,
            axisIdKey = _ref7.axisIdKey,
            stackGroups = _ref7.stackGroups,
            dataStartIndex = _ref7.dataStartIndex,
            dataEndIndex = _ref7.dataEndIndex;
        var layout = props.layout,
            children = props.children;
        var displayedData = this.constructor.getDisplayedData(props, {
          graphicalItems: graphicalItems,
          dataStartIndex: dataStartIndex,
          dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        var isCategorial = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["i" /* isCategorialAxis */])(layout, axisType);
        var index = -1; // The default type of x-axis is category axis,
        // The default contents of x-axis is the serial numbers of data
        // The default type of y-axis is number axis
        // The default contents of y-axis is the domain of data

        var axisMap = graphicalItems.reduce(function (result, child) {
          var axisId = child.props[axisIdKey];

          if (!result[axisId]) {
            index++;
            var domain;

            if (isCategorial) {
              domain = __WEBPACK_IMPORTED_MODULE_4_lodash_range___default()(0, len);
            } else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
              domain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["m" /* getDomainOfStackGroups */])(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
              domain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__util_DetectReferenceElementsDomain__["a" /* detectReferenceElementsDomain */])(children, domain, axisId, axisType);
            } else {
              domain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["o" /* parseSpecifiedDomain */])(Axis.defaultProps.domain, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["n" /* getDomainOfItemsWithSameAxis */])(displayedData, graphicalItems.filter(function (item) {
                return item.props[axisIdKey] === axisId && !item.props.hide;
              }), 'number'), Axis.defaultProps.allowDataOverflow);
              domain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_25__util_DetectReferenceElementsDomain__["a" /* detectReferenceElementsDomain */])(children, domain, axisId, axisType);
            }

            return _objectSpread({}, result, _defineProperty({}, axisId, _objectSpread({
              axisType: axisType
            }, Axis.defaultProps, {
              hide: true,
              orientation: ORIENT_MAP[axisType] && ORIENT_MAP[axisType][index % 2],
              domain: domain,
              originalDomain: Axis.defaultProps.domain,
              isCategorial: isCategorial,
              layout: layout // specify scale when no Axis
              // scale: isCategorial ? 'band' : 'linear',

            })));
          }

          return result;
        }, {});
        return axisMap;
      }
    }, {
      key: "getActiveCoordinate",
      value: function getActiveCoordinate(tooltipTicks, activeIndex, rangeObj) {
        var layout = this.props.layout;
        var entry = tooltipTicks.find(function (tick) {
          return tick && tick.index === activeIndex;
        });

        if (entry) {
          if (layout === 'horizontal') {
            return {
              x: entry.coordinate,
              y: rangeObj.y
            };
          }

          if (layout === 'vertical') {
            return {
              x: rangeObj.x,
              y: entry.coordinate
            };
          }

          if (layout === 'centric') {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return _objectSpread({}, rangeObj, {}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__util_PolarUtils__["a" /* polarToCartesian */])(rangeObj.cx, rangeObj.cy, _radius, _angle), {
              angle: _angle,
              radius: _radius
            });
          }

          var radius = entry.coordinate;
          var angle = rangeObj.angle;
          return _objectSpread({}, rangeObj, {}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__util_PolarUtils__["a" /* polarToCartesian */])(rangeObj.cx, rangeObj.cy, radius, angle), {
            angle: angle,
            radius: radius
          });
        }

        return originCoordinate;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {Object} event    The event object
       * @return {Object}          Mouse data
       */

    }, {
      key: "getMouseInfo",
      value: function getMouseInfo(event) {
        if (!this.container) {
          return null;
        }

        var containerOffset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__util_DOMUtils__["b" /* getOffset */])(this.container);
        var e = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__util_DOMUtils__["c" /* calculateChartCoordinate */])(event, containerOffset);
        var rangeObj = this.inRange(e.chartX, e.chartY);

        if (!rangeObj) {
          return null;
        }

        var _this$state9 = this.state,
            xAxisMap = _this$state9.xAxisMap,
            yAxisMap = _this$state9.yAxisMap;

        if (eventType !== 'axis' && xAxisMap && yAxisMap) {
          var xScale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["i" /* getAnyElementOfObject */])(xAxisMap).scale;
          var yScale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["i" /* getAnyElementOfObject */])(yAxisMap).scale;
          var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
          var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
          return _objectSpread({}, e, {
            xValue: xValue,
            yValue: yValue
          });
        }

        var _this$state10 = this.state,
            ticks = _this$state10.orderedTooltipTicks,
            axis = _this$state10.tooltipAxis,
            tooltipTicks = _this$state10.tooltipTicks;
        var pos = this.calculateTooltipPos(rangeObj);
        var activeIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["p" /* calculateActiveTickIndex */])(pos, ticks, tooltipTicks, axis);

        if (activeIndex >= 0 && tooltipTicks) {
          var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
          var activePayload = this.getTooltipContent(activeIndex, activeLabel);
          var activeCoordinate = this.getActiveCoordinate(ticks, activeIndex, rangeObj);
          return _objectSpread({}, e, {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
          });
        }

        return null;
      }
      /**
       * Get the content to be displayed in the tooltip
       * @param  {Number} activeIndex    Active index of data
       * @param  {String} activeLabel    Active label of data
       * @return {Array}                 The content of tooltip
       */

    }, {
      key: "getTooltipContent",
      value: function getTooltipContent(activeIndex, activeLabel) {
        var _this$state11 = this.state,
            graphicalItems = _this$state11.graphicalItems,
            tooltipAxis = _this$state11.tooltipAxis;
        var displayedData = this.constructor.getDisplayedData(this.props, this.state);

        if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) {
          return null;
        } // get data by activeIndex when the axis don't allow duplicated category


        return graphicalItems.reduce(function (result, child) {
          var hide = child.props.hide;

          if (hide) {
            return result;
          }

          var _child$props2 = child.props,
              dataKey = _child$props2.dataKey,
              name = _child$props2.name,
              unit = _child$props2.unit,
              formatter = _child$props2.formatter,
              data = _child$props2.data,
              tooltipType = _child$props2.tooltipType;
          var payload;

          if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            payload = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["g" /* findEntryInArray */])(data || displayedData, tooltipAxis.dataKey, activeLabel);
          } else {
            payload = data && data[activeIndex] || displayedData[activeIndex];
          }

          if (!payload) {
            return result;
          }

          return [].concat(_toConsumableArray(result), [_objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["a" /* getPresentationAttributes */])(child), {
            dataKey: dataKey,
            unit: unit,
            formatter: formatter,
            name: name || dataKey,
            color: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["q" /* getMainColorOfGraphicItem */])(child),
            value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["a" /* getValueByDataKey */])(payload, dataKey),
            type: tooltipType,
            payload: payload
          })]);
        }, []);
      }
    }, {
      key: "getFormatItems",
      value: function getFormatItems(props, currentState) {
        var _this4 = this;

        var graphicalItems = currentState.graphicalItems,
            stackGroups = currentState.stackGroups,
            offset = currentState.offset,
            updateId = currentState.updateId,
            dataStartIndex = currentState.dataStartIndex,
            dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize,
            layout = props.layout,
            barGap = props.barGap,
            barCategoryGap = props.barCategoryGap,
            globalMaxBarSize = props.maxBarSize;

        var _this$constructor$get = this.constructor.getAxisNameByLayout(layout),
            numericAxisName = _this$constructor$get.numericAxisName,
            cateAxisName = _this$constructor$get.cateAxisName;

        var hasBar = this.constructor.hasBar(graphicalItems);
        var sizeList = hasBar && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["r" /* getBarSizeList */])({
          barSize: barSize,
          stackGroups: stackGroups
        });
        var formatedItems = [];
        graphicalItems.forEach(function (item, index) {
          var displayedData = _this4.constructor.getDisplayedData(props, {
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
          }, item);

          var _item$props2 = item.props,
              dataKey = _item$props2.dataKey,
              childMaxBarSize = _item$props2.maxBarSize;
          var numericAxisId = item.props["".concat(numericAxisName, "Id")];
          var cateAxisId = item.props["".concat(cateAxisName, "Id")];
          var axisObj = axisComponents.reduce(function (result, entry) {
            var _objectSpread4;

            var axisMap = currentState["".concat(entry.axisType, "Map")];
            var id = item.props["".concat(entry.axisType, "Id")];
            var axis = axisMap && axisMap[id];
            return _objectSpread({}, result, (_objectSpread4 = {}, _defineProperty(_objectSpread4, entry.axisType, axis), _defineProperty(_objectSpread4, "".concat(entry.axisType, "Ticks"), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["f" /* getTicksOfAxis */])(axis)), _objectSpread4));
          }, {});
          var cateAxis = axisObj[cateAxisName];
          var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
          var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["s" /* getStackedDataOfItem */])(item, stackGroups[numericAxisId].stackGroups);
          var bandSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["g" /* getBandSizeOfAxis */])(cateAxis, cateTicks);
          var maxBarSize = __WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
          var barPosition = hasBar && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["t" /* getBarPosition */])({
            barGap: barGap,
            barCategoryGap: barCategoryGap,
            bandSize: bandSize,
            sizeList: sizeList[cateAxisId],
            maxBarSize: maxBarSize
          });
          var componsedFn = item && item.type && item.type.getComposedData;

          if (componsedFn) {
            var _objectSpread5;

            formatedItems.push({
              props: _objectSpread({}, componsedFn(_objectSpread({}, axisObj, {
                displayedData: displayedData,
                props: props,
                dataKey: dataKey,
                item: item,
                bandSize: bandSize,
                barPosition: barPosition,
                offset: offset,
                stackedData: stackedData,
                layout: layout,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex,
                onItemMouseLeave: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["h" /* combineEventHandlers */])(_this4.handleItemMouseLeave, null, item.props.onMouseLeave),
                onItemMouseEnter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["h" /* combineEventHandlers */])(_this4.handleItemMouseEnter, null, item.props.onMouseEnter)
              })), (_objectSpread5 = {
                key: item.key || "item-".concat(index)
              }, _defineProperty(_objectSpread5, numericAxisName, axisObj[numericAxisName]), _defineProperty(_objectSpread5, cateAxisName, axisObj[cateAxisName]), _defineProperty(_objectSpread5, "animationId", updateId), _objectSpread5)),
              childIndex: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["n" /* parseChildIndex */])(item, props.children),
              item: item
            });
          }
        });
        return formatedItems;
      }
    }, {
      key: "getCursorRectangle",
      value: function getCursorRectangle() {
        var layout = this.props.layout;
        var _this$state12 = this.state,
            activeCoordinate = _this$state12.activeCoordinate,
            offset = _this$state12.offset,
            tooltipAxisBandSize = _this$state12.tooltipAxisBandSize;
        var halfSize = tooltipAxisBandSize / 2;
        return {
          stroke: 'none',
          fill: '#ccc',
          x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
          y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
          width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
          height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
        };
      }
    }, {
      key: "getCursorPoints",
      value: function getCursorPoints() {
        var layout = this.props.layout;
        var _this$state13 = this.state,
            activeCoordinate = _this$state13.activeCoordinate,
            offset = _this$state13.offset;
        var x1, y1, x2, y2;

        if (layout === 'horizontal') {
          x1 = activeCoordinate.x;
          x2 = x1;
          y1 = offset.top;
          y2 = offset.top + offset.height;
        } else if (layout === 'vertical') {
          y1 = activeCoordinate.y;
          y2 = y1;
          x1 = offset.left;
          x2 = offset.left + offset.width;
        } else if (!__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(activeCoordinate.cx) || !__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(activeCoordinate.cy)) {
          if (layout === 'centric') {
            var cx = activeCoordinate.cx,
                cy = activeCoordinate.cy,
                innerRadius = activeCoordinate.innerRadius,
                outerRadius = activeCoordinate.outerRadius,
                angle = activeCoordinate.angle;
            var innerPoint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, innerRadius, angle);
            var outerPoint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, outerRadius, angle);
            x1 = innerPoint.x;
            y1 = innerPoint.y;
            x2 = outerPoint.x;
            y2 = outerPoint.y;
          } else {
            var _cx = activeCoordinate.cx,
                _cy = activeCoordinate.cy,
                radius = activeCoordinate.radius,
                startAngle = activeCoordinate.startAngle,
                endAngle = activeCoordinate.endAngle;
            var startPoint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__util_PolarUtils__["a" /* polarToCartesian */])(_cx, _cy, radius, startAngle);
            var endPoint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__util_PolarUtils__["a" /* polarToCartesian */])(_cx, _cy, radius, endAngle);
            return {
              points: [startPoint, endPoint],
              cx: _cx,
              cy: _cy,
              radius: radius,
              startAngle: startAngle,
              endAngle: endAngle
            };
          }
        }

        return [{
          x: x1,
          y: y1
        }, {
          x: x2,
          y: y2
        }];
      }
    }, {
      key: "calculateTooltipPos",
      value: function calculateTooltipPos(rangeObj) {
        var layout = this.props.layout;

        if (layout === 'horizontal') {
          return rangeObj.x;
        }

        if (layout === 'vertical') {
          return rangeObj.y;
        }

        if (layout === 'centric') {
          return rangeObj.angle;
        }

        return rangeObj.radius;
      }
    }, {
      key: "inRange",
      value: function inRange(x, y) {
        var layout = this.props.layout;

        if (layout === 'horizontal' || layout === 'vertical') {
          var offset = this.state.offset;
          var isInRange = x >= offset.left && x <= offset.left + offset.width && y >= offset.top && y <= offset.top + offset.height;
          return isInRange ? {
            x: x,
            y: y
          } : null;
        }

        var _this$state14 = this.state,
            angleAxisMap = _this$state14.angleAxisMap,
            radiusAxisMap = _this$state14.radiusAxisMap;

        if (angleAxisMap && radiusAxisMap) {
          var angleAxis = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["i" /* getAnyElementOfObject */])(angleAxisMap);
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_26__util_PolarUtils__["b" /* inRangeOfSector */])({
            x: x,
            y: y
          }, angleAxis);
        }

        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function parseEventsOfWrapper() {
        var children = this.props.children;
        var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["j" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_12__component_Tooltip__["a" /* default */]);
        var tooltipEvents = tooltipItem && eventType === 'axis' ? {
          onMouseEnter: this.handleMouseEnter,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd
        } : {};
        var outerEvents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["b" /* filterEventAttributes */])(this.props, this.handleOuterEvent);
        return _objectSpread({}, outerEvents, {}, tooltipEvents);
      }
      /**
       * The AxisMaps are expensive to render on large data sets
       * so provide the ability to store them in state and only update them when necessary
       * they are dependent upon the start and end index of
       * the brush so it's important that this method is called _after_
       * the state is updated with any new start/end indices
       *
       * @param {Object} props          The props object to be used for updating the axismaps
       * @param {Number} dataStartIndex The start index of the data series when a brush is applied
       * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
       * @param {Number} updateId       The update id
       * @return {Object} state New state to set
       */

    }, {
      key: "updateStateOfAxisMapsOffsetAndStackGroups",
      value: function updateStateOfAxisMapsOffsetAndStackGroups(_ref8) {
        var _this5 = this;

        var props = _ref8.props,
            dataStartIndex = _ref8.dataStartIndex,
            dataEndIndex = _ref8.dataEndIndex,
            updateId = _ref8.updateId;

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["o" /* validateWidthHeight */])({
          props: props
        })) {
          return null;
        }

        var children = props.children,
            layout = props.layout,
            stackOffset = props.stackOffset,
            data = props.data,
            reverseStackOrder = props.reverseStackOrder;

        var _this$constructor$get2 = this.constructor.getAxisNameByLayout(layout),
            numericAxisName = _this$constructor$get2.numericAxisName,
            cateAxisName = _this$constructor$get2.cateAxisName;

        var graphicalItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["i" /* findAllByType */])(children, GraphicalChild);
        var stackGroups = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["u" /* getStackGroupsByAxisId */])(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function (result, entry) {
          var name = "".concat(entry.axisType, "Map");
          return _objectSpread({}, result, _defineProperty({}, name, _this5.getAxisMap(props, _objectSpread({}, entry, {
            graphicalItems: graphicalItems,
            stackGroups: entry.axisType === numericAxisName && stackGroups,
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
          }))));
        }, {});
        var offset = this.calculateOffset(_objectSpread({}, axisObj, {
          props: props,
          graphicalItems: graphicalItems
        }));
        Object.keys(axisObj).forEach(function (key) {
          axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace('Map', ''), chartName);
        });
        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
        var ticksObj = this.tooltipTicksGenerator(cateAxisMap);
        var formatedGraphicalItems = this.getFormatItems(props, _objectSpread({}, axisObj, {
          dataStartIndex: dataStartIndex,
          dataEndIndex: dataEndIndex,
          updateId: updateId,
          graphicalItems: graphicalItems,
          stackGroups: stackGroups,
          offset: offset
        }));
        return _objectSpread({
          formatedGraphicalItems: formatedGraphicalItems,
          graphicalItems: graphicalItems,
          offset: offset,
          stackGroups: stackGroups
        }, ticksObj, {}, axisObj);
      }
      /* eslint-disable  no-underscore-dangle */

    }, {
      key: "addListener",
      value: function addListener() {
        __WEBPACK_IMPORTED_MODULE_28__util_Events__["a" /* eventCenter */].on(__WEBPACK_IMPORTED_MODULE_28__util_Events__["b" /* SYNC_EVENT */], this.handleReceiveSyncEvent);

        if (__WEBPACK_IMPORTED_MODULE_28__util_Events__["a" /* eventCenter */].setMaxListeners && __WEBPACK_IMPORTED_MODULE_28__util_Events__["a" /* eventCenter */]._maxListeners) {
          __WEBPACK_IMPORTED_MODULE_28__util_Events__["a" /* eventCenter */].setMaxListeners(__WEBPACK_IMPORTED_MODULE_28__util_Events__["a" /* eventCenter */]._maxListeners + 1);
        }
      }
    }, {
      key: "removeListener",
      value: function removeListener() {
        __WEBPACK_IMPORTED_MODULE_28__util_Events__["a" /* eventCenter */].removeListener(__WEBPACK_IMPORTED_MODULE_28__util_Events__["b" /* SYNC_EVENT */], this.handleReceiveSyncEvent);

        if (__WEBPACK_IMPORTED_MODULE_28__util_Events__["a" /* eventCenter */].setMaxListeners && __WEBPACK_IMPORTED_MODULE_28__util_Events__["a" /* eventCenter */]._maxListeners) {
          __WEBPACK_IMPORTED_MODULE_28__util_Events__["a" /* eventCenter */].setMaxListeners(__WEBPACK_IMPORTED_MODULE_28__util_Events__["a" /* eventCenter */]._maxListeners - 1);
        }
      }
      /**
       * Calculate the offset of main part in the svg element
       * @param  {Object} props          Latest props
       * @param  {Array}  graphicalItems The instances of item
       * @param  {Object} xAxisMap       The configuration of x-axis
       * @param  {Object} yAxisMap       The configuration of y-axis
       * @return {Object} The offset of main part in the svg element
       */

    }, {
      key: "calculateOffset",
      value: function calculateOffset(_ref9) {
        var props = _ref9.props,
            graphicalItems = _ref9.graphicalItems,
            _ref9$xAxisMap = _ref9.xAxisMap,
            xAxisMap = _ref9$xAxisMap === void 0 ? {} : _ref9$xAxisMap,
            _ref9$yAxisMap = _ref9.yAxisMap,
            yAxisMap = _ref9$yAxisMap === void 0 ? {} : _ref9$yAxisMap;
        var width = props.width,
            height = props.height,
            children = props.children;
        var margin = props.margin || {};
        var brushItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["j" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_21__cartesian_Brush__["a" /* default */]);
        var legendItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["j" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_13__component_Legend__["a" /* default */]);
        var offsetH = Object.keys(yAxisMap).reduce(function (result, id) {
          var entry = yAxisMap[id];
          var orientation = entry.orientation;

          if (!entry.mirror && !entry.hide) {
            return _objectSpread({}, result, _defineProperty({}, orientation, result[orientation] + entry.width));
          }

          return result;
        }, {
          left: margin.left || 0,
          right: margin.right || 0
        });
        var offsetV = Object.keys(xAxisMap).reduce(function (result, id) {
          var entry = xAxisMap[id];
          var orientation = entry.orientation;

          if (!entry.mirror && !entry.hide) {
            return _objectSpread({}, result, _defineProperty({}, orientation, result[orientation] + entry.height));
          }

          return result;
        }, {
          top: margin.top || 0,
          bottom: margin.bottom || 0
        });

        var offset = _objectSpread({}, offsetV, {}, offsetH);

        var brushBottom = offset.bottom;

        if (brushItem) {
          offset.bottom += brushItem.props.height || __WEBPACK_IMPORTED_MODULE_21__cartesian_Brush__["a" /* default */].defaultProps.height;
        }

        if (legendItem && this.legendInstance) {
          var legendBox = this.legendInstance.getBBox();
          offset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["v" /* appendOffsetOfLegend */])(offset, graphicalItems, props, legendBox);
        }

        return _objectSpread({
          brushBottom: brushBottom
        }, offset, {
          width: width - offset.left - offset.right,
          height: height - offset.top - offset.bottom
        });
      }
    }, {
      key: "triggerSyncEvent",
      value: function triggerSyncEvent(data) {
        var syncId = this.props.syncId;

        if (!__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(syncId)) {
          __WEBPACK_IMPORTED_MODULE_28__util_Events__["a" /* eventCenter */].emit(__WEBPACK_IMPORTED_MODULE_28__util_Events__["b" /* SYNC_EVENT */], syncId, this.uniqueChartId, data);
        }
      }
    }, {
      key: "filterFormatItem",
      value: function filterFormatItem(item, displayName, childIndex) {
        var formatedGraphicalItems = this.state.formatedGraphicalItems;

        for (var i = 0, len = formatedGraphicalItems.length; i < len; i++) {
          var entry = formatedGraphicalItems[i];

          if (entry.item === item || entry.props.key === item.key || displayName === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["k" /* getDisplayName */])(entry.item.type) && childIndex === entry.childIndex) {
            return entry;
          }
        }

        return null;
      }
    }, {
      key: "renderAxis",

      /**
       * Draw axis
       * @param {Object} axisOptions The options of axis
       * @param {Object} element      The axis element
       * @param {String} displayName  The display name of axis
       * @param {Number} index        The index of element
       * @return {ReactElement}       The instance of x-axes
       */
      value: function renderAxis(axisOptions, element, displayName, index) {
        var _this$props5 = this.props,
            width = _this$props5.width,
            height = _this$props5.height;
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__cartesian_CartesianAxis__["a" /* default */], _extends({}, axisOptions, {
          className: "recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType),
          key: element.key || "".concat(displayName, "-").concat(index),
          viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
          },
          ticksGenerator: this.axesTicksGenerator
        }));
      }
      /**
       * Draw grid
       * @param  {ReactElement} element the grid item
       * @return {ReactElement} The instance of grid
       */

    }, {
      key: "renderLegend",

      /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */
      value: function renderLegend() {
        var _this6 = this;

        var formatedGraphicalItems = this.state.formatedGraphicalItems;
        var _this$props6 = this.props,
            children = _this$props6.children,
            width = _this$props6.width,
            height = _this$props6.height;
        var margin = this.props.margin || {};
        var legendWidth = width - (margin.left || 0) - (margin.right || 0);
        var legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
        var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["w" /* getLegendProps */])({
          children: children,
          formatedGraphicalItems: formatedGraphicalItems,
          legendWidth: legendWidth,
          legendHeight: legendHeight,
          legendContent: legendContent
        });

        if (!props) {
          return null;
        }

        var item = props.item,
            otherProps = _objectWithoutProperties(props, ["item"]);

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(item, _objectSpread({}, otherProps, {
          chartWidth: width,
          chartHeight: height,
          margin: margin,
          ref: function ref(legend) {
            _this6.legendInstance = legend;
          },
          onBBoxUpdate: this.handleLegendBBoxUpdate
        }));
      }
      /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */

    }, {
      key: "renderTooltip",
      value: function renderTooltip() {
        var children = this.props.children;
        var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["j" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_12__component_Tooltip__["a" /* default */]);

        if (!tooltipItem) {
          return null;
        }

        var _this$state15 = this.state,
            isTooltipActive = _this$state15.isTooltipActive,
            activeCoordinate = _this$state15.activeCoordinate,
            activePayload = _this$state15.activePayload,
            activeLabel = _this$state15.activeLabel,
            offset = _this$state15.offset;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(tooltipItem, {
          viewBox: _objectSpread({}, offset, {
            x: offset.left,
            y: offset.top
          }),
          active: isTooltipActive,
          label: activeLabel,
          payload: isTooltipActive ? activePayload : [],
          coordinate: activeCoordinate
        });
      }
    }, {
      key: "renderActivePoints",
      value: function renderActivePoints(_ref10) {
        var item = _ref10.item,
            activePoint = _ref10.activePoint,
            basePoint = _ref10.basePoint,
            childIndex = _ref10.childIndex,
            isRange = _ref10.isRange;
        var result = [];
        var key = item.props.key;
        var _item$item$props2 = item.item.props,
            activeDot = _item$item$props2.activeDot,
            dataKey = _item$item$props2.dataKey;

        var dotProps = _objectSpread({
          index: childIndex,
          dataKey: dataKey,
          cx: activePoint.x,
          cy: activePoint.y,
          r: 4,
          fill: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__util_ChartUtils__["q" /* getMainColorOfGraphicItem */])(item.item),
          strokeWidth: 2,
          stroke: '#fff',
          payload: activePoint.payload,
          value: activePoint.value,
          key: "".concat(key, "-activePoint-").concat(childIndex)
        }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["a" /* getPresentationAttributes */])(activeDot), {}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["b" /* filterEventAttributes */])(activeDot));

        result.push(this.constructor.renderActiveDot(activeDot, dotProps, childIndex));

        if (basePoint) {
          result.push(this.constructor.renderActiveDot(activeDot, _objectSpread({}, dotProps, {
            cx: basePoint.x,
            cy: basePoint.y,
            key: "".concat(key, "-basePoint-").concat(childIndex)
          }), childIndex));
        } else if (isRange) {
          result.push(null);
        }

        return result;
      }
    }, {
      key: "renderClipPath",
      value: function renderClipPath() {
        var clipPathId = this.clipPathId;
        var _this$state$offset = this.state.offset,
            left = _this$state$offset.left,
            top = _this$state$offset.top,
            height = _this$state$offset.height,
            width = _this$state$offset.width;
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("defs", null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("clipPath", {
          id: clipPathId
        }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("rect", {
          x: left,
          y: top,
          height: height,
          width: width
        })));
      }
    }, {
      key: "render",
      value: function render() {
        var _this7 = this;

        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["o" /* validateWidthHeight */])(this)) {
          return null;
        }

        var _this$props7 = this.props,
            children = _this$props7.children,
            className = _this$props7.className,
            width = _this$props7.width,
            height = _this$props7.height,
            style = _this$props7.style,
            compact = _this$props7.compact,
            others = _objectWithoutProperties(_this$props7, ["children", "className", "width", "height", "style", "compact"]);

        var attrs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["a" /* getPresentationAttributes */])(others);
        var map = {
          CartesianGrid: {
            handler: this.renderGrid,
            once: true
          },
          ReferenceArea: {
            handler: this.renderReferenceElement
          },
          ReferenceLine: {
            handler: this.renderReferenceElement
          },
          ReferenceDot: {
            handler: this.renderReferenceElement
          },
          XAxis: {
            handler: this.renderXAxis
          },
          YAxis: {
            handler: this.renderYAxis
          },
          Brush: {
            handler: this.renderBrush,
            once: true
          },
          Bar: {
            handler: this.renderGraphicChild
          },
          Line: {
            handler: this.renderGraphicChild
          },
          Area: {
            handler: this.renderGraphicChild
          },
          Radar: {
            handler: this.renderGraphicChild
          },
          RadialBar: {
            handler: this.renderGraphicChild
          },
          Scatter: {
            handler: this.renderGraphicChild
          },
          Pie: {
            handler: this.renderGraphicChild
          },
          Funnel: {
            handler: this.renderGraphicChild
          },
          Tooltip: {
            handler: this.renderCursor,
            once: true
          },
          PolarGrid: {
            handler: this.renderPolarGrid,
            once: true
          },
          PolarAngleAxis: {
            handler: this.renderPolarAxis
          },
          PolarRadiusAxis: {
            handler: this.renderPolarAxis
          },
          Customized: {
            handler: this.renderCustomized
          }
        }; // The "compact" mode is mainly used as the panorama within Brush

        if (compact) {
          return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__container_Surface__["a" /* default */], _extends({}, attrs, {
            width: width,
            height: height
          }), this.renderClipPath(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["p" /* renderByOrder */])(children, map));
        }

        var events = this.parseEventsOfWrapper();
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div", _extends({
          className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()('recharts-wrapper', className),
          style: _objectSpread({
            position: 'relative',
            cursor: 'default',
            width: width,
            height: height
          }, style)
        }, events, {
          ref: function ref(node) {
            _this7.container = node;
          }
        }), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__container_Surface__["a" /* default */], _extends({}, attrs, {
          width: width,
          height: height
        }), this.renderClipPath(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["p" /* renderByOrder */])(children, map)), this.renderLegend(), this.renderTooltip());
      }
    }], [{
      key: "getAxisNameByLayout",
      value: function getAxisNameByLayout(layout) {
        if (layout === 'horizontal') {
          return {
            numericAxisName: 'yAxis',
            cateAxisName: 'xAxis'
          };
        }

        if (layout === 'vertical') {
          return {
            numericAxisName: 'xAxis',
            cateAxisName: 'yAxis'
          };
        }

        if (layout === 'centric') {
          return {
            numericAxisName: 'radiusAxis',
            cateAxisName: 'angleAxis'
          };
        }

        return {
          numericAxisName: 'angleAxis',
          cateAxisName: 'radiusAxis'
        };
      }
    }, {
      key: "renderActiveDot",
      value: function renderActiveDot(option, props) {
        var dot;

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["isValidElement"])(option)) {
          dot = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(option, props);
        } else if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(option)) {
          dot = option(props);
        } else {
          dot = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__shape_Dot__["a" /* default */], props);
        }

        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__container_Layer__["a" /* default */], {
          className: "recharts-active-dot",
          key: props.key
        }, dot);
      }
    }]);

    return CategoricalChartWrapper;
  }(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

  CategoricalChartWrapper.displayName = chartName;
  CategoricalChartWrapper.propTypes = _objectSpread({
    syncId: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number]),
    compact: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
    width: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
    data: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object),
    layout: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['horizontal', 'vertical']),
    stackOffset: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['sign', 'expand', 'none', 'wiggle', 'silhouette']),
    throttleDelay: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
    margin: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
      top: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
      right: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
      bottom: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
      left: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number
    }),
    barCategoryGap: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string]),
    barGap: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string]),
    barSize: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string]),
    maxBarSize: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
    style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
    className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
    children: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node]),
    defaultShowTooltip: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
    onClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onMouseLeave: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onMouseEnter: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onMouseMove: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onMouseDown: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    onMouseUp: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    reverseStackOrder: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
    id: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
  }, propTypes);
  CategoricalChartWrapper.defaultProps = _objectSpread({
    layout: 'horizontal',
    stackOffset: 'none',
    barCategoryGap: '10%',
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: false
  }, defaultProps);

  CategoricalChartWrapper.createDefaultState = function (props) {
    var children = props.children,
        defaultShowTooltip = props.defaultShowTooltip;
    var brushItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["j" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_21__cartesian_Brush__["a" /* default */]);
    var startIndex = brushItem && brushItem.props && brushItem.props.startIndex || 0;
    var endIndex = brushItem && brushItem.props && brushItem.props.endIndex || props.data && props.data.length - 1 || 0;
    return {
      chartX: 0,
      chartY: 0,
      dataStartIndex: startIndex,
      dataEndIndex: endIndex,
      activeTooltipIndex: -1,
      isTooltipActive: !__WEBPACK_IMPORTED_MODULE_6_lodash_isNil___default()(defaultShowTooltip) ? defaultShowTooltip : false
    };
  };

  CategoricalChartWrapper.hasBar = function (graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) {
      return false;
    }

    return graphicalItems.some(function (item) {
      var name = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ReactUtils__["k" /* getDisplayName */])(item && item.type);
      return name && name.indexOf('Bar') >= 0;
    });
  };

  CategoricalChartWrapper.getDisplayedData = function (props, _ref11, item) {
    var graphicalItems = _ref11.graphicalItems,
        dataStartIndex = _ref11.dataStartIndex,
        dataEndIndex = _ref11.dataEndIndex;
    var itemsData = (graphicalItems || []).reduce(function (result, child) {
      var itemData = child.props.data;

      if (itemData && itemData.length) {
        return [].concat(_toConsumableArray(result), _toConsumableArray(itemData));
      }

      return result;
    }, []);

    if (itemsData && itemsData.length > 0) {
      return itemsData;
    }

    if (item && item.props && item.props.data && item.props.data.length > 0) {
      return item.props.data;
    }

    var data = props.data;

    if (data && data.length && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["a" /* isNumber */])(dataStartIndex) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__util_DataUtils__["a" /* isNumber */])(dataEndIndex)) {
      return data.slice(dataStartIndex, dataEndIndex + 1);
    }

    return [];
  };

  return CategoricalChartWrapper;
};

/* harmony default export */ __webpack_exports__["a"] = (generateCategoricalChart);

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isObject__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_last__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isArray__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Label__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__container_Layer__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_ChartUtils__ = __webpack_require__(44);






function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var propTypes = {
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  data: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object),
  valueAccessor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  clockWise: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  dataKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func])
};
var defaultProps = {
  valueAccessor: function valueAccessor(entry) {
    return __WEBPACK_IMPORTED_MODULE_4_lodash_isArray___default()(entry.value) ? __WEBPACK_IMPORTED_MODULE_3_lodash_last___default()(entry.value) : entry.value;
  }
};

function LabelList(props) {
  var data = props.data,
      valueAccessor = props.valueAccessor,
      dataKey = props.dataKey,
      clockWise = props.clockWise,
      id = props.id,
      others = _objectWithoutProperties(props, ["data", "valueAccessor", "dataKey", "clockWise", "id"]);

  if (!data || !data.length) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */], {
    className: "recharts-label-list"
  }, data.map(function (entry, index) {
    var value = __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(dataKey) ? valueAccessor(entry, index) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_ChartUtils__["a" /* getValueByDataKey */])(entry && entry.payload, dataKey);
    var idProps = __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(id) ? {} : {
      id: "".concat(id, "-").concat(index)
    };
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Label__["a" /* default */], _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["a" /* getPresentationAttributes */])(entry), others, idProps, {
      index: index,
      value: value,
      viewBox: __WEBPACK_IMPORTED_MODULE_7__Label__["a" /* default */].parseViewBox(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(clockWise) ? entry : _objectSpread({}, entry, {
        clockWise: clockWise
      })),
      key: "label-".concat(index) // eslint-disable-line react/no-array-index-key

    }));
  }));
}

LabelList.propTypes = propTypes;
LabelList.displayName = 'LabelList';

var parseLabelList = function parseLabelList(label, data) {
  if (!label) {
    return null;
  }

  if (label === true) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LabelList, {
      key: "labelList-implicit",
      data: data
    });
  }

  if (__WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(label) || __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(label)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LabelList, {
      key: "labelList-implicit",
      data: data,
      content: label
    });
  }

  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isObject___default()(label)) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(LabelList, _extends({
      data: data
    }, label, {
      key: "labelList-implicit"
    }));
  }

  return null;
};

var renderCallByParent = function renderCallByParent(parentProps, data) {
  var ckeckPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (!parentProps || !parentProps.children && ckeckPropsLabel && !parentProps.label) {
    return null;
  }

  var children = parentProps.children;
  var explicitChilren = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["i" /* findAllByType */])(children, LabelList).map(function (child, index) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(child, {
      data: data,
      key: "labelList-".concat(index)
    });
  });

  if (!ckeckPropsLabel) {
    return explicitChilren;
  }

  var implicitLabelList = parseLabelList(parentProps.label, data);
  return [implicitLabelList].concat(_toConsumableArray(explicitChilren));
};

LabelList.renderCallByParent = renderCallByParent;
LabelList.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (LabelList);

/***/ }),
/* 76 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(373);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule PooledClass
 */



var _prodInvariant = __webpack_require__(25);

var invariant = __webpack_require__(17);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4, a5);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4, a5);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler,
  fiveArgumentPooler: fiveArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactCurrentOwner
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */

var ReactCurrentOwner = {

  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null

};

module.exports = ReactCurrentOwner;

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__ = __webpack_require__(16);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var LogbookSignatureModal = function (_Component) {
  _inherits(LogbookSignatureModal, _Component);

  function LogbookSignatureModal(props) {
    _classCallCheck(this, LogbookSignatureModal);

    var _this = _possibleConstructorReturn(this, (LogbookSignatureModal.__proto__ || Object.getPrototypeOf(LogbookSignatureModal)).call(this, props));

    _this.state = {
      email: '',
      password: '',
      showPassword: false,
      errors: {}
    };

    _this.handleChange = _this.handleChange.bind(_this);
    _this.toggleShowPassword = _this.toggleShowPassword.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }

  _createClass(LogbookSignatureModal, [{
    key: 'handleChange',
    value: function handleChange(e) {
      this.setState(_defineProperty({}, e.target.name, e.target.value));
    }
  }, {
    key: 'toggleShowPassword',
    value: function toggleShowPassword() {
      this.setState({ showPassword: !this.state.showPassword });
    }
  }, {
    key: 'validateEmail',
    value: function validateEmail(email) {
      // Expressão regular básica para validar e‑mail
      var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();
      var _state = this.state,
          email = _state.email,
          password = _state.password;

      var errors = {};

      if (!email) {
        errors.email = "Email is required";
      } else if (!this.validateEmail(email)) {
        errors.email = "Invalid email format";
      }
      if (!password) {
        errors.password = "Password is required";
      }

      if (Object.keys(errors).length > 0) {
        this.setState({ errors: errors });
        return;
      }

      // Chama o callback do pai enviando as credenciais
      if (this.props.onSubmit) {
        this.props.onSubmit({ email: email, password: password });
      }
      // Limpa o formulário e fecha o modal
      this.setState({ email: '', password: '', errors: {}, showPassword: false });
      this.props.onHide();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          show = _props.show,
          onHide = _props.onHide,
          title = _props.title,
          subtitle = _props.subtitle,
          confirmation = _props.confirmation;
      var _state2 = this.state,
          email = _state2.email,
          password = _state2.password,
          showPassword = _state2.showPassword,
          errors = _state2.errors;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["g" /* Modal */],
        { show: show, onHide: onHide, 'aria-labelledby': 'logbook-signature-modal-title' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["g" /* Modal */].Header,
          { closeButton: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["g" /* Modal */].Title,
            { id: 'logbook-signature-modal-title' },
            title
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          subtitle && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            subtitle
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["g" /* Modal */].Body,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["j" /* Form */],
            { onSubmit: this.handleSubmit },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["k" /* FormGroup */],
              { controlId: 'formEmail', validationState: errors.email ? 'error' : null },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["l" /* ControlLabel */],
                null,
                'Email'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["m" /* FormControl */], {
                type: 'email',
                name: 'email',
                value: email,
                placeholder: 'Informe seu email do Logbook',
                onChange: this.handleChange
              }),
              errors.email && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'help-block', style: { color: 'red' } },
                errors.email
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["k" /* FormGroup */],
              { controlId: 'formPassword', validationState: errors.password ? 'error' : null },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["l" /* ControlLabel */],
                null,
                'Senha'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["n" /* InputGroup */],
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["m" /* FormControl */], {
                  type: showPassword ? "text" : "password",
                  name: 'password',
                  value: password,
                  placeholder: 'Informe sua senha do Logbook',
                  onChange: this.handleChange
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["n" /* InputGroup */].Button,
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["o" /* Button */],
                    { type: 'button', onClick: this.toggleShowPassword },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["p" /* Glyphicon */], { glyph: showPassword ? "eye-close" : "eye-open" })
                  )
                )
              ),
              errors.password && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'help-block', style: { color: 'red' } },
                errors.password
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["o" /* Button */],
              { type: 'submit', bsStyle: 'primary', block: true },
              confirmation
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["g" /* Modal */].Footer,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_2_react_bootstrap__["o" /* Button */],
            { bsStyle: 'danger', onClick: onHide },
            'Cancelar'
          )
        )
      );
    }
  }]);

  return LogbookSignatureModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

LogbookSignatureModal.propTypes = {
  show: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool.isRequired,
  onHide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  onSubmit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  title: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  subtitle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  confirmation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
};

LogbookSignatureModal.defaultProps = {
  title: "Tem certeza que deseja integrar com o Logbook App?",
  subtitle: "Ao confirmar sua assinatura digital será afixada a este registro e ficará visível para todos os usuários do sistema.",
  confirmation: "Confirmo que estou ciente e desejo prosseguir com a assinatura"
};

/* harmony default export */ __webpack_exports__["a"] = (LogbookSignatureModal);

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(82);
var core = __webpack_require__(60);
var ctx = __webpack_require__(275);
var hide = __webpack_require__(114);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 82 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = identity;
/* harmony export (immutable) */ __webpack_exports__["c"] = copy;
/* harmony export (immutable) */ __webpack_exports__["b"] = transformer;
/* harmony export (immutable) */ __webpack_exports__["d"] = continuous;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(479);






var unit = [0, 1];

function identity(x) {
  return x;
}

function normalize(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(isNaN(b) ? NaN : 0.5);
}

function clamper(domain) {
  var a = domain[0], b = domain[domain.length - 1], t;
  if (a > b) t = a, a = b, b = t;
  return function(x) { return Math.max(a, Math.min(b, x)); };
}

// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
  else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, interpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = normalize(domain[i], domain[i + 1]);
    r[i] = interpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp())
      .unknown(source.unknown());
}

function transformer() {
  var domain = unit,
      range = unit,
      interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["a" /* interpolate */],
      transform,
      untransform,
      unknown,
      clamp = identity,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
  }

  scale.invert = function(y) {
    return clamp(untransform((input || (input = piecewise(range, domain.map(transform), __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["b" /* interpolateNumber */])))(y)));
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_2__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]), clamp === identity || (clamp = clamper(domain)), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["c" /* interpolateRound */], rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = _ ? clamper(domain) : identity, scale) : clamp !== identity;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function(t, u) {
    transform = t, untransform = u;
    return rescale();
  };
}

function continuous(transform, untransform) {
  return transformer()(transform, untransform);
}


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * Allows extraction of a minified key. Let's the build system minify keys
 * without losing the ability to dynamically use key strings as values
 * themselves. Pass in an object with a single key/val pair and it will return
 * you the string key of that single record. Suppose you want to grab the
 * value for a key 'className' inside of an object. Key/val minification may
 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
 * reuse those resolutions.
 */
var keyOf = function keyOf(oneKeyObj) {
  var key;
  for (key in oneKeyObj) {
    if (!oneKeyObj.hasOwnProperty(key)) {
      continue;
    }
    return key;
  }
  return null;
};

module.exports = keyOf;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(122),
    getRawTag = __webpack_require__(1233),
    objectToString = __webpack_require__(1261);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Const = __webpack_require__(35);

var _Const2 = _interopRequireDefault(_Const);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  renderReactSortCaret: function renderReactSortCaret(order) {
    var orderClass = (0, _classnames2.default)('order', {
      'dropup': order === _Const2.default.SORT_ASC
    });
    return _react2.default.createElement(
      'span',
      { className: orderClass },
      _react2.default.createElement('span', { className: 'caret', style: { margin: '10px 5px' } })
    );
  },
  isFunction: function isFunction(obj) {
    return obj && typeof obj === 'function';
  },
  getScrollBarWidth: function getScrollBarWidth() {
    var inner = document.createElement('p');
    inner.style.width = '100%';
    inner.style.height = '200px';

    var outer = document.createElement('div');
    outer.style.position = 'absolute';
    outer.style.top = '0px';
    outer.style.left = '0px';
    outer.style.visibility = 'hidden';
    outer.style.width = '200px';
    outer.style.height = '150px';
    outer.style.overflow = 'hidden';
    outer.appendChild(inner);

    document.body.appendChild(outer);
    var w1 = inner.getBoundingClientRect().width;
    outer.style.overflow = 'scroll';
    var w2 = inner.getBoundingClientRect().width;

    if (w1 === w2) w2 = outer.clientWidth;

    document.body.removeChild(outer);

    return w1 - w2;
  },
  canUseDOM: function canUseDOM() {
    return typeof window !== 'undefined' && typeof window.document !== 'undefined';
  },


  // We calculate an offset here in order to properly fetch the indexed data,
  // despite the page start index not always being 1
  getNormalizedPage: function getNormalizedPage(pageStartIndex, page) {
    pageStartIndex = this.getFirstPage(pageStartIndex);
    if (page === undefined) page = pageStartIndex;
    var offset = Math.abs(_Const2.default.PAGE_START_INDEX - pageStartIndex);
    return page + offset;
  },
  getFirstPage: function getFirstPage(pageStartIndex) {
    return pageStartIndex !== undefined ? pageStartIndex : _Const2.default.PAGE_START_INDEX;
  },
  renderColGroup: function renderColGroup(columns, selectRow) {
    var expandColumnOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    var selectRowHeader = null;
    var expandRowHeader = null;
    var isSelectRowDefined = selectRow.mode === _Const2.default.ROW_SELECT_SINGLE || selectRow.mode === _Const2.default.ROW_SELECT_MULTI;
    if (isSelectRowDefined) {
      var style = {
        width: selectRow.columnWidth || '30px',
        minWidth: selectRow.columnWidth || '30px'
      };
      if (!selectRow.hideSelectColumn) {
        selectRowHeader = _react2.default.createElement('col', { key: 'select-col', style: style });
      }
    }
    if (expandColumnOptions.expandColumnVisible) {
      var _style = {
        width: expandColumnOptions.columnWidth || 30,
        minWidth: expandColumnOptions.columnWidth || 30
      };
      expandRowHeader = _react2.default.createElement('col', { key: 'expand-col', style: _style });
    }
    var theader = columns.map(function (column, i) {
      var style = {
        display: column.hidden ? 'none' : null
      };
      if (column.width) {
        var width = !isNaN(column.width) ? column.width + 'px' : column.width;
        style.width = width;
        /** add min-wdth to fix user assign column width
        not eq offsetWidth in large column table **/
        style.minWidth = width;
      }
      return _react2.default.createElement('col', { style: style, key: i, className: column.className });
    });

    return _react2.default.createElement(
      'colgroup',
      null,
      expandColumnOptions.expandColumnVisible && expandColumnOptions.expandColumnBeforeSelectColumn && expandRowHeader,
      selectRowHeader,
      expandColumnOptions.expandColumnVisible && !expandColumnOptions.expandColumnBeforeSelectColumn && expandRowHeader,
      theader
    );
  }
}; /* eslint react/display-name: 0 */

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/util.js');
}();

;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newDate = newDate;
exports.newDateWithOffset = newDateWithOffset;
exports.now = now;
exports.cloneDate = cloneDate;
exports.parseDate = parseDate;
exports.isMoment = isMoment;
exports.isDate = isDate;
exports.formatDate = formatDate;
exports.safeDateFormat = safeDateFormat;
exports.setTime = setTime;
exports.setMonth = setMonth;
exports.setYear = setYear;
exports.setUTCOffset = setUTCOffset;
exports.getSecond = getSecond;
exports.getMinute = getMinute;
exports.getHour = getHour;
exports.getDay = getDay;
exports.getWeek = getWeek;
exports.getMonth = getMonth;
exports.getYear = getYear;
exports.getDate = getDate;
exports.getUTCOffset = getUTCOffset;
exports.getDayOfWeekCode = getDayOfWeekCode;
exports.getStartOfDay = getStartOfDay;
exports.getStartOfWeek = getStartOfWeek;
exports.getStartOfMonth = getStartOfMonth;
exports.getStartOfDate = getStartOfDate;
exports.getEndOfWeek = getEndOfWeek;
exports.getEndOfMonth = getEndOfMonth;
exports.addMinutes = addMinutes;
exports.addDays = addDays;
exports.addWeeks = addWeeks;
exports.addMonths = addMonths;
exports.addYears = addYears;
exports.subtractDays = subtractDays;
exports.subtractWeeks = subtractWeeks;
exports.subtractMonths = subtractMonths;
exports.subtractYears = subtractYears;
exports.isBefore = isBefore;
exports.isAfter = isAfter;
exports.equals = equals;
exports.isSameMonth = isSameMonth;
exports.isSameDay = isSameDay;
exports.isSameUtcOffset = isSameUtcOffset;
exports.isDayInRange = isDayInRange;
exports.getDaysDiff = getDaysDiff;
exports.localizeDate = localizeDate;
exports.getDefaultLocale = getDefaultLocale;
exports.getDefaultLocaleData = getDefaultLocaleData;
exports.registerLocale = registerLocale;
exports.getLocaleData = getLocaleData;
exports.getLocaleDataForLocale = getLocaleDataForLocale;
exports.getWeekdayMinInLocale = getWeekdayMinInLocale;
exports.getWeekdayShortInLocale = getWeekdayShortInLocale;
exports.getMonthInLocale = getMonthInLocale;
exports.isDayDisabled = isDayDisabled;
exports.isTimeDisabled = isTimeDisabled;
exports.isTimeInDisabledRange = isTimeInDisabledRange;
exports.allDaysDisabledBefore = allDaysDisabledBefore;
exports.allDaysDisabledAfter = allDaysDisabledAfter;
exports.getEffectiveMinDate = getEffectiveMinDate;
exports.getEffectiveMaxDate = getEffectiveMaxDate;

var _moment = __webpack_require__(24);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dayOfWeekCodes = {
  1: 'mon',
  2: 'tue',
  3: 'wed',
  4: 'thu',
  5: 'fri',
  6: 'sat',
  7: 'sun'

  // These functions are not exported so
  // that we avoid magic strings like 'days'
};function set(date, unit, to) {
  return date.set(unit, to);
}

function add(date, amount, unit) {
  return date.add(amount, unit);
}

function subtract(date, amount, unit) {
  return date.subtract(amount, unit);
}

function get(date, unit) {
  return date.get(unit);
}

function getStartOf(date, unit) {
  return date.startOf(unit);
}

function getEndOf(date, unit) {
  return date.endOf(unit);
}

function getDiff(date1, date2, unit) {
  return date1.diff(date2, unit);
}

function isSame(date1, date2, unit) {
  return date1.isSame(date2, unit);
}

// ** Date Constructors **

function newDate(point) {
  return (0, _moment2.default)(point);
}

function newDateWithOffset(utcOffset) {
  return (0, _moment2.default)().utc().utcOffset(utcOffset);
}

function now(maybeFixedUtcOffset) {
  if (maybeFixedUtcOffset == null) {
    return newDate();
  }
  return newDateWithOffset(maybeFixedUtcOffset);
}

function cloneDate(date) {
  return date.clone();
}

function parseDate(value, _ref) {
  var dateFormat = _ref.dateFormat,
      locale = _ref.locale;

  var m = (0, _moment2.default)(value, dateFormat, locale || _moment2.default.locale(), true);
  return m.isValid() ? m : null;
}

// ** Date "Reflection" **

function isMoment(date) {
  return _moment2.default.isMoment(date);
}

function isDate(date) {
  return _moment2.default.isDate(date);
}

// ** Date Formatting **

function formatDate(date, format) {
  return date.format(format);
}

function safeDateFormat(date, _ref2) {
  var dateFormat = _ref2.dateFormat,
      locale = _ref2.locale;

  return date && date.clone().locale(locale || _moment2.default.locale()).format(Array.isArray(dateFormat) ? dateFormat[0] : dateFormat) || '';
}

// ** Date Setters **

function setTime(date, _ref3) {
  var hour = _ref3.hour,
      minute = _ref3.minute,
      second = _ref3.second;

  date.set({ hour: hour, minute: minute, second: second });
  return date;
}

function setMonth(date, month) {
  return set(date, 'month', month);
}

function setYear(date, year) {
  return set(date, 'year', year);
}

function setUTCOffset(date, offset) {
  return date.utcOffset(offset);
}

// ** Date Getters **

function getSecond(date) {
  return get(date, 'second');
}

function getMinute(date) {
  return get(date, 'minute');
}

function getHour(date) {
  return get(date, 'hour');
}

// Returns day of week
function getDay(date) {
  return get(date, 'day');
}

function getWeek(date) {
  return get(date, 'week');
}

function getMonth(date) {
  return get(date, 'month');
}

function getYear(date) {
  return get(date, 'year');
}

// Returns day of month
function getDate(date) {
  return get(date, 'date');
}

function getUTCOffset() {
  return (0, _moment2.default)().utcOffset();
}

function getDayOfWeekCode(day) {
  return dayOfWeekCodes[day.isoWeekday()];
}

// *** Start of ***

function getStartOfDay(date) {
  return getStartOf(date, 'day');
}

function getStartOfWeek(date) {
  return getStartOf(date, 'week');
}
function getStartOfMonth(date) {
  return getStartOf(date, 'month');
}

function getStartOfDate(date) {
  return getStartOf(date, 'date');
}

// *** End of ***

function getEndOfWeek(date) {
  return getEndOf(date, 'week');
}

function getEndOfMonth(date) {
  return getEndOf(date, 'month');
}

// ** Date Math **

// *** Addition ***

function addMinutes(date, amount) {
  return add(date, amount, 'minutes');
}

function addDays(date, amount) {
  return add(date, amount, 'days');
}

function addWeeks(date, amount) {
  return add(date, amount, 'weeks');
}

function addMonths(date, amount) {
  return add(date, amount, 'months');
}

function addYears(date, amount) {
  return add(date, amount, 'years');
}

// *** Subtraction ***
function subtractDays(date, amount) {
  return subtract(date, amount, 'days');
}

function subtractWeeks(date, amount) {
  return subtract(date, amount, 'weeks');
}

function subtractMonths(date, amount) {
  return subtract(date, amount, 'months');
}

function subtractYears(date, amount) {
  return subtract(date, amount, 'years');
}

// ** Date Comparison **

function isBefore(date1, date2) {
  return date1.isBefore(date2);
}

function isAfter(date1, date2) {
  return date1.isAfter(date2);
}

function equals(date1, date2) {
  return date1.isSame(date2);
}

function isSameMonth(date1, date2) {
  return isSame(date1, date2, 'month');
}

function isSameDay(moment1, moment2) {
  if (moment1 && moment2) {
    return moment1.isSame(moment2, 'day');
  } else {
    return !moment1 && !moment2;
  }
}

function isSameUtcOffset(moment1, moment2) {
  if (moment1 && moment2) {
    return moment1.utcOffset() === moment2.utcOffset();
  } else {
    return !moment1 && !moment2;
  }
}

function isDayInRange(day, startDate, endDate) {
  var before = startDate.clone().startOf('day').subtract(1, 'seconds');
  var after = endDate.clone().startOf('day').add(1, 'seconds');
  return day.clone().startOf('day').isBetween(before, after);
}

// *** Diffing ***

function getDaysDiff(date1, date2) {
  return getDiff(date1, date2, 'days');
}

// ** Date Localization **

function localizeDate(date, locale) {
  return date.clone().locale(locale || _moment2.default.locale());
}

function getDefaultLocale() {
  return _moment2.default.locale();
}

function getDefaultLocaleData() {
  return _moment2.default.localeData();
}

function registerLocale(localeName, localeData) {
  _moment2.default.defineLocale(localeName, localeData);
}

function getLocaleData(date) {
  return date.localeData();
}

function getLocaleDataForLocale(locale) {
  return _moment2.default.localeData(locale);
}

function getWeekdayMinInLocale(locale, date) {
  return locale.weekdaysMin(date);
}

function getWeekdayShortInLocale(locale, date) {
  return locale.weekdaysShort(date);
}

// TODO what is this format exactly?
function getMonthInLocale(locale, date, format) {
  return locale.months(date, format);
}

// ** Utils for some components **

function isDayDisabled(day) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      minDate = _ref4.minDate,
      maxDate = _ref4.maxDate,
      excludeDates = _ref4.excludeDates,
      includeDates = _ref4.includeDates,
      filterDate = _ref4.filterDate;

  return minDate && day.isBefore(minDate, 'day') || maxDate && day.isAfter(maxDate, 'day') || excludeDates && excludeDates.some(function (excludeDate) {
    return isSameDay(day, excludeDate);
  }) || includeDates && !includeDates.some(function (includeDate) {
    return isSameDay(day, includeDate);
  }) || filterDate && !filterDate(day.clone()) || false;
}

function isTimeDisabled(time, disabledTimes) {
  var l = disabledTimes.length;
  for (var i = 0; i < l; i++) {
    if (disabledTimes[i].get('hours') === time.get('hours') && disabledTimes[i].get('minutes') === time.get('minutes')) {
      return true;
    }
  }

  return false;
}

function isTimeInDisabledRange(time, _ref5) {
  var minTime = _ref5.minTime,
      maxTime = _ref5.maxTime;

  if (!minTime || !maxTime) {
    throw new Error('Both minTime and maxTime props required');
  }

  var base = (0, _moment2.default)().hours(0).minutes(0).seconds(0);
  var baseTime = base.clone().hours(time.get('hours')).minutes(time.get('minutes'));
  var min = base.clone().hours(minTime.get('hours')).minutes(minTime.get('minutes'));
  var max = base.clone().hours(maxTime.get('hours')).minutes(maxTime.get('minutes'));

  return !(baseTime.isSameOrAfter(min) && baseTime.isSameOrBefore(max));
}

function allDaysDisabledBefore(day, unit) {
  var _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      minDate = _ref6.minDate,
      includeDates = _ref6.includeDates;

  var dateBefore = day.clone().subtract(1, unit);
  return minDate && dateBefore.isBefore(minDate, unit) || includeDates && includeDates.every(function (includeDate) {
    return dateBefore.isBefore(includeDate, unit);
  }) || false;
}

function allDaysDisabledAfter(day, unit) {
  var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      maxDate = _ref7.maxDate,
      includeDates = _ref7.includeDates;

  var dateAfter = day.clone().add(1, unit);
  return maxDate && dateAfter.isAfter(maxDate, unit) || includeDates && includeDates.every(function (includeDate) {
    return dateAfter.isAfter(includeDate, unit);
  }) || false;
}

function getEffectiveMinDate(_ref8) {
  var minDate = _ref8.minDate,
      includeDates = _ref8.includeDates;

  if (includeDates && minDate) {
    return _moment2.default.min(includeDates.filter(function (includeDate) {
      return minDate.isSameOrBefore(includeDate, 'day');
    }));
  } else if (includeDates) {
    return _moment2.default.min(includeDates);
  } else {
    return minDate;
  }
}

function getEffectiveMaxDate(_ref9) {
  var maxDate = _ref9.maxDate,
      includeDates = _ref9.includeDates;

  if (includeDates && maxDate) {
    return _moment2.default.max(includeDates.filter(function (includeDate) {
      return maxDate.isSameOrAfter(includeDate, 'day');
    }));
  } else if (includeDates) {
    return _moment2.default.max(includeDates);
  } else {
    return maxDate;
  }
}


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1521)();
}


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isObject__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Text__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_DataUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__ = __webpack_require__(54);




function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }








var cartesianViewBoxShape = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  x: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number
});
var polarViewBoxShape = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  cx: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  innerRadius: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  outerRadius: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  startAngle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  endAngle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number
});

var propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  viewBox: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([cartesianViewBoxShape, polarViewBoxShape]),
  formatter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string]),
  offset: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  position: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['top', 'left', 'right', 'bottom', 'inside', 'outside', 'insideLeft', 'insideRight', 'insideTop', 'insideBottom', 'insideTopLeft', 'insideBottomLeft', 'insideTopRight', 'insideBottomRight', 'insideStart', 'insideEnd', 'end', 'center', 'centerTop', 'centerBottom']),
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node]),
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  content: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func])
});

var defaultProps = {
  offset: 5
};

var getLabel = function getLabel(props) {
  var value = props.value,
      formatter = props.formatter;
  var label = __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(props.children) ? value : props.children;

  if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(formatter)) {
    return formatter(label);
  }

  return label;
};

var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
  var sign = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["d" /* mathSign */])(endAngle - startAngle);
  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
  return sign * deltaAngle;
};

var renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
  var position = labelProps.position,
      viewBox = labelProps.viewBox,
      offset = labelProps.offset,
      className = labelProps.className;
  var cx = viewBox.cx,
      cy = viewBox.cy,
      innerRadius = viewBox.innerRadius,
      outerRadius = viewBox.outerRadius,
      startAngle = viewBox.startAngle,
      endAngle = viewBox.endAngle,
      clockWise = viewBox.clockWise;
  var radius = (innerRadius + outerRadius) / 2;
  var deltaAngle = getDeltaAngle(startAngle, endAngle);
  var sign = deltaAngle >= 0 ? 1 : -1;
  var labelAngle, direction;

  if (position === 'insideStart') {
    labelAngle = startAngle + sign * offset;
    direction = clockWise;
  } else if (position === 'insideEnd') {
    labelAngle = endAngle - sign * offset;
    direction = !clockWise;
  } else if (position === 'end') {
    labelAngle = endAngle + sign * offset;
    direction = clockWise;
  }

  direction = deltaAngle <= 0 ? direction : !direction;
  var startPoint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, radius, labelAngle);
  var endPoint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
  var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
  var id = __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(labelProps.id) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["f" /* uniqueId */])('recharts-radial-line-') : labelProps.id;
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("text", _extends({}, attrs, {
    dominantBaseline: "central",
    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('recharts-radial-bar-label', className)
  }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("defs", null, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("path", {
    id: id,
    d: path
  })), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("textPath", {
    xlinkHref: "#".concat(id)
  }, label));
};

var getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
  var viewBox = props.viewBox,
      offset = props.offset,
      position = props.position;
  var cx = viewBox.cx,
      cy = viewBox.cy,
      innerRadius = viewBox.innerRadius,
      outerRadius = viewBox.outerRadius,
      startAngle = viewBox.startAngle,
      endAngle = viewBox.endAngle;
  var midAngle = (startAngle + endAngle) / 2;

  if (position === 'outside') {
    var _polarToCartesian = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, outerRadius + offset, midAngle),
        _x = _polarToCartesian.x,
        _y = _polarToCartesian.y;

    return {
      x: _x,
      y: _y,
      textAnchor: _x >= cx ? 'start' : 'end',
      verticalAnchor: 'middle'
    };
  }

  if (position === 'center') {
    return {
      x: cx,
      y: cy,
      textAnchor: 'middle',
      verticalAnchor: 'middle'
    };
  }

  if (position === 'centerTop') {
    return {
      x: cx,
      y: cy,
      textAnchor: 'middle',
      verticalAnchor: 'start'
    };
  }

  if (position === 'centerBottom') {
    return {
      x: cx,
      y: cy,
      textAnchor: 'middle',
      verticalAnchor: 'end'
    };
  }

  var r = (innerRadius + outerRadius) / 2;

  var _polarToCartesian2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, r, midAngle),
      x = _polarToCartesian2.x,
      y = _polarToCartesian2.y;

  return {
    x: x,
    y: y,
    textAnchor: 'middle',
    verticalAnchor: 'middle'
  };
};

var getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
  var viewBox = props.viewBox,
      offset = props.offset,
      position = props.position;
  var x = viewBox.x,
      y = viewBox.y,
      width = viewBox.width,
      height = viewBox.height;
  var sign = height >= 0 ? 1 : -1;

  if (position === 'top') {
    return {
      x: x + width / 2,
      y: y - sign * offset,
      textAnchor: 'middle',
      verticalAnchor: sign > 0 ? 'end' : 'start'
    };
  }

  if (position === 'bottom') {
    return {
      x: x + width / 2,
      y: y + height + sign * offset,
      textAnchor: 'middle',
      verticalAnchor: 'start'
    };
  }

  if (position === 'left') {
    return {
      x: x - offset,
      y: y + height / 2,
      textAnchor: 'end',
      verticalAnchor: 'middle'
    };
  }

  if (position === 'right') {
    return {
      x: x + width + offset,
      y: y + height / 2,
      textAnchor: 'start',
      verticalAnchor: 'middle'
    };
  }

  if (position === 'insideLeft') {
    return {
      x: x + offset,
      y: y + height / 2,
      textAnchor: 'start',
      verticalAnchor: 'middle'
    };
  }

  if (position === 'insideRight') {
    return {
      x: x + width - offset,
      y: y + height / 2,
      textAnchor: 'end',
      verticalAnchor: 'middle'
    };
  }

  if (position === 'insideTop') {
    return {
      x: x + width / 2,
      y: y + sign * offset,
      textAnchor: 'middle',
      verticalAnchor: 'start'
    };
  }

  if (position === 'insideBottom') {
    return {
      x: x + width / 2,
      y: y + height - sign * offset,
      textAnchor: 'middle',
      verticalAnchor: 'end'
    };
  }

  if (position === 'insideTopLeft') {
    return {
      x: x + offset,
      y: y + sign * offset,
      textAnchor: 'start',
      verticalAnchor: 'start'
    };
  }

  if (position === 'insideTopRight') {
    return {
      x: x + width - offset,
      y: y + sign * offset,
      textAnchor: 'end',
      verticalAnchor: 'start'
    };
  }

  if (position === 'insideBottomLeft') {
    return {
      x: x + offset,
      y: y + height - sign * offset,
      textAnchor: 'start',
      verticalAnchor: 'end'
    };
  }

  if (position === 'insideBottomRight') {
    return {
      x: x + width - offset,
      y: y + height - sign * offset,
      textAnchor: 'end',
      verticalAnchor: 'end'
    };
  }

  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isObject___default()(position) && (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["a" /* isNumber */])(position.x) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["h" /* isPercent */])(position.x)) && (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["a" /* isNumber */])(position.y) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["h" /* isPercent */])(position.y))) {
    return {
      x: x + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["e" /* getPercentValue */])(position.x, width),
      y: y + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["e" /* getPercentValue */])(position.y, height),
      textAnchor: 'end',
      verticalAnchor: 'end'
    };
  }

  return {
    x: x + width / 2,
    y: y + height / 2,
    textAnchor: 'middle',
    verticalAnchor: 'middle'
  };
};

var isPolar = function isPolar(viewBox) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["a" /* isNumber */])(viewBox.cx);
};

function Label(props) {
  var viewBox = props.viewBox,
      position = props.position,
      value = props.value,
      children = props.children,
      content = props.content,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className;

  if (!viewBox || __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(value) && __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(children) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"])(content) && !__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(content)) {
    return null;
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"])(content)) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"])(content, props);
  }

  var label;

  if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(content)) {
    label = content(props);

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"])(label)) {
      return label;
    }
  } else {
    label = getLabel(props);
  }

  var isPolarLabel = isPolar(viewBox);
  var attrs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["a" /* getPresentationAttributes */])(props);
  var events = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["b" /* filterEventAttributes */])(props);

  if (isPolarLabel && (position === 'insideStart' || position === 'insideEnd' || position === 'end')) {
    return renderRadialLabel(props, label, attrs);
  }

  var positionAttrs = isPolarLabel ? getAttrsOfPolarLabel(props) : getAttrsOfCartesianLabel(props);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Text__["a" /* default */], _extends({
    className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('recharts-label', className)
  }, attrs, positionAttrs, events), label);
}

Label.displayName = 'Label';
Label.defaultProps = defaultProps;
Label.propTypes = propTypes;

var parseViewBox = function parseViewBox(props) {
  var cx = props.cx,
      cy = props.cy,
      angle = props.angle,
      startAngle = props.startAngle,
      endAngle = props.endAngle,
      r = props.r,
      radius = props.radius,
      innerRadius = props.innerRadius,
      outerRadius = props.outerRadius,
      x = props.x,
      y = props.y,
      top = props.top,
      left = props.left,
      width = props.width,
      height = props.height,
      clockWise = props.clockWise;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["a" /* isNumber */])(width) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["a" /* isNumber */])(height)) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["a" /* isNumber */])(x) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["a" /* isNumber */])(y)) {
      return {
        x: x,
        y: y,
        width: width,
        height: height
      };
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["a" /* isNumber */])(top) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["a" /* isNumber */])(left)) {
      return {
        x: top,
        y: left,
        width: width,
        height: height
      };
    }
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["a" /* isNumber */])(x) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["a" /* isNumber */])(y)) {
    return {
      x: x,
      y: y,
      width: 0,
      height: 0
    };
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["a" /* isNumber */])(cx) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["a" /* isNumber */])(cy)) {
    return {
      cx: cx,
      cy: cy,
      startAngle: startAngle || angle || 0,
      endAngle: endAngle || angle || 0,
      innerRadius: innerRadius || 0,
      outerRadius: outerRadius || radius || r || 0,
      clockWise: clockWise
    };
  }

  if (props.viewBox) {
    return props.viewBox;
  }

  return {};
};

var parseLabel = function parseLabel(label, viewBox) {
  if (!label) {
    return null;
  }

  if (label === true) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Label, {
      key: "label-implicit",
      viewBox: viewBox
    });
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["c" /* isNumOrStr */])(label)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Label, {
      key: "label-implicit",
      viewBox: viewBox,
      value: label
    });
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"])(label)) {
    if (label.type === Label) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"])(label, {
        key: 'label-implicit',
        viewBox: viewBox
      });
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Label, {
      key: "label-implicit",
      content: label,
      viewBox: viewBox
    });
  }

  if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(label)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Label, {
      key: "label-implicit",
      content: label,
      viewBox: viewBox
    });
  }

  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isObject___default()(label)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Label, _extends({
      viewBox: viewBox
    }, label, {
      key: "label-implicit"
    }));
  }

  return null;
};

var renderCallByParent = function renderCallByParent(parentProps, viewBox) {
  var ckeckPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (!parentProps || !parentProps.children && ckeckPropsLabel && !parentProps.label) {
    return null;
  }

  var children = parentProps.children;
  var parentViewBox = parseViewBox(parentProps);
  var explicitChilren = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["i" /* findAllByType */])(children, Label).map(function (child, index) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"])(child, {
      viewBox: viewBox || parentViewBox,
      key: "label-".concat(index)
    });
  });

  if (!ckeckPropsLabel) {
    return explicitChilren;
  }

  var implicitLabel = parseLabel(parentProps.label, viewBox || parentViewBox);
  return [implicitLabel].concat(_toConsumableArray(explicitChilren));
};

Label.parseViewBox = parseViewBox;
Label.renderCallByParent = renderCallByParent;
/* harmony default export */ __webpack_exports__["a"] = (Label);

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatAxisMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rectWithPoints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return rectWithCoords; });
/* unused harmony export ScaleHelper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LabeledScaleHelper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_every__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_every___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_every__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_mapValues__ = __webpack_require__(1741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_mapValues___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_mapValues__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChartUtils__ = __webpack_require__(44);



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


/**
 * Calculate the scale function, position, width, height of axes
 * @param  {Object} props     Latest props
 * @param  {Object} axisMap   The configuration of axes
 * @param  {Object} offset    The offset of main part in the svg element
 * @param  {String} axisType  The type of axes, x-axis or y-axis
 * @param  {String} chartName The name of chart
 * @return {Object} Configuration
 */

var formatAxisMap = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
  var width = props.width,
      height = props.height,
      layout = props.layout;
  var ids = Object.keys(axisMap);
  var steps = {
    left: offset.left,
    leftMirror: offset.left,
    right: width - offset.right,
    rightMirror: width - offset.right,
    top: offset.top,
    topMirror: offset.top,
    bottom: height - offset.bottom,
    bottomMirror: height - offset.bottom
  };
  return ids.reduce(function (result, id) {
    var axis = axisMap[id];
    var orientation = axis.orientation,
        domain = axis.domain,
        _axis$padding = axis.padding,
        padding = _axis$padding === void 0 ? {} : _axis$padding,
        mirror = axis.mirror,
        reversed = axis.reversed;
    var offsetKey = "".concat(orientation).concat(mirror ? 'Mirror' : '');
    var range, x, y, needSpace;

    if (axisType === 'xAxis') {
      range = [offset.left + (padding.left || 0), offset.left + offset.width - (padding.right || 0)];
    } else if (axisType === 'yAxis') {
      range = layout === 'horizontal' ? [offset.top + offset.height - (padding.bottom || 0), offset.top + (padding.top || 0)] : [offset.top + (padding.top || 0), offset.top + offset.height - (padding.bottom || 0)];
    } else {
      range = axis.range;
    }

    if (reversed) {
      range = [range[1], range[0]];
    }

    var _parseScale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__ChartUtils__["b" /* parseScale */])(axis, chartName),
        scale = _parseScale.scale,
        realScaleType = _parseScale.realScaleType;

    scale.domain(domain).range(range);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__ChartUtils__["c" /* checkDomainOfScale */])(scale);
    var ticks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__ChartUtils__["d" /* getTicksOfScale */])(scale, _objectSpread({}, axis, {
      realScaleType: realScaleType
    }));

    if (axisType === 'xAxis') {
      needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
      x = offset.left;
      y = steps[offsetKey] - needSpace * axis.height;
    } else if (axisType === 'yAxis') {
      needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
      x = steps[offsetKey] - needSpace * axis.width;
      y = offset.top;
    }

    var finalAxis = _objectSpread({}, axis, {}, ticks, {
      realScaleType: realScaleType,
      x: x,
      y: y,
      scale: scale,
      width: axisType === 'xAxis' ? offset.width : axis.width,
      height: axisType === 'yAxis' ? offset.height : axis.height
    });

    finalAxis.bandSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__ChartUtils__["g" /* getBandSizeOfAxis */])(finalAxis, ticks);

    if (!axis.hide && axisType === 'xAxis') {
      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
    } else if (!axis.hide) {
      steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
    }

    return _objectSpread({}, result, _defineProperty({}, id, finalAxis));
  }, {});
};
var rectWithPoints = function rectWithPoints(_ref, _ref2) {
  var x1 = _ref.x,
      y1 = _ref.y;
  var x2 = _ref2.x,
      y2 = _ref2.y;
  return {
    x: Math.min(x1, x2),
    y: Math.min(y1, y2),
    width: Math.abs(x2 - x1),
    height: Math.abs(y2 - y1)
  };
};
/**
 * Compute the x, y, width, and height of a box from two reference points.
 * @param  {Object} coords     x1, x2, y1, and y2
 * @return {Object} object
 */

var rectWithCoords = function rectWithCoords(_ref3) {
  var x1 = _ref3.x1,
      y1 = _ref3.y1,
      x2 = _ref3.x2,
      y2 = _ref3.y2;
  return rectWithPoints({
    x: x1,
    y: y1
  }, {
    x: x2,
    y: y2
  });
};
var ScaleHelper =
/*#__PURE__*/
function () {
  _createClass(ScaleHelper, null, [{
    key: "create",
    value: function create(obj) {
      return new ScaleHelper(obj);
    }
  }]);

  function ScaleHelper(scale) {
    _classCallCheck(this, ScaleHelper);

    this.scale = scale;
  }

  _createClass(ScaleHelper, [{
    key: "apply",
    value: function apply(value) {
      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          bandAware = _ref4.bandAware,
          position = _ref4.position;

      if (value === undefined) {
        return undefined;
      }

      if (position) {
        switch (position) {
          case 'start':
            {
              return this.scale(value);
            }

          case 'middle':
            {
              var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(value) + offset;
            }

          case 'end':
            {
              var _offset = this.bandwidth ? this.bandwidth() : 0;

              return this.scale(value) + _offset;
            }

          default:
            {
              return this.scale(value);
            }
        }
      }

      if (bandAware) {
        var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;

        return this.scale(value) + _offset2;
      }

      return this.scale(value);
    }
  }, {
    key: "isInRange",
    value: function isInRange(value) {
      var range = this.range();
      var first = range[0];
      var last = range[range.length - 1];
      return first <= last ? value >= first && value <= last : value >= last && value <= first;
    }
  }, {
    key: "domain",
    get: function get() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function get() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function get() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function get() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function get() {
      return this.scale.bandwidth;
    }
  }]);

  return ScaleHelper;
}();
ScaleHelper.EPS = 1e-4;
var LabeledScaleHelper =
/*#__PURE__*/
function () {
  _createClass(LabeledScaleHelper, null, [{
    key: "create",
    value: function create(obj) {
      return new this(obj);
    }
  }]);

  function LabeledScaleHelper(scales) {
    _classCallCheck(this, LabeledScaleHelper);

    this.scales = __WEBPACK_IMPORTED_MODULE_1_lodash_mapValues___default()(scales, ScaleHelper.create);
    Object.assign(this, this.scales);
  }

  _createClass(LabeledScaleHelper, [{
    key: "apply",
    value: function apply(coords) {
      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          bandAware = _ref5.bandAware;

      var scales = this.scales;
      return __WEBPACK_IMPORTED_MODULE_1_lodash_mapValues___default()(coords, function (value, label) {
        return scales[label].apply(value, {
          bandAware: bandAware
        });
      });
    }
  }, {
    key: "isInRange",
    value: function isInRange(coords) {
      var scales = this.scales;
      return __WEBPACK_IMPORTED_MODULE_0_lodash_every___default()(coords, function (value, label) {
        return scales[label].isInRange(value);
      });
    }
  }]);

  return LabeledScaleHelper;
}();

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(143),
    getRawTag = __webpack_require__(1691),
    objectToString = __webpack_require__(1719);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 94 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(112);
var IE8_DOM_DEFINE = __webpack_require__(441);
var toPrimitive = __webpack_require__(286);
var dP = Object.defineProperty;

exports.f = __webpack_require__(113) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(442);
var defined = __webpack_require__(276);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
var array = Array.prototype;

var map = array.map;
var slice = array.slice;


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = linearish;
/* harmony export (immutable) */ __webpack_exports__["a"] = linear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__continuous__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tickFormat__ = __webpack_require__(482);





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* ticks */])(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    var d = domain();
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__tickFormat__["a" /* default */])(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* tickIncrement */])(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* tickIncrement */])(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* tickIncrement */])(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__continuous__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1__continuous__["a" /* identity */], __WEBPACK_IMPORTED_MODULE_1__continuous__["a" /* identity */]);

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__continuous__["c" /* copy */])(scale, linear());
  };

  __WEBPACK_IMPORTED_MODULE_2__init__["b" /* initRange */].apply(scale, arguments);

  return linearish(scale);
}


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function constant() {
    return x;
  };
});


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1198),
    getValue = __webpack_require__(1234);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 101 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 102 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(26);

var invariant = __webpack_require__(17);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reduce_css_calc__ = __webpack_require__(1753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reduce_css_calc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reduce_css_calc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_DataUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_DOMUtils__ = __webpack_require__(230);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }








var BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;

var calculateWordWidths = function calculateWordWidths(props) {
  try {
    var words = !__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(props.children) ? props.children.toString().split(BREAKING_SPACES) : [];
    var wordsWithComputedWidth = words.map(function (word) {
      return {
        word: word,
        width: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DOMUtils__["a" /* getStringSize */])(word, props.style).width
      };
    });
    var spaceWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DOMUtils__["a" /* getStringSize */])("\xA0", props.style).width;
    return {
      wordsWithComputedWidth: wordsWithComputedWidth,
      spaceWidth: spaceWidth
    };
  } catch (e) {
    return null;
  }
};

var Text =
/*#__PURE__*/
function (_Component) {
  _inherits(Text, _Component);

  function Text(_props) {
    var _this;

    _classCallCheck(this, Text);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Text).call(this, _props));

    _this.getWordsWithoutCalculate = function (props) {
      var words = !__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(props.children) ? props.children.toString().split(BREAKING_SPACES) : [];
      return [{
        words: words
      }];
    };

    _this.state = {
      wordsByLines: _this.getWordsByLines(_props, true)
    };
    return _this;
  }

  _createClass(Text, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateWordsByLines(this.props, true);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.width !== this.props.width || prevProps.scaleToFit !== this.props.scaleToFit || prevProps.children !== this.props.children || prevProps.style !== this.props.style) {
        var needCalculate = this.props.children !== prevProps.children || this.props.style !== prevProps.style;
        this.updateWordsByLines(this.props, needCalculate);
      }
    }
  }, {
    key: "updateWordsByLines",
    value: function updateWordsByLines(props, needCalculate) {
      this.setState({
        wordsByLines: this.getWordsByLines(props, needCalculate)
      });
    }
  }, {
    key: "getWordsByLines",
    value: function getWordsByLines(props, needCalculate) {
      // Only perform calculations if using features that require them (multiline, scaleToFit)
      if ((props.width || props.scaleToFit) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["h" /* isSsr */])()) {
        if (needCalculate) {
          var wordWidths = calculateWordWidths(props);

          if (wordWidths) {
            var wordsWithComputedWidth = wordWidths.wordsWithComputedWidth,
                spaceWidth = wordWidths.spaceWidth;
            this.wordsWithComputedWidth = wordsWithComputedWidth;
            this.spaceWidth = spaceWidth;
          } else {
            return this.getWordsWithoutCalculate(props);
          }
        }

        return this.calculateWordsByLines(this.wordsWithComputedWidth, this.spaceWidth, props.width);
      }

      return this.getWordsWithoutCalculate(props);
    }
  }, {
    key: "calculateWordsByLines",
    value: function calculateWordsByLines(wordsWithComputedWidth, spaceWidth, lineWidth) {
      var scaleToFit = this.props.scaleToFit;
      return (wordsWithComputedWidth || []).reduce(function (result, _ref) {
        var word = _ref.word,
            width = _ref.width;
        var currentLine = result[result.length - 1];

        if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < lineWidth)) {
          // Word can be added to an existing line
          currentLine.words.push(word);
          currentLine.width += width + spaceWidth;
        } else {
          // Add first word to line or word is too long to scaleToFit on existing line
          var newLine = {
            words: [word],
            width: width
          };
          result.push(newLine);
        }

        return result;
      }, []);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          dx = _this$props.dx,
          dy = _this$props.dy,
          textAnchor = _this$props.textAnchor,
          verticalAnchor = _this$props.verticalAnchor,
          scaleToFit = _this$props.scaleToFit,
          angle = _this$props.angle,
          lineHeight = _this$props.lineHeight,
          capHeight = _this$props.capHeight,
          className = _this$props.className,
          textProps = _objectWithoutProperties(_this$props, ["dx", "dy", "textAnchor", "verticalAnchor", "scaleToFit", "angle", "lineHeight", "capHeight", "className"]);

      var wordsByLines = this.state.wordsByLines;

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["c" /* isNumOrStr */])(textProps.x) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["c" /* isNumOrStr */])(textProps.y)) {
        return null;
      }

      var x = textProps.x + (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["a" /* isNumber */])(dx) ? dx : 0);
      var y = textProps.y + (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["a" /* isNumber */])(dy) ? dy : 0);
      var startDy;

      switch (verticalAnchor) {
        case 'start':
          startDy = __WEBPACK_IMPORTED_MODULE_3_reduce_css_calc___default()("calc(".concat(capHeight, ")"));
          break;

        case 'middle':
          startDy = __WEBPACK_IMPORTED_MODULE_3_reduce_css_calc___default()("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
          break;

        default:
          startDy = __WEBPACK_IMPORTED_MODULE_3_reduce_css_calc___default()("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
          break;
      }

      var transforms = [];

      if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        transforms.push("scale(".concat(this.props.width / lineWidth, ")"));
      }

      if (angle) {
        transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
      }

      if (transforms.length) {
        textProps.transform = transforms.join(' ');
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text", _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["a" /* getPresentationAttributes */])(textProps), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["b" /* filterEventAttributes */])(textProps), {
        x: x,
        y: y,
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('recharts-text', className),
        textAnchor: textAnchor
      }), wordsByLines.map(function (line, index) {
        return (// eslint-disable-next-line react/no-array-index-key
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: index
          }, line.words.join(' '))
        );
      }));
    }
  }]);

  return Text;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Text.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  scaleToFit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  angle: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  textAnchor: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['start', 'middle', 'end', 'inherit']),
  verticalAnchor: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['start', 'middle', 'end']),
  style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
});
Text.defaultProps = {
  x: 0,
  y: 0,
  lineHeight: '1em',
  capHeight: '0.71em',
  // Magic number from d3
  scaleToFit: false,
  textAnchor: 'start',
  verticalAnchor: 'end' // Maintain compat with existing charts / default SVG behavior

};
/* harmony default export */ __webpack_exports__["a"] = (Text);

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__ = __webpack_require__(23);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Dot
 */





var Dot =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Dot, _PureComponent);

  function Dot() {
    _classCallCheck(this, Dot);

    return _possibleConstructorReturn(this, _getPrototypeOf(Dot).apply(this, arguments));
  }

  _createClass(Dot, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          cx = _this$props.cx,
          cy = _this$props.cy,
          r = _this$props.r,
          className = _this$props.className;
      var layerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-dot', className);

      if (cx === +cx && cy === +cy && r === +r) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["b" /* filterEventAttributes */])(this.props, null, true), {
          className: layerClass,
          cx: cx,
          cy: cy,
          r: r
        }));
      }

      return null;
    }
  }]);

  return Dot;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Dot.displayName = 'Dot';
Dot.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cx: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  r: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
/* harmony default export */ __webpack_exports__["a"] = (Dot);

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1648),
    getValue = __webpack_require__(1692);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DOMLazyTree
 */



var DOMNamespaces = __webpack_require__(251);
var setInnerHTML = __webpack_require__(185);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(265);
var setTextContent = __webpack_require__(417);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DOMProperty
 */



var _prodInvariant = __webpack_require__(25);

var invariant = __webpack_require__(17);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {

  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   * @type {Object}
   */
  getPossibleStandardName:  false ? {} : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactReconciler
 */



var ReactRef = __webpack_require__(742);
var ReactInstrumentation = __webpack_require__(52);

var warning = __webpack_require__(21);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
  ) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }

};

module.exports = ReactReconciler;

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(996), __esModule: true };

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(155);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(154)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(95);
var createDesc = __webpack_require__(159);
module.exports = __webpack_require__(113) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
});


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color_js__ = __webpack_require__(291);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__color_js__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__color_js__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__color_js__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lab_js__ = __webpack_require__(1062);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__lab_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__lab_js__["a"]; });
/* unused harmony reexport lch */
/* unused harmony reexport gray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cubehelix_js__ = __webpack_require__(1061);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__cubehelix_js__["a"]; });





/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = hue;
/* harmony export (immutable) */ __webpack_exports__["c"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_js__ = __webpack_require__(472);


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(isNaN(a) ? b : a);
}


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = ownerDocument;

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

module.exports = exports["default"];

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(40);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(84));

var _default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

exports.default = _default;

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);
  return false;
}

module.exports = exports["default"];

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(1760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(1768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(1765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(1764);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(63);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(524),
    baseKeys = __webpack_require__(1201),
    isArrayLike = __webpack_require__(168);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _calendar = __webpack_require__(1397);

var _calendar2 = _interopRequireDefault(_calendar);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _popper_component = __webpack_require__(1402);

var _popper_component2 = _interopRequireDefault(_popper_component);

var _classnames2 = __webpack_require__(7);

var _classnames3 = _interopRequireDefault(_classnames2);

var _date_utils = __webpack_require__(88);

var _reactOnclickoutside = __webpack_require__(346);

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var outsideClickIgnoreClass = 'react-datepicker-ignore-onclickoutside';
var WrappedCalendar = (0, _reactOnclickoutside2.default)(_calendar2.default);

/**
 * General datepicker component.
 */

var DatePicker = function (_React$Component) {
  _inherits(DatePicker, _React$Component);

  _createClass(DatePicker, null, [{
    key: 'defaultProps',
    get: function get() {
      return {
        allowSameDay: false,
        dateFormat: 'L',
        dateFormatCalendar: 'MMMM YYYY',
        onChange: function onChange() {},

        disabled: false,
        disabledKeyboardNavigation: false,
        dropdownMode: 'scroll',
        onFocus: function onFocus() {},
        onBlur: function onBlur() {},
        onKeyDown: function onKeyDown() {},
        onSelect: function onSelect() {},
        onClickOutside: function onClickOutside() {},
        onMonthChange: function onMonthChange() {},

        monthsShown: 1,
        withPortal: false,
        shouldCloseOnSelect: true,
        showTimeSelect: false,
        timeIntervals: 30
      };
    }
  }]);

  function DatePicker(props) {
    _classCallCheck(this, DatePicker);

    var _this = _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this, props));

    _this.getPreSelection = function () {
      return _this.props.openToDate ? (0, _date_utils.newDate)(_this.props.openToDate) : _this.props.selectsEnd && _this.props.startDate ? (0, _date_utils.newDate)(_this.props.startDate) : _this.props.selectsStart && _this.props.endDate ? (0, _date_utils.newDate)(_this.props.endDate) : (0, _date_utils.now)(_this.props.utcOffset);
    };

    _this.calcInitialState = function () {
      var defaultPreSelection = _this.getPreSelection();
      var minDate = (0, _date_utils.getEffectiveMinDate)(_this.props);
      var maxDate = (0, _date_utils.getEffectiveMaxDate)(_this.props);
      var boundedPreSelection = minDate && (0, _date_utils.isBefore)(defaultPreSelection, minDate) ? minDate : maxDate && (0, _date_utils.isAfter)(defaultPreSelection, maxDate) ? maxDate : defaultPreSelection;

      return {
        open: _this.props.startOpen || false,
        preventFocus: false,
        preSelection: _this.props.selected ? (0, _date_utils.newDate)(_this.props.selected) : boundedPreSelection
      };
    };

    _this.clearPreventFocusTimeout = function () {
      if (_this.preventFocusTimeout) {
        clearTimeout(_this.preventFocusTimeout);
      }
    };

    _this.setFocus = function () {
      _this.input.focus();
    };

    _this.setOpen = function (open) {
      _this.setState({
        open: open,
        preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection
      });
    };

    _this.handleFocus = function (event) {
      if (!_this.state.preventFocus) {
        _this.props.onFocus(event);
        _this.setOpen(true);
      }
    };

    _this.cancelFocusInput = function () {
      clearTimeout(_this.inputFocusTimeout);
      _this.inputFocusTimeout = null;
    };

    _this.deferFocusInput = function () {
      _this.cancelFocusInput();
      _this.inputFocusTimeout = setTimeout(function () {
        return _this.setFocus();
      }, 1);
    };

    _this.handleDropdownFocus = function () {
      _this.cancelFocusInput();
    };

    _this.handleBlur = function (event) {
      if (_this.state.open) {
        _this.deferFocusInput();
      } else {
        _this.props.onBlur(event);
      }
    };

    _this.handleCalendarClickOutside = function (event) {
      if (!_this.props.inline) {
        _this.setOpen(false);
      }
      _this.props.onClickOutside(event);
      if (_this.props.withPortal) {
        event.preventDefault();
      }
    };

    _this.handleChange = function (event) {
      if (_this.props.onChangeRaw) {
        _this.props.onChangeRaw(event);
        if (event.isDefaultPrevented()) {
          return;
        }
      }
      _this.setState({ inputValue: event.target.value });
      var date = (0, _date_utils.parseDate)(event.target.value, _this.props);
      if (date || !event.target.value) {
        _this.setSelected(date, event, true);
      }
    };

    _this.handleSelect = function (date, event) {
      // Preventing onFocus event to fix issue
      // https://github.com/Hacker0x01/react-datepicker/issues/628
      _this.setState({ preventFocus: true }, function () {
        _this.preventFocusTimeout = setTimeout(function () {
          return _this.setState({ preventFocus: false });
        }, 50);
        return _this.preventFocusTimeout;
      });
      _this.setSelected(date, event);
      if (!_this.props.shouldCloseOnSelect) {
        _this.setPreSelection(date);
      } else if (!_this.props.inline) {
        _this.setOpen(false);
      }
    };

    _this.setSelected = function (date, event, keepInput) {
      var changedDate = date;

      if (changedDate !== null && (0, _date_utils.isDayDisabled)(changedDate, _this.props)) {
        return;
      }

      if (!(0, _date_utils.isSameDay)(_this.props.selected, changedDate) || _this.props.allowSameDay) {
        if (changedDate !== null) {
          if (_this.props.selected) {
            changedDate = (0, _date_utils.setTime)((0, _date_utils.newDate)(changedDate), {
              hour: (0, _date_utils.getHour)(_this.props.selected),
              minute: (0, _date_utils.getMinute)(_this.props.selected),
              second: (0, _date_utils.getSecond)(_this.props.selected)
            });
          }
          _this.setState({
            preSelection: changedDate
          });
        }
        _this.props.onChange(changedDate, event);
      }

      _this.props.onSelect(changedDate, event);

      if (!keepInput) {
        _this.setState({ inputValue: null });
      }
    };

    _this.setPreSelection = function (date) {
      var isDateRangePresent = typeof _this.props.minDate !== 'undefined' && typeof _this.props.maxDate !== 'undefined';
      var isValidDateSelection = isDateRangePresent && date ? (0, _date_utils.isDayInRange)(date, _this.props.minDate, _this.props.maxDate) : true;
      if (isValidDateSelection) {
        _this.setState({
          preSelection: date
        });
      }
    };

    _this.handleTimeChange = function (time) {
      var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
      var changedDate = (0, _date_utils.setTime)((0, _date_utils.cloneDate)(selected), {
        hour: (0, _date_utils.getHour)(time),
        minute: (0, _date_utils.getMinute)(time)
      });

      _this.setState({
        preSelection: changedDate
      });

      _this.props.onChange(changedDate);
    };

    _this.onInputClick = function () {
      if (!_this.props.disabled) {
        _this.setOpen(true);
      }
    };

    _this.onInputKeyDown = function (event) {
      _this.props.onKeyDown(event);
      var eventKey = event.key;
      if (!_this.state.open && !_this.props.inline) {
        if (eventKey !== 'Enter' && eventKey !== 'Escape' && eventKey !== 'Tab') {
          _this.onInputClick();
        }
        return;
      }
      var copy = (0, _date_utils.newDate)(_this.state.preSelection);
      if (eventKey === 'Enter') {
        event.preventDefault();
        if ((0, _date_utils.isMoment)(_this.state.preSelection) || (0, _date_utils.isDate)(_this.state.preSelection)) {
          _this.handleSelect(copy, event);
          !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy);
        } else {
          _this.setOpen(false);
        }
      } else if (eventKey === 'Escape') {
        event.preventDefault();
        _this.setOpen(false);
      } else if (eventKey === 'Tab') {
        _this.setOpen(false);
      } else if (!_this.props.disabledKeyboardNavigation) {
        var newSelection = void 0;
        switch (eventKey) {
          case 'ArrowLeft':
            event.preventDefault();
            newSelection = (0, _date_utils.subtractDays)(copy, 1);
            break;
          case 'ArrowRight':
            event.preventDefault();
            newSelection = (0, _date_utils.addDays)(copy, 1);
            break;
          case 'ArrowUp':
            event.preventDefault();
            newSelection = (0, _date_utils.subtractWeeks)(copy, 1);
            break;
          case 'ArrowDown':
            event.preventDefault();
            newSelection = (0, _date_utils.addWeeks)(copy, 1);
            break;
          case 'PageUp':
            event.preventDefault();
            newSelection = (0, _date_utils.subtractMonths)(copy, 1);
            break;
          case 'PageDown':
            event.preventDefault();
            newSelection = (0, _date_utils.addMonths)(copy, 1);
            break;
          case 'Home':
            event.preventDefault();
            newSelection = (0, _date_utils.subtractYears)(copy, 1);
            break;
          case 'End':
            event.preventDefault();
            newSelection = (0, _date_utils.addYears)(copy, 1);
            break;
        }
        _this.setPreSelection(newSelection);
      }
    };

    _this.onClearClick = function (event) {
      event.preventDefault();
      _this.props.onChange(null, event);
      _this.setState({ inputValue: null });
    };

    _this.renderCalendar = function () {
      if (!_this.props.inline && (!_this.state.open || _this.props.disabled)) {
        return null;
      }
      return _react2.default.createElement(
        WrappedCalendar,
        {
          ref: function ref(elem) {
            _this.calendar = elem;
          },
          locale: _this.props.locale,
          dateFormat: _this.props.dateFormatCalendar,
          useWeekdaysShort: _this.props.useWeekdaysShort,
          dropdownMode: _this.props.dropdownMode,
          selected: _this.props.selected,
          preSelection: _this.state.preSelection,
          onSelect: _this.handleSelect,
          onWeekSelect: _this.props.onWeekSelect,
          openToDate: _this.props.openToDate,
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          excludeDates: _this.props.excludeDates,
          filterDate: _this.props.filterDate,
          onClickOutside: _this.handleCalendarClickOutside,
          formatWeekNumber: _this.props.formatWeekNumber,
          highlightDates: _this.props.highlightDates,
          includeDates: _this.props.includeDates,
          inline: _this.props.inline,
          peekNextMonth: _this.props.peekNextMonth,
          showMonthDropdown: _this.props.showMonthDropdown,
          showWeekNumbers: _this.props.showWeekNumbers,
          showYearDropdown: _this.props.showYearDropdown,
          withPortal: _this.props.withPortal,
          forceShowMonthNavigation: _this.props.forceShowMonthNavigation,
          scrollableYearDropdown: _this.props.scrollableYearDropdown,
          todayButton: _this.props.todayButton,
          weekLabel: _this.props.weekLabel,
          utcOffset: _this.props.utcOffset,
          outsideClickIgnoreClass: outsideClickIgnoreClass,
          fixedHeight: _this.props.fixedHeight,
          monthsShown: _this.props.monthsShown,
          onDropdownFocus: _this.handleDropdownFocus,
          onMonthChange: _this.props.onMonthChange,
          dayClassName: _this.props.dayClassName,
          showTimeSelect: _this.props.showTimeSelect,
          onTimeChange: _this.handleTimeChange,
          timeFormat: _this.props.timeFormat,
          timeIntervals: _this.props.timeIntervals,
          minTime: _this.props.minTime,
          maxTime: _this.props.maxTime,
          excludeTimes: _this.props.excludeTimes,
          className: _this.props.calendarClassName,
          yearDropdownItemNumber: _this.props.yearDropdownItemNumber },
        _this.props.children
      );
    };

    _this.renderDateInput = function () {
      var className = (0, _classnames3.default)(_this.props.className, _defineProperty({}, outsideClickIgnoreClass, _this.state.open));

      var customInput = _this.props.customInput || _react2.default.createElement('input', { type: 'text' });
      var inputValue = typeof _this.props.value === 'string' ? _this.props.value : typeof _this.state.inputValue === 'string' ? _this.state.inputValue : (0, _date_utils.safeDateFormat)(_this.props.selected, _this.props);

      return _react2.default.cloneElement(customInput, {
        ref: function ref(input) {
          _this.input = input;
        },
        value: inputValue,
        onBlur: _this.handleBlur,
        onChange: _this.handleChange,
        onClick: _this.onInputClick,
        onFocus: _this.handleFocus,
        onKeyDown: _this.onInputKeyDown,
        id: _this.props.id,
        name: _this.props.name,
        autoFocus: _this.props.autoFocus,
        placeholder: _this.props.placeholderText,
        disabled: _this.props.disabled,
        autoComplete: _this.props.autoComplete,
        className: className,
        title: _this.props.title,
        readOnly: _this.props.readOnly,
        required: _this.props.required,
        tabIndex: _this.props.tabIndex
      });
    };

    _this.renderClearButton = function () {
      if (_this.props.isClearable && _this.props.selected != null) {
        return _react2.default.createElement('a', { className: 'react-datepicker__close-icon', href: '#', onClick: _this.onClearClick });
      } else {
        return null;
      }
    };

    _this.state = _this.calcInitialState();
    return _this;
  }

  _createClass(DatePicker, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var currentMonth = this.props.selected && (0, _date_utils.getMonth)(this.props.selected);
      var nextMonth = nextProps.selected && (0, _date_utils.getMonth)(nextProps.selected);
      if (this.props.inline && currentMonth !== nextMonth) {
        this.setPreSelection(nextProps.selected);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearPreventFocusTimeout();
    }
  }, {
    key: 'render',
    value: function render() {
      var calendar = this.renderCalendar();

      if (this.props.inline && !this.props.withPortal) {
        return calendar;
      }

      if (this.props.withPortal) {
        return _react2.default.createElement(
          'div',
          null,
          !this.props.inline ? _react2.default.createElement(
            'div',
            { className: 'react-datepicker__input-container' },
            this.renderDateInput(),
            this.renderClearButton()
          ) : null,
          this.state.open || this.props.inline ? _react2.default.createElement(
            'div',
            { className: 'react-datepicker__portal' },
            calendar
          ) : null
        );
      }

      return _react2.default.createElement(_popper_component2.default, {
        className: this.props.popperClassName,
        hidePopper: !this.state.open || this.props.disabled,
        popperModifiers: this.props.popperModifiers,
        targetComponent: _react2.default.createElement(
          'div',
          { className: 'react-datepicker__input-container' },
          this.renderDateInput(),
          this.renderClearButton()
        ),
        popperContainer: this.props.popperContainer,
        popperComponent: calendar,
        popperPlacement: this.props.popperPlacement });
    }
  }]);

  return DatePicker;
}(_react2.default.Component);

DatePicker.propTypes = {
  allowSameDay: _propTypes2.default.bool,
  autoComplete: _propTypes2.default.string,
  autoFocus: _propTypes2.default.bool,
  calendarClassName: _propTypes2.default.string,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  customInput: _propTypes2.default.element,
  dateFormat: _propTypes2.default.oneOfType([// eslint-disable-line react/no-unused-prop-types
  _propTypes2.default.string, _propTypes2.default.array]),
  dateFormatCalendar: _propTypes2.default.string,
  dayClassName: _propTypes2.default.func,
  disabled: _propTypes2.default.bool,
  disabledKeyboardNavigation: _propTypes2.default.bool,
  dropdownMode: _propTypes2.default.oneOf(['scroll', 'select']).isRequired,
  endDate: _propTypes2.default.object,
  excludeDates: _propTypes2.default.array,
  filterDate: _propTypes2.default.func,
  fixedHeight: _propTypes2.default.bool,
  formatWeekNumber: _propTypes2.default.func,
  highlightDates: _propTypes2.default.array,
  id: _propTypes2.default.string,
  includeDates: _propTypes2.default.array,
  inline: _propTypes2.default.bool,
  isClearable: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  maxDate: _propTypes2.default.object,
  minDate: _propTypes2.default.object,
  monthsShown: _propTypes2.default.number,
  name: _propTypes2.default.string,
  onBlur: _propTypes2.default.func,
  onChange: _propTypes2.default.func.isRequired,
  onSelect: _propTypes2.default.func,
  onWeekSelect: _propTypes2.default.func,
  onClickOutside: _propTypes2.default.func,
  onChangeRaw: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onMonthChange: _propTypes2.default.func,
  openToDate: _propTypes2.default.object,
  peekNextMonth: _propTypes2.default.bool,
  placeholderText: _propTypes2.default.string,
  popperContainer: _propTypes2.default.func,
  popperClassName: _propTypes2.default.string, // <PopperComponent/> props
  popperModifiers: _propTypes2.default.object, // <PopperComponent/> props
  popperPlacement: _propTypes2.default.oneOf(_popper_component.popperPlacementPositions), // <PopperComponent/> props
  readOnly: _propTypes2.default.bool,
  required: _propTypes2.default.bool,
  scrollableYearDropdown: _propTypes2.default.bool,
  selected: _propTypes2.default.object,
  selectsEnd: _propTypes2.default.bool,
  selectsStart: _propTypes2.default.bool,
  showMonthDropdown: _propTypes2.default.bool,
  showWeekNumbers: _propTypes2.default.bool,
  showYearDropdown: _propTypes2.default.bool,
  forceShowMonthNavigation: _propTypes2.default.bool,
  startDate: _propTypes2.default.object,
  startOpen: _propTypes2.default.bool,
  tabIndex: _propTypes2.default.number,
  title: _propTypes2.default.string,
  todayButton: _propTypes2.default.string,
  useWeekdaysShort: _propTypes2.default.bool,
  utcOffset: _propTypes2.default.number,
  value: _propTypes2.default.string,
  weekLabel: _propTypes2.default.string,
  withPortal: _propTypes2.default.bool,
  yearDropdownItemNumber: _propTypes2.default.number,
  shouldCloseOnSelect: _propTypes2.default.bool,
  showTimeSelect: _propTypes2.default.bool,
  timeFormat: _propTypes2.default.string,
  timeIntervals: _propTypes2.default.number,
  minTime: _propTypes2.default.object,
  maxTime: _propTypes2.default.object,
  excludeTimes: _propTypes2.default.array
};
exports.default = DatePicker;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = __webpack_require__(331);
var setInnerHTML = __webpack_require__(220);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(339);
var setTextContent = __webpack_require__(610);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(26);

var invariant = __webpack_require__(17);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactRef = __webpack_require__(1444);
var ReactInstrumentation = __webpack_require__(53);

var warning = __webpack_require__(21);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (componentOrElement) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
};

var _reactDom = __webpack_require__(33);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ownerDocument = __webpack_require__(118);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(22);

var ReactBaseClasses = __webpack_require__(630);
var ReactChildren = __webpack_require__(1539);
var ReactDOMFactories = __webpack_require__(1540);
var ReactElement = __webpack_require__(132);
var ReactPropTypes = __webpack_require__(1541);
var ReactVersion = __webpack_require__(1542);

var createReactClass = __webpack_require__(1543);
var onlyChild = __webpack_require__(1547);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(22);

var ReactCurrentOwner = __webpack_require__(73);

var warning = __webpack_require__(21);
var canDefineProperty = __webpack_require__(634);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(632);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_ReactUtils__ = __webpack_require__(23);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview X Axis
 */




var XAxis =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(XAxis, _PureComponent);

  function XAxis() {
    _classCallCheck(this, XAxis);

    return _possibleConstructorReturn(this, _getPrototypeOf(XAxis).apply(this, arguments));
  }

  _createClass(XAxis, [{
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return XAxis;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

XAxis.displayName = 'XAxis';
XAxis.propTypes = {
  allowDecimals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  allowDuplicatedCategory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // The name of data displayed in the axis
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The unit of data displayed in the axis
  unit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The unique id of x-axis
  xAxisId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  domain: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['auto', 'dataMin', 'dataMax'])])),
  // The key of data displayed in the axis
  dataKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  // The width of axis which is usually calculated internally
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // The height of axis, which need to be setted by user
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  mirror: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // The orientation of axis
  orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['top', 'bottom']),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['number', 'category']),
  // Ticks can be any type when the axis is the type of category
  // Ticks must be numbers when the axis is the type of number
  ticks: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  // The count of ticks
  tickCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // The formatter function of tick
  tickFormatter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  padding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    right: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  allowDataOverflow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_2__util_ReactUtils__["q" /* SCALE_TYPES */]), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  tick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),
  axisLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  tickLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  minTickGap: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  tickSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  interval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
  reversed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
XAxis.defaultProps = {
  allowDecimals: true,
  hide: false,
  orientation: 'bottom',
  width: 0,
  height: 30,
  mirror: false,
  xAxisId: 0,
  tickCount: 5,
  type: 'category',
  domain: [0, 'auto'],
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: false,
  scale: 'auto',
  reversed: false,
  allowDuplicatedCategory: true
};
/* harmony default export */ __webpack_exports__["a"] = (XAxis);

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Y Axis
 */



var YAxis =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(YAxis, _PureComponent);

  function YAxis() {
    _classCallCheck(this, YAxis);

    return _possibleConstructorReturn(this, _getPrototypeOf(YAxis).apply(this, arguments));
  }

  _createClass(YAxis, [{
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return YAxis;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

YAxis.displayName = 'YAxis';
YAxis.propTypes = {
  allowDecimals: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  allowDuplicatedCategory: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hide: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // The name of data displayed in the axis
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The unit of data displayed in the axis
  unit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The unique id of y-axis
  yAxisId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  domain: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['auto', 'dataMin', 'dataMax'])])),
  // The key of data displayed in the axis
  dataKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  // Ticks can be any type when the axis is the type of category
  // Ticks must be numbers when the axis is the type of number
  ticks: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  // The count of ticks
  tickCount: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // The formatter function of tick
  tickFormatter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  // The width of axis, which need to be setted by user
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  // The height of axis which is usually calculated in Chart
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  mirror: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  // The orientation of axis
  orientation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['left', 'right']),
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['number', 'category']),
  padding: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    bottom: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  allowDataOverflow: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  scale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold']), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  tick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element]),
  axisLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  tickLine: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]),
  minTickGap: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  tickSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  interval: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])]),
  reversed: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};
YAxis.defaultProps = {
  allowDuplicatedCategory: true,
  allowDecimals: true,
  hide: false,
  orientation: 'left',
  width: 60,
  height: 0,
  mirror: false,
  yAxisId: 0,
  tickCount: 5,
  type: 'number',
  domain: [0, 'auto'],
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: false,
  scale: 'auto',
  reversed: false
};
/* harmony default export */ __webpack_exports__["a"] = (YAxis);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_ReactUtils__ = __webpack_require__(23);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @fileOverview Cross
 */


function Cell() {
  return null;
}

Cell.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_0__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */]);
Cell.displayName = 'Cell';
/* harmony default export */ __webpack_exports__["a"] = (Cell);

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfill__ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__container_Surface__ = __webpack_require__(176);
/* unused harmony reexport Surface */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__container_Layer__ = __webpack_require__(36);
/* unused harmony reexport Layer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__component_Legend__ = __webpack_require__(354);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__component_Legend__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__component_Tooltip__ = __webpack_require__(225);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__component_Tooltip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component_ResponsiveContainer__ = __webpack_require__(1568);
/* unused harmony reexport ResponsiveContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component_Cell__ = __webpack_require__(136);
/* unused harmony reexport Cell */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_Text__ = __webpack_require__(104);
/* unused harmony reexport Text */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component_Label__ = __webpack_require__(90);
/* unused harmony reexport Label */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component_LabelList__ = __webpack_require__(75);
/* unused harmony reexport LabelList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__component_Customized__ = __webpack_require__(1565);
/* unused harmony reexport Customized */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shape_Sector__ = __webpack_require__(229);
/* unused harmony reexport Sector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shape_Curve__ = __webpack_require__(138);
/* unused harmony reexport Curve */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shape_Rectangle__ = __webpack_require__(139);
/* unused harmony reexport Rectangle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shape_Polygon__ = __webpack_require__(228);
/* unused harmony reexport Polygon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shape_Dot__ = __webpack_require__(105);
/* unused harmony reexport Dot */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__shape_Cross__ = __webpack_require__(645);
/* unused harmony reexport Cross */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__shape_Symbols__ = __webpack_require__(355);
/* unused harmony reexport Symbols */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__polar_PolarGrid__ = __webpack_require__(1569);
/* unused harmony reexport PolarGrid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__polar_PolarRadiusAxis__ = __webpack_require__(227);
/* unused harmony reexport PolarRadiusAxis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__polar_PolarAngleAxis__ = __webpack_require__(226);
/* unused harmony reexport PolarAngleAxis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__polar_Pie__ = __webpack_require__(642);
/* unused harmony reexport Pie */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__polar_Radar__ = __webpack_require__(643);
/* unused harmony reexport Radar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__polar_RadialBar__ = __webpack_require__(644);
/* unused harmony reexport RadialBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__cartesian_Brush__ = __webpack_require__(636);
/* unused harmony reexport Brush */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__cartesian_ReferenceLine__ = __webpack_require__(640);
/* unused harmony reexport ReferenceLine */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__cartesian_ReferenceDot__ = __webpack_require__(639);
/* unused harmony reexport ReferenceDot */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__cartesian_ReferenceArea__ = __webpack_require__(638);
/* unused harmony reexport ReferenceArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__cartesian_CartesianAxis__ = __webpack_require__(637);
/* unused harmony reexport CartesianAxis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__cartesian_CartesianGrid__ = __webpack_require__(1553);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_29__cartesian_CartesianGrid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__cartesian_Line__ = __webpack_require__(352);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_30__cartesian_Line__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__cartesian_Area__ = __webpack_require__(350);
/* unused harmony reexport Area */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__cartesian_Bar__ = __webpack_require__(351);
/* unused harmony reexport Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__cartesian_Scatter__ = __webpack_require__(353);
/* unused harmony reexport Scatter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__cartesian_XAxis__ = __webpack_require__(134);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_34__cartesian_XAxis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__cartesian_YAxis__ = __webpack_require__(135);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_35__cartesian_YAxis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__cartesian_ZAxis__ = __webpack_require__(224);
/* unused harmony reexport ZAxis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__cartesian_ErrorBar__ = __webpack_require__(175);
/* unused harmony reexport ErrorBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__chart_LineChart__ = __webpack_require__(1558);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_38__chart_LineChart__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__chart_BarChart__ = __webpack_require__(1555);
/* unused harmony reexport BarChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__chart_PieChart__ = __webpack_require__(1559);
/* unused harmony reexport PieChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__chart_Treemap__ = __webpack_require__(1564);
/* unused harmony reexport Treemap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__chart_Sankey__ = __webpack_require__(1562);
/* unused harmony reexport Sankey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__chart_RadarChart__ = __webpack_require__(1560);
/* unused harmony reexport RadarChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__chart_ScatterChart__ = __webpack_require__(1563);
/* unused harmony reexport ScatterChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__chart_AreaChart__ = __webpack_require__(1554);
/* unused harmony reexport AreaChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__chart_RadialBarChart__ = __webpack_require__(1561);
/* unused harmony reexport RadialBarChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__chart_ComposedChart__ = __webpack_require__(1556);
/* unused harmony reexport ComposedChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__numberAxis_Funnel__ = __webpack_require__(641);
/* unused harmony reexport Funnel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__chart_FunnelChart__ = __webpack_require__(1557);
/* unused harmony reexport FunnelChart */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__shape_Trapezoid__ = __webpack_require__(646);
/* unused harmony reexport Trapezoid */






































































































/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_d3_shape__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_DataUtils__ = __webpack_require__(27);



function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Curve
 */






var CURVE_FACTORIES = {
  curveBasisClosed: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["g" /* curveBasisClosed */],
  curveBasisOpen: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["h" /* curveBasisOpen */],
  curveBasis: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["i" /* curveBasis */],
  curveLinearClosed: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["j" /* curveLinearClosed */],
  curveLinear: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["k" /* curveLinear */],
  curveMonotoneX: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["l" /* curveMonotoneX */],
  curveMonotoneY: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["m" /* curveMonotoneY */],
  curveNatural: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["n" /* curveNatural */],
  curveStep: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["o" /* curveStep */],
  curveStepAfter: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["p" /* curveStepAfter */],
  curveStepBefore: __WEBPACK_IMPORTED_MODULE_4_d3_shape__["q" /* curveStepBefore */]
};

var defined = function defined(p) {
  return p.x === +p.x && p.y === +p.y;
};

var getX = function getX(p) {
  return p.x;
};

var getY = function getY(p) {
  return p.y;
};

var getCurveFactory = function getCurveFactory(type, layout) {
  if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(type)) {
    return type;
  }

  var name = "curve".concat(type.slice(0, 1).toUpperCase()).concat(type.slice(1));

  if (name === 'curveMonotone' && layout) {
    return CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
  }

  return CURVE_FACTORIES[name] || __WEBPACK_IMPORTED_MODULE_4_d3_shape__["k" /* curveLinear */];
};

var Curve =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Curve, _PureComponent);

  function Curve() {
    _classCallCheck(this, Curve);

    return _possibleConstructorReturn(this, _getPrototypeOf(Curve).apply(this, arguments));
  }

  _createClass(Curve, [{
    key: "getPath",

    /**
     * Calculate the path of curve
     * @return {String} path
     */
    value: function getPath() {
      var _this$props = this.props,
          type = _this$props.type,
          points = _this$props.points,
          baseLine = _this$props.baseLine,
          layout = _this$props.layout,
          connectNulls = _this$props.connectNulls;
      var curveFactory = getCurveFactory(type, layout);
      var formatPoints = connectNulls ? points.filter(function (entry) {
        return defined(entry);
      }) : points;
      var lineFunction;

      if (__WEBPACK_IMPORTED_MODULE_0_lodash_isArray___default()(baseLine)) {
        var formatBaseLine = connectNulls ? baseLine.filter(function (base) {
          return defined(base);
        }) : baseLine;
        var areaPoints = formatPoints.map(function (entry, index) {
          return _objectSpread({}, entry, {
            base: formatBaseLine[index]
          });
        });

        if (layout === 'vertical') {
          lineFunction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_shape__["r" /* area */])().y(getY).x1(getX).x0(function (d) {
            return d.base.x;
          });
        } else {
          lineFunction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_shape__["r" /* area */])().x(getX).y1(getY).y0(function (d) {
            return d.base.y;
          });
        }

        lineFunction.defined(defined).curve(curveFactory);
        return lineFunction(areaPoints);
      }

      if (layout === 'vertical' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["a" /* isNumber */])(baseLine)) {
        lineFunction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_shape__["r" /* area */])().y(getY).x1(getX).x0(baseLine);
      } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_DataUtils__["a" /* isNumber */])(baseLine)) {
        lineFunction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_shape__["r" /* area */])().x(getX).y1(getY).y0(baseLine);
      } else {
        lineFunction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_d3_shape__["s" /* line */])().x(getX).y(getY);
      }

      lineFunction.defined(defined).curve(curveFactory);
      return lineFunction(formatPoints);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          points = _this$props2.points,
          path = _this$props2.path,
          pathRef = _this$props2.pathRef;

      if ((!points || !points.length) && !path) {
        return null;
      }

      var realPath = points && points.length ? this.getPath() : path;
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("path", _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["b" /* filterEventAttributes */])(this.props, null, true), {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()('recharts-curve', className),
        d: realPath,
        ref: pathRef
      }));
    }
  }]);

  return Curve;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

Curve.displayName = 'Curve';
Curve.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
  layout: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['horizontal', 'vertical']),
  baseLine: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array]),
  points: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object),
  connectNulls: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  pathRef: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
});
Curve.defaultProps = {
  type: 'linear',
  points: [],
  connectNulls: false
};
/* harmony default export */ __webpack_exports__["a"] = (Curve);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_smooth__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__ = __webpack_require__(23);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Rectangle
 */






var getRectangePath = function getRectangePath(x, y, width, height, radius) {
  var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
  var ySign = height >= 0 ? 1 : -1;
  var xSign = width >= 0 ? 1 : -1;
  var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
  var path;

  if (maxRadius > 0 && radius instanceof Array) {
    var newRadius = [];

    for (var i = 0, len = 4; i < len; i++) {
      newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
    }

    path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);

    if (newRadius[0] > 0) {
      path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
    }

    path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);

    if (newRadius[1] > 0) {
      path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
    }

    path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);

    if (newRadius[2] > 0) {
      path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
    }

    path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);

    if (newRadius[3] > 0) {
      path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
    }

    path += 'Z';
  } else if (maxRadius > 0 && radius === +radius && radius > 0) {
    var _newRadius = Math.min(maxRadius, radius);

    path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
  } else {
    path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
  }

  return path;
};

var Rectangle =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Rectangle, _PureComponent);

  function Rectangle() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Rectangle);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Rectangle)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      totalLength: -1
    };
    return _this;
  }

  _createClass(Rectangle, [{
    key: "componentDidMount",

    /* eslint-disable  react/no-did-mount-set-state */
    value: function componentDidMount() {
      if (this.node && this.node.getTotalLength) {
        try {
          var totalLength = this.node.getTotalLength();

          if (totalLength) {
            this.setState({
              totalLength: totalLength
            });
          }
        } catch (err) {// calculate total length error
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          x = _this$props.x,
          y = _this$props.y,
          width = _this$props.width,
          height = _this$props.height,
          radius = _this$props.radius,
          className = _this$props.className;
      var totalLength = this.state.totalLength;
      var _this$props2 = this.props,
          animationEasing = _this$props2.animationEasing,
          animationDuration = _this$props2.animationDuration,
          animationBegin = _this$props2.animationBegin,
          isAnimationActive = _this$props2.isAnimationActive,
          isUpdateAnimationActive = _this$props2.isUpdateAnimationActive;

      if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) {
        return null;
      }

      var layerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-rectangle', className);

      if (!isUpdateAnimationActive) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["b" /* filterEventAttributes */])(this.props), {
          className: layerClass,
          d: getRectangePath(x, y, width, height, radius)
        }));
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_smooth__["a" /* default */], {
        canBegin: totalLength > 0,
        from: {
          width: width,
          height: height,
          x: x,
          y: y
        },
        to: {
          width: width,
          height: height,
          x: x,
          y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
      }, function (_ref) {
        var currWidth = _ref.width,
            currHeight = _ref.height,
            currX = _ref.x,
            currY = _ref.y;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_smooth__["a" /* default */], {
          canBegin: totalLength > 0,
          from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
          to: "".concat(totalLength, "px 0px"),
          attributeName: "strokeDasharray",
          begin: animationBegin,
          duration: animationDuration,
          isActive: isAnimationActive,
          easing: animationEasing
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["a" /* getPresentationAttributes */])(_this2.props), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["b" /* filterEventAttributes */])(_this2.props), {
          className: layerClass,
          d: getRectangePath(currX, currY, currWidth, currHeight, radius),
          ref: function ref(node) {
            _this2.node = node;
          }
        })));
      });
    }
  }]);

  return Rectangle;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Rectangle.displayName = 'Rectangle';
Rectangle.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {}, __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["d" /* EVENT_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  radius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array]),
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  isUpdateAnimationActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
});
Rectangle.defaultProps = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: false,
  isUpdateAnimationActive: false,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease'
};
/* harmony default export */ __webpack_exports__["a"] = (Rectangle);

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return warn; });
/* eslint no-console: 0 */
var isDev = "production" !== 'production';
var warn = function warn(condition, format, a, b, c, d, e, f) {
  if (isDev && typeof console !== 'undefined' && console.warn) {
    if (format === undefined) {
      console.warn('LogUtils requires an error message argument');
    }

    if (!condition) {
      if (format === undefined) {
        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
      } else {
        var args = [a, b, c, d, e, f];
        var argIndex = 0;
        console.warn(format.replace(/%s/g, function () {
          return args[argIndex++];
        }));
      }
    }
  }
};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(92)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(56);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(240);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 145 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(29),
    isLength = __webpack_require__(384);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(93),
    isObjectLike = __webpack_require__(66);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(664),
    baseKeys = __webpack_require__(1651),
    isArrayLike = __webpack_require__(146);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventPluginHub
 */



var _prodInvariant = __webpack_require__(25);

var EventPluginRegistry = __webpack_require__(252);
var EventPluginUtils = __webpack_require__(253);
var ReactErrorUtils = __webpack_require__(259);

var accumulateInto = __webpack_require__(408);
var forEachAccumulated = __webpack_require__(410);
var invariant = __webpack_require__(17);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {

  /**
   * Methods for injecting dependencies.
   */
  injection: {

    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName

  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    var bankForRegistrationName = listenerBank[registrationName];
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }

};

module.exports = EventPluginHub;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventPropagators
 */



var EventConstants = __webpack_require__(67);
var EventPluginHub = __webpack_require__(149);
var EventPluginUtils = __webpack_require__(253);

var accumulateInto = __webpack_require__(408);
var forEachAccumulated = __webpack_require__(410);
var warning = __webpack_require__(21);

var PropagationPhases = EventConstants.PropagationPhases;
var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, upwards, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactInstanceMap
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {

  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }

};

module.exports = ReactInstanceMap;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticUIEvent
 */



var SyntheticEvent = __webpack_require__(68);

var getEventTarget = __webpack_require__(268);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Transaction
 */



var _prodInvariant = __webpack_require__(25);

var invariant = __webpack_require__(17);

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var Mixin = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

var Transaction = {

  Mixin: Mixin,

  /**
   * Token to look for to determine if an error occurred.
   */
  OBSERVED_ERROR: {}

};

module.exports = Transaction;

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(446);
var enumBugKeys = __webpack_require__(277);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 158 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x === null ? NaN : +x;
});


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__path_js__ = __webpack_require__(1087);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__path_js__["a"]; });



/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return max; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return min; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return tau; });
/* harmony export (immutable) */ __webpack_exports__["l"] = acos;
/* harmony export (immutable) */ __webpack_exports__["k"] = asin;
var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;

var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
});


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
});


/***/ }),
/* 165 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(526),
    baseAssignValue = __webpack_require__(527);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(207);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(548),
    isLength = __webpack_require__(323);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SafeAnchor__ = __webpack_require__(64);
















var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  block: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  componentClass: __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType___default.a,
  href: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  /**
   * Defines HTML button type attribute
   * @defaultValue 'button'
   */
  type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['button', 'reset', 'submit'])
};

var defaultProps = {
  active: false,
  block: false,
  disabled: false
};

var Button = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Button, _React$Component);

  function Button() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Button);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Button.prototype.renderAnchor = function renderAnchor(elementProps, className) {
    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, elementProps.disabled && 'disabled')
    }));
  };

  Button.prototype.renderButton = function renderButton(_ref, className) {
    var componentClass = _ref.componentClass,
        elementProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['componentClass']);

    var Component = componentClass || 'button';

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, elementProps, {
      type: elementProps.type || 'button',
      className: className
    }));
  };

  Button.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        active = _props.active,
        block = _props.block,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['active', 'block', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), (_extends2 = {
      active: active
    }, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'block')] = block, _extends2));
    var fullClassName = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes);

    if (elementProps.href) {
      return this.renderAnchor(elementProps, fullClassName);
    }

    return this.renderButton(elementProps, fullClassName);
  };

  return Button;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["c" /* bsClass */])('btn', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["d" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["b" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["b" /* Size */].SMALL, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["b" /* Size */].XSMALL], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["f" /* bsStyles */])([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["c" /* State */]), [__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["d" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["d" /* Style */].PRIMARY, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["d" /* Style */].LINK]), __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["d" /* Style */].DEFAULT, Button))));

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(26);

var EventPluginRegistry = __webpack_require__(332);
var EventPluginUtils = __webpack_require__(333);
var ReactErrorUtils = __webpack_require__(337);

var accumulateInto = __webpack_require__(603);
var forEachAccumulated = __webpack_require__(604);
var invariant = __webpack_require__(17);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(170);
var EventPluginUtils = __webpack_require__(333);

var accumulateInto = __webpack_require__(603);
var forEachAccumulated = __webpack_require__(604);
var warning = __webpack_require__(21);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(72);

var getEventTarget = __webpack_require__(342);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1534)();
}


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__container_Layer__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__ = __webpack_require__(23);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Render a group of error bar
*/





var ErrorBar =
/*#__PURE__*/
function (_Component) {
  _inherits(ErrorBar, _Component);

  function ErrorBar() {
    _classCallCheck(this, ErrorBar);

    return _possibleConstructorReturn(this, _getPrototypeOf(ErrorBar).apply(this, arguments));
  }

  _createClass(ErrorBar, [{
    key: "renderErrorBars",
    value: function renderErrorBars() {
      var _this$props = this.props,
          offset = _this$props.offset,
          layout = _this$props.layout,
          width = _this$props.width,
          dataKey = _this$props.dataKey,
          data = _this$props.data,
          dataPointFormatter = _this$props.dataPointFormatter,
          xAxis = _this$props.xAxis,
          yAxis = _this$props.yAxis,
          others = _objectWithoutProperties(_this$props, ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"]);

      var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["a" /* getPresentationAttributes */])(others);
      return data.map(function (entry, i) {
        var _dataPointFormatter = dataPointFormatter(entry, dataKey),
            x = _dataPointFormatter.x,
            y = _dataPointFormatter.y,
            value = _dataPointFormatter.value,
            errorVal = _dataPointFormatter.errorVal;

        if (!errorVal) {
          return null;
        }

        var xMid, yMid, xMin, yMin, xMax, yMax, scale, coordsTop, coordsMid, coordsBot, lowBound, highBound;

        if (Array.isArray(errorVal)) {
          var _errorVal = _slicedToArray(errorVal, 2);

          lowBound = _errorVal[0];
          highBound = _errorVal[1];
        } else {
          lowBound = highBound = errorVal;
        }

        if (layout === 'vertical') {
          scale = xAxis.scale;
          xMid = value;
          yMid = y + offset;
          xMin = scale(xMid - lowBound);
          yMin = yMid + width;
          xMax = scale(xMid + highBound);
          yMax = yMid - width;
          coordsTop = {
            x1: xMax,
            y1: yMin,
            x2: xMax,
            y2: yMax
          };
          coordsMid = {
            x1: xMin,
            y1: yMid,
            x2: xMax,
            y2: yMid
          };
          coordsBot = {
            x1: xMin,
            y1: yMin,
            x2: xMin,
            y2: yMax
          };
        } else if (layout === 'horizontal') {
          scale = yAxis.scale;
          xMid = x + offset;
          yMid = value;
          xMin = xMid - width;
          xMax = xMid + width;
          yMin = scale(yMid - lowBound);
          yMax = scale(yMid + highBound);
          coordsTop = {
            x1: xMin,
            y1: yMax,
            x2: xMax,
            y2: yMax
          };
          coordsMid = {
            x1: xMid,
            y1: yMin,
            x2: xMid,
            y2: yMax
          };
          coordsBot = {
            x1: xMin,
            y1: yMin,
            x2: xMax,
            y2: yMin
          };
        }

        return (// eslint-disable-next-line react/no-array-index-key
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__container_Layer__["a" /* default */], _extends({
            className: "recharts-errorBar",
            key: "bar-".concat(i)
          }, props), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line", coordsTop), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line", coordsMid), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line", coordsBot))
        );
      });
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__container_Layer__["a" /* default */], {
        className: "recharts-errorBars"
      }, this.renderErrorBars());
    }
  }]);

  return ErrorBar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ErrorBar.propTypes = {
  dataKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]).isRequired,
  data: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  xAxis: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  yAxis: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  layout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  dataPointFormatter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  stroke: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  strokeWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  offset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
};
ErrorBar.defaultProps = {
  stroke: 'black',
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: 'horizontal'
};
/* harmony default export */ __webpack_exports__["a"] = (ErrorBar);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__ = __webpack_require__(23);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @fileOverview Surface
 */




var propTypes = {
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  viewBox: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }),
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node])
};

function Surface(props) {
  var children = props.children,
      width = props.width,
      height = props.height,
      viewBox = props.viewBox,
      className = props.className,
      style = props.style,
      others = _objectWithoutProperties(props, ["children", "width", "height", "viewBox", "className", "style"]);

  var svgView = viewBox || {
    width: width,
    height: height,
    x: 0,
    y: 0
  };
  var layerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-surface', className);
  var attrs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["a" /* getPresentationAttributes */])(others);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({}, attrs, {
    className: layerClass,
    width: width,
    height: height,
    style: style,
    viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height),
    version: "1.1"
  }), children);
}

Surface.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Surface);

/***/ }),
/* 177 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(666),
    baseAssignValue = __webpack_require__(370);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(147);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _createUncontrollable = __webpack_require__(1766);

var _createUncontrollable2 = _interopRequireDefault(_createUncontrollable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mixin = {
  shouldComponentUpdate: function shouldComponentUpdate() {
    //let the forceUpdate trigger the update
    return !this._notifying;
  }
};

function set(component, propName, handler, value, args) {
  if (handler) {
    component._notifying = true;
    handler.call.apply(handler, [component, value].concat(args));
    component._notifying = false;
  }

  component._values[propName] = value;

  if (!component.unmounted) component.forceUpdate();
}

exports.default = (0, _createUncontrollable2.default)(mixin, set);
module.exports = exports['default'];

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DisabledInputUtils
 */



var disableableMouseListenerNames = {
  onClick: true,
  onDoubleClick: true,
  onMouseDown: true,
  onMouseMove: true,
  onMouseUp: true,

  onClickCapture: true,
  onDoubleClickCapture: true,
  onMouseDownCapture: true,
  onMouseMoveCapture: true,
  onMouseUpCapture: true
};

/**
 * Implements a host component that does not receive mouse events
 * when `disabled` is set.
 */
var DisabledInputUtils = {
  getHostProps: function (inst, props) {
    if (!props.disabled) {
      return props;
    }

    // Copy the props, except the mouse listeners
    var hostProps = {};
    for (var key in props) {
      if (!disableableMouseListenerNames[key] && props.hasOwnProperty(key)) {
        hostProps[key] = props[key];
      }
    }

    return hostProps;
  }
};

module.exports = DisabledInputUtils;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactBrowserEventEmitter
 */



var _assign = __webpack_require__(22);

var EventConstants = __webpack_require__(67);
var EventPluginRegistry = __webpack_require__(252);
var ReactEventEmitterMixin = __webpack_require__(734);
var ViewportMetrics = __webpack_require__(407);

var getVendorPrefixedEventName = __webpack_require__(414);
var isEventSupported = __webpack_require__(269);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {

  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    var topLevelTypes = EventConstants.topLevelTypes;
    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === topLevelTypes.topWheel) {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === topLevelTypes.topScroll) {

          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {

          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening[topLevelTypes.topBlur] = true;
          isListening[topLevelTypes.topFocus] = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }

});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticMouseEvent
 */



var SyntheticUIEvent = __webpack_require__(152);
var ViewportMetrics = __webpack_require__(407);

var getEventModifierState = __webpack_require__(267);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * @providesModule escapeTextContentForBrowser
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html


/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule setInnerHTML
 */



var ExecutionEnvironment = __webpack_require__(31);
var DOMNamespaces = __webpack_require__(251);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(265);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xFEFF) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 186 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__ = __webpack_require__(188);


/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["a" /* formatDecimalParts */])(Math.abs(x)), x ? x[1] : NaN;
});


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatDecimalParts;
/* harmony default export */ __webpack_exports__["b"] = (function(x) {
  return Math.abs(x = Math.round(x)) >= 1e21
      ? x.toLocaleString("en").replace(/,/g, "")
      : x.toString(10);
});

// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function formatDecimalParts(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
}


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b = +b, function(t) {
    return a * (1 - t) + b * t;
  };
});


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Basis;
function point(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["c"] = (function(context) {
  return new Basis(context);
});


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Cardinal;
function point(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: point(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Linear(context);
});


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {});


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(40);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(84));

var on = function on() {};

if (_inDOM.default) {
  on = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

var _default = on;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getWindow;

function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}

module.exports = exports["default"];

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(40);

exports.__esModule = true;
exports.default = style;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(510));

var _hyphenateStyle = _interopRequireDefault(__webpack_require__(1150));

var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(1145));

var _removeStyle = _interopRequireDefault(__webpack_require__(1146));

var _properties = __webpack_require__(509);

var _isTransform = _interopRequireDefault(__webpack_require__(1147));

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];

    if (!value && value !== 0) {
      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
    } else if ((0, _isTransform.default)(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += _properties.transform + ": " + transforms + ";";
  }

  node.style.cssText += ';' + css;
}

module.exports = exports["default"];

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(37);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks static-only
 */



var invariant = __webpack_require__(17);

/**
 * Constructs an enumeration with keys equal to their value.
 *
 * For example:
 *
 *   var COLORS = keyMirror({blue: null, red: null});
 *   var myColor = COLORS.blue;
 *   var isColorValid = !!COLORS[myColor];
 *
 * The last line could not be performed if the values of the generated enum were
 * not equal to their keys.
 *
 *   Input:  {key1: val1, key2: val2}
 *   Output: {key1: key1, key2: key2}
 *
 * @param {object} obj
 * @return {object}
 */
var keyMirror = function keyMirror(obj) {
  var ret = {};
  var key;
  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : void 0;
  for (key in obj) {
    if (!obj.hasOwnProperty(key)) {
      continue;
    }
    ret[key] = key;
  }
  return ret;
};

module.exports = keyMirror;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1247),
    listCacheDelete = __webpack_require__(1248),
    listCacheGet = __webpack_require__(1249),
    listCacheHas = __webpack_require__(1250),
    listCacheSet = __webpack_require__(1251);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(319);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(49),
    isKey = __webpack_require__(317),
    stringToPath = __webpack_require__(1272),
    toString = __webpack_require__(1293);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1245);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(100);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(86),
    isObjectLike = __webpack_require__(71);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = all;

var _createChainableTypeChecker = __webpack_require__(211);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function all() {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  function allPropTypes() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var error = null;

    validators.forEach(function (validator) {
      if (error != null) {
        return;
      }

      var result = validator.apply(undefined, args);
      if (result != null) {
        error = result;
      }
    });

    return error;
  }

  return (0, _createChainableTypeChecker2.default)(allPropTypes);
}
module.exports = exports['default'];

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(211);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
  }

  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(validate);
module.exports = exports['default'];

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isRequiredForA11y;
function isRequiredForA11y(validator) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}
module.exports = exports['default'];

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_activeElement__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_activeElement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_activeElement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_query_contains__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_query_contains___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_dom_helpers_query_contains__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_keycode__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_all__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_elementType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_uncontrollable__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_warning__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ButtonGroup__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DropdownMenu__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DropdownToggle__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_bootstrapUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_PropTypes__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_ValidComponentChildren__ = __webpack_require__(46);


























var TOGGLE_ROLE = __WEBPACK_IMPORTED_MODULE_19__DropdownToggle__["a" /* default */].defaultProps.bsRole;
var MENU_ROLE = __WEBPACK_IMPORTED_MODULE_18__DropdownMenu__["a" /* default */].defaultProps.bsRole;

var propTypes = {
  /**
   * The menu will open above the dropdown button, instead of below it.
   */
  dropup: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * An html id attribute, necessary for assistive technologies, such as screen readers.
   * @type {string|number}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.number])),

  componentClass: __WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_elementType___default.a,

  /**
   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
   * @type {node}
   */
  children: __WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_all___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_PropTypes__["a" /* requiredRoles */])(TOGGLE_ROLE, MENU_ROLE), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_PropTypes__["b" /* exclusiveRoles */])(MENU_ROLE)),

  /**
   * Whether or not component is disabled.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * Align the menu to the right side of the Dropdown toggle
   */
  pullRight: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * Whether or not the Dropdown is visible.
   *
   * @controllable onToggle
   */
  open: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  defaultOpen: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
   * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
   *
   * ```js
   * function(Boolean isOpen, Object event, { String source }) {}
   * ```
   * @controllable open
   */
  onToggle: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * A callback fired when a menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
   * a menu button.
   */
  role: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string,

  /**
   * Which event when fired outside the component will cause it to be closed
   */
  rootCloseEvent: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.oneOf(['click', 'mousedown']),

  /**
   * @private
   */
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,
  /**
   * @private
   */
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func
};

var defaultProps = {
  componentClass: __WEBPACK_IMPORTED_MODULE_17__ButtonGroup__["a" /* default */]
};

var Dropdown = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Dropdown, _React$Component);

  function Dropdown(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Dropdown);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);

    _this._focusInDropdown = false;
    _this.lastOpenEventType = null;
    return _this;
  }

  Dropdown.prototype.componentDidMount = function componentDidMount() {
    this.focusNextOnOpen();
  };

  Dropdown.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    if (!nextProps.open && this.props.open) {
      this._focusInDropdown = __WEBPACK_IMPORTED_MODULE_7_dom_helpers_query_contains___default()(__WEBPACK_IMPORTED_MODULE_11_react_dom___default.a.findDOMNode(this.menu), __WEBPACK_IMPORTED_MODULE_6_dom_helpers_activeElement___default()(document));
    }
  };

  Dropdown.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var open = this.props.open;

    var prevOpen = prevProps.open;

    if (open && !prevOpen) {
      this.focusNextOnOpen();
    }

    if (!open && prevOpen) {
      // if focus hasn't already moved from the menu let's return it
      // to the toggle
      if (this._focusInDropdown) {
        this._focusInDropdown = false;
        this.focus();
      }
    }
  };

  Dropdown.prototype.focus = function focus() {
    var toggle = __WEBPACK_IMPORTED_MODULE_11_react_dom___default.a.findDOMNode(this.toggle);

    if (toggle && toggle.focus) {
      toggle.focus();
    }
  };

  Dropdown.prototype.focusNextOnOpen = function focusNextOnOpen() {
    var menu = this.menu;

    if (!menu.focusNext) {
      return;
    }

    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
      menu.focusNext();
    }
  };

  Dropdown.prototype.handleClick = function handleClick(event) {
    if (this.props.disabled) {
      return;
    }

    this.toggleOpen(event, { source: 'click' });
  };

  Dropdown.prototype.handleClose = function handleClose(event, eventDetails) {
    if (!this.props.open) {
      return;
    }

    this.toggleOpen(event, eventDetails);
  };

  Dropdown.prototype.handleKeyDown = function handleKeyDown(event) {
    if (this.props.disabled) {
      return;
    }

    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_8_keycode___default.a.codes.down:
        if (!this.props.open) {
          this.toggleOpen(event, { source: 'keydown' });
        } else if (this.menu.focusNext) {
          this.menu.focusNext();
        }
        event.preventDefault();
        break;
      case __WEBPACK_IMPORTED_MODULE_8_keycode___default.a.codes.esc:
      case __WEBPACK_IMPORTED_MODULE_8_keycode___default.a.codes.tab:
        this.handleClose(event, { source: 'keydown' });
        break;
      default:
    }
  };

  Dropdown.prototype.toggleOpen = function toggleOpen(event, eventDetails) {
    var open = !this.props.open;

    if (open) {
      this.lastOpenEventType = eventDetails.source;
    }

    if (this.props.onToggle) {
      this.props.onToggle(open, event, eventDetails);
    }
  };

  Dropdown.prototype.renderMenu = function renderMenu(child, _ref) {
    var _this2 = this;

    var id = _ref.id,
        onSelect = _ref.onSelect,
        rootCloseEvent = _ref.rootCloseEvent,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['id', 'onSelect', 'rootCloseEvent']);

    var ref = function ref(c) {
      _this2.menu = c;
    };

    if (typeof child.ref === 'string') {
       false ? warning(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.ref, ref);
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react__["cloneElement"])(child, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      ref: ref,
      labelledBy: id,
      bsClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_bootstrapUtils__["e" /* prefix */])(props, 'menu'),
      onClose: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.props.onClose, this.handleClose),
      onSelect: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect, function (key, event) {
        return _this2.handleClose(event, { source: 'select' });
      }),
      rootCloseEvent: rootCloseEvent
    }));
  };

  Dropdown.prototype.renderToggle = function renderToggle(child, props) {
    var _this3 = this;

    var ref = function ref(c) {
      _this3.toggle = c;
    };

    if (typeof child.ref === 'string') {
       false ? warning(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.ref, ref);
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react__["cloneElement"])(child, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      ref: ref,
      bsClass: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_bootstrapUtils__["e" /* prefix */])(props, 'toggle'),
      onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.props.onClick, this.handleClick),
      onKeyDown: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils_createChainedFunction__["a" /* default */])(child.props.onKeyDown, this.handleKeyDown)
    }));
  };

  Dropdown.prototype.render = function render() {
    var _classes,
        _this4 = this;

    var _props = this.props,
        Component = _props.componentClass,
        id = _props.id,
        dropup = _props.dropup,
        disabled = _props.disabled,
        pullRight = _props.pullRight,
        open = _props.open,
        onSelect = _props.onSelect,
        role = _props.role,
        bsClass = _props.bsClass,
        className = _props.className,
        rootCloseEvent = _props.rootCloseEvent,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'id', 'dropup', 'disabled', 'pullRight', 'open', 'onSelect', 'role', 'bsClass', 'className', 'rootCloseEvent', 'children']);

    delete props.onToggle;

    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);

    if (dropup) {
      classes[bsClass] = false;
      classes.dropup = true;
    }

    // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.

    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_23__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        switch (child.props.bsRole) {
          case TOGGLE_ROLE:
            return _this4.renderToggle(child, {
              id: id, disabled: disabled, open: open, role: role, bsClass: bsClass
            });
          case MENU_ROLE:
            return _this4.renderMenu(child, {
              id: id, open: open, pullRight: pullRight, bsClass: bsClass, onSelect: onSelect, rootCloseEvent: rootCloseEvent
            });
          default:
            return child;
        }
      })
    );
  };

  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);

Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__utils_bootstrapUtils__["c" /* bsClass */])('dropdown', Dropdown);

var UncontrolledDropdown = __WEBPACK_IMPORTED_MODULE_15_uncontrollable___default()(Dropdown, { open: 'onToggle' });

UncontrolledDropdown.Toggle = __WEBPACK_IMPORTED_MODULE_19__DropdownToggle__["a" /* default */];
UncontrolledDropdown.Menu = __WEBPACK_IMPORTED_MODULE_18__DropdownMenu__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (UncontrolledDropdown);

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_overlays_lib_Transition__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_overlays_lib_Transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_overlays_lib_Transition__);









var propTypes = {
  /**
   * Show the component; triggers the fade in or fade out animation
   */
  in: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is faded out
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Run the fade in animation when the component mounts, if it is initially
   * shown
   */
  transitionAppear: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Duration of the fade animation in milliseconds, to ensure that finishing
   * callbacks are fired even if the original browser transition end events are
   * canceled
   */
  timeout: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,

  /**
   * Callback fired before the component fades in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to fade in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  /**
   * Callback fired after the has component faded in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  /**
   * Callback fired before the component fades out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to fade out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  /**
   * Callback fired after the component has faded out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};

var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  transitionAppear: false
};

var Fade = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Fade, _React$Component);

  function Fade() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Fade);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Fade.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_overlays_lib_Transition___default.a, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(this.props.className, 'fade'),
      enteredClassName: 'in',
      enteringClassName: 'in'
    }));
  };

  return Fade;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Fade.propTypes = propTypes;
Fade.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Fade);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MediaBody__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MediaHeading__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MediaLeft__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MediaList__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__MediaListItem__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__MediaRight__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__ = __webpack_require__(20);

















var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var Media = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Media, _React$Component);

  function Media() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Media);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Media.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Media;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Media.propTypes = propTypes;
Media.defaultProps = defaultProps;

Media.Heading = __WEBPACK_IMPORTED_MODULE_9__MediaHeading__["a" /* default */];
Media.Body = __WEBPACK_IMPORTED_MODULE_8__MediaBody__["a" /* default */];
Media.Left = __WEBPACK_IMPORTED_MODULE_10__MediaLeft__["a" /* default */];
Media.Right = __WEBPACK_IMPORTED_MODULE_13__MediaRight__["a" /* default */];
Media.List = __WEBPACK_IMPORTED_MODULE_11__MediaList__["a" /* default */];
Media.ListItem = __WEBPACK_IMPORTED_MODULE_12__MediaListItem__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["c" /* bsClass */])('media', Media));

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = splitComponentProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);

function splitComponentProps(props, Component) {
  var componentPropTypes = Component.propTypes;

  var parentProps = {};
  var childProps = {};

  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (componentPropTypes[propName]) {
      parentProps[propName] = propValue;
    } else {
      childProps[propName] = propValue;
    }
  });

  return [parentProps, childProps];
}

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(22);

var EventPluginRegistry = __webpack_require__(332);
var ReactEventEmitterMixin = __webpack_require__(1436);
var ViewportMetrics = __webpack_require__(602);

var getVendorPrefixedEventName = __webpack_require__(1468);
var isEventSupported = __webpack_require__(343);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(173);
var ViewportMetrics = __webpack_require__(602);

var getEventModifierState = __webpack_require__(341);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(26);

var invariant = __webpack_require__(17);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(31);
var DOMNamespaces = __webpack_require__(331);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(339);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getContainer;

var _reactDom = __webpack_require__(33);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
}
module.exports = exports['default'];

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1513)();
}


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getIntersectionKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return identity; });
/* unused harmony export getDashCase */
/* unused harmony export generatePrefixStyle */
/* unused harmony export log */
/* unused harmony export debug */
/* unused harmony export debugf */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return mapObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return translateStyle; });
/* unused harmony export compose */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getTransitionVal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return warn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_intersection__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_intersection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_intersection__);


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint no-console: 0 */
var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
var IN_LINE_PREFIX_LIST = ['-webkit-', '-moz-', '-o-', '-ms-'];
var IN_COMPATIBLE_PROPERTY = ['transform', 'transformOrigin', 'transition'];
var getIntersectionKeys = function getIntersectionKeys(preObj, nextObj) {
  return __WEBPACK_IMPORTED_MODULE_0_lodash_intersection___default()(Object.keys(preObj), Object.keys(nextObj));
};
var identity = function identity(param) {
  return param;
};
/*
 * @description: convert camel case to dash case
 * string => string
 */

var getDashCase = function getDashCase(name) {
  return name.replace(/([A-Z])/g, function (v) {
    return "-".concat(v.toLowerCase());
  });
};
/*
 * @description: add compatible style prefix
 * (string, string) => object
 */

var generatePrefixStyle = function generatePrefixStyle(name, value) {
  if (IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) {
    return _defineProperty({}, name, value);
  }

  var isTransition = name === 'transition';
  var camelName = name.replace(/(\w)/, function (v) {
    return v.toUpperCase();
  });
  var styleVal = value;
  return PREFIX_LIST.reduce(function (result, property, i) {
    if (isTransition) {
      styleVal = value.replace(/(transform|transform-origin)/gim, "".concat(IN_LINE_PREFIX_LIST[i], "$1"));
    }

    return _objectSpread({}, result, _defineProperty({}, property + camelName, styleVal));
  }, {});
};
var log = function log() {
  var _console;

  (_console = console).log.apply(_console, arguments);
};
/*
 * @description: log the value of a varible
 * string => any => any
 */

var debug = function debug(name) {
  return function (item) {
    log(name, item);
    return item;
  };
};
/*
 * @description: log name, args, return value of a function
 * function => function
 */

var debugf = function debugf(tag, f) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var res = f.apply(void 0, args);
    var name = tag || f.name || 'anonymous function';
    var argNames = "(".concat(args.map(JSON.stringify).join(', '), ")");
    log("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
    return res;
  };
};
/*
 * @description: map object on every element in this object.
 * (function, object) => object
 */

var mapObject = function mapObject(fn, obj) {
  return Object.keys(obj).reduce(function (res, key) {
    return _objectSpread({}, res, _defineProperty({}, key, fn(key, obj[key])));
  }, {});
};
/*
 * @description: add compatible prefix to style
 * object => object
 */

var translateStyle = function translateStyle(style) {
  return Object.keys(style).reduce(function (res, key) {
    return _objectSpread({}, res, generatePrefixStyle(key, res[key]));
  }, style);
};
var compose = function compose() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (!args.length) {
    return identity;
  }

  var fns = args.reverse(); // first function can receive multiply arguments

  var firstFn = fns[0];
  var tailsFn = fns.slice(1);
  return function () {
    return tailsFn.reduce(function (res, fn) {
      return fn(res);
    }, firstFn.apply(void 0, arguments));
  };
};
var getTransitionVal = function getTransitionVal(props, duration, easing) {
  return props.map(function (prop) {
    return "".concat(getDashCase(prop), " ").concat(duration, "ms ").concat(easing);
  }).join(',');
};
var isDev = "production" !== 'production';
var warn = function warn(condition, format, a, b, c, d, e, f) {
  if (isDev && typeof console !== 'undefined' && console.warn) {
    if (format === undefined) {
      console.warn('LogUtils requires an error message argument');
    }

    if (!condition) {
      if (format === undefined) {
        console.warn('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
      } else {
        var args = [a, b, c, d, e, f];
        var argIndex = 0;
        console.warn(format.replace(/%s/g, function () {
          return args[argIndex++];
        }));
      }
    }
  }
};

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Z Axis
 */



var ZAxis =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ZAxis, _PureComponent);

  function ZAxis() {
    _classCallCheck(this, ZAxis);

    return _possibleConstructorReturn(this, _getPrototypeOf(ZAxis).apply(this, arguments));
  }

  _createClass(ZAxis, [{
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return ZAxis;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

ZAxis.displayName = 'ZAxis';
ZAxis.propTypes = {
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['number', 'category']),
  // The name of data displayed in the axis
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The unit of data displayed in the axis
  unit: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The unique id of z-axis
  zAxisId: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),
  // The key of data displayed in the axis
  dataKey: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func]),
  // The range of axis
  range: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),
  scale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold']), __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
ZAxis.defaultProps = {
  zAxisId: 0,
  range: [64, 64],
  scale: 'auto',
  type: 'number'
};
/* harmony default export */ __webpack_exports__["a"] = (ZAxis);

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_smooth__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DefaultTooltipContent__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_DataUtils__ = __webpack_require__(27);




function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Tooltip
 */







var CLS_PREFIX = 'recharts-tooltip-wrapper';
var EPS = 1;

var defaultUniqBy = function defaultUniqBy(entry) {
  return entry.dataKey;
};

var getUniqPaylod = function getUniqPaylod(option, payload) {
  if (option === true) {
    return __WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy___default()(payload, defaultUniqBy);
  }

  if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(option)) {
    return __WEBPACK_IMPORTED_MODULE_2_lodash_uniqBy___default()(payload, option);
  }

  return payload;
};

var propTypes = {
  allowEscapeViewBox: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a["boolean"],
    y: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a["boolean"]
  }),
  content: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]),
  viewBox: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    width: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number
  }),
  active: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  separator: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  formatter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  offset: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  itemStyle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  labelStyle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  wrapperStyle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  contentStyle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  cursor: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object]),
  coordinate: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number
  }),
  position: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number
  }),
  label: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
  payload: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
    value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.array]),
    unit: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
    type: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["g" /* TOOLTIP_TYPES */])
  })),
  paylodUniqBy: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool]),
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  animationDuration: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
  itemSorter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  filterNull: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  useTranslate3d: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
};
var defaultProps = {
  active: false,
  allowEscapeViewBox: {
    x: false,
    y: false
  },
  offset: 10,
  viewBox: {
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 0
  },
  coordinate: {
    x: 0,
    y: 0
  },
  cursorStyle: {},
  separator: ' : ',
  wrapperStyle: {},
  contentStyle: {},
  itemStyle: {},
  labelStyle: {},
  cursor: true,
  isAnimationActive: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["h" /* isSsr */])(),
  animationEasing: 'ease',
  animationDuration: 400,
  filterNull: true,
  useTranslate3d: false
};

var renderContent = function renderContent(content, props) {
  if (__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(content)) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(content, props);
  }

  if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(content)) {
    return content(props);
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__DefaultTooltipContent__["a" /* default */], props);
};

var Tooltip =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Tooltip, _PureComponent);

  function Tooltip() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tooltip)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      boxWidth: -1,
      boxHeight: -1
    };

    _this.getTranslate = function (_ref) {
      var key = _ref.key,
          tooltipDimension = _ref.tooltipDimension,
          viewBoxDimension = _ref.viewBoxDimension;
      var _this$props = _this.props,
          allowEscapeViewBox = _this$props.allowEscapeViewBox,
          coordinate = _this$props.coordinate,
          offset = _this$props.offset,
          position = _this$props.position,
          viewBox = _this$props.viewBox;

      if (position && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["a" /* isNumber */])(position[key])) {
        return position[key];
      }

      var restricted = coordinate[key] - tooltipDimension - offset;
      var unrestricted = coordinate[key] + offset;

      if (allowEscapeViewBox[key]) {
        return unrestricted;
      }

      var tooltipBoundary = coordinate[key] + tooltipDimension + offset;
      var viewBoxBoundary = viewBox[key] + viewBoxDimension;

      if (tooltipBoundary > viewBoxBoundary) {
        return Math.max(restricted, viewBox[key]);
      }

      return Math.max(unrestricted, viewBox[key]);
    };

    return _this;
  }

  _createClass(Tooltip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateBBox();
    }
  }, {
    key: "updateBBox",
    value: function updateBBox() {
      var _this$state = this.state,
          boxWidth = _this$state.boxWidth,
          boxHeight = _this$state.boxHeight;

      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var box = this.wrapperNode.getBoundingClientRect();

        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
          this.setState({
            boxWidth: box.width,
            boxHeight: box.height
          });
        }
      } else if (boxWidth !== -1 || boxHeight !== -1) {
        this.setState({
          boxWidth: -1,
          boxHeight: -1
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var _this$props2 = this.props,
          payload = _this$props2.payload,
          isAnimationActive = _this$props2.isAnimationActive,
          animationDuration = _this$props2.animationDuration,
          animationEasing = _this$props2.animationEasing,
          filterNull = _this$props2.filterNull,
          paylodUniqBy = _this$props2.paylodUniqBy;
      var finalPayload = getUniqPaylod(paylodUniqBy, filterNull && payload && payload.length ? payload.filter(function (entry) {
        return !__WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(entry.value);
      }) : payload);
      var hasPayload = finalPayload && finalPayload.length;
      var _this$props3 = this.props,
          content = _this$props3.content,
          viewBox = _this$props3.viewBox,
          coordinate = _this$props3.coordinate,
          position = _this$props3.position,
          active = _this$props3.active,
          wrapperStyle = _this$props3.wrapperStyle;

      var outerStyle = _objectSpread({
        pointerEvents: 'none',
        visibility: active && hasPayload ? 'visible' : 'hidden',
        position: 'absolute',
        top: 0
      }, wrapperStyle);

      var translateX, translateY;

      if (position && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["a" /* isNumber */])(position.x) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["a" /* isNumber */])(position.y)) {
        translateX = position.x;
        translateY = position.y;
      } else {
        var _this$state2 = this.state,
            boxWidth = _this$state2.boxWidth,
            boxHeight = _this$state2.boxHeight;

        if (boxWidth > 0 && boxHeight > 0 && coordinate) {
          translateX = this.getTranslate({
            key: 'x',
            tooltipDimension: boxWidth,
            viewBoxDimension: viewBox.width
          });
          translateY = this.getTranslate({
            key: 'y',
            tooltipDimension: boxHeight,
            viewBoxDimension: viewBox.height
          });
        } else {
          outerStyle.visibility = 'hidden';
        }
      }

      outerStyle = _objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_smooth__["b" /* translateStyle */])({
        transform: this.props.useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
      }), {}, outerStyle);

      if (isAnimationActive && active) {
        outerStyle = _objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_smooth__["b" /* translateStyle */])({
          transition: "transform ".concat(animationDuration, "ms ").concat(animationEasing)
        }), {}, outerStyle);
      }

      var cls = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(CLS_PREFIX, (_classNames = {}, _defineProperty(_classNames, "".concat(CLS_PREFIX, "-right"), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["a" /* isNumber */])(translateX) && coordinate && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["a" /* isNumber */])(coordinate.x) && translateX >= coordinate.x), _defineProperty(_classNames, "".concat(CLS_PREFIX, "-left"), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["a" /* isNumber */])(translateX) && coordinate && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["a" /* isNumber */])(coordinate.x) && translateX < coordinate.x), _defineProperty(_classNames, "".concat(CLS_PREFIX, "-bottom"), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["a" /* isNumber */])(translateY) && coordinate && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["a" /* isNumber */])(coordinate.y) && translateY >= coordinate.y), _defineProperty(_classNames, "".concat(CLS_PREFIX, "-top"), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["a" /* isNumber */])(translateY) && coordinate && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["a" /* isNumber */])(coordinate.y) && translateY < coordinate.y), _classNames));
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
        className: cls,
        style: outerStyle,
        ref: function ref(node) {
          _this2.wrapperNode = node;
        }
      }, renderContent(content, _objectSpread({}, this.props, {
        payload: finalPayload
      })));
    }
  }]);

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_3_react__["PureComponent"]);

Tooltip.displayName = 'Tooltip';
Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__container_Layer__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shape_Dot__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shape_Polygon__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_Text__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_PolarUtils__ = __webpack_require__(54);


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Axis of radial direction
 */








var RADIAN = Math.PI / 180;
var eps = 1e-5;

var PolarAngleAxis =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(PolarAngleAxis, _PureComponent);

  function PolarAngleAxis() {
    _classCallCheck(this, PolarAngleAxis);

    return _possibleConstructorReturn(this, _getPrototypeOf(PolarAngleAxis).apply(this, arguments));
  }

  _createClass(PolarAngleAxis, [{
    key: "getTickLineCoord",

    /**
     * Calculate the coordinate of line endpoint
     * @param  {Object} data The Data if ticks
     * @return {Object} (x0, y0): The start point of text,
     *                  (x1, y1): The end point close to text,
     *                  (x2, y2): The end point close to axis
     */
    value: function getTickLineCoord(data) {
      var _this$props = this.props,
          cx = _this$props.cx,
          cy = _this$props.cy,
          radius = _this$props.radius,
          orientation = _this$props.orientation,
          tickLine = _this$props.tickLine;
      var tickLineSize = tickLine && tickLine.size || 8;
      var p1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, radius, data.coordinate);
      var p2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, radius + (orientation === 'inner' ? -1 : 1) * tickLineSize, data.coordinate);
      return {
        x1: p1.x,
        y1: p1.y,
        x2: p2.x,
        y2: p2.y
      };
    }
    /**
     * Get the text-anchor of each tick
     * @param  {Object} data Data of ticks
     * @return {String} text-anchor
     */

  }, {
    key: "getTickTextAnchor",
    value: function getTickTextAnchor(data) {
      var orientation = this.props.orientation;
      var cos = Math.cos(-data.coordinate * RADIAN);
      var textAnchor;

      if (cos > eps) {
        textAnchor = orientation === 'outer' ? 'start' : 'end';
      } else if (cos < -eps) {
        textAnchor = orientation === 'outer' ? 'end' : 'start';
      } else {
        textAnchor = 'middle';
      }

      return textAnchor;
    }
  }, {
    key: "renderAxisLine",
    value: function renderAxisLine() {
      var _this$props2 = this.props,
          cx = _this$props2.cx,
          cy = _this$props2.cy,
          radius = _this$props2.radius,
          axisLine = _this$props2.axisLine,
          axisLineType = _this$props2.axisLineType;

      var props = _objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props), {
        fill: 'none'
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["a" /* getPresentationAttributes */])(axisLine));

      if (axisLineType === 'circle') {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shape_Dot__["a" /* default */], _extends({
          className: "recharts-polar-angle-axis-line"
        }, props, {
          cx: cx,
          cy: cy,
          r: radius
        }));
      }

      var ticks = this.props.ticks;
      var points = ticks.map(function (entry) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, radius, entry.coordinate);
      });
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__shape_Polygon__["a" /* default */], _extends({
        className: "recharts-polar-angle-axis-line"
      }, props, {
        points: points
      }));
    }
  }, {
    key: "renderTicks",
    value: function renderTicks() {
      var _this = this;

      var _this$props3 = this.props,
          ticks = _this$props3.ticks,
          tick = _this$props3.tick,
          tickLine = _this$props3.tickLine,
          tickFormatter = _this$props3.tickFormatter,
          stroke = _this$props3.stroke;
      var axisProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props);
      var customTickProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["a" /* getPresentationAttributes */])(tick);

      var tickLineProps = _objectSpread({}, axisProps, {
        fill: 'none'
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["a" /* getPresentationAttributes */])(tickLine));

      var items = ticks.map(function (entry, i) {
        var lineCoord = _this.getTickLineCoord(entry);

        var textAnchor = _this.getTickTextAnchor(entry);

        var tickProps = _objectSpread({
          textAnchor: textAnchor
        }, axisProps, {
          stroke: 'none',
          fill: stroke
        }, customTickProps, {
          index: i,
          payload: entry,
          x: lineCoord.x2,
          y: lineCoord.y2
        });

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__container_Layer__["a" /* default */], _extends({
          className: "recharts-polar-angle-axis-tick",
          key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key

        }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["e" /* filterEventsOfChild */])(_this.props, entry, i)), tickLine && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line", _extends({
          className: "recharts-polar-angle-axis-tick-line"
        }, tickLineProps, lineCoord)), tick && _this.constructor.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value));
      });
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__container_Layer__["a" /* default */], {
        className: "recharts-polar-angle-axis-ticks"
      }, items);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          ticks = _this$props4.ticks,
          radius = _this$props4.radius,
          axisLine = _this$props4.axisLine;

      if (radius <= 0 || !ticks || !ticks.length) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__container_Layer__["a" /* default */], {
        className: "recharts-polar-angle-axis"
      }, axisLine && this.renderAxisLine(), this.renderTicks());
    }
  }], [{
    key: "renderTickItem",
    value: function renderTickItem(option, props, value) {
      var tickItem;

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
        tickItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        tickItem = option(props);
      } else {
        tickItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__component_Text__["a" /* default */], _extends({}, props, {
          className: "recharts-polar-angle-axis-tick-value"
        }), value);
      }

      return tickItem;
    }
  }]);

  return PolarAngleAxis;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

PolarAngleAxis.displayName = 'PolarAngleAxis';
PolarAngleAxis.axisType = 'angleAxis';
PolarAngleAxis.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {}, __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["d" /* EVENT_ATTRIBUTES */], {
  type: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['number', 'category']),
  angleAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  dataKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]),
  cx: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  radius: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  hide: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  scale: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["q" /* SCALE_TYPES */]), __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]),
  axisLine: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]),
  axisLineType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['polygon', 'circle']),
  tickLine: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]),
  tick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element]),
  ticks: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    value: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
    coordinate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  })),
  stroke: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  orientation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['inner', 'outer']),
  tickFormatter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  allowDuplicatedCategory: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
});
PolarAngleAxis.defaultProps = {
  type: 'category',
  angleAxisId: 0,
  scale: 'auto',
  cx: 0,
  cy: 0,
  domain: [0, 'auto'],
  orientation: 'outer',
  axisLine: true,
  tickLine: true,
  tick: true,
  hide: false,
  allowDuplicatedCategory: true
};
/* harmony default export */ __webpack_exports__["a"] = (PolarAngleAxis);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_minBy__ = __webpack_require__(1743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_minBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_minBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_maxBy__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component_Text__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__component_Label__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__container_Layer__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__ = __webpack_require__(54);




function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview The axis of polar coordinate system
 */








var PolarRadiusAxis =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(PolarRadiusAxis, _PureComponent);

  function PolarRadiusAxis() {
    _classCallCheck(this, PolarRadiusAxis);

    return _possibleConstructorReturn(this, _getPrototypeOf(PolarRadiusAxis).apply(this, arguments));
  }

  _createClass(PolarRadiusAxis, [{
    key: "getTickValueCoord",

    /**
     * Calculate the coordinate of tick
     * @param  {Number} coordinate The radius of tick
     * @return {Object} (x, y)
     */
    value: function getTickValueCoord(_ref) {
      var coordinate = _ref.coordinate;
      var _this$props = this.props,
          angle = _this$props.angle,
          cx = _this$props.cx,
          cy = _this$props.cy;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, coordinate, angle);
    }
  }, {
    key: "getTickTextAnchor",
    value: function getTickTextAnchor() {
      var orientation = this.props.orientation;
      var textAnchor;

      switch (orientation) {
        case 'left':
          textAnchor = 'end';
          break;

        case 'right':
          textAnchor = 'start';
          break;

        default:
          textAnchor = 'middle';
          break;
      }

      return textAnchor;
    }
  }, {
    key: "getViewBox",
    value: function getViewBox() {
      var _this$props2 = this.props,
          cx = _this$props2.cx,
          cy = _this$props2.cy,
          angle = _this$props2.angle,
          ticks = _this$props2.ticks;

      var maxRadiusTick = __WEBPACK_IMPORTED_MODULE_2_lodash_maxBy___default()(ticks, function (entry) {
        return entry.coordinate || 0;
      });

      var minRadiusTick = __WEBPACK_IMPORTED_MODULE_1_lodash_minBy___default()(ticks, function (entry) {
        return entry.coordinate || 0;
      });

      return {
        cx: cx,
        cy: cy,
        startAngle: angle,
        endAngle: angle,
        innerRadius: minRadiusTick.coordinate || 0,
        outerRadius: maxRadiusTick.coordinate || 0
      };
    }
  }, {
    key: "renderAxisLine",
    value: function renderAxisLine() {
      var _this$props3 = this.props,
          cx = _this$props3.cx,
          cy = _this$props3.cy,
          angle = _this$props3.angle,
          ticks = _this$props3.ticks,
          axisLine = _this$props3.axisLine,
          others = _objectWithoutProperties(_this$props3, ["cx", "cy", "angle", "ticks", "axisLine"]);

      var extent = ticks.reduce(function (result, entry) {
        return [Math.min(result[0], entry.coordinate), Math.max(result[1], entry.coordinate)];
      }, [Infinity, -Infinity]);
      var point0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, extent[0], angle);
      var point1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, extent[1], angle);

      var props = _objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["a" /* getPresentationAttributes */])(others), {
        fill: 'none'
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["a" /* getPresentationAttributes */])(axisLine), {
        x1: point0.x,
        y1: point0.y,
        x2: point1.x,
        y2: point1.y
      });

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("line", _extends({
        className: "recharts-polar-radius-axis-line"
      }, props));
    }
  }, {
    key: "renderTicks",
    value: function renderTicks() {
      var _this = this;

      var _this$props4 = this.props,
          ticks = _this$props4.ticks,
          tick = _this$props4.tick,
          angle = _this$props4.angle,
          tickFormatter = _this$props4.tickFormatter,
          stroke = _this$props4.stroke,
          others = _objectWithoutProperties(_this$props4, ["ticks", "tick", "angle", "tickFormatter", "stroke"]);

      var textAnchor = this.getTickTextAnchor();
      var axisProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["a" /* getPresentationAttributes */])(others);
      var customTickProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["a" /* getPresentationAttributes */])(tick);
      var items = ticks.map(function (entry, i) {
        var coord = _this.getTickValueCoord(entry);

        var tickProps = _objectSpread({
          textAnchor: textAnchor,
          transform: "rotate(".concat(90 - angle, ", ").concat(coord.x, ", ").concat(coord.y, ")")
        }, axisProps, {
          stroke: 'none',
          fill: stroke
        }, customTickProps, {
          index: i
        }, coord, {
          payload: entry
        });

        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */], _extends({
          className: "recharts-polar-radius-axis-tick",
          key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key

        }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["e" /* filterEventsOfChild */])(_this.props, entry, i)), _this.constructor.renderTickItem(tick, tickProps, tickFormatter ? tickFormatter(entry.value) : entry.value));
      });
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */], {
        className: "recharts-polar-radius-axis-ticks"
      }, items);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          ticks = _this$props5.ticks,
          axisLine = _this$props5.axisLine,
          tick = _this$props5.tick;

      if (!ticks || !ticks.length) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */], {
        className: "recharts-polar-radius-axis"
      }, axisLine && this.renderAxisLine(), tick && this.renderTicks(), __WEBPACK_IMPORTED_MODULE_6__component_Label__["a" /* default */].renderCallByParent(this.props, this.getViewBox()));
    }
  }], [{
    key: "renderTickItem",
    value: function renderTickItem(option, props, value) {
      var tickItem;

      if (__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(option)) {
        tickItem = __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        tickItem = option(props);
      } else {
        tickItem = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__component_Text__["a" /* default */], _extends({}, props, {
          className: "recharts-polar-radius-axis-tick-value"
        }), value);
      }

      return tickItem;
    }
  }]);

  return PolarRadiusAxis;
}(__WEBPACK_IMPORTED_MODULE_3_react__["PureComponent"]);

PolarRadiusAxis.displayName = 'PolarRadiusAxis';
PolarRadiusAxis.axisType = 'radiusAxis';
PolarRadiusAxis.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {}, __WEBPACK_IMPORTED_MODULE_8__util_ReactUtils__["d" /* EVENT_ATTRIBUTES */], {
  type: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['number', 'category']),
  cx: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  hide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  radiusAxisId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  angle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  tickCount: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  ticks: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
    coordinate: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number
  })),
  orientation: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['left', 'right', 'middle']),
  axisLine: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object]),
  tick: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]),
  stroke: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  tickFormatter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  domain: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['auto', 'dataMin', 'dataMax'])])),
  scale: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['auto', 'linear', 'pow', 'sqrt', 'log', 'identity', 'time', 'band', 'point', 'ordinal', 'quantile', 'quantize', 'utc', 'sequential', 'threshold']), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]),
  allowDataOverflow: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  allowDuplicatedCategory: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
});
PolarRadiusAxis.defaultProps = {
  type: 'number',
  radiusAxisId: 0,
  cx: 0,
  cy: 0,
  angle: 0,
  orientation: 'right',
  stroke: '#ccc',
  axisLine: true,
  tick: true,
  tickCount: 5,
  domain: [0, 'auto'],
  allowDataOverflow: false,
  scale: 'auto',
  allowDuplicatedCategory: true
};
/* harmony default export */ __webpack_exports__["a"] = (PolarRadiusAxis);

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__ = __webpack_require__(23);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Polygon
 */





var getPolygonPoints = function getPolygonPoints(points) {
  return points.reduce(function (result, entry) {
    if (entry.x === +entry.x && entry.y === +entry.y) {
      result.push([entry.x, entry.y]);
    }

    return result;
  }, []).join(' ');
};

var Polygon =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Polygon, _PureComponent);

  function Polygon() {
    _classCallCheck(this, Polygon);

    return _possibleConstructorReturn(this, _getPrototypeOf(Polygon).apply(this, arguments));
  }

  _createClass(Polygon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          points = _this$props.points,
          className = _this$props.className;

      if (!points || !points.length) {
        return null;
      }

      var layerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-polygon', className);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon", _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["b" /* filterEventAttributes */])(this.props), {
        className: layerClass,
        points: getPolygonPoints(points)
      }));
    }
  }]);

  return Polygon;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Polygon.displayName = 'Polygon';
Polygon.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  points: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number
  }))
});
/* harmony default export */ __webpack_exports__["a"] = (Polygon);

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_DataUtils__ = __webpack_require__(27);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Sector
 */







var getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
  var sign = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["d" /* mathSign */])(endAngle - startAngle);
  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
  return sign * deltaAngle;
};

var getTangentCircle = function getTangentCircle(_ref) {
  var cx = _ref.cx,
      cy = _ref.cy,
      radius = _ref.radius,
      angle = _ref.angle,
      sign = _ref.sign,
      isExternal = _ref.isExternal,
      cornerRadius = _ref.cornerRadius,
      cornerIsExternal = _ref.cornerIsExternal;
  var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
  var theta = Math.asin(cornerRadius / centerRadius) / __WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__["c" /* RADIAN */];
  var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
  var center = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, centerRadius, centerAngle); // The coordinate of point which is tangent to the circle

  var circleTangency = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, radius, centerAngle); // The coordinate of point which is tangent to the radius line

  var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
  var lineTangency = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, centerRadius * Math.cos(theta * __WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__["c" /* RADIAN */]), lineTangencyAngle);
  return {
    center: center,
    circleTangency: circleTangency,
    lineTangency: lineTangency,
    theta: theta
  };
};

var getSectorPath = function getSectorPath(_ref2) {
  var cx = _ref2.cx,
      cy = _ref2.cy,
      innerRadius = _ref2.innerRadius,
      outerRadius = _ref2.outerRadius,
      startAngle = _ref2.startAngle,
      endAngle = _ref2.endAngle;
  var angle = getDeltaAngle(startAngle, endAngle); // When the angle of sector equals to 360, star point and end point coincide

  var tempEndAngle = startAngle + angle;
  var outerStartPoint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, outerRadius, startAngle);
  var outerEndPoint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, outerRadius, tempEndAngle);
  var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");

  if (innerRadius > 0) {
    var innerStartPoint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, innerRadius, startAngle);
    var innerEndPoint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, innerRadius, tempEndAngle);
    path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
  } else {
    path += "L ".concat(cx, ",").concat(cy, " Z");
  }

  return path;
};

var getSectorWithCorner = function getSectorWithCorner(_ref3) {
  var cx = _ref3.cx,
      cy = _ref3.cy,
      innerRadius = _ref3.innerRadius,
      outerRadius = _ref3.outerRadius,
      cornerRadius = _ref3.cornerRadius,
      forceCornerRadius = _ref3.forceCornerRadius,
      cornerIsExternal = _ref3.cornerIsExternal,
      startAngle = _ref3.startAngle,
      endAngle = _ref3.endAngle;
  var sign = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["d" /* mathSign */])(endAngle - startAngle);

  var _getTangentCircle = getTangentCircle({
    cx: cx,
    cy: cy,
    radius: outerRadius,
    angle: startAngle,
    sign: sign,
    cornerRadius: cornerRadius,
    cornerIsExternal: cornerIsExternal
  }),
      soct = _getTangentCircle.circleTangency,
      solt = _getTangentCircle.lineTangency,
      sot = _getTangentCircle.theta;

  var _getTangentCircle2 = getTangentCircle({
    cx: cx,
    cy: cy,
    radius: outerRadius,
    angle: endAngle,
    sign: -sign,
    cornerRadius: cornerRadius,
    cornerIsExternal: cornerIsExternal
  }),
      eoct = _getTangentCircle2.circleTangency,
      eolt = _getTangentCircle2.lineTangency,
      eot = _getTangentCircle2.theta;

  var outerArcAngle = Math.abs(startAngle - endAngle) - sot - eot;

  if (outerArcAngle < 0) {
    if (forceCornerRadius) {
      return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
    }

    return getSectorPath({
      cx: cx,
      cy: cy,
      innerRadius: innerRadius,
      outerRadius: outerRadius,
      startAngle: startAngle,
      endAngle: endAngle
    });
  }

  var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");

  if (innerRadius > 0) {
    var _getTangentCircle3 = getTangentCircle({
      cx: cx,
      cy: cy,
      radius: innerRadius,
      angle: startAngle,
      sign: sign,
      isExternal: true,
      cornerRadius: cornerRadius,
      cornerIsExternal: cornerIsExternal
    }),
        sict = _getTangentCircle3.circleTangency,
        silt = _getTangentCircle3.lineTangency,
        sit = _getTangentCircle3.theta;

    var _getTangentCircle4 = getTangentCircle({
      cx: cx,
      cy: cy,
      radius: innerRadius,
      angle: endAngle,
      sign: -sign,
      isExternal: true,
      cornerRadius: cornerRadius,
      cornerIsExternal: cornerIsExternal
    }),
        eict = _getTangentCircle4.circleTangency,
        eilt = _getTangentCircle4.lineTangency,
        eit = _getTangentCircle4.theta;

    var innerArcAngle = Math.abs(startAngle - endAngle) - sit - eit;

    if (innerArcAngle < 0) {
      return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
    }

    path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
  } else {
    path += "L".concat(cx, ",").concat(cy, "Z");
  }

  return path;
};

var Sector =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Sector, _PureComponent);

  function Sector() {
    _classCallCheck(this, Sector);

    return _possibleConstructorReturn(this, _getPrototypeOf(Sector).apply(this, arguments));
  }

  _createClass(Sector, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          cx = _this$props.cx,
          cy = _this$props.cy,
          innerRadius = _this$props.innerRadius,
          outerRadius = _this$props.outerRadius,
          cornerRadius = _this$props.cornerRadius,
          forceCornerRadius = _this$props.forceCornerRadius,
          cornerIsExternal = _this$props.cornerIsExternal,
          startAngle = _this$props.startAngle,
          endAngle = _this$props.endAngle,
          className = _this$props.className;

      if (outerRadius < innerRadius || startAngle === endAngle) {
        return null;
      }

      var layerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-sector', className);
      var deltaRadius = outerRadius - innerRadius;
      var cr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["e" /* getPercentValue */])(cornerRadius, deltaRadius, 0, true);
      var path;

      if (cr > 0 && Math.abs(startAngle - endAngle) < 360) {
        path = getSectorWithCorner({
          cx: cx,
          cy: cy,
          innerRadius: innerRadius,
          outerRadius: outerRadius,
          cornerRadius: Math.min(cr, deltaRadius / 2),
          forceCornerRadius: forceCornerRadius,
          cornerIsExternal: cornerIsExternal,
          startAngle: startAngle,
          endAngle: endAngle
        });
      } else {
        path = getSectorPath({
          cx: cx,
          cy: cy,
          innerRadius: innerRadius,
          outerRadius: outerRadius,
          startAngle: startAngle,
          endAngle: endAngle
        });
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["b" /* filterEventAttributes */])(this.props), {
        className: layerClass,
        d: path
      }));
    }
  }]);

  return Sector;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Sector.displayName = 'Sector';
Sector.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  cx: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  innerRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  outerRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  startAngle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  endAngle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  cornerRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),
  forceCornerRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  cornerIsExternal: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
});
Sector.defaultProps = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: false,
  cornerIsExternal: false
};
/* harmony default export */ __webpack_exports__["a"] = (Sector);

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getStyleString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getStringSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getOffset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return calculateChartCoordinate; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReactUtils__ = __webpack_require__(23);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }


var stringCache = {
  widthCache: {},
  cacheCount: 0
};
var MAX_CACHE_NUM = 2000;
var SPAN_STYLE = {
  position: 'absolute',
  top: '-20000px',
  left: 0,
  padding: 0,
  margin: 0,
  border: 'none',
  whiteSpace: 'pre'
};
var STYLE_LIST = ['minWidth', 'maxWidth', 'width', 'minHeight', 'maxHeight', 'height', 'top', 'left', 'fontSize', 'lineHeight', 'padding', 'margin', 'paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom'];
var MEASUREMENT_SPAN_ID = 'recharts_measurement_span';

function autoCompleteStyle(name, value) {
  if (STYLE_LIST.indexOf(name) >= 0 && value === +value) {
    return "".concat(value, "px");
  }

  return value;
}

function camelToMiddleLine(text) {
  var strs = text.split('');
  var formatStrs = strs.reduce(function (result, entry) {
    if (entry === entry.toUpperCase()) {
      return [].concat(_toConsumableArray(result), ['-', entry.toLowerCase()]);
    }

    return [].concat(_toConsumableArray(result), [entry]);
  }, []);
  return formatStrs.join('');
}

var getStyleString = function getStyleString(style) {
  return Object.keys(style).reduce(function (result, s) {
    return "".concat(result).concat(camelToMiddleLine(s), ":").concat(autoCompleteStyle(s, style[s]), ";");
  }, '');
};
var getStringSize = function getStringSize(text) {
  var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (text === undefined || text === null || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ReactUtils__["h" /* isSsr */])()) {
    return {
      width: 0,
      height: 0
    };
  }

  var str = "".concat(text);
  var styleString = getStyleString(style);
  var cacheKey = "".concat(str, "-").concat(styleString);

  if (stringCache.widthCache[cacheKey]) {
    return stringCache.widthCache[cacheKey];
  }

  try {
    var measurementSpan = document.getElementById(MEASUREMENT_SPAN_ID);

    if (!measurementSpan) {
      measurementSpan = document.createElement('span');
      measurementSpan.setAttribute('id', MEASUREMENT_SPAN_ID);
      document.body.appendChild(measurementSpan);
    } // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
    // https://en.wikipedia.org/wiki/Content_Security_Policy


    var measurementSpanStyle = _objectSpread({}, SPAN_STYLE, {}, style);

    Object.keys(measurementSpanStyle).map(function (styleKey) {
      measurementSpan.style[styleKey] = measurementSpanStyle[styleKey];
      return styleKey;
    });
    measurementSpan.textContent = str;
    var rect = measurementSpan.getBoundingClientRect();
    var result = {
      width: rect.width,
      height: rect.height
    };
    stringCache.widthCache[cacheKey] = result;

    if (++stringCache.cacheCount > MAX_CACHE_NUM) {
      stringCache.cacheCount = 0;
      stringCache.widthCache = {};
    }

    return result;
  } catch (e) {
    return {
      width: 0,
      height: 0
    };
  }
};
var getOffset = function getOffset(el) {
  var html = el.ownerDocument.documentElement;
  var box = {
    top: 0,
    left: 0
  }; // If we don't have gBCR, just use 0,0 rather than error
  // BlackBerry 5, iOS 3 (original iPhone)

  if (typeof el.getBoundingClientRect !== 'undefined') {
    box = el.getBoundingClientRect();
  }

  return {
    top: box.top + window.pageYOffset - html.clientTop,
    left: box.left + window.pageXOffset - html.clientLeft
  };
};
/**
 * Calculate coordinate of cursor in chart
 * @param  {Object} event  Event object
 * @param  {Object} offset The offset of main part in the svg element
 * @return {Object}        {chartX, chartY}
 */

var calculateChartCoordinate = function calculateChartCoordinate(event, offset) {
  return {
    chartX: Math.round(event.pageX - offset.left),
    chartY: Math.round(event.pageY - offset.top)
  };
};

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ifOverflowMatches; });
var ifOverflowMatches = function ifOverflowMatches(props, value) {
  var alwaysShow = props.alwaysShow;
  var ifOverflow = props.ifOverflow;

  if (alwaysShow) {
    ifOverflow = 'extendDomain';
  }

  return ifOverflow === value;
};

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
function shallowEqual(a, b) {
  /* eslint-disable no-restricted-syntax */
  for (var key in a) {
    if ({}.hasOwnProperty.call(a, key) && (!{}.hasOwnProperty.call(b, key) || a[key] !== b[key])) {
      return false;
    }
  }

  for (var _key in b) {
    if ({}.hasOwnProperty.call(b, _key) && !{}.hasOwnProperty.call(a, _key)) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(142);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 234 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 235 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1705),
    listCacheDelete = __webpack_require__(1706),
    listCacheGet = __webpack_require__(1707),
    listCacheHas = __webpack_require__(1708),
    listCacheSet = __webpack_require__(1709);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 237 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(247);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(147);

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum(array, iteratee, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index],
        current = iteratee(value);

    if (current != null && (computed === undefined
          ? (current === current && !isSymbol(current))
          : comparator(current, computed)
        )) {
      var computed = current,
          result = value;
    }
  }
  return result;
}

module.exports = baseExtremum;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(242),
    toKey = __webpack_require__(179);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 241 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(34),
    isKey = __webpack_require__(378),
    stringToPath = __webpack_require__(1730),
    toString = __webpack_require__(1752);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1703);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1625),
    Map = __webpack_require__(366),
    Promise = __webpack_require__(1627),
    Set = __webpack_require__(661),
    WeakMap = __webpack_require__(1628),
    baseGetTag = __webpack_require__(93),
    toSource = __webpack_require__(685);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(247),
    isArrayLike = __webpack_require__(146),
    isIndex = __webpack_require__(377),
    isObject = __webpack_require__(48);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(106);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 247 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var isNumber = __webpack_require__(385);

/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */
function isNaN(value) {
  // An `NaN` primitive is the only value that is not equal to itself.
  // Perform the `toStringTag` check first to avoid errors with some
  // ActiveX objects in IE.
  return isNumber(value) && value != +value;
}

module.exports = isNaN;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(93),
    isArray = __webpack_require__(34),
    isObjectLike = __webpack_require__(66);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DOMChildrenOperations
 */



var DOMLazyTree = __webpack_require__(108);
var Danger = __webpack_require__(709);
var ReactMultiChildUpdateTypes = __webpack_require__(403);
var ReactDOMComponentTree = __webpack_require__(39);
var ReactInstrumentation = __webpack_require__(52);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(265);
var setInnerHTML = __webpack_require__(185);
var setTextContent = __webpack_require__(417);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID, 'replace text', stringText);
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation(prevInstance._debugID, 'replace with', markup.toString());
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation(nextInstance._debugID, 'mount', markup.toString());
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {

  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'insert child', { toIndex: update.toIndex, content: update.content.toString() });
          }
          break;
        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'move child', { fromIndex: update.fromIndex, toIndex: update.toIndex });
          }
          break;
        case ReactMultiChildUpdateTypes.SET_MARKUP:
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'replace children', update.content.toString());
          }
          break;
        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'replace text', update.content.toString());
          }
          break;
        case ReactMultiChildUpdateTypes.REMOVE_NODE:
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'remove child', { fromIndex: update.fromIndex });
          }
          break;
      }
    }
  }

};

module.exports = DOMChildrenOperations;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DOMNamespaces
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventPluginRegistry
 */



var _prodInvariant = __webpack_require__(25);

var invariant = __webpack_require__(17);

/**
 * Injectable ordering of event plugins.
 */
var EventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!EventPluginOrder) {
    // Wait until an `EventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var PluginModule = namesToPlugins[pluginName];
    var pluginIndex = EventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !PluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
    var publishedEvents = PluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, PluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {

  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (InjectedEventPluginOrder) {
    !!EventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var PluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = PluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    for (var phase in dispatchConfig.phasedRegistrationNames) {
      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
        continue;
      }
      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
      if (PluginModule) {
        return PluginModule;
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    EventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }

};

module.exports = EventPluginRegistry;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EventPluginUtils
 */



var _prodInvariant = __webpack_require__(25);

var EventConstants = __webpack_require__(67);
var ReactErrorUtils = __webpack_require__(259);

var invariant = __webpack_require__(17);
var warning = __webpack_require__(21);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

var topLevelTypes = EventConstants.topLevelTypes;

function isEndish(topLevelType) {
  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
}

function isMoveish(topLevelType) {
  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
}
function isStartish(topLevelType) {
  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule KeyEscapeUtils
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule LinkedValueUtils
 */



var _prodInvariant = __webpack_require__(25);

var ReactPropTypes = __webpack_require__(405);
var ReactPropTypeLocations = __webpack_require__(262);
var ReactPropTypesSecret = __webpack_require__(263);

var invariant = __webpack_require__(17);
var warning = __webpack_require__(21);

var hasReadOnlyValue = {
  'button': true,
  'checkbox': true,
  'image': true,
  'hidden': true,
  'radio': true,
  'reset': true,
  'submit': true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: ReactPropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop, null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponent
 */



var _prodInvariant = __webpack_require__(25);

var ReactNoopUpdateQueue = __webpack_require__(260);

var canDefineProperty = __webpack_require__(409);
var emptyObject = __webpack_require__(70);
var invariant = __webpack_require__(17);
var warning = __webpack_require__(21);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

module.exports = ReactComponent;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponentEnvironment
 */



var _prodInvariant = __webpack_require__(25);

var invariant = __webpack_require__(17);

var injected = false;

var ReactComponentEnvironment = {

  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }

};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2016-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponentTreeHook
 */



var _prodInvariant = __webpack_require__(25);

var ReactCurrentOwner = __webpack_require__(79);

var invariant = __webpack_require__(17);
var warning = __webpack_require__(21);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty)
  // Strip regex characters so we can use it for regex
  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  // Remove hasOwnProperty from the template to make it generic
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var itemMap;
var rootIDSet;

var itemByKey;
var rootByKey;

if (canUseCollections) {
  itemMap = new Map();
  rootIDSet = new Set();
} else {
  itemByKey = {};
  rootByKey = {};
}

var unmountedIDs = [];

// Use non-numeric keys to prevent V8 performance issues:
// https://github.com/facebook/react/pull/7232
function getKeyFromID(id) {
  return '.' + id;
}
function getIDFromKey(key) {
  return parseInt(key.substr(1), 10);
}

function get(id) {
  if (canUseCollections) {
    return itemMap.get(id);
  } else {
    var key = getKeyFromID(id);
    return itemByKey[key];
  }
}

function remove(id) {
  if (canUseCollections) {
    itemMap['delete'](id);
  } else {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  }
}

function create(id, element, parentID) {
  var item = {
    element: element,
    parentID: parentID,
    text: null,
    childIDs: [],
    isMounted: false,
    updateCount: 0
  };

  if (canUseCollections) {
    itemMap.set(id, item);
  } else {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  }
}

function addRoot(id) {
  if (canUseCollections) {
    rootIDSet.add(id);
  } else {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  }
}

function removeRoot(id) {
  if (canUseCollections) {
    rootIDSet['delete'](id);
  } else {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  }
}

function getRegisteredIDs() {
  if (canUseCollections) {
    return Array.from(itemMap.keys());
  } else {
    return Object.keys(itemByKey).map(getIDFromKey);
  }
}

function getRootIDs() {
  if (canUseCollections) {
    return Array.from(rootIDSet.keys());
  } else {
    return Object.keys(rootByKey).map(getIDFromKey);
  }
}

function purgeDeep(id) {
  var item = get(id);
  if (item) {
    var childIDs = item.childIDs;

    remove(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + name + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = get(id);
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = get(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent ID is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    create(id, element, parentID);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = get(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = get(id);
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = get(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = get(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = get(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var type = topElement.type;
      var name = typeof type === 'function' ? type.displayName || type.name : type;
      var owner = topElement._owner;
      info += describeComponentFrame(name || 'Unknown', topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = get(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = get(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = get(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = get(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = get(id);
    return item ? item.updateCount : 0;
  },


  getRegisteredIDs: getRegisteredIDs,

  getRootIDs: getRootIDs
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactErrorUtils
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {?String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a, b) {
  try {
    return func(a, b);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
    return undefined;
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
      var boundFunc = func.bind(null, a, b);
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactNoopUpdateQueue
 */



var warning = __webpack_require__(21);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactPropTypeLocationNames
 */



var ReactPropTypeLocationNames = {};

if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
}

module.exports = ReactPropTypeLocationNames;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactPropTypeLocations
 */



var keyMirror = __webpack_require__(200);

var ReactPropTypeLocations = keyMirror({
  prop: null,
  context: null,
  childContext: null
});

module.exports = ReactPropTypeLocations;

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactPropTypesSecret
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactUpdateQueue
 */



var _prodInvariant = __webpack_require__(25);

var ReactCurrentOwner = __webpack_require__(79);
var ReactInstanceMap = __webpack_require__(151);
var ReactInstrumentation = __webpack_require__(52);
var ReactUpdates = __webpack_require__(59);

var invariant = __webpack_require__(17);
var warning = __webpack_require__(21);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }

};

module.exports = ReactUpdateQueue;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule createMicrosoftUnsafeLocalFunction
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEventCharCode
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEventModifierState
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  'Alt': 'altKey',
  'Control': 'ctrlKey',
  'Meta': 'metaKey',
  'Shift': 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEventTarget
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isEventSupported
 */



var ExecutionEnvironment = __webpack_require__(31);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule shouldUpdateReactComponent
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule traverseAllChildren
 */



var _prodInvariant = __webpack_require__(25);

var ReactCurrentOwner = __webpack_require__(79);
var ReactElement = __webpack_require__(58);

var getIteratorFn = __webpack_require__(412);
var invariant = __webpack_require__(17);
var KeyEscapeUtils = __webpack_require__(254);
var warning = __webpack_require__(21);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule validateDOMNesting
 */



var _assign = __webpack_require__(22);

var emptyFunction = __webpack_require__(37);
var warning = __webpack_require__(21);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';

      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':

      case 'pre':
      case 'listing':

      case 'table':

      case 'hr':

      case 'xmp':

      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(990);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(989);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 274 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(999);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 276 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 277 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 278 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(112);
var dPs = __webpack_require__(1014);
var enumBugKeys = __webpack_require__(277);
var IE_PROTO = __webpack_require__(282)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(440)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(1005).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 280 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(95).f;
var has = __webpack_require__(94);
var TAG = __webpack_require__(61)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(283)('keys');
var uid = __webpack_require__(186);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(82);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};


/***/ }),
/* 284 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(276);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(155);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(82);
var core = __webpack_require__(60);
var LIBRARY = __webpack_require__(278);
var wksExt = __webpack_require__(288);
var defineProperty = __webpack_require__(95).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(61);


/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(160);


/* harmony default export */ __webpack_exports__["a"] = (function(values, p, valueof) {
  if (valueof == null) valueof = __WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */];
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
});


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefix; });
var prefix = "$";

function Map() {}

Map.prototype = map.prototype = {
  constructor: Map,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map(object, f) {
  var map = new Map;

  // Copy constructor.
  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

/* harmony default export */ __webpack_exports__["a"] = (map);


/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = Color;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return darker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return brighter; });
/* harmony export (immutable) */ __webpack_exports__["h"] = color;
/* harmony export (immutable) */ __webpack_exports__["b"] = rgbConvert;
/* harmony export (immutable) */ __webpack_exports__["g"] = rgb;
/* harmony export (immutable) */ __webpack_exports__["a"] = Rgb;
/* unused harmony export hslConvert */
/* harmony export (immutable) */ __webpack_exports__["f"] = hsl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define_js__ = __webpack_require__(292);


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex = /^#([0-9a-f]{3,8})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Color, color, {
  copy: function(channels) {
    return Object.assign(new this.constructor, this, channels);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: color_formatHex, // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});

function color_formatHex() {
  return this.rgb().formatHex();
}

function color_formatHsl() {
  return hslConvert(this).formatHsl();
}

function color_formatRgb() {
  return this.rgb().formatRgb();
}

function color(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
      : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
      : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
      : l === 4 ? rgba((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
      : null) // invalid hex
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Rgb, rgb, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (-0.5 <= this.r && this.r < 255.5)
        && (-0.5 <= this.g && this.g < 255.5)
        && (-0.5 <= this.b && this.b < 255.5)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex, // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));

function rgb_formatHex() {
  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}

function rgb_formatRgb() {
  var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
  return (a === 1 ? "rgb(" : "rgba(")
      + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.b) || 0))
      + (a === 1 ? ")" : ", " + a + ")");
}

function hex(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Hsl, hsl, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "hsl(" : "hsla(")
        + (this.h || 0) + ", "
        + (this.s || 0) * 100 + "%, "
        + (this.l || 0) * 100 + "%"
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}


/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* harmony default export */ __webpack_exports__["a"] = (function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isNumberArray;
/* harmony default export */ __webpack_exports__["b"] = (function(a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0,
      c = b.slice(),
      i;
  return function(t) {
    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
    return c;
  };
});

function isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb_js__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array_js__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date_js__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object_js__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string_js__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant_js__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__numberArray_js__ = __webpack_require__(294);










/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__constant_js__["a" /* default */])(b)
      : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number_js__["a" /* default */]
      : t === "string" ? ((c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb_js__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string_js__["a" /* default */])
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* color */] ? __WEBPACK_IMPORTED_MODULE_1__rgb_js__["a" /* default */]
      : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date_js__["a" /* default */]
      : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__numberArray_js__["a" /* isNumberArray */])(b) ? __WEBPACK_IMPORTED_MODULE_8__numberArray_js__["b" /* default */]
      : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array_js__["a" /* genericArray */]
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object_js__["a" /* default */]
      : __WEBPACK_IMPORTED_MODULE_4__number_js__["a" /* default */])(a, b);
});


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = loggish;
/* harmony export (immutable) */ __webpack_exports__["a"] = log;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nice__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__continuous__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__init__ = __webpack_require__(45);






function transformLog(x) {
  return Math.log(x);
}

function transformExp(x) {
  return Math.exp(x);
}

function transformLogn(x) {
  return -Math.log(-x);
}

function transformExpn(x) {
  return -Math.exp(-x);
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function loggish(transform) {
  var scale = transform(transformLog, transformExp),
      domain = scale.domain,
      base = 10,
      logs,
      pows;

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) {
      logs = reflect(logs), pows = reflect(pows);
      transform(transformLogn, transformExpn);
    } else {
      transform(transformLog, transformExp);
    }
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* ticks */])(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* format */])(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__nice__["a" /* default */])(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  return scale;
}

function log() {
  var scale = loggish(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__continuous__["b" /* transformer */])()).domain([1, 10]);

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__continuous__["c" /* copy */])(scale, log()).base(scale.base());
  };

  __WEBPACK_IMPORTED_MODULE_4__init__["b" /* initRange */].apply(scale, arguments);

  return scale;
}


/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = powish;
/* harmony export (immutable) */ __webpack_exports__["a"] = pow;
/* harmony export (immutable) */ __webpack_exports__["b"] = sqrt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__continuous__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init__ = __webpack_require__(45);




function transformPow(exponent) {
  return function(x) {
    return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
  };
}

function transformSqrt(x) {
  return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}

function transformSquare(x) {
  return x < 0 ? -x * x : x * x;
}

function powish(transform) {
  var scale = transform(__WEBPACK_IMPORTED_MODULE_1__continuous__["a" /* identity */], __WEBPACK_IMPORTED_MODULE_1__continuous__["a" /* identity */]),
      exponent = 1;

  function rescale() {
    return exponent === 1 ? transform(__WEBPACK_IMPORTED_MODULE_1__continuous__["a" /* identity */], __WEBPACK_IMPORTED_MODULE_1__continuous__["a" /* identity */])
        : exponent === 0.5 ? transform(transformSqrt, transformSquare)
        : transform(transformPow(exponent), transformPow(1 / exponent));
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, rescale()) : exponent;
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__linear__["b" /* linearish */])(scale);
}

function pow() {
  var scale = powish(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__continuous__["b" /* transformer */])());

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__continuous__["c" /* copy */])(scale, pow()).exponent(scale.exponent());
  };

  __WEBPACK_IMPORTED_MODULE_2__init__["b" /* initRange */].apply(scale, arguments);

  return scale;
}

function sqrt() {
  return pow.apply(null, arguments).exponent(0.5);
}


/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = symlogish;
/* harmony export (immutable) */ __webpack_exports__["a"] = symlog;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__continuous__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init__ = __webpack_require__(45);




function transformSymlog(c) {
  return function(x) {
    return Math.sign(x) * Math.log1p(Math.abs(x / c));
  };
}

function transformSymexp(c) {
  return function(x) {
    return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
  };
}

function symlogish(transform) {
  var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));

  scale.constant = function(_) {
    return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
  };

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__linear__["b" /* linearish */])(scale);
}

function symlog() {
  var scale = symlogish(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__continuous__["b" /* transformer */])());

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__continuous__["c" /* copy */])(scale, symlog()).constant(scale.constant());
  };

  return __WEBPACK_IMPORTED_MODULE_2__init__["b" /* initRange */].apply(scale, arguments);
}


/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal_js__ = __webpack_require__(191);



function point(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > __WEBPACK_IMPORTED_MODULE_0__math_js__["a" /* epsilon */]) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > __WEBPACK_IMPORTED_MODULE_0__math_js__["a" /* epsilon */]) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new __WEBPACK_IMPORTED_MODULE_1__cardinal_js__["a" /* Cardinal */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arc_js__ = __webpack_require__(1097);
/* unused harmony reexport arc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area_js__ = __webpack_require__(484);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_1__area_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__line_js__ = __webpack_require__(301);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_2__line_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pie_js__ = __webpack_require__(1118);
/* unused harmony reexport pie */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__areaRadial_js__ = __webpack_require__(1098);
/* unused harmony reexport areaRadial */
/* unused harmony reexport radialArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lineRadial_js__ = __webpack_require__(489);
/* unused harmony reexport lineRadial */
/* unused harmony reexport radialLine */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pointRadial_js__ = __webpack_require__(491);
/* unused harmony reexport pointRadial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__link_index_js__ = __webpack_require__(1110);
/* unused harmony reexport linkHorizontal */
/* unused harmony reexport linkVertical */
/* unused harmony reexport linkRadial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__symbol_js__ = __webpack_require__(1120);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_8__symbol_js__["a"]; });
/* unused harmony reexport symbols */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__symbol_circle_js__ = __webpack_require__(492);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_9__symbol_circle_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__symbol_cross_js__ = __webpack_require__(493);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_10__symbol_cross_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__symbol_diamond_js__ = __webpack_require__(494);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_11__symbol_diamond_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__symbol_square_js__ = __webpack_require__(495);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_12__symbol_square_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__symbol_star_js__ = __webpack_require__(496);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_13__symbol_star_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__symbol_triangle_js__ = __webpack_require__(497);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_14__symbol_triangle_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__symbol_wye_js__ = __webpack_require__(498);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_15__symbol_wye_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__curve_basisClosed_js__ = __webpack_require__(1099);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_16__curve_basisClosed_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__curve_basisOpen_js__ = __webpack_require__(1100);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_17__curve_basisOpen_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__curve_basis_js__ = __webpack_require__(190);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_18__curve_basis_js__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__curve_bundle_js__ = __webpack_require__(1101);
/* unused harmony reexport curveBundle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__curve_cardinalClosed_js__ = __webpack_require__(486);
/* unused harmony reexport curveCardinalClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__curve_cardinalOpen_js__ = __webpack_require__(487);
/* unused harmony reexport curveCardinalOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__curve_cardinal_js__ = __webpack_require__(191);
/* unused harmony reexport curveCardinal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__curve_catmullRomClosed_js__ = __webpack_require__(1102);
/* unused harmony reexport curveCatmullRomClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__curve_catmullRomOpen_js__ = __webpack_require__(1103);
/* unused harmony reexport curveCatmullRomOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__curve_catmullRom_js__ = __webpack_require__(299);
/* unused harmony reexport curveCatmullRom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__curve_linearClosed_js__ = __webpack_require__(1104);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_26__curve_linearClosed_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__curve_linear_js__ = __webpack_require__(192);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_27__curve_linear_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__curve_monotone_js__ = __webpack_require__(1105);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_28__curve_monotone_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_28__curve_monotone_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__curve_natural_js__ = __webpack_require__(1106);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_29__curve_natural_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__curve_step_js__ = __webpack_require__(1107);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_30__curve_step_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_30__curve_step_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_30__curve_step_js__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__stack_js__ = __webpack_require__(1119);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_31__stack_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__offset_expand_js__ = __webpack_require__(1112);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_32__offset_expand_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__offset_diverging_js__ = __webpack_require__(1111);
/* unused harmony reexport stackOffsetDiverging */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__offset_none_js__ = __webpack_require__(163);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_34__offset_none_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__offset_silhouette_js__ = __webpack_require__(1113);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_35__offset_silhouette_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__offset_wiggle_js__ = __webpack_require__(1114);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_36__offset_wiggle_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__order_appearance_js__ = __webpack_require__(490);
/* unused harmony reexport stackOrderAppearance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__order_ascending_js__ = __webpack_require__(302);
/* unused harmony reexport stackOrderAscending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__order_descending_js__ = __webpack_require__(1115);
/* unused harmony reexport stackOrderDescending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__order_insideOut_js__ = __webpack_require__(1116);
/* unused harmony reexport stackOrderInsideOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__order_none_js__ = __webpack_require__(164);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_41__order_none_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__order_reverse_js__ = __webpack_require__(1117);
/* unused harmony reexport stackOrderReverse */




 // Note: radialArea is deprecated!
 // Note: radialLine is deprecated!










































/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear_js__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point_js__ = __webpack_require__(303);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_3__point_js__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point_js__["b" /* y */],
      defined = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear_js__["a" /* default */],
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), line) : x;
  };

  line.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), line) : y;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
});


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sum;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none_js__ = __webpack_require__(164);


/* harmony default export */ __webpack_exports__["b"] = (function(series) {
  var sums = series.map(sum);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none_js__["a" /* default */])(series).sort(function(a, b) { return sums[a] - sums[b]; });
});

function sum(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}


/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
function x(p) {
  return p[0];
}

function y(p) {
  return p[1];
}


/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return timeFormat; });
/* unused harmony export timeParse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcParse; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_js__ = __webpack_require__(501);


var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;

defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale(definition) {
  locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__locale_js__["a" /* default */])(definition);
  timeFormat = locale.format;
  timeParse = locale.parse;
  utcFormat = locale.utcFormat;
  utcParse = locale.utcParse;
  return locale;
}


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(43);
/* unused harmony reexport timeInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__millisecond_js__ = __webpack_require__(1124);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_1__millisecond_js__["a"]; });
/* unused harmony reexport timeMilliseconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__millisecond_js__["a"]; });
/* unused harmony reexport utcMilliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__second_js__ = __webpack_require__(1127);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_2__second_js__["a"]; });
/* unused harmony reexport timeSeconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__second_js__["a"]; });
/* unused harmony reexport utcSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__minute_js__ = __webpack_require__(1125);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_3__minute_js__["a"]; });
/* unused harmony reexport timeMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hour_js__ = __webpack_require__(1123);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_4__hour_js__["a"]; });
/* unused harmony reexport timeHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__day_js__ = __webpack_require__(1122);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_5__day_js__["a"]; });
/* unused harmony reexport timeDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__week_js__ = __webpack_require__(1134);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_6__week_js__["a"]; });
/* unused harmony reexport timeWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_6__week_js__["a"]; });
/* unused harmony reexport timeSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__week_js__["b"]; });
/* unused harmony reexport timeMondays */
/* unused harmony reexport timeTuesday */
/* unused harmony reexport timeTuesdays */
/* unused harmony reexport timeWednesday */
/* unused harmony reexport timeWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_6__week_js__["c"]; });
/* unused harmony reexport timeThursdays */
/* unused harmony reexport timeFriday */
/* unused harmony reexport timeFridays */
/* unused harmony reexport timeSaturday */
/* unused harmony reexport timeSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__month_js__ = __webpack_require__(1126);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_7__month_js__["a"]; });
/* unused harmony reexport timeMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__year_js__ = __webpack_require__(1135);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_8__year_js__["a"]; });
/* unused harmony reexport timeYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utcMinute_js__ = __webpack_require__(1130);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_9__utcMinute_js__["a"]; });
/* unused harmony reexport utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utcHour_js__ = __webpack_require__(1129);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__utcHour_js__["a"]; });
/* unused harmony reexport utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utcDay_js__ = __webpack_require__(1128);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_11__utcDay_js__["a"]; });
/* unused harmony reexport utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utcWeek_js__ = __webpack_require__(1132);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek_js__["a"]; });
/* unused harmony reexport utcWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek_js__["a"]; });
/* unused harmony reexport utcSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek_js__["b"]; });
/* unused harmony reexport utcMondays */
/* unused harmony reexport utcTuesday */
/* unused harmony reexport utcTuesdays */
/* unused harmony reexport utcWednesday */
/* unused harmony reexport utcWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek_js__["c"]; });
/* unused harmony reexport utcThursdays */
/* unused harmony reexport utcFriday */
/* unused harmony reexport utcFridays */
/* unused harmony reexport utcSaturday */
/* unused harmony reexport utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utcMonth_js__ = __webpack_require__(1131);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_13__utcMonth_js__["a"]; });
/* unused harmony reexport utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utcYear_js__ = __webpack_require__(1133);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_14__utcYear_js__["a"]; });
/* unused harmony reexport utcYears */































/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(40);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(84));

var off = function off() {};

if (_inDOM.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

var _default = off;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 307 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

function keyCode(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */
keyCode.isEventKey = function isEventKey(event, nameOrCode) {
  if (event && 'object' === typeof event) {
    var keyCode = event.which || event.keyCode || event.charCode
    if (keyCode === null || keyCode === undefined) { return false; }
    if (typeof nameOrCode === 'string') {
      // check codes
      var foundNamedKey = codes[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    
      // check aliases
      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    } else if (typeof nameOrCode === 'number') {
      return nameOrCode === keyCode;
    }
    return false;
  }
}

exports = module.exports = keyCode;

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'spacebar': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}

/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(100),
    root = __webpack_require__(63);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1252),
    mapCacheDelete = __webpack_require__(1253),
    mapCacheGet = __webpack_require__(1254),
    mapCacheHas = __webpack_require__(1255),
    mapCacheSet = __webpack_require__(1256);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(202),
    stackClear = __webpack_require__(1266),
    stackDelete = __webpack_require__(1267),
    stackGet = __webpack_require__(1268),
    stackHas = __webpack_require__(1269),
    stackSet = __webpack_require__(1270);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 311 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(204),
    toKey = __webpack_require__(167);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1195),
    isObjectLike = __webpack_require__(71);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(522);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(543);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(523),
    stubArray = __webpack_require__(551);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(49),
    isSymbol = __webpack_require__(207);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 318 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 319 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 320 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1194),
    isObjectLike = __webpack_require__(71);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(63),
    stubFalse = __webpack_require__(1289);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module)))

/***/ }),
/* 323 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Button__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(20);













var propTypes = {
  vertical: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  justified: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Display block buttons; only useful when used with the "vertical" prop.
   * @type {bool}
   */
  block: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default()(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, function (_ref) {
    var block = _ref.block,
        vertical = _ref.vertical;
    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
  })
};

var defaultProps = {
  block: false,
  justified: false,
  vertical: false
};

var ButtonGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ButtonGroup, _React$Component);

  function ButtonGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ButtonGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ButtonGroup.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        block = _props.block,
        justified = _props.justified,
        vertical = _props.vertical,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['block', 'justified', 'vertical', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps)] = !vertical, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'vertical')] = vertical, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'justified')] = justified, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_9__Button__["a" /* default */].defaultProps, 'block')] = block, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ButtonGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ButtonGroup.propTypes = propTypes;
ButtonGroup.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["c" /* bsClass */])('btn-group', ButtonGroup));

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};

var defaultProps = {
  label: 'Close'
};

var CloseButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(CloseButton, _React$Component);

  function CloseButton() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CloseButton);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  CloseButton.prototype.render = function render() {
    var _props = this.props,
        label = _props.label,
        onClick = _props.onClick;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'button',
      {
        type: 'button',
        className: 'close',
        onClick: onClick
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'span',
        { 'aria-hidden': 'true' },
        '\xD7'
      ),
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        label
      )
    );
  };

  return CloseButton;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

CloseButton.propTypes = propTypes;
CloseButton.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (CloseButton);

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_style__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_overlays_lib_Transition__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_overlays_lib_Transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_overlays_lib_Transition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_capitalize__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(41);














var MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
};

// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function triggerBrowserReflow(node) {
  node.offsetHeight; // eslint-disable-line no-unused-expressions
}

function getDimensionValue(dimension, elem) {
  var value = elem['offset' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(dimension)];
  var margins = MARGINS[dimension];

  return value + parseInt(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_style___default()(elem, margins[0]), 10) + parseInt(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_style___default()(elem, margins[1]), 10);
}

var propTypes = {
  /**
   * Show the component; triggers the expand or collapse animation
   */
  in: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is collapsed
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Run the expand animation when the component mounts, if it is initially
   * shown
   */
  transitionAppear: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Duration of the collapse animation in milliseconds, to ensure that
   * finishing callbacks are fired even if the original browser transition end
   * events are canceled
   */
  timeout: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,

  /**
   * Callback fired before the component expands
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to expand
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired after the component has expanded
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired before the component collapses
   */
  onExit: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired after the component starts to collapse
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  /**
   * Callback fired after the component has collapsed
   */
  onExited: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,

  /**
   * The dimension used when collapsing, or a function that returns the
   * dimension
   *
   * _Note: Bootstrap only partially supports 'width'!
   * You will need to supply your own CSS animation for the `.width` CSS class._
   */
  dimension: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['height', 'width']), __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func]),

  /**
   * Function that returns the height or width of the animating DOM node
   *
   * Allows for providing some custom logic for how much the Collapse component
   * should animate in its specified dimension. Called with the current
   * dimension prop value and the DOM node.
   */
  getDimensionValue: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,

  /**
   * ARIA role of collapsible element
   */
  role: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  transitionAppear: false,

  dimension: 'height',
  getDimensionValue: getDimensionValue
};

var Collapse = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Collapse, _React$Component);

  function Collapse(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Collapse);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleEnter = _this.handleEnter.bind(_this);
    _this.handleEntering = _this.handleEntering.bind(_this);
    _this.handleEntered = _this.handleEntered.bind(_this);
    _this.handleExit = _this.handleExit.bind(_this);
    _this.handleExiting = _this.handleExiting.bind(_this);
    return _this;
  }

  Collapse.prototype._dimension = function _dimension() {
    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
  };

  // for testing


  Collapse.prototype._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
    return elem['scroll' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(dimension)] + 'px';
  };

  /* -- Expanding -- */


  Collapse.prototype.handleEnter = function handleEnter(elem) {
    var dimension = this._dimension();
    elem.style[dimension] = '0';
  };

  Collapse.prototype.handleEntered = function handleEntered(elem) {
    var dimension = this._dimension();
    elem.style[dimension] = null;
  };

  Collapse.prototype.handleEntering = function handleEntering(elem) {
    var dimension = this._dimension();
    elem.style[dimension] = this._getScrollDimensionValue(elem, dimension);
  };

  /* -- Collapsing -- */


  Collapse.prototype.handleExit = function handleExit(elem) {
    var dimension = this._dimension();
    elem.style[dimension] = this.props.getDimensionValue(dimension, elem) + 'px';
    triggerBrowserReflow(elem);
  };

  Collapse.prototype.handleExiting = function handleExiting(elem) {
    var dimension = this._dimension();
    elem.style[dimension] = '0';
  };

  Collapse.prototype.render = function render() {
    var _props = this.props,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'className']);

    delete props.dimension;
    delete props.getDimensionValue;

    var handleEnter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleEnter, onEnter);
    var handleEntering = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleEntering, onEntering);
    var handleEntered = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleEntered, onEntered);
    var handleExit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleExit, onExit);
    var handleExiting = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleExiting, onExiting);

    var classes = {
      width: this._dimension() === 'width'
    };

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_overlays_lib_Transition___default.a, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      'aria-expanded': props.role ? props.in : null,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes),
      exitedClassName: 'collapse',
      exitingClassName: 'collapsing',
      enteredClassName: 'collapse in',
      enteringClassName: 'collapsing',
      onEnter: handleEnter,
      onEntering: handleEntering,
      onEntered: handleEntered,
      onExit: handleExit,
      onExiting: handleExiting
    }));
  };

  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Collapse.propTypes = propTypes;
Collapse.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Collapse);

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(20);











var propTypes = {
  /**
   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
   */
  glyph: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired
};

var Glyphicon = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Glyphicon, _React$Component);

  function Glyphicon() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Glyphicon);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Glyphicon.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        glyph = _props.glyph,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['glyph', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, glyph)] = true, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Glyphicon;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Glyphicon.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('glyphicon', Glyphicon));

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uncontrollable__);








var TAB = 'tab';
var PANE = 'pane';

var idPropType = __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number]);

var propTypes = {
  /**
   * HTML id attribute, required if no `generateChildId` prop
   * is specified.
   */
  id: function id(props) {
    var error = null;

    if (!props.generateChildId) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      error = idPropType.apply(undefined, [props].concat(args));

      if (!error && !props.id) {
        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
      }
    }

    return error;
  },


  /**
   * A function that takes an `eventKey` and `type` and returns a unique id for
   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
   * function, meaning it should always return the _same_ id for the same set
   * of inputs. The default value requires that an `id` to be set for the
   * `<TabContainer>`.
   *
   * The `type` argument will either be `"tab"` or `"pane"`.
   *
   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
   */
  generateChildId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * A callback fired when a tab is selected.
   *
   * @controllable activeKey
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * The `eventKey` of the currently active tab.
   *
   * @controllable onSelect
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};

var childContextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
    onSelect: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
    getTabId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,
    getPaneId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired
  })
};

var TabContainer = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(TabContainer, _React$Component);

  function TabContainer() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, TabContainer);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  TabContainer.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        activeKey = _props.activeKey,
        onSelect = _props.onSelect,
        generateChildId = _props.generateChildId,
        id = _props.id;


    var getId = generateChildId || function (key, type) {
      return id ? id + '-' + type + '-' + key : null;
    };

    return {
      $bs_tabContainer: {
        activeKey: activeKey,
        onSelect: onSelect,
        getTabId: function getTabId(key) {
          return getId(key, TAB);
        },
        getPaneId: function getPaneId(key) {
          return getId(key, PANE);
        }
      }
    };
  };

  TabContainer.prototype.render = function render() {
    var _props2 = this.props,
        children = _props2.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['children']);

    delete props.generateChildId;
    delete props.onSelect;
    delete props.activeKey;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children), props);
  };

  return TabContainer;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

TabContainer.propTypes = propTypes;
TabContainer.childContextTypes = childContextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6_uncontrollable___default()(TabContainer, { activeKey: 'onSelect' }));

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(20);












var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,

  /**
   * Sets a default animation strategy for all children `<TabPane>`s. Use
   * `false` to disable, `true` to enable the default `<Fade>` animation or any
   * `<Transition>` component.
   */
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a]),

  /**
   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Unmount tabs (remove it from the DOM) when they are no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  componentClass: 'div',
  animation: true,
  mountOnEnter: false,
  unmountOnExit: false
};

var contextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
  })
};

var childContextTypes = {
  $bs_tabContent: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a]),
    activeKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
    mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    onPaneEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    onPaneExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    exiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired
  })
};

var TabContent = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TabContent, _React$Component);

  function TabContent(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TabContent);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handlePaneEnter = _this.handlePaneEnter.bind(_this);
    _this.handlePaneExited = _this.handlePaneExited.bind(_this);

    // Active entries in state will be `null` unless `animation` is set. Need
    // to track active child in case keys swap and the active child changes
    // but the active key does not.
    _this.state = {
      activeKey: null,
      activeChild: null
    };
    return _this;
  }

  TabContent.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        bsClass = _props.bsClass,
        animation = _props.animation,
        mountOnEnter = _props.mountOnEnter,
        unmountOnExit = _props.unmountOnExit;


    var stateActiveKey = this.state.activeKey;
    var containerActiveKey = this.getContainerActiveKey();

    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;

    return {
      $bs_tabContent: {
        bsClass: bsClass,
        animation: animation,
        activeKey: activeKey,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        onPaneEnter: this.handlePaneEnter,
        onPaneExited: this.handlePaneExited,
        exiting: exiting
      }
    };
  };

  TabContent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!nextProps.animation && this.state.activeChild) {
      this.setState({ activeKey: null, activeChild: null });
    }
  };

  TabContent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.isUnmounted = true;
  };

  TabContent.prototype.getContainerActiveKey = function getContainerActiveKey() {
    var tabContainer = this.context.$bs_tabContainer;
    return tabContainer && tabContainer.activeKey;
  };

  TabContent.prototype.handlePaneEnter = function handlePaneEnter(child, childKey) {
    if (!this.props.animation) {
      return false;
    }

    // It's possible that this child should be transitioning out.
    if (childKey !== this.getContainerActiveKey()) {
      return false;
    }

    this.setState({
      activeKey: childKey,
      activeChild: child
    });

    return true;
  };

  TabContent.prototype.handlePaneExited = function handlePaneExited(child) {
    // This might happen as everything is unmounting.
    if (this.isUnmounted) {
      return;
    }

    this.setState(function (_ref) {
      var activeChild = _ref.activeChild;

      if (activeChild !== child) {
        return null;
      }

      return {
        activeKey: null,
        activeChild: null
      };
    });
  };

  TabContent.prototype.render = function render() {
    var _props2 = this.props,
        Component = _props2.componentClass,
        className = _props2.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['componentClass', 'className']);

    var _splitBsPropsAndOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'content'))
    }));
  };

  return TabContent;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

TabContent.propTypes = propTypes;
TabContent.defaultProps = defaultProps;
TabContent.contextTypes = contextTypes;
TabContent.childContextTypes = childContextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('tab', TabContent));

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMLazyTree = __webpack_require__(125);
var Danger = __webpack_require__(1413);
var ReactDOMComponentTree = __webpack_require__(38);
var ReactInstrumentation = __webpack_require__(53);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(339);
var setInnerHTML = __webpack_require__(220);
var setTextContent = __webpack_require__(610);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(26);

var invariant = __webpack_require__(17);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(26);

var ReactErrorUtils = __webpack_require__(337);

var invariant = __webpack_require__(17);
var warning = __webpack_require__(21);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(26);

var ReactPropTypesSecret = __webpack_require__(1442);
var propTypesFactory = __webpack_require__(554);

var React = __webpack_require__(131);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(17);
var warning = __webpack_require__(21);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(26);

var invariant = __webpack_require__(17);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = function () {
        func(a);
      };
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(26);

var ReactCurrentOwner = __webpack_require__(73);
var ReactInstanceMap = __webpack_require__(172);
var ReactInstrumentation = __webpack_require__(53);
var ReactUpdates = __webpack_require__(65);

var invariant = __webpack_require__(17);
var warning = __webpack_require__(21);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(31);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(22);

var emptyFunction = __webpack_require__(37);
var warning = __webpack_require__(21);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IGNORE_CLASS_NAME", function() { return IGNORE_CLASS_NAME; });
/* harmony export (immutable) */ __webpack_exports__["default"] = onClickOutsideHOC;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_helpers__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__detect_passive_events__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__uid__ = __webpack_require__(1484);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var passiveEventSupport = void 0;

var handlersMap = {};
var enabledInstances = {};

var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';

/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */
function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    _inherits(onClickOutside, _Component);

    function onClickOutside(props) {
      _classCallCheck(this, onClickOutside);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props));

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);
          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error('WrappedComponent lacks a handleClickOutside(event) function for processing outside click events.');
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__detect_passive_events__["a" /* testPassiveEventSupport */])();
        }

        enabledInstances[_this._uid] = true;

        var events = _this.props.eventTypes;
        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.props.disableOnClickOutside) return;
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && __WEBPACK_IMPORTED_MODULE_2__dom_helpers__["a" /* clickedScrollbar */](event)) return;

          var current = event.target;

          if (__WEBPACK_IMPORTED_MODULE_2__dom_helpers__["b" /* findHighest */](current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          var handlerOptions = null;
          var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

          if (isTouchEvent && passiveEventSupport) {
            handlerOptions = { passive: !_this.props.preventDefault };
          }

          document.addEventListener(eventName, handlersMap[_this._uid], handlerOptions);
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;
          if (!events.forEach) {
            events = [events];
          }
          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn);
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__uid__["a" /* default */])();
      return _this;
    }

    /**
     * Access the WrappedComponent's instance.
     */


    onClickOutside.prototype.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }
      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    onClickOutside.prototype.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error('WrappedComponent lacks a function for processing outside click events specified by the handleClickOutside config option.');
        }
      }

      this.componentNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this.getInstance());
      this.enableOnClickOutside();
    };

    onClickOutside.prototype.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this.getInstance());
    };

    /**
     * Remove all document's event listeners for this component
     */


    onClickOutside.prototype.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };

    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */


    /**
     * Can be called to explicitly disable event listening
     * for clicks and touches outside of this element.
     */


    /**
     * Pass-through render
     */
    onClickOutside.prototype.render = function render() {
      var _this2 = this;

      var props = Object.keys(this.props).filter(function (prop) {
        return prop !== 'excludeScrollbar';
      }).reduce(function (props, prop) {
        props[prop] = _this2.props[prop];
        return props;
      }, {});

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = 'OnClickOutside(' + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ')', _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(348);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNaN__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isNaN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isNaN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_max__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_max___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_max__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isNil__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isArray__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_smooth__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shape_Curve__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shape_Dot__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__container_Layer__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__component_LabelList__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_DataUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_ChartUtils__ = __webpack_require__(44);








function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Area
 */












var Area =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Area, _PureComponent);

  function Area() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Area);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Area)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isAnimationFinished: true
    };
    _this.id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["f" /* uniqueId */])('recharts-area-');

    _this.cachePrevData = function (points, baseLine) {
      _this.setState({
        prevPoints: points,
        prevBaseLine: baseLine
      });
    };

    _this.handleAnimationEnd = function () {
      var onAnimationEnd = _this.props.onAnimationEnd;

      _this.setState({
        isAnimationFinished: true
      });

      if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(onAnimationEnd)) {
        onAnimationEnd();
      }
    };

    _this.handleAnimationStart = function () {
      var onAnimationStart = _this.props.onAnimationStart;

      _this.setState({
        isAnimationFinished: false
      });

      if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(onAnimationStart)) {
        onAnimationStart();
      }
    };

    return _this;
  }

  _createClass(Area, [{
    key: "componentWillReceiveProps",
    // eslint-disable-next-line camelcase
    value: function componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
          animationId = _this$props.animationId,
          points = _this$props.points,
          baseLine = _this$props.baseLine;

      if (nextProps.animationId !== animationId) {
        this.cachePrevData(points, baseLine);
      }
    }
  }, {
    key: "renderDots",
    value: function renderDots(needClip, clipPathId) {
      var _this2 = this;

      var isAnimationActive = this.props.isAnimationActive;
      var isAnimationFinished = this.state.isAnimationFinished;

      if (isAnimationActive && !isAnimationFinished) {
        return null;
      }

      var _this$props2 = this.props,
          dot = _this$props2.dot,
          points = _this$props2.points,
          dataKey = _this$props2.dataKey;
      var areaProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props);
      var customDotProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["a" /* getPresentationAttributes */])(dot);
      var dotEvents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["b" /* filterEventAttributes */])(dot);
      var dots = points.map(function (entry, i) {
        var dotProps = _objectSpread({
          key: "dot-".concat(i),
          r: 3
        }, areaProps, {}, customDotProps, {}, dotEvents, {
          dataKey: dataKey,
          cx: entry.x,
          cy: entry.y,
          index: i,
          value: entry.value,
          payload: entry.payload
        });

        return _this2.constructor.renderDotItem(dot, dotProps);
      });
      var dotsProps = {
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
      };
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__container_Layer__["a" /* default */], _extends({
        className: "recharts-area-dots"
      }, dotsProps), dots);
    }
  }, {
    key: "renderHorizontalRect",
    value: function renderHorizontalRect(alpha) {
      var _this$props3 = this.props,
          baseLine = _this$props3.baseLine,
          points = _this$props3.points,
          strokeWidth = _this$props3.strokeWidth;
      var startX = points[0].x;
      var endX = points[points.length - 1].x;
      var width = alpha * Math.abs(startX - endX);

      var maxY = __WEBPACK_IMPORTED_MODULE_2_lodash_max___default()(points.map(function (entry) {
        return entry.y || 0;
      }));

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["a" /* isNumber */])(baseLine)) {
        maxY = Math.max(baseLine, maxY);
      } else if (baseLine && __WEBPACK_IMPORTED_MODULE_6_lodash_isArray___default()(baseLine) && baseLine.length) {
        maxY = Math.max(__WEBPACK_IMPORTED_MODULE_2_lodash_max___default()(baseLine.map(function (entry) {
          return entry.y || 0;
        })), maxY);
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["a" /* isNumber */])(maxY)) {
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("rect", {
          x: startX < endX ? startX : startX - width,
          y: 0,
          width: width,
          height: parseInt(maxY + (strokeWidth || 1), 10)
        });
      }

      return null;
    }
  }, {
    key: "renderVerticalRect",
    value: function renderVerticalRect(alpha) {
      var _this$props4 = this.props,
          baseLine = _this$props4.baseLine,
          points = _this$props4.points,
          strokeWidth = _this$props4.strokeWidth;
      var startY = points[0].y;
      var endY = points[points.length - 1].y;
      var height = alpha * Math.abs(startY - endY);

      var maxX = __WEBPACK_IMPORTED_MODULE_2_lodash_max___default()(points.map(function (entry) {
        return entry.x || 0;
      }));

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["a" /* isNumber */])(baseLine)) {
        maxX = Math.max(baseLine, maxX);
      } else if (baseLine && __WEBPACK_IMPORTED_MODULE_6_lodash_isArray___default()(baseLine) && baseLine.length) {
        maxX = Math.max(__WEBPACK_IMPORTED_MODULE_2_lodash_max___default()(baseLine.map(function (entry) {
          return entry.x || 0;
        })), maxX);
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["a" /* isNumber */])(maxX)) {
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("rect", {
          x: 0,
          y: startY < endY ? startY : startY - height,
          width: maxX + (strokeWidth || 1),
          height: parseInt(height, 10)
        });
      }

      return null;
    }
  }, {
    key: "renderClipRect",
    value: function renderClipRect(alpha) {
      var layout = this.props.layout;

      if (layout === 'vertical') {
        return this.renderVerticalRect(alpha);
      }

      return this.renderHorizontalRect(alpha);
    }
  }, {
    key: "renderAreaStatically",
    value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
      var _this$props5 = this.props,
          layout = _this$props5.layout,
          type = _this$props5.type,
          stroke = _this$props5.stroke,
          connectNulls = _this$props5.connectNulls,
          isRange = _this$props5.isRange;
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__container_Layer__["a" /* default */], {
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
      }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shape_Curve__["a" /* default */], _extends({}, this.props, {
        points: points,
        baseLine: baseLine,
        stroke: "none",
        className: "recharts-area-area"
      })), stroke !== 'none' && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shape_Curve__["a" /* default */], _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props), {
        className: "recharts-area-curve",
        layout: layout,
        type: type,
        connectNulls: connectNulls,
        fill: "none",
        points: points
      })), stroke !== 'none' && isRange && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shape_Curve__["a" /* default */], _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props), {
        className: "recharts-area-curve",
        layout: layout,
        type: type,
        connectNulls: connectNulls,
        fill: "none",
        points: baseLine
      })));
    }
  }, {
    key: "renderAreaWithAnimation",
    value: function renderAreaWithAnimation(needClip, clipPathId) {
      var _this3 = this;

      var _this$props6 = this.props,
          points = _this$props6.points,
          baseLine = _this$props6.baseLine,
          isAnimationActive = _this$props6.isAnimationActive,
          animationBegin = _this$props6.animationBegin,
          animationDuration = _this$props6.animationDuration,
          animationEasing = _this$props6.animationEasing,
          animationId = _this$props6.animationId;
      var _this$state = this.state,
          prevPoints = _this$state.prevPoints,
          prevBaseLine = _this$state.prevBaseLine; // const clipPathId = _.isNil(id) ? this.id : id;

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_smooth__["a" /* default */], {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "area-".concat(animationId),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function (_ref) {
        var t = _ref.t;

        if (prevPoints) {
          var prevPointsDiffFactor = prevPoints.length / points.length; // update animtaion

          var stepPoints = points.map(function (entry, index) {
            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);

            if (prevPoints[prevPointIndex]) {
              var prev = prevPoints[prevPointIndex];
              var interpolatorX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["b" /* interpolateNumber */])(prev.x, entry.x);
              var interpolatorY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["b" /* interpolateNumber */])(prev.y, entry.y);
              return _objectSpread({}, entry, {
                x: interpolatorX(t),
                y: interpolatorY(t)
              });
            }

            return entry;
          });
          var stepBaseLine;

          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["a" /* isNumber */])(baseLine)) {
            var interpolator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["b" /* interpolateNumber */])(prevBaseLine, baseLine);
            stepBaseLine = interpolator(t);
          } else if (__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(baseLine) || __WEBPACK_IMPORTED_MODULE_1_lodash_isNaN___default()(baseLine)) {
            var _interpolator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["b" /* interpolateNumber */])(prevBaseLine, 0);

            stepBaseLine = _interpolator(t);
          } else {
            stepBaseLine = baseLine.map(function (entry, index) {
              var prevPointIndex = Math.floor(index * prevPointsDiffFactor);

              if (prevBaseLine[prevPointIndex]) {
                var prev = prevBaseLine[prevPointIndex];
                var interpolatorX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["b" /* interpolateNumber */])(prev.x, entry.x);
                var interpolatorY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["b" /* interpolateNumber */])(prev.y, entry.y);
                return _objectSpread({}, entry, {
                  x: interpolatorX(t),
                  y: interpolatorY(t)
                });
              }

              return entry;
            });
          }

          return _this3.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
        }

        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__container_Layer__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("defs", null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("clipPath", {
          id: "animationClipPath-".concat(clipPathId)
        }, _this3.renderClipRect(t))), __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__container_Layer__["a" /* default */], {
          clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
        }, _this3.renderAreaStatically(points, baseLine, needClip, clipPathId)));
      });
    }
  }, {
    key: "renderArea",
    value: function renderArea(needClip, clipPathId) {
      var _this$props7 = this.props,
          points = _this$props7.points,
          baseLine = _this$props7.baseLine,
          isAnimationActive = _this$props7.isAnimationActive;
      var _this$state2 = this.state,
          prevPoints = _this$state2.prevPoints,
          prevBaseLine = _this$state2.prevBaseLine,
          totalLength = _this$state2.totalLength;

      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevPoints, points) || !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevBaseLine, baseLine))) {
        return this.renderAreaWithAnimation(needClip, clipPathId);
      }

      return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          hide = _this$props8.hide,
          dot = _this$props8.dot,
          points = _this$props8.points,
          className = _this$props8.className,
          top = _this$props8.top,
          left = _this$props8.left,
          xAxis = _this$props8.xAxis,
          yAxis = _this$props8.yAxis,
          width = _this$props8.width,
          height = _this$props8.height,
          isAnimationActive = _this$props8.isAnimationActive,
          id = _this$props8.id;

      if (hide || !points || !points.length) {
        return null;
      }

      var isAnimationFinished = this.state.isAnimationFinished;
      var hasSinglePoint = points.length === 1;
      var layerClass = __WEBPACK_IMPORTED_MODULE_9_classnames___default()('recharts-area', className);
      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
      var clipPathId = __WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(id) ? this.id : id;
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__container_Layer__["a" /* default */], {
        className: layerClass
      }, needClip ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("defs", null, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("clipPath", {
        id: "clipPath-".concat(clipPathId)
      }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("rect", {
        x: left,
        y: top,
        width: width,
        height: parseInt(height, 10)
      }))) : null, !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null, (dot || hasSinglePoint) && this.renderDots(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && __WEBPACK_IMPORTED_MODULE_14__component_LabelList__["a" /* default */].renderCallByParent(this.props, points));
    }
  }]);

  return Area;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

Area.displayName = 'Area';
Area.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {}, __WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["d" /* EVENT_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  dataKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func]).isRequired,
  type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func]),
  unit: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number]),
  name: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number]),
  yAxisId: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number]),
  xAxisId: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number]),
  yAxis: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  xAxis: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  stackId: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string]),
  legendType: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["f" /* LEGEND_TYPES */]),
  tooltipType: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["g" /* TOOLTIP_TYPES */]),
  connectNulls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  activeDot: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool]),
  // dot configuration
  dot: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool]),
  label: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool]),
  hide: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  // have curve configuration
  layout: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['horizontal', 'vertical']),
  baseLine: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.array]),
  isRange: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  points: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
    value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.array])
  })),
  onAnimationStart: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onAnimationEnd: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  animationId: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
  id: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
});
Area.defaultProps = {
  stroke: '#3182bd',
  fill: '#3182bd',
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: 'line',
  connectNulls: false,
  // points of area
  points: [],
  dot: false,
  activeDot: true,
  hide: false,
  isAnimationActive: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_ReactUtils__["h" /* isSsr */])(),
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease'
};

Area.getBaseValue = function (props, xAxis, yAxis) {
  var layout = props.layout,
      baseValue = props.baseValue;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_DataUtils__["a" /* isNumber */])(baseValue)) {
    return baseValue;
  }

  var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
  var domain = numericAxis.scale.domain();

  if (numericAxis.type === 'number') {
    var max = Math.max(domain[0], domain[1]);
    var min = Math.min(domain[0], domain[1]);

    if (baseValue === 'dataMin') {
      return min;
    }

    if (baseValue === 'dataMax') {
      return max;
    }

    return max < 0 ? max : Math.max(Math.min(domain[0], domain[1]), 0);
  }

  if (baseValue === 'dataMin') {
    return domain[0];
  }

  if (baseValue === 'dataMax') {
    return domain[1];
  }

  return domain[0];
};

Area.getComposedData = function (_ref2) {
  var props = _ref2.props,
      xAxis = _ref2.xAxis,
      yAxis = _ref2.yAxis,
      xAxisTicks = _ref2.xAxisTicks,
      yAxisTicks = _ref2.yAxisTicks,
      bandSize = _ref2.bandSize,
      dataKey = _ref2.dataKey,
      stackedData = _ref2.stackedData,
      dataStartIndex = _ref2.dataStartIndex,
      displayedData = _ref2.displayedData,
      offset = _ref2.offset;
  var layout = props.layout;
  var hasStack = stackedData && stackedData.length;
  var baseValue = Area.getBaseValue(props, xAxis, yAxis);
  var isRange = false;
  var points = displayedData.map(function (entry, index) {
    var value;

    if (hasStack) {
      value = stackedData[dataStartIndex + index];
    } else {
      value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_ChartUtils__["a" /* getValueByDataKey */])(entry, dataKey);

      if (!__WEBPACK_IMPORTED_MODULE_6_lodash_isArray___default()(value)) {
        value = [baseValue, value];
      } else {
        isRange = true;
      }
    }

    if (layout === 'horizontal') {
      return {
        x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_ChartUtils__["x" /* getCateCoordinateOfLine */])({
          axis: xAxis,
          ticks: xAxisTicks,
          bandSize: bandSize,
          entry: entry,
          index: index
        }),
        y: __WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(value[1]) ? null : yAxis.scale(value[1]),
        value: value,
        payload: entry
      };
    }

    return {
      x: __WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(value[1]) ? null : xAxis.scale(value[1]),
      y: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_ChartUtils__["x" /* getCateCoordinateOfLine */])({
        axis: yAxis,
        ticks: yAxisTicks,
        bandSize: bandSize,
        entry: entry,
        index: index
      }),
      value: value,
      payload: entry
    };
  });
  var baseLine;

  if (hasStack || isRange) {
    baseLine = points.map(function (entry) {
      if (layout === 'horizontal') {
        return {
          x: entry.x,
          y: !__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(entry, 'value[0]')) ? yAxis.scale(__WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(entry, 'value[0]')) : null
        };
      }

      return {
        x: !__WEBPACK_IMPORTED_MODULE_5_lodash_isNil___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(entry, 'value[0]')) ? xAxis.scale(__WEBPACK_IMPORTED_MODULE_4_lodash_get___default()(entry, 'value[0]')) : null,
        y: entry.y
      };
    });
  } else if (layout === 'horizontal') {
    baseLine = yAxis.scale(baseValue);
  } else {
    baseLine = xAxis.scale(baseValue);
  }

  return _objectSpread({
    points: points,
    baseLine: baseLine,
    layout: layout,
    isRange: isRange
  }, offset);
};

Area.renderDotItem = function (option, props) {
  var dotItem;

  if (__WEBPACK_IMPORTED_MODULE_7_react___default.a.isValidElement(option)) {
    dotItem = __WEBPACK_IMPORTED_MODULE_7_react___default.a.cloneElement(option, props);
  } else if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(option)) {
    dotItem = option(props);
  } else {
    dotItem = __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shape_Dot__["a" /* default */], _extends({}, props, {
      className: "recharts-area-dot"
    }));
  }

  return dotItem;
};

/* harmony default export */ __webpack_exports__["a"] = (Area);

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isFunction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_smooth__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shape_Rectangle__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__container_Layer__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ErrorBar__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__component_Cell__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__component_LabelList__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_DataUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_ChartUtils__ = __webpack_require__(44);





function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Render a group of bar
 */













var Bar =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Bar, _PureComponent);

  function Bar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Bar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Bar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isAnimationFinished: false
    };
    _this.id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["f" /* uniqueId */])('recharts-bar-');

    _this.cachePrevData = function (data) {
      _this.setState({
        prevData: data
      });
    };

    _this.handleAnimationEnd = function () {
      _this.setState({
        isAnimationFinished: true
      });

      _this.props.onAnimationEnd();
    };

    _this.handleAnimationStart = function () {
      _this.setState({
        isAnimationFinished: false
      });

      _this.props.onAnimationStart();
    };

    return _this;
  }

  _createClass(Bar, [{
    key: "componentWillReceiveProps",
    // eslint-disable-next-line camelcase
    value: function componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
          animationId = _this$props.animationId,
          data = _this$props.data;

      if (nextProps.animationId !== animationId) {
        this.cachePrevData(data);
      }
    }
  }, {
    key: "renderRectanglesStatically",
    value: function renderRectanglesStatically(data) {
      var _this2 = this;

      var shape = this.props.shape;
      var baseProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props);
      return data && data.map(function (entry, i) {
        var props = _objectSpread({}, baseProps, {}, entry, {
          index: i
        });

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], _extends({
          className: "recharts-bar-rectangle"
        }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["e" /* filterEventsOfChild */])(_this2.props, entry, i), {
          key: "rectangle-".concat(i) // eslint-disable-line react/no-array-index-key

        }), _this2.constructor.renderRectangle(shape, props));
      });
    }
  }, {
    key: "renderRectanglesWithAnimation",
    value: function renderRectanglesWithAnimation() {
      var _this3 = this;

      var _this$props2 = this.props,
          data = _this$props2.data,
          layout = _this$props2.layout,
          isAnimationActive = _this$props2.isAnimationActive,
          animationBegin = _this$props2.animationBegin,
          animationDuration = _this$props2.animationDuration,
          animationEasing = _this$props2.animationEasing,
          animationId = _this$props2.animationId;
      var prevData = this.state.prevData;
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_smooth__["a" /* default */], {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "bar-".concat(animationId),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function (_ref) {
        var t = _ref.t;
        var stepData = data.map(function (entry, index) {
          var prev = prevData && prevData[index];

          if (prev) {
            var interpolatorX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["b" /* interpolateNumber */])(prev.x, entry.x);
            var interpolatorY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["b" /* interpolateNumber */])(prev.y, entry.y);
            var interpolatorWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["b" /* interpolateNumber */])(prev.width, entry.width);
            var interpolatorHeight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["b" /* interpolateNumber */])(prev.height, entry.height);
            return _objectSpread({}, entry, {
              x: interpolatorX(t),
              y: interpolatorY(t),
              width: interpolatorWidth(t),
              height: interpolatorHeight(t)
            });
          }

          if (layout === 'horizontal') {
            var _interpolatorHeight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["b" /* interpolateNumber */])(0, entry.height);

            var h = _interpolatorHeight(t);

            return _objectSpread({}, entry, {
              y: entry.y + entry.height - h,
              height: h
            });
          }

          var interpolator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["b" /* interpolateNumber */])(0, entry.width);
          var w = interpolator(t);
          return _objectSpread({}, entry, {
            width: w
          });
        });
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], null, _this3.renderRectanglesStatically(stepData));
      });
    }
  }, {
    key: "renderRectangles",
    value: function renderRectangles() {
      var _this$props3 = this.props,
          data = _this$props3.data,
          isAnimationActive = _this$props3.isAnimationActive;
      var prevData = this.state.prevData;

      if (isAnimationActive && data && data.length && (!prevData || !__WEBPACK_IMPORTED_MODULE_1_lodash_isEqual___default()(prevData, data))) {
        return this.renderRectanglesWithAnimation();
      }

      return this.renderRectanglesStatically(data);
    }
  }, {
    key: "renderBackground",
    value: function renderBackground() {
      var _this4 = this;

      var data = this.props.data;
      var backgroundProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props.background);
      return data.map(function (entry, i) {
        // eslint-disable-next-line no-unused-vars
        var value = entry.value,
            background = entry.background,
            rest = _objectWithoutProperties(entry, ["value", "background"]);

        if (!background) {
          return null;
        }

        var props = _objectSpread({}, rest, {
          fill: '#eee'
        }, background, {}, backgroundProps, {}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["e" /* filterEventsOfChild */])(_this4.props, entry, i), {
          index: i,
          key: "background-bar-".concat(i),
          className: 'recharts-bar-background-rectangle'
        });

        return _this4.constructor.renderRectangle(_this4.props.background, props);
      });
    }
  }, {
    key: "renderErrorBar",
    value: function renderErrorBar() {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }

      var _this$props4 = this.props,
          data = _this$props4.data,
          xAxis = _this$props4.xAxis,
          yAxis = _this$props4.yAxis,
          layout = _this$props4.layout,
          children = _this$props4.children;
      var errorBarItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["i" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_10__ErrorBar__["a" /* default */]);

      if (!errorBarItems) {
        return null;
      }

      var offset = layout === 'vertical' ? data[0].height / 2 : data[0].width / 2;

      function dataPointFormatter(dataPoint, dataKey) {
        return {
          x: dataPoint.x,
          y: dataPoint.y,
          value: dataPoint.value,
          errorVal: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_ChartUtils__["a" /* getValueByDataKey */])(dataPoint, dataKey)
        };
      }

      return errorBarItems.map(function (item, i) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(item, {
          key: "error-bar-".concat(i),
          // eslint-disable-line react/no-array-index-key
          data: data,
          xAxis: xAxis,
          yAxis: yAxis,
          layout: layout,
          offset: offset,
          dataPointFormatter: dataPointFormatter
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          hide = _this$props5.hide,
          data = _this$props5.data,
          className = _this$props5.className,
          xAxis = _this$props5.xAxis,
          yAxis = _this$props5.yAxis,
          left = _this$props5.left,
          top = _this$props5.top,
          width = _this$props5.width,
          height = _this$props5.height,
          isAnimationActive = _this$props5.isAnimationActive,
          background = _this$props5.background,
          id = _this$props5.id;

      if (hide || !data || !data.length) {
        return null;
      }

      var isAnimationFinished = this.state.isAnimationFinished;
      var layerClass = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('recharts-bar', className);
      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
      var clipPathId = __WEBPACK_IMPORTED_MODULE_0_lodash_isNil___default()(id) ? this.id : id;
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], {
        className: layerClass
      }, needClip ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("defs", null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("clipPath", {
        id: "clipPath-".concat(clipPathId)
      }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("rect", {
        x: left,
        y: top,
        width: width,
        height: height
      }))) : null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], {
        className: "recharts-bar-rectangles",
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
      }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(), (!isAnimationActive || isAnimationFinished) && __WEBPACK_IMPORTED_MODULE_12__component_LabelList__["a" /* default */].renderCallByParent(this.props, data));
    }
  }], [{
    key: "renderRectangle",
    value: function renderRectangle(option, props) {
      var rectangle;

      if (__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(option)) {
        rectangle = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(option)) {
        rectangle = option(props);
      } else {
        rectangle = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shape_Rectangle__["a" /* default */], props);
      }

      return rectangle;
    }
  }]);

  return Bar;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

Bar.displayName = 'Bar';
Bar.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {}, __WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["d" /* EVENT_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  layout: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['vertical', 'horizontal']),
  xAxisId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  yAxisId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  yAxis: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  xAxis: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  stackId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),
  barSize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  unit: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number]),
  name: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number]),
  dataKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]).isRequired,
  legendType: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["f" /* LEGEND_TYPES */]),
  tooltipType: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["g" /* TOOLTIP_TYPES */]),
  minPointSize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  maxBarSize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  hide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  shape: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.element]),
  data: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    width: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    radius: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array]),
    value: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array])
  })),
  onAnimationStart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onAnimationEnd: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  animationId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
  id: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
});
Bar.defaultProps = {
  xAxisId: 0,
  yAxisId: 0,
  legendType: 'rect',
  minPointSize: 0,
  hide: false,
  // data of bar
  data: [],
  layout: 'vertical',
  isAnimationActive: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["h" /* isSsr */])(),
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: 'ease',
  onAnimationStart: function onAnimationStart() {},
  onAnimationEnd: function onAnimationEnd() {}
};

Bar.getComposedData = function (_ref2) {
  var props = _ref2.props,
      item = _ref2.item,
      barPosition = _ref2.barPosition,
      bandSize = _ref2.bandSize,
      xAxis = _ref2.xAxis,
      yAxis = _ref2.yAxis,
      xAxisTicks = _ref2.xAxisTicks,
      yAxisTicks = _ref2.yAxisTicks,
      stackedData = _ref2.stackedData,
      dataStartIndex = _ref2.dataStartIndex,
      displayedData = _ref2.displayedData,
      offset = _ref2.offset;
  var pos = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_ChartUtils__["y" /* findPositionOfBar */])(barPosition, item);

  if (!pos) {
    return [];
  }

  var layout = props.layout;
  var _item$props = item.props,
      dataKey = _item$props.dataKey,
      children = _item$props.children,
      minPointSize = _item$props.minPointSize;
  var numericAxis = layout === 'horizontal' ? yAxis : xAxis;
  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
  var baseValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_ChartUtils__["z" /* getBaseValueOfBar */])({
    props: props,
    numericAxis: numericAxis
  });
  var cells = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["i" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_11__component_Cell__["a" /* default */]);
  var rects = displayedData.map(function (entry, index) {
    var value, x, y, width, height, background;

    if (stackedData) {
      value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_ChartUtils__["A" /* truncateByDomain */])(stackedData[dataStartIndex + index], stackedDomain);
    } else {
      value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_ChartUtils__["a" /* getValueByDataKey */])(entry, dataKey);

      if (!__WEBPACK_IMPORTED_MODULE_3_lodash_isArray___default()(value)) {
        value = [baseValue, value];
      }
    }

    if (layout === 'horizontal') {
      x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_ChartUtils__["B" /* getCateCoordinateOfBar */])({
        axis: xAxis,
        ticks: xAxisTicks,
        bandSize: bandSize,
        offset: pos.offset,
        entry: entry,
        index: index
      });
      y = yAxis.scale(value[1]);
      width = pos.size;
      height = yAxis.scale(value[0]) - yAxis.scale(value[1]);
      background = {
        x: x,
        y: yAxis.y,
        width: width,
        height: yAxis.height
      };

      if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
        var delta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["d" /* mathSign */])(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
        y -= delta;
        height += delta;
      }
    } else {
      x = xAxis.scale(value[0]);
      y = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_ChartUtils__["B" /* getCateCoordinateOfBar */])({
        axis: yAxis,
        ticks: yAxisTicks,
        bandSize: bandSize,
        offset: pos.offset,
        entry: entry,
        index: index
      });
      width = xAxis.scale(value[1]) - xAxis.scale(value[0]);
      height = pos.size;
      background = {
        x: xAxis.x,
        y: y,
        width: xAxis.width,
        height: height
      };

      if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
        var _delta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_DataUtils__["d" /* mathSign */])(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));

        width += _delta;
      }
    }

    return _objectSpread({}, entry, {
      x: x,
      y: y,
      width: width,
      height: height,
      value: stackedData ? value : value[1],
      payload: entry,
      background: background
    }, cells && cells[index] && cells[index].props);
  });
  return _objectSpread({
    data: rects,
    layout: layout
  }, offset);
};

/* harmony default export */ __webpack_exports__["a"] = (Bar);

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_smooth__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shape_Curve__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shape_Dot__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__container_Layer__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__component_LabelList__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ErrorBar__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_DataUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_ChartUtils__ = __webpack_require__(44);




function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Line
 */













var Line =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Line, _PureComponent);

  function Line() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Line);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Line)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isAnimationFinished: true,
      totalLength: 0
    };
    _this.id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["f" /* uniqueId */])('recharts-line-');

    _this.cachePrevData = function (points) {
      _this.setState({
        prevPoints: points
      });
    };

    _this.pathRef = function (node) {
      _this.mainCurve = node;
    };

    _this.handleAnimationEnd = function () {
      _this.setState({
        isAnimationFinished: true
      });

      _this.props.onAnimationEnd();
    };

    _this.handleAnimationStart = function () {
      _this.setState({
        isAnimationFinished: false
      });

      _this.props.onAnimationStart();
    };

    return _this;
  }

  _createClass(Line, [{
    key: "componentDidMount",

    /* eslint-disable  react/no-did-mount-set-state */
    value: function componentDidMount() {
      if (!this.props.isAnimationActive) {
        return;
      }

      var totalLength = this.getTotalLength();
      this.setState({
        totalLength: totalLength
      });
    } // eslint-disable-next-line camelcase

  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
          animationId = _this$props.animationId,
          points = _this$props.points;

      if (nextProps.animationId !== animationId) {
        this.cachePrevData(points);
      }
    }
  }, {
    key: "getTotalLength",
    value: function getTotalLength() {
      var curveDom = this.mainCurve;

      try {
        return curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
      } catch (err) {
        return 0;
      }
    }
  }, {
    key: "getStrokeDasharray",
    value: function getStrokeDasharray(length, totalLength, lines) {
      var lineLength = lines.reduce(function (pre, next) {
        return pre + next;
      });
      var count = parseInt(length / lineLength, 10);
      var remainLength = length % lineLength;
      var restLength = totalLength - length;
      var remainLines = [];

      for (var i = 0, sum = 0;; sum += lines[i], ++i) {
        if (sum + lines[i] > remainLength) {
          remainLines = [].concat(_toConsumableArray(lines.slice(0, i)), [remainLength - sum]);
          break;
        }
      }

      var emptyLines = remainLines.length % 2 === 0 ? [0, restLength] : [restLength];
      return [].concat(_toConsumableArray(this.constructor.repeat(lines, count)), _toConsumableArray(remainLines), emptyLines).map(function (line) {
        return "".concat(line, "px");
      }).join(', ');
    }
  }, {
    key: "renderErrorBar",
    value: function renderErrorBar() {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }

      var _this$props2 = this.props,
          points = _this$props2.points,
          xAxis = _this$props2.xAxis,
          yAxis = _this$props2.yAxis,
          layout = _this$props2.layout,
          children = _this$props2.children;
      var errorBarItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["i" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_11__ErrorBar__["a" /* default */]);

      if (!errorBarItems) {
        return null;
      }

      function dataPointFormatter(dataPoint, dataKey) {
        return {
          x: dataPoint.x,
          y: dataPoint.y,
          value: dataPoint.value,
          errorVal: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_ChartUtils__["a" /* getValueByDataKey */])(dataPoint.payload, dataKey)
        };
      }

      return errorBarItems.map(function (item, i) {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(item, {
          key: i,
          // eslint-disable-line react/no-array-index-key
          data: points,
          xAxis: xAxis,
          yAxis: yAxis,
          layout: layout,
          dataPointFormatter: dataPointFormatter
        });
      });
    }
  }, {
    key: "renderDots",
    value: function renderDots(needClip, clipPathId) {
      var _this2 = this;

      var isAnimationActive = this.props.isAnimationActive;

      if (isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }

      var _this$props3 = this.props,
          dot = _this$props3.dot,
          points = _this$props3.points,
          dataKey = _this$props3.dataKey;
      var lineProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props);
      var customDotProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["a" /* getPresentationAttributes */])(dot);
      var dotEvents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["b" /* filterEventAttributes */])(dot);
      var dots = points.map(function (entry, i) {
        var dotProps = _objectSpread({
          key: "dot-".concat(i),
          r: 3
        }, lineProps, {}, customDotProps, {}, dotEvents, {
          value: entry.value,
          dataKey: dataKey,
          cx: entry.x,
          cy: entry.y,
          index: i,
          payload: entry.payload
        });

        return _this2.constructor.renderDotItem(dot, dotProps);
      });
      var dotsProps = {
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
      };
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], _extends({
        className: "recharts-line-dots",
        key: "dots"
      }, dotsProps), dots);
    }
  }, {
    key: "renderCurveStatically",
    value: function renderCurveStatically(points, needClip, clipPathId, props) {
      var _this$props4 = this.props,
          type = _this$props4.type,
          layout = _this$props4.layout,
          connectNulls = _this$props4.connectNulls;

      var curveProps = _objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props), {}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["b" /* filterEventAttributes */])(this.props), {
        fill: 'none',
        className: 'recharts-line-curve',
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null,
        points: points
      }, props, {
        type: type,
        layout: layout,
        connectNulls: connectNulls
      });

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shape_Curve__["a" /* default */], _extends({}, curveProps, {
        pathRef: this.pathRef
      }));
    }
  }, {
    key: "renderCurveWithAnimation",
    value: function renderCurveWithAnimation(needClip, clipPathId) {
      var _this3 = this;

      var _this$props5 = this.props,
          points = _this$props5.points,
          strokeDasharray = _this$props5.strokeDasharray,
          isAnimationActive = _this$props5.isAnimationActive,
          animationBegin = _this$props5.animationBegin,
          animationDuration = _this$props5.animationDuration,
          animationEasing = _this$props5.animationEasing,
          animationId = _this$props5.animationId,
          width = _this$props5.width,
          height = _this$props5.height;
      var _this$state = this.state,
          prevPoints = _this$state.prevPoints,
          totalLength = _this$state.totalLength;
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_smooth__["a" /* default */], {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "line-".concat(animationId),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function (_ref) {
        var t = _ref.t;

        if (prevPoints) {
          var prevPointsDiffFactor = prevPoints.length / points.length;
          var stepData = points.map(function (entry, index) {
            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);

            if (prevPoints[prevPointIndex]) {
              var prev = prevPoints[prevPointIndex];
              var interpolatorX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["b" /* interpolateNumber */])(prev.x, entry.x);
              var interpolatorY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["b" /* interpolateNumber */])(prev.y, entry.y);
              return _objectSpread({}, entry, {
                x: interpolatorX(t),
                y: interpolatorY(t)
              });
            } // magic number of faking previous x and y location


            if (_this3.animateNewValues) {
              var _interpolatorX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["b" /* interpolateNumber */])(width * 2, entry.x);

              var _interpolatorY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["b" /* interpolateNumber */])(height / 2, entry.y);

              return _objectSpread({}, entry, {
                x: _interpolatorX(t),
                y: _interpolatorY(t)
              });
            }

            return _objectSpread({}, entry, {
              x: entry.x,
              y: entry.y
            });
          });
          return _this3.renderCurveStatically(stepData, needClip, clipPathId);
        }

        var interpolator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["b" /* interpolateNumber */])(0, totalLength);
        var curLength = interpolator(t);
        var currentStrokeDasharray;

        if (strokeDasharray) {
          var lines = strokeDasharray.split(/[,\s]+/gim).map(function (num) {
            return parseFloat(num);
          });
          currentStrokeDasharray = _this3.getStrokeDasharray(curLength, totalLength, lines);
        } else {
          currentStrokeDasharray = "".concat(curLength, "px ").concat(totalLength - curLength, "px");
        }

        return _this3.renderCurveStatically(points, needClip, clipPathId, {
          strokeDasharray: currentStrokeDasharray
        });
      });
    }
  }, {
    key: "renderCurve",
    value: function renderCurve(needClip, clipPathId) {
      var _this$props6 = this.props,
          points = _this$props6.points,
          isAnimationActive = _this$props6.isAnimationActive;
      var _this$state2 = this.state,
          prevPoints = _this$state2.prevPoints,
          totalLength = _this$state2.totalLength;

      if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevPoints, points))) {
        return this.renderCurveWithAnimation(needClip, clipPathId);
      }

      return this.renderCurveStatically(points, needClip, clipPathId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          hide = _this$props7.hide,
          dot = _this$props7.dot,
          points = _this$props7.points,
          className = _this$props7.className,
          xAxis = _this$props7.xAxis,
          yAxis = _this$props7.yAxis,
          top = _this$props7.top,
          left = _this$props7.left,
          width = _this$props7.width,
          height = _this$props7.height,
          isAnimationActive = _this$props7.isAnimationActive,
          id = _this$props7.id;

      if (hide || !points || !points.length) {
        return null;
      }

      var isAnimationFinished = this.state.isAnimationFinished;
      var hasSinglePoint = points.length === 1;
      var layerClass = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('recharts-line', className);
      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
      var clipPathId = __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(id) ? this.id : id;
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], {
        className: layerClass
      }, needClip ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("defs", null, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("clipPath", {
        id: "clipPath-".concat(clipPathId)
      }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("rect", {
        x: left,
        y: top,
        width: width,
        height: height
      }))) : null, !hasSinglePoint && this.renderCurve(needClip, clipPathId), this.renderErrorBar(), (hasSinglePoint || dot) && this.renderDots(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && __WEBPACK_IMPORTED_MODULE_10__component_LabelList__["a" /* default */].renderCallByParent(this.props, points));
    }
  }], [{
    key: "repeat",
    value: function repeat(lines, count) {
      var linesUnit = lines.length % 2 !== 0 ? [].concat(_toConsumableArray(lines), [0]) : lines;
      var result = [];

      for (var i = 0; i < count; ++i) {
        result = [].concat(_toConsumableArray(result), _toConsumableArray(linesUnit));
      }

      return result;
    }
  }, {
    key: "renderDotItem",
    value: function renderDotItem(option, props) {
      var dotItem;

      if (__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(option)) {
        dotItem = __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(option)) {
        dotItem = option(props);
      } else {
        var className = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('recharts-line-dot', option ? option.className : '');
        dotItem = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__shape_Dot__["a" /* default */], _extends({}, props, {
          className: className
        }));
      }

      return dotItem;
    }
  }]);

  return Line;
}(__WEBPACK_IMPORTED_MODULE_3_react__["PureComponent"]);

Line.displayName = 'Line';
Line.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {}, __WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["d" /* EVENT_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]),
  unit: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  name: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  yAxisId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  xAxisId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  yAxis: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  xAxis: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object,
  legendType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["f" /* LEGEND_TYPES */]),
  tooltipType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["g" /* TOOLTIP_TYPES */]),
  layout: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['horizontal', 'vertical']),
  connectNulls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  hide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  // whether have dot in line
  activeDot: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool]),
  dot: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool]),
  top: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  left: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  points: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.value
  })),
  onAnimationStart: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onAnimationEnd: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  animateNewValues: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']),
  animationId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
});
Line.defaultProps = {
  xAxisId: 0,
  yAxisId: 0,
  connectNulls: false,
  activeDot: true,
  dot: true,
  legendType: 'line',
  stroke: '#3182bd',
  strokeWidth: 1,
  fill: '#fff',
  points: [],
  isAnimationActive: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ReactUtils__["h" /* isSsr */])(),
  animateNewValues: true,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease',
  hide: false,
  onAnimationStart: function onAnimationStart() {},
  onAnimationEnd: function onAnimationEnd() {}
};

Line.getComposedData = function (_ref2) {
  var props = _ref2.props,
      xAxis = _ref2.xAxis,
      yAxis = _ref2.yAxis,
      xAxisTicks = _ref2.xAxisTicks,
      yAxisTicks = _ref2.yAxisTicks,
      dataKey = _ref2.dataKey,
      bandSize = _ref2.bandSize,
      displayedData = _ref2.displayedData,
      offset = _ref2.offset;
  var layout = props.layout;
  var points = displayedData.map(function (entry, index) {
    var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_ChartUtils__["a" /* getValueByDataKey */])(entry, dataKey);

    if (layout === 'horizontal') {
      return {
        x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_ChartUtils__["x" /* getCateCoordinateOfLine */])({
          axis: xAxis,
          ticks: xAxisTicks,
          bandSize: bandSize,
          entry: entry,
          index: index
        }),
        y: __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(value) ? null : yAxis.scale(value),
        value: value,
        payload: entry
      };
    }

    return {
      x: __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(value) ? null : xAxis.scale(value),
      y: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_ChartUtils__["x" /* getCateCoordinateOfLine */])({
        axis: yAxis,
        ticks: yAxisTicks,
        bandSize: bandSize,
        entry: entry,
        index: index
      }),
      value: value,
      payload: entry
    };
  });
  return _objectSpread({
    points: points,
    layout: layout
  }, offset);
};

/* harmony default export */ __webpack_exports__["a"] = (Line);

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_smooth__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__container_Layer__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component_LabelList__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ZAxis__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shape_Curve__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shape_Symbols__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ErrorBar__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__component_Cell__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_DataUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__ = __webpack_require__(44);




function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Render a group of scatters
 */















var Scatter =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Scatter, _PureComponent);

  function Scatter() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Scatter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Scatter)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isAnimationFinished: false
    };

    _this.cachePrevPoints = function (points) {
      _this.setState({
        prevPoints: points
      });
    };

    _this.handleAnimationEnd = function () {
      _this.setState({
        isAnimationFinished: true
      });
    };

    _this.handleAnimationStart = function () {
      _this.setState({
        isAnimationFinished: false
      });
    };

    _this.id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["f" /* uniqueId */])('recharts-scatter-');
    return _this;
  }

  _createClass(Scatter, [{
    key: "componentWillReceiveProps",
    // eslint-disable-next-line camelcase
    value: function componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
          animationId = _this$props.animationId,
          points = _this$props.points;

      if (nextProps.animationId !== animationId) {
        this.cachePrevPoints(points);
      }
    }
  }, {
    key: "renderSymbolsStatically",
    value: function renderSymbolsStatically(points) {
      var _this2 = this;

      var _this$props2 = this.props,
          shape = _this$props2.shape,
          activeShape = _this$props2.activeShape,
          activeIndex = _this$props2.activeIndex;
      var baseProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props);
      return points.map(function (entry, i) {
        var props = _objectSpread({
          key: "symbol-".concat(i)
        }, baseProps, {}, entry);

        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */], _extends({
          className: "recharts-scatter-symbol"
        }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["e" /* filterEventsOfChild */])(_this2.props, entry, i), {
          key: "symbol-".concat(i) // eslint-disable-line react/no-array-index-key

        }), _this2.constructor.renderSymbolItem(activeIndex === i ? activeShape : shape, props));
      });
    }
  }, {
    key: "renderSymbolsWithAnimation",
    value: function renderSymbolsWithAnimation() {
      var _this3 = this;

      var _this$props3 = this.props,
          points = _this$props3.points,
          isAnimationActive = _this$props3.isAnimationActive,
          animationBegin = _this$props3.animationBegin,
          animationDuration = _this$props3.animationDuration,
          animationEasing = _this$props3.animationEasing,
          animationId = _this$props3.animationId;
      var prevPoints = this.state.prevPoints;
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_smooth__["a" /* default */], {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(animationId),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function (_ref) {
        var t = _ref.t;
        var stepData = points.map(function (entry, index) {
          var prev = prevPoints && prevPoints[index];

          if (prev) {
            var interpolatorCx = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["b" /* interpolateNumber */])(prev.cx, entry.cx);
            var interpolatorCy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["b" /* interpolateNumber */])(prev.cy, entry.cy);
            var interpolatorSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["b" /* interpolateNumber */])(prev.size, entry.size);
            return _objectSpread({}, entry, {
              cx: interpolatorCx(t),
              cy: interpolatorCy(t),
              size: interpolatorSize(t)
            });
          }

          var interpolator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["b" /* interpolateNumber */])(0, entry.size);
          return _objectSpread({}, entry, {
            size: interpolator(t)
          });
        });
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */], null, _this3.renderSymbolsStatically(stepData));
      });
    }
  }, {
    key: "renderSymbols",
    value: function renderSymbols() {
      var _this$props4 = this.props,
          points = _this$props4.points,
          isAnimationActive = _this$props4.isAnimationActive;
      var prevPoints = this.state.prevPoints;

      if (isAnimationActive && points && points.length && (!prevPoints || !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevPoints, points))) {
        return this.renderSymbolsWithAnimation();
      }

      return this.renderSymbolsStatically(points);
    }
  }, {
    key: "renderErrorBar",
    value: function renderErrorBar() {
      var isAnimationActive = this.props.isAnimationActive;

      if (isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }

      var _this$props5 = this.props,
          points = _this$props5.points,
          xAxis = _this$props5.xAxis,
          yAxis = _this$props5.yAxis,
          children = _this$props5.children;
      var errorBarItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["i" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_13__ErrorBar__["a" /* default */]);

      if (!errorBarItems) {
        return null;
      }

      function dataPointFormatterY(dataPoint, dataKey) {
        return {
          x: dataPoint.cx,
          y: dataPoint.cy,
          value: dataPoint.node.y,
          errorVal: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__["a" /* getValueByDataKey */])(dataPoint, dataKey)
        };
      }

      function dataPointFormatterX(dataPoint, dataKey) {
        return {
          x: dataPoint.cx,
          y: dataPoint.cy,
          value: dataPoint.node.x,
          errorVal: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__["a" /* getValueByDataKey */])(dataPoint, dataKey)
        };
      }

      return errorBarItems.map(function (item, i) {
        var direction = item.props.direction;
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(item, {
          key: i,
          // eslint-disable-line react/no-array-index-key
          data: points,
          xAxis: xAxis,
          yAxis: yAxis,
          layout: direction === 'x' ? 'vertical' : 'horizontal',
          dataPointFormatter: direction === 'x' ? dataPointFormatterX : dataPointFormatterY
        });
      });
    }
  }, {
    key: "renderLine",
    value: function renderLine() {
      var _this$props6 = this.props,
          points = _this$props6.points,
          line = _this$props6.line,
          lineType = _this$props6.lineType,
          lineJointType = _this$props6.lineJointType;
      var scatterProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props);
      var customLineProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["a" /* getPresentationAttributes */])(line);
      var linePoints, lineItem;

      if (lineType === 'joint') {
        linePoints = points.map(function (entry) {
          return {
            x: entry.cx,
            y: entry.cy
          };
        });
      } else if (lineType === 'fitting') {
        var _getLinearRegression = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["k" /* getLinearRegression */])(points),
            xmin = _getLinearRegression.xmin,
            xmax = _getLinearRegression.xmax,
            a = _getLinearRegression.a,
            b = _getLinearRegression.b;

        var linearExp = function linearExp(x) {
          return a * x + b;
        };

        linePoints = [{
          x: xmin,
          y: linearExp(xmin)
        }, {
          x: xmax,
          y: linearExp(xmax)
        }];
      }

      var lineProps = _objectSpread({}, scatterProps, {
        fill: 'none',
        stroke: scatterProps && scatterProps.fill
      }, customLineProps, {
        points: linePoints
      });

      if (__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(line)) {
        lineItem = __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(line, lineProps);
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(line)) {
        lineItem = line(lineProps);
      } else {
        lineItem = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shape_Curve__["a" /* default */], _extends({}, lineProps, {
          type: lineJointType
        }));
      }

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */], {
        className: "recharts-scatter-line",
        key: "recharts-scatter-line"
      }, lineItem);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          hide = _this$props7.hide,
          points = _this$props7.points,
          line = _this$props7.line,
          className = _this$props7.className,
          xAxis = _this$props7.xAxis,
          yAxis = _this$props7.yAxis,
          left = _this$props7.left,
          top = _this$props7.top,
          width = _this$props7.width,
          height = _this$props7.height,
          id = _this$props7.id;

      if (hide || !points || !points.length) {
        return null;
      }

      var _this$state = this.state,
          isAnimationActive = _this$state.isAnimationActive,
          isAnimationFinished = _this$state.isAnimationFinished;
      var layerClass = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('recharts-scatter', className);
      var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
      var clipPathId = __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(id) ? this.id : id;
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */], {
        className: layerClass,
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
      }, needClip ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("defs", null, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("clipPath", {
        id: "clipPath-".concat(clipPathId)
      }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("rect", {
        x: left,
        y: top,
        width: width,
        height: height
      }))) : null, line && this.renderLine(), this.renderErrorBar(), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */], {
        key: "recharts-scatter-symbols"
      }, this.renderSymbols()), (!isAnimationActive || isAnimationFinished) && __WEBPACK_IMPORTED_MODULE_8__component_LabelList__["a" /* default */].renderCallByParent(this.props, points));
    }
  }], [{
    key: "renderSymbolItem",
    value: function renderSymbolItem(option, props) {
      var symbol;

      if (__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(option)) {
        symbol = __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(option)) {
        symbol = option(props);
      } else {
        symbol = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__shape_Symbols__["a" /* default */], _extends({}, props, {
          type: option
        }));
      }

      return symbol;
    }
  }]);

  return Scatter;
}(__WEBPACK_IMPORTED_MODULE_3_react__["PureComponent"]);

Scatter.displayName = 'Scatter';
Scatter.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["d" /* EVENT_ATTRIBUTES */], {}, __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  xAxisId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  yAxisId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  zAxisId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  line: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element]),
  lineType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['fitting', 'joint']),
  lineJointType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['basis', 'basisClosed', 'basisOpen', 'linear', 'linearClosed', 'natural', 'monotoneX', 'monotoneY', 'monotone', 'step', 'stepBefore', 'stepAfter']), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]),
  legendType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["f" /* LEGEND_TYPES */]),
  tooltipType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["g" /* TOOLTIP_TYPES */]),
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  name: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  activeIndex: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  activeShape: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element]),
  shape: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]),
  points: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    cx: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    cy: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    size: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    node: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
      x: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string]),
      y: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string]),
      z: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string])
    }),
    payload: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
  })),
  hide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  animationId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  animationBegin: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
});
Scatter.defaultProps = {
  xAxisId: 0,
  yAxisId: 0,
  zAxisId: 0,
  legendType: 'circle',
  lineType: 'joint',
  lineJointType: 'linear',
  data: [],
  shape: 'circle',
  hide: false,
  isAnimationActive: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["h" /* isSsr */])(),
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: 'linear'
};

Scatter.getComposedData = function (_ref2) {
  var xAxis = _ref2.xAxis,
      yAxis = _ref2.yAxis,
      zAxis = _ref2.zAxis,
      item = _ref2.item,
      displayedData = _ref2.displayedData,
      onItemMouseLeave = _ref2.onItemMouseLeave,
      onItemMouseEnter = _ref2.onItemMouseEnter,
      offset = _ref2.offset,
      xAxisTicks = _ref2.xAxisTicks,
      yAxisTicks = _ref2.yAxisTicks;
  var tooltipType = item.props.tooltipType;
  var cells = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["i" /* findAllByType */])(item.props.children, __WEBPACK_IMPORTED_MODULE_14__component_Cell__["a" /* default */]);
  var xAxisDataKey = __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(xAxis.dataKey) ? item.props.dataKey : xAxis.dataKey;
  var yAxisDataKey = __WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(yAxis.dataKey) ? item.props.dataKey : yAxis.dataKey;
  var zAxisDataKey = zAxis && zAxis.dataKey;
  var defaultRangeZ = zAxis ? zAxis.range : __WEBPACK_IMPORTED_MODULE_10__ZAxis__["a" /* default */].defaultProps.range;
  var defaultZ = defaultRangeZ && defaultRangeZ[0];
  var xBandSize = xAxis.scale.bandwidth ? xAxis.scale.bandwidth() : 0;
  var yBandSize = yAxis.scale.bandwidth ? yAxis.scale.bandwidth() : 0;
  var points = displayedData.map(function (entry, index) {
    var x = entry[xAxisDataKey];
    var y = entry[yAxisDataKey];
    var z = !__WEBPACK_IMPORTED_MODULE_2_lodash_isNil___default()(zAxisDataKey) && entry[zAxisDataKey] || '-';
    var tooltipPayload = [{
      name: xAxis.name || xAxis.dataKey,
      unit: xAxis.unit || '',
      value: x,
      payload: entry,
      dataKey: xAxisDataKey,
      type: tooltipType
    }, {
      name: yAxis.name || yAxis.dataKey,
      unit: yAxis.unit || '',
      value: y,
      payload: entry,
      dataKey: yAxisDataKey,
      type: tooltipType
    }];

    if (z !== '-') {
      tooltipPayload.push({
        name: zAxis.name || zAxis.dataKey,
        unit: zAxis.unit || '',
        value: z,
        payload: entry,
        dataKey: zAxisDataKey,
        type: tooltipType
      });
    }

    var cx = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__["x" /* getCateCoordinateOfLine */])({
      axis: xAxis,
      ticks: xAxisTicks,
      bandSize: xBandSize,
      entry: entry,
      index: index,
      dataKey: xAxisDataKey
    });
    var cy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__["x" /* getCateCoordinateOfLine */])({
      axis: yAxis,
      ticks: yAxisTicks,
      bandSize: yBandSize,
      entry: entry,
      index: index,
      dataKey: yAxisDataKey
    });
    var size = z !== '-' ? zAxis.scale(z) : defaultZ;
    var radius = Math.sqrt(Math.max(size, 0) / Math.PI);
    return _objectSpread({}, entry, {
      cx: cx,
      cy: cy,
      x: cx - radius,
      y: cy - radius,
      xAxis: xAxis,
      yAxis: yAxis,
      zAxis: zAxis,
      width: 2 * radius,
      height: 2 * radius,
      size: size,
      node: {
        x: x,
        y: y,
        z: z
      },
      tooltipPayload: tooltipPayload,
      tooltipPosition: {
        x: cx,
        y: cy
      },
      payload: entry
    }, cells && cells[index] && cells[index].props);
  });
  return _objectSpread({
    onMouseLeave: onItemMouseLeave,
    onMouseEnter: onItemMouseEnter,
    points: points
  }, offset);
};

/* harmony default export */ __webpack_exports__["a"] = (Scatter);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DefaultLegendContent__ = __webpack_require__(1566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_DataUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__ = __webpack_require__(23);



function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Legend
 */






var defaultUniqBy = function defaultUniqBy(entry) {
  return entry.value;
};

var getUniqPaylod = function getUniqPaylod(option, payload) {
  if (option === true) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy___default()(payload, defaultUniqBy);
  }

  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
    return __WEBPACK_IMPORTED_MODULE_1_lodash_uniqBy___default()(payload, option);
  }

  return payload;
};

var renderContent = function renderContent(content, props) {
  if (__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(content)) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(content, props);
  }

  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(content)) {
    return content(props);
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__DefaultLegendContent__["a" /* default */], props);
};

var EPS = 1;
var ICON_TYPES = __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["f" /* LEGEND_TYPES */].filter(function (type) {
  return type !== 'none';
});

var Legend =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Legend, _PureComponent);

  function Legend() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Legend);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Legend)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      boxWidth: -1,
      boxHeight: -1
    };
    return _this;
  }

  _createClass(Legend, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function getBBox() {
      var _this$state = this.state,
          boxWidth = _this$state.boxWidth,
          boxHeight = _this$state.boxHeight;

      if (boxWidth >= 0 && boxHeight >= 0) {
        return {
          width: boxWidth,
          height: boxHeight
        };
      }

      return null;
    }
  }, {
    key: "getDefaultPosition",
    value: function getDefaultPosition(style) {
      var _this$props = this.props,
          layout = _this$props.layout,
          align = _this$props.align,
          verticalAlign = _this$props.verticalAlign,
          margin = _this$props.margin,
          chartWidth = _this$props.chartWidth,
          chartHeight = _this$props.chartHeight;
      var hPos, vPos;

      if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
        if (align === 'center' && layout === 'vertical') {
          var box = this.getBBox() || {
            width: 0
          };
          hPos = {
            left: ((chartWidth || 0) - box.width) / 2
          };
        } else {
          hPos = align === 'right' ? {
            right: margin && margin.right || 0
          } : {
            left: margin && margin.left || 0
          };
        }
      }

      if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
        if (verticalAlign === 'middle') {
          var _box = this.getBBox() || {
            height: 0
          };

          vPos = {
            top: ((chartHeight || 0) - _box.height) / 2
          };
        } else {
          vPos = verticalAlign === 'bottom' ? {
            bottom: margin && margin.bottom || 0
          } : {
            top: margin && margin.top || 0
          };
        }
      }

      return _objectSpread({}, hPos, {}, vPos);
    }
  }, {
    key: "updateBBox",
    value: function updateBBox() {
      var _this$state2 = this.state,
          boxWidth = _this$state2.boxWidth,
          boxHeight = _this$state2.boxHeight;
      var onBBoxUpdate = this.props.onBBoxUpdate;

      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var box = this.wrapperNode.getBoundingClientRect();

        if (Math.abs(box.width - boxWidth) > EPS || Math.abs(box.height - boxHeight) > EPS) {
          this.setState({
            boxWidth: box.width,
            boxHeight: box.height
          }, function () {
            if (onBBoxUpdate) {
              onBBoxUpdate(box);
            }
          });
        }
      } else if (boxWidth !== -1 || boxHeight !== -1) {
        this.setState({
          boxWidth: -1,
          boxHeight: -1
        }, function () {
          if (onBBoxUpdate) {
            onBBoxUpdate(null);
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          content = _this$props2.content,
          width = _this$props2.width,
          height = _this$props2.height,
          wrapperStyle = _this$props2.wrapperStyle,
          paylodUniqBy = _this$props2.paylodUniqBy,
          payload = _this$props2.payload;

      var outerStyle = _objectSpread({
        position: 'absolute',
        width: width || 'auto',
        height: height || 'auto'
      }, this.getDefaultPosition(wrapperStyle), {}, wrapperStyle);

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
        className: "recharts-legend-wrapper",
        style: outerStyle,
        ref: function ref(node) {
          _this2.wrapperNode = node;
        }
      }, renderContent(content, _objectSpread({}, this.props, {
        payload: getUniqPaylod(paylodUniqBy, payload)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function getWithHeight(item, chartWidth) {
      var layout = item.props.layout;

      if (layout === 'vertical' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["a" /* isNumber */])(item.props.height)) {
        return {
          height: item.props.height
        };
      }

      if (layout === 'horizontal') {
        return {
          width: item.props.width || chartWidth
        };
      }

      return null;
    }
  }]);

  return Legend;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

Legend.displayName = 'Legend';
Legend.propTypes = {
  content: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
  wrapperStyle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  chartWidth: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  chartHeight: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  iconSize: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  iconType: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(ICON_TYPES),
  layout: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['horizontal', 'vertical']),
  align: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['center', 'left', 'right']),
  verticalAlign: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['top', 'bottom', 'middle']),
  margin: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    top: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    left: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    bottom: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    right: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number
  }),
  payload: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
    id: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
    type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["f" /* LEGEND_TYPES */])
  })),
  paylodUniqBy: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool]),
  formatter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onBBoxUpdate: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};
Legend.defaultProps = {
  iconSize: 14,
  layout: 'horizontal',
  align: 'center',
  verticalAlign: 'bottom'
};
/* harmony default export */ __webpack_exports__["a"] = (Legend);

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_shape__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__ = __webpack_require__(23);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Curve
 */





var SYMBOL_FACTORIES = {
  symbolCircle: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["t" /* symbolCircle */],
  symbolCross: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["u" /* symbolCross */],
  symbolDiamond: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["v" /* symbolDiamond */],
  symbolSquare: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["w" /* symbolSquare */],
  symbolStar: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["x" /* symbolStar */],
  symbolTriangle: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["y" /* symbolTriangle */],
  symbolWye: __WEBPACK_IMPORTED_MODULE_2_d3_shape__["z" /* symbolWye */]
};
var RADIAN = Math.PI / 180;

var getSymbolFactory = function getSymbolFactory(type) {
  var name = "symbol".concat(type.slice(0, 1).toUpperCase()).concat(type.slice(1));
  return SYMBOL_FACTORIES[name] || __WEBPACK_IMPORTED_MODULE_2_d3_shape__["t" /* symbolCircle */];
};

var calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
  if (sizeType === 'area') {
    return size;
  }

  switch (type) {
    case 'cross':
      return 5 * size * size / 9;

    case 'diamond':
      return 0.5 * size * size / Math.sqrt(3);

    case 'square':
      return size * size;

    case 'star':
      {
        var angle = 18 * RADIAN;
        return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
      }

    case 'triangle':
      return Math.sqrt(3) * size * size / 4;

    case 'wye':
      return (21 - 10 * Math.sqrt(3)) * size * size / 8;

    default:
      return Math.PI * size * size / 4;
  }
};

var Symbols =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Symbols, _PureComponent);

  function Symbols() {
    _classCallCheck(this, Symbols);

    return _possibleConstructorReturn(this, _getPrototypeOf(Symbols).apply(this, arguments));
  }

  _createClass(Symbols, [{
    key: "getPath",

    /**
     * Calculate the path of curve
     * @return {String} path
     */
    value: function getPath() {
      var _this$props = this.props,
          size = _this$props.size,
          sizeType = _this$props.sizeType,
          type = _this$props.type;
      var symbolFactory = getSymbolFactory(type);
      var symbol = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_d3_shape__["A" /* symbol */])().type(symbolFactory).size(calculateAreaSize(size, sizeType, type));
      return symbol();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          cx = _this$props2.cx,
          cy = _this$props2.cy,
          size = _this$props2.size;

      if (cx === +cx && cy === +cy && size === +size) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["b" /* filterEventAttributes */])(this.props), {
          className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('recharts-symbols', className),
          transform: "translate(".concat(cx, ", ").concat(cy, ")"),
          d: this.getPath()
        }));
      }

      return null;
    }
  }]);

  return Symbols;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Symbols.displayName = 'Symbols';
Symbols.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['circle', 'cross', 'diamond', 'square', 'star', 'triangle', 'wye']),
  cx: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  sizeType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['area', 'diameter'])
});
Symbols.defaultProps = {
  type: 'circle',
  size: 64,
  sizeType: 'area'
};
/* harmony default export */ __webpack_exports__["a"] = (Symbols);

/***/ }),
/* 356 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 357 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 358 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 359 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 360 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(233);
var IE8_DOM_DEFINE = __webpack_require__(651);
var toPrimitive = __webpack_require__(365);
var dP = Object.defineProperty;

exports.f = __webpack_require__(141) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(28);
var defined = __webpack_require__(357);
var fails = __webpack_require__(92);
var spaces = __webpack_require__(363);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 363 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(1582);
var defined = __webpack_require__(357);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(142);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(106),
    root = __webpack_require__(56);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1710),
    mapCacheDelete = __webpack_require__(1711),
    mapCacheGet = __webpack_require__(1712),
    mapCacheHas = __webpack_require__(1713),
    mapCacheSet = __webpack_require__(1714);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(236),
    stackClear = __webpack_require__(1724),
    stackDelete = __webpack_require__(1725),
    stackGet = __webpack_require__(1726),
    stackHas = __webpack_require__(1727),
    stackSet = __webpack_require__(1728);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 369 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(674);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(668),
    createBaseEach = __webpack_require__(1681);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(369),
    isFlattenable = __webpack_require__(1702);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1644),
    isObjectLike = __webpack_require__(66);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(663);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(682);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(1632),
    stubArray = __webpack_require__(695);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 377 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(34),
    isSymbol = __webpack_require__(147);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 379 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(676);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module)))

/***/ }),
/* 381 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1643),
    isObjectLike = __webpack_require__(66);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(56),
    stubFalse = __webpack_require__(1748);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module)))

/***/ }),
/* 384 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(93),
    isObjectLike = __webpack_require__(66);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(93),
    getPrototype = __webpack_require__(375),
    isObjectLike = __webpack_require__(66);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(664),
    baseKeysIn = __webpack_require__(1652),
    isArrayLike = __webpack_require__(146);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(372),
    baseOrderBy = __webpack_require__(1655),
    baseRest = __webpack_require__(1659),
    isIterateeCall = __webpack_require__(245);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jQuery = exports.animation = undefined;

var _react = __webpack_require__(418);

var _react2 = _interopRequireDefault(_react);

var _reactAddonsUpdate = __webpack_require__(557);

var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _animationMixin = __webpack_require__(702);

var _animationMixin2 = _interopRequireDefault(_animationMixin);

var _jQueryMixin = __webpack_require__(703);

var _jQueryMixin2 = _interopRequireDefault(_jQueryMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function noop() {}

var ToastMessageSpec = {
  displayName: "ToastMessage",

  getDefaultProps: function getDefaultProps() {
    var iconClassNames = {
      error: "toast-error",
      info: "toast-info",
      success: "toast-success",
      warning: "toast-warning"
    };

    return {
      className: "toast",
      iconClassNames: iconClassNames,
      titleClassName: "toast-title",
      messageClassName: "toast-message",
      tapToDismiss: true,
      closeButton: false
    };
  },
  handleOnClick: function handleOnClick(event) {
    this.props.handleOnClick(event);
    if (this.props.tapToDismiss) {
      this.hideToast(true);
    }
  },
  _handle_close_button_click: function _handle_close_button_click(event) {
    event.stopPropagation();
    this.hideToast(true);
  },
  _handle_remove: function _handle_remove() {
    this.props.handleRemove(this.props.toastId);
  },
  _render_close_button: function _render_close_button() {
    return this.props.closeButton ? _react2.default.createElement("button", {
      className: "toast-close-button", role: "button",
      onClick: this._handle_close_button_click,
      dangerouslySetInnerHTML: { __html: "&times;" }
    }) : false;
  },
  _render_title_element: function _render_title_element() {
    return this.props.title ? _react2.default.createElement(
      "div",
      { className: this.props.titleClassName },
      this.props.title
    ) : false;
  },
  _render_message_element: function _render_message_element() {
    return this.props.message ? _react2.default.createElement(
      "div",
      { className: this.props.messageClassName },
      this.props.message
    ) : false;
  },
  render: function render() {
    var iconClassName = this.props.iconClassName || this.props.iconClassNames[this.props.type];

    return _react2.default.createElement(
      "div",
      {
        className: (0, _classnames2.default)(this.props.className, iconClassName),
        style: this.props.style,
        onClick: this.handleOnClick,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      },
      this._render_close_button(),
      this._render_title_element(),
      this._render_message_element()
    );
  }
};

var animation = exports.animation = _react2.default.createClass((0, _reactAddonsUpdate2.default)(ToastMessageSpec, {
  displayName: { $set: "ToastMessage.animation" },
  mixins: { $set: [_animationMixin2.default] }
}));

var jQuery = exports.jQuery = _react2.default.createClass((0, _reactAddonsUpdate2.default)(ToastMessageSpec, {
  displayName: { $set: "ToastMessage.jQuery" },
  mixins: { $set: [_jQueryMixin2.default] }
}));

/*
 * assign default noop functions
 */
ToastMessageSpec.handleMouseEnter = noop;
ToastMessageSpec.handleMouseLeave = noop;
ToastMessageSpec.hideToast = noop;

var ToastMessage = _react2.default.createClass(ToastMessageSpec);

ToastMessage.animation = animation;
ToastMessage.jQuery = jQuery;

exports.default = ToastMessage;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(718);


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CSSProperty
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CallbackQueue
 */



var _prodInvariant = __webpack_require__(25),
    _assign = __webpack_require__(22);

var PooledClass = __webpack_require__(78);

var invariant = __webpack_require__(17);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */
function CallbackQueue() {
  this._callbacks = null;
  this._contexts = null;
}

_assign(CallbackQueue.prototype, {

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */
  enqueue: function (callback, context) {
    this._callbacks = this._callbacks || [];
    this._contexts = this._contexts || [];
    this._callbacks.push(callback);
    this._contexts.push(context);
  },

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */
  notifyAll: function () {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    if (callbacks) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i]);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  },

  checkpoint: function () {
    return this._callbacks ? this._callbacks.length : 0;
  },

  rollback: function (len) {
    if (this._callbacks) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  },

  /**
   * Resets the internal queue.
   *
   * @internal
   */
  reset: function () {
    this._callbacks = null;
    this._contexts = null;
  },

  /**
   * `PooledClass` looks for this.
   */
  destructor: function () {
    this.reset();
  }

});

PooledClass.addPoolingTo(CallbackQueue);

module.exports = CallbackQueue;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DOMPropertyOperations
 */



var DOMProperty = __webpack_require__(109);
var ReactDOMComponentTree = __webpack_require__(39);
var ReactInstrumentation = __webpack_require__(52);

var quoteAttributeValueForBrowser = __webpack_require__(767);
var warning = __webpack_require__(21);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {

  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'update attribute', payload);
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'update attribute', payload);
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'remove attribute', name);
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'remove attribute', name);
    }
  }

};

module.exports = DOMPropertyOperations;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactChildren
 */



var PooledClass = __webpack_require__(78);
var ReactElement = __webpack_require__(58);

var emptyFunction = __webpack_require__(37);
var traverseAllChildren = __webpack_require__(271);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func;
  var context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result;
  var keyPrefix = bookKeeping.keyPrefix;
  var func = bookKeeping.func;
  var context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactClass
 */



var _prodInvariant = __webpack_require__(25),
    _assign = __webpack_require__(22);

var ReactComponent = __webpack_require__(256);
var ReactElement = __webpack_require__(58);
var ReactPropTypeLocations = __webpack_require__(262);
var ReactPropTypeLocationNames = __webpack_require__(261);
var ReactNoopUpdateQueue = __webpack_require__(260);

var emptyObject = __webpack_require__(70);
var invariant = __webpack_require__(17);
var keyMirror = __webpack_require__(200);
var keyOf = __webpack_require__(85);
var warning = __webpack_require__(21);

var MIXINS_KEY = keyOf({ mixins: null });

/**
 * Policies that describe methods in `ReactClassInterface`.
 */
var SpecPolicy = keyMirror({
  /**
   * These methods may be defined only once by the class specification or mixin.
   */
  DEFINE_ONCE: null,
  /**
   * These methods may be defined by both the class specification and mixins.
   * Subsequent definitions will be chained. These methods must return void.
   */
  DEFINE_MANY: null,
  /**
   * These methods are overriding the base class.
   */
  OVERRIDE_BASE: null,
  /**
   * These methods are similar to DEFINE_MANY, except we assume they return
   * objects. We try to merge the keys of the return values of all the mixed in
   * functions. If there is a key conflict we throw.
   */
  DEFINE_MANY_MERGED: null
});

var injectedMixins = [];

/**
 * Composite components are higher-level components that compose other composite
 * or host components.
 *
 * To create a new type of `ReactClass`, pass a specification of
 * your new class to `React.createClass`. The only requirement of your class
 * specification is that you implement a `render` method.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return <div>Hello World</div>;
 *     }
 *   });
 *
 * The class specification supports a specific protocol of methods that have
 * special meaning (e.g. `render`). See `ReactClassInterface` for
 * more the comprehensive protocol. Any other properties and methods in the
 * class specification will be available on the prototype.
 *
 * @interface ReactClassInterface
 * @internal
 */
var ReactClassInterface = {

  /**
   * An array of Mixin objects to include when defining your component.
   *
   * @type {array}
   * @optional
   */
  mixins: SpecPolicy.DEFINE_MANY,

  /**
   * An object containing properties and methods that should be defined on
   * the component's constructor instead of its prototype (static methods).
   *
   * @type {object}
   * @optional
   */
  statics: SpecPolicy.DEFINE_MANY,

  /**
   * Definition of prop types for this component.
   *
   * @type {object}
   * @optional
   */
  propTypes: SpecPolicy.DEFINE_MANY,

  /**
   * Definition of context types for this component.
   *
   * @type {object}
   * @optional
   */
  contextTypes: SpecPolicy.DEFINE_MANY,

  /**
   * Definition of context types this component sets for its children.
   *
   * @type {object}
   * @optional
   */
  childContextTypes: SpecPolicy.DEFINE_MANY,

  // ==== Definition methods ====

  /**
   * Invoked when the component is mounted. Values in the mapping will be set on
   * `this.props` if that prop is not specified (i.e. using an `in` check).
   *
   * This method is invoked before `getInitialState` and therefore cannot rely
   * on `this.state` or use `this.setState`.
   *
   * @return {object}
   * @optional
   */
  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,

  /**
   * Invoked once before the component is mounted. The return value will be used
   * as the initial value of `this.state`.
   *
   *   getInitialState: function() {
   *     return {
   *       isOn: false,
   *       fooBaz: new BazFoo()
   *     }
   *   }
   *
   * @return {object}
   * @optional
   */
  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,

  /**
   * @return {object}
   * @optional
   */
  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,

  /**
   * Uses props from `this.props` and state from `this.state` to render the
   * structure of the component.
   *
   * No guarantees are made about when or how often this method is invoked, so
   * it must not have side effects.
   *
   *   render: function() {
   *     var name = this.props.name;
   *     return <div>Hello, {name}!</div>;
   *   }
   *
   * @return {ReactComponent}
   * @nosideeffects
   * @required
   */
  render: SpecPolicy.DEFINE_ONCE,

  // ==== Delegate methods ====

  /**
   * Invoked when the component is initially created and about to be mounted.
   * This may have side effects, but any external subscriptions or data created
   * by this method must be cleaned up in `componentWillUnmount`.
   *
   * @optional
   */
  componentWillMount: SpecPolicy.DEFINE_MANY,

  /**
   * Invoked when the component has been mounted and has a DOM representation.
   * However, there is no guarantee that the DOM node is in the document.
   *
   * Use this as an opportunity to operate on the DOM when the component has
   * been mounted (initialized and rendered) for the first time.
   *
   * @param {DOMElement} rootNode DOM element representing the component.
   * @optional
   */
  componentDidMount: SpecPolicy.DEFINE_MANY,

  /**
   * Invoked before the component receives new props.
   *
   * Use this as an opportunity to react to a prop transition by updating the
   * state using `this.setState`. Current props are accessed via `this.props`.
   *
   *   componentWillReceiveProps: function(nextProps, nextContext) {
   *     this.setState({
   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
   *     });
   *   }
   *
   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
   * transition may cause a state change, but the opposite is not true. If you
   * need it, you are probably looking for `componentWillUpdate`.
   *
   * @param {object} nextProps
   * @optional
   */
  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,

  /**
   * Invoked while deciding if the component should be updated as a result of
   * receiving new props, state and/or context.
   *
   * Use this as an opportunity to `return false` when you're certain that the
   * transition to the new props/state/context will not require a component
   * update.
   *
   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
   *     return !equal(nextProps, this.props) ||
   *       !equal(nextState, this.state) ||
   *       !equal(nextContext, this.context);
   *   }
   *
   * @param {object} nextProps
   * @param {?object} nextState
   * @param {?object} nextContext
   * @return {boolean} True if the component should update.
   * @optional
   */
  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,

  /**
   * Invoked when the component is about to update due to a transition from
   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
   * and `nextContext`.
   *
   * Use this as an opportunity to perform preparation before an update occurs.
   *
   * NOTE: You **cannot** use `this.setState()` in this method.
   *
   * @param {object} nextProps
   * @param {?object} nextState
   * @param {?object} nextContext
   * @param {ReactReconcileTransaction} transaction
   * @optional
   */
  componentWillUpdate: SpecPolicy.DEFINE_MANY,

  /**
   * Invoked when the component's DOM representation has been updated.
   *
   * Use this as an opportunity to operate on the DOM when the component has
   * been updated.
   *
   * @param {object} prevProps
   * @param {?object} prevState
   * @param {?object} prevContext
   * @param {DOMElement} rootNode DOM element representing the component.
   * @optional
   */
  componentDidUpdate: SpecPolicy.DEFINE_MANY,

  /**
   * Invoked when the component is about to be removed from its parent and have
   * its DOM representation destroyed.
   *
   * Use this as an opportunity to deallocate any external resources.
   *
   * NOTE: There is no `componentDidUnmount` since your component will have been
   * destroyed by that point.
   *
   * @optional
   */
  componentWillUnmount: SpecPolicy.DEFINE_MANY,

  // ==== Advanced methods ====

  /**
   * Updates the component's currently mounted DOM representation.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   * @overridable
   */
  updateComponent: SpecPolicy.OVERRIDE_BASE

};

/**
 * Mapping from class specification keys to special processing functions.
 *
 * Although these are declared like instance properties in the specification
 * when defining classes using `React.createClass`, they are actually static
 * and are accessible on the constructor instead of the prototype. Despite
 * being static, they must be defined outside of the "statics" key under
 * which all other static methods are defined.
 */
var RESERVED_SPEC_KEYS = {
  displayName: function (Constructor, displayName) {
    Constructor.displayName = displayName;
  },
  mixins: function (Constructor, mixins) {
    if (mixins) {
      for (var i = 0; i < mixins.length; i++) {
        mixSpecIntoComponent(Constructor, mixins[i]);
      }
    }
  },
  childContextTypes: function (Constructor, childContextTypes) {
    if (false) {
      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
    }
    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
  },
  contextTypes: function (Constructor, contextTypes) {
    if (false) {
      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
    }
    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
  },
  /**
   * Special case getDefaultProps which should move into statics but requires
   * automatic merging.
   */
  getDefaultProps: function (Constructor, getDefaultProps) {
    if (Constructor.getDefaultProps) {
      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
    } else {
      Constructor.getDefaultProps = getDefaultProps;
    }
  },
  propTypes: function (Constructor, propTypes) {
    if (false) {
      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
    }
    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
  },
  statics: function (Constructor, statics) {
    mixStaticSpecIntoComponent(Constructor, statics);
  },
  autobind: function () {} };

// noop
function validateTypeDef(Constructor, typeDef, location) {
  for (var propName in typeDef) {
    if (typeDef.hasOwnProperty(propName)) {
      // use a warning instead of an invariant so components
      // don't show up in prod but only in __DEV__
       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
    }
  }
}

function validateMethodOverride(isAlreadyDefined, name) {
  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;

  // Disallow overriding of base class methods unless explicitly allowed.
  if (ReactClassMixin.hasOwnProperty(name)) {
    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
  }

  // Disallow defining methods more than once unless explicitly allowed.
  if (isAlreadyDefined) {
    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
  }
}

/**
 * Mixin helper which handles policy validation and reserved
 * specification keys when building React classes.
 */
function mixSpecIntoComponent(Constructor, spec) {
  if (!spec) {
    if (false) {
      var typeofSpec = typeof spec;
      var isMixinValid = typeofSpec === 'object' && spec !== null;

      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
    }

    return;
  }

  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;

  var proto = Constructor.prototype;
  var autoBindPairs = proto.__reactAutoBindPairs;

  // By handling mixins before any other properties, we ensure the same
  // chaining order is applied to methods with DEFINE_MANY policy, whether
  // mixins are listed before or after these methods in the spec.
  if (spec.hasOwnProperty(MIXINS_KEY)) {
    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
  }

  for (var name in spec) {
    if (!spec.hasOwnProperty(name)) {
      continue;
    }

    if (name === MIXINS_KEY) {
      // We have already handled mixins in a special case above.
      continue;
    }

    var property = spec[name];
    var isAlreadyDefined = proto.hasOwnProperty(name);
    validateMethodOverride(isAlreadyDefined, name);

    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
      RESERVED_SPEC_KEYS[name](Constructor, property);
    } else {
      // Setup methods on prototype:
      // The following member methods should not be automatically bound:
      // 1. Expected ReactClass methods (in the "interface").
      // 2. Overridden methods (that were mixed in).
      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
      var isFunction = typeof property === 'function';
      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;

      if (shouldAutoBind) {
        autoBindPairs.push(name, property);
        proto[name] = property;
      } else {
        if (isAlreadyDefined) {
          var specPolicy = ReactClassInterface[name];

          // These cases should already be caught by validateMethodOverride.
          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;

          // For methods which are defined more than once, call the existing
          // methods before calling the new property, merging if appropriate.
          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
            proto[name] = createMergedResultFunction(proto[name], property);
          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
            proto[name] = createChainedFunction(proto[name], property);
          }
        } else {
          proto[name] = property;
          if (false) {
            // Add verbose displayName to the function, which helps when looking
            // at profiling tools.
            if (typeof property === 'function' && spec.displayName) {
              proto[name].displayName = spec.displayName + '_' + name;
            }
          }
        }
      }
    }
  }
}

function mixStaticSpecIntoComponent(Constructor, statics) {
  if (!statics) {
    return;
  }
  for (var name in statics) {
    var property = statics[name];
    if (!statics.hasOwnProperty(name)) {
      continue;
    }

    var isReserved = name in RESERVED_SPEC_KEYS;
    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;

    var isInherited = name in Constructor;
    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
    Constructor[name] = property;
  }
}

/**
 * Merge two objects, but throw if both contain the same key.
 *
 * @param {object} one The first object, which is mutated.
 * @param {object} two The second object
 * @return {object} one after it has been mutated to contain everything in two.
 */
function mergeIntoWithNoDuplicateKeys(one, two) {
  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;

  for (var key in two) {
    if (two.hasOwnProperty(key)) {
      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
      one[key] = two[key];
    }
  }
  return one;
}

/**
 * Creates a function that invokes two functions and merges their return values.
 *
 * @param {function} one Function to invoke first.
 * @param {function} two Function to invoke second.
 * @return {function} Function that invokes the two argument functions.
 * @private
 */
function createMergedResultFunction(one, two) {
  return function mergedResult() {
    var a = one.apply(this, arguments);
    var b = two.apply(this, arguments);
    if (a == null) {
      return b;
    } else if (b == null) {
      return a;
    }
    var c = {};
    mergeIntoWithNoDuplicateKeys(c, a);
    mergeIntoWithNoDuplicateKeys(c, b);
    return c;
  };
}

/**
 * Creates a function that invokes two functions and ignores their return vales.
 *
 * @param {function} one Function to invoke first.
 * @param {function} two Function to invoke second.
 * @return {function} Function that invokes the two argument functions.
 * @private
 */
function createChainedFunction(one, two) {
  return function chainedFunction() {
    one.apply(this, arguments);
    two.apply(this, arguments);
  };
}

/**
 * Binds a method to the component.
 *
 * @param {object} component Component whose method is going to be bound.
 * @param {function} method Method to be bound.
 * @return {function} The bound method.
 */
function bindAutoBindMethod(component, method) {
  var boundMethod = method.bind(component);
  if (false) {
    boundMethod.__reactBoundContext = component;
    boundMethod.__reactBoundMethod = method;
    boundMethod.__reactBoundArguments = null;
    var componentName = component.constructor.displayName;
    var _bind = boundMethod.bind;
    boundMethod.bind = function (newThis) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      // User is trying to bind() an autobound method; we effectively will
      // ignore the value of "this" that the user is trying to use, so
      // let's warn.
      if (newThis !== component && newThis !== null) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
      } else if (!args.length) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
        return boundMethod;
      }
      var reboundMethod = _bind.apply(boundMethod, arguments);
      reboundMethod.__reactBoundContext = component;
      reboundMethod.__reactBoundMethod = method;
      reboundMethod.__reactBoundArguments = args;
      return reboundMethod;
    };
  }
  return boundMethod;
}

/**
 * Binds all auto-bound methods in a component.
 *
 * @param {object} component Component whose method is going to be bound.
 */
function bindAutoBindMethods(component) {
  var pairs = component.__reactAutoBindPairs;
  for (var i = 0; i < pairs.length; i += 2) {
    var autoBindKey = pairs[i];
    var method = pairs[i + 1];
    component[autoBindKey] = bindAutoBindMethod(component, method);
  }
}

/**
 * Add more to the ReactClass base class. These are all legacy features and
 * therefore not already part of the modern ReactComponent.
 */
var ReactClassMixin = {

  /**
   * TODO: This will be deprecated because state should always keep a consistent
   * type signature and the only use case for this, is to avoid that.
   */
  replaceState: function (newState, callback) {
    this.updater.enqueueReplaceState(this, newState);
    if (callback) {
      this.updater.enqueueCallback(this, callback, 'replaceState');
    }
  },

  /**
   * Checks whether or not this composite component is mounted.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function () {
    return this.updater.isMounted(this);
  }
};

var ReactClassComponent = function () {};
_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);

/**
 * Module for creating composite components.
 *
 * @class ReactClass
 */
var ReactClass = {

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  createClass: function (spec) {
    var Constructor = function (props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (initialState === undefined && this.getInitialState._isMockFunction) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;

      this.state = initialState;
    };
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, spec);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  },

  injection: {
    injectMixin: function (mixin) {
      injectedMixins.push(mixin);
    }
  }

};

module.exports = ReactClass;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMComponentFlags
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMSelect
 */



var _assign = __webpack_require__(22);

var DisabledInputUtils = __webpack_require__(181);
var LinkedValueUtils = __webpack_require__(255);
var ReactDOMComponentTree = __webpack_require__(39);
var ReactUpdates = __webpack_require__(59);

var warning = __webpack_require__(21);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, DisabledInputUtils.getHostProps(inst, props), {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactEmptyComponent
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactFeatureFlags
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactHostComponent
 */



var _prodInvariant = __webpack_require__(25),
    _assign = __webpack_require__(22);

var invariant = __webpack_require__(17);

var genericComponentClass = null;
// This registry keeps track of wrapper classes around host tags.
var tagToComponentClass = {};
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  },
  // This accepts a keyed object with classes as values. Each key represents a
  // tag. That particular tag will use this class instead of the generic one.
  injectComponentClasses: function (componentClasses) {
    _assign(tagToComponentClass, componentClasses);
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactInputSelection
 */



var ReactDOMSelection = __webpack_require__(728);

var containsNode = __webpack_require__(515);
var focusNode = __webpack_require__(198);
var getActiveElement = __webpack_require__(199);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {

  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactMount
 */



var _prodInvariant = __webpack_require__(25);

var DOMLazyTree = __webpack_require__(108);
var DOMProperty = __webpack_require__(109);
var ReactBrowserEventEmitter = __webpack_require__(182);
var ReactCurrentOwner = __webpack_require__(79);
var ReactDOMComponentTree = __webpack_require__(39);
var ReactDOMContainerInfo = __webpack_require__(721);
var ReactDOMFeatureFlags = __webpack_require__(724);
var ReactElement = __webpack_require__(58);
var ReactFeatureFlags = __webpack_require__(399);
var ReactInstanceMap = __webpack_require__(151);
var ReactInstrumentation = __webpack_require__(52);
var ReactMarkupChecksum = __webpack_require__(737);
var ReactReconciler = __webpack_require__(110);
var ReactUpdateQueue = __webpack_require__(264);
var ReactUpdates = __webpack_require__(59);

var emptyObject = __webpack_require__(70);
var instantiateReactComponent = __webpack_require__(415);
var invariant = __webpack_require__(17);
var setInnerHTML = __webpack_require__(185);
var shouldUpdateReactComponent = __webpack_require__(270);
var warning = __webpack_require__(21);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  // this.props is actually a ReactElement
  return this.props;
};

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {

  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !ReactElement.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
    // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation(hostNode._debugID, 'mount', markup.toString());
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactMultiChildUpdateTypes
 */



var keyMirror = __webpack_require__(200);

/**
 * When a component's children are updated, a series of update configuration
 * objects are created in order to batch and serialize the required changes.
 *
 * Enumerates all the possible types of update configurations.
 *
 * @internal
 */
var ReactMultiChildUpdateTypes = keyMirror({
  INSERT_MARKUP: null,
  MOVE_EXISTING: null,
  REMOVE_NODE: null,
  SET_MARKUP: null,
  TEXT_CONTENT: null
});

module.exports = ReactMultiChildUpdateTypes;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactNodeTypes
 * 
 */



var _prodInvariant = __webpack_require__(25);

var ReactElement = __webpack_require__(58);

var invariant = __webpack_require__(17);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (ReactElement.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactPropTypes
 */



var ReactElement = __webpack_require__(58);
var ReactPropTypeLocationNames = __webpack_require__(261);
var ReactPropTypesSecret = __webpack_require__(263);

var emptyFunction = __webpack_require__(37);
var getIteratorFn = __webpack_require__(412);
var warning = __webpack_require__(21);

/**
 * Collection of methods that allow declaration and validation of props that are
 * supplied to React components. Example usage:
 *
 *   var Props = require('ReactPropTypes');
 *   var MyArticle = React.createClass({
 *     propTypes: {
 *       // An optional string prop named "description".
 *       description: Props.string,
 *
 *       // A required enum prop named "category".
 *       category: Props.oneOf(['News','Photos']).isRequired,
 *
 *       // A prop named "dialog" that requires an instance of Dialog.
 *       dialog: Props.instanceOf(Dialog).isRequired
 *     },
 *     render: function() { ... }
 *   });
 *
 * A more formal specification of how these methods are used:
 *
 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
 *   decl := ReactPropTypes.{type}(.isRequired)?
 *
 * Each and every declaration produces a function with the same signature. This
 * allows the creation of custom validation functions. For example:
 *
 *  var MyLink = React.createClass({
 *    propTypes: {
 *      // An optional string or URI prop named "href".
 *      href: function(props, propName, componentName) {
 *        var propValue = props[propName];
 *        if (propValue != null && typeof propValue !== 'string' &&
 *            !(propValue instanceof URI)) {
 *          return new Error(
 *            'Expected a string or an URI for ' + propName + ' in ' +
 *            componentName
 *          );
 *        }
 *      }
 *    },
 *    render: function() {...}
 *  });
 *
 * @internal
 */

var ANONYMOUS = '<<anonymous>>';

var ReactPropTypes = {
  array: createPrimitiveTypeChecker('array'),
  bool: createPrimitiveTypeChecker('boolean'),
  func: createPrimitiveTypeChecker('function'),
  number: createPrimitiveTypeChecker('number'),
  object: createPrimitiveTypeChecker('object'),
  string: createPrimitiveTypeChecker('string'),
  symbol: createPrimitiveTypeChecker('symbol'),

  any: createAnyTypeChecker(),
  arrayOf: createArrayOfTypeChecker,
  element: createElementTypeChecker(),
  instanceOf: createInstanceTypeChecker,
  node: createNodeChecker(),
  objectOf: createObjectOfTypeChecker,
  oneOf: createEnumTypeChecker,
  oneOfType: createUnionTypeChecker,
  shape: createShapeTypeChecker
};

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
/*eslint-disable no-self-compare*/
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return x !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}
/*eslint-enable no-self-compare*/

/**
 * We use an Error-like object for backward compatibility as people may call
 * PropTypes directly and inspect their output. However we don't use real
 * Errors anymore. We don't inspect their stack anyway, and creating them
 * is prohibitively expensive if they are created too often, such as what
 * happens in oneOfType() for any type before the one that matched.
 */
function PropTypeError(message) {
  this.message = message;
  this.stack = '';
}
// Make `instanceof Error` still work for returned errors.
PropTypeError.prototype = Error.prototype;

function createChainableTypeChecker(validate) {
  if (false) {
    var manualPropTypeCallCache = {};
  }
  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
    componentName = componentName || ANONYMOUS;
    propFullName = propFullName || propName;
    if (false) {
      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
        var cacheKey = componentName + ':' + propName;
        if (!manualPropTypeCallCache[cacheKey]) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in the next major version. You may be ' + 'seeing this warning due to a third-party PropTypes library. ' + 'See https://fb.me/react-warning-dont-call-proptypes for details.', propFullName, componentName) : void 0;
          manualPropTypeCallCache[cacheKey] = true;
        }
      }
    }
    if (props[propName] == null) {
      var locationName = ReactPropTypeLocationNames[location];
      if (isRequired) {
        return new PropTypeError('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
      }
      return null;
    } else {
      return validate(props, propName, componentName, location, propFullName);
    }
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

function createPrimitiveTypeChecker(expectedType) {
  function validate(props, propName, componentName, location, propFullName, secret) {
    var propValue = props[propName];
    var propType = getPropType(propValue);
    if (propType !== expectedType) {
      var locationName = ReactPropTypeLocationNames[location];
      // `propValue` being instance of, say, date/regexp, pass the 'object'
      // check, but we can offer a more precise error message here rather than
      // 'of type `object`'.
      var preciseType = getPreciseType(propValue);

      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createAnyTypeChecker() {
  return createChainableTypeChecker(emptyFunction.thatReturns(null));
}

function createArrayOfTypeChecker(typeChecker) {
  function validate(props, propName, componentName, location, propFullName) {
    if (typeof typeChecker !== 'function') {
      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
    }
    var propValue = props[propName];
    if (!Array.isArray(propValue)) {
      var locationName = ReactPropTypeLocationNames[location];
      var propType = getPropType(propValue);
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
    }
    for (var i = 0; i < propValue.length; i++) {
      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
      if (error instanceof Error) {
        return error;
      }
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createElementTypeChecker() {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    if (!ReactElement.isValidElement(propValue)) {
      var locationName = ReactPropTypeLocationNames[location];
      var propType = getPropType(propValue);
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createInstanceTypeChecker(expectedClass) {
  function validate(props, propName, componentName, location, propFullName) {
    if (!(props[propName] instanceof expectedClass)) {
      var locationName = ReactPropTypeLocationNames[location];
      var expectedClassName = expectedClass.name || ANONYMOUS;
      var actualClassName = getClassName(props[propName]);
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createEnumTypeChecker(expectedValues) {
  if (!Array.isArray(expectedValues)) {
     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
    return emptyFunction.thatReturnsNull;
  }

  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    for (var i = 0; i < expectedValues.length; i++) {
      if (is(propValue, expectedValues[i])) {
        return null;
      }
    }

    var locationName = ReactPropTypeLocationNames[location];
    var valuesString = JSON.stringify(expectedValues);
    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
  }
  return createChainableTypeChecker(validate);
}

function createObjectOfTypeChecker(typeChecker) {
  function validate(props, propName, componentName, location, propFullName) {
    if (typeof typeChecker !== 'function') {
      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
    }
    var propValue = props[propName];
    var propType = getPropType(propValue);
    if (propType !== 'object') {
      var locationName = ReactPropTypeLocationNames[location];
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
    }
    for (var key in propValue) {
      if (propValue.hasOwnProperty(key)) {
        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createUnionTypeChecker(arrayOfTypeCheckers) {
  if (!Array.isArray(arrayOfTypeCheckers)) {
     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
    return emptyFunction.thatReturnsNull;
  }

  function validate(props, propName, componentName, location, propFullName) {
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
        return null;
      }
    }

    var locationName = ReactPropTypeLocationNames[location];
    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
  }
  return createChainableTypeChecker(validate);
}

function createNodeChecker() {
  function validate(props, propName, componentName, location, propFullName) {
    if (!isNode(props[propName])) {
      var locationName = ReactPropTypeLocationNames[location];
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createShapeTypeChecker(shapeTypes) {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    var propType = getPropType(propValue);
    if (propType !== 'object') {
      var locationName = ReactPropTypeLocationNames[location];
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
    }
    for (var key in shapeTypes) {
      var checker = shapeTypes[key];
      if (!checker) {
        continue;
      }
      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
      if (error) {
        return error;
      }
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function isNode(propValue) {
  switch (typeof propValue) {
    case 'number':
    case 'string':
    case 'undefined':
      return true;
    case 'boolean':
      return !propValue;
    case 'object':
      if (Array.isArray(propValue)) {
        return propValue.every(isNode);
      }
      if (propValue === null || ReactElement.isValidElement(propValue)) {
        return true;
      }

      var iteratorFn = getIteratorFn(propValue);
      if (iteratorFn) {
        var iterator = iteratorFn.call(propValue);
        var step;
        if (iteratorFn !== propValue.entries) {
          while (!(step = iterator.next()).done) {
            if (!isNode(step.value)) {
              return false;
            }
          }
        } else {
          // Iterator will provide entry [k,v] tuples rather than values.
          while (!(step = iterator.next()).done) {
            var entry = step.value;
            if (entry) {
              if (!isNode(entry[1])) {
                return false;
              }
            }
          }
        }
      } else {
        return false;
      }

      return true;
    default:
      return false;
  }
}

function isSymbol(propType, propValue) {
  // Native Symbol.
  if (propType === 'symbol') {
    return true;
  }

  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
  if (propValue['@@toStringTag'] === 'Symbol') {
    return true;
  }

  // Fallback for non-spec compliant Symbols which are polyfilled.
  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
    return true;
  }

  return false;
}

// Equivalent of `typeof` but with special handling for array and regexp.
function getPropType(propValue) {
  var propType = typeof propValue;
  if (Array.isArray(propValue)) {
    return 'array';
  }
  if (propValue instanceof RegExp) {
    // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return 'object';
  }
  if (isSymbol(propType, propValue)) {
    return 'symbol';
  }
  return propType;
}

// This handles more types than `getPropType`. Only used for error messages.
// See `createPrimitiveTypeChecker`.
function getPreciseType(propValue) {
  var propType = getPropType(propValue);
  if (propType === 'object') {
    if (propValue instanceof Date) {
      return 'date';
    } else if (propValue instanceof RegExp) {
      return 'regexp';
    }
  }
  return propType;
}

// Returns class name of the object, if any.
function getClassName(propValue) {
  if (!propValue.constructor || !propValue.constructor.name) {
    return ANONYMOUS;
  }
  return propValue.constructor.name;
}

module.exports = ReactPropTypes;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactVersion
 */



module.exports = '15.3.2';

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ViewportMetrics
 */



var ViewportMetrics = {

  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }

};

module.exports = ViewportMetrics;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule accumulateInto
 * 
 */



var _prodInvariant = __webpack_require__(25);

var invariant = __webpack_require__(17);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule canDefineProperty
 */



var canDefineProperty = false;
if (false) {
  try {
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule forEachAccumulated
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getHostComponentFromComposite
 */



var ReactNodeTypes = __webpack_require__(404);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getIteratorFn
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getTextContentAccessor
 */



var ExecutionEnvironment = __webpack_require__(31);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getVendorPrefixedEventName
 */



var ExecutionEnvironment = __webpack_require__(31);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule instantiateReactComponent
 */



var _prodInvariant = __webpack_require__(25),
    _assign = __webpack_require__(22);

var ReactCompositeComponent = __webpack_require__(717);
var ReactEmptyComponent = __webpack_require__(398);
var ReactHostComponent = __webpack_require__(400);

var invariant = __webpack_require__(17);
var warning = __webpack_require__(21);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};
_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
  _instantiateReactComponent: instantiateReactComponent
});

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

var nextDebugID = 1;

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : _prodInvariant('130', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : void 0;

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? nextDebugID++ : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

module.exports = instantiateReactComponent;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule isTextInputElement
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  'color': true,
  'date': true,
  'datetime': true,
  'datetime-local': true,
  'email': true,
  'month': true,
  'number': true,
  'password': true,
  'range': true,
  'search': true,
  'tel': true,
  'text': true,
  'time': true,
  'url': true,
  'week': true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule setTextContent
 */



var ExecutionEnvironment = __webpack_require__(31);
var escapeTextContentForBrowser = __webpack_require__(184);
var setInnerHTML = __webpack_require__(185);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(714);


/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(16);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário






// Importo o moment com a linguagem pt-br
__webpack_require__(24);
__webpack_require__(32);

var AircraftLogbookALFInspectionTab = function (_Component) {
  _inherits(AircraftLogbookALFInspectionTab, _Component);

  function AircraftLogbookALFInspectionTab(props) {
    _classCallCheck(this, AircraftLogbookALFInspectionTab);

    var _this = _possibleConstructorReturn(this, (AircraftLogbookALFInspectionTab.__proto__ || Object.getPrototypeOf(AircraftLogbookALFInspectionTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      aircraft_logbook_id: _this.props.aircraft_logbook_id,
      id: '',
      approvals: [],
      approval: [],
      alf_tool_fod_ok: '',
      alf_tool_fod_na: '',
      modal_justification: false,
      alf_fdm_required: false,
      alf_fdm_yes: false,
      alf_fdm_no: false,
      alf_fdm_justification: '',
      modal_fdm_justification: false,
      pending_fdm_choice: null,
      alf_fdm_input: ''
    };
    _this.edit = _this.edit.bind(_this);
    _this.reopen = _this.reopen.bind(_this);
    _this.handleFdmYesChange = _this.handleFdmYesChange.bind(_this);
    _this.handleFdmNoChange = _this.handleFdmNoChange.bind(_this);
    _this.closeFdmModal = _this.closeFdmModal.bind(_this);
    _this.confirmFdmNo = _this.confirmFdmNo.bind(_this);
    _this.updateFdmJustification = _this.updateFdmJustification.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(AircraftLogbookALFInspectionTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleCheckboxChange',
    value: function handleCheckboxChange(name, event) {
      if (event.target.checked === false) {
        this.setState({
          alf_tool_fod_ok: false,
          alf_tool_fod_na: false
        });
        var datasave = {
          aircraft_logbook_id: this.state.aircraft_logbook_id,
          inspection_type: 'alf',
          id: this.state.inspections.id,
          alf_tool_fod_na: false,
          alf_tool_fod_ok: false
        };
      } else {
        this.setState({
          alf_tool_fod_ok: true,
          alf_tool_fod_na: false
        });
        var datasave = {
          aircraft_logbook_id: this.state.aircraft_logbook_id,
          inspection_type: 'alf',
          id: this.state.inspections.id,
          alf_tool_fod_na: false,
          alf_tool_fod_ok: true
        };
      }
      this.edit(datasave);
    }
  }, {
    key: 'handleFdmYesChange',
    value: function handleFdmYesChange(event) {
      if (event.target.checked === false) {
        this.setState({ alf_fdm_yes: true });
        return;
      }

      this.setState({
        alf_fdm_yes: true,
        alf_fdm_no: false,
        alf_fdm_justification: ''
      });

      var datasave = {
        aircraft_logbook_id: this.state.aircraft_logbook_id,
        inspection_type: 'alf',
        id: this.state.inspections.id,
        alf_fdm: 'yes',
        alf_fdm_justification: null
      };
      this.edit(datasave);
    }
  }, {
    key: 'handleFdmNoChange',
    value: function handleFdmNoChange(event) {
      if (event.target.checked === false) {
        return;
      }

      this.setState({
        modal_fdm_justification: true,
        pending_fdm_choice: 'no',
        alf_fdm_input: this.state.alf_fdm_justification || ''
      });
    }
  }, {
    key: 'updateFdmJustification',
    value: function updateFdmJustification(event) {
      this.setState({ alf_fdm_input: event.target.value });
    }
  }, {
    key: 'closeFdmModal',
    value: function closeFdmModal() {
      this.setState({
        modal_fdm_justification: false,
        pending_fdm_choice: null,
        alf_fdm_input: ''
      });
    }
  }, {
    key: 'confirmFdmNo',
    value: function confirmFdmNo() {
      if (!this.state.alf_fdm_input || this.state.alf_fdm_input.trim() === '') {
        this.props.handleAlert('Justification is required to mark FDM as No.', 'error', 'open');
        return;
      }

      var justification = this.state.alf_fdm_input.trim();

      this.setState({
        alf_fdm_yes: false,
        alf_fdm_no: true,
        alf_fdm_justification: justification,
        modal_fdm_justification: false,
        pending_fdm_choice: null,
        alf_fdm_input: ''
      });

      var datasave = {
        aircraft_logbook_id: this.state.aircraft_logbook_id,
        inspection_type: 'alf',
        id: this.state.inspections.id,
        alf_fdm: 'no',
        alf_fdm_justification: justification
      };
      this.edit(datasave);
    }
  }, {
    key: 'handleCheckboxNaChange',
    value: function handleCheckboxNaChange(name, event) {
      if (event.target.checked === false) {
        this.setState({
          alf_tool_fod_ok: false,
          alf_tool_fod_na: false
        });
        var datasave = {
          aircraft_logbook_id: this.state.aircraft_logbook_id,
          inspection_type: 'alf',
          id: this.state.inspections.id,
          alf_tool_fod_na: false,
          alf_tool_fod_ok: false
        };
      } else {
        this.setState({
          alf_tool_fod_ok: false,
          alf_tool_fod_na: true
        });
        var datasave = {
          aircraft_logbook_id: this.state.aircraft_logbook_id,
          inspection_type: 'alf',
          id: this.state.inspections.id,
          alf_tool_fod_na: true,
          alf_tool_fod_ok: false
        };
      }
      this.edit(datasave);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          loaded: 1
        });
      }

      if (typeof newProps.inspections !== 'undefined' && newProps.inspections !== null) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          inspections: newProps.inspections,
          id: newProps.inspections.id,
          alf_tool_fod_ok: newProps.inspections.alf_tool_fod_ok,
          alf_tool_fod_na: newProps.inspections.alf_tool_fod_na,
          alf_fdm_required: newProps.inspections.alf_fdm_required || false,
          alf_fdm_yes: newProps.inspections.alf_fdm_yes || false,
          alf_fdm_no: newProps.inspections.alf_fdm_no || false,
          alf_fdm_justification: newProps.inspections.alf_fdm_justification_text || ''
        });
      }

      if (typeof newProps.approvals[7] !== 'undefined' && newProps.approvals[7] !== null) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          approvals: newProps.approvals[7],
          approval: newProps.approvals[7][0]
        });
      }
    }

    // Fetch salvando a edição

  }, {
    key: 'edit',
    value: function edit(datasave) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/inspecao', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'reopen',
    value: function reopen(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      var datasave = {
        id: this.state.id,
        aircraft_logbook_id: this.state.aircraft_logbook_id,
        justification: this.state.justification,
        inspection_type: 'alf',
        approval_type: this.state.approval.type
      };
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/inspecao/reabrir', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.setState({ modal_justification: false, justification: null });
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-1 text-center' },
            self.state.approval.status === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { onClick: function onClick() {
                  return self.setState({ modal_justification: true });
                }, className: 'btn btn-primary' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-refresh' })
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { onClick: function onClick() {
                  self.props.approve(self.state.approval.id, self.state.approval.type);
                }, className: 'btn btn-success' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-4' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              'After Last Flight (ALF) Inspection'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-3' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.edit },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                self.state.alf_fdm_required && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      'FDM'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                        name: 'alf_fdm_yes',
                        type: 'checkbox',
                        checked: this.state.alf_fdm_yes,
                        onChange: this.handleFdmYesChange
                      }),
                      '\xA0Yes'
                    ),
                    '\xA0',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                        name: 'alf_fdm_no',
                        type: 'checkbox',
                        checked: this.state.alf_fdm_no,
                        onChange: this.handleFdmNoChange
                      }),
                      '\xA0No'
                    )
                  ),
                  self.state.alf_fdm_required && this.state.alf_fdm_justification && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'small',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'strong',
                        null,
                        'Justification:'
                      ),
                      ' ',
                      this.state.alf_fdm_justification
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      'Tool/FOD'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                        name: 'alf_tool_fod_ok',
                        type: 'checkbox',
                        checked: this.state.alf_tool_fod_ok,
                        onChange: this.handleCheckboxChange.bind(this, 'alf_tool_fod_ok')
                      }),
                      '\xA0OK'
                    ),
                    '\xA0',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                        name: 'alf_tool_fod_na',
                        type: 'checkbox',
                        checked: this.state.alf_tool_fod_na,
                        onChange: this.handleCheckboxNaChange.bind(this, 'alf_tool_fod_na')
                      }),
                      '\xA0N/A'
                    )
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-4' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'table-responsive' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'table table-bordered table-hover table-striped' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'caption',
                  null,
                  'Approval'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    { className: 'text-center' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      'User'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      'Status'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      'Approval Date'
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  { id: 'alf_inspection_approvals' },
                  self.state.approvals.map(function (k) {
                    var approval = k;
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      { className: 'text-center', key: approval.id },
                      typeof approval.user_id !== 'undefined' && approval.user_id !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        approval.user_name
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        approval.status_str
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        approval.approval_date_str
                      )
                    );
                  })
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal_fdm_justification, 'aria-labelledby': 'fdm-justification-modal', bsSize: 'large', onHide: this.closeFdmModal },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Header,
            { closeButton: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                'Please justify why FDM was not performed'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Justification'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', {
                className: 'form-control',
                rows: 4,
                value: this.state.alf_fdm_input,
                onChange: this.updateFdmJustification
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-default', onClick: this.closeFdmModal },
              'Cancel'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-success', onClick: this.confirmFdmNo },
              'Confirm'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal_justification, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                'Please tell us why you need to reopen this inspection'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ modal_justification: false, justification: null });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'alert alert-danger' },
              'Attention: This reopening should only be used in case of filling errors. For a new inspection after changing the aircraft\'s conditions, please open a new logbook.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.reopen },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      'Justification:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', { style: { height: 200 }, type: 'text', name: 'justification', required: true, className: 'form-control', value: this.state.justification, onChange: this.handleChange.bind(this, 'justification') })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-certificate' }),
                      ' Submit justification'
                    )
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ modal_justification: false, justification: null });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return AircraftLogbookALFInspectionTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookALFInspectionTab);

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LogbookAppIntegration_LogbookSignatureModal__ = __webpack_require__(80);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário








// Importo o moment com a linguagem pt-br
__webpack_require__(24);
__webpack_require__(32);

var AircraftLogbookAirworthinessReleaseTab = function (_Component) {
  _inherits(AircraftLogbookAirworthinessReleaseTab, _Component);

  function AircraftLogbookAirworthinessReleaseTab(props) {
    _classCallCheck(this, AircraftLogbookAirworthinessReleaseTab);

    var _this = _possibleConstructorReturn(this, (AircraftLogbookAirworthinessReleaseTab.__proto__ || Object.getPrototypeOf(AircraftLogbookAirworthinessReleaseTab)).call(this, props));

    _this.handleChangeDecimal = function (name, event) {
      var _this$setState;

      var rawInputValue = _this.state.rawInputValue;
      console.log('first rawInputValue:');
      console.log(rawInputValue);

      var inputValue = event.target.value;

      // Se o input estiver vazio, limpa rawInputValue
      if (inputValue === '') {
        rawInputValue = '';
      } else if (/^\d+$/.test(inputValue)) {
        // Se for um número inteiro, atualiza rawInputValue
        rawInputValue = inputValue;
      } else {
        var newChar = inputValue.slice(-1);

        // Verifica se o novo caractere é um número, um ponto decimal ou uma vírgula
        if (!/^[0-9.,]$/.test(newChar)) {
          // Caractere inválido, não faz nada
          return;
        }

        // Substitui vírgula por ponto
        if (newChar === ',') {
          newChar = '.';
        }

        // Verifica se já existe um ponto decimal
        var hasDecimal = rawInputValue.includes('.');

        // Impede que "0" seja o primeiro dígito
        if (rawInputValue === '' && newChar === '0') {
          return;
        }

        // Determina se está adicionando ou removendo um caractere
        if (event.nativeEvent.inputType === 'deleteContentBackward') {
          // Removendo um caractere
          rawInputValue = rawInputValue.slice(0, -1);
        } else if (hasDecimal && newChar !== '.') {
          // Substitui o dígito após o ponto decimal
          var parts = rawInputValue.split('.');
          parts[1] = newChar;
          rawInputValue = parts.join('.');
        } else {
          // Adicionando um caractere
          rawInputValue += newChar;
        }
      }

      // Formata o valor para exibição com base em rawInputValue
      var formattedValue = _this.formatInputValue(rawInputValue);

      // Atualiza o estado
      _this.setState((_this$setState = {}, _defineProperty(_this$setState, name, formattedValue), _defineProperty(_this$setState, 'rawInputValue', rawInputValue), _this$setState));
    };

    _this.formatInputValue = function (rawValue) {
      if (!rawValue) {
        return '';
      }

      var _rawValue$split = rawValue.split('.'),
          _rawValue$split2 = _slicedToArray(_rawValue$split, 2),
          inteiro = _rawValue$split2[0],
          decimal = _rawValue$split2[1];

      // Ajusta a parte decimal para sempre ter um dígito


      decimal = decimal && decimal.length > 0 ? decimal[0] : '0';

      return inteiro + '.' + decimal;
    };

    _this.handleAirworthinessStatusChange = function (event) {
      var value = event && event.value ? event.value : null;
      if (!value) {
        _this.setState({ airworthiness_status: 'non_airworthy' });
        return;
      }
      if (value === 'airworthy') {
        _this.setState({ airworthiness_status: 'airworthy', released_for: 'any_flight' });
      } else {
        var released_for = _this.state.released_for;
        if (released_for === 'any_flight') {
          var list = _this.state.flight_type_list || [];
          var hasPower = list.find(function (o) {
            return o.value === 'power_check';
          });
          var hasMaint = list.find(function (o) {
            return o.value === 'maintenance_flight';
          });
          released_for = hasPower ? 'power_check' : hasMaint ? 'maintenance_flight' : null;
        }
        _this.setState({ airworthiness_status: 'non_airworthy', released_for: released_for });
      }
    };

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      logbook_app: _this.props.logbook_app,
      aircraft_logbook_id: _this.props.aircraft_logbook_id,
      approvals: [],
      approval: [],
      airworthiness_releases: '',
      justification: null,
      id: '',
      last_maintenance_intervention_type_id: '',
      next_maintenance_intervention_type_id: '',
      last_maintenance_intervention_option: '',
      next_maintenance_intervention_option: '',
      flight_hours_next_maintenance_intervention: '',
      rts: false,
      pre_flight: false,
      no_task: false,
      no_item: false,
      released_for: '',
      release_flight_hours: '',
      next_type: 'select',
      last_type: 'select',
      rawInputValue: '',
      inputValue: '',
      maintenance_intervention_types_list: '',
      modal_justification: false,
      email: '',
      password: '',
      showLogbookSignatureModal: false,
      editMessage: '',
      logbookIntegrationMessage: '',
      airworthiness_status: 'non_airworthy'
    };
    _this.edit = _this.edit.bind(_this);
    _this.reopen = _this.reopen.bind(_this);
    _this.logbookIntegration = _this.logbookIntegration.bind(_this);
    _this.handleLogbookSignatureSubmit = _this.handleLogbookSignatureSubmit.bind(_this);
    return _this;
  }

  _createClass(AircraftLogbookAirworthinessReleaseTab, [{
    key: 'handleChange',


    // Handlers
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleCheckboxChange',
    value: function handleCheckboxChange(name, event) {
      // valor selecionado. Valor são true e false
      var value = event.target.checked;
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      var _this2 = this;

      if (this.state.loaded === 0) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          logbook_app: newProps.logbook_app,
          loaded: 1
        });
      }

      if (typeof newProps.airworthiness_releases !== 'undefined' && newProps.airworthiness_releases !== null) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          airworthiness_releases: newProps.airworthiness_releases,
          flight_type_list: newProps.flight_type_list,
          id: newProps.airworthiness_releases.id,
          last_maintenance_intervention_type_id: newProps.airworthiness_releases.last_maintenance_intervention_type_id,
          next_maintenance_intervention_type_id: newProps.airworthiness_releases.next_maintenance_intervention_type_id,
          flight_hours_next_maintenance_intervention: newProps.airworthiness_releases.flight_hours_next_maintenance_intervention_str,
          rts: newProps.airworthiness_releases.rts,
          pre_flight: newProps.airworthiness_releases.pre_flight,
          no_task: newProps.airworthiness_releases.no_task,
          no_item: newProps.airworthiness_releases.no_item,
          released_for: newProps.airworthiness_releases.released_for,
          release_flight_hours: newProps.airworthiness_releases.release_flight_hours,
          rawInputValue: newProps.airworthiness_releases.flight_hours_next_maintenance_intervention_decimal
        }, function () {
          var anyOption = (_this2.state.flight_type_list || []).find(function (o) {
            return o.value === 'any_flight';
          });
          var status = _this2.state.released_for === 'any_flight' && anyOption ? 'airworthy' : 'non_airworthy';
          _this2.setState({ airworthiness_status: status });
        });
      }

      if (typeof newProps.maintenance_intervention_types_list !== 'undefined' && newProps.maintenance_intervention_types_list !== null) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          maintenance_intervention_types_list: newProps.maintenance_intervention_types_list
        });
      }

      this.setState({
        approvals: [],
        approval: []
      });
      if (typeof newProps.approvals[3] !== 'undefined' && newProps.approvals[3] !== null) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          approvals: newProps.approvals[3],
          approval: newProps.approvals[3][0]
        });
      }
    }

    // Fetch salvando a edição

  }, {
    key: 'edit',
    value: function edit(event) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        aircraft_logbook_id: this.state.aircraft_logbook_id,
        id: this.state.id,
        last_maintenance_intervention_type_id: this.state.last_maintenance_intervention_type_id,
        next_maintenance_intervention_type_id: this.state.next_maintenance_intervention_type_id,
        last_maintenance_intervention_option: this.state.last_maintenance_intervention_option,
        next_maintenance_intervention_option: this.state.next_maintenance_intervention_option,
        flight_hours_next_maintenance_intervention: this.state.flight_hours_next_maintenance_intervention,
        released_for: this.state.released_for,
        // Removed legacy fields from payload per new UI
        last_type: this.state.last_type,
        next_type: this.state.next_type
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/aeronavegabilidade', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ editMessage: responseJson.message }, function () {
              // Se tiver integração com o Logbook App, chama a função de integração
              if (self.props.logbook_app == 1) {
                self.logbookIntegrationSubmit();
              } else {
                self.props.updateData(responseJson);
              }
            });
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'reopen',
    value: function reopen(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      var datasave = {
        id: this.state.id,
        aircraft_logbook_id: this.state.aircraft_logbook_id,
        justification: this.state.justification
      };
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/aeronavegabilidade/reabrir', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.setState({ modal_justification: false, justification: null });
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'changeLastInput',
    value: function changeLastInput(type) {
      this.setState({
        last_type: type
      });
    }
  }, {
    key: 'changeNextInput',
    value: function changeNextInput(type) {
      this.setState({
        next_type: type
      });
    }

    // Integração com o Logbook App

  }, {
    key: 'logbookIntegration',
    value: function logbookIntegration(event) {
      // Se tiver integração com o Logbook App
      if (this.props.logbook_app == 1) {
        // Abrimos o modal para solicitar as credenciais do Logbook App
        this.setState({ showLogbookSignatureModal: true });
      } else {
        // Se não tiver integração, chama a função de edição diretamente
        this.edit();
      }
    }
  }, {
    key: 'handleLogbookSignatureSubmit',
    value: function handleLogbookSignatureSubmit(credentials) {
      var _this3 = this;

      // Recebe { email, password } do modal e atualiza o state
      this.setState({
        email: credentials.email,
        password: credentials.password,
        showLogbookSignatureModal: false
      }, function () {
        // Após informar as credenciais, chama a função de edição
        _this3.edit();
      });
    }

    // Chamada para integração após ter email e password preenchidos

  }, {
    key: 'logbookIntegrationSubmit',
    value: function logbookIntegrationSubmit() {
      var datasave = {
        id: this.state.id,
        email: this.state.email,
        password: this.state.password
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/integrar/logbook/aeronavegabilidade', {
          method: 'PUT',
          mode: 'cors',
          headers: value,
          body: JSON.stringify(datasave)
        }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ logbookIntegrationMessage: responseJson.message }, function () {
            self.props.updateData(self.groupedMessages(responseJson.status));
          });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'groupedMessages',
    value: function groupedMessages(status) {
      var combinedMessage = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          'SIGVOOS:'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
        this.state.editMessage || '',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          'Logbook App:'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
        this.state.logbookIntegrationMessage || '',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null)
      );

      return {
        status: status,
        message: combinedMessage
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var self = this;
      var flightTypeList = this.state.flight_type_list || [];
      var airworthinessOptions = [{ value: 'airworthy', label: 'Airworthy' }, { value: 'non_airworthy', label: 'Non-Airworthy' }].filter(function (opt) {
        if (opt.value === 'airworthy') {
          return !!flightTypeList.find(function (o) {
            return o.value === 'any_flight';
          });
        }
        return true;
      });
      var nonAirworthyFlightTypes = flightTypeList.filter(function (o) {
        return o.value === 'power_check' || o.value === 'maintenance_flight';
      });
      var isAirworthy = this.state.airworthiness_status === 'airworthy';
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-1 text-center' },
            self.state.approval.status === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { onClick: function onClick() {
                  return self.setState({ modal_justification: true });
                }, className: 'btn btn-primary' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-refresh' })
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { onClick: function onClick() {
                  self.logbookIntegration();
                }, className: 'btn btn-success' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-7' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              'Airworthiness Release'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-4' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'table-responsive' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'table table-bordered table-hover table-striped' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'caption',
                  null,
                  'Approval'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    { className: 'text-center' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      'User'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      'Status'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      'Approval Date'
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  { id: 'airworthiness_release_approvals' },
                  self.state.approvals.map(function (k) {
                    var approval = k;
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      { className: 'text-center', key: approval.id },
                      typeof approval.user_id !== 'undefined' && approval.user_id !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        approval.user_name
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        approval.status_str
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        approval.approval_date_str
                      )
                    );
                  })
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: this.edit },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row', style: { padding: '0px 0px 0px 50px' } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-8' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h4',
                    null,
                    'Unless new maintenance/crew reports are recorded below, I hereby certify that the release above inspection was performed and this aircraft is approved to release to service for:'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      'Airworthiness'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-group',
                      name: 'airworthiness_status',
                      value: this.state.airworthiness_status,
                      searchable: false,
                      placeholder: 'Select airworthiness status',
                      onChange: this.handleAirworthinessStatusChange,
                      options: airworthinessOptions,
                      required: true
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      'Authorized - Flight Type'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-group',
                      name: 'released_for',
                      value: this.state.released_for,
                      searchable: true,
                      placeholder: 'Selecionar tipo de voo liberado',
                      onChange: this.handleSelectChange.bind(this, 'released_for'),
                      options: isAirworthy ? flightTypeList.filter(function (o) {
                        return o.value === 'any_flight';
                      }) : nonAirworthyFlightTypes,
                      disabled: isAirworthy,
                      required: true
                    })
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                this.state.last_type === 'input' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      'New maintenance option:',
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { type: 'button', onClick: function onClick() {
                            self.changeLastInput('select');
                          }, className: 'btn btn-xs btn-info' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-refresh' })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'last_maintenance_intervention_option', className: 'form-control', placeholder: '', value: this.state.last_maintenance_intervention_option, onChange: this.handleChange.bind(this, 'last_maintenance_intervention_option'), required: true })
                  )
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      'Last Maintenance Intervention Type:',
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { type: 'button', onClick: function onClick() {
                            self.changeLastInput('input');
                          }, className: 'btn btn-xs btn-info' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-plus' })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-group',
                      name: 'last_maintenance_intervention_type_id',
                      value: this.state.last_maintenance_intervention_type_id,
                      searchable: true,
                      placeholder: 'Selecionar tipo da última intervenção de manutenção',
                      onChange: this.handleSelectChange.bind(this, 'last_maintenance_intervention_type_id'),
                      options: this.state.maintenance_intervention_types_list,
                      required: true
                    })
                  )
                ),
                this.state.next_type === 'input' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      'New maintenance option:',
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { type: 'button', onClick: function onClick() {
                            self.changeNextInput('select');
                          }, className: 'btn btn-xs btn-info' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-refresh' })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'next_maintenance_intervention_option', className: 'form-control', placeholder: '', value: this.state.next_maintenance_intervention_option, onChange: this.handleChange.bind(this, 'next_maintenance_intervention_option'), required: true })
                  )
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      'Next Maintenance Intervention Type:',
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { type: 'button', onClick: function onClick() {
                            self.changeNextInput('input');
                          }, className: 'btn btn-xs btn-info' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-plus' })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-group',
                      name: 'next_maintenance_intervention_type_id',
                      value: this.state.next_maintenance_intervention_type_id,
                      searchable: true,
                      placeholder: 'Selecionar tipo da próxima intervenção de manutenção',
                      onChange: this.handleSelectChange.bind(this, 'next_maintenance_intervention_type_id'),
                      options: this.state.maintenance_intervention_types_list,
                      required: true
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'col-md-6' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        'Hours Until Next Maintenance Intervention:'
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'col-md-6' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: this.state.flight_hours_next_maintenance_intervention, name: 'flight_hours_next_maintenance_intervention', className: 'form-control', onChange: this.handleChangeDecimal.bind(this, 'flight_hours_next_maintenance_intervention'), placeholder: 'hh.m', required: true })
                    )
                  )
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal_justification, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                'Please tell us why you need to reopen this airworthiness release'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this4.setState({ modal_justification: false, justification: null });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'alert alert-danger' },
              'Attention: This reopening should only be used in case of filling errors. For a new airworthiness release after changing the aircraft\'s conditions, please open a new logbook.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.reopen },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      'Justification:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', { style: { height: 200 }, type: 'text', name: 'justification', required: true, className: 'form-control', value: this.state.justification, onChange: this.handleChange.bind(this, 'justification') })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-certificate' }),
                      ' Submit justification'
                    )
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this4.setState({ modal_justification: false, justification: null });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__LogbookAppIntegration_LogbookSignatureModal__["a" /* default */], {
          show: this.state.showLogbookSignatureModal,
          onHide: function onHide() {
            return _this4.setState({ showLogbookSignatureModal: false });
          },
          onSubmit: this.handleLogbookSignatureSubmit,
          title: 'Voc\xEA tem certeza de que deseja integrar e editar os dados de aeronavegabilidade no Logbook App?',
          subtitle: 'Ao confirmar a assinatura digital anterior ser\xE1 revogada e a sua assinatura digital ser\xE1 afixada a este registro e ficar\xE1 vis\xEDvel para todos os usu\xE1rios do sistema.'
        })
      );
    }
  }]);

  return AircraftLogbookAirworthinessReleaseTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookAirworthinessReleaseTab);

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







// Helpers de formulário






// Importo o moment com a linguagem pt-br
__webpack_require__(24);
__webpack_require__(32);

var AircraftLogbookBFFInspectionTab = function (_Component) {
  _inherits(AircraftLogbookBFFInspectionTab, _Component);

  function AircraftLogbookBFFInspectionTab(props) {
    _classCallCheck(this, AircraftLogbookBFFInspectionTab);

    var _this = _possibleConstructorReturn(this, (AircraftLogbookBFFInspectionTab.__proto__ || Object.getPrototypeOf(AircraftLogbookBFFInspectionTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      bff_tool_fod_ok: 'false',
      bff_tool_fod_na: 'false',
      aircraft_logbook_id: _this.props.aircraft_logbook_id,
      id: '',
      approvals: [],
      approval: [],
      inspections: '',
      modal_justification: false
    };
    _this.edit = _this.edit.bind(_this);
    _this.reopen = _this.reopen.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(AircraftLogbookBFFInspectionTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleCheckboxChange',
    value: function handleCheckboxChange(name, event) {
      if (event.target.checked === false) {
        this.setState({
          bff_tool_fod_ok: false,
          bff_tool_fod_na: false
        });
        var datasave = {
          aircraft_logbook_id: this.state.aircraft_logbook_id,
          inspection_type: 'bff',
          id: this.state.inspections.id,
          bff_tool_fod_na: false,
          bff_tool_fod_ok: false
        };
      } else {
        this.setState({
          bff_tool_fod_ok: true,
          bff_tool_fod_na: false
        });
        var datasave = {
          aircraft_logbook_id: this.state.aircraft_logbook_id,
          inspection_type: 'bff',
          id: this.state.inspections.id,
          bff_tool_fod_na: false,
          bff_tool_fod_ok: true
        };
      }
      this.edit(datasave);
    }
  }, {
    key: 'handleCheckboxNaChange',
    value: function handleCheckboxNaChange(name, event) {
      if (event.target.checked === false) {
        this.setState({
          bff_tool_fod_ok: false,
          bff_tool_fod_na: false
        });
        var datasave = {
          aircraft_logbook_id: this.state.aircraft_logbook_id,
          inspection_type: 'bff',
          id: this.state.inspections.id,
          bff_tool_fod_na: false,
          bff_tool_fod_ok: false
        };
      } else {
        this.setState({
          bff_tool_fod_ok: false,
          bff_tool_fod_na: true
        });
        var datasave = {
          aircraft_logbook_id: this.state.aircraft_logbook_id,
          inspection_type: 'bff',
          id: this.state.inspections.id,
          bff_tool_fod_na: true,
          bff_tool_fod_ok: false
        };
      }
      this.edit(datasave);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          loaded: 1
        });
      }

      if (typeof newProps.inspections !== 'undefined' && newProps.inspections !== null) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          inspections: newProps.inspections,
          id: newProps.inspections.id,
          bff_tool_fod_ok: newProps.inspections.bff_tool_fod_ok,
          bff_tool_fod_na: newProps.inspections.bff_tool_fod_na
        });
      }

      if (typeof newProps.approvals[2] !== 'undefined' && newProps.approvals[2] !== null) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          approvals: newProps.approvals[2],
          approval: newProps.approvals[2][0]
        });
      }
    }

    // Fetch salvando a edição

  }, {
    key: 'edit',
    value: function edit(datasave) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/inspecao', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'reopen',
    value: function reopen(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      var datasave = {
        id: this.state.id,
        aircraft_logbook_id: this.state.aircraft_logbook_id,
        justification: this.state.justification,
        inspection_type: 'bff',
        approval_type: this.state.approval.type
      };
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/inspecao/reabrir', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.setState({ modal_justification: false, justification: null });
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-1 text-center' },
            self.state.approval.status === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { onClick: function onClick() {
                  return self.setState({ modal_justification: true });
                }, className: 'btn btn-primary' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-refresh' })
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { onClick: function onClick() {
                  self.props.approve(self.state.approval.id, self.state.approval.type);
                }, className: 'btn btn-success' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-4' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              'Before First Flight (BFF) Inspection'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-3' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.edit },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      'Tool/FOD'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                        name: 'bff_tool_fod_ok',
                        type: 'checkbox',
                        checked: this.state.bff_tool_fod_ok,
                        onChange: this.handleCheckboxChange.bind(this, 'bff_tool_fod_ok')
                      }),
                      '\xA0OK'
                    ),
                    '\xA0',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                        name: 'bff_tool_fod_na',
                        type: 'checkbox',
                        checked: this.state.bff_tool_fod_na,
                        onChange: this.handleCheckboxNaChange.bind(this, 'bff_tool_fod_na')
                      }),
                      '\xA0N/A'
                    )
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-4' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'table-responsive' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'table table-bordered table-hover table-striped' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'caption',
                  null,
                  'Approval'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    { className: 'text-center' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      'User'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      'Status'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      'Approval Date'
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  { id: 'bff_check_approvals' },
                  self.state.approvals.map(function (k) {
                    var approval = k;
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      { className: 'text-center', key: approval.id },
                      approval.user_id !== 'undefined' && approval.user_id !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        approval.user_name
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        approval.status_str
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        approval.approval_date_str
                      )
                    );
                  })
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal_justification, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                'Please tell us why you need to reopen this inspection'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ modal_justification: false, justification: null });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'alert alert-danger' },
              'Attention: This reopening should only be used in case of filling errors. For a new inspection after changing the aircraft\'s conditions, please open a new logbook.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.reopen },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      'Justification:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', { style: { height: 200 }, type: 'text', name: 'justification', required: true, className: 'form-control', value: this.state.justification, onChange: this.handleChange.bind(this, 'justification') })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-certificate' }),
                      ' Submit justification'
                    )
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ modal_justification: false, justification: null });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return AircraftLogbookBFFInspectionTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookBFFInspectionTab);

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AircraftLogbookHumsTab__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AircraftLogbookTransitInspectionTab__ = __webpack_require__(797);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário




// Tabs



// Importo o moment com a linguagem pt-br
__webpack_require__(24);
__webpack_require__(32);

var AircraftLogbookFlightAdditionalItensTab = function (_Component) {
  _inherits(AircraftLogbookFlightAdditionalItensTab, _Component);

  function AircraftLogbookFlightAdditionalItensTab(props) {
    _classCallCheck(this, AircraftLogbookFlightAdditionalItensTab);

    var _this = _possibleConstructorReturn(this, (AircraftLogbookFlightAdditionalItensTab.__proto__ || Object.getPrototypeOf(AircraftLogbookFlightAdditionalItensTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      aircraft_logbook_id: _this.props.aircraft_logbook_id,
      approvals: [],
      hums_flight_report_legs: [],
      transit_inspections_flight_report_legs: []
    };
    _this.editHums = _this.editHums.bind(_this);
    _this.editTransitInspection = _this.editTransitInspection.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(AircraftLogbookFlightAdditionalItensTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.syncStateWithProps(this.props);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps !== this.props) {
        this.syncStateWithProps(this.props);
      }
    }
  }, {
    key: 'syncStateWithProps',
    value: function syncStateWithProps(props) {
      this.setState({
        loaded: 1,
        aircraft_logbook_id: props.aircraft_logbook_id,
        hums_flight_report_legs: props.hums_flight_report_legs || [],
        transit_inspections_flight_report_legs: props.transit_inspections_flight_report_legs || [],
        approvals: props.approvals && props.approvals[5] || []
      });
    }

    // Fetch editando o HUMS

  }, {
    key: 'editHums',
    value: function editHums(flight_report_leg_id, hums_status, hums_confirmed) {
      var hums_justification = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: this.state.aircraft_logbook_id,
        flight_report_leg_id: flight_report_leg_id,
        hums_status: hums_status,
        hums_confirmed: hums_confirmed,
        hums_justification: hums_justification
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      var url = '/relatorio/voo/trecho/hums';
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
          self.setState({
            flight_report_leg_id: ''
          });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }

    // Fetch aprovação de trânsito

  }, {
    key: 'editTransitInspection',
    value: function editTransitInspection(flight_report_leg_id) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: this.state.aircraft_logbook_id,
        flight_report_leg_id: flight_report_leg_id
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      var url = '/relatorio/voo/trecho/inspection';
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
          self.setState({
            flight_report_leg_id: ''
          });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title pull-left' },
          'Additional Itens'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'caption',
              null,
              'HUMS'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                { className: 'text-center' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'ST'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Status'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Confirmed?'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'User'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Approval Date'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'hums' },
              self.state.hums_flight_report_legs.map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AircraftLogbookHumsTab__["a" /* default */], { editHums: self.editHums, hums: k, handleAlert: self.props.handleAlert });
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'caption',
              null,
              'Transit Inspection'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                { className: 'text-center' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'ST'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'User'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Approval Date'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Actions'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'transit_inspection' },
              self.state.transit_inspections_flight_report_legs.map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__AircraftLogbookTransitInspectionTab__["a" /* default */], { editTransitInspection: self.editTransitInspection, transit_inspection: k });
              })
            )
          )
        )
      );
    }
  }]);

  return AircraftLogbookFlightAdditionalItensTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookFlightAdditionalItensTab);

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







// Helpers de formulário






// Importo o moment com a linguagem pt-br
__webpack_require__(24);
__webpack_require__(32);

var AircraftLogbookFuelCheckTab = function (_Component) {
  _inherits(AircraftLogbookFuelCheckTab, _Component);

  function AircraftLogbookFuelCheckTab(props) {
    _classCallCheck(this, AircraftLogbookFuelCheckTab);

    var _this = _possibleConstructorReturn(this, (AircraftLogbookFuelCheckTab.__proto__ || Object.getPrototypeOf(AircraftLogbookFuelCheckTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      aircraft_logbook_id: _this.props.aircraft_logbook_id,
      fuel_check_ok: false,
      fuel_check_na: false,
      approvals: [],
      approval: [],
      modal_justification: false
    };
    _this.edit = _this.edit.bind(_this);
    _this.reopen = _this.reopen.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(AircraftLogbookFuelCheckTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }

    // Envia seleção OK/N/A do Fuel Check

  }, {
    key: 'edit',
    value: function edit(datasave) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/fuel-check', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (typeof self.props.updateData === 'function') {
            self.props.updateData(responseJson);
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'handleCheckboxOkChange',
    value: function handleCheckboxOkChange(name, event) {
      if (event.target.checked === false) {
        this.setState({
          fuel_check_ok: false,
          fuel_check_na: false
        });
        var datasave = {
          aircraft_logbook_id: this.state.aircraft_logbook_id,
          fuel_check_ok: false,
          fuel_check_na: false
        };
      } else {
        this.setState({
          fuel_check_ok: true,
          fuel_check_na: false
        });
        var datasave = {
          aircraft_logbook_id: this.state.aircraft_logbook_id,
          fuel_check_ok: true,
          fuel_check_na: false
        };
      }
      this.edit(datasave);
    }
  }, {
    key: 'handleCheckboxNaChange',
    value: function handleCheckboxNaChange(name, event) {
      if (event.target.checked === false) {
        this.setState({
          fuel_check_ok: false,
          fuel_check_na: false
        });
        var datasave = {
          aircraft_logbook_id: this.state.aircraft_logbook_id,
          fuel_check_ok: false,
          fuel_check_na: false
        };
      } else {
        this.setState({
          fuel_check_ok: false,
          fuel_check_na: true
        });
        var datasave = {
          aircraft_logbook_id: this.state.aircraft_logbook_id,
          fuel_check_ok: false,
          fuel_check_na: true
        };
      }
      this.edit(datasave);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          loaded: 1
        });
      }

      // Popular estado do checkbox (OK/N/A) quando vier pelas props
      if (typeof newProps.fuel_check_ok !== 'undefined' || typeof newProps.fuel_check_na !== 'undefined') {
        this.setState({
          fuel_check_ok: !!newProps.fuel_check_ok,
          fuel_check_na: !!newProps.fuel_check_na
        });
      }

      if (typeof newProps.approvals[1] !== 'undefined' && newProps.approvals[1] !== null) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          approvals: newProps.approvals[1],
          approval: newProps.approvals[1][0]
        });
      }
    }
  }, {
    key: 'reopen',
    value: function reopen(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      var datasave = {
        id: this.state.approval.id,
        aircraft_logbook_id: this.state.aircraft_logbook_id,
        justification: this.state.justification
      };
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/aprovacao/reabrir', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.setState({ modal_justification: false, justification: null });
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-1 text-center' },
            self.state.approval.status === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { onClick: function onClick() {
                  return self.setState({ modal_justification: true });
                }, className: 'btn btn-primary' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-refresh' })
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { onClick: function onClick() {
                  self.props.approve(self.state.approval.id, self.state.approval.type);
                }, className: 'btn btn-success' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-4' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              'Fuel Check'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-3' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.edit },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      'Clear, Bright, No Water or Sediments'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                        name: 'fuel_check_ok',
                        type: 'checkbox',
                        checked: this.state.fuel_check_ok,
                        onChange: this.handleCheckboxOkChange.bind(this, 'fuel_check_ok')
                      }),
                      '\xA0OK'
                    ),
                    '\xA0',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                        name: 'fuel_check_na',
                        type: 'checkbox',
                        checked: this.state.fuel_check_na,
                        onChange: this.handleCheckboxNaChange.bind(this, 'fuel_check_na')
                      }),
                      '\xA0N/A'
                    )
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-4' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'table-responsive' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'table table-bordered table-hover table-striped' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'caption',
                  null,
                  'Approval'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    { className: 'text-center' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      'User'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      'Status'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      'Approval Date'
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  { id: 'fuel_check_approvals' },
                  self.state.approvals.map(function (k) {
                    var approval = k;
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      { className: 'text-center', key: approval.id },
                      typeof approval.user_id !== 'undefined' && approval.user_id !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        approval.user_name
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        approval.status_str
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        approval.approval_date_str
                      )
                    );
                  })
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal_justification, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                'Please tell us why you need to reopen this fuel check'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ modal_justification: false, justification: null });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              { className: 'alert alert-danger' },
              'Attention: This reopening should only be used in case of filling errors. For a new fuel check after changing the aircraft\'s conditions, please open a new logbook.'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.reopen },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      'Justification:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', { style: { height: 200 }, type: 'text', name: 'justification', required: true, className: 'form-control', value: this.state.justification, onChange: this.handleChange.bind(this, 'justification') })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-certificate' }),
                      ' Submit justification'
                    )
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ modal_justification: false, justification: null });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return AircraftLogbookFuelCheckTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookFuelCheckTab);

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AircraftLogbookMaintenanceOperationalRestrictionTable__ = __webpack_require__(789);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







// Importo o moment com a linguagem pt-br
__webpack_require__(24);
__webpack_require__(32);

var AircraftLogbookMaintenanceOperationalRestrictionTab = function (_Component) {
  _inherits(AircraftLogbookMaintenanceOperationalRestrictionTab, _Component);

  function AircraftLogbookMaintenanceOperationalRestrictionTab(props) {
    _classCallCheck(this, AircraftLogbookMaintenanceOperationalRestrictionTab);

    var _this = _possibleConstructorReturn(this, (AircraftLogbookMaintenanceOperationalRestrictionTab.__proto__ || Object.getPrototypeOf(AircraftLogbookMaintenanceOperationalRestrictionTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      action_parts_modal: false,
      aircraft_logbook_id: {},
      aircraft_logbook_report_id: '',
      report_action_id: '',
      overload_analysis_str: '',
      correlation_analysis_str: '',
      limit_date_str: '',
      approval_date_str: '',
      status_str: '',
      reports: {},
      aircraft_logbook_deferred_items: {},
      report_action_parts_replacements: [],
      aircraft_logbook_reports_list: [],
      users_list: [],
      bases_list: [],
      approvals_reports: []
    };
    return _this;
  }

  // LM


  _createClass(AircraftLogbookMaintenanceOperationalRestrictionTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      // Atualiza sempre que receber novas props, garantindo que os ACRs sejam carregados
      var nextState = {};

      if (typeof newProps.aircraft_logbook_id !== 'undefined') {
        nextState.aircraft_logbook_id = newProps.aircraft_logbook_id;
      }

      if (typeof newProps.aircraft_logbook_deferred_items !== 'undefined' && newProps.aircraft_logbook_deferred_items !== null) {
        nextState.aircraft_logbook_deferred_items = newProps.aircraft_logbook_deferred_items;
      }

      if (Object.keys(nextState).length > 0) {
        nextState.loaded = 1;
        this.setState(nextState);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title pull-left' },
          'Deferred Items'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'caption',
              null,
              'Deferred Items'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter', width: '100' },
                  'Item Number'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter', width: '100' },
                  'MEL'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter', width: '100' },
                  'Category'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter', width: '100' },
                  'Type'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter', width: '100' },
                  'Limit Type'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter', width: '100' },
                  'Limit'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter', width: '100' },
                  'Limit Date'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter', width: '100' },
                  'Limit Hour'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter', width: '100' },
                  'Limit Landing'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter', width: '100' },
                  'Description'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter', width: '100' },
                  'Reason'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter', width: '100' },
                  'Correlation Analysis'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter', width: '150' },
                  'Overload Analysis'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter', width: '100' },
                  'Status'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter', width: '100' },
                  'Captain'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter', width: '100' },
                  'Acceptance Date'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter', width: '100' },
                  'Action'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'report_actions' },
              Object.keys(self.state.aircraft_logbook_deferred_items).map(function (k) {
                var report_action = self.state.aircraft_logbook_deferred_items[k];
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AircraftLogbookMaintenanceOperationalRestrictionTable__["a" /* default */], { key: k, updated: self.props.updated, report_action: report_action, approveDeferredItem: self.props.approveDeferredItem });
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
      );
    }
  }]);

  return AircraftLogbookMaintenanceOperationalRestrictionTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookMaintenanceOperationalRestrictionTab);

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AircraftLogbookReportActionPartsReplacementsTab__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AircraftLogbookReportActionMaintenanceOperationalRestrictionTab__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LogbookAppIntegration_LogbookSignatureModal__ = __webpack_require__(80);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário





// Tabs





// Importo o moment com a linguagem pt-br
__webpack_require__(24);
__webpack_require__(32);

var AircraftLogbookReportActionsTab = function (_Component) {
  _inherits(AircraftLogbookReportActionsTab, _Component);

  function AircraftLogbookReportActionsTab(props) {
    _classCallCheck(this, AircraftLogbookReportActionsTab);

    var _this = _possibleConstructorReturn(this, (AircraftLogbookReportActionsTab.__proto__ || Object.getPrototypeOf(AircraftLogbookReportActionsTab)).call(this, props));

    _this.formatInputValue = function (rawValue) {
      if (!rawValue) {
        return '';
      }

      var _rawValue$split = rawValue.split('.'),
          _rawValue$split2 = _slicedToArray(_rawValue$split, 2),
          inteiro = _rawValue$split2[0],
          decimal = _rawValue$split2[1];

      // Ajusta a parte decimal para sempre ter um dígito


      decimal = decimal && decimal.length > 0 ? decimal[0] : '0';

      return inteiro + '.' + decimal;
    };

    _this.handleChangeDecimal = function (name, event) {
      var _this$setState;

      var rawInputValue = _this.state.rawInputValue;

      var inputValue = event.target.value;

      // Se o input estiver vazio, limpa rawInputValue
      if (inputValue === '') {
        rawInputValue = '';
      } else if (/^\d+$/.test(inputValue)) {
        // Se for um número inteiro, atualiza rawInputValue
        rawInputValue = inputValue;
      } else {
        var newChar = inputValue.slice(-1);

        // Verifica se o novo caractere é um número, um ponto decimal ou uma vírgula
        if (!/^[0-9.,]$/.test(newChar)) {
          // Caractere inválido, não faz nada
          return;
        }

        // Substitui vírgula por ponto
        if (newChar === ',') {
          newChar = '.';
        }

        // Verifica se já existe um ponto decimal
        var hasDecimal = rawInputValue.includes('.');

        // Impede que "0" seja o primeiro dígito
        if (rawInputValue === '' && newChar === '0') {
          return;
        }

        // Determina se está adicionando ou removendo um caractere
        if (event.nativeEvent.inputType === 'deleteContentBackward') {
          // Removendo um caractere
          rawInputValue = rawInputValue.slice(0, -1);
        } else if (hasDecimal && newChar !== '.') {
          // Substitui o dígito após o ponto decimal
          var parts = rawInputValue.split('.');
          parts[1] = newChar;
          rawInputValue = parts.join('.');
        } else {
          // Adicionando um caractere
          rawInputValue += newChar;
        }
      }

      // Formata o valor para exibição com base em rawInputValue
      var formattedValue = _this.formatInputValue(rawInputValue);

      // Atualiza o estado
      _this.setState((_this$setState = {}, _defineProperty(_this$setState, name, formattedValue), _defineProperty(_this$setState, 'rawInputValue', rawInputValue), _this$setState));
    };

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      logbook_app: _this.props.logbook_app,
      action_parts_modal: false,
      aircraft_logbook_id: _this.props.aircraft_logbook_id,
      aircraft_logbook_report_id: '',
      report_action_id: '',
      base_id: '',
      action: '',
      deferred_item: 0,
      mandatory_inspection: 0,
      date: '',
      tools: 0,
      maintenance_flight: 0,
      executor_user_id: '',
      inspector_user_id: '',
      flight_hours_next_maintenance_intervention: '',
      system_id: null,
      next_maintenance_intervention_type_id: null,
      reports: {},
      report_actions: {},
      report_action_parts_replacements: [],
      report_action_deferred_items: [],
      maintenance_operational_restriction_list: [],
      aircraft_logbook_reports_list: [],
      users_list: [],
      bases_list: [],
      systems_list: [],
      maintenance_intervention_types_list: [],
      approvals_reports: [],
      approval_type: '',
      email: '',
      password: '',
      showLogbookSignatureModal: false,
      signature_modal_title: '',
      signature_modal_subtitle: '',
      signature_modal_confirmation: ''
    };
    _this.openDeferredModal = _this.openDeferredModal.bind(_this);
    _this.openPartsModal = _this.openPartsModal.bind(_this);
    _this.closeModal = _this.closeModal.bind(_this);
    _this.handleFormSubmit = _this.handleFormSubmit.bind(_this);
    _this.handleApproval = _this.handleApproval.bind(_this);
    _this.handleLogbookSignatureSubmit = _this.handleLogbookSignatureSubmit.bind(_this);
    _this.add = _this.add.bind(_this);
    _this.rtsApproval = _this.rtsApproval.bind(_this);
    _this.captainAcceptance = _this.captainAcceptance.bind(_this);
    _this.delete = _this.delete.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(AircraftLogbookReportActionsTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'getDefaultNextMaintenanceTypeId',
    value: function getDefaultNextMaintenanceTypeId() {
      var release = this.props.airworthiness_releases;
      if (release && release.next_maintenance_intervention_type_id) {
        return release.next_maintenance_intervention_type_id;
      }
      return null;
    }
  }, {
    key: 'componentWillReceiveProps',


    // LM
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0) {
        this.setState({
          logbook_app: newProps.logbook_app,
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          loaded: 1
        });
      }

      if (typeof newProps.reports !== 'undefined' && newProps.reports !== null) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          reports: newProps.reports
        });
      }

      if (typeof newProps.report_actions !== 'undefined' && newProps.report_actions !== null) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          report_actions: newProps.report_actions
        });
      }

      if (typeof newProps.report_action_parts_replacements !== 'undefined' && newProps.report_action_parts_replacements !== null) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          report_action_parts_replacements: newProps.report_action_parts_replacements
        });
      }

      if (typeof newProps.report_action_deferred_items !== 'undefined' && newProps.report_action_deferred_items !== null) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          report_action_deferred_items: newProps.report_action_deferred_items
        });
      }

      if (typeof newProps.maintenance_operational_restriction_list !== 'undefined' && newProps.maintenance_operational_restriction_list !== null) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          maintenance_operational_restriction_list: newProps.maintenance_operational_restriction_list
        });
      }

      if (typeof newProps.aircraft_logbook_reports_list !== 'undefined' && newProps.aircraft_logbook_reports_list !== null) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          aircraft_logbook_reports_list: newProps.aircraft_logbook_reports_list
        });
      }

      if (typeof newProps.users_list !== 'undefined' && newProps.users_list !== null) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          users_list: newProps.users_list
        });
      }

      if (typeof newProps.bases_list !== 'undefined' && newProps.bases_list !== null) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          bases_list: newProps.bases_list
        });
      }

      if (typeof newProps.systems_list !== 'undefined' && newProps.systems_list !== null) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          systems_list: newProps.systems_list
        });
      }

      if (typeof newProps.maintenance_intervention_types_list !== 'undefined' && newProps.maintenance_intervention_types_list !== null) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          maintenance_intervention_types_list: newProps.maintenance_intervention_types_list
        });
      }

      if (typeof newProps.airworthiness_releases !== 'undefined' && newProps.airworthiness_releases !== null) {
        var hasNextMaintenanceType = typeof newProps.airworthiness_releases.next_maintenance_intervention_type_id !== 'undefined' && newProps.airworthiness_releases.next_maintenance_intervention_type_id !== null;
        var defaultNextMaintenance = hasNextMaintenanceType ? newProps.airworthiness_releases.next_maintenance_intervention_type_id : null;
        if (this.state.next_maintenance_intervention_type_id === null) {
          this.setState({
            next_maintenance_intervention_type_id: defaultNextMaintenance
          });
        }
      }

      if (typeof newProps.approvals_reports !== 'undefined' && newProps.approvals_reports !== null) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          approvals_reports: newProps.approvals_reports
        });
      }
    }
  }, {
    key: 'openDeferredModal',
    value: function openDeferredModal(id) {
      var self = this;
      self.setState({
        report_action_id: id,
        action_deferred_items_modal: true
      });
    }
  }, {
    key: 'openPartsModal',
    value: function openPartsModal(id) {
      var self = this;
      self.setState({
        report_action_id: id,
        action_parts_modal: true
      });
    }
  }, {
    key: 'closeModal',
    value: function closeModal(responseJson) {
      this.props.handleAlert('', '', 'open');
      this.setState({
        action_parts_modal: false,
        action_deferred_items_modal: false
      }, this.props.updateData());
    }
  }, {
    key: 'handleFormSubmit',
    value: function handleFormSubmit(e) {
      e.preventDefault();
      this.handleApproval(null, 'report');
    }

    // Após clicar para aprovar o reporte

  }, {
    key: 'handleApproval',
    value: function handleApproval(id, type) {
      if (type === 'report') {
        // Se tiver integração com o Logbook App, chama a função de integração
        if (this.props.logbook_app == 1) {
          // Abrimos o modal para solicitar as credenciais do Logbook App
          this.setState({
            approval_type: type,
            signature_modal_title: 'Você tem certeza de que deseja integrar e enviar os dados desta ação de manutenção para o Logbook App?',
            signature_modal_subtitle: 'Ao confirmar sua assinatura digital será afixada a este registro e ficará visível para todos os usuários do sistema.',
            signature_modal_confirmation: 'Confirmo que estou ciente e desejo prosseguir com a assinatura',
            showLogbookSignatureModal: true
          });
        } else {
          this.add();
        }
      }

      if (type === 'rtsApproval') {
        // Se tiver integração com o Logbook App, chama a função de integração
        if (this.props.logbook_app == 1) {
          // Abrimos o modal para solicitar as credenciais do Logbook App
          this.setState({
            report_action_id: id,
            approval_type: type,
            signature_modal_title: 'Você tem certeza de que deseja integrar e registrar a aprovação de RTS no Logbook App?',
            signature_modal_subtitle: 'Ao confirmar sua assinatura digital será afixada a este registro e ficará visível para todos os usuários do sistema.',
            signature_modal_confirmation: 'Confirmo que estou ciente e desejo prosseguir com a assinatura',
            showLogbookSignatureModal: true
          });
        } else {
          this.rtsApproval();
        }
      }

      if (type === 'captainAcceptance') {
        // Se tiver integração com o Logbook App, chama a função de integração
        if (this.props.logbook_app == 1) {
          // Abrimos o modal para solicitar as credenciais do Logbook App
          this.setState({
            report_action_id: id,
            approval_type: type,
            signature_modal_title: 'Você tem certeza de que deseja integrar e registrar a aceitação de Comandante no Logbook App?',
            signature_modal_subtitle: 'Ao confirmar sua assinatura digital será afixada a este registro e ficará visível para todos os usuários do sistema.',
            signature_modal_confirmation: 'Confirmo que estou ciente e desejo prosseguir com a assinatura',
            showLogbookSignatureModal: true
          });
        } else {
          this.captainAcceptance();
        }
      }

      if (type === 'delete') {
        // Se tiver integração com o Logbook App, chama a função de integração
        if (this.props.logbook_app == 1) {
          // Abrimos o modal para solicitar as credenciais do Logbook App
          this.setState({
            report_action_id: id,
            approval_type: type,
            signature_modal_title: 'Você tem certeza de que deseja integrar e enviar o arquivamento desta ação de manutenção para o Logbook App?',
            signature_modal_subtitle: 'Ao confirmar sua assinatura digital será afixada a este registro e ficará visível para todos os usuários do sistema.',
            signature_modal_confirmation: 'Confirmo que estou ciente e desejo prosseguir com a assinatura',
            showLogbookSignatureModal: true
          });
        } else {
          this.delete();
        }
      }
    }

    // Após preencher as credenciais do Logbook App

  }, {
    key: 'handleLogbookSignatureSubmit',
    value: function handleLogbookSignatureSubmit(credentials) {
      var _this2 = this;

      // Recebe { email, password } do modal e atualiza o state
      this.setState({
        email: credentials.email,
        password: credentials.password,
        showLogbookSignatureModal: false
      }, function () {
        // Após informar as credenciais, chama a função de aprovação interna
        if (_this2.state.approval_type === 'report') {
          _this2.add();
        }
        if (_this2.state.approval_type === 'rtsApproval') {
          _this2.rtsApproval();
        }
        if (_this2.state.approval_type === 'captainAcceptance') {
          _this2.captainAcceptance();
        }
        if (_this2.state.approval_type === 'delete') {
          _this2.delete();
        }
      });
    }

    // Cadastra a nova ação de manutenção e, se estiver ativada a integração, envia para o Logbook App

  }, {
    key: 'add',
    value: function add() {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        email: this.state.email,
        password: this.state.password,
        aircraft_logbook_id: this.state.aircraft_logbook_id,
        aircraft_logbook_report_id: this.state.aircraft_logbook_report_id,
        base_id: this.state.base_id,
        action: this.state.action,
        deferred_item: this.state.deferred_item,
        mandatory_inspection: this.state.mandatory_inspection,
        date: this.state.date,
        tools: this.state.tools,
        maintenance_flight: this.state.maintenance_flight,
        executor_user_id: this.state.executor_user_id,
        inspector_user_id: this.state.inspector_user_id,
        flight_hours_next_maintenance_intervention: this.state.flight_hours_next_maintenance_intervention,
        system_id: this.state.system_id,
        next_maintenance_intervention_type_id: this.state.next_maintenance_intervention_type_id
      };
      var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/reporte/acoes';
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(url, { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({
              aircraft_logbook_report_id: '',
              base_id: '',
              action: '',
              deferred_item: 0,
              mandatory_inspection: 0,
              date: '',
              tools: 0,
              maintenance_flight: 0,
              executor_user_id: '',
              inspector_user_id: '',
              flight_hours_next_maintenance_intervention: '',
              system_id: null,
              next_maintenance_intervention_type_id: self.getDefaultNextMaintenanceTypeId(),
              report_action_id: '',
              approval_type: '',
              email: '',
              password: '',
              signature_modal_title: '',
              signature_modal_subtitle: '',
              signature_modal_confirmation: ''
            });
            self.props.updateData(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }

    // Aprova internamente e, se estiver ativada a integração, envia para o Logbook App

  }, {
    key: 'rtsApproval',
    value: function rtsApproval() {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        report_action_id: this.state.report_action_id,
        email: this.state.email,
        password: this.state.password
      };
      var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/reporte/acao/aprovar';
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({
            report_action_id: '',
            approval_type: '',
            email: '',
            password: '',
            signature_modal_title: '',
            signature_modal_subtitle: '',
            signature_modal_confirmation: ''
          });
          if (responseJson.status === 'success') {
            self.props.updateData(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }

    // Aprova internamente e, se estiver ativada a integração, envia para o Logbook App

  }, {
    key: 'captainAcceptance',
    value: function captainAcceptance() {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        report_action_id: this.state.report_action_id,
        email: this.state.email,
        password: this.state.password
      };
      var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/reporte/acao/aceitar';
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({
            report_action_id: '',
            approval_type: '',
            email: '',
            password: '',
            signature_modal_title: '',
            signature_modal_subtitle: '',
            signature_modal_confirmation: ''
          });
          if (responseJson.status === 'success') {
            self.props.updateData(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }

    // Deleta a ação de manutenção e, se estiver ativada a integração, arquiva no Logbook App

  }, {
    key: 'delete',
    value: function _delete() {
      var confirm = window.confirm('Are you sure that you want to delete this report action?');
      if (confirm) {
        this.props.handleAlert('', '', 'open');
        var datasave = {
          report_action_id: this.state.report_action_id,
          email: this.state.email,
          password: this.state.password
        };
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/reporte/acao/deletar';
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(url, { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({
              report_action_id: '',
              approval_type: '',
              email: '',
              password: '',
              signature_modal_title: '',
              signature_modal_subtitle: '',
              signature_modal_confirmation: ''
            });
            if (responseJson.status === 'success') {
              self.props.updateData(responseJson);
            } else {
              self.props.handleAlert(responseJson.message, responseJson.status, 'open');
            }
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title pull-left' },
          'Maintenance Actions'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: this.handleFormSubmit },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Report'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                  className: 'form-group',
                  name: 'aircraft_logbook_report_id',
                  value: this.state.aircraft_logbook_report_id,
                  searchable: true,
                  placeholder: 'Selecionar reporte',
                  onChange: this.handleSelectChange.bind(this, 'aircraft_logbook_report_id'),
                  options: this.state.aircraft_logbook_reports_list,
                  required: true
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Base'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                  className: 'form-group',
                  name: 'base_id',
                  value: this.state.base_id,
                  searchable: true,
                  placeholder: 'Selecionar base',
                  onChange: this.handleSelectChange.bind(this, 'base_id'),
                  options: this.state.bases_list,
                  required: true
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Deferred Item'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
                  'aria-label': 'deferred_item',
                  name: 'deferred_item',
                  checked: this.state.deferred_item,
                  onChange: this.handleToggleChange.bind(this, 'deferred_item')
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'RII'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
                  'aria-label': 'mandatory_inspection',
                  name: 'mandatory_inspection',
                  checked: this.state.mandatory_inspection,
                  onChange: this.handleToggleChange.bind(this, 'mandatory_inspection')
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'System'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                  className: 'form-group',
                  name: 'system_id',
                  value: this.state.system_id,
                  searchable: true,
                  placeholder: 'Select',
                  onChange: this.handleSelectChange.bind(this, 'system_id'),
                  options: this.state.systems_list,
                  required: true
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Next Maintenance Intervention Type'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                  className: 'form-group',
                  name: 'next_maintenance_intervention_type_id',
                  value: this.state.next_maintenance_intervention_type_id,
                  searchable: true,
                  placeholder: 'Select',
                  onChange: this.handleSelectChange.bind(this, 'next_maintenance_intervention_type_id'),
                  options: this.state.maintenance_intervention_types_list,
                  required: true
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Date'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.date, name: 'date', mask: '99/99/9999 99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'date'), placeholder: 'dd/mm/aaaa hh:mm', required: true })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Hours Until Next Maintenance Intervention:'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: this.state.flight_hours_next_maintenance_intervention, name: 'flight_hours_next_maintenance_intervention', className: 'form-control', onChange: this.handleChangeDecimal.bind(this, 'flight_hours_next_maintenance_intervention'), placeholder: 'hh.m', required: true })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Tools'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
                  'aria-label': 'tools',
                  name: 'tools',
                  checked: this.state.tools,
                  onChange: this.handleToggleChange.bind(this, 'tools')
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Requires maintenance flight'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
                  'aria-label': 'maintenance_flight',
                  name: 'maintenance_flight',
                  checked: this.state.maintenance_flight,
                  onChange: this.handleToggleChange.bind(this, 'maintenance_flight')
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Executor'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                  className: 'form-group',
                  name: 'executor_user_id',
                  value: this.state.executor_user_id,
                  searchable: true,
                  placeholder: 'Selecionar executor',
                  onChange: this.handleSelectChange.bind(this, 'executor_user_id'),
                  options: this.state.users_list,
                  required: true
                })
              )
            ),
            this.state.mandatory_inspection == 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Inspector'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                  className: 'form-group',
                  name: 'inspector_user_id',
                  value: this.state.inspector_user_id,
                  searchable: true,
                  placeholder: 'Selecionar inspetor',
                  onChange: this.handleSelectChange.bind(this, 'inspector_user_id'),
                  options: this.state.users_list,
                  required: true
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-12' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Action'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', { style: { height: 200 }, type: 'text', name: 'action', className: 'form-control', value: this.state.action, onChange: this.handleChange.bind(this, 'action'), required: true })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-12' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'submit', className: 'btn btn-block btn-primary' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                  ' Cadastrar'
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'caption',
              null,
              'Maintenance Actions'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Item'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Base'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Action'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'System'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Next Mnt Type'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Date'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Hrs Next Mnt'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'RII'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Tools'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Executor'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Inspector'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'RTS'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'RTS Approval'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Captain'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Captain Acceptance'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Parts Replacement'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Deferred Item'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Actions'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'report_actions' },
              Object.keys(self.state.report_actions).map(function (k) {
                var report_action = self.state.report_actions[k];
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  { className: 'text-center', key: report_action.id },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report_action.item
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report_action.base.abbreviation
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report_action.action
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report_action.system_name || (report_action.aircraft_logbook_report && report_action.aircraft_logbook_report.system ? report_action.aircraft_logbook_report.system.name : '')
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report_action.next_maintenance_intervention_type_name || (report_action.aircraft_logbook_report && report_action.aircraft_logbook_report.next_maintenance_intervention_type ? report_action.aircraft_logbook_report.next_maintenance_intervention_type.type : '')
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report_action.date_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report_action.flight_hours_next_maintenance_intervention_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report_action.mandatory_inspection_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report_action.tools_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report_action.executor_user_name
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report_action.inspector_user_name
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report_action.rts_user_name
                  ),
                  report_action.rts_approval_date == null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { onClick: function onClick() {
                          self.handleApproval(report_action.id, 'rtsApproval');
                        }, className: 'btn btn-success btn-sm button-inline' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' })
                    )
                  ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report_action.rts_approval_date_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report_action.captain_user_name
                  ),
                  report_action.captain_acceptance_date == null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { onClick: function onClick() {
                          self.handleApproval(report_action.id, 'captainAcceptance');
                        }, className: 'btn btn-success btn-sm button-inline' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' })
                    )
                  ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report_action.captain_acceptance_date_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { onClick: function onClick() {
                            return self.openPartsModal(report_action.id);
                          }, className: 'btn btn-primary btn-sm' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-gears' })
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report_action.deferred_item == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { onClick: function onClick() {
                          return self.openDeferredModal(report_action.id);
                        }, className: 'btn btn-primary btn-sm' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-hourglass-start' })
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { className: 'btn btn-primary btn-sm', disabled: true },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-hourglass-start' })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report_action.rts_approval_date == null && report_action.captain_acceptance_date == null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { onClick: function onClick() {
                          self.handleApproval(report_action.id, 'delete');
                        }, className: 'btn btn-danger btn-sm button-inline' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-trash' })
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { className: 'btn btn-danger btn-sm button-inline', disabled: true },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-trash' })
                    )
                  )
                );
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */],
          { show: this.state.action_parts_modal, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              'Part\'s Replacement'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: this.closeModal },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__AircraftLogbookReportActionPartsReplacementsTab__["a" /* default */], { handleAlert: this.props.handleAlert, handleMessage: this.props.handleMessage, updateData: this.props.updateData, report_action_id: this.state.report_action_id, reports: this.state.reports, report_actions: this.state.report_actions, report_action_parts_replacements: this.state.report_action_parts_replacements, engines_list: this.props.engines_list })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: this.closeModal },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */],
          { show: this.state.action_deferred_items_modal, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              'Deferred Item'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: this.closeModal },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__AircraftLogbookReportActionMaintenanceOperationalRestrictionTab__["a" /* default */], { handleAlert: this.props.handleAlert, handleMessage: this.props.handleMessage, updateData: this.props.updateData, report_action_id: this.state.report_action_id, reports: this.state.reports, report_actions: this.state.report_actions, report_action_deferred_items: this.state.report_action_deferred_items, maintenance_operational_restriction_list: this.state.maintenance_operational_restriction_list })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: this.closeModal },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__LogbookAppIntegration_LogbookSignatureModal__["a" /* default */], {
          show: this.state.showLogbookSignatureModal,
          onHide: function onHide() {
            return _this3.setState({ showLogbookSignatureModal: false });
          },
          onSubmit: this.handleLogbookSignatureSubmit,
          title: this.state.signature_modal_title,
          subtitle: this.state.signature_modal_subtitle,
          confirmation: this.state.signature_modal_confirmation
        })
      );
    }
  }]);

  return AircraftLogbookReportActionsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookReportActionsTab);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_getLocale__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_pad__ = __webpack_require__(1523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_signature_pad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_signature_pad__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário




var FlightReportRefuelApprovalsTab = function (_Component) {
  _inherits(FlightReportRefuelApprovalsTab, _Component);

  function FlightReportRefuelApprovalsTab(props) {
    _classCallCheck(this, FlightReportRefuelApprovalsTab);

    var _this = _possibleConstructorReturn(this, (FlightReportRefuelApprovalsTab.__proto__ || Object.getPrototypeOf(FlightReportRefuelApprovalsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      type: false,
      reproval_modal: false,
      modal_login_approval: false,
      flight_report_refuel_id: _this.props.flight_report_refuel_edit.id,
      reproved_id: null,
      reason: null,
      username: null,
      password: null,
      flight_report_refuel: _this.props.flight_report_refuel,
      flight_report_refuel_approvals: _this.props.flight_report_refuel_approvals
    };

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__i18n_getLocale__["a" /* default */])();
    _this.clearSignature = _this.clearSignature.bind(_this);
    _this.approval_login = _this.approval_login.bind(_this);
    _this.reproval_login = _this.reproval_login.bind(_this);
    _this.approval_signature = _this.approval_signature.bind(_this);
    _this.reproval_signature = _this.reproval_signature.bind(_this);
    return _this;
  }
  // LM


  _createClass(FlightReportRefuelApprovalsTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (typeof this.flight_report_refuel_approvals === 'undefined' || this.state.loaded !== 1) {
        this.setState({
          flight_report_refuel_id: newProps.flight_report_refuel_id,
          flight_report_refuel_approvals: newProps.flight_report_refuel_approvals,
          flight_report_refuel: newProps.flight_report_refuel,
          loaded: 1
        });
      }
    }
    // Handlers

  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'openLoginModal',
    value: function openLoginModal(flight_report_refuel_approval_id) {
      this.setState({ modal_login_approval: true, flight_report_refuel_approval_id: flight_report_refuel_approval_id });
    }
  }, {
    key: 'openReprovalModal',
    value: function openReprovalModal(flight_report_refuel_approval_id) {
      this.setState({ reproval_modal: true, flight_report_refuel_approval_id: flight_report_refuel_approval_id });
    }
  }, {
    key: 'approval_login',
    value: function approval_login(event) {
      var self = this;
      event.preventDefault();
      if (window.confirm(this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalAprovar.Confirmacao)) {
        self.props.handleAlert('', '', 'open');
        var datasave = {
          username: this.state.username,
          password: this.state.password,
          flight_report_refuel_approval_id: this.state.flight_report_refuel_approval_id
        };
        var header = self.refs.request_api.header('application/json');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/abastecimento/aprovacao/login/aprovar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({ modal_login_approval: false });
            self.props.updateData(responseJson);
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'reproval_login',
    value: function reproval_login(event) {
      var self = this;
      event.preventDefault();
      if (window.confirm(this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalReprovar.Confirmacao)) {
        self.props.handleAlert('', '', 'open');
        var datasave = {
          username: this.state.username,
          password: this.state.password,
          flight_report_refuel_approval_id: this.state.flight_report_refuel_approval_id
        };
        var header = self.refs.request_api.header('application/json');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/abastecimento/aprovacao/login/reprovar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({ modal_login_approval: false });
            self.props.updateData(responseJson);
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'approval_signature',
    value: function approval_signature() {
      var self = this;
      var signature = this.refs.approveSignature;
      if (signature.isEmpty()) {
        window.alert(this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalAprovar.AlertaAssinaturaVazia);
      } else {
        self.props.handleAlert('', '', 'open');
        var datasave = {
          image: signature.toDataURL(),
          flight_report_refuel_approval_id: this.state.flight_report_refuel_approval_id
        };
        var header = self.refs.request_api.header('application/json');
        // signature.clear();
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/abastecimento/aprovacao/login/aprovar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({ modal_login_approval: false });
            self.props.updateData(responseJson);
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'reproval_signature',
    value: function reproval_signature() {
      var self = this;
      var signature = this.refs.reproveSignature;
      if (signature.isEmpty()) {
        window.alert(this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalReprovar.AlertaAssinaturaVazia);
      } else {
        if (window.confirm(this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalReprovar.Confirmacao)) {
          self.props.handleAlert('', '', 'open');
          var datasave = {
            image: signature.toDataURL(),
            flight_report_refuel_approval_id: this.state.flight_report_refuel_approval_id
          };
          var header = self.refs.request_api.header('application/json');
          // signature.clear();
          Promise.resolve(header).then(function (value) {
            fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/abastecimento/aprovacao/login/reprovar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.refs.request_api.validate(responseJson, 'alert');
              self.setState({ modal_login_approval: false });
              self.props.updateData(responseJson);
              self.props.handleAlert(responseJson.message, responseJson.status, 'open');
            }).catch(function (error) {
              console.error(error);
            });
          });
        }
      }
    }
  }, {
    key: 'clearSignature',
    value: function clearSignature() {
      var reproveSignature = this.refs.reproveSignature;
      if (typeof reproveSignature !== 'undefined') {
        reproveSignature.clear();
      }
      var approveSignature = this.refs.approveSignature;
      if (typeof approveSignature !== 'undefined') {
        approveSignature.clear();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title pull-left' },
          this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.Titulo
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.tabela.Tipo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.tabela.Aprovacao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.tabela.Acoes
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              null,
              typeof self.state.flight_report_refuel_approvals !== 'undefined' && Object.keys(self.state.flight_report_refuel_approvals).map(function (k) {
                var approval = self.state.flight_report_refuel_approvals[k];
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    approval.type_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    approval.user_name
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    approval.status === 'pending' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { onClick: function onClick() {
                            self.openLoginModal(approval.id);
                          }, className: 'btn btn-success btn-sm button-inline' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' })
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { onClick: function onClick() {
                            self.openReprovalModal(approval.id);
                          }, className: 'btn btn-danger btn-sm button-inline' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-close' })
                      )
                    ) : approval.status === 'approved' || approval.status === 'reproved' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { className: 'btn btn-success btn-sm', disabled: true },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' })
                      )
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { className: 'btn btn-danger btn-sm', disabled: true },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-close' })
                      )
                    )
                  )
                );
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */],
          { show: this.state.reproval_modal, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalReprovar.Titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return self.setState({ reproval_modal: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalReprovar.BotaoReprovar
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-success btn-sm pull-right', onClick: function onClick() {
                  return self.clearSignature();
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-refresh' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'text-center' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_signature_pad___default.a, { ref: 'reproveSignature' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { type: 'button', className: 'btn btn-danger btn-block btn-inline', onClick: function onClick() {
                  return _this2.reproval_signature();
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' }),
              ' ',
              this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalReprovar.BotaoReprovar
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return self.setState({ reproval_modal: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal_login_approval, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalAprovar.Titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return self.setState({ modal_login_approval: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalAprovar.TituloPorAssinatura
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-success btn-sm pull-right', onClick: function onClick() {
                  return self.clearSignature();
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-refresh' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'text-center' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_signature_pad___default.a, { ref: 'approveSignature' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-success btn-block', type: 'button', onClick: function onClick() {
                  return _this2.approval_signature();
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-sign-in' }),
              ' ',
              this.locale.RelatorioAbastecimento.EditarAbastecimento.aprovacoes.modalAprovar.BotaoAprovar
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return self.setState({ modal_login_approval: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return FlightReportRefuelApprovalsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (FlightReportRefuelApprovalsTab);

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário




var FlightReportRefuelEditTab = function (_Component) {
  _inherits(FlightReportRefuelEditTab, _Component);

  function FlightReportRefuelEditTab(props) {
    _classCallCheck(this, FlightReportRefuelEditTab);

    var _this = _possibleConstructorReturn(this, (FlightReportRefuelEditTab.__proto__ || Object.getPrototypeOf(FlightReportRefuelEditTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      id: _this.props.flight_report_refuel_edit.id,
      approval_required: 0,
      export_required: 0,
      aircraft_id: _this.props.flight_report_refuel_edit.aircraft_id,
      date: _this.props.flight_report_refuel_edit.date,
      flight_report_id: _this.props.flight_report_refuel_edit.flight_report_id,
      flight_report_leg_id: _this.props.flight_report_refuel_edit.flight_report_leg_id,
      fuel_supplier_id: _this.props.flight_report_refuel_edit.fuel_supplier_id,
      location_id: _this.props.flight_report_refuel_edit.location_id,
      quantity: _this.props.flight_report_refuel_edit.quantity,
      receit: _this.props.flight_report_refuel_edit.receit,
      requested: _this.props.flight_report_refuel_edit.requested,
      address: _this.props.flight_report_refuel_edit.address,
      staff_id: _this.props.flight_report_refuel_edit.staff_id,
      fueling_started: _this.props.flight_report_refuel_edit.fueling_started,
      fueling_finished: _this.props.flight_report_refuel_edit.fueling_finished,
      next_location_id: _this.props.flight_report_refuel_edit.next_location_id,
      hydrant_no: _this.props.flight_report_refuel_edit.hydrant_no,
      your_sale_no: _this.props.flight_report_refuel_edit.your_sale_no,
      previous_sale_no: _this.props.flight_report_refuel_edit.previous_sale_no,
      reading_finish: _this.props.flight_report_refuel_edit.reading_finish,
      reading_start: _this.props.flight_report_refuel_edit.reading_start,
      fuel_type: _this.props.flight_report_refuel_edit.fuel_type,
      fuel_type_id: _this.props.flight_report_refuel_edit.fuel_type_id,
      unitary_value: _this.props.flight_report_refuel_edit.unitary_value,
      total_value: _this.props.flight_report_refuel_edit.total_value,
      refundable_value: _this.props.flight_report_refuel_edit.refundable_value,
      final_value: _this.props.flight_report_refuel_edit.final_value,
      fuel_suppliers_select: _this.props.fuel_suppliers_select,
      aircrafts_select: _this.props.aircrafts_select,
      locations_select: _this.props.locations_select,
      fuel_types_select: _this.props.fuel_types_select,
      companies_select: _this.props.companies_select,
      staff_select: _this.props.staff_select,
      flight_report_legs: []
    };

    _this.edit = _this.edit.bind(_this);
    _this.export_receipt = _this.export_receipt.bind(_this);
    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(FlightReportRefuelEditTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        var date = event.target.value;
        var year = date.split("-")[0];
        var month = date.split("-")[1];
        var day = date.split("-")[2];
        change[name] = date;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleChangeGallonsReading',
    value: function handleChangeGallonsReading(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);

      if (name == 'reading_start') {
        var start = event.target.value;
      } else {
        var start = this.state.reading_start;
      }
      if (name == 'reading_finish') {
        var finish = event.target.value;
      } else {
        var finish = this.state.reading_finish;
      }
      var delivered = parseInt(finish) - parseInt(start);
      this.setState({ quantity: delivered });
    }
  }, {
    key: 'handleExtraFlightToggleChange',
    value: function handleExtraFlightToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = true;
      } else {
        var value = false;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeFuelType',
    value: function handleSelectChangeFuelType(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;

        var header = this.refs.request_api.header('application/json');
        var self = this;
        self.props.handleAlert('', '', 'open');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/tipo/combustivel/' + event.value, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.setState({
              fuel_type: responseJson.data.abbreviation
            });
            self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
          });
        });
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeLeg',
    value: function handleSelectChangeLeg(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;

        var header = this.refs.request_api.header('application/json');
        var self = this;
        this.props.handleAlert('', '', 'open');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/trecho/localidade/' + event.value, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.setState({
              locations_select: responseJson.data.locations_select,
              location_id: responseJson.data.flight_report_leg.departure_location_id,
              next_location_id: responseJson.data.flight_report_leg.arrival_location_id,
              reading_start: responseJson.data.flight_report_leg.fuel_start
            });
            self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
          });
        });
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeFuelSupplier',
    value: function handleSelectChangeFuelSupplier(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;

        var header = this.refs.request_api.header('application/json');
        var self = this;
        this.props.handleAlert('', '', 'open');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/fornecedor/combustivel/' + event.value, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.setState({
              approval_required: responseJson.data.main.refuel_approval_required,
              export_required: responseJson.data.main.refuel_export_required
            });
            self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
          });
        });
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeCompany',
    value: function handleSelectChangeCompany(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;

        var header = this.refs.request_api.header('application/json');
        var self = this;
        this.props.handleAlert('', '', 'open');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/empresa/' + event.value, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.setState({
              address: responseJson.data.main.address + ', ' + responseJson.data.main.city + ', ' + responseJson.data.main.province
            });
            self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
          });
        });
      }
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (typeof this.state.id === 'undefined' || this.state.loaded !== 1) {
        this.setState({
          id: newProps.flight_report_refuel_edit.id,
          aircraft_id: newProps.flight_report_refuel_edit.aircraft_id,
          file_export: newProps.flight_report_refuel_edit.file,
          date: newProps.flight_report_refuel_edit.date,
          flight_report_id: newProps.flight_report_refuel_edit.flight_report_id,
          flight_report_leg_id: newProps.flight_report_refuel_edit.flight_report_leg_id,
          fuel_supplier_id: newProps.flight_report_refuel_edit.fuel_supplier_id,
          location_id: newProps.flight_report_refuel_edit.location_id,
          quantity: newProps.flight_report_refuel_edit.quantity,
          receit: newProps.flight_report_refuel_edit.receit,
          requested: newProps.flight_report_refuel_edit.requested,
          address: newProps.flight_report_refuel_edit.address,
          staff_id: newProps.flight_report_refuel_edit.staff_id,
          fueling_started: newProps.flight_report_refuel_edit.fueling_started,
          fueling_finished: newProps.flight_report_refuel_edit.fueling_finished,
          next_location_id: newProps.flight_report_refuel_edit.next_location_id,
          hydrant_no: newProps.flight_report_refuel_edit.hydrant_no,
          your_sale_no: newProps.flight_report_refuel_edit.your_sale_no,
          previous_sale_no: newProps.flight_report_refuel_edit.previous_sale_no,
          reading_finish: newProps.flight_report_refuel_edit.reading_finish,
          reading_start: newProps.flight_report_refuel_edit.reading_start,
          fuel_type: newProps.flight_report_refuel_edit.fuel_type,
          fuel_type_id: newProps.flight_report_refuel_edit.fuel_type_id,
          unitary_value: newProps.flight_report_refuel_edit.unitary_value,
          total_value: newProps.flight_report_refuel_edit.total_value,
          refundable_value: newProps.flight_report_refuel_edit.refundable_value,
          final_value: newProps.flight_report_refuel_edit.final_value,
          flight_report_legs: newProps.flight_report_legs_select,
          fuel_suppliers_select: newProps.fuel_suppliers_select,
          aircrafts_select: newProps.aircrafts_select,
          locations_select: newProps.locations_select,
          fuel_types_select: newProps.fuel_types_select,
          companies_select: newProps.companies_select,
          staff_select: newProps.staff_select,
          loaded: 1
        });
      }

      if (typeof newProps.flight_report_refuel_edit.fuel_supplier_id !== 'undefined' && this.state.loaded === 1 && this.state.load_fuel_supplier !== 1) {
        //Atualiza os dados do fornecedor de combustível
        var header = this.refs.request_api.header('application/json');
        var self = this;
        var fuel_supplier_id = newProps.flight_report_refuel_edit.fuel_supplier_id;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/fornecedor/combustivel/' + fuel_supplier_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.setState({
              approval_required: responseJson.data.main.refuel_approval_required,
              export_required: responseJson.data.main.refuel_export_required,
              load_fuel_supplier: 1
            });
          });
        });
      }

      if (typeof newProps.flight_report_refuel_edit.flight_report_id !== 'undefined' && this.state.loaded === 1) {
        // Atualiza os dados do relatório
        var change = {};
        var self = this;
        var flight_report_id = newProps.flight_report_refuel_edit.flight_report_id;
        if (self.state.flight_report_legs[flight_report_id]) {
          change['flight_report_legs_select'] = self.state.flight_report_legs[flight_report_id];
        } else {
          change['flight_report_legs_select'] = [];
        }
        self.setState(change);
      }

      if (typeof newProps.flight_report_refuel_edit.flight_report_leg_id !== 'undefined' && this.state.loaded === 1 && this.state.load_flight_report_leg !== 1) {
        // Atualiza os dados do trecho
        var header = this.refs.request_api.header('application/json');
        var self = this;
        var flight_report_leg_id = newProps.flight_report_refuel_edit.flight_report_leg_id;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/trecho/localidade/' + flight_report_leg_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.setState({
              locations_select: responseJson.data.locations_select,
              load_flight_report_leg: 1
            });
          });
        });
      }
    }

    // Fetch salvando a edição

  }, {
    key: 'edit',
    value: function edit(event) {
      event.preventDefault();
      var datasave = new FormData();
      var imagedata = document.querySelector(".input-nf-file").files[0];
      datasave.append("id", this.state.id);
      datasave.append("aircraft_id", this.state.aircraft_id);
      datasave.append("date", this.state.date);
      datasave.append("flight_report_id", this.state.flight_report_id);
      datasave.append("flight_report_leg_id", this.state.flight_report_leg_id);
      datasave.append("fuel_supplier_id", this.state.fuel_supplier_id);
      datasave.append("location_id", this.state.location_id);
      datasave.append("quantity", this.state.quantity);
      datasave.append("file", imagedata);
      datasave.append("receit", this.state.receit);
      datasave.append("requested", this.state.requested);
      datasave.append("address", this.state.address);
      datasave.append("staff_id", this.state.staff_id);
      datasave.append("fueling_started", this.state.fueling_started);
      datasave.append("fueling_finished", this.state.fueling_finished);
      datasave.append("next_location_id", this.state.next_location_id);
      datasave.append("hydrant_no", this.state.hydrant_no);
      datasave.append("your_sale_no", this.state.your_sale_no);
      datasave.append("previous_sale_no", this.state.previous_sale_no);
      datasave.append("reading_finish", this.state.reading_finish);
      datasave.append("reading_start", this.state.reading_start);
      datasave.append("fuel_type", this.state.fuel_type);
      datasave.append("fuel_type_id", this.state.fuel_type_id);
      var header = this.refs.request_api.header();
      var self = this;
      this.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/abastecimento/editar', { method: 'POST', mode: 'cors', headers: value, body: datasave }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);self.props.handleAlert(error.message, error.status, 'open');
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'formFields',
    value: function formFields(fields_type) {
      var _this2 = this;

      var fields = '';

      if (fields_type == 0) {
        fields = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-4 form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              null,
              this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.CombustivelSolicitado,
              ':'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.requested, maskChar: null, name: 'requested ', mask: '9999', className: 'form-control', onChange: this.handleChange.bind(this, 'requested'), placeholder: '' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-4 form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              null,
              this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.NumeroDaCe,
              ':'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'receit', className: 'form-control', placeholder: '', value: this.state.receit, onChange: this.handleChange.bind(this, 'receit'), required: true })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-4 form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              null,
              this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.CombustivelAbastecido,
              ':'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.quantity, maskChar: null, name: 'quantity ', mask: '9999', className: 'form-control', onChange: this.handleChange.bind(this, 'quantity'), placeholder: '', required: true })
          )
        );
      } else {
        fields = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Endereco
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'address', className: 'form-control', placeholder: '', value: this.state.address, onChange: this.handleChange.bind(this, 'address'), required: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Comandante
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'staff_id',
                value: this.state.staff_id,
                searchable: true,
                placeholder: 'Selecione',
                onChange: this.handleSelectChange.bind(this, 'staff_id'),
                options: this.state.staff_select
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-2 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.InicioAbastecimento,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.fueling_started, maskChar: null, name: 'fueling_started ', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'fueling_started'), placeholder: 'hh:mm' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-1 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Click
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'button', className: 'btn btn-primary btn-sm form-control', onClick: function onClick() {
                    _this2.autoFillTime('fueling_started');
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-angle-double-left' }),
                ' ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-clock-o' })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-2 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.TerminoAbastecimento,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.fueling_finished, maskChar: null, name: 'fueling_finished ', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'fueling_finished'), placeholder: 'hh:mm' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-1 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Click
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'button', className: 'btn btn-primary btn-sm form-control', onClick: function onClick() {
                    _this2.autoFillTime('fueling_finished');
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-angle-double-left' }),
                ' ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-clock-o' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.ProximaLocalidade,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'next_location_id',
                value: this.state.next_location_id,
                searchable: true,
                placeholder: 'Selecione',
                onChange: this.handleSelectChange.bind(this, 'next_location_id'),
                options: this.state.locations_select,
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.NumeroHidrante,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'hydrant_no', className: 'form-control', placeholder: '999', value: this.state.hydrant_no, onChange: this.handleChange.bind(this, 'hydrant_no'), required: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.SeuNumeroDeVenda,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'your_sale_no', className: 'form-control', placeholder: '', value: this.state.your_sale_no, onChange: this.handleChange.bind(this, 'your_sale_no'), required: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.NumeroDeVendaAnterior,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'previous_sale_no', className: 'form-control', placeholder: '', value: this.state.previous_sale_no, onChange: this.handleChange.bind(this, 'previous_sale_no'), required: true })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.LeituraFinal,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'reading_finish', className: 'form-control', placeholder: '999', value: this.state.reading_finish, onChange: this.handleChangeGallonsReading.bind(this, 'reading_finish'), required: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.LeituraInicial,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'reading_start', className: 'form-control', placeholder: '999', value: this.state.reading_start, onChange: this.handleChangeGallonsReading.bind(this, 'reading_start'), required: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Entregues,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.quantity, maskChar: null, name: 'quantity', mask: '9999', className: 'form-control', onChange: this.handleChange.bind(this, 'quantity'), placeholder: '9999', required: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.TipoCombustivel,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'fuel_type_id',
                value: this.state.fuel_type_id,
                searchable: true,
                placeholder: 'Selecione',
                onChange: this.handleSelectChangeFuelType.bind(this, 'fuel_type_id'),
                options: this.state.fuel_types_select,
                required: true
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.ValorUnitario,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.unitary_value, name: 'unitary_value', className: 'form-control', onChange: this.handleChange.bind(this, 'unitary_value'), placeholder: '999,99', readOnly: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.ValorTotal,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.total_value, name: 'total_value', className: 'form-control', onChange: this.handleChange.bind(this, 'total_value'), placeholder: '999,99', readOnly: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.ValorReembolsavel,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.refundable_value, name: 'refundable_value', className: 'form-control', onChange: this.handleChange.bind(this, 'refundable_value'), placeholder: '999,99', readOnly: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.ValorFinal,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.final_value, name: 'final_value', className: 'form-control', onChange: this.handleChange.bind(this, 'final_value'), placeholder: '999,99', readOnly: true })
            )
          )
        );
      }

      return fields;
    }
  }, {
    key: 'export_receipt',
    value: function export_receipt() {
      var url = '/files/refuels/' + this.state.id + '_' + this.state.file_export;
      window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + url);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title pull-left' },
          this.locale.RelatorioAbastecimento.EditarAbastecimento.dados
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-success btn-sm pull-right', onClick: function onClick() {
              return _this3.export_receipt();
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-download' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: this.edit },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Fornecedor,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'fuel_supplier_id',
                value: this.state.fuel_supplier_id,
                searchable: true,
                placeholder: 'Selecione',
                onChange: this.handleSelectChangeFuelSupplier.bind(this, 'fuel_supplier_id'),
                options: this.state.fuel_suppliers_select,
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.AnexarNotaFiscal,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'file', name: 'file', className: 'form-control input-nf-file', value: this.state.file, onChange: this.handleChange.bind(this, 'file') })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-4 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Relatorio,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'form-control', name: 'flight_report_id', value: this.state.flight_report_id, onChange: this.handleChange.bind(this, 'flight_report_id'), readOnly: true, required: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-4 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Trecho,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'flight_report_leg_id',
                value: this.state.flight_report_leg_id,
                searchable: true,
                placeholder: 'Selecione',
                onChange: this.handleSelectChangeLeg.bind(this, 'flight_report_leg_id'),
                options: this.state.flight_report_legs_select,
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-4 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.Localidade,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'location_id',
                value: this.state.location_id,
                searchable: true,
                placeholder: 'Selecione',
                onChange: this.handleSelectChange.bind(this, 'location_id'),
                options: this.state.locations_select,
                required: true
              })
            )
          ),
          this.formFields(this.state.export_required),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'submit', className: 'btn btn-primary btn-block btn-inline' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
            ' ',
            this.locale.RelatorioAbastecimento.EditarAbastecimento.formulario.botaoEditarAbastecimento
          )
        )
      );
    }
  }]);

  return FlightReportRefuelEditTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportRefuelEditTab);

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Elements_FlightReportRefuelApprovalsTab__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Elements_FlightReportRefuelEditTab__ = __webpack_require__(427);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// Tabs



var FlightReportRefuelsEdit = function (_Component) {
  _inherits(FlightReportRefuelsEdit, _Component);

  function FlightReportRefuelsEdit(props) {
    _classCallCheck(this, FlightReportRefuelsEdit);

    var _this = _possibleConstructorReturn(this, (FlightReportRefuelsEdit.__proto__ || Object.getPrototypeOf(FlightReportRefuelsEdit)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      flight_report_refuel_edit: {},
      flight_report_legs_select: [],
      fuel_suppliers_select: [],
      aircrafts_select: [],
      locations_select: [],
      fuel_types_select: [],
      companies_select: [],
      staff_select: [],
      flight_report_refuel_approvals: {}
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);
    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__["a" /* default */])();

    _this.updateData = _this.updateData.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    _this.export = _this.export.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(FlightReportRefuelsEdit, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }

    //LM

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'updateData',
    value: function updateData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/abastecimento/' + self.props.match.params.id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url', '/bases');
          if (responseJson.status === 'success') {
            self.setState({
              flight_report_refuel_edit: responseJson.data.main,
              flight_report_legs_select: responseJson.data.flight_report_legs_select,
              fuel_suppliers_select: responseJson.data.fuel_suppliers_select,
              aircrafts_select: responseJson.data.aircrafts_select,
              locations_select: responseJson.data.locations_select,
              fuel_types_select: responseJson.data.fuel_types_select,
              companies_select: responseJson.data.companies_select,
              staff_select: responseJson.data.staff_select,
              flight_report_refuel_approvals: responseJson.data.flight_report_refuel_approvals
            });
          }
        }).then(function () {
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/abastecimento/' + self.props.match.params.id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url', '/bases');
          if (responseJson.status === 'success') {
            self.setState({
              flight_report_refuel_edit: responseJson.data.main,
              flight_report_legs_select: responseJson.data.flight_report_legs_select,
              fuel_suppliers_select: responseJson.data.fuel_suppliers_select,
              aircrafts_select: responseJson.data.aircrafts_select,
              locations_select: responseJson.data.locations_select,
              fuel_types_select: responseJson.data.fuel_types_select,
              companies_select: responseJson.data.companies_select,
              staff_select: responseJson.data.staff_select,
              flight_report_refuel_approvals: responseJson.data.flight_report_refuel_approvals
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'export',
    value: function _export() {
      var self = this;
      var url = "/relatorio/voo/abastecimento/caribbean/exportar/";
      var header = this.refs.request_api.header('application/json');
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data;
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data);
          }
          self.handleAlert('', '', 'closed');
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.RelatorioAbastecimento.EditarAbastecimento.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'grid-buttons pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
                { to: '/abastecimentos', className: 'btn btn-default pull-right' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-left' }),
                ' ',
                this.locale.general.voltar
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Elements_FlightReportRefuelEditTab__["a" /* default */], { updateData: this.updateData, handleAlert: this.handleAlert, flight_report_refuel_edit: this.state.flight_report_refuel_edit, flight_report_legs_select: this.state.flight_report_legs_select, fuel_suppliers_select: this.state.fuel_suppliers_select, aircrafts_select: this.state.aircrafts_select, locations_select: this.state.locations_select, fuel_types_select: this.state.fuel_types_select, companies_select: this.state.companies_select, staff_select: this.state.staff_select })
          )
        )
      );
    }
  }]);

  return FlightReportRefuelsEdit;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportRefuelsEdit);

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário







var FlightReportOfflineLegEditTab = function (_Component) {
  _inherits(FlightReportOfflineLegEditTab, _Component);

  function FlightReportOfflineLegEditTab(props) {
    var _this$state;

    _classCallCheck(this, FlightReportOfflineLegEditTab);

    var _this = _possibleConstructorReturn(this, (FlightReportOfflineLegEditTab.__proto__ || Object.getPrototypeOf(FlightReportOfflineLegEditTab)).call(this, props));

    _this.state = (_this$state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      modal: false,
      id: null,
      staff_id: null,
      duty_id: null,
      flight_report_id: null,
      status_str: null,
      departure_location_id: null,
      arrival_location_id: null,
      leg_number: null,
      takeoff_scheduled: null,
      total_time_preview: null,
      engine_start_time: null,
      takeoff_time: null,
      landing_time: null,
      engine_shutoff_time: null,
      takeoff_land_time: null,
      total_time: '00:00:00',
      navigation_time: '00:00:00',
      ifr_time: '00:00:00',
      night_time: '00:00:00',
      day_landings: 0,
      night_landings: 0,
      starts: null,
      pax: 0,
      payload: 0,
      external_load_long_line: 0,
      external_load_short_line: 0,
      fuel_start: 0,
      fuel_end: 0,
      ptbr_code_id: null,
      ptbr_operation_id: null,
      ptbr_external_load_id: null,
      delay_time: null,
      delay_departure: null
    }, _defineProperty(_this$state, 'modal', false), _defineProperty(_this$state, 'locations_select', []), _defineProperty(_this$state, 'ptbr_codes_select', []), _defineProperty(_this$state, 'ptbr_operations_select', []), _defineProperty(_this$state, 'ptbr_external_loads_select', []), _defineProperty(_this$state, 'duties_select', []), _defineProperty(_this$state, 'staffs_select', []), _defineProperty(_this$state, 'flight_report_leg_edit', {}), _defineProperty(_this$state, 'flight_report_leg_edit_staffs', {}), _defineProperty(_this$state, 'style', {}), _defineProperty(_this$state, 'errors', {}), _this$state);

    _this.edit = _this.edit.bind(_this);
    _this.editMobile = _this.editMobile.bind(_this);
    _this.diffFlight = _this.diffFlight.bind(_this);
    _this.diffTotalTime = _this.diffTotalTime.bind(_this);
    _this.delayFlight = _this.delayFlight.bind(_this);
    _this.delayTotalTime = _this.delayTotalTime.bind(_this);
    _this.calcTimeFromMs = _this.calcTimeFromMs.bind(_this);
    _this.autoFillTime = _this.autoFillTime.bind(_this);
    return _this;
  }
  // Handlers


  _createClass(FlightReportOfflineLegEditTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      if (name === 'takeoff_time') {
        this.diffFlight(event.target.value, this.state.landing_time, change);
        this.delayFlight(event.target.value, this.state.takeoff_scheduled, change);
        this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, event.target.value, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'landing_time') {
        this.diffFlight(this.state.takeoff_time, event.target.value, change);
        this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, this.state.takeoff_time, event.target.value, this.state.start_parameter_total, change);
      } else if (name === 'engine_start_time') {
        this.diffTotalTime(event.target.value, this.state.engine_shutoff_time, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'engine_shutoff_time') {
        this.diffTotalTime(this.state.engine_start_time, event.target.value, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'takeoff_scheduled') {
        this.delayFlight(this.state.takeoff_time, event.target.value, change);
      } else if (name === 'total_time_preview') {
        this.delayTotalTime(event.target.value, this.state.takeoff_land_time, change);
      } else {
        this.setState(change);
      }
    }
  }, {
    key: 'autoFillTime',
    value: function autoFillTime(name) {

      var now = __WEBPACK_IMPORTED_MODULE_7_moment___default()(new Date());
      now = now.format("HH:mm");
      var change = {};
      change[name] = now;
      if (name === 'takeoff_time') {
        this.diffFlight(now, this.state.landing_time, change);
        this.delayFlight(now, this.state.takeoff_scheduled, change);
        this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, now, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'landing_time') {
        this.diffFlight(this.state.takeoff_time, now, change);
        this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, this.state.takeoff_time, now, this.state.start_parameter_total, change);
      } else if (name === 'engine_start_time') {
        this.diffTotalTime(now, this.state.engine_shutoff_time, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'engine_shutoff_time') {
        this.diffTotalTime(this.state.engine_start_time, now, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'takeoff_scheduled') {
        this.delayFlight(this.state.takeoff_time, now, change);
      } else if (name === 'total_time_preview') {
        this.delayTotalTime(now, this.state.takeoff_land_time, change);
      } else {
        this.setState(change);
      }
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
    // LM

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {

      var index_key = this.props.index_key;if (index_key === null) index_key = '';
      var takeoff_scheduled = this.props.flight_report_leg_edit.takeoff_scheduled_str;if (takeoff_scheduled === null) takeoff_scheduled = '';
      var total_time_preview = this.props.flight_report_leg_edit.total_time_preview;if (total_time_preview === null) total_time_preview = '';
      var engine_start_time = this.props.flight_report_leg_edit.engine_start_time_str;if (engine_start_time === null) engine_start_time = '';
      var takeoff_time = this.props.flight_report_leg_edit.takeoff_time_str;if (takeoff_time === null) takeoff_time = '';
      var landing_time = this.props.flight_report_leg_edit.landing_time_str;if (landing_time === null) landing_time = '';
      var engine_shutoff_time = this.props.flight_report_leg_edit.engine_shutoff_time_str;if (engine_shutoff_time === null) engine_shutoff_time = '';
      var takeoff_land_time = this.props.flight_report_leg_edit.takeoff_land_time;if (takeoff_land_time === null) takeoff_land_time = '';
      var total_time = this.props.flight_report_leg_edit.total_time;if (total_time === null) total_time = '';
      var navigation_time = this.props.flight_report_leg_edit.navigation_time;if (navigation_time === null) navigation_time = '';
      var ifr_time = this.props.flight_report_leg_edit.ifr_time;if (ifr_time === null) ifr_time = '';
      var night_time = this.props.flight_report_leg_edit.night_time;if (night_time === null) night_time = '';

      var flight_report_legs_lists = JSON.parse(localStorage.getItem("flight_report_legs_lists"));

      this.setState({
        index_key: this.props.index_key,
        flight_report_number: this.props.flight_report_leg_edit.flight_report_number,
        flight_report_leg_edit_staffs: this.props.flight_report_leg_edit_staffs,
        locations_select: flight_report_legs_lists.locations_select,
        ptbr_codes_select: flight_report_legs_lists.ptbr_codes_select,
        ptbr_operations_select: this.props.ptbr_operations_select,
        ptbr_external_loads_select: this.props.ptbr_external_loads_select,
        staffs_select: this.props.staffs_select,
        duties_select: this.props.duties_select,
        style: this.props.style,
        date: this.props.date,
        id: this.props.flight_report_leg_edit.id,
        errors: this.props.flight_report_leg_edit.errors,
        flight_report_id: this.props.flight_report_leg_edit.flight_report_id,
        status: this.props.flight_report_leg_edit.status,
        status_str: this.props.flight_report_leg_edit.status_str,
        departure_location_id: this.props.flight_report_leg_edit.departure_location_id,
        arrival_location_id: this.props.flight_report_leg_edit.arrival_location_id,
        takeoff_scheduled: takeoff_scheduled,
        total_time_preview: total_time_preview,
        engine_start_time: engine_start_time,
        takeoff_time: takeoff_time,
        landing_time: landing_time,
        engine_shutoff_time: engine_shutoff_time,
        takeoff_land_time: takeoff_land_time,
        total_time: total_time,
        navigation_time: navigation_time,
        ifr_time: ifr_time,
        night_time: night_time,
        day_landings: this.props.flight_report_leg_edit.day_landings,
        night_landings: this.props.flight_report_leg_edit.night_landings,
        starts: this.props.flight_report_leg_edit.starts,
        pax: this.props.flight_report_leg_edit.pax,
        payload: this.props.flight_report_leg_edit.payload,
        external_load_long_line: this.props.flight_report_leg_edit.external_load_long_line,
        external_load_short_line: this.props.flight_report_leg_edit.external_load_short_line,
        fuel_start: this.props.flight_report_leg_edit.fuel_start,
        fuel_end: this.props.flight_report_leg_edit.fuel_end,
        ptbr_code_id: this.props.flight_report_leg_edit.ptbr_code_id,
        ptbr_operation_id: this.props.flight_report_leg_edit.ptbr_operation_id,
        ptbr_external_load_id: this.props.flight_report_leg_edit.ptbr_external_load_id,
        delay_departure: this.props.flight_report_leg_edit.delay_departure,
        delay_time: this.props.flight_report_leg_edit.delay_time,
        leg_number: this.props.flight_report_leg_edit.leg_number,
        start_parameter_total: this.props.start_parameter_total,
        xml: this.props.xml,
        external_load: this.props.external_load
      });
    }
  }, {
    key: 'diffFlight',
    value: function diffFlight(takeoff_time, landing_time, change) {
      if (takeoff_time && landing_time && takeoff_time !== '' && landing_time !== '') {
        takeoff_time = this.state.date + ' ' + takeoff_time;
        landing_time = this.state.date + ' ' + landing_time;

        takeoff_time = __WEBPACK_IMPORTED_MODULE_7_moment___default()(takeoff_time, "DD/MM/YYYY HH:mm:ss");
        landing_time = __WEBPACK_IMPORTED_MODULE_7_moment___default()(landing_time, "DD/MM/YYYY HH:mm:ss");

        if (takeoff_time > landing_time) {
          landing_time.add(1, 'd');
        }

        takeoff_time = new Date(takeoff_time.format("YYYY-MM-DD HH:mm:ss").replace(/ /g, "T"));
        landing_time = new Date(landing_time.format("YYYY-MM-DD HH:mm:ss").replace(/ /g, "T"));
        var diffTime = Math.abs(landing_time.getTime() - takeoff_time.getTime());
        if (landing_time > takeoff_time) {
          change['takeoff_land_time'] = this.calcTimeFromMs(diffTime);
          change['navigation_time'] = this.calcTimeFromMs(diffTime);
        } else {
          change['takeoff_land_time'] = '00:00';
          change['navigation_time'] = '00:00';
        }
      } else {
        change['takeoff_land_time'] = '00:00';
        change['navigation_time'] = '00:00';
      }
      this.delayTotalTime(this.state.total_time_preview, change['takeoff_land_time'], change);
    }
  }, {
    key: 'diffTotalTime',
    value: function diffTotalTime(engine_start_time, engine_shutoff_time, takeoff_time, landing_time, start_parameter_total, change) {
      var start = null;
      if (engine_start_time !== null && engine_start_time !== '' && typeof engine_start_time !== 'undefined') {
        start = engine_start_time;
      } else if (start_parameter_total !== null) {
        start = start_parameter_total.substring(11);
      }

      if (engine_start_time !== null && engine_start_time !== '' && typeof engine_start_time !== 'undefined') {
        start = engine_start_time;
      }

      var finish = null;
      if (landing_time !== null && landing_time !== '' && typeof landing_time !== 'undefined') {
        finish = landing_time;
      }
      if (engine_shutoff_time !== null && engine_shutoff_time !== '' && typeof engine_shutoff_time !== 'undefined') {
        finish = engine_shutoff_time;
      }

      if (start && finish) {
        start = this.state.date + ' ' + start;
        finish = this.state.date + ' ' + finish;

        start = __WEBPACK_IMPORTED_MODULE_7_moment___default()(start, "DD/MM/YYYY HH:mm:ss");
        finish = __WEBPACK_IMPORTED_MODULE_7_moment___default()(finish, "DD/MM/YYYY HH:mm:ss");

        if (start > finish) {
          finish.add(1, 'd');
        }

        start = new Date(start.format("YYYY-MM-DD HH:mm:ss").replace(/ /g, "T"));
        finish = new Date(finish.format("YYYY-MM-DD HH:mm:ss").replace(/ /g, "T"));

        var diffTime = Math.abs(finish.getTime() - start.getTime());
        if (finish > start) {
          change['total_time'] = this.calcTimeFromMs(diffTime);
        } else {
          change['total_time'] = '00:00';
        }

        this.setState(change);
      } else {
        change['total_time'] = '00:00';
        this.setState(change);
      }
    }
  }, {
    key: 'delayFlight',
    value: function delayFlight(takeoff_time, takeoff_scheduled, change) {
      if (takeoff_scheduled) {
        takeoff_time = this.state.date + ' ' + takeoff_time;
        takeoff_scheduled = this.state.date + ' ' + takeoff_scheduled;

        takeoff_time = __WEBPACK_IMPORTED_MODULE_7_moment___default()(takeoff_time, "DD/MM/YYYY HH:mm:ss");
        takeoff_scheduled = __WEBPACK_IMPORTED_MODULE_7_moment___default()(takeoff_scheduled, "DD/MM/YYYY HH:mm:ss");

        var diff_hours = takeoff_scheduled.diff(takeoff_time, 'hours');

        if (takeoff_time < takeoff_scheduled && diff_hours > 12) {
          takeoff_time.add(1, 'd');
        }

        takeoff_time = new Date(takeoff_time.format("YYYY-MM-DD HH:mm:ss").replace(/ /g, "T"));
        takeoff_scheduled = new Date(takeoff_scheduled.format("YYYY-MM-DD HH:mm:ss").replace(/ /g, "T"));
        var diffTime = Math.abs(takeoff_time.getTime() - takeoff_scheduled.getTime());
        if (takeoff_time > takeoff_scheduled) {
          change['delay_departure'] = this.calcTimeFromMs(diffTime);
        } else {
          change['delay_departure'] = '00:00';
        }
      } else {
        change['delay_departure'] = '00:00';
      }
      this.setState(change);
    }
  }, {
    key: 'delayTotalTime',
    value: function delayTotalTime(total_time_preview, takeoff_land_time, change) {
      if (takeoff_land_time) {
        takeoff_land_time = __WEBPACK_IMPORTED_MODULE_7_moment___default()().format("YYYY-MM-DD") + ' ' + takeoff_land_time;
        total_time_preview = __WEBPACK_IMPORTED_MODULE_7_moment___default()().format("YYYY-MM-DD") + ' ' + total_time_preview;

        takeoff_land_time = new Date(takeoff_land_time.replace(/ /g, "T"));
        total_time_preview = new Date(total_time_preview.replace(/ /g, "T"));
        var diffTime = Math.abs(takeoff_land_time.getTime() - total_time_preview.getTime());
        if (takeoff_land_time > total_time_preview) {
          change['delay_time'] = this.calcTimeFromMs(diffTime);
        } else {
          change['delay_time'] = '00:00';
        }
      }
      this.setState(change);
    }
  }, {
    key: 'calcTimeFromMs',
    value: function calcTimeFromMs(diffTime) {
      diffTime = diffTime / 1000;
      var secs = diffTime % 60;
      diffTime = (diffTime - secs) / 60;
      var mins = diffTime % 60;
      var hrs = (diffTime - mins) / 60;
      if (secs < 10) {
        secs = '0' + secs;
      }
      if (mins < 10) {
        mins = '0' + mins;
      }
      if (hrs < 10) {
        hrs = '0' + hrs;
      }
      return hrs + ':' + mins + ':' + secs;
    }

    // Fetch salvando a edição

  }, {
    key: 'editMobile',
    value: function editMobile(event) {
      event.preventDefault();
      this.edit();
    }

    // Fetch salvando a edição
    // Fetch salvando a adição

  }, {
    key: 'edit',
    value: function edit() {
      this.props.handleAlert('', '', 'open');

      var takeoff_scheduled = null;
      var engine_start_time = null;
      var takeoff_time = null;
      var landing_time = null;
      var engine_shutoff_time = null;

      if (this.state.takeoff_scheduled) takeoff_scheduled = this.state.date + ' ' + this.state.takeoff_scheduled;
      if (this.state.engine_start_time) engine_start_time = this.state.date + ' ' + this.state.engine_start_time;
      if (this.state.takeoff_time) takeoff_time = this.state.date + ' ' + this.state.takeoff_time;
      if (this.state.landing_time) landing_time = this.state.date + ' ' + this.state.landing_time;
      if (this.state.engine_shutoff_time) engine_shutoff_time = this.state.date + ' ' + this.state.engine_shutoff_time;

      if (takeoff_scheduled) takeoff_scheduled = __WEBPACK_IMPORTED_MODULE_7_moment___default()(takeoff_scheduled, "DD/MM/YYYY HH:mm:ss");
      if (engine_start_time) engine_start_time = __WEBPACK_IMPORTED_MODULE_7_moment___default()(engine_start_time, "DD/MM/YYYY HH:mm:ss");
      if (takeoff_time) takeoff_time = __WEBPACK_IMPORTED_MODULE_7_moment___default()(takeoff_time, "DD/MM/YYYY HH:mm:ss");
      if (landing_time) landing_time = __WEBPACK_IMPORTED_MODULE_7_moment___default()(landing_time, "DD/MM/YYYY HH:mm:ss");
      if (engine_shutoff_time) engine_shutoff_time = __WEBPACK_IMPORTED_MODULE_7_moment___default()(engine_shutoff_time, "DD/MM/YYYY HH:mm:ss");

      if (takeoff_scheduled) {
        var diff_hours = takeoff_scheduled.diff(takeoff_time, 'hours');
        if (takeoff_time < takeoff_scheduled && diff_hours > 12) {
          if (engine_start_time) engine_start_time.add(1, 'd');
          if (takeoff_time) takeoff_time.add(1, 'd');
          if (landing_time) landing_time.add(1, 'd');
          if (engine_shutoff_time) engine_shutoff_time.add(1, 'd');
        }
      }

      if (takeoff_time > landing_time) {
        if (landing_time) landing_time.add(1, 'd');
      }

      if (engine_start_time > engine_shutoff_time) {
        if (engine_shutoff_time) engine_shutoff_time.add(1, 'd');
      }

      if (engine_start_time) engine_start_time = engine_start_time.format("HH:mm");
      if (takeoff_time) takeoff_time = takeoff_time.format("HH:mm");
      if (landing_time) landing_time = landing_time.format("HH:mm");
      if (engine_shutoff_time) engine_shutoff_time = engine_shutoff_time.format("HH:mm");
      if (takeoff_scheduled) takeoff_scheduled = takeoff_scheduled.format("HH:mm");

      var storage = localStorage.getItem("new_flight_report_legs_full");

      storage = JSON.parse(storage);

      storage[this.state.index_key] = {
        flight_report_id: this.state.flight_report_id,
        departure_location_id: this.state.departure_location_id,
        arrival_location_id: this.state.arrival_location_id,
        takeoff_scheduled: takeoff_scheduled,
        total_time_preview: this.state.total_time_preview,
        engine_start_time: engine_start_time,
        takeoff_time: takeoff_time,
        landing_time: landing_time,
        engine_shutoff_time: engine_shutoff_time,
        takeoff_land_time: this.state.takeoff_land_time,
        takeoff_scheduled_str: takeoff_scheduled,
        engine_start_time_str: engine_start_time,
        takeoff_time_str: takeoff_time,
        landing_time_str: landing_time,
        engine_shutoff_time_str: engine_shutoff_time,
        total_time: this.state.total_time,
        navigation_time: this.state.navigation_time,
        ifr_time: this.state.ifr_time,
        night_time: this.state.night_time,
        day_landings: this.state.day_landings,
        night_landings: this.state.night_landings,
        starts: this.state.starts,
        pax: this.state.pax,
        payload: this.state.payload,
        external_load_long_line: this.state.external_load_long_line,
        external_load_short_line: this.state.external_load_short_line,
        fuel_start: this.state.fuel_start,
        fuel_end: this.state.fuel_end,
        delay_time: this.state.delay_time,
        delay_departure: this.state.delay_departure,
        ptbr_code_id: this.state.ptbr_code_id,
        ptbr_operation_id: this.state.ptbr_operation_id,
        ptbr_external_load_id: this.state.ptbr_external_load_id,
        errors: this.state.errors,
        status: this.state.status,
        status_str: this.state.status_str
      };

      localStorage.setItem("new_flight_report_legs_full", JSON.stringify(storage));

      this.props.handleAlert('', '', 'closed');
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'tr',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'th',
          { className: 'text-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button', className: 'btn btn-primary', onClick: function onClick() {
                self.edit();
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' })
          )
        ),
        this.state.flight_report_number !== 'undefined' && this.state.flight_report_number !== undefined ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { style: { width: '200px' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', value: this.state.flight_report_number, name: 'flight_report_number ', className: 'form-control', onChange: this.handleChange.bind(this, 'flight_report_number'), placeholder: '' })
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { style: { width: '200px' } },
          this.state.flight_report_id
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { style: { width: '200px' } },
          this.state.leg_number
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
            className: 'form-field-name',
            style: this.state.style.select_places,
            name: 'departure_location_id',
            value: this.state.departure_location_id,
            searchable: true,
            placeholder: '',
            onChange: this.handleSelectChange.bind(this, 'departure_location_id'),
            options: this.state.locations_select

          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
            className: 'form-field-name',
            style: this.state.style.select_places,
            name: 'arrival_location_id',
            value: this.state.arrival_location_id,
            searchable: true,
            placeholder: '',
            onChange: this.handleSelectChange.bind(this, 'arrival_location_id'),
            options: this.state.locations_select

          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: this.state.style.input_hour, value: this.state.engine_start_time, maskChar: null, name: 'engine_start_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'engine_start_time'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button', className: 'btn btn-primary btn-sm', onClick: function onClick() {
                self.autoFillTime('engine_start_time');
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-clock-o' })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: this.state.style.input_hour, value: this.state.takeoff_time, maskChar: null, name: 'takeoff_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'takeoff_time'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button', className: 'btn btn-primary btn-sm', onClick: function onClick() {
                self.autoFillTime('takeoff_time');
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-clock-o' })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: this.state.style.input_hour, value: this.state.landing_time, maskChar: null, name: 'landing_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'landing_time'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button', className: 'btn btn-primary btn-sm', onClick: function onClick() {
                self.autoFillTime('landing_time');
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-clock-o' })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: this.state.style.input_hour, value: this.state.engine_shutoff_time, maskChar: null, name: 'engine_shutoff_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'engine_shutoff_time'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button', className: 'btn btn-primary btn-sm', onClick: function onClick() {
                self.autoFillTime('engine_shutoff_time');
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-clock-o' })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: this.state.style.input_hour, value: this.state.takeoff_land_time, maskChar: null, name: 'takeoff_land_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'takeoff_land_time'), placeholder: '', disabled: true })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: this.state.style.input_hour, value: this.state.total_time, maskChar: null, name: 'total_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'total_time'), placeholder: '', disabled: true })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: this.state.style.input_hour, value: this.state.navigation_time, maskChar: null, name: 'navigation_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'navigation_time'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: this.state.style.input_hour, value: this.state.ifr_time, maskChar: null, name: 'ifr_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'ifr_time'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: this.state.style.input_hour, value: this.state.night_time, maskChar: null, name: 'night_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'night_time'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: this.state.style.input_number, type: 'number', value: this.state.day_landings, name: 'day_landings ', className: 'form-control', onChange: this.handleChange.bind(this, 'day_landings'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: this.state.style.input_number, type: 'number', value: this.state.night_landings, name: 'night_landings ', className: 'form-control', onChange: this.handleChange.bind(this, 'night_landings'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: this.state.style.input_number, type: 'number', value: this.state.starts, name: 'starts ', className: 'form-control', onChange: this.handleChange.bind(this, 'starts'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: this.state.style.input_number, type: 'number', value: this.state.pax, name: 'pax ', className: 'form-control', onChange: this.handleChange.bind(this, 'pax'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: this.state.style.input_number, type: 'number', value: this.state.payload, name: 'payload ', className: 'form-control', onChange: this.handleChange.bind(this, 'payload'), placeholder: '' })
        ),
        this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
            checked: this.state.external_load_long_line,
            'aria-label': 'No label tag',
            name: 'external_load_long_line',
            onChange: this.handleToggleChange.bind(this, 'external_load_long_line') })
        ) : '',
        this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
            checked: this.state.external_load_short_line,
            'aria-label': 'No label tag',
            name: 'external_load_short_line',
            onChange: this.handleToggleChange.bind(this, 'external_load_short_line') })
        ) : '',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: this.state.style.input_fuel || this.state.style.input_number, type: 'number', value: this.state.fuel_start, name: 'fuel_start ', className: 'form-control', onChange: this.handleChange.bind(this, 'fuel_start'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: this.state.style.input_fuel || this.state.style.input_number, type: 'number', value: this.state.fuel_end, name: 'fuel_end ', className: 'form-control', onChange: this.handleChange.bind(this, 'fuel_end'), placeholder: '' })
        ),
        this.state.xml == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
            className: 'form-field-name',
            name: 'ptbr_code_id',
            value: this.state.ptbr_code_id,
            searchable: true,
            placeholder: '',
            onChange: this.handleSelectChange.bind(this, 'ptbr_code_id'),
            options: this.state.ptbr_codes_select,
            style: this.state.style.select_operation
          })
        ) : '',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { style: { width: '200px' } },
          this.state.status_str
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { style: { width: '200px', whiteSpace: 'nowrap', textAlign: 'center' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button', className: 'btn btn-primary', onClick: function onClick() {
                self.edit();
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button', className: 'btn btn-danger', onClick: function onClick() {
                self.props.delete(self.state.index_key);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-trash' })
          ),
          this.state.status == 'error' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button', className: 'btn btn-warning', onClick: function onClick() {
                self.props.openModal(self.state.errors);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-file-pdf-o' })
          ) : ''
        )
      );
    }
  }]);

  return FlightReportOfflineLegEditTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportOfflineLegEditTab);

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário







var FlightReportOfflineLegEditViewTab = function (_Component) {
  _inherits(FlightReportOfflineLegEditViewTab, _Component);

  function FlightReportOfflineLegEditViewTab(props) {
    var _this$state;

    _classCallCheck(this, FlightReportOfflineLegEditViewTab);

    var _this = _possibleConstructorReturn(this, (FlightReportOfflineLegEditViewTab.__proto__ || Object.getPrototypeOf(FlightReportOfflineLegEditViewTab)).call(this, props));

    _this.state = (_this$state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      modal: false,
      id: null,
      staff_id: null,
      duty_id: null,
      flight_report_id: null,
      status_str: null,
      departure_location_id: null,
      arrival_location_id: null,
      leg_number: null,
      takeoff_scheduled: null,
      total_time_preview: null,
      engine_start_time: null,
      takeoff_time: null,
      landing_time: null,
      engine_shutoff_time: null,
      takeoff_land_time: null,
      total_time: '00:00:00',
      navigation_time: '00:00:00',
      ifr_time: '00:00:00',
      night_time: '00:00:00',
      day_landings: 0,
      night_landings: 0,
      starts: null,
      pax: 0,
      payload: 0,
      external_load_long_line: 0,
      external_load_short_line: 0,
      fuel_start: 0,
      fuel_end: 0,
      ptbr_code_id: null,
      ptbr_operation_id: null,
      ptbr_external_load_id: null,
      delay_time: null,
      delay_departure: null
    }, _defineProperty(_this$state, 'modal', false), _defineProperty(_this$state, 'locations_select', []), _defineProperty(_this$state, 'ptbr_codes_select', []), _defineProperty(_this$state, 'duties_select', []), _defineProperty(_this$state, 'staffs_select', []), _defineProperty(_this$state, 'flight_report_leg_edit', {}), _defineProperty(_this$state, 'flight_report_leg_edit_staffs', {}), _defineProperty(_this$state, 'style', {}), _this$state);

    _this.diffFlight = _this.diffFlight.bind(_this);
    _this.diffTotalTime = _this.diffTotalTime.bind(_this);
    _this.delayFlight = _this.delayFlight.bind(_this);
    _this.delayTotalTime = _this.delayTotalTime.bind(_this);
    _this.calcTimeFromMs = _this.calcTimeFromMs.bind(_this);
    return _this;
  }
  // Handlers


  _createClass(FlightReportOfflineLegEditViewTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      if (name === 'takeoff_time') {
        this.diffFlight(event.target.value, this.state.landing_time, change);
        this.delayFlight(event.target.value, this.state.takeoff_scheduled, change);
        this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, event.target.value, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'landing_time') {
        this.diffFlight(this.state.takeoff_time, event.target.value, change);
        this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, this.state.takeoff_time, event.target.value, this.state.start_parameter_total, change);
      } else if (name === 'engine_start_time') {
        this.diffTotalTime(event.target.value, this.state.engine_shutoff_time, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'engine_shutoff_time') {
        this.diffTotalTime(this.state.engine_start_time, event.target.value, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'takeoff_scheduled') {
        this.delayFlight(this.state.takeoff_time, event.target.value, change);
      } else if (name === 'total_time_preview') {
        this.delayTotalTime(event.target.value, this.state.takeoff_land_time, change);
      } else {
        this.setState(change);
      }
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {

      var takeoff_scheduled = newProps.flight_report_leg_edit.takeoff_scheduled_str;if (takeoff_scheduled === null) takeoff_scheduled = '';
      var total_time_preview = newProps.flight_report_leg_edit.total_time_preview;if (total_time_preview === null) total_time_preview = '';
      var engine_start_time = newProps.flight_report_leg_edit.engine_start_time_str;if (engine_start_time === null) engine_start_time = '';
      var takeoff_time = newProps.flight_report_leg_edit.takeoff_time_str;if (takeoff_time === null) takeoff_time = '';
      var landing_time = newProps.flight_report_leg_edit.landing_time_str;if (landing_time === null) landing_time = '';
      var engine_shutoff_time = newProps.flight_report_leg_edit.engine_shutoff_time_str;if (engine_shutoff_time === null) engine_shutoff_time = '';
      var takeoff_land_time = newProps.flight_report_leg_edit.takeoff_land_time;if (takeoff_land_time === null) takeoff_land_time = '';
      var total_time = newProps.flight_report_leg_edit.total_time;if (total_time === null) total_time = '';
      var navigation_time = newProps.flight_report_leg_edit.navigation_time;if (navigation_time === null) navigation_time = '';
      var ifr_time = newProps.flight_report_leg_edit.ifr_time;if (ifr_time === null) ifr_time = '';
      var night_time = newProps.flight_report_leg_edit.night_time;if (night_time === null) night_time = '';

      this.setState({
        locations_select: newProps.locations_select,
        ptbr_codes_select: newProps.ptbr_codes_select,
        style: newProps.style,
        date: newProps.date,
        id: newProps.flight_report_leg_edit.id,
        flight_report_id: newProps.flight_report_leg_edit.flight_report_id,
        status_str: newProps.flight_report_leg_edit.status_str,
        departure_location: newProps.flight_report_leg_edit.departure_location,
        arrival_location: newProps.flight_report_leg_edit.arrival_location,
        takeoff_scheduled: takeoff_scheduled,
        total_time_preview: total_time_preview,
        engine_start_time: engine_start_time,
        takeoff_time: takeoff_time,
        landing_time: landing_time,
        engine_shutoff_time: engine_shutoff_time,
        takeoff_land_time: takeoff_land_time,
        total_time: total_time,
        navigation_time: navigation_time,
        ifr_time: ifr_time,
        night_time: night_time,
        day_landings: newProps.flight_report_leg_edit.day_landings,
        night_landings: newProps.flight_report_leg_edit.night_landings,
        starts: newProps.flight_report_leg_edit.starts,
        pax: newProps.flight_report_leg_edit.pax,
        payload: newProps.flight_report_leg_edit.payload,
        external_load_long_line: newProps.flight_report_leg_edit.external_load_long_line,
        external_load_short_line: newProps.flight_report_leg_edit.external_load_short_line,
        fuel_start: newProps.flight_report_leg_edit.fuel_start,
        fuel_end: newProps.flight_report_leg_edit.fuel_end,
        ptbr_code: newProps.flight_report_leg_edit.ptbr_code,
        delay_departure: newProps.flight_report_leg_edit.delay_departure,
        delay_time: newProps.flight_report_leg_edit.delay_time,
        leg_number: newProps.flight_report_leg_edit.leg_number,
        start_parameter_total: newProps.start_parameter_total,
        xml: newProps.xml,
        external_load: newProps.external_load
      });
    }
  }, {
    key: 'diffFlight',
    value: function diffFlight(takeoff_time, landing_time, change) {
      if (takeoff_time && landing_time && takeoff_time !== '' && landing_time !== '') {
        takeoff_time = this.state.date + ' ' + takeoff_time;
        landing_time = this.state.date + ' ' + landing_time;

        takeoff_time = __WEBPACK_IMPORTED_MODULE_7_moment___default()(takeoff_time, "DD/MM/YYYY HH:mm:ss");
        landing_time = __WEBPACK_IMPORTED_MODULE_7_moment___default()(landing_time, "DD/MM/YYYY HH:mm:ss");

        if (takeoff_time > landing_time) {
          landing_time.add(1, 'd');
        }

        takeoff_time = new Date(takeoff_time.format("YYYY-MM-DD HH:mm:ss").replace(/ /g, "T"));
        landing_time = new Date(landing_time.format("YYYY-MM-DD HH:mm:ss").replace(/ /g, "T"));
        var diffTime = Math.abs(landing_time.getTime() - takeoff_time.getTime());
        if (landing_time > takeoff_time) {
          change['takeoff_land_time'] = this.calcTimeFromMs(diffTime);
          change['navigation_time'] = this.calcTimeFromMs(diffTime);
        } else {
          change['takeoff_land_time'] = '00:00';
          change['navigation_time'] = '00:00';
        }
      } else {
        change['takeoff_land_time'] = '00:00';
        change['navigation_time'] = '00:00';
      }
      this.delayTotalTime(this.state.total_time_preview, change['takeoff_land_time'], change);
    }
  }, {
    key: 'diffTotalTime',
    value: function diffTotalTime(engine_start_time, engine_shutoff_time, takeoff_time, landing_time, start_parameter_total, change) {
      var start = null;
      if (engine_start_time !== null && engine_start_time !== '' && typeof engine_start_time !== 'undefined') {
        start = engine_start_time;
      } else if (start_parameter_total !== null) {
        start = start_parameter_total.substring(11);
      }

      if (engine_start_time !== null && engine_start_time !== '' && typeof engine_start_time !== 'undefined') {
        start = engine_start_time;
      }

      var finish = null;
      if (landing_time !== null && landing_time !== '' && typeof landing_time !== 'undefined') {
        finish = landing_time;
      }
      if (engine_shutoff_time !== null && engine_shutoff_time !== '' && typeof engine_shutoff_time !== 'undefined') {
        finish = engine_shutoff_time;
      }

      if (start && finish) {
        start = this.state.date + ' ' + start;
        finish = this.state.date + ' ' + finish;

        start = __WEBPACK_IMPORTED_MODULE_7_moment___default()(start, "DD/MM/YYYY HH:mm:ss");
        finish = __WEBPACK_IMPORTED_MODULE_7_moment___default()(finish, "DD/MM/YYYY HH:mm:ss");

        if (start > finish) {
          finish.add(1, 'd');
        }

        start = new Date(start.format("YYYY-MM-DD HH:mm:ss").replace(/ /g, "T"));
        finish = new Date(finish.format("YYYY-MM-DD HH:mm:ss").replace(/ /g, "T"));

        var diffTime = Math.abs(finish.getTime() - start.getTime());
        if (finish > start) {
          change['total_time'] = this.calcTimeFromMs(diffTime);
        } else {
          change['total_time'] = '00:00';
        }

        this.setState(change);
      } else {
        change['total_time'] = '00:00';
        this.setState(change);
      }
    }
  }, {
    key: 'delayFlight',
    value: function delayFlight(takeoff_time, takeoff_scheduled, change) {
      if (takeoff_scheduled) {
        takeoff_time = this.state.date + ' ' + takeoff_time;
        takeoff_scheduled = this.state.date + ' ' + takeoff_scheduled;

        takeoff_time = __WEBPACK_IMPORTED_MODULE_7_moment___default()(takeoff_time, "DD/MM/YYYY HH:mm:ss");
        takeoff_scheduled = __WEBPACK_IMPORTED_MODULE_7_moment___default()(takeoff_scheduled, "DD/MM/YYYY HH:mm:ss");

        var diff_hours = takeoff_scheduled.diff(takeoff_time, 'hours');

        if (takeoff_time < takeoff_scheduled && diff_hours > 12) {
          takeoff_time.add(1, 'd');
        }

        takeoff_time = new Date(takeoff_time.format("YYYY-MM-DD HH:mm:ss").replace(/ /g, "T"));
        takeoff_scheduled = new Date(takeoff_scheduled.format("YYYY-MM-DD HH:mm:ss").replace(/ /g, "T"));
        var diffTime = Math.abs(takeoff_time.getTime() - takeoff_scheduled.getTime());
        if (takeoff_time > takeoff_scheduled) {
          change['delay_departure'] = this.calcTimeFromMs(diffTime);
        } else {
          change['delay_departure'] = '00:00';
        }
      } else {
        change['delay_departure'] = '00:00';
      }
      this.setState(change);
    }
  }, {
    key: 'delayTotalTime',
    value: function delayTotalTime(total_time_preview, takeoff_land_time, change) {
      if (takeoff_land_time) {
        takeoff_land_time = __WEBPACK_IMPORTED_MODULE_7_moment___default()().format("YYYY-MM-DD") + ' ' + takeoff_land_time;
        total_time_preview = __WEBPACK_IMPORTED_MODULE_7_moment___default()().format("YYYY-MM-DD") + ' ' + total_time_preview;

        takeoff_land_time = new Date(takeoff_land_time.replace(/ /g, "T"));
        total_time_preview = new Date(total_time_preview.replace(/ /g, "T"));
        var diffTime = Math.abs(takeoff_land_time.getTime() - total_time_preview.getTime());
        if (takeoff_land_time > total_time_preview) {
          change['delay_time'] = this.calcTimeFromMs(diffTime);
        } else {
          change['delay_time'] = '00:00';
        }
      }
      this.setState(change);
    }
  }, {
    key: 'calcTimeFromMs',
    value: function calcTimeFromMs(diffTime) {
      diffTime = diffTime / 1000;
      var secs = diffTime % 60;
      diffTime = (diffTime - secs) / 60;
      var mins = diffTime % 60;
      var hrs = (diffTime - mins) / 60;
      if (secs < 10) {
        secs = '0' + secs;
      }
      if (mins < 10) {
        mins = '0' + mins;
      }
      if (hrs < 10) {
        hrs = '0' + hrs;
      }
      return hrs + ':' + mins + ':' + secs;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'tr',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.state.flight_report_id
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
          this.state.departure_location
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.state.arrival_location
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.state.engine_start_time
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.state.takeoff_time
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.state.landing_time
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.state.engine_shutoff_time
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.state.takeoff_land_time
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.state.total_time
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.state.navigation_time
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.state.ifr_time
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.state.night_time
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.state.day_landings
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.state.night_landings
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.state.starts
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.state.pax
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.state.payload
        ),
        this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.state.external_load_long_line
        ) : '',
        this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.state.external_load_short_line
        ) : '',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.state.fuel_start
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.state.fuel_end
        ),
        this.state.xml == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.state.ptbr_code
        ) : '',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.state.status_str
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { style: { width: '200px', whiteSpace: 'nowrap', textAlign: 'center' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button', className: 'btn btn-success', onClick: function onClick() {
                self.props.updateLegData(_this2.state.flight_report_id, _this2.state.id);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-plus' })
          )
        )
      );
    }
  }]);

  return FlightReportOfflineLegEditViewTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportOfflineLegEditViewTab);

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LogbookSignatureModal__ = __webpack_require__(80);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário









var LogbookAppIntegrations = function (_Component) {
  _inherits(LogbookAppIntegrations, _Component);

  function LogbookAppIntegrations(props) {
    _classCallCheck(this, LogbookAppIntegrations);

    var _this = _possibleConstructorReturn(this, (LogbookAppIntegrations.__proto__ || Object.getPrototypeOf(LogbookAppIntegrations)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      flight_report_id: _this.props.flight_report_id,
      email_logbook: '',
      password_logbook: '',
      showLogbookSignatureModal: false,
      archive_legs: [],
      update_legs: [],
      integrate_legs: [],
      modal_logbook_app: false,
      flight_report_leg_id: '',
      signature_modal_title: '',
      signature_modal_subtitle: '',
      signature_modal_confirmation: '',
      logbook_app_integration_type: null,
      flight_report_approval_id: _this.props.flight_report_approval_id,
      modal_captain_login: _this.props.modal_captain_login || false,
      integrationType: _this.props.integrationType || false,
      renderButton: _this.props.renderButton || false
    };

    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleAlertWithArray = _this.handleAlertWithArray.bind(_this);

    _this.actionsButtons = _this.actionsButtons.bind(_this);
    _this.getLogbookLegs = _this.getLogbookLegs.bind(_this);
    _this.getLogbookLegsIntegrationSubmit = _this.getLogbookLegsIntegrationSubmit.bind(_this);
    _this.handleDataLegs = _this.handleDataLegs.bind(_this);
    _this.logbookIntegration = _this.logbookIntegration.bind(_this);
    _this.handleLogbookSignatureSubmit = _this.handleLogbookSignatureSubmit.bind(_this);
    _this.handleBulkAction = _this.handleBulkAction.bind(_this);
    _this.sendAllLegs = _this.sendAllLegs.bind(_this);
    _this.captainLogin = _this.captainLogin.bind(_this);
    _this.approve = _this.approve.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(LogbookAppIntegrations, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleAlertWithArray',
    value: function handleAlertWithArray(data, message, type, status, mode) {
      var errorMessages = Array.isArray(data) ? data : [];
      var messageElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        message,
        errorMessages.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'ul',
          { style: { marginTop: 10, marginBottom: 0, paddingLeft: 20 } },
          errorMessages.map(function (error, index) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'li',
              { key: index },
              error
            );
          })
        )
      );

      if (mode === 'reset') {
        this.handleAlert('', '', '', 'reset');
      } else {
        this.handleAlert(messageElement, type, status);
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }

    // Integração com o Logbook App

    // Ajuste de dados após integração

  }, {
    key: 'handleDataLegs',
    value: function handleDataLegs(responseJson) {
      var _this2 = this;

      var mainArray = responseJson.data.data.main;
      // Captura o último registro do array, que - muito provavelmente - é o novo trecho integrado
      // Não é garantido pois o retorno é ordem pela ordem dos horários dos voos
      // Mas ainda que não seja associado ao id correto, não há problema
      // Pois o objetivo é apenas atualizar para que o botão de integração mude
      var integratedRecord = mainArray[mainArray.length - 1];
      var archivedSigtrip = this.state.archive_legs.map(function (record) {
        if (record.flight_report_leg_id === _this2.state.flight_report_leg_id) {
          // Atualiza o logbook_external_id para o id do Logbook App
          return Object.assign({}, record, { logbook_external_id: integratedRecord.id });
        }
        return record;
      });
      var updatedSigtrip = this.state.update_legs.map(function (record) {
        if (record.flight_report_leg_id === _this2.state.flight_report_leg_id) {
          // Atualiza o logbook_external_id para o id do Logbook App
          return Object.assign({}, record, { logbook_external_id: integratedRecord.id });
        }
        return record;
      });
      var integratedSigtrip = this.state.integrate_legs.map(function (record) {
        if (record.flight_report_leg_id === _this2.state.flight_report_leg_id) {
          // Atualiza o logbook_external_id para o id do Logbook App
          return Object.assign({}, record, { logbook_external_id: integratedRecord.id });
        }
        return record;
      });
      this.setState({
        archive_legs: archivedSigtrip,
        update_legs: updatedSigtrip,
        integrate_legs: integratedSigtrip
      });
    }

    // Botões de ação para integração com o Logbook App

  }, {
    key: 'actionsButtons',
    value: function actionsButtons(cell, row) {
      var _this3 = this;

      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        row.logbook_external_id == null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { onClick: function onClick() {
                return _this3.logbookIntegration(row.flight_report_leg_id, 'enviar');
              }, className: 'btn btn-info btn-sm button-inline' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-share' })
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { onClick: function onClick() {
                return _this3.logbookIntegration(row.flight_report_leg_id, 'reenviar');
              }, className: 'btn btn-success btn-sm button-inline' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-refresh' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { onClick: function onClick() {
                return _this3.logbookIntegration(row.flight_report_leg_id, 'arquivar');
              }, className: 'btn btn-danger btn-sm button-inline' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-trash' })
          )
        )
      );

      return botao;
    }

    // Obter etapas de voo do Logbook App

  }, {
    key: 'getLogbookLegs',
    value: function getLogbookLegs() {
      // Abrimos o modal para solicitar as credenciais do Logbook App
      this.setState({
        flight_report_leg_id: '',
        logbook_app_integration_type: 'obter'
      });
      this.handleLogbookSignatureSubmit({ email: '', password: '' });
    }

    // Após clicar para integrar com o Logbook App

  }, {
    key: 'logbookIntegration',
    value: function logbookIntegration(id, type) {
      if (type == 'reenviar') {
        if (!window.confirm('Esta etapa de voo já foi integrada. Deseja reenviar os dados para o Logbook App?')) {
          return;
        }
      }

      // Abrimos o modal para solicitar as credenciais do Logbook App
      this.setState({
        flight_report_leg_id: id,
        signature_modal_title: 'Voc\xEA tem certeza de que deseja integrar e ' + type + ' os dados desta etapa de voo para o Logbook App?',
        signature_modal_subtitle: 'Ao confirmar sua assinatura digital será afixada a este registro e ficará visível para todos os usuários do sistema.',
        signature_modal_confirmation: 'Confirmo que estou ciente e desejo prosseguir com a assinatura',
        showLogbookSignatureModal: true,
        logbook_app_integration_type: type
      });
    }
  }, {
    key: 'handleBulkAction',
    value: function handleBulkAction(type) {
      var title = '';
      if (type === 'enviar-todos') {
        title = 'Você tem certeza de que deseja ENVIAR TODAS as etapas de voo para o Logbook App?';
      } else if (type === 'reenviar-todos') {
        title = 'Você tem certeza de que deseja REENVIAR TODAS as etapas de voo para o Logbook App?';
      } else if (type === 'arquivar-todos') {
        title = 'Você tem certeza de que deseja ARQUIVAR TODAS as etapas de voo no Logbook App?';
      }

      this.setState({
        flight_report_leg_id: null, // Ação em massa não tem id de trecho
        signature_modal_title: title,
        signature_modal_subtitle: 'Ao confirmar sua assinatura digital será afixada a este registro e ficará visível para todos os usuários do sistema.',
        signature_modal_confirmation: 'Confirmo que estou ciente e desejo prosseguir com a assinatura',
        showLogbookSignatureModal: true,
        logbook_app_integration_type: type
      });
    }

    // Após preencher as credenciais do Logbook App

  }, {
    key: 'handleLogbookSignatureSubmit',
    value: function handleLogbookSignatureSubmit(credentials) {
      var _this4 = this;

      // Recebe { email, password } do modal e atualiza o state
      this.setState({
        email_logbook: credentials.email,
        password_logbook: credentials.password,
        showLogbookSignatureModal: false
      }, function () {
        // Após informar as credenciais
        // Se for obtenção, chama a função para obter as etapas de voo
        if (_this4.state.logbook_app_integration_type == 'obter') {
          _this4.getLogbookLegsIntegrationSubmit();
        }
        // Se for envio, reenvio ou arquivamento de todos os trechos, chama a função de envio em massa
        if (_this4.state.logbook_app_integration_type === 'enviar-todos' || _this4.state.logbook_app_integration_type === 'reenviar-todos' || _this4.state.logbook_app_integration_type === 'arquivar-todos') {
          _this4.sendAllLegs(); // Pelo integrationType é que definimos se deve-se arquivar ou integrar as etapas
        }
      });
    }

    // Chamada para obter as etapas de voo do Logbook App

  }, {
    key: 'getLogbookLegsIntegrationSubmit',
    value: function getLogbookLegsIntegrationSubmit() {
      this.setState({ overlay: { message: '', type: '', status: 'open' } });
      var datasave = {
        flight_report_id: this.state.flight_report_id,
        email: this.state.email_logbook,
        password: this.state.password_logbook,
        action_type: this.state.integrationType
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/integrar/logbook/checar', {
          method: 'POST',
          mode: 'cors',
          headers: value,
          body: JSON.stringify(datasave)
        }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({
              archive_legs: responseJson.data.archive,
              update_legs: responseJson.data.update,
              integrate_legs: responseJson.data.integrate,
              modal_logbook_app: true
            });
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
          self.setState({
            email_logbook: '',
            password_logbook: '',
            logbook_app_integration_type: null
          });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }

    // Chamada para integração de todos os trechos de voo com o Logbook App

  }, {
    key: 'sendAllLegs',
    value: function sendAllLegs() {
      this.setState({ overlay: { message: '', type: '', status: 'open' } });
      var datasave = {
        flight_report_id: this.state.flight_report_id,
        email: this.state.email_logbook,
        password: this.state.password_logbook,
        action_type: this.state.integrationType
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/integrar/logbook/executar', {
          method: 'POST',
          mode: 'cors',
          headers: value,
          body: JSON.stringify(datasave)
        }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            if (self.state.integrationType == 'cancel') {
              self.setState({
                modal_logbook_app: false
              });
            }
            self.props.updateData(responseJson);
          } else {
            self.handleAlertWithArray(responseJson.data, responseJson.message, responseJson.status, 'open');
          }
          self.setState({
            email_logbook: '',
            password_logbook: '',
            logbook_app_integration_type: null
          });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'captainLogin',
    value: function captainLogin(event) {
      var self = this;
      event.preventDefault();
      if (window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.aprovarRelatorio)) {
        self.handleAlert('', '', 'open');
        var datasave = {
          username: this.state.username,
          password: this.state.password,
          flight_report_approval_id: this.state.flight_report_approval_id
        };
        var header = self.refs.request_api.header('application/json');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/sub_commander_approval/relatorio/voo/aprovar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.setState({
                modal_logbook_app: false
              });
              self.props.updateData(responseJson);
            }
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'approve',
    value: function approve(event) {
      var self = this;
      event.preventDefault();
      if (window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.aprovarRelatorio)) {
        self.handleAlert('', '', 'open');
        var datasave = {
          flight_report_approval_id: this.state.flight_report_approval_id
        };
        var header = self.refs.request_api.header('application/json');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/commander_approval/relatorio/voo/aprovar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.setState({
                modal_logbook_app: false
              });
              self.props.updateData(responseJson);
            }
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'pull-left', style: { display: 'inline-block' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        !this.state.modal_logbook_app && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        this.props.renderButton == true && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { onClick: this.getLogbookLegs, className: this.props.buttonClass },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["q" /* OverlayTrigger */],
            { trigger: 'hover', placement: 'top', overlay: this.props.popover("Logbook App", null, "Integrar etapas de voo", "", "Visualize os detalhes das etapas de voo e envie para o Logbook App.") },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'i',
              { className: 'fa fa-check' },
              ' ',
              this.props.buttonTitle
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__LogbookSignatureModal__["a" /* default */], {
          show: this.state.showLogbookSignatureModal,
          onHide: function onHide() {
            return _this5.setState({ showLogbookSignatureModal: false });
          },
          onSubmit: this.handleLogbookSignatureSubmit,
          title: this.state.signature_modal_title,
          subtitle: this.state.signature_modal_subtitle,
          confirmation: this.state.signature_modal_confirmation
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal_logbook_app, onHide: function onHide() {
              return _this5.setState({ modal_logbook_app: false });
            }, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Header,
            { closeButton: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                'Integrar com o Logbook App'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Body,
            null,
            this.state.modal_logbook_app && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
            this.state.integrate_legs.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                null,
                'Etapas/Trechos a serem cadastrados'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["BootstrapTable"],
                { data: this.state.integrate_legs, pagination: false, striped: true, hover: true, options: { noDataText: this.locale.general.semDados } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_report_leg_id', isKey: true, hidden: true },
                  'ID'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'leg_number', dataAlign: 'center', width: '100' },
                  'N\xB0'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'date', dataAlign: 'center', width: '100' },
                  'Data'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'departure_location_str', dataAlign: 'center', width: '160' },
                  'Origem'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'arrival_location_str', dataAlign: 'center', width: '160' },
                  'Destino'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'engines_start_time', dataAlign: 'center', width: '160' },
                  'Partida'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'departure_time', dataAlign: 'center', width: '160' },
                  'Decolagem'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'landing_time', dataAlign: 'center', width: '160' },
                  'Pouso'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'engines_shut_off_time', dataAlign: 'center', width: '160' },
                  'Corte'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_time_day', dataAlign: 'center', width: '160' },
                  'Diurno'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_time_night', dataAlign: 'center', width: '160' },
                  'Noturno'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_time_ifr', dataAlign: 'center', width: '160' },
                  'IFR'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'fuel_total', dataAlign: 'center', width: '160' },
                  'Total de combust\xEDvel'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'people_on_flight', dataAlign: 'center', width: '160' },
                  'PAX'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'cargo_str', dataAlign: 'center', width: '160' },
                  'Carga'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'cycles', dataAlign: 'center', width: '160' },
                  'Ciclos'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'landings', dataAlign: 'center', width: '160' },
                  'Pousos'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_type_str', dataAlign: 'center', width: '160' },
                  'Natureza do Voo'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
            ),
            this.state.update_legs.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                null,
                'Etapas/Trechos a serem atualizados'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["BootstrapTable"],
                { data: this.state.update_legs, pagination: false, striped: true, hover: true, options: { noDataText: this.locale.general.semDados } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_report_leg_id', isKey: true, hidden: true },
                  'ID'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'leg_number', dataAlign: 'center', width: '100' },
                  'N\xB0'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'date', dataAlign: 'center', width: '100' },
                  'Data'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'departure_location_str', dataAlign: 'center', width: '160' },
                  'Origem'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'arrival_location_str', dataAlign: 'center', width: '160' },
                  'Destino'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'engines_start_time', dataAlign: 'center', width: '160' },
                  'Partida'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'departure_time', dataAlign: 'center', width: '160' },
                  'Decolagem'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'landing_time', dataAlign: 'center', width: '160' },
                  'Pouso'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'engines_shut_off_time', dataAlign: 'center', width: '160' },
                  'Corte'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_time_day', dataAlign: 'center', width: '160' },
                  'Diurno'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_time_night', dataAlign: 'center', width: '160' },
                  'Noturno'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_time_ifr', dataAlign: 'center', width: '160' },
                  'IFR'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'fuel_total', dataAlign: 'center', width: '160' },
                  'Total de combust\xEDvel'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'people_on_flight', dataAlign: 'center', width: '160' },
                  'PAX'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'cargo_str', dataAlign: 'center', width: '160' },
                  'Carga'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'cycles', dataAlign: 'center', width: '160' },
                  'Ciclos'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'landings', dataAlign: 'center', width: '160' },
                  'Pousos'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_type_str', dataAlign: 'center', width: '160' },
                  'Natureza do Voo'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
            ),
            this.state.archive_legs.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                null,
                'Etapas/Trechos a serem arquivados'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["BootstrapTable"],
                { data: this.state.archive_legs, pagination: false, striped: true, hover: true, options: { noDataText: this.locale.general.semDados } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_report_leg_id', isKey: true, hidden: true },
                  'ID'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'leg_number', dataAlign: 'center', width: '100' },
                  'N\xB0'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'date', dataAlign: 'center', width: '100' },
                  'Data'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'departure_location_str', dataAlign: 'center', width: '160' },
                  'Origem'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'arrival_location_str', dataAlign: 'center', width: '160' },
                  'Destino'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'engines_start_time', dataAlign: 'center', width: '160' },
                  'Partida'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'departure_time', dataAlign: 'center', width: '160' },
                  'Decolagem'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'landing_time', dataAlign: 'center', width: '160' },
                  'Pouso'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'engines_shut_off_time', dataAlign: 'center', width: '160' },
                  'Corte'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_time_day', dataAlign: 'center', width: '160' },
                  'Diurno'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_time_night', dataAlign: 'center', width: '160' },
                  'Noturno'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_time_ifr', dataAlign: 'center', width: '160' },
                  'IFR'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'fuel_total', dataAlign: 'center', width: '160' },
                  'Total de combust\xEDvel'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'people_on_flight', dataAlign: 'center', width: '160' },
                  'PAX'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'cargo_str', dataAlign: 'center', width: '160' },
                  'Carga'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'cycles', dataAlign: 'center', width: '160' },
                  'Ciclos'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'landings', dataAlign: 'center', width: '160' },
                  'Pousos'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_type_str', dataAlign: 'center', width: '160' },
                  'Natureza do Voo'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { style: { marginBottom: '20px' } },
              this.state.integrationType == 'approve' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { onClick: function onClick() {
                    return _this5.handleBulkAction('enviar-todos');
                  }, className: 'btn btn-info btn-block' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-share' }),
                ' Integrar todas as etapas do relat\xF3rio'
              ),
              this.state.integrationType == 'cancel' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { onClick: function onClick() {
                      return _this5.handleBulkAction('arquivar-todos');
                    }, className: 'btn btn-danger btn-block' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-trash' }),
                  ' Arquivar todas as etapas do relat\xF3rio'
                )
              )
            ),
            this.state.modal_captain_login && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                null,
                'Aprova\xE7\xE3o do Relat\xF3rio'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                'Clique no bot\xE3o abaixo para prosseguir com a aprova\xE7\xE3o do relat\xF3rio.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'form',
                { onSubmit: this.approve },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-success btn-block', type: 'submit' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' }),
                  ' Aprovar'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm', onClick: function onClick() {
                  return _this5.setState({ modal_logbook_app: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' }),
              ' Fechar'
            )
          )
        )
      );
    }
  }]);

  return LogbookAppIntegrations;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (LogbookAppIntegrations);

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var LocalStorageChecker = function (_Component) {
  _inherits(LocalStorageChecker, _Component);

  function LocalStorageChecker(props) {
    _classCallCheck(this, LocalStorageChecker);

    var _this = _possibleConstructorReturn(this, (LocalStorageChecker.__proto__ || Object.getPrototypeOf(LocalStorageChecker)).call(this, props));

    _this.clearLocalStorage = _this.clearLocalStorage.bind(_this);
    _this.removeOldReportsFromLocalStorage = _this.removeOldReportsFromLocalStorage.bind(_this);
    return _this;
  }

  // Limpa todos os dados do local storage


  _createClass(LocalStorageChecker, [{
    key: 'clearLocalStorage',
    value: function clearLocalStorage() {
      localStorage.clear();
    }

    // Remove os dados do local storage que sejam de relatórios com mais de 2 dias

  }, {
    key: 'removeOldReportsFromLocalStorage',
    value: function removeOldReportsFromLocalStorage() {
      // Remove completamente as instancias antigas de localStorage
      // flight_report_legs_states_by_id e flight_report_legs_states_new_by_id
      localStorage.removeItem('flight_report_legs_states_by_id');
      localStorage.removeItem('flight_report_legs_states_new_by_id');

      var twoDaysAgo = __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(2, 'days');

      // Remove os registros de mais relatórios de mais de 2 dias de flight_reports_index
      var flightReportsIndexObj = JSON.parse(localStorage.getItem('flight_reports_index')) || { flight_reports_index: [] };
      var flightReportsIndex = flightReportsIndexObj.flight_reports_index || [];
      var filteredFlightReportsIndex = flightReportsIndex.filter(function (report) {
        return __WEBPACK_IMPORTED_MODULE_1_moment___default()(report.date_str, 'DD/MM/YYYY').isAfter(twoDaysAgo);
      });
      flightReportsIndexObj.flight_reports_index = filteredFlightReportsIndex;
      localStorage.setItem('flight_reports_index', JSON.stringify(flightReportsIndexObj));

      // Remove os registros de mais relatórios de mais de 2 dias de flight_reports_by_id
      var flightReportsById = JSON.parse(localStorage.getItem('flight_reports_by_id')) || {};
      var filteredFlightReportsById = Object.keys(flightReportsById).reduce(function (acc, id) {
        var report = flightReportsById[id];
        if (__WEBPACK_IMPORTED_MODULE_1_moment___default()(report.flight_report.date, 'YYYY-MM-DD').isAfter(twoDaysAgo)) {
          acc[id] = report;
        }
        return acc;
      }, {});
      localStorage.setItem('flight_reports_by_id', JSON.stringify(filteredFlightReportsById));

      // Remove os registros de mais relatórios de mais de 2 dias de cached_flight_report_legs_states_by_id
      var flightReportLegsStatesById = JSON.parse(localStorage.getItem('cached_flight_report_legs_states_by_id')) || {};
      var filteredFlightReportLegsStatesById = Object.keys(flightReportLegsStatesById).reduce(function (acc, id) {
        var leg = flightReportLegsStatesById[id];
        var reportId = leg.flight_report_id;
        if (filteredFlightReportsById[reportId]) {
          acc[id] = leg;
        }
        return acc;
      }, {});
      localStorage.setItem('cached_flight_report_legs_states_by_id', JSON.stringify(filteredFlightReportLegsStatesById));

      // Remove os registros de mais relatórios de mais de 2 dias de cached_flight_report_legs_states_new_by_id
      var flightReportLegsStatesNewById = JSON.parse(localStorage.getItem('cached_flight_report_legs_states_new_by_id')) || {};
      var filteredFlightReportLegsStatesNewById = Object.keys(flightReportLegsStatesNewById).reduce(function (acc, id) {
        var legs = flightReportLegsStatesNewById[id];
        if (filteredFlightReportsById[id]) {
          acc[id] = legs;
        }
        return acc;
      }, {});
      localStorage.setItem('cached_flight_report_legs_states_new_by_id', JSON.stringify(filteredFlightReportLegsStatesNewById));
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return LocalStorageChecker;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (LocalStorageChecker);

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var PaymentRequestLeg = function (_Component) {
  _inherits(PaymentRequestLeg, _Component);

  // constructor
  function PaymentRequestLeg(props) {
    _classCallCheck(this, PaymentRequestLeg);

    var _this = _possibleConstructorReturn(this, (PaymentRequestLeg.__proto__ || Object.getPrototypeOf(PaymentRequestLeg)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      modal: false,
      leg_index: _this.props.leg_index,
      zipcode_bases: _this.props.zipcode_bases,
      zipcode_suppliers: _this.props.zipcode_suppliers,
      origin_base_id: _this.props.data.origin_base_id,
      origin_supplier_id: _this.props.data.origin_supplier_id,
      origin_base: _this.props.data.origin_base,
      origin_supplier: _this.props.data.origin_supplier,
      zipcode_origin: _this.props.data.zipcode_origin,
      destination_base_id: _this.props.data.destination_base_id,
      destination_supplier_id: _this.props.data.destination_supplier_id,
      destination_base: _this.props.data.destination_base,
      destination_supplier: _this.props.data.destination_supplier,
      zipcode_destination: _this.props.data.zipcode_destination
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.chooseLocation = _this.chooseLocation.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(PaymentRequestLeg, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      this.props.handleChangeLegData(name, event.target.value, this.state.leg_index);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      this.setState({
        leg_index: newProps.leg_index,
        zipcode_bases: newProps.zipcode_bases,
        zipcode_suppliers: newProps.zipcode_suppliers,
        origin_base_id: newProps.data.origin_base_id,
        origin_supplier_id: newProps.data.origin_supplier_id,
        origin_base: newProps.data.origin_base,
        origin_supplier: newProps.data.origin_supplier,
        zipcode_origin: newProps.data.zipcode_origin,
        destination_base_id: newProps.data.destination_base_id,
        destination_supplier_id: newProps.data.destination_supplier_id,
        destination_base: newProps.data.destination_base,
        destination_supplier: newProps.data.destination_supplier,
        zipcode_destination: newProps.data.zipcode_destination
      });
    }
  }, {
    key: 'chooseLocation',
    value: function chooseLocation(id, zipcode, name, type, source) {
      this.props.resetLeg(type, this.state.leg_index);
      var location = type + '_' + +'_id';
      var type_id = type + '_' + source + '_id';
      this.props.handleChangeLegData(type + '_' + source, name, this.state.leg_index);
      this.props.handleChangeLegData(type + '_' + source + '_id', id, this.state.leg_index);
      this.props.handleChangeLegData('zipcode_' + type, zipcode, this.state.leg_index);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'tr',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'text-center' },
          parseInt(this.state.leg_index) + 1
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button', className: 'btn btn-block btn-success', onClick: function onClick() {
                return _this2.setState({ modal: true });
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
            ' ',
            this.locale.Pagamentos.Bases.botaoLocalidades
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: this.state.origin_base, mask: '99999-999', className: 'form-control', disabled: true })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: this.state.origin_supplier, mask: '99999-999', className: 'form-control', disabled: true })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.zipcode_origin, required: true, maskChar: null, name: 'zipcode_origin', mask: '99999-999', className: 'form-control', onChange: this.handleChange.bind(this, 'zipcode_origin'), placeholder: 'XXXXX-XXX' })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: this.state.destination_base, mask: '99999-999', className: 'form-control', disabled: true })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: this.state.destination_supplier, mask: '99999-999', className: 'form-control', disabled: true })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.zipcode_destination, required: true, maskChar: null, name: 'zipcode_destination', mask: '99999-999', className: 'form-control', onChange: this.handleChange.bind(this, 'zipcode_destination'), placeholder: 'XXXXX-XXX' })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button', className: 'btn btn-danger btn-block', onClick: function onClick() {
                return _this2.props.removeLeg(_this2.state.leg_index);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal, bsSize: 'large', 'aria-labelledby': 'contained-modal-title-lg' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              this.locale.Pagamentos.Bases.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ modal: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'table-responsive' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'table table-bordered table-stripped table-hover' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { className: 'text-center' },
                      this.locale.Pagamentos.Bases.tabela.Nome
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { className: 'text-center' },
                      this.locale.Pagamentos.Bases.tabela.Tipo
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { className: 'text-center' },
                      this.locale.Pagamentos.Bases.tabela.CEP
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { className: 'text-center' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { className: 'text-center' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  { id: 'suppliers-certifications' },
                  Object.keys(this.state.zipcode_bases).map(function (k) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        self.state.zipcode_bases[k]['name']
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        self.locale.Pagamentos.Bases.tabela.Base
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        self.state.zipcode_bases[k]['zipcode']
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'button',
                          { onClick: function onClick() {
                              return self.chooseLocation(self.state.zipcode_bases[k]['id'], self.state.zipcode_bases[k]['zipcode'], self.state.zipcode_bases[k]['name'], 'origin', 'base');
                            }, className: 'btn btn-primary btn-block' },
                          self.locale.Pagamentos.Bases.tabela.botaoAssociarCEPAOrigem
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'button',
                          { onClick: function onClick() {
                              return self.chooseLocation(self.state.zipcode_bases[k]['id'], self.state.zipcode_bases[k]['zipcode'], self.state.zipcode_bases[k]['name'], 'destination', 'base');
                            }, className: 'btn btn-primary btn-block' },
                          self.locale.Pagamentos.Bases.tabela.botaoAssociarCEPADestino
                        )
                      )
                    );
                  }),
                  Object.keys(this.state.zipcode_suppliers).map(function (k) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        self.state.zipcode_suppliers[k]['name']
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        self.locale.Pagamentos.Bases.tabela.Fornecedor
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        self.state.zipcode_suppliers[k]['zipcode']
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'button',
                          { onClick: function onClick() {
                              return self.chooseLocation(self.state.zipcode_suppliers[k]['id'], self.state.zipcode_suppliers[k]['zipcode'], self.state.zipcode_suppliers[k]['name'], 'origin', 'supplier');
                            }, className: 'btn btn-primary btn-block' },
                          self.locale.Pagamentos.Bases.tabela.botaoAssociarCEPAOrigem
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'button',
                          { onClick: function onClick() {
                              return self.chooseLocation(self.state.zipcode_suppliers[k]['id'], self.state.zipcode_suppliers[k]['zipcode'], self.state.zipcode_suppliers[k]['name'], 'destination', 'supplier');
                            }, className: 'btn btn-primary btn-block' },
                          self.locale.Pagamentos.Bases.tabela.botaoAssociarCEPADestino
                        )
                      )
                    );
                  })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ modal: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return PaymentRequestLeg;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (PaymentRequestLeg);

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var StaffCertificationAddFile = function (_Component) {
  _inherits(StaffCertificationAddFile, _Component);

  function StaffCertificationAddFile(props) {
    _classCallCheck(this, StaffCertificationAddFile);

    var _this = _possibleConstructorReturn(this, (StaffCertificationAddFile.__proto__ || Object.getPrototypeOf(StaffCertificationAddFile)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      id: _this.props.staff_certification_id,
      file_archived: _this.props.file_archived,
      file: _this.props.file
    };

    //bind específico
    // this.addFile = this.addFile.bind(this);
    _this.export = _this.export.bind(_this);
    return _this;
  }
  // // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // }

  // LM


  _createClass(StaffCertificationAddFile, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (typeof newProps.staff_certification_id !== 'undefined') {
        this.setState({
          id: newProps.staff_certification_id,
          file_archived: newProps.file_archived,
          file: newProps.file
        });
      }
    }

    // addFile(event) {
    //   event.preventDefault();
    //   var confirm = window.confirm('Tem certeza que gostaria de importar este arquivo? Ao importar, o arquivo anterior será substituido permanentemente.');
    //   if (confirm) {
    //     var data = new FormData();
    //     var imagedata = document.querySelector('.input-archive-staff-certification-' + this.state.id).files[0];
    //     data.append("imagem", imagedata);
    //     data.append("id", this.state.id);
    //     var header = this.refs.request_api.header();
    //     var self = this;
    //     this.props.handleAlert('', '', 'open');
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/certificado/arquivo', {
    //         method: 'POST',
    //         mode: 'cors',
    //         headers: value,
    //         body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //           if (responseJson.status === 'success') {
    //             self.props.refreshData();
    //           }
    //           self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //         }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }


  }, {
    key: 'export',
    value: function _export(event) {
      event.preventDefault();
      var self = this;
      var url = '/exportar/certificado/funcionario/';
      var header = this.refs.request_api.header('application/json');
      self.setState({ overlay: { message: '', type: '', status: 'open' } });
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url + self.state.id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data);
          }
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: this.addFile },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: "btn btn-sm btn-warning btn-margin-bottom", disabled: this.state.file_archived === 1 ? "" : "disabled", target: '_blank', href: __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/files/certifications/' + this.state.file },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-download' })
          ),
          '\xA0',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button', className: "btn btn-sm btn-success btn-margin-bottom", onClick: this.export },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-o' })
          )
        )
      );
    }
  }]);

  return StaffCertificationAddFile;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffCertificationAddFile);

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// Importação do Router





var Login = function (_Component) {
  _inherits(Login, _Component);

  function Login(props) {
    _classCallCheck(this, Login);

    var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      username: '',
      password: '',
      mensagem: null,
      forget_password: false
    };
    // Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.login = _this.login.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(Login, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount(newProps) {
      this.handleMessage();
    }
  }, {
    key: 'login',
    value: function login(event) {
      var _this2 = this;

      event.preventDefault();
      var headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      };
      var datasave = {
        username: this.state.username,
        password: this.state.password,
        system: 'sigrfms'
      };
      this.handleAlert('', '', 'open');
      fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/get/token', { method: 'POST', mode: 'cors', headers: headers, body: JSON.stringify(datasave) }).then(function (response) {
        return response.json();
      }).catch(function (error) {
        console.error(error);
      }).then(function (responseJson) {
        _this2.refs.request_api.validate(responseJson);
        if (responseJson.error === 'inexistent_user') {
          _this2.handleAlert(_this2.locale.Usuarios.Login.usuarioNaoCadastrado, 'error', 'open');
        } else if (responseJson.error === 'inactive_user') {
          _this2.handleAlert(_this2.locale.Usuarios.Login.usuarioInativo, 'error', 'open');
        } else if (responseJson.error === 'permissionless_user') {
          _this2.handleAlert(_this2.locale.Usuarios.Login.usuarioSemPermissoes, 'error', 'open');
        } else if (responseJson.error === 'invalid_credentials' || responseJson.error === 'invalid_request' || responseJson.data.token === '{"error":"invalid_credentials","message":"The user credentials were incorrect."}') {
          _this2.handleAlert(_this2.locale.Usuarios.Login.usuarioOuSenhaInvalidos, 'error', 'open');
        } else {
          var now = new Date();
          var now_date = now.toISOString().slice(0, 10);
          var now_hr = now.toISOString().slice(11, 19);
          var now = now_date + ' ' + now_hr;
          var token = JSON.parse(responseJson.data.token);
          var storage = {
            rcode: token.refresh_token,
            acode: token.access_token,
            system: 'sigrfms',
            last_update: now
          };
          localStorage.setItem("cid", JSON.stringify(storage));
          var data = {
            email: _this2.state.username
          };
          localStorage.setItem("data", JSON.stringify(data));
          var url = responseJson.data.redirect.frms;
          if (url === null) {
            url = '/';
          }
          _this2.setState({ redirect_url: url });
        }
      }).catch(function (error) {
        console.error(error);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'user-wrapper visible-xs-block visible-sm-block visible-md-block', style: { backgroundImage: "url('" + __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + "/images/modal_background.png')" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'user-wrapper', style: { backgroundImage: "url('" + __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + "/images/modal_background.png')" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'user-layer' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'container' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-4 col-md-offset-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'user-content text-center' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/images/logo2.png', alt: 'PORTAL' }),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        { className: 'bg-primary' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-id-badge' }),
                        ' ',
                        this.locale.Usuarios.Login.paragrafoPortalDeColaboradores
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'form',
                        { onSubmit: this.login, autoComplete: 'off' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'form-group' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'input-group' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { className: 'input-group-addon' },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-at' })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autoComplete: 'off', type: 'text', name: 'username', className: 'form-control', placeholder: this.locale.Usuarios.Login.formulario.placeholder.SeuEmail, value: this.state.username, onChange: this.handleChange.bind(this, 'username') })
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'form-group' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'input-group' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { className: 'input-group-addon' },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-lock' })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { autoComplete: 'off', type: 'password', name: 'password', className: 'form-control', placeholder: this.locale.Usuarios.Login.formulario.placeholder.SuaSenha, value: this.state.password, onChange: this.handleChange.bind(this, 'password') })
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('development') && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'p',
                          { className: 'bg-danger' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa fa-warning' }),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { style: { color: 'red' } },
                            ' ',
                            this.locale.Usuarios.Login.formulario.paragrafoAtencao,
                            ' '
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa fa-warning' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'button',
                          { className: 'btn btn-success btn-block', type: 'submit' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-sign-in' }),
                          ' ',
                          this.locale.Usuarios.Login.formulario.botaoAcessarOSistema
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'col-md-5' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            { className: 'versao-login' },
                            'v1.1.5 - 22/08/2019'
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'col-md-7' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            { className: 'text-right' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
                              { to: '/usuario/recuperar_senha', className: 'link-recuperar-senha' },
                              this.locale.Usuarios.Login.paragrafoEsqueciMinhaSenha
                            )
                          )
                        )
                      ),
                      this.state.forget_password ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'label label-danger' },
                        this.locale.Usuarios.Login.paragrafoEntreEmContato
                      ) : ''
                    )
                  )
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'user-wrapper hidden-xs hidden-sm hidden-md', style: { backgroundImage: "url('" + __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + "/images/modal_background.png'), url('" + __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + "/images/fundo-login.jpg')" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'user-wrapper', style: { backgroundImage: "url('" + __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + "/images/modal_background.png'), url('" + __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + "/images/fundo-login.jpg')" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'user-layer' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'container' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-4 col-md-offset-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'user-content text-center' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/images/logo2.png', alt: 'PORTAL' }),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        { className: 'bg-primary' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-id-badge' }),
                        ' ',
                        this.locale.Usuarios.Login.paragrafoPortalDeColaboradores
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'form',
                        { onSubmit: this.login, autoComplete: 'off' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'form-group' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'input-group' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { className: 'input-group-addon' },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-at' })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'username', className: 'form-control', placeholder: this.locale.Usuarios.Login.formulario.placeholder.SeuEmail, autoComplete: 'off', value: this.state.username, onChange: this.handleChange.bind(this, 'username') })
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'form-group' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'input-group' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { className: 'input-group-addon' },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-lock' })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'password', name: 'password', className: 'form-control', placeholder: this.locale.Usuarios.Login.formulario.placeholder.SuaSenha, autoComplete: 'off', value: this.state.password, onChange: this.handleChange.bind(this, 'password') })
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('development') && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'p',
                          { className: 'bg-danger' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa fa-warning' }),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { style: { color: 'red' } },
                            ' ',
                            this.locale.Usuarios.Login.formulario.paragrafoAtencao,
                            ' '
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa fa-warning' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'button',
                          { className: 'btn btn-success btn-block', type: 'submit' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-sign-in' }),
                          ' ',
                          this.locale.Usuarios.Login.formulario.botaoAcessarOSistema
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'col-md-5' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            { className: 'versao-login' },
                            'v1.1.5 - 22/08/2019'
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'col-md-7' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'p',
                            { className: 'text-right' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
                              { to: '/usuario/recuperar_senha', className: 'link-recuperar-senha' },
                              this.locale.Usuarios.Login.paragrafoEsqueciMinhaSenha
                            )
                          )
                        )
                      ),
                      this.state.forget_password ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'label label-danger' },
                        this.locale.Usuarios.Login.paragrafoEntreEmContato
                      ) : ''
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Login;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Login);

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Importação do Router





var RecuperarSenha = function (_Component) {
  _inherits(RecuperarSenha, _Component);

  _createClass(RecuperarSenha, [{
    key: 'handleChange',

    // Handlers de form
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }]);

  function RecuperarSenha(props) {
    _classCallCheck(this, RecuperarSenha);

    var _this = _possibleConstructorReturn(this, (RecuperarSenha.__proto__ || Object.getPrototypeOf(RecuperarSenha)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      email: ''
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.recuperar_senha = _this.recuperar_senha.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(RecuperarSenha, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'recuperar_senha',
    value: function recuperar_senha(event) {
      var self = this;
      event.preventDefault();
      var headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      };
      var datasave = {
        email: this.state.email
      };
      this.handleAlert('', '', 'open');
      fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/usuario/recuperar-senha', { method: 'POST', mode: 'cors', headers: headers, body: JSON.stringify(datasave) }).then(function (response) {
        return response.json();
      }).catch(function (error) {
        console.error(error);
      }).then(function (responseJson) {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/usuario/login';
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({ redirect_url: url });
        } else {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }
      }).catch(function (error) {
        console.error(error);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'user-wrapper hidden-xs hidden-sm hidden-md', style: { backgroundImage: "url('" + __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + "/images/modal_background.png'), url('" + __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + "/images/fundo-login.jpg')" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'user-wrapper', style: { backgroundImage: "url('" + __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + "/images/modal_background.png'), url('" + __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + "/images/fundo-login.jpg')" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'user-layer' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'container' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-4 col-md-offset-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'user-content text-center' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/images/logo_frms2.png', alt: 'PORTAL' }),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'form',
                        { onSubmit: this.recuperar_senha },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'row' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-md-10 col-md-offset-1 form-group' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { className: 'input-group' },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'input-group-addon' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-at' })
                              ),
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'email', name: 'email', className: 'form-control', placeholder: this.locale.Usuarios.RecuperarSenha.formulario.placeholder.SeuEmail, value: this.state.email, onChange: this.handleChange.bind(this, 'email') })
                            )
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'row' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-md-10 col-md-offset-1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'button',
                              { className: 'btn btn-success btn-block btn-lg', type: 'submit' },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-lock' }),
                              ' ',
                              this.locale.Usuarios.RecuperarSenha.formulario.botaoRecuperarSenha
                            )
                          )
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        { className: 'text-right' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
                          { to: '/usuario/login', className: 'link-recuperar-senha' },
                          this.locale.Usuarios.RecuperarSenha.paragrafoVoltarParaLogin
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'user-wrapper visible-xs-block visible-sm-block visible-md-block', style: { backgroundImage: "url('" + __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + "/images/modal_background.png')" } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'user-wrapper', style: { backgroundImage: "url('" + __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + "/images/modal_background.png')" } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'user-layer' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'container-liquid' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-4 col-md-offset-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'user-content text-center' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/images/logo_frms2.png', alt: 'PORTAL' }),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'form',
                        { onSubmit: this.recuperar_senha },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'row' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-md-10 col-md-offset-1 form-group' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'div',
                              { className: 'input-group' },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'input-group-addon' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-at' })
                              ),
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'email', name: 'email', className: 'form-control', placeholder: this.locale.Usuarios.RecuperarSenha.formulario.placeholder.SeuEmail, value: this.state.email, onChange: this.handleChange.bind(this, 'email') })
                            )
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'row' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-md-10 col-md-offset-1' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'button',
                              { className: 'btn btn-success btn-block btn-lg', type: 'submit' },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-lock' }),
                              ' ',
                              this.locale.Usuarios.RecuperarSenha.formulario.botaoRecuperarSenha
                            )
                          )
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'p',
                        { className: 'text-right' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
                          { to: '/usuario/login', className: 'link-recuperar-senha' },
                          this.locale.Usuarios.RecuperarSenha.paragrafoVoltarParaLogin
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return RecuperarSenha;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (RecuperarSenha);

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// Importação do Router

// Importação da tabela





var Suspenso = function (_Component) {
  _inherits(Suspenso, _Component);

  function Suspenso(props) {
    _classCallCheck(this, Suspenso);

    var _this = _possibleConstructorReturn(this, (Suspenso.__proto__ || Object.getPrototypeOf(Suspenso)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      suspended_message: '0',
      prediction: '0'
    };
    // Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);

    _this.loadData = _this.loadData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  _createClass(Suspenso, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.loadData();
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var _this2 = this;

      var headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      };
      this.handleAlert('', '', 'open');
      fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/get/suspended_info', { method: 'GET', mode: 'cors', headers: headers }).then(function (response) {
        return response.json();
      }).catch(function (error) {
        console.error(error);
      }).then(function (responseJson) {
        _this2.setState({ suspended_message: responseJson.data.suspended_message, prediction: responseJson.data.prediction });
        _this2.handleAlert('', '', 'closed');
      }).catch(function (error) {
        console.error(error);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'user-wrapper', style: { backgroundImage: "url('" + __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + "/images/modal_background.png'), url('" + __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + "/images/fundo-login.jpg')" } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'user-layer-suspended' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'container-liquid' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-4 col-md-offset-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'user-content text-center' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/images/logo2.png', alt: 'SIGTREIN' }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h3',
                    null,
                    this.locale.Usuarios.SistemaSuspensoParaManutencao.titulo
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h5',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'strong',
                      null,
                      this.locale.Usuarios.SistemaSuspensoParaManutencao.tituloAtualizacao,
                      ':'
                    ),
                    ' ',
                    this.state.suspended_message
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'em',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'strong',
                        null,
                        this.locale.Usuarios.SistemaSuspensoParaManutencao.paragrafoPrevisaoDeVolta,
                        ':'
                      ),
                      ' ',
                      this.state.prediction
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Link */],
                      { className: 'btn btn-success', to: '/usuario/login' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-refresh' }),
                      ' ',
                      this.locale.general.recarregar
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Suspenso;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Suspenso);

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(992), __esModule: true };

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(994), __esModule: true };

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(155);
var document = __webpack_require__(82).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(113) && !__webpack_require__(154)(function () {
  return Object.defineProperty(__webpack_require__(440)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(274);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(278);
var $export = __webpack_require__(81);
var redefine = __webpack_require__(448);
var hide = __webpack_require__(114);
var has = __webpack_require__(94);
var Iterators = __webpack_require__(156);
var $iterCreate = __webpack_require__(1009);
var setToStringTag = __webpack_require__(281);
var getPrototypeOf = __webpack_require__(1016);
var ITERATOR = __webpack_require__(61)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(158);
var createDesc = __webpack_require__(159);
var toIObject = __webpack_require__(96);
var toPrimitive = __webpack_require__(286);
var has = __webpack_require__(94);
var IE8_DOM_DEFINE = __webpack_require__(441);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(113) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(446);
var hiddenKeys = __webpack_require__(277).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(94);
var toIObject = __webpack_require__(96);
var arrayIndexOf = __webpack_require__(1001)(false);
var IE_PROTO = __webpack_require__(282)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(157);
var toIObject = __webpack_require__(96);
var isEnum = __webpack_require__(158).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(114);


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(284);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(1018)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(443)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(22);

var emptyObject = __webpack_require__(70);
var _invariant = __webpack_require__(17);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isInherited = name in Constructor;
      _invariant(
        !isInherited,
        'ReactClass: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be ' +
          'due to a mixin.',
        name
      );
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(451);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
var array = Array.prototype;

var slice = array.slice;
var map = array.map;


/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bisectRight */
/* unused harmony export bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisector__ = __webpack_require__(455);



var ascendingBisect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__bisector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
/* harmony default export */ __webpack_exports__["a"] = (bisectRight);


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(115);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
});

function ascendingComparator(f) {
  return function(d, x) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(f(d), x);
  };
}


/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__variance__ = __webpack_require__(464);


/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  var v = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__variance__["a" /* default */])(array, f);
  return v ? Math.sqrt(v) : v;
});


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
});


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
});


/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pair;
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
});

function pair(a, b) {
  return [a, b];
}


/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
});


/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
});


/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = tickIncrement;
/* harmony export (immutable) */ __webpack_exports__["a"] = tickStep;
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ __webpack_exports__["b"] = (function(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
});

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}


/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min__ = __webpack_require__(458);


/* harmony default export */ __webpack_exports__["a"] = (function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__min__["a" /* default */])(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
});

function length(d) {
  return d.length;
}


/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(160);


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
});


/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deg2rad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rad2deg; });
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;


/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return prefixExponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__ = __webpack_require__(188);


var prefixExponent;

/* harmony default export */ __webpack_exports__["b"] = (function(x, p) {
  var d = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["a" /* formatDecimalParts */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["a" /* formatDecimalParts */])(x, Math.max(0, p + i - 1))[0]; // less than 1y!
});


/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatSpecifier;
/* unused harmony export FormatSpecifier */
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
  this.align = specifier.align === undefined ? ">" : specifier.align + "";
  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === undefined ? undefined : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === undefined ? "" : specifier.type + "";
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width === undefined ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0))
      + (this.trim ? "~" : "")
      + this.type;
};


/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__ = __webpack_require__(1063);
/* unused harmony reexport formatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale_js__ = __webpack_require__(469);
/* unused harmony reexport formatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatSpecifier_js__ = __webpack_require__(467);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__formatSpecifier_js__["a"]; });
/* unused harmony reexport FormatSpecifier */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__precisionFixed_js__ = __webpack_require__(1070);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_3__precisionFixed_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__precisionPrefix_js__ = __webpack_require__(1071);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__precisionPrefix_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__precisionRound_js__ = __webpack_require__(1072);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__precisionRound_js__["a"]; });








/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent_js__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatGroup_js__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatNumerals_js__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatSpecifier_js__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatTrim_js__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatTypes_js__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__formatPrefixAuto_js__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__identity_js__ = __webpack_require__(1069);









var map = Array.prototype.map,
    prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

/* harmony default export */ __webpack_exports__["a"] = (function(locale) {
  var group = locale.grouping === undefined || locale.thousands === undefined ? __WEBPACK_IMPORTED_MODULE_7__identity_js__["a" /* default */] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__formatGroup_js__["a" /* default */])(map.call(locale.grouping, Number), locale.thousands + ""),
      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
      numerals = locale.numerals === undefined ? __WEBPACK_IMPORTED_MODULE_7__identity_js__["a" /* default */] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__formatNumerals_js__["a" /* default */])(map.call(locale.numerals, String)),
      percent = locale.percent === undefined ? "%" : locale.percent + "",
      minus = locale.minus === undefined ? "-" : locale.minus + "",
      nan = locale.nan === undefined ? "NaN" : locale.nan + "";

  function newFormat(specifier) {
    specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier_js__["a" /* default */])(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        trim = specifier.trim,
        type = specifier.type;

    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";

    // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!__WEBPACK_IMPORTED_MODULE_5__formatTypes_js__["a" /* default */][type]) precision === undefined && (precision = 12), trim = true, type = "g";

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = __WEBPACK_IMPORTED_MODULE_5__formatTypes_js__["a" /* default */][type],
        maybeSuffix = /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision === undefined ? 6
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
        var valueNegative = value < 0 || 1 / value < 0;

        // Perform the initial formatting.
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);

        // Trim insignificant zeros.
        if (trim) value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__formatTrim_js__["a" /* default */])(value);

        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : minus) : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + __WEBPACK_IMPORTED_MODULE_6__formatPrefixAuto_js__["a" /* prefixExponent */] / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier_js__["a" /* default */])(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
});


/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = genericArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value_js__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__numberArray_js__ = __webpack_require__(294);



/* unused harmony default export */ var _unused_webpack_default_export = (function(a, b) {
  return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__numberArray_js__["a" /* isNumberArray */])(b) ? __WEBPACK_IMPORTED_MODULE_1__numberArray_js__["b" /* default */] : genericArray)(a, b);
});

function genericArray(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__value_js__["a" /* default */])(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
}


/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis_js__ = __webpack_require__(293);


/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__basis_js__["b" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var d = new Date;
  return a = +a, b = +b, function(t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
});


/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value_js__ = __webpack_require__(295);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__value_js__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});


/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export rgbBasis */
/* unused harmony export rgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis_js__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed_js__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color_js__ = __webpack_require__(117);





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__color_js__["c" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* rgb */])(start)).r, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* rgb */])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__color_js__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* rgb */])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis_js__["a" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed_js__["a" /* default */]);


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number_js__ = __webpack_require__(189);


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__band__ = __webpack_require__(1088);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleBand", function() { return __WEBPACK_IMPORTED_MODULE_0__band__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scalePoint", function() { return __WEBPACK_IMPORTED_MODULE_0__band__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity__ = __webpack_require__(1091);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleIdentity", function() { return __WEBPACK_IMPORTED_MODULE_1__identity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(98);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleLinear", function() { return __WEBPACK_IMPORTED_MODULE_2__linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__log__ = __webpack_require__(296);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleLog", function() { return __WEBPACK_IMPORTED_MODULE_3__log__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__symlog__ = __webpack_require__(298);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSymlog", function() { return __WEBPACK_IMPORTED_MODULE_4__symlog__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ordinal__ = __webpack_require__(480);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleOrdinal", function() { return __WEBPACK_IMPORTED_MODULE_5__ordinal__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleImplicit", function() { return __WEBPACK_IMPORTED_MODULE_5__ordinal__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pow__ = __webpack_require__(297);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scalePow", function() { return __WEBPACK_IMPORTED_MODULE_6__pow__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSqrt", function() { return __WEBPACK_IMPORTED_MODULE_6__pow__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__quantile__ = __webpack_require__(1092);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleQuantile", function() { return __WEBPACK_IMPORTED_MODULE_7__quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__quantize__ = __webpack_require__(1093);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleQuantize", function() { return __WEBPACK_IMPORTED_MODULE_8__quantize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__threshold__ = __webpack_require__(1095);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleThreshold", function() { return __WEBPACK_IMPORTED_MODULE_9__threshold__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__time__ = __webpack_require__(483);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleTime", function() { return __WEBPACK_IMPORTED_MODULE_10__time__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utcTime__ = __webpack_require__(1096);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleUtc", function() { return __WEBPACK_IMPORTED_MODULE_11__utcTime__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__sequential__ = __webpack_require__(481);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSequential", function() { return __WEBPACK_IMPORTED_MODULE_12__sequential__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSequentialLog", function() { return __WEBPACK_IMPORTED_MODULE_12__sequential__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSequentialPow", function() { return __WEBPACK_IMPORTED_MODULE_12__sequential__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSequentialSqrt", function() { return __WEBPACK_IMPORTED_MODULE_12__sequential__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSequentialSymlog", function() { return __WEBPACK_IMPORTED_MODULE_12__sequential__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__sequentialQuantile__ = __webpack_require__(1094);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleSequentialQuantile", function() { return __WEBPACK_IMPORTED_MODULE_13__sequentialQuantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__diverging__ = __webpack_require__(1090);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleDiverging", function() { return __WEBPACK_IMPORTED_MODULE_14__diverging__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleDivergingLog", function() { return __WEBPACK_IMPORTED_MODULE_14__diverging__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleDivergingPow", function() { return __WEBPACK_IMPORTED_MODULE_14__diverging__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleDivergingSqrt", function() { return __WEBPACK_IMPORTED_MODULE_14__diverging__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "scaleDivergingSymlog", function() { return __WEBPACK_IMPORTED_MODULE_14__diverging__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__tickFormat__ = __webpack_require__(482);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "tickFormat", function() { return __WEBPACK_IMPORTED_MODULE_15__tickFormat__["a"]; });

































/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
});


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return +x;
});


/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return implicit; });
/* harmony export (immutable) */ __webpack_exports__["a"] = ordinal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init__ = __webpack_require__(45);




var implicit = {name: "implicit"};

function ordinal() {
  var index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])(),
      domain = [],
      range = [],
      unknown = implicit;

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal(domain, range).unknown(unknown);
  };

  __WEBPACK_IMPORTED_MODULE_2__init__["b" /* initRange */].apply(scale, arguments);

  return scale;
}


/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = copy;
/* harmony export (immutable) */ __webpack_exports__["a"] = sequential;
/* harmony export (immutable) */ __webpack_exports__["b"] = sequentialLog;
/* harmony export (immutable) */ __webpack_exports__["e"] = sequentialSymlog;
/* harmony export (immutable) */ __webpack_exports__["c"] = sequentialPow;
/* harmony export (immutable) */ __webpack_exports__["d"] = sequentialSqrt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__continuous__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__init__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__log__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__symlog__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pow__ = __webpack_require__(297);







function transformer() {
  var x0 = 0,
      x1 = 1,
      t0,
      t1,
      k10,
      transform,
      interpolator = __WEBPACK_IMPORTED_MODULE_0__continuous__["a" /* identity */],
      clamp = false,
      unknown;

  function scale(x) {
    return isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
  }

  scale.domain = function(_) {
    return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function(t) {
    transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
    return scale;
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .interpolator(source.interpolator())
      .clamp(source.clamp())
      .unknown(source.unknown());
}

function sequential() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__linear__["b" /* linearish */])(transformer()(__WEBPACK_IMPORTED_MODULE_0__continuous__["a" /* identity */]));

  scale.copy = function() {
    return copy(scale, sequential());
  };

  return __WEBPACK_IMPORTED_MODULE_1__init__["a" /* initInterpolator */].apply(scale, arguments);
}

function sequentialLog() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__log__["b" /* loggish */])(transformer()).domain([1, 10]);

  scale.copy = function() {
    return copy(scale, sequentialLog()).base(scale.base());
  };

  return __WEBPACK_IMPORTED_MODULE_1__init__["a" /* initInterpolator */].apply(scale, arguments);
}

function sequentialSymlog() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__symlog__["b" /* symlogish */])(transformer());

  scale.copy = function() {
    return copy(scale, sequentialSymlog()).constant(scale.constant());
  };

  return __WEBPACK_IMPORTED_MODULE_1__init__["a" /* initInterpolator */].apply(scale, arguments);
}

function sequentialPow() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__pow__["c" /* powish */])(transformer());

  scale.copy = function() {
    return copy(scale, sequentialPow()).exponent(scale.exponent());
  };

  return __WEBPACK_IMPORTED_MODULE_1__init__["a" /* initInterpolator */].apply(scale, arguments);
}

function sequentialSqrt() {
  return sequentialPow.apply(null, arguments).exponent(0.5);
}


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(468);



/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, count, specifier) {
  var step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* tickStep */])(start, stop, count),
      precision;
  specifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* formatSpecifier */])(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["b" /* precisionPrefix */])(step, value))) specifier.precision = precision;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["c" /* formatPrefix */])(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["d" /* precisionRound */])(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["e" /* precisionFixed */])(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* format */])(specifier);
});


/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = calendar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time_format__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__array__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__continuous__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__init__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nice__ = __webpack_require__(478);








var durationSecond = 1000,
    durationMinute = durationSecond * 60,
    durationHour = durationMinute * 60,
    durationDay = durationHour * 24,
    durationWeek = durationDay * 7,
    durationMonth = durationDay * 30,
    durationYear = durationDay * 365;

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__continuous__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_4__continuous__["a" /* identity */], __WEBPACK_IMPORTED_MODULE_4__continuous__["a" /* identity */]),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second,  1,      durationSecond],
    [second,  5,  5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* bisector */])(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* tickStep */])(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = Math.max(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* tickStep */])(start, stop, interval), 1);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(__WEBPACK_IMPORTED_MODULE_3__array__["a" /* map */].call(_, number)) : domain().map(date);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__nice__["a" /* default */])(d, interval))
        : scale;
  };

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__continuous__["c" /* copy */])(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  return __WEBPACK_IMPORTED_MODULE_5__init__["b" /* initRange */].apply(calendar(__WEBPACK_IMPORTED_MODULE_1_d3_time__["l" /* timeYear */], __WEBPACK_IMPORTED_MODULE_1_d3_time__["q" /* timeMonth */], __WEBPACK_IMPORTED_MODULE_1_d3_time__["r" /* timeWeek */], __WEBPACK_IMPORTED_MODULE_1_d3_time__["k" /* timeDay */], __WEBPACK_IMPORTED_MODULE_1_d3_time__["s" /* timeHour */], __WEBPACK_IMPORTED_MODULE_1_d3_time__["t" /* timeMinute */], __WEBPACK_IMPORTED_MODULE_1_d3_time__["u" /* timeSecond */], __WEBPACK_IMPORTED_MODULE_1_d3_time__["v" /* timeMillisecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time_format__["b" /* timeFormat */]).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]), arguments);
});


/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear_js__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__line_js__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__point_js__ = __webpack_require__(303);






/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x0 = __WEBPACK_IMPORTED_MODULE_4__point_js__["a" /* x */],
      x1 = null,
      y0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(0),
      y1 = __WEBPACK_IMPORTED_MODULE_4__point_js__["b" /* y */],
      defined = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear_js__["a" /* default */],
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__line_js__["a" /* default */])().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
});


/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalClosed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop_js__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal_js__ = __webpack_require__(191);



function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop_js__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop_js__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cardinal_js__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalOpen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinal_js__ = __webpack_require__(191);


function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cardinal_js__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return curveRadialLinear; });
/* harmony export (immutable) */ __webpack_exports__["a"] = curveRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear_js__ = __webpack_require__(192);


var curveRadialLinear = curveRadial(__WEBPACK_IMPORTED_MODULE_0__linear_js__["a" /* default */]);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}


/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lineRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial_js__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__line_js__ = __webpack_require__(301);



function lineRadial(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function(_) {
    return arguments.length ? c(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__curve_radial_js__["a" /* default */])(_)) : c()._curve;
  };

  return l;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return lineRadial(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__line_js__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial_js__["b" /* curveRadialLinear */]));
});


/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none_js__ = __webpack_require__(164);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var peaks = series.map(peak);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none_js__["a" /* default */])(series).sort(function(a, b) { return peaks[a] - peaks[b]; });
});

function peak(series) {
  var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
  while (++i < n) if ((vi = +series[i][1]) > vj) vj = vi, j = i;
  return j;
}


/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
});


/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(162);


/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / __WEBPACK_IMPORTED_MODULE_0__math_js__["b" /* pi */]);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, __WEBPACK_IMPORTED_MODULE_0__math_js__["c" /* tau */]);
  }
});


/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
});


/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tan30 = Math.sqrt(1 / 3),
    tan30_2 = tan30 * 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
});


/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
});


/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(162);


var ka = 0.89081309152928522810,
    kr = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math_js__["b" /* pi */] / 10) / Math.sin(7 * __WEBPACK_IMPORTED_MODULE_0__math_js__["b" /* pi */] / 10),
    kx = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math_js__["c" /* tau */] / 10) * kr,
    ky = -Math.cos(__WEBPACK_IMPORTED_MODULE_0__math_js__["c" /* tau */] / 10) * kr;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = __WEBPACK_IMPORTED_MODULE_0__math_js__["c" /* tau */] * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
});


/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var sqrt3 = Math.sqrt(3);

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
});


/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var c = -0.5,
    s = Math.sqrt(3) / 2,
    k = 1 / Math.sqrt(12),
    a = (k / 2 + 1) * 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / a),
        x0 = r / 2,
        y0 = r * k,
        x1 = x0,
        y1 = r * k + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
    context.closePath();
  }
});


/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__ = __webpack_require__(304);
/* unused harmony reexport timeFormatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__["c"]; });
/* unused harmony reexport timeParse */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__["a"]; });
/* unused harmony reexport utcParse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale_js__ = __webpack_require__(501);
/* unused harmony reexport timeFormatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isoFormat_js__ = __webpack_require__(500);
/* unused harmony reexport isoFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isoParse_js__ = __webpack_require__(1121);
/* unused harmony reexport isoParse */






/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isoSpecifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__ = __webpack_require__(304);


var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__defaultLocale_js__["a" /* utcFormat */])(isoSpecifier);

/* unused harmony default export */ var _unused_webpack_default_export = (formatIso);


/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time__ = __webpack_require__(305);


function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newDate(y, m, d) {
  return {y: y, m: m, d: d, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "g": formatYearISO,
    "G": formatFullYearISO,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "g": formatUTCYearISO,
    "G": formatUTCFullYearISO,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "g": parseYear,
    "G": parseFullYear,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "q": parseQuarter,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, Z) {
    return function(string) {
      var d = newDate(1900, undefined, 1),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);
      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));

      // If this is utcParse, never use the local timezone.
      if (Z && !("Z" in d)) d.Z = 0;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // If the month was not specified, inherit from the quarter.
      if (d.m === undefined) d.m = "q" in d ? d.q : 0;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* utcMonday */].ceil(week) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* utcMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["d" /* utcDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* timeMonday */].ceil(week) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* timeMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return localDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatQuarter(d) {
    return 1 + ~~(d.getMonth() / 3);
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  function formatUTCQuarter(d) {
    return 1 + ~~(d.getUTCMonth() / 3);
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", false);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier += "", true);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseQuarter(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.s = +n[0], i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeDay */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* timeYear */])(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["m" /* timeSunday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* timeYear */])(d) - 1, d), p, 2);
}

function dISO(d) {
  var day = d.getDay();
  return (day >= 4 || day === 0) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["n" /* timeThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["n" /* timeThursday */].ceil(d);
}

function formatWeekNumberISO(d, p) {
  d = dISO(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["n" /* timeThursday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* timeYear */])(d), d) + (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* timeYear */])(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["j" /* timeMonday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* timeYear */])(d) - 1, d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatYearISO(d, p) {
  d = dISO(d);
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatFullYearISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["n" /* timeThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["n" /* timeThursday */].ceil(d);
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["d" /* utcDay */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcYear */])(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["o" /* utcSunday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcYear */])(d) - 1, d), p, 2);
}

function UTCdISO(d) {
  var day = d.getUTCDay();
  return (day >= 4 || day === 0) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcThursday */].ceil(d);
}

function formatUTCWeekNumberISO(d, p) {
  d = UTCdISO(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcThursday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcYear */])(d), d) + (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcYear */])(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* utcMonday */].count(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* utcYear */])(d) - 1, d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCYearISO(d, p) {
  d = UTCdISO(d);
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCFullYearISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcThursday */].ceil(d);
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! decimal.js-light v2.5.1 https://github.com/MikeMcl/decimal.js-light/LICENCE */
;(function (globalScope) {
  'use strict';


  /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */


  // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //


    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
  var MAX_DIGITS = 1e9,                        // 0 to 1e9


    // The initial configuration properties of the Decimal constructor.
    Decimal = {

      // These values must be integers within the stated ranges (inclusive).
      // Most of these values can be changed during run-time using `Decimal.config`.

      // The maximum number of significant digits of the result of a calculation or base conversion.
      // E.g. `Decimal.config({ precision: 20 });`
      precision: 20,                         // 1 to MAX_DIGITS

      // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
      // `toFixed`, `toPrecision` and `toSignificantDigits`.
      //
      // ROUND_UP         0 Away from zero.
      // ROUND_DOWN       1 Towards zero.
      // ROUND_CEIL       2 Towards +Infinity.
      // ROUND_FLOOR      3 Towards -Infinity.
      // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
      // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
      // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
      // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
      // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
      //
      // E.g.
      // `Decimal.rounding = 4;`
      // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
      rounding: 4,                           // 0 to 8

      // The exponent value at and beneath which `toString` returns exponential notation.
      // JavaScript numbers: -7
      toExpNeg: -7,                          // 0 to -MAX_E

      // The exponent value at and above which `toString` returns exponential notation.
      // JavaScript numbers: 21
      toExpPos:  21,                         // 0 to MAX_E

      // The natural logarithm of 10.
      // 115 digits
      LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
    },


  // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //


    external = true,

    decimalError = '[DecimalError] ',
    invalidArgument = decimalError + 'Invalid argument: ',
    exponentOutOfRange = decimalError + 'Exponent out of range: ',

    mathfloor = Math.floor,
    mathpow = Math.pow,

    isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,

    ONE,
    BASE = 1e7,
    LOG_BASE = 7,
    MAX_SAFE_INTEGER = 9007199254740991,
    MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE),    // 1286742750677284

    // Decimal.prototype object
    P = {};


  // Decimal prototype methods


  /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */


  /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */
  P.absoluteValue = P.abs = function () {
    var x = new this.constructor(this);
    if (x.s) x.s = 1;
    return x;
  };


  /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */
  P.comparedTo = P.cmp = function (y) {
    var i, j, xdL, ydL,
      x = this;

    y = new x.constructor(y);

    // Signs differ?
    if (x.s !== y.s) return x.s || -y.s;

    // Compare exponents.
    if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;

    xdL = x.d.length;
    ydL = y.d.length;

    // Compare digit by digit.
    for (i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i) {
      if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
    }

    // Compare lengths.
    return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
  };


  /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */
  P.decimalPlaces = P.dp = function () {
    var x = this,
      w = x.d.length - 1,
      dp = (w - x.e) * LOG_BASE;

    // Subtract the number of trailing zeros of the last word.
    w = x.d[w];
    if (w) for (; w % 10 == 0; w /= 10) dp--;

    return dp < 0 ? 0 : dp;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */
  P.dividedBy = P.div = function (y) {
    return divide(this, new this.constructor(y));
  };


  /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */
  P.dividedToIntegerBy = P.idiv = function (y) {
    var x = this,
      Ctor = x.constructor;
    return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
  };


  /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */
  P.equals = P.eq = function (y) {
    return !this.cmp(y);
  };


  /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */
  P.exponent = function () {
    return getBase10Exponent(this);
  };


  /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */
  P.greaterThan = P.gt = function (y) {
    return this.cmp(y) > 0;
  };


  /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */
  P.greaterThanOrEqualTo = P.gte = function (y) {
    return this.cmp(y) >= 0;
  };


  /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */
  P.isInteger = P.isint = function () {
    return this.e > this.d.length - 2;
  };


  /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */
  P.isNegative = P.isneg = function () {
    return this.s < 0;
  };


  /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */
  P.isPositive = P.ispos = function () {
    return this.s > 0;
  };


  /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */
  P.isZero = function () {
    return this.s === 0;
  };


  /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */
  P.lessThan = P.lt = function (y) {
    return this.cmp(y) < 0;
  };


  /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */
  P.lessThanOrEqualTo = P.lte = function (y) {
    return this.cmp(y) < 1;
  };


  /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */
  P.logarithm = P.log = function (base) {
    var r,
      x = this,
      Ctor = x.constructor,
      pr = Ctor.precision,
      wpr = pr + 5;

    // Default base is 10.
    if (base === void 0) {
      base = new Ctor(10);
    } else {
      base = new Ctor(base);

      // log[-b](x) = NaN
      // log[0](x)  = NaN
      // log[1](x)  = NaN
      if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
    }

    // log[b](-x) = NaN
    // log[b](0) = -Infinity
    if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));

    // log[b](1) = 0
    if (x.eq(ONE)) return new Ctor(0);

    external = false;
    r = divide(ln(x, wpr), ln(base, wpr), wpr);
    external = true;

    return round(r, pr);
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */
  P.minus = P.sub = function (y) {
    var x = this;
    y = new x.constructor(y);
    return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */
  P.modulo = P.mod = function (y) {
    var q,
      x = this,
      Ctor = x.constructor,
      pr = Ctor.precision;

    y = new Ctor(y);

    // x % 0 = NaN
    if (!y.s) throw Error(decimalError + 'NaN');

    // Return x if x is 0.
    if (!x.s) return round(new Ctor(x), pr);

    // Prevent rounding of intermediate calculations.
    external = false;
    q = divide(x, y, 0, 1).times(y);
    external = true;

    return x.minus(q);
  };


  /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */
  P.naturalExponential = P.exp = function () {
    return exp(this);
  };


  /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */
  P.naturalLogarithm = P.ln = function () {
    return ln(this);
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */
  P.negated = P.neg = function () {
    var x = new this.constructor(this);
    x.s = -x.s || 0;
    return x;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */
  P.plus = P.add = function (y) {
    var x = this;
    y = new x.constructor(y);
    return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
  };


  /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */
  P.precision = P.sd = function (z) {
    var e, sd, w,
      x = this;

    if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);

    e = getBase10Exponent(x) + 1;
    w = x.d.length - 1;
    sd = w * LOG_BASE + 1;
    w = x.d[w];

    // If non-zero...
    if (w) {

      // Subtract the number of trailing zeros of the last word.
      for (; w % 10 == 0; w /= 10) sd--;

      // Add the number of digits of the first word.
      for (w = x.d[0]; w >= 10; w /= 10) sd++;
    }

    return z && e > sd ? e : sd;
  };


  /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */
  P.squareRoot = P.sqrt = function () {
    var e, n, pr, r, s, t, wpr,
      x = this,
      Ctor = x.constructor;

    // Negative or zero?
    if (x.s < 1) {
      if (!x.s) return new Ctor(0);

      // sqrt(-x) = NaN
      throw Error(decimalError + 'NaN');
    }

    e = getBase10Exponent(x);
    external = false;

    // Initial estimate.
    s = Math.sqrt(+x);

    // Math.sqrt underflow/overflow?
    // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
    if (s == 0 || s == 1 / 0) {
      n = digitsToString(x.d);
      if ((n.length + e) % 2 == 0) n += '0';
      s = Math.sqrt(n);
      e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);

      if (s == 1 / 0) {
        n = '5e' + e;
      } else {
        n = s.toExponential();
        n = n.slice(0, n.indexOf('e') + 1) + e;
      }

      r = new Ctor(n);
    } else {
      r = new Ctor(s.toString());
    }

    pr = Ctor.precision;
    s = wpr = pr + 3;

    // Newton-Raphson iteration.
    for (;;) {
      t = r;
      r = t.plus(divide(x, t, wpr + 2)).times(0.5);

      if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
        n = n.slice(wpr - 3, wpr + 1);

        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
        // 4999, i.e. approaching a rounding boundary, continue the iteration.
        if (s == wpr && n == '4999') {

          // On the first iteration only, check to see if rounding up gives the exact result as the
          // nines may infinitely repeat.
          round(t, pr + 1, 0);

          if (t.times(t).eq(x)) {
            r = t;
            break;
          }
        } else if (n != '9999') {
          break;
        }

        wpr += 4;
      }
    }

    external = true;

    return round(r, pr);
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */
  P.times = P.mul = function (y) {
    var carry, e, i, k, r, rL, t, xdL, ydL,
      x = this,
      Ctor = x.constructor,
      xd = x.d,
      yd = (y = new Ctor(y)).d;

    // Return 0 if either is 0.
    if (!x.s || !y.s) return new Ctor(0);

    y.s *= x.s;
    e = x.e + y.e;
    xdL = xd.length;
    ydL = yd.length;

    // Ensure xd points to the longer array.
    if (xdL < ydL) {
      r = xd;
      xd = yd;
      yd = r;
      rL = xdL;
      xdL = ydL;
      ydL = rL;
    }

    // Initialise the result array with zeros.
    r = [];
    rL = xdL + ydL;
    for (i = rL; i--;) r.push(0);

    // Multiply!
    for (i = ydL; --i >= 0;) {
      carry = 0;
      for (k = xdL + i; k > i;) {
        t = r[k] + yd[i] * xd[k - i - 1] + carry;
        r[k--] = t % BASE | 0;
        carry = t / BASE | 0;
      }

      r[k] = (r[k] + carry) % BASE | 0;
    }

    // Remove trailing zeros.
    for (; !r[--rL];) r.pop();

    if (carry) ++e;
    else r.shift();

    y.d = r;
    y.e = e;

    return external ? round(y, Ctor.precision) : y;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */
  P.toDecimalPlaces = P.todp = function (dp, rm) {
    var x = this,
      Ctor = x.constructor;

    x = new Ctor(x);
    if (dp === void 0) return x;

    checkInt32(dp, 0, MAX_DIGITS);

    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);

    return round(x, dp + getBase10Exponent(x) + 1, rm);
  };


  /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */
  P.toExponential = function (dp, rm) {
    var str,
      x = this,
      Ctor = x.constructor;

    if (dp === void 0) {
      str = toString(x, true);
    } else {
      checkInt32(dp, 0, MAX_DIGITS);

      if (rm === void 0) rm = Ctor.rounding;
      else checkInt32(rm, 0, 8);

      x = round(new Ctor(x), dp + 1, rm);
      str = toString(x, true, dp + 1);
    }

    return str;
  };


  /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */
  P.toFixed = function (dp, rm) {
    var str, y,
      x = this,
      Ctor = x.constructor;

    if (dp === void 0) return toString(x);

    checkInt32(dp, 0, MAX_DIGITS);

    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);

    y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
    str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);

    // To determine whether to add the minus sign look at the value before it was rounded,
    // i.e. look at `x` rather than `y`.
    return x.isneg() && !x.isZero() ? '-' + str : str;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */
  P.toInteger = P.toint = function () {
    var x = this,
      Ctor = x.constructor;
    return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
  };


  /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */
  P.toNumber = function () {
    return +this;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */
  P.toPower = P.pow = function (y) {
    var e, k, pr, r, sign, yIsInt,
      x = this,
      Ctor = x.constructor,
      guard = 12,
      yn = +(y = new Ctor(y));

    // pow(x, 0) = 1
    if (!y.s) return new Ctor(ONE);

    x = new Ctor(x);

    // pow(0, y > 0) = 0
    // pow(0, y < 0) = Infinity
    if (!x.s) {
      if (y.s < 1) throw Error(decimalError + 'Infinity');
      return x;
    }

    // pow(1, y) = 1
    if (x.eq(ONE)) return x;

    pr = Ctor.precision;

    // pow(x, 1) = x
    if (y.eq(ONE)) return round(x, pr);

    e = y.e;
    k = y.d.length - 1;
    yIsInt = e >= k;
    sign = x.s;

    if (!yIsInt) {

      // pow(x < 0, y non-integer) = NaN
      if (sign < 0) throw Error(decimalError + 'NaN');

    // If y is a small integer use the 'exponentiation by squaring' algorithm.
    } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
      r = new Ctor(ONE);

      // Max k of 9007199254740991 takes 53 loop iterations.
      // Maximum digits array length; leaves [28, 34] guard digits.
      e = Math.ceil(pr / LOG_BASE + 4);

      external = false;

      for (;;) {
        if (k % 2) {
          r = r.times(x);
          truncate(r.d, e);
        }

        k = mathfloor(k / 2);
        if (k === 0) break;

        x = x.times(x);
        truncate(x.d, e);
      }

      external = true;

      return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
    }

    // Result is negative if x is negative and the last digit of integer y is odd.
    sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;

    x.s = 1;
    external = false;
    r = y.times(ln(x, pr + guard));
    external = true;
    r = exp(r);
    r.s = sign;

    return r;
  };


  /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */
  P.toPrecision = function (sd, rm) {
    var e, str,
      x = this,
      Ctor = x.constructor;

    if (sd === void 0) {
      e = getBase10Exponent(x);
      str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    } else {
      checkInt32(sd, 1, MAX_DIGITS);

      if (rm === void 0) rm = Ctor.rounding;
      else checkInt32(rm, 0, 8);

      x = round(new Ctor(x), sd, rm);
      e = getBase10Exponent(x);
      str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
    }

    return str;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */
  P.toSignificantDigits = P.tosd = function (sd, rm) {
    var x = this,
      Ctor = x.constructor;

    if (sd === void 0) {
      sd = Ctor.precision;
      rm = Ctor.rounding;
    } else {
      checkInt32(sd, 1, MAX_DIGITS);

      if (rm === void 0) rm = Ctor.rounding;
      else checkInt32(rm, 0, 8);
    }

    return round(new Ctor(x), sd, rm);
  };


  /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */
  P.toString = P.valueOf = P.val = P.toJSON = function () {
    var x = this,
      e = getBase10Exponent(x),
      Ctor = x.constructor;

    return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
  };


  // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.


  /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */


  function add(x, y) {
    var carry, d, e, i, k, len, xd, yd,
      Ctor = x.constructor,
      pr = Ctor.precision;

    // If either is zero...
    if (!x.s || !y.s) {

      // Return x if y is zero.
      // Return y if y is non-zero.
      if (!y.s) y = new Ctor(x);
      return external ? round(y, pr) : y;
    }

    xd = x.d;
    yd = y.d;

    // x and y are finite, non-zero numbers with the same sign.

    k = x.e;
    e = y.e;
    xd = xd.slice();
    i = k - e;

    // If base 1e7 exponents differ...
    if (i) {
      if (i < 0) {
        d = xd;
        i = -i;
        len = yd.length;
      } else {
        d = yd;
        e = k;
        len = xd.length;
      }

      // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
      k = Math.ceil(pr / LOG_BASE);
      len = k > len ? k + 1 : len + 1;

      if (i > len) {
        i = len;
        d.length = 1;
      }

      // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
      d.reverse();
      for (; i--;) d.push(0);
      d.reverse();
    }

    len = xd.length;
    i = yd.length;

    // If yd is longer than xd, swap xd and yd so xd points to the longer array.
    if (len - i < 0) {
      i = len;
      d = yd;
      yd = xd;
      xd = d;
    }

    // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
    for (carry = 0; i;) {
      carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
      xd[i] %= BASE;
    }

    if (carry) {
      xd.unshift(carry);
      ++e;
    }

    // Remove trailing zeros.
    // No need to check for zero, as +x + +y != 0 && -x + -y != 0
    for (len = xd.length; xd[--len] == 0;) xd.pop();

    y.d = xd;
    y.e = e;

    return external ? round(y, pr) : y;
  }


  function checkInt32(i, min, max) {
    if (i !== ~~i || i < min || i > max) {
      throw Error(invalidArgument + i);
    }
  }


  function digitsToString(d) {
    var i, k, ws,
      indexOfLastWord = d.length - 1,
      str = '',
      w = d[0];

    if (indexOfLastWord > 0) {
      str += w;
      for (i = 1; i < indexOfLastWord; i++) {
        ws = d[i] + '';
        k = LOG_BASE - ws.length;
        if (k) str += getZeroString(k);
        str += ws;
      }

      w = d[i];
      ws = w + '';
      k = LOG_BASE - ws.length;
      if (k) str += getZeroString(k);
    } else if (w === 0) {
      return '0';
    }

    // Remove trailing zeros of last w.
    for (; w % 10 === 0;) w /= 10;

    return str + w;
  }


  var divide = (function () {

    // Assumes non-zero x and k, and hence non-zero result.
    function multiplyInteger(x, k) {
      var temp,
        carry = 0,
        i = x.length;

      for (x = x.slice(); i--;) {
        temp = x[i] * k + carry;
        x[i] = temp % BASE | 0;
        carry = temp / BASE | 0;
      }

      if (carry) x.unshift(carry);

      return x;
    }

    function compare(a, b, aL, bL) {
      var i, r;

      if (aL != bL) {
        r = aL > bL ? 1 : -1;
      } else {
        for (i = r = 0; i < aL; i++) {
          if (a[i] != b[i]) {
            r = a[i] > b[i] ? 1 : -1;
            break;
          }
        }
      }

      return r;
    }

    function subtract(a, b, aL) {
      var i = 0;

      // Subtract b from a.
      for (; aL--;) {
        a[aL] -= i;
        i = a[aL] < b[aL] ? 1 : 0;
        a[aL] = i * BASE + a[aL] - b[aL];
      }

      // Remove leading zeros.
      for (; !a[0] && a.length > 1;) a.shift();
    }

    return function (x, y, pr, dp) {
      var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz,
        Ctor = x.constructor,
        sign = x.s == y.s ? 1 : -1,
        xd = x.d,
        yd = y.d;

      // Either 0?
      if (!x.s) return new Ctor(x);
      if (!y.s) throw Error(decimalError + 'Division by zero');

      e = x.e - y.e;
      yL = yd.length;
      xL = xd.length;
      q = new Ctor(sign);
      qd = q.d = [];

      // Result exponent may be one less than e.
      for (i = 0; yd[i] == (xd[i] || 0); ) ++i;
      if (yd[i] > (xd[i] || 0)) --e;

      if (pr == null) {
        sd = pr = Ctor.precision;
      } else if (dp) {
        sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
      } else {
        sd = pr;
      }

      if (sd < 0) return new Ctor(0);

      // Convert precision in number of base 10 digits to base 1e7 digits.
      sd = sd / LOG_BASE + 2 | 0;
      i = 0;

      // divisor < 1e7
      if (yL == 1) {
        k = 0;
        yd = yd[0];
        sd++;

        // k is the carry.
        for (; (i < xL || k) && sd--; i++) {
          t = k * BASE + (xd[i] || 0);
          qd[i] = t / yd | 0;
          k = t % yd | 0;
        }

      // divisor >= 1e7
      } else {

        // Normalise xd and yd so highest order digit of yd is >= BASE/2
        k = BASE / (yd[0] + 1) | 0;

        if (k > 1) {
          yd = multiplyInteger(yd, k);
          xd = multiplyInteger(xd, k);
          yL = yd.length;
          xL = xd.length;
        }

        xi = yL;
        rem = xd.slice(0, yL);
        remL = rem.length;

        // Add zeros to make remainder as long as divisor.
        for (; remL < yL;) rem[remL++] = 0;

        yz = yd.slice();
        yz.unshift(0);
        yd0 = yd[0];

        if (yd[1] >= BASE / 2) ++yd0;

        do {
          k = 0;

          // Compare divisor and remainder.
          cmp = compare(yd, rem, yL, remL);

          // If divisor < remainder.
          if (cmp < 0) {

            // Calculate trial digit, k.
            rem0 = rem[0];
            if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);

            // k will be how many times the divisor goes into the current remainder.
            k = rem0 / yd0 | 0;

            //  Algorithm:
            //  1. product = divisor * trial digit (k)
            //  2. if product > remainder: product -= divisor, k--
            //  3. remainder -= product
            //  4. if product was < remainder at 2:
            //    5. compare new remainder and divisor
            //    6. If remainder > divisor: remainder -= divisor, k++

            if (k > 1) {
              if (k >= BASE) k = BASE - 1;

              // product = divisor * trial digit.
              prod = multiplyInteger(yd, k);
              prodL = prod.length;
              remL = rem.length;

              // Compare product and remainder.
              cmp = compare(prod, rem, prodL, remL);

              // product > remainder.
              if (cmp == 1) {
                k--;

                // Subtract divisor from product.
                subtract(prod, yL < prodL ? yz : yd, prodL);
              }
            } else {

              // cmp is -1.
              // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
              // to avoid it. If k is 1 there is a need to compare yd and rem again below.
              if (k == 0) cmp = k = 1;
              prod = yd.slice();
            }

            prodL = prod.length;
            if (prodL < remL) prod.unshift(0);

            // Subtract product from remainder.
            subtract(rem, prod, remL);

            // If product was < previous remainder.
            if (cmp == -1) {
              remL = rem.length;

              // Compare divisor and new remainder.
              cmp = compare(yd, rem, yL, remL);

              // If divisor < new remainder, subtract divisor from remainder.
              if (cmp < 1) {
                k++;

                // Subtract divisor from remainder.
                subtract(rem, yL < remL ? yz : yd, remL);
              }
            }

            remL = rem.length;
          } else if (cmp === 0) {
            k++;
            rem = [0];
          }    // if cmp === 1, k will be 0

          // Add the next digit, k, to the result array.
          qd[i++] = k;

          // Update the remainder.
          if (cmp && rem[0]) {
            rem[remL++] = xd[xi] || 0;
          } else {
            rem = [xd[xi]];
            remL = 1;
          }

        } while ((xi++ < xL || rem[0] !== void 0) && sd--);
      }

      // Leading zero?
      if (!qd[0]) qd.shift();

      q.e = e;

      return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
    };
  })();


  /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */
  function exp(x, sd) {
    var denominator, guard, pow, sum, t, wpr,
      i = 0,
      k = 0,
      Ctor = x.constructor,
      pr = Ctor.precision;

    if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));

    // exp(0) = 1
    if (!x.s) return new Ctor(ONE);

    if (sd == null) {
      external = false;
      wpr = pr;
    } else {
      wpr = sd;
    }

    t = new Ctor(0.03125);

    while (x.abs().gte(0.1)) {
      x = x.times(t);    // x = x / 2^5
      k += 5;
    }

    // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
    guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
    wpr += guard;
    denominator = pow = sum = new Ctor(ONE);
    Ctor.precision = wpr;

    for (;;) {
      pow = round(pow.times(x), wpr);
      denominator = denominator.times(++i);
      t = sum.plus(divide(pow, denominator, wpr));

      if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
        while (k--) sum = round(sum.times(sum), wpr);
        Ctor.precision = pr;
        return sd == null ? (external = true, round(sum, pr)) : sum;
      }

      sum = t;
    }
  }


  // Calculate the base 10 exponent from the base 1e7 exponent.
  function getBase10Exponent(x) {
    var e = x.e * LOG_BASE,
      w = x.d[0];

    // Add the number of digits of the first word of the digits array.
    for (; w >= 10; w /= 10) e++;
    return e;
  }


  function getLn10(Ctor, sd, pr) {

    if (sd > Ctor.LN10.sd()) {


      // Reset global state in case the exception is caught.
      external = true;
      if (pr) Ctor.precision = pr;
      throw Error(decimalError + 'LN10 precision limit exceeded');
    }

    return round(new Ctor(Ctor.LN10), sd);
  }


  function getZeroString(k) {
    var zs = '';
    for (; k--;) zs += '0';
    return zs;
  }


  /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */
  function ln(y, sd) {
    var c, c0, denominator, e, numerator, sum, t, wpr, x2,
      n = 1,
      guard = 10,
      x = y,
      xd = x.d,
      Ctor = x.constructor,
      pr = Ctor.precision;

    // ln(-x) = NaN
    // ln(0) = -Infinity
    if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));

    // ln(1) = 0
    if (x.eq(ONE)) return new Ctor(0);

    if (sd == null) {
      external = false;
      wpr = pr;
    } else {
      wpr = sd;
    }

    if (x.eq(10)) {
      if (sd == null) external = true;
      return getLn10(Ctor, wpr);
    }

    wpr += guard;
    Ctor.precision = wpr;
    c = digitsToString(xd);
    c0 = c.charAt(0);
    e = getBase10Exponent(x);

    if (Math.abs(e) < 1.5e15) {

      // Argument reduction.
      // The series converges faster the closer the argument is to 1, so using
      // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
      // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
      // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
      // later be divided by this number, then separate out the power of 10 using
      // ln(a*10^b) = ln(a) + b*ln(10).

      // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
      //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
      // max n is 6 (gives 0.7 - 1.3)
      while (c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3) {
        x = x.times(y);
        c = digitsToString(x.d);
        c0 = c.charAt(0);
        n++;
      }

      e = getBase10Exponent(x);

      if (c0 > 1) {
        x = new Ctor('0.' + c);
        e++;
      } else {
        x = new Ctor(c0 + '.' + c.slice(1));
      }
    } else {

      // The argument reduction method above may result in overflow if the argument y is a massive
      // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
      // function using ln(x*10^e) = ln(x) + e*ln(10).
      t = getLn10(Ctor, wpr + 2, pr).times(e + '');
      x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);

      Ctor.precision = pr;
      return sd == null ? (external = true, round(x, pr)) : x;
    }

    // x is reduced to a value near 1.

    // Taylor series.
    // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
    // where x = (y - 1)/(y + 1)    (|x| < 1)
    sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
    x2 = round(x.times(x), wpr);
    denominator = 3;

    for (;;) {
      numerator = round(numerator.times(x2), wpr);
      t = sum.plus(divide(numerator, new Ctor(denominator), wpr));

      if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
        sum = sum.times(2);

        // Reverse the argument reduction.
        if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
        sum = divide(sum, new Ctor(n), wpr);

        Ctor.precision = pr;
        return sd == null ? (external = true, round(sum, pr)) : sum;
      }

      sum = t;
      denominator += 2;
    }
  }


  /*
   * Parse the value of a new Decimal `x` from string `str`.
   */
  function parseDecimal(x, str) {
    var e, i, len;

    // Decimal point?
    if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');

    // Exponential form?
    if ((i = str.search(/e/i)) > 0) {

      // Determine exponent.
      if (e < 0) e = i;
      e += +str.slice(i + 1);
      str = str.substring(0, i);
    } else if (e < 0) {

      // Integer.
      e = str.length;
    }

    // Determine leading zeros.
    for (i = 0; str.charCodeAt(i) === 48;) ++i;

    // Determine trailing zeros.
    for (len = str.length; str.charCodeAt(len - 1) === 48;) --len;
    str = str.slice(i, len);

    if (str) {
      len -= i;
      e = e - i - 1;
      x.e = mathfloor(e / LOG_BASE);
      x.d = [];

      // Transform base

      // e is the base 10 exponent.
      // i is where to slice str to get the first word of the digits array.
      i = (e + 1) % LOG_BASE;
      if (e < 0) i += LOG_BASE;

      if (i < len) {
        if (i) x.d.push(+str.slice(0, i));
        for (len -= LOG_BASE; i < len;) x.d.push(+str.slice(i, i += LOG_BASE));
        str = str.slice(i);
        i = LOG_BASE - str.length;
      } else {
        i -= len;
      }

      for (; i--;) str += '0';
      x.d.push(+str);

      if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
    } else {

      // Zero.
      x.s = 0;
      x.e = 0;
      x.d = [0];
    }

    return x;
  }


  /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */
   function round(x, sd, rm) {
    var i, j, k, n, rd, doRound, w, xdi,
      xd = x.d;

    // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
    // w: the word of xd which contains the rounding digit, a base 1e7 number.
    // xdi: the index of w within xd.
    // n: the number of digits of w.
    // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
    // they had leading zeros)
    // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).

    // Get the length of the first word of the digits array xd.
    for (n = 1, k = xd[0]; k >= 10; k /= 10) n++;
    i = sd - n;

    // Is the rounding digit in the first word of xd?
    if (i < 0) {
      i += LOG_BASE;
      j = sd;
      w = xd[xdi = 0];
    } else {
      xdi = Math.ceil((i + 1) / LOG_BASE);
      k = xd.length;
      if (xdi >= k) return x;
      w = k = xd[xdi];

      // Get the number of digits of w.
      for (n = 1; k >= 10; k /= 10) n++;

      // Get the index of rd within w.
      i %= LOG_BASE;

      // Get the index of rd within w, adjusted for leading zeros.
      // The number of leading zeros of w is given by LOG_BASE - n.
      j = i - LOG_BASE + n;
    }

    if (rm !== void 0) {
      k = mathpow(10, n - j - 1);

      // Get the rounding digit at index j of w.
      rd = w / k % 10 | 0;

      // Are there any non-zero digits after the rounding digit?
      doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;

      // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
      // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
      // 714.

      doRound = rm < 4
        ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
        : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 &&

          // Check whether the digit to the left of the rounding digit is odd.
          ((i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10) & 1 ||
            rm == (x.s < 0 ? 8 : 7));
    }

    if (sd < 1 || !xd[0]) {
      if (doRound) {
        k = getBase10Exponent(x);
        xd.length = 1;

        // Convert sd to decimal places.
        sd = sd - k - 1;

        // 1, 0.1, 0.01, 0.001, 0.0001 etc.
        xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
        x.e = mathfloor(-sd / LOG_BASE) || 0;
      } else {
        xd.length = 1;

        // Zero.
        xd[0] = x.e = x.s = 0;
      }

      return x;
    }

    // Remove excess digits.
    if (i == 0) {
      xd.length = xdi;
      k = 1;
      xdi--;
    } else {
      xd.length = xdi + 1;
      k = mathpow(10, LOG_BASE - i);

      // E.g. 56700 becomes 56000 if 7 is the rounding digit.
      // j > 0 means i > number of leading zeros of w.
      xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
    }

    if (doRound) {
      for (;;) {

        // Is the digit to be rounded up in the first word of xd?
        if (xdi == 0) {
          if ((xd[0] += k) == BASE) {
            xd[0] = 1;
            ++x.e;
          }

          break;
        } else {
          xd[xdi] += k;
          if (xd[xdi] != BASE) break;
          xd[xdi--] = 0;
          k = 1;
        }
      }
    }

    // Remove trailing zeros.
    for (i = xd.length; xd[--i] === 0;) xd.pop();

    if (external && (x.e > MAX_E || x.e < -MAX_E)) {
      throw Error(exponentOutOfRange + getBase10Exponent(x));
    }

    return x;
  }


  function subtract(x, y) {
    var d, e, i, j, k, len, xd, xe, xLTy, yd,
      Ctor = x.constructor,
      pr = Ctor.precision;

    // Return y negated if x is zero.
    // Return x if y is zero and x is non-zero.
    if (!x.s || !y.s) {
      if (y.s) y.s = -y.s;
      else y = new Ctor(x);
      return external ? round(y, pr) : y;
    }

    xd = x.d;
    yd = y.d;

    // x and y are non-zero numbers with the same sign.

    e = y.e;
    xe = x.e;
    xd = xd.slice();
    k = xe - e;

    // If exponents differ...
    if (k) {
      xLTy = k < 0;

      if (xLTy) {
        d = xd;
        k = -k;
        len = yd.length;
      } else {
        d = yd;
        e = xe;
        len = xd.length;
      }

      // Numbers with massively different exponents would result in a very high number of zeros
      // needing to be prepended, but this can be avoided while still ensuring correct rounding by
      // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
      i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;

      if (k > i) {
        k = i;
        d.length = 1;
      }

      // Prepend zeros to equalise exponents.
      d.reverse();
      for (i = k; i--;) d.push(0);
      d.reverse();

    // Base 1e7 exponents equal.
    } else {

      // Check digits to determine which is the bigger number.

      i = xd.length;
      len = yd.length;
      xLTy = i < len;
      if (xLTy) len = i;

      for (i = 0; i < len; i++) {
        if (xd[i] != yd[i]) {
          xLTy = xd[i] < yd[i];
          break;
        }
      }

      k = 0;
    }

    if (xLTy) {
      d = xd;
      xd = yd;
      yd = d;
      y.s = -y.s;
    }

    len = xd.length;

    // Append zeros to xd if shorter.
    // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
    for (i = yd.length - len; i > 0; --i) xd[len++] = 0;

    // Subtract yd from xd.
    for (i = yd.length; i > k;) {
      if (xd[--i] < yd[i]) {
        for (j = i; j && xd[--j] === 0;) xd[j] = BASE - 1;
        --xd[j];
        xd[i] += BASE;
      }

      xd[i] -= yd[i];
    }

    // Remove trailing zeros.
    for (; xd[--len] === 0;) xd.pop();

    // Remove leading zeros and adjust exponent accordingly.
    for (; xd[0] === 0; xd.shift()) --e;

    // Zero?
    if (!xd[0]) return new Ctor(0);

    y.d = xd;
    y.e = e;

    //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
    return external ? round(y, pr) : y;
  }


  function toString(x, isExp, sd) {
    var k,
      e = getBase10Exponent(x),
      str = digitsToString(x.d),
      len = str.length;

    if (isExp) {
      if (sd && (k = sd - len) > 0) {
        str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
      } else if (len > 1) {
        str = str.charAt(0) + '.' + str.slice(1);
      }

      str = str + (e < 0 ? 'e' : 'e+') + e;
    } else if (e < 0) {
      str = '0.' + getZeroString(-e - 1) + str;
      if (sd && (k = sd - len) > 0) str += getZeroString(k);
    } else if (e >= len) {
      str += getZeroString(e + 1 - len);
      if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
    } else {
      if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
      if (sd && (k = sd - len) > 0) {
        if (e + 1 === len) str += '.';
        str += getZeroString(k);
      }
    }

    return x.s < 0 ? '-' + str : str;
  }


  // Does not strip trailing zeros.
  function truncate(arr, len) {
    if (arr.length > len) {
      arr.length = len;
      return true;
    }
  }


  // Decimal methods


  /*
   *  clone
   *  config/set
   */


  /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */
  function clone(obj) {
    var i, p, ps;

    /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */
    function Decimal(value) {
      var x = this;

      // Decimal called without new.
      if (!(x instanceof Decimal)) return new Decimal(value);

      // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
      // which points to Object.
      x.constructor = Decimal;

      // Duplicate.
      if (value instanceof Decimal) {
        x.s = value.s;
        x.e = value.e;
        x.d = (value = value.d) ? value.slice() : value;
        return;
      }

      if (typeof value === 'number') {

        // Reject Infinity/NaN.
        if (value * 0 !== 0) {
          throw Error(invalidArgument + value);
        }

        if (value > 0) {
          x.s = 1;
        } else if (value < 0) {
          value = -value;
          x.s = -1;
        } else {
          x.s = 0;
          x.e = 0;
          x.d = [0];
          return;
        }

        // Fast path for small integers.
        if (value === ~~value && value < 1e7) {
          x.e = 0;
          x.d = [value];
          return;
        }

        return parseDecimal(x, value.toString());
      } else if (typeof value !== 'string') {
        throw Error(invalidArgument + value);
      }

      // Minus sign?
      if (value.charCodeAt(0) === 45) {
        value = value.slice(1);
        x.s = -1;
      } else {
        x.s = 1;
      }

      if (isDecimal.test(value)) parseDecimal(x, value);
      else throw Error(invalidArgument + value);
    }

    Decimal.prototype = P;

    Decimal.ROUND_UP = 0;
    Decimal.ROUND_DOWN = 1;
    Decimal.ROUND_CEIL = 2;
    Decimal.ROUND_FLOOR = 3;
    Decimal.ROUND_HALF_UP = 4;
    Decimal.ROUND_HALF_DOWN = 5;
    Decimal.ROUND_HALF_EVEN = 6;
    Decimal.ROUND_HALF_CEIL = 7;
    Decimal.ROUND_HALF_FLOOR = 8;

    Decimal.clone = clone;
    Decimal.config = Decimal.set = config;

    if (obj === void 0) obj = {};
    if (obj) {
      ps = ['precision', 'rounding', 'toExpNeg', 'toExpPos', 'LN10'];
      for (i = 0; i < ps.length;) if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
    }

    Decimal.config(obj);

    return Decimal;
  }


  /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */
  function config(obj) {
    if (!obj || typeof obj !== 'object') {
      throw Error(decimalError + 'Object expected');
    }
    var i, p, v,
      ps = [
        'precision', 1, MAX_DIGITS,
        'rounding', 0, 8,
        'toExpNeg', -1 / 0, 0,
        'toExpPos', 0, 1 / 0
      ];

    for (i = 0; i < ps.length; i += 3) {
      if ((v = obj[p = ps[i]]) !== void 0) {
        if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
        else throw Error(invalidArgument + p + ': ' + v);
      }
    }

    if ((v = obj[p = 'LN10']) !== void 0) {
        if (v == Math.LN10) this[p] = new this(v);
        else throw Error(invalidArgument + p + ': ' + v);
    }

    return this;
  }


  // Create and configure initial Decimal constructor.
  Decimal = clone(Decimal);

  Decimal['default'] = Decimal.Decimal = Decimal;

  // Internal constant.
  ONE = new Decimal(1);


  // Export.


  // AMD.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return Decimal;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

  // Node and other environments that support module.exports.
  } else if (typeof module != 'undefined' && module.exports) {
    module.exports = Decimal;

    // Browser.
  } else {
    if (!globalScope) {
      globalScope = typeof self != 'undefined' && self && self.self == self
        ? self : Function('return this')();
    }

    globalScope.Decimal = Decimal;
  }
})(this);


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(40);

exports.__esModule = true;
exports.default = activeElement;

var _ownerDocument = _interopRequireDefault(__webpack_require__(118));

function activeElement(doc) {
  if (doc === void 0) {
    doc = (0, _ownerDocument.default)();
  }

  try {
    return doc.activeElement;
  } catch (e) {
    /* ie throws if no active element */
  }
}

module.exports = exports["default"];

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(40);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(505));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(40);

exports.__esModule = true;
exports.default = offset;

var _contains = _interopRequireDefault(__webpack_require__(119));

var _isWindow = _interopRequireDefault(__webpack_require__(195));

var _ownerDocument = _interopRequireDefault(__webpack_require__(118));

function offset(node) {
  var doc = (0, _ownerDocument.default)(node),
      win = (0, _isWindow.default)(doc),
      docElem = doc && doc.documentElement,
      box = {
    top: 0,
    left: 0,
    height: 0,
    width: 0
  };
  if (!doc) return; // Make sure it's not a disconnected DOM node

  if (!(0, _contains.default)(docElem, node)) return box;
  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height

  box = {
    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
    width: (box.width == null ? node.offsetWidth : box.width) || 0,
    height: (box.height == null ? node.offsetHeight : box.height) || 0
  };
  return box;
}

module.exports = exports["default"];

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(40);

exports.__esModule = true;
exports.default = scrollTop;

var _isWindow = _interopRequireDefault(__webpack_require__(195));

function scrollTop(node, val) {
  var win = (0, _isWindow.default)(node);
  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
}

module.exports = exports["default"];

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(40);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(84));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(40);

exports.__esModule = true;
exports.default = camelizeStyleName;

var _camelize = _interopRequireDefault(__webpack_require__(1148));

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
 */
var msPattern = /^-ms-/;

function camelizeStyleName(string) {
  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
}

module.exports = exports["default"];

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(40);

exports.__esModule = true;
exports.default = scrollbarSize;

var _inDOM = _interopRequireDefault(__webpack_require__(84));

var size;

function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM.default) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

module.exports = exports["default"];

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports = function(opts) {
  return new ElementClass(opts)
}

function indexOf(arr, prop) {
  if (arr.indexOf) return arr.indexOf(prop)
  for (var i = 0, len = arr.length; i < len; i++)
    if (arr[i] === prop) return i
  return -1
}

function ElementClass(opts) {
  if (!(this instanceof ElementClass)) return new ElementClass(opts)
  var self = this
  if (!opts) opts = {}

  // similar doing instanceof HTMLElement but works in IE8
  if (opts.nodeType) opts = {el: opts}

  this.opts = opts
  this.el = opts.el || document.body
  if (typeof this.el !== 'object') this.el = document.querySelector(this.el)
}

ElementClass.prototype.add = function(className) {
  var el = this.el
  if (!el) return
  if (el.className === "") return el.className = className
  var classes = el.className.split(' ')
  if (indexOf(classes, className) > -1) return classes
  classes.push(className)
  el.className = classes.join(' ')
  return classes
}

ElementClass.prototype.remove = function(className) {
  var el = this.el
  if (!el) return
  if (el.className === "") return
  var classes = el.className.split(' ')
  var idx = indexOf(classes, className)
  if (idx > -1) classes.splice(idx, 1)
  el.className = classes.join(' ')
  return classes
}

ElementClass.prototype.has = function(className) {
  var el = this.el
  if (!el) return
  var classes = el.className.split(' ')
  return indexOf(classes, className) > -1
}

ElementClass.prototype.toggle = function(className) {
  var el = this.el
  if (!el) return
  if (this.has(className)) this.remove(className)
  else this.add(className)
}


/***/ }),
/* 513 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var camelize = __webpack_require__(1159);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(1164);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(31);

var createArrayFromMixed = __webpack_require__(1160);
var getMarkupWrap = __webpack_require__(1161);
var invariant = __webpack_require__(17);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(1162);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 520 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assign;


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(309),
    setCacheAdd = __webpack_require__(1263),
    setCacheHas = __webpack_require__(1264);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(63);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 523 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1210),
    isArguments = __webpack_require__(321),
    isArray = __webpack_require__(49),
    isBuffer = __webpack_require__(322),
    isIndex = __webpack_require__(539),
    isTypedArray = __webpack_require__(549);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 525 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(527),
    eq = __webpack_require__(319);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(532);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(311),
    isArray = __webpack_require__(49);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(1188),
    baseIsNaN = __webpack_require__(1197),
    strictIndexOf = __webpack_require__(1271);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 530 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 531 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(100);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(521),
    arraySome = __webpack_require__(1181),
    cacheHas = __webpack_require__(531);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(528),
    getSymbols = __webpack_require__(316),
    keys = __webpack_require__(123);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(528),
    getSymbolsIn = __webpack_require__(537),
    keysIn = __webpack_require__(550);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(311),
    getPrototype = __webpack_require__(315),
    getSymbols = __webpack_require__(316),
    stubArray = __webpack_require__(551);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1170),
    Map = __webpack_require__(308),
    Promise = __webpack_require__(1172),
    Set = __webpack_require__(1173),
    WeakMap = __webpack_require__(1174),
    baseGetTag = __webpack_require__(86),
    toSource = __webpack_require__(547);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 539 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(101);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 541 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 542 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 543 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(1177);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 545 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(1208),
    shortOut = __webpack_require__(1265);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 547 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(86),
    isObject = __webpack_require__(101);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1199),
    baseUnary = __webpack_require__(530),
    nodeUtil = __webpack_require__(1260);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(524),
    baseKeysIn = __webpack_require__(1202),
    isArrayLike = __webpack_require__(168);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 551 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(1167)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(771);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('not a function');
  }
  this._45 = 0;
  this._81 = 0;
  this._65 = null;
  this._54 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._10 = null;
Promise._97 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
};
function handle(self, deferred) {
  while (self._81 === 3) {
    self = self._65;
  }
  if (Promise._10) {
    Promise._10(self);
  }
  if (self._81 === 0) {
    if (self._45 === 0) {
      self._45 = 1;
      self._54 = deferred;
      return;
    }
    if (self._45 === 1) {
      self._45 = 2;
      self._54 = [self._54, deferred];
      return;
    }
    self._54.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._81 === 1) {
        resolve(deferred.promise, self._65);
      } else {
        reject(deferred.promise, self._65);
      }
      return;
    }
    var ret = tryCallOne(cb, self._65);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._81 = 3;
      self._65 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._81 = 1;
  self._65 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._81 = 2;
  self._65 = newValue;
  if (Promise._97) {
    Promise._97(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._45 === 1) {
    handle(self, self._54);
    self._54 = null;
  }
  if (self._45 === 2) {
    for (var i = 0; i < self._54.length; i++) {
      handle(self, self._54[i]);
    }
    self._54 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  })
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(1308);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1300)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1549);

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var editor = function editor(editable, attr, format, editorClass, defaultValue, ignoreEditable) {
  if (editable === true || editable === false && ignoreEditable || typeof editable === 'string') {
    // simple declare
    var type = editable ? 'text' : editable;
    return _react2.default.createElement('input', _extends({}, attr, { type: type, defaultValue: defaultValue,
      className: (editorClass || '') + ' form-control editor edit-text' }));
  } else if (!editable) {
    var _type = editable ? 'text' : editable;
    return _react2.default.createElement('input', _extends({}, attr, { type: _type, defaultValue: defaultValue,
      disabled: 'disabled',
      className: (editorClass || '') + ' form-control editor edit-text' }));
  } else if (editable && (editable.type === undefined || editable.type === null || editable.type.trim() === '')) {
    var _type2 = editable ? 'text' : editable;
    return _react2.default.createElement('input', _extends({}, attr, { type: _type2, defaultValue: defaultValue,
      className: (editorClass || '') + ' form-control editor edit-text' }));
  } else if (editable.type) {
    // standard declare
    // put style if exist
    editable.style && (attr.style = editable.style);
    // put class if exist
    attr.className = (editorClass || '') + ' form-control editor edit-' + editable.type + (editable.className ? ' ' + editable.className : '');

    if (editable.type === 'select') {
      // process select input
      var options = [];
      var _editable$options = editable.options,
          values = _editable$options.values,
          textKey = _editable$options.textKey,
          valueKey = _editable$options.valueKey;

      if (Array.isArray(values)) {
        // only can use arrray data for options
        var text = void 0;
        var value = void 0;
        options = values.map(function (option, i) {
          if ((typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object') {
            text = textKey ? option[textKey] : option.text;
            value = valueKey ? option[valueKey] : option.value;
          } else {
            text = format ? format(option) : option;
            value = option;
          }
          return _react2.default.createElement(
            'option',
            { key: 'option' + i, value: value },
            text
          );
        });
      }
      return _react2.default.createElement(
        'select',
        _extends({}, attr, { defaultValue: defaultValue }),
        options
      );
    } else if (editable.type === 'textarea') {
      // process textarea input
      // put other if exist
      editable.cols && (attr.cols = editable.cols);
      editable.rows && (attr.rows = editable.rows);
      var saveBtn = void 0;
      var keyUpHandler = attr.onKeyDown;
      if (keyUpHandler) {
        attr.onKeyDown = function (e) {
          if (e.keyCode !== 13) {
            // not Pressed ENTER
            keyUpHandler(e);
          }
        };
        saveBtn = _react2.default.createElement(
          'button',
          {
            className: 'btn btn-info btn-xs textarea-save-btn',
            onClick: keyUpHandler },
          'save'
        );
      }
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('textarea', _extends({}, attr, { defaultValue: defaultValue })),
        saveBtn
      );
    } else if (editable.type === 'checkbox') {
      var _values = 'true:false';
      if (editable.options && editable.options.values) {
        // values = editable.options.values.split(':');
        _values = editable.options.values;
      }
      attr.className = attr.className.replace('form-control', '');
      attr.className += ' checkbox pull-right';

      var checked = defaultValue && defaultValue.toString() === _values.split(':')[0] ? true : false;

      return _react2.default.createElement('input', _extends({}, attr, { type: 'checkbox',
        value: _values, defaultChecked: checked }));
    } else if (editable.type === 'datetime') {
      return _react2.default.createElement('input', _extends({}, attr, { type: 'datetime-local', defaultValue: defaultValue }));
    } else {
      // process other input type. as password,url,email...
      return _react2.default.createElement('input', _extends({}, attr, { type: editable.type, defaultValue: defaultValue }));
    }
  }
  // default return for other case of editable
  return _react2.default.createElement('input', _extends({}, attr, { type: 'text',
    className: (editorClass || '') + ' form-control editor edit-text' }));
};

var _default = editor;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(editor, 'editor', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Editor.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Editor.js');
}();

;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactToastr = __webpack_require__(704);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ToastrMessageFactory = _react2.default.createFactory(_reactToastr.ToastMessage.animation);

var Notification = function (_Component) {
  _inherits(Notification, _Component);

  function Notification() {
    _classCallCheck(this, Notification);

    return _possibleConstructorReturn(this, (Notification.__proto__ || Object.getPrototypeOf(Notification)).apply(this, arguments));
  }

  _createClass(Notification, [{
    key: 'notice',

    // allow type is success,info,warning,error
    value: function notice(type, msg, title) {
      this.refs.toastr[type](msg, title, {
        mode: 'single',
        timeOut: 5000,
        extendedTimeOut: 1000,
        showAnimation: 'animated  bounceIn',
        hideAnimation: 'animated bounceOut'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_reactToastr.ToastContainer, { ref: 'toastr',
        toastMessageFactory: ToastrMessageFactory,
        id: 'toast-container',
        className: 'toast-top-right' });
    }
  }]);

  return Notification;
}(_react.Component);

var _default = Notification;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ToastrMessageFactory, 'ToastrMessageFactory', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Notification.js');

  __REACT_HOT_LOADER__.register(Notification, 'Notification', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Notification.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Notification.js');
}();

;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Const = __webpack_require__(35);

var _Const2 = _interopRequireDefault(_Const);

var _util = __webpack_require__(87);

var _util2 = _interopRequireDefault(_util);

var _Date = __webpack_require__(1322);

var _Date2 = _interopRequireDefault(_Date);

var _Text = __webpack_require__(1326);

var _Text2 = _interopRequireDefault(_Text);

var _Regex = __webpack_require__(1324);

var _Regex2 = _interopRequireDefault(_Regex);

var _Select = __webpack_require__(1325);

var _Select2 = _interopRequireDefault(_Select);

var _Number = __webpack_require__(1323);

var _Number2 = _interopRequireDefault(_Number);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint default-case: 0 */
/* eslint guard-for-in: 0 */


var TableHeaderColumn = function (_Component) {
  _inherits(TableHeaderColumn, _Component);

  function TableHeaderColumn(props) {
    _classCallCheck(this, TableHeaderColumn);

    var _this = _possibleConstructorReturn(this, (TableHeaderColumn.__proto__ || Object.getPrototypeOf(TableHeaderColumn)).call(this, props));

    _this.handleColumnClick = function () {
      return _this.__handleColumnClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleFilter = _this.handleFilter.bind(_this);
    return _this;
  }

  _createClass(TableHeaderColumn, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.reset) {
        this.cleanFiltered();
      }
    }
  }, {
    key: '__handleColumnClick__REACT_HOT_LOADER__',
    value: function __handleColumnClick__REACT_HOT_LOADER__() {
      if (this.props.isOnlyHead || !this.props.dataSort) return;
      var order = this.props.sort;

      if (!order && this.props.defaultASC) order = _Const2.default.SORT_ASC;else order = this.props.sort === _Const2.default.SORT_DESC ? _Const2.default.SORT_ASC : _Const2.default.SORT_DESC;
      this.props.onSort(order, this.props.dataField);
    }
  }, {
    key: 'handleFilter',
    value: function handleFilter(value, type) {
      var filter = this.props.filter;

      filter.emitter.handleFilter(this.props.dataField, value, type, filter);
    }
  }, {
    key: 'getFilters',
    value: function getFilters() {
      var _props = this.props,
          headerText = _props.headerText,
          children = _props.children;

      switch (this.props.filter.type) {
        case _Const2.default.FILTER_TYPE.TEXT:
          {
            return _react2.default.createElement(_Text2.default, _extends({ ref: 'textFilter' }, this.props.filter, {
              columnName: headerText || children, filterHandler: this.handleFilter }));
          }
        case _Const2.default.FILTER_TYPE.REGEX:
          {
            return _react2.default.createElement(_Regex2.default, _extends({ ref: 'regexFilter' }, this.props.filter, {
              columnName: headerText || children, filterHandler: this.handleFilter }));
          }
        case _Const2.default.FILTER_TYPE.SELECT:
          {
            return _react2.default.createElement(_Select2.default, _extends({ ref: 'selectFilter' }, this.props.filter, {
              columnName: headerText || children, filterHandler: this.handleFilter }));
          }
        case _Const2.default.FILTER_TYPE.NUMBER:
          {
            return _react2.default.createElement(_Number2.default, _extends({ ref: 'numberFilter' }, this.props.filter, {
              columnName: headerText || children, filterHandler: this.handleFilter }));
          }
        case _Const2.default.FILTER_TYPE.DATE:
          {
            return _react2.default.createElement(_Date2.default, _extends({ ref: 'dateFilter' }, this.props.filter, {
              columnName: headerText || children, filterHandler: this.handleFilter }));
          }
        case _Const2.default.FILTER_TYPE.CUSTOM:
          {
            var elm = this.props.filter.getElement(this.handleFilter, this.props.filter.customFilterParameters);

            return _react2.default.cloneElement(elm, { ref: 'customFilter' });
          }
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs['header-col'].setAttribute('data-field', this.props.dataField);
    }
  }, {
    key: 'render',
    value: function render() {
      var defaultCaret = void 0;
      var sortCaret = void 0;
      var _props2 = this.props,
          headerText = _props2.headerText,
          dataAlign = _props2.dataAlign,
          dataField = _props2.dataField,
          headerAlign = _props2.headerAlign,
          headerTitle = _props2.headerTitle,
          hidden = _props2.hidden,
          sort = _props2.sort,
          dataSort = _props2.dataSort,
          sortIndicator = _props2.sortIndicator,
          children = _props2.children,
          caretRender = _props2.caretRender,
          className = _props2.className,
          isOnlyHead = _props2.isOnlyHead,
          style = _props2.thStyle;

      var thStyle = _extends({
        textAlign: headerAlign || dataAlign,
        display: hidden ? 'none' : null
      }, style);
      if (!isOnlyHead) {
        if (sortIndicator) {
          defaultCaret = !dataSort ? null : _react2.default.createElement(
            'span',
            { className: 'order' },
            _react2.default.createElement(
              'span',
              { className: 'dropdown' },
              _react2.default.createElement('span', { className: 'caret', style: { margin: '10px 0 10px 5px', color: '#ccc' } })
            ),
            _react2.default.createElement(
              'span',
              { className: 'dropup' },
              _react2.default.createElement('span', { className: 'caret', style: { margin: '10px 0', color: '#ccc' } })
            )
          );
        }
        sortCaret = sort ? _util2.default.renderReactSortCaret(sort) : defaultCaret;
        if (caretRender) {
          sortCaret = caretRender(sort, dataField);
        }
      }

      var classes = (0, _classnames2.default)(_util2.default.isFunction(className) ? className() : className, !isOnlyHead && dataSort ? 'sort-column' : '');

      var attr = {};
      if (headerTitle) {
        if (typeof children === 'string' && !headerText) {
          attr.title = children;
        } else {
          attr.title = headerText;
        }
      }
      return _react2.default.createElement(
        'th',
        _extends({ ref: 'header-col',
          className: classes,
          style: thStyle,
          onClick: this.handleColumnClick,
          rowSpan: this.props.rowSpan,
          colSpan: this.props.colSpan,
          'data-is-only-head': this.props.isOnlyHead
        }, attr),
        children,
        sortCaret,
        _react2.default.createElement(
          'div',
          { onClick: function onClick(e) {
              return e.stopPropagation();
            } },
          this.props.filter && !isOnlyHead ? this.getFilters() : null
        )
      );
    }
  }, {
    key: 'cleanFiltered',
    value: function cleanFiltered() {
      if (!this.props.filter) return;

      switch (this.props.filter.type) {
        case _Const2.default.FILTER_TYPE.TEXT:
          {
            this.refs.textFilter.cleanFiltered();
            break;
          }
        case _Const2.default.FILTER_TYPE.REGEX:
          {
            this.refs.regexFilter.cleanFiltered();
            break;
          }
        case _Const2.default.FILTER_TYPE.SELECT:
          {
            this.refs.selectFilter.cleanFiltered();
            break;
          }
        case _Const2.default.FILTER_TYPE.NUMBER:
          {
            this.refs.numberFilter.cleanFiltered();
            break;
          }
        case _Const2.default.FILTER_TYPE.DATE:
          {
            this.refs.dateFilter.cleanFiltered();
            break;
          }
        case _Const2.default.FILTER_TYPE.CUSTOM:
          {
            this.refs.customFilter.cleanFiltered();
            break;
          }
      }
    }
  }, {
    key: 'applyFilter',
    value: function applyFilter(val) {
      if (!this.props.filter) return;
      switch (this.props.filter.type) {
        case _Const2.default.FILTER_TYPE.TEXT:
          {
            this.refs.textFilter.applyFilter(val);
            break;
          }
        case _Const2.default.FILTER_TYPE.REGEX:
          {
            this.refs.regexFilter.applyFilter(val);
            break;
          }
        case _Const2.default.FILTER_TYPE.SELECT:
          {
            this.refs.selectFilter.applyFilter(val);
            break;
          }
        case _Const2.default.FILTER_TYPE.NUMBER:
          {
            this.refs.numberFilter.applyFilter(val);
            break;
          }
        case _Const2.default.FILTER_TYPE.DATE:
          {
            this.refs.dateFilter.applyFilter(val);
            break;
          }
      }
    }
  }]);

  return TableHeaderColumn;
}(_react.Component);

var filterTypeArray = [];
for (var key in _Const2.default.FILTER_TYPE) {
  filterTypeArray.push(_Const2.default.FILTER_TYPE[key]);
}

TableHeaderColumn.propTypes = {
  dataField: _react.PropTypes.string,
  dataAlign: _react.PropTypes.string,
  headerAlign: _react.PropTypes.string,
  headerTitle: _react.PropTypes.bool,
  headerText: _react.PropTypes.string,
  dataSort: _react.PropTypes.bool,
  onSort: _react.PropTypes.func,
  dataFormat: _react.PropTypes.func,
  csvFormat: _react.PropTypes.func,
  csvHeader: _react.PropTypes.string,
  isKey: _react.PropTypes.bool,
  editable: _react.PropTypes.any,
  hidden: _react.PropTypes.bool,
  hiddenOnInsert: _react.PropTypes.bool,
  searchable: _react.PropTypes.bool,
  className: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
  width: _react.PropTypes.string,
  sortFunc: _react.PropTypes.func,
  sortFuncExtraData: _react.PropTypes.any,
  columnClassName: _react.PropTypes.any,
  editColumnClassName: _react.PropTypes.any,
  invalidEditColumnClassName: _react.PropTypes.any,
  columnTitle: _react.PropTypes.bool,
  filterFormatted: _react.PropTypes.bool,
  filterValue: _react.PropTypes.func,
  sort: _react.PropTypes.string,
  caretRender: _react.PropTypes.func,
  formatExtraData: _react.PropTypes.any,
  csvFormatExtraData: _react.PropTypes.any,
  filter: _react.PropTypes.shape({
    type: _react.PropTypes.oneOf(filterTypeArray),
    delay: _react.PropTypes.number,
    options: _react.PropTypes.oneOfType([_react.PropTypes.object, // for SelectFilter
    _react.PropTypes.arrayOf(_react.PropTypes.number) // for NumberFilter
    ]),
    numberComparators: _react.PropTypes.arrayOf(_react.PropTypes.string),
    emitter: _react.PropTypes.object,
    placeholder: _react.PropTypes.string,
    getElement: _react.PropTypes.func,
    customFilterParameters: _react.PropTypes.object,
    condition: _react.PropTypes.oneOf([_Const2.default.FILTER_COND_EQ, _Const2.default.FILTER_COND_LIKE])
  }),
  sortIndicator: _react.PropTypes.bool,
  export: _react.PropTypes.bool,
  expandable: _react.PropTypes.bool,
  tdAttr: _react.PropTypes.object,
  tdStyle: _react.PropTypes.object,
  thStyle: _react.PropTypes.object,
  keyValidator: _react.PropTypes.bool,
  defaultASC: _react.PropTypes.bool
};

TableHeaderColumn.defaultProps = {
  dataAlign: 'left',
  headerAlign: undefined,
  headerTitle: true,
  dataSort: false,
  dataFormat: undefined,
  csvFormat: undefined,
  csvHeader: undefined,
  isKey: false,
  editable: true,
  onSort: undefined,
  hidden: false,
  hiddenOnInsert: false,
  searchable: true,
  className: '',
  columnTitle: false,
  width: null,
  sortFunc: undefined,
  columnClassName: '',
  editColumnClassName: '',
  invalidEditColumnClassName: '',
  filterFormatted: false,
  filterValue: undefined,
  sort: undefined,
  formatExtraData: undefined,
  sortFuncExtraData: undefined,
  filter: undefined,
  sortIndicator: true,
  expandable: true,
  tdAttr: undefined,
  tdStyle: undefined,
  thStyle: undefined,
  keyValidator: false,
  defaultASC: false
};

var _default = TableHeaderColumn;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableHeaderColumn, 'TableHeaderColumn', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeaderColumn.js');

  __REACT_HOT_LOADER__.register(filterTypeArray, 'filterTypeArray', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeaderColumn.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeaderColumn.js');
}();

;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizePerPageDefaultClass = 'react-bs-table-sizePerPage-dropdown';

var SizePerPageDropDown = function (_Component) {
  _inherits(SizePerPageDropDown, _Component);

  function SizePerPageDropDown() {
    _classCallCheck(this, SizePerPageDropDown);

    return _possibleConstructorReturn(this, (SizePerPageDropDown.__proto__ || Object.getPrototypeOf(SizePerPageDropDown)).apply(this, arguments));
  }

  _createClass(SizePerPageDropDown, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          open = _props.open,
          hidden = _props.hidden,
          onClick = _props.onClick,
          options = _props.options,
          className = _props.className,
          variation = _props.variation,
          btnContextual = _props.btnContextual,
          currSizePerPage = _props.currSizePerPage;


      var openClass = open ? 'open' : '';
      var dropDownStyle = { visibility: hidden ? 'hidden' : 'visible' };

      return _react2.default.createElement(
        'span',
        { style: dropDownStyle,
          className: variation + ' ' + openClass + ' ' + className + ' ' + sizePerPageDefaultClass },
        _react2.default.createElement(
          'button',
          { className: 'btn ' + btnContextual + ' dropdown-toggle',
            id: 'pageDropDown', 'data-toggle': 'dropdown',
            'aria-expanded': open,
            onClick: onClick },
          currSizePerPage,
          _react2.default.createElement(
            'span',
            null,
            ' ',
            _react2.default.createElement('span', { className: 'caret' })
          )
        ),
        _react2.default.createElement(
          'ul',
          { className: 'dropdown-menu', role: 'menu', 'aria-labelledby': 'pageDropDown' },
          options
        )
      );
    }
  }]);

  return SizePerPageDropDown;
}(_react.Component);

SizePerPageDropDown.propTypes = {
  open: _react.PropTypes.bool,
  hidden: _react.PropTypes.bool,
  btnContextual: _react.PropTypes.string,
  currSizePerPage: _react.PropTypes.string,
  options: _react.PropTypes.array,
  variation: _react.PropTypes.oneOf(['dropdown', 'dropup']),
  className: _react.PropTypes.string,
  onClick: _react.PropTypes.func
};
SizePerPageDropDown.defaultProps = {
  open: false,
  hidden: false,
  btnContextual: 'btn-default',
  variation: 'dropdown',
  className: ''
};

var _default = SizePerPageDropDown;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(sizePerPageDefaultClass, 'sizePerPageDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/SizePerPageDropDown.js');

  __REACT_HOT_LOADER__.register(SizePerPageDropDown, 'SizePerPageDropDown', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/SizePerPageDropDown.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/SizePerPageDropDown.js');
}();

;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var clearBtnDefaultClass = 'react-bs-table-search-clear-btn';

var ClearSearchButton = function (_Component) {
  _inherits(ClearSearchButton, _Component);

  function ClearSearchButton() {
    _classCallCheck(this, ClearSearchButton);

    return _possibleConstructorReturn(this, (ClearSearchButton.__proto__ || Object.getPrototypeOf(ClearSearchButton)).apply(this, arguments));
  }

  _createClass(ClearSearchButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          btnContextual = _props.btnContextual,
          className = _props.className,
          onClick = _props.onClick,
          btnText = _props.btnText,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['btnContextual', 'className', 'onClick', 'btnText', 'children']);

      var content = children || _react2.default.createElement(
        'span',
        null,
        btnText
      );
      return _react2.default.createElement(
        'button',
        _extends({ ref: 'btn',
          className: 'btn ' + btnContextual + ' ' + className + ' ' + clearBtnDefaultClass,
          type: 'button',
          onClick: onClick
        }, rest),
        content
      );
    }
  }]);

  return ClearSearchButton;
}(_react.Component);

ClearSearchButton.propTypes = {
  btnContextual: _react.PropTypes.string,
  className: _react.PropTypes.string,
  btnText: _react.PropTypes.string,
  onClick: _react.PropTypes.func
};
ClearSearchButton.defaultProps = {
  btnContextual: 'btn-default',
  className: '',
  btnText: 'Clear',
  onClick: undefined
};

var _default = ClearSearchButton;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(clearBtnDefaultClass, 'clearBtnDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ClearSearchButton.js');

  __REACT_HOT_LOADER__.register(ClearSearchButton, 'ClearSearchButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ClearSearchButton.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ClearSearchButton.js');
}();

;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Const = __webpack_require__(35);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var deleteBtnDefaultClass = 'react-bs-table-del-btn';

var DeleteButton = function (_Component) {
  _inherits(DeleteButton, _Component);

  function DeleteButton() {
    _classCallCheck(this, DeleteButton);

    return _possibleConstructorReturn(this, (DeleteButton.__proto__ || Object.getPrototypeOf(DeleteButton)).apply(this, arguments));
  }

  _createClass(DeleteButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          btnContextual = _props.btnContextual,
          className = _props.className,
          onClick = _props.onClick,
          btnGlyphicon = _props.btnGlyphicon,
          btnText = _props.btnText,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['btnContextual', 'className', 'onClick', 'btnGlyphicon', 'btnText', 'children']);

      var content = children || _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement('i', { className: 'glyphicon ' + btnGlyphicon }),
        ' ',
        btnText
      );
      return _react2.default.createElement(
        'button',
        _extends({ type: 'button',
          className: 'btn ' + btnContextual + ' ' + deleteBtnDefaultClass + ' ' + className,
          onClick: onClick
        }, rest),
        content
      );
    }
  }]);

  return DeleteButton;
}(_react.Component);

DeleteButton.propTypes = {
  btnText: _react.PropTypes.string,
  btnContextual: _react.PropTypes.string,
  className: _react.PropTypes.string,
  onClick: _react.PropTypes.func,
  btnGlyphicon: _react.PropTypes.string
};
DeleteButton.defaultProps = {
  btnText: _Const2.default.DELETE_BTN_TEXT,
  btnContextual: 'btn-warning',
  className: '',
  onClick: undefined,
  btnGlyphicon: 'glyphicon-trash'
};

var _default = DeleteButton;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(deleteBtnDefaultClass, 'deleteBtnDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/DeleteButton.js');

  __REACT_HOT_LOADER__.register(DeleteButton, 'DeleteButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/DeleteButton.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/DeleteButton.js');
}();

;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Const = __webpack_require__(35);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var exportCsvBtnDefaultClass = 'react-bs-table-csv-btn';

var ExportCSVButton = function (_Component) {
  _inherits(ExportCSVButton, _Component);

  function ExportCSVButton() {
    _classCallCheck(this, ExportCSVButton);

    return _possibleConstructorReturn(this, (ExportCSVButton.__proto__ || Object.getPrototypeOf(ExportCSVButton)).apply(this, arguments));
  }

  _createClass(ExportCSVButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          btnContextual = _props.btnContextual,
          className = _props.className,
          onClick = _props.onClick,
          btnGlyphicon = _props.btnGlyphicon,
          btnText = _props.btnText,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['btnContextual', 'className', 'onClick', 'btnGlyphicon', 'btnText', 'children']);

      var content = children || _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement('i', { className: 'glyphicon ' + btnGlyphicon }),
        ' ',
        btnText
      );
      return _react2.default.createElement(
        'button',
        _extends({ type: 'button',
          className: 'btn ' + btnContextual + ' ' + exportCsvBtnDefaultClass + ' ' + className + ' hidden-print',
          onClick: onClick
        }, rest),
        content
      );
    }
  }]);

  return ExportCSVButton;
}(_react.Component);

ExportCSVButton.propTypes = {
  btnText: _react.PropTypes.string,
  btnContextual: _react.PropTypes.string,
  className: _react.PropTypes.string,
  onClick: _react.PropTypes.func,
  btnGlyphicon: _react.PropTypes.string
};
ExportCSVButton.defaultProps = {
  btnText: _Const2.default.EXPORT_CSV_TEXT,
  btnContextual: 'btn-success',
  className: '',
  onClick: undefined,
  btnGlyphicon: 'glyphicon-export'
};

var _default = ExportCSVButton;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(exportCsvBtnDefaultClass, 'exportCsvBtnDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ExportCSVButton.js');

  __REACT_HOT_LOADER__.register(ExportCSVButton, 'ExportCSVButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ExportCSVButton.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ExportCSVButton.js');
}();

;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Const = __webpack_require__(35);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var insertBtnDefaultClass = 'react-bs-table-add-btn';

var InsertButton = function (_Component) {
  _inherits(InsertButton, _Component);

  function InsertButton() {
    _classCallCheck(this, InsertButton);

    return _possibleConstructorReturn(this, (InsertButton.__proto__ || Object.getPrototypeOf(InsertButton)).apply(this, arguments));
  }

  _createClass(InsertButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          btnContextual = _props.btnContextual,
          className = _props.className,
          onClick = _props.onClick,
          btnGlyphicon = _props.btnGlyphicon,
          btnText = _props.btnText,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['btnContextual', 'className', 'onClick', 'btnGlyphicon', 'btnText', 'children']);

      var content = children || _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement('i', { className: 'glyphicon ' + btnGlyphicon }),
        btnText
      );
      return _react2.default.createElement(
        'button',
        _extends({ type: 'button',
          className: 'btn ' + btnContextual + ' ' + insertBtnDefaultClass + ' ' + className,
          onClick: onClick
        }, rest),
        content
      );
    }
  }]);

  return InsertButton;
}(_react.Component);

InsertButton.propTypes = {
  btnText: _react.PropTypes.string,
  btnContextual: _react.PropTypes.string,
  className: _react.PropTypes.string,
  onClick: _react.PropTypes.func,
  btnGlyphicon: _react.PropTypes.string
};
InsertButton.defaultProps = {
  btnText: _Const2.default.INSERT_BTN_TEXT,
  btnContextual: 'btn-info',
  className: '',
  onClick: undefined,
  btnGlyphicon: 'glyphicon-plus'
};

var _default = InsertButton;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(insertBtnDefaultClass, 'insertBtnDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertButton.js');

  __REACT_HOT_LOADER__.register(InsertButton, 'InsertButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertButton.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertButton.js');
}();

;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Editor = __webpack_require__(558);

var _Editor2 = _interopRequireDefault(_Editor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/display-name: 0 */


var InsertModalBody = function (_Component) {
  _inherits(InsertModalBody, _Component);

  function InsertModalBody() {
    _classCallCheck(this, InsertModalBody);

    return _possibleConstructorReturn(this, (InsertModalBody.__proto__ || Object.getPrototypeOf(InsertModalBody)).apply(this, arguments));
  }

  _createClass(InsertModalBody, [{
    key: 'getFieldValue',
    value: function getFieldValue() {
      var _this2 = this;

      var newRow = {};
      this.props.columns.forEach(function (column, i) {
        var inputVal = void 0;
        if (column.autoValue) {
          // when you want same auto generate value and not allow edit, example ID field
          var time = new Date().getTime();
          inputVal = typeof column.autoValue === 'function' ? column.autoValue() : 'autovalue-' + time;
        } else if (column.hiddenOnInsert || !column.field) {
          inputVal = '';
        } else {
          var dom = _this2.refs[column.field + i];
          inputVal = dom.value;

          if (column.editable && column.editable.type === 'checkbox') {
            var values = inputVal.split(':');
            inputVal = dom.checked ? values[0] : values[1];
          } else if (column.customInsertEditor) {
            inputVal = inputVal || dom.getFieldValue();
          }
        }
        newRow[column.field] = inputVal;
      }, this);
      return newRow;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          columns = _props.columns,
          validateState = _props.validateState,
          ignoreEditable = _props.ignoreEditable;

      return _react2.default.createElement(
        'div',
        { className: 'modal-body' },
        columns.map(function (column, i) {
          var editable = column.editable,
              format = column.format,
              field = column.field,
              name = column.name,
              autoValue = column.autoValue,
              hiddenOnInsert = column.hiddenOnInsert,
              customInsertEditor = column.customInsertEditor;

          var attr = {
            ref: field + i,
            placeholder: editable.placeholder ? editable.placeholder : name
          };
          var fieldElement = void 0;
          var defaultValue = editable.defaultValue || undefined;
          if (customInsertEditor) {
            var getElement = customInsertEditor.getElement;

            fieldElement = getElement(column, attr, 'form-control', ignoreEditable, defaultValue);
          }

          // fieldElement = false, means to use default editor when enable custom editor
          // Becasuse some users want to have default editor based on some condition.
          if (!customInsertEditor || fieldElement === false) {
            fieldElement = (0, _Editor2.default)(editable, attr, format, '', defaultValue, ignoreEditable);
          }

          if (autoValue || hiddenOnInsert || !column.field) {
            // when you want same auto generate value
            // and not allow edit, for example ID field
            return null;
          }
          var error = validateState[field] ? _react2.default.createElement(
            'span',
            { className: 'help-block bg-danger' },
            validateState[field]
          ) : null;
          return _react2.default.createElement(
            'div',
            { className: 'form-group', key: field },
            _react2.default.createElement(
              'label',
              null,
              name
            ),
            fieldElement,
            error
          );
        })
      );
    }
  }]);

  return InsertModalBody;
}(_react.Component);

InsertModalBody.propTypes = {
  columns: _react.PropTypes.array,
  validateState: _react.PropTypes.object,
  ignoreEditable: _react.PropTypes.bool
};

InsertModalBody.defaultProps = {
  validateState: {},
  ignoreEditable: false
};

var _default = InsertModalBody;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(InsertModalBody, 'InsertModalBody', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalBody.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalBody.js');
}();

;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Const = __webpack_require__(35);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InsertModalFooter = function (_Component) {
  _inherits(InsertModalFooter, _Component);

  function InsertModalFooter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InsertModalFooter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InsertModalFooter.__proto__ || Object.getPrototypeOf(InsertModalFooter)).call.apply(_ref, [this].concat(args))), _this), _this.handleCloseBtnClick = function () {
      var _this2;

      return (_this2 = _this).__handleCloseBtnClick__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _this.handleSaveBtnClick = function () {
      var _this3;

      return (_this3 = _this).__handleSaveBtnClick__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InsertModalFooter, [{
    key: '__handleCloseBtnClick__REACT_HOT_LOADER__',
    value: function __handleCloseBtnClick__REACT_HOT_LOADER__(e) {
      var _props = this.props,
          beforeClose = _props.beforeClose,
          onModalClose = _props.onModalClose;

      beforeClose && beforeClose(e);
      onModalClose();
    }
  }, {
    key: '__handleSaveBtnClick__REACT_HOT_LOADER__',
    value: function __handleSaveBtnClick__REACT_HOT_LOADER__(e) {
      var _props2 = this.props,
          beforeSave = _props2.beforeSave,
          onSave = _props2.onSave;

      beforeSave && beforeSave(e);
      onSave();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          className = _props3.className,
          saveBtnText = _props3.saveBtnText,
          closeBtnText = _props3.closeBtnText,
          closeBtnContextual = _props3.closeBtnContextual,
          saveBtnContextual = _props3.saveBtnContextual,
          closeBtnClass = _props3.closeBtnClass,
          saveBtnClass = _props3.saveBtnClass,
          children = _props3.children;


      var content = children || _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'btn ' + closeBtnContextual + ' ' + closeBtnClass,
            onClick: this.handleCloseBtnClick },
          closeBtnText
        ),
        _react2.default.createElement(
          'button',
          {
            type: 'button',
            className: 'btn ' + saveBtnContextual + ' ' + saveBtnClass,
            onClick: this.handleSaveBtnClick },
          saveBtnText
        )
      );

      return _react2.default.createElement(
        'div',
        { className: 'modal-footer ' + className },
        content
      );
    }
  }]);

  return InsertModalFooter;
}(_react.Component);

InsertModalFooter.propTypes = {
  className: _react.PropTypes.string,
  saveBtnText: _react.PropTypes.string,
  closeBtnText: _react.PropTypes.string,
  closeBtnContextual: _react.PropTypes.string,
  saveBtnContextual: _react.PropTypes.string,
  closeBtnClass: _react.PropTypes.string,
  saveBtnClass: _react.PropTypes.string,
  beforeClose: _react.PropTypes.func,
  beforeSave: _react.PropTypes.func,
  onSave: _react.PropTypes.func,
  onModalClose: _react.PropTypes.func
};
InsertModalFooter.defaultProps = {
  className: '',
  saveBtnText: _Const2.default.SAVE_BTN_TEXT,
  closeBtnText: _Const2.default.CLOSE_BTN_TEXT,
  closeBtnContextual: 'btn-default',
  saveBtnContextual: 'btn-primary',
  closeBtnClass: '',
  saveBtnClass: '',
  beforeClose: undefined,
  beforeSave: undefined
};

var _default = InsertModalFooter;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(InsertModalFooter, 'InsertModalFooter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalFooter.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalFooter.js');
}();

;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InsertModalHeader = function (_Component) {
  _inherits(InsertModalHeader, _Component);

  function InsertModalHeader() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InsertModalHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InsertModalHeader.__proto__ || Object.getPrototypeOf(InsertModalHeader)).call.apply(_ref, [this].concat(args))), _this), _this.handleCloseBtnClick = function () {
      var _this2;

      return (_this2 = _this).__handleCloseBtnClick__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InsertModalHeader, [{
    key: '__handleCloseBtnClick__REACT_HOT_LOADER__',
    value: function __handleCloseBtnClick__REACT_HOT_LOADER__(e) {
      var _props = this.props,
          onModalClose = _props.onModalClose,
          beforeClose = _props.beforeClose;

      beforeClose && beforeClose(e);
      onModalClose();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          title = _props2.title,
          hideClose = _props2.hideClose,
          className = _props2.className,
          children = _props2.children;


      var closeBtn = hideClose ? null : _react2.default.createElement(
        'button',
        { type: 'button',
          className: 'close', onClick: this.handleCloseBtnClick },
        _react2.default.createElement(
          'span',
          { 'aria-hidden': 'true' },
          '\xD7'
        ),
        _react2.default.createElement(
          'span',
          { className: 'sr-only' },
          'Close'
        )
      );

      var content = children || _react2.default.createElement(
        'span',
        null,
        closeBtn,
        _react2.default.createElement(
          'h4',
          { className: 'modal-title' },
          title
        )
      );

      return _react2.default.createElement(
        'div',
        { className: 'modal-header ' + className },
        content
      );
    }
  }]);

  return InsertModalHeader;
}(_react.Component);

InsertModalHeader.propTypes = {
  className: _react.PropTypes.string,
  title: _react.PropTypes.string,
  onModalClose: _react.PropTypes.func,
  hideClose: _react.PropTypes.bool,
  beforeClose: _react.PropTypes.func
};
InsertModalHeader.defaultProps = {
  className: '',
  title: 'Add Row',
  onModalClose: undefined,
  hideClose: false,
  beforeClose: undefined
};

var _default = InsertModalHeader;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(InsertModalHeader, 'InsertModalHeader', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalHeader.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModalHeader.js');
}();

;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(33);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchField = function (_Component) {
  _inherits(SearchField, _Component);

  function SearchField() {
    _classCallCheck(this, SearchField);

    return _possibleConstructorReturn(this, (SearchField.__proto__ || Object.getPrototypeOf(SearchField)).apply(this, arguments));
  }

  _createClass(SearchField, [{
    key: 'getValue',
    value: function getValue() {
      return _reactDom2.default.findDOMNode(this).value;
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      _reactDom2.default.findDOMNode(this).value = value;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          defaultValue = _props.defaultValue,
          placeholder = _props.placeholder,
          onKeyUp = _props.onKeyUp,
          rest = _objectWithoutProperties(_props, ['className', 'defaultValue', 'placeholder', 'onKeyUp']);

      return _react2.default.createElement('input', _extends({
        className: 'form-control ' + className,
        type: 'text',
        defaultValue: defaultValue,
        placeholder: placeholder || SearchField.defaultProps.placeholder,
        onKeyUp: onKeyUp,
        style: { zIndex: 0 }
      }, rest));
    }
  }]);

  return SearchField;
}(_react.Component);

SearchField.propTypes = {
  className: _react.PropTypes.string,
  defaultValue: _react.PropTypes.string,
  placeholder: _react.PropTypes.string,
  onKeyUp: _react.PropTypes.func
};
SearchField.defaultProps = {
  className: '',
  defaultValue: '',
  placeholder: 'Search',
  onKeyUp: undefined
};

var _default = SearchField;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SearchField, 'SearchField', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/SearchField.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/SearchField.js');
}();

;

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Const = __webpack_require__(35);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var showSelectedOnlyBtnDefaultClass = 'react-bs-table-show-sel-only-btn';

var ShowSelectedOnlyButton = function (_Component) {
  _inherits(ShowSelectedOnlyButton, _Component);

  function ShowSelectedOnlyButton() {
    _classCallCheck(this, ShowSelectedOnlyButton);

    return _possibleConstructorReturn(this, (ShowSelectedOnlyButton.__proto__ || Object.getPrototypeOf(ShowSelectedOnlyButton)).apply(this, arguments));
  }

  _createClass(ShowSelectedOnlyButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          btnContextual = _props.btnContextual,
          className = _props.className,
          onClick = _props.onClick,
          toggle = _props.toggle,
          showAllText = _props.showAllText,
          showOnlySelectText = _props.showOnlySelectText,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['btnContextual', 'className', 'onClick', 'toggle', 'showAllText', 'showOnlySelectText', 'children']);

      var content = children || _react2.default.createElement(
        'span',
        null,
        toggle ? showOnlySelectText : showAllText
      );
      return _react2.default.createElement(
        'button',
        _extends({ type: 'button',
          'aria-pressed': 'false',
          'data-toggle': 'button',
          className: 'btn ' + btnContextual + ' ' + showSelectedOnlyBtnDefaultClass + ' ' + className,
          onClick: onClick
        }, rest),
        content
      );
    }
  }]);

  return ShowSelectedOnlyButton;
}(_react.Component);

ShowSelectedOnlyButton.propTypes = {
  showAllText: _react.PropTypes.string,
  showOnlySelectText: _react.PropTypes.string,
  toggle: _react.PropTypes.bool,
  btnContextual: _react.PropTypes.string,
  className: _react.PropTypes.string,
  onClick: _react.PropTypes.func
};
ShowSelectedOnlyButton.defaultProps = {
  showAllText: _Const2.default.SHOW_ALL,
  showOnlySelectText: _Const2.default.SHOW_ONLY_SELECT,
  toggle: false,
  btnContextual: 'btn-primary',
  className: '',
  onClick: undefined
};

var _default = ShowSelectedOnlyButton;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(showSelectedOnlyBtnDefaultClass, 'showSelectedOnlyBtnDefaultClass', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ShowSelectedOnlyButton.js');

  __REACT_HOT_LOADER__.register(ShowSelectedOnlyButton, 'ShowSelectedOnlyButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ShowSelectedOnlyButton.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ShowSelectedOnlyButton.js');
}();

;

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(64);











var propTypes = {
  /**
   * If set to true, renders `span` instead of `a`
   */
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * `href` attribute for the inner `a` element
   */
  href: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * `title` attribute for the inner `a` element
   */
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  /**
   * `target` attribute for the inner `a` element
   */
  target: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var defaultProps = {
  active: false
};

var BreadcrumbItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(BreadcrumbItem, _React$Component);

  function BreadcrumbItem() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, BreadcrumbItem);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  BreadcrumbItem.prototype.render = function render() {
    var _props = this.props,
        active = _props.active,
        href = _props.href,
        title = _props.title,
        target = _props.target,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['active', 'href', 'title', 'target', 'className']);

    // Don't try to render these props on non-active <span>.


    var linkProps = { href: href, title: title, target: target };

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active }) },
      active ? __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', props) : __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, linkProps))
    );
  };

  return BreadcrumbItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

BreadcrumbItem.propTypes = propTypes;
BreadcrumbItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (BreadcrumbItem);

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_TransitionEvents__ = __webpack_require__(1394);












// TODO: This should use a timeout instead of TransitionEvents, or else just
// not wait until transition end to trigger continuing animations.

var propTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['prev', 'next']),
  onAnimateOutEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  animateIn: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  animateOut: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  index: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number
};

var defaultProps = {
  active: false,
  animateIn: false,
  animateOut: false
};

var CarouselItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CarouselItem, _React$Component);

  function CarouselItem(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CarouselItem);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind(_this);

    _this.state = {
      direction: null
    };

    _this.isUnmounted = false;
    return _this;
  }

  CarouselItem.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.active !== nextProps.active) {
      this.setState({ direction: null });
    }
  };

  CarouselItem.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    var active = this.props.active;

    var prevActive = prevProps.active;

    if (!active && prevActive) {
      __WEBPACK_IMPORTED_MODULE_9__utils_TransitionEvents__["a" /* default */].addEndEventListener(__WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(this), this.handleAnimateOutEnd);
    }

    if (active !== prevActive) {
      setTimeout(function () {
        return _this2.startAnimation();
      }, 20);
    }
  };

  CarouselItem.prototype.componentWillUnmount = function componentWillUnmount() {
    this.isUnmounted = true;
  };

  CarouselItem.prototype.handleAnimateOutEnd = function handleAnimateOutEnd() {
    if (this.isUnmounted) {
      return;
    }

    if (this.props.onAnimateOutEnd) {
      this.props.onAnimateOutEnd(this.props.index);
    }
  };

  CarouselItem.prototype.startAnimation = function startAnimation() {
    if (this.isUnmounted) {
      return;
    }

    this.setState({
      direction: this.props.direction === 'prev' ? 'right' : 'left'
    });
  };

  CarouselItem.prototype.render = function render() {
    var _props = this.props,
        direction = _props.direction,
        active = _props.active,
        animateIn = _props.animateIn,
        animateOut = _props.animateOut,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['direction', 'active', 'animateIn', 'animateOut', 'className']);

    delete props.onAnimateOutEnd;
    delete props.index;

    var classes = {
      item: true,
      active: active && !animateIn || animateOut
    };
    if (direction && active && animateIn) {
      classes[direction] = true;
    }
    if (this.state.direction && (animateIn || animateOut)) {
      classes[this.state.direction] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return CarouselItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

CarouselItem.propTypes = propTypes;
CarouselItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (CarouselItem);

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Button__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(20);













var propTypes = {
  noCaret: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  open: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  useAnchor: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};

var defaultProps = {
  open: false,
  useAnchor: false,
  bsRole: 'toggle'
};

var DropdownToggle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DropdownToggle, _React$Component);

  function DropdownToggle() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, DropdownToggle);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  DropdownToggle.prototype.render = function render() {
    var _props = this.props,
        noCaret = _props.noCaret,
        open = _props.open,
        useAnchor = _props.useAnchor,
        bsClass = _props.bsClass,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['noCaret', 'open', 'useAnchor', 'bsClass', 'className', 'children']);

    delete props.bsRole;

    var Component = useAnchor ? __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_8__Button__["a" /* default */];
    var useCaret = !noCaret;

    // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.

    // FIXME: Should this really fall back to `title` as children?

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        role: 'button',
        className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()(className, bsClass),
        'aria-haspopup': true,
        'aria-expanded': open
      }),
      children || props.title,
      useCaret && ' ',
      useCaret && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('span', { className: 'caret' })
    );
  };

  return DropdownToggle;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

DropdownToggle.propTypes = propTypes;
DropdownToggle.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["c" /* bsClass */])('dropdown-toggle', DropdownToggle));

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(20);












var propTypes = {
  /**
   * Turn any fixed-width grid layout into a full-width layout by this property.
   *
   * Adds `container-fluid` class.
   */
  fluid: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * You can use a custom element for this component
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div',
  fluid: false
};

var Grid = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Grid, _React$Component);

  function Grid() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Grid);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Grid.prototype.render = function render() {
    var _props = this.props,
        fluid = _props.fluid,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['fluid', 'componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, fluid && 'fluid');

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Grid;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Grid.propTypes = propTypes;
Grid.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('container', Grid));

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(42);













var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  disabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  header: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  listItem: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  href: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

var defaultProps = {
  listItem: false
};

var ListGroupItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ListGroupItem, _React$Component);

  function ListGroupItem() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ListGroupItem);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ListGroupItem.prototype.renderHeader = function renderHeader(header, headingClassName) {
    if (__WEBPACK_IMPORTED_MODULE_7_react___default.a.isValidElement(header)) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(header, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(header.props.className, headingClassName)
      });
    }

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'h4',
      { className: headingClassName },
      header
    );
  };

  ListGroupItem.prototype.render = function render() {
    var _props = this.props,
        active = _props.active,
        disabled = _props.disabled,
        className = _props.className,
        header = _props.header,
        listItem = _props.listItem,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['active', 'disabled', 'className', 'header', 'listItem', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), {
      active: active,
      disabled: disabled
    });

    var Component = void 0;

    if (elementProps.href) {
      Component = 'a';
    } else if (elementProps.onClick) {
      Component = 'button';
      elementProps.type = elementProps.type || 'button';
    } else if (listItem) {
      Component = 'li';
    } else {
      Component = 'span';
    }

    elementProps.className = __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes);

    // TODO: Deprecate `header` prop.
    if (header) {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        Component,
        elementProps,
        this.renderHeader(header, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'heading')),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'p',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'text') },
          children
        )
      );
    }

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      Component,
      elementProps,
      children
    );
  };

  return ListGroupItem;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

ListGroupItem.propTypes = propTypes;
ListGroupItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('list-group-item', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["c" /* State */]), ListGroupItem)));

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(20);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var ModalBody = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalBody, _React$Component);

  function ModalBody() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalBody);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalBody.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ModalBody;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalBody.propTypes = propTypes;
ModalBody.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('modal-body', ModalBody));

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(20);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var ModalFooter = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalFooter, _React$Component);

  function ModalFooter() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalFooter);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalFooter.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ModalFooter;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalFooter.propTypes = propTypes;
ModalFooter.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('modal-footer', ModalFooter));

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CloseButton__ = __webpack_require__(325);













// TODO: `aria-label` should be `closeLabel`.

var propTypes = {
  /**
   * Provides an accessible label for the close
   * button. It is used for Assistive Technology when the label text is not
   * readable.
   */
  closeLabel: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /**
   * Specify whether the Component should contain a close button
   */
  closeButton: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * A Callback fired when the close button is clicked. If used directly inside
   * a Modal component, the onHide will automatically be propagated up to the
   * parent Modal `onHide`.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  closeLabel: 'Close',
  closeButton: false
};

var contextTypes = {
  $bs_modal: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    onHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
  })
};

var ModalHeader = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalHeader, _React$Component);

  function ModalHeader() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalHeader);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalHeader.prototype.render = function render() {
    var _props = this.props,
        closeLabel = _props.closeLabel,
        closeButton = _props.closeButton,
        onHide = _props.onHide,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['closeLabel', 'closeButton', 'onHide', 'className', 'children']);

    var modal = this.context.$bs_modal;

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      closeButton && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__CloseButton__["a" /* default */], {
        label: closeLabel,
        onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(modal && modal.onHide, onHide)
      }),
      children
    );
  };

  return ModalHeader;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalHeader.propTypes = propTypes;
ModalHeader.defaultProps = defaultProps;
ModalHeader.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('modal-header', ModalHeader));

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(20);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'h4'
};

var ModalTitle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalTitle, _React$Component);

  function ModalTitle() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalTitle);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalTitle.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ModalTitle;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalTitle.propTypes = propTypes;
ModalTitle.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('modal-title', ModalTitle));

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_keycode__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types_extra_lib_all__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_warning__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__ = __webpack_require__(46);

















// TODO: Should we expose `<NavItem>` as `<Nav.Item>`?

// TODO: This `bsStyle` is very unlike the others. Should we rename it?

// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
// Consider renaming or replacing them.

var propTypes = {
  /**
   * Marks the NavItem with a matching `eventKey` as active. Has a
   * higher precedence over `activeHref`.
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,

  /**
   * Marks the child NavItem with a matching `href` prop as active.
   */
  activeHref: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,

  /**
   * NavItems are be positioned vertically.
   */
  stacked: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  justified: __WEBPACK_IMPORTED_MODULE_10_prop_types_extra_lib_all___default()(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool, function (_ref) {
    var justified = _ref.justified,
        navbar = _ref.navbar;
    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
  }),

  /**
   * A callback fired when a NavItem is selected.
   *
   * ```js
   * function (
   *  Any eventKey,
   *  SyntheticEvent event?
   * )
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,

  /**
   * ARIA role for the Nav, in the context of a TabContainer, the default will
   * be set to "tablist", but can be overridden by the Nav when set explicitly.
   *
   * When the role is set to "tablist" NavItem focus is managed according to
   * the ARIA authoring practices for tabs:
   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
   */
  role: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,

  /**
   * Apply styling an alignment for use in a Navbar. This prop will be set
   * automatically when the Nav is used inside a Navbar.
   */
  navbar: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Float the Nav to the right. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullRight: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,

  /**
   * Float the Nav to the left. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullLeft: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};

var defaultProps = {
  justified: false,
  pullRight: false,
  pullLeft: false,
  stacked: false
};

var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
    onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
  }),

  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
    onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
    getTabId: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,
    getPaneId: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired
  })
};

var Nav = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Nav, _React$Component);

  function Nav() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Nav);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Nav.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    if (!this._needsRefocus) {
      return;
    }

    this._needsRefocus = false;

    var children = this.props.children;

    var _getActiveProps = this.getActiveProps(),
        activeKey = _getActiveProps.activeKey,
        activeHref = _getActiveProps.activeHref;

    var activeChild = __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].find(children, function (child) {
      return _this2.isActive(child, activeKey, activeHref);
    });

    var childrenArray = __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].toArray(children);
    var activeChildIndex = childrenArray.indexOf(activeChild);

    var childNodes = __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.findDOMNode(this).children;
    var activeNode = childNodes && childNodes[activeChildIndex];

    if (!activeNode || !activeNode.firstChild) {
      return;
    }

    activeNode.firstChild.focus();
  };

  Nav.prototype.getActiveProps = function getActiveProps() {
    var tabContainer = this.context.$bs_tabContainer;

    if (tabContainer) {
       false ? warning(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ('activeKey={' + this.props.activeKey + '} />`.')) : void 0;

      return tabContainer;
    }

    return this.props;
  };

  Nav.prototype.getNextActiveChild = function getNextActiveChild(offset) {
    var _this3 = this;

    var children = this.props.children;

    var validChildren = children.filter(function (child) {
      return child.props.eventKey != null && !child.props.disabled;
    });

    var _getActiveProps2 = this.getActiveProps(),
        activeKey = _getActiveProps2.activeKey,
        activeHref = _getActiveProps2.activeHref;

    var activeChild = __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].find(children, function (child) {
      return _this3.isActive(child, activeKey, activeHref);
    });

    // This assumes the active child is not disabled.
    var activeChildIndex = validChildren.indexOf(activeChild);
    if (activeChildIndex === -1) {
      // Something has gone wrong. Select the first valid child we can find.
      return validChildren[0];
    }

    var nextIndex = activeChildIndex + offset;
    var numValidChildren = validChildren.length;

    if (nextIndex >= numValidChildren) {
      nextIndex = 0;
    } else if (nextIndex < 0) {
      nextIndex = numValidChildren - 1;
    }

    return validChildren[nextIndex];
  };

  Nav.prototype.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
    var _this4 = this;

    if (!tabContainer && navRole !== 'tablist') {
      // No tab props here.
      return null;
    }

    var _child$props = child.props,
        id = _child$props.id,
        controls = _child$props['aria-controls'],
        eventKey = _child$props.eventKey,
        role = _child$props.role,
        onKeyDown = _child$props.onKeyDown,
        tabIndex = _child$props.tabIndex;


    if (tabContainer) {
       false ? warning(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;

      id = tabContainer.getTabId(eventKey);
      controls = tabContainer.getPaneId(eventKey);
    }

    if (navRole === 'tablist') {
      role = role || 'tab';
      onKeyDown = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__["a" /* default */])(function (event) {
        return _this4.handleTabKeyDown(onSelect, event);
      }, onKeyDown);
      tabIndex = active ? tabIndex : -1;
    }

    return {
      id: id,
      role: role,
      onKeyDown: onKeyDown,
      'aria-controls': controls,
      tabIndex: tabIndex
    };
  };

  Nav.prototype.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
    var nextActiveChild = void 0;

    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.left:
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.up:
        nextActiveChild = this.getNextActiveChild(-1);
        break;
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.right:
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.down:
        nextActiveChild = this.getNextActiveChild(1);
        break;
      default:
        // It was a different key; don't handle this keypress.
        return;
    }

    event.preventDefault();

    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
      onSelect(nextActiveChild.props.eventKey);
    }

    this._needsRefocus = true;
  };

  Nav.prototype.isActive = function isActive(_ref2, activeKey, activeHref) {
    var props = _ref2.props;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    return props.active;
  };

  Nav.prototype.render = function render() {
    var _extends2,
        _this5 = this;

    var _props = this.props,
        stacked = _props.stacked,
        justified = _props.justified,
        onSelect = _props.onSelect,
        propsRole = _props.role,
        propsNavbar = _props.navbar,
        pullRight = _props.pullRight,
        pullLeft = _props.pullLeft,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['stacked', 'justified', 'onSelect', 'role', 'navbar', 'pullRight', 'pullLeft', 'className', 'children']);

    var tabContainer = this.context.$bs_tabContainer;
    var role = propsRole || (tabContainer ? 'tablist' : null);

    var _getActiveProps3 = this.getActiveProps(),
        activeKey = _getActiveProps3.activeKey,
        activeHref = _getActiveProps3.activeHref;

    delete props.activeKey; // Accessed via this.getActiveProps().
    delete props.activeHref; // Accessed via this.getActiveProps().

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'stacked')] = stacked, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'justified')] = justified, _extends2));

    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
    var pullLeftClassName = void 0;
    var pullRightClassName = void 0;

    if (navbar) {
      var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

      classes[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'nav')] = true;

      pullRightClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'right');
      pullLeftClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'left');
    } else {
      pullRightClassName = 'pull-right';
      pullLeftClassName = 'pull-left';
    }

    classes[pullRightClassName] = pullRight;
    classes[pullLeftClassName] = pullLeft;

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'ul',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: role,
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        var active = _this5.isActive(child, activeKey, activeHref);
        var childOnSelect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(child, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this5.getTabProps(child, tabContainer, role, active, childOnSelect), {
          active: active,
          activeKey: activeKey,
          activeHref: activeHref,
          onSelect: childOnSelect
        }));
      })
    );
  };

  return Nav;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Nav.propTypes = propTypes;
Nav.defaultProps = defaultProps;
Nav.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["c" /* bsClass */])('nav', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["f" /* bsStyles */])(['tabs', 'pills'], Nav)));

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(41);












var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
};

var defaultProps = {
  active: false,
  disabled: false
};

var NavItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavItem, _React$Component);

  function NavItem(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavItem);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  NavItem.prototype.handleClick = function handleClick(e) {
    if (this.props.onSelect) {
      e.preventDefault();

      if (!this.props.disabled) {
        this.props.onSelect(this.props.eventKey, e);
      }
    }
  };

  NavItem.prototype.render = function render() {
    var _props = this.props,
        active = _props.active,
        disabled = _props.disabled,
        onClick = _props.onClick,
        className = _props.className,
        style = _props.style,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['active', 'disabled', 'onClick', 'className', 'style']);

    delete props.onSelect;
    delete props.eventKey;

    // These are injected down by `<Nav>` for building `<SubNav>`s.
    delete props.activeKey;
    delete props.activeHref;

    if (!props.role) {
      if (props.href === '#') {
        props.role = 'button';
      }
    } else if (props.role === 'tab') {
      props['aria-selected'] = active;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      {
        role: 'presentation',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active, disabled: disabled }),
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        disabled: disabled,
        onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(onClick, this.handleClick)
      }))
    );
  };

  return NavItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavItem.propTypes = propTypes;
NavItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (NavItem);

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(20);











var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
  })
};

var NavbarBrand = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavbarBrand, _React$Component);

  function NavbarBrand() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavbarBrand);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavbarBrand.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var bsClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'brand');

    if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(children.props.className, className, bsClassName)
      });
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'span',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, bsClassName) }),
      children
    );
  };

  return NavbarBrand;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavbarBrand.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavbarBrand);

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Fade__ = __webpack_require__(213);













var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay___default.a.propTypes, {

  /**
   * Set the visibility of the Overlay
   */
  show: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
   */
  rootClose: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * A callback invoked by the overlay when it wishes to be hidden. Required if
   * `rootClose` is specified.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Use animation
   */
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_9_prop_types_extra_lib_elementType___default.a]),

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Sets the direction of the Overlay.
   */
  placement: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left'])
});

var defaultProps = {
  animation: __WEBPACK_IMPORTED_MODULE_10__Fade__["a" /* default */],
  rootClose: false,
  show: false,
  placement: 'right'
};

var Overlay = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Overlay, _React$Component);

  function Overlay() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Overlay);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Overlay.prototype.render = function render() {
    var _props = this.props,
        animation = _props.animation,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['animation', 'children']);

    var transition = animation === true ? __WEBPACK_IMPORTED_MODULE_10__Fade__["a" /* default */] : animation || null;

    var child = void 0;

    if (!transition) {
      child = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(children, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(children.props.className, 'in')
      });
    } else {
      child = children;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_react_overlays_lib_Overlay___default.a,
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, props, {
        transition: transition
      }),
      child
    );
  };

  return Overlay;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Overlay.propTypes = propTypes;
Overlay.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (Overlay);

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(41);












var propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  previous: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  next: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
};

var defaultProps = {
  disabled: false,
  previous: false,
  next: false
};

var PagerItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PagerItem, _React$Component);

  function PagerItem(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PagerItem);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleSelect = _this.handleSelect.bind(_this);
    return _this;
  }

  PagerItem.prototype.handleSelect = function handleSelect(e) {
    var _props = this.props,
        disabled = _props.disabled,
        onSelect = _props.onSelect,
        eventKey = _props.eventKey;


    if (onSelect || disabled) {
      e.preventDefault();
    }

    if (disabled) {
      return;
    }

    if (onSelect) {
      onSelect(eventKey, e);
    }
  };

  PagerItem.prototype.render = function render() {
    var _props2 = this.props,
        disabled = _props2.disabled,
        previous = _props2.previous,
        next = _props2.next,
        onClick = _props2.onClick,
        className = _props2.className,
        style = _props2.style,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['disabled', 'previous', 'next', 'onClick', 'className', 'style']);

    delete props.onSelect;
    delete props.eventKey;

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { disabled: disabled, previous: previous, next: next }),
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        disabled: disabled,
        onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(onClick, this.handleSelect)
      }))
    );
  };

  return PagerItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

PagerItem.propTypes = propTypes;
PagerItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (PagerItem);

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(41);













// TODO: This should be `<Pagination.Item>`.

// TODO: This should use `componentClass` like other components.

var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  componentClass: __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__["a" /* default */],
  active: false,
  disabled: false
};

var PaginationButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PaginationButton, _React$Component);

  function PaginationButton(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PaginationButton);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  PaginationButton.prototype.handleClick = function handleClick(event) {
    var _props = this.props,
        disabled = _props.disabled,
        onSelect = _props.onSelect,
        eventKey = _props.eventKey;


    if (disabled) {
      return;
    }

    if (onSelect) {
      onSelect(eventKey, event);
    }
  };

  PaginationButton.prototype.render = function render() {
    var _props2 = this.props,
        Component = _props2.componentClass,
        active = _props2.active,
        disabled = _props2.disabled,
        onClick = _props2.onClick,
        className = _props2.className,
        style = _props2.style,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['componentClass', 'active', 'disabled', 'onClick', 'className', 'style']);

    if (Component === __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__["a" /* default */]) {
      // Assume that custom components want `eventKey`.
      delete props.eventKey;
    }

    delete props.onSelect;

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active, disabled: disabled }),
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        disabled: disabled,
        onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(onClick, this.handleClick)
      }))
    );
  };

  return PaginationButton;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

PaginationButton.propTypes = propTypes;
PaginationButton.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (PaginationButton);

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__ = __webpack_require__(46);














var propTypes = {
  accordion: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  activeKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  defaultActiveKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  role: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

var defaultProps = {
  accordion: false
};

// TODO: Use uncontrollable.

var PanelGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(PanelGroup, _React$Component);

  function PanelGroup(props, context) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, PanelGroup);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleSelect = _this.handleSelect.bind(_this);

    _this.state = {
      activeKey: props.defaultActiveKey
    };
    return _this;
  }

  PanelGroup.prototype.handleSelect = function handleSelect(key, e) {
    e.preventDefault();

    if (this.props.onSelect) {
      this.props.onSelect(key, e);
    }

    if (this.state.activeKey === key) {
      key = null;
    }

    this.setState({ activeKey: key });
  };

  PanelGroup.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        accordion = _props.accordion,
        propsActiveKey = _props.activeKey,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['accordion', 'activeKey', 'className', 'children']);

    var _splitBsPropsAndOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['defaultActiveKey', 'onSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var activeKey = void 0;
    if (accordion) {
      activeKey = propsActiveKey != null ? propsActiveKey : this.state.activeKey;
      elementProps.role = elementProps.role || 'tablist';
    }

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        var childProps = {
          bsStyle: child.props.bsStyle || bsProps.bsStyle
        };

        if (accordion) {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(childProps, {
            headerRole: 'tab',
            panelRole: 'tabpanel',
            collapsible: true,
            expanded: child.props.eventKey === activeKey,
            onSelect: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(_this2.handleSelect, child.props.onSelect)
          });
        }

        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(child, childProps);
      })
    );
  };

  return PanelGroup;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

PanelGroup.propTypes = propTypes;
PanelGroup.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('panel-group', PanelGroup));

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Fade__ = __webpack_require__(213);
















var propTypes = {
  /**
   * Uniquely identify the `<TabPane>` among its siblings.
   */
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,

  /**
   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
   * `true` to enable the default `<Fade>` animation or any `<Transition>`
   * component.
   */
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a]),

  /** @private * */
  id: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /** @private * */
  'aria-labelledby': __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /**
   * If not explicitly specified and rendered in the context of a
   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
   * If otherwise not explicitly specified, `tab-pane`.
   */
  bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /**
   * Transition onEnter callback when animation is not `false`
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onEntering callback when animation is not `false`
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onEntered callback when animation is not `false`
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onExit callback when animation is not `false`
   */
  onExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onExiting callback when animation is not `false`
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Transition onExited callback when animation is not `false`
   */
  onExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Unmount the tab (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var contextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    getTabId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
    getPaneId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
  }),
  $bs_tabContent: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a]),
    activeKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
    mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    onPaneEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    onPaneExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    exiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool.isRequired
  })
};

/**
 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
 * conflict with the top level one.
 */
var childContextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null])
};

var TabPane = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(TabPane, _React$Component);

  function TabPane(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, TabPane);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleEnter = _this.handleEnter.bind(_this);
    _this.handleExited = _this.handleExited.bind(_this);

    _this.in = false;
    return _this;
  }

  TabPane.prototype.getChildContext = function getChildContext() {
    return {
      $bs_tabContainer: null
    };
  };

  TabPane.prototype.componentDidMount = function componentDidMount() {
    if (this.shouldBeIn()) {
      // In lieu of the action event firing.
      this.handleEnter();
    }
  };

  TabPane.prototype.componentDidUpdate = function componentDidUpdate() {
    if (this.in) {
      if (!this.shouldBeIn()) {
        // We shouldn't be active any more. Notify the parent.
        this.handleExited();
      }
    } else if (this.shouldBeIn()) {
      // We are the active child. Notify the parent.
      this.handleEnter();
    }
  };

  TabPane.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.in) {
      // In lieu of the action event firing.
      this.handleExited();
    }
  };

  TabPane.prototype.getAnimation = function getAnimation() {
    if (this.props.animation != null) {
      return this.props.animation;
    }

    var tabContent = this.context.$bs_tabContent;
    return tabContent && tabContent.animation;
  };

  TabPane.prototype.handleEnter = function handleEnter() {
    var tabContent = this.context.$bs_tabContent;
    if (!tabContent) {
      return;
    }

    this.in = tabContent.onPaneEnter(this, this.props.eventKey);
  };

  TabPane.prototype.handleExited = function handleExited() {
    var tabContent = this.context.$bs_tabContent;
    if (!tabContent) {
      return;
    }

    tabContent.onPaneExited(this);
    this.in = false;
  };

  TabPane.prototype.isActive = function isActive() {
    var tabContent = this.context.$bs_tabContent;
    var activeKey = tabContent && tabContent.activeKey;

    return this.props.eventKey === activeKey;
  };

  TabPane.prototype.shouldBeIn = function shouldBeIn() {
    return this.getAnimation() && this.isActive();
  };

  TabPane.prototype.render = function render() {
    var _props = this.props,
        eventKey = _props.eventKey,
        className = _props.className,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        onExited = _props.onExited,
        propsMountOnEnter = _props.mountOnEnter,
        propsUnmountOnExit = _props.unmountOnExit,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['eventKey', 'className', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited', 'mountOnEnter', 'unmountOnExit']);

    var _context = this.context,
        tabContent = _context.$bs_tabContent,
        tabContainer = _context.$bs_tabContainer;

    var _splitBsPropsAndOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['animation']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var active = this.isActive();
    var animation = this.getAnimation();

    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;

    if (!active && !animation && unmountOnExit) {
      return null;
    }

    var Transition = animation === true ? __WEBPACK_IMPORTED_MODULE_12__Fade__["a" /* default */] : animation || null;

    if (tabContent) {
      bsProps.bsClass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(tabContent, 'pane');
    }

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), {
      active: active
    });

    if (tabContainer) {
       false ? warning(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;

      elementProps.id = tabContainer.getPaneId(eventKey);
      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
    }

    var pane = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      role: 'tabpanel',
      'aria-hidden': !active,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));

    if (Transition) {
      var exiting = tabContent && tabContent.exiting;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        Transition,
        {
          'in': active && !exiting,
          onEnter: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleEnter, onEnter),
          onEntering: onEntering,
          onEntered: onEntered,
          onExit: onExit,
          onExiting: onExiting,
          onExited: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(this.handleExited, onExited),
          mountOnEnter: mountOnEnter,
          unmountOnExit: unmountOnExit
        },
        pane
      );
    }

    return pane;
  };

  return TabPane;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

TabPane.propTypes = propTypes;
TabPane.contextTypes = contextTypes;
TabPane.childContextTypes = childContextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["c" /* bsClass */])('tab-pane', TabPane));

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Button__ = __webpack_require__(169);










var propTypes = {
  /**
   * The `<input>` `type`
   * @type {[type]}
   */
  type: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['checkbox', 'radio']),

  /**
   * The HTML input name, used to group like checkboxes or radio buttons together
   * semantically
   */
  name: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * The checked state of the input, managed by `<ToggleButtonGroup>`` automatically
   */
  checked: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * The disabled state of both the label and input
   */
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * [onChange description]
   */
  onChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  /**
   * The value of the input, and unique identifier in the ToggleButtonGroup
   */
  value: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any.isRequired
};

var ToggleButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ToggleButton, _React$Component);

  function ToggleButton() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ToggleButton);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ToggleButton.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        name = _props.name,
        checked = _props.checked,
        type = _props.type,
        onChange = _props.onChange,
        value = _props.value,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['children', 'name', 'checked', 'type', 'onChange', 'value']);

    var disabled = props.disabled;

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__Button__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        active: !!checked,
        componentClass: 'label'
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('input', {
        name: name,
        type: type,
        autoComplete: 'off',
        value: value,
        checked: !!checked,
        disabled: !!disabled,
        onChange: onChange
      }),
      children
    );
  };

  return ToggleButton;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ToggleButton.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (ToggleButton);

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = capitalize;
function capitalize(string) {
  return "" + string.charAt(0).toUpperCase() + string.slice(1);
}

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function(f) {
  if (true) {
    module.exports = f(__webpack_require__(0));
    /* global define */
  } else if (typeof define === 'function' && define.amd) {
    define(['react'], f);
  } else {
    var g;
    if (typeof window !== 'undefined') {
      g = window;
    } else if (typeof global !== 'undefined') {
      g = global;
    } else if (typeof self !== 'undefined') {
      g = self;
    } else {
      g = this;
    }

    if (typeof g.React === 'undefined') {
      throw Error('React module should be required before ReactDOMFactories');
    }

    g.ReactDOMFactories = f(g.React);
  }
})(function(React) {
  /**
   * Create a factory that creates HTML tag elements.
   */
  function createDOMFactory(type) {
    var factory = React.createElement.bind(null, type);
    // Expose the type on the factory and the prototype so that it can be
    // easily accessed on elements. E.g. `<Foo />.type === Foo`.
    // This should not be named `constructor` since this may not be the function
    // that created the element, and it may not even be a constructor.
    factory.type = type;
    return factory;
  };

  /**
   * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
   */
  var ReactDOMFactories = {
    a: createDOMFactory('a'),
    abbr: createDOMFactory('abbr'),
    address: createDOMFactory('address'),
    area: createDOMFactory('area'),
    article: createDOMFactory('article'),
    aside: createDOMFactory('aside'),
    audio: createDOMFactory('audio'),
    b: createDOMFactory('b'),
    base: createDOMFactory('base'),
    bdi: createDOMFactory('bdi'),
    bdo: createDOMFactory('bdo'),
    big: createDOMFactory('big'),
    blockquote: createDOMFactory('blockquote'),
    body: createDOMFactory('body'),
    br: createDOMFactory('br'),
    button: createDOMFactory('button'),
    canvas: createDOMFactory('canvas'),
    caption: createDOMFactory('caption'),
    cite: createDOMFactory('cite'),
    code: createDOMFactory('code'),
    col: createDOMFactory('col'),
    colgroup: createDOMFactory('colgroup'),
    data: createDOMFactory('data'),
    datalist: createDOMFactory('datalist'),
    dd: createDOMFactory('dd'),
    del: createDOMFactory('del'),
    details: createDOMFactory('details'),
    dfn: createDOMFactory('dfn'),
    dialog: createDOMFactory('dialog'),
    div: createDOMFactory('div'),
    dl: createDOMFactory('dl'),
    dt: createDOMFactory('dt'),
    em: createDOMFactory('em'),
    embed: createDOMFactory('embed'),
    fieldset: createDOMFactory('fieldset'),
    figcaption: createDOMFactory('figcaption'),
    figure: createDOMFactory('figure'),
    footer: createDOMFactory('footer'),
    form: createDOMFactory('form'),
    h1: createDOMFactory('h1'),
    h2: createDOMFactory('h2'),
    h3: createDOMFactory('h3'),
    h4: createDOMFactory('h4'),
    h5: createDOMFactory('h5'),
    h6: createDOMFactory('h6'),
    head: createDOMFactory('head'),
    header: createDOMFactory('header'),
    hgroup: createDOMFactory('hgroup'),
    hr: createDOMFactory('hr'),
    html: createDOMFactory('html'),
    i: createDOMFactory('i'),
    iframe: createDOMFactory('iframe'),
    img: createDOMFactory('img'),
    input: createDOMFactory('input'),
    ins: createDOMFactory('ins'),
    kbd: createDOMFactory('kbd'),
    keygen: createDOMFactory('keygen'),
    label: createDOMFactory('label'),
    legend: createDOMFactory('legend'),
    li: createDOMFactory('li'),
    link: createDOMFactory('link'),
    main: createDOMFactory('main'),
    map: createDOMFactory('map'),
    mark: createDOMFactory('mark'),
    menu: createDOMFactory('menu'),
    menuitem: createDOMFactory('menuitem'),
    meta: createDOMFactory('meta'),
    meter: createDOMFactory('meter'),
    nav: createDOMFactory('nav'),
    noscript: createDOMFactory('noscript'),
    object: createDOMFactory('object'),
    ol: createDOMFactory('ol'),
    optgroup: createDOMFactory('optgroup'),
    option: createDOMFactory('option'),
    output: createDOMFactory('output'),
    p: createDOMFactory('p'),
    param: createDOMFactory('param'),
    picture: createDOMFactory('picture'),
    pre: createDOMFactory('pre'),
    progress: createDOMFactory('progress'),
    q: createDOMFactory('q'),
    rp: createDOMFactory('rp'),
    rt: createDOMFactory('rt'),
    ruby: createDOMFactory('ruby'),
    s: createDOMFactory('s'),
    samp: createDOMFactory('samp'),
    script: createDOMFactory('script'),
    section: createDOMFactory('section'),
    select: createDOMFactory('select'),
    small: createDOMFactory('small'),
    source: createDOMFactory('source'),
    span: createDOMFactory('span'),
    strong: createDOMFactory('strong'),
    style: createDOMFactory('style'),
    sub: createDOMFactory('sub'),
    summary: createDOMFactory('summary'),
    sup: createDOMFactory('sup'),
    table: createDOMFactory('table'),
    tbody: createDOMFactory('tbody'),
    td: createDOMFactory('td'),
    textarea: createDOMFactory('textarea'),
    tfoot: createDOMFactory('tfoot'),
    th: createDOMFactory('th'),
    thead: createDOMFactory('thead'),
    time: createDOMFactory('time'),
    title: createDOMFactory('title'),
    tr: createDOMFactory('tr'),
    track: createDOMFactory('track'),
    u: createDOMFactory('u'),
    ul: createDOMFactory('ul'),
    var: createDOMFactory('var'),
    video: createDOMFactory('video'),
    wbr: createDOMFactory('wbr'),

    // SVG
    circle: createDOMFactory('circle'),
    clipPath: createDOMFactory('clipPath'),
    defs: createDOMFactory('defs'),
    ellipse: createDOMFactory('ellipse'),
    g: createDOMFactory('g'),
    image: createDOMFactory('image'),
    line: createDOMFactory('line'),
    linearGradient: createDOMFactory('linearGradient'),
    mask: createDOMFactory('mask'),
    path: createDOMFactory('path'),
    pattern: createDOMFactory('pattern'),
    polygon: createDOMFactory('polygon'),
    polyline: createDOMFactory('polyline'),
    radialGradient: createDOMFactory('radialGradient'),
    rect: createDOMFactory('rect'),
    stop: createDOMFactory('stop'),
    svg: createDOMFactory('svg'),
    text: createDOMFactory('text'),
    tspan: createDOMFactory('tspan'),
  };

  // due to wrapper and conditionals at the top, this will either become
  // `module.exports ReactDOMFactories` if that is available,
  // otherwise it will be defined via `define(['react'], ReactDOMFactories)`
  // if that is available,
  // otherwise it will be defined as global variable.
  return ReactDOMFactories;
});



/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(26);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(103);

var invariant = __webpack_require__(17);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(126);
var ReactDOMComponentTree = __webpack_require__(38);
var ReactInstrumentation = __webpack_require__(53);

var quoteAttributeValueForBrowser = __webpack_require__(1469);
var warning = __webpack_require__(21);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(22);

var LinkedValueUtils = __webpack_require__(335);
var ReactDOMComponentTree = __webpack_require__(38);
var ReactUpdates = __webpack_require__(65);

var warning = __webpack_require__(21);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(26);

var invariant = __webpack_require__(17);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMSelection = __webpack_require__(1429);

var containsNode = __webpack_require__(515);
var focusNode = __webpack_require__(198);
var getActiveElement = __webpack_require__(199);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(26);

var DOMLazyTree = __webpack_require__(125);
var DOMProperty = __webpack_require__(126);
var React = __webpack_require__(131);
var ReactBrowserEventEmitter = __webpack_require__(216);
var ReactCurrentOwner = __webpack_require__(73);
var ReactDOMComponentTree = __webpack_require__(38);
var ReactDOMContainerInfo = __webpack_require__(1423);
var ReactDOMFeatureFlags = __webpack_require__(1425);
var ReactFeatureFlags = __webpack_require__(597);
var ReactInstanceMap = __webpack_require__(172);
var ReactInstrumentation = __webpack_require__(53);
var ReactMarkupChecksum = __webpack_require__(1439);
var ReactReconciler = __webpack_require__(127);
var ReactUpdateQueue = __webpack_require__(338);
var ReactUpdates = __webpack_require__(65);

var emptyObject = __webpack_require__(70);
var instantiateReactComponent = __webpack_require__(608);
var invariant = __webpack_require__(17);
var setInnerHTML = __webpack_require__(220);
var shouldUpdateReactComponent = __webpack_require__(344);
var warning = __webpack_require__(21);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(26);

var React = __webpack_require__(131);

var invariant = __webpack_require__(17);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(26);

var invariant = __webpack_require__(17);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactNodeTypes = __webpack_require__(601);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(31);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(38);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  inst._wrapperState.valueTracker = null;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(26),
    _assign = __webpack_require__(22);

var ReactCompositeComponent = __webpack_require__(1420);
var ReactEmptyComponent = __webpack_require__(596);
var ReactHostComponent = __webpack_require__(598);

var getNextDebugID = __webpack_require__(1545);
var invariant = __webpack_require__(17);
var warning = __webpack_require__(21);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(31);
var escapeTextContentForBrowser = __webpack_require__(219);
var setInnerHTML = __webpack_require__(220);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(26);

var ReactCurrentOwner = __webpack_require__(73);
var REACT_ELEMENT_TYPE = __webpack_require__(1435);

var getIteratorFn = __webpack_require__(1466);
var invariant = __webpack_require__(17);
var KeyEscapeUtils = __webpack_require__(334);
var warning = __webpack_require__(21);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 613 */
/***/ (function(module, exports) {

/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */

function focusable(element, isTabIndexNotNaN) {
  var nodeName = element.nodeName.toLowerCase();
  return (/input|select|textarea|button|object/.test(nodeName) ?
    !element.disabled :
    "a" === nodeName ?
      element.href || isTabIndexNotNaN :
      isTabIndexNotNaN) && visible(element);
}

function hidden(el) {
  return (el.offsetWidth <= 0 && el.offsetHeight <= 0) ||
    el.style.display === 'none';
}

function visible(element) {
  while (element) {
    if (element === document.body) break;
    if (hidden(element)) return false;
    element = element.parentNode;
  }
  return true;
}

function tabbable(element) {
  var tabIndex = element.getAttribute('tabindex');
  if (tabIndex === null) tabIndex = undefined;
  var isTabIndexNaN = isNaN(tabIndex);
  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
}

function findTabbableDescendants(element) {
  return [].slice.call(element.querySelectorAll('*'), 0).filter(function(el) {
    return tabbable(el);
  });
}

module.exports = findTabbableDescendants;



/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(209);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(33);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(221);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(128);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _LegacyPortal = __webpack_require__(1485);

var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContainer = function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;

      _this._portalContainerNode = (0, _getContainer2.default)(props.container, (0, _ownerDocument2.default)(_this).body);
    }, _this.getMountNode = function () {
      return _this._portalContainerNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this.setContainer();
    this.forceUpdate(this.props.onRendered);
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.container !== this.props.container) {
      this.setContainer(nextProps);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._portalContainerNode = null;
  };

  Portal.prototype.render = function render() {
    return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
module.exports = exports['default'];

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _contains = __webpack_require__(119);

var _contains2 = _interopRequireDefault(_contains);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(33);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _addEventListener = __webpack_require__(617);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _ownerDocument = __webpack_require__(128);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var escapeKeyCode = 27;

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

/**
 * The `<RootCloseWrapper/>` component registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 */

var RootCloseWrapper = function (_React$Component) {
  _inherits(RootCloseWrapper, _React$Component);

  function RootCloseWrapper(props, context) {
    _classCallCheck(this, RootCloseWrapper);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.addEventListeners = function () {
      var event = _this.props.event;

      var doc = (0, _ownerDocument2.default)(_this);

      // Use capture for this listener so it fires before React's listener, to
      // avoid false positives in the contains() check below if the target DOM
      // element is removed in the React mouse callback.
      _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);

      _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);

      _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
    };

    _this.removeEventListeners = function () {
      if (_this.documentMouseCaptureListener) {
        _this.documentMouseCaptureListener.remove();
      }

      if (_this.documentMouseListener) {
        _this.documentMouseListener.remove();
      }

      if (_this.documentKeyupListener) {
        _this.documentKeyupListener.remove();
      }
    };

    _this.handleMouseCapture = function (e) {
      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
    };

    _this.handleMouse = function (e) {
      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.handleKeyUp = function (e) {
      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.preventMouseRootClose = false;
    return _this;
  }

  RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
    if (!this.props.disabled) {
      this.addEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!this.props.disabled && prevProps.disabled) {
      this.addEventListeners();
    } else if (this.props.disabled && !prevProps.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
    if (!this.props.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.render = function render() {
    return this.props.children;
  };

  return RootCloseWrapper;
}(_react2.default.Component);

RootCloseWrapper.displayName = 'RootCloseWrapper';

RootCloseWrapper.propTypes = {
  /**
   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
   */
  onRootClose: _propTypes2.default.func,
  /**
   * Children to render.
   */
  children: _propTypes2.default.element,
  /**
   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Choose which document mouse event to bind to.
   */
  event: _propTypes2.default.oneOf(['click', 'mousedown'])
};

RootCloseWrapper.defaultProps = {
  event: 'click'
};

exports.default = RootCloseWrapper;
module.exports = exports['default'];

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _on = __webpack_require__(194);

var _on2 = _interopRequireDefault(_on);

var _properties = __webpack_require__(509);

var _properties2 = _interopRequireDefault(_properties);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(33);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var transitionEndEvent = _properties2.default.end;

var UNMOUNTED = exports.UNMOUNTED = 0;
var EXITED = exports.EXITED = 1;
var ENTERING = exports.ENTERING = 2;
var ENTERED = exports.ENTERED = 3;
var EXITING = exports.EXITING = 4;

/**
 * The Transition component lets you define and run css transitions with a simple declarative api.
 * It works similar to React's own [CSSTransitionGroup](http://facebook.github.io/react/docs/animation.html#high-level-api-reactcsstransitiongroup)
 * but is specifically optimized for transitioning a single child "in" or "out".
 *
 * You don't even need to use class based css transitions if you don't want to (but it is easiest).
 * The extensive set of lifecycle callbacks means you have control over
 * the transitioning now at each step of the way.
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.updateStatus = function () {
      if (_this.nextStatus !== null) {
        // nextStatus will always be ENTERING or EXITING.
        _this.cancelNextCallback();
        var node = _reactDom2.default.findDOMNode(_this);

        if (_this.nextStatus === ENTERING) {
          _this.props.onEnter(node);

          _this.safeSetState({ status: ENTERING }, function () {
            _this.props.onEntering(node);

            _this.onTransitionEnd(node, function () {
              _this.safeSetState({ status: ENTERED }, function () {
                _this.props.onEntered(node);
              });
            });
          });
        } else {
          _this.props.onExit(node);

          _this.safeSetState({ status: EXITING }, function () {
            _this.props.onExiting(node);

            _this.onTransitionEnd(node, function () {
              _this.safeSetState({ status: EXITED }, function () {
                _this.props.onExited(node);
              });
            });
          });
        }

        _this.nextStatus = null;
      } else if (_this.props.unmountOnExit && _this.state.status === EXITED) {
        _this.setState({ status: UNMOUNTED });
      }
    };

    _this.cancelNextCallback = function () {
      if (_this.nextCallback !== null) {
        _this.nextCallback.cancel();
        _this.nextCallback = null;
      }
    };

    _this.safeSetState = function (nextState, callback) {
      // This shouldn't be necessary, but there are weird race conditions with
      // setState callbacks and unmounting in testing, so always make sure that
      // we can cancel any pending setState callbacks after we unmount.
      _this.setState(nextState, _this.setNextCallback(callback));
    };

    _this.setNextCallback = function (callback) {
      var active = true;

      _this.nextCallback = function (event) {
        if (active) {
          active = false;
          _this.nextCallback = null;

          callback(event);
        }
      };

      _this.nextCallback.cancel = function () {
        active = false;
      };

      return _this.nextCallback;
    };

    _this.onTransitionEnd = function (node, handler) {
      _this.setNextCallback(handler);

      if (node) {
        (0, _on2.default)(node, transitionEndEvent, _this.nextCallback);
        setTimeout(_this.nextCallback, _this.props.timeout);
      } else {
        setTimeout(_this.nextCallback, 0);
      }
    };

    var initialStatus = void 0;
    _this.nextStatus = null;

    if (props.in) {
      if (props.transitionAppear) {
        initialStatus = EXITED;
        _this.nextStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus();
  };

  Transition.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var status = this.state.status;


    if (nextProps.in) {
      if (status === UNMOUNTED) {
        this.setState({ status: EXITED });
      }
      if (status !== ENTERING && status !== ENTERED) {
        this.nextStatus = ENTERING;
      }
    } else {
      if (status === ENTERING || status === ENTERED) {
        this.nextStatus = EXITING;
      }
    }
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate() {
    this.updateStatus();
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        className = _props.className,
        childProps = _objectWithoutProperties(_props, ['children', 'className']);

    Object.keys(Transition.propTypes).forEach(function (key) {
      return delete childProps[key];
    });

    var transitionClassName = void 0;
    if (status === EXITED) {
      transitionClassName = this.props.exitedClassName;
    } else if (status === ENTERING) {
      transitionClassName = this.props.enteringClassName;
    } else if (status === ENTERED) {
      transitionClassName = this.props.enteredClassName;
    } else if (status === EXITING) {
      transitionClassName = this.props.exitingClassName;
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, _extends({}, childProps, {
      className: (0, _classnames2.default)(child.props.className, className, transitionClassName)
    }));
  };

  return Transition;
}(_react2.default.Component);

Transition.propTypes = {
  /**
   * Show the component; triggers the enter or exit animation
   */
  in: _propTypes2.default.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: _propTypes2.default.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is not shown
   */
  unmountOnExit: _propTypes2.default.bool,

  /**
   * Run the enter animation when the component mounts, if it is initially
   * shown
   */
  transitionAppear: _propTypes2.default.bool,

  /**
   * A Timeout for the animation, in milliseconds, to ensure that a node doesn't
   * transition indefinately if the browser transitionEnd events are
   * canceled or interrupted.
   *
   * By default this is set to a high number (5 seconds) as a failsafe. You should consider
   * setting this to the duration of your animation (or a bit above it).
   */
  timeout: _propTypes2.default.number,

  /**
   * CSS class or classes applied when the component is exited
   */
  exitedClassName: _propTypes2.default.string,
  /**
   * CSS class or classes applied while the component is exiting
   */
  exitingClassName: _propTypes2.default.string,
  /**
   * CSS class or classes applied when the component is entered
   */
  enteredClassName: _propTypes2.default.string,
  /**
   * CSS class or classes applied while the component is entering
   */
  enteringClassName: _propTypes2.default.string,

  /**
   * Callback fired before the "entering" classes are applied
   */
  onEnter: _propTypes2.default.func,
  /**
   * Callback fired after the "entering" classes are applied
   */
  onEntering: _propTypes2.default.func,
  /**
   * Callback fired after the "enter" classes are applied
   */
  onEntered: _propTypes2.default.func,
  /**
   * Callback fired before the "exiting" classes are applied
   */
  onExit: _propTypes2.default.func,
  /**
   * Callback fired after the "exiting" classes are applied
   */
  onExiting: _propTypes2.default.func,
  /**
   * Callback fired after the "exited" classes are applied
   */
  onExited: _propTypes2.default.func
};

// Name the function so it is clearer in the documentation
function noop() {}

Transition.displayName = 'Transition';

Transition.defaultProps = {
  in: false,
  unmountOnExit: false,
  transitionAppear: false,

  timeout: 5000,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

exports.default = Transition;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (node, event, handler, capture) {
  (0, _on2.default)(node, event, handler, capture);

  return {
    remove: function remove() {
      (0, _off2.default)(node, event, handler, capture);
    }
  };
};

var _on = __webpack_require__(194);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(306);

var _off2 = _interopRequireDefault(_off);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isOverflowing;

var _isWindow = __webpack_require__(195);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(118);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
}

function bodyIsOverflowing(node) {
  var doc = (0, _ownerDocument2.default)(node);
  var win = (0, _isWindow2.default)(doc);
  var fullWidth = win.innerWidth;

  // Support: ie8, no innerWidth
  if (!fullWidth) {
    var documentElementRect = doc.documentElement.getBoundingClientRect();
    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
  }

  return doc.body.clientWidth < fullWidth;
}

function isOverflowing(container) {
  var win = (0, _isWindow2.default)(container);

  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
}
module.exports = exports['default'];

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(121);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(622);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(349);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnimateManager__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__easing__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configUpdate__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util__ = __webpack_require__(223);


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }








var Animate =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Animate, _PureComponent);

  function Animate(props, context) {
    var _this;

    _classCallCheck(this, Animate);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Animate).call(this, props, context));
    var _this$props = _this.props,
        isActive = _this$props.isActive,
        attributeName = _this$props.attributeName,
        from = _this$props.from,
        to = _this$props.to,
        steps = _this$props.steps,
        children = _this$props.children;
    _this.handleStyleChange = _this.handleStyleChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.changeStyle = _this.changeStyle.bind(_assertThisInitialized(_assertThisInitialized(_this)));

    if (!isActive) {
      _this.state = {
        style: {}
      }; // if children is a function and animation is not active, set style to 'to'

      if (typeof children === 'function') {
        _this.state = {
          style: to
        };
      }

      return _possibleConstructorReturn(_this);
    }

    if (steps && steps.length) {
      _this.state = {
        style: steps[0].style
      };
    } else if (from) {
      if (typeof children === 'function') {
        _this.state = {
          style: from
        };
        return _possibleConstructorReturn(_this);
      }

      _this.state = {
        style: attributeName ? _defineProperty({}, attributeName, from) : from
      };
    } else {
      _this.state = {
        style: {}
      };
    }

    return _this;
  }

  _createClass(Animate, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
          isActive = _this$props2.isActive,
          canBegin = _this$props2.canBegin;
      this.mounted = true;

      if (!isActive || !canBegin) {
        return;
      }

      this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
          isActive = _this$props3.isActive,
          canBegin = _this$props3.canBegin,
          attributeName = _this$props3.attributeName,
          shouldReAnimate = _this$props3.shouldReAnimate;

      if (!canBegin) {
        return;
      }

      if (!isActive) {
        var newState = {
          style: attributeName ? _defineProperty({}, attributeName, this.props.to) : this.props.to
        };

        if (this.state && this.state.style) {
          if (attributeName && this.state.style[attributeName] !== this.props.to || !attributeName && this.state.style !== this.props.to) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState(newState);
          }
        }

        return;
      }

      if (__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevProps.to, this.props.to) && prevProps.canBegin && prevProps.isActive) {
        return;
      }

      var isTriggered = !prevProps.canBegin || !prevProps.isActive;

      if (this.manager) {
        this.manager.stop();
      }

      if (this.stopJSAnimation) {
        this.stopJSAnimation();
      }

      var from = isTriggered || shouldReAnimate ? this.props.from : prevProps.to;

      if (this.state && this.state.style) {
        var _newState = {
          style: attributeName ? _defineProperty({}, attributeName, from) : from
        };

        if (attributeName && this.state.style[attributeName] !== from || !attributeName && this.state.style !== from) {
          // eslint-disable-next-line react/no-did-update-set-state
          this.setState(_newState);
        }
      }

      this.runAnimation(_objectSpread({}, this.props, {
        from: from,
        begin: 0
      }));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;

      if (this.unSubscribe) {
        this.unSubscribe();
      }

      if (this.manager) {
        this.manager.stop();
        this.manager = null;
      }

      if (this.stopJSAnimation) {
        this.stopJSAnimation();
      }
    }
  }, {
    key: "runJSAnimation",
    value: function runJSAnimation(props) {
      var _this2 = this;

      var from = props.from,
          to = props.to,
          duration = props.duration,
          easing = props.easing,
          begin = props.begin,
          onAnimationEnd = props.onAnimationEnd,
          onAnimationStart = props.onAnimationStart;
      var startAnimation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__configUpdate__["a" /* default */])(from, to, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__easing__["a" /* configEasing */])(easing), duration, this.changeStyle);

      var finalStartAnimation = function finalStartAnimation() {
        _this2.stopJSAnimation = startAnimation();
      };

      this.manager.start([onAnimationStart, begin, finalStartAnimation, duration, onAnimationEnd]);
    }
  }, {
    key: "runStepAnimation",
    value: function runStepAnimation(props) {
      var _this3 = this;

      var steps = props.steps,
          begin = props.begin,
          onAnimationStart = props.onAnimationStart;
      var _steps$ = steps[0],
          initialStyle = _steps$.style,
          _steps$$duration = _steps$.duration,
          initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;

      var addStyle = function addStyle(sequence, nextItem, index) {
        if (index === 0) {
          return sequence;
        }

        var duration = nextItem.duration,
            _nextItem$easing = nextItem.easing,
            easing = _nextItem$easing === void 0 ? 'ease' : _nextItem$easing,
            style = nextItem.style,
            nextProperties = nextItem.properties,
            onAnimationEnd = nextItem.onAnimationEnd;
        var preItem = index > 0 ? steps[index - 1] : nextItem;
        var properties = nextProperties || Object.keys(style);

        if (typeof easing === 'function' || easing === 'spring') {
          return _toConsumableArray(sequence).concat([_this3.runJSAnimation.bind(_this3, {
            from: preItem.style,
            to: style,
            duration: duration,
            easing: easing
          }), duration]);
        }

        var transition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util__["a" /* getTransitionVal */])(properties, duration, easing);

        var newStyle = _objectSpread({}, preItem.style, style, {
          transition: transition
        });

        return _toConsumableArray(sequence).concat([newStyle, duration, onAnimationEnd]).filter(__WEBPACK_IMPORTED_MODULE_6__util__["b" /* identity */]);
      };

      return this.manager.start([onAnimationStart].concat(_toConsumableArray(steps.reduce(addStyle, [initialStyle, Math.max(initialTime, begin)])), [props.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function runAnimation(props) {
      if (!this.manager) {
        this.manager = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__AnimateManager__["a" /* default */])();
      }

      var begin = props.begin,
          duration = props.duration,
          attributeName = props.attributeName,
          propsTo = props.to,
          easing = props.easing,
          onAnimationStart = props.onAnimationStart,
          onAnimationEnd = props.onAnimationEnd,
          steps = props.steps,
          children = props.children;
      var manager = this.manager;
      this.unSubscribe = manager.subscribe(this.handleStyleChange);

      if (typeof easing === 'function' || typeof children === 'function' || easing === 'spring') {
        this.runJSAnimation(props);
        return;
      }

      if (steps.length > 1) {
        this.runStepAnimation(props);
        return;
      }

      var to = attributeName ? _defineProperty({}, attributeName, propsTo) : propsTo;
      var transition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util__["a" /* getTransitionVal */])(Object.keys(to), duration, easing);
      manager.start([onAnimationStart, begin, _objectSpread({}, to, {
        transition: transition
      }), duration, onAnimationEnd]);
    }
  }, {
    key: "handleStyleChange",
    value: function handleStyleChange(style) {
      this.changeStyle(style);
    }
  }, {
    key: "changeStyle",
    value: function changeStyle(style) {
      if (this.mounted) {
        this.setState({
          style: style
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          begin = _this$props4.begin,
          duration = _this$props4.duration,
          attributeName = _this$props4.attributeName,
          easing = _this$props4.easing,
          isActive = _this$props4.isActive,
          steps = _this$props4.steps,
          from = _this$props4.from,
          to = _this$props4.to,
          canBegin = _this$props4.canBegin,
          onAnimationEnd = _this$props4.onAnimationEnd,
          shouldReAnimate = _this$props4.shouldReAnimate,
          onAnimationReStart = _this$props4.onAnimationReStart,
          others = _objectWithoutProperties(_this$props4, ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"]);

      var count = __WEBPACK_IMPORTED_MODULE_1_react__["Children"].count(children);
      var stateStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util__["c" /* translateStyle */])(this.state.style);

      if (typeof children === 'function') {
        return children(stateStyle);
      }

      if (!isActive || count === 0) {
        return children;
      }

      var cloneContainer = function cloneContainer(container) {
        var _container$props = container.props,
            _container$props$styl = _container$props.style,
            style = _container$props$styl === void 0 ? {} : _container$props$styl,
            className = _container$props.className;
        var res = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(container, _objectSpread({}, others, {
          style: _objectSpread({}, style, stateStyle),
          className: className
        }));
        return res;
      };

      if (count === 1) {
        return cloneContainer(__WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(children));
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_1_react__["Children"].map(children, function (child) {
        return cloneContainer(child);
      }));
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

Animate.displayName = 'Animate';
Animate.propTypes = {
  from: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  to: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  attributeName: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  // animation duration
  duration: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  begin: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  easing: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]),
  steps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    duration: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
    style: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
    easing: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear']), __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]),
    // transition css properties(dash case), optional
    properties: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf('string'),
    onAnimationEnd: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
  })),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]),
  isActive: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  canBegin: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  onAnimationEnd: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  onAnimationStart: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onAnimationReStart: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};
Animate.defaultProps = {
  begin: 0,
  duration: 1000,
  from: '',
  to: '',
  attributeName: '',
  easing: 'ease',
  isActive: true,
  canBegin: true,
  steps: [],
  onAnimationEnd: function onAnimationEnd() {},
  onAnimationStart: function onAnimationStart() {}
};
/* harmony default export */ __webpack_exports__["a"] = (Animate);

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export configBezier */
/* unused harmony export configSpring */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return configEasing; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(223);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }


var ACCURACY = 1e-4;

var cubicBezierFactor = function cubicBezierFactor(c1, c2) {
  return [0, 3 * c1, 3 * c2 - 6 * c1, 3 * c1 - 3 * c2 + 1];
};

var multyTime = function multyTime(params, t) {
  return params.map(function (param, i) {
    return param * Math.pow(t, i);
  }).reduce(function (pre, curr) {
    return pre + curr;
  });
};

var cubicBezier = function cubicBezier(c1, c2) {
  return function (t) {
    var params = cubicBezierFactor(c1, c2);
    return multyTime(params, t);
  };
};

var derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
  return function (t) {
    var params = cubicBezierFactor(c1, c2);

    var newParams = _toConsumableArray(params.map(function (param, i) {
      return param * i;
    }).slice(1)).concat([0]);

    return multyTime(newParams, t);
  };
}; // calculate cubic-bezier using Newton's method


var configBezier = function configBezier() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var x1 = args[0],
      y1 = args[1],
      x2 = args[2],
      y2 = args[3];

  if (args.length === 1) {
    switch (args[0]) {
      case 'linear':
        x1 = 0.0;
        y1 = 0.0;
        x2 = 1.0;
        y2 = 1.0;
        break;

      case 'ease':
        x1 = 0.25;
        y1 = 0.1;
        x2 = 0.25;
        y2 = 1.0;
        break;

      case 'ease-in':
        x1 = 0.42;
        y1 = 0.0;
        x2 = 1.0;
        y2 = 1.0;
        break;

      case 'ease-out':
        x1 = 0.42;
        y1 = 0.0;
        x2 = 0.58;
        y2 = 1.0;
        break;

      case 'ease-in-out':
        x1 = 0.0;
        y1 = 0.0;
        x2 = 0.58;
        y2 = 1.0;
        break;

      default:
        {
          var easing = args[0].split('(');

          if (easing[0] === 'cubic-bezier' && easing[1].split(')')[0].split(',').length === 4) {
            var _easing$1$split$0$spl = easing[1].split(')')[0].split(',').map(function (x) {
              return parseFloat(x);
            });

            var _easing$1$split$0$spl2 = _slicedToArray(_easing$1$split$0$spl, 4);

            x1 = _easing$1$split$0$spl2[0];
            y1 = _easing$1$split$0$spl2[1];
            x2 = _easing$1$split$0$spl2[2];
            y2 = _easing$1$split$0$spl2[3];
          } else {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* warn */])(false, '[configBezier]: arguments should be one of ' + 'oneOf \'linear\', \'ease\', \'ease-in\', \'ease-out\', ' + '\'ease-in-out\',\'cubic-bezier(x1,y1,x2,y2)\', instead received %s', args);
          }
        }
    }
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* warn */])([x1, x2, y1, y2].every(function (num) {
    return typeof num === 'number' && num >= 0 && num <= 1;
  }), '[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s', args);
  var curveX = cubicBezier(x1, x2);
  var curveY = cubicBezier(y1, y2);
  var derCurveX = derivativeCubicBezier(x1, x2);

  var rangeValue = function rangeValue(value) {
    if (value > 1) {
      return 1;
    } else if (value < 0) {
      return 0;
    }

    return value;
  };

  var bezier = function bezier(_t) {
    var t = _t > 1 ? 1 : _t;
    var x = t;

    for (var i = 0; i < 8; ++i) {
      var evalT = curveX(x) - t;
      var derVal = derCurveX(x);

      if (Math.abs(evalT - t) < ACCURACY || derVal < ACCURACY) {
        return curveY(x);
      }

      x = rangeValue(x - evalT / derVal);
    }

    return curveY(x);
  };

  bezier.isStepper = false;
  return bezier;
};
var configSpring = function configSpring() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$stiff = config.stiff,
      stiff = _config$stiff === void 0 ? 100 : _config$stiff,
      _config$damping = config.damping,
      damping = _config$damping === void 0 ? 8 : _config$damping,
      _config$dt = config.dt,
      dt = _config$dt === void 0 ? 17 : _config$dt;

  var stepper = function stepper(currX, destX, currV) {
    var FSpring = -(currX - destX) * stiff;
    var FDamping = currV * damping;
    var newV = currV + (FSpring - FDamping) * dt / 1000;
    var newX = currV * dt / 1000 + currX;

    if (Math.abs(newX - destX) < ACCURACY && Math.abs(newV) < ACCURACY) {
      return [destX, 0];
    }

    return [newX, newV];
  };

  stepper.isStepper = true;
  stepper.dt = dt;
  return stepper;
};
var configEasing = function configEasing() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var easing = args[0];

  if (typeof easing === 'string') {
    switch (easing) {
      case 'ease':
      case 'ease-in-out':
      case 'ease-out':
      case 'ease-in':
      case 'linear':
        return configBezier(easing);

      case 'spring':
        return configSpring();

      default:
        if (easing.split('(')[0] === 'cubic-bezier') {
          return configBezier(easing);
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* warn */])(false, '[configEasing]: first argument should be one of \'ease\', \'ease-in\', ' + '\'ease-out\', \'ease-in-out\',\'cubic-bezier(x1,y1,x2,y2)\', \'linear\' and \'spring\', instead  received %s', args);
    }
  }

  if (typeof easing === 'function') {
    return easing;
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* warn */])(false, '[configEasing]: first argument type should be function or ' + 'string, instead received %s', args);
  return null;
};

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(174));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(33));

var _reactLifecyclesCompat = __webpack_require__(612);

var _PropTypes = __webpack_require__(629);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(174));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(612);

var _ChildMapping = __webpack_require__(1536);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = _interopRequireDefault(__webpack_require__(1532));

var _ReplaceTransition = _interopRequireDefault(__webpack_require__(1533));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(627));

var _Transition = _interopRequireDefault(__webpack_require__(626));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(174));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(133),
    _assign = __webpack_require__(22);

var ReactNoopUpdateQueue = __webpack_require__(633);

var canDefineProperty = __webpack_require__(634);
var emptyObject = __webpack_require__(70);
var invariant = __webpack_require__(17);
var lowPriorityWarning = __webpack_require__(1546);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(133);

var ReactCurrentOwner = __webpack_require__(73);

var invariant = __webpack_require__(17);
var warning = __webpack_require__(21);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(21);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PLACE_HOLDER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return curry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return range; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return reverse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return memoize; });
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var identity = function identity(i) {
  return i;
};

var PLACE_HOLDER = {
  '@@functional/placeholder': true
};

var isPlaceHolder = function isPlaceHolder(val) {
  return val === PLACE_HOLDER;
};

var curry0 = function curry0(fn) {
  return function _curried() {
    if (arguments.length === 0 || arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) {
      return _curried;
    }

    return fn.apply(void 0, arguments);
  };
};

var curryN = function curryN(n, fn) {
  if (n === 1) {
    return fn;
  }

  return curry0(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var argsLength = args.filter(function (arg) {
      return arg !== PLACE_HOLDER;
    }).length;

    if (argsLength >= n) {
      return fn.apply(void 0, args);
    }

    return curryN(n - argsLength, curry0(function () {
      for (var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        restArgs[_key2] = arguments[_key2];
      }

      var newArgs = args.map(function (arg) {
        return isPlaceHolder(arg) ? restArgs.shift() : arg;
      });
      return fn.apply(void 0, _toConsumableArray(newArgs).concat(restArgs));
    }));
  });
};

var curry = function curry(fn) {
  return curryN(fn.length, fn);
};
var range = function range(begin, end) {
  var arr = [];

  for (var i = begin; i < end; ++i) {
    arr[i - begin] = i;
  }

  return arr;
};
var map = curry(function (fn, arr) {
  if (Array.isArray(arr)) {
    return arr.map(fn);
  }

  return Object.keys(arr).map(function (key) {
    return arr[key];
  }).map(fn);
});
var compose = function compose() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  if (!args.length) {
    return identity;
  }

  var fns = args.reverse(); // first function can receive multiply arguments

  var firstFn = fns[0];
  var tailsFn = fns.slice(1);
  return function () {
    return tailsFn.reduce(function (res, fn) {
      return fn(res);
    }, firstFn.apply(void 0, arguments));
  };
};
var reverse = function reverse(arr) {
  if (Array.isArray(arr)) {
    return arr.reverse();
  } // can be string


  return arr.split('').reverse.join('');
};
var memoize = function memoize(fn) {
  var lastArgs = null;
  var lastResult = null;
  return function () {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    if (lastArgs && args.every(function (val, i) {
      return val === lastArgs[i];
    })) {
      return lastResult;
    }

    lastArgs = args;
    lastResult = fn.apply(void 0, args);
    return lastResult;
  };
};

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_d3_scale__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ChartUtils__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__container_Layer__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component_Text__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_DataUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_CssPrefixUtils__ = __webpack_require__(1572);



function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Brush
 */










var Brush =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Brush, _PureComponent);

  function Brush(props) {
    var _this;

    _classCallCheck(this, Brush);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Brush).call(this, props));

    _this.handleDrag = function (e) {
      if (_this.leaveTimer) {
        clearTimeout(_this.leaveTimer);
        _this.leaveTimer = null;
      }

      if (_this.state.isTravellerMoving) {
        _this.handleTravellerMove(e);
      } else if (_this.state.isSlideMoving) {
        _this.handleSlideDrag(e);
      }
    };

    _this.handleTouchMove = function (e) {
      if (e.changedTouches != null && e.changedTouches.length > 0) {
        _this.handleDrag(e.changedTouches[0]);
      }
    };

    _this.handleDragEnd = function () {
      _this.setState({
        isTravellerMoving: false,
        isSlideMoving: false
      });
    };

    _this.handleLeaveWrapper = function () {
      if (_this.state.isTravellerMoving || _this.state.isSlideMoving) {
        _this.leaveTimer = setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
      }
    };

    _this.handleEnterSlideOrTraveller = function () {
      _this.setState({
        isTextActive: true
      });
    };

    _this.handleLeaveSlideOrTraveller = function () {
      _this.setState({
        isTextActive: false
      });
    };

    _this.handleSlideDragStart = function (e) {
      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;

      _this.setState({
        isTravellerMoving: false,
        isSlideMoving: true,
        slideMoveStartX: event.pageX
      });
    };

    _this.travellerDragStartHandlers = {
      startX: _this.handleTravellerDragStart.bind(_assertThisInitialized(_this), 'startX'),
      endX: _this.handleTravellerDragStart.bind(_assertThisInitialized(_this), 'endX')
    };
    _this.state = props.data && props.data.length ? _this.updateScale(props) : {};
    return _this;
  } // eslint-disable-next-line camelcase


  _createClass(Brush, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var _this$props = this.props,
          data = _this$props.data,
          width = _this$props.width,
          x = _this$props.x,
          travellerWidth = _this$props.travellerWidth,
          updateId = _this$props.updateId;

      if ((nextProps.data !== data || nextProps.updateId !== updateId) && nextProps.data && nextProps.data.length) {
        this.setState(this.updateScale(nextProps));
      } else if (nextProps.width !== width || nextProps.x !== x || nextProps.travellerWidth !== travellerWidth) {
        this.scale.range([nextProps.x, nextProps.x + nextProps.width - nextProps.travellerWidth]);
        this.scaleValues = this.scale.domain().map(function (entry) {
          return _this2.scale(entry);
        });
        this.setState({
          startX: this.scale(nextProps.startIndex),
          endX: this.scale(nextProps.endIndex)
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.scale = null;
      this.scaleValues = null;

      if (this.leaveTimer) {
        clearTimeout(this.leaveTimer);
        this.leaveTimer = null;
      }
    }
  }, {
    key: "getIndex",
    value: function getIndex(_ref) {
      var startX = _ref.startX,
          endX = _ref.endX;
      var _this$props2 = this.props,
          gap = _this$props2.gap,
          data = _this$props2.data;
      var lastIndex = data.length - 1;
      var min = Math.min(startX, endX);
      var max = Math.max(startX, endX);
      var minIndex = this.constructor.getIndexInRange(this.scaleValues, min);
      var maxIndex = this.constructor.getIndexInRange(this.scaleValues, max);
      return {
        startIndex: minIndex - minIndex % gap,
        endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
      };
    }
  }, {
    key: "getTextOfTick",
    value: function getTextOfTick(index) {
      var _this$props3 = this.props,
          data = _this$props3.data,
          tickFormatter = _this$props3.tickFormatter,
          dataKey = _this$props3.dataKey;
      var text = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ChartUtils__["a" /* getValueByDataKey */])(data[index], dataKey, index);
      return __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(tickFormatter) ? tickFormatter(text) : text;
    }
  }, {
    key: "handleSlideDrag",
    value: function handleSlideDrag(e) {
      var _this$state = this.state,
          slideMoveStartX = _this$state.slideMoveStartX,
          startX = _this$state.startX,
          endX = _this$state.endX;
      var _this$props4 = this.props,
          x = _this$props4.x,
          width = _this$props4.width,
          travellerWidth = _this$props4.travellerWidth,
          startIndex = _this$props4.startIndex,
          endIndex = _this$props4.endIndex,
          onChange = _this$props4.onChange;
      var delta = e.pageX - slideMoveStartX;

      if (delta > 0) {
        delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
      } else if (delta < 0) {
        delta = Math.max(delta, x - startX, x - endX);
      }

      var newIndex = this.getIndex({
        startX: startX + delta,
        endX: endX + delta
      });

      if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) {
        onChange(newIndex);
      }

      this.setState({
        startX: startX + delta,
        endX: endX + delta,
        slideMoveStartX: e.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function handleTravellerDragStart(id, e) {
      var event = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e;
      this.setState({
        isSlideMoving: false,
        isTravellerMoving: true,
        movingTravellerId: id,
        brushMoveStartX: event.pageX
      });
    }
  }, {
    key: "handleTravellerMove",
    value: function handleTravellerMove(e) {
      var _this$setState;

      var _this$state2 = this.state,
          brushMoveStartX = _this$state2.brushMoveStartX,
          movingTravellerId = _this$state2.movingTravellerId,
          endX = _this$state2.endX,
          startX = _this$state2.startX;
      var prevValue = this.state[movingTravellerId];
      var _this$props5 = this.props,
          x = _this$props5.x,
          width = _this$props5.width,
          travellerWidth = _this$props5.travellerWidth,
          onChange = _this$props5.onChange,
          gap = _this$props5.gap,
          data = _this$props5.data;
      var params = {
        startX: this.state.startX,
        endX: this.state.endX
      };
      var delta = e.pageX - brushMoveStartX;

      if (delta > 0) {
        delta = Math.min(delta, x + width - travellerWidth - prevValue);
      } else if (delta < 0) {
        delta = Math.max(delta, x - prevValue);
      }

      params[movingTravellerId] = prevValue + delta;
      var newIndex = this.getIndex(params);
      var startIndex = newIndex.startIndex,
          endIndex = newIndex.endIndex;

      var isFullGap = function isFullGap() {
        var lastIndex = data.length - 1;

        if (movingTravellerId === 'startX' && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === 'endX' && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) {
          return true;
        }

        return false;
      };

      this.setState((_this$setState = {}, _defineProperty(_this$setState, movingTravellerId, prevValue + delta), _defineProperty(_this$setState, "brushMoveStartX", e.pageX), _this$setState), function () {
        if (onChange) {
          if (isFullGap()) {
            onChange(newIndex);
          }
        }
      });
    }
  }, {
    key: "updateScale",
    value: function updateScale(props) {
      var _this3 = this;

      var data = props.data,
          startIndex = props.startIndex,
          endIndex = props.endIndex,
          x = props.x,
          width = props.width,
          travellerWidth = props.travellerWidth;
      var len = data.length;
      this.scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_d3_scale__["scalePoint"])().domain(__WEBPACK_IMPORTED_MODULE_0_lodash_range___default()(0, len)).range([x, x + width - travellerWidth]);
      this.scaleValues = this.scale.domain().map(function (entry) {
        return _this3.scale(entry);
      });
      return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        startX: this.scale(startIndex),
        endX: this.scale(endIndex)
      };
    }
  }, {
    key: "renderBackground",
    value: function renderBackground() {
      var _this$props6 = this.props,
          x = _this$props6.x,
          y = _this$props6.y,
          width = _this$props6.width,
          height = _this$props6.height,
          fill = _this$props6.fill,
          stroke = _this$props6.stroke;
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("rect", {
        stroke: stroke,
        fill: fill,
        x: x,
        y: y,
        width: width,
        height: height
      });
    }
  }, {
    key: "renderPanorama",
    value: function renderPanorama() {
      var _this$props7 = this.props,
          x = _this$props7.x,
          y = _this$props7.y,
          width = _this$props7.width,
          height = _this$props7.height,
          data = _this$props7.data,
          children = _this$props7.children,
          padding = _this$props7.padding;
      var chartElement = __WEBPACK_IMPORTED_MODULE_2_react__["Children"].only(children);

      if (!chartElement) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(chartElement, {
        x: x,
        y: y,
        width: width,
        height: height,
        margin: padding,
        compact: true,
        data: data
      });
    }
  }, {
    key: "renderTraveller",
    value: function renderTraveller(travellerX, id) {
      var _this$props8 = this.props,
          y = _this$props8.y,
          travellerWidth = _this$props8.travellerWidth,
          height = _this$props8.height,
          stroke = _this$props8.stroke;
      var lineY = Math.floor(y + height / 2) - 1;
      var x = Math.max(travellerX, this.props.x);
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */], {
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[id],
        onTouchStart: this.travellerDragStartHandlers[id],
        style: {
          cursor: 'col-resize'
        }
      }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("rect", {
        x: x,
        y: y,
        width: travellerWidth,
        height: height,
        fill: stroke,
        stroke: "none"
      }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("line", {
        x1: x + 1,
        y1: lineY,
        x2: x + travellerWidth - 1,
        y2: lineY,
        fill: "none",
        stroke: "#fff"
      }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("line", {
        x1: x + 1,
        y1: lineY + 2,
        x2: x + travellerWidth - 1,
        y2: lineY + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderSlide",
    value: function renderSlide(startX, endX) {
      var _this$props9 = this.props,
          y = _this$props9.y,
          height = _this$props9.height,
          stroke = _this$props9.stroke;
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: 'move'
        },
        stroke: "none",
        fill: stroke,
        fillOpacity: 0.2,
        x: Math.min(startX, endX),
        y: y,
        width: Math.abs(endX - startX),
        height: height
      });
    }
  }, {
    key: "renderText",
    value: function renderText() {
      var _this$props10 = this.props,
          startIndex = _this$props10.startIndex,
          endIndex = _this$props10.endIndex,
          y = _this$props10.y,
          height = _this$props10.height,
          travellerWidth = _this$props10.travellerWidth,
          stroke = _this$props10.stroke;
      var _this$state3 = this.state,
          startX = _this$state3.startX,
          endX = _this$state3.endX;
      var offset = 5;
      var attrs = {
        pointerEvents: 'none',
        fill: stroke
      };
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */], {
        className: "recharts-brush-texts"
      }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__component_Text__["a" /* default */], _extends({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(startX, endX) - offset,
        y: y + height / 2
      }, attrs), this.getTextOfTick(startIndex)), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__component_Text__["a" /* default */], _extends({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(startX, endX) + travellerWidth + offset,
        y: y + height / 2
      }, attrs), this.getTextOfTick(endIndex)));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props11 = this.props,
          data = _this$props11.data,
          className = _this$props11.className,
          children = _this$props11.children,
          x = _this$props11.x,
          y = _this$props11.y,
          width = _this$props11.width,
          height = _this$props11.height,
          alwaysShowText = _this$props11.alwaysShowText;
      var _this$state4 = this.state,
          startX = _this$state4.startX,
          endX = _this$state4.endX,
          isTextActive = _this$state4.isTextActive,
          isSlideMoving = _this$state4.isSlideMoving,
          isTravellerMoving = _this$state4.isTravellerMoving;

      if (!data || !data.length || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["a" /* isNumber */])(x) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["a" /* isNumber */])(y) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["a" /* isNumber */])(width) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["a" /* isNumber */])(height) || width <= 0 || height <= 0) {
        return null;
      }

      var layerClass = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('recharts-brush', className);
      var isPanoramic = __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1;
      var style = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_CssPrefixUtils__["a" /* generatePrefixStyle */])('userSelect', 'none');
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__container_Layer__["a" /* default */], {
        className: layerClass,
        onMouseMove: this.handleDrag,
        onMouseLeave: this.handleLeaveWrapper,
        onMouseUp: this.handleDragEnd,
        onTouchEnd: this.handleDragEnd,
        onTouchMove: this.handleTouchMove,
        style: style
      }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTraveller(startX, 'startX'), this.renderTraveller(endX, 'endX'), (isTextActive || isSlideMoving || isTravellerMoving || alwaysShowText) && this.renderText());
    }
  }], [{
    key: "getIndexInRange",
    value: function getIndexInRange(range, x) {
      var len = range.length;
      var start = 0;
      var end = len - 1;

      while (end - start > 1) {
        var middle = Math.floor((start + end) / 2);

        if (range[middle] > x) {
          end = middle;
        } else {
          start = middle;
        }
      }

      return x >= range[end] ? end : start;
    }
  }]);

  return Brush;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

Brush.displayName = 'Brush';
Brush.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  fill: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  stroke: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  x: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number.isRequired,
  travellerWidth: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  gap: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  padding: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    top: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    right: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    bottom: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    left: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number
  }),
  dataKey: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
  data: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,
  startIndex: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  endIndex: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  tickFormatter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,
  onChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  updateId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  leaveTimeOut: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  alwaysShowText: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};
Brush.defaultProps = {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: '#fff',
  stroke: '#666',
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1000,
  alwaysShowText: false
};
/* harmony default export */ __webpack_exports__["a"] = (Brush);

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ShallowEqual__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_DOMUtils__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__container_Layer__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_Text__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__component_Label__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_DataUtils__ = __webpack_require__(27);


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Cartesian Axis
 */











var CartesianAxis =
/*#__PURE__*/
function (_Component) {
  _inherits(CartesianAxis, _Component);

  function CartesianAxis() {
    _classCallCheck(this, CartesianAxis);

    return _possibleConstructorReturn(this, _getPrototypeOf(CartesianAxis).apply(this, arguments));
  }

  _createClass(CartesianAxis, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(_ref, state) {
      var viewBox = _ref.viewBox,
          restProps = _objectWithoutProperties(_ref, ["viewBox"]);

      // props.viewBox is sometimes generated every time -
      // check that specially as object equality is likely to fail
      var _this$props = this.props,
          viewBoxOld = _this$props.viewBox,
          restPropsOld = _objectWithoutProperties(_this$props, ["viewBox"]);

      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ShallowEqual__["a" /* shallowEqual */])(viewBox, viewBoxOld) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ShallowEqual__["a" /* shallowEqual */])(restProps, restPropsOld) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ShallowEqual__["a" /* shallowEqual */])(state, this.state);
    }
    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */

  }, {
    key: "getTickLineCoord",
    value: function getTickLineCoord(data) {
      var _this$props2 = this.props,
          x = _this$props2.x,
          y = _this$props2.y,
          width = _this$props2.width,
          height = _this$props2.height,
          orientation = _this$props2.orientation,
          tickSize = _this$props2.tickSize,
          mirror = _this$props2.mirror,
          tickMargin = _this$props2.tickMargin;
      var x1, x2, y1, y2, tx, ty;
      var sign = mirror ? -1 : 1;
      var finalTickSize = data.tickSize || tickSize;
      var tickCoord = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_DataUtils__["a" /* isNumber */])(data.tickCoord) ? data.tickCoord : data.coordinate;

      switch (orientation) {
        case 'top':
          x1 = x2 = data.coordinate;
          y2 = y + !mirror * height;
          y1 = y2 - sign * finalTickSize;
          ty = y1 - sign * tickMargin;
          tx = tickCoord;
          break;

        case 'left':
          y1 = y2 = data.coordinate;
          x2 = x + !mirror * width;
          x1 = x2 - sign * finalTickSize;
          tx = x1 - sign * tickMargin;
          ty = tickCoord;
          break;

        case 'right':
          y1 = y2 = data.coordinate;
          x2 = x + mirror * width;
          x1 = x2 + sign * finalTickSize;
          tx = x1 + sign * tickMargin;
          ty = tickCoord;
          break;

        default:
          x1 = x2 = data.coordinate;
          y2 = y + mirror * height;
          y1 = y2 + sign * finalTickSize;
          ty = y1 + sign * tickMargin;
          tx = tickCoord;
          break;
      }

      return {
        line: {
          x1: x1,
          y1: y1,
          x2: x2,
          y2: y2
        },
        tick: {
          x: tx,
          y: ty
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function getTickTextAnchor() {
      var _this$props3 = this.props,
          orientation = _this$props3.orientation,
          mirror = _this$props3.mirror;
      var textAnchor;

      switch (orientation) {
        case 'left':
          textAnchor = mirror ? 'start' : 'end';
          break;

        case 'right':
          textAnchor = mirror ? 'end' : 'start';
          break;

        default:
          textAnchor = 'middle';
          break;
      }

      return textAnchor;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function getTickVerticalAnchor() {
      var _this$props4 = this.props,
          orientation = _this$props4.orientation,
          mirror = _this$props4.mirror;
      var verticalAnchor = 'end';

      switch (orientation) {
        case 'left':
        case 'right':
          verticalAnchor = 'middle';
          break;

        case 'top':
          verticalAnchor = mirror ? 'start' : 'end';
          break;

        default:
          verticalAnchor = mirror ? 'end' : 'start';
          break;
      }

      return verticalAnchor;
    }
  }, {
    key: "renderAxisLine",
    value: function renderAxisLine() {
      var _this$props5 = this.props,
          x = _this$props5.x,
          y = _this$props5.y,
          width = _this$props5.width,
          height = _this$props5.height,
          orientation = _this$props5.orientation,
          axisLine = _this$props5.axisLine,
          mirror = _this$props5.mirror;

      var props = _objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props), {
        fill: 'none'
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["a" /* getPresentationAttributes */])(axisLine));

      if (orientation === 'top' || orientation === 'bottom') {
        var needHeight = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
        props = _objectSpread({}, props, {
          x1: x,
          y1: y + needHeight * height,
          x2: x + width,
          y2: y + needHeight * height
        });
      } else {
        var needWidth = orientation === 'left' && !mirror || orientation === 'right' && mirror;
        props = _objectSpread({}, props, {
          x1: x + needWidth * width,
          y1: y,
          x2: x + needWidth * width,
          y2: y + height
        });
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line", _extends({
        className: "recharts-cartesian-axis-line"
      }, props));
    }
  }, {
    key: "renderTicks",

    /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @return {ReactComponent} renderedTicks
     */
    value: function renderTicks(ticks) {
      var _this = this;

      var _this$props6 = this.props,
          tickLine = _this$props6.tickLine,
          stroke = _this$props6.stroke,
          tick = _this$props6.tick,
          tickFormatter = _this$props6.tickFormatter,
          unit = _this$props6.unit;
      var finalTicks = CartesianAxis.getTicks(_objectSpread({}, this.props, {
        ticks: ticks
      }));
      var textAnchor = this.getTickTextAnchor();
      var verticalAnchor = this.getTickVerticalAnchor();
      var axisProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props);
      var customTickProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["a" /* getPresentationAttributes */])(tick);

      var tickLineProps = _objectSpread({}, axisProps, {
        fill: 'none'
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["a" /* getPresentationAttributes */])(tickLine));

      var items = finalTicks.map(function (entry, i) {
        var _this$getTickLineCoor = _this.getTickLineCoord(entry),
            lineCoord = _this$getTickLineCoor.line,
            tickCoord = _this$getTickLineCoor.tick;

        var tickProps = _objectSpread({
          textAnchor: textAnchor,
          verticalAnchor: verticalAnchor
        }, axisProps, {
          stroke: 'none',
          fill: stroke
        }, customTickProps, {}, tickCoord, {
          index: i,
          payload: entry,
          visibleTicksCount: finalTicks.length
        });

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__container_Layer__["a" /* default */], _extends({
          className: "recharts-cartesian-axis-tick",
          key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key

        }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["e" /* filterEventsOfChild */])(_this.props, entry, i)), tickLine && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line", _extends({
          className: "recharts-cartesian-axis-tick-line"
        }, tickLineProps, lineCoord)), tick && _this.constructor.renderTickItem(tick, tickProps, "".concat(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(tickFormatter) ? tickFormatter(entry.value) : entry.value).concat(unit || '')));
      });
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g", {
        className: "recharts-cartesian-axis-ticks"
      }, items);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          axisLine = _this$props7.axisLine,
          width = _this$props7.width,
          height = _this$props7.height,
          ticksGenerator = _this$props7.ticksGenerator,
          className = _this$props7.className,
          hide = _this$props7.hide;

      if (hide) {
        return null;
      }

      var _this$props8 = this.props,
          ticks = _this$props8.ticks,
          noTicksProps = _objectWithoutProperties(_this$props8, ["ticks"]);

      var finalTicks = ticks;

      if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(ticksGenerator)) {
        finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
      }

      if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__container_Layer__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('recharts-cartesian-axis', className)
      }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks), __WEBPACK_IMPORTED_MODULE_8__component_Label__["a" /* default */].renderCallByParent(this.props));
    }
  }], [{
    key: "getTicks",
    value: function getTicks(props) {
      var tick = props.tick,
          ticks = props.ticks,
          viewBox = props.viewBox,
          minTickGap = props.minTickGap,
          orientation = props.orientation,
          interval = props.interval,
          tickFormatter = props.tickFormatter,
          unit = props.unit;

      if (!ticks || !ticks.length || !tick) {
        return [];
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_DataUtils__["a" /* isNumber */])(interval) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["h" /* isSsr */])()) {
        return CartesianAxis.getNumberIntervalTicks(ticks, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_DataUtils__["a" /* isNumber */])(interval) ? interval : 0);
      }

      if (interval === 'preserveStartEnd') {
        return CartesianAxis.getTicksStart({
          ticks: ticks,
          tickFormatter: tickFormatter,
          viewBox: viewBox,
          orientation: orientation,
          minTickGap: minTickGap,
          unit: unit
        }, true);
      }

      if (interval === 'preserveStart') {
        return CartesianAxis.getTicksStart({
          ticks: ticks,
          tickFormatter: tickFormatter,
          viewBox: viewBox,
          orientation: orientation,
          minTickGap: minTickGap,
          unit: unit
        });
      }

      return CartesianAxis.getTicksEnd({
        ticks: ticks,
        tickFormatter: tickFormatter,
        viewBox: viewBox,
        orientation: orientation,
        minTickGap: minTickGap,
        unit: unit
      });
    }
  }, {
    key: "getNumberIntervalTicks",
    value: function getNumberIntervalTicks(ticks, interval) {
      return ticks.filter(function (entry, i) {
        return i % (interval + 1) === 0;
      });
    }
  }, {
    key: "getTicksStart",
    value: function getTicksStart(_ref2, preserveEnd) {
      var ticks = _ref2.ticks,
          tickFormatter = _ref2.tickFormatter,
          viewBox = _ref2.viewBox,
          orientation = _ref2.orientation,
          minTickGap = _ref2.minTickGap,
          unit = _ref2.unit;
      var x = viewBox.x,
          y = viewBox.y,
          width = viewBox.width,
          height = viewBox.height;
      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
      var result = (ticks || []).slice(); // we need add the width of 'unit' only when sizeKey === 'width'

      var unitSize = unit && sizeKey === 'width' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DOMUtils__["a" /* getStringSize */])(unit)[sizeKey] : 0;
      var len = result.length;
      var sign = len >= 2 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_DataUtils__["d" /* mathSign */])(result[1].coordinate - result[0].coordinate) : 1;
      var start, end;

      if (sign === 1) {
        start = sizeKey === 'width' ? x : y;
        end = sizeKey === 'width' ? x + width : y + height;
      } else {
        start = sizeKey === 'width' ? x + width : y + height;
        end = sizeKey === 'width' ? x : y;
      }

      if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailContent = __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(tickFormatter) ? tickFormatter(tail.value) : tail.value;
        var tailSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DOMUtils__["a" /* getStringSize */])(tailContent)[sizeKey] + unitSize;
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = _objectSpread({}, tail, {
          tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        var isTailShow = sign * (tail.tickCoord - sign * tailSize / 2 - start) >= 0 && sign * (tail.tickCoord + sign * tailSize / 2 - end) <= 0;

        if (isTailShow) {
          end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
          result[len - 1] = _objectSpread({}, tail, {
            isShow: true
          });
        }
      }

      var count = preserveEnd ? len - 1 : len;

      for (var _i = 0; _i < count; _i++) {
        var entry = result[_i];
        var content = __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(tickFormatter) ? tickFormatter(entry.value) : entry.value;
        var size = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DOMUtils__["a" /* getStringSize */])(content)[sizeKey] + unitSize;

        if (_i === 0) {
          var gap = sign * (entry.coordinate - sign * size / 2 - start);
          result[_i] = entry = _objectSpread({}, entry, {
            tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
          });
        } else {
          result[_i] = entry = _objectSpread({}, entry, {
            tickCoord: entry.coordinate
          });
        }

        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;

        if (isShow) {
          start = entry.tickCoord + sign * (size / 2 + minTickGap);
          result[_i] = _objectSpread({}, entry, {
            isShow: true
          });
        }
      }

      return result.filter(function (entry) {
        return entry.isShow;
      });
    }
  }, {
    key: "getTicksEnd",
    value: function getTicksEnd(_ref3) {
      var ticks = _ref3.ticks,
          tickFormatter = _ref3.tickFormatter,
          viewBox = _ref3.viewBox,
          orientation = _ref3.orientation,
          minTickGap = _ref3.minTickGap,
          unit = _ref3.unit;
      var x = viewBox.x,
          y = viewBox.y,
          width = viewBox.width,
          height = viewBox.height;
      var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height'; // we need add the width of 'unit' only when sizeKey === 'width'

      var unitSize = unit && sizeKey === 'width' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DOMUtils__["a" /* getStringSize */])(unit)[sizeKey] : 0;
      var result = (ticks || []).slice();
      var len = result.length;
      var sign = len >= 2 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_DataUtils__["d" /* mathSign */])(result[1].coordinate - result[0].coordinate) : 1;
      var start, end;

      if (sign === 1) {
        start = sizeKey === 'width' ? x : y;
        end = sizeKey === 'width' ? x + width : y + height;
      } else {
        start = sizeKey === 'width' ? x + width : y + height;
        end = sizeKey === 'width' ? x : y;
      }

      for (var _i2 = len - 1; _i2 >= 0; _i2--) {
        var entry = result[_i2];
        var content = __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(tickFormatter) ? tickFormatter(entry.value) : entry.value;
        var size = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DOMUtils__["a" /* getStringSize */])(content)[sizeKey] + unitSize;

        if (_i2 === len - 1) {
          var gap = sign * (entry.coordinate + sign * size / 2 - end);
          result[_i2] = entry = _objectSpread({}, entry, {
            tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
          });
        } else {
          result[_i2] = entry = _objectSpread({}, entry, {
            tickCoord: entry.coordinate
          });
        }

        var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;

        if (isShow) {
          end = entry.tickCoord - sign * (size / 2 + minTickGap);
          result[_i2] = _objectSpread({}, entry, {
            isShow: true
          });
        }
      }

      return result.filter(function (entry) {
        return entry.isShow;
      });
    }
  }, {
    key: "renderTickItem",
    value: function renderTickItem(option, props, value) {
      var tickItem;

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
        tickItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        tickItem = option(props);
      } else {
        tickItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__component_Text__["a" /* default */], _extends({}, props, {
          className: "recharts-cartesian-axis-tick-value"
        }), value);
      }

      return tickItem;
    }
  }]);

  return CartesianAxis;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

CartesianAxis.displayName = 'CartesianAxis';
CartesianAxis.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {}, __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["d" /* EVENT_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  orientation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['top', 'bottom', 'left', 'right']),
  // The viewBox of svg
  viewBox: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  }),
  tick: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element]),
  axisLine: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]),
  tickLine: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object]),
  mirror: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  tickMargin: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
  minTickGap: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  ticks: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  tickSize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  stroke: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  tickFormatter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  ticksGenerator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  interval: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['preserveStart', 'preserveEnd', 'preserveStartEnd'])])
});
CartesianAxis.defaultProps = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: 'bottom',
  // The ticks
  ticks: [],
  stroke: '#666',
  tickLine: true,
  axisLine: true,
  tick: true,
  mirror: false,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: 'preserveEnd'
};
/* harmony default export */ __webpack_exports__["a"] = (CartesianAxis);

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__container_Layer__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__component_Label__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_CartesianUtils__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_IfOverflowMatches__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_DataUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_LogUtils__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_ReactUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shape_Rectangle__ = __webpack_require__(139);


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Reference Line
 */












var ReferenceArea =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ReferenceArea, _PureComponent);

  function ReferenceArea() {
    _classCallCheck(this, ReferenceArea);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReferenceArea).apply(this, arguments));
  }

  _createClass(ReferenceArea, [{
    key: "getRect",
    value: function getRect(hasX1, hasX2, hasY1, hasY2) {
      var _this$props = this.props,
          xValue1 = _this$props.x1,
          xValue2 = _this$props.x2,
          yValue1 = _this$props.y1,
          yValue2 = _this$props.y2,
          xAxis = _this$props.xAxis,
          yAxis = _this$props.yAxis;
      var scale = __WEBPACK_IMPORTED_MODULE_6__util_CartesianUtils__["a" /* LabeledScaleHelper */].create({
        x: xAxis.scale,
        y: yAxis.scale
      });
      var p1 = {
        x: hasX1 ? scale.x.apply(xValue1) : scale.x.rangeMin,
        y: hasY1 ? scale.y.apply(yValue1) : scale.y.rangeMin
      };
      var p2 = {
        x: hasX2 ? scale.x.apply(xValue2) : scale.x.rangeMax,
        y: hasY2 ? scale.y.apply(yValue2) : scale.y.rangeMax
      };

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_IfOverflowMatches__["a" /* ifOverflowMatches */])(this.props, 'discard') && (!scale.isInRange(p1) || !scale.isInRange(p2))) {
        return null;
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_CartesianUtils__["b" /* rectWithPoints */])(p1, p2);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          x1 = _this$props2.x1,
          x2 = _this$props2.x2,
          y1 = _this$props2.y1,
          y2 = _this$props2.y2,
          className = _this$props2.className,
          alwaysShow = _this$props2.alwaysShow,
          clipPathId = _this$props2.clipPathId;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_LogUtils__["a" /* warn */])(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      var hasX1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["c" /* isNumOrStr */])(x1);
      var hasX2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["c" /* isNumOrStr */])(x2);
      var hasY1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["c" /* isNumOrStr */])(y1);
      var hasY2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["c" /* isNumOrStr */])(y2);
      var shape = this.props.shape;

      if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) {
        return null;
      }

      var rect = this.getRect(hasX1, hasX2, hasY1, hasY2);

      if (!rect && !shape) {
        return null;
      }

      var clipPath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_IfOverflowMatches__["a" /* ifOverflowMatches */])(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__container_Layer__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('recharts-reference-area', className)
      }, this.constructor.renderRect(shape, _objectSpread({
        clipPath: clipPath
      }, this.props, {}, rect)), __WEBPACK_IMPORTED_MODULE_5__component_Label__["a" /* default */].renderCallByParent(this.props, rect));
    }
  }], [{
    key: "renderRect",
    value: function renderRect(option, props) {
      var rect;

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
        rect = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        rect = option(props);
      } else {
        rect = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shape_Rectangle__["a" /* default */], _extends({}, props, {
          className: "recharts-reference-area-rect"
        }));
      }

      return rect;
    }
  }]);

  return ReferenceArea;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

ReferenceArea.displayName = 'ReferenceArea';
ReferenceArea.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_10__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  viewBox: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number
  }),
  xAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  yAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  isFront: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  alwaysShow: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  ifOverflow: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hidden', 'visible', 'discard', 'extendDomain']),
  x1: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  x2: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  y1: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  y2: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  yAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  xAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  shape: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element])
});
ReferenceArea.defaultProps = {
  isFront: false,
  ifOverflow: 'discard',
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: '#ccc',
  fillOpacity: 0.5,
  stroke: 'none',
  strokeWidth: 1
};
/* harmony default export */ __webpack_exports__["a"] = (ReferenceArea);

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__container_Layer__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shape_Dot__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_Label__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_DataUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_IfOverflowMatches__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_CartesianUtils__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_LogUtils__ = __webpack_require__(140);


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Reference Dot
 */












var ReferenceDot =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ReferenceDot, _PureComponent);

  function ReferenceDot() {
    _classCallCheck(this, ReferenceDot);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReferenceDot).apply(this, arguments));
  }

  _createClass(ReferenceDot, [{
    key: "getCoordinate",
    value: function getCoordinate() {
      var _this$props = this.props,
          x = _this$props.x,
          y = _this$props.y,
          xAxis = _this$props.xAxis,
          yAxis = _this$props.yAxis;
      var scales = __WEBPACK_IMPORTED_MODULE_10__util_CartesianUtils__["a" /* LabeledScaleHelper */].create({
        x: xAxis.scale,
        y: yAxis.scale
      });
      var result = scales.apply({
        x: x,
        y: y
      }, {
        bandAware: true
      });

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_IfOverflowMatches__["a" /* ifOverflowMatches */])(this.props, 'discard') && !scales.isInRange(result)) {
        return null;
      }

      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          x = _this$props2.x,
          y = _this$props2.y,
          r = _this$props2.r,
          alwaysShow = _this$props2.alwaysShow,
          clipPathId = _this$props2.clipPathId;
      var isX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["c" /* isNumOrStr */])(x);
      var isY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_DataUtils__["c" /* isNumOrStr */])(y);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_LogUtils__["a" /* warn */])(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');

      if (!isX || !isY) {
        return null;
      }

      var coordinate = this.getCoordinate();

      if (!coordinate) {
        return null;
      }

      var cx = coordinate.x,
          cy = coordinate.y;
      var _this$props3 = this.props,
          shape = _this$props3.shape,
          className = _this$props3.className;
      var clipPath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_IfOverflowMatches__["a" /* ifOverflowMatches */])(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;

      var dotProps = _objectSpread({
        clipPath: clipPath
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props), {}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["b" /* filterEventAttributes */])(this.props), {
        cx: cx,
        cy: cy
      });

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__container_Layer__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('recharts-reference-dot', className)
      }, this.constructor.renderDot(shape, dotProps), __WEBPACK_IMPORTED_MODULE_7__component_Label__["a" /* default */].renderCallByParent(this.props, {
        x: cx - r,
        y: cy - r,
        width: 2 * r,
        height: 2 * r
      }));
    }
  }], [{
    key: "renderDot",
    value: function renderDot(option, props) {
      var dot;

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
        dot = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        dot = option(props);
      } else {
        dot = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shape_Dot__["a" /* default */], _extends({}, props, {
          cx: props.cx,
          cy: props.cy,
          className: "recharts-reference-dot-dot"
        }));
      }

      return dot;
    }
  }]);

  return ReferenceDot;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

ReferenceDot.displayName = 'ReferenceDot';
ReferenceDot.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {}, __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["d" /* EVENT_ATTRIBUTES */], {
  r: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  xAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    scale: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
  }),
  yAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    scale: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
  }),
  isFront: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  alwaysShow: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  ifOverflow: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['hidden', 'visible', 'discard', 'extendDomain']),
  x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string]),
  yAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  xAxisId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  shape: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element]),
  clipPathId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
});
ReferenceDot.defaultProps = {
  isFront: false,
  ifOverflow: 'discard',
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: '#fff',
  stroke: '#ccc',
  fillOpacity: 1,
  strokeWidth: 1
};
/* harmony default export */ __webpack_exports__["a"] = (ReferenceDot);

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some__ = __webpack_require__(1747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_some___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_some__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__container_Layer__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__component_Label__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_IfOverflowMatches__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_DataUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_CartesianUtils__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_LogUtils__ = __webpack_require__(140);



function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * @fileOverview Reference Line
 */











var renderLine = function renderLine(option, props) {
  var line;

  if (__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(option)) {
    line = __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(option, props);
  } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(option)) {
    line = option(props);
  } else {
    line = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("line", _extends({}, props, {
      className: "recharts-reference-line-line"
    }));
  }

  return line;
};

var ReferenceLine =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ReferenceLine, _PureComponent);

  function ReferenceLine() {
    _classCallCheck(this, ReferenceLine);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReferenceLine).apply(this, arguments));
  }

  _createClass(ReferenceLine, [{
    key: "getEndPoints",
    value: function getEndPoints(scales, isFixedX, isFixedY, isSegment) {
      var _this$props = this.props,
          _this$props$viewBox = _this$props.viewBox,
          x = _this$props$viewBox.x,
          y = _this$props$viewBox.y,
          width = _this$props$viewBox.width,
          height = _this$props$viewBox.height,
          position = _this$props.position;

      if (isFixedY) {
        var _this$props2 = this.props,
            yCoord = _this$props2.y,
            orientation = _this$props2.yAxis.orientation;
        var coord = scales.y.apply(yCoord, {
          position: position
        });

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_IfOverflowMatches__["a" /* ifOverflowMatches */])(this.props, 'discard') && !scales.y.isInRange(coord)) {
          return null;
        }

        var points = [{
          x: x + width,
          y: coord
        }, {
          x: x,
          y: coord
        }];
        return orientation === 'left' ? points.reverse() : points;
      }

      if (isFixedX) {
        var _this$props3 = this.props,
            xCoord = _this$props3.x,
            _orientation = _this$props3.xAxis.orientation;

        var _coord = scales.x.apply(xCoord, {
          position: position
        });

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_IfOverflowMatches__["a" /* ifOverflowMatches */])(this.props, 'discard') && !scales.x.isInRange(_coord)) {
          return null;
        }

        var _points = [{
          x: _coord,
          y: y + height
        }, {
          x: _coord,
          y: y
        }];
        return _orientation === 'top' ? _points.reverse() : _points;
      }

      if (isSegment) {
        var segment = this.props.segment;

        var _points2 = segment.map(function (p) {
          return scales.apply(p, {
            position: position
          });
        });

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_IfOverflowMatches__["a" /* ifOverflowMatches */])(this.props, 'discard') && __WEBPACK_IMPORTED_MODULE_0_lodash_some___default()(_points2, function (p) {
          return !scales.isInRange(p);
        })) {
          return null;
        }

        return _points2;
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          fixedX = _this$props4.x,
          fixedY = _this$props4.y,
          segment = _this$props4.segment,
          xAxis = _this$props4.xAxis,
          yAxis = _this$props4.yAxis,
          shape = _this$props4.shape,
          className = _this$props4.className,
          alwaysShow = _this$props4.alwaysShow,
          clipPathId = _this$props4.clipPathId;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_LogUtils__["a" /* warn */])(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      var scales = __WEBPACK_IMPORTED_MODULE_10__util_CartesianUtils__["a" /* LabeledScaleHelper */].create({
        x: xAxis.scale,
        y: yAxis.scale
      });
      var isX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["c" /* isNumOrStr */])(fixedX);
      var isY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_DataUtils__["c" /* isNumOrStr */])(fixedY);
      var isSegment = segment && segment.length === 2;
      var endPoints = this.getEndPoints(scales, isX, isY, isSegment);

      if (!endPoints) {
        return null;
      }

      var _endPoints = _slicedToArray(endPoints, 2),
          _endPoints$ = _endPoints[0],
          x1 = _endPoints$.x,
          y1 = _endPoints$.y,
          _endPoints$2 = _endPoints[1],
          x2 = _endPoints$2.x,
          y2 = _endPoints$2.y;

      var clipPath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_IfOverflowMatches__["a" /* ifOverflowMatches */])(this.props, 'hidden') ? "url(#".concat(clipPathId, ")") : undefined;

      var props = _objectSpread({
        clipPath: clipPath
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props), {}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["b" /* filterEventAttributes */])(this.props), {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
      });

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__container_Layer__["a" /* default */], {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()('recharts-reference-line', className)
      }, renderLine(shape, props), __WEBPACK_IMPORTED_MODULE_7__component_Label__["a" /* default */].renderCallByParent(this.props, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__util_CartesianUtils__["c" /* rectWithCoords */])({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
      })));
    }
  }]);

  return ReferenceLine;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

ReferenceLine.displayName = 'ReferenceLine';
ReferenceLine.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_6__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  viewBox: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    width: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    height: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number
  }),
  xAxis: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  yAxis: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  isFront: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  alwaysShow: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  ifOverflow: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['hidden', 'visible', 'discard', 'extendDomain']),
  x: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  y: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  segment: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
    y: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string])
  })),
  position: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['middle', 'start', 'end']),
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),
  yAxisId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  xAxisId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  shape: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
});
ReferenceLine.defaultProps = {
  isFront: false,
  ifOverflow: 'discard',
  xAxisId: 0,
  yAxisId: 0,
  fill: 'none',
  stroke: '#ccc',
  fillOpacity: 1,
  strokeWidth: 1,
  position: 'middle'
};
/* harmony default export */ __webpack_exports__["a"] = (ReferenceLine);

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isPlainObject__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isPlainObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isPlainObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isFunction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_omit__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isString__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isString___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isString__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isNumber__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_isNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_isNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_smooth__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__container_Layer__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shape_Trapezoid__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__component_LabelList__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__component_Cell__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_DataUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__ = __webpack_require__(44);







function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Render sectors of a funnel
 */












var Funnel =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Funnel, _PureComponent);

  function Funnel() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Funnel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Funnel)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isAnimationFinished: false
    };

    _this.cachePrevData = function (trapezoids) {
      _this.setState({
        prevTrapezoids: trapezoids
      });
    };

    _this.handleAnimationEnd = function () {
      var onAnimationEnd = _this.props.onAnimationEnd;

      _this.setState({
        isAnimationFinished: true
      });

      if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(onAnimationEnd)) {
        onAnimationEnd();
      }
    };

    _this.handleAnimationStart = function () {
      var onAnimationStart = _this.props.onAnimationStart;

      _this.setState({
        isAnimationFinished: false
      });

      if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(onAnimationStart)) {
        onAnimationStart();
      }
    };

    return _this;
  }

  _createClass(Funnel, [{
    key: "componentWillReceiveProps",
    // eslint-disable-next-line camelcase
    value: function componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
          animationId = _this$props.animationId,
          trapezoids = _this$props.trapezoids;

      if (nextProps.isAnimationActive !== this.props.isAnimationActive) {
        this.cachePrevData([]);
      } else if (nextProps.animationId !== animationId) {
        this.cachePrevData(trapezoids);
      }
    }
  }, {
    key: "isActiveIndex",
    value: function isActiveIndex(i) {
      var activeIndex = this.props.activeIndex;

      if (Array.isArray(activeIndex)) {
        return activeIndex.indexOf(i) !== -1;
      }

      return i === activeIndex;
    }
  }, {
    key: "renderTrapezoidsStatically",
    value: function renderTrapezoidsStatically(trapezoids) {
      var _this2 = this;

      var activeShape = this.props.activeShape;
      return trapezoids.map(function (entry, i) {
        var trapezoidOptions = _this2.isActiveIndex(i) ? activeShape : null;

        var trapezoidProps = _objectSpread({}, entry, {
          stroke: entry.stroke
        });

        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__container_Layer__["a" /* default */], _extends({
          className: "recharts-funnel-trapezoid"
        }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["e" /* filterEventsOfChild */])(_this2.props, entry, i), {
          key: "trapezoid-".concat(i) // eslint-disable-line react/no-array-index-key

        }), _this2.constructor.renderTrapezoidItem(trapezoidOptions, trapezoidProps));
      });
    }
  }, {
    key: "renderTrapezoidsWithAnimation",
    value: function renderTrapezoidsWithAnimation() {
      var _this3 = this;

      var _this$props2 = this.props,
          trapezoids = _this$props2.trapezoids,
          isAnimationActive = _this$props2.isAnimationActive,
          animationBegin = _this$props2.animationBegin,
          animationDuration = _this$props2.animationDuration,
          animationEasing = _this$props2.animationEasing,
          animationId = _this$props2.animationId;
      var prevTrapezoids = this.state.prevTrapezoids;
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_smooth__["a" /* default */], {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "funnel-".concat(animationId),
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function (_ref) {
        var t = _ref.t;
        var stepData = trapezoids.map(function (entry, index) {
          var prev = prevTrapezoids && prevTrapezoids[index];

          if (prev) {
            var _interpolatorX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["b" /* interpolateNumber */])(prev.x, entry.x);

            var _interpolatorY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["b" /* interpolateNumber */])(prev.y, entry.y);

            var _interpolatorUpperWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["b" /* interpolateNumber */])(prev.upperWidth, entry.upperWidth);

            var _interpolatorLowerWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["b" /* interpolateNumber */])(prev.lowerWidth, entry.lowerWidth);

            var _interpolatorHeight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["b" /* interpolateNumber */])(prev.height, entry.height);

            return _objectSpread({}, entry, {
              x: _interpolatorX(t),
              y: _interpolatorY(t),
              upperWidth: _interpolatorUpperWidth(t),
              lowerWidth: _interpolatorLowerWidth(t),
              height: _interpolatorHeight(t)
            });
          }

          var interpolatorX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["b" /* interpolateNumber */])(entry.x + entry.upperWidth / 2, entry.x);
          var interpolatorY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["b" /* interpolateNumber */])(entry.y + entry.height / 2, entry.y);
          var interpolatorUpperWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["b" /* interpolateNumber */])(0, entry.upperWidth);
          var interpolatorLowerWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["b" /* interpolateNumber */])(0, entry.lowerWidth);
          var interpolatorHeight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__util_DataUtils__["b" /* interpolateNumber */])(0, entry.height);
          return _objectSpread({}, entry, {
            x: interpolatorX(t),
            y: interpolatorY(t),
            upperWidth: interpolatorUpperWidth(t),
            lowerWidth: interpolatorLowerWidth(t),
            height: interpolatorHeight(t)
          });
        });
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__container_Layer__["a" /* default */], null, _this3.renderTrapezoidsStatically(stepData));
      });
    }
  }, {
    key: "renderTrapezoids",
    value: function renderTrapezoids() {
      var _this$props3 = this.props,
          trapezoids = _this$props3.trapezoids,
          isAnimationActive = _this$props3.isAnimationActive;
      var prevTrapezoids = this.state.prevTrapezoids;

      if (isAnimationActive && trapezoids && trapezoids.length && (!prevTrapezoids || !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevTrapezoids, trapezoids))) {
        return this.renderTrapezoidsWithAnimation();
      }

      return this.renderTrapezoidsStatically(trapezoids);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          hide = _this$props4.hide,
          trapezoids = _this$props4.trapezoids,
          className = _this$props4.className,
          isAnimationActive = _this$props4.isAnimationActive;
      var isAnimationFinished = this.state.isAnimationFinished;

      if (hide || !trapezoids || !trapezoids.length) {
        return null;
      }

      var layerClass = __WEBPACK_IMPORTED_MODULE_9_classnames___default()('recharts-trapezoids', className);
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__container_Layer__["a" /* default */], {
        className: layerClass
      }, this.renderTrapezoids(), (!isAnimationActive || isAnimationFinished) && __WEBPACK_IMPORTED_MODULE_12__component_LabelList__["a" /* default */].renderCallByParent(this.props, trapezoids));
    }
  }], [{
    key: "renderTrapezoidItem",
    value: function renderTrapezoidItem(option, props) {
      if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(option)) {
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(option, props);
      }

      if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(option)) {
        return option(props);
      }

      if (__WEBPACK_IMPORTED_MODULE_1_lodash_isPlainObject___default()(option)) {
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shape_Trapezoid__["a" /* default */], _extends({}, props, option));
      }

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shape_Trapezoid__["a" /* default */], props);
    }
  }]);

  return Funnel;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

Funnel.displayName = 'Funnel';
Funnel.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {}, __WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["d" /* EVENT_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  animationId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  dataKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]).isRequired,
  nameKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]),
  data: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object),
  trapezoids: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object),
  hide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  activeShape: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.element]),
  legendType: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["f" /* LEGEND_TYPES */]),
  tooltipType: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["g" /* TOOLTIP_TYPES */]),
  activeIndex: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number)]),
  onAnimationStart: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAnimationEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'spring', 'linear'])
});
Funnel.defaultProps = {
  stroke: '#fff',
  fill: '#808080',
  legendType: 'rect',
  labelLine: true,
  hide: false,
  isAnimationActive: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["h" /* isSsr */])(),
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: 'ease',
  nameKey: 'name'
};

Funnel.getRealFunnelData = function (item) {
  var _item$props = item.props,
      data = _item$props.data,
      children = _item$props.children;
  var presentationProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["a" /* getPresentationAttributes */])(item.props);
  var cells = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_ReactUtils__["i" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_13__component_Cell__["a" /* default */]);

  if (data && data.length) {
    return data.map(function (entry, index) {
      return _objectSpread({
        payload: entry
      }, presentationProps, {}, entry, {}, cells && cells[index] && cells[index].props);
    });
  }

  if (cells && cells.length) {
    return cells.map(function (cell) {
      return _objectSpread({}, presentationProps, {}, cell.props);
    });
  }

  return [];
};

Funnel.getRealWidthHeight = function (item, offset) {
  var customWidth = item.props.width;
  var width = offset.width,
      height = offset.height,
      left = offset.left,
      right = offset.right,
      top = offset.top,
      bottom = offset.bottom;
  var realHeight = height;
  var realWidth = width;

  if (__WEBPACK_IMPORTED_MODULE_5_lodash_isNumber___default()(customWidth)) {
    realWidth = customWidth;
  } else if (__WEBPACK_IMPORTED_MODULE_4_lodash_isString___default()(customWidth)) {
    realWidth = realWidth * parseFloat(customWidth) / 100;
  }

  return {
    realWidth: realWidth - left - right - 50,
    realHeight: realHeight - bottom - top,
    offsetX: (width - realWidth) / 2,
    offsetY: (height - realHeight) / 2
  };
};

Funnel.getComposedData = function (_ref2) {
  var item = _ref2.item,
      offset = _ref2.offset,
      onItemMouseLeave = _ref2.onItemMouseLeave,
      onItemMouseEnter = _ref2.onItemMouseEnter;
  var funnelData = Funnel.getRealFunnelData(item);
  var _item$props2 = item.props,
      dataKey = _item$props2.dataKey,
      nameKey = _item$props2.nameKey,
      tooltipType = _item$props2.tooltipType;
  var left = offset.left,
      top = offset.top;

  var _Funnel$getRealWidthH = Funnel.getRealWidthHeight(item, offset),
      realHeight = _Funnel$getRealWidthH.realHeight,
      realWidth = _Funnel$getRealWidthH.realWidth,
      offsetX = _Funnel$getRealWidthH.offsetX,
      offsetY = _Funnel$getRealWidthH.offsetY;

  var maxValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__["a" /* getValueByDataKey */])(funnelData[0], dataKey, 0);
  var len = funnelData.length;
  var rowHeight = realHeight / len;
  var trapezoids = funnelData.map(function (entry, i) {
    var val = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__["a" /* getValueByDataKey */])(entry, dataKey, 0);
    var name = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__["a" /* getValueByDataKey */])(entry, nameKey, i);
    var nextVal = 0;

    if (i !== len - 1) {
      nextVal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_ChartUtils__["a" /* getValueByDataKey */])(funnelData[i + 1], dataKey, 0);
    }

    var x = (maxValue - val) * realWidth / (2 * maxValue) + top + 25 + offsetX;
    var y = realHeight / len * i + left + offsetY;
    var upperWidth = val / maxValue * realWidth;
    var lowerWidth = nextVal / maxValue * realWidth;
    var tooltipPayload = [{
      name: name,
      value: val,
      payload: entry,
      dataKey: dataKey,
      type: tooltipType
    }];
    var tooltipPosition = {
      x: x + upperWidth / 2,
      y: y + rowHeight / 2
    };
    return _objectSpread({
      x: x,
      y: y,
      width: Math.max(upperWidth, lowerWidth),
      upperWidth: upperWidth,
      lowerWidth: lowerWidth,
      height: rowHeight,
      name: name,
      val: val,
      tooltipPayload: tooltipPayload,
      tooltipPosition: tooltipPosition
    }, __WEBPACK_IMPORTED_MODULE_3_lodash_omit___default()(entry, 'width'), {
      payload: entry
    });
  });
  return {
    trapezoids: trapezoids,
    data: funnelData,
    onMouseLeave: onItemMouseLeave,
    onMouseEnter: onItemMouseEnter
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Funnel);

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isPlainObject__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isPlainObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isPlainObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isNil__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isNil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isNil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_smooth__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__container_Layer__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shape_Sector__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shape_Curve__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__component_Text__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__component_Label__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__component_LabelList__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__component_Cell__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_PolarUtils__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__util_DataUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__util_ChartUtils__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__util_LogUtils__ = __webpack_require__(140);






function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Render sectors of a pie
 */

















var Pie =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Pie, _PureComponent);

  function Pie() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Pie);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Pie)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isAnimationFinished: false
    };
    _this.id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["f" /* uniqueId */])('recharts-pie-');

    _this.cachePrevData = function (sectors) {
      _this.setState({
        prevSectors: sectors
      });
    };

    _this.handleAnimationEnd = function () {
      var onAnimationEnd = _this.props.onAnimationEnd;

      _this.setState({
        isAnimationFinished: true
      });

      if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(onAnimationEnd)) {
        onAnimationEnd();
      }
    };

    _this.handleAnimationStart = function () {
      var onAnimationStart = _this.props.onAnimationStart;

      _this.setState({
        isAnimationFinished: false
      });

      if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(onAnimationStart)) {
        onAnimationStart();
      }
    };

    return _this;
  }

  _createClass(Pie, [{
    key: "componentWillReceiveProps",
    // eslint-disable-next-line camelcase
    value: function componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
          animationId = _this$props.animationId,
          sectors = _this$props.sectors;

      if (nextProps.isAnimationActive !== this.props.isAnimationActive) {
        this.cachePrevData([]);
      } else if (nextProps.animationId !== animationId) {
        this.cachePrevData(sectors);
      }
    }
  }, {
    key: "isActiveIndex",
    value: function isActiveIndex(i) {
      var activeIndex = this.props.activeIndex;

      if (Array.isArray(activeIndex)) {
        return activeIndex.indexOf(i) !== -1;
      }

      return i === activeIndex;
    }
  }, {
    key: "renderLabels",
    value: function renderLabels(sectors) {
      var _this2 = this;

      var isAnimationActive = this.props.isAnimationActive;

      if (isAnimationActive && !this.state.isAnimationFinished) {
        return null;
      }

      var _this$props2 = this.props,
          label = _this$props2.label,
          labelLine = _this$props2.labelLine,
          dataKey = _this$props2.dataKey,
          valueKey = _this$props2.valueKey;
      var pieProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props);
      var customLabelProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["a" /* getPresentationAttributes */])(label);
      var customLabelLineProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["a" /* getPresentationAttributes */])(labelLine);
      var offsetRadius = label && label.offsetRadius || 20;
      var labels = sectors.map(function (entry, i) {
        var midAngle = (entry.startAngle + entry.endAngle) / 2;
        var endPoint = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_PolarUtils__["a" /* polarToCartesian */])(entry.cx, entry.cy, entry.outerRadius + offsetRadius, midAngle);

        var labelProps = _objectSpread({}, pieProps, {}, entry, {
          stroke: 'none'
        }, customLabelProps, {
          index: i,
          textAnchor: _this2.constructor.getTextAnchor(endPoint.x, entry.cx)
        }, endPoint);

        var lineProps = _objectSpread({}, pieProps, {}, entry, {
          fill: 'none',
          stroke: entry.fill
        }, customLabelLineProps, {
          index: i,
          points: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_PolarUtils__["a" /* polarToCartesian */])(entry.cx, entry.cy, entry.outerRadius, midAngle), endPoint],
          key: 'line'
        });

        var realDataKey = dataKey; // TODO: compatible to lower versions

        if (__WEBPACK_IMPORTED_MODULE_4_lodash_isNil___default()(dataKey) && __WEBPACK_IMPORTED_MODULE_4_lodash_isNil___default()(valueKey)) {
          realDataKey = 'value';
        } else if (__WEBPACK_IMPORTED_MODULE_4_lodash_isNil___default()(dataKey)) {
          realDataKey = valueKey;
        }

        return (// eslint-disable-next-line react/no-array-index-key
          __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], {
            key: "label-".concat(i)
          }, labelLine && _this2.constructor.renderLabelLineItem(labelLine, lineProps), _this2.constructor.renderLabelItem(label, labelProps, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ChartUtils__["a" /* getValueByDataKey */])(entry, realDataKey)))
        );
      });
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], {
        className: "recharts-pie-labels"
      }, labels);
    }
  }, {
    key: "renderSectorsStatically",
    value: function renderSectorsStatically(sectors) {
      var _this3 = this;

      var _this$props3 = this.props,
          activeShape = _this$props3.activeShape,
          blendStroke = _this$props3.blendStroke;
      return sectors.map(function (entry, i) {
        var sectorOptions = _this3.isActiveIndex(i) ? activeShape : null;

        var sectorProps = _objectSpread({}, entry, {
          stroke: blendStroke ? entry.fill : entry.stroke
        });

        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], _extends({
          className: "recharts-pie-sector"
        }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["e" /* filterEventsOfChild */])(_this3.props, entry, i), {
          key: "sector-".concat(i) // eslint-disable-line react/no-array-index-key

        }), _this3.constructor.renderSectorItem(sectorOptions, sectorProps));
      });
    }
  }, {
    key: "renderSectorsWithAnimation",
    value: function renderSectorsWithAnimation() {
      var _this4 = this;

      var _this$props4 = this.props,
          sectors = _this$props4.sectors,
          isAnimationActive = _this$props4.isAnimationActive,
          animationBegin = _this$props4.animationBegin,
          animationDuration = _this$props4.animationDuration,
          animationEasing = _this$props4.animationEasing,
          animationId = _this$props4.animationId;
      var prevSectors = this.state.prevSectors;
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_smooth__["a" /* default */], {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "pie-".concat(animationId),
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function (_ref) {
        var t = _ref.t;
        var stepData = [];
        var first = sectors && sectors[0];
        var curAngle = first.startAngle;
        sectors.forEach(function (entry, index) {
          var prev = prevSectors && prevSectors[index];
          var paddingAngle = index > 0 ? __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(entry, 'paddingAngle', 0) : 0;

          if (prev) {
            var angleIp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["b" /* interpolateNumber */])(prev.endAngle - prev.startAngle, entry.endAngle - entry.startAngle);

            var latest = _objectSpread({}, entry, {
              startAngle: curAngle + paddingAngle,
              endAngle: curAngle + angleIp(t) + paddingAngle
            });

            stepData.push(latest);
            curAngle = latest.endAngle;
          } else {
            var endAngle = entry.endAngle,
                startAngle = entry.startAngle;
            var interpolatorAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["b" /* interpolateNumber */])(0, endAngle - startAngle);
            var deltaAngle = interpolatorAngle(t);

            var _latest = _objectSpread({}, entry, {
              startAngle: curAngle + paddingAngle,
              endAngle: curAngle + deltaAngle + paddingAngle
            });

            stepData.push(_latest);
            curAngle = _latest.endAngle;
          }
        });
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], null, _this4.renderSectorsStatically(stepData));
      });
    }
  }, {
    key: "renderSectors",
    value: function renderSectors() {
      var _this$props5 = this.props,
          sectors = _this$props5.sectors,
          isAnimationActive = _this$props5.isAnimationActive;
      var prevSectors = this.state.prevSectors;

      if (isAnimationActive && sectors && sectors.length && (!prevSectors || !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevSectors, sectors))) {
        return this.renderSectorsWithAnimation();
      }

      return this.renderSectorsStatically(sectors);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          hide = _this$props6.hide,
          sectors = _this$props6.sectors,
          className = _this$props6.className,
          label = _this$props6.label,
          cx = _this$props6.cx,
          cy = _this$props6.cy,
          innerRadius = _this$props6.innerRadius,
          outerRadius = _this$props6.outerRadius,
          isAnimationActive = _this$props6.isAnimationActive,
          prevSectors = _this$props6.prevSectors;

      if (hide || !sectors || !sectors.length || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["a" /* isNumber */])(cx) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["a" /* isNumber */])(cy) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["a" /* isNumber */])(innerRadius) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["a" /* isNumber */])(outerRadius)) {
        return null;
      }

      var layerClass = __WEBPACK_IMPORTED_MODULE_8_classnames___default()('recharts-pie', className);
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], {
        className: layerClass
      }, this.renderSectors(), label && this.renderLabels(sectors), __WEBPACK_IMPORTED_MODULE_13__component_Label__["a" /* default */].renderCallByParent(this.props, null, false), (!isAnimationActive || prevSectors && __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevSectors, sectors)) && __WEBPACK_IMPORTED_MODULE_14__component_LabelList__["a" /* default */].renderCallByParent(this.props, sectors, false));
    }
  }], [{
    key: "getTextAnchor",
    value: function getTextAnchor(x, cx) {
      if (x > cx) {
        return 'start';
      }

      if (x < cx) {
        return 'end';
      }

      return 'middle';
    }
  }, {
    key: "renderLabelLineItem",
    value: function renderLabelLineItem(option, props) {
      if (__WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(option)) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(option, props);
      }

      if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(option)) {
        return option(props);
      }

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shape_Curve__["a" /* default */], _extends({}, props, {
        type: "linear",
        className: "recharts-pie-label-line"
      }));
    }
  }, {
    key: "renderLabelItem",
    value: function renderLabelItem(option, props, value) {
      if (__WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(option)) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(option, props);
      }

      var label = value;

      if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(option)) {
        label = option(props);

        if (__WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(label)) {
          return label;
        }
      }

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__component_Text__["a" /* default */], _extends({}, props, {
        alignmentBaseline: "middle",
        className: "recharts-pie-label-text"
      }), label);
    }
  }, {
    key: "renderSectorItem",
    value: function renderSectorItem(option, props) {
      if (__WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(option)) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.cloneElement(option, props);
      }

      if (__WEBPACK_IMPORTED_MODULE_3_lodash_isFunction___default()(option)) {
        return option(props);
      }

      if (__WEBPACK_IMPORTED_MODULE_2_lodash_isPlainObject___default()(option)) {
        return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shape_Sector__["a" /* default */], _extends({}, props, option));
      }

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shape_Sector__["a" /* default */], props);
    }
  }]);

  return Pie;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

Pie.displayName = 'Pie';
Pie.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {}, __WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["d" /* EVENT_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  animationId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  cx: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  cy: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  startAngle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  endAngle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  paddingAngle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  innerRadius: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  outerRadius: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  cornerRadius: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string]),
  dataKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]).isRequired,
  nameKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]),
  valueKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]),
  data: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object),
  blendStroke: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  minAngle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  legendType: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["f" /* LEGEND_TYPES */]),
  tooltipType: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["g" /* TOOLTIP_TYPES */]),
  maxRadius: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  sectors: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object),
  hide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  labelLine: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool]),
  label: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    offsetRadius: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number
  }), __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool]),
  activeShape: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.element]),
  activeIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number)]),
  onAnimationStart: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onAnimationEnd: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'spring', 'linear']),
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
});
Pie.defaultProps = {
  stroke: '#fff',
  fill: '#808080',
  legendType: 'rect',
  // The abscissa of pole
  cx: '50%',
  // The ordinate of pole
  cy: '50%',
  // The start angle of first sector
  startAngle: 0,
  // The direction of drawing sectors
  endAngle: 360,
  // The inner radius of sectors
  innerRadius: 0,
  // The outer radius of sectors
  outerRadius: '80%',
  paddingAngle: 0,
  labelLine: true,
  hide: false,
  minAngle: 0,
  isAnimationActive: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["h" /* isSsr */])(),
  animationBegin: 400,
  animationDuration: 1500,
  animationEasing: 'ease',
  nameKey: 'name',
  // Match each sector's stroke color to it's fill color
  blendStroke: false
};

Pie.parseDeltaAngle = function (_ref2) {
  var startAngle = _ref2.startAngle,
      endAngle = _ref2.endAngle;
  var sign = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["d" /* mathSign */])(endAngle - startAngle);
  var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
  return sign * deltaAngle;
};

Pie.getRealPieData = function (item) {
  var _item$props = item.props,
      data = _item$props.data,
      children = _item$props.children;
  var presentationProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["a" /* getPresentationAttributes */])(item.props);
  var cells = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_ReactUtils__["i" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_15__component_Cell__["a" /* default */]);

  if (data && data.length) {
    return data.map(function (entry, index) {
      return _objectSpread({
        payload: entry
      }, presentationProps, {}, entry, {}, cells && cells[index] && cells[index].props);
    });
  }

  if (cells && cells.length) {
    return cells.map(function (cell) {
      return _objectSpread({}, presentationProps, {}, cell.props);
    });
  }

  return [];
};

Pie.parseCoordinateOfPie = function (item, offset) {
  var top = offset.top,
      left = offset.left,
      width = offset.width,
      height = offset.height;
  var maxPieRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_PolarUtils__["e" /* getMaxRadius */])(width, height);
  var cx = left + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["e" /* getPercentValue */])(item.props.cx, width, width / 2);
  var cy = top + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["e" /* getPercentValue */])(item.props.cy, height, height / 2);
  var innerRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["e" /* getPercentValue */])(item.props.innerRadius, maxPieRadius, 0);
  var outerRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["e" /* getPercentValue */])(item.props.outerRadius, maxPieRadius, maxPieRadius * 0.8);
  var maxRadius = item.props.maxRadius || Math.sqrt(width * width + height * height) / 2;
  return {
    cx: cx,
    cy: cy,
    innerRadius: innerRadius,
    outerRadius: outerRadius,
    maxRadius: maxRadius
  };
};

Pie.getComposedData = function (_ref3) {
  var item = _ref3.item,
      offset = _ref3.offset,
      onItemMouseLeave = _ref3.onItemMouseLeave,
      onItemMouseEnter = _ref3.onItemMouseEnter;
  var pieData = Pie.getRealPieData(item);

  if (!pieData || !pieData.length) {
    return [];
  }

  var _item$props2 = item.props,
      cornerRadius = _item$props2.cornerRadius,
      startAngle = _item$props2.startAngle,
      endAngle = _item$props2.endAngle,
      paddingAngle = _item$props2.paddingAngle,
      dataKey = _item$props2.dataKey,
      nameKey = _item$props2.nameKey,
      valueKey = _item$props2.valueKey,
      tooltipType = _item$props2.tooltipType;
  var minAngle = Math.abs(item.props.minAngle);
  var coordinate = Pie.parseCoordinateOfPie(item, offset);
  var len = pieData.length;
  var deltaAngle = Pie.parseDeltaAngle({
    startAngle: startAngle,
    endAngle: endAngle
  });
  var absDeltaAngle = Math.abs(deltaAngle);
  var totalPadingAngle = (absDeltaAngle >= 360 ? len : len - 1) * paddingAngle;
  var realTotalAngle = absDeltaAngle - len * minAngle - totalPadingAngle;
  var realDataKey = dataKey;

  if (__WEBPACK_IMPORTED_MODULE_4_lodash_isNil___default()(dataKey) && __WEBPACK_IMPORTED_MODULE_4_lodash_isNil___default()(valueKey)) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__util_LogUtils__["a" /* warn */])(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
    realDataKey = 'value';
  } else if (__WEBPACK_IMPORTED_MODULE_4_lodash_isNil___default()(dataKey)) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__util_LogUtils__["a" /* warn */])(false, "Use \"dataKey\" to specify the value of pie,\n      the props \"valueKey\" will be deprecated in 1.1.0");
    realDataKey = valueKey;
  }

  var sum = pieData.reduce(function (result, entry) {
    var val = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ChartUtils__["a" /* getValueByDataKey */])(entry, realDataKey, 0);
    return result + (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["a" /* isNumber */])(val) ? val : 0);
  }, 0);
  var sectors;

  if (sum > 0) {
    var prev;
    sectors = pieData.map(function (entry, i) {
      var val = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ChartUtils__["a" /* getValueByDataKey */])(entry, realDataKey, 0);
      var name = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ChartUtils__["a" /* getValueByDataKey */])(entry, nameKey, i);
      var percent = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["a" /* isNumber */])(val) ? val : 0) / sum;
      var tempStartAngle;

      if (i) {
        tempStartAngle = prev.endAngle + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["d" /* mathSign */])(deltaAngle) * paddingAngle;
      } else {
        tempStartAngle = startAngle;
      }

      var tempEndAngle = tempStartAngle + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["d" /* mathSign */])(deltaAngle) * (minAngle + percent * realTotalAngle);
      var midAngle = (tempStartAngle + tempEndAngle) / 2;
      var middleRadius = (coordinate.innerRadius + coordinate.outerRadius) / 2;
      var tooltipPayload = [{
        name: name,
        value: val,
        payload: entry,
        dataKey: realDataKey,
        type: tooltipType
      }];
      var tooltipPosition = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_PolarUtils__["a" /* polarToCartesian */])(coordinate.cx, coordinate.cy, middleRadius, midAngle);
      prev = _objectSpread({
        percent: percent,
        cornerRadius: cornerRadius,
        name: name,
        tooltipPayload: tooltipPayload,
        midAngle: midAngle,
        middleRadius: middleRadius,
        tooltipPosition: tooltipPosition
      }, entry, {}, coordinate, {
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__util_ChartUtils__["a" /* getValueByDataKey */])(entry, realDataKey),
        startAngle: tempStartAngle,
        endAngle: tempEndAngle,
        payload: entry,
        paddingAngle: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__util_DataUtils__["d" /* mathSign */])(deltaAngle) * paddingAngle
      });
      return prev;
    });
  }

  return _objectSpread({}, coordinate, {
    sectors: sectors,
    data: pieData,
    onMouseLeave: onItemMouseLeave,
    onMouseEnter: onItemMouseEnter
  });
};

/* harmony default export */ __webpack_exports__["a"] = (Pie);

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_smooth__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_DataUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_PolarUtils__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_ChartUtils__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shape_Polygon__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shape_Dot__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__container_Layer__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__component_LabelList__ = __webpack_require__(75);



function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Radar
 */













var Radar =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Radar, _PureComponent);

  function Radar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Radar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Radar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isAnimationFinished: false
    };

    _this.cachePrevData = function (points) {
      _this.setState({
        prevPoints: points
      });
    };

    _this.handleAnimationEnd = function () {
      var onAnimationEnd = _this.props.onAnimationEnd;

      _this.setState({
        isAnimationFinished: true
      });

      if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(onAnimationEnd)) {
        onAnimationEnd();
      }
    };

    _this.handleAnimationStart = function () {
      var onAnimationStart = _this.props.onAnimationStart;

      _this.setState({
        isAnimationFinished: false
      });

      if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(onAnimationStart)) {
        onAnimationStart();
      }
    };

    _this.handleMouseEnter = function (e) {
      var onMouseEnter = _this.props.onMouseEnter;

      if (onMouseEnter) {
        onMouseEnter(_this.props, e);
      }
    };

    _this.handleMouseLeave = function (e) {
      var onMouseLeave = _this.props.onMouseLeave;

      if (onMouseLeave) {
        onMouseLeave(_this.props, e);
      }
    };

    return _this;
  }

  _createClass(Radar, [{
    key: "componentWillReceiveProps",
    // eslint-disable-next-line camelcase
    value: function componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
          animationId = _this$props.animationId,
          points = _this$props.points;

      if (nextProps.animationId !== animationId) {
        this.cachePrevData(points);
      }
    }
  }, {
    key: "renderDots",
    value: function renderDots(points) {
      var _this2 = this;

      var _this$props2 = this.props,
          dot = _this$props2.dot,
          dataKey = _this$props2.dataKey;
      var baseProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props);
      var customDotProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["a" /* getPresentationAttributes */])(dot);
      var dots = points.map(function (entry, i) {
        var dotProps = _objectSpread({
          key: "dot-".concat(i),
          r: 3
        }, baseProps, {}, customDotProps, {
          dataKey: dataKey,
          cx: entry.x,
          cy: entry.y,
          index: i,
          payload: entry
        });

        return _this2.constructor.renderDotItem(dot, dotProps);
      });
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__container_Layer__["a" /* default */], {
        className: "recharts-radar-dots"
      }, dots);
    }
  }, {
    key: "renderPolygonStatically",
    value: function renderPolygonStatically(points) {
      var _this$props3 = this.props,
          shape = _this$props3.shape,
          dot = _this$props3.dot;
      var radar;

      if (__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(shape)) {
        radar = __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(shape, _objectSpread({}, this.props, {
          points: points
        }));
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(shape)) {
        radar = shape(_objectSpread({}, this.props, {
          points: points
        }));
      } else {
        radar = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shape_Polygon__["a" /* default */], _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["b" /* filterEventAttributes */])(this.props), {
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave
        }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props), {
          points: points
        }));
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__container_Layer__["a" /* default */], {
        className: "recharts-radar-polygon"
      }, radar, dot ? this.renderDots(points) : null);
    }
  }, {
    key: "renderPolygonWithAnimation",
    value: function renderPolygonWithAnimation() {
      var _this3 = this;

      var _this$props4 = this.props,
          points = _this$props4.points,
          isAnimationActive = _this$props4.isAnimationActive,
          animationBegin = _this$props4.animationBegin,
          animationDuration = _this$props4.animationDuration,
          animationEasing = _this$props4.animationEasing,
          animationId = _this$props4.animationId;
      var prevPoints = this.state.prevPoints;
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_smooth__["a" /* default */], {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "radar-".concat(animationId),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function (_ref) {
        var t = _ref.t;
        var prevPointsDiffFactor = prevPoints && prevPoints.length / points.length;
        var stepData = points.map(function (entry, index) {
          var prev = prevPoints && prevPoints[Math.floor(index * prevPointsDiffFactor)];

          if (prev) {
            var _interpolatorX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_DataUtils__["b" /* interpolateNumber */])(prev.x, entry.x);

            var _interpolatorY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_DataUtils__["b" /* interpolateNumber */])(prev.y, entry.y);

            return _objectSpread({}, entry, {
              x: _interpolatorX(t),
              y: _interpolatorY(t)
            });
          }

          var interpolatorX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_DataUtils__["b" /* interpolateNumber */])(entry.cx, entry.x);
          var interpolatorY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_DataUtils__["b" /* interpolateNumber */])(entry.cy, entry.y);
          return _objectSpread({}, entry, {
            x: interpolatorX(t),
            y: interpolatorY(t)
          });
        });
        return _this3.renderPolygonStatically(stepData);
      });
    }
  }, {
    key: "renderPolygon",
    value: function renderPolygon() {
      var _this$props5 = this.props,
          points = _this$props5.points,
          isAnimationActive = _this$props5.isAnimationActive;
      var prevPoints = this.state.prevPoints;

      if (isAnimationActive && points && points.length && (!prevPoints || !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevPoints, points))) {
        return this.renderPolygonWithAnimation();
      }

      return this.renderPolygonStatically(points);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          hide = _this$props6.hide,
          className = _this$props6.className,
          points = _this$props6.points,
          isAnimationActive = _this$props6.isAnimationActive;

      if (hide || !points || !points.length) {
        return null;
      }

      var isAnimationFinished = this.state.isAnimationFinished;
      var layerClass = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('recharts-radar', className);
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__container_Layer__["a" /* default */], {
        className: layerClass
      }, this.renderPolygon(), (!isAnimationActive || isAnimationFinished) && __WEBPACK_IMPORTED_MODULE_13__component_LabelList__["a" /* default */].renderCallByParent(this.props, points));
    }
  }], [{
    key: "renderDotItem",
    value: function renderDotItem(option, props) {
      var dotItem;

      if (__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(option)) {
        dotItem = __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(option)) {
        dotItem = option(props);
      } else {
        dotItem = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__shape_Dot__["a" /* default */], _extends({}, props, {
          className: "recharts-radar-dot"
        }));
      }

      return dotItem;
    }
  }]);

  return Radar;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

Radar.displayName = 'Radar';
Radar.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  dataKey: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]).isRequired,
  angleAxisId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  radiusAxisId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]),
  points: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    x: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    y: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    cx: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    cy: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    angle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    radius: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
    payload: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })),
  shape: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func]),
  activeDot: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool]),
  // whether have dot in poly line
  dot: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool]),
  label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool]),
  legendType: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["f" /* LEGEND_TYPES */]),
  tooltipType: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["g" /* TOOLTIP_TYPES */]),
  hide: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  onAnimationStart: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onAnimationEnd: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  animationId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  animationBegin: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
});
Radar.defaultProps = {
  angleAxisId: 0,
  radiusAxisId: 0,
  hide: false,
  activeDot: true,
  dot: false,
  legendType: 'rect',
  isAnimationActive: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__util_ReactUtils__["h" /* isSsr */])(),
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease'
};

Radar.getComposedData = function (_ref2) {
  var radiusAxis = _ref2.radiusAxis,
      angleAxis = _ref2.angleAxis,
      displayedData = _ref2.displayedData,
      dataKey = _ref2.dataKey,
      bandSize = _ref2.bandSize;
  var cx = angleAxis.cx,
      cy = angleAxis.cy;
  var points = displayedData.map(function (entry, i) {
    var name = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ChartUtils__["a" /* getValueByDataKey */])(entry, angleAxis.dataKey, i);
    var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ChartUtils__["a" /* getValueByDataKey */])(entry, dataKey, 0);
    var angle = angleAxis.scale(name) + (bandSize || 0);
    var radius = radiusAxis.scale(value);
    return _objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, radius, angle), {
      name: name,
      value: value,
      cx: cx,
      cy: cy,
      radius: radius,
      angle: angle,
      payload: entry
    });
  });
  return {
    points: points
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Radar);

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isArray__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_smooth__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shape_Sector__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__container_Layer__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__component_LabelList__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__component_Cell__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_DataUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__ = __webpack_require__(44);




function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Render a group of radial bar
 */












var RadialBar =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(RadialBar, _PureComponent);

  function RadialBar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, RadialBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(RadialBar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isAnimationFinished: false
    };

    _this.cachePrevData = function (data) {
      _this.setState({
        prevData: data
      });
    };

    _this.handleAnimationEnd = function () {
      var onAnimationEnd = _this.props.onAnimationEnd;

      _this.setState({
        isAnimationFinished: true
      });

      if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(onAnimationEnd)) {
        onAnimationEnd();
      }
    };

    _this.handleAnimationStart = function () {
      var onAnimationStart = _this.props.onAnimationStart;

      _this.setState({
        isAnimationFinished: false
      });

      if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(onAnimationStart)) {
        onAnimationStart();
      }
    };

    return _this;
  }

  _createClass(RadialBar, [{
    key: "componentWillReceiveProps",
    // eslint-disable-next-line camelcase
    value: function componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
          animationId = _this$props.animationId,
          data = _this$props.data;

      if (nextProps.animationId !== animationId) {
        this.cachePrevData(data);
      }
    }
  }, {
    key: "getDeltaAngle",
    value: function getDeltaAngle() {
      var _this$props2 = this.props,
          startAngle = _this$props2.startAngle,
          endAngle = _this$props2.endAngle;
      var sign = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["d" /* mathSign */])(endAngle - startAngle);
      var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
      return sign * deltaAngle;
    }
  }, {
    key: "renderSectorsStatically",
    value: function renderSectorsStatically(sectors) {
      var _this2 = this;

      var _this$props3 = this.props,
          shape = _this$props3.shape,
          activeShape = _this$props3.activeShape,
          activeIndex = _this$props3.activeIndex,
          cornerRadius = _this$props3.cornerRadius,
          others = _objectWithoutProperties(_this$props3, ["shape", "activeShape", "activeIndex", "cornerRadius"]);

      var baseProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["a" /* getPresentationAttributes */])(others);
      return sectors.map(function (entry, i) {
        var props = _objectSpread({}, baseProps, {
          cornerRadius: cornerRadius
        }, entry, {}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["e" /* filterEventsOfChild */])(_this2.props, entry, i), {
          key: "sector-".concat(i),
          className: 'recharts-radial-bar-sector',
          forceCornerRadius: others.forceCornerRadius,
          cornerIsExternal: others.cornerIsExternal
        });

        return _this2.constructor.renderSectorShape(i === activeIndex ? activeShape : shape, props);
      });
    }
  }, {
    key: "renderSectorsWithAnimation",
    value: function renderSectorsWithAnimation() {
      var _this3 = this;

      var _this$props4 = this.props,
          data = _this$props4.data,
          isAnimationActive = _this$props4.isAnimationActive,
          animationBegin = _this$props4.animationBegin,
          animationDuration = _this$props4.animationDuration,
          animationEasing = _this$props4.animationEasing,
          animationId = _this$props4.animationId;
      var prevData = this.state.prevData;
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_smooth__["a" /* default */], {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "radialBar-".concat(animationId),
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function (_ref) {
        var t = _ref.t;
        var stepData = data.map(function (entry, index) {
          var prev = prevData && prevData[index];

          if (prev) {
            var interpolatorStartAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["b" /* interpolateNumber */])(prev.startAngle, entry.startAngle);
            var interpolatorEndAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["b" /* interpolateNumber */])(prev.endAngle, entry.endAngle);
            return _objectSpread({}, entry, {
              startAngle: interpolatorStartAngle(t),
              endAngle: interpolatorEndAngle(t)
            });
          }

          var endAngle = entry.endAngle,
              startAngle = entry.startAngle;
          var interpolator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["b" /* interpolateNumber */])(startAngle, endAngle);
          return _objectSpread({}, entry, {
            endAngle: interpolator(t)
          });
        });
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */], null, _this3.renderSectorsStatically(stepData));
      });
    }
  }, {
    key: "renderSectors",
    value: function renderSectors() {
      var _this$props5 = this.props,
          data = _this$props5.data,
          isAnimationActive = _this$props5.isAnimationActive;
      var prevData = this.state.prevData;

      if (isAnimationActive && data && data.length && (!prevData || !__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(prevData, data))) {
        return this.renderSectorsWithAnimation();
      }

      return this.renderSectorsStatically(data);
    }
  }, {
    key: "renderBackground",
    value: function renderBackground(sectors) {
      var _this4 = this;

      var cornerRadius = this.props.cornerRadius;
      var backgroundProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props.background);
      return sectors.map(function (entry, i) {
        // eslint-disable-next-line no-unused-vars
        var value = entry.value,
            background = entry.background,
            rest = _objectWithoutProperties(entry, ["value", "background"]);

        if (!background) {
          return null;
        }

        var props = _objectSpread({
          cornerRadius: cornerRadius
        }, rest, {
          fill: '#eee'
        }, background, {}, backgroundProps, {}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["e" /* filterEventsOfChild */])(_this4.props, entry, i), {
          index: i,
          key: "sector-".concat(i),
          className: 'recharts-radial-bar-background-sector'
        });

        return _this4.constructor.renderSectorShape(background, props);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          hide = _this$props6.hide,
          data = _this$props6.data,
          className = _this$props6.className,
          background = _this$props6.background,
          isAnimationActive = _this$props6.isAnimationActive;

      if (hide || !data || !data.length) {
        return null;
      }

      var isAnimationFinished = this.state.isAnimationFinished;
      var layerClass = __WEBPACK_IMPORTED_MODULE_5_classnames___default()('recharts-area', className);
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */], {
        className: layerClass
      }, background && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */], {
        className: "recharts-radial-bar-background"
      }, this.renderBackground(data)), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */], {
        className: "recharts-radial-bar-sectors"
      }, this.renderSectors(data)), (!isAnimationActive || isAnimationFinished) && __WEBPACK_IMPORTED_MODULE_10__component_LabelList__["a" /* default */].renderCallByParent(_objectSpread({}, this.props, {
        clockWise: this.getDeltaAngle() < 0
      }), data));
    }
  }], [{
    key: "renderSectorShape",
    value: function renderSectorShape(shape, props) {
      var sectorShape;

      if (__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(shape)) {
        sectorShape = __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(shape, props);
      } else if (__WEBPACK_IMPORTED_MODULE_1_lodash_isFunction___default()(shape)) {
        sectorShape = shape(props);
      } else {
        sectorShape = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__shape_Sector__["a" /* default */], props);
      }

      return sectorShape;
    }
  }]);

  return RadialBar;
}(__WEBPACK_IMPORTED_MODULE_3_react__["PureComponent"]);

RadialBar.displayName = 'RadialBar';
RadialBar.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  angleAxisId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  radiusAxisId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number]),
  shape: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element]),
  activeShape: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element]),
  activeIndex: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  dataKey: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]).isRequired,
  cornerRadius: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string]),
  forceCornerRadius: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  cornerIsExternal: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  minPointSize: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  maxBarSize: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  data: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    cx: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    cy: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    innerRadius: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    outerRadius: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
    value: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.value
  })),
  legendType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["f" /* LEGEND_TYPES */]),
  tooltipType: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["g" /* TOOLTIP_TYPES */]),
  label: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object]),
  background: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.element]),
  hide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  onAnimationStart: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onAnimationEnd: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear', 'spring'])
});
RadialBar.defaultProps = {
  angleAxisId: 0,
  radiusAxisId: 0,
  minPointSize: 0,
  hide: false,
  legendType: 'rect',
  data: [],
  isAnimationActive: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["h" /* isSsr */])(),
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease',
  forceCornerRadius: false,
  cornerIsExternal: false
};

RadialBar.getComposedData = function (_ref2) {
  var item = _ref2.item,
      props = _ref2.props,
      radiusAxis = _ref2.radiusAxis,
      radiusAxisTicks = _ref2.radiusAxisTicks,
      angleAxis = _ref2.angleAxis,
      angleAxisTicks = _ref2.angleAxisTicks,
      displayedData = _ref2.displayedData,
      dataKey = _ref2.dataKey,
      stackedData = _ref2.stackedData,
      barPosition = _ref2.barPosition,
      bandSize = _ref2.bandSize,
      dataStartIndex = _ref2.dataStartIndex;
  var pos = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__["y" /* findPositionOfBar */])(barPosition, item);

  if (!pos) {
    return [];
  }

  var cx = angleAxis.cx,
      cy = angleAxis.cy;
  var layout = props.layout;
  var _item$props = item.props,
      children = _item$props.children,
      minPointSize = _item$props.minPointSize;
  var numericAxis = layout === 'radial' ? angleAxis : radiusAxis;
  var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
  var baseValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__["z" /* getBaseValueOfBar */])({
    props: props,
    numericAxis: numericAxis
  });
  var cells = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util_ReactUtils__["i" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_11__component_Cell__["a" /* default */]);
  var sectors = displayedData.map(function (entry, index) {
    var value, innerRadius, outerRadius, startAngle, endAngle, backgroundSector;

    if (stackedData) {
      value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__["A" /* truncateByDomain */])(stackedData[dataStartIndex + index], stackedDomain);
    } else {
      value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__["a" /* getValueByDataKey */])(entry, dataKey);

      if (!__WEBPACK_IMPORTED_MODULE_2_lodash_isArray___default()(value)) {
        value = [baseValue, value];
      }
    }

    if (layout === 'radial') {
      innerRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__["B" /* getCateCoordinateOfBar */])({
        axis: radiusAxis,
        ticks: radiusAxisTicks,
        bandSize: bandSize,
        offset: pos.offset,
        entry: entry,
        index: index
      });
      endAngle = angleAxis.scale(value[1]);
      startAngle = angleAxis.scale(value[0]);
      outerRadius = innerRadius + pos.size;
      var deltaAngle = endAngle - startAngle;

      if (Math.abs(minPointSize) > 0 && Math.abs(deltaAngle) < Math.abs(minPointSize)) {
        var delta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["d" /* mathSign */])(deltaAngle || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaAngle));
        endAngle += delta;
      }

      backgroundSector = {
        background: {
          cx: cx,
          cy: cy,
          innerRadius: innerRadius,
          outerRadius: outerRadius,
          startAngle: props.startAngle,
          endAngle: props.endAngle
        }
      };
    } else {
      innerRadius = radiusAxis.scale(value[0]);
      outerRadius = radiusAxis.scale(value[1]);
      startAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__["B" /* getCateCoordinateOfBar */])({
        axis: angleAxis,
        ticks: angleAxisTicks,
        bandSize: bandSize,
        offset: pos.offset,
        entry: entry,
        index: index
      });
      endAngle = startAngle + pos.size;
      var deltaRadius = outerRadius - innerRadius;

      if (Math.abs(minPointSize) > 0 && Math.abs(deltaRadius) < Math.abs(minPointSize)) {
        var _delta = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_DataUtils__["d" /* mathSign */])(deltaRadius || minPointSize) * (Math.abs(minPointSize) - Math.abs(deltaRadius));

        outerRadius += _delta;
      }
    }

    return _objectSpread({}, entry, {}, backgroundSector, {
      payload: entry,
      value: stackedData ? value : value[1],
      cx: cx,
      cy: cy,
      innerRadius: innerRadius,
      outerRadius: outerRadius,
      startAngle: startAngle,
      endAngle: endAngle
    }, cells && cells[index] && cells[index].props);
  });
  return {
    data: sectors,
    layout: layout
  };
};

/* harmony default export */ __webpack_exports__["a"] = (RadialBar);

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_DataUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__ = __webpack_require__(23);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Cross
 */






var Cross =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Cross, _PureComponent);

  function Cross() {
    _classCallCheck(this, Cross);

    return _possibleConstructorReturn(this, _getPrototypeOf(Cross).apply(this, arguments));
  }

  _createClass(Cross, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          x = _this$props.x,
          y = _this$props.y,
          width = _this$props.width,
          height = _this$props.height,
          top = _this$props.top,
          left = _this$props.left,
          className = _this$props.className;

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_DataUtils__["a" /* isNumber */])(x) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_DataUtils__["a" /* isNumber */])(y) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_DataUtils__["a" /* isNumber */])(width) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_DataUtils__["a" /* isNumber */])(height) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_DataUtils__["a" /* isNumber */])(top) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_DataUtils__["a" /* isNumber */])(left)) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props), {
        className: __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-cross', className),
        d: this.constructor.getPath(x, y, width, height, top, left)
      }));
    }
  }], [{
    key: "getPath",
    value: function getPath(x, y, width, height, top, left) {
      return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
    }
  }]);

  return Cross;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Cross.displayName = 'Cross';
Cross.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  top: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  left: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
});
Cross.defaultProps = {
  x: 0,
  y: 0,
  top: 0,
  left: 0,
  width: 0,
  height: 0
};
/* harmony default export */ __webpack_exports__["a"] = (Cross);

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_smooth__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__ = __webpack_require__(23);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Rectangle
 */






var getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
  var widthGap = upperWidth - lowerWidth;
  var path;
  path = "M ".concat(x, ",").concat(y);
  path += "L ".concat(x + upperWidth, ",").concat(y);
  path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
  path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
  path += "L ".concat(x, ",").concat(y, " Z");
  return path;
};

var Trapezoid =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Trapezoid, _PureComponent);

  function Trapezoid() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Trapezoid);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Trapezoid)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      totalLength: -1
    };
    return _this;
  }

  _createClass(Trapezoid, [{
    key: "componentDidMount",

    /* eslint-disable  react/no-did-mount-set-state */
    value: function componentDidMount() {
      if (this.node && this.node.getTotalLength) {
        try {
          var totalLength = this.node.getTotalLength();

          if (totalLength) {
            this.setState({
              totalLength: totalLength
            });
          }
        } catch (err) {// calculate total length error
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          x = _this$props.x,
          y = _this$props.y,
          upperWidth = _this$props.upperWidth,
          lowerWidth = _this$props.lowerWidth,
          height = _this$props.height,
          className = _this$props.className;
      var totalLength = this.state.totalLength;
      var _this$props2 = this.props,
          animationEasing = _this$props2.animationEasing,
          animationDuration = _this$props2.animationDuration,
          animationBegin = _this$props2.animationBegin,
          isUpdateAnimationActive = _this$props2.isUpdateAnimationActive;

      if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) {
        return null;
      }

      var layerClass = __WEBPACK_IMPORTED_MODULE_2_classnames___default()('recharts-trapezoid', className);

      if (!isUpdateAnimationActive) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["b" /* filterEventAttributes */])(this.props), {
          className: layerClass,
          d: getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
        })));
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_smooth__["a" /* default */], {
        canBegin: totalLength > 0,
        from: {
          upperWidth: 0,
          lowerWidth: 0,
          height: height,
          x: x,
          y: y
        },
        to: {
          upperWidth: upperWidth,
          lowerWidth: lowerWidth,
          height: height,
          x: x,
          y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
      }, function (_ref) {
        var currUpperWidth = _ref.upperWidth,
            currLowerWidth = _ref.lowerWidth,
            currHeight = _ref.height,
            currX = _ref.x,
            currY = _ref.y;
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_smooth__["a" /* default */], {
          canBegin: totalLength > 0,
          from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
          to: "".concat(totalLength, "px 0px"),
          attributeName: "strokeDasharray",
          begin: animationBegin,
          duration: animationDuration,
          easing: animationEasing
        }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["a" /* getPresentationAttributes */])(_this2.props), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["b" /* filterEventAttributes */])(_this2.props), {
          className: layerClass,
          d: getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
          ref: function ref(node) {
            _this2.node = node;
          }
        })));
      });
    }
  }]);

  return Trapezoid;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

Trapezoid.displayName = 'Trapezoid';
Trapezoid.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {}, __WEBPACK_IMPORTED_MODULE_4__util_ReactUtils__["d" /* EVENT_ATTRIBUTES */], {
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  x: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  upperWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  lowerWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  isUpdateAnimationActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
});
Trapezoid.defaultProps = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: false,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'ease'
};
/* harmony default export */ __webpack_exports__["a"] = (Trapezoid);

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(356);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(1577);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(142);
var document = __webpack_require__(76).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(361);
var createDesc = __webpack_require__(656);
module.exports = __webpack_require__(141) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(141) && !__webpack_require__(92)(function () {
  return Object.defineProperty(__webpack_require__(649)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(142);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 653 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(1589);
var createDesc = __webpack_require__(656);
var toIObject = __webpack_require__(364);
var toPrimitive = __webpack_require__(365);
var has = __webpack_require__(234);
var IE8_DOM_DEFINE = __webpack_require__(651);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(141) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(234);
var toIObject = __webpack_require__(364);
var arrayIndexOf = __webpack_require__(1578)(false);
var IE_PROTO = __webpack_require__(658)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(76);
var hide = __webpack_require__(650);
var has = __webpack_require__(234);
var SRC = __webpack_require__(660)('src');
var $toString = __webpack_require__(1579);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(177).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(659)('keys');
var uid = __webpack_require__(660);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(177);
var global = __webpack_require__(76);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(1583) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 660 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(106),
    root = __webpack_require__(56);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(367),
    setCacheAdd = __webpack_require__(1721),
    setCacheHas = __webpack_require__(1722);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(56);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1665),
    isArguments = __webpack_require__(382),
    isArray = __webpack_require__(34),
    isBuffer = __webpack_require__(383),
    isIndex = __webpack_require__(377),
    isTypedArray = __webpack_require__(688);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 665 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(370),
    eq = __webpack_require__(247);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 667 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(1640),
    keys = __webpack_require__(148);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(369),
    isArray = __webpack_require__(34);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 670 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */
function baseGt(value, other) {
  return value > other;
}

module.exports = baseGt;


/***/ }),
/* 671 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */
function baseLt(value, other) {
  return value < other;
}

module.exports = baseLt;


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(371),
    isArrayLike = __webpack_require__(146);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 673 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(106);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(662),
    arraySome = __webpack_require__(665),
    cacheHas = __webpack_require__(673);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(669),
    getSymbols = __webpack_require__(376),
    keys = __webpack_require__(148);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(669),
    getSymbolsIn = __webpack_require__(679),
    keysIn = __webpack_require__(387);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(369),
    getPrototype = __webpack_require__(375),
    getSymbols = __webpack_require__(376),
    stubArray = __webpack_require__(695);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(48);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 681 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 682 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(1629);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(1660),
    shortOut = __webpack_require__(1723);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 685 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(48),
    now = __webpack_require__(1745),
    toNumber = __webpack_require__(697);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEvery = __webpack_require__(1631),
    baseEvery = __webpack_require__(1639),
    baseIteratee = __webpack_require__(55),
    isArray = __webpack_require__(34),
    isIterateeCall = __webpack_require__(245);

/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = isArray(collection) ? arrayEvery : baseEvery;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = every;


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1650),
    baseUnary = __webpack_require__(241),
    nodeUtil = __webpack_require__(380);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 689 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var baseExtremum = __webpack_require__(239),
    baseGt = __webpack_require__(670),
    identity = __webpack_require__(145);

/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */
function max(array) {
  return (array && array.length)
    ? baseExtremum(array, identity, baseGt)
    : undefined;
}

module.exports = max;


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

var baseExtremum = __webpack_require__(239),
    baseGt = __webpack_require__(670),
    baseIteratee = __webpack_require__(55);

/**
 * This method is like `_.max` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.maxBy(objects, function(o) { return o.n; });
 * // => { 'n': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.maxBy(objects, 'n');
 * // => { 'n': 2 }
 */
function maxBy(array, iteratee) {
  return (array && array.length)
    ? baseExtremum(array, baseIteratee(iteratee, 2), baseGt)
    : undefined;
}

module.exports = maxBy;


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

var baseExtremum = __webpack_require__(239),
    baseLt = __webpack_require__(671),
    identity = __webpack_require__(145);

/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */
function min(array) {
  return (array && array.length)
    ? baseExtremum(array, identity, baseLt)
    : undefined;
}

module.exports = min;


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(237),
    baseClone = __webpack_require__(1637),
    baseUnset = __webpack_require__(1669),
    castPath = __webpack_require__(242),
    copyObject = __webpack_require__(178),
    customOmitClone = __webpack_require__(1686),
    flatRest = __webpack_require__(1689),
    getAllKeysIn = __webpack_require__(678);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__(1684);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),
/* 695 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(697);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(1667),
    isObject = __webpack_require__(48),
    isSymbol = __webpack_require__(147);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(55),
    baseUniq = __webpack_require__(1668);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(1303).enable();
  window.Promise = __webpack_require__(1302);
}

// fetch() polyfill for making API calls.
__webpack_require__(1771);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(22);


/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_css_app_min_css__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_css_app_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_css_app_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_logbook_css__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_css_logbook_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_css_logbook_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_min_css__ = __webpack_require__(1152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_font_awesome_css_font_awesome_min_css__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table_dist_react_bootstrap_table_min_css__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table_dist_react_bootstrap_table_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table_dist_react_bootstrap_table_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select_dist_react_select_css__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select_dist_react_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_select_dist_react_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_datepicker_dist_react_datepicker_css__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_datepicker_dist_react_datepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_datepicker_dist_react_datepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__registerServiceWorker__ = __webpack_require__(985);











console.disableYellowBox = true;
__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */], null), document.getElementById('root'));
__WEBPACK_IMPORTED_MODULE_10__registerServiceWorker__["a" /* register */]();

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _omit2 = __webpack_require__(1287);

var _omit3 = _interopRequireDefault(_omit2);

var _includes2 = __webpack_require__(1278);

var _includes3 = _interopRequireDefault(_includes2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(418);

var _react2 = _interopRequireDefault(_react);

var _reactAddonsUpdate = __webpack_require__(557);

var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);

var _ToastMessage = __webpack_require__(389);

var _ToastMessage2 = _interopRequireDefault(_ToastMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ToastContainer = function (_Component) {
  _inherits(ToastContainer, _Component);

  function ToastContainer() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ToastContainer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ToastContainer.__proto__ || Object.getPrototypeOf(ToastContainer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      toasts: [],
      toastId: 0,
      messageList: []
    }, _this._handle_toast_remove = _this._handle_toast_remove.bind(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ToastContainer, [{
    key: "error",
    value: function error(message, title, optionsOverride) {
      this._notify(this.props.toastType.error, message, title, optionsOverride);
    }
  }, {
    key: "info",
    value: function info(message, title, optionsOverride) {
      this._notify(this.props.toastType.info, message, title, optionsOverride);
    }
  }, {
    key: "success",
    value: function success(message, title, optionsOverride) {
      this._notify(this.props.toastType.success, message, title, optionsOverride);
    }
  }, {
    key: "warning",
    value: function warning(message, title, optionsOverride) {
      this._notify(this.props.toastType.warning, message, title, optionsOverride);
    }
  }, {
    key: "clear",
    value: function clear() {
      var _this2 = this;

      Object.keys(this.refs).forEach(function (key) {
        _this2.refs[key].hideToast(false);
      });
    }
  }, {
    key: "_notify",
    value: function _notify(type, message, title) {
      var _this3 = this;

      var optionsOverride = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      if (this.props.preventDuplicates) {
        if ((0, _includes3.default)(this.state.messageList, message)) {
          return;
        }
      }
      var key = this.state.toastId++;
      var toastId = key;
      var newToast = (0, _reactAddonsUpdate2.default)(optionsOverride, {
        $merge: {
          type: type,
          title: title,
          message: message,
          toastId: toastId,
          key: key,
          ref: "toasts__" + key,
          handleOnClick: function handleOnClick(e) {
            if ("function" === typeof optionsOverride.handleOnClick) {
              optionsOverride.handleOnClick();
            }
            return _this3._handle_toast_on_click(e);
          },
          handleRemove: this._handle_toast_remove
        }
      });
      var toastOperation = _defineProperty({}, "" + (this.props.newestOnTop ? "$unshift" : "$push"), [newToast]);

      var messageOperation = _defineProperty({}, "" + (this.props.newestOnTop ? "$unshift" : "$push"), [message]);

      var nextState = (0, _reactAddonsUpdate2.default)(this.state, {
        toasts: toastOperation,
        messageList: messageOperation
      });
      this.setState(nextState);
    }
  }, {
    key: "_handle_toast_on_click",
    value: function _handle_toast_on_click(event) {
      this.props.onClick(event);
      if (event.defaultPrevented) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
    }
  }, {
    key: "_handle_toast_remove",
    value: function _handle_toast_remove(toastId) {
      var _this4 = this;

      if (this.props.preventDuplicates) {
        this.state.previousMessage = "";
      }
      var operationName = "" + (this.props.newestOnTop ? "reduceRight" : "reduce");
      this.state.toasts[operationName](function (found, toast, index) {
        if (found || toast.toastId !== toastId) {
          return false;
        }
        _this4.setState((0, _reactAddonsUpdate2.default)(_this4.state, {
          toasts: { $splice: [[index, 1]] },
          messageList: { $splice: [[index, 1]] }
        }));
        return true;
      }, false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var divProps = (0, _omit3.default)(this.props, ["toastType", "toastMessageFactory", "preventDuplicates", "newestOnTop"]);

      return _react2.default.createElement(
        "div",
        _extends({}, divProps, { "aria-live": "polite", role: "alert" }),
        this.state.toasts.map(function (toast) {
          return _this5.props.toastMessageFactory(toast);
        })
      );
    }
  }]);

  return ToastContainer;
}(_react.Component);

ToastContainer.propTypes = {
  toastType: _react.PropTypes.shape({
    error: _react.PropTypes.string,
    info: _react.PropTypes.string,
    success: _react.PropTypes.string,
    warning: _react.PropTypes.string
  }).isRequired,
  id: _react.PropTypes.string.isRequired,
  toastMessageFactory: _react.PropTypes.func.isRequired,
  preventDuplicates: _react.PropTypes.bool.isRequired,
  newestOnTop: _react.PropTypes.bool.isRequired,
  onClick: _react.PropTypes.func.isRequired
};
ToastContainer.defaultProps = {
  toastType: {
    error: "error",
    info: "info",
    success: "success",
    warning: "warning"
  },
  id: "toast-container",
  toastMessageFactory: _react2.default.createFactory(_ToastMessage2.default.animation),
  preventDuplicates: true,
  newestOnTop: true,
  onClick: function onClick() {}
};
exports.default = ToastContainer;

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ReactTransitionEvents = __webpack_require__(745);

var _ReactTransitionEvents2 = _interopRequireDefault(_ReactTransitionEvents);

var _reactDom = __webpack_require__(390);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _elementClass = __webpack_require__(512);

var _elementClass2 = _interopRequireDefault(_elementClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TICK = 17;
var toString = Object.prototype.toString;
exports.default = {
  getDefaultProps: function getDefaultProps() {
    return {
      transition: null, // some examples defined in index.scss (scale, fadeInOut, rotate)
      showAnimation: "animated bounceIn", // or other animations from animate.css
      hideAnimation: "animated bounceOut",
      timeOut: 5000,
      extendedTimeOut: 1000
    };
  },
  componentWillMount: function componentWillMount() {
    this.classNameQueue = [];
    this.isHiding = false;
    this.intervalId = null;
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    this._is_mounted = true;
    this._show();
    var node = _reactDom2.default.findDOMNode(this);

    var onHideComplete = function onHideComplete() {
      if (_this.isHiding) {
        _this._set_is_hiding(false);
        _ReactTransitionEvents2.default.removeEndEventListener(node, onHideComplete);
        _this._handle_remove();
      }
    };
    _ReactTransitionEvents2.default.addEndEventListener(node, onHideComplete);

    if (this.props.timeOut > 0) {
      this._set_interval_id(setTimeout(this.hideToast, this.props.timeOut));
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    this._is_mounted = false;
    if (this.intervalId) {
      clearTimeout(this.intervalId);
    }
  },
  _set_transition: function _set_transition(hide) {
    var animationType = hide ? "leave" : "enter";
    var node = _reactDom2.default.findDOMNode(this);
    var className = this.props.transition + "-" + animationType;
    var activeClassName = className + "-active";

    var endListener = function endListener(e) {
      if (e && e.target !== node) {
        return;
      }

      var classList = (0, _elementClass2.default)(node);
      classList.remove(className);
      classList.remove(activeClassName);

      _ReactTransitionEvents2.default.removeEndEventListener(node, endListener);
    };

    _ReactTransitionEvents2.default.addEndEventListener(node, endListener);

    (0, _elementClass2.default)(node).add(className);

    // Need to do this to actually trigger a transition.
    this._queue_class(activeClassName);
  },
  _clear_transition: function _clear_transition(hide) {
    var node = _reactDom2.default.findDOMNode(this);
    var animationType = hide ? "leave" : "enter";
    var className = this.props.transition + "-" + animationType;
    var activeClassName = className + "-active";

    var classList = (0, _elementClass2.default)(node);
    classList.remove(className);
    classList.remove(activeClassName);
  },
  _set_animation: function _set_animation(hide) {
    var node = _reactDom2.default.findDOMNode(this);
    var animations = this._get_animation_classes(hide);
    var endListener = function endListener(e) {
      if (e && e.target !== node) {
        return;
      }

      animations.forEach(function (anim) {
        return (0, _elementClass2.default)(node).remove(anim);
      });

      _ReactTransitionEvents2.default.removeEndEventListener(node, endListener);
    };

    _ReactTransitionEvents2.default.addEndEventListener(node, endListener);

    animations.forEach(function (anim) {
      return (0, _elementClass2.default)(node).add(anim);
    });
  },
  _get_animation_classes: function _get_animation_classes(hide) {
    var animations = hide ? this.props.hideAnimation : this.props.showAnimation;
    if ("[object Array]" === toString.call(animations)) {
      return animations;
    } else if ("string" === typeof animations) {
      return animations.split(" ");
    }
  },
  _clear_animation: function _clear_animation(hide) {
    var node = _reactDom2.default.findDOMNode(this);
    var animations = this._get_animation_classes(hide);
    animations.forEach(function (animation) {
      return (0, _elementClass2.default)(node).remove(animation);
    });
  },
  _queue_class: function _queue_class(className) {
    this.classNameQueue.push(className);

    if (!this.timeout) {
      this.timeout = setTimeout(this._flush_class_name_queue, TICK);
    }
  },
  _flush_class_name_queue: function _flush_class_name_queue() {
    var _this2 = this;

    if (this._is_mounted) {
      (function () {
        var node = _reactDom2.default.findDOMNode(_this2);
        _this2.classNameQueue.forEach(function (className) {
          return (0, _elementClass2.default)(node).add(className);
        });
      })();
    }
    this.classNameQueue.length = 0;
    this.timeout = null;
  },
  _show: function _show() {
    if (this.props.transition) {
      this._set_transition();
    } else if (this.props.showAnimation) {
      this._set_animation();
    }
  },
  handleMouseEnter: function handleMouseEnter() {
    clearTimeout(this.intervalId);
    this._set_interval_id(null);
    if (this.isHiding) {
      this._set_is_hiding(false);

      if (this.props.hideAnimation) {
        this._clear_animation(true);
      } else if (this.props.transition) {
        this._clear_transition(true);
      }
    }
  },
  handleMouseLeave: function handleMouseLeave() {
    if (!this.isHiding && (this.props.timeOut > 0 || this.props.extendedTimeOut > 0)) {
      this._set_interval_id(setTimeout(this.hideToast, this.props.extendedTimeOut));
    }
  },
  hideToast: function hideToast(override) {
    if (this.isHiding || this.intervalId === null && !override) {
      return;
    }

    this._set_is_hiding(true);
    if (this.props.transition) {
      this._set_transition(true);
    } else if (this.props.hideAnimation) {
      this._set_animation(true);
    } else {
      this._handle_remove();
    }
  },
  _set_interval_id: function _set_interval_id(intervalId) {
    this.intervalId = intervalId;
  },
  _set_is_hiding: function _set_is_hiding(isHiding) {
    this.isHiding = isHiding;
  }
};

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactDom = __webpack_require__(390);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function call_show_method($node, props) {
  $node[props.showMethod]({
    duration: props.showDuration,
    easing: props.showEasing
  });
}

exports.default = {
  getDefaultProps: function getDefaultProps() {
    return {
      style: {
        display: "none" },
      showMethod: "fadeIn", // slideDown, and show are built into jQuery
      showDuration: 300,
      showEasing: "swing", // and linear are built into jQuery
      hideMethod: "fadeOut",
      hideDuration: 1000,
      hideEasing: "swing",
      //
      timeOut: 5000,
      extendedTimeOut: 1000
    };
  },
  getInitialState: function getInitialState() {
    return {
      intervalId: null,
      isHiding: false
    };
  },
  componentDidMount: function componentDidMount() {
    call_show_method(this._get_$_node(), this.props);
    if (this.props.timeOut > 0) {
      this._set_interval_id(setTimeout(this.hideToast, this.props.timeOut));
    }
  },
  handleMouseEnter: function handleMouseEnter() {
    clearTimeout(this.state.intervalId);
    this._set_interval_id(null);
    this._set_is_hiding(false);

    call_show_method(this._get_$_node().stop(true, true), this.props);
  },
  handleMouseLeave: function handleMouseLeave() {
    if (!this.state.isHiding && (this.props.timeOut > 0 || this.props.extendedTimeOut > 0)) {
      this._set_interval_id(setTimeout(this.hideToast, this.props.extendedTimeOut));
    }
  },
  hideToast: function hideToast(override) {
    if (this.state.isHiding || this.state.intervalId === null && !override) {
      return;
    }
    this.setState({ isHiding: true });

    this._get_$_node()[this.props.hideMethod]({
      duration: this.props.hideDuration,
      easing: this.props.hideEasing,
      complete: this._handle_remove
    });
  },
  _get_$_node: function _get_$_node() {
    /* eslint-disable no-undef */
    return jQuery(_reactDom2.default.findDOMNode(this));
    /* eslint-enable no-undef */
  },
  _set_interval_id: function _set_interval_id(intervalId) {
    this.setState({
      intervalId: intervalId
    });
  },
  _set_is_hiding: function _set_is_hiding(isHiding) {
    this.setState({
      isHiding: isHiding
    });
  }
};

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastMessage = exports.ToastContainer = undefined;

var _ToastContainer = __webpack_require__(701);

var _ToastContainer2 = _interopRequireDefault(_ToastContainer);

var _ToastMessage = __webpack_require__(389);

var _ToastMessage2 = _interopRequireDefault(_ToastMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ToastContainer = _ToastContainer2.default;
exports.ToastMessage = _ToastMessage2.default;

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule AutoFocusUtils
 */



var ReactDOMComponentTree = __webpack_require__(39);

var focusNode = __webpack_require__(198);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule BeforeInputEventPlugin
 */



var EventConstants = __webpack_require__(67);
var EventPropagators = __webpack_require__(150);
var ExecutionEnvironment = __webpack_require__(31);
var FallbackCompositionState = __webpack_require__(712);
var SyntheticCompositionEvent = __webpack_require__(751);
var SyntheticInputEvent = __webpack_require__(754);

var keyOf = __webpack_require__(85);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

var topLevelTypes = EventConstants.topLevelTypes;

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onBeforeInput: null }),
      captured: keyOf({ onBeforeInputCapture: null })
    },
    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCompositionEnd: null }),
      captured: keyOf({ onCompositionEndCapture: null })
    },
    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCompositionStart: null }),
      captured: keyOf({ onCompositionStartCapture: null })
    },
    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCompositionUpdate: null }),
      captured: keyOf({ onCompositionUpdateCapture: null })
    },
    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case topLevelTypes.topCompositionStart:
      return eventTypes.compositionStart;
    case topLevelTypes.topCompositionEnd:
      return eventTypes.compositionEnd;
    case topLevelTypes.topCompositionUpdate:
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case topLevelTypes.topKeyUp:
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case topLevelTypes.topKeyDown:
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case topLevelTypes.topKeyPress:
    case topLevelTypes.topMouseDown:
    case topLevelTypes.topBlur:
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case topLevelTypes.topCompositionEnd:
      return getDataFromCustomEvent(nativeEvent);
    case topLevelTypes.topKeyPress:
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case topLevelTypes.topTextInput:
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === topLevelTypes.topCompositionEnd || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case topLevelTypes.topPaste:
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case topLevelTypes.topKeyPress:
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case topLevelTypes.topCompositionEnd:
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule CSSPropertyOperations
 */



var CSSProperty = __webpack_require__(391);
var ExecutionEnvironment = __webpack_require__(31);
var ReactInstrumentation = __webpack_require__(52);

var camelizeStyleName = __webpack_require__(514);
var dangerousStyleValue = __webpack_require__(761);
var hyphenateStyleName = __webpack_require__(518);
var memoizeStringOnly = __webpack_require__(519);
var warning = __webpack_require__(21);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {

  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var styleValue = styles[styleName];
      if (false) {
        warnValidStyle(styleName, styleValue, component);
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation(component._debugID, 'update styles', styles);
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      if (false) {
        warnValidStyle(styleName, styles[styleName], component);
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }

};

module.exports = CSSPropertyOperations;

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ChangeEventPlugin
 */



var EventConstants = __webpack_require__(67);
var EventPluginHub = __webpack_require__(149);
var EventPropagators = __webpack_require__(150);
var ExecutionEnvironment = __webpack_require__(31);
var ReactDOMComponentTree = __webpack_require__(39);
var ReactUpdates = __webpack_require__(59);
var SyntheticEvent = __webpack_require__(68);

var getEventTarget = __webpack_require__(268);
var isEventSupported = __webpack_require__(269);
var isTextInputElement = __webpack_require__(416);
var keyOf = __webpack_require__(85);

var topLevelTypes = EventConstants.topLevelTypes;

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onChange: null }),
      captured: keyOf({ onChangeCapture: null })
    },
    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
  }
};

/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;
var activeElementValue = null;
var activeElementValueProp = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
  EventPropagators.accumulateTwoPhaseDispatches(event);

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === topLevelTypes.topChange) {
    return targetInst;
  }
}
function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === topLevelTypes.topFocus) {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === topLevelTypes.topBlur) {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.
  // IE10+ fire input events to often, such when a placeholder
  // changes or when an input with a placeholder is focused.
  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
}

/**
 * (For IE <=11) Replacement getter/setter for the `value` property that gets
 * set on the active element.
 */
var newValueProp = {
  get: function () {
    return activeElementValueProp.get.call(this);
  },
  set: function (val) {
    // Cast to a string so we can do equality checks.
    activeElementValue = '' + val;
    activeElementValueProp.set.call(this, val);
  }
};

/**
 * (For IE <=11) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElementValue = target.value;
  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');

  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
  // on DOM elements
  Object.defineProperty(activeElement, 'value', newValueProp);
  if (activeElement.attachEvent) {
    activeElement.attachEvent('onpropertychange', handlePropertyChange);
  } else {
    activeElement.addEventListener('propertychange', handlePropertyChange, false);
  }
}

/**
 * (For IE <=11) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }

  // delete restores the original property definition
  delete activeElement.value;

  if (activeElement.detachEvent) {
    activeElement.detachEvent('onpropertychange', handlePropertyChange);
  } else {
    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
  }

  activeElement = null;
  activeElementInst = null;
  activeElementValue = null;
  activeElementValueProp = null;
}

/**
 * (For IE <=11) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  var value = nativeEvent.srcElement.value;
  if (value === activeElementValue) {
    return;
  }
  activeElementValue = value;

  manualDispatchChangeEvent(nativeEvent);
}

/**
 * If a `change` event should be fired, returns the target's ID.
 */
function getTargetInstForInputEvent(topLevelType, targetInst) {
  if (topLevelType === topLevelTypes.topInput) {
    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
    // what we want so fall through here and trigger an abstract event
    return targetInst;
  }
}

function handleEventsForInputEventIE(topLevelType, target, targetInst) {
  if (topLevelType === topLevelTypes.topFocus) {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9-11, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === topLevelTypes.topBlur) {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventIE(topLevelType, targetInst) {
  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    if (activeElement && activeElement.value !== activeElementValue) {
      activeElementValue = activeElement.value;
      return activeElementInst;
    }
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst) {
  if (topLevelType === topLevelTypes.topClick) {
    return targetInst;
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventIE;
        handleEventFunc = handleEventsForInputEventIE;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst);
      if (inst) {
        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
        event.type = 'change';
        EventPropagators.accumulateTwoPhaseDispatches(event);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }
  }

};

module.exports = ChangeEventPlugin;

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule Danger
 */



var _prodInvariant = __webpack_require__(25);

var DOMLazyTree = __webpack_require__(108);
var ExecutionEnvironment = __webpack_require__(31);

var createNodesFromMarkup = __webpack_require__(516);
var emptyFunction = __webpack_require__(37);
var invariant = __webpack_require__(17);

var Danger = {

  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }

};

module.exports = Danger;

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule DefaultEventPluginOrder
 */



var keyOf = __webpack_require__(85);

/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */
var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule EnterLeaveEventPlugin
 */



var EventConstants = __webpack_require__(67);
var EventPropagators = __webpack_require__(150);
var ReactDOMComponentTree = __webpack_require__(39);
var SyntheticMouseEvent = __webpack_require__(183);

var keyOf = __webpack_require__(85);

var topLevelTypes = EventConstants.topLevelTypes;

var eventTypes = {
  mouseEnter: {
    registrationName: keyOf({ onMouseEnter: null }),
    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
  },
  mouseLeave: {
    registrationName: keyOf({ onMouseLeave: null }),
    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
  }
};

var EnterLeaveEventPlugin = {

  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === topLevelTypes.topMouseOut) {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }

};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule FallbackCompositionState
 */



var _assign = __webpack_require__(22);

var PooledClass = __webpack_require__(78);

var getTextContentAccessor = __webpack_require__(413);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule HTMLDOMPropertyConfig
 */



var DOMProperty = __webpack_require__(109);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {}
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule React
 */



var _assign = __webpack_require__(22);

var ReactChildren = __webpack_require__(394);
var ReactComponent = __webpack_require__(256);
var ReactPureComponent = __webpack_require__(740);
var ReactClass = __webpack_require__(395);
var ReactDOMFactories = __webpack_require__(723);
var ReactElement = __webpack_require__(58);
var ReactPropTypes = __webpack_require__(405);
var ReactVersion = __webpack_require__(406);

var onlyChild = __webpack_require__(766);
var warning = __webpack_require__(21);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;

if (false) {
  var warned = false;
  __spread = function () {
    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
    warned = true;
    return _assign.apply(null, arguments);
  };
}

var React = {

  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactComponent,
  PureComponent: ReactPureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: ReactClass.createClass,
  createFactory: createFactory,
  createMixin: function (mixin) {
    // Currently a noop. Will be used to validate and trace mixins.
    return mixin;
  },

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

module.exports = React;

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactChildReconciler
 */



var ReactReconciler = __webpack_require__(110);

var instantiateReactComponent = __webpack_require__(415);
var KeyEscapeUtils = __webpack_require__(254);
var shouldUpdateReactComponent = __webpack_require__(270);
var traverseAllChildren = __webpack_require__(271);
var warning = __webpack_require__(21);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":""}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(258);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('./ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
  ) {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
  ) {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }

};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(102)))

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactComponentBrowserEnvironment
 */



var DOMChildrenOperations = __webpack_require__(250);
var ReactDOMIDOperations = __webpack_require__(725);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {

  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup

};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactCompositeComponent
 */



var _prodInvariant = __webpack_require__(25),
    _assign = __webpack_require__(22);

var ReactComponentEnvironment = __webpack_require__(257);
var ReactCurrentOwner = __webpack_require__(79);
var ReactElement = __webpack_require__(58);
var ReactErrorUtils = __webpack_require__(259);
var ReactInstanceMap = __webpack_require__(151);
var ReactInstrumentation = __webpack_require__(52);
var ReactNodeTypes = __webpack_require__(404);
var ReactPropTypeLocations = __webpack_require__(262);
var ReactReconciler = __webpack_require__(110);

var checkReactTypeSpec = __webpack_require__(760);
var emptyObject = __webpack_require__(70);
var invariant = __webpack_require__(17);
var shallowEqual = __webpack_require__(120);
var shouldUpdateReactComponent = __webpack_require__(270);
var warning = __webpack_require__(21);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || ReactElement.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponentMixin = {

  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || ReactElement.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedComponent;

    if (false) {
      renderedComponent = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedComponent = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedComponent === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedComponent = null;
      }
    }

    return renderedComponent;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedComponent;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedComponent;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null

};

var ReactCompositeComponent = {

  Mixin: ReactCompositeComponentMixin

};

module.exports = ReactCompositeComponent;

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOM
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(39);
var ReactDefaultInjection = __webpack_require__(733);
var ReactMount = __webpack_require__(402);
var ReactReconciler = __webpack_require__(110);
var ReactUpdates = __webpack_require__(59);
var ReactVersion = __webpack_require__(406);

var findDOMNode = __webpack_require__(762);
var getHostComponentFromComposite = __webpack_require__(411);
var renderSubtreeIntoContainer = __webpack_require__(768);
var warning = __webpack_require__(21);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
/* eslint-enable camelcase */
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {

    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
}

module.exports = ReactDOM;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMButton
 */



var DisabledInputUtils = __webpack_require__(181);

/**
 * Implements a <button> host component that does not receive mouse events
 * when `disabled` is set.
 */
var ReactDOMButton = {
  getHostProps: DisabledInputUtils.getHostProps
};

module.exports = ReactDOMButton;

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMComponent
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(25),
    _assign = __webpack_require__(22);

var AutoFocusUtils = __webpack_require__(705);
var CSSPropertyOperations = __webpack_require__(707);
var DOMLazyTree = __webpack_require__(108);
var DOMNamespaces = __webpack_require__(251);
var DOMProperty = __webpack_require__(109);
var DOMPropertyOperations = __webpack_require__(393);
var EventConstants = __webpack_require__(67);
var EventPluginHub = __webpack_require__(149);
var EventPluginRegistry = __webpack_require__(252);
var ReactBrowserEventEmitter = __webpack_require__(182);
var ReactDOMButton = __webpack_require__(719);
var ReactDOMComponentFlags = __webpack_require__(396);
var ReactDOMComponentTree = __webpack_require__(39);
var ReactDOMInput = __webpack_require__(726);
var ReactDOMOption = __webpack_require__(727);
var ReactDOMSelect = __webpack_require__(397);
var ReactDOMTextarea = __webpack_require__(730);
var ReactInstrumentation = __webpack_require__(52);
var ReactMultiChild = __webpack_require__(738);
var ReactServerRenderingTransaction = __webpack_require__(743);

var emptyFunction = __webpack_require__(37);
var escapeTextContentForBrowser = __webpack_require__(184);
var invariant = __webpack_require__(17);
var isEventSupported = __webpack_require__(269);
var keyOf = __webpack_require__(85);
var shallowEqual = __webpack_require__(120);
var validateDOMNesting = __webpack_require__(272);
var warning = __webpack_require__(21);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { 'string': true, 'number': true };

var STYLE = keyOf({ style: null });
var HTML = keyOf({ __html: null });
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
      break;
    case 'video':
    case 'audio':

      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topInvalid, 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  'area': true,
  'base': true,
  'br': true,
  'col': true,
  'embed': true,
  'hr': true,
  'img': true,
  'input': true,
  'keygen': true,
  'link': true,
  'meta': true,
  'param': true,
  'source': true,
  'track': true,
  'wbr': true
};

// NOTE: menuitem's close tag should be omitted, but that causes problems.
var newlineEatingTags = {
  'listing': true,
  'pre': true,
  'textarea': true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  'menuitem': true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {

  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'button':
        props = ReactDOMButton.getHostProps(this, props, hostParent);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
        DOMLazyTree.queueText(lazyTree, contentToUse);
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'button':
        lastProps = ReactDOMButton.getHostProps(this, lastProps);
        nextProps = ReactDOMButton.getHostProps(this, nextProps);
        break;
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }

};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMContainerInfo
 */



var validateDOMNesting = __webpack_require__(272);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMEmptyComponent
 */



var _assign = __webpack_require__(22);

var DOMLazyTree = __webpack_require__(108);
var ReactDOMComponentTree = __webpack_require__(39);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMFactories
 */



var ReactElement = __webpack_require__(58);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 * This is also accessible via `React.DOM`.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMFeatureFlags
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMIDOperations
 */



var DOMChildrenOperations = __webpack_require__(250);
var ReactDOMComponentTree = __webpack_require__(39);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {

  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMInput
 */



var _prodInvariant = __webpack_require__(25),
    _assign = __webpack_require__(22);

var DisabledInputUtils = __webpack_require__(181);
var DOMPropertyOperations = __webpack_require__(393);
var LinkedValueUtils = __webpack_require__(255);
var ReactDOMComponentTree = __webpack_require__(39);
var ReactUpdates = __webpack_require__(59);

var invariant = __webpack_require__(17);
var warning = __webpack_require__(21);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, DisabledInputUtils.getHostProps(inst, props), {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };

    if (false) {
      inst._wrapperState.controlled = isControlled(props);
    }
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {

      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        node.defaultValue = '' + props.defaultValue;
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMOption
 */



var _assign = __webpack_require__(22);

var ReactChildren = __webpack_require__(394);
var ReactDOMComponentTree = __webpack_require__(39);
var ReactDOMSelect = __webpack_require__(397);

var warning = __webpack_require__(21);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  ReactChildren.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }

};

module.exports = ReactDOMOption;

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMSelection
 */



var ExecutionEnvironment = __webpack_require__(31);

var getNodeForCharacterOffset = __webpack_require__(765);
var getTextContentAccessor = __webpack_require__(413);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMTextComponent
 */



var _prodInvariant = __webpack_require__(25),
    _assign = __webpack_require__(22);

var DOMChildrenOperations = __webpack_require__(250);
var DOMLazyTree = __webpack_require__(108);
var ReactDOMComponentTree = __webpack_require__(39);

var escapeTextContentForBrowser = __webpack_require__(184);
var invariant = __webpack_require__(17);
var validateDOMNesting = __webpack_require__(272);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {

  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }

});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMTextarea
 */



var _prodInvariant = __webpack_require__(25),
    _assign = __webpack_require__(22);

var DisabledInputUtils = __webpack_require__(181);
var LinkedValueUtils = __webpack_require__(255);
var ReactDOMComponentTree = __webpack_require__(39);
var ReactUpdates = __webpack_require__(59);

var invariant = __webpack_require__(17);
var warning = __webpack_require__(21);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, DisabledInputUtils.getHostProps(inst, props), {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Warning: node.value may be the empty string at this point (IE11) if placeholder is set.
    node.value = node.textContent; // Detach value from defaultValue
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDOMTreeTraversal
 */



var _prodInvariant = __webpack_require__(25);

var invariant = __webpack_require__(17);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], false, arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], true, arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], true, argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], false, argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDefaultBatchingStrategy
 */



var _assign = __webpack_require__(22);

var ReactUpdates = __webpack_require__(59);
var Transaction = __webpack_require__(153);

var emptyFunction = __webpack_require__(37);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      callback(a, b, c, d, e);
    } else {
      transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactDefaultInjection
 */



var BeforeInputEventPlugin = __webpack_require__(706);
var ChangeEventPlugin = __webpack_require__(708);
var DefaultEventPluginOrder = __webpack_require__(710);
var EnterLeaveEventPlugin = __webpack_require__(711);
var HTMLDOMPropertyConfig = __webpack_require__(713);
var ReactComponentBrowserEnvironment = __webpack_require__(716);
var ReactDOMComponent = __webpack_require__(720);
var ReactDOMComponentTree = __webpack_require__(39);
var ReactDOMEmptyComponent = __webpack_require__(722);
var ReactDOMTreeTraversal = __webpack_require__(731);
var ReactDOMTextComponent = __webpack_require__(729);
var ReactDefaultBatchingStrategy = __webpack_require__(732);
var ReactEventListener = __webpack_require__(735);
var ReactInjection = __webpack_require__(736);
var ReactReconcileTransaction = __webpack_require__(741);
var SVGDOMPropertyConfig = __webpack_require__(746);
var SelectEventPlugin = __webpack_require__(747);
var SimpleEventPlugin = __webpack_require__(748);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactEventEmitterMixin
 */



var EventPluginHub = __webpack_require__(149);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {

  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactEventListener
 */



var _assign = __webpack_require__(22);

var EventListener = __webpack_require__(197);
var ExecutionEnvironment = __webpack_require__(31);
var PooledClass = __webpack_require__(78);
var ReactDOMComponentTree = __webpack_require__(39);
var ReactUpdates = __webpack_require__(59);

var getEventTarget = __webpack_require__(268);
var getUnboundedScrollPosition = __webpack_require__(517);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} handle Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    var element = handle;
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} handle Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    var element = handle;
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactInjection
 */



var DOMProperty = __webpack_require__(109);
var EventPluginHub = __webpack_require__(149);
var EventPluginUtils = __webpack_require__(253);
var ReactComponentEnvironment = __webpack_require__(257);
var ReactClass = __webpack_require__(395);
var ReactEmptyComponent = __webpack_require__(398);
var ReactBrowserEventEmitter = __webpack_require__(182);
var ReactHostComponent = __webpack_require__(400);
var ReactUpdates = __webpack_require__(59);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  Class: ReactClass.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactMarkupChecksum
 */



var adler32 = __webpack_require__(759);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactMultiChild
 */



var _prodInvariant = __webpack_require__(25);

var ReactComponentEnvironment = __webpack_require__(257);
var ReactInstanceMap = __webpack_require__(151);
var ReactInstrumentation = __webpack_require__(52);
var ReactMultiChildUpdateTypes = __webpack_require__(403);

var ReactCurrentOwner = __webpack_require__(79);
var ReactReconciler = __webpack_require__(110);
var ReactChildReconciler = __webpack_require__(715);

var emptyFunction = __webpack_require__(37);
var flattenChildren = __webpack_require__(763);
var invariant = __webpack_require__(17);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: ReactMultiChildUpdateTypes.SET_MARKUP,
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {

  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {

    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }

  }

};

module.exports = ReactMultiChild;

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactOwner
 */



var _prodInvariant = __webpack_require__(25);

var invariant = __webpack_require__(17);

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {

  /**
   * @param {?object} object
   * @return {boolean} True if `object` is a valid owner.
   * @final
   */
  isValidOwner: function (object) {
    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
  },

  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }

};

module.exports = ReactOwner;

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactPureComponent
 */



var _assign = __webpack_require__(22);

var ReactComponent = __webpack_require__(256);
var ReactNoopUpdateQueue = __webpack_require__(260);

var emptyObject = __webpack_require__(70);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = ReactPureComponent;

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactReconcileTransaction
 */



var _assign = __webpack_require__(22);

var CallbackQueue = __webpack_require__(392);
var PooledClass = __webpack_require__(78);
var ReactBrowserEventEmitter = __webpack_require__(182);
var ReactInputSelection = __webpack_require__(401);
var ReactInstrumentation = __webpack_require__(52);
var Transaction = __webpack_require__(153);
var ReactUpdateQueue = __webpack_require__(264);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactRef
 */



var ReactOwner = __webpack_require__(739);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || element === false) {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;

  return (
    // This has a few false positives w/r/t empty components.
    prevEmpty || nextEmpty || nextElement.ref !== prevElement.ref ||
    // If owner changes but we have an unchanged function ref, don't update refs
    typeof nextElement.ref === 'string' && nextElement._owner !== prevElement._owner
  );
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || element === false) {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactServerRenderingTransaction
 */



var _assign = __webpack_require__(22);

var PooledClass = __webpack_require__(78);
var Transaction = __webpack_require__(153);
var ReactInstrumentation = __webpack_require__(52);
var ReactServerUpdateQueue = __webpack_require__(744);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactServerUpdateQueue
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(264);
var Transaction = __webpack_require__(153);
var warning = __webpack_require__(21);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  /* :: transaction: Transaction; */

  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ReactTransitionEvents
 */



var ExecutionEnvironment = __webpack_require__(31);

var getVendorPrefixedEventName = __webpack_require__(414);

var endEvents = [];

function detectEvents() {
  var animEnd = getVendorPrefixedEventName('animationend');
  var transEnd = getVendorPrefixedEventName('transitionend');

  if (animEnd) {
    endEvents.push(animEnd);
  }

  if (transEnd) {
    endEvents.push(transEnd);
  }
}

if (ExecutionEnvironment.canUseDOM) {
  detectEvents();
}

// We use the raw {add|remove}EventListener() call because EventListener
// does not know how to remove event listeners and we really should
// clean up. Also, these events are not triggered in older browsers
// so we should be A-OK here.

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var ReactTransitionEvents = {
  addEndEventListener: function (node, eventListener) {
    if (endEvents.length === 0) {
      // If CSS transitions are not supported, trigger an "end animation"
      // event immediately.
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },

  removeEndEventListener: function (node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

module.exports = ReactTransitionEvents;

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SVGDOMPropertyConfig
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SelectEventPlugin
 */



var EventConstants = __webpack_require__(67);
var EventPropagators = __webpack_require__(150);
var ExecutionEnvironment = __webpack_require__(31);
var ReactDOMComponentTree = __webpack_require__(39);
var ReactInputSelection = __webpack_require__(401);
var SyntheticEvent = __webpack_require__(68);

var getActiveElement = __webpack_require__(199);
var isTextInputElement = __webpack_require__(416);
var keyOf = __webpack_require__(85);
var shallowEqual = __webpack_require__(120);

var topLevelTypes = EventConstants.topLevelTypes;

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onSelect: null }),
      captured: keyOf({ onSelectCapture: null })
    },
    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;
var ON_SELECT_KEY = keyOf({ onSelect: null });

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case topLevelTypes.topFocus:
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case topLevelTypes.topBlur:
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;

      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case topLevelTypes.topMouseDown:
        mouseDown = true;
        break;
      case topLevelTypes.topContextMenu:
      case topLevelTypes.topMouseUp:
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);

      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case topLevelTypes.topSelectionChange:
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case topLevelTypes.topKeyDown:
      case topLevelTypes.topKeyUp:
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === ON_SELECT_KEY) {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SimpleEventPlugin
 */



var _prodInvariant = __webpack_require__(25);

var EventConstants = __webpack_require__(67);
var EventListener = __webpack_require__(197);
var EventPropagators = __webpack_require__(150);
var ReactDOMComponentTree = __webpack_require__(39);
var SyntheticAnimationEvent = __webpack_require__(749);
var SyntheticClipboardEvent = __webpack_require__(750);
var SyntheticEvent = __webpack_require__(68);
var SyntheticFocusEvent = __webpack_require__(753);
var SyntheticKeyboardEvent = __webpack_require__(755);
var SyntheticMouseEvent = __webpack_require__(183);
var SyntheticDragEvent = __webpack_require__(752);
var SyntheticTouchEvent = __webpack_require__(756);
var SyntheticTransitionEvent = __webpack_require__(757);
var SyntheticUIEvent = __webpack_require__(152);
var SyntheticWheelEvent = __webpack_require__(758);

var emptyFunction = __webpack_require__(37);
var getEventCharCode = __webpack_require__(266);
var invariant = __webpack_require__(17);
var keyOf = __webpack_require__(85);

var topLevelTypes = EventConstants.topLevelTypes;

var eventTypes = {
  abort: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onAbort: true }),
      captured: keyOf({ onAbortCapture: true })
    }
  },
  animationEnd: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onAnimationEnd: true }),
      captured: keyOf({ onAnimationEndCapture: true })
    }
  },
  animationIteration: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onAnimationIteration: true }),
      captured: keyOf({ onAnimationIterationCapture: true })
    }
  },
  animationStart: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onAnimationStart: true }),
      captured: keyOf({ onAnimationStartCapture: true })
    }
  },
  blur: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onBlur: true }),
      captured: keyOf({ onBlurCapture: true })
    }
  },
  canPlay: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCanPlay: true }),
      captured: keyOf({ onCanPlayCapture: true })
    }
  },
  canPlayThrough: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCanPlayThrough: true }),
      captured: keyOf({ onCanPlayThroughCapture: true })
    }
  },
  click: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onClick: true }),
      captured: keyOf({ onClickCapture: true })
    }
  },
  contextMenu: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onContextMenu: true }),
      captured: keyOf({ onContextMenuCapture: true })
    }
  },
  copy: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCopy: true }),
      captured: keyOf({ onCopyCapture: true })
    }
  },
  cut: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onCut: true }),
      captured: keyOf({ onCutCapture: true })
    }
  },
  doubleClick: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDoubleClick: true }),
      captured: keyOf({ onDoubleClickCapture: true })
    }
  },
  drag: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDrag: true }),
      captured: keyOf({ onDragCapture: true })
    }
  },
  dragEnd: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragEnd: true }),
      captured: keyOf({ onDragEndCapture: true })
    }
  },
  dragEnter: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragEnter: true }),
      captured: keyOf({ onDragEnterCapture: true })
    }
  },
  dragExit: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragExit: true }),
      captured: keyOf({ onDragExitCapture: true })
    }
  },
  dragLeave: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragLeave: true }),
      captured: keyOf({ onDragLeaveCapture: true })
    }
  },
  dragOver: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragOver: true }),
      captured: keyOf({ onDragOverCapture: true })
    }
  },
  dragStart: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDragStart: true }),
      captured: keyOf({ onDragStartCapture: true })
    }
  },
  drop: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDrop: true }),
      captured: keyOf({ onDropCapture: true })
    }
  },
  durationChange: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onDurationChange: true }),
      captured: keyOf({ onDurationChangeCapture: true })
    }
  },
  emptied: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onEmptied: true }),
      captured: keyOf({ onEmptiedCapture: true })
    }
  },
  encrypted: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onEncrypted: true }),
      captured: keyOf({ onEncryptedCapture: true })
    }
  },
  ended: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onEnded: true }),
      captured: keyOf({ onEndedCapture: true })
    }
  },
  error: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onError: true }),
      captured: keyOf({ onErrorCapture: true })
    }
  },
  focus: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onFocus: true }),
      captured: keyOf({ onFocusCapture: true })
    }
  },
  input: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onInput: true }),
      captured: keyOf({ onInputCapture: true })
    }
  },
  invalid: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onInvalid: true }),
      captured: keyOf({ onInvalidCapture: true })
    }
  },
  keyDown: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onKeyDown: true }),
      captured: keyOf({ onKeyDownCapture: true })
    }
  },
  keyPress: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onKeyPress: true }),
      captured: keyOf({ onKeyPressCapture: true })
    }
  },
  keyUp: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onKeyUp: true }),
      captured: keyOf({ onKeyUpCapture: true })
    }
  },
  load: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onLoad: true }),
      captured: keyOf({ onLoadCapture: true })
    }
  },
  loadedData: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onLoadedData: true }),
      captured: keyOf({ onLoadedDataCapture: true })
    }
  },
  loadedMetadata: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onLoadedMetadata: true }),
      captured: keyOf({ onLoadedMetadataCapture: true })
    }
  },
  loadStart: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onLoadStart: true }),
      captured: keyOf({ onLoadStartCapture: true })
    }
  },
  // Note: We do not allow listening to mouseOver events. Instead, use the
  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
  mouseDown: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onMouseDown: true }),
      captured: keyOf({ onMouseDownCapture: true })
    }
  },
  mouseMove: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onMouseMove: true }),
      captured: keyOf({ onMouseMoveCapture: true })
    }
  },
  mouseOut: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onMouseOut: true }),
      captured: keyOf({ onMouseOutCapture: true })
    }
  },
  mouseOver: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onMouseOver: true }),
      captured: keyOf({ onMouseOverCapture: true })
    }
  },
  mouseUp: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onMouseUp: true }),
      captured: keyOf({ onMouseUpCapture: true })
    }
  },
  paste: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onPaste: true }),
      captured: keyOf({ onPasteCapture: true })
    }
  },
  pause: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onPause: true }),
      captured: keyOf({ onPauseCapture: true })
    }
  },
  play: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onPlay: true }),
      captured: keyOf({ onPlayCapture: true })
    }
  },
  playing: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onPlaying: true }),
      captured: keyOf({ onPlayingCapture: true })
    }
  },
  progress: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onProgress: true }),
      captured: keyOf({ onProgressCapture: true })
    }
  },
  rateChange: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onRateChange: true }),
      captured: keyOf({ onRateChangeCapture: true })
    }
  },
  reset: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onReset: true }),
      captured: keyOf({ onResetCapture: true })
    }
  },
  scroll: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onScroll: true }),
      captured: keyOf({ onScrollCapture: true })
    }
  },
  seeked: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onSeeked: true }),
      captured: keyOf({ onSeekedCapture: true })
    }
  },
  seeking: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onSeeking: true }),
      captured: keyOf({ onSeekingCapture: true })
    }
  },
  stalled: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onStalled: true }),
      captured: keyOf({ onStalledCapture: true })
    }
  },
  submit: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onSubmit: true }),
      captured: keyOf({ onSubmitCapture: true })
    }
  },
  suspend: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onSuspend: true }),
      captured: keyOf({ onSuspendCapture: true })
    }
  },
  timeUpdate: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onTimeUpdate: true }),
      captured: keyOf({ onTimeUpdateCapture: true })
    }
  },
  touchCancel: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onTouchCancel: true }),
      captured: keyOf({ onTouchCancelCapture: true })
    }
  },
  touchEnd: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onTouchEnd: true }),
      captured: keyOf({ onTouchEndCapture: true })
    }
  },
  touchMove: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onTouchMove: true }),
      captured: keyOf({ onTouchMoveCapture: true })
    }
  },
  touchStart: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onTouchStart: true }),
      captured: keyOf({ onTouchStartCapture: true })
    }
  },
  transitionEnd: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onTransitionEnd: true }),
      captured: keyOf({ onTransitionEndCapture: true })
    }
  },
  volumeChange: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onVolumeChange: true }),
      captured: keyOf({ onVolumeChangeCapture: true })
    }
  },
  waiting: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onWaiting: true }),
      captured: keyOf({ onWaitingCapture: true })
    }
  },
  wheel: {
    phasedRegistrationNames: {
      bubbled: keyOf({ onWheel: true }),
      captured: keyOf({ onWheelCapture: true })
    }
  }
};

var topLevelEventsToDispatchConfig = {
  topAbort: eventTypes.abort,
  topAnimationEnd: eventTypes.animationEnd,
  topAnimationIteration: eventTypes.animationIteration,
  topAnimationStart: eventTypes.animationStart,
  topBlur: eventTypes.blur,
  topCanPlay: eventTypes.canPlay,
  topCanPlayThrough: eventTypes.canPlayThrough,
  topClick: eventTypes.click,
  topContextMenu: eventTypes.contextMenu,
  topCopy: eventTypes.copy,
  topCut: eventTypes.cut,
  topDoubleClick: eventTypes.doubleClick,
  topDrag: eventTypes.drag,
  topDragEnd: eventTypes.dragEnd,
  topDragEnter: eventTypes.dragEnter,
  topDragExit: eventTypes.dragExit,
  topDragLeave: eventTypes.dragLeave,
  topDragOver: eventTypes.dragOver,
  topDragStart: eventTypes.dragStart,
  topDrop: eventTypes.drop,
  topDurationChange: eventTypes.durationChange,
  topEmptied: eventTypes.emptied,
  topEncrypted: eventTypes.encrypted,
  topEnded: eventTypes.ended,
  topError: eventTypes.error,
  topFocus: eventTypes.focus,
  topInput: eventTypes.input,
  topInvalid: eventTypes.invalid,
  topKeyDown: eventTypes.keyDown,
  topKeyPress: eventTypes.keyPress,
  topKeyUp: eventTypes.keyUp,
  topLoad: eventTypes.load,
  topLoadedData: eventTypes.loadedData,
  topLoadedMetadata: eventTypes.loadedMetadata,
  topLoadStart: eventTypes.loadStart,
  topMouseDown: eventTypes.mouseDown,
  topMouseMove: eventTypes.mouseMove,
  topMouseOut: eventTypes.mouseOut,
  topMouseOver: eventTypes.mouseOver,
  topMouseUp: eventTypes.mouseUp,
  topPaste: eventTypes.paste,
  topPause: eventTypes.pause,
  topPlay: eventTypes.play,
  topPlaying: eventTypes.playing,
  topProgress: eventTypes.progress,
  topRateChange: eventTypes.rateChange,
  topReset: eventTypes.reset,
  topScroll: eventTypes.scroll,
  topSeeked: eventTypes.seeked,
  topSeeking: eventTypes.seeking,
  topStalled: eventTypes.stalled,
  topSubmit: eventTypes.submit,
  topSuspend: eventTypes.suspend,
  topTimeUpdate: eventTypes.timeUpdate,
  topTouchCancel: eventTypes.touchCancel,
  topTouchEnd: eventTypes.touchEnd,
  topTouchMove: eventTypes.touchMove,
  topTouchStart: eventTypes.touchStart,
  topTransitionEnd: eventTypes.transitionEnd,
  topVolumeChange: eventTypes.volumeChange,
  topWaiting: eventTypes.waiting,
  topWheel: eventTypes.wheel
};

for (var type in topLevelEventsToDispatchConfig) {
  topLevelEventsToDispatchConfig[type].dependencies = [type];
}

var ON_CLICK_KEY = keyOf({ onClick: null });
var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

var SimpleEventPlugin = {

  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case topLevelTypes.topAbort:
      case topLevelTypes.topCanPlay:
      case topLevelTypes.topCanPlayThrough:
      case topLevelTypes.topDurationChange:
      case topLevelTypes.topEmptied:
      case topLevelTypes.topEncrypted:
      case topLevelTypes.topEnded:
      case topLevelTypes.topError:
      case topLevelTypes.topInput:
      case topLevelTypes.topInvalid:
      case topLevelTypes.topLoad:
      case topLevelTypes.topLoadedData:
      case topLevelTypes.topLoadedMetadata:
      case topLevelTypes.topLoadStart:
      case topLevelTypes.topPause:
      case topLevelTypes.topPlay:
      case topLevelTypes.topPlaying:
      case topLevelTypes.topProgress:
      case topLevelTypes.topRateChange:
      case topLevelTypes.topReset:
      case topLevelTypes.topSeeked:
      case topLevelTypes.topSeeking:
      case topLevelTypes.topStalled:
      case topLevelTypes.topSubmit:
      case topLevelTypes.topSuspend:
      case topLevelTypes.topTimeUpdate:
      case topLevelTypes.topVolumeChange:
      case topLevelTypes.topWaiting:
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case topLevelTypes.topKeyPress:
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case topLevelTypes.topKeyDown:
      case topLevelTypes.topKeyUp:
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case topLevelTypes.topBlur:
      case topLevelTypes.topFocus:
        EventConstructor = SyntheticFocusEvent;
        break;
      case topLevelTypes.topClick:
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case topLevelTypes.topContextMenu:
      case topLevelTypes.topDoubleClick:
      case topLevelTypes.topMouseDown:
      case topLevelTypes.topMouseMove:
      case topLevelTypes.topMouseOut:
      case topLevelTypes.topMouseOver:
      case topLevelTypes.topMouseUp:
        EventConstructor = SyntheticMouseEvent;
        break;
      case topLevelTypes.topDrag:
      case topLevelTypes.topDragEnd:
      case topLevelTypes.topDragEnter:
      case topLevelTypes.topDragExit:
      case topLevelTypes.topDragLeave:
      case topLevelTypes.topDragOver:
      case topLevelTypes.topDragStart:
      case topLevelTypes.topDrop:
        EventConstructor = SyntheticDragEvent;
        break;
      case topLevelTypes.topTouchCancel:
      case topLevelTypes.topTouchEnd:
      case topLevelTypes.topTouchMove:
      case topLevelTypes.topTouchStart:
        EventConstructor = SyntheticTouchEvent;
        break;
      case topLevelTypes.topAnimationEnd:
      case topLevelTypes.topAnimationIteration:
      case topLevelTypes.topAnimationStart:
        EventConstructor = SyntheticAnimationEvent;
        break;
      case topLevelTypes.topTransitionEnd:
        EventConstructor = SyntheticTransitionEvent;
        break;
      case topLevelTypes.topScroll:
        EventConstructor = SyntheticUIEvent;
        break;
      case topLevelTypes.topWheel:
        EventConstructor = SyntheticWheelEvent;
        break;
      case topLevelTypes.topCopy:
      case topLevelTypes.topCut:
      case topLevelTypes.topPaste:
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    if (registrationName === ON_CLICK_KEY) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === ON_CLICK_KEY) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }

};

module.exports = SimpleEventPlugin;

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticAnimationEvent
 */



var SyntheticEvent = __webpack_require__(68);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticClipboardEvent
 */



var SyntheticEvent = __webpack_require__(68);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticCompositionEvent
 */



var SyntheticEvent = __webpack_require__(68);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticDragEvent
 */



var SyntheticMouseEvent = __webpack_require__(183);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticFocusEvent
 */



var SyntheticUIEvent = __webpack_require__(152);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticInputEvent
 */



var SyntheticEvent = __webpack_require__(68);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticKeyboardEvent
 */



var SyntheticUIEvent = __webpack_require__(152);

var getEventCharCode = __webpack_require__(266);
var getEventKey = __webpack_require__(764);
var getEventModifierState = __webpack_require__(267);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticTouchEvent
 */



var SyntheticUIEvent = __webpack_require__(152);

var getEventModifierState = __webpack_require__(267);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticTransitionEvent
 */



var SyntheticEvent = __webpack_require__(68);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule SyntheticWheelEvent
 */



var SyntheticMouseEvent = __webpack_require__(183);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX :
    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY :
    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY :
    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule adler32
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule checkReactTypeSpec
 */



var _prodInvariant = __webpack_require__(25);

var ReactPropTypeLocationNames = __webpack_require__(261);
var ReactPropTypesSecret = __webpack_require__(263);

var invariant = __webpack_require__(17);
var warning = __webpack_require__(21);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":""}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(258);
}

var loggedTypeFailures = {};

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?object} element The React element that is being type-checked
 * @param {?number} debugID The React component instance that is being type-checked
 * @private
 */
function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
  for (var typeSpecName in typeSpecs) {
    if (typeSpecs.hasOwnProperty(typeSpecName)) {
      var error;
      // Prop type validation may throw. In case they do, we don't want to
      // fail the render phase where it didn't fail before. So we log it.
      // After these have been cleaned up, we'll let them throw.
      try {
        // This is intentionally an invariant that gets caught. It's the same
        // behavior as without this statement except with a better message.
        !(typeof typeSpecs[typeSpecName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
      } catch (ex) {
        error = ex;
      }
       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var componentStackInfo = '';

        if (false) {
          if (!ReactComponentTreeHook) {
            ReactComponentTreeHook = require('./ReactComponentTreeHook');
          }
          if (debugID !== null) {
            componentStackInfo = ReactComponentTreeHook.getStackAddendumByID(debugID);
          } else if (element !== null) {
            componentStackInfo = ReactComponentTreeHook.getCurrentStackAddendum(element);
          }
        }

         false ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
      }
    }
  }
}

module.exports = checkReactTypeSpec;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(102)))

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule dangerousStyleValue
 */



var CSSProperty = __webpack_require__(391);
var warning = __webpack_require__(21);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule findDOMNode
 */



var _prodInvariant = __webpack_require__(25);

var ReactCurrentOwner = __webpack_require__(79);
var ReactDOMComponentTree = __webpack_require__(39);
var ReactInstanceMap = __webpack_require__(151);

var getHostComponentFromComposite = __webpack_require__(411);
var invariant = __webpack_require__(17);
var warning = __webpack_require__(21);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule flattenChildren
 * 
 */



var KeyEscapeUtils = __webpack_require__(254);
var traverseAllChildren = __webpack_require__(271);
var warning = __webpack_require__(21);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":""}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(258);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('./ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(102)))

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getEventKey
 */



var getEventCharCode = __webpack_require__(266);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  'Esc': 'Escape',
  'Spacebar': ' ',
  'Left': 'ArrowLeft',
  'Up': 'ArrowUp',
  'Right': 'ArrowRight',
  'Down': 'ArrowDown',
  'Del': 'Delete',
  'Win': 'OS',
  'Menu': 'ContextMenu',
  'Apps': 'ContextMenu',
  'Scroll': 'ScrollLock',
  'MozPrintableKey': 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule getNodeForCharacterOffset
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule onlyChild
 */


var _prodInvariant = __webpack_require__(25);

var ReactElement = __webpack_require__(58);

var invariant = __webpack_require__(17);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule quoteAttributeValueForBrowser
 */



var escapeTextContentForBrowser = __webpack_require__(184);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
* @providesModule renderSubtreeIntoContainer
*/



var ReactMount = __webpack_require__(402);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 770 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Users_Login__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_Users_RecuperarSenha__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_Users_Suspenso__ = __webpack_require__(437);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// Importação do Router


// Layout






var App = function (_Component) {
  _inherits(App, _Component);

  // constructor
  function App(props, context) {
    _classCallCheck(this, App);

    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props, context));

    _this.state = {
      permission: false,
      deferredPrompt: null
    };
    _this.promptInstall = _this.promptInstall.bind(_this);

    return _this;
  }

  _createClass(App, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('beforeinstallprompt', function (e) {
        // Prevent the mini-infobar from appearing on mobile
        e.preventDefault();
        // Stash the event so it can be triggered later.
        _this2.setState({ deferredPrompt: e });
      });

      var url_login = __WEBPACK_IMPORTED_MODULE_2_react_global_configuration___default.a.get('url') + '/usuario/login';
      var url_suspended = __WEBPACK_IMPORTED_MODULE_2_react_global_configuration___default.a.get('url') + '/usuario/suspenso';
      var url_recovery_pw = __WEBPACK_IMPORTED_MODULE_2_react_global_configuration___default.a.get('url') + '/usuario/recuperar_senha';
      var url_flight_report_index = 'relatorios/voo';
      var url_flight_report_edit = 'relatorio/voo/editar';
      var url_staff_deslocation_edit = 'tripulante/deslocamento/editar';
      var url_actual = window.location.href;

      if (!navigator.onLine && !url_actual.includes(url_flight_report_index) && !url_actual.includes(url_flight_report_edit)) {
        window.location.replace(__WEBPACK_IMPORTED_MODULE_2_react_global_configuration___default.a.get('url') + '/relatorios/voo');
      }

      if (url_actual !== url_login && url_actual !== url_suspended && url_actual !== url_recovery_pw && !url_actual.includes(url_staff_deslocation_edit)) {
        // busco as infos
        var params = JSON.parse(localStorage.getItem("cid"));
        // Verifico se há algum storage setado
        if (params === null || typeof params === 'undefined') {
          window.location.replace(__WEBPACK_IMPORTED_MODULE_2_react_global_configuration___default.a.get('url') + '/usuario/login');
        } else {
          // Verifico se o cid acode setado
          if (params.acode === null || typeof params.acode === 'undefined') {
            window.location.replace(__WEBPACK_IMPORTED_MODULE_2_react_global_configuration___default.a.get('url') + '/usuario/login');
          } else {
            this.setState({ permission: true });
          }
        }
      } else {
        this.setState({ permission: true });
      }
    }
  }, {
    key: 'promptInstall',
    value: function () {
      var _ref = _asyncToGenerator(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref2, outcome;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(this.state.deferredPrompt === null)) {
                  _context.next = 4;
                  break;
                }

                window.open(__WEBPACK_IMPORTED_MODULE_2_react_global_configuration___default.a.get('cdn') + '/tutorials/instrucoes-instalacao.pdf');
                _context.next = 10;
                break;

              case 4:
                // Show the install prompt
                this.state.deferredPrompt.prompt();
                // Wait for the user to respond to the prompt
                _context.next = 7;
                return this.state.deferredPrompt.userChoice;

              case 7:
                _ref2 = _context.sent;
                outcome = _ref2.outcome;

                // We've used the prompt, and can't use it again, throw it away
                this.setState({ deferredPrompt: null });

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function promptInstall() {
        return _ref.apply(this, arguments);
      }

      return promptInstall;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        this.state.permission === false ? '' : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* BrowserRouter */],
            null,
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Switch */],
              null,
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/usuario/login', render: function render(props) {
                  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Users_Login__["a" /* default */], Object.assign({}, props, { promptInstall: _this3.promptInstall }));
                } }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/usuario/recuperar_senha', render: function render(props) {
                  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_Users_RecuperarSenha__["a" /* default */], Object.assign({}, props, { promptInstall: _this3.promptInstall }));
                } }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/usuario/suspenso', render: function render(props) {
                  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_Users_Suspenso__["a" /* default */], Object.assign({}, props, { promptInstall: _this3.promptInstall }));
                } }),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Route */], { promptInstall: this.promptInstall, path: '/', render: function render(props) {
                  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Layout_Topo__["a" /* default */], Object.assign({}, props, { promptInstall: _this3.promptInstall }));
                } })
            )
          )
        )
      );
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var AircraftLogbookReportActionEdit = function (_Component) {
    _inherits(AircraftLogbookReportActionEdit, _Component);

    function AircraftLogbookReportActionEdit(props) {
        _classCallCheck(this, AircraftLogbookReportActionEdit);

        var _this = _possibleConstructorReturn(this, (AircraftLogbookReportActionEdit.__proto__ || Object.getPrototypeOf(AircraftLogbookReportActionEdit)).call(this, props));

        _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__["a" /* default */])();

        _this.state = {
            overlay: {
                message: '',
                type: '',
                status: 'open'
            },
            redirect_url: false,
            loaded: 0,
            id: '',
            type: '',
            type_field: '',
            item_number: '',
            mel: '',
            category: '',
            limit_type: '',
            limit: '',
            limit_date: '',
            limit_hour: '',
            limit_landing: '',
            description: '',
            reason: '',
            correlation_analysis: '',
            maintenance_action: '',
            postponement: '',
            release_date: '',
            correction_date: '',
            task_card: '',
            responsible_release_id: '',
            responsible_correction_id: '',
            maintenance_operational_restriction: '',
            justification: '',
            new_date: '',
            postponement_date: '',
            document: null,
            users_list: [],
            postponements: {}
        };
        //Handlers
        _this.handleAlert = _this.handleAlert.bind(_this);
        _this.handleLoaded = _this.handleLoaded.bind(_this);
        _this.handleMessage = _this.handleMessage.bind(_this);

        _this.loadData = _this.loadData.bind(_this);
        _this.edit = _this.edit.bind(_this);
        _this.addPostponement = _this.addPostponement.bind(_this);
        _this.approve = _this.approve.bind(_this);
        return _this;
    }
    // Handlers


    _createClass(AircraftLogbookReportActionEdit, [{
        key: 'handleChange',
        value: function handleChange(name, event) {
            var change = {};
            change[name] = event.target.value;
            this.setState(change);
        }
    }, {
        key: 'handleSelectChange',
        value: function handleSelectChange(name, event) {
            var change = {};
            if (event == null) {
                change[name] = null;
            } else {
                change[name] = event.value;
            }
            this.setState(change);
        }
    }, {
        key: 'handleMultiSelectChange',
        value: function handleMultiSelectChange(name, event) {
            var change = {};
            if (event == null) {
                change[name] = null;
            } else {
                change[name] = event;
            }
            this.setState(change);
        }
    }, {
        key: 'handleToggleChange',
        value: function handleToggleChange(name, event) {
            var change = {};
            if (event.target.checked === true) {
                var value = 1;
            } else {
                var value = 0;
            }
            change[name] = value;
            this.setState(change);
        }
    }, {
        key: 'handleAlert',
        value: function handleAlert(message, type, status, mode) {
            if (mode === 'reset') {
                this.setState({ overlay: { message: '', type: '', status: 'closed' } });
            } else {
                this.setState({ overlay: { message: message, type: type, status: status } });
            }
        }
    }, {
        key: 'handleLoaded',
        value: function handleLoaded(state) {
            if (this.state.loaded !== 2) {
                this.setState({ loaded: state });
            }
        }
    }, {
        key: 'handleMessage',
        value: function handleMessage() {
            var message = localStorage.getItem("verify_message");
            if (message !== null && typeof message !== 'undefined') {
                message = JSON.parse(message);
                var self = this;
                self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
                localStorage.removeItem("verify_message");
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.refs.request_api.header();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.state.loaded === 1 && prevState.loaded === 0) {
                this.setState({ loaded: 2 }, this.loadData());
            }
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            var self = this;
            var header = this.refs.request_api.header('application/json');
            Promise.resolve(header).then(function (value) {
                var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/acr/' + self.props.match.params.id;
                fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
                    return response.json();
                }).catch(function (error) {
                    console.error(error);
                }).then(function (responseJson) {
                    self.refs.request_api.validate(responseJson, 'url', '/funcoes/bordo');
                    if (responseJson.status === 'success') {
                        self.setState({
                            id: responseJson.data.main.id,
                            type: responseJson.data.main.type,
                            type_field: responseJson.data.main.type_field,
                            item_number: responseJson.data.main.item_number,
                            mel: responseJson.data.main.mel,
                            category: responseJson.data.main.category,
                            limit_type: responseJson.data.main.limit_type,
                            limit: responseJson.data.main.limit,
                            limit_date: responseJson.data.main.limit_date,
                            limit_hour: responseJson.data.main.limit_hour,
                            limit_landing: responseJson.data.main.limit_landing,
                            description: responseJson.data.main.description,
                            reason: responseJson.data.main.reason,
                            correlation_analysis: responseJson.data.main.correlation_analysis,
                            maintenance_action: responseJson.data.main.maintenance_action,
                            captain_approval_date_str: responseJson.data.main.captain_approval_date_str,
                            postponement: responseJson.data.main.postponement,
                            release_date: responseJson.data.main.release_date_str,
                            correction_date: responseJson.data.main.correction_date_str,
                            task_card: responseJson.data.main.task_card,
                            responsible_release_id: responseJson.data.main.responsible_release_id,
                            responsible_correction_id: responseJson.data.main.responsible_correction_id,
                            maintenance_operational_restriction: responseJson.data.main.maintenance_operational_restriction,
                            users_list: responseJson.data.users_list,
                            postponements: responseJson.data.postponements
                        });
                    }
                }).then(function () {
                    self.setState({ overlay: { message: '', type: '', status: 'closed' } });
                    self.handleMessage();
                });
            });
        }
    }, {
        key: 'changeInput',
        value: function changeInput(type_field) {
            this.setState({
                type_field: type_field
            });
        }
    }, {
        key: 'addPostponement',
        value: function addPostponement(event) {
            event.preventDefault();
            var data = new FormData();
            var input_document = document.querySelector(".input-document").files[0];
            data.append("document", input_document);
            data.append("date", this.state.postponement_date);
            data.append("new_date", this.state.new_date);
            data.append("justification", this.state.justification);
            data.append("aircraft_logbook_report_action_deferred_item_id", this.state.id);

            var header = this.refs.request_api.header();
            var self = this;
            this.handleAlert('', '', 'open');
            Promise.resolve(header).then(function (value) {
                fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/acr/postergacao', {
                    method: 'POST',
                    mode: 'cors',
                    headers: value,
                    body: data }).then(function (response) {
                    return response.json();
                }).catch(function (error) {
                    console.error(error);
                }).then(function (responseJson) {
                    if (responseJson.status === 'success') {
                        self.setState({ postponements: responseJson.data });
                    }
                    self.handleAlert(responseJson.message, responseJson.status, 'open');
                }).catch(function (error) {
                    console.error(error);
                });
            });
        }
    }, {
        key: 'edit',
        value: function edit(event) {
            event.preventDefault();
            this.handleAlert('', '', 'open');
            var datasave = {
                id: this.state.id,
                postponement: this.state.postponement,
                task_card: this.state.task_card,
                responsible_release_id: this.state.responsible_release_id,
                responsible_correction_id: this.state.responsible_correction_id,
                release_date: this.state.release_date,
                correction_date: this.state.correction_date
            };
            var header = this.refs.request_api.header('application/json');
            var self = this;
            Promise.resolve(header).then(function (value) {
                fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/item/acao/adiada', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
                    return response.json();
                }).catch(function (error) {
                    console.error(error);
                }).then(function (responseJson) {
                    self.refs.request_api.validate(responseJson, 'alert');
                    self.handleAlert(responseJson.message, responseJson.status, 'open');
                }).catch(function (error) {
                    console.error(error);
                });
            });
        }
    }, {
        key: 'approve',
        value: function approve(id) {
            var confirm = "Tem certeza que deseja aprovar a postergação?";
            if (window.confirm(confirm)) {
                var datasave = {
                    id: id
                };
                this.handleAlert('', '', 'open');
                var header = this.refs.request_api.header('application/json');
                var self = this;
                var url = '/aeronave/diario/postergacao/aprovar';
                Promise.resolve(header).then(function (value) {
                    fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
                        return response.json();
                    }).catch(function (error) {
                        console.error(error);
                    }).then(function (responseJson) {
                        if (responseJson.status === 'success') {
                            self.setState({ postponements: responseJson.data });
                        }
                        self.handleAlert(responseJson.message, responseJson.status, 'open');
                    }).catch(function (error) {
                        console.error(error);
                    });
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var self = this;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'container-fluid' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'conteudo' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'h3',
                            { className: 'page-title pull-left' },
                            'Edi\xE7\xE3o de ACR'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'grid-buttons pull-right' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
                                { to: '/aeronave/diario/acrs/abertos', className: 'btn btn-default pull-right' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-left' }),
                                ' ',
                                this.locale.general.voltar
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'form',
                            { onSubmit: this.edit },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'row' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            'Type'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                                            className: 'form-group',
                                            name: 'type',
                                            value: this.state.type,
                                            searchable: true,
                                            placeholder: 'Selecionar',
                                            onChange: this.handleSelectChange.bind(this, 'type'),
                                            options: [{ value: 0, label: "MEL" }, { value: 1, label: "NEF" }],
                                            disabled: true
                                        })
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            'N\xB0 Item'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', value: this.state.item_number, name: 'item_number', onChange: this.handleChange.bind(this, 'item_number'), placeholder: 'N\xB0 Item', disabled: true })
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'row' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            'Categoria'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                                            className: 'form-group',
                                            name: 'category',
                                            value: this.state.category,
                                            searchable: true,
                                            placeholder: 'Selecionar',
                                            onChange: this.handleSelectChange.bind(this, 'category'),
                                            options: [{ value: "a", label: "A" }, { value: "b", label: "B" }, { value: "c", label: "C" }, { value: "d", label: "D" }],
                                            disabled: true
                                        })
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            'Tipos de limite'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                                            className: 'form-group',
                                            name: 'limit_type',
                                            value: this.state.limit_type,
                                            searchable: true,
                                            placeholder: 'Selecionar',
                                            onChange: this.handleSelectChange.bind(this, 'limit_type'),
                                            options: [{ value: 0, label: "Sem limitação" }, { value: 1, label: "Data" }, { value: 2, label: "Horas de voo" }, { value: 3, label: "Pousos" }, { value: 4, label: "Específico" }],
                                            disabled: true
                                        })
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'row' },
                                this.state.type == 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            'MEL'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', value: this.state.mel, name: 'mel', onChange: this.handleChange.bind(this, 'mel'), placeholder: 'MEL', disabled: true })
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            'Limite'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', value: this.state.limit, name: 'limit', onChange: this.handleChange.bind(this, 'limit'), placeholder: 'Limite', disabled: true })
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'row' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            'Descri\xE7\xE3o'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', value: this.state.description, name: 'description', onChange: this.handleChange.bind(this, 'description'), placeholder: 'Descri\xE7\xE3o', disabled: true })
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            'Motivo'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', value: this.state.reason, name: 'reason', onChange: this.handleChange.bind(this, 'reason'), placeholder: 'Motivo', disabled: true })
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'row' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            'An\xE1lise de correla\xE7\xE3o'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                                            className: 'form-group',
                                            name: 'correlation_analysis',
                                            value: this.state.correlation_analysis,
                                            searchable: true,
                                            placeholder: 'Selecionar',
                                            onChange: this.handleSelectChange.bind(this, 'correlation_analysis'),
                                            options: [{ value: 0, label: "N/A" }, { value: 1, label: "Satisfatório" }],
                                            disabled: true
                                        })
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            'Restri\xE7\xF5es Operacionais'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'maintenance_operational_restriction', className: 'form-control', placeholder: '', value: this.state.maintenance_operational_restriction, onChange: this.handleChange.bind(this, 'maintenance_operational_restriction'), disabled: true })
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'row' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            'A\xE7\xE3o de manuten\xE7\xE3o'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', value: this.state.maintenance_action, name: 'maintenance_action', onChange: this.handleChange.bind(this, 'maintenance_action'), placeholder: 'A\xE7\xE3o de manuten\xE7\xE3o', disabled: true })
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            'Aprova\xE7\xE3o comandante'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', value: this.state.captain_approval_date_str, name: 'captain_approval_date_str', onChange: this.handleChange.bind(this, 'captain_approval_date_str'), placeholder: '', disabled: true })
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'row' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            'Posterga\xE7\xE3o'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                                            className: 'form-group',
                                            name: 'postponement',
                                            value: this.state.postponement,
                                            searchable: true,
                                            placeholder: 'Selecionar',
                                            onChange: this.handleSelectChange.bind(this, 'postponement'),
                                            options: [{ value: 0, label: "Não" }, { value: 1, label: "Sim" }],
                                            required: this.state.category !== 'b' && this.state.category !== 'c' ? false : true,
                                            disabled: this.state.category !== 'b' && this.state.category !== 'c' ? true : false
                                        })
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            'Task Card'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', value: this.state.task_card, name: 'task_card', onChange: this.handleChange.bind(this, 'task_card'), placeholder: 'Task Card' })
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'row' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            'Respons\xE1vel pela libera\xE7\xE3o'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                                            className: 'form-group',
                                            name: 'responsible_release_id',
                                            value: this.state.responsible_release_id,
                                            searchable: true,
                                            placeholder: 'Selecionar',
                                            onChange: this.handleSelectChange.bind(this, 'responsible_release_id'),
                                            options: this.state.users_list
                                        })
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            'Data de libera\xE7\xE3o'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.release_date, name: 'release_date', mask: '99/99/9999 99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'release_date'), placeholder: 'dd/mm/yyyy hh:mm' })
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'row' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            'Respons\xE1vel pela corre\xE7\xE3o'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                                            className: 'form-group',
                                            name: 'responsible_correction_id',
                                            value: this.state.responsible_correction_id,
                                            searchable: true,
                                            placeholder: 'Selecionar',
                                            onChange: this.handleSelectChange.bind(this, 'responsible_correction_id'),
                                            options: this.state.users_list
                                        })
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            'Data de corre\xE7\xE3o'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.correction_date, name: 'correction_date', mask: '99/99/9999 99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'correction_date'), placeholder: 'dd/mm/yyyy hh:mm' })
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'row' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-12' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'button',
                                            { type: 'submit', className: 'btn btn-block btn-primary' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                                            ' Salvar'
                                        )
                                    )
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                        this.state.category == 'b' || this.state.category == 'c' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'h3',
                                null,
                                'Posterga\xE7\xE3o'
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'form',
                                { onSubmit: this.addPostponement },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'row' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-md-6' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'form-group' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'label',
                                                null,
                                                'Data:'
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.postponement_date, name: 'postponement_date', mask: '99/99/9999 99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'postponement_date'), placeholder: 'dd/mm/yyyy hh:mm', required: true })
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-md-6' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'form-group' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'label',
                                                null,
                                                'Novo prazo:'
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.new_date, name: 'new_date', mask: '99/99/9999 99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'new_date'), placeholder: 'dd/mm/yyyy hh:mm', required: true })
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'row' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-md-6' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'form-group' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'label',
                                                null,
                                                'Documento que autoriza a posterga\xE7\xE3o:'
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'file', name: 'document', className: 'form-control input-document', placeholder: 'Documento', value: this.state.document, onChange: this.handleChange.bind(this, 'document'), required: true })
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-md-6' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'form-group' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'label',
                                                null,
                                                'Justificativa:'
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', { style: { height: 100 }, type: 'text', name: 'justification', className: 'form-control', value: this.state.justification, onChange: this.handleChange.bind(this, 'justification'), required: true })
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'button',
                                        { type: 'submit', className: 'btn btn-primary btn-block' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                                        ' Salvar posterga\xE7\xE3o'
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'table-responsive' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'table',
                                    { className: 'table table-bordered table-hover table-striped' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'thead',
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'tr',
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'th',
                                                { className: 'text-center vcenter' },
                                                'Data'
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'th',
                                                { className: 'text-center vcenter' },
                                                'Justificativa'
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'th',
                                                { className: 'text-center vcenter' },
                                                'Novo prazo'
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'th',
                                                { className: 'text-center vcenter' },
                                                'Data da aprova\xE7\xE3o'
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'th',
                                                { className: 'text-center vcenter' },
                                                'Aprova\xE7\xE3o do respons\xE1vel pela posterga\xE7\xE3o'
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'th',
                                                { className: 'text-center vcenter' },
                                                'A\xE7\xF5es'
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'tbody',
                                        null,
                                        Object.keys(self.state.postponements).map(function (k) {
                                            var postponement = self.state.postponements[k];
                                            var responsible_name = '';
                                            if (postponement.responsible_id) {
                                                responsible_name = postponement.responsible.name;
                                            }
                                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'tr',
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'td',
                                                    { className: 'text-center vcenter' },
                                                    postponement.date_str
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'td',
                                                    { className: 'text-center vcenter' },
                                                    postponement.justification
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'td',
                                                    { className: 'text-center vcenter' },
                                                    postponement.new_date_str
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'td',
                                                    { className: 'text-center vcenter' },
                                                    postponement.approval_date_str
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'td',
                                                    { className: 'text-center vcenter' },
                                                    responsible_name
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'td',
                                                    { className: 'text-center vcenter' },
                                                    postponement.responsible_id ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        'div',
                                                        { className: 'btn-group text-center' },
                                                        typeof postponement.document != 'undefined' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            'a',
                                                            { className: "btn btn-sm btn-warning button-inline", target: '_blank', href: __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/files/deferred_item_postponements/' + postponement.document },
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-download' })
                                                        ),
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            'button',
                                                            { className: 'btn btn-success btn-sm button-inline', disabled: true },
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' })
                                                        )
                                                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                        'div',
                                                        { className: 'btn-group text-center' },
                                                        typeof postponement.document != 'undefined' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            'a',
                                                            { className: "btn btn-sm btn-warning button-inline", target: '_blank', href: __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/files/deferred_item_postponements/' + postponement.document },
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-download' })
                                                        ),
                                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                            'button',
                                                            { onClick: function onClick() {
                                                                    return self.approve(postponement.id);
                                                                }, className: 'btn btn-success btn-sm button-inline' },
                                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' }),
                                                            ' Aprovar'
                                                        )
                                                    )
                                                )
                                            );
                                        })
                                    )
                                )
                            )
                        ) : '',
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
                    )
                )
            );
        }
    }]);

    return AircraftLogbookReportActionEdit;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookReportActionEdit);

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// Importação da tabela


var AircraftLogbookReportActionsIndexClosed = function (_Component) {
  _inherits(AircraftLogbookReportActionsIndexClosed, _Component);

  function AircraftLogbookReportActionsIndexClosed(props) {
    _classCallCheck(this, AircraftLogbookReportActionsIndexClosed);

    var _this = _possibleConstructorReturn(this, (AircraftLogbookReportActionsIndexClosed.__proto__ || Object.getPrototypeOf(AircraftLogbookReportActionsIndexClosed)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(AircraftLogbookReportActionsIndexClosed, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronaves/diarios/acrs/fechados', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var url = '/aeronave/diario/acr/editar/' + cell;

      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
          { className: 'btn btn-primary btn-sm', to: url },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
        )
      );

      return botao;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-fluid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              'Lista de ACRs encerrados'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: 'Exportar CSV', noDataText: 'Não há ACRs cadastrados' }, search: true, multiColumnSearch: true, searchPlaceholder: 'Procurar' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                'ID'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'aircraft_registration', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '100' },
                'Aeronave'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'aircraft_model', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '100' },
                'Frota'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'date_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '100' },
                'Data'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'item_number', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '100' },
                'N\xB0 Item'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'mel', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '100' },
                'MEL'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'category', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '100' },
                'Categoria'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'limit_type', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '100' },
                'Tipo de limite'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'limit', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '100' },
                'Limite'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'aircraft_logbook_id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '100' },
                'A\xE7\xF5es'
              )
            )
          )
        )
      );
    }
  }]);

  return AircraftLogbookReportActionsIndexClosed;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookReportActionsIndexClosed);

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// Importação da tabela


var AircraftLogbookReportActionsIndexOpened = function (_Component) {
  _inherits(AircraftLogbookReportActionsIndexOpened, _Component);

  function AircraftLogbookReportActionsIndexOpened(props) {
    _classCallCheck(this, AircraftLogbookReportActionsIndexOpened);

    var _this = _possibleConstructorReturn(this, (AircraftLogbookReportActionsIndexOpened.__proto__ || Object.getPrototypeOf(AircraftLogbookReportActionsIndexOpened)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(AircraftLogbookReportActionsIndexOpened, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronaves/diarios/acrs/abertos', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var url = '/aeronave/diario/acr/editar/' + cell;

      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
          { className: 'btn btn-primary btn-sm', to: url },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
        )
      );

      return botao;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-fluid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              'Lista de ACRs abertos'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: 'Exportar CSV', noDataText: 'Não há ACRs cadastrados' }, search: true, multiColumnSearch: true, searchPlaceholder: 'Procurar' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                'ID'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'aircraft_registration', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '100' },
                'Aeronave'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'aircraft_model', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '100' },
                'Frota'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'date_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '100' },
                'Data'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'item_number', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '100' },
                'N\xB0 Item'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'mel', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '100' },
                'MEL'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'category', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '100' },
                'Categoria'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'limit_type', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '100' },
                'Tipo de limite'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'limit', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '100' },
                'Limite'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '100' },
                'A\xE7\xF5es'
              )
            )
          )
        )
      );
    }
  }]);

  return AircraftLogbookReportActionsIndexOpened;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookReportActionsIndexOpened);

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LogbookAppIntegration_LogbookSignatureModal__ = __webpack_require__(80);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var AircraftLogbooksAdd = function (_Component) {
  _inherits(AircraftLogbooksAdd, _Component);

  // constructor
  function AircraftLogbooksAdd(props) {
    _classCallCheck(this, AircraftLogbooksAdd);

    var _this = _possibleConstructorReturn(this, (AircraftLogbooksAdd.__proto__ || Object.getPrototypeOf(AircraftLogbooksAdd)).call(this, props));

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__["a" /* default */])();

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      aircraft_id: null,
      date: null,
      aircrafts_list: [],
      logbook_app: 0,
      email: '',
      password: '',
      showLogbookSignatureModal: false,
      preValidationStatus: null,
      preValidationMessage: '',
      preValidationItems: [],
      preValidationLoading: false
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.add = _this.add.bind(_this);
    _this.logbookIntegration = _this.logbookIntegration.bind(_this);
    _this.handleLogbookSignatureSubmit = _this.handleLogbookSignatureSubmit.bind(_this);
    _this.runPreValidation = _this.runPreValidation.bind(_this);
    return _this;
  }
  // Handlers


  _createClass(AircraftLogbooksAdd, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var _this2 = this;

      var change = {};
      change[name] = event.target.value;
      this.setState(change, function () {
        if (name === 'date') {
          _this2.runPreValidation();
        }
      });
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectAircraftChange',
    value: function handleSelectAircraftChange(name, event) {
      var _this3 = this;

      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change, function () {
        _this3.runPreValidation();
      });

      if (event == null) {
        return;
      }

      // Captura os dados da aeronave selecionada para verificar se tem integração com o Logbook App
      var aircraft_id = event.value;
      var self = this;
      var header = this.refs.request_api.header('application/json');
      var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/' + aircraft_id;
      Promise.resolve(header).then(function (value) {
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ logbook_app: responseJson.data.main.use_logbook_external });
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.runPreValidation();
        });
      });
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronaves/lista';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ aircrafts_list: responseJson.data });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
        });
      });
    }
  }, {
    key: 'runPreValidation',
    value: function runPreValidation() {
      var aircraft_id = this.state.aircraft_id;
      var date = this.state.date;

      if (!aircraft_id || !date || date.length !== 10) {
        this.setState({
          preValidationStatus: null,
          preValidationMessage: '',
          preValidationItems: [],
          preValidationLoading: false
        });
        return;
      }

      this.setState({ preValidationLoading: true });
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/validar', {
          method: 'POST',
          mode: 'cors',
          headers: value,
          body: JSON.stringify({
            aircraft_id: aircraft_id,
            date: date
          })
        }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
          return { status: 'error', message: 'Não foi possível validar a abertura do diário.', data: { pendencias: [] } };
        }).then(function (responseJson) {
          var pendencias = responseJson && responseJson.data && responseJson.data.pendencias ? responseJson.data.pendencias : [];
          self.setState({
            preValidationStatus: responseJson.status || 'error',
            preValidationMessage: responseJson.message || '',
            preValidationItems: pendencias,
            preValidationLoading: false
          });
        }).catch(function (error) {
          console.error(error);
          self.setState({
            preValidationStatus: 'error',
            preValidationMessage: 'Não foi possível validar a abertura do diário.',
            preValidationItems: [],
            preValidationLoading: false
          });
        });
      });
    }
  }, {
    key: 'add',
    value: function add() {
      this.handleAlert('', '', 'open');
      var datasave = {
        aircraft_id: this.state.aircraft_id,
        date: this.state.date,
        email: this.state.email,
        password: this.state.password
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var url = '/aeronave/diario/editar/' + responseJson.data.id;
            var storage = {
              alert_message: responseJson.message,
              alert_type: responseJson.status
            };
            localStorage.setItem("verify_message", JSON.stringify(storage));
            self.setState({ redirect_url: url });
          }
          self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }

    // Integração com o Logbook App

  }, {
    key: 'logbookIntegration',
    value: function logbookIntegration(event) {
      event.preventDefault();
      // Se tiver integração com o Logbook App
      if (this.state.logbook_app == 1) {
        // Abrimos o modal para solicitar as credenciais do Logbook App
        this.setState({ showLogbookSignatureModal: true });
      } else {
        // Se não tiver integração, chama a função de cadastro diretamente
        this.add();
      }
    }
  }, {
    key: 'handleLogbookSignatureSubmit',
    value: function handleLogbookSignatureSubmit(credentials) {
      var _this4 = this;

      // Recebe { email, password } do modal e atualiza o state
      this.setState({
        email: credentials.email,
        password: credentials.password,
        showLogbookSignatureModal: false
      }, function () {
        // Após informar as credenciais, chama a função de cadastro
        _this4.add();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              'Cadastrar di\xE1rio de bordo'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/aeronave/diarios', className: 'btn btn-default pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-left' }),
              ' Voltar'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            this.state.aircraft_id && this.state.date && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'panel panel-info' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'panel-heading' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  'Checagem pr\xE9via do di\xE1rio'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'panel-body' },
                this.state.preValidationLoading && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-spinner fa-spin' }),
                  ' Validando condi\xE7\xF5es de abertura\u2026'
                ),
                !this.state.preValidationLoading && this.state.preValidationStatus === 'success' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check text-success' }),
                  ' ',
                  this.state.preValidationMessage || 'Nenhuma restrição encontrada para a data informada.'
                ),
                !this.state.preValidationLoading && this.state.preValidationStatus === 'warning' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-exclamation-triangle text-warning' }),
                    ' ',
                    this.state.preValidationMessage
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'ul',
                    { className: 'list-unstyled', style: { marginBottom: 0 } },
                    this.state.preValidationItems.map(function (item, index) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'li',
                        { key: index },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-minus text-warning' }),
                        ' ',
                        item
                      );
                    })
                  )
                ),
                !this.state.preValidationLoading && this.state.preValidationStatus === 'error' && this.state.preValidationMessage !== '' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-exclamation-circle text-danger' }),
                  ' ',
                  this.state.preValidationMessage
                ),
                !this.state.preValidationLoading && this.state.preValidationStatus === null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  'Selecione a aeronave e informe a data para verificar se o di\xE1rio pode ser aberto.'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.logbookIntegration },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      'Aeronave:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'aircraft_id',
                      value: this.state.aircraft_id,
                      searchable: true,
                      placeholder: 'Selecionar matrícula de aeronave',
                      onChange: this.handleSelectAircraftChange.bind(this, 'aircraft_id'),
                      options: this.state.aircrafts_list,
                      required: true
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      'Data:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.date, maskChar: null, name: 'date', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date'), placeholder: 'dd/mm/aaaa', required: true })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                    ' Adicionar di\xE1rio de bordo'
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__LogbookAppIntegration_LogbookSignatureModal__["a" /* default */], {
            show: this.state.showLogbookSignatureModal,
            onHide: function onHide() {
              return _this5.setState({ showLogbookSignatureModal: false });
            },
            onSubmit: this.handleLogbookSignatureSubmit,
            title: 'Consultar Logbook App',
            subtitle: 'Informe suas credenciais para que possamos consultar o Logbook App.',
            confirmation: 'Confirmar'
          })
        )
      );
    }
  }]);

  return AircraftLogbooksAdd;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbooksAdd);

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Elements_AircraftLogbookAirworthinessReleaseTab__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Elements_AircraftLogbookBFFInspectionTab__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Elements_AircraftLogbookALFInspectionTab__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Elements_AircraftLogbookFuelCheckTab__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Elements_AircraftLogbookFlightAdditionalItensTab__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Elements_AircraftLogbookDashboardReportsTab__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Elements_AircraftLogbookReportActionsTab__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Elements_AircraftLogbookMaintenanceOperationalRestrictionTab__ = __webpack_require__(424);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// Importação da tabela
















var AircraftLogbooksDashboard = function (_Component) {
  _inherits(AircraftLogbooksDashboard, _Component);

  function AircraftLogbooksDashboard(props) {
    _classCallCheck(this, AircraftLogbooksDashboard);

    var _this = _possibleConstructorReturn(this, (AircraftLogbooksDashboard.__proto__ || Object.getPrototypeOf(AircraftLogbooksDashboard)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      updated: 0,
      data: [],
      availability_percentage: 0,
      commercial_availability_percentage: 0,
      aircraft_modal: false,
      aircraft_modal_data: false,
      legendas_modal: false,
      filtros_modal: false,
      filter_data: [],
      filters_select: [],
      bases_select: [],
      aircraft_models_select: [],
      totals: [],
      order_by: 'base',
      show_info: {}
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.approve = _this.approve.bind(_this);
    _this.updateData = _this.updateData.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    _this.reloadPage = _this.reloadPage.bind(_this);
    _this.toggleBox = _this.toggleBox.bind(_this);
    _this.openLegendasModal = _this.openLegendasModal.bind(_this);
    _this.openFiltrosModal = _this.openFiltrosModal.bind(_this);
    _this.filter = _this.filter.bind(_this);
    _this.approveDeferredItem = _this.approveDeferredItem.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(AircraftLogbooksDashboard, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeOrder',
    value: function handleSelectChangeOrder(name, event) {
      var change = {};
      var value = 'base';
      if (event !== null) {
        value = event.value;
      }
      change[name] = value;
      this.setState(change);
      this.setState({ overlay: { message: '', type: '', status: 'open' } });
      localStorage.setItem("status_order_preference", value);

      this.loadData(value);
    }
  }, {
    key: 'handleSelectChangeFilter',
    value: function handleSelectChangeFilter(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
        change['filters_select'] = null;
        if (event.value == 'base') {
          change['filters_select'] = this.state.bases_select;
        }
      }
      this.setState(change);
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, event) {
      var change = {};
      var full_date = this.state.date_start;
      if (event == null) {
        change[name] = null;
      } else {
        var date = event.target.value;
        var year = date.split("-")[0];
        var month = date.split("-")[1];
        var day = date.split("-")[2];
        // Utilizo o .slice(-2) para garantir o formato com 2 dígitos.
        var full_date = ("0" + day).slice(-2) + "/" + ("0" + month).slice(-2) + "/" + year;
        change[name] = date;
      }
      this.setState(change);
      this.loadData(full_date);
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'popover',
    value: function popover(title, boldText) {
      var regularTexts = Array.from(arguments).slice(1);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["i" /* Popover */],
        { id: 'popover-positioned-top', title: title },
        boldText != null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          boldText
        ),
        boldText != null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
        regularTexts.map(function (text, i) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { key: i },
            i > 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            text
          );
        })
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
      // Define o tempo de recarregamento da página em milissegundos
      var updateTime = 10 * 60 * 1000; // 10 minutos em milissegundos
      // Define o intervalo de tempo para executar a função
      this.interval = setInterval(this.reloadPage, updateTime);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        var preference = localStorage.getItem("status_order_preference");
        if (preference === null || typeof preference == 'undefined') {
          localStorage.setItem("status_order_preference", 'aircraft_model');
          preference = 'aircraft_model';
        }

        this.setState({ loaded: 2, order_by: preference }, this.loadData(preference));
      }
    }
  }, {
    key: 'loadData',
    value: function loadData(preference) {
      var self = this;
      var header = this.refs.request_api.header('application/json');

      var now = new Date();
      var month = now.getMonth() + 1;
      var year = now.getFullYear();
      var day = now.getDate();
      if (day < 10) {
        day = '0' + day;
      }
      if (month < 10) {
        month = '0' + month;
      }
      var reference = day + '/' + month + '/' + year;

      var datasave = {
        'date': reference,
        // 'order': preference,
        'filter': this.state.filter_data
      };

      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/dashboard', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              data: responseJson.data.main.index_data,
              bases_select: responseJson.data.bases_select
            });
          }
          self.totals();
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'filter',
    value: function filter(event) {
      var _this2 = this;

      event.preventDefault();

      var _state = this.state,
          filter_type = _state.filter_type,
          filter_value = _state.filter_value;

      var filter_data = { type: filter_type, value: filter_value };

      this.setState({ filter_data: filter_data }, function () {
        _this2.loadData();
      });
    }
  }, {
    key: 'toggleBox',
    value: function toggleBox(record) {
      //Damos load nos selects para o modal
      var self = this;
      var header = self.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/dashboard/' + record.id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          if (responseJson.status === 'success') {
            record.aircraft_logbook_reports_list = responseJson.data.aircraft_logbook_reports_list;
            record.bases_list = responseJson.data.bases_list;
            record.users_list = responseJson.data.users_list;
            record.flight_type_list = responseJson.data.flight_type_list;
            record.maintenance_operational_restriction_list = responseJson.data.maintenance_operational_restriction_list;
            record.maintenance_intervention_types_list = responseJson.data.maintenance_intervention_types_list;
          }
        }).then(function () {
          // Enriquecer com os dados completos para popular Fuel Check flags
          var url_view = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/' + record.id;
          return fetch(url_view, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJsonView) {
            if (responseJsonView.status === 'success') {
              record.approvals = responseJsonView.data.approvals;
              record.approvals_reports = responseJsonView.data.approvals_reports;
              record.inspections = responseJsonView.data.inspections;
              record.airworthiness_releases = responseJsonView.data.airworthiness_releases;
              record.hums_flight_report_legs = responseJsonView.data.hums_flight_report_legs;
              record.transit_inspections_flight_report_legs = responseJsonView.data.transit_inspections_flight_report_legs;
              record.fluids_refils = responseJsonView.data.fluids_refils;
              record.reports = responseJsonView.data.reports;
              record.report_actions = responseJsonView.data.report_actions;
              record.report_action_parts_replacements = responseJsonView.data.report_action_parts_replacements;
              // Itens ACR (lista direta) e mapeados por ação
              record.aircraft_logbook_deferred_items = responseJsonView.data.aircraft_logbook_deferred_items;
              record.report_action_deferred_items = responseJsonView.data.report_action_deferred_items;
              record.fuel_check_ok = responseJsonView.data.main.fuel_check_ok;
              record.fuel_check_na = responseJsonView.data.main.fuel_check_na;
              record.logbook_app = responseJsonView.data.logbook_app;
              record.aircraft_logbook_id = record.id;
            }
            self.setState({
              aircraft_modal_data: record,
              aircraft_modal: true
            });
          });
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'openLegendasModal',
    value: function openLegendasModal() {
      this.setState({ legendas_modal: true });
    }
  }, {
    key: 'openFiltrosModal',
    value: function openFiltrosModal() {
      this.setState({ filtros_modal: true });
    }
  }, {
    key: 'reloadPage',
    value: function reloadPage() {
      this.setState({ overlay: { message: '', type: '', status: 'open' } });
      this.loadData();
    }
  }, {
    key: 'totals',
    value: function totals() {
      var _this3 = this;

      // Mapeando o array totals
      var totalsElements = this.state.totals.map(function (total, index) {
        var isLast = index === _this3.state.totals.length - 1;
        // Se for o último elemento, armazene as informações nas variáveis
        if (isLast) {
          _this3.setState({ availability_percentage: total.availability_percentage, commercial_availability_percentage: total.commercial_availability_percentage });
        }
      });
    }
  }, {
    key: 'approve',
    value: function approve(id, type) {
      var confirm = "Tem certeza que deseja aprovar?";
      if (window.confirm(confirm)) {
        var datasave = {
          id: id,
          type: type
        };
        this.handleAlert('', '', 'open');
        var self = this;
        var header = self.refs.request_api.header('application/json');
        var url = '/aeronave/diario/aprovacao/aprovar';
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url, { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            if (responseJson.status === 'success') {
              self.refs.request_api.validate(responseJson, 'alert');
              self.updateData(responseJson);
            } else {
              self.handleAlert(responseJson.message, responseJson.status, 'open');
            }
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'approveDeferredItem',
    value: function approveDeferredItem(id, overload_analysis) {
      var confirm = "Tem certeza que deseja continuar?";
      if (window.confirm(confirm)) {
        var datasave = {
          id: id,
          overload_analysis: overload_analysis
        };
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        var url = '/aeronave/diario/item/acao/adiada/aprovar';
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            if (responseJson.status === 'success') {
              self.refs.request_api.validate(responseJson, 'alert');
              self.updateData(responseJson);
            } else {
              self.handleAlert(responseJson.message, responseJson.status, 'open');
            }
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'updateData',
    value: function updateData(responseJson) {
      this.setState({
        updated: 1,
        edit_modal: false,
        edit_modal_data: false,
        edit_modal_type: false
      }, this.loadData(responseJson));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              'Dashboard'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-10' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p', { style: { fontSize: '17px', marginTop: '6px' } })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-2' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { href: '#', className: 'pull-left', onClick: function onClick(e) {
                        e.preventDefault();_this4.openFiltrosModal();
                      } },
                    'Filtrar'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { href: '#', className: 'pull-right', onClick: function onClick(e) {
                        e.preventDefault();_this4.openLegendasModal();
                      } },
                    'Legendas'
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            this.state.data.map(function (lines) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                lines.map(function (record) {
                  var outline_danger = record.discrepancy == 1 || record.airworthiness_check == 1 || record.transit_check == 1 || record.fuel_check == 1 || record.bff_check == 1 || record.alf_check == 1 || record.acr_check == 1 ? true : false;
                  var inscription_danger = record.discrepancy == 1 || record.airworthiness_check == 1 || record.transit_check == 1 || record.fuel_check == 1 || record.bff_check == 1 || record.alf_check == 1 || record.acr_check == 1 ? true : false;
                  var inscription_warning = record.old_logbook_status !== 0 ? true : false;
                  var background_class = '';
                  {
                    outline_danger == true ? background_class = 'panel-danger' : background_class = 'panel-primary';
                  }
                  // {record.date !== record.reference ? background_class = 'panel-approved' : ''};
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-1' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: record.background_class, style: { cursor: 'pointer' }, onClick: function onClick() {
                          return self.toggleBox(record);
                        } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'panel-body', style: { background: record.background, padding: "10px" } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'p',
                          { className: 'aircraft-status-title' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: 'label label-primary' },
                            record.aircraft
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'p',
                          { className: 'base-status-title' },
                          record.aircraft_model,
                          ' ',
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            null,
                            '(',
                            record.aircraft_logbook_id,
                            ')'
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'p',
                          { className: 'text-center' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: record.airworthiness_check == 1 ? "label label-danger" : "label label-primary" },
                            'AIRWORT RLS'
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'p',
                          { className: 'text-center' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: record.bff_check == 1 ? "label label-danger" : "label label-primary" },
                            'BFF'
                          ),
                          ' ',
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: record.alf_check == 1 ? "label label-danger" : "label label-primary" },
                            'ALF'
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'p',
                          { className: 'text-center' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: record.fuel_check == 1 ? "label label-danger" : "label label-primary" },
                            'FC'
                          ),
                          ' ',
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: record.transit_check == 1 ? "label label-danger" : "label label-primary" },
                            'BEF'
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'p',
                          { className: 'text-center' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: record.discrepancy == 1 ? "label label-danger" : "label label-primary" },
                            'REPORT'
                          ),
                          ' ',
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: record.acr_check == 1 ? "label label-danger" : "label label-primary" },
                            'ACR'
                          )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'p',
                          { className: 'text-center' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: 'label' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
                              { to: "/aeronave/diario/editar/" + record.id, className: 'btn btn-default btn-sm' },
                              record.date
                            )
                          )
                        )
                      )
                    )
                  );
                })
              );
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */],
          { show: this.state.edit_modal, 'aria-labelledby': 'contained-modal-alert-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4', { className: 'pull-left' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return self.setState({ edit_modal: false, edit_modal_data: false, edit_modal_type: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'conteudo' },
              self.state.edit_modal_type == 'fuel_check' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12 text-center', style: { marginBottom: '10px' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: self.state.edit_modal_data && self.state.edit_modal_data.fuel_check_ok ? 'label label-success' : self.state.edit_modal_data && self.state.edit_modal_data.fuel_check_na ? 'label label-default' : 'label label-warning' },
                    self.state.edit_modal_data && self.state.edit_modal_data.fuel_check_ok ? 'FC OK' : self.state.edit_modal_data && self.state.edit_modal_data.fuel_check_na ? 'FC N/A' : 'FC — Not Informed'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                self.state.edit_modal_type == 'airworthiness_check' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Elements_AircraftLogbookAirworthinessReleaseTab__["a" /* default */], { handleAlert: this.handleAlert, handleMessage: this.handleMessage, updateData: this.updateData, popover: this.popover, aircraft_logbook_id: this.state.edit_modal_data.aircraft_logbook_id, logbook_app: this.state.edit_modal_data.logbook_app, approvals: this.state.edit_modal_data.approvals, approve: this.approve, airworthiness_releases: this.state.edit_modal_data.airworthiness_releases, maintenance_intervention_types_list: this.state.edit_modal_data.maintenance_intervention_types_list, flight_type_list: this.state.edit_modal_data.flight_type_list }),
                self.state.edit_modal_type == 'bff_check' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Elements_AircraftLogbookBFFInspectionTab__["a" /* default */], { handleAlert: this.handleAlert, handleMessage: this.handleMessage, updateData: this.updateData, popover: this.popover, aircraft_logbook_id: this.state.edit_modal_data.aircraft_logbook_id, approvals: this.state.edit_modal_data.approvals, approve: this.approve, inspections: this.state.edit_modal_data.inspections }),
                self.state.edit_modal_type == 'alf_check' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Elements_AircraftLogbookALFInspectionTab__["a" /* default */], { handleAlert: this.handleAlert, handleMessage: this.handleMessage, updateData: this.updateData, popover: this.popover, aircraft_logbook_id: this.state.edit_modal_data.aircraft_logbook_id, approvals: this.state.edit_modal_data.approvals, approve: this.approve, inspections: this.state.edit_modal_data.inspections }),
                self.state.edit_modal_type == 'fuel_check' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Elements_AircraftLogbookFuelCheckTab__["a" /* default */], { handleAlert: this.handleAlert, handleMessage: this.handleMessage, updateData: this.updateData, popover: this.popover, aircraft_logbook_id: this.state.edit_modal_data.aircraft_logbook_id, approvals: this.state.edit_modal_data.approvals, approve: this.approve, fuel_check_ok: this.state.edit_modal_data.fuel_check_ok, fuel_check_na: this.state.edit_modal_data.fuel_check_na }),
                self.state.edit_modal_type == 'transit_check' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Elements_AircraftLogbookFlightAdditionalItensTab__["a" /* default */], { handleAlert: this.handleAlert, handleMessage: this.handleMessage, updateData: this.updateData, popover: this.popover, aircraft_logbook_id: this.state.edit_modal_data.aircraft_logbook_id, approvals: this.state.edit_modal_data.approvals, approve: this.approve, hums_flight_report_legs: this.state.edit_modal_data.hums_flight_report_legs, transit_inspections_flight_report_legs: this.state.edit_modal_data.transit_inspections_flight_report_legs }),
                self.state.edit_modal_type == 'report_check' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Elements_AircraftLogbookDashboardReportsTab__["a" /* default */], { handleAlert: this.handleAlert, handleMessage: this.handleMessage, updateData: this.updateData, popover: this.popover, aircraft_logbook_id: this.state.edit_modal_data.aircraft_logbook_id, approvals: this.state.edit_modal_data.approvals, approve: this.approve, reports: this.state.edit_modal_data.reports }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Elements_AircraftLogbookReportActionsTab__["a" /* default */], { handleAlert: this.handleAlert, handleMessage: this.handleMessage, updateData: this.updateData, popover: this.popover, aircraft_logbook_id: this.state.edit_modal_data.aircraft_logbook_id, logbook_app: this.state.edit_modal_data.logbook_app, approvals: this.state.edit_modal_data.approvals, approvals_reports: this.state.edit_modal_data.approvals_reports, approve: this.approve, reports: this.state.edit_modal_data.acrs_by_logbook, aircraft_logbook_reports_list: this.state.edit_modal_data.aircraft_logbook_reports_list, report_actions: this.state.edit_modal_data.report_actions, report_action_parts_replacements: this.state.edit_modal_data.report_action_parts_replacements, report_action_deferred_items: this.state.edit_modal_data.report_action_deferred_items, users_list: this.state.edit_modal_data.users_list, bases_list: this.state.edit_modal_data.bases_list, maintenance_operational_restriction_list: this.state.edit_modal_data.maintenance_operational_restriction_list })
                ),
                self.state.edit_modal_type == 'acr_check' && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Elements_AircraftLogbookMaintenanceOperationalRestrictionTab__["a" /* default */], { updated: this.state.updated, handleAlert: this.handleAlert, handleMessage: this.handleMessage, updateData: this.updateData, popover: this.popover, aircraft_logbook_id: this.state.edit_modal_data.aircraft_logbook_id, approvals: this.state.edit_modal_data.approvals, approveDeferredItem: this.approveDeferredItem, aircraft_logbook_deferred_items: this.state.edit_modal_data.aircraft_logbook_deferred_items })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return self.setState({ edit_modal: false, edit_modal_data: false, edit_modal_type: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */],
          { show: this.state.aircraft_modal, 'aria-labelledby': 'contained-modal-alert-title-lg', bsSize: 'small' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Header,
            null,
            self.state.aircraft_modal_data && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: self.state.aircraft_modal_data.discrepancy == 1 ? "label label-danger" : self.state.aircraft_modal_data.airworthiness_check == 1 ? "label label-danger" : self.state.aircraft_modal_data.transit_check == 1 ? "label label-danger" : self.state.aircraft_modal_data.fuel_check == 1 ? "label label-danger" : self.state.aircraft_modal_data.bff_check == 1 ? "label label-danger" : self.state.aircraft_modal_data.alf_check == 1 ? "label label-danger" : self.state.aircraft_modal_data.acr_check == 1 ? "label label-danger" : self.state.aircraft_modal_data.old_logbook_status !== 0 ? "label label-warning" : "" },
                self.state.aircraft_modal_data.aircraft_model,
                ' - ',
                self.state.aircraft_modal_data.aircraft
              ),
              self.state.aircraft_modal_data && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { style: { marginLeft: '8px' }, className: self.state.aircraft_modal_data.fuel_check_ok ? 'label label-success' : self.state.aircraft_modal_data.fuel_check_na ? 'label label-default' : 'label label-warning' },
                self.state.aircraft_modal_data.fuel_check_ok ? 'FC OK' : self.state.aircraft_modal_data.fuel_check_na ? 'FC N/A' : 'FC — N/I'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return self.setState({ aircraft_modal: false, aircraft_modal_data: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              self.state.aircraft_modal_data.airworthiness_check == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-12 form-group text-center' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-block btn-danger', onClick: function onClick() {
                      return self.setState({ aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'airworthiness_check' });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-eye' }),
                  'AIRWORTHINESS'
                )
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-12 form-group text-center' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-block btn-secondary', onClick: function onClick() {
                      return self.setState({ aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'airworthiness_check' });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-eye' }),
                  'AIRWORTHINESS'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              self.state.aircraft_modal_data.bff_check == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group text-center' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-block btn-danger', onClick: function onClick() {
                      return self.setState({ aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'bff_check' });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-eye' }),
                  'BFF'
                )
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group text-center' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-block btn-secondary', onClick: function onClick() {
                      return self.setState({ aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'bff_check' });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-eye' }),
                  'BFF'
                )
              ),
              self.state.aircraft_modal_data.alf_check == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group text-center' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-block btn-danger', onClick: function onClick() {
                      return self.setState({ aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'alf_check' });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-eye' }),
                  'ALF'
                )
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group text-center' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-block btn-secondary', onClick: function onClick() {
                      return self.setState({ aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'alf_check' });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-eye' }),
                  'ALF'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              self.state.aircraft_modal_data.fuel_check == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group text-center' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-block btn-danger', onClick: function onClick() {
                      return self.setState({ aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'fuel_check' });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-eye' }),
                  'FC'
                )
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group text-center' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-block btn-secondary', onClick: function onClick() {
                      return self.setState({ aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'fuel_check' });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-eye' }),
                  'FC'
                )
              ),
              self.state.aircraft_modal_data.transit_check == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group text-center' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-block btn-danger', onClick: function onClick() {
                      return self.setState({ aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'transit_check' });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-eye' }),
                  'BEF'
                )
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group text-center' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-block btn-secondary', onClick: function onClick() {
                      return self.setState({ aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'transit_check' });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-eye' }),
                  'BEF'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              self.state.aircraft_modal_data.discrepancy == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-12 form-group text-center' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-block btn-danger', onClick: function onClick() {
                      return self.setState({ aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'report_check' });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-eye' }),
                  'REPORT'
                )
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-12 form-group text-center' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-block btn-secondary', onClick: function onClick() {
                      return self.setState({ aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'report_check' });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-eye' }),
                  'REPORT'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              self.state.aircraft_modal_data.acr_check == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-12 form-group text-center' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-block btn-danger', onClick: function onClick() {
                      return self.setState({ aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'acr_check' });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-eye' }),
                  'ACR'
                )
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-12 form-group text-center' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-block btn-secondary', onClick: function onClick() {
                      return self.setState({ aircraft_modal: false, edit_modal: true, edit_modal_data: self.state.aircraft_modal_data, edit_modal_type: 'acr_check' });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-eye' }),
                  'ACR'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return self.setState({ aircraft_modal: false, aircraft_modal_data: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */],
          { show: this.state.legendas_modal, onHide: function onHide() {
              return self.setState({ legendas_modal: false });
            }, 'aria-labelledby': 'contained-legendas-modal', bsSize: 'medium' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left', id: 'contained-legendas-modal' },
              'Legendas'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return self.setState({ legendas_modal: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'label label-danger', style: { background: '#ffcccc', fontSize: '16px', color: 'black' } },
                  'Discrep\xE2ncia t\xE9cnica'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'label label-warning', style: { background: '#f7ff76', fontSize: '16px', color: 'black' } },
                  'A\xE7\xE3o necess\xE1ria'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'label label-success', style: { background: '#3a763b', fontSize: '16px' } },
                  'Nenhuma a\xE7\xE3o necess\xE1ria'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return self.setState({ legendas_modal: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */],
          { show: this.state.filtros_modal, onHide: function onHide() {
              return self.setState({ filtros_modal: false });
            }, 'aria-labelledby': 'contained-filtros-modal', bsSize: 'medium' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left', id: 'contained-filtros-modal' },
              'Filtrar'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return self.setState({ filtros_modal: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.filter },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    name: 'filter_type',
                    value: this.state.filter_type,
                    searchable: true,
                    placeholder: 'Tipo de Filtro',
                    onChange: this.handleSelectChangeFilter.bind(this, 'filter_type'),
                    options: [{ value: 'base', label: 'Filtrar por Base' }, { value: 'date', label: 'Filtrar por Data' }],
                    required: true
                  })
                ),
                this.state.filter_type === 'base' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'filter_value',
                      value: this.state.filter_value,
                      searchable: true,
                      placeholder: 'Filtro',
                      onChange: this.handleSelectChange.bind(this, 'filter_value'),
                      options: this.state.filters_select,
                      required: true
                    })
                  )
                ) : '',
                this.state.filter_type === 'date' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.filter_value, maskChar: null, name: 'filter_value', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'filter_value'), placeholder: '', required: true })
                  )
                ) : ''
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-block btn-lg' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                ' Filtrar'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return self.setState({ filtros_modal: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return AircraftLogbooksDashboard;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbooksDashboard);

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Elements_AircraftLogbookFuelCheckTab__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Elements_AircraftLogbookBFFInspectionTab__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Elements_AircraftLogbookMaintenanceOperationalRestrictionTab__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Elements_AircraftLogbookAirworthinessReleaseTab__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Elements_AircraftLogbookCrewTab__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Elements_AircraftLogbookFlightsTab__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Elements_AircraftLogbookFlightAdditionalItensTab__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Elements_AircraftLogbookTotalsTab__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Elements_AircraftLogbookEngineSpecialCountersTab__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Elements_AircraftLogbookEquipmentSpecialCountersTab__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Elements_AircraftLogbookFluidsRefilTab__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Elements_AircraftLogbookPowerCheckTab__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Elements_AircraftLogbookALFInspectionTab__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Elements_AircraftLogbookOccurrencesTab__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Elements_AircraftLogbookNoDiscrepanciesTab__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Elements_AircraftLogbookReportsTab__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Elements_AircraftLogbookReportActionsTab__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Elements_AircraftLogbookLogsTab__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__LogbookAppIntegration_LogbookSignatureModal__ = __webpack_require__(80);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













// Tabs




















var AircraftLogbookEdit = function (_Component) {
  _inherits(AircraftLogbookEdit, _Component);

  function AircraftLogbookEdit(props) {
    _classCallCheck(this, AircraftLogbookEdit);

    var _this = _possibleConstructorReturn(this, (AircraftLogbookEdit.__proto__ || Object.getPrototypeOf(AircraftLogbookEdit)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      updated: 0,
      report_trash: 0,
      id: '',
      logbook_app: '',
      logbook_app_status: {},
      validation_overview: {},
      logbook_app_status_sync_error: null,
      aircraft_id: '',
      date: '',
      date_str: '',
      status: '',
      status_str: '',
      correlation_analysis: '',
      correlation_analysis_str: '',
      limit_date: '',
      limit_date_str: '',
      registration: '',
      serial_number: '',
      ca: '',
      iam: '',
      aircraft_model: '',
      engine_1_id: '',
      engine_2_id: '',
      aircraft: {},
      engines_list: [],
      approvals: [],
      approvals_reports: [],
      inspections: '',
      airworthiness_releases: '',
      staffs: {},
      flights: {},
      aircraft_model_version_custom_items: {},
      flight_reports_list: [],
      flight_legs_list: [],
      hums_flight_report_legs: [],
      transit_inspections_flight_report_legs: [],
      totals: '',
      special_counters: [],
      fluids_refils: {},
      power_checks: {},
      occurrences: {},
      reports: {},
      aircraft_logbook_logs: {},
      fuel_check_ok: false,
      fuel_check_na: false,
      aircraft_logbook_reports_list: [],
      aircraft_logbook_deferred_items: {},
      report_actions: {},
      pending_captain_acceptances: [],
      report_action_parts_replacements: [],
      report_action_deferred_items: [],
      aircraft_models_list: [],
      maintenance_intervention_types_list: [],
      flight_type_list: [],
      locations_list: [],
      civil_qualification_types_list: [],
      fluids_refills_list: [],
      systems_list: [],
      abnormal_occurrence_types_select: [],
      users_list: [],
      maintenance_operational_restriction_list: [],
      bases_list: [],
      errors_messages: [],
      errors_listing: false,
      showLogbookSignatureModal: false,
      logbookSignaturePurpose: null,
      pendingSignaturePayload: null,
      validation_overview_open: true,
      logbook_app_url: ''
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);
    _this.popover = _this.popover.bind(_this);

    _this.updateData = _this.updateData.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    _this.edit = _this.edit.bind(_this);
    _this.editEngines = _this.editEngines.bind(_this);
    _this.statusOptions = _this.statusOptions.bind(_this);
    _this.changeStatus = _this.changeStatus.bind(_this);
    _this.approve = _this.approve.bind(_this);
    _this.approveDeferredItem = _this.approveDeferredItem.bind(_this);
    _this.openLogbookAppAction = _this.openLogbookAppAction.bind(_this);
    _this.handleLogbookSignatureModalSubmit = _this.handleLogbookSignatureModalSubmit.bind(_this);
    _this.closeLogbookSignatureModal = _this.closeLogbookSignatureModal.bind(_this);
    _this.executeLogbookAppAction = _this.executeLogbookAppAction.bind(_this);
    _this.executeApprovalRequest = _this.executeApprovalRequest.bind(_this);
    _this.requiresLogbookAppReopen = _this.requiresLogbookAppReopen.bind(_this);
    _this.getSignatureModalProps = _this.getSignatureModalProps.bind(_this);
    _this.toggleValidationOverview = _this.toggleValidationOverview.bind(_this);
    _this.renderGuidancePanel = _this.renderGuidancePanel.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(AircraftLogbookEdit, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'popover',
    value: function popover(title, boldText) {
      var regularTexts = Array.from(arguments).slice(1);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["i" /* Popover */],
        { id: 'popover-positioned-top', title: title },
        boldText != null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          boldText
        ),
        boldText != null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
        regularTexts.map(function (text, i) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { key: i },
            i > 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            text
          );
        })
      );
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'updateData',
    value: function updateData(responseJson) {
      this.setState({ updated: 1 }, this.loadData(responseJson));
    }
  }, {
    key: 'loadData',
    value: function loadData(event) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/' + self.props.match.params.id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url', '/aeronaves/diarios');
          if (responseJson.status === 'success') {
            self.setState({
              logbook_app: responseJson.data.logbook_app,
              logbook_app_status: responseJson.data.logbook_app_status || {},
              logbook_app_status_sync_error: event && event.data ? event.data.status_sync_error : null,
              logbook_app_url: responseJson.data.logbook_app_url || self.state.logbook_app_url,
              validation_overview: responseJson.data.validation_overview || {},
              id: responseJson.data.main.id,
              aircraft_id: responseJson.data.main.aircraft_id,
              report_trash: responseJson.data.main.report_trash,
              aircraft: responseJson.data.main.aircraft,
              engine_1_id: responseJson.data.main.engine_1_id,
              engine_2_id: responseJson.data.main.engine_2_id,
              date: responseJson.data.main.date,
              date_str: responseJson.data.main.date_str,
              status: responseJson.data.main.status,
              status_str: responseJson.data.main.status_str,
              correlation_analysis: responseJson.data.main.correlation_analysis,
              correlation_analysis_str: responseJson.data.main.correlation_analysis_str,
              overload_analysis: responseJson.data.main.overload_analysis,
              overload_analysis_str: responseJson.data.main.overload_analysis_str,
              limit_date: responseJson.data.main.limit_date,
              limit_date_str: responseJson.data.main.limit_date_str,
              registration: responseJson.data.main.registration,
              aircraft_model: responseJson.data.main.aircraft_model,
              serial_number: responseJson.data.main.serial_number,
              ca: responseJson.data.main.ca,
              iam: responseJson.data.main.iam,
              fuel_check_ok: responseJson.data.main.fuel_check_ok,
              fuel_check_na: responseJson.data.main.fuel_check_na,
              engines_list: responseJson.data.engines_list,
              approvals: responseJson.data.approvals,
              approvals_reports: responseJson.data.approvals_reports,
              inspections: responseJson.data.inspections,
              airworthiness_releases: responseJson.data.airworthiness_releases,
              staffs: responseJson.data.staffs,
              flights: responseJson.data.flights,
              aircraft_model_version_custom_items: responseJson.data.aircraft_model_version_custom_items,
              flight_reports_list: responseJson.data.flight_reports_list,
              flight_legs_list: responseJson.data.flight_legs_list,
              fluids_refills_list: responseJson.data.fluids_refills_list,
              hums_flight_report_legs: responseJson.data.hums_flight_report_legs,
              transit_inspections_flight_report_legs: responseJson.data.transit_inspections_flight_report_legs,
              totals: responseJson.data.totals,
              special_counters: responseJson.data.special_counters,
              fluids_refils: responseJson.data.fluids_refils,
              power_checks: responseJson.data.power_checks,
              occurrences: responseJson.data.occurrences,
              abnormal_occurrence_types_select: responseJson.data.abnormal_occurrence_types_select,
              users_list: responseJson.data.users_list,
              bases_list: responseJson.data.bases_list,
              reports: responseJson.data.reports,
              aircraft_logbook_logs: responseJson.data.aircraft_logbook_logs,
              aircraft_logbook_reports_list: responseJson.data.aircraft_logbook_reports_list,
              maintenance_operational_restriction_list: responseJson.data.maintenance_operational_restriction_list,
              systems_list: responseJson.data.systems_list,
              aircraft_logbook_deferred_items: responseJson.data.aircraft_logbook_deferred_items,
              report_actions: responseJson.data.report_actions,
              pending_captain_acceptances: responseJson.data.pending_captain_acceptances,
              report_action_parts_replacements: responseJson.data.report_action_parts_replacements,
              report_action_deferred_items: responseJson.data.report_action_deferred_items,
              maintenance_intervention_types_list: responseJson.data.maintenance_intervention_types_list,
              flight_type_list: responseJson.data.flight_type_list,
              locations_list: responseJson.data.locations_list,
              civil_qualification_types_list: responseJson.data.civil_qualification_types_list
            });
          }
        }).then(function () {
          var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/modelo/lista';
          fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson);
            if (responseJson.status === 'success') {
              self.setState({ aircraft_models_list: responseJson.data });
            }
          }).then(function () {
            if (event) {
              self.handleAlert(event.message, event.status, 'open');
            } else {
              self.setState({ overlay: { message: '', type: '', status: 'closed' } });
              self.handleMessage();
            }
          });
        });
      });
    }

    //Salvar ou atualizar motores

  }, {
    key: 'editEngines',
    value: function editEngines(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var url = '/aeronave/diario/motores';
      var data = {
        id: this.state.id,
        engine_1_id: this.state.engine_1_id,
        engine_2_id: this.state.engine_2_id
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(data) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.updateData(responseJson);
            self.setState({ overlay: { message: responseJson.message, type: 'success', status: 'open' } });
          } else {
            self.setState({ overlay: { message: responseJson.message, type: 'error', status: 'open' } });
          }
        });
      });
    }

    // Fetch salvando a edição

  }, {
    key: 'edit',
    value: function edit(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        id: this.state.id,
        aircraft_id: this.state.aircraft_id,
        date: this.state.date,
        status: this.state.status
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.updateData(responseJson);
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'statusOptions',
    value: function statusOptions() {
      switch (this.state.status) {
        // Se o status for "Em andamento"
        case 0:
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["h" /* Dropdown */],
            { id: 'revisions' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["h" /* Dropdown */].Toggle,
              { bsStyle: 'primary' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-certificate' }),
              ' ',
              this.state.status_str
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["h" /* Dropdown */].Menu,
              { className: 'super-colors' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                { onSelect: this.changeStatus, eventKey: 1 },
                'Trocar para Finalizado'
              )
            )
          );
        // Se o status for "Finalizado"
        case 1:
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["h" /* Dropdown */],
            { id: 'revisions' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["h" /* Dropdown */].Toggle,
              { bsStyle: 'primary' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-certificate' }),
              ' ',
              this.state.status_str
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["h" /* Dropdown */].Menu,
              { className: 'super-colors' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                { onSelect: this.changeStatus, eventKey: 0 },
                'Retornar para Em Andamento'
              )
            )
          );
      }
    }
  }, {
    key: 'changeStatus',
    value: function changeStatus(status) {
      var confirm = "Tem certeza que gostaria de trocar o status do diário de bordo?";
      if (window.confirm(confirm)) {
        var datasave = {
          id: this.props.match.params.id,
          status: status
        };
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        var url = '/aeronave/diario/status';
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.updateData(responseJson);
            if (responseJson.status === 'warning') {
              self.setState({
                errors_listing: true,
                errors_messages: responseJson.data
              });
            } else {
              self.setState({
                errors_listing: false,
                errors_messages: []
              });
            }
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'openLogbookAppAction',
    value: function openLogbookAppAction(action) {
      if (action === 'approve') {
        var finalizeConfirm = 'Isso deve ser feito apenas ao final da jornada. Tem certeza que deseja continuar?';
        if (!window.confirm(finalizeConfirm)) {
          return;
        }
      }

      this.setState({
        showLogbookSignatureModal: true,
        logbookSignaturePurpose: 'logbook_app_action',
        pendingSignaturePayload: { action: action }
      });
    }
  }, {
    key: 'closeLogbookSignatureModal',
    value: function closeLogbookSignatureModal() {
      this.setState({
        showLogbookSignatureModal: false,
        logbookSignaturePurpose: null,
        pendingSignaturePayload: null
      });
    }
  }, {
    key: 'requiresLogbookAppReopen',
    value: function requiresLogbookAppReopen() {
      return this.state.logbook_app === 1 && this.state.logbook_app_status && this.state.logbook_app_status.is_approved === true;
    }
  }, {
    key: 'toggleValidationOverview',
    value: function toggleValidationOverview() {
      this.setState({ validation_overview_open: !this.state.validation_overview_open });
    }
  }, {
    key: 'handleLogbookSignatureModalSubmit',
    value: function handleLogbookSignatureModalSubmit(credentials) {
      var _this2 = this;

      var purpose = this.state.logbookSignaturePurpose;
      var payload = this.state.pendingSignaturePayload;
      this.setState({ showLogbookSignatureModal: false }, function () {
        if (purpose === 'logbook_app_action' && payload) {
          _this2.executeLogbookAppAction(payload.action, credentials);
        }

        if (purpose === 'airworthiness_release' && payload) {
          _this2.executeApprovalRequest(payload, credentials);
        }
      });
    }
  }, {
    key: 'executeLogbookAppAction',
    value: function executeLogbookAppAction(action, credentials) {
      this.setState({ pendingSignaturePayload: null, logbookSignaturePurpose: null });
      var endpoint = action === 'reopen' ? '/integrar/logbook/data/reabrir' : '/integrar/logbook/data/aprovar';
      var datasave = {
        aircraft_logbook_id: this.props.match.params.id,
        email: credentials.email,
        password: credentials.password
      };

      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;

      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + endpoint, { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          if (responseJson && responseJson.status === 'success') {
            self.refs.request_api.validate(responseJson, 'alert');
            self.updateData(responseJson);
          } else if (responseJson) {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'executeApprovalRequest',
    value: function executeApprovalRequest(approvalData, credentials) {
      this.setState({ pendingSignaturePayload: null, logbookSignaturePurpose: null });
      var datasave = {
        id: approvalData.id,
        type: approvalData.type
      };

      if (credentials) {
        datasave.email = credentials.email;
        datasave.password = credentials.password;
      }

      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      var url = '/aeronave/diario/aprovacao/aprovar';
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url, { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          if (responseJson.status === 'success') {
            self.refs.request_api.validate(responseJson, 'alert');
            self.updateData(responseJson);
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'getSignatureModalProps',
    value: function getSignatureModalProps() {
      var purpose = this.state.logbookSignaturePurpose;
      var isApproved = this.state.logbook_app_status && this.state.logbook_app_status.is_approved;

      if (purpose === 'logbook_app_action') {
        return {
          title: isApproved ? 'Reabrir data no Logbook App' : 'Aprovar data no Logbook App',
          subtitle: 'Informe suas credenciais do Logbook App para continuar.',
          confirmation: isApproved ? 'Confirmar reabertura' : 'Confirmar aprovação'
        };
      }

      if (purpose === 'airworthiness_release') {
        return {
          title: 'Reabrir data no Logbook App',
          subtitle: 'Antes de aprovar a liberação de aeronavegabilidade, precisamos reabrir a data no Logbook App usando sua assinatura.',
          confirmation: 'Reabrir e prosseguir'
        };
      }

      return {
        title: 'Informe suas credenciais do Logbook App',
        subtitle: 'As credenciais são necessárias para concluir esta ação no Logbook App.',
        confirmation: 'Confirmar'
      };
    }
  }, {
    key: 'renderGuidancePanel',
    value: function renderGuidancePanel() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'panel panel-default', style: { marginTop: 15 } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'panel-heading' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'strong',
            null,
            'Orienta\xE7\xF5es r\xE1pidas'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'panel-body' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h5',
                { className: 'text-uppercase' },
                'Tripula\xE7\xE3o'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'ul',
                { className: 'list-unstyled', style: { marginBottom: 0 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check text-primary' }),
                  ' Ap\xF3s revisar o di\xE1rio, utilize o bot\xE3o verde de Aceita\xE7\xE3o do Comandante.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check text-primary' }),
                  ' Na an\xE1lise de ACR, confirme a sobrecarga antes de enviar para manuten\xE7\xE3o.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check text-primary' }),
                  ' Registre reportes quando houver discrep\xE2ncia e aprove-os para bloquear novos voos at\xE9 a resposta.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check text-primary' }),
                  ' No final da jornada, ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'strong',
                    null,
                    'finalize'
                  ),
                  ' o Logbook App.'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h5',
                { className: 'text-uppercase' },
                'Manuten\xE7\xE3o'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'ul',
                { className: 'list-unstyled', style: { marginBottom: 0 } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-wrench text-danger' }),
                  ' Preencha e confirme a libera\xE7\xE3o de aeronavegabilidade; sem ela, relat\xF3rios de voo n\xE3o podem ser finalizados.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-wrench text-danger' }),
                  ' Confirme inspe\xE7\xF5es de HUMS e de tr\xE2nsito.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-wrench text-danger' }),
                  ' Responda aos reportes com a\xE7\xF5es de manuten\xE7\xE3o e aprove o RTS correspondente.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-wrench text-danger' }),
                  ' Registre posterga\xE7\xF5es e substitui\xE7\xF5es de componentes.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'li',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-wrench text-danger' }),
                  ' Se houver a necessidade de nova libera\xE7\xE3o de aeronavegabilidade crie uma nova p\xE1gina de di\xE1rio de bordo.'
                )
              )
            )
          )
        )
      );
    }
  }, {
    key: 'approve',
    value: function approve(id, type) {
      var confirm = "Tem certeza que deseja aprovar?";
      if (window.confirm(confirm)) {
        if (type === 3 && this.requiresLogbookAppReopen()) {
          this.setState({
            showLogbookSignatureModal: true,
            logbookSignaturePurpose: 'airworthiness_release',
            pendingSignaturePayload: { id: id, type: type }
          });
          return;
        }

        this.executeApprovalRequest({ id: id, type: type });
      }
    }
  }, {
    key: 'approveDeferredItem',
    value: function approveDeferredItem(id, overload_analysis) {
      var confirm = "Tem certeza que deseja continuar?";
      if (window.confirm(confirm)) {
        var datasave = {
          id: id,
          overload_analysis: overload_analysis
        };
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        var url = '/aeronave/diario/item/acao/adiada/aprovar';
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            if (responseJson.status === 'success') {
              self.refs.request_api.validate(responseJson, 'alert');
              self.updateData(responseJson);
            } else {
              self.handleAlert(responseJson.message, responseJson.status, 'open');
            }
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var self = this;
      var signatureModalProps = this.getSignatureModalProps();
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-fluid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              'Editar Di\xE1rio de Bordo'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'page-title pull-left' },
              'Aeronave: ',
              this.state.registration,
              ' | Data: ',
              this.state.date_str
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'grid-buttons pull-right' },
              this.statusOptions(),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
                { to: '/aeronave/diarios', className: 'btn btn-default pull-right' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-left' }),
                ' Voltar'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            this.renderGuidancePanel(),
            this.state.logbook_app == 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'panel panel-default', style: { marginTop: 20 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'panel-heading clearfix' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'a',
                    { href: this.state.logbook_app_url || '#', target: '_blank', rel: 'noopener noreferrer' },
                    'Logbook App'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'panel-body' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'alert alert-danger', role: 'alert' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'fa fa-warning' }),
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'strong',
                    null,
                    'Aten\xE7\xE3o:'
                  ),
                  ' O Logbook App s\xF3 dever\xE1 ser finalizado ap\xF3s o t\xE9rmino da jornada! Ap\xF3s a finaliza\xE7\xE3o, o sistema impedir\xE1 qualquer altera\xE7\xE3o no di\xE1rio de bordo.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      'Status'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'p',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'span',
                        { className: 'label ' + (this.state.logbook_app_status.is_approved ? 'label-success' : 'label-warning') },
                        this.state.logbook_app_status.status_label || 'Pendente'
                      )
                    ),
                    this.state.logbook_app_status.synced_at && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'small',
                      null,
                      'Atualizado em ',
                      this.state.logbook_app_status.synced_at
                    ),
                    this.state.logbook_app_status.signature_status && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'small',
                        null,
                        'Assinatura: ',
                        this.state.logbook_app_status.signature_status
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      'A\xE7\xF5es'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      null,
                      this.state.logbook_app_status.is_approved ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { type: 'button', className: 'btn btn-danger', onClick: function onClick() {
                            return _this3.openLogbookAppAction('reopen');
                          } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-undo' }),
                        ' Reabrir Logbook App'
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { type: 'button', className: 'btn btn-primary', onClick: function onClick() {
                            return _this3.openLogbookAppAction('approve');
                          } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' }),
                        ' Finalizar Logbook App'
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      'Aprovado em'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'p',
                      null,
                      this.state.logbook_app_status.approval_date || '-'
                    )
                  )
                ),
                this.state.logbook_app_status_sync_error && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'alert alert-warning', style: { marginTop: 15 } },
                  this.state.logbook_app_status_sync_error
                )
              )
            ),
            Object.keys(this.state.validation_overview || {}).length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'panel panel-info', style: { marginTop: 15 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'panel-heading clearfix' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  'Checklist de pend\xEAncias'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  {
                    type: 'button',
                    className: 'btn btn-link btn-xs pull-right',
                    onClick: this.toggleValidationOverview,
                    style: { marginTop: -3 }
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa ' + (this.state.validation_overview_open ? 'fa-chevron-down' : 'fa-chevron-up') })
                )
              ),
              this.state.validation_overview_open && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'panel-body' },
                ['finalize', 'add_same_day', 'add_next_day'].map(function (key) {
                  var item = _this3.state.validation_overview[key];
                  if (!item) {
                    return null;
                  }

                  var hasErrors = Array.isArray(item.errors) && item.errors.length > 0;

                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { key: key, style: { marginBottom: 15 } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'strong',
                      null,
                      item.label || '',
                      item.date ? ' — ' + item.date : ''
                    ),
                    hasErrors ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'ul',
                      { className: 'list-unstyled', style: { marginTop: 10 } },
                      item.errors.map(function (message, index) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'li',
                          { key: index },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-exclamation-circle text-danger' }),
                          ' ',
                          message
                        );
                      })
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'p',
                      { style: { marginTop: 10 } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check text-success' }),
                      ' Nenhuma pend\xEAncia identificada.'
                    )
                  );
                })
              )
            ),
            this.state.errors_listing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'alert alert-danger alert-dismissible', role: 'alert', style: { marginTop: 25 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { onClick: function onClick() {
                    return self.setState({ errors_listing: false, errors_messages: [] });
                  }, type: 'button', className: 'close', 'data-dismiss': 'alert', 'aria-label': 'Close' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { 'aria-hidden': 'true' },
                  '\xD7'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                'Os seguintes erros de preenchimento impediram o di\xE1rio de bordo de ser finalizado:'
              ),
              Object.keys(self.state.errors_messages).map(function (k) {
                var message = self.state.errors_messages[k];
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  '- ',
                  message
                );
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.edit },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      'Manufacturer/Model:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'aircraft_model', className: 'form-control', placeholder: 'Modelo da aeronave', value: this.state.aircraft_model, onChange: this.handleChange.bind(this, 'aircraft_model'), disabled: true })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      'Tail Number:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'registration', className: 'form-control', placeholder: 'Registro da aeronave', value: this.state.registration, onChange: this.handleChange.bind(this, 'registration'), disabled: true })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      'CAT:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'operation_type_id', className: 'form-control', placeholder: 'Categoria da aeronave', value: this.state.operation_type_id, onChange: this.handleChange.bind(this, 'operation_type_id'), disabled: true })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      'S/N:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'serial_number', className: 'form-control', placeholder: 'N\xFAmero de s\xE9rie', value: this.state.serial_number, onChange: this.handleChange.bind(this, 'serial_number'), disabled: true })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      'C.A.:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'ca', className: 'form-control', placeholder: 'Vencimento do CA', value: this.state.ca, onChange: this.handleChange.bind(this, 'ca'), disabled: true })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      'I.A.M:'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'iam', className: 'form-control', placeholder: 'Vencimento do IAM', value: this.state.iam, onChange: this.handleChange.bind(this, 'iam'), disabled: true })
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Engine #1:'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: 'form-group',
                    name: 'engine_1_id',
                    value: this.state.engine_1_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'engine_1_id'),
                    options: this.state.engines_list,
                    disabled: true
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Engine #2:'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: 'form-group',
                    name: 'engine_2_id',
                    value: this.state.engine_2_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'engine_2_id'),
                    options: this.state.engines_list,
                    disabled: true
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'overlay' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Elements_AircraftLogbookFuelCheckTab__["a" /* default */], { handleAlert: this.handleAlert, handleMessage: this.handleMessage, updateData: this.updateData, popover: this.popover, aircraft_logbook_id: this.props.match.params.id, approvals: this.state.approvals, approve: this.approve, fuel_check_ok: this.state.fuel_check_ok, fuel_check_na: this.state.fuel_check_na }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Elements_AircraftLogbookBFFInspectionTab__["a" /* default */], { handleAlert: this.handleAlert, handleMessage: this.handleMessage, updateData: this.updateData, popover: this.popover, aircraft_logbook_id: this.props.match.params.id, approvals: this.state.approvals, approve: this.approve, inspections: this.state.inspections }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Elements_AircraftLogbookMaintenanceOperationalRestrictionTab__["a" /* default */], { updated: this.state.updated, handleAlert: this.handleAlert, handleMessage: this.handleMessage, updateData: this.updateData, popover: this.popover, aircraft_logbook_id: this.props.match.params.id, approvals: this.state.approvals, approveDeferredItem: this.approveDeferredItem, aircraft_logbook_deferred_items: this.state.aircraft_logbook_deferred_items, status_str: this.state.status_str, overload_analysis_str: this.state.overload_analysis_str, correlation_analysis_str: this.state.correlation_analysis_str, limit_date_str: this.state.limit_date_str }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'overlay' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Elements_AircraftLogbookAirworthinessReleaseTab__["a" /* default */], { handleAlert: this.handleAlert, handleMessage: this.handleMessage, updateData: this.updateData, popover: this.popover, aircraft_logbook_id: this.props.match.params.id, approvals: this.state.approvals, approve: this.approve, airworthiness_releases: this.state.airworthiness_releases, maintenance_intervention_types_list: this.state.maintenance_intervention_types_list, flight_type_list: this.state.flight_type_list, logbook_app: this.state.logbook_app })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Elements_AircraftLogbookCrewTab__["a" /* default */], { handleAlert: this.handleAlert, handleMessage: this.handleMessage, updateData: this.updateData, popover: this.popover, aircraft_logbook_id: this.props.match.params.id, approvals: this.state.approvals, approve: this.approve, staffs: this.state.staffs, pending_captain_acceptances: this.state.pending_captain_acceptances, logbook_app: this.state.logbook_app }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Elements_AircraftLogbookFlightsTab__["a" /* default */], { handleAlert: this.handleAlert, handleMessage: this.handleMessage, updateData: this.updateData, popover: this.popover, aircraft_logbook_id: this.props.match.params.id, approvals: this.state.approvals, approve: this.approve, flights: this.state.flights, aircraft_model_version_custom_items: this.state.aircraft_model_version_custom_items, flight_reports_list: this.state.flight_reports_list, aircraft: this.state.aircraft }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'overlay' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Elements_AircraftLogbookFlightAdditionalItensTab__["a" /* default */], { handleAlert: this.handleAlert, handleMessage: this.handleMessage, updateData: this.updateData, popover: this.popover, aircraft_logbook_id: this.props.match.params.id, approvals: this.state.approvals, approve: this.approve, hums_flight_report_legs: this.state.hums_flight_report_legs, transit_inspections_flight_report_legs: this.state.transit_inspections_flight_report_legs }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Elements_AircraftLogbookTotalsTab__["a" /* default */], { handleAlert: this.handleAlert, handleMessage: this.handleMessage, updateData: this.updateData, popover: this.popover, aircraft_logbook_id: this.props.match.params.id, totals: this.state.totals }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Elements_AircraftLogbookEngineSpecialCountersTab__["a" /* default */], { handleAlert: this.handleAlert, handleMessage: this.handleMessage, updateData: this.updateData, popover: this.popover, aircraft_logbook_id: this.props.match.params.id, special_counters: this.state.special_counters }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Elements_AircraftLogbookEquipmentSpecialCountersTab__["a" /* default */], { handleAlert: this.handleAlert, handleMessage: this.handleMessage, updateData: this.updateData, popover: this.popover, aircraft_logbook_id: this.props.match.params.id, special_counters: this.state.special_counters }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Elements_AircraftLogbookPowerCheckTab__["a" /* default */], { handleAlert: this.handleAlert, handleMessage: this.handleMessage, updateData: this.updateData, popover: this.popover, aircraft_logbook_id: this.props.match.params.id, power_checks: this.state.power_checks, flight_legs_list: this.state.flight_legs_list }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Elements_AircraftLogbookOccurrencesTab__["a" /* default */], { handleAlert: this.handleAlert, handleMessage: this.handleMessage, updateData: this.updateData, popover: this.popover, aircraft_logbook_id: this.props.match.params.id, occurrences: this.state.occurrences, flight_legs_list: this.state.flight_legs_list, abnormal_occurrence_types_select: this.state.abnormal_occurrence_types_select, locations_list: this.state.locations_list, civil_qualification_types_list: this.state.civil_qualification_types_list, logbook_app: this.state.logbook_app }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'overlay' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Elements_AircraftLogbookFluidsRefilTab__["a" /* default */], { handleAlert: this.handleAlert, handleMessage: this.handleMessage, updateData: this.updateData, popover: this.popover, aircraft_logbook_id: this.props.match.params.id, approvals: this.state.approvals, approve: this.approve, fluids_refils: this.state.fluids_refils, flight_legs_list: this.state.flight_legs_list, fluids_refills_list: this.state.fluids_refills_list }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__Elements_AircraftLogbookALFInspectionTab__["a" /* default */], { handleAlert: this.handleAlert, handleMessage: this.handleMessage, updateData: this.updateData, popover: this.popover, aircraft_logbook_id: this.props.match.params.id, approvals: this.state.approvals, approve: this.approve, inspections: this.state.inspections }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__Elements_AircraftLogbookNoDiscrepanciesTab__["a" /* default */], { handleAlert: this.handleAlert, handleMessage: this.handleMessage, updateData: this.updateData, aircraft_logbook_id: this.props.match.params.id }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__Elements_AircraftLogbookReportsTab__["a" /* default */], { handleAlert: this.handleAlert, handleMessage: this.handleMessage, updateData: this.updateData, popover: this.popover, aircraft_logbook_id: this.props.match.params.id, report_trash: this.state.report_trash, approvals: this.state.approvals, approve: this.approve, flight_legs_list: this.state.flight_legs_list, reports: this.state.reports, users_list: this.state.users_list, maintenance_intervention_types_list: this.state.maintenance_intervention_types_list, fluids_refills_list: this.state.fluids_refills_list, bases_list: this.state.bases_list, locations_list: this.state.locations_list, logbook_app: this.state.logbook_app }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'overlay' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Elements_AircraftLogbookReportActionsTab__["a" /* default */], { handleAlert: this.handleAlert, handleMessage: this.handleMessage, updateData: this.updateData, popover: this.popover, aircraft_logbook_id: this.props.match.params.id, approvals_reports: this.state.approvals_reports, approve: this.approve, aircraft_logbook_reports_list: this.state.aircraft_logbook_reports_list, reports: this.state.reports, report_actions: this.state.report_actions, report_action_parts_replacements: this.state.report_action_parts_replacements, report_action_deferred_items: this.state.report_action_deferred_items, users_list: this.state.users_list, bases_list: this.state.bases_list, maintenance_operational_restriction_list: this.state.maintenance_operational_restriction_list, systems_list: this.state.systems_list, engines_list: this.state.engines_list, fluids_refills_list: this.state.fluids_refills_list, maintenance_intervention_types_list: this.state.maintenance_intervention_types_list, airworthiness_releases: this.state.airworthiness_releases, logbook_app: this.state.logbook_app }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__Elements_AircraftLogbookLogsTab__["a" /* default */], { handleAlert: this.handleAlert, handleMessage: this.handleMessage, aircraft_logbook_id: this.props.match.params.id, aircraft_logbook_logs: this.state.aircraft_logbook_logs }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__LogbookAppIntegration_LogbookSignatureModal__["a" /* default */], Object.assign({
          show: this.state.showLogbookSignatureModal,
          onHide: this.closeLogbookSignatureModal,
          onSubmit: this.handleLogbookSignatureModalSubmit
        }, signatureModalProps))
      );
    }
  }]);

  return AircraftLogbookEdit;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookEdit);

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// Importação da tabela


var AircraftLogbooksIndex = function (_Component) {
  _inherits(AircraftLogbooksIndex, _Component);

  function AircraftLogbooksIndex(props) {
    _classCallCheck(this, AircraftLogbooksIndex);

    var _this = _possibleConstructorReturn(this, (AircraftLogbooksIndex.__proto__ || Object.getPrototypeOf(AircraftLogbooksIndex)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.delete = _this.delete.bind(_this);
    _this.deleteRow = _this.deleteRow.bind(_this);
    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(AircraftLogbooksIndex, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronaves/diarios', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var url = '/aeronave/diario/editar/' + cell;

      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
          { className: 'btn btn-primary btn-sm button-inline', to: url },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-sm btn-danger button-inline', value: cell, onClick: this.delete },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-trash' })
        )
      );

      return botao;
    }
  }, {
    key: 'delete',
    value: function _delete(event) {
      var id = event.currentTarget.value;
      var confirm = window.confirm('Tem certeza que gostaria de deletar esse diário de bordo?');
      if (confirm) {
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.deleteRow(id);
            }
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'deleteRow',
    value: function deleteRow(id) {
      var data = this.state.data;
      data.map(function (dado, index) {
        if (dado.id == id) {
          data.splice(index, 1);
        }
      });
      this.setState({ data: data });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-fluid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              'Lista de di\xE1rios de bordo'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/aeronave/diario/cadastrar', className: 'btn btn-primary pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-plus' }),
              ' ',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { className: 'hidden-sm hidden-xs' },
                'Adicionar di\xE1rio de bordo'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: 'Exportar CSV', noDataText: 'Não há diários de bordo cadastrados' }, search: true, multiColumnSearch: true, searchPlaceholder: 'Procurar' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                'ID'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'aircraft_registration', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '130' },
                'Matr\xEDcula'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'date_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '130' },
                'Data'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'status_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '130' },
                'Status'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '80' },
                'A\xE7\xF5es'
              )
            )
          )
        )
      );
    }
  }]);

  return AircraftLogbooksIndex;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbooksIndex);

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_recharts__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













// Importação da tabela


var AircraftLogbooksSearch = function (_Component) {
  _inherits(AircraftLogbooksSearch, _Component);

  function AircraftLogbooksSearch(props) {
    _classCallCheck(this, AircraftLogbooksSearch);

    var _this = _possibleConstructorReturn(this, (AircraftLogbooksSearch.__proto__ || Object.getPrototypeOf(AircraftLogbooksSearch)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.search = _this.search.bind(_this);
    _this.exportPdf = _this.exportPdf.bind(_this);
    _this.exportXls = _this.exportXls.bind(_this);
    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.AlertColumn = _this.AlertColumn.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(AircraftLogbooksSearch, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeMultiple',
    value: function handleSelectChangeMultiple(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/papeleta/consulta/gestor/dados', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              staffs_select: responseJson.data
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'search',
    value: function search(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');

      var datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        staffs: this.state.staffs,
        fired: this.state.fired,
        alerts: this.state.alerts
      };

      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/papeleta/consulta/gestor/pesquisa', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
            self.handleAlert('', '', 'closed');
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'exportPdf',
    value: function exportPdf(url) {
      var self = this;
      var header = this.refs.request_api.header('application/json');

      var datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        staffs: this.state.staffs,
        fired: this.state.fired,
        alerts: this.state.alerts
      };

      self.handleAlert('Aguarde enquanto o arquivo é gerado. Este processo pode levar alguns minutos.', 'warning', 'open');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/papeleta/consulta/gestor/pdf', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data;
            self.setState({
              url_export: url
            });
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data);
          }
        });
      });
    }
  }, {
    key: 'exportXls',
    value: function exportXls(url) {
      var self = this;
      var header = this.refs.request_api.header('application/json');

      var datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        staffs: this.state.staffs,
        fired: this.state.fired,
        alerts: this.state.alerts
      };

      self.handleAlert('Aguarde enquanto o arquivo é gerado. Este processo pode levar alguns minutos.', 'warning', 'open');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/papeleta/consulta/gestor/xls', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data;
            self.setState({
              url_export: url
            });
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data);
          }
        });
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var url = '/papeleta/editar/' + cell;

      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
          { className: 'btn btn-primary btn-sm', to: url },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
        )
      );

      return botao;
    }
  }, {
    key: 'AlertColumn',
    value: function AlertColumn(cell, row) {

      if (cell === 'Sim') {
        var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'label label-danger', style: { fontSize: 14 } },
          'Sim'
        );
      } else {
        var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'label label-success', style: { fontSize: 14 } },
          'N\xE3o'
        );
      }

      return botao;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              'Consulta de Di\xE1rios de Bordo'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.search },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Data Inicial:'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_input_mask___default.a, { value: this.state.date_start, maskChar: null, name: 'date_start ', mask: '99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: 'mm/yyyyy', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Data Final:'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_input_mask___default.a, { value: this.state.date_finish, maskChar: null, name: 'date_finish ', mask: '99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: 'mm/yyyyy', required: true })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Aeronaves:'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                    className: '',
                    name: 'aircrafts',
                    value: this.state.aircrafts,
                    searchable: true,
                    placeholder: '',
                    multi: true
                    // onChange={this.handleSelectChangeMultiple.bind(this, 'aircrafts')}
                    , options: [{ label: 'PR-OHN', value: 1 }, { label: 'PR-OHA', value: 2 }, { label: 'PR-OHB', value: 3 }, { label: 'PR-OHC', value: 4 }]
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Status:'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                    className: '',
                    name: 'status',
                    value: '',
                    searchable: true,
                    placeholder: ''
                    // onChange={this.handleSelectChange.bind(this, 'fired')}
                    , options: [{ label: 'Rascunho', value: 1 }, { label: 'Finalizado', value: 2 }, { label: 'Aprovado', value: 3 }, { label: 'Enviado para ANAC', value: 4 }, { label: 'Cancelado', value: 0 }]
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Somente com alertas:'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                    className: '',
                    name: 'alerts',
                    value: this.state.alerts,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'alerts'),
                    options: [{ label: 'Sim', value: 1 }, { label: 'Não', value: 0 }]
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-block btn-lg' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                ' Pesquisar'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { onClick: function onClick() {
                      _this2.exportPdf();
                    }, className: 'btn btn-success btn-block btn-lg' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' }),
                  ' Exportar PDF'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { onClick: function onClick() {
                      _this2.exportXls();
                    }, className: 'btn btn-warning btn-block btn-lg' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-excel-o' }),
                  ' Exportar XLS'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, options: { exportCSVText: 'Exportar CSV', noDataText: ' ' }, multiColumnSearch: true, searchPlaceholder: 'Procurar' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'staff_name', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' } },
                'Tripulante'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'month', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' } },
                'M\xEAs/Ano'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'alerts', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, dataFormat: this.AlertColumn },
                'Alertas'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '100' },
                'A\xE7\xF5es'
              )
            )
          )
        )
      );
    }
  }]);

  return AircraftLogbooksSearch;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbooksSearch);

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LogbookAppIntegration_LogbookSignatureModal__ = __webpack_require__(80);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário






// Importo o moment com a linguagem pt-br
__webpack_require__(24);
__webpack_require__(32);

var AircraftLogbookCrewTab = function (_Component) {
  _inherits(AircraftLogbookCrewTab, _Component);

  function AircraftLogbookCrewTab(props) {
    _classCallCheck(this, AircraftLogbookCrewTab);

    var _this = _possibleConstructorReturn(this, (AircraftLogbookCrewTab.__proto__ || Object.getPrototypeOf(AircraftLogbookCrewTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      aircraft_logbook_id: _this.props.aircraft_logbook_id,
      staffs: {},
      approvals: [],
      approval: [],
      reason: '',
      pending_captain_acceptances: [],
      pending_report_action_id: null,
      email: '',
      password: '',
      showLogbookSignatureModal: false,
      signature_modal_title: '',
      signature_modal_subtitle: '',
      signature_modal_confirmation: ''
    };
    //Handlers
    _this.reprove = _this.reprove.bind(_this);
    _this.handleApprove = _this.handleApprove.bind(_this);
    _this.handlePendingAcceptance = _this.handlePendingAcceptance.bind(_this);
    _this.acceptPendingAction = _this.acceptPendingAction.bind(_this);
    _this.handleLogbookSignatureSubmit = _this.handleLogbookSignatureSubmit.bind(_this);
    _this.handleSignatureModalCancel = _this.handleSignatureModalCancel.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(AircraftLogbookCrewTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          loaded: 1
        });
      }

      if (typeof newProps.staffs !== 'undefined' && newProps.staffs !== null && this.state.loaded === 1) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          staffs: newProps.staffs
        });
      }

      if (typeof newProps.approvals[4] !== 'undefined' && newProps.approvals[4] !== null && this.state.loaded === 1) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          approvals: newProps.approvals[4],
          approval: newProps.approvals[4][0]
        });
      }

      if (typeof newProps.pending_captain_acceptances !== 'undefined' && newProps.pending_captain_acceptances !== null && this.state.loaded === 1) {
        this.setState({
          pending_captain_acceptances: newProps.pending_captain_acceptances
        });
      }
    }
  }, {
    key: 'handleApprove',
    value: function handleApprove() {
      if (!this.state.approval || typeof this.state.approval.id === 'undefined') {
        return;
      }

      if (this.state.pending_captain_acceptances.length > 0) {
        if (typeof this.props.handleAlert === 'function') {
          this.props.handleAlert('Não é possível aprovar, existem ações de manutenção pendentes de aceitação do comandante.', 'error', 'open');
        }
        return;
      }

      this.props.approve(this.state.approval.id, this.state.approval.type);
    }
  }, {
    key: 'handlePendingAcceptance',
    value: function handlePendingAcceptance(actionId) {
      if (!actionId) {
        return;
      }

      if (this.props.logbook_app == 1) {
        this.setState({
          pending_report_action_id: actionId,
          signature_modal_title: 'Você tem certeza de que deseja integrar e registrar a aceitação de Comandante no Logbook App?',
          signature_modal_subtitle: 'Ao confirmar sua assinatura digital será afixada a este registro e ficará visível para todos os usuários do sistema.',
          signature_modal_confirmation: 'Confirmo que estou ciente e desejo prosseguir com a assinatura',
          showLogbookSignatureModal: true
        });
        return;
      }

      this.setState({
        pending_report_action_id: actionId,
        email: '',
        password: ''
      }, this.acceptPendingAction);
    }
  }, {
    key: 'handleLogbookSignatureSubmit',
    value: function handleLogbookSignatureSubmit(credentials) {
      this.setState({
        email: credentials.email,
        password: credentials.password,
        showLogbookSignatureModal: false
      }, this.acceptPendingAction);
    }
  }, {
    key: 'acceptPendingAction',
    value: function acceptPendingAction() {
      if (!this.state.pending_report_action_id) {
        return;
      }

      this.props.handleAlert('', '', 'open');
      var datasave = {
        report_action_id: this.state.pending_report_action_id,
        email: this.state.email,
        password: this.state.password
      };

      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/reporte/acao/aceitar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({
              pending_report_action_id: null,
              email: '',
              password: '',
              signature_modal_title: '',
              signature_modal_subtitle: '',
              signature_modal_confirmation: ''
            });
            self.props.updateData(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'handleSignatureModalCancel',
    value: function handleSignatureModalCancel() {
      this.setState({
        showLogbookSignatureModal: false,
        pending_report_action_id: null,
        email: '',
        password: '',
        signature_modal_title: '',
        signature_modal_subtitle: '',
        signature_modal_confirmation: ''
      });
    }
  }, {
    key: 'reprove',
    value: function reprove(event) {
      event.preventDefault();
      var self = this;
      if (window.confirm('Tem certeza que deseja reprovar?')) {
        self.props.handleAlert('', '', 'open');
        var datasave = {
          aircraft_logbook_approval_id: self.state.reproved_id,
          reason: self.state.reason
        };
        var header = self.refs.request_api.header('application/json');
        var url = '/aeronave/diario/aprovacao/reprovar';
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url, { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({ reason: null, reproved_id: null, modal: false });
            self.props.updateData(responseJson);
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        this.state.pending_captain_acceptances.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'alert alert-warning', role: 'alert' },
          'Existe(m) a\xE7\xE3o(\xF5es) de manuten\xE7\xE3o pendente(s) de aceita\xE7\xE3o do comandante em di\xE1rio(s) anterior(es). Realize as aprova\xE7\xF5es antes de prosseguir.'
        ),
        this.state.pending_captain_acceptances.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'caption',
              null,
              'Maintenance Actions Pending Captain Acceptance'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Item'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Base'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Action'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'System'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Next Mnt Type'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Date'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Hrs Next Mnt'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'RII'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Tools'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Executor'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Inspector'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'RTS'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'RTS Approval'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Captain'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Captain Acceptance'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'pending_report_actions' },
              this.state.pending_captain_acceptances.map(function (action) {
                var systemName = action.system_name || (action.aircraft_logbook_report && action.aircraft_logbook_report.system ? action.aircraft_logbook_report.system.name : '');
                var nextMaintenanceName = action.next_maintenance_intervention_type_name || (action.aircraft_logbook_report && action.aircraft_logbook_report.next_maintenance_intervention_type ? action.aircraft_logbook_report.next_maintenance_intervention_type.type : '');
                var baseAbbreviation = action.base && action.base.abbreviation ? action.base.abbreviation : action.base_name;

                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  { className: 'text-center', key: action.id },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    action.item
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    baseAbbreviation
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    action.action
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    systemName
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    nextMaintenanceName
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    action.date_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    action.flight_hours_next_maintenance_intervention_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    action.mandatory_inspection_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    action.tools_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    action.executor_user_name
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    action.inspector_user_name
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    action.rts_user_name
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    action.rts_approval_date_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    action.captain_user_name
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    action.captain_acceptance_date === null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { onClick: function onClick() {
                          return self.handlePendingAcceptance(action.id);
                        }, className: 'btn btn-success btn-sm button-inline' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' })
                    ) : action.captain_acceptance_date_str
                  )
                );
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-1 text-center' },
            self.state.approval.status === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-success', disabled: true },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' })
            ) : self.state.approval.status === 2 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger', disabled: true },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-close' })
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { onClick: function onClick() {
                    self.setState({ reproved_id: self.state.approval.id, modal: true, type: self.state.approval.type });
                  }, className: 'btn btn-danger button-inline' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-close' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { onClick: self.handleApprove, className: 'btn btn-success button-inline' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-7' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              'Captain Acceptance\xA0'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-4' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'table-responsive' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'table table-bordered table-hover table-striped' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'caption',
                  null,
                  'Approval'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    { className: 'text-center' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      'User'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      'Status'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      'Approval Date'
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  { id: 'crew_approvals' },
                  self.state.approvals.map(function (k) {
                    var approval = k;
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      { className: 'text-center', key: approval.id },
                      typeof approval.user_id !== 'undefined' && approval.user_id !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        approval.user_name
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        approval.status_str
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        approval.approval_date_str
                      )
                    );
                  })
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-12' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              'Crew'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'table-responsive' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'table table-bordered table-hover table-striped' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      'Crew Name'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      'Function'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      'ANAC Code'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      'Arrival Time'
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  null,
                  Object.keys(self.state.staffs).map(function (k) {
                    var staff = self.state.staffs[k];
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      { className: 'text-center', key: staff.id },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        staff.staff.name
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        staff.duty.anac_code
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        staff.staff.canac
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        staff.arrival_str
                      )
                    );
                  })
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              'Justificativa de reprova\xE7\xE3o'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return self.setState({ modal: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.reprove },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Raz\xE3o da reprova\xE7\xE3o:'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'reason', className: 'form-control', placeholder: 'Justifique a sua reprova\xE7\xE3o', value: this.state.reason, onChange: this.handleChange.bind(this, 'reason') })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'submit', className: 'btn btn-danger btn-block btn-inline' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' }),
                    ' Reprovar di\xE1rio de bordo'
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return self.setState({ modal_captain_login: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__LogbookAppIntegration_LogbookSignatureModal__["a" /* default */], {
          show: this.state.showLogbookSignatureModal,
          onHide: this.handleSignatureModalCancel,
          onSubmit: this.handleLogbookSignatureSubmit,
          title: this.state.signature_modal_title,
          subtitle: this.state.signature_modal_subtitle,
          confirmation: this.state.signature_modal_confirmation
        })
      );
    }
  }]);

  return AircraftLogbookCrewTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookCrewTab);

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Importo o moment com a linguagem pt-br
__webpack_require__(24);
__webpack_require__(32);

var AircraftLogbookDashboardReportsTab = function (_Component) {
  _inherits(AircraftLogbookDashboardReportsTab, _Component);

  function AircraftLogbookDashboardReportsTab(props) {
    _classCallCheck(this, AircraftLogbookDashboardReportsTab);

    var _this = _possibleConstructorReturn(this, (AircraftLogbookDashboardReportsTab.__proto__ || Object.getPrototypeOf(AircraftLogbookDashboardReportsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      aircraft_logbook_id: _this.props.aircraft_logbook_id,
      reports: {},
      flight_legs_list: [],
      users_list: [],
      bases_list: [],
      approvals: []
    };
    return _this;
  }

  // Handlers


  _createClass(AircraftLogbookDashboardReportsTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          loaded: 1
        });
      }

      if (typeof newProps.reports !== 'undefined' && newProps.reports !== null) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          reports: newProps.reports
        });
      }

      if (typeof newProps.flight_legs_list !== 'undefined' && newProps.flight_legs_list !== null) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          flight_legs_list: newProps.flight_legs_list
        });
      }

      if (typeof newProps.users_list !== 'undefined' && newProps.users_list !== null) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          users_list: newProps.users_list
        });
      }

      if (typeof newProps.bases_list !== 'undefined' && newProps.bases_list !== null) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          bases_list: newProps.bases_list
        });
      }

      if (typeof newProps.approvals[8] !== 'undefined' && newProps.approvals[8] !== null) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          approvals: newProps.approvals[8]
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title pull-left' },
          'Reports of Crew or Maintenance'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'caption',
              null,
              'Reports'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Item'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Flight Leg'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Location'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Detected By'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Detected At'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'System'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Next Mnt Type'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Hrs Next Mnt'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Description'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Approved By'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Approved At'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'reports' },
              Object.keys(self.state.reports).map(function (k) {
                var report = self.state.reports[k];
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  { className: 'text-center', key: report.id },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report.item
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report.leg
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report.location_name
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report.user_name
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report.date_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report.system_name
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report.next_maintenance_intervention_type_name
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report.flight_hours_next_maintenance_intervention_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report.description
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report.approval_user_name
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report.approval_date_str
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);

  return AircraftLogbookDashboardReportsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookDashboardReportsTab);

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_input_mask__);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário



// Importo o moment com a linguagem pt-br
__webpack_require__(24);
__webpack_require__(32);

var AircraftLogbookEngineSpecialCountersTab = function (_Component) {
  _inherits(AircraftLogbookEngineSpecialCountersTab, _Component);

  function AircraftLogbookEngineSpecialCountersTab(props) {
    _classCallCheck(this, AircraftLogbookEngineSpecialCountersTab);

    var _this = _possibleConstructorReturn(this, (AircraftLogbookEngineSpecialCountersTab.__proto__ || Object.getPrototypeOf(AircraftLogbookEngineSpecialCountersTab)).call(this, props));

    _this.handleChangeDecimal = function (name, event) {
      var _this$setState;

      var rawInputValue = _this.state.rawInputValue;

      var inputValue = event.target.value;

      // Se o input estiver vazio, limpa rawInputValue
      if (inputValue === '') {
        rawInputValue = '';
      } else if (/^\d+$/.test(inputValue)) {
        // Se for um número inteiro, atualiza rawInputValue
        rawInputValue = inputValue;
      } else {
        var newChar = inputValue.slice(-1);

        // Verifica se o novo caractere é um número, um ponto decimal ou uma vírgula
        if (!/^[0-9.,]$/.test(newChar)) {
          // Caractere inválido, não faz nada
          return;
        }

        // Substitui vírgula por ponto
        if (newChar === ',') {
          newChar = '.';
        }

        // Verifica se já existe um ponto decimal
        var hasDecimal = rawInputValue.includes('.');

        // Impede que "0" seja o primeiro dígito
        if (rawInputValue === '' && newChar === '0') {
          return;
        }

        // Determina se está adicionando ou removendo um caractere
        if (event.nativeEvent.inputType === 'deleteContentBackward') {
          // Removendo um caractere
          rawInputValue = rawInputValue.slice(0, -1);
        } else if (hasDecimal && newChar !== '.') {
          // Substitui o dígito após o ponto decimal
          var parts = rawInputValue.split('.');
          parts[1] = newChar;
          rawInputValue = parts.join('.');
        } else {
          // Adicionando um caractere
          rawInputValue += newChar;
        }
      }

      // Formata o valor para exibição com base em rawInputValue
      var formattedValue = _this.formatInputValue(rawInputValue);

      // Atualiza o estado
      _this.setState((_this$setState = {}, _defineProperty(_this$setState, name, formattedValue), _defineProperty(_this$setState, 'rawInputValue', rawInputValue), _this$setState));
    };

    _this.handleChangePreviousDecimal = function (name, event) {
      var _this$setState2;

      var rawInputValue = _this.state.rawInputValuePrevious;

      var inputValue = event.target.value;

      // Se o input estiver vazio, limpa rawInputValue
      if (inputValue === '') {
        rawInputValue = '';
      } else if (/^\d+$/.test(inputValue)) {
        // Se for um número inteiro, atualiza rawInputValue
        rawInputValue = inputValue;
      } else {
        var newChar = inputValue.slice(-1);

        // Verifica se o novo caractere é um número, um ponto decimal ou uma vírgula
        if (!/^[0-9.,]$/.test(newChar)) {
          // Caractere inválido, não faz nada
          return;
        }

        // Substitui vírgula por ponto
        if (newChar === ',') {
          newChar = '.';
        }

        // Verifica se já existe um ponto decimal
        var hasDecimal = rawInputValue.includes('.');

        // Impede que "0" seja o primeiro dígito
        if (rawInputValue === '' && newChar === '0') {
          return;
        }

        // Determina se está adicionando ou removendo um caractere
        if (event.nativeEvent.inputType === 'deleteContentBackward') {
          // Removendo um caractere
          rawInputValue = rawInputValue.slice(0, -1);
        } else if (hasDecimal && newChar !== '.') {
          // Substitui o dígito após o ponto decimal
          var parts = rawInputValue.split('.');
          parts[1] = newChar;
          rawInputValue = parts.join('.');
        } else {
          // Adicionando um caractere
          rawInputValue += newChar;
        }
      }

      // Formata o valor para exibição com base em rawInputValue
      var formattedValue = _this.formatInputValue(rawInputValue);

      // Atualiza o estado
      _this.setState((_this$setState2 = {}, _defineProperty(_this$setState2, name, formattedValue), _defineProperty(_this$setState2, 'rawInputValuePrevious', rawInputValue), _this$setState2));
    };

    _this.formatInputValue = function (rawValue) {
      if (!rawValue) {
        return '';
      }

      var _rawValue$split = rawValue.split('.'),
          _rawValue$split2 = _slicedToArray(_rawValue$split, 2),
          inteiro = _rawValue$split2[0],
          decimal = _rawValue$split2[1];

      // Ajusta a parte decimal para sempre ter um dígito


      decimal = decimal && decimal.length > 0 ? decimal[0] : '0';

      return inteiro + '.' + decimal;
    };

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      aircraft_logbook_id: _this.props.aircraft_logbook_id,
      special_counters: [],
      rawInputValue: '',
      rawInputValuePrevious: ''
    };
    _this.edit = _this.edit.bind(_this);
    return _this;
  }

  _createClass(AircraftLogbookEngineSpecialCountersTab, [{
    key: 'handleChange',


    // Handlers
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          loaded: 1
        });
      }

      if (typeof newProps.special_counters['version'] !== 'undefined' && newProps.special_counters['version'] !== null && this.state.loaded === 1) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          special_counters: newProps.special_counters['version']
        });
      }
    }

    // Fetch salvando a edição

  }, {
    key: 'edit',
    value: function edit(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: this.state.edit_id,
        previous_logbook: this.state.previous_logbook,
        actual_logbook: this.state.actual_logbook
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/contadores/especiais/voos', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'showModalEdit',
    value: function showModalEdit(counter, event) {
      this.setState({
        edit_id: counter.id,
        previous_logbook: counter.previous_logbook_str,
        actual_logbook: counter.actual_logbook_str,
        rawInputValuePrevious: counter.previous_logbook_decimal,
        rawInputValue: counter.actual_logbook_decimal,
        field_type: counter.field_type,
        modal_edit: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title pull-left' },
          'Engines Special Counters'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { width: '70px' },
                  'Engine'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { width: '150px' },
                  'Counter'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { width: '100px' },
                  'Previous'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { width: '100px' },
                  'Actual'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { width: '100px' },
                  'Total'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { width: '100px' },
                  'Actions'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              null,
              self.state.special_counters.map(function (k) {
                var counter = k;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  { className: 'text-center', key: counter.id },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { width: '70px' },
                    counter.engine_position
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { width: '150px' },
                    counter.counter
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { width: '100px' },
                    counter.previous_logbook_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { width: '100px' },
                    counter.actual_logbook_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { width: '100px' },
                    counter.total_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { width: '100px', className: 'text-center' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { onClick: self.showModalEdit.bind(self, counter), className: 'btn btn-primary btn-sm' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-pencil' })
                    )
                  )
                );
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal_edit, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              'Engine Special Counter'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ modal_edit: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.edit },
              this.state.field_type === 'decimal' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Previous Logbook:'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'form-control', value: this.state.previous_logbook, name: 'previous_logbook', onChange: this.handleChangePreviousDecimal.bind(this, 'previous_logbook'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Actual Logbook:'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: this.state.actual_logbook, name: 'actual_logbook', className: 'form-control', onChange: this.handleChangeDecimal.bind(this, 'actual_logbook'), placeholder: '' })
                )
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Previous Logbook:'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { required: true, value: this.state.previous_logbook, name: 'previous_logbook', className: 'form-control', onChange: this.handleChange.bind(this, 'previous_logbook'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Actual Logbook:'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { required: true, value: this.state.actual_logbook, name: 'actual_logbook', className: 'form-control', onChange: this.handleChange.bind(this, 'actual_logbook'), placeholder: '' })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'submit', className: 'btn btn-primary btn-block' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                  ' Save'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ modal_edit: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return AircraftLogbookEngineSpecialCountersTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookEngineSpecialCountersTab);

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(16);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário



// Importo o moment com a linguagem pt-br
__webpack_require__(24);
__webpack_require__(32);

var AircraftLogbookEquipmentSpecialCountersTab = function (_Component) {
  _inherits(AircraftLogbookEquipmentSpecialCountersTab, _Component);

  function AircraftLogbookEquipmentSpecialCountersTab(props) {
    _classCallCheck(this, AircraftLogbookEquipmentSpecialCountersTab);

    var _this = _possibleConstructorReturn(this, (AircraftLogbookEquipmentSpecialCountersTab.__proto__ || Object.getPrototypeOf(AircraftLogbookEquipmentSpecialCountersTab)).call(this, props));

    _this.handleChangeDecimal = function (name, event) {
      var _this$setState;

      var rawInputValue = _this.state.rawInputValue;

      var inputValue = event.target.value;

      // Se o input estiver vazio, limpa rawInputValue
      if (inputValue === '') {
        rawInputValue = '';
      } else if (/^\d+$/.test(inputValue)) {
        // Se for um número inteiro, atualiza rawInputValue
        rawInputValue = inputValue;
      } else {
        var newChar = inputValue.slice(-1);

        // Verifica se o novo caractere é um número, um ponto decimal ou uma vírgula
        if (!/^[0-9.,]$/.test(newChar)) {
          // Caractere inválido, não faz nada
          return;
        }

        // Substitui vírgula por ponto
        if (newChar === ',') {
          newChar = '.';
        }

        // Verifica se já existe um ponto decimal
        var hasDecimal = rawInputValue.includes('.');

        // Impede que "0" seja o primeiro dígito
        if (rawInputValue === '' && newChar === '0') {
          return;
        }

        // Determina se está adicionando ou removendo um caractere
        if (event.nativeEvent.inputType === 'deleteContentBackward') {
          // Removendo um caractere
          rawInputValue = rawInputValue.slice(0, -1);
        } else if (hasDecimal && newChar !== '.') {
          // Substitui o dígito após o ponto decimal
          var parts = rawInputValue.split('.');
          parts[1] = newChar;
          rawInputValue = parts.join('.');
        } else {
          // Adicionando um caractere
          rawInputValue += newChar;
        }
      }

      // Formata o valor para exibição com base em rawInputValue
      var formattedValue = _this.formatInputValue(rawInputValue);

      // Atualiza o estado
      _this.setState((_this$setState = {}, _defineProperty(_this$setState, name, formattedValue), _defineProperty(_this$setState, 'rawInputValue', rawInputValue), _this$setState));
    };

    _this.handleChangePreviousDecimal = function (name, event) {
      var _this$setState2;

      var rawInputValue = _this.state.rawInputValuePrevious;

      var inputValue = event.target.value;

      // Se o input estiver vazio, limpa rawInputValue
      if (inputValue === '') {
        rawInputValue = '';
      } else if (/^\d+$/.test(inputValue)) {
        // Se for um número inteiro, atualiza rawInputValue
        rawInputValue = inputValue;
      } else {
        var newChar = inputValue.slice(-1);

        // Verifica se o novo caractere é um número, um ponto decimal ou uma vírgula
        if (!/^[0-9.,]$/.test(newChar)) {
          // Caractere inválido, não faz nada
          return;
        }

        // Substitui vírgula por ponto
        if (newChar === ',') {
          newChar = '.';
        }

        // Verifica se já existe um ponto decimal
        var hasDecimal = rawInputValue.includes('.');

        // Impede que "0" seja o primeiro dígito
        if (rawInputValue === '' && newChar === '0') {
          return;
        }

        // Determina se está adicionando ou removendo um caractere
        if (event.nativeEvent.inputType === 'deleteContentBackward') {
          // Removendo um caractere
          rawInputValue = rawInputValue.slice(0, -1);
        } else if (hasDecimal && newChar !== '.') {
          // Substitui o dígito após o ponto decimal
          var parts = rawInputValue.split('.');
          parts[1] = newChar;
          rawInputValue = parts.join('.');
        } else {
          // Adicionando um caractere
          rawInputValue += newChar;
        }
      }

      // Formata o valor para exibição com base em rawInputValue
      var formattedValue = _this.formatInputValue(rawInputValue);

      // Atualiza o estado
      _this.setState((_this$setState2 = {}, _defineProperty(_this$setState2, name, formattedValue), _defineProperty(_this$setState2, 'rawInputValuePrevious', rawInputValue), _this$setState2));
    };

    _this.formatInputValue = function (rawValue) {
      if (!rawValue) {
        return '';
      }

      var _rawValue$split = rawValue.split('.'),
          _rawValue$split2 = _slicedToArray(_rawValue$split, 2),
          inteiro = _rawValue$split2[0],
          decimal = _rawValue$split2[1];

      // Ajusta a parte decimal para sempre ter um dígito


      decimal = decimal && decimal.length > 0 ? decimal[0] : '0';

      return inteiro + '.' + decimal;
    };

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      aircraft_logbook_id: _this.props.aircraft_logbook_id,
      special_counters: [],
      rawInputValue: '',
      rawInputValuePrevious: ''
    };
    _this.edit = _this.edit.bind(_this);
    _this.showModalEdit = _this.showModalEdit.bind(_this);
    return _this;
  }

  _createClass(AircraftLogbookEquipmentSpecialCountersTab, [{
    key: 'handleChange',


    // Handlers
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          loaded: 1
        });
      }

      if (typeof newProps.special_counters['model'] !== 'undefined' && newProps.special_counters['model'] !== null && this.state.loaded === 1) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          special_counters: newProps.special_counters['model']
        });
      }
    }

    // Fetch salvando a edição

  }, {
    key: 'edit',
    value: function edit(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: this.state.edit_id,
        previous_logbook: this.state.previous_logbook,
        actual_logbook: this.state.actual_logbook
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/contadores/especiais/voos', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'showModalEdit',
    value: function showModalEdit(counter, event) {
      this.setState({
        edit_id: counter.id,
        previous_logbook: counter.previous_logbook_str,
        actual_logbook: counter.actual_logbook_str,
        rawInputValuePrevious: counter.previous_logbook_decimal,
        rawInputValue: counter.actual_logbook_decimal,
        field_type: counter.field_type,
        modal_edit: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title pull-left' },
          'Equipment\'s Special Counters'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Counter'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Previous'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Actual'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Total'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Actions'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              null,
              self.state.special_counters.map(function (k) {
                var counter = k;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  { className: 'text-center', key: counter.id },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    counter.counter
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    counter.previous_logbook_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    counter.actual_logbook_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    counter.total_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { onClick: self.showModalEdit.bind(self, counter), className: 'btn btn-primary btn-sm' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-pencil' })
                    )
                  )
                );
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal_edit, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              'Engine Special Counter'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ modal_edit: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.edit },
              this.state.field_type === 'decimal' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Previous Logbook:'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'form-control', value: this.state.previous_logbook, name: 'previous_logbook', onChange: this.handleChangePreviousDecimal.bind(this, 'previous_logbook'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Actual Logbook:'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: this.state.actual_logbook, name: 'actual_logbook', className: 'form-control', onChange: this.handleChangeDecimal.bind(this, 'actual_logbook'), placeholder: '' })
                )
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Previous Logbook:'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { required: true, value: this.state.previous_logbook, name: 'previous_logbook', className: 'form-control', onChange: this.handleChange.bind(this, 'previous_logbook'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Actual Logbook:'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { required: true, value: this.state.actual_logbook, name: 'actual_logbook', className: 'form-control', onChange: this.handleChange.bind(this, 'actual_logbook'), placeholder: '' })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'submit', className: 'btn btn-primary btn-block' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                  ' Save'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ modal_edit: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return AircraftLogbookEquipmentSpecialCountersTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookEquipmentSpecialCountersTab);

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário




// Importo o moment com a linguagem pt-br
__webpack_require__(24);
__webpack_require__(32);

var AircraftLogbookFlightsTab = function (_Component) {
  _inherits(AircraftLogbookFlightsTab, _Component);

  function AircraftLogbookFlightsTab(props) {
    _classCallCheck(this, AircraftLogbookFlightsTab);

    var _this = _possibleConstructorReturn(this, (AircraftLogbookFlightsTab.__proto__ || Object.getPrototypeOf(AircraftLogbookFlightsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      aircraft_logbook_id: _this.props.aircraft_logbook_id,
      aircraft: {},
      approvals: [],
      flight_reports_list: [],
      flights: {},
      aircraft_model_version_custom_items: {}
    };
    _this.add = _this.add.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(AircraftLogbookFlightsTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          loaded: 1
        });
      }

      if (typeof newProps.aircraft !== 'undefined' && newProps.aircraft !== null && this.state.loaded === 1) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          aircraft: newProps.aircraft
        });
      }

      if (typeof newProps.flights !== 'undefined' && newProps.flights !== null && this.state.loaded === 1) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          flights: newProps.flights
        });
      }

      if (typeof newProps.aircraft_model_version_custom_items !== 'undefined' && newProps.aircraft_model_version_custom_items !== null && this.state.loaded === 1) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          aircraft_model_version_custom_items: newProps.aircraft_model_version_custom_items
        });
      }

      if (typeof newProps.flight_reports_list !== 'undefined' && newProps.flight_reports_list !== null && this.state.loaded === 1) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          flight_reports_list: newProps.flight_reports_list
        });
      }

      if (typeof newProps.approvals[4] !== 'undefined' && newProps.approvals[4] !== null && this.state.loaded === 1) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          approvals: newProps.approvals[4]
        });
      }
    }

    // Fetch cadastrando o voo

  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var datasave = {
        aircraft_logbook_id: this.state.aircraft_logbook_id,
        flight_report_id: this.state.flight_report_id
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      var url = '/aeronave/diario/voos';
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url, { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
          self.setState({
            flight_report_id: ''
          });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title pull-left' },
          'Flights'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'ST'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'RV'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'FROM'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'TO'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'START'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'TAKE OFF'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'LANDING'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'SHUTDOWN'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'NIGHT TIME'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'IFR'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'LDG'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'TOTAL TO-LDG'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'TOTAL ST/SHT'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'START FUEL'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'FINAL FUEL'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'POB'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'CARGO'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 2, className: 'text-center vcenter' },
                  'HOOK OPER'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'FLIGHT TYPE'
                ),
                Object.keys(self.state.aircraft_model_version_custom_items).length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: Object.keys(self.state.aircraft_model_version_custom_items).length, className: 'text-center vcenter' },
                  'CUSTOM ITEMS'
                ) : '',
                self.state.aircraft.hums == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 2, className: 'text-center vcenter' },
                  'HUMS ALERTS'
                ) : ''
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'HRS'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'CYC'
                ),
                Object.keys(self.state.aircraft_model_version_custom_items).length > 0 ? Object.keys(self.state.aircraft_model_version_custom_items).map(function (k) {
                  var custom_item = self.state.aircraft_model_version_custom_items[k];
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    { className: 'text-center vcenter' },
                    custom_item.name
                  );
                }) : '',
                self.state.aircraft.hums == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'STATUS'
                ) : '',
                self.state.aircraft.hums == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'CONFIRMED'
                ) : ''
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              null,
              Object.keys(self.state.flights).map(function (k) {
                var flight = self.state.flights[k];
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  { className: 'text-center', key: flight.id },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    flight.id
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    flight.flight_report_id
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    flight.departure_location.icao_code
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    flight.arrival_location.icao_code
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    flight.engine_start_time_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    flight.takeoff_time_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    flight.landing_time_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    flight.engine_shutoff_time_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    flight.night_time_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    flight.ifr_time_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    flight.day_landings + flight.night_landings
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    flight.takeoff_landing_time_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    flight.total_time_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    flight.fuel_start
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    flight.fuel_end
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    flight.pax + flight.flight_report_leg_staffs.length
                  ),
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    flight.payload
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    flight.external_load_time
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    flight.external_load_cycles
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    flight.flight_report.flight_type.anac_code
                  ),
                  Object.keys(self.state.aircraft_model_version_custom_items).length > 0 && Object.keys(flight.flight_report_leg_custom_items).length > 0 ? Object.keys(flight.flight_report_leg_custom_items).map(function (k) {
                    var custom_item = flight.flight_report_leg_custom_items[k];
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      custom_item.value
                    );
                  }) : Object.keys(self.state.aircraft_model_version_custom_items).length > 0 ? Object.keys(self.state.aircraft_model_version_custom_items).map(function (k) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null);
                  }) : '',
                  self.state.aircraft.hums == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    flight.hums_status
                  ) : '',
                  self.state.aircraft.hums == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    flight.hums_confirmed_str
                  ) : ''
                );
              })
            )
          )
        )
      );
    }
  }]);

  return AircraftLogbookFlightsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookFlightsTab);

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário


// Importo o moment com a linguagem pt-br
__webpack_require__(24);
__webpack_require__(32);

var AircraftLogbookFluidsRefilTab = function (_Component) {
  _inherits(AircraftLogbookFluidsRefilTab, _Component);

  function AircraftLogbookFluidsRefilTab(props) {
    _classCallCheck(this, AircraftLogbookFluidsRefilTab);

    var _this = _possibleConstructorReturn(this, (AircraftLogbookFluidsRefilTab.__proto__ || Object.getPrototypeOf(AircraftLogbookFluidsRefilTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      fluids_refils: {},
      aircraft_logbook_id: _this.props.aircraft_logbook_id,
      aircraft_logbook_flight_id: '',
      fluid_refill_id: '',
      qty: '',
      unity: '',
      fluid_refill_option: null,
      type: 'select',
      flight_legs_list: [],
      approvals: []
    };
    _this.add = _this.add.bind(_this);
    _this.delete = _this.delete.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(AircraftLogbookFluidsRefilTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          loaded: 1
        });
      }

      if (typeof newProps.fluids_refils !== 'undefined' && newProps.fluids_refils !== null && this.state.loaded === 1) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          fluids_refils: newProps.fluids_refils
        });
      }

      if (typeof newProps.fluids_refills_list !== 'undefined' && newProps.fluids_refills_list !== null && this.state.loaded === 1) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          fluids_refills_list: newProps.fluids_refills_list
        });
      }

      if (typeof newProps.flight_legs_list !== 'undefined' && newProps.flight_legs_list !== null && this.state.loaded === 1) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          flight_legs_list: newProps.flight_legs_list
        });
      }

      if (typeof newProps.approvals[6] !== 'undefined' && newProps.approvals[6] !== null && this.state.loaded === 1) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          approvals: newProps.approvals[6]
        });
      }
    }

    // Fetch salvando a edição

  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var datasave = {
        aircraft_logbook_id: this.state.aircraft_logbook_id,
        aircraft_logbook_flight_id: this.state.aircraft_logbook_flight_id,
        fluid_refill_id: this.state.fluid_refill_id,
        qty: this.state.qty,
        unity: this.state.unity,
        type: this.state.type,
        fluid_refill_option: this.state.fluid_refill_option
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/fluidos', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
          self.setState({
            aircraft_logbook_flight_id: '',
            fluid_refill_id: '',
            qty: '',
            unity: ''
          });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'delete',
    value: function _delete(id) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/fluido/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'changeInput',
    value: function changeInput(type) {
      this.setState({
        type: type
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title pull-left' },
          'Fluids Refill'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: this.add },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Flight Leg:'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], {
                  className: 'form-group',
                  name: 'aircraft_logbook_flight_id',
                  value: this.state.aircraft_logbook_flight_id,
                  searchable: true,
                  placeholder: 'Select leg',
                  onChange: this.handleSelectChange.bind(this, 'aircraft_logbook_flight_id'),
                  options: this.state.flight_legs_list,
                  required: true
                })
              )
            ),
            this.state.type === 'input' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'New system option: ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', onClick: function onClick() {
                        self.changeInput('select');
                      }, className: 'btn btn-xs btn-info' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-refresh' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'fluid_refill_option', className: 'form-control', placeholder: '', value: this.state.fluid_refill_option, onChange: this.handleChange.bind(this, 'fluid_refill_option'), required: true })
              )
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'System: ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', onClick: function onClick() {
                        self.changeInput('input');
                      }, className: 'btn btn-xs btn-info' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-plus' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], {
                  className: 'form-group',
                  name: 'fluid_refill_id',
                  value: this.state.fluid_refill_id,
                  searchable: true,
                  placeholder: 'System options',
                  onChange: this.handleSelectChange.bind(this, 'fluid_refill_id'),
                  options: this.state.fluids_refills_list,
                  required: true
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Qty:'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', value: this.state.qty, name: 'qty', onChange: this.handleChange.bind(this, 'qty'), placeholder: 'Quantidade abastecida', required: true })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Unity:'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], {
                  className: 'form-group',
                  name: 'unity',
                  value: this.state.unity,
                  searchable: true,
                  placeholder: '',
                  onChange: this.handleSelectChange.bind(this, 'unity'),
                  options: [{ value: "liters", label: "Liters" }, { value: "milliliters", label: "Milliliters" }, { value: "gallons", label: "Gallons" }],
                  required: true
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-12' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'submit', className: 'btn btn-block btn-primary' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                  ' Cadastrar'
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'caption',
              null,
              'Fluids Refill'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                { className: 'text-center' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Flight Leg'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'System'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Qty'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Unity'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Actions'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'fluids_refils' },
              Object.keys(self.state.fluids_refils).map(function (k) {
                var fluid_refil = self.state.fluids_refils[k];
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  { className: 'text-center', key: fluid_refil.id },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    fluid_refil.leg
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    fluid_refil.fluid_refill.name
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    fluid_refil.qty
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    fluid_refil.unity_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { onClick: function onClick() {
                            self.delete(fluid_refil.id);
                          }, className: 'btn btn-danger btn-sm' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-trash' })
                      )
                    )
                  )
                );
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'caption',
              null,
              'Approval'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                { className: 'text-center' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'User'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Status'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Approval Date'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Actions'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'fluids_refil_approvals' },
              self.state.approvals.map(function (k) {
                var approval = k;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  { className: 'text-center', key: approval.id },
                  typeof approval.user_id !== 'undefined' && approval.user_id !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    approval.user_name
                  ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    approval.status_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    approval.approval_date_str
                  ),
                  approval.status === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { className: 'btn btn-success btn-sm', disabled: true },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' })
                      )
                    )
                  ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { onClick: function onClick() {
                            self.props.approve(approval.id, approval.type);
                          }, className: 'btn btn-success btn-sm' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' })
                      )
                    )
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);

  return AircraftLogbookFluidsRefilTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookFluidsRefilTab);

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(16);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário





// Importo o moment com a linguagem pt-br
__webpack_require__(24);
__webpack_require__(32);

var AircraftLogbookHumsTab = function (_Component) {
  _inherits(AircraftLogbookHumsTab, _Component);

  function AircraftLogbookHumsTab(props) {
    _classCallCheck(this, AircraftLogbookHumsTab);

    var _this = _possibleConstructorReturn(this, (AircraftLogbookHumsTab.__proto__ || Object.getPrototypeOf(AircraftLogbookHumsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      hums: [],
      st: '',
      flight_report_leg_id: '',
      absence: false,
      red: false,
      yellow: false,
      failure: false,
      not_read: false,
      not_installed: false,
      na: false,
      confirmed_na: false,
      confirmed_unknown: false,
      confirmed_false: false,
      confirmed_real: false,
      hum_status: '',
      hums_confirmed: '',
      hums_approval_date: '',
      hums_approval_user_id: '',
      hums_user_name: '',
      hums_justification: '',
      hums_justification_input: '',
      modal_justification: false,
      pending_status_choice: null
    };
    _this.handleNaJustificationChange = _this.handleNaJustificationChange.bind(_this);
    _this.closeJustificationModal = _this.closeJustificationModal.bind(_this);
    _this.confirmNaJustification = _this.confirmNaJustification.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(AircraftLogbookHumsTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleCheckboxChange',
    value: function handleCheckboxChange(name, event) {
      if (name === 'na') {
        if (!event || event.target.checked === true) {
          this.setState({
            modal_justification: true,
            pending_status_choice: 'na',
            hums_justification_input: this.state.hums_justification || ''
          });
        }
        return;
      }

      var change = {};
      if (this.state.hums_status && typeof this.state[this.state.hums_status] !== 'undefined') {
        change[this.state.hums_status] = false;
      }

      if (event == null || event && event.target.checked === true) {
        change[name] = true;
        change['hums_status'] = name;
        change['na'] = false;
        change['hums_justification'] = '';
        change['hums_justification_input'] = '';
        change['pending_status_choice'] = null;
        this.setState(change);
        this.props.editHums(this.state.flight_report_leg_id, name, this.state.hums_confirmed, null);
      }
    }
  }, {
    key: 'handleCheckboxChangeConfirmed',
    value: function handleCheckboxChangeConfirmed(name, event) {
      // valor selecionado. Valor são true e false
      var value = event.target.checked;
      var change = {};
      if (event == null) {
        change[name] = true;
      } else {
        change[this.state.hums_confirmed] = false;
        change[name] = true;
        change['hums_confirmed'] = name;
      }
      this.setState(change);
      this.props.editHums(this.state.flight_report_leg_id, this.state.hums_status, name, this.state.hums_justification);
    }
  }, {
    key: 'handleNaJustificationChange',
    value: function handleNaJustificationChange(event) {
      this.setState({ hums_justification_input: event.target.value });
    }
  }, {
    key: 'closeJustificationModal',
    value: function closeJustificationModal() {
      this.setState({
        modal_justification: false,
        pending_status_choice: null,
        hums_justification_input: ''
      });
    }
  }, {
    key: 'confirmNaJustification',
    value: function confirmNaJustification() {
      var _this2 = this;

      var justification = (this.state.hums_justification_input || '').trim();
      if (!justification) {
        if (typeof this.props.handleAlert === 'function') {
          this.props.handleAlert('Justificativa obrigatória para marcar HUMS como N/A.', 'error', 'open');
        }
        return;
      }

      var change = {};
      if (this.state.hums_status && this.state.hums_status !== 'na' && typeof this.state[this.state.hums_status] !== 'undefined') {
        change[this.state.hums_status] = false;
      }

      change['na'] = true;
      change['hums_status'] = 'na';
      change['hums_justification'] = justification;
      change['modal_justification'] = false;
      change['pending_status_choice'] = null;
      change['hums_justification_input'] = '';

      this.setState(change, function () {
        _this2.props.editHums(_this2.state.flight_report_leg_id, 'na', _this2.state.hums_confirmed, justification);
      });
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (typeof newProps.hums !== 'undefined' && newProps.hums !== null && this.state.loaded === 0) {
        var change = {};
        if (newProps.hums.hums_status) {
          change[newProps.hums.hums_status] = true;
          if (newProps.hums.hums_status !== 'na') {
            change['na'] = false;
          }
        }
        if (newProps.hums.hums_confirmed) {
          change[newProps.hums.hums_confirmed] = true;
        }
        this.setState(change);
        this.setState({
          loaded: 1,
          hums: newProps.hums,
          st: newProps.hums.st,
          flight_report_leg_id: newProps.hums.flight_report_leg_id,
          hums_status: newProps.hums.hums_status,
          hums_confirmed: newProps.hums.hums_confirmed,
          hums_approval_date: newProps.hums.hums_approval_date,
          hums_approval_user_id: newProps.hums.hums_approval_user_id,
          hums_user_name: newProps.hums.hums_user_name,
          hums_justification: newProps.hums.hums_justification || '',
          na: newProps.hums.hums_status === 'na'
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'tr',
        { className: 'text-center', key: this.state.flight_report_leg_id },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'st', className: 'form-control text-center', value: this.state.st, disabled: true })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                    name: 'absence',
                    type: 'checkbox',
                    checked: this.state.absence,
                    onChange: this.handleCheckboxChange.bind(this, 'absence')
                  }),
                  '\xA0 Absence'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                    name: 'red',
                    type: 'checkbox',
                    checked: this.state.red,
                    onChange: this.handleCheckboxChange.bind(this, 'red')
                  }),
                  '\xA0 Red'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                    name: 'yellow',
                    type: 'checkbox',
                    checked: this.state.yellow,
                    onChange: this.handleCheckboxChange.bind(this, 'yellow')
                  }),
                  '\xA0 Yellow'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                    name: 'na',
                    type: 'checkbox',
                    checked: this.state.na,
                    onChange: this.handleCheckboxChange.bind(this, 'na')
                  }),
                  '\xA0 N/A'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                    name: 'failure',
                    type: 'checkbox',
                    checked: this.state.failure,
                    onChange: this.handleCheckboxChange.bind(this, 'failure')
                  }),
                  '\xA0 Failure'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                    name: 'not_read',
                    type: 'checkbox',
                    checked: this.state.not_read,
                    onChange: this.handleCheckboxChange.bind(this, 'not_read')
                  }),
                  '\xA0 Not Read'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                    name: 'not_installed',
                    type: 'checkbox',
                    checked: this.state.not_installed,
                    onChange: this.handleCheckboxChange.bind(this, 'not_installed')
                  }),
                  '\xA0 Not Installed'
                )
              )
            )
          ),
          this.state.hums_status === 'na' && this.state.hums_justification ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-12 text-left' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'small',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  'Justificativa:'
                ),
                ' ',
                this.state.hums_justification
              )
            )
          ) : null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */],
            { show: this.state.modal_justification, 'aria-labelledby': 'hums-na-justification-modal', bsSize: 'large', onHide: this.closeJustificationModal },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Header,
              { closeButton: true },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Title,
                { id: 'hums-na-justification-modal' },
                'Justificativa para N/A'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Body,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Informe a justificativa'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', {
                  className: 'form-control',
                  value: this.state.hums_justification_input,
                  onChange: this.handleNaJustificationChange,
                  rows: 4
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Footer,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'button', className: 'btn btn-default', onClick: this.closeJustificationModal },
                'Cancelar'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'button', className: 'btn btn-primary', onClick: this.confirmNaJustification },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                ' Confirmar'
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                    name: 'confirmed_unknown',
                    type: 'checkbox',
                    checked: this.state.confirmed_unknown,
                    onChange: this.handleCheckboxChangeConfirmed.bind(this, 'confirmed_unknown')
                  }),
                  '\xA0 Unknown'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                    name: 'confirmed_na',
                    type: 'checkbox',
                    checked: this.state.confirmed_na,
                    onChange: this.handleCheckboxChangeConfirmed.bind(this, 'confirmed_na')
                  }),
                  '\xA0 N/A'
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                    name: 'confirmed_false',
                    type: 'checkbox',
                    checked: this.state.confirmed_false,
                    onChange: this.handleCheckboxChangeConfirmed.bind(this, 'confirmed_false')
                  }),
                  '\xA0 False'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                    name: 'confirmed_real',
                    type: 'checkbox',
                    checked: this.state.confirmed_real,
                    onChange: this.handleCheckboxChangeConfirmed.bind(this, 'confirmed_real')
                  }),
                  '\xA0 Real'
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'hums_user_name', className: 'form-control text-center', value: this.state.hums_user_name, disabled: true })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'hums_approval_date', className: 'form-control text-center', value: this.state.hums_approval_date, disabled: true })
        )
      );
    }
  }]);

  return AircraftLogbookHumsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookHumsTab);

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário





var AircraftLogbookLogsTab = function (_Component) {
  _inherits(AircraftLogbookLogsTab, _Component);

  function AircraftLogbookLogsTab(props) {
    _classCallCheck(this, AircraftLogbookLogsTab);

    var _this = _possibleConstructorReturn(this, (AircraftLogbookLogsTab.__proto__ || Object.getPrototypeOf(AircraftLogbookLogsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      aircraft_logbook_logs: {}
    };

    // Handlers
    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();

    return _this;
  }

  // LM


  _createClass(AircraftLogbookLogsTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.aircraft_logbook_logs) || this.state.loaded === 1 && newProps.updated === 1) {
        this.setState({
          aircraft_logbook_logs: newProps.aircraft_logbook_logs,
          loaded: 1
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'page-title' },
            'Logs de altera\xE7\xF5es'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'table-responsive' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'table',
              { className: 'table table-bordered table-hover table-striped' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'thead',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    'Usuario'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    'Acao'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    'Descricao'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    'Data'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tbody',
                null,
                Object.keys(self.state.aircraft_logbook_logs).map(function (k) {
                  var srl = self.state.aircraft_logbook_logs[k];
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      srl.user_name
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      srl.action
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      srl.message
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      srl.created_at_str
                    )
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);

  return AircraftLogbookLogsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookLogsTab);

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário


// Importo o moment com a linguagem pt-br
__webpack_require__(24);
__webpack_require__(32);

var AircraftLogbookMaintenanceOperationalRestrictionTable = function (_Component) {
    _inherits(AircraftLogbookMaintenanceOperationalRestrictionTable, _Component);

    function AircraftLogbookMaintenanceOperationalRestrictionTable(props) {
        _classCallCheck(this, AircraftLogbookMaintenanceOperationalRestrictionTable);

        var _this = _possibleConstructorReturn(this, (AircraftLogbookMaintenanceOperationalRestrictionTable.__proto__ || Object.getPrototypeOf(AircraftLogbookMaintenanceOperationalRestrictionTable)).call(this, props));

        _this.state = {
            overlay: {
                message: '',
                type: '',
                status: 'closed'
            },
            redirect_url: false,
            loaded: 0,
            report_action: props.report_action,
            overload_analysis_str: '',
            correlation_analysis_str: '',
            limit_date_str: '',
            approval_date_str: '',
            status_str: '',
            overload_analysis: props.report_action.overload_analysis
        };

        _this.approve = _this.approve.bind(_this);
        return _this;
    }

    // Handlers


    _createClass(AircraftLogbookMaintenanceOperationalRestrictionTable, [{
        key: 'handleChange',
        value: function handleChange(name, event) {
            var change = {};
            change[name] = event.target.value;
            this.setState(change);
        }
    }, {
        key: 'handleSelectChange',
        value: function handleSelectChange(name, event) {
            var change = {};
            if (event == null) {
                change[name] = null;
            } else {
                change[name] = event.value;
            }
            this.setState(change);
        }

        // LM

    }, {
        key: 'approve',
        value: function approve() {
            this.props.approveDeferredItem(this.state.report_action.id, this.state.overload_analysis);
        }
    }, {
        key: 'render',
        value: function render() {
            var self = this;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                { className: 'text-center', key: this.state.report_action.id },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { width: '100' },
                    this.state.report_action.item_number
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { width: '100' },
                    this.state.report_action.mel
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { width: '100' },
                    this.state.report_action.category
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { width: '100' },
                    this.state.report_action.type_str
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { width: '100' },
                    this.state.report_action.limit_type_str
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { width: '100' },
                    this.state.report_action.limit
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { width: '100' },
                    this.state.report_action.limit_date_str
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { width: '100' },
                    this.state.report_action.limit_hour
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { width: '100' },
                    this.state.report_action.limit_landing
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { width: '100' },
                    this.state.report_action.description
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { width: '100' },
                    this.state.report_action.reason
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { width: '100' },
                    this.state.report_action.correlation_analysis_str
                ),
                this.state.report_action.status !== 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { width: '150' },
                    this.state.report_action.overload_analysis_str
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { width: '150' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], {
                        className: 'form-group',
                        name: 'overload_analysis',
                        value: self.state.overload_analysis,
                        searchable: true,
                        placeholder: "Selecionar",
                        onChange: self.handleSelectChange.bind(self, 'overload_analysis'),
                        options: [{ value: 0, label: "Recusado" }, { value: 1, label: "Ok" }],
                        required: true
                    })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { width: '100' },
                    this.state.report_action.status_str
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { width: '100' },
                    this.state.report_action.captain
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { width: '100' },
                    this.state.report_action.captain_approval_date_str
                ),
                this.state.report_action.status !== 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { width: '100' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'button',
                            { className: 'btn btn-success btn-sm', disabled: true },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' })
                        )
                    )
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { width: '100' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'button',
                            { onClick: self.approve, className: 'btn btn-success btn-sm' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' })
                        )
                    )
                )
            );
        }
    }]);

    return AircraftLogbookMaintenanceOperationalRestrictionTable;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookMaintenanceOperationalRestrictionTable);

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var AircraftLogbookNoDiscrepanciesTab = function (_Component) {
  _inherits(AircraftLogbookNoDiscrepanciesTab, _Component);

  function AircraftLogbookNoDiscrepanciesTab(props) {
    _classCallCheck(this, AircraftLogbookNoDiscrepanciesTab);

    var _this = _possibleConstructorReturn(this, (AircraftLogbookNoDiscrepanciesTab.__proto__ || Object.getPrototypeOf(AircraftLogbookNoDiscrepanciesTab)).call(this, props));

    _this.state = {
      loaded: 0,
      aircraft_logbook_id: _this.props.aircraft_logbook_id,
      rows: []
    };
    _this.load = _this.load.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  _createClass(AircraftLogbookNoDiscrepanciesTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0) {
        this.setState({ loaded: 1, aircraft_logbook_id: newProps.aircraft_logbook_id }, this.load);
      }
    }
  }, {
    key: 'load',
    value: function load() {
      var _this2 = this;

      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/sem-discrepancias/' + _this2.state.aircraft_logbook_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          _this2.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            _this2.setState({ rows: responseJson.data || [] });
          }
        });
      });
    }
  }, {
    key: 'toggle',
    value: function toggle(row) {
      var _this3 = this;

      this.props.handleAlert('', '', 'open');
      var confirmed = row.confirmed === 1;
      var header = this.refs.request_api.header('application/json');
      var url = confirmed ? __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/sem-discrepancias' : __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/sem-discrepancias';
      var method = confirmed ? 'DELETE' : 'POST';
      var body = confirmed ? JSON.stringify({ id: row.id }) : JSON.stringify({
        aircraft_logbook_id: row.aircraft_logbook_id,
        flight_report_id: row.flight_report_id,
        flight_report_leg_id: row.flight_report_leg_id
      });

      Promise.resolve(header).then(function (value) {
        fetch(url, { method: method, mode: 'cors', headers: value, body: body }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          _this3.refs.request_api.validate(responseJson, 'alert');
          _this3.props.handleAlert(responseJson.message, responseJson.status, 'open');
          if (responseJson.status === 'success') {
            _this3.load();
            if (typeof _this3.props.updateData === 'function') {
              _this3.props.updateData(responseJson);
            }
          }
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-12' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              'Flight Reports Without Discrepancies'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'table-responsive' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'table table-bordered table-hover table-striped' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      'Flight Report ID'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      'Flight Leg'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      'No Discrepancies'
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  null,
                  self.state.rows.map(function (r) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      { key: r.flight_report_leg_id, className: 'text-center' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        r.flight_report_id
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        r.leg_label
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'button',
                          { onClick: function onClick() {
                              return _this4.toggle(r);
                            }, className: 'btn btn-sm btn-success', disabled: r.confirmed ? true : false },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { className: 'fa fa-check' }),
                          ' ',
                          r.confirmed ? 'Confirmed' : 'Confirm'
                        )
                      )
                    );
                  }),
                  self.state.rows.length === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      { colSpan: 3, className: 'text-center' },
                      'No items'
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return AircraftLogbookNoDiscrepanciesTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookNoDiscrepanciesTab);

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LogbookAppIntegration_LogbookSignatureModal__ = __webpack_require__(80);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






// Helpers de formulário









// Importo o moment com a linguagem pt-br
__webpack_require__(24);
__webpack_require__(32);

var AircraftLogbookOccurrencesTab = function (_Component) {
  _inherits(AircraftLogbookOccurrencesTab, _Component);

  function AircraftLogbookOccurrencesTab(props) {
    _classCallCheck(this, AircraftLogbookOccurrencesTab);

    var _this = _possibleConstructorReturn(this, (AircraftLogbookOccurrencesTab.__proto__ || Object.getPrototypeOf(AircraftLogbookOccurrencesTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      logbook_app: _this.props.logbook_app,
      occurrence_flight: false,
      occurrences: {},
      aircraft_logbook_id: _this.props.aircraft_logbook_id,
      aircraft_logbook_flight_id: '',
      abnormal_occurrence_type_id: '',
      coordinates: '',
      location_id: '',
      observations: '',
      occurrence: '',
      date: '',
      legally_interested_contact_type: '',
      staff_key: '',
      staffs: [{ id: 0, name: '', document: '', civil_qualification_type_id: '' }],
      flight_legs_list: [],
      abnormal_occurrence_types_select: [],
      civil_qualification_types_list: [],
      locations_list: [],
      approval_type: '',
      email: '',
      password: '',
      selected_staffs: [],
      staffs_modal: false,
      showLogbookSignatureModal: false,
      signature_modal_title: '',
      signature_modal_subtitle: '',
      signature_modal_confirmation: ''
    };
    _this.showStaffsModal = _this.showStaffsModal.bind(_this);
    _this.closeStaffsModal = _this.closeStaffsModal.bind(_this);
    _this.handleStaffChange = _this.handleStaffChange.bind(_this);
    _this.add = _this.add.bind(_this);
    _this.delete = _this.delete.bind(_this);
    _this.handleFormSubmit = _this.handleFormSubmit.bind(_this);
    _this.handleApproval = _this.handleApproval.bind(_this);
    _this.handleLogbookSignatureSubmit = _this.handleLogbookSignatureSubmit.bind(_this);
    _this.addStaffRow = _this.addStaffRow.bind(_this);
    _this.deleteStaffRow = _this.deleteStaffRow.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(AircraftLogbookOccurrencesTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = true;
      } else {
        var value = false;
      }
      change[name] = value;
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0) {
        this.setState({
          logbook_app: newProps.logbook_app,
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          loaded: 1
        });
      }

      if (typeof newProps.occurrences !== 'undefined' && newProps.occurrences !== null && this.state.loaded === 1) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          occurrences: newProps.occurrences
        });
        if (Object.keys(newProps.occurrences).length > 0) {
          this.setState({
            occurrence_flight: true
          });
        }
      }

      if (typeof newProps.flight_legs_list !== 'undefined' && newProps.flight_legs_list !== null && this.state.loaded === 1) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          flight_legs_list: newProps.flight_legs_list
        });
      }

      if (typeof newProps.abnormal_occurrence_types_select !== 'undefined' && newProps.abnormal_occurrence_types_select !== null && this.state.loaded === 1) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          abnormal_occurrence_types_select: newProps.abnormal_occurrence_types_select
        });
      }

      if (typeof newProps.locations_list !== 'undefined' && newProps.locations_list !== null && this.state.loaded === 1) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          locations_list: newProps.locations_list
        });
      }

      if (typeof newProps.civil_qualification_types_list !== 'undefined' && newProps.civil_qualification_types_list !== null && this.state.loaded === 1) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          civil_qualification_types_list: newProps.civil_qualification_types_list
        });
      }
    }

    // Exibe o modal de pessoas envolvidas

  }, {
    key: 'showStaffsModal',
    value: function showStaffsModal(occurrence_id) {
      // Localiza a ocorrência no array de ocorrências
      var occurrence = this.state.occurrences.find(function (o) {
        return o.id === occurrence_id;
      });

      // Extrai o array de staffs e guarda no state
      this.setState({
        selected_staffs: occurrence && occurrence.flight_report_occurrence_staffs ? occurrence.flight_report_occurrence_staffs : [],
        staffs_modal: true
      });
    }

    // Fecha o modal de pessoas envolvidas

  }, {
    key: 'closeStaffsModal',
    value: function closeStaffsModal() {
      this.setState({
        selected_staffs: [],
        staffs_modal: false
      });
    }
  }, {
    key: 'handleStaffChange',
    value: function handleStaffChange(index, field, value) {
      var staffs = [].concat(_toConsumableArray(this.state.staffs));
      staffs[index] = Object.assign({}, staffs[index], _defineProperty({}, field, value));
      this.setState({ staffs: staffs });
    }
  }, {
    key: 'handleFormSubmit',
    value: function handleFormSubmit(e) {
      e.preventDefault();
      this.handleApproval('add', null);
    }

    // Após clicar para aprovar o reporte

  }, {
    key: 'handleApproval',
    value: function handleApproval(type, key) {
      if (type === 'add') {
        // Se tiver integração com o Logbook App, chama a função de integração
        if (this.props.logbook_app == 1) {
          // Abrimos o modal para solicitar as credenciais do Logbook App
          this.setState({
            approval_type: type,
            signature_modal_title: 'Você tem certeza de que deseja integrar e enviar os dados desta ocorrência anormal para o Logbook App?',
            signature_modal_subtitle: 'Ao confirmar sua assinatura digital será afixada a este registro e ficará visível para todos os usuários do sistema.',
            signature_modal_confirmation: 'Confirmo que estou ciente e desejo prosseguir com a assinatura',
            showLogbookSignatureModal: true
          });
        } else {
          this.add();
        }
      }

      if (type === 'delete') {
        // Se tiver integração com o Logbook App, chama a função de integração
        if (this.props.logbook_app == 1) {
          // Abrimos o modal para solicitar as credenciais do Logbook App
          this.setState({
            staff_key: key,
            approval_type: type,
            signature_modal_title: 'Você tem certeza de que deseja integrar e enviar o arquivamento desta ocorrência anormal para o Logbook App?',
            signature_modal_subtitle: 'Ao confirmar sua assinatura digital será afixada a este registro e ficará visível para todos os usuários do sistema.',
            signature_modal_confirmation: 'Confirmo que estou ciente e desejo prosseguir com a assinatura',
            showLogbookSignatureModal: true
          });
        } else {
          this.delete(key);
        }
      }
    }

    // Após preencher as credenciais do Logbook App

  }, {
    key: 'handleLogbookSignatureSubmit',
    value: function handleLogbookSignatureSubmit(credentials) {
      var _this2 = this;

      // Recebe { email, password } do modal e atualiza o state
      this.setState({
        email: credentials.email,
        password: credentials.password,
        showLogbookSignatureModal: false
      }, function () {
        // Após informar as credenciais, chama a função de aprovação interna
        if (_this2.state.approval_type === 'add') {
          _this2.add();
        }
        if (_this2.state.approval_type === 'delete') {
          _this2.delete(_this2.state.staff_key);
        }
      });
    }

    // Fetch salvando a edição

  }, {
    key: 'add',
    value: function add() {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        aircraft_logbook_id: this.state.aircraft_logbook_id,
        aircraft_logbook_flight_id: this.state.aircraft_logbook_flight_id,
        abnormal_occurrence_type_id: this.state.abnormal_occurrence_type_id,
        observations: this.state.observations,
        coordinates: this.state.coordinates,
        location_id: this.state.location_id,
        occurrence: this.state.occurrence,
        date: this.state.date,
        legally_interested_contact_type: this.state.legally_interested_contact_type,
        staffs: this.state.staffs,
        email: this.state.email,
        password: this.state.password
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/ocorrencia/logbook', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.props.updateData(responseJson);
            self.setState({
              aircraft_logbook_flight_id: '',
              abnormal_occurrence_type_id: '',
              coordinates: '',
              location_id: '',
              observations: '',
              occurrence: '',
              date: '',
              legally_interested_contact_type: '',
              staffs: [{ id: 0, name: '', document: '', civil_qualification_type_id: '' }],
              email: '',
              password: ''
            });
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'delete',
    value: function _delete(id) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      var datasave = {
        id: id,
        aircraft_logbook_id: this.state.aircraft_logbook_id,
        email: this.state.email,
        password: this.state.password
      };
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/ocorrencia/logbook', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({
            email: '',
            password: ''
          });
          if (responseJson.status === 'success') {
            self.props.updateData(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'addStaffRow',
    value: function addStaffRow() {
      var newKey = this.state.staff_key + 1;
      var staff = {
        id: newKey,
        name: '',
        document: '',
        civil_qualification_type_id: ''
      };
      this.setState({
        staffs: this.state.staffs.concat([staff]),
        staff_key: newKey
      });
    }
  }, {
    key: 'deleteStaffRow',
    value: function deleteStaffRow(id) {
      var staffs = this.state.staffs;
      staffs = staffs.filter(function (staff) {
        return staff.id !== id;
      });
      this.setState({
        staffs: staffs
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.props.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-1' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_toggle___default.a, {
              checked: this.state.occurrence_flight,
              'aria-label': 'No label tag',
              name: 'occurrence_flight',
              onChange: this.handleToggleChange.bind(this, 'occurrence_flight')
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-11' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              'Occurrences In Flight'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          )
        ),
        this.state.occurrence_flight == true && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'form',
            { onSubmit: this.handleFormSubmit },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Flight Leg'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: 'form-group',
                    name: 'aircraft_logbook_flight_id',
                    value: this.state.aircraft_logbook_flight_id,
                    searchable: true,
                    placeholder: 'Selecionar trecho',
                    onChange: this.handleSelectChange.bind(this, 'aircraft_logbook_flight_id'),
                    options: this.state.flight_legs_list,
                    required: true
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Type'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: 'form-group',
                    name: 'abnormal_occurrence_type_id',
                    value: this.state.abnormal_occurrence_type_id,
                    searchable: true,
                    placeholder: 'Selecionar tipo',
                    onChange: this.handleSelectChange.bind(this, 'abnormal_occurrence_type_id'),
                    options: this.state.abnormal_occurrence_types_select,
                    required: true
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Location'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: 'form-group',
                    name: 'location_id',
                    value: this.state.location_id,
                    searchable: true,
                    placeholder: 'Selecionar localidade',
                    onChange: this.handleSelectChange.bind(this, 'location_id'),
                    options: this.state.locations_list,
                    required: true
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Coordinates'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', value: this.state.coordinates, name: 'coordinates', onChange: this.handleChange.bind(this, 'coordinates'), placeholder: 'Coordenadas', required: true })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Date'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.date, name: 'date', mask: '99/99/9999 99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'date'), placeholder: 'dd/mm/aaaa hh:mm', required: true })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Contact Type'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', value: this.state.legally_interested_contact_type, name: 'legally_interested_contact_type', onChange: this.handleChange.bind(this, 'legally_interested_contact_type'), placeholder: 'Meio de contato do interessado', required: true })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Occurrence'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', value: this.state.occurrence, name: 'occurrence', onChange: this.handleChange.bind(this, 'occurrence'), placeholder: 'Ocorr\xEAncia', required: true })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Description'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', value: this.state.observations, name: 'observations', onChange: this.handleChange.bind(this, 'observations'), placeholder: 'Descri\xE7\xE3o', required: true })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              'Personnel Involved'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'table',
              { className: 'table table-bordered table-hover table-striped' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'thead',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    'Name'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    'Document'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    'Civil Qualification'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    'Actions'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tbody',
                { id: 'staffs' },
                self.state.staffs.map(function (staff, idx) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    { className: 'text-center', key: staff.id },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', value: staff.name, onChange: function onChange(e) {
                          return self.handleStaffChange(idx, 'name', e.target.value);
                        }, placeholder: 'Nome', required: true })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', value: staff.document, onChange: function onChange(e) {
                          return self.handleStaffChange(idx, 'document', e.target.value);
                        }, placeholder: 'Documento', required: true })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                        className: 'form-group',
                        value: self.state.civil_qualification_types_list.find(function (o) {
                          return o.value === staff.civil_qualification_type_id;
                        }) || null,
                        searchable: true,
                        placeholder: 'Selecionar qualificação civil',
                        onChange: function onChange(opt) {
                          return self.handleStaffChange(idx, 'civil_qualification_type_id', opt ? opt.value : null);
                        },
                        options: self.state.civil_qualification_types_list,
                        required: true
                      })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'button',
                          { type: 'button', onClick: function onClick() {
                              self.deleteStaffRow(staff.id);
                            }, className: 'btn btn-danger btn-sm button-inline' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-trash' })
                        ),
                        idx === self.state.staffs.length - 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'button',
                          { type: 'button', onClick: self.addStaffRow, className: 'btn btn-success btn-sm button-inline' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-plus' })
                        )
                      )
                    )
                  );
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-12' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'submit', className: 'btn btn-block btn-primary' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                    ' Cadastrar'
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'table-responsive' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'table',
              { className: 'table table-bordered table-hover table-striped' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'caption',
                null,
                'Occurrences'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'thead',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    'Flight Leg'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    'Type'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    'Location'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    'Coordinates'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    'Date'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    'Contact Type'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    'Occurrence'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    'Description'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    'Actions'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tbody',
                { id: 'occurrences' },
                Object.keys(self.state.occurrences).map(function (k) {
                  var occurrence = self.state.occurrences[k];
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    { className: 'text-center', key: occurrence.id },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      occurrence.leg
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      occurrence.abnormal_occurrence_type.type
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      occurrence.location.icao_code
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      occurrence.coordinates
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      occurrence.date_str
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      occurrence.legally_interested_contact_type
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      occurrence.occurrence
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      occurrence.observations
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'btn-group' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'button',
                          { onClick: function onClick() {
                              self.showStaffsModal(occurrence.id);
                            }, className: 'btn btn-info btn-sm button-inline' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-eye' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'button',
                          { onClick: function onClick() {
                              self.handleApproval('delete', occurrence.id);
                            }, className: 'btn btn-danger btn-sm button-inline' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-trash' })
                        )
                      )
                    )
                  );
                })
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__LogbookAppIntegration_LogbookSignatureModal__["a" /* default */], {
          show: this.state.showLogbookSignatureModal,
          onHide: function onHide() {
            return _this3.setState({ showLogbookSignatureModal: false });
          },
          onSubmit: this.handleLogbookSignatureSubmit,
          title: this.state.signature_modal_title,
          subtitle: this.state.signature_modal_subtitle,
          confirmation: this.state.signature_modal_confirmation
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */],
          { show: this.state.staffs_modal, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              'Personnel Involved'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: this.closeStaffsModal },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'table-responsive' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'table table-bordered table-hover table-striped' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      'Name'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      'Document'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      'Civil Qualification'
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  null,
                  this.state.selected_staffs.length > 0 ? this.state.selected_staffs.map(function (staff) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      { className: 'text-center', key: staff.id },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        staff.name
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        staff.document
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        staff.civil_qualification_type ? staff.civil_qualification_type.description : ''
                      )
                    );
                  }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      { colSpan: '3', className: 'text-center' },
                      'No personnel found for this occurrence.'
                    )
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: this.closeStaffsModal },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return AircraftLogbookOccurrencesTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookOccurrencesTab);

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário




// Importo o moment com a linguagem pt-br
__webpack_require__(24);
__webpack_require__(32);

var AircraftLogbookPowerCheckTab = function (_Component) {
  _inherits(AircraftLogbookPowerCheckTab, _Component);

  function AircraftLogbookPowerCheckTab(props) {
    _classCallCheck(this, AircraftLogbookPowerCheckTab);

    var _this = _possibleConstructorReturn(this, (AircraftLogbookPowerCheckTab.__proto__ || Object.getPrototypeOf(AircraftLogbookPowerCheckTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      power_checks: {},
      aircraft_logbook_id: _this.props.aircraft_logbook_id,
      flight_report_power_check_id: '',
      engine: '',
      altitude: '',
      external_temperature: '',
      power_turbine_rotation_rate: '',
      engine_power_rate: '',
      gas_turbine_rotation_rate: '',
      engine_temperature: '',
      engine_temperature_margin: '',
      gas_turbine_torque_margin: ''
    };
    return _this;
  }

  // Handlers


  _createClass(AircraftLogbookPowerCheckTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          loaded: 1
        });
      }

      if (typeof newProps.power_checks !== 'undefined' && newProps.power_checks !== null && this.state.loaded === 1) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          power_checks: newProps.power_checks
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title pull-left' },
          'Power Check'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'caption',
              null,
              'Power Checks'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'Engine'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'Altitude'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'OAT'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'N2/NR'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'Torque'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'N1/NG'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'T4/T5/ITT/TOT/MGT (\xB0C)'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 2, className: 'text-center vcenter' },
                  'Margins'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'T5/ITT/T4/TOT/MGT (\xB0C)'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'NG/Torque'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'power_checks' },
              Object.keys(self.state.power_checks).map(function (k) {
                var power_check = self.state.power_checks[k];
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  { className: 'text-center', key: power_check.id },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    power_check.engine
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    power_check.altitude
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    power_check.external_temperature
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    power_check.power_turbine_rotation_rate
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    power_check.engine_power_rate
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    power_check.gas_turbine_rotation_rate_decimal
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    power_check.engine_temperature
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    power_check.engine_temperature_margin
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    power_check.gas_turbine_torque_margin_decimal
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);

  return AircraftLogbookPowerCheckTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookPowerCheckTab);

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(16);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário





// Importo o moment com a linguagem pt-br
__webpack_require__(24);
__webpack_require__(32);

var AircraftLogbookReportActionMaintenanceOperationalRestrictionTab = function (_Component) {
  _inherits(AircraftLogbookReportActionMaintenanceOperationalRestrictionTab, _Component);

  function AircraftLogbookReportActionMaintenanceOperationalRestrictionTab(props) {
    _classCallCheck(this, AircraftLogbookReportActionMaintenanceOperationalRestrictionTab);

    var _this = _possibleConstructorReturn(this, (AircraftLogbookReportActionMaintenanceOperationalRestrictionTab.__proto__ || Object.getPrototypeOf(AircraftLogbookReportActionMaintenanceOperationalRestrictionTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      action_parts_modal: false,
      maintenance_operational_restriction_name: null,
      report_action_id: _this.props.report_action_id,
      type_field: 'select',
      limit_type: 0,
      reports: {},
      report_actions: {},
      report_action_deferred_items: [],
      maintenance_operational_restriction_list: [],
      maintenance_operational_restrictions: '',
      filtered_options: [{ "value": 1, "label": "Data" }],
      full_options: [{ "value": 0, "label": "Sem limitação" }, { "value": 1, "label": "Data" }, { "value": 2, "label": "Horas de voo" }, { "value": 3, "label": "Pousos" }, { "value": 4, "label": "Específico" }]
    };
    _this.add = _this.add.bind(_this);
    _this.deleteDeferredItem = _this.deleteDeferredItem.bind(_this);

    return _this;
  }

  // Handlers


  _createClass(AircraftLogbookReportActionMaintenanceOperationalRestrictionTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleMultiSelectChange',
    value: function handleMultiSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'changeInput',
    value: function changeInput(type_field) {
      this.setState({
        type_field: type_field
      });
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      // Sempre atualiza o id da ação atual
      var incomingActionId = newProps.report_action_id;
      var deferredMap = newProps.report_action_deferred_items || {};

      this.setState({
        loaded: 1,
        report_action_id: incomingActionId,
        reports: typeof newProps.reports !== 'undefined' && newProps.reports !== null ? newProps.reports : this.state.reports,
        report_actions: typeof newProps.report_actions !== 'undefined' && newProps.report_actions !== null ? newProps.report_actions : this.state.report_actions,
        report_action_deferred_items: typeof deferredMap[incomingActionId] !== 'undefined' && deferredMap[incomingActionId] !== null ? deferredMap[incomingActionId] : [],
        maintenance_operational_restriction_list: typeof newProps.maintenance_operational_restriction_list !== 'undefined' && newProps.maintenance_operational_restriction_list !== null ? newProps.maintenance_operational_restriction_list : this.state.maintenance_operational_restriction_list
      });
    }

    // Fetch salvando a ação

  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var datasave = {
        aircraft_logbook_report_action_id: this.state.report_action_id,
        type: this.state.type,
        type_field: this.state.type_field,
        item_number: this.state.item_number,
        mel: this.state.mel,
        category: this.state.category,
        limit_type: this.state.limit_type,
        limit: this.state.limit,
        limit_date: this.state.limit_date,
        limit_hour: this.state.limit_hour,
        limit_landing: this.state.limit_landing,
        description: this.state.description,
        reason: this.state.reason,
        correlation_analysis: this.state.correlation_analysis,
        maintenance_operational_restrictions: this.state.maintenance_operational_restrictions,
        maintenance_operational_restriction_name: this.state.maintenance_operational_restriction_name
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/item/acao/adiada', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
          self.setState({
            type: '',
            item_number: '',
            mel: '',
            category: '',
            limit: '',
            limit_date: '',
            limit_hour: '',
            limit_landing: '',
            description: '',
            reason: '',
            correlation_analysis: ''
          });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'deleteDeferredItem',
    value: function deleteDeferredItem(id) {
      if (!window.confirm('Tem certeza que deseja excluir este item adiado?')) {
        return;
      }
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/item/acao/adiada/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: this.add },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Type'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                  className: 'form-group',
                  name: 'type',
                  value: this.state.type,
                  searchable: true,
                  placeholder: 'Selecionar',
                  onChange: this.handleSelectChange.bind(this, 'type'),
                  options: [{ value: 0, label: "MEL" }, { value: 1, label: "NEF" }],
                  required: true
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'N\xB0 Item'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', value: this.state.item_number, name: 'item_number', onChange: this.handleChange.bind(this, 'item_number'), placeholder: 'N\xB0 Item', required: true })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Categoria'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                  className: 'form-group',
                  name: 'category',
                  value: this.state.category,
                  searchable: true,
                  placeholder: 'Selecionar',
                  onChange: this.handleSelectChange.bind(this, 'category'),
                  options: [{ value: "a", label: "A" }, { value: "b", label: "B" }, { value: "c", label: "C" }, { value: "d", label: "D" }],
                  required: true
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Tipos de limite'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                  className: 'form-group',
                  name: 'limit_type',
                  value: this.state.limit_type,
                  searchable: true,
                  placeholder: 'Selecionar',
                  onChange: this.handleSelectChange.bind(this, 'limit_type'),
                  options: this.state.category === 'a' ? this.state.full_options : this.state.filtered_options,
                  required: true
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            this.state.type == 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'MEL'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', value: this.state.mel, name: 'mel', onChange: this.handleChange.bind(this, 'mel'), placeholder: 'MEL', required: true })
              )
            ) : '',
            this.state.limit_type == 1 && this.state.category !== 'a' || this.state.limit_type == 0 ? '' : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Limite'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', className: 'form-control', value: this.state.limit, name: 'limit', onChange: this.handleChange.bind(this, 'limit'), placeholder: 'Limite', required: true })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Descri\xE7\xE3o'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', value: this.state.description, name: 'description', onChange: this.handleChange.bind(this, 'description'), placeholder: 'Descri\xE7\xE3o', required: true })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Motivo'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', value: this.state.reason, name: 'reason', onChange: this.handleChange.bind(this, 'reason'), placeholder: 'Motivo', required: true })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'An\xE1lise de correla\xE7\xE3o'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                  className: 'form-group',
                  name: 'correlation_analysis',
                  value: this.state.correlation_analysis,
                  searchable: true,
                  placeholder: 'Selecionar',
                  onChange: this.handleSelectChange.bind(this, 'correlation_analysis'),
                  options: [{ value: "0", label: "N/A" }, { value: "1", label: "Satisfatório" }],
                  required: true
                })
              )
            ),
            this.state.type_field === 'input' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Nova Restri\xE7\xF5es Operacional: ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', onClick: function onClick() {
                        self.changeInput('select');
                      }, className: 'btn btn-xs btn-info' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-refresh' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'maintenance_operational_restriction_name', className: 'form-control', placeholder: '', value: this.state.maintenance_operational_restriction_name, onChange: this.handleChange.bind(this, 'maintenance_operational_restriction_name'), required: true })
              )
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Restri\xE7\xF5es Operacionais ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', onClick: function onClick() {
                        self.changeInput('input');
                      }, className: 'btn btn-xs btn-info' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-plus' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                  className: 'form-group',
                  name: 'maintenance_operational_restrictions',
                  value: this.state.maintenance_operational_restrictions,
                  searchable: true,
                  placeholder: 'Restrições Operacionais',
                  multi: true,
                  onChange: this.handleMultiSelectChange.bind(this, 'maintenance_operational_restrictions'),
                  options: this.state.maintenance_operational_restriction_list
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-12' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'submit', className: 'btn btn-block btn-primary' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                  ' Cadastrar'
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'caption',
              null,
              'Deferred Items'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Type'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'N\xB0 Item'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Categoria'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Tipo de limite'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'MEL'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Limite'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Descri\xE7\xE3o'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Motivo'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'An\xE1lise de correla\xE7\xE3o'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Restri\xE7\xF5es operacionais'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'A\xE7\xF5es'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'deferred_items' },
              self.state.report_action_deferred_items.map(function (k) {
                var deferred_item = k;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  { className: 'text-center', key: deferred_item.id },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    deferred_item.type_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    deferred_item.item_number
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    deferred_item.category
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    deferred_item.limit_type_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    deferred_item.mel
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    deferred_item.limit
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    deferred_item.description
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    deferred_item.reason
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    deferred_item.correlation_analysis_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    deferred_item.maintenance_operational_restriction
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { onClick: function onClick() {
                          return self.deleteDeferredItem(deferred_item.id);
                        }, className: 'btn btn-danger btn-sm' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-trash' })
                    )
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);

  return AircraftLogbookReportActionMaintenanceOperationalRestrictionTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookReportActionMaintenanceOperationalRestrictionTab);

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(16);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário





// Importo o moment com a linguagem pt-br
__webpack_require__(24);
__webpack_require__(32);

var AircraftLogbookReportActionPartsReplacementsTab = function (_Component) {
  _inherits(AircraftLogbookReportActionPartsReplacementsTab, _Component);

  function AircraftLogbookReportActionPartsReplacementsTab(props) {
    _classCallCheck(this, AircraftLogbookReportActionPartsReplacementsTab);

    var _this = _possibleConstructorReturn(this, (AircraftLogbookReportActionPartsReplacementsTab.__proto__ || Object.getPrototypeOf(AircraftLogbookReportActionPartsReplacementsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      action_parts_modal: false,
      report_action_id: _this.props.report_action_id,
      reports: {},
      report_actions: {},
      report_action_parts_replacements: [],
      engines_list: []
    };
    _this.add = _this.add.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(AircraftLogbookReportActionPartsReplacementsTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0) {
        this.setState({
          report_action_id: newProps.report_action_id,
          loaded: 1
        });
      }

      if (typeof newProps.reports !== 'undefined' && newProps.reports !== null && this.state.loaded === 1) {
        this.setState({
          reports: newProps.reports
        });
      }

      if (typeof newProps.report_actions !== 'undefined' && newProps.report_actions !== null && this.state.loaded === 1) {
        this.setState({
          report_actions: newProps.report_actions
        });
      }

      if (typeof newProps.report_action_parts_replacements[this.state.report_action_id] !== 'undefined' && newProps.report_action_parts_replacements[this.state.report_action_id] !== null && this.state.loaded === 1) {
        this.setState({
          report_action_parts_replacements: newProps.report_action_parts_replacements[this.state.report_action_id]
        });
      }
    }

    // Fetch salvando a ação

  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var datasave = {
        aircraft_logbook_report_action_id: this.state.report_action_id,
        is_engine: this.state.is_engine,
        engine_id: this.state.engine_id,
        part_number: this.state.part_number,
        type: this.state.type
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/reporte/acoes/partes', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
          self.setState({
            is_engine: '',
            engine_id: '',
            part_number: '',
            type: ''
          });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: this.add },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Is engine?'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                  className: 'form-group',
                  name: 'is_engine',
                  value: this.state.is_engine,
                  searchable: true,
                  placeholder: '',
                  onChange: this.handleSelectChange.bind(this, 'is_engine'),
                  options: [{ value: 0, label: "No" }, { value: 1, label: "Yes" }],
                  required: true
                })
              )
            ),
            this.state.is_engine === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Part Number'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                  className: 'form-group',
                  name: 'engine_id',
                  value: this.state.engine_id,
                  searchable: true,
                  placeholder: 'Selecionar',
                  onChange: this.handleSelectChange.bind(this, 'engine_id'),
                  options: this.props.engines_list,
                  required: true
                })
              )
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Part Number'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', value: this.state.part_number, name: 'part_number', onChange: this.handleChange.bind(this, 'part_number'), placeholder: 'Part Number', required: true })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'On/Off'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                  className: 'form-group',
                  name: 'type',
                  value: this.state.type,
                  searchable: true,
                  placeholder: 'Selecionar',
                  onChange: this.handleSelectChange.bind(this, 'type'),
                  options: [{ value: "installed", label: "Installed" }, { value: "removed", label: "Removed" }],
                  required: true
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-12' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'submit', className: 'btn btn-block btn-primary' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                  ' Cadastrar'
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'caption',
              null,
              'Part\'s Replacement'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Is engine?'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'Part Number'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'On/Off'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'parts_replacements' },
              self.state.report_action_parts_replacements.map(function (k) {
                var parts_replacements = k;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  { className: 'text-center', key: parts_replacements.id },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    parts_replacements.is_engine_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    parts_replacements.part_number
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    parts_replacements.type_str
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);

  return AircraftLogbookReportActionPartsReplacementsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookReportActionPartsReplacementsTab);

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LogbookAppIntegration_LogbookSignatureModal__ = __webpack_require__(80);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário








// Importo o moment com a linguagem pt-br
__webpack_require__(24);
__webpack_require__(32);

var AircraftLogbookReportsTab = function (_Component) {
  _inherits(AircraftLogbookReportsTab, _Component);

  function AircraftLogbookReportsTab(props) {
    _classCallCheck(this, AircraftLogbookReportsTab);

    var _this = _possibleConstructorReturn(this, (AircraftLogbookReportsTab.__proto__ || Object.getPrototypeOf(AircraftLogbookReportsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      logbook_app: _this.props.logbook_app,
      report_trash: 0,
      aircraft_logbook_id: _this.props.aircraft_logbook_id,
      aircraft_logbook_flight_id: '',
      aircraft_logbook_report_id: '',
      location_id: '',
      user_id: '',
      date: '',
      description: '',
      reports: {},
      flight_legs_list: [],
      locations_list: [],
      users_list: [],
      bases_list: [],
      approval_type: '',
      email: '',
      password: '',
      showLogbookSignatureModal: false,
      signature_modal_title: '',
      signature_modal_subtitle: '',
      signature_modal_confirmation: ''
    };
    _this.add = _this.add.bind(_this);
    _this.delete = _this.delete.bind(_this);
    _this.approve = _this.approve.bind(_this);
    _this.handleApproval = _this.handleApproval.bind(_this);
    _this.handleLogbookSignatureSubmit = _this.handleLogbookSignatureSubmit.bind(_this);

    return _this;
  }

  // Handlers


  _createClass(AircraftLogbookReportsTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0) {
        this.setState({
          logbook_app: newProps.logbook_app,
          report_trash: newProps.report_trash,
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          loaded: 1
        });
      }

      if (typeof newProps.reports !== 'undefined' && newProps.reports !== null && this.state.loaded === 1) {
        this.setState({
          report_trash: newProps.report_trash,
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          reports: newProps.reports
        });
      }

      if (typeof newProps.flight_legs_list !== 'undefined' && newProps.flight_legs_list !== null && this.state.loaded === 1) {
        this.setState({
          report_trash: newProps.report_trash,
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          flight_legs_list: newProps.flight_legs_list
        });
      }

      if (typeof newProps.users_list !== 'undefined' && newProps.users_list !== null && this.state.loaded === 1) {
        this.setState({
          report_trash: newProps.report_trash,
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          users_list: newProps.users_list
        });
      }

      if (typeof newProps.bases_list !== 'undefined' && newProps.bases_list !== null && this.state.loaded === 1) {
        this.setState({
          report_trash: newProps.report_trash,
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          bases_list: newProps.bases_list
        });
      }

      if (typeof newProps.locations_list !== 'undefined' && newProps.locations_list !== null && this.state.loaded === 1) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          locations_list: newProps.locations_list
        });
      }
    }

    // Fetch salvando o reporte

  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var datasave = {
        aircraft_logbook_id: this.state.aircraft_logbook_id,
        aircraft_logbook_flight_id: this.state.aircraft_logbook_flight_id,
        location_id: this.state.location_id,
        user_id: this.state.user_id,
        date: this.state.date,
        description: this.state.description
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/reporte', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
          self.setState({
            aircraft_logbook_flight_id: '',
            location_id: '',
            user_id: '',
            date: '',
            description: ''
          });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'delete',
    value: function _delete() {
      var confirm = window.confirm('Are you sure that you want to delete this report?');
      if (confirm) {
        this.props.handleAlert('', '', 'open');
        var datasave = {
          aircraft_logbook_report_id: this.state.aircraft_logbook_report_id,
          email: this.state.email,
          password: this.state.password
        };
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/reporte/deletar';
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(url, { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({
              aircraft_logbook_report_id: '',
              approval_type: '',
              email: '',
              password: '',
              signature_modal_title: '',
              signature_modal_subtitle: '',
              signature_modal_confirmation: ''
            });
            if (responseJson.status === 'success') {
              self.props.updateData(responseJson);
            }
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }

    // Aprova internamente e, se estiver ativada a integração, envia para o Logbook App

  }, {
    key: 'approve',
    value: function approve() {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        aircraft_logbook_report_id: this.state.aircraft_logbook_report_id,
        email: this.state.email,
        password: this.state.password
      };
      var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/diario/reporte/aprovar';
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({
            aircraft_logbook_report_id: '',
            approval_type: '',
            email: '',
            password: '',
            signature_modal_title: '',
            signature_modal_subtitle: '',
            signature_modal_confirmation: ''
          });
          if (responseJson.status === 'success') {
            self.props.updateData(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }

    // Após clicar para aprovar o reporte

  }, {
    key: 'handleApproval',
    value: function handleApproval(id, type) {
      if (type === 'approve') {
        // Se tiver integração com o Logbook App, chama a função de integração
        if (this.props.logbook_app == 1) {
          // Abrimos o modal para solicitar as credenciais do Logbook App
          this.setState({
            aircraft_logbook_report_id: id,
            approval_type: type,
            signature_modal_title: 'Você tem certeza de que deseja integrar e enviar os dados desta discrepância técnica para o Logbook App?',
            signature_modal_subtitle: 'Ao confirmar sua assinatura digital será afixada a este registro e ficará visível para todos os usuários do sistema.',
            signature_modal_confirmation: 'Confirmo que estou ciente e desejo prosseguir com a assinatura',
            showLogbookSignatureModal: true
          });
        } else {
          this.approve();
        }
      }

      if (type === 'delete') {
        // Se tiver integração com o Logbook App, chama a função de integração
        if (this.props.logbook_app == 1) {
          // Abrimos o modal para solicitar as credenciais do Logbook App
          this.setState({
            aircraft_logbook_report_id: id,
            approval_type: type,
            signature_modal_title: 'Você tem certeza de que deseja integrar e enviar o arquivamento desta discrepância técnica para o Logbook App?',
            signature_modal_subtitle: 'Ao confirmar sua assinatura digital será afixada a este registro e ficará visível para todos os usuários do sistema.',
            signature_modal_confirmation: 'Confirmo que estou ciente e desejo prosseguir com a assinatura',
            showLogbookSignatureModal: true
          });
        } else {
          this.delete();
        }
      }
    }

    // Após preencher as credenciais do Logbook App

  }, {
    key: 'handleLogbookSignatureSubmit',
    value: function handleLogbookSignatureSubmit(credentials) {
      var _this2 = this;

      // Recebe { email, password } do modal e atualiza o state
      this.setState({
        email: credentials.email,
        password: credentials.password,
        showLogbookSignatureModal: false
      }, function () {
        // Após informar as credenciais, chama a função de aprovação interna
        if (_this2.state.approval_type === 'approve') {
          _this2.approve();
        }
        if (_this2.state.approval_type === 'delete') {
          _this2.delete();
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.props.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title pull-left' },
          'Reports of Crew or Maintenance'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: this.add },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Flight Leg'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                  className: 'form-group',
                  name: 'aircraft_logbook_flight_id',
                  value: this.state.aircraft_logbook_flight_id,
                  searchable: true,
                  placeholder: 'Select',
                  onChange: this.handleSelectChange.bind(this, 'aircraft_logbook_flight_id'),
                  options: this.state.flight_legs_list
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Location'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                  className: 'form-group',
                  name: 'location_id',
                  value: this.state.location_id,
                  searchable: true,
                  placeholder: 'Select',
                  onChange: this.handleSelectChange.bind(this, 'location_id'),
                  options: this.state.locations_list,
                  required: true
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Detected By'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                  className: 'form-group',
                  name: 'user_id',
                  value: this.state.user_id,
                  searchable: true,
                  placeholder: 'Select',
                  onChange: this.handleSelectChange.bind(this, 'user_id'),
                  options: this.state.users_list,
                  required: true
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Detected At'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.date, name: 'date', mask: '99/99/9999 99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'date'), placeholder: 'dd/mm/aaaa hh:mm', required: true })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-12' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Description'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', { style: { height: 35 }, type: 'text', name: 'description', className: 'form-control', value: this.state.description, onChange: this.handleChange.bind(this, 'description'), required: true })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-12' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'submit', className: 'btn btn-block btn-primary' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                  ' Cadastrar'
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'caption',
              null,
              'Reports'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Item'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Flight Leg'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Location'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Detected By'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Detected At'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Description'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Approved By'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Approved At'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Actions'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'reports' },
              Object.keys(self.state.reports).map(function (k) {
                var report = self.state.reports[k];
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  { className: 'text-center', key: report.id },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report.item
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report.leg
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report.location_name
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report.user_name
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report.date_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report.description
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report.approval_user_name
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    report.approval_date_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'btn-group' },
                      self.state.report_trash == 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { onClick: function onClick() {
                            self.handleApproval(report.id, 'delete');
                          }, className: 'btn btn-danger btn-sm button-inline' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-trash' })
                      ),
                      report.approval_date == null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { onClick: function onClick() {
                            self.handleApproval(report.id, 'approve');
                          }, className: 'btn btn-success btn-sm button-inline' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' })
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { className: 'btn btn-success btn-sm button-inline', disabled: true },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' })
                      )
                    )
                  )
                );
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__LogbookAppIntegration_LogbookSignatureModal__["a" /* default */], {
          show: this.state.showLogbookSignatureModal,
          onHide: function onHide() {
            return _this3.setState({ showLogbookSignatureModal: false });
          },
          onSubmit: this.handleLogbookSignatureSubmit,
          title: this.state.signature_modal_title,
          subtitle: this.state.signature_modal_subtitle,
          confirmation: this.state.signature_modal_confirmation
        })
      );
    }
  }]);

  return AircraftLogbookReportsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookReportsTab);

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário




// Importo o moment com a linguagem pt-br
__webpack_require__(24);
__webpack_require__(32);

var AircraftLogbookTotalsTab = function (_Component) {
  _inherits(AircraftLogbookTotalsTab, _Component);

  function AircraftLogbookTotalsTab(props) {
    _classCallCheck(this, AircraftLogbookTotalsTab);

    var _this = _possibleConstructorReturn(this, (AircraftLogbookTotalsTab.__proto__ || Object.getPrototypeOf(AircraftLogbookTotalsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      aircraft_logbook_id: _this.props.aircraft_logbook_id,
      totals: {}
    };
    _this.edit = _this.edit.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(AircraftLogbookTotalsTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          loaded: 1
        });
      }

      if (typeof newProps.totals !== 'undefined' && newProps.totals !== null && this.state.loaded === 1) {
        this.setState({
          aircraft_logbook_id: newProps.aircraft_logbook_id,
          totals: newProps.totals
        });
      }
    }

    // Fetch salvando a edição

  }, {
    key: 'edit',
    value: function edit(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var datasave = {
        aircraft_logbook_id: this.state.aircraft_logbook_id
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '#', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title pull-left' },
          'Totals'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                { className: 'text-center' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Counter'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'ACFT FH'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'ACFT FH (decimal)'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'ACFT LDG'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'ENG #1 FH'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'ENG #2 FH'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                { className: 'text-center' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  'Previous'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  this.state.totals.previous_logbook_aircraft_flight_hours_str
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  this.state.totals.previous_logbook_aircraft_flight_hours_decimal
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  this.state.totals.previous_logbook_aircraft_landings
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  this.state.totals.previous_logbook_engine_1_flight_hours_str
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  this.state.totals.previous_logbook_engine_2_flight_hours_str
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                { className: 'text-center' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  'Actual'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  this.state.totals.actual_logbook_aircraft_flight_hours_str
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  this.state.totals.actual_logbook_aircraft_flight_hours_decimal
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  this.state.totals.actual_logbook_aircraft_landings
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  this.state.totals.actual_logbook_engine_1_flight_hours_str
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  this.state.totals.actual_logbook_engine_2_flight_hours_str
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                { className: 'text-center' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  'Total'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  this.state.totals.total_aircraft_flight_hours_str
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  this.state.totals.total_aircraft_flight_hours_decimal
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  this.state.totals.total_aircraft_landings
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  this.state.totals.total_engine_1_flight_hours_str
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  this.state.totals.total_engine_2_flight_hours_str
                )
              )
            )
          )
        )
      );
    }
  }]);

  return AircraftLogbookTotalsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookTotalsTab);

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário




// Importo o moment com a linguagem pt-br
__webpack_require__(24);
__webpack_require__(32);

var AircraftLogbookTransitInspectionTab = function (_Component) {
  _inherits(AircraftLogbookTransitInspectionTab, _Component);

  function AircraftLogbookTransitInspectionTab(props) {
    _classCallCheck(this, AircraftLogbookTransitInspectionTab);

    var _this = _possibleConstructorReturn(this, (AircraftLogbookTransitInspectionTab.__proto__ || Object.getPrototypeOf(AircraftLogbookTransitInspectionTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      transit_inspection: [],
      st: '',
      flight_report_leg_id: '',
      transit_inspection_approval_date: '',
      transit_inspection_approval_user_id: '',
      transit_inspection_user_name: ''
    };
    return _this;
  }

  // Handlers


  _createClass(AircraftLogbookTransitInspectionTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (typeof newProps.transit_inspection !== 'undefined' && newProps.transit_inspection !== null && this.state.loaded === 0) {
        this.setState({
          transit_inspection: newProps.transit_inspection,
          st: newProps.transit_inspection.st,
          flight_report_leg_id: newProps.transit_inspection.flight_report_leg_id,
          transit_inspection_approval_date: newProps.transit_inspection.transit_inspection_approval_date,
          transit_inspection_approval_user_id: newProps.transit_inspection.transit_inspection_approval_user_id,
          transit_inspection_user_name: newProps.transit_inspection.transit_inspection_user_name
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'tr',
        { className: 'text-center', key: this.state.flight_report_leg_id },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'st', className: 'form-control text-center', value: this.state.st, disabled: true })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'transit_inspection_user_name', className: 'form-control text-center', value: this.state.transit_inspection_user_name, disabled: true })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'transit_inspection_approval_date', className: 'form-control text-center', value: this.state.transit_inspection_approval_date, disabled: true })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.state.transit_inspection_approval_date !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn btn-block btn-success', disabled: true },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'i',
              { className: 'fa fa-check' },
              ' Inspe\xE7\xE3o de Tr\xE2nsito Realizada'
            )
          ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { onClick: function onClick() {
                self.props.editTransitInspection(_this2.state.flight_report_leg_id);
              }, className: 'btn btn-block btn-success' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'i',
              { className: 'fa fa-check' },
              ' Inspe\xE7\xE3o de Tr\xE2nsito Realizada'
            )
          )
        )
      );
    }
  }]);

  return AircraftLogbookTransitInspectionTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AircraftLogbookTransitInspectionTab);

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Elements_CalendarDay__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var Calendar = function (_Component) {
  _inherits(Calendar, _Component);

  function Calendar(props) {
    _classCallCheck(this, Calendar);

    var _this = _possibleConstructorReturn(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      dados: []
    };
    _this.calendario = _this.calendario.bind(_this);
    _this.proximo = _this.proximo.bind(_this);
    _this.anterior = _this.anterior.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  _createClass(Calendar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.verifyPermission();
      var now = new Date();
      var mes = now.getMonth() + 1;
      var ano = now.getFullYear();
      var referencia = mes + '/' + ano;
      this.calendario(referencia);
    }
  }, {
    key: 'calendario',
    value: function calendario(referencia) {
      var header = this.refs.request_api.header('application/json');
      var self = this;
      var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/calendario/' + referencia;
      Promise.resolve(header).then(function (value) {
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({
              dados: responseJson.data,
              anterior: responseJson.datas.anterior,
              atual: responseJson.datas.atual,
              proximo: responseJson.datas.proximo,
              overlay: {
                message: '',
                type: '',
                status: 'closed'
              }
            });
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'proximo',
    value: function proximo() {
      this.calendario(this.state.proximo);
    }
  }, {
    key: 'anterior',
    value: function anterior() {
      this.calendario(this.state.anterior);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-primary', onClick: this.anterior },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-chevron-left' }),
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'hidden-xs' },
                    this.state.anterior
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h3',
                  { className: 'page-title text-center' },
                  this.state.atual
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-4 text-right' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-primary', onClick: this.proximo },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'hidden-xs' },
                    this.state.proximo
                  ),
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-chevron-right' })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'table-responsive' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'table calendario' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      this.locale.Calendario.Calendario.tabela.Domingo
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      this.locale.Calendario.Calendario.tabela.SegundaFeira
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      this.locale.Calendario.Calendario.tabela.TercaFeira
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      this.locale.Calendario.Calendario.tabela.QuartaFeira
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      this.locale.Calendario.Calendario.tabela.QuintaFeira
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      this.locale.Calendario.Calendario.tabela.SextaFeira
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      this.locale.Calendario.Calendario.tabela.Sabado
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  null,
                  this.state.dados.map(function (semana, linha) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Elements_CalendarDay__["a" /* default */], { semana: semana });
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Calendar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Calendar);

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CalendarDayTeam__ = __webpack_require__(800);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var CalendarDay = function (_Component) {
  _inherits(CalendarDay, _Component);

  function CalendarDay() {
    _classCallCheck(this, CalendarDay);

    return _possibleConstructorReturn(this, (CalendarDay.__proto__ || Object.getPrototypeOf(CalendarDay)).apply(this, arguments));
  }

  _createClass(CalendarDay, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'tr',
        null,
        this.props.semana.map(function (dia, linha) {
          if (dia.day) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'td',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                { className: 'text-center calendario-dia' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'strong',
                  null,
                  dia.day
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'calendario-cont' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__CalendarDayTeam__["a" /* default */], { training_schedules: dia.training_schedules, daily_schedules: dia.daily_schedules, mission_schedules: dia.mission_schedules, base_schedules: dia.base_schedules, team_schedules: dia.team_schedules })
              )
            );
          } else {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null);
          }
        })
      );
    }
  }]);

  return CalendarDay;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (CalendarDay);

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var CalendarDay = function (_Component) {
  _inherits(CalendarDay, _Component);

  function CalendarDay() {
    _classCallCheck(this, CalendarDay);

    return _possibleConstructorReturn(this, (CalendarDay.__proto__ || Object.getPrototypeOf(CalendarDay)).apply(this, arguments));
  }

  _createClass(CalendarDay, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.props.daily_schedules.map(function (daily_schedule, linha) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'link-daily', style: { background: daily_schedule['background'], color: daily_schedule['color'] } },
            daily_schedule['text']
          );
        }),
        this.props.base_schedules.map(function (base_schedule, linha) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'link-bases', style: { background: base_schedule['background'], color: base_schedule['color'] } },
            base_schedule['text']
          );
        }),
        this.props.training_schedules.map(function (training_schedule, linha) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'link-trainings' },
            training_schedule
          );
        }),
        this.props.mission_schedules.map(function (mission_schedule, linha) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'link-missions', style: { background: mission_schedule['background'], color: mission_schedule['color'] } },
            mission_schedule['text']
          );
        }),
        this.props.team_schedules.map(function (team_schedule, linha) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'link-teams' },
            team_schedule
          );
        })
      );
    }
  }]);

  return CalendarDay;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (CalendarDay);

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var PaymentMonthControl = function (_Component) {
  _inherits(PaymentMonthControl, _Component);

  function PaymentMonthControl(props) {
    _classCallCheck(this, PaymentMonthControl);

    var _this = _possibleConstructorReturn(this, (PaymentMonthControl.__proto__ || Object.getPrototypeOf(PaymentMonthControl)).call(this, props));

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__i18n_getLocale__["a" /* default */])();

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      modal_days: false,
      modal_debts: false,
      modal_debt_payments: false,
      types_select: [{ value: 'Missão', label: _this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.opcoesTipos.Missao }, { value: 'Treinamento', label: _this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.opcoesTipos.Treinamento }],
      mission_types_select: [{ value: 'daily', label: _this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.opcoesMissao.Diarias }, { value: 'base_chief', label: _this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.opcoesMissao.RepresentanteOperacional }, { value: 'transport', label: _this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.opcoesMissao.Transporte }, { value: 'distance', label: _this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.opcoesMissao.Deslocamento }, { value: 'extra', label: _this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.opcoesMissao.Extra }],
      training_types_select: [{ value: 'daily', label: _this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.opcoesTreinamento.Diarias }, { value: 'check', label: _this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.opcoesTreinamento.Cheques }, { value: 'extra', label: _this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.opcoesTreinamento.Extra }],
      simple_select: [{ value: 1, label: _this.locale.general.sim }, { value: 0, label: _this.locale.general.nao }],
      sigtrip_grades_list: [],
      sigtrip_trainings_list: [],
      sigmec_grades_list: [],
      sigmec_trainings_list: [],
      grades_select: [],
      trainings_select: [],
      staffs_select: [],
      source: 'sigtrip',
      user_type: null,
      reference: null,
      show_opened: 1,
      period: null,
      date_start: null,
      date_finish: null,
      payments: [],
      consolidated: [],
      days: [],
      debts: [],
      debt_payments: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.search = _this.search.bind(_this);
    _this.openTutorial = _this.openTutorial.bind(_this);
    _this.debtLabel = _this.debtLabel.bind(_this);
    _this.scheduleExport = _this.scheduleExport.bind(_this);
    _this.actionButton = _this.actionButton.bind(_this);
    _this.exportSigmec = _this.exportSigmec.bind(_this);
    _this.paymentDays = _this.paymentDays.bind(_this);
    _this.staffDebtDays = _this.staffDebtDays.bind(_this);
    _this.paymentDebts = _this.paymentDebts.bind(_this);
    _this.staffDebtPayments = _this.staffDebtPayments.bind(_this);
    return _this;
  }
  // Handlers


  _createClass(PaymentMonthControl, [{
    key: 'handleNavTab',
    value: function handleNavTab(state, key) {
      var change = {};
      change[state] = key;
      this.setState(change);
      this.setState({ overlay: { message: '', type: '', status: '' } });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
        if (name === 'source') {
          change['reference'] = null;
          change['payments'] = [];
          if (event.value == 'sigtrip') {
            change['grades_select'] = this.state.sigtrip_grades_list;
            change['trainings_select'] = this.state.sigtrip_trainings_list;
          }
          if (event.value == 'sigmec') {
            change['grades_select'] = this.state.sigmec_grades_list;
            change['trainings_select'] = this.state.sigmec_trainings_list;
          }
          if (event.value === 'sigtrip') {
            var self = this;
            var header = this.refs.request_api.header('application/json');
            Promise.resolve(header).then(function (value) {
              var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/tripulantes/ativos/inscricao/lista';
              fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
                return response.json();
              }).catch(function (error) {
                console.error(error);
              }).then(function (responseJson) {
                if (responseJson.status === 'success') {
                  self.setState({
                    staffs_select: responseJson.data
                  });
                }
              }).then(function () {
                self.setState({ overlay: { message: '', type: '', status: 'closed' } });
                self.handleMessage();
              });
            });
          }
          if (event.value === 'sigmec') {
            var self = this;
            var header = this.refs.request_api.header('application/json');
            Promise.resolve(header).then(function (value) {
              var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaboradores/inscricao/lista';
              fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
                return response.json();
              }).catch(function (error) {
                console.error(error);
              }).then(function (responseJson) {
                if (responseJson.status === 'success') {
                  self.setState({
                    staffs_select: responseJson.data
                  });
                }
              }).then(function () {
                self.setState({ overlay: { message: '', type: '', status: 'closed' } });
                self.handleMessage();
              });
            });
          }
        }
      }
      if (name === 'type') {
        change['reference'] = null;
        change['payments'] = [];
      }
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'openTutorial',
    value: function openTutorial() {
      window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tutorials/extratos_pagamentos.pdf');
    }
  }, {
    key: 'debtLabel',
    value: function debtLabel(cell, row) {
      var botao = '';
      if (row.debt === 1 && row.credit === 1) {
        var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'text-success fa fa-fw fa-warning' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'text-danger fa fa-fw fa-warning' })
          )
        );
      } else if (row.debt === 1) {
        var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'text-danger' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-warning' })
          )
        );
      } else if (row.credit === 1) {
        var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'text-success' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-warning' })
          )
        );
      }

      return botao;
    }
  }, {
    key: 'exportSigmec',
    value: function exportSigmec(url) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      self.setState({ overlay: { message: '', type: '', status: 'open' } });
      Promise.resolve(header).then(function (value) {
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn_sigmec') + '/tmp/' + responseJson.data);
          }
        });
      });
    }
  }, {
    key: 'scheduleExport',
    value: function scheduleExport(cell, row) {
      var _this2 = this;

      if (row.order_type == 'Missão') {

        if (row.origin == 'SIGTRIP') {
          var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/schedule_grades/main/' + row.schedule_link;
          var field = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'btn btn-link btn-sm', href: url },
            row.revision
          );
        } else if (row.origin == 'SIGMEC') {
          var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/exportar/escala/grade/visualizar/' + row.schedule_link + '/1';
          var field = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn btn-link btn-sm', onClick: function onClick() {
                return _this2.exportSigmec(url);
              } },
            row.revision
          );
        }
      } else {
        var field = row.revision;
      }

      return field;
    }
  }, {
    key: 'actionButton',
    value: function actionButton(cell, row) {
      if (row.field_type == 'Pagamento' && row.order_id > 0) {
        var modalDaysBtn = '';
        if (row.payment_type == 'Diária' || row.payment_type == 'Transporte') {
          var modalDaysBtn = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn button-inline btn-sm btn-primary', value: row.id, onClick: this.paymentDays },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-calendar' })
          );
        }

        var modalDebtsBtn = '';
        if (row.debt == 1) {
          var modalDebtsBtn = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn button-inline btn-sm btn-danger', value: row.id, onClick: this.paymentDebts },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-info-circle' })
          );
        }

        var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          modalDaysBtn,
          modalDebtsBtn
        );
      } else if (row.field_type == 'Débito') {
        var modalDaysBtn = '';
        if (row.payment_type == 'Diária' || row.payment_type == 'Transporte') {
          var modalDaysBtn = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn button-inline btn-sm btn-primary', value: row.id, onClick: this.staffDebtDays },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-calendar' })
          );
        }

        var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          modalDaysBtn,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn button-inline btn-sm btn-info', value: row.id, onClick: this.staffDebtPayments },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-info-circle' })
          )
        );
      }
      return botao;
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/pagamentos/controle/mensal';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({
              sigtrip_grades_list: responseJson.sigtrip_grades_list,
              sigtrip_trainings_list: responseJson.sigtrip_trainings_list,
              grades_select: responseJson.sigtrip_grades_list,
              trainings_select: responseJson.sigtrip_trainings_list,
              staffs_select: responseJson.sigtrip_staffs_list
            });
          }
        }).then(function () {
          var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/pagamentos/controle/mensal';
          fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson);
            if (responseJson.status === 'success') {
              self.setState({
                sigmec_grades_list: responseJson.sigmec_grades_list,
                sigmec_trainings_list: responseJson.sigmec_trainings_list
              });
            }
          }).then(function () {
            var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/checar/origem/usuario';
            fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.refs.request_api.validate(responseJson);
              if (responseJson.status === 'success') {
                self.setState({
                  user_type: responseJson.data
                });
              }
            }).then(function () {
              self.setState({ overlay: { message: '', type: '', status: 'closed' } });
              self.handleMessage();
            });
          });
        });
      });
    }
  }, {
    key: 'search',
    value: function search(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      if (this.state.user_type === 'sigtrip') {
        var api = 'api';
      } else if (this.state.user_type === 'sigmec') {
        var api = 'api_sigmec';
      }
      var datasave = {
        period: this.state.period,
        type: this.state.type,
        payment_type: this.state.payment_type,
        show_opened: this.state.show_opened
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get(api) + '/pagamentos/controle/extrato/mensal', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({
            payments: responseJson.data.payments,
            consolidated: responseJson.data.consolidated
          });
          if (responseJson.status == 'error') {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'paymentDays',
    value: function paymentDays(event) {
      var payment_id = event.currentTarget.value;
      var self = this;
      self.handleAlert('', '', 'open');
      if (this.state.user_type === 'sigtrip') {
        var api = 'api';
      } else if (this.state.user_type === 'sigmec') {
        var api = 'api_sigmec';
      }
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get(api) + '/pagamentos/dias/' + payment_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.handleAlert('', '', 'closed');
            self.setState({ days: responseJson.data, modal_days: true });
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'staffDebtDays',
    value: function staffDebtDays(event) {
      var staff_debt_id = event.currentTarget.value;
      var self = this;
      self.handleAlert('', '', 'open');
      if (this.state.user_type === 'sigtrip') {
        var api = 'api';
      } else if (this.state.user_type === 'sigmec') {
        var api = 'api_sigmec';
      }
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get(api) + '/saldo/devedor/dias/' + staff_debt_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.handleAlert('', '', 'closed');
            self.setState({ days: responseJson.data, modal_days: true });
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'paymentDebts',
    value: function paymentDebts(event) {
      var payment_id = event.currentTarget.value;
      var self = this;
      self.handleAlert('', '', 'open');
      if (this.state.user_type === 'sigtrip') {
        var api = 'api';
      } else if (this.state.user_type === 'sigmec') {
        var api = 'api_sigmec';
      }
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get(api) + '/pagamentos/saldos/devedores/' + payment_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.handleAlert('', '', 'closed');
            self.setState({ debts: responseJson.data, modal_debts: true });
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'staffDebtPayments',
    value: function staffDebtPayments(event) {
      var staff_debt_id = event.currentTarget.value;
      var self = this;
      self.handleAlert('', '', 'open');
      if (this.state.user_type === 'sigtrip') {
        var api = 'api';
      } else if (this.state.user_type === 'sigmec') {
        var api = 'api_sigmec';
      }
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get(api) + '/saldo/devedor/pagamentos/' + staff_debt_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.handleAlert('', '', 'closed');
            self.setState({ debt_payments: responseJson.data, modal_debt_payments: true });
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-primary pull-right', onClick: this.openTutorial },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'i',
                { className: 'fa fa-file-pdf-o' },
                ' Tutorial'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.paragrafoOControleExibeTodosOspagamentos
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.paragrafoADataDeReferenciaParaAPesquisa
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.search },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.formulario.Periodo,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.period, required: true, maskChar: null, name: 'date', mask: '99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'period'), placeholder: this.locale.general.mesAno })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.formulario.ExibirPagamentosAbertos,
                    '?'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                    className: '',
                    name: 'show_opened',
                    value: this.state.show_opened,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'show_opened'),
                    options: this.state.simple_select,
                    required: true
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'submit', className: 'btn btn-primary btn-lg btn-block', required: true },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                  ' ',
                  this.locale.general.buscar
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.consolidated, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaSaldos.semSaldoAnterior }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'previous_balance', isKey: true, dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '120' },
                this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaSaldos.SaldoAnterior
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.payments, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.semPagamentos }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'base', isKey: true, dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '120' },
                this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.BaseOperacional
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'period', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '240' },
                this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.Periodo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'order_type', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.TipoDeOrdem
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'training', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '240' },
                this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.Treinamento
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'code', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.CodigoDeControle
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'revision', dataAlign: 'center', dataFormat: this.scheduleExport, dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.Revisao
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'payment_type', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.TipoDePagamento
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'status', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.Status
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'qty', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.Quantidade
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'value', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.ValorUnitario
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'original_amount', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.ValorOriginal
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'debt_charge', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.Desconto
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'total', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.ValorRecebido
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'balance', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.Saldo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'payment_date', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.DataDoPagamento
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.actionButton, dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '150' },
                this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentos.Acoes
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.consolidated, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaValores.semValores }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'original_amount', isKey: true, dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '120' },
                this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaValores.ValorOriginal
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'debt', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '120' },
                this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaValores.Desconto
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'total', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '120' },
                this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaValores.ValorRecebido
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'balance', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '120' },
                this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaValores.Saldo
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["g" /* Modal */],
              { show: this.state.modal_days, 'aria-labelledby': 'contained-modal-title' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["g" /* Modal */].Header,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h4',
                  { className: 'pull-left' },
                  this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tituloDiasDoPagamento
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                      return _this3.setState({ modal_days: false });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["g" /* Modal */].Body,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'table-responsive' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'table',
                    { className: 'table table-bordered table-hover table-striped' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'thead',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'tr',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'th',
                          { className: 'text-center vcenter' },
                          this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaDiasDoPagamento.Data
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'th',
                          { className: 'text-center vcenter' },
                          this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaDiasDoPagamento.Diarias
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tbody',
                      null,
                      Object.keys(self.state.days).length > 0 ? Object.keys(self.state.days).map(function (k) {
                        var day = self.state.days[k];
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'tr',
                          { key: day.id },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'td',
                            { className: 'text-center vcenter' },
                            day.date_str
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'td',
                            { className: 'text-center vcenter' },
                            day.coefficient
                          )
                        );
                      }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'tr',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'td',
                          { colSpan: '2', className: 'text-center vcenter' },
                          this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaDiasDoPagamento.nenhumDiaEncontrado
                        )
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["g" /* Modal */].Footer,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                      return _this3.setState({ modal_days: false });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["g" /* Modal */],
              { show: this.state.modal_debts, 'aria-labelledby': 'contained-modal-title' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["g" /* Modal */].Header,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h4',
                  { className: 'pull-left' },
                  this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tituloDescontosRelacionados
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                      return _this3.setState({ modal_debts: false });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["g" /* Modal */].Body,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'table-responsive' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'table',
                    { className: 'table table-bordered table-hover table-striped' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'thead',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'tr',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'th',
                          { className: 'text-center vcenter' },
                          this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaDescontosRelacionados.IdDoDebito
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'th',
                          { className: 'text-center vcenter' },
                          this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaDescontosRelacionados.ReferenciaDoDebito
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'th',
                          { className: 'text-center vcenter' },
                          this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaDescontosRelacionados.ValorOriginalDoDebito
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'th',
                          { className: 'text-center vcenter' },
                          this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaDescontosRelacionados.ValorAmortizadoNoPagamento
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tbody',
                      null,
                      Object.keys(self.state.debts).map(function (k) {
                        var debt = self.state.debts[k];
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'tr',
                          { key: debt.id },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'td',
                            { className: 'text-center vcenter' },
                            debt.staff_debt_id
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'td',
                            { className: 'text-center vcenter' },
                            debt.reference
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'td',
                            { className: 'text-center vcenter' },
                            debt.staff_debt_value
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'td',
                            { className: 'text-center vcenter' },
                            debt.charge
                          )
                        );
                      })
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["g" /* Modal */].Footer,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                      return _this3.setState({ modal_debts: false });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["g" /* Modal */],
              { show: this.state.modal_debt_payments, 'aria-labelledby': 'contained-modal-title' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["g" /* Modal */].Header,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h4',
                  { className: 'pull-left' },
                  this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tituloPagamentosRelacionados
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                      return _this3.setState({ modal_debt_payments: false });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["g" /* Modal */].Body,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'table-responsive' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'table',
                    { className: 'table table-bordered table-hover table-striped' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'thead',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'tr',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'th',
                          { className: 'text-center vcenter' },
                          this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentosRelacionados.IdDoDebito
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'th',
                          { className: 'text-center vcenter' },
                          this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentosRelacionados.ReferenciaDoPagamento
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'th',
                          { className: 'text-center vcenter' },
                          this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentosRelacionados.ValorOriginalDoDebito
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'th',
                          { className: 'text-center vcenter' },
                          this.locale.Controles.ExtratoMensalDePagamentosPorDataDeReferencia.tabelaPagamentosRelacionados.ValorAmortizadoNoPagamento
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tbody',
                      null,
                      Object.keys(self.state.debt_payments).map(function (k) {
                        var debt_payment = self.state.debt_payments[k];
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'tr',
                          { key: debt_payment.id },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'td',
                            { className: 'text-center vcenter' },
                            debt_payment.payment_id
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'td',
                            { className: 'text-center vcenter' },
                            debt_payment.reference
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'td',
                            { className: 'text-center vcenter' },
                            debt_payment.staff_debt_value
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'td',
                            { className: 'text-center vcenter' },
                            debt_payment.charge
                          )
                        );
                      })
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["g" /* Modal */].Footer,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                      return _this3.setState({ modal_debt_payments: false });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return PaymentMonthControl;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (PaymentMonthControl);

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var PaymentStatementControl = function (_Component) {
  _inherits(PaymentStatementControl, _Component);

  function PaymentStatementControl(props) {
    _classCallCheck(this, PaymentStatementControl);

    var _this = _possibleConstructorReturn(this, (PaymentStatementControl.__proto__ || Object.getPrototypeOf(PaymentStatementControl)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      modal_days: false,
      modal_debts: false,
      modal_debt_payments: false,
      user_type: null,
      sigtrip_grades_list: [],
      sigtrip_trainings_list: [],
      sigmec_grades_list: [],
      sigmec_trainings_list: [],
      grades_select: [],
      trainings_select: [],
      staffs_select: [],
      source: 'sigtrip',
      reference: null,
      staff_id: null,
      date_start: '',
      date_finish: '',
      payments: [],
      days: [],
      debts: [],
      debt_payments: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.search = _this.search.bind(_this);
    _this.openTutorial = _this.openTutorial.bind(_this);
    _this.debtLabel = _this.debtLabel.bind(_this);
    _this.scheduleExport = _this.scheduleExport.bind(_this);
    _this.actionButton = _this.actionButton.bind(_this);
    _this.exportSigmec = _this.exportSigmec.bind(_this);
    _this.paymentDays = _this.paymentDays.bind(_this);
    _this.staffDebtDays = _this.staffDebtDays.bind(_this);
    _this.paymentDebts = _this.paymentDebts.bind(_this);
    _this.staffDebtPayments = _this.staffDebtPayments.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(PaymentStatementControl, [{
    key: 'handleNavTab',
    value: function handleNavTab(state, key) {
      var change = {};
      change[state] = key;
      this.setState(change);
      this.setState({ overlay: { message: '', type: '', status: '' } });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
        if (name === 'source') {
          change['reference'] = null;
          change['payments'] = [];
          if (event.value == 'sigtrip') {
            change['grades_select'] = this.state.sigtrip_grades_list;
            change['trainings_select'] = this.state.sigtrip_trainings_list;
          }
          if (event.value == 'sigmec') {
            change['grades_select'] = this.state.sigmec_grades_list;
            change['trainings_select'] = this.state.sigmec_trainings_list;
          }
          if (event.value === 'sigtrip') {
            var self = this;
            var header = this.refs.request_api.header('application/json');
            Promise.resolve(header).then(function (value) {
              var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/tripulantes/ativos/inscricao/lista';
              fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
                return response.json();
              }).catch(function (error) {
                console.error(error);
              }).then(function (responseJson) {
                if (responseJson.status === 'success') {
                  self.setState({
                    staffs_select: responseJson.data
                  });
                }
              }).then(function () {
                self.setState({ overlay: { message: '', type: '', status: 'closed' } });
                self.handleMessage();
              });
            });
          }
          if (event.value === 'sigmec') {
            var self = this;
            var header = this.refs.request_api.header('application/json');
            Promise.resolve(header).then(function (value) {
              var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaboradores/inscricao/lista';
              fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
                return response.json();
              }).catch(function (error) {
                console.error(error);
              }).then(function (responseJson) {
                if (responseJson.status === 'success') {
                  self.setState({
                    staffs_select: responseJson.data
                  });
                }
              }).then(function () {
                self.setState({ overlay: { message: '', type: '', status: 'closed' } });
                self.handleMessage();
              });
            });
          }
        }
      }
      if (name === 'type') {
        change['reference'] = null;
        change['payments'] = [];
      }
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'openTutorial',
    value: function openTutorial() {
      window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tutorials/extratos_pagamentos.pdf');
    }
  }, {
    key: 'debtLabel',
    value: function debtLabel(cell, row) {
      var botao = '';
      if (row.debt === 1 && row.credit === 1) {
        var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'text-success fa fa-fw fa-warning' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'text-danger fa fa-fw fa-warning' })
          )
        );
      } else if (row.debt === 1) {
        var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'text-danger' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-warning' })
          )
        );
      } else if (row.credit === 1) {
        var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            { className: 'text-success' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-warning' })
          )
        );
      }

      return botao;
    }
  }, {
    key: 'exportSigmec',
    value: function exportSigmec(url) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      self.setState({ overlay: { message: '', type: '', status: 'open' } });
      Promise.resolve(header).then(function (value) {
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn_sigmec') + '/tmp/' + responseJson.data);
          }
        });
      });
    }
  }, {
    key: 'scheduleExport',
    value: function scheduleExport(cell, row) {
      var _this2 = this;

      if (row.order_type == 'Missão') {
        if (row.origin == 'SIGTRIP') {
          var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/schedule_grades/main/' + row.schedule_link;
          var field = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'btn btn-link btn-sm', href: url },
            row.revision
          );
        } else if (row.origin == 'SIGMEC') {
          var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/exportar/escala/grade/visualizar/' + row.schedule_link + '/1';
          var field = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn btn-link btn-sm', onClick: function onClick() {
                return _this2.exportSigmec(url);
              } },
            row.revision
          );
        }
      } else {
        var field = row.revision;
      }
      return field;
    }
  }, {
    key: 'actionButton',
    value: function actionButton(cell, row) {
      if (row.field_type == 'Pagamento' && row.order_id > 0) {
        var modalDaysBtn = '';
        if (row.payment_type == 'Diária' || row.payment_type == 'Transporte') {
          var modalDaysBtn = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn button-inline btn-sm btn-primary', value: row.id, onClick: this.paymentDays },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-calendar' })
          );
        }

        var modalDebtsBtn = '';
        if (row.debt == 1) {
          var modalDebtsBtn = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn button-inline btn-sm btn-danger', value: row.id, onClick: this.paymentDebts },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-info-circle' })
          );
        }

        var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          modalDaysBtn,
          modalDebtsBtn
        );
      } else if (row.field_type == 'Débito') {
        var modalDaysBtn = '';
        if (row.payment_type == 'Diária' || row.payment_type == 'Transporte') {
          var modalDaysBtn = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn button-inline btn-sm btn-primary', value: row.id, onClick: this.staffDebtDays },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-calendar' })
          );
        }

        var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          modalDaysBtn,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn button-inline btn-sm btn-info', value: row.id, onClick: this.staffDebtPayments },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-info-circle' })
          )
        );
      }
      return botao;
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/pagamentos/controle/mensal';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({
              sigtrip_grades_list: responseJson.sigtrip_grades_list,
              sigtrip_trainings_list: responseJson.sigtrip_trainings_list,
              grades_select: responseJson.sigtrip_grades_list,
              trainings_select: responseJson.sigtrip_trainings_list,
              staffs_select: responseJson.sigtrip_staffs_list
            });
          }
        }).then(function () {
          var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/pagamentos/controle/mensal';
          fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson);
            if (responseJson.status === 'success') {
              self.setState({
                sigmec_grades_list: responseJson.sigmec_grades_list,
                sigmec_trainings_list: responseJson.sigmec_trainings_list
              });
            }
          }).then(function () {
            var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/checar/origem/usuario';
            fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.refs.request_api.validate(responseJson);
              if (responseJson.status === 'success') {
                self.setState({
                  user_type: responseJson.data
                });
              }
            }).then(function () {
              self.setState({ overlay: { message: '', type: '', status: 'closed' } });
              self.handleMessage();
            });
          });
        });
      });
    }
  }, {
    key: 'search',
    value: function search(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      if (this.state.user_type === 'sigtrip') {
        var api = 'api';
      } else if (this.state.user_type === 'sigmec') {
        var api = 'api_sigmec';
      }
      var datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_finish
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get(api) + '/pagamentos/controle/extrato/periodo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({
            payments: responseJson.data.payments
          });
          if (responseJson.status == 'error') {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'paymentDays',
    value: function paymentDays(event) {
      var payment_id = event.currentTarget.value;
      var self = this;
      self.handleAlert('', '', 'open');
      if (this.state.user_type === 'sigtrip') {
        var api = 'api';
      } else if (this.state.user_type === 'sigmec') {
        var api = 'api_sigmec';
      }
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get(api) + '/pagamentos/dias/' + payment_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.handleAlert('', '', 'closed');
            self.setState({ days: responseJson.data, modal_days: true });
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'staffDebtDays',
    value: function staffDebtDays(event) {
      var staff_debt_id = event.currentTarget.value;
      var self = this;
      self.handleAlert('', '', 'open');
      if (this.state.user_type === 'sigtrip') {
        var api = 'api';
      } else if (this.state.user_type === 'sigmec') {
        var api = 'api_sigmec';
      }
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get(api) + '/saldo/devedor/dias/' + staff_debt_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.handleAlert('', '', 'closed');
            self.setState({ days: responseJson.data, modal_days: true });
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'paymentDebts',
    value: function paymentDebts(event) {
      var payment_id = event.currentTarget.value;
      var self = this;
      self.handleAlert('', '', 'open');
      if (this.state.user_type === 'sigtrip') {
        var api = 'api';
      } else if (this.state.user_type === 'sigmec') {
        var api = 'api_sigmec';
      }
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get(api) + '/pagamentos/saldos/devedores/' + payment_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.handleAlert('', '', 'closed');
            self.setState({ debts: responseJson.data, modal_debts: true });
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'staffDebtPayments',
    value: function staffDebtPayments(event) {
      var staff_debt_id = event.currentTarget.value;
      var self = this;
      self.handleAlert('', '', 'open');
      if (this.state.user_type === 'sigtrip') {
        var api = 'api';
      } else if (this.state.user_type === 'sigmec') {
        var api = 'api_sigmec';
      }
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get(api) + '/saldo/devedor/pagamentos/' + staff_debt_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.handleAlert('', '', 'closed');
            self.setState({ debt_payments: responseJson.data, modal_debt_payments: true });
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Layout_Topo__["a" /* default */], { promptInstall: this.props.promptInstall }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-primary pull-right', onClick: this.openTutorial },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'i',
                { className: 'fa fa-file-pdf-o' },
                ' Tutorial'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.paragrafoOControleExibeTodosOspagamentos
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.paragrafoAsDatasDeReferenciaParaAPesquisa
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.search },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.formulario.Inicio,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_start, required: true, maskChar: null, name: 'date', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: this.locale.general.diaMesAno })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.formulario.Termino,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_finish, required: true, maskChar: null, name: 'date', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: this.locale.general.diaMesAno })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'submit', className: 'btn btn-primary btn-lg btn-block', required: true },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                  ' ',
                  this.locale.general.buscar
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.payments, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaPagamentos.semPagamentos }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'base', isKey: true, dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '120' },
                this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaPagamentos.BaseOperacional
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'aircraft_model', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '240' },
                this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaPagamentos.Frota
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'period', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '240' },
                this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaPagamentos.Periodo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'order_type', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaPagamentos.TipoDeOrdem
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'training', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaPagamentos.Treinamento
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'code', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaPagamentos.CodigoDeControle
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'revision', dataAlign: 'center', dataFormat: this.scheduleExport, dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaPagamentos.Revisao
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'payment_type', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaPagamentos.TipoDePagamento
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'status', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaPagamentos.Status
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'qty', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaPagamentos.Quantidade
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'value', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaPagamentos.ValorUnitario
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'original_amount', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaPagamentos.ValorOriginal
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'debt_charge', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaPagamentos.Desconto
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'total', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaPagamentos.ValorRecebido
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'balance', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaPagamentos.Saldo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'payment_date', dataAlign: 'center', dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaPagamentos.DataDoPagamento
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.actionButton, dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '150' },
                this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaPagamentos.Acoes
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["g" /* Modal */],
              { show: this.state.modal_days, 'aria-labelledby': 'contained-modal-title' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["g" /* Modal */].Header,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h4',
                  { className: 'pull-left' },
                  this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tituloDiasDoPagamento
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                      return _this3.setState({ modal_days: false });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["g" /* Modal */].Body,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'table-responsive' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'table',
                    { className: 'table table-bordered table-hover table-striped' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'thead',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'tr',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'th',
                          { className: 'text-center vcenter' },
                          this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaDiasDoPagamento.Data
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'th',
                          { className: 'text-center vcenter' },
                          this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaDiasDoPagamento.Diarias
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tbody',
                      null,
                      Object.keys(self.state.days).length > 0 ? Object.keys(self.state.days).map(function (k) {
                        var day = self.state.days[k];
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'tr',
                          { key: day.id },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'td',
                            { className: 'text-center vcenter' },
                            day.date_str
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'td',
                            { className: 'text-center vcenter' },
                            day.coefficient
                          )
                        );
                      }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'tr',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'td',
                          { colSpan: '2', className: 'text-center vcenter' },
                          this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaDiasDoPagamento.nenhumDiaEncontrado
                        )
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["g" /* Modal */].Footer,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                      return _this3.setState({ modal_days: false });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["g" /* Modal */],
              { show: this.state.modal_debts, 'aria-labelledby': 'contained-modal-title' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["g" /* Modal */].Header,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h4',
                  { className: 'pull-left' },
                  this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tituloDescontosRelacionados
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                      return _this3.setState({ modal_debts: false });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["g" /* Modal */].Body,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'table-responsive' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'table',
                    { className: 'table table-bordered table-hover table-striped' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'thead',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'tr',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'th',
                          { className: 'text-center vcenter' },
                          this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaDescontosRelacionados.IdDoDebito
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'th',
                          { className: 'text-center vcenter' },
                          this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaDescontosRelacionados.ReferenciaDoDebito
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'th',
                          { className: 'text-center vcenter' },
                          this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaDescontosRelacionados.ValorOriginalDoDebito
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'th',
                          { className: 'text-center vcenter' },
                          this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaDescontosRelacionados.ValorAmortizadoNoPagamento
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tbody',
                      null,
                      Object.keys(self.state.debts).map(function (k) {
                        var debt = self.state.debts[k];
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'tr',
                          { key: debt.id },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'td',
                            { className: 'text-center vcenter' },
                            debt.staff_debt_id
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'td',
                            { className: 'text-center vcenter' },
                            debt.reference
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'td',
                            { className: 'text-center vcenter' },
                            debt.staff_debt_value
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'td',
                            { className: 'text-center vcenter' },
                            debt.charge
                          )
                        );
                      })
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["g" /* Modal */].Footer,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                      return _this3.setState({ modal_debts: false });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["g" /* Modal */],
              { show: this.state.modal_debt_payments, 'aria-labelledby': 'contained-modal-title' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["g" /* Modal */].Header,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h4',
                  { className: 'pull-left' },
                  this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tituloPagamentosRelacionados
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                      return _this3.setState({ modal_debt_payments: false });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["g" /* Modal */].Body,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'table-responsive' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'table',
                    { className: 'table table-bordered table-hover table-striped' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'thead',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'tr',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'th',
                          { className: 'text-center vcenter' },
                          this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaPagamentosRelacionados.IdDoDebito
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'th',
                          { className: 'text-center vcenter' },
                          this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaPagamentosRelacionados.ReferenciaDoPagamento
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'th',
                          { className: 'text-center vcenter' },
                          this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaPagamentosRelacionados.ValorOriginalDoDebito
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'th',
                          { className: 'text-center vcenter' },
                          this.locale.Controles.ExtratoPagamentosPorPeriodoPorDataDePagamento.tabelaPagamentosRelacionados.ValorAmortizadoNoPagamento
                        )
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tbody',
                      null,
                      Object.keys(self.state.debt_payments).map(function (k) {
                        var debt_payment = self.state.debt_payments[k];
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'tr',
                          { key: debt_payment.id },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'td',
                            { className: 'text-center vcenter' },
                            debt_payment.payment_id
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'td',
                            { className: 'text-center vcenter' },
                            debt_payment.reference
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'td',
                            { className: 'text-center vcenter' },
                            debt_payment.staff_debt_value
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'td',
                            { className: 'text-center vcenter' },
                            debt_payment.charge
                          )
                        );
                      })
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap__["g" /* Modal */].Footer,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                      return _this3.setState({ modal_debt_payments: false });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return PaymentStatementControl;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (PaymentStatementControl);

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var DrowsinessSchedulesAdd = function (_Component) {
  _inherits(DrowsinessSchedulesAdd, _Component);

  // constructor
  function DrowsinessSchedulesAdd(props) {
    _classCallCheck(this, DrowsinessSchedulesAdd);

    var _this = _possibleConstructorReturn(this, (DrowsinessSchedulesAdd.__proto__ || Object.getPrototypeOf(DrowsinessSchedulesAdd)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      applicabilities_list: [],
      staff_list: [],
      date_start: '',
      date_finish: '',
      send_hours: '',
      name: ''
    };

    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.add = _this.add.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(DrowsinessSchedulesAdd, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeApplicability',
    value: function handleSelectChangeApplicability(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;

        var header = this.refs.request_api.header('application/json');
        var self = this;
        this.handleAlert('', '', 'open');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aplicabilidade/colaboradores/listagens/' + event.value, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.setState({ staff_list: responseJson.data.staffs });
            self.handleAlert(responseJson.message, responseJson.status, 'closed');
          });
        });
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeMulti',
    value: function handleSelectChangeMulti(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/parametros-de-fadiga/listagens';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ applicabilities_list: responseJson.data.applicabilities });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
        }); /* Overlay */
      });
    }
  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      this.handleAlert(this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.aguardeEnquantoAEscalaEGerada, 'warning', 'open');
      var datasave = {
        name: this.state.name,
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        send_hours: this.state.send_hours,
        applicability_id: this.state.applicability_id,
        staff_id: this.state.staff_id
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/escala/sonolencia', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var url = '/escala/sonolencia/editar/' + responseJson.data.id;
            var storage = {
              alert_message: responseJson.message,
              alert_type: responseJson.status
            };
            localStorage.setItem("verify_message", JSON.stringify(storage));
            self.setState({ redirect_url: url });
          }
          self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.add },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.Nome,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'name', className: 'form-control', placeholder: this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.placeholder.NomeDaEscalaDeSonolencia, value: this.state.name, onChange: this.handleChange.bind(this, 'name') })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.HorariosDeEnvio,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'send_hours', className: 'form-control', placeholder: this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.placeholder.HorariosDeEnvio, value: this.state.send_hours, onChange: this.handleChange.bind(this, 'send_hours') })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.DataInicial,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.date_start, required: true, maskChar: null, name: 'date_start', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: '' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.DataFinal,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.date_finish, required: true, maskChar: null, name: 'date_finish', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: '' })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.AplicabilidadeTipoDeColaborador,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'applicability_id',
                      value: this.state.applicability_id,
                      searchable: true,
                      placeholder: this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.placeholder.SelecionarAplicabilidade,
                      onChange: this.handleSelectChangeApplicability.bind(this, 'applicability_id'),
                      options: this.state.applicabilities_list
                    })
                  )
                ),
                this.state.applicability_id === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.Tripulantes,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'staff_id',
                      value: this.state.staff_id,
                      searchable: true,
                      placeholder: this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.placeholder.SelecionarAplicabilidade,
                      onChange: this.handleSelectChangeMulti.bind(this, 'staff_id'),
                      options: this.state.staff_list,
                      multi: true
                    })
                  )
                ) : this.state.applicability_id === 2 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.Mecanicos,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'staff_id',
                      value: this.state.staff_id,
                      searchable: true,
                      placeholder: this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.placeholder.SelecionarAplicabilidade,
                      onChange: this.handleSelectChangeMulti.bind(this, 'staff_id'),
                      options: this.state.staff_list,
                      multi: true
                    })
                  )
                ) : this.state.applicability_id === 3 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.Coordenadores,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'staff_id',
                      value: this.state.staff_id,
                      searchable: true,
                      placeholder: this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.placeholder.SelecionarAplicabilidade,
                      onChange: this.handleSelectChangeMulti.bind(this, 'staff_id'),
                      options: this.state.staff_list,
                      multi: true
                    })
                  )
                ) : ''
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                    ' ',
                    this.locale.EscalasDeTesteDeSonolencia.AdicionarEscalaDeSonolencia.formulario.botaoAdicionarEscalaDeTeste
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return DrowsinessSchedulesAdd;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (DrowsinessSchedulesAdd);

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Elements_DrowsinessSchedulesEditTab__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Elements_DrowsinessScheduleTestTab__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Elements_DrowsinessScheduleResultTab__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












// Tabs





var PropTypes = __webpack_require__(5);

var DrowsinessSchedulesEdit = function (_Component) {
  _inherits(DrowsinessSchedulesEdit, _Component);

  function DrowsinessSchedulesEdit(props) {
    _classCallCheck(this, DrowsinessSchedulesEdit);

    var _this = _possibleConstructorReturn(this, (DrowsinessSchedulesEdit.__proto__ || Object.getPrototypeOf(DrowsinessSchedulesEdit)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      file: {
        class: '',
        status_str: '',
        status_alt_str: '',
        id: ''
      },
      redirect_url: false,
      loaded: 0,
      actual_id: _this.props.match.params.id,
      key: 1,
      drowsiness_schedule_data: {},
      updated: 0
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.updateData = _this.updateData.bind(_this);
    _this.changeStatus = _this.changeStatus.bind(_this);
    _this.confirmChangeStatus = _this.confirmChangeStatus.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  _createClass(DrowsinessSchedulesEdit, [{
    key: 'handleNavTab',
    value: function handleNavTab(state, key) {
      var change = {};
      change[state] = key;
      this.setState(change);
      this.setState({ overlay: { message: '', type: '', status: '' } });
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }

    //LM

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ actual_id: this.props.match.params.id });
        this.setState({ loaded: 2 }, this.loadData());
      }
      if (this.props.match.params.id !== this.state.actual_id) {
        this.handleAlert('', '', 'open');
        this.setState({ actual_id: this.props.match.params.id });
        var responseJson = { data: '', status: '', message: '' };
        this.updateData(responseJson);
      }
    }
  }, {
    key: 'updateData',
    value: function updateData(responseJson) {
      this.setState({ updated: 1 }, this.loadData(responseJson));
    }
  }, {
    key: 'loadData',
    value: function loadData(event) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/escala/sonolencia/' + self.props.match.params.id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url', '/escalas/sonolencia');
          if (responseJson.status === 'success') {
            self.setState({
              drowsiness_schedule_data: responseJson.data.drowsiness_schedule_data,
              drowsiness_schedule_applicability: responseJson.data.drowsiness_schedule_data.applicability_id,
              drowsiness_schedule_tests: responseJson.data.drowsiness_schedule_tests,
              staff_list: responseJson.data.staff_list,
              drowsiness_schedule_reports: responseJson.data.reports
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          if (self.state.updated == 1) {
            self.handleAlert(event.message, event.status, 'open');
            self.setState({ updated: 0 });
          } else {
            self.handleMessage();
          }
        }); /* Overlay */
      });
    }
  }, {
    key: 'confirmChangeStatus',
    value: function confirmChangeStatus(event) {
      this.handleAlert('', '', 'open');
      var url = event.currentTarget.value;
      var confirm = this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.trocarStatusDaEscala;
      if (url === '/escala/sonolencia/' + this.state.drowsiness_schedule_data.id + '/trocar/status/aprovado') {
        confirm = window.confirm(this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.trocarStatusDaEscalaParaAprovado);
      } else if (url === '/escala/sonolencia/' + this.state.drowsiness_schedule_data.id + '/trocar/status/finalizado') {
        confirm = window.confirm(this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.trocarStatusDaEscalaParaFinalizado);
      }
      if (confirm) {
        this.setState({
          modal_change_status: false,
          iframe: 'iframe-hidden'
        });
        var datasave = {};
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.updateData(responseJson);
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'changeStatus',
    value: function changeStatus(url) {
      var confirm = this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.trocarStatusDaEscala;
      if (url === '/escala/sonolencia/' + this.state.drowsiness_schedule_data.id + '/trocar/status/aprovado') {
        confirm = window.confirm(this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.trocarStatusDaEscalaParaAprovado);
      } else if (url === '/escala/sonolencia/' + this.state.drowsiness_schedule_data.id + '/trocar/status/finalizado') {
        confirm = window.confirm(this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.trocarStatusDaEscalaParaFinalizado);
      }
      if (confirm) {
        var datasave = {};
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.updateData(responseJson);
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: self.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__["a" /* default */], { overlay: self.state.overlay, handleAlert: self.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'grid-buttons pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["h" /* Dropdown */],
                { id: 'revisions' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["h" /* Dropdown */].Toggle,
                  { bsStyle: 'danger' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-certificate' }),
                  ' ',
                  self.state.drowsiness_schedule_data.status_str
                ),
                self.state.drowsiness_schedule_data.status === 'rascunho' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["h" /* Dropdown */].Menu,
                  { className: 'super-colors' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { onSelect: self.changeStatus, eventKey: '/escala/sonolencia/' + self.state.drowsiness_schedule_data.id + '/trocar/status/aprovado' },
                    this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.botaoDeFichas.TrocarParaAprovado
                  )
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["h" /* Dropdown */].Menu,
                  { className: 'super-colors' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { onSelect: self.changeStatus, eventKey: '/escala/sonolencia/' + self.state.drowsiness_schedule_data.id + '/trocar/status/finalizado' },
                    this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.botaoDeFichas.TrocarParaFinalizado
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
                { to: '/escalas/sonolencia', className: 'btn btn-default' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-left' }),
                ' ',
                this.locale.general.voltar
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Tabs */],
              { activeKey: self.state.key, onSelect: self.handleNavTab.bind(self, 'key'), id: 'controlled-tab-example' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 1, title: this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabDadosDaEscala.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Elements_DrowsinessSchedulesEditTab__["a" /* default */], { updateData: self.updateData, updated: self.state.updated, handleAlert: self.handleAlert, drowsiness_schedule_id: self.props.match.params.id, drowsiness_schedule_data: self.state.drowsiness_schedule_data })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 2, title: this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Elements_DrowsinessScheduleTestTab__["a" /* default */], { RequestApi: self.refs.request_api, updateData: self.updateData, status: self.state.drowsiness_schedule_data.status, updated: self.state.updated, handleAlert: self.handleAlert, drowsiness_schedule_id: self.props.match.params.id, drowsiness_schedule_data: self.state.drowsiness_schedule_data, drowsiness_schedule_tests: self.state.drowsiness_schedule_tests, staff_list: self.state.staff_list, drowsiness_schedule_status: self.state.drowsiness_schedule_status })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 3, title: this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Elements_DrowsinessScheduleResultTab__["a" /* default */], { RequestApi: self.refs.request_api, updateData: self.updateData, status: self.state.drowsiness_schedule_data.status, updated: self.state.updated, handleAlert: self.handleAlert, drowsiness_schedule_id: self.props.match.params.id, drowsiness_schedule_reports: self.state.drowsiness_schedule_reports, drowsiness_schedule_status: self.state.drowsiness_schedule_status, drowsiness_schedule_applicability: self.state.drowsiness_schedule_applicability })
              )
            )
          )
        )
      );
    }
  }]);

  return DrowsinessSchedulesEdit;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DrowsinessSchedulesEdit.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (DrowsinessSchedulesEdit);

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// Importação da tabela



var DrowsinessSchedulesIndex = function (_Component) {
  _inherits(DrowsinessSchedulesIndex, _Component);

  function DrowsinessSchedulesIndex(props) {
    _classCallCheck(this, DrowsinessSchedulesIndex);

    var _this = _possibleConstructorReturn(this, (DrowsinessSchedulesIndex.__proto__ || Object.getPrototypeOf(DrowsinessSchedulesIndex)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.loadData = _this.loadData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(DrowsinessSchedulesIndex, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/escalas/sonolencia', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var url = '/escala/sonolencia/editar/' + cell;
      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
          { className: 'btn btn-primary btn-sm', to: url },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
        )
      );

      return botao;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.EscalasDeTesteDeSonolencia.ListaDeEscalasDeTesteDeSonolencia.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/escala/sonolencia/cadastrar', className: 'btn btn-primary pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-plus' }),
              ' ',
              this.locale.EscalasDeTesteDeSonolencia.ListaDeEscalasDeTesteDeSonolencia.botaoAdicionarEscala
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.EscalasDeTesteDeSonolencia.ListaDeEscalasDeTesteDeSonolencia.tabela.semEscalas }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.EscalasDeTesteDeSonolencia.ListaDeEscalasDeTesteDeSonolencia.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'name', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.EscalasDeTesteDeSonolencia.ListaDeEscalasDeTesteDeSonolencia.tabela.Nome
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'date_start_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.EscalasDeTesteDeSonolencia.ListaDeEscalasDeTesteDeSonolencia.tabela.DataInicial
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'date_finish_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.EscalasDeTesteDeSonolencia.ListaDeEscalasDeTesteDeSonolencia.tabela.DataFinal
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '100' },
                this.locale.EscalasDeTesteDeSonolencia.ListaDeEscalasDeTesteDeSonolencia.tabela.Acoes
              )
            )
          )
        )
      );
    }
  }]);

  return DrowsinessSchedulesIndex;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (DrowsinessSchedulesIndex);

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_recharts__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var DrowsinessScheduleResultTab = function (_Component) {
  _inherits(DrowsinessScheduleResultTab, _Component);

  function DrowsinessScheduleResultTab(props) {
    _classCallCheck(this, DrowsinessScheduleResultTab);

    var _this = _possibleConstructorReturn(this, (DrowsinessScheduleResultTab.__proto__ || Object.getPrototypeOf(DrowsinessScheduleResultTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      id: _this.props.drowsiness_schedule_id,
      horas_registradas: null,
      hours_registred_active: 0,
      days_period_active: 0,
      jornadas_horas: null,
      jornadas_dias: null,
      bases_array: null,
      roles_array: null,
      groups_array: null,
      aircraft_models_array: null,
      designations_array: null,
      hours_registred_list: [],
      bases_list: [],
      roles_list: [],
      designations_list: [],
      aircraft_models_list: [],
      groups_list: [],
      hours_registred: null,
      days_period: null
    };

    _this.searchReports = _this.searchReports.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(DrowsinessScheduleResultTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeMulti',
    value: function handleSelectChangeMulti(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (typeof newProps.drowsiness_schedule_id !== 'undefined' && typeof newProps.drowsiness_schedule_reports !== 'undefined') {
        this.setState({
          id: newProps.drowsiness_schedule_id,
          applicability_id: newProps.drowsiness_schedule_applicability,
          hours_registred_list: newProps.drowsiness_schedule_reports.hours_registred_list,
          bases_list: newProps.drowsiness_schedule_reports.bases_list,
          roles_list: newProps.drowsiness_schedule_reports.roles_list,
          designations_list: newProps.drowsiness_schedule_reports.designations_list,
          aircraft_models_list: newProps.drowsiness_schedule_reports.aircraft_models_list,
          groups_list: newProps.drowsiness_schedule_reports.groups_list
        });
      }
    }
  }, {
    key: 'searchReports',
    value: function searchReports(event) {
      event.preventDefault();
      var self = this;
      self.props.handleAlert('', '', 'open');
      var datasave = {
        hours_registred: this.state.hours_registred,
        days_period: this.state.days_period,
        bases: this.state.bases,
        bases_list: this.state.bases_list,
        roles: this.state.roles,
        roles_list: this.state.roles_list,
        designations: this.state.designations,
        designations_list: this.state.designations_list,
        aircraft_models: this.state.aircraft_models,
        aircraft_models_list: this.state.aircraft_models_list,
        groups: this.state.groups,
        groups_list: this.state.groups_list,
        drowsiness_schedule_id: this.state.id
      };

      var header = self.props.RequestApi.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/escala/sonolencia/relatorio', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.props.RequestApi.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ horas_registradas: responseJson.data.horas_registradas });
            self.setState({ jornadas_dias: responseJson.data.jornadas_dias });
            self.setState({ jornadas_horas: responseJson.data.jornadas_horas });
            self.setState({ bases_array: responseJson.data.bases_array });
            self.setState({ roles_array: responseJson.data.roles_array });
            self.setState({ groups_array: responseJson.data.groups_array });
            self.setState({ aircraft_models_array: responseJson.data.aircraft_models_array });
            self.setState({ designations_array: responseJson.data.designations_array });
            self.setState({ percent_result: responseJson.data.percent_result });
            self.setState({ percent_result_global: responseJson.data.percent_result_global });
            self.setState({ media_time_report: responseJson.data.media_time_report });
            self.setState({ reports: responseJson.data.reports });
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: self.searchReports },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.PeriodoDeJornada,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */], {
                  className: 'form-field-name',
                  name: 'hours_registred',
                  value: this.state.hours_registred,
                  searchable: true,
                  placeholder: this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.placeholder.SelecionarPeriodoDeJornada,
                  multi: true,
                  onChange: this.handleSelectChangeMulti.bind(this, 'hours_registred'),
                  options: this.state.hours_registred_list
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.DiasDeJornada,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'days_period', className: 'form-control', placeholder: this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.placeholder.DiasDeJornada, value: this.state.days_period, onChange: this.handleChange.bind(this, 'days_period') })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.Bases,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */], {
                  className: 'form-field-name',
                  name: 'bases',
                  value: this.state.bases,
                  searchable: true,
                  placeholder: this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.placeholder.SelecionarBases,
                  multi: true,
                  onChange: this.handleSelectChangeMulti.bind(this, 'bases'),
                  options: this.state.bases_list
                })
              )
            ),
            this.state.applicability_id === 1 || this.state.applicability_id === 4 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.Designacoes,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */], {
                  className: 'form-field-name',
                  name: 'designations',
                  value: this.state.designations,
                  searchable: true,
                  placeholder: this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.placeholder.SelecionarDesignacoes,
                  multi: true,
                  onChange: this.handleSelectChangeMulti.bind(this, 'designations'),
                  options: this.state.designations_list
                })
              )
            ) : this.state.applicability_id === 2 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.Funcoes,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */], {
                  className: 'form-field-name',
                  name: 'roles',
                  value: this.state.roles,
                  searchable: true,
                  placeholder: this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.placeholder.SelecionarFuncoes,
                  multi: true,
                  onChange: this.handleSelectChangeMulti.bind(this, 'roles'),
                  options: this.state.roles_list
                })
              )
            ) : this.state.applicability_id === 3 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.Cargos,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */], {
                  className: 'form-field-name',
                  name: 'roles',
                  value: this.state.roles,
                  searchable: true,
                  placeholder: this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.placeholder.SelecionarCargos,
                  multi: true,
                  onChange: this.handleSelectChangeMulti.bind(this, 'roles'),
                  options: this.state.roles_list
                })
              )
            ) : ''
          ),
          this.state.applicability_id === 1 || this.state.applicability_id === 4 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.Frotas,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */], {
                  className: 'form-field-name',
                  name: 'aircraft_models',
                  value: this.state.aircraft_models,
                  searchable: true,
                  placeholder: this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.placeholder.SelecionarFrotas,
                  multi: true,
                  onChange: this.handleSelectChangeMulti.bind(this, 'aircraft_models'),
                  options: this.state.aircraft_models_list
                })
              )
            )
          ) : this.state.applicability_id === 2 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.Grupos,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */], {
                  className: 'form-field-name',
                  name: 'groups',
                  value: this.state.groups,
                  searchable: true,
                  placeholder: this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.placeholder.SelecionarGrupos,
                  multi: true,
                  onChange: this.handleSelectChangeMulti.bind(this, 'groups'),
                  options: this.state.groups_list
                })
              )
            )
          ) : '',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { type: 'submit', className: 'btn btn-primary btn-block' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
              ' ',
              this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.formulario.botaoProcurarRelatorios
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        self.state.horas_registradas !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            null,
            this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tituloPontosPorHorarioDeResposta
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.paragrafoPercentualDeAdesaoParcial,
            ' ',
            self.state.percent_result
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.paragrafoPercentualDeAdesaoGlobal,
            ' ',
            self.state.percent_result_global
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.paragrafoTempoMedioDeResposta,
            ' ',
            self.state.media_time_report
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'p',
            null,
            this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.paragrafoTotalRespostas,
            ' ',
            self.state.reports
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            null,
            this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tituloCadaHorarioDeResposta
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaHorariosDeResposta.PeriodoHoras
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaHorariosDeResposta.Total
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaHorariosDeResposta.Pontos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaHorariosDeResposta.Media
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'horas' },
              self.state.horas_registradas !== null ? Object.keys(self.state.horas_registradas.table).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    k
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    self.state.horas_registradas.table[k].total
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    self.state.horas_registradas.table[k].points
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    self.state.horas_registradas.table[k].media
                  )
                );
              }) : ""
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'hidden-sm hidden-xs' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_recharts__["a" /* LineChart */],
              { width: 890, height: 400, data: self.state.horas_registradas.horas,
                margin: { top: 5, right: 30, left: 20, bottom: 5 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["b" /* XAxis */], { dataKey: 'name' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["c" /* YAxis */], { dataKey: 'M\xE9dia' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["e" /* Tooltip */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["f" /* Legend */], null),
              Object.keys(self.state.horas_registradas.names).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.horas_registradas.names[k].name, stroke: self.state.horas_registradas.names[k].color, activeDot: { r: 8 } });
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'visible-sm-inline-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_recharts__["a" /* LineChart */],
              { width: 690, height: 300, data: self.state.horas_registradas.horas,
                margin: { top: 5, right: 30, left: 20, bottom: 5 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["b" /* XAxis */], { dataKey: 'name' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["c" /* YAxis */], { dataKey: 'M\xE9dia' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["e" /* Tooltip */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["f" /* Legend */], null),
              Object.keys(self.state.horas_registradas.names).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.horas_registradas.names[k].name, stroke: self.state.horas_registradas.names[k].color, activeDot: { r: 8 } });
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'visible-xs-inline-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_recharts__["a" /* LineChart */],
              { width: 280, height: 400, data: self.state.horas_registradas.horas,
                margin: { top: 5, right: 30, left: 20, bottom: 5 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["b" /* XAxis */], { dataKey: 'name' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["c" /* YAxis */], { dataKey: 'M\xE9dia' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["e" /* Tooltip */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["f" /* Legend */], null),
              Object.keys(self.state.horas_registradas.names).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.horas_registradas.names[k].name, stroke: self.state.horas_registradas.names[k].color, activeDot: { r: 8 } });
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : "",
        self.state.jornadas_horas !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            null,
            this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tituloPontosPorPeriodoDeJornada
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaPontosPorPeriodoDeJornada.PeriodoHoras
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaPontosPorPeriodoDeJornada.Total
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaPontosPorPeriodoDeJornada.Pontos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaPontosPorPeriodoDeJornada.Media
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'periodo' },
              self.state.jornadas_horas !== null ? Object.keys(self.state.jornadas_horas.table).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    k
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    self.state.jornadas_horas.table[k].total
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    self.state.jornadas_horas.table[k].points
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    self.state.jornadas_horas.table[k].media
                  )
                );
              }) : ""
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'hidden-sm hidden-xs' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_recharts__["a" /* LineChart */],
              { width: 890, height: 400, data: self.state.jornadas_horas.horas,
                margin: { top: 5, right: 30, left: 20, bottom: 5 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["b" /* XAxis */], { dataKey: 'name' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["c" /* YAxis */], { dataKey: 'M\xE9dia' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["e" /* Tooltip */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["f" /* Legend */], null),
              Object.keys(self.state.jornadas_horas.names).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.jornadas_horas.names[k].name, stroke: self.state.jornadas_horas.names[k].color, activeDot: { r: 8 } });
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'visible-sm-inline-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_recharts__["a" /* LineChart */],
              { width: 690, height: 300, data: self.state.jornadas_horas.horas,
                margin: { top: 5, right: 30, left: 20, bottom: 5 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["b" /* XAxis */], { dataKey: 'name' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["c" /* YAxis */], { dataKey: 'M\xE9dia' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["e" /* Tooltip */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["f" /* Legend */], null),
              Object.keys(self.state.jornadas_horas.names).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.jornadas_horas.names[k].name, stroke: self.state.jornadas_horas.names[k].color, activeDot: { r: 8 } });
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'visible-xs-inline-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_recharts__["a" /* LineChart */],
              { width: 280, height: 400, data: self.state.jornadas_horas.horas,
                margin: { top: 5, right: 30, left: 20, bottom: 5 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["b" /* XAxis */], { dataKey: 'name' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["c" /* YAxis */], { dataKey: 'M\xE9dia' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["e" /* Tooltip */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["f" /* Legend */], null),
              Object.keys(self.state.jornadas_horas.names).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.jornadas_horas.names[k].name, stroke: self.state.jornadas_horas.names[k].color, activeDot: { r: 8 } });
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : "",
        self.state.jornadas_dias !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            null,
            this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tituloPontosPorDiasDeJornada
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaPontosPorDiasDeJornada.PeriodoDias
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaPontosPorDiasDeJornada.Total
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaPontosPorDiasDeJornada.Pontos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaPontosPorDiasDeJornada.Media
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'dias' },
              self.state.jornadas_dias !== null ? Object.keys(self.state.jornadas_dias.table).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    k
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    self.state.jornadas_dias.table[k].total
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    self.state.jornadas_dias.table[k].points
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    self.state.jornadas_dias.table[k].media
                  )
                );
              }) : ""
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'hidden-sm hidden-xs' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_recharts__["a" /* LineChart */],
              { width: 890, height: 400, data: self.state.jornadas_dias.horas,
                margin: { top: 5, right: 30, left: 20, bottom: 5 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["b" /* XAxis */], { dataKey: 'name' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["c" /* YAxis */], { dataKey: 'M\xE9dia' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["e" /* Tooltip */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["f" /* Legend */], null),
              Object.keys(self.state.jornadas_dias.names).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.jornadas_dias.names[k].name, stroke: self.state.jornadas_dias.names[k].color, activeDot: { r: 8 } });
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'visible-sm-inline-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_recharts__["a" /* LineChart */],
              { width: 690, height: 300, data: self.state.jornadas_dias.horas,
                margin: { top: 5, right: 30, left: 20, bottom: 5 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["b" /* XAxis */], { dataKey: 'name' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["c" /* YAxis */], { dataKey: 'M\xE9dia' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["e" /* Tooltip */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["f" /* Legend */], null),
              Object.keys(self.state.jornadas_dias.names).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.jornadas_dias.names[k].name, stroke: self.state.jornadas_dias.names[k].color, activeDot: { r: 8 } });
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'visible-xs-inline-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_recharts__["a" /* LineChart */],
              { width: 280, height: 400, data: self.state.jornadas_dias.horas,
                margin: { top: 5, right: 30, left: 20, bottom: 5 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["b" /* XAxis */], { dataKey: 'name' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["c" /* YAxis */], { dataKey: 'M\xE9dia' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["e" /* Tooltip */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["f" /* Legend */], null),
              Object.keys(self.state.jornadas_dias.names).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.jornadas_dias.names[k].name, stroke: self.state.jornadas_dias.names[k].color, activeDot: { r: 8 } });
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : "",
        self.state.bases_array !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            null,
            this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tituloBases
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaBases.Base
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaBases.Total
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaBases.Pontos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaBases.Media
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'bases' },
              self.state.bases_array !== null ? Object.keys(self.state.bases_array.table).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    k
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    self.state.bases_array.table[k].total
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    self.state.bases_array.table[k].points
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    self.state.bases_array.table[k].media
                  )
                );
              }) : ""
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'hidden-sm hidden-xs' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_recharts__["a" /* LineChart */],
              { width: 890, height: 400, data: self.state.bases_array.horas,
                margin: { top: 5, right: 30, left: 20, bottom: 5 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["b" /* XAxis */], { dataKey: 'name' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["c" /* YAxis */], { dataKey: 'M\xE9dia' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["e" /* Tooltip */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["f" /* Legend */], null),
              Object.keys(self.state.bases_array.names).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.bases_array.names[k].name, stroke: self.state.bases_array.names[k].color, activeDot: { r: 8 } });
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'visible-sm-inline-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_recharts__["a" /* LineChart */],
              { width: 690, height: 300, data: self.state.bases_array.horas,
                margin: { top: 5, right: 30, left: 20, bottom: 5 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["b" /* XAxis */], { dataKey: 'name' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["c" /* YAxis */], { dataKey: 'M\xE9dia' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["e" /* Tooltip */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["f" /* Legend */], null),
              Object.keys(self.state.bases_array.names).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.bases_array.names[k].name, stroke: self.state.bases_array.names[k].color, activeDot: { r: 8 } });
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'visible-xs-inline-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_recharts__["a" /* LineChart */],
              { width: 280, height: 400, data: self.state.bases_array.horas,
                margin: { top: 5, right: 30, left: 20, bottom: 5 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["b" /* XAxis */], { dataKey: 'name' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["c" /* YAxis */], { dataKey: 'M\xE9dia' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["e" /* Tooltip */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["f" /* Legend */], null),
              Object.keys(self.state.bases_array.names).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.bases_array.names[k].name, stroke: self.state.bases_array.names[k].color, activeDot: { r: 8 } });
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : "",
        self.state.roles_array !== null && self.state.roles_array !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            null,
            this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tituloFuncoes
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaFuncoes.Funcao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaFuncoes.Total
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaFuncoes.Pontos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaFuncoes.Media
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'funcoes' },
              self.state.roles_array !== null && self.state.roles_array !== 'undefined' ? Object.keys(self.state.roles_array.table).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    k
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    self.state.roles_array.table[k].total
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    self.state.roles_array.table[k].points
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    self.state.roles_array.table[k].media
                  )
                );
              }) : ""
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'hidden-sm hidden-xs' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_recharts__["a" /* LineChart */],
              { width: 890, height: 400, data: self.state.roles_array.horas,
                margin: { top: 5, right: 30, left: 20, bottom: 5 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["b" /* XAxis */], { dataKey: 'name' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["c" /* YAxis */], { dataKey: 'M\xE9dia' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["e" /* Tooltip */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["f" /* Legend */], null),
              Object.keys(self.state.roles_array.names).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.roles_array.names[k].name, stroke: self.state.roles_array.names[k].color, activeDot: { r: 8 } });
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'visible-sm-inline-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_recharts__["a" /* LineChart */],
              { width: 690, height: 300, data: self.state.roles_array.horas,
                margin: { top: 5, right: 30, left: 20, bottom: 5 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["b" /* XAxis */], { dataKey: 'name' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["c" /* YAxis */], { dataKey: 'M\xE9dia' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["e" /* Tooltip */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["f" /* Legend */], null),
              Object.keys(self.state.roles_array.names).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.roles_array.names[k].name, stroke: self.state.roles_array.names[k].color, activeDot: { r: 8 } });
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'visible-xs-inline-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_recharts__["a" /* LineChart */],
              { width: 280, height: 400, data: self.state.roles_array.horas,
                margin: { top: 5, right: 30, left: 20, bottom: 5 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["b" /* XAxis */], { dataKey: 'name' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["c" /* YAxis */], { dataKey: 'M\xE9dia' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["e" /* Tooltip */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["f" /* Legend */], null),
              Object.keys(self.state.roles_array.names).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.roles_array.names[k].name, stroke: self.state.roles_array.names[k].color, activeDot: { r: 8 } });
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : "",
        self.state.groups_array !== null && self.state.groups_array !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            null,
            this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tituloGrupos
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaGrupos.Grupo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaGrupos.Total
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaGrupos.Pontos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaGrupos.Media
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'grupos' },
              self.state.groups_array !== null && self.state.groups_array !== 'undefined' ? Object.keys(self.state.groups_array.table).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    k
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    self.state.groups_array.table[k].total
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    self.state.groups_array.table[k].points
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    self.state.groups_array.table[k].media
                  )
                );
              }) : ""
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'hidden-sm hidden-xs' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_recharts__["a" /* LineChart */],
              { width: 890, height: 400, data: self.state.groups_array.horas,
                margin: { top: 5, right: 30, left: 20, bottom: 5 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["b" /* XAxis */], { dataKey: 'name' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["c" /* YAxis */], { dataKey: 'M\xE9dia' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["e" /* Tooltip */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["f" /* Legend */], null),
              Object.keys(self.state.groups_array.names).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.groups_array.names[k].name, stroke: self.state.groups_array.names[k].color, activeDot: { r: 8 } });
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'visible-sm-inline-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_recharts__["a" /* LineChart */],
              { width: 690, height: 300, data: self.state.groups_array.horas,
                margin: { top: 5, right: 30, left: 20, bottom: 5 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["b" /* XAxis */], { dataKey: 'name' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["c" /* YAxis */], { dataKey: 'M\xE9dia' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["e" /* Tooltip */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["f" /* Legend */], null),
              Object.keys(self.state.groups_array.names).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.groups_array.names[k].name, stroke: self.state.groups_array.names[k].color, activeDot: { r: 8 } });
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'visible-xs-inline-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_recharts__["a" /* LineChart */],
              { width: 280, height: 400, data: self.state.groups_array.horas,
                margin: { top: 5, right: 30, left: 20, bottom: 5 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["b" /* XAxis */], { dataKey: 'name' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["c" /* YAxis */], { dataKey: 'M\xE9dia' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["e" /* Tooltip */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["f" /* Legend */], null),
              Object.keys(self.state.groups_array.names).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.groups_array.names[k].name, stroke: self.state.groups_array.names[k].color, activeDot: { r: 8 } });
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : "",
        self.state.designations_array !== null && self.state.designations_array !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            null,
            this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tituloDesignacoes
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaDesignacoes.Designacao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaDesignacoes.Total
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaDesignacoes.Pontos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaDesignacoes.Media
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'designacoes' },
              self.state.designations_array !== null ? Object.keys(self.state.designations_array.table).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    k
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    self.state.designations_array.table[k].total
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    self.state.designations_array.table[k].points
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    self.state.designations_array.table[k].media
                  )
                );
              }) : ""
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'hidden-sm hidden-xs' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_recharts__["a" /* LineChart */],
              { width: 890, height: 400, data: self.state.designations_array.horas,
                margin: { top: 5, right: 30, left: 20, bottom: 5 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["b" /* XAxis */], { dataKey: 'name' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["c" /* YAxis */], { dataKey: 'M\xE9dia' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["e" /* Tooltip */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["f" /* Legend */], null),
              Object.keys(self.state.designations_array.names).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.designations_array.names[k].name, stroke: self.state.designations_array.names[k].color, activeDot: { r: 8 } });
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'visible-sm-inline-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_recharts__["a" /* LineChart */],
              { width: 690, height: 300, data: self.state.designations_array.horas,
                margin: { top: 5, right: 30, left: 20, bottom: 5 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["b" /* XAxis */], { dataKey: 'name' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["c" /* YAxis */], { dataKey: 'M\xE9dia' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["e" /* Tooltip */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["f" /* Legend */], null),
              Object.keys(self.state.designations_array.names).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.designations_array.names[k].name, stroke: self.state.designations_array.names[k].color, activeDot: { r: 8 } });
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'visible-xs-inline-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_recharts__["a" /* LineChart */],
              { width: 280, height: 400, data: self.state.designations_array.horas,
                margin: { top: 5, right: 30, left: 20, bottom: 5 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["b" /* XAxis */], { dataKey: 'name' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["c" /* YAxis */], { dataKey: 'M\xE9dia' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["e" /* Tooltip */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["f" /* Legend */], null),
              Object.keys(self.state.designations_array.names).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.designations_array.names[k].name, stroke: self.state.designations_array.names[k].color, activeDot: { r: 8 } });
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : "",
        self.state.aircraft_models_array !== null && self.state.aircraft_models_array !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            null,
            this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tituloFrotas
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaFrotas.Frota
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaFrotas.Total
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaFrotas.Pontos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabRelatorioFinal.tabelaFrotas.Media
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'frotas' },
              self.state.aircraft_models_array !== null ? Object.keys(self.state.aircraft_models_array.table).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    k
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    self.state.aircraft_models_array.table[k].total
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    self.state.aircraft_models_array.table[k].points
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    self.state.aircraft_models_array.table[k].media
                  )
                );
              }) : ""
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'hidden-sm hidden-xs' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_recharts__["a" /* LineChart */],
              { width: 890, height: 400, data: self.state.aircraft_models_array.horas,
                margin: { top: 5, right: 30, left: 20, bottom: 5 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["b" /* XAxis */], { dataKey: 'name' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["c" /* YAxis */], { dataKey: 'M\xE9dia' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["e" /* Tooltip */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["f" /* Legend */], null),
              Object.keys(self.state.aircraft_models_array.names).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.aircraft_models_array.names[k].name, stroke: self.state.aircraft_models_array.names[k].color, activeDot: { r: 8 } });
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'visible-sm-inline-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_recharts__["a" /* LineChart */],
              { width: 690, height: 300, data: self.state.aircraft_models_array.horas,
                margin: { top: 5, right: 30, left: 20, bottom: 5 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["b" /* XAxis */], { dataKey: 'name' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["c" /* YAxis */], { dataKey: 'M\xE9dia' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["e" /* Tooltip */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["f" /* Legend */], null),
              Object.keys(self.state.aircraft_models_array.names).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.aircraft_models_array.names[k].name, stroke: self.state.aircraft_models_array.names[k].color, activeDot: { r: 8 } });
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'visible-xs-inline-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_recharts__["a" /* LineChart */],
              { width: 280, height: 400, data: self.state.aircraft_models_array.horas,
                margin: { top: 5, right: 30, left: 20, bottom: 5 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["b" /* XAxis */], { dataKey: 'name' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["c" /* YAxis */], { dataKey: 'M\xE9dia' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["e" /* Tooltip */], null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["f" /* Legend */], null),
              Object.keys(self.state.aircraft_models_array.names).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.aircraft_models_array.names[k].name, stroke: self.state.aircraft_models_array.names[k].color, activeDot: { r: 8 } });
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : ""
      );
    }
  }]);

  return DrowsinessScheduleResultTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (DrowsinessScheduleResultTab);

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var DrowsinessScheduleTestTab = function (_Component) {
  _inherits(DrowsinessScheduleTestTab, _Component);

  function DrowsinessScheduleTestTab(props) {
    _classCallCheck(this, DrowsinessScheduleTestTab);

    var _this = _possibleConstructorReturn(this, (DrowsinessScheduleTestTab.__proto__ || Object.getPrototypeOf(DrowsinessScheduleTestTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      staff_list: [],
      id: _this.props.drowsiness_schedule_id,
      drowsiness_schedule_status: _this.props.drowsiness_schedule_status
    };

    _this.editTest = _this.editTest.bind(_this);
    _this.showModal = _this.showModal.bind(_this);
    _this.deleteTest = _this.deleteTest.bind(_this);
    _this.ActionsButtons = _this.ActionsButtons.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  _createClass(DrowsinessScheduleTestTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (typeof newProps.drowsiness_schedule_id !== 'undefined' && Array.isArray(newProps.drowsiness_schedule_tests)) {
        this.setState({
          id: newProps.drowsiness_schedule_id,
          staff_list: newProps.staff_list,
          drowsiness_schedule_tests: newProps.drowsiness_schedule_tests,
          drowsiness_schedule_status: newProps.drowsiness_schedule_status
        });
      }
    }

    // Fetch salvando a edição

  }, {
    key: 'editTest',
    value: function editTest(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: this.state.drowsiness_schedule_test_id,
        staff_id: this.state.staff_id,
        date: this.state.date,
        hours: this.state.hours
      };
      var header = this.props.RequestApi.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/escala/sonolencia/teste', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.props.RequestApi.validate(responseJson, 'alert');
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          if (responseJson.status === 'success') {
            self.props.updateData(responseJson);
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'deleteTest',
    value: function deleteTest(event) {
      var drowsiness_schedule_test_id = event.currentTarget.value;
      var confirm = window.confirm(this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.deletarColaboradorDaEscalaDeTeste);
      if (confirm) {
        this.props.handleAlert('', '', 'open');
        var header = this.props.RequestApi.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/escala/sonolencia/teste/' + drowsiness_schedule_test_id, { method: 'DELETE', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.props.RequestApi.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.props.updateData(responseJson);
            }
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'showModal',
    value: function showModal(event) {
      var self = this;
      var drowsiness_schedule_test_id = event.currentTarget.value;

      var data = self.state.drowsiness_schedule_tests;
      data.map(function (dado, index) {
        if (dado.id == drowsiness_schedule_test_id) {
          self.setState({
            staff_id: dado.staff_id,
            date: dado.date_str,
            hours: dado.hours,
            drowsiness_schedule_test_id: dado.id,
            modal: true
          });
        }
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var botao_disabled = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-primary btn-sm', disabled: true, value: cell, onClick: this.showModal },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-sm btn-danger', disabled: true, value: cell, onClick: this.deleteTest },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-trash' })
        )
      );
      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-primary btn-sm', value: cell, onClick: this.showModal },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-sm btn-danger', value: cell, onClick: this.deleteTest },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-trash' })
        )
      );
      {
        this.state.drowsiness_schedule_status !== 'rascunho' ? botao_disabled : botao;
      }

      return botao;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          null,
          this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.tituloTestesDeEscalaDeSonolencia
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["BootstrapTable"],
          { data: this.state.drowsiness_schedule_tests, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.tabela.semColaboradores }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
            this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.tabela.ID
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'staff_name', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
            this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.tabela.Colaborador
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'date_hours', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
            this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.tabela.ProgramacaoDeEnvio
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '100' },
            this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.tabela.Acoes
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal, bsSize: 'large', 'aria-labelledby': 'contained-modal-title-lg' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.tituloEditarTeste
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ modal: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.editTest },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.formulario.Data,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.date, required: true, maskChar: null, name: 'date', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date'), placeholder: '' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.formulario.HorariosDeEnvio,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { required: true, value: this.state.hours, maskChar: null, name: 'hours', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'hours'), placeholder: this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.formulario.placeholder.HorariosDeEnvio })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.formulario.Colaborador,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'staff_id',
                      value: this.state.staff_id,
                      searchable: true,
                      placeholder: this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabTestesDeEscala.formulario.placeholder.SelecionarAplicabilidade,
                      onChange: this.handleSelectChange.bind(this, 'staff_id'),
                      options: this.state.staff_list
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                    ' ',
                    this.locale.general.salvarEdicao
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ modal: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return DrowsinessScheduleTestTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (DrowsinessScheduleTestTab);

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário



var DrowsinessSchedulesEditTab = function (_Component) {
  _inherits(DrowsinessSchedulesEditTab, _Component);

  function DrowsinessSchedulesEditTab(props) {
    _classCallCheck(this, DrowsinessSchedulesEditTab);

    var _this = _possibleConstructorReturn(this, (DrowsinessSchedulesEditTab.__proto__ || Object.getPrototypeOf(DrowsinessSchedulesEditTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      id: _this.props.base_id,
      staff_list: [],
      transportation: 0,
      active: 0,
      date_start: _this.props.drowsiness_schedule_data.date_start_str,
      date_finish: _this.props.drowsiness_schedule_data.date_finish_str,
      name: _this.props.drowsiness_schedule_data.name,
      status: _this.props.drowsiness_schedule_data.status
    };

    //bind específico
    _this.edit = _this.edit.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(DrowsinessSchedulesEditTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (typeof this.state.date_start === 'undefined' && typeof newProps.drowsiness_schedule_data.date_start !== 'undefined') {
        this.setState({
          id: newProps.drowsiness_schedule_data.id,
          date_start: newProps.drowsiness_schedule_data.date_start_str,
          date_finish: newProps.drowsiness_schedule_data.date_finish_str,
          name: newProps.drowsiness_schedule_data.name,
          status: newProps.drowsiness_schedule_data.status
        });
      }
      if (Array.isArray(newProps.staff_list)) {
        this.setState({ staff_list: newProps.staff_list });
      }
    }

    // Fetch salvando a edição

  }, {
    key: 'edit',
    value: function edit(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: this.state.id,
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        name: this.state.name
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/escala/sonolencia', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: this.edit },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabDadosDaEscala.formulario.Nome,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'name', className: 'form-control', placeholder: this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabDadosDaEscala.formulario.placeholder.NomeDaEscalaDeSonolencia, value: this.state.name, onChange: this.handleChange.bind(this, 'name') })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabDadosDaEscala.formulario.DataInicial,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.date_start, required: true, maskChar: null, name: 'date_start', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: '' })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.EscalasDeTesteDeSonolencia.EditarEscalaDeSonolencia.tabDadosDaEscala.formulario.DataFinal,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.date_finish, required: true, maskChar: null, name: 'date_finish', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: '' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-12' },
              this.state.status === 'rascunho' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                ' ',
                this.locale.general.salvarEdicao
              ) : ''
            )
          )
        )
      );
    }
  }]);

  return DrowsinessSchedulesEditTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (DrowsinessSchedulesEditTab);

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var FatigueAdd = function (_Component) {
  _inherits(FatigueAdd, _Component);

  // constructor
  function FatigueAdd(props) {
    _classCallCheck(this, FatigueAdd);

    var _this = _possibleConstructorReturn(this, (FatigueAdd.__proto__ || Object.getPrototypeOf(FatigueAdd)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      types_list: [],
      applicabilities_list: [],
      automation_types_list: [],
      automatic_field: 0,
      operators_list: [],
      operator: '',
      applicability: '',
      type: '',
      name: '',
      hour_points: '',
      quantity_points: '',
      point_limit: '',
      limit_extra_hours_week: '',
      limit_extra_hours_month: '',
      day_limit_extra_hours_week: '',
      day_limit_extra_hours_month: '',
      max_points: null,
      nocturnal_extra_points: null,
      min_points: null,
      required: 0,
      extra_hours: 0,
      aps_day: 0,
      hours_day: 0,
      hours_off: 0,
      applicability_id: 1
    };

    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.add = _this.add.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(FatigueAdd, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeMulti',
    value: function handleSelectChangeMulti(name, event) {
      var change = {};
      var change2 = {};
      if (event == null) {
        change['applicability_name'] = null;
        change2['applicability_id'] = null;
      } else {
        change['applicability_name'] = event.label;
        change2['applicability_id'] = event.value;
      }
      this.setState(change);
      this.setState(change2);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/parametros-de-fadiga/listagens';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ types_list: responseJson.data.types });
            self.setState({ operators_list: responseJson.data.operators });
            self.setState({ applicabilities_list: responseJson.data.applicabilities });
            self.setState({ automation_types_list: responseJson.data.automation_types });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
        }); /* Overlay */
      });
    }
  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      var datasave = {
        operator: this.state.operator,
        applicability_name: this.state.applicability_name,
        applicability_id: this.state.applicability_id,
        automation_type_id: this.state.automation_type_id,
        automatic_field: this.state.automatic_field,
        type: this.state.type,
        name: this.state.name,
        hour_points: this.state.hour_points,
        quantity_points: this.state.quantity_points,
        point_limit: this.state.point_limit,
        max_points: this.state.max_points,
        nocturnal_extra_points: this.state.nocturnal_extra_points,
        min_points: this.state.min_points,
        required: this.state.required,
        extra_hours: this.state.extra_hours,
        aps_day: this.state.aps_day,
        hours_day: this.state.hours_day,
        hours_off: this.state.hours_off,
        reduction_points: this.state.reduction_points,
        limit_extra_hours_week: this.state.limit_extra_hours_week,
        limit_extra_hours_month: this.state.limit_extra_hours_month,
        day_limit_extra_hours_week: this.state.day_limit_extra_hours_week,
        day_limit_extra_hours_month: this.state.day_limit_extra_hours_month
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/parametro-de-fadiga', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var url = '/parametro-de-fadiga/editar/' + responseJson.data.id;
            var storage = {
              alert_message: responseJson.message,
              alert_type: responseJson.status
            };
            localStorage.setItem("verify_message", JSON.stringify(storage));
            self.setState({ redirect_url: url });
          }
          self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.Fadigas.AdicionarFadiga.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/parametros-de-fadiga', className: 'btn btn-default pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-left' }),
              ' ',
              this.locale.general.voltar
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.add },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.AdicionarFadiga.formulario.Nome,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'name', className: 'form-control', placeholder: this.locale.Fadigas.AdicionarFadiga.formulario.placeholder.NomeDoParametroDeFadiga, value: this.state.name, onChange: this.handleChange.bind(this, 'name'), required: true })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.AdicionarFadiga.formulario.Tipo,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'type',
                      value: this.state.type,
                      searchable: true,
                      placeholder: this.locale.Fadigas.AdicionarFadiga.formulario.placeholder.SelecionarTipo,
                      onChange: this.handleSelectChange.bind(this, 'type'),
                      options: this.state.types_list,
                      required: true
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.AdicionarFadiga.formulario.Operador,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'operator',
                      value: this.state.operator,
                      searchable: true,
                      placeholder: this.locale.Fadigas.AdicionarFadiga.formulario.placeholder.SelecionarOperador,
                      onChange: this.handleSelectChange.bind(this, 'operator'),
                      options: this.state.operators_list,
                      required: true
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.AdicionarFadiga.formulario.PontosPorHora,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'hour_points', className: 'form-control', placeholder: this.locale.Fadigas.AdicionarFadiga.formulario.placeholder.QuantidadeDePontosPorHora, value: this.state.hour_points, onChange: this.handleChange.bind(this, 'hour_points') })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.AdicionarFadiga.formulario.PontuacaoExtraPorHoraNoturna,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'nocturnal_extra_points', className: 'form-control', placeholder: this.locale.Fadigas.AdicionarFadiga.formulario.placeholder.PontuacaoExtraPorHoraNoturna, value: this.state.nocturnal_extra_points, onChange: this.handleChange.bind(this, 'nocturnal_extra_points') })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.AdicionarFadiga.formulario.PontosPorQuantidade,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'quantity_points', className: 'form-control', placeholder: this.locale.Fadigas.AdicionarFadiga.formulario.placeholder.QuantidadeDePontosPorQuantidade, value: this.state.quantity_points, onChange: this.handleChange.bind(this, 'quantity_points') })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.AdicionarFadiga.formulario.LimiteDePontos,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'point_limit', className: 'form-control', placeholder: this.locale.Fadigas.AdicionarFadiga.formulario.placeholder.LimiteDePontosDoParametro, value: this.state.point_limit, onChange: this.handleChange.bind(this, 'point_limit') })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.AdicionarFadiga.formulario.AplicabilidadeTipoDeColaborador,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'applicability_id',
                      value: this.state.applicability_id,
                      searchable: true,
                      required: true,
                      placeholder: this.locale.Fadigas.AdicionarFadiga.formulario.placeholder.SelecionarAplicabilidade,
                      onChange: this.handleSelectChangeMulti.bind(this, 'applicability_id'),
                      options: this.state.applicabilities_list
                    })
                  )
                ),
                this.state.applicability_id == 1 ? '' : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.AdicionarFadiga.formulario.PontosAReduzirParaTreinamento,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'reduction_points', className: 'form-control', placeholder: this.locale.Fadigas.AdicionarFadiga.formulario.placeholder.PontosAReduzirParaTreinamento, value: this.state.reduction_points, onChange: this.handleChange.bind(this, 'reduction_points') })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.AdicionarFadiga.formulario.ParametroObrigatorio,
                      '?'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
                      checked: this.state.required,
                      'aria-label': 'No label tag',
                      name: 'required',
                      onChange: this.handleToggleChange.bind(this, 'required') })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.AdicionarFadiga.formulario.ParametroAutomatico,
                      '?'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
                      checked: this.state.automatic_field,
                      'aria-label': 'No label tag',
                      name: 'automatic_field',
                      onChange: this.handleToggleChange.bind(this, 'automatic_field') })
                  )
                ),
                this.state.automatic_field === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.AdicionarFadiga.formulario.TipoDeAutomacao,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'automation_type',
                      value: this.state.automation_type_id,
                      searchable: true,
                      placeholder: this.locale.Fadigas.AdicionarFadiga.formulario.placeholder.SelecionarTipo,
                      onChange: this.handleSelectChange.bind(this, 'automation_type_id'),
                      options: this.state.automation_types_list
                    })
                  )
                ) : ''
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                null,
                this.locale.Fadigas.AdicionarFadiga.formulario.tituloAlertas
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.AdicionarFadiga.formulario.LimiteMaximoDePontos,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'max_points', className: 'form-control', placeholder: this.locale.Fadigas.AdicionarFadiga.formulario.placeholder.LimiteMaximoDePontos, value: this.state.max_points, onChange: this.handleChange.bind(this, 'max_points') })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.AdicionarFadiga.formulario.LimiteMinimoDePontos,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'min_points', className: 'form-control', placeholder: this.locale.Fadigas.AdicionarFadiga.formulario.placeholder.LimiteMinimoDePontos, value: this.state.min_points, onChange: this.handleChange.bind(this, 'min_points') })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.AdicionarFadiga.formulario.LimiteDePontosDeHoraExtraPorSemana,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'limit_extra_hours_week', className: 'form-control', placeholder: '', value: this.state.limit_extra_hours_week, onChange: this.handleChange.bind(this, 'limit_extra_hours_week') })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.AdicionarFadiga.formulario.LimiteDePontosDeHoraExtraPorMes,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'limit_extra_hours_month', className: 'form-control', placeholder: '', value: this.state.limit_extra_hours_month, onChange: this.handleChange.bind(this, 'limit_extra_hours_month') })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.AdicionarFadiga.formulario.LimiteDeDiasComHoraExtraPorSemana,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'day_limit_extra_hours_week', className: 'form-control', placeholder: '', value: this.state.day_limit_extra_hours_week, onChange: this.handleChange.bind(this, 'day_limit_extra_hours_week') })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.AdicionarFadiga.formulario.LimiteDeDiasComHoraExtraPorMes,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'day_limit_extra_hours_month', className: 'form-control', placeholder: '', value: this.state.day_limit_extra_hours_month, onChange: this.handleChange.bind(this, 'day_limit_extra_hours_month') })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                    ' ',
                    this.locale.Fadigas.AdicionarFadiga.formulario.botaoAdicionarParametroDeFadiga
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FatigueAdd;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FatigueAdd);

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var Fatigue = function (_Component) {
  _inherits(Fatigue, _Component);

  function Fatigue(props) {
    _classCallCheck(this, Fatigue);

    var _this = _possibleConstructorReturn(this, (Fatigue.__proto__ || Object.getPrototypeOf(Fatigue)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      fatigue_data: {},
      fatigue_options_data: {},
      applicabilities_list: [],
      types_list: [],
      operators_list: [],
      automation_types_list: [],
      operator: '',
      type: '',
      name: '',
      applicability_id: '',
      automation_type_id: '',
      hour_points: '',
      quantity_points: '',
      point_limit: '',
      option_name: '',
      nocturnal_extra_points: null,
      max_points: null,
      min_points: null,
      reduction_points: null,
      points: '',
      required: 0,
      automatic_field: 0
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.delete = _this.delete.bind(_this);
    _this.deleteRow = _this.deleteRow.bind(_this);
    _this.addFatigueOption = _this.addFatigueOption.bind(_this);
    _this.edit = _this.edit.bind(_this);
    _this.loadData = _this.loadData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(Fatigue, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeMulti',
    value: function handleSelectChangeMulti(name, event) {
      var change = {};
      var change2 = {};
      if (event == null) {
        change['applicability_name'] = null;
        change2['applicability_id'] = null;
      } else {
        change['applicability_name'] = event.label;
        change2['applicability_id'] = event.value;
      }
      this.setState(change);
      this.setState(change2);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }

    //LM

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData(event) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/parametro-de-fadiga/' + self.props.match.params.id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url', '/parametros-de-fadiga');
          if (responseJson.status === 'success') {
            self.setState({
              id: responseJson.data.fatigue.id,
              name: responseJson.data.fatigue.name,
              type: responseJson.data.fatigue.type,
              operator: responseJson.data.fatigue.operator,
              hour_points: responseJson.data.fatigue.hour_points,
              quantity_points: responseJson.data.fatigue.quantity_points,
              point_limit: responseJson.data.fatigue.point_limit,
              required: responseJson.data.fatigue.required,
              api_type: responseJson.data.fatigue.api_type,
              automatic_field: responseJson.data.fatigue.automatic_field,
              automation_type: responseJson.data.fatigue.automation_type,
              automation_type_id: responseJson.data.fatigue.automation_type_id,
              limit_extra_hours_week: responseJson.data.fatigue.limit_extra_hours_week,
              limit_extra_hours_month: responseJson.data.fatigue.limit_extra_hours_month,
              day_limit_extra_hours_week: responseJson.data.fatigue.day_limit_extra_hours_week,
              day_limit_extra_hours_month: responseJson.data.fatigue.day_limit_extra_hours_month,
              max_points: responseJson.data.fatigue.max_points,
              nocturnal_extra_points: responseJson.data.fatigue.nocturnal_extra_points,
              min_points: responseJson.data.fatigue.min_points,
              reduction_points: responseJson.data.fatigue.reduction_points,
              applicabilities_list: responseJson.data.applicabilities,
              types_list: responseJson.data.types,
              operators_list: responseJson.data.operators,
              automation_types_list: responseJson.data.automation_types,
              applicability_id: responseJson.data.fatigue.applicability_id,
              applicability_name: responseJson.data.fatigue.applicability_name
            });
          }
        }).then(function () {
          var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/parametro-de-fadiga/opcoes/' + self.props.match.params.id;
          fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson);
            if (responseJson.status === 'success') {
              self.setState({ fatigue_options_data: responseJson.data });
            }
          }).then(function () {
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
            if (typeof event === 'undefined') {
              self.handleMessage();
            } else {
              self.handleAlert(event.message, event.status, 'open');
            }
          }); /* Overlay */
        }); /* Opções da fadiga */
      });
    }

    // Fetch salvando a edição

  }, {
    key: 'edit',
    value: function edit(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        id: this.state.id,
        name: this.state.name,
        type: this.state.type,
        operator: this.state.operator,
        applicability_id: this.state.applicability_id,
        applicability_name: this.state.applicability_name,
        hour_points: this.state.hour_points,
        quantity_points: this.state.quantity_points,
        point_limit: this.state.point_limit,
        required: this.state.required,
        extra_hours: this.state.extra_hours,
        automatic_field: this.state.automatic_field,
        automation_type_id: this.state.automation_type_id,
        nocturnal_extra_points: this.state.nocturnal_extra_points,
        max_points: this.state.max_points,
        min_points: this.state.min_points,
        reduction_points: this.state.reduction_points,
        limit_extra_hours_week: this.state.limit_extra_hours_week,
        limit_extra_hours_month: this.state.limit_extra_hours_month,
        day_limit_extra_hours_week: this.state.day_limit_extra_hours_week,
        day_limit_extra_hours_month: this.state.day_limit_extra_hours_month
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/parametro-de-fadiga', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'addFatigueOption',
    value: function addFatigueOption(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        name: this.state.option_name,
        points: this.state.points,
        fatigue_id: this.state.id
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/parametro-de-fadiga/opcao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var data_temp = self.state.fatigue_options_data;
            data_temp.push(responseJson.data);
            self.setState({ fatigue_options_data: data_temp });
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'delete',
    value: function _delete(event) {
      var fatigue_option_id = event.currentTarget.value;
      var confirm = window.confirm(this.locale.Fadigas.EditarFadiga.deletar);
      if (confirm) {
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/parametro-de-fadiga/opcao/' + fatigue_option_id, { method: 'DELETE', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.deleteRow(fatigue_option_id);
              self.loadData();
            }
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'deleteRow',
    value: function deleteRow(fatigue_option_id) {
      var data = this.state.fatigue_options_data;
      data.map(function (dado, index) {
        if (dado.id == fatigue_option_id) {
          data.splice(index, 1);
        }
      });
      this.setState({ fatigue_options_data: data });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.Fadigas.EditarFadiga.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_router_dom__["d" /* Link */],
              { to: '/parametros-de-fadiga', className: 'btn btn-default pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-left' }),
              ' ',
              this.locale.general.voltar
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.edit },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.EditarFadiga.formulario.Nome,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'name', className: 'form-control', placeholder: this.locale.Fadigas.EditarFadiga.formulario.placeholder.NomeDoParametroDeFadiga, value: this.state.name, onChange: this.handleChange.bind(this, 'name') })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.EditarFadiga.formulario.Tipo,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'type',
                      value: this.state.type,
                      searchable: true,
                      placeholder: this.locale.Fadigas.EditarFadiga.formulario.placeholder.SelecionarCliente,
                      onChange: this.handleSelectChange.bind(this, 'type'),
                      options: this.state.types_list
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.EditarFadiga.formulario.Operador,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'operator',
                      value: this.state.operator,
                      searchable: true,
                      placeholder: this.locale.Fadigas.EditarFadiga.formulario.placeholder.SelecionarCliente,
                      onChange: this.handleSelectChange.bind(this, 'operator'),
                      options: this.state.operators_list
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.EditarFadiga.formulario.PontosPorHora,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'hour_points', className: 'form-control', placeholder: this.locale.Fadigas.EditarFadiga.formulario.placeholder.QuantidadeDePontosPorHora, value: this.state.hour_points, onChange: this.handleChange.bind(this, 'hour_points') })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.EditarFadiga.formulario.PontosPorQuantidade,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'quantity_points', className: 'form-control', placeholder: this.locale.Fadigas.EditarFadiga.formulario.placeholder.QuantidadeDePontosPorQuantidade, value: this.state.quantity_points, onChange: this.handleChange.bind(this, 'quantity_points') })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.EditarFadiga.formulario.LimiteDePontos,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'point_limit', className: 'form-control', placeholder: this.locale.Fadigas.EditarFadiga.formulario.placeholder.LimiteDePontosDoParametro, value: this.state.point_limit, onChange: this.handleChange.bind(this, 'point_limit') })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.EditarFadiga.formulario.PontuacaoExtraPorHoraNoturna,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'nocturnal_extra_points', className: 'form-control', placeholder: this.locale.Fadigas.EditarFadiga.formulario.placeholder.PontuacaoExtraPorHoraNoturna, value: this.state.nocturnal_extra_points, onChange: this.handleChange.bind(this, 'nocturnal_extra_points') })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.EditarFadiga.formulario.AplicabilidadeTipoDeColaborador,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'applicability_id',
                      value: this.state.applicability_id,
                      searchable: true,
                      required: true,
                      placeholder: this.locale.Fadigas.EditarFadiga.formulario.placeholder.SelecionarAplicabilidade,
                      onChange: this.handleSelectChangeMulti.bind(this, 'applicability_id'),
                      options: this.state.applicabilities_list
                    })
                  )
                ),
                this.state.applicability_id == 1 ? '' : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.EditarFadiga.formulario.PontosAReduzirParaTreinamento,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'reduction_points', className: 'form-control', placeholder: this.locale.Fadigas.EditarFadiga.formulario.placeholder.PontosAReduzirParaTreinamento, value: this.state.reduction_points, onChange: this.handleChange.bind(this, 'reduction_points') })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.EditarFadiga.formulario.ParametroObrigatorio,
                      '?'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_toggle___default.a, {
                      checked: this.state.required,
                      'aria-label': 'No label tag',
                      name: 'required',
                      onChange: this.handleToggleChange.bind(this, 'required') })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.EditarFadiga.formulario.ParametroAutomatico,
                      '?'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_toggle___default.a, {
                      checked: this.state.automatic_field,
                      'aria-label': 'No label tag',
                      name: 'extra_hours',
                      onChange: this.handleToggleChange.bind(this, 'automatic_field') })
                  )
                ),
                this.state.automatic_field === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.EditarFadiga.formulario.TipoDeAutomacao,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'automation_type',
                      value: this.state.automation_type_id,
                      searchable: true,
                      placeholder: this.locale.Fadigas.EditarFadiga.formulario.placeholder.SelecionarTipo,
                      onChange: this.handleSelectChange.bind(this, 'automation_type_id'),
                      options: this.state.automation_types_list
                    })
                  )
                ) : ''
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                null,
                this.locale.Fadigas.EditarFadiga.formulario.tituloAlertas
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.EditarFadiga.formulario.LimiteMaximoDePontos,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'max_points', className: 'form-control', placeholder: this.locale.Fadigas.EditarFadiga.formulario.placeholder.LimiteMaximoDePontos, value: this.state.max_points, onChange: this.handleChange.bind(this, 'max_points') })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.EditarFadiga.formulario.LimiteMinimoDePontos,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'min_points', className: 'form-control', placeholder: this.locale.Fadigas.EditarFadiga.formulario.placeholder.LimiteMinimoDePontos, value: this.state.min_points, onChange: this.handleChange.bind(this, 'min_points') })
                  )
                )
              ),
              this.state.automation_type === 'extra_hours' && this.state.api_type === 'rubi' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.EditarFadiga.formulario.LimiteDePontosDeHoraExtraPorSemana,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'limit_extra_hours_week', className: 'form-control', placeholder: '', value: this.state.limit_extra_hours_week, onChange: this.handleChange.bind(this, 'limit_extra_hours_week') })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.EditarFadiga.formulario.LimiteDePontosDeHoraExtraPorMes,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'limit_extra_hours_month', className: 'form-control', placeholder: '', value: this.state.limit_extra_hours_month, onChange: this.handleChange.bind(this, 'limit_extra_hours_month') })
                  )
                )
              ) : '',
              this.state.automation_type === 'extra_hours' && this.state.api_type === 'rubi' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.EditarFadiga.formulario.LimiteDeDiasComHoraExtraPorSemana,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'day_limit_extra_hours_week', className: 'form-control', placeholder: '', value: this.state.day_limit_extra_hours_week, onChange: this.handleChange.bind(this, 'day_limit_extra_hours_week') })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Fadigas.EditarFadiga.formulario.LimiteDeDiasComHoraExtraPorMes,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'day_limit_extra_hours_month', className: 'form-control', placeholder: '', value: this.state.day_limit_extra_hours_month, onChange: this.handleChange.bind(this, 'day_limit_extra_hours_month') })
                  )
                )
              ) : '',
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                    ' ',
                    this.locale.general.voltar
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              null,
              this.locale.Fadigas.EditarFadiga.tituloAdicionarOpcoes
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'form',
                { onSubmit: this.addFatigueOption },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Fadigas.EditarFadiga.formularioAdicionarOpcoes.Nome,
                        ':'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'option_name', className: 'form-control', placeholder: this.locale.Fadigas.EditarFadiga.formularioAdicionarOpcoes.placeholder.NomeDoParametroDeFadiga, value: this.state.option_name, onChange: this.handleChange.bind(this, 'option_name') })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Fadigas.EditarFadiga.formularioAdicionarOpcoes.Pontos,
                        ':'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'points', className: 'form-control', placeholder: this.locale.Fadigas.EditarFadiga.formularioAdicionarOpcoes.placeholder.QuantidadeDePontos, value: this.state.points, onChange: this.handleChange.bind(this, 'points') })
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-12' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                      ' ',
                      this.locale.general.salvar
                    )
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              this.locale.Fadigas.EditarFadiga.tituloOpcoes
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'table',
              { className: 'table' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'thead',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    '#'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    this.locale.Fadigas.EditarFadiga.tabela.Opcao
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    this.locale.Fadigas.EditarFadiga.tabela.Pontos
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    { className: 'col-md-1' },
                    this.locale.Fadigas.EditarFadiga.tabela.Acoes
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tbody',
                { id: 'frotas' },
                Object.keys(self.state.fatigue_options_data).map(function (k) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      self.state.fatigue_options_data[k].id
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      self.state.fatigue_options_data[k].name
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      self.state.fatigue_options_data[k].points
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { className: 'btn btn-sm btn-danger', value: self.state.fatigue_options_data[k].id, onClick: self.delete },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-trash' })
                      )
                    )
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Fatigue;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Fatigue);

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// Importação da tabela



var FatigueIndex = function (_Component) {
  _inherits(FatigueIndex, _Component);

  function FatigueIndex(props) {
    _classCallCheck(this, FatigueIndex);

    var _this = _possibleConstructorReturn(this, (FatigueIndex.__proto__ || Object.getPrototypeOf(FatigueIndex)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };

    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.delete = _this.delete.bind(_this);
    _this.deleteRow = _this.deleteRow.bind(_this);
    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.loadData = _this.loadData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(FatigueIndex, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/parametros-de-fadiga', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var url = '/parametro-de-fadiga/editar/' + cell;

      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
          { className: 'btn btn-primary btn-sm', to: url },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-sm btn-danger', value: cell, onClick: this.delete },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-trash' })
        )
      );

      return botao;
    }
  }, {
    key: 'delete',
    value: function _delete(event) {
      var fatigue_id = event.currentTarget.value;
      var confirm = window.confirm(this.locale.Fadigas.ListaDeFadigas.deletar);
      if (confirm) {
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/parametro-de-fadiga/' + fatigue_id, { method: 'DELETE', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.deleteRow(fatigue_id);
            }
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'deleteRow',
    value: function deleteRow(fatigue_id) {
      var data = this.state.data;
      data.map(function (dado, index) {
        if (dado.id == fatigue_id) {
          data.splice(index, 1);
        }
      });
      this.setState({ data: data });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.Fadigas.ListaDeFadigas.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/parametro-de-fadiga/cadastrar', className: 'btn btn-primary pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-plus' }),
              ' ',
              this.locale.Fadigas.ListaDeFadigas.botaoAdicionarFadiga
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Fadigas.ListaDeFadigas.tabela.semParametroDeFadiga }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.Fadigas.ListaDeFadigas.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'applicability_name', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.Fadigas.ListaDeFadigas.tabela.Aplicabilidade
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'name', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.Fadigas.ListaDeFadigas.tabela.Nome
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'type_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.Fadigas.ListaDeFadigas.tabela.Tipo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'operator', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.Fadigas.ListaDeFadigas.tabela.Operador
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'hour_points', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.Fadigas.ListaDeFadigas.tabela.PontosPorHora
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'quantity_points', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.Fadigas.ListaDeFadigas.tabela.PontosPorQuantidade
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'point_limit', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.Fadigas.ListaDeFadigas.tabela.LimiteDePontos
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'required_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.Fadigas.ListaDeFadigas.tabela.ObrigatorioPreenchimento,
                '?'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '100' },
                this.locale.Fadigas.ListaDeFadigas.tabela.Acoes
              )
            )
          )
        )
      );
    }
  }]);

  return FatigueIndex;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FatigueIndex);

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var FatigueAuxiliaryReportsAdd = function (_Component) {
    _inherits(FatigueAuxiliaryReportsAdd, _Component);

    function FatigueAuxiliaryReportsAdd(props) {
        _classCallCheck(this, FatigueAuxiliaryReportsAdd);

        var _this = _possibleConstructorReturn(this, (FatigueAuxiliaryReportsAdd.__proto__ || Object.getPrototypeOf(FatigueAuxiliaryReportsAdd)).call(this, props));

        _this.state = {
            overlay: {
                message: '',
                type: '',
                status: 'open'
            },
            redirect_url: false,
            loaded: 0,
            generated_result: false,

            first_question_answer: null,
            second_question_first_part_answer: null,
            second_question_second_part_answer: null,
            second_question_third_part_answer: null,
            third_question_answer: null,
            fourth_question_first_option: null,
            fourth_question_second_option: null,
            fourth_question_third_option: null,
            fourth_question_fourth_option: null,
            fourth_question_fifth_option: null,
            fourth_question_sixth_option: null,

            answered_data: {},

            first_question_values: [],
            second_question_first_part_values: [],
            second_question_second_part_values: [],
            third_question_values: [],

            first_question_options: [],
            second_question_first_part_options: [],
            second_question_second_part_options: [],
            third_question_options: []
        };
        //Handlers
        _this.handleAlert = _this.handleAlert.bind(_this);
        _this.handleLoaded = _this.handleLoaded.bind(_this);
        _this.handleMessage = _this.handleMessage.bind(_this);

        _this.add = _this.add.bind(_this);
        _this.loadData = _this.loadData.bind(_this);

        _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__["a" /* default */])();
        return _this;
    }

    // Handlers


    _createClass(FatigueAuxiliaryReportsAdd, [{
        key: 'handleChange',
        value: function handleChange(name, event) {
            var change = {};
            change[name] = event.target.value;
            this.setState(change);
        }
    }, {
        key: 'handleSelectChange',
        value: function handleSelectChange(name, event) {
            var change = {};
            if (event == null) {
                change[name] = null;
            } else {
                change[name] = event.value;
            }
            this.setState(change);
        }
    }, {
        key: 'handleAlert',
        value: function handleAlert(message, type, status, mode) {
            if (mode === 'reset') {
                this.setState({ overlay: { message: '', type: '', status: 'closed' } });
            } else {
                this.setState({ overlay: { message: message, type: type, status: status } });
            }
        }
    }, {
        key: 'handleLoaded',
        value: function handleLoaded(state) {
            if (this.state.loaded !== 2) {
                this.setState({ loaded: state });
            }
        }
    }, {
        key: 'handleMessage',
        value: function handleMessage() {
            var message = localStorage.getItem("verify_message");
            if (message !== null && typeof message !== 'undefined') {
                message = JSON.parse(message);
                var self = this;
                self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
                localStorage.removeItem("verify_message");
            }
        }

        //LM

    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.refs.request_api.header();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.state.loaded === 1 && prevState.loaded === 0) {
                this.setState({ loaded: 2 }, this.loadData());
            }
        }
    }, {
        key: 'loadData',
        value: function loadData(event) {
            var self = this;
            var header = this.refs.request_api.header('application/json');
            Promise.resolve(header).then(function (value) {
                var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/fadiga/ferramenta/auxiliar/info/cadastro';
                fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
                    return response.json();
                }).catch(function (error) {
                    console.error(error);
                }).then(function (responseJson) {
                    self.refs.request_api.validate(responseJson, 'url', '/');
                    if (responseJson.status === 'success') {
                        self.setState({
                            first_question_options: responseJson.data.first_question_options,
                            second_question_first_part_options: responseJson.data.second_question_first_part_options,
                            second_question_second_part_options: responseJson.data.second_question_second_part_options,
                            third_question_options: responseJson.data.third_question_options,
                            first_question_values: responseJson.data.first_question_values,
                            second_question_first_part_values: responseJson.data.second_question_first_part_values,
                            second_question_second_part_values: responseJson.data.second_question_second_part_values,
                            third_question_values: responseJson.data.third_question_values
                        });
                    }
                }).then(function () {
                    self.setState({ overlay: { message: '', type: '', status: 'closed' } });
                    if (typeof event === 'undefined') {
                        self.handleMessage();
                    } else {
                        self.handleAlert(event.message, event.status, 'open');
                    }
                });
            });
        }
    }, {
        key: 'add',
        value: function add(event) {
            event.preventDefault();
            this.handleAlert('', '', 'open');
            var datasave = {
                first_question_answer: this.state.first_question_answer,
                second_question_first_part_answer: this.state.second_question_first_part_answer,
                second_question_second_part_answer: this.state.second_question_second_part_answer,
                second_question_third_part_answer: this.state.second_question_third_part_answer,
                third_question_answer: this.state.third_question_answer,
                fourth_question_first_option: this.state.fourth_question_first_option,
                fourth_question_second_option: this.state.fourth_question_second_option,
                fourth_question_third_option: this.state.fourth_question_third_option,
                fourth_question_fourth_option: this.state.fourth_question_fourth_option,
                fourth_question_fifth_option: this.state.fourth_question_fifth_option,
                fourth_question_sixth_option: this.state.fourth_question_sixth_option
            };
            var self = this;
            var header = this.refs.request_api.header('application/json');
            Promise.resolve(header).then(function (value) {
                fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/reporte/ferramenta/auxiliar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
                    return response.json();
                }).catch(function (error) {
                    console.error(error);
                }).then(function (responseJson) {
                    self.refs.request_api.validate(responseJson, 'alert');
                    self.handleAlert(responseJson.message, responseJson.status, 'open');
                    self.setState({
                        generated_result: true,
                        answered_data: responseJson.data
                    });
                }).catch(function (error) {
                    console.error(error);
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var self = this;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
                this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'container-liquid' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'conteudo' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'h3',
                            { className: 'page-title pull-left' },
                            this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.titulo
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                        !self.state.generated_result ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'form',
                                { onSubmit: this.add },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'h4',
                                    { className: 'page-title' },
                                    this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.tituloQuestao1QuaoAlertaVoceEsta
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'row' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-md-6' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'form-group' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], {
                                                className: 'form-field-name',
                                                name: 'first_question_answer',
                                                value: this.state.first_question_answer,
                                                searchable: true,
                                                placeholder: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.placeholder.SelecioneUmaOpcao,
                                                onChange: this.handleSelectChange.bind(this, 'first_question_answer'),
                                                options: this.state.first_question_options,
                                                required: true
                                            })
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'h4',
                                    { className: 'page-title' },
                                    this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.tituloQuestao2VoceTeveSonoAdequado
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'row' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-md-6' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'form-group' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'label',
                                                null,
                                                this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.QuantoTempoDormiuNas24HorasAnteriores
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], {
                                                className: 'form-field-name',
                                                name: 'second_question_first_part_answer',
                                                value: this.state.second_question_first_part_answer,
                                                searchable: true,
                                                placeholder: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.placeholder.SelecioneUmaOpcao,
                                                onChange: this.handleSelectChange.bind(this, 'second_question_first_part_answer'),
                                                options: this.state.second_question_first_part_options,
                                                required: true
                                            })
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-md-6' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'form-group' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'label',
                                                null,
                                                this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.QuantoTempoDormiuNas48HorasAnteriores
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], {
                                                className: 'form-field-name',
                                                name: 'second_question_second_part_answer',
                                                value: this.state.second_question_second_part_answer,
                                                searchable: true,
                                                placeholder: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.placeholder.SelecioneUmaOpcao,
                                                onChange: this.handleSelectChange.bind(this, 'second_question_second_part_answer'),
                                                options: this.state.second_question_second_part_options,
                                                required: true
                                            })
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'row' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-md-6' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'form-group' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'label',
                                                null,
                                                this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.AoFimDaJornadaPorQuantasHorasTeraPermanicidoAcordado
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.second_question_third_part_answer, required: true, maskChar: null, name: 'second_question_third_part_answer', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'second_question_third_part_answer'), placeholder: 'hh:mm' })
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'h4',
                                    { className: 'page-title' },
                                    this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.tituloQuestao3QueHorasOcorreAPresenteJornada
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'row' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-md-6' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'form-group' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], {
                                                className: 'form-field-name',
                                                name: 'third_question_answer',
                                                value: this.state.third_question_answer,
                                                searchable: true,
                                                placeholder: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.placeholder.SelecioneUmaOpcao,
                                                onChange: this.handleSelectChange.bind(this, 'third_question_answer'),
                                                options: this.state.third_question_options,
                                                required: true
                                            })
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'h4',
                                    { className: 'page-title' },
                                    this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.tituloQuestao4QualNivelDeRiscoOperacionalAssociado
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'row' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-md-6' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'form-group' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'label',
                                                null,
                                                this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Rota,
                                                ':'
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], {
                                                className: 'form-field-name',
                                                name: 'fourth_question_first_option',
                                                value: this.state.fourth_question_first_option,
                                                searchable: true,
                                                placeholder: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.placeholder.SelecioneUmaOpcao,
                                                onChange: this.handleSelectChange.bind(this, 'fourth_question_first_option'),
                                                options: [{ value: 1, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Baixo }, { value: 2, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Moderado }, { value: 3, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Elevado }],
                                                required: true
                                            })
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-md-6' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'form-group' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'label',
                                                null,
                                                this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Aeroportos,
                                                ':'
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], {
                                                className: 'form-field-name',
                                                name: 'fourth_question_second_option',
                                                value: this.state.fourth_question_second_option,
                                                searchable: true,
                                                placeholder: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.placeholder.SelecioneUmaOpcao,
                                                onChange: this.handleSelectChange.bind(this, 'fourth_question_second_option'),
                                                options: [{ value: 1, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Baixo }, { value: 2, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Moderado }, { value: 3, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Elevado }],
                                                required: true
                                            })
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'row' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-md-6' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'form-group' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'label',
                                                null,
                                                this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.EspacoAereo,
                                                ':'
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], {
                                                className: 'form-field-name',
                                                name: 'fourth_question_third_option',
                                                value: this.state.fourth_question_third_option,
                                                searchable: true,
                                                placeholder: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.placeholder.SelecioneUmaOpcao,
                                                onChange: this.handleSelectChange.bind(this, 'fourth_question_third_option'),
                                                options: [{ value: 1, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Baixo }, { value: 2, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Moderado }, { value: 3, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Elevado }],
                                                required: true
                                            })
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-md-6' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'form-group' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'label',
                                                null,
                                                this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.NivelExperienciaTripulacao,
                                                ':'
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], {
                                                className: 'form-field-name',
                                                name: 'fourth_question_fourth_option',
                                                value: this.state.fourth_question_fourth_option,
                                                searchable: true,
                                                placeholder: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.placeholder.SelecioneUmaOpcao,
                                                onChange: this.handleSelectChange.bind(this, 'fourth_question_fourth_option'),
                                                options: [{ value: 1, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Baixo }, { value: 2, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Moderado }, { value: 3, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Elevado }],
                                                required: true
                                            })
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'row' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-md-6' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'form-group' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'label',
                                                null,
                                                this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.CaracteristicasEOperacionalidadeDaAeronave,
                                                ':'
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], {
                                                className: 'form-field-name',
                                                name: 'fourth_question_fifth_option',
                                                value: this.state.fourth_question_fifth_option,
                                                searchable: true,
                                                placeholder: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.placeholder.SelecioneUmaOpcao,
                                                onChange: this.handleSelectChange.bind(this, 'fourth_question_fifth_option'),
                                                options: [{ value: 1, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Baixo }, { value: 2, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Moderado }, { value: 3, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Elevado }],
                                                required: true
                                            })
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-md-6' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'form-group' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'label',
                                                null,
                                                this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.CondicoesAtmosfericas,
                                                ':'
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], {
                                                className: 'form-field-name',
                                                name: 'fourth_question_sixth_option',
                                                value: this.state.fourth_question_sixth_option,
                                                searchable: true,
                                                placeholder: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.placeholder.SelecioneUmaOpcao,
                                                onChange: this.handleSelectChange.bind(this, 'fourth_question_sixth_option'),
                                                options: [{ value: 1, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Baixo }, { value: 2, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Moderado }, { value: 3, label: this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.Opcoes.Elevado }],
                                                required: true
                                            })
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'row' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-md-12' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'button',
                                            { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                                            ' ',
                                            this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.formulario.botaoGerarAvaliacao
                                        )
                                    )
                                )
                            )
                        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'h4',
                                { className: 'page-title' },
                                this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.tituloQuestao1QuaoAlertaVoceEsta
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'p',
                                null,
                                this.state.first_question_values[this.state.first_question_answer],
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    { style: { fontStyle: 'italic' } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'strong',
                                        null,
                                        this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.nota,
                                        ':'
                                    ),
                                    ' ',
                                    this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.paragrafoSeORiscoElevadoEstiverPresenteInformarAoDespachoOperacional
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'h4',
                                { className: 'page-title' },
                                this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.tituloQuestao2VoceTeveSonoAdequado
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'row' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.QuantoTempoDormiuNas24HorasAnteriores
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                        this.state.second_question_first_part_values[this.state.second_question_first_part_answer]
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.QuantoTempoDormiuNas48HorasAnteriores
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                        this.state.second_question_second_part_values[this.state.second_question_second_part_answer]
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'row' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.AoFimDaJornadaPorQuantasHorasTeraPermanicidoAcordado
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                        this.state.second_question_third_part_answer,
                                        ' (',
                                        this.state.answered_data.second_question_fourth_part_points,
                                        ' pontos)'
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'p',
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'strong',
                                    null,
                                    this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.paragrafoPontuacao,
                                    ':'
                                ),
                                ' ',
                                this.state.answered_data.second_question_risk_str,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'span',
                                    { style: { fontStyle: 'italic' } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'strong',
                                        null,
                                        this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.nota,
                                        ':'
                                    ),
                                    ' ',
                                    this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.paragrafoSeORiscoElevadoEstiverPresenteInformarAoOperador
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'h4',
                                { className: 'page-title' },
                                this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.tituloQuestao3QueHorasOcorreAPresenteJornada
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'row' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        this.state.third_question_values[this.state.third_question_answer]
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'h4',
                                { className: 'page-title' },
                                this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.tituloQuestao4QualNivelDeRiscoOperacionalAssociado
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'row' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.rota,
                                            ':'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                        this.state.answered_data.fourth_question_first_option_str
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.aeroportos,
                                            ':'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                        this.state.answered_data.fourth_question_second_option_str
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'row' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.espacoAereo,
                                            ':'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                        this.state.answered_data.fourth_question_third_option_str
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.nivelExperienciaTripulacao,
                                            ':'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                        this.state.answered_data.fourth_question_fourth_option_str
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'row' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.caracteristicasEOperacionalidadeDaAeronave,
                                            ':'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                        this.state.answered_data.fourth_question_fifth_option_str
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-6' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.condicoesAtmosfericas,
                                            ':'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                        this.state.answered_data.fourth_question_sixth_option_str
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'p',
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'strong',
                                    null,
                                    this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.paragrafoPontuacao,
                                    ':'
                                ),
                                ' ',
                                this.state.answered_data.fourth_question_risk_str
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'h4',
                                { className: 'page-title' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'strong',
                                    null,
                                    this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.tituloResultadoDosRiscos,
                                    ':'
                                ),
                                ' ',
                                this.state.answered_data.result_str
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'p',
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'strong',
                                    null,
                                    this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.paragrafoOrientacaoAoTripulante,
                                    ':'
                                )
                            ),
                            this.state.answered_data.result == 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'p',
                                { style: { padding: '20px' }, className: 'bg-success' },
                                this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.paragrafoMecaONivelDeAlertaTripulacaoAumentada
                            ),
                            this.state.answered_data.result == 2 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'p',
                                { style: { padding: '20px' }, className: 'bg-warning' },
                                this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.paragrafoMecaONivelDeAlertaChochilo
                            ),
                            this.state.answered_data.result == 3 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'p',
                                { style: { padding: '20px' }, className: 'bg-danger' },
                                this.locale.RelatoriosAuxiliaresFadiga.AdicionarRelatorioAuxiliar.paragrafoMecaONivelDeAlertaCafeina
                            )
                        )
                    )
                )
            );
        }
    }]);

    return FatigueAuxiliaryReportsAdd;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FatigueAuxiliaryReportsAdd);

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










// Importação da tabela



var SearchAuxiliaryReport = function (_Component) {
  _inherits(SearchAuxiliaryReport, _Component);

  function SearchAuxiliaryReport(props) {
    _classCallCheck(this, SearchAuxiliaryReport);

    var _this = _possibleConstructorReturn(this, (SearchAuxiliaryReport.__proto__ || Object.getPrototypeOf(SearchAuxiliaryReport)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      data_modal: {},
      date_start: null,
      date_finish: null
    };

    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    _this.loadModal = _this.loadModal.bind(_this);
    _this.showModal = _this.showModal.bind(_this);
    _this.closeModal = _this.closeModal.bind(_this);
    _this.searchReports = _this.searchReports.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(SearchAuxiliaryReport, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      self.setState({ overlay: { message: '', type: '', status: 'closed' } });
    }
  }, {
    key: 'loadModal',
    value: function loadModal(value, event) {
      var self = this;
      var id = value;
      self.setState({ overlay: { message: '', type: '', status: 'open' } });
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio-de-fadiga/' + id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ data_report_fatigues: responseJson.data });
            self.showModal();
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
        }); /* Overlay */
      });
    }
  }, {
    key: 'showModal',
    value: function showModal(value, event) {
      this.setState({ modal: true });
    }
  }, {
    key: 'closeModal',
    value: function closeModal(event) {
      this.setState({ modal: false });
    }
  }, {
    key: 'searchReports',
    value: function searchReports(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_finish
      };

      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/reporte/ferramenta/auxiliar/pesquisar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          } else {
            self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { onClick: this.loadModal.bind(this, cell), className: 'btn btn-sm btn-info', alt: this.locale.general.informacoes, title: this.locale.general.informacoes },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-eye' })
        )
      );

      return botao;
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosAuxiliaresFadiga.ProcurarRelatorioAuxiliar.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.searchReports },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosAuxiliaresFadiga.ProcurarRelatorioAuxiliar.formulario.DataInicial,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_input_mask___default.a, { value: this.state.date_start, required: true, maskChar: null, name: 'date_start', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: '' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosAuxiliaresFadiga.ProcurarRelatorioAuxiliar.formulario.DataFinal,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_input_mask___default.a, { value: this.state.date_finish, required: true, maskChar: null, name: 'date_finish', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: '' })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'submit', className: 'btn btn-primary btn-block' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                  ' ',
                  this.locale.general.pesquisar
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosAuxiliaresFadiga.ProcurarRelatorioAuxiliar.tituloResultadosDeAutoavaliacoes
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: 'Exportar CSV', noDataText: this.locale.RelatoriosAuxiliaresFadiga.ProcurarRelatorioAuxiliar.tabela.semParametroDeFadiga }, search: true, multiColumnSearch: true, searchPlaceholder: 'Procurar' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { isKey: true, dataField: 'id', dataAlign: 'center', type: 'hidden', width: '60' },
                this.locale.RelatoriosAuxiliaresFadiga.ProcurarRelatorioAuxiliar.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { sortFunc: this.sortDates, dataField: 'created_at_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '100' },
                this.locale.RelatoriosAuxiliaresFadiga.ProcurarRelatorioAuxiliar.tabela.Data
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'staff_name', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '250' },
                this.locale.RelatoriosAuxiliaresFadiga.ProcurarRelatorioAuxiliar.tabela.Colaborador
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'first_question_risk_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '130' },
                this.locale.RelatoriosAuxiliaresFadiga.ProcurarRelatorioAuxiliar.tabela.Questao1
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'second_question_risk_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '130' },
                this.locale.RelatoriosAuxiliaresFadiga.ProcurarRelatorioAuxiliar.tabela.Questao2
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'third_question_risk_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '130' },
                this.locale.RelatoriosAuxiliaresFadiga.ProcurarRelatorioAuxiliar.tabela.Questao3
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'fourth_question_risk_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '130' },
                this.locale.RelatoriosAuxiliaresFadiga.ProcurarRelatorioAuxiliar.tabela.Questao4
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'result_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '140' },
                this.locale.RelatoriosAuxiliaresFadiga.ProcurarRelatorioAuxiliar.tabela.PontuacaoFinal
              )
            )
          )
        )
      );
    }
  }]);

  return SearchAuxiliaryReport;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SearchAuxiliaryReport);

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var FatigueReasonReportsAdd = function (_Component) {
  _inherits(FatigueReasonReportsAdd, _Component);

  function FatigueReasonReportsAdd(props) {
    var _this$state;

    _classCallCheck(this, FatigueReasonReportsAdd);

    var _this = _possibleConstructorReturn(this, (FatigueReasonReportsAdd.__proto__ || Object.getPrototypeOf(FatigueReasonReportsAdd)).call(this, props));

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__["a" /* default */])();

    _this.state = (_this$state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      fatigue_reason_id: null,
      pontual_issue: _this.locale.general.nao,
      observations: ''
    }, _defineProperty(_this$state, 'observations', ''), _defineProperty(_this$state, 'date', ''), _defineProperty(_this$state, 'fatigue_reasons', []), _defineProperty(_this$state, 'pontual_issue_list', [{ value: 'Não', label: _this.locale.general.nao }, { value: 'Sim', label: _this.locale.general.sim }]), _this$state);
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.add = _this.add.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(FatigueReasonReportsAdd, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }

    //LM

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData(event) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/fadigas/motivos/lista';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url', '/parametros-de-fadiga');
          if (responseJson.status === 'success') {
            self.setState({
              fatigue_reasons: responseJson.data
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          if (typeof event === 'undefined') {
            self.handleMessage();
          } else {
            self.handleAlert(event.message, event.status, 'open');
          }
        });
      });
    }
  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        fatigue_reason_id: this.state.fatigue_reason_id,
        date: this.state.date,
        observations: this.state.observations,
        pontual_issue: this.state.pontual_issue
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/reporte/voluntario/fadiga', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.ReportesDeFadigas.AdicionarReporteDeFadiga.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'form',
                { onSubmit: this.add },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.ReportesDeFadigas.AdicionarReporteDeFadiga.formulario.Motivo,
                        ':'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], {
                        className: 'form-field-name',
                        name: 'fatigue_reason_id',
                        value: this.state.fatigue_reason_id,
                        searchable: true,
                        placeholder: this.locale.ReportesDeFadigas.AdicionarReporteDeFadiga.formulario.placeholder.SelecionarMotivo,
                        onChange: this.handleSelectChange.bind(this, 'fatigue_reason_id'),
                        options: this.state.fatigue_reasons
                      })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.ReportesDeFadigas.AdicionarReporteDeFadiga.formulario.Data,
                        ':'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date, required: true, maskChar: null, name: 'date', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date'), placeholder: '' })
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-12' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.ReportesDeFadigas.AdicionarReporteDeFadiga.formulario.OProblemaApresentadoPodeSerAlgoPontual,
                        '?'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], {
                        className: 'form-field-name',
                        name: 'pontual_issue',
                        value: this.state.pontual_issue,
                        searchable: true,
                        placeholder: this.locale.ReportesDeFadigas.AdicionarReporteDeFadiga.formulario.placeholder.SelecionarOpcao,
                        onChange: this.handleSelectChange.bind(this, 'pontual_issue'),
                        options: this.state.pontual_issue_list
                      })
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-12' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.ReportesDeFadigas.AdicionarReporteDeFadiga.formulario.Observacoes,
                        ':'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'observations', className: 'form-control', placeholder: '', value: this.state.observations, onChange: this.handleChange.bind(this, 'observations') })
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-12' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                      ' ',
                      this.locale.ReportesDeFadigas.AdicionarReporteDeFadiga.formulario.botaoEnviarReporte
                    )
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
          )
        )
      );
    }
  }]);

  return FatigueReasonReportsAdd;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FatigueReasonReportsAdd);

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











// Importação da tabela



var FatigueReasonReportsArchived = function (_Component) {
  _inherits(FatigueReasonReportsArchived, _Component);

  function FatigueReasonReportsArchived(props) {
    _classCallCheck(this, FatigueReasonReportsArchived);

    var _this = _possibleConstructorReturn(this, (FatigueReasonReportsArchived.__proto__ || Object.getPrototypeOf(FatigueReasonReportsArchived)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      report_data: []
    };

    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.expandComponent = _this.expandComponent.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    _this.loadData = _this.loadData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(FatigueReasonReportsArchived, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/reporte/voluntario/fechados', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var button = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        { className: 'btn btn-primary' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-eye' })
      );

      return button;
    }
  }, {
    key: 'confirmReport',
    value: function confirmReport(id) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: id
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/fadiga/voluntaria/arquivar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'expandComponent',
    value: function expandComponent(row) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'expandable-row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-6 text-center' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              this.locale.ReportesDeFadigas.ListaDeReportesDeFadigasFechados.tituloMotivo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              row.fatigue_reason_name
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-6 text-center' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              this.locale.ReportesDeFadigas.ListaDeReportesDeFadigasFechados.tituloObservacoes
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              row.observations
            )
          )
        )
      );
    }
  }, {
    key: 'expandableRow',
    value: function expandableRow(row) {
      return true;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.ReportesDeFadigas.ListaDeReportesDeFadigasFechados.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.ReportesDeFadigas.ListaDeReportesDeFadigasFechados.tabela.semParametroDeFadiga, expandRowBgColor: 'rgb(235, 235, 235)' }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar, expandComponent: this.expandComponent, expandableRow: this.expandableRow },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.ReportesDeFadigas.ListaDeReportesDeFadigasFechados.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'name', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.ReportesDeFadigas.ListaDeReportesDeFadigasFechados.tabela.Tripulante
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'date', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.ReportesDeFadigas.ListaDeReportesDeFadigasFechados.tabela.Data
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '80' },
                this.locale.ReportesDeFadigas.ListaDeReportesDeFadigasFechados.tabela.Acoes
              )
            )
          )
        )
      );
    }
  }]);

  return FatigueReasonReportsArchived;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FatigueReasonReportsArchived);

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











// Importação da tabela



var FatigueReasonReportsIndex = function (_Component) {
  _inherits(FatigueReasonReportsIndex, _Component);

  function FatigueReasonReportsIndex(props) {
    _classCallCheck(this, FatigueReasonReportsIndex);

    var _this = _possibleConstructorReturn(this, (FatigueReasonReportsIndex.__proto__ || Object.getPrototypeOf(FatigueReasonReportsIndex)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      report_data: []
    };

    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.expandComponent = _this.expandComponent.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    _this.loadData = _this.loadData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(FatigueReasonReportsIndex, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/reporte/voluntario/abertos', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var button = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        { className: 'btn btn-primary' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-eye' })
      );

      return button;
    }
  }, {
    key: 'confirmReport',
    value: function confirmReport(id) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: id
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      var url = '/fadiga/voluntaria/arquivar/' + id;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'expandComponent',
    value: function expandComponent(row) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'expandable-row' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-6 text-center' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              this.locale.ReportesDeFadigas.ListaDeReportesDeFadigasAbertos.tituloMotivo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              row.fatigue_reason_name
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-6 text-center' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              this.locale.ReportesDeFadigas.ListaDeReportesDeFadigasAbertos.tituloObservacoes
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              row.observations
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-12 text-center' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { onClick: function onClick() {
                  _this2.confirmReport(row.id);
                }, className: 'btn btn-success btn-block' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-check' }),
              ' ',
              this.locale.ReportesDeFadigas.ListaDeReportesDeFadigasAbertos.botaoConfirmarVisualizacao
            )
          )
        )
      );
    }
  }, {
    key: 'expandableRow',
    value: function expandableRow(row) {
      return true;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.ReportesDeFadigas.ListaDeReportesDeFadigasAbertos.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.ReportesDeFadigas.ListaDeReportesDeFadigasAbertos.tabela.semParametroDeFadiga, expandRowBgColor: 'rgb(235, 235, 235)' }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar, expandComponent: this.expandComponent, expandableRow: this.expandableRow },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.ReportesDeFadigas.ListaDeReportesDeFadigasAbertos.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'name', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.ReportesDeFadigas.ListaDeReportesDeFadigasAbertos.tabela.Tripulante
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'date', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.ReportesDeFadigas.ListaDeReportesDeFadigasAbertos.tabela.Data
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '80' },
                this.locale.ReportesDeFadigas.ListaDeReportesDeFadigasAbertos.tabela.Acoes
              )
            )
          )
        )
      );
    }
  }]);

  return FatigueReasonReportsIndex;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FatigueReasonReportsIndex);

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var FatigueReasonsEdit = function (_Component) {
  _inherits(FatigueReasonsEdit, _Component);

  function FatigueReasonsEdit(props) {
    _classCallCheck(this, FatigueReasonsEdit);

    var _this = _possibleConstructorReturn(this, (FatigueReasonsEdit.__proto__ || Object.getPrototypeOf(FatigueReasonsEdit)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: {},
      name: ''
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.delete = _this.delete.bind(_this);
    _this.deleteRow = _this.deleteRow.bind(_this);
    _this.add = _this.add.bind(_this);
    _this.loadData = _this.loadData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(FatigueReasonsEdit, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }

    //LM

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData(event) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/fadigas/motivos';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url', '/parametros-de-fadiga');
          if (responseJson.status === 'success') {
            self.setState({
              data: responseJson.data
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          if (typeof event === 'undefined') {
            self.handleMessage();
          } else {
            self.handleAlert(event.message, event.status, 'open');
          }
        });
      });
    }
  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        name: this.state.name
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/fadiga/motivo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var data_temp = self.state.data;
            data_temp.push(responseJson.data);
            self.setState({ data: data_temp });
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'delete',
    value: function _delete(event) {
      var id = event.currentTarget.value;
      var confirm = window.confirm(this.locale.ReportesDeFadigas.EditarMotivosDeFadiga.deletar);
      if (confirm) {
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/fadiga/motivo/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.deleteRow(id);
              self.loadData();
            }
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'deleteRow',
    value: function deleteRow(id) {
      var data = this.state.data;
      data.map(function (dado, index) {
        if (dado.id == id) {
          data.splice(index, 1);
        }
      });
      this.setState({ fatigue_options_data: data });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.ReportesDeFadigas.EditarMotivosDeFadiga.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'form',
                { onSubmit: this.add },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.ReportesDeFadigas.EditarMotivosDeFadiga.formulario.Nome,
                        ':'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'name', className: 'form-control', placeholder: this.locale.ReportesDeFadigas.EditarMotivosDeFadiga.formulario.placeholder.NomeDoMotivoDeFadiga, value: this.state.name, onChange: this.handleChange.bind(this, 'name') })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { type: 'submit', className: 'btn btn-primary btn-block btn-inline' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                      ' ',
                      this.locale.general.salvar
                    )
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              this.locale.ReportesDeFadigas.EditarMotivosDeFadiga.tituloMotivosDeFadigaCadastrados
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'table',
              { className: 'table' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'thead',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    '#'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    this.locale.ReportesDeFadigas.EditarMotivosDeFadiga.tabela.Nome
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    { className: 'col-md-1' },
                    this.locale.ReportesDeFadigas.EditarMotivosDeFadiga.tabela.Acoes
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tbody',
                { id: 'frotas' },
                Object.keys(self.state.data).map(function (k) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      self.state.data[k].id
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      self.state.data[k].name
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { className: 'btn btn-sm btn-danger', value: self.state.data[k].id, onClick: self.delete },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-trash' })
                      )
                    )
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);

  return FatigueReasonsEdit;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FatigueReasonsEdit);

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












// Importação da tabela



var FatigueTestsIndex = function (_Component) {
  _inherits(FatigueTestsIndex, _Component);

  function FatigueTestsIndex(props) {
    _classCallCheck(this, FatigueTestsIndex);

    var _this = _possibleConstructorReturn(this, (FatigueTestsIndex.__proto__ || Object.getPrototypeOf(FatigueTestsIndex)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      modal: false,
      data: [],
      data_modal: [],
      applicabilities_list: [],
      staff_list: [],
      origins_list: [],
      status_list: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.search = _this.search.bind(_this);
    _this.showModal = _this.showModal.bind(_this);
    _this.export = _this.export.bind(_this);
    _this.sendEmail = _this.sendEmail.bind(_this);
    _this.loadData = _this.loadData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(FatigueTestsIndex, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeApplicability',
    value: function handleSelectChangeApplicability(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;

        var header = this.refs.request_api.header('application/json');
        var self = this;
        this.handleAlert('', '', 'open');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aplicabilidade/colaboradores/listagens/' + event.value, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.setState({ staff_list: responseJson.data.staffs });
            self.handleAlert(responseJson.message, responseJson.status, 'closed');
          });
        });
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeMulti',
    value: function handleSelectChangeMulti(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/questionario/pesquisa/fadiga/listagens';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ applicabilities_list: responseJson.data.applicabilities_list });
            self.setState({ origins_list: responseJson.data.origins_list });
            self.setState({ status_list: responseJson.data.status_list });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
        }); /* Overlay */
      });
    }
  }, {
    key: 'export',
    value: function _export() {
      var self = this;
      var url = "/questionario/pesquisa/fadiga/exportar/" + this.state.data_modal.id;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data);
          }
        });
      });
    }
  }, {
    key: 'sendEmail',
    value: function sendEmail(event) {
      var self = this;
      var url = "/questionario/pesquisa/fadiga/email/" + event.id;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
        });
      });
    }
  }, {
    key: 'search',
    value: function search(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        staff_ids: this.state.staff_ids,
        applicability_id: this.state.applicability_id,
        status: this.state.status,
        origins: this.state.origins
      };

      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/fadiga/questionarios/pesquisa', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          } else {
            self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'showModal',
    value: function showModal(event) {
      this.setState({ modal: true, data_modal: event.data_modal, date_str: event.date });
    }
  }, {
    key: 'modalPropsOff',
    value: function modalPropsOff(event) {
      this.setState({ modal: false, data_modal: [] });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var _this2 = this;

      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-success btn-sm', disabled: row.status === 'respondido' ? 'disabled' : '', onClick: function onClick() {
              _this2.sendEmail(row);
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-envelope' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-primary btn-sm', onClick: function onClick() {
              _this2.showModal(row);
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
        )
      );

      return botao;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.PesquisaDeRelatorios.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.search },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.PesquisaDeRelatorios.formulario.AplicabilidadeTipoDeColaborador,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'applicability_id',
                      value: this.state.applicability_id,
                      searchable: true,
                      required: true,
                      placeholder: this.locale.PesquisaDeRelatorios.formulario.placeholder.SelecionarAplicabilidade,
                      onChange: this.handleSelectChangeApplicability.bind(this, 'applicability_id'),
                      options: this.state.applicabilities_list
                    })
                  )
                ),
                this.state.applicability_id === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.PesquisaDeRelatorios.formulario.Tripulantes135,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'staff_id',
                      value: this.state.staff_id,
                      searchable: true,
                      placeholder: this.locale.PesquisaDeRelatorios.formulario.placeholder.SelecionarTripulante,
                      onChange: this.handleSelectChangeMulti.bind(this, 'staff_id'),
                      options: this.state.staff_list
                    })
                  )
                ) : this.state.applicability_id === 4 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.PesquisaDeRelatorios.formulario.Tripulantes121,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'staff_id',
                      value: this.state.staff_id,
                      searchable: true,
                      placeholder: this.locale.PesquisaDeRelatorios.formulario.placeholder.SelecionarTripulante,
                      onChange: this.handleSelectChangeMulti.bind(this, 'staff_id'),
                      options: this.state.staff_list
                    })
                  )
                ) : this.state.applicability_id === 2 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.PesquisaDeRelatorios.formulario.Mecanicos,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'staff_id',
                      value: this.state.staff_id,
                      searchable: true,
                      placeholder: this.locale.PesquisaDeRelatorios.formulario.placeholder.SelecionarMecanico,
                      onChange: this.handleSelectChangeMulti.bind(this, 'staff_id'),
                      options: this.state.staff_list
                    })
                  )
                ) : this.state.applicability_id === 3 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.PesquisaDeRelatorios.formulario.Coordenadores,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'staff_id',
                      value: this.state.staff_id,
                      searchable: true,
                      placeholder: this.locale.PesquisaDeRelatorios.formulario.placeholder.SelecionarCoordenador,
                      onChange: this.handleSelectChangeMulti.bind(this, 'staff_id'),
                      options: this.state.staff_list
                    })
                  )
                ) : ''
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.PesquisaDeRelatorios.formulario.DataInicial,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_input_mask___default.a, { value: this.state.date_start, required: true, maskChar: null, name: 'date_start', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: '' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.PesquisaDeRelatorios.formulario.DataFinal,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_input_mask___default.a, { value: this.state.date_finish, required: true, maskChar: null, name: 'date_finish', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: '' })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.PesquisaDeRelatorios.formulario.MotivoDoEnvio,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'origins',
                      value: this.state.origins,
                      searchable: true,
                      placeholder: this.locale.PesquisaDeRelatorios.formulario.placeholder.SelecionarMotivos,
                      multi: true,
                      onChange: this.handleSelectChangeMulti.bind(this, 'origins'),
                      options: this.state.origins_list
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.PesquisaDeRelatorios.formulario.Respondido,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'status',
                      value: this.state.status,
                      searchable: true,
                      placeholder: this.locale.PesquisaDeRelatorios.formulario.placeholder.SelecionarStatus,
                      multi: true,
                      onChange: this.handleSelectChangeMulti.bind(this, 'status'),
                      options: this.state.status_list
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'submit', className: 'btn btn-primary btn-block' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                  ' ',
                  this.locale.PesquisaDeRelatorios.formulario.botaoProcurarQuestionarios
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.PesquisaDeRelatorios.tituloListaDeQuestionarios
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.PesquisaDeRelatorios.tabelaListaDeQuestionarios.semQuestionarios }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'date', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' } },
                this.locale.PesquisaDeRelatorios.tabelaListaDeQuestionarios.Data
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'staff', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' } },
                this.locale.PesquisaDeRelatorios.tabelaListaDeQuestionarios.Colaborador
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'status_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' } },
                this.locale.PesquisaDeRelatorios.tabelaListaDeQuestionarios.Status
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'origin_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' } },
                this.locale.PesquisaDeRelatorios.tabelaListaDeQuestionarios.Motivo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '100' },
                this.locale.PesquisaDeRelatorios.tabelaListaDeQuestionarios.Acoes
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */],
              { show: this.state.modal, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Header,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h4',
                  { className: 'pull-left' },
                  this.locale.PesquisaDeRelatorios.tituloDadosDoQuestionarioDeFadiga,
                  ' - ',
                  self.state.date_str
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                      return _this3.setState({ modal: false });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Body,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { onClick: self.export, className: 'btn btn-success btn-md' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o', alt: 'Resultado de prova', title: 'Resultado da pesquisa' }),
                  ' ',
                  this.locale.PesquisaDeRelatorios.botaoExportarCSV
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'table',
                  { className: 'table table-bordered table-stripped table-hover' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'thead',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center' },
                        this.locale.PesquisaDeRelatorios.tabelaDadosDoQuestionario.Pergunta
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center' },
                        this.locale.PesquisaDeRelatorios.tabelaDadosDoQuestionario.Resposta
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tbody',
                    { id: 'suppliers-certifications' },
                    Object.keys(self.state.data_modal).map(function (k) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'tr',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'td',
                          { className: 'text-center' },
                          self.state.data_modal[k]['name']
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'td',
                          { className: 'text-center' },
                          self.state.data_modal[k]['value']
                        )
                      );
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Footer,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                      return _this3.setState({ modal: false });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FatigueTestsIndex;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FatigueTestsIndex);

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FlightReportRefuelsEdit__ = __webpack_require__(428);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var FlightReportRefuelsAdd = function (_Component) {
  _inherits(FlightReportRefuelsAdd, _Component);

  function FlightReportRefuelsAdd(props) {
    _classCallCheck(this, FlightReportRefuelsAdd);

    var _this = _possibleConstructorReturn(this, (FlightReportRefuelsAdd.__proto__ || Object.getPrototypeOf(FlightReportRefuelsAdd)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      approval_required: 0,
      export_required: 0,
      aircraft_id: '',
      date: '',
      flight_report_id: '',
      flight_report_leg_id: '',
      fuel_supplier_id: '',
      location_id: '',
      quantity: '',
      receit: '',
      requested: '',
      address: '',
      staff_id: '',
      fueling_started: '',
      fueling_finished: '',
      next_location_id: '',
      hydrant_no: '',
      your_sale_no: '',
      previous_sale_no: '',
      reading_finish: '',
      reading_start: '',
      fuel_type: '',
      fuel_type_id: '',
      aircrafts_select: [],
      flight_reports_select: [],
      flight_report_legs_select: [],
      locations_select: [],
      flight_report_legs: [],
      flight_report_refuels: [],
      flight_report_refuels_table: [],
      ptbr_fuels_select: [],
      fuel_suppliers_select: [],
      fuel_types_select: [],
      companies_select: [],
      staff_select: [],
      flight_report_refuel_edit: {},
      modal_locations_select: []
    };

    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);
    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    _this.add = _this.add.bind(_this);
    _this.updateData = _this.updateData.bind(_this);
    _this.updateDataByModal = _this.updateDataByModal.bind(_this);
    _this.closeModal = _this.closeModal.bind(_this);
    _this.openEditModal = _this.openEditModal.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(FlightReportRefuelsAdd, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        var date = event.target.value;
        var year = date.split("-")[0];
        var month = date.split("-")[1];
        var day = date.split("-")[2];
        change[name] = date;
      }
      this.setState(change);
    }
  }, {
    key: 'handleChangeGallonsReading',
    value: function handleChangeGallonsReading(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);

      if (name == 'reading_start') {
        var start = event.target.value;
      } else {
        var start = this.state.reading_start;
      }
      if (name == 'reading_finish') {
        var finish = event.target.value;
      } else {
        var finish = this.state.reading_finish;
      }
      var delivered = parseInt(finish) - parseInt(start);
      this.setState({ quantity: delivered });
    }
  }, {
    key: 'handleExtraFlightToggleChange',
    value: function handleExtraFlightToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = true;
      } else {
        var value = false;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeReport',
    value: function handleSelectChangeReport(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;

        var self = this;
        self.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');

        change['requested'] = '';
        change['receit'] = '';
        change['quantity'] = '';

        if (self.state.flight_report_legs[event.value]) {
          change['flight_report_legs_select'] = self.state.flight_report_legs[event.value];
        } else {
          change['flight_report_legs_select'] = [];
        }
        if (self.state.flight_report_refuels[event.value]) {
          change['flight_report_refuels_table'] = self.state.flight_report_refuels[event.value];
        } else {
          change['flight_report_refuels_table'] = [];
        }

        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/basic/' + event.value, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.setState({
              aircraft_id: responseJson.data.aircraft_id,
              fuel_type_id: responseJson.data.aircraft.aircraft_model.fuel_type_id
            });
            self.handleSelectChangeFuelType('fuel_type_id', { 'value': self.state.fuel_type_id });
            self.handleAlert(responseJson.message, responseJson.status, 'closed');
          });
        });
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeAircraft',
    value: function handleSelectChangeAircraft(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;

        var header = this.refs.request_api.header('application/json');
        var self = this;
        self.handleAlert('', '', 'open');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/' + event.value, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.setState({
              aircraft_id: responseJson.data.main.id,
              fuel_type_id: responseJson.data.main.aircraft_model.fuel_type_id
            });
            self.handleSelectChangeFuelType('fuel_type_id', { 'value': self.state.fuel_type_id });
            self.handleAlert(responseJson.message, responseJson.status, 'closed');
          });
        });
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeFuelType',
    value: function handleSelectChangeFuelType(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;

        var header = this.refs.request_api.header('application/json');
        var self = this;
        self.handleAlert('', '', 'open');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/tipo/combustivel/' + event.value, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.setState({
              fuel_type: responseJson.data.abbreviation
            });
            self.handleAlert(responseJson.message, responseJson.status, 'closed');
          });
        });
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeLeg',
    value: function handleSelectChangeLeg(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;

        var header = this.refs.request_api.header('application/json');
        var self = this;
        this.handleAlert('', '', 'open');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/trecho/localidade/' + event.value, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.setState({
              locations_select: responseJson.data.locations_select,
              location_id: responseJson.data.flight_report_leg.departure_location_id,
              next_location_id: responseJson.data.flight_report_leg.arrival_location_id,
              reading_start: responseJson.data.flight_report_leg.fuel_start
            });
            self.handleAlert(responseJson.message, responseJson.status, 'closed');
          });
        });
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeFuelSupplier',
    value: function handleSelectChangeFuelSupplier(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;

        var header = this.refs.request_api.header('application/json');
        var self = this;
        this.handleAlert('', '', 'open');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/fornecedor/combustivel/' + event.value, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            var _self$setState;

            self.setState((_self$setState = {
              approval_required: responseJson.data.main.refuel_approval_required,
              export_required: responseJson.data.main.refuel_export_required,
              staff_id: '',
              requested: '',
              receit: '',
              quantity: '',
              address: ''
            }, _defineProperty(_self$setState, 'staff_id', ''), _defineProperty(_self$setState, 'fueling_started', ''), _defineProperty(_self$setState, 'fueling_finished', ''), _defineProperty(_self$setState, 'next_location_id', ''), _defineProperty(_self$setState, 'hydrant_no', ''), _defineProperty(_self$setState, 'your_sale_no', ''), _defineProperty(_self$setState, 'previous_sale_no', ''), _defineProperty(_self$setState, 'reading_finish', ''), _defineProperty(_self$setState, 'reading_start', ''), _self$setState));
            self.handleAlert(responseJson.message, responseJson.status, 'closed');
          });
        });
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeCompany',
    value: function handleSelectChangeCompany(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;

        var header = this.refs.request_api.header('application/json');
        var self = this;
        this.handleAlert('', '', 'open');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/empresa/' + event.value, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.setState({
              address: responseJson.data.main.address + ', ' + responseJson.data.main.city + ', ' + responseJson.data.main.province
            });
            self.handleAlert(responseJson.message, responseJson.status, 'closed');
          });
        });
      }
      this.setState(change);
    }
  }, {
    key: 'updateData',
    value: function updateData() {
      var change = {};
      if (this.state.flight_report_refuels[this.state.flight_report_id]) {
        change['flight_report_refuels_table'] = this.state.flight_report_refuels[this.state.flight_report_id];
      } else {
        change['flight_report_refuels_table'] = [];
      }
      this.setState(change);
    }
  }, {
    key: 'updateDataByModal',
    value: function updateDataByModal(responseJson) {
      this.setState({
        flight_reports_select: responseJson.data.infos.flight_reports_select,
        flight_report_legs: responseJson.data.infos.flight_report_legs_select,
        flight_report_refuels: responseJson.data.infos.flight_report_refuels_table,
        fuel_suppliers_select: responseJson.data.infos.fuel_suppliers_select,
        fuel_types_select: responseJson.data.infos.fuel_types_select,
        companies_select: responseJson.data.infos.companies_select,
        staff_select: responseJson.data.infos.staff_select
      });
      this.updateData();
      this.handleAlert(responseJson.message, responseJson.status, 'open');
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/abastecimento/listas';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              aircrafts_select: responseJson.data.aircrafts_select,
              locations_select: responseJson.data.locations_select,
              flight_reports_select: responseJson.data.flight_reports_select,
              flight_report_legs: responseJson.data.flight_report_legs_select,
              flight_report_refuels: responseJson.data.flight_report_refuels,
              fuel_suppliers_select: responseJson.data.fuel_suppliers_select,
              fuel_types_select: responseJson.data.fuel_types_select,
              companies_select: responseJson.data.companies_select,
              staff_select: responseJson.data.staff_select
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
        });
      });
    }

    // Fetch salvando a edição

  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      var datasave = new FormData();
      var imagedata = document.querySelector(".input-nf-file").files[0];
      datasave.append("aircraft_id", this.state.aircraft_id);
      datasave.append("date", this.state.date);
      datasave.append("flight_report_id", this.state.flight_report_id);
      datasave.append("flight_report_leg_id", this.state.flight_report_leg_id);
      datasave.append("fuel_supplier_id", this.state.fuel_supplier_id);
      datasave.append("location_id", this.state.location_id);
      datasave.append("receit", this.state.receit);
      datasave.append("requested", this.state.requested);
      datasave.append("quantity", this.state.quantity);
      datasave.append("file", imagedata);
      datasave.append("address", this.state.address);
      datasave.append("staff_id", this.state.staff_id);
      datasave.append("fueling_started", this.state.fueling_started);
      datasave.append("fueling_finished", this.state.fueling_finished);
      datasave.append("next_location_id", this.state.next_location_id);
      datasave.append("hydrant_no", this.state.hydrant_no);
      datasave.append("your_sale_no", this.state.your_sale_no);
      datasave.append("previous_sale_no", this.state.previous_sale_no);
      datasave.append("reading_finish", this.state.reading_finish);
      datasave.append("reading_start", this.state.reading_start);
      datasave.append("fuel_type_id", this.state.fuel_type_id);
      var header = this.refs.request_api.header();
      var self = this;
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/abastecimento', {
          method: 'POST',
          mode: 'cors',
          headers: value,
          body: datasave }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var url = '/abastecimento/editar/' + responseJson.data.flight_report_refuel.id;
            var storage = {
              alert_message: responseJson.message,
              alert_type: responseJson.status
            };
            localStorage.setItem("verify_message", JSON.stringify(storage));
            self.setState({ redirect_url: url });
          }
          self.updateData();
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'delete',
    value: function _delete(id) {
      if (window.confirm(this.locale.RelatorioAbastecimento.AdicionarAbastecimento.deletar)) {
        this.handleAlert('', '', 'open');
        var datasave = {
          id: id
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/abastecimento', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({
              aircrafts_select: responseJson.data.infos.aircrafts_select,
              locations_select: responseJson.data.infos.locations_select,
              flight_reports_select: responseJson.data.infos.flight_reports_select,
              flight_report_legs: responseJson.data.infos.flight_report_legs_select,
              flight_report_refuels: responseJson.data.infos.flight_report_refuels_table,
              fuel_suppliers_select: responseJson.data.infos.fuel_suppliers_select,
              fuel_types_select: responseJson.data.infos.fuel_types_select,
              companies_select: responseJson.data.infos.companies_select,
              staff_select: responseJson.data.infos.staff_select,
              aircraft_id: '',
              date: '',
              flight_report_id: '',
              flight_report_leg_id: '',
              fuel_supplier_id: '',
              location_id: '',
              receit: '',
              requested: '',
              quantity: '',
              address: '',
              staff_id: '',
              fueling_started: '',
              fueling_finished: '',
              next_location_id: '',
              hydrant_no: '',
              your_sale_no: '',
              previous_sale_no: '',
              reading_finish: '',
              reading_start: '',
              fuel_type_id: ''
            });
            self.updateData();
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'openEditModal',
    value: function openEditModal(id) {
      var self = this;
      Object.keys(this.state.flight_report_refuels_table).map(function (k) {
        if (self.state.flight_report_refuels_table[k].id == id) {
          var flight_report_leg_id = self.state.flight_report_refuels_table[k].flight_report_leg_id;
          var flight_report_refuel_edit = self.state.flight_report_refuels_table[k];
          var fuel_supplier_id = self.state.flight_report_refuels_table[k].fuel_supplier.id;
          var header = self.refs.request_api.header('application/json');
          self.handleAlert('', '', 'open');
          Promise.resolve(header).then(function (value) {
            fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/trecho/localidade/' + flight_report_leg_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.setState({
                modal_locations_select: responseJson.data.locations_select,
                modal_location_id: responseJson.data.location_id,
                fuel_supplier_id: fuel_supplier_id,
                flight_report_refuel_edit: flight_report_refuel_edit,
                modal: true
              });
              self.handleAlert(responseJson.message, responseJson.status, 'closed');
            });
          });
        }
      });
    }
  }, {
    key: 'closeModal',
    value: function closeModal(responseJson) {
      this.setState({
        modal: false,
        flight_report_refuel_edit: {}
      });
      this.updateData();
    }
  }, {
    key: 'autoFillTime',
    value: function autoFillTime(name) {

      var now = __WEBPACK_IMPORTED_MODULE_8_moment___default()(new Date());
      now = now.format("HH:mm");
      var change = {};
      change[name] = now;

      this.setState(change);
    }
  }, {
    key: 'formFields',
    value: function formFields(fields_type) {
      var _this2 = this;

      var fields = '';

      if (fields_type == 0) {
        fields = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-4 form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              null,
              this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.CombustivelSolicitado,
              ':'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.requested, maskChar: null, name: 'requested ', mask: '9999', className: 'form-control', onChange: this.handleChange.bind(this, 'requested'), placeholder: '' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-4 form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              null,
              this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.NumeroDaCe,
              ':'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'receit', className: 'form-control', placeholder: '', value: this.state.receit, onChange: this.handleChange.bind(this, 'receit'), required: true })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-4 form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              null,
              this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.CombustivelAbastecido,
              ':'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.quantity, maskChar: null, name: 'quantity ', mask: '9999', className: 'form-control', onChange: this.handleChange.bind(this, 'quantity'), placeholder: '', required: true })
          )
        );
      } else {
        fields = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Endereco
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'address', className: 'form-control', placeholder: '', value: this.state.address, onChange: this.handleChange.bind(this, 'address'), required: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Comandante
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'staff_id',
                value: this.state.staff_id,
                searchable: true,
                placeholder: 'Selecione',
                onChange: this.handleSelectChange.bind(this, 'staff_id'),
                options: this.state.staff_select
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-2 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.InicioAbastecimento,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.fueling_started, maskChar: null, name: 'fueling_started ', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'fueling_started'), placeholder: 'hh:mm' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-1 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Click
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'button', className: 'btn btn-primary btn-sm form-control', onClick: function onClick() {
                    _this2.autoFillTime('fueling_started');
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-angle-double-left' }),
                ' ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-clock-o' })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-2 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.TerminoAbastecimento,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.fueling_finished, maskChar: null, name: 'fueling_finished ', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'fueling_finished'), placeholder: 'hh:mm' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-1 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Click
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'button', className: 'btn btn-primary btn-sm form-control', onClick: function onClick() {
                    _this2.autoFillTime('fueling_finished');
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-angle-double-left' }),
                ' ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-clock-o' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.ProximaLocalidade,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'next_location_id',
                value: this.state.next_location_id,
                searchable: true,
                placeholder: 'Selecione',
                onChange: this.handleSelectChange.bind(this, 'next_location_id'),
                options: this.state.locations_select,
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.NumeroHidrante,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'hydrant_no', className: 'form-control', placeholder: '999', value: this.state.hydrant_no, onChange: this.handleChange.bind(this, 'hydrant_no'), required: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.SeuNumeroDeVenda,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'your_sale_no', className: 'form-control', placeholder: '', value: this.state.your_sale_no, onChange: this.handleChange.bind(this, 'your_sale_no'), required: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.NumeroDeVendaAnterior,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'previous_sale_no', className: 'form-control', placeholder: '', value: this.state.previous_sale_no, onChange: this.handleChange.bind(this, 'previous_sale_no'), required: true })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.LeituraFinal,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'reading_finish', className: 'form-control', placeholder: '999', value: this.state.reading_finish, onChange: this.handleChangeGallonsReading.bind(this, 'reading_finish'), required: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.LeituraInicial,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'reading_start', className: 'form-control', placeholder: '999', value: this.state.reading_start, onChange: this.handleChangeGallonsReading.bind(this, 'reading_start'), required: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Entregues,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.quantity, maskChar: null, name: 'quantity', mask: '9999', className: 'form-control', onChange: this.handleChange.bind(this, 'quantity'), placeholder: '9999', required: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.TipoCombustivel,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'fuel_type_id',
                value: this.state.fuel_type_id,
                searchable: true,
                placeholder: 'Selecione',
                onChange: this.handleSelectChangeFuelType.bind(this, 'fuel_type_id'),
                options: this.state.fuel_types_select,
                required: true
              })
            )
          )
        );
      }

      return fields;
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.RelatorioAbastecimento.AdicionarAbastecimento.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/abastecimentos', className: 'btn btn-default pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-left' }),
              ' ',
              this.locale.general.voltar
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.add },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Fornecedor,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    name: 'fuel_supplier_id',
                    value: this.state.fuel_supplier_id,
                    searchable: true,
                    placeholder: 'Selecione',
                    onChange: this.handleSelectChangeFuelSupplier.bind(this, 'fuel_supplier_id'),
                    options: this.state.fuel_suppliers_select,
                    required: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.AnexarNotaFiscal,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'file', name: 'file', className: 'form-control input-nf-file', value: this.state.file, onChange: this.handleChange.bind(this, 'file') })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Relatorio,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    name: 'flight_report_id',
                    value: this.state.flight_report_id,
                    searchable: true,
                    placeholder: 'Selecione',
                    onChange: this.handleSelectChangeReport.bind(this, 'flight_report_id'),
                    options: this.state.flight_reports_select,
                    required: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Trecho,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    name: 'flight_report_leg_id',
                    value: this.state.flight_report_leg_id,
                    searchable: true,
                    placeholder: 'Selecione',
                    onChange: this.handleSelectChangeLeg.bind(this, 'flight_report_leg_id'),
                    options: this.state.flight_report_legs_select,
                    required: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Localidade,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    name: 'location_id',
                    value: this.state.location_id,
                    searchable: true,
                    placeholder: 'Selecione',
                    onChange: this.handleSelectChange.bind(this, 'location_id'),
                    options: this.state.locations_select,
                    required: true
                  })
                )
              ),
              this.formFields(this.state.export_required),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-block btn-inline' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                ' ',
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.botaoAdicionarAbastecimento
              )
            ),
            this.state.flight_report_id ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'table-responsive' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'table table-bordered table-hover table-striped' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      this.locale.RelatorioAbastecimento.AdicionarAbastecimento.tabela.Trecho
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      this.locale.RelatorioAbastecimento.AdicionarAbastecimento.tabela.NumeroDaCe
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      this.locale.RelatorioAbastecimento.AdicionarAbastecimento.tabela.Fornecedor
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      this.locale.RelatorioAbastecimento.AdicionarAbastecimento.tabela.Localidade
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      this.locale.RelatorioAbastecimento.AdicionarAbastecimento.tabela.QuantidadeSolicitada
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      this.locale.RelatorioAbastecimento.AdicionarAbastecimento.tabela.QuantidadeAbastecida
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { className: 'col-md-1 text-center' },
                      this.locale.RelatorioAbastecimento.AdicionarAbastecimento.tabela.Acoes
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  null,
                  Object.keys(self.state.flight_report_refuels_table).map(function (k) {
                    var srr = self.state.flight_report_refuels_table[k];
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      { key: srr.id },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        srr.flight_report_leg === null ? '' : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'span',
                          null,
                          srr.flight_report_leg.leg_number
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        srr.receit
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        srr.fuel_supplier === null ? '' : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'span',
                          null,
                          srr.fuel_supplier.name
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        srr.location === null ? '' : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'span',
                          null,
                          srr.location.name
                        )
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        srr.requested,
                        ' ',
                        self.state.fuel_type
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        srr.quantity,
                        ' L'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
                          { to: "/abastecimento/editar/" + srr.id, className: 'btn btn-primary btn-sm button-inline' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-pencil' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'button',
                          { onClick: function onClick() {
                              return self.delete(srr.id);
                            }, className: 'btn btn-danger btn-sm button-inline' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-trash' })
                        )
                      )
                    );
                  })
                )
              )
            ) : ''
          )
        )
      );
    }
  }]);

  return FlightReportRefuelsAdd;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportRefuelsAdd);

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// Importação da tabela


var FlightReportRefuelsIndex = function (_Component) {
  _inherits(FlightReportRefuelsIndex, _Component);

  function FlightReportRefuelsIndex(props) {
    _classCallCheck(this, FlightReportRefuelsIndex);

    var _this = _possibleConstructorReturn(this, (FlightReportRefuelsIndex.__proto__ || Object.getPrototypeOf(FlightReportRefuelsIndex)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      selected_date: '',
      data: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);
    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__["a" /* default */])();

    _this.export_caribbean_receipt = _this.export_caribbean_receipt.bind(_this);
    _this.export_receipt = _this.export_receipt.bind(_this);
    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    _this.next = _this.next.bind(_this);
    _this.previous = _this.previous.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(FlightReportRefuelsIndex, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, event) {
      var change = {};
      var full_date = this.state.date_start;
      if (event == null) {
        change[name] = null;
      } else {
        var date = event.target.value;
        var year = date.split("-")[0];
        var month = date.split("-")[1];
        var day = date.split("-")[2];
        // Utilizo o .slice(-2) para garantir o formato com 2 dígitos.
        var full_date = ("0" + day).slice(-2) + "/" + ("0" + month).slice(-2) + "/" + year;
        change[name] = date;
      }
      this.setState(change);
      this.loadData(full_date);
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        var now = new Date();
        var month = now.getMonth() + 1;
        var year = now.getFullYear();
        var day = now.getDate();
        if (day < 10) {
          day = '0' + day;
        }
        if (month < 10) {
          month = '0' + month;
        }
        var reference = day + '/' + month + '/' + year;
        this.setState({ loaded: 2 }, this.loadData(reference));
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var today = new Date();
      var date = today.setDate(today.getDate());
      var today_str = new Date(date).toISOString().split('T')[0]; // yyyy-mm-dd

      this.setState({ date_start: today_str });
    }
  }, {
    key: 'loadData',
    value: function loadData(reference) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/abastecimentos/' + reference, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data.index_data, current: responseJson.data.current, previous: responseJson.data.previous, next: responseJson.data.next });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'export_caribbean_receipt',
    value: function export_caribbean_receipt(id) {
      var self = this;
      var url = "/relatorio/voo/abastecimento/caribbean/exportar/";
      var header = this.refs.request_api.header('application/json');
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url + id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data;
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data);
          }
          self.handleAlert('', '', 'closed');
        });
      });
    }
  }, {
    key: 'export_receipt',
    value: function export_receipt(cell, row) {
      if (row.file === null) {
        return;
      }
      var url = '/files/refuels/' + cell + '_' + row.file;
      window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + url);
    }
  }, {
    key: 'delete',
    value: function _delete(id) {
      var confirm = window.confirm('Tem certeza que gostaria de deletar esse abastecimento?');
      if (confirm) {
        this.handleAlert('', '', 'open');
        var datasave = {
          id: id
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/abastecimento', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.deleteRow(id);
            }
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'deleteRow',
    value: function deleteRow(id) {
      var data = this.state.data;
      data.map(function (dado, index) {
        if (dado.id == id) {
          data.splice(index, 1);
        }
      });
      this.setState({ data: data });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var _this2 = this;

      var url = '/abastecimento/editar/' + cell;

      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
          { className: 'btn btn-primary btn-sm button-inline', to: url },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-success btn-sm button-inline', onClick: function onClick() {
              return _this2.export_receipt(cell, row);
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-download' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-danger btn-sm button-inline', onClick: function onClick() {
              return _this2.delete(cell);
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-trash' })
        )
      );

      return botao;
    }
  }, {
    key: 'next',
    value: function next() {
      this.setState({ overlay: { message: '', type: '', status: 'open' } });
      this.loadData(this.state.next);
    }
  }, {
    key: 'previous',
    value: function previous() {
      this.setState({ overlay: { message: '', type: '', status: 'open' } });
      this.loadData(this.state.previous);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-primary', onClick: this.previous },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-chevron-left' }),
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'hidden-sm hidden-xs' },
                    this.state.previous
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h3',
                  { className: 'page-title text-center' },
                  this.state.current
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3 text-right' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-primary', onClick: this.next },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'hidden-sm hidden-xs' },
                    this.state.next
                  ),
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-chevron-right' })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.lista
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/abastecimento/cadastrar', className: 'btn btn-primary pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-plus' }),
              ' ',
              this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.adicionar
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-2 col-md-offset-5' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'date', value: this.state.date_start, onChange: this.handleChangeDate.bind(this, 'date_start'), className: 'form-control' })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.general.semDados }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, hidden: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '60' },
                'ID'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'date_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '100' },
                this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.tabela.Data
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'flight_report_id', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '140' },
                this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.tabela.Relatório
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'flight_number', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.tabela.Voo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'aircraft_registration', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.tabela.Aeronave
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'fuel_supplier_name', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.tabela.Fornecedor
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'location_icao_code', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.tabela.Localidade
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'quantity', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.tabela.Quantidade
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '200' },
                this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.tabela.Acoes
              )
            )
          )
        )
      );
    }
  }]);

  return FlightReportRefuelsIndex;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportRefuelsIndex);

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












// Importação da tabela



var FlightReportsAbnormalOcurrences = function (_Component) {
  _inherits(FlightReportsAbnormalOcurrences, _Component);

  function FlightReportsAbnormalOcurrences(props) {
    _classCallCheck(this, FlightReportsAbnormalOcurrences);

    var _this = _possibleConstructorReturn(this, (FlightReportsAbnormalOcurrences.__proto__ || Object.getPrototypeOf(FlightReportsAbnormalOcurrences)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      searched: null,
      data: [],
      headers: [],
      status: 1,
      aircrafts_select: [],
      aircraft_models_select: [],
      bases_select: [],
      flight_types_select: [],
      clients_select: [],
      staffs_select: [],
      staffs: [],
      receits_select: [],
      fuel_company_select: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.search = _this.search.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(FlightReportsAbnormalOcurrences, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeMultiple',
    value: function handleSelectChangeMultiple(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/voo/formulario', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              aircrafts_select: responseJson.data.aircrafts_select,
              aircraft_models_select: responseJson.data.aircraft_models_select,
              bases_select: responseJson.data.bases_select,
              flight_types_select: responseJson.data.flight_types_select,
              clients_select: responseJson.data.clients_select,
              receits_select: responseJson.data.receits_select,
              fuel_company_select: responseJson.data.fuel_company_select,
              staffs_select: responseJson.data.staffs_select
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'search',
    value: function search(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');

      var datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        aircraft_id: this.state.aircraft_id,
        flight_report_id: this.state.flight_report_id,
        status: this.state.status,
        aircraft_model_id: this.state.aircraft_model_id
      };

      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/ocorrencia/anormal/pesquisa', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data.main, headers: responseJson.data.headers, searched: 1 });
          }
          self.handleAlert('', '', 'closed');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      var columns = null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosDeVoo.RelatorioDeOcorrenciasAnormais.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.search },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeOcorrenciasAnormais.formulario.DataInicial,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_start, maskChar: null, name: 'date_start ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeOcorrenciasAnormais.formulario.DataFinal,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_finish, maskChar: null, name: 'date_finish ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeOcorrenciasAnormais.formulario.SomenteAprovados,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'status',
                    value: this.state.status,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'status'),
                    options: [{ value: 1, label: this.locale.general.sim }, { value: 0, label: this.locale.general.nao }]
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeOcorrenciasAnormais.formulario.RelatorioDeVoo,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'flight_report_id', className: 'form-control', placeholder: this.locale.RelatoriosDeVoo.RelatorioDeOcorrenciasAnormais.formulario.placeholder.InformeONumeroDoRelatorioDeVoo, value: this.state.flight_report_id, onChange: this.handleChange.bind(this, 'flight_report_id') })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeOcorrenciasAnormais.formulario.Aeronave,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'aircraft_id',
                    value: this.state.aircraft_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'aircraft_id'),
                    options: this.state.aircrafts_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeOcorrenciasAnormais.formulario.Frota,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'aircraft_model_id',
                    value: this.state.aircraft_model_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'aircraft_model_id'),
                    options: this.state.aircraft_models_select
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-block btn-lg' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                ' ',
                this.locale.general.pesquisar
              )
            ),
            self.state.searched === 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["BootstrapTable"],
                { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: ' ' }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                  '#'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'date', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeOcorrenciasAnormais.tabela.Data
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeOcorrenciasAnormais.tabela.Prefixo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft_model_id', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeOcorrenciasAnormais.tabela.Frota
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'base', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeOcorrenciasAnormais.tabela.Base
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_type', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeOcorrenciasAnormais.tabela.TipoDeVoo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'contract', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeOcorrenciasAnormais.tabela.Contrato
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'client', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeOcorrenciasAnormais.tabela.Cliente
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_report', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeOcorrenciasAnormais.tabela.NumeroRelatorio
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_number', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeOcorrenciasAnormais.tabela.NumeroDoVoo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'type', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeOcorrenciasAnormais.tabela.TipoDeOcorrencia
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'description', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeOcorrenciasAnormais.tabela.DescricaoDaOcorrencia
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'action_required', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeOcorrenciasAnormais.tabela.AcaoRequerida
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'observations', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeOcorrenciasAnormais.tabela.Observacoes
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'staffs', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeOcorrenciasAnormais.tabela.Tripulantes
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FlightReportsAbnormalOcurrences;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportsAbnormalOcurrences);

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












// Importação da tabela



var FlightReportsAircrafts = function (_Component) {
  _inherits(FlightReportsAircrafts, _Component);

  function FlightReportsAircrafts(props) {
    _classCallCheck(this, FlightReportsAircrafts);

    var _this = _possibleConstructorReturn(this, (FlightReportsAircrafts.__proto__ || Object.getPrototypeOf(FlightReportsAircrafts)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      searched: null,
      data: [],
      headers: [],
      status: 1,
      range: 1,
      date_start: null,
      date_finish: null,
      base_id: null,
      contract_base_id: null,
      client_id: null,
      aircrafts_select: [],
      aircraft_models_select: [],
      bases_select: [],
      flight_types_select: [],
      clients_select: [],
      clients_full_select: [],
      receits_select: [],
      staffs_select: [],
      staffs: [],
      fuel_company_select: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.search = _this.search.bind(_this);
    _this.exportPdf = _this.exportPdf.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(FlightReportsAircrafts, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeMultiple',
    value: function handleSelectChangeMultiple(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/voo/formulario', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              aircrafts_select: responseJson.data.aircrafts_select,
              bases_select: responseJson.data.bases_select,
              clients_select: responseJson.data.clients_select,
              clients_full_select: responseJson.data.clients_full_select
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'search',
    value: function search(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');

      var datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_start,
        aircraft_id: this.state.aircraft_id,
        base_id: this.state.base_id,
        contract_base_id: this.state.contract_base_id,
        contract_id: this.state.contract_id,
        client_id: this.state.client_id,
        status: this.state.status,
        export_type: 0
      };

      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/voo/aeronaves/contratadas', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data.main, headers: responseJson.data.headers, searched: self.state.range });
          }
          self.handleAlert('', '', 'closed');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'exportPdf',
    value: function exportPdf() {
      this.handleAlert('', '', 'open');

      var datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_start,
        aircraft_id: this.state.aircraft_id,
        base_id: this.state.base_id,
        contract_id: this.state.contract_id,
        contract_base_id: this.state.contract_base_id,
        client_id: this.state.client_id,
        status: this.state.status,
        export_type: 1
      };
      var self = this;

      if (this.state.date_start === null || this.state.date_start === '' || this.state.contract_base_id === null || this.state.contract_base_id === '' | this.state.client_id === null || this.state.client_id === '') {
        self.handleAlert(this.locale.RelatoriosDeVoo.ControleDiarioDeUtilizacaoDeAeronavesContratadas.osCamposDataClienteEBaseSaoObrigatoriosParaExportacaoEmPDF, 'error', 'open');
      } else {
        var header = this.refs.request_api.header('application/json');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/voo/aeronaves/contratadas', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data.file;
              window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data.file);
            }
            self.handleAlert('', '', 'closed');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      var columns = null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosDeVoo.ControleDiarioDeUtilizacaoDeAeronavesContratadas.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.search },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ControleDiarioDeUtilizacaoDeAeronavesContratadas.formulario.Data,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_start, maskChar: null, name: 'date_start ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ControleDiarioDeUtilizacaoDeAeronavesContratadas.formulario.SomenteAprovados,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'status',
                    value: this.state.status,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'status'),
                    options: [{ value: 1, label: this.locale.general.sim }, { value: 0, label: this.locale.general.nao }]
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ControleDiarioDeUtilizacaoDeAeronavesContratadas.formulario.Base,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'base_id',
                    value: this.state.base_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'base_id'),
                    options: this.state.bases_select
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ControleDiarioDeUtilizacaoDeAeronavesContratadas.formulario.Aeronave,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'aircraft_id',
                    value: this.state.aircraft_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'aircraft_id'),
                    options: this.state.aircrafts_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ControleDiarioDeUtilizacaoDeAeronavesContratadas.formulario.Contrato,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'contract_id',
                    value: this.state.contract_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'contract_id'),
                    options: this.state.clients_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ControleDiarioDeUtilizacaoDeAeronavesContratadas.formulario.Cliente,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'client_id',
                    value: this.state.client_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'client_id'),
                    options: this.state.clients_full_select,
                    required: true
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ControleDiarioDeUtilizacaoDeAeronavesContratadas.formulario.BaseContratual,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'contract_base_id',
                    value: this.state.contract_base_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'contract_base_id'),
                    options: this.state.bases_select,
                    required: true
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'submit', className: 'btn btn-primary btn-block btn-lg' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                    ' ',
                    this.locale.general.pesquisar
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-success btn-block btn-lg', onClick: function onClick() {
                        return self.exportPdf();
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' }),
                    ' ',
                    this.locale.general.exportarPDF
                  )
                )
              )
            ),
            self.state.searched === 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["BootstrapTable"],
                { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: 'Exportar CSV', noDataText: ' ' }, search: true, multiColumnSearch: true, searchPlaceholder: 'Procurar' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '200' },
                  this.locale.RelatoriosDeVoo.ControleDiarioDeUtilizacaoDeAeronavesContratadas.tabela.Prefixo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft_model', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleDiarioDeUtilizacaoDeAeronavesContratadas.tabela.Frota
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'contract_name', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleDiarioDeUtilizacaoDeAeronavesContratadas.tabela.Contrato
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'ptbr_code', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleDiarioDeUtilizacaoDeAeronavesContratadas.tabela.CodigoSAP
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'takeoff_land_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleDiarioDeUtilizacaoDeAeronavesContratadas.tabela.TempoTotalDeVooNaDataDecolagemAoPouso
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'time_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleDiarioDeUtilizacaoDeAeronavesContratadas.tabela.TempoTotalDeVooNoDataPartidaAoCorte
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'reason', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleDiarioDeUtilizacaoDeAeronavesContratadas.tabela.IndisponibilidadesMotivos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'interruption_contractual_time_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleDiarioDeUtilizacaoDeAeronavesContratadas.tabela.IndisponibilidadesHoras
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FlightReportsAircrafts;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportsAircrafts);

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












// Importação da tabela



var FlightReportsAvailabilities = function (_Component) {
  _inherits(FlightReportsAvailabilities, _Component);

  function FlightReportsAvailabilities(props) {
    _classCallCheck(this, FlightReportsAvailabilities);

    var _this = _possibleConstructorReturn(this, (FlightReportsAvailabilities.__proto__ || Object.getPrototypeOf(FlightReportsAvailabilities)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      searched: null,
      data: [],
      totals: [],
      headers: [],
      status: 1,
      aircrafts_select: [],
      aircraft_models_select: [],
      bases_select: [],
      flight_types_select: [],
      clients_select: [],
      staffs_select: [],
      staffs: [],
      receits_select: [],
      fuel_company_select: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.search = _this.search.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(FlightReportsAvailabilities, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeMultiple',
    value: function handleSelectChangeMultiple(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/voo/formulario', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              aircrafts_select: responseJson.data.aircrafts_select,
              aircraft_models_select: responseJson.data.aircraft_models_select,
              bases_select: responseJson.data.bases_select,
              flight_types_select: responseJson.data.flight_types_select,
              clients_select: responseJson.data.clients_select,
              receits_select: responseJson.data.receits_select,
              fuel_company_select: responseJson.data.fuel_company_select,
              staffs_select: responseJson.data.staffs_select
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'search',
    value: function search(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');

      var datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        aircraft_id: this.state.aircraft_id,
        contract_id: this.state.contract_id,
        contract_base_id: this.state.contract_base_id,
        status: this.state.status
      };

      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/boletim/disponibilidade', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data.main, totals: responseJson.data.totals, headers: responseJson.data.headers, searched: 1 });
          }
          self.handleAlert('', '', 'closed');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      var columns = null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.search },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.formulario.DataInicial,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_start, maskChar: null, name: 'date_start ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.formulario.DataFinal,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_finish, maskChar: null, name: 'date_finish ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: '', required: true })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.formulario.Contrato,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'contract_id',
                    value: this.state.contract_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'contract_id'),
                    options: this.state.clients_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.formulario.SomenteAprovados,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'status',
                    value: this.state.status,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'status'),
                    options: [{ value: 1, label: this.locale.general.sim }, { value: 0, label: this.locale.general.nao }]
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.formulario.BaseContratual,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'contract_base_id',
                    value: this.state.contract_base_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'contract_base_id'),
                    options: this.state.bases_select
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-block btn-lg' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                ' ',
                this.locale.general.pesquisar
              )
            ),
            self.state.searched === 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["BootstrapTable"],
                { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: ' ' }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'contract', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '180' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.Contrato
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '120' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.Prefixo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'date', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '135' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.Data
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'contract_type', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.TipoDeContrato
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'takeoff_landing', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.VooDecolagemAoPouso
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'engines', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.VooPartidaAoCorte
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'landing', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.QtdPousos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'starts', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.QtdPartidas
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'takeoff_landing_total_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.VooTotalDecolagemAoPouso
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'takeoff_landing_average_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.DuracaoMediaDeVooDecolagemAoPouso
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'engines_total_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.VooTotalPartidaAoCorte
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'engines_average_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.DuracaoMediaDeVooPartidaAoCorte
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'contract_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.MaximoDeDisponibilidadeContratual
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'interruption_total_time_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.IndisponibilidadeReal
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'interruption_contractual_time_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.IndisponibilidadeContratual
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'availability_total_time_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.DisponibilidadeReal
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'availability_contractual_time_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.DisponibilidadeContratual
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'interruption_mprg_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.TipoMPRG
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'interruption_mnpr_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.TipoMNPR
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'interruption_ops_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.TipoOPS
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'abnormal_ocurrences', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabela.OcorrenciaAnormal
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                { classNam: 'page-title' },
                this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tituloTotais
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["BootstrapTable"],
                { data: this.state.totals, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: ' ' }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'contract', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '180' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.Contrato
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '120' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.Prefixo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'contract_type', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.TipoDeContrato
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'landing', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.QtdPousos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'starts', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.QtdPartidas
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'takeoff_landing_total_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.VooTotalDecolagemAoPouso
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'engines_total_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.VooTotalPartidaAoCorte
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'takeoff_landing_average_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.DuracaoMediaDeVooDecolagemAoPouso
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'engines_average_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.DuracaoMediaDeVooPartidaAoCorte
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'total_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.TempoTotalRegistrado
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'contract_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.MaximoDeDisponibilidadeContratual
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'interruption_total_time_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.IndisponibilidadeReal
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'interruption_contractual_time_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.IndisponibilidadeContratual
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'availability_total_time_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.DisponibilidadeReal
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'availability_contractual_time_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.DisponibilidadeContratual
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'interruption_mprg_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.TipoMPRG
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'interruption_mnpr_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.TipoMNPR
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'interruption_ops_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.TipoOPS
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'abnormal_ocurrences', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.OcorrenciaAnormal
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'interruption_total_time_percent', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.PorcentagemIndisponibilidadeReal
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'interruption_contractual_time_percent', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.PorcentagemIndisponibilidadeContratual
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'availability_total_time_percent', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.PorcentagemDisponibilidadeReal
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'availability_contractual_time_percent', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.PorcentagemDisponibilidadeContratual
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'interruption_mprg_percent', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.PorcentagemTipoMPRG
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'interruption_mnpr_percent', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.PorcentagemTipoMNPR
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'interruption_ops_percent', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.PorcentagemTipoOPS
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'utilization_takeoff_landing', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.PorcentagemAproveitamentoDecolagemAoPouso
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'utilization_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.BoletimDeDisponibilidade.tabelaTotais.PorcentagemAproveitamentoPartidaAoCorte
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FlightReportsAvailabilities;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportsAvailabilities);

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












// Importação da tabela



var FlightReportsAvailabilitiesSearch = function (_Component) {
  _inherits(FlightReportsAvailabilitiesSearch, _Component);

  function FlightReportsAvailabilitiesSearch(props) {
    _classCallCheck(this, FlightReportsAvailabilitiesSearch);

    var _this = _possibleConstructorReturn(this, (FlightReportsAvailabilitiesSearch.__proto__ || Object.getPrototypeOf(FlightReportsAvailabilitiesSearch)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      searched: null,
      data: [],
      headers: [],
      status: 1,
      aircrafts_select: [],
      aircraft_models_select: [],
      bases_select: [],
      flight_types_select: [],
      clients_select: [],
      staffs_select: [],
      staffs: [],
      receits_select: [],
      fuel_company_select: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.search = _this.search.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(FlightReportsAvailabilitiesSearch, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeMultiple',
    value: function handleSelectChangeMultiple(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/voo/formulario', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              aircrafts_select: responseJson.data.aircrafts_select,
              aircraft_models_select: responseJson.data.aircraft_models_select,
              bases_select: responseJson.data.bases_select,
              flight_types_select: responseJson.data.flight_types_select,
              clients_select: responseJson.data.clients_select,
              receits_select: responseJson.data.receits_select,
              fuel_company_select: responseJson.data.fuel_company_select,
              staffs_select: responseJson.data.staffs_select
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'search',
    value: function search(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');

      var datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        aircraft_id: this.state.aircraft_id,
        contract_id: this.state.contract_id,
        base_id: this.state.base_id,
        status: this.state.status
      };

      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/consulta/indisponibilidade', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data.main, headers: responseJson.data.headers, searched: 1 });
          }
          self.handleAlert('', '', 'closed');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      var columns = null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosDeVoo.FichasDeDisponibilidade.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.search },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.FichasDeDisponibilidade.formulario.DataInicial,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_start, maskChar: null, name: 'date_start ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.FichasDeDisponibilidade.formulario.DataFinal,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_finish, maskChar: null, name: 'date_finish ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: '', required: true })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.FichasDeDisponibilidade.formulario.Aeronave,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'aircraft_id',
                    value: this.state.aircraft_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'aircraft_id'),
                    options: this.state.aircrafts_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.FichasDeDisponibilidade.formulario.Contrato,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'contract_id',
                    value: this.state.contract_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'contract_id'),
                    options: this.state.clients_select
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.FichasDeDisponibilidade.formulario.Base,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'base_id',
                    value: this.state.base_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'base_id'),
                    options: this.state.bases_select
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-block btn-lg' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                ' ',
                this.locale.general.pesquisar
              )
            ),
            self.state.searched === 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["BootstrapTable"],
                { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: ' ' }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                  '#'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.FichasDeDisponibilidade.tabela.Prefixo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'contract', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.FichasDeDisponibilidade.tabela.Contrato
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'availability_start', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.FichasDeDisponibilidade.tabela.InicioDisponibilidadeContratual
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'availability_finish', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.FichasDeDisponibilidade.tabela.FimDispContratual
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'interruption_start', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.FichasDeDisponibilidade.tabela.InicioIndisponibilidade
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'interruption_finish', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.FichasDeDisponibilidade.tabela.FimIndisponibilidade
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'spare_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.FichasDeDisponibilidade.tabela.Franquia
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'interruption_contract_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.FichasDeDisponibilidade.tabela.IndisponibilidadeTotal
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'total_spare', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.FichasDeDisponibilidade.tabela.SemFranquia
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'interruption_total_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.FichasDeDisponibilidade.tabela.TempoTotal
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FlightReportsAvailabilitiesSearch;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportsAvailabilitiesSearch);

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












// Importação da tabela



var FlightReportsConsumption = function (_Component) {
  _inherits(FlightReportsConsumption, _Component);

  function FlightReportsConsumption(props) {
    _classCallCheck(this, FlightReportsConsumption);

    var _this = _possibleConstructorReturn(this, (FlightReportsConsumption.__proto__ || Object.getPrototypeOf(FlightReportsConsumption)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      searched: null,
      data: [],
      totals: [],
      headers: [],
      status: 1,
      aircrafts_select: [],
      aircraft_models_select: [],
      bases_select: [],
      flight_types_select: [],
      clients_select: [],
      clients_full_select: [],
      staffs_select: [],
      staffs: [],
      receits_select: [],
      fuel_company_select: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.search = _this.search.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(FlightReportsConsumption, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeMultiple',
    value: function handleSelectChangeMultiple(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/voo/formulario', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              aircrafts_select: responseJson.data.aircrafts_select,
              aircraft_models_select: responseJson.data.aircraft_models_select,
              bases_select: responseJson.data.bases_select,
              flight_types_select: responseJson.data.flight_types_select,
              clients_select: responseJson.data.clients_select,
              clients_full_select: responseJson.data.clients_full_select,
              receits_select: responseJson.data.receits_select,
              fuel_company_select: responseJson.data.fuel_company_select,
              staffs_select: responseJson.data.staffs_select
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'search',
    value: function search(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');

      var datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        aircraft_id: this.state.aircraft_id,
        client_id: this.state.client_id,
        base_id: this.state.base_id,
        contract_base_id: this.state.contract_base_id,
        contract_id: this.state.contract_id,
        flight_type_id: this.state.flight_type_id,
        flight_report_id: this.state.flight_report_id,
        status: this.state.status,
        aircraft_model_id: this.state.aircraft_model_id,
        receit: this.state.receit,
        fuel_company: this.state.fuel_company
      };

      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/consumo/pesquisa', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data.main, totals: responseJson.data.totals, headers: responseJson.data.headers, searched: 1 });
            self.handleAlert('', '', 'closed');
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      var columns = null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosDeVoo.RelatorioDeConsumo.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.search },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeConsumo.formulario.DataInicial,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_start, maskChar: null, name: 'date_start ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeConsumo.formulario.DataFinal,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_finish, maskChar: null, name: 'date_finish ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeConsumo.formulario.SomenteAprovados,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'status',
                    value: this.state.status,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'status'),
                    options: [{ value: 1, label: this.locale.general.sim }, { value: 0, label: this.locale.general.nao }]
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeConsumo.formulario.RelatorioDeVoo,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'flight_report_id', className: 'form-control', placeholder: this.locale.RelatoriosDeVoo.RelatorioDeConsumo.formulario.placeholder.InformeONumeroDoRelatorioDeVoo, value: this.state.flight_report_id, onChange: this.handleChange.bind(this, 'flight_report_id') })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeConsumo.formulario.Aeronave,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'aircraft_id',
                    value: this.state.aircraft_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'aircraft_id'),
                    options: this.state.aircrafts_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeConsumo.formulario.Frota,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'aircraft_model_id',
                    value: this.state.aircraft_model_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'aircraft_model_id'),
                    options: this.state.aircraft_models_select
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeConsumo.formulario.Base,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'base_id',
                    value: this.state.base_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'base_id'),
                    options: this.state.bases_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeConsumo.formulario.TipoDeVoo,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'flight_type_id',
                    value: this.state.flight_type_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'flight_type_id'),
                    options: this.state.flight_types_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeConsumo.formulario.Contrato,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'contract_id',
                    value: this.state.contract_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'contract_id'),
                    options: this.state.clients_select
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeConsumo.formulario.Cliente,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'client_id',
                    value: this.state.client_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'client_id'),
                    options: this.state.clients_full_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeConsumo.formulario.NumeroDeReciboDoCombustivel,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'receit',
                    value: this.state.receit,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'receit'),
                    options: this.state.receits_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeConsumo.formulario.FornecedorDeCombustivel,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'fuel_company',
                    value: this.state.fuel_company,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'fuel_company'),
                    options: this.state.fuel_company_select
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeConsumo.formulario.BaseContratual,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'contract_base_id',
                    value: this.state.contract_base_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'contract_base_id'),
                    options: this.state.bases_select
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-block btn-lg' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                ' ',
                this.locale.general.pesquisar
              )
            ),
            self.state.searched === 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["BootstrapTable"],
                { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: ' ' }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                  '#'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'date', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.Data
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.Prefixo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft_model_id', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.Frota
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'base', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.Base
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_type', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.TipoDeVoo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'contract', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.Contrato
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'client', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.Cliente
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_report', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.NumeroRelatorio
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_number', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.NumeroDoVoo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'exemption', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.Isencao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'takeoff_land_time_continuous_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.TotalVooDecolagemAoPouso
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'time_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.TotalDoVooPartidaAoCorte
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'navigation_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.TotalDoVooNavegacao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'ifr_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.TotalDoVooInstrumento
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'night_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.TotalDoVooNoturno
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'starts', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.TotalDoVooPartidas
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'day_landings_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.TotalDoVooPousosDiurnos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'night_landings_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.TotalDoVooPousosNoturnos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'pax_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.TotalDoVooPAX
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'payload_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.TotalDoVooCarga
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'payment_type', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.TipoDeContrato
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'authorized_consumption', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.CombustivelAutorizado
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'fuel_company', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.FornecedorDeCombustivel
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'receit', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.NumeroDaCE
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'requested', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.QuantidadeSolicitada
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'quantity', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.QuantidadeAbastecida
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'quantity_converted', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.QuantidadeAbastecidaConvertida
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'difference', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.Saldo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'fuel_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.Consumo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'consumption_liters', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabela.ConsumoEmLitros
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                null,
                this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tituloTotais
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["BootstrapTable"],
                { data: this.state.totals, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: ' ' }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                  '#'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabelaTotais.Prefixo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft_model_id', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabelaTotais.Frota
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'takeoff_land_time_continuous_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabelaTotais.TotalVooDecolagemAoPouso
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'time_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabelaTotais.TotalDoVooPartidaAoCorte
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'navigation_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabelaTotais.TotalDoVooNavegacao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'ifr_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabelaTotais.TotalDoVooInstrumento
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'night_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabelaTotais.TotalDoVooNoturno
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'starts', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabelaTotais.TotalDoVooPartidas
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'day_landings_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabelaTotais.TotalDoVooPousosDiurnos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'night_landings_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabelaTotais.TotalDoVooPousosNoturnos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'pax_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabelaTotais.TotalDoVooPAX
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'payload_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabelaTotais.TotalDoVooCarga
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'authorized_consumption', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabelaTotais.CombustivelAutorizado
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'requested', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabelaTotais.QuantidadeSolicitada
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'quantity', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabelaTotais.QuantidadeAbastecida
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'quantity_converted', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabelaTotais.QuantidadeAbastecidaConvertida
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'difference', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabelaTotais.Saldo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'fuel_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabelaTotais.Consumo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'consumption_liters', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeConsumo.tabelaTotais.ConsumoEmLitros
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FlightReportsConsumption;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportsConsumption);

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












// Importação da tabela



var FlightReportsConsumptionDisponibility = function (_Component) {
  _inherits(FlightReportsConsumptionDisponibility, _Component);

  function FlightReportsConsumptionDisponibility(props) {
    _classCallCheck(this, FlightReportsConsumptionDisponibility);

    var _this = _possibleConstructorReturn(this, (FlightReportsConsumptionDisponibility.__proto__ || Object.getPrototypeOf(FlightReportsConsumptionDisponibility)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      searched: null,
      data: [],
      headers: [],
      status: 1,
      aircrafts_select: [],
      aircraft_models_select: [],
      bases_select: [],
      flight_types_select: [],
      clients_full_select: [],
      staffs_select: [],
      staffs: [],
      receits_select: [],
      fuel_company_select: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.search = _this.search.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(FlightReportsConsumptionDisponibility, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeMultiple',
    value: function handleSelectChangeMultiple(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/voo/formulario', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              aircrafts_select: responseJson.data.aircrafts_select,
              aircraft_models_select: responseJson.data.aircraft_models_select,
              bases_select: responseJson.data.bases_select,
              flight_types_select: responseJson.data.flight_types_select,
              clients_full_select: responseJson.data.clients_full_select,
              receits_select: responseJson.data.receits_select,
              fuel_company_select: responseJson.data.fuel_company_select,
              staffs_select: responseJson.data.staffs_select
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'search',
    value: function search(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');

      var datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        aircraft_id: this.state.aircraft_id,
        base_id: this.state.base_id,
        client_id: this.state.client_id,
        status: this.state.status
      };

      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/consumo/disponibilidade/pesquisa', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data.main, headers: responseJson.data.headers, searched: 1 });
          }
          self.handleAlert('', '', 'closed');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      var columns = null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosDeVoo.RelatorioDeDisponibilidadeDeCombustivel.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.search },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeDisponibilidadeDeCombustivel.formulario.MesInicio,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_start, maskChar: null, name: 'date_start ', mask: '99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: this.locale.general.mesAno, required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeDisponibilidadeDeCombustivel.formulario.MesTermino,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_finish, maskChar: null, name: 'date_finish ', mask: '99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: this.locale.general.mesAno, required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeDisponibilidadeDeCombustivel.formulario.Aeronave,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'aircraft_id',
                    value: this.state.aircraft_id,
                    searchable: true,
                    placeholder: '',
                    multi: true,
                    onChange: this.handleSelectChangeMultiple.bind(this, 'aircraft_id'),
                    options: this.state.aircrafts_select
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeDisponibilidadeDeCombustivel.formulario.Base,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'base_id',
                    value: this.state.base_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'base_id'),
                    options: this.state.bases_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeDisponibilidadeDeCombustivel.formulario.Cliente,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'client_id',
                    value: this.state.client_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'client_id'),
                    options: this.state.clients_full_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeDisponibilidadeDeCombustivel.formulario.SomenteAprovados,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'status',
                    value: this.state.status,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'status'),
                    options: [{ value: 1, label: this.locale.general.sim }, { value: 0, label: this.locale.general.nao }]
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-block btn-lg' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                ' ',
                this.locale.general.pesquisar
              )
            ),
            self.state.searched === 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["BootstrapTable"],
                { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: ' ' }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                  '#'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'start', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeDisponibilidadeDeCombustivel.tabela.Inicio
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'finish', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeDisponibilidadeDeCombustivel.tabela.Fim
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeDisponibilidadeDeCombustivel.tabela.Aeronave
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft_model', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeDisponibilidadeDeCombustivel.tabela.Frota
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'contract', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeDisponibilidadeDeCombustivel.tabela.Contrato
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'client', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeDisponibilidadeDeCombustivel.tabela.Cliente
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'quantity', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeDisponibilidadeDeCombustivel.tabela.QuantidadeAbastecida
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'quantity_converted', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeDisponibilidadeDeCombustivel.tabela.QuantidadeAbastecidaConvertida
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'fuel_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeDisponibilidadeDeCombustivel.tabela.Consumo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'authorized_consumption', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeDisponibilidadeDeCombustivel.tabela.CAutorizado
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'net_consumption', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeDisponibilidadeDeCombustivel.tabela.Saldo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'total_hours', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeDisponibilidadeDeCombustivel.tabela.HorasTotais
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'total_days', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeDisponibilidadeDeCombustivel.tabela.Dias
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'average_hours', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeDisponibilidadeDeCombustivel.tabela.MediaDeHorasDeVooPorDia
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'average_consumption', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeDisponibilidadeDeCombustivel.tabela.MediaDeConsumoPorDia
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'average_consumption_per_hour', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '280' },
                  this.locale.RelatoriosDeVoo.RelatorioDeDisponibilidadeDeCombustivel.tabela.MediaDeConsumoPorHorasDeVoo
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FlightReportsConsumptionDisponibility;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportsConsumptionDisponibility);

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












// Importação da tabela



var FlightReportsDBMultiple = function (_Component) {
  _inherits(FlightReportsDBMultiple, _Component);

  function FlightReportsDBMultiple(props) {
    _classCallCheck(this, FlightReportsDBMultiple);

    var _this = _possibleConstructorReturn(this, (FlightReportsDBMultiple.__proto__ || Object.getPrototypeOf(FlightReportsDBMultiple)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      searched: null,
      data: [],
      headers: [],
      status: 1,
      aircrafts_select: [],
      aircraft_models_select: [],
      bases_select: [],
      flight_types_select: [],
      clients_select: [],
      receits_select: [],
      fuel_company_select: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.search = _this.search.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(FlightReportsDBMultiple, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeMultiple',
    value: function handleSelectChangeMultiple(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/voo/formulario', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              aircrafts_select: responseJson.data.aircrafts_select,
              aircraft_models_select: responseJson.data.aircraft_models_select,
              bases_select: responseJson.data.bases_select,
              flight_types_select: responseJson.data.flight_types_select,
              clients_select: responseJson.data.clients_select,
              receits_select: responseJson.data.receits_select,
              fuel_company_select: responseJson.data.fuel_company_select
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'search',
    value: function search(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');

      var datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        aircraft_id: this.state.aircraft_id,
        contract_base_id: this.state.contract_base_id,
        contract_id: this.state.contract_id,
        base_id: this.state.base_id,
        status: this.state.status
      };

      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/db/completo/restrito', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data.main, headers: responseJson.data.headers, searched: 1 });
            var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data.file;
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data.file);
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      var columns = null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosDeVoo.ExtratoDeDBEmBloco.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.search },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ExtratoDeDBEmBloco.formulario.DataInicial,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_start, maskChar: null, name: 'date_start ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ExtratoDeDBEmBloco.formulario.DataFinal,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_finish, maskChar: null, name: 'date_finish ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ExtratoDeDBEmBloco.formulario.Aeronave,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'aircraft_id',
                    value: this.state.aircraft_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'aircraft_id'),
                    options: this.state.aircrafts_select
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ExtratoDeDBEmBloco.formulario.Contrato,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'contract_id',
                    value: this.state.contract_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'contract_id'),
                    options: this.state.clients_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ExtratoDeDBEmBloco.formulario.Base,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'base_id',
                    value: this.state.base_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'base_id'),
                    options: this.state.bases_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ExtratoDeDBEmBloco.formulario.BasesContratual,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'contract_base_id',
                    value: this.state.contract_base_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'contract_base_id'),
                    options: this.state.bases_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ExtratoDeDBEmBloco.formulario.SomenteAprovados,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'status',
                    value: this.state.status,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'status'),
                    options: [{ value: 1, label: this.locale.general.sim }, { value: 0, label: this.locale.general.nao }]
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-block btn-lg' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                ' ',
                this.locale.general.pesquisar
              )
            ),
            self.state.searched === 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["BootstrapTable"],
                { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: ' ' }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                  '#'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'date', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ExtratoDeDBEmBloco.tabela.Data
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ExtratoDeDBEmBloco.tabela.Prefixo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft_model_id', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ExtratoDeDBEmBloco.tabela.Frota
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'base', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ExtratoDeDBEmBloco.tabela.Base
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'contract', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ExtratoDeDBEmBloco.tabela.Contrato
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'client', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ExtratoDeDBEmBloco.tabela.Cliente
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_report', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ExtratoDeDBEmBloco.tabela.NumeroRelatorio
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_number', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ExtratoDeDBEmBloco.tabela.NumeroDoVoo
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FlightReportsDBMultiple;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportsDBMultiple);

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












// Importação da tabela



var FlightReportsDestinies = function (_Component) {
  _inherits(FlightReportsDestinies, _Component);

  function FlightReportsDestinies(props) {
    _classCallCheck(this, FlightReportsDestinies);

    var _this = _possibleConstructorReturn(this, (FlightReportsDestinies.__proto__ || Object.getPrototypeOf(FlightReportsDestinies)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      searched: null,
      data: [],
      headers: [],
      status: 1,
      aircrafts_select: [],
      aircraft_models_select: [],
      bases_select: [],
      flight_types_select: [],
      clients_select: [],
      staffs_select: [],
      staffs: [],
      receits_select: [],
      fuel_company_select: [],
      locations_select: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.search = _this.search.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(FlightReportsDestinies, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeMultiple',
    value: function handleSelectChangeMultiple(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/voo/formulario', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              aircrafts_select: responseJson.data.aircrafts_select,
              aircraft_models_select: responseJson.data.aircraft_models_select,
              bases_select: responseJson.data.bases_select,
              flight_types_select: responseJson.data.flight_types_select,
              clients_select: responseJson.data.clients_select,
              receits_select: responseJson.data.receits_select,
              fuel_company_select: responseJson.data.fuel_company_select,
              staffs_select: responseJson.data.staffs_select,
              locations_select: responseJson.data.locations_select
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'search',
    value: function search(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');

      var datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        aircraft_id: this.state.aircraft_id,
        flight_report_id: this.state.flight_report_id,
        status: this.state.status,
        aircraft_model_id: this.state.aircraft_model_id,
        location_id: this.state.location_id
      };

      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/destino/pesquisa', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data.main, headers: responseJson.data.headers, searched: 1 });
          }
          self.handleAlert('', '', 'closed');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      var columns = null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosDeVoo.RelatorioDePousosPorLocalidade.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.search },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDePousosPorLocalidade.formulario.DataInicial,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_start, maskChar: null, name: 'date_start ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDePousosPorLocalidade.formulario.DataFinal,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_finish, maskChar: null, name: 'date_finish ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDePousosPorLocalidade.formulario.SomenteAprovados,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'status',
                    value: this.state.status,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'status'),
                    options: [{ value: 1, label: this.locale.general.sim }, { value: 0, label: this.locale.general.nao }]
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDePousosPorLocalidade.formulario.Local,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'location_id',
                    value: this.state.location_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'location_id'),
                    options: this.state.locations_select,
                    required: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDePousosPorLocalidade.formulario.RelatorioDeVoo,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'flight_report_id', className: 'form-control', placeholder: this.locale.RelatoriosDeVoo.RelatorioDePousosPorLocalidade.formulario.placeholder.InformeONumeroDoRelatorioDeVoo, value: this.state.flight_report_id, onChange: this.handleChange.bind(this, 'flight_report_id') })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDePousosPorLocalidade.formulario.Aeronave,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'aircraft_id',
                    value: this.state.aircraft_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'aircraft_id'),
                    options: this.state.aircrafts_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDePousosPorLocalidade.formulario.Frota,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'aircraft_model_id',
                    value: this.state.aircraft_model_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'aircraft_model_id'),
                    options: this.state.aircraft_models_select
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-block btn-lg' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                ' ',
                this.locale.general.pesquisar
              )
            ),
            self.state.searched === 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["BootstrapTable"],
                { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: ' ' }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                  '#'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'date', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDePousosPorLocalidade.tabela.Data
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDePousosPorLocalidade.tabela.Prefixo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft_model_id', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDePousosPorLocalidade.tabela.Frota
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'base', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDePousosPorLocalidade.tabela.Base
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_type', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDePousosPorLocalidade.tabela.TipoDeVoo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'contract', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDePousosPorLocalidade.tabela.Contrato
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'client', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDePousosPorLocalidade.tabela.Cliente
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_report', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDePousosPorLocalidade.tabela.NumeroRelatorio
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_number', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDePousosPorLocalidade.tabela.NumeroDoVoo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'departure_location', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDePousosPorLocalidade.tabela.Origem
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'arrival_location', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDePousosPorLocalidade.tabela.Destino
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'staffs', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDePousosPorLocalidade.tabela.Tripulantes
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'takeoff_land_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDePousosPorLocalidade.tabela.DEPARR
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'total_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDePousosPorLocalidade.tabela.Total
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'total_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDePousosPorLocalidade.tabela.TotalDePousosDaAnvNaData
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'total_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDePousosPorLocalidade.tabela.TotalDePousosDaAnvNoPeriodo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'total_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDePousosPorLocalidade.tabela.TotalDePousosDaFrotaNoPeriodo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'total_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDePousosPorLocalidade.tabela.TotalDePousosGeralNoPeriodo
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FlightReportsDestinies;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportsDestinies);

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












// Importação da tabela



var FlightReportsHoursReport = function (_Component) {
  _inherits(FlightReportsHoursReport, _Component);

  function FlightReportsHoursReport(props) {
    _classCallCheck(this, FlightReportsHoursReport);

    var _this = _possibleConstructorReturn(this, (FlightReportsHoursReport.__proto__ || Object.getPrototypeOf(FlightReportsHoursReport)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      searched: null,
      data: [],
      headers: [],
      status: 1,
      type: 0,
      aircrafts_select: [],
      aircraft_models_select: [],
      bases_select: [],
      flight_types_select: [],
      clients_select: [],
      clients_full_select: [],
      staffs_select: [],
      staffs: [],
      receits_select: [],
      fuel_company_select: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.search = _this.search.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(FlightReportsHoursReport, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeMultiple',
    value: function handleSelectChangeMultiple(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/voo/formulario', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              aircrafts_select: responseJson.data.aircrafts_select,
              aircraft_models_select: responseJson.data.aircraft_models_select,
              bases_select: responseJson.data.bases_select,
              flight_types_select: responseJson.data.flight_types_select,
              clients_select: responseJson.data.clients_select,
              clients_full_select: responseJson.data.clients_full_select,
              receits_select: responseJson.data.receits_select,
              fuel_company_select: responseJson.data.fuel_company_select,
              staffs_select: responseJson.data.staffs_select
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'search',
    value: function search(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');

      var datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        aircraft_id: this.state.aircraft_id,
        contract_base_id: this.state.contract_base_id,
        contract_id: this.state.contract_id,
        client_id: this.state.client_id,
        type: this.state.type,
        status: this.state.status
      };

      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/apuracao/horas', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data.main, headers: responseJson.data.headers, searched: 1 });
          }
          self.handleAlert('', '', 'closed');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      var columns = null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosDeVoo.ApuracaoDeHoras.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.search },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ApuracaoDeHoras.formulario.DataInicial,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_start, maskChar: null, name: 'date_start ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ApuracaoDeHoras.formulario.DataFinal,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_finish, maskChar: null, name: 'date_finish ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ApuracaoDeHoras.formulario.Aeronave,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'aircraft_id',
                    value: this.state.aircraft_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'aircraft_id'),
                    options: this.state.aircrafts_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ApuracaoDeHoras.formulario.BaseContratual,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'contract_base_id',
                    value: this.state.contract_base_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'contract_base_id'),
                    options: this.state.bases_select
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ApuracaoDeHoras.formulario.Contrato,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'contract_id',
                    value: this.state.contract_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'contract_id'),
                    options: this.state.clients_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ApuracaoDeHoras.formulario.Cliente,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'client_id',
                    value: this.state.client_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'client_id'),
                    options: this.state.clients_full_select,
                    required: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ApuracaoDeHoras.formulario.Indisponibilidade,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'type',
                    value: this.state.type,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'type'),
                    options: [{ value: 0, label: this.locale.RelatoriosDeVoo.ApuracaoDeHoras.formulario.opcoesIndisponibilidade.NaoExibir }, { value: 1, label: this.locale.RelatoriosDeVoo.ApuracaoDeHoras.formulario.opcoesIndisponibilidade.ExibirApenasTotal }, { value: 2, label: this.locale.RelatoriosDeVoo.ApuracaoDeHoras.formulario.opcoesIndisponibilidade.ExibirApenasContratual }, { value: 3, label: this.locale.RelatoriosDeVoo.ApuracaoDeHoras.formulario.opcoesIndisponibilidade.ExibirTodas }]
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ApuracaoDeHoras.formulario.SomenteAprovados,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'status',
                    value: this.state.status,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'status'),
                    options: [{ value: 1, label: this.locale.general.sim }, { value: 0, label: this.locale.general.nao }]
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-block btn-lg' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                ' ',
                this.locale.general.pesquisar
              )
            ),
            self.state.searched === 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["BootstrapTable"],
                { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: ' ' }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                  '#'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'date', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ApuracaoDeHoras.tabela.Data
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'contract', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ApuracaoDeHoras.tabela.Contrato
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ApuracaoDeHoras.tabela.PrefixoContratual
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'backup', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ApuracaoDeHoras.tabela.Backup
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_report', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ApuracaoDeHoras.tabela.NumeroDoRelatorioDeVoo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_number', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ApuracaoDeHoras.tabela.NumeroDoVoo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'payment_type', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ApuracaoDeHoras.tabela.TipoDeContrato,
                  ' '
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'takeoff_land_time_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ApuracaoDeHoras.tabela.TempoTotalDeVooDecolagemAoPouso
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'time_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ApuracaoDeHoras.tabela.TempoTotalDeVooPartidaAoCorte
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'consumption', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ApuracaoDeHoras.tabela.CombustivelConsumido
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'refuels', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ApuracaoDeHoras.tabela.CombustivelAbastecido
                ),
                (this.state.type === 1 || this.state.type === 3) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'interruption_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ApuracaoDeHoras.tabela.IndisponibilidadeDiariaTotal
                ),
                (this.state.type === 2 || this.state.type === 3) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'interruption_contract', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '290' },
                  this.locale.RelatoriosDeVoo.ApuracaoDeHoras.tabela.IndisponibilidadeDiariaContratual
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FlightReportsHoursReport;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportsHoursReport);

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












// Importação da tabela



var FlightReportsLegDifferences = function (_Component) {
  _inherits(FlightReportsLegDifferences, _Component);

  function FlightReportsLegDifferences(props) {
    _classCallCheck(this, FlightReportsLegDifferences);

    var _this = _possibleConstructorReturn(this, (FlightReportsLegDifferences.__proto__ || Object.getPrototypeOf(FlightReportsLegDifferences)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      searched: null,
      data: [],
      headers: [],
      status: 1,
      aircrafts_select: [],
      aircraft_models_select: [],
      bases_select: [],
      flight_types_select: [],
      clients_select: [],
      staffs_select: [],
      staffs: [],
      receits_select: [],
      fuel_company_select: [],
      locations_select: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.search = _this.search.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(FlightReportsLegDifferences, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeMultiple',
    value: function handleSelectChangeMultiple(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/voo/formulario', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              aircrafts_select: responseJson.data.aircrafts_select,
              aircraft_models_select: responseJson.data.aircraft_models_select,
              bases_select: responseJson.data.bases_select,
              flight_types_select: responseJson.data.flight_types_select,
              clients_select: responseJson.data.clients_select,
              receits_select: responseJson.data.receits_select,
              fuel_company_select: responseJson.data.fuel_company_select,
              staffs_select: responseJson.data.staffs_select,
              locations_select: responseJson.data.locations_select
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'search',
    value: function search(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');

      var datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        aircraft_id: this.state.aircraft_id,
        flight_report_id: this.state.flight_report_id,
        status: this.state.status,
        aircraft_model_id: this.state.aircraft_model_id
      };

      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/diferenca/trechos/pesquisa', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data.main, headers: responseJson.data.headers, searched: 1 });
          }
          self.handleAlert('', '', 'closed');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      var columns = null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosDeVoo.RelatorioDeTempoEntreTrechos.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.search },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeTempoEntreTrechos.formulario.DataInicial,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_start, maskChar: null, name: 'date_start ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeTempoEntreTrechos.formulario.DataFinal,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_finish, maskChar: null, name: 'date_finish ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeTempoEntreTrechos.formulario.SomenteAprovados,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'status',
                    value: this.state.status,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'status'),
                    options: [{ value: 1, label: this.locale.general.sim }, { value: 0, label: this.locale.general.nao }]
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeTempoEntreTrechos.formulario.RelatorioDeVoo,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'flight_report_id', className: 'form-control', placeholder: 'Informe o n\xFAmero do relat\xF3rio de voo', value: this.state.flight_report_id, onChange: this.handleChange.bind(this, 'flight_report_id') })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeTempoEntreTrechos.formulario.Aeronave,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'aircraft_id',
                    value: this.state.aircraft_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'aircraft_id'),
                    options: this.state.aircrafts_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeTempoEntreTrechos.formulario.Frota,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'aircraft_model_id',
                    value: this.state.aircraft_model_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'aircraft_model_id'),
                    options: this.state.aircraft_models_select
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-block btn-lg' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                ' ',
                this.locale.general.pesquisar
              )
            ),
            self.state.searched === 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["BootstrapTable"],
                { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: ' ' }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                  '#'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'date', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeTempoEntreTrechos.tabela.Data
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeTempoEntreTrechos.tabela.Prefixo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft_model_id', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeTempoEntreTrechos.tabela.Frota
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'base', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeTempoEntreTrechos.tabela.Base
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_type', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeTempoEntreTrechos.tabela.TipoDeVoo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'contract', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeTempoEntreTrechos.tabela.Contrato
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'client', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeTempoEntreTrechos.tabela.Cliente
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_report', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeTempoEntreTrechos.tabela.NumeroRelatorio
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_number', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeTempoEntreTrechos.tabela.NumeroDoVoo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'staffs', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeTempoEntreTrechos.tabela.Tripulantes
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'quantity', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeTempoEntreTrechos.tabela.QuantidadeDeTrechos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'difference', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeTempoEntreTrechos.tabela.TempoEntreTrechos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'takeoff_land_time_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeTempoEntreTrechos.tabela.TotalDoVooDEPARR
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'time_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeTempoEntreTrechos.tabela.TotalDoVooTempoTotal
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FlightReportsLegDifferences;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportsLegDifferences);

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












// Importação da tabela



var FlightReportsMain = function (_Component) {
  _inherits(FlightReportsMain, _Component);

  function FlightReportsMain(props) {
    _classCallCheck(this, FlightReportsMain);

    var _this = _possibleConstructorReturn(this, (FlightReportsMain.__proto__ || Object.getPrototypeOf(FlightReportsMain)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      searched: null,
      data: [],
      headers: [],
      status: 1,
      range: 1,
      aircrafts_select: [],
      aircraft_models_select: [],
      bases_select: [],
      flight_types_select: [],
      clients_select: [],
      clients_full_select: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.search = _this.search.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(FlightReportsMain, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeType',
    value: function handleSelectChangeType(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeMultiple',
    value: function handleSelectChangeMultiple(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/voo/formulario', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              aircrafts_select: responseJson.data.aircrafts_select,
              aircraft_models_select: responseJson.data.aircraft_models_select,
              bases_select: responseJson.data.bases_select,
              flight_types_select: responseJson.data.flight_types_select,
              clients_select: responseJson.data.clients_select,
              clients_full_select: responseJson.data.clients_full_select
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'search',
    value: function search(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');

      var datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        aircraft_id: this.state.aircraft_id,
        base_id: this.state.base_id,
        contract_id: this.state.contract_id,
        client_id: this.state.client_id,
        contract_base_id: this.state.contract_base_id,
        flight_type_id: this.state.flight_type_id,
        flight_report_id: this.state.flight_report_id,
        flight_report_flight_number: this.state.flight_report_flight_number,
        status: this.state.status,
        range: this.state.range,
        exemption: this.state.exemption,
        payload: this.state.payload,
        aircraft_model_id: this.state.aircraft_model_id
      };

      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/voo/pesquisa/restrito', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data.main, headers: responseJson.data.headers, searched: self.state.range });
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      var columns = null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.search },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.DataInicial,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_start, maskChar: null, name: 'date_start ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.DataFinal,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_finish, maskChar: null, name: 'date_finish ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.AnaliticoOuSintetico,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'range',
                    value: this.state.range,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'range'),
                    options: [{ value: 1, label: this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.opcoesAnaliticoOuSintetico.AnaliticoPorTripulante }, { value: 2, label: this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.opcoesAnaliticoOuSintetico.AnaliticoPorRelatorio }, { value: 0, label: this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.opcoesAnaliticoOuSintetico.Sintetico }]
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.SomenteAprovados,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'status',
                    value: this.state.status,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'status'),
                    options: [{ value: 1, label: this.locale.general.sim }, { value: 0, label: this.locale.general.nao }]
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.RelatorioDeVoo,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'flight_report_id', className: 'form-control', placeholder: this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.placeholder.InformeONumeroDoRelatorioDeVoo, value: this.state.flight_report_id, onChange: this.handleChange.bind(this, 'flight_report_id') })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.NumeroDoVoo,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'flight_report_flight_number', className: 'form-control', placeholder: this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.placeholder.InformeONumeroDoVoo, value: this.state.flight_report_flight_number, onChange: this.handleChange.bind(this, 'flight_report_flight_number') })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.Aeronave,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'aircraft_id',
                    value: this.state.aircraft_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'aircraft_id'),
                    options: this.state.aircrafts_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.Frota,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'aircraft_model_id',
                    value: this.state.aircraft_model_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'aircraft_model_id'),
                    options: this.state.aircraft_models_select
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.Base,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'base_id',
                    value: this.state.base_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'base_id'),
                    options: this.state.bases_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.TipoDeVoo,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'flight_type_id',
                    value: this.state.flight_type_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'flight_type_id'),
                    options: this.state.flight_types_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.Contrato,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'contract_id',
                    value: this.state.contract_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'contract_id'),
                    options: this.state.clients_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.Isencao,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'exemption',
                    value: this.state.exemption,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'exemption'),
                    options: [{ value: 0, label: this.locale.general.nao }, { value: 1, label: this.locale.general.sim }]
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.CargaExterna,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'payload',
                    value: this.state.payload,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'payload'),
                    options: [{ value: 0, label: this.locale.general.nao }, { value: 1, label: this.locale.general.sim }]
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.Cliente,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'client_id',
                    value: this.state.client_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'client_id'),
                    options: this.state.clients_full_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.formulario.BasesContratual,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'contract_base_id',
                    value: this.state.contract_base_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'contract_base_id'),
                    options: this.state.bases_select
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-block btn-lg' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                ' ',
                this.locale.general.pesquisar
              )
            ),
            self.state.searched === 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["BootstrapTable"],
                { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: 'Exportar CSV', noDataText: ' ' }, search: true, multiColumnSearch: true, searchPlaceholder: 'Procurar' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                  '#'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'date', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Data
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Prefixo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft_model_id', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Frota
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'base', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Base
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_type', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TipoDeVoo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'contract', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Contrato
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'client', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Cliente
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_report', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.NumeroRelatorio
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_number', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.NumeroDoVoo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'exemption', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Isencao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'takeoff_land_time_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TotalDoVooDEPARR
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'time_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TotalDoVooTempoTotal
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'navigation_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TotalDoVooNavegacao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'ifr_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TotalDoVooInstrumento
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'night_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TotalDoVooNoturno
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'day_landings_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TotalDoVooPousosDiurnos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'night_landings_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TotalDoVooPousosNoturnos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'pax_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TotalDoVooPAX
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'payload_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TotalDoVooCarga
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'fuel_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TotalDoVooConsumo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'refuels', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.QuantidadeAbastecida
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'observations', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Observacoes
                )
              )
            ),
            self.state.searched === 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["BootstrapTable"],
                { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: 'Exportar CSV', noDataText: ' ' }, search: true, multiColumnSearch: true, searchPlaceholder: 'Procurar' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                  '#'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'date', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Data
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Prefixo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft_model_id', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Frota
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'base', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Base
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_type', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TipoDeVoo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'contract', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Contrato
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'client', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Cliente
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_report', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.NumeroRelatorio
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_number', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.NumeroDoVoo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'exemption', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Isencao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'duty', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.FB
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'arrival', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Apresentacao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'inscription', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Matricula
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'staff', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Tripulante
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'leg_number', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Etapa
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'departure_location', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Origem
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'arrival_location', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  'Destino'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'engine_start_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.HrPart
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'takeoff_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.DEP
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'landing_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.ARR
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'engine_shutoff_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Corte
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'takeoff_land_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.DEPARR
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'total_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TempoTotal
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'navigation_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TempoNavegacao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'ifr_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TempoInstrumento
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'night_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TempoNoturno
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'day_landings', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.PousosDiurnos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'night_landings', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.PousosNoturnos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'starts', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Partidas
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'pax', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.PAX
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'payload', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Carga
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'external_load_long_line', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.CargaExternaLongLine
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'external_load_short_line', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.CargaExternaShortLine
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'fuel_start', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.CombustivelInicial
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'fuel_end', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.CombustivelFinal
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'refuels', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.QuantidadeAbastecida
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'observations', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Observacoes
                )
              )
            ),
            self.state.searched === 2 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["BootstrapTable"],
                { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: 'Exportar CSV', noDataText: ' ' }, search: true, multiColumnSearch: true, searchPlaceholder: 'Procurar' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                  '#'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'date', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Data
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Prefixo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft_model_id', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Frota
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'base', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Base
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_type', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TipoDeVoo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'contract', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Contrato
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'client', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Cliente
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_report', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.NumeroRelatorio
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_number', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.NumeroDoVoo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'exemption', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Isencao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'leg_number', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Etapa
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'departure_location', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Origem
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'arrival_location', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Destino
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'engine_start_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.HrPart
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'takeoff_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.DEP
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'landing_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.ARR
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'engine_shutoff_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Corte
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'takeoff_land_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.DEPARR
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'total_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TempoTotal
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'navigation_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TempoNavegacao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'ifr_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TempoInstrumento
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'night_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.TempoNoturno
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'day_landings', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.PousosDiurnos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'night_landings', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.PousosNoturnos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'starts', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Partidas
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'pax', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.PAX
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'payload', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Carga
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'external_load_long_line', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.CargaExternaLongLine
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'external_load_short_line', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.CargaExternaShortLine
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'fuel_start', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.CombustivelInicial
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'fuel_end', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.CombustivelFinal
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'refuels', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.QuantidadeAbastecida
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'observations', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ControleGeralDeRelatorios.tabela.Observacoes
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FlightReportsMain;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportsMain);

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












// Importação da tabela



var FlightReportsMainMultiple = function (_Component) {
  _inherits(FlightReportsMainMultiple, _Component);

  function FlightReportsMainMultiple(props) {
    _classCallCheck(this, FlightReportsMainMultiple);

    var _this = _possibleConstructorReturn(this, (FlightReportsMainMultiple.__proto__ || Object.getPrototypeOf(FlightReportsMainMultiple)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      searched: null,
      data: [],
      headers: [],
      status: 1,
      aircrafts_select: [],
      aircraft_models_select: [],
      bases_select: [],
      flight_types_select: [],
      clients_select: [],
      receits_select: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.search = _this.search.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(FlightReportsMainMultiple, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeMultiple',
    value: function handleSelectChangeMultiple(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/voo/formulario', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              aircrafts_select: responseJson.data.aircrafts_select,
              aircraft_models_select: responseJson.data.aircraft_models_select,
              bases_select: responseJson.data.bases_select,
              flight_types_select: responseJson.data.flight_types_select,
              clients_select: responseJson.data.clients_select,
              receits_select: responseJson.data.receits_select
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'search',
    value: function search(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');

      var datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        aircraft_id: this.state.aircraft_id,
        contract_base_id: this.state.contract_base_id,
        contract_id: this.state.contract_id,
        base_id: this.state.base_id,
        status: this.state.status,
        language: this.state.language
      };

      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/main/completo/restrito', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data.main, headers: responseJson.data.headers, searched: 1 });
            var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data.file;
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data.file);
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      var columns = null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosDeVoo.ExtratoDeRelatorioDeVooEmBloco.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.search },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ExtratoDeRelatorioDeVooEmBloco.formulario.DataInicial,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_start, maskChar: null, name: 'date_start ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ExtratoDeRelatorioDeVooEmBloco.formulario.DataFinal,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_finish, maskChar: null, name: 'date_finish ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ExtratoDeRelatorioDeVooEmBloco.formulario.Aeronave,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'aircraft_id',
                    value: this.state.aircraft_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'aircraft_id'),
                    options: this.state.aircrafts_select
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ExtratoDeRelatorioDeVooEmBloco.formulario.Contrato,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'contract_id',
                    value: this.state.contract_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'contract_id'),
                    options: this.state.clients_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ExtratoDeRelatorioDeVooEmBloco.formulario.Base,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'base_id',
                    value: this.state.base_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'base_id'),
                    options: this.state.bases_select
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ExtratoDeRelatorioDeVooEmBloco.formulario.BasesContratual,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'contract_base_id',
                    value: this.state.contract_base_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'contract_base_id'),
                    options: this.state.bases_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ExtratoDeRelatorioDeVooEmBloco.formulario.SomenteAprovados,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'status',
                    value: this.state.status,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'status'),
                    options: [{ value: 1, label: this.locale.general.sim }, { value: 0, label: this.locale.general.nao }]
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ExtratoDeRelatorioDeVooEmBloco.formulario.linguagem,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'language',
                    value: this.state.language,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'language'),
                    options: [{ value: 'pt', label: this.locale.general.portugues }, { value: 'en', label: this.locale.general.ingles }],
                    required: true
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-block btn-lg' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                ' ',
                this.locale.general.pesquisar
              )
            ),
            self.state.searched === 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["BootstrapTable"],
                { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: ' ' }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                  '#'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'date', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ExtratoDeRelatorioDeVooEmBloco.tabela.Data
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ExtratoDeRelatorioDeVooEmBloco.tabela.Prefixo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft_model_id', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ExtratoDeRelatorioDeVooEmBloco.tabela.Frota
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'base', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ExtratoDeRelatorioDeVooEmBloco.tabela.Base
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'contract', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ExtratoDeRelatorioDeVooEmBloco.tabela.Contrato
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'client', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ExtratoDeRelatorioDeVooEmBloco.tabela.Cliente
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_report', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ExtratoDeRelatorioDeVooEmBloco.tabela.NumeroRelatorio
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_number', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ExtratoDeRelatorioDeVooEmBloco.tabela.NumeroDoVoo
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FlightReportsMainMultiple;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportsMainMultiple);

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












// Importação da tabela



var FlightReportsMeasurementCheck = function (_Component) {
  _inherits(FlightReportsMeasurementCheck, _Component);

  function FlightReportsMeasurementCheck(props) {
    _classCallCheck(this, FlightReportsMeasurementCheck);

    var _this = _possibleConstructorReturn(this, (FlightReportsMeasurementCheck.__proto__ || Object.getPrototypeOf(FlightReportsMeasurementCheck)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      searched: null,
      data: [],
      headers: [],
      status: 1,
      range: 2,
      aircrafts_select: [],
      aircraft_models_select: [],
      bases_select: [],
      flight_types_select: [],
      clients_select: [],
      clients_full_select: [],
      staffs_select: [],
      staffs: [],
      receits_select: [],
      fuel_company_select: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.search = _this.search.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(FlightReportsMeasurementCheck, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeMultiple',
    value: function handleSelectChangeMultiple(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/voo/formulario', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              aircrafts_select: responseJson.data.aircrafts_select,
              aircraft_models_select: responseJson.data.aircraft_models_select,
              bases_select: responseJson.data.bases_select,
              flight_types_select: responseJson.data.flight_types_select,
              clients_select: responseJson.data.clients_select,
              clients_full_select: responseJson.data.clients_full_select,
              receits_select: responseJson.data.receits_select,
              fuel_company_select: responseJson.data.fuel_company_select,
              staffs_select: responseJson.data.staffs_select
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'search',
    value: function search(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');

      var datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        aircraft_id: this.state.aircraft_id,
        contract_id: this.state.contract_id,
        contract_base_id: this.state.contract_base_id,
        client_id: this.state.client_id,
        range: this.state.range,
        status: this.state.status
      };

      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/conferencia/medicao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data.main, headers: responseJson.data.headers, searched: 1 });
          }
          self.handleAlert('', '', 'closed');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      var columns = null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.search },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.formulario.DataInicial,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_start, maskChar: null, name: 'date_start ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.formulario.DataFinal,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_finish, maskChar: null, name: 'date_finish ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.formulario.Contrato,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'contract_id',
                    value: this.state.contract_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'contract_id'),
                    options: this.state.clients_select
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.formulario.Cliente,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'client_id',
                    value: this.state.client_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'client_id'),
                    options: this.state.clients_full_select,
                    required: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.formulario.TipoDeMedicao,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'range',
                    value: this.state.range,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'range'),
                    options: [{ value: 1, label: this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.formulario.opcoesMedicao.Sintetica }, { value: 2, label: this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.formulario.opcoesMedicao.Analitica }]
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.formulario.SomenteAprovados,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'status',
                    value: this.state.status,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'status'),
                    options: [{ value: 1, label: this.locale.general.sim }, { value: 0, label: this.locale.general.nao }]
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.formulario.BaseContratual,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'contract_base_id',
                    value: this.state.contract_base_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'contract_base_id'),
                    options: this.state.bases_select
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-block btn-lg' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                ' ',
                this.locale.general.procurar
              )
            ),
            self.state.searched === 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["BootstrapTable"],
                { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: ' ' }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'contract', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '180' },
                  this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.tabela.Contrato
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'contract_aircraft', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '150' },
                  this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.tabela.PrefixoContrato
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'available_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '100' },
                  this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.tabela.Status
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_number', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.tabela.NumeroDoVoo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'client', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.tabela.Cliente
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'ptbr_code', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '180' },
                  this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.tabela.CodigoPTBR
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'departure_location', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '180' },
                  this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.tabela.LocalidadeInicio
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'arrival_location', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '180' },
                  this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.tabela.LocalidadeFim
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '130' },
                  this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.tabela.Prefixo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'start_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '180' },
                  this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.tabela.Inicio
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'finish_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '180' },
                  this.locale.RelatoriosDeVoo.ConferenciaDeMedicao.tabela.Fim
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FlightReportsMeasurementCheck;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportsMeasurementCheck);

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












// Importação da tabela



var FlightReportsDestinies = function (_Component) {
  _inherits(FlightReportsDestinies, _Component);

  function FlightReportsDestinies(props) {
    _classCallCheck(this, FlightReportsDestinies);

    var _this = _possibleConstructorReturn(this, (FlightReportsDestinies.__proto__ || Object.getPrototypeOf(FlightReportsDestinies)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      searched: null,
      data: [],
      headers: [],
      status: 1,
      aircrafts_select: [],
      aircraft_models_select: [],
      bases_select: [],
      flight_types_select: [],
      clients_select: [],
      staffs_select: [],
      staffs: [],
      receits_select: [],
      fuel_company_select: [],
      locations_select: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.search = _this.search.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(FlightReportsDestinies, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeMultiple',
    value: function handleSelectChangeMultiple(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/voo/formulario', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              aircrafts_select: responseJson.data.aircrafts_select,
              aircraft_models_select: responseJson.data.aircraft_models_select,
              bases_select: responseJson.data.bases_select,
              flight_types_select: responseJson.data.flight_types_select,
              clients_select: responseJson.data.clients_select,
              receits_select: responseJson.data.receits_select,
              fuel_company_select: responseJson.data.fuel_company_select,
              staffs_select: responseJson.data.staffs_select,
              locations_select: responseJson.data.locations_select
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'search',
    value: function search(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');

      var datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        aircraft_id: this.state.aircraft_id,
        flight_report_id: this.state.flight_report_id,
        status: this.state.status,
        aircraft_model_id: this.state.aircraft_model_id,
        location_id: this.state.location_id
      };

      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/carga/externa/pesquisa', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data.main, headers: responseJson.data.headers, searched: 1 });
          }
          self.handleAlert('', '', 'closed');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      var columns = null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosDeVoo.RelatorioDeVoosComCargaExterna.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.search },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeVoosComCargaExterna.formulario.DataInicial,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_start, maskChar: null, name: 'date_start ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeVoosComCargaExterna.formulario.DataFinal,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_finish, maskChar: null, name: 'date_finish ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeVoosComCargaExterna.formulario.SomenteAprovados,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'status',
                    value: this.state.status,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'status'),
                    options: [{ value: 1, label: this.locale.general.sim }, { value: 0, label: this.locale.general.nao }]
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeVoosComCargaExterna.formulario.RelatorioDeVoo,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'flight_report_id', className: 'form-control', placeholder: this.locale.RelatoriosDeVoo.RelatorioDeVoosComCargaExterna.formulario.placeholder.InformeONumeroDoRelatorioDeVoo, value: this.state.flight_report_id, onChange: this.handleChange.bind(this, 'flight_report_id') })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeVoosComCargaExterna.formulario.Aeronave,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'aircraft_id',
                    value: this.state.aircraft_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'aircraft_id'),
                    options: this.state.aircrafts_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeVoosComCargaExterna.formulario.Frota,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'aircraft_model_id',
                    value: this.state.aircraft_model_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'aircraft_model_id'),
                    options: this.state.aircraft_models_select
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeVoosComCargaExterna.formulario.Tripulantes,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'staffs',
                    value: this.state.staffs,
                    searchable: true,
                    placeholder: '',
                    multi: true,
                    onChange: this.handleSelectChangeMultiple.bind(this, 'staffs'),
                    options: this.state.staffs_select
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-block btn-lg' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                ' ',
                this.locale.general.pesquisar
              )
            ),
            self.state.searched === 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["BootstrapTable"],
                { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: 'Exportar CSV', noDataText: ' ' }, search: true, multiColumnSearch: true, searchPlaceholder: 'Procurar' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                  '#'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'date', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeVoosComCargaExterna.tabela.Data
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeVoosComCargaExterna.tabela.Prefixo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft_model_id', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeVoosComCargaExterna.tabela.Frota
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'base', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeVoosComCargaExterna.tabela.Base
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_type', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeVoosComCargaExterna.tabela.TipoDeVoo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'contract', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeVoosComCargaExterna.tabela.Contrato
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'client', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeVoosComCargaExterna.tabela.Cliente
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_report', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeVoosComCargaExterna.tabela.NumeroRelatorio
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_number', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeVoosComCargaExterna.tabela.NumeroDoVoo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'staffs', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeVoosComCargaExterna.tabela.Tripulantes
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'takeoff_land_time_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeVoosComCargaExterna.tabela.TotalDoVooDEPARR
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'time_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeVoosComCargaExterna.tabela.TotalDoVooTempoTotal
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'long_line_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeVoosComCargaExterna.tabela.CargaExternaLongLine
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'short_line_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.RelatorioDeVoosComCargaExterna.tabela.CargaExternaShortLine
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FlightReportsDestinies;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportsDestinies);

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












// Importação da tabela



var FlightReportsPontuality = function (_Component) {
  _inherits(FlightReportsPontuality, _Component);

  function FlightReportsPontuality(props) {
    _classCallCheck(this, FlightReportsPontuality);

    var _this = _possibleConstructorReturn(this, (FlightReportsPontuality.__proto__ || Object.getPrototypeOf(FlightReportsPontuality)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      searched: null,
      data: [],
      headers: [],
      status: 1,
      aircrafts_select: [],
      aircraft_models_select: [],
      bases_select: [],
      flight_types_select: [],
      clients_select: [],
      staffs_select: [],
      staffs: [],
      receits_select: [],
      fuel_company_select: [],
      totals: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.search = _this.search.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(FlightReportsPontuality, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeMultiple',
    value: function handleSelectChangeMultiple(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/voo/formulario', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              aircrafts_select: responseJson.data.aircrafts_select,
              aircraft_models_select: responseJson.data.aircraft_models_select,
              bases_select: responseJson.data.bases_select,
              flight_types_select: responseJson.data.flight_types_select,
              clients_select: responseJson.data.clients_select,
              receits_select: responseJson.data.receits_select,
              fuel_company_select: responseJson.data.fuel_company_select,
              staffs_select: responseJson.data.staffs_select
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'search',
    value: function search(event) {
      var _datasave;

      event.preventDefault();
      this.handleAlert('', '', 'open');

      var datasave = (_datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        aircraft_id: this.state.aircraft_id,
        base_id: this.state.base_id,
        contract_id: this.state.contract_id,
        flight_type_id: this.state.flight_type_id,
        flight_report_id: this.state.flight_report_id,
        status: this.state.status,
        aircraft_model_id: this.state.aircraft_model_id,
        receit: this.state.receit,
        fuel_company: this.state.fuel_company
      }, _defineProperty(_datasave, 'status', this.state.status), _defineProperty(_datasave, 'type', this.state.type), _datasave);

      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/pontualidade', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ totals: responseJson.data.main, headers: responseJson.data.headers, searched: 1 });
            self.handleAlert('', '', 'closed');
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      var columns = null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosDeVoo.RelatorioDePontualidade.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.search },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDePontualidade.formulario.DataInicial,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_start, maskChar: null, name: 'date_start ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDePontualidade.formulario.DataFinal,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_finish, maskChar: null, name: 'date_finish ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: '', required: true })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDePontualidade.formulario.Base,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'base_id',
                    value: this.state.base_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'base_id'),
                    options: this.state.bases_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDePontualidade.formulario.SomenteAprovados,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'status',
                    value: this.state.status,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'status'),
                    options: [{ value: 1, label: this.locale.general.sim }, { value: 0, label: this.locale.general.nao }]
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDePontualidade.formulario.TipoDeAtraso,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'type',
                    value: this.state.type,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'type'),
                    options: [{ value: "departure", label: this.locale.RelatoriosDeVoo.RelatorioDePontualidade.formulario.opcoesTiposDeAtraso.Decolagem }, { value: "flight", label: this.locale.RelatoriosDeVoo.RelatorioDePontualidade.formulario.opcoesTiposDeAtraso.TempoDeVoo }]
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-block btn-lg' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                ' ',
                this.locale.general.pesquisar
              )
            ),
            self.state.searched === 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'table table-bordered table-striped table-hover' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { className: 'table-totals-flights-style', colSpan: '2' },
                      this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.EstatisticasDeVooDe(this.state.date_start, this.state.date_finish)
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.Tipo
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.Valor
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.TempoTotalDeAtraso
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.state.totals ? this.state.totals['atraso_total'] : 0
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.Atrasados
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.state.totals ? this.state.totals['atraso_qtd'] : 0
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.Pontuais
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.state.totals ? this.state.totals['pontual_qtd'] : 0
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.MediaTempo
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.state.totals ? this.state.totals['atraso_media'] : 0
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.Operacoes
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.state.totals ? this.state.totals['operacoes'] : 0
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.Coordenacao
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.state.totals ? this.state.totals['coordenacao'] : 0
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.Despacho
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.state.totals ? this.state.totals['despacho'] : 0
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.Manutencao
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.state.totals ? this.state.totals['manutencao'] : 0
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.NumeroVoos
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.state.totals ? this.state.totals['voo_total'] : 0
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.AtrasadosInterno
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.state.totals ? this.state.totals['atraso_interno'] : 0
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.AtrasadosExterno
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.state.totals ? this.state.totals['atraso_externo'] : 0
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.Pontualidade
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.state.totals ? this.state.totals['pontualidade_total'] : 0,
                      '%'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.PontualidadeSemAtrasoExterno
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.state.totals ? this.state.totals['pontualidade_ext'] : 0,
                      '%'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.PontualidadeSemAtrasoInterno
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.state.totals ? this.state.totals['pontualidade_int'] : 0,
                      '%'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.VooManutencao
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.state.totals ? this.state.totals['mnt'] : 0
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.VooGiros
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.state.totals ? this.state.totals['giros'] : 0
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.VooTreinamento
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.state.totals ? this.state.totals['treinamento'] : 0
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.VooPTBR
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.state.totals ? this.state.totals['ptbr'] : 0
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.VooOutrosClientes
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.state.totals ? this.state.totals['clientes'] : 0
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.locale.RelatoriosDeVoo.RelatorioDePontualidade.tabela.VoosComerciais
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      this.state.totals ? this.state.totals['comerciais'] : 0
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FlightReportsPontuality;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (FlightReportsPontuality);

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












// Importação da tabela



var FlightReportsRefuels = function (_Component) {
  _inherits(FlightReportsRefuels, _Component);

  function FlightReportsRefuels(props) {
    _classCallCheck(this, FlightReportsRefuels);

    var _this = _possibleConstructorReturn(this, (FlightReportsRefuels.__proto__ || Object.getPrototypeOf(FlightReportsRefuels)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      status: 1,
      aircrafts_select: [],
      aircraft_models_select: [],
      bases_select: [],
      flight_types_select: [],
      clients_select: [],
      receits_select: [],
      fuel_company_select: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.search = _this.search.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(FlightReportsRefuels, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/voo/formulario', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              aircrafts_select: responseJson.data.aircrafts_select,
              aircraft_models_select: responseJson.data.aircraft_models_select,
              bases_select: responseJson.data.bases_select,
              flight_types_select: responseJson.data.flight_types_select,
              clients_select: responseJson.data.clients_select,
              receits_select: responseJson.data.receits_select,
              fuel_company_select: responseJson.data.fuel_company_select
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'search',
    value: function search(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');

      var datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        aircraft_id: this.state.aircraft_id,
        base_id: this.state.base_id,
        contract_id: this.state.contract_id,
        flight_type_id: this.state.flight_type_id,
        flight_report_id: this.state.flight_report_id,
        status: this.state.status,
        aircraft_model_id: this.state.aircraft_model_id,
        receit: this.state.receit,
        fuel_company: this.state.fuel_company
      };

      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/abastecimento/pesquisa', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
          }
          self.handleAlert('', '', 'closed');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosDeVoo.RelatorioDeAbastecimentos.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.search },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeAbastecimentos.formulario.DataInicial,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_start, maskChar: null, name: 'date_start ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeAbastecimentos.formulario.DataFinal,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_finish, maskChar: null, name: 'date_finish ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeAbastecimentos.formulario.SomenteAprovados,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'status',
                    value: this.state.status,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'status'),
                    options: [{ value: 1, label: this.locale.general.sim }, { value: 0, label: this.locale.general.nao }]
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeAbastecimentos.formulario.RelatorioDeVoo,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'flight_report_id', className: 'form-control', placeholder: this.locale.RelatoriosDeVoo.RelatorioDeAbastecimentos.formulario.placeholder.InformeONumeroDoRelatorioDeVoo, value: this.state.flight_report_id, onChange: this.handleChange.bind(this, 'flight_report_id') })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeAbastecimentos.formulario.Aeronave,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'aircraft_id',
                    value: this.state.aircraft_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'aircraft_id'),
                    options: this.state.aircrafts_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeAbastecimentos.formulario.Frota,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'aircraft_model_id',
                    value: this.state.aircraft_model_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'aircraft_model_id'),
                    options: this.state.aircraft_models_select
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeAbastecimentos.formulario.Base,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'base_id',
                    value: this.state.base_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'base_id'),
                    options: this.state.bases_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeAbastecimentos.formulario.TipoDeVoo,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'flight_type_id',
                    value: this.state.flight_type_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'flight_type_id'),
                    options: this.state.flight_types_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeAbastecimentos.formulario.Contrato,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'contract_id',
                    value: this.state.contract_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'contract_id'),
                    options: this.state.clients_select
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeAbastecimentos.formulario.NumeroDeReciboDoCombustivel,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'receit', className: 'form-control', placeholder: this.locale.RelatoriosDeVoo.RelatorioDeAbastecimentos.formulario.placeholder.InformeONumeroDeReciboDoCombustivel, value: this.state.receit, onChange: this.handleChange.bind(this, 'receit') })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.RelatorioDeAbastecimentos.formulario.FornecedorDeCombustivel,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'fuel_company',
                    value: this.state.fuel_company,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'fuel_company'),
                    options: this.state.fuel_company_select
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-block btn-lg' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                ' ',
                this.locale.general.pesquisar
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: 'Exportar CSV', noDataText: ' ' }, search: true, multiColumnSearch: true, searchPlaceholder: 'Procurar' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.RelatoriosDeVoo.RelatorioDeAbastecimentos.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'date', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '100' },
                this.locale.RelatoriosDeVoo.RelatorioDeAbastecimentos.tabela.Data
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'aircraft', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '100' },
                this.locale.RelatoriosDeVoo.RelatorioDeAbastecimentos.tabela.Aeronave
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'aircraft_model_id', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '100' },
                this.locale.RelatoriosDeVoo.RelatorioDeAbastecimentos.tabela.Modelo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'flight_report', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '100' },
                this.locale.RelatoriosDeVoo.RelatorioDeAbastecimentos.tabela.NumeroRelatorioDeVoo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'flight_type', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '200' },
                this.locale.RelatoriosDeVoo.RelatorioDeAbastecimentos.tabela.TipoDeVoo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'fuel_company', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '200' },
                this.locale.RelatoriosDeVoo.RelatorioDeAbastecimentos.tabela.FornecedorDeCombustivel
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'receit', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '200' },
                this.locale.RelatoriosDeVoo.RelatorioDeAbastecimentos.tabela.NumeroDoRecibo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'quantity', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '100' },
                this.locale.RelatoriosDeVoo.RelatorioDeAbastecimentos.tabela.QuantidadeDeCombustivel
              )
            )
          )
        )
      );
    }
  }]);

  return FlightReportsRefuels;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportsRefuels);

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












// Importação da tabela



var FlightReportsXMLMultiple = function (_Component) {
  _inherits(FlightReportsXMLMultiple, _Component);

  function FlightReportsXMLMultiple(props) {
    _classCallCheck(this, FlightReportsXMLMultiple);

    var _this = _possibleConstructorReturn(this, (FlightReportsXMLMultiple.__proto__ || Object.getPrototypeOf(FlightReportsXMLMultiple)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      searched: null,
      data: [],
      headers: [],
      status: 1,
      aircrafts_select: [],
      aircraft_models_select: [],
      bases_select: [],
      flight_types_select: [],
      clients_full_select: [],
      clients_select: [],
      staffs_select: [],
      staffs: [],
      receits_select: [],
      fuel_company_select: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.search = _this.search.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(FlightReportsXMLMultiple, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeMultiple',
    value: function handleSelectChangeMultiple(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/voo/formulario', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              aircrafts_select: responseJson.data.aircrafts_select,
              aircraft_models_select: responseJson.data.aircraft_models_select,
              bases_select: responseJson.data.bases_select,
              flight_types_select: responseJson.data.flight_types_select,
              clients_full_select: responseJson.data.clients_full_select,
              clients_select: responseJson.data.clients_select,
              receits_select: responseJson.data.receits_select,
              fuel_company_select: responseJson.data.fuel_company_select,
              staffs_select: responseJson.data.staffs_select
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'search',
    value: function search(event) {
      var _datasave;

      event.preventDefault();
      this.handleAlert('', '', 'open');

      var datasave = (_datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        aircraft_id: this.state.aircraft_id,
        base_id: this.state.base_id,
        contract_base_id: this.state.contract_base_id,
        contract_id: this.state.contract_id,
        client_id: this.state.client_id
      }, _defineProperty(_datasave, 'base_id', this.state.base_id), _defineProperty(_datasave, 'status', this.state.status), _datasave);

      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios/xml/completo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data.main, headers: responseJson.data.headers, searched: 1 });
            var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data.file;
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data.file);
          }
          self.handleAlert(responseJson.message, responseJson.status, 'closed');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      var columns = null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosDeVoo.ExtracaoDeXMLEmBloco.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.search },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ExtracaoDeXMLEmBloco.formulario.DataInicial,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_start, maskChar: null, name: 'date_start ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ExtracaoDeXMLEmBloco.formulario.DataFinal,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_finish, maskChar: null, name: 'date_finish ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ExtracaoDeXMLEmBloco.formulario.Aeronave,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'aircraft_id',
                    value: this.state.aircraft_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'aircraft_id'),
                    options: this.state.aircrafts_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ExtracaoDeXMLEmBloco.formulario.Cliente,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'client_id',
                    value: this.state.client_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'client_id'),
                    options: this.state.clients_full_select
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ExtracaoDeXMLEmBloco.formulario.Contrato,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'contract_id',
                    value: this.state.contract_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'contract_id'),
                    options: this.state.clients_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ExtracaoDeXMLEmBloco.formulario.Base,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'base_id',
                    value: this.state.base_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'base_id'),
                    options: this.state.bases_select
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ExtracaoDeXMLEmBloco.formulario.SomenteAprovados,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'status',
                    value: this.state.status,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'status'),
                    options: [{ value: 1, label: this.locale.general.sim }, { value: 0, label: this.locale.general.nao }]
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.ExtracaoDeXMLEmBloco.formulario.BaseContratual,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: '',
                    name: 'contract_base_id',
                    value: this.state.contract_base_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'contract_base_id'),
                    options: this.state.bases_select
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-block btn-lg' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                ' ',
                this.locale.general.pesquisar
              )
            ),
            self.state.searched === 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["BootstrapTable"],
                { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: 'Exportar CSV', noDataText: ' ' }, search: true, multiColumnSearch: true, searchPlaceholder: 'Procurar' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                  '#'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'date', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ExtracaoDeXMLEmBloco.tabela.Data
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ExtracaoDeXMLEmBloco.tabela.Prefixo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'aircraft_model_id', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ExtracaoDeXMLEmBloco.tabela.Frota
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'base', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ExtracaoDeXMLEmBloco.tabela.Base
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'contract', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ExtracaoDeXMLEmBloco.tabela.Contrato
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'client', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ExtracaoDeXMLEmBloco.tabela.Cliente
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_report', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ExtracaoDeXMLEmBloco.tabela.NumeroRelatorio
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'flight_number', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '260' },
                  this.locale.RelatoriosDeVoo.ExtracaoDeXMLEmBloco.tabela.NumeroDoVoo
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FlightReportsXMLMultiple;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportsXMLMultiple);

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LogbookAppIntegration_LogbookAppIntegrations__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário





var FlightReportApprovalsTab = function (_Component) {
  _inherits(FlightReportApprovalsTab, _Component);

  function FlightReportApprovalsTab(props) {
    _classCallCheck(this, FlightReportApprovalsTab);

    var _this = _possibleConstructorReturn(this, (FlightReportApprovalsTab.__proto__ || Object.getPrototypeOf(FlightReportApprovalsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      logbook_app: _this.props.logbook_app,
      type: false,
      modal: false,
      modal_captain_login: false,
      flight_report_id: null,
      reproved_id: null,
      reason: null,
      username: null,
      password: null,
      flight_report: _this.props.flight_report,
      flight_report_approvals: _this.props.flight_report_approvals,
      flight_report_reopen_warnings: _this.props.flight_report_reopen_warnings
    };

    _this.reopen = _this.reopen.bind(_this);
    _this.approve = _this.approve.bind(_this);
    _this.reprove = _this.reprove.bind(_this);
    _this.login = _this.login.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // LM


  _createClass(FlightReportApprovalsTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.flight_report_approvals) || this.state.loaded === 1 && newProps.updated === 1) {
        this.setState({
          logbook_app: newProps.logbook_app,
          flight_report_id: newProps.flight_report_id,
          flight_report_approvals: newProps.flight_report_approvals,
          flight_report_reopen_warnings: newProps.flight_report_reopen_warnings,
          flight_report: newProps.flight_report,
          loaded: 1
        });
      }
    }
    // Handlers

  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'login',
    value: function login(event) {
      var self = this;
      event.preventDefault();
      if (navigator.onLine) {
        if (window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.aprovarRelatorio)) {
          self.props.handleAlert('', '', 'open');
          var datasave = {
            username: this.state.username,
            password: this.state.password,
            flight_report_approval_id: this.state.flight_report_approval_id
          };
          var header = self.refs.request_api.header('application/json');
          Promise.resolve(header).then(function (value) {
            fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/sub_commander_approval/relatorio/voo/aprovar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.refs.request_api.validate(responseJson, 'alert');
              self.setState({ modal_captain_login: false });
              self.props.updateData(responseJson);
            }).catch(function (error) {
              console.error(error);
            });
          });
        }
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'reopen',
    value: function reopen(flight_report_id) {
      var self = this;

      if (navigator.onLine) {
        if (window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.reabrirRelatorio)) {
          self.props.handleAlert('', '', 'open');
          var datasave = {
            flight_report_id: flight_report_id
          };
          var header = self.refs.request_api.header('application/json');
          Promise.resolve(header).then(function (value) {
            fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/reabrir', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.refs.request_api.validate(responseJson, 'alert');
              self.props.updateData(responseJson);
            }).catch(function (error) {
              console.error(error);
            });
          });
        }
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'approve',
    value: function approve(flight_report_approval_id, type) {
      var self = this;
      if (navigator.onLine) {

        if (window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.aprovarRelatorio)) {
          self.props.handleAlert('', '', 'open');
          var datasave = {
            flight_report_approval_id: flight_report_approval_id
          };
          var header = self.refs.request_api.header('application/json');
          Promise.resolve(header).then(function (value) {
            fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/' + type + '/relatorio/voo/aprovar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              if (responseJson.status === 'success') {

                self.refs.request_api.validate(responseJson, 'alert');
                self.props.updateData(responseJson);
              } else {
                self.setState({ modal_captain_login: true, flight_report_approval_id: flight_report_approval_id });
                self.props.handleAlert('', '', 'closed');
              }
            }).catch(function (error) {
              console.error(error);
            });
          });
        }
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'reprove',
    value: function reprove(event) {
      event.preventDefault();
      var self = this;

      if (navigator.onLine) {
        if (window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.reprovarRelatorio)) {
          self.props.handleAlert('', '', 'open');
          var datasave = {
            flight_report_approval_id: self.state.reproved_id,
            reason: self.state.reason
          };
          var header = self.refs.request_api.header('application/json');
          Promise.resolve(header).then(function (value) {
            fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/' + self.state.type + '/relatorio/voo/reprovar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.refs.request_api.validate(responseJson, 'alert');
              self.setState({ reason: null, reproved_id: null, modal: false });
              self.props.updateData(responseJson);
            }).catch(function (error) {
              console.error(error);
            });
          });
        }
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        this.state.flight_report_reopen_warnings.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'alert alert-danger alert-dismissible', role: 'alert', style: { marginTop: 25 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'strong',
            null,
            this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.relatorioReabertoGerouImplicacoes,
            ':'
          )
        ) : '',
        this.state.flight_report_reopen_warnings.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaImplicacoes.Mensagem
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaImplicacoes.Data
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              null,
              Object.keys(self.state.flight_report_reopen_warnings).map(function (k) {
                var srl = self.state.flight_report_reopen_warnings[k];
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { className: "box-alert box-alert-red", dangerouslySetInnerHTML: { __html: srl.text } }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: "box-alert box-alert-red" },
                    srl.created_at_str
                  )
                );
              })
            )
          )
        ) : '',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title pull-left' },
          this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloAprovacoes
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'grid-buttons pull-right' },
          this.state.flight_report.status_reopen === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { onClick: function onClick() {
                return _this2.reopen(_this2.state.flight_report.id);
              }, className: 'btn btn-danger' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' }),
            ' ',
            this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.botaoReabrirRelatorio
          ) : '',
          this.state.flight_report.status === 4 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { onClick: function onClick() {
                return _this2.reopen(_this2.state.flight_report.id);
              }, className: 'btn btn-danger' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' }),
            ' ',
            this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.botaoReabrirRelatorio
          ) : ''
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaAprovacoes.Tipo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaAprovacoes.Tripulante
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaAprovacoes.Aprovacao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaAprovacoes.Acoes
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              null,
              Object.keys(self.state.flight_report_approvals).map(function (k) {
                var sra = self.state.flight_report_approvals[k];
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    sra.type_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    sra.staff_name
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    sra.user_name
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    sra.status === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'btn-group' },
                      sra.type == 'commander_approval' && self.state.logbook_app == 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__LogbookAppIntegration_LogbookAppIntegrations__["a" /* default */], {
                        flight_report_id: self.state.flight_report_id,
                        flight_report_approval_id: sra.id,
                        renderButton: true,
                        popover: self.props.popover,
                        buttonClass: 'btn btn-info btn-sm button-inline',
                        modal_captain_login: true,
                        integrationType: 'approve',
                        updateData: self.props.updateData
                      }),
                      (sra.type !== 'commander_approval' || self.state.logbook_app !== 1) && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { onClick: function onClick() {
                            self.approve(sra.id, sra.type);
                          }, className: 'btn btn-success btn-sm button-inline' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' })
                      ),
                      sra.type !== 'reopen_approval' && sra.type !== 'commercial_approval' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { onClick: function onClick() {
                            self.setState({ reproved_id: sra.id, modal: true, type: sra.type });
                          }, className: 'btn btn-danger btn-sm button-inline' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-close' })
                      ) : ''
                    ) : sra.status === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { className: 'btn btn-success btn-sm', disabled: true },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' })
                      )
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { className: 'btn btn-danger btn-sm', disabled: true },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-close' })
                      )
                    )
                  )
                );
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloJustificativaReprovacao
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return self.setState({ modal: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.reprove },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioReprovacao.RazaoDaReprovacao,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'reason', className: 'form-control', placeholder: '', value: this.state.reason, onChange: this.handleChange.bind(this, 'reason') })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'submit', className: 'btn btn-danger btn-block btn-inline' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' }),
                    ' ',
                    this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioReprovacao.botaoReprovarRelatorio
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return self.setState({ modal_captain_login: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal_captain_login, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloLoginDoComandanteNoLDAP
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return self.setState({ modal_captain_login: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.login },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'input-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'input-group-addon' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-at' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'username', className: 'form-control', placeholder: this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioLogin.placeholder.Email, value: this.state.username, onChange: this.handleChange.bind(this, 'username') })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'input-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'input-group-addon' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-lock' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'password', name: 'password', className: 'form-control', placeholder: this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioLogin.placeholder.Senha, value: this.state.password, onChange: this.handleChange.bind(this, 'password') })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: 'btn btn-success btn-block', type: 'submit' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-sign-in' }),
                ' ',
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioLogin.botaoAcessarSistema
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return self.setState({ modal_captain_login: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return FlightReportApprovalsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportApprovalsTab);

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário






// Importo o moment com a linguagem pt-br
__webpack_require__(24);
__webpack_require__(32);

var FlightReportEditTab = function (_Component) {
  _inherits(FlightReportEditTab, _Component);

  function FlightReportEditTab(props) {
    _classCallCheck(this, FlightReportEditTab);

    var _this = _possibleConstructorReturn(this, (FlightReportEditTab.__proto__ || Object.getPrototypeOf(FlightReportEditTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      show_select_clients: false,
      id: _this.props.flight_report_id,
      aircraft_id: _this.props.flight_report.aircraft_id,
      base_id: _this.props.flight_report.base_id,
      contract_id: _this.props.flight_report.contract_id,
      flight_type_id: _this.props.flight_report.flight_type_id,
      staff_sigmec_id: _this.props.flight_report.staff_sigmec_id,
      client_id: _this.props.flight_report.client_id,
      date: _this.props.flight_report.date,
      flight_type: _this.props.flight_type,
      flight_number: _this.props.flight_report.flight_number,
      report_number: _this.props.flight_report.report_number,
      exemption: _this.props.flight_report.exemption,
      sar_flights: _this.props.flight_report.sar_flights,
      power_checks: _this.props.flight_report.power_checks,
      night_deck_landing: _this.props.flight_report.night_deck_landing,
      observations: _this.props.flight_report.observations,
      bases_select: _this.props.bases_select,
      aircrafts_select: _this.props.aircrafts_select,
      flight_types_select: _this.props.flight_types_select,
      contracts_select: _this.props.contracts_select,
      clients_select: _this.props.clients_select,
      staff_mechanics_select: _this.props.staff_mechanics_select,
      daily_flights: _this.props.daily_flights
    };

    //bind específico
    _this.edit = _this.edit.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(FlightReportEditTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      if (name === 'takeoff_time') {
        this.diffFlight(event.target.value, this.state.landing_time, change);
        this.delayFlight(event.target.value, this.state.takeoff_time_scheduled, change);
        this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, event.target.value, this.state.landing_time, change);
      } else if (name === 'landing_time') {
        this.diffFlight(this.state.takeoff_time, event.target.value, change);
        this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, this.state.takeoff_time, event.target.value, change);
      } else if (name === 'engine_start_time') {
        this.diffTotalTime(event.target.value, this.state.engine_shutoff_time, this.state.takeoff_time, this.state.landing_time, change);
      } else if (name === 'engine_shutoff_time') {
        this.diffTotalTime(this.state.engine_start_time, event.target.value, this.state.takeoff_time, this.state.landing_time, change);
      } else if (name === 'takeoff_time_scheduled') {
        this.delayFlight(this.state.takeoff_time, event.target.value, change);
        this.delayTotalTime(this.state.total_time_scheduled, event.target.value, change);
      } else if (name === 'total_time_scheduled') {
        this.delayTotalTime(event.target.value, this.state.takeoff_land_time, change);
      } else {
        this.setState(change);
      }
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectFlightTypeChange',
    value: function handleSelectFlightTypeChange(name, event) {
      var change = {};
      var self = this;
      change['flight_type_id'] = null;
      change['client_id'] = null;
      change['show_select_clients'] = null;
      if (event == null) {
        change[name] = null;
      } else {

        if (navigator.onLine) {
          self.setState({ overlay: { message: '', type: '', status: 'open' } });
          change[name] = event.value;
          var header = this.refs.request_api.header('application/json');
          Promise.resolve(header).then(function (value) {
            var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/tipo/voo/' + event.value;
            fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              if (responseJson.data.client_required === 1) {
                self.setState({
                  show_select_clients: true
                });
              }
            }).then(function () {
              self.setState({ overlay: { message: '', type: '', status: 'closed' } });
            }); /* Overlay */
          });
        } else {
          window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
        }
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectAircraftChange',
    value: function handleSelectAircraftChange(name, event) {
      var change = {};
      var self = this;
      change['contract_id'] = null;
      if (event == null) {
        change[name] = null;
      } else {
        self.props.handleAlert('', '', 'open');
        change[name] = event.value;
        var header = self.refs.request_api.header('application/json');

        if (navigator.onLine) {

          Promise.resolve(header).then(function (value) {
            var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/contrato/aeronave/select/' + event.value;
            fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              if (responseJson.status === 'success') {
                self.setState({
                  contracts_select: responseJson.data
                });
              }
            }).then(function () {
              self.props.handleAlert('', '', 'closed');
            }); /* Overlay */
          });
        } else {
          window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
        }
      }
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (typeof this.state.date === 'undefined' || this.state.loaded === 1 && newProps.updated === 1) {
        this.setState({
          id: newProps.flight_report_id,
          aircraft_id: newProps.flight_report.aircraft_id,
          base_id: newProps.flight_report.base_id,
          contract_id: newProps.flight_report.contract_id,
          flight_type_id: newProps.flight_report.flight_type_id,
          staff_sigmec_id: newProps.flight_report.staff_sigmec_id,
          client_id: newProps.flight_report.client_id,
          show_select_clients: newProps.flight_type.client_required,
          date: newProps.flight_report.date_str,
          flight_number: newProps.flight_report.flight_number,
          report_number: newProps.flight_report.report_number,
          flight_type: newProps.flight_type,
          exemption: newProps.flight_report.exemption,
          sar_flights: newProps.flight_report.sar_flights,
          power_checks: newProps.flight_report.power_checks,
          night_deck_landing: newProps.flight_report.night_deck_landing,
          observations: newProps.flight_report.observations,
          bases_select: newProps.bases_select,
          aircrafts_select: newProps.aircrafts_select,
          flight_types_select: newProps.flight_types_select,
          contracts_select: newProps.contracts_select,
          clients_select: newProps.clients_select,
          staff_mechanics_select: newProps.staff_mechanics_select,
          daily_flights: newProps.daily_flights,
          loaded: 1
        });
        if (!newProps.flight_report.flight_number || newProps.flight_report.flight_number === null) {
          this.setState({
            flight_number: ''
          });
        }
      }
    }

    // Fetch salvando a edição

  }, {
    key: 'edit',
    value: function edit(event) {

      event.preventDefault();
      if (navigator.onLine) {
        this.props.handleAlert('', '', 'open');
        var datasave = {
          id: this.state.id,
          aircraft_id: this.state.aircraft_id,
          base_id: this.state.base_id,
          contract_id: this.state.contract_id,
          flight_type_id: this.state.flight_type_id,
          staff_sigmec_id: this.state.staff_sigmec_id,
          client_id: this.state.client_id,
          date: this.state.date,
          flight_number: this.state.flight_number,
          report_number: this.state.report_number,
          exemption: this.state.exemption,
          sar_flights: this.state.sar_flights,
          power_checks: this.state.power_checks,
          night_deck_landing: this.state.night_deck_landing,
          observations: this.state.observations
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
          }).catch(function (error) {
            console.error(error);
          });
        });
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: this.edit },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarRelatorio.Data,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.date, maskChar: null, name: 'date ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date'), placeholder: '', disabled: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarRelatorio.Prefixo,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'aircraft_id',
                value: this.state.aircraft_id,
                searchable: true,
                placeholder: '',
                onChange: this.handleSelectAircraftChange.bind(this, 'aircraft_id'),
                options: this.state.aircrafts_select,
                disabled: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarRelatorio.Voo,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'flight_type_id',
                value: this.state.flight_type_id,
                searchable: true,
                placeholder: '',
                onChange: this.handleSelectFlightTypeChange.bind(this, 'flight_type_id'),
                options: this.state.flight_types_select,
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarRelatorio.NumeroDeVoo,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'flight_number', className: 'form-control', placeholder: '', value: this.state.flight_number, onChange: this.handleChange.bind(this, 'flight_number') })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarRelatorio.SolicitouIsencao
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
                checked: this.state.exemption,
                'aria-label': 'No label tag',
                name: 'exemption',
                onChange: this.handleToggleChange.bind(this, 'exemption') })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarRelatorio.PowerCheck
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
                checked: this.state.power_checks,
                'aria-label': 'No label tag',
                name: 'power_checks',
                onChange: this.handleToggleChange.bind(this, 'power_checks')
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarRelatorio.Base,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'base_id',
                value: this.state.base_id,
                searchable: true,
                placeholder: '',
                onChange: this.handleSelectChange.bind(this, 'base_id'),
                options: this.state.bases_select,
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarRelatorio.Contrato,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'contract_id',
                value: this.state.contract_id,
                searchable: true,
                placeholder: '',
                onChange: this.handleSelectChange.bind(this, 'contract_id'),
                options: this.state.contracts_select,
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarRelatorio.NumeroDoRelatorio,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'report_number', className: 'form-control', placeholder: '', value: this.state.report_number, onChange: this.handleChange.bind(this, 'report_number'), required: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarRelatorio.MecanicoResponsavel,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'staff_sigmec_id',
                value: this.state.staff_sigmec_id,
                searchable: true,
                placeholder: '',
                onChange: this.handleSelectChange.bind(this, 'staff_sigmec_id'),
                options: this.state.staff_mechanics_select
              })
            )
          ),
          this.state.show_select_clients == true && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarRelatorio.Cliente
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'client_id',
                value: this.state.client_id,
                searchable: true,
                placeholder: '',
                onChange: this.handleSelectChange.bind(this, 'client_id'),
                options: this.state.clients_select,
                required: true
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            null,
            this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaVoosDia.Titulo
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["BootstrapTable"],
            { data: this.state.daily_flights, pagination: false, striped: true, hover: true, exportCSV: false, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaVoosDia.SemVoos }, search: false, multiColumnSearch: false, searchPlaceholder: this.locale.general.procurar },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
              { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: false, width: '60' },
              this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaVoosDia.Id
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
              { dataField: 'flight_number', dataAlign: 'center', dataSort: false, width: '120' },
              this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaVoosDia.NumeroVoo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
              { dataField: 'report_number', dataAlign: 'center', dataSort: false, width: '120' },
              this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaVoosDia.NumeroRelatório
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
              { dataField: 'client', dataAlign: 'center', dataSort: false, width: '120' },
              this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaVoosDia.Cliente
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
              { dataField: 'contract', dataAlign: 'center', dataSort: false, width: '120' },
              this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaVoosDia.Contrato
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
              { dataField: 'flight_type', dataAlign: 'center', dataSort: false, width: '120' },
              this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaVoosDia.TipoVoo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
              { dataField: 'status', dataAlign: 'center', dataSort: false, width: '120' },
              this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaVoosDia.Status
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
            ' ',
            this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarRelatorio.botaoEditarRelatorioDeVoo
          )
        )
      );
    }
  }]);

  return FlightReportEditTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportEditTab);

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__ = __webpack_require__(3);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário








var FlightReportLegAddTab = function (_Component) {
  _inherits(FlightReportLegAddTab, _Component);

  function FlightReportLegAddTab(props) {
    _classCallCheck(this, FlightReportLegAddTab);

    var _this = _possibleConstructorReturn(this, (FlightReportLegAddTab.__proto__ || Object.getPrototypeOf(FlightReportLegAddTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      updated: false,
      modal: false,
      modal_flight_following: false,
      id: null,
      staff_id: null,
      duty_id: null,
      flight_report_id: null,
      departure_location_id: null,
      arrival_location_id: null,
      leg_number: null,
      takeoff_time_scheduled: null,
      total_time_scheduled: null,
      engine_start_time: null,
      takeoff_time: null,
      landing_time: null,
      engine_shutoff_time: null,
      takeoff_land_time: null,
      total_time: '00:00:00',
      navigation_time: '00:00:00',
      ifr_time: '00:00:00',
      night_time: '00:00:00',
      day_landings: 0,
      night_landings: 0,
      starts: null,
      pax: 0,
      payload: 0,
      external_load_long_line: 0,
      external_load_short_line: 0,
      fuel_start: 0,
      fuel_end: 0,
      ptbr_code_id: null,
      ptbr_operation_id: null,
      ptbr_external_load_id: null,
      delay_time: null,
      delay_departure: null,
      locations_select: [],
      ptbr_codes_select: [],
      ptbr_operations_select: [],
      ptbr_external_loads_select: [],
      duties_select: [],
      staffs_select: [],
      flight_report_leg_edit: {},
      flight_report_leg_edit_staffs: {},
      aircraft_model_version_custom_items: {},
      custom_items: {},
      style: {},
      edited: false,
      handle_edited: false
    };

    _this.editMobile = _this.editMobile.bind(_this);
    _this.delete = _this.delete.bind(_this);
    _this.addStaff = _this.addStaff.bind(_this);
    _this.deleteStaff = _this.deleteStaff.bind(_this);
    _this.diffFlight = _this.diffFlight.bind(_this);
    _this.diffTotalTime = _this.diffTotalTime.bind(_this);
    _this.delayFlight = _this.delayFlight.bind(_this);
    _this.delayTotalTime = _this.delayTotalTime.bind(_this);
    _this.calcTimeFromMs = _this.calcTimeFromMs.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__["a" /* default */])();
    _this.autoFillTime = _this.autoFillTime.bind(_this);
    _this.cleanLeg = _this.cleanLeg.bind(_this);
    _this.propsHandling = _this.propsHandling.bind(_this);
    _this.handleCustomItem = _this.handleCustomItem.bind(_this);
    _this.handleChangeDecimal = _this.handleChangeDecimal.bind(_this);
    _this.formatInputValue = _this.formatInputValue.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(FlightReportLegAddTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change['handle_edited'] = true;
      change['edited'] = true;
      change[name] = event.target.value;
      if (name === 'takeoff_time') {
        this.diffFlight(event.target.value, this.state.landing_time, change);
        this.delayFlight(event.target.value, this.state.takeoff_time_scheduled, change);
        this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, event.target.value, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'landing_time') {
        this.diffFlight(this.state.takeoff_time, event.target.value, change);
        this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, this.state.takeoff_time, event.target.value, this.state.start_parameter_total, change);
      } else if (name === 'engine_start_time') {
        this.diffTotalTime(event.target.value, this.state.engine_shutoff_time, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'engine_shutoff_time') {
        this.diffTotalTime(this.state.engine_start_time, event.target.value, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'takeoff_time_scheduled') {
        this.delayFlight(this.state.takeoff_time, event.target.value, change);
      } else if (name === 'total_time_scheduled') {
        this.delayTotalTime(event.target.value, this.state.takeoff_land_time, change);
      } else {
        this.setState(change);
      }
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      change['handle_edited'] = true;
      change['edited'] = true;
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      change['handle_edited'] = true;
      change['edited'] = true;
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.propsHandling(this.props);

      var flight_report_id = this.props.flight_report_id;
      var flight_report_legs_new_all = JSON.parse(localStorage.getItem("cached_flight_report_legs_states_new_by_id")) || {};
      var flight_report_legs_new = flight_report_legs_new_all[flight_report_id] || [];

      this.setState({
        flight_report_legs_new: flight_report_legs_new
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.handle_edited) {
        var cached_flight_report_legs_states_new_by_id = JSON.parse(localStorage.getItem("cached_flight_report_legs_states_new_by_id")) || {};

        if (!cached_flight_report_legs_states_new_by_id[this.props.flight_report_id]) {
          cached_flight_report_legs_states_new_by_id[this.props.flight_report_id] = [];
        }

        cached_flight_report_legs_states_new_by_id[this.props.flight_report_id][this.props.flight_report_legs_states_new_index] = {
          'id': this.state.id,
          'takeoff_time_scheduled': this.state.takeoff_time_scheduled,
          'total_time_scheduled': this.state.total_time_scheduled,
          'engine_start_time': this.state.engine_start_time,
          'takeoff_time': this.state.takeoff_time,
          'landing_time': this.state.landing_time,
          'engine_shutoff_time': this.state.engine_shutoff_time,
          'takeoff_land_time': this.state.takeoff_land_time,
          'flight_following_engine_start_time': this.state.flight_following_engine_start_time,
          'flight_following_takeoff_time': this.state.flight_following_takeoff_time,
          'flight_following_landing_time': this.state.flight_following_landing_time,
          'flight_following_engine_shutoff_time': this.state.flight_following_engine_shutoff_time,
          'total_time': this.state.total_time,
          'navigation_time': this.state.navigation_time,
          'ifr_time': this.state.ifr_time,
          'night_time': this.state.night_time,
          'start_parameter_total': this.state.start_parameter_total,
          'xml': this.state.xml,
          'external_load': this.state.external_load,
          'flight_report_id': this.state.flight_report_id,
          'departure_location_id': this.state.departure_location_id,
          'arrival_location_id': this.state.arrival_location_id,
          'day_landings': this.state.day_landings,
          'night_landings': this.state.night_landings,
          'starts': this.state.starts,
          'pax': this.state.pax,
          'payload': this.state.payload,
          'external_load_long_line': this.state.external_load_long_line,
          'external_load_short_line': this.state.external_load_short_line,
          'fuel_start': this.state.fuel_start,
          'fuel_end': this.state.fuel_end,
          'ptbr_code_id': this.state.ptbr_code_id,
          'ptbr_operation_id': this.state.ptbr_operation_id,
          'ptbr_external_load_id': this.state.ptbr_external_load_id,
          'delay_departure': this.state.delay_departure,
          'delay_time': this.state.delay_time,
          'leg_number': this.state.leg_number,
          'custom_items': Object.assign({}, this.state.custom_items || {}),
          'edited': true
        };

        this.setState({ handle_edited: false });

        localStorage.setItem("cached_flight_report_legs_states_new_by_id", JSON.stringify(cached_flight_report_legs_states_new_by_id));
      }

      if (this.props.deleting === true && this.state.loaded === true) {
        this.propsHandling(this.props);
        this.props.setDeleteFalse();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === false || newProps.updated === 1) {
        this.propsHandling(newProps);
        if (newProps.flight_report_leg_edit.edited) {
          this.setState({
            flight_report_leg_edit_staffs: newProps.flight_report_leg_edit_staffs,
            locations_select: newProps.locations_select,
            ptbr_codes_select: newProps.ptbr_codes_select,
            ptbr_operations_select: newProps.ptbr_operations_select,
            ptbr_external_loads_select: newProps.ptbr_external_loads_select,
            staffs_select: newProps.staffs_select,
            duties_select: newProps.duties_select,
            style: newProps.style,
            date: newProps.date,
            id: newProps.flight_report_leg_edit.id,
            flight_report_id: newProps.flight_report_leg_edit.flight_report_id,
            departure_location_id: newProps.flight_report_leg_edit.departure_location_id,
            arrival_location_id: newProps.flight_report_leg_edit.arrival_location_id,
            takeoff_time_scheduled: newProps.flight_report_leg_edit.takeoff_time_scheduled,
            total_time_scheduled: newProps.flight_report_leg_edit.total_time_scheduled,
            engine_start_time: newProps.flight_report_leg_edit.engine_start_time,
            takeoff_time: newProps.flight_report_leg_edit.takeoff_time,
            landing_time: newProps.flight_report_leg_edit.landing_time,
            engine_shutoff_time: newProps.flight_report_leg_edit.engine_shutoff_time,
            takeoff_land_time: newProps.flight_report_leg_edit.takeoff_land_time,
            flight_following_engine_start_time: newProps.flight_report_leg_edit.flight_following_engine_start_time,
            flight_following_takeoff_time: newProps.flight_report_leg_edit.flight_following_takeoff_time,
            flight_following_landing_time: newProps.flight_report_leg_edit.flight_following_landing_time,
            flight_following_engine_shutoff_time: newProps.flight_report_leg_edit.flight_following_engine_shutoff_time,
            total_time: newProps.flight_report_leg_edit.total_time,
            navigation_time: newProps.flight_report_leg_edit.navigation_time,
            ifr_time: newProps.flight_report_leg_edit.ifr_time,
            night_time: newProps.flight_report_leg_edit.night_time,
            day_landings: newProps.flight_report_leg_edit.day_landings,
            night_landings: newProps.flight_report_leg_edit.night_landings,
            starts: newProps.flight_report_leg_edit.starts,
            pax: newProps.flight_report_leg_edit.pax,
            payload: newProps.flight_report_leg_edit.payload,
            external_load_long_line: newProps.flight_report_leg_edit.external_load_long_line,
            external_load_short_line: newProps.flight_report_leg_edit.external_load_short_line,
            fuel_start: newProps.flight_report_leg_edit.fuel_start,
            fuel_end: newProps.flight_report_leg_edit.fuel_end,
            ptbr_code_id: newProps.flight_report_leg_edit.ptbr_code_id,
            ptbr_operation_id: newProps.flight_report_leg_edit.ptbr_operation_id,
            ptbr_external_load_id: newProps.flight_report_leg_edit.ptbr_external_load_id,
            delay_departure: newProps.flight_report_leg_edit.delay_departure,
            delay_time: newProps.flight_report_leg_edit.delay_time,
            leg_number: newProps.flight_report_leg_edit.leg_number,
            start_parameter_total: newProps.flight_report_leg_edit.start_parameter_total,
            xml: newProps.flight_report_leg_edit.xml,
            external_load: newProps.flight_report_leg_edit.external_load,
            aircraft_model_version_custom_items: newProps.aircraft_model_version_custom_items || {},
            custom_items: function () {
              var ci = {};
              if (newProps.flight_report_leg_edit && newProps.flight_report_leg_edit.flight_report_leg_custom_items) {
                Object.keys(newProps.flight_report_leg_edit.flight_report_leg_custom_items).map(function (k) {
                  var it = newProps.flight_report_leg_edit.flight_report_leg_custom_items[k];
                  ci[it.aircraft_model_version_custom_item_id] = it.value;
                });
              } else if (newProps.flight_report_leg_edit && newProps.flight_report_leg_edit.custom_items) {
                Object.keys(newProps.flight_report_leg_edit.custom_items).map(function (k) {
                  ci[k] = newProps.flight_report_leg_edit.custom_items[k];
                });
              }
              return ci;
            }(),
            loaded: true,
            updated: false,
            edited: true
          });
        } else {

          var takeoff_time_scheduled = newProps.flight_report_leg_edit.takeoff_time_scheduled_str;if (takeoff_time_scheduled === null) takeoff_time_scheduled = '';
          var total_time_scheduled = newProps.flight_report_leg_edit.total_time_scheduled;if (total_time_scheduled === null) total_time_scheduled = '';
          var engine_start_time = newProps.flight_report_leg_edit.engine_start_time_str;if (engine_start_time === null) engine_start_time = '';
          var takeoff_time = newProps.flight_report_leg_edit.takeoff_time_str;if (takeoff_time === null) takeoff_time = '';
          var landing_time = newProps.flight_report_leg_edit.landing_time_str;if (landing_time === null) landing_time = '';
          var engine_shutoff_time = newProps.flight_report_leg_edit.engine_shutoff_time_str;if (engine_shutoff_time === null) engine_shutoff_time = '';
          var takeoff_land_time = newProps.flight_report_leg_edit.takeoff_land_time;if (takeoff_land_time === null) takeoff_land_time = '';
          var flight_following_engine_start_time = newProps.flight_report_leg_edit.flight_following_engine_start_time_str;if (flight_following_engine_start_time === null) flight_following_engine_start_time = '';
          var flight_following_takeoff_time = newProps.flight_report_leg_edit.flight_following_takeoff_time_str;if (flight_following_takeoff_time === null) flight_following_takeoff_time = '';
          var flight_following_landing_time = newProps.flight_report_leg_edit.flight_following_landing_time_str;if (flight_following_landing_time === null) flight_following_landing_time = '';
          var flight_following_engine_shutoff_time = newProps.flight_report_leg_edit.flight_following_engine_shutoff_time_str;if (flight_following_engine_shutoff_time === null) flight_following_engine_shutoff_time = '';
          var total_time = newProps.flight_report_leg_edit.total_time;if (total_time === null) total_time = '';
          var navigation_time = newProps.flight_report_leg_edit.navigation_time;if (navigation_time === null) navigation_time = '';
          var ifr_time = newProps.flight_report_leg_edit.ifr_time;if (ifr_time === null) ifr_time = '';
          var night_time = newProps.flight_report_leg_edit.night_time;if (night_time === null) night_time = '';

          var leg_data = {
            flight_report_leg_edit_staffs: newProps.flight_report_leg_edit_staffs,
            locations_select: newProps.locations_select,
            ptbr_codes_select: newProps.ptbr_codes_select,
            ptbr_operations_select: newProps.ptbr_operations_select,
            ptbr_external_loads_select: newProps.ptbr_external_loads_select,
            staffs_select: newProps.staffs_select,
            duties_select: newProps.duties_select,
            style: newProps.style,
            date: newProps.date,
            id: newProps.flight_report_leg_edit.id,
            flight_report_id: newProps.flight_report_leg_edit.flight_report_id,
            departure_location_id: newProps.flight_report_leg_edit.departure_location_id,
            arrival_location_id: newProps.flight_report_leg_edit.arrival_location_id,
            takeoff_time_scheduled: takeoff_time_scheduled,
            total_time_scheduled: total_time_scheduled,
            engine_start_time: engine_start_time,
            takeoff_time: takeoff_time,
            landing_time: landing_time,
            engine_shutoff_time: engine_shutoff_time,
            takeoff_land_time: takeoff_land_time,
            flight_following_engine_start_time: flight_following_engine_start_time,
            flight_following_takeoff_time: flight_following_takeoff_time,
            flight_following_landing_time: flight_following_landing_time,
            flight_following_engine_shutoff_time: flight_following_engine_shutoff_time,
            total_time: total_time,
            navigation_time: navigation_time,
            ifr_time: ifr_time,
            night_time: night_time,
            day_landings: newProps.flight_report_leg_edit.day_landings,
            night_landings: newProps.flight_report_leg_edit.night_landings,
            starts: newProps.flight_report_leg_edit.starts,
            pax: newProps.flight_report_leg_edit.pax,
            payload: newProps.flight_report_leg_edit.payload,
            external_load_long_line: newProps.flight_report_leg_edit.external_load_long_line,
            external_load_short_line: newProps.flight_report_leg_edit.external_load_short_line,
            fuel_start: newProps.flight_report_leg_edit.fuel_start,
            fuel_end: newProps.flight_report_leg_edit.fuel_end,
            ptbr_code_id: newProps.flight_report_leg_edit.ptbr_code_id,
            ptbr_operation_id: newProps.flight_report_leg_edit.ptbr_operation_id,
            ptbr_external_load_id: newProps.flight_report_leg_edit.ptbr_external_load_id,
            delay_departure: newProps.flight_report_leg_edit.delay_departure,
            delay_time: newProps.flight_report_leg_edit.delay_time,
            leg_number: newProps.flight_report_leg_edit.leg_number,
            start_parameter_total: newProps.start_parameter_total,
            xml: newProps.xml,
            external_load: newProps.external_load,
            aircraft_model_version_custom_items: newProps.aircraft_model_version_custom_items || {},
            custom_items: function () {
              var ci = {};
              if (newProps.flight_report_leg_edit && newProps.flight_report_leg_edit.flight_report_leg_custom_items) {
                Object.keys(newProps.flight_report_leg_edit.flight_report_leg_custom_items).map(function (k) {
                  var it = newProps.flight_report_leg_edit.flight_report_leg_custom_items[k];
                  ci[it.aircraft_model_version_custom_item_id] = it.value;
                });
              } else if (newProps.flight_report_leg_edit && newProps.flight_report_leg_edit.custom_items) {
                Object.keys(newProps.flight_report_leg_edit.custom_items).map(function (k) {
                  ci[k] = newProps.flight_report_leg_edit.custom_items[k];
                });
              }
              return ci;
            }(),
            loaded: true,
            updated: false,
            edited: false
          };
          this.setState(leg_data);
        }
      }
    }
  }, {
    key: 'propsHandling',
    value: function propsHandling(props) {
      if (props.flight_report_leg_edit.edited) {
        this.setState({
          flight_report_leg_edit_staffs: props.flight_report_leg_edit_staffs,
          locations_select: props.locations_select,
          ptbr_codes_select: props.ptbr_codes_select,
          ptbr_operations_select: props.ptbr_operations_select,
          ptbr_external_loads_select: props.ptbr_external_loads_select,
          staffs_select: props.staffs_select,
          duties_select: props.duties_select,
          style: props.style,
          date: props.date,
          id: props.flight_report_leg_edit.id,
          flight_report_id: props.flight_report_leg_edit.flight_report_id,
          departure_location_id: props.flight_report_leg_edit.departure_location_id,
          arrival_location_id: props.flight_report_leg_edit.arrival_location_id,
          takeoff_time_scheduled: props.flight_report_leg_edit.takeoff_time_scheduled,
          total_time_scheduled: props.flight_report_leg_edit.total_time_scheduled,
          engine_start_time: props.flight_report_leg_edit.engine_start_time,
          takeoff_time: props.flight_report_leg_edit.takeoff_time,
          landing_time: props.flight_report_leg_edit.landing_time,
          engine_shutoff_time: props.flight_report_leg_edit.engine_shutoff_time,
          takeoff_land_time: props.flight_report_leg_edit.takeoff_land_time,
          flight_following_engine_start_time: props.flight_report_leg_edit.flight_following_engine_start_time,
          flight_following_takeoff_time: props.flight_report_leg_edit.flight_following_takeoff_time,
          flight_following_landing_time: props.flight_report_leg_edit.flight_following_landing_time,
          flight_following_engine_shutoff_time: props.flight_report_leg_edit.flight_following_engine_shutoff_time,
          total_time: props.flight_report_leg_edit.total_time,
          navigation_time: props.flight_report_leg_edit.navigation_time,
          ifr_time: props.flight_report_leg_edit.ifr_time,
          night_time: props.flight_report_leg_edit.night_time,
          day_landings: props.flight_report_leg_edit.day_landings,
          night_landings: props.flight_report_leg_edit.night_landings,
          starts: props.flight_report_leg_edit.starts,
          pax: props.flight_report_leg_edit.pax,
          payload: props.flight_report_leg_edit.payload,
          external_load_long_line: props.flight_report_leg_edit.external_load_long_line,
          external_load_short_line: props.flight_report_leg_edit.external_load_short_line,
          fuel_start: props.flight_report_leg_edit.fuel_start,
          fuel_end: props.flight_report_leg_edit.fuel_end,
          ptbr_code_id: props.flight_report_leg_edit.ptbr_code_id,
          ptbr_operation_id: props.flight_report_leg_edit.ptbr_operation_id,
          ptbr_external_load_id: props.flight_report_leg_edit.ptbr_external_load_id,
          delay_departure: props.flight_report_leg_edit.delay_departure,
          delay_time: props.flight_report_leg_edit.delay_time,
          leg_number: props.flight_report_leg_edit.leg_number,
          start_parameter_total: props.flight_report_leg_edit.start_parameter_total,
          xml: props.flight_report_leg_edit.xml,
          external_load: props.flight_report_leg_edit.external_load,
          aircraft_model_version_custom_items: props.aircraft_model_version_custom_items || {},
          custom_items: function () {
            var ci = {};
            if (props.flight_report_leg_edit && props.flight_report_leg_edit.flight_report_leg_custom_items) {
              Object.keys(props.flight_report_leg_edit.flight_report_leg_custom_items).map(function (k) {
                var it = props.flight_report_leg_edit.flight_report_leg_custom_items[k];
                ci[it.aircraft_model_version_custom_item_id] = it.value;
              });
            } else if (props.flight_report_leg_edit && props.flight_report_leg_edit.custom_items) {
              Object.keys(props.flight_report_leg_edit.custom_items).map(function (k) {
                ci[k] = props.flight_report_leg_edit.custom_items[k];
              });
            }
            return ci;
          }(),
          loaded: true,
          updated: false,
          edited: true
        });
      } else {
        var takeoff_time_scheduled = props.flight_report_leg_edit.takeoff_time_scheduled_str;if (takeoff_time_scheduled === null) takeoff_time_scheduled = '';
        var total_time_scheduled = props.flight_report_leg_edit.total_time_scheduled;if (total_time_scheduled === null) total_time_scheduled = '';
        var engine_start_time = props.flight_report_leg_edit.engine_start_time_str;if (engine_start_time === null) engine_start_time = '';
        var takeoff_time = props.flight_report_leg_edit.takeoff_time_str;if (takeoff_time === null) takeoff_time = '';
        var landing_time = props.flight_report_leg_edit.landing_time_str;if (landing_time === null) landing_time = '';
        var engine_shutoff_time = props.flight_report_leg_edit.engine_shutoff_time_str;if (engine_shutoff_time === null) engine_shutoff_time = '';
        var takeoff_land_time = props.flight_report_leg_edit.takeoff_land_time;if (takeoff_land_time === null) takeoff_land_time = '';
        var flight_following_engine_start_time = props.flight_report_leg_edit.flight_following_engine_start_time_str;if (flight_following_engine_start_time === null) flight_following_engine_start_time = '';
        var flight_following_takeoff_time = props.flight_report_leg_edit.flight_following_takeoff_time_str;if (flight_following_takeoff_time === null) flight_following_takeoff_time = '';
        var flight_following_landing_time = props.flight_report_leg_edit.flight_following_landing_time_str;if (flight_following_landing_time === null) flight_following_landing_time = '';
        var flight_following_engine_shutoff_time = props.flight_report_leg_edit.flight_following_engine_shutoff_time_str;if (flight_following_engine_shutoff_time === null) flight_following_engine_shutoff_time = '';
        var total_time = props.flight_report_leg_edit.total_time;if (total_time === null) total_time = '';
        var navigation_time = props.flight_report_leg_edit.navigation_time;if (navigation_time === null) navigation_time = '';
        var ifr_time = props.flight_report_leg_edit.ifr_time;if (ifr_time === null) ifr_time = '';
        var night_time = props.flight_report_leg_edit.night_time;if (night_time === null) night_time = '';

        this.setState({
          flight_report_leg_edit_staffs: props.flight_report_leg_edit_staffs,
          locations_select: props.locations_select,
          ptbr_codes_select: props.ptbr_codes_select,
          ptbr_operations_select: props.ptbr_operations_select,
          ptbr_external_loads_select: props.ptbr_external_loads_select,
          staffs_select: props.staffs_select,
          duties_select: props.duties_select,
          style: props.style,
          date: props.date,
          id: props.flight_report_leg_edit.id,
          flight_report_id: props.flight_report_leg_edit.flight_report_id,
          departure_location_id: props.flight_report_leg_edit.departure_location_id,
          arrival_location_id: props.flight_report_leg_edit.arrival_location_id,
          takeoff_time_scheduled: takeoff_time_scheduled,
          total_time_scheduled: total_time_scheduled,
          engine_start_time: engine_start_time,
          takeoff_time: takeoff_time,
          landing_time: landing_time,
          engine_shutoff_time: engine_shutoff_time,
          takeoff_land_time: takeoff_land_time,
          flight_following_engine_start_time: flight_following_engine_start_time,
          flight_following_takeoff_time: flight_following_takeoff_time,
          flight_following_landing_time: flight_following_landing_time,
          flight_following_engine_shutoff_time: flight_following_engine_shutoff_time,
          total_time: total_time,
          navigation_time: navigation_time,
          ifr_time: ifr_time,
          night_time: night_time,
          day_landings: props.flight_report_leg_edit.day_landings,
          night_landings: props.flight_report_leg_edit.night_landings,
          starts: props.flight_report_leg_edit.starts,
          pax: props.flight_report_leg_edit.pax,
          payload: props.flight_report_leg_edit.payload,
          external_load_long_line: props.flight_report_leg_edit.external_load_long_line,
          external_load_short_line: props.flight_report_leg_edit.external_load_short_line,
          fuel_start: props.flight_report_leg_edit.fuel_start,
          fuel_end: props.flight_report_leg_edit.fuel_end,
          ptbr_code_id: props.flight_report_leg_edit.ptbr_code_id,
          ptbr_operation_id: props.flight_report_leg_edit.ptbr_operation_id,
          ptbr_external_load_id: props.flight_report_leg_edit.ptbr_external_load_id,
          delay_departure: props.flight_report_leg_edit.delay_departure,
          delay_time: props.flight_report_leg_edit.delay_time,
          leg_number: props.flight_report_leg_edit.leg_number,
          start_parameter_total: props.start_parameter_total,
          xml: props.xml,
          external_load: props.external_load,
          aircraft_model_version_custom_items: props.aircraft_model_version_custom_items || {},
          custom_items: function () {
            var ci = {};
            if (props.flight_report_leg_edit && props.flight_report_leg_edit.flight_report_leg_custom_items) {
              Object.keys(props.flight_report_leg_edit.flight_report_leg_custom_items).map(function (k) {
                var it = props.flight_report_leg_edit.flight_report_leg_custom_items[k];
                ci[it.aircraft_model_version_custom_item_id] = it.value;
              });
            } else if (props.flight_report_leg_edit && props.flight_report_leg_edit.custom_items) {
              Object.keys(props.flight_report_leg_edit.custom_items).map(function (k) {
                ci[k] = props.flight_report_leg_edit.custom_items[k];
              });
            }
            return ci;
          }(),
          loaded: true,
          updated: false,
          edited: false
        });
      }
    }
  }, {
    key: 'autoFillTime',
    value: function autoFillTime(name, value) {
      var now = __WEBPACK_IMPORTED_MODULE_7_moment___default()(new Date());
      now = now.format("HH:mm");

      if (value !== null) {
        now = value;
      }

      var change = {};
      change[name] = now;
      change['handle_edited'] = true;
      change['edited'] = true;

      if (name === 'takeoff_time') {
        this.diffFlight(now, this.state.landing_time, change);
        this.delayFlight(now, this.state.takeoff_scheduled, change);
        this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, now, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'landing_time') {
        this.diffFlight(this.state.takeoff_time, now, change);
        this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, this.state.takeoff_time, now, this.state.start_parameter_total, change);
      } else if (name === 'engine_start_time') {
        this.diffTotalTime(now, this.state.engine_shutoff_time, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'engine_shutoff_time') {
        this.diffTotalTime(this.state.engine_start_time, now, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'takeoff_scheduled') {
        this.delayFlight(this.state.takeoff_time, now, change);
      } else if (name === 'total_time_preview') {
        this.delayTotalTime(now, this.state.takeoff_land_time, change);
      } else {
        this.setState(change);
      }
    }
  }, {
    key: 'diffFlight',
    value: function diffFlight(takeoff_time, landing_time, change) {
      if (takeoff_time && landing_time && takeoff_time !== '' && landing_time !== '') {
        takeoff_time = this.state.date + ' ' + takeoff_time;
        landing_time = this.state.date + ' ' + landing_time;

        takeoff_time = __WEBPACK_IMPORTED_MODULE_7_moment___default()(takeoff_time, "DD/MM/YYYY HH:mm:ss");
        landing_time = __WEBPACK_IMPORTED_MODULE_7_moment___default()(landing_time, "DD/MM/YYYY HH:mm:ss");

        if (takeoff_time > landing_time) {
          landing_time.add(1, 'd');
        }

        takeoff_time = new Date(takeoff_time.format("YYYY-MM-DD HH:mm:ss"));
        landing_time = new Date(landing_time.format("YYYY-MM-DD HH:mm:ss"));
        var diffTime = Math.abs(landing_time.getTime() - takeoff_time.getTime());
        if (landing_time > takeoff_time) {
          change['takeoff_land_time'] = this.calcTimeFromMs(diffTime);
          change['navigation_time'] = this.calcTimeFromMs(diffTime);
        } else {
          change['takeoff_land_time'] = '00:00';
          change['navigation_time'] = '00:00';
        }
      } else {
        change['takeoff_land_time'] = '00:00';
        change['navigation_time'] = '00:00';
      }
      this.delayTotalTime(this.state.total_time_scheduled, change['takeoff_land_time'], change);
    }
  }, {
    key: 'diffTotalTime',
    value: function diffTotalTime(engine_start_time, engine_shutoff_time, takeoff_time, landing_time, start_parameter_total, change) {
      var start = null;
      if (engine_start_time !== null && engine_start_time !== '' && typeof engine_start_time !== 'undefined') {
        start = engine_start_time;
      } else if (start_parameter_total !== null) {
        start = start_parameter_total.substring(11);
      }

      if (engine_start_time !== null && engine_start_time !== '' && typeof engine_start_time !== 'undefined') {
        start = engine_start_time;
      }

      var finish = null;
      if (landing_time !== null && landing_time !== '' && typeof landing_time !== 'undefined') {
        finish = landing_time;
      }
      if (engine_shutoff_time !== null && engine_shutoff_time !== '' && typeof engine_shutoff_time !== 'undefined') {
        finish = engine_shutoff_time;
      }

      if (start && finish) {
        start = this.state.date + ' ' + start;
        finish = this.state.date + ' ' + finish;

        start = __WEBPACK_IMPORTED_MODULE_7_moment___default()(start, "DD/MM/YYYY HH:mm:ss");
        finish = __WEBPACK_IMPORTED_MODULE_7_moment___default()(finish, "DD/MM/YYYY HH:mm:ss");

        if (start > finish) {
          finish.add(1, 'd');
        }

        start = new Date(start.format("YYYY-MM-DD HH:mm:ss"));
        finish = new Date(finish.format("YYYY-MM-DD HH:mm:ss"));

        var diffTime = Math.abs(finish.getTime() - start.getTime());
        if (finish > start) {
          change['total_time'] = this.calcTimeFromMs(diffTime);
        } else {
          change['total_time'] = '00:00';
        }
        this.setState(change);
      } else {
        change['total_time'] = '00:00';
        this.setState(change);
      }
    }
  }, {
    key: 'delayFlight',
    value: function delayFlight(takeoff_time, takeoff_time_scheduled, change) {
      if (takeoff_time_scheduled) {
        takeoff_time = this.state.date + ' ' + takeoff_time;
        takeoff_time_scheduled = this.state.date + ' ' + takeoff_time_scheduled;

        takeoff_time = __WEBPACK_IMPORTED_MODULE_7_moment___default()(takeoff_time, "DD/MM/YYYY HH:mm:ss");
        takeoff_time_scheduled = __WEBPACK_IMPORTED_MODULE_7_moment___default()(takeoff_time_scheduled, "DD/MM/YYYY HH:mm:ss");

        var diff_hours = takeoff_time_scheduled.diff(takeoff_time, 'hours');

        if (takeoff_time < takeoff_time_scheduled && diff_hours > 12) {
          takeoff_time.add(1, 'd');
        }

        takeoff_time = new Date(takeoff_time.format("YYYY-MM-DD HH:mm:ss"));
        takeoff_time_scheduled = new Date(takeoff_time_scheduled.format("YYYY-MM-DD HH:mm:ss"));
        var diffTime = Math.abs(takeoff_time.getTime() - takeoff_time_scheduled.getTime());
        if (takeoff_time > takeoff_time_scheduled) {
          change['delay_departure'] = this.calcTimeFromMs(diffTime);
        } else {
          change['delay_departure'] = '00:00';
        }
      } else {
        change['delay_departure'] = '00:00';
      }
      this.setState(change);
    }
  }, {
    key: 'delayTotalTime',
    value: function delayTotalTime(total_time_scheduled, takeoff_land_time, change) {
      if (takeoff_land_time) {
        takeoff_land_time = __WEBPACK_IMPORTED_MODULE_7_moment___default()().format("YYYY-MM-DD") + ' ' + takeoff_land_time;
        total_time_scheduled = __WEBPACK_IMPORTED_MODULE_7_moment___default()().format("YYYY-MM-DD") + ' ' + total_time_scheduled;

        takeoff_land_time = new Date(takeoff_land_time);
        total_time_scheduled = new Date(total_time_scheduled);
        var diffTime = Math.abs(takeoff_land_time.getTime() - total_time_scheduled.getTime());
        if (takeoff_land_time > total_time_scheduled) {
          change['delay_time'] = this.calcTimeFromMs(diffTime);
        } else {
          change['delay_time'] = '00:00';
        }
      }
      this.setState(change);
    }
  }, {
    key: 'calcTimeFromMs',
    value: function calcTimeFromMs(diffTime) {
      diffTime = diffTime / 1000;
      var secs = diffTime % 60;
      diffTime = (diffTime - secs) / 60;
      var mins = diffTime % 60;
      var hrs = (diffTime - mins) / 60;
      if (secs < 10) {
        secs = '0' + secs;
      }
      if (mins < 10) {
        mins = '0' + mins;
      }
      if (hrs < 10) {
        hrs = '0' + hrs;
      }
      return hrs + ':' + mins + ':' + secs;
    }
  }, {
    key: 'handleChangeDecimal',
    value: function handleChangeDecimal(k, event) {
      var model_item = this.state.aircraft_model_version_custom_items[k];
      if (!model_item) {
        return;
      }
      var rawInputValue = model_item['rawInputValue'];
      var inputValue = event.target.value;
      if (inputValue === '') {
        rawInputValue = '';
      } else if (/^\d+$/.test(inputValue)) {
        rawInputValue = inputValue;
      } else {
        var newChar = inputValue.slice(-1);
        if (!/^[0-9.,]$/.test(newChar)) {
          return;
        }
        if (newChar === ',') {
          newChar = '.';
        }
        var hasDecimal = (rawInputValue || '').includes('.');
        if ((rawInputValue || '') === '' && newChar === '0') {
          return;
        }
        if (event.nativeEvent && event.nativeEvent.inputType === 'deleteContentBackward') {
          rawInputValue = (rawInputValue || '').slice(0, -1);
        } else if (hasDecimal && newChar !== '.') {
          var parts = (rawInputValue || '').split('.');
          parts[1] = newChar;
          rawInputValue = parts.join('.');
        } else {
          rawInputValue = (rawInputValue || '') + newChar;
        }
      }
      var formattedValue = this.formatInputValue(rawInputValue);
      var custom_items = Object.assign({}, this.state.custom_items || {});
      custom_items[model_item.id] = formattedValue;
      model_item['rawInputValue'] = rawInputValue;
      this.setState({ custom_items: custom_items, handle_edited: true, edited: true });
    }
  }, {
    key: 'formatInputValue',
    value: function formatInputValue(rawValue) {
      if (!rawValue) {
        return '';
      }

      var _rawValue$split = rawValue.split('.'),
          _rawValue$split2 = _slicedToArray(_rawValue$split, 2),
          inteiro = _rawValue$split2[0],
          decimal = _rawValue$split2[1];

      decimal = decimal && decimal.length > 0 ? decimal[0] : '0';
      return inteiro + '.' + decimal;
    }
  }, {
    key: 'handleCustomItem',
    value: function handleCustomItem(id, event) {
      var custom_items = Object.assign({}, this.state.custom_items || {});
      if (event == null) {
        custom_items[id] = null;
      } else {
        custom_items[id] = event.target.value;
      }
      this.setState({ custom_items: custom_items, handle_edited: true, edited: true });
    }

    // Fetch salvando a edição

  }, {
    key: 'editMobile',
    value: function editMobile(event) {
      event.preventDefault();
      this.edit();
    }
  }, {
    key: 'delete',
    value: function _delete() {
      if (window.confirm('Tem certeza que deseja excluir este trecho?')) {
        this.props.setParentState(this.props.flight_report_legs_states_new_index);
      }
    }
  }, {
    key: 'addStaff',
    value: function addStaff(event) {
      event.preventDefault();
      if (navigator.onLine) {
        this.props.handleAlert('', '', 'open');
        var datasave = {
          flight_report_leg_id: this.state.id,
          staff_id: this.state.staff_id,
          duty_id: this.state.duty_id
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/trecho/tripulante', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
          }).catch(function (error) {
            console.error(error);
          });
        });
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'deleteStaff',
    value: function deleteStaff(id) {
      if (navigator.onLine) {
        if (window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.removerTripulanteDoTrecho)) {
          this.props.handleAlert('', '', 'open');
          var datasave = {
            id: id
          };
          var header = this.refs.request_api.header('application/json');
          var self = this;
          Promise.resolve(header).then(function (value) {
            fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/trecho/tripulante', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.refs.request_api.validate(responseJson, 'alert');
              self.props.updateData(responseJson);
            }).catch(function (error) {
              console.error(error);
            });
          });
        }
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'cleanLeg',
    value: function cleanLeg(id) {
      var flight_report_leg_ids = [id];
      if (localStorage.getItem("cached_flight_report_legs_states_by_id")) {
        this.props.handleAlert('', '', 'open');
        var cached_flight_report_legs_states_by_id = localStorage.getItem("cached_flight_report_legs_states_by_id");
        cached_flight_report_legs_states_by_id = JSON.parse(cached_flight_report_legs_states_by_id);
        var new_cached_flight_report_legs_states_by_id = {};
        {
          Object.keys(cached_flight_report_legs_states_by_id).map(function (k) {
            var frl_by_id = cached_flight_report_legs_states_by_id[k];
            if (!flight_report_leg_ids.includes(frl_by_id.id)) {
              new_cached_flight_report_legs_states_by_id[frl_by_id.id] = frl_by_id;
            }
          });
        }
        localStorage.setItem("cached_flight_report_legs_states_by_id", JSON.stringify(new_cached_flight_report_legs_states_by_id));
        var responseJson = {
          data: {},
          status: 'success',
          message: this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.limparTrecho
        };
        this.props.updateData(responseJson);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      var style = {};
      if (self.state.edited) {
        style = { background: '#f3e5c9' };
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'tr',
        { style: style },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { style: { width: '200px', whiteSpace: 'nowrap', textAlign: 'center' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button', className: 'btn btn-info btn-sm button-inline', onClick: function onClick() {
                _this2.setState({ modal_flight_following: true });
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-clock-o' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button', className: 'btn btn-danger button-inline btn-sm', onClick: function onClick() {
                _this2.delete();
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-close' })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.state.leg_number
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
            className: 'form-field-name',
            style: this.state.style.select_places,
            name: 'departure_location_id',
            value: this.state.departure_location_id,
            searchable: true,
            placeholder: '',
            onChange: this.handleSelectChange.bind(this, 'departure_location_id'),
            options: this.state.locations_select

          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
            className: 'form-field-name',
            style: this.state.style.select_places,
            name: 'arrival_location_id',
            value: this.state.arrival_location_id,
            searchable: true,
            placeholder: '',
            onChange: this.handleSelectChange.bind(this, 'arrival_location_id'),
            options: this.state.locations_select

          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: this.state.style.input_hour, value: this.state.engine_start_time, maskChar: null, name: 'engine_start_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'engine_start_time'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: this.state.style.input_hour, value: this.state.takeoff_time, maskChar: null, name: 'takeoff_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'takeoff_time'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: this.state.style.input_hour, value: this.state.landing_time, maskChar: null, name: 'landing_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'landing_time'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: this.state.style.input_hour, value: this.state.engine_shutoff_time, maskChar: null, name: 'engine_shutoff_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'engine_shutoff_time'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: this.state.style.input_hour, value: this.state.takeoff_land_time, maskChar: null, name: 'takeoff_land_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'takeoff_land_time'), placeholder: '', disabled: true })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: this.state.style.input_hour, value: this.state.total_time, maskChar: null, name: 'total_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'total_time'), placeholder: '', disabled: true })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: this.state.style.input_hour, value: this.state.navigation_time, maskChar: null, name: 'navigation_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'navigation_time'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: this.state.style.input_hour, value: this.state.ifr_time, maskChar: null, name: 'ifr_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'ifr_time'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: this.state.style.input_hour, value: this.state.night_time, maskChar: null, name: 'night_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'night_time'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: this.state.style.input_number, type: 'number', value: this.state.day_landings, name: 'day_landings ', className: 'form-control', onChange: this.handleChange.bind(this, 'day_landings'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: this.state.style.input_number, type: 'number', value: this.state.night_landings, name: 'night_landings ', className: 'form-control', onChange: this.handleChange.bind(this, 'night_landings'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: this.state.style.input_number, type: 'number', value: this.state.starts, name: 'starts ', className: 'form-control', onChange: this.handleChange.bind(this, 'starts'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: this.state.style.input_number, type: 'number', value: this.state.pax, name: 'pax ', className: 'form-control', onChange: this.handleChange.bind(this, 'pax'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: this.state.style.input_number, type: 'number', value: this.state.payload, name: 'payload ', className: 'form-control', onChange: this.handleChange.bind(this, 'payload'), placeholder: '' })
        ),
        this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
            checked: this.state.external_load_long_line,
            'aria-label': 'No label tag',
            name: 'external_load_long_line',
            onChange: this.handleToggleChange.bind(this, 'external_load_long_line') })
        ) : '',
        this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
            checked: this.state.external_load_short_line,
            'aria-label': 'No label tag',
            name: 'external_load_short_line',
            onChange: this.handleToggleChange.bind(this, 'external_load_short_line') })
        ) : '',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: this.state.style.input_fuel || this.state.style.input_number, type: 'number', value: this.state.fuel_start, name: 'fuel_start ', className: 'form-control', onChange: this.handleChange.bind(this, 'fuel_start'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: this.state.style.input_fuel || this.state.style.input_number, type: 'number', value: this.state.fuel_end, name: 'fuel_end ', className: 'form-control', onChange: this.handleChange.bind(this, 'fuel_end'), placeholder: '' })
        ),
        this.state.xml == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
            className: 'form-field-name',
            name: 'ptbr_code_id',
            value: this.state.ptbr_code_id,
            searchable: true,
            placeholder: '',
            onChange: this.handleSelectChange.bind(this, 'ptbr_code_id'),
            options: this.state.ptbr_codes_select,
            style: this.state.style.select_operation
          })
        ) : '',
        Object.keys(this.state.aircraft_model_version_custom_items || {}).length > 0 && Object.keys(this.state.aircraft_model_version_custom_items).map(function (k) {
          var custom_item = _this2.state.aircraft_model_version_custom_items[k];
          if (!custom_item) {
            return null;
          }
          var id = custom_item.id;
          var cellInput = void 0;
          if (custom_item.type === 'text' || custom_item.type === 'number') {
            cellInput = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
              type: custom_item.type,
              name: id,
              id: 'custom-item-id-' + id,
              className: 'form-control',
              style: _this2.state.style.input_custom,
              onChange: function onChange(event) {
                return _this2.handleCustomItem(id, event);
              },
              value: _this2.state.custom_items && _this2.state.custom_items[id] || '',
              placeholder: ''
            });
          } else if (custom_item.type === 'hour') {
            cellInput = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, {
              name: id,
              id: 'custom-item-id-' + id,
              className: 'form-control',
              style: _this2.state.style.input_custom,
              onChange: function onChange(event) {
                return _this2.handleCustomItem(id, event);
              },
              value: _this2.state.custom_items && _this2.state.custom_items[id] || '',
              placeholder: 'hh:mm',
              mask: '99:99'
            });
          } else if (custom_item.type === 'options') {
            var optionValues = Array.isArray(custom_item.options) ? custom_item.options : [];
            cellInput = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'select',
              {
                name: id,
                id: 'custom-item-id-' + id,
                className: 'form-control',
                style: _this2.state.style.input_custom,
                onChange: function onChange(event) {
                  return _this2.handleCustomItem(id, event);
                },
                value: _this2.state.custom_items && _this2.state.custom_items[id] || ''
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'option',
                { value: '' },
                _this2.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.SelecioneOpcao
              ),
              optionValues.map(function (optionValue, optionIndex) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'option',
                  { value: optionValue, key: 'custom-item-option-' + id + '-' + optionIndex },
                  optionValue
                );
              })
            );
          } else {
            cellInput = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
              name: id,
              className: 'form-control',
              style: _this2.state.style.input_custom,
              value: _this2.state.custom_items && _this2.state.custom_items[id] || '',
              onChange: _this2.handleChangeDecimal.bind(_this2, k),
              placeholder: 'hh.m'
            });
          }
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'td',
            { key: 'custom-item-' + id },
            cellInput
          );
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { style: { width: '200px', whiteSpace: 'nowrap', textAlign: 'center' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button', className: 'btn btn-danger button-inline btn-sm', onClick: function onClick() {
                _this2.delete();
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal_flight_following, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloEdicaoTrecho,
              ' - ',
              this.state.leg_number
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return self.setState({ modal_flight_following: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Partida
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'table-responsive' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'table table-bordered table-hover table-striped' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { className: 'text-center col-md-2' },
                      this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Horario
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'col-md-6' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.engine_start_time, maskChar: null, name: 'engine_start_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'engine_start_time'), placeholder: '' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'col-md-6' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'button',
                            { className: 'btn btn-primary button-inline btn-sm form-control', onClick: function onClick() {
                                _this2.autoFillTime('engine_start_time', null);
                              } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-calendar-check-o' })
                          )
                        )
                      )
                    )
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.DEC
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'table-responsive' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'table table-bordered table-hover table-striped' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { className: 'text-center col-md-2' },
                      this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Horario
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'col-md-6' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.takeoff_time, style: { minWidth: '63px' }, maskChar: null, name: 'takeoff_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'takeoff_time'), placeholder: '' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'col-md-6' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'button',
                            { className: 'btn btn-primary button-inline btn-sm form-control', onClick: function onClick() {
                                _this2.autoFillTime('takeoff_time', null);
                              } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-calendar-check-o' })
                          )
                        )
                      )
                    )
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.POU
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'table-responsive' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'table table-bordered table-hover table-striped' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { className: 'text-center col-md-2' },
                      this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Horario
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'col-md-6' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.landing_time, style: { minWidth: '63px' }, maskChar: null, name: 'landing_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'landing_time'), placeholder: '' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'col-md-6' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'button',
                            { className: 'btn btn-primary button-inline btn-sm form-control', onClick: function onClick() {
                                _this2.autoFillTime('landing_time', null);
                              } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-calendar-check-o' })
                          )
                        )
                      )
                    )
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Corte
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'table-responsive' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'table table-bordered table-hover table-striped' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { className: 'text-center col-md-2' },
                      this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Horario
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'row' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'col-md-6' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.engine_shutoff_time, style: { minWidth: '63px' }, maskChar: null, name: 'engine_shutoff_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'engine_shutoff_time'), placeholder: '' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'col-md-6' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'button',
                            { className: 'btn btn-primary button-inline btn-sm form-control', onClick: function onClick() {
                                _this2.autoFillTime('engine_shutoff_time', null);
                              } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-calendar-check-o' })
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  _this2.setState({ modal_flight_following: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return FlightReportLegAddTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportLegAddTab);

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário




var FlightReportLegDelayJustifications = function (_Component) {
  _inherits(FlightReportLegDelayJustifications, _Component);

  function FlightReportLegDelayJustifications(props) {
    _classCallCheck(this, FlightReportLegDelayJustifications);

    var _this = _possibleConstructorReturn(this, (FlightReportLegDelayJustifications.__proto__ || Object.getPrototypeOf(FlightReportLegDelayJustifications)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      justified_time: '00:00:00',
      flight_omni_id: null,
      flight_ptbr_id: null,
      description: null,
      reason_omni: null,
      session_omni: null,
      reason_ptbr: null,
      code_ptbr: null,
      flight_ptbr_selects: [],
      flight_omni_selects: [],
      codes_ptbr_select: [],
      flight_report_leg_delay_edit: {},
      flight_report_leg_delay_justifications: {}
    };

    _this.addJustification = _this.addJustification.bind(_this);
    _this.deleteJustification = _this.deleteJustification.bind(_this);
    _this.exportOmniJustification = _this.exportOmniJustification.bind(_this);
    _this.exportPtbrJustification = _this.exportPtbrJustification.bind(_this);
    return _this;
  }
  // Handlers


  _createClass(FlightReportLegDelayJustifications, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeJustificationPtbr',
    value: function handleSelectChangeJustificationPtbr(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
        this.clearJustificationPtbr();
      } else {
        this.props.handleAlert('', '', 'open');
        change[name] = event.value;

        var datasave = {
          justification_ptbr: event.value
        };

        if (navigator.onLine) {
          var header = this.refs.request_api.header('application/json');
          var self = this;
          Promise.resolve(header).then(function (value) {
            fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/justificativas/ptbr/codigos/lista', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.setState({ codes_ptbr_select: responseJson.data });
              self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
            }).catch(function (error) {
              console.error(error);
            });
          });
        } else {
          window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
        }
      }
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.flight_report_leg_delay_edit.type === 'departure') {
        this.setState({
          flight_ptbr_selects: newProps.ptbr_departure_selects,
          flight_omni_selects: newProps.omni_departure_selects,
          flight_ptbr: newProps.flight_ptbr,
          flight_report_leg_delay_edit: newProps.flight_report_leg_delay_edit,
          justified_time: newProps.flight_report_leg_delay_edit.delay_time_remaining,
          flight_report_leg_delay_justifications: newProps.flight_report_leg_delay_justifications,
          flight_report_leg_delay_id: newProps.flight_report_leg_delay_edit.id
        });
      } else {
        this.setState({
          flight_ptbr_selects: newProps.ptbr_flight_selects,
          flight_omni_selects: newProps.omni_flight_selects,
          flight_ptbr: newProps.flight_ptbr,
          flight_report_leg_delay_edit: newProps.flight_report_leg_delay_edit,
          justified_time: newProps.flight_report_leg_delay_edit.delay_time_remaining,
          flight_report_leg_delay_justifications: newProps.flight_report_leg_delay_justifications,
          flight_report_leg_delay_id: newProps.flight_report_leg_delay_edit.id
        });
      }
    }
  }, {
    key: 'addJustification',
    value: function addJustification(event) {
      event.preventDefault();
      if (navigator.onLine) {
        this.props.handleAlert('', '', 'open');
        var datasave = {
          flight_report_id: this.state.flight_report_leg_delay_edit.flight_report_id,
          flight_report_leg_id: this.state.flight_report_leg_delay_edit.flight_report_leg_id,
          flight_report_leg_delay_id: this.state.flight_report_leg_delay_edit.id,
          justified_time: this.state.justified_time,
          flight_omni_id: this.state.flight_omni_id,
          flight_ptbr_id: this.state.flight_ptbr_id,
          description: this.state.description,
          code_ptbr: this.state.code_ptbr
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/atraso/justificativa', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.refreshJustificationsModal(responseJson);
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'deleteJustification',
    value: function deleteJustification(id) {
      if (navigator.onLine) {
        if (window.confirm('Tem certeza que gostaria de remover esta justificativa atraso?')) {
          this.props.handleAlert('', '', 'open');
          var datasave = {
            id: id
          };
          var header = this.refs.request_api.header('application/json');
          var self = this;
          Promise.resolve(header).then(function (value) {
            fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/atraso/justificativa', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.refs.request_api.validate(responseJson, 'alert');
              self.props.refreshJustificationsModal(responseJson);
              self.props.handleAlert(responseJson.message, responseJson.status, 'open');
            }).catch(function (error) {
              console.error(error);
            });
          });
        }
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'exportOmniJustification',
    value: function exportOmniJustification() {
      if (navigator.onLine) {
        var self = this;
        var url = "/exportar/justificativas/omni";
        var header = this.refs.request_api.header('application/json');
        this.props.handleAlert('', '', 'open');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'url');
            if (responseJson.status === 'success') {
              var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data;
              window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data);
              self.props.handleAlert('', '', 'closed');
            }
          });
        });
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'exportPtbrJustification',
    value: function exportPtbrJustification() {
      if (navigator.onLine) {
        var self = this;
        var url = "/exportar/justificativas/ptbr";
        var header = this.refs.request_api.header('application/json');
        this.props.handleAlert('', '', 'open');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'url');
            if (responseJson.status === 'success') {
              var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data;
              window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data);
              self.props.handleAlert('', '', 'closed');
            }
          });
        });
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: this.addJustification },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'button', onClick: function onClick() {
                      return _this2.exportOmniJustification();
                    }, className: 'btn btn-success btn-xs' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' })
                ),
                ' Justificativa OMNI:'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'flight_omni_id',
                value: this.state.flight_omni_id,
                searchable: true,
                placeholder: '',
                onChange: this.handleSelectChange.bind(this, 'flight_omni_id'),
                options: this.state.flight_omni_selects,
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Atraso justificado:'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.justified_time, maskChar: null, name: 'justified_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'justified_time'), placeholder: '', required: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Descri\xE7\xE3o do atraso:'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: this.state.description, maskChar: null, name: 'description', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'description'), placeholder: '', required: true })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
            ' Adicionar justificativa'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          'Raz\xF5es cadastradas'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Tempo justificado'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Descri\xE7\xE3o'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Justificativa OMNI'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Motivo OMNI'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Setor OMNI'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'A\xE7\xF5es'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              null,
              Object.keys(self.state.flight_report_leg_delay_justifications).map(function (k) {
                var srldj = self.state.flight_report_leg_delay_justifications[k];
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srldj.justified_time
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srldj.description
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srldj.flight_omni.name
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srldj.flight_omni.reason
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srldj.flight_omni.session
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { onClick: function onClick() {
                          return self.deleteJustification(srldj.id);
                        }, className: 'btn btn-danger btn-sm' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-trash' })
                    )
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);

  return FlightReportLegDelayJustifications;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportLegDelayJustifications);

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FlightReportLegDelayJustifications__ = __webpack_require__(841);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário







var FlightReportLegDelaysTab = function (_Component) {
  _inherits(FlightReportLegDelaysTab, _Component);

  function FlightReportLegDelaysTab(props) {
    _classCallCheck(this, FlightReportLegDelaysTab);

    var _this = _possibleConstructorReturn(this, (FlightReportLegDelaysTab.__proto__ || Object.getPrototypeOf(FlightReportLegDelaysTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      modal: false,
      flight_report_id: _this.props.flight_report_id,
      flight_report_leg_delays: _this.props.flight_report_leg_delays,
      flight_report_leg_delay_justifications: _this.props.flight_report_leg_delay_justifications,
      flight_ptbr_selects: [],
      flight_omni_selects: [],
      flight_report_leg_delay_edit: {}
    };

    //bind específico
    _this.delete = _this.delete.bind(_this);
    _this.openEditModal = _this.openEditModal.bind(_this);
    _this.closeModal = _this.closeModal.bind(_this);
    _this.refreshJustificationsModal = _this.refreshJustificationsModal.bind(_this);
    return _this;
  }
  // Handlers


  _createClass(FlightReportLegDelaysTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (typeof this.state.fuel_type === 'undefined' || this.state.loaded === 1 && newProps.updated === 1) {
        this.setState({
          flight_report_id: newProps.flight_report_id,
          flight_report_leg_delays: newProps.flight_report_leg_delays,
          flight_ptbr_selects: newProps.flight_ptbr_selects,
          flight_omni_selects: newProps.flight_omni_selects,
          ptbr_departure_selects: newProps.ptbr_departure_selects,
          omni_departure_selects: newProps.omni_departure_selects,
          ptbr_flight_selects: newProps.ptbr_flight_selects,
          omni_flight_selects: newProps.omni_flight_selects,
          loaded: 1
        });
      }
    }
  }, {
    key: 'delete',
    value: function _delete(id) {
      if (navigator.onLine) {
        if (window.confirm('Tem certeza que deseja excluir esse atraso?')) {
          this.props.handleAlert('', '', 'open');
          var datasave = {
            id: id
          };
          var header = this.refs.request_api.header('application/json');
          var self = this;
          Promise.resolve(header).then(function (value) {
            fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/atraso', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.refs.request_api.validate(responseJson, 'alert');
              self.props.updateData(responseJson);
            }).catch(function (error) {
              console.error(error);
            });
          });
        }
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'openEditModal',
    value: function openEditModal(id) {
      var self = this;
      Object.keys(this.state.flight_report_leg_delays).map(function (k) {
        if (self.state.flight_report_leg_delays[k].id == id) {
          self.setState({
            modal: true,
            flight_report_leg_delay_edit: self.state.flight_report_leg_delays[k],
            flight_report_leg_delay_justifications: self.state.flight_report_leg_delays[k].flight_report_leg_delay_justifications
          });
        }
      });
    }
  }, {
    key: 'closeModal',
    value: function closeModal(responseJson) {
      this.props.handleAlert('', '', 'open');
      this.setState({
        modal: false,
        flight_report_leg_delay_edit: {},
        flight_report_leg_delay_justifications: {}
      }, this.props.updateData({ message: 'Dados atualizados com sucesso', status: 'success', data: {} }));
    }
  }, {
    key: 'refreshJustificationsModal',
    value: function refreshJustificationsModal(responseJson) {
      this.setState({
        flight_report_leg_delay_justifications: responseJson.data
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          'Atrasos'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Trecho'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Tipo'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Atraso total'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'col-md-1 text-center' },
                  'A\xE7\xF5es'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              null,
              Object.keys(self.state.flight_report_leg_delays).map(function (k) {
                var srld = self.state.flight_report_leg_delays[k];
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srld.flight_report_leg.leg_number
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srld.type_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srld.total_delay_time
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { onClick: function onClick() {
                          return self.delete(srld.id);
                        }, className: 'btn btn-danger btn-sm' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-trash' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { onClick: function onClick() {
                          return self.openEditModal(srld.id);
                        }, className: 'btn btn-primary btn-sm' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-pencil' })
                    )
                  )
                );
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              'Justificativas'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: this.closeModal },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FlightReportLegDelayJustifications__["a" /* default */], { updateData: this.props.updateData, updated: this.props.updated, handleAlert: this.props.handleAlert, flight_ptbr_selects: this.props.flight_ptbr_selects, flight_omni_selects: this.props.flight_omni_selects, codes_ptbr_select: this.props.codes_ptbr_select, flight_report_leg_delay_edit: this.state.flight_report_leg_delay_edit, flight_report_leg_delay_justifications: this.state.flight_report_leg_delay_justifications, refreshJustificationsModal: this.refreshJustificationsModal, ptbr_departure_selects: this.state.ptbr_departure_selects, ptbr_flight_selects: this.state.ptbr_flight_selects, omni_departure_selects: this.state.omni_departure_selects, omni_flight_selects: this.state.omni_flight_selects })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: this.closeModal },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return FlightReportLegDelaysTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (FlightReportLegDelaysTab);

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__ = __webpack_require__(3);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário








var FlightReportLegEditTab = function (_Component) {
  _inherits(FlightReportLegEditTab, _Component);

  function FlightReportLegEditTab(props) {
    _classCallCheck(this, FlightReportLegEditTab);

    var _this = _possibleConstructorReturn(this, (FlightReportLegEditTab.__proto__ || Object.getPrototypeOf(FlightReportLegEditTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      updated: false,
      modal: false,
      modal_flight_following: false,
      id: null,
      staff_id: null,
      duty_id: null,
      flight_report_id: null,
      departure_location_id: null,
      arrival_location_id: null,
      leg_number: null,
      takeoff_time_scheduled: null,
      total_time_scheduled: null,
      engine_start_time: null,
      takeoff_time: null,
      landing_time: null,
      engine_shutoff_time: null,
      takeoff_land_time: null,
      total_time: '00:00:00',
      navigation_time: '00:00:00',
      ifr_time: '00:00:00',
      night_time: '00:00:00',
      day_landings: 0,
      night_landings: 0,
      starts: null,
      pax: 0,
      payload: 0,
      external_load_long_line: 0,
      external_load_short_line: 0,
      fuel_start: 0,
      fuel_end: 0,
      ptbr_code_id: null,
      ptbr_operation_id: null,
      ptbr_external_load_id: null,
      delay_time: null,
      delay_departure: null,
      locations_select: [],
      ptbr_codes_select: [],
      ptbr_operations_select: [],
      ptbr_external_loads_select: [],
      duties_select: [],
      staffs_select: [],
      flight_report_leg_edit: {},
      flight_report_leg_edit_staffs: {},
      aircraft_model_version_custom_items: {},
      custom_items: {},
      style: {},
      edited: false,
      handle_edited: false
    };

    _this.edit = _this.edit.bind(_this);
    _this.editMobile = _this.editMobile.bind(_this);
    _this.delete = _this.delete.bind(_this);
    _this.addStaff = _this.addStaff.bind(_this);
    _this.deleteStaff = _this.deleteStaff.bind(_this);
    _this.diffFlight = _this.diffFlight.bind(_this);
    _this.diffTotalTime = _this.diffTotalTime.bind(_this);
    _this.delayFlight = _this.delayFlight.bind(_this);
    _this.delayTotalTime = _this.delayTotalTime.bind(_this);
    _this.calcTimeFromMs = _this.calcTimeFromMs.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__["a" /* default */])();
    _this.autoFillTime = _this.autoFillTime.bind(_this);
    _this.cleanLeg = _this.cleanLeg.bind(_this);
    _this.propsHandling = _this.propsHandling.bind(_this);
    _this.handleCustomItem = _this.handleCustomItem.bind(_this);
    _this.handleChangeDecimal = _this.handleChangeDecimal.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(FlightReportLegEditTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change['handle_edited'] = true;
      change['edited'] = true;
      change[name] = event.target.value;
      if (name === 'takeoff_time') {
        this.diffFlight(event.target.value, this.state.landing_time, change);
        this.delayFlight(event.target.value, this.state.takeoff_time_scheduled, change);
        this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, event.target.value, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'landing_time') {
        this.diffFlight(this.state.takeoff_time, event.target.value, change);
        this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, this.state.takeoff_time, event.target.value, this.state.start_parameter_total, change);
      } else if (name === 'engine_start_time') {
        this.diffTotalTime(event.target.value, this.state.engine_shutoff_time, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'engine_shutoff_time') {
        this.diffTotalTime(this.state.engine_start_time, event.target.value, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'takeoff_time_scheduled') {
        this.delayFlight(this.state.takeoff_time, event.target.value, change);
      } else if (name === 'total_time_scheduled') {
        this.delayTotalTime(event.target.value, this.state.takeoff_land_time, change);
      } else {
        this.setState(change);
      }
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      change['handle_edited'] = true;
      change['edited'] = true;
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      change['handle_edited'] = true;
      change['edited'] = true;
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.handle_edited) {
        var cached_flight_report_legs_states_by_id = {};
        if (localStorage.getItem("cached_flight_report_legs_states_by_id")) {
          cached_flight_report_legs_states_by_id = localStorage.getItem("cached_flight_report_legs_states_by_id");
          cached_flight_report_legs_states_by_id = JSON.parse(cached_flight_report_legs_states_by_id);
        }

        cached_flight_report_legs_states_by_id[this.state.id] = {
          'id': this.state.id,
          'takeoff_time_scheduled': this.state.takeoff_time_scheduled,
          'total_time_scheduled': this.state.total_time_scheduled,
          'engine_start_time': this.state.engine_start_time,
          'takeoff_time': this.state.takeoff_time,
          'landing_time': this.state.landing_time,
          'engine_shutoff_time': this.state.engine_shutoff_time,
          'takeoff_land_time': this.state.takeoff_land_time,
          'flight_following_engine_start_time': this.state.flight_following_engine_start_time,
          'flight_following_takeoff_time': this.state.flight_following_takeoff_time,
          'flight_following_landing_time': this.state.flight_following_landing_time,
          'flight_following_engine_shutoff_time': this.state.flight_following_engine_shutoff_time,
          'total_time': this.state.total_time,
          'navigation_time': this.state.navigation_time,
          'ifr_time': this.state.ifr_time,
          'night_time': this.state.night_time,
          'start_parameter_total': this.state.start_parameter_total,
          'xml': this.state.xml,
          'external_load': this.state.external_load,
          'flight_report_id': this.state.flight_report_id,
          'departure_location_id': this.state.departure_location_id,
          'arrival_location_id': this.state.arrival_location_id,
          'day_landings': this.state.day_landings,
          'night_landings': this.state.night_landings,
          'starts': this.state.starts,
          'pax': this.state.pax,
          'payload': this.state.payload,
          'external_load_long_line': this.state.external_load_long_line,
          'external_load_short_line': this.state.external_load_short_line,
          'fuel_start': this.state.fuel_start,
          'fuel_end': this.state.fuel_end,
          'ptbr_code_id': this.state.ptbr_code_id,
          'ptbr_operation_id': this.state.ptbr_operation_id,
          'ptbr_external_load_id': this.state.ptbr_external_load_id,
          'delay_departure': this.state.delay_departure,
          'delay_time': this.state.delay_time,
          'leg_number': this.state.leg_number,
          'edited': true
        };

        this.setState({ handle_edited: false });

        localStorage.setItem("cached_flight_report_legs_states_by_id", JSON.stringify(cached_flight_report_legs_states_by_id));
      }
    }

    // LM

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!navigator.onLine) {
        this.propsHandling(this.props);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === false || newProps.updated === 1) {

        this.propsHandling(newProps);
        if (newProps.flight_report_leg_edit.edited) {
          this.setState({
            flight_report_leg_edit_staffs: newProps.flight_report_leg_edit_staffs,
            locations_select: newProps.locations_select,
            ptbr_codes_select: newProps.ptbr_codes_select,
            ptbr_operations_select: newProps.ptbr_operations_select,
            ptbr_external_loads_select: newProps.ptbr_external_loads_select,
            staffs_select: newProps.staffs_select,
            duties_select: newProps.duties_select,
            style: newProps.style,
            date: newProps.date,
            id: newProps.flight_report_leg_edit.id,
            flight_report_id: newProps.flight_report_leg_edit.flight_report_id,
            departure_location_id: newProps.flight_report_leg_edit.departure_location_id,
            arrival_location_id: newProps.flight_report_leg_edit.arrival_location_id,
            takeoff_time_scheduled: newProps.flight_report_leg_edit.takeoff_time_scheduled,
            total_time_scheduled: newProps.flight_report_leg_edit.total_time_scheduled,
            engine_start_time: newProps.flight_report_leg_edit.engine_start_time,
            takeoff_time: newProps.flight_report_leg_edit.takeoff_time,
            landing_time: newProps.flight_report_leg_edit.landing_time,
            engine_shutoff_time: newProps.flight_report_leg_edit.engine_shutoff_time,
            takeoff_land_time: newProps.flight_report_leg_edit.takeoff_land_time,
            flight_following_engine_start_time: newProps.flight_report_leg_edit.flight_following_engine_start_time,
            flight_following_takeoff_time: newProps.flight_report_leg_edit.flight_following_takeoff_time,
            flight_following_landing_time: newProps.flight_report_leg_edit.flight_following_landing_time,
            flight_following_engine_shutoff_time: newProps.flight_report_leg_edit.flight_following_engine_shutoff_time,
            total_time: newProps.flight_report_leg_edit.total_time,
            navigation_time: newProps.flight_report_leg_edit.navigation_time,
            ifr_time: newProps.flight_report_leg_edit.ifr_time,
            night_time: newProps.flight_report_leg_edit.night_time,
            day_landings: newProps.flight_report_leg_edit.day_landings,
            night_landings: newProps.flight_report_leg_edit.night_landings,
            starts: newProps.flight_report_leg_edit.starts,
            pax: newProps.flight_report_leg_edit.pax,
            payload: newProps.flight_report_leg_edit.payload,
            external_load_long_line: newProps.flight_report_leg_edit.external_load_long_line,
            external_load_short_line: newProps.flight_report_leg_edit.external_load_short_line,
            fuel_start: newProps.flight_report_leg_edit.fuel_start,
            fuel_end: newProps.flight_report_leg_edit.fuel_end,
            ptbr_code_id: newProps.flight_report_leg_edit.ptbr_code_id,
            ptbr_operation_id: newProps.flight_report_leg_edit.ptbr_operation_id,
            ptbr_external_load_id: newProps.flight_report_leg_edit.ptbr_external_load_id,
            delay_departure: newProps.flight_report_leg_edit.delay_departure,
            delay_time: newProps.flight_report_leg_edit.delay_time,
            leg_number: newProps.flight_report_leg_edit.leg_number,
            start_parameter_total: newProps.flight_report_leg_edit.start_parameter_total,
            xml: newProps.flight_report_leg_edit.xml,
            external_load: newProps.flight_report_leg_edit.external_load,
            aircraft_model_version_custom_items: newProps.aircraft_model_version_custom_items || {},
            custom_items: function () {
              var ci = {};
              if (newProps.flight_report_leg_edit && newProps.flight_report_leg_edit.flight_report_leg_custom_items) {
                Object.keys(newProps.flight_report_leg_edit.flight_report_leg_custom_items).map(function (k) {
                  var it = newProps.flight_report_leg_edit.flight_report_leg_custom_items[k];
                  ci[it.aircraft_model_version_custom_item_id] = it.value;
                });
              }
              return ci;
            }(),
            loaded: 1,
            updated: false,
            edited: true
          });
        } else {
          var takeoff_time_scheduled = newProps.flight_report_leg_edit.takeoff_time_scheduled_str;if (takeoff_time_scheduled === null) takeoff_time_scheduled = '';
          var total_time_scheduled = newProps.flight_report_leg_edit.total_time_scheduled;if (total_time_scheduled === null) total_time_scheduled = '';
          var engine_start_time = newProps.flight_report_leg_edit.engine_start_time_str;if (engine_start_time === null) engine_start_time = '';
          var takeoff_time = newProps.flight_report_leg_edit.takeoff_time_str;if (takeoff_time === null) takeoff_time = '';
          var landing_time = newProps.flight_report_leg_edit.landing_time_str;if (landing_time === null) landing_time = '';
          var engine_shutoff_time = newProps.flight_report_leg_edit.engine_shutoff_time_str;if (engine_shutoff_time === null) engine_shutoff_time = '';
          var takeoff_land_time = newProps.flight_report_leg_edit.takeoff_land_time;if (takeoff_land_time === null) takeoff_land_time = '';
          var flight_following_engine_start_time = newProps.flight_report_leg_edit.flight_following_engine_start_time_str;if (flight_following_engine_start_time === null) flight_following_engine_start_time = '';
          var flight_following_takeoff_time = newProps.flight_report_leg_edit.flight_following_takeoff_time_str;if (flight_following_takeoff_time === null) flight_following_takeoff_time = '';
          var flight_following_landing_time = newProps.flight_report_leg_edit.flight_following_landing_time_str;if (flight_following_landing_time === null) flight_following_landing_time = '';
          var flight_following_engine_shutoff_time = newProps.flight_report_leg_edit.flight_following_engine_shutoff_time_str;if (flight_following_engine_shutoff_time === null) flight_following_engine_shutoff_time = '';
          var total_time = newProps.flight_report_leg_edit.total_time;if (total_time === null) total_time = '';
          var navigation_time = newProps.flight_report_leg_edit.navigation_time;if (navigation_time === null) navigation_time = '';
          var ifr_time = newProps.flight_report_leg_edit.ifr_time;if (ifr_time === null) ifr_time = '';
          var night_time = newProps.flight_report_leg_edit.night_time;if (night_time === null) night_time = '';

          this.setState({
            flight_report_leg_edit_staffs: newProps.flight_report_leg_edit_staffs,
            locations_select: newProps.locations_select,
            ptbr_codes_select: newProps.ptbr_codes_select,
            ptbr_operations_select: newProps.ptbr_operations_select,
            ptbr_external_loads_select: newProps.ptbr_external_loads_select,
            staffs_select: newProps.staffs_select,
            duties_select: newProps.duties_select,
            style: newProps.style,
            date: newProps.date,
            id: newProps.flight_report_leg_edit.id,
            flight_report_id: newProps.flight_report_leg_edit.flight_report_id,
            departure_location_id: newProps.flight_report_leg_edit.departure_location_id,
            arrival_location_id: newProps.flight_report_leg_edit.arrival_location_id,
            takeoff_time_scheduled: takeoff_time_scheduled,
            total_time_scheduled: total_time_scheduled,
            engine_start_time: engine_start_time,
            takeoff_time: takeoff_time,
            landing_time: landing_time,
            engine_shutoff_time: engine_shutoff_time,
            takeoff_land_time: takeoff_land_time,
            flight_following_engine_start_time: flight_following_engine_start_time,
            flight_following_takeoff_time: flight_following_takeoff_time,
            flight_following_landing_time: flight_following_landing_time,
            flight_following_engine_shutoff_time: flight_following_engine_shutoff_time,
            total_time: total_time,
            navigation_time: navigation_time,
            ifr_time: ifr_time,
            night_time: night_time,
            day_landings: newProps.flight_report_leg_edit.day_landings,
            night_landings: newProps.flight_report_leg_edit.night_landings,
            starts: newProps.flight_report_leg_edit.starts,
            pax: newProps.flight_report_leg_edit.pax,
            payload: newProps.flight_report_leg_edit.payload,
            external_load_long_line: newProps.flight_report_leg_edit.external_load_long_line,
            external_load_short_line: newProps.flight_report_leg_edit.external_load_short_line,
            fuel_start: newProps.flight_report_leg_edit.fuel_start,
            fuel_end: newProps.flight_report_leg_edit.fuel_end,
            ptbr_code_id: newProps.flight_report_leg_edit.ptbr_code_id,
            ptbr_operation_id: newProps.flight_report_leg_edit.ptbr_operation_id,
            ptbr_external_load_id: newProps.flight_report_leg_edit.ptbr_external_load_id,
            delay_departure: newProps.flight_report_leg_edit.delay_departure,
            delay_time: newProps.flight_report_leg_edit.delay_time,
            leg_number: newProps.flight_report_leg_edit.leg_number,
            start_parameter_total: newProps.start_parameter_total,
            xml: newProps.xml,
            external_load: newProps.external_load,
            aircraft_model_version_custom_items: newProps.aircraft_model_version_custom_items || {},
            custom_items: function () {
              var ci = {};
              if (newProps.flight_report_leg_edit && newProps.flight_report_leg_edit.flight_report_leg_custom_items) {
                Object.keys(newProps.flight_report_leg_edit.flight_report_leg_custom_items).map(function (k) {
                  var it = newProps.flight_report_leg_edit.flight_report_leg_custom_items[k];
                  ci[it.aircraft_model_version_custom_item_id] = it.value;
                });
              }
              return ci;
            }(),
            loaded: 1,
            updated: false,
            edited: false
          });
        }
      }
    }
  }, {
    key: 'propsHandling',
    value: function propsHandling(props) {
      if (props.flight_report_leg_edit.edited) {
        this.setState({
          flight_report_leg_edit_staffs: props.flight_report_leg_edit_staffs,
          locations_select: props.locations_select,
          ptbr_codes_select: props.ptbr_codes_select,
          ptbr_operations_select: props.ptbr_operations_select,
          ptbr_external_loads_select: props.ptbr_external_loads_select,
          staffs_select: props.staffs_select,
          duties_select: props.duties_select,
          style: props.style,
          date: props.date,
          id: props.flight_report_leg_edit.id,
          flight_report_id: props.flight_report_leg_edit.flight_report_id,
          departure_location_id: props.flight_report_leg_edit.departure_location_id,
          arrival_location_id: props.flight_report_leg_edit.arrival_location_id,
          takeoff_time_scheduled: props.flight_report_leg_edit.takeoff_time_scheduled,
          total_time_scheduled: props.flight_report_leg_edit.total_time_scheduled,
          engine_start_time: props.flight_report_leg_edit.engine_start_time,
          takeoff_time: props.flight_report_leg_edit.takeoff_time,
          landing_time: props.flight_report_leg_edit.landing_time,
          engine_shutoff_time: props.flight_report_leg_edit.engine_shutoff_time,
          takeoff_land_time: props.flight_report_leg_edit.takeoff_land_time,
          flight_following_engine_start_time: props.flight_report_leg_edit.flight_following_engine_start_time,
          flight_following_takeoff_time: props.flight_report_leg_edit.flight_following_takeoff_time,
          flight_following_landing_time: props.flight_report_leg_edit.flight_following_landing_time,
          flight_following_engine_shutoff_time: props.flight_report_leg_edit.flight_following_engine_shutoff_time,
          total_time: props.flight_report_leg_edit.total_time,
          navigation_time: props.flight_report_leg_edit.navigation_time,
          ifr_time: props.flight_report_leg_edit.ifr_time,
          night_time: props.flight_report_leg_edit.night_time,
          day_landings: props.flight_report_leg_edit.day_landings,
          night_landings: props.flight_report_leg_edit.night_landings,
          starts: props.flight_report_leg_edit.starts,
          pax: props.flight_report_leg_edit.pax,
          payload: props.flight_report_leg_edit.payload,
          external_load_long_line: props.flight_report_leg_edit.external_load_long_line,
          external_load_short_line: props.flight_report_leg_edit.external_load_short_line,
          fuel_start: props.flight_report_leg_edit.fuel_start,
          fuel_end: props.flight_report_leg_edit.fuel_end,
          ptbr_code_id: props.flight_report_leg_edit.ptbr_code_id,
          ptbr_operation_id: props.flight_report_leg_edit.ptbr_operation_id,
          ptbr_external_load_id: props.flight_report_leg_edit.ptbr_external_load_id,
          delay_departure: props.flight_report_leg_edit.delay_departure,
          delay_time: props.flight_report_leg_edit.delay_time,
          leg_number: props.flight_report_leg_edit.leg_number,
          start_parameter_total: props.flight_report_leg_edit.start_parameter_total,
          xml: props.flight_report_leg_edit.xml,
          external_load: props.flight_report_leg_edit.external_load,
          loaded: 1,
          updated: false,
          edited: true
        });
      } else {
        var takeoff_time_scheduled = props.flight_report_leg_edit.takeoff_time_scheduled_str;if (takeoff_time_scheduled === null) takeoff_time_scheduled = '';
        var total_time_scheduled = props.flight_report_leg_edit.total_time_scheduled;if (total_time_scheduled === null) total_time_scheduled = '';
        var engine_start_time = props.flight_report_leg_edit.engine_start_time_str;if (engine_start_time === null) engine_start_time = '';
        var takeoff_time = props.flight_report_leg_edit.takeoff_time_str;if (takeoff_time === null) takeoff_time = '';
        var landing_time = props.flight_report_leg_edit.landing_time_str;if (landing_time === null) landing_time = '';
        var engine_shutoff_time = props.flight_report_leg_edit.engine_shutoff_time_str;if (engine_shutoff_time === null) engine_shutoff_time = '';
        var takeoff_land_time = props.flight_report_leg_edit.takeoff_land_time;if (takeoff_land_time === null) takeoff_land_time = '';
        var flight_following_engine_start_time = props.flight_report_leg_edit.flight_following_engine_start_time_str;if (flight_following_engine_start_time === null) flight_following_engine_start_time = '';
        var flight_following_takeoff_time = props.flight_report_leg_edit.flight_following_takeoff_time_str;if (flight_following_takeoff_time === null) flight_following_takeoff_time = '';
        var flight_following_landing_time = props.flight_report_leg_edit.flight_following_landing_time_str;if (flight_following_landing_time === null) flight_following_landing_time = '';
        var flight_following_engine_shutoff_time = props.flight_report_leg_edit.flight_following_engine_shutoff_time_str;if (flight_following_engine_shutoff_time === null) flight_following_engine_shutoff_time = '';
        var total_time = props.flight_report_leg_edit.total_time;if (total_time === null) total_time = '';
        var navigation_time = props.flight_report_leg_edit.navigation_time;if (navigation_time === null) navigation_time = '';
        var ifr_time = props.flight_report_leg_edit.ifr_time;if (ifr_time === null) ifr_time = '';
        var night_time = props.flight_report_leg_edit.night_time;if (night_time === null) night_time = '';

        this.setState({
          flight_report_leg_edit_staffs: props.flight_report_leg_edit_staffs,
          locations_select: props.locations_select,
          ptbr_codes_select: props.ptbr_codes_select,
          ptbr_operations_select: props.ptbr_operations_select,
          ptbr_external_loads_select: props.ptbr_external_loads_select,
          staffs_select: props.staffs_select,
          duties_select: props.duties_select,
          style: props.style,
          date: props.date,
          id: props.flight_report_leg_edit.id,
          flight_report_id: props.flight_report_leg_edit.flight_report_id,
          departure_location_id: props.flight_report_leg_edit.departure_location_id,
          arrival_location_id: props.flight_report_leg_edit.arrival_location_id,
          takeoff_time_scheduled: takeoff_time_scheduled,
          total_time_scheduled: total_time_scheduled,
          engine_start_time: engine_start_time,
          takeoff_time: takeoff_time,
          landing_time: landing_time,
          engine_shutoff_time: engine_shutoff_time,
          takeoff_land_time: takeoff_land_time,
          flight_following_engine_start_time: flight_following_engine_start_time,
          flight_following_takeoff_time: flight_following_takeoff_time,
          flight_following_landing_time: flight_following_landing_time,
          flight_following_engine_shutoff_time: flight_following_engine_shutoff_time,
          total_time: total_time,
          navigation_time: navigation_time,
          ifr_time: ifr_time,
          night_time: night_time,
          day_landings: props.flight_report_leg_edit.day_landings,
          night_landings: props.flight_report_leg_edit.night_landings,
          starts: props.flight_report_leg_edit.starts,
          pax: props.flight_report_leg_edit.pax,
          payload: props.flight_report_leg_edit.payload,
          external_load_long_line: props.flight_report_leg_edit.external_load_long_line,
          external_load_short_line: props.flight_report_leg_edit.external_load_short_line,
          fuel_start: props.flight_report_leg_edit.fuel_start,
          fuel_end: props.flight_report_leg_edit.fuel_end,
          ptbr_code_id: props.flight_report_leg_edit.ptbr_code_id,
          ptbr_operation_id: props.flight_report_leg_edit.ptbr_operation_id,
          ptbr_external_load_id: props.flight_report_leg_edit.ptbr_external_load_id,
          delay_departure: props.flight_report_leg_edit.delay_departure,
          delay_time: props.flight_report_leg_edit.delay_time,
          leg_number: props.flight_report_leg_edit.leg_number,
          start_parameter_total: props.start_parameter_total,
          xml: props.xml,
          external_load: props.external_load,
          loaded: 1,
          updated: false,
          edited: false
        });
      }
    }
  }, {
    key: 'autoFillTime',
    value: function autoFillTime(name, value) {
      var now = __WEBPACK_IMPORTED_MODULE_7_moment___default()(new Date());
      now = now.format("HH:mm");

      if (value !== null) {
        now = value;
      }

      var change = {};
      change[name] = now;
      change['handle_edited'] = true;
      change['edited'] = true;

      if (name === 'takeoff_time') {
        this.diffFlight(now, this.state.landing_time, change);
        this.delayFlight(now, this.state.takeoff_scheduled, change);
        this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, now, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'landing_time') {
        this.diffFlight(this.state.takeoff_time, now, change);
        this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, this.state.takeoff_time, now, this.state.start_parameter_total, change);
      } else if (name === 'engine_start_time') {
        this.diffTotalTime(now, this.state.engine_shutoff_time, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'engine_shutoff_time') {
        this.diffTotalTime(this.state.engine_start_time, now, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'takeoff_scheduled') {
        this.delayFlight(this.state.takeoff_time, now, change);
      } else if (name === 'total_time_preview') {
        this.delayTotalTime(now, this.state.takeoff_land_time, change);
      } else {
        this.setState(change);
      }
    }
  }, {
    key: 'diffFlight',
    value: function diffFlight(takeoff_time, landing_time, change) {
      if (takeoff_time && landing_time && takeoff_time !== '' && landing_time !== '') {
        takeoff_time = this.state.date + ' ' + takeoff_time;
        landing_time = this.state.date + ' ' + landing_time;

        takeoff_time = __WEBPACK_IMPORTED_MODULE_7_moment___default()(takeoff_time, "DD/MM/YYYY HH:mm:ss");
        landing_time = __WEBPACK_IMPORTED_MODULE_7_moment___default()(landing_time, "DD/MM/YYYY HH:mm:ss");

        if (takeoff_time > landing_time) {
          landing_time.add(1, 'd');
        }

        takeoff_time = new Date(takeoff_time.format("YYYY-MM-DD HH:mm:ss"));
        landing_time = new Date(landing_time.format("YYYY-MM-DD HH:mm:ss"));
        var diffTime = Math.abs(landing_time.getTime() - takeoff_time.getTime());
        if (landing_time > takeoff_time) {
          change['takeoff_land_time'] = this.calcTimeFromMs(diffTime);
          change['navigation_time'] = this.calcTimeFromMs(diffTime);
        } else {
          change['takeoff_land_time'] = '00:00';
          change['navigation_time'] = '00:00';
        }
      } else {
        change['takeoff_land_time'] = '00:00';
        change['navigation_time'] = '00:00';
      }
      this.delayTotalTime(this.state.total_time_scheduled, change['takeoff_land_time'], change);
    }
  }, {
    key: 'diffTotalTime',
    value: function diffTotalTime(engine_start_time, engine_shutoff_time, takeoff_time, landing_time, start_parameter_total, change) {
      var start = null;
      if (engine_start_time !== null && engine_start_time !== '' && typeof engine_start_time !== 'undefined') {
        start = engine_start_time;
      } else if (start_parameter_total !== null) {
        start = start_parameter_total.substring(11);
      }

      if (engine_start_time !== null && engine_start_time !== '' && typeof engine_start_time !== 'undefined') {
        start = engine_start_time;
      }

      var finish = null;
      if (landing_time !== null && landing_time !== '' && typeof landing_time !== 'undefined') {
        finish = landing_time;
      }
      if (engine_shutoff_time !== null && engine_shutoff_time !== '' && typeof engine_shutoff_time !== 'undefined') {
        finish = engine_shutoff_time;
      }

      if (start && finish) {
        start = this.state.date + ' ' + start;
        finish = this.state.date + ' ' + finish;

        start = __WEBPACK_IMPORTED_MODULE_7_moment___default()(start, "DD/MM/YYYY HH:mm:ss");
        finish = __WEBPACK_IMPORTED_MODULE_7_moment___default()(finish, "DD/MM/YYYY HH:mm:ss");

        if (start > finish) {
          finish.add(1, 'd');
        }

        start = new Date(start.format("YYYY-MM-DD HH:mm:ss"));
        finish = new Date(finish.format("YYYY-MM-DD HH:mm:ss"));

        var diffTime = Math.abs(finish.getTime() - start.getTime());
        if (finish > start) {
          change['total_time'] = this.calcTimeFromMs(diffTime);
        } else {
          change['total_time'] = '00:00';
        }
        this.setState(change);
      } else {
        change['total_time'] = '00:00';
        this.setState(change);
      }
    }
  }, {
    key: 'delayFlight',
    value: function delayFlight(takeoff_time, takeoff_time_scheduled, change) {
      if (takeoff_time_scheduled) {
        takeoff_time = this.state.date + ' ' + takeoff_time;
        takeoff_time_scheduled = this.state.date + ' ' + takeoff_time_scheduled;

        takeoff_time = __WEBPACK_IMPORTED_MODULE_7_moment___default()(takeoff_time, "DD/MM/YYYY HH:mm:ss");
        takeoff_time_scheduled = __WEBPACK_IMPORTED_MODULE_7_moment___default()(takeoff_time_scheduled, "DD/MM/YYYY HH:mm:ss");

        var diff_hours = takeoff_time_scheduled.diff(takeoff_time, 'hours');

        if (takeoff_time < takeoff_time_scheduled && diff_hours > 12) {
          takeoff_time.add(1, 'd');
        }

        takeoff_time = new Date(takeoff_time.format("YYYY-MM-DD HH:mm:ss"));
        takeoff_time_scheduled = new Date(takeoff_time_scheduled.format("YYYY-MM-DD HH:mm:ss"));
        var diffTime = Math.abs(takeoff_time.getTime() - takeoff_time_scheduled.getTime());
        if (takeoff_time > takeoff_time_scheduled) {
          change['delay_departure'] = this.calcTimeFromMs(diffTime);
        } else {
          change['delay_departure'] = '00:00';
        }
      } else {
        change['delay_departure'] = '00:00';
      }
      this.setState(change);
    }
  }, {
    key: 'delayTotalTime',
    value: function delayTotalTime(total_time_scheduled, takeoff_land_time, change) {
      if (takeoff_land_time) {
        takeoff_land_time = __WEBPACK_IMPORTED_MODULE_7_moment___default()().format("YYYY-MM-DD") + ' ' + takeoff_land_time;
        total_time_scheduled = __WEBPACK_IMPORTED_MODULE_7_moment___default()().format("YYYY-MM-DD") + ' ' + total_time_scheduled;

        takeoff_land_time = new Date(takeoff_land_time);
        total_time_scheduled = new Date(total_time_scheduled);
        var diffTime = Math.abs(takeoff_land_time.getTime() - total_time_scheduled.getTime());
        if (takeoff_land_time > total_time_scheduled) {
          change['delay_time'] = this.calcTimeFromMs(diffTime);
        } else {
          change['delay_time'] = '00:00';
        }
      }
      this.setState(change);
    }
  }, {
    key: 'calcTimeFromMs',
    value: function calcTimeFromMs(diffTime) {
      diffTime = diffTime / 1000;
      var secs = diffTime % 60;
      diffTime = (diffTime - secs) / 60;
      var mins = diffTime % 60;
      var hrs = (diffTime - mins) / 60;
      if (secs < 10) {
        secs = '0' + secs;
      }
      if (mins < 10) {
        mins = '0' + mins;
      }
      if (hrs < 10) {
        hrs = '0' + hrs;
      }
      return hrs + ':' + mins + ':' + secs;
    }

    // Fetch salvando a edição

  }, {
    key: 'editMobile',
    value: function editMobile(event) {
      event.preventDefault();
      this.edit();
    }

    // Fetch salvando a edição

  }, {
    key: 'edit',
    value: function edit() {

      var takeoff_time_scheduled = null;
      var engine_start_time = null;
      var takeoff_time = null;
      var landing_time = null;
      var engine_shutoff_time = null;

      if (this.state.takeoff_time_scheduled) takeoff_time_scheduled = this.state.date + ' ' + this.state.takeoff_time_scheduled;
      if (this.state.engine_start_time) engine_start_time = this.state.date + ' ' + this.state.engine_start_time;
      if (this.state.takeoff_time) takeoff_time = this.state.date + ' ' + this.state.takeoff_time;
      if (this.state.landing_time) landing_time = this.state.date + ' ' + this.state.landing_time;
      if (this.state.engine_shutoff_time) engine_shutoff_time = this.state.date + ' ' + this.state.engine_shutoff_time;

      if (takeoff_time_scheduled) takeoff_time_scheduled = __WEBPACK_IMPORTED_MODULE_7_moment___default()(takeoff_time_scheduled, "DD/MM/YYYY HH:mm:ss");
      if (engine_start_time) engine_start_time = __WEBPACK_IMPORTED_MODULE_7_moment___default()(engine_start_time, "DD/MM/YYYY HH:mm:ss");
      if (takeoff_time) takeoff_time = __WEBPACK_IMPORTED_MODULE_7_moment___default()(takeoff_time, "DD/MM/YYYY HH:mm:ss");
      if (landing_time) landing_time = __WEBPACK_IMPORTED_MODULE_7_moment___default()(landing_time, "DD/MM/YYYY HH:mm:ss");
      if (engine_shutoff_time) engine_shutoff_time = __WEBPACK_IMPORTED_MODULE_7_moment___default()(engine_shutoff_time, "DD/MM/YYYY HH:mm:ss");

      if (takeoff_time_scheduled) {
        var diff_hours = takeoff_time_scheduled.diff(takeoff_time, 'hours');
        if (takeoff_time < takeoff_time_scheduled && diff_hours > 12) {
          if (engine_start_time) engine_start_time.add(1, 'd');
          if (takeoff_time) takeoff_time.add(1, 'd');
          if (landing_time) landing_time.add(1, 'd');
          if (engine_shutoff_time) engine_shutoff_time.add(1, 'd');
        }
      }

      if (takeoff_time > landing_time) {
        if (landing_time) landing_time.add(1, 'd');
      }

      if (engine_start_time > engine_shutoff_time) {
        if (engine_shutoff_time) engine_shutoff_time.add(1, 'd');
      }

      if (engine_start_time) engine_start_time = engine_start_time.format("YYYY-MM-DD HH:mm:ss");
      if (takeoff_time) takeoff_time = takeoff_time.format("YYYY-MM-DD HH:mm:ss");
      if (landing_time) landing_time = landing_time.format("YYYY-MM-DD HH:mm:ss");
      if (engine_shutoff_time) engine_shutoff_time = engine_shutoff_time.format("YYYY-MM-DD HH:mm:ss");
      if (takeoff_time_scheduled) takeoff_time_scheduled = takeoff_time_scheduled.format("YYYY-MM-DD HH:mm:ss");

      var datasave = _defineProperty({
        origin: 'Manual',
        custom_items: this.state.custom_items,
        id: this.state.id,
        flight_report_id: this.state.flight_report_id,
        leg_number: this.state.leg_number,
        departure_location_id: this.state.departure_location_id,
        arrival_location_id: this.state.arrival_location_id,
        takeoff_time_scheduled: takeoff_time_scheduled,
        total_time_scheduled: this.state.total_time_scheduled,
        engine_start_time: engine_start_time,
        takeoff_time: takeoff_time,
        landing_time: landing_time,
        engine_shutoff_time: engine_shutoff_time,
        takeoff_land_time: this.state.takeoff_land_time,
        total_time: this.state.total_time,
        navigation_time: this.state.navigation_time,
        ifr_time: this.state.ifr_time,
        night_time: this.state.night_time,
        day_landings: this.state.day_landings,
        night_landings: this.state.night_landings,
        starts: this.state.starts,
        pax: this.state.pax,
        payload: this.state.payload,
        external_load_long_line: this.state.external_load_long_line,
        external_load_short_line: this.state.external_load_short_line,
        fuel_start: this.state.fuel_start,
        fuel_end: this.state.fuel_end,
        ptbr_code_id: this.state.ptbr_code_id,
        ptbr_operation_id: this.state.ptbr_operation_id,
        ptbr_external_load_id: this.state.ptbr_external_load_id,
        delay_time: this.state.delay_time,
        delay_departure: this.state.delay_departure
      }, 'custom_items', this.state.custom_items);

      var flight_report_leg_ids = [this.state.id];

      if (navigator.onLine) {
        this.props.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/trecho', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');

            if (responseJson.status === 'success') {
              if (localStorage.getItem("cached_flight_report_legs_states_by_id")) {
                var cached_flight_report_legs_states_by_id = localStorage.getItem("cached_flight_report_legs_states_by_id");
                cached_flight_report_legs_states_by_id = JSON.parse(cached_flight_report_legs_states_by_id);
                var new_cached_flight_report_legs_states_by_id = {};
                {
                  Object.keys(cached_flight_report_legs_states_by_id).map(function (k) {
                    var frl_by_id = cached_flight_report_legs_states_by_id[k];
                    if (!flight_report_leg_ids.includes(frl_by_id.id)) {
                      new_cached_flight_report_legs_states_by_id.push(cached_flight_report_legs_states_by_id[k]);
                    }
                  });
                }
                localStorage.setItem("cached_flight_report_legs_states_by_id", JSON.stringify(new_cached_flight_report_legs_states_by_id));
              }
            }
            self.props.updateData(responseJson);
          }).catch(function (error) {
            console.error(error);
          });
        });
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'handleChangeDecimal',
    value: function handleChangeDecimal(k, event) {
      var model_item = this.state.aircraft_model_version_custom_items[k];
      var rawInputValue = model_item && model_item['rawInputValue'];
      var inputValue = event.target.value;
      if (inputValue === '') {
        rawInputValue = '';
      } else if (/^\d+$/.test(inputValue)) {
        rawInputValue = inputValue;
      } else {
        var newChar = inputValue.slice(-1);
        if (!/^[0-9.,]$/.test(newChar)) {
          return;
        }
        if (newChar === ',') {
          newChar = '.';
        }
        var hasDecimal = (rawInputValue || '').includes('.');
        if ((rawInputValue || '') === '' && newChar === '0') {
          return;
        }
        if (event.nativeEvent && event.nativeEvent.inputType === 'deleteContentBackward') {
          rawInputValue = (rawInputValue || '').slice(0, -1);
        } else if (hasDecimal && newChar !== '.') {
          var parts = (rawInputValue || '').split('.');
          parts[1] = newChar;
          rawInputValue = parts.join('.');
        } else {
          rawInputValue = (rawInputValue || '') + newChar;
        }
      }
      var formattedValue = this.formatInputValue(rawInputValue);
      var custom_items = Object.assign({}, this.state.custom_items || {});
      custom_items[model_item.id] = formattedValue;
      if (model_item) model_item['rawInputValue'] = rawInputValue;
      this.setState({ custom_items: custom_items, model_item: model_item });
    }
  }, {
    key: 'formatInputValue',
    value: function formatInputValue(rawValue) {
      if (!rawValue) {
        return '';
      }

      var _rawValue$split = rawValue.split('.'),
          _rawValue$split2 = _slicedToArray(_rawValue$split, 2),
          inteiro = _rawValue$split2[0],
          decimal = _rawValue$split2[1];

      decimal = decimal && decimal.length > 0 ? decimal[0] : '0';
      return inteiro + '.' + decimal;
    }
  }, {
    key: 'handleCustomItem',
    value: function handleCustomItem(id, event) {
      var custom_items = Object.assign({}, this.state.custom_items || {});
      if (event == null) {
        custom_items[id] = null;
      } else {
        custom_items[id] = event.target.value;
      }
      this.setState({ custom_items: custom_items });
    }
  }, {
    key: 'delete',
    value: function _delete() {
      if (navigator.onLine) {
        if (window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.excluirTrecho)) {
          this.props.handleAlert('', '', 'open');

          var datasave = {
            id: this.state.id
          };
          var header = this.refs.request_api.header('application/json');
          var self = this;
          Promise.resolve(header).then(function (value) {
            fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/trecho', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.refs.request_api.validate(responseJson, 'alert');
              self.props.updateData(responseJson);
            }).catch(function (error) {
              console.error(error);
            });
          });
        }
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'addStaff',
    value: function addStaff(event) {
      event.preventDefault();
      if (navigator.onLine) {
        this.props.handleAlert('', '', 'open');
        var datasave = {
          flight_report_leg_id: this.state.id,
          staff_id: this.state.staff_id,
          duty_id: this.state.duty_id
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/trecho/tripulante', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
          }).catch(function (error) {
            console.error(error);
          });
        });
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'deleteStaff',
    value: function deleteStaff(id) {
      if (navigator.onLine) {
        if (window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.removerTripulanteDoTrecho)) {
          this.props.handleAlert('', '', 'open');
          var datasave = {
            id: id
          };
          var header = this.refs.request_api.header('application/json');
          var self = this;
          Promise.resolve(header).then(function (value) {
            fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/trecho/tripulante', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.refs.request_api.validate(responseJson, 'alert');
              self.props.updateData(responseJson);
            }).catch(function (error) {
              console.error(error);
            });
          });
        }
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'cleanLeg',
    value: function cleanLeg(id) {
      var flight_report_leg_ids = [id];
      if (localStorage.getItem("cached_flight_report_legs_states_by_id")) {
        this.props.handleAlert('', '', 'open');
        var cached_flight_report_legs_states_by_id = localStorage.getItem("cached_flight_report_legs_states_by_id");
        cached_flight_report_legs_states_by_id = JSON.parse(cached_flight_report_legs_states_by_id);
        var new_cached_flight_report_legs_states_by_id = {};
        {
          Object.keys(cached_flight_report_legs_states_by_id).map(function (k) {
            var frl_by_id = cached_flight_report_legs_states_by_id[k];
            if (!flight_report_leg_ids.includes(frl_by_id.id)) {
              new_cached_flight_report_legs_states_by_id[frl_by_id.id] = frl_by_id;
            }
          });
        }
        localStorage.setItem("cached_flight_report_legs_states_by_id", JSON.stringify(new_cached_flight_report_legs_states_by_id));
        var responseJson = {
          data: {},
          status: 'success',
          message: this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.limparTrecho
        };
        this.props.updateData(responseJson);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      var style = {};
      if (self.state.edited) {
        style = { background: '#f3e5c9' };
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'tr',
        { style: style },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { style: { width: '200px', whiteSpace: 'nowrap', textAlign: 'center' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button', className: 'btn btn-info btn-sm button-inline', onClick: function onClick() {
                _this2.setState({ modal_flight_following: true });
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-clock-o' })
          ),
          self.state.edited && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button', className: 'btn btn-danger btn-sm button-inline', onClick: function onClick() {
                _this2.cleanLeg(_this2.state.id);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-eraser' })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.state.leg_number
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
            className: 'form-field-name',
            style: this.state.style.select_places,
            name: 'departure_location_id',
            value: this.state.departure_location_id,
            searchable: true,
            placeholder: '',
            onChange: this.handleSelectChange.bind(this, 'departure_location_id'),
            options: this.state.locations_select

          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
            className: 'form-field-name',
            style: this.state.style.select_places,
            name: 'arrival_location_id',
            value: this.state.arrival_location_id,
            searchable: true,
            placeholder: '',
            onChange: this.handleSelectChange.bind(this, 'arrival_location_id'),
            options: this.state.locations_select

          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: this.state.style.input_hour, value: this.state.engine_start_time, maskChar: null, name: 'engine_start_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'engine_start_time'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: this.state.style.input_hour, value: this.state.takeoff_time, maskChar: null, name: 'takeoff_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'takeoff_time'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: this.state.style.input_hour, value: this.state.landing_time, maskChar: null, name: 'landing_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'landing_time'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: this.state.style.input_hour, value: this.state.engine_shutoff_time, maskChar: null, name: 'engine_shutoff_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'engine_shutoff_time'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: this.state.style.input_hour, value: this.state.takeoff_land_time, maskChar: null, name: 'takeoff_land_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'takeoff_land_time'), placeholder: '', disabled: true })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: this.state.style.input_hour, value: this.state.total_time, maskChar: null, name: 'total_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'total_time'), placeholder: '', disabled: true })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: this.state.style.input_hour, value: this.state.navigation_time, maskChar: null, name: 'navigation_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'navigation_time'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: this.state.style.input_hour, value: this.state.ifr_time, maskChar: null, name: 'ifr_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'ifr_time'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: this.state.style.input_hour, value: this.state.night_time, maskChar: null, name: 'night_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'night_time'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: this.state.style.input_number, type: 'number', value: this.state.day_landings, name: 'day_landings ', className: 'form-control', onChange: this.handleChange.bind(this, 'day_landings'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: this.state.style.input_number, type: 'number', value: this.state.night_landings, name: 'night_landings ', className: 'form-control', onChange: this.handleChange.bind(this, 'night_landings'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: this.state.style.input_number, type: 'number', value: this.state.starts, name: 'starts ', className: 'form-control', onChange: this.handleChange.bind(this, 'starts'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: this.state.style.input_number, type: 'number', value: this.state.pax, name: 'pax ', className: 'form-control', onChange: this.handleChange.bind(this, 'pax'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: this.state.style.input_number, type: 'number', value: this.state.payload, name: 'payload ', className: 'form-control', onChange: this.handleChange.bind(this, 'payload'), placeholder: '' })
        ),
        this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
            checked: this.state.external_load_long_line,
            'aria-label': 'No label tag',
            name: 'external_load_long_line',
            onChange: this.handleToggleChange.bind(this, 'external_load_long_line') })
        ) : '',
        this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
            checked: this.state.external_load_short_line,
            'aria-label': 'No label tag',
            name: 'external_load_short_line',
            onChange: this.handleToggleChange.bind(this, 'external_load_short_line') })
        ) : '',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: this.state.style.input_fuel || this.state.style.input_number, type: 'number', value: this.state.fuel_start, name: 'fuel_start ', className: 'form-control', onChange: this.handleChange.bind(this, 'fuel_start'), placeholder: '' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: this.state.style.input_fuel || this.state.style.input_number, type: 'number', value: this.state.fuel_end, name: 'fuel_end ', className: 'form-control', onChange: this.handleChange.bind(this, 'fuel_end'), placeholder: '' })
        ),
        this.state.xml == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
            className: 'form-field-name',
            name: 'ptbr_code_id',
            value: this.state.ptbr_code_id,
            searchable: true,
            placeholder: '',
            onChange: this.handleSelectChange.bind(this, 'ptbr_code_id'),
            options: this.state.ptbr_codes_select,
            style: this.state.style.select_operation
          })
        ) : '',
        Object.keys(this.state.aircraft_model_version_custom_items).length > 0 && Object.keys(this.state.aircraft_model_version_custom_items).map(function (k) {
          var custom_item = _this2.state.aircraft_model_version_custom_items[k];
          var id = custom_item.id;
          var inputElement = void 0;
          if (custom_item.type === 'text' || custom_item.type === 'number') {
            inputElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
              type: custom_item.type,
              name: id,
              id: 'custom-item-id-' + id,
              className: 'form-control',
              style: _this2.state.style.input_custom,
              onChange: function onChange(event) {
                return _this2.handleCustomItem(id, event);
              },
              value: _this2.state.custom_items && _this2.state.custom_items[id] || '',
              placeholder: ''
            });
          } else if (custom_item.type === 'hour') {
            inputElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, {
              name: id,
              id: 'custom-item-id-' + id,
              className: 'form-control',
              style: _this2.state.style.input_custom,
              onChange: function onChange(event) {
                return _this2.handleCustomItem(id, event);
              },
              value: _this2.state.custom_items && _this2.state.custom_items[id] || '',
              placeholder: 'hh:mm',
              mask: '99:99'
            });
          } else if (custom_item.type === 'options') {
            var optionValues = Array.isArray(custom_item.options) ? custom_item.options : [];
            inputElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'select',
              {
                name: id,
                id: 'custom-item-id-' + id,
                className: 'form-control',
                style: _this2.state.style.input_custom,
                onChange: function onChange(event) {
                  return _this2.handleCustomItem(id, event);
                },
                value: _this2.state.custom_items && _this2.state.custom_items[id] || ''
              },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'option',
                { value: '' },
                _this2.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.SelecioneOpcao
              ),
              optionValues.map(function (optionValue, optionIndex) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'option',
                  { value: optionValue, key: 'custom-item-option-' + id + '-' + optionIndex },
                  optionValue
                );
              })
            );
          } else {
            inputElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
              name: id,
              className: 'form-control',
              style: _this2.state.style.input_custom,
              value: _this2.state.custom_items && _this2.state.custom_items[id] || '',
              onChange: _this2.handleChangeDecimal.bind(_this2, k),
              placeholder: 'hh.m'
            });
          }
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'td',
            { key: id },
            inputElement
          );
        }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { style: { width: '200px', whiteSpace: 'nowrap', textAlign: 'center' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button', className: 'btn btn-primary button-inline', onClick: function onClick() {
                _this2.edit();
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' })
          ),
          this.props.edit && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button', className: 'btn btn-danger button-inline', onClick: function onClick() {
                _this2.delete();
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-trash' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button', className: 'btn btn-success button-inline', onClick: function onClick() {
                _this2.setState({ modal: true });
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-user' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button', className: 'btn btn-info button-inline', onClick: function onClick() {
                _this2.setState({ modal_flight_following: true });
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-clock-o' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */],
            { show: this.state.modal, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Header,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                    _this2.setState({ modal: false });
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Body,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'form',
                { onSubmit: this.editMobile, className: 'visible-xs' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-3 form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Origem
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'departure_location_id',
                      value: this.state.departure_location_id,
                      searchable: true,
                      placeholder: '',
                      onChange: this.handleSelectChange.bind(this, 'departure_location_id'),
                      options: this.state.locations_select
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-3 form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Destino
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'arrival_location_id',
                      value: this.state.arrival_location_id,
                      searchable: true,
                      placeholder: '',
                      onChange: this.handleSelectChange.bind(this, 'arrival_location_id'),
                      options: this.state.locations_select
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-3 form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Partida
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.engine_start_time, maskChar: null, name: 'engine_start_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'engine_start_time'), placeholder: '' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-3 form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.DEC
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.takeoff_time, maskChar: null, name: 'takeoff_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'takeoff_time'), placeholder: '' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-3 form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.POU
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.landing_time, maskChar: null, name: 'landing_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'landing_time'), placeholder: '' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-3 form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Corte
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.engine_shutoff_time, maskChar: null, name: 'engine_shutoff_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'engine_shutoff_time'), placeholder: '' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-3 form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.DECPOU
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.takeoff_land_time, maskChar: null, name: 'takeoff_land_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'takeoff_land_time'), placeholder: '', disabled: true })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-3 form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Total
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.total_time, maskChar: null, name: 'total_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'total_time'), placeholder: '', disabled: true })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-3 form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Nav
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.navigation_time, maskChar: null, name: 'navigation_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'navigation_time'), placeholder: '' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-3 form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.IFR
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.ifr_time, maskChar: null, name: 'ifr_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'ifr_time'), placeholder: '' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-3 form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Noturno
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.night_time, maskChar: null, name: 'night_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'night_time'), placeholder: '' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-3 form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Diurnos
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.day_landings, name: 'day_landings ', className: 'form-control', onChange: this.handleChange.bind(this, 'day_landings'), placeholder: '' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-3 form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Noturnos
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.night_landings, name: 'night_landings ', className: 'form-control', onChange: this.handleChange.bind(this, 'night_landings'), placeholder: '' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-3 form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Partidas
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.starts, name: 'starts ', className: 'form-control', onChange: this.handleChange.bind(this, 'starts'), placeholder: '' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-3 form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.PAX
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.pax, name: 'pax ', className: 'form-control', onChange: this.handleChange.bind(this, 'pax'), placeholder: '' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-3 form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Carga
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.payload, name: 'payload ', className: 'form-control', onChange: this.handleChange.bind(this, 'payload'), placeholder: '' })
                  ),
                  this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-3 col-xs-6 form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.LongLine
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
                      checked: this.state.external_load_long_line,
                      'aria-label': 'No label tag',
                      name: 'external_load_long_line',
                      onChange: this.handleToggleChange.bind(this, 'external_load_long_line') })
                  ) : '',
                  this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-3 col-xs-6 form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.ShortLine
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
                      checked: this.state.external_load_short_line,
                      'aria-label': 'No label tag',
                      name: 'external_load_short_line',
                      onChange: this.handleToggleChange.bind(this, 'external_load_short_line') })
                  ) : '',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-3 form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Inicial
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.fuel_start, name: 'fuel_start ', className: 'form-control', onChange: this.handleChange.bind(this, 'fuel_start'), placeholder: '' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-3 form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Final
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.fuel_end, name: 'fuel_end ', className: 'form-control', onChange: this.handleChange.bind(this, 'fuel_end'), placeholder: '' })
                  ),
                  this.state.xml == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-3 form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.CódigoPTBR,
                      ' \xA0\xA0',
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { type: 'button', onClick: function onClick() {
                            return _this2.exportPtbrCode();
                          }, className: 'btn btn-success btn-xs' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'ptbr_code_id',
                      value: this.state.ptbr_code_id,
                      searchable: true,
                      placeholder: '',
                      onChange: this.handleSelectChange.bind(this, 'ptbr_code_id'),
                      options: this.state.ptbr_codes_select
                    })
                  ) : ''
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'submit', className: 'btn btn-primary btn-block' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                  ' ',
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.botaoEditarTrecho
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h3',
                { className: 'page-title' },
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloTripulacaoCadastrada
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'form',
                { onSubmit: this.addStaff },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-6 form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioAdicionarTripulante.Tripulante,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'staff_id',
                      value: this.state.staff_id,
                      searchable: true,
                      placeholder: '',
                      onChange: this.handleSelectChange.bind(this, 'staff_id'),
                      options: this.state.staffs_select,
                      required: true
                    })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-6 form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioAdicionarTripulante.FuncaoDeBordo,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'duty_id',
                      value: this.state.duty_id,
                      searchable: true,
                      placeholder: '',
                      onChange: this.handleSelectChange.bind(this, 'duty_id'),
                      options: this.state.duties_select,
                      required: true
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                  ' ',
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioAdicionarTripulante.botaoAdicionarTripulante
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-responsive' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'table',
                  { className: 'table table-bordered table-hover table-striped' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'thead',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        null,
                        this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantes.Nome
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        null,
                        this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantes.FuncaoDeBordo
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        null,
                        '\xA0\xA0\xA0\xA0\xA0\xA0A\xE7\xF5es\xA0\xA0\xA0\xA0\xA0\xA0'
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tbody',
                    null,
                    Object.keys(self.state.flight_report_leg_edit_staffs).map(function (k) {
                      var srl = self.state.flight_report_leg_edit_staffs[k];
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'tr',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'td',
                          null,
                          srl.staff.name
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'td',
                          null,
                          srl.duty.name
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'td',
                          { className: 'text-center' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'button',
                            { onClick: function onClick() {
                                return self.deleteStaff(srl.id);
                              }, className: 'btn btn-danger btn-sm' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-trash' })
                          )
                        )
                      );
                    })
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Footer,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                    _this2.setState({ modal: false });
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */],
            { show: this.state.modal_flight_following, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Header,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                { className: 'pull-left' },
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloEdicaoTrecho,
                ' - ',
                this.state.leg_number
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                    return self.setState({ modal_flight_following: false });
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Body,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Partida
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-responsive' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'table',
                  { className: 'table table-bordered table-hover table-striped' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'thead',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center col-md-2' },
                        this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Horario
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tbody',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'row' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-md-6' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.engine_start_time, maskChar: null, name: 'engine_start_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'engine_start_time'), placeholder: '' })
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-md-6' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'button',
                              { className: 'btn btn-primary button-inline btn-sm form-control', onClick: function onClick() {
                                  _this2.autoFillTime('engine_start_time', null);
                                } },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-calendar-check-o' })
                            )
                          )
                        )
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.DEC
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-responsive' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'table',
                  { className: 'table table-bordered table-hover table-striped' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'thead',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center col-md-2' },
                        this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Horario
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tbody',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'row' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-md-6' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.takeoff_time, style: { minWidth: '63px' }, maskChar: null, name: 'takeoff_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'takeoff_time'), placeholder: '' })
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-md-6' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'button',
                              { className: 'btn btn-primary button-inline btn-sm form-control', onClick: function onClick() {
                                  _this2.autoFillTime('takeoff_time', null);
                                } },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-calendar-check-o' })
                            )
                          )
                        )
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.POU
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-responsive' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'table',
                  { className: 'table table-bordered table-hover table-striped' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'thead',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center col-md-2' },
                        this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Horario
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tbody',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'row' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-md-6' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.landing_time, style: { minWidth: '63px' }, maskChar: null, name: 'landing_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'landing_time'), placeholder: '' })
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-md-6' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'button',
                              { className: 'btn btn-primary button-inline btn-sm form-control', onClick: function onClick() {
                                  _this2.autoFillTime('landing_time', null);
                                } },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-calendar-check-o' })
                            )
                          )
                        )
                      )
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Corte
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-responsive' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'table',
                  { className: 'table table-bordered table-hover table-striped' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'thead',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center col-md-2' },
                        this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarTrecho.Horario
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tbody',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: 'row' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-md-6' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.engine_shutoff_time, style: { minWidth: '63px' }, maskChar: null, name: 'engine_shutoff_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'engine_shutoff_time'), placeholder: '' })
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'col-md-6' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                              'button',
                              { className: 'btn btn-primary button-inline btn-sm form-control', onClick: function onClick() {
                                  _this2.autoFillTime('engine_shutoff_time', null);
                                } },
                              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-calendar-check-o' })
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Footer,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                    _this2.setState({ modal_flight_following: false });
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
              )
            )
          )
        )
      );
    }
  }]);

  return FlightReportLegEditTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportLegEditTab);

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FlightReportLegEditTab__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FlightReportLegAddTab__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__ = __webpack_require__(3);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário









var FlightReportLegsTab = function (_Component) {
  _inherits(FlightReportLegsTab, _Component);

  function FlightReportLegsTab(props) {
    _classCallCheck(this, FlightReportLegsTab);

    var _this = _possibleConstructorReturn(this, (FlightReportLegsTab.__proto__ || Object.getPrototypeOf(FlightReportLegsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      modal: false,
      deleting: false,
      flight_report_id: null,
      status: 0,
      departure_location_id: null,
      arrival_location_id: null,
      date: null,
      leg_number: null,
      takeoff_time_scheduled: null,
      total_time_scheduled: null,
      engine_start_time: null,
      start_parameter_total: null,
      takeoff_time: null,
      landing_time: null,
      engine_shutoff_time: null,
      takeoff_land_time: '00:00',
      total_time: '00:00',
      navigation_time: '00:00',
      ifr_time: '00:00',
      night_time: '00:00',
      day_landings: 1,
      night_landings: 0,
      starts: null,
      pax: 0,
      payload: 0,
      external_load_long_line: 0,
      external_load_short_line: 0,
      fuel_start: 0,
      fuel_end: 0,
      ptbr_code_id: 35,
      ptbr_operation_id: null,
      ptbr_external_load_id: null,
      delay_time: '00:00',
      delay_departure: '00:00',
      flight_report_legs: _this.props.flight_report_legs,
      flight_report_legs_totals: _this.props.flight_report_legs_totals,
      flight_report_legs_new: [],
      locations_select: [],
      ptbr_codes_select: [],
      ptbr_operations_select: [],
      ptbr_external_loads_select: [],
      staffs_select: [],
      duties_select: [],
      flight_report_leg_edit: {},
      flight_report_leg_edit_staffs: {},
      aircraft_model_version_custom_items: {},
      custom_items: {}
    };

    _this.saveAll = _this.saveAll.bind(_this);
    _this.add = _this.add.bind(_this);
    _this.addMobile = _this.addMobile.bind(_this);
    _this.diffFlight = _this.diffFlight.bind(_this);
    _this.diffTotalTime = _this.diffTotalTime.bind(_this);
    _this.delayFlight = _this.delayFlight.bind(_this);
    _this.delayTotalTime = _this.delayTotalTime.bind(_this);
    _this.calcTimeFromMs = _this.calcTimeFromMs.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.exportPtbrCode = _this.exportPtbrCode.bind(_this);
    _this.handleChangeDecimal = _this.handleChangeDecimal.bind(_this);
    _this.handleCustomItem = _this.handleCustomItem.bind(_this);
    _this.setParentState = _this.setParentState.bind(_this);
    _this.saveAdd = _this.saveAdd.bind(_this);
    _this.setDeleteFalse = _this.setDeleteFalse.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(FlightReportLegsTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      if (name === 'takeoff_time') {
        this.diffFlight(event.target.value, this.state.landing_time, change);
        this.delayFlight(event.target.value, this.state.takeoff_time_scheduled, change);
        this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, event.target.value, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'landing_time') {
        this.diffFlight(this.state.takeoff_time, event.target.value, change);
        this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, this.state.takeoff_time, event.target.value, this.state.start_parameter_total, change);
      } else if (name === 'engine_start_time') {
        this.diffTotalTime(event.target.value, this.state.engine_shutoff_time, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'engine_shutoff_time') {
        this.diffTotalTime(this.state.engine_start_time, event.target.value, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'takeoff_time_scheduled') {
        this.delayFlight(this.state.takeoff_time, event.target.value, change);
      } else if (name === 'total_time_scheduled') {
        this.delayTotalTime(event.target.value, this.state.takeoff_land_time, change);
      } else {
        this.setState(change);
      }
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var flight_report_id = this.props.flight_report_id;
      var flight_report_legs_new_all = JSON.parse(localStorage.getItem("cached_flight_report_legs_states_new_by_id")) || {};
      var flight_report_legs_new = flight_report_legs_new_all[flight_report_id] || [];

      this.setState({
        flight_report_legs_new: flight_report_legs_new
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.flight_report_legs) || this.state.loaded === 1 && newProps.updated === 1) {
        var index = newProps.flight_report_legs.length - 1;
        var start_parameter_total = null;
        var flight_report_id = newProps.flight_report_id;

        if (typeof newProps.flight_report_legs[index] !== 'undefined') {
          if (newProps.flight_report_legs[index].engine_shutoff_time === null || newProps.flight_report_legs[index].engine_shutoff_time === '' || typeof newProps.flight_report_legs[index].engine_shutoff_time === 'undefined') {
            start_parameter_total = newProps.flight_report_legs[index].landing_time;
          }
        }

        var flight_report_legs_new_all = JSON.parse(localStorage.getItem("cached_flight_report_legs_states_new_by_id")) || {};

        var flight_report_legs_new = flight_report_legs_new_all[flight_report_id] || [];

        index = Object.keys(flight_report_legs_new).length - 1;
        if (typeof flight_report_legs_new[index] !== 'undefined') {
          if (flight_report_legs_new[index].engine_shutoff_time === null || flight_report_legs_new[index].engine_shutoff_time === '' || typeof flight_report_legs_new[index].engine_shutoff_time === 'undefined') {
            start_parameter_total = flight_report_legs_new[index].landing_time;
          }
        }

        this.setState({
          flight_report_id: newProps.flight_report_id,
          flight_report_legs_new: flight_report_legs_new,
          flight_report_legs: newProps.flight_report_legs,
          flight_report_legs_totals: newProps.flight_report_legs_totals,
          locations_select: newProps.locations_select,
          ptbr_codes_select: newProps.ptbr_codes_select,
          ptbr_operations_select: newProps.ptbr_operations_select,
          ptbr_external_loads_select: newProps.ptbr_external_loads_select,
          staffs_select: newProps.staffs_select,
          duties_select: newProps.duties_select,
          date: newProps.flight_report.date_str,
          external_load: newProps.flight_report.contract.carga_externa,
          xml: newProps.flight_report.contract.xml,
          status: newProps.flight_report.status,
          start_parameter_total: start_parameter_total,
          loaded: 1
        });
      }

      if (typeof newProps.aircraft_model_version_custom_items !== 'undefined') {
        var custom_items = {};
        Object.keys(newProps.aircraft_model_version_custom_items || {}).map(function (k) {
          custom_items[k] = null;
        });
        this.setState({
          custom_items: custom_items,
          aircraft_model_version_custom_items: newProps.aircraft_model_version_custom_items
        });
      }

      if (Array.isArray(newProps.flight_report_legs) || this.state.loaded === 1 && newProps.updated === 0) {
        var index = newProps.flight_report_legs.length - 1;
        var start_parameter_total = null;
        var flight_report_id = newProps.flight_report_id;

        if (typeof newProps.flight_report_legs[index] !== 'undefined') {
          if (newProps.flight_report_legs[index].engine_shutoff_time === null || newProps.flight_report_legs[index].engine_shutoff_time === '' || typeof newProps.flight_report_legs[index].engine_shutoff_time === 'undefined') {
            start_parameter_total = newProps.flight_report_legs[index].landing_time;
          }
        }

        var flight_report_legs_new_all = JSON.parse(localStorage.getItem("cached_flight_report_legs_states_new_by_id")) || {};

        var flight_report_legs_new = flight_report_legs_new_all[flight_report_id] || [];

        index = Object.keys(flight_report_legs_new).length - 1;
        if (typeof flight_report_legs_new[index] !== 'undefined') {
          if (flight_report_legs_new[index].engine_shutoff_time === null || flight_report_legs_new[index].engine_shutoff_time === '' || typeof flight_report_legs_new[index].engine_shutoff_time === 'undefined') {
            start_parameter_total = flight_report_legs_new[index].landing_time;
          }
        }

        var departure_location_id = null;
        var fuel_start = 0;
        if (newProps.flight_report_legs.length > 0) {
          var index = newProps.flight_report_legs.length - 1;
          departure_location_id = newProps.flight_report_legs[index].arrival_location_id;
          fuel_start = newProps.flight_report_legs[index].fuel_end;
        }

        if (Object.keys(flight_report_legs_new).length > 0) {
          index = Object.keys(flight_report_legs_new).length - 1;
          departure_location_id = flight_report_legs_new[index].arrival_location_id;
          fuel_start = flight_report_legs_new[index].fuel_end;
        }

        this.setState({
          flight_report_id: newProps.flight_report_id,
          departure_location_id: departure_location_id,
          arrival_location_id: null,
          takeoff_time_scheduled: '',
          total_time_scheduled: '',
          engine_start_time: '',
          takeoff_time: '',
          landing_time: '',
          engine_shutoff_time: '',
          takeoff_land_time: '00:00',
          total_time: '00:00',
          navigation_time: '',
          ifr_time: '',
          night_time: '',
          day_landings: 1,
          night_landings: 0,
          starts: 0,
          pax: 0,
          payload: 0,
          external_load_long_line: 0,
          external_load_short_line: 0,
          fuel_start: fuel_start,
          fuel_end: 0,
          delay_time: '',
          delay_departure: '',
          ptbr_code_id: 35,
          ptbr_operation_id: null,
          ptbr_external_load_id: null,
          start_parameter_total: start_parameter_total
        });
      }
    }
  }, {
    key: 'handleChangeDecimal',
    value: function handleChangeDecimal(k, event) {
      var custom_items = this.state.custom_items;
      var model_item = this.state.aircraft_model_version_custom_items[k];
      var rawInputValue = model_item['rawInputValue'];
      var inputValue = event.target.value;
      if (inputValue === '') {
        rawInputValue = '';
      } else if (/^\d+$/.test(inputValue)) {
        rawInputValue = inputValue;
      } else {
        var newChar = inputValue.slice(-1);
        if (!/^[0-9.,]$/.test(newChar)) {
          return;
        }
        if (newChar === ',') {
          newChar = '.';
        }
        var hasDecimal = rawInputValue.includes('.');
        if (rawInputValue === '' && newChar === '0') {
          return;
        }
        if (event.nativeEvent && event.nativeEvent.inputType === 'deleteContentBackward') {
          rawInputValue = rawInputValue.slice(0, -1);
        } else if (hasDecimal && newChar !== '.') {
          var parts = rawInputValue.split('.');
          parts[1] = newChar;
          rawInputValue = parts.join('.');
        } else {
          rawInputValue += newChar;
        }
      }
      var formattedValue = this.formatInputValue(rawInputValue);
      custom_items[model_item.id] = formattedValue;
      model_item['rawInputValue'] = rawInputValue;
      model_item['value'] = formattedValue;
      this.setState({ custom_items: custom_items, model_item: model_item });
    }
  }, {
    key: 'formatInputValue',
    value: function formatInputValue(rawValue) {
      if (!rawValue) {
        return '';
      }

      var _rawValue$split = rawValue.split('.'),
          _rawValue$split2 = _slicedToArray(_rawValue$split, 2),
          inteiro = _rawValue$split2[0],
          decimal = _rawValue$split2[1];

      decimal = decimal && decimal.length > 0 ? decimal[0] : '0';
      return inteiro + '.' + decimal;
    }
  }, {
    key: 'handleCustomItem',
    value: function handleCustomItem(name, event) {
      var custom_items = this.state.custom_items;
      if (event == null) {
        custom_items[name] = null;
      } else {
        custom_items[name] = event.target.value;
      }
      this.setState({ custom_items: custom_items });
    }

    // Fetch salvando a adição mobile

  }, {
    key: 'addMobile',
    value: function addMobile(event) {
      event.preventDefault();
      this.add();
    }
  }, {
    key: 'setDeleteFalse',
    value: function setDeleteFalse() {
      this.setState({ deleting: false });
    }
  }, {
    key: 'setParentState',
    value: function setParentState(index) {
      var flight_report_id = this.props.flight_report_id;
      var cached_flight_report_legs_states_new_by_id = JSON.parse(localStorage.getItem("cached_flight_report_legs_states_new_by_id")) || {};
      var new_cached_flight_report_legs_states_new_by_id = [];
      var total_legs = Object.keys(this.state.flight_report_legs).length + 1;

      if (cached_flight_report_legs_states_new_by_id[flight_report_id]) {
        cached_flight_report_legs_states_new_by_id[flight_report_id].forEach(function (flight_report_leg_new, k) {
          if (parseInt(k) !== parseInt(index)) {
            flight_report_leg_new.total_legs = total_legs;
            new_cached_flight_report_legs_states_new_by_id.push(flight_report_leg_new);
            total_legs += 1;
          }
        });
      }

      cached_flight_report_legs_states_new_by_id[flight_report_id] = new_cached_flight_report_legs_states_new_by_id;
      localStorage.setItem("cached_flight_report_legs_states_new_by_id", JSON.stringify(cached_flight_report_legs_states_new_by_id));

      this.setState({
        flight_report_legs_new: new_cached_flight_report_legs_states_new_by_id,
        deleting: true
      });
    }

    // Fetch salvando a adição

  }, {
    key: 'add',
    value: function add() {
      var toSave = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var takeoff_time_scheduled = null;
      var engine_start_time = null;
      var takeoff_time = null;
      var landing_time = null;
      var engine_shutoff_time = null;
      var engine_start_time_str = null;
      var takeoff_time_str = null;
      var landing_time_str = null;
      var engine_shutoff_time_str = null;

      if (this.state.takeoff_time_scheduled) takeoff_time_scheduled = this.state.date + ' ' + this.state.takeoff_time_scheduled;
      if (this.state.engine_start_time) engine_start_time = this.state.date + ' ' + this.state.engine_start_time;
      if (this.state.takeoff_time) takeoff_time = this.state.date + ' ' + this.state.takeoff_time;
      if (this.state.landing_time) landing_time = this.state.date + ' ' + this.state.landing_time;
      if (this.state.engine_shutoff_time) engine_shutoff_time = this.state.date + ' ' + this.state.engine_shutoff_time;

      if (takeoff_time_scheduled) takeoff_time_scheduled = __WEBPACK_IMPORTED_MODULE_8_moment___default()(takeoff_time_scheduled, "DD/MM/YYYY HH:mm:ss");
      if (engine_start_time) engine_start_time = __WEBPACK_IMPORTED_MODULE_8_moment___default()(engine_start_time, "DD/MM/YYYY HH:mm:ss");
      if (takeoff_time) takeoff_time = __WEBPACK_IMPORTED_MODULE_8_moment___default()(takeoff_time, "DD/MM/YYYY HH:mm:ss");
      if (landing_time) landing_time = __WEBPACK_IMPORTED_MODULE_8_moment___default()(landing_time, "DD/MM/YYYY HH:mm:ss");
      if (engine_shutoff_time) engine_shutoff_time = __WEBPACK_IMPORTED_MODULE_8_moment___default()(engine_shutoff_time, "DD/MM/YYYY HH:mm:ss");
      if (engine_start_time) engine_start_time_str = engine_start_time;
      if (takeoff_time) takeoff_time_str = takeoff_time;
      if (landing_time) landing_time_str = landing_time;
      if (engine_shutoff_time) engine_shutoff_time_str = engine_shutoff_time;

      if (takeoff_time_scheduled) {
        var diff_hours = takeoff_time_scheduled.diff(takeoff_time, 'hours');
        if (takeoff_time < takeoff_time_scheduled && diff_hours > 12) {
          if (engine_start_time) engine_start_time.add(1, 'd');
          if (takeoff_time) takeoff_time.add(1, 'd');
          if (landing_time) landing_time.add(1, 'd');
          if (engine_shutoff_time) engine_shutoff_time.add(1, 'd');
          if (engine_start_time) engine_start_time_str.add(1, 'd');
          if (takeoff_time) takeoff_time_str.add(1, 'd');
          if (landing_time) landing_time_str.add(1, 'd');
          if (engine_shutoff_time) engine_shutoff_time_str.add(1, 'd');
        }
      }

      if (takeoff_time > landing_time) {
        if (landing_time) landing_time.add(1, 'd');
        if (landing_time) landing_time_str.add(1, 'd');
      }

      if (engine_start_time > engine_shutoff_time) {
        if (engine_shutoff_time) engine_shutoff_time.add(1, 'd');
        if (engine_shutoff_time) engine_shutoff_time_str.add(1, 'd');
      }

      if (engine_start_time) engine_start_time = engine_start_time.format("YYYY-MM-DD HH:mm:ss");
      if (takeoff_time) takeoff_time = takeoff_time.format("YYYY-MM-DD HH:mm:ss");
      if (landing_time) landing_time = landing_time.format("YYYY-MM-DD HH:mm:ss");
      if (engine_shutoff_time) engine_shutoff_time = engine_shutoff_time.format("YYYY-MM-DD HH:mm:ss");
      if (engine_start_time_str) engine_start_time_str = engine_start_time_str.format("HH:mm");
      if (takeoff_time_str) takeoff_time_str = takeoff_time_str.format("HH:mm");
      if (landing_time_str) landing_time_str = landing_time_str.format("HH:mm");
      if (engine_shutoff_time_str) engine_shutoff_time_str = engine_shutoff_time_str.format("HH:mm");
      if (takeoff_time_scheduled) takeoff_time_scheduled = takeoff_time_scheduled.format("YYYY-MM-DD HH:mm:ss");

      var datasave = {
        origin: 'Manual',
        flight_report_id: this.props.flight_report_id,
        departure_location_id: this.state.departure_location_id,
        arrival_location_id: this.state.arrival_location_id,
        takeoff_time_scheduled: takeoff_time_scheduled,
        total_time_scheduled: this.state.total_time_scheduled,
        engine_start_time: engine_start_time,
        takeoff_time: takeoff_time,
        landing_time: landing_time,
        engine_shutoff_time: engine_shutoff_time,
        takeoff_land_time: this.state.takeoff_land_time,
        total_time: this.state.total_time,
        navigation_time: this.state.navigation_time,
        ifr_time: this.state.ifr_time,
        night_time: this.state.night_time,
        day_landings: this.state.day_landings,
        night_landings: this.state.night_landings,
        starts: this.state.starts,
        pax: this.state.pax,
        payload: this.state.payload,
        external_load_long_line: this.state.external_load_long_line,
        external_load_short_line: this.state.external_load_short_line,
        fuel_start: this.state.fuel_start,
        fuel_end: this.state.fuel_end,
        delay_time: this.state.delay_time,
        delay_departure: this.state.delay_departure,
        ptbr_code_id: this.state.ptbr_code_id,
        ptbr_operation_id: this.state.ptbr_operation_id,
        ptbr_external_load_id: this.state.ptbr_external_load_id,
        custom_items: Object.assign({}, this.state.custom_items || {})
      };
      if (toSave) {
        if (navigator.onLine) {
          this.saveAdd(datasave);
        } else {
          window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
        }
      } else {
        this.setState({ start_parameter_total: landing_time });
        var flight_report_id = this.state.flight_report_id;

        var total_legs = 1;

        var cached_flight_report_legs_states_new_by_id = {};
        var new_index = 0;
        var flight_report_id = this.props.flight_report_id;

        if (localStorage.getItem("cached_flight_report_legs_states_new_by_id")) {
          cached_flight_report_legs_states_new_by_id = JSON.parse(localStorage.getItem("cached_flight_report_legs_states_new_by_id"));
          if (!cached_flight_report_legs_states_new_by_id[flight_report_id]) {
            cached_flight_report_legs_states_new_by_id[flight_report_id] = [];
          }
          total_legs += cached_flight_report_legs_states_new_by_id[flight_report_id].length;
          new_index = total_legs - 1;
        } else {
          cached_flight_report_legs_states_new_by_id[flight_report_id] = [];
        }

        cached_flight_report_legs_states_new_by_id[flight_report_id][new_index] = {
          origin: 'Manual',
          flight_report_id: flight_report_id,
          departure_location_id: this.state.departure_location_id,
          arrival_location_id: this.state.arrival_location_id,
          takeoff_time_scheduled: takeoff_time_scheduled,
          total_time_scheduled: this.state.total_time_scheduled,
          engine_start_time: engine_start_time,
          takeoff_time: takeoff_time,
          landing_time: landing_time,
          engine_shutoff_time: engine_shutoff_time,
          engine_start_time_str: engine_start_time_str,
          takeoff_time_str: takeoff_time_str,
          landing_time_str: landing_time_str,
          engine_shutoff_time_str: engine_shutoff_time_str,
          takeoff_land_time: this.state.takeoff_land_time,
          total_time: this.state.total_time,
          navigation_time: this.state.navigation_time,
          ifr_time: this.state.ifr_time,
          night_time: this.state.night_time,
          day_landings: this.state.day_landings,
          night_landings: this.state.night_landings,
          starts: this.state.starts,
          pax: this.state.pax,
          payload: this.state.payload,
          external_load_long_line: this.state.external_load_long_line,
          external_load_short_line: this.state.external_load_short_line,
          fuel_start: this.state.fuel_start,
          fuel_end: this.state.fuel_end,
          delay_time: this.state.delay_time,
          delay_departure: this.state.delay_departure,
          ptbr_code_id: this.state.ptbr_code_id,
          ptbr_operation_id: this.state.ptbr_operation_id,
          ptbr_external_load_id: this.state.ptbr_external_load_id,
          custom_items: Object.assign({}, this.state.custom_items || {}),
          xml: this.state.xml
        };

        this.setState({ flight_report_legs_new: cached_flight_report_legs_states_new_by_id[flight_report_id] });

        this.setState({
          departure_location_id: this.state.arrival_location_id,
          arrival_location_id: null,
          takeoff_time_scheduled: '',
          total_time_scheduled: '',
          engine_start_time: '',
          takeoff_time: '',
          landing_time: '',
          engine_shutoff_time: '',
          takeoff_land_time: '00:00',
          total_time: '00:00',
          navigation_time: '',
          ifr_time: '',
          night_time: '',
          day_landings: 1,
          night_landings: 0,
          starts: 0,
          pax: 0,
          payload: 0,
          external_load_long_line: 0,
          external_load_short_line: 0,
          fuel_start: this.state.fuel_end,
          fuel_end: 0,
          delay_time: '',
          delay_departure: '',
          ptbr_code_id: 35,
          ptbr_operation_id: null,
          ptbr_external_load_id: null,
          custom_items: {}
        });

        localStorage.setItem("cached_flight_report_legs_states_new_by_id", JSON.stringify(cached_flight_report_legs_states_new_by_id));
      }
    }
  }, {
    key: 'saveAdd',
    value: function saveAdd(datasave) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/trecho', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'diffFlight',
    value: function diffFlight(takeoff_time, landing_time, change) {
      if (takeoff_time && landing_time && takeoff_time !== '' && landing_time !== '') {
        takeoff_time = this.state.date + ' ' + takeoff_time;
        landing_time = this.state.date + ' ' + landing_time;

        takeoff_time = __WEBPACK_IMPORTED_MODULE_8_moment___default()(takeoff_time, "DD/MM/YYYY HH:mm:ss");
        landing_time = __WEBPACK_IMPORTED_MODULE_8_moment___default()(landing_time, "DD/MM/YYYY HH:mm:ss");

        if (takeoff_time > landing_time) {
          landing_time.add(1, 'd');
        }

        takeoff_time = new Date(takeoff_time.format("YYYY-MM-DD HH:mm:ss"));
        landing_time = new Date(landing_time.format("YYYY-MM-DD HH:mm:ss"));
        var diffTime = Math.abs(landing_time.getTime() - takeoff_time.getTime());
        if (landing_time > takeoff_time) {
          change['takeoff_land_time'] = this.calcTimeFromMs(diffTime);
          change['navigation_time'] = this.calcTimeFromMs(diffTime);
        } else {
          change['takeoff_land_time'] = '00:00';
          change['navigation_time'] = '00:00';
        }
      } else {
        change['takeoff_land_time'] = '00:00';
        change['navigation_time'] = '00:00';
      }
      this.delayTotalTime(this.state.total_time_scheduled, change['takeoff_land_time'], change);
    }
  }, {
    key: 'diffTotalTime',
    value: function diffTotalTime(engine_start_time, engine_shutoff_time, takeoff_time, landing_time, start_parameter_total, change) {
      var start = null;
      if (engine_start_time !== null && engine_start_time !== '' && typeof engine_start_time !== 'undefined') {
        start = engine_start_time;
      } else if (start_parameter_total !== null) {
        start = start_parameter_total.substring(11);
      }

      var finish = null;
      if (landing_time !== null && landing_time !== '' && typeof landing_time !== 'undefined') {
        finish = landing_time;
      }
      if (engine_shutoff_time !== null && engine_shutoff_time !== '' && typeof engine_shutoff_time !== 'undefined') {
        finish = engine_shutoff_time;
      }

      if (start && finish) {
        start = this.state.date + ' ' + start;
        finish = this.state.date + ' ' + finish;

        start = __WEBPACK_IMPORTED_MODULE_8_moment___default()(start, "DD/MM/YYYY HH:mm:ss");
        finish = __WEBPACK_IMPORTED_MODULE_8_moment___default()(finish, "DD/MM/YYYY HH:mm:ss");

        if (start > finish) {
          finish.add(1, 'd');
        }

        start = new Date(start.format("YYYY-MM-DD HH:mm:ss"));
        finish = new Date(finish.format("YYYY-MM-DD HH:mm:ss"));

        var diffTime = Math.abs(finish.getTime() - start.getTime());
        if (finish > start) {
          change['total_time'] = this.calcTimeFromMs(diffTime);
        } else {
          change['total_time'] = '00:00';
        }

        this.setState(change);
      } else {
        change['total_time'] = '00:00';
        this.setState(change);
      }
    }
  }, {
    key: 'delayFlight',
    value: function delayFlight(takeoff_time, takeoff_time_scheduled, change) {
      if (takeoff_time_scheduled) {
        takeoff_time = this.state.date + ' ' + takeoff_time;
        takeoff_time_scheduled = this.state.date + ' ' + takeoff_time_scheduled;

        takeoff_time = __WEBPACK_IMPORTED_MODULE_8_moment___default()(takeoff_time, "DD/MM/YYYY HH:mm:ss");
        takeoff_time_scheduled = __WEBPACK_IMPORTED_MODULE_8_moment___default()(takeoff_time_scheduled, "DD/MM/YYYY HH:mm:ss");

        var diff_hours = takeoff_time_scheduled.diff(takeoff_time, 'hours');

        if (takeoff_time < takeoff_time_scheduled && diff_hours > 12) {
          takeoff_time.add(1, 'd');
        }

        takeoff_time = new Date(takeoff_time.format("YYYY-MM-DD HH:mm:ss").replace(/ /g, "T"));
        takeoff_time_scheduled = new Date(takeoff_time_scheduled.format("YYYY-MM-DD HH:mm:ss").replace(/ /g, "T"));
        var diffTime = Math.abs(takeoff_time.getTime() - takeoff_time_scheduled.getTime());
        if (takeoff_time > takeoff_time_scheduled) {
          change['delay_departure'] = this.calcTimeFromMs(diffTime);
        } else {
          change['delay_departure'] = '00:00';
        }
      } else {
        change['delay_departure'] = '00:00';
      }
      this.setState(change);
    }
  }, {
    key: 'delayTotalTime',
    value: function delayTotalTime(total_time_scheduled, takeoff_land_time, change) {
      if (takeoff_land_time && total_time_scheduled) {
        takeoff_land_time = __WEBPACK_IMPORTED_MODULE_8_moment___default()().format("YYYY-MM-DD") + ' ' + takeoff_land_time;
        total_time_scheduled = __WEBPACK_IMPORTED_MODULE_8_moment___default()().format("YYYY-MM-DD") + ' ' + total_time_scheduled;
        takeoff_land_time = new Date(takeoff_land_time.replace(/ /g, "T"));
        total_time_scheduled = new Date(total_time_scheduled.replace(/ /g, "T"));
        var diffTime = Math.abs(takeoff_land_time.getTime() - total_time_scheduled.getTime());
        if (takeoff_land_time > total_time_scheduled) {
          change['delay_time'] = this.calcTimeFromMs(diffTime);
        } else {
          change['delay_time'] = '00:00';
        }
      } else {
        change['delay_time'] = '00:00';
      }
      this.setState(change);
    }
  }, {
    key: 'calcTimeFromMs',
    value: function calcTimeFromMs(diffTime) {
      diffTime = diffTime / 1000;
      var secs = diffTime % 60;
      diffTime = (diffTime - secs) / 60;
      var mins = diffTime % 60;
      var hrs = (diffTime - mins) / 60;
      if (secs < 10) {
        secs = '0' + secs;
      }
      if (mins < 10) {
        mins = '0' + mins;
      }
      if (hrs < 10) {
        hrs = '0' + hrs;
      }
      return hrs + ':' + mins + ':' + secs;
    }
  }, {
    key: 'exportPtbrCode',
    value: function exportPtbrCode() {
      if (navigator.onLine) {
        var self = this;
        var url = "/exportar/codigos/ptbr";
        var header = this.refs.request_api.header('application/json');
        this.props.handleAlert('', '', 'open');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'url');
            if (responseJson.status === 'success') {
              var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data;
              window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data);
              self.props.handleAlert('', '', 'closed');
            }
          });
        });
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'saveAll',
    value: function saveAll() {
      var self = this;
      if (navigator.onLine) {
        var confirm = window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.confirmarSalvarTodos);
        if (confirm) {
          var data_legs = [];
          var flight_report_leg_ids = [];
          var last_leg_number = 0;
          {
            Object.keys(self.state.flight_report_legs).map(function (k) {
              var srl = self.state.flight_report_legs[k];
              var ref = 'child_leg_' + srl.leg_number;
              flight_report_leg_ids.push(srl.id);
              var takeoff_time_scheduled = null;
              var engine_start_time = null;
              var takeoff_time = null;
              var landing_time = null;
              var engine_shutoff_time = null;

              if (self[ref].state.takeoff_time_scheduled) takeoff_time_scheduled = self[ref].state.date + ' ' + self[ref].state.takeoff_time_scheduled;
              if (self[ref].state.engine_start_time) engine_start_time = self[ref].state.date + ' ' + self[ref].state.engine_start_time;
              if (self[ref].state.takeoff_time) takeoff_time = self[ref].state.date + ' ' + self[ref].state.takeoff_time;
              if (self[ref].state.landing_time) landing_time = self[ref].state.date + ' ' + self[ref].state.landing_time;
              if (self[ref].state.engine_shutoff_time) engine_shutoff_time = self[ref].state.date + ' ' + self[ref].state.engine_shutoff_time;

              if (takeoff_time_scheduled) takeoff_time_scheduled = __WEBPACK_IMPORTED_MODULE_8_moment___default()(takeoff_time_scheduled, "DD/MM/YYYY HH:mm:ss");
              if (engine_start_time) engine_start_time = __WEBPACK_IMPORTED_MODULE_8_moment___default()(engine_start_time, "DD/MM/YYYY HH:mm:ss");
              if (takeoff_time) takeoff_time = __WEBPACK_IMPORTED_MODULE_8_moment___default()(takeoff_time, "DD/MM/YYYY HH:mm:ss");
              if (landing_time) landing_time = __WEBPACK_IMPORTED_MODULE_8_moment___default()(landing_time, "DD/MM/YYYY HH:mm:ss");
              if (engine_shutoff_time) engine_shutoff_time = __WEBPACK_IMPORTED_MODULE_8_moment___default()(engine_shutoff_time, "DD/MM/YYYY HH:mm:ss");

              if (takeoff_time_scheduled) {
                var diff_hours = takeoff_time_scheduled.diff(takeoff_time, 'hours');
                if (takeoff_time < takeoff_time_scheduled && diff_hours > 12) {
                  if (engine_start_time) engine_start_time.add(1, 'd');
                  if (takeoff_time) takeoff_time.add(1, 'd');
                  if (landing_time) landing_time.add(1, 'd');
                  if (engine_shutoff_time) engine_shutoff_time.add(1, 'd');
                }
              }

              if (takeoff_time > landing_time) {
                if (landing_time) landing_time.add(1, 'd');
              }

              if (engine_start_time > engine_shutoff_time) {
                if (engine_shutoff_time) engine_shutoff_time.add(1, 'd');
              }

              if (engine_start_time) engine_start_time = engine_start_time.format("YYYY-MM-DD HH:mm:ss");
              if (takeoff_time) takeoff_time = takeoff_time.format("YYYY-MM-DD HH:mm:ss");
              if (landing_time) landing_time = landing_time.format("YYYY-MM-DD HH:mm:ss");
              if (engine_shutoff_time) engine_shutoff_time = engine_shutoff_time.format("YYYY-MM-DD HH:mm:ss");
              if (takeoff_time_scheduled) takeoff_time_scheduled = takeoff_time_scheduled.format("YYYY-MM-DD HH:mm:ss");

              var datasave = {
                origin: 'Manual',
                id: self[ref].state.id,
                flight_report_id: self[ref].state.flight_report_id,
                leg_number: self[ref].state.leg_number,
                departure_location_id: self[ref].state.departure_location_id,
                arrival_location_id: self[ref].state.arrival_location_id,
                takeoff_time_scheduled: takeoff_time_scheduled,
                total_time_scheduled: self[ref].state.total_time_scheduled,
                engine_start_time: engine_start_time,
                takeoff_time: takeoff_time,
                landing_time: landing_time,
                engine_shutoff_time: engine_shutoff_time,
                takeoff_land_time: self[ref].state.takeoff_land_time,
                total_time: self[ref].state.total_time,
                navigation_time: self[ref].state.navigation_time,
                ifr_time: self[ref].state.ifr_time,
                night_time: self[ref].state.night_time,
                day_landings: self[ref].state.day_landings,
                night_landings: self[ref].state.night_landings,
                starts: self[ref].state.starts,
                pax: self[ref].state.pax,
                payload: self[ref].state.payload,
                external_load_long_line: self[ref].state.external_load_long_line,
                external_load_short_line: self[ref].state.external_load_short_line,
                fuel_start: self[ref].state.fuel_start,
                fuel_end: self[ref].state.fuel_end,
                ptbr_code_id: self[ref].state.ptbr_code_id,
                ptbr_operation_id: self[ref].state.ptbr_operation_id,
                ptbr_external_load_id: self[ref].state.ptbr_external_load_id,
                delay_time: self[ref].state.delay_time,
                delay_departure: self[ref].state.delay_departure,
                custom_items: self[ref].state.custom_items
              };

              data_legs.push(datasave);
              last_leg_number = parseInt(srl.leg_number) + 1;
            });
          }
          {
            Object.keys(self.state.flight_report_legs_new).map(function (k) {
              var srl = self.state.flight_report_legs_new[k];
              last_leg_number = parseInt(last_leg_number) + 1;
              var ref = 'child_leg_' + last_leg_number;
              var takeoff_time_scheduled = null;
              var engine_start_time = null;
              var takeoff_time = null;
              var landing_time = null;
              var engine_shutoff_time = null;

              if (self[ref].state.takeoff_time_scheduled) takeoff_time_scheduled = self[ref].state.date + ' ' + self[ref].state.takeoff_time_scheduled;
              if (self[ref].state.engine_start_time) engine_start_time = self[ref].state.date + ' ' + self[ref].state.engine_start_time;
              if (self[ref].state.takeoff_time) takeoff_time = self[ref].state.date + ' ' + self[ref].state.takeoff_time;
              if (self[ref].state.landing_time) landing_time = self[ref].state.date + ' ' + self[ref].state.landing_time;
              if (self[ref].state.engine_shutoff_time) engine_shutoff_time = self[ref].state.date + ' ' + self[ref].state.engine_shutoff_time;

              if (takeoff_time_scheduled) takeoff_time_scheduled = __WEBPACK_IMPORTED_MODULE_8_moment___default()(takeoff_time_scheduled, "DD/MM/YYYY HH:mm:ss");
              if (engine_start_time) engine_start_time = __WEBPACK_IMPORTED_MODULE_8_moment___default()(engine_start_time, "DD/MM/YYYY HH:mm:ss");
              if (takeoff_time) takeoff_time = __WEBPACK_IMPORTED_MODULE_8_moment___default()(takeoff_time, "DD/MM/YYYY HH:mm:ss");
              if (landing_time) landing_time = __WEBPACK_IMPORTED_MODULE_8_moment___default()(landing_time, "DD/MM/YYYY HH:mm:ss");
              if (engine_shutoff_time) engine_shutoff_time = __WEBPACK_IMPORTED_MODULE_8_moment___default()(engine_shutoff_time, "DD/MM/YYYY HH:mm:ss");

              if (takeoff_time_scheduled) {
                var diff_hours = takeoff_time_scheduled.diff(takeoff_time, 'hours');
                if (takeoff_time < takeoff_time_scheduled && diff_hours > 12) {
                  if (engine_start_time) engine_start_time.add(1, 'd');
                  if (takeoff_time) takeoff_time.add(1, 'd');
                  if (landing_time) landing_time.add(1, 'd');
                  if (engine_shutoff_time) engine_shutoff_time.add(1, 'd');
                }
              }

              if (takeoff_time > landing_time) {
                if (landing_time) landing_time.add(1, 'd');
              }

              if (engine_start_time > engine_shutoff_time) {
                if (engine_shutoff_time) engine_shutoff_time.add(1, 'd');
              }

              if (engine_start_time) engine_start_time = engine_start_time.format("YYYY-MM-DD HH:mm:ss");
              if (takeoff_time) takeoff_time = takeoff_time.format("YYYY-MM-DD HH:mm:ss");
              if (landing_time) landing_time = landing_time.format("YYYY-MM-DD HH:mm:ss");
              if (engine_shutoff_time) engine_shutoff_time = engine_shutoff_time.format("YYYY-MM-DD HH:mm:ss");
              if (takeoff_time_scheduled) takeoff_time_scheduled = takeoff_time_scheduled.format("YYYY-MM-DD HH:mm:ss");

              var datasave = {
                origin: 'Manual',
                flight_report_id: self[ref].state.flight_report_id,
                leg_number: self[ref].state.leg_number,
                departure_location_id: self[ref].state.departure_location_id,
                arrival_location_id: self[ref].state.arrival_location_id,
                takeoff_time_scheduled: takeoff_time_scheduled,
                total_time_scheduled: self[ref].state.total_time_scheduled,
                engine_start_time: engine_start_time,
                takeoff_time: takeoff_time,
                landing_time: landing_time,
                engine_shutoff_time: engine_shutoff_time,
                takeoff_land_time: self[ref].state.takeoff_land_time,
                total_time: self[ref].state.total_time,
                navigation_time: self[ref].state.navigation_time,
                ifr_time: self[ref].state.ifr_time,
                night_time: self[ref].state.night_time,
                day_landings: self[ref].state.day_landings,
                night_landings: self[ref].state.night_landings,
                starts: self[ref].state.starts,
                pax: self[ref].state.pax,
                payload: self[ref].state.payload,
                external_load_long_line: self[ref].state.external_load_long_line,
                external_load_short_line: self[ref].state.external_load_short_line,
                fuel_start: self[ref].state.fuel_start,
                fuel_end: self[ref].state.fuel_end,
                ptbr_code_id: self[ref].state.ptbr_code_id,
                ptbr_operation_id: self[ref].state.ptbr_operation_id,
                ptbr_external_load_id: self[ref].state.ptbr_external_load_id,
                delay_time: self[ref].state.delay_time,
                delay_departure: self[ref].state.delay_departure,
                custom_items: self[ref].state.custom_items
              };

              data_legs.push(datasave);
            });
          }
          var data = {};
          data.flight_report_id = this.props.flight_report_id;
          data.legs = data_legs;
          this.props.handleAlert('', '', 'open');
          var header = this.refs.request_api.header('application/json');
          var self = this;
          Promise.resolve(header).then(function (value) {
            fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/trecho/salvar/todos', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(data) }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.refs.request_api.validate(responseJson, 'alert');
              responseJson.errors_save = false;

              if (responseJson.status === 'success') {
                localStorage.removeItem('cached_flight_report_legs_states_by_id');
                localStorage.removeItem('cached_flight_report_legs_states_new_by_id');
                self.setState({ flight_report_legs_new: [] });

                responseJson.errors_save = true;
              }

              if (responseJson.status === 'error') {
                responseJson.errors_save = true;
              }

              self.props.saveAllUpdate(responseJson);
            }).catch(function (error) {
              console.error(error);
            });
          });
        }
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      var start_parameter_total = null;
      var total = 1;
      var style = {
        form: { width: '100%', height: 'auto', overflowX: 'auto', whiteSpace: 'nowrap' },
        input_hour: { width: '75px', textAlign: 'center' },
        select_places: { width: '130px' },
        select_operation: { width: '240px' },
        input_number: { width: '70px', textAlign: 'center' },
        // Campos específicos mais largos para leitura
        input_fuel: { width: '110px', textAlign: 'center' },
        input_custom: { minWidth: '120px' },
        divs: { display: 'inline-block', marginRight: '15px' }
      };
      var define_leg_number = 0;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloCadastrarTrecho
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: this.addMobile, className: 'visible-xs' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.Origem
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'departure_location_id',
                value: this.state.departure_location_id,
                searchable: true,
                placeholder: '',
                onChange: this.handleSelectChange.bind(this, 'departure_location_id'),
                options: this.state.locations_select
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.Destino
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'arrival_location_id',
                value: this.state.arrival_location_id,
                searchable: true,
                placeholder: '',
                onChange: this.handleSelectChange.bind(this, 'arrival_location_id'),
                options: this.state.locations_select
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.Partida
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.engine_start_time, maskChar: null, name: 'engine_start_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'engine_start_time'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.DEC
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.takeoff_time, maskChar: null, name: 'takeoff_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'takeoff_time'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.POU
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.landing_time, maskChar: null, name: 'landing_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'landing_time'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.Corte
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.engine_shutoff_time, maskChar: null, name: 'engine_shutoff_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'engine_shutoff_time'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.DECPOU
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.takeoff_land_time, maskChar: null, name: 'takeoff_land_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'takeoff_land_time'), placeholder: '', disabled: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.Total
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.total_time, maskChar: null, name: 'total_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'total_time'), placeholder: '', disabled: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.Nav
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.navigation_time, maskChar: null, name: 'navigation_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'navigation_time'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.IFR
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.ifr_time, maskChar: null, name: 'ifr_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'ifr_time'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.Noturno
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.night_time, maskChar: null, name: 'night_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'night_time'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.Diurnos
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.day_landings, name: 'day_landings ', className: 'form-control', onChange: this.handleChange.bind(this, 'day_landings'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.Noturnos
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.night_landings, name: 'night_landings ', className: 'form-control', onChange: this.handleChange.bind(this, 'night_landings'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.Partidas
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.starts, name: 'starts ', className: 'form-control', onChange: this.handleChange.bind(this, 'starts'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.PAX
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.pax, name: 'pax ', className: 'form-control', onChange: this.handleChange.bind(this, 'pax'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.Carga
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.payload, name: 'payload ', className: 'form-control', onChange: this.handleChange.bind(this, 'payload'), placeholder: '' })
            ),
            this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 col-xs-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.LongLine
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
                checked: this.state.external_load_long_line,
                'aria-label': 'No label tag',
                name: 'external_load_long_line',
                onChange: this.handleToggleChange.bind(this, 'external_load_long_line') })
            ) : '',
            this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 col-xs-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.ShortLine
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
                checked: this.state.external_load_short_line,
                'aria-label': 'No label tag',
                name: 'external_load_short_line',
                onChange: this.handleToggleChange.bind(this, 'external_load_short_line') })
            ) : '',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.Inicial
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.fuel_start, name: 'fuel_start ', className: 'form-control', style: style.input_fuel, onChange: this.handleChange.bind(this, 'fuel_start'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.Final
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.fuel_end, name: 'fuel_end ', className: 'form-control', style: style.input_fuel, onChange: this.handleChange.bind(this, 'fuel_end'), placeholder: '' })
            ),
            Object.keys(self.state.aircraft_model_version_custom_items).length > 0 ? Object.keys(self.state.aircraft_model_version_custom_items).map(function (k) {
              var custom_item = self.state.aircraft_model_version_custom_items[k];
              var id = custom_item.id;
              var inputElement = void 0;
              if (custom_item.type === 'text' || custom_item.type === 'number') {
                inputElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                  type: custom_item.type,
                  name: id,
                  id: 'custom-item-id-' + id,
                  className: 'form-control',
                  style: style.input_custom,
                  onChange: function onChange(event) {
                    return self.handleCustomItem(id, event);
                  },
                  value: self.state.custom_items[id] || '',
                  placeholder: ''
                });
              } else if (custom_item.type === 'hour') {
                inputElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, {
                  name: id,
                  id: 'custom-item-id-' + id,
                  className: 'form-control',
                  style: style.input_custom,
                  onChange: function onChange(event) {
                    return self.handleCustomItem(id, event);
                  },
                  value: self.state.custom_items[id] || '',
                  placeholder: 'hh:mm',
                  mask: '99:99'
                });
              } else if (custom_item.type === 'options') {
                var optionValues = Array.isArray(custom_item.options) ? custom_item.options : [];
                inputElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'select',
                  {
                    name: id,
                    id: 'custom-item-id-' + id,
                    className: 'form-control',
                    style: style.input_custom,
                    onChange: function onChange(event) {
                      return self.handleCustomItem(id, event);
                    },
                    value: self.state.custom_items[id] || ''
                  },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'option',
                    { value: '' },
                    self.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.SelecioneOpcao
                  ),
                  optionValues.map(function (optionValue, optionIndex) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'option',
                      { value: optionValue, key: 'custom-item-option-' + id + '-' + optionIndex },
                      optionValue
                    );
                  })
                );
              } else {
                inputElement = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                  name: id,
                  className: 'form-control',
                  style: style.input_custom,
                  value: custom_item.value,
                  onChange: self.handleChangeDecimal.bind(self, k),
                  placeholder: 'hh.m'
                });
              }
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-3 form-group', key: id },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  custom_item.name
                ),
                inputElement
              );
            }) : '',
            this.state.xml == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.CodigoPTBR,
                ' \xA0\xA0',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'button', onClick: function onClick() {
                      return _this2.exportPtbrCode();
                    }, className: 'btn btn-success btn-xs' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'ptbr_code_id',
                value: this.state.ptbr_code_id,
                searchable: true,
                placeholder: '',
                onChange: this.handleSelectChange.bind(this, 'ptbr_code_id'),
                options: this.state.ptbr_codes_select
              })
            ) : ''
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'submit', className: 'btn btn-primary btn-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
            ' ',
            this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.botaoAdicionarTrecho
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { colSpan: 4 }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 9, className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Realizados
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 2, className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Pousos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 3, className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Dados
                ),
                this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 2, className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.CargaExterna
                ) : '',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 2, className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Combustivel
                ),
                Object.keys(this.state.aircraft_model_version_custom_items || {}).length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: Object.keys(this.state.aircraft_model_version_custom_items).length, className: 'text-center' },
                  'Itens Personalizados'
                ) : '',
                this.state.xml == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 1, className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.OperacaoPTBR,
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', onClick: function onClick() {
                        return _this2.exportPtbrCode();
                      }, className: 'btn btn-success btn-xs' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' })
                  )
                ) : '',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Acoes
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { className: 'text-center' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Numero
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Origem
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Destino
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Partida
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.DEC
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.POU
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Corte
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.DECPOU
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Total
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Nav
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.IFR
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Noturno
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Diurnos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Noturnos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Partidas
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.PAX
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Carga
                ),
                this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.LongLine
                ) : '',
                this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.ShortLine
                ) : '',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Inicial
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.Final
                ),
                this.state.xml == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaCadastrarTrecho.CodigoPTBR,
                  ' '
                ) : '',
                Object.keys(self.state.aircraft_model_version_custom_items).length > 0 && Object.keys(self.state.aircraft_model_version_custom_items).map(function (k) {
                  var custom_item = self.state.aircraft_model_version_custom_items[k];
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    { className: 'text-center' },
                    custom_item.name
                  );
                }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { className: 'text-center', style: { width: '200px' } })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              null,
              Object.keys(self.state.flight_report_legs).map(function (k) {
                var srl = self.state.flight_report_legs[k];
                var flight_report_leg_edit = self.state.flight_report_legs[k];
                var cached_flight_report_legs_states_by_id = {};
                if (localStorage.getItem("cached_flight_report_legs_states_by_id")) {
                  cached_flight_report_legs_states_by_id = localStorage.getItem("cached_flight_report_legs_states_by_id");
                  cached_flight_report_legs_states_by_id = JSON.parse(cached_flight_report_legs_states_by_id);
                }

                if (cached_flight_report_legs_states_by_id[srl.id]) {
                  flight_report_leg_edit = cached_flight_report_legs_states_by_id[srl.id];
                }

                var last_index = parseInt(k) - 1;
                if (typeof self.state.flight_report_legs[last_index] !== 'undefined') {
                  if (self.state.flight_report_legs[last_index].engine_shutoff_time === null || self.state.flight_report_legs[last_index].engine_shutoff_time === '' || typeof self.state.flight_report_legs[last_index].engine_shutoff_time === 'undefined') {
                    start_parameter_total = self.state.flight_report_legs[last_index].landing_time;
                  }
                }
                var index = self.state.flight_report_legs.length;
                index--;
                var edit = false;
                if (parseInt(k) === index || srl.status === 'Incomplete') {
                  edit = true;
                }
                var child_state = 'child_leg_' + srl.leg_number;
                define_leg_number = parseInt(srl.leg_number) + 1;

                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__FlightReportLegEditTab__["a" /* default */], { ref: function ref(leg_data) {
                    self[child_state] = leg_data;
                  }, external_load: self.state.external_load, xml: self.state.xml, updateData: self.props.updateData, updated: self.props.updated, handleAlert: self.props.handleAlert, aircraft_model_version_custom_items: self.props.aircraft_model_version_custom_items, flight_report_leg_edit: flight_report_leg_edit, flight_report_leg_edit_staffs: srl.flight_report_leg_staffs, locations_select: self.state.locations_select, ptbr_codes_select: self.state.ptbr_codes_select, ptbr_operations_select: self.state.ptbr_operations_select, ptbr_external_loads_select: self.state.ptbr_external_loads_select, staffs_select: self.state.staffs_select, duties_select: self.state.duties_select, date: self.state.date, style: style, edit: edit, start_parameter_total: start_parameter_total });
              }),
              self.state.status == 1 && Object.keys(self.state.flight_report_legs_new).map(function (k) {
                define_leg_number = parseInt(define_leg_number) + 1;
                var flight_report_id = self.state.flight_report_id;
                var srl = self.state.flight_report_legs_new[k];
                var flight_report_leg_edit = self.state.flight_report_legs_new[k];
                var cached_flight_report_legs_states_new_by_id = {};
                if (localStorage.getItem("cached_flight_report_legs_states_new_by_id")) {
                  cached_flight_report_legs_states_new_by_id = JSON.parse(localStorage.getItem("cached_flight_report_legs_states_new_by_id"));
                  if (!cached_flight_report_legs_states_new_by_id[flight_report_id]) {
                    cached_flight_report_legs_states_new_by_id[flight_report_id] = srl;
                  }
                } else {
                  cached_flight_report_legs_states_new_by_id[flight_report_id] = srl;
                }

                if (cached_flight_report_legs_states_new_by_id[flight_report_id][k]) {
                  flight_report_leg_edit = cached_flight_report_legs_states_new_by_id[flight_report_id][k];
                }

                var last_index = parseInt(k) - 1;
                if (typeof self.state.flight_report_legs_new[last_index] !== 'undefined') {
                  if (self.state.flight_report_legs_new[last_index].engine_shutoff_time === null || self.state.flight_report_legs_new[last_index].engine_shutoff_time === '' || typeof self.state.flight_report_legs_new[last_index].engine_shutoff_time === 'undefined') {
                    start_parameter_total = self.state.flight_report_legs_new[last_index].landing_time;
                  }
                }
                var index = self.state.flight_report_legs_new.length;
                index--;
                var edit = false;
                if (parseInt(k) === index || srl.status === 'Incomplete') {
                  edit = true;
                }
                var child_state = 'child_leg_' + define_leg_number;

                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FlightReportLegAddTab__["a" /* default */], { ref: function ref(leg_data) {
                    self[child_state] = leg_data;
                  }, external_load: self.state.external_load, xml: self.state.xml, updateData: self.props.updateData, updated: self.props.updated, handleAlert: self.props.handleAlert, aircraft_model_version_custom_items: self.props.aircraft_model_version_custom_items, flight_report_leg_edit: flight_report_leg_edit, flight_report_leg_edit_staffs: srl.flight_report_leg_staffs, locations_select: self.state.locations_select, ptbr_codes_select: self.state.ptbr_codes_select, ptbr_operations_select: self.state.ptbr_operations_select, ptbr_external_loads_select: self.state.ptbr_external_loads_select, staffs_select: self.state.staffs_select, duties_select: self.state.duties_select, date: self.state.date, style: style, edit: edit, start_parameter_total: start_parameter_total, flight_report_legs_states_new_index: k, setParentState: self.setParentState, setDeleteFalse: self.setDeleteFalse, deleting: self.state.deleting, flight_report_id: flight_report_id });
              }),
              self.state.status == 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { style: { width: '200px', whiteSpace: 'nowrap' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-primary btn-sm', onClick: function onClick() {
                        self.add();
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-plus' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    style: style.select_places,
                    name: 'departure_location_id',
                    value: this.state.departure_location_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'departure_location_id'),
                    options: this.state.locations_select

                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    style: style.select_places,
                    name: 'arrival_location_id',
                    value: this.state.arrival_location_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'arrival_location_id'),
                    options: this.state.locations_select

                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: style.input_hour, value: this.state.engine_start_time, maskChar: null, name: 'engine_start_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'engine_start_time'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: style.input_hour, value: this.state.takeoff_time, maskChar: null, name: 'takeoff_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'takeoff_time'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: style.input_hour, value: this.state.landing_time, maskChar: null, name: 'landing_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'landing_time'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: style.input_hour, value: this.state.engine_shutoff_time, maskChar: null, name: 'engine_shutoff_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'engine_shutoff_time'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: style.input_hour, value: this.state.takeoff_land_time, maskChar: null, name: 'takeoff_land_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'takeoff_land_time'), placeholder: '', disabled: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: style.input_hour, value: this.state.total_time, maskChar: null, name: 'total_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'total_time'), placeholder: '', disabled: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: style.input_hour, value: this.state.navigation_time, maskChar: null, name: 'navigation_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'navigation_time'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: style.input_hour, value: this.state.ifr_time, maskChar: null, name: 'ifr_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'ifr_time'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: style.input_hour, value: this.state.night_time, maskChar: null, name: 'night_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'night_time'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: style.input_number, type: 'number', value: this.state.day_landings, name: 'day_landings ', className: 'form-control', onChange: this.handleChange.bind(this, 'day_landings'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: style.input_number, type: 'number', value: this.state.night_landings, name: 'night_landings ', className: 'form-control', onChange: this.handleChange.bind(this, 'night_landings'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: style.input_number, type: 'number', value: this.state.starts, name: 'starts ', className: 'form-control', onChange: this.handleChange.bind(this, 'starts'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: style.input_number, type: 'number', value: this.state.pax, name: 'pax ', className: 'form-control', onChange: this.handleChange.bind(this, 'pax'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: style.input_number, type: 'number', value: this.state.payload, name: 'payload ', className: 'form-control', onChange: this.handleChange.bind(this, 'payload'), placeholder: '' })
                ),
                this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
                    checked: this.state.external_load_long_line,
                    'aria-label': 'No label tag',
                    name: 'external_load_long_line',
                    onChange: this.handleToggleChange.bind(this, 'external_load_long_line') })
                ) : '',
                this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
                    checked: this.state.external_load_short_line,
                    'aria-label': 'No label tag',
                    name: 'external_load_short_line',
                    onChange: this.handleToggleChange.bind(this, 'external_load_short_line') })
                ) : '',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: style.input_fuel, type: 'number', value: this.state.fuel_start, name: 'fuel_start ', className: 'form-control', onChange: this.handleChange.bind(this, 'fuel_start'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: style.input_fuel, type: 'number', value: this.state.fuel_end, name: 'fuel_end ', className: 'form-control', onChange: this.handleChange.bind(this, 'fuel_end'), placeholder: '' })
                ),
                Object.keys(self.state.aircraft_model_version_custom_items || {}).length > 0 && Object.keys(self.state.aircraft_model_version_custom_items).map(function (k) {
                  var custom_item = self.state.aircraft_model_version_custom_items[k];
                  var id = custom_item.id;
                  var cellInput = void 0;
                  if (custom_item.type === 'text' || custom_item.type === 'number') {
                    cellInput = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      type: custom_item.type,
                      name: id,
                      id: 'custom-item-id-' + id,
                      className: 'form-control',
                      style: style.input_custom,
                      onChange: function onChange(event) {
                        return self.handleCustomItem(id, event);
                      },
                      value: self.state.custom_items[id] || '',
                      placeholder: ''
                    });
                  } else if (custom_item.type === 'hour') {
                    cellInput = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, {
                      name: id,
                      id: 'custom-item-id-' + id,
                      className: 'form-control',
                      style: style.input_custom,
                      onChange: function onChange(event) {
                        return self.handleCustomItem(id, event);
                      },
                      value: self.state.custom_items[id] || '',
                      placeholder: 'hh:mm',
                      mask: '99:99'
                    });
                  } else if (custom_item.type === 'options') {
                    var optionValues = Array.isArray(custom_item.options) ? custom_item.options : [];
                    cellInput = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'select',
                      {
                        name: id,
                        id: 'custom-item-id-' + id,
                        className: 'form-control',
                        style: style.input_custom,
                        onChange: function onChange(event) {
                          return self.handleCustomItem(id, event);
                        },
                        value: self.state.custom_items[id] || ''
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'option',
                        { value: '' },
                        self.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTrecho.SelecioneOpcao
                      ),
                      optionValues.map(function (optionValue, indexOption) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'option',
                          { value: optionValue, key: 'custom-item-option-' + id + '-' + indexOption },
                          optionValue
                        );
                      })
                    );
                  } else {
                    cellInput = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      name: id,
                      className: 'form-control',
                      style: style.input_custom,
                      value: custom_item.value,
                      onChange: self.handleChangeDecimal.bind(self, k),
                      placeholder: 'hh.m'
                    });
                  }
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { key: 'citem-td-' + id },
                    cellInput
                  );
                }),
                this.state.xml == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    name: 'ptbr_code_id',
                    value: this.state.ptbr_code_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'ptbr_code_id'),
                    options: this.state.ptbr_codes_select,
                    style: style.select_operation
                  })
                ) : '',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { style: { width: '200px', whiteSpace: 'nowrap', textAlign: 'center' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-primary btn-sm', onClick: function onClick() {
                        self.add();
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-plus' })
                  )
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { onClick: function onClick() {
              self.saveAll();
            }, className: 'btn btn-success btn-block btn-lg' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-save' }),
          ' ',
          this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.botaoSalvarTodos
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          { className: 'page-title' },
          this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloTotaisDosTrechos
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTotaisDosTrechos.DecolagemPouso
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTotaisDosTrechos.TempoTotal
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTotaisDosTrechos.Navegacao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTotaisDosTrechos.Instrumento
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTotaisDosTrechos.Noturno
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTotaisDosTrechos.PousosDiurnos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTotaisDosTrechos.PousosNoturnos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTotaisDosTrechos.Pax
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTotaisDosTrechos.Carga
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTotaisDosTrechos.Consumo
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  self.state.flight_report_legs_totals.takeoff_land_time_total
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  self.state.flight_report_legs_totals.time_total
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  self.state.flight_report_legs_totals.navigation_total
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  self.state.flight_report_legs_totals.ifr_total
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  self.state.flight_report_legs_totals.night_total
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  self.state.flight_report_legs_totals.day_landings_total
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  self.state.flight_report_legs_totals.night_landings_total
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  self.state.flight_report_legs_totals.pax_total
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  self.state.flight_report_legs_totals.payload_total
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  self.state.flight_report_legs_totals.fuel_total
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FlightReportLegsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportLegsTab);

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário





var FlightReportLogsTab = function (_Component) {
  _inherits(FlightReportLogsTab, _Component);

  function FlightReportLogsTab(props) {
    _classCallCheck(this, FlightReportLogsTab);

    var _this = _possibleConstructorReturn(this, (FlightReportLogsTab.__proto__ || Object.getPrototypeOf(FlightReportLogsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      flight_report_logs: {}
    };

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers

  // LM


  _createClass(FlightReportLogsTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.flight_report_logs) || this.state.loaded === 1 && newProps.updated === 1) {
        this.setState({
          flight_report_logs: newProps.flight_report_logs,
          loaded: 1
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'page-title' },
            this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloLogDoRelatorio
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'table-responsive' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'table',
              { className: 'table table-bordered table-hover table-striped' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'thead',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaLogRelatorio.Usuario
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaLogRelatorio.Acao
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaLogRelatorio.Descricao
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaLogRelatorio.Data
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tbody',
                null,
                Object.keys(self.state.flight_report_logs).map(function (k) {
                  var srl = self.state.flight_report_logs[k];
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      srl.user_name
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      srl.action
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      srl.message
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      srl.created_at_str
                    )
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);

  return FlightReportLogsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportLogsTab);

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário


var FlightReportOcurrencesTab = function (_Component) {
  _inherits(FlightReportOcurrencesTab, _Component);

  function FlightReportOcurrencesTab(props) {
    _classCallCheck(this, FlightReportOcurrencesTab);

    var _this = _possibleConstructorReturn(this, (FlightReportOcurrencesTab.__proto__ || Object.getPrototypeOf(FlightReportOcurrencesTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      modal: false,
      flight_report_id: _this.props.flight_report_id,
      flight_report_occurrences: _this.props.flight_report_occurrences,
      abnormal_occurrence_types_select: _this.props.abnormal_occurrence_types_select,
      flight_report_legs_select: _this.props.flight_report_legs_select,
      flight_report: _this.props.flight_report,
      flight_report_leg_id: null,
      abnormal_occurrence_type_id: null,
      observations: null
    };

    //bind específico
    _this.add = _this.add.bind(_this);
    _this.delete = _this.delete.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(FlightReportOcurrencesTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (typeof this.state.fuel_type === 'undefined' || this.state.loaded === 1 && newProps.updated === 1) {
        this.setState({
          flight_report_id: newProps.flight_report_id,
          fuel_type: newProps.fuel_type,
          flight_report_occurrences: newProps.flight_report_occurrences,
          abnormal_occurrence_types_select: newProps.abnormal_occurrence_types_select,
          flight_report_legs_select: newProps.flight_report_legs_select,
          flight_report: newProps.flight_report,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição

  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      if (navigator.onLine) {
        this.props.handleAlert('', '', 'open');
        var datasave = {
          flight_report_id: this.state.flight_report_id,
          flight_report_leg_id: this.state.flight_report_leg_id,
          abnormal_occurrence_type_id: this.state.abnormal_occurrence_type_id,
          observations: this.state.observations
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/ocorrencia', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
          }).catch(function (error) {
            console.error(error);
          });
        });
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'delete',
    value: function _delete(id) {
      if (navigator.onLine) {
        if (window.confirm('Tem certeza que deseja excluir essa ocorrência?')) {
          this.props.handleAlert('', '', 'open');
          var datasave = {
            id: id
          };
          var header = this.refs.request_api.header('application/json');
          var self = this;
          Promise.resolve(header).then(function (value) {
            fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/ocorrencia', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.refs.request_api.validate(responseJson, 'alert');
              self.props.updateData(responseJson);
            }).catch(function (error) {
              console.error(error);
            });
          });
        }
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          'Cadastrar ocorr\xEAncias anormais'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: this.add },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Trecho:'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'flight_report_leg_id',
                value: this.state.flight_report_leg_id,
                searchable: true,
                placeholder: '',
                onChange: this.handleSelectChange.bind(this, 'flight_report_leg_id'),
                options: this.state.flight_report_legs_select,
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Tipo:'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'abnormal_occurrence_type_id',
                value: this.state.abnormal_occurrence_type_id,
                searchable: true,
                placeholder: '',
                onChange: this.handleSelectChange.bind(this, 'abnormal_occurrence_type_id'),
                options: this.state.abnormal_occurrence_types_select,
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Observa\xE7\xF5es:'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'observations', className: 'form-control', placeholder: '', value: this.state.observations, onChange: this.handleChange.bind(this, 'observations'), required: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-block btn-inline' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                ' Adicionar ocorr\xEAncia'
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          { className: 'page-title' },
          'Ocorr\xEAncias cadastradas'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Trecho'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Tipo'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Observa\xE7\xF5es'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'col-md-1 text-center' },
                  'A\xE7\xF5es'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              null,
              Object.keys(self.state.flight_report_occurrences).map(function (k) {
                var srr = self.state.flight_report_occurrences[k];
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srr.flight_report_leg === null ? '' : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      null,
                      srr.flight_report_leg.leg_number
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srr.abnormal_occurrence_type.type
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srr.observations
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { onClick: function onClick() {
                          return self.delete(srr.id);
                        }, className: 'btn btn-danger btn-sm' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-trash' })
                    )
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);

  return FlightReportOcurrencesTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (FlightReportOcurrencesTab);

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário




// Importo o moment com a linguagem pt-br
__webpack_require__(24);
__webpack_require__(32);

var FlightReportOfflineEditTab = function (_Component) {
  _inherits(FlightReportOfflineEditTab, _Component);

  function FlightReportOfflineEditTab(props) {
    _classCallCheck(this, FlightReportOfflineEditTab);

    var _this = _possibleConstructorReturn(this, (FlightReportOfflineEditTab.__proto__ || Object.getPrototypeOf(FlightReportOfflineEditTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      show_select_clients: 0,
      id: _this.props.flight_report_id,
      aircraft: _this.props.flight_report.aircraft,
      base: _this.props.flight_report.base,
      contract: _this.props.flight_report.contract,
      flight_type: _this.props.flight_report.flight_type,
      staff_sigmec: _this.props.flight_report.staff_sigmec,
      client_name: _this.props.flight_report.client_name,
      date: _this.props.flight_report.date_str,
      flight_number: _this.props.flight_report.flight_number,
      exemption: _this.props.flight_report.exemption,
      exemption_str: _this.props.flight_report.exemption_str,
      observations: _this.props.flight_report.observations
    };

    return _this;
  }

  // LM


  _createClass(FlightReportOfflineEditTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (typeof this.state.date === 'undefined' || this.state.loaded === 1 && newProps.updated === 1) {
        this.setState({
          id: newProps.id,
          aircraft_id: newProps.flight_report.aircraft_id,
          base: newProps.flight_report.base,
          contract: newProps.flight_report.contract,
          flight_type: newProps.flight_report.flight_type,
          staff_sigmec: newProps.flight_report.staff_sigmec,
          client_name: newProps.flight_report.client_name,
          show_select_clients: newProps.flight_report.show_select_clients,
          date: newProps.flight_report.date_str,
          flight_number: newProps.flight_report.flight_number,
          exemption: newProps.flight_report.exemption,
          exemption_str: newProps.flight_report.exemption_str,
          observations: newProps.flight_report.observations,
          loaded: 1
        });
        if (!newProps.flight_report.flight_number || newProps.flight_report.flight_number === null) {
          this.setState({
            flight_number: ''
          });
        }
      }
    }

    // Fetch salvando a edição

  }, {
    key: 'edit',
    value: function edit(event) {
      event.preventDefault();
      if (navigator.onLine) {
        this.props.handleAlert('', '', 'open');
        var datasave = {
          id: this.state.id,
          aircraft_id: this.state.aircraft_id,
          base_id: this.state.base_id,
          contract_id: this.state.contract_id,
          flight_type_id: this.state.flight_type_id,
          staff_sigmec_id: this.state.staff_sigmec_id,
          client_id: this.state.client_id,
          date: this.state.date,
          flight_number: this.state.flight_number,
          exemption: this.state.exemption,
          observations: this.state.observations
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
          }).catch(function (error) {
            console.error(error);
          });
        });
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-3 form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              null,
              'Data:'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            this.state.date
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-3 form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              null,
              'Prefixo:'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            this.state.aircraft
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-3 form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              null,
              'Voo:'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            this.state.flight_type
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-3 form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              null,
              'N\xFAmero de voo:'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            this.state.flight_number
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-3 form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              null,
              'Solicitou isen\xE7\xE3o'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            this.state.exemption_str
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-3 form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              null,
              'Base:'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            this.state.base
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-3 form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              null,
              'Contrato:'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            this.state.contract
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-3 form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              null,
              'Mec\xE2nico respons\xE1vel:'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            this.state.staff_sigmec
          )
        ),
        this.state.show_select_clients == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-3 form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              null,
              'Cliente'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            this.state.client_name
          )
        ) : '',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
      );
    }
  }]);

  return FlightReportOfflineEditTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportOfflineEditTab);

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FlightReportOfflineLegEditViewTab__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FlightReportOfflineLegEditTab__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário









var FlightReportOfflineLegsTab = function (_Component) {
  _inherits(FlightReportOfflineLegsTab, _Component);

  function FlightReportOfflineLegsTab(props) {
    _classCallCheck(this, FlightReportOfflineLegsTab);

    var _this = _possibleConstructorReturn(this, (FlightReportOfflineLegsTab.__proto__ || Object.getPrototypeOf(FlightReportOfflineLegsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      modal_alerts: false,
      loaded: false,
      modal: false,
      flight_report_id: null,
      departure_location_id: null,
      arrival_location_id: null,
      date: null,
      leg_number: null,
      takeoff_scheduled: null,
      total_time_preview: null,
      engine_start_time: null,
      start_parameter_total: null,
      takeoff_time: null,
      landing_time: null,
      engine_shutoff_time: null,
      takeoff_land_time: '00:00',
      total_time: '00:00',
      navigation_time: '00:00',
      ifr_time: '00:00',
      night_time: '00:00',
      day_landings: 0,
      night_landings: 0,
      starts: null,
      pax: 0,
      payload: 0,
      external_load_long_line: 0,
      external_load_short_line: 0,
      fuel_start: 0,
      fuel_end: 0,
      ptbr_code_id: null,
      ptbr_operation_id: null,
      ptbr_external_load_id: null,
      delay_time: '00:00',
      delay_departure: '00:00',
      flight_report_legs: {},
      flight_report_legs_view: {},
      locations_select: [],
      ptbr_codes_select: [],
      ptbr_operations_select: [],
      ptbr_external_loads_select: [],
      staffs_select: [],
      duties_select: [],
      flight_report_leg_edit: {},
      flight_report_leg_edit_staffs: {},
      frl_alerts: {}
    };

    _this.add = _this.add.bind(_this);
    _this.addMobile = _this.addMobile.bind(_this);
    _this.diffFlight = _this.diffFlight.bind(_this);
    _this.diffTotalTime = _this.diffTotalTime.bind(_this);
    _this.delayFlight = _this.delayFlight.bind(_this);
    _this.delayTotalTime = _this.delayTotalTime.bind(_this);
    _this.calcTimeFromMs = _this.calcTimeFromMs.bind(_this);
    _this.autoFillTime = _this.autoFillTime.bind(_this);
    _this.openModal = _this.openModal.bind(_this);
    _this.delete = _this.delete.bind(_this);
    _this.saveOnline = _this.saveOnline.bind(_this);
    return _this;
  }

  _createClass(FlightReportOfflineLegsTab, [{
    key: 'autoFillTime',
    value: function autoFillTime(name) {

      var now = __WEBPACK_IMPORTED_MODULE_9_moment___default()(new Date());
      now = now.format("HH:mm");
      var change = {};
      change[name] = now;
      if (name === 'takeoff_time') {
        this.diffFlight(now, this.state.landing_time, change);
        this.delayFlight(now, this.state.takeoff_scheduled, change);
        this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, now, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'landing_time') {
        this.diffFlight(this.state.takeoff_time, now, change);
        this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, this.state.takeoff_time, now, this.state.start_parameter_total, change);
      } else if (name === 'engine_start_time') {
        this.diffTotalTime(now, this.state.engine_shutoff_time, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'engine_shutoff_time') {
        this.diffTotalTime(this.state.engine_start_time, now, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'takeoff_scheduled') {
        this.delayFlight(this.state.takeoff_time, now, change);
      } else if (name === 'total_time_preview') {
        this.delayTotalTime(now, this.state.takeoff_land_time, change);
      } else {
        this.setState(change);
      }
    }

    // Handlers

  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      if (name === 'takeoff_time') {
        this.diffFlight(event.target.value, this.state.landing_time, change);
        this.delayFlight(event.target.value, this.state.takeoff_scheduled, change);
        this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, event.target.value, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'landing_time') {
        this.diffFlight(this.state.takeoff_time, event.target.value, change);
        this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, this.state.takeoff_time, event.target.value, this.state.start_parameter_total, change);
      } else if (name === 'engine_start_time') {
        this.diffTotalTime(event.target.value, this.state.engine_shutoff_time, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'engine_shutoff_time') {
        this.diffTotalTime(this.state.engine_start_time, event.target.value, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'takeoff_scheduled') {
        this.delayFlight(this.state.takeoff_time, event.target.value, change);
      } else if (name === 'total_time_preview') {
        this.delayTotalTime(event.target.value, this.state.takeoff_land_time, change);
      } else {
        this.setState(change);
      }
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.flight_report_legs_view) || this.state.loaded === 1 && newProps.updated === 1) {
        var index = newProps.flight_report_legs_view.length - 1;
        var start_parameter_total = null;
        if (typeof newProps.flight_report_legs_view[index] !== 'undefined') {
          if (newProps.flight_report_legs_view[index].engine_shutoff_time === null || newProps.flight_report_legs_view[index].engine_shutoff_time === '' || typeof newProps.flight_report_legs_view[index].engine_shutoff_time === 'undefined') {
            start_parameter_total = newProps.flight_report_legs_view[index].landing_time;
          }
        }

        this.setState({
          flight_report_id: newProps.flight_report_id,
          flight_report_legs_view: newProps.flight_report_legs_view,
          locations_select: newProps.locations_select,
          ptbr_codes_select: newProps.ptbr_codes_select,
          staffs_select: newProps.staffs_select,
          duties_select: newProps.duties_select,
          date: newProps.flight_report.date_str,
          external_load: newProps.flight_report.external_load,
          xml: newProps.flight_report.xml,
          status: newProps.flight_report.status,
          start_parameter_total: start_parameter_total,
          loaded: 1
        });
      }

      var new_flight_report_legs = JSON.parse(localStorage.getItem("new_flight_report_legs_full"));
      if (new_flight_report_legs !== 'undefined' && new_flight_report_legs !== null && new_flight_report_legs !== undefined) {
        this.setState({ flight_report_legs: new_flight_report_legs });
      }
    }
  }, {
    key: 'openModal',
    value: function openModal(modal_errors) {
      this.setState({ frl_alerts: modal_errors, modal_alerts: true });
    }

    // Fetch salvando a adição mobile

  }, {
    key: 'addMobile',
    value: function addMobile(event) {
      event.preventDefault();
      this.add();
    }

    // Fetch salvando a adição

  }, {
    key: 'add',
    value: function add() {
      this.props.handleAlert('', '', 'open');

      var takeoff_scheduled = null;
      var engine_start_time = null;
      var takeoff_time = null;
      var landing_time = null;
      var engine_shutoff_time = null;

      if (this.state.takeoff_scheduled) takeoff_scheduled = this.state.date + ' ' + this.state.takeoff_scheduled;
      if (this.state.engine_start_time) engine_start_time = this.state.date + ' ' + this.state.engine_start_time;
      if (this.state.takeoff_time) takeoff_time = this.state.date + ' ' + this.state.takeoff_time;
      if (this.state.landing_time) landing_time = this.state.date + ' ' + this.state.landing_time;
      if (this.state.engine_shutoff_time) engine_shutoff_time = this.state.date + ' ' + this.state.engine_shutoff_time;

      if (takeoff_scheduled) takeoff_scheduled = __WEBPACK_IMPORTED_MODULE_9_moment___default()(takeoff_scheduled, "DD/MM/YYYY HH:mm:ss");
      if (engine_start_time) engine_start_time = __WEBPACK_IMPORTED_MODULE_9_moment___default()(engine_start_time, "DD/MM/YYYY HH:mm:ss");
      if (takeoff_time) takeoff_time = __WEBPACK_IMPORTED_MODULE_9_moment___default()(takeoff_time, "DD/MM/YYYY HH:mm:ss");
      if (landing_time) landing_time = __WEBPACK_IMPORTED_MODULE_9_moment___default()(landing_time, "DD/MM/YYYY HH:mm:ss");
      if (engine_shutoff_time) engine_shutoff_time = __WEBPACK_IMPORTED_MODULE_9_moment___default()(engine_shutoff_time, "DD/MM/YYYY HH:mm:ss");

      if (takeoff_scheduled) {
        var diff_hours = takeoff_scheduled.diff(takeoff_time, 'hours');
        if (takeoff_time < takeoff_scheduled && diff_hours > 12) {
          if (engine_start_time) engine_start_time.add(1, 'd');
          if (takeoff_time) takeoff_time.add(1, 'd');
          if (landing_time) landing_time.add(1, 'd');
          if (engine_shutoff_time) engine_shutoff_time.add(1, 'd');
        }
      }

      if (takeoff_time > landing_time) {
        if (landing_time) landing_time.add(1, 'd');
      }

      if (engine_start_time > engine_shutoff_time) {
        if (engine_shutoff_time) engine_shutoff_time.add(1, 'd');
      }

      if (engine_start_time) engine_start_time = engine_start_time.format("HH:mm");
      if (takeoff_time) takeoff_time = takeoff_time.format("HH:mm");
      if (landing_time) landing_time = landing_time.format("HH:mm");
      if (engine_shutoff_time) engine_shutoff_time = engine_shutoff_time.format("HH:mm");
      if (takeoff_scheduled) takeoff_scheduled = takeoff_scheduled.format("HH:mm");

      var storage = localStorage.getItem("new_flight_report_legs_full");
      if (storage !== 'undefined' && storage !== null && storage !== undefined) {
        var datasave = {
          flight_report_id: this.props.flight_report_id,
          departure_location_id: this.state.departure_location_id,
          arrival_location_id: this.state.arrival_location_id,
          takeoff_scheduled: takeoff_scheduled,
          total_time_preview: this.state.total_time_preview,
          engine_start_time: engine_start_time,
          takeoff_time: takeoff_time,
          landing_time: landing_time,
          engine_shutoff_time: engine_shutoff_time,
          takeoff_land_time: this.state.takeoff_land_time,
          takeoff_scheduled_str: takeoff_scheduled,
          engine_start_time_str: engine_start_time,
          takeoff_time_str: takeoff_time,
          landing_time_str: landing_time,
          engine_shutoff_time_str: engine_shutoff_time,
          total_time: this.state.total_time,
          navigation_time: this.state.navigation_time,
          ifr_time: this.state.ifr_time,
          night_time: this.state.night_time,
          day_landings: this.state.day_landings,
          night_landings: this.state.night_landings,
          starts: this.state.starts,
          pax: this.state.pax,
          payload: this.state.payload,
          external_load_long_line: this.state.external_load_long_line,
          external_load_short_line: this.state.external_load_short_line,
          fuel_start: this.state.fuel_start,
          fuel_end: this.state.fuel_end,
          delay_time: this.state.delay_time,
          delay_departure: this.state.delay_departure,
          ptbr_code_id: this.state.ptbr_code_id,
          ptbr_operation_id: this.state.ptbr_operation_id,
          ptbr_external_load_id: this.state.ptbr_external_load_id,
          errors: [],
          status: 'pending',
          status_str: 'Pendente'
        };

        storage = JSON.parse(storage);
        storage.push(datasave);
        localStorage.setItem("new_flight_report_legs_full", JSON.stringify(storage));
      } else {
        var datasave = [{
          flight_report_id: this.props.flight_report_id,
          departure_location_id: this.state.departure_location_id,
          arrival_location_id: this.state.arrival_location_id,
          takeoff_scheduled: takeoff_scheduled,
          total_time_preview: this.state.total_time_preview,
          engine_start_time: engine_start_time,
          takeoff_time: takeoff_time,
          landing_time: landing_time,
          engine_shutoff_time: engine_shutoff_time,
          takeoff_land_time: this.state.takeoff_land_time,
          takeoff_scheduled_str: takeoff_scheduled,
          engine_start_time_str: engine_start_time,
          takeoff_time_str: takeoff_time,
          landing_time_str: landing_time,
          engine_shutoff_time_str: engine_shutoff_time,
          total_time: this.state.total_time,
          navigation_time: this.state.navigation_time,
          ifr_time: this.state.ifr_time,
          night_time: this.state.night_time,
          day_landings: this.state.day_landings,
          night_landings: this.state.night_landings,
          starts: this.state.starts,
          pax: this.state.pax,
          payload: this.state.payload,
          external_load_long_line: this.state.external_load_long_line,
          external_load_short_line: this.state.external_load_short_line,
          fuel_start: this.state.fuel_start,
          fuel_end: this.state.fuel_end,
          delay_time: this.state.delay_time,
          delay_departure: this.state.delay_departure,
          ptbr_code_id: this.state.ptbr_code_id,
          ptbr_operation_id: this.state.ptbr_operation_id,
          ptbr_external_load_id: this.state.ptbr_external_load_id,
          status: 'pending',
          status_str: 'Pendente'
        }];
        localStorage.setItem("new_flight_report_legs_full", JSON.stringify(datasave));
      }

      var storage = JSON.parse(localStorage.getItem("new_flight_report_legs_full"));

      var departure_location_id = null;
      var fuel_start = 0;
      this.setState({
        flight_report_legs: storage,
        departure_location_id: departure_location_id,
        arrival_location_id: null,
        takeoff_scheduled: '',
        total_time_preview: '',
        engine_start_time: '',
        takeoff_time: '',
        landing_time: '',
        engine_shutoff_time: '',
        takeoff_land_time: '00:00',
        total_time: '00:00',
        navigation_time: '',
        ifr_time: '',
        night_time: '',
        day_landings: 0,
        night_landings: 0,
        starts: 0,
        pax: 0,
        payload: 0,
        external_load_long_line: 0,
        external_load_short_line: 0,
        fuel_start: fuel_start,
        fuel_end: 0,
        delay_time: '',
        delay_departure: '',
        ptbr_code_id: null,
        ptbr_operation_id: null,
        ptbr_external_load_id: null
      });

      this.props.handleAlert('', '', 'closed');
    }
  }, {
    key: 'diffFlight',
    value: function diffFlight(takeoff_time, landing_time, change) {
      if (takeoff_time && landing_time && takeoff_time !== '' && landing_time !== '') {
        takeoff_time = this.state.date + ' ' + takeoff_time;
        landing_time = this.state.date + ' ' + landing_time;

        takeoff_time = __WEBPACK_IMPORTED_MODULE_9_moment___default()(takeoff_time, "DD/MM/YYYY HH:mm:ss");
        landing_time = __WEBPACK_IMPORTED_MODULE_9_moment___default()(landing_time, "DD/MM/YYYY HH:mm:ss");

        if (takeoff_time > landing_time) {
          landing_time.add(1, 'd');
        }

        takeoff_time = new Date(takeoff_time.format("YYYY-MM-DD HH:mm:ss").replace(/ /g, "T"));
        landing_time = new Date(landing_time.format("YYYY-MM-DD HH:mm:ss").replace(/ /g, "T"));

        var diffTime = Math.abs(landing_time.getTime() - takeoff_time.getTime());

        if (landing_time > takeoff_time) {
          change['takeoff_land_time'] = this.calcTimeFromMs(diffTime);
          change['navigation_time'] = this.calcTimeFromMs(diffTime);
        } else {
          change['takeoff_land_time'] = '00:00';
          change['navigation_time'] = '00:00';
        }
      } else {
        change['takeoff_land_time'] = '00:00';
        change['navigation_time'] = '00:00';
      }
      this.delayTotalTime(this.state.total_time_preview, change['takeoff_land_time'], change);
    }
  }, {
    key: 'diffTotalTime',
    value: function diffTotalTime(engine_start_time, engine_shutoff_time, takeoff_time, landing_time, start_parameter_total, change) {
      var start = null;
      if (engine_start_time !== null && engine_start_time !== '' && typeof engine_start_time !== 'undefined') {
        start = engine_start_time;
      } else if (start_parameter_total !== null) {
        start = start_parameter_total.substring(11);
      }

      var finish = null;
      if (landing_time !== null && landing_time !== '' && typeof landing_time !== 'undefined') {
        finish = landing_time;
      }
      if (engine_shutoff_time !== null && engine_shutoff_time !== '' && typeof engine_shutoff_time !== 'undefined') {
        finish = engine_shutoff_time;
      }

      if (start && finish) {
        start = this.state.date + ' ' + start;
        finish = this.state.date + ' ' + finish;

        start = __WEBPACK_IMPORTED_MODULE_9_moment___default()(start, "DD/MM/YYYY HH:mm:ss");
        finish = __WEBPACK_IMPORTED_MODULE_9_moment___default()(finish, "DD/MM/YYYY HH:mm:ss");

        if (start > finish) {
          finish.add(1, 'd');
        }

        start = new Date(start.format("YYYY-MM-DD HH:mm:ss").replace(/ /g, "T"));
        finish = new Date(finish.format("YYYY-MM-DD HH:mm:ss").replace(/ /g, "T"));

        var diffTime = Math.abs(finish.getTime() - start.getTime());
        if (finish > start) {
          change['total_time'] = this.calcTimeFromMs(diffTime);
        } else {
          change['total_time'] = '00:00';
        }

        this.setState(change);
      } else {
        change['total_time'] = '00:00';
        this.setState(change);
      }
    }
  }, {
    key: 'delayFlight',
    value: function delayFlight(takeoff_time, takeoff_scheduled, change) {
      if (takeoff_scheduled) {
        takeoff_time = this.state.date + ' ' + takeoff_time;
        takeoff_scheduled = this.state.date + ' ' + takeoff_scheduled;

        takeoff_time = __WEBPACK_IMPORTED_MODULE_9_moment___default()(takeoff_time, "DD/MM/YYYY HH:mm:ss");
        takeoff_scheduled = __WEBPACK_IMPORTED_MODULE_9_moment___default()(takeoff_scheduled, "DD/MM/YYYY HH:mm:ss");

        var diff_hours = takeoff_scheduled.diff(takeoff_time, 'hours');

        if (takeoff_time < takeoff_scheduled && diff_hours > 12) {
          takeoff_time.add(1, 'd');
        }

        takeoff_time = new Date(takeoff_time.format("YYYY-MM-DD HH:mm:ss").replace(/ /g, "T"));
        takeoff_scheduled = new Date(takeoff_scheduled.format("YYYY-MM-DD HH:mm:ss").replace(/ /g, "T"));
        var diffTime = Math.abs(takeoff_time.getTime() - takeoff_scheduled.getTime());
        if (takeoff_time > takeoff_scheduled) {
          change['delay_departure'] = this.calcTimeFromMs(diffTime);
        } else {
          change['delay_departure'] = '00:00';
        }
      } else {
        change['delay_departure'] = '00:00';
      }
      this.setState(change);
    }
  }, {
    key: 'delayTotalTime',
    value: function delayTotalTime(total_time_preview, takeoff_land_time, change) {
      if (takeoff_land_time && total_time_preview) {
        takeoff_land_time = __WEBPACK_IMPORTED_MODULE_9_moment___default()().format("YYYY-MM-DD") + ' ' + takeoff_land_time;
        total_time_preview = __WEBPACK_IMPORTED_MODULE_9_moment___default()().format("YYYY-MM-DD") + ' ' + total_time_preview;

        takeoff_land_time = new Date(takeoff_land_time.replace(/ /g, "T"));
        total_time_preview = new Date(total_time_preview.replace(/ /g, "T"));
        var diffTime = Math.abs(takeoff_land_time.getTime() - total_time_preview.getTime());
        if (takeoff_land_time > total_time_preview) {
          change['delay_time'] = this.calcTimeFromMs(diffTime);
        } else {
          change['delay_time'] = '00:00';
        }
      } else {
        change['delay_time'] = '00:00';
      }
      this.setState(change);
    }
  }, {
    key: 'calcTimeFromMs',
    value: function calcTimeFromMs(diffTime) {
      diffTime = diffTime / 1000;
      var secs = diffTime % 60;
      diffTime = (diffTime - secs) / 60;
      var mins = diffTime % 60;
      var hrs = (diffTime - mins) / 60;
      if (secs < 10) {
        secs = '0' + secs;
      }
      if (mins < 10) {
        mins = '0' + mins;
      }
      if (hrs < 10) {
        hrs = '0' + hrs;
      }
      return hrs + ':' + mins + ':' + secs;
    }
  }, {
    key: 'delete',
    value: function _delete(index_key) {

      var storage = localStorage.getItem("new_flight_report_legs_full");

      storage = JSON.parse(storage);
      storage.splice(index_key, 1);

      localStorage.setItem("new_flight_report_legs_full", JSON.stringify(storage));

      var storage = JSON.parse(localStorage.getItem("new_flight_report_legs_full"));

      this.setState({ flight_report_legs: storage });
    }
  }, {
    key: 'saveOnline',
    value: function saveOnline() {
      var self = this;
      if (navigator.onLine) {
        this.props.handleAlert('', '', 'open');
        var header = self.refs.request_api.header('application/json');
        var new_flight_report_legs_full = JSON.parse(localStorage.getItem("new_flight_report_legs_full"));

        var datasave = {
          new_flight_report_legs_full: new_flight_report_legs_full
        };
        if (new_flight_report_legs_full !== 'undefined' && new_flight_report_legs_full !== null && new_flight_report_legs_full !== undefined && new_flight_report_legs_full.length > 0) {
          Promise.resolve(header).then(function (value) {
            var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/portal/relatorios/salvar/offline';
            fetch(url, { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.refs.request_api.validate(responseJson, 'url');
              if (responseJson.status === 'success') {
                if (responseJson.data === true) {
                  localStorage.removeItem("new_flight_report_legs");
                  localStorage.removeItem("new_flight_report_legs_full");
                  self.props.handleAlert('Os relatórios de voo offline foram salvos.', 'success', 'open');
                } else {
                  localStorage.setItem("new_flight_report_legs_full", JSON.stringify(responseJson.data));
                  self.props.handleAlert('Alguns trechos encontram-se com erro.', 'warning', 'open');
                }
              }
            });
          });
        } else {
          this.props.handleAlert('', '', 'closed');
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      var start_parameter_total = null;
      var total = 1;
      var style = {
        form: { width: '100%', height: 'auto', overflowX: 'auto', whiteSpace: 'nowrap' },
        input_hour: { width: '75px', textAlign: 'center' },
        select_places: { width: '130px' },
        select_operation: { width: '240px' },
        input_number: { width: '70px', textAlign: 'center' },
        input_fuel: { width: '110px', textAlign: 'center' },
        divs: { display: 'inline-block', marginRight: '15px' }
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          'Cadastrar trecho'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: this.addMobile, className: 'visible-xs' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Origem'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'departure_location_id',
                value: this.state.departure_location_id,
                searchable: true,
                placeholder: '',
                onChange: this.handleSelectChange.bind(this, 'departure_location_id'),
                options: this.state.locations_select
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Destino'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'arrival_location_id',
                value: this.state.arrival_location_id,
                searchable: true,
                placeholder: '',
                onChange: this.handleSelectChange.bind(this, 'arrival_location_id'),
                options: this.state.locations_select
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Partida'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.engine_start_time, maskChar: null, name: 'engine_start_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'engine_start_time'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'DEC.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.takeoff_time, maskChar: null, name: 'takeoff_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'takeoff_time'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'POU.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.landing_time, maskChar: null, name: 'landing_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'landing_time'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Corte'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.engine_shutoff_time, maskChar: null, name: 'engine_shutoff_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'engine_shutoff_time'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'DEC-POU'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.takeoff_land_time, maskChar: null, name: 'takeoff_land_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'takeoff_land_time'), placeholder: '', disabled: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Total'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.total_time, maskChar: null, name: 'total_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'total_time'), placeholder: '', disabled: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Nav.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.navigation_time, maskChar: null, name: 'navigation_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'navigation_time'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'IFR'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.ifr_time, maskChar: null, name: 'ifr_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'ifr_time'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Noturno'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.night_time, maskChar: null, name: 'night_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'night_time'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Diurnos'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.day_landings, name: 'day_landings ', className: 'form-control', onChange: this.handleChange.bind(this, 'day_landings'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Noturnos'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.night_landings, name: 'night_landings ', className: 'form-control', onChange: this.handleChange.bind(this, 'night_landings'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Partidas'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.starts, name: 'starts ', className: 'form-control', onChange: this.handleChange.bind(this, 'starts'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'PAX'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.pax, name: 'pax ', className: 'form-control', onChange: this.handleChange.bind(this, 'pax'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Carga'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.payload, name: 'payload ', className: 'form-control', onChange: this.handleChange.bind(this, 'payload'), placeholder: '' })
            ),
            this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 col-xs-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Long Line'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
                checked: this.state.external_load_long_line,
                'aria-label': 'No label tag',
                name: 'external_load_long_line',
                onChange: this.handleToggleChange.bind(this, 'external_load_long_line') })
            ) : '',
            this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 col-xs-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Short Line'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
                checked: this.state.external_load_short_line,
                'aria-label': 'No label tag',
                name: 'external_load_short_line',
                onChange: this.handleToggleChange.bind(this, 'external_load_short_line') })
            ) : '',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Inicial'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.fuel_start, name: 'fuel_start ', className: 'form-control', onChange: this.handleChange.bind(this, 'fuel_start'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Final'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.fuel_end, name: 'fuel_end ', className: 'form-control', onChange: this.handleChange.bind(this, 'fuel_end'), placeholder: '' })
            ),
            this.state.xml == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'C\xF3digo PTBR \xA0\xA0',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'button', onClick: function onClick() {
                      return _this2.exportPtbrCode();
                    }, className: 'btn btn-success btn-xs' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'ptbr_code_id',
                value: this.state.ptbr_code_id,
                searchable: true,
                placeholder: '',
                onChange: this.handleSelectChange.bind(this, 'ptbr_code_id'),
                options: this.state.ptbr_codes_select
              })
            ) : ''
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'submit', className: 'btn btn-primary btn-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
            ' Adicionar Trecho'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { type: 'button', className: 'btn btn-sm btn-success pull-left', onClick: function onClick() {
              self.saveOnline();
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-refresh' }),
          'Enviar para o servidor'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { colSpan: 4 }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 13, className: 'text-center' },
                  'Realizado'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 2, className: 'text-center' },
                  'Pousos'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 3, className: 'text-center' },
                  'Dados'
                ),
                this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 2, className: 'text-center' },
                  'Carga externa'
                ) : '',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 2, className: 'text-center' },
                  'Combust\xEDvel'
                ),
                this.state.xml == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 1, className: 'text-center' },
                  'Opera\xE7\xE3o PTBR ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', onClick: function onClick() {
                        return _this2.exportPtbrCode();
                      }, className: 'btn btn-success btn-xs' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' })
                  )
                ) : '',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'A\xE7\xF5es'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Status'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { className: 'text-center' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center', style: { width: '200px' } },
                  'N\xB0'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Trecho'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Origem'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Destino'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 2, className: 'text-center' },
                  'Partida'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 2, className: 'text-center' },
                  'DEC.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 2, className: 'text-center' },
                  'POU.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 2, className: 'text-center' },
                  'Corte'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'DEC-POU'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Total'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Nav.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'IFR'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Noturno'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Diurnos'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Noturnos'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Partidas'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'PAX'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Carga'
                ),
                this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Long Line'
                ) : '',
                this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Short Line'
                ) : '',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Inicial'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Final'
                ),
                this.state.xml == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'C\xF3digo PTBR '
                ) : '',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { className: 'text-center', style: { width: '200px' } })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              null,
              Object.keys(self.state.flight_report_legs_view).map(function (k) {
                var srl = self.state.flight_report_legs_view[k];
                var last_index = parseInt(k) - 1;
                if (typeof self.state.flight_report_legs_view[last_index] !== 'undefined') {
                  if (self.state.flight_report_legs_view[last_index].engine_shutoff_time === null || self.state.flight_report_legs_view[last_index].engine_shutoff_time === '' || typeof self.state.flight_report_legs_view[last_index].engine_shutoff_time === 'undefined') {
                    start_parameter_total = self.state.flight_report_legs_view[last_index].landing_time;
                  }
                }
                var index = self.state.flight_report_legs_view.length;
                index--;
                var edit = false;
                if (parseInt(k) === index) {
                  edit = true;
                }
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FlightReportOfflineLegEditViewTab__["a" /* default */], { external_load: self.state.external_load, xml: self.state.xml, flight_report_leg_edit: srl, locations_select: self.state.locations_select, ptbr_codes_select: self.state.ptbr_codes_select, date: self.state.date, style: style, start_parameter_total: start_parameter_total });
              }),
              Object.keys(self.state.flight_report_legs).map(function (k) {
                var srl = self.state.flight_report_legs[k];
                var last_index = parseInt(k) - 1;
                if (typeof self.state.flight_report_legs[last_index] !== 'undefined') {
                  if (self.state.flight_report_legs[last_index].engine_shutoff_time === null || self.state.flight_report_legs[last_index].engine_shutoff_time === '' || typeof self.state.flight_report_legs[last_index].engine_shutoff_time === 'undefined') {
                    start_parameter_total = self.state.flight_report_legs[last_index].landing_time;
                  }
                }
                var index = self.state.flight_report_legs.length;
                index--;
                var edit = false;
                if (parseInt(k) === index) {
                  edit = true;
                }
                if (srl.flight_report_id == self.state.flight_report_id) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__FlightReportOfflineLegEditTab__["a" /* default */], { index_key: k, openModal: self.openModal, 'delete': self.delete, handleAlert: self.props.handleAlert, external_load: self.state.external_load, xml: self.state.xml, flight_report_leg_edit: srl, locations_select: self.state.locations_select, ptbr_codes_select: self.state.ptbr_codes_select, date: self.state.date, style: style, start_parameter_total: start_parameter_total });
                }
              }),
              self.state.status == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    style: style.select_places,
                    name: 'departure_location_id',
                    value: this.state.departure_location_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'departure_location_id'),
                    options: this.state.locations_select

                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    style: style.select_places,
                    name: 'arrival_location_id',
                    value: this.state.arrival_location_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'arrival_location_id'),
                    options: this.state.locations_select

                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: style.input_hour, value: this.state.engine_start_time, maskChar: null, name: 'engine_start_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'engine_start_time'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-primary btn-sm', onClick: function onClick() {
                        self.autoFillTime('engine_start_time');
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-clock-o' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: style.input_hour, value: this.state.takeoff_time, maskChar: null, name: 'takeoff_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'takeoff_time'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-primary btn-sm', onClick: function onClick() {
                        self.autoFillTime('takeoff_time');
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-clock-o' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: style.input_hour, value: this.state.landing_time, maskChar: null, name: 'landing_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'landing_time'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-primary btn-sm', onClick: function onClick() {
                        self.autoFillTime('landing_time');
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-clock-o' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: style.input_hour, value: this.state.engine_shutoff_time, maskChar: null, name: 'engine_shutoff_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'engine_shutoff_time'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-primary btn-sm', onClick: function onClick() {
                        self.autoFillTime('engine_shutoff_time');
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-clock-o' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: style.input_hour, value: this.state.takeoff_land_time, maskChar: null, name: 'takeoff_land_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'takeoff_land_time'), placeholder: '', disabled: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: style.input_hour, value: this.state.total_time, maskChar: null, name: 'total_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'total_time'), placeholder: '', disabled: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: style.input_hour, value: this.state.navigation_time, maskChar: null, name: 'navigation_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'navigation_time'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: style.input_hour, value: this.state.ifr_time, maskChar: null, name: 'ifr_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'ifr_time'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: style.input_hour, value: this.state.night_time, maskChar: null, name: 'night_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'night_time'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: style.input_number, type: 'number', value: this.state.day_landings, name: 'day_landings ', className: 'form-control', onChange: this.handleChange.bind(this, 'day_landings'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: style.input_number, type: 'number', value: this.state.night_landings, name: 'night_landings ', className: 'form-control', onChange: this.handleChange.bind(this, 'night_landings'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: style.input_number, type: 'number', value: this.state.starts, name: 'starts ', className: 'form-control', onChange: this.handleChange.bind(this, 'starts'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: style.input_number, type: 'number', value: this.state.pax, name: 'pax ', className: 'form-control', onChange: this.handleChange.bind(this, 'pax'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: style.input_number, type: 'number', value: this.state.payload, name: 'payload ', className: 'form-control', onChange: this.handleChange.bind(this, 'payload'), placeholder: '' })
                ),
                this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
                    checked: this.state.external_load_long_line,
                    'aria-label': 'No label tag',
                    name: 'external_load_long_line',
                    onChange: this.handleToggleChange.bind(this, 'external_load_long_line') })
                ) : '',
                this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
                    checked: this.state.external_load_short_line,
                    'aria-label': 'No label tag',
                    name: 'external_load_short_line',
                    onChange: this.handleToggleChange.bind(this, 'external_load_short_line') })
                ) : '',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: style.input_number, type: 'number', value: this.state.fuel_start, name: 'fuel_start ', className: 'form-control', onChange: this.handleChange.bind(this, 'fuel_start'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: style.input_number, type: 'number', value: this.state.fuel_end, name: 'fuel_end ', className: 'form-control', onChange: this.handleChange.bind(this, 'fuel_end'), placeholder: '' })
                ),
                this.state.xml == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    name: 'ptbr_code_id',
                    value: this.state.ptbr_code_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'ptbr_code_id'),
                    options: this.state.ptbr_codes_select,
                    style: style.select_operation
                  })
                ) : '',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  'Cria\xE7\xE3o'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { style: { width: '200px', whiteSpace: 'nowrap', textAlign: 'center' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-primary', onClick: function onClick() {
                        self.add();
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' })
                  )
                )
              ) : ''
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal_alerts, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                'Alertas'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ modal_alerts: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              Object.keys(self.state.frl_alerts).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: "box-alert box-alert-" + self.state.frl_alerts[k].color },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: self.state.frl_alerts[k].message } })
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ modal_alerts: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return FlightReportOfflineLegsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportOfflineLegsTab);

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_input_mask__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário



var FlightReportOfflineStaffsTab = function (_Component) {
  _inherits(FlightReportOfflineStaffsTab, _Component);

  function FlightReportOfflineStaffsTab(props) {
    _classCallCheck(this, FlightReportOfflineStaffsTab);

    var _this = _possibleConstructorReturn(this, (FlightReportOfflineStaffsTab.__proto__ || Object.getPrototypeOf(FlightReportOfflineStaffsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      flight_report_id: null,
      staff_id: null,
      duty_id: null,
      arrival: null,
      date: _this.props.flight_report.date_str,
      flight_report: _this.props.flight_report,
      flight_report_staffs: _this.props.flight_report_staffs,
      staffs_select: [],
      duties_select: []
    };

    _this.add = _this.add.bind(_this);
    _this.deleteStaff = _this.deleteStaff.bind(_this);
    return _this;
  }
  // Handlers


  _createClass(FlightReportOfflineStaffsTab, [{
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.flight_report_staffs) || this.state.loaded === 1 && newProps.updated === 1) {
        this.setState({
          flight_report_id: newProps.flight_report_id,
          flight_report_staffs: newProps.flight_report_staffs,
          staffs_select: newProps.staffs_select,
          duties_select: newProps.duties_select,
          flight_report: newProps.flight_report,
          date: newProps.flight_report.date_str,
          loaded: 1
        });
      }
    }
  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      if (navigator.onLine) {
        this.props.handleAlert('', '', 'open');
        var arrival = this.state.date + ' ' + this.state.arrival_hour;
        var datasave = {
          flight_report_id: this.state.flight_report_id,
          staff_id: this.state.staff_id,
          duty_id: this.state.duty_id,
          arrival: arrival
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/tripulante', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
            self.setState({ staff_id: null, duty_id: null });
          }).catch(function (error) {
            console.error(error);
          });
        });
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'deleteStaff',
    value: function deleteStaff(staff_id) {
      if (navigator.onLine) {
        if (window.confirm('Tem certeza que deseja excluir esse tripulante? Ele será excluido de todos os trechos.')) {
          this.props.handleAlert('', '', 'open');
          var datasave = {
            staff_id: staff_id,
            flight_report_id: this.state.flight_report_id
          };
          var header = this.refs.request_api.header('application/json');
          var self = this;
          Promise.resolve(header).then(function (value) {
            fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/tripulante', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.refs.request_api.validate(responseJson, 'alert');
              self.props.updateData(responseJson);
            }).catch(function (error) {
              console.error(error);
            });
          });
        }
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          { className: 'page-title' },
          'Tripulantes cadastrados'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { style: { width: '380px' } },
                  'Nome'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'CANAC'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'SISPAT'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'FB'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Apresenta\xE7\xE3o'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              null,
              Object.keys(self.state.flight_report_staffs).map(function (k) {
                var srls = self.state.flight_report_staffs[k];
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { style: { width: '380px' } },
                    srls.name
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srls.canac
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srls.sispat
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srls.duty
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srls.arrival
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);

  return FlightReportOfflineStaffsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportOfflineStaffsTab);

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário




// Importo o moment com a linguagem pt-br
__webpack_require__(24);
__webpack_require__(32);

var FlightReportPowerCheckTab = function (_Component) {
  _inherits(FlightReportPowerCheckTab, _Component);

  function FlightReportPowerCheckTab(props) {
    _classCallCheck(this, FlightReportPowerCheckTab);

    var _this = _possibleConstructorReturn(this, (FlightReportPowerCheckTab.__proto__ || Object.getPrototypeOf(FlightReportPowerCheckTab)).call(this, props));

    _this.handleChangeDecimal = function (name, event) {
      var _this$setState;

      var rawInputValue = _this.state.rawInputValue;

      var inputValue = event.target.value;

      // Se o input estiver vazio, limpa rawInputValue
      if (inputValue === '') {
        rawInputValue = '';
      } else if (/^\d+$/.test(inputValue)) {
        // Se for um número inteiro, atualiza rawInputValue
        rawInputValue = inputValue;
      } else {
        var newChar = inputValue.slice(-1);

        // Verifica se o novo caractere é um número, um ponto decimal ou uma vírgula
        if (!/^[0-9.,]$/.test(newChar)) {
          // Caractere inválido, não faz nada
          return;
        }

        // Substitui vírgula por ponto
        if (newChar === ',') {
          newChar = '.';
        }

        // Verifica se já existe um ponto decimal
        var hasDecimal = rawInputValue.includes('.');

        // Impede que "0" seja o primeiro dígito
        if (rawInputValue === '' && newChar === '0') {
          return;
        }

        // Determina se está adicionando ou removendo um caractere
        if (event.nativeEvent.inputType === 'deleteContentBackward') {
          // Removendo um caractere
          rawInputValue = rawInputValue.slice(0, -1);
        } else if (hasDecimal && newChar !== '.') {
          // Substitui o dígito após o ponto decimal
          var parts = rawInputValue.split('.');
          parts[1] = newChar;
          rawInputValue = parts.join('.');
        } else {
          // Adicionando um caractere
          rawInputValue += newChar;
        }
      }

      // Formata o valor para exibição com base em rawInputValue
      var formattedValue = _this.formatInputValue(rawInputValue);

      // Atualiza o estado
      _this.setState((_this$setState = {}, _defineProperty(_this$setState, name, formattedValue), _defineProperty(_this$setState, 'rawInputValue', rawInputValue), _this$setState));
    };

    _this.handleChangeTorqueDecimal = function (name, event) {
      var _this$setState2;

      var rawInputValue = _this.state.rawInputValueTorque;

      var inputValue = event.target.value;

      // Se o input estiver vazio, limpa rawInputValue
      if (inputValue === '') {
        rawInputValue = '';
      } else if (/^\d+$/.test(inputValue)) {
        // Se for um número inteiro, atualiza rawInputValue
        rawInputValue = inputValue;
      } else {
        var newChar = inputValue.slice(-1);

        // Verifica se o novo caractere é um número, um ponto decimal ou uma vírgula
        if (!/^[0-9.,]$/.test(newChar)) {
          // Caractere inválido, não faz nada
          return;
        }

        // Substitui vírgula por ponto
        if (newChar === ',') {
          newChar = '.';
        }

        // Verifica se já existe um ponto decimal
        var hasDecimal = rawInputValue.includes('.');

        // Impede que "0" seja o primeiro dígito
        if (rawInputValue === '' && newChar === '0') {
          return;
        }

        // Determina se está adicionando ou removendo um caractere
        if (event.nativeEvent.inputType === 'deleteContentBackward') {
          // Removendo um caractere
          rawInputValue = rawInputValue.slice(0, -1);
        } else if (hasDecimal && newChar !== '.') {
          // Substitui o dígito após o ponto decimal
          var parts = rawInputValue.split('.');
          parts[1] = newChar;
          rawInputValue = parts.join('.');
        } else {
          // Adicionando um caractere
          rawInputValue += newChar;
        }
      }

      // Formata o valor para exibição com base em rawInputValue
      var formattedValue = _this.formatInputValue(rawInputValue);

      // Atualiza o estado
      _this.setState((_this$setState2 = {}, _defineProperty(_this$setState2, name, formattedValue), _defineProperty(_this$setState2, 'rawInputValueTorque', rawInputValue), _this$setState2));
    };

    _this.formatInputValue = function (rawValue) {
      if (!rawValue) {
        return '';
      }

      var _rawValue$split = rawValue.split('.'),
          _rawValue$split2 = _slicedToArray(_rawValue$split, 2),
          inteiro = _rawValue$split2[0],
          decimal = _rawValue$split2[1];

      // Ajusta a parte decimal para sempre ter um dígito


      decimal = decimal && decimal.length > 0 ? decimal[0] : '0';

      return inteiro + '.' + decimal;
    };

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      flight_report_power_checks: _this.props.flight_report_power_checks,
      flight_report_id: _this.props.flight_report_id,
      engine: '',
      altitude: '',
      external_temperature: '',
      power_turbine_rotation_rate: '',
      engine_power_rate: '',
      gas_turbine_rotation_rate: '',
      engine_temperature: '',
      engine_temperature_margin: '',
      gas_turbine_torque_margin: '',
      rawInputValue: '',
      rawInputValueTorque: '',
      flight_legs_list: []
    };
    _this.add = _this.add.bind(_this);
    _this.delete = _this.delete.bind(_this);
    return _this;
  }

  _createClass(FlightReportPowerCheckTab, [{
    key: 'handleChange',


    // Handlers
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0) {
        this.setState({
          flight_report_id: newProps.flight_report_id,
          loaded: 1
        });
      }

      if (typeof newProps.flight_report_power_checks !== 'undefined' && newProps.flight_report_power_checks !== null && this.state.loaded === 1) {
        this.setState({
          flight_report_power_checks: newProps.flight_report_power_checks
        });
      }
    }

    // Fetch salvando a edição

  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var datasave = {
        flight_report_id: this.state.flight_report_id,
        engine: this.state.engine,
        altitude: this.state.altitude,
        external_temperature: this.state.external_temperature,
        power_turbine_rotation_rate: this.state.power_turbine_rotation_rate,
        engine_power_rate: this.state.engine_power_rate,
        gas_turbine_rotation_rate: this.state.gas_turbine_rotation_rate,
        engine_temperature: this.state.engine_temperature,
        engine_temperature_margin: this.state.engine_temperature_margin,
        gas_turbine_torque_margin: this.state.gas_turbine_torque_margin
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/power/checks', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
          self.setState({
            altitude: '',
            engine: '',
            external_temperature: '',
            power_turbine_rotation_rate: '',
            engine_power_rate: '',
            gas_turbine_rotation_rate: '',
            engine_temperature: '',
            engine_temperature_margin: '',
            gas_turbine_torque_margin: ''
          });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'delete',
    value: function _delete(id) {
      if (window.confirm('Deseja realmente excluir este registro?')) {
        this.props.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/power/check/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.props.updateData(responseJson);
            } else {
              self.props.handleAlert(responseJson.message, responseJson.status, 'open');
            }
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title pull-left' },
          'Power Check'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: this.add },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Engine'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                  className: 'form-group',
                  name: 'engine',
                  value: this.state.engine,
                  searchable: true,
                  placeholder: 'Selecione',
                  onChange: this.handleSelectChange.bind(this, 'engine'),
                  options: [{ value: "ENG #1", label: "ENG #1" }, { value: "ENG #2", label: "ENG #2" }, { value: "APU", label: "APU" }],
                  required: true
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Altitude'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', className: 'form-control', value: this.state.altitude, name: 'altitude', onChange: this.handleChange.bind(this, 'altitude'), placeholder: 'Altitude', required: true })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'OAT'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', className: 'form-control', value: this.state.external_temperature, name: 'external_temperature', onChange: this.handleChange.bind(this, 'external_temperature'), placeholder: 'Temperatura externa', required: true })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'N2/NR'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', className: 'form-control', value: this.state.power_turbine_rotation_rate, name: 'power_turbine_rotation_rate', onChange: this.handleChange.bind(this, 'power_turbine_rotation_rate'), placeholder: 'Taxa de rota\xE7\xE3o da turbina de pot\xEAncia', required: true })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Torque'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', className: 'form-control', value: this.state.engine_power_rate, name: 'engine_power_rate', onChange: this.handleChange.bind(this, 'engine_power_rate'), placeholder: 'Taxa de pot\xEAncia do motor', required: true })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'N1/NG'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'form-control', value: this.state.gas_turbine_rotation_rate, name: 'gas_turbine_rotation_rate', onChange: this.handleChangeDecimal.bind(this, 'gas_turbine_rotation_rate'), placeholder: 'Taxa de rota\xE7\xE3o da turbina de gases do motor', required: true })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'T4/T5/ITT/TOT/MGT (\xB0C)'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', className: 'form-control', value: this.state.engine_temperature, name: 'engine_temperature', onChange: this.handleChange.bind(this, 'engine_temperature'), placeholder: 'Temperatura do motor', required: true })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Margin - T5/ITT/T4/TOT/MGT (\xB0C)'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', className: 'form-control', value: this.state.engine_temperature_margin, name: 'engine_temperature_margin', onChange: this.handleChange.bind(this, 'engine_temperature_margin'), placeholder: 'Margem de temperatura do motor', required: true })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  'Margin - NG/Torque'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: 'form-control', value: this.state.gas_turbine_torque_margin, name: 'gas_turbine_torque_margin', onChange: this.handleChangeTorqueDecimal.bind(this, 'gas_turbine_torque_margin'), placeholder: 'Margem de torque da turbina de gases', required: true })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-12' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'submit', className: 'btn btn-block btn-primary' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                  ' Cadastrar'
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'Engine'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'Altitude'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'OAT'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'N2/NR'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'Torque'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'N1/NG'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { rowSpan: 2, className: 'text-center vcenter' },
                  'T4/T5/ITT/TOT/MGT (\xB0C)'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 2, className: 'text-center vcenter' },
                  'Margins'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { rowSpan: 2, className: 'text-center vcenter' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'T5/ITT/T4/TOT/MGT (\xB0C)'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center vcenter' },
                  'NG/Torque'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'power_checks' },
              Object.keys(self.state.flight_report_power_checks).map(function (k) {
                var power_check = self.state.flight_report_power_checks[k];
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  { className: 'text-center', key: power_check.id },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    power_check.engine
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    power_check.altitude
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    power_check.external_temperature
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    power_check.power_turbine_rotation_rate
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    power_check.engine_power_rate
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    power_check.gas_turbine_rotation_rate_decimal
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    power_check.engine_temperature
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    power_check.engine_temperature_margin
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    power_check.gas_turbine_torque_margin_decimal
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { style: { width: '100px', whiteSpace: 'nowrap', textAlign: 'center' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { onClick: function onClick() {
                          return self.delete(power_check.id);
                        }, className: 'btn btn-danger btn-sm button-inline' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-trash' })
                    )
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);

  return FlightReportPowerCheckTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportPowerCheckTab);

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FlightReportRefuels_Elements_FlightReportRefuelApprovalsTab__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FlightReportRefuels_Elements_FlightReportRefuelEditTab__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário










// Importo o moment com a linguagem pt-br
__webpack_require__(24);
__webpack_require__(32);

var FlightReportRefuelTab = function (_Component) {
  _inherits(FlightReportRefuelTab, _Component);

  function FlightReportRefuelTab(props) {
    _classCallCheck(this, FlightReportRefuelTab);

    var _this = _possibleConstructorReturn(this, (FlightReportRefuelTab.__proto__ || Object.getPrototypeOf(FlightReportRefuelTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      modal: false,
      approval_required: 0,
      export_required: 0,
      flight_report_id: _this.props.flight_report_id,
      fuel_type: _this.props.fuel_type,
      fuel_type_id: _this.props.fuel_type_id,
      fuel_unity: _this.props.fuel_unity,
      flight_report_legs_select: _this.props.flight_report_legs_select,
      fuel_suppliers_select: _this.props.fuel_suppliers_select,
      ptbr_fuels_select: _this.props.ptbr_fuels_select,
      flight_report_refuels: _this.props.flight_report_refuels,
      flight_report_refuel_edit: {},
      companies_select: _this.props.companies_select,
      fuel_types_select: _this.props.fuel_types_select,
      staffs_select: _this.props.staffs_select,
      flight_report_leg_id: null
    };

    //bind específico
    _this.add = _this.add.bind(_this);
    _this.delete = _this.delete.bind(_this);
    _this.openEditModal = _this.openEditModal.bind(_this);
    _this.closeModal = _this.closeModal.bind(_this);

    // Handlers
    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(FlightReportRefuelTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        var date = event.target.value;
        var year = date.split("-")[0];
        var month = date.split("-")[1];
        var day = date.split("-")[2];
        change[name] = date;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeFuelType',
    value: function handleSelectChangeFuelType(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;

        if (navigator.onLine) {
          var header = this.refs.request_api.header('application/json');
          var self = this;
          self.props.handleAlert('', '', 'open');
          Promise.resolve(header).then(function (value) {
            fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/tipo/combustivel/' + event.value, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.setState({
                fuel_type: responseJson.data.abbreviation
              });
              self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
            });
          });
        } else {
          window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
        }
      }
      this.setState(change);
    }
  }, {
    key: 'handleChangeGallonsReading',
    value: function handleChangeGallonsReading(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);

      if (name == 'reading_start') {
        var start = event.target.value;
      } else {
        var start = this.state.reading_start;
      }
      if (name == 'reading_finish') {
        var finish = event.target.value;
      } else {
        var finish = this.state.reading_finish;
      }
      var delivered = parseInt(finish) - parseInt(start);
      this.setState({ quantity: delivered });
    }
  }, {
    key: 'handleExtraFlightToggleChange',
    value: function handleExtraFlightToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = true;
      } else {
        var value = false;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeLeg',
    value: function handleSelectChangeLeg(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;

        if (navigator.onLine) {
          var header = this.refs.request_api.header('application/json');
          var self = this;
          this.props.handleAlert('', '', 'open');
          Promise.resolve(header).then(function (value) {
            fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/trecho/localidade/' + event.value, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.setState({
                locations_select: responseJson.data.locations_select,
                location_id: responseJson.data.flight_report_leg.departure_location_id,
                next_location_id: responseJson.data.flight_report_leg.arrival_location_id,
                reading_start: responseJson.data.flight_report_leg.fuel_start
              });
              self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
            });
          });
        } else {
          window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
        }
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeFuelSupplier',
    value: function handleSelectChangeFuelSupplier(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;

        if (navigator.onLine) {
          var header = this.refs.request_api.header('application/json');
          var self = this;
          this.props.handleAlert('', '', 'open');
          Promise.resolve(header).then(function (value) {
            fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/fornecedor/combustivel/' + event.value, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.setState({
                approval_required: responseJson.data.main.refuel_approval_required,
                export_required: responseJson.data.main.refuel_export_required,
                staff_id: '',
                requested: '',
                receit: '',
                quantity: '',
                address: '',
                fueling_started: '',
                fueling_finished: '',
                next_location_id: '',
                hydrant_no: '',
                your_sale_no: '',
                previous_sale_no: '',
                reading_finish: '',
                reading_start: ''
              });
              self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
            });
          });
        } else {
          window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
        }
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeCompany',
    value: function handleSelectChangeCompany(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;

        if (navigator.onLine) {
          var header = this.refs.request_api.header('application/json');
          var self = this;
          this.props.handleAlert('', '', 'open');
          Promise.resolve(header).then(function (value) {
            fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/empresa/' + event.value, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.setState({
                address: responseJson.data.main.address + ', ' + responseJson.data.main.city + ', ' + responseJson.data.main.province
              });
              self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
            });
          });
        } else {
          window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
        }
      }
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (typeof this.state.fuel_unity === 'undefined' || this.state.loaded === 1 && newProps.updated === 1) {
        this.setState({
          flight_report_id: newProps.flight_report_id,
          fuel_type: newProps.fuel_type,
          fuel_type_id: newProps.fuel_type_id,
          fuel_unity: newProps.fuel_unity,
          flight_report_refuels: newProps.flight_report_refuels,
          flight_report_legs_select: newProps.flight_report_legs_select,
          fuel_suppliers_select: newProps.fuel_suppliers_select,
          companies_select: newProps.companies_select,
          ptbr_fuels_select: newProps.ptbr_fuels_select,
          staffs_select: newProps.staffs_select,
          fuel_types_select: newProps.fuel_types_select,
          loaded: 1
        });
      }
    }
  }, {
    key: 'autoFillTime',
    value: function autoFillTime(name) {

      var now = __WEBPACK_IMPORTED_MODULE_7_moment___default()(new Date());
      now = now.format("HH:mm");
      var change = {};
      change[name] = now;

      this.setState(change);
    }

    // Fetch salvando a edição
    // Fetch salvando a edição

  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();

      if (navigator.onLine) {
        var datasave = new FormData();
        var imagedata = document.querySelector(".input-nf-file").files[0];
        datasave.append("aircraft_id", this.state.aircraft_id);
        datasave.append("date", this.state.date);
        datasave.append("flight_report_id", this.state.flight_report_id);
        datasave.append("flight_report_leg_id", this.state.flight_report_leg_id);
        datasave.append("fuel_supplier_id", this.state.fuel_supplier_id);
        datasave.append("location_id", this.state.location_id);
        datasave.append("receit", this.state.receit);
        datasave.append("requested", this.state.requested);
        datasave.append("quantity", this.state.quantity);
        datasave.append("file", imagedata);
        datasave.append("address", this.state.address);
        datasave.append("staff_id", this.state.staff_id);
        datasave.append("fueling_started", this.state.fueling_started);
        datasave.append("fueling_finished", this.state.fueling_finished);
        datasave.append("next_location_id", this.state.next_location_id);
        datasave.append("hydrant_no", this.state.hydrant_no);
        datasave.append("your_sale_no", this.state.your_sale_no);
        datasave.append("previous_sale_no", this.state.previous_sale_no);
        datasave.append("reading_finish", this.state.reading_finish);
        datasave.append("reading_start", this.state.reading_start);
        datasave.append("fuel_type_id", this.state.fuel_type_id);
        var header = this.refs.request_api.header();
        var self = this;
        this.props.handleAlert('', '', 'open');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/abastecimento', {
            method: 'POST',
            mode: 'cors',
            headers: value,
            body: datasave }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              var url = '/abastecimento/editar/' + responseJson.data.flight_report_refuel.id;
              var storage = {
                alert_message: responseJson.message,
                alert_type: responseJson.status
              };
              localStorage.setItem("verify_message", JSON.stringify(storage));
              self.setState({ redirect_url: url });
            }
            self.props.updateData(responseJson);
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'delete',
    value: function _delete(id) {

      if (navigator.onLine) {
        if (window.confirm(this.locale.RelatorioAbastecimento.AdicionarAbastecimento.deletar)) {
          this.props.handleAlert('', '', 'open');
          var datasave = {
            id: id
          };
          var header = this.refs.request_api.header('application/json');
          var self = this;
          Promise.resolve(header).then(function (value) {
            fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/abastecimento', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.refs.request_api.validate(responseJson, 'alert');
              self.setState({
                aircrafts_select: responseJson.data.infos.aircrafts_select,
                locations_select: responseJson.data.infos.locations_select,
                flight_reports_select: responseJson.data.infos.flight_reports_select,
                flight_report_legs: responseJson.data.infos.flight_report_legs_select,
                flight_report_refuels: responseJson.data.infos.flight_report_refuels_table,
                fuel_suppliers_select: responseJson.data.infos.fuel_suppliers_select,
                fuel_types_select: responseJson.data.infos.fuel_types_select,
                companies_select: responseJson.data.infos.companies_select,
                staffs_select: responseJson.data.infos.staffs_select,
                aircraft_id: '',
                date: '',
                flight_report_leg_id: '',
                fuel_supplier_id: '',
                location_id: '',
                receit: '',
                requested: '',
                quantity: '',
                address: '',
                staff_id: '',
                fueling_started: '',
                fueling_finished: '',
                next_location_id: '',
                hydrant_no: '',
                your_sale_no: '',
                previous_sale_no: '',
                reading_finish: '',
                reading_start: '',
                fuel_type_id: ''
              });
              self.props.updateData(responseJson);
              self.props.handleAlert(responseJson.message, responseJson.status, 'open');
            }).catch(function (error) {
              console.error(error);
            });
          });
        }
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'openEditModal',
    value: function openEditModal(id) {

      if (navigator.onLine) {
        var self = this;
        var header = this.refs.request_api.header('application/json');
        Promise.resolve(header).then(function (value) {
          var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/abastecimento/' + id;
          fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'url', '/bases');
            if (responseJson.status === 'success') {
              self.setState({
                modal_flight_report_refuel_edit: responseJson.data.main,
                modal_flight_report_legs_select: responseJson.data.flight_report_legs_select,
                modal_fuel_suppliers_select: responseJson.data.fuel_suppliers_select,
                modal_aircrafts_select: responseJson.data.aircrafts_select,
                modal_locations_select: responseJson.data.locations_select,
                modal_fuel_types_select: responseJson.data.fuel_types_select,
                modal_companies_select: responseJson.data.companies_select,
                modal_staffs_select: responseJson.data.staffs_select,
                flight_report_refuel_approvals: responseJson.data.flight_report_refuel_approvals,
                modal: true
              });
            }
          }).then(function () {
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          }); /* Overlay */
        });
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'closeModal',
    value: function closeModal(responseJson) {
      this.props.handleAlert('', '', 'open');
      this.setState({
        modal: false,
        flight_report_refuel_edit: {}
      }, this.props.updateData({ message: this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.mensagemDadosAtualizadosComSucesso, status: 'success', data: {} }));
    }
  }, {
    key: 'formFields',
    value: function formFields(fields_type) {
      var _this2 = this;

      var fields = '';

      if (fields_type == 0) {
        fields = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-4 form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              null,
              this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.CombustivelSolicitado,
              ':'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.requested, maskChar: null, name: 'requested ', mask: '9999', className: 'form-control', onChange: this.handleChange.bind(this, 'requested'), placeholder: '' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-4 form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              null,
              this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.NumeroDaCe,
              ':'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'receit', className: 'form-control', placeholder: '', value: this.state.receit, onChange: this.handleChange.bind(this, 'receit'), required: true })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'col-md-4 form-group' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'label',
              null,
              this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.CombustivelAbastecido,
              ':'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.quantity, maskChar: null, name: 'quantity ', mask: '9999', className: 'form-control', onChange: this.handleChange.bind(this, 'quantity'), placeholder: '', required: true })
          )
        );
      } else {
        fields = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Endereco
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'address', className: 'form-control', placeholder: '', value: this.state.address, onChange: this.handleChange.bind(this, 'address'), required: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Comandante
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'staff_id',
                value: this.state.staff_id,
                searchable: true,
                placeholder: 'Selecione',
                onChange: this.handleSelectChange.bind(this, 'staff_id'),
                options: this.state.staffs_select
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-2 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.InicioAbastecimento,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.fueling_started, maskChar: null, name: 'fueling_started ', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'fueling_started'), placeholder: 'hh:mm' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-1 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Click
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'button', className: 'btn btn-primary btn-sm form-control', onClick: function onClick() {
                    _this2.autoFillTime('fueling_started');
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-angle-double-left' }),
                ' ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-clock-o' })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-2 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.TerminoAbastecimento,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.fueling_finished, maskChar: null, name: 'fueling_finished ', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'fueling_finished'), placeholder: 'hh:mm' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-1 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Click
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'button', className: 'btn btn-primary btn-sm form-control', onClick: function onClick() {
                    _this2.autoFillTime('fueling_finished');
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-angle-double-left' }),
                ' ',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-clock-o' })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.ProximaLocalidade,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'next_location_id',
                value: this.state.next_location_id,
                searchable: true,
                placeholder: 'Selecione',
                onChange: this.handleSelectChange.bind(this, 'next_location_id'),
                options: this.state.locations_select,
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.NumeroHidrante,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'hydrant_no', className: 'form-control', placeholder: '999', value: this.state.hydrant_no, onChange: this.handleChange.bind(this, 'hydrant_no'), required: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.SeuNumeroDeVenda,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'your_sale_no', className: 'form-control', placeholder: '', value: this.state.your_sale_no, onChange: this.handleChange.bind(this, 'your_sale_no'), required: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.NumeroDeVendaAnterior,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'previous_sale_no', className: 'form-control', placeholder: '', value: this.state.previous_sale_no, onChange: this.handleChange.bind(this, 'previous_sale_no'), required: true })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.LeituraFinal,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'reading_finish', className: 'form-control', placeholder: '999', value: this.state.reading_finish, onChange: this.handleChangeGallonsReading.bind(this, 'reading_finish'), required: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.LeituraInicial,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'reading_start', className: 'form-control', placeholder: '999', value: this.state.reading_start, onChange: this.handleChangeGallonsReading.bind(this, 'reading_start'), required: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Entregues,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.quantity, maskChar: null, name: 'quantity', mask: '9999', className: 'form-control', onChange: this.handleChange.bind(this, 'quantity'), placeholder: '9999', required: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.TipoCombustivel,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'fuel_type_id',
                value: this.state.fuel_type_id,
                searchable: true,
                placeholder: 'Selecione',
                onChange: this.handleSelectChangeFuelType.bind(this, 'fuel_type_id'),
                options: this.state.fuel_types_select,
                required: true
              })
            )
          )
        );
      }

      return fields;
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloCadastrarAbastecimento
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: this.add },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Fornecedor,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'fuel_supplier_id',
                value: this.state.fuel_supplier_id,
                searchable: true,
                placeholder: 'Selecione',
                onChange: this.handleSelectChangeFuelSupplier.bind(this, 'fuel_supplier_id'),
                options: this.state.fuel_suppliers_select,
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.AnexarNotaFiscal,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'file', name: 'file', className: 'form-control input-nf-file', value: this.state.file, onChange: this.handleChange.bind(this, 'file') })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-4 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Trecho,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'flight_report_leg_id',
                value: this.state.flight_report_leg_id,
                searchable: true,
                placeholder: 'Selecione',
                onChange: this.handleSelectChangeLeg.bind(this, 'flight_report_leg_id'),
                options: this.state.flight_report_legs_select,
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-4 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Localidade,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'location_id',
                value: this.state.location_id,
                searchable: true,
                placeholder: 'Selecione',
                onChange: this.handleSelectChange.bind(this, 'location_id'),
                options: this.state.locations_select,
                required: true
              })
            )
          ),
          this.formFields(this.state.export_required),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'submit', className: 'btn btn-primary btn-block btn-inline' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
            ' ',
            this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.botaoAdicionarAbastecimento
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          { className: 'page-title' },
          this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloAbastecimentosCadastrados
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaAbastecimentosCadastrados.Trecho
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaAbastecimentosCadastrados.NumeroDaCE
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaAbastecimentosCadastrados.Fornecedor
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaAbastecimentosCadastrados.Localidade
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaAbastecimentosCadastrados.QuantidadeSolicitada
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaAbastecimentosCadastrados.QuantidadeAbastecida
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'col-md-1 text-center' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaAbastecimentosCadastrados.Acoes
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              null,
              Object.keys(self.state.flight_report_refuels).map(function (k) {
                var srr = self.state.flight_report_refuels[k];
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  { key: srr.id },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srr.flight_report_leg === null ? '' : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      null,
                      srr.flight_report_leg.leg_number
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srr.receit
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srr.fuel_supplier === null ? '' : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      null,
                      srr.fuel_supplier.name
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srr.location === null ? '' : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      null,
                      srr.location.name
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srr.requested,
                    ' ',
                    self.state.fuel_unity
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srr.quantity,
                    ' L'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { onClick: function onClick() {
                          return self.delete(srr.id);
                        }, className: 'btn btn-danger btn-sm' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-trash' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { onClick: function onClick() {
                          return self.openEditModal(srr.id);
                        }, className: 'btn btn-primary btn-sm' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-pencil' })
                    )
                  )
                );
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloEditarSolicitacaoDeCombustivel
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: this.closeModal },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__FlightReportRefuels_Elements_FlightReportRefuelEditTab__["a" /* default */], { updateData: this.props.updateData, handleAlert: this.props.handleAlert, flight_report_refuel_edit: this.state.modal_flight_report_refuel_edit, flight_report_legs_select: this.state.modal_flight_report_legs_select, fuel_suppliers_select: this.state.modal_fuel_suppliers_select, aircrafts_select: this.state.modal_aircrafts_select, locations_select: this.state.modal_locations_select, fuel_types_select: this.state.modal_fuel_types_select, companies_select: this.state.modal_companies_select, staffs_select: this.state.modal_staffs_select })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: this.closeModal },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return FlightReportRefuelTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportRefuelTab);

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







// Helpers de formulário




var FlightReportStaffsTab = function (_Component) {
  _inherits(FlightReportStaffsTab, _Component);

  function FlightReportStaffsTab(props) {
    _classCallCheck(this, FlightReportStaffsTab);

    var _this = _possibleConstructorReturn(this, (FlightReportStaffsTab.__proto__ || Object.getPrototypeOf(FlightReportStaffsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      modal_edit: false,
      flight_report_id: null,
      staff_id: null,
      duty_id: null,
      arrival: null,
      date: _this.props.flight_report.date_str,
      flight_report: _this.props.flight_report,
      flight_report_staffs: _this.props.flight_report_staffs,
      staffs_select: [],
      duties_select: []
    };

    _this.add = _this.add.bind(_this);
    _this.edit = _this.edit.bind(_this);
    _this.deleteStaff = _this.deleteStaff.bind(_this);
    _this.openModal = _this.openModal.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(FlightReportStaffsTab, [{
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.flight_report_staffs) || this.state.loaded === 1 && newProps.updated === 1) {
        this.setState({
          flight_report_id: newProps.flight_report_id,
          flight_report_staffs: newProps.flight_report_staffs,
          staffs_select: newProps.staffs_select,
          duties_select: newProps.duties_select,
          flight_report: newProps.flight_report,
          date: newProps.flight_report.date_str,
          loaded: 1
        });
      }
    }
  }, {
    key: 'openModal',
    value: function openModal(flight_report_leg_staff) {

      var arrival = flight_report_leg_staff.arrival;
      var date = arrival.slice(0, 10);
      var arrival_hour = arrival.slice(11, 16);

      this.setState({
        staff_id: flight_report_leg_staff.staff_id,
        duty_id: flight_report_leg_staff.duty_id,
        date: date,
        arrival_hour: arrival_hour,
        modal_edit: true
      });
    }
  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      if (navigator.onLine) {
        this.props.handleAlert('', '', 'open');
        var arrival = this.state.date + ' ' + this.state.arrival_hour;
        var datasave = {
          flight_report_id: this.state.flight_report_id,
          staff_id: this.state.staff_id,
          duty_id: this.state.duty_id,
          arrival: arrival
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/tripulante', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
            self.setState({ staff_id: null, duty_id: null });
          }).catch(function (error) {
            console.error(error);
          });
        });
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'edit',
    value: function edit(event) {
      event.preventDefault();
      if (navigator.onLine) {
        this.props.handleAlert('', '', 'open');
        var arrival = this.state.date + ' ' + this.state.arrival_hour;
        var datasave = {
          flight_report_id: this.state.flight_report_id,
          staff_id: this.state.staff_id,
          duty_id: this.state.duty_id,
          arrival: arrival
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/tripulante', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
            self.setState({ staff_id: null, duty_id: null, modal_edit: false });
          }).catch(function (error) {
            console.error(error);
          });
        });
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'deleteStaff',
    value: function deleteStaff(staff_id) {
      if (navigator.onLine) {
        if (window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.excluirTripulante)) {
          this.props.handleAlert('', '', 'open');
          var datasave = {
            staff_id: staff_id,
            flight_report_id: this.state.flight_report_id
          };
          var header = this.refs.request_api.header('application/json');
          var self = this;
          Promise.resolve(header).then(function (value) {
            fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/tripulante', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.refs.request_api.validate(responseJson, 'alert');
              self.props.updateData(responseJson);
            }).catch(function (error) {
              console.error(error);
            });
          });
        }
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloCadastrarTripulacao
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: this.add },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTripulacao.Tripulante,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'staff_id',
                value: this.state.staff_id,
                searchable: true,
                placeholder: '',
                onChange: this.handleSelectChange.bind(this, 'staff_id'),
                options: this.state.staffs_select,
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTripulacao.FuncaoDeBordo,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'duty_id',
                value: this.state.duty_id,
                searchable: true,
                placeholder: '',
                onChange: this.handleSelectChange.bind(this, 'duty_id'),
                options: this.state.duties_select,
                required: true
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTripulacao.DataDeApresentacao,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_input_mask___default.a, { value: this.state.date, maskChar: null, name: 'arrival', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date'), placeholder: this.locale.general.diaMesAno, required: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTripulacao.HoraDeApresentacao,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_input_mask___default.a, { value: this.state.arrival_hour, maskChar: null, name: 'arrival', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'arrival_hour'), placeholder: this.locale.general.horaMinuto, required: true })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
            ' ',
            this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioCadastrarTripulacao.botaoAdicionarTripulante
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          { className: 'page-title' },
          this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloTripulantesCadastrados
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { style: { width: '380px' } },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.Nome
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.CANAC
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.SISPAT
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.FB
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.Apresentacao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.DecolagemPouso
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.TempoTotal
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.Navegacao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.Instrumento
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.Noturno
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.PousosDiurnos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.PousosNoturnos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.Pax
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.Carga
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.Consumo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.LongLine
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.ShortLine
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaTripulantesCadastrados.Acoes
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              null,
              Object.keys(self.state.flight_report_staffs).map(function (k) {
                var srls = self.state.flight_report_staffs[k];
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { style: { width: '380px' } },
                    srls.staff
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srls.canac
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srls.sispat
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srls.duty
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srls.arrival
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srls.takeoff_land_time_total
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srls.time_total
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srls.navigation_total
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srls.ifr_total
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srls.night_total
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srls.day_landings_total
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srls.night_landings_total
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srls.pax_total
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srls.payload_total
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srls.fuel_total
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srls.long_line_total
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    null,
                    srls.short_line_total
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { style: { width: '100px', whiteSpace: 'nowrap', textAlign: 'center' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { onClick: function onClick() {
                          return self.openModal(srls);
                        }, className: 'btn btn-primary btn-sm button-inline' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-pencil' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { onClick: function onClick() {
                          return self.deleteStaff(srls.staff_id);
                        }, className: 'btn btn-danger btn-sm button-inline' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-trash' })
                    )
                  )
                );
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal_edit, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalEditarTripulacao.Titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return self.setState({ modal_edit: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.edit },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalEditarTripulacao.FuncaoDeBordo,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    name: 'duty_id',
                    value: this.state.duty_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'duty_id'),
                    options: this.state.duties_select,
                    required: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalEditarTripulacao.DataDeApresentacao,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_input_mask___default.a, { value: this.state.date, maskChar: null, name: 'arrival', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date'), placeholder: this.locale.general.diaMesAno, required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalEditarTripulacao.HoraDeApresentacao,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_input_mask___default.a, { value: this.state.arrival_hour, maskChar: null, name: 'arrival', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'arrival_hour'), placeholder: this.locale.general.horaMinuto, required: true })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                ' ',
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalEditarTripulacao.botaoEditarTripulante
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  _this2.setState({ modal_edit: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return FlightReportStaffsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportStaffsTab);

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário





var FlightReportWarningsTab = function (_Component) {
  _inherits(FlightReportWarningsTab, _Component);

  function FlightReportWarningsTab(props) {
    _classCallCheck(this, FlightReportWarningsTab);

    var _this = _possibleConstructorReturn(this, (FlightReportWarningsTab.__proto__ || Object.getPrototypeOf(FlightReportWarningsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      flight_report_warnings: {}
    };
    //bind específico
    _this.edit = _this.edit.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(FlightReportWarningsTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.flight_report_warnings) || this.state.loaded === 1 && newProps.updated === 1) {
        this.setState({
          observations: newProps.flight_report.observations,
          flight_report_warnings: newProps.flight_report_warnings,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição

  }, {
    key: 'edit',
    value: function edit(event) {
      event.preventDefault();
      if (navigator.onLine) {
        this.props.handleAlert('', '', 'open');
        var datasave = {
          id: this.props.flight_report_id,
          observations: this.state.observations
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/editar/observacoes', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
          }).catch(function (error) {
            console.error(error);
          });
        });
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'page-title' },
            this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloObservacoes
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'form',
            { onSubmit: this.edit },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarObservacoes.Observacoes,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', { style: { height: 100 }, type: 'text', name: 'observations', className: 'form-control', placeholder: '', value: this.state.observations, onChange: this.handleChange.bind(this, 'observations') })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
              ' ',
              this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.formularioEditarObservacoes.botaoEditarObservacoes
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            { className: 'page-title' },
            this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloAlertasDoRelatorio
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'table-responsive' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'table',
              { className: 'table table-bordered table-hover table-striped' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'thead',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaAlertasDoRelatorio.Mensagem
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaAlertasDoRelatorio.Data
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tbody',
                null,
                Object.keys(self.state.flight_report_warnings).map(function (k) {
                  var srl = self.state.flight_report_warnings[k];
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { className: "box-alert box-alert-" + srl.color, dangerouslySetInnerHTML: { __html: srl.message } }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      { className: "box-alert box-alert-" + srl.color },
                      srl.created_at_str
                    )
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);

  return FlightReportWarningsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportWarningsTab);

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Elements_FlightReportOfflineLegEditTab__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Elements_FlightReportOfflineLegEditViewTab__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_moment__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário









var FlightReportLegsFullOffline = function (_Component) {
  _inherits(FlightReportLegsFullOffline, _Component);

  function FlightReportLegsFullOffline(props) {
    var _this$state;

    _classCallCheck(this, FlightReportLegsFullOffline);

    var _this = _possibleConstructorReturn(this, (FlightReportLegsFullOffline.__proto__ || Object.getPrototypeOf(FlightReportLegsFullOffline)).call(this, props));

    _this.state = (_this$state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: false,
      modal: false,
      modal_alerts: false,
      flight_report_id: null,
      leg_number: null,
      departure_location_id: null,
      arrival_location_id: null,
      date: null
    }, _defineProperty(_this$state, 'leg_number', null), _defineProperty(_this$state, 'takeoff_scheduled', null), _defineProperty(_this$state, 'total_time_preview', null), _defineProperty(_this$state, 'engine_start_time', null), _defineProperty(_this$state, 'start_parameter_total', null), _defineProperty(_this$state, 'takeoff_time', null), _defineProperty(_this$state, 'landing_time', null), _defineProperty(_this$state, 'engine_shutoff_time', null), _defineProperty(_this$state, 'takeoff_land_time', '00:00'), _defineProperty(_this$state, 'total_time', '00:00'), _defineProperty(_this$state, 'navigation_time', '00:00'), _defineProperty(_this$state, 'ifr_time', '00:00'), _defineProperty(_this$state, 'night_time', '00:00'), _defineProperty(_this$state, 'day_landings', 0), _defineProperty(_this$state, 'night_landings', 0), _defineProperty(_this$state, 'starts', null), _defineProperty(_this$state, 'flight_report_id', null), _defineProperty(_this$state, 'pax', 0), _defineProperty(_this$state, 'payload', 0), _defineProperty(_this$state, 'external_load_long_line', 0), _defineProperty(_this$state, 'external_load_short_line', 0), _defineProperty(_this$state, 'fuel_start', 0), _defineProperty(_this$state, 'fuel_end', 0), _defineProperty(_this$state, 'ptbr_code_id', null), _defineProperty(_this$state, 'ptbr_operation_id', null), _defineProperty(_this$state, 'ptbr_external_load_id', null), _defineProperty(_this$state, 'delay_time', '00:00'), _defineProperty(_this$state, 'delay_departure', '00:00'), _defineProperty(_this$state, 'flight_report_legs', {}), _defineProperty(_this$state, 'flight_reports_by_id', {}), _defineProperty(_this$state, 'locations_select', []), _defineProperty(_this$state, 'ptbr_codes_select', []), _defineProperty(_this$state, 'ptbr_operations_select', []), _defineProperty(_this$state, 'ptbr_external_loads_select', []), _defineProperty(_this$state, 'staffs_select', []), _defineProperty(_this$state, 'duties_select', []), _defineProperty(_this$state, 'flight_report_leg_edit', {}), _defineProperty(_this$state, 'flight_report_leg_edit_staffs', {}), _defineProperty(_this$state, 'frl_alerts', {}), _this$state);

    _this.add = _this.add.bind(_this);
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.addMobile = _this.addMobile.bind(_this);
    _this.diffFlight = _this.diffFlight.bind(_this);
    _this.diffTotalTime = _this.diffTotalTime.bind(_this);
    _this.delayFlight = _this.delayFlight.bind(_this);
    _this.delayTotalTime = _this.delayTotalTime.bind(_this);
    _this.calcTimeFromMs = _this.calcTimeFromMs.bind(_this);
    _this.autoFillTime = _this.autoFillTime.bind(_this);
    _this.updateLegData = _this.updateLegData.bind(_this);
    _this.openModal = _this.openModal.bind(_this);
    _this.delete = _this.delete.bind(_this);
    _this.saveOnline = _this.saveOnline.bind(_this);
    return _this;
  }

  _createClass(FlightReportLegsFullOffline, [{
    key: 'autoFillTime',
    value: function autoFillTime(name) {

      var now = __WEBPACK_IMPORTED_MODULE_10_moment___default()(new Date());
      now = now.format("HH:mm");
      var change = {};
      change[name] = now;
      if (name === 'takeoff_time') {
        this.diffFlight(now, this.state.landing_time, change);
        this.delayFlight(now, this.state.takeoff_scheduled, change);
        this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, now, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'landing_time') {
        this.diffFlight(this.state.takeoff_time, now, change);
        this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, this.state.takeoff_time, now, this.state.start_parameter_total, change);
      } else if (name === 'engine_start_time') {
        this.diffTotalTime(now, this.state.engine_shutoff_time, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'engine_shutoff_time') {
        this.diffTotalTime(this.state.engine_start_time, now, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'takeoff_scheduled') {
        this.delayFlight(this.state.takeoff_time, now, change);
      } else if (name === 'total_time_preview') {
        this.delayTotalTime(now, this.state.takeoff_land_time, change);
      } else {
        this.setState(change);
      }
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }

    // Handlers

  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      if (name === 'takeoff_time') {
        this.diffFlight(event.target.value, this.state.landing_time, change);
        this.delayFlight(event.target.value, this.state.takeoff_scheduled, change);
        this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, event.target.value, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'landing_time') {
        this.diffFlight(this.state.takeoff_time, event.target.value, change);
        this.diffTotalTime(this.state.engine_start_time, this.state.engine_shutoff_time, this.state.takeoff_time, event.target.value, this.state.start_parameter_total, change);
      } else if (name === 'engine_start_time') {
        this.diffTotalTime(event.target.value, this.state.engine_shutoff_time, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'engine_shutoff_time') {
        this.diffTotalTime(this.state.engine_start_time, event.target.value, this.state.takeoff_time, this.state.landing_time, this.state.start_parameter_total, change);
      } else if (name === 'takeoff_scheduled') {
        this.delayFlight(this.state.takeoff_time, event.target.value, change);
      } else if (name === 'total_time_preview') {
        this.delayTotalTime(event.target.value, this.state.takeoff_land_time, change);
      } else {
        this.setState(change);
      }
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var flight_report_legs_lists = JSON.parse(localStorage.getItem("flight_report_legs_lists"));

      var flight_reports_by_id = JSON.parse(localStorage.getItem("flight_reports_by_id"));
      this.setState({ flight_reports_by_id: flight_reports_by_id });

      var new_flight_report_legs_full = JSON.parse(localStorage.getItem("new_flight_report_legs_full"));
      if (new_flight_report_legs_full !== 'undefined' && new_flight_report_legs_full !== null && new_flight_report_legs_full !== undefined) {
        this.setState({ flight_report_legs: new_flight_report_legs_full });
      }

      var now = __WEBPACK_IMPORTED_MODULE_10_moment___default()(new Date());
      now = now.format("DD/MM/YYYY");

      this.setState({
        locations_select: flight_report_legs_lists.locations_select,
        ptbr_codes_select: flight_report_legs_lists.ptbr_codes_select,
        date: now
      });
    }

    // Fetch salvando a adição mobile

  }, {
    key: 'addMobile',
    value: function addMobile(event) {
      event.preventDefault();
      this.add();
    }

    // Fetch salvando a adição

  }, {
    key: 'add',
    value: function add() {
      this.handleAlert('', '', 'open');

      var takeoff_scheduled = null;
      var engine_start_time = null;
      var takeoff_time = null;
      var landing_time = null;
      var engine_shutoff_time = null;

      if (this.state.takeoff_scheduled) takeoff_scheduled = this.state.date + ' ' + this.state.takeoff_scheduled;
      if (this.state.engine_start_time) engine_start_time = this.state.date + ' ' + this.state.engine_start_time;
      if (this.state.takeoff_time) takeoff_time = this.state.date + ' ' + this.state.takeoff_time;
      if (this.state.landing_time) landing_time = this.state.date + ' ' + this.state.landing_time;
      if (this.state.engine_shutoff_time) engine_shutoff_time = this.state.date + ' ' + this.state.engine_shutoff_time;

      if (takeoff_scheduled) takeoff_scheduled = __WEBPACK_IMPORTED_MODULE_10_moment___default()(takeoff_scheduled, "DD/MM/YYYY HH:mm:ss");
      if (engine_start_time) engine_start_time = __WEBPACK_IMPORTED_MODULE_10_moment___default()(engine_start_time, "DD/MM/YYYY HH:mm:ss");
      if (takeoff_time) takeoff_time = __WEBPACK_IMPORTED_MODULE_10_moment___default()(takeoff_time, "DD/MM/YYYY HH:mm:ss");
      if (landing_time) landing_time = __WEBPACK_IMPORTED_MODULE_10_moment___default()(landing_time, "DD/MM/YYYY HH:mm:ss");
      if (engine_shutoff_time) engine_shutoff_time = __WEBPACK_IMPORTED_MODULE_10_moment___default()(engine_shutoff_time, "DD/MM/YYYY HH:mm:ss");

      if (takeoff_scheduled) {
        var diff_hours = takeoff_scheduled.diff(takeoff_time, 'hours');
        if (takeoff_time < takeoff_scheduled && diff_hours > 12) {
          if (engine_start_time) engine_start_time.add(1, 'd');
          if (takeoff_time) takeoff_time.add(1, 'd');
          if (landing_time) landing_time.add(1, 'd');
          if (engine_shutoff_time) engine_shutoff_time.add(1, 'd');
        }
      }

      if (takeoff_time > landing_time) {
        if (landing_time) landing_time.add(1, 'd');
      }

      if (engine_start_time > engine_shutoff_time) {
        if (engine_shutoff_time) engine_shutoff_time.add(1, 'd');
      }

      if (engine_start_time) engine_start_time = engine_start_time.format("HH:mm");
      if (takeoff_time) takeoff_time = takeoff_time.format("HH:mm");
      if (landing_time) landing_time = landing_time.format("HH:mm");
      if (engine_shutoff_time) engine_shutoff_time = engine_shutoff_time.format("HH:mm");
      if (takeoff_scheduled) takeoff_scheduled = takeoff_scheduled.format("HH:mm");

      var storage = JSON.parse(localStorage.getItem("new_flight_report_legs_full"));
      if (storage !== 'undefined' && storage !== null && storage !== undefined && storage.length > 0) {
        var datasave = {
          flight_report_id: null,
          flight_report_number: this.state.flight_report_number,
          leg_number: this.state.leg_number,
          departure_location_id: this.state.departure_location_id,
          arrival_location_id: this.state.arrival_location_id,
          takeoff_scheduled: takeoff_scheduled,
          total_time_preview: this.state.total_time_preview,
          engine_start_time: engine_start_time,
          takeoff_time: takeoff_time,
          landing_time: landing_time,
          engine_shutoff_time: engine_shutoff_time,
          takeoff_land_time: this.state.takeoff_land_time,
          takeoff_scheduled_str: takeoff_scheduled,
          engine_start_time_str: engine_start_time,
          takeoff_time_str: takeoff_time,
          landing_time_str: landing_time,
          engine_shutoff_time_str: engine_shutoff_time,
          total_time: this.state.total_time,
          navigation_time: this.state.navigation_time,
          ifr_time: this.state.ifr_time,
          night_time: this.state.night_time,
          day_landings: this.state.day_landings,
          night_landings: this.state.night_landings,
          starts: this.state.starts,
          pax: this.state.pax,
          payload: this.state.payload,
          external_load_long_line: this.state.external_load_long_line,
          external_load_short_line: this.state.external_load_short_line,
          fuel_start: this.state.fuel_start,
          fuel_end: this.state.fuel_end,
          delay_time: this.state.delay_time,
          delay_departure: this.state.delay_departure,
          ptbr_code_id: this.state.ptbr_code_id,
          ptbr_operation_id: this.state.ptbr_operation_id,
          ptbr_external_load_id: this.state.ptbr_external_load_id,
          errors: [],
          status: 'pending',
          status_str: 'Pendente'
        };

        storage.push(datasave);
        localStorage.setItem("new_flight_report_legs_full", JSON.stringify(storage));
      } else {
        var storage = [{
          flight_report_id: null,
          leg_number: this.state.flight_report_number,
          flight_report_number: this.state.flight_report_number,
          departure_location_id: this.state.departure_location_id,
          arrival_location_id: this.state.arrival_location_id,
          takeoff_scheduled: takeoff_scheduled,
          total_time_preview: this.state.total_time_preview,
          engine_start_time: engine_start_time,
          takeoff_time: takeoff_time,
          landing_time: landing_time,
          engine_shutoff_time: engine_shutoff_time,
          takeoff_land_time: this.state.takeoff_land_time,
          takeoff_scheduled_str: takeoff_scheduled,
          engine_start_time_str: engine_start_time,
          takeoff_time_str: takeoff_time,
          landing_time_str: landing_time,
          engine_shutoff_time_str: engine_shutoff_time,
          total_time: this.state.total_time,
          navigation_time: this.state.navigation_time,
          ifr_time: this.state.ifr_time,
          night_time: this.state.night_time,
          day_landings: this.state.day_landings,
          night_landings: this.state.night_landings,
          starts: this.state.starts,
          pax: this.state.pax,
          payload: this.state.payload,
          external_load_long_line: this.state.external_load_long_line,
          external_load_short_line: this.state.external_load_short_line,
          fuel_start: this.state.fuel_start,
          fuel_end: this.state.fuel_end,
          delay_time: this.state.delay_time,
          delay_departure: this.state.delay_departure,
          ptbr_code_id: this.state.ptbr_code_id,
          ptbr_operation_id: this.state.ptbr_operation_id,
          ptbr_external_load_id: this.state.ptbr_external_load_id,
          status: 'pending',
          status_str: 'Pendente'
        }];

        localStorage.setItem("new_flight_report_legs_full", JSON.stringify(storage));
      }

      var storage = JSON.parse(localStorage.getItem("new_flight_report_legs_full"));
      this.setState({
        flight_report_id: null,
        leg_number: null,
        flight_report_number: null,
        departure_location_id: null,
        arrival_location_id: null,
        takeoff_scheduled: '',
        total_time_preview: '',
        engine_start_time: '',
        takeoff_time: '',
        landing_time: '',
        engine_shutoff_time: '',
        takeoff_land_time: '00:00',
        total_time: '00:00',
        navigation_time: '',
        ifr_time: '',
        night_time: '',
        day_landings: 0,
        night_landings: 0,
        starts: 0,
        pax: 0,
        payload: 0,
        external_load_long_line: 0,
        external_load_short_line: 0,
        fuel_start: 0,
        fuel_end: 0,
        delay_time: '',
        delay_departure: '',
        ptbr_code_id: null,
        ptbr_operation_id: null,
        ptbr_external_load_id: null
      });

      this.handleAlert('', '', 'closed');
    }
  }, {
    key: 'diffFlight',
    value: function diffFlight(takeoff_time, landing_time, change) {
      if (takeoff_time && landing_time && takeoff_time !== '' && landing_time !== '') {
        takeoff_time = this.state.date + ' ' + takeoff_time;
        landing_time = this.state.date + ' ' + landing_time;

        takeoff_time = __WEBPACK_IMPORTED_MODULE_10_moment___default()(takeoff_time, "DD/MM/YYYY HH:mm:ss");
        landing_time = __WEBPACK_IMPORTED_MODULE_10_moment___default()(landing_time, "DD/MM/YYYY HH:mm:ss");

        if (takeoff_time > landing_time) {
          landing_time.add(1, 'd');
        }

        takeoff_time = new Date(takeoff_time.format("YYYY-MM-DD HH:mm:ss").replace(/ /g, "T"));
        landing_time = new Date(landing_time.format("YYYY-MM-DD HH:mm:ss").replace(/ /g, "T"));

        var diffTime = Math.abs(landing_time.getTime() - takeoff_time.getTime());

        if (landing_time > takeoff_time) {
          change['takeoff_land_time'] = this.calcTimeFromMs(diffTime);
          change['navigation_time'] = this.calcTimeFromMs(diffTime);
        } else {
          change['takeoff_land_time'] = '00:00';
          change['navigation_time'] = '00:00';
        }
      } else {
        change['takeoff_land_time'] = '00:00';
        change['navigation_time'] = '00:00';
      }
      this.delayTotalTime(this.state.total_time_preview, change['takeoff_land_time'], change);
    }
  }, {
    key: 'diffTotalTime',
    value: function diffTotalTime(engine_start_time, engine_shutoff_time, takeoff_time, landing_time, start_parameter_total, change) {
      var start = null;
      if (engine_start_time !== null && engine_start_time !== '' && typeof engine_start_time !== 'undefined') {
        start = engine_start_time;
      } else if (start_parameter_total !== null) {
        start = start_parameter_total.substring(11);
      }

      var finish = null;
      if (landing_time !== null && landing_time !== '' && typeof landing_time !== 'undefined') {
        finish = landing_time;
      }
      if (engine_shutoff_time !== null && engine_shutoff_time !== '' && typeof engine_shutoff_time !== 'undefined') {
        finish = engine_shutoff_time;
      }

      if (start && finish) {
        start = this.state.date + ' ' + start;
        finish = this.state.date + ' ' + finish;

        start = __WEBPACK_IMPORTED_MODULE_10_moment___default()(start, "DD/MM/YYYY HH:mm:ss");
        finish = __WEBPACK_IMPORTED_MODULE_10_moment___default()(finish, "DD/MM/YYYY HH:mm:ss");

        if (start > finish) {
          finish.add(1, 'd');
        }

        start = new Date(start.format("YYYY-MM-DD HH:mm:ss").replace(/ /g, "T"));
        finish = new Date(finish.format("YYYY-MM-DD HH:mm:ss").replace(/ /g, "T"));

        var diffTime = Math.abs(finish.getTime() - start.getTime());
        if (finish > start) {
          change['total_time'] = this.calcTimeFromMs(diffTime);
        } else {
          change['total_time'] = '00:00';
        }

        this.setState(change);
      } else {
        change['total_time'] = '00:00';
        this.setState(change);
      }
    }
  }, {
    key: 'delayFlight',
    value: function delayFlight(takeoff_time, takeoff_scheduled, change) {
      if (takeoff_scheduled) {
        takeoff_time = this.state.date + ' ' + takeoff_time;
        takeoff_scheduled = this.state.date + ' ' + takeoff_scheduled;

        takeoff_time = __WEBPACK_IMPORTED_MODULE_10_moment___default()(takeoff_time, "DD/MM/YYYY HH:mm:ss");
        takeoff_scheduled = __WEBPACK_IMPORTED_MODULE_10_moment___default()(takeoff_scheduled, "DD/MM/YYYY HH:mm:ss");

        var diff_hours = takeoff_scheduled.diff(takeoff_time, 'hours');

        if (takeoff_time < takeoff_scheduled && diff_hours > 12) {
          takeoff_time.add(1, 'd');
        }

        takeoff_time = new Date(takeoff_time.format("YYYY-MM-DD HH:mm:ss").replace(/ /g, "T"));
        takeoff_scheduled = new Date(takeoff_scheduled.format("YYYY-MM-DD HH:mm:ss").replace(/ /g, "T"));
        var diffTime = Math.abs(takeoff_time.getTime() - takeoff_scheduled.getTime());
        if (takeoff_time > takeoff_scheduled) {
          change['delay_departure'] = this.calcTimeFromMs(diffTime);
        } else {
          change['delay_departure'] = '00:00';
        }
      } else {
        change['delay_departure'] = '00:00';
      }
      this.setState(change);
    }
  }, {
    key: 'delayTotalTime',
    value: function delayTotalTime(total_time_preview, takeoff_land_time, change) {
      if (takeoff_land_time && total_time_preview) {
        takeoff_land_time = __WEBPACK_IMPORTED_MODULE_10_moment___default()().format("YYYY-MM-DD") + ' ' + takeoff_land_time;
        total_time_preview = __WEBPACK_IMPORTED_MODULE_10_moment___default()().format("YYYY-MM-DD") + ' ' + total_time_preview;

        takeoff_land_time = new Date(takeoff_land_time.replace(/ /g, "T"));
        total_time_preview = new Date(total_time_preview.replace(/ /g, "T"));
        var diffTime = Math.abs(takeoff_land_time.getTime() - total_time_preview.getTime());
        if (takeoff_land_time > total_time_preview) {
          change['delay_time'] = this.calcTimeFromMs(diffTime);
        } else {
          change['delay_time'] = '00:00';
        }
      } else {
        change['delay_time'] = '00:00';
      }
      this.setState(change);
    }
  }, {
    key: 'calcTimeFromMs',
    value: function calcTimeFromMs(diffTime) {
      diffTime = diffTime / 1000;
      var secs = diffTime % 60;
      diffTime = (diffTime - secs) / 60;
      var mins = diffTime % 60;
      var hrs = (diffTime - mins) / 60;
      if (secs < 10) {
        secs = '0' + secs;
      }
      if (mins < 10) {
        mins = '0' + mins;
      }
      if (hrs < 10) {
        hrs = '0' + hrs;
      }
      return hrs + ':' + mins + ':' + secs;
    }
  }, {
    key: 'updateLegData',
    value: function updateLegData(flight_report_id, flight_report_leg_id) {
      var self = this;

      var flight_report_legs = self.state.flight_reports_by_id.flight_reports_by_id[flight_report_id].flight_report_legs;
      Object.keys(flight_report_legs).map(function (index_legs) {
        var srl = flight_report_legs[index_legs];

        if (flight_report_leg_id == srl.id) {
          Object.keys(srl).map(function (field) {
            var data = {};
            data[field] = srl[field];
            self.setState(data);
          });
        }
        self.setState({
          flight_report_number: srl['flight_report_id'],
          engine_start_time: srl['engine_start_time_str'],
          takeoff_time: srl['takeoff_time_str'],
          landing_time: srl['landing_time_str'],
          engine_shutoff_time: srl['engine_shutoff_time_str']
        });
      });
    }
  }, {
    key: 'openModal',
    value: function openModal(modal_errors) {
      this.setState({ frl_alerts: modal_errors, modal_alerts: true });
    }
  }, {
    key: 'delete',
    value: function _delete(index_key) {

      var storage = localStorage.getItem("new_flight_report_legs_full");

      storage = JSON.parse(storage);
      storage.splice(index_key, 1);

      localStorage.setItem("new_flight_report_legs_full", JSON.stringify(storage));

      var storage = JSON.parse(localStorage.getItem("new_flight_report_legs_full"));

      this.setState({ flight_report_legs: storage });
    }
  }, {
    key: 'saveOnline',
    value: function saveOnline() {
      var self = this;
      if (navigator.onLine) {
        this.handleAlert('', '', 'open');

        var header = self.refs.request_api.header('application/json');
        var new_flight_report_legs_full = JSON.parse(localStorage.getItem("new_flight_report_legs_full"));

        var datasave = {
          new_flight_report_legs_full: new_flight_report_legs_full
        };
        if (new_flight_report_legs_full !== 'undefined' && new_flight_report_legs_full !== null && new_flight_report_legs_full !== undefined && new_flight_report_legs_full.length > 0) {
          Promise.resolve(header).then(function (value) {
            var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/portal/relatorios/salvar/offline';
            fetch(url, { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.refs.request_api.validate(responseJson, 'url');
              if (responseJson.status === 'success') {
                if (responseJson.data === true) {
                  localStorage.removeItem("new_flight_report_legs");
                  localStorage.removeItem("new_flight_report_legs_full");
                  self.handleAlert('Os relatórios de voo offline foram salvos.', 'success', 'open');
                } else {
                  localStorage.setItem("new_flight_report_legs_full", JSON.stringify(responseJson.data));
                  self.handleAlert('Alguns trechos encontram-se com erro.', 'warning', 'open');
                }
              }
            });
          });
        } else {
          this.handleAlert('', '', 'closed');
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      var start_parameter_total = null;
      var total = 1;
      var style = {
        form: { width: '100%', height: 'auto', overflowX: 'auto', whiteSpace: 'nowrap' },
        input_hour: { width: '75px', textAlign: 'center' },
        input_flight_report_id: { width: '105px', textAlign: 'center' },
        select_places: { width: '130px' },
        select_operation: { width: '240px' },
        input_number: { width: '70px', textAlign: 'center' },
        input_fuel: { width: '110px', textAlign: 'center' },
        divs: { display: 'inline-block', marginRight: '15px' }
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'conteudo' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          'Cadastrar trecho de voo'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: this.addMobile, className: 'visible-xs' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'N\xFAmero do Relat\xF3rio'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', value: this.state.flight_report_id, name: 'flight_report_id ', className: 'form-control', onChange: this.handleChange.bind(this, 'flight_report_id'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Trecho'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.leg_number, name: 'leg_number ', className: 'form-control', onChange: this.handleChange.bind(this, 'leg_number'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Origem'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'departure_location_id',
                value: this.state.departure_location_id,
                searchable: true,
                placeholder: '',
                onChange: this.handleSelectChange.bind(this, 'departure_location_id'),
                options: this.state.locations_select
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Destino'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'arrival_location_id',
                value: this.state.arrival_location_id,
                searchable: true,
                placeholder: '',
                onChange: this.handleSelectChange.bind(this, 'arrival_location_id'),
                options: this.state.locations_select
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Partida'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'input-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.engine_start_time, maskChar: null, name: 'engine_start_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'engine_start_time'), placeholder: '' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'input-group-btn' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-primary btn-md', onClick: function onClick() {
                        self.autoFillTime('engine_start_time');
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-clock-o' })
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'DEC.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'input-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.takeoff_time, maskChar: null, name: 'takeoff_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'takeoff_time'), placeholder: '' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'input-group-btn' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-primary btn-md', onClick: function onClick() {
                        self.autoFillTime('takeoff_time');
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-clock-o' })
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'POU.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'input-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.landing_time, maskChar: null, name: 'landing_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'landing_time'), placeholder: '' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'input-group-btn' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-primary btn-md', onClick: function onClick() {
                        self.autoFillTime('landing_time');
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-clock-o' })
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Corte'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'input-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.engine_shutoff_time, maskChar: null, name: 'engine_shutoff_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'engine_shutoff_time'), placeholder: '' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'input-group-btn' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-primary btn-md', onClick: function onClick() {
                        self.autoFillTime('engine_shutoff_time');
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-clock-o' })
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'DEC-POU'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.takeoff_land_time, maskChar: null, name: 'takeoff_land_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'takeoff_land_time'), placeholder: '', disabled: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Total'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.total_time, maskChar: null, name: 'total_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'total_time'), placeholder: '', disabled: true })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Nav.'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.navigation_time, maskChar: null, name: 'navigation_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'navigation_time'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'IFR'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.ifr_time, maskChar: null, name: 'ifr_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'ifr_time'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Noturno'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.night_time, maskChar: null, name: 'night_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'night_time'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Diurnos'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.day_landings, name: 'day_landings ', className: 'form-control', onChange: this.handleChange.bind(this, 'day_landings'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Noturnos'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.night_landings, name: 'night_landings ', className: 'form-control', onChange: this.handleChange.bind(this, 'night_landings'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Partidas'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.starts, name: 'starts ', className: 'form-control', onChange: this.handleChange.bind(this, 'starts'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'PAX'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.pax, name: 'pax ', className: 'form-control', onChange: this.handleChange.bind(this, 'pax'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Carga'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.payload, name: 'payload ', className: 'form-control', onChange: this.handleChange.bind(this, 'payload'), placeholder: '' })
            ),
            this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 col-xs-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Long Line'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
                checked: this.state.external_load_long_line,
                'aria-label': 'No label tag',
                name: 'external_load_long_line',
                onChange: this.handleToggleChange.bind(this, 'external_load_long_line') })
            ) : '',
            this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 col-xs-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Short Line'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
                checked: this.state.external_load_short_line,
                'aria-label': 'No label tag',
                name: 'external_load_short_line',
                onChange: this.handleToggleChange.bind(this, 'external_load_short_line') })
            ) : '',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Inicial'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.fuel_start, name: 'fuel_start ', className: 'form-control', onChange: this.handleChange.bind(this, 'fuel_start'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Final'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', value: this.state.fuel_end, name: 'fuel_end ', className: 'form-control', onChange: this.handleChange.bind(this, 'fuel_end'), placeholder: '' })
            ),
            this.state.xml == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'C\xF3digo PTBR \xA0\xA0',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'button', onClick: function onClick() {
                      return _this2.exportPtbrCode();
                    }, className: 'btn btn-success btn-xs' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'ptbr_code_id',
                value: this.state.ptbr_code_id,
                searchable: true,
                placeholder: '',
                onChange: this.handleSelectChange.bind(this, 'ptbr_code_id'),
                options: this.state.ptbr_codes_select
              })
            ) : ''
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'submit', className: 'btn btn-primary btn-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
            ' Adicionar Trecho'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { type: 'button', className: 'btn btn-sm btn-success pull-left', onClick: function onClick() {
              self.saveOnline();
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-refresh' }),
          'Enviar para o servidor'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-hover table-striped' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { colSpan: 4 }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 13, className: 'text-center' },
                  'Realizado'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 2, className: 'text-center' },
                  'Pousos'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 3, className: 'text-center' },
                  'Dados'
                ),
                this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 2, className: 'text-center' },
                  'Carga externa'
                ) : '',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 2, className: 'text-center' },
                  'Combust\xEDvel'
                ),
                this.state.xml == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 1, className: 'text-center' },
                  'Opera\xE7\xE3o PTBR ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', onClick: function onClick() {
                        return _this2.exportPtbrCode();
                      }, className: 'btn btn-success btn-xs' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' })
                  )
                ) : '',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  null,
                  'Status'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'A\xE7\xF5es'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { className: 'text-center' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'N\xB0 Relvoo.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Trecho'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Origem'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Destino'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 2, className: 'text-center' },
                  'Partida'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 2, className: 'text-center' },
                  'DEC.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 2, className: 'text-center' },
                  'POU.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 2, className: 'text-center' },
                  'Corte'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'DEC-POU'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Total'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Nav.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'IFR'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Noturno'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Diurnos'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Noturnos'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Partidas'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'PAX'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Carga'
                ),
                this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Long Line'
                ) : '',
                this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Short Line'
                ) : '',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Inicial'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Final'
                ),
                this.state.xml == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'C\xF3digo PTBR '
                ) : '',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { className: 'text-center', style: { width: '200px' } })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              null,
              Object.keys(self.state.flight_report_legs).map(function (k) {
                var srl = self.state.flight_report_legs[k];
                var last_index = parseInt(k) - 1;
                if (typeof self.state.flight_report_legs[last_index] !== 'undefined') {
                  if (self.state.flight_report_legs[last_index].engine_shutoff_time === null || self.state.flight_report_legs[last_index].engine_shutoff_time === '' || typeof self.state.flight_report_legs[last_index].engine_shutoff_time === 'undefined') {
                    start_parameter_total = self.state.flight_report_legs[last_index].landing_time;
                  }
                }
                var index = self.state.flight_report_legs.length;
                index--;
                var edit = false;
                if (parseInt(k) === index) {
                  edit = true;
                }
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Elements_FlightReportOfflineLegEditTab__["a" /* default */], { index_key: k, openModal: self.openModal, 'delete': self.delete, handleAlert: self.handleAlert, external_load: self.state.external_load, xml: self.state.xml, flight_report_leg_edit: srl, locations_select: self.state.locations_select, ptbr_codes_select: self.state.ptbr_codes_select, date: self.state.date, style: style, start_parameter_total: start_parameter_total });
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-primary', onClick: function onClick() {
                        self.add();
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: style.input_flight_report_number, type: 'text', value: this.state.flight_report_number, name: 'flight_report_number ', className: 'form-control', onChange: this.handleChange.bind(this, 'flight_report_number'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: style.input_flight_report_number, type: 'number', value: this.state.leg_number, name: 'leg_number ', className: 'form-control', onChange: this.handleChange.bind(this, 'leg_number'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    style: style.select_places,
                    name: 'departure_location_id',
                    value: this.state.departure_location_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'departure_location_id'),
                    options: this.state.locations_select

                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    style: style.select_places,
                    name: 'arrival_location_id',
                    value: this.state.arrival_location_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'arrival_location_id'),
                    options: this.state.locations_select

                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: style.input_hour, value: this.state.engine_start_time, maskChar: null, name: 'engine_start_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'engine_start_time'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-primary btn-sm', onClick: function onClick() {
                        self.autoFillTime('engine_start_time');
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-clock-o' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: style.input_hour, value: this.state.takeoff_time, maskChar: null, name: 'takeoff_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'takeoff_time'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-primary btn-sm', onClick: function onClick() {
                        self.autoFillTime('takeoff_time');
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-clock-o' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: style.input_hour, value: this.state.landing_time, maskChar: null, name: 'landing_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'landing_time'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-primary btn-sm', onClick: function onClick() {
                        self.autoFillTime('landing_time');
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-clock-o' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: style.input_hour, value: this.state.engine_shutoff_time, maskChar: null, name: 'engine_shutoff_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'engine_shutoff_time'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-primary btn-sm', onClick: function onClick() {
                        self.autoFillTime('engine_shutoff_time');
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-clock-o' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: style.input_hour, value: this.state.takeoff_land_time, maskChar: null, name: 'takeoff_land_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'takeoff_land_time'), placeholder: '', disabled: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: style.input_hour, value: this.state.total_time, maskChar: null, name: 'total_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'total_time'), placeholder: '', disabled: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: style.input_hour, value: this.state.navigation_time, maskChar: null, name: 'navigation_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'navigation_time'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: style.input_hour, value: this.state.ifr_time, maskChar: null, name: 'ifr_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'ifr_time'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { style: style.input_hour, value: this.state.night_time, maskChar: null, name: 'night_time', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'night_time'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: style.input_number, type: 'number', value: this.state.day_landings, name: 'day_landings ', className: 'form-control', onChange: this.handleChange.bind(this, 'day_landings'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: style.input_number, type: 'number', value: this.state.night_landings, name: 'night_landings ', className: 'form-control', onChange: this.handleChange.bind(this, 'night_landings'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: style.input_number, type: 'number', value: this.state.starts, name: 'starts ', className: 'form-control', onChange: this.handleChange.bind(this, 'starts'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: style.input_number, type: 'number', value: this.state.pax, name: 'pax ', className: 'form-control', onChange: this.handleChange.bind(this, 'pax'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: style.input_number, type: 'number', value: this.state.payload, name: 'payload ', className: 'form-control', onChange: this.handleChange.bind(this, 'payload'), placeholder: '' })
                ),
                this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
                    checked: this.state.external_load_long_line,
                    'aria-label': 'No label tag',
                    name: 'external_load_long_line',
                    onChange: this.handleToggleChange.bind(this, 'external_load_long_line') })
                ) : '',
                this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
                    checked: this.state.external_load_short_line,
                    'aria-label': 'No label tag',
                    name: 'external_load_short_line',
                    onChange: this.handleToggleChange.bind(this, 'external_load_short_line') })
                ) : '',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: style.input_number, type: 'number', value: this.state.fuel_start, name: 'fuel_start ', className: 'form-control', onChange: this.handleChange.bind(this, 'fuel_start'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { style: style.input_number, type: 'number', value: this.state.fuel_end, name: 'fuel_end ', className: 'form-control', onChange: this.handleChange.bind(this, 'fuel_end'), placeholder: '' })
                ),
                this.state.xml == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    name: 'ptbr_code_id',
                    value: this.state.ptbr_code_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'ptbr_code_id'),
                    options: this.state.ptbr_codes_select,
                    style: style.select_operation
                  })
                ) : '',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  'Cria\xE7\xE3o'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { style: { width: '200px', whiteSpace: 'nowrap', textAlign: 'center' } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-primary', onClick: function onClick() {
                        self.add();
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' })
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 13, className: 'text-center' },
                  'Trechos Abertos'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 13, className: 'text-center' },
                  'Trechos Abertos'
                ),
                this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 2, className: 'text-center' },
                  'Carga externa'
                ) : '',
                this.state.xml == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { colSpan: 1, className: 'text-center' },
                  'Opera\xE7\xE3o PTBR ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', onClick: function onClick() {
                        return _this2.exportPtbrCode();
                      }, className: 'btn btn-success btn-xs' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' })
                  )
                ) : ''
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { className: 'text-center' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'N\xB0 Relvoo.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Trecho'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Origem'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Destino'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Partida'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { className: 'text-center' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'DEC.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { className: 'text-center' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'POU.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { className: 'text-center' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Corte'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { className: 'text-center' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'DEC-POU'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Total'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Nav.'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'IFR'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Noturno'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Diurnos'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Noturnos'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Partidas'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'PAX'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Carga'
                ),
                this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Long Line'
                ) : '',
                this.state.external_load == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Short Line'
                ) : '',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Inicial'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Final'
                ),
                this.state.xml == 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'C\xF3digo PTBR '
                ) : '',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { className: 'text-center', style: { width: '200px' } })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              null,
              Object.keys(self.state.flight_reports_by_id.flight_reports_by_id).map(function (k) {
                var flight_report_legs = self.state.flight_reports_by_id.flight_reports_by_id[k].flight_report_legs;
                return Object.keys(flight_report_legs).map(function (index_legs) {
                  var srl = flight_report_legs[index_legs];
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Elements_FlightReportOfflineLegEditViewTab__["a" /* default */], { external_load: self.state.external_load, xml: self.state.xml, flight_report_leg_edit: srl, locations_select: self.state.locations_select, ptbr_codes_select: self.state.ptbr_codes_select, date: self.state.date, style: style, start_parameter_total: start_parameter_total, updateLegData: self.updateLegData });
                });
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal_alerts, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                'Alertas'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ modal_alerts: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              Object.keys(self.state.frl_alerts).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: "box-alert box-alert-" + self.state.frl_alerts[k].color },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: self.state.frl_alerts[k].message } })
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ modal_alerts: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return FlightReportLegsFullOffline;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportLegsFullOffline);

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var FlightReportsAdd = function (_Component) {
  _inherits(FlightReportsAdd, _Component);

  // constructor
  function FlightReportsAdd(props) {
    _classCallCheck(this, FlightReportsAdd);

    var _this = _possibleConstructorReturn(this, (FlightReportsAdd.__proto__ || Object.getPrototypeOf(FlightReportsAdd)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      aircraft_id: null,
      base_id: null,
      contract_id: null,
      client_id: null,
      flight_type_id: null,
      date: null,
      flight_number: null,
      report_number: null,
      staff_sigmec_id: null,
      exemption: 0,
      power_checks: 0,
      observations: null,
      bases_select: [],
      aircrafts_select: [],
      flight_types_select: [],
      contracts_select: [],
      show_select_clients: false
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.add = _this.add.bind(_this);
    _this.loadData = _this.loadData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(FlightReportsAdd, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectFlightTypeChange',
    value: function handleSelectFlightTypeChange(name, event) {
      var change = {};
      var self = this;
      change['flight_type_id'] = null;
      change['client_id'] = null;
      change['show_select_clients'] = null;
      if (event == null) {
        change[name] = null;
      } else {
        self.setState({ overlay: { message: '', type: '', status: 'open' } });
        change[name] = event.value;
        var header = this.refs.request_api.header('application/json');
        Promise.resolve(header).then(function (value) {
          var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/tipo/voo/' + event.value;
          fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            if (responseJson.data.client_required === 1) {
              self.setState({
                show_select_clients: true
              });
            }
          }).then(function () {
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          }); /* Overlay */
        });
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectAircraftChange',
    value: function handleSelectAircraftChange(name, event) {
      var change = {};
      var self = this;
      change['contract_id'] = null;
      if (event == null) {
        change[name] = null;
      } else {
        self.setState({ overlay: { message: '', type: '', status: 'open' } });
        change[name] = event.value;
        var header = this.refs.request_api.header('application/json');
        Promise.resolve(header).then(function (value) {
          var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/contrato/aeronave/select/' + event.value;
          fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            if (responseJson.status === 'success') {
              self.setState({
                contracts_select: responseJson.data
              });
            }
          }).then(function () {
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          }); /* Overlay */
        });
      }
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/info/cadastro';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url', '/relatorios/voo');
          if (responseJson.status === 'success') {
            var staffs_sigmec_select = responseJson.data.staffs_sigmec_select || responseJson.data.staff_mechanics_select || [];
            self.setState({
              bases_select: responseJson.data.bases_select,
              aircrafts_select: responseJson.data.aircrafts_select,
              clients_select: responseJson.data.clients_select,
              flight_types_select: responseJson.data.flight_types_select,
              staffs_sigmec_select: staffs_sigmec_select,
              date: responseJson.data.date
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      var datasave = {
        origin: 'Manual',
        client_id: this.state.client_id,
        aircraft_id: this.state.aircraft_id,
        base_id: this.state.base_id,
        contract_id: this.state.contract_id,
        flight_type_id: this.state.flight_type_id,
        date: this.state.date,
        flight_number: this.state.flight_number,
        power_checks: this.state.power_checks,
        report_number: this.state.report_number,
        exemption: this.state.exemption,
        staff_sigmec_id: this.state.staff_sigmec_id,
        observations: this.state.observations
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var url = '/relatorio/voo/editar/' + responseJson.data.id;
            var storage = {
              alert_message: responseJson.message,
              alert_type: responseJson.status
            };
            localStorage.setItem("verify_message", JSON.stringify(storage));
            self.setState({ redirect_url: url });
          }
          self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/relatorios/voo', className: 'btn btn-default pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-left' }),
              ' ',
              this.locale.general.voltar
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.add },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.formulario.Data,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.date, maskChar: null, name: 'date ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date'), placeholder: '', required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.formulario.Prefixo,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    name: 'aircraft_id',
                    value: this.state.aircraft_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectAircraftChange.bind(this, 'aircraft_id'),
                    options: this.state.aircrafts_select,
                    required: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.formulario.Voo,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    name: 'flight_type_id',
                    value: this.state.flight_type_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectFlightTypeChange.bind(this, 'flight_type_id'),
                    options: this.state.flight_types_select,
                    required: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.formulario.NumeroDeVoo,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'flight_number', className: 'form-control', placeholder: '', value: this.state.flight_number, onChange: this.handleChange.bind(this, 'flight_number') })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.formulario.SolicitouIsencao
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_toggle___default.a, {
                    checked: this.state.exemption,
                    'aria-label': 'No label tag',
                    name: 'exemption',
                    onChange: this.handleToggleChange.bind(this, 'exemption')
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.formulario.PowerCheck
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_toggle___default.a, {
                    checked: this.state.power_checks,
                    'aria-label': 'No label tag',
                    name: 'power_checks',
                    onChange: this.handleToggleChange.bind(this, 'power_checks')
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.formulario.Base,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    name: 'base_id',
                    value: this.state.base_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'base_id'),
                    options: this.state.bases_select,
                    required: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.formulario.Contrato,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    name: 'contract_id',
                    value: this.state.contract_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'contract_id'),
                    options: this.state.contracts_select,
                    required: true
                  })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.formulario.NumeroDoRelatorio,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'report_number', className: 'form-control', placeholder: '', value: this.state.report_number, onChange: this.handleChange.bind(this, 'report_number'), required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.formulario.MecanicoResponsavel,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    name: 'staff_sigmec_id',
                    value: this.state.staff_sigmec_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'staff_sigmec_id'),
                    options: this.state.staffs_sigmec_select
                  })
                )
              ),
              this.state.show_select_clients == true && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.formulario.Cliente
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    name: 'client_id',
                    value: this.state.client_id,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'client_id'),
                    options: this.state.clients_select,
                    required: true
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.formulario.Observacoes,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', { style: { height: 100 }, type: 'text', name: 'observations', className: 'form-control', placeholder: '', value: this.state.observations, onChange: this.handleChange.bind(this, 'observations') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                ' ',
                this.locale.RelatoriosDeVoo.AdicionarRelatorioDeVoo.formulario.botaoCriarRelatorioDeVoo
              )
            )
          )
        )
      );
    }
  }]);

  return FlightReportsAdd;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportsAdd);

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Elements_FlightReportEditTab__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Elements_FlightReportLegsTab__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Elements_FlightReportStaffsTab__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Elements_FlightReportRefuelTab__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Elements_FlightReportLogsTab__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Elements_FlightReportWarningsTab__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Elements_FlightReportLegDelaysTab__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Elements_FlightReportApprovalsTab__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__LogbookAppIntegration_LogbookAppIntegrations__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Elements_FlightReportOcurrencesTab__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Elements_FlightReportPowerCheckTab__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










// Importação da tabela





// Tabs













var FlightReportsEdit = function (_Component) {
  _inherits(FlightReportsEdit, _Component);

  // constructor
  function FlightReportsEdit(props) {
    _classCallCheck(this, FlightReportsEdit);

    var _this = _possibleConstructorReturn(this, (FlightReportsEdit.__proto__ || Object.getPrototypeOf(FlightReportsEdit)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      updated: 0,
      key: 1,
      logbook_app: '',
      modal_alerts: false,
      staff_alerts: {},
      global_alerts: {},
      flight_type: {},
      flight_report: {},
      flight_report_legs: {},
      flight_report_leg_delays: {},
      flight_report_occurrences: {},
      flight_report_legs_totals: {},
      flight_report_approvals: {},
      flight_report_reopen_warnings: {},
      aircraft_model_version_custom_items: {},
      flight_report_power_checks: {},
      flight_report_staffs: {},
      flight_report_refuels: {},
      flight_report_fees: {},
      flight_report_logs: {},
      flight_report_warnings: {},
      daily_flights: [],
      airspace_responsibles_select: [],
      airport_operators_select: [],
      bases_select: [],
      aircrafts_select: [],
      flight_types_select: [],
      contracts_select: [],
      clients_select: [],
      locations_select: [],
      staffs_select: [],
      staff_mechanics_select: [],
      flight_report_legs_select: [],
      fuel_suppliers_select: [],
      companies_select: [],
      fuel_types_select: [],
      abnormal_occurrence_types_select: [],
      flight_ptbr_selects: [],
      flight_omni_selects: [],
      codes_ptbr_select: [],
      duties_select: [],
      errors_messages: [],
      flight_report_skytrac_ids: [],
      errors_listing: false,
      errors_save: false,
      errors_skytrac: false,
      error_skytrac: false
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    _this.updateData = _this.updateData.bind(_this);
    _this.changeStatus = _this.changeStatus.bind(_this);
    _this.exportXml = _this.exportXml.bind(_this);
    _this.export = _this.export.bind(_this);
    _this.warnings = _this.warnings.bind(_this);
    _this.active = _this.active.bind(_this);
    _this.archive = _this.archive.bind(_this);
    _this.activeAll = _this.activeAll.bind(_this);
    _this.archiveAll = _this.archiveAll.bind(_this);
    _this.saveAllUpdate = _this.saveAllUpdate.bind(_this);
    _this.handleOffline = _this.handleOffline.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  _createClass(FlightReportsEdit, [{
    key: 'popover',
    value: function popover(title, boldText) {
      var regularTexts = Array.from(arguments).slice(1);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["i" /* Popover */],
        { id: 'popover-positioned-top', title: title },
        boldText != null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'strong',
          null,
          boldText
        ),
        boldText != null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
        regularTexts.map(function (text, i) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'span',
            { key: i },
            i > 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
            text
          );
        })
      );
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleNavTab',
    value: function handleNavTab(state, key) {
      var change = {};
      change[state] = key;
      this.setState(change);
      this.setState({ overlay: { message: '', type: '', status: '' } });
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.handleOffline();
      }
    }
  }, {
    key: 'handleOffline',
    value: function handleOffline(responseJson) {
      if (navigator.onLine) {
        this.setState({ loaded: 2 }, this.loadData(responseJson));
      } else {
        var flight_reports_by_id = {};
        if (localStorage.getItem("flight_reports_by_id")) {
          flight_reports_by_id = localStorage.getItem("flight_reports_by_id");
          flight_reports_by_id = JSON.parse(flight_reports_by_id);
          if (typeof flight_reports_by_id[this.props.match.params.id] !== 'undefined') {
            this.setState({
              flight_report: flight_reports_by_id[this.props.match.params.id]['flight_report'],
              fuel_type: flight_reports_by_id[this.props.match.params.id]['fuel_type'],
              fuel_type_id: flight_reports_by_id[this.props.match.params.id]['fuel_type_id'],
              fuel_unity: flight_reports_by_id[this.props.match.params.id]['fuel_unity'],
              status_options: flight_reports_by_id[this.props.match.params.id]['status_options'],
              flight_report_legs: flight_reports_by_id[this.props.match.params.id]['flight_report_legs'],
              flight_report_leg_delays: flight_reports_by_id[this.props.match.params.id]['flight_report_leg_delays'],
              flight_report_legs_totals: flight_reports_by_id[this.props.match.params.id]['flight_report_legs_totals'],
              flight_report_occurrences: flight_reports_by_id[this.props.match.params.id]['flight_report_occurrences'],
              flight_report_staffs: flight_reports_by_id[this.props.match.params.id]['flight_report_staffs'],
              flight_report_refuels: flight_reports_by_id[this.props.match.params.id]['flight_report_refuels'],
              flight_report_fees: flight_reports_by_id[this.props.match.params.id]['flight_report_fees'],
              flight_report_logs: flight_reports_by_id[this.props.match.params.id]['flight_report_logs'],
              flight_report_warnings: flight_reports_by_id[this.props.match.params.id]['flight_report_warnings'],
              flight_report_reopen_warnings: flight_reports_by_id[this.props.match.params.id]['flight_report_reopen_warnings'],
              flight_report_approvals: flight_reports_by_id[this.props.match.params.id]['flight_report_approvals'],
              bases_select: flight_reports_by_id[this.props.match.params.id]['bases_select'],
              aircrafts_select: flight_reports_by_id[this.props.match.params.id]['aircrafts_select'],
              flight_types_select: flight_reports_by_id[this.props.match.params.id]['flight_types_select'],
              contracts_select: flight_reports_by_id[this.props.match.params.id]['contracts_select'],
              clients_select: flight_reports_by_id[this.props.match.params.id]['clients_select'],
              flight_type: flight_reports_by_id[this.props.match.params.id]['flight_type'],
              locations_select: flight_reports_by_id[this.props.match.params.id]['locations_select'],
              ptbr_codes_select: flight_reports_by_id[this.props.match.params.id]['ptbr_codes_select'],
              ptbr_operations_select: flight_reports_by_id[this.props.match.params.id]['ptbr_operations_select'],
              ptbr_external_loads_select: flight_reports_by_id[this.props.match.params.id]['ptbr_external_loads_select'],
              ptbr_fuels_select: flight_reports_by_id[this.props.match.params.id]['ptbr_fuels_select'],
              abnormal_occurrence_types_select: flight_reports_by_id[this.props.match.params.id]['abnormal_occurrence_types_select'],
              staffs_select: flight_reports_by_id[this.props.match.params.id]['staffs_select'],
              duties_select: flight_reports_by_id[this.props.match.params.id]['duties_select'],
              flight_report_legs_select: flight_reports_by_id[this.props.match.params.id]['flight_report_legs_select'],
              airspace_responsibles_select: flight_reports_by_id[this.props.match.params.id]['airspace_responsibles_select'],
              airport_operators_select: flight_reports_by_id[this.props.match.params.id]['airport_operators_select'],
              fuel_suppliers_select: flight_reports_by_id[this.props.match.params.id]['fuel_suppliers_select'],
              companies_select: flight_reports_by_id[this.props.match.params.id]['companies_select'],
              fuel_types_select: flight_reports_by_id[this.props.match.params.id]['fuel_types_select'],
              flight_ptbr_selects: flight_reports_by_id[this.props.match.params.id]['flight_ptbr_selects'],
              flight_omni_selects: flight_reports_by_id[this.props.match.params.id]['flight_omni_selects'],
              ptbr_departure_selects: flight_reports_by_id[this.props.match.params.id]['ptbr_departure_selects'],
              ptbr_flight_selects: flight_reports_by_id[this.props.match.params.id]['ptbr_flight_selects'],
              omni_departure_selects: flight_reports_by_id[this.props.match.params.id]['omni_departure_selects'],
              omni_flight_selects: flight_reports_by_id[this.props.match.params.id]['omni_flight_selects'],
              codes_ptbr_select: flight_reports_by_id[this.props.match.params.id]['codes_ptbr_select'],
              staff_mechanics_select: flight_reports_by_id[this.props.match.params.id]['staff_mechanics_select']
            });
            this.handleAlert('', '', 'closed');
          } else {
            this.handleAlert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.mensagemOfflineSemVoo, 'error', 'open');
          }
        } else {
          this.handleAlert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.mensagemOfflineSemVoo, 'error', 'open');
        }
      }
    }
  }, {
    key: 'updateData',
    value: function updateData(responseJson) {
      // Alinha com o client: recarrega e exibe mensagens do responseJson
      this.setState({ updated: 1 }, this.loadData(responseJson));
    }
  }, {
    key: 'loadData',
    value: function loadData(event) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/' + self.props.match.params.id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url', '/relatorios/voo');
          if (responseJson.status === 'success') {
            self.setState({
              logbook_app: responseJson.data.logbook_app,
              flight_report: responseJson.data.main,
              fuel_type: responseJson.data.fuel_type,
              fuel_type_id: responseJson.data.fuel_type_id,
              fuel_unity: responseJson.data.fuel_unity,
              status_options: responseJson.data.status_options,
              flight_report_legs: responseJson.data.flight_report_legs,
              flight_report_leg_delays: responseJson.data.flight_report_leg_delays,
              flight_report_legs_totals: responseJson.data.flight_report_legs_totals,
              flight_report_occurrences: responseJson.data.flight_report_occurrences,
              flight_report_staffs: responseJson.data.flight_report_staffs,
              aircraft_model_version_custom_items: responseJson.data.aircraft_model_version_custom_items,
              flight_report_power_checks: responseJson.data.flight_report_power_checks,
              flight_report_refuels: responseJson.data.flight_report_refuels,
              flight_report_fees: responseJson.data.flight_report_fees,
              flight_report_logs: responseJson.data.flight_report_logs,
              flight_report_warnings: responseJson.data.flight_report_warnings,
              flight_report_reopen_warnings: responseJson.data.flight_report_reopen_warnings,
              flight_report_approvals: responseJson.data.flight_report_approvals,
              daily_flights: responseJson.data.daily_flights,
              bases_select: responseJson.data.bases_select,
              aircrafts_select: responseJson.data.aircrafts_select,
              flight_types_select: responseJson.data.flight_types_select,
              contracts_select: responseJson.data.contracts_select,
              clients_select: responseJson.data.clients_select,
              flight_type: responseJson.data.flight_type,
              locations_select: responseJson.data.locations_select,
              ptbr_codes_select: responseJson.data.ptbr_codes_select,
              ptbr_operations_select: responseJson.data.ptbr_operations_select,
              ptbr_external_loads_select: responseJson.data.ptbr_external_loads_select,
              ptbr_fuels_select: responseJson.data.ptbr_fuels_select,
              abnormal_occurrence_types_select: responseJson.data.abnormal_occurrence_types_select,
              staffs_select: responseJson.data.staffs_select,
              duties_select: responseJson.data.duties_select,
              flight_report_legs_select: responseJson.data.flight_report_legs_select,
              airspace_responsibles_select: responseJson.data.airspace_responsibles_select,
              airport_operators_select: responseJson.data.airport_operators_select,
              fuel_suppliers_select: responseJson.data.fuel_suppliers_select,
              companies_select: responseJson.data.companies_select,
              fuel_types_select: responseJson.data.fuel_types_select,
              flight_ptbr_selects: responseJson.data.flight_ptbr_selects,
              flight_omni_selects: responseJson.data.flight_omni_selects,
              ptbr_departure_selects: responseJson.data.ptbr_departure_selects,
              ptbr_flight_selects: responseJson.data.ptbr_flight_selects,
              omni_departure_selects: responseJson.data.omni_departure_selects,
              omni_flight_selects: responseJson.data.omni_flight_selects,
              codes_ptbr_select: responseJson.data.codes_ptbr_select,
              staff_mechanics_select: responseJson.data.staff_mechanics_select
            });
            var flight_reports_by_id = {};
            if (localStorage.getItem("flight_reports_by_id")) {
              flight_reports_by_id = localStorage.getItem("flight_reports_by_id");
              flight_reports_by_id = JSON.parse(flight_reports_by_id);
            }
            flight_reports_by_id[self.props.match.params.id] = self.state;

            var new_flight_reports_by_id = {};
            Object.keys(flight_reports_by_id).map(function (k) {
              var flight_report_line = flight_reports_by_id[k].flight_report;
              var flight_report_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(flight_report_line.date, 'YYYY-MM-DD');
              var twoDaysAgo = __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(2, 'days');
              var difference = flight_report_date.isAfter(twoDaysAgo);

              if (difference) {
                // Se a data do relatório for menor que 2 dias
                new_flight_reports_by_id[k] = flight_reports_by_id[k];
              }
            });
            localStorage.setItem("flight_reports_by_id", JSON.stringify(new_flight_reports_by_id));
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          if (self.state.updated == 1) {
            self.handleAlert(event.message, event.status, 'open');
            self.setState({ updated: 0 });
          } else {
            self.handleMessage();
          }
        }); /* Overlay */
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-sm btn-danger button-inline', value: cell, onClick: this.archive },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-refresh' }),
          this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.botaoSubstituir
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-sm btn-success button-inline', value: cell, onClick: this.active },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-toggle-right' }),
          this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.botaoIgnorar
        )
      );

      return botao;
    }

    // Fetch ativando um item

  }, {
    key: 'active',
    value: function active(event) {
      var confirm = window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.ignorar);
      if (confirm) {
        var id = event.currentTarget.value;
        this.handleAlert('', '', 'open');
        var datasave = {
          ids: [id],
          flight_report_id: this.props.match.params.id
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/trecho/manter', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({ error_skytrac: false });
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'activeAll',
    value: function activeAll(event) {
      var confirm = window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.ignorarTodos);
      if (confirm) {
        this.handleAlert('', '', 'open');
        var datasave = {
          ids: event,
          flight_report_id: this.props.match.params.id
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/trecho/manter', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({ error_skytrac: false });
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }

    // Fetch deletando um item

  }, {
    key: 'archive',
    value: function archive(event) {
      var confirm = window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.substituir);
      if (confirm) {
        var id = event.currentTarget.value;
        this.handleAlert('', '', 'open');
        var datasave = {
          ids: [id],
          flight_report_id: this.props.match.params.id
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/trecho/skytrac', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({ error_skytrac: false });
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }

    // Fetch deletando um item

  }, {
    key: 'archiveAll',
    value: function archiveAll(event) {
      var confirm = window.confirm(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.substituirTodos);
      if (confirm) {
        this.handleAlert('', '', 'open');
        var datasave = {
          ids: event,
          flight_report_id: this.props.match.params.id
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio/voo/trecho/skytrac', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({ error_skytrac: false });
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'saveAllUpdate',
    value: function saveAllUpdate(responseJson) {
      this.setState({
        errors_save: responseJson.errors_save,
        errors_save_messages: responseJson.data
      });
      this.updateData(responseJson);
    }
  }, {
    key: 'changeStatus',
    value: function changeStatus(url) {
      var confirm = this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.trocarStatusDoRelatorioDeVoo;
      if (window.confirm(confirm)) {
        var datasave = { origin: 'Manual', id: this.props.match.params.id };
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.updateData(responseJson);
            if (responseJson.status === 'warning') {
              self.setState({
                errors_listing: responseJson.data.errors_listing,
                errors_messages: responseJson.data.errors,
                errors_skytrac: responseJson.data.errors_skytrac,
                error_skytrac: responseJson.data.error_skytrac,
                flight_report_skytrac_ids: responseJson.data.flight_report_skytrac_ids
              });
            } else {
              self.setState({
                errors_listing: false,
                errors_messages: [],
                error_skytrac: false,
                errors_skytrac: []
              });
            }
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'export',
    value: function _export(lang) {
      var self = this;
      var url = "/relatorio/voo/exportar/";
      if (lang === 'en') url = "/relatorio/voo/us/exportar/";
      var header = this.refs.request_api.header('application/json');
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data;
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data);
          }
          if (responseJson.status === 'warning') {
            self.setState({
              errors_listing: responseJson.data_view.errors_listing,
              errors_messages: responseJson.data_view.errors_messages
            });
          } else {
            self.setState({
              errors_listing: false,
              errors_messages: []
            });
          }
          self.handleAlert('', '', 'closed');
        });
      });
    }
  }, {
    key: 'exportDB',
    value: function exportDB() {
      var self = this;
      var url = "/relatorio/voo/db/exportar/";
      var header = this.refs.request_api.header('application/json');
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data;
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data);
            self.handleAlert('', '', 'closed');
          }
        });
      });
    }
  }, {
    key: 'exportXml',
    value: function exportXml() {
      var self = this;
      var url = "/relatorio/voo/xml/exportar/";
      var header = this.refs.request_api.header('application/json');
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data;
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data);
            self.handleAlert('', '', 'closed');
          }
        });
      });
    }
  }, {
    key: 'warnings',
    value: function warnings() {
      var self = this;
      var url = "/relatorio/voo/alertas/";
      var header = this.refs.request_api.header('application/json');
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ staff_alerts: responseJson.data.staff, global_alerts: responseJson.data.global, modal_alerts: true });
            self.handleAlert('', '', 'closed');
          }
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.titulo,
              ' - ',
              this.state.flight_report.report_number
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'grid-buttons pull-right' },
              this.state.logbook_app == 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__LogbookAppIntegration_LogbookAppIntegrations__["a" /* default */], {
                ref: function ref(_ref) {
                  _this2.logbookAppIntegration = _ref;
                },
                flight_report_id: this.props.match.params.id,
                integrationType: 'cancel',
                updateData: this.updateData
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { onClick: function onClick() {
                    return _this2.warnings();
                  }, className: 'btn btn-warning' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-warning' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'hidden-xs hidden-sm' },
                  this.locale.general.alertas
                ),
                ' '
              ),
              this.state.flight_report.status !== 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["h" /* Dropdown */],
                { id: 'export-main' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["h" /* Dropdown */].Toggle,
                  { bsStyle: 'success' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' }),
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'hidden-xs hidden-sm' },
                    this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.botaoRelatorio
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["h" /* Dropdown */].Menu,
                  { className: 'super-colors' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* MenuItem */],
                    { onSelect: function onSelect() {
                        _this2.export('pt');
                      } },
                    'Portugu\xEAs'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* MenuItem */],
                    { onSelect: function onSelect() {
                        _this2.export('en');
                      } },
                    'English'
                  )
                )
              ) : '',
              this.state.flight_report.status === 5 || this.state.flight_report.status === 4 || this.state.flight_report.status === 3 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { onClick: function onClick() {
                    return _this2.exportDB();
                  }, className: 'btn btn-success' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'hidden-xs hidden-sm' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.botaoExtratoDB
                )
              ) : '',
              this.state.flight_report.status === 5 || this.state.flight_report.status === 4 || this.state.flight_report.status === 3 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { onClick: function onClick() {
                    return _this2.exportXml();
                  }, className: 'btn btn-success' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-excel-o' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'hidden-xs hidden-sm' },
                  this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.botaoXML
                )
              ) : '',
              this.state.flight_report.status === 0 || this.state.flight_report.status === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["h" /* Dropdown */],
                { id: 'revisions' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["h" /* Dropdown */].Toggle,
                  { bsStyle: 'primary' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-certificate' }),
                  ' ',
                  this.state.flight_report.status_str
                ),
                this.state.flight_report.status === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["h" /* Dropdown */].Menu,
                  { className: 'super-colors' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* MenuItem */],
                    { onSelect: this.changeStatus, eventKey: '/relatorio/voo/status/rascunho' },
                    this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.botaoRelatorioDeVoo.TrocarParaRascunho
                  )
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["h" /* Dropdown */].Menu,
                  { className: 'super-colors' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* MenuItem */],
                    { onSelect: this.changeStatus, eventKey: '/relatorio/voo/status/finalizado' },
                    this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.botaoRelatorioDeVoo.TrocarParaFinalizado
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["d" /* MenuItem */],
                    { onSelect: function onSelect() {
                        if (_this2.state.logbook_app == 1 && (_this2.state.flight_report.logbook_external_status == 0 || _this2.state.flight_report.logbook_external_status == null) && _this2.logbookAppIntegration) {
                          _this2.logbookAppIntegration.getLogbookLegs();
                        } else {
                          _this2.changeStatus('/relatorio/voo/status/cancelado');
                        }
                      } },
                    this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.botaoRelatorioDeVoo.TrocarParaCancelado
                  )
                )
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: 'btn btn-primary', disabled: true },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-certificate' }),
                '  ',
                this.state.flight_report.status_str
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Link */],
                { to: '/relatorios/voo', className: 'btn btn-default' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-left' }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { className: 'hidden-xs hidden-sm' },
                  ' ',
                  this.locale.general.voltar
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            this.state.errors_listing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'alert alert-danger alert-dismissible', role: 'alert', style: { marginTop: 25 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { onClick: function onClick() {
                    return self.setState({ errors_listing: false, errors_messages: [] });
                  }, type: 'button', className: 'close', 'data-dismiss': 'alert', 'aria-label': 'Close' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { 'aria-hidden': 'true' },
                  '\xD7'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.erros,
                ':'
              ),
              Object.keys(self.state.errors_messages).map(function (k) {
                var message = self.state.errors_messages[k];
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  '- ',
                  message
                );
              })
            ),
            this.state.errors_save && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'alert alert-danger alert-dismissible', role: 'alert', style: { marginTop: 25 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { onClick: function onClick() {
                    return self.setState({ errors_save: false, errors_save_messages: [] });
                  }, type: 'button', className: 'close', 'data-dismiss': 'alert', 'aria-label': 'Close' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { 'aria-hidden': 'true' },
                  '\xD7'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.erros_salvar,
                ':'
              ),
              Object.keys(self.state.errors_save_messages).map(function (k) {
                var message = self.state.errors_save_messages[k];
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  '- ',
                  message
                );
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Elements_FlightReportEditTab__["a" /* default */], { updateData: this.updateData, updated: this.state.updated, handleAlert: this.handleAlert, flight_report_id: this.props.match.params.id, flight_report: this.state.flight_report, bases_select: this.state.bases_select, aircrafts_select: this.state.aircrafts_select, flight_types_select: this.state.flight_types_select, flight_type: this.state.flight_type, clients_select: this.state.clients_select, contracts_select: this.state.contracts_select, staff_mechanics_select: this.state.staff_mechanics_select, daily_flights: this.state.daily_flights }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Elements_FlightReportStaffsTab__["a" /* default */], { updateData: this.updateData, updated: this.state.updated, handleAlert: this.handleAlert, flight_report_id: this.props.match.params.id, flight_report_staffs: this.state.flight_report_staffs, staffs_select: this.state.staffs_select, flight_report: this.state.flight_report, duties_select: this.state.duties_select }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Elements_FlightReportLegsTab__["a" /* default */], { saveAllUpdate: this.saveAllUpdate, updateData: this.updateData, updated: this.state.updated, handleAlert: this.handleAlert, flight_report: this.state.flight_report, flight_report_id: this.props.match.params.id, flight_report_legs: this.state.flight_report_legs, flight_report_legs_totals: this.state.flight_report_legs_totals, locations_select: this.state.locations_select, ptbr_codes_select: this.state.ptbr_codes_select, ptbr_operations_select: this.state.ptbr_operations_select, ptbr_external_loads_select: this.state.ptbr_external_loads_select, ptbr_fuels_select: this.state.ptbr_fuels_select, staffs_select: this.state.staffs_select, duties_select: this.state.duties_select, aircraft_model_version_custom_items: this.state.aircraft_model_version_custom_items }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Elements_FlightReportRefuelTab__["a" /* default */], { updateData: this.updateData, updated: this.state.updated, handleAlert: this.handleAlert, flight_report_id: this.props.match.params.id, fuel_type: this.state.fuel_type, fuel_type_id: this.state.fuel_type_id, fuel_types_select: this.state.fuel_types_select, fuel_unity: this.state.fuel_unity, fuel_suppliers_select: this.state.fuel_suppliers_select, companies_select: this.state.companies_select, staffs_select: this.state.staffs_select, flight_report_legs_select: this.state.flight_report_legs_select, ptbr_fuels_select: this.state.ptbr_fuels_select, flight_report_refuels: this.state.flight_report_refuels }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            this.state.flight_report && this.state.flight_report.power_checks == 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Elements_FlightReportPowerCheckTab__["a" /* default */], { handleAlert: this.handleAlert, updateData: this.updateData, flight_report_id: this.props.match.params.id, flight_report_power_checks: this.state.flight_report_power_checks }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Elements_FlightReportWarningsTab__["a" /* default */], { updateData: this.updateData, updated: this.state.updated, handleAlert: this.handleAlert, flight_report_warnings: this.state.flight_report_warnings, flight_report_id: this.props.match.params.id, flight_report: this.state.flight_report }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Elements_FlightReportApprovalsTab__["a" /* default */], { updateData: this.updateData, updated: this.state.updated, handleAlert: this.handleAlert, flight_report_id: this.props.match.params.id, flight_report_reopen_warnings: this.state.flight_report_reopen_warnings, flight_report_approvals: this.state.flight_report_approvals, flight_report: this.state.flight_report, logbook_app: this.state.logbook_app, popover: this.popover }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Elements_FlightReportLogsTab__["a" /* default */], { updateData: this.updateData, updated: this.state.updated, handleAlert: this.handleAlert, flight_report_logs: this.state.flight_report_logs })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal_alerts, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                this.locale.general.alertas
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ modal_alerts: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              Object.keys(self.state.global_alerts).map(function (k) {
                var alert = self.state.global_alerts[k];
                if (Array.isArray(alert)) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    Object.keys(alert).map(function (klert) {
                      var alert2 = alert[klert];
                      if (alert2) {
                        if (alert2.error && alert2.error === 1) {
                          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: "box-alert box-alert-" + alert2.color },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: alert2.message } })
                          );
                        }
                      }
                    })
                  );
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              Object.keys(self.state.global_alerts).map(function (k) {
                var alert = self.state.global_alerts[k];
                if (alert) {
                  if (alert.error && alert.error === 1) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: "box-alert box-alert-" + alert.color },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: alert.message } })
                    );
                  }
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              Object.keys(self.state.staff_alerts).map(function (nickname) {
                var alerts = self.state.staff_alerts[nickname];
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h4',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'strong',
                      null,
                      nickname
                    )
                  ),
                  Object.keys(alerts).map(function (k) {
                    var alert = alerts[k];
                    if (alert) {
                      if (alert.error === 1) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: "box-alert box-alert-" + alert.color },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: alert.message } })
                        );
                      }
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ modal_alerts: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["g" /* Modal */],
          { show: this.state.error_skytrac, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                this.locale.general.alertas
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ error_skytrac: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'btn-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: 'btn btn-danger button-inline', onClick: function onClick() {
                    return _this2.archiveAll(_this2.state.flight_report_skytrac_ids);
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-refresh' }),
                ' ',
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.botaoSubstituirTodos
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: 'btn btn-success button-inline', onClick: function onClick() {
                    return _this2.activeAll(_this2.state.flight_report_skytrac_ids);
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-toggle-right' }),
                ' ',
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.botaoIgnorarTodos
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.errors_skytrac, pagination: true, striped: true, hover: true, options: { noDataText: this.locale.general.semDados } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { row: 0, rowSpan: 2, dataField: 'id', isKey: true, hidden: true, dataAlign: 'center', width: '100' },
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { row: 0, rowSpan: 2, dataField: 'leg_number', dataAlign: 'center', width: '100' },
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.tabela.Trecho
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { row: 0, colSpan: 4, dataAlign: 'center', width: '100' },
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.tabela.FlightFollowing
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { row: 0, colSpan: 4, dataAlign: 'center', width: '100' },
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.tabela.Preenchido
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { row: 1, dataField: 'flight_following_engine_start_time_str', dataAlign: 'center', width: '160' },
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.tabela.Partida
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { row: 1, dataField: 'flight_following_takeoff_time_str', dataAlign: 'center', width: '160' },
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.tabela.Decolagem
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { row: 1, dataField: 'flight_following_landing_time_str', dataAlign: 'center', width: '160' },
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.tabela.Pouso
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { row: 1, dataField: 'flight_following_engine_shutoff_time_str', dataAlign: 'center', width: '160' },
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.tabela.Corte
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { row: 1, dataField: 'engine_start_time_str', dataAlign: 'center', width: '160' },
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.tabela.Partida
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { row: 1, dataField: 'takeoff_time_str', dataAlign: 'center', width: '160' },
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.tabela.Decolagem
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { row: 1, dataField: 'landing_time_str', dataAlign: 'center', width: '160' },
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.tabela.Pouso
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { row: 1, dataField: 'engine_shutoff_time_str', dataAlign: 'center', width: '160' },
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.tabela.Corte
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { row: 0, rowSpan: 2, dataField: "id", dataAlign: 'center', dataFormat: this.ActionsButtons, width: '220' },
                this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.modalDiscrepanciaHorarios.tabela.Acoes
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ error_skytrac: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return FlightReportsEdit;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportsEdit);

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_datepicker__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










// Importação da tabela



var FlightReportsIndex = function (_Component) {
  _inherits(FlightReportsIndex, _Component);

  function FlightReportsIndex(props) {
    _classCallCheck(this, FlightReportsIndex);

    var _this = _possibleConstructorReturn(this, (FlightReportsIndex.__proto__ || Object.getPrototypeOf(FlightReportsIndex)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      mode: 'online',
      data: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    _this.next = _this.next.bind(_this);
    _this.previous = _this.previous.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(FlightReportsIndex, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, event) {
      var change = {};
      var full_date = this.state.date_start;
      if (event == null) {
        change[name] = null;
      } else {
        var date = event.target.value;
        var year = date.split("-")[0];
        var month = date.split("-")[1];
        var day = date.split("-")[2];
        // Utilizo o .slice(-2) para garantir o formato com 2 dígitos.
        var full_date = ("0" + day).slice(-2) + "/" + ("0" + month).slice(-2) + "/" + year;
        change[name] = date;
      }
      this.setState(change);
      this.loadData(full_date);
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        var now = new Date();
        var month = now.getMonth() + 1;
        var year = now.getFullYear();
        var day = now.getDate();
        if (day < 10) {
          day = '0' + day;
        }
        if (month < 10) {
          month = '0' + month;
        }
        var reference = day + '/' + month + '/' + year;
        this.setState({ loaded: 2 }, this.loadData(reference));
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var today = new Date();
      var date = today.setDate(today.getDate());
      var today_str = new Date(date).toISOString().split('T')[0]; // yyyy-mm-dd

      this.setState({ date_start: today_str });
    }
  }, {
    key: 'loadData',
    value: function loadData(reference) {
      var self = this;
      if (navigator.onLine) {
        var header = this.refs.request_api.header('application/json');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/relatorios/voo/' + reference, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.setState({ data: responseJson.data.index_data, current: responseJson.data.current, previous: responseJson.data.previous, next: responseJson.data.next });
            } else {
              self.setState({ data: responseJson.data.index_data, current: responseJson.data.current, previous: responseJson.data.previous, next: responseJson.data.next });
              self.handleAlert(responseJson.message, responseJson.status, 'open');
            }
          }).then(function () {
            var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/portal/relatorios/offline';
            fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.refs.request_api.validate(responseJson, 'url');
              if (responseJson.status === 'success') {
                var storage = {
                  flight_reports_index: responseJson.data.flight_reports
                };

                localStorage.setItem("flight_reports_index", JSON.stringify(storage));
              }
            }).then(function () {
              self.setState({ overlay: { message: '', type: '', status: 'closed' } });
              self.handleMessage();
            });
          }); /* Overlay */
        });
      } else {
        var fr_index = [];
        if (localStorage.getItem("flight_reports_index")) {
          var flight_reports_index = JSON.parse(localStorage.getItem("flight_reports_index"));
          fr_index = flight_reports_index.flight_reports_index;
        }

        self.setState({ data: fr_index });
        self.setState({ overlay: { message: '', type: '', status: 'closed' }, mode: 'offline' });
      }
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var url = '/relatorio/voo/editar/' + cell;

      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
          { className: 'btn btn-primary btn-sm', to: url },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
        )
      );

      return botao;
    }
  }, {
    key: 'next',
    value: function next() {
      this.setState({ overlay: { message: '', type: '', status: 'open' } });
      this.loadData(this.state.next);
    }
  }, {
    key: 'previous',
    value: function previous() {
      this.setState({ overlay: { message: '', type: '', status: 'open' } });
      this.loadData(this.state.previous);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        this.state.mode === 'online' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-primary', onClick: this.previous },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-chevron-left' }),
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'hidden-sm hidden-xs' },
                    this.state.previous
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h3',
                  { className: 'page-title text-center' },
                  this.state.current
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-xs-3 text-right' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-primary', onClick: this.next },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'span',
                    { className: 'hidden-sm hidden-xs' },
                    this.state.next
                  ),
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-chevron-right' })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/relatorio/voo/cadastrar', className: 'btn btn-primary pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-plus' }),
              ' ',
              this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.botaoAdicionarRelatorioDeVoo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-2 col-md-offset-5' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'date', value: this.state.date_start, onChange: this.handleChangeDate.bind(this, 'date_start'), className: 'form-control' })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: 'Exportar CSV', noDataText: this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.tabela.semRelatorios }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '70' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.tabela.Acoes
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'base', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '120' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.tabela.Base
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'date_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '120' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.tabela.Data
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'registration', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '120' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.tabela.Aeronave
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'model', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '120' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.tabela.Frota
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'client', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '160' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.tabela.Cliente
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'flight_type', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '160' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.tabela.TipoDeVoo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'report_number', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '160' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.tabela.NumeroDoRelatorio
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'flight_number', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '160' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.tabela.NumeroDoVoo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'status_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '160' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.tabela.Status
              )
            )
          )
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVoo.tituloOffLine
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.general.semDados }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '70' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.Acoes
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'base', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.Base
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'date_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.Data
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'registration', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.Aeronave
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'model', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.Frota
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'client', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '160' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.Cliente
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'flight_type', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '160' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.TipoDeVoo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'report_number', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '160' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.NumeroDoRelatorio
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'flight_number', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '160' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.NumeroDoVoo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'status_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '160' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.Status
              )
            )
          )
        )
      );
    }
  }]);

  return FlightReportsIndex;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportsIndex);

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Elements_FlightReportOfflineEditTab__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Elements_FlightReportOfflineStaffsTab__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Elements_FlightReportOfflineLegsTab__ = __webpack_require__(848);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







// Tabs




var FlightReportsOfflineEdit = function (_Component) {
  _inherits(FlightReportsOfflineEdit, _Component);

  // constructor
  function FlightReportsOfflineEdit(props) {
    var _this$state;

    _classCallCheck(this, FlightReportsOfflineEdit);

    var _this = _possibleConstructorReturn(this, (FlightReportsOfflineEdit.__proto__ || Object.getPrototypeOf(FlightReportsOfflineEdit)).call(this, props));

    _this.state = (_this$state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      updated: 0,
      key: 1,
      modal_alerts: false,
      staff_alerts: {},
      global_alerts: {},
      flight_type: {},
      flight_report: {},
      flight_report_legs: {},
      flight_report_leg_delays: {},
      flight_report_occurrences: {},
      flight_report_legs_totals: {},
      flight_report_approvals: {},
      flight_report_reopen_warnings: {},
      flight_report_staffs: {},
      flight_report_refuels: {},
      flight_report_logs: {},
      flight_report_warnings: {},
      bases_select: [],
      aircrafts_select: [],
      flight_types_select: [],
      contracts_select: []
    }, _defineProperty(_this$state, 'contracts_select', []), _defineProperty(_this$state, 'locations_select', []), _defineProperty(_this$state, 'staffs_select', []), _defineProperty(_this$state, 'staffs_sigmec_select', []), _defineProperty(_this$state, 'flight_report_legs_select', []), _defineProperty(_this$state, 'abnormal_occurrence_types_select', []), _defineProperty(_this$state, 'flight_ptbr_selects', []), _defineProperty(_this$state, 'flight_omni_selects', []), _defineProperty(_this$state, 'codes_ptbr_select', []), _defineProperty(_this$state, 'duties_select', []), _defineProperty(_this$state, 'errors_messages', []), _defineProperty(_this$state, 'errors_listing', false), _this$state);
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    return _this;
  }

  _createClass(FlightReportsOfflineEdit, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleNavTab',
    value: function handleNavTab(state, key) {
      var change = {};
      change[state] = key;
      this.setState(change);
      this.setState({ overlay: { message: '', type: '', status: '' } });
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var flight_reports_by_id = JSON.parse(localStorage.getItem("flight_reports_by_id"));
      var flight_report_legs_lists = JSON.parse(localStorage.getItem("flight_report_legs_lists"));

      this.setState({
        flight_report_id: this.props.match.params.id,
        flight_report: flight_reports_by_id.flight_reports_by_id[this.props.match.params.id],
        flight_report_staffs: flight_reports_by_id.flight_reports_by_id[this.props.match.params.id].flight_report_leg_staffs,
        flight_report_legs: flight_reports_by_id.flight_reports_by_id[this.props.match.params.id].flight_report_legs,
        locations_select: flight_report_legs_lists.locations_select,
        ptbr_codes_select: flight_report_legs_lists.ptbr_codes_select
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              'Editar relat\xF3rio de voo - ',
              this.state.flight_report.report_number
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Elements_FlightReportOfflineEditTab__["a" /* default */], { updateData: this.updateData, updated: this.state.updated, handleAlert: this.handleAlert, flight_report_id: this.state.flight_report_id, flight_report: this.state.flight_report }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Elements_FlightReportOfflineStaffsTab__["a" /* default */], { updateData: this.updateData, updated: this.state.updated, handleAlert: this.handleAlert, flight_report_id: this.state.flight_report_id, flight_report_staffs: this.state.flight_report_staffs, flight_report: this.state.flight_report }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Elements_FlightReportOfflineLegsTab__["a" /* default */], { updateData: this.updateData, updated: this.state.updated, handleAlert: this.handleAlert, flight_report_id: this.state.flight_report_id, flight_report_legs_view: this.state.flight_report_legs, flight_report: this.state.flight_report, duties_select: this.state.duties_select, ptbr_codes_select: this.state.ptbr_codes_select, locations_select: this.state.locations_select }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
          )
        )
      );
    }
  }]);

  return FlightReportsOfflineEdit;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportsOfflineEdit);

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_datepicker__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










// Importação da tabela


var FlightReportsOfflineIndex = function (_Component) {
  _inherits(FlightReportsOfflineIndex, _Component);

  function FlightReportsOfflineIndex(props) {
    _classCallCheck(this, FlightReportsOfflineIndex);

    var _this = _possibleConstructorReturn(this, (FlightReportsOfflineIndex.__proto__ || Object.getPrototypeOf(FlightReportsOfflineIndex)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);
    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__["a" /* default */])();
    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(FlightReportsOfflineIndex, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleChangeDatePicker',
    value: function handleChangeDatePicker(state, date) {
      var change = {};
      change[state] = date.format("DD/MM/YYYY");
      this.setState(change);
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var flight_reports_index = JSON.parse(localStorage.getItem("flight_reports_index"));
      this.setState({ data: flight_reports_index.flight_reports_index });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var url = '/relatorio/voo/editar/offline/' + cell;

      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
          { className: 'btn btn-primary btn-sm', to: url },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
        )
      );

      return botao;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.general.semDados }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'base', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.Base
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'date_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.Data
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'registration', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.Aeronave
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'model', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.Frota
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'client', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '160' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.Cliente
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'flight_type', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '160' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.TipoDeVoo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'report_number', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '160' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.NumeroDoRelatorio
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'flight_number', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '160' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.NumeroDoVoo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'status_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '160' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.Status
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '70' },
                this.locale.RelatoriosDeVoo.ListaDeRelatoriosDeVooOffline.tabela.Acoes
              )
            )
          )
        )
      );
    }
  }]);

  return FlightReportsOfflineIndex;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FlightReportsOfflineIndex);

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// config.set({
// 	url: 'http://localhost:5001',
// 	auth: 'http://sigvoos.test',
// 	api: 'http://sigvoos.test/api',
// 	cdn: 'http://sigvooscdn.test',
// 	refresh_time: 20,
// 	development: 1
// });

// Produção
__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.set({
	url: 'https://portal.sigvoos.com.br',
	auth: 'https://api.sigvoos.com.br',
	api: 'https://api.sigvoos.com.br/api',
	cdn: 'https://cdn.sigvoos.com.br',
	api_sigmec: 'https://api.sigvoos.com.br/api',
	cdn_sigmec: 'https://cdn.sigvoos.com.br',
	api_sigtrein: 'https://api.sigvoos.com.br/api',
	cdn_sigtrein: 'https://cdn.sigvoos.com.br',
	development: false,
	refresh_time: 20
});

var Globals = function (_Component) {
	_inherits(Globals, _Component);

	function Globals() {
		_classCallCheck(this, Globals);

		return _possibleConstructorReturn(this, (Globals.__proto__ || Object.getPrototypeOf(Globals)).apply(this, arguments));
	}

	return Globals;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (Globals);

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PaymentRequestLegs__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var PaymentRequestScheduleDistanceAdd = function (_Component) {
  _inherits(PaymentRequestScheduleDistanceAdd, _Component);

  // constructor
  function PaymentRequestScheduleDistanceAdd(props) {
    _classCallCheck(this, PaymentRequestScheduleDistanceAdd);

    var _this = _possibleConstructorReturn(this, (PaymentRequestScheduleDistanceAdd.__proto__ || Object.getPrototypeOf(PaymentRequestScheduleDistanceAdd)).call(this, props));

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__i18n_getLocale__["a" /* default */])();

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      modal: false,
      schedule_grade_id: null,
      staff_id: null,
      payment_batch_id: null,
      destination: null,
      origin: null,
      date_start: '',
      date_finish: '',
      daily_currency: 'BRL',
      training_selected: 0,
      payment_value: 0,
      max_value: 0,
      distance: 0,
      daily_value: 0,
      ignores_debts: 0,
      observation: null,
      bonus: null,
      certification_supplier: null,
      certification_supplier_id: null,
      zipcode_bases: [],
      zipcode_suppliers: [],
      payment_legs: [{
        origin_base_id: null,
        origin_supplier_id: null,
        origin_base: null,
        origin_supplier: null,
        zipcode_origin: null,
        destination_base_id: null,
        destination_supplier_id: null,
        destination_base: null,
        destination_supplier: null,
        zipcode_destination: null,
        total: 0
      }],
      daily_currency_list: [{ value: "EUR", label: _this.locale.general.euro }, { value: "USD", label: _this.locale.general.dolar }, { value: "BRL", label: _this.locale.general.real }]
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);
    _this.handleChangeLegData = _this.handleChangeLegData.bind(_this);
    // this.handleChangeDate = this.handleChangeDate.bind(this);

    _this.add = _this.add.bind(_this);
    _this.addLeg = _this.addLeg.bind(_this);
    _this.removeLeg = _this.removeLeg.bind(_this);
    _this.resetLeg = _this.resetLeg.bind(_this);
    _this.calculateDistances = _this.calculateDistances.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    return _this;
  }
  // Handlers


  _createClass(PaymentRequestScheduleDistanceAdd, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleChangeLegData',
    value: function handleChangeLegData(name, value, index) {
      var payment_legs = this.state.payment_legs;
      payment_legs[index][name] = value;
      this.setState({ payment_legs: payment_legs });
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }

    // Descontinuado
    // Não atualizamos mais a quantidade de acordo com a quantidade de dias. A quantidade é definida pelo usuário
    // handleChangeDate (name, event) {
    //   var change = {};
    //   change[name] = event.target.value;
    //   this.setState(change);

    //   var daily_paid = 0;
    //   var other_date = this.state.date_start;
    //   if(name === 'date_start') {
    //     var other_date = this.state.date_finish;
    //   }
    //   if(change[name].length === 10 && other_date.length === 10) {
    //     date1 = change[name].split('/');
    //     date2 = other_date.split('/');

    //     var date1 = new Date(date1[1] + '/' + date1[0] + '/' + date1[2]);
    //     var date2 = new Date(date2[1] + '/' + date2[0] + '/' + date2[2]);

    //     // To calculate the time difference of two dates
    //     var Difference_In_Time = date2.getTime() - date1.getTime();

    //     // To calculate the no. of days between two dates
    //     daily_paid = Difference_In_Time / (1000 * 3600 * 24);

    //     daily_paid =  Math.abs(daily_paid) + 1;
    //   }    
    //   this.setState({daily_paid: daily_paid});
    //   this.handleChangeDailyTotal(this.state.daily_value, daily_paid);
    // }


  }, {
    key: 'handleChangeDaily',
    value: function handleChangeDaily(name, event) {
      var change = {};
      change[name] = event.target.value;

      this.setState(change);
      this.handleChangeDailyTotal(this.state.daily_value, event.target.value);
    }
  }, {
    key: 'handleChangeDailyPaid',
    value: function handleChangeDailyPaid(name, event) {
      var change = {};
      change[name] = event.target.value;

      this.setState(change);
      this.handleChangeDailyTotal(this.state.distance, event.target.value);
    }
  }, {
    key: 'handleChangeDailyTotal',
    value: function handleChangeDailyTotal(daily_value, daily_paid) {
      var daily_paid = daily_paid.toString().replace(',', '.');
      var daily_value = daily_value.toString().replace(',', '.');
      var total = daily_paid * daily_value;

      this.setState({ daily_total: total });
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'TrainingclearSelects',
    value: function TrainingclearSelects() {
      this.setState({ training_selected: 0 });
      this.setState({ distance: '' });
      this.setState({ daily_total: '' });
      this.setState({ date_start: '' });
      this.setState({ date_finish: '' });
      this.setState({ training_code: '' });
      this.setState({ daily_currency: '' });
      this.setState({ certification_supplier_id: '' });
      this.loadData();
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      this.handleAlert('', '', 'open');
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/solicitacao/deslocamento/info';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          if (responseJson.status === 'success') {
            var api = 'api';
            self.setState({
              api: api,
              payment_value: responseJson.data.payment_value,
              max_value: responseJson.data.max_value,
              zipcode_bases: responseJson.data.zipcode_bases,
              zipcode_suppliers: responseJson.data.zipcode_suppliers
            });
            self.setState({ schedule_grades_list: responseJson.data.schedule_grades_list });
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          } else {
            self.setState({ overlay: { message: responseJson.message, type: 'error', status: 'open' } });
          }
        });
      });
    }
  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        schedule_grade_id: this.state.schedule_grade_id,
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        daily_paid: this.state.daily_paid,
        daily_value: this.state.daily_value,
        daily_total: this.state.daily_total,
        daily_currency: this.state.daily_currency,
        observation: this.state.observation,
        payment_legs: this.state.payment_legs
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get(self.state.api) + '/pagamento/escala/deslocamento/solicitacao/cadastrar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var url = '/lista/solicitacao/pagamento/deslocamento/missao';
            var storage = {
              alert_message: responseJson.message,
              alert_type: responseJson.status
            };
            localStorage.setItem("verify_message", JSON.stringify(storage));
            self.setState({ redirect_url: url });
          }
          self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'resetLeg',
    value: function resetLeg(type, leg) {
      this.handleChangeLegData(type + '_base_id', null, leg);
      this.handleChangeLegData(type + '_base', null, leg);
      this.handleChangeLegData(type + '_supplier_id', null, leg);
      this.handleChangeLegData(type + '_supplier', null, leg);
      this.handleChangeLegData('zipcode_' + type, null, leg);
    }
  }, {
    key: 'calculateDistances',
    value: function calculateDistances() {
      var header = this.refs.request_api.header('application/json');
      var self = this;

      var datasave = this.state.payment_legs;

      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/calcular/distancia/google';
        fetch(url, { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var total = responseJson.data * self.state.payment_value / 1000;
            if (total > self.state.max_value) {
              total = self.state.max_value;
            }
            self.setState({ daily_value: total.toFixed(2) });
            if (self.state.daily_paid) {
              self.handleChangeDailyTotal(total.toFixed(2), self.state.daily_paid);
            }
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        });
      });
    }
  }, {
    key: 'addLeg',
    value: function addLeg() {
      var payment_legs = this.state.payment_legs;

      payment_legs.push({
        origin_base_id: null,
        origin_supplier_id: null,
        origin_base: null,
        origin_supplier: null,
        zipcode_origin: null,
        destination_base_id: null,
        destination_supplier_id: null,
        destination_base: null,
        destination_supplier: null,
        zipcode_destination: null,
        total: 0
      });
      this.setState({ payment_legs: payment_legs });
    }
  }, {
    key: 'removeLeg',
    value: function removeLeg(index) {
      var self = this;
      this.state.payment_legs;
      var payment_legs = [];
      Object.keys(this.state.payment_legs).map(function (k) {
        if (k !== index) {
          payment_legs.push(Object.assign({}, self.state.payment_legs[k]));
        }
      });
      this.setState({ payment_legs: payment_legs });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/lista/solicitacao/pagamento/deslocamento/missao', className: 'btn btn-default pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-left' }),
              ' ',
              this.locale.general.voltar
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.add },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.EscalaGrade,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'schedule_grade_id',
                      value: this.state.schedule_grade_id,
                      searchable: true,
                      placeholder: this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.placeholder.SelecionarEscala,
                      onChange: this.handleSelectChange.bind(this, 'schedule_grade_id'),
                      options: this.state.schedule_grades_list,
                      required: true
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.Quantidade,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: this.state.daily_paid, name: 'daily_paid', className: 'form-control', onChange: this.handleChangeDaily.bind(this, 'daily_paid'), placeholder: '', required: true })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.DataInicial,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_input_mask___default.a, { value: this.state.date_start, maskChar: null, name: 'date_start', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: this.locale.general.diaMesAno, required: true })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.DataFinal,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_input_mask___default.a, { value: this.state.date_finish, maskChar: null, name: 'date_finish', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: this.locale.general.diaMesAno, required: true })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.Valor,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: this.state.daily_value, name: 'daily_value', className: 'form-control', onChange: this.handleChangeDailyPaid.bind(this, 'daily_value'), placeholder: '', disabled: true, required: true })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.Moeda,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'daily_currency',
                      value: this.state.daily_currency,
                      placeholder: this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.placeholder.SelecionarMoeda,
                      onChange: this.handleSelectChange.bind(this, 'daily_currency'),
                      options: this.state.daily_currency_list,
                      required: true
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.ValorTotal,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: this.state.daily_total, name: 'daily_total', className: 'form-control', onChange: this.handleChangeDailyTotal.bind(this.state.daily_value, this.state.daily_paid), placeholder: '', disabled: true, required: true })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.Observacao,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: this.state.observation, name: 'observation', className: 'form-control', onChange: this.handleChange.bind(this, 'observation'), placeholder: this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.placeholder.Observacao })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                { className: 'page-title pull-left' },
                this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.tituloTrechos
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'button', className: 'btn button-inline btn-warning pull-right', onClick: function onClick() {
                    return _this2.addLeg();
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-plus' }),
                ' ',
                this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.botaoAdicionarTrecho
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-responsive' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'table',
                  { className: 'table table-bordered table-stripped table-hover' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'thead',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center' },
                        '#'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center' },
                        this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.tabela.BuscarLocais
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center' },
                        this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.tabela.BaseOrigem
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center' },
                        this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.tabela.FornecedorOrigem
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center' },
                        this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.tabela.CEPOrigem
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center' },
                        this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.tabela.BaseDestino
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center' },
                        this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.tabela.FornecedorDestino
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center' },
                        this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.tabela.CEPDestino
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { className: 'text-center' })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tbody',
                    { id: 'suppliers-certifications' },
                    Object.keys(this.state.payment_legs).map(function (k) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__PaymentRequestLegs__["a" /* default */], { leg_index: k, data: self.state.payment_legs[k], zipcode_bases: self.state.zipcode_bases, zipcode_suppliers: self.state.zipcode_suppliers, removeLeg: self.removeLeg, handleChangeLegData: self.handleChangeLegData, resetLeg: self.resetLeg });
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-lg btn-block btn-success pull-right', onClick: function onClick() {
                        return _this2.calculateDistances();
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' }),
                    ' ',
                    this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.botaoCalcular
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                    ' ',
                    this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoDeslocamento.formulario.botaoSalvarSolicitacao
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return PaymentRequestScheduleDistanceAdd;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (PaymentRequestScheduleDistanceAdd);

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










// Importação da tabela



var PaymentRequestScheduleDistanceIndex = function (_Component) {
  _inherits(PaymentRequestScheduleDistanceIndex, _Component);

  function PaymentRequestScheduleDistanceIndex(props) {
    _classCallCheck(this, PaymentRequestScheduleDistanceIndex);

    var _this = _possibleConstructorReturn(this, (PaymentRequestScheduleDistanceIndex.__proto__ || Object.getPrototypeOf(PaymentRequestScheduleDistanceIndex)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      payment_legs: [],
      modal: false
    };

    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.delete = _this.delete.bind(_this);
    _this.deleteRow = _this.deleteRow.bind(_this);
    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    _this.openModal = _this.openModal.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(PaymentRequestScheduleDistanceIndex, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/pagamento/escala/deslocamento/solicitacao', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'openModal',
    value: function openModal(payment_id) {
      var self = this;
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/pagamento/deslocamento/solicitacao/trechos/' + payment_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ payment_legs: responseJson.data, modal: true });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var _this2 = this;

      var botao = '';
      if (row.request_status === 'Aberta') {
        botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn btn-sm btn-danger', value: cell, onClick: this.delete },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-trash' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn btn-sm btn-info', value: cell, onClick: function onClick() {
                return _this2.openModal(cell);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-eye' })
          )
        );
      } else {
        botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn btn-sm btn-info', value: cell, onClick: function onClick() {
                return _this2.openModal(cell);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-eye' })
          )
        );
      }

      return botao;
    }
  }, {
    key: 'delete',
    value: function _delete(event) {
      var fatigue_id = event.currentTarget.value;
      var confirm = window.confirm(this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.deletar);
      if (confirm) {
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/pagamento/escala/deslocamento/solicitacao/' + fatigue_id, { method: 'DELETE', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.deleteRow(fatigue_id);
            }
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'deleteRow',
    value: function deleteRow(fatigue_id) {
      var data = this.state.data;
      data.map(function (dado, index) {
        if (dado.id == fatigue_id) {
          data.splice(index, 1);
        }
      });
      this.setState({ data: data });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/cadastrar/solicitacao/pagamento/deslocamento/missao', className: 'btn btn-primary pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-plus' }),
              ' ',
              this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.botaoSolicitarPagamentoDeDeslocamentoMissao
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.semSolicitacaoDePagamento }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'request_status', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.Status
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'payment_batch', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.Lote
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'aircraft_model', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.Frota
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'schedule_month', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.Mes
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'schedule_grade_revision', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.Revisao
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'date_start_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.Inicio
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'date_finish_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.Fim
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'daily_paid', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.Quantidade
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'daily_value', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.Valor
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'daily_total_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.ValorTotal
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'daily_currency', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.Moeda
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'observation', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.Observacao
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '100' },
                this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabela.Ações
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal, bsSize: 'large', 'aria-labelledby': 'contained-modal-title-lg' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tituloBases
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this3.setState({ modal: false, payment_legs: [] });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'table-responsive' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'table table-bordered table-stripped table-hover' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { className: 'text-center' },
                      this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabelaBases.Origem
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { className: 'text-center' },
                      this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabelaBases.CEPOrigem
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { className: 'text-center' },
                      this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabelaBases.Destino
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { className: 'text-center' },
                      this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoMissao.tabelaBases.CEPDestino
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  { id: 'suppliers-certifications' },
                  Object.keys(this.state.payment_legs).map(function (k) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        self.state.payment_legs[k]['origin']
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        self.state.payment_legs[k]['zipcode_origin']
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        self.state.payment_legs[k]['destination']
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        self.state.payment_legs[k]['zipcode_destination']
                      )
                    );
                  })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this3.setState({ modal: false, payment_legs: [] });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return PaymentRequestScheduleDistanceIndex;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (PaymentRequestScheduleDistanceIndex);

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var PaymentRequestScheduleTransportAdd = function (_Component) {
  _inherits(PaymentRequestScheduleTransportAdd, _Component);

  // constructor
  function PaymentRequestScheduleTransportAdd(props) {
    _classCallCheck(this, PaymentRequestScheduleTransportAdd);

    var _this = _possibleConstructorReturn(this, (PaymentRequestScheduleTransportAdd.__proto__ || Object.getPrototypeOf(PaymentRequestScheduleTransportAdd)).call(this, props));

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__["a" /* default */])();

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      schedule_grade_id: '',
      staff_id: '',
      daily_currency: 'BRL',
      training_selected: 0,
      daily_value: 0,
      daily_paid: 0,
      ignores_debts: 0,
      observation: '',
      date_start: '',
      date_finish: '',
      bonus: '',
      certification_supplier: '',
      certification_supplier_id: '',
      daily_currency_list: [{ value: "EUR", label: _this.locale.general.euro }, { value: "USD", label: _this.locale.general.dolar }, { value: "BRL", label: _this.locale.general.real }]
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.add = _this.add.bind(_this);
    _this.handleSelectChangeStaff = _this.handleSelectChangeStaff.bind(_this);
    _this.loadStaffData = _this.loadStaffData.bind(_this);
    return _this;
  }
  // Handlers


  _createClass(PaymentRequestScheduleTransportAdd, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);

      var daily_paid = 0;
      var other_date = this.state.date_start;
      if (name === 'date_start') {
        var other_date = this.state.date_finish;
      }

      if (change[name].length === 10 && other_date.length === 10) {
        date1 = change[name].split('/');
        date2 = other_date.split('/');

        var date1 = new Date(date1[1] + '/' + date1[0] + '/' + date1[2]);
        var date2 = new Date(date2[1] + '/' + date2[0] + '/' + date2[2]);

        // To calculate the time difference of two dates
        var Difference_In_Time = date2.getTime() - date1.getTime();

        // To calculate the no. of days between two dates
        daily_paid = Difference_In_Time / (1000 * 3600 * 24);

        daily_paid = Math.abs(daily_paid) + 1;
      }

      this.setState({ daily_paid: daily_paid });
      this.handleChangeDailyTotal(this.state.daily_value, daily_paid);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleChangeDaily',
    value: function handleChangeDaily(name, event) {
      var change = {};
      change[name] = event.target.value;

      this.setState(change);
      this.handleChangeDailyTotal(event.target.value, this.state.daily_paid);
    }
  }, {
    key: 'handleChangeDailyPaid',
    value: function handleChangeDailyPaid(name, event) {
      var change = {};
      change[name] = event.target.value;

      this.setState(change);
      this.handleChangeDailyTotal(this.state.daily_value, event.target.value);
    }
  }, {
    key: 'handleChangeDailyTotal',
    value: function handleChangeDailyTotal(daily_paid, daily_value) {
      var daily_paid = daily_paid.toString().replace(',', '.');
      var daily_value = daily_value.toString().replace(',', '.');
      var total = daily_paid * daily_value;

      this.setState({ daily_total: total });
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeStaff',
    value: function handleSelectChangeStaff(name, event) {
      var _this2 = this;

      var change = {};
      if (event == null) {
        change[name] = null;
        this.setState(change, function () {
          _this2.setState({ daily_value: '' });
        });
      } else {
        change[name] = event.value;
        this.setState(change, function () {
          _this2.loadStaffData(event);
        });
      }
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadStaffData',
    value: function loadStaffData(event) {
      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/pagamento/valores/funcionario/' + event.value;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            Object.keys(responseJson.data).map(function (k) {
              if (responseJson.data[k].type === 'transport' && responseJson.data[k].currency === self.state.daily_currency) {
                self.setState({ daily_value: responseJson.data[k].value_str });
              }
              return true;
            });
          }
          self.handleAlert('', '', 'closed');
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
        });
      });
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      this.handleAlert('', '', 'open');
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/solicitacao/transporte/info';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          if (responseJson.status === 'success') {
            var api = 'api';
            self.setState({ api: api, daily_value: responseJson.data.value });
            self.setState({ schedule_grades_list: responseJson.data.schedule_grades_list });

            var url_bases = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get(api) + '/bases/ativas/lista/escala';
            fetch(url_bases, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.refs.request_api.validate(responseJson);
              if (responseJson.status === 'success') {
                self.setState({ bases_list: responseJson.data });
              }
            }).then(function () {
              self.setState({ overlay: { message: '', type: '', status: 'closed' } });
            }); /* Overlay */
          } else {
            self.setState({ overlay: { message: responseJson.message, type: 'error', status: 'open' } });
          }
        });
      });
    }
  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      var datasave = {
        schedule_grade_id: this.state.schedule_grade_id,
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        daily_value: this.state.daily_value,
        daily_paid: this.state.daily_paid,
        daily_total: this.state.daily_total,
        daily_currency: this.state.daily_currency,
        base_id: this.state.base_id,
        observation: this.state.observation
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get(self.state.api) + '/pagamento/escala/transporte/solicitacao/cadastrar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var url = '/lista/solicitacao/pagamento/transporte/missao';
            var storage = {
              alert_message: responseJson.message,
              alert_type: responseJson.status
            };
            localStorage.setItem("verify_message", JSON.stringify(storage));
            self.setState({ redirect_url: url });
          }
          self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoTransporte.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/lista/solicitacao/pagamento/transporte/missao', className: 'btn btn-default pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-left' }),
              ' ',
              this.locale.general.voltar
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.add },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoTransporte.formulario.EscalaGrade,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'schedule_grade_id',
                      value: this.state.schedule_grade_id,
                      searchable: true,
                      placeholder: this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoTransporte.formulario.placeholder.SelecionarEscala,
                      onChange: this.handleSelectChange.bind(this, 'schedule_grade_id'),
                      options: this.state.schedule_grades_list,
                      required: true
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoTransporte.formulario.Quantidade,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: this.state.daily_paid, name: 'daily_paid', className: 'form-control', onChange: this.handleChangeDailyPaid.bind(this, 'daily_paid'), placeholder: '', disabled: true })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoTransporte.formulario.DataInicial,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_input_mask___default.a, { value: this.state.date_start, required: true, maskChar: null, name: 'date_start', mask: '99/99/9999', className: 'form-control', onChange: this.handleChangeDate.bind(this, 'date_start'), placeholder: this.locale.general.diaMesAno })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoTransporte.formulario.DataFinal,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_input_mask___default.a, { value: this.state.date_finish, required: true, maskChar: null, name: 'date_finish', mask: '99/99/9999', className: 'form-control', onChange: this.handleChangeDate.bind(this, 'date_finish'), placeholder: this.locale.general.diaMesAno })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoTransporte.formulario.Valor,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: this.state.daily_value, name: 'daily_value', className: 'form-control', onChange: this.handleChangeDaily.bind(this, 'daily_value'), placeholder: '', disabled: true })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoTransporte.formulario.Moeda,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'daily_currency',
                      value: this.state.daily_currency,
                      placeholder: this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoTransporte.formulario.placeholder.SelecionarMoeda,
                      onChange: this.handleSelectChange.bind(this, 'daily_currency'),
                      options: this.state.daily_currency_list,
                      required: true
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoTransporte.formulario.ValorTotal,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: this.state.daily_total, disabled: 'disabled', name: 'daily_total', className: 'form-control', onChange: this.handleChangeDaily.bind(this, 'daily_total'), placeholder: '' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoTransporte.formulario.Base,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'base_id',
                      value: this.state.base_id,
                      placeholder: this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoTransporte.formulario.placeholder.SelecionarBase,
                      onChange: this.handleSelectChange.bind(this, 'base_id'),
                      options: this.state.bases_list,
                      required: true
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoTransporte.formulario.Observacao,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: this.state.observation, name: 'observation', className: 'form-control', onChange: this.handleChange.bind(this, 'observation'), placeholder: this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoTransporte.formulario.placeholder.Observacao })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                    ' ',
                    this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoMissaoTransporte.formulario.botaoSalvarPagamento
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return PaymentRequestScheduleTransportAdd;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (PaymentRequestScheduleTransportAdd);

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// Importação da tabela



var PaymentRequestTransportIndex = function (_Component) {
  _inherits(PaymentRequestTransportIndex, _Component);

  function PaymentRequestTransportIndex(props) {
    _classCallCheck(this, PaymentRequestTransportIndex);

    var _this = _possibleConstructorReturn(this, (PaymentRequestTransportIndex.__proto__ || Object.getPrototypeOf(PaymentRequestTransportIndex)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };

    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.delete = _this.delete.bind(_this);
    _this.deleteRow = _this.deleteRow.bind(_this);
    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    _this.openModal = _this.openModal.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(PaymentRequestTransportIndex, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/pagamento/escala/transporte/solicitacao', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'openModal',
    value: function openModal(payment_id) {
      var self = this;
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/pagamento/deslocamento/solicitacao/trechos/' + payment_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ payment_legs: responseJson.data, modal: true });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var botao = '';
      if (row.request_status === 'Aberta') {
        botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn btn-sm btn-danger', value: cell, onClick: this.delete },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-trash' })
          )
        );
      }

      return botao;
    }
  }, {
    key: 'delete',
    value: function _delete(event) {
      var fatigue_id = event.currentTarget.value;
      var confirm = window.confirm(this.locale.Pagamentos.SolicitacoesDePagamentoTransporteMissao.deletar);
      if (confirm) {
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/pagamento/escala/transporte/solicitacao/' + fatigue_id, { method: 'DELETE', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.deleteRow(fatigue_id);
            }
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'deleteRow',
    value: function deleteRow(fatigue_id) {
      var data = this.state.data;
      data.map(function (dado, index) {
        if (dado.id == fatigue_id) {
          data.splice(index, 1);
        }
      });
      this.setState({ data: data });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.Pagamentos.SolicitacoesDePagamentoTransporteMissao.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/cadastrar/solicitacao/pagamento/transporte/missao', className: 'btn btn-primary pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-plus' }),
              ' ',
              this.locale.Pagamentos.SolicitacoesDePagamentoTransporteMissao.botaoSolicitarPagamentoDeTransporteMissao
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Pagamentos.SolicitacoesDePagamentoTransporteMissao.tabela.semSolicitacaoDePagamento }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.Pagamentos.SolicitacoesDePagamentoTransporteMissao.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'request_status', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoTransporteMissao.tabela.Status
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'payment_batch', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoTransporteMissao.tabela.Lote
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'aircraft_model', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoTransporteMissao.tabela.Frota
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'schedule_month', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoTransporteMissao.tabela.Mes
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'base', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoTransporteMissao.tabela.Base
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'schedule_grade_revision', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoTransporteMissao.tabela.Revisao
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'daily_paid', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoTransporteMissao.tabela.Quantidade
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'daily_total_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoTransporteMissao.tabela.Valor
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'daily_currency', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoTransporteMissao.tabela.Moeda
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'observation', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoTransporteMissao.tabela.Observacao
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '100' },
                this.locale.Pagamentos.SolicitacoesDePagamentoTransporteMissao.tabela.Acoes
              )
            )
          )
        )
      );
    }
  }]);

  return PaymentRequestTransportIndex;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (PaymentRequestTransportIndex);

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PaymentRequestLegs__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var PaymentRequestTrainingDistanceAdd = function (_Component) {
  _inherits(PaymentRequestTrainingDistanceAdd, _Component);

  // constructor
  function PaymentRequestTrainingDistanceAdd(props) {
    var _this$state;

    _classCallCheck(this, PaymentRequestTrainingDistanceAdd);

    var _this = _possibleConstructorReturn(this, (PaymentRequestTrainingDistanceAdd.__proto__ || Object.getPrototypeOf(PaymentRequestTrainingDistanceAdd)).call(this, props));

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__i18n_getLocale__["a" /* default */])();

    _this.state = (_this$state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      modal: false,
      training_id: null,
      staff_id: null,
      payment_batch_id: null,
      destination: null,
      origin: null,
      date_start: '',
      date_finish: '',
      daily_currency: 'BRL',
      training_selected: 0,
      payment_value: 0,
      distance: 0,
      daily_value: 0,
      ignores_debts: 0,
      observation: null,
      bonus: null,
      certification_supplier: null,
      certification_supplier_id: null,
      zipcode_bases: []
    }, _defineProperty(_this$state, 'zipcode_bases', []), _defineProperty(_this$state, 'zipcode_suppliers', []), _defineProperty(_this$state, 'payment_legs', [{
      origin_base_id: null,
      origin_supplier_id: null,
      origin_base: null,
      origin_supplier: null,
      zipcode_origin: null,
      destination_base_id: null,
      destination_supplier_id: null,
      destination_base: null,
      destination_supplier: null,
      zipcode_destination: null,
      total: 0
    }]), _defineProperty(_this$state, 'daily_currency_list', [{ value: "EUR", label: _this.locale.general.euro }, { value: "USD", label: _this.locale.general.dolar }, { value: "BRL", label: _this.locale.general.real }]), _this$state);
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);
    _this.handleChangeLegData = _this.handleChangeLegData.bind(_this);

    _this.add = _this.add.bind(_this);
    _this.addLeg = _this.addLeg.bind(_this);
    _this.removeLeg = _this.removeLeg.bind(_this);
    _this.resetLeg = _this.resetLeg.bind(_this);
    _this.calculateDistances = _this.calculateDistances.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    // this.handleChangeDate = this.handleChangeDate.bind(this);
    return _this;
  }
  // Handlers


  _createClass(PaymentRequestTrainingDistanceAdd, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }

    // Descontinuado
    // Não atualizamos mais a quantidade de acordo com a quantidade de dias. A quantidade é definida pelo usuário
    // handleChangeDate (name, event) {
    //   var change = {};
    //   change[name] = event.target.value;
    //   this.setState(change);

    //   var daily_paid = 0;
    //   var other_date = this.state.date_start;
    //   if(name === 'date_start') {
    //     var other_date = this.state.date_finish;
    //   }
    //   if(change[name].length === 10 && other_date.length === 10) {
    //     date1 = change[name].split('/');
    //     date2 = other_date.split('/');

    //     var date1 = new Date(date1[1] + '/' + date1[0] + '/' + date1[2]);
    //     var date2 = new Date(date2[1] + '/' + date2[0] + '/' + date2[2]);

    //     // To calculate the time difference of two dates
    //     var Difference_In_Time = date2.getTime() - date1.getTime();

    //     // To calculate the no. of days between two dates
    //     daily_paid = Difference_In_Time / (1000 * 3600 * 24);

    //     daily_paid =  Math.abs(daily_paid) + 1;
    //   }    
    //   this.setState({daily_paid: daily_paid});
    //   this.handleChangeDailyTotal(this.state.daily_value, daily_paid);
    // }

  }, {
    key: 'handleChangeLegData',
    value: function handleChangeLegData(name, value, index) {
      var payment_legs = this.state.payment_legs;
      payment_legs[index][name] = value;
      this.setState({ payment_legs: payment_legs });
    }
  }, {
    key: 'handleChangeDaily',
    value: function handleChangeDaily(name, event) {
      var change = {};
      change[name] = event.target.value;

      this.setState(change);
      this.handleChangeDailyTotal(this.state.daily_value, event.target.value);
    }
  }, {
    key: 'handleChangeDailyPaid',
    value: function handleChangeDailyPaid(name, event) {
      var change = {};
      change[name] = event.target.value;

      this.setState(change);
      this.handleChangeDailyTotal(this.state.distance, event.target.value);
    }
  }, {
    key: 'handleChangeDailyTotal',
    value: function handleChangeDailyTotal(daily_value, daily_paid) {
      var daily_paid = daily_paid.toString().replace(',', '.');
      var daily_value = daily_value.toString().replace(',', '.');
      var total = daily_paid * daily_value;

      this.setState({ daily_total: total });
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'TrainingclearSelects',
    value: function TrainingclearSelects() {
      this.setState({ training_selected: 0 });
      this.setState({ distance: '' });
      this.setState({ daily_total: '' });
      this.setState({ date_start: '' });
      this.setState({ date_finish: '' });
      this.setState({ training_code: '' });
      this.setState({ daily_currency: '' });
      this.setState({ certification_supplier_id: '' });
      this.loadData();
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      this.handleAlert('', '', 'open');
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/solicitacao/deslocamento/info';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          if (responseJson.status === 'success') {
            var api = 'api';
            self.setState({
              api: api,
              payment_value: responseJson.data.payment_value,
              zipcode_bases: responseJson.data.zipcode_bases,
              zipcode_suppliers: responseJson.data.zipcode_suppliers
            });
            self.setState({ trainings_list: responseJson.data.trainings_list });
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          } else {
            self.setState({ overlay: { message: responseJson.message, type: 'error', status: 'open' } });
          }
        });
      });
    }
  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        training_id: this.state.training_id,
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        daily_paid: this.state.daily_paid,
        daily_value: this.state.daily_value,
        daily_total: this.state.daily_total,
        daily_currency: this.state.daily_currency,
        observation: this.state.observation,
        payment_legs: this.state.payment_legs
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get(self.state.api) + '/pagamento/treinamento/deslocamento/solicitacao/cadastrar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var url = '/lista/solicitacao/pagamento/deslocamento/treinamento';
            var storage = {
              alert_message: responseJson.message,
              alert_type: responseJson.status
            };
            localStorage.setItem("verify_message", JSON.stringify(storage));
            self.setState({ redirect_url: url });
          }
          self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'resetLeg',
    value: function resetLeg(type, leg) {
      this.handleChangeLegData(type + '_base_id', null, leg);
      this.handleChangeLegData(type + '_base', null, leg);
      this.handleChangeLegData(type + '_supplier_id', null, leg);
      this.handleChangeLegData(type + '_supplier', null, leg);
      this.handleChangeLegData('zipcode_' + type, null, leg);
    }
  }, {
    key: 'calculateDistances',
    value: function calculateDistances() {
      var header = this.refs.request_api.header('application/json');
      var self = this;

      var datasave = this.state.payment_legs;

      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/calcular/distancia/google';
        fetch(url, { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var total = responseJson.data * self.state.payment_value / 1000;
            self.setState({ daily_value: total.toFixed(2) });
            if (self.state.daily_paid) {
              self.handleChangeDailyTotal(total.toFixed(2), self.state.daily_paid);
            }
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        });
      });
    }
  }, {
    key: 'addLeg',
    value: function addLeg() {
      var payment_legs = this.state.payment_legs;

      payment_legs.push({
        origin_base_id: null,
        origin_supplier_id: null,
        origin_base: null,
        origin_supplier: null,
        zipcode_origin: null,
        destination_base_id: null,
        destination_supplier_id: null,
        destination_base: null,
        destination_supplier: null,
        zipcode_destination: null,
        total: 0
      });
      this.setState({ payment_legs: payment_legs });
    }
  }, {
    key: 'removeLeg',
    value: function removeLeg(index) {
      var self = this;
      this.state.payment_legs;
      var payment_legs = [];
      Object.keys(this.state.payment_legs).map(function (k) {
        if (k !== index) {
          payment_legs.push(Object.assign({}, self.state.payment_legs[k]));
        }
      });
      this.setState({ payment_legs: payment_legs });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoDeslocamento.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/lista/solicitacao/pagamento/deslocamento/treinamento', className: 'btn btn-default pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-left' }),
              ' ',
              this.locale.general.voltar
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.add },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoDeslocamento.formulario.Treinamento,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'training_id',
                      value: this.state.training_id,
                      searchable: true,
                      placeholder: this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoDeslocamento.formulario.placeholder.SelecionarTreinamento,
                      onChange: this.handleSelectChange.bind(this, 'training_id'),
                      options: this.state.trainings_list,
                      required: true
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoDeslocamento.formulario.Quantidade,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: this.state.daily_paid, name: 'daily_paid', className: 'form-control', onChange: this.handleChangeDaily.bind(this, 'daily_paid'), placeholder: '', required: true })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoDeslocamento.formulario.DataInicial,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_input_mask___default.a, { value: this.state.date_start, maskChar: null, name: 'date_start', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: this.locale.general.diaMesAno, required: true })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoDeslocamento.formulario.DataFinal,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_input_mask___default.a, { value: this.state.date_finish, maskChar: null, name: 'date_finish', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: this.locale.general.diaMesAno, required: true })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoDeslocamento.formulario.Valor,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: this.state.daily_value, name: 'daily_value', className: 'form-control', onChange: this.handleChangeDailyPaid.bind(this, 'daily_value'), placeholder: '', disabled: true, required: true })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoDeslocamento.formulario.Moeda,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'daily_currency',
                      value: this.state.daily_currency,
                      placeholder: this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoDeslocamento.formulario.placeholder.SelecionarMoeda,
                      onChange: this.handleSelectChange.bind(this, 'daily_currency'),
                      options: this.state.daily_currency_list,
                      required: true
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoDeslocamento.formulario.ValorTotal,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: this.state.daily_total, name: 'daily_total', className: 'form-control', onChange: this.handleChangeDailyTotal.bind(this.state.daily_value, this.state.daily_paid), placeholder: '', disabled: true, required: true })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoDeslocamento.formulario.Observacao,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: this.state.observation, name: 'observation', className: 'form-control', onChange: this.handleChange.bind(this, 'observation'), placeholder: this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoDeslocamento.formulario.placeholder.Observacao })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                { className: 'page-title pull-left' },
                this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoDeslocamento.formulario.tituloTrechos
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'button', className: 'btn button-inline btn-warning pull-right', onClick: function onClick() {
                    return _this2.addLeg();
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-plus' }),
                ' ',
                this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoDeslocamento.formulario.botaoAdicionarTrecho
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-responsive' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'table',
                  { className: 'table table-bordered table-stripped table-hover' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'thead',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center' },
                        '#'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center' },
                        this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoDeslocamento.formulario.tabela.BuscarLocais
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center' },
                        this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoDeslocamento.formulario.tabela.BaseOrigem
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center' },
                        this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoDeslocamento.formulario.tabela.FornecedorOrigem
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center' },
                        this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoDeslocamento.formulario.tabela.CEPOrigem
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center' },
                        this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoDeslocamento.formulario.tabela.BaseDestino
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center' },
                        this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoDeslocamento.formulario.tabela.FornecedorDestino
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center' },
                        this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoDeslocamento.formulario.tabela.CEPDestino
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { className: 'text-center' })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tbody',
                    { id: 'suppliers-certifications' },
                    Object.keys(this.state.payment_legs).map(function (k) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__PaymentRequestLegs__["a" /* default */], { leg_index: k, data: self.state.payment_legs[k], zipcode_bases: self.state.zipcode_bases, zipcode_suppliers: self.state.zipcode_suppliers, removeLeg: self.removeLeg, handleChangeLegData: self.handleChangeLegData, resetLeg: self.resetLeg });
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'button', className: 'btn btn-lg btn-block btn-success pull-right', onClick: function onClick() {
                        return _this2.calculateDistances();
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' }),
                    ' ',
                    this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoDeslocamento.formulario.botaoCalcular
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                    ' ',
                    this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoDeslocamento.formulario.botaoSalvarSolicitacao
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return PaymentRequestTrainingDistanceAdd;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (PaymentRequestTrainingDistanceAdd);

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










// Importação da tabela



var PaymentRequestTrainingDistanceIndex = function (_Component) {
  _inherits(PaymentRequestTrainingDistanceIndex, _Component);

  function PaymentRequestTrainingDistanceIndex(props) {
    _classCallCheck(this, PaymentRequestTrainingDistanceIndex);

    var _this = _possibleConstructorReturn(this, (PaymentRequestTrainingDistanceIndex.__proto__ || Object.getPrototypeOf(PaymentRequestTrainingDistanceIndex)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      payment_legs: [],
      modal: false
    };

    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.delete = _this.delete.bind(_this);
    _this.deleteRow = _this.deleteRow.bind(_this);
    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    _this.openModal = _this.openModal.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(PaymentRequestTrainingDistanceIndex, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/pagamento/treinamento/deslocamento/solicitacao', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'openModal',
    value: function openModal(payment_id) {
      var self = this;
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/pagamento/deslocamento/solicitacao/trechos/' + payment_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ payment_legs: responseJson.data, modal: true });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var _this2 = this;

      var botao = '';
      if (row.request_status === 'Aberta') {
        botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn btn-sm btn-danger', value: cell, onClick: this.delete },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-trash' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn btn-sm btn-info', value: cell, onClick: function onClick() {
                return _this2.openModal(cell);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-eye' })
          )
        );
      } else {
        botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn btn-sm btn-info', value: cell, onClick: function onClick() {
                return _this2.openModal(cell);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-eye' })
          )
        );
      }
      return botao;
    }
  }, {
    key: 'delete',
    value: function _delete(event) {
      var fatigue_id = event.currentTarget.value;
      var confirm = window.confirm(this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoTreinamento.deletar);
      if (confirm) {
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/pagamento/treinamento/deslocamento/solicitacao/' + fatigue_id, { method: 'DELETE', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.deleteRow(fatigue_id);
            }
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'deleteRow',
    value: function deleteRow(fatigue_id) {
      var data = this.state.data;
      data.map(function (dado, index) {
        if (dado.id == fatigue_id) {
          data.splice(index, 1);
        }
      });
      this.setState({ data: data });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoTreinamento.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/cadastrar/solicitacao/pagamento/deslocamento/treinamento', className: 'btn btn-primary pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-plus' }),
              ' ',
              this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoTreinamento.botaoSolicitarPagamentoDeDeslocamentoTreinamento
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoTreinamento.tabela.semSolicitacaoDePagamento }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoTreinamento.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'request_status', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoTreinamento.tabela.Status
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'payment_batch', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoTreinamento.tabela.Lote
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'training', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoTreinamento.tabela.Treinamento
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'training_revision', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoTreinamento.tabela.Revisao
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'date_start_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoTreinamento.tabela.Inicio
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'date_finish_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoTreinamento.tabela.Fim
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'daily_paid', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoTreinamento.tabela.Quantidade
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'daily_value', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoTreinamento.tabela.Valor
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'daily_total_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoTreinamento.tabela.ValorTotal
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'daily_currency', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoTreinamento.tabela.Moeda
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'observation', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoTreinamento.tabela.Observacao
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '100' },
                this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoTreinamento.tabela.Acoes
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal, bsSize: 'large', 'aria-labelledby': 'contained-modal-title-lg' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoTreinamento.tituloBases
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this3.setState({ modal: false, payment_legs: [] });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'table-responsive' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'table table-bordered table-stripped table-hover' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { className: 'text-center' },
                      this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoTreinamento.tabelaBases.Origem
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { className: 'text-center' },
                      this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoTreinamento.tabelaBases.CEPOrigem
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { className: 'text-center' },
                      this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoTreinamento.tabelaBases.Destino
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { className: 'text-center' },
                      this.locale.Pagamentos.SolicitacoesDePagamentoDeslocamentoTreinamento.tabelaBases.CEPDestino
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  { id: 'suppliers-certifications' },
                  Object.keys(this.state.payment_legs).map(function (k) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        self.state.payment_legs[k]['origin']
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        self.state.payment_legs[k]['zipcode_origin']
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        self.state.payment_legs[k]['destination']
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        self.state.payment_legs[k]['zipcode_destination']
                      )
                    );
                  })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this3.setState({ modal: false, payment_legs: [] });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return PaymentRequestTrainingDistanceIndex;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (PaymentRequestTrainingDistanceIndex);

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















var PaymentRequestScheduleTransportAdd = function (_Component) {
  _inherits(PaymentRequestScheduleTransportAdd, _Component);

  // constructor
  function PaymentRequestScheduleTransportAdd(props) {
    _classCallCheck(this, PaymentRequestScheduleTransportAdd);

    var _this = _possibleConstructorReturn(this, (PaymentRequestScheduleTransportAdd.__proto__ || Object.getPrototypeOf(PaymentRequestScheduleTransportAdd)).call(this, props));

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__["a" /* default */])();

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      schedule_grade_id: '',
      staff_id: '',
      daily_currency: 'BRL',
      training_selected: 0,
      daily_value: 0,
      daily_paid: 0,
      ignores_debts: 0,
      observation: '',
      date_start: '',
      date_finish: '',
      bonus: '',
      certification_supplier: '',
      certification_supplier_id: '',
      daily_currency_list: [{ value: "EUR", label: _this.locale.general.euro }, { value: "USD", label: _this.locale.general.dolar }, { value: "BRL", label: _this.locale.general.real }]
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.add = _this.add.bind(_this);
    _this.handleSelectChangeStaff = _this.handleSelectChangeStaff.bind(_this);
    _this.loadStaffData = _this.loadStaffData.bind(_this);
    return _this;
  }
  // Handlers


  _createClass(PaymentRequestScheduleTransportAdd, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);

      var daily_paid = 0;
      var other_date = this.state.date_start;
      if (name === 'date_start') {
        var other_date = this.state.date_finish;
      }

      if (change[name].length === 10 && other_date.length === 10) {
        date1 = change[name].split('/');
        date2 = other_date.split('/');

        var date1 = new Date(date1[1] + '/' + date1[0] + '/' + date1[2]);
        var date2 = new Date(date2[1] + '/' + date2[0] + '/' + date2[2]);

        // To calculate the time difference of two dates
        var Difference_In_Time = date2.getTime() - date1.getTime();

        // To calculate the no. of days between two dates
        daily_paid = Difference_In_Time / (1000 * 3600 * 24);

        daily_paid = Math.abs(daily_paid) + 1;
      }

      this.setState({ daily_paid: daily_paid });
      this.handleChangeDailyTotal(this.state.daily_value, daily_paid);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleChangeDaily',
    value: function handleChangeDaily(name, event) {
      var change = {};
      change[name] = event.target.value;

      this.setState(change);
      this.handleChangeDailyTotal(event.target.value, this.state.daily_paid);
    }
  }, {
    key: 'handleChangeDailyPaid',
    value: function handleChangeDailyPaid(name, event) {
      var change = {};
      change[name] = event.target.value;

      this.setState(change);
      this.handleChangeDailyTotal(this.state.daily_value, event.target.value);
    }
  }, {
    key: 'handleChangeDailyTotal',
    value: function handleChangeDailyTotal(daily_paid, daily_value) {
      var daily_paid = daily_paid.toString().replace(',', '.');
      var daily_value = daily_value.toString().replace(',', '.');
      var total = daily_paid * daily_value;

      this.setState({ daily_total: total });
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeStaff',
    value: function handleSelectChangeStaff(name, event) {
      var _this2 = this;

      var change = {};
      if (event == null) {
        change[name] = null;
        this.setState(change, function () {
          _this2.setState({ daily_value: '' });
        });
      } else {
        change[name] = event.value;
        this.setState(change, function () {
          _this2.loadStaffData(event);
        });
      }
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadStaffData',
    value: function loadStaffData(event) {
      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/pagamento/valores/funcionario/' + event.value;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            Object.keys(responseJson.data).map(function (k) {
              if (responseJson.data[k].type === 'transport' && responseJson.data[k].currency === self.state.daily_currency) {
                self.setState({ daily_value: responseJson.data[k].value_str });
              }
              return true;
            });
          }
          self.handleAlert('', '', 'closed');
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
        });
      });
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      this.handleAlert('', '', 'open');
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/solicitacao/transporte/info';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          if (responseJson.status === 'success') {
            var api = 'api';
            self.setState({ api: api, daily_value: responseJson.data.value });
            self.setState({ trainings_list: responseJson.data.trainings_list });
            var url_bases = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get(api) + '/bases/ativas/lista/escala';
            fetch(url_bases, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.refs.request_api.validate(responseJson);
              if (responseJson.status === 'success') {
                self.setState({ bases_list: responseJson.data });
              }
            }).then(function () {
              self.setState({ overlay: { message: '', type: '', status: 'closed' } });
            }); /* Overlay */
          } else {
            self.setState({ overlay: { message: responseJson.message, type: 'error', status: 'open' } });
          }
        });
      });
    }
  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      var datasave = {
        training_id: this.state.training_id,
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        daily_value: this.state.daily_value,
        daily_paid: this.state.daily_paid,
        daily_total: this.state.daily_total,
        daily_currency: this.state.daily_currency,
        base_id: this.state.base_id,
        observation: this.state.observation
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get(self.state.api) + '/pagamento/treinamento/transporte/solicitacao/cadastrar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var url = '/lista/solicitacao/pagamento/transporte/treinamento';
            var storage = {
              alert_message: responseJson.message,
              alert_type: responseJson.status
            };
            localStorage.setItem("verify_message", JSON.stringify(storage));
            self.setState({ redirect_url: url });
          }
          self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/lista/solicitacao/pagamento/transporte/treinamento', className: 'btn btn-default pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-left' }),
              ' ',
              this.locale.general.voltar
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.add },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.Treinamento,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'training_id',
                      value: this.state.training_id,
                      searchable: true,
                      placeholder: this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.placeholder.SelecionarTreinamento,
                      onChange: this.handleSelectChange.bind(this, 'training_id'),
                      options: this.state.trainings_list,
                      required: true
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.Quantidade,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: this.state.daily_paid, name: 'daily_paid', className: 'form-control', onChange: this.handleChangeDailyPaid.bind(this, 'daily_paid'), placeholder: '', disabled: true })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.DataInicial,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_input_mask___default.a, { value: this.state.date_start, required: true, maskChar: null, name: 'date_start', mask: '99/99/9999', className: 'form-control', onChange: this.handleChangeDate.bind(this, 'date_start'), placeholder: this.locale.general.diaMesAno })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.DataFinal,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_input_mask___default.a, { value: this.state.date_finish, required: true, maskChar: null, name: 'date_finish', mask: '99/99/9999', className: 'form-control', onChange: this.handleChangeDate.bind(this, 'date_finish'), placeholder: this.locale.general.diaMesAno })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.Valor,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: this.state.daily_value, name: 'daily_value', className: 'form-control', onChange: this.handleChangeDaily.bind(this, 'daily_value'), placeholder: '', disabled: true })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.Moeda,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'daily_currency',
                      value: this.state.daily_currency,
                      placeholder: this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.placeholder.SelecionarMoeda,
                      onChange: this.handleSelectChange.bind(this, 'daily_currency'),
                      options: this.state.daily_currency_list,
                      required: true
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.ValorTotal,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: this.state.daily_total, disabled: 'disabled', name: 'daily_total', className: 'form-control', onChange: this.handleChangeDaily.bind(this, 'daily_total'), placeholder: '' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.Base,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'base_id',
                      value: this.state.base_id,
                      placeholder: this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.placeholder.SelecionarBase,
                      onChange: this.handleSelectChange.bind(this, 'base_id'),
                      options: this.state.bases_list,
                      required: true
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.Observacao,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: this.state.observation, name: 'observation', className: 'form-control', onChange: this.handleChange.bind(this, 'observation'), placeholder: this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.placeholder.Observacao })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                    ' ',
                    this.locale.Pagamentos.AdicionarSolicitacaoDePagamentoTreinamentoTransporte.formulario.botaoSalvarPagamento
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return PaymentRequestScheduleTransportAdd;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (PaymentRequestScheduleTransportAdd);

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// Importação da tabela



var PaymentRequestTransportIndex = function (_Component) {
  _inherits(PaymentRequestTransportIndex, _Component);

  function PaymentRequestTransportIndex(props) {
    _classCallCheck(this, PaymentRequestTransportIndex);

    var _this = _possibleConstructorReturn(this, (PaymentRequestTransportIndex.__proto__ || Object.getPrototypeOf(PaymentRequestTransportIndex)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };

    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.delete = _this.delete.bind(_this);
    _this.deleteRow = _this.deleteRow.bind(_this);
    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    _this.openModal = _this.openModal.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(PaymentRequestTransportIndex, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/pagamento/treinamento/transporte/solicitacao', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'openModal',
    value: function openModal(payment_id) {
      var self = this;
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/pagamento/deslocamento/solicitacao/trechos/' + payment_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ payment_legs: responseJson.data, modal: true });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var botao = '';
      if (row.request_status === 'Aberta') {
        botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn btn-sm btn-danger', value: cell, onClick: this.delete },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-trash' })
          )
        );
      }

      return botao;
    }
  }, {
    key: 'delete',
    value: function _delete(event) {
      var fatigue_id = event.currentTarget.value;
      var confirm = window.confirm(this.locale.Pagamentos.SolicitacoesDePagamentoTransporteTreinamento.deletar);
      if (confirm) {
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/pagamento/treinamento/transporte/solicitacao/' + fatigue_id, { method: 'DELETE', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.deleteRow(fatigue_id);
            }
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'deleteRow',
    value: function deleteRow(fatigue_id) {
      var data = this.state.data;
      data.map(function (dado, index) {
        if (dado.id == fatigue_id) {
          data.splice(index, 1);
        }
      });
      this.setState({ data: data });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.Pagamentos.SolicitacoesDePagamentoTransporteTreinamento.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/cadastrar/solicitacao/pagamento/transporte/treinamento', className: 'btn btn-primary pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-plus' }),
              ' ',
              this.locale.Pagamentos.SolicitacoesDePagamentoTransporteTreinamento.botaoSolicitarPagamentoDeTransporteTreinamento
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Pagamentos.SolicitacoesDePagamentoTransporteTreinamento.tabela.semSolicitacaoDePagamento }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.Pagamentos.SolicitacoesDePagamentoTransporteTreinamento.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'request_status', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoTransporteTreinamento.tabela.Status
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'payment_batch', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoTransporteTreinamento.tabela.Lote
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'training', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoTransporteTreinamento.tabela.Treinamento
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'base', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoTransporteTreinamento.tabela.Base
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'training_revision', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoTransporteTreinamento.tabela.Revisao
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'daily_paid', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoTransporteTreinamento.tabela.Quantidade
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'daily_total_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoTransporteTreinamento.tabela.Valor
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'daily_currency', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoTransporteTreinamento.tabela.Moeda
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'observation', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Pagamentos.SolicitacoesDePagamentoTransporteTreinamento.tabela.Observacao
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '100' },
                this.locale.Pagamentos.SolicitacoesDePagamentoTransporteTreinamento.tabela.Acoes
              )
            )
          )
        )
      );
    }
  }]);

  return PaymentRequestTransportIndex;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (PaymentRequestTransportIndex);

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var ScheduleGroupStaffs = function (_Component) {
  _inherits(ScheduleGroupStaffs, _Component);

  function ScheduleGroupStaffs(props) {
    _classCallCheck(this, ScheduleGroupStaffs);

    var _this = _possibleConstructorReturn(this, (ScheduleGroupStaffs.__proto__ || Object.getPrototypeOf(ScheduleGroupStaffs)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      number: 0,
      schedule_group: {},
      schedule_group_staffs: []
    };

    _this.addCaptain = _this.addCaptain.bind(_this);
    _this.addCopilot = _this.addCopilot.bind(_this);
    _this.addFlightAttendant = _this.addFlightAttendant.bind(_this);
    _this.deleteGroup = _this.deleteGroup.bind(_this);
    _this.editGroup = _this.editGroup.bind(_this);
    _this.deleteGroupStaff = _this.deleteGroupStaff.bind(_this);
    _this.setFinish = _this.setFinish.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  _createClass(ScheduleGroupStaffs, [{
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && typeof newProps.schedule_group.id !== 'undefined' || this.state.loaded === 1 && newProps.updated === 1) {
        this.setState({
          schedule_group: newProps.schedule_group,
          schedule_group_staffs: newProps.schedule_group.schedule_group_staffs,
          start: newProps.schedule_group.start_str,
          finish: newProps.schedule_group.finish_str,
          schedule_initial_id: newProps.schedule_group.schedule_initial_id,
          captains_select: newProps.captains_select,
          copilots_select: newProps.copilots_select,
          flight_attendants_select: newProps.flight_attendants_select,
          schedule_initials_select: newProps.schedule_initials_select,
          number: newProps.number,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição

  }, {
    key: 'setFinish',
    value: function setFinish(event) {
      var data = new Date();
      var day = data.getDate();
      if (day < 10) {
        day = '0' + day;
      }
      var month = data.getMonth() + 1;
      if (month < 10) {
        month = '0' + month;
      }
      var hours = data.getHours();
      if (hours < 10) {
        hours = '0' + hours;
      }
      var minutes = data.getMinutes();
      if (minutes < 10) {
        minutes = '0' + minutes;
      }
      var finish = day + '/' + month + '/' + data.getFullYear() + ' ' + hours + ':' + minutes;

      this.setState({ finish: finish });
    }
    // Fetch salvando a edição

  }, {
    key: 'addCaptain',
    value: function addCaptain(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var datasave = {
        schedule_id: this.state.schedule_group.schedule_id,
        schedule_group_id: this.state.schedule_group.id,
        staff_id: this.state.captain_id,
        role: 'captain'
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/escala/programacao/grupo/tripulante', { method: 'post', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch(function (error) {
          console.error(error);
        });
      });
    }

    // Fetch salvando a edição

  }, {
    key: 'addCopilot',
    value: function addCopilot(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var datasave = {
        schedule_id: this.state.schedule_group.schedule_id,
        schedule_group_id: this.state.schedule_group.id,
        staff_id: this.state.copilot_id,
        role: 'copilot'
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/escala/programacao/grupo/tripulante', { method: 'post', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch(function (error) {
          console.error(error);
        });
      });
    }

    // Fetch salvando a edição

  }, {
    key: 'addFlightAttendant',
    value: function addFlightAttendant(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var datasave = {
        schedule_id: this.state.schedule_group.schedule_id,
        schedule_group_id: this.state.schedule_group.id,
        staff_id: this.state.flight_attendant_id,
        role: 'flight_attendant'
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/escala/programacao/grupo/tripulante', { method: 'post', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch(function (error) {
          console.error(error);
        });
      });
    }

    // Fetch salvando a edição

  }, {
    key: 'deleteGroupStaff',
    value: function deleteGroupStaff(id) {
      if (window.confirm(this.locale.Escalas.EditarEscalaDiaria.deletarTripulante)) {
        this.props.handleAlert('', '', 'open');
        var datasave = {
          id: id
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/escala/programacao/grupo/tripulante', { method: 'delete', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'deleteGroup',
    value: function deleteGroup(id) {
      if (window.confirm(this.locale.Escalas.EditarEscalaDiaria.deletarGrupo)) {
        this.props.handleAlert('', '', 'open');
        var datasave = {
          id: id
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/escala/programacao/grupo', { method: 'delete', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.updateData(responseJson);
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'editGroup',
    value: function editGroup(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: this.state.schedule_group.id,
        start: this.state.start,
        finish: this.state.finish,
        schedule_initial_id: this.state.schedule_initial_id
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/escala/programacao/grupo', { method: 'put', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      var sg = this.state.schedule_group;

      var initial = '';
      if (typeof sg.schedule_initial !== 'undefined' && sg.schedule_initial !== null) {
        initial = sg.schedule_initial.name;
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          { className: 'pull-left' },
          this.locale.Escalas.EditarEscalaDiaria.tituloGrupoAs(this.state.number, sg.start_str, sg.finish_str),
          ' - ',
          initial
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { onClick: function onClick() {
              self.deleteGroup(sg.id);
            }, className: 'btn btn-danger pull-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-trash' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: this.editGroup },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.Escalas.EditarEscalaDiaria.formularioGrupo.HorarioDeApresentacao,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.start, maskChar: null, name: 'start', mask: '99/99/9999 99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'start'), placeholder: '', required: true })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-4' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.Escalas.EditarEscalaDiaria.formularioGrupo.HorarioDeTerminoDaJornada,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.finish, maskChar: null, name: 'finish', mask: '99/99/9999 99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'finish'), placeholder: '' })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-1' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'button', onClick: function onClick() {
                      return _this2.setFinish();
                    }, className: 'btn btn-inline btn-default btn-block' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-calendar' })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-3' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.Escalas.EditarEscalaDiaria.formularioGrupo.Situacao,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], {
                  className: 'form-field-name',
                  name: 'schedule_initial_id',
                  value: this.state.schedule_initial_id,
                  searchable: true,
                  placeholder: '',
                  onChange: this.handleSelectChange.bind(this, 'schedule_initial_id'),
                  options: this.state.schedule_initials_select,
                  required: true
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-12' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                ' ',
                this.locale.Escalas.EditarEscalaDiaria.formularioGrupo.botaoEditarGrupo
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'row' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'form',
            { onSubmit: this.addCaptain, className: 'col-md-4' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-10' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.Escalas.EditarEscalaDiaria.formularioAdicionarComandante.Comandante,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    name: 'captain_id',
                    value: self.state.captain_id,
                    searchable: true,
                    placeholder: '',
                    onChange: self.handleSelectChange.bind(self, 'captain_id'),
                    options: self.state.captains_select,
                    required: true
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-2' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'submit', className: 'btn btn-primary btn-block btn-inline' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'form',
            { onSubmit: this.addCopilot, className: 'col-md-4' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-10' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.Escalas.EditarEscalaDiaria.formularioAdicionarCopiloto.Copiloto,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    name: 'copilot_id',
                    value: self.state.copilot_id,
                    searchable: true,
                    placeholder: '',
                    onChange: self.handleSelectChange.bind(self, 'copilot_id'),
                    options: self.state.copilots_select,
                    required: true
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-2' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'submit', className: 'btn btn-primary btn-block btn-inline' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'form',
            { onSubmit: this.addFlightAttendant, className: 'col-md-4' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-10' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.Escalas.EditarEscalaDiaria.formularioAdicionarComissario.Comissario,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    name: 'flight_attendant_id',
                    value: self.state.flight_attendant_id,
                    searchable: true,
                    placeholder: '',
                    onChange: self.handleSelectChange.bind(self, 'flight_attendant_id'),
                    options: self.state.flight_attendants_select,
                    required: true
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-2' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'submit', className: 'btn btn-primary btn-block btn-inline' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' })
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'table',
          { className: 'table table-bordered table-hover table-striped' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'thead',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tr',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                null,
                this.locale.Escalas.EditarEscalaDiaria.tabelaGrupo.Tripulante
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                null,
                this.locale.Escalas.EditarEscalaDiaria.tabelaGrupo.Funcao
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { className: 'col-md-1' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'tbody',
            null,
            Object.keys(this.state.schedule_group_staffs).map(function (ksgs) {
              var sgs = self.state.schedule_group_staffs[ksgs];
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  sgs.staff.name
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  null,
                  sgs.role_str
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { className: 'text-center' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { onClick: function onClick() {
                        self.deleteGroupStaff(sgs.id);
                      }, className: 'btn btn-danger' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-trash' })
                  )
                )
              );
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
      );
    }
  }]);

  return ScheduleGroupStaffs;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ScheduleGroupStaffs);

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Elements_ScheduleGroupStaffs__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

















var SchedulePlanningEdit = function (_Component) {
  _inherits(SchedulePlanningEdit, _Component);

  function SchedulePlanningEdit(props) {
    _classCallCheck(this, SchedulePlanningEdit);

    var _this = _possibleConstructorReturn(this, (SchedulePlanningEdit.__proto__ || Object.getPrototypeOf(SchedulePlanningEdit)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      updated: 0,
      errors_listing: false,
      approve: false,
      justification: null,
      id: null,
      schedule_availability_id: null,
      status_str: null,
      status: null,
      aircraft: null,
      base: null,
      date: null,
      available: null,
      interruption_start: null,
      unavailable_reason: null,
      deadline_preview: null,
      flight_following: null,
      flight_following_reason: null,
      flight_following_date: null,
      flight_following_preview: null,
      sigmec_id: null,
      observations: null,
      schedule_initials_select: [],
      captains_select: [],
      copilots_select: [],
      flight_attendants_select: [],
      flight_following_reasons_select: [],
      staffs_sigmec_select: [],
      flight_reports_select: [],
      schedule_groups: [],
      schedule_warnings: [],
      schedule_logs: [],
      modal_alerts: false,
      staff_alerts: {},
      global_alerts: {}
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.updateData = _this.updateData.bind(_this);
    _this.addGroup = _this.addGroup.bind(_this);
    _this.setFinish = _this.setFinish.bind(_this);
    _this.editAvailability = _this.editAvailability.bind(_this);
    _this.warnings = _this.warnings.bind(_this);
    _this.changeStatus = _this.changeStatus.bind(_this);
    _this.approve = _this.approve.bind(_this);
    _this.modalAlerts = _this.modalAlerts.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(SchedulePlanningEdit, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
        change[name] = value;
        this.setState(change);
      } else {
        var value = 0;
        change[name] = value;
        this.setState(change);
      }
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleSelectChangeMulti',
    value: function handleSelectChangeMulti(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData(1));
      }
    }
  }, {
    key: 'updateData',
    value: function updateData(responseJson) {
      this.setState({ updated: 1 }, this.loadData(responseJson));
    }
  }, {
    key: 'loadData',
    value: function loadData(event) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/escala/programacao/info/edicao/' + self.props.match.params.id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url', '/sigla/modelos');
          if (responseJson.status === 'success') {
            if (responseJson.data.main.extra_crew == 0) {
              self.setState({
                id: responseJson.data.main.id,
                status: responseJson.data.main.status,
                extra_crew: responseJson.data.main.extra_crew,
                status_str: responseJson.data.main.status_str,
                aircraft: responseJson.data.main.aircraft.registration,
                contract: responseJson.data.main.contract.name,
                base: responseJson.data.main.base.name,
                date: responseJson.data.main.date_str,
                available: responseJson.data.availability.available,
                interruption_start: responseJson.data.availability.interruption_start_str,
                unavailable_reason: responseJson.data.availability.reason,
                deadline_preview: responseJson.data.availability.deadline_preview_str,
                schedule_availability_id: responseJson.data.schedule_availability.id,
                flight_following: responseJson.data.schedule_availability.flight_following,
                flight_following_reason: responseJson.data.schedule_availability.flight_following_reason,
                flight_following_date: responseJson.data.schedule_availability.flight_following_date_str,
                flight_following_preview: responseJson.data.schedule_availability.flight_following_preview_str,
                sigmec_id: responseJson.data.schedule_availability.sigmec_id,
                observations: responseJson.data.schedule_availability.observations,
                schedule_initials_select: responseJson.data.schedule_initials_select,
                captains_select: responseJson.data.captains_select,
                copilots_select: responseJson.data.copilots_select,
                flight_attendants_select: responseJson.data.flight_attendants_select,
                flight_following_reasons_select: responseJson.data.flight_following_reasons_select,
                staffs_sigmec_select: responseJson.data.staffs_sigmec_select,
                flight_reports_select: responseJson.data.flight_reports_select,
                schedule_groups: responseJson.data.schedule_groups,
                schedule_warnings: responseJson.data.schedule_warnings,
                schedule_logs: responseJson.data.schedule_logs,
                captain_duties_select: responseJson.data.captain_duties_select,
                pre_select_captain: responseJson.data.pre_select_captain,
                copilot_duties_select: responseJson.data.copilot_duties_select,
                pre_select_copilot: responseJson.data.pre_select_copilot,
                flight_attendant_duties_select: responseJson.data.flight_attendant_duties_select,
                pre_select_flight_attendant: responseJson.data.pre_select_flight_attendant
              });
            } else {
              self.setState({
                id: responseJson.data.main.id,
                status: responseJson.data.main.status,
                status_str: responseJson.data.main.status_str,
                aircraft: null,
                contract: null,
                base: responseJson.data.main.base.name,
                extra_crew: responseJson.data.main.extra_crew,
                date: responseJson.data.main.date_str,
                available: responseJson.data.availability.available,
                interruption_start: responseJson.data.availability.interruption_start_str,
                unavailable_reason: responseJson.data.availability.reason,
                deadline_preview: responseJson.data.availability.deadline_preview_str,
                schedule_availability_id: responseJson.data.schedule_availability.id,
                flight_following: responseJson.data.schedule_availability.flight_following,
                flight_following_reason: responseJson.data.schedule_availability.flight_following_reason,
                flight_following_date: responseJson.data.schedule_availability.flight_following_date_str,
                flight_following_preview: responseJson.data.schedule_availability.flight_following_preview_str,
                sigmec_id: responseJson.data.schedule_availability.sigmec_id,
                observations: responseJson.data.schedule_availability.observations,
                schedule_initials_select: responseJson.data.schedule_initials_select,
                captains_select: responseJson.data.captains_select,
                copilots_select: responseJson.data.copilots_select,
                flight_attendants_select: responseJson.data.flight_attendants_select,
                flight_following_reasons_select: responseJson.data.flight_following_reasons_select,
                staffs_sigmec_select: responseJson.data.staffs_sigmec_select,
                flight_reports_select: responseJson.data.flight_reports_select,
                schedule_groups: responseJson.data.schedule_groups,
                schedule_warnings: responseJson.data.schedule_warnings,
                schedule_logs: responseJson.data.schedule_logs,
                captain_duties_select: responseJson.data.captain_duties_select,
                pre_select_captain: responseJson.data.pre_select_captain,
                copilot_duties_select: responseJson.data.copilot_duties_select,
                pre_select_copilot: responseJson.data.pre_select_copilot,
                flight_attendant_duties_select: responseJson.data.flight_attendant_duties_select,
                pre_select_flight_attendant: responseJson.data.pre_select_flight_attendant
              });
            }
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          if (self.state.updated == 1) {
            self.handleAlert(event.message, event.status, 'open');
            self.setState({ updated: 0 });
          } else {
            self.handleMessage();
          }
        });
      });
    }

    // Fetch salvando a edição

  }, {
    key: 'addGroup',
    value: function addGroup(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        schedule_id: this.state.id,
        start: this.state.start,
        finish: this.state.finish,
        schedule_initial_id: this.state.schedule_initial_id,
        flight_report_ids: this.state.flight_report_ids
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/escala/programacao/grupo', { method: 'post', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.loadData(responseJson);
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }

    // Fetch salvando a edição

  }, {
    key: 'setFinish',
    value: function setFinish(event) {
      var data = new Date();
      var day = data.getDate();
      if (day < 10) {
        day = '0' + day;
      }
      var month = data.getMonth() + 1;
      if (month < 10) {
        month = '0' + month;
      }
      var hours = data.getHours();
      if (hours < 10) {
        hours = '0' + hours;
      }
      var minutes = data.getMinutes();
      if (minutes < 10) {
        minutes = '0' + minutes;
      }
      var finish = day + '/' + month + '/' + data.getFullYear() + ' ' + hours + ':' + minutes;
      this.setState({ finish: finish });
    }

    // Fetch salvando a edição

  }, {
    key: 'editAvailability',
    value: function editAvailability(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        id: this.state.schedule_availability_id,
        flight_following: this.state.flight_following,
        flight_following_reason: this.state.flight_following_reason,
        flight_following_date: this.state.flight_following_date,
        flight_following_preview: this.state.flight_following_preview,
        sigmec_id: this.state.sigmec_id,
        observations: this.state.observations
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/escala/programacao/disponibilidade', { method: 'put', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.loadData(responseJson);
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'warnings',
    value: function warnings() {
      var self = this;
      var url = "/escala/programacao/alertas/";
      var header = this.refs.request_api.header('application/json');
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ approve: false, modal_alerts: true });
            self.modalAlerts(responseJson.data);
            self.handleAlert('', '', 'closed');
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        });
      });
    }
  }, {
    key: 'modalAlerts',
    value: function modalAlerts(data) {

      if (data.staff) {
        this.setState({ staff_alerts: data.staff });
      }
      if (data.global) {
        this.setState({ global_alerts: data.global });
      }
    }
  }, {
    key: 'changeStatus',
    value: function changeStatus(url) {
      var confirm = this.locale.Escalas.EditarEscalaDiaria.trocarOStatusDaEscala;
      if (window.confirm(confirm)) {
        var datasave = { id: this.props.match.params.id, ignore_warning: false };
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'validation_error') {
              self.setState({ errors_listing: true, errors_messages: responseJson.data });
              self.handleAlert('', '', 'closed');
            }if (responseJson.status === 'warning') {
              self.setState({ approve: true, modal_alerts: true });
              self.modalAlerts(responseJson.data);
              self.handleAlert(responseJson.message, responseJson.status, 'open');
            } else {
              self.updateData(responseJson);
            }
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'approve',
    value: function approve(event) {
      event.preventDefault();
      var confirm = this.locale.Escalas.EditarEscalaDiaria.aprovarEscalaMesmoComAlertasVermelhos;
      if (window.confirm(confirm)) {
        var datasave = { id: this.props.match.params.id, ignore_warning: true, justification: this.state.justification, staff_alerts: this.state.staff_alerts, global_alerts: this.state.global_alerts };
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/escala/programacao/status/aprovada', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'validation_error') {
              self.setState({ errors_listing: true, errors_messages: responseJson.data });
              self.handleAlert('', '', 'closed');
            } else {
              self.setState({ errors_listing: responseJson.data.error, errors_messages: responseJson.data.errors });
              self.updateData(responseJson);
            }
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            this.state.extra_crew == 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.Escalas.EditarEscalaDiaria.titulo,
              ' - ',
              this.state.aircraft,
              ' - ',
              this.state.contract,
              ' - ',
              this.state.base,
              ' - ',
              this.state.date
            ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.Escalas.EditarEscalaDiaria.tituloEditarEscalaDiariaTripulacaoExtra,
              ' - ',
              this.state.base,
              ' - ',
              this.state.date
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'grid-buttons pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
                { to: '/escalas/programacao', className: 'btn btn-default' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-left' }),
                ' ',
                this.locale.general.voltar
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["h" /* Dropdown */],
                { id: 'revisions' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["h" /* Dropdown */].Toggle,
                  { bsStyle: 'primary' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-certificate' }),
                  ' ',
                  this.state.status_str
                ),
                this.state.status === 'approved' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["h" /* Dropdown */].Menu,
                  { className: 'super-colors' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { onSelect: this.changeStatus, eventKey: '/escala/programacao/status/rascunho' },
                    this.locale.Escalas.EditarEscalaDiaria.botaoProgramacao.TrocarParaRascunho
                  )
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["h" /* Dropdown */].Menu,
                  { className: 'super-colors' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { onSelect: this.changeStatus, eventKey: '/escala/programacao/status/aprovada' },
                    this.locale.Escalas.EditarEscalaDiaria.botaoProgramacao.TrocarParaAprovada
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { onClick: function onClick() {
                    return _this2.warnings();
                  }, className: 'btn btn-warning button-inline' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-warning' }),
                '  ',
                this.locale.Escalas.EditarEscalaDiaria.botaoAlertas
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            this.state.errors_listing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'alert alert-danger alert-dismissible', role: 'alert', style: { marginTop: 25 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { onClick: function onClick() {
                    return self.setState({ errors_listing: false, errors_messages: [] });
                  }, type: 'button', className: 'close', 'data-dismiss': 'alert', 'aria-label': 'Close' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { 'aria-hidden': 'true' },
                  '\xD7'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                this.locale.Escalas.EditarEscalaDiaria.erros,
                ':'
              ),
              Object.keys(self.state.errors_messages).map(function (k) {
                var message = self.state.errors_messages[k];
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  '- ',
                  message
                );
              })
            ),
            this.state.extra_crew == 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h3',
                null,
                this.locale.Escalas.EditarEscalaDiaria.tituloDisponibilidadeDaAeronave
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'form',
                { onSubmit: this.editAvailability },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-3' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Escalas.EditarEscalaDiaria.formularioDisponibilidadeDaAeronave.Disponivel,
                        '?'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_toggle___default.a, {
                        checked: this.state.available,
                        'aria-label': '',
                        name: 'flight_following'
                      })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-3' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Escalas.EditarEscalaDiaria.formularioDisponibilidadeDaAeronave.IndisponivelDesde,
                        ':'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.interruption_start, maskChar: null, name: 'interruption_start', mask: '99/99/9999 99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'interruption_start'), placeholder: '', disabled: true })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-3' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Escalas.EditarEscalaDiaria.formularioDisponibilidadeDaAeronave.Razao,
                        ':'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: this.state.unavailable_reason, name: 'unavailable_reason', className: 'form-control', onChange: this.handleChange.bind(this, 'unavailable_reason'), placeholder: '', disabled: true })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-3' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Escalas.EditarEscalaDiaria.formularioDisponibilidadeDaAeronave.Previsao,
                        ':'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.deadline_preview, maskChar: null, name: 'deadline_preview', mask: '99/99/9999 99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'deadline_preview'), placeholder: '', disabled: true })
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-3' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Escalas.EditarEscalaDiaria.formularioDisponibilidadeDaAeronave.FlightFollowingAnormal,
                        '?'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_toggle___default.a, {
                        checked: this.state.flight_following,
                        'aria-label': '',
                        name: 'flight_following',
                        onChange: this.handleToggleChange.bind(this, 'flight_following') })
                    )
                  ),
                  this.state.flight_following ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'col-md-3' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'form-group' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'label',
                          null,
                          this.locale.Escalas.EditarEscalaDiaria.formularioDisponibilidadeDaAeronave.AnormalDesde,
                          ':'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.flight_following_date, maskChar: null, name: 'flight_following_date', mask: '99/99/9999 99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'flight_following_date'), placeholder: '' })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'col-md-3' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'form-group' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'label',
                          null,
                          this.locale.Escalas.EditarEscalaDiaria.formularioDisponibilidadeDaAeronave.Razao,
                          ':'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                          className: '',
                          name: 'flight_following_reason',
                          value: this.state.flight_following_reason,
                          searchable: true,
                          placeholder: '',
                          onChange: this.handleSelectChange.bind(this, 'flight_following_reason'),
                          options: this.state.flight_following_reasons_select
                        })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'col-md-3' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'form-group' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'label',
                          null,
                          this.locale.Escalas.EditarEscalaDiaria.formularioDisponibilidadeDaAeronave.Previsao,
                          ':'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.flight_following_preview, maskChar: null, name: 'flight_following_preview', mask: '99/99/9999 99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'flight_following_preview'), placeholder: '' })
                      )
                    )
                  ) : ''
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Escalas.EditarEscalaDiaria.formularioDisponibilidadeDaAeronave.InspetorMecanicoResponsavel,
                        ':'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                        className: '',
                        name: 'sigmec_id',
                        value: this.state.sigmec_id,
                        searchable: true,
                        placeholder: '',
                        onChange: this.handleSelectChange.bind(this, 'sigmec_id'),
                        options: this.state.staffs_sigmec_select
                      })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Escalas.EditarEscalaDiaria.formularioDisponibilidadeDaAeronave.Observacoes,
                        ':'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { value: this.state.observations, name: 'observations', className: 'form-control', onChange: this.handleChange.bind(this, 'observations'), placeholder: '' })
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-12' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                      ' ',
                      this.locale.general.editar
                    )
                  )
                )
              )
            ) : '',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              null,
              this.locale.Escalas.EditarEscalaDiaria.tituloCriarGrupo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.addGroup },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Escalas.EditarEscalaDiaria.formularioCriarGrupo.HorarioDeApresentacao,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.start, maskChar: null, name: 'start', mask: '99/99/9999 99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'start'), placeholder: '', required: true })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Escalas.EditarEscalaDiaria.formularioCriarGrupo.HorarioDeTerminoDaJornada,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.finish, maskChar: null, name: 'finish', mask: '99/99/9999 99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'finish'), placeholder: '' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-1' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { type: 'button', onClick: function onClick() {
                          return _this2.setFinish();
                        }, className: 'btn btn-inline btn-default btn-block' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-calendar' })
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Escalas.EditarEscalaDiaria.formularioCriarGrupo.Situacao,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'schedule_initial_id',
                      value: this.state.schedule_initial_id,
                      searchable: true,
                      placeholder: '',
                      onChange: this.handleSelectChange.bind(this, 'schedule_initial_id'),
                      options: this.state.schedule_initials_select,
                      required: true
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Escalas.EditarEscalaDiaria.formularioCriarGrupo.Voos,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'flight_report_ids',
                      value: this.state.flight_report_ids,
                      searchable: true,
                      placeholder: '',
                      onChange: this.handleSelectChangeMulti.bind(this, 'flight_report_ids'),
                      options: this.state.flight_reports_select,
                      multi: true
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                    ' ',
                    this.locale.Escalas.EditarEscalaDiaria.formularioCriarGrupo.botaoAdicionarGrupo
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            Object.keys(self.state.schedule_groups).map(function (k) {
              var sg = self.state.schedule_groups[k];
              var number = parseInt(k) + 1;

              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Elements_ScheduleGroupStaffs__["a" /* default */], { updateData: self.updateData, updated: self.state.updated, handleAlert: self.handleAlert, captains_select: self.state.captains_select, captain_duties_select: self.state.captain_duties_select, pre_select_captain: self.state.pre_select_captain, copilots_select: self.state.copilots_select, copilot_duties_select: self.state.copilot_duties_select, pre_select_copilot: self.state.pre_select_copilot, schedule_initials_select: self.state.schedule_initials_select, flight_attendants_select: self.state.flight_attendants_select, flight_attendant_duties_select: self.state.flight_attendant_duties_select, pre_select_flight_attendant: self.state.pre_select_flight_attendant, flight_reports_select: self.state.flight_reports_select, schedule_group: sg, number: number })
              );
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              null,
              this.locale.Escalas.EditarEscalaDiaria.tituloAlertasDeAprovacao
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'table-responsive' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'table table-bordered table-hover table-striped' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      this.locale.Escalas.EditarEscalaDiaria.tabelaAlertasDeAprovacao.Mensagem
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      this.locale.Escalas.EditarEscalaDiaria.tabelaAlertasDeAprovacao.Data
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  null,
                  Object.keys(self.state.schedule_warnings).map(function (k) {
                    var srl = self.state.schedule_warnings[k];
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { className: "box-alert box-alert-" + srl.color, dangerouslySetInnerHTML: { __html: srl.message } }),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: "box-alert box-alert-" + srl.color },
                        srl.created_at_str
                      )
                    );
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.Escalas.EditarEscalaDiaria.tituloLogDeStatus
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'table-responsive' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'table table-bordered table-hover table-striped' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      this.locale.Escalas.EditarEscalaDiaria.tabelaLogDeStatus.Usuario
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      this.locale.Escalas.EditarEscalaDiaria.tabelaLogDeStatus.Acao
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      this.locale.Escalas.EditarEscalaDiaria.tabelaLogDeStatus.Descricao
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      this.locale.Escalas.EditarEscalaDiaria.tabelaLogDeStatus.Justificativa
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      this.locale.Escalas.EditarEscalaDiaria.tabelaLogDeStatus.Data
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  null,
                  Object.keys(self.state.schedule_logs).map(function (k) {
                    var srl = self.state.schedule_logs[k];
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        srl.user_name
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        srl.action
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        srl.message
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        srl.justification
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        srl.created_at_str
                      )
                    );
                  })
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal_alerts, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                this.locale.Escalas.EditarEscalaDiaria.tituloAlertas
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ modal_alerts: false, justification: null, approve: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              Object.keys(self.state.global_alerts).map(function (k) {
                var alert = self.state.global_alerts[k];
                if (Array.isArray(alert)) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    null,
                    Object.keys(alert).map(function (klert) {
                      var alert2 = alert[klert];
                      if (alert2) {
                        if (alert2.error && alert2.error === 1) {
                          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: "box-alert box-alert-" + alert2.color },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: alert2.message } })
                          );
                        }
                      }
                    })
                  );
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              Object.keys(self.state.global_alerts).map(function (k) {
                var alert = self.state.global_alerts[k];
                if (alert) {
                  if (alert.error && alert.error === 1) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: "box-alert box-alert-" + alert.color },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: alert.message } })
                    );
                  }
                }
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              Object.keys(self.state.staff_alerts).map(function (nickname) {
                var alerts = self.state.staff_alerts[nickname];
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h4',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'strong',
                      null,
                      nickname
                    )
                  ),
                  Object.keys(alerts).map(function (k) {
                    var alert = alerts[k];
                    if (alert) {
                      if (alert.error === 1) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'div',
                          { className: "box-alert box-alert-" + alert.color },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: alert.message } })
                        );
                      }
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
                );
              })
            ),
            this.state.approve === true ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.approve },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Escalas.EditarEscalaDiaria.formularioAlertas.Justificativa,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', { style: { height: 200 }, type: 'text', name: 'justification', required: true, className: 'form-control', value: this.state.justification, onChange: this.handleChange.bind(this, 'justification') })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-certificate' }),
                      ' ',
                      this.locale.Escalas.EditarEscalaDiaria.formularioAlertas.botaoContinuarAprovacao
                    )
                  )
                )
              )
            ) : ''
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ modal_alerts: false, justification: null, approve: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return SchedulePlanningEdit;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SchedulePlanningEdit);

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_datepicker__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// Importação da tabela



var SchedulePlanningIndex = function (_Component) {
  _inherits(SchedulePlanningIndex, _Component);

  function SchedulePlanningIndex(props) {
    _classCallCheck(this, SchedulePlanningIndex);

    var _this = _possibleConstructorReturn(this, (SchedulePlanningIndex.__proto__ || Object.getPrototypeOf(SchedulePlanningIndex)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      current: '',
      next: '',
      previous: ''
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.delete = _this.delete.bind(_this);
    _this.deleteRow = _this.deleteRow.bind(_this);
    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    _this.next = _this.next.bind(_this);
    _this.previous = _this.previous.bind(_this);
    _this.availabilityLable = _this.availabilityLable.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(SchedulePlanningIndex, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleChangeDate',
    value: function handleChangeDate(name, event) {
      var change = {};
      var full_date = this.state.date_start;
      if (event == null) {
        change[name] = null;
      } else {
        var date = event.target.value;
        var year = date.split("-")[0];
        var month = date.split("-")[1];
        var day = date.split("-")[2];
        // Utilizo o .slice(-2) para garantir o formato com 2 dígitos.
        var full_date = ("0" + day).slice(-2) + "/" + ("0" + month).slice(-2) + "/" + year;
        change[name] = date;
      }
      this.setState(change);
      this.loadData(full_date);
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        var now = new Date();
        var month = now.getMonth() + 1;
        var year = now.getFullYear();
        var day = now.getDate();
        if (day < 10) {
          day = '0' + day;
        }
        if (month < 10) {
          month = '0' + month;
        }
        var reference = day + '/' + month + '/' + year;
        this.setState({ loaded: 2 }, this.loadData(reference));
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var today = new Date();
      var date = today.setDate(today.getDate());
      var today_str = new Date(date).toISOString().split('T')[0]; // yyyy-mm-dd

      this.setState({ date_start: today_str });
    }
  }, {
    key: 'loadData',
    value: function loadData(reference) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/escalas/programacao/' + reference, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data.index_data, current: responseJson.data.current, previous: responseJson.data.previous, next: responseJson.data.next });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'availabilityLable',
    value: function availabilityLable(cell, row) {
      if (cell === 1) {
        var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'label label-success' },
          this.locale.Escalas.ListaDeEscalaDiaria.botaoDisponivel
        );
      } else {
        var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'label label-danger' },
          this.locale.Escalas.ListaDeEscalaDiaria.botaoIndisponivel
        );
      }

      return botao;
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var edit = '/escala/programacao/editar/' + cell;

      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
          { className: 'btn btn-primary btn-sm', to: edit },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
        ),
        '\xA0',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-sm btn-danger', value: cell, onClick: this.delete },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-trash' })
        )
      );

      return botao;
    }
  }, {
    key: 'delete',
    value: function _delete(event) {
      var schedule_id = event.currentTarget.value;
      var confirm = window.confirm(this.locale.Escalas.ListaDeEscalaDiaria.deletar);
      if (confirm) {
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/escala/' + schedule_id, { method: 'DELETE', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.deleteRow(schedule_id);
            }
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'deleteRow',
    value: function deleteRow(schedule_id) {
      var data = this.state.data;
      data.map(function (dado, index) {
        if (dado.id == schedule_id) {
          data.splice(index, 1);
        }
      });
      this.setState({ data: data });
    }
  }, {
    key: 'next',
    value: function next() {
      this.setState({ overlay: { message: '', type: '', status: 'open' } });
      this.loadData(this.state.next);
    }
  }, {
    key: 'previous',
    value: function previous() {
      this.setState({ overlay: { message: '', type: '', status: 'open' } });
      this.loadData(this.state.previous);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-primary', onClick: this.previous },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-chevron-left' }),
                  ' ',
                  this.state.previous
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h3',
                  { className: 'page-title text-center' },
                  this.state.current
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-4 text-right' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-primary', onClick: this.next },
                  this.state.next,
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-chevron-right' })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.Escalas.ListaDeEscalaDiaria.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-2 col-md-offset-5' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'date', value: this.state.date_start, onChange: this.handleChangeDate.bind(this, 'date_start'), className: 'form-control' })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: 'Exportar CSV', noDataText: this.locale.Escalas.ListaDeEscalaDiaria.tabela.semProgramacaoParaHoje }, search: true, multiColumnSearch: true, searchPlaceholder: 'Procurar' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.Escalas.ListaDeEscalaDiaria.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'base', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '250' },
                this.locale.Escalas.ListaDeEscalaDiaria.tabela.Base
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'aircraft', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '250' },
                this.locale.Escalas.ListaDeEscalaDiaria.tabela.Aeronave
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'aircraft_model', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '250' },
                this.locale.Escalas.ListaDeEscalaDiaria.tabela.Modelo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'contract', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '250' },
                this.locale.Escalas.ListaDeEscalaDiaria.tabela.Contrato
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'availability', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '250', dataFormat: this.availabilityLable },
                this.locale.Escalas.ListaDeEscalaDiaria.tabela.Disponibilidade
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'cmdts', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '250' },
                this.locale.Escalas.ListaDeEscalaDiaria.tabela.ComandanteS
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'copils', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '250' },
                this.locale.Escalas.ListaDeEscalaDiaria.tabela.CopilotoS
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'flight_attendants', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '250' },
                this.locale.Escalas.ListaDeEscalaDiaria.tabela.ComissarioS
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'group_starts', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '250' },
                this.locale.Escalas.ListaDeEscalaDiaria.tabela.Apresentacao
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'group_finishes', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '250' },
                this.locale.Escalas.ListaDeEscalaDiaria.tabela.Corte
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'status', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '250' },
                this.locale.Escalas.ListaDeEscalaDiaria.tabela.Status
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '200' },
                this.locale.Escalas.ListaDeEscalaDiaria.tabela.Acoes
              )
            )
          )
        )
      );
    }
  }]);

  return SchedulePlanningIndex;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SchedulePlanningIndex);

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// Importação da tabela



var SchedulesIndex = function (_Component) {
  _inherits(SchedulesIndex, _Component);

  function SchedulesIndex(props) {
    _classCallCheck(this, SchedulesIndex);

    var _this = _possibleConstructorReturn(this, (SchedulesIndex.__proto__ || Object.getPrototypeOf(SchedulesIndex)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      current: '',
      next: '',
      previous: '',
      show_fleet: 0,
      show_base: 0,
      user_type: null
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.exportPdfGrade = _this.exportPdfGrade.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    _this.loadOrigin = _this.loadOrigin.bind(_this);
    _this.next = _this.next.bind(_this);
    _this.previous = _this.previous.bind(_this);
    _this.apiOrigin = _this.apiOrigin.bind(_this);
    _this.personalFields = _this.personalFields.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(SchedulesIndex, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadOrigin());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData(reference) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      if (this.state.user_type === 'sigtrip') {
        var api = 'api';
      } else if (this.state.user_type === 'sigmec') {
        var api = 'api_sigmec';
      }
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get(api) + '/funcionario/escalas/' + reference;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data.index_data, current: responseJson.data.current, previous: responseJson.data.previous, next: responseJson.data.next });
            self.personalFields(responseJson.data.fleet, responseJson.data.base);
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'loadOrigin',
    value: function loadOrigin() {
      var now = new Date();
      var month = now.getMonth() + 1;
      var year = now.getFullYear();
      var reference = month + '/' + year;
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/checar/origem/usuario';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.apiOrigin(responseJson.data);
            self.loadData(reference);
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }); /* Overlay */
      });
    }
  }, {
    key: 'apiOrigin',
    value: function apiOrigin(origin) {
      this.setState({ user_type: origin });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(event) {
      var schedule_grade_id = this.state.data[0].schedule_grade_id;
      var revision = this.state.data[0].schedule_grade_revision;
      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { onClick: this.exportPdfGrade, className: 'btn btn-warning button-inline', value: schedule_grade_id },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' }),
          ' ',
          this.locale.Escalas.ListaDeEscalas.botaoRevisao,
          ' ',
          revision
        )
      );

      return botao;
    }
  }, {
    key: 'personalFields',
    value: function personalFields(fleet, base) {
      this.setState({ show_fleet: fleet, show_base: base });
    }
  }, {
    key: 'exportPdfGrade',
    value: function exportPdfGrade(event) {
      var schedule_grade_id = event.currentTarget.value;
      var self = this;
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      if (this.state.user_type === 'sigtrip') {
        var api = 'api';
        var cdn = 'cdn';
        var route = '/exportar/pdf/escala-grade/' + schedule_grade_id;
        var pdf = '/schedule_grades/main/';
      } else if (this.state.user_type === 'sigmec') {
        var api = 'api_sigmec';
        var cdn = 'cdn_sigmec';
        var route = '/exportar/escala/grade/visualizar/' + schedule_grade_id + '/2';
        var pdf = '/tmp/';
      }
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get(api) + route;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get(cdn) + pdf + responseJson.data);
        });
      });
    }
  }, {
    key: 'next',
    value: function next() {
      this.setState({ overlay: { message: '', type: '', status: 'open' } });
      this.loadData(this.state.next);
    }
  }, {
    key: 'previous',
    value: function previous() {
      this.setState({ overlay: { message: '', type: '', status: 'open' } });
      this.loadData(this.state.previous);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-primary', onClick: this.previous },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-chevron-left' }),
                  ' ',
                  this.state.previous
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h3',
                  { className: 'page-title text-center' },
                  this.state.current
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-4 text-right' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-primary', onClick: this.next },
                  this.state.next,
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-chevron-right' })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.Escalas.ListaDeEscalas.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Escalas.ListaDeEscalas.tabela.semEscalasEsteMes }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.Escalas.ListaDeEscalas.tabela.ID
              ),
              this.state.show_fleet == 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'aircraft_model', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '100' },
                this.locale.Escalas.ListaDeEscalas.tabela.Frota
              ),
              this.state.show_base == 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'base', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '100' },
                this.locale.Escalas.ListaDeEscalas.tabela.Base
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'reference', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '150' },
                this.locale.Escalas.ListaDeEscalas.tabela.Referencia
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '200' },
                this.locale.Escalas.ListaDeEscalas.tabela.Acoes
              )
            )
          )
        )
      );
    }
  }]);

  return SchedulesIndex;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SchedulesIndex);

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var SettingsEdit = function (_Component) {
  _inherits(SettingsEdit, _Component);

  function SettingsEdit(props) {
    var _this$state;

    _classCallCheck(this, SettingsEdit);

    var _this = _possibleConstructorReturn(this, (SettingsEdit.__proto__ || Object.getPrototypeOf(SettingsEdit)).call(this, props));

    _this.state = (_this$state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      warning_points: 0,
      danger_points: 0,
      daily_points: 0,
      day_off_points: 0,
      primary_points: 0,
      fatigue_setting_primary_points: 0,
      fatigue_setting_warning_points: 0,
      fatigue_setting_danger_points: 0,
      fatigue_setting_daily_points: 0,
      fatigue_setting_day_off_points: 0,
      fatigue_setting_daily_points_simulation: 0,
      limit_extra_hours_week: 0,
      limit_extra_hours_month: 0,
      day_limit_extra_hours_week: 0,
      day_limit_extra_hours_month: 0,
      regular_hours: 0,
      minimum_day_off: 0,
      hour_points: 0,
      day_points: 0,
      rest_points: 0
    }, _defineProperty(_this$state, 'day_off_points', 0), _defineProperty(_this$state, 'fatigue_setting_applicability_id', ''), _defineProperty(_this$state, 'fatigue_setting_id', ''), _defineProperty(_this$state, 'applicabilities', ''), _defineProperty(_this$state, 'applicabilities_list', []), _defineProperty(_this$state, 'limits_task_list', []), _defineProperty(_this$state, 'tasks_list', []), _defineProperty(_this$state, 'fatigue_settings', {}), _defineProperty(_this$state, 'applicability_tasks', {}), _defineProperty(_this$state, 'modal', false), _this$state);

    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.addTasks = _this.addTasks.bind(_this);
    _this.add = _this.add.bind(_this);
    _this.edit = _this.edit.bind(_this);
    _this.showModal = _this.showModal.bind(_this);
    _this.delete = _this.delete.bind(_this);
    _this.deleteRow = _this.deleteRow.bind(_this);
    _this.deleteTask = _this.deleteTask.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(SettingsEdit, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleSelectChangeFatigueApplicability',
    value: function handleSelectChangeFatigueApplicability(name, event) {
      if (event == null) {
        this.setState({
          fatigue_setting_applicability_id: this.state.fatigue_setting_applicability_id,
          fatigue_setting_applicability_label: this.state.fatigue_setting_applicability_label
        });
      } else {
        this.setState({
          fatigue_setting_applicability_id: event.value,
          fatigue_setting_applicability_label: event.label
        });
      }
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeMulti',
    value: function handleSelectChangeMulti(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
    //LM

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'showModal',
    value: function showModal(event) {
      var self = this;
      var fatigue_setting_id = event.currentTarget.value;

      var data = self.state.fatigue_settings;
      data.map(function (dado, index) {
        if (dado.id == fatigue_setting_id) {
          self.setState({
            fatigue_setting_primary_points: dado.primary_points,
            fatigue_setting_warning_points: dado.warning_points,
            fatigue_setting_danger_points: dado.danger_points,
            fatigue_setting_daily_points: dado.daily_points,
            fatigue_setting_day_off_points: dado.day_off_points,
            fatigue_setting_daily_points_simulation: dado.daily_points_simulation,
            fatigue_setting_applicability_id: dado.applicability_id,
            fatigue_setting_applicability_label: dado.name,
            fatigue_setting_id: dado.id,
            applicability_tasks: dado.applicability_tasks,
            modal: true
          });
        }
      });
    }
  }, {
    key: 'loadData',
    value: function loadData(event) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/configuracoes/fadiga';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url', '/parametros-de-fadiga');
          if (responseJson.status === 'success') {
            self.setState({
              fatigue_settings: responseJson.data.fatigue_settings,
              applicabilities_list: responseJson.data.applicabilities,
              tasks_list: responseJson.data.tasks_list,
              limits_task_list: responseJson.data.limits_task_list
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          if (typeof event === 'undefined') {
            self.handleMessage();
          } else {
            self.handleAlert(event.message, event.status, 'open');
          }
        });
      });
    }

    // Fetch salvando a adição de task

  }, {
    key: 'addTasks',
    value: function addTasks(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        applicability_id: this.state.fatigue_setting_applicability_id,
        task_id: this.state.task_id,
        limit_task: this.state.limit_task,
        text: this.state.text
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aplicabilidade/tarefas/restricao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.handleAlert(responseJson.message, responseJson.status, 'open');
          if (responseJson.status === 'success') {
            self.setState({
              fatigue_settings: responseJson.data
            });
            var data = responseJson.data;
            data.map(function (dado, index) {
              if (dado.id == self.state.fatigue_setting_id) {
                self.setState({
                  fatigue_setting_primary_points: dado.primary_points,
                  fatigue_setting_warning_points: dado.warning_points,
                  fatigue_setting_danger_points: dado.danger_points,
                  fatigue_setting_daily_points: dado.daily_points,
                  fatigue_setting_day_off_points: dado.day_off_points,
                  fatigue_setting_daily_points_simulation: dado.daily_points_simulation,
                  fatigue_setting_applicability_id: dado.applicability_id,
                  fatigue_setting_applicability_label: dado.name,
                  fatigue_setting_id: dado.id,
                  applicability_tasks: dado.applicability_tasks,
                  modal: true
                });
              }
            });
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
    // Fetch salvando a adição

  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        daily_points_simulation: this.state.daily_points_simulation,
        warning_points: this.state.warning_points,
        danger_points: this.state.danger_points,
        daily_points: this.state.daily_points,
        day_off_points: this.state.day_off_points,
        primary_points: this.state.primary_points,
        applicabilities: this.state.applicabilities
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/configuracoes/fadiga', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.handleAlert(responseJson.message, responseJson.status, 'open');
          if (responseJson.status === 'success') {
            self.setState({
              fatigue_settings: responseJson.data
            });
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
    // Fetch salvando a edição

  }, {
    key: 'edit',
    value: function edit(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        id: this.state.fatigue_setting_id,
        warning_points: this.state.fatigue_setting_warning_points,
        danger_points: this.state.fatigue_setting_danger_points,
        daily_points: this.state.fatigue_setting_daily_points,
        day_off_points: this.state.fatigue_setting_day_off_points,
        daily_points_simulation: this.state.fatigue_setting_daily_points_simulation,
        primary_points: this.state.fatigue_setting_primary_points,
        applicability_id: this.state.fatigue_setting_applicability_id,
        applicability_label: this.state.fatigue_setting_applicability_label
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/configuracoes/fadiga', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.handleAlert(responseJson.message, responseJson.status, 'open');
          if (responseJson.status === 'success') {
            self.setState({
              fatigue_settings: responseJson.data
            });
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'delete',
    value: function _delete(event) {
      var fatigue_setting_id = event.currentTarget.value;
      var confirm = window.confirm(this.locale.Configuracoes.EditarConfiguracoes.deletarConfiguracao);
      if (confirm) {
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/configuracoes/fadiga/' + fatigue_setting_id, { method: 'DELETE', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.deleteRow(fatigue_setting_id);
              self.loadData();
            }
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'deleteRow',
    value: function deleteRow(fatigue_setting_id) {
      var data = this.state.fatigue_settings;
      data.map(function (dado, index) {
        if (dado.id == fatigue_setting_id) {
          data.splice(index, 1);
        }
      });
      this.setState({ fatigue_settings: data });
    }
  }, {
    key: 'deleteTask',
    value: function deleteTask(event) {
      var applicability_task_id = event.currentTarget.value;
      var confirm = window.confirm(this.locale.Configuracoes.EditarConfiguracoes.deletarTarefa);
      if (confirm) {
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aplicabilidade/tarefa/restricao/' + applicability_task_id, { method: 'DELETE', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.setState({
                fatigue_settings: responseJson.data
              });
              var data = responseJson.data;
              data.map(function (dado, index) {
                if (dado.id == self.state.fatigue_setting_id) {
                  self.setState({
                    fatigue_setting_primary_points: dado.primary_points,
                    fatigue_setting_warning_points: dado.warning_points,
                    fatigue_setting_danger_points: dado.danger_points,
                    fatigue_setting_daily_points: dado.daily_points,
                    fatigue_setting_day_off_points: dado.day_off_points,
                    fatigue_setting_daily_points_simulation: dado.daily_points_simulation,
                    fatigue_setting_applicability_id: dado.applicability_id,
                    fatigue_setting_applicability_label: dado.name,
                    fatigue_setting_id: dado.id,
                    applicability_tasks: dado.applicability_tasks,
                    modal: true
                  });
                }
              });
            }
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.Configuracoes.EditarConfiguracoes.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.add },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Configuracoes.EditarConfiguracoes.formulario.AplicabilidadeTipoDeColaborador,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'applicabilities',
                      value: this.state.applicabilities,
                      searchable: true,
                      placeholder: this.locale.Configuracoes.EditarConfiguracoes.formulario.placeholder.SelecionarAplicabilidade,
                      onChange: this.handleSelectChangeMulti.bind(this, 'applicabilities'),
                      options: this.state.applicabilities_list,
                      multi: true
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Configuracoes.EditarConfiguracoes.formulario.LimiteDePontosZonaVerde,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'primary_points', className: 'form-control', placeholder: '', value: this.state.primary_points, onChange: this.handleChange.bind(this, 'primary_points') })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Configuracoes.EditarConfiguracoes.formulario.LimiteDePontosZonaAmarela,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'warning_points', className: 'form-control', placeholder: '', value: this.state.warning_points, onChange: this.handleChange.bind(this, 'warning_points') })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Configuracoes.EditarConfiguracoes.formulario.LimiteDePontosZonaVermelha,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'danger_points', className: 'form-control', placeholder: '', value: this.state.danger_points, onChange: this.handleChange.bind(this, 'danger_points') })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Configuracoes.EditarConfiguracoes.formulario.LimiteDePontosDiario,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'daily_points', className: 'form-control', placeholder: '', value: this.state.daily_points, onChange: this.handleChange.bind(this, 'daily_points') })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Configuracoes.EditarConfiguracoes.formulario.PontuacaoPorDiaDeFolga,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'day_off_points', className: 'form-control', placeholder: '', value: this.state.day_off_points, onChange: this.handleChange.bind(this, 'day_off_points') })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Configuracoes.EditarConfiguracoes.formulario.PontuacaoDiariaMediaParaSimulacao,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'daily_points_simulation', className: 'form-control', placeholder: '', value: this.state.daily_points_simulation, onChange: this.handleChange.bind(this, 'daily_points_simulation') })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                    ' ',
                    this.locale.general.salvarEdicao
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              this.locale.Configuracoes.EditarConfiguracoes.tituloConfiguracoesDePontuacao
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'table',
              { className: 'table' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'thead',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    '#'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    this.locale.Configuracoes.EditarConfiguracoes.tabelaConfiguracoesDePontuacao.TipoDeColaborador
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    this.locale.Configuracoes.EditarConfiguracoes.tabelaConfiguracoesDePontuacao.Acoes
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tbody',
                { id: 'configuracoes' },
                Object.keys(self.state.fatigue_settings).map(function (k) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      self.state.fatigue_settings[k].id
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      self.state.fatigue_settings[k].name
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { className: 'btn btn-primary btn-sm', value: self.state.fatigue_settings[k].id, onClick: self.showModal },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { className: 'btn btn-sm btn-danger', value: self.state.fatigue_settings[k].id, onClick: self.delete },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-trash' })
                      )
                    )
                  );
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["g" /* Modal */],
              { show: this.state.modal, bsSize: 'large', 'aria-labelledby': 'contained-modal-title-lg' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["g" /* Modal */].Header,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h4',
                  { className: 'pull-left' },
                  this.locale.Configuracoes.EditarConfiguracoes.tituloEditarConfiguracao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                      return _this2.setState({ modal: false });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["g" /* Modal */].Body,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'form',
                  { onSubmit: this.edit },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'col-md-6' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'form-group' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'label',
                          null,
                          this.locale.Configuracoes.EditarConfiguracoes.formularioEditarConfiguracao.AplicabilidadeTipoDeColaborador,
                          ':'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], {
                          className: 'form-field-name',
                          name: 'fatigue_setting_applicability_id',
                          value: this.state.fatigue_setting_applicability_id,
                          searchable: true,
                          placeholder: this.locale.Configuracoes.EditarConfiguracoes.formularioEditarConfiguracao.placeholder.SelecionarAplicabilidade,
                          onChange: this.handleSelectChangeFatigueApplicability.bind(this, 'fatigue_setting_applicability_id'),
                          options: this.state.applicabilities_list
                        })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'col-md-6' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'form-group' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'label',
                          null,
                          this.locale.Configuracoes.EditarConfiguracoes.formularioEditarConfiguracao.LimiteDePontosZonaVerde,
                          ':'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'fatigue_setting_primary_points', className: 'form-control', placeholder: '', value: this.state.fatigue_setting_primary_points, onChange: this.handleChange.bind(this, 'fatigue_setting_primary_points') })
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'col-md-6' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'form-group' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'label',
                          null,
                          this.locale.Configuracoes.EditarConfiguracoes.formularioEditarConfiguracao.LimiteDePontosZonaAmarela,
                          ':'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'fatigue_setting_warning_points', className: 'form-control', placeholder: '', value: this.state.fatigue_setting_warning_points, onChange: this.handleChange.bind(this, 'fatigue_setting_warning_points') })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'col-md-6' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'form-group' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'label',
                          null,
                          this.locale.Configuracoes.EditarConfiguracoes.formularioEditarConfiguracao.LimiteDePontosZonaVermelha,
                          ':'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'fatigue_setting_danger_points', className: 'form-control', placeholder: '', value: this.state.fatigue_setting_danger_points, onChange: this.handleChange.bind(this, 'fatigue_setting_danger_points') })
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'col-md-6' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'form-group' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'label',
                          null,
                          this.locale.Configuracoes.EditarConfiguracoes.formularioEditarConfiguracao.LimiteDePontosDiario,
                          ':'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'fatigue_setting_daily_points', className: 'form-control', placeholder: '', value: this.state.fatigue_setting_daily_points, onChange: this.handleChange.bind(this, 'fatigue_setting_daily_points') })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'col-md-6' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'form-group' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'label',
                          null,
                          this.locale.Configuracoes.EditarConfiguracoes.formularioEditarConfiguracao.PontuacaoPorDiaDeFolga,
                          ':'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'fatigue_setting_day_off_points', className: 'form-control', placeholder: '', value: this.state.fatigue_setting_day_off_points, onChange: this.handleChange.bind(this, 'fatigue_setting_day_off_points') })
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'col-md-6' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'form-group' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'label',
                          null,
                          this.locale.Configuracoes.EditarConfiguracoes.formularioEditarConfiguracao.PontuacaoDiariaMediaParaSimulacao,
                          ':'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'number', name: 'fatigue_setting_daily_points_simulation', className: 'form-control', placeholder: '', value: this.state.fatigue_setting_daily_points_simulation, onChange: this.handleChange.bind(this, 'fatigue_setting_daily_points_simulation') })
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'col-md-12' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                        ' ',
                        this.locale.general.salvarEdicao
                      )
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h4',
                  null,
                  this.locale.Configuracoes.EditarConfiguracoes.tituloTarefasDeRestricao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'form',
                  { onSubmit: this.addTasks },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'col-md-6' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'form-group' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'label',
                          null,
                          this.locale.Configuracoes.EditarConfiguracoes.formularioTarefasDeRestricao.Tarefa,
                          ':'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], {
                          className: 'form-field-name',
                          name: 'task_id',
                          value: this.state.task_id,
                          searchable: true,
                          placeholder: this.locale.Configuracoes.EditarConfiguracoes.formularioTarefasDeRestricao.placeholder.SelecionarAplicabilidade,
                          onChange: this.handleSelectChangeMulti.bind(this, 'task_id'),
                          options: this.state.tasks_list
                        })
                      )
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'col-md-6' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'form-group' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'label',
                          null,
                          this.locale.Configuracoes.EditarConfiguracoes.formularioTarefasDeRestricao.LimiteDaRestricao,
                          ':'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_select__["a" /* default */], {
                          className: 'form-field-name',
                          name: 'limit_task',
                          value: this.state.limit_task,
                          searchable: true,
                          placeholder: this.locale.Configuracoes.EditarConfiguracoes.formularioTarefasDeRestricao.placeholder.SelecionarLimite,
                          onChange: this.handleSelectChangeMulti.bind(this, 'limit_task'),
                          options: this.state.limits_task_list
                        })
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'col-md-6' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'form-group' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'label',
                          null,
                          this.locale.Configuracoes.EditarConfiguracoes.formularioTarefasDeRestricao.Restricao,
                          ':'
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'text', className: 'form-control', placeholder: this.locale.Configuracoes.EditarConfiguracoes.formularioTarefasDeRestricao.placeholder.Restricao, value: this.state.text, onChange: this.handleChange.bind(this, 'text') })
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'row' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'col-md-12' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                        ' ',
                        this.locale.Configuracoes.EditarConfiguracoes.formularioTarefasDeRestricao.botaoCadastrarTarefa
                      )
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h4',
                  null,
                  this.locale.Configuracoes.EditarConfiguracoes.tituloTarefasDaAplicabilidade
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'table',
                  { className: 'table' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'thead',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        null,
                        '#'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        null,
                        this.locale.Configuracoes.EditarConfiguracoes.tabelaTarefasDaAplicabilidade.Limite
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        null,
                        this.locale.Configuracoes.EditarConfiguracoes.tabelaTarefasDaAplicabilidade.Tarefa
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        null,
                        this.locale.Configuracoes.EditarConfiguracoes.tabelaTarefasDaAplicabilidade.Restricao
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        null,
                        this.locale.Configuracoes.EditarConfiguracoes.tabelaTarefasDaAplicabilidade.Acoes
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tbody',
                    { id: 'tasks' },
                    Object.keys(self.state.applicability_tasks).map(function (k) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'tr',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'td',
                          null,
                          self.state.applicability_tasks[k].id
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'td',
                          null,
                          self.state.applicability_tasks[k].limit_label
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'td',
                          null,
                          self.state.applicability_tasks[k].task_label
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'td',
                          null,
                          self.state.applicability_tasks[k].limit_restriction
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'td',
                          null,
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'button',
                            { className: 'btn btn-sm btn-danger', value: self.state.applicability_tasks[k].id, onClick: self.deleteTask },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-trash' })
                          )
                        )
                      );
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["g" /* Modal */].Footer,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                      return _this2.setState({ modal: false });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return SettingsEdit;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SettingsEdit);

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário




var StaffAbsencesTab = function (_Component) {
  _inherits(StaffAbsencesTab, _Component);

  function StaffAbsencesTab(props) {
    _classCallCheck(this, StaffAbsencesTab);

    var _this = _possibleConstructorReturn(this, (StaffAbsencesTab.__proto__ || Object.getPrototypeOf(StaffAbsencesTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      staff_id: _this.props.staff_id,
      absence_id: null,
      date_start: '',
      date_finish: '',
      staff_absences: [],
      absences_list: []
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.ativar = this.ativar.bind(this);
    // this.desativar = this.desativar.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);
    _this.refreshDataActive = _this.refreshDataActive.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }
  // handleToggleChange (name, event) {
  //   var change = {};
  //   if (event.target.checked === true) {
  //     var value = 1;
  //   } else {
  //     var value = 0;
  //   }
  //   change[name] = value;
  //   this.setState(change);
  // }

  // LM


  _createClass(StaffAbsencesTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.staff_absences)) {
        this.setState({
          staff_absences: newProps.staff_absences,
          absences_list: newProps.absences_list,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     absence_id: this.state.absence_id,
    //     date_start: this.state.date_start,
    //     date_finish: this.state.date_finish,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/afastamento', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.setState({ staff_absences: responseJson.data });
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }


    // // Fetch ativando um item
    // ativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar esse afastamento?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/afastamento/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_absences: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch deletando um item
    // desativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar esse afastamento?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/afastamento/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_absences: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/afastamentos/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ staff_absences: responseJson.data, only_active: 0 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'refreshDataActive',
    value: function refreshDataActive(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/afastamentos/ativas/' + self.state.staff_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_absences: responseJson.data, only_active: 1 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabAfastamentos.tituloAfastamento
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_absences === null || typeof this.state.staff_absences === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabAfastamentos.nenhumaAfastamentoCadastrada
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabAfastamentos.tabela.DataInicial
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabAfastamentos.tabela.DataFinal
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabAfastamentos.tabela.Motivo
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_absences).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_absences[k].date_start_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_absences[k].date_finish_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_absences[k].absence
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffAbsencesTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffAbsencesTab);

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário




var StaffAircraftModelsTab = function (_Component) {
  _inherits(StaffAircraftModelsTab, _Component);

  function StaffAircraftModelsTab(props) {
    _classCallCheck(this, StaffAircraftModelsTab);

    var _this = _possibleConstructorReturn(this, (StaffAircraftModelsTab.__proto__ || Object.getPrototypeOf(StaffAircraftModelsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      instruction: 0,
      instruction_subtype: 0,
      expiration: '',
      date_start: '',
      expiration_subtype: '',
      date_start_subtype: '',
      staff_id: _this.props.staff_id,
      aircraft_model_id: null,
      aircraft_model_subtype_id: null,
      staff_aircraft_models: [],
      aircraft_models_list: [],
      aircraft_model_subtypes_list: []
    };

    //bind específico
    // this.addAircraftModel = this.addAircraftModel.bind(this);
    // this.addAircraftModelSubtype = this.addAircraftModelSubtype.bind(this);
    // this.ativar = this.ativar.bind(this);
    // this.desativar = this.desativar.bind(this);
    // this.addToRevision = this.addToRevision.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);
    _this.refreshDataActive = _this.refreshDataActive.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // }
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }
  // handleToggleChange (name, event) {
  //   var change = {};
  //   if (event.target.checked === true) {
  //     var value = 1;
  //   } else {
  //     var value = 0;
  //   }
  //   change[name] = value;
  //   this.setState(change);
  // }

  // LM


  _createClass(StaffAircraftModelsTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.staff_aircraft_models)) {
        this.setState({
          staff_aircraft_models: newProps.staff_aircraft_models,
          aircraft_models_list: newProps.aircraft_models_list,
          aircraft_model_subtypes_list: newProps.aircraft_model_subtypes_list,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição
    // addAircraftModel(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     aircraft_model_id: this.state.aircraft_model_id,
    //     date_start: this.state.date_start,
    //     expiration: this.state.expiration,
    //     instruction: this.state.instruction,
    //     only_active: this.state.only_active,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/frota', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.refreshData();
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // // Fetch salvando a edição
    // addAircraftModelSubtype(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     aircraft_model_subtype_id: this.state.aircraft_model_subtype_id,
    //     date_start_subtype: this.state.date_start_subtype,
    //     expiration_subtype: this.state.expiration_subtype,
    //     instruction_subtype: this.state.instruction_subtype,
    //     only_active: this.state.only_active,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/frota', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.refreshData();
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // // Fetch ativando um item
    // ativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar essa frota?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       staff_id: this.state.staff_id,
    //       only_active: this.state.only_active,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/frota/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.refreshData();
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

    // // Fetch deletando um item
    // desativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar essa frota?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       staff_id: this.state.staff_id,
    //       only_active: this.state.only_active,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/frota/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.refreshData();
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/frotas/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ staff_aircraft_models: responseJson.data, only_active: 0 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'refreshDataActive',
    value: function refreshDataActive(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/frotas/ativas/' + self.state.staff_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_aircraft_models: responseJson.data, only_active: 1 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
    // addToRevision(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de associar essa frota a uma revisão de designação aberta?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/revisao/frota', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }


  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasDesignadas.tituloFrotasDesignadas
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_aircraft_models === null || typeof this.state.staff_aircraft_models === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasDesignadas.nenhumaFrotaCadastrada
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasDesignadas.tabela.Aeronave
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasDesignadas.tabela.Subtipo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasDesignadas.tabela.Vencimento
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasDesignadas.tabela.Instrucao,
                  '?'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasDesignadas.tabela.Status
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_aircraft_models).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_aircraft_models[k].aircraft_model
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_aircraft_models[k].aircraft_model_subtype
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_aircraft_models[k].expiration_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_aircraft_models[k].instruction_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_aircraft_models[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasDesignadas.tabela.Ativo
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasDesignadas.tabela.Arquivado
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffAircraftModelsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffAircraftModelsTab);

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário



var StaffAircraftsTab = function (_Component) {
  _inherits(StaffAircraftsTab, _Component);

  function StaffAircraftsTab(props) {
    _classCallCheck(this, StaffAircraftsTab);

    var _this = _possibleConstructorReturn(this, (StaffAircraftsTab.__proto__ || Object.getPrototypeOf(StaffAircraftsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      staff_id: _this.props.staff_id,
      aircraft_id: null,
      date_start: '',
      staff_aircrafts: [],
      aircrafts_list: []
    };

    //bind específico
    _this.add = _this.add.bind(_this);
    _this.refreshData = _this.refreshData.bind(_this);
    _this.refreshDataActive = _this.refreshDataActive.bind(_this);
    _this.ativar = _this.ativar.bind(_this);
    _this.desativar = _this.desativar.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(StaffAircraftsTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.staff_aircrafts)) {
        this.setState({
          staff_aircrafts: newProps.staff_aircrafts,
          aircrafts_list: newProps.aircrafts_list,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição

  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var datasave = {
        staff_id: this.state.staff_id,
        aircraft_id: this.state.aircraft_id,
        date_start: this.state.date_start
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/aeronave', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ staff_aircrafts: responseJson.data });
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }

    // Fetch ativando um item

  }, {
    key: 'ativar',
    value: function ativar(event) {
      var id = event.currentTarget.value;
      var confirm = window.confirm('Tem certeza que gostaria de ativar essa aeronave?');
      if (confirm) {
        this.props.handleAlert('', '', 'open');
        var datasave = {
          id: id,
          only_active: this.state.only_active,
          staff_id: this.state.staff_id
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/aeronave/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({ staff_aircrafts: responseJson.data });
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }

    // Fetch deletando um item

  }, {
    key: 'desativar',
    value: function desativar(event) {
      var id = event.currentTarget.value;
      var confirm = window.confirm('Tem certeza que gostaria de arquivar essa aeronave?');
      if (confirm) {
        this.props.handleAlert('', '', 'open');
        var datasave = {
          id: id,
          only_active: this.state.only_active,
          staff_id: this.state.staff_id
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/aeronave/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({ staff_aircrafts: responseJson.data });
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/aeronaves/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ staff_aircrafts: responseJson.data, only_active: 0 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'refreshDataActive',
    value: function refreshDataActive(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/aeronaves/ativas/' + self.state.staff_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_aircrafts: responseJson.data, only_active: 1 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          'Aeronaves'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_aircrafts === null || typeof this.state.staff_aircrafts === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              'Nenhuma aeronave cadastrada.'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Data Inicial'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Aeronave'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Status'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'col-md-1 text-center' },
                  'A\xE7\xF5es'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_aircrafts).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_aircrafts[k].date_start_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_aircrafts[k].aircraft
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_aircrafts[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      'ativo'
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      'arquivado'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_aircrafts[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { className: 'btn btn-sm btn-danger', value: self.state.staff_aircrafts[k].id, onClick: self.desativar },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-power-off' })
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { className: 'btn btn-sm btn-success', value: self.state.staff_aircrafts[k].id, onClick: self.ativar },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-power-off' })
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          'Adicionar aeronave'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: this.add },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Aeronave:'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'aircraft_id',
                value: this.state.aircraft_id,
                searchable: true,
                placeholder: '',
                onChange: this.handleSelectChange.bind(this, 'aircraft_id'),
                options: this.state.aircrafts_list
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Data inicial:'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.date_start, maskChar: null, name: 'date_start', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: '' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
            ' Salvar aeronave'
          )
        )
      );
    }
  }]);

  return StaffAircraftsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (StaffAircraftsTab);

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário


var StaffAttestationsTab = function (_Component) {
  _inherits(StaffAttestationsTab, _Component);

  function StaffAttestationsTab(props) {
    _classCallCheck(this, StaffAttestationsTab);

    var _this = _possibleConstructorReturn(this, (StaffAttestationsTab.__proto__ || Object.getPrototypeOf(StaffAttestationsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      staff_id: _this.props.staff_id,
      date: '',
      expiration: '',
      staff_attestations: []
    };

    //bind específico
    _this.add = _this.add.bind(_this);
    _this.refreshData = _this.refreshData.bind(_this);
    _this.refreshDataActive = _this.refreshDataActive.bind(_this);
    _this.ativar = _this.ativar.bind(_this);
    _this.desativar = _this.desativar.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(StaffAttestationsTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.staff_attestations)) {
        this.setState({
          staff_attestations: newProps.staff_attestations,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição

  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var datasave = {
        staff_id: this.state.staff_id,
        date: this.state.date,
        expiration: this.state.expiration
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/aso', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ staff_attestations: responseJson.data });
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }

    // Fetch ativando um item

  }, {
    key: 'ativar',
    value: function ativar(event) {
      var id = event.currentTarget.value;
      var confirm = window.confirm('Tem certeza que gostaria de ativar esse aso?');
      if (confirm) {
        this.props.handleAlert('', '', 'open');
        var datasave = {
          id: id,
          only_active: this.state.only_active,
          staff_id: this.state.staff_id
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/aso/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({ staff_attestations: responseJson.data });
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }

    // Fetch deletando um item

  }, {
    key: 'desativar',
    value: function desativar(event) {
      var id = event.currentTarget.value;
      var confirm = window.confirm('Tem certeza que gostaria de arquivar esse aso?');
      if (confirm) {
        this.props.handleAlert('', '', 'open');
        var datasave = {
          id: id,
          only_active: this.state.only_active,
          staff_id: this.state.staff_id
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/aso/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({ staff_attestations: responseJson.data });
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/aso/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ staff_attestations: responseJson.data, only_active: 0 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'refreshDataActive',
    value: function refreshDataActive(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/aso/ativas/' + self.state.staff_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_attestations: responseJson.data, only_active: 1 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          'ASO'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_attestations === null || typeof this.state.staff_attestations === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              'Nenhuma aso cadastrado.'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Data do exame'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Vencimento'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Status'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'col-md-1 text-center' },
                  'A\xE7\xF5es'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_attestations).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_attestations[k].date_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_attestations[k].expiration_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_attestations[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      'ativo'
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      'arquivado'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_attestations[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { className: 'btn btn-sm btn-danger', value: self.state.staff_attestations[k].id, onClick: self.desativar },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-power-off' })
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { className: 'btn btn-sm btn-success', value: self.state.staff_attestations[k].id, onClick: self.ativar },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-power-off' })
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          'Adicionar aso'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: this.add },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Data do exame:'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.date, maskChar: null, name: 'date', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Vencimento:'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.expiration, maskChar: null, name: 'expiration', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'expiration'), placeholder: '' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
            ' Adicionar aso'
          )
        )
      );
    }
  }]);

  return StaffAttestationsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (StaffAttestationsTab);

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário




var StaffBasesTab = function (_Component) {
  _inherits(StaffBasesTab, _Component);

  function StaffBasesTab(props) {
    _classCallCheck(this, StaffBasesTab);

    var _this = _possibleConstructorReturn(this, (StaffBasesTab.__proto__ || Object.getPrototypeOf(StaffBasesTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      staff_id: _this.props.staff_id,
      base_id: null,
      date_start: '',
      staff_bases: [],
      bases_list: []
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.ativar = this.ativar.bind(this);
    // this.desativar = this.desativar.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);
    _this.refreshDataActive = _this.refreshDataActive.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }

  // LM


  _createClass(StaffBasesTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.staff_bases)) {
        this.setState({
          staff_bases: newProps.staff_bases,
          bases_list: newProps.bases_list,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     base_id: this.state.base_id,
    //     date_start: this.state.date_start,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/base', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.setState({ staff_bases: responseJson.data });
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }


    // // Fetch ativando um item
    // ativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar essa base?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/base/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_bases: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch deletando um item
    // desativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar essa base?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/base/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_bases: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/bases/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ staff_bases: responseJson.data, only_active: 0 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'refreshDataActive',
    value: function refreshDataActive(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/bases/ativas/' + self.state.staff_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_bases: responseJson.data, only_active: 1 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabBases.tituloBases
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_bases === null || typeof this.state.staff_bases === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabBases.nenhumaBaseCadastrada
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabBases.tabela.DataInicial
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabBases.tabela.Aase
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabBases.tabela.Atatus
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_bases).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_bases[k].date_start_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_bases[k].base
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_bases[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabBases.tabela.Ativo
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabBases.tabela.Arquivado
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffBasesTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffBasesTab);

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário





var StaffCertificationsTab = function (_Component) {
  _inherits(StaffCertificationsTab, _Component);

  function StaffCertificationsTab(props) {
    _classCallCheck(this, StaffCertificationsTab);

    var _this = _possibleConstructorReturn(this, (StaffCertificationsTab.__proto__ || Object.getPrototypeOf(StaffCertificationsTab)).call(this, props));

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      staff_id: _this.props.staff_id,
      name: null,
      type: null,
      only_active: 1,
      designacoes: 0,
      expiration: '',
      dispatch: '',
      staff_certifications: [],
      simple_list: [{ value: 1, label: _this.locale.general.sim }, { value: 0, label: _this.locale.general.nao }],
      certifications_list: []
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.refreshSupplierSelect = this.refreshSupplierSelect.bind(this);
    // this.ativar = this.ativar.bind(this);
    // this.desativar = this.desativar.bind(this);
    // this.editFile = this.editFile.bind(this);
    // this.delete = this.delete.bind(this);
    _this.exportGenerate = _this.exportGenerate.bind(_this);
    _this.refreshData = _this.refreshData.bind(_this);
    _this.refreshDataActive = _this.refreshDataActive.bind(_this);
    return _this;
  }

  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChangeCertification(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //     this.setState(change, this.clearSupplierList());
  //   } else {
  //     change[name] = event.value;
  //     this.setState(change, this.refreshSupplierSelect(event.value));
  //   }
  // }
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }

  // LM


  _createClass(StaffCertificationsTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.staff_certifications)) {
        this.setState({
          staff_certifications: newProps.staff_certifications,
          certifications_list: newProps.certifications_list,
          loaded: 1
        });
      }
    }

    // clearSupplierList (name, event) {
    //   this.setState({ certification_suppliers_list: [] });
    // } 

    // // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     certification_id: this.state.certification_id,
    //     certification_supplier_id: this.state.certification_supplier_id,
    //     date_start: this.state.date_start,
    //     date_finish: this.state.date_finish,
    //     result: this.state.result,
    //     pf: this.state.pf,
    //     expire: this.state.expire,
    //     designacoes: this.state.designacoes,
    //     type: this.state.type,
    //     emissao: this.state.emissao,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/certificado', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.refreshData();
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

  }, {
    key: 'exportGenerate',
    value: function exportGenerate(event) {
      var self = this;
      var staff_certification_id = event;
      var url = '/exportar/certificado/colaborador/';
      var header = this.refs.request_api.header('application/json');
      self.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + url + staff_certification_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data);
          }
          self.props.handleAlert('', '', 'closed');
        });
      });
    }
  }, {
    key: 'export',
    value: function _export(event) {
      var self = this;
      var staff_certification_id = event;
      var url = '/exportar/certificado/arquivo/colaborador/';
      var header = this.refs.request_api.header('application/json');
      self.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + url + staff_certification_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/uploads/certifications/' + responseJson.data);
          }
          self.props.handleAlert('', '', 'closed');
        });
      });
    }

    // Fetch ativando um item
    // ativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar esse certificado?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/certificado/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_certifications: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch deletando um item
    // editFile(staff_certification_id) {
    //   var confirm = window.confirm('Tem certeza que gostaria de adicionar/editar o arquivo desse certificado?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var data = new FormData();
    //     let input = '.input-sc-' + staff_certification_id;
    //     var import_data = document.querySelector(input).files[0];
    //     data.append("file", import_data);
    //     data.append("id", staff_certification_id);
    //     var header = this.refs.request_api.header();
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/certificado/editar/arquivo', { method: 'POST', mode: 'cors', headers: value, body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.refreshData();
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }  
    // // Fetch deletando um item
    // desativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar esse certificado?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/certificado/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_certifications: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // refreshSupplierSelect (event) {
    //   this.props.handleAlert('', '', 'open');
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/certificado/fornecedores/lista/' + event, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       if (responseJson.status === 'success') {
    //         self.setState({certification_suppliers_list: responseJson.data});
    //       }
    //       if(typeof event.message !== 'undefined') {
    //         self.props.handleAlert(event.message, event.status, 'open');
    //       } else {
    //         self.props.handleAlert("", "", 'closed');
    //       }
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/certificados/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ staff_certifications: responseJson.data, only_active: 0 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'refreshDataActive',
    value: function refreshDataActive(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/certificados/ativos/' + self.state.staff_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_certifications: responseJson.data, only_active: 1 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }

    // delete($staff_certification_id) {
    //   var confirm = window.confirm('Tem certeza que deseja deletar esse certificado?');
    //   if (confirm) {
    //     var self = this;
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/certificado/' + $staff_certification_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.refreshData(responseJson);
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTreinamentos.tituloCertificados
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_certifications === null || typeof this.state.staff_certifications === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTreinamentos.nenhumCertificadoCadastrado
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTreinamentos.tabela.ID
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTreinamentos.tabela.Tipo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTreinamentos.tabela.Fim
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTreinamentos.tabela.Vencimento
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTreinamentos.tabela.Val
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTreinamentos.tabela.Status
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTreinamentos.tabela.Acoes
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_certifications).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_certifications[k].id
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_certifications[k].certification
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_certifications[k].date_finish_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_certifications[k].expire_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_certifications[k].expire_status_str === 'Expirado' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      { className: 'label label-sm label-danger' },
                      self.state.staff_certifications[k].expire_status_str
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      { className: 'label label-sm label-success' },
                      self.state.staff_certifications[k].expire_status_str
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_certifications[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTreinamentos.tabela.Ativo
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTreinamentos.tabela.Arquivado
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center', style: { whiteSpace: "nowrap" } },
                    self.state.staff_certifications[k].file !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { className: 'btn btn-sm btn-warning', onClick: function onClick() {
                          self.export(self.state.staff_certifications[k].id);
                        } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' })
                    ) : '',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { className: 'btn btn-info btn-sm', onClick: function onClick() {
                          self.exportGenerate(self.state.staff_certifications[k].id);
                        } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' })
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffCertificationsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffCertificationsTab);

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário



var StaffChecksTab = function (_Component) {
  _inherits(StaffChecksTab, _Component);

  function StaffChecksTab(props) {
    _classCallCheck(this, StaffChecksTab);

    var _this = _possibleConstructorReturn(this, (StaffChecksTab.__proto__ || Object.getPrototypeOf(StaffChecksTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      staff_id: _this.props.staff_id,
      base_id: null,
      checker_id: null,
      sae: '',
      gru: '',
      type: '',
      check_type: '',
      expiration: '',
      dispatch: '',
      date: '',
      hours: '',
      staff_checks: [],
      bases_list: [],
      staff_list: [],
      group_list: [{ value: "1", label: "AVI" }, { value: "2", label: "CEL" }, { value: "3", label: "GMP" }],
      type_list: [{ value: "CHT", label: "CHT" }, { value: "CCT", label: "CCT" }],
      check_type_list: [{ value: 0, label: "Cheque de inclusão" }, { value: 1, label: "Cheque inicial" }],
      simple_list: [{ value: 0, label: "Sim" }, { value: 1, label: "Não" }],
      certification_list: []
    };

    //bind específico
    _this.add = _this.add.bind(_this);
    _this.refreshData = _this.refreshData.bind(_this);
    _this.export = _this.export.bind(_this);
    _this.refreshDataActive = _this.refreshDataActive.bind(_this);
    _this.ativar = _this.ativar.bind(_this);
    _this.desativar = _this.desativar.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(StaffChecksTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
    // Handlers

  }, {
    key: 'handleSelectChangeGroup',
    value: function handleSelectChangeGroup(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.staff_checks)) {
        this.setState({
          staff_checks: newProps.staff_checks,
          bases_list: newProps.bases_list,
          staff_list: newProps.staff_list,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição

  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var datasave = {
        staff_id: this.state.staff_id,
        base_id: this.state.base_id,
        checker_id: this.state.checker_id,
        gru: this.state.gru,
        group: this.state.group,
        type: this.state.type,
        check_type: this.state.check_type,
        expiration: this.state.expiration,
        dispatch: this.state.dispatch,
        date: this.state.date,
        hours: this.state.hours
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/cheque', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ staff_checks: responseJson.data });
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }

    // Fetch ativando um item

  }, {
    key: 'ativar',
    value: function ativar(event) {
      var id = event.currentTarget.value;
      var confirm = window.confirm('Tem certeza que gostaria de ativar esse cheque?');
      if (confirm) {
        this.props.handleAlert('', '', 'open');
        var datasave = {
          id: id,
          only_active: this.state.only_active,
          staff_id: this.state.staff_id
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/cheque/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({ staff_checks: responseJson.data });
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }

    // Fetch deletando um item

  }, {
    key: 'desativar',
    value: function desativar(event) {
      var id = event.currentTarget.value;
      var confirm = window.confirm('Tem certeza que gostaria de arquivar esse cheque?');
      if (confirm) {
        this.props.handleAlert('', '', 'open');
        var datasave = {
          id: id,
          only_active: this.state.only_active,
          staff_id: this.state.staff_id
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/cheque/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({ staff_checks: responseJson.data });
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/cheques/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ staff_checks: responseJson.data, only_active: 0 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'refreshDataActive',
    value: function refreshDataActive(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/cheques/ativos/' + self.state.staff_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_checks: responseJson.data, only_active: 1 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'export',
    value: function _export(event) {
      var self = this;
      var staff_stamp_id = event;
      var url = '/exportar/cheque/colaborador/';
      var header = this.refs.request_api.header('application/json');
      self.setState({ overlay: { message: '', type: '', status: 'open' } });
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + url + staff_stamp_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data);
          }
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          'Cheques'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_checks === null || typeof this.state.staff_checks === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              'Nenhuma cheque cadastrada.'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'SAE'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Tipo'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Tipo de cheque'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Checador'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Base'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'AVI'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'CEL'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'GMP'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Vencimento'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Status'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'col-md-3 text-center' },
                  'A\xE7\xF5es'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_checks).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_checks[k].sae
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_checks[k].type
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_checks[k].check_type_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_checks[k].checador
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_checks[k].base
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_checks[k].avi
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_checks[k].cel
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_checks[k].gmp
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_checks[k].expiration_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_checks[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      'ativo'
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      'arquivado'
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_checks[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { className: 'btn btn-sm btn-danger', value: self.state.staff_checks[k].id, onClick: self.desativar },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-power-off' })
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { className: 'btn btn-sm btn-success', value: self.state.staff_checks[k].id, onClick: self.ativar },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-power-off' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { className: 'btn btn-info btn-sm', onClick: function onClick() {
                          self.export(self.state.staff_checks[k].id);
                        } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' })
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          'Adicionar cheque'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: this.add },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Tipo:'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'type',
                value: this.state.type,
                searchable: true,
                placeholder: '',
                onChange: this.handleSelectChange.bind(this, 'type'),
                options: this.state.type_list
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Tipo de cheque:'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'check_type',
                value: this.state.check_type,
                searchable: true,
                placeholder: '',
                onChange: this.handleSelectChange.bind(this, 'check_type'),
                options: this.state.check_type_list
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Checador:'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'checker_id',
                value: this.state.checker_id,
                searchable: true,
                placeholder: '',
                onChange: this.handleSelectChange.bind(this, 'checker_id'),
                options: this.state.staff_list
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Base:'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'base_id',
                value: this.state.base_id,
                searchable: true,
                placeholder: '',
                onChange: this.handleSelectChange.bind(this, 'base_id'),
                options: this.state.bases_list
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'GRU:'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', name: 'gru', value: this.state.gru, onChange: this.handleChange.bind(this, 'gru') })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Grupo:'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                className: 'form-field-name',
                name: 'group',
                value: this.state.group,
                searchable: true,
                multi: true,
                placeholder: '',
                onChange: this.handleSelectChangeGroup.bind(this, 'group'),
                options: this.state.group_list
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Data:'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.date, maskChar: null, name: 'date', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                'Hora:'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', name: 'hours', value: this.state.hours, onChange: this.handleChange.bind(this, 'hours') })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
            ' Adicionar cheque'
          )
        )
      );
    }
  }]);

  return StaffChecksTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (StaffChecksTab);

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário




var StaffContractualBasesTab = function (_Component) {
  _inherits(StaffContractualBasesTab, _Component);

  function StaffContractualBasesTab(props) {
    _classCallCheck(this, StaffContractualBasesTab);

    var _this = _possibleConstructorReturn(this, (StaffContractualBasesTab.__proto__ || Object.getPrototypeOf(StaffContractualBasesTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      only_active: 0,
      staff_id: _this.props.staff_id,
      base_id: null,
      date_start: '',
      staff_contractual_bases: [],
      bases_list: []
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.ativar = this.ativar.bind(this);
    // this.desativar = this.desativar.bind(this);
    // this.delete = this.delete.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);
    _this.refreshDataActive = _this.refreshDataActive.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }

  // LM


  _createClass(StaffContractualBasesTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.staff_contractual_bases)) {
        this.setState({
          staff_contractual_bases: newProps.staff_contractual_bases,
          bases_list: newProps.bases_list,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     base_id: this.state.base_id,
    //     only_active: this.state.only_active,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/base/contratual', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.setState({ staff_contractual_bases: responseJson.data });
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }


    // // Fetch ativando um item
    // ativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar essa base?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/base/contratual/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_contractual_bases: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch deletando um item
    // desativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar essa base?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/base/contratual/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_contractual_bases: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // delete(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de deletar essa base?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/base/contratual/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           self.refreshData(responseJson);
    //         }
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/bases/contratual/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ staff_contractual_bases: responseJson.data, only_active: 0 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'refreshDataActive',
    value: function refreshDataActive(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/bases/contratual/ativas/' + self.state.staff_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_contractual_bases: responseJson.data, only_active: 1 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabBaseContratual.tituloBases
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_contractual_bases === null || typeof this.state.staff_contractual_bases === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabBaseContratual.nenhumaBaseCadastrada
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabBaseContratual.tabela.Base
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_contractual_bases).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_contractual_bases[k].base
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffContractualBasesTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffContractualBasesTab);

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário


var StaffCostsTab = function (_Component) {
  _inherits(StaffCostsTab, _Component);

  function StaffCostsTab(props) {
    var _this$state;

    _classCallCheck(this, StaffCostsTab);

    var _this = _possibleConstructorReturn(this, (StaffCostsTab.__proto__ || Object.getPrototypeOf(StaffCostsTab)).call(this, props));

    _this.state = (_this$state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      staff_id: _this.props.staff_id,
      cost_center: null,
      date_start: ''
    }, _defineProperty(_this$state, 'only_active', 1), _defineProperty(_this$state, 'staff_costs', []), _this$state);

    //bind específico
    // this.add = this.add.bind(this);
    // this.ativar = this.ativar.bind(this);
    // this.desativar = this.desativar.bind(this);
    // this.delete = this.delete.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);
    _this.refreshDataActive = _this.refreshDataActive.bind(_this);
    return _this;
  }
  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // }
  // LM


  _createClass(StaffCostsTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.staff_costs)) {
        this.setState({
          staff_costs: newProps.staff_costs,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     cost_center: this.state.cost_center,
    //     only_active: this.state.only_active,
    //     date_start: this.state.date_start,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/custos', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.setState({ staff_costs: responseJson.data });
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // // Fetch ativando um item
    // ativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar esse centro de custo?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/custos/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_costs: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

    // // Fetch deletando um item
    // desativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar esse centro de custo?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/custos/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_costs: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/custos/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ staff_costs: responseJson.data, only_active: 0 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'refreshDataActive',
    value: function refreshDataActive(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/custos/ativas/' + self.state.staff_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_costs: responseJson.data, only_active: 1 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }

    // delete($staff_language_id) {
    //   var confirm = window.confirm('Tem certeza que deseja deletar esse centro de custo?');
    //   if (confirm) {
    //     var self = this;
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/custos/' + $staff_language_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.refreshData(responseJson);
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          'Centro de custo'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_costs === null || typeof this.state.staff_costs === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              'Nenhuma centro de custo cadastrado.'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Centro de custo'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Data In\xEDcio'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Status'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_costs).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_costs[k].cost_center
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_costs[k].date_start_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_costs[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      'ativo'
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      'arquivado'
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffCostsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (StaffCostsTab);

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StaffDesignationRevisionModal__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StaffDesignationRevisionApprovesModal__ = __webpack_require__(884);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário







var StaffDesignationApprovesTab = function (_Component) {
  _inherits(StaffDesignationApprovesTab, _Component);

  function StaffDesignationApprovesTab(props) {
    _classCallCheck(this, StaffDesignationApprovesTab);

    var _this = _possibleConstructorReturn(this, (StaffDesignationApprovesTab.__proto__ || Object.getPrototypeOf(StaffDesignationApprovesTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      staff_id: _this.props.staff_id,
      designation_id: null,
      date_start: '',
      modal_props: false,
      data_modal_approves: {}
    };

    //bind específico
    _this.showModal = _this.showModal.bind(_this);
    _this.showModalApproves = _this.showModalApproves.bind(_this);
    _this.modalPropsOff = _this.modalPropsOff.bind(_this);
    return _this;
  }
  // LM


  _createClass(StaffDesignationApprovesTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      this.setState({
        staff_designations_finalized: newProps.staff_designations_finalized
      });
    }
  }, {
    key: 'showModal',
    value: function showModal(value) {
      this.setState({
        data_modal: value,
        modal_props: true
      });
    }
  }, {
    key: 'showModalApproves',
    value: function showModalApproves(value) {
      this.setState({
        data_modal_approves: value,
        modal_approves: true
      });
    }
  }, {
    key: 'modalPropsOff',
    value: function modalPropsOff() {
      this.setState({ modal_props: false });
      this.setState({ modal_approves: false });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          'Lista de Revis\xE3o de Designa\xE7\xE3o'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_designations_finalized === null || typeof this.state.staff_designations_finalized === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              'Nenhuma designa\xE7\xE3o finalizada cadastrada.'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'N\xFAmero da Revis\xE3o'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Data de Finaliza\xE7\xE3o da Revis\xE3o'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Gestores Respons\xE1veis'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Aprova\xE7\xF5es'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_designations_finalized).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_designations_finalized[k].number_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_designations_finalized[k].date_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      {
                        className: 'btn btn-sm btn-primary',
                        onClick: function onClick() {
                          return self.showModal(self.state.staff_designations_finalized[k].staff_revision_designation_responsibles);
                        },
                        disabled: self.state.staff_designations_finalized[k].finalized !== 1 ? "disabled" : ""
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      {
                        className: 'btn btn-sm btn-primary',
                        value: self.state.staff_designations_finalized[k],
                        id: self.state.staff_designations_finalized[k].id,
                        onClick: function onClick() {
                          return self.showModalApproves(self.state.staff_designations_finalized[k]);
                        },
                        disabled: self.state.staff_designations_finalized[k].finalized !== 1 ? "disabled" : ""
                      },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StaffDesignationRevisionModal__["a" /* default */], { handleAlert: self.props.handleAlert, modalPropsOff: self.modalPropsOff, modal: self.state.modal_props, designation_responsibles: self.state.data_modal, refreshData: self.props.refreshData }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StaffDesignationRevisionApprovesModal__["a" /* default */], { handleAlert: self.props.handleAlert, modalPropsOff: self.modalPropsOff, modal: self.state.modal_approves, responsibles_to_approve: self.state.data_modal_approves.responsibles_to_approve, staff_to_approve: self.state.data_modal_approves.staff_to_approve, refreshData: self.props.refreshData })
      );
    }
  }]);

  return StaffDesignationApprovesTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (StaffDesignationApprovesTab);

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(16);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário



var StaffDesignationRevisionApprovesModal = function (_Component) {
  _inherits(StaffDesignationRevisionApprovesModal, _Component);

  function StaffDesignationRevisionApprovesModal(props) {
    _classCallCheck(this, StaffDesignationRevisionApprovesModal);

    var _this = _possibleConstructorReturn(this, (StaffDesignationRevisionApprovesModal.__proto__ || Object.getPrototypeOf(StaffDesignationRevisionApprovesModal)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      staff_designation: {},
      staff_designations_finalized: {},
      responsibles_to_approve: {},
      staff_to_approve: {},
      required: 0
    };
    return _this;
  }

  // LM


  _createClass(StaffDesignationRevisionApprovesModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.responsibles_to_approve)) {
        this.setState({
          responsibles_to_approve: newProps.responsibles_to_approve,
          staff_to_approve: newProps.staff_to_approve
        });
      }
      this.setState({ modal: newProps.modal });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */],
          { show: self.state.modal, 'aria-labelledby': 'contained-modal-alert-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              'Revis\xE3o ',
              self.state.staff_designation.number
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: this.props.modalPropsOff },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Body,
            null,
            self.state.responsibles_to_approve.length > 0 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'table table-bordered table-stripped table-hover' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { className: 'text-center' },
                      'Gestor'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { className: 'text-center' },
                      'Designa\xE7\xE3o Respons\xE1vel'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { className: 'text-center' },
                      'Data de Aprova\xE7\xE3o'
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  { id: 'suppliers-certifications' },
                  Object.keys(self.state.responsibles_to_approve).map(function (k) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        self.state.responsibles_to_approve[k].designation_responsible.staff.name
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        self.state.responsibles_to_approve[k].designation.name
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        self.state.responsibles_to_approve[k].approval_date_str
                      )
                    );
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'table table-bordered table-stripped table-hover' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { className: 'text-center' },
                      'Colaborador'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { className: 'text-center' },
                      'Data de Ci\xEAncia'
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  { id: 'suppliers-certifications' },
                  Object.keys(self.state.staff_to_approve).map(function (k) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        self.state.staff_to_approve[k].staff_revision.staff.name
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        self.state.staff_to_approve[k].approval_date_str
                      )
                    );
                  })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: this.props.modalPropsOff },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return StaffDesignationRevisionApprovesModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffDesignationRevisionApprovesModal);

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(16);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário



var StaffDesignationRevisionModal = function (_Component) {
  _inherits(StaffDesignationRevisionModal, _Component);

  function StaffDesignationRevisionModal(props) {
    _classCallCheck(this, StaffDesignationRevisionModal);

    var _this = _possibleConstructorReturn(this, (StaffDesignationRevisionModal.__proto__ || Object.getPrototypeOf(StaffDesignationRevisionModal)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      staff_designation: {},
      designation_responsibles: {},
      required: 0
    };
    _this.sendEmail = _this.sendEmail.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(StaffDesignationRevisionModal, [{
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      var data_temp = [];
      var self = this;
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }

      Object.keys(self.state.designation_responsibles).map(function (k) {
        if (self.state.designation_responsibles[k].id === name) {
          change = {
            required: value,
            status: self.state.designation_responsibles[k].status,
            staff_revision_id: self.state.designation_responsibles[k].staff_revision_id,
            staff_revision_designation_id: self.state.designation_responsibles[k].staff_revision_designation_id,
            staff_designation_id: self.state.designation_responsibles[k].staff_designation_id,
            designation_id: self.state.designation_responsibles[k].designation_id,
            designation_responsible_id: self.state.designation_responsibles[k].designation_responsible_id,
            name: self.state.designation_responsibles[k].name,
            document_id: self.state.designation_responsibles[k].document_id,
            id: self.state.designation_responsibles[k].id,
            designation_responsible: self.state.designation_responsibles[k].designation_responsible,
            designation: self.state.designation_responsibles[k].designation,
            staff_revision_designation: self.state.designation_responsibles[k].staff_revision_designation,
            staff_revision: self.state.designation_responsibles[k].staff_revision
          };
        } else {
          var _change;

          change = (_change = {
            required: self.state.designation_responsibles[k].required,
            status: self.state.designation_responsibles[k].status,
            staff_revision_id: self.state.designation_responsibles[k].staff_revision_id,
            staff_revision_designation_id: self.state.designation_responsibles[k].staff_revision_designation_id,
            staff_designation_id: self.state.designation_responsibles[k].staff_designation_id,
            designation_id: self.state.designation_responsibles[k].designation_id,
            designation_responsible_id: self.state.designation_responsibles[k].designation_responsible_id,
            name: self.state.designation_responsibles[k].name,
            document_id: self.state.designation_responsibles[k].document_id
          }, _defineProperty(_change, 'document_id', self.state.designation_responsibles[k].document_id), _defineProperty(_change, 'id', self.state.designation_responsibles[k].id), _defineProperty(_change, 'designation_responsible', self.state.designation_responsibles[k].designation_responsible), _defineProperty(_change, 'designation', self.state.designation_responsibles[k].designation), _defineProperty(_change, 'staff_revision_designation', self.state.designation_responsibles[k].staff_revision_designation), _defineProperty(_change, 'staff_revision', self.state.designation_responsibles[k].staff_revision), _change);
        }
        data_temp.push(change);
      });
      this.setState({ designation_responsibles: data_temp });
    }
    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.designation_responsibles)) {
        this.setState({
          designation_responsibles: newProps.designation_responsibles
        });
      }
      this.setState({ modal: newProps.modal });
    }
  }, {
    key: 'sendEmail',
    value: function sendEmail(event) {
      var confirm = window.confirm('Tem certeza que gostaria de enviar os emails de finalização de designação?');
      if (confirm) {
        var self = this;
        self.props.modalPropsOff();
        this.props.handleAlert('', '', 'open');
        var datasave = {
          staff_revision_designation_responsibles: this.state.designation_responsibles
        };
        var header = this.refs.request_api.header('application/json');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/revisao/designacao/email/finalizacao', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.refreshData(responseJson);
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */],
          { show: self.state.modal, 'aria-labelledby': 'contained-modal-alert-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              'Revis\xE3o ',
              self.state.staff_designation.number
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: this.props.modalPropsOff },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'table table-bordered table-stripped table-hover' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { className: 'text-center' },
                      'Nome do Colaborador'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { className: 'text-center' },
                      'Designa\xE7\xE3o'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { className: 'text-center' },
                      'Selecionar'
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  { id: 'suppliers-certifications' },
                  Object.keys(self.state.designation_responsibles).map(function (k) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        self.state.designation_responsibles[k].designation_responsible.staff.name
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        self.state.designation_responsibles[k].designation.name
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_toggle___default.a, {
                          checked: self.state.designation_responsibles[k].required,
                          disabled: self.state.designation_responsibles[k].staff_revision_designation.status !== 'pendente' ? "disabled" : "",
                          name: self.state.designation_responsibles[k].id,
                          onChange: self.handleToggleChange.bind(self, self.state.designation_responsibles[k].id) })
                      )
                    );
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: 'btn btn-lg btn-primary btn-block', value: 'ii', onClick: self.sendEmail },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-email' }),
                ' Solicitar Aprova\xE7\xF5es'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: this.props.modalPropsOff },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return StaffDesignationRevisionModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffDesignationRevisionModal);

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário






var StaffDesignationRevisionsTab = function (_Component) {
  _inherits(StaffDesignationRevisionsTab, _Component);

  function StaffDesignationRevisionsTab(props) {
    _classCallCheck(this, StaffDesignationRevisionsTab);

    var _this = _possibleConstructorReturn(this, (StaffDesignationRevisionsTab.__proto__ || Object.getPrototypeOf(StaffDesignationRevisionsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      staff_id: _this.props.staff_id,
      designation_id: null,
      designation_date: null,
      date_start: '',
      errors_listing: false,
      errors_messages: [],
      staff_designations: [],
      staff_designations_open: [],
      designation_observations: [],
      designations_list: [],
      lines: {},
      lines_open: {},
      staff_aircraft_models: {},
      staff_aircraft_models_open: {},
      staff_designations_open_info: {},
      staff_tasks: {},
      staff_tasks_open: {},
      staff_licenses: {},
      staff_licenses_open: {},
      staff_revisions: {},
      designation_observation_info: {},
      info: {},
      modal: false,
      modal_file: false,
      modal_open_revision: false,
      modal_observations: false
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.closeRevision = this.closeRevision.bind(this);
    // this.deleteRevision = this.deleteRevision.bind(this);
    // this.openRevision = this.openRevision.bind(this);
    // this.deleteDesignation = this.deleteDesignation.bind(this);
    // this.deleteOpenItem = this.deleteOpenItem.bind(this);
    // this.editFile = this.editFile.bind(this);
    _this.export = _this.export.bind(_this);
    _this.viewObservations = _this.viewObservations.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(StaffDesignationRevisionsTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (typeof newProps.staff_designations !== 'undefined' && typeof newProps.staff_designations_open !== 'undefined' && (this.state.loaded === 0 || this.state.loaded === 1 && newProps.updated === 1)) {
        this.setState({
          staff_designations: newProps.staff_designations,
          staff_designations_open: newProps.staff_designations_open,
          staff_designations_open_info: newProps.staff_designations_open.info,
          lines: newProps.staff_designations.dlines,
          info: newProps.staff_designations.info,
          staff_aircraft_models: newProps.staff_designations.staff_aircraft_models,
          observations: newProps.staff_designations.info.staff_revision_observations,
          staff_tasks: newProps.staff_designations.staff_tasks,
          staff_licenses: newProps.staff_designations.staff_licenses,
          lines_open: newProps.staff_designations_open.dlines,
          staff_aircraft_models_open: newProps.staff_designations_open.staff_aircraft_models,
          observations_open: newProps.staff_designations_open.info.staff_revision_observations,
          staff_tasks_open: newProps.staff_designations_open.staff_tasks,
          staff_licenses_open: newProps.staff_designations_open.staff_licenses,
          designations_list: newProps.designations_list,
          staff_revisions: newProps.staff_revisions,
          staff_revisions_list: newProps.staff_revisions_list,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     designation_id: this.state.designation_id,
    //     limitations: this.state.limitations,
    //     products: this.state.products,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/designacao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       if (responseJson.status === 'success') {
    //         self.setState({loaded: 0});
    //         self.props.refreshData(responseJson);
    //       } else {
    //         self.setState({errors_messages: responseJson.data, errors_listing: true});
    //         self.props.refreshData(responseJson);
    //       }
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // deleteDesignation(id) {
    //   if (window.confirm('Tem certeza que deseja deletar essa designação?')) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/designacao/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({loaded: 0});
    //         self.props.refreshData(responseJson);
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

    // deleteOpenItem(id, type) {
    //   if (window.confirm('Tem certeza que deseja deletar esse item da revisão de designação?')) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     let url = '/colaborador/revisao/frota/' + id;
    //     if (type === 'task') { url = '/colaborador/revisao/tarefa/' + id; }
    //     if (type === 'license') { url = '/colaborador/revisao/habilitacao/' + id; }
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + url, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({loaded: 0});
    //         self.props.refreshData(responseJson);
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

    // closeRevision(event) {
    //   event.preventDefault();
    //   if (window.confirm('Tem certeza que deseja fechar essa revisão de designação?')) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       staff_revision_id: this.state.staff_designations_open.info.staff_revision_id,
    //       designation_date: this.state.designation_date,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/designacao/fechar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({modal: false});
    //         self.setState({loaded: 0});
    //         self.props.refreshData(responseJson);
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

    // deleteRevision(event) {
    //   event.preventDefault();
    //   if (window.confirm('Tem certeza que deseja deletar essa revisão de designação?')) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       staff_revision_id: this.state.staff_designations_open.info.staff_revision_id,
    //       reason: this.state.delete_reason,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/designacao/deletar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({modal: false});
    //         self.setState({loaded: 0});
    //         self.props.refreshData(responseJson);
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

    // openRevision(event) {
    //   event.preventDefault();
    //   if (window.confirm('Tem certeza que deseja abrir essa revisão de designação?')) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       staff_revision_id: this.state.staff_designations.info.staff_revision_id,
    //       reason: this.state.open_reason,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/designacao/abrir', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({modal_open_revision: false});
    //         self.setState({modal: false});
    //         self.setState({loaded: 0});
    //         self.props.refreshData(responseJson);
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

  }, {
    key: 'viewObservations',
    value: function viewObservations(staff_revision_id) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/designacao/observacoes/' + staff_revision_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ modal_open_revision: false });
          self.setState({ modal: false });
          self.setState({ modal_observations: true });
          self.setState({ designation_observations: responseJson.data.main, designation_observation_info: responseJson.data.info });
          self.props.handleAlert('', '', 'closed');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }

    // editFile(event) {
    //   event.preventDefault();
    //   var self = this;
    //   var data = new FormData();
    //   var import_data = document.querySelector('.import-data').files[0];
    //   data.append("file", import_data);
    //   data.append("staff_revision_id", this.state.staff_revision_file_id);
    //   var header = self.refs.request_api.header();
    //   self.props.handleAlert('', '', 'open');
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/importar/arquivo/designacao', { method: 'POST', mode: 'cors', headers: value, body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.setState({modal_file: false});
    //         self.setState({loaded: 0});
    //         self.props.refreshData(responseJson);
    //       }).catch((error) => {
    //         console.error(error);
    //     });
    //   });
    // }

  }, {
    key: 'export',
    value: function _export(url) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      self.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data);
            self.props.handleAlert('', '', 'closed');
          }
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'grid-buttons pull-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["h" /* Dropdown */],
            { id: 'export-data' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["h" /* Dropdown */].Toggle,
              { bsStyle: 'info' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' }),
              ' ',
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.botaoExportacoes.ExportarDesignacoes
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["h" /* Dropdown */].Menu,
              null,
              Object.keys(self.state.staff_revisions).map(function (k) {
                if (self.state.staff_revisions[k].type === 'export') {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { onSelect: self.export, eventKey: '/exportar/revisao/designacao/' + self.state.staff_revisions[k].id },
                    self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.botaoExportacoes.Revisao,
                    ' ',
                    self.state.staff_revisions[k].number,
                    ' - ',
                    self.state.staff_revisions[k].status_str
                  );
                }
                if (self.state.staff_revisions[k].type === 'file') {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { href: __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/uploads/designations/' + self.state.staff_revisions[k].file, target: '_blank' },
                    self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.botaoExportacoes.RevisaoArquivo(self.state.staff_revisions[k].number, self.state.staff_revisions[k].status_str)
                  );
                }
                if (self.state.staff_revisions[k].type === 'observations') {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
                    { onSelect: function onSelect() {
                        self.viewObservations(self.state.staff_revisions[k].id);
                      } },
                    self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.botaoExportacoes.RevisaoObservacoes(self.state.staff_revisions[k].number, self.state.staff_revisions[k].status_str)
                  );
                }
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        typeof this.state.lines === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.nenhumaDesignacaoCadastrada
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            null,
            this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tituloRevisao,
            ' ',
            self.state.info.number,
            ' - ',
            self.state.info.date_str
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabela.Codigo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabela.Designacao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabela.DS
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabela.CEL
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabela.GMP
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabela.AVI
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabela.ProdutoEspecificacao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabela.LimitacoesObservacoes
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.lines).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.lines[k].code
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.lines[k].name
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.lines[k].des
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.lines[k].cel
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.lines[k].gmp
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.lines[k].avi
                  ),
                  self.state.lines[k].products.no_act !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.lines[k].products.no_act,
                    self.state.lines[k].products.manual === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      '*'
                    ) : ''
                  ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.lines[k].products.am !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      null,
                      ' ',
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabela.Acfts,
                      ':',
                      self.state.lines[k].products.am
                    ) : '',
                    self.state.lines[k].products.ams !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      null,
                      ' ',
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabela.Eng,
                      ':',
                      self.state.lines[k].products.ams
                    ) : '',
                    self.state.lines[k].tasks.task !== '' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      null,
                      ' ',
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabela.Comp,
                      ':',
                      self.state.lines[k].tasks.task
                    ) : ''
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.lines[k].limitations
                  )
                );
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'label label-danger' },
          '*'
        ),
        ' ',
        this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.designacoesComProdutoEspecificacaoEscritosManualmente,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tituloRazaoDeAberturaDaRevisao
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        typeof this.state.info !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          null,
          this.state.info.reason
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          null,
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tituloRazaoNaoDisponivel
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tituloHabilitacoesDesignadasDestaRevisao
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        typeof this.state.staff_licenses === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.nenhumaHabilitacaoCadastrada
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'table',
          { className: 'table table-bordered table-stripped table-hover' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'thead',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tr',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                { className: 'text-center' },
                this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabelaHabilitacoesDesignadasDestaRevisao.Nome
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                { className: 'text-center' },
                this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabelaHabilitacoesDesignadasDestaRevisao.Expiracao
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'tbody',
            { id: 'suppliers-certifications' },
            Object.keys(self.state.staff_licenses).map(function (k) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { className: 'text-center' },
                  self.state.staff_licenses[k].name
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { className: 'text-center' },
                  self.state.staff_licenses[k].expiration_str
                )
              );
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tituloTarefasDesignadasDestaRevisao
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        typeof this.state.staff_tasks === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.nenhumaTarefaCadastrada
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'table',
          { className: 'table table-bordered table-stripped table-hover' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'thead',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tr',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                { className: 'text-center' },
                this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabelaTarefasDesignadasDestaRevisao.Nome
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                { className: 'text-center' },
                this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabelaTarefasDesignadasDestaRevisao.Expiracao
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'tbody',
            { id: 'suppliers-certifications' },
            Object.keys(self.state.staff_tasks).map(function (k) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { className: 'text-center' },
                  self.state.staff_tasks[k].name
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { className: 'text-center' },
                  self.state.staff_tasks[k].expiration_str
                )
              );
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tituloFrotasDesignadasDestaRevisao
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        typeof this.state.staff_aircraft_models === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.nenhumaFrotaCadastrada
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'table',
          { className: 'table table-bordered table-stripped table-hover' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'thead',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tr',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                { className: 'text-center' },
                this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabelaFrotasDesignadasDestaRevisao.Nome
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                { className: 'text-center' },
                this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabelaFrotasDesignadasDestaRevisao.Expiracao
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'tbody',
            { id: 'suppliers-certifications' },
            Object.keys(self.state.staff_aircraft_models).map(function (k) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { className: 'text-center' },
                  self.state.staff_aircraft_models[k].name
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { className: 'text-center' },
                  self.state.staff_aircraft_models[k].expiration_str
                )
              );
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tituloLogDeAcoesManuaisDestaRevisao
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        typeof this.state.observations === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.nenhumaAcaoCadastrada
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'table',
          { className: 'table table-bordered table-stripped table-hover' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'thead',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tr',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                { className: 'text-center' },
                this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabelaLogDeAcoesManuaisDestaRevisao.Acao
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                { className: 'text-center' },
                this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabelaLogDeAcoesManuaisDestaRevisao.Tipo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                { className: 'text-center' },
                this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabelaLogDeAcoesManuaisDestaRevisao.Usuario
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                { className: 'text-center' },
                this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tabelaLogDeAcoesManuaisDestaRevisao.Data
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'tbody',
            { id: 'suppliers-certifications' },
            Object.keys(self.state.observations).map(function (k) {
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { className: 'text-center' },
                  self.state.observations[k].observation
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { className: 'text-center' },
                  self.state.observations[k].type
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { className: 'text-center' },
                  self.state.observations[k].user_name
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'td',
                  { className: 'text-center' },
                  self.state.observations[k].created_at_str
                )
              );
            })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.errors_listing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'alert alert-danger alert-dismissible', role: 'alert', style: { marginTop: 25 } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { onClick: function onClick() {
                return self.setState({ errors_listing: false, errors_messages: [] });
              }, type: 'button', className: 'close', 'data-dismiss': 'alert', 'aria-label': 'Close' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'span',
              { 'aria-hidden': 'true' },
              '\xD7'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'strong',
            null,
            this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.osColaboradorNaoPossuiOsCertificadosListadosAbaixo,
            ':'
          ),
          Object.keys(self.state.errors_messages).map(function (k) {
            var message = self.state.errors_messages[k];
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              '- ',
              message
            );
          })
        )
      );
    }
  }]);

  return StaffDesignationRevisionsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffDesignationRevisionsTab);

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StaffDesignationRevisionsTab__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaffDesignationApprovesTab__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Tabs




var StaffDesignationsTab = function (_Component) {
  _inherits(StaffDesignationsTab, _Component);

  function StaffDesignationsTab(props) {
    _classCallCheck(this, StaffDesignationsTab);

    var _this = _possibleConstructorReturn(this, (StaffDesignationsTab.__proto__ || Object.getPrototypeOf(StaffDesignationsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      updated: 0,
      key: 1,
      staff_id: _this.props.staff_id
    };
    _this.refreshData = _this.refreshData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(StaffDesignationsTab, [{
    key: 'handleNavTab',
    value: function handleNavTab(state, key) {
      var change = {};
      change[state] = key;
      this.setState(change);
      this.setState({ overlay: { message: '', type: '', status: '' } });
    }
    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (typeof newProps.staff_designations !== 'undefined' && typeof newProps.staff_designations_open !== 'undefined' && this.state.loaded === 0) {
        this.setState({
          staff_id: newProps.staff_id,
          staff_designations: newProps.staff_designations,
          staff_designations_open: newProps.staff_designations_open,
          staff_designations_open_info: newProps.staff_designations_open.info,
          staff_designations_finalized: newProps.staff_designations_finalized,
          lines: newProps.staff_designations.dlines,
          info: newProps.staff_designations.info,
          staff_aircraft_models: newProps.staff_designations.staff_aircraft_models,
          observations: newProps.staff_designations.info.staff_revision_observations,
          staff_tasks: newProps.staff_designations.staff_tasks,
          staff_licenses: newProps.staff_designations.staff_licenses,
          lines_open: newProps.staff_designations_open.dlines,
          staff_aircraft_models_open: newProps.staff_designations_open.staff_aircraft_models,
          observations_open: newProps.staff_designations_open.info.staff_revision_observations,
          staff_tasks_open: newProps.staff_designations_open.staff_tasks,
          staff_licenses_open: newProps.staff_designations_open.staff_licenses,
          designations_list: newProps.designations_list,
          staff_revisions: newProps.staff_revisions,
          staff_revisions_list: newProps.staff_revisions_list,
          loaded: 1
        });
      }
    }
  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/designacoes/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({
              staff_designations: responseJson.data.staff_designations,
              staff_designations_open: responseJson.data.staff_designations_open,
              staff_designations_open_info: responseJson.data.staff_designations_open.info,
              staff_designations_finalized: responseJson.data.staff_designations_finalized,
              lines: responseJson.data.staff_designations.dlines,
              info: responseJson.data.staff_designations.info,
              staff_aircraft_models: responseJson.data.staff_designations.staff_aircraft_models,
              observations: responseJson.data.staff_designations.info.staff_revision_observations,
              staff_tasks: responseJson.data.staff_designations.staff_tasks,
              staff_licenses: responseJson.data.staff_designations.staff_licenses,
              lines_open: responseJson.data.staff_designations_open.dlines,
              staff_aircraft_models_open: responseJson.data.staff_designations_open.staff_aircraft_models,
              observations_open: responseJson.data.staff_designations_open.info.staff_revision_observations,
              staff_tasks_open: responseJson.data.staff_designations_open.staff_tasks,
              staff_licenses_open: responseJson.data.staff_designations_open.staff_licenses,
              staff_revisions: responseJson.data.staff_revisions,
              staff_revisions_list: responseJson.data.staff_revisions_list,
              updated: 1
            });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tituloDesignacoes
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Tabs */],
          { activeKey: this.state.key, onSelect: this.handleNavTab.bind(this, 'key'), id: 'controlled-tab-example' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["f" /* Tab */],
            { eventKey: 1, title: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tabRevisoesDeDesignacoes.tituloTab },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__StaffDesignationRevisionsTab__["a" /* default */], { handleAlert: this.props.handleAlert, staff_id: this.state.staff_id, staff_designations: this.state.staff_designations, staff_designations_open: this.state.staff_designations_open, designations_list: this.state.designations_list, staff_revisions: this.state.staff_revisions, staff_revisions_list: this.state.staff_revisions_list, refreshData: this.refreshData, updated: self.state.updated })
          )
        )
      );
    }
  }]);

  return StaffDesignationsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffDesignationsTab);

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário




var StaffEditTab = function (_Component) {
  _inherits(StaffEditTab, _Component);

  function StaffEditTab(props) {
    _classCallCheck(this, StaffEditTab);

    var _this = _possibleConstructorReturn(this, (StaffEditTab.__proto__ || Object.getPrototypeOf(StaffEditTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      id: _this.props.staff_id,
      name: _this.props.staff_data.name,
      email: _this.props.staff_data.email,
      civil_state: _this.props.staff_data.civil_state,
      phone: _this.props.staff_data.phone,
      blood_type: _this.props.staff_data.blood_type,
      dados_bancarios: _this.props.staff_data.dados_bancarios,
      date_of_birth: _this.props.staff_data.date_of_birth_str,
      country_birth: _this.props.staff_data.country_birth,
      uf_birth: _this.props.staff_data.uf_birth,
      city_birth: _this.props.staff_data.city_birth,
      address: _this.props.staff_data.address,
      number: _this.props.staff_data.number,
      complement: _this.props.staff_data.complement,
      neighborhood: _this.props.staff_data.neighborhood,
      city: _this.props.staff_data.city,
      uf: _this.props.staff_data.uf,
      country: _this.props.staff_data.country,
      pis: _this.props.staff_data.pis,
      cep: _this.props.staff_data.cep,
      photo: "",
      cpf: _this.props.staff_data.cpf_str,
      identity: _this.props.staff_data.identity,
      id_uf: _this.props.staff_data.id_uf,
      id_exp: _this.props.staff_data.id_exp,
      id_date: _this.props.staff_data.id_date,
      ctps_uf: _this.props.staff_data.ctps_uf,
      ctps: _this.props.staff_data.ctps,
      ctps_expedition: _this.props.staff_data.ctps_expedition,
      escola_formacao: _this.props.staff_data.escola_formacao,
      scholarly: _this.props.staff_data.scholarly,
      confidence_us: _this.props.staff_data.confidence_us,
      expire_us: _this.props.staff_data.expire_us,
      confidence_eu: _this.props.staff_data.confidence_eu,
      expire_eu: _this.props.staff_data.expire_eu,
      passport: _this.props.staff_data.passport,
      passport_expiration: _this.props.staff_data.passport_expiration,
      voting_title: _this.props.staff_data.voting_title,
      voting_title_zone: _this.props.staff_data.voting_title_zone,
      voting_title_session: _this.props.staff_data.voting_title_session,
      cnh: _this.props.staff_data.cnh,
      cnh_expiration: _this.props.staff_data.cnh_expiration,
      reservista: _this.props.staff_data.reservista,
      reservista_cat: _this.props.staff_data.reservista_cat,
      certificado_militar: _this.props.staff_data.certificado_militar,
      certificado_militar_ministerio: _this.props.staff_data.certificado_militar_ministerio,
      certificado_militar_obs: _this.props.staff_data.certificado_militar_obs,
      visto_usa: _this.props.staff_data.visto_usa,
      crea: _this.props.staff_data.crea,
      crea_titulo: _this.props.staff_data.crea_titulo,
      crea_expedicao: _this.props.staff_data.crea_expedicao,
      crea_validade: _this.props.staff_data.crea_validade,
      aso: _this.props.staff_data.aso,
      hired: _this.props.staff_data.hired,
      fired: _this.props.staff_data.fired,
      mom: _this.props.staff_data.mom,
      dad: _this.props.staff_data.dad,
      license: _this.props.staff_data.license,
      canac: _this.props.staff_data.canac,
      inscription: _this.props.staff_data.inscription,
      hour_value: _this.props.staff_data.hour_value,
      sispat: _this.props.staff_data.sispat,
      uf_list: _this.props.uf_list,
      sapiens_code: _this.props.sapiens_code
    };

    //bind específico
    // this.edit = this.edit.bind(this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(StaffEditTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && typeof newProps.staff_data.name !== 'undefined' && Array.isArray(newProps.uf_list)) {
        this.setState({
          id: newProps.staff_id,
          name: newProps.staff_data.name,
          email: newProps.staff_data.email,
          civil_state: newProps.staff_data.civil_state,
          phone1: newProps.staff_data.phone1,
          phone2: newProps.staff_data.phone2,
          blood_type: newProps.staff_data.blood_type,
          dados_bancarios: newProps.staff_data.dados_bancarios,
          date_of_birth: newProps.staff_data.date_of_birth_str,
          country_birth: newProps.staff_data.country_birth,
          uf_birth: newProps.staff_data.uf_birth,
          city_birth: newProps.staff_data.city_birth,
          address: newProps.staff_data.address,
          number: newProps.staff_data.number,
          complement: newProps.staff_data.complement,
          neighborhood: newProps.staff_data.neighborhood,
          city: newProps.staff_data.city,
          uf: newProps.staff_data.uf,
          country: newProps.staff_data.country,
          pis: newProps.staff_data.pis,
          cep: newProps.staff_data.cep,
          cpf: newProps.staff_data.cpf_str,
          identity: newProps.staff_data.identity,
          id_uf: newProps.staff_data.id_uf,
          id_exp: newProps.staff_data.id_exp,
          id_date: newProps.staff_data.id_date,
          ctps_uf: newProps.staff_data.ctps_uf,
          ctps: newProps.staff_data.ctps,
          ctps_expedition: newProps.staff_data.ctps_expedition,
          escola_formacao: newProps.staff_data.escola_formacao,
          scholarly: newProps.staff_data.scholarly,
          confidence_us: newProps.staff_data.confidence_us,
          expire_us: newProps.staff_data.expire_us,
          confidence_eu: newProps.staff_data.confidence_eu,
          expire_eu: newProps.staff_data.expire_eu,
          passport: newProps.staff_data.passport,
          passport_expiration: newProps.staff_data.passport_expiration,
          voting_title: newProps.staff_data.voting_title,
          voting_title_zone: newProps.staff_data.voting_title_zone,
          voting_title_session: newProps.staff_data.voting_title_session,
          cnh: newProps.staff_data.cnh,
          cnh_expiration: newProps.staff_data.cnh_expiration,
          reservista: newProps.staff_data.reservista,
          reservista_cat: newProps.staff_data.reservista_cat,
          certificado_militar: newProps.staff_data.certificado_militar,
          certificado_militar_ministerio: newProps.staff_data.certificado_militar_ministerio,
          certificado_militar_obs: newProps.staff_data.certificado_militar_obs,
          visto_usa: newProps.staff_data.visto_usa,
          crea: newProps.staff_data.crea,
          crea_titulo: newProps.staff_data.crea_titulo,
          crea_expedicao: newProps.staff_data.crea_expedicao,
          crea_validade: newProps.staff_data.crea_validade,
          aso: newProps.staff_data.aso,
          hired: newProps.staff_data.hired,
          fired: newProps.staff_data.fired,
          mom: newProps.staff_data.mom,
          dad: newProps.staff_data.dad,
          license: newProps.staff_data.license,
          canac: newProps.staff_data.canac,
          inscription: newProps.staff_data.inscription,
          hour_value: newProps.staff_data.hour_value,
          sispat: newProps.staff_data.sispat,
          sapiens_code: newProps.staff_data.sapiens_code,
          uf_list: newProps.uf_list,
          loaded: 1
        });
      }
    }

    // // Fetch salvando a edição
    // edit(event) {
    //   event.preventDefault();
    //   var data = new FormData();
    //   var imagedata = document.querySelector(".input-photo").files[0];
    //   data.append("name", this.state.name);
    //   data.append("email", this.state.email);
    //   data.append("civil_state", this.state.civil_state);
    //   data.append("phone1", this.state.phone1);
    //   data.append("phone2", this.state.phone2);
    //   data.append("blood_type", this.state.blood_type);
    //   data.append("dados_bancarios", this.state.dados_bancarios);
    //   data.append("date_of_birth", this.state.date_of_birth);
    //   data.append("country_birth", this.state.country_birth);
    //   data.append("uf_birth", this.state.uf_birth);
    //   data.append("city_birth", this.state.city_birth);
    //   data.append("address", this.state.address);
    //   data.append("number", this.state.number);
    //   data.append("complement", this.state.complement);
    //   data.append("neighborhood", this.state.neighborhood);
    //   data.append("city", this.state.city);
    //   data.append("uf", this.state.uf);
    //   data.append("country", this.state.country);
    //   data.append("pis", this.state.pis);
    //   data.append("cep", this.state.cep);
    //   data.append("cpf", this.state.cpf);
    //   data.append("identity", this.state.identity);
    //   data.append("id_uf", this.state.id_uf);
    //   data.append("id_exp", this.state.id_exp);
    //   data.append("id_date", this.state.id_date);
    //   data.append("ctps_uf", this.state.ctps_uf);
    //   data.append("ctps", this.state.ctps);
    //   data.append("ctps_expedition", this.state.ctps_expedition);
    //   data.append("escola_formacao", this.state.escola_formacao);
    //   data.append("scholarly", this.state.scholarly);
    //   data.append("confidence_us", this.state.confidence_us);
    //   data.append("expire_us", this.state.expire_us);
    //   data.append("confidence_eu", this.state.confidence_eu);
    //   data.append("expire_eu", this.state.expire_eu);
    //   data.append("passport", this.state.passport);
    //   data.append("passport_expiration", this.state.passport_expiration);
    //   data.append("voting_title", this.state.voting_title);
    //   data.append("voting_title_zone", this.state.voting_title_zone);
    //   data.append("voting_title_session", this.state.voting_title_session);
    //   data.append("cnh", this.state.cnh);
    //   data.append("cnh_expiration", this.state.cnh_expiration);
    //   data.append("reservista", this.state.reservista);
    //   data.append("reservista_cat", this.state.reservista_cat);
    //   data.append("certificado_militar", this.state.certificado_militar);
    //   data.append("certificado_militar_ministerio", this.state.certificado_militar_ministerio);
    //   data.append("certificado_militar_obs", this.state.certificado_militar_obs);
    //   data.append("visto_usa", this.state.visto_usa);
    //   data.append("crea", this.state.crea);
    //   data.append("crea_titulo", this.state.crea_titulo);
    //   data.append("crea_expedicao", this.state.crea_expedicao);
    //   data.append("crea_validade", this.state.crea_validade);
    //   data.append("aso", this.state.aso);
    //   data.append("hired", this.state.hired);
    //   data.append("fired", this.state.fired);
    //   data.append("mom", this.state.mom);
    //   data.append("dad", this.state.dad);
    //   data.append("license", this.state.license);
    //   data.append("canac", this.state.canac);
    //   data.append("inscription", this.state.inscription);
    //   data.append("hour_value", this.state.hour_value);
    //   data.append("sispat", this.state.sispat);
    //   data.append("sapiens_code", this.state.sapiens_code);
    //   data.append("id", this.state.id);
    //   data.append("imagem", imagedata);
    //   var header = this.refs.request_api.header();
    //   var self = this;
    //   this.props.handleAlert('', '', 'open');
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/edicao', {
    //       method: 'POST',
    //       mode: 'cors',
    //       headers: value,
    //       body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'form',
            { onSubmit: this.edit },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.tituloInformacoesPessoais
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Nome,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'name', value: this.state.name, placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.NomeDoColaborador, onChange: this.handleChange.bind(this, 'name') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Email,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'email', value: this.state.email, placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.EmailDoColaborador, onChange: this.handleChange.bind(this, 'email') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.EstadoCivil,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'civil_state', value: this.state.civil_state, placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.EstadoCivil, onChange: this.handleChange.bind(this, 'civil_state') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.TipoSanguineo,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.TipoSanguineo, className: 'form-control', disabled: true, name: 'blood_type', value: this.state.blood_type, onChange: this.handleChange.bind(this, 'blood_type') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Telefone1,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'phone1', value: this.state.phone1, placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.TelefoneDoColaborador, onChange: this.handleChange.bind(this, 'phone1') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Telefone2,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'phone2', value: this.state.phone2, placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.TelefoneDoColaborador, onChange: this.handleChange.bind(this, 'phone2') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.DadosBancarios,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', { style: { height: 130 }, type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.DadosBancarios, className: 'form-control', disabled: true, name: 'dados_bancarios', value: this.state.dados_bancarios, onChange: this.handleChange.bind(this, 'dados_bancarios') })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Nascimento,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.date_of_birth, placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.NascimentoDoColaborador, maskChar: null, name: 'date_of_birth', mask: '99/99/9999', className: 'form-control', disabled: true, onChange: this.handleChange.bind(this, 'date_of_birth') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.PaisNascimento,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.PaisNascimento, className: 'form-control', disabled: true, name: 'country', value: this.state.country, onChange: this.handleChange.bind(this, 'country') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.UFNascimento,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                  className: '',
                  name: 'uf_birth',
                  value: this.state.uf_birth,
                  searchable: true,
                  placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.SelecioneOUF,
                  onChange: this.handleSelectChange.bind(this, 'uf_birth'),
                  options: this.state.uf_list,
                  disabled: true
                })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CidadeNascimento,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CidadeNascimento, className: 'form-control', disabled: true, name: 'city_birth', value: this.state.city_birth, onChange: this.handleChange.bind(this, 'city_birth') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Endereco,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.EnderecoDoColaborador, name: 'address', value: this.state.address, onChange: this.handleChange.bind(this, 'address') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Numero,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.Numero, className: 'form-control', disabled: true, name: 'number', value: this.state.number, onChange: this.handleChange.bind(this, 'number') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Complemento,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.Complemento, className: 'form-control', disabled: true, name: 'complement', value: this.state.complement, onChange: this.handleChange.bind(this, 'complement') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Bairro,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.BairroDoColaborador, className: 'form-control', disabled: true, name: 'neighborhood', value: this.state.neighborhood, onChange: this.handleChange.bind(this, 'neighborhood') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Cidade,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CidadeDoColaborador, className: 'form-control', disabled: true, name: 'city', value: this.state.city, onChange: this.handleChange.bind(this, 'city') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.UF,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                  className: '',
                  name: 'uf',
                  value: this.state.uf,
                  searchable: true,
                  placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.SelecioneOUF,
                  onChange: this.handleSelectChange.bind(this, 'uf'),
                  options: this.state.uf_list,
                  disabled: true
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Pais,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.Pais, className: 'form-control', disabled: true, name: 'country', value: this.state.country, onChange: this.handleChange.bind(this, 'country') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.PIS,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.PIS, className: 'form-control', disabled: true, name: 'pis', value: this.state.pis, onChange: this.handleChange.bind(this, 'pis') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CEP,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CEPDoColaborador, className: 'form-control', disabled: true, name: 'cep', value: this.state.cep, onChange: this.handleChange.bind(this, 'cep') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CPF,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CPFDoColaborador, className: 'form-control', disabled: true, name: 'cpf', value: this.state.cpf, onChange: this.handleChange.bind(this, 'cpf') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Identidade,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'identity', value: this.state.identity, onChange: this.handleChange.bind(this, 'identity') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.IDUF,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.EstadoDeEmissaoDaID, className: 'form-control', disabled: true, name: 'id_uf', value: this.state.id_uf, onChange: this.handleChange.bind(this, 'id_uf') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.OrgaoDeExpedicao,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.OrgaoExpeditorDaID, className: 'form-control', disabled: true, name: 'id_exp', value: this.state.id_exp, onChange: this.handleChange.bind(this, 'id_exp') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.IDExpedicao,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.id_date, placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.ExpedicaoDaID, maskChar: null, name: 'id_date', mask: '99/99/9999', className: 'form-control', disabled: true, onChange: this.handleChange.bind(this, 'id_date') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CarteiraDeTrabalhoUF,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CarteiraDeTrabalhoUF, name: 'ctps_uf', value: this.state.ctps_uf, onChange: this.handleChange.bind(this, 'ctps_uf') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CarteiraDeTrabalhoProfissional,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CarteiraDeTrabalhoProfissional, name: 'ctps', value: this.state.ctps, onChange: this.handleChange.bind(this, 'ctps') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CarteiraDeTrabalhoExpedicao,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.ctps_expedition, placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CarteiraDeTrabalhoExpedicao, maskChar: null, name: 'ctps_expedition', mask: '99/99/9999', className: 'form-control', disabled: true, onChange: this.handleChange.bind(this, 'ctps_expedition') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.EscolaFormacao,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.EscolaFormacao, className: 'form-control', disabled: true, name: 'escola_formacao', value: this.state.escola_formacao, onChange: this.handleChange.bind(this, 'escola_formacao') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Escolaridade,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.Escolaridade, className: 'form-control', disabled: true, name: 'scholarly', value: this.state.scholarly, onChange: this.handleChange.bind(this, 'scholarly') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.ConfidenceUS,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.NumeroDoCartaoConfidenceAmericano, className: 'form-control', disabled: true, name: 'confidence_us', value: this.state.confidence_us, onChange: this.handleChange.bind(this, 'confidence_us') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.ExpiracaoConfidenceUS,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.expire_us, placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.ValidadeDoCartaoConfidenceAmericano, maskChar: null, name: 'expire_us', mask: '99/99/9999', className: 'form-control', disabled: true, onChange: this.handleChange.bind(this, 'expire_us') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.ConfidenceEU,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.NumeroDoCartaoConfidenceEuropeu, name: 'confidence_eu', value: this.state.confidence_eu, onChange: this.handleChange.bind(this, 'confidence_eu') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.ExpiracaoConfidenceEU,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.expire_eu, placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.ValidadeDoCartaoConfidenceEuropeu, maskChar: null, name: 'expire_eu', mask: '99/99/9999', className: 'form-control', disabled: true, onChange: this.handleChange.bind(this, 'expire_eu') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Passaporte,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.NumeroDoPassaporte, className: 'form-control', disabled: true, name: 'passport', value: this.state.passport, onChange: this.handleChange.bind(this, 'passport') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.PassaporteExpiracao,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.passport_expiration, placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.ExpiracaoDoPassaporte, maskChar: null, name: 'passport_expiration', mask: '99/99/9999', className: 'form-control', disabled: true, onChange: this.handleChange.bind(this, 'passport_expiration') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.TituloDeEleitor,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.TituloDeEleitor, className: 'form-control', disabled: true, name: 'voting_title', value: this.state.voting_title, onChange: this.handleChange.bind(this, 'voting_title') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.ZonaDeEleitor,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.ZonaDeEleitor, className: 'form-control', disabled: true, name: 'voting_title_zone', value: this.state.voting_title_zone, onChange: this.handleChange.bind(this, 'voting_title_zone') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.SessaoDeEleitor,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.SessaoDeEleitor, className: 'form-control', disabled: true, name: 'voting_title_session', value: this.state.voting_title_session, onChange: this.handleChange.bind(this, 'voting_title_session') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CNHCategoria,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CNHCategoria, className: 'form-control', disabled: true, name: 'cnh_cat', value: this.state.cnh_cat, onChange: this.handleChange.bind(this, 'cnh_cat') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CNH,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.NumeroDaCarteiraDeMotorista, className: 'form-control', disabled: true, name: 'cnh', value: this.state.cnh, onChange: this.handleChange.bind(this, 'cnh') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CNHExpiracao,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.ExpiracaoDaCarteiraDeMotorista, className: 'form-control', disabled: true, name: 'cnh_expiration', value: this.state.cnh_expiration, onChange: this.handleChange.bind(this, 'cnh_expiration') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Reservista,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.Reservista, className: 'form-control', disabled: true, name: 'reservista', value: this.state.reservista, onChange: this.handleChange.bind(this, 'reservista') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.ReservistaCategoria,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.ReservistaCategoria, className: 'form-control', disabled: true, name: 'reservista_cat', value: this.state.reservista_cat, onChange: this.handleChange.bind(this, 'reservista_cat') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CertificadoMilitar,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CertificadoMilitar, className: 'form-control', disabled: true, name: 'certificado_militar', value: this.state.certificado_militar, onChange: this.handleChange.bind(this, 'certificado_militar') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CertificadoMilitarMinisterio,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CertificadoMilitarMinisterio, className: 'form-control', disabled: true, name: 'certificado_militar_ministerio', value: this.state.certificado_militar_ministerio, onChange: this.handleChange.bind(this, 'certificado_militar_ministerio') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CertificadoMilitarObservacoes,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CertificadoMilitarObservacoes, className: 'form-control', disabled: true, name: 'certificado_militar_obs', value: this.state.certificado_militar_obs, onChange: this.handleChange.bind(this, 'certificado_militar_obs') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.VistoAmericano,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.VistoAmericano, className: 'form-control', disabled: true, name: 'visto_usa', value: this.state.visto_usa, onChange: this.handleChange.bind(this, 'visto_usa') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CREA,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CREA, className: 'form-control', disabled: true, name: 'crea', value: this.state.crea, onChange: this.handleChange.bind(this, 'crea') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CREATitulo,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CREATitulo, className: 'form-control', disabled: true, name: 'crea_titulo', value: this.state.crea_titulo, onChange: this.handleChange.bind(this, 'crea_titulo') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CREAExpedicao,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CREAExpedicao, className: 'form-control', disabled: true, name: 'crea_expedicao', value: this.state.crea_expedicao, onChange: this.handleChange.bind(this, 'crea_expedicao') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CREAValidade,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CREAValidade, className: 'form-control', disabled: true, name: 'crea_validade', value: this.state.crea_validade, onChange: this.handleChange.bind(this, 'crea_validade') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.ASO,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.ASO, className: 'form-control', disabled: true, name: 'aso', value: this.state.aso, onChange: this.handleChange.bind(this, 'aso') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Contratacao,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.Contratacao, className: 'form-control', disabled: true, name: 'hired', value: this.state.hired, onChange: this.handleChange.bind(this, 'hired') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Demissao,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.Demissao, className: 'form-control', disabled: true, name: 'fired', value: this.state.fired, onChange: this.handleChange.bind(this, 'fired') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.NomeDaMae,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.NomeDaMaeDoColaborador, className: 'form-control', disabled: true, name: 'mom', value: this.state.mom, onChange: this.handleChange.bind(this, 'mom') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.NomeDoPai,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.NomeDoPaiDoColaborador, className: 'form-control', disabled: true, name: 'dad', value: this.state.dad, onChange: this.handleChange.bind(this, 'dad') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.tituloInformacoesProfissionais
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Licenca,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.Licenca, className: 'form-control', disabled: true, name: 'license', value: this.state.license, onChange: this.handleChange.bind(this, 'license') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CANAC,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CANAC, className: 'form-control', disabled: true, name: 'canac', value: this.state.canac, onChange: this.handleChange.bind(this, 'canac') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.Matricula,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.InscricaoDoColaborador, className: 'form-control', disabled: true, name: 'inscription', value: this.state.inscription, onChange: this.handleChange.bind(this, 'inscription') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.ValorHora,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.ValorHora, className: 'form-control', disabled: true, name: 'hour_value', value: this.state.hour_value, onChange: this.handleChange.bind(this, 'hour_value') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.ContratoSISPAT,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.ContratoSISPAT, className: 'form-control', disabled: true, name: 'sispat', value: this.state.sispat, onChange: this.handleChange.bind(this, 'sispat') })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.CodigoSapiens,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', placeholder: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.formulario.placeholder.CodigoSapiens, className: 'form-control', disabled: true, name: 'sapiens_code', value: this.state.sapiens_code, onChange: this.handleChange.bind(this, 'sapiens_code') })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
          )
        )
      );
    }
  }]);

  return StaffEditTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffEditTab);

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário




var StaffEducationsTab = function (_Component) {
  _inherits(StaffEducationsTab, _Component);

  function StaffEducationsTab(props) {
    var _this$state;

    _classCallCheck(this, StaffEducationsTab);

    var _this = _possibleConstructorReturn(this, (StaffEducationsTab.__proto__ || Object.getPrototypeOf(StaffEducationsTab)).call(this, props));

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__["a" /* default */])();

    _this.state = (_this$state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0
    }, _defineProperty(_this$state, 'loaded', 0), _defineProperty(_this$state, 'staff_id', _this.props.staff_id), _defineProperty(_this$state, 'type', null), _defineProperty(_this$state, 'name', ''), _defineProperty(_this$state, 'institution', ''), _defineProperty(_this$state, 'date', ''), _defineProperty(_this$state, 'staff_educations', []), _defineProperty(_this$state, 'educations_type_list', [{ value: "", label: _this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFormacaoAcademica.opcoesTipoDeFormacao.SelecionarTipo }, { value: '1º Grau', label: _this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFormacaoAcademica.opcoesTipoDeFormacao.PrimeiroGrau }, { value: '2º Grau', label: _this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFormacaoAcademica.opcoesTipoDeFormacao.SegundoGrau }, { value: 'Ensino superior', label: _this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFormacaoAcademica.opcoesTipoDeFormacao.EnsinoSuperior }, { value: 'Pós graduação', label: _this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFormacaoAcademica.opcoesTipoDeFormacao.PosGraduacao }, { value: 'MMA', label: _this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFormacaoAcademica.opcoesTipoDeFormacao.MMA }]), _this$state);

    //bind específico
    // this.add = this.add.bind(this);
    // this.ativar = this.ativar.bind(this);
    // this.desativar = this.desativar.bind(this);
    // this.delete = this.delete.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);
    _this.refreshDataActive = _this.refreshDataActive.bind(_this);
    return _this;
  }

  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }

  // LM


  _createClass(StaffEducationsTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.staff_educations)) {
        this.setState({
          staff_educations: newProps.staff_educations,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     type: this.state.type,
    //     name: this.state.name,
    //     institution: this.state.institution,
    //     date: this.state.date,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/formacao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.setState({ staff_educations: responseJson.data });
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }


    // // Fetch ativando um item
    // ativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar essa formação?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/formacao/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_educations: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch deletando um item
    // desativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar essa formação?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/formacao/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_educations: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/formacoes/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ staff_educations: responseJson.data, only_active: 0 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'refreshDataActive',
    value: function refreshDataActive(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/formacoes/ativas/' + self.state.staff_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_educations: responseJson.data, only_active: 1 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }

    // delete($staff_education_id) {
    //   var confirm = window.confirm('Tem certeza que deseja deletar essa formação?');
    //   if (confirm) {
    //     var self = this;
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/formacao/' + $staff_education_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.refreshData(responseJson);
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFormacaoAcademica.tituloFormacaoAcademica
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_educations === null || typeof this.state.staff_educations === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFormacaoAcademica.nenhumaFormacaoCadastrada
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFormacaoAcademica.tabela.Tipo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFormacaoAcademica.tabela.NomeDoCurso
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFormacaoAcademica.tabela.Instituicao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFormacaoAcademica.tabela.DataDeConclusao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFormacaoAcademica.tabela.Status
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_educations).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_educations[k].type
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_educations[k].name
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_educations[k].institution
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_educations[k].date_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_educations[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFormacaoAcademica.tabela.Ativo
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFormacaoAcademica.tabela.Arquivado
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffEducationsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffEducationsTab);

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário



var StaffFleetsTab = function (_Component) {
  _inherits(StaffFleetsTab, _Component);

  function StaffFleetsTab(props) {
    _classCallCheck(this, StaffFleetsTab);

    var _this = _possibleConstructorReturn(this, (StaffFleetsTab.__proto__ || Object.getPrototypeOf(StaffFleetsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      expiration: '',
      date_start: '',
      expiration_subtype: '',
      date_start_subtype: '',
      staff_id: _this.props.staff_id,
      aircraft_model_id: null,
      aircraft_model_subtype_id: null,
      staff_fleets: [],
      aircraft_models_list: [],
      aircraft_model_subtypes_list: []
    };

    //bind específico
    // this.addAircraftModel = this.addAircraftModel.bind(this);
    // this.addAircraftModelSubtype = this.addAircraftModelSubtype.bind(this);
    // this.ativar = this.ativar.bind(this);
    // this.desativar = this.desativar.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);
    _this.refreshDataActive = _this.refreshDataActive.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }
  // handleToggleChange (name, event) {
  //   var change = {};
  //   if (event.target.checked === true) {
  //     var value = 1;
  //   } else {
  //     var value = 0;
  //   }
  //   change[name] = value;
  //   this.setState(change);
  // }

  // LM


  _createClass(StaffFleetsTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.staff_fleets)) {
        this.setState({
          staff_fleets: newProps.staff_fleets,
          aircraft_models_list: newProps.aircraft_models_list,
          aircraft_model_subtypes_list: newProps.aircraft_model_subtypes_list,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição
    // addAircraftModel(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     aircraft_model_id: this.state.aircraft_model_id,
    //     only_active: this.state.only_active,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/frota_obrigatoria', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.setState({ staff_fleets: responseJson.data });
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // // Fetch salvando a edição
    // addAircraftModelSubtype(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     aircraft_model_subtype_id: this.state.aircraft_model_subtype_id,
    //     only_active: this.state.only_active,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/frota_obrigatoria', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.setState({ staff_fleets: responseJson.data });
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // // Fetch ativando um item
    // ativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar essa frota?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/frota_obrigatoria/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_fleets: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch deletando um item
    // desativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar essa frota?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/frota_obrigatoria/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_fleets: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/frota_obrigatoria/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ staff_fleets: responseJson.data, only_active: 0 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'refreshDataActive',
    value: function refreshDataActive(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/frota_obrigatoria/ativas/' + self.state.staff_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_fleets: responseJson.data, only_active: 1 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasObrigatorias.tituloFrotasObrigatorias
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_fleets === null || typeof this.state.staff_fleets === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasObrigatorias.nenhumaFrotaCadastrada
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasObrigatorias.tabela.Aeronave
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasObrigatorias.tabela.Subtipo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasObrigatorias.tabela.Status
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_fleets).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_fleets[k].aircraft_model
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_fleets[k].aircraft_model_subtype
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_fleets[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasObrigatorias.tabela.Ativo
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasObrigatorias.tabela.Arquivado
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffFleetsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffFleetsTab);

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário





var StaffGradesTab = function (_Component) {
  _inherits(StaffGradesTab, _Component);

  function StaffGradesTab(props) {
    _classCallCheck(this, StaffGradesTab);

    var _this = _possibleConstructorReturn(this, (StaffGradesTab.__proto__ || Object.getPrototypeOf(StaffGradesTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      staff_id: _this.props.staff_id,
      name: null,
      type: null,
      only_active: 1,
      expiration: '',
      dispatch: '',
      staff_grades: [],
      aircraft_list: []
    };

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }
  // handleToggleChange (name, event) {
  //   var change = {};
  //   if (event.target.checked === true) {
  //     var value = 1;
  //   } else {
  //     var value = 0;
  //   }
  //   change[name] = value;
  //   this.setState(change);
  // }

  // LM


  _createClass(StaffGradesTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.staff_grades)) {
        this.setState({
          staff_grades: newProps.staff_grades,
          loaded: 1
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNiveisDeCargos.tituloNiveisDeCargos
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_grades === null || typeof this.state.staff_grades === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNiveisDeCargos.nenhumaAeronaveCadastrada
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNiveisDeCargos.tabela.DataDeAlteracao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNiveisDeCargos.tabela.Nivel
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNiveisDeCargos.tabela.Motivo
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_grades).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_grades[k].date_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_grades[k].level
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_grades[k].motivo
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffGradesTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffGradesTab);

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário


var StaffGuaranteedHoursTab = function (_Component) {
  _inherits(StaffGuaranteedHoursTab, _Component);

  function StaffGuaranteedHoursTab(props) {
    var _this$state;

    _classCallCheck(this, StaffGuaranteedHoursTab);

    var _this = _possibleConstructorReturn(this, (StaffGuaranteedHoursTab.__proto__ || Object.getPrototypeOf(StaffGuaranteedHoursTab)).call(this, props));

    _this.state = (_this$state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      staff_id: _this.props.staff_id,
      code: null,
      hours: null
    }, _defineProperty(_this$state, 'only_active', 1), _defineProperty(_this$state, 'staff_guaranteed_hours', []), _this$state);

    //bind específico
    // this.add = this.add.bind(this);
    // this.ativar = this.ativar.bind(this);
    // this.desativar = this.desativar.bind(this);
    // this.delete = this.delete.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);
    _this.refreshDataActive = _this.refreshDataActive.bind(_this);
    return _this;
  }
  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // }
  // LM


  _createClass(StaffGuaranteedHoursTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.staff_guaranteed_hours)) {
        this.setState({
          staff_guaranteed_hours: newProps.staff_guaranteed_hours,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     code: this.state.code,
    //     only_active: this.state.only_active,
    //     hours: this.state.hours,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/horas/garantidas', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.setState({ staff_guaranteed_hours: responseJson.data });
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // // Fetch ativando um item
    // ativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar essas horas garantidas?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/horas/garantidas/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_guaranteed_hours: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

    // // Fetch deletando um item
    // desativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar essas horas garantidas?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/horas/garantidas/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_guaranteed_hours: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/horas/garantidas/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ staff_guaranteed_hours: responseJson.data, only_active: 0 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'refreshDataActive',
    value: function refreshDataActive(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/horas/garantidas/ativas/' + self.state.staff_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_guaranteed_hours: responseJson.data, only_active: 1 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }

    // delete($id) {
    //   var confirm = window.confirm('Tem certeza que deseja deletar essas horas garantidas?');
    //   if (confirm) {
    //     var self = this;
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/horas/garantidas/' + $id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.refreshData(responseJson);
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          'Centro de custo'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_guaranteed_hours === null || typeof this.state.staff_guaranteed_hours === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              'Nenhuma horas garantidas cadastrado.'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Horas Garantidas - Adicional'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'C\xF3digo'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Cadastrado em'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Status'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_guaranteed_hours).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_guaranteed_hours[k].hours
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_guaranteed_hours[k].code
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_guaranteed_hours[k].created_at_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_guaranteed_hours[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      'ativo'
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      'arquivado'
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffGuaranteedHoursTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (StaffGuaranteedHoursTab);

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário




var StaffJobsTab = function (_Component) {
  _inherits(StaffJobsTab, _Component);

  function StaffJobsTab(props) {
    _classCallCheck(this, StaffJobsTab);

    var _this = _possibleConstructorReturn(this, (StaffJobsTab.__proto__ || Object.getPrototypeOf(StaffJobsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      staff_id: _this.props.staff_id,
      date_start: '',
      date_finish: '',
      only_active: 1,
      company: '',
      function: '',
      staff_jobs: [],
      staff_list: []
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.ativar = this.ativar.bind(this);
    // this.desativar = this.desativar.bind(this);
    // this.delete = this.delete.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);
    _this.refreshDataActive = _this.refreshDataActive.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }
  // LM


  _createClass(StaffJobsTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.staff_jobs)) {
        this.setState({
          staff_list: newProps.staff_list,
          staff_jobs: newProps.staff_jobs,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     function: this.state.function,
    //     company: this.state.company,
    //     date_start: this.state.date_start,
    //     date_finish: this.state.date_finish,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/experiencia_profissional', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_jobs: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // // Fetch ativando um item
    // ativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar essa experiência profissional?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/experiencia_profissional/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_jobs: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch deletando um item
    // desativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar essa experiência profissional?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/experiencia_profissional/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_jobs: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/experiencia_profissional/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ staff_jobs: responseJson.data, only_active: 0 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'refreshDataActive',
    value: function refreshDataActive(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/experiencia_profissional/ativas/' + self.state.staff_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_jobs: responseJson.data, only_active: 1 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
    // delete($staff_job_id) {
    //   var confirm = window.confirm('Tem certeza que deseja deletar essa experiência profissional?');
    //   if (confirm) {
    //     var self = this;
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/experiencia_profissional/' + $staff_job_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.refreshData(responseJson);
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabExperienciaProfissional.titutloExperienciaProfissional
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_jobs === null || typeof this.state.staff_jobs === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabExperienciaProfissional.nenhumaExperienciaProfissionalCadastrada
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabExperienciaProfissional.tabela.DataInicial
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabExperienciaProfissional.tabela.DataFinal
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabExperienciaProfissional.tabela.Empresa
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabExperienciaProfissional.tabela.Funcao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabExperienciaProfissional.tabela.Status
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_jobs).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_jobs[k].date_start_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_jobs[k].date_finish_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_jobs[k].company
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_jobs[k].function
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_jobs[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabExperienciaProfissional.tabela.Ativo
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabExperienciaProfissional.tabela.Arquivado
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffJobsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffJobsTab);

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário



var StaffLanguagesTab = function (_Component) {
  _inherits(StaffLanguagesTab, _Component);

  function StaffLanguagesTab(props) {
    var _this$state;

    _classCallCheck(this, StaffLanguagesTab);

    var _this = _possibleConstructorReturn(this, (StaffLanguagesTab.__proto__ || Object.getPrototypeOf(StaffLanguagesTab)).call(this, props));

    _this.state = (_this$state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      staff_id: _this.props.staff_id,
      coeficient: null,
      name: null,
      date_start: '',
      expiration: ''
    }, _defineProperty(_this$state, 'only_active', 1), _defineProperty(_this$state, 'staff_languages', []), _this$state);

    //bind específico
    // this.add = this.add.bind(this);
    // this.ativar = this.ativar.bind(this);
    // this.desativar = this.desativar.bind(this);
    // this.delete = this.delete.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);
    _this.refreshDataActive = _this.refreshDataActive.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // }
  // LM


  _createClass(StaffLanguagesTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.staff_languages)) {
        this.setState({
          staff_languages: newProps.staff_languages,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     coeficient: this.state.coeficient,
    //     only_active: this.state.only_active,
    //     name: this.state.name,
    //     date_start: this.state.date_start,
    //     expiration: this.state.expiration,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/prova_idioma', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.setState({ staff_languages: responseJson.data });
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // // Fetch ativando um item
    // ativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar essa prova de idioma?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/prova_idioma/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_languages: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

    // // Fetch deletando um item
    // desativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar essa prova de idioma?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/prova_idioma/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_languages: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/prova_idioma/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ staff_languages: responseJson.data, only_active: 0 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'refreshDataActive',
    value: function refreshDataActive(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/prova_idioma/ativas/' + self.state.staff_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_languages: responseJson.data, only_active: 1 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }

    // delete($staff_language_id) {
    //   var confirm = window.confirm('Tem certeza que deseja deletar essa experiência profissional?');
    //   if (confirm) {
    //     var self = this;
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/prova_idioma/' + $staff_language_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.refreshData(responseJson);
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabProvasDeIdioma.tituloListaDeProvasDeIdioma
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_languages === null || typeof this.state.staff_languages === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabProvasDeIdioma.nenhumaProvasDeIdiomaCadastrada
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabProvasDeIdioma.tabela.Coeficiente
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabProvasDeIdioma.tabela.Idioma
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabProvasDeIdioma.tabela.Emissao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabProvasDeIdioma.tabela.Vencimento
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabProvasDeIdioma.tabela.Status
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_languages).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_languages[k].coeficient
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_languages[k].name
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_languages[k].date_start_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_languages[k].expiration_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_languages[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabProvasDeIdioma.tabela.Ativo
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabProvasDeIdioma.tabela.Arquivado
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffLanguagesTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffLanguagesTab);

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário




var StaffLicensesTab = function (_Component) {
  _inherits(StaffLicensesTab, _Component);

  function StaffLicensesTab(props) {
    _classCallCheck(this, StaffLicensesTab);

    var _this = _possibleConstructorReturn(this, (StaffLicensesTab.__proto__ || Object.getPrototypeOf(StaffLicensesTab)).call(this, props));

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__["a" /* default */])();

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      staff_id: _this.props.staff_id,
      name: null,
      type: null,
      only_active: 1,
      expiration: '',
      dispatch: '',
      staff_licenses: [],
      license_names: [{ value: "AVI", label: _this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.opcoesNome.AVI }, { value: "CEL", label: _this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.opcoesNome.CEL }, { value: "GMP", label: _this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.opcoesNome.GMP }],
      license_types: [{ value: "", label: _this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.opcoesTipo.SelecionarTipo }, { value: "CHT", label: _this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.opcoesTipo.CHT }, { value: "CCT", label: _this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.opcoesTipo.CCT }]
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.updateLicenses = this.updateLicenses.bind(this);
    // this.ativar = this.ativar.bind(this);
    // this.desativar = this.desativar.bind(this);
    // this.addToRevision = this.addToRevision.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);
    _this.refreshDataActive = _this.refreshDataActive.bind(_this);
    return _this;
  }

  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }
  // handleToggleChange (name, event) {
  //   var change = {};
  //   if (event.target.checked === true) {
  //     var value = 1;
  //   } else {
  //     var value = 0;
  //   }
  //   change[name] = value;
  //   this.setState(change);
  // }

  // LM


  _createClass(StaffLicensesTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.staff_licenses)) {
        this.setState({
          staff_licenses: newProps.staff_licenses,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   var self = this;
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     name: this.state.name,
    //     type: this.state.type,
    //     expiration: this.state.expiration,
    //     dispatch: this.state.dispatch,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/habilitacao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.setState({ staff_licenses: responseJson.data });
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // // Fetch salvando a edição
    // addToRevision(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de associar essa habilitação a uma revisão de designação aberta?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/revisao/habilitacao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch ativando um item
    // ativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar essa habilitação?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/habilitacao/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_licenses: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch deletando um item
    // desativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar essa habilitação?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/habilitacao/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_licenses: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/habilitacoes/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ staff_licenses: responseJson.data, only_active: 0 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'refreshDataActive',
    value: function refreshDataActive(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/habilitacoes/ativas/' + self.state.staff_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_licenses: responseJson.data, only_active: 1 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }

    // updateLicenses(event) {
    //   var id = event;
    //   var confirm = window.confirm('Tem certeza que gostaria de atualizar habilitações desse colaborador?');
    //   if (confirm) {
    //     var datasave = {
    //       only_active: this.state.only_active,
    //       staff_id: id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/atualizar/habilitacoes', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_licenses: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.tituloHabilitacoes
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_licenses === null || typeof this.state.staff_licenses === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.nenhumaHabilitacaoCadastrada
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.tabela.Tipo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.tabela.Nome
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.tabela.Expedicao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.tabela.Vencimento
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.tabela.Valido,
                  '?'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.tabela.Status
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_licenses).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_licenses[k].type
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_licenses[k].name
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_licenses[k].dispatch_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_licenses[k].expiration_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_licenses[k].expire_status_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_licenses[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.tabela.Ativo
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.tabela.Arquivado
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffLicensesTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffLicensesTab);

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário





var StaffNeededTrainingsModal = function (_Component) {
  _inherits(StaffNeededTrainingsModal, _Component);

  function StaffNeededTrainingsModal(props) {
    _classCallCheck(this, StaffNeededTrainingsModal);

    var _this = _possibleConstructorReturn(this, (StaffNeededTrainingsModal.__proto__ || Object.getPrototypeOf(StaffNeededTrainingsModal)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      show_other: false,
      staff_needed_training_id: _this.props.data_modal_new.staff_needed_training_id,
      date: _this.props.data_modal_new.date,
      motivo: _this.props.data_modal_new.motivo,
      other_reason: _this.props.data_modal_new.other_reason,
      conhecimento_analise: _this.props.data_modal_new.conhecimento_analise,
      outras_atividades: _this.props.data_modal_new.outras_atividades,
      print_integracao: _this.props.data_modal_new.print_integracao,
      print_geral: _this.props.data_modal_new.print_geral,
      print_sup: _this.props.data_modal_new.print_sup,
      print_fer: _this.props.data_modal_new.print_fer,
      print_mnt: _this.props.data_modal_new.print_mnt,
      print_eng: _this.props.data_modal_new.print_eng,
      print_ctm: _this.props.data_modal_new.print_ctm,
      print_sasc: _this.props.data_modal_new.print_sasc,
      print_qua: _this.props.data_modal_new.print_qua,
      print_inspetores: _this.props.data_modal_new.print_inspetores,
      print_rampa: _this.props.data_modal_new.print_rampa,
      apoio_corrosao: _this.props.data_modal_new.apoio_corrosao,
      apoio_pbn: _this.props.data_modal_new.apoio_pbn,
      apoio_hums1: _this.props.data_modal_new.apoio_hums1,
      apoio_hums2: _this.props.data_modal_new.apoio_hums2,
      apoio_ingles: _this.props.data_modal_new.apoio_ingles,
      apoio_boroscopia: _this.props.data_modal_new.apoio_boroscopia,
      apoio_fatores_humanos: _this.props.data_modal_new.apoio_fatores_humanos,
      apoio_orientacao_pedagogica: _this.props.data_modal_new.apoio_orientacao_pedagogica,
      apoio_artigos_perigosos: _this.props.data_modal_new.apoio_artigos_perigosos,
      apoio_eos: _this.props.data_modal_new.apoio_eos,
      staff_id: _this.props.data_modal_new.staff_id,
      modal_new: false,
      aeronaves: null,
      motores: null,
      oficinas: null,
      funcao: null,
      organizacao: null,
      periodo: null,
      staff_needed_training_items: {},
      staff_needed_trainings: {}
    };
    // this.edit = this.edit.bind(this);
    // this.addItemProduct = this.addItemProduct.bind(this);
    // this.addItemKnowledge = this.addItemKnowledge.bind(this);
    // this.deleteItemKnowledge = this.deleteItemKnowledge.bind(this);
    // this.deleteItemProduct = this.deleteItemProduct.bind(this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(StaffNeededTrainingsModal, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
      if (event.value === 'Outro') {
        this.setState({ show_other: true });
      } else {
        this.setState({ show_other: false });
      }
    }
  }, {
    key: 'handleCheckboxChange',
    value: function handleCheckboxChange(name, event) {
      var change = {};
      if (event.target.checked == true) {
        change[event.target.name] = true;
      } else {
        change[event.target.name] = false;
      }
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.data_modal_new.staff_needed_training_items)) {
        this.setState({
          data_modal_new: newProps.data_modal_new,
          staff_needed_training_id: newProps.data_modal_new.id,
          date: newProps.data_modal_new.date_str,
          motivo: newProps.data_modal_new.motivo,
          other_reason: newProps.data_modal_new.other_reason,
          conhecimento_analise: newProps.data_modal_new.conhecimento_analise,
          outras_atividades: newProps.data_modal_new.outras_atividades,
          print_integracao: newProps.data_modal_new.print_integracao,
          print_geral: newProps.data_modal_new.print_geral,
          print_sup: newProps.data_modal_new.print_sup,
          print_fer: newProps.data_modal_new.print_fer,
          print_mnt: newProps.data_modal_new.print_mnt,
          print_eng: newProps.data_modal_new.print_eng,
          print_ctm: newProps.data_modal_new.print_ctm,
          print_sasc: newProps.data_modal_new.print_sasc,
          print_qua: newProps.data_modal_new.print_qua,
          print_inspetores: newProps.data_modal_new.print_inspetores,
          print_rampa: newProps.data_modal_new.print_rampa,
          apoio_corrosao: newProps.data_modal_new.apoio_corrosao,
          apoio_pbn: newProps.data_modal_new.apoio_pbn,
          apoio_hums1: newProps.data_modal_new.apoio_hums1,
          apoio_hums2: newProps.data_modal_new.apoio_hums2,
          apoio_ingles: newProps.data_modal_new.apoio_ingles,
          apoio_boroscopia: newProps.data_modal_new.apoio_boroscopia,
          apoio_fatores_humanos: newProps.data_modal_new.apoio_fatores_humanos,
          apoio_orientacao_pedagogica: newProps.data_modal_new.apoio_orientacao_pedagogica,
          apoio_artigos_perigosos: newProps.data_modal_new.apoio_artigos_perigosos,
          apoio_eos: newProps.data_modal_new.apoio_eos,
          staff_id: newProps.data_modal_new.staff_id,
          staff_needed_training_items: newProps.data_modal_new.staff_needed_training_items,
          staff_needed_trainings: newProps.staff_needed_trainings,
          loaded: 1
        });
        if (newProps.data_modal_new.motivo === 'Outro') {}
      }
      this.setState({ modal_new: newProps.modal_new });
    }

    // Fetch salvando a edição

  }, {
    key: 'edit',
    value: function edit(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: this.state.staff_needed_training_id,
        date: this.state.date,
        outras_atividades: this.state.outras_atividades,
        motivo: this.state.motivo,
        other_reason: this.state.other_reason,
        print_integracao: this.state.print_integracao,
        print_geral: this.state.print_geral,
        print_sup: this.state.print_sup,
        print_fer: this.state.print_fer,
        print_mnt: this.state.print_mnt,
        print_eng: this.state.print_eng,
        print_ctm: this.state.print_ctm,
        print_sasc: this.state.print_sasc,
        print_qua: this.state.print_qua,
        print_inspetores: this.state.print_inspetores,
        print_rampa: this.state.print_rampa,
        apoio_corrosao: this.state.apoio_corrosao,
        apoio_pbn: this.state.apoio_pbn,
        apoio_hums1: this.state.apoio_hums1,
        apoio_hums2: this.state.apoio_hums2,
        apoio_ingles: this.state.apoio_ingles,
        apoio_boroscopia: this.state.apoio_boroscopia,
        apoio_fatores_humanos: this.state.apoio_fatores_humanos,
        apoio_orientacao_pedagogica: this.state.apoio_orientacao_pedagogica,
        apoio_artigos_perigosos: this.state.apoio_artigos_perigosos,
        apoio_eos: this.state.apoio_eos
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/necessidade/treinamento/novo', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ staff_needed_trainings: responseJson.data });
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'addItemKnowledge',
    value: function addItemKnowledge(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var datasave = {
        staff_needed_training_id: this.state.staff_needed_training_id,
        staff_id: this.state.staff_id,
        funcao: this.state.funcao,
        organizacao: this.state.organizacao,
        periodo: this.state.periodo
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/necessidade/treinamento/item/conhecimento/novo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ staff_needed_trainings: responseJson.data.staff_needed_trainings, staff_needed_training_items: responseJson.data.staff_needed_training_items });
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'addItemProduct',
    value: function addItemProduct(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var datasave = {
        staff_needed_training_id: this.state.staff_needed_training_id,
        staff_id: this.state.staff_id,
        aeronaves: this.state.aeronaves,
        motores: this.state.motores,
        oficinas: this.state.oficinas
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/necessidade/treinamento/item/produto/novo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ staff_needed_trainings: responseJson.data.staff_needed_trainings, staff_needed_training_items: responseJson.data.staff_needed_training_items });
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'deleteItemKnowledge',
    value: function deleteItemKnowledge(staff_needed_training_item_id) {
      if (window.confirm(this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.deletarItem)) {
        this.props.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/necessidade/treinamento/item/' + staff_needed_training_item_id, { method: 'DELETE', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({ staff_needed_trainings: responseJson.data.staff_needed_trainings, staff_needed_training_items: responseJson.data.staff_needed_training_items });
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'deleteItemProduct',
    value: function deleteItemProduct(staff_needed_training_item_id) {
      if (window.confirm(this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.deletarItem)) {
        this.props.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/necessidade/treinamento/item/' + staff_needed_training_item_id, { method: 'DELETE', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({ staff_needed_trainings: responseJson.data.staff_needed_trainings, staff_needed_training_items: responseJson.data.staff_needed_training_items });
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal_new, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tituloEditarNecessidadeDeTreinamento
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  _this2.props.closeModalNew(self.state.staff_needed_trainings);
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.edit },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.Data,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.date, disabled: true, maskChar: null, name: 'date', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date'), placeholder: '' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.MotivoDaAnalise,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                    disabled: true,
                    className: 'form-field-name',
                    name: 'motivo',
                    value: this.state.motivo,
                    searchable: true,
                    placeholder: '',
                    onChange: this.handleSelectChange.bind(this, 'motivo'),
                    options: [{ value: 'Contratação do Colaborador', label: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.opcoesMotivoDaAnalise.ContratacaoDoColaborador }, { value: 'Nova Função do Colaborador', label: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.opcoesMotivoDaAnalise.NovaFuncaoDoColaborador }, { value: 'Promoção do Colaborador', label: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.opcoesMotivoDaAnalise.PromocaoDoColaborador }, { value: 'Outro', label: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.opcoesMotivoDaAnalise.Outro }]
                  }),
                  self.state.show_other ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.PreenchaOMotivo,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { disabled: true, value: this.state.other_reason, name: 'other_reason', className: 'form-control', onChange: this.handleChange.bind(this, 'other_reason'), placeholder: '' })
                  ) : ''
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.OutrasAtividades,
                  ':'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', { name: 'outras_atividades', disabled: true, className: 'form-control', value: this.state.outras_atividades, onChange: this.handleChange.bind(this, 'outras_atividades'), style: { height: 200 } })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                null,
                this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.tituloProcedimentosInternos
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'print_integracao',
                      type: 'checkbox',
                      checked: self.state.print_integracao,
                      onChange: self.handleCheckboxChange.bind(self, self.state.print_integracao) }),
                    '\xA0\xA0',
                    this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.Integracao
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'print_geral',
                      type: 'checkbox',
                      checked: self.state.print_geral,
                      onChange: self.handleCheckboxChange.bind(self, self.state.print_geral) }),
                    '\xA0\xA0',
                    this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.Geral
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'print_sup',
                      type: 'checkbox',
                      checked: self.state.print_sup,
                      onChange: self.handleCheckboxChange.bind(self, self.state.print_sup) }),
                    '\xA0\xA0',
                    this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.SUP
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'print_fer',
                      type: 'checkbox',
                      checked: self.state.print_fer,
                      onChange: self.handleCheckboxChange.bind(self, self.state.print_fer) }),
                    '\xA0\xA0',
                    this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.FER
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'print_mnt',
                      type: 'checkbox',
                      checked: self.state.print_mnt,
                      onChange: self.handleCheckboxChange.bind(self, self.state.print_mnt) }),
                    '\xA0\xA0',
                    this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.MNT
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'print_eng',
                      type: 'checkbox',
                      checked: self.state.print_eng,
                      onChange: self.handleCheckboxChange.bind(self, self.state.print_eng) }),
                    '\xA0\xA0',
                    this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.ENG
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'print_ctm',
                      type: 'checkbox',
                      checked: self.state.print_ctm,
                      onChange: self.handleCheckboxChange.bind(self, self.state.print_ctm) }),
                    '\xA0\xA0',
                    this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.CTM
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'print_sasc',
                      type: 'checkbox',
                      checked: self.state.print_sasc,
                      onChange: self.handleCheckboxChange.bind(self, self.state.print_sasc) }),
                    '\xA0\xA0',
                    this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.SASC
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'print_qua',
                      type: 'checkbox',
                      checked: self.state.print_qua,
                      onChange: self.handleCheckboxChange.bind(self, self.state.print_qua) }),
                    '\xA0\xA0',
                    this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.QUA
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'print_inspetores',
                      type: 'checkbox',
                      checked: self.state.print_inspetores,
                      onChange: self.handleCheckboxChange.bind(self, self.state.print_inspetores) }),
                    '\xA0\xA0',
                    this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.Inspetores
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'print_rampa',
                      type: 'checkbox',
                      checked: self.state.print_rampa,
                      onChange: self.handleCheckboxChange.bind(self, self.state.print_rampa) }),
                    '\xA0\xA0',
                    this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.Rampa
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'print_eng',
                      type: 'checkbox',
                      checked: self.state.print_eng,
                      onChange: self.handleCheckboxChange.bind(self, self.state.print_eng) }),
                    '\xA0\xA0',
                    this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.ENG
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                null,
                this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.tituloApoio
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'apoio_corrosao',
                      type: 'checkbox',
                      checked: self.state.apoio_corrosao,
                      onChange: self.handleCheckboxChange.bind(self, self.state.apoio_corrosao) }),
                    '\xA0\xA0',
                    this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.Corrosao
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'apoio_pbn',
                      type: 'checkbox',
                      checked: self.state.apoio_pbn,
                      onChange: self.handleCheckboxChange.bind(self, self.state.apoio_pbn) }),
                    '\xA0\xA0',
                    this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.PBN
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'apoio_hums1',
                      type: 'checkbox',
                      checked: self.state.apoio_hums1,
                      onChange: self.handleCheckboxChange.bind(self, self.state.apoio_hums1) }),
                    '\xA0\xA0',
                    this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.HUMSNivel1
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'apoio_hums2',
                      type: 'checkbox',
                      checked: self.state.apoio_hums2,
                      onChange: self.handleCheckboxChange.bind(self, self.state.apoio_hums2) }),
                    '\xA0\xA0',
                    this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.HUMSNivel2
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'apoio_ingles',
                      type: 'checkbox',
                      checked: self.state.apoio_ingles,
                      onChange: self.handleCheckboxChange.bind(self, self.state.apoio_ingles) }),
                    '\xA0\xA0',
                    this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.Ingles
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'apoio_boroscopia',
                      type: 'checkbox',
                      checked: self.state.apoio_boroscopia,
                      onChange: self.handleCheckboxChange.bind(self, self.state.apoio_boroscopia) }),
                    '\xA0\xA0',
                    this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.Boroscopia
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'apoio_fatores_humanos',
                      type: 'checkbox',
                      checked: self.state.apoio_fatores_humanos,
                      onChange: self.handleCheckboxChange.bind(self, self.state.apoio_fatores_humanos) }),
                    '\xA0\xA0',
                    this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.FatoresHumanos
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'apoio_orientacao_pedagogica',
                      type: 'checkbox',
                      checked: self.state.apoio_orientacao_pedagogica,
                      onChange: self.handleCheckboxChange.bind(self, self.state.apoio_orientacao_pedagogica) }),
                    '\xA0\xA0',
                    this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.Orientacao,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.Pedagogica
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'apoio_artigos_perigosos',
                      type: 'checkbox',
                      checked: self.state.apoio_artigos_perigosos,
                      onChange: self.handleCheckboxChange.bind(self, self.state.apoio_artigos_perigosos) }),
                    '\xA0\xA0',
                    this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.ArtigosPerigosos
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'apoio_eos',
                      type: 'checkbox',
                      checked: self.state.apoio_eos,
                      onChange: self.handleCheckboxChange.bind(self, self.state.apoio_eos) }),
                    '\xA0\xA0',
                    this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.formularioEditarNecessidadeDeTreinamento.EOS
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h4',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tituloTreinamentosDeProdutos
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'table',
                  { className: 'table table-bordered table-stripped table-hover' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'thead',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center' },
                        this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaTreinamentosDeProdutos.Aeronaves
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center' },
                        this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaTreinamentosDeProdutos.Motores
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center' },
                        this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaTreinamentosDeProdutos.Oficinas
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tbody',
                    null,
                    Object.keys(self.state.staff_needed_training_items).map(function (k) {
                      if (self.state.staff_needed_training_items[k].type === 'produto') {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'tr',
                          null,
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'td',
                            { className: 'text-center' },
                            self.state.staff_needed_training_items[k].aeronaves
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'td',
                            { className: 'text-center' },
                            self.state.staff_needed_training_items[k].motores
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'td',
                            { className: 'text-center' },
                            self.state.staff_needed_training_items[k].oficinas
                          )
                        );
                      } else {
                        return '';
                      }
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h4',
                  null,
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tituloConhecimentoTreinamentoEExperienciaAnterior
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'table',
                  { className: 'table table-bordered table-stripped table-hover' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'thead',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center' },
                        this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaConhecimentoTreinamentoEExperienciaAnterior.Descricao
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center' },
                        this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaConhecimentoTreinamentoEExperienciaAnterior.Organizacao
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center' },
                        this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaConhecimentoTreinamentoEExperienciaAnterior.Periodo
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tbody',
                    null,
                    Object.keys(self.state.staff_needed_training_items).map(function (k) {
                      if (self.state.staff_needed_training_items[k].type !== 'produto') {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'tr',
                          null,
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'td',
                            { className: 'text-center' },
                            self.state.staff_needed_training_items[k].funcao
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'td',
                            { className: 'text-center' },
                            self.state.staff_needed_training_items[k].organizacao
                          ),
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'td',
                            { className: 'text-center' },
                            self.state.staff_needed_training_items[k].periodo
                          )
                        );
                      } else {
                        return '';
                      }
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  _this2.props.closeModalNew(self.state.staff_needed_trainings);
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return StaffNeededTrainingsModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffNeededTrainingsModal);

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(16);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário




var StaffNeededTrainingsOldModal = function (_Component) {
  _inherits(StaffNeededTrainingsOldModal, _Component);

  function StaffNeededTrainingsOldModal(props) {
    _classCallCheck(this, StaffNeededTrainingsOldModal);

    var _this = _possibleConstructorReturn(this, (StaffNeededTrainingsOldModal.__proto__ || Object.getPrototypeOf(StaffNeededTrainingsOldModal)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      show_other: false,
      staff_needed_training_id: _this.props.data_modal_old.staff_needed_training_id,
      date: _this.props.data_modal_old.date,
      motivo: _this.props.data_modal_old.motivo,
      other_reason: _this.props.data_modal_old.other_reason,
      conhecimento_analise: _this.props.data_modal_old.conhecimento_analise,
      outras_atividades: _this.props.data_modal_old.outras_atividades,
      print_integracao: _this.props.data_modal_old.print_integracao,
      print_geral: _this.props.data_modal_old.print_geral,
      print_sup: _this.props.data_modal_old.print_sup,
      print_fer: _this.props.data_modal_old.print_fer,
      print_mnt: _this.props.data_modal_old.print_mnt,
      print_eng: _this.props.data_modal_old.print_eng,
      print_ctm: _this.props.data_modal_old.print_ctm,
      print_sasc: _this.props.data_modal_old.print_sasc,
      print_qua: _this.props.data_modal_old.print_qua,
      print_inspetores: _this.props.data_modal_old.print_inspetores,
      print_rampa: _this.props.data_modal_old.print_rampa,
      apoio_corrosao: _this.props.data_modal_old.apoio_corrosao,
      apoio_pbn: _this.props.data_modal_old.apoio_pbn,
      apoio_hums1: _this.props.data_modal_old.apoio_hums1,
      apoio_hums2: _this.props.data_modal_old.apoio_hums2,
      apoio_ingles: _this.props.data_modal_old.apoio_ingles,
      apoio_boroscopia: _this.props.data_modal_old.apoio_boroscopia,
      apoio_fatores_humanos: _this.props.data_modal_old.apoio_fatores_humanos,
      apoio_orientacao_pedagogica: _this.props.data_modal_old.apoio_orientacao_pedagogica,
      apoio_artigos_perigosos: _this.props.data_modal_old.apoio_artigos_perigosos,
      apoio_eos: _this.props.data_modal_old.apoio_eos,
      staff_id: _this.props.data_modal_old.staff_id,
      modal_old: false,
      aeronaves: null,
      motores: null,
      oficinas: null,
      funcao: null,
      organizacao: null,
      periodo: null,
      staff_needed_training_items: {},
      staff_needed_trainings: _this.props.data_modal_old
    };

    // this.edit = this.edit.bind(this);
    // this.addItemProduct = this.addItemProduct.bind(this);
    // this.addItemKnowledge = this.addItemKnowledge.bind(this);
    // this.deleteItemKnowledge = this.deleteItemKnowledge.bind(this);
    // this.deleteItemProduct = this.deleteItemProduct.bind(this);
    return _this;
  }

  // Handlers


  _createClass(StaffNeededTrainingsOldModal, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
      if (event.value === 'Outro') {
        this.setState({ show_other: true });
      } else {
        this.setState({ show_other: false });
      }
    }
  }, {
    key: 'handleCheckboxChange',
    value: function handleCheckboxChange(name, event) {
      var change = {};
      if (event.target.checked == true) {
        change[event.target.name] = true;
      } else {
        change[event.target.name] = false;
      }
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.data_modal_old.staff_needed_training_items)) {
        var _setState;

        this.setState((_setState = {
          data_modal_old: newProps.data_modal_old,
          staff_needed_training_id: newProps.data_modal_old.id,
          date: newProps.data_modal_old.date_str,
          motivo: newProps.data_modal_old.motivo,
          other_reason: newProps.data_modal_old.other_reason,
          conhecimento_analise: newProps.data_modal_old.conhecimento_analise,
          outras_atividades: newProps.data_modal_old.outras_atividades
        }, _defineProperty(_setState, 'conhecimento_analise', newProps.data_modal_old.conhecimento_analise), _defineProperty(_setState, 'print_integracao', newProps.data_modal_old.print_integracao), _defineProperty(_setState, 'print_geral', newProps.data_modal_old.print_geral), _defineProperty(_setState, 'print_sup', newProps.data_modal_old.print_sup), _defineProperty(_setState, 'print_fer', newProps.data_modal_old.print_fer), _defineProperty(_setState, 'print_mnt', newProps.data_modal_old.print_mnt), _defineProperty(_setState, 'print_eng', newProps.data_modal_old.print_eng), _defineProperty(_setState, 'print_ctm', newProps.data_modal_old.print_ctm), _defineProperty(_setState, 'print_sasc', newProps.data_modal_old.print_sasc), _defineProperty(_setState, 'print_qua', newProps.data_modal_old.print_qua), _defineProperty(_setState, 'print_inspetores', newProps.data_modal_old.print_inspetores), _defineProperty(_setState, 'print_rampa', newProps.data_modal_old.print_rampa), _defineProperty(_setState, 'apoio_corrosao', newProps.data_modal_old.apoio_corrosao), _defineProperty(_setState, 'apoio_pbn', newProps.data_modal_old.apoio_pbn), _defineProperty(_setState, 'apoio_hums1', newProps.data_modal_old.apoio_hums1), _defineProperty(_setState, 'apoio_hums2', newProps.data_modal_old.apoio_hums2), _defineProperty(_setState, 'apoio_ingles', newProps.data_modal_old.apoio_ingles), _defineProperty(_setState, 'apoio_boroscopia', newProps.data_modal_old.apoio_boroscopia), _defineProperty(_setState, 'apoio_fatores_humanos', newProps.data_modal_old.apoio_fatores_humanos), _defineProperty(_setState, 'apoio_orientacao_pedagogica', newProps.data_modal_old.apoio_orientacao_pedagogica), _defineProperty(_setState, 'apoio_artigos_perigosos', newProps.data_modal_old.apoio_artigos_perigosos), _defineProperty(_setState, 'apoio_eos', newProps.data_modal_old.apoio_eos), _defineProperty(_setState, 'staff_id', newProps.data_modal_old.staff_id), _defineProperty(_setState, 'staff_needed_training_items', newProps.data_modal_old.staff_needed_training_items), _defineProperty(_setState, 'staff_needed_trainings', newProps.staff_needed_trainings), _defineProperty(_setState, 'loaded', 1), _setState));

        if (newProps.data_modal_old.motivo === 'Outro') {}
      }
      this.setState({ modal_old: newProps.modal_old });
    }

    // Fetch salvando a edição
    // edit(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     id: this.state.staff_needed_training_id,
    //     date: this.state.date,
    //     outras_atividades: this.state.outras_atividades,
    //     conhecimento_analise: this.state.conhecimento_analise,
    //     motivo: this.state.motivo,
    //     other_reason: this.state.other_reason,
    //     print_integracao: this.state.print_integracao,
    //     print_geral: this.state.print_geral,
    //     print_sup: this.state.print_sup,
    //     print_fer: this.state.print_fer,
    //     print_mnt: this.state.print_mnt,
    //     print_eng: this.state.print_eng,
    //     print_ctm: this.state.print_ctm,
    //     print_sasc: this.state.print_sasc,
    //     print_qua: this.state.print_qua,
    //     print_inspetores: this.state.print_inspetores,
    //     print_rampa: this.state.print_rampa,
    //     apoio_corrosao: this.state.apoio_corrosao,
    //     apoio_pbn: this.state.apoio_pbn,
    //     apoio_hums1: this.state.apoio_hums1,
    //     apoio_hums2: this.state.apoio_hums2,
    //     apoio_ingles: this.state.apoio_ingles,
    //     apoio_boroscopia: this.state.apoio_boroscopia,
    //     apoio_fatores_humanos: this.state.apoio_fatores_humanos,
    //     apoio_orientacao_pedagogica: this.state.apoio_orientacao_pedagogica,
    //     apoio_artigos_perigosos: this.state.apoio_artigos_perigosos,
    //     apoio_eos: this.state.apoio_eos,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/necessidade/treinamento/novo', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.setState({staff_needed_trainings: responseJson.data});
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // addItemKnowledge(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_needed_training_id: this.state.staff_needed_training_id,
    //     staff_id: this.state.staff_id,
    //     funcao: this.state.funcao,
    //     organizacao: this.state.organizacao,
    //     periodo: this.state.periodo,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/necessidade/treinamento/item/conhecimento/novo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.setState({staff_needed_trainings: responseJson.data.staff_needed_trainings, staff_needed_training_items: responseJson.data.staff_needed_training_items});
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // addItemProduct(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_needed_training_id: this.state.staff_needed_training_id,
    //     staff_id: this.state.staff_id,
    //     aeronaves: this.state.aeronaves,
    //     motores: this.state.motores,
    //     oficinas: this.state.oficinas,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/necessidade/treinamento/item/produto/novo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.setState({staff_needed_trainings: responseJson.data.staff_needed_trainings, staff_needed_training_items: responseJson.data.staff_needed_training_items});
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }


    // deleteItemKnowledge(staff_needed_training_item_id) {
    //   if (window.confirm('Tem certeza que gostaria de deletar esse item?')) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/necessidade/treinamento/item/' + staff_needed_training_item_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({staff_needed_trainings: responseJson.data.staff_needed_trainings, staff_needed_training_items: responseJson.data.staff_needed_training_items});
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

    // deleteItemProduct(staff_needed_training_item_id) {
    //   if (window.confirm('Tem certeza que gostaria de deletar esse item?')) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/necessidade/treinamento/item/' + staff_needed_training_item_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({staff_needed_trainings: responseJson.data.staff_needed_trainings, staff_needed_training_items: responseJson.data.staff_needed_training_items});
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal_old, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              'Editar necessidade de treinamento'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  _this2.props.closeModalOld(self.state.staff_needed_trainings);
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.edit },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Data:'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.date, disabled: true, maskChar: null, name: 'date', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date'), placeholder: '' })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Conhecimento e treinamento:'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', { name: 'conhecimento_analise', disabled: true, className: 'form-control', value: this.state.conhecimento_analise, onChange: this.handleChange.bind(this, 'conhecimento_analise'), style: { height: 200 } })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    'Outras atividades:'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', { name: 'outras_atividades', disabled: true, className: 'form-control', value: this.state.outras_atividades, onChange: this.handleChange.bind(this, 'outras_atividades'), style: { height: 200 } })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                null,
                'Procedimentos internos'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'print_integracao',
                      type: 'checkbox',
                      checked: self.state.print_integracao,
                      onChange: self.handleCheckboxChange.bind(self, self.state.print_integracao) }),
                    '\xA0\xA0Integra\xE7\xE3o'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'print_geral',
                      type: 'checkbox',
                      checked: self.state.print_geral,
                      onChange: self.handleCheckboxChange.bind(self, self.state.print_geral) }),
                    '\xA0\xA0Geral'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'print_sup',
                      type: 'checkbox',
                      checked: self.state.print_sup,
                      onChange: self.handleCheckboxChange.bind(self, self.state.print_sup) }),
                    '\xA0\xA0SUP'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'print_fer',
                      type: 'checkbox',
                      checked: self.state.print_fer,
                      onChange: self.handleCheckboxChange.bind(self, self.state.print_fer) }),
                    '\xA0\xA0FER'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'print_mnt',
                      type: 'checkbox',
                      checked: self.state.print_mnt,
                      onChange: self.handleCheckboxChange.bind(self, self.state.print_mnt) }),
                    '\xA0\xA0MNT'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'print_eng',
                      type: 'checkbox',
                      checked: self.state.print_eng,
                      onChange: self.handleCheckboxChange.bind(self, self.state.print_eng) }),
                    '\xA0\xA0ENG'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'print_ctm',
                      type: 'checkbox',
                      checked: self.state.print_ctm,
                      onChange: self.handleCheckboxChange.bind(self, self.state.print_ctm) }),
                    '\xA0\xA0CTM'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'print_sasc',
                      type: 'checkbox',
                      checked: self.state.print_sasc,
                      onChange: self.handleCheckboxChange.bind(self, self.state.print_sasc) }),
                    '\xA0\xA0SASC'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'print_qua',
                      type: 'checkbox',
                      checked: self.state.print_qua,
                      onChange: self.handleCheckboxChange.bind(self, self.state.print_qua) }),
                    '\xA0\xA0QUA'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'print_inspetores',
                      type: 'checkbox',
                      checked: self.state.print_inspetores,
                      onChange: self.handleCheckboxChange.bind(self, self.state.print_inspetores) }),
                    '\xA0\xA0Inspetores'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'print_rampa',
                      type: 'checkbox',
                      checked: self.state.print_rampa,
                      onChange: self.handleCheckboxChange.bind(self, self.state.print_rampa) }),
                    '\xA0\xA0Rampa'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'print_eng',
                      type: 'checkbox',
                      checked: self.state.print_eng,
                      onChange: self.handleCheckboxChange.bind(self, self.state.print_eng) }),
                    '\xA0\xA0ENG'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                null,
                'Apoio'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'apoio_corrosao',
                      type: 'checkbox',
                      checked: self.state.apoio_corrosao,
                      onChange: self.handleCheckboxChange.bind(self, self.state.apoio_corrosao) }),
                    '\xA0\xA0Corros\xE3o'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'apoio_pbn',
                      type: 'checkbox',
                      checked: self.state.apoio_pbn,
                      onChange: self.handleCheckboxChange.bind(self, self.state.apoio_pbn) }),
                    '\xA0\xA0PBN'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'apoio_hums1',
                      type: 'checkbox',
                      checked: self.state.apoio_hums1,
                      onChange: self.handleCheckboxChange.bind(self, self.state.apoio_hums1) }),
                    '\xA0\xA0HUMS N\xEDvel 1'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'apoio_hums2',
                      type: 'checkbox',
                      checked: self.state.apoio_hums2,
                      onChange: self.handleCheckboxChange.bind(self, self.state.apoio_hums2) }),
                    '\xA0\xA0HUMS N\xEDvel 2'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'apoio_ingles',
                      type: 'checkbox',
                      checked: self.state.apoio_ingles,
                      onChange: self.handleCheckboxChange.bind(self, self.state.apoio_ingles) }),
                    '\xA0\xA0Ingl\xEAs'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'apoio_boroscopia',
                      type: 'checkbox',
                      checked: self.state.apoio_boroscopia,
                      onChange: self.handleCheckboxChange.bind(self, self.state.apoio_boroscopia) }),
                    '\xA0\xA0Boroscopia'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'apoio_fatores_humanos',
                      type: 'checkbox',
                      checked: self.state.apoio_fatores_humanos,
                      onChange: self.handleCheckboxChange.bind(self, self.state.apoio_fatores_humanos) }),
                    '\xA0\xA0Fatores Humanos'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'apoio_orientacao_pedagogica',
                      type: 'checkbox',
                      checked: self.state.apoio_orientacao_pedagogica,
                      onChange: self.handleCheckboxChange.bind(self, self.state.apoio_orientacao_pedagogica) }),
                    '\xA0\xA0Orienta\xE7\xE3o',
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    'Pedag\xF3gica'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'apoio_artigos_perigosos',
                      type: 'checkbox',
                      checked: self.state.apoio_artigos_perigosos,
                      onChange: self.handleCheckboxChange.bind(self, self.state.apoio_artigos_perigosos) }),
                    '\xA0\xA0Artigos Perigosos'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-2 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                      disabled: true,
                      name: 'apoio_eos',
                      type: 'checkbox',
                      checked: self.state.apoio_eos,
                      onChange: self.handleCheckboxChange.bind(self, self.state.apoio_eos) }),
                    '\xA0\xA0EOS'
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              'Treinamentos de produtos'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'table',
              { className: 'table table-bordered table-stripped table-hover' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'thead',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    { className: 'text-center' },
                    'Aeronaves'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    { className: 'text-center' },
                    'Motores'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    { className: 'text-center' },
                    'Oficinas'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tbody',
                null,
                Object.keys(self.state.staff_needed_training_items).map(function (k) {
                  if (self.state.staff_needed_training_items[k].type === 'produto') {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        self.state.staff_needed_training_items[k].aeronaves
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        self.state.staff_needed_training_items[k].motores
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: 'text-center' },
                        self.state.staff_needed_training_items[k].oficinas
                      )
                    );
                  } else {
                    return '';
                  }
                })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  _this2.props.closeModalOld(self.state.staff_needed_trainings);
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return StaffNeededTrainingsOldModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffNeededTrainingsOldModal);

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaffNeededTrainingsModal__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StaffNeededTrainingsOldModal__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário







var StaffNeededTrainingsTab = function (_Component) {
  _inherits(StaffNeededTrainingsTab, _Component);

  function StaffNeededTrainingsTab(props) {
    _classCallCheck(this, StaffNeededTrainingsTab);

    var _this = _possibleConstructorReturn(this, (StaffNeededTrainingsTab.__proto__ || Object.getPrototypeOf(StaffNeededTrainingsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      date: null,
      motivo: null,
      other_reason: null,
      conhecimento_analise: null,
      outras_atividades: null,
      print_integracao: null,
      print_geral: null,
      print_sup: null,
      print_fer: null,
      print_mnt: null,
      print_eng: null,
      print_ctm: null,
      print_sasc: null,
      print_qua: null,
      print_inspetores: null,
      print_rampa: null,
      apoio_corrosao: null,
      apoio_pbn: null,
      apoio_hums1: null,
      apoio_hums2: null,
      apoio_ingles: null,
      apoio_boroscopia: null,
      apoio_fatores_humanos: null,
      apoio_orientacao_pedagogica: null,
      apoio_artigos_perigosos: null,
      apoio_eos: null,
      staff_id: _this.props.staff_id,
      show_other: false,
      staff_needed_trainings: [],
      staff_necessities: [],
      modal_new: false,
      modal_old: false,
      data_modal_new: {},
      data_modal_old: {},
      staff_needed_trainings_new: [],
      staff_needed_trainings_old: []
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.addNew = this.addNew.bind(this);
    // this.addOld = this.addOld.bind(this);
    // this.delete = this.delete.bind(this);
    // this.deleteNew = this.deleteNew.bind(this);
    // this.deleteOld = this.deleteOld.bind(this);
    _this.editModalNew = _this.editModalNew.bind(_this);
    _this.closeModalNew = _this.closeModalNew.bind(_this);
    _this.closeModalOld = _this.closeModalOld.bind(_this);
    _this.editModalOld = _this.editModalOld.bind(_this);
    _this.exportNecessity = _this.exportNecessity.bind(_this);
    _this.exportNeeded = _this.exportNeeded.bind(_this);
    _this.exportNeededNew = _this.exportNeededNew.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(StaffNeededTrainingsTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
      if (event.value === 'Outro') {
        this.setState({ show_other: true });
      } else {
        this.setState({ show_other: false });
      }
    }
  }, {
    key: 'handleCheckboxChange',
    value: function handleCheckboxChange(name, event) {
      var change = {};
      if (event.target.checked == true) {
        change[event.target.name] = true;
      } else {
        change[event.target.name] = false;
      }
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.staff_needed_trainings) && Array.isArray(newProps.staff_needed_trainings_new)) {
        this.setState({
          staff_needed_trainings: newProps.staff_needed_trainings,
          staff_needed_trainings_new: newProps.staff_needed_trainings_new,
          staff_necessities: newProps.staff_necessities,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição
    // addNew(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     date: this.state.date,
    //     outras_atividades: this.state.outras_atividades,
    //     motivo: this.state.motivo,
    //     other_reason: this.state.other_reason,
    //     print_integracao: this.state.print_integracao,
    //     print_geral: this.state.print_geral,
    //     print_sup: this.state.print_sup,
    //     print_fer: this.state.print_fer,
    //     print_mnt: this.state.print_mnt,
    //     print_eng: this.state.print_eng,
    //     print_ctm: this.state.print_ctm,
    //     print_sasc: this.state.print_sasc,
    //     print_qua: this.state.print_qua,
    //     print_inspetores: this.state.print_inspetores,
    //     print_rampa: this.state.print_rampa,
    //     apoio_corrosao: this.state.apoio_corrosao,
    //     apoio_pbn: this.state.apoio_pbn,
    //     apoio_hums1: this.state.apoio_hums1,
    //     apoio_hums2: this.state.apoio_hums2,
    //     apoio_ingles: this.state.apoio_ingles,
    //     apoio_boroscopia: this.state.apoio_boroscopia,
    //     apoio_fatores_humanos: this.state.apoio_fatores_humanos,
    //     apoio_orientacao_pedagogica: this.state.apoio_orientacao_pedagogica,
    //     apoio_artigos_perigosos: this.state.apoio_artigos_perigosos,
    //     apoio_eos: this.state.apoio_eos,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/necessidade/treinamento/novo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.setState({ staff_needed_trainings_new: responseJson.data });
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     date: this.state.date,
    //     conhecimento_analise: this.state.conhecimento_analise,
    //     outras_atividades: this.state.outras_atividades,
    //     print_integracao: this.state.print_integracao,
    //     print_geral: this.state.print_geral,
    //     print_sup: this.state.print_sup,
    //     print_fer: this.state.print_fer,
    //     print_mnt: this.state.print_mnt,
    //     print_eng: this.state.print_eng,
    //     print_ctm: this.state.print_ctm,
    //     print_sasc: this.state.print_sasc,
    //     print_qua: this.state.print_qua,
    //     print_inspetores: this.state.print_inspetores,
    //     print_rampa: this.state.print_rampa,
    //     apoio_corrosao: this.state.apoio_corrosao,
    //     apoio_pbn: this.state.apoio_pbn,
    //     apoio_hums1: this.state.apoio_hums1,
    //     apoio_hums2: this.state.apoio_hums2,
    //     apoio_ingles: this.state.apoio_ingles,
    //     apoio_boroscopia: this.state.apoio_boroscopia,
    //     apoio_fatores_humanos: this.state.apoio_fatores_humanos,
    //     apoio_orientacao_pedagogica: this.state.apoio_orientacao_pedagogica,
    //     apoio_artigos_perigosos: this.state.apoio_artigos_perigosos,
    //     apoio_eos: this.state.apoio_eos,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/necessidade/treinamento', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.setState({ staff_needed_trainings: responseJson.data });
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // // Fetch salvando a edição
    // addOld(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     conhecimento: this.state.conhecimento,
    //     experiencia: this.state.experiencia,
    //     oficina: this.state.oficina,
    //     aeronaves: this.state.aeronaves,
    //     motores: this.state.motores,
    //     inspecao: this.state.inspecao,
    //     instrucao: this.state.instrucao,
    //     atividades: this.state.atividades,
    //     date: this.state.date,
    //     only_active: this.state.only_active,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/necessidade/treinamento/antigo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.setState({ staff_necessities: responseJson.data });
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // // Fetch deletando um item
    // delete (event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de delete essa frota?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/necessidade/treinamento/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_needed_trainings: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch deletando um item
    // deleteNew (event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de delete essa frota?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/necessidade/treinamento/novo/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_needed_trainings: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch deletando um item
    // deleteOld (event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de delete essa frota?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/frota_obrigatoria/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_needed_trainings: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

  }, {
    key: 'editModalNew',
    value: function editModalNew(staff_needed_training, staff_needed_trainings) {
      this.setState({ modal_new: true, data_modal_new: staff_needed_training, staff_needed_trainings: staff_needed_trainings });
    }
  }, {
    key: 'closeModalNew',
    value: function closeModalNew(staff_needed_trainings) {
      this.setState({ modal_new: false, staff_needed_trainings_new: staff_needed_trainings });
    }
  }, {
    key: 'editModalOld',
    value: function editModalOld(staff_needed_training, staff_needed_trainings) {
      this.setState({ modal_old: true, data_modal_old: staff_needed_training, staff_needed_trainings: staff_needed_trainings });
    }
  }, {
    key: 'closeModalOld',
    value: function closeModalOld(staff_needed_trainings) {
      this.setState({ modal_old: false, staff_needed_trainings: staff_needed_trainings });
    }
  }, {
    key: 'exportNecessity',
    value: function exportNecessity(event) {
      var self = this;
      var staff_necessity = event;
      var url = '/exportar/necessidade/treinamento/antigo/colaborador/';
      var header = this.refs.request_api.header('application/json');
      self.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + url + staff_necessity, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data);
          }
          self.props.handleAlert('', '', 'closed');
        });
      });
    }
  }, {
    key: 'exportNeeded',
    value: function exportNeeded(event) {
      var self = this;
      var staff_needed_training_id = event;
      var url = '/exportar/necessidade/treinamento/colaborador/';
      var header = this.refs.request_api.header('application/json');
      self.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + url + staff_needed_training_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data);
          }
          self.props.handleAlert('', '', 'closed');
        });
      });
    }
  }, {
    key: 'exportNeededNew',
    value: function exportNeededNew(event) {
      var self = this;
      var staff_needed_training_id = event;
      var url = '/exportar/necessidade/treinamento/colaborador/novo/';
      var header = this.refs.request_api.header('application/json');
      self.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + url + staff_needed_training_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data);
          }
          self.props.handleAlert('', '', 'closed');
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StaffNeededTrainingsModal__["a" /* default */], { modal_new: self.state.modal_new, staff_needed_trainings: self.state.staff_needed_trainings_new, data_modal_new: self.state.data_modal_new, closeModalNew: self.closeModalNew, handleAlert: self.props.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StaffNeededTrainingsOldModal__["a" /* default */], { modal_old: self.state.modal_old, staff_needed_trainings: self.state.staff_needed_trainings, data_modal_old: self.state.data_modal_old, closeModalOld: self.closeModalOld, handleAlert: self.props.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tituloAvaliacaoDeNecessidadeDeTreinamento
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_needed_trainings_new === null || typeof this.state.staff_needed_trainings_new === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.naoHaFormulariosDeAvaliacao
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabela.Data
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabela.MotivoDaAnalise
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabela.OutrasAtividades
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'col-md-2 text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabela.Acoes
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_needed_trainings_new).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_needed_trainings_new[k].date_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_needed_trainings_new[k].motivo
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_needed_trainings_new[k].outras_atividades
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { className: 'btn btn-info btn-sm', onClick: function onClick() {
                          self.exportNeededNew(self.state.staff_needed_trainings_new[k].id);
                        } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { className: 'btn btn-sm btn-primary', onClick: function onClick() {
                          self.editModalNew(self.state.staff_needed_trainings_new[k], self.state.staff_needed_trainings_new);
                        } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
                    )
                  )
                );
              })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tituloAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_needed_trainings === null || typeof this.state.staff_needed_trainings === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.naoHaFormulariosDeAvaliacao
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.Conhecimento
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.OutrasAtividades
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.Data
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'col-md-2 text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.Acoes
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_needed_trainings).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_needed_trainings[k].conhecimento_analise
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_needed_trainings[k].outras_atividades
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_needed_trainings[k].date_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { className: 'btn btn-info btn-sm', onClick: function onClick() {
                          self.exportNeeded(self.state.staff_needed_trainings[k].id);
                        } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { className: 'btn btn-sm btn-primary', onClick: function onClick() {
                          self.editModalOld(self.state.staff_needed_trainings[k], self.state.staff_needed_trainings);
                        } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tituloAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_necessities === null || typeof this.state.staff_necessities === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.naoHaFormulariosDeAvaliacao
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.ConhecimentoETreinamento
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.Experiencia
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.Oficina
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.Aeronaves
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.Motores
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.Inspecao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.Instrucao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.OutrasAtividades
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.Criacao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'col-md-2 text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo.Acoes
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_necessities).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_necessities[k].conhecimento
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_necessities[k].experiencia
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_necessities[k].oficina
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_necessities[k].aeronaves
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_necessities[k].motores
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_necessities[k].inspecao
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_necessities[k].instrucao
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_necessities[k].atividades
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_necessities[k].date_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { className: 'btn btn-info btn-sm', onClick: function onClick() {
                          self.exportNecessity(self.state.staff_necessities[k].id);
                        } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' })
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
      );
    }
  }]);

  return StaffNeededTrainingsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffNeededTrainingsTab);

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Importação da tabela


var StaffOJTsTab = function (_Component) {
  _inherits(StaffOJTsTab, _Component);

  function StaffOJTsTab(props) {
    _classCallCheck(this, StaffOJTsTab);

    var _this = _possibleConstructorReturn(this, (StaffOJTsTab.__proto__ || Object.getPrototypeOf(StaffOJTsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      staff_ojts: []
    };
    return _this;
  }

  // LM


  _createClass(StaffOJTsTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.staff_ojts)) {
        this.setState({ staff_ojts: newProps.staff_ojts });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          'OJTS'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'table',
          { className: 'table table-bordered table-stripped table-hover' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'thead',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tr',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                { className: 'text-center' },
                'Tarefa'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                { className: 'text-center' },
                'Data final'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                { className: 'text-center' },
                'Fun\xE7\xE3o treinada'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                { className: 'text-center' },
                'Ordem de servi\xE7o'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                { className: 'text-center' },
                'Base'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                { className: 'text-center' },
                'Satisfat\xF3rio'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'th',
                { className: 'text-center' },
                'Status'
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody', { id: 'suppliers-certifications' })
        )
      );
    }
  }]);

  return StaffOJTsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (StaffOJTsTab);

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário





var StaffPostsTab = function (_Component) {
  _inherits(StaffPostsTab, _Component);

  function StaffPostsTab(props) {
    _classCallCheck(this, StaffPostsTab);

    var _this = _possibleConstructorReturn(this, (StaffPostsTab.__proto__ || Object.getPrototypeOf(StaffPostsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      staff_id: _this.props.staff_id,
      post_id: null,
      date_start: '',
      staff_posts: [],
      posts_list: []
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.ativar = this.ativar.bind(this);
    // this.desativar = this.desativar.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);
    _this.refreshDataActive = _this.refreshDataActive.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }
  // handleToggleChange (name, event) {
  //   var change = {};
  //   if (event.target.checked === true) {
  //     var value = 1;
  //   } else {
  //     var value = 0;
  //   }
  //   change[name] = value;
  //   this.setState(change);
  // }

  // LM


  _createClass(StaffPostsTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.staff_posts)) {
        this.setState({
          staff_posts: newProps.staff_posts,
          posts_list: newProps.posts_list,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     post_id: this.state.post_id,
    //     date_start: this.state.date_start,
    //     only_active: this.state.only_active,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/cargo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.setState({ staff_posts: responseJson.data });
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // // Fetch ativando um item
    // ativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar esse cargo?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/cargo/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_posts: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch deletando um item
    // desativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar esse cargo?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/cargo/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_posts: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/cargos/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ staff_posts: responseJson.data, only_active: 0 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'refreshDataActive',
    value: function refreshDataActive(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/cargos/ativas/' + self.state.staff_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_posts: responseJson.data, only_active: 1 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCargos.tituloCargos
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_posts === null || typeof this.state.staff_posts === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCargos.nenhumCargoCadastrado
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCargos.tabela.DataInicial
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCargos.tabela.Cargo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'col-md-1 text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCargos.tabela.CodRubi
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'col-md-1 text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCargos.tabela.Status
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_posts).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_posts[k].date_start_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_posts[k].post
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_posts[k].rubi_code
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_posts[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCargos.tabela.Ativo
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCargos.tabela.Arquivado
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffPostsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffPostsTab);

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário



var StaffReferencesTab = function (_Component) {
  _inherits(StaffReferencesTab, _Component);

  function StaffReferencesTab(props) {
    _classCallCheck(this, StaffReferencesTab);

    var _this = _possibleConstructorReturn(this, (StaffReferencesTab.__proto__ || Object.getPrototypeOf(StaffReferencesTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      staff_id: _this.props.staff_id,
      aircraft_model_id: null,
      reference_id: null,
      staff_references: [],
      references_list: [],
      aircraft_models_list: []
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.ativar = this.ativar.bind(this);
    // this.desativar = this.desativar.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);
    _this.refreshDataActive = _this.refreshDataActive.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }

  // LM


  _createClass(StaffReferencesTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.staff_references)) {
        this.setState({
          staff_references: newProps.staff_references,
          aircraft_models_list: newProps.aircraft_models_list,
          references_list: newProps.references_list,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     aircraft_model_id: this.state.aircraft_model_id,
    //     reference_id: this.state.reference_id,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/referencia', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.setState({ staff_references: responseJson.data });
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }


    // // Fetch ativando um item
    // ativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar esse referencia?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/referencia/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_references: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch deletando um item
    // desativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar esse referencia?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/referencia/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_references: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/referencias/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ staff_references: responseJson.data, only_active: 0 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'refreshDataActive',
    value: function refreshDataActive(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/referencias/ativas/' + self.state.staff_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_references: responseJson.data, only_active: 1 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabColaboradorReferencia.tituloReferencias
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_references === null || typeof this.state.staff_references === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabColaboradorReferencia.nenhumaReferenciaCadastrada
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabColaboradorReferencia.tabela.Aeronave
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabColaboradorReferencia.tabela.Referencia
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabColaboradorReferencia.tabela.Status
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_references).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_references[k].aircraft_model
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_references[k].reference
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_references[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabColaboradorReferencia.tabela.Ativo
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabColaboradorReferencia.tabela.Arquivado
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffReferencesTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffReferencesTab);

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário




var StaffRegimesTab = function (_Component) {
  _inherits(StaffRegimesTab, _Component);

  function StaffRegimesTab(props) {
    _classCallCheck(this, StaffRegimesTab);

    var _this = _possibleConstructorReturn(this, (StaffRegimesTab.__proto__ || Object.getPrototypeOf(StaffRegimesTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      staff_id: _this.props.staff_id,
      regime_id: null,
      date_start: '',
      staff_regimes: [],
      regimes_select: []
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.ativar = this.ativar.bind(this);
    // this.desativar = this.desativar.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);
    _this.refreshDataActive = _this.refreshDataActive.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }

  // LM


  _createClass(StaffRegimesTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.staff_regimes)) {
        this.setState({
          regimes_select: newProps.regimes_select,
          staff_regimes: newProps.staff_regimes,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     regime_id: this.state.regime_id,
    //     date_start: this.state.date_start,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/regime', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.setState({ staff_regimes: responseJson.data });
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }


    // // Fetch ativando um item
    // ativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar esse regime?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/regime/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_regimes: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch deletando um item
    // desativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar esse regime?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/regime/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_regimes: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/regimes/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ staff_regimes: responseJson.data, only_active: 0 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'refreshDataActive',
    value: function refreshDataActive(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/regimes/ativas/' + self.state.staff_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_regimes: responseJson.data, only_active: 1 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabRegimeDeTrabalho.tituloRegimeDeTrabalho
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_regimes === null || typeof this.state.staff_regimes === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabRegimeDeTrabalho.nenhumRegimeCadastrado
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabRegimeDeTrabalho.tabela.Tipo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabRegimeDeTrabalho.tabela.DataInicial
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabRegimeDeTrabalho.tabela.Status
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_regimes).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_regimes[k].regime
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_regimes[k].date_start_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_regimes[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabRegimeDeTrabalho.tabela.Ativo
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabRegimeDeTrabalho.tabela.Arquivado
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffRegimesTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffRegimesTab);

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário




var StaffRolesTab = function (_Component) {
  _inherits(StaffRolesTab, _Component);

  function StaffRolesTab(props) {
    _classCallCheck(this, StaffRolesTab);

    var _this = _possibleConstructorReturn(this, (StaffRolesTab.__proto__ || Object.getPrototypeOf(StaffRolesTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      staff_id: _this.props.staff_id,
      role_id: null,
      staff_roles: [],
      role_list: []
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.ativar = this.ativar.bind(this);
    // this.desativar = this.desativar.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);
    _this.refreshDataActive = _this.refreshDataActive.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }
  // LM


  _createClass(StaffRolesTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.staff_roles)) {
        this.setState({
          staff_roles: newProps.staff_roles,
          roles_list: newProps.roles_list,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     role_id: this.state.role_id,
    //     date_start: this.state.date_start,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/funcao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.setState({ staff_roles: responseJson.data });
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }


    // // Fetch ativando um item
    // ativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar essa função?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/funcao/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_roles: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch deletando um item
    // desativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar essa função?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/funcao/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_roles: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/funcao/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ staff_roles: responseJson.data, only_active: 0 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'refreshDataActive',
    value: function refreshDataActive(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/funcao/ativas/' + self.state.staff_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_roles: responseJson.data, only_active: 1 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFuncoes.tituloFuncoes
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_roles === null || typeof this.state.staff_roles === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFuncoes.nenhumaFuncaoCadastrada
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFuncoes.tabela.DataInicial
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFuncoes.tabela.Funco
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFuncoes.tabela.Status
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_roles).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_roles[k].date_start_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_roles[k].role
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_roles[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFuncoes.tabela.Ativo
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFuncoes.tabela.Arquivado
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffRolesTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffRolesTab);

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário





var StaffStampsTab = function (_Component) {
  _inherits(StaffStampsTab, _Component);

  function StaffStampsTab(props) {
    _classCallCheck(this, StaffStampsTab);

    var _this = _possibleConstructorReturn(this, (StaffStampsTab.__proto__ || Object.getPrototypeOf(StaffStampsTab)).call(this, props));

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      staff_id: _this.props.staff_id,
      role_id: null,
      type: '',
      number: '',
      revision: '',
      observation: '',
      date: '',
      staff_stamps: [],
      stamp_types: [{ value: "Círculo", label: _this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.opcoesCarimbo.Circulo }, { value: "Triângulo", label: _this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.opcoesCarimbo.Triangulo }, { value: "Quadrado", label: _this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.opcoesCarimbo.Quadrado }, { value: "Pentágono", label: _this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.opcoesCarimbo.Pentagono }, { value: "Hexágono", label: _this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.opcoesCarimbo.Hexagono }],
      roles_list: []
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.ativar = this.ativar.bind(this);
    // this.desativar = this.desativar.bind(this);
    // this.addToRevision = this.addToRevision.bind(this);
    // this.delete = this.delete.bind(this);
    _this.export = _this.export.bind(_this);
    _this.refreshDataActive = _this.refreshDataActive.bind(_this);
    _this.refreshData = _this.refreshData.bind(_this);
    return _this;
  }

  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }
  // handleToggleChange (name, event) {
  //   var change = {};
  //   if (event.target.checked === true) {
  //     var value = 1;
  //   } else {
  //     var value = 0;
  //   }
  //   change[name] = value;
  //   this.setState(change);
  // }

  // LM


  _createClass(StaffStampsTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.staff_stamps)) {
        this.setState({
          staff_stamps: newProps.staff_stamps,
          roles_list: newProps.roles_list,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     role_id: this.state.role_id,
    //     type: this.state.type,
    //     number: this.state.number,
    //     revision: this.state.revision,
    //     observation: this.state.observation,
    //     date: this.state.date,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/carimbo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.setState({ staff_stamps: responseJson.data });
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }


    // // Fetch ativando um item
    // ativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar esse carimbo?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/carimbo/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_stamps: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch deletando um item
    // desativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar esse carimbo?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/carimbo/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_stamps: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/carimbos/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ staff_stamps: responseJson.data, only_active: 0 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'refreshDataActive',
    value: function refreshDataActive(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/carimbos/ativas/' + self.state.staff_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_stamps: responseJson.data, only_active: 1 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'export',
    value: function _export(event) {
      var self = this;
      self.props.handleAlert('', '', 'open');
      var staff_stamp_id = event;
      var url = '/exportar/carimbo/colaborador/';
      var header = this.refs.request_api.header('application/json');
      self.setState({ overlay: { message: '', type: '', status: 'open' } });
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + url + staff_stamp_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data);
          }
          self.props.handleAlert('', '', 'closed');
        });
      });
    }

    // addToRevision(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de associar esse carimbo a uma revisão de designação aberta?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/revisao/carimbo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // delete($staff_stamp_id) {
    //   var confirm = window.confirm('Tem certeza que deseja deletar esse carimbo?');
    //   if (confirm) {
    //     var self = this;
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/carimbo/' + $staff_stamp_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.refreshData(responseJson);
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.tituloCarimbos
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_stamps === null || typeof this.state.staff_stamps === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.nenhumCarimboCadastrado
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.tabela.DataDeEmissao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.tabela.Funcao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.tabela.TipoDeCarimbo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.tabela.Numero
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.tabela.Revisao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.tabela.Observacao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.tabela.Status
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_stamps).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_stamps[k].date_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_stamps[k].role
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_stamps[k].type
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_stamps[k].number
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_stamps[k].number_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_stamps[k].observation
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_stamps[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.tabela.Ativo
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.tabela.Arquivado
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { className: 'btn btn-info btn-sm', onClick: function onClick() {
                          self.export(self.state.staff_stamps[k].id);
                        } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' })
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffStampsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffStampsTab);

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário




var StaffTasksTab = function (_Component) {
  _inherits(StaffTasksTab, _Component);

  function StaffTasksTab(props) {
    _classCallCheck(this, StaffTasksTab);

    var _this = _possibleConstructorReturn(this, (StaffTasksTab.__proto__ || Object.getPrototypeOf(StaffTasksTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      staff_id: _this.props.staff_id,
      name: null,
      task_id: null,
      only_active: 1,
      expiration: '',
      date_start: '',
      staff_tasks: [],
      tasks_list: []
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.ativar = this.ativar.bind(this);
    // this.desativar = this.desativar.bind(this);
    // this.addToRevision = this.addToRevision.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);
    _this.refreshDataActive = _this.refreshDataActive.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }

  // LM


  _createClass(StaffTasksTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.staff_tasks)) {
        this.setState({
          staff_tasks: newProps.staff_tasks,
          tasks_list: newProps.tasks_list,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   var self = this;
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     task_id: this.state.task_id,
    //     expiration: this.state.expiration,
    //     date_start: this.state.date_start,
    //     only_active: this.state.only_active,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/tarefa_designada', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.setState({ staff_tasks: responseJson.data });
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // // Fetch ativando um item
    // ativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar essa tarefa?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/tarefa_designada/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_tasks: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch deletando um item
    // desativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar essa tarefa?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/tarefa_designada/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_tasks: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/tarefas_designadas/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ staff_tasks: responseJson.data, only_active: 0 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'refreshDataActive',
    value: function refreshDataActive(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/tarefas_designadas/ativas/' + self.state.staff_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_tasks: responseJson.data, only_active: 1 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }

    // addToRevision(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de associar essa tarefa a uma revisão de designação aberta?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/revisao/tarefa', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTarefasDesignadas.tituloTarefas
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_tasks === null || typeof this.state.staff_tasks === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTarefasDesignadas.nenhumaTarefaCadastrada
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTarefasDesignadas.tabela.Tarefa
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTarefasDesignadas.tabela.Vencimento
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTarefasDesignadas.tabela.Valido,
                  '?'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTarefasDesignadas.tabela.Status
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_tasks).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_tasks[k].task
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_tasks[k].expiration_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_tasks[k].expire_status_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_tasks[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTarefasDesignadas.tabela.Ativo
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTarefasDesignadas.tabela.Arquivado
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffTasksTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffTasksTab);

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário



var StaffVacationsTab = function (_Component) {
  _inherits(StaffVacationsTab, _Component);

  function StaffVacationsTab(props) {
    _classCallCheck(this, StaffVacationsTab);

    var _this = _possibleConstructorReturn(this, (StaffVacationsTab.__proto__ || Object.getPrototypeOf(StaffVacationsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      staff_id: _this.props.staff_id,
      date_start: '',
      date_finish: '',
      vacation_right: '',
      vacation_end: '',
      staff_vacations: []
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.ativar = this.ativar.bind(this);
    // this.desativar = this.desativar.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);
    _this.refreshDataActive = _this.refreshDataActive.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // }

  // LM


  _createClass(StaffVacationsTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.staff_vacations)) {
        this.setState({
          staff_vacations: newProps.staff_vacations,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     date_start: this.state.date_start,
    //     date_finish: this.state.date_finish,
    //     only_active: this.state.only_active,
    //     vacation_right: this.state.vacation_right,
    //     vacation_end: this.state.vacation_end,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api_sigmec') + '/colaborador/ferias', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.setState({ staff_vacations: responseJson.data });
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }


    // // Fetch ativando um item
    // ativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar essas ferias?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/ferias/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_vacations: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch deletando um item
    // desativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar essas ferias?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api_sigmec') + '/colaborador/ferias/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_vacations: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/ferias/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ staff_vacations: responseJson.data, only_active: 0 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'refreshDataActive',
    value: function refreshDataActive(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/ferias/ativas/' + self.state.staff_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_vacations: responseJson.data, only_active: 1 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFerias.tituloFerias
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_vacations === null || typeof this.state.staff_vacations === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFerias.nenhumaFeriasCadastrada
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFerias.tabela.DataInicial
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFerias.tabela.DataFinal
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFerias.tabela.DireitoAFerias
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFerias.tabela.VencimentoDeFerias
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFerias.tabela.Status
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_vacations).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_vacations[k].date_start_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_vacations[k].date_finish_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_vacations[k].vacation_right_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_vacations[k].vacation_end_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_vacations[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFerias.tabela.Ativo
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      self.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFerias.tabela.Arquivado
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffVacationsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffVacationsTab);

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Elements_StaffEditTab__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Elements_StaffLicensesTab__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Elements_StaffTasksTab__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Elements_StaffAircraftModelsTab__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Elements_StaffFleetsTab__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Elements_StaffDesignationsTab__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Elements_StaffJobsTab__ = __webpack_require__(893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Elements_StaffLanguagesTab__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Elements_StaffVacationsTab__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Elements_StaffRolesTab__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Elements_StaffBasesTab__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Elements_StaffContractualBasesTab__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Elements_StaffCostsTab__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Elements_StaffGuaranteedHoursTab__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Elements_StaffAircraftsTab__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Elements_StaffGradesTab__ = __webpack_require__(891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Elements_StaffPostsTab__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Elements_StaffStampsTab__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Elements_StaffCertificationsTab__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Elements_StaffNeededTrainingsTab__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Elements_StaffChecksTab__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Elements_StaffReferencesTab__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Elements_StaffAbsencesTab__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__Elements_StaffAttestationsTab__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Elements_StaffRegimesTab__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Elements_StaffEducationsTab__ = __webpack_require__(889);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Elements_StaffOJTsTab__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










// Tabs























//21





//25


var SigmecStaffsEdit = function (_Component) {
  _inherits(SigmecStaffsEdit, _Component);

  function SigmecStaffsEdit(props) {
    _classCallCheck(this, SigmecStaffsEdit);

    var _this = _possibleConstructorReturn(this, (SigmecStaffsEdit.__proto__ || Object.getPrototypeOf(SigmecStaffsEdit)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      situation: 'Demitido',
      staff_id: _this.props.match.params.id,
      staff_data: {},
      staff_roles: {},
      staff_tasks: {},
      staff_contractual_bases: {},
      staff_aircraft_models: {},
      regimes_select: {},
      uf_list: [],
      tasks_list: [],
      aircraft_models_list: [],
      aircraft_model_subtypes_list: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.changeSituation = _this.changeSituation.bind(_this);
    _this.export = _this.export.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_34__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(SigmecStaffsEdit, [{
    key: 'handleNavTab',
    value: function handleNavTab(state, key) {
      var change = {};
      change[state] = key;
      this.setState(change);
      this.setState({ overlay: { message: '', type: '', status: '' } });
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }

    //LM

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'changeSituation',
    value: function changeSituation(situation) {
      if (window.confirm(this.locale.ColaboradoresSigmec.EdicaoDeColaborador.trocarStatusDoColaborador)) {
        var self = this;
        var header = this.refs.request_api.header('application/json');
        self.setState({ overlay: { message: '', type: '', status: 'open' } });
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/trocar/status/' + self.props.match.params.id + '/' + situation, { method: 'PUT', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'url');
            if (responseJson.status === 'success') {
              self.setState({
                staff_data: responseJson.data.main,
                situation: responseJson.data.main.situation
              });
            }
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          });
        });
      }
    }
  }, {
    key: 'export',
    value: function _export(url) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      self.setState({ overlay: { message: '', type: '', status: 'open' } });
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data);
          }
        });
      });
    }
  }, {
    key: 'loadData',
    value: function loadData(event) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/portal/funcionario/sigmec';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url', '/colaboradores');
          if (responseJson.status === 'success') {
            var _self$setState;

            self.setState((_self$setState = {
              staff_data: responseJson.data.main,
              situation: responseJson.data.main.situation,
              url_anac: responseJson.data.url_anac,
              url_anac_dob: responseJson.data.url_anac_dob,
              staff_roles: responseJson.data.staff_roles,
              staff_licenses: responseJson.data.staff_licenses,
              staff_tasks: responseJson.data.staff_tasks,
              staff_fleets: responseJson.data.staff_fleets,
              staff_aircraft_models: responseJson.data.staff_aircraft_models,
              staff_jobs: responseJson.data.staff_jobs,
              staff_grades: responseJson.data.staff_grades,
              staff_languages: responseJson.data.staff_languages,
              staff_vacations: responseJson.data.staff_vacations
            }, _defineProperty(_self$setState, 'staff_roles', responseJson.data.staff_roles), _defineProperty(_self$setState, 'staff_bases', responseJson.data.staff_bases), _defineProperty(_self$setState, 'staff_contractual_bases', responseJson.data.staff_contractual_bases), _defineProperty(_self$setState, 'staff_aircrafts', responseJson.data.staff_aircrafts), _defineProperty(_self$setState, 'staff_posts', responseJson.data.staff_posts), _defineProperty(_self$setState, 'staff_stamps', responseJson.data.staff_stamps), _defineProperty(_self$setState, 'staff_checks', responseJson.data.staff_checks), _defineProperty(_self$setState, 'staff_references', responseJson.data.staff_references), _defineProperty(_self$setState, 'staff_absences', responseJson.data.staff_absences), _defineProperty(_self$setState, 'staff_revisions', responseJson.data.staff_revisions), _defineProperty(_self$setState, 'staff_revisions_list', responseJson.data.staff_revisions_list), _defineProperty(_self$setState, 'staff_designations_finalized', responseJson.data.staff_designations_finalized), _defineProperty(_self$setState, 'staff_attestations', responseJson.data.staff_attestations), _defineProperty(_self$setState, 'staff_regimes', responseJson.data.staff_regimes), _defineProperty(_self$setState, 'staff_educations', responseJson.data.staff_educations), _defineProperty(_self$setState, 'staff_needed_trainings', responseJson.data.staff_needed_trainings), _defineProperty(_self$setState, 'staff_needed_trainings_new', responseJson.data.staff_needed_trainings_new), _defineProperty(_self$setState, 'staff_necessities', responseJson.data.staff_necessities), _defineProperty(_self$setState, 'staff_designations', responseJson.data.staff_designations), _defineProperty(_self$setState, 'staff_designations_open', responseJson.data.staff_designations_open), _defineProperty(_self$setState, 'staff_certifications', responseJson.data.staff_certifications), _defineProperty(_self$setState, 'staff_costs', responseJson.data.staff_costs), _defineProperty(_self$setState, 'staff_guaranteed_hours', responseJson.data.staff_guaranteed_hours), _defineProperty(_self$setState, 'staff_ojts', responseJson.data.staff_ojts), _defineProperty(_self$setState, 'absences_list', responseJson.data.absences_list), _defineProperty(_self$setState, 'references_list', responseJson.data.references_list), _defineProperty(_self$setState, 'posts_list', responseJson.data.posts_list), _defineProperty(_self$setState, 'aircrafts_list', responseJson.data.aircrafts_list), _defineProperty(_self$setState, 'bases_list', responseJson.data.bases_list), _defineProperty(_self$setState, 'roles_list', responseJson.data.roles_list), _defineProperty(_self$setState, 'tasks_list', responseJson.data.tasks_list), _defineProperty(_self$setState, 'certifications_list', responseJson.data.certifications_list), _defineProperty(_self$setState, 'aircraft_models_list', responseJson.data.aircraft_models_list), _defineProperty(_self$setState, 'aircraft_model_subtypes_list', responseJson.data.aircraft_model_subtypes_list), _defineProperty(_self$setState, 'uf_list', responseJson.data.uf_list), _defineProperty(_self$setState, 'staff_list', responseJson.data.staff_list), _defineProperty(_self$setState, 'regimes_select', responseJson.data.regimes_select), _defineProperty(_self$setState, 'designations_list', responseJson.data.designations_list), _self$setState));
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          if (typeof event === 'undefined') {
            self.handleMessage();
          } else {
            self.handleAlert(event.message, event.status, 'open');
          }
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.ColaboradoresSigmec.EdicaoDeColaborador.titulo,
              ' - ',
              this.state.staff_data.name
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Tabs */],
              { activeKey: this.state.key, onSelect: this.handleNavTab.bind(this, 'key'), id: 'controlled-tab-example' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 1, title: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDadosDoColaborador.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Elements_StaffEditTab__["a" /* default */], { handleAlert: this.handleAlert, staff_id: this.props.match.params.id, staff_data: this.state.staff_data, uf_list: this.state.uf_list })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 2, title: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabHabilitacoes.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Elements_StaffLicensesTab__["a" /* default */], { handleAlert: this.handleAlert, staff_id: this.props.match.params.id, staff_licenses: this.state.staff_licenses })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 3, title: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTarefasDesignadas.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Elements_StaffTasksTab__["a" /* default */], { handleAlert: this.handleAlert, staff_id: this.props.match.params.id, staff_tasks: this.state.staff_tasks, tasks_list: this.state.tasks_list })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 4, title: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasDesignadas.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Elements_StaffAircraftModelsTab__["a" /* default */], { handleAlert: this.handleAlert, staff_id: this.props.match.params.id, staff_aircraft_models: this.state.staff_aircraft_models, aircraft_model_subtypes_list: this.state.aircraft_model_subtypes_list, aircraft_models_list: this.state.aircraft_models_list })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 5, title: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFrotasObrigatorias.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Elements_StaffFleetsTab__["a" /* default */], { handleAlert: this.handleAlert, staff_id: this.props.match.params.id, staff_fleets: this.state.staff_fleets, aircraft_model_subtypes_list: this.state.aircraft_model_subtypes_list, aircraft_models_list: this.state.aircraft_models_list })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 6, title: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabDesignacoes.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Elements_StaffDesignationsTab__["a" /* default */], { handleAlert: this.handleAlert, staff_id: this.props.match.params.id, staff_designations: this.state.staff_designations, staff_designations_open: this.state.staff_designations_open, designations_list: this.state.designations_list, staff_revisions: this.state.staff_revisions, staff_revisions_list: this.state.staff_revisions_list, staff_designations_finalized: this.state.staff_designations_finalized, loadData: this.loadData })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 7, title: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabExperienciaProfissional.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Elements_StaffJobsTab__["a" /* default */], { handleAlert: this.handleAlert, staff_id: this.props.match.params.id, staff_jobs: this.state.staff_jobs, staff_list: this.state.staff_list })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 8, title: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabProvasDeIdioma.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Elements_StaffLanguagesTab__["a" /* default */], { handleAlert: this.handleAlert, staff_id: this.props.match.params.id, staff_languages: this.state.staff_languages })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 9, title: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFerias.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Elements_StaffVacationsTab__["a" /* default */], { handleAlert: this.handleAlert, staff_id: this.props.match.params.id, staff_vacations: this.state.staff_vacations })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 10, title: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFuncoes.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Elements_StaffRolesTab__["a" /* default */], { handleAlert: this.handleAlert, staff_id: this.props.match.params.id, roles_list: this.state.roles_list, staff_roles: this.state.staff_roles })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 11, title: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabBases.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Elements_StaffBasesTab__["a" /* default */], { handleAlert: this.handleAlert, staff_id: this.props.match.params.id, bases_list: this.state.bases_list, staff_bases: this.state.staff_bases })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 13, title: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNiveisDeCargos.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__Elements_StaffGradesTab__["a" /* default */], { handleAlert: this.handleAlert, staff_id: this.props.match.params.id, staff_grades: this.state.staff_grades })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 14, title: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCargos.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__Elements_StaffPostsTab__["a" /* default */], { handleAlert: this.handleAlert, staff_id: this.props.match.params.id, staff_posts: this.state.staff_posts, posts_list: this.state.posts_list })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 15, title: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabCarimbos.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Elements_StaffStampsTab__["a" /* default */], { handleAlert: this.handleAlert, staff_id: this.props.match.params.id, staff_stamps: this.state.staff_stamps, roles_list: this.state.roles_list })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 16, title: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabTreinamentos.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__Elements_StaffCertificationsTab__["a" /* default */], { handleAlert: this.handleAlert, staff_id: this.props.match.params.id, staff_certifications: this.state.staff_certifications, certifications_list: this.state.certifications_list })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 17, title: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabNecessidadeDeTreinamentos.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__Elements_StaffNeededTrainingsTab__["a" /* default */], { handleAlert: this.handleAlert, staff_id: this.props.match.params.id, staff_needed_trainings_new: this.state.staff_needed_trainings_new, staff_needed_trainings: this.state.staff_needed_trainings, staff_necessities: this.state.staff_necessities })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 19, title: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabColaboradorReferencia.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__Elements_StaffReferencesTab__["a" /* default */], { handleAlert: this.handleAlert, staff_id: this.props.match.params.id, staff_references: this.state.staff_references, references_list: this.state.references_list, aircraft_models_list: this.state.aircraft_models_list })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 20, title: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabAfastamentos.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__Elements_StaffAbsencesTab__["a" /* default */], { handleAlert: this.handleAlert, staff_id: this.props.match.params.id, staff_absences: this.state.staff_absences, absences_list: this.state.absences_list })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 23, title: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabRegimeDeTrabalho.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_31__Elements_StaffRegimesTab__["a" /* default */], { handleAlert: this.handleAlert, staff_id: this.props.match.params.id, staff_regimes: this.state.staff_regimes, regimes_select: this.state.regimes_select })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 24, title: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabFormacaoAcademica.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_32__Elements_StaffEducationsTab__["a" /* default */], { handleAlert: this.handleAlert, staff_id: this.props.match.params.id, staff_educations: this.state.staff_educations })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 26, title: this.locale.ColaboradoresSigmec.EdicaoDeColaborador.tabBaseContratual.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Elements_StaffContractualBasesTab__["a" /* default */], { handleAlert: this.handleAlert, staff_contractual_bases: this.state.staff_contractual_bases, staff_id: this.props.match.params.id, bases_list: this.state.bases_list })
              )
            )
          )
        )
      );
    }
  }]);

  return SigmecStaffsEdit;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SigmecStaffsEdit);

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// Importação da tabela



var SigmecStaffsTrainings = function (_Component) {
  _inherits(SigmecStaffsTrainings, _Component);

  function SigmecStaffsTrainings(props) {
    _classCallCheck(this, SigmecStaffsTrainings);

    var _this = _possibleConstructorReturn(this, (SigmecStaffsTrainings.__proto__ || Object.getPrototypeOf(SigmecStaffsTrainings)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(SigmecStaffsTrainings, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/funcionario/treinamentos/pendentes/associados', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {

      var botao = "";
      if (row.confirmation_token_presence && row.confirmation_token_absence) {
        var confirmation_token_presence_url = 'http://' + row.confirmation_url + '/email/confirmacao/' + row.confirmation_token_presence;
        var confirmation_token_absence_url = 'http://' + row.confirmation_url + '/email/confirmacao/' + row.confirmation_token_absence;
        botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'btn btn-success btn-sm button-inline', target: '_blank', href: confirmation_token_presence_url },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-check' }),
            ' ',
            this.locale.ColaboradoresSigmec.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.botaoConfirmarPresenca
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'btn btn-danger btn-sm button-inline', target: '_blank', href: confirmation_token_absence_url },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' }),
            ' ',
            this.locale.ColaboradoresSigmec.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.botaoConfirmarAusencia
          )
        );
      }
      return botao;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.ColaboradoresSigmec.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: 'Exportar CSV', noDataText: this.locale.ColaboradoresSigmec.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.semTreinamentos }, search: true, multiColumnSearch: true, searchPlaceholder: 'Procurar' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, hidden: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.ColaboradoresSigmec.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'name', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '450' },
                this.locale.ColaboradoresSigmec.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.Nome
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'status_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '120' },
                this.locale.ColaboradoresSigmec.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.Status
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'code', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '124' },
                this.locale.ColaboradoresSigmec.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.CodigoDeControle
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'date_start_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '120' },
                this.locale.ColaboradoresSigmec.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.DataInicial
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'date_finish_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '120' },
                this.locale.ColaboradoresSigmec.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.DataFinal
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '280' },
                this.locale.ColaboradoresSigmec.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.Acoes
              )
            )
          )
        )
      );
    }
  }]);

  return SigmecStaffsTrainings;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SigmecStaffsTrainings);

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// Importação da tabela



var SigmecStaffsTrainings = function (_Component) {
  _inherits(SigmecStaffsTrainings, _Component);

  function SigmecStaffsTrainings(props) {
    _classCallCheck(this, SigmecStaffsTrainings);

    var _this = _possibleConstructorReturn(this, (SigmecStaffsTrainings.__proto__ || Object.getPrototypeOf(SigmecStaffsTrainings)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.export = _this.export.bind(_this);
    _this.ActionsButtons = _this.ActionsButtons.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(SigmecStaffsTrainings, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/funcionario/treinamentos/associados', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var _this2 = this;

      var url = '/relatorio/voo/editar/' + cell;

      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-info', onClick: function onClick() {
              _this2.export(row.id, row.staff_id);
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' }),
          ' ',
          this.locale.ColaboradoresSigmec.ComunicadosDeTreinamentos.botaoComunicado
        )
      );

      return botao;
    }
  }, {
    key: 'export',
    value: function _export(training_id, staff_id) {
      var self = this;
      var url = '/treinamento/exportar/comunicado/colaborador/';
      var header = this.refs.request_api.header('application/json');
      self.setState({ overlay: { message: '', type: '', status: 'open' } });
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + url + staff_id + "/" + training_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data);
          }
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.ColaboradoresSigmec.ComunicadosDeTreinamentos.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.ColaboradoresSigmec.ComunicadosDeTreinamentos.tabela.semTreinamentos, defaultSortName: 'id', defaultSortOrder: 'desc', sizePerPage: 100, sizePerPageList: [{ text: '10', value: 10 }, { text: '25', value: 25 }, { text: '50', value: 50 }, { text: '100', value: 100 }] }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.ColaboradoresSigmec.ComunicadosDeTreinamentos.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'name', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '500' },
                this.locale.ColaboradoresSigmec.ComunicadosDeTreinamentos.tabela.Nome
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'status_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.ColaboradoresSigmec.ComunicadosDeTreinamentos.tabela.Status
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'code', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.ColaboradoresSigmec.ComunicadosDeTreinamentos.tabela.CodigoDeControle
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'date_start_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.ColaboradoresSigmec.ComunicadosDeTreinamentos.tabela.DataInicial
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'date_finish_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.ColaboradoresSigmec.ComunicadosDeTreinamentos.tabela.DataFinal
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '140' },
                this.locale.ColaboradoresSigmec.ComunicadosDeTreinamentos.tabela.Acoes
              )
            )
          )
        )
      );
    }
  }]);

  return SigmecStaffsTrainings;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SigmecStaffsTrainings);

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_datepicker__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Importação da tabela






var StaffAdministrativeTab = function (_Component) {
  _inherits(StaffAdministrativeTab, _Component);

  function StaffAdministrativeTab(props) {
    _classCallCheck(this, StaffAdministrativeTab);

    var _this = _possibleConstructorReturn(this, (StaffAdministrativeTab.__proto__ || Object.getPrototypeOf(StaffAdministrativeTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      name: '',
      archive: '',
      expiration: '',
      dados: [],
      docs_types_list: []
    };

    // this.botaoDeletar = this.botaoDeletar.bind(this);
    // this.adicionarArquivo = this.adicionarArquivo.bind(this);
    _this.botaoDownloadArquivo = _this.botaoDownloadArquivo.bind(_this);
    // this.deletar = this.deletar.bind(this);
    // this.deletarLinha = this.deletarLinha.bind(this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(StaffAdministrativeTab, [{
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
      this.setState({ expiration: '' });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleChangeDatePicker',
    value: function handleChangeDatePicker(state, date) {
      var change = {};
      change[state] = date.format("DD/MM/YYYY");
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.adm_files)) {
        this.setState({ dados: newProps.adm_files });
      }
      if (Array.isArray(newProps.docs_types_list)) {
        this.setState({ docs_types_list: newProps.docs_types_list });
      }
    }

    // adicionarArquivo(event) {
    //   event.preventDefault();
    //   var data = new FormData();
    //   var imagedata = document.querySelector(".input-archive-administrative").files[0];
    //   data.append("name", this.state.name);
    //   data.append("type", this.state.type);
    //   data.append("expiration", this.state.expiration);
    //   data.append("imagem", imagedata);
    //   data.append("staff_id", this.props.staff_id);
    //   var header = this.refs.request_api.header();
    //   var self = this;
    //   this.props.handleAlert('', '', 'open');
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api') + '/funcionario/administrativo/arquivo', {
    //       method: 'POST',
    //       mode: 'cors',
    //       headers: value,
    //       body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           var dados_temp = self.state.dados;
    //           dados_temp.push(responseJson.data);
    //           self.setState({dados: dados_temp});
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //       console.error(error);
    //     });
    //   });   
    // }

    // botaoDeletar (cell, row, enumObject, index) {
    //   var variavel = (
    //     <button className="btn btn-sm btn-danger" value={cell} onClick={this.deletar}>
    //       <i className="fa fa-fw fa-trash"></i>
    //     </button>
    //   );

    //   return variavel;
    // }

    // deletar (event) {
    //   var staff_administrative_id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de deletar esse arquivo?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/administrativo/arquivo/' + staff_administrative_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //         if (responseJson.status === 'success') {
    //           self.deletarLinha(staff_administrative_id);
    //         }
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // deletarLinha(staff_administrative_id) {
    //   var dados = this.state.dados;
    //   dados.map(function(dado, index){
    //     if (dado.id == staff_administrative_id) {
    //       dados.splice(index, 1);
    //     }
    //   });
    //   this.setState({dados: dados});
    // }

  }, {
    key: 'botaoDownloadArquivo',
    value: function botaoDownloadArquivo(cell, row) {
      var dados = this.state.dados;
      var status = '';
      var arquivo = '';
      var nome = '';
      var url = '';
      dados.map(function (dado, index) {
        if (dado.id == cell) {
          arquivo = dado.archive;
          nome = dado.name;
          url = dado.type;
        }
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { target: '_blank', href: __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/files/administrative/' + url + '/' + arquivo },
        ' ',
        nome
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigtrip.EditarFuncionario.tabAdministrativo.tituloAdicionarArquivos
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["BootstrapTable"],
          { data: this.state.dados, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.ColaboradoresSigtrip.EditarFuncionario.tabAdministrativo.tabela.semArquivos }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
            { isKey: true, dataFormat: this.botaoDownloadArquivo, dataField: 'id', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
            this.locale.ColaboradoresSigtrip.EditarFuncionario.tabAdministrativo.tabela.NomeDoArquivo
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'type_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
            this.locale.ColaboradoresSigtrip.EditarFuncionario.tabAdministrativo.tabela.Tipo
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'expiration_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
            this.locale.ColaboradoresSigtrip.EditarFuncionario.tabAdministrativo.tabela.Validade
          )
        )
      );
    }
  }]);

  return StaffAdministrativeTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (StaffAdministrativeTab);

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário




var StaffBasesTab = function (_Component) {
  _inherits(StaffBasesTab, _Component);

  function StaffBasesTab(props) {
    _classCallCheck(this, StaffBasesTab);

    var _this = _possibleConstructorReturn(this, (StaffBasesTab.__proto__ || Object.getPrototypeOf(StaffBasesTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      only_active: 0,
      staff_id: _this.props.staff_id,
      base_id: null,
      date_start: '',
      staff_bases: [],
      bases_list: []
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.ativar = this.ativar.bind(this);
    // this.desativar = this.desativar.bind(this);
    // this.delete = this.delete.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);
    _this.refreshDataActive = _this.refreshDataActive.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // }
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }

  // LM


  _createClass(StaffBasesTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.staff_bases)) {
        this.setState({
          staff_bases: newProps.staff_bases,
          bases_list: newProps.bases_list,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     base_id: this.state.base_id,
    //     only_active: this.state.only_active,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api') + '/funcionario/base', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.setState({ staff_bases: responseJson.data });
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }


    // // Fetch ativando um item
    // ativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar essa base?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/base/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_bases: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

    // // Fetch deletando um item
    // desativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar essa base?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/base/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_bases: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

    // delete(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de deletar essa base?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/base/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           self.refreshData(responseJson);
    //         }
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/bases/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ staff_bases: responseJson.data, only_active: 0 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'refreshDataActive',
    value: function refreshDataActive(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/bases/ativas/' + self.state.staff_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_bases: responseJson.data, only_active: 1 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigtrip.EditarFuncionario.tabBaseContratual.tituloBases
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_bases === null || typeof this.state.staff_bases === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigtrip.EditarFuncionario.tabBaseContratual.nenhumaBaseCadastrada
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabBaseContratual.tabela.Base
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'col-md-1 text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabBaseContratual.tabela.Status
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_bases).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_bases[k].base
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_bases[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      self.locale.ColaboradoresSigtrip.EditarFuncionario.tabBaseContratual.tabela.Ativo
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      self.locale.ColaboradoresSigtrip.EditarFuncionario.tabBaseContratual.tabela.Arquivado
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffBasesTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (StaffBasesTab);

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StaffCertificationAddFile__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário







var StaffCertificationsTab = function (_Component) {
  _inherits(StaffCertificationsTab, _Component);

  function StaffCertificationsTab(props) {
    _classCallCheck(this, StaffCertificationsTab);

    var _this = _possibleConstructorReturn(this, (StaffCertificationsTab.__proto__ || Object.getPrototypeOf(StaffCertificationsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      staff_id: _this.props.staff_id,
      date_start: '',
      date_finish: '',
      pf: 0,
      only_active: 1,
      certification_id: null,
      certification_supplier_id: null,
      observations: '',
      staff_certifications: [],
      certifications: [],
      certification_suppliers: []
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.activate = this.activate.bind(this);
    // this.delete = this.delete.bind(this);
    // this.archive = this.archive.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);
    _this.refreshDataActive = _this.refreshDataActive.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }
  // handleToggleChange (name, event) {
  //   var change = {};
  //   if (event.target.checked === true) {
  //     var value = 1;
  //   } else {
  //     var value = 0;
  //   }
  //   change[name] = value;
  //   this.setState(change);
  // } 

  // handleSelectChangeCertification(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //       this.setState({certification_suppliers: []});
  //   } else {
  //     this.props.handleAlert('', '', 'open');
  //     change[name] = event.value;

  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     if (event.value !== null) {
  //       this.props.handleAlert('', '', 'open');
  //       Promise.resolve(header).then(function(value) {
  //         fetch(config.get('api') + '/certificado/fornecedores/lista/' + event.value , { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //           self.setState({certification_suppliers: responseJson.data});
  //           self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
  //         });
  //       });      
  //     }
  //   }
  //   this.setState(change);
  // }

  // LM


  _createClass(StaffCertificationsTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.staff_certifications) && this.state.loaded === false) {
        this.setState({
          certifications: newProps.certifications,
          staff_certifications: newProps.staff_certifications,
          loaded: true
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {

    //     staff_id: this.props.staff_id,
    //     date_start: this.state.date_start,
    //     date_finish: this.state.date_finish,
    //     pf: this.state.pf,
    //     certification_id: this.state.certification_id,
    //     certification_supplier_id: this.state.certification_supplier_id,
    //     observations: this.state.observations,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api') + '/funcionario/certificado', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       if(self.state.only_active === 0){
    //         self.refreshDataActive(responseJson);
    //       } else{      
    //         self.refreshData(responseJson);
    //       }
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // // Fetch ativando um item
    // activate(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar esse certificado?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/certificado/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           if(self.state.only_active === 0){
    //             self.refreshDataActive(responseJson);
    //           } else{      
    //             self.refreshData(responseJson);
    //           }
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch deletando um item
    // archive(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar esse certificado?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/certificado/arquivar/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           if(self.state.only_active === 0){
    //             self.refreshDataActive(responseJson);
    //           } else{      
    //             self.refreshData(responseJson);
    //           }
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // delete (event) {
    //   var staff_certification_id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de deletar esse certificado?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/certificado/' + staff_certification_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.refreshData(responseJson);
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/certificados/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_certifications: responseJson.data, only_active: 0 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'refreshDataActive',
    value: function refreshDataActive(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/certificados/ativos/' + self.state.staff_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_certifications: responseJson.data, only_active: 1 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigtrip.EditarFuncionario.tabCertificacoes.tituloCertificados
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_certifications === null || typeof this.state.staff_certifications === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigtrip.EditarFuncionario.tabCertificacoes.nenhumCertificadoCadastrado
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabCertificacoes.tabela.NomeDoCertificado
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabCertificacoes.tabela.Inicio
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabCertificacoes.tabela.Fim
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabCertificacoes.tabela.Vencimento
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabCertificacoes.tabela.Status
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabCertificacoes.tabela.Arquivo
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_certifications).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_certifications[k].certification
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_certifications[k].date_start_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_certifications[k].date_finish_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_certifications[k].expire_status_int === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'text text-success' },
                      self.state.staff_certifications[k].expire_str
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'text text-danger' },
                      self.state.staff_certifications[k].expire_str
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_certifications[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      self.locale.ColaboradoresSigtrip.EditarFuncionario.tabCertificacoes.tabela.Ativo
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      self.locale.ColaboradoresSigtrip.EditarFuncionario.tabCertificacoes.tabela.Arquivado
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center', width: '300' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StaffCertificationAddFile__["a" /* default */], { handleAlert: self.props.handleAlert, refreshData: self.refreshData, staff_certification_id: self.state.staff_certifications[k].id, file: self.state.staff_certifications[k].file, file_archived: self.state.staff_certifications[k].file_archived })
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffCertificationsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (StaffCertificationsTab);

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StaffCertificationAddFile__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário







var StaffCertificationsTypeTab = function (_Component) {
  _inherits(StaffCertificationsTypeTab, _Component);

  function StaffCertificationsTypeTab(props) {
    _classCallCheck(this, StaffCertificationsTypeTab);

    var _this = _possibleConstructorReturn(this, (StaffCertificationsTypeTab.__proto__ || Object.getPrototypeOf(StaffCertificationsTypeTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      staff_id: _this.props.staff_id,
      date_start: '',
      date_finish: '',
      pf: 0,
      only_active: 1,
      certification_id: null,
      certification_supplier_id: null,
      observations: '',
      staff_certifications: [],
      certifications: [],
      certification_suppliers: []
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.activate = this.activate.bind(this);
    // this.delete = this.delete.bind(this);
    // this.archive = this.archive.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);
    _this.refreshDataActive = _this.refreshDataActive.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }
  // handleToggleChange (name, event) {
  //   var change = {};
  //   if (event.target.checked === true) {
  //     var value = 1;
  //   } else {
  //     var value = 0;
  //   }
  //   change[name] = value;
  //   this.setState(change);
  // } 

  // handleSelectChangeCertification(name, event) {
  //   this.props.handleAlert('', '', 'open');
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;

  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     if (event.value !== null) {
  //       Promise.resolve(header).then(function(value) {
  //         fetch(config.get('api') + '/certificado/fornecedores/lista/' + event.value , { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //           self.setState({certification_suppliers: responseJson.data});
  //           self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
  //         });
  //       });      
  //     }
  //   }
  //   this.setState(change);
  // }

  // LM


  _createClass(StaffCertificationsTypeTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.staff_certifications_other_type) && this.state.loaded === false) {
        this.setState({
          certifications: newProps.certifications,
          staff_certifications: newProps.staff_certifications_other_type,
          loaded: true
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.props.staff_id,
    //     date_start: this.state.date_start,
    //     date_finish: this.state.date_finish,
    //     pf: this.state.pf,
    //     certification_id: this.state.certification_id,
    //     certification_supplier_id: this.state.certification_supplier_id,
    //     observations: this.state.observations,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api') + '/funcionario/certificado', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.refreshData();
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // // Fetch ativando um item
    // activate(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar esse certificado?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/certificado/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           if(self.state.only_active === 0){
    //             self.refreshDataActive();
    //           } else{      
    //             self.refreshData();
    //           }
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch deletando um item
    // archive(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar esse certificado?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/certificado/arquivar/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           if(self.state.only_active === 0){
    //             self.refreshDataActive();
    //           } else{      
    //             self.refreshData();
    //           }
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }
    // // Fetch deletando um item
    // delete(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de deletar esse certificado?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/certificado/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           if(self.state.only_active === 0){
    //             self.refreshDataActive();
    //           } else{      
    //             self.refreshData();
    //           }
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData() {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/certificados/tipo/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ staff_certifications: responseJson.data, only_active: 0 });
          }
          self.props.handleAlert('', '', 'closed');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'refreshDataActive',
    value: function refreshDataActive() {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/certificados/ativos/tipo/' + self.state.staff_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_certifications: responseJson.data, only_active: 1 });
          }
          self.props.handleAlert('', '', 'closed');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigtrip.EditarFuncionario.tabAvaliacoes.tituloAvaliacoes
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_certifications === null || typeof this.state.staff_certifications === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigtrip.EditarFuncionario.tabAvaliacoes.nenhumCertificadoCadastrado
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabAvaliacoes.tabela.NomeDoCertificado
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabAvaliacoes.tabela.Inicio
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabAvaliacoes.tabela.Fim
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabAvaliacoes.tabela.Vencimento
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabAvaliacoes.tabela.Status
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabAvaliacoes.tabela.Arquivo
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_certifications).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_certifications[k].certification
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_certifications[k].date_start_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_certifications[k].date_finish_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_certifications[k].expire_status_int === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'text text-success' },
                      self.state.staff_certifications[k].expire_str
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'text text-danger' },
                      self.state.staff_certifications[k].expire_str
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_certifications[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      self.locale.ColaboradoresSigtrip.EditarFuncionario.tabAvaliacoes.tabela.Ativo
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      self.locale.ColaboradoresSigtrip.EditarFuncionario.tabAvaliacoes.tabela.Arquivado
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StaffCertificationAddFile__["a" /* default */], { handleAlert: self.props.handleAlert, refreshData: self.refreshData, staff_certification_id: self.state.staff_certifications[k].id, file: self.state.staff_certifications[k].file, file_archived: self.state.staff_certifications[k].file_archived })
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffCertificationsTypeTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (StaffCertificationsTypeTab);

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário





var StaffClientsTab = function (_Component) {
  _inherits(StaffClientsTab, _Component);

  function StaffClientsTab(props) {
    _classCallCheck(this, StaffClientsTab);

    var _this = _possibleConstructorReturn(this, (StaffClientsTab.__proto__ || Object.getPrototypeOf(StaffClientsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      staff_id: _this.props.staff_id,
      staff_clients: ['']
    };

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(StaffClientsTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.staff_clients) && this.state.loaded === false) {
        this.setState({
          staff_clients: newProps.staff_clients,
          loaded: true
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigtrip.EditarFuncionario.tabAprovacoes.tituloAprovacoesDeClientes
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_clients === null || typeof this.state.staff_clients === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigtrip.EditarFuncionario.tabAprovacoes.nenhumaAprovacaoCadastrada
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'table-responsive' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabAprovacoes.tabela.Client
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabAprovacoes.tabela.Grupo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabAprovacoes.tabela.Funcao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'col-md-7 text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabAprovacoes.tabela.Aeronaves
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_clients).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_clients[k].client
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_clients[k].group_name
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center text-uppercase' },
                    self.state.staff_clients[k].role
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.loaded === true ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      null,
                      Object.keys(self.state.staff_clients[k].client_group_aircrafts).map(function (cga_k) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'span',
                          null,
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'span',
                            { className: 'label label-default' },
                            self.state.staff_clients[k].client_group_aircrafts[cga_k].aircraft.registration
                          ),
                          '\xA0'
                        );
                      })
                    ) : ''
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffClientsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (StaffClientsTab);

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário


var StaffCostsTab = function (_Component) {
  _inherits(StaffCostsTab, _Component);

  function StaffCostsTab(props) {
    _classCallCheck(this, StaffCostsTab);

    var _this = _possibleConstructorReturn(this, (StaffCostsTab.__proto__ || Object.getPrototypeOf(StaffCostsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      staff_id: _this.props.staff_id,
      date_start: '',
      staff_costs: [],
      cost_center: null
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.activate = this.activate.bind(this);
    // this.archive = this.archive.bind(this);
    // this.delete = this.delete.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);
    return _this;
  }
  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // }
  // LM


  _createClass(StaffCostsTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.staff_costs) && this.state.loaded === false) {
        this.setState({
          staff_costs: newProps.staff_costs,
          loaded: true
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     cost_center: this.state.cost_center,
    //     date_start: this.state.date_start,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api') + '/funcionario/custo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.refreshData();
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // // Fetch ativando um item
    // activate(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar esse centro de custo?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/custo/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           self.refreshData();
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

    // // Fetch deletando um item
    // archive(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar esse centro de custo?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/custo/arquivar/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           self.refreshData();
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }
    // // Fetch deletando um item
    // delete(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de deletar esse centro de custo?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/custo/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           self.refreshData();
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData() {
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/custos/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ staff_costs: responseJson.data });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          'Centro de custo'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_costs === null || typeof this.state.staff_costs === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              'Nenhum centro de custo cadastrado.'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Centro de custo'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Data'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'col-md-1 text-center' },
                  'Status'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'staff-costs' },
              Object.keys(self.state.staff_costs).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_costs[k].cost_center
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_costs[k].date_start_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_costs[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      'ativo'
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      'arquivado'
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffCostsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (StaffCostsTab);

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário





var StaffDesignationsTab = function (_Component) {
  _inherits(StaffDesignationsTab, _Component);

  function StaffDesignationsTab(props) {
    _classCallCheck(this, StaffDesignationsTab);

    var _this = _possibleConstructorReturn(this, (StaffDesignationsTab.__proto__ || Object.getPrototypeOf(StaffDesignationsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      staff_id: _this.props.staff_id,
      designation_id: null,
      aircraft_model_id: null,
      date_start: '',
      staff_designations: [],
      aircraft_models: [],
      designations: []
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.activate = this.activate.bind(this);
    // this.delete = this.delete.bind(this);
    // this.archive = this.archive.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }
  // handleToggleChange (name, event) {
  //   var change = {};
  //   if (event.target.checked === true) {
  //     var value = 1;
  //   } else {
  //     var value = 0;
  //   }
  //   change[name] = value;
  //   this.setState(change);
  // } 
  // LM


  _createClass(StaffDesignationsTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.staff_designations) && this.state.loaded === false) {
        this.setState({
          aircraft_models: newProps.aircraft_models,
          designations: newProps.designations,
          staff_designations: newProps.staff_designations,
          loaded: true
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     designation_id: this.state.designation_id,
    //     aircraft_model_id: this.state.aircraft_model_id,
    //     date_start: this.state.date_start,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api') + '/funcionario/designacao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.refreshData();
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // // Fetch ativando um item
    // activate(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar essa designação?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/designacao/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           self.refreshData();
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch deletando um item
    // delete(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de deletar essa designação?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/designacao/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           self.refreshData();
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch deletando um item
    // archive(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar essa designação?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/designacao/arquivar/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           self.refreshData();
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData() {
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/designacoes/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ staff_designations: responseJson.data });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDesignacoes.tituloDesignacoes
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_designations === null || typeof this.state.staff_designations === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDesignacoes.nenhumaDesignacaoCadastrada
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDesignacoes.tabela.Designacao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDesignacoes.tabela.Frota
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'col-md-1 text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDesignacoes.tabela.Status
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDesignacoes.tabela.Data
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_designations).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_designations[k].designation
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_designations[k].aircraft_model
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_designations[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      self.locale.ColaboradoresSigtrip.EditarFuncionario.tabDesignacoes.tabela.Ativo
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      self.locale.ColaboradoresSigtrip.EditarFuncionario.tabDesignacoes.tabela.Arquivado
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_designations[k].date_start_str
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffDesignationsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffDesignationsTab);

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário





var StaffEditTab = function (_Component) {
  _inherits(StaffEditTab, _Component);

  function StaffEditTab(props) {
    _classCallCheck(this, StaffEditTab);

    var _this = _possibleConstructorReturn(this, (StaffEditTab.__proto__ || Object.getPrototypeOf(StaffEditTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      id: _this.props.staff_data.staff_id,
      name: _this.props.staff_data.name,
      nickname: _this.props.staff_data.nickname,
      civil_state: _this.props.staff_data.civil_state,
      email: _this.props.staff_data.email,
      phone_1: _this.props.staff_data.phone_1,
      ddd_1: _this.props.staff_data.ddd_1,
      phone_2: _this.props.staff_data.phone_2,
      ddd_2: _this.props.staff_data.ddd_2,
      address: _this.props.staff_data.address,
      number: _this.props.staff_data.number,
      complement: _this.props.staff_data.complement,
      city: _this.props.staff_data.city,
      state: _this.props.staff_data.state,
      country: _this.props.staff_data.country,
      cep: _this.props.staff_data.cep,
      cpf: _this.props.staff_data.cpf,
      identity: _this.props.staff_data.identity,
      id_uf: _this.props.staff_data.id_uf,
      id_date: _this.props.staff_data.id_date,
      id_exp: _this.props.staff_data.id_exp,
      date_of_birth: _this.props.staff_data.date_of_birth,
      neighborhood: _this.props.staff_data.neighborhood,
      naturality: _this.props.staff_data.naturality,
      scholarly: _this.props.staff_data.scholarly,
      mother: _this.props.staff_data.mother,
      father: _this.props.staff_data.father,
      confidence_us: _this.props.staff_data.confidence_us,
      expire_us: _this.props.staff_data.expire_us,
      confidence_eu: _this.props.staff_data.confidence_eu,
      expire_eu: _this.props.staff_data.expire_eu,
      photo: _this.props.staff_data.photo,
      ctps: _this.props.staff_data.ctps,
      ctps_serial: _this.props.staff_data.ctps_serial,
      ctps_expedition: _this.props.staff_data.ctps_expedition,
      ctps_uf: _this.props.staff_data.ctps_uf,
      pis: _this.props.staff_data.pis,
      blood_type: _this.props.staff_data.blood_type,
      inscription: _this.props.staff_data.inscription,
      sispat: _this.props.staff_data.sispat,
      canac: _this.props.staff_data.canac,
      license: _this.props.staff_data.license,
      hired: _this.props.staff_data.hired,
      car_adm: _this.props.staff_data.car_adm,
      car_atu: _this.props.staff_data.car_atu,
      type: _this.props.staff_data.type,
      race: _this.props.staff_data.race,
      uf_birth: _this.props.staff_data.uf_birth,
      city_birth: _this.props.staff_data.city_birth,
      country_birth: _this.props.staff_data.country_birth,
      aso: _this.props.staff_data.aso_str,
      electrocard: _this.props.staff_data.electrocard_str,
      sapiens_code: _this.props.staff_data.sapiens_code
    };

    //bind específico
    // this.edit = this.edit.bind(this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(StaffEditTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (typeof this.state.name === 'undefined' && typeof newProps.staff_data.name !== 'undefined') {
        this.setState({
          id: newProps.staff_id,
          name: newProps.staff_data.name,
          nickname: newProps.staff_data.nickname,
          civil_state: newProps.staff_data.civil_state,
          email: newProps.staff_data.email,
          ddd_1: newProps.staff_data.ddd_1,
          phone_1: newProps.staff_data.phone_1,
          ddd_2: newProps.staff_data.ddd_2,
          phone_2: newProps.staff_data.phone_2,
          address: newProps.staff_data.address,
          number: newProps.staff_data.number,
          complement: newProps.staff_data.complement,
          city: newProps.staff_data.city,
          state: newProps.staff_data.state,
          country: newProps.staff_data.country,
          cep: newProps.staff_data.cep,
          cpf: newProps.staff_data.cpf,
          identity: newProps.staff_data.identity,
          id_uf: newProps.staff_data.id_uf,
          id_date: newProps.staff_data.id_date_str,
          id_exp: newProps.staff_data.id_exp,
          date_of_birth: newProps.staff_data.date_of_birth_str,
          neighborhood: newProps.staff_data.neighborhood,
          naturality: newProps.staff_data.naturality,
          scholarly: newProps.staff_data.scholarly,
          mother: newProps.staff_data.mother,
          father: newProps.staff_data.father,
          confidence_us: newProps.staff_data.confidence_us,
          expire_us: newProps.staff_data.expire_us_str,
          confidence_eu: newProps.staff_data.confidence_eu,
          expire_eu: newProps.staff_data.expire_eu_str,
          photo: newProps.staff_data.photo,
          ctps: newProps.staff_data.ctps,
          ctps_serial: newProps.staff_data.ctps_serial,
          ctps_expedition: newProps.staff_data.ctps_expedition,
          ctps_uf: newProps.staff_data.ctps_uf,
          pis: newProps.staff_data.pis,
          blood_type: newProps.staff_data.blood_type,
          inscription: newProps.staff_data.inscription,
          sispat: newProps.staff_data.sispat,
          canac: newProps.staff_data.canac,
          license: newProps.staff_data.license,
          hired: newProps.staff_data.hired_str,
          car_adm: newProps.staff_data.car_adm,
          car_atu: newProps.staff_data.car_atu,
          type: newProps.staff_data.type,
          race: newProps.staff_data.race,
          uf_birth: newProps.staff_data.uf_birth,
          city_birth: newProps.staff_data.city_birth,
          country_birth: newProps.staff_data.country_birth,
          aso: newProps.staff_data.aso_str,
          electrocard: newProps.staff_data.electrocard_str,
          sapiens_code: newProps.staff_data.sapiens_code
        });
      }
    }

    // Fetch salvando a edição
    // edit(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //       id: this.state.id,
    //       name: this.state.name,
    //       nickname: this.state.nickname,
    //       civil_state: this.state.civil_state,
    //       email: this.state.email,
    //       ddd_1: this.state.ddd_1,
    //       phone_1: this.state.phone_1,
    //       ddd_2: this.state.ddd_2,
    //       phone_2: this.state.phone_2,
    //       address: this.state.address,
    //       number: this.state.number,
    //       complement: this.state.complement,
    //       city: this.state.city,
    //       state: this.state.state,
    //       country: this.state.country,
    //       cep: this.state.cep,
    //       cpf: this.state.cpf,
    //       identity: this.state.identity,
    //       id_uf: this.state.id_uf,
    //       id_date: this.state.id_date,
    //       id_exp: this.state.id_exp,
    //       date_of_birth: this.state.date_of_birth,
    //       neighborhood: this.state.neighborhood,
    //       naturality: this.state.naturality,
    //       scholarly: this.state.scholarly,
    //       mother: this.state.mother,
    //       father: this.state.father,
    //       confidence_us: this.state.confidence_us,
    //       expire_us: this.state.expire_us,
    //       confidence_eu: this.state.confidence_eu,
    //       expire_eu: this.state.expire_eu,
    //       photo: this.state.photo,
    //       ctps: this.state.ctps,
    //       ctps_serial: this.state.ctps_serial,
    //       ctps_expedition: this.state.ctps_expedition,
    //       ctps_uf: this.state.ctps_uf,
    //       pis: this.state.pis,
    //       blood_type: this.state.blood_type,
    //       inscription: this.state.inscription,
    //       sispat: this.state.sispat,
    //       canac: this.state.canac,
    //       license: this.state.license,
    //       hired: this.state.hired,
    //       car_adm: this.state.car_adm,
    //       car_atu: this.state.car_atu,
    //       type: this.state.type,
    //       race: this.state.race,
    //       uf_birth: this.state.uf_birth,
    //       city_birth: this.state.city_birth,
    //       country_birth: this.state.country_birth,
    //       aso: this.state.aso,
    //       electrocard: this.state.electrocard,
    //       sapiens_code: this.state.sapiens_code
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api') + '/funcionario', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }


    // // Fetch salvando a edição
    // editar(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api') + '/funcionario', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }


  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: this.edit },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            null,
            this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.tituloInformacoesPessoais
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.Nome,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'name', value: this.state.name, onChange: this.handleChange.bind(this, 'name') })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.Apelido,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'nickname', value: this.state.nickname, onChange: this.handleChange.bind(this, 'nickname') })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.Telefone1,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'ddd_1', value: this.state.ddd_1, onChange: this.handleChange.bind(this, 'ddd_1') })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-9' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'phone_1', value: this.state.phone_1, onChange: this.handleChange.bind(this, 'phone_1') })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.Telefone2,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'ddd_2', value: this.state.ddd_2, onChange: this.handleChange.bind(this, 'ddd_2') })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-9' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'phone_2', value: this.state.phone_2, onChange: this.handleChange.bind(this, 'phone_2') })
                )
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.EstadoCivil,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'civil_state', value: this.state.civil_state, onChange: this.handleChange.bind(this, 'civil_state') })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.Email,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'email', value: this.state.email, onChange: this.handleChange.bind(this, 'email') })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.Naturalidade,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'naturality', value: this.state.naturality, onChange: this.handleChange.bind(this, 'naturality') })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.Escolaridade,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'scholarly', value: this.state.scholarly, onChange: this.handleChange.bind(this, 'scholarly') })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.NomeDaMae,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'mother', value: this.state.mother, onChange: this.handleChange.bind(this, 'mother') })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.NomeDoPai,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'father', value: this.state.father, onChange: this.handleChange.bind(this, 'father') })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.Raca,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'race', value: this.state.race, onChange: this.handleChange.bind(this, 'race') })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.DataDeNascimento,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.date_of_birth, maskChar: null, name: 'date_of_birth', mask: '99/99/9999', className: 'form-control', disabled: true, onChange: this.handleChange.bind(this, 'date_of_birth'), placeholder: '' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            null,
            this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.tituloEndereco
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-12 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.Endereco,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'address', value: this.state.address, onChange: this.handleChange.bind(this, 'address') })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.Numero,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'number', value: this.state.number, onChange: this.handleChange.bind(this, 'number') })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.Complemento,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'complement', value: this.state.complement, onChange: this.handleChange.bind(this, 'complement') })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.Bairro,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'neighborhood', value: this.state.neighborhood, onChange: this.handleChange.bind(this, 'neighborhood') })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.Cidade,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'city', value: this.state.city, onChange: this.handleChange.bind(this, 'city') })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.Estado,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'state', value: this.state.state, onChange: this.handleChange.bind(this, 'state') })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.Pais,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'country', value: this.state.country, onChange: this.handleChange.bind(this, 'country') })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.CEP,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'cep', value: this.state.cep, onChange: this.handleChange.bind(this, 'cep') })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.CPF,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'cpf', value: this.state.cpf, onChange: this.handleChange.bind(this, 'cpf') })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.Identidade,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'identity', value: this.state.identity, onChange: this.handleChange.bind(this, 'identity') })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.IdentidadeUF,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'id_uf', value: this.state.id_uf, onChange: this.handleChange.bind(this, 'id_uf') })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.IdentidadeDataDeExpedicao,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.id_date, maskChar: null, name: 'id_date', mask: '99/99/9999', className: 'form-control', disabled: true, onChange: this.handleChange.bind(this, 'id_date'), placeholder: '' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.IdentidadeOrgaoExpeditor,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'id_exp', value: this.state.id_exp, onChange: this.handleChange.bind(this, 'id_exp') })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.PIS,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'pis', value: this.state.pis, onChange: this.handleChange.bind(this, 'pis') })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.ConfidenceUS,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'confidence_us', value: this.state.confidence_us, onChange: this.handleChange.bind(this, 'confidence_us') })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.ExpiracaoConfidenceUS,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.expire_us, maskChar: null, name: 'expire_us', mask: '99/99/9999', className: 'form-control', disabled: true, onChange: this.handleChange.bind(this, 'expire_us'), placeholder: '' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.ConfidenceEU,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'confidence_eu', value: this.state.confidence_eu, onChange: this.handleChange.bind(this, 'confidence_eu') })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.ExpiracaoConfidenceEU,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.expire_eu, maskChar: null, name: 'expire_eu', mask: '99/99/9999', className: 'form-control', disabled: true, onChange: this.handleChange.bind(this, 'expire_eu'), placeholder: '' })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.CTPS,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'ctps', value: this.state.ctps, onChange: this.handleChange.bind(this, 'ctps') })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.CTPSNumeroDeSerie,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'ctps_serial', value: this.state.ctps_serial, onChange: this.handleChange.bind(this, 'ctps_serial') })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.CTPSExpedicao,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.ctps_expedition, maskChar: null, name: 'ctps_expedition', mask: '99/99/9999', className: 'form-control', disabled: true, onChange: this.handleChange.bind(this, 'ctps_expedition'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.CTPSUF,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'ctps_uf', value: this.state.ctps_uf, onChange: this.handleChange.bind(this, 'ctps_uf') })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.TipoSanguineo,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'blood_type', value: this.state.blood_type, onChange: this.handleChange.bind(this, 'blood_type') })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.Matricula,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'inscription', value: this.state.inscription, onChange: this.handleChange.bind(this, 'inscription') })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.SISPAT,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'sispat', value: this.state.sispat, onChange: this.handleChange.bind(this, 'sispat') })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.CANAC,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'canac', value: this.state.canac, onChange: this.handleChange.bind(this, 'canac') })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.Licenca,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'license', value: this.state.license, onChange: this.handleChange.bind(this, 'license') })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.Contratacao,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'hired', value: this.state.hired, onChange: this.handleChange.bind(this, 'hired') })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.CargoDeAdmissao,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'car_adm', value: this.state.car_adm, onChange: this.handleChange.bind(this, 'car_adm') })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.CargoAtual,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'car_atu', value: this.state.car_atu, onChange: this.handleChange.bind(this, 'car_atu') })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.EstadoDeNascimento,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'uf_birth', value: this.state.uf_birth, onChange: this.handleChange.bind(this, 'uf_birth') })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.CidadeDeNascimento,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'city_birth', value: this.state.city_birth, onChange: this.handleChange.bind(this, 'city_birth') })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.PaisDeNascimento,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'country_birth', value: this.state.country_birth, onChange: this.handleChange.bind(this, 'country_birth') })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.ASO,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'aso', value: this.state.aso, onChange: this.handleChange.bind(this, 'aso') })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.Eletrocardiograma,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.electrocard, maskChar: null, name: 'electrocard', mask: '99/99/9999', className: 'form-control', disabled: true, onChange: this.handleChange.bind(this, 'electrocard'), placeholder: '' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-6 form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'label',
                null,
                this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.formulario.CodigoSapiens,
                ':'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', className: 'form-control', disabled: true, name: 'sapiens_code', value: this.state.sapiens_code, onChange: this.handleChange.bind(this, 'sapiens_code') })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffEditTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffEditTab);

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário





var StaffGratificationsTab = function (_Component) {
  _inherits(StaffGratificationsTab, _Component);

  function StaffGratificationsTab(props) {
    _classCallCheck(this, StaffGratificationsTab);

    var _this = _possibleConstructorReturn(this, (StaffGratificationsTab.__proto__ || Object.getPrototypeOf(StaffGratificationsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      staff_id: _this.props.staff_id,
      date_start: '',
      staff_gratifications: [],
      gratification_id: null,
      gratifications: []
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.activate = this.activate.bind(this);
    // this.archive = this.archive.bind(this);
    // this.delete = this.delete.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }
  // handleToggleChange (name, event) {
  //   var change = {};
  //   if (event.target.checked === true) {
  //     var value = 1;
  //   } else {
  //     var value = 0;
  //   }
  //   change[name] = value;
  //   this.setState(change);
  // } 
  // LM


  _createClass(StaffGratificationsTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.staff_gratifications) && this.state.loaded === false) {
        this.setState({
          gratifications: newProps.gratifications,
          staff_gratifications: newProps.staff_gratifications,
          loaded: true
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     gratification_id: this.state.gratification_id,
    //     date_start: this.state.date_start,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api') + '/funcionario/gratificacao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.refreshData();
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // // Fetch ativando um item
    // activate(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar essa gratificação?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/gratificacao/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           self.refreshData();
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch deletando um item
    // archive(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar essa gratificação?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/gratificacao/arquivar/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           self.refreshData();
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }
    // // Fetch deletando um item
    // delete(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de deletar essa gratificação?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/gratificacao/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           self.refreshData();
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData() {
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/gratificacoes/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ staff_gratifications: responseJson.data });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigtrip.EditarFuncionario.tabGratificacoes.tituloGratificacoes
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_gratifications === null || typeof this.state.staff_gratifications === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigtrip.EditarFuncionario.tabGratificacoes.nenhumaGratificacaoCadastrada
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabGratificacoes.tabela.Gratificacao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabGratificacoes.tabela.Data
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'col-md-1 text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabGratificacoes.tabela.Status
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_gratifications).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_gratifications[k].gratification
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_gratifications[k].date_start_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_gratifications[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      self.locale.ColaboradoresSigtrip.EditarFuncionario.tabGratificacoes.tabela.Ativo
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      self.locale.ColaboradoresSigtrip.EditarFuncionario.tabGratificacoes.tabela.Arquivado
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffGratificationsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (StaffGratificationsTab);

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário


var StaffGuaranteedHoursTab = function (_Component) {
  _inherits(StaffGuaranteedHoursTab, _Component);

  function StaffGuaranteedHoursTab(props) {
    var _this$state;

    _classCallCheck(this, StaffGuaranteedHoursTab);

    var _this = _possibleConstructorReturn(this, (StaffGuaranteedHoursTab.__proto__ || Object.getPrototypeOf(StaffGuaranteedHoursTab)).call(this, props));

    _this.state = (_this$state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      only_active: 1,
      staff_id: _this.props.staff_id,
      code: null,
      hours: null
    }, _defineProperty(_this$state, 'only_active', 1), _defineProperty(_this$state, 'staff_guaranteed_hours', []), _this$state);

    //bind específico
    // this.add = this.add.bind(this);
    // this.ativar = this.ativar.bind(this);
    // this.desativar = this.desativar.bind(this);
    // this.delete = this.delete.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);
    _this.refreshDataActive = _this.refreshDataActive.bind(_this);
    return _this;
  }
  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // }
  // LM


  _createClass(StaffGuaranteedHoursTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && Array.isArray(newProps.staff_guaranteed_hours)) {
        this.setState({
          staff_guaranteed_hours: newProps.staff_guaranteed_hours,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     code: this.state.code,
    //     only_active: this.state.only_active,
    //     hours: this.state.hours,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api') + '/funcionario/horas/garantidas', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.setState({ staff_guaranteed_hours: responseJson.data });
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // // Fetch ativando um item
    // ativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar essas horas garantidas?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/horas/garantidas/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_guaranteed_hours: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

    // // Fetch deletando um item
    // desativar(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar essas horas garantidas?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       only_active: this.state.only_active,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/horas/garantidas/desativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.setState({ staff_guaranteed_hours: responseJson.data });
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/horas/garantidas/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ staff_guaranteed_hours: responseJson.data, only_active: 0 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'refreshDataActive',
    value: function refreshDataActive(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/horas/garantidas/ativas/' + self.state.staff_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_guaranteed_hours: responseJson.data, only_active: 1 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }

    // delete($id) {
    //   var confirm = window.confirm('Tem certeza que deseja deletar essas horas garantidas?');
    //   if (confirm) {
    //     var self = this;
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/horas/garantidas/' + $id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.refreshData(responseJson);
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          'Centro de custo'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_guaranteed_hours === null || typeof this.state.staff_guaranteed_hours === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              'Nenhuma horas garantidas cadastrado.'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Horas Garantidas - Adicional'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'C\xF3digo'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Cadastrado em'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Status'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_guaranteed_hours).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_guaranteed_hours[k].hours
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_guaranteed_hours[k].code
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_guaranteed_hours[k].created_at_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_guaranteed_hours[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      'ativo'
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      'arquivado'
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffGuaranteedHoursTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (StaffGuaranteedHoursTab);

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_datepicker__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Importação da tabela




var StaffHoursTab = function (_Component) {
  _inherits(StaffHoursTab, _Component);

  function StaffHoursTab(props) {
    _classCallCheck(this, StaffHoursTab);

    var _this = _possibleConstructorReturn(this, (StaffHoursTab.__proto__ || Object.getPrototypeOf(StaffHoursTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      flight_hours_totals: [],
      staff_flight_files: [],
      name: '',
      archive: '',
      date_start: '',
      id: ''
    };
    // this.botaoDeletar = this.botaoDeletar.bind(this);
    // this.adicionarArquivo = this.adicionarArquivo.bind(this);
    // this.deletar = this.deletar.bind(this);
    // this.deletarLinha = this.deletarLinha.bind(this);
    _this.botaoDownloadArquivo = _this.botaoDownloadArquivo.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 

  // handleChangeDatePicker (state, date) {
  //   var change = {};
  //   change[state] = date.format("DD/MM/YYYY");
  //   this.setState(change);
  // }   

  // LM
  // Setamos o state.date para a data de hoje


  _createClass(StaffHoursTab, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var today = new Date().toISOString().slice(0, 10);
      var today_str = new Date().toJSON().slice(0, 10).split('-').reverse().join('/');

      this.setState({ date_start: today_str });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.flight_hours_totals)) {
        this.setState({
          flight_hours_totals: newProps.flight_hours_totals
        });
      }
      if (typeof newProps.staff_id !== 'undefined') {
        this.setState({
          id: newProps.staff_id
        });
      }
      if (Array.isArray(newProps.staff_flight_files)) {
        this.setState({ staff_flight_files: newProps.staff_flight_files });
      }
    }

    // adicionarArquivo(event) {
    //   event.preventDefault();
    //   var data = new FormData();
    //   var imagedata = document.querySelector(".input-archive-flight-files").files[0];
    //   data.append("name", this.state.name);
    //   data.append("date_start", this.state.date_start);
    //   data.append("imagem", imagedata);
    //   data.append("staff_id", this.props.staff_id);
    //   var header = this.refs.request_api.header();
    //   var self = this;
    //   this.props.handleAlert('', '', 'open');
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api') + '/funcionario/voos/arquivo', {
    //       method: 'POST',
    //       mode: 'cors',
    //       headers: value,
    //       body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           var data_temp = self.state.staff_flight_files;
    //           data_temp.push(responseJson.data);
    //           self.setState({staff_flight_files: data_temp});
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //       console.error(error);
    //     });
    //   });   
    // }


    // botaoDeletar (cell, row, enumObject, index) {
    //   var variavel = (
    //     <button className="btn btn-sm btn-danger" value={cell} onClick={this.deletar}>
    //       <i className="fa fa-fw fa-trash"></i>
    //     </button>
    //   );

    //   return variavel;
    // }

    // deletar (event) {
    //   var staff_flight_file_id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de deletar esse arquivo?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/voos/arquivo/' + staff_flight_file_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //         if (responseJson.status === 'success') {
    //           self.deletarLinha(staff_flight_file_id);
    //         }
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // deletarLinha(staff_flight_file_id) {
    //   var data = this.state.staff_flight_files;
    //   data.map(function(dado, index){
    //     if (dado.id == staff_flight_file_id) {
    //       data.splice(index, 1);
    //     }
    //   });
    //   this.setState({staff_flight_files: data});
    // }

  }, {
    key: 'botaoDownloadArquivo',
    value: function botaoDownloadArquivo(cell, row) {
      var data = this.state.staff_flight_files;
      var status = '';
      var arquivo = '';
      var nome = '';
      data.map(function (dado, index) {
        if (dado.id == cell) {
          arquivo = dado.archive;
          nome = dado.name;
        }
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { target: '_blank', href: __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/files/staff_flights/' + arquivo },
        ' ',
        nome
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHorasDeVoo.tituloTotaisDeHoras
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["BootstrapTable"],
          { data: this.state.flight_hours_totals, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHorasDeVoo.tabelaTotaisDeHoras.semAeronaves }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'id', isKey: true, hidden: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
            this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHorasDeVoo.tabelaTotaisDeHoras.ID
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'aircraft_model', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
            this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHorasDeVoo.tabelaTotaisDeHoras.Modelo
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'fb', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
            this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHorasDeVoo.tabelaTotaisDeHoras.FB
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'total_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
            this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHorasDeVoo.tabelaTotaisDeHoras.Total
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'ifr_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
            this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHorasDeVoo.tabelaTotaisDeHoras.IFR
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'noturno_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
            this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHorasDeVoo.tabelaTotaisDeHoras.Noturno
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'app', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
            this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHorasDeVoo.tabelaTotaisDeHoras.APP
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'daytime', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
            this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHorasDeVoo.tabelaTotaisDeHoras.Diurno
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'nighttime', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
            this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHorasDeVoo.tabelaTotaisDeHoras.Noturno
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["BootstrapTable"],
          { data: this.state.staff_flight_files, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHorasDeVoo.tabelaArquivos.semArquivos }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
            { isKey: true, dataFormat: this.botaoDownloadArquivo, dataField: 'id', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
            this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHorasDeVoo.tabelaArquivos.NomeDoArquivo
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'date_start_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
            this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHorasDeVoo.tabelaArquivos.Validade
          )
        )
      );
    }
  }]);

  return StaffHoursTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffHoursTab);

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário





var StaffIcaosTab = function (_Component) {
  _inherits(StaffIcaosTab, _Component);

  function StaffIcaosTab(props) {
    _classCallCheck(this, StaffIcaosTab);

    var _this = _possibleConstructorReturn(this, (StaffIcaosTab.__proto__ || Object.getPrototypeOf(StaffIcaosTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      staff_id: _this.props.staff_id,
      staff_icaos: [],
      expiration: '',
      level: '',
      icaos: [{ value: "NOT COMPLIANT", label: "NOT COMPLIANT" }, { value: "1", label: "1" }, { value: "2", label: "2" }, { value: "3", label: "3" }, { value: "4", label: "4" }, { value: "5", label: "5" }, { value: "6", label: "6" }]
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.activate = this.activate.bind(this);
    // this.archive = this.archive.bind(this);
    // this.delete = this.delete.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }
  // handleToggleChange (name, event) {
  //   var change = {};
  //   if (event.target.checked === true) {
  //     var value = 1;
  //   } else {
  //     var value = 0;
  //   }
  //   change[name] = value;
  //   this.setState(change);
  // } 
  // LM


  _createClass(StaffIcaosTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.staff_icaos) && this.state.loaded === false) {
        this.setState({
          staff_icaos: newProps.staff_icaos,
          loaded: true
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     level: this.state.level,
    //     expiration: this.state.expiration,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api') + '/funcionario/icao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.refreshData();
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // // Fetch ativando um item
    // activate(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar esse ICAO?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/icao/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           self.refreshData();
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch deletando um item
    // delete(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de deletar esse ICAO?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/icao/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           self.refreshData();
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch deletando um item
    // archive(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar esse ICAO?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/icao/arquivar/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           self.refreshData();
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData() {
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/icaos/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ staff_icaos: responseJson.data });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigtrip.EditarFuncionario.tabICAO.tituloICAOS
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_icaos === null || typeof this.state.staff_icaos === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigtrip.EditarFuncionario.tabICAO.nenhumICAOCadastrado
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabICAO.tabela.Level
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabICAO.tabela.Vencimento
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabICAO.tabela.DataDeInsercao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'col-md-1 text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabICAO.tabela.Status
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_icaos).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_icaos[k].level
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_icaos[k].expiration_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_icaos[k].date_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_icaos[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      self.locale.ColaboradoresSigtrip.EditarFuncionario.tabICAO.tabela.Ativo
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      self.locale.ColaboradoresSigtrip.EditarFuncionario.tabICAO.tabela.Arquivado
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffIcaosTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (StaffIcaosTab);

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário





var SStaffIndicationsTab = function (_Component) {
  _inherits(SStaffIndicationsTab, _Component);

  function SStaffIndicationsTab(props) {
    _classCallCheck(this, SStaffIndicationsTab);

    var _this = _possibleConstructorReturn(this, (SStaffIndicationsTab.__proto__ || Object.getPrototypeOf(SStaffIndicationsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      staff_id: _this.props.staff_id,
      designation_id: null,
      aircraft_model_id: null,
      date_start: '',
      staff_indications: [],
      aircraft_models: [],
      designations: []
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.activate = this.activate.bind(this);
    // this.delete = this.delete.bind(this);
    // this.archive = this.archive.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }
  // handleToggleChange (name, event) {
  //   var change = {};
  //   if (event.target.checked === true) {
  //     var value = 1;
  //   } else {
  //     var value = 0;
  //   }
  //   change[name] = value;
  //   this.setState(change);
  // } 
  // LM


  _createClass(SStaffIndicationsTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.staff_indications) && this.state.loaded === false) {
        this.setState({
          aircraft_models: newProps.aircraft_models,
          designations: newProps.designations,
          staff_indications: newProps.staff_indications,
          loaded: true
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     designation_id: this.state.designation_id,
    //     aircraft_model_id: this.state.aircraft_model_id,
    //     date_start: this.state.date_start,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api') + '/funcionario/indicacao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.refreshData();
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // // Fetch ativando um item
    // activate(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar essa indicação?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //       staff_id: this.state.staff_id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/indicacao/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           self.refreshData();
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch deletando um item
    // archive(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar essa indicação?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/indicacao/arquivar/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           self.refreshData();
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }
    // // Fetch deletando um item
    // delete(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de deletar essa indicação?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/indicacao/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           self.refreshData();
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData() {
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/indicacoes/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ staff_indications: responseJson.data });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigtrip.EditarFuncionario.tabIndicacoes.tituloIndicacao
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_indications === null || typeof this.state.staff_indications === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigtrip.EditarFuncionario.tabIndicacoes.nenhumaIndicacaoCadastrada
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabIndicacoes.tabela.Designacao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabIndicacoes.tabela.Frota
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'col-md-1 text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabIndicacoes.tabela.Status
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabIndicacoes.tabela.Data
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_indications).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_indications[k].designation
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_indications[k].aircraft_model
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_indications[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      self.locale.ColaboradoresSigtrip.EditarFuncionario.tabIndicacoes.tabela.Ativo
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      self.locale.ColaboradoresSigtrip.EditarFuncionario.tabIndicacoes.tabela.Arquivado
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_indications[k].date_start_str
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return SStaffIndicationsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SStaffIndicationsTab);

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário





var StaffLicensesTab = function (_Component) {
  _inherits(StaffLicensesTab, _Component);

  function StaffLicensesTab(props) {
    _classCallCheck(this, StaffLicensesTab);

    var _this = _possibleConstructorReturn(this, (StaffLicensesTab.__proto__ || Object.getPrototypeOf(StaffLicensesTab)).call(this, props));

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      staff_id: _this.props.staff_id,
      code: null,
      only_active: 1,
      expiration: '',
      aircraft_model_id: null,
      type: null,
      staff_licenses: [],
      licence_codes: [{ value: "CCF", label: _this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHabilitacoes.opcoesCodigoDeHabilitacao.CCF }, { value: "CHT", label: _this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHabilitacoes.opcoesCodigoDeHabilitacao.CHT }],
      aircraft_models: [],
      licence_types: [{ value: "", label: _this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHabilitacoes.opcoesHabilitacao.SelecionarTipo }, { value: "IFRH", label: _this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHabilitacoes.opcoesHabilitacao.IFRH }]
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.activate = this.activate.bind(this);
    // this.archive = this.archive.bind(this);
    // this.delete = this.delete.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);
    _this.refreshDataActive = _this.refreshDataActive.bind(_this);
    return _this;
  }

  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }
  // handleToggleChange (name, event) {
  //   var change = {};
  //   if (event.target.checked === true) {
  //     var value = 1;
  //   } else {
  //     var value = 0;
  //   }
  //   change[name] = value;
  //   this.setState(change);
  // } 


  // LM


  _createClass(StaffLicensesTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.staff_licenses) && this.state.loaded === false) {
        this.setState({
          aircraft_models: newProps.aircraft_models,
          staff_licenses: newProps.staff_licenses,
          loaded: true
        });
      }
    }

    // // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     code: this.state.code,
    //     expiration: this.state.expiration,
    //     aircraft_model_id: this.state.aircraft_model_id,
    //     type: this.state.type,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api') + '/funcionario/habilitacao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.refreshData();
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // // Fetch ativando um item
    // activate(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar essa habilitação?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/habilitacao/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           if(self.state.only_active === 0){
    //             self.refreshDataActive(responseJson);
    //           } else{      
    //             self.refreshData(responseJson);
    //           }
    //         }
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }
    // delete (event) {
    //   var staff_license_id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de deletar essa habilitação?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/habilitacao/' + staff_license_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.refreshData(responseJson);
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }
    // // Fetch deletando um item
    // archive(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar essa habilitação?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/habilitacao/arquivar/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           if(self.state.only_active === 0){
    //             self.refreshDataActive(responseJson);
    //           } else{      
    //             self.refreshData(responseJson);
    //           }
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/habilitacoes/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ staff_licenses: responseJson.data, only_active: 0 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'refreshDataActive',
    value: function refreshDataActive(event) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/habilitacoes/ativas/' + self.state.staff_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ staff_licenses: responseJson.data, only_active: 1 });
          }
          if (typeof event.message !== 'undefined') {
            self.props.handleAlert(event.message, event.status, 'open');
          } else {
            self.props.handleAlert("", "", 'closed');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHabilitacoes.tituloHabilitacoes
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_licenses === null || typeof this.state.staff_licenses === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHabilitacoes.nenhumaHabilitacaoCadastrada
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHabilitacoes.tabela.Codigo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHabilitacoes.tabela.Frota
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHabilitacoes.tabela.Tipo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHabilitacoes.tabela.CANAC
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHabilitacoes.tabela.Licenca
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHabilitacoes.tabela.Vencimento
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'col-md-1 text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHabilitacoes.tabela.Status
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_licenses).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_licenses[k].code
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_licenses[k].aircraft_model
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_licenses[k].type
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_licenses[k].canac
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_licenses[k].license
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_licenses[k].expiration_status === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'text text-success' },
                      self.state.staff_licenses[k].expiration_str
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'text text-danger' },
                      self.state.staff_licenses[k].expiration_str
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_licenses[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      self.locale.ColaboradoresSigtrip.EditarFuncionario.tabHabilitacoes.tabela.Ativo
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      self.locale.ColaboradoresSigtrip.EditarFuncionario.tabHabilitacoes.tabela.Arquivado
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffLicensesTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffLicensesTab);

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






// Importação da tabela


var StaffPaymentsHourTab = function (_Component) {
  _inherits(StaffPaymentsHourTab, _Component);

  // constructor
  function StaffPaymentsHourTab(props) {
    _classCallCheck(this, StaffPaymentsHourTab);

    var _this = _possibleConstructorReturn(this, (StaffPaymentsHourTab.__proto__ || Object.getPrototypeOf(StaffPaymentsHourTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      training_certification_staff_payments_hours: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    // this.botaoEditOrderPayment = this.botaoEditOrderPayment.bind(this);
    return _this;
  }

  _createClass(StaffPaymentsHourTab, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.training_certification_staff_payments_hours)) {
        this.setState({ training_certification_staff_payments_hours: newProps.training_certification_staff_payments_hours });
      }
    }

    // botaoEditOrderPayment (cell, row) {
    //   var dados = this.state.training_certification_staff_payments_hours;
    //   var payment_order_id = '';
    //   var code = '';
    //   dados.map(function(dado, index){
    //     if (dado.id == cell) {
    //       payment_order_id = dado.payment_order_id;
    //       code = dado.payment_order_code;
    //     }
    //   });
    //   return (
    //     <Link to={'/ordem/pagamento/editar/' + payment_order_id}> {code}</Link>
    //   );
    // }

  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["BootstrapTable"],
          { data: this.state.training_certification_staff_payments_hours, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: 'Exportar CSV', noDataText: 'Não há pagamentos em aberto' }, search: true, multiColumnSearch: true, searchPlaceholder: 'Procurar' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
            'ID'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'payment_order_code', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' } },
            'C\xF3digo trein.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'certification_type', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' } },
            'Tipo de trein.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'certification', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' } },
            'Aula'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'period', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' } },
            'Per\xEDodo'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'training', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' } },
            'Treinamento'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'training_code', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' } },
            'N\xBA e Rev.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'supplier', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' } },
            'Local'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'hours_paid_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' } },
            'Horas pagas'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'hour_value', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' } },
            'Valor da hora'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'hours_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' } },
            'Total de horas'
          )
        )
      );
    }
  }]);

  return StaffPaymentsHourTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffPaymentsHourTab);

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







// Importação da tabela


var StaffPaymentsInternationalTab = function (_Component) {
  _inherits(StaffPaymentsInternationalTab, _Component);

  // constructor
  function StaffPaymentsInternationalTab(props) {
    _classCallCheck(this, StaffPaymentsInternationalTab);

    var _this = _possibleConstructorReturn(this, (StaffPaymentsInternationalTab.__proto__ || Object.getPrototypeOf(StaffPaymentsInternationalTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      payment_order_id: '',
      training_certification_staff_payments_international: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    // this.botaoEditOrderPayment = this.botaoEditOrderPayment.bind(this);
    return _this;
  }

  _createClass(StaffPaymentsInternationalTab, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.training_certification_staff_payments_international)) {
        this.setState({ training_certification_staff_payments_international: newProps.training_certification_staff_payments_international });
      }
    }

    // botaoEditOrderPayment (cell, row) {
    //   var dados = this.state.training_certification_staff_payments_international;
    //   var payment_order_id = '';
    //   var code = '';
    //   dados.map(function(dado, index){
    //     if (dado.id == cell) {
    //       payment_order_id = dado.payment_order_id;
    //       code = dado.payment_order_code;
    //     }
    //   });
    //   return (
    //     <Link to={'/ordem/pagamento/editar/' + payment_order_id}> {code}</Link>
    //   );
    // }

  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["BootstrapTable"],
          { data: this.state.training_certification_staff_payments_international, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: 'Exportar CSV', noDataText: 'Não há pagamentos em aberto' }, search: true, multiColumnSearch: true, searchPlaceholder: 'Procurar' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
            'ID'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'payment_order_code', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' } },
            'C\xF3digo trein.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'period', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' } },
            'Per\xEDodo'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'training', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' } },
            'Treinamento'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'training_code', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' } },
            'N\xBA e Rev.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'daily_paid', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' } },
            'Di\xE1rias'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'daily_value', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' } },
            'Valor/di\xE1ria'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'daily_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' } },
            'Total em di\xE1rias'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'daily_currency', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' } },
            'Moeda'
          )
        )
      );
    }
  }]);

  return StaffPaymentsInternationalTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffPaymentsInternationalTab);

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Miscelania_Overlay__ = __webpack_require__(8);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







// Importação da tabela








var StaffPaymentsNationalTab = function (_Component) {
  _inherits(StaffPaymentsNationalTab, _Component);

  // constructor
  function StaffPaymentsNationalTab(props) {
    _classCallCheck(this, StaffPaymentsNationalTab);

    var _this = _possibleConstructorReturn(this, (StaffPaymentsNationalTab.__proto__ || Object.getPrototypeOf(StaffPaymentsNationalTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      training_certification_staff_payments_national: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    // this.botaoEditOrderPayment = this.botaoEditOrderPayment.bind(this);
    return _this;
  }
  // Handlers


  _createClass(StaffPaymentsNationalTab, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.training_certification_staff_payments_national)) {
        this.setState({ training_certification_staff_payments_national: newProps.training_certification_staff_payments_national });
      }
    }

    // botaoEditOrderPayment (cell, row) {
    //   var dados = this.state.training_certification_staff_payments_national;
    //   var payment_order_id = '';
    //   var code = '';
    //   dados.map(function(dado, index){
    //     if (dado.id == cell) {
    //       payment_order_id = dado.payment_order_id;
    //       code = dado.payment_order_code;
    //     }
    //   });
    //   return (
    //     <Link to={'/ordem/pagamento/editar/' + payment_order_id}> {code}</Link>
    //   );
    // }

  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["BootstrapTable"],
          { data: this.state.training_certification_staff_payments_national, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: 'Exportar CSV', noDataText: 'Não há pagamentos em aberto' }, search: true, multiColumnSearch: true, searchPlaceholder: 'Procurar' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
            'ID'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'payment_order_code', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' } },
            'C\xF3digo trein.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'period', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' } },
            'Per\xEDodo'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'training', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' } },
            'Treinamento'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'training_code', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' } },
            'N\xBA e Rev.'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'daily_paid', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' } },
            'Di\xE1rias'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'daily_value', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' } },
            'Valor/di\xE1ria'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'daily_total', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' } },
            'Total em di\xE1rias'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'daily_currency', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' } },
            'Moeda'
          )
        )
      );
    }
  }]);

  return StaffPaymentsNationalTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffPaymentsNationalTab);

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StaffPaymentsHourTab__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaffPaymentsNationalTab__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StaffPaymentsInternationalTab__ = __webpack_require__(925);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







// Tabs




var StaffPaymentsTab = function (_Component) {
  _inherits(StaffPaymentsTab, _Component);

  // constructor
  function StaffPaymentsTab(props) {
    _classCallCheck(this, StaffPaymentsTab);

    var _this = _possibleConstructorReturn(this, (StaffPaymentsTab.__proto__ || Object.getPrototypeOf(StaffPaymentsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      key: 1,
      loaded: 0,
      training_certification_staff_payments_national: [],
      training_certification_staff_payments_international: [],
      training_certification_staff_payments_hours: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);
    return _this;
  }
  // Handlers


  _createClass(StaffPaymentsTab, [{
    key: 'handleNavTab',
    value: function handleNavTab(state, key) {
      var change = {};
      change[state] = key;
      this.setState(change);
      this.setState({ overlay: { message: '', type: '', status: '' } });
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.training_certification_staff_payments_hours)) {
        this.setState({ training_certification_staff_payments_hours: newProps.training_certification_staff_payments_hours });
      }
      if (Array.isArray(newProps.training_certification_staff_payments_international)) {
        this.setState({ training_certification_staff_payments_international: newProps.training_certification_staff_payments_international });
      }
      if (Array.isArray(newProps.training_certification_staff_payments_national)) {
        this.setState({ training_certification_staff_payments_national: newProps.training_certification_staff_payments_national });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["e" /* Tabs */],
          { activeKey: this.state.key, onSelect: this.handleNavTab.bind(this, 'key'), id: 'controlled-tab-example' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["f" /* Tab */],
            { eventKey: 1, title: 'Horas' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__StaffPaymentsHourTab__["a" /* default */], { handleAlert: this.handleAlert, training_certification_staff_payments_hours: this.state.training_certification_staff_payments_hours })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["f" /* Tab */],
            { eventKey: 2, title: 'Di\xE1ria nacional' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StaffPaymentsNationalTab__["a" /* default */], { handleAlert: this.handleAlert, training_certification_staff_payments_national: this.state.training_certification_staff_payments_national })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["f" /* Tab */],
            { eventKey: 3, title: 'Di\xE1ria internacional' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StaffPaymentsInternationalTab__["a" /* default */], { handleAlert: this.handleAlert, training_certification_staff_payments_international: this.state.training_certification_staff_payments_international })
          )
        )
      );
    }
  }]);

  return StaffPaymentsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (StaffPaymentsTab);

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário





var StaffPeriodsTab = function (_Component) {
  _inherits(StaffPeriodsTab, _Component);

  function StaffPeriodsTab(props) {
    _classCallCheck(this, StaffPeriodsTab);

    var _this = _possibleConstructorReturn(this, (StaffPeriodsTab.__proto__ || Object.getPrototypeOf(StaffPeriodsTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      staff_id: _this.props.staff_id,
      date_start: '',
      staff_periods: [],
      schedule_regime_id: null,
      staff_regimes_select: []
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.activate = this.activate.bind(this);
    // this.archive = this.archive.bind(this);
    // this.delete = this.delete.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // }
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }
  // handleToggleChange (name, event) {
  //   var change = {};
  //   if (event.target.checked === true) {
  //     var value = 1;
  //   } else {
  //     var value = 0;
  //   }
  //   change[name] = value;
  //   this.setState(change);
  // }
  // LM


  _createClass(StaffPeriodsTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.staff_periods) && this.state.loaded === false) {
        this.setState({
          staff_regimes_select: newProps.staff_regimes_select,
          staff_periods: newProps.staff_periods,
          loaded: true
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     schedule_regime_id: this.state.schedule_regime_id,
    //     date_start: this.state.date_start,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api') + '/funcionario/quinzena', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.refreshData();
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // // Fetch ativando um item
    // activate(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar essa quinzena?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/quinzena/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           self.refreshData();
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

    // // Fetch deletando um item
    // archive(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar essa quinzena?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/quinzena/arquivar/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           self.refreshData();
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

    // // Fetch deletando um item
    // delete(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de deletar essa quinzena?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/quinzena/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           self.refreshData();
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData() {
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/quinzenas/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ staff_periods: responseJson.data });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigtrip.EditarFuncionario.tabRegimes.tituloRegimes
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_periods === null || typeof this.state.staff_periods === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigtrip.EditarFuncionario.tabRegimes.nenhumRegimeCadastrado
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabRegimes.tabela.Regime
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabRegimes.tabela.Data
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabRegimes.tabela.Mes
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabRegimes.tabela.Ano
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'col-md-1 text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabRegimes.tabela.Status
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_periods).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_periods[k].schedule_regime
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_periods[k].date_start_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_periods[k].month
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_periods[k].year
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_periods[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      self.locale.ColaboradoresSigtrip.EditarFuncionario.tabRegimes.tabela.Ativo
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      self.locale.ColaboradoresSigtrip.EditarFuncionario.tabRegimes.tabela.Arquivado
                    )
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffPeriodsTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (StaffPeriodsTab);

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var StaffProcessTab = function (_Component) {
  _inherits(StaffProcessTab, _Component);

  function StaffProcessTab(props) {
    _classCallCheck(this, StaffProcessTab);

    var _this = _possibleConstructorReturn(this, (StaffProcessTab.__proto__ || Object.getPrototypeOf(StaffProcessTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      process_documents: '',
      aircraft_models: null,
      staff_processes: [],
      processes_list: null,
      process_subtypes_list: [],
      process_subtype_documents: [],
      process_subtype_id: '',
      aircraft_model_id: '',
      date_start: '',
      expiration: '',
      process_id: '',
      process_selected: 0,
      process_subtype_selected: 0,
      process_modal: {},
      modal: false,
      file_process: ''
    };
    //bind específico
    // this.clearSelects = this.clearSelects.bind(this);
    // this.loadSubtypes = this.loadSubtypes.bind(this);
    // this.loadDocuments = this.loadDocuments.bind(this);
    // this.addProcess = this.addProcess.bind(this);
    // this.ActionsButtons = this.ActionsButtons.bind(this);
    // this.delete = this.delete.bind(this);
    // this.refreshData = this.refreshData.bind(this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers
  // handleToggleChange (name, event) {
  //   var change = {};
  //   var data_temp = [];
  //   var self = this;
  //   Object.keys(self.state.process_subtype_documents).map(function(k) {
  //     if("process_documents_" + self.state.process_subtype_documents[k].id === name) {
  //       change = {
  //         checked: event.target.checked,
  //         required: self.state.process_subtype_documents[k].required,
  //         required_str: self.state.process_subtype_documents[k].required_str,
  //         name_slug: self.state.process_subtype_documents[k].name_slug,
  //         name: self.state.process_subtype_documents[k].name,
  //         document_id: self.state.process_subtype_documents[k].document_id,
  //         id: self.state.process_subtype_documents[k].id,
  //       };
  //     } else {
  //       change = {
  //         checked: self.state.process_subtype_documents[k].checked,
  //         required: self.state.process_subtype_documents[k].required,
  //         required_str: self.state.process_subtype_documents[k].required_str,
  //         name_slug: self.state.process_subtype_documents[k].name_slug,
  //         name: self.state.process_subtype_documents[k].name,
  //         document_id: self.state.process_subtype_documents[k].document_id,
  //         id: self.state.process_subtype_documents[k].id,
  //       };
  //     }
  //     data_temp.push(change);
  //   });
  //   this.setState({process_subtype_documents: data_temp});
  // }

  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // }

  // handleSelectChangeProcess(name, event) {   
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //     this.setState(change, ()=> {
  //       this.clearSelects();
  //     });
  //   } else {
  //     change[name] = event.value;
  //     this.setState(change, ()=> {
  //       this.loadSubtypes(event);
  //     });
  //   }
  // }

  // handleSelectChangeSubtype(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //     this.setState(change, ()=> {
  //       this.clearInputs();
  //     });
  //   } else {
  //     change[name] = event.value;
  //     this.setState(change, ()=> {
  //       this.loadDocuments(event);
  //     });
  //   }
  // }

  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }

  // LM


  _createClass(StaffProcessTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.staff_processes) && this.state.loaded === 0) {
        this.setState({
          processes_list: newProps.processes_list,
          periodic_processes: newProps.periodic_processes,
          staff_processes: newProps.staff_processes,
          aircraft_models: newProps.aircraft_models,
          loaded: 1
        });
      }
    }

    // clearSelects() {
    //   this.setState({process_subtypes_list: []});
    //   this.setState({process_selected: 0});
    // }

    // clearInputs() {
    //   var self = this;
    //   this.setState({process_subtype_selected: 0});
    //   var i;
    //   Object.keys(self.state.process_subtype_documents).map(function(k) {
    //     var element = document.getElementsByClassName(self.state.process_subtype_documents[k].name_slug + "-" + self.state.process_subtype_documents[k].id);
    //     for (i = 0; i < element.length; i++) {
    //       element[i].parentNode.removeChild(element);    
    //     }      
    //   });
    //   this.setState({process_subtype_documents: []});
    // }


    // refreshData (event) {
    //   var self = this;
    //   self.clearInputs();
    //   self.clearSelects();
    //   var header = this.refs.request_api.header('application/json');
    //   Promise.resolve(header).then(function(value) {
    //     var url = config.get('api') + '/funcionario/processos/' + self.props.staff_id;
    //     fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.setState({staff_processes: responseJson.data});
    //     }).then(() => {
    //       self.props.handleAlert(event.message, event.status, 'open');
    //     });
    //   });
    // }

  }, {
    key: 'export',
    value: function _export(event) {
      var url = event.currentTarget.value;
      window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + url);
    }

    // loadSubtypes(event) {
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   this.props.handleAlert('', '', 'open');
    //   Promise.resolve(header).then(function(value) {
    //     var url = config.get('api') + '/processo/subtipos/lista/' + event.value;
    //     fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'url');
    //       if (responseJson.status === 'success') {
    //         self.setState({process_subtypes_list: responseJson.data});
    //         self.setState({process_selected: 1});
    //       }
    //       window.setTimeout(function(){ self.props.handleAlert('', '', 'closed'); }, 650);
    //     });
    //   });
    // }

    // loadDocuments(event) {
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   this.props.handleAlert('', '', 'open');
    //   Promise.resolve(header).then(function(value) {
    //     var url = config.get('api') + '/processo/subtipos/documentos/' + event.value;
    //     fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'url');
    //       if (responseJson.status === 'success') {
    //         self.setState({process_subtype_documents: responseJson.data});
    //         self.setState({process_subtype_selected: 1});
    //       }
    //       window.setTimeout(function(){ self.props.handleAlert('', '', 'closed'); }, 650);
    //     });
    //   });
    // }

    // addProcess(event) {
    //   var self = this;
    //   event.preventDefault();
    //   var data = new FormData();
    //   var file = document.querySelector(".input-file-process").files[0];
    //   var documents = JSON.stringify(this.state.process_subtype_documents);
    //   data.append("file_process", file);
    //   data.append("process_id", this.state.process_id);
    //   data.append("process_subtype_id", this.state.process_subtype_id);
    //   data.append("aircraft_model_id", this.state.aircraft_model_id);
    //   data.append("date_start", this.state.date_start);
    //   data.append("expiration", this.state.expiration);
    //   data.append("staff_id", this.props.staff_id);
    //   data.append("process_subtype_documents", documents);
    //   var header = this.refs.request_api.header();
    //   this.props.handleAlert('', '', 'open');
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api') + '/funcionario/processo', {
    //       method: 'POST',
    //       mode: 'cors',
    //       headers: value,
    //       body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           self.refreshData(responseJson);
    //         } else {
    //           self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //         }
    //       }).catch((error) => {
    //       console.error(error);
    //     });
    //   });   
    // }
    // // Fetch deletando um item
    // delete(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de deletar esse arquivo?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/processo/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           self.refreshData(responseJson);
    //         } else {
    //           self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //         }
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }


    // ActionsButtons (cell, row) { 
    //   var botao = (
    //     <div className="btn-group">
    //       <button className="btn btn-sm btn-success" onClick={this.export} value={'/files/staff_processes/' + row.archive}>
    //         <i className="fa fa-fw fa-download"></i>
    //       </button>
    //       <button className="btn btn-sm btn-danger" value={cell} onClick={this.delete}>
    //         <i className="fa fa-fw fa-trash"></i>
    //       </button>
    //     </div>
    //   );

    //   return botao;
    // }


  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigtrip.EditarFuncionario.tabProcessos.tituloProcessos
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["BootstrapTable"],
          { data: self.state.staff_processes, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.ColaboradoresSigtrip.EditarFuncionario.tabProcessos.tabela.semArquivosDeProcessos }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'aircraft_model', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
            this.locale.ColaboradoresSigtrip.EditarFuncionario.tabProcessos.tabela.Frota
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'process', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
            this.locale.ColaboradoresSigtrip.EditarFuncionario.tabProcessos.tabela.Processo
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'process_subtype', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
            this.locale.ColaboradoresSigtrip.EditarFuncionario.tabProcessos.tabela.Subtipo
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
            { isKey: true, dataField: 'date_start', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
            this.locale.ColaboradoresSigtrip.EditarFuncionario.tabProcessos.tabela.DataDeEmissao
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap_table__["TableHeaderColumn"],
            { dataField: 'expiration', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
            this.locale.ColaboradoresSigtrip.EditarFuncionario.tabProcessos.tabela.Validade
          )
        )
      );
    }
  }]);

  return StaffProcessTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (StaffProcessTab);

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_input_mask__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Importação da tabela



var StaffRecordTab = function (_Component) {
  _inherits(StaffRecordTab, _Component);

  function StaffRecordTab(props) {
    _classCallCheck(this, StaffRecordTab);

    var _this = _possibleConstructorReturn(this, (StaffRecordTab.__proto__ || Object.getPrototypeOf(StaffRecordTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      name: '',
      archive: '',
      dados: []
    };

    // this.botaoDeletar = this.botaoDeletar.bind(this);
    // this.adicionarArquivo = this.adicionarArquivo.bind(this);
    // this.deletar = this.deletar.bind(this);
    // this.deletarLinha = this.deletarLinha.bind(this);
    _this.botaoDownloadArquivo = _this.botaoDownloadArquivo.bind(_this);
    return _this;
  }

  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 

  // LM


  _createClass(StaffRecordTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.staff_record_files)) {
        this.setState({ dados: newProps.staff_record_files });
      }
    }

    // adicionarArquivo(event) {
    //   event.preventDefault();
    //   var data = new FormData();
    //   var imagedata = document.querySelector(".input-archive-staff-record").files[0];
    //   data.append("name", this.state.name);
    //   data.append("imagem", imagedata);
    //   data.append("staff_id", this.props.staff_id);
    //   var header = this.refs.request_api.header();
    //   var self = this;
    //   this.props.handleAlert('', '', 'open');
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api') + '/funcionario/fira/arquivo', {
    //       method: 'POST',
    //       mode: 'cors',
    //       headers: value,
    //       body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           var dados_temp = self.state.dados;
    //           dados_temp.push(responseJson.data);
    //           self.setState({dados: dados_temp});
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //       console.error(error);
    //     });
    //   });   
    // }

    // botaoDeletar (cell, row, enumObject, index) {
    //   var variavel = (
    //     <button className="btn btn-sm btn-danger" value={cell} onClick={this.deletar}>
    //       <i className="fa fa-fw fa-trash"></i>
    //     </button>
    //   );

    //   return variavel;
    // }

    // deletar (event) {
    //   var staff_record_id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de deletar esse arquivo?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/fira/arquivo/' + staff_record_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //         if (responseJson.status === 'success') {
    //           self.deletarLinha(staff_record_id);
    //         }
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // deletarLinha(staff_record_id) {
    //   var dados = this.state.dados;
    //   dados.map(function(dado, index){
    //     if (dado.id == staff_record_id) {
    //       dados.splice(index, 1);
    //     }
    //   });
    //   this.setState({dados: dados});
    // }

  }, {
    key: 'botaoDownloadArquivo',
    value: function botaoDownloadArquivo(cell, row) {
      var dados = this.state.dados;
      var status = '';
      var arquivo = '';
      var nome = '';
      dados.map(function (dado, index) {
        if (dado.id == cell) {
          arquivo = dado.archive;
          nome = dado.date_str;
        }
      });
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { target: '_blank', href: __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/files/staff_records/' + arquivo },
        ' ',
        nome
      );
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          'Adicionar arquivos'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["BootstrapTable"],
          { data: this.state.dados, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: 'Exportar CSV', noDataText: 'Não há arquivos cadastrados' }, search: true, multiColumnSearch: true, searchPlaceholder: 'Procurar' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap_table__["TableHeaderColumn"],
            { isKey: true, dataFormat: this.botaoDownloadArquivo, dataField: 'id', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' } },
            'Data'
          )
        )
      );
    }
  }]);

  return StaffRecordTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (StaffRecordTab);

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário





var StaffRolesTab = function (_Component) {
  _inherits(StaffRolesTab, _Component);

  function StaffRolesTab(props) {
    _classCallCheck(this, StaffRolesTab);

    var _this = _possibleConstructorReturn(this, (StaffRolesTab.__proto__ || Object.getPrototypeOf(StaffRolesTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      staff_id: _this.props.staff_id,
      role_id: null,
      date_start: '',
      staff_roles: [],
      roles: []
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.activate = this.activate.bind(this);
    // this.delete = this.delete.bind(this);
    // this.archive = this.archive.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(StaffRolesTab, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.staff_roles) && this.state.loaded === false) {
        this.setState({
          roles: newProps.roles,
          staff_roles: newProps.staff_roles,
          loaded: true
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     role_id: this.state.role_id,
    //     date_start: this.state.date_start,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api') + '/funcionario/cargo', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.refreshData();
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // // Fetch ativando um item
    // activate(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar esse cargo?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/cargo/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           self.refreshData();
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch deletando um item
    // archive(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar esse cargo?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/cargo/arquivar/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           self.refreshData();
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }
    // delete(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de deletar esse cargo?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/cargo/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           self.refreshData();
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData() {
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/cargos/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ staff_roles: responseJson.data });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          this.locale.ColaboradoresSigtrip.EditarFuncionario.tabCargos.tituloCargos
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_roles === null || typeof this.state.staff_roles === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              this.locale.ColaboradoresSigtrip.EditarFuncionario.tabCargos.nenhumCargoCadastrado
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabCargos.tabela.Cargo
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'col-md-1 text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabCargos.tabela.CodigoRubi
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'col-md-1 text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabCargos.tabela.Status
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  this.locale.ColaboradoresSigtrip.EditarFuncionario.tabCargos.tabela.Data
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_roles).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_roles[k].role
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_roles[k].rubi_code
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_roles[k].active === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-success' },
                      self.locale.ColaboradoresSigtrip.EditarFuncionario.tabCargos.tabela.Ativo
                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'span',
                      { className: 'label label-danger' },
                      self.locale.ColaboradoresSigtrip.EditarFuncionario.tabCargos.tabela.Arquivado
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_roles[k].date_start_str
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffRolesTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffRolesTab);

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toggle__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário




var StaffVacationTab = function (_Component) {
  _inherits(StaffVacationTab, _Component);

  function StaffVacationTab(props) {
    _classCallCheck(this, StaffVacationTab);

    var _this = _possibleConstructorReturn(this, (StaffVacationTab.__proto__ || Object.getPrototypeOf(StaffVacationTab)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      staff_id: _this.props.staff_id,
      designation_id: null,
      aircraft_model_id: null,
      date_start: '',
      staff_vacations: [],
      aircraft_models: [],
      designations: []
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.activate = this.activate.bind(this);
    // this.delete = this.delete.bind(this);
    _this.refreshData = _this.refreshData.bind(_this);
    return _this;
  }
  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }
  // handleToggleChange (name, event) {
  //   var change = {};
  //   if (event.target.checked === true) {
  //     var value = 1;
  //   } else {
  //     var value = 0;
  //   }
  //   change[name] = value;
  //   this.setState(change);
  // } 
  // LM


  _createClass(StaffVacationTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (Array.isArray(newProps.staff_vacations) && this.state.loaded === false) {
        this.setState({
          aircraft_models: newProps.aircraft_models,
          designations: newProps.designations,
          staff_vacations: newProps.staff_vacations,
          loaded: true
        });
      }
    }

    // Fetch salvando a edição
    // add(event) {
    //   event.preventDefault();
    //   this.props.handleAlert('', '', 'open');
    //   var datasave = {
    //     staff_id: this.state.staff_id,
    //     designation_id: this.state.designation_id,
    //     aircraft_model_id: this.state.aircraft_model_id,
    //     date_start: this.state.date_start,
    //   };
    //   var header = this.refs.request_api.header('application/json');
    //   var self = this;
    //   Promise.resolve(header).then(function(value) {
    //     fetch(config.get('api') + '/funcionario/indicacao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //       self.refs.request_api.validate(responseJson, 'alert');
    //       self.refreshData();
    //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //     }).catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // }

    // // Fetch ativando um item
    // activate(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de ativar essa indicação??');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var datasave = {
    //       id: id,
    //     };
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/indicacao/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           self.refreshData();
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

    // // Fetch deletando um item
    // delete(event) {
    //   var id = event.currentTarget.value;
    //   var confirm = window.confirm('Tem certeza que gostaria de arquivar essa indicação?');
    //   if (confirm) {
    //     this.props.handleAlert('', '', 'open');
    //     var header = this.refs.request_api.header('application/json');
    //     var self = this;
    //     Promise.resolve(header).then(function(value) {
    //       fetch(config.get('api') + '/funcionario/indicacao/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
    //         self.refs.request_api.validate(responseJson, 'alert');
    //         if (responseJson.status === 'success') {
    //           self.refreshData();
    //         }
    //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
    //       }).catch((error) => {
    //         console.error(error);
    //       });
    //     });      
    //   }
    // }

  }, {
    key: 'refreshData',
    value: function refreshData() {
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/indicacoes/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({ staff_vacations: responseJson.data });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h3',
          { className: 'page-title' },
          'F\xE9rias'
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        this.state.staff_vacations === null || typeof this.state.staff_vacations === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'small',
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'em',
              null,
              'Nenhuma indica\xE7\xE3o cadastrada.'
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'table',
            { className: 'table table-bordered table-stripped table-hover' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'thead',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Limite'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'text-center' },
                  'Diireito'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'center' },
                  'In\xEDcio Escala'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'th',
                  { className: 'center' },
                  'T\xE9rmino Escala'
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'tbody',
              { id: 'suppliers-certifications' },
              Object.keys(self.state.staff_vacations).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_vacations[k].date_limit_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_vacations[k].date_max_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_vacations[k].date_start_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.staff_vacations[k].date_finish_str
                  )
                );
              })
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
        )
      );
    }
  }]);

  return StaffVacationTab;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* unused harmony default export */ var _unused_webpack_default_export = (StaffVacationTab);

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Elements_StaffEditTab__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Elements_StaffLicensesTab__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Elements_StaffRolesTab__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Elements_StaffDesignationsTab__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Elements_StaffPeriodsTab__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Elements_StaffGratificationsTab__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Elements_StaffIcaosTab__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Elements_StaffHoursTab__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Elements_StaffClientsTab__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Elements_StaffCertificationsTab__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Elements_StaffIndicationsTab__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Elements_StaffPaymentsTab__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Elements_StaffVacationTab__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Elements_StaffCertificationsTypeTab__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Elements_StaffRecordTab__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Elements_StaffAdministrativeTab__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Elements_StaffProcessTab__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Elements_StaffBasesTab__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Elements_StaffCostsTab__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Elements_StaffGuaranteedHoursTab__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










// Tabs






















var SigtripStaffsEdit = function (_Component) {
  _inherits(SigtripStaffsEdit, _Component);

  function SigtripStaffsEdit(props) {
    _classCallCheck(this, SigtripStaffsEdit);

    var _this = _possibleConstructorReturn(this, (SigtripStaffsEdit.__proto__ || Object.getPrototypeOf(SigtripStaffsEdit)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      staff_data: {},
      staff_bases: {},
      staff_costs: {},
      staff_guaranteed_hours: {},
      processes_list: null,
      bases_list: null,
      training_certification_staff_payments_national: null,
      training_certification_staff_payments_international: null,
      training_certification_staff_payments_hours: null,
      flight_hours_totals: null,
      staff_flight_files: null,
      aircraft_models: null,
      designations: null,
      gratifications: null,
      certifications: null,
      staff_licenses: null,
      staff_roles: null,
      staff_designations: null,
      staff_periods: null,
      staff_regimes_select: null,
      staff_processes: null,
      staff_gratifications: null,
      staff_icaos: null,
      staff_clients: null,
      staff_certifications: null,
      staff_indications: null,
      staff_certifications_other_type: null,
      staff_record_files: null,
      roles: null
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.export = _this.export.bind(_this);
    _this.openAnac = _this.openAnac.bind(_this);
    _this.archive = _this.archive.bind(_this);
    _this.restauration = _this.restauration.bind(_this);
    _this.refreshData = _this.refreshData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(SigtripStaffsEdit, [{
    key: 'handleNavTab',
    value: function handleNavTab(state, key) {
      var change = {};
      change[state] = key;
      this.setState(change);
      this.setState({ overlay: { message: '', type: '', status: '' } });
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }

    //LM

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData(event) {
      var self = this;
      var id = null;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/portal/funcionario/sigtrip';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          if (responseJson.status === 'redirect') {
            var url = '/portal/file/digital/sigmec/';
            self.setState({ redirect_url: url });
          } else {
            self.refs.request_api.validate(responseJson, 'url');
            if (responseJson.status === 'success') {
              self.setState({ staff_data: responseJson.data.main });
              self.setState({ id: responseJson.data.main.id });
              id = responseJson.data.main.id;
              self.setState({ staff_licenses: responseJson.data.staff_licenses });
              self.setState({ staff_roles: responseJson.data.staff_roles });
              self.setState({ staff_designations: responseJson.data.staff_designations });
              self.setState({ staff_indications: responseJson.data.staff_indications });
              self.setState({ staff_periods: responseJson.data.staff_periods });
              self.setState({ staff_gratifications: responseJson.data.staff_gratifications });
              self.setState({ staff_icaos: responseJson.data.staff_icaos });
              self.setState({ staff_clients: responseJson.data.staff_clients });
              self.setState({ staff_certifications: responseJson.data.staff_certifications });
              self.setState({ staff_certifications_other_type: responseJson.data.staff_certifications_other_type });
              self.setState({ flight_hours_totals: responseJson.data.flight_hours_totals });
              self.setState({ staff_flight_files: responseJson.data.staff_flight_files });
              self.setState({ adm_files: responseJson.data.adm_files });
              self.setState({ staff_record_files: responseJson.data.staff_record_files });
              self.setState({ staff_processes: responseJson.data.staff_processes });
              self.setState({ training_certification_staff_payments_national: responseJson.data.training_certification_staff_payments_national });
              self.setState({ training_certification_staff_payments_international: responseJson.data.training_certification_staff_payments_international });
              self.setState({ staff_bases: responseJson.data.staff_bases });
              self.setState({ staff_costs: responseJson.data.staff_costs });
              self.setState({ staff_guaranteed_hours: responseJson.data.staff_guaranteed_hours });
              self.setState({ training_certification_staff_payments_hours: responseJson.data.training_certification_staff_payments_hours });
            }
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          if (typeof event === 'undefined') {
            self.handleMessage();
          } else {
            self.handleAlert(event.message, event.status, 'open');
          }
        });
      });
    }
  }, {
    key: 'export',
    value: function _export(url) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      self.setState({ overlay: { message: '', type: '', status: 'open' } });
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data);
            self.handleAlert('', '', 'closed');
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        });
      });
    }
  }, {
    key: 'archive',
    value: function archive(event) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      var url = '/demitir/funcionario/';
      self.setState({ overlay: { message: '', type: '', status: 'open' } });
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url + self.state.id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.refreshData(responseJson);
          }
        });
      });
    }
  }, {
    key: 'restauration',
    value: function restauration(event) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      var url = '/restaurar/funcionario/';
      self.setState({ overlay: { message: '', type: '', status: 'open' } });
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url + self.state.id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.refreshData(responseJson);
          }
        });
      });
    }
  }, {
    key: 'refreshData',
    value: function refreshData(event) {
      var header = this.refs.request_api.header('application/json');
      var self = this;
      var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/' + self.state.id;
      Promise.resolve(header).then(function (value) {
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ staff_data: responseJson.data });
            self.handleAlert(event.message, event.status, 'open');
          }
        });
      });
    }
  }, {
    key: 'openAnac',
    value: function openAnac(url) {
      window.open(this.state.staff_data.url_anac);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.ColaboradoresSigtrip.EditarFuncionario.titulo,
              ' - ',
              this.state.staff_data.name
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Tabs */],
              { activeKey: this.state.key, onSelect: this.handleNavTab.bind(this, 'key'), id: 'controlled-tab-example' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 1, title: this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDadosDoFuncionario.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Elements_StaffEditTab__["a" /* default */], { handleAlert: this.handleAlert, staff_id: this.props.match.params.id, staff_data: this.state.staff_data })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 3, title: this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHorasDeVoo.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Elements_StaffHoursTab__["a" /* default */], { RequestApi: this.refs.request_api, handleAlert: this.handleAlert, staff_id: this.props.match.params.id, flight_hours_totals: this.state.flight_hours_totals, staff_flight_files: this.state.staff_flight_files })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 4, title: this.locale.ColaboradoresSigtrip.EditarFuncionario.tabHabilitacoes.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Elements_StaffLicensesTab__["a" /* default */], { handleAlert: this.handleAlert, staff_id: this.props.match.params.id, aircraft_models: this.state.aircraft_models, staff_licenses: this.state.staff_licenses })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 9, title: this.locale.ColaboradoresSigtrip.EditarFuncionario.tabCargos.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Elements_StaffRolesTab__["a" /* default */], { handleAlert: this.handleAlert, staff_id: this.props.match.params.id, staff_roles: this.state.staff_roles, roles: this.state.roles })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 10, title: this.locale.ColaboradoresSigtrip.EditarFuncionario.tabDesignacoes.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Elements_StaffDesignationsTab__["a" /* default */], { handleAlert: this.handleAlert, staff_id: this.props.match.params.id, staff_designations: this.state.staff_designations, designations: this.state.designations, aircraft_models: this.state.aircraft_models })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                { eventKey: 11, title: this.locale.ColaboradoresSigtrip.EditarFuncionario.tabIndicacoes.tituloTab },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Elements_StaffIndicationsTab__["a" /* default */], { handleAlert: this.handleAlert, staff_id: this.props.match.params.id, staff_indications: this.state.staff_indications, designations: this.state.designations, aircraft_models: this.state.aircraft_models })
              )
            )
          )
        )
      );
    }
  }]);

  return SigtripStaffsEdit;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SigtripStaffsEdit);

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// Importação da tabela



var SigtripStaffsPendingFlightReport = function (_Component) {
  _inherits(SigtripStaffsPendingFlightReport, _Component);

  function SigtripStaffsPendingFlightReport(props) {
    _classCallCheck(this, SigtripStaffsPendingFlightReport);

    var _this = _possibleConstructorReturn(this, (SigtripStaffsPendingFlightReport.__proto__ || Object.getPrototypeOf(SigtripStaffsPendingFlightReport)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(SigtripStaffsPendingFlightReport, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/relatorios/voo/pendentes', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var url = '/relatorio/voo/editar/' + cell;

      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
          { className: 'btn btn-primary btn-sm', to: url },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
        )
      );

      return botao;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.ColaboradoresSigtrip.RelatoriosPendentesDeAprovacao.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.ColaboradoresSigtrip.RelatoriosPendentesDeAprovacao.tabela.semRelatorios }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, hidden: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.ColaboradoresSigtrip.RelatoriosPendentesDeAprovacao.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'base', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.ColaboradoresSigtrip.RelatoriosPendentesDeAprovacao.tabela.Base
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'date_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.ColaboradoresSigtrip.RelatoriosPendentesDeAprovacao.tabela.Data
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'registration', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.ColaboradoresSigtrip.RelatoriosPendentesDeAprovacao.tabela.Aeronave
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'model', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.ColaboradoresSigtrip.RelatoriosPendentesDeAprovacao.tabela.Frota
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'client', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '160' },
                this.locale.ColaboradoresSigtrip.RelatoriosPendentesDeAprovacao.tabela.Cliente
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'flight_type', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '160' },
                this.locale.ColaboradoresSigtrip.RelatoriosPendentesDeAprovacao.tabela.TipoDeVoo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'report_number', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '160' },
                this.locale.ColaboradoresSigtrip.RelatoriosPendentesDeAprovacao.tabela.NumeroDoRelatorio
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'flight_number', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '160' },
                this.locale.ColaboradoresSigtrip.RelatoriosPendentesDeAprovacao.tabela.NumeroDoVoo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'status_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '160' },
                this.locale.ColaboradoresSigtrip.RelatoriosPendentesDeAprovacao.tabela.Status
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '70' },
                this.locale.ColaboradoresSigtrip.RelatoriosPendentesDeAprovacao.tabela.Acoes
              )
            )
          )
        )
      );
    }
  }]);

  return SigtripStaffsPendingFlightReport;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SigtripStaffsPendingFlightReport);

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// Importação da tabela



var SigtripStaffsPendingPapers = function (_Component) {
  _inherits(SigtripStaffsPendingPapers, _Component);

  function SigtripStaffsPendingPapers(props) {
    _classCallCheck(this, SigtripStaffsPendingPapers);

    var _this = _possibleConstructorReturn(this, (SigtripStaffsPendingPapers.__proto__ || Object.getPrototypeOf(SigtripStaffsPendingPapers)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(SigtripStaffsPendingPapers, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/papeletas/pendentes', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var url = '/papeleta/editar/' + cell;

      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
          { className: 'btn btn-primary btn-sm', to: url },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
        )
      );

      return botao;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.ColaboradoresSigtrip.PapeletasPendentesDeAprovacao.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.ColaboradoresSigtrip.PapeletasPendentesDeAprovacao.tabela.semPapeletas }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, hidden: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.ColaboradoresSigtrip.PapeletasPendentesDeAprovacao.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'staff_name', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '240' },
                this.locale.ColaboradoresSigtrip.PapeletasPendentesDeAprovacao.tabela.Nome
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'staff_inscription', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.ColaboradoresSigtrip.PapeletasPendentesDeAprovacao.tabela.Matricula
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'month', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.ColaboradoresSigtrip.PapeletasPendentesDeAprovacao.tabela.Referencia
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'status_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.ColaboradoresSigtrip.PapeletasPendentesDeAprovacao.tabela.Status
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '100' },
                this.locale.ColaboradoresSigtrip.PapeletasPendentesDeAprovacao.tabela.Acoes
              )
            )
          )
        )
      );
    }
  }]);

  return SigtripStaffsPendingPapers;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SigtripStaffsPendingPapers);

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// Importação da tabela



var SigtripStaffsPendingSchedules = function (_Component) {
  _inherits(SigtripStaffsPendingSchedules, _Component);

  function SigtripStaffsPendingSchedules(props) {
    _classCallCheck(this, SigtripStaffsPendingSchedules);

    var _this = _possibleConstructorReturn(this, (SigtripStaffsPendingSchedules.__proto__ || Object.getPrototypeOf(SigtripStaffsPendingSchedules)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.exportPdfGrade = _this.exportPdfGrade.bind(_this);
    _this.confirmSchedule = _this.confirmSchedule.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(SigtripStaffsPendingSchedules, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/colaborador/pendencias/grades', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'exportPdfGrade',
    value: function exportPdfGrade(id, type) {
      var self = this;
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      if (type === 'sigtrip') {
        var api = 'api';
        var cdn = 'cdn';
        var route = '/exportar/pdf/escala-grade/' + id;
        var pdf = '/schedule_grades/main/';
      } else if (type === 'sigmec') {
        var api = 'api_sigmec';
        var cdn = 'cdn_sigmec';
        var route = '/exportar/escala/grade/visualizar/' + id + '/2';
        var pdf = '/tmp/';
      }
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get(api) + route;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get(cdn) + pdf + responseJson.data);
        });
      });
    }
  }, {
    key: 'confirmSchedule',
    value: function confirmSchedule(id) {
      this.setState({ overlay: { message: '', type: '', status: 'open' } });
      var datasave = {
        id: id
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/colaborador/pendencias/grade/confirmar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
            self.loadData();
          }
          self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var _this2 = this;

      var botao = "";

      if (row.type === 'sigmec') {
        botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { onClick: function onClick() {
                return _this2.exportPdfGrade(row.schedule_grade_id, 'sigmec');
              }, className: 'btn btn-warning button-inline' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' }),
            ' ',
            this.locale.ColaboradoresSigtrip.EscalasPendentesDeConhecimento.botaoRevisao,
            ' ',
            row.schedule_grade_revision
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn btn-success button-inline', onClick: function onClick() {
                return _this2.confirmSchedule(row.id);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-check' })
          )
        );
      }
      if (row.type === 'sigtrip') {
        botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { onClick: function onClick() {
                return _this2.exportPdfGrade(row.schedule_grade_id, 'sigtrip');
              }, className: 'btn btn-warning button-inline' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' }),
            ' ',
            this.locale.ColaboradoresSigtrip.EscalasPendentesDeConhecimento.botaoRevisao,
            ' ',
            row.schedule_grade_revision
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn btn-success button-inline', onClick: function onClick() {
                return _this2.confirmSchedule(row.id);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-check' })
          )
        );
      }

      return botao;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.ColaboradoresSigtrip.EscalasPendentesDeConhecimento.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.ColaboradoresSigtrip.EscalasPendentesDeConhecimento.tabela.semEscalas }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, hidden: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '60' },
                this.locale.ColaboradoresSigtrip.EscalasPendentesDeConhecimento.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'month', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.ColaboradoresSigtrip.EscalasPendentesDeConhecimento.tabela.Mes
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'base', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.ColaboradoresSigtrip.EscalasPendentesDeConhecimento.tabela.Base
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'aircraft_model', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.ColaboradoresSigtrip.EscalasPendentesDeConhecimento.tabela.Frota
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'schedule_grade_revision', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.ColaboradoresSigtrip.EscalasPendentesDeConhecimento.tabela.Revisao
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'schedule_grade_status', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.ColaboradoresSigtrip.EscalasPendentesDeConhecimento.tabela.Status
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '120' },
                this.locale.ColaboradoresSigtrip.EscalasPendentesDeConhecimento.tabela.Acoes
              )
            )
          )
        )
      );
    }
  }]);

  return SigtripStaffsPendingSchedules;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SigtripStaffsPendingSchedules);

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// Importação da tabela



var SigtripStaffsTrainings = function (_Component) {
  _inherits(SigtripStaffsTrainings, _Component);

  function SigtripStaffsTrainings(props) {
    _classCallCheck(this, SigtripStaffsTrainings);

    var _this = _possibleConstructorReturn(this, (SigtripStaffsTrainings.__proto__ || Object.getPrototypeOf(SigtripStaffsTrainings)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(SigtripStaffsTrainings, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/treinamentos/pendentes/associados', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'redirect') {
            var url = '/pendencias/treinamento/sigmec';
            self.setState({ redirect_url: url });
          } else {
            self.setState({ data: responseJson.data });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {

      var botao = "";

      if (row.confirmation_token_presence && row.confirmation_token_absence) {
        var confirmation_token_presence_url = 'http://' + row.confirmation_url + '/email/confirmacao/' + row.confirmation_token_presence;
        var confirmation_token_absence_url = 'http://' + row.confirmation_url + '/email/confirmacao/' + row.confirmation_token_absence;
        botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'btn btn-success btn-sm button-inline', target: '_blank', href: confirmation_token_presence_url },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-check' }),
            ' ',
            this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.botaoConfirmarPresenca
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: 'btn btn-danger btn-sm button-inline', target: '_blank', href: confirmation_token_absence_url },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' }),
            ' ',
            this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.botaoConfirmarAusencia
          )
        );
      }

      return botao;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.semTreinamentos }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, hidden: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'name', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '450' },
                this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.Nome
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'status_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.Status
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'code', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '140' },
                this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.CodigoDeControle
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'certification_types', dataAlign: 'center', filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, dataFormat: this.CertificationsTypesTable, width: '140' },
                this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.TiposDeCertificado
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'presence_types', dataAlign: 'center', filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, dataFormat: this.PresenceTypesTable, width: '120' },
                this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.Modalidade
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'date_start_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.DataInicial
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'date_finish_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.DataFinal
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '280' },
                this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia.tabela.Acoes
              )
            )
          )
        )
      );
    }
  }]);

  return SigtripStaffsTrainings;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SigtripStaffsTrainings);

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// Importação da tabela



var SigtripStaffsQpulse = function (_Component) {
  _inherits(SigtripStaffsQpulse, _Component);

  function SigtripStaffsQpulse(props) {
    _classCallCheck(this, SigtripStaffsQpulse);

    var _this = _possibleConstructorReturn(this, (SigtripStaffsQpulse.__proto__ || Object.getPrototypeOf(SigtripStaffsQpulse)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.delete = _this.delete.bind(_this);
    _this.deleteRow = _this.deleteRow.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.next = _this.next.bind(_this);
    _this.previous = _this.previous.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(SigtripStaffsQpulse, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/documentos/q-pulse', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var url = '/papeleta/editar/' + cell;

      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
          { className: 'btn btn-primary btn-sm', to: url },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-sm btn-danger', value: cell, onClick: this.delete },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-trash' })
        )
      );

      return botao;
    }
  }, {
    key: 'delete',
    value: function _delete(event) {
      var fira_id = event.currentTarget.value;
      var confirm = window.confirm(this.locale.ColaboradoresSigtrip.DocumentosPendentesDeConhecimento.deletarPapeleta);
      if (confirm) {
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/papeleta/' + fira_id, { method: 'DELETE', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.deleteRow(fira_id);
            }
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'deleteRow',
    value: function deleteRow(fira_id) {
      var data = this.state.data;
      data.map(function (dado, index) {
        if (dado.id == fira_id) {
          data.splice(index, 1);
        }
      });
      this.setState({ data: data });
    }
  }, {
    key: 'next',
    value: function next() {
      this.setState({ overlay: { message: '', type: '', status: 'open' } });
      this.loadData(this.state.next);
    }
  }, {
    key: 'previous',
    value: function previous() {
      this.setState({ overlay: { message: '', type: '', status: 'open' } });
      this.loadData(this.state.previous);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.ColaboradoresSigtrip.DocumentosPendentesDeConhecimento.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'page-title info-warning' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-warning' }),
              ' ',
              this.locale.ColaboradoresSigtrip.DocumentosPendentesDeConhecimento.tituloAListaDeDocumentosPendentesEOriundaDoQPulse
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.ColaboradoresSigtrip.DocumentosPendentesDeConhecimento.tabela.semDocumentosPendentes }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, hidden: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.ColaboradoresSigtrip.DocumentosPendentesDeConhecimento.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'inscription', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.ColaboradoresSigtrip.DocumentosPendentesDeConhecimento.tabela.Matricula
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'name', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.ColaboradoresSigtrip.DocumentosPendentesDeConhecimento.tabela.Nome
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'documents', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.ColaboradoresSigtrip.DocumentosPendentesDeConhecimento.tabela.Documentos
              )
            )
          )
        )
      );
    }
  }]);

  return SigtripStaffsQpulse;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SigtripStaffsQpulse);

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// Importação da tabela



var SigtripStaffsTrainings = function (_Component) {
  _inherits(SigtripStaffsTrainings, _Component);

  function SigtripStaffsTrainings(props) {
    _classCallCheck(this, SigtripStaffsTrainings);

    var _this = _possibleConstructorReturn(this, (SigtripStaffsTrainings.__proto__ || Object.getPrototypeOf(SigtripStaffsTrainings)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.export = _this.export.bind(_this);
    _this.ActionsButtons = _this.ActionsButtons.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(SigtripStaffsTrainings, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/treinamentos/associados', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'redirect') {
            var url = '/sigmec/treinamentos/';
            self.setState({ redirect_url: url });
          } else {
            self.setState({ data: responseJson.data });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var url = '/relatorio/voo/editar/' + cell;

      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["h" /* Dropdown */],
        { id: 'export-data' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["h" /* Dropdown */].Toggle,
          { bsStyle: 'primary' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' }),
          ' ',
          this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.botaoExportar.Exportar
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["h" /* Dropdown */].Menu,
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
            { onSelect: this.export, eventKey: '/exportar/comunicado/treinamento/solo/' + row.id },
            this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.botaoExportar.Solo
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
            { onSelect: this.export, eventKey: '/exportar/comunicado/treinamento/solo-tic/' + row.id },
            this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.botaoExportar.SoloTIC
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
            { onSelect: this.export, eventKey: '/exportar/comunicado/treinamento/simulador/' + row.id },
            this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.botaoExportar.Simulador
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["d" /* MenuItem */],
            { onSelect: this.export, eventKey: '/exportar/comunicado/treinamento/ead/' + row.id },
            this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.botaoExportar.EAD
          )
        )
      );

      return botao;
    }
  }, {
    key: 'export',
    value: function _export(url) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      self.setState({ overlay: { message: '', type: '', status: 'open' } });
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data;
            self.setState({
              url_export: url
            });
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data);
          }
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.tabela.semTreinamentos, defaultSortName: 'id', defaultSortOrder: 'desc', sizePerPage: 100, sizePerPageList: [{ text: '10', value: 10 }, { text: '25', value: 25 }, { text: '50', value: 50 }, { text: '100', value: 100 }] }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'name', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '500' },
                this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.tabela.Nome
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'status_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.tabela.Status
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'code', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.tabela.CodigoDeControle
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'certification_types', dataAlign: 'center', filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, dataFormat: this.CertificationsTypesTable, width: '120' },
                this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.tabela.TiposDeCertificado
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'presence_types', dataAlign: 'center', filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, dataFormat: this.PresenceTypesTable },
                this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.tabela.Modalidade
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'date_start_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.tabela.DataInicial
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'date_finish_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.tabela.DataFinal
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '120' },
                this.locale.ColaboradoresSigtrip.ComunicadosDeTreinamentos.tabela.Acoes
              )
            )
          )
        )
      );
    }
  }]);

  return SigtripStaffsTrainings;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (SigtripStaffsTrainings);

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__ = __webpack_require__(8);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var StaffDeslocationsEdit = function (_Component) {
    _inherits(StaffDeslocationsEdit, _Component);

    function StaffDeslocationsEdit(props) {
        _classCallCheck(this, StaffDeslocationsEdit);

        var _this = _possibleConstructorReturn(this, (StaffDeslocationsEdit.__proto__ || Object.getPrototypeOf(StaffDeslocationsEdit)).call(this, props));

        _this.state = {
            overlay: {
                message: '',
                type: '',
                status: 'open'
            },
            redirect_url: false,
            loaded: 0,
            id: '',
            date: '',
            deslocation: 0,
            deslocation_time: null,
            staff_deslocations: {}
        };
        //Handlers
        _this.handleAlert = _this.handleAlert.bind(_this);
        _this.handleLoaded = _this.handleLoaded.bind(_this);
        _this.handleMessage = _this.handleMessage.bind(_this);
        _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__["a" /* default */])();

        _this.loadData = _this.loadData.bind(_this);
        _this.edit = _this.edit.bind(_this);
        return _this;
    }
    // Handlers

    _createClass(StaffDeslocationsEdit, [{
        key: 'handleToggleChange',
        value: function handleToggleChange(name, event) {
            var change = {};
            if (event.target.checked === true) {
                var value = 1;
            } else {
                var value = 0;
            }
            change[name] = value;
            change['deslocation_time'] = null;
            this.setState(change);
        }
    }, {
        key: 'handleChange',
        value: function handleChange(name, event) {
            var change = {};
            change[name] = event.target.value;
            this.setState(change);
        }
    }, {
        key: 'handleAlert',
        value: function handleAlert(message, type, status, mode) {
            if (mode === 'reset') {
                this.setState({ overlay: { message: '', type: '', status: 'closed' } });
            } else {
                this.setState({ overlay: { message: message, type: type, status: status } });
            }
        }
    }, {
        key: 'handleLoaded',
        value: function handleLoaded(state) {
            if (this.state.loaded !== 2) {
                this.setState({ loaded: state });
            }
        }
    }, {
        key: 'handleMessage',
        value: function handleMessage() {
            var message = localStorage.getItem("verify_message");
            if (message !== null && typeof message !== 'undefined') {
                message = JSON.parse(message);
                var self = this;
                self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
                localStorage.removeItem("verify_message");
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.state.loaded === 0) {
                this.setState({ loaded: 1 }, this.loadData());
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.state.loaded === 1 && prevState.loaded === 0) {
                this.setState({ loaded: 2 }, this.loadData());
            }
        }
    }, {
        key: 'loadData',
        value: function loadData() {
            var self = this;
            var header = {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            };

            var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/tripulante/deslocamento/' + self.props.match.params.token;
            fetch(url, { method: 'GET', mode: 'cors', headers: header }).then(function (response) {
                return response.json();
            }).catch(function (error) {
                console.error(error);
            }).then(function (responseJson) {
                if (responseJson.status === 'success') {
                    self.setState({
                        id: responseJson.data.main.id,
                        date_str: responseJson.data.main.date_str,
                        staff_deslocations: responseJson.data.staff_deslocations,
                        loaded: true
                    });
                    self.setState({ overlay: { message: '', type: '', status: 'closed' } });
                } else {
                    self.handleAlert(responseJson.message, responseJson.status, 'open');
                }
            }).then(function () {
                self.handleMessage();
            });
        }
    }, {
        key: 'edit',
        value: function edit(event) {
            event.preventDefault();
            this.handleAlert('', '', 'open');
            var datasave = {
                id: this.state.id,
                deslocation: this.state.deslocation,
                deslocation_time: this.state.deslocation_time
            };

            var header = {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            };

            var self = this;
            fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/tripulante/deslocamento', { method: 'PUT', mode: 'cors', headers: header, body: JSON.stringify(datasave) }).then(function (response) {
                return response.json();
            }).catch(function (error) {
                console.error(error);
            }).then(function (responseJson) {
                if (responseJson.status === 'success') {
                    self.setState({ staff_deslocations: responseJson.data });
                } else if (responseJson.data == 'incomplete') {
                    self.setState({ loaded: true });
                }
                self.handleAlert(responseJson.message, responseJson.status, 'open');
            }).catch(function (error) {
                console.error(error);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var self = this;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'container-liquid' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'conteudo' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'h3',
                            { className: 'page-title pull-left' },
                            this.locale.TripulanteDeslocamentos.AdicionarDeslocamento.titulo
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                        this.state.loaded === true ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'form',
                                { onSubmit: this.edit },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'row' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-md-12 form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            this.locale.TripulanteDeslocamentos.AdicionarDeslocamento.formulario.houveDeslocamento + " (" + this.state.date_str + ")",
                                            '?'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
                                            checked: this.state.deslocation,
                                            'aria-label': 'No label tag',
                                            name: 'deslocation',
                                            onChange: this.handleToggleChange.bind(this, 'deslocation')
                                        })
                                    )
                                ),
                                this.state.deslocation ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'row' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-md-12 form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            this.locale.TripulanteDeslocamentos.AdicionarDeslocamento.formulario.tempoDeslocamento,
                                            ':'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.deslocation_time, maskChar: null, name: 'deslocation_time ', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'deslocation_time'), placeholder: 'hh:mm' })
                                    )
                                ) : '',
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'button',
                                        { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                                        ' ',
                                        this.locale.TripulanteDeslocamentos.AdicionarDeslocamento.formulario.botaoSalvar
                                    )
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'h3',
                                { className: 'page-title' },
                                this.locale.TripulanteDeslocamentos.AdicionarDeslocamento.tituloAnteriores
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'table-responsive' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'table',
                                    { className: 'table table-bordered table-hover table-striped' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'thead',
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'tr',
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'th',
                                                null,
                                                this.locale.TripulanteDeslocamentos.AdicionarDeslocamento.tabela.dataApresentacao
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'th',
                                                null,
                                                this.locale.TripulanteDeslocamentos.AdicionarDeslocamento.tabela.houveDeslocamento
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'th',
                                                null,
                                                this.locale.TripulanteDeslocamentos.AdicionarDeslocamento.tabela.tempoDeslocamento
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'th',
                                                null,
                                                this.locale.TripulanteDeslocamentos.AdicionarDeslocamento.tabela.Status
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'tbody',
                                        { id: 'dates' },
                                        Object.keys(self.state.staff_deslocations).map(function (k) {
                                            var staff_deslocation = self.state.staff_deslocations[k];
                                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'tr',
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'td',
                                                    null,
                                                    staff_deslocation.date_str
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'td',
                                                    null,
                                                    staff_deslocation.deslocation_str
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'td',
                                                    null,
                                                    staff_deslocation.deslocation_time
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'td',
                                                    null,
                                                    staff_deslocation.status_str
                                                )
                                            );
                                        })
                                    )
                                )
                            )
                        ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'div',
                            { className: 'user-content text-center', style: { paddingTop: '20px', border: 'none' } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'row' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'col-md-4 col-md-offset-4 text-center' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { src: __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/images/logo2.png', alt: 'SIGVOOS' })
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return StaffDeslocationsEdit;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffDeslocationsEdit);

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var StaffDiscrepanciesAdd = function (_Component) {
  _inherits(StaffDiscrepanciesAdd, _Component);

  // constructor
  function StaffDiscrepanciesAdd(props) {
    _classCallCheck(this, StaffDiscrepanciesAdd);

    var _this = _possibleConstructorReturn(this, (StaffDiscrepanciesAdd.__proto__ || Object.getPrototypeOf(StaffDiscrepanciesAdd)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      discrepancy: null,
      stress_rate: null,
      date: null,
      staff_discrepancies: {}
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();

    _this.add = _this.add.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    return _this;
  }
  // Handlers


  _createClass(StaffDiscrepanciesAdd, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/tripulante/discrepancias';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ staff_discrepancies: responseJson.data.staff_discrepancies, staff_id: responseJson.data.staff_id });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
        });
      });
    }
  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      var datasave = {
        staff_id: this.state.staff_id,
        date: this.state.date,
        discrepancy: this.state.discrepancy,
        stress_rate: this.state.stress_rate
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/tripulante/discrepancia', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ staff_discrepancies: responseJson.data });
          }
          self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.TripulanteDiscrepancias.AdicionarDiscrepancia.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.add },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.TripulanteDiscrepancias.AdicionarDiscrepancia.formulario.Data,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_input_mask___default.a, { value: this.state.date, maskChar: null, name: 'date', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date'), placeholder: '', required: true })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.TripulanteDiscrepancias.AdicionarDiscrepancia.formulario.Discrepancia,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'discrepancy', className: 'form-control', placeholder: '', value: this.state.discrepancy, onChange: this.handleChange.bind(this, 'discrepancy'), required: true })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.TripulanteDiscrepancias.AdicionarDiscrepancia.formulario.grauEstresse,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'stress_rate',
                      value: this.state.stress_rate,
                      searchable: true,
                      placeholder: '',
                      onChange: this.handleSelectChange.bind(this, 'stress_rate'),
                      options: [{ value: '1', label: '1' }, { value: '2', label: '2' }, { value: '3', label: '3' }, { value: '4', label: '4' }, { value: '5', label: '5' }],
                      required: true
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                    ' ',
                    this.locale.TripulanteDiscrepancias.AdicionarDiscrepancia.formulario.botaoAdicionar
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.TripulanteDiscrepancias.AdicionarDiscrepancia.tituloAnteriores
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'table-responsive' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'table table-bordered table-hover table-striped' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      this.locale.TripulanteDiscrepancias.AdicionarDiscrepancia.tabela.Data
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      this.locale.TripulanteDiscrepancias.AdicionarDiscrepancia.tabela.Discrepancia
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      this.locale.TripulanteDiscrepancias.AdicionarDiscrepancia.tabela.grauEstresse
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  { id: 'dates' },
                  Object.keys(self.state.staff_discrepancies).map(function (k) {
                    var staff_discrepancy = self.state.staff_discrepancies[k];
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        staff_discrepancy.date_str
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        staff_discrepancy.discrepancy
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        staff_discrepancy.stress_rate
                      )
                    );
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return StaffDiscrepanciesAdd;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffDiscrepanciesAdd);

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












// Importação da tabela



var StaffPapersControl = function (_Component) {
  _inherits(StaffPapersControl, _Component);

  function StaffPapersControl(props) {
    _classCallCheck(this, StaffPapersControl);

    var _this = _possibleConstructorReturn(this, (StaffPapersControl.__proto__ || Object.getPrototypeOf(StaffPapersControl)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      status: 1
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.search = _this.search.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(StaffPapersControl, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      self.setState({ overlay: { message: '', type: '', status: 'closed' } });
      self.handleMessage();
    }
  }, {
    key: 'search',
    value: function search(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');

      var datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        portal: 1
      };

      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/papeleta/controle', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
            self.handleAlert('', '', 'closed');
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.Papeletas.ControleDePapeletas.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.search },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.Papeletas.ControleDePapeletas.formulario.DataInicial,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_start, maskChar: null, name: 'date_start ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: this.locale.general.diaMesAno, required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.Papeletas.ControleDePapeletas.formulario.DataFinal,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_finish, maskChar: null, name: 'date_finish ', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: this.locale.general.diaMesAno, required: true })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-block btn-lg' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                ' ',
                this.locale.general.pesquisar
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: ' ' }, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'name', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' } },
                this.locale.Papeletas.ControleDePapeletas.tabela.Tripulante
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'total_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' } },
                this.locale.Papeletas.ControleDePapeletas.tabela.SomaDeHorasDeJornada
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'night_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' } },
                ' ',
                this.locale.Papeletas.ControleDePapeletas.tabela.SomaDeHorasDeVooNoturno
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'flight_time', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' } },
                this.locale.Papeletas.ControleDePapeletas.tabela.SomaDeHorasDeVooTotal
              )
            )
          )
        )
      );
    }
  }]);

  return StaffPapersControl;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffPapersControl);

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












// Importação da tabela



var StaffPapersControleCrew = function (_Component) {
  _inherits(StaffPapersControleCrew, _Component);

  function StaffPapersControleCrew(props) {
    _classCallCheck(this, StaffPapersControleCrew);

    var _this = _possibleConstructorReturn(this, (StaffPapersControleCrew.__proto__ || Object.getPrototypeOf(StaffPapersControleCrew)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      status: 1
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.search = _this.search.bind(_this);
    _this.exportPdf = _this.exportPdf.bind(_this);
    _this.exportXls = _this.exportXls.bind(_this);
    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.AlertColumn = _this.AlertColumn.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(StaffPapersControleCrew, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      self.setState({ overlay: { message: '', type: '', status: 'closed' } });
      self.handleMessage();
    }
  }, {
    key: 'search',
    value: function search(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');

      var datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_finish
      };

      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/papeleta/consulta/tripulante/pesquisa', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
            self.handleAlert('', '', 'closed');
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'exportPdf',
    value: function exportPdf(url) {
      var self = this;
      var header = this.refs.request_api.header('application/json');

      var datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_finish
      };

      self.setState({ overlay: { message: '', type: '', status: 'open' } });
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/papeleta/consulta/tripulante/pdf', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data;
            self.setState({
              url_export: url
            });
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data);
          }
        });
      });
    }
  }, {
    key: 'exportXls',
    value: function exportXls(url) {
      var self = this;
      var header = this.refs.request_api.header('application/json');

      var datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_finish
      };

      self.setState({ overlay: { message: '', type: '', status: 'open' } });
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/papeleta/consulta/tripulante/xls', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data;
            self.setState({
              url_export: url
            });
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data);
          }
        });
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var url = '/papeleta/editar/' + cell;

      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
          { className: 'btn btn-primary btn-sm', to: url },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
        )
      );

      return botao;
    }
  }, {
    key: 'AlertColumn',
    value: function AlertColumn(cell, row) {

      if (cell === 'Sim') {
        var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'label label-danger', style: { fontSize: 14 } },
          this.locale.general.sim
        );
      } else {
        var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'label label-success', style: { fontSize: 14 } },
          this.locale.general.nao
        );
      }

      return botao;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.Papeletas.ConsultaDePapeletas.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.search },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.Papeletas.ConsultaDePapeletas.formulario.DataInicial,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_start, maskChar: null, name: 'date_start ', mask: '99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: this.locale.general.mesAno, required: true })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6 form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    this.locale.Papeletas.ConsultaDePapeletas.formulario.DataFinal,
                    ':'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_finish, maskChar: null, name: 'date_finish ', mask: '99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: this.locale.general.mesAno, required: true })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-block btn-lg' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                ' ',
                this.locale.general.pesquisar
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { onClick: function onClick() {
                      _this2.exportPdf();
                    }, className: 'btn btn-success btn-block btn-lg' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' }),
                  ' ',
                  this.locale.general.exportarPDF
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6 form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { onClick: function onClick() {
                      _this2.exportXls();
                    }, className: 'btn btn-warning btn-block btn-lg' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-excel-o' }),
                  ' ',
                  this.locale.general.exportarXLS
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: ' ' }, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'month', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' } },
                this.locale.Papeletas.ConsultaDePapeletas.tabela.MesAno
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'alerts', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, dataFormat: this.AlertColumn },
                this.locale.Papeletas.ConsultaDePapeletas.tabela.Alertas
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_8_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '100' },
                this.locale.Papeletas.ConsultaDePapeletas.tabela.Acoes
              )
            )
          )
        )
      );
    }
  }]);

  return StaffPapersControleCrew;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffPapersControleCrew);

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





// Helpers de formulário



var StaffPaperApprovals = function (_Component) {
  _inherits(StaffPaperApprovals, _Component);

  function StaffPaperApprovals(props) {
    _classCallCheck(this, StaffPaperApprovals);

    var _this = _possibleConstructorReturn(this, (StaffPaperApprovals.__proto__ || Object.getPrototypeOf(StaffPaperApprovals)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      modal: false,
      loaded: 0,
      crew: 0,
      manager: 0,
      staff_paper_id: _this.props.staff_paper_id,
      staff_paper_approvals: [],
      staff_paper: {},
      display_errors: false,
      errors: []
    };

    //bind específico
    _this.approveCrew = _this.approveCrew.bind(_this);
    _this.approveManager = _this.approveManager.bind(_this);
    _this.getInfoPaper = _this.getInfoPaper.bind(_this);
    _this.confirmApproveCrew = _this.confirmApproveCrew.bind(_this);
    _this.confirmApproveManager = _this.confirmApproveManager.bind(_this);
    _this.reproveManager = _this.reproveManager.bind(_this);
    _this.reopen = _this.reopen.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(StaffPaperApprovals, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 && typeof newProps.staff_paper.month !== 'undefined' && Array.isArray(newProps.staff_paper_approvals)) {
        this.setState({
          staff_paper_id: newProps.staff_paper_id,
          staff_paper_approvals: newProps.staff_paper_approvals,
          staff_paper: newProps.staff_paper,
          loaded: 1
        });
      }
    }

    // Modal para marcar como verificada

  }, {
    key: 'approveCrew',
    value: function approveCrew(schedule_grade_id) {
      this.setState({ crew: 1, manager: 0 });
      this.getInfoPaper(schedule_grade_id);
    }

    // Modal para marcar como verificada

  }, {
    key: 'approveManager',
    value: function approveManager(event) {
      this.setState({ manager: event, crew: 0 });
      this.getInfoPaper(event);
    }
  }, {
    key: 'getInfoPaper',
    value: function getInfoPaper(event) {
      var self = this;
      var header = this.refs.request_api.header('application/json');

      var datasave = {
        id: self.state.staff_paper_id
      };
      this.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/papeleta/tripulante/pdf', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data;
            self.setState({
              modal: true,
              url_export: url,
              iframe: 'iframe'
            });
          }
          self.props.handleAlert('', '', 'closed');
        });
      });
    }
  }, {
    key: 'confirmApproveCrew',
    value: function confirmApproveCrew() {
      if (window.confirm(this.locale.Papeletas.EditarPapeleta.trocarStatus)) {
        this.props.handleAlert('', '', 'open');

        var header = this.refs.request_api.header('application/json');
        var self = this;

        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/papeleta/tripulante/aprovar/' + self.state.staff_paper_id, { method: 'PUT', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
            var staff_paper = Object.assign({}, self.state.staff_paper);
            staff_paper.status = 1;
            self.setState({ modal: false });
            if (responseJson.status === 'success') {
              self.setState({ staff_paper: staff_paper, staff_paper_approvals: responseJson.data.staff_paper_approvals });
            }
            if (responseJson.status === 'warning') {
              self.setState({ display_errors: true, errors: responseJson.data });
            }
            if (responseJson.data.staff_paper_warnings) {
              self.props.changeParentState({ staff_paper_warnings: responseJson.data.staff_paper_warnings });
            }
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'confirmApproveManager',
    value: function confirmApproveManager(event) {
      if (window.confirm(this.locale.Papeletas.EditarPapeleta.trocarStatus)) {
        this.props.handleAlert('', '', 'open');

        var header = this.refs.request_api.header('application/json');
        var self = this;

        var datasave = {
          bypass_approval: event,
          id: self.state.staff_paper_id
        };

        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/papeleta/gestor/aprovar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
            var staff_paper = Object.assign({}, self.state.staff_paper);
            staff_paper.status = 2;
            self.setState({ modal: false });
            if (responseJson.status === 'success') {
              self.setState({ staff_paper: staff_paper, staff_paper_approvals: responseJson.data.staff_paper_approvals });
            }
            if (responseJson.data.staff_paper_warnings) {
              self.props.changeParentState({ staff_paper_warnings: responseJson.data.staff_paper_warnings });
            }
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }

    // Fetch salvando a edição

  }, {
    key: 'reproveManager',
    value: function reproveManager() {
      if (window.confirm(this.locale.Papeletas.EditarPapeleta.trocarStatus)) {
        this.props.handleAlert('', '', 'open');

        var header = this.refs.request_api.header('application/json');
        var self = this;

        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/papeleta/gestor/reprovar/' + self.state.staff_paper_id, { method: 'PUT', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
            var staff_paper = Object.assign({}, self.state.staff_paper);
            staff_paper.status = 0;
            self.setState({ modal: false });
            if (responseJson.status === 'success') {
              self.setState({ staff_paper: staff_paper, staff_paper_approvals: responseJson.data.staff_paper_approvals });
            }
            if (responseJson.data.staff_paper_warnings) {
              self.props.changeParentState({ staff_paper_warnings: responseJson.data.staff_paper_warnings });
            }
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }

    // Fetch salvando a edição

  }, {
    key: 'reopen',
    value: function reopen() {
      if (window.confirm(this.locale.Papeletas.EditarPapeleta.reabrir)) {
        this.props.handleAlert('', '', 'open');

        var header = this.refs.request_api.header('application/json');
        var self = this;

        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/papeleta/reabrir/status/4/' + self.state.staff_paper_id, { method: 'PUT', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
            var staff_paper = Object.assign({}, self.state.staff_paper);
            staff_paper.status = responseJson.data.status;
            self.setState({ staff_paper: staff_paper, staff_paper_approvals: responseJson.data.staff_paper_approvals });
            if (responseJson.data.staff_paper_warnings) {

              self.props.changeParentState({ staff_paper_warnings: responseJson.data.staff_paper_warnings });
            }
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;

      var approveButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'pull-right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { onClick: function onClick() {
              return self.approveManager(2);
            }, className: 'btn button-inline btn-danger' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' }),
          ' ',
          this.locale.Papeletas.EditarPapeleta.botaoForcarAprovacao
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { onClick: function onClick() {
              return self.approveCrew();
            }, className: 'btn btn-primary pull-right' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' }),
          ' ',
          this.locale.Papeletas.EditarPapeleta.botaoAprovacaoTripulante
        )
      );

      var managerButton = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'pull-right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { onClick: function onClick() {
              return self.approveManager(1);
            }, className: 'btn button-inline btn-primary' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' }),
          ' ',
          this.locale.Papeletas.EditarPapeleta.botaoAprovacaoGestor
        )
      );

      var approved = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'pull-right' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { onClick: function onClick() {
              return self.reopen();
            }, className: 'btn button-inline btn-danger' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-close' }),
          ' ',
          this.locale.Papeletas.EditarPapeleta.botaoReabrirPapeleta
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn button-inline btn-success', disabled: true },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' }),
          ' ',
          this.locale.Papeletas.EditarPapeleta.botaoPapeletaAprovada,
          ' '
        )
      );

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          null,
          self.state.display_errors && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'alert alert-danger alert-dismissible', role: 'alert', style: { marginTop: 25 } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { onClick: function onClick() {
                  return self.setState({ display_errors: false, errors: [] });
                }, type: 'button', className: 'close', 'data-dismiss': 'alert', 'aria-label': 'Close' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'span',
                { 'aria-hidden': 'true' },
                '\xD7'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'strong',
              null,
              this.locale.Papeletas.EditarPapeleta.erros,
              ':'
            ),
            Object.keys(self.state.errors).map(function (k) {
              var message = self.state.errors[k];
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                '- ',
                message
              );
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h4',
            { className: 'pull-left' },
            this.locale.Papeletas.EditarPapeleta.tituloLogDeAprovacoes
          ),
          self.state.staff_paper.status === 0 && approveButton,
          self.state.staff_paper.status === 1 && managerButton,
          self.state.staff_paper.status === 2 && approved,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'table-responsive' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'table',
              { className: 'table table-bordered table-hover table-striped' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'thead',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    { style: { width: '380px' } },
                    this.locale.Papeletas.EditarPapeleta.tabelaLogDeAprovacoes.Usuario
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    this.locale.Papeletas.EditarPapeleta.tabelaLogDeAprovacoes.Acao
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    null,
                    this.locale.Papeletas.EditarPapeleta.tabelaLogDeAprovacoes.Data
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tbody',
                null,
                Object.keys(self.state.staff_paper_approvals).map(function (k) {
                  var spa = self.state.staff_paper_approvals[k];
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      { style: { width: '380px' } },
                      spa.user_name
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      spa.type
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      null,
                      spa.created_at_str
                    )
                  );
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */],
            { show: this.state.modal, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Header,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                { className: 'pull-left' },
                this.locale.Papeletas.EditarPapeleta.tituloFIRA
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                    return _this2.setState({ modal: false });
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Body,
              null,
              self.state.crew === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { onClick: function onClick() {
                      return self.confirmApproveCrew();
                    }, className: 'btn btn-success btn-block btn-lg' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' }),
                  ' ',
                  this.locale.Papeletas.EditarPapeleta.botaoAprovacaoTripulante
                )
              ) : "",
              self.state.manager === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { onClick: function onClick() {
                      return self.confirmApproveManager(0);
                    }, className: 'btn button-inline btn-success btn-block btn-lg' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' }),
                  ' ',
                  this.locale.Papeletas.EditarPapeleta.botaoAprovacaoGestor
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { onClick: function onClick() {
                      return self.reproveManager();
                    }, className: 'btn button-inline btn-danger btn-block btn-lg' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-close' }),
                  ' ',
                  this.locale.Papeletas.EditarPapeleta.botaoReprovacaoGestor
                )
              ) : "",
              self.state.manager === 2 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { onClick: function onClick() {
                      return self.confirmApproveManager(1);
                    }, className: 'btn button-inline btn-success btn-block btn-lg' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' }),
                  ' ',
                  this.locale.Papeletas.EditarPapeleta.botaoAprovacaoGestor
                )
              ) : "",
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe', { className: this.state.iframe, height: '600px', width: '100%', src: this.state.url_export, name: 'iframe_a' })
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Footer,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                    return _this2.setState({ modal: false });
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
              )
            )
          )
        )
      );
    }
  }]);

  return StaffPaperApprovals;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffPaperApprovals);

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StaffPaperEditDayInterruptions__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







// Helpers de formulário



// Tabs



var StaffPaperEditDay = function (_Component) {
  _inherits(StaffPaperEditDay, _Component);

  function StaffPaperEditDay(props) {
    _classCallCheck(this, StaffPaperEditDay);

    var _this = _possibleConstructorReturn(this, (StaffPaperEditDay.__proto__ || Object.getPrototypeOf(StaffPaperEditDay)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      aircraft_model_id: null,
      date: null,
      modal: false,
      modal_interruptions: false,
      schedule_initials_select: [],
      aircraft_models_select: [],
      staff_paper_day_aircraft_models: [],
      staff_paper_day_interruptions: [],
      id: _this.props.day.id,
      schedule_initial_id: _this.props.day.schedule_initial_id,
      departure_location: _this.props.day.departure_location,
      arrival_location: _this.props.day.arrival_location,
      add_interruption_start: _this.props.day.start_str,
      start: _this.props.day.start,
      interruption_start: _this.props.day.interruption_start,
      interruption_finish: _this.props.day.interruption_finish,
      second_interruption_start: _this.props.day.second_interruption_start,
      second_interruption_finish: _this.props.day.second_interruption_finish,
      add_interruption_finish: _this.props.day.finish_str,
      total_time: _this.props.day.total_time,
      night_time: _this.props.day.night_time,
      flight_time: _this.props.day.flight_time,
      updated: 0
    };

    //bind específico
    _this.edit = _this.edit.bind(_this);
    _this.deleteAircraftModel = _this.deleteAircraftModel.bind(_this);
    _this.addAircraftModel = _this.addAircraftModel.bind(_this);
    _this.editInterruptions = _this.editInterruptions.bind(_this);
    _this.addInterruptions = _this.addInterruptions.bind(_this);
    _this.deleteInterruptions = _this.deleteInterruptions.bind(_this);
    _this.deleteRow = _this.deleteRow.bind(_this);
    _this.autoUpdate = _this.autoUpdate.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(StaffPaperEditDay, [{
    key: 'handleChangeDate',
    value: function handleChangeDate(name, event) {
      if (!event.target.value) {
        var change = {};
        change[name] = this.state.date;
        this.setState(change);
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if ((this.state.loaded === 0 || newProps.updated == true) && typeof newProps.day.date !== 'undefined' && Array.isArray(newProps.schedule_initials_select) && Array.isArray(newProps.aircraft_models_select)) {
        this.setState({
          id: newProps.day.id,
          staff_paper_day_aircraft_models: newProps.day.staff_paper_day_aircraft_models,
          staff_paper_day_interruptions: newProps.day.staff_paper_day_interruptions,
          schedule_initial_id: newProps.day.schedule_initial_id,
          departure_location: newProps.day.departure_location,
          arrival_location: newProps.day.arrival_location,

          start_date: newProps.day.start_date,
          start_hour: newProps.day.start_hour,
          interruption_start_date: newProps.day.interruption_start_date,
          interruption_start_hour: newProps.day.interruption_start_hour,
          interruption_finish_date: newProps.day.interruption_finish_date,
          interruption_finish_hour: newProps.day.interruption_finish_hour,
          second_interruption_start_date: newProps.day.second_interruption_start_date,
          second_interruption_start_hour: newProps.day.second_interruption_start_hour,
          second_interruption_finish_date: newProps.day.second_interruption_finish_date,
          second_interruption_finish_hour: newProps.day.second_interruption_finish_hour,
          finish_date: newProps.day.finish_date,
          finish_hour: newProps.day.finish_hour,

          start: newProps.day.start_str,
          interruption_start: newProps.day.interruption_start_str,
          interruption_finish: newProps.day.interruption_finish_str,
          second_interruption_start: newProps.day.second_interruption_start_str,
          second_interruption_finish: newProps.day.second_interruption_finish_str,
          finish: newProps.day.finish_str,
          total_time: newProps.day.total_time,
          night_time: newProps.day.night_time,
          flight_time: newProps.day.flight_time,
          interruption_time: newProps.day.interruption_time,
          date: newProps.day.date_str,
          schedule_initials_select: newProps.schedule_initials_select,
          aircraft_models_select: newProps.aircraft_models_select,
          loaded: 1
        });
      }
      if (newProps.updated == true) {
        this.props.changeUpdate();
      }
    }

    // Fetch salvando a edição

  }, {
    key: 'edit',
    value: function edit() {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        id: this.state.id,
        schedule_initial_id: this.state.schedule_initial_id,
        departure_location: this.state.departure_location,
        arrival_location: this.state.arrival_location,
        start_date: this.state.start_date,
        start_hour: this.state.start_hour,
        interruption_start_date: this.state.interruption_start_date,
        interruption_start_hour: this.state.interruption_start_hour,
        interruption_finish_date: this.state.interruption_finish_date,
        interruption_finish_hour: this.state.interruption_finish_hour,
        second_interruption_start_date: this.state.second_interruption_start_date,
        second_interruption_start_hour: this.state.second_interruption_start_hour,
        second_interruption_finish_date: this.state.second_interruption_finish_date,
        second_interruption_finish_hour: this.state.second_interruption_finish_hour,
        finish_date: this.state.finish_date,
        finish_hour: this.state.finish_hour,
        total_time: this.state.total_time,
        night_time: this.state.night_time,
        flight_time: this.state.flight_time
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/papeleta/dia/' + self.state.id, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          self.setState({ total_time: responseJson.data.total_time_str });
          self.setState({ night_time: responseJson.data.night_time });
          self.setState({ flight_time: responseJson.data.flight_time });
          self.setState({ interruption_time: responseJson.data.interruption_time });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'addAircraftModel',
    value: function addAircraftModel(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var datasave = {
        staff_paper_day_id: this.state.id,
        aircraft_model_id: this.state.aircraft_model_id
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/papeleta/frota', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          self.setState({ staff_paper_day_aircraft_models: responseJson.data });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'deleteAircraftModel',
    value: function deleteAircraftModel(id) {
      if (window.confirm(this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.DeletarFrota)) {
        this.props.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/papeleta/frota/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
            self.setState({ staff_paper_day_aircraft_models: responseJson.data });
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'addInterruptions',
    value: function addInterruptions(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var datasave = {
        staff_paper_day_id: this.state.id,
        start: this.state.add_interruption_start,
        finish: this.state.add_interruption_finish
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/papeleta/interrupcao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status == 'success') {
            self.setState({ staff_paper_day_interruptions: responseJson.data.staff_paper_day_interruptions });
            self.setState({ total_time: responseJson.data.staff_paper_day.total_time_str });
            self.setState({ night_time: responseJson.data.staff_paper_day.night_time });
            self.setState({ flight_time: responseJson.data.staff_paper_day.flight_time });
            self.setState({ interruption_time: responseJson.data.staff_paper_day.interruption_time });
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }

    // Fetch salvando a edição

  }, {
    key: 'editInterruptions',
    value: function editInterruptions(datasave) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/papeleta/interrupcao', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status == 'success') {
            self.setState({ staff_paper_day_interruptions: responseJson.data.staff_paper_day_interruptions });
            self.setState({ total_time: responseJson.data.staff_paper_day.total_time_str });
            self.setState({ night_time: responseJson.data.staff_paper_day.night_time });
            self.setState({ flight_time: responseJson.data.staff_paper_day.flight_time });
            self.setState({ interruption_time: responseJson.data.staff_paper_day.interruption_time });
            self.setState({ updated: 1 });
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'deleteInterruptions',
    value: function deleteInterruptions(id) {
      if (window.confirm(this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.DeletarInterrupcao)) {
        this.props.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/papeleta/interrupcao/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status == 'success') {
              self.deleteRow(id);
              self.setState({ staff_paper_day_interruptions: responseJson.data.staff_paper_day_interruptions });
              self.setState({ total_time: responseJson.data.staff_paper_day.total_time_str });
              self.setState({ night_time: responseJson.data.staff_paper_day.night_time });
              self.setState({ flight_time: responseJson.data.staff_paper_day.flight_time });
              self.setState({ interruption_time: responseJson.data.staff_paper_day.interruption_time });
            }
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'deleteRow',
    value: function deleteRow(id) {
      var data = this.state.staff_paper_day_interruptions;
      data.map(function (dado, index) {
        if (dado.id == id) {
          data.splice(index, 1);
        }
      });
      this.setState({ data: data });
    }
  }, {
    key: 'autoUpdate',
    value: function autoUpdate() {
      var self = this;
      if (window.confirm(this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.AtualizarInformacoesDestaData)) {

        var url = "/papeleta/dia/atualizar/";
        var header = this.refs.request_api.header('application/json');
        this.props.handleAlert('', '', 'open');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url + self.state.id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'url');
            if (responseJson.status === 'success') {
              self.props.updateData(responseJson);
            }
          });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'tr',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'text-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
          this.state.date
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'text-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'departure_location', className: 'form-control form-control', placeholder: '', value: this.state.departure_location, onChange: this.handleChange.bind(this, 'departure_location') })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'text-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'arrival_location', className: 'form-control form-control', placeholder: '', value: this.state.arrival_location, onChange: this.handleChange.bind(this, 'arrival_location') })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'text-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
            name: 'schedule_initial_id',
            value: this.state.schedule_initial_id,
            searchable: true,
            placeholder: this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.placeholder.SelecionarSituacao,
            onChange: this.handleSelectChange.bind(this, 'schedule_initial_id'),
            options: this.state.schedule_initials_select
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'text-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.start_date, maskChar: null, name: 'start_date', mask: '99/99/9999', className: 'form-control form-control', onMouseDown: this.handleChangeDate.bind(this, 'start_date'), onChange: this.handleChange.bind(this, 'start_date'), placeholder: this.locale.general.diaMesAno })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'text-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.start_hour, maskChar: null, name: 'start_hour', mask: '99:99', className: 'form-control form-control', onMouseDown: this.handleChangeDate.bind(this, 'start_date'), onChange: this.handleChange.bind(this, 'start_hour'), placeholder: this.locale.general.horaMinuto })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'text-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.interruption_start_date, maskChar: null, name: 'interruption_start_date', mask: '99/99/9999', className: 'form-control form-control', onMouseDown: this.handleChangeDate.bind(this, 'interruption_start_date'), onChange: this.handleChange.bind(this, 'interruption_start_date'), placeholder: this.locale.general.diaMesAno })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'text-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.interruption_start_hour, maskChar: null, name: 'interruption_start_hour', mask: '99:99', className: 'form-control form-control', onMouseDown: this.handleChangeDate.bind(this, 'interruption_start_date'), onChange: this.handleChange.bind(this, 'interruption_start_hour'), placeholder: this.locale.general.horaMinuto })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'text-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.interruption_finish_date, maskChar: null, name: 'interruption_finish_date', mask: '99/99/9999', className: 'form-control form-control', onMouseDown: this.handleChangeDate.bind(this, 'interruption_finish_date'), onChange: this.handleChange.bind(this, 'interruption_finish_date'), placeholder: this.locale.general.diaMesAno })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'text-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.interruption_finish_hour, maskChar: null, name: 'interruption_finish_hour', mask: '99:99', className: 'form-control form-control', onMouseDown: this.handleChangeDate.bind(this, 'interruption_finish_date'), onChange: this.handleChange.bind(this, 'interruption_finish_hour'), placeholder: this.locale.general.horaMinuto })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'text-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.second_interruption_start_date, maskChar: null, name: 'second_interruption_start', mask: '99/99/9999', className: 'form-control form-control', onMouseDown: this.handleChangeDate.bind(this, 'second_interruption_start_date'), onChange: this.handleChange.bind(this, 'second_interruption_start_date'), placeholder: this.locale.general.diaMesAno })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'text-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.second_interruption_start_hour, maskChar: null, name: 'second_interruption_start_hour', mask: '99:99', className: 'form-control form-control', onMouseDown: this.handleChangeDate.bind(this, 'second_interruption_start_date'), onChange: this.handleChange.bind(this, 'second_interruption_start_hour'), placeholder: this.locale.general.horaMinuto })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'text-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.second_interruption_finish_date, maskChar: null, name: 'second_interruption_finish_date', mask: '99/99/9999', className: 'form-control form-control', onMouseDown: this.handleChangeDate.bind(this, 'second_interruption_finish_date'), onChange: this.handleChange.bind(this, 'second_interruption_finish_date'), placeholder: this.locale.general.diaMesAno })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'text-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.second_interruption_finish_hour, maskChar: null, name: 'second_interruption_finish_hour', mask: '99:99', className: 'form-control form-control', onMouseDown: this.handleChangeDate.bind(this, 'second_interruption_finish_date'), onChange: this.handleChange.bind(this, 'second_interruption_finish_hour'), placeholder: this.locale.general.horaMinuto })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'text-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.finish_date, maskChar: null, name: 'finish_date', mask: '99/99/9999', className: 'form-control form-control', onMouseDown: this.handleChangeDate.bind(this, 'finish_date'), onChange: this.handleChange.bind(this, 'finish_date'), placeholder: this.locale.general.diaMesAno })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'text-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.finish_hour, maskChar: null, name: 'finish_hour', mask: '99:99', className: 'form-control form-control', onMouseDown: this.handleChangeDate.bind(this, 'finish_date'), onChange: this.handleChange.bind(this, 'finish_hour'), placeholder: this.locale.general.horaMinuto })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'text-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'row' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'col-md-12' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.total_time, maskChar: null, disabled: true, name: 'total_time', mask: '99:99', className: 'form-control form-control', onChange: this.handleChange.bind(this, 'total_time'), placeholder: this.locale.general.horaMinuto })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'text-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.night_time, maskChar: null, disabled: true, name: 'night_time', mask: '99:99', className: 'form-control form-control', onChange: this.handleChange.bind(this, 'night_time'), placeholder: this.locale.general.horaMinuto })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'text-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.flight_time, maskChar: null, disabled: true, name: 'flight_time', mask: '99:99', className: 'form-control form-control', onChange: this.handleChange.bind(this, 'flight_time'), placeholder: this.locale.general.horaMinuto })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'text-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'submit', onClick: function onClick() {
                return _this2.edit();
              }, className: 'btn btn-primary btn-sm' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' })
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'text-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { onClick: function onClick() {
                return self.autoUpdate();
              }, className: 'btn btn-success btn-sm' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-refresh' }),
            ' '
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'text-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button', onClick: function onClick() {
                return _this2.setState({ modal_interruptions: true });
              }, className: 'btn btn-warning btn-sm' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-clock-o' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */],
            { show: this.state.modal_interruptions, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Header,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                { className: 'pull-left' },
                this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.tituloInterrupcoes
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                    return _this2.setState({ modal_interruptions: false });
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Body,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'form',
                { onSubmit: this.addInterruptions },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-4', style: { textAlign: 'center' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.formularioInterrupcoes.InicioDaInterrupcao
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.add_interruption_start, maskChar: null, name: 'add_interruption_start', mask: '99/99/9999 99:99', className: 'form-control field-papers-main-datetime', onChange: this.handleChange.bind(this, 'add_interruption_start'), placeholder: this.locale.general.diaMesAnoHoraMinuto })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-4', style: { textAlign: 'center' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.formularioInterrupcoes.FimDaInterrupcao
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.add_interruption_finish, maskChar: null, name: 'add_interruption_finish', mask: '99/99/9999 99:99', className: 'form-control field-papers-main-datetime', onChange: this.handleChange.bind(this, 'add_interruption_finish'), placeholder: this.locale.general.diaMesAnoHoraMinuto })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { type: 'submit', className: 'btn btn-primary btn-block' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                      ' ',
                      this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.formularioInterrupcoes.botaoAdicionarInterrupcao
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-responsive' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'table',
                  { className: 'table table-bordered table-hover table-striped' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'thead',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { style: { textAlign: 'center' } },
                        this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.tabelaInterrupcoes.Inicio
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { style: { textAlign: 'center' } },
                        this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.tabelaInterrupcoes.Fim
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { style: { textAlign: 'center' } },
                        this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.tabelaInterrupcoes.Total
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { style: { textAlign: 'center' } },
                        this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.tabelaInterrupcoes.Acoes
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tbody',
                    null,
                    Object.keys(self.state.staff_paper_day_interruptions).map(function (k) {
                      var interruption = self.state.staff_paper_day_interruptions[k];
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StaffPaperEditDayInterruptions__["a" /* default */], { handleAlert: self.props.handleAlert, editInterruptions: self.editInterruptions, deleteInterruptions: self.deleteInterruptions, updated: self.state.updated, interruption: interruption, staff_paper_day_id: self.state.id });
                    }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { colSpan: 2, style: { textAlign: 'right', fontWeight: 700 } },
                        'Total'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { style: { textAlign: 'center', fontWeight: 700 } },
                        self.state.interruption_time
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', { className: 'text-center' })
                    )
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Footer,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                    return _this2.setState({ modal_interruptions: false });
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { className: 'text-center' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'button', onClick: function onClick() {
                return _this2.setState({ modal: true });
              }, className: 'btn btn-info btn-sm' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-plane' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */],
            { show: this.state.modal, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Header,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h4',
                { className: 'pull-left' },
                this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.tituloEquipamentos
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                    return _this2.setState({ modal: false });
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Body,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'form',
                { onSubmit: this.addAircraftModel },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-12', style: { textAlign: 'center' } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                        className: 'form-field-name',
                        name: 'aircraft_model_id',
                        value: this.state.aircraft_model_id,
                        searchable: true,
                        placeholder: this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.formularioEquipamentos.placeholder.SelecionarFrota,
                        onChange: this.handleSelectChange.bind(this, 'aircraft_model_id'),
                        options: this.state.aircraft_models_select
                      })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-12' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { type: 'submit', className: 'btn btn-primary btn-block' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                      ' ',
                      this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.formularioEquipamentos.botaoAdicionarFrota
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-responsive' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'table',
                  { className: 'table table-bordered table-hover table-striped' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'thead',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { style: { textAlign: 'center' } },
                        this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.tabelaEquipamentos.Frota
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'col-md-1', style: { textAlign: 'center' } },
                        this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.tabelaEquipamentos.Acoes
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tbody',
                    null,
                    Object.keys(self.state.staff_paper_day_aircraft_models).map(function (k) {
                      var spdam = self.state.staff_paper_day_aircraft_models[k];
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'tr',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'td',
                          { style: { textAlign: 'center' } },
                          spdam.aircraft_model.model
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'td',
                          { style: { textAlign: 'center' } },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'button',
                            { className: 'btn btn-danger', onClick: function onClick() {
                                return self.deleteAircraftModel(spdam.id);
                              } },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-trash' })
                          )
                        )
                      );
                    })
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Footer,
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                    return _this2.setState({ modal: false });
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
              )
            )
          )
        )
      );
    }
  }]);

  return StaffPaperEditDay;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffPaperEditDay);

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// Helpers de formulário



var StaffPaperEditDayInterruptions = function (_Component) {
  _inherits(StaffPaperEditDayInterruptions, _Component);

  function StaffPaperEditDayInterruptions(props) {
    _classCallCheck(this, StaffPaperEditDayInterruptions);

    var _this = _possibleConstructorReturn(this, (StaffPaperEditDayInterruptions.__proto__ || Object.getPrototypeOf(StaffPaperEditDayInterruptions)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      staff_paper_day_id: _this.props.staff_paper_day_id,
      id: _this.props.interruption.id,
      start: _this.props.interruption.start_str,
      finish: _this.props.interruption.finish_str,
      total: _this.props.interruption.total
    };

    //bind específico
    _this.edit = _this.edit.bind(_this);
    _this.delete = _this.delete.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(StaffPaperEditDayInterruptions, [{
    key: 'handleChange',
    value: function handleChange(name, event) {

      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 || this.state.loaded === 1 && newProps.updated === 1) {
        this.setState({
          id: newProps.interruption.id,
          staff_paper_day_id: newProps.staff_paper_day_id,
          start: newProps.interruption.start_str,
          finish: newProps.interruption.finish_str,
          total: newProps.interruption.total,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição

  }, {
    key: 'edit',
    value: function edit() {
      var datasave = {
        staff_paper_day_id: this.state.staff_paper_day_id,
        id: this.state.id,
        start: this.state.start,
        finish: this.state.finish
      };
      this.props.editInterruptions(datasave);
    }
  }, {
    key: 'delete',
    value: function _delete(id) {
      this.props.deleteInterruptions(id);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'tr',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_input_mask___default.a, { value: this.state.start, maskChar: null, name: 'start', mask: '99/99/9999 99:99', className: 'form-control field-papers-main-datetime', onChange: this.handleChange.bind(this, 'start'), placeholder: this.locale.general.diaMesAnoHoraMinuto })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_input_mask___default.a, { value: this.state.finish, maskChar: null, name: 'finish', mask: '99/99/9999 99:99', className: 'form-control field-papers-main-datetime', onChange: this.handleChange.bind(this, 'finish'), placeholder: this.locale.general.diaMesAnoHoraMinuto })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { style: { textAlign: 'center' } },
          this.state.total
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { style: { textAlign: 'center' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'submit', onClick: function onClick() {
                return _this2.edit();
              }, className: 'btn btn-primary' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'submit', onClick: function onClick() {
                return _this2.delete(_this2.state.id);
              }, className: 'btn btn-danger' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-trash' })
          )
        )
      );
    }
  }]);

  return StaffPaperEditDayInterruptions;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffPaperEditDayInterruptions);

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StaffPaperPendencyDayInterruptions__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







// Tabs



var StaffPaperPendencyDay = function (_Component) {
    _inherits(StaffPaperPendencyDay, _Component);

    function StaffPaperPendencyDay(props) {
        _classCallCheck(this, StaffPaperPendencyDay);

        var _this = _possibleConstructorReturn(this, (StaffPaperPendencyDay.__proto__ || Object.getPrototypeOf(StaffPaperPendencyDay)).call(this, props));

        _this.state = {
            overlay: {
                message: '',
                type: '',
                status: 'closed'
            },
            redirect_url: false,
            loaded: 0,
            aircraft_model_id: null,
            date: null,
            modal: false,
            modal_interruptions: false,
            schedule_initials_select: [],
            aircraft_models_select: [],
            staff_paper_day_aircraft_models: [],
            staff_paper_day_interruptions: [],
            id: _this.props.day.id,
            schedule_initial: null,
            schedule_initial_id: _this.props.day.schedule_initial_id,
            departure_location: _this.props.day.departure_location,
            arrival_location: _this.props.day.arrival_location,
            add_interruption_start: _this.props.day.start,
            start: _this.props.day.start,
            interruption_start: _this.props.day.interruption_start,
            interruption_finish: _this.props.day.interruption_finish,
            second_interruption_start: _this.props.day.second_interruption_start,
            second_interruption_finish: _this.props.day.second_interruption_finish,
            add_interruption_finish: _this.props.day.finish,
            total_time: _this.props.day.total_time,
            night_time: _this.props.day.night_time,
            flight_time: _this.props.day.flight_time,
            updated: 0
        };
        //bind específico
        _this.autoUpdate = _this.autoUpdate.bind(_this);

        _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__i18n_getLocale__["a" /* default */])();
        return _this;
    }

    // LM


    _createClass(StaffPaperPendencyDay, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(newProps) {
            if ((this.state.loaded === 0 || newProps.updated == true) && typeof newProps.day.date !== 'undefined' && Array.isArray(newProps.schedule_initials_select) && Array.isArray(newProps.aircraft_models_select)) {
                this.setState({
                    id: newProps.day.id,
                    staff_paper_day_aircraft_models: newProps.day.staff_paper_pendency_day_aircraft_models,
                    staff_paper_day_interruptions: newProps.day.staff_paper_pendency_day_interruptions,
                    schedule_initial_id: newProps.day.schedule_initial_id,
                    schedule_initial: newProps.day.schedule_initial.name,
                    departure_location: newProps.day.departure_location,
                    arrival_location: newProps.day.arrival_location,
                    start: newProps.day.start_str,
                    interruption_start: newProps.day.interruption_start_str,
                    interruption_finish: newProps.day.interruption_finish_str,
                    second_interruption_start: newProps.day.second_interruption_start_str,
                    second_interruption_finish: newProps.day.second_interruption_finish_str,
                    finish: newProps.day.finish_str,
                    total_time: newProps.day.total_time,
                    night_time: newProps.day.night_time,
                    flight_time: newProps.day.flight_time,
                    interruption_time: newProps.day.interruption_time,
                    date: newProps.day.date_str,
                    schedule_initials_select: newProps.schedule_initials_select,
                    aircraft_models_select: newProps.aircraft_models_select,
                    loaded: 1
                });
            }
            if (newProps.updated == true) {
                this.props.changeUpdate();
            }
        }
    }, {
        key: 'autoUpdate',
        value: function autoUpdate() {
            if (window.confirm(this.locale.Papeletas.EditarPapeleta.tabelaPendencias.AtualizarAsInformacoesDestaDataDeAcordoComAPendencia)) {

                var url = "/papeleta/pendencia/dia/atualizar/";
                var header = this.props.RequestApi.header('application/json');
                this.props.handleAlert('', '', 'open');
                var self = this;
                Promise.resolve(header).then(function (value) {
                    fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url + self.state.id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
                        return response.json();
                    }).catch(function (error) {
                        console.error(error);
                    }).then(function (responseJson) {
                        self.props.RequestApi.validate(responseJson, 'alert');
                        if (responseJson.status === 'success') {
                            self.props.updateData(responseJson);
                        }
                    });
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var self = this;
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tr',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.date
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.departure_location
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.arrival_location
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.schedule_initial
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.start
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.interruption_start
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.interruption_finish
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.second_interruption_start
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.second_interruption_finish
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.finish
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.total_time
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.night_time
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    self.state.flight_time
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { onClick: function onClick() {
                                return self.autoUpdate();
                            }, className: 'btn btn-primary btn-sm' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-check' }),
                        ' '
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { type: 'button', onClick: function onClick() {
                                return _this2.setState({ modal_interruptions: true });
                            }, className: 'btn btn-warning btn-sm' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-clock-o' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */],
                        { show: this.state.modal_interruptions, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Header,
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'h4',
                                { className: 'pull-left' },
                                this.locale.Papeletas.EditarPapeleta.tabelaPendencias.tituloInterrupcoes
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'button',
                                { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                                        return _this2.setState({ modal_interruptions: false });
                                    } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Body,
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'table-responsive' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'table',
                                    { className: 'table table-bordered table-hover table-striped' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'thead',
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'tr',
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'th',
                                                { style: { textAlign: 'center' } },
                                                this.locale.Papeletas.EditarPapeleta.tabelaPendencias.tabelaInterrupcoes.Inicio
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'th',
                                                { style: { textAlign: 'center' } },
                                                this.locale.Papeletas.EditarPapeleta.tabelaPendencias.tabelaInterrupcoes.Fim
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'th',
                                                { style: { textAlign: 'center' } },
                                                this.locale.Papeletas.EditarPapeleta.tabelaPendencias.tabelaInterrupcoes.Total
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'tbody',
                                        null,
                                        Object.keys(self.state.staff_paper_day_interruptions).map(function (k) {
                                            var interruption = self.state.staff_paper_day_interruptions[k];
                                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__StaffPaperPendencyDayInterruptions__["a" /* default */], { handleAlert: self.props.handleAlert, editInterruptions: self.editInterruptions, deleteInterruptions: self.deleteInterruptions, updated: self.state.updated, interruption: interruption, staff_paper_day_id: self.state.id });
                                        }),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'tr',
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'td',
                                                { colSpan: 2, style: { textAlign: 'right', fontWeight: 700 } },
                                                this.locale.Papeletas.EditarPapeleta.tabelaPendencias.tabelaInterrupcoes.Total
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'td',
                                                { style: { textAlign: 'center', fontWeight: 700 } },
                                                self.state.interruption_time
                                            )
                                        )
                                    )
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Footer,
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'button',
                                { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                                        return _this2.setState({ modal_interruptions: false });
                                    } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                            )
                        )
                    )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'td',
                    { className: 'text-center' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { type: 'button', onClick: function onClick() {
                                return _this2.setState({ modal: true });
                            }, className: 'btn btn-info btn-sm' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-plane' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */],
                        { show: this.state.modal, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Header,
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'h4',
                                { className: 'pull-left' },
                                this.locale.Papeletas.EditarPapeleta.tabelaPendencias.tituloEquipamentos
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'button',
                                { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                                        return _this2.setState({ modal: false });
                                    } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Body,
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'div',
                                { className: 'table-responsive' },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'table',
                                    { className: 'table table-bordered table-hover table-striped' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'thead',
                                        null,
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'tr',
                                            null,
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'th',
                                                { style: { textAlign: 'center' } },
                                                this.locale.Papeletas.EditarPapeleta.tabelaPendencias.tabelaEquipamentos.Frota
                                            )
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'tbody',
                                        null,
                                        Object.keys(self.state.staff_paper_day_aircraft_models).map(function (k) {
                                            var spdam = self.state.staff_paper_day_aircraft_models[k];
                                            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'tr',
                                                null,
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'td',
                                                    { style: { textAlign: 'center' } },
                                                    spdam.aircraft_model.model
                                                )
                                            );
                                        })
                                    )
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_3_react_bootstrap__["g" /* Modal */].Footer,
                            null,
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                'button',
                                { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                                        return _this2.setState({ modal: false });
                                    } },
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                            )
                        )
                    )
                )
            );
        }
    }]);

    return StaffPaperPendencyDay;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffPaperPendencyDay);

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_input_mask__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// Helpers de formulário


var StaffPaperPendencyDayInterruptions = function (_Component) {
  _inherits(StaffPaperPendencyDayInterruptions, _Component);

  function StaffPaperPendencyDayInterruptions(props) {
    _classCallCheck(this, StaffPaperPendencyDayInterruptions);

    var _this = _possibleConstructorReturn(this, (StaffPaperPendencyDayInterruptions.__proto__ || Object.getPrototypeOf(StaffPaperPendencyDayInterruptions)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      staff_paper_day_id: _this.props.staff_paper_day_id,
      id: _this.props.interruption.id,
      start: _this.props.interruption.start_str,
      finish: _this.props.interruption.finish_str,
      total: _this.props.interruption.total
    };

    //bind específico
    _this.edit = _this.edit.bind(_this);
    _this.delete = _this.delete.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(StaffPaperPendencyDayInterruptions, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === 0 || this.state.loaded === 1 && newProps.updated === 1) {
        this.setState({
          id: newProps.interruption.id,
          staff_paper_day_id: newProps.staff_paper_day_id,
          start: newProps.interruption.start_str,
          finish: newProps.interruption.finish_str,
          total: newProps.interruption.total,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição

  }, {
    key: 'edit',
    value: function edit() {
      var datasave = {
        staff_paper_day_id: this.state.staff_paper_day_id,
        id: this.state.id,
        start: this.state.start,
        finish: this.state.finish
      };
      this.props.editInterruptions(datasave);
    }
  }, {
    key: 'delete',
    value: function _delete(id) {
      this.props.deleteInterruptions(id);
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'tr',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.state.start
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          null,
          this.state.finish
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'td',
          { style: { textAlign: 'center' } },
          this.state.total
        )
      );
    }
  }]);

  return StaffPaperPendencyDayInterruptions;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffPaperPendencyDayInterruptions);

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var StaffPapersAdd = function (_Component) {
  _inherits(StaffPapersAdd, _Component);

  // constructor
  function StaffPapersAdd(props) {
    _classCallCheck(this, StaffPapersAdd);

    var _this = _possibleConstructorReturn(this, (StaffPapersAdd.__proto__ || Object.getPrototypeOf(StaffPapersAdd)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      month: null,
      staff_id: null,
      date_start: '',
      date_finish: '',
      staffs: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.add = _this.add.bind(_this);
    _this.loadData = _this.loadData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(StaffPapersAdd, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/tripulantes/ativos/lista', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ staffs: responseJson.data });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      this.setState({ overlay: { message: '', type: '', status: 'open' } });
      var datasave = {
        month: this.state.month,
        staff_id: this.state.staff_id
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/papeleta', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var url = '/papeleta/editar/' + responseJson.data.id;
            var storage = {
              alert_message: responseJson.message,
              alert_type: responseJson.status
            };
            localStorage.setItem("verify_message", JSON.stringify(storage));
            self.setState({ redirect_url: url });
          }
          self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.Papeletas.AdicionarPapeleta.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/papeletas/abertas', className: 'btn btn-default pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-left' }),
              ' ',
              this.locale.general.voltar
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.add },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Papeletas.AdicionarPapeleta.formulario.MesAno,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_input_mask___default.a, { value: this.state.month, maskChar: null, name: 'month', mask: '99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'month'), placeholder: '' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Papeletas.AdicionarPapeleta.formulario.Tripulante,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'staff_id',
                      value: this.state.staff_id,
                      searchable: true,
                      placeholder: '',
                      onChange: this.handleSelectChange.bind(this, 'staff_id'),
                      options: this.state.staffs
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                    ' ',
                    this.locale.general.salvar
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return StaffPapersAdd;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffPapersAdd);

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// Importação da tabela



var Done = function (_Component) {
  _inherits(Done, _Component);

  function Done(props) {
    _classCallCheck(this, Done);

    var _this = _possibleConstructorReturn(this, (Done.__proto__ || Object.getPrototypeOf(Done)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.delete = _this.delete.bind(_this);
    _this.deleteRow = _this.deleteRow.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    _this.ActionsButtons = _this.ActionsButtons.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(Done, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/papeletas/finalizadas', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var url = '/papeleta/editar/' + cell;

      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
          { className: 'btn btn-primary btn-sm', to: url },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
        )
      );

      return botao;
    }
  }, {
    key: 'delete',
    value: function _delete(event) {
      var fira_id = event.currentTarget.value;
      var confirm = window.confirm(this.locale.Papeletas.ListaDePapeletasFinalizadas.deletar);
      if (confirm) {
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/papeleta/' + fira_id, { method: 'DELETE', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.deleteRow(fira_id);
            }
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'deleteRow',
    value: function deleteRow(fira_id) {
      var data = this.state.data;
      data.map(function (dado, index) {
        if (dado.id == fira_id) {
          data.splice(index, 1);
        }
      });
      this.setState({ data: data });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.Papeletas.ListaDePapeletasFinalizadas.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Papeletas.ListaDePapeletasFinalizadas.tabela.semPapeletasPendentes }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.Papeletas.ListaDePapeletasFinalizadas.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'staff_name', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.Papeletas.ListaDePapeletasFinalizadas.tabela.Nome
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'staff_inscription', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.Papeletas.ListaDePapeletasFinalizadas.tabela.Matricula
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'month', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.Papeletas.ListaDePapeletasFinalizadas.tabela.Referencia
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '100' },
                this.locale.Papeletas.ListaDePapeletasFinalizadas.tabela.Acoes
              )
            )
          )
        )
      );
    }
  }]);

  return Done;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Done);

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Elements_StaffPaperPendencyDay__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Elements_StaffPaperEditDay__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Elements_StaffPaperApprovals__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











// Tabs





var StaffPapersEdit = function (_Component) {
  _inherits(StaffPapersEdit, _Component);

  function StaffPapersEdit(props) {
    _classCallCheck(this, StaffPapersEdit);

    var _this = _possibleConstructorReturn(this, (StaffPapersEdit.__proto__ || Object.getPrototypeOf(StaffPapersEdit)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      key: 100,
      staff_paper_id: _this.props.match.params.id,
      status: 0,
      staff_paper: {},
      staff: {},
      staff_paper_pendency_days: [],
      staff_paper_days: [],
      schedule_initials_select: [],
      aircraft_models_select: [],
      staff_paper_approvals: [],
      staff_paper_warnings: [],
      staff_alerts: [],
      global_alerts: [],
      modal_alerts: false,
      updated: false
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.exportPdf = _this.exportPdf.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    _this.changeParentState = _this.changeParentState.bind(_this);
    _this.warnings = _this.warnings.bind(_this);
    _this.autoUpdate = _this.autoUpdate.bind(_this);
    _this.updateData = _this.updateData.bind(_this);
    _this.changeUpdate = _this.changeUpdate.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(StaffPapersEdit, [{
    key: 'handleNavTab',
    value: function handleNavTab(state, key) {
      var change = {};
      change[state] = key;
      this.setState(change);
      this.setState({ overlay: { message: '', type: '', status: '' } });
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }

    //LM

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'changeParentState',
    value: function changeParentState(data) {
      this.setState(data);
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/papeleta/info/edicao/' + self.props.match.params.id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url', '/papeletas');
          if (responseJson.status === 'success') {
            self.setState({
              staff_paper: responseJson.data.main,
              status: responseJson.data.main.status,
              staff: responseJson.data.main.staff,
              staff_paper_days: responseJson.data.staff_paper_days,
              staff_paper_pendency_days: responseJson.data.main.staff_paper_pendency_days,
              staff_paper_approvals: responseJson.data.staff_paper_approvals,
              schedule_initials_select: responseJson.data.schedule_initials_select,
              aircraft_models_select: responseJson.data.aircraft_models_select,
              staff_paper_warnings: responseJson.data.staff_paper_warnings
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        });
      });
    }
  }, {
    key: 'exportPdf',
    value: function exportPdf(url) {
      var self = this;
      var header = this.refs.request_api.header('application/json');

      var datasave = {
        id: self.props.match.params.id
      };

      self.handleAlert(this.locale.Papeletas.EditarPapeleta.aguardeEnquantoOArquivoEGerado, 'warning', 'open');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/papeleta/tripulante/pdf', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data;
            self.setState({
              url_export: url
            });
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/tmp/' + responseJson.data);
          }
        });
      });
    }
  }, {
    key: 'warnings',
    value: function warnings() {
      var self = this;
      var url = "/papeletas/alertas/";
      var header = this.refs.request_api.header('application/json');
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ staff_alerts: responseJson.data.staff, global_alerts: responseJson.data.global, modal_alerts: true });
            self.handleAlert('', '', 'closed');
          }
        });
      });
    }
  }, {
    key: 'autoUpdate',
    value: function autoUpdate() {
      var self = this;
      if (window.confirm(this.locale.Papeletas.EditarPapeleta.atualizarAsInformacoes)) {

        var url = "/papeletas/atualizar/";
        var header = this.refs.request_api.header('application/json');
        this.handleAlert('', '', 'open');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url + self.props.match.params.id, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'url');
            if (responseJson.status === 'success') {
              self.setState({
                staff_paper: responseJson.data.staff_paper,
                status: responseJson.data.staff_paper.status,
                staff: responseJson.data.staff_paper.staff,
                staff_paper_days: responseJson.data.staff_paper_days,
                staff_paper_pendency_days: responseJson.data.staff_paper.staff_paper_pendency_days,
                updated: true
              });
              self.handleAlert(responseJson.message, responseJson.status, 'open');
            }
          });
        });
      }
    }
  }, {
    key: 'updateData',
    value: function updateData(responseJson) {
      this.setState({
        staff_paper: responseJson.data,
        status: responseJson.data.status,
        staff: responseJson.data.staff,
        staff_paper_days: responseJson.data.staff_paper_days,
        staff_paper_pendency_days: responseJson.data.staff_paper_pendency_days,
        updated: true
      });

      this.handleAlert(responseJson.message, responseJson.status, 'open');
    }
  }, {
    key: 'changeUpdate',
    value: function changeUpdate(responseJson) {
      this.setState({
        updated: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.Papeletas.EditarPapeleta.titulo,
              ' - ',
              self.state.staff.name,
              ' - ',
              self.state.staff_paper.month
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'grid-buttons pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { onClick: function onClick() {
                    return self.autoUpdate();
                  }, className: 'btn btn-success' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-refresh' }),
                '  ',
                this.locale.Papeletas.EditarPapeleta.botaoAtualizar
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { onClick: function onClick() {
                    _this2.exportPdf();
                  }, className: 'btn btn-info' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' }),
                ' ',
                this.locale.general.exportarPDF
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { onClick: function onClick() {
                    return self.warnings();
                  }, className: 'btn btn-warning' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-warning' }),
                '  ',
                this.locale.Papeletas.EditarPapeleta.botaoAlertas
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
                { to: '/papeletas/abertas', className: 'btn btn-default' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-left' }),
                ' ',
                this.locale.general.voltar
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            this.state.staff_paper.completed === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Elements_StaffPaperApprovals__["a" /* default */], { handleAlert: this.handleAlert, staff_paper_id: this.props.match.params.id, staff_paper_approvals: this.state.staff_paper_approvals, staff_paper: this.state.staff_paper, changeParentState: self.changeParentState }) : '',
            self.state.staff_paper_pendency_days.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h3',
                { className: 'page-title' },
                this.locale.Papeletas.EditarPapeleta.tituloPendencias
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'table-responsive' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'table',
                  { className: 'table table-bordered table-papers-main table-hover table-striped' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'thead',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { rowSpan: 2, style: { width: "100px" }, className: 'text-center vcenter' },
                        this.locale.Papeletas.EditarPapeleta.tabelaPendencias.Data
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { colSpan: 2, style: { width: "310px" }, className: 'text-center vcenter' },
                        this.locale.Papeletas.EditarPapeleta.tabelaPendencias.Localidades
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { rowSpan: 2, style: { width: "155px" }, className: 'text-center vcenter' },
                        this.locale.Papeletas.EditarPapeleta.tabelaPendencias.Situacao
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { colSpan: 6, style: { width: "1200px" }, className: 'text-center vcenter' },
                        this.locale.Papeletas.EditarPapeleta.tabelaPendencias.Horarios
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { colSpan: 3, style: { width: "360px" }, className: 'text-center vcenter' },
                        this.locale.Papeletas.EditarPapeleta.tabelaPendencias.Totais
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { rowSpan: 2, style: { width: "50px" }, className: 'text-center' }),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { rowSpan: 2, style: { width: "50px" }, className: 'text-center' }),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { rowSpan: 2, style: { width: "50px" }, className: 'text-center' })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { style: { width: "155px" }, className: 'text-center vcenter' },
                        this.locale.Papeletas.EditarPapeleta.tabelaPendencias.Apresentacao
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { style: { width: "155px" }, className: 'text-center vcenter' },
                        this.locale.Papeletas.EditarPapeleta.tabelaPendencias.Liberacao
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { style: { width: "200px" }, className: 'text-center vcenter' },
                        this.locale.Papeletas.EditarPapeleta.tabelaPendencias.Apresentacao
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { style: { width: "200px" }, className: 'text-center vcenter' },
                        this.locale.Papeletas.EditarPapeleta.tabelaPendencias.InicioDaRefeicao
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { style: { width: "200px" }, className: 'text-center vcenter' },
                        this.locale.Papeletas.EditarPapeleta.tabelaPendencias.TerminoDaRefeicao
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { style: { width: "200px" }, className: 'text-center vcenter' },
                        this.locale.Papeletas.EditarPapeleta.tabelaPendencias.InicioDaSegundaRefeicao
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { style: { width: "200px" }, className: 'text-center vcenter' },
                        this.locale.Papeletas.EditarPapeleta.tabelaPendencias.TerminoDaSegundaRefeicao
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { style: { width: "200px" }, className: 'text-center vcenter' },
                        this.locale.Papeletas.EditarPapeleta.tabelaPendencias.Liberacao
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { style: { width: "120px" }, className: 'text-center vcenter' },
                        this.locale.Papeletas.EditarPapeleta.tabelaPendencias.HorasDeJornada
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { style: { width: "120px" }, className: 'text-center vcenter' },
                        this.locale.Papeletas.EditarPapeleta.tabelaPendencias.VooNoturno
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { style: { width: "120px" }, className: 'text-center vcenter' },
                        this.locale.Papeletas.EditarPapeleta.tabelaPendencias.VooTotal
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tbody',
                    null,
                    Object.keys(self.state.staff_paper_pendency_days).map(function (k) {
                      var day = self.state.staff_paper_pendency_days[k];
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Elements_StaffPaperPendencyDay__["a" /* default */], { RequestApi: self.refs.request_api, handleAlert: self.handleAlert, changeUpdate: self.changeUpdate, updated: self.state.updated, updateData: self.updateData, staff_paper_id: self.props.match.params.id, day: day, schedule_initials_select: self.state.schedule_initials_select, aircraft_models_select: self.state.aircraft_models_select, status: self.state.status });
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null)
            ) : '',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.Papeletas.EditarPapeleta.tituloPapeleta
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'table-responsive' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'table table-bordered table-papers-main table-hover table-striped' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { rowSpan: 2, style: { width: "100px" }, className: 'text-center vcenter' },
                      this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.Data
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { colSpan: 2, style: { width: "310px" }, className: 'text-center vcenter' },
                      this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.Localidades
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { rowSpan: 2, style: { width: "155px" }, className: 'text-center vcenter' },
                      this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.Situacao
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { colSpan: 12, style: { width: "2400px" }, className: 'text-center vcenter' },
                      this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.Horarios
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { colSpan: 3, style: { width: "360px" }, className: 'text-center vcenter' },
                      this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.Totais
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { rowSpan: 2, style: { width: "50px" }, className: 'text-center' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { rowSpan: 2, style: { width: "50px" }, className: 'text-center' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { rowSpan: 2, style: { width: "50px" }, className: 'text-center' }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { rowSpan: 2, style: { width: "50px" }, className: 'text-center' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "155px" }, className: 'text-center vcenter' },
                      this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.Apresentacao
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "155px" }, className: 'text-center vcenter' },
                      this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.Liberacao
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "200px" }, className: 'text-center vcenter' },
                      this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.ApresentacaoData
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "200px" }, className: 'text-center vcenter' },
                      this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.ApresentacaoHora
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "200px" }, className: 'text-center vcenter' },
                      this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.InicioDaRefeicaoData
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "200px" }, className: 'text-center vcenter' },
                      this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.InicioDaRefeicaoHora
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "200px" }, className: 'text-center vcenter' },
                      this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.TerminoDaRefeicaoData
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "200px" }, className: 'text-center vcenter' },
                      this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.TerminoDaRefeicaoHora
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "200px" }, className: 'text-center vcenter' },
                      this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.InicioDaSegundaRefeicaoData
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "200px" }, className: 'text-center vcenter' },
                      this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.InicioDaSegundaRefeicaoHora
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "200px" }, className: 'text-center vcenter' },
                      this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.InicioDaSegundaRefeicaoData
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "200px" }, className: 'text-center vcenter' },
                      this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.TerminoDaSegundaRefeicaoHora
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "200px" }, className: 'text-center vcenter' },
                      this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.LiberacaoData
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "200px" }, className: 'text-center vcenter' },
                      this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.Liberacaohora
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "120px" }, className: 'text-center vcenter' },
                      this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.HorasDeJornada
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "120px" }, className: 'text-center vcenter' },
                      this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.VooNoturno
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "120px" }, className: 'text-center vcenter' },
                      this.locale.Papeletas.EditarPapeleta.tabelaPapeleta.VooTotal
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  null,
                  Object.keys(self.state.staff_paper_days).map(function (k) {
                    var day = self.state.staff_paper_days[k];
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Elements_StaffPaperEditDay__["a" /* default */], { handleAlert: self.handleAlert, changeUpdate: self.changeUpdate, updated: self.state.updated, updateData: self.updateData, staff_paper_id: self.props.match.params.id, day: day, schedule_initials_select: self.state.schedule_initials_select, aircraft_models_select: self.state.aircraft_models_select, status: self.state.status });
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.Papeletas.EditarPapeleta.tituloAlertasDoRelatorio
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'table-responsive' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'table table-bordered table-hover table-striped' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      null,
                      this.locale.Papeletas.EditarPapeleta.tabelaAlertasDoRelatorio.Mensagem
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  null,
                  Object.keys(self.state.staff_paper_warnings).map(function (k) {
                    var spw = self.state.staff_paper_warnings[k];
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { className: "box-alert box-alert-" + spw.color },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: spw.message } })
                      )
                    );
                  })
                )
              )
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal_alerts, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                this.locale.Papeletas.EditarPapeleta.tituloAlertas
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ modal_alerts: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Body,
            null,
            Object.keys(self.state.staff_alerts).map(function (nickname) {
              var alerts = self.state.staff_alerts[nickname];
              return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                Object.keys(alerts).map(function (k) {

                  var alert = alerts[k];
                  if (alert !== null && alert.error === 1) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: "box-alert box-alert-" + alert.color },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { dangerouslySetInnerHTML: { __html: alert.message } })
                    );
                  }
                })
              );
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ modal_alerts: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return StaffPapersEdit;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffPapersEdit);

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// Importação da tabela



var StaffPapersIndex = function (_Component) {
  _inherits(StaffPapersIndex, _Component);

  function StaffPapersIndex(props) {
    _classCallCheck(this, StaffPapersIndex);

    var _this = _possibleConstructorReturn(this, (StaffPapersIndex.__proto__ || Object.getPrototypeOf(StaffPapersIndex)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      current: '',
      next: '',
      previous: ''
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.delete = _this.delete.bind(_this);
    _this.deleteRow = _this.deleteRow.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.next = _this.next.bind(_this);
    _this.previous = _this.previous.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(StaffPapersIndex, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        var now = new Date();
        var year = now.getFullYear();
        var reference = year;
        this.setState({ loaded: 2 }, this.loadData(reference));
      }
    }
  }, {
    key: 'loadData',
    value: function loadData(reference) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/papeletas/portal/' + reference, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data.index_data, current: responseJson.data.current, previous: responseJson.data.previous, next: responseJson.data.next, array_hide: responseJson.data.array_hide });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var url = '/papeleta/editar/' + cell;

      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
          { className: 'btn btn-primary btn-sm', to: url },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-sm btn-danger', value: cell, onClick: this.delete },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-trash' })
        )
      );

      return botao;
    }
  }, {
    key: 'delete',
    value: function _delete(event) {
      var fira_id = event.currentTarget.value;
      var confirm = window.confirm(this.locale.Papeletas.ListaDePapeletas.deletar);
      if (confirm) {
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/papeleta/' + fira_id, { method: 'DELETE', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.deleteRow(fira_id);
            }
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'deleteRow',
    value: function deleteRow(fira_id) {
      var data = this.state.data;
      data.map(function (dado, index) {
        if (dado.id == fira_id) {
          data.splice(index, 1);
        }
      });
      this.setState({ data: data });
    }
  }, {
    key: 'next',
    value: function next() {
      this.setState({ overlay: { message: '', type: '', status: 'open' } });
      this.loadData(this.state.next);
    }
  }, {
    key: 'previous',
    value: function previous() {
      this.setState({ overlay: { message: '', type: '', status: 'open' } });
      this.loadData(this.state.previous);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-primary', onClick: this.previous },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-chevron-left' }),
                  ' ',
                  this.state.previous
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-4' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h3',
                  { className: 'page-title text-center' },
                  this.state.current
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-4 text-right' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-primary', onClick: this.next },
                  this.state.next,
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-chevron-right' })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.Papeletas.ListaDePapeletas.titulo,
              ' '
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Papeletas.ListaDePapeletas.tabela.semPapeletas }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.Papeletas.ListaDePapeletas.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'staff_name', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '240' },
                this.locale.Papeletas.ListaDePapeletas.tabela.Nome
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'staff_inscription', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Papeletas.ListaDePapeletas.tabela.Matricula
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'month', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Papeletas.ListaDePapeletas.tabela.Referencia
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'status_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Papeletas.ListaDePapeletas.tabela.Status
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '100' },
                this.locale.Papeletas.ListaDePapeletas.tabela.Acoes
              )
            )
          )
        )
      );
    }
  }]);

  return StaffPapersIndex;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffPapersIndex);

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// Importação da tabela



var StaffPapersManager = function (_Component) {
  _inherits(StaffPapersManager, _Component);

  function StaffPapersManager(props) {
    _classCallCheck(this, StaffPapersManager);

    var _this = _possibleConstructorReturn(this, (StaffPapersManager.__proto__ || Object.getPrototypeOf(StaffPapersManager)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.delete = _this.delete.bind(_this);
    _this.deleteRow = _this.deleteRow.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    _this.ActionsButtons = _this.ActionsButtons.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(StaffPapersManager, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/papeletas/gestor', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var url = '/papeleta/editar/' + cell;

      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
          { className: 'btn btn-primary btn-sm', to: url },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
        )
      );

      return botao;
    }
  }, {
    key: 'delete',
    value: function _delete(event) {
      var fira_id = event.currentTarget.value;
      var confirm = window.confirm(this.locale.Papeletas.ListaDePapeletasPendentesGestor.deletar);
      if (confirm) {
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/papeleta/' + fira_id, { method: 'DELETE', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.deleteRow(fira_id);
            }
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'deleteRow',
    value: function deleteRow(fira_id) {
      var data = this.state.data;
      data.map(function (dado, index) {
        if (dado.id == fira_id) {
          data.splice(index, 1);
        }
      });
      this.setState({ data: data });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.Papeletas.ListaDePapeletasPendentesGestor.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Papeletas.ListaDePapeletasPendentesGestor.tabela.semPapeletasPendentes }, search: true, multiColumnSearch: true, searchPlaceholder: this.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.Papeletas.ListaDePapeletasPendentesGestor.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'staff_name', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.general.procurar } },
                this.locale.Papeletas.ListaDePapeletasPendentesGestor.tabela.Nome
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'staff_inscription', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.general.procurar } },
                this.locale.Papeletas.ListaDePapeletasPendentesGestor.tabela.Matricula
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'month', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.general.procurar } },
                this.locale.Papeletas.ListaDePapeletasPendentesGestor.tabela.Referencia
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '100' },
                this.locale.Papeletas.ListaDePapeletasPendentesGestor.tabela.Acoes
              )
            )
          )
        )
      );
    }
  }]);

  return StaffPapersManager;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffPapersManager);

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// Helpers de formulário



var ToogleCheckedIncident = function (_Component) {
  _inherits(ToogleCheckedIncident, _Component);

  function ToogleCheckedIncident(props) {
    _classCallCheck(this, ToogleCheckedIncident);

    var _this = _possibleConstructorReturn(this, (ToogleCheckedIncident.__proto__ || Object.getPrototypeOf(ToogleCheckedIncident)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      update: false,
      report_incident: _this.props.report_incident,
      actual_checked: _this.props.actual_checked
    };

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(ToogleCheckedIncident, [{
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      var fatigue_event = this.state.report_incident.fatigue_event;
      if (event.target.checked === true) {
        var value = true;
      } else {
        var value = false;
      }
      change[name] = value;
      this.checkFadiga(change, fatigue_event);
    }
  }, {
    key: 'checkFadiga',
    value: function checkFadiga(change, fatigue_event) {
      if (window.confirm(this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.marcarEsteIncidenteComoChecado)) {
        this.props.handleAlert('', '', 'open');
        var header = this.props.RequestApi.header('application/json');
        var self = this;
        var url = '/fadiga/voluntaria/arquivar/' + this.state.report_incident.id;
        var requisition_method = 'PUT';
        if (fatigue_event !== 5) {
          var url = '/relatorio-de-fadiga/tripulante/checkar/' + this.state.report_incident.id;
          var requisition_method = 'GET';
        }
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url, { method: requisition_method, mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.props.RequestApi.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.setState(change);
              self.props.updateReports();
            }
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.state.loaded === false && typeof newProps.report_incident !== 'undefined') {
        this.setState({
          actual_checked: newProps.actual_checked,
          report_incident: newProps.report_incident,
          loaded: true,
          update: false
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_toggle___default.a, {
          checked: this.state.actual_checked,
          'aria-label': 'No label tag',
          name: 'actual_checked',
          disabled: this.state.actual_checked == true ? true : false,
          onChange: this.handleToggleChange.bind(this, 'actual_checked')
        })
      );
    }
  }]);

  return ToogleCheckedIncident;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ToogleCheckedIncident);

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_recharts__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var FatigueAdd = function (_Component) {
  _inherits(FatigueAdd, _Component);

  // constructor
  function FatigueAdd(props) {
    _classCallCheck(this, FatigueAdd);

    var _this = _possibleConstructorReturn(this, (FatigueAdd.__proto__ || Object.getPrototypeOf(FatigueAdd)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      simulated: 0,
      applicabilities_list: [],
      data: [],
      data_reports: null,
      key: 1,
      date_start_str: '',
      date_finish_str: '',
      quantity_points: '',
      modal: false
    };

    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.add = _this.add.bind(_this);
    _this.addFatigue = _this.addFatigue.bind(_this);
    _this.copytoNextDate = _this.copytoNextDate.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(FatigueAdd, [{
    key: 'handleChangeData',
    value: function handleChangeData(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(date_str, event) {
      var change = {};
      var data_temp = [];
      var data_temp_inputs = [];
      var self = this;
      Object.keys(self.state.data).map(function (date) {
        data_temp[date] = {};
        data_temp[date].date_str = self.state.data[date].date_str;
        data_temp[date].quantity_points = self.state.data[date].quantity_points;
        data_temp_inputs = [];
        if (self.state.data[date].date_str === date_str) {
          data_temp[date].day_off = event.target.checked;
        } else {
          data_temp[date].day_off = self.state.data[date].day_off;
        }
        Object.keys(self.state.data[date].inputs).map(function (info) {
          change = {
            value: self.state.data[date].inputs[info].value,
            id: self.state.data[date].inputs[info].id,
            name: self.state.data[date].inputs[info].name,
            type_str: self.state.data[date].inputs[info].type_str,
            type: self.state.data[date].inputs[info].type,
            fatigue_options: self.state.data[date].inputs[info].fatigue_options,
            operator: self.state.data[date].inputs[info].operator,
            hour_points: self.state.data[date].inputs[info].hour_points,
            quantity_points: self.state.data[date].inputs[info].quantity_points,
            point_limit: self.state.data[date].inputs[info].point_limit,
            required: self.state.data[date].inputs[info].required,
            max_points: self.state.data[date].inputs[info].max_points,
            min_points: self.state.data[date].inputs[info].min_points,
            aps_day: self.state.data[date].inputs[info].aps_day,
            hours_day: self.state.data[date].inputs[info].hours_day,
            nocturnal_extra_points: self.state.data[date].inputs[info].nocturnal_extra_points,
            reduction_points: self.state.data[date].inputs[info].reduction_points,
            extra_hours: self.state.data[date].inputs[info].extra_hours,
            automation_type: self.state.data[date].inputs[info].automation_type,
            limit_extra_hours_week: self.state.data[date].inputs[info].limit_extra_hours_week,
            limit_extra_hours_month: self.state.data[date].inputs[info].limit_extra_hours_month,
            day_limit_extra_hours_week: self.state.data[date].inputs[info].day_limit_extra_hours_week,
            day_limit_extra_hours_month: self.state.data[date].inputs[info].day_limit_extra_hours_month
          };
          data_temp_inputs.push(change);
        });
        data_temp[date].inputs = data_temp_inputs;
      });
      this.setState({ data: data_temp });
    }
  }, {
    key: 'handleFatigueChange',
    value: function handleFatigueChange(name, date_str, event) {
      var change = {};
      var data_temp = [];
      var data_temp_inputs = [];
      var self = this;
      Object.keys(self.state.data).map(function (date) {
        data_temp[date] = {};
        data_temp[date].date_str = self.state.data[date].date_str;
        data_temp[date].quantity_points = self.state.data[date].quantity_points;
        data_temp[date].day_off = self.state.data[date].day_off;
        data_temp_inputs = [];
        Object.keys(self.state.data[date].inputs).map(function (info) {
          if (self.state.data[date].inputs[info].id === name && self.state.data[date].date_str === date_str) {
            change = {
              value: event.target.value,
              id: self.state.data[date].inputs[info].id,
              name: self.state.data[date].inputs[info].name,
              type_str: self.state.data[date].inputs[info].type_str,
              type: self.state.data[date].inputs[info].type,
              fatigue_options: self.state.data[date].inputs[info].fatigue_options,
              operator: self.state.data[date].inputs[info].operator,
              hour_points: self.state.data[date].inputs[info].hour_points,
              quantity_points: self.state.data[date].inputs[info].quantity_points,
              point_limit: self.state.data[date].inputs[info].point_limit,
              required: self.state.data[date].inputs[info].required,
              max_points: self.state.data[date].inputs[info].max_points,
              min_points: self.state.data[date].inputs[info].min_points,
              aps_day: self.state.data[date].inputs[info].aps_day,
              hours_day: self.state.data[date].inputs[info].hours_day,
              nocturnal_extra_points: self.state.data[date].inputs[info].nocturnal_extra_points,
              reduction_points: self.state.data[date].inputs[info].reduction_points,
              extra_hours: self.state.data[date].inputs[info].extra_hours,
              automation_type: self.state.data[date].inputs[info].automation_type,
              limit_extra_hours_week: self.state.data[date].inputs[info].limit_extra_hours_week,
              limit_extra_hours_month: self.state.data[date].inputs[info].limit_extra_hours_month,
              day_limit_extra_hours_week: self.state.data[date].inputs[info].day_limit_extra_hours_week,
              day_limit_extra_hours_month: self.state.data[date].inputs[info].day_limit_extra_hours_month
            };
          } else {
            change = {
              value: self.state.data[date].inputs[info].value,
              id: self.state.data[date].inputs[info].id,
              name: self.state.data[date].inputs[info].name,
              type_str: self.state.data[date].inputs[info].type_str,
              type: self.state.data[date].inputs[info].type,
              fatigue_options: self.state.data[date].inputs[info].fatigue_options,
              operator: self.state.data[date].inputs[info].operator,
              hour_points: self.state.data[date].inputs[info].hour_points,
              quantity_points: self.state.data[date].inputs[info].quantity_points,
              point_limit: self.state.data[date].inputs[info].point_limit,
              required: self.state.data[date].inputs[info].required,
              max_points: self.state.data[date].inputs[info].max_points,
              min_points: self.state.data[date].inputs[info].min_points,
              aps_day: self.state.data[date].inputs[info].aps_day,
              hours_day: self.state.data[date].inputs[info].hours_day,
              nocturnal_extra_points: self.state.data[date].inputs[info].nocturnal_extra_points,
              reduction_points: self.state.data[date].inputs[info].reduction_points,
              extra_hours: self.state.data[date].inputs[info].extra_hours,
              automation_type: self.state.data[date].inputs[info].automation_type,
              limit_extra_hours_week: self.state.data[date].inputs[info].limit_extra_hours_week,
              limit_extra_hours_month: self.state.data[date].inputs[info].limit_extra_hours_month,
              day_limit_extra_hours_week: self.state.data[date].inputs[info].day_limit_extra_hours_week,
              day_limit_extra_hours_month: self.state.data[date].inputs[info].day_limit_extra_hours_month
            };
          }
          data_temp_inputs.push(change);
        });
        data_temp[date].inputs = data_temp_inputs;
      });
      this.setState({ data: data_temp });
    }
  }, {
    key: 'handleSelectFatigueChange',
    value: function handleSelectFatigueChange(name, date_str, event) {
      var change = {};
      var data_temp = [];
      var data_temp_inputs = [];
      var self = this;
      Object.keys(self.state.data).map(function (date) {
        data_temp[date] = {};
        data_temp[date].date_str = self.state.data[date].date_str;
        data_temp[date].quantity_points = self.state.data[date].quantity_points;
        data_temp[date].day_off = self.state.data[date].day_off;
        data_temp_inputs = [];
        Object.keys(self.state.data[date].inputs).map(function (info) {
          if (self.state.data[date].inputs[info].id === name && self.state.data[date].date_str === date_str) {
            change = {
              value: event.value,
              id: self.state.data[date].inputs[info].id,
              name: self.state.data[date].inputs[info].name,
              type_str: self.state.data[date].inputs[info].type_str,
              type: self.state.data[date].inputs[info].type,
              fatigue_options: self.state.data[date].inputs[info].fatigue_options,
              operator: self.state.data[date].inputs[info].operator,
              hour_points: self.state.data[date].inputs[info].hour_points,
              quantity_points: self.state.data[date].inputs[info].quantity_points,
              point_limit: self.state.data[date].inputs[info].point_limit,
              required: self.state.data[date].inputs[info].required,
              max_points: self.state.data[date].inputs[info].max_points,
              min_points: self.state.data[date].inputs[info].min_points,
              aps_day: self.state.data[date].inputs[info].aps_day,
              hours_day: self.state.data[date].inputs[info].hours_day,
              nocturnal_extra_points: self.state.data[date].inputs[info].nocturnal_extra_points,
              reduction_points: self.state.data[date].inputs[info].reduction_points,
              extra_hours: self.state.data[date].inputs[info].extra_hours,
              automation_type: self.state.data[date].inputs[info].automation_type,
              limit_extra_hours_week: self.state.data[date].inputs[info].limit_extra_hours_week,
              limit_extra_hours_month: self.state.data[date].inputs[info].limit_extra_hours_month,
              day_limit_extra_hours_week: self.state.data[date].inputs[info].day_limit_extra_hours_week,
              day_limit_extra_hours_month: self.state.data[date].inputs[info].day_limit_extra_hours_month
            };
          } else {
            change = {
              value: self.state.data[date].inputs[info].value,
              id: self.state.data[date].inputs[info].id,
              name: self.state.data[date].inputs[info].name,
              type_str: self.state.data[date].inputs[info].type_str,
              type: self.state.data[date].inputs[info].type,
              fatigue_options: self.state.data[date].inputs[info].fatigue_options,
              operator: self.state.data[date].inputs[info].operator,
              hour_points: self.state.data[date].inputs[info].hour_points,
              quantity_points: self.state.data[date].inputs[info].quantity_points,
              point_limit: self.state.data[date].inputs[info].point_limit,
              required: self.state.data[date].inputs[info].required,
              max_points: self.state.data[date].inputs[info].max_points,
              min_points: self.state.data[date].inputs[info].min_points,
              aps_day: self.state.data[date].inputs[info].aps_day,
              hours_day: self.state.data[date].inputs[info].hours_day,
              nocturnal_extra_points: self.state.data[date].inputs[info].nocturnal_extra_points,
              reduction_points: self.state.data[date].inputs[info].reduction_points,
              extra_hours: self.state.data[date].inputs[info].extra_hours,
              automation_type: self.state.data[date].inputs[info].automation_type,
              limit_extra_hours_week: self.state.data[date].inputs[info].limit_extra_hours_week,
              limit_extra_hours_month: self.state.data[date].inputs[info].limit_extra_hours_month,
              day_limit_extra_hours_week: self.state.data[date].inputs[info].day_limit_extra_hours_week,
              day_limit_extra_hours_month: self.state.data[date].inputs[info].day_limit_extra_hours_month
            };
          }
          data_temp_inputs.push(change);
        });
        data_temp[date].inputs = data_temp_inputs;
      });
      this.setState({ data: data_temp });
    }

    // Handlers

  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleNavTab',
    value: function handleNavTab(state, key) {
      var change = {};
      change[state] = key;
      this.setState(change);
      this.setState({ overlay: { message: '', type: '', status: '' } });
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleSelectChangeApplicability',
    value: function handleSelectChangeApplicability(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios-de-fadiga/listagens';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              applicabilities_list: responseJson.data.applicabilities_list
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
        }); /* Overlay */
      });
    }
  }, {
    key: 'copytoNextDate',
    value: function copytoNextDate(event) {
      //Data que ta sendo copiado os dados
      var this_date = event.currentTarget.value;
      var self = this;
      this.handleAlert('', '', 'open');
      var copy_data = [];
      var day_off = false;
      //Itero todas as datas afim de achar qual está sendo copiada
      Object.keys(self.state.data).map(function (date) {
        if (self.state.data[date].date_str === this_date) {
          day_off = self.state.data[date].day_off;
          Object.keys(self.state.data[date].inputs).map(function (info) {
            copy_data[info] = {};
            copy_data[info].value = self.state.data[date].inputs[info].value;
            copy_data[info].id = self.state.data[date].inputs[info].id;
          });
        }
      });

      var change = {};
      var data_temp = [];
      var data_temp_inputs = [];
      Object.keys(self.state.data).map(function (date) {
        data_temp[date] = {};
        data_temp[date].date_str = self.state.data[date].date_str;
        data_temp[date].quantity_points = self.state.data[date].quantity_points;
        data_temp[date].day_off = day_off;
        data_temp_inputs = [];
        Object.keys(self.state.data[date].inputs).map(function (info) {
          Object.keys(copy_data).map(function (k) {
            if (self.state.data[date].date_str > this_date) {
              if (self.state.data[date].inputs[info].id === copy_data[k].id) {
                change = {
                  value: copy_data[k].value,
                  id: self.state.data[date].inputs[info].id,
                  name: self.state.data[date].inputs[info].name,
                  type_str: self.state.data[date].inputs[info].type_str,
                  day_off: self.state.data[date].inputs[info].day_off,
                  type: self.state.data[date].inputs[info].type,
                  fatigue_options: self.state.data[date].inputs[info].fatigue_options,
                  operator: self.state.data[date].inputs[info].operator,
                  hour_points: self.state.data[date].inputs[info].hour_points,
                  quantity_points: self.state.data[date].inputs[info].quantity_points,
                  point_limit: self.state.data[date].inputs[info].point_limit,
                  required: self.state.data[date].inputs[info].required,
                  max_points: self.state.data[date].inputs[info].max_points,
                  min_points: self.state.data[date].inputs[info].min_points,
                  aps_day: self.state.data[date].inputs[info].aps_day,
                  hours_day: self.state.data[date].inputs[info].hours_day,
                  nocturnal_extra_points: self.state.data[date].inputs[info].nocturnal_extra_points,
                  reduction_points: self.state.data[date].inputs[info].reduction_points,
                  extra_hours: self.state.data[date].inputs[info].extra_hours,
                  automation_type: self.state.data[date].inputs[info].automation_type,
                  limit_extra_hours_week: self.state.data[date].inputs[info].limit_extra_hours_week,
                  limit_extra_hours_month: self.state.data[date].inputs[info].limit_extra_hours_month,
                  day_limit_extra_hours_week: self.state.data[date].inputs[info].day_limit_extra_hours_week,
                  day_limit_extra_hours_month: self.state.data[date].inputs[info].day_limit_extra_hours_month

                };
              }
            } else {
              change = {
                value: self.state.data[date].inputs[info].value,
                id: self.state.data[date].inputs[info].id,
                name: self.state.data[date].inputs[info].name,
                type_str: self.state.data[date].inputs[info].type_str,
                day_off: self.state.data[date].inputs[info].day_off,
                type: self.state.data[date].inputs[info].type,
                fatigue_options: self.state.data[date].inputs[info].fatigue_options,
                operator: self.state.data[date].inputs[info].operator,
                hour_points: self.state.data[date].inputs[info].hour_points,
                quantity_points: self.state.data[date].inputs[info].quantity_points,
                point_limit: self.state.data[date].inputs[info].point_limit,
                required: self.state.data[date].inputs[info].required,
                max_points: self.state.data[date].inputs[info].max_points,
                min_points: self.state.data[date].inputs[info].min_points,
                aps_day: self.state.data[date].inputs[info].aps_day,
                hours_day: self.state.data[date].inputs[info].hours_day,
                nocturnal_extra_points: self.state.data[date].inputs[info].nocturnal_extra_points,
                reduction_points: self.state.data[date].inputs[info].reduction_points,
                extra_hours: self.state.data[date].inputs[info].extra_hours,
                automation_type: self.state.data[date].inputs[info].automation_type,
                limit_extra_hours_week: self.state.data[date].inputs[info].limit_extra_hours_week,
                limit_extra_hours_month: self.state.data[date].inputs[info].limit_extra_hours_month,
                day_limit_extra_hours_week: self.state.data[date].inputs[info].day_limit_extra_hours_week,
                day_limit_extra_hours_month: self.state.data[date].inputs[info].day_limit_extra_hours_month
              };
            }
          });
          data_temp_inputs.push(change);
        });
        data_temp[date].inputs = data_temp_inputs;
      });
      setTimeout(function () {
        self.setState({ overlay: { message: "", type: "", status: 'closed' }, data: data_temp });
      }, 1000);
    }
  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        date_start_str: this.state.date_start_str,
        date_finish_str: this.state.date_finish_str,
        quantity_points: this.state.quantity_points,
        applicability_id: this.state.applicability_id
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/gerar/simulador/relatorios-de-fadiga', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data, simulated: 1 });
          }
          self.setState({ overlay: { message: "", type: "", status: 'closed' } });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'addFatigue',
    value: function addFatigue(event) {
      event.preventDefault();
      //this.handleAlert('', '', 'open');
      var email = localStorage.getItem("data");
      var cid = localStorage.getItem("cid");
      var storage = JSON.parse(cid);
      var datasave = {
        data: this.state.data,
        applicability_id: this.state.applicability_id
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/simular/relatorios-de-fadiga', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data_reports: responseJson.data, modal: true });
          }
          self.setState({ overlay: { message: "", type: "", status: 'closed' } });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      var e_key = 0;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/parametros-de-fadiga', className: 'btn btn-default pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-left' }),
              ' ',
              this.locale.general.voltar
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.add },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.formulario.DataInicial,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_input_mask___default.a, { value: this.state.date_start_str, required: true, maskChar: null, name: 'date_start_str', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start_str'), placeholder: '' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.formulario.DataFinal,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_input_mask___default.a, { value: this.state.date_finish_str, required: true, maskChar: null, name: 'date_finish_str', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish_str'), placeholder: '' })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.formulario.AplicabilidadeTipoDeColaborador,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'applicability_id',
                      value: this.state.applicability_id,
                      searchable: true,
                      placeholder: this.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.formulario.placeholder.SelecionarAplicabilidade,
                      onChange: this.handleSelectChangeApplicability.bind(this, 'applicability_id'),
                      options: this.state.applicabilities_list
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.formulario.QuantidadeDePontos,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'quantity_points', className: 'form-control', placeholder: '', value: this.state.quantity_points, onChange: this.handleChange.bind(this, 'quantity_points') })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                    ' ',
                    this.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.formulario.botaoGerarSimulacaoDeRelatoriosDeFadiga
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            self.state.simulated === 0 ? "" : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["e" /* Tabs */],
              { activeKey: this.state.key, onSelect: this.handleNavTab.bind(this, 'key'), id: 'controlled-tab-example' },
              Object.keys(self.state.data).map(function (k) {
                {
                  e_key++;
                }
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["f" /* Tab */],
                  { eventKey: e_key, title: self.state.data[k].date_str },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { onClick: self.addFatigue, className: 'btn btn-primary btn-lg btn-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                    ' ',
                    self.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.tabDatas.botaoGerarRelatoriosDeFadiga
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { className: 'btn btn-lg btn-info btn-block', value: self.state.data[k].date_str, onClick: self.copytoNextDate },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-chevron-right' }),
                    ' ',
                    self.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.tabDatas.botaoCopiarParaProximasDatas
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'form',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        self.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.tabDatas.formulario.MarcarComoFolga,
                        '??'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
                        checked: self.state.data[k].day_off,
                        'aria-label': 'No label tag',
                        name: 'day_off',
                        onChange: self.handleToggleChange.bind(self, self.state.data[k].date_str) })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        self.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.tabDatas.formulario.Data,
                        ':'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_input_mask___default.a, { value: self.state.data[k].date_str, required: true, maskChar: null, name: 'date_str', disabled: 'disabled', mask: '99/99/9999', className: 'form-control', onChange: self.handleChangeData.bind(self, 'date_str'), placeholder: '' })
                    ),
                    Object.keys(self.state.data[k].inputs).map(function (ki) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'form-group' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'label',
                          null,
                          self.state.data[k].inputs[ki].name + " - " + self.state.data[k].inputs[ki].type_str
                        ),
                        self.state.data[k].inputs[ki].type === 'options' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                          className: 'form-field-name',
                          name: 'type',
                          value: self.state.data[k].inputs[ki].value,
                          searchable: true,
                          placeholder: self.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.tabDatas.formulario.placeholder.SelecionarOpcao,
                          onChange: self.handleSelectFatigueChange.bind(self, self.state.data[k].inputs[ki].id, self.state.data[k].date_str),
                          options: self.state.data[k].inputs[ki]['fatigue_options']
                        }) : self.state.data[k].inputs[ki].type === 'hour' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_input_mask___default.a, { value: self.state.data[k].inputs[ki].value, maskChar: null, name: "fatigue_reason_" + self.state.data[k].inputs[ki].id, mask: '99:99', className: 'form-control', onChange: self.handleFatigueChange.bind(self, self.state.data[k].inputs[ki].id, self.state.data[k].date_str), placeholder: self.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.tabDatas.formulario.placeholder.Horas }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: "fatigue_reason_" + self.state.data[k].inputs[ki].id, className: "form-control", placeholder: self.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.tabDatas.formulario.placeholder.Quantidade, value: self.state.data[k].inputs[ki].value, onChange: self.handleFatigueChange.bind(self, self.state.data[k].inputs[ki].id, self.state.data[k].date_str) })
                      );
                    })
                  )
                );
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["g" /* Modal */],
              { show: this.state.modal, bsSize: 'large', 'aria-labelledby': 'contained-modal-title-lg' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["g" /* Modal */].Header,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                      return _this2.setState({ modal: false });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["g" /* Modal */].Body,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'table',
                  { className: 'table table-bordered table-stripped' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'thead',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        null,
                        this.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.tabela.Data
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        null,
                        this.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.tabela.Diaria
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        null,
                        this.locale.RelatoriosDeFadiga.SimuladorDeRelatoriosDeFadiga.tabela.Acumulada
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tbody',
                    { id: 'frotas' },
                    self.state.data_reports !== null ? Object.keys(self.state.data_reports.data_reports).map(function (k) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'tr',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'td',
                          null,
                          self.state.data_reports.data_reports[k].date_str
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'td',
                          { style: { background: self.state.data_reports.data_reports[k].report_points_background } },
                          self.state.data_reports.data_reports[k].report_points
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'td',
                          { style: { background: self.state.data_reports.data_reports[k].actual_points_background } },
                          self.state.data_reports.data_reports[k].actual_points
                        )
                      );
                    }) : ""
                  )
                ),
                self.state.data_reports !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'hidden-sm hidden-xs' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_recharts__["a" /* LineChart */],
                      { width: 890, height: 400, data: self.state.data_reports.dates,
                        margin: { top: 5, right: 30, left: 20, bottom: 5 } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_recharts__["b" /* XAxis */], { dataKey: 'name' }),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_recharts__["c" /* YAxis */], null),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_recharts__["e" /* Tooltip */], null),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_recharts__["f" /* Legend */], null),
                      Object.keys(self.state.data_reports.names).map(function (k) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.data_reports.names[k].name, stroke: self.state.data_reports.names[k].color, activeDot: { r: 8 } });
                      })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'visible-sm-inline-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_recharts__["a" /* LineChart */],
                      { width: 690, height: 300, data: self.state.data_reports.dates,
                        margin: { top: 5, right: 30, left: 20, bottom: 5 } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_recharts__["b" /* XAxis */], { dataKey: 'name' }),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_recharts__["c" /* YAxis */], null),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_recharts__["e" /* Tooltip */], null),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_recharts__["f" /* Legend */], null),
                      Object.keys(self.state.data_reports.names).map(function (k) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.data_reports.names[k].name, stroke: self.state.data_reports.names[k].color, activeDot: { r: 8 } });
                      })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'visible-xs-inline-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_10_recharts__["a" /* LineChart */],
                      { width: 280, height: 400, data: self.state.data_reports.dates,
                        margin: { top: 5, right: 30, left: 20, bottom: 5 } },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_recharts__["b" /* XAxis */], { dataKey: 'name' }),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_recharts__["c" /* YAxis */], null),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_recharts__["e" /* Tooltip */], null),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_recharts__["f" /* Legend */], null),
                      Object.keys(self.state.data_reports.names).map(function (k) {
                        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.data_reports.names[k].name, stroke: self.state.data_reports.names[k].color, activeDot: { r: 8 } });
                      })
                    )
                  )
                ) : ""
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["g" /* Modal */].Footer,
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                      return _this2.setState({ modal: false });
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FatigueAdd;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (FatigueAdd);

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var StaffRfmsReportAdd = function (_Component) {
  _inherits(StaffRfmsReportAdd, _Component);

  // constructor
  function StaffRfmsReportAdd(props) {
    _classCallCheck(this, StaffRfmsReportAdd);

    var _this = _possibleConstructorReturn(this, (StaffRfmsReportAdd.__proto__ || Object.getPrototypeOf(StaffRfmsReportAdd)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: {},
      inputs: {},
      bases_list: [],
      date_str: ''
    };

    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.add = _this.add.bind(_this);
    _this.confirmAdd = _this.confirmAdd.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(StaffRfmsReportAdd, [{
    key: 'handleChangeData',
    value: function handleChangeData(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeBase',
    value: function handleSelectChangeBase(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      var data_temp = [];
      var self = this;
      Object.keys(this.state.inputs).map(function (k) {
        if (self.state.inputs[k].id === name) {
          var _change;

          change = (_change = {
            value: event.target.value,
            value_input: event.target.value,
            id: self.state.inputs[k].id,
            name: self.state.inputs[k].name,
            type_str: self.state.inputs[k].type_str,
            type: self.state.inputs[k].type,
            fatigue_options: self.state.inputs[k].fatigue_options,
            operator: self.state.inputs[k].operator,
            hour_points: self.state.inputs[k].hour_points,
            quantity_points: self.state.inputs[k].quantity_points,
            point_limit: self.state.inputs[k].point_limit,
            required: self.state.inputs[k].required,
            max_points: self.state.inputs[k].max_points,
            min_points: self.state.inputs[k].min_points,
            aps_day: self.state.inputs[k].aps_day,
            hours_day: self.state.inputs[k].hours_day,
            nocturnal_extra_points: self.state.inputs[k].nocturnal_extra_points,
            reduction_points: self.state.inputs[k].reduction_points,
            extra_hours: self.state.inputs[k].extra_hours,
            automation_type: self.state.inputs[k].automation_type,
            limit_extra_hours_week: self.state.inputs[k].limit_extra_hours_week,
            limit_extra_hours_month: self.state.inputs[k].limit_extra_hours_month,
            day_limit_extra_hours_week: self.state.inputs[k].day_limit_extra_hours_week,
            day_limit_extra_hours_month: self.state.inputs[k].day_limit_extra_hours_month,
            automation_type_id: self.state.inputs[k].automation_type_id,
            automation_field: self.state.inputs[k].automation_field
          }, _defineProperty(_change, 'automation_type', self.state.inputs[k].automation_type), _defineProperty(_change, 'automation_type_name', self.state.inputs[k].automation_type_name), _defineProperty(_change, 'api_type', self.state.inputs[k].api_type), _change);
        } else {
          var _change2;

          change = (_change2 = {
            value: self.state.inputs[k].value,
            value_input: self.state.inputs[k].value_input,
            id: self.state.inputs[k].id,
            name: self.state.inputs[k].name,
            type_str: self.state.inputs[k].type_str,
            type: self.state.inputs[k].type,
            fatigue_options: self.state.inputs[k].fatigue_options,
            operator: self.state.inputs[k].operator,
            hour_points: self.state.inputs[k].hour_points,
            quantity_points: self.state.inputs[k].quantity_points,
            point_limit: self.state.inputs[k].point_limit,
            required: self.state.inputs[k].required,
            max_points: self.state.inputs[k].max_points,
            min_points: self.state.inputs[k].min_points,
            aps_day: self.state.inputs[k].aps_day,
            hours_day: self.state.inputs[k].hours_day,
            nocturnal_extra_points: self.state.inputs[k].nocturnal_extra_points,
            reduction_points: self.state.inputs[k].reduction_points,
            extra_hours: self.state.inputs[k].extra_hours,
            automation_type: self.state.inputs[k].automation_type,
            limit_extra_hours_week: self.state.inputs[k].limit_extra_hours_week,
            limit_extra_hours_month: self.state.inputs[k].limit_extra_hours_month,
            day_limit_extra_hours_week: self.state.inputs[k].day_limit_extra_hours_week,
            day_limit_extra_hours_month: self.state.inputs[k].day_limit_extra_hours_month,
            automation_type_id: self.state.inputs[k].automation_type_id,
            automation_field: self.state.inputs[k].automation_field
          }, _defineProperty(_change2, 'automation_type', self.state.inputs[k].automation_type), _defineProperty(_change2, 'automation_type_name', self.state.inputs[k].automation_type_name), _defineProperty(_change2, 'api_type', self.state.inputs[k].api_type), _change2);
        }
        data_temp.push(change);
      });
      this.setState({ inputs: data_temp });
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      var data_temp = [];
      var self = this;
      Object.keys(this.state.inputs).map(function (k) {
        if (self.state.inputs[k].id === name) {
          var _change3;

          change = (_change3 = {
            value: event.label,
            value_input: event.value,
            id: self.state.inputs[k].id,
            name: self.state.inputs[k].name,
            type_str: self.state.inputs[k].type_str,
            type: self.state.inputs[k].type,
            fatigue_options: self.state.inputs[k].fatigue_options,
            operator: self.state.inputs[k].operator,
            hour_points: self.state.inputs[k].hour_points,
            quantity_points: self.state.inputs[k].quantity_points,
            point_limit: self.state.inputs[k].point_limit,
            required: self.state.inputs[k].required,
            max_points: self.state.inputs[k].max_points,
            min_points: self.state.inputs[k].min_points,
            aps_day: self.state.inputs[k].aps_day,
            hours_day: self.state.inputs[k].hours_day,
            nocturnal_extra_points: self.state.inputs[k].nocturnal_extra_points,
            reduction_points: self.state.inputs[k].reduction_points,
            extra_hours: self.state.inputs[k].extra_hours,
            automation_type: self.state.inputs[k].automation_type,
            limit_extra_hours_week: self.state.inputs[k].limit_extra_hours_week,
            limit_extra_hours_month: self.state.inputs[k].limit_extra_hours_month,
            day_limit_extra_hours_week: self.state.inputs[k].day_limit_extra_hours_week,
            day_limit_extra_hours_month: self.state.inputs[k].day_limit_extra_hours_month,
            automation_type_id: self.state.inputs[k].automation_type_id,
            automation_field: self.state.inputs[k].automation_field
          }, _defineProperty(_change3, 'automation_type', self.state.inputs[k].automation_type), _defineProperty(_change3, 'automation_type_name', self.state.inputs[k].automation_type_name), _defineProperty(_change3, 'api_type', self.state.inputs[k].api_type), _change3);
        } else {
          var _change4;

          change = (_change4 = {
            value: self.state.inputs[k].value,
            value_input: self.state.inputs[k].value_input,
            id: self.state.inputs[k].id,
            name: self.state.inputs[k].name,
            type_str: self.state.inputs[k].type_str,
            type: self.state.inputs[k].type,
            fatigue_options: self.state.inputs[k].fatigue_options,
            operator: self.state.inputs[k].operator,
            hour_points: self.state.inputs[k].hour_points,
            quantity_points: self.state.inputs[k].quantity_points,
            point_limit: self.state.inputs[k].point_limit,
            required: self.state.inputs[k].required,
            max_points: self.state.inputs[k].max_points,
            min_points: self.state.inputs[k].min_points,
            aps_day: self.state.inputs[k].aps_day,
            hours_day: self.state.inputs[k].hours_day,
            nocturnal_extra_points: self.state.inputs[k].nocturnal_extra_points,
            reduction_points: self.state.inputs[k].reduction_points,
            extra_hours: self.state.inputs[k].extra_hours,
            automation_type: self.state.inputs[k].automation_type,
            limit_extra_hours_week: self.state.inputs[k].limit_extra_hours_week,
            limit_extra_hours_month: self.state.inputs[k].limit_extra_hours_month,
            day_limit_extra_hours_week: self.state.inputs[k].day_limit_extra_hours_week,
            day_limit_extra_hours_month: self.state.inputs[k].day_limit_extra_hours_month,
            automation_type_id: self.state.inputs[k].automation_type_id,
            automation_field: self.state.inputs[k].automation_field
          }, _defineProperty(_change4, 'automation_type', self.state.inputs[k].automation_type), _defineProperty(_change4, 'automation_type_name', self.state.inputs[k].automation_type_name), _defineProperty(_change4, 'api_type', self.state.inputs[k].api_type), _change4);
        }
        data_temp.push(change);
      });
      this.setState({ inputs: data_temp });
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }

    // Setamos o state.date_start para a data de hoje

  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var date_str = new Date().toISOString().slice(0, 10).split('-').reverse().join('/');
      this.setState({ date_str: date_str });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/parametros-de-fadiga/relatorio-de-fadiga', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            var change = {};
            var data_temp = [];
            Object.keys(responseJson.data.params).map(function (k) {
              var _change5;

              var change = (_change5 = {
                value: null,
                id: responseJson.data.params[k].id,
                name: responseJson.data.params[k].name,
                type_str: responseJson.data.params[k].type_str,
                type: responseJson.data.params[k].type,
                fatigue_options: responseJson.data.params[k].fatigue_options,
                operator: responseJson.data.params[k].operator,
                hour_points: responseJson.data.params[k].hour_points,
                quantity_points: responseJson.data.params[k].quantity_points,
                point_limit: responseJson.data.params[k].point_limit,
                required: responseJson.data.params[k].required,
                max_points: responseJson.data.params[k].max_points,
                min_points: responseJson.data.params[k].min_points,
                aps_day: responseJson.data.params[k].aps_day,
                hours_day: responseJson.data.params[k].hours_day,
                nocturnal_extra_points: responseJson.data.params[k].nocturnal_extra_points,
                reduction_points: responseJson.data.params[k].reduction_points,
                extra_hours: responseJson.data.params[k].extra_hours,
                automation_type: responseJson.data.params[k].automation_type,
                limit_extra_hours_week: responseJson.data.params[k].limit_extra_hours_week,
                limit_extra_hours_month: responseJson.data.params[k].limit_extra_hours_month,
                day_limit_extra_hours_week: responseJson.data.params[k].day_limit_extra_hours_week,
                day_limit_extra_hours_month: responseJson.data.params[k].day_limit_extra_hours_month,
                automation_type_id: responseJson.data.params[k].automation_type_id,
                automation_field: responseJson.data.params[k].automation_field
              }, _defineProperty(_change5, 'automation_type', responseJson.data.params[k].automation_type), _defineProperty(_change5, 'automation_type_name', responseJson.data.params[k].automation_type_name), _defineProperty(_change5, 'api_type', responseJson.data.params[k].api_type), _change5);
              data_temp.push(change);
            });
            self.setState({ data: responseJson.data.params, inputs: data_temp, bases_list: responseJson.data.bases_list });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'confirmAdd',
    value: function confirmAdd(event) {
      event.preventDefault();
      var self = this;
      var confirmed = 0;
      Object.keys(self.state.inputs).map(function (k) {
        if (self.state.inputs[k].value !== null && typeof self.state.inputs[k].value !== 'undefined') {
          var value = self.state.inputs[k].value;
          if (self.state.inputs[k].type == 'hour') {
            var arr = value.split(':');
            value = parseFloat(parseInt(arr[0], 10) + '.' + parseInt(arr[1] / 6 * 10, 10));
            value = value * self.state.inputs[k].hour_points;
          } else if (self.state.inputs[k].type == 'quantity') {
            value = value * self.state.inputs[k].quantity_points;
          }

          if (self.state.inputs[k].max_points !== null) {
            if (value > self.state.inputs[k].max_points) {
              var confirm = window.confirm(self.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadiga.noParametroAPontuacaoMaximaFoiUltrapassada(self.state.inputs[k].name));
              if (confirm) {
                if (confirmed !== null) {
                  confirmed++;
                }
              } else {
                confirmed = null;
              }
            }
          }
          if (self.state.inputs[k].min_points !== null) {
            if (value < self.state.inputs[k].min_points) {
              var confirm = window.confirm(self.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadiga.noParametroAPontuacaoMinimaNaoFoiAtingida(self.state.inputs[k].name));
              if (confirm) {
                if (confirmed !== null) {
                  confirmed++;
                }
              } else {
                confirmed = null;
              }
            }
          }
        }
      });
      if (confirmed >= 0 && confirmed !== null) {
        this.add();
      }
    }
  }, {
    key: 'add',
    value: function add() {
      var self = this;
      self.setState({ overlay: { message: '', type: '', status: 'open' } });
      var email = localStorage.getItem("data");
      var cid = localStorage.getItem("cid");
      var storage = JSON.parse(cid);
      var datasave = {
        inputs: this.state.inputs,
        date_str: this.state.date_str,
        base_id: this.state.base_id
      };
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio-de-fadiga', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var url = '/relatorio-de-fadiga/tripulante/editar/' + responseJson.data.id;
            var storage = {
              alert_message: responseJson.message,
              alert_type: responseJson.status
            };
            localStorage.setItem("verify_message", JSON.stringify(storage));
            document.location = url;
          }
          self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              self.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadiga.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/relatorios-de-fadiga/tripulante', className: 'btn btn-default pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-left' }),
              ' ',
              this.locale.general.voltar
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.confirmAdd },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadiga.formulario.Data,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.date_str, required: true, maskChar: null, name: 'date_str', mask: '99/99/9999', className: 'form-control', onChange: this.handleChangeData.bind(this, 'date_str'), placeholder: '' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadiga.formulario.Bases,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'base_id',
                      value: this.state.base_id,
                      searchable: true,
                      placeholder: this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadiga.formulario.placeholder.SelecionarBase,
                      onChange: this.handleSelectChangeBase.bind(this, 'base_id'),
                      options: this.state.bases_list
                    })
                  )
                )
              ),
              Object.keys(self.state.inputs).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    self.state.inputs[k].name + " - " + self.state.inputs[k].type_str
                  ),
                  self.state.inputs[k].type === 'options' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    name: 'type',
                    required: self.state.inputs[k].required,
                    value: self.state.inputs[k].value_input,
                    searchable: true,
                    placeholder: self.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadiga.formulario.placeholder.SelecionarOpcao,
                    onChange: self.handleSelectChange.bind(self, self.state.inputs[k].id),
                    options: self.state.inputs[k]['fatigue_options']
                  }) : self.state.inputs[k].type === 'hour' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { required: self.state.inputs[k].required, value: self.state.inputs[k].value, maskChar: null, name: "fatigue_reason_" + self.state.inputs[k].id, mask: '99:99', className: 'form-control', onChange: self.handleChange.bind(self, self.state.inputs[k].id), placeholder: self.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadiga.formulario.placeholder.Horas }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { required: self.state.inputs[k].required, type: 'text', name: "fatigue_reason_" + self.state.inputs[k].id, className: "form-control", placeholder: self.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadiga.formulario.placeholder.Quantidade, value: self.state.inputs[k].value, onChange: self.handleChange.bind(self, self.state.inputs[k].id) })
                );
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                    ' ',
                    this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadiga.formulario.botaoAdicionarRelatorioDeFadiga
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return StaffRfmsReportAdd;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffRfmsReportAdd);

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












// Importação da tabela



var StaffRfmsReportAdjustHours = function (_Component) {
  _inherits(StaffRfmsReportAdjustHours, _Component);

  function StaffRfmsReportAdjustHours(props) {
    _classCallCheck(this, StaffRfmsReportAdjustHours);

    var _this = _possibleConstructorReturn(this, (StaffRfmsReportAdjustHours.__proto__ || Object.getPrototypeOf(StaffRfmsReportAdjustHours)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      modal: false,
      data: [],
      data_modal: [],
      applicabilities_list: [],
      staff_list: [],
      origins_list: [],
      status_list: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.edit = _this.edit.bind(_this);
    _this.loadData = _this.loadData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(StaffRfmsReportAdjustHours, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeApplicability',
    value: function handleSelectChangeApplicability(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;

        var header = this.refs.request_api.header('application/json');
        var self = this;
        this.handleAlert('', '', 'open');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aplicabilidade/colaboradores/listagens/' + event.value, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.setState({ staff_list: responseJson.data.staffs });
            self.handleAlert(responseJson.message, responseJson.status, 'closed');
          });
        });
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/questionario/pesquisa/fadiga/listagens';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ applicabilities_list: responseJson.data.applicabilities_list });
            self.setState({ origins_list: responseJson.data.origins_list });
            self.setState({ status_list: responseJson.data.status_list });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
        }); /* Overlay */
      });
    }
  }, {
    key: 'edit',
    value: function edit(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        date: this.state.date,
        staff_id: this.state.staff_id,
        applicability_id: this.state.applicability_id,
        status: this.state.status,
        origins: this.state.origins
      };

      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/fadiga/revisar/horarios/ponto', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
          }
          self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'bg-info', style: { padding: '10px' } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-warning' }),
              ' ',
              this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.tituloUtilizeEstaFerramentaParaCorrigirOsReportes,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.tituloAtencaoCasoOReportNaoExistaDeveraSerCriado
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.edit },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.formulario.AplicabilidadeTipoDeColaborador,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'applicability_id',
                      value: this.state.applicability_id,
                      searchable: true,
                      required: true,
                      placeholder: this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.formulario.placeholder.SelecionarAplicabilidade,
                      onChange: this.handleSelectChangeApplicability.bind(this, 'applicability_id'),
                      options: this.state.applicabilities_list
                    })
                  )
                ),
                this.state.applicability_id === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.formulario.Tripulantes135,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'staff_id',
                      value: this.state.staff_id,
                      searchable: true,
                      placeholder: this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.formulario.placeholder.SelecionarTripulante,
                      onChange: this.handleSelectChange.bind(this, 'staff_id'),
                      options: this.state.staff_list,
                      required: true
                    })
                  )
                ) : this.state.applicability_id === 4 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.formulario.Tripulantes121,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'staff_id',
                      value: this.state.staff_id,
                      searchable: true,
                      placeholder: this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.formulario.placeholder.SelecionarTripulante,
                      onChange: this.handleSelectChange.bind(this, 'staff_id'),
                      options: this.state.staff_list,
                      required: true
                    })
                  )
                ) : this.state.applicability_id === 2 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.formulario.Mecanicos,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'staff_id',
                      value: this.state.staff_id,
                      searchable: true,
                      placeholder: this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.formulario.placeholder.SelecionarMecanico,
                      onChange: this.handleSelectChange.bind(this, 'staff_id'),
                      options: this.state.staff_list,
                      required: true
                    })
                  )
                ) : this.state.applicability_id === 3 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.formulario.Coordenadores,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'staff_id',
                      value: this.state.staff_id,
                      searchable: true,
                      placeholder: this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.formulario.placeholder.SelecionarCoordenador,
                      onChange: this.handleSelectChange.bind(this, 'staff_id'),
                      options: this.state.staff_list,
                      required: true
                    })
                  )
                ) : '',
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-4' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.formulario.Data,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_input_mask___default.a, { value: this.state.date, required: true, maskChar: null, name: 'date', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date'), placeholder: '' })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'submit', className: 'btn btn-primary btn-block' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                  ' ',
                  this.locale.RelatoriosDeFadiga.RevisarHorariosDePonto.formulario.botaoRevisarHorarios
                )
              )
            )
          )
        )
      );
    }
  }]);

  return StaffRfmsReportAdjustHours;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffRfmsReportAdjustHours);

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














var StaffRfmsReportAdd = function (_Component) {
  _inherits(StaffRfmsReportAdd, _Component);

  // constructor
  function StaffRfmsReportAdd(props) {
    _classCallCheck(this, StaffRfmsReportAdd);

    var _this = _possibleConstructorReturn(this, (StaffRfmsReportAdd.__proto__ || Object.getPrototypeOf(StaffRfmsReportAdd)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: {},
      inputs: {},
      bases_list: [],
      date_str: ''
    };

    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.add = _this.add.bind(_this);
    _this.confirmAdd = _this.confirmAdd.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(StaffRfmsReportAdd, [{
    key: 'handleChangeData',
    value: function handleChangeData(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeBase',
    value: function handleSelectChangeBase(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      var data_temp = [];
      var self = this;
      Object.keys(this.state.inputs).map(function (k) {
        if (self.state.inputs[k].id === name) {
          var _change;

          change = (_change = {
            value: event.target.value,
            value_input: event.target.value,
            id: self.state.inputs[k].id,
            name: self.state.inputs[k].name,
            type_str: self.state.inputs[k].type_str,
            type: self.state.inputs[k].type,
            fatigue_options: self.state.inputs[k].fatigue_options,
            operator: self.state.inputs[k].operator,
            hour_points: self.state.inputs[k].hour_points,
            quantity_points: self.state.inputs[k].quantity_points,
            point_limit: self.state.inputs[k].point_limit,
            required: self.state.inputs[k].required,
            max_points: self.state.inputs[k].max_points,
            min_points: self.state.inputs[k].min_points,
            aps_day: self.state.inputs[k].aps_day,
            hours_day: self.state.inputs[k].hours_day,
            nocturnal_extra_points: self.state.inputs[k].nocturnal_extra_points,
            reduction_points: self.state.inputs[k].reduction_points,
            extra_hours: self.state.inputs[k].extra_hours,
            automation_type: self.state.inputs[k].automation_type,
            limit_extra_hours_week: self.state.inputs[k].limit_extra_hours_week,
            limit_extra_hours_month: self.state.inputs[k].limit_extra_hours_month,
            day_limit_extra_hours_week: self.state.inputs[k].day_limit_extra_hours_week,
            day_limit_extra_hours_month: self.state.inputs[k].day_limit_extra_hours_month,
            automation_type_id: self.state.inputs[k].automation_type_id,
            automation_field: self.state.inputs[k].automation_field
          }, _defineProperty(_change, 'automation_type', self.state.inputs[k].automation_type), _defineProperty(_change, 'automation_type_name', self.state.inputs[k].automation_type_name), _defineProperty(_change, 'api_type', self.state.inputs[k].api_type), _change);
        } else {
          var _change2;

          change = (_change2 = {
            value: self.state.inputs[k].value,
            value_input: self.state.inputs[k].value_input,
            id: self.state.inputs[k].id,
            name: self.state.inputs[k].name,
            type_str: self.state.inputs[k].type_str,
            type: self.state.inputs[k].type,
            fatigue_options: self.state.inputs[k].fatigue_options,
            operator: self.state.inputs[k].operator,
            hour_points: self.state.inputs[k].hour_points,
            quantity_points: self.state.inputs[k].quantity_points,
            point_limit: self.state.inputs[k].point_limit,
            required: self.state.inputs[k].required,
            max_points: self.state.inputs[k].max_points,
            min_points: self.state.inputs[k].min_points,
            aps_day: self.state.inputs[k].aps_day,
            hours_day: self.state.inputs[k].hours_day,
            nocturnal_extra_points: self.state.inputs[k].nocturnal_extra_points,
            reduction_points: self.state.inputs[k].reduction_points,
            extra_hours: self.state.inputs[k].extra_hours,
            automation_type: self.state.inputs[k].automation_type,
            limit_extra_hours_week: self.state.inputs[k].limit_extra_hours_week,
            limit_extra_hours_month: self.state.inputs[k].limit_extra_hours_month,
            day_limit_extra_hours_week: self.state.inputs[k].day_limit_extra_hours_week,
            day_limit_extra_hours_month: self.state.inputs[k].day_limit_extra_hours_month,
            automation_type_id: self.state.inputs[k].automation_type_id,
            automation_field: self.state.inputs[k].automation_field
          }, _defineProperty(_change2, 'automation_type', self.state.inputs[k].automation_type), _defineProperty(_change2, 'automation_type_name', self.state.inputs[k].automation_type_name), _defineProperty(_change2, 'api_type', self.state.inputs[k].api_type), _change2);
        }
        data_temp.push(change);
      });
      this.setState({ inputs: data_temp });
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      var data_temp = [];
      var self = this;
      Object.keys(this.state.inputs).map(function (k) {
        if (self.state.inputs[k].id === name) {
          var _change3;

          change = (_change3 = {
            value: event.label,
            value_input: event.value,
            id: self.state.inputs[k].id,
            name: self.state.inputs[k].name,
            type_str: self.state.inputs[k].type_str,
            type: self.state.inputs[k].type,
            fatigue_options: self.state.inputs[k].fatigue_options,
            operator: self.state.inputs[k].operator,
            hour_points: self.state.inputs[k].hour_points,
            quantity_points: self.state.inputs[k].quantity_points,
            point_limit: self.state.inputs[k].point_limit,
            required: self.state.inputs[k].required,
            max_points: self.state.inputs[k].max_points,
            min_points: self.state.inputs[k].min_points,
            aps_day: self.state.inputs[k].aps_day,
            hours_day: self.state.inputs[k].hours_day,
            nocturnal_extra_points: self.state.inputs[k].nocturnal_extra_points,
            reduction_points: self.state.inputs[k].reduction_points,
            extra_hours: self.state.inputs[k].extra_hours,
            automation_type: self.state.inputs[k].automation_type,
            limit_extra_hours_week: self.state.inputs[k].limit_extra_hours_week,
            limit_extra_hours_month: self.state.inputs[k].limit_extra_hours_month,
            day_limit_extra_hours_week: self.state.inputs[k].day_limit_extra_hours_week,
            day_limit_extra_hours_month: self.state.inputs[k].day_limit_extra_hours_month,
            automation_type_id: self.state.inputs[k].automation_type_id,
            automation_field: self.state.inputs[k].automation_field
          }, _defineProperty(_change3, 'automation_type', self.state.inputs[k].automation_type), _defineProperty(_change3, 'automation_type_name', self.state.inputs[k].automation_type_name), _defineProperty(_change3, 'api_type', self.state.inputs[k].api_type), _change3);
        } else {
          var _change4;

          change = (_change4 = {
            value: self.state.inputs[k].value,
            value_input: self.state.inputs[k].value_input,
            id: self.state.inputs[k].id,
            name: self.state.inputs[k].name,
            type_str: self.state.inputs[k].type_str,
            type: self.state.inputs[k].type,
            fatigue_options: self.state.inputs[k].fatigue_options,
            operator: self.state.inputs[k].operator,
            hour_points: self.state.inputs[k].hour_points,
            quantity_points: self.state.inputs[k].quantity_points,
            point_limit: self.state.inputs[k].point_limit,
            required: self.state.inputs[k].required,
            max_points: self.state.inputs[k].max_points,
            min_points: self.state.inputs[k].min_points,
            aps_day: self.state.inputs[k].aps_day,
            hours_day: self.state.inputs[k].hours_day,
            nocturnal_extra_points: self.state.inputs[k].nocturnal_extra_points,
            reduction_points: self.state.inputs[k].reduction_points,
            extra_hours: self.state.inputs[k].extra_hours,
            automation_type: self.state.inputs[k].automation_type,
            limit_extra_hours_week: self.state.inputs[k].limit_extra_hours_week,
            limit_extra_hours_month: self.state.inputs[k].limit_extra_hours_month,
            day_limit_extra_hours_week: self.state.inputs[k].day_limit_extra_hours_week,
            day_limit_extra_hours_month: self.state.inputs[k].day_limit_extra_hours_month,
            automation_type_id: self.state.inputs[k].automation_type_id,
            automation_field: self.state.inputs[k].automation_field
          }, _defineProperty(_change4, 'automation_type', self.state.inputs[k].automation_type), _defineProperty(_change4, 'automation_type_name', self.state.inputs[k].automation_type_name), _defineProperty(_change4, 'api_type', self.state.inputs[k].api_type), _change4);
        }
        data_temp.push(change);
      });
      this.setState({ inputs: data_temp });
    }
  }, {
    key: 'handleSelectChangeApplicability',
    value: function handleSelectChangeApplicability(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;

        var header = this.refs.request_api.header('application/json');
        var self = this;
        this.handleAlert('', '', 'open');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/parametros-de-fadiga/relatorio-de-fadiga/administrativo/' + event.value, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'url');
            if (responseJson.status === 'success') {
              var change = {};
              var data_temp = [];
              Object.keys(responseJson.data.params).map(function (k) {
                var _change5;

                var change = (_change5 = {
                  value: null,
                  value_input: null,
                  id: responseJson.data.params[k].id,
                  name: responseJson.data.params[k].name,
                  type_str: responseJson.data.params[k].type_str,
                  type: responseJson.data.params[k].type,
                  fatigue_options: responseJson.data.params[k].fatigue_options,
                  operator: responseJson.data.params[k].operator,
                  hour_points: responseJson.data.params[k].hour_points,
                  quantity_points: responseJson.data.params[k].quantity_points,
                  point_limit: responseJson.data.params[k].point_limit,
                  required: responseJson.data.params[k].required,
                  max_points: responseJson.data.params[k].max_points,
                  min_points: responseJson.data.params[k].min_points,
                  aps_day: responseJson.data.params[k].aps_day,
                  hours_day: responseJson.data.params[k].hours_day,
                  nocturnal_extra_points: responseJson.data.params[k].nocturnal_extra_points,
                  reduction_points: responseJson.data.params[k].reduction_points,
                  extra_hours: responseJson.data.params[k].extra_hours,
                  automation_type: responseJson.data.params[k].automation_type,
                  limit_extra_hours_week: responseJson.data.params[k].limit_extra_hours_week,
                  limit_extra_hours_month: responseJson.data.params[k].limit_extra_hours_month,
                  day_limit_extra_hours_week: responseJson.data.params[k].day_limit_extra_hours_week,
                  day_limit_extra_hours_month: responseJson.data.params[k].day_limit_extra_hours_month,
                  automation_type_id: responseJson.data.params[k].automation_type_id,
                  automation_field: responseJson.data.params[k].automation_field
                }, _defineProperty(_change5, 'automation_type', responseJson.data.params[k].automation_type), _defineProperty(_change5, 'automation_type_name', responseJson.data.params[k].automation_type_name), _defineProperty(_change5, 'api_type', responseJson.data.params[k].api_type), _change5);
                data_temp.push(change);
              });
              self.setState({ data: responseJson.data.params, inputs: data_temp, staffs_list: responseJson.data.staffs_list, bases_list: responseJson.data.bases_list });
            }
          }).then(function () {
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
            self.handleMessage();
          }); /* Overlay */
        });
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeNormal',
    value: function handleSelectChangeNormal(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }

    // Setamos o state.date_start para a data de hoje

  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var date_str = new Date().toISOString().slice(0, 10).split('-').reverse().join('/');
      this.setState({ date_str: date_str });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios-de-fadiga/listagens';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ applicabilities_list: responseJson.data.applicabilities_list });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
        }); /* Overlay */
      });
    }
  }, {
    key: 'loadInputsData',
    value: function loadInputsData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/parametros-de-fadiga/relatorio-de-fadiga/administrativo/', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            var change = {};
            var data_temp = [];
            Object.keys(responseJson.data.params).map(function (k) {
              var change = {
                value: null,
                value_input: null,
                id: responseJson.data.params[k].id,
                name: responseJson.data.params[k].name,
                type_str: responseJson.data.params[k].type_str,
                type: responseJson.data.params[k].type,
                fatigue_options: responseJson.data.params[k].fatigue_options,
                operator: responseJson.data.params[k].operator,
                hour_points: responseJson.data.params[k].hour_points,
                quantity_points: responseJson.data.params[k].quantity_points,
                point_limit: responseJson.data.params[k].point_limit,
                required: responseJson.data.params[k].required,
                max_points: responseJson.data.params[k].max_points,
                min_points: responseJson.data.params[k].min_points,
                aps_day: responseJson.data.params[k].aps_day,
                hours_day: responseJson.data.params[k].hours_day,
                nocturnal_extra_points: responseJson.data.params[k].nocturnal_extra_points,
                reduction_points: responseJson.data.params[k].reduction_points,
                extra_hours: responseJson.data.params[k].extra_hours,
                automation_type: responseJson.data.params[k].automation_type,
                limit_extra_hours_week: responseJson.data.params[k].limit_extra_hours_week,
                limit_extra_hours_month: responseJson.data.params[k].limit_extra_hours_month,
                day_limit_extra_hours_week: responseJson.data.params[k].day_limit_extra_hours_week,
                day_limit_extra_hours_month: responseJson.data.params[k].day_limit_extra_hours_month
              };
              data_temp.push(change);
            });
            self.setState({ data: responseJson.data.params, inputs: data_temp });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'confirmAdd',
    value: function confirmAdd(event) {
      event.preventDefault();
      var self = this;
      var confirmed = 0;
      Object.keys(self.state.inputs).map(function (k) {
        if (self.state.inputs[k].value !== null && typeof self.state.inputs[k].value !== 'undefined') {
          var value = self.state.inputs[k].value;
          if (self.state.inputs[k].type == 'hour') {
            var arr = value.split(':');
            value = parseFloat(parseInt(arr[0], 10) + '.' + parseInt(arr[1] / 6 * 10, 10));
            value = value * self.state.inputs[k].hour_points;
          } else if (self.state.inputs[k].type == 'quantity') {
            value = value * self.state.inputs[k].quantity_points;
          }

          if (self.state.inputs[k].max_points !== null) {
            if (value > self.state.inputs[k].max_points) {
              var confirm = window.confirm(self.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.noParametroAPontuacaoMaximaFoiUltrapassada(self.state.inputs[k].name));
              if (confirm) {
                if (confirmed !== null) {
                  confirmed++;
                }
              } else {
                confirmed = null;
              }
            }
          }
          if (self.state.inputs[k].min_points !== null) {
            if (value < self.state.inputs[k].min_points) {
              var confirm = window.confirm(self.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.noParametroAPontuacaoMinimaNaoFoiAtingida(self.state.inputs[k].name));
              if (confirm) {
                if (confirmed !== null) {
                  confirmed++;
                }
              } else {
                confirmed = null;
              }
            }
          }
        }
      });
      if (confirmed >= 0 && confirmed !== null) {
        this.add();
      }
    }
  }, {
    key: 'add',
    value: function add() {
      var self = this;
      self.setState({ overlay: { message: '', type: '', status: 'open' } });
      var email = localStorage.getItem("data");
      var cid = localStorage.getItem("cid");
      var storage = JSON.parse(cid);
      var datasave = {
        inputs: this.state.inputs,
        date_str: this.state.date_str,
        base_id: this.state.base_id,
        staff_id: this.state.staff_id,
        applicability_id: this.state.applicability_id
      };
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/administrativo/relatorio-de-fadiga', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          if (responseJson.status === 'success') {
            var url = '/relatorio-de-fadiga/tripulante/administrativo/editar/' + responseJson.data.id + '/' + responseJson.applicability_id + '/' + responseJson.staff_id;
            var storage = {
              alert_message: responseJson.message,
              alert_type: responseJson.status
            };
            localStorage.setItem("verify_message", JSON.stringify(storage));
            document.location = url;
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/relatorios-de-fadiga/tripulante', className: 'btn btn-default pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-left' }),
              ' ',
              this.locale.general.voltar
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.confirmAdd },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.AplicabilidadeTipoDeColaborador,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'applicability_id',
                      value: this.state.applicability_id,
                      searchable: true,
                      placeholder: this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.placeholder.SelecionarAplicabilidade,
                      onChange: this.handleSelectChangeApplicability.bind(this, 'applicability_id'),
                      options: this.state.applicabilities_list
                    })
                  )
                ),
                this.state.applicability_id === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.Tripulantes135,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'staff_id',
                      value: this.state.staff_id,
                      searchable: true,
                      placeholder: this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.placeholder.SelecionarTripulante,
                      onChange: this.handleSelectChangeNormal.bind(this, 'staff_id'),
                      options: this.state.staffs_list
                    })
                  )
                ) : this.state.applicability_id === 4 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.Tripulantes121,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'staff_id',
                      value: this.state.staff_id,
                      searchable: true,
                      placeholder: this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.placeholder.SelecionarTripulante,
                      onChange: this.handleSelectChangeNormal.bind(this, 'staff_id'),
                      options: this.state.staffs_list
                    })
                  )
                ) : this.state.applicability_id === 2 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.Mecanicos,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'staff_id',
                      value: this.state.staff_id,
                      searchable: true,
                      placeholder: this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.placeholder.SelecionarMecanico,
                      onChange: this.handleSelectChangeNormal.bind(this, 'staff_id'),
                      options: this.state.staffs_list
                    })
                  )
                ) : this.state.applicability_id === 3 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.Coordenadores,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'staff_id',
                      value: this.state.staff_id,
                      searchable: true,
                      placeholder: this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.placeholder.SelecionarCoordenador,
                      onChange: this.handleSelectChangeNormal.bind(this, 'staff_id'),
                      options: this.state.staffs_list
                    })
                  )
                ) : ''
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.Data,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { value: this.state.date_str, required: true, maskChar: null, name: 'date_str', mask: '99/99/9999', className: 'form-control', onChange: this.handleChangeData.bind(this, 'date_str'), placeholder: '' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.Bases,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'base_id',
                      value: this.state.base_id,
                      searchable: true,
                      placeholder: this.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.placeholder.SelecionarBase,
                      onChange: this.handleSelectChangeBase.bind(this, 'base_id'),
                      options: this.state.bases_list
                    })
                  )
                )
              ),
              Object.keys(self.state.inputs).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    self.state.inputs[k].name + " - " + self.state.inputs[k].type_str
                  ),
                  self.state.inputs[k].type === 'options' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    name: 'type',
                    required: self.state.inputs[k].required,
                    value: self.state.inputs[k].value_input,
                    searchable: true,
                    placeholder: self.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.placeholder.SelecionarOpcao,
                    onChange: self.handleSelectChange.bind(self, self.state.inputs[k].id),
                    options: self.state.inputs[k]['fatigue_options']
                  }) : self.state.inputs[k].type === 'hour' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_input_mask___default.a, { required: self.state.inputs[k].required, value: self.state.inputs[k].value, maskChar: null, name: "fatigue_reason_" + self.state.inputs[k].id, mask: '99:99', className: 'form-control', onChange: self.handleChange.bind(self, self.state.inputs[k].id), placeholder: self.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.placeholder.Horas }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { required: self.state.inputs[k].required, type: 'text', name: "fatigue_reason_" + self.state.inputs[k].id, className: "form-control", placeholder: self.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.placeholder.Quantidade, value: self.state.inputs[k].value, onChange: self.handleChange.bind(self, self.state.inputs[k].id) })
                );
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                    ' ',
                    self.locale.RelatoriosDeFadiga.AdicionarRelatorioDeFadigaAdministrador.formulario.botaoAdicionarRelatorioDeFadiga
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return StaffRfmsReportAdd;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffRfmsReportAdd);

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














// Tabs

var StaffRfmsReportAdmEdit = function (_Component) {
  _inherits(StaffRfmsReportAdmEdit, _Component);

  function StaffRfmsReportAdmEdit(props) {
    _classCallCheck(this, StaffRfmsReportAdmEdit);

    var _this = _possibleConstructorReturn(this, (StaffRfmsReportAdmEdit.__proto__ || Object.getPrototypeOf(StaffRfmsReportAdmEdit)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      data: {},
      revisions_data: {},
      inputs: {},
      fatigues: {},
      data_permission: 1
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.createRevision = _this.createRevision.bind(_this);
    _this.confirmCreate = _this.confirmCreate.bind(_this);
    _this.loadData = _this.loadData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(StaffRfmsReportAdmEdit, [{
    key: 'handleChangeData',
    value: function handleChangeData(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      var data_temp = [];
      var self = this;
      Object.keys(this.state.inputs).map(function (k) {
        if (self.state.inputs[k].id === name) {
          var _change;

          change = (_change = {
            value: event.label,
            value_input: event.value,
            id: self.state.inputs[k].id,
            name: self.state.inputs[k].name,
            type_str: self.state.inputs[k].type_str,
            type: self.state.inputs[k].type,
            fatigue_options: self.state.inputs[k].fatigue_options,
            operator: self.state.inputs[k].operator,
            hour_points: self.state.inputs[k].hour_points,
            quantity_points: self.state.inputs[k].quantity_points,
            point_limit: self.state.inputs[k].point_limit,
            required: self.state.inputs[k].required,
            max_points: self.state.inputs[k].max_points,
            min_points: self.state.inputs[k].min_points,
            aps_day: self.state.inputs[k].aps_day,
            hours_day: self.state.inputs[k].hours_day,
            nocturnal_extra_points: self.state.inputs[k].nocturnal_extra_points,
            reduction_points: self.state.inputs[k].reduction_points,
            extra_hours: self.state.inputs[k].extra_hours,
            automation_type: self.state.inputs[k].automation_type,
            limit_extra_hours_week: self.state.inputs[k].limit_extra_hours_week,
            limit_extra_hours_month: self.state.inputs[k].limit_extra_hours_month,
            day_limit_extra_hours_week: self.state.inputs[k].day_limit_extra_hours_week,
            day_limit_extra_hours_month: self.state.inputs[k].day_limit_extra_hours_month,
            automation_type_id: self.state.inputs[k].automation_type_id,
            automation_field: self.state.inputs[k].automation_field
          }, _defineProperty(_change, 'automation_type', self.state.inputs[k].automation_type), _defineProperty(_change, 'automation_type_name', self.state.inputs[k].automation_type_name), _defineProperty(_change, 'api_type', self.state.inputs[k].api_type), _change);
        } else {
          var _change2;

          change = (_change2 = {
            value: self.state.inputs[k].value,
            value_input: self.state.inputs[k].value_input,
            id: self.state.inputs[k].id,
            name: self.state.inputs[k].name,
            type_str: self.state.inputs[k].type_str,
            type: self.state.inputs[k].type,
            fatigue_options: self.state.inputs[k].fatigue_options,
            operator: self.state.inputs[k].operator,
            hour_points: self.state.inputs[k].hour_points,
            quantity_points: self.state.inputs[k].quantity_points,
            point_limit: self.state.inputs[k].point_limit,
            required: self.state.inputs[k].required,
            max_points: self.state.inputs[k].max_points,
            min_points: self.state.inputs[k].min_points,
            aps_day: self.state.inputs[k].aps_day,
            hours_day: self.state.inputs[k].hours_day,
            nocturnal_extra_points: self.state.inputs[k].nocturnal_extra_points,
            reduction_points: self.state.inputs[k].reduction_points,
            extra_hours: self.state.inputs[k].extra_hours,
            automation_type: self.state.inputs[k].automation_type,
            limit_extra_hours_week: self.state.inputs[k].limit_extra_hours_week,
            limit_extra_hours_month: self.state.inputs[k].limit_extra_hours_month,
            day_limit_extra_hours_week: self.state.inputs[k].day_limit_extra_hours_week,
            day_limit_extra_hours_month: self.state.inputs[k].day_limit_extra_hours_month,
            automation_type_id: self.state.inputs[k].automation_type_id,
            automation_field: self.state.inputs[k].automation_field
          }, _defineProperty(_change2, 'automation_type', self.state.inputs[k].automation_type), _defineProperty(_change2, 'automation_type_name', self.state.inputs[k].automation_type_name), _defineProperty(_change2, 'api_type', self.state.inputs[k].api_type), _change2);
        }
        data_temp.push(change);
      });
      this.setState({ inputs: data_temp });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      var data_temp = [];
      var self = this;
      Object.keys(this.state.inputs).map(function (k) {
        if (self.state.inputs[k].id === name) {
          var _change3;

          change = (_change3 = {
            value: event.target.value,
            value_input: event.target.value,
            id: self.state.inputs[k].id,
            name: self.state.inputs[k].name,
            type_str: self.state.inputs[k].type_str,
            type: self.state.inputs[k].type,
            fatigue_options: self.state.inputs[k].fatigue_options,
            operator: self.state.inputs[k].operator,
            hour_points: self.state.inputs[k].hour_points,
            quantity_points: self.state.inputs[k].quantity_points,
            point_limit: self.state.inputs[k].point_limit,
            required: self.state.inputs[k].required,
            max_points: self.state.inputs[k].max_points,
            min_points: self.state.inputs[k].min_points,
            aps_day: self.state.inputs[k].aps_day,
            hours_day: self.state.inputs[k].hours_day,
            nocturnal_extra_points: self.state.inputs[k].nocturnal_extra_points,
            reduction_points: self.state.inputs[k].reduction_points,
            extra_hours: self.state.inputs[k].extra_hours,
            automation_type: self.state.inputs[k].automation_type,
            limit_extra_hours_week: self.state.inputs[k].limit_extra_hours_week,
            limit_extra_hours_month: self.state.inputs[k].limit_extra_hours_month,
            day_limit_extra_hours_week: self.state.inputs[k].day_limit_extra_hours_week,
            day_limit_extra_hours_month: self.state.inputs[k].day_limit_extra_hours_month,
            automation_type_id: self.state.inputs[k].automation_type_id,
            automation_field: self.state.inputs[k].automation_field
          }, _defineProperty(_change3, 'automation_type', self.state.inputs[k].automation_type), _defineProperty(_change3, 'automation_type_name', self.state.inputs[k].automation_type_name), _defineProperty(_change3, 'api_type', self.state.inputs[k].api_type), _change3);
        } else {
          var _change4;

          change = (_change4 = {
            value: self.state.inputs[k].value,
            value_input: self.state.inputs[k].value_input,
            id: self.state.inputs[k].id,
            name: self.state.inputs[k].name,
            type_str: self.state.inputs[k].type_str,
            type: self.state.inputs[k].type,
            fatigue_options: self.state.inputs[k].fatigue_options,
            operator: self.state.inputs[k].operator,
            hour_points: self.state.inputs[k].hour_points,
            quantity_points: self.state.inputs[k].quantity_points,
            point_limit: self.state.inputs[k].point_limit,
            required: self.state.inputs[k].required,
            max_points: self.state.inputs[k].max_points,
            min_points: self.state.inputs[k].min_points,
            aps_day: self.state.inputs[k].aps_day,
            hours_day: self.state.inputs[k].hours_day,
            nocturnal_extra_points: self.state.inputs[k].nocturnal_extra_points,
            reduction_points: self.state.inputs[k].reduction_points,
            extra_hours: self.state.inputs[k].extra_hours,
            automation_type: self.state.inputs[k].automation_type,
            limit_extra_hours_week: self.state.inputs[k].limit_extra_hours_week,
            limit_extra_hours_month: self.state.inputs[k].limit_extra_hours_month,
            day_limit_extra_hours_week: self.state.inputs[k].day_limit_extra_hours_week,
            day_limit_extra_hours_month: self.state.inputs[k].day_limit_extra_hours_month,
            automation_type_id: self.state.inputs[k].automation_type_id,
            automation_field: self.state.inputs[k].automation_field
          }, _defineProperty(_change4, 'automation_type', self.state.inputs[k].automation_type), _defineProperty(_change4, 'automation_type_name', self.state.inputs[k].automation_type_name), _defineProperty(_change4, 'api_type', self.state.inputs[k].api_type), _change4);
        }
        data_temp.push(change);
      });
      this.setState({ inputs: data_temp });
    }
  }, {
    key: 'handleNavTab',
    value: function handleNavTab(state, key) {
      var change = {};
      change[state] = key;
      this.setState(change);
      this.setState({ overlay: { message: '', type: '', status: '' } });
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }

    //LM

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData(event) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio-de-fadiga/' + self.props.match.params.id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url', '/contratos');
          if (responseJson.status === 'success') {
            if (responseJson.data.fatigues === null || typeof responseJson.data.fatigues === 'undefined') {
              fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/parametros-de-fadiga/relatorio-de-fadiga', { method: 'GET', mode: 'cors', headers: value }).then(function (responseSimple) {
                return responseSimple.json();
              }).catch(function (error) {
                console.error(error);
              }).then(function (responseSimpleJson) {
                self.refs.request_api.validate(responseSimpleJson);
                if (responseSimpleJson.status === 'success') {
                  var change = {};
                  var data_temp = [];
                  Object.keys(responseSimpleJson.data.params).map(function (k) {
                    var _change5;

                    var change = (_change5 = {
                      value: null,
                      id: responseSimpleJson.data.params[k].id,
                      name: responseSimpleJson.data.params[k].name,
                      type_str: responseSimpleJson.data.params[k].type_str,
                      type: responseSimpleJson.data.params[k].type,
                      fatigue_options: responseSimpleJson.data.params[k].fatigue_options,
                      operator: responseSimpleJson.data.params[k].operator,
                      hour_points: responseSimpleJson.data.params[k].hour_points,
                      quantity_points: responseSimpleJson.data.params[k].quantity_points,
                      point_limit: responseSimpleJson.data.params[k].point_limit,
                      required: responseSimpleJson.data.params[k].required,
                      max_points: responseSimpleJson.data.params[k].max_points,
                      min_points: responseSimpleJson.data.params[k].min_points,
                      aps_day: responseSimpleJson.data.params[k].aps_day,
                      hours_day: responseSimpleJson.data.params[k].hours_day,
                      nocturnal_extra_points: responseSimpleJson.data.params[k].nocturnal_extra_points,
                      reduction_points: responseSimpleJson.data.params[k].reduction_points,
                      extra_hours: responseSimpleJson.data.params[k].extra_hours,
                      automation_type: responseSimpleJson.data.params[k].automation_type,
                      limit_extra_hours_week: responseSimpleJson.data.params[k].limit_extra_hours_week,
                      limit_extra_hours_month: responseSimpleJson.data.params[k].limit_extra_hours_month,
                      day_limit_extra_hours_week: responseSimpleJson.data.params[k].day_limit_extra_hours_week,
                      day_limit_extra_hours_month: responseSimpleJson.data.params[k].day_limit_extra_hours_month,
                      automation_type_id: responseSimpleJson.data.params[k].automation_type_id,
                      automation_field: responseSimpleJson.data.params[k].automation_field
                    }, _defineProperty(_change5, 'automation_type', responseSimpleJson.data.params[k].automation_type), _defineProperty(_change5, 'automation_type_name', responseSimpleJson.data.params[k].automation_type_name), _defineProperty(_change5, 'api_type', responseSimpleJson.data.params[k].api_type), _change5);
                    data_temp.push(change);
                  });
                  self.setState({ inputs: data_temp });
                }
              });
              self.setState({ data: responseJson.data });
              self.setState({ fatigues: responseJson.data.staff_rfms_report_fatigues });
            } else {
              self.setState({ data: responseJson.data });
              self.setState({ inputs: responseJson.data.fatigues });
              self.setState({ fatigues: responseJson.data.staff_rfms_report_fatigues });
            }
          }
        }).then(function () {
          var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio-de-fadiga/revisoes/' + self.props.match.params.id;
          fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson);
            if (responseJson.status === 'success') {
              self.setState({ revisions_data: responseJson.data });
            }
          }).then(function () {
            var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/verificar/permissao/administrativo/criar-revisao/' + self.props.match.params.id + '/' + self.props.match.params.staff_id + '/' + self.props.match.params.applicability_id;
            fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.refs.request_api.validate(responseJson);
              if (responseJson.status === 'success') {
                self.setState({ staff_name: responseJson.staff_name });
                self.setState({ data_permission: responseJson.data });
              }
            }).then(function () {
              self.setState({ overlay: { message: '', type: '', status: 'closed' } });
              if (typeof event === 'undefined') {
                self.handleMessage();
              } else {
                self.handleAlert(event.message, event.status, 'open');
              }
            }); /* Overlay */
          }); /* Revisões */
        }); /* Verificar se é permitido criar revisões */
      });
    }
  }, {
    key: 'confirmCreate',
    value: function confirmCreate(event) {
      event.preventDefault();
      var self = this;
      var confirmed = 0;
      Object.keys(self.state.inputs).map(function (k) {
        if (self.state.inputs[k].value !== null && typeof self.state.inputs[k].value !== 'undefined') {
          var value = self.state.inputs[k].value;
          if (self.state.inputs[k].type == 'hour') {
            var arr = value.split(':');
            value = parseFloat(parseInt(arr[0], 10) + '.' + parseInt(arr[1] / 6 * 10, 10));
            value = value * self.state.inputs[k].hour_points;
          } else if (self.state.inputs[k].type == 'quantity') {
            value = value * self.state.inputs[k].quantity_points;
          }

          if (self.state.inputs[k].max_points !== null) {
            if (value > self.state.inputs[k].max_points) {
              var confirm = window.confirm(self.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.noParametroAPontuacaoMaximaFoiUltrapassada(self.state.inputs[k].name));
              if (confirm) {
                if (confirmed !== null) {
                  confirmed++;
                }
              } else {
                confirmed = null;
              }
            }
          }
          if (self.state.inputs[k].min_points !== null) {
            if (value < self.state.inputs[k].min_points) {
              var confirm = window.confirm(self.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.noParametroAPontuacaoMinimaNaoFoiAtingida(self.state.inputs[k].name));
              if (confirm) {
                if (confirmed !== null) {
                  confirmed++;
                }
              } else {
                confirmed = null;
              }
            }
          }
        }
      });
      if (confirmed >= 0 && confirmed !== null) {
        this.createRevision();
      }
    }
  }, {
    key: 'createRevision',
    value: function createRevision() {
      this.handleAlert('', '', 'open');
      var datasave = {
        inputs: this.state.inputs,
        date_str: this.state.data.date_str,
        revision_id: this.props.match.params.id,
        staff_id: this.props.match.params.staff_id,
        applicability_id: this.props.match.params.applicability_id
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio-de-fadiga/administrativo/criar-revisao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var url = '/relatorio-de-fadiga/tripulante/administrativo/editar/' + responseJson.data.id + '/' + responseJson.applicability_id + '/' + responseJson.staff_id;
            var storage = {
              alert_message: responseJson.message,
              alert_type: responseJson.status
            };
            localStorage.setItem("verify_message", JSON.stringify(storage));
            document.location = url;
          }
          self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      var x = 0;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.titulo,
              ' ',
              this.state.data.revision,
              ' - ',
              this.state.staff_name
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/administrativo/relatorio-de-fadiga/cadastrar', className: 'btn btn-default pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-left' }),
              ' ',
              this.locale.general.voltar
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                this.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.paragrafoStatusDaRevisao,
                ': ',
                self.state.data.revision_status
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                this.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.paragrafoQuantidadeDePontosAtual,
                ': ',
                self.state.data.actual_points_str
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                this.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.paragrafoQuantidadeDePontosReportados,
                ': ',
                self.state.data.report_points_str
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Tabs */],
              { activeKey: this.state.key, onSelect: this.handleNavTab.bind(this, 'key'), id: 'controlled-tab-example' },
              Object.keys(self.state.revisions_data).map(function (k) {
                x = x + 1;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                  { eventKey: x, title: self.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.tabRevisao.tituloTab + self.state.revisions_data[k].revision },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    self.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.tabRevisao.paragrafoStatusDaRevisao,
                    ': ',
                    self.state.revisions_data[k].revision_status
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    self.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.tabRevisao.paragrafoQuantidadeDePontosAtual,
                    ': ',
                    self.state.revisions_data[k].actual_points_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    self.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.tabRevisao.paragrafoQuantidadeDePontosReportados,
                    ': ',
                    self.state.revisions_data[k].report_points_str
                  )
                );
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              this.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.tituloCriarRevisao
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            self.state.data_permission === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: self.confirmCreate },
              Object.keys(self.state.inputs).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    self.state.inputs[k].name + " - " + self.state.inputs[k].type_str
                  ),
                  self.state.inputs[k].type === 'options' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    name: 'type',
                    value: self.state.inputs[k].value_input,
                    required: self.state.inputs[k].required,
                    searchable: true,
                    placeholder: self.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.formularioCriarRevisao.placeholder.SelecionarOpcao,
                    onChange: self.handleSelectChange.bind(self, self.state.inputs[k].id),
                    options: self.state.inputs[k]['fatigue_options']
                  }) : self.state.inputs[k].type === 'hour' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { required: self.state.inputs[k].required, value: self.state.inputs[k].value, maskChar: null, name: "fatigue_reason_" + self.state.inputs[k].id, mask: '99:99', className: 'form-control', onChange: self.handleChange.bind(self, self.state.inputs[k].id), placeholder: self.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.formularioCriarRevisao.placeholder.Horas }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { required: self.state.inputs[k].required, type: 'text', name: "fatigue_reason_" + self.state.inputs[k].id, className: "form-control", placeholder: self.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.formularioCriarRevisao.placeholder.Quantidade, value: self.state.inputs[k].value, onChange: self.handleChange.bind(self, self.state.inputs[k].id) })
                );
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { disabled: self.state.data_permission === 0 ? 'disabled' : "", type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                    ' ',
                    this.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.formularioCriarRevisao.botaoCriarRevisaoDeRelatorioDeFadiga
                  )
                )
              )
            ) : ""
          )
        )
      );
    }
  }]);

  return StaffRfmsReportAdmEdit;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffRfmsReportAdmEdit);

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














// Tabs

var StaffRfmsReportEdit = function (_Component) {
  _inherits(StaffRfmsReportEdit, _Component);

  function StaffRfmsReportEdit(props) {
    _classCallCheck(this, StaffRfmsReportEdit);

    var _this = _possibleConstructorReturn(this, (StaffRfmsReportEdit.__proto__ || Object.getPrototypeOf(StaffRfmsReportEdit)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      data: {},
      revisions_data: {},
      inputs: {},
      fatigues: {},
      data_permission: 1
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.createRevision = _this.createRevision.bind(_this);
    _this.confirmCreate = _this.confirmCreate.bind(_this);
    _this.loadData = _this.loadData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(StaffRfmsReportEdit, [{
    key: 'handleChangeData',
    value: function handleChangeData(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      var data_temp = [];
      var self = this;
      Object.keys(this.state.inputs).map(function (k) {
        if (self.state.inputs[k].id === name) {
          var _change;

          change = (_change = {
            value: event.label,
            value_input: event.value,
            id: self.state.inputs[k].id,
            name: self.state.inputs[k].name,
            type_str: self.state.inputs[k].type_str,
            type: self.state.inputs[k].type,
            fatigue_options: self.state.inputs[k].fatigue_options,
            operator: self.state.inputs[k].operator,
            hour_points: self.state.inputs[k].hour_points,
            quantity_points: self.state.inputs[k].quantity_points,
            point_limit: self.state.inputs[k].point_limit,
            required: self.state.inputs[k].required,
            max_points: self.state.inputs[k].max_points,
            min_points: self.state.inputs[k].min_points,
            aps_day: self.state.inputs[k].aps_day,
            hours_day: self.state.inputs[k].hours_day,
            nocturnal_extra_points: self.state.inputs[k].nocturnal_extra_points,
            reduction_points: self.state.inputs[k].reduction_points,
            extra_hours: self.state.inputs[k].extra_hours,
            automation_type: self.state.inputs[k].automation_type,
            limit_extra_hours_week: self.state.inputs[k].limit_extra_hours_week,
            limit_extra_hours_month: self.state.inputs[k].limit_extra_hours_month,
            day_limit_extra_hours_week: self.state.inputs[k].day_limit_extra_hours_week,
            day_limit_extra_hours_month: self.state.inputs[k].day_limit_extra_hours_month,
            automation_type_id: self.state.inputs[k].automation_type_id,
            automation_field: self.state.inputs[k].automation_field
          }, _defineProperty(_change, 'automation_type', self.state.inputs[k].automation_type), _defineProperty(_change, 'automation_type_name', self.state.inputs[k].automation_type_name), _defineProperty(_change, 'api_type', self.state.inputs[k].api_type), _change);
        } else {
          var _change2;

          change = (_change2 = {
            value: self.state.inputs[k].value,
            value_input: self.state.inputs[k].value_input,
            id: self.state.inputs[k].id,
            name: self.state.inputs[k].name,
            type_str: self.state.inputs[k].type_str,
            type: self.state.inputs[k].type,
            fatigue_options: self.state.inputs[k].fatigue_options,
            operator: self.state.inputs[k].operator,
            hour_points: self.state.inputs[k].hour_points,
            quantity_points: self.state.inputs[k].quantity_points,
            point_limit: self.state.inputs[k].point_limit,
            required: self.state.inputs[k].required,
            max_points: self.state.inputs[k].max_points,
            min_points: self.state.inputs[k].min_points,
            aps_day: self.state.inputs[k].aps_day,
            hours_day: self.state.inputs[k].hours_day,
            nocturnal_extra_points: self.state.inputs[k].nocturnal_extra_points,
            reduction_points: self.state.inputs[k].reduction_points,
            extra_hours: self.state.inputs[k].extra_hours,
            automation_type: self.state.inputs[k].automation_type,
            limit_extra_hours_week: self.state.inputs[k].limit_extra_hours_week,
            limit_extra_hours_month: self.state.inputs[k].limit_extra_hours_month,
            day_limit_extra_hours_week: self.state.inputs[k].day_limit_extra_hours_week,
            day_limit_extra_hours_month: self.state.inputs[k].day_limit_extra_hours_month,
            automation_type_id: self.state.inputs[k].automation_type_id,
            automation_field: self.state.inputs[k].automation_field
          }, _defineProperty(_change2, 'automation_type', self.state.inputs[k].automation_type), _defineProperty(_change2, 'automation_type_name', self.state.inputs[k].automation_type_name), _defineProperty(_change2, 'api_type', self.state.inputs[k].api_type), _change2);
        }
        data_temp.push(change);
      });
      this.setState({ inputs: data_temp });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      var data_temp = [];
      var self = this;
      Object.keys(this.state.inputs).map(function (k) {
        if (self.state.inputs[k].id === name) {
          var _change3;

          change = (_change3 = {
            value: event.target.value,
            value_input: event.target.value,
            id: self.state.inputs[k].id,
            name: self.state.inputs[k].name,
            type_str: self.state.inputs[k].type_str,
            type: self.state.inputs[k].type,
            fatigue_options: self.state.inputs[k].fatigue_options,
            operator: self.state.inputs[k].operator,
            hour_points: self.state.inputs[k].hour_points,
            quantity_points: self.state.inputs[k].quantity_points,
            point_limit: self.state.inputs[k].point_limit,
            required: self.state.inputs[k].required,
            max_points: self.state.inputs[k].max_points,
            min_points: self.state.inputs[k].min_points,
            aps_day: self.state.inputs[k].aps_day,
            hours_day: self.state.inputs[k].hours_day,
            nocturnal_extra_points: self.state.inputs[k].nocturnal_extra_points,
            reduction_points: self.state.inputs[k].reduction_points,
            extra_hours: self.state.inputs[k].extra_hours,
            automation_type: self.state.inputs[k].automation_type,
            limit_extra_hours_week: self.state.inputs[k].limit_extra_hours_week,
            limit_extra_hours_month: self.state.inputs[k].limit_extra_hours_month,
            day_limit_extra_hours_week: self.state.inputs[k].day_limit_extra_hours_week,
            day_limit_extra_hours_month: self.state.inputs[k].day_limit_extra_hours_month,
            automation_type_id: self.state.inputs[k].automation_type_id,
            automation_field: self.state.inputs[k].automation_field
          }, _defineProperty(_change3, 'automation_type', self.state.inputs[k].automation_type), _defineProperty(_change3, 'automation_type_name', self.state.inputs[k].automation_type_name), _defineProperty(_change3, 'api_type', self.state.inputs[k].api_type), _change3);
        } else {
          var _change4;

          change = (_change4 = {
            value: self.state.inputs[k].value,
            value_input: self.state.inputs[k].value_input,
            id: self.state.inputs[k].id,
            name: self.state.inputs[k].name,
            type_str: self.state.inputs[k].type_str,
            type: self.state.inputs[k].type,
            fatigue_options: self.state.inputs[k].fatigue_options,
            operator: self.state.inputs[k].operator,
            hour_points: self.state.inputs[k].hour_points,
            quantity_points: self.state.inputs[k].quantity_points,
            point_limit: self.state.inputs[k].point_limit,
            required: self.state.inputs[k].required,
            max_points: self.state.inputs[k].max_points,
            min_points: self.state.inputs[k].min_points,
            aps_day: self.state.inputs[k].aps_day,
            hours_day: self.state.inputs[k].hours_day,
            nocturnal_extra_points: self.state.inputs[k].nocturnal_extra_points,
            reduction_points: self.state.inputs[k].reduction_points,
            extra_hours: self.state.inputs[k].extra_hours,
            automation_type: self.state.inputs[k].automation_type,
            limit_extra_hours_week: self.state.inputs[k].limit_extra_hours_week,
            limit_extra_hours_month: self.state.inputs[k].limit_extra_hours_month,
            day_limit_extra_hours_week: self.state.inputs[k].day_limit_extra_hours_week,
            day_limit_extra_hours_month: self.state.inputs[k].day_limit_extra_hours_month,
            automation_type_id: self.state.inputs[k].automation_type_id,
            automation_field: self.state.inputs[k].automation_field
          }, _defineProperty(_change4, 'automation_type', self.state.inputs[k].automation_type), _defineProperty(_change4, 'automation_type_name', self.state.inputs[k].automation_type_name), _defineProperty(_change4, 'api_type', self.state.inputs[k].api_type), _change4);
        }
        data_temp.push(change);
      });
      this.setState({ inputs: data_temp });
    }
  }, {
    key: 'handleNavTab',
    value: function handleNavTab(state, key) {
      var change = {};
      change[state] = key;
      this.setState(change);
      this.setState({ overlay: { message: '', type: '', status: '' } });
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }

    //LM

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData(event) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio-de-fadiga/' + self.props.match.params.id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url', '/contratos');
          if (responseJson.status === 'success') {
            if (responseJson.data.fatigues === null || typeof responseJson.data.fatigues === 'undefined') {
              fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/parametros-de-fadiga/relatorio-de-fadiga', { method: 'GET', mode: 'cors', headers: value }).then(function (responseSimple) {
                return responseSimple.json();
              }).catch(function (error) {
                console.error(error);
              }).then(function (responseSimpleJson) {
                self.refs.request_api.validate(responseSimpleJson);
                if (responseSimpleJson.status === 'success') {
                  var change = {};
                  var data_temp = [];
                  Object.keys(responseSimpleJson.data.params).map(function (k) {
                    var _change5;

                    var change = (_change5 = {
                      value: null,
                      value_input: null,
                      id: responseSimpleJson.data.params[k].id,
                      name: responseSimpleJson.data.params[k].name,
                      type_str: responseSimpleJson.data.params[k].type_str,
                      type: responseSimpleJson.data.params[k].type,
                      fatigue_options: responseSimpleJson.data.params[k].fatigue_options,
                      operator: responseSimpleJson.data.params[k].operator,
                      hour_points: responseSimpleJson.data.params[k].hour_points,
                      quantity_points: responseSimpleJson.data.params[k].quantity_points,
                      point_limit: responseSimpleJson.data.params[k].point_limit,
                      required: responseSimpleJson.data.params[k].required,
                      max_points: responseSimpleJson.data.params[k].max_points,
                      min_points: responseSimpleJson.data.params[k].min_points,
                      aps_day: responseSimpleJson.data.params[k].aps_day,
                      hours_day: responseSimpleJson.data.params[k].hours_day,
                      nocturnal_extra_points: responseSimpleJson.data.params[k].nocturnal_extra_points,
                      reduction_points: responseSimpleJson.data.params[k].reduction_points,
                      extra_hours: responseSimpleJson.data.params[k].extra_hours,
                      automation_type: responseSimpleJson.data.params[k].automation_type,
                      limit_extra_hours_week: responseSimpleJson.data.params[k].limit_extra_hours_week,
                      limit_extra_hours_month: responseSimpleJson.data.params[k].limit_extra_hours_month,
                      day_limit_extra_hours_week: responseSimpleJson.data.params[k].day_limit_extra_hours_week,
                      day_limit_extra_hours_month: responseSimpleJson.data.params[k].day_limit_extra_hours_month,
                      automation_type_id: responseSimpleJson.data.params[k].automation_type_id,
                      automation_field: responseSimpleJson.data.params[k].automation_field
                    }, _defineProperty(_change5, 'automation_type', responseSimpleJson.data.params[k].automation_type), _defineProperty(_change5, 'automation_type_name', responseSimpleJson.data.params[k].automation_type_name), _defineProperty(_change5, 'api_type', responseSimpleJson.data.params[k].api_type), _change5);
                    data_temp.push(change);
                  });
                  self.setState({ inputs: data_temp });
                }
              });
              self.setState({ data: responseJson.data });
              self.setState({ fatigues: responseJson.data.staff_rfms_report_fatigues });
            } else {
              self.setState({ data: responseJson.data });
              self.setState({ inputs: responseJson.data.fatigues });
              self.setState({ fatigues: responseJson.data.staff_rfms_report_fatigues });
            }
          }
        }).then(function () {
          var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio-de-fadiga/revisoes/' + self.props.match.params.id;
          fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson);
            if (responseJson.status === 'success') {
              self.setState({ revisions_data: responseJson.data });
            }
          }).then(function () {
            var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/verificar/permissao/criar-revisao/' + self.props.match.params.id;
            fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
              return response.json();
            }).catch(function (error) {
              console.error(error);
            }).then(function (responseJson) {
              self.refs.request_api.validate(responseJson);
              if (responseJson.status === 'success') {
                self.setState({ data_permission: responseJson.data });
              }
            }).then(function () {
              self.setState({ overlay: { message: '', type: '', status: 'closed' } });
              if (typeof event === 'undefined') {
                self.handleMessage();
              } else {
                self.handleAlert(event.message, event.status, 'open');
              }
            }); /* Overlay */
          }); /* Revisões */
        }); /* Verificar se é permitido criar revisões */
      });
    }
  }, {
    key: 'confirmCreate',
    value: function confirmCreate(event) {
      event.preventDefault();
      var self = this;
      var confirmed = 0;
      Object.keys(self.state.inputs).map(function (k) {
        if (self.state.inputs[k].value !== null && typeof self.state.inputs[k].value !== 'undefined') {
          var value = self.state.inputs[k].value;
          if (self.state.inputs[k].type == 'hour') {
            var arr = value.split(':');
            value = parseFloat(parseInt(arr[0], 10) + '.' + parseInt(arr[1] / 6 * 10, 10));
            value = value * self.state.inputs[k].hour_points;
          } else if (self.state.inputs[k].type == 'quantity') {
            value = value * self.state.inputs[k].quantity_points;
          }

          if (self.state.inputs[k].max_points !== null) {
            if (value > self.state.inputs[k].max_points) {
              var confirm = window.confirm(self.locale.RelatoriosDeFadiga.EditarRelatorioDeFadiga.noParametroAPontuacaoMaximaFoiUltrapassada(self.state.inputs[k].name));
              if (confirm) {
                if (confirmed !== null) {
                  confirmed++;
                }
              } else {
                confirmed = null;
              }
            }
          }
          if (self.state.inputs[k].min_points !== null) {
            if (value < self.state.inputs[k].min_points) {
              var confirm = window.confirm(self.locale.RelatoriosDeFadiga.EditarRelatorioDeFadiga.noParametroAPontuacaoMinimaNaoFoiAtingida(self.state.inputs[k].name));
              if (confirm) {
                if (confirmed !== null) {
                  confirmed++;
                }
              } else {
                confirmed = null;
              }
            }
          }
        }
      });
      if (confirmed >= 0 && confirmed !== null) {
        this.createRevision();
      }
    }
  }, {
    key: 'createRevision',
    value: function createRevision() {
      this.handleAlert('', '', 'open');
      var datasave = {
        inputs: this.state.inputs,
        date_str: this.state.data.date_str,
        revision_id: this.props.match.params.id
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio-de-fadiga/criar-revisao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var url = '/relatorio-de-fadiga/tripulante/editar/' + responseJson.data.id;
            var storage = {
              alert_message: responseJson.message,
              alert_type: responseJson.status
            };
            localStorage.setItem("verify_message", JSON.stringify(storage));
            document.location = url;
          }
          self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      var x = 0;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.RelatoriosDeFadiga.EditarRelatorioDeFadiga.titulo,
              ' ',
              this.state.data.revision
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/relatorios-de-fadiga/tripulante', className: 'btn btn-default pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-left' }),
              ' ',
              this.locale.general.voltar
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                this.locale.RelatoriosDeFadiga.EditarRelatorioDeFadiga.paragrafoStatusDaRevisao,
                ': ',
                self.state.data.revision_status
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                this.locale.RelatoriosDeFadiga.EditarRelatorioDeFadiga.paragrafoQuantidadeDePontosAtual,
                ': ',
                self.state.data.actual_points_str
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'p',
                null,
                this.locale.RelatoriosDeFadiga.EditarRelatorioDeFadiga.paragrafoQuantidadeDePontosReportados,
                ': ',
                self.state.data.report_points_str
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["e" /* Tabs */],
              { activeKey: this.state.key, onSelect: this.handleNavTab.bind(this, 'key'), id: 'controlled-tab-example' },
              Object.keys(self.state.revisions_data).map(function (k) {
                x = x + 1;
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["f" /* Tab */],
                  { eventKey: x, title: self.locale.RelatoriosDeFadiga.EditarRelatorioDeFadiga.tabRevisao.tituloTab + self.state.revisions_data[k].revision },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    self.locale.RelatoriosDeFadiga.EditarRelatorioDeFadiga.tabRevisao.paragrafoStatusDaRevisao,
                    ': ',
                    self.state.revisions_data[k].revision_status
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    self.locale.RelatoriosDeFadiga.EditarRelatorioDeFadiga.tabRevisao.paragrafoQuantidadeDePontosAtual,
                    ': ',
                    self.state.revisions_data[k].actual_points_str
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'p',
                    null,
                    self.locale.RelatoriosDeFadiga.EditarRelatorioDeFadiga.tabRevisao.paragrafoQuantidadeDePontosReportados,
                    ': ',
                    self.state.revisions_data[k].report_points_str
                  )
                );
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              this.locale.RelatoriosDeFadiga.EditarRelatorioDeFadiga.tituloCriarRevisao
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            self.state.data_permission === 1 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: self.confirmCreate },
              Object.keys(self.state.inputs).map(function (k) {
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'form-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'label',
                    null,
                    self.state.inputs[k].name + " - " + self.state.inputs[k].type_str
                  ),
                  self.state.inputs[k].type === 'options' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                    className: 'form-field-name',
                    name: 'type',
                    value: self.state.inputs[k].value_input,
                    required: self.state.inputs[k].required,
                    searchable: true,
                    placeholder: self.locale.RelatoriosDeFadiga.EditarRelatorioDeFadiga.formularioCriarRevisao.placeholder.SelecionarOpcao,
                    onChange: self.handleSelectChange.bind(self, self.state.inputs[k].id),
                    options: self.state.inputs[k]['fatigue_options']
                  }) : self.state.inputs[k].type === 'hour' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { required: self.state.inputs[k].required, value: self.state.inputs[k].value, maskChar: null, name: "fatigue_reason_" + self.state.inputs[k].id, mask: '99:99', className: 'form-control', onChange: self.handleChange.bind(self, self.state.inputs[k].id), placeholder: self.locale.RelatoriosDeFadiga.EditarRelatorioDeFadiga.formularioCriarRevisao.placeholder.Horas }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { required: self.state.inputs[k].required, type: 'text', name: "fatigue_reason_" + self.state.inputs[k].id, className: "form-control", placeholder: self.locale.RelatoriosDeFadiga.EditarRelatorioDeFadiga.formularioCriarRevisao.placeholder.Quantidade, value: self.state.inputs[k].value, onChange: self.handleChange.bind(self, self.state.inputs[k].id) })
                );
              }),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { disabled: self.state.data_permission === 0 ? 'disabled' : "", type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                    ' ',
                    this.locale.RelatoriosDeFadiga.EditarRelatorioDeFadiga.formularioCriarRevisao.botaoCriarRevisaoDeRelatorioDeFadiga
                  )
                )
              )
            ) : ""
          )
        )
      );
    }
  }]);

  return StaffRfmsReportEdit;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffRfmsReportEdit);

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_recharts__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














// Importação da tabela



var StaffRfmsReportFilter = function (_Component) {
  _inherits(StaffRfmsReportFilter, _Component);

  function StaffRfmsReportFilter(props) {
    _classCallCheck(this, StaffRfmsReportFilter);

    var _this = _possibleConstructorReturn(this, (StaffRfmsReportFilter.__proto__ || Object.getPrototypeOf(StaffRfmsReportFilter)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: null,
      fatigue_incident: 0,
      applicabilities_list: [],
      staff_list: [],
      roles_list: [],
      aircraft_models_list: [],
      bases_list: [],
      date_start: '',
      date_finish: '',
      applicability_id: '',
      crew_visibility: { display: 'none' }
    };

    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.delete = _this.delete.bind(_this);
    _this.deleteRow = _this.deleteRow.bind(_this);
    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    _this.searchReports = _this.searchReports.bind(_this);
    _this.toggleCheckbox = _this.toggleCheckbox.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(StaffRfmsReportFilter, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeApplicability',
    value: function handleSelectChangeApplicability(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;

        var header = this.refs.request_api.header('application/json');
        var self = this;
        this.handleAlert('', '', 'open');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aplicabilidade/colaboradores/listagens/' + event.value, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.setState({
              roles_list: responseJson.data.roles,
              bases_list: responseJson.data.bases,
              staff_list: responseJson.data.staffs,
              aircraft_models_list: responseJson.data.aircraft_models
            });
            self.handleAlert(responseJson.message, responseJson.status, 'closed');
          });
        });
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios-de-fadiga/listagens';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              staff_list: responseJson.data.staff_list,
              roles_list: responseJson.data.roles_list,
              aircraft_models_list: responseJson.data.aircraft_models_list,
              bases_list: responseJson.data.bases_list,
              applicabilities_list: responseJson.data.applicabilities_list
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
        }); /* Overlay */
      });
    }
  }, {
    key: 'searchReports',
    value: function searchReports(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        staff_ids: this.state.staff_ids,
        roles: this.state.roles_ids,
        applicability_id: this.state.applicability_id,
        aircraft_models: this.state.aircraft_models_ids,
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        fatigue_incident: this.state.fatigue_incident,
        bases: this.state.bases_ids
      };

      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios-de-fadiga/buscar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          } else {
            self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var url = '/parametro-de-fadiga/editar/' + cell;

      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
          { className: 'btn btn-primary btn-sm', to: url },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-sm btn-danger', value: cell, onClick: this.delete },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-trash' })
        )
      );

      return botao;
    }
  }, {
    key: 'delete',
    value: function _delete(event) {
      var fatigue_id = event.currentTarget.value;
      var confirm = window.confirm(this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.deletar);
      if (confirm) {
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/parametro-de-fadiga/' + fatigue_id, { method: 'DELETE', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.deleteRow(fatigue_id);
            }
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'filterCrew',
    value: function filterCrew(event) {
      var self = this;
      var staff = [];
      var i = 0;
      Object.keys(self.state.data.checkboxes).map(function (k) {
        if (self.state.data.checkboxes[k].checked) {
          staff[i] = {
            value: self.state.data.checkboxes[k].staff_id,
            label: self.state.data.checkboxes[k].staff_id
          };
          i = i + 1;
        }
      });
      this.handleAlert('', '', 'open');
      var datasave = {
        staff_ids: staff,
        roles: this.state.roles_ids,
        applicability_id: this.state.applicability_id,
        aircraft_models: this.state.aircraft_models_ids,
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        fatigue_incident: this.state.fatigue_incident,
        bases: this.state.bases_ids
      };

      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios-de-fadiga/buscar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          } else {
            self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'toggleCheckbox',
    value: function toggleCheckbox(index) {
      var self = this;
      index = parseInt(index);
      // Verifica-se se o checkbox está marcado ou desmarcado
      var data = this.state.data;
      if (this.state.data.checkboxes[index].checked) {
        data.checkboxes[index].checked = false;
      } else {
        data.checkboxes[index].checked = true;
      }
      this.setState({ data: data });
    }
  }, {
    key: 'deleteRow',
    value: function deleteRow(fatigue_id) {
      var data = this.state.data;
      data.map(function (dado, index) {
        if (dado.id == fatigue_id) {
          data.splice(index, 1);
        }
      });
      this.setState({ data: data });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.searchReports },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.DataInicial,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_start, required: true, maskChar: null, name: 'date_start', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: '' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.DataFinal,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_finish, required: true, maskChar: null, name: 'date_finish', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: '' })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.AplicabilidadeTipoDeColaborador,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'applicability_id',
                      value: this.state.applicability_id,
                      searchable: true,
                      placeholder: this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.placeholder.SelecionarAplicabilidade,
                      onChange: this.handleSelectChangeApplicability.bind(this, 'applicability_id'),
                      options: this.state.applicabilities_list,
                      required: true
                    })
                  )
                ),
                this.state.applicability_id == 2 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.Mecanicos,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'staff_ids',
                      value: this.state.staff_ids,
                      searchable: true,
                      placeholder: this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.placeholder.SelecionarMecanicos,
                      onChange: this.handleSelectChange.bind(this, 'staff_ids'),
                      options: this.state.staff_list,
                      multi: true
                    })
                  )
                ) : this.state.applicability_id == 3 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.Coordenadores,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'staff_ids',
                      value: this.state.staff_ids,
                      searchable: true,
                      placeholder: this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.placeholder.SelecionarCoordenadores,
                      onChange: this.handleSelectChange.bind(this, 'staff_ids'),
                      options: this.state.staff_list,
                      multi: true
                    })
                  )
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.Tripulantes,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'staff_ids',
                      value: this.state.staff_ids,
                      searchable: true,
                      placeholder: this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.placeholder.SelecionarTripulantes,
                      onChange: this.handleSelectChange.bind(this, 'staff_ids'),
                      options: this.state.staff_list,
                      multi: true
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.Cargos,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                      className: '',
                      name: 'roles_ids',
                      value: this.state.roles_ids,
                      searchable: true,
                      multi: true,
                      placeholder: this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.placeholder.SelecionarCargos,
                      onChange: this.handleSelectChange.bind(this, 'roles_ids'),
                      options: this.state.roles_list
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.Frotas,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                      className: '',
                      name: 'aircraft_models_ids',
                      value: this.state.aircraft_models_ids,
                      searchable: true,
                      multi: true,
                      placeholder: this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.placeholder.SelecionarFrotas,
                      onChange: this.handleSelectChange.bind(this, 'aircraft_models_ids'),
                      options: this.state.aircraft_models_list
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.Bases,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                      className: '',
                      name: 'bases_ids',
                      value: this.state.bases_ids,
                      searchable: true,
                      multi: true,
                      placeholder: this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.placeholder.SelecionarBases,
                      onChange: this.handleSelectChange.bind(this, 'bases_ids'),
                      options: this.state.bases_list
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.ApenasIncidentesDeFadiga,
                      '?'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_toggle___default.a, {
                      checked: this.state.fatigue_incident,
                      'aria-label': 'No label tag',
                      name: 'fatigue_incident',
                      onChange: this.handleToggleChange.bind(this, 'fatigue_incident') })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'submit', className: 'btn btn-primary btn-block' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                  ' ',
                  this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.formulario.botaoProcurarRelatorios
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.tituloListaDeRelatoriosDeFadiga
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            self.state.data !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_9_recharts__["a" /* LineChart */],
                  { width: 890, height: 400, data: self.state.data.dates,
                    margin: { top: 5, right: 30, left: 20, bottom: 5 } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_recharts__["b" /* XAxis */], { dataKey: 'name' }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_recharts__["c" /* YAxis */], null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_recharts__["d" /* CartesianGrid */], { strokeDasharray: '3 3' }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_recharts__["e" /* Tooltip */], null),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_recharts__["f" /* Legend */], null),
                  Object.keys(self.state.data.names).map(function (k) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_recharts__["g" /* Line */], { type: 'monotone', dataKey: self.state.data.names[k].name, stroke: self.state.data.names[k].color, activeDot: { r: 8 } });
                  })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { className: 'btn btn-block btn-lg btn-success', onClick: function onClick() {
                    if (self.state.crew_visibility.display === 'none') {
                      self.setState({ crew_visibility: { display: 'block' } });
                    } else {
                      self.setState({ crew_visibility: { display: 'none' } });
                    }
                  } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-users' }),
                ' ',
                this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.botaoMostrarEsconderTripulantes
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { style: this.state.crew_visibility },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-block btn-info', onClick: function onClick() {
                      self.filterCrew();
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-users' }),
                  ' ',
                  this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.botaoFiltrarTripulantes
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'table',
                  { className: 'table table-bordered table-stripped table-hover' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'thead',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th', { className: 'col-md-1 text-center' }),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center' },
                        this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.tabela.Nome
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'th',
                        { className: 'text-center' },
                        this.locale.RelatoriosDeFadiga.FiltroDeRelatorio.tabela.Pontos
                      )
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tbody',
                    { id: 'suppliers-certifications' },
                    Object.keys(self.state.data.names_list).map(function (k) {
                      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'tr',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'td',
                          { className: 'text-center' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', {
                            name: 'payment_checked',
                            type: 'checkbox',
                            checked: self.state.data.checkboxes[k].checked,
                            className: 'checkbox-filter-search',
                            onChange: function onChange() {
                              self.toggleCheckbox(k);
                            } })
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'td',
                          { className: 'text-center' },
                          self.state.data.names_list[k].nickname
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'td',
                          { className: 'text-center' },
                          self.state.data.names_list[k].points
                        )
                      );
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { className: 'btn btn-block btn-info', onClick: function onClick() {
                      self.filterCrew();
                    } },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-users' }),
                  ' Filtrar tripulantes'
                )
              )
            ) : ""
          )
        )
      );
    }
  }]);

  return StaffRfmsReportFilter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffRfmsReportFilter);

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Elements_ToogleCheckedIncident__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }















// Importação da tabela




var StaffRfmsReportIncidentFatigueFilter = function (_Component) {
  _inherits(StaffRfmsReportIncidentFatigueFilter, _Component);

  function StaffRfmsReportIncidentFatigueFilter(props) {
    _classCallCheck(this, StaffRfmsReportIncidentFatigueFilter);

    var _this = _possibleConstructorReturn(this, (StaffRfmsReportIncidentFatigueFilter.__proto__ || Object.getPrototypeOf(StaffRfmsReportIncidentFatigueFilter)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: null,
      fatigue_incident_list: [],
      staff_list: [],
      applicabilities_list: [],
      date_start: '',
      date_finish: '',
      fatigue_event: '',
      checked: false,
      modal: false
    };

    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);
    _this.loadData = _this.loadData.bind(_this);

    _this.searchReports = _this.searchReports.bind(_this);
    _this.updateReports = _this.updateReports.bind(_this);
    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.buttonActionPlan = _this.buttonActionPlan.bind(_this);
    _this.showModal = _this.showModal.bind(_this);
    _this.editActionPlan = _this.editActionPlan.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(StaffRfmsReportIncidentFatigueFilter, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = true;
      } else {
        var value = false;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeApplicability',
    value: function handleSelectChangeApplicability(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;

        var header = this.refs.request_api.header('application/json');
        var self = this;
        this.handleAlert('', '', 'open');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aplicabilidade/colaboradores/listagens/' + event.value, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.setState({
              staff_list: responseJson.data.staffs
            });
            self.handleAlert(responseJson.message, responseJson.status, 'closed');
          });
        });
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios-de-fadiga/listagens';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              staff_list: responseJson.data.staff_list,
              applicabilities_list: responseJson.data.applicabilities_list,
              fatigue_incident_list: responseJson.data.fatigue_incident_list
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
        }); /* Overlay */
      });
    }
  }, {
    key: 'updateReports',
    value: function updateReports() {
      this.searchReports(null);
    }
  }, {
    key: 'searchReports',
    value: function searchReports(event) {
      if (event !== null) {
        event.preventDefault();
      }
      this.handleAlert('', '', 'open');
      var datasave = {
        staff_ids: this.state.staff_ids,
        applicability_id: this.state.applicability_id,
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        checked: this.state.checked,
        fatigue_event: this.state.fatigue_event
      };

      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios-de-fadiga/incidentes-de-fadiga/buscar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          } else {
            self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var self = this;
      if (row.checked == false) {
        var checked = false;
      } else {
        var checked = true;
      }
      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Elements_ToogleCheckedIncident__["a" /* default */], { updateReports: self.updateReports, handleAlert: self.handleAlert, RequestApi: self.refs.request_api, report_incident: row, actual_checked: checked })
      );

      return botao;
    }
  }, {
    key: 'buttonActionPlan',
    value: function buttonActionPlan(cell, row) {
      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'button',
        { className: 'btn btn-info button-inline', title: 'Clique para editar a a\xE7\xE3o realizada', onClick: this.showModal.bind(this, row) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-align-left' })
      );

      return botao;
    }
  }, {
    key: 'showModal',
    value: function showModal(data, event) {
      this.setState({ id: data.id, action_plan: data.action_plan, plan_fatigue_event: data.fatigue_event, modal: true });
    }
  }, {
    key: 'editActionPlan',
    value: function editActionPlan(event) {
      event.preventDefault();
      var self = this;
      this.handleAlert('', '', 'open');
      var datasave = {
        id: this.state.id,
        action_plan: this.state.action_plan
      };
      var url = '/reporte/voluntario/acao';
      if (this.state.plan_fatigue_event !== 5) {
        var url = '/relatorio-de-fadiga/tripulante/acao';
      }
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + url, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.refs.request_api.validate(responseJson, 'alert');
            self.updateReports();
            self.setState({ modal: false, id: '', action_plan: '', plan_fatigue_event: '' });
            self.handleAlert('', '', 'closed');
          } else {
            self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.searchReports },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.DataInicial,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_start, required: true, maskChar: null, name: 'date_start', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: '' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.DataFinal,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_finish, required: true, maskChar: null, name: 'date_finish', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: '' })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.AplicabilidadeTipoDeColaborador,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'applicability_id',
                      value: this.state.applicability_id,
                      searchable: true,
                      placeholder: this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.placeholder.SelecionarAplicabilidade,
                      onChange: this.handleSelectChangeApplicability.bind(this, 'applicability_id'),
                      options: this.state.applicabilities_list,
                      required: true
                    })
                  )
                ),
                this.state.applicability_id == 2 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.Mecanicos,
                        ':'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                        className: 'form-field-name',
                        name: 'staff_ids',
                        value: this.state.staff_ids,
                        searchable: true,
                        placeholder: this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.placeholder.SelecionarMecanicos,
                        onChange: this.handleSelectChange.bind(this, 'staff_ids'),
                        options: this.state.staff_list,
                        multi: true
                      })
                    )
                  )
                ) : this.state.applicability_id == 3 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.Coordenadores,
                        ':'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                        className: 'form-field-name',
                        name: 'staff_ids',
                        value: this.state.staff_ids,
                        searchable: true,
                        placeholder: this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.placeholder.SelecionarCoordenadores,
                        onChange: this.handleSelectChange.bind(this, 'staff_ids'),
                        options: this.state.staff_list,
                        multi: true
                      })
                    )
                  )
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.Tripulantes,
                        ':'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                        className: 'form-field-name',
                        name: 'staff_ids',
                        value: this.state.staff_ids,
                        searchable: true,
                        placeholder: this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.placeholder.SelecionarTripulantes,
                        onChange: this.handleSelectChange.bind(this, 'staff_ids'),
                        options: this.state.staff_list,
                        multi: true
                      })
                    )
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.TipoDeEventoIncidente,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                      className: '',
                      name: 'fatigue_event',
                      value: this.state.fatigue_event,
                      searchable: true,
                      placeholder: this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.placeholder.SelecionarIncidente,
                      onChange: this.handleSelectChange.bind(this, 'fatigue_event'),
                      options: this.state.fatigue_incident_list
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.ApenasIncidentesDeFadigaChecados,
                      '?'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_toggle___default.a, {
                      checked: this.state.checked,
                      'aria-label': 'No label tag',
                      name: 'checked',
                      onChange: this.handleToggleChange.bind(this, 'checked') })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'submit', className: 'btn btn-primary btn-block' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                  ' ',
                  this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formulario.botaoProcurarRelatorios
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tituloListaDeEventosIncidentesDeFadiga
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            self.state.data !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["BootstrapTable"],
                { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: 'Exportar CSV', noDataText: this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tabela.semEventosIncidentesDeFadiga }, search: true, multiColumnSearch: true, searchPlaceholder: 'Procurar' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '65' },
                  this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tabela.ID
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'fatigue_event_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '120' },
                  this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tabela.TipoDeEvento
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'date_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '100' },
                  this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tabela.Data
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'revision', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '70' },
                  this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tabela.Revisao
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'staff_name', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '240' },
                  this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tabela.Tripulante
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'report_points', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '125' },
                  this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tabela.PontuacaoReportada
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'actual_points', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '125' },
                  this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tabela.PontuacaoTotal
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '70' },
                  this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tabela.Checado,
                  '?'
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'checked_at_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '120' },
                  this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tabela.DataDaChecagem
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'action_plan', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '240' },
                  this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tabela.AcaoRealizada
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'id', dataAlign: 'center', dataFormat: self.buttonActionPlan, width: '80' },
                  this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tabela.Acoes
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["g" /* Modal */],
                { show: this.state.modal, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["g" /* Modal */].Header,
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'h4',
                    { className: 'pull-left' },
                    this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.tituloEditarPlanoDeAcao
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                        return _this2.setState({ modal: false });
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["g" /* Modal */].Body,
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'form',
                    { onSubmit: this.editActionPlan },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'hidden', name: 'id', className: 'form-control', value: self.state.id }),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formularioEditarPlanoDeAcao.PlanoDeAcao,
                        ':'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', { style: { height: 100 }, className: 'form-control', type: 'text', name: 'action_plan', value: self.state.action_plan, onChange: self.handleChange.bind(self, 'action_plan') })
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { className: 'btn btn-primary btn-block', type: 'submit' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                        ' ',
                        this.locale.RelatoriosDeFadiga.RelatorioDeEventosIncidentesDeFadiga.formularioEditarPlanoDeAcao.botaoEditarPlanoDeAcao
                      )
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_11_react_bootstrap__["g" /* Modal */].Footer,
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                        return _this2.setState({ modal: false });
                      } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                  )
                )
              )
            ) : ""
          )
        )
      );
    }
  }]);

  return StaffRfmsReportIncidentFatigueFilter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffRfmsReportIncidentFatigueFilter);

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











// Importação da tabela



var StaffRfmsReportIndex = function (_Component) {
  _inherits(StaffRfmsReportIndex, _Component);

  function StaffRfmsReportIndex(props) {
    _classCallCheck(this, StaffRfmsReportIndex);

    var _this = _possibleConstructorReturn(this, (StaffRfmsReportIndex.__proto__ || Object.getPrototypeOf(StaffRfmsReportIndex)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      staff_list: []
    };

    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    _this.sortDates = _this.sortDates.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(StaffRfmsReportIndex, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios-de-fadiga/tripulante', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var url = '/relatorio-de-fadiga/tripulante/editar/' + cell;
      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
          { className: 'btn btn-primary btn-sm', to: url },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
        )
      );

      return botao;
    }
  }, {
    key: 'sortDates',
    value: function sortDates(a, b, order) {
      var indices = [6, 7, 8, 9, 3, 4, 0, 1];
      if (order === 'asc') {
        var r = 0;
        indices.find(function (i) {
          return r = a.date.charCodeAt(i) - b.date.charCodeAt(i);
        });
        return r;
      } else if (order === 'desc') {
        var _r = 0;
        indices.find(function (i) {
          return _r = b.date.toString().charCodeAt(i) - a.date.toString().charCodeAt(i);
        });
        return _r;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/relatorio-de-fadiga/cadastrar', className: 'btn btn-primary pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-plus' }),
              ' ',
              this.locale.RelatoriosDeFadiga.ListaDeRelatoriosDeFadigas.botaoAdicionarRelatorioDeFadiga
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.RelatoriosDeFadiga.ListaDeRelatoriosDeFadigas.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.RelatoriosDeFadiga.ListaDeRelatoriosDeFadigas.tabela.semParametroDeFadiga }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { isKey: true, sortFunc: this.sortDates, dataField: 'date_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.RelatoriosDeFadiga.ListaDeRelatoriosDeFadigas.tabela.Data
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'revision', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.RelatoriosDeFadiga.ListaDeRelatoriosDeFadigas.tabela.Revisao
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'staff', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '240' },
                this.locale.RelatoriosDeFadiga.ListaDeRelatoriosDeFadigas.tabela.Tripulante
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'day_off_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.RelatoriosDeFadiga.ListaDeRelatoriosDeFadigas.tabela.Folga,
                '?'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'actual_points_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.RelatoriosDeFadiga.ListaDeRelatoriosDeFadigas.tabela.QuantidadeDePontosAtual
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'report_points_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.RelatoriosDeFadiga.ListaDeRelatoriosDeFadigas.tabela.QuantidadeDePontosReportados
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '60' },
                this.locale.RelatoriosDeFadiga.ListaDeRelatoriosDeFadigas.tabela.Acoes
              )
            )
          )
        )
      );
    }
  }]);

  return StaffRfmsReportIndex;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffRfmsReportIndex);

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_recharts__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














// Importação da tabela



var StaffRfmsReportMissing = function (_Component) {
  _inherits(StaffRfmsReportMissing, _Component);

  function StaffRfmsReportMissing(props) {
    _classCallCheck(this, StaffRfmsReportMissing);

    var _this = _possibleConstructorReturn(this, (StaffRfmsReportMissing.__proto__ || Object.getPrototypeOf(StaffRfmsReportMissing)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      day_off: 0,
      data: null,
      date_start: '',
      date_finish: '',
      applicability_id: '',
      bases_list: [],
      applicabilities_list: [],
      base_id: null
    };

    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.searchReports = _this.searchReports.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(StaffRfmsReportMissing, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeMulti',
    value: function handleSelectChangeMulti(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'searchReports',
    value: function searchReports(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        base_id: this.state.base_id,
        applicability_id: this.state.applicability_id,
        day_off: this.state.day_off
      };

      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios-de-fadiga/faltantes', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          } else {
            self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios-de-fadiga/listagens';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              bases_list: responseJson.data.bases_list,
              applicabilities_list: responseJson.data.applicabilities_list
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
        }); /* Overlay */
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.searchReports },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.formulario.DataInicial,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_start, required: true, maskChar: null, name: 'date_start', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: '' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.formulario.DataFinal,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_finish, required: true, maskChar: null, name: 'date_finish', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: '' })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.formulario.AplicabilidadeTipoDeColaborador,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'applicability_id',
                      value: this.state.applicability_id,
                      searchable: true,
                      placeholder: this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.formulario.placeholder.SelecionarAplicabilidade,
                      onChange: this.handleSelectChange.bind(this, 'applicability_id'),
                      options: this.state.applicabilities_list
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.formulario.Bases,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'base_id',
                      value: this.state.base_id,
                      searchable: true,
                      placeholder: this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.formulario.placeholder.SelecionarBase,
                      onChange: this.handleSelectChange.bind(this, 'base_id'),
                      options: this.state.bases_list
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.formulario.IncluirFolgaCadastradaAutomaticamente,
                      '?'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_toggle___default.a, {
                      checked: this.state.day_off,
                      'aria-label': 'No label tag',
                      name: 'day_off',
                      onChange: this.handleToggleChange.bind(this, 'day_off') })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'submit', className: 'btn btn-primary btn-block' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                  ' ',
                  this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.formulario.botaoProcurarRelatorios
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            self.state.data !== null ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              null,
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h3',
                { className: 'page-title' },
                this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.tituloListaDeRelatOriosDeFadigasFaltantes
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["BootstrapTable"],
                { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.tabela.semReportesFaltantes }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                  { isKey: true, dataField: 'staff_name', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                  this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.tabela.Nome
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'date', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                  this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.tabela.Data
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                  { dataField: 'situation', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                  this.locale.RelatoriosDeFadiga.PesquisaDeRelatoriosNaoPreenchidos.tabela.Situacao
                )
              )
            ) : ""
          )
        )
      );
    }
  }]);

  return StaffRfmsReportMissing;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffRfmsReportMissing);

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_recharts__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StaffRfmsReportViewModal__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }














// Importação da tabela


//Modal



var StaffRfmsReportSearch = function (_Component) {
  _inherits(StaffRfmsReportSearch, _Component);

  function StaffRfmsReportSearch(props) {
    _classCallCheck(this, StaffRfmsReportSearch);

    var _this = _possibleConstructorReturn(this, (StaffRfmsReportSearch.__proto__ || Object.getPrototypeOf(StaffRfmsReportSearch)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: null,
      total_daily: null,
      total_period: null,
      fatigue_incident: 0,
      staff_list: [],
      roles_list: [],
      bases_list: [],
      applicabilities_list: [],
      data_report_fatigues: [],
      date_start: '',
      date_finish: '',
      crew_visibility: { display: 'none' }
    };

    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    _this.loadModal = _this.loadModal.bind(_this);
    _this.showModal = _this.showModal.bind(_this);
    _this.modalPropsOff = _this.modalPropsOff.bind(_this);
    _this.searchReports = _this.searchReports.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(StaffRfmsReportSearch, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleSelectChangeApplicability',
    value: function handleSelectChangeApplicability(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;

        var header = this.refs.request_api.header('application/json');
        var self = this;
        this.handleAlert('', '', 'open');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aplicabilidade/colaboradores/listagens/' + event.value, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.setState({
              roles_list: responseJson.data.roles,
              bases_list: responseJson.data.bases,
              staff_list: responseJson.data.staffs
            });
            self.handleAlert(responseJson.message, responseJson.status, 'closed');
          });
        });
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios-de-fadiga/listagens';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({
              staff_list: responseJson.data.staff_list,
              roles_list: responseJson.data.roles_list,
              bases_list: responseJson.data.bases_list,
              applicabilities_list: responseJson.data.applicabilities_list
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
        }); /* Overlay */
      });
    }
  }, {
    key: 'loadModal',
    value: function loadModal(value, event) {
      var self = this;
      var id = value;
      self.setState({ overlay: { message: '', type: '', status: 'open' } });
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorio-de-fadiga/' + id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ data_report_fatigues: responseJson.data });
            self.showModal();
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.modalPropsOff();
        }); /* Overlay */
      });
    }
  }, {
    key: 'showModal',
    value: function showModal(value, event) {
      this.setState({ modal_props: true });
    }
  }, {
    key: 'modalPropsOff',
    value: function modalPropsOff(event) {
      this.setState({ modal_props: false });
    }
  }, {
    key: 'searchReports',
    value: function searchReports(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        staff: this.state.staff_ids,
        roles: this.state.roles_ids,
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        bases: this.state.bases_ids,
        applicability_id: this.state.applicability_id
      };

      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/relatorios-de-fadiga/buscar/diarias', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data.reports, total_daily: responseJson.data.total_daily, total_period: responseJson.data.total_period });
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          } else {
            self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
          }
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { onClick: this.loadModal.bind(this, cell), className: 'btn btn-sm btn-info', alt: this.locale.general.informacoes, title: this.locale.general.informacoes },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-eye' })
        )
      );

      return botao;
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.searchReports },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.DataInicial,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_start, required: true, maskChar: null, name: 'date_start', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: '' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.DataFinal,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_input_mask___default.a, { value: this.state.date_finish, required: true, maskChar: null, name: 'date_finish', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: '' })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.AplicabilidadeTipoDeColaborador,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'applicability_id',
                      value: this.state.applicability_id,
                      searchable: true,
                      placeholder: this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.AplicabilidadeTipoDeColaborador,
                      onChange: this.handleSelectChangeApplicability.bind(this, 'applicability_id'),
                      options: this.state.applicabilities_list
                    })
                  )
                ),
                this.state.applicability_id == 2 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.Mecanicos,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'staff_ids',
                      value: this.state.staff_ids,
                      searchable: true,
                      placeholder: this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.placeholder.SelecionarMecanicos,
                      onChange: this.handleSelectChange.bind(this, 'staff_ids'),
                      options: this.state.staff_list,
                      multi: true
                    })
                  )
                ) : this.state.applicability_id == 3 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.Coordenadores,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'staff_ids',
                      value: this.state.staff_ids,
                      searchable: true,
                      placeholder: this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.placeholder.SelecionarCoordenadores,
                      onChange: this.handleSelectChange.bind(this, 'staff_ids'),
                      options: this.state.staff_list,
                      multi: true
                    })
                  )
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.Tripulantes,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'staff_ids',
                      value: this.state.staff_ids,
                      searchable: true,
                      placeholder: this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.placeholder.SelecionarTripulantes,
                      onChange: this.handleSelectChange.bind(this, 'staff_ids'),
                      options: this.state.staff_list,
                      multi: true
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.Cargos,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                      className: '',
                      name: 'roles_ids',
                      value: this.state.roles_ids,
                      searchable: true,
                      multi: true,
                      placeholder: this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.placeholder.SelecionarCargos,
                      onChange: this.handleSelectChange.bind(this, 'roles_ids'),
                      options: this.state.roles_list
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.Bases,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_select__["a" /* default */], {
                      className: '',
                      name: 'bases_ids',
                      value: this.state.bases_ids,
                      searchable: true,
                      multi: true,
                      placeholder: this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.placeholder.SelecionarBases,
                      onChange: this.handleSelectChange.bind(this, 'bases_ids'),
                      options: this.state.bases_list
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'submit', className: 'btn btn-primary btn-block' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                  ' ',
                  this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.botaoProcurarRelatarios
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tituloTotalDoPeriodo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.total_period, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaTotalDoPeriodo.semParametrosDeFadiga }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                { isKey: true, dataField: 'not_fatigue', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaTotalDoPeriodo.NaoFadigados
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'blue_fatigue', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaTotalDoPeriodo.PontosAzul
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'yellow_fatigue', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaTotalDoPeriodo.PontosAmarelo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'red_fatigue', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaTotalDoPeriodo.PontosVermelho
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tituloTotalDiario
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.total_daily, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaTotalDiario.semParametrosDeFadiga }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                { isKey: true, dataField: 'date', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaTotalDiario.Data
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'not_fatigue', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaTotalDiario.NaoFadigados
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'blue_fatigue', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaTotalDiario.PontosAzul
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'yellow_fatigue', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaTotalDiario.PontosAmarelo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'red_fatigue', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaTotalDiario.PontosVermelho
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tituloListaDeRelatoriosDeFadigas
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaListaDeRelatoriosDeFadigas.semParametrosDeFadiga }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                { isKey: true, dataField: 'date_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaListaDeRelatoriosDeFadigas.Data
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'revision', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaListaDeRelatoriosDeFadigas.Revisao
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'staff_name', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaListaDeRelatoriosDeFadigas.Tripulante
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'day_off_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaListaDeRelatoriosDeFadigas.Folga,
                '?'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'actual_points_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaListaDeRelatoriosDeFadigas.QuantidadeDePontosAtual
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'report_points_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaListaDeRelatoriosDeFadigas.QuantidadeDePontosReportados
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'created_at_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaListaDeRelatoriosDeFadigas.DiaDePreenchimento
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '100' },
                this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaListaDeRelatoriosDeFadigas.Acoes
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__StaffRfmsReportViewModal__["a" /* default */], { handleAlert: self.props.handleAlert, modal_props: self.state.modal_props, staff_name: self.state.staff_name, data_report_fatigues: self.state.data_report_fatigues })
          )
        )
      );
    }
  }]);

  return StaffRfmsReportSearch;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffRfmsReportSearch);

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var StaffRfmsReportViewModal = function (_Component) {
  _inherits(StaffRfmsReportViewModal, _Component);

  function StaffRfmsReportViewModal(props) {
    _classCallCheck(this, StaffRfmsReportViewModal);

    var _this = _possibleConstructorReturn(this, (StaffRfmsReportViewModal.__proto__ || Object.getPrototypeOf(StaffRfmsReportViewModal)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      modal: false,
      loaded: 0,
      fatigues: [],
      data: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(StaffRfmsReportViewModal, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }

    //LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.modal_props === true) {
        this.setState({ modal: true });
        if (typeof newProps.data_report_fatigues.id !== 'undefined') {
          this.setState({
            fatigues: newProps.data_report_fatigues.staff_rfms_report_fatigues,
            data: newProps.data_report_fatigues,
            staff_name: newProps.data_report_fatigues.staff.name
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tituloDadosDoRelatorioDeFadiga,
              ' - ',
              self.state.data.date_str,
              ' - ',
              self.state.staff_name
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ modal: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.paragrafoQuantidadeDePontosAtual,
              ': ',
              self.state.data.actual_points_str
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'p',
              null,
              this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.paragrafoQuantidadeDePontosReportados,
              ': ',
              self.state.data.report_points_str
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'table',
              { className: 'table table-bordered table-stripped table-hover' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'thead',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    { className: 'text-center' },
                    this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaDadosDoRelatorioDeFadiga.Parametro
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    { className: 'text-center' },
                    this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaDadosDoRelatorioDeFadiga.Dados
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    { className: 'text-center' },
                    this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaDadosDoRelatorioDeFadiga.Pontos
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tbody',
                { id: 'suppliers-certifications' },
                Object.keys(self.state.fatigues).map(function (k) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      { className: 'text-center' },
                      self.state.fatigues[k].name
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      { className: 'text-center' },
                      self.state.fatigues[k].type === "options" ? self.state.fatigues[k].fatigue_option_name : self.state.fatigues[k].type === "quantity" ? self.state.fatigues[k].quantity : self.state.fatigues[k].hours_str
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      { className: 'text-center' },
                      self.state.fatigues[k].total_points
                    )
                  );
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                  return _this2.setState({ modal: false });
                } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return StaffRfmsReportViewModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffRfmsReportViewModal);

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var StaffScheduleRequestsAdd = function (_Component) {
  _inherits(StaffScheduleRequestsAdd, _Component);

  // constructor
  function StaffScheduleRequestsAdd(props) {
    _classCallCheck(this, StaffScheduleRequestsAdd);

    var _this = _possibleConstructorReturn(this, (StaffScheduleRequestsAdd.__proto__ || Object.getPrototypeOf(StaffScheduleRequestsAdd)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      start: null,
      finish: null,
      reason: null
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.add = _this.add.bind(_this);
    _this.loadData = _this.loadData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(StaffScheduleRequestsAdd, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData(event) {
      var self = this;
      var id = null;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/escala/solicitacao';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          if (responseJson.status === 'redirect') {
            var url = '/escala/solicitacao/cadastrar/sigmec';
            self.setState({ redirect_url: url });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          if (typeof event === 'undefined') {
            self.handleMessage();
          } else {
            self.handleAlert(event.message, event.status, 'open');
          }
        });
      });
    }
  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      if (window.confirm(this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscala.criar)) {
        this.setState({ overlay: { message: '', type: '', status: 'open' } });
        var datasave = {
          start: this.state.start,
          finish: this.state.finish,
          reason: this.state.reason
        };
        var self = this;
        var header = this.refs.request_api.header('application/json');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/funcionario/escala/solicitacao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              var url = '/escala/solicitacoes';
              var storage = {
                alert_message: responseJson.message,
                alert_type: responseJson.status
              };
              localStorage.setItem("verify_message", JSON.stringify(storage));
              self.setState({ redirect_url: url });
            }
            self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscala.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/escala/solicitacoes', className: 'btn btn-default pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-left' }),
              ' ',
              this.locale.general.voltar
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.add },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscala.formulario.Inicio,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_input_mask___default.a, { value: this.state.start, maskChar: null, name: 'start', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'start'), placeholder: '', required: true })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscala.formulario.Fim,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_input_mask___default.a, { value: this.state.finish, maskChar: null, name: 'finish', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'finish'), placeholder: '', required: true })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscala.formulario.Razao,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', { value: this.state.reason, name: 'reason', className: 'form-control', onChange: this.handleChange.bind(this, 'reason'), placeholder: '', style: { height: '200px' }, required: true })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                    ' ',
                    this.locale.general.salvar
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return StaffScheduleRequestsAdd;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffScheduleRequestsAdd);

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// Importação da tabela



var StaffScheduleRequestsIndex = function (_Component) {
  _inherits(StaffScheduleRequestsIndex, _Component);

  function StaffScheduleRequestsIndex(props) {
    _classCallCheck(this, StaffScheduleRequestsIndex);

    var _this = _possibleConstructorReturn(this, (StaffScheduleRequestsIndex.__proto__ || Object.getPrototypeOf(StaffScheduleRequestsIndex)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(StaffScheduleRequestsIndex, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData(event) {
      var self = this;
      var id = null;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/escala/solicitacao';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          if (responseJson.status === 'redirect') {
            var url = '/funcionario/escala/solicitacoes/sigmec';
            self.setState({ redirect_url: url });
          }
          self.setState({ data: responseJson.data });
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.Solicitacoes.ListaDeSolicitacoes.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: 'Exportar CSV', noDataText: this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.semSolicitacoes }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.Procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'creation_date_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.Procurar }, width: '200' },
                this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.DataDeCriacao
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'start_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.Procurar }, width: '100' },
                this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.Inicio
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'finish_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.Procurar }, width: '100' },
                this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.Fim
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'reason', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.Procurar }, width: '500' },
                this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.Justificativa
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'status_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.Procurar }, width: '200' },
                this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.Status
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'fleet_chief_name', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.Procurar }, width: '300' },
                this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.ChefeDeFrota
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'fleet_chief_answer_date_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.Procurar }, width: '200' },
                this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.ChefeDeFrotaDataResposta
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'fleet_chief_answer_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.Procurar }, width: '120' },
                this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.ChefeDeFrotaAprovacao
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'fleet_chief_answer_reason', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.Procurar }, width: '350' },
                this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.ChefeDeFrotaJustificativa
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'manager_name', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.Procurar }, width: '200' },
                this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.Administrativo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'manager_answer_date_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.Procurar }, width: '200' },
                this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.AdministrativoDataResposta
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'manager_answer_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.Procurar }, width: '120' },
                this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.AdministrativoAprovacao
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_5_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'manager_answer_reason', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.Procurar }, width: '350' },
                this.locale.Solicitacoes.ListaDeSolicitacoes.tabela.AdministrativoResposta
              )
            )
          )
        )
      );
    }
  }]);

  return StaffScheduleRequestsIndex;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffScheduleRequestsIndex);

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var StaffScheduleRequestsSigmecAdd = function (_Component) {
  _inherits(StaffScheduleRequestsSigmecAdd, _Component);

  // constructor
  function StaffScheduleRequestsSigmecAdd(props) {
    _classCallCheck(this, StaffScheduleRequestsSigmecAdd);

    var _this = _possibleConstructorReturn(this, (StaffScheduleRequestsSigmecAdd.__proto__ || Object.getPrototypeOf(StaffScheduleRequestsSigmecAdd)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      errors_listing: false,
      loaded: 0,
      list_staffs: [],
      list_schedules: [],
      data: {},
      errors_messages: {}
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.addLine = _this.addLine.bind(_this);
    _this.deleteLine = _this.deleteLine.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    _this.save = _this.save.bind(_this);
    _this.saveImages = _this.saveImages.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(StaffScheduleRequestsSigmecAdd, [{
    key: 'handleChange',
    value: function handleChange(name, index, event) {
      var change = this.state.data;
      change[index][name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, index, event) {
      var change = this.state.data;
      if (event.target.checked === true) {
        var value = 1;
      } else {
        change[index]['date_finish'] = null;
        var value = 0;
      }
      change[index][name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, index, event) {
      var change = this.state.data;
      if (event == null) {
        change[index][name] = null;
      } else {
        change[index][name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectScheduleChange',
    value: function handleSelectScheduleChange(name, index, event) {
      var change = this.state.data;
      var self = this;
      change[index]['staff_id'] = null;
      change[index]['change_type'] = null;
      if (event == null) {
        change[index][name] = null;
      } else {
        self.setState({ overlay: { message: '', type: '', status: 'open' } });
        change[index][name] = event.value;
        var header = this.refs.request_api.header('application/json');
        Promise.resolve(header).then(function (value) {
          var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaboradores/escala/lista/' + event.value;
          fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            if (responseJson.status === 'success') {
              self.setState({
                list_staffs: responseJson.data
              });
            }
            change[index]['list_staffs'] = responseJson.data;
          }).then(function () {
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          }); /* Overlay */
        });
      }

      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeType',
    value: function handleSelectChangeType(name, index, event) {
      var change = this.state.data;
      change[index]['definitive_change'] = false;
      change[index]['date_finish'] = null;
      change[index]['current_base_id'] = null;
      change[index]['current_role_id'] = null;
      change[index]['current_group_id'] = null;
      change[index]['current_regime_id'] = null;
      change[index]['current_schedule_period_id'] = null;
      change[index]['new_base_id'] = null;
      change[index]['new_role_id'] = null;
      change[index]['new_group_id'] = null;
      change[index]['new_regime_id'] = null;
      change[index]['new_schedule_period_id'] = null;
      change[index]['warning_message'] = null;
      var self = this;
      self.setState({ overlay: { message: '', type: '', status: 'open' } });
      if (event == null) {
        change[index][name] = null;
        self.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        change[index][name] = event.value;
        var datasave = {
          staff_id: this.state.data[index].staff_id,
          schedule_id: this.state.data[index].schedule_id,
          change_type: event.value
        };
        var self = this;
        var header = this.refs.request_api.header('application/json');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaboradores/escala/tipo/alteracao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              change[index]['current_base_id'] = responseJson.data.current_base_id;
              change[index]['current_role_id'] = responseJson.data.current_role_id;
              change[index]['list_current_groups'] = responseJson.data.list_current_groups;
              change[index]['list_schedule_groups'] = responseJson.data.list_schedule_groups;
              change[index]['list_current_regimes'] = responseJson.data.list_current_regimes;
              change[index]['regimes_select'] = responseJson.data.regimes_select;
              change[index]['list_base'] = responseJson.data.list_current_bases;
              change[index]['list_bases'] = responseJson.data.list_bases;
              change[index]['list_current_schedule_periods'] = responseJson.data.list_current_schedule_periods;
              change[index]['list_schedule_periods'] = responseJson.data.list_schedule_periods;
              change[index]['list_current_roles'] = responseJson.data.list_current_roles;
              change[index]['list_roles'] = responseJson.data.list_roles;
            }
            self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData(event) {
      var self = this;
      var id = null;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/escala/solicitacao';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          if (responseJson.status === 'success') {
            self.setState({ list_schedules: responseJson.data.list_schedules });
            self.setState({ list_change_types: responseJson.data.list_change_types });
            self.addLine();
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          if (typeof event === 'undefined') {
            self.handleMessage();
          } else {
            self.handleAlert(event.message, event.status, 'open');
          }
        });
      });
    }

    // Deleta uma linha de período do modal

  }, {
    key: 'deleteLine',
    value: function deleteLine(deleted_index) {
      var self = this;
      var new_data = {};
      var x = 0;
      Object.keys(self.state.data).map(function (k) {
        if (deleted_index !== k) {
          new_data[x] = self.state.data[k];
          x++;
        }
      });
      this.setState({ data: new_data });
    }

    // Adiciona uma linha de período do modal

  }, {
    key: 'addLine',
    value: function addLine() {
      var self = this;
      var x = 0;
      var new_data = self.state.data;
      Object.keys(self.state.data).map(function (k) {
        x++;
      });
      new_data[x] = {
        staff_id: null,
        schedule_id: null,
        change_type: null,
        definitive_change: false,
        current_schedule_period_id: null,
        new_schedule_period_id: null,
        current_role_id: null,
        new_role_id: null,
        request_number: null,
        mp_number: null,
        current_group_id: null,
        new_group_id: null,
        current_regime_id: null,
        new_regime_id: null,
        current_base_id: null,
        new_base_id: null,
        description: null,
        date_start: null,
        date_finish: null,
        reason: null,
        lists: {}
      };

      this.setState({ data: new_data });
    }
  }, {
    key: 'saveImages',
    value: function saveImages() {
      var self = this;
      {
        Object.keys(self.state.data).map(function (k) {
          if (self.state.data[k].change_type == 'change_absences') {
            var data = new FormData();
            var imagedata = document.querySelector('.input-absense-justify-' + k).files[0];
            data.append("imagem", imagedata);
            data.append("id", self.state.change_absences_ids[k]);

            var header = self.refs.request_api.header();
            Promise.resolve(header).then(function (value) {
              fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/escala/solicitacao/imagem', {
                method: 'POST',
                mode: 'cors',
                headers: value,
                body: data }).then(function (response) {
                return response.json();
              }).catch(function (error) {
                console.error(error);
              }).then(function (responseJson) {
                self.refs.request_api.validate(responseJson, 'alert');
                self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
              }).catch(function (error) {
                console.error(error);
              });
            });
          }
        });
      };
      var url = '/funcionario/escala/solicitacoes/sigmec';
      this.setState({ redirect_url: url });
    }
  }, {
    key: 'save',
    value: function save() {
      var self = this;
      if (window.confirm('Tem certeza de que deseja criar estas solicitações?')) {
        this.setState({ overlay: { message: '', type: '', status: 'open' } });

        var datasave = {};
        {
          Object.keys(self.state.data).map(function (k) {
            if (self.state.data[k].change_type == 'change_absences') {
              var imagedata = document.querySelector('.input-absense-justify-' + k).files[0];
              datasave[k] = {
                imagem: imagedata,
                staff_id: self.state.data[k].staff_id,
                schedule_id: self.state.data[k].schedule_id,
                change_type: self.state.data[k].change_type,
                definitive_change: self.state.data[k].definitive_change,
                current_schedule_period_id: self.state.data[k].current_schedule_period_id,
                new_schedule_period_id: self.state.data[k].new_schedule_period_id,
                current_role_id: self.state.data[k].current_role_id,
                new_role_id: self.state.data[k].new_role_id,
                request_number: self.state.data[k].request_number,
                mp_number: self.state.data[k].mp_number,
                current_group_id: self.state.data[k].current_group_id,
                new_group_id: self.state.data[k].new_group_id,
                current_regime_id: self.state.data[k].current_regime_id,
                new_regime_id: self.state.data[k].new_regime_id,
                current_base_id: self.state.data[k].current_base_id,
                new_base_id: self.state.data[k].new_base_id,
                description: self.state.data[k].description,
                date_start: self.state.data[k].date_start,
                date_finish: self.state.data[k].date_finish,
                reason: self.state.data[k].reason
              };
            } else {
              datasave[k] = {
                staff_id: self.state.data[k].staff_id,
                schedule_id: self.state.data[k].schedule_id,
                change_type: self.state.data[k].change_type,
                definitive_change: self.state.data[k].definitive_change,
                current_schedule_period_id: self.state.data[k].current_schedule_period_id,
                new_schedule_period_id: self.state.data[k].new_schedule_period_id,
                current_role_id: self.state.data[k].current_role_id,
                new_role_id: self.state.data[k].new_role_id,
                request_number: self.state.data[k].request_number,
                mp_number: self.state.data[k].mp_number,
                current_group_id: self.state.data[k].current_group_id,
                new_group_id: self.state.data[k].new_group_id,
                current_regime_id: self.state.data[k].current_regime_id,
                new_regime_id: self.state.data[k].new_regime_id,
                current_base_id: self.state.data[k].current_base_id,
                new_base_id: self.state.data[k].new_base_id,
                description: self.state.data[k].description,
                date_start: self.state.data[k].date_start,
                date_finish: self.state.data[k].date_finish,
                reason: self.state.data[k].reason
              };
            }
          });
        };

        var data = JSON.stringify(datasave);

        var header = this.refs.request_api.header('application/json');

        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/escala/solicitacao', {
            method: 'POST',
            mode: 'cors',
            headers: value,
            body: data }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              var url = '/funcionario/escala/solicitacoes/sigmec';
              var storage = {
                alert_message: responseJson.message,
                alert_type: responseJson.status
              };
              localStorage.setItem("verify_message", JSON.stringify(storage));

              //Se der certo o save, e precisarmos salvar imagem
              //executamos um método para salvar as imagens que enviamos
              if (responseJson.data.send_images === true) {
                //Ids que usaremos para salvar
                self.setState({ change_absences_ids: responseJson.data.change_absences_ids });
                self.saveImages();
              } else {
                self.setState({ redirect_url: url });
              }
            } else {
              self.handleAlert(responseJson.message, responseJson.status, 'open');
              self.setState({ errors_messages: responseJson.data, errors_listing: true });
            }
            self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/escala/solicitacoes', className: 'btn btn-default pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-left' }),
              ' ',
              this.locale.general.voltar
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            this.state.errors_listing && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'alert alert-danger alert-dismissible', role: 'alert', style: { marginTop: 25 } },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { onClick: function onClick() {
                    return self.setState({ errors_listing: false, errors_messages: [] });
                  }, type: 'button', className: 'close', 'data-dismiss': 'alert', 'aria-label': 'Close' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'span',
                  { 'aria-hidden': 'true' },
                  '\xD7'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'strong',
                null,
                this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.erros,
                ':'
              ),
              Object.keys(self.state.errors_messages).map(function (k) {
                var message = self.state.errors_messages[k];
                return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'p',
                  null,
                  '- ',
                  message
                );
              })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'table-responsive' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'table',
                { className: 'table table-bordered table-schedule-requests table-hover table-striped', style: { width: "250px", height: "400px" } },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'thead',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "250px" }, className: 'text-center' },
                      this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.EscalaMesAtual
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "350px" }, className: 'text-center' },
                      this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.Colaborador
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "250px" }, className: 'text-center' },
                      this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.TipoDeAlteracao
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "150px" }, className: 'text-center' },
                      this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.DataDeInicio
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "150px" }, className: 'text-center' },
                      this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.DataDeTermino
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "150px" }, className: 'text-center' },
                      this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.Duracao
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "350px" }, className: 'text-center' },
                      this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.Justificativa
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "200px" }, className: 'text-center' },
                      this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.Atual
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "200px" }, className: 'text-center' },
                      this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.Novo
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "200px" }, className: 'text-center' },
                      this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.NumeroChamado
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "200px" }, className: 'text-center' },
                      this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.NumeroMp
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "200px" }, className: 'text-center' },
                      this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.Atestado
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "200px" }, className: 'text-center' },
                      this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.Descricao
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'th',
                      { style: { width: "60px" }, className: 'text-center' },
                      this.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.tabela.Acoes
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tbody',
                  null,
                  Object.keys(self.state.data).map(function (k) {
                    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'tr',
                      null,
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                          className: '',
                          name: 'schedule_id',
                          value: self.state.data[k].schedule_id,
                          placeholder: 'Selecione uma escala',
                          onChange: self.handleSelectScheduleChange.bind(self, 'schedule_id', k),
                          options: self.state.list_schedules,
                          required: true
                        })
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                          className: '',
                          name: 'staff_id',
                          value: self.state.data[k].staff_id,
                          placeholder: 'Selecione um colaborador',
                          onChange: self.handleSelectChange.bind(self, 'staff_id', k),
                          options: self.state.data[k].list_staffs,
                          required: true
                        })
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                          className: '',
                          name: 'change_type',
                          value: self.state.data[k].change_type,
                          placeholder: 'Selecione um tipo de alteração',
                          onChange: self.handleSelectChangeType.bind(self, 'change_type', k),
                          options: self.state.list_change_types,
                          required: true
                        })
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_input_mask___default.a, { value: self.state.data[k].date_start, maskChar: null, name: 'date_start', mask: '99/99/9999', className: 'form-control', onChange: self.handleChange.bind(self, 'date_start', k), placeholder: '', required: true })
                      ),
                      (self.state.data[k].change_type == 'change_group' || self.state.data[k].change_type == 'change_base' || self.state.data[k].change_type == 'change_role' || self.state.data[k].change_type == 'change_absences') && self.state.data[k].definitive_change == false ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_input_mask___default.a, { value: self.state.data[k].date_finish, maskChar: null, name: 'date_finish', mask: '99/99/9999', className: 'form-control', onChange: self.handleChange.bind(self, 'date_finish', k), placeholder: '', required: true })
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null),
                      self.state.data[k].change_type == 'change_group' || self.state.data[k].change_type == 'change_base' || self.state.data[k].change_type == 'change_role' || self.state.data[k].change_type == 'change_absences' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_toggle___default.a, {
                          checked: self.state.data[k].definitive_change,
                          'aria-label': 'No label tag',
                          name: 'definitive_change',
                          onChange: self.handleToggleChange.bind(self, 'definitive_change', k)
                        })
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', value: self.state.data[k].reason, name: 'reason', className: 'form-control', onChange: self.handleChange.bind(self, 'reason', k), placeholder: '', required: true })
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        self.state.data[k].change_type == 'change_group' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                          className: '',
                          name: 'current_group_id',
                          value: self.state.data[k].current_group_id,
                          placeholder: self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.placeholder.SelecioneGrupo,
                          onChange: self.handleSelectChange.bind(self, 'current_group_id', k),
                          options: self.state.data[k].list_current_groups,
                          required: true
                        }) : self.state.data[k].change_type == 'change_regime' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                          className: '',
                          name: 'current_regime_id',
                          value: self.state.data[k].current_regime_id,
                          placeholder: self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.placeholder.SelecioneQuinzena,
                          onChange: self.handleSelectChange.bind(self, 'current_regime_id', k),
                          options: self.state.data[k].list_current_regimes,
                          required: true
                        }) : self.state.data[k].change_type == 'change_base' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                          className: '',
                          name: 'current_base_id',
                          value: self.state.data[k].current_base_id,
                          placeholder: self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.placeholder.SelecioneBase,
                          onChange: self.handleSelectChange.bind(self, 'current_base_id', k),
                          options: self.state.data[k].list_base,
                          required: true,
                          disabled: true
                        }) : self.state.data[k].change_type == 'change_period' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                          className: '',
                          name: 'current_schedule_period_id',
                          value: self.state.data[k].current_schedule_period_id,
                          placeholder: self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.placeholder.SelecionePeriodo,
                          onChange: self.handleSelectChange.bind(self, 'current_schedule_period_id', k),
                          options: self.state.data[k].list_current_schedule_periods,
                          required: true
                        }) : self.state.data[k].change_type == 'change_role' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                          className: '',
                          name: 'current_role_id',
                          value: self.state.data[k].current_role_id,
                          placeholder: self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.placeholder.SelecioneFuncao,
                          onChange: self.handleSelectChange.bind(self, 'current_role_id', k),
                          options: self.state.data[k].list_current_roles,
                          required: true
                        }) : ''
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        self.state.data[k].change_type == 'change_group' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                          className: '',
                          name: 'new_group_id',
                          value: self.state.data[k].new_group_id,
                          placeholder: self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.placeholder.SelecioneGrupo,
                          onChange: self.handleSelectChange.bind(self, 'new_group_id', k),
                          options: self.state.data[k].list_schedule_groups,
                          required: true
                        }) : self.state.data[k].change_type == 'change_regime' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                          className: '',
                          name: 'new_regime_id',
                          value: self.state.data[k].new_regime_id,
                          placeholder: self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.placeholder.SelecioneQuinzena,
                          onChange: self.handleSelectChange.bind(self, 'new_regime_id', k),
                          options: self.state.data[k].regimes_select,
                          required: true
                        }) : self.state.data[k].change_type == 'change_base' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                          className: '',
                          name: 'new_base_id',
                          value: self.state.data[k].new_base_id,
                          placeholder: self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.placeholder.SelecioneBase,
                          onChange: self.handleSelectChange.bind(self, 'new_base_id', k),
                          options: self.state.data[k].list_bases,
                          required: true
                        }) : self.state.data[k].change_type == 'change_period' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                          className: '',
                          name: 'new_schedule_period_id',
                          value: self.state.data[k].new_schedule_period_id,
                          placeholder: self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.placeholder.SelecionePeriodo,
                          onChange: self.handleSelectChange.bind(self, 'new_schedule_period_id', k),
                          options: self.state.data[k].list_schedule_periods,
                          required: true
                        }) : self.state.data[k].change_type == 'change_role' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                          className: '',
                          name: 'new_role_id',
                          value: self.state.data[k].new_role_id,
                          placeholder: self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.placeholder.SelecioneFuncao,
                          onChange: self.handleSelectChange.bind(self, 'new_role_id', k),
                          options: self.state.data[k].list_roles,
                          required: true
                        }) : ''
                      ),
                      self.state.data[k].change_type == 'change_role' && self.state.data[k].definitive_change == false ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'request_number', className: 'form-control', required: true, placeholder: self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.placeholder.NumeroChamado, value: self.state.data[k].request_number, onChange: self.handleChange.bind(self, 'request_number', k) })
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null),
                      self.state.data[k].change_type == 'change_role' && self.state.data[k].definitive_change == true ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'mp_number', className: 'form-control', required: true, placeholder: self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.placeholder.NumeroMp, value: self.state.data[k].NumeroMp, onChange: self.handleChange.bind(self, 'mp_number', k) })
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null),
                      self.state.data[k].change_type == 'change_absences' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'file', name: 'absense_justify', className: "form-control input-absense-justify-" + k, placeholder: self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.placeholder.Atestado, value: self.state.data[k].absense_justify, onChange: self.handleChange.bind(self, 'absense_justify', k) })
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null),
                      self.state.data[k].change_type == 'other_changes' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        null,
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', value: self.state.data[k].description, name: 'description', className: 'form-control', onChange: self.handleChange.bind(self, 'description', k), placeholder: '', required: true })
                      ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td', null),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'td',
                        { style: { width: '200px', whiteSpace: 'nowrap', textAlign: 'center' } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                          'button',
                          { onClick: function onClick() {
                              self.deleteLine(k);
                            }, type: 'button', className: 'btn btn-danger' },
                          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                        )
                      )
                    );
                  })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'row' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { onClick: function onClick() {
                      self.save();
                    }, className: 'btn btn-block btn-primary' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                  ' ',
                  self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.botaoSalvarSolicitacoes
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'col-md-6' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { onClick: function onClick() {
                      self.addLine();
                    }, className: 'btn btn-block btn-success' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-plus' }),
                  ' ',
                  self.locale.Solicitacoes.AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec.formulario.botaoAdicionarSolicitacao
                )
              )
            )
          )
        )
      );
    }
  }]);

  return StaffScheduleRequestsSigmecAdd;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffScheduleRequestsSigmecAdd);

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













// Importação da tabela


var StaffScheduleRequestsSigmecIndex = function (_Component) {
    _inherits(StaffScheduleRequestsSigmecIndex, _Component);

    function StaffScheduleRequestsSigmecIndex(props) {
        _classCallCheck(this, StaffScheduleRequestsSigmecIndex);

        var _this = _possibleConstructorReturn(this, (StaffScheduleRequestsSigmecIndex.__proto__ || Object.getPrototypeOf(StaffScheduleRequestsSigmecIndex)).call(this, props));

        _this.state = {
            overlay: {
                message: '',
                type: '',
                status: 'open'
            },
            redirect_url: false,
            modal: false,
            loaded: 0,
            staff_id: '',
            data: [],
            schedule_request: {}
        };
        //Handlers
        _this.handleAlert = _this.handleAlert.bind(_this);
        _this.handleLoaded = _this.handleLoaded.bind(_this);
        _this.handleMessage = _this.handleMessage.bind(_this);

        _this.loadData = _this.loadData.bind(_this);
        _this.openModal = _this.openModal.bind(_this);
        _this.ActionsButtons = _this.ActionsButtons.bind(_this);
        _this.changeStatus = _this.changeStatus.bind(_this);
        _this.confirmChangeStatus = _this.confirmChangeStatus.bind(_this);

        _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__["a" /* default */])();
        return _this;
    }

    // Handlers


    _createClass(StaffScheduleRequestsSigmecIndex, [{
        key: 'handleChange',
        value: function handleChange(name, event) {
            var change = {};
            change[name] = event.target.value;
            this.setState(change);
        }
    }, {
        key: 'handleAlert',
        value: function handleAlert(message, type, status, mode) {
            if (mode === 'reset') {
                this.setState({ overlay: { message: '', type: '', status: 'closed' } });
            } else {
                this.setState({ overlay: { message: message, type: type, status: status } });
            }
        }
    }, {
        key: 'handleLoaded',
        value: function handleLoaded(state) {
            if (this.state.loaded !== 2) {
                this.setState({ loaded: state });
            }
        }
    }, {
        key: 'handleMessage',
        value: function handleMessage() {
            var message = localStorage.getItem("verify_message");
            if (message !== null && typeof message !== 'undefined') {
                message = JSON.parse(message);
                var self = this;
                self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
                localStorage.removeItem("verify_message");
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.refs.request_api.header();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            if (this.state.loaded === 1 && prevState.loaded === 0) {
                this.setState({ loaded: 2 }, this.loadData());
            }
        }
    }, {
        key: 'loadData',
        value: function loadData(event) {
            var self = this;
            var id = null;
            var header = this.refs.request_api.header('application/json');
            Promise.resolve(header).then(function (value) {
                var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/colaborador/escala/solicitacoes';
                fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
                    return response.json();
                }).catch(function (error) {
                    console.error(error);
                }).then(function (responseJson) {
                    self.setState({ data: responseJson.data.main, staff_id: responseJson.data.staff_id });
                }).then(function () {
                    self.setState({ overlay: { message: '', type: '', status: 'closed' } });
                    if (typeof event === 'undefined') {
                        self.handleMessage();
                    } else {
                        self.handleAlert(event.message, event.status, 'open');
                    }
                });
            });
        }
    }, {
        key: 'openModal',
        value: function openModal(schedule_request_id) {
            var self = this;
            this.handleAlert('', '', 'open');
            var header = this.refs.request_api.header('application/json');
            Promise.resolve(header).then(function (value) {
                var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/escala/solicitacao/' + schedule_request_id;
                fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
                    return response.json();
                }).catch(function (error) {
                    console.error(error);
                }).then(function (responseJson) {
                    self.setState({ schedule_request: responseJson.data, modal: true });
                    self.handleAlert('', '', 'closed');
                });
            });
        }
    }, {
        key: 'ActionsButtons',
        value: function ActionsButtons(cell, row) {
            var _this2 = this;

            var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'btn-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { className: 'btn button-inline btn-sm btn-primary', value: cell, onClick: function onClick() {
                            _this2.openModal(cell);
                        } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-tasks' })
                ),
                row.status == 'additional_info_pending' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { className: 'btn button-inline btn-sm btn-warning', onClick: function onClick() {
                            _this2.changeStatus(cell, 'additional_info_pending', row.additional_info_request);
                        } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-reply' })
                ) : row.status == 'additional_approval_pending' && row.approval_staff_id == this.state.staff_id ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { className: 'btn button-inline btn-sm btn-info', onClick: function onClick() {
                            _this2.changeStatus(cell, 'additional_approval_pending', row.additional_info_request, null);
                        } },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-reply' })
                ) : ''
            );

            return botao;
        }
    }, {
        key: 'changeStatus',
        value: function changeStatus(schedule_request_id, value, additional_info_request, additional_info_answer) {
            this.setState({ additional_info_modal: true, change_status: value, schedule_request_id: schedule_request_id, additional_info_request: additional_info_request, additional_info_answer: additional_info_answer });
        }
    }, {
        key: 'confirmChangeStatus',
        value: function confirmChangeStatus(status) {
            if (window.confirm(this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.confirmarMudanca)) {
                var datasave = {
                    type: 'colaborador',
                    schedule_request_id: this.state.schedule_request_id,
                    additional_info_answer: this.state.additional_info_answer,
                    change_status: status
                };
                var self = this;
                this.handleAlert('', '', 'open');
                var header = this.refs.request_api.header('application/json');
                Promise.resolve(header).then(function (value) {
                    fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api_sigmec') + '/escala/solicitacao/status', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
                        return response.json();
                    }).catch(function (error) {
                        console.error(error);
                    }).then(function (responseJson) {
                        self.refs.request_api.validate(responseJson, 'alert');
                        self.setState({ data: responseJson.data.main, staff_id: responseJson.data.staff_id, schedule_request_id: null, change_status: null, additional_info_modal: false, reason: null });
                        self.handleAlert(responseJson.message, responseJson.status, 'open');
                    }).catch(function (error) {
                        console.error(error);
                    });
                });
            }
        }
    }, {
        key: 'exportMedicalCertificate',
        value: function exportMedicalCertificate(url) {
            window.open(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn_sigmec') + '/files/atestados/' + url);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'container-liquid' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'div',
                        { className: 'conteudo' },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            'h3',
                            { className: 'page-title' },
                            this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.titulo
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table__["BootstrapTable"],
                            { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: 'Exportar CSV', noDataText: this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.tabela.semDados }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table__["TableHeaderColumn"],
                                { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                                this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.tabela.ID
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table__["TableHeaderColumn"],
                                { dataField: 'schedule', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '200' },
                                this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.tabela.Escala
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table__["TableHeaderColumn"],
                                { dataField: 'staff', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '250' },
                                this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.tabela.Colaborador
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table__["TableHeaderColumn"],
                                { dataField: 'change_type_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '150' },
                                this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.tabela.TipoDeSolicitacao
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table__["TableHeaderColumn"],
                                { dataField: 'reason', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '250' },
                                this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.tabela.Justificativa
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table__["TableHeaderColumn"],
                                { dataField: 'status_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '200' },
                                this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.tabela.Status
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_9_react_bootstrap_table__["TableHeaderColumn"],
                                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, dataSort: false, filter: { type: 'TextFilter', delay: 200, placeholder: 'Procurar' }, width: '100' },
                                this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.tabela.Acoes
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["g" /* Modal */],
                            { show: this.state.modal, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["g" /* Modal */].Header,
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'h4',
                                    { className: 'pull-left' },
                                    this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.titulo
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'button',
                                    { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                                            return _this3.setState({ modal: false });
                                        } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["g" /* Modal */].Body,
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'row' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-md-6 form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.EscalasMesAtual,
                                            'l'
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'schedule', className: 'form-control', disabled: true, value: this.state.schedule_request.schedule })
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-md-6 form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.Colaborador
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'staff', className: 'form-control', disabled: true, value: this.state.schedule_request.staff })
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'row' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-md-6 form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.TipoDeAlteracao
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'change_type_str', className: 'form-control', disabled: true, value: this.state.schedule_request.change_type_str })
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-md-6 form-group' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'label',
                                            null,
                                            this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.Solicitante
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'user', className: 'form-control', disabled: true, value: this.state.schedule_request.user })
                                    )
                                ),
                                this.state.schedule_request.change_type == 'change_group' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6 form-group' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'label',
                                                null,
                                                this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.GrupoAtual
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'current_schedule_group', className: 'form-control', disabled: true, value: this.state.schedule_request.current_group })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6 form-group' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'label',
                                                null,
                                                this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.Novogrupo
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'new_schedule_group', className: 'form-control', disabled: true, value: this.state.schedule_request.new_group })
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { className: 'form-group' },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'label',
                                                    null,
                                                    this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.DataInicio,
                                                    ':'
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'date_start_str', className: 'form-control', disabled: true, value: this.state.schedule_request.date_start_str })
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { className: 'form-group' },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'label',
                                                    null,
                                                    this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.Definitiva
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'definitive_change_str', className: 'form-control', disabled: true, value: this.state.schedule_request.definitive_change_str })
                                            )
                                        )
                                    ),
                                    this.state.schedule_request.definitive_change == false ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { className: 'form-group' },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'label',
                                                    null,
                                                    this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.DataTermino,
                                                    ':'
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'date_finish_str', className: 'form-control', disabled: true, value: this.state.schedule_request.date_finish_str })
                                            )
                                        )
                                    ) : ''
                                ) : '',
                                this.state.schedule_request.change_type == 'change_regime' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6 form-group' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'label',
                                                null,
                                                this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.QuinzenaAtual
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'current_regime', className: 'form-control', disabled: true, value: this.state.schedule_request.current_regime })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6 form-group' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'label',
                                                null,
                                                this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.NovaQuinzena
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'new_regime', className: 'form-control', disabled: true, value: this.state.schedule_request.new_regime })
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { className: 'form-group' },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'label',
                                                    null,
                                                    this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.DataInicio,
                                                    ':'
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'date_start_str', className: 'form-control', disabled: true, value: this.state.schedule_request.date_start_str })
                                            )
                                        )
                                    )
                                ) : '',
                                this.state.schedule_request.change_type == 'change_base' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6 form-group' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'label',
                                                null,
                                                this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.BaseAtual
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'current_base', className: 'form-control', disabled: true, value: this.state.schedule_request.current_base })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6 form-group' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'label',
                                                null,
                                                this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.NovaBase
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'new_base', className: 'form-control', disabled: true, value: this.state.schedule_request.new_base })
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { className: 'form-group' },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'label',
                                                    null,
                                                    this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.DataInicio,
                                                    ':'
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'date_start_str', className: 'form-control', disabled: true, value: this.state.schedule_request.date_start_str })
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { className: 'form-group' },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'label',
                                                    null,
                                                    this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.Definitiva,
                                                    '?'
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'definitive_change_str', className: 'form-control', disabled: true, value: this.state.schedule_request.definitive_change_str })
                                            )
                                        )
                                    ),
                                    this.state.schedule_request.definitive_change == false ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { className: 'form-group' },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'label',
                                                    null,
                                                    this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.DataTermino,
                                                    ':'
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'date_finish_str', className: 'form-control', disabled: true, value: this.state.schedule_request.date_finish_str })
                                            )
                                        )
                                    ) : ''
                                ) : '',
                                this.state.schedule_request.change_type == 'change_period' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6 form-group' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'label',
                                                null,
                                                this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.PeriodoAtual
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'current_schedule_period', className: 'form-control', disabled: true, value: this.state.schedule_request.current_schedule_period })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6 form-group' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'label',
                                                null,
                                                this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.NovaPeriodo
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'new_schedule_period', className: 'form-control', disabled: true, value: this.state.schedule_request.new_schedule_period })
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { className: 'form-group' },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'label',
                                                    null,
                                                    this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.DataInicio,
                                                    ':'
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'date_start_str', className: 'form-control', disabled: true, value: this.state.schedule_request.date_start_str })
                                            )
                                        )
                                    )
                                ) : '',
                                this.state.schedule_request.change_type == 'change_role' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6 form-group' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'label',
                                                null,
                                                this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.FuncaoAtual
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'current_role', className: 'form-control', disabled: true, value: this.state.schedule_request.current_role })
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6 form-group' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'label',
                                                null,
                                                this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.NovaFuncao
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'new_role', className: 'form-control', disabled: true, value: this.state.schedule_request.new_role })
                                        )
                                    ),
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { className: 'form-group' },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'label',
                                                    null,
                                                    this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.DataInicio,
                                                    ':'
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'date_start_str', className: 'form-control', disabled: true, value: this.state.schedule_request.date_start_str })
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { className: 'form-group' },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'label',
                                                    null,
                                                    this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.Definitiva,
                                                    '?'
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'definitive_change_str', className: 'form-control', disabled: true, value: this.state.schedule_request.definitive_change_str })
                                            )
                                        )
                                    ),
                                    this.state.schedule_request.definitive_change == false ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { className: 'form-group' },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'label',
                                                    null,
                                                    this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.DataTermino,
                                                    ':'
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'date_finish_str', className: 'form-control', disabled: true, value: this.state.schedule_request.date_finish_str })
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { className: 'form-group' },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'label',
                                                    null,
                                                    this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.NumeroChamado,
                                                    ':'
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'request_number', className: 'form-control', disabled: true, value: this.state.schedule_request.request_number })
                                            )
                                        )
                                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { className: 'form-group' },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'label',
                                                    null,
                                                    this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.NumeroMp,
                                                    ':'
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'mp_number', className: 'form-control', disabled: true, value: this.state.schedule_request.mp_number })
                                            )
                                        )
                                    )
                                ) : '',
                                this.state.schedule_request.change_type == 'change_absences' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { className: 'form-group' },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'label',
                                                    null,
                                                    this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.DataInicio,
                                                    ':'
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'date_start_str', className: 'form-control', disabled: true, value: this.state.schedule_request.date_start_str })
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { className: 'form-group' },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'label',
                                                    null,
                                                    this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.TempoIndeterminado,
                                                    '?'
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'schedule', className: 'form-control', disabled: true, value: this.state.schedule_request.definitive_change_str })
                                            )
                                        )
                                    ),
                                    this.state.schedule_request.definitive_change == false ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { className: 'form-group' },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'label',
                                                    null,
                                                    this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.DataTermino,
                                                    ':'
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'date_finish_str', className: 'form-control', disabled: true, value: this.state.schedule_request.date_finish_str })
                                            )
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { className: 'form-group' },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'label',
                                                    null,
                                                    this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.Atestado,
                                                    ':'
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'button',
                                                    { onClick: function onClick() {
                                                            return _this3.exportMedicalCertificate(_this3.state.schedule_request.file);
                                                        }, className: 'btn btn-primary', value: this.state.schedule_request.id },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' })
                                                )
                                            )
                                        )
                                    ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-6' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { className: 'form-group' },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'label',
                                                    null,
                                                    this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.Atestado,
                                                    ':'
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'button',
                                                    { onClick: function onClick() {
                                                            return _this3.exportMedicalCertificate(_this3.state.schedule_request.file);
                                                        }, className: 'btn btn-primary', value: this.state.schedule_request.id },
                                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-file-pdf-o' })
                                                )
                                            )
                                        )
                                    )
                                ) : '',
                                this.state.schedule_request.change_type == 'other_changes' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-12' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { className: 'form-group' },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'label',
                                                    null,
                                                    this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.Descricao,
                                                    ':'
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', { value: this.state.schedule_request.description, name: 'description', className: 'form-control', placeholder: '', disabled: true, style: { height: '200px' }, required: true })
                                            )
                                        )
                                    )
                                ) : '',
                                this.state.schedule_request.change_type !== null && this.state.schedule_request.change_type !== 'change_absences' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    null,
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'row' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'col-md-12' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'div',
                                                { className: 'form-group' },
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                    'label',
                                                    null,
                                                    this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.formulario.Justificativa,
                                                    ':'
                                                ),
                                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', { value: this.state.schedule_request.reason, disabled: true, name: 'reason', className: 'form-control', placeholder: '', style: { height: '200px' }, required: true })
                                            )
                                        )
                                    )
                                ) : ''
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["g" /* Modal */].Footer,
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'button',
                                    { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                                            return _this3.setState({ modal: false });
                                        } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                                )
                            )
                        ),
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                            __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["g" /* Modal */],
                            { show: this.state.additional_info_modal, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["g" /* Modal */].Header,
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'h4',
                                    { className: 'pull-left' },
                                    this.state.change_status == 'additional_approval_pending' ? 'Aprovação' : 'Informações'
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'button',
                                    { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                                            return _this3.setState({ additional_info_modal: false });
                                        } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["g" /* Modal */].Body,
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'row' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-md-12' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'form-group' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'label',
                                                null,
                                                this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.modal_additional.Exigencia,
                                                ':'
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', { value: this.state.additional_info_request, name: 'additional_info_request', className: 'form-control', placeholder: '', style: { height: '200px' }, disabled: true })
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'row' },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-md-12' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'div',
                                            { className: 'form-group' },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                                'label',
                                                null,
                                                this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.modal_additional.Resposta,
                                                ':'
                                            ),
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', { value: this.state.additional_info_answer, name: 'additional_info_answer', className: 'form-control', onChange: this.handleChange.bind(this, 'additional_info_answer'), placeholder: '', style: { height: '200px' }, required: true })
                                        )
                                    )
                                ),
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'div',
                                    { className: 'row' },
                                    this.state.change_status == 'additional_info_pending' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-md-12' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'button',
                                            { className: 'btn btn-lg btn-block btn-primary', onClick: function onClick() {
                                                    _this3.confirmChangeStatus('additional_info_acceptance_pending');
                                                } },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                                            ' ',
                                            this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.modal_additional.botaoEnviarInformacaos
                                        )
                                    ) : this.state.change_status == 'additional_approval_pending' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                        'div',
                                        { className: 'col-md-12' },
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'button',
                                            { className: 'btn btn-lg btn-block btn-success', onClick: function onClick() {
                                                    _this3.confirmChangeStatus('additional_approval_acceptance_pending');
                                                } },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                                            ' ',
                                            this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.modal_additional.botaoAprovar
                                        ),
                                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                            'button',
                                            { className: 'btn btn-lg btn-block btn-danger', onClick: function onClick() {
                                                    _this3.confirmChangeStatus('additional_approval_reproved');
                                                } },
                                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                                            ' ',
                                            this.locale.Solicitacoes.ListaDeSolicitacoesSigmec.modal.modal_additional.botaoReprovar
                                        )
                                    ) : ''
                                )
                            ),
                            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap__["g" /* Modal */].Footer,
                                null,
                                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                                    'button',
                                    { className: 'btn btn-danger btn-sm pull-right', onClick: function onClick() {
                                            return _this3.setState({ additional_info_modal: false });
                                        } },
                                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
                                )
                            )
                        )
                    )
                )
            );
        }
    }]);

    return StaffScheduleRequestsSigmecIndex;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffScheduleRequestsSigmecIndex);

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_datepicker__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// Importação da tabela








var StaffFlightHourSearch = function (_Component) {
  _inherits(StaffFlightHourSearch, _Component);

  function StaffFlightHourSearch(props) {
    _classCallCheck(this, StaffFlightHourSearch);

    var _this = _possibleConstructorReturn(this, (StaffFlightHourSearch.__proto__ || Object.getPrototypeOf(StaffFlightHourSearch)).call(this, props));

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__i18n_getLocale__["a" /* default */])();

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      situation: 0,
      company: 0,
      data_search: [],
      aircraft_models_list: [],
      staff_list: [],
      totals: [],
      fb: null,
      type: 0,
      date_start: null,
      date_finish: null,
      fb_list: [{ value: "DC", label: "DC" }, { value: "IN", label: "IN" }, { value: "2P", label: "2P" }, { value: "1P", label: "1P" }, { value: "CM", label: "CM" }, { value: "PS", label: "PS" }],
      type_list: [{ value: 0, label: _this.locale.HorasDeVoo.VisualizarHorasDeVoo.opcoesTipo.Sintetica }, { value: 1, label: _this.locale.HorasDeVoo.VisualizarHorasDeVoo.opcoesTipo.Analitica }]
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.searchFlightHours = _this.searchFlightHours.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    return _this;
  }

  // Handlers


  _createClass(StaffFlightHourSearch, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeStaffSimple',
    value: function handleSelectChangeStaffSimple(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeList',
    value: function handleSelectChangeList(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
      this.setState({ staff_ids: null });
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleChangeDatePicker',
    value: function handleChangeDatePicker(state, date) {
      var change = {};
      change[state] = date.format("DD/MM/YYYY");
      this.setState(change);
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'searchFlightHours',
    value: function searchFlightHours(event) {
      event.preventDefault();

      if (this.state.type == 1 && (this.state.date_start === '' || this.state.date_start === null || this.state.date_finish === '' || this.state.date_finish === null)) {
        this.handleAlert(this.locale.HorasDeVoo.VisualizarHorasDeVoo.eNecessarioPreencherDataDeInicioEFimParaPesquisasAnaliticas, 'error', 'open');
      } else {
        this.handleAlert('', '', 'open');
        var datasave = {
          type: this.state.type,
          fb: this.state.fb,
          situation: this.state.situation,
          aircraft_models: this.state.aircraft_models_ids,
          company: this.state.company,
          date_start: this.state.date_start,
          date_finish: this.state.date_finish
        };

        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/tripulante/buscar/horas/voos', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.setState({ data_search: responseJson.data.main });
              self.setState({ totals: responseJson.data.totals });
              self.setState({ overlay: { message: '', type: '', status: 'closed' } });
            } else {
              self.handleAlert(responseJson.message, responseJson.status, 'open');
            }
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');

      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/aeronave/modelo/lista/modelos';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson);
          if (responseJson.status === 'success') {
            self.setState({ aircraft_models_list: responseJson.data });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.HorasDeVoo.VisualizarHorasDeVoo.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.searchFlightHours },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.HorasDeVoo.VisualizarHorasDeVoo.formulario.DataInicial,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_input_mask___default.a, { value: this.state.date_start, maskChar: null, name: 'date_start', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_start'), placeholder: '' })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.HorasDeVoo.VisualizarHorasDeVoo.formulario.DataFinal,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_input_mask___default.a, { value: this.state.date_finish, maskChar: null, name: 'date_finish', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date_finish'), placeholder: '' })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.HorasDeVoo.VisualizarHorasDeVoo.formulario.FB,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                      className: '',
                      name: 'fb',
                      value: this.state.fb,
                      searchable: true,
                      multi: true,
                      placeholder: this.locale.HorasDeVoo.VisualizarHorasDeVoo.formulario.placeholder.SelecionarTipo,
                      onChange: this.handleSelectChange.bind(this, 'fb'),
                      options: this.state.fb_list
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.HorasDeVoo.VisualizarHorasDeVoo.formulario.Listagem,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                      className: '',
                      name: 'type',
                      value: this.state.type,
                      searchable: true,
                      onChange: this.handleSelectChangeList.bind(this, 'type'),
                      options: this.state.type_list
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.HorasDeVoo.VisualizarHorasDeVoo.formulario.Modelo,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_select__["a" /* default */], {
                      className: '',
                      name: 'aircraft_models_ids',
                      value: this.state.aircraft_models_ids,
                      searchable: true,
                      multi: true,
                      placeholder: this.locale.HorasDeVoo.VisualizarHorasDeVoo.formulario.placeholder.SelecionarModelosDeAeronave,
                      onChange: this.handleSelectChange.bind(this, 'aircraft_models_ids'),
                      options: this.state.aircraft_models_list
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'button',
                  { type: 'submit', className: 'btn btn-success btn-block' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-search' }),
                  ' ',
                  this.locale.general.pesquisar,
                  ' '
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data_search, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.semAeronaves }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, hidden: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'date_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.Data
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'staff_inscription', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '80' },
                this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.Matricula
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'staff_nickname', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '160' },
                this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.Apelido
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'aircraft_model', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.Modelo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'fb', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.FB
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'simulator_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.Simulador
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'total_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.Total
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'ifr_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.IFR
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'noturno_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.Noturno
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'app', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.APP
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'daytime', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.Diu
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'nighttime', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.Not
              ),
              this.state.type === 0 ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'freight_ex_total_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.CgExt
              ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'freight_ex_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabela.CgExt
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              this.locale.HorasDeVoo.VisualizarHorasDeVoo.tituloTotais
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.totals, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabelaTotais.semAeronaves }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, hidden: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabelaTotais.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'staff_inscription', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '80' },
                this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabelaTotais.Matricula
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'staff_nickname', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '160' },
                this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabelaTotais.Apelido
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'aircraft_model', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabelaTotais.Modelo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'total_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabelaTotais.Total
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'ifr_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabelaTotais.IFR
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'noturno_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabelaTotais.Noturno
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'app', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabelaTotais.APP
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'daytime', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabelaTotais.Diu
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'nighttime', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.HorasDeVoo.VisualizarHorasDeVoo.tabelaTotais.Not
              )
            )
          )
        )
      );
    }
  }]);

  return StaffFlightHourSearch;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (StaffFlightHourSearch);

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var TasksAdd = function (_Component) {
  _inherits(TasksAdd, _Component);

  // constructor
  function TasksAdd(props) {
    _classCallCheck(this, TasksAdd);

    var _this = _possibleConstructorReturn(this, (TasksAdd.__proto__ || Object.getPrototypeOf(TasksAdd)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      name: ''
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.add = _this.add.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(TasksAdd, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      var datasave = {
        name: this.state.name
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/tarefa', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var url = '/tarefa/editar/' + responseJson.data.id;
            var storage = {
              alert_message: responseJson.message,
              alert_type: responseJson.status
            };
            localStorage.setItem("verify_message", JSON.stringify(storage));
            self.setState({ redirect_url: url });
          }
          self.setState({ overlay: { message: responseJson.message, type: responseJson.status, status: 'open' } });
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.Tarefas.AdicionarTarefa.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/tarefas', className: 'btn btn-default pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-left' }),
              ' ',
              this.locale.general.voltar
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.add },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Tarefas.AdicionarTarefa.formulario.Tarefa,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'name', className: 'form-control', placeholder: this.locale.Tarefas.AdicionarTarefa.formulario.placeholder.TarefaDeRestricao, value: this.state.name, onChange: this.handleChange.bind(this, 'name') })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                    ' ',
                    this.locale.Tarefas.AdicionarTarefa.formulario.botaoCadastrarTarefa
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return TasksAdd;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (TasksAdd);

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var TasksEdit = function (_Component) {
  _inherits(TasksEdit, _Component);

  // constructor
  function TasksEdit(props) {
    _classCallCheck(this, TasksEdit);

    var _this = _possibleConstructorReturn(this, (TasksEdit.__proto__ || Object.getPrototypeOf(TasksEdit)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      name: ''
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.edit = _this.edit.bind(_this);
    _this.loadData = _this.loadData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(TasksEdit, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/tarefa/' + self.props.match.params.id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url', '/tarefas');
          if (responseJson.status === 'success') {
            self.setState({
              id: responseJson.data.id,
              name: responseJson.data.name
            });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        });
      });
    }
    // Fetch salvando a edição

  }, {
    key: 'edit',
    value: function edit(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        id: this.state.id,
        name: this.state.name
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/tarefa', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        this.state.redirect_url ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["e" /* Redirect */], { to: { pathname: this.state.redirect_url } }) : "",
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.Tarefas.EditarTarefa.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/tarefas', className: 'btn btn-default pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-chevron-left' }),
              ' ',
              this.locale.general.voltar
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.edit },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Tarefas.EditarTarefa.formulario.Tarefa,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'text', name: 'name', className: 'form-control', placeholder: this.locale.Tarefas.EditarTarefa.formulario.placeholder.TarefaDeRestricao, value: this.state.name, onChange: this.handleChange.bind(this, 'name') })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                    ' ',
                    this.locale.general.salvarEdicao
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return TasksEdit;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (TasksEdit);

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// Importação da tabela



var TasksIndex = function (_Component) {
  _inherits(TasksIndex, _Component);

  function TasksIndex(props) {
    _classCallCheck(this, TasksIndex);

    var _this = _possibleConstructorReturn(this, (TasksIndex.__proto__ || Object.getPrototypeOf(TasksIndex)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.loadData = _this.loadData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(TasksIndex, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/tarefas', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var url = '/tarefa/editar/' + cell;
      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
          { className: 'btn btn-primary btn-sm', to: url },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-pencil' })
        )
      );

      return botao;
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.Tarefas.ListaDeTarefas.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Link */],
              { to: '/tarefas/cadastrar', className: 'btn btn-primary pull-right' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-plus' }),
              ' ',
              this.locale.Tarefas.ListaDeTarefas.botaoAdicionarTarefa
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Tarefas.ListaDeTarefas.tabela.semTarefas }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.Tarefas.ListaDeTarefas.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'name', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.Tarefas.ListaDeTarefas.tabela.Nome
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_6_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '100' },
                this.locale.Tarefas.ListaDeTarefas.tabela.Acoes
              )
            )
          )
        )
      );
    }
  }]);

  return TasksIndex;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (TasksIndex);

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var TrainingCertificationLogbooksModal = function (_Component) {
  _inherits(TrainingCertificationLogbooksModal, _Component);

  function TrainingCertificationLogbooksModal(props) {
    _classCallCheck(this, TrainingCertificationLogbooksModal);

    var _this = _possibleConstructorReturn(this, (TrainingCertificationLogbooksModal.__proto__ || Object.getPrototypeOf(TrainingCertificationLogbooksModal)).call(this, props));

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__["a" /* default */])();

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      modal: false,
      staff_id: null,
      type: null,
      staff_list: [],
      training_certification_logbook_staffs: [],
      types_select: [{ value: 'examiner', label: _this.locale.Sessoes.AdicionarSessao.opcoesTipo.Examinador }, { value: 'instructor', label: _this.locale.Sessoes.AdicionarSessao.opcoesTipo.Instrutor }, { value: 'pilot_flying', label: _this.locale.Sessoes.AdicionarSessao.opcoesTipo.PilotFlying }, { value: 'pilot_monitoring', label: _this.locale.Sessoes.AdicionarSessao.opcoesTipo.PilotMonitoring }]
    };
    //handlers

    _this.add = _this.add.bind(_this);
    _this.delete = _this.delete.bind(_this);
    _this.closeModal = _this.closeModal.bind(_this);
    return _this;
  }
  // Handlers


  _createClass(TrainingCertificationLogbooksModal, [{
    key: 'handleNavTab',
    value: function handleNavTab(state, key) {
      var change = {};
      change[state] = key;
      this.setState(change);
      this.setState({ overlay: { message: '', type: '', status: '' } });
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }

    //LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (newProps.modal_props === true && this.state.loaded === 0) {
        this.setState({
          modal: true,
          id: newProps.training_certification_logbook.id,
          training_certification_logbook_id: newProps.training_certification_logbook.id,
          training_certification_logbook_staffs: newProps.training_certification_logbook_staffs,
          staff_list: newProps.staff_list,
          loaded: 1
        });
      }
    }

    // Fetch salvando a edição

  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      this.props.handleAlert('', '', 'open');
      var datasave = {
        training_certification_logbook_id: this.state.id,
        staff_id: this.state.staff_id,
        type: this.state.type
      };

      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/treinamento/certificado/logbook/tripulante', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.setState({
            training_certification_logbook_staffs: responseJson.data
          });
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'delete',
    value: function _delete(id) {
      if (window.confirm(this.locale.Sessoes.AdicionarSessao.deletarTripulante)) {
        this.props.handleAlert('', '', 'open');

        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/treinamento/certificado/logbook/tripulante/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({
              training_certification_logbook_staffs: responseJson.data
            });
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.setState({
        modal: false,
        loaded: 0
      }, this.props.closeModalParent());
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */],
          { show: this.state.modal, 'aria-labelledby': 'contained-modal-title-lg', bsSize: 'large' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Header,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              { className: 'pull-left' },
              this.locale.Sessoes.AdicionarSessao.tituloAdicionarTripulante
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: this.closeModal },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Body,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.add },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Sessoes.AdicionarSessao.formularioAdicionarArquivo.Tripulante,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'staff_id',
                      value: this.state.staff_id,
                      searchable: true,
                      placeholder: '',
                      onChange: this.handleSelectChange.bind(this, 'staff_id'),
                      options: this.state.staff_list
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Sessoes.AdicionarSessao.formularioAdicionarArquivo.Tipo,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'type',
                      value: this.state.type,
                      searchable: true,
                      placeholder: '',
                      onChange: this.handleSelectChange.bind(this, 'type'),
                      options: this.state.types_select
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                    ' ',
                    this.locale.general.salvar
                  )
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'table',
              { className: 'table table-bordered table-hover' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'thead',
                null,
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'tr',
                  null,
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    { className: 'text-center' },
                    this.locale.Sessoes.AdicionarSessao.tabelaTripulantes.Tripulante
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    { className: 'text-center' },
                    this.locale.Sessoes.AdicionarSessao.tabelaTripulantes.Matricula
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    { className: 'text-center' },
                    this.locale.Sessoes.AdicionarSessao.tabelaTripulantes.Tipo
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'th',
                    { className: 'text-center' },
                    this.locale.Sessoes.AdicionarSessao.tabelaTripulantes.Acoes
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'tbody',
                { id: 'training-certification-staffs' },
                Object.keys(self.state.training_certification_logbook_staffs).map(function (k) {
                  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'tr',
                    null,
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      { className: 'text-center' },
                      self.state.training_certification_logbook_staffs[k].staff.name
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      { className: 'text-center' },
                      self.state.training_certification_logbook_staffs[k].staff.inscription
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      { className: 'text-center' },
                      self.state.training_certification_logbook_staffs[k].type_str
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'td',
                      { className: 'col-md-2 text-center' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'button',
                        { className: 'btn btn-danger btn-sm', onClick: function onClick() {
                            return self.delete(self.state.training_certification_logbook_staffs[k].id);
                          } },
                        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-trash' })
                      )
                    )
                  );
                })
              )
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_4_react_bootstrap__["g" /* Modal */].Footer,
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'button',
              { className: 'btn btn-danger btn-sm pull-right', onClick: this.closeModal },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
            )
          )
        )
      );
    }
  }]);

  return TrainingCertificationLogbooksModal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (TrainingCertificationLogbooksModal);

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n_getLocale__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Miscelania_RequestApi__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var TrainingLogbooksTabAddFile = function (_Component) {
  _inherits(TrainingLogbooksTabAddFile, _Component);

  function TrainingLogbooksTabAddFile(props) {
    _classCallCheck(this, TrainingLogbooksTabAddFile);

    var _this = _possibleConstructorReturn(this, (TrainingLogbooksTabAddFile.__proto__ || Object.getPrototypeOf(TrainingLogbooksTabAddFile)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: false,
      id: _this.props.id,
      file_archived: _this.props.file_archived,
      file: _this.props.file
    };

    //bind específico
    _this.addFile = _this.addFile.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(TrainingLogbooksTabAddFile, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }

    // LM

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (typeof newProps.id !== 'undefined') {
        this.setState({
          id: newProps.id,
          file_archived: newProps.file_archived,
          file: newProps.file
        });
      }
    }
  }, {
    key: 'addFile',
    value: function addFile(event) {
      event.preventDefault();
      var confirm = window.confirm(this.locale.Sessoes.AdicionarSessao.importarArquivo);
      if (confirm) {
        var data = new FormData();
        var imagedata = document.querySelector('.input-archive-logbooks-' + this.state.id).files[0];
        data.append("imagem", imagedata);
        data.append("id", this.state.id);
        var header = this.refs.request_api.header();
        var self = this;
        this.props.handleAlert('', '', 'open');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/treinamento/certificado/logbook/arquivo', {
            method: 'POST',
            mode: 'cors',
            headers: value,
            body: data }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.props.updateData(responseJson);
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api' }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'form',
          { onSubmit: this.addFile },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'file', name: 'archive', className: "form-control input-display-inline input-archive-logbooks-" + this.state.id, placeholder: this.locale.Sessoes.AdicionarSessao.formularioAdicionarArquivo.placeholder.Arquivo, value: this.state.archive, onChange: this.handleChange.bind(this, 'archive'), style: { width: 135 }, required: true }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { type: 'submit', className: 'btn btn-primary btn-sm btn-margin-bottom btn-margin-left' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-save' })
          ),
          '\xA0',
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: "btn btn-sm btn-warning btn-margin-bottom", disabled: this.state.file_archived === 1 ? "" : "disabled", target: '_blank', href: __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('cdn') + '/files/logbooks/' + this.state.file },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-download' })
          ),
          '\xA0'
        )
      );
    }
  }]);

  return TrainingLogbooksTabAddFile;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (TrainingLogbooksTabAddFile);

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Elements_TrainingLogbooksTabAddFile__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Elements_TrainingCertificationLogbooksModal__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











// Helpers de formulário


// Importação da tabela



var TrainingCertificationLogbooksIndex = function (_Component) {
  _inherits(TrainingCertificationLogbooksIndex, _Component);

  function TrainingCertificationLogbooksIndex(props) {
    _classCallCheck(this, TrainingCertificationLogbooksIndex);

    var _this = _possibleConstructorReturn(this, (TrainingCertificationLogbooksIndex.__proto__ || Object.getPrototypeOf(TrainingCertificationLogbooksIndex)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      updated: 0,
      training_certification_logbooks: [],
      training_certification_id: null,
      date: null,
      start: null,
      finish: null,
      training_certifications_select: [],
      staff_list: [],
      training_certification_logbook: {},
      modal_props: false,
      modal_duplicate_props: false
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.loadData = _this.loadData.bind(_this);
    _this.add = _this.add.bind(_this);
    _this.delete = _this.delete.bind(_this);
    _this.editModal = _this.editModal.bind(_this);
    _this.closeModalParent = _this.closeModalParent.bind(_this);
    _this.updateDataModal = _this.updateDataModal.bind(_this);
    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.ArchiveButtons = _this.ArchiveButtons.bind(_this);
    _this.StatusButtons = _this.StatusButtons.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(TrainingCertificationLogbooksIndex, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData(event) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/treinamento/usuario/logbooks';
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ training_certification_logbooks: responseJson.data.main, training_certifications_select: responseJson.data.training_certifications_select, staff_list: responseJson.data.staff_list });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          if (typeof event === 'undefined') {
            self.handleMessage();
          } else {
            self.handleAlert(event.message, event.status, 'open');
          }
        }); /* Overlay */
      });
    }

    // Fetch salvando a edição

  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        training_certification_id: this.state.training_certification_id,
        date: this.state.date,
        start: this.state.start,
        finish: this.state.finish,
        examiner_id: this.state.examiner_id,
        instructor_id: this.state.instructor_id,
        pf_id: this.state.pf_id,
        pm_id: this.state.pm_id
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/treinamento/certificado/logbook', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.loadData(responseJson);
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'delete',
    value: function _delete(id) {
      var training_certification_logbook_id = id;
      var confirm = window.confirm(this.locale.Sessoes.AdicionarSessao.deletar);
      if (confirm) {
        var self = this;
        self.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/treinamento/certificado/logbook/' + training_certification_logbook_id, { method: 'DELETE', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.loadData(responseJson);
            } else {
              self.handleAlert(responseJson.message, responseJson.status, 'open');
            }
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'updateDataModal',
    value: function updateDataModal(responseJson) {
      var header = this.setState({ updated: 1 });
      var self = this;
      Promise.resolve(header).then(function (value) {
        self.editModal(responseJson);
      });
    }
  }, {
    key: 'editModal',
    value: function editModal(event) {
      if (this.state.updated == 0) {
        var training_certification_logbook_id = event.id;
        this.handleAlert('', '', 'open');
      } else {
        var training_certification_logbook_id = event.data.training_certification_logbook_id;
      }
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/treinamento/certificado/logbook/tripulantes/' + training_certification_logbook_id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            if (self.state.updated == 1) {
              self.handleAlert(event.message, event.status, 'open');
            } else {
              self.setState({ modal_props: true, training_certification_logbook: event, training_certification_logbook_staffs: responseJson.data, training_certification_logbook_id: training_certification_logbook_id });
              self.handleAlert('', '', 'closed');
            }
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        });
      });
    }
  }, {
    key: 'finalize',
    value: function finalize(id) {
      var training_certification_logbook_id = id;
      var confirm = window.confirm(this.locale.Sessoes.AdicionarSessao.finalizar);
      if (confirm) {
        var datasave = {};
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/treinamento/certificado/logbook/finalizar/' + training_certification_logbook_id, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.loadData(responseJson);
            } else {
              self.handleAlert(responseJson.message, responseJson.status, 'open');
            }
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'reopen',
    value: function reopen(id) {
      var training_certification_logbook_id = id;
      var confirm = window.confirm(this.locale.Sessoes.AdicionarSessao.reabrir);
      if (confirm) {
        var datasave = {};
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/treinamento/certificado/logbook/reabrir/' + training_certification_logbook_id, { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.loadData(responseJson);
            } else {
              self.handleAlert(responseJson.message, responseJson.status, 'open');
            }
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'closeModalParent',
    value: function closeModalParent() {
      var responseJson = {
        status: 'success',
        message: this.locale.Sessoes.AdicionarSessao.osDadosForamAtualizadosComSucesso
      };
      this.handleAlert('', '', 'open');
      this.setState({ modal_props: false, modal_duplicate_props: false, updated: 0 }, this.loadData(responseJson));
    }
  }, {
    key: 'StatusButtons',
    value: function StatusButtons(cell, row) {
      if (row.status === 0) {
        var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'label label-danger' },
          this.locale.Sessoes.AdicionarSessao.botaoAberto
        );
      }
      if (row.status === 1) {
        var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'label label-primary' },
          this.locale.Sessoes.AdicionarSessao.botaoFinalizado
        );
      }
      if (row.status === 2) {
        var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          { className: 'label label-success' },
          this.locale.Sessoes.AdicionarSessao.botaoConfirmado
        );
      }
      return botao;
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var _this2 = this;

      if (row.status === 0) {
        var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn btn-primary btn-sm', onClick: function onClick() {
                return _this2.editModal(row);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-users' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn btn-danger btn-sm', onClick: function onClick() {
                return _this2.delete(row.id);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-trash' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn btn-success btn-sm', onClick: function onClick() {
                return _this2.finalize(row.id);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-check' })
          )
        );
      }
      if (row.status === 1) {
        var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'btn-group' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn btn-primary btn-sm', onClick: function onClick() {
                return _this2.editModal(row);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-users' })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'button',
            { className: 'btn btn-danger btn-sm', onClick: function onClick() {
                return _this2.reopen(row.id);
              } },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-close' })
          )
        );
      }

      return botao;
    }
  }, {
    key: 'ArchiveButtons',
    value: function ArchiveButtons(cell, row) {
      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Elements_TrainingLogbooksTabAddFile__["a" /* default */], { handleAlert: this.handleAlert, updateData: this.loadData, id: row.id, file: row.file, file_archived: row.file_archived });
      return botao;
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.Sessoes.AdicionarSessao.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.add },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Sessoes.AdicionarSessao.formulario.Treinamento,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'training_certification_id',
                      value: this.state.training_certification_id,
                      searchable: true,
                      placeholder: this.locale.Sessoes.AdicionarSessao.formulario.placeholder.SelecionarCertificado,
                      onChange: this.handleSelectChange.bind(this, 'training_certification_id'),
                      options: this.state.training_certifications_select,
                      required: true
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Sessoes.AdicionarSessao.formulario.Data,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_input_mask___default.a, { value: this.state.date, maskChar: null, name: 'date', mask: '99/99/9999', className: 'form-control', onChange: this.handleChange.bind(this, 'date'), placeholder: this.locale.Sessoes.AdicionarSessao.formulario.placeholder.Data })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Sessoes.AdicionarSessao.formulario.Inicio,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_input_mask___default.a, { value: this.state.start, maskChar: null, name: 'start', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'start'), placeholder: this.locale.Sessoes.AdicionarSessao.formulario.placeholder.HorarioDeInicio })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Sessoes.AdicionarSessao.formulario.Fim,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_input_mask___default.a, { value: this.state.finish, maskChar: null, name: 'finish', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'finish'), placeholder: this.locale.Sessoes.AdicionarSessao.formulario.placeholder.HorarioDeFim })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Sessoes.AdicionarSessao.formulario.Examinador,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'examiner_id',
                      value: this.state.examiner_id,
                      searchable: true,
                      placeholder: '',
                      onChange: this.handleSelectChange.bind(this, 'examiner_id'),
                      options: this.state.staff_list
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Sessoes.AdicionarSessao.formulario.Instrutor,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'instructor_id',
                      value: this.state.instructor_id,
                      searchable: true,
                      placeholder: '',
                      onChange: this.handleSelectChange.bind(this, 'instructor_id'),
                      options: this.state.staff_list
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Sessoes.AdicionarSessao.formulario.PilotFlying,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'pf_id',
                      value: this.state.pf_id,
                      searchable: true,
                      placeholder: '',
                      onChange: this.handleSelectChange.bind(this, 'pf_id'),
                      options: this.state.staff_list
                    })
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-3' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'form-group' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'label',
                      null,
                      this.locale.Sessoes.AdicionarSessao.formulario.PilotMonitoring,
                      ':'
                    ),
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_select__["a" /* default */], {
                      className: 'form-field-name',
                      name: 'pm_id',
                      value: this.state.pm_id,
                      searchable: true,
                      placeholder: '',
                      onChange: this.handleSelectChange.bind(this, 'pm_id'),
                      options: this.state.staff_list
                    })
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-plus' }),
                ' ',
                this.locale.Sessoes.AdicionarSessao.formulario.botaoAdicionarSessao
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.Sessoes.AdicionarSessao.tituloListaDeSessoes
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.training_certification_logbooks, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Sessoes.AdicionarSessao.tabela.semTarefas }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 50, placeholder: ' ' }, width: '60' },
                this.locale.Sessoes.AdicionarSessao.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'training', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 50, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Sessoes.AdicionarSessao.tabela.Treinamento
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'certification', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 50, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Sessoes.AdicionarSessao.tabela.Certificado
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'start_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 50, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Sessoes.AdicionarSessao.tabela.Inicio
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'finish_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 50, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Sessoes.AdicionarSessao.tabela.Fim
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'hours_str', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 50, placeholder: this.locale.general.procurar }, width: '120' },
                this.locale.Sessoes.AdicionarSessao.tabela.HorasTotais
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ArchiveButtons, width: '300' },
                this.locale.Sessoes.AdicionarSessao.tabela.Arquivo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.StatusButtons, width: '120' },
                this.locale.Sessoes.AdicionarSessao.tabela.Status
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_10_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', dataAlign: 'center', dataFormat: this.ActionsButtons, width: '200' },
                this.locale.Sessoes.AdicionarSessao.tabela.Acoes
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Elements_TrainingCertificationLogbooksModal__["a" /* default */], { handleAlert: this.handleAlert, staff_list: this.state.staff_list, training_certification_logbook: this.state.training_certification_logbook, training_certification_logbook_staffs: this.state.training_certification_logbook_staffs, training_certification_logbook_id: this.state.training_certification_logbook_id, modal_props: this.state.modal_props, updateData: this.loadData, closeModalParent: this.closeModalParent, updateDataModal: this.updateDataModal, updated: this.state.updated })
          )
        )
      );
    }
  }]);

  return TrainingCertificationLogbooksIndex;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (TrainingCertificationLogbooksIndex);

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











// Importação da tabela



var UsefulLinksIndex = function (_Component) {
  _inherits(UsefulLinksIndex, _Component);

  function UsefulLinksIndex(props) {
    _classCallCheck(this, UsefulLinksIndex);

    var _this = _possibleConstructorReturn(this, (UsefulLinksIndex.__proto__ || Object.getPrototypeOf(UsefulLinksIndex)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open'
      },
      redirect_url: false,
      loaded: 0,
      data: [],
      name: null,
      link: null
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.add = _this.add.bind(_this);
    _this.delete = _this.delete.bind(_this);
    _this.deleteRow = _this.deleteRow.bind(_this);
    _this.loadData = _this.loadData.bind(_this);
    _this.ActionsButtons = _this.ActionsButtons.bind(_this);
    _this.FormatLink = _this.FormatLink.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers
  // Handlers


  _createClass(UsefulLinksIndex, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData() {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/links/uteis', { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'url');
          if (responseJson.status === 'success') {
            self.setState({ data: responseJson.data });
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }
  }, {
    key: 'add',
    value: function add(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        name: this.state.name,
        link: this.state.link
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/link/util', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.loadData();
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'ActionsButtons',
    value: function ActionsButtons(cell, row) {
      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'btn-group' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'button',
          { className: 'btn btn-sm btn-danger', value: cell, onClick: this.delete },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-trash' })
        )
      );

      return botao;
    }
  }, {
    key: 'FormatLink',
    value: function FormatLink(cell, row) {
      var botao = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'a',
        { target: '_blank', href: cell },
        cell
      );

      return botao;
    }
  }, {
    key: 'delete',
    value: function _delete(event) {
      var useful_link_id = event.currentTarget.value;
      var confirm = window.confirm(this.locale.LinksUteis.LinksUteis.deletar);
      if (confirm) {
        this.handleAlert('', '', 'open');
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function (value) {
          fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/link/util/' + useful_link_id, { method: 'DELETE', mode: 'cors', headers: value }).then(function (response) {
            return response.json();
          }).catch(function (error) {
            console.error(error);
          }).then(function (responseJson) {
            self.refs.request_api.validate(responseJson, 'alert');
            if (responseJson.status === 'success') {
              self.deleteRow(useful_link_id);
            }
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch(function (error) {
            console.error(error);
          });
        });
      }
    }
  }, {
    key: 'deleteRow',
    value: function deleteRow(useful_link_id) {
      var data = this.state.data;
      data.map(function (dado, index) {
        if (dado.id == useful_link_id) {
          data.splice(index, 1);
        }
      });
      this.setState({ data: data });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              this.locale.LinksUteis.LinksUteis.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["BootstrapTable"],
              { data: this.state.data, pagination: true, striped: true, hover: true, exportCSV: true, options: { exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.LinksUteis.LinksUteis.tabela.semIncompatibilidades }, search: true, multiColumnSearch: true, searchPlaceholder: this.locale.general.procurar },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'id', isKey: true, dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: ' ' }, width: '60' },
                this.locale.LinksUteis.LinksUteis.tabela.ID
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'name', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar } },
                this.locale.LinksUteis.LinksUteis.tabela.Nome
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_7_react_bootstrap_table__["TableHeaderColumn"],
                { dataField: 'link', dataAlign: 'center', dataSort: true, filter: { type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar }, dataFormat: this.FormatLink },
                this.locale.LinksUteis.LinksUteis.tabela.Link
              )
            )
          )
        )
      );
    }
  }]);

  return UsefulLinksIndex;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (UsefulLinksIndex);

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var EmailDrowsinessScheduleTest = function (_Component) {
  _inherits(EmailDrowsinessScheduleTest, _Component);

  function EmailDrowsinessScheduleTest(props) {
    _classCallCheck(this, EmailDrowsinessScheduleTest);

    var _this = _possibleConstructorReturn(this, (EmailDrowsinessScheduleTest.__proto__ || Object.getPrototypeOf(EmailDrowsinessScheduleTest)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      message: '',
      status: 'respondido'
    };
    // Handlers
    _this.edit = _this.edit.bind(_this);
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);
    _this.loadData = _this.loadData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }
  // Handlers


  _createClass(EmailDrowsinessScheduleTest, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData(event) {
      var self = this;
      self.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/escala/sonolencia/teste/status/' + self.props.match.params.token;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          if (responseJson.status === 'success') {
            self.setState({
              status: responseJson.data
            });
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }

    // Fetch salvando a edição

  }, {
    key: 'edit',
    value: function edit(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        token: this.props.match.params.token,
        hour_start: this.state.hour_start,
        fatigue: this.state.fatigue
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/escala/sonolencia/teste/reposta', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.setState({
            status: 'respondido'
          });
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'user-wrapper' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'user-layer-suspended' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'container-liquid' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'conteudo' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h3',
                { className: 'page-title' },
                this.locale.Usuarios.TesteDeSonolencia.titulo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              this.state.status == 'respondido' ? "" : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'form',
                { onSubmit: this.edit },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Usuarios.TesteDeSonolencia.formulario.HorarioDeInicioDaJornada,
                        ':'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_input_mask___default.a, { required: true, value: this.state.hour_start, maskChar: null, name: 'hour_start', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'hour_start'), placeholder: this.locale.Usuarios.TesteDeSonolencia.formulario.placeholder.HorarioDeApresentacao })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Usuarios.TesteDeSonolencia.formulario.ComoVoceEstaSeSentindoAgora,
                        '?'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                        className: 'form-field-name',
                        name: 'fatigue',
                        value: this.state.fatigue,
                        searchable: true,
                        placeholder: 'Selecionar uma opção',
                        onChange: this.handleSelectChange.bind(this, 'fatigue'),
                        options: [{ value: 'extremely_alert', label: this.locale.Usuarios.TesteDeSonolencia.formulario.opcoesComoVoceEstaSeSentindoAgora.ExtremamenteAlerta }, { value: 'very_alert', label: this.locale.Usuarios.TesteDeSonolencia.formulario.opcoesComoVoceEstaSeSentindoAgora.MuitoAlerta }, { value: 'alert', label: this.locale.Usuarios.TesteDeSonolencia.formulario.opcoesComoVoceEstaSeSentindoAgora.Alerta }, { value: 'fairly_alert', label: this.locale.Usuarios.TesteDeSonolencia.formulario.opcoesComoVoceEstaSeSentindoAgora.RazoavelmenteAlerta }, { value: 'neither_alert_sleet', label: this.locale.Usuarios.TesteDeSonolencia.formulario.opcoesComoVoceEstaSeSentindoAgora.NemAlertaNemSonolento }, { value: 'signs_sleepiness', label: this.locale.Usuarios.TesteDeSonolencia.formulario.opcoesComoVoceEstaSeSentindoAgora.AlgunsSinaisDeSonolencia }, { value: 'sleepy_no_effort', label: this.locale.Usuarios.TesteDeSonolencia.formulario.opcoesComoVoceEstaSeSentindoAgora.SonolentoMasConsigoMeManterAcordado }, { value: 'sleepy_some_effort', label: this.locale.Usuarios.TesteDeSonolencia.formulario.opcoesComoVoceEstaSeSentindoAgora.SonolentoPrecisoMeConcentrarParaMeManterAcordado }, { value: 'sleepy_great_effort', label: this.locale.Usuarios.TesteDeSonolencia.formulario.opcoesComoVoceEstaSeSentindoAgora.MuitosonolentoMuitoEsforcoParaMeManterAcordadoLutandoComOSono }]
                      })
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-12' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                      ' ',
                      this.locale.Usuarios.TesteDeSonolencia.formulario.botaoResponder
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return EmailDrowsinessScheduleTest;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (EmailDrowsinessScheduleTest);

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_select__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_input_mask__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_input_mask___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_input_mask__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_toggle__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_toggle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_toggle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var EmailFatigueQuestions = function (_Component) {
  _inherits(EmailFatigueQuestions, _Component);

  function EmailFatigueQuestions(props) {
    _classCallCheck(this, EmailFatigueQuestions);

    var _this = _possibleConstructorReturn(this, (EmailFatigueQuestions.__proto__ || Object.getPrototypeOf(EmailFatigueQuestions)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      message: '',
      fatigue_system_efficient: false,
      fadigado: false,
      status: 0
    };
    // Handlers
    _this.edit = _this.edit.bind(_this);
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);
    _this.loadData = _this.loadData.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(EmailFatigueQuestions, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleSelectChangeMulti',
    value: function handleSelectChangeMulti(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event;
      }
      this.setState(change);
    }
  }, {
    key: 'handleSelectChange',
    value: function handleSelectChange(name, event) {
      var change = {};
      if (event == null) {
        change[name] = null;
      } else {
        change[name] = event.value;
      }
      this.setState(change);
    }
  }, {
    key: 'handleToggleChange',
    value: function handleToggleChange(name, event) {
      var change = {};
      if (event.target.checked === true) {
        var value = 1;
      } else {
        var value = 0;
      }
      change[name] = value;
      this.setState(change);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        this.setState({ loaded: 2 }, this.loadData());
      }
    }
  }, {
    key: 'loadData',
    value: function loadData(event) {
      var self = this;
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        var url = __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/questionario/pesquisa/fadiga/' + self.props.match.params.token;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          if (responseJson.status === 'success') {
            self.setState({
              status: 1
            });
          } else {
            self.handleAlert(responseJson.message, responseJson.status, 'open');
          }
        }).then(function () {
          self.setState({ overlay: { message: '', type: '', status: 'closed' } });
          self.handleMessage();
        }); /* Overlay */
      });
    }

    // Fetch salvando a edição

  }, {
    key: 'edit',
    value: function edit(event) {
      event.preventDefault();
      this.handleAlert('', '', 'open');
      var datasave = {
        token: this.props.match.params.token,
        contramedidas: this.state.contramedidas,
        fatores_fadiga: this.state.fatores_fadiga,
        fadigado: this.state.fadigado,
        ultimo_dia_acordou: this.state.ultimo_dia_acordou,
        ultimo_dia_dormiu: this.state.ultimo_dia_dormiu,
        penultimo_dia_acordou: this.state.penultimo_dia_acordou,
        penultimo_dia_dormiu: this.state.penultimo_dia_dormiu,
        qualidade_sono_ultimo: this.state.qualidade_sono_ultimo,
        qualidade_sono_penultimo: this.state.qualidade_sono_penultimo,
        tres_dias_horas_dormiu: this.state.tres_dias_horas_dormiu,
        tres_dias_horas_acordou: this.state.tres_dias_horas_acordou,
        qualidade_sono_tres_dias: this.state.qualidade_sono_tres_dias,
        details: this.state.details,
        sinais: this.state.sinais,
        fatigue_system_efficient: this.state.fatigue_system_efficient,
        sugestoes: this.state.sugestoes
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/questionario/pesquisa/fadiga/reposta', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: 'user-wrapper' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'user-layer-suspended' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'container-liquid' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'conteudo' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h3',
                { className: 'page-title' },
                this.locale.Usuarios.Questionario.titulo
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
              this.state.status == 0 ? "" : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'form',
                { onSubmit: this.edit },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-4 col-md-offset-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Usuarios.Questionario.formulario.VoceConcordaQueSeSentiuFadigadoNosUltimosDias,
                        '?'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_toggle___default.a, {
                        checked: this.state.fadigado,
                        'aria-label': 'No label tag',
                        name: 'fadigado',
                        onChange: this.handleToggleChange.bind(this, 'fadigado') })
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-4 col-md-offset-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Usuarios.Questionario.formulario.SelecioneOsFatoresQueContribuiramParaAFadiga
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                        className: 'form-field-name',
                        name: 'fatores_fadiga',
                        value: this.state.fatores_fadiga,
                        searchable: true,
                        placeholder: this.locale.Usuarios.Questionario.formulario.placeholder.SelecionarUmaOpcao,
                        onChange: this.handleSelectChangeMulti.bind(this, 'fatores_fadiga'),
                        multi: true,
                        options: [{ value: 'nao_fadigado', label: this.locale.Usuarios.Questionario.formulario.opcoesFatoresQueContribuiramParaAFadiga.NaoMeSentiFadigado }, { value: 'hotel_casa', label: 'Hotel/Casa' }, { value: 'descanso_insuficiente', label: this.locale.Usuarios.Questionario.formulario.opcoesFatoresQueContribuiramParaAFadiga.DescansoInsuficienteEntreJornadas }, { value: 'jornada_interrompida', label: this.locale.Usuarios.Questionario.formulario.opcoesFatoresQueContribuiramParaAFadiga.JornadaInterrompida }, { value: 'transicao_jornada_diurno', label: this.locale.Usuarios.Questionario.formulario.opcoesFatoresQueContribuiramParaAFadiga.TransicaoDaJornadaDiurnoParaNoturno }, { value: 'transicao_jornada_noturno', label: this.locale.Usuarios.Questionario.formulario.opcoesFatoresQueContribuiramParaAFadiga.TransicaoDaJornadaNoturnoParaDiurno }, { value: 'hora_inicio_jornada_diurno', label: this.locale.Usuarios.Questionario.formulario.opcoesFatoresQueContribuiramParaAFadiga.HorarioDeInicioDaJornadaDiurno }, { value: 'hora_inicio_jornada_noturno', label: this.locale.Usuarios.Questionario.formulario.opcoesFatoresQueContribuiramParaAFadiga.HorarioDeInicioDaJornadaNoturno }, { value: 'trabalho_noturno', label: this.locale.Usuarios.Questionario.formulario.opcoesFatoresQueContribuiramParaAFadiga.TrabalhoNoturno }, { value: 'duracao', label: this.locale.Usuarios.Questionario.formulario.opcoesFatoresQueContribuiramParaAFadiga.DuracaoDaJornada }, { value: 'hora_extra', label: this.locale.Usuarios.Questionario.formulario.opcoesFatoresQueContribuiramParaAFadiga.HoraExtra }, { value: 'transporte', label: this.locale.Usuarios.Questionario.formulario.opcoesFatoresQueContribuiramParaAFadiga.Transporte }, { value: 'saude', label: 'Saúde' }, { value: 'fadiga_acumulada', label: this.locale.Usuarios.Questionario.formulario.opcoesFatoresQueContribuiramParaAFadiga.FadigaAcumulada }, { value: 'problemas_pessoais', label: this.locale.Usuarios.Questionario.formulario.opcoesFatoresQueContribuiramParaAFadiga.ProblemasPessoais }],
                        required: true
                      })
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-4 col-md-offset-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Usuarios.Questionario.formulario.HistoricoDoSonoDosUltimos3Dias,
                        '?'
                      )
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Usuarios.Questionario.formulario.QueHorasDormiuNoUltimoDia,
                        '?'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_input_mask___default.a, { required: true, value: this.state.ultimo_dia_dormiu, maskChar: null, name: 'ultimo_dia_dormiu', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'ultimo_dia_dormiu'), placeholder: this.locale.Usuarios.Questionario.formulario.placeholder.HorarioDeApresentacao })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Usuarios.Questionario.formulario.QueHorasAcordouNoUltimoDia,
                        '?'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_input_mask___default.a, { required: true, value: this.state.ultimo_dia_acordou, maskChar: null, name: 'ultimo_dia_acordou', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'ultimo_dia_acordou'), placeholder: this.locale.Usuarios.Questionario.formulario.placeholder.HorarioDeApresentacao })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Usuarios.Questionario.formulario.QualidadeDoSonoNoUltimoDia,
                        '?'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                        className: 'form-field-name',
                        name: 'qualidade_sono_ultimo',
                        value: this.state.qualidade_sono_ultimo,
                        searchable: true,
                        placeholder: this.locale.Usuarios.Questionario.formulario.placeholder.SelecionarAplicabilidade,
                        onChange: this.handleSelectChange.bind(this, 'qualidade_sono_ultimo'),
                        options: [{ value: 'Ótimo', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Otimo }, { value: 'Bom', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Bom }, { value: 'Normal', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Normal }, { value: 'Ruim', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Ruim }, { value: 'Péssimo', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Pessimo }],
                        required: true
                      })
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Usuarios.Questionario.formulario.QueHorasDormiuNoPenultimoDia,
                        '?'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_input_mask___default.a, { required: true, value: this.state.penultimo_dia_dormiu, maskChar: null, name: 'penultimo_dia_dormiu', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'penultimo_dia_dormiu'), placeholder: this.locale.Usuarios.Questionario.formulario.placeholder.HorarioDeApresentacao })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Usuarios.Questionario.formulario.QueHorasAcordouNoPenultimoDia,
                        '?'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_input_mask___default.a, { required: true, value: this.state.penultimo_dia_acordou, maskChar: null, name: 'penultimo_dia_acordou', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'penultimo_dia_acordou'), placeholder: this.locale.Usuarios.Questionario.formulario.placeholder.HorarioDeApresentacao })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Usuarios.Questionario.formulario.QualidadeDoSonoNoPenultimoDia,
                        '?'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                        className: 'form-field-name',
                        name: 'qualidade_sono_penultimo',
                        value: this.state.qualidade_sono_penultimo,
                        searchable: true,
                        placeholder: this.locale.Usuarios.Questionario.formulario.placeholder.SelecionarAplicabilidade,
                        onChange: this.handleSelectChange.bind(this, 'qualidade_sono_penultimo'),
                        options: [{ value: 'Ótimo', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Otimo }, { value: 'Bom', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Bom }, { value: 'Normal', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Normal }, { value: 'Ruim', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Ruim }, { value: 'Péssimo', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Pessimo }],
                        required: true
                      })
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Usuarios.Questionario.formulario.QueHorasDormiuHa3Dias,
                        '?'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_input_mask___default.a, { required: true, value: this.state.tres_dias_horas_dormiu, maskChar: null, name: 'tres_dias_horas_dormiu', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'tres_dias_horas_dormiu'), placeholder: this.locale.Usuarios.Questionario.formulario.placeholder.HorarioDeApresentacao })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Usuarios.Questionario.formulario.QueHorasAcordouHa3Dias,
                        '?'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_input_mask___default.a, { required: true, value: this.state.tres_dias_horas_acordou, maskChar: null, name: 'tres_dias_horas_acordou', mask: '99:99', className: 'form-control', onChange: this.handleChange.bind(this, 'tres_dias_horas_acordou'), placeholder: this.locale.Usuarios.Questionario.formulario.placeholder.HorarioDeApresentacao })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Usuarios.Questionario.formulario.QualidadeDoSonoHa3Dias,
                        '?'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                        className: 'form-field-name',
                        name: 'qualidade_sono_tres_dias',
                        value: this.state.qualidade_sono_tres_dias,
                        searchable: true,
                        placeholder: this.locale.Usuarios.Questionario.formulario.placeholder.SelecionarAplicabilidade,
                        onChange: this.handleSelectChange.bind(this, 'qualidade_sono_tres_dias'),
                        options: [{ value: 'Ótimo', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Otimo }, { value: 'Bom', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Bom }, { value: 'Normal', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Normal }, { value: 'Ruim', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Ruim }, { value: 'Péssimo', label: this.locale.Usuarios.Questionario.formulario.opcoesSono.Pessimo }],
                        required: true
                      })
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Usuarios.Questionario.formulario.SinaisFisiologicosECognitivos
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                        className: 'form-field-name',
                        name: 'sinais',
                        value: this.state.sinais,
                        searchable: true,
                        placeholder: this.locale.Usuarios.Questionario.formulario.placeholder.SelecionarUmaOpcao,
                        onChange: this.handleSelectChangeMulti.bind(this, 'sinais'),
                        multi: true,
                        options: [{ value: 'nao_fadigado', label: this.locale.Usuarios.Questionario.formulario.opcoesSinaisFisiologicos.NaoMeSentiFadigado }, { value: 'nenhum_sinal_fisico', label: this.locale.Usuarios.Questionario.formulario.opcoesSinaisFisiologicos.NenhumSinalFisicoPercebido }, { value: 'esfregar_olhos', label: this.locale.Usuarios.Questionario.formulario.opcoesSinaisFisiologicos.EsfregarOsOlhosComFrequencia }, { value: 'piscadas_frequentes', label: this.locale.Usuarios.Questionario.formulario.opcoesSinaisFisiologicos.PiscadasFrequentes }, { value: 'bocejar', label: this.locale.Usuarios.Questionario.formulario.opcoesSinaisFisiologicos.Bocejo }, { value: 'olhar_fixo', label: this.locale.Usuarios.Questionario.formulario.opcoesSinaisFisiologicos.OlharFixo }, { value: 'dificuldade_olhos_abertos', label: this.locale.Usuarios.Questionario.formulario.opcoesSinaisFisiologicos.DificuldadeEmManterOsOlhosAbertos }, { value: 'dificuldade_olhos_abertos', label: this.locale.Usuarios.Questionario.formulario.opcoesSinaisFisiologicos.DificuldadeEmManterOsOlhosAbertos }, { value: 'piscadas_longas', label: this.locale.Usuarios.Questionario.formulario.opcoesSinaisFisiologicos.PiscadasLongas }, { value: 'cabeca_caindo', label: this.locale.Usuarios.Questionario.formulario.opcoesSinaisFisiologicos.CabeçaBalancandoOuCaindo }, { value: 'inquietacao', label: this.locale.Usuarios.Questionario.formulario.opcoesSinaisFisiologicos.Inquietacao }],
                        required: true
                      })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-6' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Usuarios.Questionario.formulario.Contramedidas
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_select__["a" /* default */], {
                        className: 'form-field-name',
                        name: 'contramedidas',
                        value: this.state.contramedidas,
                        searchable: true,
                        placeholder: this.locale.Usuarios.Questionario.formulario.placeholder.SelecionarUmaOpcao,
                        onChange: this.handleSelectChangeMulti.bind(this, 'contramedidas'),
                        multi: true,
                        options: [{ value: 'nao_fadigado', label: this.locale.Usuarios.Questionario.formulario.opcoesContramedidas.NaoMeSentiFadigado }, { value: 'alertou_colega', label: this.locale.Usuarios.Questionario.formulario.opcoesContramedidas.AlertouAoColegaSobreORiscoDeFadiga }, { value: 'aumentou_comunicacao', label: this.locale.Usuarios.Questionario.formulario.opcoesContramedidas.AumentouAComunicacao }, { value: 'comida_bebida', label: this.locale.Usuarios.Questionario.formulario.opcoesContramedidas.ComidaOuBebida }, { value: 'soneca', label: this.locale.Usuarios.Questionario.formulario.opcoesContramedidas.Soneca }, { value: 'coordenou_carga_trabalho', label: this.locale.Usuarios.Questionario.formulario.opcoesContramedidas.CoordenouACargaDeTrabalho }, { value: 'cafe', label: this.locale.Usuarios.Questionario.formulario.opcoesContramedidas.Cafeina }],
                        required: true
                      })
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-4 col-md-offset-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Usuarios.Questionario.formulario.DetalhamentoECausasProvaveis
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', { required: true, style: { height: 200 }, type: 'text', name: 'details', className: 'form-control', value: this.state.details, placeholder: this.locale.Usuarios.Questionario.formulario.placeholder.CasoNaoTenhaSeSentidoFadigadoPreenchaComNA, onChange: this.handleChange.bind(this, 'details') })
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-4 col-md-offset-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Usuarios.Questionario.formulario.VoceAcreditaQueOSistemaDeGerenciamentoDeFadigaEEficiente,
                        '?'
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_toggle___default.a, {
                        checked: this.state.fatigue_system_efficient,
                        'aria-label': 'No label tag',
                        name: 'fatigue_system_efficient',
                        onChange: this.handleToggleChange.bind(this, 'fatigue_system_efficient') })
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-4 col-md-offset-4' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'div',
                      { className: 'form-group' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                        'label',
                        null,
                        this.locale.Usuarios.Questionario.formulario.Sugestoes
                      ),
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('textarea', { style: { height: 200 }, type: 'text', name: 'sugestoes', className: 'form-control', value: this.state.sugestoes, onChange: this.handleChange.bind(this, 'sugestoes') })
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'col-md-12' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                      'button',
                      { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                      __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                      ' ',
                      this.locale.Usuarios.Questionario.formulario.botaoResponder
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return EmailFatigueQuestions;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (EmailFatigueQuestions);

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n_getLocale__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_LocalStorageChecker__ = __webpack_require__(432);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var LocalStorageIndex = function (_Component) {
  _inherits(LocalStorageIndex, _Component);

  function LocalStorageIndex(props) {
    _classCallCheck(this, LocalStorageIndex);

    var _this = _possibleConstructorReturn(this, (LocalStorageIndex.__proto__ || Object.getPrototypeOf(LocalStorageIndex)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    // Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);
    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__i18n_getLocale__["a" /* default */])();
    _this.clearLocalStorage = _this.clearLocalStorage.bind(_this);
    _this.removeOldReportsFromLocalStorage = _this.removeOldReportsFromLocalStorage.bind(_this);
    return _this;
  }
  // Handlers


  _createClass(LocalStorageIndex, [{
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleChangeDatePicker',
    value: function handleChangeDatePicker(state, date) {
      var change = {};
      change[state] = date.format("DD/MM/YYYY");
      this.setState(change);
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.loaded === 1 && prevState.loaded === 0) {
        localStorage.data = JSON.stringify(this.state.data);
      }
    }
  }, {
    key: 'clearLocalStorage',
    value: function clearLocalStorage() {
      this.localStorageCheckerRef.clearLocalStorage(true);
      alert('Cache zerado com sucesso!');
    }
  }, {
    key: 'removeOldReportsFromLocalStorage',
    value: function removeOldReportsFromLocalStorage() {
      this.localStorageCheckerRef.removeOldReportsFromLocalStorage(true);
      alert('Relatórios com mais de 02 dias removidos do cache com sucesso!');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_LocalStorageChecker__["a" /* default */], { ref: function ref(_ref) {
            _this2.localStorageCheckerRef = _ref;
          } }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title pull-left' },
              'Dados em cache'
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: 'clearfix' }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: 'form-group' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { className: 'btn btn-danger btn-group btn-block', onClick: this.clearLocalStorage },
                    'Limpar todo cache'
                  )
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br', null),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'col-md-12' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'button',
                    { className: 'btn btn-warning btn-group btn-block', onClick: this.removeOldReportsFromLocalStorage },
                    'Remover cache de relat\xF3rios de mais de 02 dias atr\xE1s'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return LocalStorageIndex;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (LocalStorageIndex);

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Layout_Topo__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__ = __webpack_require__(3);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var UsersEdit = function (_Component) {
  _inherits(UsersEdit, _Component);

  function UsersEdit(props) {
    _classCallCheck(this, UsersEdit);

    var _this = _possibleConstructorReturn(this, (UsersEdit.__proto__ || Object.getPrototypeOf(UsersEdit)).call(this, props));

    _this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed'
      },
      redirect_url: false,
      loaded: 0,
      actual_password: '',
      new_password: '',
      re_new_password: ''
    };
    //Handlers
    _this.handleAlert = _this.handleAlert.bind(_this);
    _this.handleLoaded = _this.handleLoaded.bind(_this);
    _this.handleMessage = _this.handleMessage.bind(_this);

    _this.edit = _this.edit.bind(_this);

    _this.locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__i18n_getLocale__["a" /* default */])();
    return _this;
  }

  // Handlers


  _createClass(UsersEdit, [{
    key: 'handleChange',
    value: function handleChange(name, event) {
      var change = {};
      change[name] = event.target.value;
      this.setState(change);
    }
  }, {
    key: 'handleAlert',
    value: function handleAlert(message, type, status, mode) {
      if (mode === 'reset') {
        this.setState({ overlay: { message: '', type: '', status: 'closed' } });
      } else {
        this.setState({ overlay: { message: message, type: type, status: status } });
      }
    }
  }, {
    key: 'handleLoaded',
    value: function handleLoaded(state) {
      if (this.state.loaded !== 2) {
        this.setState({ loaded: state });
      }
    }
  }, {
    key: 'handleMessage',
    value: function handleMessage() {
      var message = localStorage.getItem("verify_message");
      if (message !== null && typeof message !== 'undefined') {
        message = JSON.parse(message);
        var self = this;
        self.setState({ overlay: { message: message.alert_message, type: message.alert_type, status: 'open' } });
        localStorage.removeItem("verify_message");
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.refs.request_api.header();
    }
  }, {
    key: 'edit',
    value: function edit(event) {
      event.preventDefault();
      var datasave = {
        actual_password: this.state.actual_password,
        new_password: this.state.new_password,
        re_new_password: this.state.re_new_password
      };
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function (value) {
        fetch(__WEBPACK_IMPORTED_MODULE_1_react_global_configuration___default.a.get('api') + '/usuario/alterar/senha', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then(function (response) {
          return response.json();
        }).catch(function (error) {
          console.error(error);
        }).then(function (responseJson) {
          self.refs.request_api.validate(responseJson, 'alert');
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch(function (error) {
          console.error(error);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var self = this;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Miscelania_RequestApi__["a" /* default */], { ref: 'request_api', handleLoaded: this.handleLoaded }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Miscelania_Overlay__["a" /* default */], { overlay: this.state.overlay, handleAlert: this.handleAlert }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: 'container-liquid' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: 'conteudo' },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h3',
              { className: 'page-title' },
              this.locale.Usuarios.AlteracaoDeSenha.titulo
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('hr', null),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'form',
              { onSubmit: this.edit },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.Usuarios.AlteracaoDeSenha.formulario.SenhaAtual
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'input-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'input-group-addon' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-lock' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'password', name: 'actual_password', className: 'form-control', placeholder: this.locale.Usuarios.AlteracaoDeSenha.formulario.placeholder.SenhaAtual, value: this.state.actual_password, onChange: this.handleChange.bind(this, 'actual_password') })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.Usuarios.AlteracaoDeSenha.formulario.NovaSenha
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'input-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'input-group-addon' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-lock' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'password', name: 'actual_password', className: 'form-control', placeholder: this.locale.Usuarios.AlteracaoDeSenha.formulario.placeholder.NovaSenha, value: this.state.new_password, onChange: this.handleChange.bind(this, 'new_password') })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: 'form-group' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'label',
                  null,
                  this.locale.Usuarios.AlteracaoDeSenha.formulario.RepitaANovaSenha
                ),
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'div',
                  { className: 'input-group' },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'div',
                    { className: 'input-group-addon' },
                    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-lock' })
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { type: 'password', name: 'actual_password', className: 'form-control', placeholder: this.locale.Usuarios.AlteracaoDeSenha.formulario.placeholder.RepitaANovaSenha, value: this.state.re_new_password, onChange: this.handleChange.bind(this, 're_new_password') })
                )
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'button',
                { type: 'submit', className: 'btn btn-primary btn-lg btn-block' },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('i', { className: 'fa fa-fw fa-save' }),
                ' ',
                this.locale.general.salvar
              )
            )
          )
        )
      );
    }
  }]);

  return UsersEdit;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (UsersEdit);

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** PROTOTYPED */
var getLocale = function getLocale() {
    return {
        "general": {
            "voltar": "Back",
            "abrirMenu": "Open menu",
            "procurar": "Search",
            "adicionar": "Add",
            "editar": "Edit",
            "informacoes": "Information",
            "buscar": "Search",
            "salvar": "Save",
            "duplicar": "Duplicate",
            "deletar": "Delete",
            "abrir": "Open",
            "salvarEdicao": "Save edition",
            "semDados": "No data registered",
            "semConexao": "Attention: there is no internet connection. The only functionality available is the registration of flight legs, available in the menu. All other functionality will fail.",
            "alertas": "Alerts",
            "desde": "Since",
            "pesquisar": "Find",
            "sim": "Yes",
            "nao": "No",
            "ambos": "Both",
            "consulta": "Query",
            "exportar": "Export",
            "exportarPDF": "Export PDF",
            "exportarXLS": "Export XLS",
            "exportarXLSX": "Export XLSX",
            "exportarTextoCSV": "Export CSV",
            "diaMesAno": "Mm/dd/yyyy",
            "mesAno": "Mm/yyyy",
            "horaMinuto": "Hh:mm",
            "diaMesAnoHoraMinuto": "Mm/dd/yyyy hh:mm",
            "recarregar": "Recharge",
            "importar": "Import",
            "justificar": "Justify",
            "atualizar": "To update",
            "filtrar": "Filter",
            "cancelar": "Cancel",
            "aberta": "Open",
            "expiracao": "Expiration",
            "realizada": "Carried out",
            "euro": "Euro",
            "dolar": "Dollar",
            "real": "Real",
            "mudarLinguagem": "Trocar para Português",
            "ingles": "English",
            "portugues": "Portuguese",
            'offlineRefresh': "You are offline. System won't be properly refreshed. Are you sure you want to continue?"
        },
        "Calendario": {
            "Calendario": {
                "tabela": {
                    "Domingo": "Sunday",
                    "SegundaFeira": "Monday",
                    "TercaFeira": "Tuesday",
                    "QuartaFeira": "Wednesday",
                    "QuintaFeira": "Thursday",
                    "SextaFeira": "Friday",
                    "Sabado": "Saturday"
                }
            }
        },
        "Controles": {
            "ExtratoMensalDePagamentosPorDataDeReferencia": {
                "opcoesTipos": {
                    "Missao": "Mission",
                    "Treinamento": "Training"
                },
                "opcoesMissao": {
                    "Diarias": "Daily",
                    "RepresentanteOperacional": "Operational Representative",
                    "Transporte": "Transport",
                    "Deslocamento": "Displacement",
                    "Extra": "Extra"
                },
                "opcoesTreinamento": {
                    "Diarias": "Daily",
                    "Cheques": "Checks",
                    "Extra": "Extra"
                },
                "titulo": "Monthly Payment Statement - By Reference Date",
                "botaoTutorial": "Tutorial",
                "paragrafoOControleExibeTodosOspagamentos": "The control displays all payments regardless of whether they are in the open listing or in any payment order",
                "paragrafoADataDeReferenciaParaAPesquisa": "The reference date for the search is the date of the pay schedule or training period",
                "formulario": {
                    "Periodo": "Time course",
                    "ExibirPagamentosAbertos": "View open payments"
                },
                "tabelaSaldos": {
                    "semSaldoAnterior": "No previous balance found",
                    "SaldoAnterior": "Previous balance"
                },
                "tabelaPagamentos": {
                    "semPagamentos": "No payment found",
                    "BaseOperacional": "Operating Base",
                    "Periodo": "Time course",
                    "TipoDeOrdem": "Order Type",
                    "Treinamento": "Training",
                    "CodigoDeControle": "Control Code",
                    "Revisao": "Revision",
                    "TipoDePagamento": "Type of payment",
                    "Status": "Status",
                    "Quantidade": "The amount",
                    "ValorUnitario": "Unitary value",
                    "ValorOriginal": "Original value",
                    "Desconto": "Discount",
                    "ValorRecebido": "Amount received",
                    "Saldo": "Balance",
                    "DataDoPagamento": "Pay day",
                    "Acoes": "Actions"
                },
                "tabelaValores": {
                    "semValores": "No consolidated value found",
                    "ValorOriginal": "Original value",
                    "Desconto": "Discount",
                    "ValorRecebido": "Amount received",
                    "Saldo": "Balance"
                },
                "tituloDiasDoPagamento": "Paydays",
                "tabelaDiasDoPagamento": {
                    "Data": "Date",
                    "Diarias": "Daily",
                    "nenhumDiaEncontrado": "No days found. Certain information only started to be recorded from 05/2022"
                },
                "tituloDescontosRelacionados": "Related Discounts",
                "tabelaDescontosRelacionados": {
                    "IdDoDebito": "Debit id",
                    "ReferenciaDoDebito": "Debit reference",
                    "ValorOriginalDoDebito": "Original debit amount",
                    "ValorAmortizadoNoPagamento": "Amount amortized upon payment"
                },
                "tituloPagamentosRelacionados": "Related Payments",
                "tabelaPagamentosRelacionados": {
                    "IdDoDebito": "Debit id",
                    "ReferenciaDoPagamento": "Payment reference",
                    "ValorOriginalDoDebito": "Original debit amount",
                    "ValorAmortizadoNoPagamento": "Amount amortized upon payment"
                }
            },
            "ExtratoPagamentosPorPeriodoPorDataDePagamento": {
                "titulo": "Statement Payments by Period - By Payment Date",
                "paragrafoOControleExibeTodosOspagamentos": "The control displays all payments regardless of whether they are in the open listing or in any payment order",
                "paragrafoAsDatasDeReferenciaParaAPesquisa": "The reference dates for the search are the payment dates",
                "formulario": {
                    "Inicio": "Start",
                    "Termino": "End"
                },
                "tabelaPagamentos": {
                    "semPagamentos": "No payment found",
                    "BaseOperacional": "Operating Base",
                    "Frota": "Fleet",
                    "Periodo": "Time course",
                    "TipoDeOrdem": "Order Type",
                    "Treinamento": "Training",
                    "CodigoDeControle": "Control Code",
                    "Revisao": "Revision",
                    "TipoDePagamento": "Type of payment",
                    "Status": "Status",
                    "Quantidade": "The amount",
                    "ValorUnitario": "Unitary value",
                    "ValorOriginal": "Original value",
                    "Desconto": "Discount",
                    "ValorRecebido": "Amount received",
                    "Saldo": "Balance",
                    "DataDoPagamento": "Pay day",
                    "Acoes": "Actions"
                },
                "tituloDiasDoPagamento": "Paydays",
                "tabelaDiasDoPagamento": {
                    "Data": "Date",
                    "Diarias": "Daily",
                    "nenhumDiaEncontrado": "No days found. Certain information only started to be recorded from 05/2022"
                },
                "tituloDescontosRelacionados": "Related Discounts",
                "tabelaDescontosRelacionados": {
                    "IdDoDebito": "Debit id",
                    "ReferenciaDoDebito": "Debit reference",
                    "ValorOriginalDoDebito": "Original debit amount",
                    "ValorAmortizadoNoPagamento": "Amount amortized upon payment"
                },
                "tituloPagamentosRelacionados": "Related Payments",
                "tabelaPagamentosRelacionados": {
                    "IdDoDebito": "Debit id",
                    "ReferenciaDoPagamento": "Payment reference",
                    "ValorOriginalDoDebito": "Original debit amount",
                    "ValorAmortizadoNoPagamento": "Amount amortized upon payment"
                }
            }
        },
        "EscalasDeTesteDeSonolencia": {
            "ListaDeEscalasDeTesteDeSonolencia": {
                "titulo": "List of drowsiness test scales",
                "botaoAdicionarEscala": "Add scale",
                "tabela": {
                    "semEscalas": "There are no test scales registered",
                    "ID": "ID",
                    "Nome": "Name",
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "Acoes": "Actions"
                }
            },
            "AdicionarEscalaDeSonolencia": {
                "aguardeEnquantoAEscalaEGerada": "Please wait while the scale is generated. This process can take a few minutes.",
                "titulo": "Register drowsiness test scale",
                "formulario": {
                    "Nome": "Name",
                    "HorariosDeEnvio": "Shipping times",
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                    "Tripulantes": "Crew",
                    "Mecanicos": "Mechanics",
                    "Coordenadores": "Coordinators",
                    "botaoAdicionarEscalaDeTeste": "Add test scale",
                    "placeholder": {
                        "NomeDaEscalaDeSonolencia": "Sleepiness scale name",
                        "HorariosDeEnvio": "Hh:mm, separated by a comma.",
                        "SelecionarAplicabilidade": "Select applicability"
                    }
                }
            },
            "EditarEscalaDeSonolencia": {
                "trocarStatusDaEscala": "Are you sure you would like to change the scale status?",
                "trocarStatusDaEscalaParaAprovado": "Are you sure you'd like to change the escalation status to approved?",
                "trocarStatusDaEscalaParaFinalizado": "Are you sure you'd like to change the status of the scale to finished?",
                "titulo": "Sleepiness scale editing",
                "botaoDeFichas": {
                    "TrocarParaAprovado": "Switch to approved",
                    "TrocarParaFinalizado": "Switch to finished"
                },
                "tabDadosDaEscala": {
                    "tituloTab": "Scale data",
                    "formulario": {
                        "Nome": "Name",
                        "DataInicial": "Initial date",
                        "DataFinal": "Final date",
                        "placeholder": {
                            "NomeDaEscalaDeSonolencia": "Sleepiness scale name"
                        }
                    }
                },
                "tabTestesDeEscala": {
                    "tituloTab": "Scale tests",
                    "deletarColaboradorDaEscalaDeTeste": "Are you sure you'd like to delete this contributor from the roster of tests?",
                    "tituloTestesDeEscalaDeSonolencia": "Sleepiness scale tests",
                    "tabela": {
                        "semColaboradores": "There are no registered employees",
                        "ID": "ID",
                        "Colaborador": "Collaborator",
                        "ProgramacaoDeEnvio": "Shipping Schedule",
                        "Acoes": "Actions"
                    },
                    "tituloEditarTeste": "Edit test",
                    "formulario": {
                        "Data": "Date",
                        "HorariosDeEnvio": "Shipping time",
                        "Colaborador": "Collaborator",
                        "placeholder": {
                            "HorariosDeEnvio": "Shipping time",
                            "SelecionarAplicabilidade": "Select applicability"
                        }
                    }
                },
                "tabRelatorioFinal": {
                    "tituloTab": "Final report",
                    "formulario": {
                        "PeriodoDeJornada": "Working Period",
                        "DiasDeJornada": "Journey days",
                        "Bases": "Bases",
                        "Designacoes": "Designations",
                        "Funcoes": "Functions",
                        "Cargos": "Roles",
                        "Frotas": "Fleets",
                        "Grupos": "Groups",
                        "botaoProcurarRelatorios": "Browse reports",
                        "placeholder": {
                            "SelecionarPeriodoDeJornada": "Select journey periods",
                            "DiasDeJornada": "Days, separated by a comma. Ex.: 01, 02, 10, 11, etc.",
                            "SelecionarBases": "Select bases",
                            "SelecionarDesignacoes": "Select designations",
                            "SelecionarFuncoes": "Select functions",
                            "SelecionarCargos": "Select positions",
                            "SelecionarFrotas": "Select fleets",
                            "SelecionarGrupos": "Select groups"
                        }
                    },
                    "tituloPontosPorHorarioDeResposta": "Points for response time",
                    "paragrafoPercentualDeAdesaoParcial": "Partial adherence percentage (to date)",
                    "paragrafoPercentualDeAdesaoGlobal": "Global membership percentage",
                    "paragrafoTempoMedioDeResposta": "Average response time",
                    "paragrafoTotalRespostas": "Total responses",
                    "tituloCadaHorarioDeResposta": "Every response time",
                    "tabelaHorariosDeResposta": {
                        "PeriodoHoras": "Period hours",
                        "Total": "Total",
                        "Pontos": "Spots",
                        "Media": "Average"
                    },
                    "tituloPontosPorPeriodoDeJornada": "Points per journey period",
                    "tabelaPontosPorPeriodoDeJornada": {
                        "PeriodoHoras": "Period hours",
                        "Total": "Total",
                        "Pontos": "Spots",
                        "Media": "Average"
                    },
                    "tituloPontosPorDiasDeJornada": "Points per journey day",
                    "tabelaPontosPorDiasDeJornada": {
                        "PeriodoDias": "Period days",
                        "Total": "Total",
                        "Pontos": "Spots",
                        "Media": "Average"
                    },
                    "tituloBases": "Bases",
                    "tabelaBases": {
                        "Base": "Base",
                        "Total": "Total",
                        "Pontos": "Spots",
                        "Media": "Average"
                    },
                    "tituloFuncoes": "Functions",
                    "tabelaFuncoes": {
                        "Funcao": "Occupation",
                        "Total": "Total",
                        "Pontos": "Spots",
                        "Media": "Average"
                    },
                    "tituloGrupos": "Groups",
                    "tabelaGrupos": {
                        "Grupo": "Group",
                        "Total": "Total",
                        "Pontos": "Spots",
                        "Media": "Average"
                    },
                    "tituloDesignacoes": "Designations",
                    "tabelaDesignacoes": {
                        "Designacao": "Designation",
                        "Total": "Total",
                        "Pontos": "Spots",
                        "Media": "Average"
                    },
                    "tituloFrotas": "Fleets",
                    "tabelaFrotas": {
                        "Frota": "Fleet",
                        "Total": "Total",
                        "Pontos": "Spots",
                        "Media": "Average"
                    }
                }
            }
        },

        "TripulanteDeslocamentos": {
            "AdicionarDeslocamento": {
                "titulo": 'Add deslocation',
                "tituloAnteriores": 'Last deslocations',

                "formulario": {
                    "houveDeslocamento": 'Houve deslocamento para sua apresentação no aeroporto',
                    "tempoDeslocamento": 'Quanto tempo de deslocamento (inclui desde a saída de sua residência até a chegada no hotel ou aeroporto, o que tiver ocorrido primeiro)',
                    "botaoSalvar": 'Save'
                },

                "tabela": {
                    "dataApresentacao": 'Date of presentation',
                    "houveDeslocamento": 'Has deslocation?',
                    "tempoDeslocamento": 'Deslocation time',
                    "Status": 'Status'
                }
            }
        },

        "TripulanteDiscrepancias": {
            "AdicionarDiscrepancia": {
                "titulo": 'Adicionar discrepância',
                "tituloAnteriores": 'Discrepâncias anteriores',

                "formulario": {
                    "Data": 'Data',
                    "Discrepancia": 'Discrepância',
                    "grauEstresse": 'Grau de severidade/estresse',
                    "botaoAdicionar": 'Adicionar'
                },

                "tabela": {
                    "Data": 'Data',
                    "Discrepancia": 'Discrepância',
                    "grauEstresse": 'Grau de severidade/estresse'
                }
            }
        },

        "Fadigas": {
            "ListaDeFadigas": {
                "deletar": "Are you sure you'd like to delete this fatigue parameter?",
                "titulo": "List of fatigue parameters",
                "botaoAdicionarFadiga": "Add Fatigue",
                "tabela": {
                    "semParametroDeFadiga": "There are no registered fatigue parameters",
                    "ID": "ID",
                    "Aplicabilidade": "Applicability",
                    "Nome": "Name",
                    "Tipo": "Type",
                    "Operador": "Operator",
                    "PontosPorHora": "PointsPerHour",
                    "PontosPorQuantidade": "Points per quantity",
                    "LimiteDePontos": "Point limit",
                    "ObrigatorioPreenchimento": "Mandatory completion",
                    "Acoes": "Actions"
                }
            },
            "AdicionarFadiga": {
                "titulo": "Register fatigue parameter",
                "formulario": {
                    "Nome": "Name",
                    "Tipo": "Type",
                    "Operador": "Operator",
                    "PontosPorHora": "Points per hour",
                    "PontosPorQuantidade": "Points per quantity",
                    "LimiteDePontos": "Point limit",
                    "PontuacaoExtraPorHoraNoturna": "Extra Score for Night Time",
                    "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                    "PontosAReduzirParaTreinamento": "Points to reduce for training",
                    "ParametroObrigatorio": "Mandatory Parameter",
                    "ParametroAutomatico": "Automatic parameter",
                    "TipoDeAutomacao": "Automation type",
                    "tituloAlertas": "Alerts",
                    "LimiteMaximoDePontos": "Max points limit",
                    "LimiteMinimoDePontos": "Minimum point limit",
                    "LimiteDePontosDeHoraExtraPorSemana": "Limit of overtime points per week",
                    "LimiteDePontosDeHoraExtraPorMes": "Limit of overtime points per month",
                    "LimiteDeDiasComHoraExtraPorSemana": "Limit of overtime days per week",
                    "LimiteDeDiasComHoraExtraPorMes": "Limit of days with overtime per month",
                    "botaoAdicionarParametroDeFadiga": "Add fatigue parameter",
                    "placeholder": {
                        "NomeDoParametroDeFadiga": "Fatigue parameter name",
                        "SelecionarTipo": "Select type",
                        "SelecionarOperador": "Select operator",
                        "QuantidadeDePontosPorHora": "Number of points per hour",
                        "QuantidadeDePontosPorQuantidade": "Number of points per amount",
                        "LimiteDePontosDoParametro": "Parameter point limit",
                        "PontuacaoExtraPorHoraNoturna": "Extra Score for Night Time",
                        "SelecionarAplicabilidade": "Select applicability",
                        "PontosAReduzirParaTreinamento": "Points to reduce for training",
                        "ParametroObrigatorio": "Mandatory Parameter",
                        "ParametroAutomatico": "Automatic parameter",
                        "LimiteMaximoDePontos": "Max points limit",
                        "LimiteMinimoDePontos": "Minimum point limit"
                    }
                }
            },
            "EditarFadiga": {
                "deletar": "Are you sure you would like to delete this option?",
                "titulo": "Edit Fatigue Parameter",
                "formulario": {
                    "Nome": "Name",
                    "Tipo": "Type",
                    "Operador": "Operator",
                    "PontosPorHora": "Points per hour",
                    "PontosPorQuantidade": "Points per quantity",
                    "LimiteDePontos": "Point limit",
                    "PontuacaoExtraPorHoraNoturna": "Extra Score for Night Time",
                    "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                    "PontosAReduzirParaTreinamento": "Points to reduce for training",
                    "ParametroObrigatorio": "Mandatory Parameter",
                    "ParametroAutomatico": "Automatic parameter",
                    "TipoDeAutomacao": "Automation type",
                    "tituloAlertas": "Alerts",
                    "LimiteMaximoDePontos": "Max points limit",
                    "LimiteMinimoDePontos": "Minimum point limit",
                    "LimiteDePontosDeHoraExtraPorSemana": "Limit of overtime points per week",
                    "LimiteDePontosDeHoraExtraPorMes": "Limit of overtime points per month",
                    "LimiteDeDiasComHoraExtraPorSemana": "Limit of overtime days per week",
                    "LimiteDeDiasComHoraExtraPorMes": "Limit of days with overtime per month",
                    "placeholder": {
                        "NomeDoParametroDeFadiga": "Fatigue parameter name",
                        "SelecionarCliente": "Select customer",
                        "QuantidadeDePontosPorHora": "Number of points per hour",
                        "QuantidadeDePontosPorQuantidade": "Number of points per amount",
                        "LimiteDePontosDoParametro": "Parameter point limit",
                        "PontuacaoExtraPorHoraNoturna": "Extra Score for Night Time",
                        "SelecionarAplicabilidade": "Select applicability",
                        "PontosAReduzirParaTreinamento": "Points to reduce for training",
                        "ParametroObrigatorio": "Mandatory Parameter",
                        "ParametroAutomatico": "Automatic parameter",
                        "SelecionarTipo": "Select type",
                        "LimiteMaximoDePontos": "Max points limit",
                        "LimiteMinimoDePontos": "Minimum point limit"
                    }
                },
                "tituloAdicionarOpcoes": "Add options",
                "formularioAdicionarOpcoes": {
                    "Nome": "Name",
                    "Pontos": "Spots",
                    "placeholder": {
                        "NomeDoParametroDeFadiga": "Fatigue parameter name",
                        "QuantidadeDePontos": "Amount of points"
                    }
                },
                "tituloOpcoes": "Options",
                "tabela": {
                    "Opcao": "Option",
                    "Pontos": "Spots",
                    "Acoes": "Actions"
                }
            }
        },
        "RelatoriosAuxiliaresFadiga": {
            "ProcurarRelatorioAuxiliar": {
                "titulo": "Statistics (FAPA)",
                "formulario": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date"
                },
                "tituloResultadosDeAutoavaliacoes": "Self-Assessment Results",
                "tabela": {
                    "semParametroDeFadiga": "There are no registered fatigue parameters",
                    "ID": "ID",
                    "Data": "Date",
                    "Colaborador": "Collaborator",
                    "Questao1": "Question 1",
                    "Questao2": "Question 2",
                    "Questao3": "Question 3",
                    "Questao4": "Question 4",
                    "PontuacaoFinal": "Final score"
                }
            },
            "AdicionarRelatorioAuxiliar": {
                "titulo": "Fatigue Self-Assessment Aid Tool (FAPA)",
                "formulario": {
                    "tituloQuestao1QuaoAlertaVoceEsta": "Question 1: How alert do you think you are? (Consider your condition before taking the journey)",
                    "tituloQuestao2VoceTeveSonoAdequado": "Question 2: Did you get adequate sleep?",
                    "QuantoTempoDormiuNas24HorasAnteriores": "At the beginning of the journey, how long did you sleep in the previous 24 hours?",
                    "QuantoTempoDormiuNas48HorasAnteriores": "At the beginning of the journey, how long did you sleep in the previous 48 hours?",
                    "AoFimDaJornadaPorQuantasHorasTeraPermanicidoAcordado": "At the end of the scheduled journey, how many hours will you have remained awake, discounting any time allocated for rest in suitable accommodation or rest on board when composing an increased crew?",
                    "tituloQuestao3QueHorasOcorreAPresenteJornada": "Question 3: What time does this journey take place?",
                    "tituloQuestao4QualNivelDeRiscoOperacionalAssociado": "Question 4: What is the level of operational risk associated with the journey?",
                    "Rota": "Route",
                    "Opcoes": {
                        "Baixo": "Low",
                        "Moderado": "Moderate",
                        "Elevado": "High"
                    },
                    "Aeroportos": "Airports",
                    "EspacoAereo": "Airspace",
                    "NivelExperienciaTripulacao": "Crew Experience Level",
                    "CaracteristicasEOperacionalidadeDaAeronave": "Aircraft characteristics and operability",
                    "CondicoesAtmosfericas": "Atmosphere conditions",
                    "botaoGerarAvaliacao": "Generate Assessment",
                    "placeholder": {
                        "SelecioneUmaOpcao": "Select an option"
                    }
                },
                "tituloQuestao1QuaoAlertaVoceEsta": "Question 1: How alert do you think you are? (Consider your condition before taking the journey)",
                "tituloQuestao2VoceTeveSonoAdequado": "Question 2: Did you get adequate sleep?",
                "QuantoTempoDormiuNas24HorasAnteriores": "At the beginning of the journey, how long did you sleep in the previous 24 hours?",
                "QuantoTempoDormiuNas48HorasAnteriores": "At the beginning of the journey, how long did you sleep in the previous 48 hours?",
                "AoFimDaJornadaPorQuantasHorasTeraPermanicidoAcordado": "At the end of the scheduled journey, how many hours will you have remained awake, discounting any time allocated for rest in suitable accommodation or rest on board when composing an increased crew?",
                "pontos": "Spots",
                "tituloQuestao3QueHorasOcorreAPresenteJornada": "Question 3: What time does this journey take place?",
                "tituloQuestao4QualNivelDeRiscoOperacionalAssociado": "Question 4: What is the level of operational risk associated with the journey?",
                "nota": "Note",
                "paragrafoSeORiscoElevadoEstiverPresenteInformarAoDespachoOperacional": "If Elevated Risk is present, it is recommended to consider risk controls such as napping, task rotation or informing the operational dispatch that you are not fit for duty.",
                "paragrafoPontuacao": "Punctuation",
                "paragrafoSeORiscoElevadoEstiverPresenteInformarAoOperador": "If Elevated Risk is present, it is recommended to consider risk controls such as napping, task rotation or informing the operator that you are not fit for duty.",
                "rota": "Route",
                "aeroportos": "Airports",
                "espacoAereo": "Airspace",
                "nivelExperienciaTripulacao": "Crew Experience Level",
                "caracteristicasEOperacionalidadeDaAeronave": "Aircraft characteristics and operability",
                "condicoesAtmosfericas": "Atmosphere conditions",
                "tituloResultadoDosRiscos": "Result of the risks",
                "paragrafoOrientacaoAoTripulante": "Crew Member Orientation",
                "paragrafoMecaONivelDeAlertaTripulacaoAumentada": "Measure the alert level using objective and subjective methods and discuss with your supervisor why your alert level may not be sufficient for this journey and consider being scheduled for another journey in order to manage the risk (e.g. in increased crew , longer rest period).",
                "paragrafoMecaONivelDeAlertaChochilo": "Measure alertness using objective and subjective methods, discuss with your supervisor whether your alertness level is adequate for this journey, and consider using additional mitigation strategies (eg nap, task rotation).",
                "paragrafoMecaONivelDeAlertaCafeina": "Measure alertness using both objective and subjective methods, discuss with your supervisor whether your alertness level is appropriate for this journey, and consider fatigue risk controls beneficial for this journey (e.g. use of caffeine, increased care with hydration and food)."
            }
        },
        "ReportesDeFadigas": {
            "ListaDeReportesDeFadigasAbertos": {
                "tituloMotivo": "Reason",
                "tituloObservacoes": "Comments",
                "botaoConfirmarVisualizacao": "Confirm view",
                "titulo": "List of Voluntary Fatigue Reports - Open",
                "tabela": {
                    "semParametroDeFadiga": "There are no registered fatigue parameters",
                    "ID": "ID",
                    "Tripulante": "Crew member",
                    "Data": "Date",
                    "Acoes": "Actions"
                }
            },
            "ListaDeReportesDeFadigasFechados": {
                "tituloMotivo": "Reason",
                "tituloObservacoes": "Comments",
                "titulo": "List of Voluntary Fatigue Reports - Closed",
                "tabela": {
                    "semParametroDeFadiga": "There are no registered fatigue parameters",
                    "ID": "ID",
                    "Tripulante": "Crew member",
                    "Data": "Date",
                    "Acoes": "Actions"
                }
            },
            "AdicionarReporteDeFadiga": {
                "titulo": "Voluntary fatigue report",
                "formulario": {
                    "Motivo": "Reason",
                    "Data": "Date",
                    "OProblemaApresentadoPodeSerAlgoPontual": "Can the problem presented be considered punctual, that is, is it something that allows you to return to activities on the next mission day?",
                    "Observacoes": "Comments",
                    "botaoEnviarReporte": "Send report",
                    "placeholder": {
                        "SelecionarMotivo": "Select reason",
                        "SelecionarOpcao": "Select option"
                    }
                }
            },
            "EditarMotivosDeFadiga": {
                "deletar": "Are you sure you would like to delete this fatigue reason?",
                "titulo": "Edit Fatigue Reasons",
                "formulario": {
                    "Nome": "Name",
                    "placeholder": {
                        "NomeDoMotivoDeFadiga": "Fatigue reason name"
                    }
                },
                "tituloMotivosDeFadigaCadastrados": "Registered reasons for fatigue",
                "tabela": {
                    "Nome": "Name",
                    "Acoes": "Actions"
                }
            }
        },
        "PesquisaDeRelatorios": {
            "titulo": "Report search",
            "formulario": {
                "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                "Tripulantes135": "Crew - 135",
                "Tripulantes121": "Crew - 121",
                "Mecanicos": "Mechanics",
                "Coordenadores": "Coordinators",
                "DataInicial": "Initial date",
                "DataFinal": "Final date",
                "MotivoDoEnvio": "Reason for submission",
                "Respondido": "Answered",
                "botaoProcurarQuestionarios": "Browse surveys",
                "placeholder": {
                    "SelecionarAplicabilidade": "Select applicability",
                    "SelecionarTripulante": "Select crew member",
                    "SelecionarMecanico": "Select mechanic",
                    "SelecionarCoordenador": "Select coordinator",
                    "SelecionarMotivos": "Select reasons",
                    "SelecionarStatus": "Select status"
                }
            },
            "tituloListaDeQuestionarios": "List of questionnaires",
            "tabelaListaDeQuestionarios": {
                "semQuestionarios": "There are no registered questionnaires",
                "Data": "Date",
                "Colaborador": "Collaborator",
                "Status": "Status",
                "Motivo": "Reason",
                "Acoes": "Actions"
            },
            "tituloDadosDoQuestionarioDeFadiga": "Fatigue questionnaire data",
            "tituloBotaoResultadoDaPesquisa": "Search result",
            "tituloBotaoAltResultadoDeProva": "Test result",
            "botaoExportarCSV": "Export CSV",
            "tabelaDadosDoQuestionario": {
                "Pergunta": "Question",
                "Resposta": "Answer"
            }
        },
        "RelatorioAbastecimento": {
            "ListaDeAbastecimentos": {
                "lista": "Refuels list",
                "adicionar": "Add refuel",
                "editar": "Edit refuel",
                "deletar": "Delete refuel",
                "tabela": {
                    "Data": "Date",
                    "Relatório": "Flight Report Nº",
                    "Voo": "Flight N°",
                    "Aeronave": "Aircraft",
                    "Fornecedor": "Supplier",
                    "Localidade": "Location",
                    "Quantidade": "Quantity",
                    "Acoes": "Actions"
                }
            },
            "EditarAbastecimento": {
                "titulo": "Edit refuel",
                "dados": "Data",
                "formulario": {
                    "AnexarNotaFiscal": "Attach invoice",
                    "Aeronave": "Aircraft",
                    "Empresa": "Company",
                    "Relatorio": "Report",
                    "CombustivelSolicitado": "Fuel Requested (Kg or Lb)",
                    "NumeroDaCe": "EC number",
                    "Trecho": "Flight Leg",
                    "Fornecedor": "Provider",
                    "CombustivelAbastecido": "Fuel supplied (L)",
                    "Localidade": "Location",
                    "Comandante": "Captain",
                    "VendidoPara": "Sold to",
                    "Endereco": "Address",
                    "Tipo": "Type",
                    "Reg": "Register",
                    "Capt": "Captain",
                    "InicioAbastecimento": "Refuel start",
                    "Click": "Click",
                    "TerminoAbastecimento": "Refuel finish",
                    "ProximaLocalidade": "Next location",
                    "NumeroHidrante": "Hydrant number",
                    "SeuNumeroDeVenda": "Your sales number",
                    "NumeroDeVendaAnterior": "Previous sale number",
                    "LeituraInicial": "Initial reading",
                    "LeituraFinal": "Final reading",
                    "Entregues": "Delivered",
                    "TipoCombustivel": "Type of fuel",
                    "Preco": "Price.",
                    "Quantidade": "Quantity",
                    "ValorUnitario": "Unitary valie",
                    "ValorTotal": "Total value",
                    "ValorReembolsavel": "Refundable value",
                    "ValorFinal": "Final value",
                    "botaoEditarAbastecimento": "Edit refuel",
                    "placeholder": {
                        "SelecioneAeronave": "Select the aircraft",
                        "SelecioneRelatorio": "Select the report",
                        "SelecioneTrecho": "Select the leg",
                        "SelecioneFornecedor": "Select fuel supplier",
                        "SelecioneLocal": "Select location"
                    }
                },
                "aprovacoes": {
                    "titulo": "Approvals",
                    "tabela": {
                        "Tipo": "Type",
                        "Aprovacao": "Approval",
                        "Acoes": "Actions"
                    },
                    "modalReprovar": {
                        "Titulo": "Reprove",
                        "TituloPorLogin": "Reprove with Login",
                        "TituloPorAssinatura": "Reprove with e-signature",
                        "Razao": "Reproval justification",
                        "BotaoReprovar": "Reprove refuel",
                        "Confirmacao": "Are you sure you want to reprove this refuel?",
                        "AlertaAssinaturaVazia": "You have to sign before approving"

                    },
                    "modalAprovar": {
                        "Titulo": "Approve",
                        "TituloPorLogin": "Approve with Login",
                        "TituloPorAssinatura": "Approve with e-signature",
                        "BotaoAprovar": "Approve refuel",
                        "Confirmacao": "Are you sure you want to approve this refuel?",
                        "AlertaAssinaturaVazia": "You have to sign before approving"
                    }
                }
            },
            "AdicionarAbastecimento": {
                "deletar": "Are you sure you want to delete this refuel?",
                "titulo": "Register refuel",
                "formulario": {
                    "AnexarNotaFiscal": "Attach invoice",
                    "Aeronave": "Aircraft",
                    "Empresa": "Company",
                    "Relatorio": "Report",
                    "CombustivelSolicitado": "Fuel Requested (Kg or Lb)",
                    "NumeroDaCe": "EC number",
                    "Trecho": "Flight Leg",
                    "Fornecedor": "Provider",
                    "CombustivelAbastecido": "Fuel supplied (L)",
                    "Localidade": "Location",
                    "Comandante": "Captain",
                    "VendidoPara": "Sold to",
                    "Endereco": "Address",
                    "Tipo": "Type",
                    "Reg": "Register",
                    "Capt": "Captain",
                    "InicioAbastecimento": "Refuel start",
                    "Click": "Click",
                    "TerminoAbastecimento": "Refuel finish",
                    "ProximaLocalidade": "Next location",
                    "NumeroHidrante": "Hydrant number",
                    "SeuNumeroDeVenda": "Your sales number",
                    "NumeroDeVendaAnterior": "Previous sale number",
                    "LeituraInicial": "Initial reading",
                    "LeituraFinal": "Final reading",
                    "Entregues": "Delivered",
                    "TipoCombustivel": "Type of fuel",
                    "Preco": "Price",
                    "Quantidade": "Amount",
                    "ValorTotal": "Total",
                    "botaoAdicionarAbastecimento": "Add refuel",
                    "placeholder": {
                        "SelecioneAeronave": "Select the aircraft",
                        "SelecioneRelatorio": "Select the report",
                        "SelecioneTrecho": "Select the leg",
                        "SelecioneFornecedor": "Select fuel supplier",
                        "SelecioneLocal": "Select location"
                    }
                },
                "tabela": {
                    "Trecho": "Flight Leg",
                    "NumeroDaCe": "EC No.",
                    "Fornecedor": "Provider",
                    "Localidade": "Location",
                    "QuantidadeSolicitada": "Quantity requested",
                    "QuantidadeAbastecida": "Quantity supplied",
                    "Acoes": "Actions"
                },
                "modalEditarAbastecimento": {
                    "titulo": "Edit fuel request",
                    "formulario": {
                        "CombustivelSolicitado": "Fuel Requested (Kg or Lb)",
                        "NumeroDaCe": "EC number",
                        "Trecho": "Flight Leg",
                        "Fornecedor": "Provider",
                        "CombustivelAbastecido": "Fuel supplied (L)",
                        "Localidade": "Location",
                        "botaoEditarAbastecimento": "Edit refuel"
                    }
                }
            }
        },
        "RelatoriosDeVoo": {
            "ListaDeRelatoriosDeVoo": {
                "titulo": "Flight reports",
                "tituloOffLine": "Flight reports - Offline",
                "botaoAdicionarRelatorioDeVoo": "Add flight report",
                "formulario": {
                    "botaoMudarData": "Change date"
                },
                "tabela": {
                    "semRelatorios": "There are no registered reports",
                    "NumeroDoRelatorio": "Report number",
                    "ID": "ID",
                    "Base": "Base",
                    "Data": "Date",
                    "Aeronave": "Aircraft",
                    "Frota": "Fleet",
                    "Cliente": "Client",
                    "TipoDeVoo": "Type of flight",
                    "NumeroDoVoo": "Flight number",
                    "Status": "Status",
                    "Acoes": "Actions"
                }
            },
            "AdicionarRelatorioDeVoo": {
                "titulo": "Register new flight report",
                "formulario": {
                    "Data": "Date",
                    "Prefixo": "Prefix",
                    "Voo": "Flight",
                    "NumeroDeVoo": "Flight number",
                    "NumeroDoRelatorio": "Flight report number",
                    "SolicitouIsencao": "Requested exemption",
                    "PowerCheck": "Power Check",
                    "Base": "Base",
                    "Contrato": "Contract",
                    "MecanicoResponsavel": "Responsible mechanic",
                    "Cliente": "Client",
                    "Observacoes": "Comments",
                    "botaoCriarRelatorioDeVoo": "Create flight report"
                }
            },
            "EditarRelatoriosDeVoo": {
                "trocarStatusDoRelatorioDeVoo": "Are you sure you would like to change the flight report status?",
                "confirmarSalvarTodos": "Are you sure you would like to save all legs?",
                "infoOffline": "System offline. Wait for connection and try again.",
                "mensagemOfflineSemVoo": "This flight report wasn't registered offline and can't be edited.",

                "titulo": "Edit flight report",
                "botaoRelatorio": "Report",
                "botaoExtratoDB": "DB extract",
                "botaoXML": "XML",
                "botaoRelatorioDeVoo": {
                    "TrocarParaRascunho": "Switch to draft",
                    "TrocarParaFinalizado": "Switch to finished",
                    "TrocarParaCancelado": "Switch to Canceled"
                },
                "erros": "The following filling errors prevented the report from being finalized",
                "erros_salvar": "The following filling errors prevented the leg(s) from being saved",

                "modalDiscrepanciaHorarios": {
                    "titulo": "Discrepancy of times filled in the sections with those received from Flight Following",
                    "substituir": "Are you sure you'd like to replace the leg times with those of Flight Following?",
                    "substituirTodos": "Are you sure you'd like to replace the times for all legs with those for Flight Following?",
                    "botaoSubstituir": "Replace",
                    "botaoSubstituirTodos": "Replace all times with those from Flight Following",
                    "ignorar": "Are you sure you'd like to keep the leg times and ignore the Flight Following ones?",
                    "ignorarTodos": "Are you sure you'd like to keep the times for all legs and ignore those for Flight Following?",
                    "botaoIgnorar": "Ignore",
                    "botaoIgnorarTodos": "Ignore all Flight Following times and keep those filled in",
                    "tabela": {
                        "ID": "ID",
                        "Trecho": "Flight Leg",
                        "FlightFollowing": "Flight Following",
                        "Preenchido": "Filled",
                        "Partida": "Departure",
                        "Decolagem": "Take off",
                        "Pouso": "Landing",
                        "Corte": "Cut",
                        "Acoes": "Actions",
                        "botaoSubstituir": "To replace",
                        "botaoIgnorar": "Ignore"
                    }
                },
                "formularioEditarRelatorio": {
                    "Data": "Date",
                    "Prefixo": "Prefix",
                    "Voo": "Flight",
                    "NumeroDeVoo": "Flight number",
                    "NumeroDoRelatorio": "Flight report number",
                    "SolicitouIsencao": "Requested exemption",
                    "PowerCheck": "Power Check",
                    "Base": "Base",
                    "Contrato": "Contract",
                    "MecanicoResponsavel": "Responsible mechanic",
                    "Cliente": "Client",
                    "Observacoes": "Comments",
                    "botaoEditarRelatorioDeVoo": "Edit flight report"
                },
                "tabelaVoosDia": {
                    "Titulo": "Other flights for the day",
                    "SemVoos": "No other flights for the day",
                    "Id": "Id",
                    "NumeroVoo": "Flight No.",
                    "NumeroRelatório": "Flight Report No.",
                    "DecolagemPrevista": "Scheduled departure",
                    "Origem": "Origin",
                    "Cliente": "Client",
                    "Contrato": "Contract",
                    "TipoVoo": "Flight Type",
                    "Status": "Status"
                },
                "excluirTripulante": "Are you sure you want to delete this crew member? It will be deleted from all legs.",
                "tituloCadastrarTripulacao": "Register crew",
                "formularioCadastrarTripulacao": {
                    "Tripulante": "Crew member",
                    "FuncaoDeBordo": "On-board function",
                    "DataDeApresentacao": "Date of the presentation",
                    "HoraDeApresentacao": "Presentation time",
                    "botaoAdicionarTripulante": "Add crew member"
                },
                "tituloTripulantesCadastrados": "Registered crew",
                "tabelaTripulantesCadastrados": {
                    "Nome": "Name",
                    "CANAC": "CANAC",
                    "SISPAT": "SISPAT",
                    "FB": "FB",
                    "Apresentacao": "Presentation",
                    "DecolagemPouso": "Takeoff/Landing",
                    "TempoTotal": "Total time",
                    "Navegacao": "Navigation",
                    "Instrumento": "Instrument",
                    "Noturno": "Night",
                    "PousosDiurnos": "Day Landings",
                    "PousosNoturnos": "Night Landings",
                    "Pax": "Pax.",
                    "Carga": "Payload",
                    "Consumo": "Consumption",
                    "LongLine": "Long line",
                    "ShortLine": "Short line",
                    "Acoes": "Actions"
                },
                "tituloCadastrarTrecho": "Register leg",
                "botaoSalvarTodos": "Edit all legs",
                "formularioCadastrarTrecho": {
                    "Origem": "From",
                    "Destino": "To",
                    "Partida": "Start",
                    "DEC": "Takeoff",
                    "POU": "Landing",
                    "Corte": "Shutdown",
                    "DECPOU": "Tkof-Land",
                    "Total": "Total",
                    "Nav": "Nav.",
                    "IFR": "IFR",
                    "Noturno": "Night",
                    "Diurnos": "Day",
                    "Noturnos": "Night",
                    "Partidas": "Starts",
                    "PAX": "PAX",
                    "Carga": "Payload",
                    "LongLine": "Long line",
                    "ShortLine": "Short line",
                    "Inicial": "Initial",
                    "Final": "Final",
                    "CodigoPTBR": "PTBR code",
                    "SelecioneOpcao": "Select an option",
                    "botaoAdicionarTrecho": "Add leg"
                },
                "tabelaCadastrarTrecho": {
                    "Realizados": "Performed",
                    "Pousos": "Landings",
                    "Dados": "Data",
                    "CargaExterna": "External load",
                    "Combustivel": "Fuel",
                    "OperacaoPTBR": "PTBR operation",
                    "Acoes": "Actions",
                    "Numero": "No.",
                    "Origem": "From",
                    "Destino": "To",
                    "Partida": "Start",
                    "DEC": "Takeoff",
                    "POU": "Landing",
                    "Corte": "Shutdown",
                    "DECPOU": "Tkof-Land",
                    "Total": "Total",
                    "Nav": "Nav.",
                    "IFR": "IFR",
                    "Noturno": "Night",
                    "Diurnos": "Day",
                    "Noturnos": "Night",
                    "Partidas": "Starts",
                    "PAX": "PAX",
                    "Carga": "Payload",
                    "LongLine": "Long line",
                    "ShortLine": "Short line",
                    "Inicial": "Initial",
                    "Final": "Final",
                    "CodigoPTBR": "PTBR code"
                },
                "tituloTotaisDosTrechos": "Total legs",
                "tabelaTotaisDosTrechos": {
                    "DecolagemPouso": "Takeoff/Landing",
                    "TempoTotal": "Total time",
                    "Navegacao": "Navigation",
                    "Instrumento": "Instrument",
                    "Noturno": "Night",
                    "PousosDiurnos": "Day Landings",
                    "PousosNoturnos": "Night Landings",
                    "Pax": "Pax.",
                    "Carga": "Payload",
                    "Consumo": "Consumption"
                },
                "excluirTrecho": "Are you sure you want to delete this leg?",
                "removerTripulanteDoTrecho": "Are you sure you'd like to remove this crew member from this leg?",
                "tituloEdicaoTrecho": "Edit leg",
                "formularioEditarTrecho": {
                    "Origem": "From",
                    "Destino": "To",
                    "Partida": "Start",
                    "DEC": "Takeoff",
                    "POU": "Landing",
                    "Corte": "Shutdown",
                    "DECPOU": "Tkof-Land",
                    "Total": "Total",
                    "Nav": "Nav.",
                    "IFR": "IFR",
                    "Noturno": "Night",
                    "Diurnos": "Day",
                    "Noturnos": "Night",
                    "Partidas": "Starts",
                    "PAX": "PAX",
                    "Carga": "Payload",
                    "LongLine": "Long line",
                    "ShortLine": "Short line",
                    "Inicial": "Initial",
                    "Final": "Final",
                    "CodigoPTBR": "PTBR code",
                    "Horario": "Schedule",
                    "Copiar": "Copy",
                    "Atual": "Current",
                    "Following": "F. Follow",
                    "FollowingShort": "Follow",
                    "botaoEditarTrecho": "Edit leg",
                    "limparTrecho": "The leg data was deleted."
                },
                "tituloTripulacaoCadastrada": "Registered crew",
                "formularioAdicionarTripulante": {
                    "Tripulante": "Crew member",
                    "FuncaoDeBordo": "Role",
                    "botaoAdicionarTripulante": "Add crew member"
                },
                "tabelaTripulantes": {
                    "Nome": "Name",
                    "FuncaoDeBordo": "Role",
                    "Acoes": "Actions"
                },
                "excluirAbastecimento": "Are you sure you want to delete this refuel?",
                "mensagemDadosAtualizadosComSucesso": "Data updated successfully",
                "tituloCadastrarAbastecimento": "Register refuel",
                "formularioAdicionarAbastecimento": {
                    "CombustivelSolicitado": "Fuel Requested (Kg or Lb)",
                    "Trecho": "Leg",
                    "NumeroDaCE": "EC number",
                    "Fornecedor": "Provider",
                    "CombustivelAbastecido": "Fuel supplied (L)",
                    "Localidade": "Location",
                    "botaoAdicionarAbastecimento": "Add refuel"
                },
                "tituloAbastecimentosCadastrados": "Registered supplies",
                "tabelaAbastecimentosCadastrados": {
                    "Trecho": "Flight Leg",
                    "NumeroDaCE": "EC No.",
                    "Cia": "Co.",
                    "QuantidadeSolicitada": "Quantity requested",
                    "QuantidadeAbastecida": "Quantity supplied",
                    "Acoes": "Actions"
                },
                "tituloEditarSolicitacaoDeCombustivel": "Edit fuel request",
                "formularioEditarSolicitacaoDeCombustivel": {
                    "CombustivelSolicitado": "Fuel Requested",
                    "Trecho": "Flight Leg",
                    "NumeroDaCE": "EC number",
                    "Fornecedor": "Provider",
                    "CombustivelAbastecido": "Fuel supplied (L)",
                    "Localidade": "Location",
                    "botaoEditarAbastecimento": "Edit refuel"
                },
                "tituloObservacoes": "Comments",
                "formularioEditarObservacoes": {
                    "Observacoes": "Comments",
                    "botaoEditarObservacoes": "Edit notes"
                },
                "tituloAlertasDoRelatorio": "Report Alerts",
                "tabelaAlertasDoRelatorio": {
                    "Mensagem": "Message",
                    "Data": "Date"
                },
                "aprovarRelatorio": "Are you sure you want to approve this report?",
                "reabrirRelatorio": "Are you sure you want to reopen this report?",
                "reprovarRelatorio": "Are you sure you want to disapprove this report?",
                "relatorioReabertoGerouImplicacoes": "This report has been reopened! This led to the following implications",
                "tabelaImplicacoes": {
                    "Mensagem": "Message",
                    "Data": "Date"
                },
                "tituloAprovacoes": "Approvals",
                "botaoReabrirRelatorio": "Reopen report",
                "tabelaAprovacoes": {
                    "Tipo": "Type",
                    "Tripulante": "Crew member",
                    "Aprovacao": "Approval",
                    "Acoes": "Actions"
                },
                "tituloJustificativaReprovacao": "Justification for disapproval",
                "formularioReprovacao": {
                    "RazaoDaReprovacao": "Reason for disapproval",
                    "botaoReprovarRelatorio": "Fail report"
                },
                "tituloLoginDoComandanteNoLDAP": "Commander login in LDAP",
                "formularioLogin": {
                    "botaoAcessarSistema": "Access the system",
                    "placeholder": {
                        "Email": "Your email",
                        "Senha": "Your password"
                    }
                },
                "tituloLogDoRelatorio": "Report log",
                "tabelaLogRelatorio": {
                    "Usuario": "User",
                    "Acao": "Action",
                    "Descricao": "Description",
                    "Data": "Date"
                }
            },
            "ListaDeRelatoriosDeVooOffline": {
                "titulo": "Flight reports",
                "tabela": {
                    "semRelatorios": "There are no registered reports",
                    "ID": "ID",
                    "NumeroDoRelatorio": "Report number",
                    "Base": "Base",
                    "Data": "Date",
                    "Aeronave": "Aircraft",
                    "Frota": "Fleet",
                    "Cliente": "Client",
                    "TipoDeVoo": "Type of flight",
                    "NumeroDoVoo": "Flight number",
                    "Status": "Status",
                    "Acoes": "Actions"
                }
            },
            "EditarRelatoriosDeVooOffline": {
                "trocarStatusDoRelatorioDeVoo": "Are you sure you would like to change the flight report status?",
                "confirmarSalvarTodos": "Are you sure you would like to save all legs?",
                "titulo": "Edit flight report",
                "botaoRelatorio": "Report",
                "botaoExtratoDB": "DB extract",
                "botaoXML": "XML",
                "botaoRelatorioDeVoo": {
                    "TrocarParaRascunho": "Switch to draft",
                    "TrocarParaFinalizado": "Switch to finished",
                    "TrocarParaCancelado": "Switch to canceled"
                },
                "erros": "The following filling errors prevented the report from being finalized",
                "formularioEditarRelatorio": {
                    "Data": "Date",
                    "Prefixo": "Prefix",
                    "Voo": "Flight",
                    "NumeroDeVoo": "Flight number",
                    "NumeroDoRelatorio": "Flight report number",
                    "SolicitouIsencao": "Requested exemption",
                    "Base": "Base",
                    "Contrato": "Contract",
                    "MecanicoResponsavel": "Responsible mechanic",
                    "Cliente": "Client",
                    "Observacoes": "Comments",
                    "botaoEditarRelatorioDeVoo": "Edit flight report"
                },
                "excluirTripulante": "Are you sure you want to delete this crew member? It will be deleted from all legs.",
                "tituloCadastrarTripulacao": "Register crew",
                "formularioCadastrarTripulacao": {
                    "Tripulante": "Crew member",
                    "FuncaoDeBordo": "On-board function",
                    "DataDeApresentacao": "Start duty date",
                    "HoraDeApresentacao": "Start duty time",
                    "botaoAdicionarTripulante": "Add crew member"
                },
                "modalEditarTripulacao": {
                    "Titulo": "Edit",
                    "FuncaoDeBordo": "On-board function",
                    "DataDeApresentacao": "Start duty date",
                    "HoraDeApresentacao": "Start duty time",
                    "botaoEditarTripulante": "Edit crew member"
                },
                "tituloTripulantesCadastrados": "Registered crew",
                "tabelaTripulantesCadastrados": {
                    "Nome": "Name",
                    "CANAC": "CANAC",
                    "SISPAT": "SISPAT",
                    "FB": "FB",
                    "Apresentacao": "Presentation",
                    "DecolagemPouso": "Takeoff/Landing",
                    "TempoTotal": "Total time",
                    "Navegacao": "Navigation",
                    "Instrumento": "Instrument",
                    "Noturno": "Night",
                    "PousosDiurnos": "Day Landings",
                    "PousosNoturnos": "Night Landings",
                    "Pax": "Pax.",
                    "Carga": "Payload",
                    "Consumo": "Consumption",
                    "LongLine": "Long line",
                    "ShortLine": "Short line",
                    "Acoes": "Actions"
                },
                "tituloCadastrarTrecho": "Register leg",
                "botaoSalvarTodos": "Edit all legs",
                "formularioCadastrarTrecho": {
                    "Origem": "From",
                    "Destino": "To",
                    "Partida": "Start",
                    "DEC": "Takeoff",
                    "POU": "Landing",
                    "Corte": "Shutdown",
                    "DECPOU": "Tkof-Land",
                    "Total": "Total",
                    "Nav": "Nav.",
                    "IFR": "IFR",
                    "Noturno": "Night",
                    "Diurnos": "Day",
                    "Noturnos": "Night",
                    "Partidas": "Starts",
                    "PAX": "PAX",
                    "Carga": "Payload",
                    "LongLine": "Long line",
                    "ShortLine": "ShortLine",
                    "Inicial": "Initial",
                    "Final": "Final",
                    "CodigoPTBR": "PTBR code",
                    "SelecioneOpcao": "Select an option",
                    "botaoAdicionarTrecho": "Add leg"
                },
                "tabelaCadastrarTrecho": {
                    "Realizados": "Performed",
                    "Pousos": "Landings",
                    "Dados": "Data",
                    "CargaExterna": "External load",
                    "Combustivel": "Fuel",
                    "OperacaoPTBR": "PTBR operation",
                    "Acoes": "Actions",
                    "Numero": "No.",
                    "Origem": "From",
                    "Destino": "To",
                    "Partida": "Start",
                    "DEC": "Takeoff",
                    "POU": "Landing",
                    "Corte": "Shutdown",
                    "DECPOU": "Tkof-Land",
                    "Total": "Total",
                    "Nav": "Nav.",
                    "IFR": "IFR",
                    "Noturno": "Night",
                    "Diurnos": "Day",
                    "Noturnos": "Night",
                    "Partidas": "Starts",
                    "PAX": "PAX",
                    "Carga": "Payload",
                    "LongLine": "Long line",
                    "ShortLine": "Short line",
                    "Inicial": "Initial",
                    "Final": "Final",
                    "CodigoPTBR": "PTBR code"
                },
                "tituloTotaisDosTrechos": "Legs total",
                "tabelaTotaisDosTrechos": {
                    "DecolagemPouso": "Takeoff/Landing",
                    "TempoTotal": "Total time",
                    "Navegacao": "Navigation",
                    "Instrumento": "Instrument",
                    "Noturno": "Night",
                    "PousosDiurnos": "Day Landings",
                    "PousosNoturnos": "Night Landings",
                    "Pax": "Pax.",
                    "Carga": "Payload",
                    "Consumo": "Consumption"
                },
                "excluirTrecho": "Are you sure you want to delete this leg?",
                "removerTripulanteDoTrecho": "Are you sure you'd like to remove this crew member from this leg?",
                "formularioEditarTrecho": {
                    "Origem": "From",
                    "Destino": "To",
                    "Partida": "Start",
                    "DEC": "Takeoff",
                    "POU": "Landing",
                    "Corte": "Shutdown",
                    "DECPOU": "Tkof-Land",
                    "Total": "Total",
                    "Nav": "Nav.",
                    "IFR": "IFR",
                    "Noturno": "Night",
                    "Diurnos": "Day",
                    "Noturnos": "Night",
                    "Partidas": "Starts",
                    "PAX": "PAX",
                    "Carga": "Payload",
                    "LongLine": "Long line",
                    "ShortLine": "Short line",
                    "Inicial": "Initial",
                    "Final": "Final",
                    "CodigoPTBR": "PTBR code",
                    "botaoEditarTrecho": "Edit leg"
                },
                "tituloTripulacaoCadastrada": "Registered crew",
                "formularioAdicionarTripulante": {
                    "Tripulante": "Crew member",
                    "FuncaoDeBordo": "On-board function",
                    "botaoAdicionarTripulante": "Add crew member"
                },
                "tabelaTripulantes": {
                    "Nome": "Name",
                    "FuncaoDeBordo": "On-board function",
                    "Acoes": "Actions"
                },
                "excluirAbastecimento": "Are you sure you want to delete this refuel?",
                "mensagemDadosAtualizadosComSucesso": "Data updated successfully",
                "tituloCadastrarAbastecimento": "Register refuel",
                "formularioAdicionarAbastecimento": {
                    "CombustivelSolicitado": "Fuel Requested (Kg or Lb)",
                    "Trecho": "Flight Leg",
                    "NumeroDaCE": "EC number",
                    "Cia": "Co.",
                    "CombustivelAbastecido": "Fuel supplied (L)",
                    "botaoAdicionarAbastecimento": "Add refuel"
                },
                "tituloAbastecimentosCadastrados": "Registered supplies",
                "tabelaAbastecimentosCadastrados": {
                    "Trecho": "Leg",
                    "NumeroDaCE": "EC No.",
                    "Cia": "Co.",
                    "QuantidadeSolicitada": "Quantity requested",
                    "QuantidadeAbastecida": "Quantity supplied",
                    "Acoes": "Actions"
                },
                "tituloEditarSolicitacaoDeCombustivel": "Edit fuel request",
                "formularioEditarSolicitacaoDeCombustivel": {
                    "CombustivelSolicitado": "Fuel Requested",
                    "Trecho": "Flight Leg",
                    "NumeroDaCE": "EC number",
                    "Cia": "Co.",
                    "CombustivelAbastecido": "Fuel supplied (L)",
                    "botaoEditarAbastecimento": "Edit refuel"
                },
                "tituloObservacoes": "Comments",
                "formularioEditarObservacoes": {
                    "Observacoes": "Comments",
                    "botaoEditarObservacoes": "Edit notes"
                },
                "tituloAlertasDoRelatorio": "Report Alerts",
                "tabelaAlertasDoRelatorio": {
                    "Mensagem": "Message",
                    "Data": "Date"
                },
                "aprovarRelatorio": "Are you sure you want to approve this report?",
                "reabrirRelatorio": "Are you sure you want to reopen this report?",
                "reprovarRelatorio": "Are you sure you want to disapprove this report?",
                "relatorioReabertoGerouImplicacoes": "This report has been reopened! This led to the following implications",
                "tabelaImplicacoes": {
                    "Mensagem": "Message",
                    "Data": "Date"
                },
                "tituloAprovacoes": "Approvals",
                "botaoReabrirRelatorio": "Reopen report",
                "tabelaAprovacoes": {
                    "Tipo": "Type",
                    "Tripulante": "Crew member",
                    "Aprovacao": "Approval",
                    "Acoes": "Actions"
                },
                "tituloJustificativaReprovacao": "Justification for disapproval",
                "formularioReprovacao": {
                    "RazaoDaReprovacao": "Reason for disapproval",
                    "botaoReprovarRelatorio": "Fail report"
                },
                "tituloLoginDoComandanteNoLDAP": "Commander login in LDAP",
                "formularioLogin": {
                    "botaoAcessarSistema": "Access the system",
                    "placeholder": {
                        "Email": "Your email",
                        "Senha": "Your password"
                    }
                },
                "tituloLogDoRelatorio": "Report log",
                "tabelaLogRelatorio": {
                    "Usuario": "User",
                    "Acao": "Action",
                    "Descricao": "Description",
                    "Data": "Date"
                }
            },
            "AdicionarRelatorioDeVooOffline": {
                "titulo": "Register new flight report",
                "formulario": {
                    "Data": "Date",
                    "Prefixo": "Prefix",
                    "Voo": "Flight",
                    "NumeroDeVoo": "Flight number",
                    "SolicitouIsencao": "Requested exemption",
                    "Base": "Base",
                    "Contrato": "Contract",
                    "MecanicoResponsavel": "Responsible mechanic",
                    "Cliente": "Client",
                    "Observacoes": "Comments",
                    "botaoCriarRelatorioDeVoo": "Create flight report"
                }
            },
            "RelatoriosPendentesDeAprovacao": {
                "aprovar": "Are you sure you want to approve this report?",
                "titulo": "Pending Approval Reports",
                "formulario": {
                    "Base": "Base",
                    "Status": "Status"
                },
                "botaoAprovar": "Approve",
                "tabela": {
                    "Data": "Date",
                    "Base": "Base",
                    "Aeronave": "Aircraft",
                    "Frota": "Fleet",
                    "Contrato": "Contract",
                    "TipoDeVoo": "Flight Type",
                    "NumeroDoVoo": "Flight No.",
                    "Status": "Status",
                    "Acoes": "Actions"
                }
            },
            "QuantidadeDeVoosPorDia": {
                "titulo": "Number of flights per day",
                "formulario": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "Aeronave": "Aircraft",
                    "Frota": "Fleet",
                    "Base": "Base",
                    "Tripulantes": "Crew",
                    "TipoDeVoo": "Flight Type",
                    "Contrato": "Contract",
                    "SomenteAprovados": "Only approved",
                    "BaseContratual": "Contract Base"
                },
                "tituloTotaisDaAeronavePorData": "Aircraft totals by date",
                "tabelaTotaisDaAeronavePorData": {
                    "Data": "Date",
                    "Prefixo": "Prefix",
                    "Frota": "Fleet",
                    "QuantidadeDeVoos": "Number of Flights",
                    "QuantidadeDePousos": "Number of Landings",
                    "QuantidadeDeCortes": "Number of Cuts",
                    "QuantidadeDePAX": "Amount of PAX"
                },
                "tituloTotaisDaAeronavePorPeriodo": "Aircraft totals by period",
                "tabelaTotaisDaAeronavePorPeriodo": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "Prefixo": "Prefix",
                    "Frota": "Fleet",
                    "QuantidadeDeVoos": "Number of Flights",
                    "QuantidadeDePousos": "Number of Landings",
                    "QuantidadeDeCortes": "Number of Cuts",
                    "QuantidadeDePAX": "Amount of PAX"
                },
                "tituloTotaisDoModeloPorData": "Template Totals by Date",
                "tabelaTotaisDoModeloPorData": {
                    "Data": "Date",
                    "Frota": "Fleet",
                    "QuantidadeDeVoos": "Number of Flights",
                    "QuantidadeDePousos": "Number of Landings",
                    "QuantidadeDeCortes": "Number of Cuts",
                    "QuantidadeDePAX": "Amount of PAX"
                },
                "tituloTotaisDoModeloPorPeriodo": "Model totals by period",
                "tabelaTotaisDoModeloPorPeriodo": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "Frota": "Fleet",
                    "QuantidadeDeVoos": "Number of Flights",
                    "QuantidadeDePousos": "Number of Landings",
                    "QuantidadeDeCortes": "Number of Cuts",
                    "QuantidadeDePAX": "Amount of PAX"
                },
                "tituloTotalGeralPorData": "Grand Total by date",
                "tabelaTotalGeralPorData": {
                    "Data": "Date",
                    "QuantidadeDeVoos": "Number of Flights",
                    "QuantidadeDePousos": "Number of Landings",
                    "QuantidadeDeCortes": "Number of Cuts",
                    "QuantidadeDePAX": "Amount of PAX"
                },
                "tituloTotalGeralPorPeriodo": "Grand Total per period",
                "tabelaTotalGeralPorPeriodo": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "Base": "Base",
                    "QuantidadeDeVoos": "Number of Flights",
                    "QuantidadeDePousos": "Number of Landings",
                    "QuantidadeDeCortes": "Number of Cuts",
                    "QuantidadeDePAX": "Amount of PAX"
                }
            },
            "RelatorioDeOcorrenciasAnormais": {
                "titulo": "Report of Abnormal Occurrences",
                "formulario": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "SomenteAprovados": "Only approved",
                    "RelatorioDeVoo": "Flight Report",
                    "Aeronave": "Aircraft",
                    "Frota": "Fleet",
                    "placeholder": {
                        "InformeONumeroDoRelatorioDeVoo": "Enter the flight report number"
                    }
                },
                "tabela": {
                    "Data": "Date",
                    "Prefixo": "Prefix",
                    "Frota": "Fleet",
                    "Base": "Base",
                    "TipoDeVoo": "Flight Type",
                    "Contrato": "Contract",
                    "Cliente": "Client",
                    "NumeroRelatorio": "Report No.",
                    "NumeroDoVoo": "Flight No.",
                    "TipoDeOcorrencia": "Type of Occurrence",
                    "DescricaoDaOcorrencia": "Occurrence description",
                    "AcaoRequerida": "Required Action",
                    "Observacoes": "Comments",
                    "Tripulantes": "Crew"
                }
            },
            "ControleDiarioDeUtilizacaoDeAeronavesContratadas": {
                "osCamposDataClienteEBaseSaoObrigatoriosParaExportacaoEmPDF": "The fields Date, Customer and Base are mandatory for PDF export.",
                "titulo": "Daily Control of Use of Contracted Aircraft",
                "formulario": {
                    "Data": "Date",
                    "SomenteAprovados": "Only approved",
                    "Base": "Base",
                    "Aeronave": "Aircraft",
                    "Contrato": "Contract",
                    "Cliente": "Client",
                    "BaseContratual": "Contract Base"
                },
                "tabela": {
                    "Prefixo": "Prefix",
                    "Frota": "Fleet",
                    "Contrato": "Contract",
                    "CodigoSAP": "SAP code",
                    "TempoTotalDeVooNaDataDecolagemAoPouso": "Total Flight Time on Date - Takeoff to Landing",
                    "TempoTotalDeVooNoDataPartidaAoCorte": "Total Flight Time on Date - Start to Shutoff",
                    "IndisponibilidadesMotivos": "Outages - Reasons",
                    "IndisponibilidadesHoras": "Outages - Hours"
                }
            },
            "BoletimDeDisponibilidade": {
                "titulo": "Availability bulletin",
                "formulario": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "Contrato": "Contract",
                    "SomenteAprovados": "Only approved",
                    "BaseContratual": "Contract Base"
                },
                "tabela": {
                    "Contrato": "Contract",
                    "Prefixo": "Prefix",
                    "Data": "Date",
                    "TipoDeContrato": "Type of contract",
                    "VooDecolagemAoPouso": "Flight - Takeoff to Landing",
                    "VooPartidaAoCorte": "Flight - Start to Shutoff",
                    "QtdPousos": "Qty. landings",
                    "QtdPartidas": "Qty. Departures",
                    "VooTotalDecolagemAoPouso": "Total Flight - Takeoff to Landing",
                    "DuracaoMediaDeVooDecolagemAoPouso": "Average Flight Duration - Takeoff to Landing",
                    "VooTotalPartidaAoCorte": "Total Flight - Start to Shutoff",
                    "DuracaoMediaDeVooPartidaAoCorte": "Average Flight Duration - Start to Shutoff",
                    "MaximoDeDisponibilidadeContratual": "Maximum Contractual Availability",
                    "IndisponibilidadeReal": "Actual Unavailability",
                    "IndisponibilidadeContratual": "Contractual Unavailability",
                    "DisponibilidadeReal": "Actual Availability",
                    "DisponibilidadeContratual": "Contractual Availability",
                    "TipoMPRG": "MPRG type",
                    "TipoMNPR": "MNPR type",
                    "TipoOPS": "OPS type",
                    "OcorrenciaAnormal": "Abnormal Occurrence"
                },
                "tituloTotais": "Totals",
                "tabelaTotais": {
                    "Contrato": "Contract",
                    "Prefixo": "Prefix",
                    "TipoDeContrato": "Type of contract",
                    "QtdPousos": "Qty. landings",
                    "QtdPartidas": "Qty. Departures",
                    "VooTotalDecolagemAoPouso": "Total Flight - Takeoff to Landing",
                    "VooTotalPartidaAoCorte": "Total Flight - Start to Shutoff",
                    "DuracaoMediaDeVooDecolagemAoPouso": "Average Flight Duration - Takeoff to Landing",
                    "DuracaoMediaDeVooPartidaAoCorte": "Average Flight Duration - Start to Shutoff",
                    "TempoTotalRegistrado": "Total Recorded Time",
                    "MaximoDeDisponibilidadeContratual": "Maximum Contractual Availability",
                    "IndisponibilidadeReal": "Actual Unavailability",
                    "IndisponibilidadeContratual": "Contractual Unavailability",
                    "DisponibilidadeReal": "Actual Availability",
                    "DisponibilidadeContratual": "Contractual Availability",
                    "TipoMPRG": "MPRG type",
                    "TipoMNPR": "MNPR type",
                    "TipoOPS": "OPS type",
                    "OcorrenciaAnormal": "Abnormal Occurrence",
                    "PorcentagemIndisponibilidadeReal": "% Actual Unavailability",
                    "PorcentagemIndisponibilidadeContratual": "% Contractual Unavailability",
                    "PorcentagemDisponibilidadeReal": "% Actual Availability",
                    "PorcentagemDisponibilidadeContratual": "% Contractual Availability",
                    "PorcentagemTipoMPRG": "% MPRG Type",
                    "PorcentagemTipoMNPR": "% MNPR Type",
                    "PorcentagemTipoOPS": "% Type OPS",
                    "PorcentagemAproveitamentoDecolagemAoPouso": "% Utilization - Takeoff to Landing",
                    "PorcentagemAproveitamentoPartidaAoCorte": "% Utilization - Departure to Cut"
                }
            },
            "FichasDeDisponibilidade": {
                "titulo": "Availability sheets",
                "formulario": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "Aeronave": "Aircraft",
                    "Contrato": "Contract",
                    "Base": "Base"
                },
                "tabela": {
                    "Prefixo": "Prefix",
                    "Contrato": "Contract",
                    "InicioDisponibilidadeContratual": "Home disp. contractual",
                    "FimDispContratual": "End available contractual",
                    "InicioIndisponibilidade": "Indisp.",
                    "FimIndisponibilidade": "Indisp. end",
                    "Franquia": "Franchise",
                    "IndisponibilidadeTotal": "Indisp. Total",
                    "SemFranquia": "No deductible",
                    "TempoTotal": "Total time"
                }
            },
            "RelatorioDeConsumo": {
                "titulo": "Consumption Report",
                "formulario": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "SomenteAprovados": "Only approved",
                    "RelatorioDeVoo": "Flight Report",
                    "Aeronave": "Aircraft",
                    "Frota": "Fleet",
                    "Base": "Base",
                    "TipoDeVoo": "Flight Type",
                    "Contrato": "Contract",
                    "Cliente": "Client",
                    "NumeroDeReciboDoCombustivel": "Fuel Receipt No.",
                    "FornecedorDeCombustivel": "Fuel Supplier",
                    "BaseContratual": "Contract Base",
                    "placeholder": {
                        "InformeONumeroDoRelatorioDeVoo": "Enter the flight report number"
                    }
                },
                "tabela": {
                    "Data": "Date",
                    "Prefixo": "Prefix",
                    "Frota": "Fleet",
                    "Base": "Base",
                    "TipoDeVoo": "Flight Type",
                    "Contrato": "Contract",
                    "Cliente": "Client",
                    "NumeroRelatorio": "Report No.",
                    "NumeroDoVoo": "Flight No.",
                    "Isencao": "Exemption",
                    "TotalVooDecolagemAoPouso": "Total Flight - Takeoff to Landing",
                    "TotalDoVooPartidaAoCorte": "Total Flight - Start to Shutoff",
                    "TotalDoVooNavegacao": "Total Flight - Navigation",
                    "TotalDoVooInstrumento": "Total Flight - Instrument",
                    "TotalDoVooNoturno": "Total Flight - Night",
                    "TotalDoVooPartidas": "Total Flight - Departures",
                    "TotalDoVooPousosDiurnos": "Total Flight - Day Landings",
                    "TotalDoVooPousosNoturnos": "Total Flight - Night Landings",
                    "TotalDoVooPAX": "Total Flight - PAX",
                    "TotalDoVooCarga": "Total Flight - Cargo",
                    "TipoDeContrato": "Type of contract",
                    "CombustivelAutorizado": "Authorized Fuel",
                    "FornecedorDeCombustivel": "Fuel Supplier",
                    "NumeroDaCE": "EC No.",
                    "QuantidadeSolicitada": "Quantity Requested",
                    "QuantidadeAbastecida": "Quantity Supplied",
                    "QuantidadeAbastecidaConvertida": "Quantity Supplied Converted",
                    "Saldo": "Balance",
                    "Consumo": "Consumption",
                    "ConsumoEmLitros": "Consumption in liters"
                },
                "tituloTotais": "Totals",
                "tabelaTotais": {
                    "Prefixo": "Prefix",
                    "Frota": "Fleet",
                    "TotalVooDecolagemAoPouso": "Total Flight - Takeoff to Landing",
                    "TotalDoVooPartidaAoCorte": "Total Flight - Start to Shutoff",
                    "TotalDoVooNavegacao": "Total Flight - Navigation",
                    "TotalDoVooInstrumento": "Total Flight - Instrument",
                    "TotalDoVooNoturno": "Total Flight - Night",
                    "TotalDoVooPartidas": "Total Flight - Departures",
                    "TotalDoVooPousosDiurnos": "Total Flight - Day Landings",
                    "TotalDoVooPousosNoturnos": "Total Flight - Night Landings",
                    "TotalDoVooPAX": "Total Flight - PAX",
                    "TotalDoVooCarga": "Total Flight - Cargo",
                    "CombustivelAutorizado": "Authorized Fuel",
                    "QuantidadeSolicitada": "Quantity Requested",
                    "QuantidadeAbastecida": "Quantity Supplied",
                    "QuantidadeAbastecidaConvertida": "Quantity Supplied Converted",
                    "Saldo": "Balance",
                    "Consumo": "Consumption",
                    "ConsumoEmLitros": "Consumption in liters"
                }
            },
            "RelatorioDeDisponibilidadeDeCombustivel": {
                "titulo": "Fuel Availability Report",
                "formulario": {
                    "MesInicio": "Start Month",
                    "MesTermino": "End Month",
                    "Aeronave": "Aircraft",
                    "Base": "Base",
                    "Cliente": "Client",
                    "SomenteAprovados": "Only approved"
                },
                "tabela": {
                    "Inicio": "Start",
                    "Fim": "End",
                    "Aeronave": "Aircraft",
                    "Frota": "Fleet",
                    "Contrato": "Contract",
                    "Cliente": "Client",
                    "QuantidadeAbastecida": "Quantity Supplied",
                    "QuantidadeAbastecidaConvertida": "Quantity Supplied Converted",
                    "Consumo": "Consumption",
                    "CAutorizado": "C. Authorized",
                    "Saldo": "Balance",
                    "HorasTotais": "Total hours",
                    "Dias": "Days",
                    "MediaDeHorasDeVooPorDia": "Average Flight Hours per Day",
                    "MediaDeConsumoPorDia": "Average Consumption per Day",
                    "MediaDeConsumoPorHorasDeVoo": "Average Consumption by Flight Hours"
                }
            },
            "ExtratoDeDBEmBloco": {
                "titulo": "Multiple DB extract",
                "formulario": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "Aeronave": "Aircraft",
                    "Contrato": "Contract",
                    "Base": "Base",
                    "BasesContratual": "Contract Bases",
                    "SomenteAprovados": "Only approved"
                },
                "tabela": {
                    "Data": "Date",
                    "Prefixo": "Prefix",
                    "Frota": "Fleet",
                    "Base": "Base",
                    "Contrato": "Contract",
                    "Cliente": "Client",
                    "NumeroRelatorio": "Report No.",
                    "NumeroDoVoo": "Flight No."
                }
            },
            "RelatorioDePousosPorLocalidade": {
                "titulo": "Landing Report by Location",
                "formulario": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "SomenteAprovados": "Only approved",
                    "Local": "Place",
                    "RelatorioDeVoo": "Flight Report",
                    "Aeronave": "Aircraft",
                    "Frota": "Fleet",
                    "placeholder": {
                        "InformeONumeroDoRelatorioDeVoo": "Enter the flight report number"
                    }
                },
                "tabela": {
                    "Data": "Date",
                    "Prefixo": "Prefix",
                    "Frota": "Fleet",
                    "Base": "Base",
                    "TipoDeVoo": "Flight Type",
                    "Contrato": "Contract",
                    "Cliente": "Client",
                    "NumeroRelatorio": "Report No.",
                    "NumeroDoVoo": "Flight No.",
                    "Origem": "From",
                    "Destino": "To",
                    "Tripulantes": "Crew",
                    "DEPARR": "DEP-ARR",
                    "Total": "Total",
                    "TotalDePousosDaAnvNaData": "Total number of ANV landings on the date",
                    "TotalDePousosDaAnvNoPeriodo": "Total number of ANV landings in the period",
                    "TotalDePousosDaFrotaNoPeriodo": "Total fleet landings in the period",
                    "TotalDePousosGeralNoPeriodo": "Total overall landings in the period"
                }
            },
            "ApuracaoDeHoras": {
                "titulo": "Time calculation",
                "formulario": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "Aeronave": "Aircraft",
                    "BaseContratual": "Contract Base",
                    "Contrato": "Contract",
                    "Cliente": "Client",
                    "Indisponibilidade": "Unavailability",
                    "opcoesIndisponibilidade": {
                        "NaoExibir": "Do not display",
                        "ExibirApenasTotal": "Show Only Total",
                        "ExibirApenasContratual": "Show only Contractual",
                        "ExibirTodas": "Show All"
                    },
                    "SomenteAprovados": "Only approved"
                },
                "tabela": {
                    "Data": "Date",
                    "Contrato": "Contract",
                    "PrefixoContratual": "Contract Prefix",
                    "Backup": "Backup",
                    "NumeroDoRelatorioDeVoo": "Flight Report No.",
                    "NumeroDoVoo": "Flight No.",
                    "TipoDeContrato": "Type of contract",
                    "TempoTotalDeVooDecolagemAoPouso": "Total Flight Time - Takeoff to Landing",
                    "TempoTotalDeVooPartidaAoCorte": "Total Flight Time - Start to Shutoff",
                    "CombustivelConsumido": "Fuel consumed",
                    "CombustivelAbastecido": "Fuel supplied",
                    "IndisponibilidadeDiariaTotal": "Daily Unavailability - Total",
                    "IndisponibilidadeDiariaContratual": "Daily Unavailability - Contractual"
                }
            },
            "RelatorioDeTempoEmSolo": {
                "titulo": "Ground Time Report",
                "formulario": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "SomenteAprovados": "Only approved",
                    "Local": "Place",
                    "Aeronave": "Aircraft",
                    "Frota": "Fleet"
                },
                "tabela": {
                    "Data": "Date",
                    "Prefixo": "Prefix",
                    "Frota": "Fleet",
                    "Base": "Base",
                    "TipoDeVoo": "Flight Type",
                    "Contrato": "Contract",
                    "Cliente": "Client",
                    "NumeroRelatorio": "Report No.",
                    "NumeroDoVoo": "Flight No.",
                    "Origem": "From",
                    "Destino": "To",
                    "Tripulantes": "Crew",
                    "DEPARR": "DEP-ARR",
                    "Total": "Total"
                }
            },
            "RelatorioDeTempoEntreTrechos": {
                "titulo": "Time Report between Legs",
                "formulario": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "SomenteAprovados": "Only approved",
                    "RelatorioDeVoo": "Flight Report",
                    "Aeronave": "Aircraft",
                    "Frota": "Fleet",
                    "placeholder": {
                        "InformeONumeroDoRelatorioDeVoo": "Enter the flight report number"
                    }
                },
                "tabela": {
                    "Data": "Date",
                    "Prefixo": "Prefix",
                    "Frota": "Fleet",
                    "Base": "Base",
                    "TipoDeVoo": "Flight Type",
                    "Contrato": "Contract",
                    "Cliente": "Client",
                    "NumeroRelatorio": "Report No.",
                    "NumeroDoVoo": "Flight No.",
                    "Tripulantes": "Crew",
                    "QuantidadeDeTrechos": "Number of sections",
                    "TempoEntreTrechos": "Time between legs",
                    "TotalDoVooDEPARR": "Total Flight - DEP-ARR",
                    "TotalDoVooTempoTotal": "Total Flight - Total Time"
                }
            },
            "ControleGeralDeRelatorios": {
                "titulo": "General Control of Reports",
                "formulario": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "AnaliticoOuSintetico": "Analytical or Synthetic",
                    "opcoesAnaliticoOuSintetico": {
                        "AnaliticoPorTripulante": "Analytics - Per Crew",
                        "AnaliticoPorRelatorio": "Analytics - Per Report",
                        "Sintetico": "Synthetic"
                    },
                    "SomenteAprovados": "Only approved",
                    "RelatorioDeVoo": "Flight Report",
                    "NumeroDoVoo": "Flight No.",
                    "Aeronave": "Aircraft",
                    "Frota": "Fleet",
                    "Base": "Base",
                    "TipoDeVoo": "Flight Type",
                    "Contrato": "Contract",
                    "Isencao": "Exemption",
                    "CargaExterna": "External load",
                    "Cliente": "Client",
                    "BasesContratual": "Contract Bases",
                    "placeholder": {
                        "InformeONumeroDoRelatorioDeVoo": "Enter the flight report number",
                        "InformeONumeroDoVoo": "Enter the flight number"
                    }
                },
                "tabela": {
                    "Data": "Date",
                    "Prefixo": "Prefix",
                    "Frota": "Fleet",
                    "Base": "Base",
                    "TipoDeVoo": "Flight Type",
                    "Contrato": "Contract",
                    "Cliente": "Client",
                    "NumeroRelatorio": "Report No.",
                    "NumeroDoVoo": "Flight No.",
                    "Isencao": "Exemption",
                    "TotalDoVooDEPARR": "Total Flight - DEP-ARR",
                    "TotalDoVooTempoTotal": "Total Flight - Total Time",
                    "TotalDoVooNavegacao": "Total Flight - Navigation",
                    "TotalDoVooInstrumento": "Total Flight - Instrument",
                    "TotalDoVooNoturno": "Total Flight - Night",
                    "TotalDoVooPousosDiurnos": "Total Flight - Day Landings",
                    "TotalDoVooPousosNoturnos": "Total Flight - Night Landings",
                    "TotalDoVooPAX": "Total Flight - PAX",
                    "TotalDoVooCarga": "Total Flight - Cargo",
                    "TotalDoVooConsumo": "Total Flight - Consumption",
                    "QuantidadeAbastecida": "Quantity supplied",
                    "Observacoes": "Comments",
                    "FB": "FB",
                    "Apresentacao": "Presentation",
                    "Matricula": "Registration",
                    "Tripulante": "Crew member",
                    "Etapa": "Stage",
                    "Origem": "From",
                    "Destino": "To",
                    "HrPart": "Hr. part.",
                    "DEP": "DEP.",
                    "ARR": "ARR.",
                    "Corte": "Shutdown",
                    "DEPARR": "DEP-ARR",
                    "TempoTotal": "Total time",
                    "TempoNavegacao": "Weather - Navigation",
                    "TempoInstrumento": "Time - Instrument",
                    "TempoNoturno": "Weather - Night",
                    "PousosDiurnos": "Landings - Daytime",
                    "PousosNoturnos": "Landings - Night",
                    "Partidas": "Starts",
                    "PAX": "PAX.",
                    "Carga": "Payload",
                    "CargaExternaLongLine": "External Cargo - Long Line",
                    "CargaExternaShortLine": "External Load - Short Line",
                    "CombustivelInicial": "Fuel - Initial",
                    "CombustivelFinal": "Fuel - Final"
                }
            },
            "ExtratoDeRelatorioDeVooEmBloco": {
                "titulo": "Multiple Flight Report Extract",
                "formulario": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "Aeronave": "Aircraft",
                    "Contrato": "Contract",
                    "Base": "Base",
                    "BasesContratual": "Contract Base",
                    "SomenteAprovados": "Only approved",
                    "linguagem": "Language"
                },

                "tabela": {
                    "Data": "Date",
                    "Prefixo": "Prefix",
                    "Frota": "Fleet",
                    "Base": "Base",
                    "Contrato": "Contract",
                    "Cliente": "Client",
                    "NumeroRelatorio": "Report No.",
                    "NumeroDoVoo": "Flight No."
                }

            },
            "ConferenciaDeMedicao": {
                "titulo": "Measurement conference",
                "formulario": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "Contrato": "Contract",
                    "Cliente": "Client",
                    "TipoDeMedicao": "Measurement Type",
                    "opcoesMedicao": {
                        "Sintetica": "Synthetic",
                        "Analitica": "Analytics"
                    },
                    "SomenteAprovados": "Only approved",
                    "BaseContratual": "Contract Base"
                },
                "tabela": {
                    "Contrato": "Contract",
                    "PrefixoContrato": "Contract prefix",
                    "Status": "Status",
                    "NumeroDoVoo": "Flight No.",
                    "Cliente": "Client",
                    "CodigoPTBR": "PTBR code",
                    "LocalidadeInicio": "Location - start",
                    "LocalidadeFim": "Location - end",
                    "Prefixo": "Prefix",
                    "Inicio": "Start",
                    "Fim": "End"
                }
            },
            "RelatorioDeVoosComCargaExterna": {
                "titulo": "Report of Flights with External Cargo",
                "formulario": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "SomenteAprovados": "Only approved",
                    "RelatorioDeVoo": "Flight Report",
                    "Aeronave": "Aircraft",
                    "Frota": "Fleet",
                    "Tripulantes": "Crew",
                    "placeholder": {
                        "InformeONumeroDoRelatorioDeVoo": "Enter the flight report number"
                    }
                },
                "tabela": {
                    "Data": "Date",
                    "Prefixo": "Prefix",
                    "Frota": "Fleet",
                    "Base": "Base",
                    "TipoDeVoo": "Flight Type",
                    "Contrato": "Contract",
                    "Cliente": "Client",
                    "NumeroRelatorio": "Report No.",
                    "NumeroDoVoo": "Flight No.",
                    "Tripulantes": "Crew",
                    "TotalDoVooDEPARR": "Total Flight - DEP-ARR",
                    "TotalDoVooTempoTotal": "Total Flight - Total Time",
                    "CargaExternaLongLine": "External Cargo - Long Line",
                    "CargaExternaShortLine": "External Load - Short Line"
                }
            },
            "RelatorioDePontualidade": {
                "titulo": "Punctuality Report",
                "formulario": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "Base": "Base",
                    "SomenteAprovados": "Only approved",
                    "TipoDeAtraso": "Type of delay",
                    "opcoesTiposDeAtraso": {
                        "Decolagem": "Take-off",
                        "TempoDeVoo": "Flight time"
                    }
                },
                "tabela": {
                    EstatisticasDeVooDe: function EstatisticasDeVooDe(dataInicial, dataFinal) {
                        return "Flight statistic from " + dataInicial + " to " + dataFinal;
                    },


                    "Tipo": "Type",
                    "Valor": "Value",
                    "TempoTotalDeAtraso": "Total Delay Time",
                    "Atrasados": "Late",
                    "Pontuais": "Punctual",
                    "MediaTempo": "Average Time",
                    "Operacoes": "Operations",
                    "Coordenacao": "Coordination",
                    "Despacho": "Dispatch",
                    "Manutencao": "Maintenance",
                    "NumeroVoos": "Number of flights",
                    "AtrasadosInterno": "Int arrears",
                    "AtrasadosExterno": "Late Ext",
                    "Pontualidade": "Punctuality",
                    "PontualidadeSemAtrasoExterno": "Pont (w/o ext delays)",
                    "PontualidadeSemAtrasoInterno": "Pont (w/o int delays)",
                    "VooManutencao": "Flight Maintenance",
                    "VooGiros": "Flight Tours",
                    "VooTreinamento": "Flight Training",
                    "VooPTBR": "PTBR flight",
                    "VooOutrosClientes": "Flight Other Clients",
                    "VoosComerciais": "Commercial Flights"
                }
            },
            "RelatorioDeAbastecimentos": {
                "titulo": "Supply Report",
                "formulario": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "SomenteAprovados": "Only approved",
                    "RelatorioDeVoo": "Flight Report",
                    "Aeronave": "Aircraft",
                    "Frota": "Fleet",
                    "Base": "Base",
                    "TipoDeVoo": "Flight Type",
                    "Contrato": "Contract",
                    "NumeroDeReciboDoCombustivel": "Fuel Receipt No.",
                    "FornecedorDeCombustivel": "Fuel Supplier",
                    "placeholder": {
                        "InformeONumeroDoRelatorioDeVoo": "Enter the flight report number",
                        "InformeONumeroDeReciboDoCombustivel": "Enter fuel receipt number"
                    }
                },
                "tabela": {
                    "ID": "ID",
                    "Data": "Date",
                    "Aeronave": "Aircraft",
                    "Modelo": "Model",
                    "NumeroRelatorioDeVoo": "Flight Report No.",
                    "TipoDeVoo": "Flight Type",
                    "FornecedorDeCombustivel": "Fuel Supplier",
                    "NumeroDoRecibo": "Receipt No.",
                    "QuantidadeDeCombustivel": "Amount of Fuel"
                }
            },
            "ExtracaoDeXMLEmBloco": {
                "titulo": "Multiple XML extraction",
                "formulario": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "Aeronave": "Aircraft",
                    "Cliente": "Client",
                    "Contrato": "Contract",
                    "Base": "Base",
                    "SomenteAprovados": "Only approved",
                    "BaseContratual": "Contract Base"
                },
                "tabela": {
                    "Data": "Date",
                    "Prefixo": "Prefix",
                    "Frota": "Fleet",
                    "Base": "Base",
                    "Contrato": "Contract",
                    "Cliente": "Client",
                    "NumeroRelatorio": "Report No.",
                    "NumeroDoVoo": "Flight No."
                }
            }
        },
        "Layout": {
            "Topo": {
                "bemvindo": "Welcome,",
                "botaoMinhaConta": "My account",
                "botaoSair": "Logout",
                "menuDadosBasicos": {
                    "tituloMenu": "Basic data",
                    "FileDigital": "Digital file"
                },
                "menuVoos": {
                    "tituloMenu": "Flights",
                    "Abastecimentos": "Refuel",
                    "ListaDeAbastecimentos": "Refuels list",
                    "CadastrarAbastecimentoAvulso": "Register refuel",
                    "Relatorios": "Reports",
                    "ListaDeRelatoriosDeVoo": "Flight report list",
                    "CadastrarRelatorioDeVoo": "Register flight report",
                    "ListaDeRelatoriosDeVooOffline": "Offline flight report list",
                    "Controle": "Control",
                    "VisualizarHoraDeVoo": "View flight time",
                    "ControleGeralDeRelatorios": "General Control of Reports",
                    "ExtratoDeDBEmBloco": "Multiple DB extract",
                    "ExtratoDeRelatoriosEmBloco": "Multiple Report Extract"
                },
                "menuEscalas": {
                    "tituloMenu": "Schedules",
                    "EscalasDeMissao": "Mission Schedules",
                    "EscalaDeMissao": "Mission Schedule",
                    "SolicitacoesDeEscala": "Escalation Requests",
                    "CadastrarSolicitacao": "Register Request",
                    "ListaDeSolicitacoes": "List of Requests",
                    "EscalaDiaria": "Daily schedule",
                    "ListaDeEscalasDiaria": "List of daily schedule"
                },
                "menuTreinamentos": {
                    "tituloMenu": "Trainings",
                    "ComunicadosDeTreinamento": "Training Announcements",
                    "ListaDeLogbooks": "List of logbooks"
                },
                "menuPagamentos": {
                    "tituloMenu": "Payments",
                    "Pagamentos": "Payments",
                    "ExtratoPorReferencia": "Extract by Reference",
                    "ExtratoPorPagamento": "Statement by Payment",
                    "SolicitacoesDePagamento": "Payment Requests",
                    "DeslocamentoDeMissao": "Mission Shift",
                    "DeslocamentoDeTreinamento": "Training Displacement",
                    "TransporteDeMissao": "Mission Transport",
                    "TransporteDeTreinamento": "Training Transport"
                },
                "menuFIRA": {
                    "tituloMenu": "FIRA",
                    "PapeletasIndividuaisFIRA": "Individual pilot logbooks (FIRA)",
                    "ListaDePapeletas": "List of Pilot Logbooks",
                    "Consulta": "Query",
                    "ControleDeFIRA": "FIRA control"
                },
                "menuFRMS": {
                    "tituloMenu": "FRMS",
                    "AdicionarDiscrepancia": "Discrepância técnica",
                    "RelatoriosDeFadiga": "Fatigue reports",
                    "ListaDeRelatoriosDeFadigas": "Fatigue report list",
                    "CadastrarRelatoriosDeFadiga": "Register fatigue reports",
                    "ReporteVoluntarioDeFadiga": "Voluntary fatigue report",
                    "ReportarFadiga": "Report fatigue",
                    "FerramentaDeAuxilioParaAutoavaliacaoDaFadigaFAPA": "Fatigue Self-Assessment Aid Tool (FAPA)",
                    "Cadastrar": "Register"
                },
                "menuPendencias": {
                    "OUsuarioNaoPossuiPendencias": "The user has no issues",
                    "Documentacao": "Documentation",
                    "Papeletas": "Pilot logbooks",
                    "Escalas": "Schedules",
                    "Voos": "Flights",
                    "Treinamentos": "Trainings"
                },
                "menuConfiguracoes": {
                    "App": "App",
                    "InstalacaoMobile": "Mobile Installation",
                    "Diversos": "Several",
                    "LinksUteis": "Useful links"
                },
                "atencaoVoceEstaUtilizandoOAmbienteDeHomologacao": "Attention: You are using the approval environment"
            }
        },
        "Miscelania": {
            "Overlay": {
                "paragrafoCarregando": "Loading..."
            },
            "RequestApi": {
                "seuUsuarioNaoTemPermissaoParaAcessarEstaPagina": "Your username does not have permission to access this page.",
                "seuUsuarioNaoTemPermissaoParaAcessarEstaFuncionalidade": "Your user does not have permission to access this functionality."
            }
        },
        "Pagamentos": {
            "Bases": {
                "botaoLocalidades": "Places",
                "titulo": "Bases",
                "tabela": {
                    "Nome": "Name",
                    "Tipo": "Type",
                    "CEP": "Zip code",
                    "Base": "Base",
                    "botaoAssociarCEPAOrigem": "Associate zip code to origin",
                    "botaoAssociarCEPADestino": "Associate zip code to destination",
                    "Fornecedor": "Provider"
                }
            },
            "AdicionarSolicitacaoDePagamentoMissaoDeslocamento": {
                "titulo": "Add payment request - mission - displacement",
                "formulario": {
                    "EscalaGrade": "Schedule / Grid",
                    "Quantidade": "The amount",
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "Valor": "Value",
                    "Moeda": "Coin",
                    "ValorTotal": "Amount",
                    "Observacao": "Observation",
                    "tituloTrechos": "Parts",
                    "botaoAdicionarTrecho": "Add Leg",
                    "tabela": {
                        "BuscarLocais": "Search Locations",
                        "BaseOrigem": "Base Origin",
                        "FornecedorOrigem": "Origin Supplier",
                        "CEPOrigem": "CEP Origin",
                        "BaseDestino": "Destination Base",
                        "FornecedorDestino": "Destination Supplier",
                        "CEPDestino": "CEP Destination"
                    },
                    "botaoCalcular": "Calculate",
                    "botaoSalvarSolicitacao": "Save request",
                    "placeholder": {
                        "SelecionarEscala": "Select schedule",
                        "SelecionarMoeda": "Select currency",
                        "Observacao": "Observation"
                    }
                }
            },
            "SolicitacoesDePagamentoDeslocamentoMissao": {
                "deletar": "Are you sure you would like to delete this request?",
                "titulo": "Payment Requests - Displacement - Mission",
                "botaoSolicitarPagamentoDeDeslocamentoMissao": "Request travel payment - Mission",
                "tabela": {
                    "semSolicitacaoDePagamento": "No payment request registered",
                    "ID": "ID",
                    "Status": "Status",
                    "Lote": "Batch",
                    "Frota": "Fleet",
                    "Mes": "Month",
                    "Revisao": "Revision",
                    "Inicio": "Start",
                    "Fim": "End",
                    "Quantidade": "The amount",
                    "Valor": "Value",
                    "ValorTotal": "Amount",
                    "Moeda": "Coin",
                    "Observacao": "Observation",
                    "Acoes": "Actions"
                },
                "tituloBases": "Bases",
                "tabelaBases": {
                    "Origem": "From",
                    "CEPOrigem": "CEP Origin",
                    "Destino": "To",
                    "CEPDestino": "CEP Destination"
                }
            },
            "AdicionarSolicitacaoDePagamentoMissaoTransporte": {
                "titulo": "Add payment request - mission - transport",
                "formulario": {
                    "EscalaGrade": "Schedule / Grid",
                    "Quantidade": "The amount",
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "Valor": "Value",
                    "Moeda": "Coin",
                    "ValorTotal": "Amount",
                    "Base": "Base",
                    "Observacao": "Observation",
                    "botaoSalvarPagamento": "Save payment",
                    "placeholder": {
                        "SelecionarEscala": "Select schedule",
                        "SelecionarMoeda": "Select currency",
                        "SelecionarBase": "Select base",
                        "Observacao": "Observation"
                    }
                }
            },
            "SolicitacoesDePagamentoTransporteMissao": {
                "deletar": "Are you sure you would like to delete this request?",
                "titulo": "Payment Requests - Transportation - Mission",
                "botaoSolicitarPagamentoDeTransporteMissao": "Request transport payment - Quest",
                "tabela": {
                    "semSolicitacaoDePagamento": "No payment request registered",
                    "ID": "ID",
                    "Status": "Status",
                    "Lote": "Batch",
                    "Frota": "Fleet",
                    "Mes": "Month",
                    "Base": "Base",
                    "Revisao": "Revision",
                    "Quantidade": "The amount",
                    "Valor": "Value",
                    "Moeda": "Coin",
                    "Observaco": "Observation",
                    "Acoes": "Actions"
                }
            },
            "AdicionarSolicitacaoDePagamentoTreinamentoDeslocamento": {
                "titulo": "Add payment request - training - shift",
                "formulario": {
                    "Treinamento": "Training",
                    "Quantidade": "The amount",
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "Valor": "Value",
                    "Moeda": "Coin",
                    "ValorTotal": "Amount",
                    "Observacao": "Observation",
                    "placeholder": {
                        "SelecionarTreinamento": "Select training",
                        "SelecionarMoeda": "Select currency",
                        "Observacao": "Observation"
                    },
                    "tituloTrechos": "Parts",
                    "botaoAdicionarTrecho": "Add Leg",
                    "tabela": {
                        "BuscarLocais": "Search Locations",
                        "BaseOrigem": "Base Origin",
                        "FornecedorOrigem": "Origin Supplier",
                        "CEPOrigem": "CEP Origin",
                        "BaseDestino": "Destination Base",
                        "FornecedorDestino": "Destination Supplier",
                        "CEPDestino": "CEP Destination"
                    },
                    "botaoCalcular": "Calculate",
                    "botaoSalvarSolicitacao": "Save request"
                }
            },
            "SolicitacoesDePagamentoDeslocamentoTreinamento": {
                "deletar": "Are you sure you would like to delete this request?",
                "titulo": "Payment Requests - Displacement - Training",
                "botaoSolicitarPagamentoDeDeslocamentoTreinamento": "Request travel payment - Training",
                "tabela": {
                    "semSolicitacaoDePagamento": "No payment request registered",
                    "ID": "ID",
                    "Status": "Status",
                    "Lote": "Batch",
                    "Treinamento": "Training",
                    "Revisao": "Revision",
                    "Inicio": "Start",
                    "Fim": "End",
                    "Quantidade": "The amount",
                    "Valor": "Value",
                    "ValorTotal": "Amount",
                    "Moeda": "Coin",
                    "Observacao": "Observation",
                    "Acoes": "Actions"
                },
                "tituloBases": "Bases",
                "tabelaBases": {
                    "Origem": "From",
                    "CEPOrigem": "CEP Origin",
                    "Destino": "To",
                    "CEPDestino": "CEP Destination"
                }
            },
            "AdicionarSolicitacaoDePagamentoTreinamentoTransporte": {
                "titulo": "Add Payment Request - Training - Transport",
                "formulario": {
                    "Treinamento": "Training",
                    "Quantidade": "The amount",
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "Valor": "Value",
                    "Moeda": "Coin",
                    "ValorTotal": "Amount",
                    "Base": "Base",
                    "Observacao": "Observation",
                    "botaoSalvarPagamento": "Save payment",
                    "placeholder": {
                        "SelecionarTreinamento": "Select training",
                        "SelecionarMoeda": "Select currency",
                        "SelecionarBase": "Select base",
                        "Observacao": "Observation"
                    }
                }
            },
            "SolicitacoesDePagamentoTransporteTreinamento": {
                "deletar": "Are you sure you would like to delete this request?",
                "titulo": "Payment Requests - Transportation - Training",
                "botaoSolicitarPagamentoDeTransporteTreinamento": "Request transport payment - Training",
                "tabela": {
                    "semSolicitacaoDePagamento": "No payment request registered",
                    "ID": "ID",
                    "Status": "Status",
                    "Lote": "Batch",
                    "Treinamento": "Training",
                    "Base": "Base",
                    "Revisao": "Revision",
                    "Quantidade": "The amount",
                    "Valor": "Value",
                    "Moeda": "Coin",
                    "Observacao": "Observation",
                    "Acoes": "Actions"
                }
            }
        },
        "Escalas": {
            "ListaDeEscalaDiaria": {
                "botaoDisponivel": "Available",
                "botaoIndisponivel": "Unavailable",
                "deletar": "Are you sure you would like to delete this schedule?",
                "titulo": "Daily roster list",
                "botaoAdicionarProgramacao": "Add schedule",
                "formulario": {
                    "botaoMudarData": "Change date"
                },
                "tabela": {
                    "semProgramacaoParaHoje": "There is no schedule registered for today",
                    "ID": "ID",
                    "Base": "Base",
                    "Aeronave": "Aircraft",
                    "Modelo": "Model",
                    "Contrato": "Contract",
                    "Disponibilidade": "Availability",
                    "ComandanteS": "Commander(s)",
                    "CopilotoS": "Copilot(s)",
                    "ComissarioS": "Commissioner(s)",
                    "Apresentacao": "Presentation",
                    "Corte": "Shutdown",
                    "Status": "Status",
                    "Acoes": "Actions"
                }
            },
            "AdicionarEscalaDiaria": {
                "titulo": "Register daily schedule",
                "formulario": {
                    "Data": "Date",
                    "Base": "Base",
                    "Prefixo": "Prefix",
                    "Contrato": "Contract",
                    "DesejaImportarTripulacaoDaEscala": "Want to import roster crew",
                    "botaoSalvarProgramacao": "Save schedule"
                }
            },
            "EditarEscalaDiaria": {
                "trocarOStatusDaEscala": "Are you sure you would like to change the schedule status?",
                "aprovarEscalaMesmoComAlertasVermelhos": "Are you sure you would like to approve the schedule even with the red flags?",
                "titulo": "Edit daily schedule",
                "tituloEditarEscalaDiariaTripulacaoExtra": "Edit Daily Schedule Extra Crew",
                "botaoProgramacao": {
                    "TrocarParaRascunho": "Switch to draft",
                    "TrocarParaAprovada": "Change to Approved"
                },
                "botaoAlertas": "Alerts",
                "erros": "The following filling errors prevented the unavailability form from being processed",
                "tituloDisponibilidadeDaAeronave": "Aircraft Availability",
                "formularioDisponibilidadeDaAeronave": {
                    "Disponivel": "Available",
                    "IndisponivelDesde": "Unavailable since",
                    "Razao": "Reason",
                    "Previsao": "Prediction",
                    "FlightFollowingAnormal": "Flight following abnormal",
                    "AnormalDesde": "Abnormal since",
                    "InspetorMecanicoResponsavel": "Inspector / Responsible Mechanic",
                    "Observacoes": "Comments"
                },
                "tituloCriarGrupo": "Create group",
                "formularioCriarGrupo": {
                    "HorarioDeApresentacao": "Presentation Time",
                    "HorarioDeTerminoDaJornada": "End of Day Time",
                    "Situacao": "Situation",
                    "Voos": "Flights",
                    "botaoAdicionarGrupo": "Add group"
                },
                "tituloAlertasDeAprovacao": "Approval alerts",
                "tabelaAlertasDeAprovacao": {
                    "Mensagem": "Message",
                    "Data": "Date"
                },
                "tituloLogDeStatus": "Status log",
                "tabelaLogDeStatus": {
                    "Usuario": "User",
                    "Acao": "Action",
                    "Descricao": "Description",
                    "Justificativa": "Justification",
                    "Data": "Date"
                },
                "tituloAlertas": "Alerts",
                "formularioAlertas": {
                    "Justificativa": "Justification",
                    "botaoContinuarAprovacao": "Continue approval"
                },

                tituloGrupoAs: function tituloGrupoAs(Numero, Inicio, Fim) {
                    // Verifico se o Fim é nulo, se for, retorno apenas o Inicio
                    if (Fim == null) {
                        return "Group " + Numero + " - " + Inicio;
                    }
                    return "Group " + Numero + " - " + Inicio + " to " + Fim;
                },


                "deletarTripulante": "Are you sure you want to delete this crew member?",
                "deletarGrupo": "Are you sure you want to delete this group?",
                "formularioGrupo": {
                    "HorarioDeApresentacao": "Presentation Time",
                    "HorarioDeTerminoDaJornada": "End of Day Time",
                    "Situacao": "Situation",
                    "botaoEditarGrupo": "Edit group"
                },
                "formularioAdicionarComandante": {
                    "Comandante": "Commander"
                },
                "formularioAdicionarCopiloto": {
                    "Copiloto": "Co-pilot"
                },
                "formularioAdicionarComissario": {
                    "Comissario": "Commissioner"
                },
                "tabelaGrupo": {
                    "Tripulante": "Crew member",
                    "Funcao": "Occupation"
                }
            },
            "ListaDeEscalas": {
                "botaoRevisao": "Revision",
                "titulo": "List of schedules",
                "botaoAdicionarEscala": "Add schedule",
                "tabela": {
                    "semEscalasEsteMes": "There are no schedules registered for this month",
                    "ID": "ID",
                    "Frota": "Fleet",
                    "Base": "Base",
                    "Referencia": "Reference",
                    "Acoes": "Actions"
                }
            }
        },
        "Configuracoes": {
            "EditarConfiguracoes": {
                "deletarConfiguracao": "Are you sure you would like to delete this configuration?",
                "deletarTarefa": "Are you sure you would like to delete this task?",
                "titulo": "Editing Fatigue Settings",
                "formulario": {
                    "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                    "LimiteDePontosZonaVerde": "Point limit - green zone",
                    "LimiteDePontosZonaAmarela": "Points limit - yellow zone",
                    "LimiteDePontosZonaVermelha": "Point limit - red zone",
                    "LimiteDePontosDiario": "Point limit - daily",
                    "PontuacaoPorDiaDeFolga": "Score per day off",
                    "PontuacaoDiariaMediaParaSimulacao": "Average Daily Score for Simulation",
                    "placeholder": {
                        "SelecionarAplicabilidade": "Select applicability"
                    }
                },
                "tituloConfiguracoesDePontuacao": "Scoring Settings",
                "tabelaConfiguracoesDePontuacao": {
                    "TipoDeColaborador": "Employee Type",
                    "Acoes": "Actions"
                },
                "tituloEditarConfiguracao": "Edit configuration",
                "formularioEditarConfiguracao": {
                    "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                    "LimiteDePontosZonaVerde": "Point limit - green zone",
                    "LimiteDePontosZonaAmarela": "Points limit - yellow zone",
                    "LimiteDePontosZonaVermelha": "Point limit - red zone",
                    "LimiteDePontosDiario": "Point limit - daily",
                    "PontuacaoPorDiaDeFolga": "Score per day off",
                    "PontuacaoDiariaMediaParaSimulacao": "Average Daily Score for Simulation",
                    "placeholder": {
                        "SelecionarAplicabilidade": "Select applicability"
                    }
                },
                "tituloTarefasDeRestricao": "Constraint tasks",
                "formularioTarefasDeRestricao": {
                    "Tarefa": "Assignment",
                    "LimiteDaRestricao": "Constraint limit",
                    "Restricao": "Restriction",
                    "botaoCadastrarTarefa": "Register task",
                    "placeholder": {
                        "SelecionarAplicabilidade": "Select applicability",
                        "SelecionarLimite": "Select limit",
                        "Restricao": "Restriction"
                    }
                },
                "tituloTarefasDaAplicabilidade": "Applicability tasks",
                "tabelaTarefasDaAplicabilidade": {
                    "Limite": "Limit",
                    "Tarefa": "Assignment",
                    "Restricao": "Restriction",
                    "Acoes": "Actions"
                }
            }
        },
        "ColaboradoresSigmec": {
            "ComunicadosDeTreinamentos": {
                "botaoComunicado": "Announcement",
                "titulo": "Training Announcements",
                "tabela": {
                    "semTreinamentos": "There are no registered trainings",
                    "ID": "ID",
                    "Nome": "Name",
                    "Status": "Status",
                    "CodigoDeControle": "Control code",
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "Acoes": "Actions"
                }
            },
            "ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia": {
                "botaoConfirmarPresenca": "RSVP",
                "botaoConfirmarAusencia": "Confirm absence",
                "titulo": "Communications of training pending confirmation of presence/absence",
                "tabela": {
                    "semTreinamentos": "There are no registered trainings",
                    "ID": "ID",
                    "Nome": "Name",
                    "Status": "Status",
                    "CodigoDeControle": "Control code",
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "Acoes": "Actions"
                }
            },
            "EdicaoDeColaborador": {
                "trocarStatusDoColaborador": "Are you sure you want to change the collaborator's status?",
                "titulo": "Contributor Edit",
                "tabDadosDoColaborador": {
                    "tituloTab": "Employee data",
                    "formulario": {
                        "tituloInformacoesPessoais": "Personal information",
                        "Nome": "Name",
                        "Email": "Email",
                        "EstadoCivil": "Marital status",
                        "TipoSanguineo": "Blood type",
                        "Telefone1": "Phone 1",
                        "Telefone2": "Phone 2",
                        "DadosBancarios": "Bank data",
                        "Nascimento": "Birth",
                        "PaisNascimento": "Country of birth",
                        "UFNascimento": "State of birth",
                        "CidadeNascimento": "City of birth",
                        "Endereco": "Address",
                        "Numero": "Number",
                        "Complemento": "Complement",
                        "Bairro": "Neighborhood",
                        "Cidade": "City",
                        "UF": "State",
                        "Pais": "Country",
                        "PIS": "PIS",
                        "CEP": "Zip code",
                        "CPF": "CPF",
                        "Identidade": "Identity",
                        "IDUF": "UF ID",
                        "OrgaoDeExpedicao": "Dispatch Body",
                        "IDExpedicao": "Shipping ID",
                        "CarteiraDeTrabalhoUF": "State Employment Card",
                        "CarteiraDeTrabalhoProfissional": "Professional Work Card",
                        "CarteiraDeTrabalhoExpedicao": "Dispatch Work Card",
                        "EscolaFormacao": "School/Training",
                        "Escolaridade": "Education",
                        "ConfidenceUS": "US Confidence",
                        "ExpiracaoConfidenceUS": "US confidence expiration",
                        "ConfidenceEU": "Confidence EU",
                        "ExpiracaoConfidenceEU": "EU confidence expiry",
                        "Passaporte": "Passport",
                        "PassaporteExpiracao": "Passport Expiration",
                        "TituloDeEleitor": "Voter ID",
                        "ZonaDeEleitor": "Voter Zone",
                        "SessaoDeEleitor": "Voter session",
                        "CNHCategoria": "CNH category",
                        "CNH": "Driver's license",
                        "CNHExpiracao": "Expiry driver's license",
                        "Reservista": "Reservist",
                        "ReservistaCategoria": "Reservist category",
                        "CertificadoMilitar": "Military Certificate",
                        "CertificadoMilitarMinisterio": "Ministry Military Certificate",
                        "CertificadoMilitarObservacoes": "Military certificate notes",
                        "VistoAmericano": "American visa",
                        "CREA": "CREA",
                        "CREATitulo": "CREATE title",
                        "CREAExpedicao": "CREATE expedition",
                        "CREAValidade": "CREATE validity",
                        "ASO": "ASO",
                        "Contratacao": "Hiring",
                        "Demissao": "Resignation",
                        "NomeDaMae": "Mother's name",
                        "NomeDoPai": "Father's name",
                        "tituloInformacoesProfissionais": "Professional information",
                        "Licenca": "License",
                        "CANAC": "CANAC",
                        "Matricula": "Registration",
                        "ValorHora": "Hourly rate",
                        "ContratoSISPAT": "SISPAT contract",
                        "CodigoSapiens": "Sapiens Code",
                        "placeholder": {
                            "NomeDoColaborador": "Contributor's name",
                            "EmailDoColaborador": "Collaborator's email",
                            "EstadoCivil": "Marital status",
                            "TipoSanguineo": "Blood type",
                            "TelefoneDoColaborador": "Employee phone",
                            "DadosBancarios": "Bank data",
                            "NascimentoDoColaborador": "Employee's birth",
                            "PaisNascimento": "Country of birth",
                            "SelecioneOUF": "Select the UF",
                            "CidadeNascimento": "City of birth",
                            "EnderecoDoColaborador": "Employee address",
                            "Numero": "Number",
                            "Complemento": "Complement",
                            "BairroDoColaborador": "Employee neighborhood",
                            "CidadeDoColaborador": "Employee's city",
                            "Pais": "Country",
                            "PIS": "PIS",
                            "CEPDoColaborador": "Employee zip code",
                            "CPFDoColaborador": "Employee's CPF",
                            "EstadoDeEmissaoDaID": "ID issuing state",
                            "OrgaoExpeditorDaID": "ID issuing agency",
                            "ExpedicaoDaID": "Issuance of ID",
                            "CarteiraDeTrabalhoUF": "State Employment Card",
                            "CarteiraDeTrabalhoProfissional": "Professional Work Card",
                            "CarteiraDeTrabalhoExpedicao": "Dispatch Work Card",
                            "EscolaFormacao": "School/Training",
                            "Escolaridade": "Education",
                            "NumeroDoCartaoConfidenceAmericano": "American confidence card number",
                            "ValidadeDoCartaoConfidenceAmericano": "Validity of the American confidence card",
                            "NumeroDoCartaoConfidenceEuropeu": "European confidence card number",
                            "ValidadeDoCartaoConfidenceEuropeu": "Validity of the European confidence card",
                            "NumeroDoPassaporte": "Passport No.",
                            "ExpiracaoDoPassaporte": "Passport expiration",
                            "TituloDeEleitor": "Voter ID",
                            "ZonaDeEleitor": "Voter Zone",
                            "SessaoDeEleitor": "Voter session",
                            "CNHCategoria": "CNH category",
                            "NumeroDaCarteiraDeMotorista": "Driver's License No.",
                            "ExpiracaoDaCarteiraDeMotorista": "Expiration of driver's license",
                            "Reservista": "Reservist",
                            "ReservistaCategoria": "Reservist category",
                            "CertificadoMilitar": "Military Certificate",
                            "CertificadoMilitarMinisterio": "Ministry Military Certificate",
                            "CertificadoMilitarObservacoes": "Military certificate notes",
                            "VistoAmericano": "American visa",
                            "CREA": "CREA",
                            "CREATitulo": "CREATE title",
                            "CREAExpedicao": "CREATE expedition",
                            "CREAValidade": "CREATE validity",
                            "ASO": "ASO",
                            "Contratacao": "Hiring",
                            "Demissao": "Resignation",
                            "NomeDaMaeDoColaborador": "Employee's mother's name",
                            "NomeDoPaiDoColaborador": "Employee's father's name",
                            "Licenca": "License",
                            "CANAC": "CANAC",
                            "InscricaoDoColaborador": "Collaborator registration",
                            "ValorHora": "Hourly rate",
                            "ContratoSISPAT": "SISPAT contract",
                            "CodigoSapiens": "Sapiens Code"
                        }
                    }
                },
                "tabHabilitacoes": {
                    "tituloTab": "Qualifications",
                    "opcoesNome": {
                        "AVI": "AVI",
                        "CEL": "CEL",
                        "GMP": "GMP"
                    },
                    "opcoesTipo": {
                        "SelecionarTipo": "Select type",
                        "CHT": "CHT",
                        "CCT": "CCT"
                    },
                    "tituloHabilitacoes": "Qualifications",
                    "nenhumaHabilitacaoCadastrada": "No registration registered.",
                    "tabela": {
                        "Tipo": "Type",
                        "Nome": "Name",
                        "Expedicao": "Expedition",
                        "Vencimento": "Maturity",
                        "Valido": "Valid",
                        "Status": "Status",
                        "Ativo": "Active",
                        "Arquivado": "Filed"
                    }
                },
                "tabTarefasDesignadas": {
                    "tituloTab": "Assigned tasks",
                    "tituloTarefas": "Tasks",
                    "nenhumaTarefaCadastrada": "No tasks registered.",
                    "tabela": {
                        "Tarefa": "Assignment",
                        "Vencimento": "Maturity",
                        "Valido": "Valid",
                        "Status": "Status",
                        "Ativo": "Active",
                        "Arquivado": "Filed"
                    }
                },
                "tabFrotasDesignadas": {
                    "tituloTab": "Designated fleets",
                    "tituloFrotasDesignadas": "Designated fleets",
                    "nenhumaFrotaCadastrada": "No fleet registered.",
                    "tabela": {
                        "Aeronave": "Aircraft",
                        "Subtipo": "Subtype",
                        "Vencimento": "Maturity",
                        "Instrucao": "Instruction",
                        "Status": "Status",
                        "Ativo": "Active",
                        "Arquivado": "Filed"
                    }
                },
                "tabFrotasObrigatorias": {
                    "tituloTab": "Mandatory fleets",
                    "tituloFrotasObrigatorias": "Mandatory fleets",
                    "nenhumaFrotaCadastrada": "No fleet registered.",
                    "tabela": {
                        "Aeronave": "Aircraft",
                        "Subtipo": "Subtype",
                        "Status": "Status",
                        "Ativo": "Active",
                        "Arquivado": "Filed"
                    }
                },
                "tabDesignacoes": {
                    "tituloTab": "Designations",
                    "tituloDesignacoes": "Designations",
                    "tabRevisoesDeDesignacoes": {
                        "tituloTab": "Assignment Revisions",
                        "botaoExportacoes": {
                            "ExportarDesignacoes": "Export designations",
                            "Revisao": "Revision",
                            RevisaoArquivo: function RevisaoArquivo(Numero, Status) {
                                return "Revision " + Numero + " - " + Status + " - File";
                            },
                            RevisaoObservacoes: function RevisaoObservacoes(Numero, Status) {
                                return "Revision " + Numero + " - " + Status + " - Observations";
                            }
                        },
                        "nenhumaDesignacaoCadastrada": "No designation registered.",
                        "tituloRevisao": "Revision",
                        "tabela": {
                            "Codigo": "Code",
                            "Designacao": "Designation",
                            "DS": "DS",
                            "CEL": "CEL",
                            "GMP": "GMP",
                            "AVI": "AVI",
                            "ProdutoEspecificacao": "Product/Specification",
                            "LimitacoesObservacoes": "Limitations/Observations",
                            "Acfts": "Acfts.",
                            "Eng": "Eng.",
                            "Comp": "Comp."
                        },
                        "designacoesComProdutoEspecificacaoEscritosManualmente": "Handwritten product/specification designations",
                        "tituloRazaoDeAberturaDaRevisao": "Reason for opening the review",
                        "tituloRazaoNaoDisponivel": "Reason not available",
                        "tituloHabilitacoesDesignadasDestaRevisao": "Designated Qualifications of this revision",
                        "nenhumaHabilitacaoCadastrada": "No registration registered.",
                        "tabelaHabilitacoesDesignadasDestaRevisao": {
                            "Nome": "Name",
                            "Expiração": "Expiration"
                        },
                        "tituloTarefasDesignadasDestaRevisao": "Assigned tasks of this review",
                        "nenhumaTarefaCadastrada": "No tasks registered.",
                        "tabelaTarefasDesignadasDestaRevisao": {
                            "Nome": "Name",
                            "Expiracao": "Expiration"
                        },
                        "tituloFrotasDesignadasDestaRevisao": "Designated fleets of this review",
                        "nenhumaFrotaCadastrada": "No fleet registered.",
                        "tabelaFrotasDesignadasDestaRevisao": {
                            "Nome": "Name",
                            "Expiracao": "Expiration"
                        },
                        "tituloLogDeAcoesManuaisDestaRevisao": "Log of manual actions for this revision",
                        "nenhumaAcaoCadastrada": "No action registered.",
                        "tabelaLogDeAcoesManuaisDestaRevisao": {
                            "Acao": "Action",
                            "Tipo": "Type",
                            "Usuario": "User",
                            "Data": "Date"
                        },
                        "osColaboradorNaoPossuiOsCertificadosListadosAbaixo": "Employees do not have the certificates listed below, required for this designation item"
                    }
                },
                "tabExperienciaProfissional": {
                    "tituloTab": "Professional experience",
                    "titutloExperienciaProfissional": "Professional experience",
                    "nenhumaExperienciaProfissionalCadastrada": "No registered professional experience.",
                    "tabela": {
                        "DataInicial": "Initial date",
                        "DataFinal": "Final date",
                        "Empresa": "Company",
                        "Funcao": "Occupation",
                        "Status": "Status",
                        "Ativo": "Active",
                        "Arquivado": "Filed"
                    }
                },
                "tabProvasDeIdioma": {
                    "tituloTab": "Language tests",
                    "tituloListaDeProvasDeIdioma": "List of Language Tests",
                    "nenhumaProvasDeIdiomaCadastrada": "No language tests registered.",
                    "tabela": {
                        "Coeficiente": "Coefficient",
                        "Idioma": "Language",
                        "Emissao": "Issuance",
                        "Vencimento": "Maturity",
                        "Status": "Status",
                        "Ativo": "Active",
                        "Arquivado": "Filed"
                    }
                },
                "tabFerias": {
                    "tituloTab": "Vacation",
                    "tituloFerias": "Vacation",
                    "nenhumaFeriasCadastrada": "No holidays registered.",
                    "tabela": {
                        "DataInicial": "Initial date",
                        "DataFinal": "Final date",
                        "DireitoAFerias": "Right to vacation",
                        "VencimentoDeFerias": "Vacation expiration",
                        "Status": "Status",
                        "Ativo": "Active",
                        "Arquivado": "Filed"
                    }
                },
                "tabFuncoes": {
                    "tituloTab": "Functions",
                    "tituloFuncoes": "Functions",
                    "nenhumaFuncaoCadastrada": "No function registered.",
                    "tabela": {
                        "DataInicial": "Initial date",
                        "Funcao": "Occupation",
                        "Status": "Status",
                        "Ativo": "Active",
                        "Arquivado": "Filed"
                    }
                },
                "tabBases": {
                    "tituloTab": "Bases",
                    "tituloBases": "Bases",
                    "nenhumaBaseCadastrada": "No base registered.",
                    "tabela": {
                        "DataInicial": "Initial date",
                        "Base": "Base",
                        "Status": "Status",
                        "Ativo": "Active",
                        "Arquivado": "Filed"
                    }
                },
                "tabNiveisDeCargos": {
                    "tituloTab": "Job levels",
                    "tituloNiveisDeCargos": "Job levels",
                    "nenhumaAeronaveCadastrada": "No aircraft registered.",
                    "tabela": {
                        "DataDeAlteracao": "Date of change",
                        "Nivel": "Level",
                        "Motivo": "Reason"
                    }
                },
                "tabCargos": {
                    "tituloTab": "Roles",
                    "tituloCargos": "Roles",
                    "nenhumCargoCadastrado": "No jobs registered.",
                    "tabela": {
                        "DataInicial": "Initial date",
                        "Cargo": "Role",
                        "CodRubi": "Code Ruby",
                        "Status": "Status",
                        "Ativo": "Active",
                        "Arquivado": "Filed"
                    }
                },
                "tabCarimbos": {
                    "tituloTab": "Stamps",
                    "opcoesCarimbo": {
                        "Circulo": "Circle",
                        "Triangulo": "Triangle",
                        "Quadrado": "Square",
                        "Pentagono": "Pentagon",
                        "Hexagono": "Hexagon"
                    },
                    "tituloCarimbos": "Stamps",
                    "nenhumCarimboCadastrado": "No stamp registered.",
                    "tabela": {
                        "DataDeEmissao": "Date of issue",
                        "Funcao": "Occupation",
                        "TipoDeCarimbo": "Stamp type",
                        "Numero": "Number",
                        "Revisao": "Revision",
                        "Observacao": "Observation",
                        "Status": "Status",
                        "Ativo": "Active",
                        "Arquivado": "Filed"
                    }
                },
                "tabTreinamentos": {
                    "tituloTab": "Trainings",
                    "tituloCertificados": "Certificates",
                    "nenhumCertificadoCadastrado": "No registered certificate",
                    "tabela": {
                        "ID": "ID",
                        "Tipo": "Type",
                        "Fim": "End",
                        "Vencimento": "Maturity",
                        "Val": "Val.",
                        "Status": "Status",
                        "Ações": "Actions",
                        "Ativo": "Active",
                        "Arquivado": "Filed"
                    }
                },
                "tabNecessidadeDeTreinamentos": {
                    "tituloTab": "Training needs",
                    "tituloAvaliacaoDeNecessidadeDeTreinamento": "Training need assessment",
                    "naoHaFormulariosDeAvaliacao": "There are no training need assessment forms for this employee.",
                    "tabela": {
                        "Data": "Date",
                        "MotivoDaAnalise": "Reason for analysis",
                        "OutrasAtividades": "Other activities",
                        "Acoes": "Actions"
                    },
                    "tituloAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo": "Training need assessment - OLD MODEL",
                    "tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo": {
                        "Conhecimento": "Knowledge",
                        "OutrasAtividades": "Other activities",
                        "Data": "Date",
                        "Acoes": "Actions",
                        "ConhecimentoETreinamento": "Knowledge and Training",
                        "Experiencia": "Experience",
                        "Oficina": "Workshop",
                        "Aeronaves": "Aircraft",
                        "Motores": "Engines",
                        "Inspecao": "Inspection",
                        "Instrucao": "Instruction",
                        "Criacao": "Creation"
                    },
                    "deletarItem": "Are you sure you would like to delete this item?",
                    "tituloEditarNecessidadeDeTreinamento": "Edit training need",
                    "formularioEditarNecessidadeDeTreinamento": {
                        "Data": "Date",
                        "MotivoDaAnalise": "Reason for analysis",
                        "opcoesMotivoDaAnalise": {
                            "ContratacaoDoColaborador": "Employee Hiring",
                            "NovaFuncaoDoColaborador": "New Employee Role",
                            "PromocaoDoColaborador": "Employee Promotion",
                            "Outro": "Other"
                        },
                        "PreenchaOMotivo": "Fill in the reason",
                        "OutrasAtividades": "Other activities",
                        "tituloProcedimentosInternos": "Internal procedures",
                        "Integracao": "Integration",
                        "Geral": "General",
                        "SUP": "SUP",
                        "FER": "FER",
                        "MNT": "MNT",
                        "ENG": "ENG",
                        "CTM": "CTM",
                        "SASC": "CASS",
                        "QUA": "WED",
                        "Inspetores": "Inspectors",
                        "Rampa": "Ramp",
                        "tituloApoio": "Support",
                        "Corrosao": "Corrosion",
                        "PBN": "PBN",
                        "HUMSNivel1": "HUMS Level 1",
                        "HUMSNivel2": "HUMS Level 2",
                        "Ingles": "English",
                        "Boroscopia": "Boroscopy",
                        "FatoresHumanos": "Human Factors",
                        "Orientacao": "Guidance",
                        "Pedagogica": "Pedagogical",
                        "ArtigosPerigosos": "Dangerous Goods",
                        "EOS": "EOS"
                    },
                    "tituloTreinamentosDeProdutos": "Product training",
                    "tabelaTreinamentosDeProdutos": {
                        "Aeronaves": "Aircraft",
                        "Motores": "Engines",
                        "Oficinas": "Workshops"
                    },
                    "tituloConhecimentoTreinamentoEExperienciaAnterior": "Knowledge, Training and Previous Experience",
                    "tabelaConhecimentoTreinamentoEExperienciaAnterior": {
                        "Descricao": "Description",
                        "Organizacao": "Organization",
                        "Periodo": "Time course"
                    }
                },
                "tabColaboradorReferencia": {
                    "tituloTab": "Reference employee",
                    "tituloReferencias": "References",
                    "nenhumaReferenciaCadastrada": "No reference registered.",
                    "tabela": {
                        "Aeronave": "Aircraft",
                        "Referencia": "Reference",
                        "Status": "Status",
                        "Ativo": "Active",
                        "Arquivado": "Filed"
                    }
                },
                "tabAfastamentos": {
                    "tituloTab": "Removals",
                    "tituloAfastamento": "Removal",
                    "nenhumaAfastamentoCadastrada": "No recorded leave.",
                    "tabela": {
                        "DataInicial": "Initial date",
                        "DataFinal": "Final date",
                        "Motivo": "Reason"
                    }
                },
                "tabRegimeDeTrabalho": {
                    "tituloTab": "Work regime",
                    "tituloRegimeDeTrabalho": "Work regime",
                    "nenhumRegimeCadastrado": "No regime registered.",
                    "tabela": {
                        "Tipo": "Type",
                        "DataInicial": "Initial date",
                        "Status": "Status",
                        "Ativo": "Active",
                        "Arquivado": "Filed"
                    }
                },
                "tabFormacaoAcademica": {
                    "tituloTab": "Academic education",
                    "opcoesTipoDeFormacao": {
                        "SelecionarTipo": "Select type",
                        "PrimeiroGrau": "1st grade",
                        "SegundoGrau": "2nd degree",
                        "EnsinoSuperior": "University education",
                        "PosGraduacao": "Postgraduate",
                        "MMA": "MMA"
                    },
                    "tituloFormacaoAcademica": "Academic education",
                    "nenhumaFormacaoCadastrada": "No training registered.",
                    "tabela": {
                        "Tipo": "Type",
                        "NomeDoCurso": "Course name",
                        "Instituicao": "Institution",
                        "DataDeConclusao": "Date of the conclusion",
                        "Status": "Status",
                        "Ativo": "Active",
                        "Arquivado": "Filed"
                    }
                },
                "tabBaseContratual": {
                    "tituloTab": "Contract Base",
                    "tituloBases": "Bases",
                    "nenhumaBaseCadastrada": "No base registered.",
                    "tabela": {
                        "Base": "Base"
                    }
                }
            }
        },
        "ColaboradoresSigtrip": {
            "ComunicadosDeTreinamentos": {
                "botaoExportar": {
                    "Exportar": "Export",
                    "Solo": "Ground",
                    "SoloTIC": "ICT floor",
                    "Simulador": "Simulator",
                    "EAD": "EAD"
                },
                "titulo": "Training Announcements",
                "tabela": {
                    "semTreinamentos": "There are no registered trainings",
                    "ID": "ID",
                    "Nome": "Name",
                    "Status": "Status",
                    "CodigoDeControle": "Control code",
                    "TiposDeCertificado": "Certificate types",
                    "Modalidade": "Modality",
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "Acoes": "Actions"
                }
            },
            "DocumentosPendentesDeConhecimento": {
                "deletarPapeleta": "Are you sure you would like to delete this pilot logbook?",
                "titulo": "Pending knowledge documents",
                "tituloAListaDeDocumentosPendentesEOriundaDoQPulse": "The list of pending documents comes from Q-Pulse and is updated once a day at 05:00",
                "tabela": {
                    "semDocumentosPendentes": "There are no documents pending knowledge",
                    "ID": "ID",
                    "Matricula": "Registration",
                    "Nome": "Name",
                    "Documentos": "Documents"
                }
            },
            "ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia": {
                "botaoConfirmarPresenca": "RSVP",
                "botaoConfirmarAusencia": "Confirm absence",
                "titulo": "Communications of training pending confirmation of presence/absence",
                "tabela": {
                    "semTreinamentos": "There are no trainings pending confirmation",
                    "ID": "ID",
                    "Nome": "Name",
                    "Status": "Status",
                    "CodigoDeControle": "Control code",
                    "TiposDeCertificado": "Certificate types",
                    "Modalidade": "Modality",
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "Acoes": "Actions"
                }
            },
            "EscalasPendentesDeConhecimento": {
                "botaoRevisao": "Revision",
                "titulo": "Outstanding schedules of knowledge",
                "tabela": {
                    "semEscalas": "No pending schedules of knowledge",
                    "ID": "ID",
                    "Mes": "Month",
                    "Base": "Base",
                    "Frota": "Fleet",
                    "Revisao": "Revision",
                    "Status": "Status",
                    "Acoes": "Actions"
                }
            },
            "PapeletasPendentesDeAprovacao": {
                "titulo": "Papers pending approval",
                "tabela": {
                    "semPapeletas": "There are no papers pending approval",
                    "ID": "ID",
                    "Nome": "Name",
                    "Matricula": "Registration",
                    "Referencia": "Reference",
                    "Status": "Status",
                    "Acoes": "Actions"
                }
            },
            "RelatoriosPendentesDeAprovacao": {
                "titulo": "Reports pending approval",
                "tabela": {
                    "semRelatorios": "There are no reports pending approval",
                    "ID": "ID",
                    "Base": "Base",
                    "Data": "Date",
                    "Aeronave": "Aircraft",
                    "Frota": "Fleet",
                    "Cliente": "Client",
                    "TipoDeVoo": "Type of flight",
                    "NumeroDoRelatorio": "Report number",
                    "NumeroDoVoo": "Flight number",
                    "Status": "Status",
                    "Acoes": "Actions"
                }
            },
            "EditarFuncionario": {
                "titulo": "Employee edit",
                "tabDadosDoFuncionario": {
                    "tituloTab": "Employee data",
                    "formulario": {
                        "tituloInformacoesPessoais": "Personal information",
                        "Nome": "Name",
                        "Apelido": "Surname",
                        "Telefone1": "Phone 1",
                        "Telefone2": "Phone 2",
                        "EstadoCivil": "Marital status",
                        "Email": "Email",
                        "Naturalidade": "Naturalness",
                        "Escolaridade": "Education",
                        "NomeDaMae": "Mother's name",
                        "NomeDoPai": "Father's name",
                        "Raca": "Race",
                        "DataDeNascimento": "Birth date",
                        "tituloEndereco": "Address",
                        "Endereco": "Address",
                        "Numero": "Number",
                        "Complemento": "Complement",
                        "Bairro": "Neighborhood",
                        "Cidade": "City",
                        "Estado": "State",
                        "Pais": "Country",
                        "CEP": "Zip code",
                        "CPF": "CPF",
                        "Identidade": "Identity",
                        "IdentidadeUF": "Identity - State",
                        "IdentidadeDataDeExpedicao": "Identity - date of issue",
                        "IdentidadeOrgaoExpeditor": "Identity - issuing body",
                        "PIS": "PIS",
                        "ConfidenceUS": "US Confidence",
                        "ExpiracaoConfidenceUS": "US confidence expiration",
                        "ConfidenceEU": "Confidence EU",
                        "ExpiracaoConfidenceEU": "EU confidence expiry",
                        "CTPS": "CTPS",
                        "CTPSNumeroDeSerie": "CTPS - Serial No.",
                        "CTPSExpedicao": "CTPS expedition",
                        "CTPSUF": "CTPS State",
                        "TipoSanguineo": "Blood type",
                        "Matricula": "Registration",
                        "SISPAT": "SISPAT",
                        "CANAC": "CANAC",
                        "Licenca": "License",
                        "Contratacao": "Hiring",
                        "CargoDeAdmissao": "Admission position",
                        "CargoAtual": "Current Position",
                        "EstadoDeNascimento": "Birth state",
                        "CidadeDeNascimento": "City of birth",
                        "PaisDeNascimento": "Country of birth",
                        "ASO": "ASO",
                        "Eletrocardiograma": "Electrocardiogram",
                        "CodigoSapiens": "Sapiens Code"
                    }
                },
                "tabAdministrativo": {
                    "tituloTab": "Administrative",
                    "tituloAdicionarArquivos": "Add files",
                    "tabela": {
                        "semArquivos": "There are no registered files",
                        "NomeDoArquivo": "File name",
                        "Tipo": "Type",
                        "Validade": "Shelf life"
                    }
                },
                "tabHorasDeVoo": {
                    "tituloTab": "Flight hours",
                    "tituloTotaisDeHoras": "Total hours",
                    "tabelaTotaisDeHoras": {
                        "semAeronaves": "There are no registered aircraft",
                        "ID": "ID",
                        "Modelo": "Model",
                        "FB": "FB",
                        "Total": "Total",
                        "IFR": "IFR.",
                        "Noturno": "Night",
                        "APP": "APP",
                        "Diurno": "Diurnal"
                    },
                    "tabelaArquivos": {
                        "semArquivos": "There are no registered files",
                        "NomeDoArquivo": "File name",
                        "Validade": "Shelf life"
                    }
                },
                "tabHabilitacoes": {
                    "tituloTab": "Qualifications",
                    "opcoesCodigoDeHabilitacao": {
                        "CCF": "CCF",
                        "CHT": "CHT"
                    },
                    "opcoesHabilitacao": {
                        "SelecionarTipo": "Select type",
                        "IFRH": "IFRH"
                    },
                    "tituloHabilitacoes": "Qualifications",
                    "botaoEsconderArquivoMorto": "Hide archive",
                    "botaoMostrarArquivoMorto": "Show archive",
                    "nenhumaHabilitacaoCadastrada": "No registration registered.",
                    "tabela": {
                        "Codigo": "Code",
                        "Frota": "Fleet",
                        "Tipo": "Type",
                        "CANAC": "CANAC",
                        "Licenca": "License",
                        "Vencimento": "Maturity",
                        "Status": "Status",
                        "Ativo": "Active",
                        "Arquivado": "Filed"
                    }
                },
                "tabProcessos": {
                    "tituloTab": "Law Suit",
                    "tituloProcessos": "Law Suit",
                    "tabela": {
                        "semArquivosDeProcessos": "No process files",
                        "Frota": "Fleet",
                        "Processo": "Process",
                        "Subtipo": "Subtype",
                        "DataDeEmissao": "Date of issue",
                        "Validade": "Shelf life"
                    }
                },
                "tabCertificacoes": {
                    "tituloTab": "Certifications",
                    "tituloCertificados": "Certificates",
                    "nenhumCertificadoCadastrado": "No registered certificate.",
                    "tabela": {
                        "NomeDoCertificado": "Certificate name",
                        "Inicio": "Start",
                        "Fim": "End",
                        "Vencimento": "Maturity",
                        "Status": "Status",
                        "Arquivo": "Archive",
                        "Ativo": "Active",
                        "Arquivado": "Filed"
                    }
                },
                "tabAvaliacoes": {
                    "tituloTab": "Assessments",
                    "tituloAvaliacoes": "Assessments",
                    "nenhumCertificadoCadastrado": "No registered certificate.",
                    "tabela": {
                        "NomeDoCertificado": "Certificate name",
                        "Inicio": "Start",
                        "Fim": "End",
                        "Vencimento": "Maturity",
                        "Status": "Status",
                        "Arquivo": "Archive",
                        "Ativo": "Active",
                        "Arquivado": "Filed"
                    }
                },
                "tabCargos": {
                    "tituloTab": "Roles",
                    "tituloCargos": "Roles",
                    "nenhumCargoCadastrado": "No jobs registered.",
                    "tabela": {
                        "Cargo": "Role",
                        "CodigoRubi": "Code Ruby",
                        "Status": "Status",
                        "Data": "Date",
                        "Ativo": "Active",
                        "Arquivado": "Filed"
                    }
                },
                "tabDesignacoes": {
                    "tituloTab": "Designations",
                    "tituloDesignacoes": "Designations",
                    "nenhumaDesignacaoCadastrada": "No designation registered.",
                    "tabela": {
                        "Designacao": "Designation",
                        "Frota": "Fleet",
                        "Status": "Status",
                        "Data": "Date",
                        "Ativo": "Active",
                        "Arquivado": "Filed"
                    }
                },
                "tabIndicacoes": {
                    "tituloTab": "Indications",
                    "tituloIndicacao": "Recommendation",
                    "nenhumaIndicacaoCadastrada": "No indication registered.",
                    "tabela": {
                        "Designacao": "Designation",
                        "Frota": "Fleet",
                        "Status": "Status",
                        "Data": "Date",
                        "Ativo": "Active",
                        "Arquivado": "Filed"
                    }
                },
                "tabRegimes": {
                    "tituloTab": "Regimes",
                    "tituloRegimes": "Regimes",
                    "nenhumRegimeCadastrado": "No regime registered.",
                    "tabela": {
                        "Regime": "Regime",
                        "Data": "Date",
                        "Mes": "Month",
                        "Ano": "Year",
                        "Status": "Status",
                        "Ativo": "Active",
                        "Arquivado": "Filed"
                    }
                },
                "tabGratificacoes": {
                    "tituloTab": "Gratuities",
                    "tituloGratificacoes": "Gratuities",
                    "nenhumaGratificacaoCadastrada": "No bonus registered.",
                    "tabela": {
                        "Gratificacao": "Gratification",
                        "Data": "Date",
                        "Status": "Status",
                        "Ativo": "Active",
                        "Arquivado": "Filed"
                    }
                },
                "tabAprovacoes": {
                    "tituloTab": "Approvals",
                    "tituloAprovacoesDeClientes": "Customer Approvals",
                    "nenhumaAprovacaoCadastrada": "No registered approval.",
                    "tabela": {
                        "Client": "Client",
                        "Grupo": "Group",
                        "Funcao": "Occupation",
                        "Aeronaves": "Aircraft"
                    }
                },
                "tabICAO": {
                    "tituloTab": "ICAO",
                    "tituloICAOS": "ICAOS",
                    "nenhumICAOCadastrado": "No ICAO registered.",
                    "tabela": {
                        "Level": "Level",
                        "Vencimento": "Maturity",
                        "DataDeInsercao": "Insertion Date",
                        "Status": "Status",
                        "Ativo": "Active",
                        "Arquivado": "Filed"
                    }
                },
                "tabBaseContratual": {
                    "tituloTab": "Contractual base",
                    "tituloBases": "Bases",
                    "nenhumaBaseCadastrada": "No base registered.",
                    "tabela": {
                        "Base": "Base",
                        "Status": "Status",
                        "Ativo": "Active",
                        "Arquivado": "Filed"
                    }
                }
            }
        },
        "Papeletas": {
            "ListaDePapeletas": {
                "deletar": "Are you sure you would like to delete this pilot logbook?",
                "botaoAprovarSelecionados": "Approve Selected",
                "titulo": "List of pilot logbooks",
                "tabela": {
                    "semPapeletasPendentes": "There are no outstanding papers",
                    "ID": "ID",
                    "Nome": "Name",
                    "Matricula": "Registration",
                    "Referencia": "Reference",
                    "Status": "Status",
                    "Acoes": "Actions"
                }
            },
            "AdicionarPapeleta": {
                "titulo": "Register pilot logbook",
                "formulario": {
                    "MesAno": "Month year",
                    "Tripulante": "Crew member"
                }
            },
            "EditarPapeleta": {
                "aguardeEnquantoOArquivoEGerado": "Wait while the file is generated. This process can take a few minutes.",
                "atualizarAsInformacoes": "Are you sure you want to update the information? Changes made in the FIRA will be lost.",
                "titulo": "Slip editing",
                "botaoAtualizar": "To update",
                "botaoAlertas": "Alerts",
                "tituloPendencias": "Pendencies",
                "tabelaPendencias": {
                    "Data": "Date",
                    "Localidades": "Places",
                    "Situacao": "Situation",
                    "Horarios": "Schedules",
                    "Totais": "Totals",
                    "Apresentacao": "Presentation",
                    "Liberacao": "Release",
                    "InicioDaRefeicao": "Start of Meal",
                    "TerminoDaRefeicao": "End of Meal",
                    "InicioDaSegundaRefeicao": "Beginning of the Second Meal",
                    "TerminoDaSegundaRefeicao": "End of the Second Meal",
                    "HorasDeJornada": "Working hours",
                    "VooNoturno": "Night flight",
                    "VooTotal": "Total Flight",
                    "AtualizarAsInformacoesDestaDataDeAcordoComAPendencia": "Are you sure you want to update the information for this date according to the issue? Changes made to the FIRA on this date will be lost.",
                    "tituloInterrupcoes": "Interruptions",
                    "tabelaInterrupcoes": {
                        "Inicio": "Start",
                        "Fim": "End",
                        "Total": "Total"
                    },
                    "tituloEquipamentos": "Equipment",
                    "tabelaEquipamentos": {
                        "Frota": "Fleet"
                    }
                },
                "tituloPapeleta": "Slip",
                "tabelaPapeleta": {
                    "Data": "Date",
                    "Localidades": "Places",
                    "Situacao": "Situation",
                    "Horarios": "Schedules",
                    "Totais": "Totals",
                    "Apresentacao": "Presentation",
                    "Liberacao": "Release",
                    "ApresentacaoData": "Presentation date",
                    "ApresentacaoHora": "Presentation time",
                    "InicioDaRefeicaoData": "Meal start date",
                    "InicioDaRefeicaoHora": "Meal start time",
                    "TerminoDaRefeicaoData": "End of Meal date",
                    "TerminoDaRefeicaoHora": "Meal end time",
                    "InicioDaSegundaRefeicaoData": "Start of Second Meal date",
                    "InicioDaSegundaRefeicaoHora": "Start of Second Meal time",
                    "TerminoDaSegundaRefeicaoData": "End of Second Meal date",
                    "TerminoDaSegundaRefeicaoHora": "End of Second Meal hour",
                    "LiberacaoData": "Release date",
                    "Liberacaohora": "Release time",
                    "HorasDeJornada": "Working hours",
                    "VooNoturno": "Night flight",
                    "VooTotal": "Total Flight",
                    "DeletarFrota": "Are you sure you want to delete this fleet?",
                    "DeletarInterrupcao": "Are you sure you want to delete this interrupt?",
                    "AtualizarInformacoesDestaData": "Are you sure you want to update the information for this date? Changes made to the FIRA on this date will be lost.",
                    "placeholder": {
                        "SelecionarSituacao": "Select situation"
                    },
                    "tituloInterrupcoes": "Interruptions",
                    "formularioInterrupcoes": {
                        "InicioDaInterrupcao": "Start of interruption",
                        "FimDaInterrupcao": "End of interruption",
                        "botaoAdicionarInterrupcao": "Add interrupt"
                    },
                    "tabelaInterrupcoes": {
                        "Inicio": "Start",
                        "Fim": "End",
                        "Total": "Total",
                        "Acoes": "Actions"
                    },
                    "tituloEquipamentos": "Equipment",
                    "formularioEquipamentos": {
                        "botaoAdicionarFrota": "Add fleet",
                        "placeholder": {
                            "SelecionarFrota": "Select fleet"
                        }
                    },
                    "tabelaEquipamentos": {
                        "Frota": "Fleet",
                        "Acoes": "Actions"
                    }
                },
                "tituloAlertasDoRelatorio": "Report alerts",
                "tabelaAlertasDoRelatorio": {
                    "Mensagem": "Message"
                },
                "tituloAlertas": "Alerts",
                "trocarStatus": "Are you sure you want to change the pilot logbook status?",
                "reabrir": "Are you sure you want to reopen the pilot logbook?",
                "botaoForcarAprovacao": "Force Approval",
                "botaoAprovacaoTripulante": "Approval - Crew",
                "botaoAprovacaoGestor": "Approval - Manager",
                "botaoReabrirPapeleta": "Reopen pilot logbook",
                "botaoPapeletaAprovada": "Approved pilot logbook",
                "erros": "The following filling errors on the indicated days prevented the pilot logbook from being finalized",
                "tituloLogDeAprovacoes": "Approvals log",
                "tabelaLogDeAprovacoes": {
                    "Usuario": "User",
                    "Acao": "Action",
                    "Data": "Date"
                },
                "tituloFIRA": "FIRA",
                "botaoReprovacaoGestor": "Failure - Manager"
            },
            "ListaDePapeletasFinalizadas": {
                "deletar": "Are you sure you would like to delete this pilot logbook?",
                "titulo": "List of completed papers",
                "tabela": {
                    "semPapeletasPendentes": "There are no outstanding papers",
                    "ID": "ID",
                    "Nome": "Name",
                    "Matricula": "Registration",
                    "Referencia": "Reference",
                    "Acoes": "Actions"
                }
            },
            "ListaDePapeletasPendentesGestor": {
                "deletar": "Are you sure you would like to delete this pilot logbook?",
                "titulo": "List of pending pilot logbooks - Manager",
                "tabela": {
                    "semPapeletasPendentes": "There are no outstanding papers",
                    "ID": "ID",
                    "Nome": "Name",
                    "Matricula": "Registration",
                    "Referencia": "Reference",
                    "Acoes": "Actions"
                }
            },
            "ListaDePapeletasPendentesTripulantes": {
                "deletar": "Are you sure you would like to delete this pilot logbook?",
                "titulo": "List of pending pilot logbooks - Crew",
                "tabela": {
                    "semPapeletasPendentes": "There are no outstanding papers",
                    "ID": "ID",
                    "Nome": "Name",
                    "Matricula": "Registration",
                    "Referencia": "Reference",
                    "Acoes": "Actions"
                }
            },
            "ControleDePapeletas": {
                "titulo": "Control of pilot logbooks",
                "formulario": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "Nome": "Name",
                    "placeholder": {
                        "SelecionarTripulantes": "Select crew"
                    }
                },
                "tabela": {
                    "Tripulante": "Crew member",
                    "SomaDeHorasDeJornada": "Sum of Working Hours",
                    "SomaDeHorasDeVooNoturno": "Sum of Night Flight Hours",
                    "SomaDeHorasDeVooTotal": "Sum of Total Flight Hours"
                }
            },
            "ConsultaDePapeletas": {
                "titulo": "Consultation of pilot logbooks",
                "formulario": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date"
                },
                "tabela": {
                    "MesAno": "Month year",
                    "Alertas": "Alerts",
                    "Acoes": "Actions"
                }
            },
            "ConsultaDePapeletasGestores": {
                "aguardeEnquantoOArquivoEGerado": "Wait while the file is generated. This process can take a few minutes.",
                "titulo": "Consultation of pilot logbooks - Managers",
                "formulario": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "Tripulante": "Crew member",
                    "ExibirDesligados": "Show off",
                    "SomenteComAlertas": "Only with alerts"
                },
                "tabela": {
                    "Tripulante": "Crew member",
                    "MesAno": "Month year",
                    "Alertas": "Alerts",
                    "Acoes": "Actions"
                }
            }
        },
        "RelatoriosDeFadiga": {
            "ListaDeRelatoriosDeFadigas": {
                "botaoAdicionarRelatorioDeFadiga": "Add Fatigue Report",
                "titulo": "Fatigue report list",
                "tabela": {
                    "semParametroDeFadiga": "There are no registered fatigue parameters",
                    "Data": "Date",
                    "Revisao": "Revision",
                    "Tripulante": "Crew member",
                    "Folga": "Day off",
                    "QuantidadeDePontosAtual": "Current amount of points",
                    "QuantidadeDePontosReportados": "Number of points reported",
                    "Acoes": "Actions"
                }
            },
            "AdicionarRelatorioDeFadiga": {
                noParametroAPontuacaoMaximaFoiUltrapassada: function noParametroAPontuacaoMaximaFoiUltrapassada(name) {
                    return "In the parameter " + name + " the maximum score was exceeded, confirm sending the report?";
                },
                noParametroAPontuacaoMinimaNaoFoiAtingida: function noParametroAPontuacaoMinimaNaoFoiAtingida(name) {
                    return "In parameter " + name + " the minimum score was not reached, confirm sending the report?";
                },

                "titulo": "Register fatigue report",
                "formulario": {
                    "Data": "Date",
                    "Bases": "Bases",
                    "botaoAdicionarRelatorioDeFadiga": "Add Fatigue Report",
                    "placeholder": {
                        "SelecionarBase": "Select base",
                        "SelecionarOpcao": "Select option",
                        "Horas": "Hours",
                        "Quantidade": "The amount"
                    }
                }
            },
            "EditarRelatorioDeFadiga": {
                noParametroAPontuacaoMaximaFoiUltrapassada: function noParametroAPontuacaoMaximaFoiUltrapassada(name) {
                    return "In the parameter " + name + " the maximum score was exceeded, confirm sending the report?";
                },
                noParametroAPontuacaoMinimaNaoFoiAtingida: function noParametroAPontuacaoMinimaNaoFoiAtingida(name) {
                    return "In parameter " + name + " the minimum score was not reached, confirm sending the report?";
                },

                "titulo": "Fatigue Report Editing - Review",
                "paragrafoStatusDaRevisao": "Review status",
                "paragrafoQuantidadeDePontosAtual": "Current amount of points",
                "paragrafoQuantidadeDePontosReportados": "Number of points reported",
                "tabRevisao": {
                    "tituloTab": "Revision",
                    "paragrafoStatusDaRevisao": "Review status",
                    "paragrafoQuantidadeDePontosAtual": "Current amount of points",
                    "paragrafoQuantidadeDePontosReportados": "Number of points reported"
                },
                "tituloCriarRevisao": "Create review",
                "formularioCriarRevisao": {
                    "botaoCriarRevisaoDeRelatorioDeFadiga": "Create fatigue report review",
                    "placeholder": {
                        "SelecionarOpcao": "Select option",
                        "Horas": "Hours",
                        "Quantidade": "The amount"
                    }
                }
            },
            "EditarRelatorioDeFadigaAdministrador": {
                noParametroAPontuacaoMaximaFoiUltrapassada: function noParametroAPontuacaoMaximaFoiUltrapassada(name) {
                    return "In the parameter " + name + " the maximum score was exceeded, confirm sending the report?";
                },
                noParametroAPontuacaoMinimaNaoFoiAtingida: function noParametroAPontuacaoMinimaNaoFoiAtingida(name) {
                    return "In parameter " + name + " the minimum score was not reached, confirm sending the report?";
                },


                "titulo": "Fatigue Report Editing - Review",
                "paragrafoStatusDaRevisao": "Review status",
                "paragrafoQuantidadeDePontosAtual": "Current amount of points",
                "paragrafoQuantidadeDePontosReportados": "Number of points reported",
                "tabRevisao": {
                    "tituloTab": "Revision",
                    "paragrafoStatusDaRevisao": "Review status",
                    "paragrafoQuantidadeDePontosAtual": "Current amount of points",
                    "paragrafoQuantidadeDePontosReportados": "Number of points reported"
                },
                "tituloCriarRevisao": "Create review",
                "formularioCriarRevisao": {
                    "botaoCriarRevisaoDeRelatorioDeFadiga": "Create fatigue report review",
                    "placeholder": {
                        "SelecionarOpcao": "Select option",
                        "Horas": "Hours",
                        "Quantidade": "The amount"
                    }
                }
            },
            "AdicionarRelatorioDeFadigaAdministrador": {
                noParametroAPontuacaoMaximaFoiUltrapassada: function noParametroAPontuacaoMaximaFoiUltrapassada(name) {
                    return "In the parameter " + name + " the maximum score was exceeded, confirm sending the report?";
                },
                noParametroAPontuacaoMinimaNaoFoiAtingida: function noParametroAPontuacaoMinimaNaoFoiAtingida(name) {
                    return "In parameter " + name + " the minimum score was not reached, confirm sending the report?";
                },


                "titulo": "Register fatigue report",
                "formulario": {
                    "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                    "Tripulantes135": "Crew - 135",
                    "Tripulantes121": "Crew - 121",
                    "Mecanicos": "Mechanics",
                    "Coordenadores": "Coordinators",
                    "Data": "Date",
                    "Bases": "Bases",
                    "botaoAdicionarRelatorioDeFadiga": "Add Fatigue Report",
                    "placeholder": {
                        "SelecionarAplicabilidade": "Select applicability",
                        "SelecionarTripulante": "Select crew member",
                        "SelecionarMecanico": "Select mechanic",
                        "SelecionarCoordenador": "Select coordinator",
                        "SelecionarBase": "Select base",
                        "SelecionarOpcao": "Select option",
                        "Horas": "Hours",
                        "Quantidade": "The amount"
                    }
                }
            },
            "EditarParametroDeFadiga": {
                "deletar": "Are you sure you would like to delete this option?",
                "titulo": "Edit Fatigue Parameter",
                "formulario": {
                    "Nome": "Name",
                    "Tipo": "Type",
                    "Operador": "Operator",
                    "PontosPorHora": "Points per hour",
                    "PontosPorQuantidade": "Points per quantity",
                    "LimiteDePontos": "Point limit",
                    "placeholder": {
                        "NomeDoParametroDeFadiga": "Fatigue parameter name",
                        "SelecionarCliente": "Select customer",
                        "QuantidadeDePontosPorHora": "Number of points per hour",
                        "QuantidadeDePontosPorQuantidade": "Number of points per amount"
                    }
                },
                "tituloAdicionarOpcoes": "Add options",
                "formularioAdicionarOpcoes": {
                    "Nome": "Name",
                    "Pontos": "Spots",
                    "placeholder": {
                        "NomeDoParametroDeFadiga": "Fatigue parameter name",
                        "QuantidadeDePontos": "Amount of points"
                    }
                },
                "tituloOpcoes": "Options",
                "tabelaOpcoes": {
                    "Opcao": "Option",
                    "Pontos": "Spots",
                    "Acoes": "Actions"
                }
            },
            "SimuladorDeRelatoriosDeFadiga": {
                "titulo": "Fatigue report simulator",
                "formulario": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                    "QuantidadeDePontos": "Amount of points",
                    "botaoGerarSimulacaoDeRelatoriosDeFadiga": "Generate simulation of fatigue reports",
                    "placeholder": {
                        "SelecionarAplicabilidade": "Select applicability"
                    }
                },
                "tabDatas": {
                    "botaoGerarRelatoriosDeFadiga": "Generate fatigue reports",
                    "botaoCopiarParaProximasDatas": "Copy to next dates",
                    "formulario": {
                        "MarcarComoFolga": "Mark as day off",
                        "Data": "Date",
                        "placeholder": {
                            "SelecionarOpcao": "Select option",
                            "Horas": "Hours",
                            "Quantidade": "The amount"
                        }
                    }
                },
                "tabela": {
                    "Data": "Date",
                    "Diaria": "Daily",
                    "Acumulada": "Accumulated"
                }
            },
            "RevisarHorariosDePonto": {
                "titulo": "Review point schedules",
                "tituloUtilizeEstaFerramentaParaCorrigirOsReportes": "Use this tool to correct reports according to the point API.",
                "tituloAtencaoCasoOReportNaoExistaDeveraSerCriado": "Attention: If the report does not exist, it must be created manually first.",
                "formulario": {
                    "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                    "Tripulantes135": "Crew - 135",
                    "Tripulantes121": "Crew - 121",
                    "Mecanicos": "Mechanics",
                    "Coordenadores": "Coordinators",
                    "Data": "Date",
                    "botaoRevisarHorarios": "Review schedules",
                    "placeholder": {
                        "SelecionarAplicabilidade": "Select applicability",
                        "SelecionarTripulante": "Select crew member",
                        "SelecionarMecanico": "Select mechanic",
                        "SelecionarCoordenador": "Select coordinator"
                    }
                }
            },
            "FiltroDeRelatorio": {
                "deletar": "Are you sure you'd like to delete this fatigue parameter?",
                "titulo": "Report search",
                "formulario": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                    "Mecanicos": "Mechanics",
                    "Coordenadores": "Coordinators",
                    "Tripulantes": "Crew",
                    "Cargos": "Roles",
                    "Frotas": "Fleets",
                    "Bases": "Bases",
                    "ApenasIncidentesDeFadiga": "Just incidents of fatigue",
                    "botaoProcurarRelatorios": "Browse reports",
                    "placeholder": {
                        "SelecionarAplicabilidade": "Select applicability",
                        "SelecionarMecanicos": "Select Mechanics",
                        "SelecionarCoordenadores": "Select Coordinators",
                        "SelecionarTripulantes": "Select Crew Members",
                        "SelecionarCargos": "Select positions",
                        "SelecionarFrotas": "Select fleets",
                        "SelecionarBases": "Select bases"
                    }
                },
                "tituloListaDeRelatoriosDeFadiga": "Fatigue report list",
                "botaoMostrarEsconderTripulantes": "Show/Hide Crewmates",
                "botaoFiltrarTripulantes": "Filter crew",
                "tabela": {
                    "Nome": "Name",
                    "Pontos": "Spots"
                }
            },
            "RelatorioDeEventosIncidentesDeFadiga": {
                "titulo": "Fatigue Event/Incident Report",
                "formulario": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                    "Mecanicos": "Mechanics",
                    "Coordenadores": "Coordinators",
                    "Tripulantes": "Crew",
                    "TipoDeEventoIncidente": "Type of Event/Incident",
                    "ApenasIncidentesDeFadigaChecados": "Only fatigue incidents checked",
                    "botaoProcurarRelatorios": "Browse reports",
                    "placeholder": {
                        "SelecionarAplicabilidade": "Select applicability",
                        "SelecionarMecanicos": "Select Mechanics",
                        "SelecionarCoordenadores": "Select Coordinators",
                        "SelecionarTripulantes": "Select Crew Members",
                        "SelecionarIncidente": "Select incident"
                    }
                },
                "tituloListaDeEventosIncidentesDeFadiga": "List of fatigue events/incidents",
                "tabela": {
                    "semEventosIncidentesDeFadiga": "There were no fatigue events/incidents in the period",
                    "ID": "ID",
                    "TipoDeEvento": "Kind of event",
                    "Data": "Date",
                    "Revisao": "Revision",
                    "Tripulante": "Crew member",
                    "PontuacaoReportada": "Reported score",
                    "PontuacaoTotal": "Total score",
                    "Checado": "Checked",
                    "DataDaChecagem": "Check Date",
                    "AcaoRealizada": "Action Taken",
                    "Acoes": "Actions"
                },
                "tituloEditarPlanoDeAcao": "Edit action plan",
                "formularioEditarPlanoDeAcao": {
                    "PlanoDeAcao": "Action plan",
                    "botaoEditarPlanoDeAcao": "Edit action plan"
                },
                "marcarEsteIncidenteComoChecado": "Are you sure you want to mark this incident as checked?"
            },
            "PesquisaDeRelatoriosNaoPreenchidos": {
                "titulo": "Search for unfilled reports",
                "formulario": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                    "Bases": "Bases",
                    "IncluirFolgaCadastradaAutomaticamente": "Include automatically registered time off",
                    "botaoProcurarRelatorios": "Browse reports",
                    "placeholder": {
                        "SelecionarAplicabilidade": "Select applicability",
                        "SelecionarBase": "Select base"
                    }
                },
                "tituloListaDeRelatOriosDeFadigasFaltantes": "List of missing fatigue reports",
                "tabela": {
                    "semReportesFaltantes": "There are no missing reports in this period",
                    "Nome": "Name",
                    "Data": "Date",
                    "Situacao": "Situation"
                }
            },
            "PesquisaDeRelatorios": {
                "titulo": "Report search",
                "formulario": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "AplicabilidadeTipoDeColaborador": "Applicability - Type of Employee",
                    "Mecanicos": "Mechanics",
                    "Coordenadores": "Coordinators",
                    "Tripulantes": "Crew",
                    "Cargos": "Roles",
                    "Bases": "Bases",
                    "botaoProcurarRelatarios": "Browse reports",
                    "placeholder": {
                        "SelecionarAplicabilidade": "Select applicability",
                        "SelecionarMecanicos": "Select Mechanics",
                        "SelecionarCoordenadores": "Select Coordinators",
                        "SelecionarTripulantes": "Select Crew Members",
                        "SelecionarCargos": "Select positions",
                        "SelecionarBases": "Select bases"
                    }
                },
                "tituloTotalDoPeriodo": "Period Total",
                "tabelaTotalDoPeriodo": {
                    "semParametrosDeFadiga": "There are no registered fatigue parameters",
                    "NaoFadigados": "Not fatigued",
                    "PontosAzul": "Blue Points",
                    "PontosAmarelo": "Yellow Points",
                    "PontosVermelho": "Red dots"
                },
                "tituloTotalDiario": "Daily Total",
                "tabelaTotalDiario": {
                    "semParametrosDeFadiga": "There are no registered fatigue parameters",
                    "Data": "Date",
                    "NaoFadigados": "Not fatigued",
                    "PontosAzul": "Blue Points",
                    "PontosAmarelo": "Yellow Points",
                    "PontosVermelho": "Red dots"
                },
                "tituloListaDeRelatoriosDeFadigas": "Fatigue report list",
                "tabelaListaDeRelatoriosDeFadigas": {
                    "semParametrosDeFadiga": "There are no registered fatigue parameters",
                    "Data": "Date",
                    "Revisao": "Revision",
                    "Tripulante": "Crew member",
                    "Folga": "Day off",
                    "QuantidadeDePontosAtual": "Current amount of points",
                    "QuantidadeDePontosReportados": "Number of points reported",
                    "DiaDePreenchimento": "Filling day",
                    "Acoes": "Actions"
                },
                "tituloDadosDoRelatorioDeFadiga": "Fatigue report data",
                "paragrafoQuantidadeDePontosAtual": "Current amount of points",
                "paragrafoQuantidadeDePontosReportados": "Number of points reported",
                "tabelaDadosDoRelatorioDeFadiga": {
                    "Parametro": "Parameter",
                    "Dados": "Data",
                    "Pontos": "Spots"
                }
            }
        },
        "HorasDeVoo": {
            "VisualizarHorasDeVoo": {
                "opcoesTipo": {
                    "Sintetica": "Synthetic (Ignores date filter)",
                    "Analitica": "Analytics"
                },
                "eNecessarioPreencherDataDeInicioEFimParaPesquisasAnaliticas": "It is necessary to fill in start and end date for analytical searches",
                "titulo": "View flight hours",
                "formulario": {
                    "DataInicial": "Initial date",
                    "DataFinal": "Final date",
                    "FB": "FB",
                    "Listagem": "Listing",
                    "Modelo": "Model",
                    "placeholder": {
                        "SelecionarTipo": "Select type",
                        "SelecionarModelosDeAeronave": "Select aircraft models"
                    }
                },
                "tabela": {
                    "semAeronaves": "There are no registered aircraft",
                    "ID": "ID",
                    "Data": "Date",
                    "Matricula": "Mat.",
                    "Apelido": "Surname",
                    "Modelo": "Model",
                    "FB": "FB",
                    "Simulador": "Simulator",
                    "Total": "Total",
                    "IFR": "IFR.",
                    "Noturno": "Night",
                    "APP": "APP",
                    "Diu": "Diu",
                    "Not": "Not",
                    "CgExt": "Cg. Ext."
                },
                "tituloTotais": "Totals",
                "tabelaTotais": {
                    "semAeronaves": "There are no registered aircraft",
                    "ID": "ID",
                    "Matricula": "Mat.",
                    "Apelido": "Surname",
                    "Modelo": "Model",
                    "Total": "Total",
                    "IFR": "IFR.",
                    "Noturno": "Night",
                    "APP": "APP",
                    "Diu": "Diu",
                    "Not": "Not"
                }
            }
        },
        "Solicitacoes": {
            "ListaDeSolicitacoes": {
                "titulo": "List of Requests",
                "tabela": {
                    "semSolicitacoes": "There are no registered requests",
                    "ID": "ID",
                    "DataDeCriacao": "Creation date",
                    "Inicio": "Start",
                    "Fim": "End",
                    "Justificativa": "Justification",
                    "Status": "Status",
                    "ChefeDeFrota": "Fleet Chief",
                    "ChefeDeFrotaDataResposta": "Chief of Fleet - Response Date",
                    "ChefeDeFrotaAprovacao": "Chief of Fleet - Approval",
                    "ChefeDeFrotaJustificativa": "Chief of Fleet - Justification",
                    "Administrativo": "Administrative",
                    "AdministrativoDataResposta": "Administrative - Reply Date",
                    "AdministrativoAprovacao": "Administrative - Approval",
                    "AdministrativoResposta": "Administrative - Answer"
                }
            },
            "AdicionarSolicitacaoDeAlteracaoDeEscala": {
                "criar": "Are you sure you want to create this request?",
                "titulo": "Register Schedule Change Request",
                "formulario": {
                    "Inicio": "Start",
                    "Fim": "End",
                    "Razao": "Reason"
                }
            },
            "ListaDeSolicitacoesSigmec": {
                "confirmarMudanca": "Are you sure you want to change the status of this request?",
                "titulo": "List of Requests",
                "tabela": {
                    "semSolicitacoes": "There are no registered requests",
                    "ID": "ID",
                    "Escala": "Schedule",
                    "Colaborador": "Collaborator",
                    "TipoDeSolicitacao": "Request type",
                    "Justificativa": "Justification",
                    "Status": "Status",
                    "Acoes": "Actions"
                },
                "modal": {
                    "titulo": "Requisition view",
                    "formulario": {
                        "EscalaMesAtual": "Current month schedules",
                        "Atestado": "Certificate",
                        "Colaborador": "Collaborator",
                        "TipoDeAlteracao": "Type of alteration",
                        "Solicitante": "Requester",
                        "DataDeInicio": "Start date",
                        "DataDeTermino": "End date",
                        "Definitiva": "Is the change permanent?",
                        "TempoIndeterminado": "Undetermined time",
                        "Descrição": "Description",
                        "Justificativa": "Justification",
                        "NumeroChamado": "Call No.",
                        "NumeroMp": "Approved MP No.",
                        "Descricao": "Description",
                        "BaseAtual": "Current Base",
                        "NovaBase": "New Base",
                        "FuncaoAtual": "Current Role",
                        "NovaFuncao": "New Function",
                        "QuinzenaAtual": "Current fortnight",
                        "NovaQuinzena": "New fortnight",
                        "PeriodoAtual": "Current Period",
                        "NovaPeriodo": "New Period",
                        "GrupoAtual": "Current Group",
                        "NovoGrupo": "New group"
                    },
                    "modal_additional": {
                        "Exigencia": "Requirement",
                        "Resposta": "Answer",
                        "botaoEnviarInformacaos": "Send Information",
                        "botaoAprovar": "To approve",
                        "botaoReprovar": "Fail"
                    }
                }
            },
            "AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec": {
                "titulo": "Register SIGMEC Schedule Change Request",
                "erros": "The following errors were encountered when trying to request changes",
                "tabela": {
                    "EscalaMesAtual": "Current month schedules",
                    "Colaborador": "Collaborator",
                    "TipoDeAlteracao": "Type of alteration",
                    "DataDeInicio": "Start date",
                    "DataDeTermino": "End date",
                    "Duracao": "Is the change permanent? / Undetermined time",
                    "Justificativa": "Justification",
                    "Atual": "Current",
                    "Novo": "Young",
                    "NumeroChamado": "Call No.",
                    "NumeroMp": "Approved MP No.",
                    "Atestado": "Certificate",
                    "Descricao": "Description",
                    "Acoes": "Actions"
                },
                "formulario": {
                    "placeholder": {
                        "SelecioneEscala": "Select a schedule",
                        "selecioneColaborador": "Select a contributor",
                        "SelecioneTipoDeAlteracao": "Select a change type",
                        "SelecineGrupo": "Select a group",
                        "SelecineQuinzena": "Select a fortnight",
                        "SelecineBase": "Select a base",
                        "SelecinePeriodo": "Select a period",
                        "SelecineFuncao": "Select a role",
                        "NumeroChamado": "Call No.",
                        "NumeroMp": "Approved MP No.",
                        "Atestado": "Certificate"
                    },
                    "botaoSalvarSolicitacoes": "Add requests",
                    "botaoAdicionarSolicitacao": "Add request"
                }
            }
        },
        "Tarefas": {
            "ListaDeTarefas": {
                "titulo": "To-do list",
                "botaoAdicionarTarefa": "Add task",
                "tabela": {
                    "semTarefas": "There are no tasks registered",
                    "ID": "ID",
                    "Nome": "Name",
                    "Acoes": "Actions"
                }
            },
            "AdicionarTarefa": {
                "titulo": "Register restriction tasks",
                "formulario": {
                    "Tarefa": "Assignment",
                    "botaoCadastrarTarefa": "Register task",
                    "placeholder": {
                        "TarefaDeRestricao": "Constraint task"
                    }
                }
            },
            "EditarTarefa": {
                "titulo": "Edit Constraint Task",
                "formulario": {
                    "Tarefa": "Assignment",
                    "placeholder": {
                        "TarefaDeRestricao": "Constraint task"
                    }
                }
            }
        },
        "Sessoes": {
            "AdicionarSessao": {
                "deletar": "Are you sure you would like to delete this session?",
                "finalizar": "Are you sure you'd like to end this session?",
                "reabrir": "Are you sure you'd like to reopen this session?",
                "osDadosForamAtualizadosComSucesso": "The data has been updated successfully",
                "botaoAberto": "Open",
                "botaoFinalizado": "Finished",
                "botaoConfirmado": "Confirmed",
                "titulo": "Add session",
                "formulario": {
                    "Treinamento": "Training",
                    "Data": "Date",
                    "Inicio": "Start",
                    "Fim": "End",
                    "Examinador": "Examiner",
                    "Instrutor": "Instructor",
                    "PilotFlying": "Pilot Flying",
                    "PilotMonitoring": "Pilot Monitoring",

                    "botaoAdicionarSessao": "Add session",

                    "placeholder": {
                        "SelecionarCertificado": "Select Certificates",
                        "Data": "Data",
                        "HorarioDeInicio": "Start hour",
                        "HorarioDeFim": "End hour"
                    }
                },
                "tituloListaDeSessoes": "List of sessions",
                "tabela": {
                    "semTarefas": "There are no tasks registered",
                    "ID": "ID",
                    "Treinamento": "Training",
                    "Certificado": "Certificate",
                    "Inicio": "Start",
                    "Fim": "End",
                    "HorasTotais": "Total Hours",
                    "Arquivo": "Archive",
                    "Status": "Status",
                    "Acoes": "Actions"
                },
                "importarArquivo": "Are you sure you would like to import this file? When importing, the previous file, if any, will be permanently replaced.",
                "formularioAdicionarArquivo": {
                    "placeholder": {
                        "Arquivo": "Archive"
                    }
                },
                "opcoesTipo": {
                    "Examinador": "Examiner",
                    "Instrutor": "Instructor",
                    "PilotFlying": "Pilot Flying",
                    "PilotMonitoring": "Pilot Monitoring"
                },
                "deletarTripulante": "Are you sure you want to delete this crew member?",
                "tituloAdicionarTripulante": "Add crew member",
                "tabelaTripulantes": {
                    "Tripulante": "Crew member",
                    "Matricula": "Registration",
                    "Tipo": "Type",
                    "Acoes": "Actions"
                }
            }
        },
        "LinksUteis": {
            "LinksUteis": {
                "deletar": "Are you sure you would like to delete this link?",
                "titulo": "Useful links",
                "tabela": {
                    "semIncompatibilidades": "There are no registered incompatibilities",
                    "ID": "ID",
                    "Nome": "Name",
                    "Link": "Link"
                }
            }
        },
        "Usuarios": {
            "AlteracaoDeSenha": {
                "titulo": "Change password",
                "formulario": {
                    "SenhaAtual": "Current password",
                    "NovaSenha": "New Password",
                    "RepitaANovaSenha": "Repeat the new password",
                    "placeholder": {
                        "SenhaAtual": "Current password",
                        "NovaSenha": "New Password",
                        "RepitaANovaSenha": "Repeat the new password"
                    }
                }
            },
            "SistemaSuspensoParaManutencao": {
                "titulo": "Suspended system for maintenance",
                "tituloAtualizacao": "Update",
                "paragrafoPrevisaoDeVolta": "Back forecast"
            },
            "RecuperarSenha": {
                "formulario": {
                    "botaoRecuperarSenha": "Recover Password",
                    "placeholder": {
                        "SeuEmail": "Your email"
                    }
                },
                "paragrafoVoltarParaLogin": "Back to login"
            },
            "Login": {
                "usuarioNaoCadastrado": "User not registered. Ask IT to create the user.",
                "usuarioInativo": "Inactive user on this system. Ask IT to release the user.",
                "usuarioSemPermissoes": "User without permissions for this system. Ask IT for access permissions for this user.",
                "usuarioOuSenhaInvalidos": "Username or password is invalid.",
                "paragrafoModuloAdministrativo": "ADMINISTRATIVE MODULE",
                "formulario": {
                    "paragrafoAtencao": "ATTENTION: YOU WILL ACCESS THE APPROVAL ENVIRONMENT",
                    "botaoAcessarOSistema": "Access the system",
                    "placeholder": {
                        "SeuEmail": "Your email",
                        "SuaSenha": "Your password"
                    }
                },
                "paragrafoOLoginDeveSerFeitoComUsuarioESenhaOmniRubi": "LOGIN MUST BE DONE WITH THE USERNAME AND PASSWORD OMNI/RUBI",
                "paragrafoEsqueciMinhaSenha": "I forgot my password",
                "paragrafoEntreEmContato": "Please contact IT.",
                "paragrafoPortalDeColaboradores": "EMPLOYEE PORTAL"
            },
            "Questionario": {
                "titulo": "Quiz",
                "formulario": {
                    "VoceConcordaQueSeSentiuFadigadoNosUltimosDias": "Do you agree that you have felt fatigued in the last few days?",
                    "SelecioneOsFatoresQueContribuiramParaAFadiga": "Select the factors that contributed to the fatigue",
                    "opcoesFatoresQueContribuiramParaAFadiga": {
                        "NaoMeSentiFadigado": "I didn't feel fatigued",
                        "DescansoInsuficienteEntreJornadas": "Insufficient rest between shifts",
                        "JornadaInterrompida": "Journey interrupted",
                        "TransicaoDaJornadaDiurnoParaNoturno": "Journey transition (day to night)",
                        "TransicaoDaJornadaNoturnoParaDiurno": "Day transition (night to day)",
                        "HorarioDeInicioDaJornadaDiurno": "Start time of the journey (daytime)",
                        "HorarioDeInicioDaJornadaNoturno": "Start time of the journey (night)",
                        "TrabalhoNoturno": "Night work",
                        "DuracaoDaJornada": "Length of journey",
                        "HoraExtra": "Extra hour",
                        "Transporte": "Transport",
                        "Saude": "Health",
                        "FadigaAcumulada": "Accumulated fatigue",
                        "ProblemasPessoais": "Personal problems"
                    },
                    "HistoricoDoSonoDosUltimos3Dias": "Sleep History for the last 3 days",
                    "QueHorasDormiuNoUltimoDia": "What time did you sleep last day",
                    "QueHorasAcordouNoUltimoDia": "What time did you wake up last day",
                    "QualidadeDoSonoNoUltimoDia": "Sleep quality on the last day",
                    "opcoesSono": {
                        "Otimo": "Excellent",
                        "Bom": "Good",
                        "Normal": "Normal",
                        "Ruim": "Bad",
                        "Pessimo": "Terrible"
                    },
                    "QueHorasDormiuNoPenultimoDia": "What time did you sleep on the penultimate day",
                    "QueHorasAcordouNoPenultimoDia": "What time did you wake up on the penultimate day",
                    "QualidadeDoSonoNoPenultimoDia": "Sleep quality on the penultimate day",
                    "QueHorasDormiuHa3Dias": "What time did you sleep 3 days ago",
                    "QueHorasAcordouHa3Dias": "What time did you wake up 3 days ago",
                    "QualidadeDoSonoHa3Dias": "Sleep quality 3 days ago",
                    "SinaisFisiologicosECognitivos": "Physiological and cognitive signs",
                    "opcoesSinaisFisiologicos": {
                        "NaoMeSentiFadigado": "I didn't feel fatigued",
                        "NenhumSinalFisicoPercebido": "No perceived physical signs",
                        "EsfregarOsOlhosComFrequencia": "Rubbing your eyes frequently",
                        "PiscadasFrequentes": "Frequent blinks",
                        "Bocejo": "Yawn",
                        "OlharFixo": "Stare",
                        "DificuldadeEmManterOsOlhosAbertos": "Difficulty keeping your eyes open",
                        "PiscadasLongas": "Long blinks",
                        "CabeçaBalancandoOuCaindo": "Head shaking or falling",
                        "Inquietacao": "Restlessness"
                    },
                    "Contramedidas": "Countermeasures",
                    "opcoesContramedidas": {
                        "NaoMeSentiFadigado": "I didn't feel fatigued",
                        "AlertouAoColegaSobreORiscoDeFadiga": "Warned the colleague about the risk of fatigue",
                        "AumentouAComunicacao": "Increased communication",
                        "ComidaOuBebida": "Food or drink",
                        "Soneca": "Nap",
                        "CoordenouACargaDeTrabalho": "Coordinated the workload",
                        "Cafeina": "Caffeine"
                    },
                    "DetalhamentoECausasProvaveis": "Details and probable causes",
                    "VoceAcreditaQueOSistemaDeGerenciamentoDeFadigaEEficiente": "Do you believe that the fatigue management system is efficient",
                    "Sugestoes": "Suggestions",
                    "botaoResponder": "Reply",
                    "placeholder": {
                        "SelecionarUmaOpcao": "Select an option",
                        "HorarioDeApresentacao": "Presentation Time",
                        "SelecionarAplicabilidade": "Select applicability",
                        "CasoNaoTenhaSeSentidoFadigadoPreenchaComNA": "If you have not felt fatigued, fill in with N/A"
                    }
                }
            },
            "TesteDeSonolencia": {
                "titulo": "Drowsiness test",
                "formulario": {
                    "HorarioDeInicioDaJornada": "Start Time of the Day",
                    "ComoVoceEstaSeSentindoAgora": "How are you feeling now",
                    "opcoesComoVoceEstaSeSentindoAgora": {
                        "ExtremamenteAlerta": "Extremely alert (Extremely alert)",
                        "MuitoAlerta": "Very alert (Very alert)",
                        "Alerta": "Alert",
                        "RazoavelmenteAlerta": "Fairly alert (Reasonably alert)",
                        "NemAlertaNemSonolento": "Neither alert nor sleepy",
                        "AlgunsSinaisDeSonolencia": "Some signs of sleepiness",
                        "SonolentoMasConsigoMeManterAcordado": "Sleepy, but no effort to keep alert",
                        "SonolentoPrecisoMeConcentrarParaMeManterAcordado": "Sleepy, some effort to keep alert",
                        "MuitosonolentoMuitoEsforcoParaMeManterAcordadoLutandoComOSono": "Very sleepy, great effort to keep alert, fighting sleep"
                    },
                    "botaoResponder": "Reply",
                    "placeholder": {
                        "HorarioDeApresentacao": "Presentation Time"
                    }
                }
            }
        }
    };
};

/* harmony default export */ __webpack_exports__["a"] = (getLocale);

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** PROTOTYPED */
var getLocale = function getLocale() {
  var _placeholder, _menuVoos, _formulario, _placeholder2;

  return {
    general: {
      voltar: "Voltar",
      abrirMenu: "Abrir menu",
      procurar: "Procurar",
      adicionar: "Adicionar",
      editar: "Editar",
      informacoes: "Informações",
      buscar: "Buscar",
      salvar: "Salvar",
      duplicar: "Duplicar",
      deletar: "Deletar",
      abrir: "Abrir",
      salvarEdicao: "Salvar edição",
      semDados: "Não há dados cadastrados",
      semConexao: "Atenção: não há conexão com a internet. A única funcionalidade disponível é a de cadastro de trechos de voo, disponível no menu. Todas as outras funcionalidades apresentarão erro.",
      alertas: "Alertas",
      desde: "desde",
      pesquisar: "Pesquisar",
      sim: "Sim",
      nao: "Não",
      ambos: "Ambos",
      consulta: "Consulta",
      exportar: "Exportar",
      exportarPDF: "Exportar PDF",
      exportarXLS: "Exportar XLS",
      exportarXLSX: "Exportar XLSX",
      exportarTextoCSV: "Exportar CSV",
      diaMesAno: "dd/mm/aaaa",
      mesAno: "mm/aaaa",
      horaMinuto: "hh:mm",
      diaMesAnoHoraMinuto: "dd/mm/aaaa hh:mm",
      recarregar: "Recarregar",
      importar: "Importar",
      justificar: "Justificar",
      atualizar: "Atualizar",
      filtrar: "Filtrar",
      cancelar: "Cancelar",
      aberta: "Aberta",
      expiracao: "Expiração",
      realizada: "Realizada",
      euro: "Euro",
      dolar: "Dólar",
      real: "Real",
      mudarLinguagem: "Change to English",
      ingles: "Inglês",
      portugues: "Português",
      offlineRefresh: "Você está offline. O sistema não será recarregado. Tem certeza que deseja continuar?"
    },

    Calendario: {
      Calendario: {
        tabela: {
          Domingo: "Domingo",
          SegundaFeira: "Segunda-feira",
          TercaFeira: "Terça-feira",
          QuartaFeira: "Quarta-feira",
          QuintaFeira: "Quinta-feira",
          SextaFeira: "Sexta-feira",
          Sabado: "Sábado"
        }
      }
    },

    Controles: {
      ExtratoMensalDePagamentosPorDataDeReferencia: {
        opcoesTipos: {
          Missao: "Missão",
          Treinamento: "Treinamento"
        },

        opcoesMissao: {
          Diarias: "Diárias",
          RepresentanteOperacional: "Representante Operacional",
          Transporte: "Transporte",
          Deslocamento: "Deslocamento",
          Extra: "Extra"
        },

        opcoesTreinamento: {
          Diarias: "Diárias",
          Cheques: "Cheques",
          Extra: "Extra"
        },

        titulo: "Extrato Mensal de Pagamentos - Por Data de Referência",

        botaoTutorial: "Tutorial",

        paragrafoOControleExibeTodosOspagamentos: "O controle exibe todos os pagamentos independente de estarem na listagem em aberto ou em alguma ordem de pagamentos",
        paragrafoADataDeReferenciaParaAPesquisa: "A data de referência para a pesquisa é a data do período da escala ou treinamento relacionado ao pagamento",

        formulario: {
          Periodo: "Período",
          ExibirPagamentosAbertos: "Exibir pagamentos abertos"
        },

        tabelaSaldos: {
          semSaldoAnterior: "Nenhum saldo anterior encontrado",
          SaldoAnterior: "Saldo Anterior"
        },

        tabelaPagamentos: {
          semPagamentos: "Nenhum pagamento encontrado",
          BaseOperacional: "Base Operacional",
          Periodo: "Período",
          TipoDeOrdem: "Tipo de Ordem",
          Treinamento: "Treinamento",
          CodigoDeControle: "Código de Controle",
          Revisao: "Revisão",
          TipoDePagamento: "Tipo de Pagamento",
          Status: "Status",
          Quantidade: "Quantidade",
          ValorUnitario: "Valor/Unitário",
          ValorOriginal: "Valor Original",
          Desconto: "Desconto",
          ValorRecebido: "Valor Recebido",
          Saldo: "Saldo",
          DataDoPagamento: "Data do Pagamento",
          Acoes: "Ações"
        },

        tabelaValores: {
          semValores: "Nenhum valor consolidado encontrado",
          ValorOriginal: "Valor Original",
          Desconto: "Desconto",
          ValorRecebido: "Valor Recebido",
          Saldo: "Saldo"
        },

        tituloDiasDoPagamento: "Dias do pagamento",

        tabelaDiasDoPagamento: {
          Data: "Data",
          Diarias: "Diárias",

          nenhumDiaEncontrado: "Nenhum dia encontrado. Certas informações só passaram a ser gravadas à partir de 05/2022"
        },

        tituloDescontosRelacionados: "Descontos Relacionados",

        tabelaDescontosRelacionados: {
          IdDoDebito: "Id do débito",
          ReferenciaDoDebito: "Referência do débito",
          ValorOriginalDoDebito: "Valor original do débito",
          ValorAmortizadoNoPagamento: "Valor amortizado no pagamento"
        },

        tituloPagamentosRelacionados: "Pagamentos Relacionados",

        tabelaPagamentosRelacionados: {
          IdDoDebito: "Id do débito",
          ReferenciaDoPagamento: "Referência do pagamento",
          ValorOriginalDoDebito: "Valor original do débito",
          ValorAmortizadoNoPagamento: "Valor amortizado no pagamento"
        }
      },

      ExtratoPagamentosPorPeriodoPorDataDePagamento: {
        titulo: "Extrato Pagamentos por Período - Por Data de Pagamento",

        paragrafoOControleExibeTodosOspagamentos: "O controle exibe todos os pagamentos independente de estarem na listagem em aberto ou em alguma ordem de pagamentos",
        paragrafoAsDatasDeReferenciaParaAPesquisa: "As datas de referência para a pesquisa são as datas do pagamento",

        formulario: {
          Inicio: "Início",
          Termino: "Término"
        },

        tabelaPagamentos: {
          semPagamentos: "Nenhum pagamento encontrado",
          BaseOperacional: "Base Operacional",
          Frota: "Frota",
          Periodo: "Período",
          TipoDeOrdem: "Tipo de Ordem",
          Treinamento: "Treinamento",
          CodigoDeControle: "Código de Controle",
          Revisao: "Revisão",
          TipoDePagamento: "Tipo de Pagamento",
          Status: "Status",
          Quantidade: "Quantidade",
          ValorUnitario: "Valor/Unitário",
          ValorOriginal: "Valor Original",
          Desconto: "Desconto",
          ValorRecebido: "Valor Recebido",
          Saldo: "Saldo",
          DataDoPagamento: "Data do Pagamento",
          Acoes: "Ações"
        },

        tituloDiasDoPagamento: "Dias do pagamento",

        tabelaDiasDoPagamento: {
          Data: "Data",
          Diarias: "Diárias",

          nenhumDiaEncontrado: "Nenhum dia encontrado. Certas informações só passaram a ser gravadas à partir de 05/2022"
        },

        tituloDescontosRelacionados: "Descontos Relacionados",

        tabelaDescontosRelacionados: {
          IdDoDebito: "Id do débito",
          ReferenciaDoDebito: "Referência do débito",
          ValorOriginalDoDebito: "Valor original do débito",
          ValorAmortizadoNoPagamento: "Valor amortizado no pagamento"
        },

        tituloPagamentosRelacionados: "Pagamentos Relacionados",

        tabelaPagamentosRelacionados: {
          IdDoDebito: "Id do débito",
          ReferenciaDoPagamento: "Referência do pagamento",
          ValorOriginalDoDebito: "Valor original do débito",
          ValorAmortizadoNoPagamento: "Valor amortizado no pagamento"
        }
      }

    },

    EscalasDeTesteDeSonolencia: {

      ListaDeEscalasDeTesteDeSonolencia: {
        titulo: "Lista de escalas de teste de sonolência",
        botaoAdicionarEscala: "Adicionar escala",

        tabela: {
          semEscalas: "Não há escalas de testes cadastradas",
          ID: "ID",
          Nome: "Nome",
          DataInicial: "Data inicial",
          DataFinal: "Data final",
          Acoes: "Ações"
        }
      },

      AdicionarEscalaDeSonolencia: {
        aguardeEnquantoAEscalaEGerada: "Aguarde enquanto a escala é gerada. Este processo pode levar alguns minutos.",
        titulo: "Cadastrar escala de testes de sonolência",

        formulario: {
          Nome: "Nome",
          HorariosDeEnvio: "Horários de envio",
          DataInicial: "Data inicial",
          DataFinal: "Data final",
          AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
          Tripulantes: "Tripulantes",
          Mecanicos: "Mecânicos",
          Coordenadores: "Coordenadores",
          botaoAdicionarEscalaDeTeste: "Adicionar escala de teste",

          placeholder: {
            NomeDaEscalaDeSonolencia: "Nome da escala de sonolência",
            HorariosDeEnvio: "hh:mm, separados por virgula.",
            SelecionarAplicabilidade: "Selecionar aplicabilidade"
          }
        }

      },

      EditarEscalaDeSonolencia: {
        trocarStatusDaEscala: "Tem certeza que gostaria de trocar o status da escala?",
        trocarStatusDaEscalaParaAprovado: "Tem certeza que gostaria de trocar o status da escala para aprovado?",
        trocarStatusDaEscalaParaFinalizado: "Tem certeza que gostaria de trocar o status da escala para finalizado?",

        titulo: "Edição de escala de sonolência",

        botaoDeFichas: {
          TrocarParaAprovado: "Trocar para aprovado",
          TrocarParaFinalizado: "Trocar para finalizado"
        },

        tabDadosDaEscala: {
          tituloTab: "Dados da escala",
          formulario: {
            Nome: "Nome",
            DataInicial: "Data inicial",
            DataFinal: "Data final",

            placeholder: {
              NomeDaEscalaDeSonolencia: "Nome da escala de sonolência"
            }
          }
        },

        tabTestesDeEscala: {
          tituloTab: "Testes de escala",

          deletarColaboradorDaEscalaDeTeste: "Tem certeza que gostaria de deletar esse colaborador da escala de testes?",

          tituloTestesDeEscalaDeSonolencia: "Testes de escala de sonolência",

          tabela: {
            semColaboradores: "Não há colaboradores cadastrados",
            ID: "ID",
            Colaborador: "Colaborador",
            ProgramacaoDeEnvio: "Programação de Envio",
            Acoes: "Ações"
          },

          tituloEditarTeste: "Editar teste",

          formulario: {
            Data: "Data",
            HorariosDeEnvio: "Horário de envio",
            Colaborador: "Colaborador",

            placeholder: {
              HorariosDeEnvio: "Horário de envio",
              SelecionarAplicabilidade: "Selecionar aplicabilidade"
            }
          }
        },

        tabRelatorioFinal: {
          tituloTab: "Relatório final",

          formulario: {
            PeriodoDeJornada: "Período de Jornada",
            DiasDeJornada: "Dias de jornada",
            Bases: "Bases",
            Designacoes: "Designações",
            Funcoes: "Funções",
            Cargos: "Cargos",
            Frotas: "Frotas",
            Grupos: "Grupos",

            botaoProcurarRelatorios: "Procurar relatórios",

            placeholder: {
              SelecionarPeriodoDeJornada: "Selecionar períodos de jornada",
              DiasDeJornada: "Dias, separados por virgula. Ex.: 01,02,10,11,etc.",
              SelecionarBases: "Selecionar bases",
              SelecionarDesignacoes: "Selecionar designações",
              SelecionarFuncoes: "Selecionar funções",
              SelecionarCargos: "Selecionar cargos",
              SelecionarFrotas: "Selecionar frotas",
              SelecionarGrupos: "Selecionar grupos"
            }

          },

          tituloPontosPorHorarioDeResposta: "Pontos por horário de resposta",

          paragrafoPercentualDeAdesaoParcial: "Percentual de adesão parcial (até a data)",
          paragrafoPercentualDeAdesaoGlobal: "Percentual de adesão global",
          paragrafoTempoMedioDeResposta: "Tempo médio de resposta",
          paragrafoTotalRespostas: "Total respostas",

          tituloCadaHorarioDeResposta: "Cada horário de resposta",

          tabelaHorariosDeResposta: {
            PeriodoHoras: "Período horas",
            Total: "Total",
            Pontos: "Pontos",
            Media: "Média"
          },

          tituloPontosPorPeriodoDeJornada: "Pontos por período de jornada",

          tabelaPontosPorPeriodoDeJornada: {
            PeriodoHoras: "Período horas",
            Total: "Total",
            Pontos: "Pontos",
            Media: "Média"
          },

          tituloPontosPorDiasDeJornada: "Pontos por dias de jornada",

          tabelaPontosPorDiasDeJornada: {
            PeriodoDias: "Período dias",
            Total: "Total",
            Pontos: "Pontos",
            Media: "Média"
          },

          tituloBases: "Bases",

          tabelaBases: {
            Base: "Base",
            Total: "Total",
            Pontos: "Pontos",
            Media: "Média"
          },

          tituloFuncoes: "Funções",

          tabelaFuncoes: {
            Funcao: "Função",
            Total: "Total",
            Pontos: "Pontos",
            Media: "Média"
          },

          tituloGrupos: "Grupos",

          tabelaGrupos: {
            Grupo: "Grupo",
            Total: "Total",
            Pontos: "Pontos",
            Media: "Média"
          },

          tituloDesignacoes: "Designações",

          tabelaDesignacoes: {
            Designacao: "Designação",
            Total: "Total",
            Pontos: "Pontos",
            Media: "Média"
          },

          tituloFrotas: "Frotas",

          tabelaFrotas: {
            Frota: "Frota",
            Total: "Total",
            Pontos: "Pontos",
            Media: "Média"
          }
        }

      }
    },

    TripulanteDeslocamentos: {
      AdicionarDeslocamento: {
        titulo: 'Adicionar deslocamento',
        tituloAnteriores: 'Deslocamentos anteriores',

        formulario: {
          houveDeslocamento: 'Houve deslocamento para sua apresentação no aeroporto',
          tempoDeslocamento: 'Quanto tempo de deslocamento (inclui desde a saída de sua residência até a chegada no hotel ou aeroporto, o que tiver ocorrido primeiro)',
          botaoSalvar: 'Salvar'
        },

        tabela: {
          dataApresentacao: 'Data apresentação',
          houveDeslocamento: 'Houve deslocamento?',
          tempoDeslocamento: 'Tempo de deslocamento',
          Status: 'Status'
        }
      }
    },

    TripulanteDiscrepancias: {
      AdicionarDiscrepancia: {
        titulo: 'Adicionar discrepância',
        tituloAnteriores: 'Discrepâncias anteriores',

        formulario: {
          Data: 'Data',
          Discrepancia: 'Discrepância',
          grauEstresse: 'Grau de severidade/estresse',
          botaoAdicionar: 'Adicionar'
        },

        tabela: {
          Data: 'Data',
          Discrepancia: 'Discrepância',
          grauEstresse: 'Grau de severidade/estresse'
        }
      }
    },

    Fadigas: {

      ListaDeFadigas: {
        deletar: "Tem certeza que gostaria de deletar esse parâmetro de fadiga?",

        titulo: "Lista de parâmetros de fadigas",

        botaoAdicionarFadiga: "Adicionar Fadiga",

        tabela: {
          semParametroDeFadiga: "Não há parâmetros de fadiga cadastrados",
          ID: "ID",
          Aplicabilidade: "Aplicabilidade",
          Nome: "Nome",
          Tipo: "Tipo",
          Operador: "Operador",
          PontosPorHora: "PontosPorHora",
          PontosPorQuantidade: "Pontos por quantidade",
          LimiteDePontos: "Limite de pontos",
          ObrigatorioPreenchimento: "Obrigatório preenchimento",
          Acoes: "Ações"
        }
      },

      AdicionarFadiga: {
        titulo: "Cadastrar parâmetro de fadiga",
        formulario: {
          Nome: "Nome",
          Tipo: "Tipo",
          Operador: "Operador",
          PontosPorHora: "Pontos por hora",
          PontosPorQuantidade: "Pontos por quantidade",
          LimiteDePontos: "Limite de pontos",
          PontuacaoExtraPorHoraNoturna: "Pontuação Extra por Hora Noturna",
          AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
          PontosAReduzirParaTreinamento: "Pontos a reduzir para treinamento",
          ParametroObrigatorio: "Parâmetro Obrigatório",
          ParametroAutomatico: "Parâmetro Automático",
          TipoDeAutomacao: "Tipo de automação",

          tituloAlertas: "Alertas",

          LimiteMaximoDePontos: "Limite máximo de pontos",
          LimiteMinimoDePontos: "Limite mínimo de pontos",
          LimiteDePontosDeHoraExtraPorSemana: "Limite de pontos de hora extra por semana",
          LimiteDePontosDeHoraExtraPorMes: "Limite de pontos de hora extra por mês",
          LimiteDeDiasComHoraExtraPorSemana: "Limite de dias com hora extra por semana",
          LimiteDeDiasComHoraExtraPorMes: "Limite de dias com hora extra por mês",

          botaoAdicionarParametroDeFadiga: "Adicionar parâmetro de fadiga",

          placeholder: (_placeholder = {
            NomeDoParametroDeFadiga: "Nome do parâmetro de fadiga",
            SelecionarTipo: "Selecionar tipo",
            SelecionarOperador: "Selecionar operador",
            QuantidadeDePontosPorHora: "Quantidade de pontos por hora",
            QuantidadeDePontosPorQuantidade: "Quantidade de pontos por quantidade",
            LimiteDePontosDoParametro: "Limite de pontos do parâmetro",
            PontuacaoExtraPorHoraNoturna: "Pontuação Extra por Hora Noturna",
            SelecionarAplicabilidade: "Selecionar aplicabilidade",
            PontosAReduzirParaTreinamento: "Pontos a reduzir para treinamento",
            ParametroObrigatorio: "Parâmetro Obrigatório",
            ParametroAutomatico: "Parâmetro Automático"
          }, _defineProperty(_placeholder, "SelecionarTipo", "Selecionar tipo"), _defineProperty(_placeholder, "LimiteMaximoDePontos", "Limite máximo de pontos"), _defineProperty(_placeholder, "LimiteMinimoDePontos", "Limite mínimo de pontos"), _placeholder)
        }
      },

      EditarFadiga: {

        deletar: "Tem certeza que gostaria de deletar essa opção?",

        titulo: "Editar parâmetro de fadiga",

        formulario: {
          Nome: "Nome",
          Tipo: "Tipo",
          Operador: "Operador",
          PontosPorHora: "Pontos por hora",
          PontosPorQuantidade: "Pontos por quantidade",
          LimiteDePontos: "Limite de pontos",
          PontuacaoExtraPorHoraNoturna: "Pontuação Extra por Hora Noturna",
          AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
          PontosAReduzirParaTreinamento: "Pontos a reduzir para treinamento",
          ParametroObrigatorio: "Parâmetro Obrigatório",
          ParametroAutomatico: "Parâmetro Automático",
          TipoDeAutomacao: "Tipo de automação",

          tituloAlertas: "Alertas",

          LimiteMaximoDePontos: "Limite máximo de pontos",
          LimiteMinimoDePontos: "Limite mínimo de pontos",
          LimiteDePontosDeHoraExtraPorSemana: "Limite de pontos de hora extra por semana",
          LimiteDePontosDeHoraExtraPorMes: "Limite de pontos de hora extra por mês",
          LimiteDeDiasComHoraExtraPorSemana: "Limite de dias com hora extra por semana",
          LimiteDeDiasComHoraExtraPorMes: "Limite de dias com hora extra por mês",

          placeholder: {
            NomeDoParametroDeFadiga: "Nome do parâmetro de fadiga",
            SelecionarCliente: "Selecionar cliente",
            QuantidadeDePontosPorHora: "Quantidade de pontos por hora",
            QuantidadeDePontosPorQuantidade: "Quantidade de pontos por quantidade",
            LimiteDePontosDoParametro: "Limite de pontos do parâmetro",
            PontuacaoExtraPorHoraNoturna: "Pontuação Extra por Hora Noturna",
            SelecionarAplicabilidade: "Selecionar aplicabilidade",
            PontosAReduzirParaTreinamento: "Pontos a reduzir para treinamento",
            ParametroObrigatorio: "Parâmetro Obrigatório",
            ParametroAutomatico: "Parâmetro Automático",
            SelecionarTipo: "Selecionar tipo",
            LimiteMaximoDePontos: "Limite máximo de pontos",
            LimiteMinimoDePontos: "Limite mínimo de pontos"
          }
        },

        tituloAdicionarOpcoes: "Adicionar opções",
        formularioAdicionarOpcoes: {
          Nome: "Nome",
          Pontos: "Pontos",

          placeholder: {
            NomeDoParametroDeFadiga: "Nome do parâmetro de fadiga",
            QuantidadeDePontos: "Quantidade de pontos"
          }
        },

        tituloOpcoes: "Opções",
        tabela: {
          Opcao: "Opção",
          Pontos: "Pontos",
          Acoes: "Ações"
        }

      }

    },

    RelatoriosAuxiliaresFadiga: {

      ProcurarRelatorioAuxiliar: {
        titulo: "Estatísticas (FAPA)",

        formulario: {
          DataInicial: "Data inicial",
          DataFinal: "Data final"
        },

        tituloResultadosDeAutoavaliacoes: "Resultados de Autoavaliações",

        tabela: {
          semParametroDeFadiga: "Não há parâmetros de fadiga cadastrados",
          ID: "ID",
          Data: "Data",
          Colaborador: "Colaborador",
          Questao1: "Questão 1",
          Questao2: "Questão 2",
          Questao3: "Questão 3",
          Questao4: "Questão 4",
          PontuacaoFinal: "Pontuação final"
        }

      },

      AdicionarRelatorioAuxiliar: {
        titulo: "Ferramenta de Auxílio para Autoavaliação da Fadiga (FAPA)",

        formulario: {
          tituloQuestao1QuaoAlertaVoceEsta: "Questão 1: Quão alerta você acha que está? (Considere sua condição antes de assumir a jornada)",
          tituloQuestao2VoceTeveSonoAdequado: "Questão 2: Você teve um sono adequado?",
          QuantoTempoDormiuNas24HorasAnteriores: "No início da jornada, por quanto tempo dormiu nas 24 horas anteriores?",
          QuantoTempoDormiuNas48HorasAnteriores: "No início da jornada, por quanto tempo dormiu nas 48 horas anteriores?",
          AoFimDaJornadaPorQuantasHorasTeraPermanicidoAcordado: "Ao fim da jornada prevista, por quantas horas você terá permanecido acordado, descontado qualquer tempo alocado para repouso em acomodação adequada ou repouso a bordo quando compondo tripulação aumentada?",
          tituloQuestao3QueHorasOcorreAPresenteJornada: "Questão 3: A que horas ocorre a presente jornada?",
          tituloQuestao4QualNivelDeRiscoOperacionalAssociado: "Questão 4: Qual o nível de risco operacional associado à jornada?",

          Rota: "Rota",

          Opcoes: {
            Baixo: "Baixo",
            Moderado: "Moderado",
            Elevado: "Elevado"
          },

          Aeroportos: "Aeroportos",
          EspacoAereo: "Espaço Aéreo",
          NivelExperienciaTripulacao: "Nível de Experiência da Tripulação",
          CaracteristicasEOperacionalidadeDaAeronave: "Características e operacionalidade da aeronave",
          CondicoesAtmosfericas: "Condições Atmosféricas",

          botaoGerarAvaliacao: "Gerar Avaliação",

          placeholder: {
            SelecioneUmaOpcao: "Selecione uma opção"
          }
        },

        tituloQuestao1QuaoAlertaVoceEsta: "Questão 1: Quão alerta você acha que está? (Considere sua condição antes de assumir a jornada)",

        tituloQuestao2VoceTeveSonoAdequado: "Questão 2: Você teve um sono adequado?",

        QuantoTempoDormiuNas24HorasAnteriores: "No início da jornada, por quanto tempo dormiu nas 24 horas anteriores?",

        QuantoTempoDormiuNas48HorasAnteriores: "No início da jornada, por quanto tempo dormiu nas 48 horas anteriores?",

        AoFimDaJornadaPorQuantasHorasTeraPermanicidoAcordado: "Ao fim da jornada prevista, por quantas horas você terá permanecido acordado, descontado qualquer tempo alocado para repouso em acomodação adequada ou repouso a bordo quando compondo tripulação aumentada?",
        pontos: "pontos",

        tituloQuestao3QueHorasOcorreAPresenteJornada: "Questão 3: A que horas ocorre a presente jornada?",
        tituloQuestao4QualNivelDeRiscoOperacionalAssociado: "Questão 4: Qual o nível de risco operacional associado à jornada?",

        nota: "Nota",
        paragrafoSeORiscoElevadoEstiverPresenteInformarAoDespachoOperacional: "Se o Risco Elevado estiver presente, é recomendável considerar controles de risco tais como o cochilo, rotação de tarefa ou informar ao despacho operacional que você não se encontra apto para o serviço.",

        paragrafoPontuacao: "Pontuação",
        paragrafoSeORiscoElevadoEstiverPresenteInformarAoOperador: "Se o Risco Elevado estiver presente, é recomendável considerar controles de risco tais como o cochilo, rotação de tarefa ou informar ao operador que você não se encontra apto para o serviço.",

        rota: "Rota",
        aeroportos: "Aeroportos",
        espacoAereo: "Espaço Aéreo",
        nivelExperienciaTripulacao: "Nível de Experiência da Tripulação",
        caracteristicasEOperacionalidadeDaAeronave: "Características e operacionalidade da aeronave",
        condicoesAtmosfericas: "Condições Atmosféricas",

        tituloResultadoDosRiscos: "Resultado dos riscos",

        paragrafoOrientacaoAoTripulante: "Orientação ao Tripulante",

        paragrafoMecaONivelDeAlertaTripulacaoAumentada: "Meça o nível de alerta usando métodos objetivos e subjetivos e discuta com seu supervisor porque seu nível de alerta pode não ser suficiente para esta jornada e considere a possibilidade de ser escalado para outra jornada de forma a gerenciar o risco (por exemplo, em tripulação aumentada, período de repouso maior).",

        paragrafoMecaONivelDeAlertaChochilo: "Meça o nível de alerta usando métodos objetivos e subjetivos, discuta com seu supervisor se seu nível de alerta é adequado para esta jornada e considere o uso de estratégias de mitigação adicionais (por exemplo, cochilo, rotação de tarefa).",

        paragrafoMecaONivelDeAlertaCafeina: "Meça o nível de alerta usando métodos objetivos e subjetivos, discuta com seu supervisor se seu nível de alerta é adequado para esta jornada e considere controles de risco de fadiga benéficos para esta jornada (por exemplo, uso de cafeína, cuidado maior com a hidratação e alimentação)."
      }

    },

    ReportesDeFadigas: {

      ListaDeReportesDeFadigasAbertos: {
        tituloMotivo: "Motivo",
        tituloObservacoes: "Observações",
        botaoConfirmarVisualizacao: "Confirmar visualização",

        titulo: "Lista de reportes voluntários de fadigas - Abertos",

        tabela: {
          semParametroDeFadiga: "Não há parâmetros de fadiga cadastrados",
          ID: "ID",
          Tripulante: "Tripulante",
          Data: "Data",
          Acoes: "Ações"
        }
      },

      ListaDeReportesDeFadigasFechados: {
        tituloMotivo: "Motivo",
        tituloObservacoes: "Observações",

        titulo: "Lista de reportes voluntários de fadigas - Fechados",

        tabela: {
          semParametroDeFadiga: "Não há parâmetros de fadiga cadastrados",
          ID: "ID",
          Tripulante: "Tripulante",
          Data: "Data",
          Acoes: "Ações"
        }

      },

      AdicionarReporteDeFadiga: {
        titulo: "Reporte voluntário de fadiga",

        formulario: {
          Motivo: "Motivo",
          Data: "Data",
          OProblemaApresentadoPodeSerAlgoPontual: "O problema apresentado pode ser considerado Pontual, ou seja, é algo que permite o retorno às atividades no próximo dia de missão?",
          Observacoes: "Observações",

          botaoEnviarReporte: "Enviar reporte",

          placeholder: {
            SelecionarMotivo: "Selecionar motivo",
            SelecionarOpcao: "Selecionar opção"

          }
        }
      },

      EditarMotivosDeFadiga: {
        deletar: "Tem certeza que gostaria de deletar esse motivo de fadiga?",

        titulo: "Editar motivos de fadiga",

        formulario: {
          Nome: "Nome",

          placeholder: {
            NomeDoMotivoDeFadiga: "Nome do motivo de fadiga"
          }
        },

        tituloMotivosDeFadigaCadastrados: "Motivos de fadiga cadastrados",

        tabela: {
          Nome: "Nome",
          Acoes: "Ações"
        }
      }
    },

    PesquisaDeRelatorios: {
      titulo: "Pesquisa de relatórios",

      formulario: {
        AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
        Tripulantes135: "Tripulantes - 135",
        Tripulantes121: "Tripulantes - 121",
        Mecanicos: "Mecânicos",
        Coordenadores: "Coordenadores",
        DataInicial: "Data inicial",
        DataFinal: "Data final",
        MotivoDoEnvio: "Motivo do envio",
        Respondido: "Respondido",

        botaoProcurarQuestionarios: "Procurar questionários",

        placeholder: {
          SelecionarAplicabilidade: "Selecionar aplicabilidade",
          SelecionarTripulante: "Selecionar tripulante",
          SelecionarMecanico: "Selecionar mecânico",
          SelecionarCoordenador: "Selecionar coordenador",
          SelecionarMotivos: "Selecionar motivos",
          SelecionarStatus: "Selecionar status"
        }
      },

      tituloListaDeQuestionarios: "Lista de questionários",

      tabelaListaDeQuestionarios: {
        semQuestionarios: "Não há questionários cadastrados",
        Data: "Data",
        Colaborador: "Colaborador",
        Status: "Status",
        Motivo: "Motivo",
        Acoes: "Ações"
      },

      tituloDadosDoQuestionarioDeFadiga: "Dados do questionário de fadiga",
      tituloBotaoResultadoDaPesquisa: "Resultado da pesquisa",
      tituloBotaoAltResultadoDeProva: "Resultado de prova",
      botaoExportarCSV: "Exportar CSV",

      tabelaDadosDoQuestionario: {
        Pergunta: "Pergunta",
        Resposta: "Resposta"
      }
    },

    RelatorioAbastecimento: {

      ListaDeAbastecimentos: {
        lista: "Lista de abastecimentos",
        adicionar: "Adicionar abastecimento",
        editar: "Editar abastecimento",
        deletar: "Deletar abastecimento",

        tabela: {
          Data: "Data",
          Relatório: "N° do Relatório",
          Voo: "Nº do Voo",
          Aeronave: "Aeronave",
          Fornecedor: "Fornecedor",
          Localidade: "Localidade",
          Quantidade: "Quantidade",
          Acoes: "Ações"
        }

      },

      EditarAbastecimento: {
        titulo: "Editar abastecimento",
        dados: "Dados",
        formulario: {
          AnexarNotaFiscal: "Anexar nota fiscal",
          Aeronave: "Aeronave",
          Empresa: "Empresa",
          Relatorio: "Relatório",
          CombustivelSolicitado: "Combustível Solicitado (Kg ou Lb)",
          NumeroDaCe: "Número da CE",
          Trecho: "Trecho",
          Fornecedor: "Fornecedor",
          CombustivelAbastecido: "Combustível abastecido (L)",
          Localidade: "Localidade",
          Comandante: "Comandante",
          VendidoPara: "Vendido para",
          Endereco: "Endereço",
          Tipo: "Tipo",
          Reg: "Registro",
          Capt: "Comandante",
          InicioAbastecimento: "Início do abastecimento",
          Click: "Clique",
          TerminoAbastecimento: "Término do abastecimento",
          ProximaLocalidade: "Próxima localidade",
          NumeroHidrante: "N° hidrante",
          SeuNumeroDeVenda: "Seu n° de venda",
          NumeroDeVendaAnterior: "N° de venda anterior",
          LeituraInicial: "Leitura inicial",
          LeituraFinal: "Leitura final",
          Entregues: "Entregues",
          TipoCombustivel: "Tipo de combustível",
          Preco: "Preço.",
          Quantidade: "Quantidade",
          ValorUnitario: "Valor unitário",
          ValorTotal: "Valor total",
          ValorReembolsavel: "Valor reembolsável",
          ValorFinal: "Valor final",
          botaoEditarAbastecimento: "Editar abastecimento",
          placeholder: {
            SelecioneAeronave: "Selecione a aeronave",
            SelecioneRelatorio: "Selecione o relatório",
            SelecioneTrecho: "Selecione o trecho",
            SelecioneFornecedor: "Selecione o fornecedor de combustível",
            SelecioneLocal: "Selecione o local"
          }
        },
        aprovacoes: {
          titulo: "Aprovações",
          tabela: {
            Tipo: "Tipo",
            Aprovacao: "Aprovação",
            Acoes: "Ações"
          },
          modalReprovar: {
            Titulo: "Reprovar",
            TituloPorLogin: "Reprovar Por Login",
            TituloPorAssinatura: "Reprovar Por Assinatura Eletrônica",
            Razao: "Razão da reprovação",
            BotaoReprovar: "Reprovar abastecimento",
            Confirmacao: "Tem certeza que deseja reprovar este abastecimento?",
            AlertaAssinaturaVazia: "É necessário assinar digitalmente antes de reprovasr"
          },
          modalAprovar: {
            Titulo: "Aprovar",
            TituloPorLogin: "Aprovar Por Login",
            TituloPorAssinatura: "Aprovar Por Assinatura Eletrônica",
            BotaoAprovar: "Aprovar abastecimento",
            Confirmacao: "Tem certeza que deseja aprovar este abastecimento?",
            AlertaAssinaturaVazia: "É necessário assinar digitalmente antes de aprovar"
          }
        }
      },

      AdicionarAbastecimento: {
        deletar: "Tem certeza que deseja excluir esse abastecimento?",
        titulo: "Cadastrar abastecimento",
        formulario: {
          AnexarNotaFiscal: "Anexar nota fiscal",
          Aeronave: "Aeronave",
          Empresa: "Empresa",
          Relatorio: "Relatório",
          CombustivelSolicitado: "Combustível Solicitado (Kg ou Lb)",
          NumeroDaCe: "Número da CE",
          Trecho: "Trecho",
          Fornecedor: "Fornecedor",
          CombustivelAbastecido: "Combustível abastecido (L)",
          Localidade: "Localidade",
          Comandante: "Comandante",
          VendidoPara: "Vendido para",
          Endereco: "Endereço",
          Tipo: "Tipo",
          Reg: "Registro",
          Capt: "Comandante",
          InicioAbastecimento: "Início do abastecimento",
          Click: "Clique",
          TerminoAbastecimento: "Término do abastecimento",
          ProximaLocalidade: "Próxima localidade",
          NumeroHidrante: "N° hidrante",
          SeuNumeroDeVenda: "Seu n° de venda",
          NumeroDeVendaAnterior: "N° de venda anterior",
          LeituraInicial: "Leitura inicial",
          LeituraFinal: "Leitura final",
          Entregues: "Entregues",
          TipoCombustivel: "Tipo de combustível",
          Preco: "Preço.",
          Quantidade: "Quantidade",
          ValorTotal: "Valor total",
          botaoAdicionarAbastecimento: "Adicionar abastecimento",
          placeholder: {
            SelecioneAeronave: "Selecione a aeronave",
            SelecioneRelatorio: "Selecione o relatório",
            SelecioneTrecho: "Selecione o trecho",
            SelecioneFornecedor: "Selecione o fornecedor de combustível",
            SelecioneLocal: "Selecione o local"
          }
        },

        tabela: {
          Trecho: "Trecho",
          NumeroDaCe: "Nº da CE",
          Fornecedor: "Fornecedor",
          Localidade: "Localidade",
          QuantidadeSolicitada: "Quantidade solicitada",
          QuantidadeAbastecida: "Quantidade abastecida",
          Acoes: "Ações"
        },

        modalEditarAbastecimento: {
          titulo: "Editar solicitação de combustível",
          formulario: {
            CombustivelSolicitado: "Combustível Solicitado (Kg ou Lb)",
            NumeroDaCe: "Número da CE",
            Trecho: "Trecho",
            Fornecedor: "Fornecedor",
            CombustivelAbastecido: "Combustível abastecido (L)",
            Localidade: "Localidade",

            botaoEditarAbastecimento: "Editar abastecimento"

          }
        }

      }
    },

    RelatoriosDeVoo: {

      ListaDeRelatoriosDeVoo: {

        titulo: "Relatórios de voo",
        tituloOffLine: "Relatórios de voo - Offline",
        botaoAdicionarRelatorioDeVoo: "Adicionar relatório de voo",

        formulario: {
          botaoMudarData: "Mudar data"
        },

        tabela: {
          semRelatorios: "Não há relatórios cadastrados",
          NumeroDoRelatorio: "Número do relatório",
          ID: "ID",
          Base: "Base",
          Data: "Data",
          Aeronave: "Aeronave",
          Frota: "Frota",
          Cliente: "Cliente",
          TipoDeVoo: "Tipo de voo",
          NumeroDoVoo: "Número do voo",
          Status: "Status",
          Acoes: "Ações"
        }
      },

      AdicionarRelatorioDeVoo: {
        titulo: "Cadastrar novo relatório de voo",

        formulario: {
          Data: "Data",
          Prefixo: "Prefixo",
          Voo: "Vôo",
          NumeroDeVoo: "Número de voo",
          NumeroDoRelatorio: "Número do relatório",
          SolicitouIsencao: "Solicitou isenção",
          PowerCheck: "Power Check",
          Base: "Base",
          Contrato: "Contrato",
          MecanicoResponsavel: "Mecânico responsável",
          Cliente: "Cliente",
          Observacoes: "Observações",

          botaoCriarRelatorioDeVoo: "Criar relatório de voo"
        }
      },

      EditarRelatoriosDeVoo: {

        trocarStatusDoRelatorioDeVoo: "Tem certeza que gostaria de trocar o status do relatório de voo?",

        mensagemOfflineSemVoo: "Este voo não foi registrado offline e não pode ser editado.",

        confirmarSalvarTodos: "Deseja salvar todos os trechos?",

        infoOffline: "O sistema está offline. Aguarde o retorno da conexão para salvar os trechos.",

        titulo: "Editar relatório de voo",

        botaoRelatorio: "Relatório",
        botaoExtratoDB: "Extrato DB",
        botaoXML: "XML",

        botaoRelatorioDeVoo: {
          TrocarParaRascunho: "Trocar para rascunho",
          TrocarParaFinalizado: "Trocar para finalizado",
          TrocarParaCancelado: "Trocar para Cancelado"
        },

        erros: "Os seguintes erros de preenchimento impediram o relatório de ser finalizado",

        erros_salvar: "Os seguintes erros de preenchimento impediram o(s) trecho(s) de serem salvos",

        modalDiscrepanciaHorarios: {
          titulo: "Discrepância de horários preenchidos nos trechos com os recebidos do Flight Following",
          substituir: "Tem certeza que gostaria de substituir os horários do trecho pelos do Flight Following?",
          substituirTodos: "Tem certeza que gostaria de substituir os horários de todos os trechos pelos do Flight Following?",
          botaoSubstituir: 'Substituir',
          botaoSubstituirTodos: "Substituir todos os horários preenchidos pelos do Flight Following",
          ignorar: "Tem certeza que gostaria de manter os horários do trecho e ignorar os do Flight Following?",
          ignorarTodos: "Tem certeza que gostaria de manter os horários de todos os trechos e ignorar os do Flight Following?",
          botaoIgnorar: 'Ignorar',
          botaoIgnorarTodos: "Ignorar todos os horários do Flight Following e manter os preenchidos",
          tabela: {
            ID: "ID",
            Trecho: "Trecho",
            FlightFollowing: "Flight Following",
            Preenchido: "Preenchido",
            Partida: "Partida",
            Decolagem: "Decolagem",
            Pouso: "Pouso",
            Corte: "Corte",
            Acoes: "Ações",
            botaoSubstituir: "Substituir",
            botaoIgnorar: "Ignorar"
          }
        },

        formularioEditarRelatorio: {
          Data: "Data",
          Prefixo: "Prefixo",
          Voo: "Vôo",
          NumeroDeVoo: "Número de voo",
          NumeroDoRelatorio: "Número do relatório",
          SolicitouIsencao: "Solicitou isenção",
          PowerCheck: "Power Check",
          Base: "Base",
          Contrato: "Contrato",
          MecanicoResponsavel: "Mecânico responsável",
          Cliente: "Cliente",
          Observacoes: "Observações",

          botaoEditarRelatorioDeVoo: "Editar relatório de voo"
        },

        tabelaVoosDia: {
          Titulo: "Outros voos do dia",
          SemVoos: "Não há outros voos no dia",
          Id: "Id",
          NumeroVoo: "Número do Voo",
          NumeroRelatório: "Número do Relatório",
          DecolagemPrevista: "Decolagem Prevista",
          Origem: "Origem",
          Cliente: "Cliente",
          Contrato: "Contrato",
          TipoVoo: "Tipo de Voo",
          Status: "Status"
        },

        excluirTripulante: "Tem certeza que deseja excluir esse tripulante? Ele será excluido de todos os trechos.",

        tituloCadastrarTripulacao: "Cadastrar tripulação",

        formularioCadastrarTripulacao: {
          Tripulante: "Tripulante",
          FuncaoDeBordo: "Função de bordo",
          DataDeApresentacao: "Data de Apresentação",
          HoraDeApresentacao: "Hora de Apresentação",

          botaoAdicionarTripulante: "Adicionar tripulante"
        },

        modalEditarTripulacao: {
          Titulo: "Editar Tripulante",
          FuncaoDeBordo: "Função de bordo",
          DataDeApresentacao: "Data de Apresentação",
          HoraDeApresentacao: "Hora de Apresentação",
          botaoEditarTripulante: "Editar tripulante"
        },

        tituloTripulantesCadastrados: "Tripulantes cadastrados",

        tabelaTripulantesCadastrados: {
          Nome: "Nome",
          CANAC: "CANAC",
          SISPAT: "SISPAT",
          FB: "FB",
          Apresentacao: "Apresentação",
          DecolagemPouso: "Decolagem/Pouso",
          TempoTotal: "Tempo Total",
          Navegacao: "Navegação",
          Instrumento: "Instrumento",
          Noturno: "Noturno",
          PousosDiurnos: "Pousos Diurnos",
          PousosNoturnos: "Pousos Noturnos",
          Pax: "Pax.",
          Carga: "Carga",
          Consumo: "Consumo",
          LongLine: "Long Line",
          ShortLine: "Short Line",
          Acoes: "Ações"
        },

        tituloCadastrarTrecho: "Cadastrar trecho",
        botaoSalvarTodos: "Salvar todos os trechos",

        formularioCadastrarTrecho: {
          Origem: "Origem",
          Destino: "Destino",
          Partida: "Partida",
          DEC: "DEC.",
          POU: "POU.",
          Corte: "Corte",
          DECPOU: "DEC-POU",
          Total: "Total",
          Nav: "Nav.",
          IFR: "IFR",
          Noturno: "Noturno",
          Diurnos: "Diurnos",
          Noturnos: "Noturnos",
          Partidas: "Partidas",
          PAX: "PAX",
          Carga: "Carga",
          LongLine: "Long line",
          ShortLine: "ShortLine",
          Inicial: "Inicial",
          Final: "Final",
          CodigoPTBR: "Código PTBR",
          SelecioneOpcao: "Selecione uma opção",

          botaoAdicionarTrecho: "Adicionar trecho"
        },

        tabelaCadastrarTrecho: {
          Realizados: "Realizados",
          Pousos: "Pousos",
          Dados: "Dados",
          CargaExterna: "Carga externa",
          Combustivel: "Combustível",
          OperacaoPTBR: "Operação PTBR",
          Acoes: "Ações",
          Numero: "N°",
          Origem: "Origem",
          Destino: "Destino",
          Partida: "Partida",
          DEC: "DEC.",
          POU: "POU.",
          Corte: "Corte",
          DECPOU: "DEC-POU",
          Total: "Total",
          Nav: "Nav.",
          IFR: "IFR",
          Noturno: "Noturno",
          Diurnos: "Diurnos",
          Noturnos: "Noturnos",
          Partidas: "Partidas",
          PAX: "PAX",
          Carga: "Carga",
          LongLine: "Long Line",
          ShortLine: "Short Line",
          Inicial: "Inicial",
          Final: "Final",
          CodigoPTBR: "Código PTBR"
        },

        tituloTotaisDosTrechos: "Totais dos trechos",

        tabelaTotaisDosTrechos: {
          DecolagemPouso: "Decolagem/Pouso",
          TempoTotal: "Tempo total",
          Navegacao: "Navegação",
          Instrumento: "Instrumento",
          Noturno: "Noturno",
          PousosDiurnos: "Pousos Diurnos",
          PousosNoturnos: "Pousos Noturnos",
          Pax: "Pax.",
          Carga: "Carga",
          Consumo: "Consumo"
        },

        excluirTrecho: "Tem certeza que deseja excluir esse trecho?",

        removerTripulanteDoTrecho: "Tem certeza que gostaria de remover este tripulante deste trecho?",

        tituloEdicaoTrecho: "Edição de Trecho",

        formularioEditarTrecho: {
          Origem: "Origem",
          Destino: "Destino",
          Partida: "Partida",
          DEC: "DEC.",
          POU: "POU.",
          Corte: "Corte",
          DECPOU: "DEC-POU",
          Total: "Total",
          Nav: "Nav.",
          IFR: "IFR",
          Noturno: "Noturno",
          Diurnos: "Diurnos",
          Noturnos: "Noturnos",
          Partidas: "Partidas",
          PAX: "PAX",
          Carga: "Carga",
          LongLine: "Long Line",
          ShortLine: "Short Line",
          Inicial: "Inicial",
          Final: "Final",
          CodigoPTBR: "Código PTBR",
          Horario: 'Horário',
          Copiar: 'Copiar',
          Atual: 'Hr.Atual',
          Following: 'F. Follow',
          FollowingShort: 'Follow',
          botaoEditarTrecho: "Editar trecho",
          limparTrecho: "As edições do trecho foram apagadas."
        },

        tituloTripulacaoCadastrada: "Tripulação cadastrada",

        formularioAdicionarTripulante: {
          Tripulante: "Tripulante",
          FuncaoDeBordo: "Função de bordo",

          botaoAdicionarTripulante: "Adicionar tripulante"
        },

        tabelaTripulantes: {
          Nome: "Nome",
          FuncaoDeBordo: "Função de bordo",
          Acoes: "Ações"
        },

        excluirAbastecimento: "Tem certeza que deseja excluir esse abastecimento?",
        mensagemDadosAtualizadosComSucesso: "Dados atualizados com sucesso",

        tituloCadastrarAbastecimento: "Cadastrar abastecimento",

        formularioAdicionarAbastecimento: {
          CombustivelSolicitado: "Combustível Solicitado (Kg ou Lb)",
          Trecho: "Trecho",
          NumeroDaCE: "Número da CE",
          Fornecedor: "Fornecedor",
          CombustivelAbastecido: "Combustível abastecido (L)",
          Localidade: "Localidade",

          botaoAdicionarAbastecimento: "Adicionar abastecimento"

        },

        tituloAbastecimentosCadastrados: "Abastecimentos cadastrados",

        tabelaAbastecimentosCadastrados: {
          Trecho: "Trecho",
          NumeroDaCE: "Nº da CE",
          Cia: "Cia.",
          QuantidadeSolicitada: "Quantidade solicitada",
          QuantidadeAbastecida: "Quantidade abastecida",
          Acoes: "Ações"
        },

        tituloEditarSolicitacaoDeCombustivel: "Editar solicitação de combustível",

        formularioEditarSolicitacaoDeCombustivel: {
          CombustivelSolicitado: "Combustível Solicitado",
          Trecho: "Trecho",
          NumeroDaCE: "Número da CE",
          Fornecedor: "Fornecedor",
          CombustivelAbastecido: "Combustível abastecido (L)",
          Localidade: "Localidade",

          botaoEditarAbastecimento: "Editar abastecimento"
        },

        tituloObservacoes: "Observações",

        formularioEditarObservacoes: {
          Observacoes: "Observações",

          botaoEditarObservacoes: "Editar observações"
        },

        tituloAlertasDoRelatorio: "Alertas do Relatório",

        tabelaAlertasDoRelatorio: {
          Mensagem: "Mensagem",
          Data: "Data"
        },

        aprovarRelatorio: "Tem certeza que deseja aprovar este relatório?",
        reabrirRelatorio: "Tem certeza que deseja reabrir este relatório?",
        reprovarRelatorio: "Tem certeza que deseja reprovar este relatório?",

        relatorioReabertoGerouImplicacoes: "Este relatório foi reaberto! Isso gerou as seguintes implicações",

        tabelaImplicacoes: {
          Mensagem: "Mensagem",
          Data: "Data"
        },

        tituloAprovacoes: "Aprovações",

        botaoReabrirRelatorio: "Reabrir relatório",

        tabelaAprovacoes: {
          Tipo: "Tipo",
          Tripulante: "Tripulante",
          Aprovacao: "Aprovação",
          Acoes: "Ações"
        },

        tituloJustificativaReprovacao: "Justificativa de reprovação",

        formularioReprovacao: {
          RazaoDaReprovacao: "Razão da reprovação",
          botaoReprovarRelatorio: "Reprovar relatório"
        },

        tituloLoginDoComandanteNoLDAP: "Login do comandante no LDAP",

        formularioLogin: {

          botaoAcessarSistema: "Acessar o sistema",

          placeholder: {
            Email: "Seu e-mail",
            Senha: "Sua senha"
          }
        },

        tituloLogDoRelatorio: "Log do relatório",

        tabelaLogRelatorio: {
          Usuario: "Usuário",
          Acao: "Ação",
          Descricao: "Descrição",
          Data: "Data"
        }
      },

      ListaDeRelatoriosDeVooOffline: {

        titulo: "Relatórios de voo",

        tabela: {
          semRelatorios: "Não há relatórios cadastrados",
          ID: "ID",
          NumeroDoRelatorio: "Número do relatório",
          Base: "Base",
          Data: "Data",
          Aeronave: "Aeronave",
          Frota: "Frota",
          Cliente: "Cliente",
          TipoDeVoo: "Tipo de voo",
          NumeroDoVoo: "Número do voo",
          Status: "Status",
          Acoes: "Ações"
        }
      },

      EditarRelatoriosDeVooOffline: {

        trocarStatusDoRelatorioDeVoo: "Tem certeza que gostaria de trocar o status do relatório de voo?",

        confirmarSalvarTodos: "Deseja salvar todos os trechos?",

        titulo: "Editar relatório de voo",

        botaoRelatorio: "Relatório",
        botaoExtratoDB: "Extrato DB",
        botaoXML: "XML",

        botaoRelatorioDeVoo: {
          TrocarParaRascunho: "Trocar para rascunho",
          TrocarParaFinalizado: "Trocar para finalizado",
          TrocarParaCancelado: "Trocar para Cancelado"
        },

        erros: "Os seguintes erros de preenchimento impediram o relatório de ser finalizado",

        formularioEditarRelatorio: {
          Data: "Data",
          Prefixo: "Prefixo",
          Voo: "Vôo",
          NumeroDeVoo: "Número de voo",
          NumeroDoRelatorio: "Número do relatório",
          SolicitouIsencao: "Solicitou isenção",
          Base: "Base",
          Contrato: "Contrato",
          MecanicoResponsavel: "Mecânico responsável",
          Cliente: "Cliente",
          Observacoes: "Observações",

          botaoEditarRelatorioDeVoo: "Editar relatório de voo"
        },

        excluirTripulante: "Tem certeza que deseja excluir esse tripulante? Ele será excluido de todos os trechos.",

        tituloCadastrarTripulacao: "Cadastrar tripulação",

        formularioCadastrarTripulacao: {
          Tripulante: "Tripulante",
          FuncaoDeBordo: "Função de bordo",
          DataDeApresentacao: "Data de Apresentação",
          HoraDeApresentacao: "Hora de Apresentação",

          botaoAdicionarTripulante: "Adicionar tripulante"
        },

        tituloTripulantesCadastrados: "Tripulantes cadastrados",

        tabelaTripulantesCadastrados: {
          Nome: "Nome",
          CANAC: "CANAC",
          SISPAT: "SISPAT",
          FB: "FB",
          Apresentacao: "Apresentação",
          DecolagemPouso: "Decolagem/Pouso",
          TempoTotal: "Tempo Total",
          Navegacao: "Navegação",
          Instrumento: "Instrumento",
          Noturno: "Noturno",
          PousosDiurnos: "Pousos Diurnos",
          PousosNoturnos: "Pousos Noturnos",
          Pax: "Pax.",
          Carga: "Carga",
          Consumo: "Consumo",
          LongLine: "Long Line",
          ShortLine: "Short Line",
          Acoes: "Ações"
        },

        tituloCadastrarTrecho: "Cadastrar trecho",
        botaoSalvarTodos: "Salvar todos os trechos",

        formularioCadastrarTrecho: {
          Origem: "Origem",
          Destino: "Destino",
          Partida: "Partida",
          DEC: "DEC.",
          POU: "POU.",
          Corte: "Corte",
          DECPOU: "DEC-POU",
          Total: "Total",
          Nav: "Nav.",
          IFR: "IFR",
          Noturno: "Noturno",
          Diurnos: "Diurnos",
          Noturnos: "Noturnos",
          Partidas: "Partidas",
          PAX: "PAX",
          Carga: "Carga",
          LongLine: "Long line",
          ShortLine: "ShortLine",
          Inicial: "Inicial",
          Final: "Final",
          CodigoPTBR: "Código PTBR",
          SelecioneOpcao: "Selecione uma opção",

          botaoAdicionarTrecho: "Adicionar trecho"
        },

        tabelaCadastrarTrecho: {
          Realizados: "Realizados",
          Pousos: "Pousos",
          Dados: "Dados",
          CargaExterna: "Carga externa",
          Combustivel: "Combustível",
          OperacaoPTBR: "Operação PTBR",
          Acoes: "Ações",
          Numero: "N°",
          Origem: "Origem",
          Destino: "Destino",
          Partida: "Partida",
          DEC: "DEC.",
          POU: "POU.",
          Corte: "Corte",
          DECPOU: "DEC-POU",
          Total: "Total",
          Nav: "Nav.",
          IFR: "IFR",
          Noturno: "Noturno",
          Diurnos: "Diurnos",
          Noturnos: "Noturnos",
          Partidas: "Partidas",
          PAX: "PAX",
          Carga: "Carga",
          LongLine: "Long Line",
          ShortLine: "Short Line",
          Inicial: "Inicial",
          Final: "Final",
          CodigoPTBR: "Código PTBR"
        },

        tituloTotaisDosTrechos: "Totais dos trechos",

        tabelaTotaisDosTrechos: {
          DecolagemPouso: "Decolagem/Pouso",
          TempoTotal: "Tempo total",
          Navegacao: "Navegação",
          Instrumento: "Instrumento",
          Noturno: "Noturno",
          PousosDiurnos: "Pousos Diurnos",
          PousosNoturnos: "Pousos Noturnos",
          Pax: "Pax.",
          Carga: "Carga",
          Consumo: "Consumo"
        },

        excluirTrecho: "Tem certeza que deseja excluir esse trecho?",

        removerTripulanteDoTrecho: "Tem certeza que gostaria de remover este tripulante deste trecho?",

        formularioEditarTrecho: {
          Origem: "Origem",
          Destino: "Destino",
          Partida: "Partida",
          DEC: "DEC.",
          POU: "POU.",
          Corte: "Corte",
          DECPOU: "DEC-POU",
          Total: "Total",
          Nav: "Nav.",
          IFR: "IFR",
          Noturno: "Noturno",
          Diurnos: "Diurnos",
          Noturnos: "Noturnos",
          Partidas: "Partidas",
          PAX: "PAX",
          Carga: "Carga",
          LongLine: "Long Line",
          ShortLine: "Short Line",
          Inicial: "Inicial",
          Final: "Final",
          CodigoPTBR: "Código PTBR",

          botaoEditarTrecho: "Editar trecho"
        },

        tituloTripulacaoCadastrada: "Tripulação cadastrada",

        formularioAdicionarTripulante: {
          Tripulante: "Tripulante",
          FuncaoDeBordo: "Função de bordo",

          botaoAdicionarTripulante: "Adicionar tripulante"
        },

        tabelaTripulantes: {
          Nome: "Nome",
          FuncaoDeBordo: "Função de bordo",
          Acoes: "Ações"
        },

        excluirAbastecimento: "Tem certeza que deseja excluir esse abastecimento?",
        mensagemDadosAtualizadosComSucesso: "Dados atualizados com sucesso",

        tituloCadastrarAbastecimento: "Cadastrar abastecimento",

        formularioAdicionarAbastecimento: {
          CombustivelSolicitado: "Combustível Solicitado (Kg ou Lb)",
          Trecho: "Trecho",
          NumeroDaCE: "Número da CE",
          Cia: "Cia.",
          CombustivelAbastecido: "Combustível abastecido (L)",

          botaoAdicionarAbastecimento: "Adicionar abastecimento"

        },

        tituloAbastecimentosCadastrados: "Abastecimentos cadastrados",

        tabelaAbastecimentosCadastrados: {
          Trecho: "Trecho",
          NumeroDaCE: "Nº da CE",
          Cia: "Cia.",
          QuantidadeSolicitada: "Quantidade solicitada",
          QuantidadeAbastecida: "Quantidade abastecida",
          Acoes: "Ações"
        },

        tituloEditarSolicitacaoDeCombustivel: "Editar solicitação de combustível",

        formularioEditarSolicitacaoDeCombustivel: {
          CombustivelSolicitado: "Combustível Solicitado",
          Trecho: "Trecho",
          NumeroDaCE: "Número da CE",
          Cia: "Cia.",
          CombustivelAbastecido: "Combustível abastecido (L)",

          botaoEditarAbastecimento: "Editar abastecimento"
        },

        tituloObservacoes: "Observações",

        formularioEditarObservacoes: {
          Observacoes: "Observações",

          botaoEditarObservacoes: "Editar observações"
        },

        tituloAlertasDoRelatorio: "Alertas do Relatório",

        tabelaAlertasDoRelatorio: {
          Mensagem: "Mensagem",
          Data: "Data"
        },

        aprovarRelatorio: "Tem certeza que deseja aprovar este relatório?",
        reabrirRelatorio: "Tem certeza que deseja reabrir este relatório?",
        reprovarRelatorio: "Tem certeza que deseja reprovar este relatório?",

        relatorioReabertoGerouImplicacoes: "Este relatório foi reaberto! Isso gerou as seguintes implicações",

        tabelaImplicacoes: {
          Mensagem: "Mensagem",
          Data: "Data"
        },

        tituloAprovacoes: "Aprovações",

        botaoReabrirRelatorio: "Reabrir relatório",

        tabelaAprovacoes: {
          Tipo: "Tipo",
          Tripulante: "Tripulante",
          Aprovacao: "Aprovação",
          Acoes: "Ações"
        },

        tituloJustificativaReprovacao: "Justificativa de reprovação",

        formularioReprovacao: {
          RazaoDaReprovacao: "Razão da reprovação",
          botaoReprovarRelatorio: "Reprovar relatório"
        },

        tituloLoginDoComandanteNoLDAP: "Login do comandante no LDAP",

        formularioLogin: {

          botaoAcessarSistema: "Acessar o sistema",

          placeholder: {
            Email: "Seu e-mail",
            Senha: "Sua senha"
          }
        },

        tituloLogDoRelatorio: "Log do relatório",

        tabelaLogRelatorio: {
          Usuario: "Usuário",
          Acao: "Ação",
          Descricao: "Descrição",
          Data: "Data"
        }
      },

      AdicionarRelatorioDeVooOffline: {
        titulo: "Cadastrar novo relatório de voo",

        formulario: {
          Data: "Data",
          Prefixo: "Prefixo",
          Voo: "Vôo",
          NumeroDeVoo: "Número de voo",
          SolicitouIsencao: "Solicitou isenção",
          Base: "Base",
          Contrato: "Contrato",
          MecanicoResponsavel: "Mecânico responsável",
          Cliente: "Cliente",
          Observacoes: "Observações",

          botaoCriarRelatorioDeVoo: "Criar relatório de voo"
        }
      },

      RelatoriosPendentesDeAprovacao: {
        aprovar: "Tem certeza que deseja aprovar este relatório?",

        titulo: "Relatórios Pendentes de Aprovação",

        formulario: {
          Base: "Base",
          Status: "Status"
        },

        botaoAprovar: "APROVAR",

        tabela: {
          Data: "Data",
          Base: "Base",
          Aeronave: "Aeronave",
          Frota: "Frota",
          Contrato: "Contrato",
          TipoDeVoo: "Tipo de Voo",
          NumeroDoVoo: "N° do Voo",
          Status: "Status",
          Acoes: "Ações"
        }

      },

      QuantidadeDeVoosPorDia: {
        titulo: "Quantidade de voos por dia",

        formulario: {
          DataInicial: "Data Inicial",
          DataFinal: "Data Final",
          Aeronave: "Aeronave",
          Frota: "Frota",
          Base: "Base",
          Tripulantes: "Tripulantes",
          TipoDeVoo: "Tipo de Voo",
          Contrato: "Contrato",
          SomenteAprovados: "Somente aprovados",
          BaseContratual: "Base Contratual"
        },

        tituloTotaisDaAeronavePorData: "Totais da aeronave por data",

        tabelaTotaisDaAeronavePorData: {
          Data: "Data",
          Prefixo: "Prefixo",
          Frota: "Frota",
          QuantidadeDeVoos: "Quantidade de Voos",
          QuantidadeDePousos: "Quantidade de Pousos",
          QuantidadeDeCortes: "Quantidade de Cortes",
          QuantidadeDePAX: "Quantidade de PAX"
        },

        tituloTotaisDaAeronavePorPeriodo: "Totais da aeronave por período",

        tabelaTotaisDaAeronavePorPeriodo: {
          DataInicial: "Data Inicial",
          DataFinal: "Data Final",
          Prefixo: "Prefixo",
          Frota: "Frota",
          QuantidadeDeVoos: "Quantidade de Voos",
          QuantidadeDePousos: "Quantidade de Pousos",
          QuantidadeDeCortes: "Quantidade de Cortes",
          QuantidadeDePAX: "Quantidade de PAX"
        },

        tituloTotaisDoModeloPorData: "Totais do modelo por data",

        tabelaTotaisDoModeloPorData: {
          Data: "Data",
          Frota: "Frota",
          QuantidadeDeVoos: "Quantidade de Voos",
          QuantidadeDePousos: "Quantidade de Pousos",
          QuantidadeDeCortes: "Quantidade de Cortes",
          QuantidadeDePAX: "Quantidade de PAX"
        },

        tituloTotaisDoModeloPorPeriodo: "Totais do modelo por período",

        tabelaTotaisDoModeloPorPeriodo: {
          DataInicial: "Data Inicial",
          DataFinal: "Data Final",
          Frota: "Frota",
          QuantidadeDeVoos: "Quantidade de Voos",
          QuantidadeDePousos: "Quantidade de Pousos",
          QuantidadeDeCortes: "Quantidade de Cortes",
          QuantidadeDePAX: "Quantidade de PAX"
        },

        tituloTotalGeralPorData: "Total Geral por data",

        tabelaTotalGeralPorData: {
          Data: "Data",
          QuantidadeDeVoos: "Quantidade de Voos",
          QuantidadeDePousos: "Quantidade de Pousos",
          QuantidadeDeCortes: "Quantidade de Cortes",
          QuantidadeDePAX: "Quantidade de PAX"
        },

        tituloTotalGeralPorPeriodo: "Total Geral por período",

        tabelaTotalGeralPorPeriodo: {
          DataInicial: "Data Inicial",
          DataFinal: "Data Final",
          Base: "Base",
          QuantidadeDeVoos: "Quantidade de Voos",
          QuantidadeDePousos: "Quantidade de Pousos",
          QuantidadeDeCortes: "Quantidade de Cortes",
          QuantidadeDePAX: "Quantidade de PAX"
        }

      },

      RelatorioDeOcorrenciasAnormais: {
        titulo: "Relatório de Ocorrências Anormais",

        formulario: {
          DataInicial: "Data Inicial",
          DataFinal: "Data Final",
          SomenteAprovados: "Somente aprovados",
          RelatorioDeVoo: "Relatório de Voo",
          Aeronave: "Aeronave",
          Frota: "Frota",

          placeholder: {
            InformeONumeroDoRelatorioDeVoo: "Informe o número do relatório de voo"
          }
        },

        tabela: {
          Data: "Data",
          Prefixo: "Prefixo",
          Frota: "Frota",
          Base: "Base",
          TipoDeVoo: "Tipo de Voo",
          Contrato: "Contrato",
          Cliente: "Cliente",
          NumeroRelatorio: "N° Relatório",
          NumeroDoVoo: "N° do Voo",
          TipoDeOcorrencia: "Tipo de Ocorrência",
          DescricaoDaOcorrencia: "Descrição da Ocorrência",
          AcaoRequerida: "Ação Requerida",
          Observacoes: "Observações",
          Tripulantes: "Tripulantes"
        }

      },

      ControleDiarioDeUtilizacaoDeAeronavesContratadas: {
        osCamposDataClienteEBaseSaoObrigatoriosParaExportacaoEmPDF: "Os campos Data, Cliente e Base são obrigatórios para exportação em PDF.",

        titulo: "Controle Diário de Utilização de Aeronaves Contratadas",

        formulario: {
          Data: "Data",
          SomenteAprovados: "Somente aprovados",
          Base: "Base",
          Aeronave: "Aeronave",
          Contrato: "Contrato",
          Cliente: "Cliente",
          BaseContratual: "Base Contratual"
        },

        tabela: {
          Prefixo: "Prefixo",
          Frota: "Frota",
          Contrato: "Contrato",
          CodigoSAP: "Código SAP",
          TempoTotalDeVooNaDataDecolagemAoPouso: "Tempo Total de Voo na Data - Decolagem ao Pouso",
          TempoTotalDeVooNoDataPartidaAoCorte: "Tempo Total de Voo no Data - Partida ao Corte",
          IndisponibilidadesMotivos: "Indisponibilidades - Motivos",
          IndisponibilidadesHoras: "Indisponibilidades - Horas"
        }
      },

      BoletimDeDisponibilidade: {
        titulo: "Boletim de disponibilidade",

        formulario: {
          DataInicial: "Data Inicial",
          DataFinal: "Data Final",
          Contrato: "Contrato",
          SomenteAprovados: "Somente aprovados",
          BaseContratual: "Base Contratual"
        },

        tabela: {
          Contrato: "Contrato",
          Prefixo: "Prefixo",
          Data: "Data",
          TipoDeContrato: "Tipo de Contrato",
          VooDecolagemAoPouso: "Voo - Decolagem ao Pouso",
          VooPartidaAoCorte: "Voo - Partida ao Corte",
          QtdPousos: "Qtd. Pousos",
          QtdPartidas: "Qtd. Partidas",
          VooTotalDecolagemAoPouso: "Voo Total - Decolagem ao Pouso",
          DuracaoMediaDeVooDecolagemAoPouso: "Duração Média de Voo - Decolagem ao Pouso",
          VooTotalPartidaAoCorte: "Voo Total - Partida ao Corte",
          DuracaoMediaDeVooPartidaAoCorte: "Duração Média de Voo - Partida ao Corte",
          MaximoDeDisponibilidadeContratual: "Máximo de Disponibilidade Contratual",
          IndisponibilidadeReal: "Indisponibilidade Real",
          IndisponibilidadeContratual: "Indisponibilidade Contratual",
          DisponibilidadeReal: "Disponibilidade Real",
          DisponibilidadeContratual: "Disponibilidade Contratual",
          TipoMPRG: "Tipo MPRG",
          TipoMNPR: "Tipo MNPR",
          TipoOPS: "Tipo OPS",
          OcorrenciaAnormal: "Ocorrência Anormal"
        },

        tituloTotais: "Totais",

        tabelaTotais: {
          Contrato: "Contrato",
          Prefixo: "Prefixo",
          TipoDeContrato: "Tipo de Contrato",
          QtdPousos: "Qtd. Pousos",
          QtdPartidas: "Qtd. Partidas",
          VooTotalDecolagemAoPouso: "Voo Total - Decolagem ao Pouso",
          VooTotalPartidaAoCorte: "Voo Total - Partida ao Corte",
          DuracaoMediaDeVooDecolagemAoPouso: "Duração Média de Voo - Decolagem ao Pouso",
          DuracaoMediaDeVooPartidaAoCorte: "Duração Média de Voo - Partida ao Corte",
          TempoTotalRegistrado: "Tempo Total Registrado",
          MaximoDeDisponibilidadeContratual: "Máximo de Disponibilidade Contratual",
          IndisponibilidadeReal: "Indisponibilidade Real",
          IndisponibilidadeContratual: "Indisponibilidade Contratual",
          DisponibilidadeReal: "Disponibilidade Real",
          DisponibilidadeContratual: "Disponibilidade Contratual",
          TipoMPRG: "Tipo MPRG",
          TipoMNPR: "Tipo MNPR",
          TipoOPS: "Tipo OPS",
          OcorrenciaAnormal: "Ocorrência Anormal",

          PorcentagemIndisponibilidadeReal: "% Indisponibilidade Real",
          PorcentagemIndisponibilidadeContratual: "% Indisponibilidade Contratual",
          PorcentagemDisponibilidadeReal: "% Disponibilidade Real",
          PorcentagemDisponibilidadeContratual: "% Disponibilidade Contratual",
          PorcentagemTipoMPRG: "% Tipo MPRG",
          PorcentagemTipoMNPR: "% Tipo MNPR",
          PorcentagemTipoOPS: "% Tipo OPS",
          PorcentagemAproveitamentoDecolagemAoPouso: "% Aproveitamento - Decolagem ao Pouso",
          PorcentagemAproveitamentoPartidaAoCorte: "% Aproveitamento - Partida ao Corte"
        }

      },

      FichasDeDisponibilidade: {
        titulo: "Fichas de disponibilidade",

        formulario: {
          DataInicial: "Data Inicial",
          DataFinal: "Data Final",
          Aeronave: "Aeronave",
          Contrato: "Contrato",
          Base: "Base"
        },

        tabela: {
          Prefixo: "Prefixo",
          Contrato: "Contrato",
          InicioDisponibilidadeContratual: "Início disp. contratual",
          FimDispContratual: "Fim disp. contratual",
          InicioIndisponibilidade: "Início indisp.",
          FimIndisponibilidade: "Fim indisp.",
          Franquia: "Franquia",
          IndisponibilidadeTotal: "Indisp. Total",
          SemFranquia: "Sem franquia",
          TempoTotal: "Tempo total"
        }
      },

      RelatorioDeConsumo: {
        titulo: "Relatório de Consumo",

        formulario: {
          DataInicial: "Data Inicial",
          DataFinal: "Data Final",
          SomenteAprovados: "Somente aprovados",
          RelatorioDeVoo: "Relatório de Voo",
          Aeronave: "Aeronave",
          Frota: "Frota",
          Base: "Base",
          TipoDeVoo: "Tipo de Voo",
          Contrato: "Contrato",
          Cliente: "Cliente",
          NumeroDeReciboDoCombustivel: "N° de Recibo do Combustível",
          FornecedorDeCombustivel: "Fornecedor de Combustível",
          BaseContratual: "Base Contratual",

          placeholder: {
            InformeONumeroDoRelatorioDeVoo: "Informe o número do relatório de voo"
          }
        },

        tabela: {
          Data: "Data",
          Prefixo: "Prefixo",
          Frota: "Frota",
          Base: "Base",
          TipoDeVoo: "Tipo de Voo",
          Contrato: "Contrato",
          Cliente: "Cliente",
          NumeroRelatorio: "N° Relatório",
          NumeroDoVoo: "N° do Voo",
          Isencao: "Isenção",
          TotalVooDecolagemAoPouso: "Total Voo - Decolagem ao Pouso",
          TotalDoVooPartidaAoCorte: "Total do Voo - Partida ao Corte",
          TotalDoVooNavegacao: "Total do Voo - Navegação",
          TotalDoVooInstrumento: "Total do Voo - Instrumento",
          TotalDoVooNoturno: "Total do Voo - Noturno",
          TotalDoVooPartidas: "Total do Voo - Partidas",
          TotalDoVooPousosDiurnos: "Total do Voo - Pousos Diurnos",
          TotalDoVooPousosNoturnos: "Total do Voo - Pousos Noturnos",
          TotalDoVooPAX: "Total do Voo - PAX",
          TotalDoVooCarga: "Total do Voo - Carga",
          TipoDeContrato: "Tipo de Contrato",
          CombustivelAutorizado: "Combustível Autorizado",
          FornecedorDeCombustivel: "Fornecedor de Combustível",
          NumeroDaCE: "N° da CE",
          QuantidadeSolicitada: "Quantidade Solicitada",
          QuantidadeAbastecida: "Quantidade Abastecida",
          QuantidadeAbastecidaConvertida: "Quantidade Abastecida Convertida",
          Saldo: "Saldo",
          Consumo: "Consumo",
          ConsumoEmLitros: "Consumo em litros"
        },

        tituloTotais: "Totais",

        tabelaTotais: {
          Prefixo: "Prefixo",
          Frota: "Frota",
          TotalVooDecolagemAoPouso: "Total Voo - Decolagem ao Pouso",
          TotalDoVooPartidaAoCorte: "Total do Voo - Partida ao Corte",
          TotalDoVooNavegacao: "Total do Voo - Navegação",
          TotalDoVooInstrumento: "Total do Voo - Instrumento",
          TotalDoVooNoturno: "Total do Voo - Noturno",
          TotalDoVooPartidas: "Total do Voo - Partidas",
          TotalDoVooPousosDiurnos: "Total do Voo - Pousos Diurnos",
          TotalDoVooPousosNoturnos: "Total do Voo - Pousos Noturnos",
          TotalDoVooPAX: "Total do Voo - PAX",
          TotalDoVooCarga: "Total do Voo - Carga",
          CombustivelAutorizado: "Combustível Autorizado",
          QuantidadeSolicitada: "Quantidade Solicitada",
          QuantidadeAbastecida: "Quantidade Abastecida",
          QuantidadeAbastecidaConvertida: "Quantidade Abastecida Convertida",
          Saldo: "Saldo",
          Consumo: "Consumo",
          ConsumoEmLitros: "Consumo em litros"
        }
      },

      RelatorioDeDisponibilidadeDeCombustivel: {
        titulo: "Relatório de Disponibilidade de Combustível",

        formulario: {
          MesInicio: "Mês Início",
          MesTermino: "Mês Término",
          Aeronave: "Aeronave",
          Base: "Base",
          Cliente: "Cliente",
          SomenteAprovados: "Somente aprovados"
        },

        tabela: {
          Inicio: "Início",
          Fim: "Fim",
          Aeronave: "Aeronave",
          Frota: "Frota",
          Contrato: "Contrato",
          Cliente: "Cliente",
          QuantidadeAbastecida: "Quantidade Abastecida",
          QuantidadeAbastecidaConvertida: "Quantidade Abastecida Convertida",
          Consumo: "Consumo",
          CAutorizado: "C. Autorizado",
          Saldo: "Saldo",
          HorasTotais: "Horas totais",
          Dias: "Dias",
          MediaDeHorasDeVooPorDia: "Média de Horas de Voo por Dia",
          MediaDeConsumoPorDia: "Média de Consumo por Dia",
          MediaDeConsumoPorHorasDeVoo: "Média de Consumo por Horas de voo"
        }

      },

      ExtratoDeDBEmBloco: {
        titulo: "Extrato de DB em bloco",

        formulario: {
          DataInicial: "Data Inicial",
          DataFinal: "Data Final",
          Aeronave: "Aeronave",
          Contrato: "Contrato",
          Base: "Base",
          BasesContratual: "Bases Contratual",
          SomenteAprovados: "Somente aprovados"
        },

        tabela: {
          Data: "Data",
          Prefixo: "Prefixo",
          Frota: "Frota",
          Base: "Base",
          Contrato: "Contrato",
          Cliente: "Cliente",
          NumeroRelatorio: "N° Relatório",
          NumeroDoVoo: "N° do Voo"
        }

      },

      RelatorioDePousosPorLocalidade: {
        titulo: "Relatório de Pousos por Localidade",

        formulario: {
          DataInicial: "Data Inicial",
          DataFinal: "Data Final",
          SomenteAprovados: "Somente aprovados",
          Local: "Local",
          RelatorioDeVoo: "Relatório de Voo",
          Aeronave: "Aeronave",
          Frota: "Frota",

          placeholder: {
            InformeONumeroDoRelatorioDeVoo: "Informe o número do relatório de voo"
          }
        },

        tabela: {
          Data: "Data",
          Prefixo: "Prefixo",
          Frota: "Frota",
          Base: "Base",
          TipoDeVoo: "Tipo de Voo",
          Contrato: "Contrato",
          Cliente: "Cliente",
          NumeroRelatorio: "N° Relatório",
          NumeroDoVoo: "N° do Voo",
          Origem: "Origem",
          Destino: "Destino",
          Tripulantes: "Tripulantes",
          DEPARR: "DEP-ARR",
          Total: "Total",
          TotalDePousosDaAnvNaData: "Total de pousos da anv na data",
          TotalDePousosDaAnvNoPeriodo: "Total de pousos da anv no período",
          TotalDePousosDaFrotaNoPeriodo: "Total de pousos da frota no período",
          TotalDePousosGeralNoPeriodo: "Total de pousos geral no período"
        }

      },

      ApuracaoDeHoras: {
        titulo: "Apuração de horas",

        formulario: {
          DataInicial: "Data Inicial",
          DataFinal: "Data Final",
          Aeronave: "Aeronave",
          BaseContratual: "Base Contratual",
          Contrato: "Contrato",
          Cliente: "Cliente",
          Indisponibilidade: "Indisponibilidade",

          opcoesIndisponibilidade: {
            NaoExibir: "Não Exibir",
            ExibirApenasTotal: "Exibir apenas Total",
            ExibirApenasContratual: "Exibir apenas Contratual",
            ExibirTodas: "Exibir Todas"
          },

          SomenteAprovados: "Somente aprovados"
        },

        tabela: {
          Data: "Data",
          Contrato: "Contrato",
          PrefixoContratual: "Prefixo Contratual",
          Backup: "Backup",
          NumeroDoRelatorioDeVoo: "N° do Relatório de Voo",
          NumeroDoVoo: "N° do Voo",
          TipoDeContrato: "Tipo de Contrato",
          TempoTotalDeVooDecolagemAoPouso: "Tempo Total de Voo - Decolagem ao Pouso",
          TempoTotalDeVooPartidaAoCorte: "Tempo Total de Voo - Partida ao Corte",
          CombustivelConsumido: "Combustível consumido",
          CombustivelAbastecido: "Combustível abastecido",
          IndisponibilidadeDiariaTotal: "Indisponibilidade Diária - Total",
          IndisponibilidadeDiariaContratual: "Indisponibilidade Diária - Contratual"
        }

      },

      RelatorioDeTempoEmSolo: {
        titulo: "Relatório de Tempo em Solo",

        formulario: {
          DataInicial: "Data Inicial",
          DataFinal: "Data Final",
          SomenteAprovados: "Somente aprovados",
          Local: "Local",
          Aeronave: "Aeronave",
          Frota: "Frota"
        },

        tabela: {
          Data: "Data",
          Prefixo: "Prefixo",
          Frota: "Frota",
          Base: "Base",
          TipoDeVoo: "Tipo de Voo",
          Contrato: "Contrato",
          Cliente: "Cliente",
          NumeroRelatorio: "N° Relatório",
          NumeroDoVoo: "N° do Voo",
          Origem: "Origem",
          Destino: "Destino",
          Tripulantes: "Tripulantes",
          DEPARR: "DEP-ARR",
          Total: "Total"
        }
      },

      RelatorioDeTempoEntreTrechos: {
        titulo: "Relatório de Tempo entre Trechos",

        formulario: {
          DataInicial: "Data Inicial",
          DataFinal: "Data Final",
          SomenteAprovados: "Somente aprovados",
          RelatorioDeVoo: "Relatório de Voo",
          Aeronave: "Aeronave",
          Frota: "Frota",

          placeholder: {
            InformeONumeroDoRelatorioDeVoo: "Informe o número do relatório de voo"
          }
        },

        tabela: {
          Data: "Data",
          Prefixo: "Prefixo",
          Frota: "Frota",
          Base: "Base",
          TipoDeVoo: "Tipo de Voo",
          Contrato: "Contrato",
          Cliente: "Cliente",
          NumeroRelatorio: "N° Relatório",
          NumeroDoVoo: "N° do Voo",
          Tripulantes: "Tripulantes",
          QuantidadeDeTrechos: "Quantidade de trechos",
          TempoEntreTrechos: "Tempo entre Trechos",
          TotalDoVooDEPARR: "Total do Voo - DEP-ARR",
          TotalDoVooTempoTotal: "Total do Voo - Tempo Total"
        }

      },

      ControleGeralDeRelatorios: {
        titulo: "Controle Geral de Relatórios",

        formulario: {
          DataInicial: "Data Inicial",
          DataFinal: "Data Final",
          AnaliticoOuSintetico: "Analítico ou Sintético",

          opcoesAnaliticoOuSintetico: {
            AnaliticoPorTripulante: "Analítico - Por Tripulante",
            AnaliticoPorRelatorio: "Analítico - Por Relatório",
            Sintetico: "Sintético"
          },

          SomenteAprovados: "Somente aprovados",
          RelatorioDeVoo: "Relatório de Voo",
          NumeroDoVoo: "N° do Voo",
          Aeronave: "Aeronave",
          Frota: "Frota",
          Base: "Base",
          TipoDeVoo: "Tipo de Voo",
          Contrato: "Contrato",
          Isencao: "Isenção",
          CargaExterna: "Carga externa",
          Cliente: "Cliente",
          BasesContratual: "Bases Contratual",

          placeholder: {
            InformeONumeroDoRelatorioDeVoo: "Informe o número do relatório de voo",
            InformeONumeroDoVoo: "Informe o número do voo"
          }
        },

        tabela: {
          Data: "Data",
          Prefixo: "Prefixo",
          Frota: "Frota",
          Base: "Base",
          TipoDeVoo: "Tipo de Voo",
          Contrato: "Contrato",
          Cliente: "Cliente",
          NumeroRelatorio: "N° Relatório",
          NumeroDoVoo: "N° do Voo",
          Isencao: "Isenção",
          TotalDoVooDEPARR: "Total do Voo - DEP-ARR",
          TotalDoVooTempoTotal: "Total do Voo - Tempo Total",
          TotalDoVooNavegacao: "Total do Voo - Navegação",
          TotalDoVooInstrumento: "Total do Voo - Instrumento",
          TotalDoVooNoturno: "Total do Voo - Noturno",
          TotalDoVooPousosDiurnos: "Total do Voo - Pousos Diurnos",
          TotalDoVooPousosNoturnos: "Total do Voo - Pousos Noturnos",
          TotalDoVooPAX: "Total do Voo - PAX",
          TotalDoVooCarga: "Total do Voo - Carga",
          TotalDoVooConsumo: "Total do Voo - Consumo",
          QuantidadeAbastecida: "Quantidade abastecida",
          Observacoes: "Observações",

          FB: "FB",
          Apresentacao: "Apresentação",
          Matricula: "Matrícula",
          Tripulante: "Tripulante",
          Etapa: "Etapa",
          Origem: "Origem",
          Destino: "Destino",
          HrPart: "Hr. Part.",
          DEP: "DEP.",
          ARR: "ARR.",
          Corte: "Corte",
          DEPARR: "DEP-ARR",
          TempoTotal: "Tempo - Total",
          TempoNavegacao: "Tempo - Navegação",
          TempoInstrumento: "Tempo - Instrumento",
          TempoNoturno: "Tempo - Noturno",
          PousosDiurnos: "Pousos - Diurnos",
          PousosNoturnos: "Pousos - Noturnos",
          Partidas: "Partidas",
          PAX: "PAX.",
          Carga: "Carga",
          CargaExternaLongLine: "Carga Externa - Long Line",
          CargaExternaShortLine: "Carga Externa - Short Line",
          CombustivelInicial: "Combustível - Inicial",
          CombustivelFinal: "Combustível - Final"
        }

      },

      ExtratoDeRelatorioDeVooEmBloco: {
        titulo: "Extrato de Relatório de Voo em bloco",

        formulario: {
          DataInicial: "Data Inicial",
          DataFinal: "Data Final",
          Aeronave: "Aeronave",
          Contrato: "Contrato",
          Base: "Base",
          Tripulantes: "Tripulantes",
          BasesContratual: "Bases Contratual",
          SomenteAprovados: "Somente aprovados",
          linguagem: "Linguagem"
        },

        tabela: {
          Data: "Data",
          Prefixo: "Prefixo",
          Frota: "Frota",
          Base: "Base",
          Contrato: "Contrato",
          Cliente: "Cliente",
          NumeroRelatorio: "N° Relatório",
          NumeroDoVoo: "N° do Voo"
        }

      },

      ConferenciaDeMedicao: {
        titulo: "Conferência de medição",

        formulario: {
          DataInicial: "Data Inicial",
          DataFinal: "Data Final",
          Contrato: "Contrato",
          Cliente: "Cliente",
          TipoDeMedicao: "Tipo de Medição",

          opcoesMedicao: {
            Sintetica: "Sintética",
            Analitica: "Analítica"
          },

          SomenteAprovados: "Somente aprovados",
          BaseContratual: "Base Contratual"
        },

        tabela: {
          Contrato: "Contrato",
          PrefixoContrato: "Prefixo contrato",
          Status: "Status",
          NumeroDoVoo: "N° do Voo",
          Cliente: "Cliente",
          CodigoPTBR: "Código PTBR",
          LocalidadeInicio: "Localidade - início",
          LocalidadeFim: "Localidade - fim",
          Prefixo: "Prefixo",
          Inicio: "Início",
          Fim: "Fim"
        }
      },

      RelatorioDeVoosComCargaExterna: {
        titulo: "Relatório de Voos com Carga Externa",

        formulario: {
          DataInicial: "Data Inicial",
          DataFinal: "Data Final",
          SomenteAprovados: "Somente aprovados",
          RelatorioDeVoo: "Relatório de Voo",
          Aeronave: "Aeronave",
          Frota: "Frota",
          Tripulantes: "Tripulantes",

          placeholder: {
            InformeONumeroDoRelatorioDeVoo: "Informe o número do relatório de voo"
          }
        },

        tabela: {
          Data: "Data",
          Prefixo: "Prefixo",
          Frota: "Frota",
          Base: "Base",
          TipoDeVoo: "Tipo de Voo",
          Contrato: "Contrato",
          Cliente: "Cliente",
          NumeroRelatorio: "N° Relatório",
          NumeroDoVoo: "N° do Voo",
          Tripulantes: "Tripulantes",
          TotalDoVooDEPARR: "Total do Voo - DEP-ARR",
          TotalDoVooTempoTotal: "Total do Voo - Tempo Total",
          CargaExternaLongLine: "Carga Externa - Long Line",
          CargaExternaShortLine: "Carga Externa - Short Line"
        }

      },

      RelatorioDePontualidade: {
        titulo: "Relatório de Pontualidade",

        formulario: {
          DataInicial: "Data Inicial",
          DataFinal: "Data Final",
          Base: "Base",
          SomenteAprovados: "Somente aprovados",
          TipoDeAtraso: "Tipo de atraso",

          opcoesTiposDeAtraso: {
            Decolagem: "Decolagem",
            TempoDeVoo: "Tempo de voo"
          }
        },

        tabela: {
          EstatisticasDeVooDe: function EstatisticasDeVooDe(dataInicial, dataFinal) {
            return "Estast\xEDsticas de Voo de " + dataInicial + " a " + dataFinal;
          },


          Tipo: "Tipo",
          Valor: "Valor",
          TempoTotalDeAtraso: "Tempo Total de Atraso",
          Atrasados: "Atrasados",
          Pontuais: "Pontuais",
          MediaTempo: "Média Tempo",
          Operacoes: "Operações",
          Coordenacao: "Coordenação",
          Despacho: "Despacho",
          Manutencao: "Manutenção",
          NumeroVoos: "Nº Voos",
          AtrasadosInterno: "Atrasados Int",
          AtrasadosExterno: "Atrasados Ext",
          Pontualidade: "Pontualidade",
          PontualidadeSemAtrasoExterno: "Pont (s/ atrasos ext)",
          PontualidadeSemAtrasoInterno: "Pont (s/ atrasos int)",
          VooManutencao: "Voo Manutenção",
          VooGiros: "Voo Giros",
          VooTreinamento: "Voo Treinamento",
          VooPTBR: "Voo PTBR",
          VooOutrosClientes: "Voo Outros Clientes",
          VoosComerciais: "Voos Comerciais"
        }

      },

      RelatorioDeAbastecimentos: {
        titulo: "Relatório de Abastecimentos",

        formulario: {
          DataInicial: "Data Inicial",
          DataFinal: "Data Final",
          SomenteAprovados: "Somente aprovados",
          RelatorioDeVoo: "Relatório de Voo",
          Aeronave: "Aeronave",
          Frota: "Frota",
          Base: "Base",
          TipoDeVoo: "Tipo de Voo",
          Contrato: "Contrato",
          NumeroDeReciboDoCombustivel: "N° de Recibo do Combustível",
          FornecedorDeCombustivel: "Fornecedor de Combustível",

          placeholder: {
            InformeONumeroDoRelatorioDeVoo: "Informe o número do relatório de voo",
            InformeONumeroDeReciboDoCombustivel: "Informe o número de recibo de combustível"
          }
        },

        tabela: {
          ID: "ID",
          Data: "Data",
          Aeronave: "Aeronave",
          Modelo: "Modelo",
          NumeroRelatorioDeVoo: "N° Relatório de Voo",
          TipoDeVoo: "Tipo de Voo",
          FornecedorDeCombustivel: "Fornecedor de Combustível",
          NumeroDoRecibo: "N° do Recibo",
          QuantidadeDeCombustivel: "Quantidade de Combustível"
        }

      },

      ExtracaoDeXMLEmBloco: {
        titulo: "Extração de XML em bloco",

        formulario: {
          DataInicial: "Data Inicial",
          DataFinal: "Data Final",
          Aeronave: "Aeronave",
          Cliente: "Cliente",
          Contrato: "Contrato",
          Base: "Base",
          SomenteAprovados: "Somente aprovados",
          BaseContratual: "Base Contratual"
        },

        tabela: {
          Data: "Data",
          Prefixo: "Prefixo",
          Frota: "Frota",
          Base: "Base",
          Contrato: "Contrato",
          Cliente: "Cliente",
          NumeroRelatorio: "N° Relatório",
          NumeroDoVoo: "N° do Voo"
        }

      }
    },

    Layout: {
      Topo: {
        bemvindo: "Bem-vindo,",

        botaoMinhaConta: "Minha Conta",
        botaoSair: "Sair",

        menuDadosBasicos: {
          tituloMenu: "Dados Básicos",

          FileDigital: "File Digital"
        },

        menuVoos: (_menuVoos = {
          tituloMenu: "Voos",
          Abastecimentos: "Abastecimentos",
          ListaDeAbastecimentos: "Lista de abastecimentos",
          CadastrarAbastecimentoAvulso: "Cadastrar abastecimento avulso",
          Relatorios: "Relatórios"
        }, _defineProperty(_menuVoos, "Relatorios", "Relatórios"), _defineProperty(_menuVoos, "ListaDeRelatoriosDeVoo", "Lista de relatórios de voo"), _defineProperty(_menuVoos, "CadastrarRelatorioDeVoo", "Cadastrar relatório de voo"), _defineProperty(_menuVoos, "ListaDeRelatoriosDeVooOffline", "Lista de relatórios de voo offline"), _defineProperty(_menuVoos, "Controle", "Controle"), _defineProperty(_menuVoos, "VisualizarHoraDeVoo", "Visualizar hora de vôo"), _defineProperty(_menuVoos, "ControleGeralDeRelatorios", "Controle Geral de Relatórios"), _defineProperty(_menuVoos, "ExtratoDeDBEmBloco", "Extrato de DB em bloco"), _defineProperty(_menuVoos, "ExtratoDeRelatoriosEmBloco", "Extrato de Relatórios em bloco"), _menuVoos),

        menuEscalas: {
          tituloMenu: "Escalas",

          EscalasDeMissao: "Escalas de Missão",
          EscalaDeMissao: "Escala de Missão",
          SolicitacoesDeEscala: "Solicitações de Escala",
          CadastrarSolicitacao: "Cadastrar Solicitação",
          ListaDeSolicitacoes: "Lista de Solicitações",
          EscalaDiaria: "Escala diária",
          ListaDeEscalasDiaria: "Lista de escalas diária"
        },

        menuTreinamentos: {
          tituloMenu: "Treinamentos",

          ComunicadosDeTreinamento: "Comunicados de Treinamento",
          ListaDeLogbooks: "Lista de logbooks"
        },

        menuPagamentos: {
          tituloMenu: "Pagamentos",

          Pagamentos: "Pagamentos",
          ExtratoPorReferencia: "Extrato por Referência",
          ExtratoPorPagamento: "Extrato por Pagamento",
          SolicitacoesDePagamento: "Solicitações de Pagamento",
          DeslocamentoDeMissao: "Deslocamento de Missão",
          DeslocamentoDeTreinamento: "Deslocamento de Treinamento",
          TransporteDeMissao: "Transporte de Missão",
          TransporteDeTreinamento: "Transporte de Treinamento"
        },

        menuFIRA: {
          tituloMenu: "FIRA",

          PapeletasIndividuaisFIRA: "Papeletas individuais (FIRA)",
          ListaDePapeletas: "Lista de Papeletas",
          Consulta: "Consulta",
          ControleDeFIRA: "Controle de FIRA"
        },

        menuFRMS: {
          tituloMenu: "FRMS",
          AdicionarDiscrepancia: "Discrepância técnica",
          RelatoriosDeFadiga: "Relatórios de fadiga",
          ListaDeRelatoriosDeFadigas: "Lista de relatórios de fadigas",
          CadastrarRelatoriosDeFadiga: "Cadastrar relatórios de fadiga",
          ReporteVoluntarioDeFadiga: "Reporte voluntário de fadiga",
          ReportarFadiga: "Reportar fadiga",
          FerramentaDeAuxilioParaAutoavaliacaoDaFadigaFAPA: "Ferramenta de Auxílio para Autoavaliação da Fadiga (FAPA)",
          Cadastrar: "Cadastrar"
        },

        menuPendencias: {
          OUsuarioNaoPossuiPendencias: "O usuário não possui pendências",
          Documentacao: "Documentação",
          Papeletas: "Papeletas",
          Escalas: "Escalas",
          Voos: "Voos",
          Treinamentos: "Treinamentos"
        },

        menuConfiguracoes: {
          App: "App",
          InstalacaoMobile: "Instalação Mobile",
          Diversos: "Diversos",
          LinksUteis: "Links Úteis"
        },

        atencaoVoceEstaUtilizandoOAmbienteDeHomologacao: "Atenção: Você está utilizando o ambiente de homologação"

      }
    },

    Miscelania: {
      Overlay: {
        paragrafoCarregando: "Carregando..."
      },

      RequestApi: {
        seuUsuarioNaoTemPermissaoParaAcessarEstaPagina: "Seu usuário não tem permissão para acessar esta página.",
        seuUsuarioNaoTemPermissaoParaAcessarEstaFuncionalidade: "Seu usuário não tem permissão para acessar esta funcionalidade."
      }
    },

    Pagamentos: {
      Bases: {
        botaoLocalidades: "Localidades",

        titulo: "Bases",

        tabela: {
          Nome: "Nome",
          Tipo: "Tipo",
          CEP: "CEP",
          Base: "Base",

          botaoAssociarCEPAOrigem: "Associar CEP à origem",
          botaoAssociarCEPADestino: "Associar CEP à destino",

          Fornecedor: "Fornecedor"
        }
      },

      AdicionarSolicitacaoDePagamentoMissaoDeslocamento: {

        titulo: "Adicionar solicitação de pagamento - missão - deslocamento",

        formulario: {
          EscalaGrade: "Escala / Grade",
          Quantidade: "Quantidade",
          DataInicial: "Data inicial",
          DataFinal: "Data final",
          Valor: "Valor",
          Moeda: "Moeda",
          ValorTotal: "Valor total",
          Observacao: "Observação",

          tituloTrechos: "Trechos",

          botaoAdicionarTrecho: "Adicionar Trecho",

          tabela: {
            BuscarLocais: "Buscar Locais",
            BaseOrigem: "Base Origem",
            FornecedorOrigem: "Fornecedor Origem",
            CEPOrigem: "CEP Origem",
            BaseDestino: "Base Destino",
            FornecedorDestino: "Fornecedor Destino",
            CEPDestino: "CEP Destino"
          },

          botaoCalcular: "Calcular",

          botaoSalvarSolicitacao: "Salvar solicitação",

          placeholder: {
            SelecionarEscala: "Selecionar escala",
            SelecionarMoeda: "Selecionar moeda",
            Observacao: "Observação"
          }
        }
      },

      SolicitacoesDePagamentoDeslocamentoMissao: {
        deletar: "Tem certeza que gostaria de deletar essa solicitação?",

        titulo: "Solicitações de Pagamento - Deslocamento - Missão",

        botaoSolicitarPagamentoDeDeslocamentoMissao: "Solicitar pagamento de deslocamento - Missão",

        tabela: {
          semSolicitacaoDePagamento: "Não há solicitação de pagamento cadastrada",
          ID: "ID",
          Status: "Status",
          Lote: "Lote",
          Frota: "Frota",
          Mes: "Mês",
          Revisao: "Revisão",
          Inicio: "Início",
          Fim: "Fim",
          Quantidade: "Quantidade",
          Valor: "Valor",
          ValorTotal: "Valor Total",
          Moeda: "Moeda",
          Observacao: "Observação",
          Acoes: "Ações"
        },

        tituloBases: "Bases",

        tabelaBases: {
          Origem: "Origem",
          CEPOrigem: "CEP Origem",
          Destino: "Destino",
          CEPDestino: "CEP Destino"
        }
      },

      AdicionarSolicitacaoDePagamentoMissaoTransporte: {
        titulo: "Adicionar solicitação de pagamento - missão - transporte",

        formulario: {
          EscalaGrade: "Escala / Grade",
          Quantidade: "Quantidade",
          DataInicial: "Data inicial",
          DataFinal: "Data final",
          Valor: "Valor",
          Moeda: "Moeda",
          ValorTotal: "Valor total",
          Base: "Base",
          Observacao: "Observação",

          botaoSalvarPagamento: "Salvar pagamento",

          placeholder: {
            SelecionarEscala: "Selecionar escala",
            SelecionarMoeda: "Selecionar moeda",
            SelecionarBase: "Selecionar base",
            Observacao: "Observação"
          }
        }
      },

      SolicitacoesDePagamentoTransporteMissao: {
        deletar: "Tem certeza que gostaria de deletar essa solicitação?",

        titulo: "Solicitações de Pagamento - Transporte - Missão",

        botaoSolicitarPagamentoDeTransporteMissao: "Solicitar pagamento de transporte - Missão",

        tabela: {
          semSolicitacaoDePagamento: "Não há solicitação de pagamento cadastrada",
          ID: "ID",
          Status: "Status",
          Lote: "Lote",
          Frota: "Frota",
          Mes: "Mês",
          Base: "Base",
          Revisao: "Revisão",
          Quantidade: "Quantidade",
          Valor: "Valor",
          Moeda: "Moeda",
          Observaco: "Observação",
          Acoes: "Ações"
        }
      },

      AdicionarSolicitacaoDePagamentoTreinamentoDeslocamento: {
        titulo: "Adicionar solicitação de pagamento - treinamento - deslocamento",

        formulario: {
          Treinamento: "Treinamento",
          Quantidade: "Quantidade",
          DataInicial: "Data inicial",
          DataFinal: "Data final",
          Valor: "Valor",
          Moeda: "Moeda",
          ValorTotal: "Valor total",
          Observacao: "Observação",

          placeholder: {
            SelecionarTreinamento: "Selecionar treinamento",
            SelecionarMoeda: "Selecionar moeda",
            Observacao: "Observação"
          },

          tituloTrechos: "Trechos",

          botaoAdicionarTrecho: "Adicionar Trecho",

          tabela: {
            BuscarLocais: "Buscar Locais",
            BaseOrigem: "Base Origem",
            FornecedorOrigem: "Fornecedor Origem",
            CEPOrigem: "CEP Origem",
            BaseDestino: "Base Destino",
            FornecedorDestino: "Fornecedor Destino",
            CEPDestino: "CEP Destino"
          },

          botaoCalcular: "Calcular",
          botaoSalvarSolicitacao: "Salvar solicitação"
        }

      },

      SolicitacoesDePagamentoDeslocamentoTreinamento: {
        deletar: "Tem certeza que gostaria de deletar essa solicitação?",

        titulo: "Solicitações de Pagamento - Deslocamento - Treinamento",

        botaoSolicitarPagamentoDeDeslocamentoTreinamento: "Solicitar pagamento de deslocamento - Treinamento",

        tabela: {
          semSolicitacaoDePagamento: "Não há solicitação de pagamento cadastrada",
          ID: "ID",
          Status: "Status",
          Lote: "Lote",
          Treinamento: "Treinamento",
          Revisao: "Revisão",
          Inicio: "Início",
          Fim: "Fim",
          Quantidade: "Quantidade",
          Valor: "Valor",
          ValorTotal: "Valor Total",
          Moeda: "Moeda",
          Observacao: "Observação",
          Acoes: "Ações"
        },

        tituloBases: "Bases",

        tabelaBases: {
          Origem: "Origem",
          CEPOrigem: "CEP Origem",
          Destino: "Destino",
          CEPDestino: "CEP Destino"
        }

      },

      AdicionarSolicitacaoDePagamentoTreinamentoTransporte: {
        titulo: "Adicionar solicitação de pagamento - treinamento - transporte",

        formulario: {
          Treinamento: "Treinamento",
          Quantidade: "Quantidade",
          DataInicial: "Data inicial",
          DataFinal: "Data final",
          Valor: "Valor",
          Moeda: "Moeda",
          ValorTotal: "Valor total",
          Base: "Base",
          Observacao: "Observação",

          botaoSalvarPagamento: "Salvar pagamento",

          placeholder: {
            SelecionarTreinamento: "Selecionar treinamento",
            SelecionarMoeda: "Selecionar moeda",
            SelecionarBase: "Selecionar base",
            Observacao: "Observação"
          }
        }
      },

      SolicitacoesDePagamentoTransporteTreinamento: {
        deletar: "Tem certeza que gostaria de deletar essa solicitação?",

        titulo: "Solicitações de Pagamento - Transporte - Treinamento",

        botaoSolicitarPagamentoDeTransporteTreinamento: "Solicitar pagamento de transporte - Treinamento",

        tabela: {
          semSolicitacaoDePagamento: "Não há solicitação de pagamento cadastrada",
          ID: "ID",
          Status: "Status",
          Lote: "Lote",
          Treinamento: "Treinamento",
          Base: "Base",
          Revisao: "Revisão",
          Quantidade: "Quantidade",
          Valor: "Valor",
          Moeda: "Moeda",
          Observacao: "Observação",
          Acoes: "Ações"
        }

      }
    },

    Escalas: {
      ListaDeEscalaDiaria: {
        botaoDisponivel: "Disponível",
        botaoIndisponivel: "Indisponível",

        deletar: "Tem certeza que gostaria de deletar essa escala?",

        titulo: "Lista de escala diária",

        botaoAdicionarProgramacao: "Adicionar programação",

        formulario: {
          botaoMudarData: "Mudar data"
        },

        tabela: {
          semProgramacaoParaHoje: "Não há programação cadastrada para hoje",
          ID: "ID",
          Base: "Base",
          Aeronave: "Aeronave",
          Modelo: "Modelo",
          Contrato: "Contrato",
          Disponibilidade: "Disponibilidade",
          ComandanteS: "Comandante(s)",
          CopilotoS: "Copiloto(s)",
          ComissarioS: "Comissário(s)",
          Apresentacao: "Apresentação",
          Corte: "Corte",
          Status: "Status",
          Acoes: "Ações"
        }
      },

      AdicionarEscalaDiaria: {
        titulo: "Cadastrar escala diária",

        formulario: {
          Data: "Data",
          Base: "Base",
          Prefixo: "Prefixo",
          Contrato: "Contrato",
          DesejaImportarTripulacaoDaEscala: "Deseja importar tripulação da escala",

          botaoSalvarProgramacao: "Salvar programação"
        }
      },

      EditarEscalaDiaria: {
        trocarOStatusDaEscala: "Tem certeza que gostaria de trocar o status da escala?",
        aprovarEscalaMesmoComAlertasVermelhos: "Tem certeza que gostaria de aprovar a escala mesmo com os alertas vermelhos?",

        titulo: "Editar escala diária",

        tituloEditarEscalaDiariaTripulacaoExtra: "Editar escala diária Tripulação Extra",

        botaoProgramacao: {
          TrocarParaRascunho: "Trocar para Rascunho",
          TrocarParaAprovada: "Trocar para Aprovada"
        },

        botaoAlertas: "Alertas",

        erros: "Os seguintes erros de preenchimento impediram a ficha de indisponibilidade de ser processada",

        tituloDisponibilidadeDaAeronave: "Disponibilidade da Aeronave",

        formularioDisponibilidadeDaAeronave: {
          Disponivel: "Disponível",
          IndisponivelDesde: "Indisponível desde",
          Razao: "Razão",
          Previsao: "Previsão",
          FlightFollowingAnormal: "Flight following anormal",
          AnormalDesde: "Anormal desde",
          InspetorMecanicoResponsavel: "Inspetor / Mecânico Responsável",
          Observacoes: "Observações"
        },

        tituloCriarGrupo: "Criar grupo",

        formularioCriarGrupo: {
          HorarioDeApresentacao: "Horário de Apresentação",
          HorarioDeTerminoDaJornada: "Horário de Término da Jornada",
          Situacao: "Situação",
          Voos: "Vôos",

          botaoAdicionarGrupo: "Adicionar grupo"
        },

        tituloAlertasDeAprovacao: "Alertas de aprovação",

        tabelaAlertasDeAprovacao: {
          Mensagem: "Mensagem",
          Data: "Data"
        },

        tituloLogDeStatus: "Log de status",

        tabelaLogDeStatus: {
          Usuario: "Usuário",
          Acao: "Ação",
          Descricao: "Descrição",
          Justificativa: "Justificativa",
          Data: "Data"
        },

        tituloAlertas: "Alertas",

        formularioAlertas: {
          Justificativa: "Justificativa",

          botaoContinuarAprovacao: "Continuar aprovação"
        },

        //ScheduleGroupStaff abaixo
        deletarTripulante: "Tem certeza que deseja deletar esse tripulante?",
        deletarGrupo: "Tem certeza que deseja deletar esse grupo?",

        tituloGrupoAs: function tituloGrupoAs(Numero, Inicio, Fim) {
          // Verifico se o Fim é nulo, se for, retorno apenas o Inicio
          if (Fim == null) {
            return "Grupo " + Numero + " - " + Inicio;
          }
          return "Grupo " + Numero + " - " + Inicio + " \xE0s " + Fim;
        },


        formularioGrupo: {
          HorarioDeApresentacao: "Horário de Apresentação",
          HorarioDeTerminoDaJornada: "Horário de Término da Jornada",
          Situacao: "Situação",

          botaoEditarGrupo: "Editar grupo"
        },

        formularioAdicionarComandante: {
          Comandante: "Comandante"
        },

        formularioAdicionarCopiloto: {
          Copiloto: "Copiloto"
        },

        formularioAdicionarComissario: {
          Comissario: "Comissário"
        },

        tabelaGrupo: {
          Tripulante: "Tripulante",
          Funcao: "Função"
        }

      },

      ListaDeEscalas: {
        botaoRevisao: "Revisão",

        titulo: "Lista de escalas",
        botaoAdicionarEscala: "Adicionar escala",

        tabela: {
          semEscalasEsteMes: "Não há escalas cadastradas para este mês",
          ID: "ID",
          Frota: "Frota",
          Base: "Base",
          Referencia: "Referência",
          Acoes: "Ações"
        }
      }
    },

    Configuracoes: {

      EditarConfiguracoes: {
        deletarConfiguracao: "Tem certeza que gostaria de deletar essa configuração?",
        deletarTarefa: "Tem certeza que gostaria de deletar essa tarefa?",

        titulo: "Edição de configurações de fadiga",

        formulario: {
          AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
          LimiteDePontosZonaVerde: "Limite de pontos - zona verde",
          LimiteDePontosZonaAmarela: "Limite de pontos - zona amarela",
          LimiteDePontosZonaVermelha: "Limite de pontos - zona vermelha",
          LimiteDePontosDiario: "Limite de pontos - diário",
          PontuacaoPorDiaDeFolga: "Pontuação por dia de folga",
          PontuacaoDiariaMediaParaSimulacao: "Pontuação Diária Média para Simulação",

          placeholder: {
            SelecionarAplicabilidade: "Selecionar aplicabilidade"
          }
        },

        tituloConfiguracoesDePontuacao: "Configurações de Pontuação",

        tabelaConfiguracoesDePontuacao: {
          TipoDeColaborador: "Tipo de Colaborador",
          Acoes: "Ações"
        },

        tituloEditarConfiguracao: "Editar configuração",

        formularioEditarConfiguracao: {
          AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
          LimiteDePontosZonaVerde: "Limite de pontos - zona verde",
          LimiteDePontosZonaAmarela: "Limite de pontos - zona amarela",
          LimiteDePontosZonaVermelha: "Limite de pontos - zona vermelha",
          LimiteDePontosDiario: "Limite de pontos - diário",
          PontuacaoPorDiaDeFolga: "Pontuação por dia de folga",
          PontuacaoDiariaMediaParaSimulacao: "Pontuação Diária Média para Simulação",

          placeholder: {
            SelecionarAplicabilidade: "Selecionar aplicabilidade"
          }
        },

        tituloTarefasDeRestricao: "Tarefas de restrição",

        formularioTarefasDeRestricao: {
          Tarefa: "Tarefa",
          LimiteDaRestricao: "Limite da restrição",
          Restricao: "Restrição",

          botaoCadastrarTarefa: "Cadastrar tarefa",

          placeholder: {
            SelecionarAplicabilidade: "Selecionar aplicabilidade",
            SelecionarLimite: "Selecionar limite",
            Restricao: "Restrição"
          }
        },

        tituloTarefasDaAplicabilidade: "Tarefas da aplicabilidade",

        tabelaTarefasDaAplicabilidade: {
          Limite: "Limite",
          Tarefa: "Tarefa",
          Restricao: "Restrição",
          Acoes: "Ações"
        }
      }
    },

    ColaboradoresSigmec: {
      ComunicadosDeTreinamentos: {
        botaoComunicado: "Comunicado",

        titulo: "Comunicados de Treinamentos",

        tabela: {
          semTreinamentos: "Não há treinamentos cadastrados",
          ID: "ID",
          Nome: "Nome",
          Status: "Status",
          CodigoDeControle: "Código de controle",
          DataInicial: "Data inicial",
          DataFinal: "Data final",
          Acoes: "Ações"
        }
      },

      ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia: {
        botaoConfirmarPresenca: "Confirmar presença",
        botaoConfirmarAusencia: "Confirmar ausência",

        titulo: "Comunicados de treinamentos pendentes de confirmação de presença/ausência",

        tabela: {
          semTreinamentos: "Não há treinamentos cadastrados",
          ID: "ID",
          Nome: "Nome",
          Status: "Status",
          CodigoDeControle: "Código de controle",
          DataInicial: "Data inicial",
          DataFinal: "Data final",
          Acoes: "Ações"
        }
      },

      EdicaoDeColaborador: {
        trocarStatusDoColaborador: "Tem certeza que deseja trocar o status do colaborador?",

        titulo: "Edição de colaborador",

        tabDadosDoColaborador: {
          tituloTab: "Dados do colaborador",

          formulario: {
            tituloInformacoesPessoais: "Informações pessoais",

            Nome: "Nome",
            Email: "E-mail",
            EstadoCivil: "Estado civil",
            TipoSanguineo: "Tipo sanguíneo",
            Telefone1: "Telefone 1",
            Telefone2: "Telefone 2",
            DadosBancarios: "Dados bancários",
            Nascimento: "Nascimento",
            PaisNascimento: "País nascimento",
            UFNascimento: "UF nascimento",
            CidadeNascimento: "Cidade nascimento",
            Endereco: "Endereço",
            Numero: "Número",
            Complemento: "Complemento",
            Bairro: "Bairro",
            Cidade: "Cidade",
            UF: "UF",
            Pais: "País",
            PIS: "PIS",
            CEP: "CEP",
            CPF: "CPF",
            Identidade: "Identidade",
            IDUF: "ID UF",
            OrgaoDeExpedicao: "Orgão de Expedição",
            IDExpedicao: "ID Expedição",
            CarteiraDeTrabalhoUF: "Carteira de Trabalho UF",
            CarteiraDeTrabalhoProfissional: "Carteira de Trabalho Profissional",
            CarteiraDeTrabalhoExpedicao: "Carteira de Trabalho Expedição",
            EscolaFormacao: "Escola/Formação",
            Escolaridade: "Escolaridade",
            ConfidenceUS: "Confidence US",
            ExpiracaoConfidenceUS: "Expiração confidence US",
            ConfidenceEU: "Confidence EU",
            ExpiracaoConfidenceEU: "Expiração confidence EU",
            Passaporte: "Passaporte",
            PassaporteExpiracao: "Passaporte Expiração",
            TituloDeEleitor: "Título de Eleitor",
            ZonaDeEleitor: "Zona de Eleitor",
            SessaoDeEleitor: "Sessão de Eleitor",
            CNHCategoria: "CNH categoria",
            CNH: "CNH",
            CNHExpiracao: "CNH expiração",
            Reservista: "Reservista",
            ReservistaCategoria: "Reservista categoria",
            CertificadoMilitar: "Certificado Militar",
            CertificadoMilitarMinisterio: "Certificado Militar Ministério",
            CertificadoMilitarObservacoes: "Certificado militar observações",
            VistoAmericano: "Visto Americano",
            CREA: "CREA",
            CREATitulo: "CREA título",
            CREAExpedicao: "CREA expedição",
            CREAValidade: "CREA validade",
            ASO: "ASO",
            Contratacao: "Contratação",
            Demissao: "Demissão",
            NomeDaMae: "Nome da mãe",
            NomeDoPai: "Nome do pai",

            tituloInformacoesProfissionais: "Informações Profissionais",

            Licenca: "Licença",
            CANAC: "CANAC",
            Matricula: "Matrícula",
            ValorHora: "Valor hora",
            ContratoSISPAT: "Contrato SISPAT",
            CodigoSapiens: "Código Sapiens",

            placeholder: {
              NomeDoColaborador: "Nome do colaborador",
              EmailDoColaborador: "E-mail do colaborador",
              EstadoCivil: "Estado civil",
              TipoSanguineo: "Tipo sanguíneo",
              TelefoneDoColaborador: "Telefone do colaborador",
              DadosBancarios: "Dados Bancários",
              NascimentoDoColaborador: "Nascimento do colaborador",
              PaisNascimento: "País nascimento",
              SelecioneOUF: "Selecione o UF",
              CidadeNascimento: "Cidade nascimento",
              EnderecoDoColaborador: "Endereço do colaborador",
              Numero: "Número",
              Complemento: "Complemento",
              BairroDoColaborador: "Bairro do colaborador",
              CidadeDoColaborador: "Cidade do colaborador",
              Pais: "País",
              PIS: "PIS",
              CEPDoColaborador: "CEP do colaborador",
              CPFDoColaborador: "CPF do colaborador",
              EstadoDeEmissaoDaID: "Estado de emissão da ID",
              OrgaoExpeditorDaID: "Orgão expeditor da ID",
              ExpedicaoDaID: "Expedição da ID",
              CarteiraDeTrabalhoUF: "Carteira de Trabalho UF",
              CarteiraDeTrabalhoProfissional: "Carteira de Trabalho Profissional",
              CarteiraDeTrabalhoExpedicao: "Carteira de Trabalho Expedição",
              EscolaFormacao: "Escola/Formação",
              Escolaridade: "Escolaridade",
              NumeroDoCartaoConfidenceAmericano: "Nº do cartão confidence americano",
              ValidadeDoCartaoConfidenceAmericano: "Validade do cartão confidence americano",
              NumeroDoCartaoConfidenceEuropeu: "Nº do cartão confidence europeu",
              ValidadeDoCartaoConfidenceEuropeu: "Validade do cartão confidence europeu",
              NumeroDoPassaporte: "Nº do passaporte",
              ExpiracaoDoPassaporte: "Expiração do passaporte",
              TituloDeEleitor: "Título de Eleitor",
              ZonaDeEleitor: "Zona de Eleitor",
              SessaoDeEleitor: "Sessão de Eleitor",
              CNHCategoria: "CNH categoria",
              NumeroDaCarteiraDeMotorista: "Nº da carteira de motorista",
              ExpiracaoDaCarteiraDeMotorista: "Expiração da carteira de motorista",
              Reservista: "Reservista",
              ReservistaCategoria: "Reservista categoria",
              CertificadoMilitar: "Certificado Militar",
              CertificadoMilitarMinisterio: "Certificado Militar Ministério",
              CertificadoMilitarObservacoes: "Certificado militar observações",
              VistoAmericano: "Visto Americano",
              CREA: "CREA",
              CREATitulo: "CREA título",
              CREAExpedicao: "CREA expedição",
              CREAValidade: "CREA validade",
              ASO: "ASO",
              Contratacao: "Contratação",
              Demissao: "Demissão",
              NomeDaMaeDoColaborador: "Nome da mãe do colaborador",
              NomeDoPaiDoColaborador: "Nome do pai do colaborador",
              Licenca: "Licença",
              CANAC: "CANAC",
              InscricaoDoColaborador: "Inscrição do colaborador",
              ValorHora: "Valor hora",
              ContratoSISPAT: "Contrato SISPAT",
              CodigoSapiens: "Código Sapiens"
            }
          }

        },

        tabHabilitacoes: {
          tituloTab: "Habilitações",

          opcoesNome: {
            AVI: "AVI",
            CEL: "CEL",
            GMP: "GMP"
          },

          opcoesTipo: {
            SelecionarTipo: "Selecionar tipo",
            CHT: "CHT",
            CCT: "CCT"
          },

          tituloHabilitacoes: "Habilitações",

          nenhumaHabilitacaoCadastrada: "Nenhuma habilitação cadastrada.",

          tabela: {
            Tipo: "Tipo",
            Nome: "Nome",
            Expedicao: "Expedição",
            Vencimento: "Vencimento",
            Valido: "Válido",
            Status: "Status",

            Ativo: "ativo",
            Arquivado: "arquivado"
          }

        },

        tabTarefasDesignadas: {
          tituloTab: "Tarefas designadas",

          tituloTarefas: "Tarefas",

          nenhumaTarefaCadastrada: "Nenhuma tarefa cadastrada.",

          tabela: {
            Tarefa: "Tarefa",
            Vencimento: "Vencimento",
            Valido: "Válido",
            Status: "Status",

            Ativo: "ativo",
            Arquivado: "arquivado"
          }

        },

        tabFrotasDesignadas: {
          tituloTab: "Frotas designadas",

          tituloFrotasDesignadas: "Frotas designadas",

          nenhumaFrotaCadastrada: "Nenhuma frota cadastrada.",

          tabela: {
            Aeronave: "Aeronave",
            Subtipo: "Subtipo",
            Vencimento: "Vencimento",
            Instrucao: "Instrução",
            Status: "Status",

            Ativo: "ativo",
            Arquivado: "arquivado"
          }

        },

        tabFrotasObrigatorias: {
          tituloTab: "Frotas obrigatórias",

          tituloFrotasObrigatorias: "Frotas obrigatórias",

          nenhumaFrotaCadastrada: "Nenhuma frota cadastrada.",

          tabela: {
            Aeronave: "Aeronave",
            Subtipo: "Subtipo",
            Status: "Status",

            Ativo: "ativo",
            Arquivado: "arquivado"
          }

        },

        tabDesignacoes: {
          tituloTab: "Designações",

          tituloDesignacoes: "Designações",

          tabRevisoesDeDesignacoes: {
            tituloTab: "Revisões de Designações",

            botaoExportacoes: {
              ExportarDesignacoes: "Exportar designações",
              Revisao: "Revisão",

              RevisaoArquivo: function RevisaoArquivo(Numero, Status) {
                return "Revis\xE3o " + Numero + " - " + Status + " - Arquivo";
              },
              RevisaoObservacoes: function RevisaoObservacoes(Numero, Status) {
                return "Revis\xE3o " + Numero + " - " + Status + " - Observa\xE7\xF5es";
              }
            },

            nenhumaDesignacaoCadastrada: "Nenhuma designação cadastrada.",

            tituloRevisao: "Revisão",

            tabela: {
              Codigo: "Código",
              Designacao: "Designação",
              DS: "DS",
              CEL: "CEL",
              GMP: "GMP",
              AVI: "AVI",
              ProdutoEspecificacao: "Produto/Especificação",
              LimitacoesObservacoes: "Limitações/Observações",

              Acfts: "Acfts.",
              Eng: "Eng.",
              Comp: "Comp."
            },

            designacoesComProdutoEspecificacaoEscritosManualmente: "Designações com produto/especificação escritos manualmente",

            tituloRazaoDeAberturaDaRevisao: "Razão de abertura da revisão",
            tituloRazaoNaoDisponivel: "Razão não disponível",

            tituloHabilitacoesDesignadasDestaRevisao: "Habilitações designadas desta revisão",

            nenhumaHabilitacaoCadastrada: "Nenhuma habilitação cadastrada.",

            tabelaHabilitacoesDesignadasDestaRevisao: {
              Nome: "Nome",
              Expiração: "Expiração"
            },

            tituloTarefasDesignadasDestaRevisao: "Tarefas designadas desta revisão",

            nenhumaTarefaCadastrada: "Nenhuma tarefa cadastrada.",

            tabelaTarefasDesignadasDestaRevisao: {
              Nome: "Nome",
              Expiracao: "Expiração"
            },

            tituloFrotasDesignadasDestaRevisao: "Frotas designadas desta revisão",

            nenhumaFrotaCadastrada: "Nenhuma frota cadastrada.",

            tabelaFrotasDesignadasDestaRevisao: {
              Nome: "Nome",
              Expiracao: "Expiração"
            },

            tituloLogDeAcoesManuaisDestaRevisao: "Log de ações manuais desta revisão",

            nenhumaAcaoCadastrada: "Nenhuma ação cadastrada.",

            tabelaLogDeAcoesManuaisDestaRevisao: {
              Acao: "Ação",
              Tipo: "Tipo",
              Usuario: "Usuário",
              Data: "Data"
            },

            osColaboradorNaoPossuiOsCertificadosListadosAbaixo: "Os colaborador não possui os certificados listados abaixo, necessários para este item de designação"

          }

        },

        tabExperienciaProfissional: {
          tituloTab: "Experiência profissional",

          titutloExperienciaProfissional: "Experiência profissional",

          nenhumaExperienciaProfissionalCadastrada: "Nenhuma experiência profissional cadastrada.",

          tabela: {
            DataInicial: "Data inicial",
            DataFinal: "Data final",
            Empresa: "Empresa",
            Funcao: "Função",
            Status: "Status",

            Ativo: "ativo",
            Arquivado: "arquivado"
          }

        },

        tabProvasDeIdioma: {
          tituloTab: "Provas de idioma",

          tituloListaDeProvasDeIdioma: "Lista de Provas de Idioma",

          nenhumaProvasDeIdiomaCadastrada: "Nenhuma provas de idioma cadastrada.",

          tabela: {
            Coeficiente: "Coeficiente",
            Idioma: "Idioma",
            Emissao: "Emissão",
            Vencimento: "Vencimento",
            Status: "Status",

            Ativo: "ativo",
            Arquivado: "arquivado"
          }
        },

        tabFerias: {
          tituloTab: "Férias",

          tituloFerias: "Férias",

          nenhumaFeriasCadastrada: "Nenhuma férias cadastrada.",

          tabela: {
            DataInicial: "Data inicial",
            DataFinal: "Data final",
            DireitoAFerias: "Direito à férias",
            VencimentoDeFerias: "Vencimento de férias",
            Status: "Status",

            Ativo: "ativo",
            Arquivado: "arquivado"
          }
        },

        tabFuncoes: {
          tituloTab: "Funções",

          tituloFuncoes: "Funções",

          nenhumaFuncaoCadastrada: "Nenhuma função cadastrada.",

          tabela: {
            DataInicial: "Data Inicial",
            Funcao: "Função",
            Status: "Status",

            Ativo: "ativo",
            Arquivado: "arquivado"
          }

        },

        tabBases: {
          tituloTab: "Bases",

          tituloBases: "Bases",

          nenhumaBaseCadastrada: "Nenhuma base cadastrada.",

          tabela: {
            DataInicial: "Data Inicial",
            Base: "Base",
            Status: "Status",

            Ativo: "ativo",
            Arquivado: "arquivado"
          }

        },

        tabNiveisDeCargos: {
          tituloTab: "Níveis de cargos",

          tituloNiveisDeCargos: "Níveis de cargos",

          nenhumaAeronaveCadastrada: "Nenhuma aeronave cadastrada.",

          tabela: {
            DataDeAlteracao: "Data de alteração",
            Nivel: "Nível",
            Motivo: "Motivo"
          }

        },

        tabCargos: {
          tituloTab: "Cargos",

          tituloCargos: "Cargos",

          nenhumCargoCadastrado: "Nenhum cargo cadastrado.",

          tabela: {
            DataInicial: "Data Inicial",
            Cargo: "Cargo",
            CodRubi: "Cód. Rubi",
            Status: "Status",

            Ativo: "ativo",
            Arquivado: "arquivado"
          }

        },

        tabCarimbos: {
          tituloTab: "Carimbos",

          opcoesCarimbo: {
            Circulo: "Círculo",
            Triangulo: "Triângulo",
            Quadrado: "Quadrado",
            Pentagono: "Pentágono",
            Hexagono: "Hexágono"
          },

          tituloCarimbos: "Carimbos",

          nenhumCarimboCadastrado: "Nenhum carimbo cadastrado.",

          tabela: {
            DataDeEmissao: "Data de emissão",
            Funcao: "Função",
            TipoDeCarimbo: "Tipo de carimbo",
            Numero: "Número",
            Revisao: "Revisão",
            Observacao: "Observação",
            Status: "Status",

            Ativo: "ativo",
            Arquivado: "arquivado"
          }

        },

        tabTreinamentos: {
          tituloTab: "Treinamentos",

          tituloCertificados: "Certificados",

          nenhumCertificadoCadastrado: "Nenhum certificado cadastrado",

          tabela: {
            ID: "ID",
            Tipo: "Tipo",
            Fim: "Fim",
            Vencimento: "Vencimento",
            Val: "Val.",
            Status: "Status",
            Ações: "Ações",

            Ativo: "ativo",
            Arquivado: "arquivado"
          }

        },

        tabNecessidadeDeTreinamentos: {
          tituloTab: "Necessidade de treinamentos",

          tituloAvaliacaoDeNecessidadeDeTreinamento: "Avaliação de necessidade de treinamento",

          naoHaFormulariosDeAvaliacao: "Não há formulários de avaliação de necessidade de treinamento para este funcionário.",

          tabela: {
            Data: "Data",
            MotivoDaAnalise: "Motivo da análise",
            OutrasAtividades: "Outras Atividades",
            Acoes: "Ações"
          },

          tituloAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo: "Avaliação de necessidade de treinamento - MODELO ANTIGO",

          tabelaAvaliacaoDeNecessidadeDeTreinamentoModeloAntigo: {
            Conhecimento: "Conhecimento",
            OutrasAtividades: "Outras Atividades",
            Data: "Data",
            Acoes: "Ações",

            ConhecimentoETreinamento: "Conhecimento e Treinamento",
            Experiencia: "Experiência",
            Oficina: "Oficina",
            Aeronaves: "Aeronaves",
            Motores: "Motores",
            Inspecao: "Inspeção",
            Instrucao: "Instrução",
            Criacao: "Criação"
          },

          deletarItem: "Tem certeza que gostaria de deletar esse item?",

          tituloEditarNecessidadeDeTreinamento: "Editar necessidade de treinamento",

          formularioEditarNecessidadeDeTreinamento: {
            Data: "Data",
            MotivoDaAnalise: "Motivo da análise",

            opcoesMotivoDaAnalise: {
              ContratacaoDoColaborador: "Contratação do Colaborador",
              NovaFuncaoDoColaborador: "Nova Função do Colaborador",
              PromocaoDoColaborador: "Promoção do Colaborador",
              Outro: "Outro"
            },

            PreenchaOMotivo: "Preencha o motivo",

            OutrasAtividades: "Outras atividades",

            tituloProcedimentosInternos: "Procedimentos internos",

            Integracao: "Integração",
            Geral: "Geral",
            SUP: "SUP",
            FER: "FER",
            MNT: "MNT",
            ENG: "ENG",
            CTM: "CTM",
            SASC: "SASC",
            QUA: "QUA",
            Inspetores: "Inspetores",
            Rampa: "Rampa",

            tituloApoio: "Apoio",

            Corrosao: "Corrosão",
            PBN: "PBN",
            HUMSNivel1: "HUMS Nível 1",
            HUMSNivel2: "HUMS Nível 2",
            Ingles: "Inglês",
            Boroscopia: "Boroscopia",
            FatoresHumanos: "Fatores Humanos",
            Orientacao: "Orientação",
            Pedagogica: "Pedagógica",
            ArtigosPerigosos: "Artigos Perigosos",
            EOS: "EOS"
          },

          tituloTreinamentosDeProdutos: "Treinamentos de produtos",

          tabelaTreinamentosDeProdutos: {
            Aeronaves: "Aeronaves",
            Motores: "Motores",
            Oficinas: "Oficinas"
          },

          tituloConhecimentoTreinamentoEExperienciaAnterior: "Conhecimento, Treinamento e Experiência Anterior",

          tabelaConhecimentoTreinamentoEExperienciaAnterior: {
            Descricao: "Descrição",
            Organizacao: "Organização",
            Periodo: "Período"
          }

        },

        tabColaboradorReferencia: {
          tituloTab: "Colaborador referência",

          tituloReferencias: "Referências",

          nenhumaReferenciaCadastrada: "Nenhuma referência cadastrada.",

          tabela: {
            Aeronave: "Aeronave",
            Referencia: "Referência",
            Status: "Status",

            Ativo: "ativo",
            Arquivado: "arquivado"
          }

        },

        tabAfastamentos: {
          tituloTab: "Afastamentos",

          tituloAfastamento: "Afastamento",

          nenhumaAfastamentoCadastrada: "Nenhuma afastamento cadastrada.",

          tabela: {
            DataInicial: "Data inicial",
            DataFinal: "Data final",
            Motivo: "Motivo"
          }

        },

        tabRegimeDeTrabalho: {
          tituloTab: "Regime de trabalho",

          tituloRegimeDeTrabalho: "Regime de Trabalho",

          nenhumRegimeCadastrado: "Nenhum regime cadastrado.",

          tabela: {
            Tipo: "Tipo",
            DataInicial: "Data inicial",
            Status: "Status",

            Ativo: "ativo",
            Arquivado: "arquivado"
          }

        },

        tabFormacaoAcademica: {
          tituloTab: "Formação acadêmica",

          opcoesTipoDeFormacao: {
            SelecionarTipo: "Selecionar tipo",
            PrimeiroGrau: "1º Grau",
            SegundoGrau: "2º Grau",
            EnsinoSuperior: "Ensino superior",
            PosGraduacao: "Pós graduação",
            MMA: "MMA"
          },

          tituloFormacaoAcademica: "Formação acadêmica",

          nenhumaFormacaoCadastrada: "Nenhuma formação cadastrada.",

          tabela: {
            Tipo: "Tipo",
            NomeDoCurso: "Nome do curso",
            Instituicao: "Instituição",
            DataDeConclusao: "Data de conclusão",
            Status: "Status",

            Ativo: "ativo",
            Arquivado: "arquivado"
          }

        },

        tabBaseContratual: {
          tituloTab: "Base Contratual",

          tituloBases: "Bases",

          nenhumaBaseCadastrada: "Nenhuma base cadastrada.",

          tabela: {
            Base: "Base"

          }

        }
      }
    },

    ColaboradoresSigtrip: {
      ComunicadosDeTreinamentos: {
        botaoExportar: {
          Exportar: "Exportar",
          Solo: "Solo",
          SoloTIC: "Solo TIC",
          Simulador: "Simulador",
          EAD: "EAD"
        },

        titulo: "Comunicados de Treinamentos",

        tabela: {
          semTreinamentos: "Não há treinamentos cadastrados",
          ID: "ID",
          Nome: "Nome",
          Status: "Status",
          CodigoDeControle: "Código de controle",
          TiposDeCertificado: "Tipos de certificado",
          Modalidade: "Modalidade",
          DataInicial: "Data inicial",
          DataFinal: "Data final",
          Acoes: "Ações"
        }

      },

      DocumentosPendentesDeConhecimento: {
        deletarPapeleta: "Tem certeza que gostaria de deletar essa papeleta?",

        titulo: "Documentos pendentes de conhecimento",

        tituloAListaDeDocumentosPendentesEOriundaDoQPulse: "A lista de documentos pendentes é oriunda do Q-Pulse e é atualizada uma vez ao dia, às 05:00",

        tabela: {
          semDocumentosPendentes: "Não há documentos pendentes de conhecimento",
          ID: "ID",
          Matricula: "Matrícula",
          Nome: "Nome",
          Documentos: "Documentos"
        }

      },

      ComunicadosDeTreinamentosPendentesDeConfirmacaoDePresencaAusencia: {
        botaoConfirmarPresenca: "Confirmar presença",
        botaoConfirmarAusencia: "Confirmar ausência",

        titulo: "Comunicados de treinamentos pendentes de confirmação de presença/ausência",

        tabela: {
          semTreinamentos: "Não há treinamentos pendentes de confirmação",
          ID: "ID",
          Nome: "Nome",
          Status: "Status",
          CodigoDeControle: "Código de controle",
          TiposDeCertificado: "Tipos de certificado",
          Modalidade: "Modalidade",
          DataInicial: "Data inicial",
          DataFinal: "Data final",
          Acoes: "Ações"
        }
      },

      EscalasPendentesDeConhecimento: {
        botaoRevisao: "Revisão",

        titulo: "Escalas pendentes de conhecimento",

        tabela: {
          semEscalas: "Não há escalas pendentes de conhecimento",
          ID: "ID",
          Mes: "Mês",
          Base: "Base",
          Frota: "Frota",
          Revisao: "Revisão",
          Status: "Status",
          Acoes: "Ações"
        }
      },

      PapeletasPendentesDeAprovacao: {
        titulo: "Papeletas pendentes de aprovação",

        tabela: {
          semPapeletas: "Não há papeletas pendentes de aprovação",
          ID: "ID",
          Nome: "Nome",
          Matricula: "Matrícula",
          Referencia: "Referência",
          Status: "Status",
          Acoes: "Ações"
        }
      },

      RelatoriosPendentesDeAprovacao: {
        titulo: "Relatórios pendentes de aprovação",

        tabela: {
          semRelatorios: "Não há relatórios pendentes de aprovação",
          ID: "ID",
          Base: "Base",
          Data: "Data",
          Aeronave: "Aeronave",
          Frota: "Frota",
          Cliente: "Cliente",
          TipoDeVoo: "Tipo de voo",
          NumeroDoRelatorio: "Número do relatório",
          NumeroDoVoo: "Número do voo",
          Status: "Status",
          Acoes: "Ações"
        }

      },

      EditarFuncionario: {
        titulo: "Edição de funcionário",

        tabDadosDoFuncionario: {
          tituloTab: "Dados do funcionário",

          formulario: {
            tituloInformacoesPessoais: "Informações pessoais",

            Nome: "Nome",
            Apelido: "Apelido",
            Telefone1: "Telefone 1",
            Telefone2: "Telefone 2",
            EstadoCivil: "Estado civil",
            Email: "E-mail",
            Naturalidade: "Naturalidade",
            Escolaridade: "Escolaridade",
            NomeDaMae: "Nome da mãe",
            NomeDoPai: "Nome do pai",
            Raca: "Raça",
            DataDeNascimento: "Data de nascimento",

            tituloEndereco: "Endereço",

            Endereco: "Endereço",
            Numero: "Número",
            Complemento: "Complemento",
            Bairro: "Bairro",
            Cidade: "Cidade",
            Estado: "Estado",
            Pais: "País",
            CEP: "CEP",
            CPF: "CPF",
            Identidade: "Identidade",
            IdentidadeUF: "Identidade - UF",
            IdentidadeDataDeExpedicao: "Identidade - data de expedição",
            IdentidadeOrgaoExpeditor: "Identidade - orgão expeditor",
            PIS: "PIS",
            ConfidenceUS: "Confidence US",
            ExpiracaoConfidenceUS: "Expiração confidence US",
            ConfidenceEU: "Confidence EU",
            ExpiracaoConfidenceEU: "Expiração confidence EU",
            CTPS: "CTPS",
            CTPSNumeroDeSerie: "CTPS - N de Serie",
            CTPSExpedicao: "CTPS expedição",
            CTPSUF: "CTPS UF",
            TipoSanguineo: "Tipo sanguíneo",
            Matricula: "Matrícula",
            SISPAT: "SISPAT",
            CANAC: "CANAC",
            Licenca: "Licença",
            Contratacao: "Contratação",
            CargoDeAdmissao: "Cargo de admissão",
            CargoAtual: "Cargo Atual",
            EstadoDeNascimento: "Estado de nascimento",
            CidadeDeNascimento: "Cidade de nascimento",
            PaisDeNascimento: "País de nascimento",
            ASO: "ASO",
            Eletrocardiograma: "Eletrocardiograma",
            CodigoSapiens: "Código Sapiens"
          }

        },

        tabAdministrativo: {
          tituloTab: "Administrativo",

          tituloAdicionarArquivos: "Adicionar arquivos",

          tabela: {
            semArquivos: "Não há arquivos cadastrados",
            NomeDoArquivo: "Nome do arquivo",
            Tipo: "Tipo",
            Validade: "Validade"
          }

        },

        tabHorasDeVoo: {
          tituloTab: "Horas de voo",

          tituloTotaisDeHoras: "Totais de horas",

          tabelaTotaisDeHoras: {
            semAeronaves: "Não há aeronaves cadastrados",
            ID: "ID",
            Modelo: "Modelo",
            FB: "FB",
            Total: "Total",
            IFR: "IFR.",
            Noturno: "Noturno",
            APP: "APP",
            Diurno: "Diurno"
          },

          tabelaArquivos: {
            semArquivos: "Não há arquivos cadastrados",
            NomeDoArquivo: "Nome do arquivo",
            Validade: "Validade"
          }
        },

        tabHabilitacoes: {
          tituloTab: "Habilitações",

          opcoesCodigoDeHabilitacao: {
            CCF: "CCF",
            CHT: "CHT"
          },

          opcoesHabilitacao: {
            SelecionarTipo: "Selecionar tipo",
            IFRH: "IFRH"
          },

          tituloHabilitacoes: "Habilitações",

          botaoEsconderArquivoMorto: "Esconder arquivo morto",
          botaoMostrarArquivoMorto: "Mostrar arquivo morto",

          nenhumaHabilitacaoCadastrada: "Nenhuma habilitação cadastrada.",

          tabela: {
            Codigo: "Código",
            Frota: "Frota",
            Tipo: "Tipo",
            CANAC: "CANAC",
            Licenca: "Licença",
            Vencimento: "Vencimento",
            Status: "Status",

            Ativo: "ativo",
            Arquivado: "arquivado"
          }
        },

        tabProcessos: {
          tituloTab: "Processos",

          tituloProcessos: "Processos",

          tabela: {
            semArquivosDeProcessos: "Não há arquivos de processos",
            Frota: "Frota",
            Processo: "Processo",
            Subtipo: "Subtipo",
            DataDeEmissao: "Data de emissão",
            Validade: "Validade"
          }

        },

        tabCertificacoes: {
          tituloTab: "Certificações",

          tituloCertificados: "Certificados",

          nenhumCertificadoCadastrado: "Nenhum certificado cadastrado.",

          tabela: {
            NomeDoCertificado: "Nome do certificado",
            Inicio: "Início",
            Fim: "Fim",
            Vencimento: "Vencimento",
            Status: "Status",
            Arquivo: "Arquivo",

            Ativo: "ativo",
            Arquivado: "arquivado"
          }
        },

        tabAvaliacoes: {
          tituloTab: "Avaliações",

          tituloAvaliacoes: "Avaliações",

          nenhumCertificadoCadastrado: "Nenhum certificado cadastrado.",

          tabela: {
            NomeDoCertificado: "Nome do certificado",
            Inicio: "Início",
            Fim: "Fim",
            Vencimento: "Vencimento",
            Status: "Status",
            Arquivo: "Arquivo",

            Ativo: "ativo",
            Arquivado: "arquivado"
          }
        },

        tabCargos: {
          tituloTab: "Cargos",

          tituloCargos: "Cargos",

          nenhumCargoCadastrado: "Nenhum cargo cadastrado.",

          tabela: {
            Cargo: "Cargo",
            CodigoRubi: "Cód. Rubi",
            Status: "Status",
            Data: "Data",

            Ativo: "ativo",
            Arquivado: "arquivado"
          }
        },

        tabDesignacoes: {
          tituloTab: "Designações",

          tituloDesignacoes: "Designações",

          nenhumaDesignacaoCadastrada: "Nenhuma designação cadastrada.",

          tabela: {
            Designacao: "Designação",
            Frota: "Frota",
            Status: "Status",
            Data: "Data",

            Ativo: "ativo",
            Arquivado: "arquivado"
          }
        },

        tabIndicacoes: {
          tituloTab: "Indicações",

          tituloIndicacao: "Indicação",

          nenhumaIndicacaoCadastrada: "Nenhuma indicação cadastrada.",

          tabela: {
            Designacao: "Designação",
            Frota: "Frota",
            Status: "Status",
            Data: "Data",

            Ativo: "ativo",
            Arquivado: "arquivado"
          }
        },

        tabRegimes: {
          tituloTab: "Regimes",

          tituloRegimes: "Regimes",

          nenhumRegimeCadastrado: "Nenhum regime cadastrado.",

          tabela: {
            Regime: "Regime",
            Data: "Data",
            Mes: "Mês",
            Ano: "Ano",
            Status: "Status",

            Ativo: "ativo",
            Arquivado: "arquivado"
          }
        },

        tabGratificacoes: {
          tituloTab: "Gratificações",

          tituloGratificacoes: "Gratificações",

          nenhumaGratificacaoCadastrada: "Nenhuma gratificação cadastrada.",

          tabela: {
            Gratificacao: "Gratificação",
            Data: "Data",
            Status: "Status",

            Ativo: "ativo",
            Arquivado: "arquivado"
          }
        },

        tabAprovacoes: {
          tituloTab: "Aprovações",

          tituloAprovacoesDeClientes: "Aprovações de clientes",

          nenhumaAprovacaoCadastrada: "Nenhuma aprovação cadastrada.",

          tabela: {
            Client: "Client",
            Grupo: "Grupo",
            Funcao: "Função",
            Aeronaves: "Aeronaves"
          }

        },

        tabICAO: {
          tituloTab: "ICAO",

          tituloICAOS: "ICAOS",

          nenhumICAOCadastrado: "Nenhum ICAO cadastrado.",

          tabela: {
            Level: "Level",
            Vencimento: "Vencimento",
            DataDeInsercao: "Data de Inserção",
            Status: "Status",

            Ativo: "ativo",
            Arquivado: "arquivado"
          }
        },

        tabBaseContratual: {
          tituloTab: "Base contratual",

          tituloBases: "Bases",

          nenhumaBaseCadastrada: "Nenhuma base cadastrada.",

          tabela: {
            Base: "Base",
            Status: "Status",

            Ativo: "ativo",
            Arquivado: "arquivado"
          }
        }
      }

    },

    Papeletas: {
      ListaDePapeletas: {
        deletar: "Tem certeza que gostaria de deletar essa papeleta?",

        botaoAprovarSelecionados: "Aprovar selecionados",

        titulo: "Lista de papeletas",

        tabela: {
          semPapeletasPendentes: "Não há papeletas pendentes",
          ID: "ID",
          Nome: "Nome",
          Matricula: "Matrícula",
          Referencia: "Referência",
          Status: "Status",
          Acoes: "Ações"
        }
      },

      AdicionarPapeleta: {
        titulo: "Cadastrar papeleta",

        formulario: {
          MesAno: "Mês/ano",

          Tripulante: "Tripulante"
        }
      },

      EditarPapeleta: {
        aguardeEnquantoOArquivoEGerado: "Aguarde enquanto o arquivo é gerado. Este processo pode levar alguns minutos.",
        atualizarAsInformacoes: "Tem certeza que deseja atualizar as informações? As alterações realizadas na FIRA serão perdidas.",

        titulo: "Edição de papeleta",

        botaoAtualizar: "Atualizar",
        botaoAlertas: "Alertas",

        tituloPendencias: "Pendências",

        tabelaPendencias: {
          Data: "Data",
          Localidades: "Localidades",
          Situacao: "Situação",
          Horarios: "Horários",
          Totais: "Totais",
          Apresentacao: "Apresentação",
          Liberacao: "Liberação",
          InicioDaRefeicao: "Início da Refeição",
          TerminoDaRefeicao: "Término da Refeição",
          InicioDaSegundaRefeicao: "Início da Segunda Refeição",
          TerminoDaSegundaRefeicao: "Término da Segunda Refeição",
          HorasDeJornada: "Horas de Jornada",
          VooNoturno: "Voo Noturno",
          VooTotal: "Voo Total",

          ///pendencyday
          AtualizarAsInformacoesDestaDataDeAcordoComAPendencia: "Tem certeza que deseja atualizar as informações desta data de acordo com a pendência? As alterações realizadas na FIRA nesta data serão perdidas",

          tituloInterrupcoes: "Interrupções",

          tabelaInterrupcoes: {
            Inicio: "Início",
            Fim: "Fim",
            Total: "Total"
          },

          tituloEquipamentos: "Equipamentos",

          tabelaEquipamentos: {
            Frota: "Frota"
          }
        },

        tituloPapeleta: "Papeleta",

        tabelaPapeleta: {
          Data: "Data",
          Localidades: "Localidades",
          Situacao: "Situação",
          Horarios: "Horários",
          Totais: "Totais",
          Apresentacao: "Apresentação",
          Liberacao: "Liberação",
          ApresentacaoData: "Apresentação data",
          ApresentacaoHora: "Apresentação hora",
          InicioDaRefeicaoData: "Início da Refeição data",
          InicioDaRefeicaoHora: "Início da Refeição hora",
          TerminoDaRefeicaoData: "Término da Refeição data",
          TerminoDaRefeicaoHora: "Término da Refeição hora",
          InicioDaSegundaRefeicaoData: "Início da Segunda Refeição data",
          InicioDaSegundaRefeicaoHora: "Início da Segunda Refeição hora",
          TerminoDaSegundaRefeicaoData: "Término da Segunda Refeição data",
          TerminoDaSegundaRefeicaoHora: "Término da Segunda Refeição hora",
          LiberacaoData: "Liberação data",
          Liberacaohora: "Liberação hora",
          HorasDeJornada: "Horas de Jornada",
          VooNoturno: "Voo Noturno",
          VooTotal: "Voo Total",

          ///////editday
          DeletarFrota: "Tem certeza que deseja deletar essa frota?",
          DeletarInterrupcao: "Tem certeza que deseja deletar essa interrupção?",
          AtualizarInformacoesDestaData: "Tem certeza que deseja atualizar as informações desta data? As alterações realizadas na FIRA nesta data serão perdidas",

          placeholder: {
            SelecionarSituacao: "Selecionar situação"
          },

          tituloInterrupcoes: "Interrupções",

          formularioInterrupcoes: {
            InicioDaInterrupcao: "Início da interrupção",
            FimDaInterrupcao: "Fim da interrupção",

            botaoAdicionarInterrupcao: "Adicionar interrupção"
          },

          tabelaInterrupcoes: {
            Inicio: "Início",
            Fim: "Fim",
            Total: "Total",
            Acoes: "Ações"
          },

          tituloEquipamentos: "Equipamentos",

          formularioEquipamentos: {
            botaoAdicionarFrota: "Adicionar frota",

            placeholder: {
              SelecionarFrota: "Selecionar frota"
            }
          },

          tabelaEquipamentos: {
            Frota: "Frota",
            Acoes: "Ações"
          }
        },

        tituloAlertasDoRelatorio: "Alertas do relatório",

        tabelaAlertasDoRelatorio: {
          Mensagem: "Mensagem"
        },

        tituloAlertas: "Alertas",

        /////////aqui acaba o papersedit

        //////aprovals
        trocarStatus: "Tem certeza que deseja trocar o status da papeleta?",
        reabrir: "Tem certeza que deseja reabrir a papeleta?",

        botaoForcarAprovacao: "Forçar Aprovação",
        botaoAprovacaoTripulante: "Aprovação - Tripulante",
        botaoAprovacaoGestor: "Aprovação - Gestor",
        botaoReabrirPapeleta: "Reabrir papeleta",
        botaoPapeletaAprovada: "Papeleta aprovada",

        erros: "Os seguintes erros de preenchimento nos dias indicados impediram a papeleta de ser finalizada",

        tituloLogDeAprovacoes: "Log de aprovações",

        tabelaLogDeAprovacoes: {
          Usuario: "Usuário",
          Acao: "Ação",
          Data: "Data"
        },

        tituloFIRA: "FIRA",

        botaoReprovacaoGestor: "Reprovação - Gestor"

      },

      ListaDePapeletasFinalizadas: {
        deletar: "Tem certeza que gostaria de deletar essa papeleta?",

        titulo: "Lista de papeletas finalizadas",

        tabela: {
          semPapeletasPendentes: "Não há papeletas pendentes",
          ID: "ID",
          Nome: "Nome",
          Matricula: "Matrícula",
          Referencia: "Referência",
          Acoes: "Ações"
        }
      },

      ListaDePapeletasPendentesGestor: {
        deletar: "Tem certeza que gostaria de deletar essa papeleta?",

        titulo: "Lista de papeletas pendentes - Gestor",

        tabela: {
          semPapeletasPendentes: "Não há papeletas pendentes",
          ID: "ID",
          Nome: "Nome",
          Matricula: "Matrícula",
          Referencia: "Referência",
          Acoes: "Ações"
        }
      },

      ListaDePapeletasPendentesTripulantes: {
        deletar: "Tem certeza que gostaria de deletar essa papeleta?",

        titulo: "Lista de papeletas pendentes - Tripulantes",

        tabela: {
          semPapeletasPendentes: "Não há papeletas pendentes",
          ID: "ID",
          Nome: "Nome",
          Matricula: "Matrícula",
          Referencia: "Referência",
          Acoes: "Ações"
        }
      },

      ControleDePapeletas: {
        titulo: "Controle de papeletas",

        formulario: {
          DataInicial: "Data Inicial",
          DataFinal: "Data Final",
          Nome: "Nome",

          placeholder: {
            SelecionarTripulantes: "Selecionar tripulantes"
          }
        },

        tabela: {
          Tripulante: "Tripulante",
          SomaDeHorasDeJornada: "Soma de Horas de Jornada",
          SomaDeHorasDeVooNoturno: "Soma de Horas de Voo Noturno",
          SomaDeHorasDeVooTotal: "Soma de Horas de Voo Total"
        }
      },

      ConsultaDePapeletas: {
        titulo: "Consulta de papeletas",

        formulario: {
          DataInicial: "Data Inicial",
          DataFinal: "Data Final"
        },

        tabela: {
          MesAno: "Mês/Ano",
          Alertas: "Alertas",
          Acoes: "Ações"
        }
      },

      ConsultaDePapeletasGestores: {
        aguardeEnquantoOArquivoEGerado: "Aguarde enquanto o arquivo é gerado. Este processo pode levar alguns minutos.",

        titulo: "Consulta de papeletas - Gestores",

        formulario: {
          DataInicial: "Data Inicial",
          DataFinal: "Data Final",
          Tripulante: "Tripulante",
          ExibirDesligados: "Exibir desligados",
          SomenteComAlertas: "Somente com alertas"
        },

        tabela: {
          Tripulante: "Tripulante",
          MesAno: "Mês/Ano",
          Alertas: "Alertas",
          Acoes: "Ações"
        }
      }
    },

    RelatoriosDeFadiga: {

      ListaDeRelatoriosDeFadigas: {
        botaoAdicionarRelatorioDeFadiga: "Adicionar relatório de fadiga",

        titulo: "Lista de relatórios de fadigas",

        tabela: {
          semParametroDeFadiga: "Não há parâmetros de fadiga cadastrados",
          Data: "Data",
          Revisao: "Revisão",
          Tripulante: "Tripulante",
          Folga: "Folga",
          QuantidadeDePontosAtual: "Quantidade de pontos atual",
          QuantidadeDePontosReportados: "Quantidade de pontos reportados",
          Acoes: "Ações"
        }
      },

      AdicionarRelatorioDeFadiga: {
        noParametroAPontuacaoMaximaFoiUltrapassada: function noParametroAPontuacaoMaximaFoiUltrapassada(name) {
          return "No par\xE2metro " + name + " a pontua\xE7\xE3o m\xE1xima foi ultrapassada, confirma o envio do relat\xF3rio?";
        },
        noParametroAPontuacaoMinimaNaoFoiAtingida: function noParametroAPontuacaoMinimaNaoFoiAtingida(name) {
          return "No par\xE2metro " + name + " a pontua\xE7\xE3o m\xEDnima n\xE3o foi atingida, confirma o envio do relat\xF3rio?";
        },


        titulo: "Cadastrar relatório de fadiga",

        formulario: {
          Data: "Data",
          Bases: "Bases",

          botaoAdicionarRelatorioDeFadiga: "Adicionar relatório de fadiga",

          placeholder: {
            SelecionarBase: "Selecionar base",
            SelecionarOpcao: "Selecionar opção",
            Horas: "Horas",
            Quantidade: "Quantidade"
          }
        }

      },

      EditarRelatorioDeFadiga: {
        noParametroAPontuacaoMaximaFoiUltrapassada: function noParametroAPontuacaoMaximaFoiUltrapassada(name) {
          return "No par\xE2metro " + name + " a pontua\xE7\xE3o m\xE1xima foi ultrapassada, confirma o envio do relat\xF3rio?";
        },
        noParametroAPontuacaoMinimaNaoFoiAtingida: function noParametroAPontuacaoMinimaNaoFoiAtingida(name) {
          return "No par\xE2metro " + name + " a pontua\xE7\xE3o m\xEDnima n\xE3o foi atingida, confirma o envio do relat\xF3rio?";
        },


        titulo: "Edição de relatório de fadiga - Revisão",

        paragrafoStatusDaRevisao: "Status da revisão",
        paragrafoQuantidadeDePontosAtual: "Quantidade de pontos atual",
        paragrafoQuantidadeDePontosReportados: "Quantidade de pontos reportados",

        tabRevisao: {
          tituloTab: "Revisão ",

          paragrafoStatusDaRevisao: "Status da revisão",
          paragrafoQuantidadeDePontosAtual: "Quantidade de pontos atual",
          paragrafoQuantidadeDePontosReportados: "Quantidade de pontos reportados"
        },

        tituloCriarRevisao: "Criar revisão",

        formularioCriarRevisao: {

          botaoCriarRevisaoDeRelatorioDeFadiga: "Criar revisão de relatório de fadiga",

          placeholder: {
            SelecionarOpcao: "Selecionar opção",
            Horas: "Horas",
            Quantidade: "Quantidade"
          }
        }
      },

      EditarRelatorioDeFadigaAdministrador: {
        noParametroAPontuacaoMaximaFoiUltrapassada: function noParametroAPontuacaoMaximaFoiUltrapassada(name) {
          return "No par\xE2metro " + name + " a pontua\xE7\xE3o m\xE1xima foi ultrapassada, confirma o envio do relat\xF3rio?";
        },
        noParametroAPontuacaoMinimaNaoFoiAtingida: function noParametroAPontuacaoMinimaNaoFoiAtingida(name) {
          return "No par\xE2metro " + name + " a pontua\xE7\xE3o m\xEDnima n\xE3o foi atingida, confirma o envio do relat\xF3rio?";
        },


        titulo: "Edição de relatório de fadiga - Revisão",

        paragrafoStatusDaRevisao: "Status da revisão",
        paragrafoQuantidadeDePontosAtual: "Quantidade de pontos atual",
        paragrafoQuantidadeDePontosReportados: "Quantidade de pontos reportados",

        tabRevisao: {
          tituloTab: "Revisão ",

          paragrafoStatusDaRevisao: "Status da revisão",
          paragrafoQuantidadeDePontosAtual: "Quantidade de pontos atual",
          paragrafoQuantidadeDePontosReportados: "Quantidade de pontos reportados"
        },

        tituloCriarRevisao: "Criar revisão",

        formularioCriarRevisao: {
          botaoCriarRevisaoDeRelatorioDeFadiga: "Criar revisão de relatório de fadiga",

          placeholder: {
            SelecionarOpcao: "Selecionar opção",
            Horas: "Horas",
            Quantidade: "Quantidade"
          }
        }
      },

      AdicionarRelatorioDeFadigaAdministrador: {
        noParametroAPontuacaoMaximaFoiUltrapassada: function noParametroAPontuacaoMaximaFoiUltrapassada(name) {
          return "No par\xE2metro " + name + " a pontua\xE7\xE3o m\xE1xima foi ultrapassada, confirma o envio do relat\xF3rio?";
        },
        noParametroAPontuacaoMinimaNaoFoiAtingida: function noParametroAPontuacaoMinimaNaoFoiAtingida(name) {
          return "No par\xE2metro " + name + " a pontua\xE7\xE3o m\xEDnima n\xE3o foi atingida, confirma o envio do relat\xF3rio?";
        },


        titulo: "Cadastrar relatório de fadiga",

        formulario: {
          AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
          Tripulantes135: "Tripulantes - 135",
          Tripulantes121: "Tripulantes - 121",
          Mecanicos: "Mecânicos",
          Coordenadores: "Coordenadores",
          Data: "Data",
          Bases: "Bases",

          botaoAdicionarRelatorioDeFadiga: "Adicionar relatório de fadiga",

          placeholder: {
            SelecionarAplicabilidade: "Selecionar aplicabilidade",
            SelecionarTripulante: "Selecionar tripulante",
            SelecionarMecanico: "Selecionar mecânico",
            SelecionarCoordenador: "Selecionar coordenador",
            SelecionarBase: "Selecionar base",
            SelecionarOpcao: "Selecionar opção",
            Horas: "Horas",
            Quantidade: "Quantidade"
          }
        }

      },

      EditarParametroDeFadiga: {
        deletar: "Tem certeza que gostaria de deletar essa opção?",

        titulo: "Editar parâmetro de fadiga",

        formulario: {
          Nome: "Nome",
          Tipo: "Tipo",
          Operador: "Operador",
          PontosPorHora: "Pontos por hora",
          PontosPorQuantidade: "Pontos por quantidade",
          LimiteDePontos: "Limite de pontos",

          placeholder: {
            NomeDoParametroDeFadiga: "Nome do parâmetro de fadiga",
            SelecionarCliente: "Selecionar cliente",
            QuantidadeDePontosPorHora: "Quantidade de pontos por hora",
            QuantidadeDePontosPorQuantidade: "Quantidade de pontos por quantidade"
          }
        },

        tituloAdicionarOpcoes: "Adicionar opções",

        formularioAdicionarOpcoes: {
          Nome: "Nome",
          Pontos: "Pontos",

          placeholder: {
            NomeDoParametroDeFadiga: "Nome do parâmetro de fadiga",
            QuantidadeDePontos: "Quantidade de pontos"
          }
        },

        tituloOpcoes: "Opções",

        tabelaOpcoes: {
          Opcao: "Opção",
          Pontos: "Pontos",
          Acoes: "Ações"
        }

      },

      SimuladorDeRelatoriosDeFadiga: {
        titulo: "Simulador de relatórios de fadiga",

        formulario: {
          DataInicial: "Data inicial",
          DataFinal: "Data final",
          AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
          QuantidadeDePontos: "Quantidade de pontos",

          botaoGerarSimulacaoDeRelatoriosDeFadiga: "Gerar simulação de relatórios de fadiga",

          placeholder: {
            SelecionarAplicabilidade: "Selecionar aplicabilidade"
          }
        },

        tabDatas: {
          botaoGerarRelatoriosDeFadiga: "Gerar relatórios de fadiga",
          botaoCopiarParaProximasDatas: "Copiar para próximas datas",

          formulario: {
            MarcarComoFolga: "Marcar como folga",
            Data: "Data",

            placeholder: {
              SelecionarOpcao: "Selecionar opção",
              Horas: "Horas",
              Quantidade: "Quantidade"
            }
          }
        },

        tabela: {
          Data: "Data",
          Diaria: "Diária",
          Acumulada: "Acumulada"
        }
      },

      RevisarHorariosDePonto: {
        titulo: "Revisar horários de ponto",

        tituloUtilizeEstaFerramentaParaCorrigirOsReportes: "Utilize esta ferramenta para corrigir os reportes de acordo com a API de ponto.",
        tituloAtencaoCasoOReportNaoExistaDeveraSerCriado: "Atenção: Caso o reporte não exista, ele deverá ser criado manualmente primeiro.",

        formulario: {
          AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
          Tripulantes135: "Tripulantes - 135",
          Tripulantes121: "Tripulantes - 121",
          Mecanicos: "Mecânicos",
          Coordenadores: "Coordenadores",
          Data: "Data",

          botaoRevisarHorarios: "Revisar horários",

          placeholder: {
            SelecionarAplicabilidade: "Selecionar aplicabilidade",
            SelecionarTripulante: "Selecionar tripulante",
            SelecionarMecanico: "Selecionar mecânico",
            SelecionarCoordenador: "Selecionar coordenador"
          }
        }
      },

      FiltroDeRelatorio: {
        deletar: "Tem certeza que gostaria de deletar esse parâmetro de fadiga?",

        titulo: "Pesquisa de relatórios",

        formulario: {
          DataInicial: "Data inicial",
          DataFinal: "Data final",
          AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
          Mecanicos: "Mecânicos",
          Coordenadores: "Coordenadores",
          Tripulantes: "Tripulantes",
          Cargos: "Cargos",
          Frotas: "Frotas",
          Bases: "Bases",
          ApenasIncidentesDeFadiga: "Apenas incidentes de fadiga",

          botaoProcurarRelatorios: "Procurar relatórios",

          placeholder: {
            SelecionarAplicabilidade: "Selecionar aplicabilidade",
            SelecionarMecanicos: "Selecionar Mecânicos",
            SelecionarCoordenadores: "Selecionar Coordenadores",
            SelecionarTripulantes: "Selecionar Tripulantes",
            SelecionarCargos: "Selecionar cargos",
            SelecionarFrotas: "Selecionar frotas",
            SelecionarBases: "Selecionar bases"
          }
        },

        tituloListaDeRelatoriosDeFadiga: "Lista de relatórios de fadiga",

        botaoMostrarEsconderTripulantes: "Mostrar/Esconder tripulantes",
        botaoFiltrarTripulantes: "Filtrar tripulantes",

        tabela: {
          Nome: "Nome",
          Pontos: "Pontos"
        }

      },

      RelatorioDeEventosIncidentesDeFadiga: {
        titulo: "Relatório de Eventos/Incidentes de Fadiga",

        formulario: {
          DataInicial: "Data inicial",
          DataFinal: "Data final",
          AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
          Mecanicos: "Mecânicos",
          Coordenadores: "Coordenadores",
          Tripulantes: "Tripulantes",
          TipoDeEventoIncidente: "Tipo de Evento/Incidente",
          ApenasIncidentesDeFadigaChecados: "Apenas incidentes de fadiga checados",

          botaoProcurarRelatorios: "Procurar relatórios",

          placeholder: {
            SelecionarAplicabilidade: "Selecionar aplicabilidade",
            SelecionarMecanicos: "Selecionar Mecânicos",
            SelecionarCoordenadores: "Selecionar Coordenadores",
            SelecionarTripulantes: "Selecionar Tripulantes",
            SelecionarIncidente: "Selecionar incidente"
          }
        },

        tituloListaDeEventosIncidentesDeFadiga: "Lista de eventos/incidentes de fadiga",

        tabela: {
          semEventosIncidentesDeFadiga: "Não ocorreram eventos/incidentes de fadiga no período",
          ID: "ID",
          TipoDeEvento: "Tipo de Evento",
          Data: "Data",
          Revisao: "Revisão",
          Tripulante: "Tripulante",
          PontuacaoReportada: "Pontuação reportada",
          PontuacaoTotal: "Pontuação total",
          Checado: "Checado",
          DataDaChecagem: "Data da Checagem",
          AcaoRealizada: "Ação Realizada",
          Acoes: "Ações"
        },

        tituloEditarPlanoDeAcao: "Editar plano de ação",

        formularioEditarPlanoDeAcao: {
          PlanoDeAcao: "Plano de Ação",

          botaoEditarPlanoDeAcao: "Editar plano de ação"
        },

        marcarEsteIncidenteComoChecado: "Tem certeza que deseja marcar este incidente como checado?"
      },

      PesquisaDeRelatoriosNaoPreenchidos: {
        titulo: "Pesquisa de relatórios não preenchidos",

        formulario: {
          DataInicial: "Data inicial",
          DataFinal: "Data final",
          AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
          Bases: "Bases",
          IncluirFolgaCadastradaAutomaticamente: "Incluir folga cadastrada automaticamente",

          botaoProcurarRelatorios: "Procurar relatórios",

          placeholder: {
            SelecionarAplicabilidade: "Selecionar aplicabilidade",
            SelecionarBase: "Selecionar base"
          }
        },

        tituloListaDeRelatOriosDeFadigasFaltantes: "Lista de relatórios de fadigas faltantes",

        tabela: {
          semReportesFaltantes: "Não há reportes faltantes nesse período",
          Nome: "Nome",
          Data: "Data",
          Situacao: "Situação"
        }
      },

      PesquisaDeRelatorios: {
        titulo: "Pesquisa de relatórios",

        formulario: {
          DataInicial: "Data inicial",
          DataFinal: "Data final",
          AplicabilidadeTipoDeColaborador: "Aplicabilidade - Tipo de Colaborador",
          Mecanicos: "Mecânicos",
          Coordenadores: "Coordenadores",
          Tripulantes: "Tripulantes",
          Cargos: "Cargos",
          Bases: "Bases",

          botaoProcurarRelatarios: "Procurar relatórios",

          placeholder: {
            SelecionarAplicabilidade: "Selecionar aplicabilidade",
            SelecionarMecanicos: "Selecionar Mecânicos",
            SelecionarCoordenadores: "Selecionar Coordenadores",
            SelecionarTripulantes: "Selecionar Tripulantes",
            SelecionarCargos: "Selecionar cargos",
            SelecionarBases: "Selecionar bases"
          }
        },

        tituloTotalDoPeriodo: "Total do Período",

        tabelaTotalDoPeriodo: {
          semParametrosDeFadiga: "Não há parâmetros de fadiga cadastrados",
          NaoFadigados: "Não fadigados",
          PontosAzul: "Pontos Azul",
          PontosAmarelo: "Pontos Amarelo",
          PontosVermelho: "Pontos Vermelho"
        },

        tituloTotalDiario: "Total Diário",

        tabelaTotalDiario: {
          semParametrosDeFadiga: "Não há parâmetros de fadiga cadastrados",
          Data: "Data",
          NaoFadigados: "Não fadigados",
          PontosAzul: "Pontos Azul",
          PontosAmarelo: "Pontos Amarelo",
          PontosVermelho: "Pontos Vermelho"
        },

        tituloListaDeRelatoriosDeFadigas: "Lista de relatórios de fadigas",

        tabelaListaDeRelatoriosDeFadigas: {
          semParametrosDeFadiga: "Não há parâmetros de fadiga cadastrados",
          Data: "Data",
          Revisao: "Revisão",
          Tripulante: "Tripulante",
          Folga: "Folga",
          QuantidadeDePontosAtual: "Quantidade de pontos atual",
          QuantidadeDePontosReportados: "Quantidade de pontos reportados",
          DiaDePreenchimento: "Dia de preenchimento",
          Acoes: "Ações"
        },

        tituloDadosDoRelatorioDeFadiga: "Dados do relatório de fadiga",

        paragrafoQuantidadeDePontosAtual: "Quantidade de pontos atual",
        paragrafoQuantidadeDePontosReportados: "Quantidade de pontos reportados",

        tabelaDadosDoRelatorioDeFadiga: {
          Parametro: "Parâmetro",
          Dados: "Dados",
          Pontos: "Pontos"
        }
      }
    },

    HorasDeVoo: {

      VisualizarHorasDeVoo: {
        opcoesTipo: {
          Sintetica: "Sintética (Ignora filtro de data)",
          Analitica: "Analítica"
        },

        eNecessarioPreencherDataDeInicioEFimParaPesquisasAnaliticas: "É necessário preencher data de início e fim para pesquisas analíticas",

        titulo: "Visualizar horas de voo",

        formulario: {
          DataInicial: "Data Inicial",
          DataFinal: "Data Final",
          FB: "FB",
          Listagem: "Listagem",
          Modelo: "Modelo",

          placeholder: {
            SelecionarTipo: "Selecionar tipo",
            SelecionarModelosDeAeronave: "Selecionar modelos de aeronave"
          }
        },

        tabela: {
          semAeronaves: "Não há aeronaves cadastrados",
          ID: "ID",
          Data: "Data",
          Matricula: "Mat.",
          Apelido: "Apelido",
          Modelo: "Modelo",
          FB: "FB",
          Simulador: "Simulador",
          Total: "Total",
          IFR: "IFR.",
          Noturno: "Noturno",
          APP: "APP",
          Diu: "Diu",
          Not: "Not",
          CgExt: "Cg. Ext."
        },

        tituloTotais: "Totais",

        tabelaTotais: {
          semAeronaves: "Não há aeronaves cadastrados",
          ID: "ID",
          Matricula: "Mat.",
          Apelido: "Apelido",
          Modelo: "Modelo",
          Total: "Total",
          IFR: "IFR.",
          Noturno: "Noturno",
          APP: "APP",
          Diu: "Diu",
          Not: "Not"
        }
      }
    },

    Solicitacoes: {
      ListaDeSolicitacoes: {
        titulo: "Lista de Solicitações",

        tabela: {
          semSolicitacoes: "Não há solicitações cadastradas",
          ID: "ID",
          DataDeCriacao: "Data de Criação",
          Inicio: "Início",
          Fim: "Fim",
          Justificativa: "Justificativa",
          Status: "Status",
          ChefeDeFrota: "Chefe de Frota",
          ChefeDeFrotaDataResposta: "Chefe de Frota - Data Resposta",
          ChefeDeFrotaAprovacao: "Chefe de Frota - Aprovação",
          ChefeDeFrotaJustificativa: "Chefe de Frota - Justificativa",
          Administrativo: "Administrativo",
          AdministrativoDataResposta: "Administrativo - Data Resposta",
          AdministrativoAprovacao: "Administrativo - Aprovação",
          AdministrativoResposta: "Administrativo - Resposta"
        }
      },

      AdicionarSolicitacaoDeAlteracaoDeEscala: {
        criar: "Tem certeza de que deseja criar esta solicitação?",

        titulo: "Cadastrar Solicitação de Alteração de Escala",

        formulario: {
          Inicio: "Início",
          Fim: "Fim",
          Razao: "Razão"
        }
      },

      ListaDeSolicitacoesSigmec: {
        confirmarMudanca: "Tem certeza de que deseja mudar o status desta solicitação?",

        titulo: "Lista de Solicitações",

        tabela: {
          semSolicitacoes: "Não há solicitações cadastradas",
          ID: "ID",
          Escala: "Escala",
          Colaborador: "Colaborador",
          TipoDeSolicitacao: "Tipo de solicitação",
          Justificativa: "Justificativa",
          Status: "Status",
          Acoes: "Ações"
        },
        modal: {
          titulo: "Visualização de requisição",
          formulario: (_formulario = {
            EscalaMesAtual: "Escalas do mês atual",
            Atestado: "Atestado",
            Colaborador: "Colaborador",
            TipoDeAlteracao: "Tipo de alteração",
            Solicitante: "Solicitante",
            DataDeInicio: "Data de início",
            DataDeTermino: "Data de término",
            Definitiva: "A alteração é definitiva?",
            TempoIndeterminado: "Tempo Indeterminado",
            Descrição: "Descrição",
            Justificativa: "Justificativa",
            NumeroChamado: "N° do chamado",
            NumeroMp: "N° da MP aprovada"
          }, _defineProperty(_formulario, "Atestado", "Atestado"), _defineProperty(_formulario, "Descricao", "Descrição"), _defineProperty(_formulario, "BaseAtual", "Base Atual"), _defineProperty(_formulario, "NovaBase", "Nova Base"), _defineProperty(_formulario, "FuncaoAtual", "Função Atual"), _defineProperty(_formulario, "NovaFuncao", "Nova Função"), _defineProperty(_formulario, "QuinzenaAtual", "Quinzena Atual"), _defineProperty(_formulario, "NovaQuinzena", "Nova Quinzena"), _defineProperty(_formulario, "PeriodoAtual", "Período Atual"), _defineProperty(_formulario, "NovaPeriodo", "Nova Período"), _defineProperty(_formulario, "GrupoAtual", "Grupo Atual"), _defineProperty(_formulario, "NovoGrupo", "Novo Grupo"), _formulario),
          modal_additional: {
            Exigencia: "Exigência",
            Resposta: "Resposta",
            botaoEnviarInformacaos: "Enviar Informações",
            botaoAprovar: "Aprovar",
            botaoReprovar: "Reprovar"
          }
        }
      },

      AdicionarSolicitacaoDeAlteracaoDeEscalaSigmec: {
        titulo: "Cadastrar Solicitação de Alteração de Escala SIGMEC",
        erros: "Foram encontradosos seguintes erros ao tentar solicitar alterações",
        tabela: {
          EscalaMesAtual: "Escalas do mês atual",
          Colaborador: "Colaborador",
          TipoDeAlteracao: "Tipo de alteração",
          DataDeInicio: "Data de início",
          DataDeTermino: "Data de término",
          Duracao: "A alteração é definitiva? / Tempo Indeterminado",
          Justificativa: "Justificativa",
          Atual: "Atual",
          Novo: "Novo",
          NumeroChamado: "N° do chamado",
          NumeroMp: "N° da MP aprovada",
          Atestado: "Atestado",
          Descricao: "Descrição",
          Acoes: "Ações"
        },
        formulario: {
          placeholder: (_placeholder2 = {
            SelecioneEscala: "Selecione uma escala",
            selecioneColaborador: "Selecione um colaborador",
            SelecioneTipoDeAlteracao: "Selecione um tipo de alteração",
            SelecineGrupo: "Selecione um grupo",
            SelecineQuinzena: "Selecione uma quinzena",
            SelecineBase: "Selecione uma base",
            SelecinePeriodo: "Selecione um período",
            SelecineFuncao: "Selecione uma função"
          }, _defineProperty(_placeholder2, "SelecineFuncao", "Selecione uma função"), _defineProperty(_placeholder2, "NumeroChamado", "N° do chamado"), _defineProperty(_placeholder2, "NumeroMp", "N° da MP aprovada"), _defineProperty(_placeholder2, "Atestado", "Atestado"), _placeholder2),
          botaoSalvarSolicitacoes: "Adicionar solicitações",
          botaoAdicionarSolicitacao: "Adicionar solicitação"
        }

      }
    },

    Tarefas: {

      ListaDeTarefas: {
        titulo: "Lista de tarefas",

        botaoAdicionarTarefa: "Adicionar tarefa",

        tabela: {
          semTarefas: "Não há tarefas cadastradas",
          ID: "ID",
          Nome: "Nome",
          Acoes: "Ações"
        }
      },

      AdicionarTarefa: {
        titulo: "Cadastrar tarefas de restrição",

        formulario: {
          Tarefa: "Tarefa",

          botaoCadastrarTarefa: "Cadastrar tarefa",

          placeholder: {
            TarefaDeRestricao: "Tarefa de restrição"
          }
        }
      },

      EditarTarefa: {
        titulo: "Editar tarefa de restrição",

        formulario: {
          Tarefa: "Tarefa",

          placeholder: {
            TarefaDeRestricao: "Tarefa de restrição"
          }
        }
      }
    },

    Sessoes: {
      AdicionarSessao: {
        deletar: "Tem certeza que gostaria de deletar essa sessão?",
        finalizar: "Tem certeza que gostaria de finalizar essa sessão?",
        reabrir: "Tem certeza que gostaria de reabrir essa sessão?",

        osDadosForamAtualizadosComSucesso: "Os dados foram atualizados com sucesso",

        botaoAberto: "Aberto",
        botaoFinalizado: "Finalizado",
        botaoConfirmado: "Confirmado",

        titulo: "Adicionar sessão",

        formulario: {
          Treinamento: "Treinamento",
          Data: "Data",
          Inicio: "Início",
          Fim: "Fim",
          Examinador: "Examinador",
          Instrutor: "Instrutor",
          PilotFlying: "Pilot Flying",
          PilotMonitoring: "Pilot Monitoring",

          botaoAdicionarSessao: "Adicionar sessão",

          placeholder: {
            SelecionarCertificado: "Selecionar certificado",
            Data: "Data",
            HorarioDeInicio: "Horário de início",
            HorarioDeFim: "Horário de fim"
          }
        },

        tituloListaDeSessoes: "Lista de sessões",

        tabela: {
          semTarefas: "Não há tarefas cadastradas",
          ID: "ID",
          Treinamento: "Treinamento",
          Certificado: "Certificado",
          Inicio: "Início",
          Fim: "Fim",
          HorasTotais: "Horas Totais",
          Arquivo: "Arquivo",
          Status: "Status",
          Acoes: "Ações"
        },

        importarArquivo: "Tem certeza que gostaria de importar este arquivo? Ao importar, o arquivo anterior, se houver, será substituido permanentemente.",

        formularioAdicionarArquivo: {

          placeholder: {
            Arquivo: "Arquivo"
          }
        },

        opcoesTipo: {
          Examinador: "Examinador",
          Instrutor: "Instrutor",
          PilotFlying: "Pilot Flying",
          PilotMonitoring: "Pilot Monitoring"
        },

        deletarTripulante: "Tem certeza que deseja deletar esse tripulante?",

        tituloAdicionarTripulante: "Adicionar tripulante",

        tabelaTripulantes: {
          Tripulante: "Tripulante",
          Matricula: "Matrícula",
          Tipo: "Tipo",
          Acoes: "Ações"
        }

      }
    },

    LinksUteis: {
      LinksUteis: {
        deletar: "Tem certeza que gostaria de deletar esse link?",

        titulo: "Links Úteis",

        tabela: {
          semIncompatibilidades: "Não há incompatibilidades cadastradas",
          ID: "ID",
          Nome: "Nome",
          Link: "Link"
        }
      }
    },

    Usuarios: {
      AlteracaoDeSenha: {
        titulo: "Alteração de senha",

        formulario: {
          SenhaAtual: "Senha atual",
          NovaSenha: "Nova senha",
          RepitaANovaSenha: "Repita a nova senha",

          placeholder: {
            SenhaAtual: "Senha atual",
            NovaSenha: "Nova senha",
            RepitaANovaSenha: "Repita a nova senha"
          }
        }
      },

      SistemaSuspensoParaManutencao: {
        titulo: "Sistema suspenso para manutenção",

        tituloAtualizacao: "Atualização",

        paragrafoPrevisaoDeVolta: "Previsão de volta"
      },

      RecuperarSenha: {
        formulario: {

          botaoRecuperarSenha: "Recuperar senha",

          placeholder: {
            SeuEmail: "Seu e-mail"
          }
        },

        paragrafoVoltarParaLogin: "Voltar para login"
      },

      Login: {
        usuarioNaoCadastrado: "Usuário não cadastrato. Solicite a TI a criação do usuário.",
        usuarioInativo: "Usuário inativo neste sistema. Solicite a TI a liberação do usuário.",
        usuarioSemPermissoes: "Usuário sem permissões para este sistema. Solicite a TI as permissões de acesso para este usuário.",
        usuarioOuSenhaInvalidos: "Usuário ou senha inválidos.",

        paragrafoModuloAdministrativo: "MÓDULO ADMINISTRATIVO",

        formulario: {
          paragrafoAtencao: "ATENÇÃO: VOCÊ ACESSARÁ O AMBIENTE DE HOMOLOGAÇÃO",

          botaoAcessarOSistema: "Acessar o sistema",

          placeholder: {
            SeuEmail: "Seu E-mail",
            SuaSenha: "Sua senha"
          }
        },

        paragrafoOLoginDeveSerFeitoComUsuarioESenhaOmniRubi: "O LOGIN DEVE SER FEITO COM O USUÁRIO E SENHA OMNI/RUBI",

        paragrafoEsqueciMinhaSenha: "Esqueci minha senha",

        paragrafoEntreEmContato: "Entre em contato com o setor de TI.",

        paragrafoPortalDeColaboradores: "PORTAL DE COLABORADORES"
      },

      Questionario: {

        titulo: "Questionário",

        formulario: {
          VoceConcordaQueSeSentiuFadigadoNosUltimosDias: "Você concorda que se sentiu fadigado nos últimos dias",
          SelecioneOsFatoresQueContribuiramParaAFadiga: "Selecione os fatores que contribuíram para a fadiga",

          opcoesFatoresQueContribuiramParaAFadiga: {
            NaoMeSentiFadigado: "Não me senti fadigado",
            DescansoInsuficienteEntreJornadas: "Descanso insuficiente entre jornadas",
            JornadaInterrompida: "Jornada interrompida",
            TransicaoDaJornadaDiurnoParaNoturno: "Transição da jornada (diurno para noturno)",
            TransicaoDaJornadaNoturnoParaDiurno: "Transição da jornada (noturno para diurno)",
            HorarioDeInicioDaJornadaDiurno: "Horário de início da jornada (diurno)",
            HorarioDeInicioDaJornadaNoturno: "Horário de início da jornada (noturno)",
            TrabalhoNoturno: "Trabalho noturno",
            DuracaoDaJornada: "Duração da jornada",
            HoraExtra: "Hora extra",
            Transporte: "Transporte",
            Saude: "Saúde",
            FadigaAcumulada: "Fadiga acumulada",
            ProblemasPessoais: "Problemas Pessoais"
          },

          HistoricoDoSonoDosUltimos3Dias: "Histórico do Sono dos últimos 3 dias",
          QueHorasDormiuNoUltimoDia: "Que horas dormiu no último dia",
          QueHorasAcordouNoUltimoDia: "Que horas acordou no último dia",
          QualidadeDoSonoNoUltimoDia: "Qualidade do sono no último dia",

          opcoesSono: {
            Otimo: "Ótimo",
            Bom: "Bom",
            Normal: "Normal",
            Ruim: "Ruim",
            Pessimo: "Péssimo"
          },

          QueHorasDormiuNoPenultimoDia: "Que horas dormiu no penúltimo dia",
          QueHorasAcordouNoPenultimoDia: "Que horas acordou no penúltimo dia",
          QualidadeDoSonoNoPenultimoDia: "Qualidade do sono no penúltimo dia",

          QueHorasDormiuHa3Dias: "Que horas dormiu há 3 dias",
          QueHorasAcordouHa3Dias: "Que horas acordou há 3 dias",
          QualidadeDoSonoHa3Dias: "Qualidade do sono há 3 dias",

          SinaisFisiologicosECognitivos: "Sinais fisiológicos e cognitivos",

          opcoesSinaisFisiologicos: {
            NaoMeSentiFadigado: "Não me senti fadigado",
            NenhumSinalFisicoPercebido: "Nenhum sinal físico percebido",
            EsfregarOsOlhosComFrequencia: "Esfregar os olhos com frequência",
            PiscadasFrequentes: "Piscadas frequentes",
            Bocejo: "Bocejo",
            OlharFixo: "Olhar fixo",
            DificuldadeEmManterOsOlhosAbertos: "Dificuldade em manter os olhos abertos",
            PiscadasLongas: "Piscadas longas",
            CabeçaBalancandoOuCaindo: "Cabeça balançando ou caindo",
            Inquietacao: "Inquietação"
          },

          Contramedidas: "Contramedidas",

          opcoesContramedidas: {
            NaoMeSentiFadigado: "Não me senti fadigado",
            AlertouAoColegaSobreORiscoDeFadiga: "Alertou ao colega sobre o risco de fadiga",
            AumentouAComunicacao: "Aumentou a comunicação",
            ComidaOuBebida: "Comida ou bebida",
            Soneca: "Soneca",
            CoordenouACargaDeTrabalho: "Coordenou a carga de trabalho",
            Cafeina: "Cafeína"
          },

          DetalhamentoECausasProvaveis: "Detalhamento e causas prováveis",
          VoceAcreditaQueOSistemaDeGerenciamentoDeFadigaEEficiente: "Você acredita que o sistema de gerenciamento de fadiga é eficiente",
          Sugestoes: "Sugestões",

          botaoResponder: "Responder",

          placeholder: {
            SelecionarUmaOpcao: "Selecionar uma opção",
            HorarioDeApresentacao: "Horário de Apresentação",
            SelecionarAplicabilidade: "Selecionar aplicabilidade",
            CasoNaoTenhaSeSentidoFadigadoPreenchaComNA: "Caso não tenha se sentido fadigado, preencha com N/A"
          }
        }

      },

      TesteDeSonolencia: {
        titulo: "Teste de sonolência",

        formulario: {
          HorarioDeInicioDaJornada: "Horário de Início da Jornada",
          ComoVoceEstaSeSentindoAgora: "Como você está se sentindo agora",

          opcoesComoVoceEstaSeSentindoAgora: {
            ExtremamenteAlerta: "Extremely alert (Extremamente alerta)",
            MuitoAlerta: "Very alert (Muito alerta)",
            Alerta: "Alert (Alerta)",
            RazoavelmenteAlerta: "Fairly alert (Razoavelmente alerta)",
            NemAlertaNemSonolento: "Neither alert nor sleepy (Nem alerta nem sonolento)",
            AlgunsSinaisDeSonolencia: "Some signs of sleepiness (Alguns sinais de sonolência)",
            SonolentoMasConsigoMeManterAcordado: "Sleepy, but no effort to keep alert (Sonolento, mas consigo me manter acordado)",
            SonolentoPrecisoMeConcentrarParaMeManterAcordado: "Sleepy, some effort to keep alert (Sonolento, preciso me concentrar para me manter acordado)",
            MuitosonolentoMuitoEsforcoParaMeManterAcordadoLutandoComOSono: "Very sleepy, great effort to keep alert, fighting sleep (Muito sonolento, muito esforço para me manter acordado, lutando com o sono)"
          },

          botaoResponder: "Responder",

          placeholder: {
            HorarioDeApresentacao: "Horário de Apresentação"
          }
        }
      }

    }

  };
};

/* harmony default export */ __webpack_exports__["a"] = (getLocale);

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.

// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.

function register() {
  if ("production" === 'production' && 'serviceWorker' in navigator) {
    window.addEventListener('load', function () {
      var swUrl = "" + '/service-worker.js';
      navigator.serviceWorker.register(swUrl).then(function (registration) {
        registration.onupdatefound = function () {
          var installingWorker = registration.installing;
          installingWorker.onstatechange = function () {
            if (installingWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                // At this point, the old content will have been purged and
                // the fresh content will have been added to the cache.
                // It's the perfect time to display a "New content is
                // available; please refresh." message in your web app.
              } else {
                  // At this point, everything has been precached.
                  // It's the perfect time to display a
                  // "Content is cached for offline use." message.
                }
            }
          };
        };
      }).catch(function (error) {
        console.error('Error during service worker registration:', error);
      });
    });
  }
}

function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(function (registration) {
      registration.unregister();
    });
  }
}

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(991), __esModule: true };

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(993), __esModule: true };

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(995), __esModule: true };

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(997), __esModule: true };

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(998), __esModule: true };

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(450);
__webpack_require__(1021);
module.exports = __webpack_require__(60).Array.from;


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1023);
module.exports = __webpack_require__(60).Object.assign;


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1024);
var $Object = __webpack_require__(60).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1028);
module.exports = __webpack_require__(60).Object.entries;


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1025);
module.exports = __webpack_require__(60).Object.setPrototypeOf;


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1029);
module.exports = __webpack_require__(60).Object.values;


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1027);
__webpack_require__(1026);
__webpack_require__(1030);
__webpack_require__(1031);
module.exports = __webpack_require__(60).Symbol;


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(450);
__webpack_require__(1032);
module.exports = __webpack_require__(288).f('iterator');


/***/ }),
/* 999 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 1000 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(96);
var toLength = __webpack_require__(449);
var toAbsoluteIndex = __webpack_require__(1019);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(274);
var TAG = __webpack_require__(61)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(95);
var createDesc = __webpack_require__(159);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(157);
var gOPS = __webpack_require__(280);
var pIE = __webpack_require__(158);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(82).document;
module.exports = document && document.documentElement;


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(156);
var ITERATOR = __webpack_require__(61)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(274);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(112);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(279);
var descriptor = __webpack_require__(159);
var setToStringTag = __webpack_require__(281);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(114)(IteratorPrototype, __webpack_require__(61)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(61)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 1011 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(186)('meta');
var isObject = __webpack_require__(155);
var has = __webpack_require__(94);
var setDesc = __webpack_require__(95).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(154)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(157);
var gOPS = __webpack_require__(280);
var pIE = __webpack_require__(158);
var toObject = __webpack_require__(285);
var IObject = __webpack_require__(442);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(154)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(95);
var anObject = __webpack_require__(112);
var getKeys = __webpack_require__(157);

module.exports = __webpack_require__(113) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(96);
var gOPN = __webpack_require__(445).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(94);
var toObject = __webpack_require__(285);
var IE_PROTO = __webpack_require__(282)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(155);
var anObject = __webpack_require__(112);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(275)(Function.call, __webpack_require__(444).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(284);
var defined = __webpack_require__(276);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(284);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(1002);
var ITERATOR = __webpack_require__(61)('iterator');
var Iterators = __webpack_require__(156);
module.exports = __webpack_require__(60).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(275);
var $export = __webpack_require__(81);
var toObject = __webpack_require__(285);
var call = __webpack_require__(1008);
var isArrayIter = __webpack_require__(1006);
var toLength = __webpack_require__(449);
var createProperty = __webpack_require__(1003);
var getIterFn = __webpack_require__(1020);

$export($export.S + $export.F * !__webpack_require__(1010)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(1000);
var step = __webpack_require__(1011);
var Iterators = __webpack_require__(156);
var toIObject = __webpack_require__(96);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(443)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(81);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1013) });


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(81);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(279) });


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(81);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1017).set });


/***/ }),
/* 1026 */
/***/ (function(module, exports) {



/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(82);
var has = __webpack_require__(94);
var DESCRIPTORS = __webpack_require__(113);
var $export = __webpack_require__(81);
var redefine = __webpack_require__(448);
var META = __webpack_require__(1012).KEY;
var $fails = __webpack_require__(154);
var shared = __webpack_require__(283);
var setToStringTag = __webpack_require__(281);
var uid = __webpack_require__(186);
var wks = __webpack_require__(61);
var wksExt = __webpack_require__(288);
var wksDefine = __webpack_require__(287);
var enumKeys = __webpack_require__(1004);
var isArray = __webpack_require__(1007);
var anObject = __webpack_require__(112);
var toIObject = __webpack_require__(96);
var toPrimitive = __webpack_require__(286);
var createDesc = __webpack_require__(159);
var _create = __webpack_require__(279);
var gOPNExt = __webpack_require__(1015);
var $GOPD = __webpack_require__(444);
var $DP = __webpack_require__(95);
var $keys = __webpack_require__(157);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(445).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(158).f = $propertyIsEnumerable;
  __webpack_require__(280).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(278)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(114)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(81);
var $entries = __webpack_require__(447)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(81);
var $values = __webpack_require__(447)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(287)('asyncIterator');


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(287)('observable');


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1022);
var global = __webpack_require__(82);
var hide = __webpack_require__(114);
var Iterators = __webpack_require__(156);
var TO_STRING_TAG = __webpack_require__(61)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1757);


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return (b64.length * 3 / 4) - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr((len * 3 / 4) - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0; i < l; i += 4) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(1034)
var ieee754 = __webpack_require__(1166)
var isArray = __webpack_require__(1036)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AC */
/* unused harmony export AD */
/* unused harmony export AE */
/* unused harmony export AF */
/* unused harmony export AG */
/* unused harmony export AI */
/* unused harmony export AL */
/* unused harmony export AM */
/* unused harmony export AO */
/* unused harmony export AQ */
/* unused harmony export AR */
/* unused harmony export AS */
/* unused harmony export AT */
/* unused harmony export AU */
/* unused harmony export AW */
/* unused harmony export AX */
/* unused harmony export AZ */
/* unused harmony export BA */
/* unused harmony export BB */
/* unused harmony export BD */
/* unused harmony export BE */
/* unused harmony export BF */
/* unused harmony export BG */
/* unused harmony export BH */
/* unused harmony export BI */
/* unused harmony export BJ */
/* unused harmony export BL */
/* unused harmony export BM */
/* unused harmony export BN */
/* unused harmony export BO */
/* unused harmony export BQ */
/* unused harmony export BR */
/* unused harmony export BS */
/* unused harmony export BT */
/* unused harmony export BV */
/* unused harmony export BW */
/* unused harmony export BY */
/* unused harmony export BZ */
/* unused harmony export CA */
/* unused harmony export CC */
/* unused harmony export CD */
/* unused harmony export CF */
/* unused harmony export CG */
/* unused harmony export CH */
/* unused harmony export CI */
/* unused harmony export CK */
/* unused harmony export CL */
/* unused harmony export CM */
/* unused harmony export CN */
/* unused harmony export CO */
/* unused harmony export CR */
/* unused harmony export CU */
/* unused harmony export CV */
/* unused harmony export CW */
/* unused harmony export CX */
/* unused harmony export CY */
/* unused harmony export CZ */
/* unused harmony export DE */
/* unused harmony export DJ */
/* unused harmony export DK */
/* unused harmony export DM */
/* unused harmony export DO */
/* unused harmony export DZ */
/* unused harmony export EC */
/* unused harmony export EE */
/* unused harmony export EG */
/* unused harmony export EH */
/* unused harmony export ER */
/* unused harmony export ES */
/* unused harmony export ET */
/* unused harmony export EU */
/* unused harmony export FI */
/* unused harmony export FJ */
/* unused harmony export FK */
/* unused harmony export FM */
/* unused harmony export FO */
/* unused harmony export FR */
/* unused harmony export GA */
/* unused harmony export GB */
/* unused harmony export GD */
/* unused harmony export GE */
/* unused harmony export GF */
/* unused harmony export GG */
/* unused harmony export GH */
/* unused harmony export GI */
/* unused harmony export GL */
/* unused harmony export GM */
/* unused harmony export GN */
/* unused harmony export GP */
/* unused harmony export GQ */
/* unused harmony export GR */
/* unused harmony export GS */
/* unused harmony export GT */
/* unused harmony export GU */
/* unused harmony export GW */
/* unused harmony export GY */
/* unused harmony export HK */
/* unused harmony export HM */
/* unused harmony export HN */
/* unused harmony export HR */
/* unused harmony export HT */
/* unused harmony export HU */
/* unused harmony export IC */
/* unused harmony export ID */
/* unused harmony export IE */
/* unused harmony export IL */
/* unused harmony export IM */
/* unused harmony export IN */
/* unused harmony export IO */
/* unused harmony export IQ */
/* unused harmony export IR */
/* unused harmony export IS */
/* unused harmony export IT */
/* unused harmony export JE */
/* unused harmony export JM */
/* unused harmony export JO */
/* unused harmony export JP */
/* unused harmony export KE */
/* unused harmony export KG */
/* unused harmony export KH */
/* unused harmony export KI */
/* unused harmony export KM */
/* unused harmony export KN */
/* unused harmony export KP */
/* unused harmony export KR */
/* unused harmony export KW */
/* unused harmony export KY */
/* unused harmony export KZ */
/* unused harmony export LA */
/* unused harmony export LB */
/* unused harmony export LC */
/* unused harmony export LI */
/* unused harmony export LK */
/* unused harmony export LR */
/* unused harmony export LS */
/* unused harmony export LT */
/* unused harmony export LU */
/* unused harmony export LV */
/* unused harmony export LY */
/* unused harmony export MA */
/* unused harmony export MC */
/* unused harmony export MD */
/* unused harmony export ME */
/* unused harmony export MF */
/* unused harmony export MG */
/* unused harmony export MH */
/* unused harmony export MK */
/* unused harmony export ML */
/* unused harmony export MM */
/* unused harmony export MN */
/* unused harmony export MO */
/* unused harmony export MP */
/* unused harmony export MQ */
/* unused harmony export MR */
/* unused harmony export MS */
/* unused harmony export MT */
/* unused harmony export MU */
/* unused harmony export MV */
/* unused harmony export MW */
/* unused harmony export MX */
/* unused harmony export MY */
/* unused harmony export MZ */
/* unused harmony export NA */
/* unused harmony export NC */
/* unused harmony export NE */
/* unused harmony export NF */
/* unused harmony export NG */
/* unused harmony export NI */
/* unused harmony export NL */
/* unused harmony export NO */
/* unused harmony export NP */
/* unused harmony export NR */
/* unused harmony export NU */
/* unused harmony export NZ */
/* unused harmony export OM */
/* unused harmony export PA */
/* unused harmony export PE */
/* unused harmony export PF */
/* unused harmony export PG */
/* unused harmony export PH */
/* unused harmony export PK */
/* unused harmony export PL */
/* unused harmony export PM */
/* unused harmony export PN */
/* unused harmony export PR */
/* unused harmony export PS */
/* unused harmony export PT */
/* unused harmony export PW */
/* unused harmony export PY */
/* unused harmony export QA */
/* unused harmony export RE */
/* unused harmony export RO */
/* unused harmony export RS */
/* unused harmony export RU */
/* unused harmony export RW */
/* unused harmony export SA */
/* unused harmony export SB */
/* unused harmony export SC */
/* unused harmony export SD */
/* unused harmony export SE */
/* unused harmony export SG */
/* unused harmony export SH */
/* unused harmony export SI */
/* unused harmony export SJ */
/* unused harmony export SK */
/* unused harmony export SL */
/* unused harmony export SM */
/* unused harmony export SN */
/* unused harmony export SO */
/* unused harmony export SR */
/* unused harmony export SS */
/* unused harmony export ST */
/* unused harmony export SV */
/* unused harmony export SX */
/* unused harmony export SY */
/* unused harmony export SZ */
/* unused harmony export TA */
/* unused harmony export TC */
/* unused harmony export TD */
/* unused harmony export TF */
/* unused harmony export TG */
/* unused harmony export TH */
/* unused harmony export TJ */
/* unused harmony export TK */
/* unused harmony export TL */
/* unused harmony export TM */
/* unused harmony export TN */
/* unused harmony export TO */
/* unused harmony export TR */
/* unused harmony export TT */
/* unused harmony export TV */
/* unused harmony export TW */
/* unused harmony export TZ */
/* unused harmony export UA */
/* unused harmony export UG */
/* unused harmony export UM */
/* unused harmony export US */
/* unused harmony export UY */
/* unused harmony export UZ */
/* unused harmony export VA */
/* unused harmony export VC */
/* unused harmony export VE */
/* unused harmony export VG */
/* unused harmony export VI */
/* unused harmony export VN */
/* unused harmony export VU */
/* unused harmony export WF */
/* unused harmony export WS */
/* unused harmony export XK */
/* unused harmony export YE */
/* unused harmony export YT */
/* unused harmony export ZA */
/* unused harmony export ZM */
/* unused harmony export ZW */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _excluded = ["title"],
    _excluded2 = ["title"],
    _excluded3 = ["title"],
    _excluded4 = ["title"],
    _excluded5 = ["title"],
    _excluded6 = ["title"],
    _excluded7 = ["title"],
    _excluded8 = ["title"],
    _excluded9 = ["title"],
    _excluded10 = ["title"],
    _excluded11 = ["title"],
    _excluded12 = ["title"],
    _excluded13 = ["title"],
    _excluded14 = ["title"],
    _excluded15 = ["title"],
    _excluded16 = ["title"],
    _excluded17 = ["title"],
    _excluded18 = ["title"],
    _excluded19 = ["title"],
    _excluded20 = ["title"],
    _excluded21 = ["title"],
    _excluded22 = ["title"],
    _excluded23 = ["title"],
    _excluded24 = ["title"],
    _excluded25 = ["title"],
    _excluded26 = ["title"],
    _excluded27 = ["title"],
    _excluded28 = ["title"],
    _excluded29 = ["title"],
    _excluded30 = ["title"],
    _excluded31 = ["title"],
    _excluded32 = ["title"],
    _excluded33 = ["title"],
    _excluded34 = ["title"],
    _excluded35 = ["title"],
    _excluded36 = ["title"],
    _excluded37 = ["title"],
    _excluded38 = ["title"],
    _excluded39 = ["title"],
    _excluded40 = ["title"],
    _excluded41 = ["title"],
    _excluded42 = ["title"],
    _excluded43 = ["title"],
    _excluded44 = ["title"],
    _excluded45 = ["title"],
    _excluded46 = ["title"],
    _excluded47 = ["title"],
    _excluded48 = ["title"],
    _excluded49 = ["title"],
    _excluded50 = ["title"],
    _excluded51 = ["title"],
    _excluded52 = ["title"],
    _excluded53 = ["title"],
    _excluded54 = ["title"],
    _excluded55 = ["title"],
    _excluded56 = ["title"],
    _excluded57 = ["title"],
    _excluded58 = ["title"],
    _excluded59 = ["title"],
    _excluded60 = ["title"],
    _excluded61 = ["title"],
    _excluded62 = ["title"],
    _excluded63 = ["title"],
    _excluded64 = ["title"],
    _excluded65 = ["title"],
    _excluded66 = ["title"],
    _excluded67 = ["title"],
    _excluded68 = ["title"],
    _excluded69 = ["title"],
    _excluded70 = ["title"],
    _excluded71 = ["title"],
    _excluded72 = ["title"],
    _excluded73 = ["title"],
    _excluded74 = ["title"],
    _excluded75 = ["title"],
    _excluded76 = ["title"],
    _excluded77 = ["title"],
    _excluded78 = ["title"],
    _excluded79 = ["title"],
    _excluded80 = ["title"],
    _excluded81 = ["title"],
    _excluded82 = ["title"],
    _excluded83 = ["title"],
    _excluded84 = ["title"],
    _excluded85 = ["title"],
    _excluded86 = ["title"],
    _excluded87 = ["title"],
    _excluded88 = ["title"],
    _excluded89 = ["title"],
    _excluded90 = ["title"],
    _excluded91 = ["title"],
    _excluded92 = ["title"],
    _excluded93 = ["title"],
    _excluded94 = ["title"],
    _excluded95 = ["title"],
    _excluded96 = ["title"],
    _excluded97 = ["title"],
    _excluded98 = ["title"],
    _excluded99 = ["title"],
    _excluded100 = ["title"],
    _excluded101 = ["title"],
    _excluded102 = ["title"],
    _excluded103 = ["title"],
    _excluded104 = ["title"],
    _excluded105 = ["title"],
    _excluded106 = ["title"],
    _excluded107 = ["title"],
    _excluded108 = ["title"],
    _excluded109 = ["title"],
    _excluded110 = ["title"],
    _excluded111 = ["title"],
    _excluded112 = ["title"],
    _excluded113 = ["title"],
    _excluded114 = ["title"],
    _excluded115 = ["title"],
    _excluded116 = ["title"],
    _excluded117 = ["title"],
    _excluded118 = ["title"],
    _excluded119 = ["title"],
    _excluded120 = ["title"],
    _excluded121 = ["title"],
    _excluded122 = ["title"],
    _excluded123 = ["title"],
    _excluded124 = ["title"],
    _excluded125 = ["title"],
    _excluded126 = ["title"],
    _excluded127 = ["title"],
    _excluded128 = ["title"],
    _excluded129 = ["title"],
    _excluded130 = ["title"],
    _excluded131 = ["title"],
    _excluded132 = ["title"],
    _excluded133 = ["title"],
    _excluded134 = ["title"],
    _excluded135 = ["title"],
    _excluded136 = ["title"],
    _excluded137 = ["title"],
    _excluded138 = ["title"],
    _excluded139 = ["title"],
    _excluded140 = ["title"],
    _excluded141 = ["title"],
    _excluded142 = ["title"],
    _excluded143 = ["title"],
    _excluded144 = ["title"],
    _excluded145 = ["title"],
    _excluded146 = ["title"],
    _excluded147 = ["title"],
    _excluded148 = ["title"],
    _excluded149 = ["title"],
    _excluded150 = ["title"],
    _excluded151 = ["title"],
    _excluded152 = ["title"],
    _excluded153 = ["title"],
    _excluded154 = ["title"],
    _excluded155 = ["title"],
    _excluded156 = ["title"],
    _excluded157 = ["title"],
    _excluded158 = ["title"],
    _excluded159 = ["title"],
    _excluded160 = ["title"],
    _excluded161 = ["title"],
    _excluded162 = ["title"],
    _excluded163 = ["title"],
    _excluded164 = ["title"],
    _excluded165 = ["title"],
    _excluded166 = ["title"],
    _excluded167 = ["title"],
    _excluded168 = ["title"],
    _excluded169 = ["title"],
    _excluded170 = ["title"],
    _excluded171 = ["title"],
    _excluded172 = ["title"],
    _excluded173 = ["title"],
    _excluded174 = ["title"],
    _excluded175 = ["title"],
    _excluded176 = ["title"],
    _excluded177 = ["title"],
    _excluded178 = ["title"],
    _excluded179 = ["title"],
    _excluded180 = ["title"],
    _excluded181 = ["title"],
    _excluded182 = ["title"],
    _excluded183 = ["title"],
    _excluded184 = ["title"],
    _excluded185 = ["title"],
    _excluded186 = ["title"],
    _excluded187 = ["title"],
    _excluded188 = ["title"],
    _excluded189 = ["title"],
    _excluded190 = ["title"],
    _excluded191 = ["title"],
    _excluded192 = ["title"],
    _excluded193 = ["title"],
    _excluded194 = ["title"],
    _excluded195 = ["title"],
    _excluded196 = ["title"],
    _excluded197 = ["title"],
    _excluded198 = ["title"],
    _excluded199 = ["title"],
    _excluded200 = ["title"],
    _excluded201 = ["title"],
    _excluded202 = ["title"],
    _excluded203 = ["title"],
    _excluded204 = ["title"],
    _excluded205 = ["title"],
    _excluded206 = ["title"],
    _excluded207 = ["title"],
    _excluded208 = ["title"],
    _excluded209 = ["title"],
    _excluded210 = ["title"],
    _excluded211 = ["title"],
    _excluded212 = ["title"],
    _excluded213 = ["title"],
    _excluded214 = ["title"],
    _excluded215 = ["title"],
    _excluded216 = ["title"],
    _excluded217 = ["title"],
    _excluded218 = ["title"],
    _excluded219 = ["title"],
    _excluded220 = ["title"],
    _excluded221 = ["title"],
    _excluded222 = ["title"],
    _excluded223 = ["title"],
    _excluded224 = ["title"],
    _excluded225 = ["title"],
    _excluded226 = ["title"],
    _excluded227 = ["title"],
    _excluded228 = ["title"],
    _excluded229 = ["title"],
    _excluded230 = ["title"],
    _excluded231 = ["title"],
    _excluded232 = ["title"],
    _excluded233 = ["title"],
    _excluded234 = ["title"],
    _excluded235 = ["title"],
    _excluded236 = ["title"],
    _excluded237 = ["title"],
    _excluded238 = ["title"],
    _excluded239 = ["title"],
    _excluded240 = ["title"],
    _excluded241 = ["title"],
    _excluded242 = ["title"],
    _excluded243 = ["title"],
    _excluded244 = ["title"],
    _excluded245 = ["title"],
    _excluded246 = ["title"],
    _excluded247 = ["title"],
    _excluded248 = ["title"],
    _excluded249 = ["title"],
    _excluded250 = ["title"],
    _excluded251 = ["title"],
    _excluded252 = ["title"],
    _excluded253 = ["title"],
    _excluded254 = ["title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var AC = function AC(_ref) {
  var title = _ref.title,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M440.1 181.1c-.1 39.2-6.4 81.4-57.4 101.5-51.1-20.1-57.3-62.3-57.4-101.5h114.8z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#29DBFF",
    d: "M439.6 197.7c-2.8 34.9-12.4 67.4-57 85-44.4-17.6-54.5-51.2-56.9-84.9"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M437.8 214.1c-3.2 24.3-16.7 53.5-55.1 68.6-38.4-15.1-50.5-42.5-55.1-68.4"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#29DBFF",
    d: "M434.2 230.3c-5.7 17.7-19.3 39.4-51.3 52.8-32-12.6-45.2-33.8-51.4-53"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M426.7 246.9c-6.5 11.3-17.7 25.4-44 35.9-27.5-11.5-37.4-25.3-44-36.1"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#29DBFF",
    d: "M412.4 265.1c-8.1 7.2-12 11.2-29.6 17.9-20.1-7.9-22.6-11.6-29.2-17.5"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#5CC85C",
    d: "M383.3 231.6c-.2-.2-27.9 35.7-27.9 35.7-1.8-1.3-10-9.5-13.3-15l41.3-50.1 40.2 49.7c-3.9 6.5-11.4 13.6-13.2 15M382.6 85.3l-26.5 45h53z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", {
    transform: "rotate(-82.3 291.431 225.686)",
    fill: "#F7A226",
    cx: 291.4,
    cy: 225.7,
    rx: 48.7,
    ry: 15.7
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", {
    transform: "rotate(-68.099 303.087 164.67)",
    fill: "#DDC7AB",
    cx: 303.1,
    cy: 164.7,
    rx: 11.7,
    ry: 7.2
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", {
    transform: "rotate(-81.738 291.697 271.697)",
    fill: "#DDC7AB",
    cx: 291.7,
    cy: 271.7,
    rx: 11.4,
    ry: 3.3
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", {
    transform: "matrix(.9986 -.05353 .05353 .9986 -13.992 16.424)",
    fill: "#DDC7AB",
    cx: 299.6,
    cy: 269.4,
    rx: 3.3,
    ry: 11
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", {
    transform: "rotate(-21.518 314.54 201.06)",
    fill: "#DDC7AB",
    cx: 314.5,
    cy: 201.1,
    rx: 4.1,
    ry: 13.7
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", {
    transform: "rotate(-21.518 317.511 178.077)",
    fill: "#DDC7AB",
    cx: 317.5,
    cy: 178.1,
    rx: 13.7,
    ry: 4.1
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", {
    transform: "rotate(-7.7 473.781 225.857)",
    fill: "#F7A226",
    cx: 473.6,
    cy: 225.9,
    rx: 15.7,
    ry: 48.7
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", {
    transform: "rotate(-21.901 462.057 164.866)",
    fill: "#DDC7AB",
    cx: 462,
    cy: 164.9,
    rx: 7.2,
    ry: 11.7
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", {
    transform: "rotate(-8.27 473.27 271.908)",
    fill: "#DDC7AB",
    cx: 473.4,
    cy: 271.9,
    rx: 3.3,
    ry: 11.4
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", {
    transform: "matrix(.05353 -.9986 .9986 .05353 171.34 719.998)",
    fill: "#DDC7AB",
    cx: 465.5,
    cy: 269.6,
    rx: 11,
    ry: 3.3
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", {
    transform: "rotate(-68.482 450.552 201.247)",
    fill: "#DDC7AB",
    cx: 450.6,
    cy: 201.2,
    rx: 13.7,
    ry: 4.1
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", {
    transform: "rotate(-68.482 447.58 178.265)",
    fill: "#DDC7AB",
    cx: 447.6,
    cy: 178.3,
    rx: 4.1,
    ry: 13.7
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#B0C6CC",
    d: "M373.3 130.3 356.1 155l17.8 26.1H396l4.7-25.4-5.4-25.4z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zm-7.3 170.6-77.8-53.3h22.6l62.5 42.3v11z"
  }));
};
var AD = function AD(_ref2) {
  var title = _ref2.title,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("style", null, ".prefix__st0{fill:#ffda44}.prefix__st1{fill:#0052b4}.prefix__st2{fill:#d80027}.prefix__st3,.prefix__st4{fill:none;stroke:#d80027;stroke-width:7;stroke-miterlimit:10}.prefix__st4{stroke-width:4}.prefix__st5{fill:#bc8b00}"), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h171v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342zM198.9 113.6H256v64.8h-57.1z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M267.6 113.6v64.7m16.6-64.7v64.7m16.6-64.7v64.7",
    stroke: "#D80027",
    strokeWidth: 7
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M247.4 178.4v64.7m-13.3-64.7v64.7m-13.3-64.6v53.9m-13.7-53.9v47.1",
    stroke: "#D80027",
    strokeWidth: 5
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "m199.9 146 27.6-32.4 28.5 32.3-28.1 32.4z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#BC8B00",
    d: "M182.2 95.9v92.2c0 34.3 27.3 54.2 48.6 64.5-.8 1.4 25.1 8.3 25.1 8.3s25.9-6.9 25.1-8.3c21.4-10.3 48.6-30.1 48.6-64.5V95.9H182.2zm129.9 92.2c0 16.9-10 29.4-32.8 43.9-8.6 5.5-17.5 9-23.3 11-5.8-2-14.7-5.5-23.3-11-22.8-14.5-32.8-28-32.8-43.9v-74.5h112.2v74.5z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M264.4 188.9h29.5v8.6h-29.5zm0 17.6h29.5v8.6h-29.5z"
  }));
};
var AE = function AE(_ref3) {
  var title = _ref3.title,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#009e49",
    d: "M0 0h513v114H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 228h513v114H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#ce1126",
    d: "M0 0h171v342H0z"
  }));
};
var AF = function AF(_ref4) {
  var title = _ref4.title,
      rest = _objectWithoutProperties(_ref4, _excluded4);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#DB3E00",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#479900",
    d: "M331 0h182v342H331z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 0h181.8v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M256 126.7c-19.4 0-35.2 15.8-35.2 35.2v52.8h70.4v-52.8c0-19.5-15.8-35.2-35.2-35.2z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M256 84.3c-47.7 0-86.4 38.7-86.4 86.4S208.3 257 256 257s86.4-38.7 86.4-86.4-38.7-86.3-86.4-86.3zm0 157.7c-39.4 0-71.4-32-71.4-71.4 0-39.4 32-71.4 71.4-71.4 39.4 0 71.4 32 71.4 71.4 0 39.5-32 71.4-71.4 71.4z"
  }));
};
var AG = function AG(_ref5) {
  var title = _ref5.title,
      rest = _objectWithoutProperties(_ref5, _excluded5);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0072c6",
    d: "M88.8 136.5c-2.2 12.9-3.4 26.2-3.4 39.8 0 13.6 1.2 27 3.4 39.8L256 228.3l167.2-12.1c2.2-12.9 3.4-26.2 3.4-39.8s-1.2-27-3.4-39.8"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M423.2 219H88.8c15.8 69.8 84.7 122.3 167.2 122.3S407.4 288.8 423.2 219z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M365.9 136.5H146.1l44.9-21.1-23.9-43.5 48.8 9.4L222 32l34 36.2L290 32l6.1 49.3 48.8-9.4-23.9 43.5z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#ce1126"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M256.5 342 0 0v342z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M513 342V0L256 342z"
  })));
};
var AI = function AI(_ref6) {
  var title = _ref6.title,
      rest = _objectWithoutProperties(_ref6, _excluded6);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#00318b",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M454.8 265.38c7.94-10.93 13.24-24.27 13.24-40.42V104.89a59.754 59.754 0 0 1-36.02 12.01c-19.64 0-37.07-9.43-48.03-24.01-10.95 14.58-28.39 24.01-48.03 24.01-13.52 0-25.99-4.47-36.02-12v120.06c0 16.16 5.3 29.5 13.24 40.42H454.8z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#8DCCFF",
    d: "M310.23 260.98C332.65 296.96 384 309 384 309s51.35-12.04 73.77-48.02H310.23z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D87B00",
    d: "M396.66 172.21c.32 1.42 8.72 10.17 17.56 20.15 1.39 1.57-8.74 12.63-6.91 12.59 4.75-.12 19.27-17.26 19.34 6.65.05 15.94-30 27.51-30 27.51h17.47l.65 14.96s4.97-13.34 7.59-16.57c8.1-9.97 20.18-30.07 34.59-27.1 14.41 2.97-13.66-13.92-13.66-13.92s-5.2-15.19-16.63-16.97c-10.06-1.57-14.29-2.51-26.64-7.3-1.68-.65-3.88-2.32-3.36 0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D87B00",
    d: "M359.69 198.69c1.07-.99 4.46-12.63 8.69-25.28.67-1.99 15.31 1.27 14.35-.3-2.47-4.06-24.58-8.08-3.9-20.08 13.79-8 38.82 12.27 38.82 12.27l-8.72-15.14 12.64-8.03s-14.05 2.35-18.14 1.69c-12.68-2.04-36.13-2.48-40.75-16.45-4.62-13.97-5.25 18.79-5.25 18.79s-10.56 12.08-6.4 22.88c3.66 9.5 4.96 13.64 6.97 26.73.29 1.79-.06 4.53 1.69 2.92z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D87B00",
    d: "M395.67 219.87c-1.39-.43-13.16 2.49-26.22 5.18-2.06.42-6.59-13.88-7.47-12.26-2.27 4.17 5.36 25.31-15.41 13.45-13.84-7.91-8.89-39.73-8.89-39.73l-8.71 15.14-13.29-6.9s9.09 10.96 10.57 14.84c4.6 11.99 16 32.49 6.24 43.49-9.76 11.01 18.88-4.9 18.88-4.9s15.76 3.07 23-5.96c6.38-7.94 9.3-11.14 19.61-19.45 1.43-1.12 3.97-2.19 1.69-2.9z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M256.5 0h-23.1L160 48.9V0H96v48.9L22.6 0H0v22.7l46.1 30.7H0v64h46.1L0 148.1V171h22.6L96 121.8V171h64v-49.2l73.4 49.2h23.1v-22.9l-46.6-30.7h46.6v-64h-46.6l46.6-30.7z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.4H0v32h112V171h32v-69.6h112.5v-32H144z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 171v-11.3l62.5-42.3h22.6L7.3 171zM7.3.1l77.8 53.2H62.5L0 11.1V.1zm249.2 0v11l-63 42.3h-22.6L248.7.1zM248.7 171l-77.8-53.6h22.6l63 42.3V171z"
  }));
};
var AL = function AL(_ref7) {
  var title = _ref7.title,
      rest = _objectWithoutProperties(_ref7, _excluded7);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 60"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#ED2024",
    d: "M0 0h90v60H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#212121",
    d: "M32.5 12.2v16l7.1 2.5-5 4.9 2.4 3 5.3-5.5 1.2 2.3-3 4.9 3.6 5.6-1.8 2.6 2.8 3.6 2.7-3.7-1.5-2.6 3-5.8-2.7-4.6 1.2-2.3 5.2 5.5 2.5-2.9-5.2-5.1 7.2-2.6V12.2l-5.2 1.9-.1 3.8-3.3.3v-2.6l1.7-2.3 5.6-2.2-2.3-.4 1.4-1.2.9.4-.8-1.4L54 9l-1-1.1L47.5 9l1.4 1.1-3.8 4.9-3.8-4.8 1.3-1.1-5-1.2L36.2 9l-1.5-.4-.8 1.4.9-.6 1.6 1.1-2.3.5 5.5 2 1.6 2.3v2.9l-3.3-.3v-3.6z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M26.2 25h6.4v2.5h-6.4zm0-4.1h6.4v2.7h-6.4zm0-4.2h6.4v2.6h-6.4zm0-4h6.4v2.5h-6.4zM57.4 25h6.4v2.5h-6.4zm0-4.1h6.4v2.7h-6.4zm0-4.2h6.4v2.6h-6.4zm0-4h6.4v2.5h-6.4zM53.4 36.1h6.4V38h-6.4zm-23.2 0h6.4V38h-6.4z",
    fill: "#212121"
  }));
};
var AM = function AM(_ref8) {
  var title = _ref8.title,
      rest = _objectWithoutProperties(_ref8, _excluded8);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FF9811",
    d: "M0 228h513v114H0z"
  }));
};
var AO = function AO(_ref9) {
  var title = _ref9.title,
      rest = _objectWithoutProperties(_ref9, _excluded9);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 171h513v171H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    className: "prefix__st0",
    d: "M0 0h513v171H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#FFDA44"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m332.7 135.6 17.5-8.6-7.4-19-18.7 6.2zm-45.6-56 5.5-18.8-19.1-7.2-8 18zm29.4 23.2 12.2-15.3-14.9-13.9-14.2 13.6zm19.4 68.9 19.5-.8v-21.3l-22.9.2zm-12.6 38.1 18.8 5.5 7.3-19-18-8zm-29 32.4 14.9 12.7 14.4-14.4-13.1-14.7zm-47-147.7 9.8 19.9 21.9 3.3-15.9 15.5 3.6 21.9-19.6-10.4-19.7 10.2 3.8-21.9-15.8-15.5 22-3.1z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m250.8 61.3-2.7 18.3c43.1 3.2 77 39.2 77 83.1 0 46-37.3 82.9-83.4 83.4-29.2.3-51.3-14.8-67-33.7l-13.9 12.3c15 19 40.8 39.9 80.9 39.9 56.3 0 101.9-45.6 101.9-101.9.1-53.2-40.7-96.9-92.8-101.4z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#000",
    d: "m291.9 223.4-11.8 14s51.9 38.9 53.6 40.4c1.7 1.5 5.2 2 9.1-2.7 3.7-4.5 2.8-8.1.9-9.7-2-1.5-51.8-42-51.8-42z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M206.1 157.2c-7.7 10.3-7.5 23.1 2.8 30.9 0 0 135.2 101.5 136.9 103 1.7 1.5 5.2 2 9.1-2.7 3.7-4.5 2.8-8.1.9-9.7-1.9-1.5-149.7-121.5-149.7-121.5zm47.7 99.1 7.3 18.2 19.5-6-4.8-19.1zm-40.4-3.7-2 19.5 20.1 3.6 4.5-19.1zm-35.7-21.2L167.4 248l16.4 12.1 12.5-15.2z"
  })));
};
var AQ = function AQ(_ref10) {
  var title = _ref10.title,
      rest = _objectWithoutProperties(_ref10, _excluded10);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 744 496"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#3A7DCE",
    d: "M0 0h744v496H0V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#fff",
    d: "m120 125 90 63 54-14 23-81 61-36 92 14 105 55 6 90 34 12v92l-65 115-78 24-72-17 18-30-8-32-10 9-162-25-49-85 20-46-49-62z"
  }));
};
var AR = function AR(_ref11) {
  var title = _ref11.title,
      rest = _objectWithoutProperties(_ref11, _excluded11);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h512v114H0zm0 228h512v114H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#FFDA44",
    stroke: "#d6ab00",
    strokeWidth: 5,
    cx: 256.5,
    cy: 171,
    r: 40
  }));
};
var AS = function AS(_ref12) {
  var title = _ref12.title,
      rest = _objectWithoutProperties(_ref12, _excluded12);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#10338c",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M513 33 95.3 171 513 310.76v30.57L0 171 513 0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M513 287.18v24.58L81.72 171 513 30v24.16"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#A2001D",
    d: "m476.98 140.21-21.89 10.68-3.18-15.32 31.19-29.77s-9.42-40.65-13.75-44.98l-112.32 55.82-6.84 36.76-31.9 28.59-.4 34.2 34.29-22.76 67.23-2.66-1.51 38.11h22.23l11.9-44.64 31.55-24.61-6.6-19.42z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#EFC100",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "m317.89 238.41-22.24-11.11 22.24-11.11h144.46v22.22z"
  }));
};
var AT = function AT(_ref13) {
  var title = _ref13.title,
      rest = _objectWithoutProperties(_ref13, _excluded13);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 114h513v114H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0zm0 228h513v114H0z"
  }));
};
var AU = function AU(_ref14) {
  var title = _ref14.title,
      rest = _objectWithoutProperties(_ref14, _excluded14);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#10338c",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M222.2 170.7c.3-.3.5-.6.8-.9-.2.3-.5.6-.8.9zM188 212.6l11 22.9 24.7-5.7-11 22.8 19.9 15.8-24.8 5.6.1 25.4-19.9-15.9-19.8 15.9.1-25.4-24.8-5.6 19.9-15.8-11.1-22.8 24.8 5.7zm197.9 28.5 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6v12.2l-9.4-7.6-9.5 7.6.1-12.2-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zm-48.6-116 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.9-2.7 9.5-7.5-5.3-10.9L332 136zm48.6-66.2 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.8-2.7 9.5-7.5-5.3-10.9 11.8 2.7zm42.5 49.7 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6V150l-9.4-7.6-9.5 7.6v-12.2l-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zM398 166.5l4.1 12.7h13.3l-10.8 7.8 4.2 12.7-10.8-7.9-10.8 7.9 4.1-12.7-10.7-7.8h13.3z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M254.8 0v30.6l-45.1 25.1h45.1V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9H99v-48.6l-87.4 48.6H-1.2v-30.6L44 115H-1.2V55.7h59.1L-1.2 22.8V0h26.7L99 40.8V0h55.6v48.6L242.1 0z"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M142.8 0h-32v69.3h-112v32h112v69.4h32v-69.4h112v-32h-112z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "m154.6 115 100.2 55.7v-15.8L183 115z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "m154.6 115 100.2 55.7v-15.8L183 115z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m154.6 115 100.2 55.7v-15.8L183 115zm-83.9 0-71.9 39.9v15.8L99 115z",
    fill: "#D80027"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M99 55.7-1.2 0v15.7l71.9 40z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M99 55.7-1.2 0v15.7l71.9 40z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M99 55.7-1.2 0v15.7l71.9 40zm84 0 71.8-40V0L154.6 55.7z",
    fill: "#D80027"
  }));
};
var AW = function AW(_ref15) {
  var title = _ref15.title,
      rest = _objectWithoutProperties(_ref15, _excluded15);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 363 242"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h363v242H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M57 96.9 14.7 78.2 57 59.6l18.6-42.2 18.6 42.2 42.3 18.6-42.3 18.7-18.6 42.2z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#f30028",
    d: "m75.6 40.6 11.5 26.1 26.1 11.5-26.1 11.5-11.5 26.1-11.5-26.1L38 78.2l26.1-11.5z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 152.2h363v15.7H0zm0 31.4h363v15.7H0z",
    fill: "#FFDA44"
  }));
};
var AX = function AX(_ref16) {
  var title = _ref16.title,
      rest = _objectWithoutProperties(_ref16, _excluded16);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M513 210.9H202.2V342h-79.8V210.9H0v-79.8h122.4V0h79.8v131.1H513v61.2z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M513 149.7v42.6H183.7V342H141V192.3H0v-42.6h141V0h42.7v149.7z"
  }));
};
var AZ = function AZ(_ref17) {
  var title = _ref17.title,
      rest = _objectWithoutProperties(_ref17, _excluded17);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#ef3340",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#00b5e2",
    d: "M0 0h513v114H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#509e2f",
    d: "M0 228h513v114H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M265.6 212.6c-23 0-41.6-18.6-41.6-41.6s18.6-41.6 41.6-41.6c7.2 0 13.9 1.8 19.8 5-9.2-9-21.9-14.6-35.8-14.6-28.3 0-51.2 22.9-51.2 51.2s22.9 51.2 51.2 51.2c13.9 0 26.6-5.6 35.8-14.6-5.9 3.2-12.6 5-19.8 5z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m297.6 142.2 5.5 15.5 14.9-7.1-7.1 14.9 15.5 5.5-15.5 5.5 7.1 14.9-14.9-7.1-5.5 15.5-5.5-15.5-14.9 7.1 7.1-14.9-15.5-5.5 15.5-5.5-7.1-14.9 14.9 7.1z"
  })));
};
var BA = function BA(_ref18) {
  var title = _ref18.title,
      rest = _objectWithoutProperties(_ref18, _excluded18);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#10338C",
    d: "M0 0h513.1v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#F6C500",
    d: "M99.9 0h342v342"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M19.9 21.1 40.3 6.2 60.9 21 54 0H26.7z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M92.3 25.5 84.4 1.3l-7.8 24.2H51.3l20.5 14.8-7.8 24 20.4-14.8L105 64.3l-7.9-24 20.5-14.9z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m136.3 69.2-7.8-24-7.8 24H95.5l20.4 14.9-7.8 24 20.4-14.8 20.6 14.8-7.8-24 20.4-14.9z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m179.4 112.3-7.8-24.1-7.8 24.1h-25.3l20.5 14.9-7.8 24 20.4-14.8 20.6 14.8-7.9-24 20.5-15z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m222.5 155.3-7.8-24-7.8 24h-25.4l20.6 15-7.8 24 20.4-14.9 20.4 14.9-7.8-24 20.6-15z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m265.6 198.4-7.8-24-7.8 24h-25.4l20.6 14.9-7.8 24.1 20.4-14.9 20.4 14.9-7.8-24.2 20.5-14.8z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m308.7 241.5-7.9-24-7.8 24h-25.3l20.5 14.8-7.9 24.2 20.6-14.9 20.4 14.8-7.8-24.1 20.5-14.8z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m351.7 284.6-7.8-24.2-7.8 24.2h-25.3l20.4 14.8-7.8 24.1 20.5-14.9 20.5 14.9-7.8-24.1 20.4-14.8z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m387 303.5-7.9 24.1-25.3.1 19.8 14.3h26.6l19.9-14.4h-25.3z"
  })));
};
var BB = function BB(_ref19) {
  var title = _ref19.title,
      rest = _objectWithoutProperties(_ref19, _excluded19);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#ffc726",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 0h171v342H0zm342 0h171v342H342z",
    fill: "#00267f"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m325.74 101.02-31.97 12.4c-.68 1.35-5.79 7.54-8.18 53.06h-17.05v-60.42L256 78.68l-12.54 27v60.8H226.4c-2.39-45.53-7.8-52.48-8.47-53.84l-31.68-11.63c.15.31 15.4 31.34 15.4 78.01v12.54h41.81v71.07h25.08v-71.07h41.81v-12.54c0-24.13 4.17-44.02 7.68-56.46 3.82-13.57 7.7-21.49 7.74-21.57l-.03.03z"
  }));
};
var BD = function BD(_ref20) {
  var title = _ref20.title,
      rest = _objectWithoutProperties(_ref20, _excluded20);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#2d6e41",
    d: "M0 85.331h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#F40B32",
    cx: 218.902,
    cy: 256.5,
    r: 115
  }));
};
var BE = function BE(_ref21) {
  var title = _ref21.title,
      rest = _objectWithoutProperties(_ref21, _excluded21);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#fdda25",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 0h171v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#ef3340",
    d: "M342 0h171v342H342z"
  }));
};
var BF = function BF(_ref22) {
  var title = _ref22.title,
      rest = _objectWithoutProperties(_ref22, _excluded22);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#3d944f",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#ef2b2d",
    d: "M0 0h513v171H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "m256 102.6 16.9 52h54.7l-44.2 32.2 16.8 52-44.2-32.1-44.2 32.1 16.8-52-44.2-32.2h54.7z"
  }));
};
var BG = function BG(_ref23) {
  var title = _ref23.title,
      rest = _objectWithoutProperties(_ref23, _excluded23);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#00966e",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#d62612",
    d: "M0 312.888h512v113.775H0z"
  }));
};
var BH = function BH(_ref24) {
  var title = _ref24.title,
      rest = _objectWithoutProperties(_ref24, _excluded24);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "m222.8 34.3-85.2 34.2 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.1H0V0h137.6z"
  }));
};
var BI = function BI(_ref25) {
  var title = _ref25.title,
      rest = _objectWithoutProperties(_ref25, _excluded25);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M215.9 170.7 0 314.6V26.8zM513 26.8v287.8L297.1 170.7z",
    fill: "#47a644"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M512 26.8 296.1 170.7 512 314.6v26.7h-40.1L256 197.4 40.1 341.3H0v-26.7l215.9-143.9L0 26.8V0h40.1L256 143.9 471.9 0H512z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M513 26.8 297.1 170.7 513 314.6V342h-40L256 197.4 39 342H0v-27.4l215.9-143.9L0 26.8V0h40.1L256 143.9 471.9 0H513z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#FFF",
    cx: 251.6,
    cy: 170.7,
    r: 100.2
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m251.4 103.6 7.4 12.9h14.8l-7.4 12.8 7.4 12.8h-14.8l-7.4 12.9-7.4-12.9h-14.8l7.4-12.8-7.4-12.8H244zm38.8 66.7 7.4 12.9h14.8L305 196l7.4 12.8h-14.8l-7.4 12.9-7.4-12.9h-14.9l7.4-12.8-7.4-12.8h14.9zm-77.2 0 7.4 12.9h14.9l-7.4 12.8 7.4 12.8h-14.9l-7.4 12.9-7.4-12.9h-14.8l7.4-12.8-7.4-12.8h14.8z",
    fill: "#D80027",
    stroke: "#47a644",
    strokeWidth: 3
  }));
};
var BJ = function BJ(_ref26) {
  var title = _ref26.title,
      rest = _objectWithoutProperties(_ref26, _excluded26);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#008751",
    d: "M0 85.333h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#fcd116",
    d: "M196.666 85.333H513v171H196.666z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#e8112d",
    d: "M196.666 256H513v171H196.666z"
  }));
};
var BL = function BL(_ref27) {
  var title = _ref27.title,
      rest = _objectWithoutProperties(_ref27, _excluded27);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.33"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v341.33H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#E6BC00",
    d: "M157.31 199.76s-9.04 43.93-19.31 40.39c-10.62-3.54-17.53-18.76-17.53-18.76l-14.52 21.24s38.18 8.48 41.01 5.47c1.22-1.14 8.21-15.1 10.34-26.05v-22.29zm-56.13 60.57s-2.48 20.18-1.06 22.66c1.24 2.3 39.48 11.33 39.48 11.33s-24.96 16.46-29.74 20.54L91.8 284.94l-.71-24.61h10.09zm11.33-165.69s39.65 41.6 40.36 45.5c.71 3.72-4.25 3.19-4.25 3.19s-44.79-37.53-49.92-41.07c-5.31-3.55 13.81-7.62 13.81-7.62z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#ADADAD",
    d: "M99.41 104.73s16.99-.71 16.64-11.51c-.35-10.62-11.15-14.87-19.12-12.39-7.97 2.3-23.01 13.45-13.63 35.05 9.38 21.42 23.37 29.39 26.2 47.8 0 0-5.46 9.86-19.12.35-16.9-11.77-6.2-38.24-10.44-44.96-4.25-7.08-40.95-38.92-40.95-38.92s-30.24 39.37-18 74.92c16.95 49.21 51.74 31.98 64.61 36.76 0 0-42.13 61.96-49.57 67.09 0 0 24.08 8.32 47.8-18.76 0 0 5.84 9.74 7.08 20.18h10.27c4.78-26.2 51.51-64.26 49.92-82.32-1.77-21.25-49.21-49.39-51.69-73.29z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#E6BC00",
    d: "M359.17 201.27s8.96 42.43 19.23 38.89c10.62-3.54 17.53-18.76 17.53-18.76l14.52 21.24s-37 8.48-39.83 5.47c-1.21-1.14-9.32-13.79-11.52-24.66l.07-22.18zm56.05 59.06s2.48 20.18 1.06 22.66c-1.24 2.3-39.48 11.33-39.48 11.33s24.96 16.46 29.74 20.54l18.06-29.92.71-24.61h-10.09zM403.89 94.64s-39.65 41.6-40.36 45.5c-.71 3.72 4.25 3.19 4.25 3.19s44.79-37.53 49.92-41.07c5.14-3.55-13.81-7.62-13.81-7.62z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#125ECC",
    d: "M157.31 87.06H359.1v145.46c0 16.06-9.69 21.39-21.91 31.85l-45.92 39.41c-18.25 15.62-47.91 15.57-66.07 0l-46.01-39.43c-12.08-10.35-21.88-15.71-21.88-31.82V87.06z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFE600",
    d: "M200.55 147.71c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm57.65-3c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm57.65 3c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zM214.96 274.43c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41c.01 7.96-6.45 14.41-14.41 14.41zm43.24 14.42c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41c0 7.95-6.45 14.41-14.41 14.41zm43.24-14.42c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D60537",
    d: "M157.31 175.36H359.1v57.65H157.31v-57.65z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#EACE00",
    d: "M142.9 43.82s57.65-14.41 115.31-14.41 115.31 14.41 115.31 14.41l-14.41 57.65s-50.45-14.41-100.89-14.41-100.89 14.41-100.89 14.41L142.9 43.82z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#7A6920",
    d: "M258.2 72.65c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm57.65 5c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm-115.3 0c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#ADADAD",
    d: "M365.08 178.02c-1.59 18.06 45.14 56.12 49.92 82.32h10.27c1.24-10.44 7.08-20.18 7.08-20.18 23.72 27.09 47.8 18.76 47.8 18.76-7.44-5.13-49.57-67.09-49.57-67.09 12.88-4.78 47.67 12.45 64.61-36.76 12.24-35.55-18-74.92-18-74.92s-36.7 31.84-40.95 38.92c-4.25 6.73 6.46 33.2-10.44 44.96-13.66 9.51-19.12-.35-19.12-.35 2.83-18.41 16.82-26.38 26.2-47.8 9.38-21.6-5.66-32.75-13.63-35.05-7.97-2.48-18.76 1.77-19.12 12.39-.35 10.8 16.64 11.51 16.64 11.51-2.48 23.9-49.92 52.04-51.69 73.29z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#FFF",
    cx: 258.2,
    cy: 204.19,
    r: 16.93
  }));
};
var BM = function BM(_ref28) {
  var title = _ref28.title,
      rest = _objectWithoutProperties(_ref28, _excluded28);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#c8102e",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#012169",
    d: "M0 .1h256.5v171H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M256 0h-22.6L160 48.9V0H96v48.9L22.6 0H0v22.7l46.1 30.7H0v64h46.1L0 148.1v22.6h22.6L96 121.8v48.9h64v-48.9l73.4 48.9H256v-22.6l-46.1-30.7H256v-64h-46.1L256 22.7z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#c8102e",
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#c8102e",
    d: "M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zm-7.3 170.6-77.8-53.3h22.6l62.5 42.3v11z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    transform: "translate(13 5)"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#fff",
    d: "M303.9 94.94v99.69c0 59.81 79.75 99.69 79.75 99.69s79.75-39.88 79.75-99.69V94.94H303.9z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#2F8F22",
    d: "M436.37 254.44H330.93c23.13 25.08 52.72 39.88 52.72 39.88s29.59-14.8 52.72-39.88z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#65B5D2",
    cx: 383.65,
    cy: 214.56,
    r: 39.88
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#c8102e",
    cx: 343.77,
    cy: 194.63,
    r: 19.94
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#c8102e",
    cx: 423.52,
    cy: 194.63,
    r: 19.94
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#c8102e",
    cx: 383.65,
    cy: 154.75,
    r: 19.94
  })));
};
var BN = function BN(_ref29) {
  var title = _ref29.title,
      rest = _objectWithoutProperties(_ref29, _excluded29);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.33"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h512v341.33H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m0 193.74 512 127.19V214.26L0 97.08z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M512 234.26v-86.67L0 20.41v86.67"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#D80027",
    stroke: "#231F20",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M306.4 134.01a50.28 50.28 0 0 1 6.07 24.02c0 21.55-13.51 39.94-32.52 47.19v-59.51c5.7-1.19 10-6.37 10-12.59 6.9 0 12.5-5.75 12.5-12.85h-.42c6.9 0 12.91-5.75 12.91-12.85h-34.99V76.58l-14.99-27.71-15 27.71v30.84h-34.99c0 7.1 6.01 12.85 12.91 12.85h-.42c0 7.1 5.6 12.85 12.5 12.85 0 6.22 4.29 11.4 9.99 12.59v61.37c-22.09-5.39-38.48-25.3-38.48-49.05 0-8.7 2.2-16.88 6.07-24.02-10.96 11.21-17.72 26.53-17.72 43.44 0 34.32 27.82 62.15 62.15 62.15s62.15-27.83 62.15-62.15c0-16.91-6.77-32.24-17.72-43.44z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M198.46 226.81s20.69 27.71 66.5 27.71 66.5-27.71 66.5-27.71l13.47 28.37s-21.03 27.71-79.97 27.71-79.97-27.71-79.97-27.71l13.47-28.37zm-69.22-93.63h20.88l24.93 27.26v73.45h-26.28v-68.37zm270.76 0h-20.88l-24.93 27.26v73.45h26.27v-68.37z"
  })));
};
var BO = function BO(_ref30) {
  var title = _ref30.title,
      rest = _objectWithoutProperties(_ref30, _excluded30);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#d52b1e",
    d: "M0 0h513v114H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#f9e300",
    d: "M0 114h513v114H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#007934",
    d: "M0 228h513v114H0z"
  }));
};
var BQ = function BQ(_ref31) {
  var title = _ref31.title,
      rest = _objectWithoutProperties(_ref31, _excluded31);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#012a87",
    d: "M0 341.3h512V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#f9d90f",
    d: "M250.4 0H0v166.9z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#dc171d",
    d: "m140.4 118.3 12.2 21.2h24.5l-12.3 21.1 12.3 21.2h-24.5L140.4 203l-12.2-21.2h-24.5l12.3-21.2-12.3-21.1h24.5z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 9,
    strokeMiterlimit: 10,
    cx: 140.4,
    cy: 160.6,
    r: 57.7
  }));
};
var BR = function BR(_ref32) {
  var title = _ref32.title,
      rest = _objectWithoutProperties(_ref32, _excluded32);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#009b3a",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#fedf00",
    d: "m256.5 19.3 204.9 151.4L256.5 322 50.6 170.7z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#FFF",
    cx: 256.5,
    cy: 171,
    r: 80.4
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#002776",
    d: "M215.9 165.7c-13.9 0-27.4 2.1-40.1 6 .6 43.9 36.3 79.3 80.3 79.3 27.2 0 51.3-13.6 65.8-34.3-24.9-31-63.2-51-106-51zm119 20.3c.9-5 1.5-10.1 1.5-15.4 0-44.4-36-80.4-80.4-80.4-33.1 0-61.5 20.1-73.9 48.6 10.9-2.2 22.1-3.4 33.6-3.4 46.8.1 89 19.5 119.2 50.6z"
  }));
};
var BS = function BS(_ref33) {
  var title = _ref33.title,
      rest = _objectWithoutProperties(_ref33, _excluded33);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#ffc72c",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
    fill: "#00778b"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M256 256.006 0 426.668V85.331z"
  }));
};
var BT = function BT(_ref34) {
  var title = _ref34.title,
      rest = _objectWithoutProperties(_ref34, _excluded34);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FF7415",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M512 0H0v341.3"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 42,
    strokeMiterlimit: 10,
    d: "M128.7 255.5s35 54 67.3 32.4c56.9-37.9-68.9-108.6-2.9-152.6 58.3-38.8 76.6 103.5 137.6 62.8 59-39.3-64.7-111.4-9.2-148.4 33.4-22.2 67.1 32.6 67.1 32.6"
  }));
};
var BV = function BV(_ref35) {
  var title = _ref35.title,
      rest = _objectWithoutProperties(_ref35, _excluded35);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 33.333 1100 733.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#ef2b2d",
    d: "M0 0h1100v800H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#fff",
    d: "M300 0h200v800H300z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#fff",
    d: "M0 300h1100v200H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#002868",
    d: "M350 0h100v800H350z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#002868",
    d: "M0 350h1100v100H0z"
  }));
};
var BW = function BW(_ref36) {
  var title = _ref36.title,
      rest = _objectWithoutProperties(_ref36, _excluded36);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 238h513v104H0zM0 0h513v104H0z",
    fill: "#6da9d2"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 125.5h513v89.656H0z"
  }));
};
var BY = function BY(_ref37) {
  var title = _ref37.title,
      rest = _objectWithoutProperties(_ref37, _excluded37);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#007C30",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#CE1720",
    d: "M0 230h513V0H0"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M100 230V0H0v342h513-413z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M28 159.6 8.6 128.2 28 97.4l19.3 30.8zm44.6 0-19.3-31.4 19.3-30.8L92 128.2zM28 241.2 8.6 209.8 28 179l19.3 30.8zm44.6 0-19.3-31.4L72.6 179 92 209.8z",
    fill: "#CE1720"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m28 73.8-16.1-26L28 22.2l16 25.6zm44.6 0-16-26 16-25.6 16.1 25.6zM28 318l-16.1-26.1L28 266.3l16 25.6zm44.6 0-16-26.1 16-25.6 16.1 25.6z",
    fill: "none",
    stroke: "#CE1720",
    strokeWidth: 7
  }));
};
var BZ = function BZ(_ref38) {
  var title = _ref38.title,
      rest = _objectWithoutProperties(_ref38, _excluded38);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#003e87",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#FFF",
    cx: 260.9,
    cy: 170.9,
    r: 118.9
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "none",
    stroke: "#6DA544",
    strokeWidth: 18,
    strokeMiterlimit: 10,
    cx: 261.9,
    cy: 173.1,
    r: 94.5
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#003e87",
    d: "m261.9 151.5-50.6 23.4v20c0 11.8 6.1 22.8 16.2 28.9L262 239l34.5-15.2c10-6.2 16.2-17.1 16.2-28.9v-20l-50.8-23.4z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M211.3 128.1h101.3v46.7H211.3z"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 0h512v35H0zm0 306h512v35H0z",
    fill: "#ce1127"
  }));
};
var CA = function CA(_ref39) {
  var title = _ref39.title,
      rest = _objectWithoutProperties(_ref39, _excluded39);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 0h142v342H0zm371 0h142v342H371zm-64.5 206 50.4-25.2-25.2-12.6V143l-50.4 25.2 25.2-50.4h-25.2L256.1 80l-25.2 37.8h-25.2l25.2 50.4-50.4-25.2v25.2l-25.2 12.6 50.4 25.2-12.6 25.2h50.4V269h25.2v-37.8h50.4z",
    fill: "red"
  }));
};
var CC = function CC(_ref40) {
  var title = _ref40.title,
      rest = _objectWithoutProperties(_ref40, _excluded40);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "green",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m422.7 252.4 6.2 12.8 13.8-3.2-6.2 12.8 11.2 8.8-13.9 3.2V301l-11.1-8.9-11.1 8.9v-14.2l-13.8-3.2 11.1-8.8-6.2-12.8 13.9 3.2zm-46.6-136.3 6.2 12.9 13.8-3.2-6.2 12.8 11.2 8.8-13.9 3.1v14.3l-11.1-8.9-11.1 8.9.1-14.3-13.9-3.1 11.1-8.8-6.2-12.8L370 129zm37-77.8 6.2 12.8 13.8-3.2-6.2 12.8 11.2 8.9-13.9 3.1v14.2L413.1 78 402 86.9l.1-14.2-13.9-3.1 11.1-8.9-6.2-12.8 13.9 3.2zm51.8 58.4 6.2 12.8 13.9-3.2-6.3 12.8 11.2 8.9-13.9 3.1.1 14.2-11.2-8.9-11.1 8.9.1-14.2L440 128l11.2-8.9-6.3-12.8 13.9 3.2zm-28 68.1 4.9 14.8h15.6l-12.6 9.2 4.8 14.9-12.7-9.2-12.6 9.2 4.8-14.9-12.6-9.2h15.6zM306.8 254.7c-49.2 0-89.1-39.9-89.1-89.1s39.9-89.1 89.1-89.1c15.3 0 29.8 3.9 42.4 10.7C329.4 67.9 302.3 56 272.5 56c-60.5 0-109.6 49.1-109.6 109.6S212 275.3 272.5 275.3c29.8 0 56.9-11.9 76.6-31.3-12.6 6.8-27 10.7-42.3 10.7zM140.4 59.5C129.7 41 109.7 28.6 86.8 28.6S44 41 33.3 59.5h107.1zm.2.4-53.8 53.8-53.7-53.8C28 68.9 25 79.3 25 90.5c0 34.2 27.7 61.9 61.9 61.9s61.9-27.7 61.9-61.9c-.1-11.2-3.1-21.6-8.2-30.6z",
    fill: "#FFDA44"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#A2001D",
    d: "M71.4 98.2v52.2c4.9 1.3 10.1 1.9 15.5 1.9s10.5-.7 15.5-1.9V98.2h-31z"
  }));
};
var CD = function CD(_ref41) {
  var title = _ref41.title,
      rest = _objectWithoutProperties(_ref41, _excluded41);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M512 66.9V0H411.7L0 274.4v66.9h100.3z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M512 0v40.1L60.2 341.3H0v-40.1L451.8 0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "m93.6 31.2 16.3 50.4H163l-42.9 31.2 16.4 50.5-42.9-31.2-43 31.2L67 112.8 24.1 81.6h53.1z"
  }));
};
var CF = function CF(_ref42) {
  var title = _ref42.title,
      rest = _objectWithoutProperties(_ref42, _excluded42);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#d21034",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 170.7h211.5V256H0zm300.5 0H512V256H300.5z",
    fill: "#3a9927"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#003082",
    d: "M0 0v85.3h211.5V0h89v85.3H512V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M300.5 85.3H512v85.3H300.5zM0 85.3h211.5v85.3H0z",
    fill: "#FFF"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M300.5 341.3h-89V256H0v85.3h512V256H300.5zM105.7 8.6l8.6 26.2h27.5L119.5 51l8.6 26.2L105.7 61 83.4 77.2 91.9 51 69.6 34.8h27.6z",
    fill: "#ffce00"
  }));
};
var CG = function CG(_ref43) {
  var title = _ref43.title,
      rest = _objectWithoutProperties(_ref43, _excluded43);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#da1a35",
    d: "M0 85.331h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#009543",
    d: "M443.726 85.331 102.4 426.657H0V85.331z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#fbde4a",
    d: "M500.124 85.331 158.798 426.657H11.876L353.202 85.331z"
  }));
};
var CH = function CH(_ref44) {
  var title = _ref44.title,
      rest = _objectWithoutProperties(_ref44, _excluded44);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "red",
    d: "M0 85.337h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M356.174 222.609h-66.783v-66.783h-66.782v66.783h-66.783v66.782h66.783v66.783h66.782v-66.783h66.783z"
  }));
};
var CI = function CI(_ref45) {
  var title = _ref45.title,
      rest = _objectWithoutProperties(_ref45, _excluded45);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#009e60",
    d: "M330.207 85.331H512v341.337H330.207z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#f77f00",
    d: "M0 85.331h181.793v341.337H0z"
  }));
};
var CK = function CK(_ref46) {
  var title = _ref46.title,
      rest = _objectWithoutProperties(_ref46, _excluded46);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#01237a",
    d: "M0 85.332h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m384 156.705 5.283 16.254h17.089l-13.826 10.045 5.281 16.254L384 189.211l-13.825 10.047 5.28-16.254-13.825-10.045h17.089zm-70.209 29.081 15.228 7.758 12.084-12.083-2.673 16.879 15.227 7.759-16.879 2.673-2.674 16.88-7.76-15.227-16.878 2.673 12.086-12.084zm-29.081 70.209 16.254-5.281.001-17.089 10.044 13.825 16.254-5.282-10.046 13.827 10.046 13.826-16.254-5.28-10.044 13.825v-17.09zm29.081 70.209 7.759-15.229-12.084-12.084 16.881 2.674 7.757-15.227 2.674 16.879 16.879 2.672-15.227 7.759 2.673 16.882-12.084-12.087zM384 355.284l-5.281-16.253h-17.091l13.827-10.045-5.28-16.254L384 322.776l13.827-10.044-5.281 16.254 13.826 10.045h-17.089zm70.209-29.08-15.229-7.758-12.083 12.084 2.673-16.882-15.227-7.756 16.879-2.675 2.675-16.879 7.756 15.227 16.881-2.674-12.086 12.085zm29.081-70.209-16.254 5.281v17.09l-10.045-13.826-16.254 5.281 10.046-13.826-10.046-13.827 16.254 5.282 10.045-13.825v17.089zm-29.081-70.207-7.757 15.226 12.082 12.084-16.881-2.673-7.756 15.227-2.675-16.88-16.879-2.675 15.227-7.757-2.673-16.878 12.084 12.082zM0 186.665v16h46.069L0 233.377v7.539l57.377-38.252H80L0 255.998h112v-69.334H0zm96 69.331H22.628L96 207.083v48.913zm80-117.331 80-53.334H144v69.334h112v-16h-46.069L256 107.951v-7.539l-57.377 38.251H176v.002zm-16-53.332h73.372L160 134.246V85.333zm-16 170.665h112l-80-53.334h22.623L256 240.917v-7.539l-46.069-30.713H256v-16H144v69.333zm16-48.915 73.372 48.913H160v-48.913zM112 85.331H0l80 53.334H57.377L0 100.413v7.539l46.069 30.712H0v16h112V85.331zm-16 48.915L22.628 85.333H96v48.913z",
    fill: "#FFF"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M144 85.331h-32v69.334H0v32h112v69.333h32v-69.333h112v-32H144z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M80 138.665 0 85.331v15.082l57.377 38.252zm96 0h22.623L256 100.413V85.331zm-118.623 64L0 240.917v15.081l80-53.333zm118.623 0 80 53.333v-15.081l-57.377-38.252z"
  })));
};
var CL = function CL(_ref47) {
  var title = _ref47.title,
      rest = _objectWithoutProperties(_ref47, _excluded47);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M196 0h317v171H196z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0037A1",
    d: "M0 0h196v171H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M98 24.5 113.1 71H162l-39.6 28.7 15.2 46.5L98 117.5l-39.6 28.7 15.2-46.5L34 71h48.9z"
  }));
};
var CM = function CM(_ref48) {
  var title = _ref48.title,
      rest = _objectWithoutProperties(_ref48, _excluded48);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#ce1126",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#007a5e",
    d: "M0 0h171v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M342 0h171v342H342zm-86 102.2 17.2 53H329L283.9 188l17.2 53-45.1-32.7-45.1 32.7 17.2-53-45.1-32.8h55.8z",
    fill: "#fcd116"
  }));
};
var CN = function CN(_ref49) {
  var title = _ref49.title,
      rest = _objectWithoutProperties(_ref49, _excluded49);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m226.8 239.2-9.7-15.6-17.9 4.4 11.9-14.1-9.7-15.6 17.1 6.9 11.8-14.1-1.3 18.4 17.1 6.9-17.9 4.4zM290.6 82l-10.1 15.4 11.6 14.3-17.7-4.8-10.1 15.5-1-18.4-17.7-4.8 17.2-6.6-1-18.4 11.6 14.3zm-54.4-56.6-2 18.3 16.8 7.6-18 3.8-2 18.3-9.2-16-17.9 3.8 12.3-13.7-9.2-15.9 16.8 7.5zm56.6 136.4-14.9 10.9 5.8 17.5-14.9-10.8-14.9 11 5.6-17.6-14.9-10.7 18.4-.1 5.6-17.6 5.8 17.5zM115 46.3l17.3 53.5h56.2l-45.4 32.9 17.3 53.5-45.4-33-45.5 33 17.4-53.5-45.5-32.9h56.3z",
    fill: "#FFDA44"
  }));
};
var CO = function CO(_ref50) {
  var title = _ref50.title,
      rest = _objectWithoutProperties(_ref50, _excluded50);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 343.096h512v83.567H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 256h512v87.096H0z"
  }));
};
var CR = function CR(_ref51) {
  var title = _ref51.title,
      rest = _objectWithoutProperties(_ref51, _excluded51);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 211.473h512v89.043H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 352.462h512v74.207H0zM0 85.331h512v74.207H0z",
    fill: "#0052B4"
  }));
};
var CU = function CU(_ref52) {
  var title = _ref52.title,
      rest = _objectWithoutProperties(_ref52, _excluded52);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FF9811",
    d: "M0-40.8v422.9-211.4z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 0h512v68.3H0zm0 136.5h512v68.3H0zm0 136.6h512v68.3H0z",
    fill: "#0052B4"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M256 170.7 0 341.3V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "m86.5 111.4 12.7 39.2h41.3l-33.4 24.2 12.8 39.3-33.4-24.2-33.4 24.2 12.8-39.3-33.4-24.2h41.2z"
  }));
};
var CV = function CV(_ref53) {
  var title = _ref53.title,
      rest = _objectWithoutProperties(_ref53, _excluded53);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#003893",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#cf2027",
    d: "M0 182.2h513v41.4H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 140.8h513v41.4H0zm0 82.8h513V265H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m150.4 70 6.9 21.1h22.2l-18 13.1 6.9 21.1-18-13.1-17.9 13.1 6.8-21.1-17.9-13.1h22.2zm0 209.7 6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-17.9-13h22.2zm-97.6-70.9 6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-17.9-13H46zM90.1 91l6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-18-13h22.3zm-66.3 71H46l6.8-21.1 6.9 21.1h22.2l-18 13.1 6.9 21.1-18-13-17.9 13 6.8-21.1zm48.4 148.9 6.8-21.1-18-13h22.3l6.8-21.2 6.9 21.2h22.2l-18 13 6.9 21.1-18-13zM248 208.8l-6.9 21.1h-22.2l18 13-6.9 21.2 18-13.1 18 13.1-6.9-21.2 18-13h-22.2zM210.7 91l-6.8 21.1h-22.2l17.9 13-6.8 21.2 17.9-13.1 18 13.1-6.9-21.2 18-13h-22.2zm66.4 71h-22.2l-6.9-21.1-6.9 21.1h-22.2l18 13.1-6.9 21.1 18-13 18 13-6.9-21.1zm-48.4 148.9-6.9-21.1 18-13h-22.2l-6.9-21.2-6.8 21.2h-22.2l17.9 13-6.8 21.1 17.9-13z",
    fill: "#f7d116",
    stroke: "#000"
  }));
};
var CW = function CW(_ref54) {
  var title = _ref54.title,
      rest = _objectWithoutProperties(_ref54, _excluded54);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#002b7f",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#f9e814",
    d: "M0 233.5h513v51H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m168.7 86.5 12.9 39.8h41.8l-33.8 24.5 12.9 39.7-33.8-24.5-33.8 24.5 12.9-39.7-33.8-24.5h41.8zm-83.3-54 7.8 23.9h25L97.9 71.1l7.8 23.8-20.3-14.7-20.3 14.7 7.8-23.8-20.3-14.7h25.1z",
    fill: "#FFF"
  }));
};
var CX = function CX(_ref55) {
  var title = _ref55.title,
      rest = _objectWithoutProperties(_ref55, _excluded55);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0021ad",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#1c8a42",
    d: "M0 0h512v341.3"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m77.6 272 5.7 11.9 12.8-3-5.7 11.9 10.3 8.1-12.8 2.9V317l-10.3-8.3-10.2 8.3v-13.2l-12.8-2.9 10.3-8.1-5.8-11.9 12.9 3zm-37.1-98.9 5.7 11.9 12.8-3-5.7 11.8 10.3 8.2-12.9 2.9.1 13.2-10.3-8.3-10.3 8.3.1-13.2-12.9-2.9 10.4-8.2L22 182l12.8 3zm37.1-80.9 5.7 11.8 12.8-2.9-5.7 11.8 10.3 8.2-12.8 2.9v13.1l-10.3-8.2-10.2 8.2V124l-12.8-2.9 10.3-8.2-5.8-11.8L72 104zm46.1 62.9 5.7 11.9 12.8-3-5.7 11.9 10.3 8.1-12.8 2.9v13.2l-10.3-8.2-10.2 8.2v-13.2l-12.8-2.9 10.3-8.1-5.7-11.9 12.8 3zm-32.9 54 4.4 13.7h14.5L98 231.3l4.5 13.7-11.7-8.4-11.7 8.4 4.5-13.7-11.7-8.5h14.4z",
    fill: "#FFF"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#ffc639",
    cx: 267.1,
    cy: 170.7,
    r: 74.5
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#1c8a42",
    d: "M267.1 220.3h24.8s10.8-19 0-37.2l24.8-24.8-12.4-24.8h-12.4s-6.2 18.6-31 18.6-31-18.6-31-18.6h-12.4l12.4 24.8-12.4 24.8 12.4 12.4s12.4-24.8 37.2-12.4c0 0 10.5 15.5 0 37.2z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#ffc639",
    d: "M464.4 92.2c.6-2.9-.2-17.6-.2-20.7 0-21.3-13.9-39.4-33.2-45.7 5.9 12 9.2 25.4 9.2 39.7 0 4.8-.4 9.5-1.1 14.1-2.9-4.7-6.6-8.9-11.2-12.6-17.1-13.6-40.6-14-57.9-2.5 13.4 2.9 26.3 8.9 37.7 18 9 7.1 16.2 16.8 21.7 26.1 0 0-17.8 10.9-31 15.1s-42.3 7.9-42.3 7.9c72 12 132-36 132-36-6.5-13.4-15.8-4-23.7-3.4z"
  }));
};
var CY = function CY(_ref56) {
  var title = _ref56.title,
      rest = _objectWithoutProperties(_ref56, _excluded56);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#DB7D00",
    d: "M141.7 154.7s.2 67.1 74.7 65.3l4.5 13.9h8.9s-7.4-41.1 60.1-41.5c0 0 0-27.6 27.6-27.6H359s-66-51.8 58.9-118l1.8-13.1s-129.9 71-198.9 57.2c0 0 10.7 42.5-10.8 42.5-10.8 0-9.7-8.1-32.3-8.1-18.7 0-17.3 19.7-26.3 19.5-8.9-.2-18.8-12.3-19.6-10.2-.7 2.1 9.9 20.1 9.9 20.1z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#006651"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M237.2 308.1c6.9-5 13-6.6 22.4-8.3s19.4-4.4 24.6-5.8-17.7 6.6-23.5 8.3c-5.8 1.6-23.5 5.8-23.5 5.8zm37.9-14.7c-1.9-11.9 2.8-24.3 13.5-29.3 2.5 8.6-5.2 23.2-13.5 29.3zm18.2-6.2c-5.8-9.8 4-22.6 11.1-28.8 3.3 6-2.5 23.7-11.1 28.8zm16.9-7.6c-6.2-8.4 1.1-23.2 8.8-29 3.1 8.2.1 23.2-8.8 29zm16.9-10.6c-5.6-8-1.7-20.4 6.3-28.4 5.8 6.6.9 21-6.3 28.4zm13.5-10.7c-4.7-7.5 1.1-25.4 8.6-30.4 3.3 6.6.8 25.4-8.6 30.4zm10.8-2.8c-1.4-10.8 17.4-22.7 25.2-22.4-.9 8.9-8.9 18.6-25.2 22.4zm-10.5 12.2c8.8-9.1 26-9.1 32.1-7.2-1.7 5.3-21.9 16.9-32.1 7.2z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M328.7 276.8c12.4-3.3 20.5-6.1 27.9 1.7-5.2 6.6-25.4 4.7-27.9-1.7zm-17.7 8c11.9-6.4 26.3 3 28.5 8.6-13.3 5.5-28.7-7.2-28.5-8.6zm-16.3 9.2c10.8-4.1 23.2 1.4 28.2 7.5-5.8 2.7-21 5.7-28.2-7.5zm-14.9 4.7c12.4-1.4 24.4 8 27 13.4-15.9 1.5-22-3.2-27-13.4zm-4 9.4c-6.9-5-13-6.6-22.4-8.3-9.4-1.7-19.4-4.4-24.6-5.8-5.3-1.4 17.7 6.6 23.5 8.3 5.8 1.6 23.5 5.8 23.5 5.8zm-37.9-14.7c1.9-11.9-2.8-24.3-13.5-29.3-2.5 8.6 5.2 23.2 13.5 29.3zm-18.2-6.2c5.8-9.8-4-22.6-11.1-28.8-3.3 6 2.5 23.7 11.1 28.8zm-16.9-7.6c6.2-8.4-1.1-23.2-8.8-29-3.1 8.2-.1 23.2 8.8 29zM185.9 269c5.6-8 1.7-20.4-6.3-28.4-5.8 6.6-.9 21 6.3 28.4zm-13.5-10.7c4.7-7.5-1.1-25.4-8.6-30.4-3.3 6.6-.8 25.4 8.6 30.4zm-10.8-2.8c1.4-10.8-17.4-22.7-25.2-22.4.9 8.9 8.9 18.6 25.2 22.4zm10.5 12.2c-8.8-9.1-26-9.1-32.1-7.2 1.7 5.3 21.9 16.9 32.1 7.2z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M184.3 276.8c-12.4-3.3-20.5-6.1-27.9 1.7 5.2 6.6 25.4 4.7 27.9-1.7zm17.7 8c-11.9-6.4-26.3 3-28.5 8.6 13.3 5.5 28.7-7.2 28.5-8.6zm16.3 9.2c-10.8-4.1-23.2 1.4-28.2 7.5 5.8 2.7 21 5.7 28.2-7.5zm14.9 4.7c-12.4-1.4-24.4 8-27 13.4 15.9 1.5 22-3.2 27-13.4z"
  })));
};
var CZ = function CZ(_ref57) {
  var title = _ref57.title,
      rest = _objectWithoutProperties(_ref57, _excluded57);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#11457e",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#d7141a",
    d: "M512 256v170.663H0L215.185 256z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M512 85.337V256H215.185L0 85.337z"
  }));
};
var DE = function DE(_ref58) {
  var title = _ref58.title,
      rest = _objectWithoutProperties(_ref58, _excluded58);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.331h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 312.882h512v113.775H0z"
  }));
};
var DJ = function DJ(_ref59) {
  var title = _ref59.title,
      rest = _objectWithoutProperties(_ref59, _excluded59);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#12ad2b",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6ab2e7",
    d: "M512 0v166.7L0 170.8V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M256 170.7 0 341.3V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#d7141a",
    d: "m89.8 92.5 17 52.4H162l-44.6 32.5 17 52.4-44.6-32.4-44.6 32.4 17-52.4-44.6-32.5h55.2z"
  }));
};
var DK = function DK(_ref60) {
  var title = _ref60.title,
      rest = _objectWithoutProperties(_ref60, _excluded60);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#c60c30",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M190 0h-60v140H0v60h130v142h60V200h323v-60H190z"
  }));
};
var DM = function DM(_ref61) {
  var title = _ref61.title,
      rest = _objectWithoutProperties(_ref61, _excluded61);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#496E2D",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 110.7v120h512v-120z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 110.7h512v40H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 190.7h512v40H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M196 0h120v341.3H196z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M196 0h40v341.3h-40z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M274.7 0h40v341.3h-40z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#D80027",
    cx: 256,
    cy: 170.7,
    r: 123.1
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m256 58.6 4.6 14.2h15l-12.1 8.9 4.6 14.2-12.1-8.8-12.1 8.8 4.6-14.2-12.1-8.9h15zM190.1 80l12.2 8.8 12.1-8.8-4.6 14.3 12.1 8.8h-15l-4.6 14.2-4.7-14.2h-15l12.1-8.8zm-40.7 56h15l4.6-14.2 4.7 14.2h15l-12.2 8.8 4.7 14.3-12.2-8.8-12.1 8.8 4.6-14.3zm0 69.3 12.1-8.8-4.6-14.3L169 191l12.2-8.8-4.7 14.3 12.2 8.8h-15l-4.7 14.3-4.6-14.3zm40.7 56.1 4.6-14.3-12.1-8.8h15l4.7-14.3 4.6 14.3h15l-12.1 8.8 4.6 14.3-12.1-8.9zm65.9 21.4-4.6-14.3h-15l12.1-8.8-4.6-14.3 12.1 8.8 12.1-8.8-4.6 14.3 12.1 8.8h-15zm65.9-21.4-12.2-8.9-12.1 8.9 4.6-14.3-12.1-8.8h15l4.6-14.3 4.7 14.3h15l-12.1 8.8zm40.7-56.1h-15l-4.6 14.3-4.7-14.3h-15l12.2-8.8-4.7-14.3L343 191l12.1-8.8-4.6 14.3zm0-69.3-12.1 8.8 4.6 14.3-12.1-8.8-12.2 8.8 4.7-14.3-12.2-8.8h15l4.7-14.2 4.6 14.2zm-40.7-56-4.6 14.3 12.1 8.8h-15l-4.7 14.2-4.6-14.2h-15l12.1-8.8-4.6-14.3 12.1 8.8zM279.3 168.7c-11-21.1-14.5-25.1-14.5-25.1s.4-9.7.4-15.6c0-8.8-7.4-15.8-16.5-15.8-8.6 0-15.7 2.9-16.5 11-4.2.9-8.6 4.1-8.6 10.7 0 4.8 1 7.3 5.2 9.3 2.1-4.6 4.3-4.8 9.3-6.4.8.6 1.7 3 2.6 3.4l.3 1s-13.3 6.6-13.3 30.9c0 29.5 22 45.4 22 45.4l-1.8.3-1.9 7.1h22v-7.2l11 17.5c.3-.3 10.2-47.6.3-66.5z",
    fill: "#496E2D"
  }));
};
var DO = function DO(_ref62) {
  var title = _ref62.title,
      rest = _objectWithoutProperties(_ref62, _excluded62);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 215.2h211.5v126.1H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h211.5v126.2H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M300.5 0H512v126.2H300.5z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M300.5 215.2H512v126.1H300.5z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M256 130h-49.9v49.4s19.5 6 49.9 6V130z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M206.1 179.4v6c0 27.5 22.3 49.9 49.9 49.9v-49.9c-30.4 0-49.9-6-49.9-6z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M256 235.3c27.5 0 49.9-22.3 49.9-49.9v-6s-19.5 6-49.9 6v49.9z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M256 130v55.4c30.4 0 49.9-6 49.9-6V130H256z"
  })));
};
var DZ = function DZ(_ref63) {
  var title = _ref63.title,
      rest = _objectWithoutProperties(_ref63, _excluded63);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#41662E",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M256 0h256v341.3H256z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m341.5 105.3-29.4 40.4-47.5-15.4 29.4 40.4-29.4 40.4 47.5-15.4 29.4 40.4v-50l47.5-15.5-47.5-15.4z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M309.9 276.7c-58.5 0-106-47.5-106-106s47.5-106 106-106c18.3 0 35.4 4.6 50.4 12.7-23.5-23-55.7-37.2-91.2-37.2-72 0-130.4 58.4-130.4 130.4S197.1 301 269.1 301c35.5 0 67.7-14.2 91.2-37.2-14.9 8.2-32.1 12.9-50.4 12.9z"
  })));
};
var EC = function EC(_ref64) {
  var title = _ref64.title,
      rest = _objectWithoutProperties(_ref64, _excluded64);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 170.7h512V256H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 256h512v85.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#FFDA44",
    cx: 256,
    cy: 170.7,
    r: 59.4
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#4C1F00",
    d: "M369.2 79.9s-27.2-13.8-33.9-16c-6.7-2.2-49.1-13.2-49.1-7 0 10.3-13.5 12-15.5 12s-2-5.3-14.8-5.3-13.7 4.8-15.8 4.8c-2.2 0-14.5-1-14.5-11.5 0-5.2-42.9 4-49.1 7-6.1 3.1-33.9 16-33.9 16s45.8 2.7 53.9 6.2 43.8 16.5 43.8 16.5l-2.8 13.3h37.8l-3.8-13.3s35.1-12.7 43.8-16.5 53.9-6.2 53.9-6.2z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#57BA17",
    d: "M217.7 171.7c0 21.1 17.2 38.3 38.3 38.3 21.1 0 38.3-17.2 38.3-38.3v-11.5h-76.5v11.5z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#338AF3",
    d: "M256 110.5c-21.1 0-38.3 17.2-38.3 38.3v11.5h76.5v-11.5c.1-21.1-17.1-38.3-38.2-38.3z"
  }));
};
var EE = function EE(_ref65) {
  var title = _ref65.title,
      rest = _objectWithoutProperties(_ref65, _excluded65);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#111",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#368FD8",
    d: "M0 85.337h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 312.888h512v113.775H0z"
  }));
};
var EG = function EG(_ref66) {
  var title = _ref66.title,
      rest = _objectWithoutProperties(_ref66, _excluded66);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h512v113.8H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 227.6h512v113.8H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#C09300",
    d: "M220.3 204.4s0-58.4 4.5-64.7c3.1-4.3 16.8 5.2 22.7 4.5 0 0 4.2-7.5 4.5-12 .3-4.6-1.1-7.6-4.9-6.2 0 0-1.2-2.1.5-3.3 1.6-1.2 5.6.1 5.6.1s-.5-1 1.6-.9c2.9.2 7.2 1.4 7.4 5.6.2 3.1.3 7.7.4 8.7.7 6.8 2.7 8.7 2.7 8.7s18.4-9.2 22-5.2c3.3 3.8 4.5 64.7 4.5 64.7l-18.1-16.8 12.1 29.5s-14.4 2.4-28.9 2.4c-14.5 0-31.1-4.2-31.1-4.2l13.8-28.2-19.3 17.3z"
  }));
};
var EH = function EH(_ref67) {
  var title = _ref67.title,
      rest = _objectWithoutProperties(_ref67, _excluded67);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 0h512v113.8H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#428823",
    d: "M0 227.6h512v113.8H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M256 170.7 0 341.3V0zm53.1 0c0-22.9 13.1-42.1 34.6-46.8-3.3-.7-6.7-1.1-10.3-1.1-26.4 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9c3.5 0 7-.4 10.3-1.1-21.5-4.8-34.6-23.9-34.6-46.8z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m365 129.2 10.3 31.7h33.3l-27 19.6 10.3 31.7-26.9-19.6-27 19.6 10.3-31.7-27-19.6h33.4z"
  })));
};
var ER = function ER(_ref68) {
  var title = _ref68.title,
      rest = _objectWithoutProperties(_ref68, _excluded68);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#56AF35",
    d: "M0 0h512v170.7H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "m0 341.3 512-170.7L0 0v341.3z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#ffc945"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M134.7 231.5c33.6 0 60.8-27.2 60.8-60.8s-27.2-60.8-60.8-60.8-60.8 27.2-60.8 60.8 27.2 60.8 60.8 60.8zm0 24.3c-47 0-85.2-38.1-85.2-85.2s38.1-85.2 85.2-85.2 85.2 38.1 85.2 85.2-38.2 85.2-85.2 85.2z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: 119.5,
    cy: 148.3,
    r: 17.5
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: 148.9,
    cy: 158.5,
    r: 17.5
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: 134.7,
    cy: 135.2,
    r: 17.5
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: 119.5,
    cy: 172.7,
    r: 17.5
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: 149.9,
    cy: 182.8,
    r: 17.5
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: 122.5,
    cy: 198,
    r: 17.5
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: 145.9,
    cy: 205.2,
    r: 17.5
  })));
};
var ES = function ES(_ref69) {
  var title = _ref69.title,
      rest = _objectWithoutProperties(_ref69, _excluded69);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h22.5v15H0V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D03433",
    d: "M0 0h22.5v4H0V0zm0 11h22.5v4H0v-4z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FBCA46",
    d: "M0 4h22.5v7H0V4z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M7.8 7h1v.5h-1V7z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#A41517",
    d: "M7.2 8.5c0 .3.3.5.6.5s.6-.2.6-.5L8.5 7H7.1l.1 1.5zM6.6 7c0-.3.2-.5.4-.5h1.5c.3 0 .5.2.5.4V7l-.1 1.5c-.1.6-.5 1-1.1 1-.6 0-1-.4-1.1-1L6.6 7z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#A41517",
    d: "M6.8 7.5h2V8h-.5l-.5 1-.5-1h-.5v-.5zM5.3 6h1v3.5h-1V6zm4 0h1v3.5h-1V6zm-2.5-.5c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v.2c0 .2-.1.3-.3.3H7c-.1 0-.2-.1-.2-.2v-.3z"
  }));
};
var ET = function ET(_ref70) {
  var title = _ref70.title,
      rest = _objectWithoutProperties(_ref70, _excluded70);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#20AA46",
    d: "M0 0h22.5v5H0V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#E92F3B",
    d: "M0 10h22.5v5H0v-5z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FADF50",
    d: "M0 5h22.5v5H0V5z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#205CCA",
    cx: 11.3,
    cy: 7.5,
    r: 5.2
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    stroke: "#FFDB3D",
    fill: "none"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m11.3 8.8-2.1 1.5.8-2.4-2-1.5h2.5l.8-2.3.8 2.3h2.6l-2.1 1.5.8 2.4-2.1-1.5zm-1-2.4h1.9M9.9 7.8l1.3 1m.8-2.6.7 1.8M10 7.9l.6-1.8M11 9l1.6-1.1",
    strokeWidth: 0.5
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m8.7 3.9 1.1 1.6m4-1.7-1 1.6m-1.5 4.7V12M8.9 8.3 7.1 9m8.4 0-1.8-.7",
    strokeWidth: 0.25
  })));
};
var EU = function EU(_ref71) {
  var title = _ref71.title,
      rest = _objectWithoutProperties(_ref71, _excluded71);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 810 540"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#039",
    d: "M0 0h810v540H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FC0",
    d: "m404.951 59.865 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-90 24 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-66 66 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-24 89.999 6.735 20.719h21.894l-17.633 12.813 6.638 20.74-17.634-12.813-17.634 12.813 6.736-20.731-17.633-12.811h21.796zm24 90.001 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm66 66 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm180-312 6.735 20.718h21.894l-17.633 12.812 6.637 20.74-17.633-12.812-17.635 12.812 6.737-20.729-17.633-12.812h21.795zm66 66 6.735 20.718h21.894l-17.633 12.812 6.637 20.74-17.633-12.812-17.635 12.812 6.737-20.729-17.633-12.812h21.795zm24 90 6.735 20.718h21.894l-17.633 12.813 6.638 20.74-17.634-12.813-17.634 12.813 6.736-20.731-17.633-12.811h21.796zm-24 90 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm-156 90 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm90-24.001 6.735 20.719h21.894l-17.633 12.812 6.639 20.74-17.635-12.812-17.633 12.812 6.735-20.73-17.633-12.811h21.797z"
  }));
};
var FI = function FI(_ref72) {
  var title = _ref72.title,
      rest = _objectWithoutProperties(_ref72, _excluded72);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#2E52B2",
    d: "M512 129.3V212H203.7v129.3H121V212H0v-82.7h121V0h82.7v129.3z"
  }));
};
var FJ = function FJ(_ref73) {
  var title = _ref73.title,
      rest = _objectWithoutProperties(_ref73, _excluded73);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#2E52B2",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M256 0v22.6l-46.1 30.7H256v64h-46.1L256 148v22.7h-22.6l-73.4-49v49H96v-49l-73.4 49H0V148l46.1-30.7H0v-64h46.1L0 22.6V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 0v15.1l57.4 38.2H80zm256 0v15.1l-57.4 38.2H176z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 0v15.1l57.4 38.2H80zm256 0v15.1l-57.4 38.2H176zM0 170.7v-15.1l57.4-38.3H80zm256 0v-15.1l-57.4-38.3H176z"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#F3F3F3",
    d: "M307.1 127.1v92c0 61.6 80.5 80.5 80.5 80.5s80.4-19 80.4-80.6v-92l-80.5-23-80.4 23.1z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M468 132.8V98.3H307.1v34.5h69v69h-69v23h69V296c6.9 2.5 11.5 3.5 11.5 3.5s4.6-1.1 11.5-3.5v-71.2h69v-23h-69v-69H468z"
  }));
};
var FK = function FK(_ref74) {
  var title = _ref74.title,
      rest = _objectWithoutProperties(_ref74, _excluded74);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M256 0v30.6l-45.2 25.1H256V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9h-55.6v-48.6l-87.5 48.6H0v-30.6L45.2 115H0V55.7h59.1L0 22.8V0h26.7l73.5 40.8V0h55.6v48.6L243.3 0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M155.8 115 256 170.7v-15.8L184.2 115zm-84 0L0 154.9v15.8L100.2 115z",
    fill: "#D80027"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M100.2 55.6 0 0v15.7l71.8 39.9zm84 0L256 15.7V0L155.8 55.6z",
    fill: "#D80027"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#1F8BDE",
    d: "M312.2 194.2v-90c0-8.5 6.5-15.3 15-15.3h120.5c8.3 0 15 6.8 15 15.3v90c0 75.2-75.2 105.3-75.2 105.3s-75.3-30.1-75.3-105.3z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M312.2 194.2v-90c0-8.5 6.5-15.3 15-15.3h120.5c8.3 0 15 6.8 15 15.3v90c0 75.2-75.2 105.3-75.2 105.3s-75.3-30.1-75.3-105.3zm79.6 86.3c7.9-4.5 15.9-10 23.2-16.7 20.5-18.5 32.6-41.4 32.6-69.7v-90c0-.3-120.4-.3-120.4-.3v90.3c0 28.3 12.1 51.2 32.6 69.7 8.3 7.5 17.6 13.9 27.6 19 1.4-.6 2.8-1.4 4.4-2.3z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#187536",
    d: "M347.1 193.4c-2.6-7.9 1.7-14.3 10.1-14.3h60.5c8.2 0 12.8 6.3 10.1 14.3l-5.5 16.5c-2.6 7.9-8.9 9.2-15.8 4 0 0 2.6-4.8-19.1-4.8-21.7 0-19.1 4.8-19.1 4.8-6.1 5.7-13.1 4-15.8-4 .1.1-5.4-16.5-5.4-16.5z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M357.4 179.1c8.1 1.6 17.8-15 30.1-15 13.1 0 21.8 17.1 30.1 15 7.4-1.8 15-22.2 15-30.1 0-16.6-20.2-30.1-45.1-30.1-24.9 0-45.1 13.5-45.1 30.1-.1 8.5 6.6 28.5 15 30.1zm-1.4 91.6c6.2.4 12.5-1.8 17.2-6.5l9-9c2.9-2.9 7.5-2.9 10.4 0l9 9c4.7 4.7 11 6.9 17.1 6.5 5.3-.3 32.5-33.5 25.7-32.6-4.6.6-9.1 2.8-12.7 6.3l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-8.7-8.8-22.9-8.8-31.7-.1l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-3.5-3.5-7.8-5.6-12.3-6.3-6.7-1.1 20.1 32.2 25.3 32.5zM322.1 210c2.9-2.9 7.5-2.9 10.4 0l9 9c8.8 8.7 22.9 8.7 31.7 0l9-9c2.9-2.9 7.5-2.9 10.4 0l9 9c8.8 8.7 22.9 8.7 31.7 0l9-9c2.9-2.9 7.5-2.9 10.4 0 0 0 5.5-14.8 2.5-15.9-7.9-2.9-17.2-1.2-23.5 5.2l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-8.7-8.8-22.9-8.8-31.7-.1l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-6.2-6.2-15.1-8-22.8-5.5-3.1 1.1 1.9 16.1 1.9 16.1z"
  }));
};
var FM = function FM(_ref75) {
  var title = _ref75.title,
      rest = _objectWithoutProperties(_ref75, _excluded75);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m256 37.9 10.1 31.2H299l-26.6 19.3 10.2 31.2-26.6-19.3-26.6 19.3 10.2-31.2L213 69.1h32.9zM123.2 170.7l31.2-10.2v-32.8l19.3 26.6 31.2-10.2-19.3 26.6 19.3 26.5-31.2-10.1-19.3 26.5v-32.8zM256 303.5l-10.1-31.2H213l26.6-19.3-10.2-31.3L256 241l26.6-19.3-10.2 31.3 26.6 19.3h-32.9zm132.8-132.8-31.2 10.1v32.8l-19.3-26.5-31.2 10.1 19.3-26.5-19.3-26.6 31.2 10.2 19.3-26.6v32.8z",
    fill: "#FFF"
  }));
};
var FO = function FO(_ref76) {
  var title = _ref76.title,
      rest = _objectWithoutProperties(_ref76, _excluded76);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0F61A5",
    d: "M512 214.5H206.2v126.8h-87.8V214.5H0v-87.7h118.4V0h87.8v126.8H512V192z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#E50E3D",
    d: "M512 149.3V192H183.7v149.3H141V192H0v-42.7h141V0h42.7v149.3z"
  }));
};
var FR = function FR(_ref77) {
  var title = _ref77.title,
      rest = _objectWithoutProperties(_ref77, _excluded77);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h170.663v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M341.337 85.331H512v341.337H341.337z"
  }));
};
var GA = function GA(_ref78) {
  var title = _ref78.title,
      rest = _objectWithoutProperties(_ref78, _excluded78);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M0 85.337h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 312.888h512v113.775H0z"
  }));
};
var GB = function GB(_ref79) {
  var title = _ref79.title,
      rest = _objectWithoutProperties(_ref79, _excluded79);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.333h512V426.67H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M288 85.33h-64v138.666H0v64h224v138.666h64V287.996h224v-64H288z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M393.785 315.358 512 381.034v-65.676zm-82.133 0L512 426.662v-31.474l-143.693-79.83zm146.982 111.304-146.982-81.664v81.664z",
    fill: "#0052B4"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M311.652 315.358 512 426.662v-31.474l-143.693-79.83z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M311.652 315.358 512 426.662v-31.474l-143.693-79.83z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M90.341 315.356 0 365.546v-50.19zm110.007 14.154v97.151H25.491z",
    fill: "#0052B4"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M143.693 315.358 0 395.188v31.474l200.348-111.304z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M118.215 196.634 0 130.958v65.676zm82.133 0L0 85.33v31.474l143.693 79.83zM53.366 85.33l146.982 81.664V85.33z",
    fill: "#0052B4"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M200.348 196.634 0 85.33v31.474l143.693 79.83z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M200.348 196.634 0 85.33v31.474l143.693 79.83z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M421.659 196.636 512 146.446v50.19zm-110.007-14.154V85.331h174.857z",
    fill: "#0052B4"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M368.307 196.634 512 116.804V85.33L311.652 196.634z"
  }));
};
var GD = function GD(_ref80) {
  var title = _ref80.title,
      rest = _objectWithoutProperties(_ref80, _excluded80);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#c60a0a",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#3E8446",
    d: "M256 170.7 44.5 296.8V44.5z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m256 170.7 211.5 126.1h-423zM467.5 44.5 256 170.7 44.5 44.5z",
    fill: "#FFDA44"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#3E8446",
    d: "M467.5 44.5v252.3L256 170.7z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m256 10.4 3.3 10.2H270l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm-85.9 0 3.3 10.2h10.7l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm171.8 0 3.3 10.2H356l-8.7 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zM256 304.2l3.3 10.2H270l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm-85.9 0 3.3 10.2h10.7l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm171.8 0 3.3 10.2H356l-8.7 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7z",
    fill: "#FFDA44"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#c60a0a",
    cx: 244.5,
    cy: 170.7,
    r: 76.2
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "m244.5 110.1 13.6 41.8h44l-35.6 25.8 13.6 41.8-35.6-25.8-35.5 25.8 13.6-41.8-35.6-25.8h44zm-136.8 57.7c4.4 6.9 2.3 16.1-4.6 20.5s-16.1 2.3-20.5-4.6c-7.9-12.5-3.3-33-3.3-33s20.4 4.6 28.4 17.1z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#A2001D",
    cx: 99.1,
    cy: 182.1,
    r: 7.4
  }));
};
var GE = function GE(_ref81) {
  var title = _ref81.title,
      rest = _objectWithoutProperties(_ref81, _excluded81);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M.8 0h21v15H.8V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#eb000e",
    d: "M9.8 6H0v3h9.8v6h3V9h9.8V6h-9.8V0h-3v6z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#eb000e",
    d: "m17.3 2.7-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm-12.7 0-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm0 9-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm12.7 0-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2z"
  }));
};
var GF = function GF(_ref82) {
  var title = _ref82.title,
      rest = _objectWithoutProperties(_ref82, _excluded82);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 60"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FDEB01",
    d: "m0 0 90 60H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#58A846",
    d: "M90 0v60L0 0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#ED3D24",
    d: "m50.7 33.3 9.3-6.7H48.5L45 15.7l-3.5 10.9H30l9.3 6.7-3.6 11 9.3-6.7 9.3 6.7z"
  }));
};
var GG = function GG(_ref83) {
  var title = _ref83.title,
      rest = _objectWithoutProperties(_ref83, _excluded83);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M308 0H204v118.7H0v104h204V342h104V222.7h205v-104H308z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "m368.6 188 26 17.3V136l-26 17.3h-95.3V58.1l17.3-26h-69.2l17.3 26v95.2h-95.3l-26-17.3v69.3l26-17.3h95.3v95.2l-17.3 26h69.2l-17.3-26V188z"
  }));
};
var GH = function GH(_ref84) {
  var title = _ref84.title,
      rest = _objectWithoutProperties(_ref84, _excluded84);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#496E2D",
    d: "M0 312.888h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m255.883 199.111 14.119 43.458 40.366 3.2-36.969 26.861 19.453 40.259-36.969-26.859-36.97 26.859 14.123-43.459-36.969-26.861h45.696z"
  }));
};
var GI = function GI(_ref85) {
  var title = _ref85.title,
      rest = _objectWithoutProperties(_ref85, _excluded85);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 230h513v112H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M363.1 131.8V99.1H374V77.3h-21.9v10.9h-21.8V77.3h-21.8v21.8h10.9v32.7h-21.8V55.5h10.9V33.7h-21.8v10.9h-10.9V33.7H254v10.9h-10.9V33.7h-21.8v21.8h10.9v76.3h-21.8V99.1h10.9V77.3h-21.8v10.9h-21.8V77.3h-21.8v21.8h10.9v32.7H145V219h239.9v-87.2z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "m264.9 235.5-24.2 18.2 19.1 14.3v31.3h-23.2v9h23v7.9h-23v9.3H270V268l19.1-14.3-24.2-18.2zm0 25.3-10.1-7.1 10.1-7.1 10.1 7.1-10.1 7.1z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M239.6 209.7v-27.9s.1-22.3 25-22.3c24.8 0 25.7 22 25.7 22v28.2h-50.7zm-69.1 0v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M169.1 209.7v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8zm151.8 0v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8zm8.4-77.7v-15.7s.1-12.1 11.3-12.1c11.3 0 11.7 11.9 11.7 11.9V132h-23zm-78.8 0v-23.7s.1-18.3 14.3-18.3c14.2 0 14.7 18 14.7 18v24h-29zm-73 0v-15.7s.1-12.1 11.3-12.1 11.7 11.9 11.7 11.9V132h-23z"
  }));
};
var GL = function GL(_ref86) {
  var title = _ref86.title,
      rest = _objectWithoutProperties(_ref86, _excluded86);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M513 0v171H0V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#FFF",
    cx: 185.8,
    cy: 171.2,
    r: 117.8
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M68 171c0-65.1 52.8-117.8 117.8-117.8 65.1 0 117.8 52.8 117.8 117.8"
  }));
};
var GM = function GM(_ref87) {
  var title = _ref87.title,
      rest = _objectWithoutProperties(_ref87, _excluded87);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#1a7e25",
    d: "M0 322.783h512v103.88H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#cf0d19",
    d: "M0 85.337h512v104.515H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 210.877h512v89.656H0z"
  }));
};
var GN = function GN(_ref88) {
  var title = _ref88.title,
      rest = _objectWithoutProperties(_ref88, _excluded88);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h512v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M342 0h171v342H342z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h171v342H0z"
  }));
};
var GP = function GP(_ref89) {
  var title = _ref89.title,
      rest = _objectWithoutProperties(_ref89, _excluded89);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h170.663v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M341.337 85.331H512v341.337H341.337z"
  }));
};
var GQ = function GQ(_ref90) {
  var title = _ref90.title,
      rest = _objectWithoutProperties(_ref90, _excluded90);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v113.8H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 227.6h513V342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0070C8",
    d: "M126 170.7 0 341.3V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M233.8 139.4v40.4c0 35.6 35.6 35.6 35.6 35.6s35.6 0 35.6-35.6v-40.4h-71.2z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#786145",
    d: "M264.5 179.8h9.8l4 25.8h-17.8z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M287.2 162c0-9.8-8-14.8-17.8-14.8s-17.8 5-17.8 14.8c-4.9 0-8.9 4-8.9 8.9s4 8.9 8.9 8.9h35.6c4.9 0 8.9-4 8.9-8.9s-4-8.9-8.9-8.9z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m230.7 120 1.9 3.3h3.8l-1.9 3.3 1.9 3.2h-3.8l-1.9 3.3-1.9-3.3H225l1.9-3.2-1.9-3.3h3.8zm15.3 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2h-3.7l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8zm15.3 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2h-3.7l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8zm15.8 0 1.9 3.3h3.8l-1.9 3.3 1.9 3.2H279l-1.9 3.3-1.9-3.3h-3.7l1.8-3.2-1.8-3.3h3.7zm16 0 1.9 3.3h3.8l-1.9 3.3 1.9 3.2H295l-1.9 3.3-1.9-3.3h-3.7l1.8-3.2-1.8-3.3h3.7zm15 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2H310l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8z",
    fill: "#FFDA00",
    stroke: "#000",
    strokeMiterlimit: 10
  }));
};
var GR = function GR(_ref91) {
  var title = _ref91.title,
      rest = _objectWithoutProperties(_ref91, _excluded91);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#0d5eaf"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 0h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 0h190v190H0z"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 76h190v38H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M76 0h38v190H76z"
  })));
};
var GS = function GS(_ref92) {
  var title = _ref92.title,
      rest = _objectWithoutProperties(_ref92, _excluded92);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zm-7.3 170.6-77.8-53.3h22.6l62.5 42.3v11z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", {
    fill: "#FFF",
    cx: 443.4,
    cy: 233.6,
    rx: 29,
    ry: 43.5
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", {
    fill: "#FFCE00",
    cx: 406.9,
    cy: 317.7,
    rx: 22,
    ry: 9.3
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", {
    fill: "#FFCE00",
    cx: 364,
    cy: 317.7,
    rx: 22,
    ry: 9.3
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#39B200",
    d: "m342 190.1 43.4 86.9 43.5-86.9z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", {
    fill: "#9B9B9B",
    cx: 327.5,
    cy: 233.6,
    rx: 29,
    ry: 43.5
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#757575",
    d: "m371 175.6-14.5 14.5h57.9l-14.5-14.5 14.5-43.5s-13-29-29-29-29 29-29 29l14.6 43.5z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#C6B56F",
    cx: 385.4,
    cy: 67,
    r: 29
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#A54A00",
    cx: 386,
    cy: 88.7,
    r: 29
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#FFF",
    cx: 443.4,
    cy: 117.7,
    r: 29
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#0049FF",
    cx: 342.2,
    cy: 146.7,
    r: 29
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#0041F9",
    cx: 429.8,
    cy: 146.7,
    r: 29
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#F7D71E",
    cx: 386,
    cy: 233.6,
    r: 29
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#CEC851",
    cx: 457.9,
    cy: 190.1,
    r: 29
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#FFF",
    cx: 385.4,
    cy: 289.5,
    r: 29
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#7C0B29",
    d: "m371 135.7 14.5-3.5 14.5 3.5c0 7.5-14.5 11-14.5 11s-14.5-3.5-14.5-11z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#FFF",
    cx: 327.5,
    cy: 117.4,
    r: 29
  }));
};
var GT = function GT(_ref93) {
  var title = _ref93.title,
      rest = _objectWithoutProperties(_ref93, _excluded93);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 0h171v342H0zm342 0h171v342H342z",
    fill: "#338AF3"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#DCC26D",
    cx: 256,
    cy: 155.8,
    r: 25.5
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#628A40",
    d: "M194.2 155.9c0 22.1 11.8 42.5 30.8 53.5 5.9 3.4 13.5 1.4 16.9-4.5 3.4-5.9 1.4-13.5-4.5-16.9-11.5-6.6-18.5-18.9-18.5-32.1 0-6.8-5.5-12.4-12.4-12.4s-12.3 5.5-12.3 12.4zm95.1 52.1c17.8-11.4 28.6-31 28.5-52.1 0-6.8-5.5-12.4-12.4-12.4-6.8 0-12.4 5.5-12.4 12.4 0 12.7-6.5 24.5-17.1 31.3-5.8 3.6-7.7 11.2-4.1 17 3.6 5.8 11.2 7.7 17 4.1.2-.1.3-.2.5-.3z"
  }));
};
var GU = function GU(_ref94) {
  var title = _ref94.title,
      rest = _objectWithoutProperties(_ref94, _excluded94);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M11.1 11.1h489.7v319.1H11.1z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#7DBEF1",
    d: "M256 285.3s76.4-51.3 76.4-114.6S256 56 256 56s-76.4 51.3-76.4 114.6S256 285.3 256 285.3z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#1C8AE6",
    d: "M179.8 180.7h152.6l-29.3 64.9h-95.2z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF042",
    d: "M192.3 205.9s40.5 38.2 51 38.2c12.4 0 12.6-18.4 25.5-25.5 20.2-11.1 51-12.7 51-12.7L297 248.7l-41 36.6-46.8-39.7-16.9-39.7z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#259C7B",
    d: "m256 157.5-22.5 15.6 7.9-26.2-21.8-16.5 27.4-.5 9-25.9 9 25.9 27.4.5-21.8 16.6 7.9 26.2-22.5-15.7z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#8E5715",
    d: "M249.7 144.6c-.9 9.2-1.5 18.4-1.7 27.6-.3 11.9.3 20.7 2 26 2.2 6.6 7.2 12.9 14.2 18.9 5.3 4.6 10.6 8.1 14.2 10.1 3.1 1.7 7 .6 8.7-2.4 1.7-3.1.6-7-2.4-8.7-4.3-2.5-8.4-5.4-12.2-8.7-5.4-4.6-9.1-9.2-10.4-13.3-1.1-3.4-1.6-11.3-1.4-21.7.2-8.9.8-17.8 1.7-26.6.4-3.5-2.2-6.6-5.7-7-3.6-.3-6.7 2.3-7 5.8z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "m217.8 170.7 25.5 38.2h-25.5v-38.2z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "none",
    stroke: "#D80027",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    d: "M256 285.3s76.4-51.3 76.4-114.6S256 56 256 56s-76.4 51.3-76.4 114.6S256 285.3 256 285.3z"
  }));
};
var GW = function GW(_ref95) {
  var title = _ref95.title,
      rest = _objectWithoutProperties(_ref95, _excluded95);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M0 85.331h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v170.663H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h181.793v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m98.32 195.127 15.107 46.497h48.894l-39.555 28.74 15.108 46.498-39.554-28.737-39.556 28.737 15.111-46.498-39.554-28.74h48.891z"
  }));
};
var GY = function GY(_ref96) {
  var title = _ref96.title,
      rest = _objectWithoutProperties(_ref96, _excluded96);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#009E49",
    d: "M0 0h900v600H0V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "m0 0 947 300L0 600V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFD00D",
    d: "M0 26.1 870 300 0 573.9V26.1z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#2D2D2D",
    d: "m0 0 450 300L0 600V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D3132F",
    d: "m0 35 397.5 265L0 565V35z"
  }));
};
var HK = function HK(_ref97) {
  var title = _ref97.title,
      rest = _objectWithoutProperties(_ref97, _excluded97);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    viewBox: "0 0.5 21 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h21v15H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#ee1c25",
    d: "M0 0h21v15H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M12 7.19c-.798-.5-1 .409-1 0 0-.828.895-1.5 2-1.5s2 .672 2 1.5c-.949 0-1.044.5-1.5.5-.56 0-.702 0-1.5-.5zM13.25 7a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5zm-1.81 1.962c.228-.913-.698-.824-.31-.95.788-.257 1.703.387 2.045 1.438.341 1.05-.021 2.11-.809 2.366-.293-.903-.798-.838-.939-1.272-.173-.533-.217-.668.012-1.582zm.566 1.13a.25.25 0 1 0 .476-.154.25.25 0 0 0-.476.154zM9.58 8.977c.94-.065.57-.919.81-.588.486.67.157 1.74-.737 2.389-.894.65-2.013.632-2.5-.038.768-.558.55-1.018.92-1.286.453-.33.568-.413 1.507-.477zm-.899.888a.25.25 0 1 0 .294.405.25.25 0 0 0-.294-.405zm.312-2.652c.351.874 1.049.258.809.588-.487.67-1.606.687-2.5.038-.894-.65-1.223-1.719-.736-2.39.767.559 1.138.21 1.507.478.453.33.568.413.92 1.286zm-1.124-.58a.25.25 0 1 0-.293.404.25.25 0 0 0 .293-.404zm2.619-.524c-.722.605.08 1.078-.309.951-.788-.256-1.15-1.315-.809-2.365.342-1.05 1.257-1.695 2.045-1.439-.293.903.153 1.147.012 1.581-.173.533-.217.668-.939 1.272zm.205-1.247a.25.25 0 1 0-.475-.155.25.25 0 0 0 .475.155z",
    fill: "#FFF"
  })));
};
var HM = function HM(_ref98) {
  var title = _ref98.title,
      rest = _objectWithoutProperties(_ref98, _excluded98);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.333h512V426.67H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M223.397 255.996c.273-.304.543-.609.813-.916-.27.308-.546.61-.82.916h.007zm-34.18 41.927 10.958 22.913 24.747-5.718-11.083 22.853 19.9 15.781-24.776 5.585.069 25.398-19.815-15.89-19.814 15.89.069-25.398-24.776-5.585 19.9-15.781-11.083-22.853 24.746 5.718zm197.859 28.464 5.227 10.929 11.803-2.728-5.286 10.9 9.492 7.528-11.818 2.663.032 12.114-9.45-7.578-9.45 7.578.032-12.114-11.817-2.663 9.491-7.528-5.285-10.9 11.803 2.728zm-48.623-115.939 5.227 10.93 11.803-2.729-5.286 10.901 9.491 7.528-11.817 2.663.032 12.115-9.45-7.58-9.451 7.58.033-12.115-11.818-2.663 9.491-7.528-5.284-10.901 11.802 2.729zm48.623-66.25 5.227 10.93 11.803-2.73-5.286 10.902 9.491 7.527-11.817 2.664.032 12.114-9.45-7.58-9.45 7.58.032-12.114-11.817-2.664 9.491-7.527-5.285-10.902 11.803 2.73zm42.471 49.688 5.227 10.929 11.802-2.728-5.284 10.9 9.491 7.527-11.818 2.664.033 12.114-9.451-7.578-9.45 7.578.032-12.114-11.817-2.664 9.491-7.527-5.286-10.9 11.803 2.728zm-30.368 57.97 4.11 12.652h13.304l-10.763 7.82 4.112 12.652-10.763-7.819-10.765 7.819 4.112-12.652-10.763-7.82h13.304z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M256 85.333v30.553l-45.167 25.099H256v59.359h-59.103L256 233.179v22.817h-26.68l-73.494-40.826v40.826h-55.652v-48.573l-87.43 48.573H0v-30.553l45.167-25.099H0v-59.359h59.103L0 108.139V85.333h26.68l73.494 40.827V85.333h55.652v48.573l87.43-48.573z"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M144 85.33h-32v69.332H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915zm-83.98 0L0 240.259v15.737l100.174-55.652z",
    fill: "#D80027"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915zm83.98 0L256 101.067V85.33l-100.174 55.652z",
    fill: "#D80027"
  }));
};
var HN = function HN(_ref99) {
  var title = _ref99.title,
      rest = _objectWithoutProperties(_ref99, _excluded99);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 0h513v114H0zm0 228h513v114H0zm203.5-110.1 6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zm105 0 6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zM256 147.6l6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zm-52.5 29.7 6.7 16.6 17.6 1-14 10.9 4.7 17.6-15-9.9-15 9.9 4.7-17.6-14-10.9 17.6-1zm105 0 6.7 16.6 17.6 1-14 10.9 4.7 17.6-15-9.9-15 9.9 4.7-17.6-14-10.9 17.6-1z",
    fill: "#338AF3"
  }));
};
var HR = function HR(_ref100) {
  var title = _ref100.title,
      rest = _objectWithoutProperties(_ref100, _excluded100);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 228h513v114H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M309.3 113.2v-44l17.5-14.4 17.7 14.4v44zm-105.6 0v-44l-17.3-14.4-17.9 14.4v44zm35.2 0v-44l17.6-14.4 17.6 14.4v44z",
    fill: "#338AF3"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M309.3 113.2h-35.2v-44l17.5-14.4 17.7 14.4zm-70.4 0h-35.2v-44l17.5-14.4 17.7 14.4z",
    fill: "#0052B4"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    stroke: "#D80027",
    fill: "#FFF",
    d: "M168.5 113.2v101.9c0 24.3 14.4 46.2 35.4 59.4 21.3 13.4 42.1 14.7 52.6 14.7s31.4-1.7 52.6-14.8c21-13 35.4-35.1 35.4-59.3V113.2h-176z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M168.5 113.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-105.6 35.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-105.6 35.2h35.2v35.2h-35.2zm35.2 35.2h35.2V254h-35.2zm35.2-35.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-35.2 35.2h35.2V254h-35.2zm35.2 55.5c8.6-5.4 16.2-12.3 22-20.3h-22v20.3zM181.7 254c5.8 8 13.3 14.9 22 20.4V254h-22zm57.2 0v33.7c7.2 1.2 13.3 1.5 17.6 1.5 4.3 0 10.4-.3 17.6-1.6V254h-35.2z",
    fill: "#D80027"
  }));
};
var HT = function HT(_ref101) {
  var title = _ref101.title,
      rest = _objectWithoutProperties(_ref101, _excluded101);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#A2001D",
    d: "M0 0h513v172H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 172h513v172H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "m381.4 251.5-110.7-13.8-110.8 13.8V85.4h221.5z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#0052B4",
    cx: 270.7,
    cy: 182.3,
    r: 55.4
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#A2001D",
    cx: 270.7,
    cy: 182.3,
    r: 27.7
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M229.1 113.1h83.1l-41.5 41.5z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M256.8 140.8h27.7v83h-27.7z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M314.9 215.5h-88.5l-66.5 36h221.5z"
  }));
};
var HU = function HU(_ref102) {
  var title = _ref102.title,
      rest = _objectWithoutProperties(_ref102, _excluded102);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M0 312.888h512v113.775H0z"
  }));
};
var IC = function IC(_ref103) {
  var title = _ref103.title,
      rest = _objectWithoutProperties(_ref103, _excluded103);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 200"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#fc0",
    d: "M0 0h300v200H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0768a9",
    d: "M0 0h200v200H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v200H0z"
  }));
};
var ID = function ID(_ref104) {
  var title = _ref104.title,
      rest = _objectWithoutProperties(_ref104, _excluded104);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.333h512v341.333H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#E00",
    d: "M0 85.333h512V256H0z"
  }));
};
var IE = function IE(_ref105) {
  var title = _ref105.title,
      rest = _objectWithoutProperties(_ref105, _excluded105);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M0 85.331h170.663v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FF9811",
    d: "M341.337 85.331H512v341.337H341.337z"
  }));
};
var IL = function IL(_ref106) {
  var title = _ref106.title,
      rest = _objectWithoutProperties(_ref106, _excluded106);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M340.6 122.4h-56.1l-28-48.6-28 48.6h-56.1l28 48.6-28 48.6h56.1l28 48.6 28-48.6h56.1l-28-48.6 28-48.6zM293.2 171 276 204.2h-38.9L219.8 171l17.2-33.2h38.9l17.3 33.2zm-36.7-71.8 11.9 23.3h-23.9l12-23.3zm-58.3 38.6h23.9l-10.8 21-13.1-21zm0 66.4 13-22.1 11.9 22.1h-24.9zm58.3 37.5-11.9-22.1h23.9l-12 22.1zm59.4-37.5h-25l11.9-22.1 13.1 22.1zm-26.1-66.4h26.1l-13 22.1-13.1-22.1zM0 21.3h512V64H0zm0 256h512V320H0z",
    fill: "#2E52B2"
  }));
};
var IM = function IM(_ref107) {
  var title = _ref107.title,
      rest = _objectWithoutProperties(_ref107, _excluded107);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#E52D42",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M393.3 68.2h-45.8l-33.8 80.2-34.4-22.9s-24.7-59.1-34.4-68.2c-9.7-9.7-18.7-.6-48.9 7.8-29.6 8.4-30.8 18.7-42.2 18.7-4.8 0-19.9-17.5-27.7-22.3-12.1-7.8-16.9-4.2-13.9 7.2 1.2 4.8 10.9 10.9 16.9 19.9 7.8 11.5 12.7 25.9 12.7 25.9s10.9-10.3 16.9-12.1c9-2.4 19.3 1.8 31.4 0 15.1-2.4 31.4-10.9 31.4-10.9l4.2 43.4s-54.3 50.7-49.5 70.6 56.1 44.6 68.2 62.7c12.1 17.5-7.2 24.1-7.2 32.6s-1.8 19.9 7.2 16.3c9-3.6 10.3-18.1 18.7-31.4 6-9 10.3-13.9 11.5-17.5 1.8-9-23.5-32-37.4-48.9-6.6-7.8-19.9-18.7-19.9-18.7l39.2-29.6s67.6 27.7 82.6 18.7c15.1-9 19.3-98.3 19.3-98.3l47-11.5-12.1-11.7z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#F8DD4E",
    d: "M279.3 262.4c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm45.8-182.8c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm0 91.1c-6 0-11.5-4.8-11.5-11.5 0-6 4.8-11.5 11.5-11.5 6 0 11.5 4.8 11.5 11.5-.6 6.7-5.5 11.5-11.5 11.5zm-136.9 45.8c-6 0-11.5-4.8-11.5-11.5 0-6 4.8-11.5 11.5-11.5 6.6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm45.2-136.9c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-4.8 11.5-11.5 11.5zm22.9 91.1c-6 0-11.5-10.3-11.5-22.9s4.8-22.9 11.5-22.9c6 0 11.5 10.3 11.5 22.9s-4.8 22.9-11.5 22.9zm-114-45.2c-6 0-11.5-4.8-11.5-11.5 0-6.6 4.8-11.5 11.5-11.5 6.6 0 11.5 4.8 11.5 11.5 0 6.6-4.8 11.5-11.5 11.5z"
  }));
};
var IN = function IN(_ref108) {
  var title = _ref108.title,
      rest = _objectWithoutProperties(_ref108, _excluded108);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#181A93",
    d: "M17.3 0h478.4v342H17.3V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFA44A",
    d: "M0 0h513v114H0V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#1A9F0B",
    d: "M0 228h513v114H0V228z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 114h513v114H0V114z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#FFF",
    cx: 256.5,
    cy: 171,
    r: 34.2
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#181A93",
    d: "M256.5 216.6c-25.1 0-45.6-20.5-45.6-45.6s20.5-45.6 45.6-45.6 45.6 20.5 45.6 45.6-20.5 45.6-45.6 45.6zm0-11.4c18.2 0 34.2-16 34.2-34.2s-15.9-34.2-34.2-34.2-34.2 16-34.2 34.2 16 34.2 34.2 34.2z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#181A93",
    cx: 256.5,
    cy: 171,
    r: 22.8
  }));
};
var IO = function IO(_ref109) {
  var title = _ref109.title,
      rest = _objectWithoutProperties(_ref109, _excluded109);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0-.3h513V342H0V-.3z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M462.9 198.1c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 10c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-10 20-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-10 21-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 21 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 20 10c11 6 22 12 32.1 12s20-6 31.1-12l19-10v-22c-10 0-20 6-30.1 12-7 4-16 9-20 9zM0 31.7l19 10c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-10 20-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-10 21-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 21 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 20 10c11 6 22 12 32.1 12s20-6 31.1-12l19-10v-22c-10 1-20 6-30.1 12-7 4-16 9-20 9s-14-5-21-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-11-30.1-12v22zm462.9 55.2c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 9c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12l19-9v-22c-10 0-20 6-30.1 12-7 3.9-16 9-20 9zm50.1 34c-10 1-20 6-30.1 12-7 4-16 10-20 10s-14-6-21-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-14-6-20-10c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-13-6-20-10c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 10-20 10s-13-6-20-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 10-21 10s-13-6-20-10c-10-6-20-11-30.1-12v23c4 1 13 5 19 9 11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12c6-4 15-8 19-9v-23zm-50.1 133.3c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 9c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12l19-9v-22c-10 0-20 6-30.1 12-7 4-16 9-20 9zm50.1 34c-10 1-20 6-30.1 12-7 4-16 10-20 10s-14-6-21-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-14-6-20-10c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-13-6-20-10c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 10-20 10s-13-6-20-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 10-21 10s-13-6-20-10c-10-6-20-11-30.1-12v23c4 0 13 5 19 9 11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12c6-4 15-9 19-9v-23z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0-.3h256v171H0V-.3z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M389.8 119.9H408v78.8h-18.3l.1-78.8zm0 117.8H408v75.1h-18.3l.1-75.1z",
    fill: "#A2001D"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M144-.3h-32v70H0v32h112v69h32v-69h112v-32H144v-70z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0-.3v15l57 39h23L0-.3zm256 0v15l-57 39h-23l80-54z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0-.3v15l57 39h23L0-.3zm256 0v15l-57 39h-23l80-54zM0 170.7v-15l57-38h23l-80 53zm256 0v-15l-57-38h-23l80 53z"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#2E52B2"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 22.7v31h46l-46-31zm96-23v49L23-.3h73zm160 23v31h-46l46-31zm-96-23v49l73-49h-73z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 22.7v31h46l-46-31zm96-23v49L23-.3h73zm160 23v31h-46l46-31zm-96-23v49l73-49h-73zM0 147.7v-30h46l-46 30zm96 23v-49l-73 49h73zm160-23v-30h-46l46 30zm-96 23v-49l73 49h-73z"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#5DA51E",
    stroke: "#45602C",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M462.8 91.5h-29.1l25.7-25.7c4.5-4.4 4.5-11.4 0-15.8l-3.4-3.4c-4.4-4.4-11.4-4.4-15.8 0l-25.9 25.9V37.4c0-6.2-5.1-11.3-11.3-11.3h-4.7c-6.2 0-11.3 5.1-11.3 11.3v31.7l-23.5-23.8c-4.7-4.7-12.2-4.7-16.9 0l-3.6 3.6c-4.7 4.7-4.7 12.4 0 17.2l25 25.4h-30.6c-6 0-10.9 4.9-10.9 10.9v4.6c0 6 4.9 10.9 10.9 10.9H369l-20.7 20.7c-4.4 4.4-4.4 11.4 0 15.8l3.4 3.4c4.4 4.4 11.4 4.4 15.8 0l19.6-19.6V167c0 6.1 5.1 11.1 11.3 11.3h4.7c6.2 0 11.3-5.1 11.3-11.3v-28.3l22.2 22.6c4.7 4.7 12.4 4.7 17.1 0l3.6-3.6c4.7-4.7 4.7-12.4 0-17.2L435.2 118h27.6c5.9 0 10.7-4.9 10.9-10.9v-4.6c0-6.1-4.9-11-10.9-11z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#E2DD24",
    stroke: "#525625",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M439.2 249.1h-79.8s-.9-13.4-6-21.8c-6.2-10.4-13.9-28.1-1.4-36.7 15.9-10.9 33.7.8 48.2.8 11.8.1 26.9-14 45-.8 12.2 8.9 3.9 28.2-1.3 36.7-7 11.5-4.7 21.8-4.7 21.8z"
  }));
};
var IQ = function IQ(_ref110) {
  var title = _ref110.title,
      rest = _objectWithoutProperties(_ref110, _excluded110);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#CE1126",
    d: "M0 0h513v114H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 228h513v114H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M219.2 160.7h-29.3c1.5-5.7 6.6-9.9 12.8-9.9v-19.9c-18.3 0-33.1 14.9-33.1 33.1v16.5h49.6c1.8 0 3.3 1.5 3.3 3.3v6.6h-66.2v19.9h86.1v-26.5c0-12.7-10.4-23.1-23.2-23.1zm49.6 29.8v-59.6H249v79.5h33.1v-19.9zm66.2 0v-59.6h-19.8v59.6h-6.6v-19.8h-19.9v39.7h59.6v-19.9z",
    fill: "#547C31"
  }));
};
var IR = function IR(_ref111) {
  var title = _ref111.title,
      rest = _objectWithoutProperties(_ref111, _excluded111);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v114H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 227.9h513v114H0zm278.8-93.1c.1 2 8.7 26.2 4.4 39.4-6.6 20.3-15.8 21.8-19.8 24.5V134l-6.9-4.2-6.9 4.2v64.7c-4-2.7-12.4-2.4-19.8-24.5-4.3-12.7 5.7-37.3 5.8-39.2 0 0-9.5 8.1-15.8 24-5.9 14.8 1.9 49.6 29.5 54.8 2.3.4 4.7 5.6 7.2 5.6 2.1 0 4.1-5.2 6-5.5 28.4-4.6 35-41.7 29.9-55.6-5.4-14.6-13.6-23.5-13.6-23.5z",
    fill: "#D80027"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M44.6 98.9h22.3v24.4H44.6zM0 98.9h22.3v24.4H0zm89.2 0h22.3v24.4H89.2zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4H223zm44.7 0H290v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0H513v24.4h-22.3zm-446.1 118h22.3v25.5H44.6zm-44.6 0h22.3v25.5H0zm89.2 0h22.3v25.5H89.2zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5H223zm44.7 0H290v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0H513v25.5h-22.3z",
    fill: "#FFF",
    opacity: 0.5
  }));
};
var IS = function IS(_ref112) {
  var title = _ref112.title,
      rest = _objectWithoutProperties(_ref112, _excluded112);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.334h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M512 295.883H202.195v130.783h-79.76V295.883H0v-79.772h122.435V85.329h79.76v130.782H512v61.218z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M512 234.666v42.663H183.652v149.337h-42.674V277.329H0v-42.663h140.978V85.329h42.674v149.337z"
  }));
};
var IT = function IT(_ref113) {
  var title = _ref113.title,
      rest = _objectWithoutProperties(_ref113, _excluded113);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M341.334 85.33H0v341.332h512V85.33z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M0 85.333h170.663V426.67H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M341.337 85.333H512V426.67H341.337z"
  }));
};
var JE = function JE(_ref114) {
  var title = _ref114.title,
      rest = _objectWithoutProperties(_ref114, _excluded114);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M301.8 171 513 30.2V0h-45.3L256.5 140.8 45.3 0H0v30.2L211.2 171 0 311.8V342h45.3l211.2-140.8L467.7 342H513v-30.2z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "m233.7 44.6 22.3 5.6 22.3-5.6 4-20.9-14.9 6.5L256 14.8l-11.4 15.4-14.9-6.5z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M233.7 44.6s-4 12.9-4 29.9c0 27.9 26.3 41.3 26.3 41.3s26.3-15.5 26.3-41.3c0-15.4-4-29.9-4-29.9s-8.1-5-22.3-5-22.3 5-22.3 5z"
  }));
};
var JM = function JM(_ref115) {
  var title = _ref115.title,
      rest = _objectWithoutProperties(_ref115, _excluded115);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M215.864 256.006 0 399.911V112.089zM512 112.089v287.822L296.136 256.006z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M512 112.089 296.136 256.006 512 399.911v26.757h-40.125L256 282.752 40.125 426.668H0v-26.757l215.864-143.905L0 112.089V85.331h40.125L256 229.248 471.875 85.331H512z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M512 112.089 296.136 256.006 512 399.911v26.757h-40.125L256 282.752 40.125 426.668H0v-26.757l215.864-143.905L0 112.089V85.331h40.125L256 229.248 471.875 85.331H512z"
  }));
};
var JO = function JO(_ref116) {
  var title = _ref116.title,
      rest = _objectWithoutProperties(_ref116, _excluded116);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.339h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.339h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M0 312.89h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M256 256.006 0 426.669V85.331z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "m77.913 224.802 7.876 16.469 17.786-4.11-7.965 16.426 14.303 11.343-17.808 4.014.049 18.255-14.241-11.421-14.241 11.421.05-18.255-17.809-4.014 14.303-11.343-7.965-16.426 17.786 4.11z"
  }));
};
var JP = function JP(_ref117) {
  var title = _ref117.title,
      rest = _objectWithoutProperties(_ref117, _excluded117);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#D80027",
    cx: 256,
    cy: 255.994,
    r: 96
  }));
};
var KE = function KE(_ref118) {
  var title = _ref118.title,
      rest = _objectWithoutProperties(_ref118, _excluded118);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.331h512v90.579H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#496E2D",
    d: "M0 336.089h512v90.568H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#A2001D",
    d: "M0 198.606h512v114.799H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m323.265 139.803-25.583-11.809L256 222.376l-41.682-94.382-25.583 11.809 51.749 116.191-51.749 116.192 25.583 11.808L256 289.613l41.682 94.381 25.583-11.808-51.749-116.192z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M273.376 150.931C263.472 140.115 256 133.898 256 133.898s-7.472 6.216-17.376 17.032v210.127C248.528 371.873 256 378.091 256 378.091s7.472-6.216 17.376-17.033V150.931z"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M209.04 191.226v129.535c10.465 18.542 23.274 33.742 32.872 43.818V147.408c-9.599 10.076-22.408 25.275-32.872 43.818zm93.92 0c-10.465-18.543-23.274-33.742-32.872-43.818V364.58c9.599-10.077 22.407-25.276 32.872-43.818V191.226z",
    fill: "#A2001D"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M302.96 191.226v129.535c10.594-18.774 18.784-40.973 18.784-64.767s-8.19-45.993-18.784-64.768zm-93.92 0v129.535c-10.594-18.774-18.784-40.973-18.784-64.767s8.19-45.993 18.784-64.768z"
  }));
};
var KG = function KG(_ref119) {
  var title = _ref119.title,
      rest = _objectWithoutProperties(_ref119, _excluded119);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: 256,
    cy: 170.7,
    r: 170.7
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M382.4 170.7 330.8 195l27.5 50-56.1-10.7-7.1 56.6-39.1-41.7-39.1 41.7-7.1-56.6-56.1 10.7 27.5-50-51.6-24.3 51.6-24.3-27.5-50.1 56.1 10.8 7.1-56.7L256 92.1l39.1-41.7 7.1 56.7 56.1-10.8-27.5 50.1z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#D80027",
    cx: 257.4,
    cy: 170.7,
    r: 71.6
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M214.2 170.7c-2.1 0-4.1.1-6.2.3.1 12 4.4 22.9 11.6 31.5 3.8-10.3 9.5-19.6 16.7-27.7-6.9-2.7-14.3-4.1-22.1-4.1zm26.6 46.5c5.2 1.9 10.8 2.9 16.6 2.9 5.8 0 11.4-1 16.6-2.9-2.8-11.1-8.7-21-16.6-28.8-7.9 7.8-13.8 17.7-16.6 28.8zm59.4-71.2c-8.5-14.8-24.5-24.7-42.8-24.7-18.3 0-34.2 9.9-42.8 24.7 15.6.1 30.2 4.3 42.8 11.6 12.6-7.3 27.2-11.6 42.8-11.6zm-21.7 28.8c7.2 8 12.9 17.4 16.7 27.7 7.2-8.5 11.5-19.5 11.6-31.5-2-.2-4.1-.3-6.2-.3-7.7 0-15.2 1.4-22.1 4.1z",
    fill: "#FFDA44"
  }));
};
var KH = function KH(_ref120) {
  var title = _ref120.title,
      rest = _objectWithoutProperties(_ref120, _excluded120);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
    fill: "#0052B4"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M303.49 281.971v-17.809h-11.873v-23.745l-11.872-11.872-11.872 11.872v-23.744L256 204.8l-11.873 11.873v23.744l-11.872-11.872-11.872 11.872v23.745H208.51v17.809h-11.872v17.808h118.724v-17.808z"
  }));
};
var KI = function KI(_ref121) {
  var title = _ref121.title,
      rest = _objectWithoutProperties(_ref121, _excluded121);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 450 300"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#CE1126",
    d: "M0 0h450v300H0V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#FCD116"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: 227.6,
    cy: 161.2,
    r: 56.2
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m254.1 73.4-23.7 26 28.6 6.5zm-51.5.2-4.8 33.1 28.5-8zm94.3 26.7-34.7 8.5 20.1 23.7zm-138.3-1.8 15.5 32.7 20.2-22.7zm159 45.3-34.4-9.9 5.6 29.5zm-182-2.6 31.9 19.8 5.2-27.7z"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#003F87",
    d: "M0 175h450v125H0V175z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 267c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21zm0-43c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21zm0-43c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FCD116",
    d: "m183.2 48.3-1.1-5.3 22.4-3.7s-30.1-7.1-40-10.7c-14.3-5.1-16.3-12.1-16.3-12.1s44.7 11 64.8 11c4.3 0 12.8 10.7 12.8 10.7s14.8-14.9 21.9-15.4c32.1-2.3 66.6-6.4 66.6-6.4s-10 6.7-16 8.5c-16.2 4.9-50.6 11.7-50.6 11.7l-4.8 7.5H277l-14.4 4.3 7.4 6.9s-7.8-4.1-18.1-2.1c-7.1 1.3-15.4 6-22.9 8-18.7 4.8-29.9-12.8-29.9-12.8l-15.9-.1z"
  }));
};
var KM = function KM(_ref122) {
  var title = _ref122.title,
      rest = _objectWithoutProperties(_ref122, _excluded122);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v85.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 170.663h512V256H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 256h512v85.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M256 256.006 0 426.668V85.331z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M68.638 256c0-24.865 17.476-45.638 40.812-50.734a52.059 52.059 0 0 0-11.13-1.208c-28.688 0-51.942 23.255-51.942 51.942s23.255 51.942 51.942 51.942c3.822 0 7.543-.425 11.13-1.208-23.337-5.096-40.812-25.869-40.812-50.734z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m108.877 211.478 2.762 8.503h8.94l-7.232 5.256 2.762 8.502-7.232-5.255-7.234 5.255 2.764-8.502-7.234-5.256h8.94zm0 22.261 2.762 8.503h8.94l-7.232 5.255 2.762 8.503-7.232-5.255-7.234 5.255 2.764-8.503-7.234-5.255h8.94zm0 22.261 2.762 8.503h8.94l-7.232 5.255 2.762 8.503-7.232-5.255-7.234 5.255 2.764-8.503-7.234-5.255h8.94zm0 22.261 2.762 8.502h8.94l-7.232 5.256 2.762 8.503-7.232-5.255-7.234 5.255 2.764-8.503-7.234-5.256h8.94z"
  })));
};
var KN = function KN(_ref123) {
  var title = _ref123.title,
      rest = _objectWithoutProperties(_ref123, _excluded123);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M512 0H0v342"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M307.7 0 0 194.5V342h206.9L513 148.5V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M513 0H385.2L0 249.4V341l126.2 1L513 91.6z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m141.1 187 31.2 24 32.3-22.2-13.1 37 31.1 23.9-39.2-1.1-13.2 37-11.1-37.6-39.2-1.1 32.3-22.2zM310.6 70.8l31.2 23.9 32.3-22.2-13.1 37 31.1 23.9-39.2-1.1-13.2 37-11.1-37.6-39.2-1.1 32.4-22.2z",
    fill: "#FFF"
  }));
};
var KP = function KP(_ref124) {
  var title = _ref124.title,
      rest = _objectWithoutProperties(_ref124, _excluded124);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#91DC5A",
    d: "M0 85.331h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.331h512v57.188H0zM0 369.48h512v57.177H0z",
    fill: "#0052B4"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 165.215h512v181.582H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#FFF",
    cx: 190.33,
    cy: 255.994,
    r: 65.668
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "m190.332 190.332 14.734 45.346h47.757l-38.65 28.028 14.849 45.481-38.69-28.16-38.631 28.107 14.79-45.428-38.616-28.028h47.722z"
  }));
};
var KR = function KR(_ref125) {
  var title = _ref125.title,
      rest = _objectWithoutProperties(_ref125, _excluded125);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h900v600H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    transform: "rotate(-56.31)"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M-75 228.3H75m-150 37.5H75m-150 37.5H75m-150 475H75m-150 37.5H75m-150 37.5H75",
    stroke: "#000",
    strokeWidth: 25
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 12.5,
    d: "M0 753.3v125"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#ca163a",
    cy: 540.8,
    r: 150
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0e4896",
    d: "M0 390.8c-41.4 0-75 33.6-75 75s33.6 75 75 75 75 33.6 75 75-33.6 75-75 75c-82.8 0-150-67.2-150-150s67.2-150 150-150z"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m231.56 535.73-83.205-124.808M262.76 514.928l-83.205-124.807m114.407 104.006-83.205-124.808m478.43-138.675-83.205-124.807M720.39 209.843 637.184 85.036m114.407 104.006L668.386 64.234",
    stroke: "#000",
    strokeWidth: 25
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 12.5,
    d: "m205.6 462.897 31.202-20.8m389.981-259.989 36.444-24.296m31.202-20.801 31.202-20.801"
  }));
};
var KW = function KW(_ref126) {
  var title = _ref126.title,
      rest = _objectWithoutProperties(_ref126, _excluded126);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M0 85.337h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 312.888h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M166.957 312.889 0 426.663V85.337l166.957 113.774z"
  }));
};
var KY = function KY(_ref127) {
  var title = _ref127.title,
      rest = _objectWithoutProperties(_ref127, _excluded127);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.334h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#6DA544",
    cx: 384,
    cy: 181.79,
    r: 29.682
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M332.054 174.377h103.88v44.522h-103.88z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#496E2D",
    d: "M435.942 255.997v-.001.001z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M332.058 285.678v29.682h15.616c9.364 9.176 22.18 14.84 36.326 14.84 14.147 0 26.962-5.664 36.326-14.84h15.616v-29.682H332.058z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#338AF3",
    d: "M332.058 211.475v44.522c0 39.759 51.942 51.942 51.942 51.942s51.942-12.182 51.942-51.942v-44.522H332.058z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M383.997 235.256c-12.985 0-12.985 11.873-25.97 11.873s-12.985-11.873-25.97-11.873v20.777c12.985 0 12.985 11.873 25.97 11.873s12.985-11.873 25.97-11.873c12.986 0 12.986 11.873 25.973 11.873 12.986 0 12.986-11.873 25.973-11.873v-20.777c-12.986 0-12.986 11.873-25.973 11.873-12.986-.001-12.986-11.873-25.973-11.873zm0-41.59c-12.985 0-12.985 11.873-25.97 11.873s-12.985-11.873-25.97-11.873v20.777c12.985 0 12.985 11.873 25.97 11.873s12.985-11.873 25.97-11.873c12.986 0 12.986 11.873 25.973 11.873 12.986 0 12.986-11.873 25.973-11.873v-20.777c-12.986 0-12.986 11.873-25.973 11.873-12.986 0-12.986-11.873-25.973-11.873z",
    fill: "#F3F3F3"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M256 85.334v22.617l-46.069 30.709H256v64h-46.069L256 233.38v22.617h-22.628L160 207.078v48.919H96v-48.919l-73.372 48.919H0V233.38l46.069-30.72H0v-64h46.069L0 107.951V85.334h22.628L96 134.241V85.334h64v48.907l73.372-48.907z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M144 85.329h-32v69.334H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.329v15.082l57.377 38.252H80zm256 0v15.082l-57.377 38.252H176z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.329v15.082l57.377 38.252H80zm256 0v15.082l-57.377 38.252H176zM0 255.997v-15.082l57.377-38.252H80zm256 0v-15.082l-57.377-38.252H176z"
  })));
};
var KZ = function KZ(_ref128) {
  var title = _ref128.title,
      rest = _objectWithoutProperties(_ref128, _excluded128);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#36B6CC",
    d: "M0 0h513v342H0V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#FFD400",
    cx: 256.5,
    cy: 170.9,
    r: 68.4
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFD400",
    d: "m256.5 251.5-27.9 41.7-7.1-49.7-43.2 25.5 15.2-47.8-50 4.2 34.4-36.5-46.9-18 46.8-18-34.4-36.5 50 4.2-15.2-47.8 43.2 25.4 7.1-49.7 27.9 41.7 27.9-41.7 7.1 49.7 43.2-25.4-15.2 47.8 50-4.2-34.3 36.6 46.8 17.9-46.8 18 34.4 36.5-50-4.2 15.2 47.8-43.2-25.4-7.1 49.7c0-.1-27.9-41.8-27.9-41.8zm0-.8c44.1 0 79.9-35.8 79.9-79.9S300.6 91 256.5 91s-79.9 35.8-79.9 79.9 35.8 79.8 79.9 79.8zM22.8 28.3c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6V28.3zm0 45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6V74zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm22.8-22.8c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7V245c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V188zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V96.8zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V51.2z"
  }));
};
var LA = function LA(_ref129) {
  var title = _ref129.title,
      rest = _objectWithoutProperties(_ref129, _excluded129);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 .1h513v90.7H0zm0 251.2h513V342H0z",
    fill: "#D80027"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#FFF",
    cx: 256.5,
    cy: 171,
    r: 65.9
  }));
};
var LB = function LB(_ref130) {
  var title = _ref130.title,
      rest = _objectWithoutProperties(_ref130, _excluded130);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 .2h513v90.7H0zm.5 251.1H513V342H.5z",
    fill: "#D80027"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M290.3 193.5 256 130.7l-34.3 62.8h25.7v17.2h17.2v-17.2z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#14AF5A",
    d: "M241.3 213.1c4.4-4.4 4.4-11.6-.1-16l4.7 4.7c-5.2-4.7-12.2-6.6-19.1-5.3l-23.5 5.9c-6.1 1.5-6.8-.4-1.8-4.2l27.1-20.3c5.1-3.8 4.2-6.9-2.3-6.9h-11c-6.4 0-7-2.3-1.5-5.1l25.3-12.7c5.6-2.8 5.1-5.1-1.5-5.1h-11c-6.4 0-7.4-3.1-2.3-6.9l27.1-20.3c5.6-3.8 12.9-3.8 18.5 0l27.1 20.3c5.1 3.8 4.2 6.9-2.3 6.9h-11c-6.4 0-7 2.3-1.5 5.1l25.3 12.7c5.6 2.8 5.1 5.1-1.5 5.1h-11c-6.4 0-7.4 3.1-2.3 6.9l27.1 20.3c5.1 3.8 4.4 5.7-1.8 4.2l-23.5-5.9c-6.8-1.3-13.9.6-19.1 5.3l4.7-4.7c-4.4 4.4-4.5 11.5-.1 16l6.8 6.8c4.4 4.4 3.1 8-3.3 8h-45.8c-6.2 0-7.7-3.6-3.3-8 .1.1 6.9-6.8 6.9-6.8z"
  }));
};
var LC = function LC(_ref131) {
  var title = _ref131.title,
      rest = _objectWithoutProperties(_ref131, _excluded131);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#55B2FF",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#F3F3F3",
    d: "M148.5 298.1h216l-108-254.2z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#333",
    d: "m186 272.7 70.5-160.3L327 272.7z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M148.5 298.1h216l-108-101.7z"
  }));
};
var LI = function LI(_ref132) {
  var title = _ref132.title,
      rest = _objectWithoutProperties(_ref132, _excluded132);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v171H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M149.3 98.1c0-14-11.3-25.3-25.3-25.3-6.5 0-12.4 2.4-16.9 6.4V64.4h8.4V47.5h-8.4v-8.4H90.3v8.4h-8.4v16.9h8.4v14.9c-4.5-4-10.4-6.4-16.9-6.4-14 0-25.3 11.3-25.3 25.3 0 7.5 3.3 14.2 8.4 18.8v14.9h84.3V117c5.3-4.7 8.5-11.5 8.5-18.9z"
  }));
};
var LK = function LK(_ref133) {
  var title = _ref133.title,
      rest = _objectWithoutProperties(_ref133, _excluded133);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#A2001D",
    d: "M222.6 22.3h267.1v296.8H222.6z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M22.3 22.3h200.3v296.8H22.3z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M200.3 0h22.3v342h-22.3z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M22.3 22.3h89v296.8h-89z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FF9811",
    d: "M111.3 22.3h89v296.8h-89z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M368.2 156.8c-1.4-2 0-37.9 0-37.9.9-7.4.1-8.4 1-11.4.9-2.9 5.4-11.6 5.4-11.6s-6-2.3-10.3-.6c-4.3 1.7-24.7-7.5-31.2 3.4-4.4 7-23.6 16.2-24.6 14-1-2.2-5.9-5-6.9-2.9s-.7 13.9 0 16c.8 2.6 9.8 2 12.3 3.1 3.7 1.8 12.2 8.2 11.9 10.7-.3 2.5-22.5-6-24.2-4.5-1.4 1.2-1.9 13.2-.4 15 1.8 2.1 23.4 5.6 25 7.5 1.6 1.9-13.1 7.4-12.3 25 .7 14.7 8 17.4 8 17.4s-2.4 3.6-7.8 3.1c-6.2-.6-27.4-17.7-27.4-17.7s-3.5-109 3.6-121.4c4.9-8.5-22.7 10.1-22.7 50.8V151c0 6.6-1.4 22.4 2.6 34 0 0-.4 46.9 1.5 49.6s12.7 2.2 14.8 0 0-30 0-30c7.7.2 18.3 17.5 32.5 16.4 20.6-1.6 28.7-9.9 34.3-5 8.1 7.1 5.5 23.2.4 31.5-2.2 3.5-14.3 4.7-15.7 7.6-1.4 2.9.5 5.4.5 5.4h29.7s1.4-20.5 2.7-26.1c1.3-5.7-.6-10.7 5.9-10.4 23.5 1.1 39.8-15.3 45.5-8 3.2 4.1 5.6 29.9 3.3 33.3-2.2 3.4-13.8 2.8-15.2 6.7-1.4 4 .8 4.4.8 4.4h29.7s-.4-21.2 2.5-27.7 4.9-10.4 9.3-17.2c4.4-6.8 11.3-15.7 11.3-36.2 0-14.2-8.1-22.8-8.1-22.8H417c-14.1.2-47.4 2.3-48.8.3zm-136-124.5c10.7-10.6 20.2-2.7 22.2 2.1 1.9 4.8 2.1 8.2 2.8 13.6.9 6.9 4.9 14 4.9 14s-7.1-3.8-14.7-4.2c-4.7-.3-9-.6-13.6-2.5-5.7-2.3-11.7-12.9-1.6-23zm248.4-.1c10.7 10.6 2.8 20.2-2 22.2s-8.2 2.1-13.6 2.8c-6.9.9-14 5-14 5s3.7-7.1 4.2-14.7c.3-4.7.6-9.1 2.4-13.6 2.2-5.7 12.8-11.8 23-1.7zm.1 276.9c-10.7 10.6-20.2 2.6-22.2-2.2-1.9-4.8-2.1-8.2-2.7-13.6-.8-6.9-4.9-14.1-4.9-14.1s7 3.8 14.7 4.3c4.7.3 9 .6 13.6 2.5 5.7 2.4 11.7 13.1 1.5 23.1zm-248.2-.1c-10.6-10.7-2.7-20.2 2.1-22.2 4.8-1.9 8.2-2.1 13.6-2.8 6.9-.9 14-4.9 14-4.9s-3.8 7.1-4.2 14.7c-.3 4.7-.6 9-2.5 13.6-2.3 5.7-12.9 11.8-23 1.6z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "none",
    stroke: "#FFDA44",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    d: "M446.9 162.4s7.5-2.6 8.4-16.1c.6-8.6-19.8-16-39-11.5-19.7 4.6-34-3.1-34-14.6 0-22.9 29.7-16.2 38.9-11.3 9.1 4.9 29.7 23.5 35.1 9.4"
  }));
};
var LR = function LR(_ref134) {
  var title = _ref134.title,
      rest = _objectWithoutProperties(_ref134, _excluded134);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 0h512v31.1H0zm0 62.2h512v31.1H0zm0 62.3h512v31.1H0zm0 62.3h512v31.1H0zm0 62.5h512v31.1H0zm0 61.6h512V342H0z",
    fill: "#bf0a30"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#002868",
    d: "M0 0h155.6v155.6H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "m77.8 30.2 10.7 32.9h34.6l-28 20.4 10.7 32.9-28-20.3-28 20.3 10.7-32.9-28-20.4h34.6z"
  }));
};
var LS = function LS(_ref135) {
  var title = _ref135.title,
      rest = _objectWithoutProperties(_ref135, _excluded135);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v114H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M0 227.6h513v114H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m245.2 171 7.7-23.1c2-5.9 5.1-6 7.1 0l7.7 23.1 19.4 29.1c1.7 2.6 1.3 6.3-1.2 8 0 0-6.9 8-29.5 8s-29.5-8-29.5-8c-2.4-2-2.9-5.4-1.2-8l19.5-29.1z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M256.5 171c-12.5 0-22.6-10.1-22.6-22.6 0-12.5 10.1-22.6 22.6-22.6s22.6 10.1 22.6 22.6c0 12.5-10.2 22.6-22.6 22.6zm0 0c6.2 0 11.3-16.3 11.3-22.6 0-6.2-5.1-11.3-11.3-11.3-6.2 0-11.3 5.1-11.3 11.3 0 6.3 5 22.6 11.3 22.6z"
  }));
};
var LT = function LT(_ref136) {
  var title = _ref136.title,
      rest = _objectWithoutProperties(_ref136, _excluded136);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 312.888h512v113.775H0z"
  }));
};
var LU = function LU(_ref137) {
  var title = _ref137.title,
      rest = _objectWithoutProperties(_ref137, _excluded137);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#338AF3",
    d: "M0 312.888h512v113.775H0z"
  }));
};
var LV = function LV(_ref138) {
  var title = _ref138.title,
      rest = _objectWithoutProperties(_ref138, _excluded138);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    className: "prefix__st1",
    d: "M0 0h513v127.6H0zm0 214.4h513V342H0z",
    fill: "#A2001D"
  }));
};
var LY = function LY(_ref139) {
  var title = _ref139.title,
      rest = _objectWithoutProperties(_ref139, _excluded139);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#496E2D",
    d: "M0 312.888h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m281.424 236.026 8.962 12.35 14.513-4.706-8.975 12.339 8.961 12.349-14.509-4.724-8.976 12.34.01-15.258-14.51-4.725 14.514-4.706z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M256.965 286.868c-17.048 0-30.868-13.821-30.868-30.868s13.821-30.868 30.868-30.868a30.742 30.742 0 0 1 14.684 3.71c-6.851-6.698-16.218-10.833-26.556-10.833-20.982 0-37.992 17.01-37.992 37.992s17.01 37.992 37.992 37.992c10.338 0 19.706-4.135 26.556-10.833a30.738 30.738 0 0 1-14.684 3.708z"
  })));
};
var MA = function MA(_ref140) {
  var title = _ref140.title,
      rest = _objectWithoutProperties(_ref140, _excluded140);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337v341.326h512V85.337z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#20661b",
    d: "M352 226.484h-73.337L256 156.738l-22.663 69.748H160l59.331 43.107-22.663 69.749L256 296.232l59.332 43.107-22.663-69.749L352 226.484zm-116.063 37.711 7.663-23.585h24.8l7.663 23.585v.001L256 278.772l-20.063-14.577zm27.873-37.711h-15.619L256 202.447l7.81 24.037zm24.269 28.982-4.827-14.856h25.274l-20.447 14.856zm-59.331-14.856-4.827 14.856-20.447-14.856h25.274zm-5.211 61.748 7.81-24.036 12.636 9.181-20.446 14.855zm44.479-14.856 12.636-9.181 7.81 24.036-20.446-14.855z"
  }));
};
var MC = function MC(_ref141) {
  var title = _ref141.title,
      rest = _objectWithoutProperties(_ref141, _excluded141);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.333h512v341.333H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#c70000",
    d: "M0 85.333h512V256H0z"
  }));
};
var MD = function MD(_ref142) {
  var title = _ref142.title,
      rest = _objectWithoutProperties(_ref142, _excluded142);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h171v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#AF7F59",
    d: "M206.2 129.1h33.2L256 79.3l16.6 49.8h33.2v99.6L256 262l-49.8-33.2v-99.7zm33.2 33.3v49.8h33.2v-49.8h-33.2z"
  }));
};
var ME = function ME(_ref143) {
  var title = _ref143.title,
      rest = _objectWithoutProperties(_ref143, _excluded143);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#E6BE53",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#E01D24",
    d: "M20 20h473v302H20z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#E6BE53",
    d: "M248.5 112.9c4.4 4.4 11.6 4.4 16 0l-4.7 4.7 22.7-22.7c4.9-4.5 12.1-5.6 18.2-2.8l2.1 1c5.7 2.9 6.7 8.7 2.3 13.1l4.7-4.7-22.8 22.8c-4.5 4.9-5.6 12.1-2.8 18.2l1 2.1c2.9 5.7 5.1 15.4 5.1 21.6v-11.3c0 6.2 4.4 9.1 10.2 6.2l2.1-1c5.7-2.9 6.7-8.7 2.3-13.1l4.7 4.7c-4.4-4.4-4.4-11.6 0-16l-4.7 4.7c5.2-5.5 9.6-11.6 13.1-18.2l1-2.1c2.9-5.7 6.3-15.1 7.9-21.2l5.8-23.3c1.5-6 5.9-6.8 9.6-1.8l20.2 26.9c3.8 5.1 6.9 14 6.9 20.6v22.4c0 6.3-2.2 15.8-5.1 21.7l-1 2.1c-3.5 6.6-7.9 12.7-13.1 18.2l-6.8 6.8c-5.4 5.2-11.5 9.6-18.2 13.1l-2.1 1c-5.7 2.9-15.5 5.1-21.6 5.1-6.2 0-6.9 2.2-1.1 5.1l2.1 1c5.7 2.9 13.8 8.7 18.2 13.1l-4.7-4.7c4.4 4.4 11.6 4.4 16 0l-4.7 4.7c4.4-4.4 11.6-4.4 16 0L339 226c4.6 4.9 5.7 12.1 2.9 18.2l-1 2.1c-2.9 5.7-10.4 10.2-16.4 10.2-7.5-.3-14.8-2-21.6-5.1l-2.1-1c-6.5-3.6-11.8-8.9-15.4-15.4l-1-2.1c-2.9-5.7-8.7-6.7-13.1-2.3l4.7-4.7c-4.4 4.7-5.2 11.8-1.8 17.3l10.3 15.4c3.4 5.1 2 12.1-3.1 15.5L266 284.4c-5.7 3.4-12.8 3.4-18.6 0L232 274.1c-5.1-3.4-6.5-10.3-3.1-15.5l10.3-15.4c3.4-5.5 2.6-12.6-1.8-17.3l4.7 4.7c-4.4-4.4-10.2-3.6-13.1 2.3l-1 2.1c-2.9 5.7-9.5 12.4-15.4 15.4l-2.1 1c-5.7 2.9-15.5 5.1-21.6 5.1-6.9-.3-13.1-4.2-16.4-10.2l-1-2.1c-2.8-6.1-1.6-13.3 2.9-18.2l-4.7 4.7c4.4-4.4 11.6-4.4 16 0L181 226c4.4 4.4 11.6 4.4 16 0l-4.7 4.7c5.5-5.2 11.6-9.6 18.2-13.1l2.1-1c5.7-2.9 5-5.1-1.1-5.1-7.5-.3-14.8-2-21.6-5.1l-2.1-1c-6.6-3.5-12.7-7.9-18.2-13.1l-6.8-6.8c-5.2-5.4-9.6-11.5-13.1-18.2l-1-2.1c-3.1-6.8-4.9-14.2-5.1-21.7V121c0-6.3 3.1-15.6 6.9-20.6l20.2-26.9c3.8-5.1 8.1-4.3 9.6 1.8l5.8 23.3c2 7.3 4.6 14.4 7.9 21.2l1 2.1c2.9 5.7 8.7 13.8 13.1 18.2l-4.7-4.7c4.4 4.4 4.4 11.6 0 16l4.7-4.7c-4.4 4.4-3.6 10.2 2.3 13.1l2.1 1c5.7 2.9 10.2 0 10.2-6.2v11.3c0-6.2 2.2-15.7 5.1-21.6l1-2.1c2.8-6.1 1.7-13.2-2.8-18.2l-22.7-22.7 4.7 4.7c-4.4-4.4-3.6-10.2 2.3-13.1l2.1-1c6.1-2.8 13.2-1.7 18.2 2.8l22.7 22.7-4.8-4.5zm-18-40.7c-4.4-4.4-3.2-9.5 2.8-11.5l12.4-4.2c6-2 15.5-2 21.5 0l12.4 4.2c6 2 7.2 7.1 2.8 11.5l-6.8 6.8c-5.3 4.7-12.1 7.5-19.2 7.9-6.2 0-14.8-3.5-19.2-7.9.1 0-6.7-6.8-6.7-6.8z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#215F90",
    d: "M233.9 200.2c0 6.2 1.7 6.4 4.2.5 0 0 7.1-23.2 18.4-23.2 11.3 0 18.6 23.6 18.6 23.6 2.2 5.7 4 5.3 4-1.1v-11.2c0-18.7-10.1-33.9-22.6-33.9-12.5 0-22.6 15.2-22.6 33.9v11.4z"
  }));
};
var MF = function MF(_ref144) {
  var title = _ref144.title,
      rest = _objectWithoutProperties(_ref144, _excluded144);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108 72"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 0h108v72H0z",
    fill: "#003787"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 0h108L60 48v24H48V48z",
    fill: "#fff"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: 54,
    cy: 30,
    r: 8,
    fill: "#f9d90f"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M44 30h20L54 48z",
    fill: "#fff"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M54 48 38 33h32z",
    fill: "#cf142b"
  }));
};
var MG = function MG(_ref145) {
  var title = _ref145.title,
      rest = _objectWithoutProperties(_ref145, _excluded145);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M512 426.666V85.329H0v341.337h512z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M512 85.331H0v170.666h512V85.331z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.334h181.793v341.337H0z"
  }));
};
var MH = function MH(_ref146) {
  var title = _ref146.title,
      rest = _objectWithoutProperties(_ref146, _excluded146);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#1E509C",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M513 176.1V81.3L0 342l513-165.9z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#F18D36",
    d: "M513 0v81.3L0 342 513 0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "m126.7 99.3-7.8-54.1-7.7 54.1-20.8-23.7 10.7 31.6-31.5-10.7 23.6 20.8-54.1 7.7 54.1 7.7-23.6 20.8 31.5-10.7-10.7 31.6 20.8-23.7 7.7 54.1 7.8-54.1 20.7 23.7-10.6-31.6 31.5 10.7-23.6-20.8 54-7.7-54-7.7 23.6-20.8-31.5 10.7 10.6-31.6z"
  }));
};
var MK = function MK(_ref147) {
  var title = _ref147.title,
      rest = _objectWithoutProperties(_ref147, _excluded147);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.333h512V426.67H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M383.875 426.662 256 252.286l26.827 174.376zM133.565 85.33 256 252.286 230.314 85.33zm95.606 341.332L256 252.286 128.124 426.662zM0 85.33V212.9l256 39.386L28.333 85.33zm0 341.332h18.212L256 252.286 0 291.67zm256-174.376L512 212.9V85.33h-28.331zM281.686 85.33 256 252.286 378.434 85.33zM512 426.662V291.671l-256-39.385 237.787 174.376z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: 256,
    cy: 252.29,
    r: 59.359
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#FFDA44",
    cx: 256,
    cy: 252.29,
    r: 44.522
  }));
};
var ML = function ML(_ref148) {
  var title = _ref148.title,
      rest = _objectWithoutProperties(_ref148, _excluded148);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M0 85.331h170.663v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M341.337 85.331H512v341.337H341.337z"
  }));
};
var MM = function MM(_ref149) {
  var title = _ref149.title,
      rest = _objectWithoutProperties(_ref149, _excluded149);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 312.888h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M384 227.261h-97.783L256 134.265l-30.217 92.997H128l79.108 57.475-30.217 92.998L256 320.925l79.108 56.81-30.217-92.998L384 227.261z"
  }));
};
var MN = function MN(_ref150) {
  var title = _ref150.title,
      rest = _objectWithoutProperties(_ref150, _excluded150);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#095FAD",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M342 0h171v342H342zM0 0h171v342H0z",
    fill: "#BE1229"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#FFDA44"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M108.3 166.3h14.8v74.2h-14.8zm-59.4 0h14.8v74.2H48.9z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: 86,
    cy: 203.4,
    r: 14.8
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M71.2 225.7h29.7v14.8H71.2zm0-59.4h29.7v14.8H71.2z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: 86,
    cy: 144,
    r: 14.8
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M76.3 123.9h19.5L86 108.3z"
  })));
};
var MO = function MO(_ref151) {
  var title = _ref151.title,
      rest = _objectWithoutProperties(_ref151, _excluded151);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#00745a",
    d: "M0 85.331h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M285.682 248.878c-4.19 0-8.166.836-11.861 2.164 2.023-4.509 3.379-9.527 3.379-14.885 0-21.201-21.201-37.101-21.201-37.101s-21.201 15.901-21.201 37.101c0 5.357 1.356 10.375 3.379 14.885-3.693-1.328-7.671-2.164-11.861-2.164-21.201 0-37.101 21.201-37.101 21.201s15.901 21.201 37.101 21.201c12.429 0 23.031-7.286 29.682-13.315 6.65 6.03 17.251 13.315 29.682 13.315 21.201 0 37.101-21.201 37.101-21.201s-15.899-21.201-37.099-21.201z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m256 152.111 4.38 13.476h14.171l-11.464 8.332 4.376 13.476-11.463-8.33-11.463 8.33 4.376-13.476-11.464-8.332h14.171zm-53.888 23.572 8.425 7.585 9.818-5.667-4.61 10.355 8.423 7.588-11.274-1.185-4.611 10.355-2.358-11.088-11.275-1.185 9.818-5.669zm-39.45 39.449 11.09 2.358 5.668-9.818 1.186 11.274 11.089 2.358-10.357 4.61 1.186 11.274-7.587-8.423-10.357 4.61 5.669-9.818zm147.227-39.449-8.425 7.585-9.818-5.667 4.611 10.355-8.425 7.588 11.275-1.185 4.61 10.355 2.359-11.088 11.275-1.185-9.818-5.669zm39.449 39.449-11.089 2.358-5.669-9.818-1.186 11.274-11.088 2.358 10.357 4.61-1.185 11.274 7.586-8.423 10.357 4.61-5.669-9.818z",
    fill: "#FFDA44"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M256 350.642c16.84 0 32.363-5.619 44.816-15.073h-89.63c12.451 9.454 27.974 15.073 44.814 15.073zm-68.023-44.522a74.138 74.138 0 0 0 8.85 15.073h118.345a74.13 74.13 0 0 0 8.85-15.073H187.977z",
    fill: "#FFF"
  }));
};
var MP = function MP(_ref152) {
  var title = _ref152.title,
      rest = _objectWithoutProperties(_ref152, _excluded152);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0071BC",
    d: "M0 0h750v500H0V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 1.9
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: 375,
    cy: 245,
    r: 225,
    fill: "#fff"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: 375,
    cy: 245,
    r: 165,
    fill: "#0071BC"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#8C8A8C",
    strokeWidth: 1.9,
    d: "M444.7 450c.7 11-7.8 20-18.8 20H323.6c-11 0-19.5-9-19-20l16.7-325c.6-11 10-20 21-20h61.4c11 0 20.5 9 21.2 20l19.8 325z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    strokeWidth: 2,
    strokeLinejoin: "round",
    d: "m373 114 30 93h97l-78 56 29 92-78-56-78 57 30-93-79-57h97l30-92z"
  })));
};
var MQ = function MQ(_ref153) {
  var title = _ref153.title,
      rest = _objectWithoutProperties(_ref153, _excluded153);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M512 148.4v44.5H278.3v148.4h-44.6V192.9H0v-44.5h233.7V0h44.6v148.4z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M101 36.1c4.2-.2 8.3-.1 12.5.2 5.5.4 9.4 1.6 9.1.5-.5-1.8-.1-2.2-.8-1.8-1.3 1 .7-.2-7.4 4.4-11.8 6.7-16.9 11.8-14.3 21 2.3 8.1 8.2 10.3 22.3 12.5l1.9.3c5.6.9 8.1 1.4 9.8 2.2.4.2-.3-1-.1-1.7-.2.6-3.9 2.1-13.3 3.9l-4.7.9c-18.1 3.7-27.1 8.5-28.5 21-1.5 13.7 12.7 23.3 30.6 25.6 18.2 2.4 34.1-3.6 35.7-18.4 1-9.4-5.5-15-15.9-17.1-7-1.4-16.3-1.4-27.4-.3-12.4 1.3-24.7 3.4-36.9 6.3-3.6.7-5.9 4.2-5.2 7.8.7 3.6 4.2 5.9 7.8 5.2.2 0 .3-.1.5-.1 11.6-2.7 23.3-4.7 35.1-5.9 9.9-1 18-1 23.4.1 4.4.9 5.3 1.7 5.2 2.6-.5 5.1-8.9 8.2-20.7 6.7-11.6-1.5-19.5-6.8-19.1-11 .5-4.3 5.3-6.8 17.9-9.4l4.6-.9c15.5-3 21.1-5.3 23.5-13.2 1.9-6.5-1.3-11.6-7.2-14.2-3.2-1.4-6.3-2.1-13.2-3.1l-1.8-.3c-8-1.3-11.4-2.6-11.5-3-.1-.4 1.8-2.3 8.1-5.9l4.4-2.5c1.5-.8 2.9-1.8 4.3-2.7 4.6-3.4 7.2-7.1 5.8-12.3-1.9-7.3-9-9.5-20.9-10.4-4.7-.3-9.3-.4-14-.3l-2 .1c-3.7.2-6.5 3.4-6.3 7 .2 3.7 3.4 6.5 7 6.3l1.7-.1zm284 0c4.2-.2 8.3-.1 12.5.2 5.5.4 9.4 1.6 9.1.5-.5-1.8-.1-2.2-.8-1.8-1.3 1 .7-.2-7.4 4.4-11.8 6.7-16.9 11.8-14.3 21 2.3 8.1 8.2 10.3 22.3 12.5l1.9.3c5.6.9 8.1 1.4 9.8 2.2.4.2-.3-1-.1-1.7-.2.6-3.9 2.1-13.3 3.9l-4.7.9c-18.1 3.7-27.1 8.5-28.5 21-1.5 13.7 12.7 23.3 30.6 25.6 18.2 2.4 34.1-3.6 35.7-18.4 1-9.4-5.5-15-15.9-17.1-7-1.4-16.3-1.4-27.4-.3-12.4 1.3-24.7 3.4-36.9 6.3-3.6.7-5.9 4.2-5.2 7.8.7 3.6 4.2 5.9 7.8 5.2.2 0 .3-.1.5-.1 11.6-2.7 23.3-4.7 35.1-5.9 9.9-1 18-1 23.4.1 4.4.9 5.3 1.7 5.2 2.6-.5 5.1-8.9 8.2-20.7 6.7-11.6-1.5-19.5-6.8-19.1-11 .5-4.3 5.3-6.8 17.9-9.4l4.6-.9c15.5-3 21.1-5.3 23.5-13.2 1.9-6.5-1.3-11.6-7.2-14.2-3.2-1.4-6.3-2.1-13.2-3.1l-1.8-.3c-8-1.3-11.4-2.6-11.5-3-.1-.4 1.8-2.3 8.1-5.9l4.4-2.5c1.5-.8 2.9-1.8 4.3-2.7 4.6-3.4 7.2-7.1 5.8-12.3-1.9-7.3-9-9.5-20.9-10.4-4.7-.3-9.3-.4-14-.3l-2 .1c-3.7.2-6.5 3.4-6.3 7 .2 3.7 3.4 6.5 7 6.3l1.7-.1zm-5.4 199c4.2-.2 8.3-.1 12.5.2 5.5.4 9.4 1.6 9.1.5-.5-1.8-.1-2.2-.8-1.8-1.3 1 .7-.2-7.4 4.4-11.8 6.7-16.9 11.8-14.3 21 2.3 8.1 8.2 10.3 22.3 12.5l1.9.3c5.6.9 8.1 1.4 9.8 2.2.4.2-.3-1-.1-1.7-.2.6-3.9 2.1-13.3 3.9l-4.7.9c-18.1 3.7-27.1 8.5-28.5 21-1.5 13.7 12.7 23.3 30.6 25.6 18.2 2.4 34.1-3.6 35.7-18.4 1-9.4-5.5-15-15.9-17.1-7-1.4-16.3-1.4-27.4-.3-12.4 1.3-24.7 3.4-36.9 6.3-3.6.7-5.9 4.2-5.2 7.8.7 3.6 4.2 5.9 7.8 5.2.2 0 .3-.1.5-.1 11.6-2.7 23.3-4.7 35.1-5.9 9.9-1 18-1 23.4.1 4.4.9 5.3 1.7 5.2 2.6-.5 5.1-8.9 8.2-20.7 6.7-11.6-1.5-19.5-6.8-19.1-11 .5-4.3 5.3-6.8 17.9-9.4l4.6-.9c15.5-3 21.1-5.3 23.5-13.2 1.9-6.5-1.3-11.6-7.2-14.2-3.2-1.4-6.3-2.1-13.2-3.1l-1.8-.3c-8-1.3-11.4-2.6-11.5-3-.1-.4 1.8-2.3 8.1-5.9l4.4-2.5c1.5-.8 2.9-1.8 4.3-2.7 4.6-3.4 7.2-7.1 5.8-12.3-1.9-7.3-9-9.5-20.9-10.4-4.7-.3-9.3-.4-14-.3l-2 .1c-3.7.2-6.5 3.4-6.3 7s3.4 6.5 7 6.3l1.7-.1zm-278.6 0c4.2-.2 8.3-.1 12.5.2 5.5.4 9.4 1.6 9.1.5-.5-1.8-.1-2.2-.8-1.8-1.3 1 .7-.2-7.4 4.4-11.8 6.7-16.9 11.8-14.3 21 2.3 8.1 8.2 10.3 22.3 12.5l1.9.3c5.6.9 8.1 1.4 9.8 2.2.4.2-.3-1-.1-1.7-.2.6-3.9 2.1-13.3 3.9l-4.7.9c-18.1 3.7-27.1 8.5-28.5 21-1.5 13.7 12.7 23.3 30.6 25.6 18.2 2.4 34.1-3.6 35.7-18.4 1-9.4-5.5-15-15.9-17.1-7-1.4-16.3-1.4-27.4-.3-12.4 1.3-24.7 3.4-36.9 6.3-3.6.7-5.9 4.2-5.2 7.8s4.2 5.9 7.8 5.2c.2 0 .3-.1.5-.1 11.6-2.7 23.3-4.7 35.1-5.9 9.9-1 18-1 23.4.1 4.4.9 5.3 1.7 5.2 2.6-.5 5.1-8.9 8.2-20.7 6.7-11.6-1.5-19.5-6.8-19.1-11 .5-4.3 5.3-6.8 17.9-9.4l4.6-.9c15.5-3 21.1-5.3 23.5-13.2 1.9-6.5-1.3-11.6-7.2-14.2-3.2-1.4-6.3-2.1-13.2-3.1l-1.8-.3c-8-1.3-11.4-2.6-11.5-3-.1-.4 1.8-2.3 8.1-5.9l4.4-2.5c1.5-.8 2.9-1.8 4.3-2.7 4.6-3.4 7.2-7.1 5.8-12.3-1.9-7.3-9-9.5-20.9-10.4-4.7-.3-9.3-.4-14-.3l-2 .1c-3.7.2-6.5 3.4-6.3 7 .2 3.7 3.4 6.5 7 6.3l1.7-.1z"
  })));
};
var MR = function MR(_ref154) {
  var title = _ref154.title,
      rest = _objectWithoutProperties(_ref154, _excluded154);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 100 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#006233",
    d: "M0 100h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#cd2a3e",
    d: "M0 100h513v46H0zm0 296h513v46H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#ffc400",
    d: "M256 298.851c-45.956 0-84.348-32.298-93.767-75.429A96.288 96.288 0 0 0 160 243.994c0 53.02 42.979 96 96 96s96-42.98 96-96c0-7.066-.785-13.942-2.233-20.572-9.419 43.131-47.811 75.429-93.767 75.429z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#ffc400",
    d: "m255.999 171.994 8.935 27.502h28.918l-23.394 16.996 8.936 27.503-23.395-16.998-23.394 16.998 8.937-27.503-23.394-16.996h28.915z"
  }));
};
var MS = function MS(_ref155) {
  var title = _ref155.title,
      rest = _objectWithoutProperties(_ref155, _excluded155);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#1B4991",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#00A2B8",
    stroke: "#FFF",
    strokeWidth: 3,
    d: "M318.2 106.7v106.5c0 51.9 67.8 67.8 67.8 67.8s67.8-15.9 67.8-67.8V106.7H318.2z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#A35023",
    d: "M319.7 212.7c0 50.8 66.3 66.3 66.3 66.3s66.3-15.6 66.3-66.3H319.7z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M415.1 155.1h-19.4v-19.4h-19.4v19.4H357v19.4h19.3v58.1h19.4v-58.1h19.4z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M256 0v30.6l-45.2 25.1H256V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9h-55.6v-48.6l-87.5 48.6H0v-30.6L45.2 115H0V55.7h59.1L0 22.8V0h26.7l73.5 40.8V0h55.6v48.6L243.3 0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M155.8 115 256 170.7v-15.8L184.2 115zm-84 0L0 154.9v15.8L100.2 115z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9zm84 0L256 15.7V0L155.8 55.6z"
  }));
};
var MT = function MT(_ref156) {
  var title = _ref156.title,
      rest = _objectWithoutProperties(_ref156, _excluded156);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#C31B28",
    d: "M256 0h256.5v342H256z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#ACABB1",
    stroke: "#C31B28",
    strokeWidth: 2,
    d: "M101.2 68.2V33H66v35.2H30.8v35.2H66v35.2h35.2v-35.2h35.2V68.2z"
  }));
};
var MU = function MU(_ref157) {
  var title = _ref157.title,
      rest = _objectWithoutProperties(_ref157, _excluded157);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#f7ce00",
    d: "M0 85.331h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#e32737",
    d: "M0 85.331h512v85.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#191f6a",
    d: "M0 170.657h512v85.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#00a04e",
    d: "M0 341.331h512v85.337H0z"
  }));
};
var MV = function MV(_ref158) {
  var title = _ref158.title,
      rest = _objectWithoutProperties(_ref158, _excluded158);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#d01920",
    d: "M0 85.331h512v341.333H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#017c3b",
    d: "M144.696 174.375h222.609v163.25H144.696z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M283.484 304.226c-26.637 0-48.232-21.594-48.232-48.232s21.594-48.232 48.232-48.232c8.306 0 16.12 2.1 22.943 5.797-10.703-10.467-25.341-16.927-41.494-16.927-32.784 0-59.362 26.577-59.362 59.362s26.578 59.362 59.362 59.362c16.154 0 30.791-6.461 41.494-16.927-6.822 3.698-14.636 5.797-22.943 5.797z"
  }));
};
var MW = function MW(_ref159) {
  var title = _ref159.title,
      rest = _objectWithoutProperties(_ref159, _excluded159);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#272727",
    d: "M0 0h512v114H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#e40112",
    d: "M0 114h512v114H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#07893f",
    d: "M0 228h512v114H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#e40112",
    cx: 256,
    cy: 125,
    r: 95
  }));
};
var MX = function MX(_ref160) {
  var title = _ref160.title,
      rest = _objectWithoutProperties(_ref160, _excluded160);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#dc2339",
    d: "M342 0H0v341.3h513V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#11865d",
    d: "M0 0h171v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M171 0h171v342H171z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#8C9157",
    d: "M195.8 171.2c0 21.6 11.5 41.7 30.3 52.5 5.8 3.4 13.2 1.4 16.6-4.4 3.4-5.8 1.4-13.2-4.4-16.6-11.3-6.5-18.2-18.5-18.2-31.5 0-6.7-5.4-12.1-12.1-12.1-6.7 0-12.2 5.4-12.2 12.1zm93.4 51.1c17.5-11.1 28-30.4 28-51.1 0-6.7-5.4-12.1-12.1-12.1s-12.1 5.4-12.1 12.1c0 12.4-6.3 24-16.8 30.7-5.7 3.5-7.5 10.9-4.1 16.7s10.9 7.5 16.7 4.1c0-.2.2-.3.4-.4z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", {
    fill: "#C59262",
    cx: 256.5,
    cy: 159.1,
    rx: 24.3,
    ry: 36.4
  }));
};
var MY = function MY(_ref161) {
  var title = _ref161.title,
      rest = _objectWithoutProperties(_ref161, _excluded161);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 0h513v24.4H0zm0 48.9h513v24.4H0zm0 48.8h513v24.4H0zm0 48.9h513V171H0zm0 48.8h513v24.4H0zm0 48.9h513v24.4H0zm0 48.8h513v24.4H0z",
    fill: "#c00"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#006",
    d: "M0 0h256.5v195.4H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M153.3 42.1C122.6 30.7 88.5 46.3 77.1 77s4.2 64.8 34.9 76.2c13.3 5 28 5 41.4 0-30.7 24.5-75.4 19.6-100-11.1s-19.6-75.4 11.1-100c26-20.7 62.9-20.7 88.8 0zm26.7 75-20.6 23.3 5.4-30.6-31-1.6 27.3-14.9L143 68l28.6 12 8.4-29.9 8.4 29.9L217 68l-18 25.4 27.3 14.9-31 1.6 5.4 30.6-20.7-23.4z",
    fill: "#fc0"
  }));
};
var MZ = function MZ(_ref162) {
  var title = _ref162.title,
      rest = _objectWithoutProperties(_ref162, _excluded162);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.333h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#f4d900",
    d: "M0 323.333h513v104H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#006d66",
    d: "M0 85.333h513v104H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 204.333h513v104H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#cb0f31",
    d: "M256 256.006 0 426.668V85.331z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#f4d900",
    d: "m83.477 195.132 15.107 46.498h48.894l-39.554 28.739 15.107 46.499-39.554-28.738-39.555 28.738 15.11-46.499-39.554-28.739H68.37z"
  }));
};
var NA = function NA(_ref163) {
  var title = _ref163.title,
      rest = _objectWithoutProperties(_ref163, _excluded163);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#496E2D",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 426.663V85.337h512"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M512 152.222V85.337H411.67L0 359.778v66.885h100.33z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#A2001D",
    d: "M512 85.337v40.125L60.193 426.663H0v-40.125L451.807 85.337z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "m187.737 189.212-22.741 10.696 12.11 22.024-24.693-4.724-3.129 24.945-17.199-18.347-17.2 18.347-3.129-24.945-24.693 4.723 12.109-22.023-22.739-10.696 22.74-10.697-12.11-22.022 24.693 4.722 3.13-24.944 17.199 18.347 17.2-18.347 3.128 24.944 24.693-4.722-12.108 22.024z"
  }));
};
var NC = function NC(_ref164) {
  var title = _ref164.title,
      rest = _objectWithoutProperties(_ref164, _excluded164);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 426.7"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#009543",
    d: "M0 293h640v133.7H0V293z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#ED4135",
    d: "M0 132h640v161.3H0V132z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0035AD",
    d: "M0 0h640v133.3H0V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#FAE600",
    stroke: "#000",
    strokeWidth: 5.3,
    cx: 240,
    cy: 213.3,
    r: 157.3
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m307.9 354.5-31.8 12-36.1 4.2-37.8-2.4-35.9-15.5s28.6-29.3 40.7-33.5c8.6-3 22.4-3.7 22.4-3.7V122l-.3-66H246l-.5 67.5v191.7s15.3 1.2 22.1 4.1c11.3 4.9 40.3 35.2 40.3 35.2z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m212.727 102.375 42.955-21.418 5.577 11.187-42.955 21.417z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", {
    cx: 237.8,
    cy: 280.5,
    rx: 16.8,
    ry: 26.5
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: 237.4,
    cy: 143.4,
    r: 20.9
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", {
    cx: 238.4,
    cy: 211.1,
    rx: 19.9,
    ry: 12.1
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M213.8 177h47v10h-47zm0 57h47v10h-47z"
  }));
};
var NE = function NE(_ref165) {
  var title = _ref165.title,
      rest = _objectWithoutProperties(_ref165, _excluded165);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#e05206",
    d: "M0 85.337h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0db02b",
    d: "M0 312.888h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#e05206",
    cx: 256,
    cy: 256,
    r: 32
  }));
};
var NF = function NF(_ref166) {
  var title = _ref166.title,
      rest = _objectWithoutProperties(_ref166, _excluded166);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.5 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.5h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.5h171v342H0zm342 0h171v342H342zm-38 226.495-48-152.001-48 152.001h36v39.999h24v-39.999z",
    fill: "#007b23"
  }));
};
var NG = function NG(_ref167) {
  var title = _ref167.title,
      rest = _objectWithoutProperties(_ref167, _excluded167);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.5 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.5h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.5h171v342H0zm342 0h171v342H342z",
    fill: "#007b23"
  }));
};
var NI = function NI(_ref168) {
  var title = _ref168.title,
      rest = _objectWithoutProperties(_ref168, _excluded168);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
    fill: "#338AF3"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M256 214.447c-22.949 0-41.553 18.603-41.553 41.553S233.05 297.553 256 297.553c22.949 0 41.553-18.603 41.553-41.553S278.949 214.447 256 214.447zm0 65.298c-13.114 0-23.745-10.631-23.745-23.745s10.631-23.745 23.745-23.745 23.745 10.631 23.745 23.745-10.631 23.745-23.745 23.745z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M276.563 261.936 256 256l-20.563 5.936-6.855 11.873h54.836z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#338AF3",
    d: "m256 226.32-13.709 23.744L256 256l13.709-5.936z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M235.437 261.936h41.126l-6.854-11.872h-27.418z"
  }));
};
var NL = function NL(_ref169) {
  var title = _ref169.title,
      rest = _objectWithoutProperties(_ref169, _excluded169);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.5 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.5h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#cd1f2a",
    d: "M0 85.5h513v114H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#1d4185",
    d: "M0 312h513v114H0z"
  }));
};
var NO = function NO(_ref170) {
  var title = _ref170.title,
      rest = _objectWithoutProperties(_ref170, _excluded170);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.334h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M512 295.883H202.195v130.783h-79.76V295.883H0v-79.772h122.435V85.329h79.76v130.782H512v61.218z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#2E52B2",
    d: "M512 234.666v42.663H183.652v149.337h-42.674V277.329H0v-42.663h140.978V85.329h42.674v149.337z"
  }));
};
var NP = function NP(_ref171) {
  var title = _ref171.title,
      rest = _objectWithoutProperties(_ref171, _excluded171);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 426.663V85.337l280.419 174.75H87.61l183.576 166.576z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M244.769 249.888 10.199 103.71v312.754h234.57L61.193 249.888z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m98.003 324.433-14.589-6.863 7.77-14.13-15.844 3.03-2.008-16.005-11.035 11.772-11.036-11.772-2.008 16.005-15.843-3.031 7.77 14.131-14.591 6.863 14.591 6.862-7.77 14.13 15.844-3.029 2.007 16.004 11.036-11.772L73.332 358.4l2.008-16.004 15.843 3.03-7.769-14.13zm-9.735-132.771-10.612-4.991 5.651-10.278-11.523 2.205-1.461-11.641-8.026 8.561-8.026-8.561-1.46 11.641-11.525-2.205 5.652 10.278-10.613 4.991 25.972 5.194z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M93.462 191.662c0 17.212-13.953 31.165-31.165 31.165s-31.165-13.953-31.165-31.165"
  })));
};
var NR = function NR(_ref172) {
  var title = _ref172.title,
      rest = _objectWithoutProperties(_ref172, _excluded172);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 239.994h512v32H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "m174.802 341.329-19.124 8.996 10.184 18.521-20.767-3.973-2.631 20.978L128 370.422l-14.465 15.429-2.63-20.978-20.767 3.973 10.183-18.521-19.123-8.996 19.124-8.995-10.184-18.52 20.766 3.971 2.632-20.978L128 312.236l14.465-15.429 2.63 20.978 20.767-3.971-10.183 18.521z"
  }));
};
var NU = function NU(_ref173) {
  var title = _ref173.title,
      rest = _objectWithoutProperties(_ref173, _excluded173);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.334h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.334h256v170.663H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M144 85.33h-32v69.333H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.329v15.083l57.377 38.251H80z"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 107.951v30.712h46.069zm96-22.62v48.913L22.628 85.331z",
    fill: "#2E52B2"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M256 85.329v15.083l-57.377 38.251H176z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M256 107.951v30.712h-46.069zm-96-22.62v48.913l73.372-48.913z",
    fill: "#2E52B2"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.329v15.083l57.377 38.251H80z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 107.951v30.712h46.069zm96-22.62v48.913L22.628 85.331z",
    fill: "#2E52B2"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M256 85.329v15.083l-57.377 38.251H176z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M256 107.951v30.712h-46.069zm-96-22.62v48.913l73.372-48.913z",
    fill: "#2E52B2"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 255.997v-15.082l57.377-38.252H80z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 233.376v-30.713h46.069zm96 22.618v-48.912l-73.372 48.912z",
    fill: "#2E52B2"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M256 255.997v-15.082l-57.377-38.252H176z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#2E52B2"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M256 233.376v-30.713h-46.069zm-96 22.618v-48.912l73.372 48.912z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: 128,
    cy: 170.66,
    r: 22.627
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m128 154.663 3.97 12.222h12.854l-10.398 7.556 3.971 12.222L128 179.109l-10.398 7.554 3.972-12.222-10.398-7.556h12.853zm0 65.14 2.364 7.278h7.653l-6.19 4.498 2.364 7.278-6.191-4.498-6.191 4.498 2.364-7.278-6.19-4.498h7.652zm0-117.334 2.364 7.278h7.653l-6.19 4.498 2.364 7.278-6.191-4.498-6.191 4.498 2.364-7.278-6.19-4.498h7.652zm69.931 58.667 2.365 7.277h7.653l-6.192 4.499 2.365 7.279-6.191-4.498-6.191 4.498 2.365-7.279-6.191-4.499h7.652zm-139.862 0 2.364 7.277h7.653l-6.191 4.499 2.364 7.279-6.19-4.498-6.191 4.498 2.365-7.279-6.192-4.499h7.653z",
    fill: "#FFDA44"
  }));
};
var NZ = function NZ(_ref174) {
  var title = _ref174.title,
      rest = _objectWithoutProperties(_ref174, _excluded174);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.334h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m425.301 233.745 3.388 10.428h10.963l-8.87 6.444 3.388 10.427-8.869-6.444-8.871 6.444 3.388-10.427-8.87-6.444h10.963zm-39.194 75.072 5.083 15.642h16.445l-13.305 9.667 5.082 15.64-13.305-9.667-13.305 9.667 5.083-15.64-13.305-9.667h16.445zm1.481-122.846 4.236 13.036h13.704l-11.088 8.054 4.235 13.034-11.087-8.056-11.088 8.056 4.235-13.034-11.087-8.054h13.704zm-37.712 47.32 5.082 15.641h16.446l-13.306 9.666 5.084 15.641-13.306-9.666-13.305 9.666 5.082-15.641-13.305-9.666h16.445z",
    fill: "#D80027"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M256.003 85.329v30.564l-45.178 25.088h45.178v59.359H196.89l59.113 32.846v22.806h-26.69l-73.484-40.826v40.826h-55.652v-48.573l-87.429 48.573H.003v-30.553l45.168-25.099H.003v-59.359h59.103L.003 108.147V85.329h26.68l73.494 40.838V85.329h55.652v48.573l87.43-48.573z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M144 85.33h-32v69.334H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M155.826 200.344 256 255.998v-15.739l-71.847-39.915z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M155.826 200.344 256 255.998v-15.739l-71.847-39.915z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M155.826 200.344 256 255.998v-15.739l-71.847-39.915zm-83.98 0L0 240.259v15.739l100.174-55.654z",
    fill: "#D80027"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M100.174 140.983 0 85.33v15.738l71.847 39.915z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M100.174 140.983 0 85.33v15.738l71.847 39.915z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M100.174 140.983 0 85.33v15.738l71.847 39.915zm83.98 0L256 101.068V85.33l-100.174 55.653z",
    fill: "#D80027"
  }));
};
var OM = function OM(_ref175) {
  var title = _ref175.title,
      rest = _objectWithoutProperties(_ref175, _excluded175);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M138 0h377v114H138z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#4A7C3A",
    d: "M138 230h377v114H138z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 10,
    strokeMiterlimit: 2
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M40.3 35.2s37.1 48 50.8 54.5c13.7 6.5 17.1 5.7 17.1 5.7"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M100 35.2S62.9 80.6 53.3 87.6c-9.6 7-18.7 7.8-18.7 7.8m17.1-30.1h37.9M70.7 35.2v30.1"
  })));
};
var PA = function PA(_ref176) {
  var title = _ref176.title,
      rest = _objectWithoutProperties(_ref176, _excluded176);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M256 256v170.663H0V256h256z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M512 85.337V256H256V85.337h256z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "m128 123.034 11.824 36.389h38.263l-30.955 22.491 11.823 36.389L128 195.813l-30.955 22.49 11.823-36.389-30.955-22.491h38.263z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "m384 293.697 11.824 36.389h38.263l-30.955 22.491 11.823 36.389L384 366.476l-30.955 22.49 11.823-36.389-30.955-22.491h38.263z"
  }));
};
var PE = function PE(_ref177) {
  var title = _ref177.title,
      rest = _objectWithoutProperties(_ref177, _excluded177);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.331h170.663v341.337H0zm341.337 0H512v341.337H341.337z",
    fill: "#D80027"
  }));
};
var PF = function PF(_ref178) {
  var title = _ref178.title,
      rest = _objectWithoutProperties(_ref178, _excluded178);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
    fill: "#D80027"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M293.991 256c0 20.982-17.01 33.243-37.992 33.243S218.008 276.982 218.008 256s17.01-37.992 37.992-37.992 37.991 17.01 37.991 37.992z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M293.991 256c0 20.982-17.01 37.992-37.992 37.992s-37.992-17.01-37.992-37.992"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M232.259 246.506h9.498v19h-9.498zm37.988 0h9.498v19h-9.498zm-19-14.247h9.498v33.243h-9.498z",
    fill: "#D80027"
  }));
};
var PG = function PG(_ref179) {
  var title = _ref179.title,
      rest = _objectWithoutProperties(_ref179, _excluded179);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.333h512V426.67H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#A2001D",
    d: "M0 85.33h512v341.332"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m204.631 326.488 2.762 8.504h8.941l-7.233 5.255 2.763 8.502-7.233-5.254-7.233 5.254 2.762-8.502-7.233-5.255h8.94zm-22.834-81.622 4.605 14.172h14.901l-12.056 8.757 4.605 14.172-12.055-8.759-12.055 8.759 4.606-14.172-12.056-8.757h14.901zm0 103.883 4.604 14.173h14.902l-12.057 8.757 4.606 14.173-12.055-8.759-12.055 8.759 4.604-14.173-12.054-8.757h14.899zm43.566-66.782 4.606 14.172h14.901l-12.056 8.758 4.605 14.172-12.056-8.759-12.054 8.759 4.606-14.172-12.056-8.758h14.901zm-87.133 0 4.606 14.172h14.899l-12.054 8.758 4.603 14.172-12.054-8.759-12.055 8.759 4.605-14.172-12.055-8.758h14.9z",
    fill: "#FFF"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M376.526 204.163c-7.628-7.628-17.538-12.133-28.189-12.908l31.88-24.795c-12.698-12.698-29.714-18.431-46.319-17.218a44.31 44.31 0 0 0-11.396-19.511l-12.593 25.186a18.47 18.47 0 0 0-3.148-4.197c-7.245-7.245-18.991-7.244-26.234 0s-7.245 18.99 0 26.234a18.536 18.536 0 0 0 4.197 3.148l-25.186 12.593a44.303 44.303 0 0 0 19.519 11.399c-1.217 16.606 4.511 33.619 17.209 46.317L324.12 214.6a11.053 11.053 0 0 1 7.807-3.202c2.973 0 5.768 1.158 7.87 3.26a11.055 11.055 0 0 1 3.26 7.87c0 2.974-1.158 5.768-3.26 7.87l10.494 10.494c4.905-4.905 7.607-11.428 7.607-18.364 0-5.675-1.81-11.071-5.153-15.534a29.492 29.492 0 0 1 13.288 7.662c11.573 11.572 11.573 30.403 0 41.975l10.494 10.494c8.409-8.409 13.039-19.59 13.039-31.481-.001-11.892-4.632-23.072-13.04-31.481z"
  }));
};
var PH = function PH(_ref180) {
  var title = _ref180.title,
      rest = _objectWithoutProperties(_ref180, _excluded180);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M512 85.337V256H256L0 85.337z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M512 256v170.663H0L256 256z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m161.908 256-27.288-12.835 14.532-26.428-29.632 5.668-3.755-29.933-20.64 22.015-20.639-22.015-3.755 29.933-29.631-5.669 14.531 26.428L28.343 256l27.288 12.835L41.1 295.263l29.633-5.668 3.753 29.933 20.639-22.015 20.64 22.015 3.755-29.933 29.631 5.669-14.532-26.427zM21.789 117.607l9.081 12.696 14.879-4.714-9.268 12.56 9.081 12.694-14.809-4.932-9.268 12.559.117-15.608-14.809-4.934 14.88-4.712zm0 235.923 9.081 12.696 14.879-4.714-9.268 12.56 9.081 12.695-14.809-4.933-9.268 12.558.117-15.607-14.809-4.934 14.88-4.712zm188.606-117.961-9.081 12.695-14.879-4.713 9.268 12.559-9.081 12.696 14.809-4.933 9.268 12.558-.117-15.607 14.809-4.934-14.88-4.713z",
    fill: "#FFDA44"
  }));
};
var PK = function PK(_ref181) {
  var title = _ref181.title,
      rest = _objectWithoutProperties(_ref181, _excluded181);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m393.508 170.516 17.512 18.875 23.363-10.821-12.541 22.487 17.513 18.876-25.263-4.978-12.539 22.488-3.073-25.564-25.263-4.978 23.363-10.82z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.343h512v341.326H0z"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#01411c",
    d: "M128 85.331h384v341.337H128z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M361.909 298.793c-31.037 22.426-74.378 15.446-96.804-15.592-22.427-31.038-15.446-74.379 15.593-96.804 9.677-6.992 20.55-11.125 31.613-12.563-21.283-3.183-43.777 1.613-62.598 15.211-38.2 27.602-46.792 80.944-19.191 119.145 27.601 38.199 80.944 46.792 119.145 19.189 18.82-13.598 30.436-33.448 34.096-54.655-4.839 10.05-12.176 19.076-21.854 26.069zm-1.329-125.904 17.484 18.842 23.322-10.802-12.519 22.447 17.483 18.844-25.219-4.968-12.519 22.45-3.067-25.521-25.22-4.969 23.323-10.802z",
    fill: "#FFF"
  }));
};
var PL = function PL(_ref182) {
  var title = _ref182.title,
      rest = _objectWithoutProperties(_ref182, _excluded182);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.337h512V256H0z"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 256h512v170.663H0z"
  }));
};
var PM = function PM(_ref183) {
  var title = _ref183.title,
      rest = _objectWithoutProperties(_ref183, _excluded183);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 26.666 640 426.666"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#fff",
    d: "M0 0h640v480H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#00267f",
    d: "M0 0h213.3v480H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#f31830",
    d: "M426.7 0H640v480H426.7z"
  })));
};
var PN = function PN(_ref184) {
  var title = _ref184.title,
      rest = _objectWithoutProperties(_ref184, _excluded184);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.333h512V426.67H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#ACABB1",
    d: "M400.696 219.822 384 225.387l-16.696-5.565-5.565-13.913 5.565-13.913h33.392l-5.566 13.913z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#338AF3",
    d: "M345.043 219.822v61.217c0 29.821 38.957 38.957 38.957 38.957s38.957-9.137 38.957-38.957v-61.217h-77.914z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M348.555 295.541C358.131 313.927 384 319.996 384 319.996s25.869-6.069 35.445-24.455L384 236.518l-35.445 59.023z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M422.957 280.421 384 219.822l-38.957 60.599v.618c0 5.518 1.337 10.328 3.512 14.503L384 240.405l35.445 55.137c2.175-4.175 3.512-8.983 3.512-14.503v-.618z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M256 85.333v30.553l-45.167 25.099H256v59.359h-59.103L256 233.179v22.817h-26.68l-73.494-40.826v40.826h-55.652v-48.573l-87.43 48.573H0v-30.554l45.167-25.098H0v-59.359h59.103L0 108.139V85.333h26.68l73.494 40.825V85.333h55.652v48.572l87.43-48.572z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M144 85.33h-32v69.332H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915zm-83.98 0L0 240.259v15.737l100.174-55.652z",
    fill: "#D80027"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915zm83.98 0L256 101.067V85.33l-100.174 55.652z",
    fill: "#D80027"
  }));
};
var PR = function PR(_ref185) {
  var title = _ref185.title,
      rest = _objectWithoutProperties(_ref185, _excluded185);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.337h512V153.6H0zm0 136.526h512v68.263H0zM0 358.4h512v68.263H0z",
    fill: "#D80027"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M256 256.006 0 426.668V85.331z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "m83.477 195.132 15.107 46.498h48.894l-39.554 28.739 15.107 46.499-39.554-28.738-39.555 28.738 15.11-46.499-39.554-28.739H68.37z"
  }));
};
var PS = function PS(_ref186) {
  var title = _ref186.title,
      rest = _objectWithoutProperties(_ref186, _excluded186);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.337h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#268024",
    d: "M0 312.888h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#e4312b",
    d: "M256 256.006 0 426.668V85.331z"
  }));
};
var PT = function PT(_ref187) {
  var title = _ref187.title,
      rest = _objectWithoutProperties(_ref187, _excluded187);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M196.641 85.337v341.326H0V85.337z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#FFDA44",
    cx: 196.641,
    cy: 256,
    r: 64
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M160.638 224v40.001c0 19.882 16.118 36 36 36s36-16.118 36-36V224h-72z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M196.638 276c-6.617 0-12-5.383-12-12v-16h24.001v16c-.001 6.616-5.385 12-12.001 12z"
  }));
};
var PW = function PW(_ref188) {
  var title = _ref188.title,
      rest = _objectWithoutProperties(_ref188, _excluded188);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.331h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#FFDA44",
    cx: 218.902,
    cy: 255.994,
    r: 74.207
  }));
};
var PY = function PY(_ref189) {
  var title = _ref189.title,
      rest = _objectWithoutProperties(_ref189, _excluded189);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 312.888h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "m289.579 216.738-12.592 12.592c5.37 5.372 8.693 12.792 8.693 20.988 0 16.392-13.289 29.68-29.68 29.68-16.392 0-29.68-13.289-29.68-29.68 0-8.195 3.322-15.616 8.693-20.988l-12.592-12.592c-8.594 8.594-13.91 20.466-13.91 33.579 0 26.228 21.261 47.489 47.489 47.489s47.489-21.261 47.489-47.489c0-13.112-5.316-24.985-13.91-33.579z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "m256 232.51 4.421 13.605h14.304l-11.573 8.408 4.421 13.604L256 259.719l-11.573 8.408 4.421-13.604-11.573-8.408h14.304z"
  }));
};
var QA = function QA(_ref190) {
  var title = _ref190.title,
      rest = _objectWithoutProperties(_ref190, _excluded190);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#751A46",
    d: "M0 0h512v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0v342h150.3l37.7-19.6-37.7-18.9 37.7-19-37.7-18.9 37.7-19-37.7-19 37.7-18.9-37.7-19 37.7-19-37.7-18.9 37.7-19-37.7-18.9 37.7-19-37.7-19L188 57l-37.7-19L188 19.1 150.3 0z"
  }));
};
var RE = function RE(_ref191) {
  var title = _ref191.title,
      rest = _objectWithoutProperties(_ref191, _excluded191);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 26.666 640 426.666"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#fff",
    d: "M0 0h640v480H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#00267f",
    d: "M0 0h213.3v480H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#f31830",
    d: "M426.7 0H640v480H426.7z"
  })));
};
var RO = function RO(_ref192) {
  var title = _ref192.title,
      rest = _objectWithoutProperties(_ref192, _excluded192);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h170.663v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M341.337 85.331H512v341.337H341.337z"
  }));
};
var RS = function RS(_ref193) {
  var title = _ref193.title,
      rest = _objectWithoutProperties(_ref193, _excluded193);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 312.882h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M129.468 181.793v85.136c0 48.429 63.267 63.267 63.267 63.267S256 315.356 256 266.929v-85.136H129.468z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M155.634 196.634h74.201v-29.681l-14.841 7.42-22.261-22.26-22.259 22.26-14.84-7.42zm85.526 82.148-48.231-48.231-48.231 48.231 15.741 15.74 32.49-32.49 32.49 32.49z",
    fill: "#FFDA44"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M241.16 233.734h-22.504a14.74 14.74 0 0 0 2.001-7.418c0-8.196-6.645-14.84-14.84-14.84-5.663 0-10.581 3.172-13.083 7.836-2.502-4.663-7.421-7.836-13.083-7.836-8.195 0-14.84 6.644-14.84 14.84 0 2.706.736 5.235 2.001 7.418h-22.114c0 8.196 7.139 14.84 15.334 14.84h-.494c0 8.196 6.644 14.84 14.84 14.84 0 7.257 5.211 13.286 12.094 14.576l-11.694 26.401a48.075 48.075 0 0 0 18.149 3.544 48.079 48.079 0 0 0 18.149-3.544l-11.694-26.401c6.883-1.29 12.094-7.319 12.094-14.576 8.196 0 14.84-6.644 14.84-14.84h-.494c8.199 0 15.338-6.644 15.338-14.84z"
  }));
};
var RU = function RU(_ref194) {
  var title = _ref194.title,
      rest = _objectWithoutProperties(_ref194, _excluded194);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.33v341.332h512V85.33z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.333h512V426.67H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.333h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 312.884h512v113.775H0z"
  }));
};
var RW = function RW(_ref195) {
  var title = _ref195.title,
      rest = _objectWithoutProperties(_ref195, _excluded195);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.331h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 255.994h512v81.619H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#496E2D",
    d: "M0 337.614h512v89.043H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "m278.261 185.209 20.844 9.804-11.099 20.186 22.632-4.33 2.868 22.865 15.765-16.816 15.766 16.816 2.867-22.865 22.633 4.33-11.099-20.186 20.843-9.804-20.844-9.805 11.1-20.185-22.633 4.329-2.868-22.864-15.765 16.816-15.766-16.816-2.867 22.864-22.634-4.329 11.1 20.187z"
  }));
};
var SA = function SA(_ref196) {
  var title = _ref196.title,
      rest = _objectWithoutProperties(_ref196, _excluded196);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#055e1c",
    d: "M0 85.333h512v341.333H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M183.548 289.386c0 12.295 9.731 22.261 21.736 22.261h65.208c0 10.244 8.11 18.551 18.114 18.551h21.736c10.004 0 18.114-8.306 18.114-18.551v-22.261H183.548zm146.716-107.595v51.942c0 8.183-6.5 14.84-14.491 14.84v22.261c19.976 0 36.226-16.643 36.226-37.101v-51.942h-21.735zm-155.773 51.943c0 8.183-6.5 14.84-14.491 14.84v22.261c19.976 0 36.226-16.643 36.226-37.101v-51.942H174.49v51.942z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M297.661 181.788h21.736v51.942h-21.736zm-32.604 29.685c0 2.046-1.625 3.71-3.623 3.71-1.998 0-3.623-1.664-3.623-3.71v-29.682h-21.736v29.682c0 2.046-1.625 3.71-3.623 3.71s-3.623-1.664-3.623-3.71v-29.682h-21.736v29.682c0 14.32 11.376 25.971 25.358 25.971 5.385 0 10.38-1.733 14.491-4.677 4.11 2.944 9.106 4.677 14.491 4.677 1.084 0 2.15-.078 3.2-.215-1.54 6.499-7.255 11.345-14.068 11.345v22.261c19.976 0 36.226-16.643 36.226-37.101v-51.943h-21.736l.002 29.682z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M207.093 248.57h32.601v22.261h-32.601z"
  })));
};
var SB = function SB(_ref197) {
  var title = _ref197.title,
      rest = _objectWithoutProperties(_ref197, _excluded197);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#496E2D",
    d: "M0 85.334h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 426.663V85.329h512"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 396.494v30.169h45.255L512 115.499v-30.17h-45.255z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m85.688 108.787 5.12 15.756h16.566l-13.403 9.737 5.12 15.757-13.403-9.738-13.405 9.738 5.12-15.757L64 124.543h16.567zm84.624 0 5.121 15.756H192l-13.403 9.737 5.12 15.757-13.405-9.738-13.403 9.738 5.12-15.757-13.403-9.737h16.566zm-84.624 82.502 5.12 15.756h16.566l-13.403 9.738 5.12 15.757-13.403-9.739-13.405 9.739 5.12-15.757L64 207.045h16.567zm84.624 0 5.121 15.756H192l-13.403 9.738 5.12 15.757-13.405-9.739-13.403 9.739 5.12-15.757-13.403-9.738h16.566zM128 150.037l5.12 15.756h16.568l-13.405 9.738 5.12 15.758L128 181.55l-13.403 9.739 5.12-15.758-13.405-9.738h16.568z",
    fill: "#FFF"
  }));
};
var SC = function SC(_ref198) {
  var title = _ref198.title,
      rest = _objectWithoutProperties(_ref198, _excluded198);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M235.454 85.337 0 426.663 427.345 85.337z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M512 329.393 0 426.663h512z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M512 85.337h-84.655L0 426.663l512-204.512z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337v341.326L235.454 85.337z"
  }));
};
var SD = function SD(_ref199) {
  var title = _ref199.title,
      rest = _objectWithoutProperties(_ref199, _excluded199);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 312.888h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#496E2D",
    d: "M0 426.668V85.331l256 170.675z"
  }));
};
var SE = function SE(_ref200) {
  var title = _ref200.title,
      rest = _objectWithoutProperties(_ref200, _excluded200);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.333h512V426.67H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M192 85.33h-64v138.666H0v64h128v138.666h64V287.996h320v-64H192z"
  }));
};
var SG = function SG(_ref201) {
  var title = _ref201.title,
      rest = _objectWithoutProperties(_ref201, _excluded201);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512V256H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M83.478 170.666c0-24.865 17.476-45.637 40.812-50.734a52.059 52.059 0 0 0-11.13-1.208c-28.688 0-51.942 23.254-51.942 51.941s23.255 51.942 51.942 51.942c3.822 0 7.543-.425 11.13-1.208-23.336-5.095-40.812-25.867-40.812-50.733zm66.783-48.231 3.684 11.337h11.921l-9.645 7.007 3.684 11.337-9.644-7.006-9.645 7.006 3.685-11.337-9.645-7.007h11.921z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m121.344 144.696 3.683 11.337h11.921l-9.645 7.007 3.684 11.337-9.643-7.006-9.645 7.006 3.685-11.337-9.645-7.007h11.921zm57.834 0 3.684 11.337h11.921l-9.645 7.007 3.684 11.337-9.644-7.006-9.644 7.006 3.685-11.337-9.645-7.007h11.921zm-11.131 33.391 3.684 11.337h11.921l-9.644 7.007 3.684 11.337-9.645-7.006-9.643 7.006 3.684-11.337-9.644-7.007h11.92zm-35.573 0 3.683 11.337h11.921l-9.644 7.007 3.684 11.337-9.644-7.006-9.644 7.006 3.684-11.337-9.644-7.007h11.92z"
  })));
};
var SH = function SH(_ref202) {
  var title = _ref202.title,
      rest = _objectWithoutProperties(_ref202, _excluded202);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z",
    fill: "#D80027"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 170.7v-15.1l57.4-38.2H80zm256 0v-15.1l-57.4-38.2H176z",
    fill: "#D80027"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#29DBFF",
    d: "M449 139.7c-.1 44.4-7.2 92.1-65 114.9-57.8-22.8-64.9-70.5-65-114.9h130z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#ffda44",
    d: "M449 139.7c0-16.7-.9-32.9-.5-47.1C426.9 83 398.4 81 383.9 81s-42.9 2-64.6 11.6c.4 14.2-.5 30.4-.5 47.1H449z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#BF521B",
    d: "m369.5 204.5.3 10.3-12.8.2 4.9 13.2h-17.3c-18-20.2-23.4-42.4-24.9-68.1l9.1-9.7 8.3 14.3 10.8-12.8 7 7.8.8 15.7 13.8 29.1z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#474747",
    d: "m436.6 192.5-8.6 18.3h-47l-29.2-19.5 25.7 10.5h25.1l3.7-6.5 7.2.2 2-3z"
  }));
};
var SI = function SI(_ref203) {
  var title = _ref203.title,
      rest = _objectWithoutProperties(_ref203, _excluded203);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 199.112h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 312.888h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M233.606 196.639v14.837c0 34.081-44.522 44.522-44.522 44.522s-44.522-10.44-44.522-44.522v-14.837l-.145-44.188 89.043-.266.146 44.454z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M233.606 196.639v14.837c0 34.081-44.522 44.522-44.522 44.522s-44.522-10.44-44.522-44.522v-14.837l-.145-44.188 89.043-.266.146 44.454z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M233.606 196.639v14.837c0 34.081-44.522 44.522-44.522 44.522s-44.522-10.44-44.522-44.522v-14.837l14.848 14.837 29.674-22.261 29.685 22.261 14.837-14.837z"
  }));
};
var SJ = function SJ(_ref204) {
  var title = _ref204.title,
      rest = _objectWithoutProperties(_ref204, _excluded204);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.334h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M512 295.883H202.195v130.783h-79.76V295.883H0v-79.772h122.435V85.329h79.76v130.782H512v61.218z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#2E52B2",
    d: "M512 234.666v42.663H183.652v149.337h-42.674V277.329H0v-42.663h140.978V85.329h42.674v149.337z"
  }));
};
var SK = function SK(_ref205) {
  var title = _ref205.title,
      rest = _objectWithoutProperties(_ref205, _excluded205);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 196.641h512v118.717H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 315.359h512v111.304H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M129.468 181.799v85.136c0 48.429 63.267 63.267 63.267 63.267S256 315.362 256 266.935v-85.136H129.468z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M146.126 184.294v81.941c0 5.472 1.215 10.64 3.623 15.485h85.97c2.408-4.844 3.623-10.012 3.623-15.485v-81.941h-93.216z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M221.301 241.427h-21.425v-14.283h14.284v-14.283h-14.284v-14.284h-14.283v14.284h-14.282v14.283h14.282v14.283h-21.426v14.284h21.426v14.283h14.283v-14.283h21.425z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M169.232 301.658c9.204 5.783 18.66 9.143 23.502 10.636 4.842-1.494 14.298-4.852 23.502-10.636 9.282-5.833 15.79-12.506 19.484-19.939a24.878 24.878 0 0 0-14.418-4.583c-1.956 0-3.856.232-5.682.657-3.871-8.796-12.658-14.94-22.884-14.94-10.227 0-19.013 6.144-22.884 14.94a25.048 25.048 0 0 0-5.682-.657 24.88 24.88 0 0 0-14.418 4.583c3.691 7.433 10.198 14.106 19.48 19.939z"
  }));
};
var SL = function SL(_ref206) {
  var title = _ref206.title,
      rest = _objectWithoutProperties(_ref206, _excluded206);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M0 85.337h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#338AF3",
    d: "M0 312.888h512v113.775H0z"
  }));
};
var SM = function SM(_ref207) {
  var title = _ref207.title,
      rest = _objectWithoutProperties(_ref207, _excluded207);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.34h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M512 85.334v166.69L0 256.175V85.334z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M323.744 203.099 256 270.843l-67.744-67.744a81.156 81.156 0 0 0-13.879 45.483v22.261c0 35.744 23.097 66.193 55.148 77.213-4.277 8.385-3.556 18.848 2.712 26.671l24.258-19.439 24.258 19.439c6.342-7.915 7.011-18.534 2.564-26.968 31.614-11.261 54.308-41.485 54.308-76.916v-22.261a81.174 81.174 0 0 0-13.881-45.483z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M256 330.206c-32.732 0-59.362-26.63-59.362-59.362v-22.261c0-32.733 26.63-59.363 59.362-59.363s59.362 26.63 59.362 59.362v22.261c0 32.733-26.63 59.363-59.362 59.363z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#338AF3",
    d: "M293.101 270.843v-22.261c0-20.458-16.643-37.101-37.101-37.101s-37.101 16.643-37.101 37.101v22.261L256 278.264l37.101-7.421z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M218.899 270.843c0 20.458 16.643 37.101 37.101 37.101s37.101-16.643 37.101-37.101h-74.202z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M300.522 189.22c0-12.295-9.966-22.261-22.261-22.261a22.173 22.173 0 0 0-14.84 5.672v-13.093h7.421v-14.84h-7.421v-7.421h-14.84v7.421h-7.421v14.84h7.421v13.093a22.177 22.177 0 0 0-14.841-5.672c-12.295 0-22.261 9.966-22.261 22.261 0 6.591 2.867 12.512 7.421 16.589v13.093h74.203v-13.093c4.552-4.077 7.419-9.997 7.419-16.589z"
  }));
};
var SN = function SN(_ref208) {
  var title = _ref208.title,
      rest = _objectWithoutProperties(_ref208, _excluded208);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M330.207 85.331H512v341.337H330.207z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.331h181.793v341.337H0zm255.999 111.301 14.733 45.347h47.685l-38.576 28.029 14.734 45.348-38.576-28.026-38.577 28.026 14.737-45.348-38.576-28.029h47.681z",
    fill: "#496E2D"
  }));
};
var SO = function SO(_ref209) {
  var title = _ref209.title,
      rest = _objectWithoutProperties(_ref209, _excluded209);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.331h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "m256 157.273 22.663 69.748H352l-59.332 43.106 22.664 69.749L256 296.769l-59.332 43.107 22.664-69.749L160 227.021h73.337z"
  }));
};
var SR = function SR(_ref210) {
  var title = _ref210.title,
      rest = _objectWithoutProperties(_ref210, _excluded210);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#A2001D",
    d: "M0 196.636h512v118.728H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 352.462h512v74.207H0zM0 85.331h512v74.207H0z",
    fill: "#6DA544"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "m256.742 218.003 9.43 29.021h30.518L272 264.963l9.431 29.023-24.689-17.937-24.689 17.937 9.431-29.023-24.69-17.939h30.518z"
  }));
};
var SS = function SS(_ref211) {
  var title = _ref211.title,
      rest = _objectWithoutProperties(_ref211, _excluded211);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#496E2D",
    d: "M0 322.783h512v103.88H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.337h512v104.515H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#A2001D",
    d: "M0 210.877h512v89.656H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M256 256.006 0 426.668V85.331z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "m73.178 209.188 20.831 29.067 34.084-10.83-21.207 28.795 20.83 29.069-33.939-11.271-21.208 28.794.234-35.762-33.94-11.273 34.083-10.83z"
  }));
};
var ST = function ST(_ref212) {
  var title = _ref212.title,
      rest = _objectWithoutProperties(_ref212, _excluded212);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
    fill: "#6DA544"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M256 256.006 0 426.668V85.331z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m302.049 226.318 7.368 22.674h23.842l-19.288 14.016 7.366 22.674-19.288-14.015-19.287 14.015 7.366-22.674-19.288-14.016h23.842zm74.203 0 7.367 22.674h23.842l-19.288 14.016 7.367 22.674-19.288-14.015-19.288 14.015 7.367-22.674-19.288-14.016h23.842z"
  }));
};
var SV = function SV(_ref213) {
  var title = _ref213.title,
      rest = _objectWithoutProperties(_ref213, _excluded213);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
    fill: "#0052B4"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M228.582 261.936 256 214.447l27.418 47.489z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M291.616 277.616 256 295.425l-35.616-17.809v-23.744h71.232z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "m289.579 216.485-12.592 12.592c5.37 5.372 8.693 12.791 8.693 20.988 0 16.392-13.289 29.68-29.68 29.68-16.392 0-29.68-13.289-29.68-29.68 0-8.195 3.322-15.616 8.693-20.988l-12.592-12.592c-8.594 8.594-13.91 20.466-13.91 33.579 0 26.228 21.261 47.489 47.489 47.489s47.489-21.261 47.489-47.489c0-13.114-5.316-24.987-13.91-33.579z"
  }));
};
var SX = function SX(_ref214) {
  var title = _ref214.title,
      rest = _objectWithoutProperties(_ref214, _excluded214);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M512 85.331v166.69L0 256.173V85.331z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M256 256.006 0 426.668V85.331z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#FFDA44"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M59.621 256a59.546 59.546 0 0 0-.193 4.57c0 32.821 26.607 59.429 59.429 59.429s59.429-26.607 59.429-59.429c0-1.539-.078-3.061-.193-4.57H59.621z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: 118.862,
    cy: 210.287,
    r: 18.286
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M77.715 205.714v59.429c0 31.494 41.144 41.143 41.144 41.143s41.144-9.649 41.144-41.143v-59.429H77.715z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#338AF3",
    d: "M118.877 287.148c-7.632-2.746-22.876-9.767-22.876-22.006v-41.144h45.715v41.144c-.001 12.28-15.244 19.283-22.839 22.006z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#F3F3F3",
    d: "M128.001 246.856v-9.142l-9.144-4.571-9.142 4.571v9.142l-4.571 4.573v18.285h27.428v-18.285z"
  }));
};
var SY = function SY(_ref215) {
  var title = _ref215.title,
      rest = _objectWithoutProperties(_ref215, _excluded215);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 312.882h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m187.31 215.184 9.208 28.341h29.802l-24.11 17.518 9.209 28.342-24.109-17.516-24.11 17.516 9.209-28.342-24.109-17.518h29.801zm137.38 0 9.209 28.341H363.7l-24.109 17.518 9.209 28.342-24.11-17.516-24.109 17.516 9.209-28.342-24.11-17.518h29.802z",
    fill: "#6DA544"
  }));
};
var SZ = function SZ(_ref216) {
  var title = _ref216.title,
      rest = _objectWithoutProperties(_ref216, _excluded216);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#2B5DEA",
    d: "M0 0h900v600H0V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDF29",
    d: "M0 100h900v400H0V100z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D70000",
    d: "M0 150h900v300H0V150z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M450 171.4v257.2c114.3 0 171.4-85.7 214.3-128.6-42.9-42.9-100-128.6-214.3-128.6z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M450 171.4c-100 0-171.4 85.7-214.3 128.6C278.6 342.9 350 428.6 450 428.6V171.4z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M346.3 254.3h21v91.3h-21zm51.9 0h21v91.3h-21z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M477.8 254.3h21v91.3h-21zm51.9 0h21v91.3h-21z"
  }));
};
var TA = function TA(_ref217) {
  var title = _ref217.title,
      rest = _objectWithoutProperties(_ref217, _excluded217);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z",
    fill: "#D80027"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 170.7v-15.1l57.4-38.2H80zm256 0v-15.1l-57.4-38.2H176z",
    fill: "#D80027"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#29DBFF",
    d: "M448.9 169.5c0 9.6-.3 29.6-1.4 39.2-4.1 34.9-23.5 68.8-62.1 85.9-45.3-17.9-60.8-51-64.9-85.9-1.1-9.6-1.5-19.4-1.5-29l.3-47.1h129.2l.4 36.9z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M447.5 208.7c-.2 1.6-.4 3.3-.6 4.9-4.8 33.1-22.9 65.4-61.5 81-43.2-17-59.4-47.9-64.2-81-.2-1.6-.4-3.2-.6-4.9"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#29DBFF",
    d: "m385.4 251.7-22.9-43h45.8z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "m385.4 165.8-22.9 42.9h45.8z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", {
    fill: "#FFBE57",
    cx: 474.8,
    cy: 236.8,
    rx: 16.8,
    ry: 43.3
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", {
    fill: "#FFBE57",
    cx: 295.3,
    cy: 236.8,
    rx: 16.8,
    ry: 43.3
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "m385.4 31.5-33.4 44h68.5zM315.5 280s33.8 29.5 69.9 29.5 67.1-29.5 67.1-29.5l8.5 14.6S439.2 326 385.4 326 307 294.6 307 294.6l8.5-14.6z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse", {
    fill: "#A5A5A5",
    cx: 386.3,
    cy: 104.3,
    rx: 34.3,
    ry: 23.3
  }));
};
var TC = function TC(_ref218) {
  var title = _ref218.title,
      rest = _objectWithoutProperties(_ref218, _excluded218);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.333h512V426.67H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M332.058 191.996v78.221c0 38.103 51.942 49.779 51.942 49.779s51.942-11.675 51.942-49.779v-78.221H332.058z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FF9811",
    d: "M376.579 220.44c0 7.855-6.644 28.445-14.84 28.445s-14.84-20.589-14.84-28.445c0-7.856 14.84-14.222 14.84-14.222s14.84 6.367 14.84 14.222z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#A2001D",
    d: "M415.961 235.93c2.394-5.6 4.257-13.785 4.257-17.86 0-6.546-8.904-11.852-8.904-11.852s-8.904 5.306-8.904 11.852c0 4.075 1.862 12.26 4.257 17.86l-5.141 11.123a26.898 26.898 0 0 0 9.788 1.831c3.463 0 6.766-.654 9.788-1.831l-5.141-11.123z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M372.87 270.217s-7.421 14.222-7.421 28.445h37.101c0-14.222-7.421-28.445-7.421-28.445l-11.13-7.111-11.129 7.111z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M395.13 270.217v-3.555c0-5.891-4.983-10.666-11.13-10.666-6.147 0-11.13 4.776-11.13 10.666v3.555h22.26z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M256 85.333v30.553l-45.167 25.099H256v59.359h-59.103L256 233.179v22.817h-26.68l-73.494-40.826v40.826h-55.652v-48.573l-87.43 48.573H0v-30.554l45.167-25.098H0v-59.359h59.103L0 108.139V85.333h26.68l73.494 40.825V85.333h55.652v48.572l87.43-48.572z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M144 85.33h-32v69.332H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915zm-83.98 0L0 240.259v15.737l100.174-55.652z",
    fill: "#D80027"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915zm83.98 0L256 101.067V85.33l-100.174 55.652z",
    fill: "#D80027"
  }));
};
var TD = function TD(_ref219) {
  var title = _ref219.title,
      rest = _objectWithoutProperties(_ref219, _excluded219);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h170.663v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M341.337 85.331H512v341.337H341.337z"
  }));
};
var TF = function TF(_ref220) {
  var title = _ref220.title,
      rest = _objectWithoutProperties(_ref220, _excluded220);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h21v15H0V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#073AB6",
    d: "M0 0h22.5v15H0V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h11.3v7.5H0V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#F44653",
    d: "M7.1 0h3.6v7H7.1V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#1035BB",
    d: "M0 0h3.6v7H0V0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M3.6 0h3.6v7H3.6V0zm10.9 6h5L19 7h-1.5v.5h1l-.5 1h-.5V10h-1V7H15l-.5-1zm4 2.5 1 1.5h-2l1-1.5zm-3 0 1 1.5h-2l1-1.5zm1.5 3L16 10h2l-1 1.5zM20 8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm-6 0c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm1 4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm4 0c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm-2 1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5z"
  }));
};
var TG = function TG(_ref221) {
  var title = _ref221.title,
      rest = _objectWithoutProperties(_ref221, _excluded221);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.337h512V153.6H0zM0 358.4h512v68.263H0zm0-136.537h512v68.263H0z",
    fill: "#496E2D"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h204.054v204.054H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "m102.026 133.938 13.26 40.812h42.916l-34.718 25.226 13.26 40.814-34.718-25.224-34.719 25.224 13.263-40.814-34.718-25.226h42.913z"
  }));
};
var TH = function TH(_ref222) {
  var title = _ref222.title,
      rest = _objectWithoutProperties(_ref222, _excluded222);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.334h512V426.66H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 194.056h512v123.882H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.334h512v54.522H0zm0 286.809h512v54.522H0z",
    fill: "#D80027"
  }));
};
var TJ = function TJ(_ref223) {
  var title = _ref223.title,
      rest = _objectWithoutProperties(_ref223, _excluded223);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M0 312.888h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M226.318 300.522h59.364v-25.23l-11.873 5.937L256 263.421l-17.809 17.808-11.873-5.937zm-33.963-29.682 2.763 8.504h8.94l-7.233 5.255 2.763 8.502-7.233-5.255-7.234 5.255 2.763-8.502-7.233-5.255h8.94zm8.566-29.68 2.763 8.502h8.94l-7.233 5.255 2.763 8.504-7.233-5.256-7.234 5.256 2.763-8.504-7.233-5.255h8.94zm24.488-22.261 2.763 8.502h8.94l-7.233 5.255 2.763 8.504-7.233-5.256-7.234 5.256 2.763-8.504-7.233-5.255h8.94zm94.236 51.941-2.763 8.504h-8.94l7.233 5.255-2.763 8.502 7.233-5.255 7.234 5.255-2.763-8.502 7.233-5.255h-8.94zm-8.566-29.68-2.763 8.502h-8.94l7.233 5.255-2.763 8.504 7.233-5.256 7.234 5.256-2.763-8.504 7.233-5.255h-8.94zm-24.488-22.261-2.763 8.502h-8.94l7.233 5.255-2.763 8.504 7.233-5.256 7.234 5.256-2.763-8.504 7.233-5.255h-8.94zM256 207.767l2.763 8.503h8.941l-7.234 5.256 2.763 8.502-7.233-5.254-7.233 5.254 2.763-8.502-7.234-5.256h8.941z",
    fill: "#FFDA44"
  }));
};
var TK = function TK(_ref224) {
  var title = _ref224.title,
      rest = _objectWithoutProperties(_ref224, _excluded224);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m210.715 174.377 3.684 11.338h11.919l-9.643 7.006 3.684 11.337-9.644-7.007-9.644 7.007 3.684-11.337-9.645-7.006h11.921zm-93.899 107.594 4.605 14.172h14.9l-12.055 8.757 4.606 14.173-12.056-8.76-12.055 8.76 4.604-14.173-12.054-8.757h14.899zm27.88-162.292 4.604 14.172h14.901l-12.056 8.758 4.606 14.171-12.055-8.759-12.056 8.759 4.606-14.171-12.055-8.758h14.9zm-75.157 55.652 4.604 14.172h14.9l-12.055 8.758 4.606 14.171-12.055-8.758-12.056 8.758 4.606-14.171-12.055-8.758h14.9z",
    fill: "#FFF"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M483.386 354.503H117.801s109.234-88.562 310.593-220.938c.001 0-88.443 128.935 54.992 220.938zm-365.585 11.586c-11.177 0-11.195 17.37 0 17.37h365.585c11.177 0 11.195-17.37 0-17.37H117.801z",
    fill: "#FFDA44"
  }));
};
var TL = function TL(_ref225) {
  var title = _ref225.title,
      rest = _objectWithoutProperties(_ref225, _excluded225);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M256 256 0 90.691v44.242L155.826 256 0 377.067v44.242z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 90.691v330.618L189.217 256z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "m44.184 213.36 24.912 23.577 30.121-16.41-14.723 30.98 24.911 23.575-34.012-4.43L60.67 301.63l-6.296-33.716-34.012-4.43 30.119-16.408z"
  }));
};
var TM = function TM(_ref226) {
  var title = _ref226.title,
      rest = _objectWithoutProperties(_ref226, _excluded226);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#496E2D",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M357.208 183.679c8.397-23.404-1.036-48.858-21.281-61.536a52.131 52.131 0 0 1 10.884 2.621c27.002 9.688 41.038 39.428 31.35 66.431s-39.428 41.038-66.431 31.35a52.182 52.182 0 0 1-10.069-4.895c23.686 3.084 47.15-10.566 55.547-33.971zm-46.571-67.95-7.297 9.427-11.22-4.026 6.712 9.852-7.296 9.427 11.443-3.338 6.712 9.852.361-11.914 11.444-3.339-11.221-4.025z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m330.338 146.448-7.296 9.427-11.221-4.026 6.712 9.852-7.296 9.427 11.443-3.339 6.712 9.853.36-11.915 11.445-3.34-11.221-4.024zM275.9 126.916l-7.296 9.427-11.219-4.024 6.711 9.851-7.296 9.426 11.443-3.338 6.712 9.852.361-11.915 11.444-3.337-11.221-4.027zm-.799 35.189-7.296 9.427-11.221-4.026 6.712 9.852-7.296 9.427 11.444-3.338 6.711 9.852.362-11.915 11.443-3.338-11.22-4.026zm33.484 12.013-7.296 9.427-11.22-4.026 6.712 9.853-7.297 9.426 11.444-3.338 6.712 9.852.36-11.915 11.443-3.338-11.219-4.025z"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M83.478 85.337h89.043v341.326H83.478z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "m117.458 175.191-14.908-11.105v-15.705l14.908-11.105h21.084l14.908 11.105v15.705l-14.908 11.105z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M128 137.276h-10.542l-14.908 11.105v7.678H128zm0 37.915h10.542l14.908-11.105v-8.012H128z",
    fill: "#FF9811"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "m117.458 374.725-14.908-11.106v-15.704l14.908-11.105h21.084l14.908 11.105v15.704l-14.908 11.106z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M128 336.81h-10.542l-14.908 11.105v7.678H128zm0 37.915h10.542l14.908-11.106v-8.011H128z",
    fill: "#FF9811"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m117.458 274.957-14.908-11.105v-15.703l14.908-11.106h21.084l14.908 11.106v15.703l-14.908 11.105zm36.513 24.434h-6.493v-6.493h-11.411l-8.068-8.068-8.067 8.068h-11.41v6.493h-6.493v12.986h6.493v6.492h11.41l8.068 8.069 8.068-8.069h11.41v-6.492h6.493zm0-99.768h-6.493v-6.492h-11.411l-8.068-8.069-8.067 8.069h-11.41v6.492h-6.493v12.986h6.493v6.492h11.41l8.068 8.07 8.068-8.07h11.41v-6.492h6.493z",
    fill: "#496E2D"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M120.576 248.576h14.84v14.84h-14.84z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: 128,
    cy: 206.113,
    r: 7.421
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    cx: 128,
    cy: 305.887,
    r: 7.421
  })));
};
var TN = function TN(_ref227) {
  var title = _ref227.title,
      rest = _objectWithoutProperties(_ref227, _excluded227);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#FFF",
    cx: 256,
    cy: 255.994,
    r: 96
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m267.826 219.291 16.47 22.695 26.673-8.649-16.496 22.676 16.468 22.695-26.664-8.681-16.495 22.676.017-28.04-26.664-8.682 26.674-8.648z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M277.818 312.724c-31.33 0-56.727-25.397-56.727-56.727s25.397-56.727 56.727-56.727c9.769 0 18.96 2.47 26.985 6.819-12.589-12.31-29.804-19.909-48.803-19.909-38.558 0-69.818 31.259-69.818 69.818s31.26 69.818 69.818 69.818c18.999 0 36.215-7.599 48.803-19.909-8.026 4.347-17.216 6.817-26.985 6.817z"
  })));
};
var TO = function TO(_ref228) {
  var title = _ref228.title,
      rest = _objectWithoutProperties(_ref228, _excluded228);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h256v170.663H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M141.357 157.303V130.59h-26.714v26.713H87.93v26.713h26.713v26.713h26.714v-26.713h26.713v-26.713z"
  }));
};
var TR = function TR(_ref229) {
  var title = _ref229.title,
      rest = _objectWithoutProperties(_ref229, _excluded229);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#E30A17",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M259.7 118.6c-13.1-9.5-29-14.6-45.3-14.5-40.8 0-73.8 30.8-73.8 68.9s33.1 68.9 73.8 68.9c17.1 0 32.9-5.4 45.3-14.5-30 38.6-85.7 45.6-124.3 15.5s-45.6-85.7-15.5-124.3 85.7-45.6 124.3-15.5c5.8 4.5 11 9.8 15.5 15.5zm39.9 65.8-18.1 21.9 1.2-28.4-26.4-10.4 27.3-7.6 1.8-28.3 15.6 23.7 27.5-7.1-17.5 22 15.3 23.9-26.7-9.7z"
  }));
};
var TT = function TT(_ref230) {
  var title = _ref230.title,
      rest = _objectWithoutProperties(_ref230, _excluded230);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "m6.066 85.337 207.961 212.636 131.584 128.69h160.323L297.973 214.027 166.389 85.337z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M43.364 85.337 384.69 426.663h83.946L127.31 85.337z"
  }));
};
var TV = function TV(_ref231) {
  var title = _ref231.title,
      rest = _objectWithoutProperties(_ref231, _excluded231);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h900v600H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#00B2EE",
    d: "M0 300h450V0h450v600H0V300z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "m345.3 480.9 29.4 90.6-77.1-56H393l-77.1 56 29.4-90.6zM706.4 340l29.4 90.6-77.1-56H754l-77.1 56 29.5-90.6zm106.4-78.5 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zm0-224.1 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M449.9 0v206.3h-81l81 54V300h-39.7l-129-85.9V300H168.7v-85.9L39.7 300H0v-39.7l81-54H0V93.8h81L0 39.9V0h39.7l129 85.9V0h112.5v85.9L410.2 0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M253.1 0h-56.3v122H0v56.2h196.8V300h56.3V178.2h196.8V122H253.1z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#2E52B2",
    d: "M449.9 39.9v53.9h-81z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 300v-19.3l109.9-74.4h39.7L12.8 300zM12.8.1l136.8 93.7h-39.7L0 19.4V.1zm437.1.1v19.3L340 93.8h-39.7L437.1.2zM437.1 300l-136.8-93.7H340l109.9 74.4V300z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "m719.9 131.6 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zM584 187.7l29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zm30 242.9 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zM488 332l29.4 90.6-77.1-56h95.3l-77.1 56L488 332zm0 132 29.4 90.6-77.1-56h95.3l-77.1 56L488 464z"
  }));
};
var TW = function TW(_ref232) {
  var title = _ref232.title,
      rest = _objectWithoutProperties(_ref232, _excluded232);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337h256V256H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M186.435 170.669 162.558 181.9l12.714 23.125-25.927-4.961-3.286 26.192L128 206.993l-18.06 19.263-3.285-26.192-25.927 4.96 12.714-23.125-23.877-11.23 23.877-11.231-12.714-23.125 25.927 4.96 3.286-26.192L128 134.344l18.06-19.263 3.285 26.192 25.928-4.96-12.715 23.125z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#0052B4",
    cx: 128,
    cy: 170.674,
    r: 29.006
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M128 190.06c-10.692 0-19.391-8.7-19.391-19.391 0-10.692 8.7-19.391 19.391-19.391 10.692 0 19.391 8.7 19.391 19.391 0 10.691-8.699 19.391-19.391 19.391z"
  }));
};
var TZ = function TZ(_ref233) {
  var title = _ref233.title,
      rest = _objectWithoutProperties(_ref233, _excluded233);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M0 426.663V85.337h512"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M512 152.222V85.337H411.67L0 359.778v66.885h100.33z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M512 85.337v40.125L60.193 426.663H0v-40.125L451.807 85.337z"
  }));
};
var UA = function UA(_ref234) {
  var title = _ref234.title,
      rest = _objectWithoutProperties(_ref234, _excluded234);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.337h512V256H0z"
  }));
};
var UG = function UG(_ref235) {
  var title = _ref235.title,
      rest = _objectWithoutProperties(_ref235, _excluded235);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#232323",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 56.9h512v56.9H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D32300",
    d: "M0 113.8h512v56.9H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 227.6h512v56.9H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D32300",
    d: "M0 284.4h512v56.9H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#FFF",
    cx: 256,
    cy: 170.7,
    r: 80.7
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M234.5 127.5c.9-1.4-19.6-2-19.6-2 1.7-2.5 18.4-10.5 18.4-10.5s-.9-6 2.7-9.8l-4.5-9.8s7-3.4 18.4-3.4 19.9 7 21 13.1l-6.4 3.4c-.1 4.7 1.7 11.6-4.3 17.3-5.9 5.7-8.3 6.9-8.5 18.8 0 3.9 2.3 8.2 8.8 11.7 17.4 9.3 38.6 28.2 44.6 33.9 6.1 5.7 5.1 19.2 2.6 25.2s-12.1 14.3-14.3 13.6c-2.2-.6 1.2-9.2-3.5-11.6 0 0-8.9-7.6-16.8.6s-.2 25.2 3.9 28c4.1 2.8 1.7 5-1.9 5H247c-3.8 0-5.4-2.3-1.9-5 7.6-3.8 12.4-15.3 7.4-20.3-4.9-4.9-18.3 1.5-21.5 6.3-2.8 2.8-8.8 3.6-12.9-1.4s-4.1-10.4-1.1-12.5c7-4.8 0 0 .1-.1 0 0 11.9-8.6 29.9-9 3.9 0 4.8-2.2 2.2-4.8 0 0-30.9-27.4-28.1-44.2 3-18.3 20-26.3 13.4-32.5-1.3-1.8 0 0 0 0z"
  }));
};
var UM = function UM(_ref236) {
  var title = _ref236.title,
      rest = _objectWithoutProperties(_ref236, _excluded236);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 0h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.7h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513V342H0z",
    fill: "#D80027"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#2E52B2",
    d: "M0 0h256.5v184.1H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m47.8 138.9-4-12.8-4.4 12.8H26.2l10.7 7.7-4 12.8 10.9-7.9 10.6 7.9-4.1-12.8 10.9-7.7zm56.3 0-4.1-12.8-4.2 12.8H82.6l10.7 7.7-4 12.8 10.7-7.9 10.8 7.9-4-12.8 10.7-7.7zm56.5 0-4.3-12.8-4 12.8h-13.5l11 7.7-4.2 12.8 10.7-7.9 11 7.9-4.2-12.8 10.7-7.7zm56.2 0-4-12.8-4.2 12.8h-13.3l10.8 7.7-4 12.8 10.7-7.9 10.8 7.9-4.3-12.8 11-7.7zM100 75.3l-4.2 12.8H82.6L93.3 96l-4 12.6 10.7-7.8 10.8 7.8-4-12.6 10.7-7.9h-13.4zm-56.2 0-4.4 12.8H26.2L36.9 96l-4 12.6 10.9-7.8 10.6 7.8L50.3 96l10.9-7.9H47.8zm112.5 0-4 12.8h-13.5l11 7.9-4.2 12.6 10.7-7.8 11 7.8-4.2-12.6 10.7-7.9h-13.2zm56.5 0-4.2 12.8h-13.3l10.8 7.9-4 12.6 10.7-7.8 10.8 7.8-4.3-12.6 11-7.9h-13.5zm-169-50.6-4.4 12.6H26.2l10.7 7.9-4 12.7L43.8 50l10.6 7.9-4.1-12.7 10.9-7.9H47.8zm56.2 0-4.2 12.6H82.6l10.7 7.9-4 12.7L100 50l10.8 7.9-4-12.7 10.7-7.9h-13.4zm56.3 0-4 12.6h-13.5l11 7.9-4.2 12.7 10.7-7.9 11 7.9-4.2-12.7 10.7-7.9h-13.2zm56.5 0-4.2 12.6h-13.3l10.8 7.9-4 12.7 10.7-7.9 10.8 7.9-4.3-12.7 11-7.9h-13.5z",
    fill: "#FFF"
  }));
};
var US = function US(_ref237) {
  var title = _ref237.title,
      rest = _objectWithoutProperties(_ref237, _excluded237);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 0h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.7h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513V342H0z",
    fill: "#D80027"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#2E52B2",
    d: "M0 0h256.5v184.1H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m47.8 138.9-4-12.8-4.4 12.8H26.2l10.7 7.7-4 12.8 10.9-7.9 10.6 7.9-4.1-12.8 10.9-7.7zm56.3 0-4.1-12.8-4.2 12.8H82.6l10.7 7.7-4 12.8 10.7-7.9 10.8 7.9-4-12.8 10.7-7.7zm56.5 0-4.3-12.8-4 12.8h-13.5l11 7.7-4.2 12.8 10.7-7.9 11 7.9-4.2-12.8 10.7-7.7zm56.2 0-4-12.8-4.2 12.8h-13.3l10.8 7.7-4 12.8 10.7-7.9 10.8 7.9-4.3-12.8 11-7.7zM100 75.3l-4.2 12.8H82.6L93.3 96l-4 12.6 10.7-7.8 10.8 7.8-4-12.6 10.7-7.9h-13.4zm-56.2 0-4.4 12.8H26.2L36.9 96l-4 12.6 10.9-7.8 10.6 7.8L50.3 96l10.9-7.9H47.8zm112.5 0-4 12.8h-13.5l11 7.9-4.2 12.6 10.7-7.8 11 7.8-4.2-12.6 10.7-7.9h-13.2zm56.5 0-4.2 12.8h-13.3l10.8 7.9-4 12.6 10.7-7.8 10.8 7.8-4.3-12.6 11-7.9h-13.5zm-169-50.6-4.4 12.6H26.2l10.7 7.9-4 12.7L43.8 50l10.6 7.9-4.1-12.7 10.9-7.9H47.8zm56.2 0-4.2 12.6H82.6l10.7 7.9-4 12.7L100 50l10.8 7.9-4-12.7 10.7-7.9h-13.4zm56.3 0-4 12.6h-13.5l11 7.9-4.2 12.7 10.7-7.9 11 7.9-4.2-12.7 10.7-7.9h-13.2zm56.5 0-4.2 12.6h-13.3l10.8 7.9-4 12.7 10.7-7.9 10.8 7.9-4.3-12.7 11-7.9h-13.5z",
    fill: "#FFF"
  }));
};
var UY = function UY(_ref238) {
  var title = _ref238.title,
      rest = _objectWithoutProperties(_ref238, _excluded238);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 38h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0z",
    fill: "#0038a8"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h256.5v190H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FED443",
    d: "m128.3 138.7-15.1 22.6-3.8-26.9L86 148.2l8.2-25.9-27.2 2.2 18.6-19.8L60.3 95l25.4-9.7L67 65.5l27.1 2.3-8.2-25.9 23.4 13.8 3.9-26.9 15.1 22.6 15.1-22.6 3.8 26.9 23.4-13.8-8.2 25.9 27.1-2.2-18.6 19.8 25.4 9.7-25.4 9.7 18.6 19.8-27.1-2.2 8.2 25.9-23.4-13.8-3.9 26.9-15-22.7zm0-.5c23.9.9 44-17.6 44.9-41.5.9-23.9-17.6-44-41.5-44.9h-3.4c-23.9.8-42.6 20.8-41.8 44.6.6 22.8 19 41.1 41.8 41.8zm0-10.6c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.3 34-34 34z"
  }));
};
var UZ = function UZ(_ref239) {
  var title = _ref239.title,
      rest = _objectWithoutProperties(_ref239, _excluded239);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M0 322.783h512v103.88H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.337h512v104.515H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 210.877h512v89.656H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.337h512v104.515H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M188.688 137.589c0-15.984 11.234-29.339 26.236-32.614a33.531 33.531 0 0 0-7.155-.777c-18.442 0-33.391 14.949-33.391 33.391s14.949 33.391 33.391 33.391c2.458 0 4.85-.273 7.155-.777-15.002-3.275-26.236-16.63-26.236-32.614zm45.97 15.177 2.261 6.957h7.315l-5.918 4.301 2.261 6.956-5.919-4.3-5.918 4.3 2.261-6.956-5.918-4.301h7.315zm23.348 0 2.26 6.957h7.315l-5.918 4.301 2.261 6.956-5.918-4.3-5.918 4.3 2.26-6.956-5.917-4.301h7.314zm23.347 0 2.26 6.957h7.315l-5.917 4.301 2.26 6.956-5.918-4.3-5.918 4.3 2.26-6.956-5.918-4.301h7.315zm23.347 0 2.262 6.957h7.315l-5.919 4.301 2.261 6.956-5.919-4.3-5.918 4.3 2.262-6.956-5.919-4.301h7.314zm23.348 0 2.26 6.957h7.315l-5.918 4.301 2.261 6.956-5.918-4.3-5.918 4.3 2.26-6.956-5.917-4.301h7.314zm-70.042-24.284 2.26 6.956h7.315l-5.918 4.3 2.261 6.957-5.918-4.299-5.918 4.299 2.26-6.957-5.917-4.3h7.314zm23.347 0 2.26 6.956h7.315l-5.917 4.3 2.26 6.957-5.918-4.299-5.918 4.299 2.26-6.957-5.918-4.3h7.315zm23.347 0 2.262 6.956h7.315l-5.919 4.3 2.261 6.957-5.919-4.299-5.918 4.299 2.262-6.957-5.919-4.3h7.314zm23.348 0 2.26 6.956h7.315l-5.918 4.3 2.261 6.957-5.918-4.299-5.918 4.299 2.26-6.957-5.917-4.3h7.314zm-46.695-24.284 2.26 6.956h7.315l-5.917 4.3 2.26 6.957-5.918-4.3-5.918 4.3 2.26-6.957-5.918-4.3h7.315zm23.347 0 2.262 6.956h7.315l-5.919 4.3 2.261 6.957-5.919-4.3-5.918 4.3 2.262-6.957-5.919-4.3h7.314zm23.348 0 2.26 6.956h7.315l-5.918 4.3 2.261 6.957-5.918-4.3-5.918 4.3 2.26-6.957-5.917-4.3h7.314z",
    fill: "#FFF"
  }));
};
var VA = function VA(_ref240) {
  var title = _ref240.title,
      rest = _objectWithoutProperties(_ref240, _excluded240);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M256 85.331h256v341.337H256z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#ACABB1",
    d: "m321.353 233.837 32.073 42.43c-5.053 7.651-5.026 17.961.817 25.692 7.414 9.807 21.374 11.748 31.182 4.335 9.807-7.414 11.748-21.374 4.334-31.182-5.843-7.731-15.756-10.568-24.495-7.795l-49.988-66.129-11.838 8.949-17.759 13.424 17.899 23.677 17.775-13.401zm46.175 48.78a7.421 7.421 0 1 1 8.95 11.84 7.421 7.421 0 0 1-8.95-11.84z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "m376.367 247.24 17.899-23.677-17.759-13.424-11.838-8.949-49.988 66.129c-8.74-2.775-18.651.063-24.495 7.795-7.414 9.808-5.473 23.768 4.334 31.182 9.808 7.414 23.768 5.473 31.182-4.335 5.845-7.731 5.871-18.041.817-25.692l32.073-42.43 17.775 13.401zm-62.504 45.771a7.42 7.42 0 1 1-11.84-8.95 7.42 7.42 0 0 1 11.84 8.95z"
  }));
};
var VC = function VC(_ref241) {
  var title = _ref241.title,
      rest = _objectWithoutProperties(_ref241, _excluded241);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.331h170.663v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M341.337 85.331H512v341.337H341.337zM214.261 283.82l-33.393-50.086 33.392-50.087 33.392 50.087zm83.478 0-33.391-50.086 33.391-50.087 33.393 50.087zM256 350.603l-33.391-50.087L256 250.429l33.391 50.087z",
    fill: "#6DA544"
  }));
};
var VE = function VE(_ref242) {
  var title = _ref242.title,
      rest = _objectWithoutProperties(_ref242, _excluded242);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFCE00",
    d: "M0 0h22.5v5H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#203899",
    d: "M0 5h22.5v5H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D82B2B",
    d: "M0 10h22.5v5H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "m12.13 5.38.14.46.45.14-.39.27.01.48-.38-.29-.45.15.15-.44-.28-.38h.47zm-1.77 0 .27.39h.47l-.28.38.15.45-.45-.16-.38.28.01-.47-.39-.28.45-.13zm3.44.56-.01.48.39.27-.46.14-.14.45-.27-.38h-.48l.29-.38-.15-.45.45.16zm-5.11.02.4.27.44-.18-.13.46.3.36-.47.02-.26.4-.16-.44-.46-.12.37-.3zm6.55 1.17-.2.44.25.4-.47-.05-.31.36-.1-.46-.43-.18.41-.24.03-.47.35.31zm.19 1.12.21.43.47.07-.34.33.08.46-.42-.22-.42.22.08-.46-.34-.33.47-.07zM7 8.2l.21.43.47.06-.34.33.08.47L7 9.27l-.42.22.08-.47-.34-.33.47-.06zm.31-1.15.45.14.38-.29v.48l.39.26-.45.15-.13.46-.28-.38-.47.01.27-.38z"
  }));
};
var VG = function VG(_ref243) {
  var title = _ref243.title,
      rest = _objectWithoutProperties(_ref243, _excluded243);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.334h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M256 85.334V202.66h-46.069L256 233.38v22.617h-22.628L160 207.078v48.919H96v-48.919l-73.372 48.919H0V233.38l46.069-30.72H0v-64h46.069L0 107.951V85.334h22.628L96 134.241V85.334h64v48.907l73.372-48.907z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M144 85.33h-32v69.333H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.329v15.083l57.377 38.251H80zm256 0v15.083l-57.377 38.251H176z"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#2E52B2",
    d: "M256 107.951v30.712h-46.069z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.329v15.083l57.377 38.251H80zm256 0v15.083l-57.377 38.251H176z",
    fill: "#D80027"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#2E52B2",
    d: "M256 107.951v30.712h-46.069z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 255.997v-15.082l57.377-38.252H80zm256 0v-15.082l-57.377-38.252H176z",
    fill: "#D80027"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "m384 259.706-46.129 46.129c8.645 16.675 26.051 28.074 46.129 28.074s37.484-11.4 46.129-28.074L384 259.706z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M332.058 178.084v81.624c.001 39.759 51.942 51.941 51.942 51.941s51.941-12.182 51.942-51.942v-81.623H332.058z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M372.87 215.181h22.261v59.359H372.87z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#A2001D",
    cx: 384,
    cy: 215.181,
    r: 11.13
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M346.902 192.92h14.84v14.84h-14.84zm0 33.392h14.84v14.84h-14.84zm0 33.391h14.84v14.84h-14.84zm59.359-66.783h14.84v14.84h-14.84zm0 33.392h14.84v14.84h-14.84zm0 33.391h14.84v14.84h-14.84z",
    fill: "#FFDA44"
  }));
};
var VI = function VI(_ref244) {
  var title = _ref244.title,
      rest = _objectWithoutProperties(_ref244, _excluded244);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v341.3H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#1583C4",
    d: "m397.7 166.3-51 97.7c-1.1 2-.3 4.5 1.8 5.6 2 1.1 4.5.3 5.6-1.8l51-97.7c1-2.1.1-4.6-2-5.5-2-.9-4.3-.2-5.4 1.7z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#1583C4",
    d: "m404.9 188-57.8 75.4c-1.3 1.9-.8 4.5 1.1 5.8 1.7 1.2 4.1.9 5.5-.7l57.8-75.4c1.4-1.8 1.1-4.4-.8-5.8-1.8-1.5-4.4-1.1-5.8.7z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#1583C4",
    d: "m379 181.3-32.5 83.1c-.8 2.1.2 4.6 2.4 5.4 2.1.8 4.6-.2 5.4-2.4l32.5-83.1c.7-2.2-.4-4.5-2.6-5.3-2.1-.6-4.3.4-5.2 2.3z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#409347",
    d: "M122.1 171.9c.4 1.7 1.2 4.7 2.2 8.5 1.7 6.4 3.6 12.8 5.6 18.7 2.3 6.9 14.7 31.4 20.2 39.1 6.9 9.7 14.1 19.3 21.5 28.6 1.6 1.9 4.5 2.1 6.4.5 1.8-1.6 2.1-4.3.7-6.2-7.3-9.2-14.4-18.6-21.2-28.2-4.2-5.8-17.2-31.1-19-36.7-2.9-8.7-5.4-17.6-7.6-26.5-.5-2.4-2.9-4-5.3-3.5s-4 2.9-3.5 5.3c-.1.2 0 .3 0 .4z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#FFD836",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M297.1 114.9S279.5 42.8 261 42.8c-6.9 0-11.9-.6-15.4 6.4-.9 1.7-20.7-1.6-19.1 20.8.5 6.9 1.1-9.8 14.9-3.4 6.3 3-16.4 48.2-16.4 48.2h72.1z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m466.1 48.4-90.9 22c-75.3 18.3-42.1 44.4-42.1 44.4l-72.1 12-72.1-12s33.2-26.1-42.1-44.4l-90.9-22C43.1 45.3 38.1 51.8 45.3 63c0 0 106.6 104 126.8 112 20.2 8.1 40.8 0 40.8 0s-14.9 8.7-24 24c-9.2 15.3-4.6 34.7-38.9 40.2-5.5 6.6-5 14 2.9 19.9 7.9 5.8 72.1-48.1 72.1-48.1s-24 24.4-24 36.1c0 5.1 44.1 53.8 60.1 53.8s60.1-48.7 60.1-53.8c0-11.7-24-36.1-24-36.1s64.2 53.9 72.1 48.1 11.4-19.3 2.8-19.9c-28-1.8-29.7-24.9-38.9-40.2-9.2-15.3-24-24-24-24s20.6 8.1 40.8 0S476.7 63 476.7 63c7.2-11.2 2.3-17.7-10.6-14.6z"
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M201.3 111.8v80.3c0 45.7 59.7 59.7 59.7 59.7s59.7-14 59.7-59.7v-80.3H201.3z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M225.2 137.7V235c8.2 6 17 10.2 23.9 12.9V137.7h-23.9zm71.6 0V235c-8.2 6-17 10.2-23.9 12.9V137.7h23.9z",
    fill: "#D80027"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M201.3 111.8h119.4v37.9H201.3z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#1583C4",
    d: "m60.1 210.5-21.9-58.1H15.7l31.8 80.8h25.2l31.5-80.8H81.7zm391.4-58.6h18.9v81.7h-18.9z"
  }));
};
var VN = function VN(_ref245) {
  var title = _ref245.title,
      rest = _objectWithoutProperties(_ref245, _excluded245);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M196.641 85.337H0v341.326h512V85.337z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "m256 157.279 22.663 69.747H352l-59.332 43.106 22.664 69.749L256 296.774l-59.332 43.107 22.664-69.749L160 227.026h73.337z"
  }));
};
var VU = function VU(_ref246) {
  var title = _ref246.title,
      rest = _objectWithoutProperties(_ref246, _excluded246);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#6DA544",
    d: "M512 256v170.663H0L215.185 256z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M512 85.337V256H215.185L0 85.337z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M221.001 239.304 26.868 85.337H8.956l208.168 165.098H512v-11.131zM8.956 426.663h17.912l194.133-153.967H512v-11.131H217.124zM0 92.44v14.206L188.317 256 0 405.354v14.205L206.229 256z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
    fill: "#FFDA44"
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M8.956 85.337H0v7.103L206.229 256 0 419.559v7.104h8.956l208.168-165.098H512v-11.13H217.124z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M63.718 292.382v-14.295c14.265 0 25.87-11.606 25.87-25.869 0-10.092-8.211-18.303-18.304-18.303-6.875 0-12.469 5.593-12.469 12.469 0 4.397 3.577 7.974 7.974 7.974a4.514 4.514 0 0 0 4.508-4.508h14.295c0 10.368-8.435 18.804-18.802 18.804-12.279-.002-22.269-9.993-22.269-22.271 0-14.758 12.006-26.764 26.764-26.764 17.975 0 32.599 14.623 32.599 32.599 0 22.145-18.018 40.164-40.166 40.164z"
  })));
};
var WF = function WF(_ref247) {
  var title = _ref247.title,
      rest = _objectWithoutProperties(_ref247, _excluded247);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#ED2939",
    d: "M0 0h150v100H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#002395",
    d: "M0 0h20v44.33H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M20 0h20v44.33H20z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 3,
    d: "M0 44.33h62.75V0"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M108.08 43.29 87.96 23.17h40.25l-20.13 20.12zm-6.7 6.71L81.25 29.88v40.25L101.38 50zm6.7 6.71L87.96 76.83h40.25l-20.13-20.12zm6.71-6.71 20.13-20.13v40.25L114.79 50z"
  }));
};
var WS = function WS(_ref248) {
  var title = _ref248.title,
      rest = _objectWithoutProperties(_ref248, _excluded248);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h256v170.663H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m165.483 181.79 2.764 8.504h8.939l-7.232 5.254 2.763 8.503-7.234-5.255-7.233 5.255 2.763-8.503-7.233-5.254h8.94zm-44.904-66.783 4.606 14.173h14.9l-12.055 8.757 4.605 14.171-12.056-8.758-12.054 8.758 4.605-14.171-12.056-8.757h14.901zm44.522 14.841 4.606 14.172h14.9l-12.055 8.757 4.604 14.173-12.055-8.76-12.054 8.76 4.604-14.173-12.055-8.757h14.9zm-35.192 59.363 4.606 14.172h14.9l-12.055 8.758 4.604 14.171-12.055-8.759-12.054 8.759 4.604-14.171-12.055-8.758h14.9zm-39.01-37.103 4.605 14.173h14.9l-12.055 8.757 4.604 14.173-12.054-8.76-12.055 8.76 4.604-14.173-12.055-8.757h14.9z",
    fill: "#FFF"
  }));
};
var XK = function XK(_ref249) {
  var title = _ref249.title,
      rest = _objectWithoutProperties(_ref249, _excluded249);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.33"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h512v341.34H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "m220.72 42.63 7.95 16.11 17.77 2.58-12.86 12.54 3.04 17.7-15.9-8.36-15.9 8.36 3.03-17.7-12.86-12.54 17.78-2.58zm70.56-.06 7.95 16.1 17.78 2.59-12.86 12.53 3.03 17.71-15.9-8.36-15.9 8.36 3.04-17.71-12.86-12.53 17.77-2.59zm62.08 11.36 7.95 16.11 17.77 2.58-12.86 12.54 3.04 17.7-15.9-8.35-15.9 8.35 3.04-17.7-12.87-12.54 17.78-2.58zm63.01 18.3 7.95 16.11 17.77 2.59-12.86 12.53 3.04 17.71-15.9-8.36-15.9 8.36 3.03-17.71-12.86-12.53 17.78-2.59zm-257.73-18.3 7.95 16.11 17.78 2.58-12.87 12.54 3.04 17.7-15.9-8.35-15.9 8.35 3.04-17.7-12.86-12.54 17.77-2.58zm-63.01 18.3 7.95 16.11 17.78 2.59-12.86 12.53 3.03 17.71-15.9-8.36-15.9 8.36 3.04-17.71-12.86-12.53 17.77-2.59z",
    fill: "#FFF"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "m217.53 259.33-27.22-13.61-27.22-54.43h27.22l27.22-27.22 13.61-27.22 27.22-13.61 13.61 13.61 27.22 13.61v13.61l13.61 13.61 40.83 27.22L340 245.73l-40.83 40.83-13.61-27.22-40.83 27.22v27.22l-13.61-13.61-13.59-40.84z"
  }));
};
var YE = function YE(_ref250) {
  var title = _ref250.title,
      rest = _objectWithoutProperties(_ref250, _excluded250);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 312.888h512v113.775H0z"
  }));
};
var YT = function YT(_ref251) {
  var title = _ref251.title,
      rest = _objectWithoutProperties(_ref251, _excluded251);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 60"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 0h90v60H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    stroke: "#7f7f7f",
    strokeWidth: 0.25,
    fill: "#ABABAB",
    d: "M75.6 39.6c-1.1.7 0 1.8-.6 1.9-.6.1-1.5-1.4-.2-2.5 1.6-1.5 5.8 0 5.9 4.3 0 2.2-.9 6.8-7.2 6.8-7.6 0-11.4-5.7-11.4-11.4 0-4.8 3.7-13.5 6.5-14.6 3.1-1.2 6.7-3.5 6.8-5 0-.5-1.4-.1-3.3.9-3.1 1.7-6.6 2.5-6.6 1.4s2.9-3.1 4-4.6c1.2-1.6.9-5.5 3-5.5 7.6 0 9.9 7.7 7 11.7-1.9 2.6 4.3 1 4.3 1s0 5.3-3.2 7.3c-3 1.8-4.8 3.9-4.8 3.9s.2-4.6-.5-3.9c-.6.7-11.1 4.5-10.3 12 .3 3 4.5 5.4 8.5 5.2s5.7-2.4 5.8-4.9c.1-3.9-3-4.4-3.7-4zm-64.9 4c.1 2.5 1.8 4.7 5.8 4.9s8.2-2.2 8.5-5.2c.8-7.5-9.7-11.3-10.3-12-.7-.7-.5 3.9-.5 3.9s-1.8-2.1-4.8-3.9c-3.2-2-3.2-7.3-3.2-7.3s6.2 1.6 4.3-1c-2.9-4-.6-11.7 7-11.7 2.1 0 1.8 3.9 3 5.5 1.1 1.5 4 3.5 4 4.6s-3.5.3-6.6-1.4c-1.9-1-3.3-1.4-3.3-.9.1 1.5 3.7 3.8 6.8 5 2.8 1.1 6.5 9.8 6.5 14.6 0 5.7-3.8 11.4-11.4 11.4-6.3 0-7.2-4.6-7.2-6.8.1-4.3 4.3-5.8 5.9-4.3 1.2 1.1.4 2.7-.2 2.5-.6-.1.6-1.2-.6-1.9-.6-.4-3.7.1-3.7 4z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#DE393A",
    d: "M31 28.8v14c0 1.9 2.1 1.6 2.1 1.6h9.3c1.2 0 2.6 2.3 2.6 2.3s1.4-2.3 2.5-2.3h9.6s2 .2 2-1.8V28.7H31z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#3951A3",
    d: "M31 13.1h28v15.7H31z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M50.1 16.5c-.4 2.4-2.5 4.2-5.1 4.2-2.5 0-4.6-1.8-5.1-4.2-.5.9-.8 1.9-.8 3 0 3.3 2.6 5.9 5.9 5.9 3.3 0 5.9-2.6 5.9-5.9 0-1.1-.3-2.1-.8-3z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#FEE05F",
    cx: 39.1,
    cy: 36.5,
    r: 3
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
    fill: "#FEE05F",
    cx: 50.9,
    cy: 36.5,
    r: 3
  }));
};
var ZA = function ZA(_ref252) {
  var title = _ref252.title,
      rest = _objectWithoutProperties(_ref252, _excluded252);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M114.024 256.001 0 141.926v228.17z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#ffb915",
    d: "M161.192 256 0 94.7v47.226l114.024 114.075L0 370.096v47.138z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#007847",
    d: "M509.833 289.391c.058-.44.804-.878 2.167-1.318v-65.464H222.602L85.33 85.337H0V94.7L161.192 256 0 417.234v9.429h85.33l137.272-137.272h287.231z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#000c8a",
    d: "M503.181 322.783H236.433l-103.881 103.88H512v-103.88z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#e1392d",
    d: "M503.181 189.217H512V85.337H132.552l103.881 103.88z"
  }));
};
var ZM = function ZM(_ref253) {
  var title = _ref253.title,
      rest = _objectWithoutProperties(_ref253, _excluded253);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#496E2D",
    d: "M0 85.331h512v341.337H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FF9811",
    d: "M490.668 195.476h-48c0-8.836-7.164-16-16-16s-16 7.164-16 16h-48c0 8.836 7.697 16 16.533 16h-.533c0 8.836 7.162 16 16 16 0 8.836 7.162 16 16 16h32c8.836 0 16-7.164 16-16 8.836 0 16-7.164 16-16h-.533c8.837 0 16.533-7.164 16.533-16z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "M341.337 255.994h56.888v170.663h-56.888z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FF9811",
    d: "M455.112 255.994H512v170.663h-56.888z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M398.225 255.994h56.888v170.663h-56.888z"
  }));
};
var ZW = function ZW(_ref254) {
  var title = _ref254.title,
      rest = _objectWithoutProperties(_ref254, _excluded254);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, rest), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title", null, title), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 85.333h512V426.67H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 134.196h512v48.868H0zm0 195.472h512v48.868H0z",
    fill: "#FFDA44"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#057f44",
    d: "M0 85.333h512v48.868H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M0 183.069h512v48.868H0zm0 97.737h512v48.868H0z",
    fill: "#D80027"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#057f44",
    d: "M0 378.542h512v48.128H0z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFF",
    d: "M276.992 255.996 106.329 426.659H0V85.333h106.329z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    d: "M256 255.996 85.334 426.662h20.987l170.667-170.666L106.321 85.33H85.334z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#D80027",
    d: "m102.465 202.57 13.259 40.812h42.917l-34.718 25.226 13.26 40.814-34.718-25.224-34.72 25.224 13.262-40.814-34.718-25.226h42.915z"
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
    fill: "#FFDA44",
    d: "m138.94 259.335-34.559-12.243s-2.553-23.955-2.708-24.766c-1.173-6.18-6.603-10.851-13.123-10.851-7.376 0-13.357 5.98-13.357 13.357 0 1.223.178 2.402.486 3.528l-9.689 9.755h17.229c0 17.882-13.344 17.882-13.344 35.691l7.402 17.809h44.522l7.422-17.809h-.004a17.782 17.782 0 0 0 1.381-5.231c6.397-2.589 8.342-9.24 8.342-9.24z"
  }));
};
/* unused harmony default export */ var _unused_webpack_default_export = ({
  AC: AC,
  AD: AD,
  AE: AE,
  AF: AF,
  AG: AG,
  AI: AI,
  AL: AL,
  AM: AM,
  AO: AO,
  AQ: AQ,
  AR: AR,
  AS: AS,
  AT: AT,
  AU: AU,
  AW: AW,
  AX: AX,
  AZ: AZ,
  BA: BA,
  BB: BB,
  BD: BD,
  BE: BE,
  BF: BF,
  BG: BG,
  BH: BH,
  BI: BI,
  BJ: BJ,
  BL: BL,
  BM: BM,
  BN: BN,
  BO: BO,
  BQ: BQ,
  BR: BR,
  BS: BS,
  BT: BT,
  BV: BV,
  BW: BW,
  BY: BY,
  BZ: BZ,
  CA: CA,
  CC: CC,
  CD: CD,
  CF: CF,
  CG: CG,
  CH: CH,
  CI: CI,
  CK: CK,
  CL: CL,
  CM: CM,
  CN: CN,
  CO: CO,
  CR: CR,
  CU: CU,
  CV: CV,
  CW: CW,
  CX: CX,
  CY: CY,
  CZ: CZ,
  DE: DE,
  DJ: DJ,
  DK: DK,
  DM: DM,
  DO: DO,
  DZ: DZ,
  EC: EC,
  EE: EE,
  EG: EG,
  EH: EH,
  ER: ER,
  ES: ES,
  ET: ET,
  EU: EU,
  FI: FI,
  FJ: FJ,
  FK: FK,
  FM: FM,
  FO: FO,
  FR: FR,
  GA: GA,
  GB: GB,
  GD: GD,
  GE: GE,
  GF: GF,
  GG: GG,
  GH: GH,
  GI: GI,
  GL: GL,
  GM: GM,
  GN: GN,
  GP: GP,
  GQ: GQ,
  GR: GR,
  GS: GS,
  GT: GT,
  GU: GU,
  GW: GW,
  GY: GY,
  HK: HK,
  HM: HM,
  HN: HN,
  HR: HR,
  HT: HT,
  HU: HU,
  IC: IC,
  ID: ID,
  IE: IE,
  IL: IL,
  IM: IM,
  IN: IN,
  IO: IO,
  IQ: IQ,
  IR: IR,
  IS: IS,
  IT: IT,
  JE: JE,
  JM: JM,
  JO: JO,
  JP: JP,
  KE: KE,
  KG: KG,
  KH: KH,
  KI: KI,
  KM: KM,
  KN: KN,
  KP: KP,
  KR: KR,
  KW: KW,
  KY: KY,
  KZ: KZ,
  LA: LA,
  LB: LB,
  LC: LC,
  LI: LI,
  LK: LK,
  LR: LR,
  LS: LS,
  LT: LT,
  LU: LU,
  LV: LV,
  LY: LY,
  MA: MA,
  MC: MC,
  MD: MD,
  ME: ME,
  MF: MF,
  MG: MG,
  MH: MH,
  MK: MK,
  ML: ML,
  MM: MM,
  MN: MN,
  MO: MO,
  MP: MP,
  MQ: MQ,
  MR: MR,
  MS: MS,
  MT: MT,
  MU: MU,
  MV: MV,
  MW: MW,
  MX: MX,
  MY: MY,
  MZ: MZ,
  NA: NA,
  NC: NC,
  NE: NE,
  NF: NF,
  NG: NG,
  NI: NI,
  NL: NL,
  NO: NO,
  NP: NP,
  NR: NR,
  NU: NU,
  NZ: NZ,
  OM: OM,
  PA: PA,
  PE: PE,
  PF: PF,
  PG: PG,
  PH: PH,
  PK: PK,
  PL: PL,
  PM: PM,
  PN: PN,
  PR: PR,
  PS: PS,
  PT: PT,
  PW: PW,
  PY: PY,
  QA: QA,
  RE: RE,
  RO: RO,
  RS: RS,
  RU: RU,
  RW: RW,
  SA: SA,
  SB: SB,
  SC: SC,
  SD: SD,
  SE: SE,
  SG: SG,
  SH: SH,
  SI: SI,
  SJ: SJ,
  SK: SK,
  SL: SL,
  SM: SM,
  SN: SN,
  SO: SO,
  SR: SR,
  SS: SS,
  ST: ST,
  SV: SV,
  SX: SX,
  SY: SY,
  SZ: SZ,
  TA: TA,
  TC: TC,
  TD: TD,
  TF: TF,
  TG: TG,
  TH: TH,
  TJ: TJ,
  TK: TK,
  TL: TL,
  TM: TM,
  TN: TN,
  TO: TO,
  TR: TR,
  TT: TT,
  TV: TV,
  TW: TW,
  TZ: TZ,
  UA: UA,
  UG: UG,
  UM: UM,
  US: US,
  UY: UY,
  UZ: UZ,
  VA: VA,
  VC: VC,
  VE: VE,
  VG: VG,
  VI: VI,
  VN: VN,
  VU: VU,
  WF: WF,
  WS: WS,
  XK: XK,
  YE: YE,
  YT: YT,
  ZA: ZA,
  ZM: ZM,
  ZW: ZW
});
//# sourceMappingURL=index.js.map

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_react_3x2_index_js__ = __webpack_require__(1037);
/* unused harmony reexport AC */
/* unused harmony reexport AD */
/* unused harmony reexport AE */
/* unused harmony reexport AF */
/* unused harmony reexport AG */
/* unused harmony reexport AI */
/* unused harmony reexport AL */
/* unused harmony reexport AM */
/* unused harmony reexport AO */
/* unused harmony reexport AQ */
/* unused harmony reexport AR */
/* unused harmony reexport AS */
/* unused harmony reexport AT */
/* unused harmony reexport AU */
/* unused harmony reexport AW */
/* unused harmony reexport AX */
/* unused harmony reexport AZ */
/* unused harmony reexport BA */
/* unused harmony reexport BB */
/* unused harmony reexport BD */
/* unused harmony reexport BE */
/* unused harmony reexport BF */
/* unused harmony reexport BG */
/* unused harmony reexport BH */
/* unused harmony reexport BI */
/* unused harmony reexport BJ */
/* unused harmony reexport BL */
/* unused harmony reexport BM */
/* unused harmony reexport BN */
/* unused harmony reexport BO */
/* unused harmony reexport BQ */
/* unused harmony reexport BR */
/* unused harmony reexport BS */
/* unused harmony reexport BT */
/* unused harmony reexport BV */
/* unused harmony reexport BW */
/* unused harmony reexport BY */
/* unused harmony reexport BZ */
/* unused harmony reexport CA */
/* unused harmony reexport CC */
/* unused harmony reexport CD */
/* unused harmony reexport CF */
/* unused harmony reexport CG */
/* unused harmony reexport CH */
/* unused harmony reexport CI */
/* unused harmony reexport CK */
/* unused harmony reexport CL */
/* unused harmony reexport CM */
/* unused harmony reexport CN */
/* unused harmony reexport CO */
/* unused harmony reexport CR */
/* unused harmony reexport CU */
/* unused harmony reexport CV */
/* unused harmony reexport CW */
/* unused harmony reexport CX */
/* unused harmony reexport CY */
/* unused harmony reexport CZ */
/* unused harmony reexport DE */
/* unused harmony reexport DJ */
/* unused harmony reexport DK */
/* unused harmony reexport DM */
/* unused harmony reexport DO */
/* unused harmony reexport DZ */
/* unused harmony reexport EC */
/* unused harmony reexport EE */
/* unused harmony reexport EG */
/* unused harmony reexport EH */
/* unused harmony reexport ER */
/* unused harmony reexport ES */
/* unused harmony reexport ET */
/* unused harmony reexport EU */
/* unused harmony reexport FI */
/* unused harmony reexport FJ */
/* unused harmony reexport FK */
/* unused harmony reexport FM */
/* unused harmony reexport FO */
/* unused harmony reexport FR */
/* unused harmony reexport GA */
/* unused harmony reexport GB */
/* unused harmony reexport GD */
/* unused harmony reexport GE */
/* unused harmony reexport GF */
/* unused harmony reexport GG */
/* unused harmony reexport GH */
/* unused harmony reexport GI */
/* unused harmony reexport GL */
/* unused harmony reexport GM */
/* unused harmony reexport GN */
/* unused harmony reexport GP */
/* unused harmony reexport GQ */
/* unused harmony reexport GR */
/* unused harmony reexport GS */
/* unused harmony reexport GT */
/* unused harmony reexport GU */
/* unused harmony reexport GW */
/* unused harmony reexport GY */
/* unused harmony reexport HK */
/* unused harmony reexport HM */
/* unused harmony reexport HN */
/* unused harmony reexport HR */
/* unused harmony reexport HT */
/* unused harmony reexport HU */
/* unused harmony reexport IC */
/* unused harmony reexport ID */
/* unused harmony reexport IE */
/* unused harmony reexport IL */
/* unused harmony reexport IM */
/* unused harmony reexport IN */
/* unused harmony reexport IO */
/* unused harmony reexport IQ */
/* unused harmony reexport IR */
/* unused harmony reexport IS */
/* unused harmony reexport IT */
/* unused harmony reexport JE */
/* unused harmony reexport JM */
/* unused harmony reexport JO */
/* unused harmony reexport JP */
/* unused harmony reexport KE */
/* unused harmony reexport KG */
/* unused harmony reexport KH */
/* unused harmony reexport KI */
/* unused harmony reexport KM */
/* unused harmony reexport KN */
/* unused harmony reexport KP */
/* unused harmony reexport KR */
/* unused harmony reexport KW */
/* unused harmony reexport KY */
/* unused harmony reexport KZ */
/* unused harmony reexport LA */
/* unused harmony reexport LB */
/* unused harmony reexport LC */
/* unused harmony reexport LI */
/* unused harmony reexport LK */
/* unused harmony reexport LR */
/* unused harmony reexport LS */
/* unused harmony reexport LT */
/* unused harmony reexport LU */
/* unused harmony reexport LV */
/* unused harmony reexport LY */
/* unused harmony reexport MA */
/* unused harmony reexport MC */
/* unused harmony reexport MD */
/* unused harmony reexport ME */
/* unused harmony reexport MF */
/* unused harmony reexport MG */
/* unused harmony reexport MH */
/* unused harmony reexport MK */
/* unused harmony reexport ML */
/* unused harmony reexport MM */
/* unused harmony reexport MN */
/* unused harmony reexport MO */
/* unused harmony reexport MP */
/* unused harmony reexport MQ */
/* unused harmony reexport MR */
/* unused harmony reexport MS */
/* unused harmony reexport MT */
/* unused harmony reexport MU */
/* unused harmony reexport MV */
/* unused harmony reexport MW */
/* unused harmony reexport MX */
/* unused harmony reexport MY */
/* unused harmony reexport MZ */
/* unused harmony reexport NA */
/* unused harmony reexport NC */
/* unused harmony reexport NE */
/* unused harmony reexport NF */
/* unused harmony reexport NG */
/* unused harmony reexport NI */
/* unused harmony reexport NL */
/* unused harmony reexport NO */
/* unused harmony reexport NP */
/* unused harmony reexport NR */
/* unused harmony reexport NU */
/* unused harmony reexport NZ */
/* unused harmony reexport OM */
/* unused harmony reexport PA */
/* unused harmony reexport PE */
/* unused harmony reexport PF */
/* unused harmony reexport PG */
/* unused harmony reexport PH */
/* unused harmony reexport PK */
/* unused harmony reexport PL */
/* unused harmony reexport PM */
/* unused harmony reexport PN */
/* unused harmony reexport PR */
/* unused harmony reexport PS */
/* unused harmony reexport PT */
/* unused harmony reexport PW */
/* unused harmony reexport PY */
/* unused harmony reexport QA */
/* unused harmony reexport RE */
/* unused harmony reexport RO */
/* unused harmony reexport RS */
/* unused harmony reexport RU */
/* unused harmony reexport RW */
/* unused harmony reexport SA */
/* unused harmony reexport SB */
/* unused harmony reexport SC */
/* unused harmony reexport SD */
/* unused harmony reexport SE */
/* unused harmony reexport SG */
/* unused harmony reexport SH */
/* unused harmony reexport SI */
/* unused harmony reexport SJ */
/* unused harmony reexport SK */
/* unused harmony reexport SL */
/* unused harmony reexport SM */
/* unused harmony reexport SN */
/* unused harmony reexport SO */
/* unused harmony reexport SR */
/* unused harmony reexport SS */
/* unused harmony reexport ST */
/* unused harmony reexport SV */
/* unused harmony reexport SX */
/* unused harmony reexport SY */
/* unused harmony reexport SZ */
/* unused harmony reexport TA */
/* unused harmony reexport TC */
/* unused harmony reexport TD */
/* unused harmony reexport TF */
/* unused harmony reexport TG */
/* unused harmony reexport TH */
/* unused harmony reexport TJ */
/* unused harmony reexport TK */
/* unused harmony reexport TL */
/* unused harmony reexport TM */
/* unused harmony reexport TN */
/* unused harmony reexport TO */
/* unused harmony reexport TR */
/* unused harmony reexport TT */
/* unused harmony reexport TV */
/* unused harmony reexport TW */
/* unused harmony reexport TZ */
/* unused harmony reexport UA */
/* unused harmony reexport UG */
/* unused harmony reexport UM */
/* unused harmony reexport US */
/* unused harmony reexport UY */
/* unused harmony reexport UZ */
/* unused harmony reexport VA */
/* unused harmony reexport VC */
/* unused harmony reexport VE */
/* unused harmony reexport VG */
/* unused harmony reexport VI */
/* unused harmony reexport VN */
/* unused harmony reexport VU */
/* unused harmony reexport WF */
/* unused harmony reexport WS */
/* unused harmony reexport XK */
/* unused harmony reexport YE */
/* unused harmony reexport YT */
/* unused harmony reexport ZA */
/* unused harmony reexport ZM */
/* unused harmony reexport ZW */
/* unused harmony reexport default */


/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pairs__ = __webpack_require__(459);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = __WEBPACK_IMPORTED_MODULE_0__pairs__["a" /* pair */];

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
});


/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisect__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__range__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ticks__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__ = __webpack_require__(461);









/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */],
      domain = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */],
      threshold = __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__["a" /* default */];

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__ticks__["a" /* tickStep */])(x0, x1, tz);
      tz = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__range__["a" /* default */])(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__bisect__["a" /* default */])(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(_)) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : threshold;
  };

  return histogram;
});


/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
});


/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(160);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
});


/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quantile__ = __webpack_require__(289);




/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__quantile__["a" /* default */])(numbers.sort(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]), 0.5);
});


/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
});


/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
});


/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(115);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = __WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */];

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
});


/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
});


/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
});


/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quantile__ = __webpack_require__(289);





/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  values = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(values, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]).sort(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" /* default */]);
  return Math.ceil((max - min) / (2 * (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.75) - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.25)) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deviation__ = __webpack_require__(456);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__deviation__["a" /* default */])(values) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transpose__ = __webpack_require__(463);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__transpose__["a" /* default */])(arguments);
});


/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
});


/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nest__ = __webpack_require__(1058);
/* unused harmony reexport nest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__set__ = __webpack_require__(1059);
/* unused harmony reexport set */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__map__ = __webpack_require__(290);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__map__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__keys__ = __webpack_require__(1057);
/* unused harmony reexport keys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__values__ = __webpack_require__(1060);
/* unused harmony reexport values */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__entries__ = __webpack_require__(1055);
/* unused harmony reexport entries */








/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
});


/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(290);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var keys = [],
      sortKeys = [],
      sortValues,
      rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) {
      if (sortValues != null) array.sort(sortValues);
      return rollup != null ? rollup(array) : array;
    }

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function(values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function entries(map, depth) {
    if (++depth > keys.length) return map;
    var array, sortKey = sortKeys[depth - 1];
    if (rollup != null && depth >= keys.length) array = map.entries();
    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
  }

  return nest = {
    object: function(array) { return apply(array, 0, createObject, setObject); },
    map: function(array) { return apply(array, 0, createMap, setMap); },
    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
    key: function(d) { keys.push(d); return nest; },
    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
    sortValues: function(order) { sortValues = order; return nest; },
    rollup: function(f) { rollup = f; return nest; }
  };
});

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])();
}

function setMap(map, key, value) {
  map.set(key, value);
}


/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(290);


function Set() {}

var proto = __WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */].prototype;

Set.prototype = set.prototype = {
  constructor: Set,
  has: proto.has,
  add: function(value) {
    value += "";
    this[__WEBPACK_IMPORTED_MODULE_0__map__["b" /* prefix */] + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set(object, f) {
  var set = new Set;

  // Copy constructor.
  if (object instanceof Set) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

/* unused harmony default export */ var _unused_webpack_default_export = (set);


/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
});


/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubehelix;
/* unused harmony export Cubehelix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define_js__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math_js__ = __webpack_require__(465);




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* Rgb */])) o = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["b" /* rgbConvert */])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* rad2deg */] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Cubehelix, cubehelix, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color_js__["c" /* Color */], {
  brighter: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color_js__["d" /* brighter */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color_js__["d" /* brighter */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color_js__["e" /* darker */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color_js__["e" /* darker */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math_js__["b" /* deg2rad */],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new __WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* Rgb */](
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));


/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gray */
/* harmony export (immutable) */ __webpack_exports__["b"] = lab;
/* unused harmony export Lab */
/* unused harmony export lch */
/* harmony export (immutable) */ __webpack_exports__["a"] = hcl;
/* unused harmony export Hcl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define_js__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math_js__ = __webpack_require__(465);




// https://observablehq.com/@mbostock/lab-and-rgb
var K = 18,
    Xn = 0.96422,
    Yn = 1,
    Zn = 0.82521,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) return hcl2lab(o);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* Rgb */])) o = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["b" /* rgbConvert */])(o);
  var r = rgb2lrgb(o.r),
      g = rgb2lrgb(o.g),
      b = rgb2lrgb(o.b),
      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
  if (r === g && g === b) x = z = y; else {
    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
  }
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function gray(l, opacity) {
  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Lab, lab, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color_js__["c" /* Color */], {
  brighter: function(k) {
    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    x = Xn * lab2xyz(x);
    y = Yn * lab2xyz(y);
    z = Zn * lab2xyz(z);
    return new __WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* Rgb */](
      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function lrgb2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2lrgb(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
  var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* rad2deg */];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function lch(l, c, h, opacity) {
  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

function hcl2lab(o) {
  if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
  var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math_js__["b" /* deg2rad */];
  return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["a" /* default */])(Hcl, hcl, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__define_js__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color_js__["c" /* Color */], {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return hcl2lab(this).rgb();
  }
}));


/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatPrefix; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_js__ = __webpack_require__(469);


var locale;
var format;
var formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""],
  minus: "-"
});

function defaultLocale(definition) {
  locale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__locale_js__["a" /* default */])(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}


/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
});


/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
});


/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__ = __webpack_require__(188);


/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["a" /* formatDecimalParts */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
});


/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
/* harmony default export */ __webpack_exports__["a"] = (function(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      default: if (!+s[i]) break out; if (i0 > 0) i0 = 0; break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
});


/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto_js__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatRounded_js__ = __webpack_require__(1066);




/* harmony default export */ __webpack_exports__["a"] = ({
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": __WEBPACK_IMPORTED_MODULE_0__formatDecimal_js__["b" /* default */],
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__formatRounded_js__["a" /* default */])(x * 100, p); },
  "r": __WEBPACK_IMPORTED_MODULE_2__formatRounded_js__["a" /* default */],
  "s": __WEBPACK_IMPORTED_MODULE_1__formatPrefixAuto_js__["b" /* default */],
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
});


/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent_js__ = __webpack_require__(187);


/* harmony default export */ __webpack_exports__["a"] = (function(step) {
  return Math.max(0, -__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent_js__ = __webpack_require__(187);


/* harmony default export */ __webpack_exports__["a"] = (function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(value) / 3))) * 3 - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent_js__ = __webpack_require__(187);


/* harmony default export */ __webpack_exports__["a"] = (function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(max) - __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__exponent_js__["a" /* default */])(step)) + 1;
});


/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export cubehelixLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(117);



function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* cubehelix */])(end)).h),
          s = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.s, end.s),
          l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.l, end.l),
          opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

/* unused harmony default export */ var _unused_webpack_default_export = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color_js__["b" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */]);


/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
});


/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(117);



function hcl(hue) {
  return function(start, end) {
    var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* hcl */])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* hcl */])(end)).h),
        c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.c, end.c),
        l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.l, end.l),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hcl(__WEBPACK_IMPORTED_MODULE_1__color_js__["b" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */]);


/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(117);



function hsl(hue) {
  return function(start, end) {
    var h = hue((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(start)).h, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(end)).h),
        s = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.s, end.s),
        l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.l, end.l),
        opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (hsl(__WEBPACK_IMPORTED_MODULE_1__color_js__["b" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */]);


/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color_js__ = __webpack_require__(117);


/* unused harmony default export */ var _unused_webpack_default_export = (function(a, b) {
  var i = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__color_js__["b" /* hue */])(+a, +b);
  return function(t) {
    var x = i(t);
    return x - 360 * Math.floor(x / 360);
  };
});


/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value_js__ = __webpack_require__(295);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__value_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array_js__ = __webpack_require__(470);
/* unused harmony reexport interpolateArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basis_js__ = __webpack_require__(293);
/* unused harmony reexport interpolateBasis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__basisClosed_js__ = __webpack_require__(471);
/* unused harmony reexport interpolateBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__date_js__ = __webpack_require__(473);
/* unused harmony reexport interpolateDate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__discrete_js__ = __webpack_require__(1074);
/* unused harmony reexport interpolateDiscrete */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hue_js__ = __webpack_require__(1077);
/* unused harmony reexport interpolateHue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__number_js__ = __webpack_require__(189);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_7__number_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__numberArray_js__ = __webpack_require__(294);
/* unused harmony reexport interpolateNumberArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__object_js__ = __webpack_require__(474);
/* unused harmony reexport interpolateObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__round_js__ = __webpack_require__(1082);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_10__round_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__string_js__ = __webpack_require__(476);
/* unused harmony reexport interpolateString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__transform_index_js__ = __webpack_require__(1084);
/* unused harmony reexport interpolateTransformCss */
/* unused harmony reexport interpolateTransformSvg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__zoom_js__ = __webpack_require__(1086);
/* unused harmony reexport interpolateZoom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__rgb_js__ = __webpack_require__(475);
/* unused harmony reexport interpolateRgb */
/* unused harmony reexport interpolateRgbBasis */
/* unused harmony reexport interpolateRgbBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__hsl_js__ = __webpack_require__(1076);
/* unused harmony reexport interpolateHsl */
/* unused harmony reexport interpolateHslLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lab_js__ = __webpack_require__(1079);
/* unused harmony reexport interpolateLab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__hcl_js__ = __webpack_require__(1075);
/* unused harmony reexport interpolateHcl */
/* unused harmony reexport interpolateHclLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__cubehelix_js__ = __webpack_require__(1073);
/* unused harmony reexport interpolateCubehelix */
/* unused harmony reexport interpolateCubehelixLong */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__piecewise_js__ = __webpack_require__(1080);
/* unused harmony reexport piecewise */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__quantize_js__ = __webpack_require__(1081);
/* unused harmony reexport quantize */























/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color_js__ = __webpack_require__(117);



function lab(start, end) {
  var l = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])((start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* lab */])(start)).l, (end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* lab */])(end)).l),
      a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.a, end.a),
      b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.b, end.b),
      opacity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__color_js__["a" /* default */])(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}


/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
function piecewise(interpolate, values) {
  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
  while (i < n) I[i] = interpolate(v, v = values[++i]);
  return function(t) {
    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
    return I[i](t - i);
  };
}


/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});


/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b = +b, function(t) {
    return Math.round(a * (1 - t) + b * t);
  };
});


/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ __webpack_exports__["b"] = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});


/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export interpolateTransformCss */
/* unused harmony export interpolateTransformSvg */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse_js__ = __webpack_require__(1085);



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(xa, xb)}, {i: i - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(xa, xb)}, {i: i - 2, x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__number_js__["a" /* default */])(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse_js__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse_js__["b" /* parseSvg */], ", ", ")", ")");


/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose_js__ = __webpack_require__(1083);


var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose_js__["a" /* identity */];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__decompose_js__["b" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose_js__["a" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose_js__["a" /* identity */];
  value = value.matrix;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__decompose_js__["b" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}


/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* unused harmony default export */ var _unused_webpack_default_export = (function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    }
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    }
  }

  i.duration = S * 1000;

  return i;
});


/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pi = Math.PI,
    tau = 2 * pi,
    epsilon = 1e-6,
    tauEpsilon = tau - epsilon;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon));

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r, ccw = !!ccw;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau + tau;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (path);


/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = band;
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__init__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ordinal__ = __webpack_require__(480);




function band() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__ordinal__["a" /* default */])().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* range */])(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band(domain(), range)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return __WEBPACK_IMPORTED_MODULE_1__init__["b" /* initRange */].apply(rescale(), arguments);
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band.apply(null, arguments).paddingInner(1));
}


/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = diverging;
/* harmony export (immutable) */ __webpack_exports__["b"] = divergingLog;
/* harmony export (immutable) */ __webpack_exports__["e"] = divergingSymlog;
/* harmony export (immutable) */ __webpack_exports__["c"] = divergingPow;
/* harmony export (immutable) */ __webpack_exports__["d"] = divergingSqrt;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__continuous__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__init__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__log__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sequential__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__symlog__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pow__ = __webpack_require__(297);








function transformer() {
  var x0 = 0,
      x1 = 0.5,
      x2 = 1,
      t0,
      t1,
      t2,
      k10,
      k21,
      interpolator = __WEBPACK_IMPORTED_MODULE_0__continuous__["a" /* identity */],
      transform,
      clamp = false,
      unknown;

  function scale(x) {
    return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (x < t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
  }

  scale.domain = function(_) {
    return arguments.length ? (t0 = transform(x0 = +_[0]), t1 = transform(x1 = +_[1]), t2 = transform(x2 = +_[2]), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), scale) : [x0, x1, x2];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function(t) {
    transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1);
    return scale;
  };
}

function diverging() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__linear__["b" /* linearish */])(transformer()(__WEBPACK_IMPORTED_MODULE_0__continuous__["a" /* identity */]));

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__sequential__["f" /* copy */])(scale, diverging());
  };

  return __WEBPACK_IMPORTED_MODULE_1__init__["a" /* initInterpolator */].apply(scale, arguments);
}

function divergingLog() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__log__["b" /* loggish */])(transformer()).domain([0.1, 1, 10]);

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__sequential__["f" /* copy */])(scale, divergingLog()).base(scale.base());
  };

  return __WEBPACK_IMPORTED_MODULE_1__init__["a" /* initInterpolator */].apply(scale, arguments);
}

function divergingSymlog() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__symlog__["b" /* symlogish */])(transformer());

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__sequential__["f" /* copy */])(scale, divergingSymlog()).constant(scale.constant());
  };

  return __WEBPACK_IMPORTED_MODULE_1__init__["a" /* initInterpolator */].apply(scale, arguments);
}

function divergingPow() {
  var scale = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__pow__["c" /* powish */])(transformer());

  scale.copy = function() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__sequential__["f" /* copy */])(scale, divergingPow()).exponent(scale.exponent());
  };

  return __WEBPACK_IMPORTED_MODULE_1__init__["a" /* initInterpolator */].apply(scale, arguments);
}

function divergingSqrt() {
  return divergingPow.apply(null, arguments).exponent(0.5);
}


/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = identity;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(479);




function identity(domain) {
  var unknown;

  function scale(x) {
    return isNaN(x = +x) ? unknown : x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]), scale) : domain.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return identity(domain).unknown(unknown);
  };

  domain = arguments.length ? __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(domain, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]) : [0, 1];

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quantile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init__ = __webpack_require__(45);




function quantile() {
  var domain = [],
      range = [],
      thresholds = [],
      unknown;

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g" /* quantile */])(domain, i / n);
    return scale;
  }

  function scale(x) {
    return isNaN(x = +x) ? unknown : range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" /* ascending */]);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return __WEBPACK_IMPORTED_MODULE_2__init__["b" /* initRange */].apply(scale, arguments);
}


/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = quantize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__init__ = __webpack_require__(45);





function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1],
      unknown;

  function scale(x) {
    return x <= x ? range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 0, n)] : unknown;
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : scale;
  };

  scale.thresholds = function() {
    return domain.slice();
  };

  scale.copy = function() {
    return quantize()
        .domain([x0, x1])
        .range(range)
        .unknown(unknown);
  };

  return __WEBPACK_IMPORTED_MODULE_3__init__["b" /* initRange */].apply(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__linear__["b" /* linearish */])(scale), arguments);
}


/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = sequentialQuantile;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__continuous__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init__ = __webpack_require__(45);




function sequentialQuantile() {
  var domain = [],
      interpolator = __WEBPACK_IMPORTED_MODULE_1__continuous__["a" /* identity */];

  function scale(x) {
    if (!isNaN(x = +x)) return interpolator((__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x) - 1) / (domain.length - 1));
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" /* ascending */]);
    return scale;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequentialQuantile(interpolator).domain(domain);
  };

  return __WEBPACK_IMPORTED_MODULE_2__init__["a" /* initInterpolator */].apply(scale, arguments);
}


/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = threshold;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__init__ = __webpack_require__(45);




function threshold() {
  var domain = [0.5],
      range = [0, 1],
      unknown,
      n = 1;

  function scale(x) {
    return x <= x ? range[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 0, n)] : unknown;
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return __WEBPACK_IMPORTED_MODULE_2__init__["b" /* initRange */].apply(scale, arguments);
}


/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__time__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time_format__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__init__ = __webpack_require__(45);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  return __WEBPACK_IMPORTED_MODULE_3__init__["b" /* initRange */].apply(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__time__["b" /* calendar */])(__WEBPACK_IMPORTED_MODULE_2_d3_time__["a" /* utcYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["b" /* utcMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["c" /* utcWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["d" /* utcDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["e" /* utcHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["f" /* utcMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["g" /* utcSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["h" /* utcMillisecond */], __WEBPACK_IMPORTED_MODULE_1_d3_time_format__["a" /* utcFormat */]).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]), arguments);
});


/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math_js__ = __webpack_require__(162);




function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = y32 * x10 - x32 * y10;
  if (t * t < __WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* epsilon */]) return;
  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["d" /* sqrt */])(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["d" /* sqrt */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["e" /* max */])(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math_js__["f" /* halfPi */],
        a1 = endAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math_js__["f" /* halfPi */],
        da = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["g" /* abs */])(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > __WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* epsilon */])) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > __WEBPACK_IMPORTED_MODULE_2__math_js__["c" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* epsilon */]) {
      context.moveTo(r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["h" /* cos */])(a0), r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["i" /* sin */])(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > __WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* epsilon */]) {
        context.moveTo(r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["h" /* cos */])(a1), r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["i" /* sin */])(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > __WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* epsilon */]) && (padRadius ? +padRadius.apply(this, arguments) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["d" /* sqrt */])(r0 * r0 + r1 * r1)),
          rc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["j" /* min */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["g" /* abs */])(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > __WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* epsilon */]) {
        var p0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["k" /* asin */])(rp / r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["i" /* sin */])(ap)),
            p1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["k" /* asin */])(rp / r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["i" /* sin */])(ap));
        if ((da0 -= p0 * 2) > __WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* epsilon */]) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > __WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* epsilon */]) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["h" /* cos */])(a01),
          y01 = r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["i" /* sin */])(a01),
          x10 = r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["h" /* cos */])(a10),
          y10 = r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["i" /* sin */])(a10);

      // Apply rounded corners?
      if (rc > __WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* epsilon */]) {
        var x11 = r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["h" /* cos */])(a11),
            y11 = r1 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["i" /* sin */])(a11),
            x00 = r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["h" /* cos */])(a00),
            y00 = r0 * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["i" /* sin */])(a00),
            oc;

        // Restrict the corner radius according to the sector angle.
        if (da < __WEBPACK_IMPORTED_MODULE_2__math_js__["b" /* pi */] && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
          var ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["i" /* sin */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["l" /* acos */])((ax * bx + ay * by) / (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["d" /* sqrt */])(ax * ax + ay * ay) * __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["d" /* sqrt */])(bx * bx + by * by))) / 2),
              lc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["d" /* sqrt */])(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["j" /* min */])(rc, (r0 - lc) / (kc - 1));
          rc1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["j" /* min */])(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > __WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* epsilon */])) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > __WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* epsilon */]) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["m" /* atan2 */])(t0.y01, t0.x01), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["m" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["m" /* atan2 */])(t0.y01, t0.x01), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["m" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["m" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["m" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["m" /* atan2 */])(t1.y11, t1.x11), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["m" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > __WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* epsilon */]) || !(da0 > __WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* epsilon */])) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > __WEBPACK_IMPORTED_MODULE_2__math_js__["a" /* epsilon */]) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["m" /* atan2 */])(t0.y01, t0.x01), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["m" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["m" /* atan2 */])(t0.y01, t0.x01), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["m" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["m" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["m" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["m" /* atan2 */])(t1.y11, t1.x11), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["m" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - __WEBPACK_IMPORTED_MODULE_2__math_js__["b" /* pi */] / 2;
    return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["h" /* cos */])(a) * r, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__math_js__["i" /* sin */])(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
});


/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial_js__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area_js__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lineRadial_js__ = __webpack_require__(489);




/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__area_js__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial_js__["b" /* curveRadialLinear */]),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;

  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function() { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lineRadial_js__["a" /* lineRadial */])(x0()); }, delete a.lineX0;
  a.lineEndAngle = function() { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lineRadial_js__["a" /* lineRadial */])(x1()); }, delete a.lineX1;
  a.lineInnerRadius = function() { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lineRadial_js__["a" /* lineRadial */])(y0()); }, delete a.lineY0;
  a.lineOuterRadius = function() { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lineRadial_js__["a" /* lineRadial */])(y1()); }, delete a.lineY1;

  a.curve = function(_) {
    return arguments.length ? c(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__curve_radial_js__["a" /* default */])(_)) : c()._curve;
  };

  return a;
});


/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop_js__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis_js__ = __webpack_require__(190);



function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop_js__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop_js__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__basis_js__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new BasisClosed(context);
});


/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis_js__ = __webpack_require__(190);


function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__basis_js__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new BasisOpen(context);
});


/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis_js__ = __webpack_require__(190);


function Bundle(context, beta) {
  this._basis = new __WEBPACK_IMPORTED_MODULE_0__basis_js__["a" /* Basis */](context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new __WEBPACK_IMPORTED_MODULE_0__basis_js__["a" /* Basis */](context) : new Bundle(context, beta);
  }

  bundle.beta = function(beta) {
    return custom(+beta);
  };

  return bundle;
})(0.85));


/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalClosed_js__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop_js__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__catmullRom_js__ = __webpack_require__(299);




function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_1__noop_js__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_1__noop_js__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__catmullRom_js__["a" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalClosed_js__["a" /* CardinalClosed */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalOpen_js__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__catmullRom_js__ = __webpack_require__(299);



function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__catmullRom_js__["a" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalOpen_js__["a" /* CardinalOpen */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop_js__ = __webpack_require__(193);


function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop_js__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop_js__["a" /* default */],
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new LinearClosed(context);
});


/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = monotoneX;
/* harmony export (immutable) */ __webpack_exports__["b"] = monotoneY;
function sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
}

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}


/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Natural(context);
});


/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = stepBefore;
/* harmony export (immutable) */ __webpack_exports__["b"] = stepAfter;
function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Step(context, 0.5);
});

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}


/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(d) {
  return d;
});


/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export linkHorizontal */
/* unused harmony export linkVertical */
/* unused harmony export linkRadial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array_js__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point_js__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pointRadial_js__ = __webpack_require__(491);






function linkSource(d) {
  return d.source;
}

function linkTarget(d) {
  return d.target;
}

function link(curve) {
  var source = linkSource,
      target = linkTarget,
      x = __WEBPACK_IMPORTED_MODULE_3__point_js__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point_js__["b" /* y */],
      context = null;

  function link() {
    var buffer, argv = __WEBPACK_IMPORTED_MODULE_1__array_js__["a" /* slice */].call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
    if (!context) context = buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
    if (buffer) return context = null, buffer + "" || null;
  }

  link.source = function(_) {
    return arguments.length ? (source = _, link) : source;
  };

  link.target = function(_) {
    return arguments.length ? (target = _, link) : target;
  };

  link.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant_js__["a" /* default */])(+_), link) : x;
  };

  link.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__constant_js__["a" /* default */])(+_), link) : y;
  };

  link.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), link) : context;
  };

  return link;
}

function curveHorizontal(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}

function curveVertical(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}

function curveRadial(context, x0, y0, x1, y1) {
  var p0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__pointRadial_js__["a" /* default */])(x0, y0),
      p1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__pointRadial_js__["a" /* default */])(x0, y0 = (y0 + y1) / 2),
      p2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__pointRadial_js__["a" /* default */])(x1, y0),
      p3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__pointRadial_js__["a" /* default */])(x1, y1);
  context.moveTo(p0[0], p0[1]);
  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}

function linkHorizontal() {
  return link(curveHorizontal);
}

function linkVertical() {
  return link(curveVertical);
}

function linkRadial() {
  var l = link(curveRadial);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}


/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = 0, d[1] = dy;
      }
    }
  }
});


/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none_js__ = __webpack_require__(163);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none_js__["a" /* default */])(series, order);
});


/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none_js__ = __webpack_require__(163);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none_js__["a" /* default */])(series, order);
});


/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none_js__ = __webpack_require__(163);


/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none_js__["a" /* default */])(series, order);
});


/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending_js__ = __webpack_require__(302);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ascending_js__["b" /* default */])(series).reverse();
});


/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__appearance_js__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending_js__ = __webpack_require__(302);



/* unused harmony default export */ var _unused_webpack_default_export = (function(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(__WEBPACK_IMPORTED_MODULE_1__ascending_js__["a" /* sum */]),
      order = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__appearance_js__["a" /* default */])(series),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
});


/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none_js__ = __webpack_require__(164);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__none_js__["a" /* default */])(series).reverse();
});


/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__descending_js__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math_js__ = __webpack_require__(162);





/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */],
      sortValues = __WEBPACK_IMPORTED_MODULE_1__descending_js__["a" /* default */],
      sort = null,
      startAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(0),
      endAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__math_js__["c" /* tau */]),
      padAngle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(__WEBPACK_IMPORTED_MODULE_3__math_js__["c" /* tau */], Math.max(-__WEBPACK_IMPORTED_MODULE_3__math_js__["c" /* tau */], endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(+_), pie) : padAngle;
  };

  return pie;
});


/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array_js__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant_js__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__offset_none_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__order_none_js__ = __webpack_require__(164);





function stackValue(d, key) {
  return d[key];
}

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var keys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])([]),
      order = __WEBPACK_IMPORTED_MODULE_3__order_none_js__["a" /* default */],
      offset = __WEBPACK_IMPORTED_MODULE_2__offset_none_js__["a" /* default */],
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* slice */].call(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? __WEBPACK_IMPORTED_MODULE_3__order_none_js__["a" /* default */] : typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__constant_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array_js__["a" /* slice */].call(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? __WEBPACK_IMPORTED_MODULE_2__offset_none_js__["a" /* default */] : _, stack) : offset;
  };

  return stack;
});


/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export symbols */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__symbol_circle_js__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__symbol_cross_js__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__symbol_diamond_js__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__symbol_star_js__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__symbol_square_js__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__symbol_triangle_js__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__symbol_wye_js__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constant_js__ = __webpack_require__(99);










var symbols = [
  __WEBPACK_IMPORTED_MODULE_1__symbol_circle_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_2__symbol_cross_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_3__symbol_diamond_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_5__symbol_square_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_4__symbol_star_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_6__symbol_triangle_js__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_7__symbol_wye_js__["a" /* default */]
];

/* harmony default export */ __webpack_exports__["a"] = (function() {
  var type = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constant_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__symbol_circle_js__["a" /* default */]),
      size = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constant_js__["a" /* default */])(64),
      context = null;

  function symbol() {
    var buffer;
    if (!context) context = buffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constant_js__["a" /* default */])(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__constant_js__["a" /* default */])(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
});


/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isoFormat_js__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultLocale_js__ = __webpack_require__(304);



function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__defaultLocale_js__["b" /* utcParse */])(__WEBPACK_IMPORTED_MODULE_0__isoFormat_js__["a" /* isoSpecifier */]);

/* unused harmony default export */ var _unused_webpack_default_export = (parseIso);


/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export days */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(69);



var day = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration_js__["d" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["b" /* durationDay */];
}, function(date) {
  return date.getDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (day);
var days = day.range;


/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(69);



var hour = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * __WEBPACK_IMPORTED_MODULE_1__duration_js__["e" /* durationSecond */] - date.getMinutes() * __WEBPACK_IMPORTED_MODULE_1__duration_js__["d" /* durationMinute */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration_js__["c" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["c" /* durationHour */];
}, function(date) {
  return date.getHours();
});

/* harmony default export */ __webpack_exports__["a"] = (hour);
var hours = hour.range;


/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export milliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(43);


var millisecond = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (millisecond);
var milliseconds = millisecond.range;


/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export minutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(69);



var minute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * __WEBPACK_IMPORTED_MODULE_1__duration_js__["e" /* durationSecond */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration_js__["d" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["d" /* durationMinute */];
}, function(date) {
  return date.getMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (minute);
var minutes = minute.range;


/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export months */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(43);


var month = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (month);
var months = month.range;


/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export seconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(69);



var second = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setTime(date - date.getMilliseconds());
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration_js__["e" /* durationSecond */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["e" /* durationSecond */];
}, function(date) {
  return date.getUTCSeconds();
});

/* harmony default export */ __webpack_exports__["a"] = (second);
var seconds = second.range;


/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(69);



var utcDay = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["b" /* durationDay */];
}, function(date) {
  return date.getUTCDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (utcDay);
var utcDays = utcDay.range;


/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(69);



var utcHour = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration_js__["c" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["c" /* durationHour */];
}, function(date) {
  return date.getUTCHours();
});

/* harmony default export */ __webpack_exports__["a"] = (utcHour);
var utcHours = utcHour.range;


/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(69);



var utcMinute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration_js__["d" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["d" /* durationMinute */];
}, function(date) {
  return date.getUTCMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMinute);
var utcMinutes = utcMinute.range;


/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(43);


var utcMonth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMonth);
var utcMonths = utcMonth.range;


/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcSunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcMonday; });
/* unused harmony export utcTuesday */
/* unused harmony export utcWednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utcThursday; });
/* unused harmony export utcFriday */
/* unused harmony export utcSaturday */
/* unused harmony export utcSundays */
/* unused harmony export utcMondays */
/* unused harmony export utcTuesdays */
/* unused harmony export utcWednesdays */
/* unused harmony export utcThursdays */
/* unused harmony export utcFridays */
/* unused harmony export utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(69);



function utcWeekday(i) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["a" /* durationWeek */];
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;


/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(43);


var utcYear = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (utcYear);
var utcYears = utcYear.range;


/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return monday; });
/* unused harmony export tuesday */
/* unused harmony export wednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return thursday; });
/* unused harmony export friday */
/* unused harmony export saturday */
/* unused harmony export sundays */
/* unused harmony export mondays */
/* unused harmony export tuesdays */
/* unused harmony export wednesdays */
/* unused harmony export thursdays */
/* unused harmony export fridays */
/* unused harmony export saturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration_js__ = __webpack_require__(69);



function weekday(i) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration_js__["d" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration_js__["a" /* durationWeek */];
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;


/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export years */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval_js__ = __webpack_require__(43);


var year = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__interval_js__["a" /* default */])(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (year);
var years = year.range;


/***/ }),
/* 1136 */
/***/ (function(module, exports) {

module.exports = function deepFreeze (o) {
  Object.freeze(o);

  Object.getOwnPropertyNames(o).forEach(function (prop) {
    if (o.hasOwnProperty(prop)
    && o[prop] !== null
    && (typeof o[prop] === "object" || typeof o[prop] === "function")
    && !Object.isFrozen(o[prop])) {
      deepFreeze(o[prop]);
    }
  });
  
  return o;
};


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(40);

exports.__esModule = true;
exports.default = void 0;

var _addClass = _interopRequireDefault(__webpack_require__(504));

exports.addClass = _addClass.default;

var _removeClass = _interopRequireDefault(__webpack_require__(506));

exports.removeClass = _removeClass.default;

var _hasClass = _interopRequireDefault(__webpack_require__(505));

exports.hasClass = _hasClass.default;
var _default = {
  addClass: _addClass.default,
  removeClass: _removeClass.default,
  hasClass: _hasClass.default
};
exports.default = _default;

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(40);

exports.__esModule = true;
exports.default = filterEvents;

var _contains = _interopRequireDefault(__webpack_require__(119));

var _querySelectorAll = _interopRequireDefault(__webpack_require__(1143));

function filterEvents(selector, handler) {
  return function filterHandler(e) {
    var top = e.currentTarget,
        target = e.target,
        matches = (0, _querySelectorAll.default)(top, selector);
    if (matches.some(function (match) {
      return (0, _contains.default)(match, target);
    })) handler.call(this, e);
  };
}

module.exports = exports["default"];

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(40);

exports.__esModule = true;
exports.default = void 0;

var _on = _interopRequireDefault(__webpack_require__(194));

exports.on = _on.default;

var _off = _interopRequireDefault(__webpack_require__(306));

exports.off = _off.default;

var _filter = _interopRequireDefault(__webpack_require__(1138));

exports.filter = _filter.default;

var _listen = _interopRequireDefault(__webpack_require__(1140));

exports.listen = _listen.default;
var _default = {
  on: _on.default,
  off: _off.default,
  filter: _filter.default,
  listen: _listen.default
};
exports.default = _default;

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(40);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(84));

var _on = _interopRequireDefault(__webpack_require__(194));

var _off = _interopRequireDefault(__webpack_require__(306));

var listen = function listen() {};

if (_inDOM.default) {
  listen = function listen(node, eventName, handler, capture) {
    (0, _on.default)(node, eventName, handler, capture);
    return function () {
      (0, _off.default)(node, eventName, handler, capture);
    };
  };
}

var _default = listen;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(40);

exports.__esModule = true;
exports.default = offsetParent;

var _ownerDocument = _interopRequireDefault(__webpack_require__(118));

var _style = _interopRequireDefault(__webpack_require__(196));

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function offsetParent(node) {
  var doc = (0, _ownerDocument.default)(node),
      offsetParent = node && node.offsetParent;

  while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
    offsetParent = offsetParent.offsetParent;
  }

  return offsetParent || doc.documentElement;
}

module.exports = exports["default"];

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(40);

exports.__esModule = true;
exports.default = position;

var _extends2 = _interopRequireDefault(__webpack_require__(770));

var _offset = _interopRequireDefault(__webpack_require__(507));

var _offsetParent = _interopRequireDefault(__webpack_require__(1141));

var _scrollTop = _interopRequireDefault(__webpack_require__(508));

var _scrollLeft = _interopRequireDefault(__webpack_require__(1144));

var _style = _interopRequireDefault(__webpack_require__(196));

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function position(node, offsetParent) {
  var parentOffset = {
    top: 0,
    left: 0
  },
      offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
  // because it is its only offset parent

  if ((0, _style.default)(node, 'position') === 'fixed') {
    offset = node.getBoundingClientRect();
  } else {
    offsetParent = offsetParent || (0, _offsetParent.default)(node);
    offset = (0, _offset.default)(node);
    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
  } // Subtract parent offsets and node margins


  return (0, _extends2.default)({}, offset, {
    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
  });
}

module.exports = exports["default"];

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = qsa;
// Zepto.js
// (c) 2010-2015 Thomas Fuchs
// Zepto.js may be freely distributed under the MIT license.
var simpleSelectorRE = /^[\w-]*$/;
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);

function qsa(element, selector) {
  var maybeID = selector[0] === '#',
      maybeClass = selector[0] === '.',
      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
      isSimple = simpleSelectorRE.test(nameOnly),
      found;

  if (isSimple) {
    if (maybeID) {
      element = element.getElementById ? element : document;
      return (found = element.getElementById(nameOnly)) ? [found] : [];
    }

    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
    return toArray(element.getElementsByTagName(selector));
  }

  return toArray(element.querySelectorAll(selector));
}

module.exports = exports["default"];

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(40);

exports.__esModule = true;
exports.default = scrollTop;

var _isWindow = _interopRequireDefault(__webpack_require__(195));

function scrollTop(node, val) {
  var win = (0, _isWindow.default)(node);
  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
}

module.exports = exports["default"];

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(40);

exports.__esModule = true;
exports.default = _getComputedStyle;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(510));

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;
  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;
      prop = (0, _camelizeStyle.default)(prop);
      if (prop == 'float') prop = 'styleFloat';
      var current = node.currentStyle[prop] || null;
      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out

        if (rsLeft) runStyle.left = node.currentStyle.left;
        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px'; // Revert the changed values

        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}

module.exports = exports["default"];

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = removeStyle;

function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}

module.exports = exports["default"];

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}

module.exports = exports["default"];

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}

module.exports = exports["default"];

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hyphenate;
var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

module.exports = exports["default"];

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(40);

exports.__esModule = true;
exports.default = hyphenateStyleName;

var _hyphenate = _interopRequireDefault(__webpack_require__(1149));

/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */
var msPattern = /^ms-/;

function hyphenateStyleName(string) {
  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
}

module.exports = exports["default"];

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 1152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var invariant = __webpack_require__(17);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(31);

var invariant = __webpack_require__(17);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(1163);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1166 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 1167 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(100),
    root = __webpack_require__(63);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1236),
    hashDelete = __webpack_require__(1237),
    hashGet = __webpack_require__(1238),
    hashHas = __webpack_require__(1239),
    hashSet = __webpack_require__(1240);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(100),
    root = __webpack_require__(63);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(100),
    root = __webpack_require__(63);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(100),
    root = __webpack_require__(63);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 1175 */
/***/ (function(module, exports) {

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

module.exports = addMapEntry;


/***/ }),
/* 1176 */
/***/ (function(module, exports) {

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

module.exports = addSetEntry;


/***/ }),
/* 1177 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 1178 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(529);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 1180 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 1181 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(166),
    keys = __webpack_require__(123);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(166),
    keysIn = __webpack_require__(550);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(310),
    arrayEach = __webpack_require__(1178),
    assignValue = __webpack_require__(526),
    baseAssign = __webpack_require__(1182),
    baseAssignIn = __webpack_require__(1183),
    cloneBuffer = __webpack_require__(1215),
    copyArray = __webpack_require__(1222),
    copySymbols = __webpack_require__(1223),
    copySymbolsIn = __webpack_require__(1224),
    getAllKeys = __webpack_require__(535),
    getAllKeysIn = __webpack_require__(536),
    getTag = __webpack_require__(538),
    initCloneArray = __webpack_require__(1241),
    initCloneByTag = __webpack_require__(1242),
    initCloneObject = __webpack_require__(1243),
    isArray = __webpack_require__(49),
    isBuffer = __webpack_require__(322),
    isObject = __webpack_require__(101),
    keys = __webpack_require__(123);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(101);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(1191),
    createBaseEach = __webpack_require__(1226);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(1186);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),
/* 1188 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(311),
    isFlattenable = __webpack_require__(1244);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1227);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(1190),
    keys = __webpack_require__(123);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 1192 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(521),
    arrayIncludes = __webpack_require__(1179),
    arrayIncludesWith = __webpack_require__(1180),
    arrayMap = __webpack_require__(165),
    baseUnary = __webpack_require__(530),
    cacheHas = __webpack_require__(531);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith : arrayIncludes,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap(array, baseUnary(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseIntersection;


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(86),
    isObjectLike = __webpack_require__(71);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(310),
    equalArrays = __webpack_require__(533),
    equalByTag = __webpack_require__(1229),
    equalObjects = __webpack_require__(1230),
    getTag = __webpack_require__(538),
    isArray = __webpack_require__(49),
    isBuffer = __webpack_require__(322),
    isTypedArray = __webpack_require__(549);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(310),
    baseIsEqual = __webpack_require__(313);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 1197 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(548),
    isMasked = __webpack_require__(1246),
    isObject = __webpack_require__(101),
    toSource = __webpack_require__(547);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(86),
    isLength = __webpack_require__(323),
    isObjectLike = __webpack_require__(71);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1203),
    baseMatchesProperty = __webpack_require__(1204),
    identity = __webpack_require__(320),
    isArray = __webpack_require__(49),
    property = __webpack_require__(1288);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(318),
    nativeKeys = __webpack_require__(1258);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(101),
    isPrototype = __webpack_require__(318),
    nativeKeysIn = __webpack_require__(1259);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1196),
    getMatchData = __webpack_require__(1232),
    matchesStrictComparable = __webpack_require__(542);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(313),
    get = __webpack_require__(1276),
    hasIn = __webpack_require__(1277),
    isKey = __webpack_require__(317),
    isStrictComparable = __webpack_require__(540),
    matchesStrictComparable = __webpack_require__(542),
    toKey = __webpack_require__(167);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1205 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(312);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(320),
    overRest = __webpack_require__(544),
    setToString = __webpack_require__(546);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(1273),
    defineProperty = __webpack_require__(532),
    identity = __webpack_require__(320);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 1209 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 1210 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(122),
    arrayMap = __webpack_require__(165),
    isArray = __webpack_require__(49),
    isSymbol = __webpack_require__(207);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(204),
    last = __webpack_require__(1285),
    parent = __webpack_require__(1262),
    toKey = __webpack_require__(167);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(165);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLikeObject = __webpack_require__(1280);

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return isArrayLikeObject(value) ? value : [];
}

module.exports = castArrayLikeObject;


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(63);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module)))

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(314);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

var addMapEntry = __webpack_require__(1175),
    arrayReduce = __webpack_require__(525),
    mapToArray = __webpack_require__(541);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

module.exports = cloneMap;


/***/ }),
/* 1218 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

var addSetEntry = __webpack_require__(1176),
    arrayReduce = __webpack_require__(525),
    setToArray = __webpack_require__(545);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

module.exports = cloneSet;


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(122);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(314);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 1222 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(166),
    getSymbols = __webpack_require__(316);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(166),
    getSymbolsIn = __webpack_require__(537);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(63);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(168);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 1227 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(1283);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(122),
    Uint8Array = __webpack_require__(522),
    eq = __webpack_require__(319),
    equalArrays = __webpack_require__(533),
    mapToArray = __webpack_require__(541),
    setToArray = __webpack_require__(545);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(535);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(1275),
    overRest = __webpack_require__(544),
    setToString = __webpack_require__(546);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(540),
    keys = __webpack_require__(123);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(122);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1234 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(204),
    isArguments = __webpack_require__(321),
    isArray = __webpack_require__(49),
    isIndex = __webpack_require__(539),
    isLength = __webpack_require__(323),
    toKey = __webpack_require__(167);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(206);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1237 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(206);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(206);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(206);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1241 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(314),
    cloneDataView = __webpack_require__(1216),
    cloneMap = __webpack_require__(1217),
    cloneRegExp = __webpack_require__(1218),
    cloneSet = __webpack_require__(1219),
    cloneSymbol = __webpack_require__(1220),
    cloneTypedArray = __webpack_require__(1221);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(1185),
    getPrototype = __webpack_require__(315),
    isPrototype = __webpack_require__(318);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(122),
    isArguments = __webpack_require__(321),
    isArray = __webpack_require__(49);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 1245 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1225);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1247 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(203);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(203);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(203);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(203);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1171),
    ListCache = __webpack_require__(202),
    Map = __webpack_require__(308);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(205);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(205);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(205);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(205);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1286);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(543);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1259 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(534);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module)))

/***/ }),
/* 1261 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(312),
    baseSlice = __webpack_require__(1209);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 1263 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1264 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1265 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(202);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1267 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1268 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1269 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(202),
    Map = __webpack_require__(308),
    MapCache = __webpack_require__(309);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1271 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1257);

/** Used to match property names within property paths. */
var reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1273 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(523),
    baseFilter = __webpack_require__(1187),
    baseIteratee = __webpack_require__(1200),
    isArray = __webpack_require__(49);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(1189);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(312);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1192),
    hasPath = __webpack_require__(1235);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(529),
    isArrayLike = __webpack_require__(168),
    isString = __webpack_require__(1284),
    toInteger = __webpack_require__(1291),
    values = __webpack_require__(1294);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(165),
    baseIntersection = __webpack_require__(1193),
    baseRest = __webpack_require__(1207),
    castArrayLikeObject = __webpack_require__(1214);

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest(function(arrays) {
  var mapped = arrayMap(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

module.exports = intersection;


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(168),
    isObjectLike = __webpack_require__(71);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(313);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(86),
    isObjectLike = __webpack_require__(71);

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && baseGetTag(value) == numberTag);
}

module.exports = isNumber;


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(86),
    getPrototype = __webpack_require__(315),
    isObjectLike = __webpack_require__(71);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(86),
    isArray = __webpack_require__(49),
    isObjectLike = __webpack_require__(71);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 1285 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(309);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(165),
    baseClone = __webpack_require__(1184),
    baseUnset = __webpack_require__(1212),
    castPath = __webpack_require__(204),
    copyObject = __webpack_require__(166),
    customOmitClone = __webpack_require__(1228),
    flatRest = __webpack_require__(1231),
    getAllKeysIn = __webpack_require__(536);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1205),
    basePropertyDeep = __webpack_require__(1206),
    isKey = __webpack_require__(317),
    toKey = __webpack_require__(167);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1289 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(1292);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(1290);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(101),
    isSymbol = __webpack_require__(207);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1211);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(1213),
    keys = __webpack_require__(123);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

var Mexp=__webpack_require__(1299);
Mexp.prototype.formulaEval = function () {
	"use strict";
	var stack=[],pop1,pop2,pop3;
	var disp=[];
	var temp='';
	var arr=this.value;
	for(var i=0;i<arr.length;i++){
		if(arr[i].type===1||arr[i].type===3){
			disp.push({value:arr[i].type===3?arr[i].show:arr[i].value,type:1});
		}
		else if(arr[i].type===13){
			disp.push({value:arr[i].show,type:1});
		}
		else if(arr[i].type===0){
			disp[disp.length-1]={value:arr[i].show+(arr[i].show!="-"?"(":"")+disp[disp.length-1].value+(arr[i].show!="-"?")":""),type:0};
		}
		else if(arr[i].type===7){
			disp[disp.length-1]={value:(disp[disp.length-1].type!=1?"(":"")+disp[disp.length-1].value+(disp[disp.length-1].type!=1?")":"")+arr[i].show,type:7};
		}
		else if(arr[i].type===10){
			pop1=disp.pop();
			pop2=disp.pop();
			if(arr[i].show==='P'||arr[i].show==='C')disp.push({value:"<sup>"+pop2.value+"</sup>"+arr[i].show+"<sub>"+pop1.value+"</sub>",type:10});
			else disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+"<sup>"+pop1.value+"</sup>",type:1});
		}
		else if(arr[i].type===2||arr[i].type===9){
			pop1=disp.pop();
			pop2=disp.pop();
			disp.push({value:(pop2.type!=1?"(":"")+pop2.value+(pop2.type!=1?")":"")+arr[i].show+(pop1.type!=1?"(":"")+pop1.value+(pop1.type!=1?")":""),type:arr[i].type});
		}
		else if(arr[i].type===12){
			pop1=disp.pop();
			pop2=disp.pop();
			pop3=disp.pop();
			disp.push({value:arr[i].show+"("+pop3.value+","+pop2.value+","+pop1.value+")",type:12});
		}
	}
	return disp[0].value;
};
module.exports=Mexp;

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

var Mexp=__webpack_require__(1297);
	function inc(arr,val){
		for(var i=0;i<arr.length;i++)
			arr[i]+=val;
		return arr;
	}
	var token=['sin','cos','tan','pi','(',')','P','C',
		  'asin','acos','atan','7','8','9','int',
		  'cosh','acosh','ln','^','root','4','5','6','/','!',
		  'tanh','atanh','Mod','1','2','3','*',
		  'sinh','asinh','e','log','0','.','+','-',',','Sigma','n','Pi','pow'];
	var show=['sin','cos','tan','&pi;','(',')','P','C',
		'asin','acos','atan','7','8','9','Int',
		'cosh','acosh',' ln','^','root','4','5','6','&divide;','!',
		'tanh','atanh',' Mod ','1','2','3','&times;',
		'sinh','asinh','e',' log','0','.','+','-',',','&Sigma;','n','&Pi;','pow'];
	var eva=[Mexp.math.sin,Mexp.math.cos,Mexp.math.tan,'PI','(',')',Mexp.math.P,Mexp.math.C,
		Mexp.math.asin,Mexp.math.acos,Mexp.math.atan,'7','8','9',Math.floor,
		Mexp.math.cosh,Mexp.math.acosh,Math.log,Math.pow,Math.sqrt,'4','5','6',Mexp.math.div,Mexp.math.fact,
		Mexp.math.tanh,Mexp.math.atanh,Mexp.math.mod,'1','2','3',Mexp.math.mul,
		Mexp.math.sinh,Mexp.math.asinh,'E',Mexp.math.log,'0','.',Mexp.math.add,Mexp.math.sub,',',Mexp.math.sigma,'n',Mexp.math.Pi,Math.pow];
	var preced={0:11,1:0,2:3,3:0,4:0,5:0,6:0,7:11,8:11,9:1,10:10,11:0,12:11,13:0};
	var type=[0,0,0,3,4,5,10,10,
		0,0,0,1,1,1,0,
		0,0,0,10,0,1,1,1,2,7,
		0,0,2,1,1,1,2,
		0,0,3,0,1,6,9,9,11,12,13,12,8];
	 /*
	0 : function with syntax function_name(Maths_exp)
	1 : numbers
	2 : binary operators like * / Mod left associate and same precedence
	3 : Math constant values like e,pi,Cruncher ans
	4 : opening bracket
	5 : closing bracket
	6 : decimal
	7 : function with syntax (Math_exp)function_name
	8: function with syntax function_name(Math_exp1,Math_exp2)
	9 : binary operator like +,-
	10: binary operator like P C or ^
	11: ,
	12: function with , seperated three parameters
	13: variable of Sigma function
	 */
	var type0={0:true,1:true,3:true,4:true,6:true,8:true,9:true,12:true,13:true},//type2:true,type4:true,type9:true,type11:true,type21:true,type22
	type1={0:true,1:true,2:true,3:true,4:true,5:true,6:true,7:true,8:true,9:true,10:true,11:true,12:true,13:true},//type3:true,type5:true,type7:true,type23
	type_1={0:true,3:true,4:true,8:true,12:true,13:true},
	empty={},
	type_3={0:true,1:true,3:true,4:true,6:true,8:true,12:true,13:true},//type_5:true,type_7:true,type_23
	type6={1:true},
	newAr=[[],
			["1","2","3","7","8","9","4","5","6","+","-","*","/","(",")","^","!","P","C","e","0",".",",","n"],
			["pi","ln","Pi"],
			["sin","cos","tan","Del","int","Mod","log","pow"],
			["asin","acos","atan","cosh","root","tanh","sinh"],
			["acosh","atanh","asinh","Sigma"]];
	function match(str1,str2,i,x){
		for(var f=0;f<x;f++){
			if (str1[i+f]!==str2[f])
				return false;
		}
		return true;
	}
	Mexp.addToken=function(tokens){
		for(i=0;i<tokens.length;i++){
			x=tokens[i].token.length;
			var temp=-1;

			//newAr is a specially designed data structure in which 1D array at location one of 2d array has all string with length 1 2 with 2 and so on

			if (x<newAr.length)	//match to check if token is really huge and not existing
								//if not checked it will break in next line as undefined index
				for(y=0;y<newAr[x].length;y++){
					if (tokens[i].token===newAr[x][y]){
						temp=token.indexOf(newAr[x][y]);
						break;
					}
				}
			if (temp===-1) {
				token.push(tokens[i].token);
				type.push(tokens[i].type);
				if(newAr.length<=tokens[i].token.length)
					newAr[tokens[i].token.length]=[];
				newAr[tokens[i].token.length].push(tokens[i].token);
				eva.push(tokens[i].value);
				show.push(tokens[i].show);
			}
			else {
				token[temp]=tokens[i].token;
				type[temp]=tokens[i].type;
				eva[temp]=tokens[i].value;
				show[temp]=tokens[i].show;
			}
		}
	};
	Mexp.lex=function(inp,tokens){
		'use strict';
		var str=[{type:4,value:"(",show:"(",pre:0}];
		var ptc=[];	//Parenthesis to close at the beginning is after one token
		var inpStr=inp;
		var key;
        var pcounter=0;
		var allowed=type0;
		var bracToClose=0;
		var asterick=empty;
		var prevKey='';
		var i,x,y;
		if(typeof tokens!=="undefined")
			Mexp.addToken(tokens);
		var obj={};
		for(i=0;i<inpStr.length;i++){
			if (inpStr[i]==' ') {
				continue;
			}
			key='';
			sec:for(x=(inpStr.length-i>(newAr.length-2)?newAr.length-1:inpStr.length-i);x>0;x--){
				for(y=0;y<newAr[x].length;y++){
					if (match(inpStr,newAr[x][y],i,x)){
						key=newAr[x][y];
						break sec;
					}
				}
			}
			i+=key.length-1;
			if(key===''){
				throw(new Mexp.exception("Can't understand after "+inpStr.slice(i)));
			}
			var index=token.indexOf(key);
			var cToken=key;
			var cType=type[index];
			var cEv=eva[index];
			var cPre=preced[cType];
			var	cShow=show[index];
			var pre=str[str.length-1];
			for(j=ptc.length;j--;){	//loop over ptc
				if(ptc[j]===0){
					if([0,2,3,5,9,11,12,13].indexOf(cType)!==-1){
						if(allowed[cType]!==true){
							throw(new Mexp.exception(key+" is not allowed after "+prevKey));
						}
						str.push({value:")",type:5,pre:0,show:")"});
						allowed=type1;
						asterick=type_3;
						inc(ptc,-1).pop();
					}
				}
			}
			if(allowed[cType]!==true){
				throw(new Mexp.exception(key+" is not allowed after "+prevKey));
			}
			if(asterick[cType]===true){
				cType=2;
				cEv=Mexp.math.mul;
				cShow="&times;";
				cPre=3;
				i=i-key.length;
		 	}
			obj={value:cEv,type:cType,pre:cPre,show:cShow};
			if(cType===0){
				allowed=type0;
				asterick=empty;
				inc(ptc,2).push(2);
				str.push(obj);
				str.push({value:"(",type:4,pre:0,show:"("});
			}
			else if(cType===1){
				if(pre.type===1){
					pre.value+=cEv;
					inc(ptc,1);
				}
				else {
					str.push(obj);
				}
				allowed=type1;
				asterick=type_1;
			}
			else if(cType===2){
				allowed=type0;
				asterick=empty;
				inc(ptc,2);
				str.push(obj);
			}
			else if(cType===3){//constant
				str.push(obj);
				allowed=type1;
				asterick=type_3;
			}
			else if(cType===4){
                pcounter+=ptc.length;
                ptc=[];
				bracToClose++;
				allowed=type0;
				asterick=empty;
				str.push(obj);
			}
			else if(cType===5){
				if(!bracToClose){
					throw(new Mexp.exception("Closing parenthesis are more than opening one, wait What!!!"));
				}
                while(pcounter--){	//loop over ptc
    						str.push({value:")",type:5,pre:0,show:")"});
    			}
                pcounter=0;
				bracToClose--;
				allowed=type1;
				asterick=type_3;
				str.push(obj);
			}
			else if(cType===6){
				if(pre.hasDec){
					throw(new Mexp.exception("Two decimals are not allowed in one number"));
				}
				if(pre.type!==1){
					pre={value:0,type:1,pre:0};	//pre needs to be changed as it will the last value now to be safe in later code
					str.push(pre);
					inc(ptc,-1);
				}
				allowed=type6;
				inc(ptc,1);
				asterick=empty;
				pre.value+=cEv;
				pre.hasDec=true;
			}
			else if(cType===7){
				allowed=type1;
				asterick=type_3;
				inc(ptc,1);
				str.push(obj);
			}
			if(cType===8){
				allowed=type0;
				asterick=empty;
				inc(ptc,4).push(4);
				str.push(obj);
				str.push({value:"(",type:4,pre:0,show:"("});
			}
			else if(cType===9){
				if(pre.type===9){
					if(pre.value===Mexp.math.add){
						pre.value=cEv;
						pre.show=cShow;
						inc(ptc,1);
					}
					else if(pre.value===Mexp.math.sub&&cShow==='-'){
						pre.value=Mexp.math.add;
						pre.show='+';
						inc(ptc,1);
					}
				}
				else if(pre.type!==5&&pre.type!==7&&pre.type!==1&&pre.type!==3&&pre.type!==13){//changesign only when negative is found
					if(cToken==='-'){//do nothing for + token
									//don't add with the above if statement as that will run the else statement of parent if on Ctoken +
						allowed=type0;
						asterick=empty;
						inc(ptc,2).push(2);
						str.push({value:Mexp.math.changeSign,type:0,pre:21,show:"-"});
						str.push({value:"(",type:4,pre:0,show:"("});
					}
				}
				else{
					str.push(obj);
					inc(ptc,2);
				}
				allowed=type0;
				asterick=empty;
			}
			else if(cType===10){
				allowed=type0;
				asterick=empty;
				inc(ptc,2);
				str.push(obj);
			}
			else if(cType===11){
				allowed=type0;
				asterick=empty;
				str.push(obj);
			}
			else if(cType===12){
				allowed=type0;
				asterick=empty;
				inc(ptc,6).push(6);
				str.push(obj);
				str.push({value:"(",type:4,pre:0});
			}
			else if(cType===13){
				allowed=type1;
				asterick=type_3;
				str.push(obj);
			}
			inc(ptc,-1);
			prevKey=key;
		}
		for(var j=ptc.length;j--;){	//loop over ptc
			if(ptc[j]===0){

				str.push({value:")",show:")",type:5,pre:3});
				inc(ptc,-1).pop();
			}
		}
		if (allowed[5]!==true) {
			throw(new Mexp.exception("complete the expression"));
		}
		while(bracToClose--)
			str.push({value:")",show:")",type:5,pre:3});

		str.push({type:5,value:")",show:")",pre:0});
//        console.log(str);
		return new Mexp(str);
	};
    module.exports=Mexp;


/***/ }),
/* 1297 */
/***/ (function(module, exports) {

	var Mexp=function(parsed){
		this.value=parsed;

	};

	Mexp.math={
		isDegree:true, //mode of calculator
		acos:function(x){
			return (Mexp.math.isDegree?180/Math.PI*Math.acos(x):Math.acos(x));
		},
		add:function(a,b){
			return a+b;
		},
		asin:function(x){
			return (Mexp.math.isDegree?180/Math.PI*Math.asin(x):Math.asin(x));
		},
		atan:function(x){
			return (Mexp.math.isDegree?180/Math.PI*Math.atan(x):Math.atan(x));
		},
		acosh:function(x){
			return Math.log(x+Math.sqrt(x*x-1));
		},
		asinh:function(x){
			return Math.log(x+Math.sqrt(x*x+1));
		},
		atanh:function(x){
			return Math.log((1+x)/(1-x));
		},
		C:function(n,r){
			var pro=1,other=n-r,choice=r;
			if(choice<other){
			choice=other;
			other=r;
			}
			for(var i=choice+1;i<=n;i++)
				pro*=i;
			return pro/Mexp.math.fact(other);
		},
		changeSign:function(x){
			return -x;
		},
		cos:function(x){
			if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
			return Math.cos(x);
		},
		cosh:function(x){
			return (Math.pow(Math.E,x)+Math.pow(Math.E,-1*x))/2;
		},
		div:function(a,b){
		return a/b;
		},
		fact:function(n) {
		if(n%1!==0)return "NAN";
			var pro=1;
			for(var i=2;i<=n;i++)
				pro*=i;
			return pro;
		},
		inverse:function(x){
			return 1/x;
		},
		log:function(i){
			return Math.log(i)/Math.log(10);
		},
		mod:function(a,b){
		return a%b;
		},
		mul:function(a,b){
		return a*b;
		},
		P:function(n,r){var pro=1;
			 for(var i=Math.floor(n)-Math.floor(r)+1;i<=Math.floor(n);i++)
					pro*=i;
					return pro;

		},
		Pi:function(low,high,ex){
			var pro=1;
			for(var i=low;i<=high;i++){
				pro*=Number(ex.postfixEval({n:i}));
			}
			return pro;
		},
		pow10x:function(e){
			var x=1;
			while(e--){x*=10;}
			return x;
		},
		sigma:function(low,high,ex){
			var sum=0;
			for(var i=low;i<=high;i++){
				sum+=Number(ex.postfixEval({n:i}));
			}
			return sum;
		},
		sin:function(x){
			if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
			return Math.sin(x);
		},
		sinh:function(x){
			return (Math.pow(Math.E,x)-Math.pow(Math.E,-1*x))/2;
		},
		sub:function(a,b){
		return a-b;
		},
		tan:function(x){
			if(Mexp.math.isDegree)x=Mexp.math.toRadian(x);
			return Math.tan(x);
		},
		tanh:function(x){
			return Mexp.sinha(x)/Mexp.cosha(x);
		},
		toRadian:function(x){
			return x*Math.PI/180;
		}
	};
	Mexp.exception=function(message){
		this.message=message;
	};
    module.exports=Mexp;

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {


    var Mexp=__webpack_require__(1296);

	Mexp.prototype.toPostfix = function () {
		'use strict';
		var post=[],elem,popped,prep,pre,ele;
    	var stack=[{value:"(",type:4,pre:0}];
		var arr=this.value;
		for (var i=1; i < arr.length; i++) {
			if(arr[i].type===1||arr[i].type===3||arr[i].type===13){	//if token is number,constant,or n(which is also a special constant in our case)
				if(arr[i].type===1)
					arr[i].value=Number(arr[i].value);
				post.push(arr[i]);
			}
			else if(arr[i].type===4){
				stack.push(arr[i]);
			}
			else if(arr[i].type===5){
				while((popped=stack.pop()).type!==4){
					post.push(popped);
				}
			}
			else if(arr[i].type===11){
				while((popped=stack.pop()).type!==4){
					post.push(popped);
				}
				stack.push(popped);
			}
			else {
				elem=arr[i];
				pre=elem.pre;
				ele=stack[stack.length-1];
				prep=ele.pre;
				var flag=ele.value=='Math.pow'&&elem.value=='Math.pow';
				if(pre>prep)stack.push(elem);
				else {
					while(prep>=pre&&!flag||flag&&pre<prep){
						popped=stack.pop();
						ele=stack[stack.length-1];
						post.push(popped);
						prep=ele.pre;
						flag=elem.value=='Math.pow'&&ele.value=='Math.pow';
					}
					stack.push(elem);
				}
			}
		}
		return new Mexp(post);
	};
    module.exports=Mexp;

/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

var Mexp=__webpack_require__(1298);
Mexp.prototype.postfixEval = function (UserDefined) {
	'use strict';
	UserDefined=UserDefined||{};
	UserDefined.PI=Math.PI;
	UserDefined.E=Math.E;
	var stack=[],pop1,pop2,pop3;
	var disp=[];
	var temp='';
	var arr=this.value;
	var bool=(typeof UserDefined.n!=="undefined");
	for(var i=0;i<arr.length;i++){
		if(arr[i].type===1){
			stack.push({value:arr[i].value,type:1});
		}
		else if(arr[i].type===3){
			stack.push({value:UserDefined[arr[i].value],type:1});
		}
		else if(arr[i].type===0){
			if(typeof stack[stack.length-1].type==="undefined"){
				stack[stack.length-1].value.push(arr[i]);
			}
			else stack[stack.length-1].value=arr[i].value(stack[stack.length-1].value);
		}
		else if(arr[i].type===7){
			if(typeof stack[stack.length-1].type==="undefined"){
				stack[stack.length-1].value.push(arr[i]);
			}
			else stack[stack.length-1].value=arr[i].value(stack[stack.length-1].value);
		}
		else if(arr[i].type===8){
			pop1=stack.pop();
			pop2=stack.pop();
			stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
		}
		else if(arr[i].type===10){
			pop1=stack.pop();
			pop2=stack.pop();
			if(typeof pop2.type==="undefined"){
				pop2.value=pop2.concat(pop1);
				pop2.value.push(arr[i]);
				stack.push(pop2);
			}
			else if (typeof pop1.type==="undefined") {
				pop1.unshift(pop2);
				pop1.push(arr[i]);
				stack.push(pop1);
			}
			else{
				stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
            }
		}
		else if(arr[i].type===2||arr[i].type===9){
			pop1=stack.pop();
			pop2=stack.pop();
			if(typeof pop2.type==="undefined"){
                console.log(pop2);
				pop2=pop2.concat(pop1);
				pop2.push(arr[i]);
				stack.push(pop2);
			}
			else if (typeof pop1.type==="undefined") {
				pop1.unshift(pop2);
				pop1.push(arr[i]);
				stack.push(pop1);
			}
			else{
				stack.push({type:1,value:arr[i].value(pop2.value,pop1.value)});
			}
		}
		else if(arr[i].type===12){
			pop1=stack.pop();
			if (typeof pop1.type!=="undefined") {
				pop1=[pop1];
			}
			pop2=stack.pop();
			pop3=stack.pop();
			stack.push({type:1,value:arr[i].value(pop3.value,pop2.value,new Mexp(pop1))});
		}
		else if(arr[i].type===13){
			if(bool){
				stack.push({value:UserDefined[arr[i].value],type:3});
			}
			else stack.push([arr[i]]);
		}
	}
	if (stack.length>1) {
		throw(new Mexp.exception("Uncaught Syntax error"));
	}
	return stack[0].value>1000000000000000?"Infinity":parseFloat(stack[0].value.toFixed(15));
};
Mexp.eval=function(str,tokens,obj){
	if (typeof tokens==="undefined") {
		return this.lex(str).toPostfix().postfixEval();
	}
	else if (typeof obj==="undefined") {
		if (typeof tokens.length!=="undefined") 
			return this.lex(str,tokens).toPostfix().postfixEval();
		else
			return this.lex(str).toPostfix().postfixEval(tokens);
	}
	else
		return this.lex(str,tokens).toPostfix().postfixEval(obj);
};
module.exports=Mexp;

/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(102)))

/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.12.6
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return window.document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  // NOTE: 1 DOM access here
  var offsetParent = element && element.offsetParent;
  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    if (element) {
      return element.ownerDocument.documentElement;
    }

    return window.document.documentElement;
  }

  // .offsetParent will return the closest TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return window.document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return +styles['border' + sideA + 'Width'].split('px')[0] + +styles['border' + sideB + 'Width'].split('px')[0];
}

/**
 * Tells if you are running Internet Explorer 10
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean} isIE10
 */
var isIE10 = undefined;

var isIE10$1 = function () {
  if (isIE10 === undefined) {
    isIE10 = navigator.appVersion.indexOf('MSIE 10') !== -1;
  }
  return isIE10;
};

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE10$1() ? html['offset' + axis] + computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')] + computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')] : 0);
}

function getWindowSizes() {
  var body = window.document.body;
  var html = window.document.documentElement;
  var computedStyle = isIE10$1() && window.getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  if (isIE10$1()) {
    try {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } catch (err) {}
  } else {
    rect = element.getBoundingClientRect();
  }

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes() : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var isIE10 = isIE10$1();
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = +styles.borderTopWidth.split('px')[0];
  var borderLeftWidth = +styles.borderLeftWidth.split('px')[0];

  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = +styles.marginTop.split('px')[0];
    var marginLeft = +styles.marginLeft.split('px')[0];

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = getScroll(html);
  var scrollLeft = getScroll(html, 'left');

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  // NOTE: 1 DOM access here
  var boundaries = { top: 0, left: 0 };
  var offsetParent = findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(popper));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  boundaries.left += padding;
  boundaries.top += padding;
  boundaries.right -= padding;
  boundaries.bottom -= padding;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var commonOffsetParent = findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop) + parseFloat(styles.marginBottom);
  var y = parseFloat(styles.marginLeft) + parseFloat(styles.marginRight);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
  data.offsets.popper.position = 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length - 1; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof window.document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroy the popper
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.left = '';
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger onUpdate callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    window.cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper.
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  // floor sides to avoid blurry text
  var offsets = {
    left: Math.floor(popper.left),
    top: Math.floor(popper.top),
    bottom: Math.floor(popper.bottom),
    right: Math.floor(popper.right)
  };

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    top = -offsetParentRect.height + offsets.bottom;
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    left = -offsetParentRect.width + offsets.right;
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjuction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var popperMarginSide = getStyleComputedProperty(data.instance.popper, 'margin' + sideCapitalized).replace('px', '');
  var sideValue = center - getClientRect(data.offsets.popper)[side] - popperMarginSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = {};
  data.offsets.arrow[side] = Math.round(sideValue);
  data.offsets.arrow[altSide] = ''; // make sure to unset any eventual altSide value from the DOM node

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-right` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement);
  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unitless, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the height.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > More on this [reading this issue](https://github.com/FezVrasta/popper.js/issues/373)
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * An scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper this makes sure the popper has always a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier, can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near eachothers
   * without leaving any gap between the two. Expecially useful when the arrow is
   * enabled and you want to assure it to point to its reference element.
   * It cares only about the first axis, you can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjuction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations).
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position,
     * the popper will never be placed outside of the defined boundaries
     * (except if keepTogether is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define you own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3d transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties.
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the informations used by Popper.js
 * this object get passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper.
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow, it expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements.
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overriden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass as 3rd argument an object with the same
 * structure of this object, example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Whether events (resize, scroll) are initially enabled
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated, this callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Create a new Popper.js instance
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as popper.
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedule an update, it will run on the next UI update available
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["default"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(51)))

/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(553);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._81 = 1;
  p._65 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._81 === 3) {
            val = val._65;
          }
          if (val._81 === 1) return res(i, val._65);
          if (val._81 === 2) reject(val._65);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(553);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._10 = null;
  Promise._97 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._10 = function (promise) {
    if (
      promise._81 === 2 && // IS REJECTED
      rejections[promise._72]
    ) {
      if (rejections[promise._72].logged) {
        onHandled(promise._72);
      } else {
        clearTimeout(rejections[promise._72].timeout);
      }
      delete rejections[promise._72];
    }
  };
  Promise._97 = function (promise, err) {
    if (promise._45 === 0) { // not yet handled
      promise._72 = id++;
      rejections[promise._72] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._72),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = deprecated;

var _warning = __webpack_require__(1305);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warned = {};

function deprecated(validator, reason) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] != null) {
      var messageKey = componentName + '.' + propName;

      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));

      warned[messageKey] = true;
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}

/* eslint-disable no-underscore-dangle */
function _resetWarned() {
  warned = {};
}

deprecated._resetWarned = _resetWarned;
/* eslint-enable no-underscore-dangle */

module.exports = exports['default'];

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (false) {
  var invariant = require('fbjs/lib/invariant');
  var warning = require('fbjs/lib/warning');
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(37);
var invariant = __webpack_require__(17);
var ReactPropTypesSecret = __webpack_require__(555);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(37);
var invariant = __webpack_require__(17);
var warning = __webpack_require__(21);
var assign = __webpack_require__(22);

var ReactPropTypesSecret = __webpack_require__(555);
var checkPropTypes = __webpack_require__(1306);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Const = __webpack_require__(35);

var _Const2 = _interopRequireDefault(_Const);

var _TableHeader = __webpack_require__(1318);

var _TableHeader2 = _interopRequireDefault(_TableHeader);

var _TableBody = __webpack_require__(1314);

var _TableBody2 = _interopRequireDefault(_TableBody);

var _PaginationList = __webpack_require__(1328);

var _PaginationList2 = _interopRequireDefault(_PaginationList);

var _ToolBar = __webpack_require__(1332);

var _ToolBar2 = _interopRequireDefault(_ToolBar);

var _TableFilter = __webpack_require__(1317);

var _TableFilter2 = _interopRequireDefault(_TableFilter);

var _TableDataStore = __webpack_require__(1329);

var _util = __webpack_require__(87);

var _util2 = _interopRequireDefault(_util);

var _csv_export_util = __webpack_require__(1320);

var _csv_export_util2 = _interopRequireDefault(_csv_export_util);

var _Filter = __webpack_require__(1312);

var _TableHeaderColumn = __webpack_require__(560);

var _TableHeaderColumn2 = _interopRequireDefault(_TableHeaderColumn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-alert: 0 */
/* eslint max-len: 0 */


var BootstrapTable = function (_Component) {
  _inherits(BootstrapTable, _Component);

  function BootstrapTable(props) {
    _classCallCheck(this, BootstrapTable);

    var _this = _possibleConstructorReturn(this, (BootstrapTable.__proto__ || Object.getPrototypeOf(BootstrapTable)).call(this, props));

    _this.handleSort = function () {
      return _this.__handleSort__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleExpandRow = function () {
      return _this.__handleExpandRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handlePaginationData = function () {
      return _this.__handlePaginationData__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleMouseLeave = function () {
      return _this.__handleMouseLeave__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleMouseEnter = function () {
      return _this.__handleMouseEnter__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowMouseOut = function () {
      return _this.__handleRowMouseOut__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowMouseOver = function () {
      return _this.__handleRowMouseOver__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleNavigateCell = function () {
      return _this.__handleNavigateCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowClick = function () {
      return _this.__handleRowClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowDoubleClick = function () {
      return _this.__handleRowDoubleClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleSelectAllRow = function () {
      return _this.__handleSelectAllRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleShowOnlySelected = function () {
      return _this.__handleShowOnlySelected__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleSelectRow = function () {
      return _this.__handleSelectRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleEditCell = function () {
      return _this.__handleEditCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleAddRow = function () {
      return _this.__handleAddRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.getPageByRowKey = function () {
      return _this.__getPageByRowKey__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleDropRow = function () {
      return _this.__handleDropRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleFilterData = function () {
      return _this.__handleFilterData__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleExportCSV = function () {
      return _this.__handleExportCSV__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleSearch = function () {
      return _this.__handleSearch__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this._scrollTop = function () {
      return _this.___scrollTop__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this._scrollHeader = function () {
      return _this.___scrollHeader__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.isIE = false;
    if (_util2.default.canUseDOM()) {
      _this.isIE = document.documentMode;
    }
    _this.store = new _TableDataStore.TableDataStore(_this.props.data ? _this.props.data.slice() : []);
    _this.isVerticalScroll = false;
    _this.initTable(_this.props);

    if (_this.props.selectRow && _this.props.selectRow.selected) {
      var copy = _this.props.selectRow.selected.slice();
      _this.store.setSelectedRowKey(copy);
    }
    var currPage = _Const2.default.PAGE_START_INDEX;
    if (typeof _this.props.options.page !== 'undefined') {
      currPage = _this.props.options.page;
    } else if (typeof _this.props.options.pageStartIndex !== 'undefined') {
      currPage = _this.props.options.pageStartIndex;
    }

    _this._adjustHeaderWidth = _this._adjustHeaderWidth.bind(_this);
    _this._adjustHeight = _this._adjustHeight.bind(_this);
    _this._adjustTable = _this._adjustTable.bind(_this);

    _this.state = {
      data: _this.getTableData(),
      currPage: currPage,
      expanding: _this.props.options.expanding || [],
      sizePerPage: _this.props.options.sizePerPage || _Const2.default.SIZE_PER_PAGE_LIST[0],
      selectedRowKeys: _this.store.getSelectedRowKeys(),
      reset: false,
      x: _this.props.keyBoardNav ? 0 : -1,
      y: _this.props.keyBoardNav ? 0 : -1
    };
    return _this;
  }

  _createClass(BootstrapTable, [{
    key: 'initTable',
    value: function initTable(props) {
      var _this2 = this;

      var keyField = props.keyField;


      var isKeyFieldDefined = typeof keyField === 'string' && keyField.length;
      _react2.default.Children.forEach(props.children, function (column) {
        if (column === null || column === undefined) {
          // Skip null and undefined value
          return;
        }
        if (column.props.isKey) {
          if (keyField) {
            throw new Error('Error. Multiple key column be detected in TableHeaderColumn.');
          }
          keyField = column.props.dataField;
        }
        if (column.props.filter) {
          // a column contains a filter
          if (!_this2.filter) {
            // first time create the filter on the BootstrapTable
            _this2.filter = new _Filter.Filter();
          }
          // pass the filter to column with filter
          column.props.filter.emitter = _this2.filter;
        }
      });

      if (this.filter) {
        this.filter.removeAllListeners('onFilterChange');
        this.filter.on('onFilterChange', function (currentFilter) {
          _this2.handleFilterData(currentFilter);
        });
      }

      this.colInfos = this.getColumnsDescription(props).reduce(function (prev, curr) {
        prev[curr.name] = curr;
        return prev;
      }, {});

      if (!isKeyFieldDefined && !keyField) {
        throw new Error('Error. No any key column defined in TableHeaderColumn.\n            Use \'isKey={true}\' to specify a unique column after version 0.5.4.');
      }

      this.store.setProps({
        isPagination: props.pagination,
        keyField: keyField,
        colInfos: this.colInfos,
        multiColumnSearch: props.multiColumnSearch,
        strictSearch: props.strictSearch,
        multiColumnSort: props.multiColumnSort,
        remote: this.props.remote
      });
    }
  }, {
    key: 'getTableData',
    value: function getTableData() {
      var result = [];
      var _props = this.props,
          options = _props.options,
          pagination = _props.pagination;

      var sortName = options.defaultSortName || options.sortName;
      var sortOrder = options.defaultSortOrder || options.sortOrder;
      var searchText = options.defaultSearch;

      if (sortName && sortOrder) {
        this.store.setSortInfo(sortOrder, sortName);
        if (!this.allowRemote(_Const2.default.REMOTE_SORT)) {
          this.store.sort();
        }
      }

      if (searchText) {
        this.store.search(searchText);
      }

      if (pagination) {
        var page = void 0;
        var sizePerPage = void 0;
        if (this.store.isChangedPage()) {
          sizePerPage = this.state.sizePerPage;
          page = this.state.currPage;
        } else {
          sizePerPage = options.sizePerPage || _Const2.default.SIZE_PER_PAGE_LIST[0];
          page = options.page || 1;
        }
        result = this.store.page(page, sizePerPage).get();
      } else {
        result = this.store.get();
      }
      return result;
    }
  }, {
    key: 'getColumnsDescription',
    value: function getColumnsDescription(_ref) {
      var _this3 = this;

      var children = _ref.children;

      var rowCount = 0;
      _react2.default.Children.forEach(children, function (column) {
        if (column === null || column === undefined) {
          // Skip null and undefined value
          return;
        }

        if (Number(column.props.row) > rowCount) {
          rowCount = Number(column.props.row);
        }
      });
      return _react2.default.Children.map(children, function (column, i) {
        if (column === null || column === undefined) {
          // Return null for empty objects
          return null;
        }

        var rowIndex = column.props.row ? Number(column.props.row) : 0;
        var rowSpan = column.props.rowSpan ? Number(column.props.rowSpan) : 1;
        if (rowSpan + rowIndex === rowCount + 1) {
          var columnDescription = _this3.getColumnDescription(column);

          columnDescription.index = i;

          return columnDescription;
        }
      });
    }
  }, {
    key: 'getColumnDescription',
    value: function getColumnDescription(column) {
      var columnDescription = {
        name: column.props.dataField,
        align: column.props.dataAlign,
        sort: column.props.dataSort,
        format: column.props.dataFormat,
        formatExtraData: column.props.formatExtraData,
        filterFormatted: column.props.filterFormatted,
        filterValue: column.props.filterValue,
        editable: column.props.editable,
        customEditor: column.props.customEditor,
        hidden: column.props.hidden,
        hiddenOnInsert: column.props.hiddenOnInsert,
        searchable: column.props.searchable,
        className: column.props.columnClassName,
        editClassName: column.props.editColumnClassName,
        invalidEditColumnClassName: column.props.invalidEditColumnClassName,
        columnTitle: column.props.columnTitle,
        width: column.props.width,
        text: column.props.headerText || column.props.children,
        sortFunc: column.props.sortFunc,
        sortFuncExtraData: column.props.sortFuncExtraData,
        export: column.props.export,
        expandable: column.props.expandable,
        attrs: column.props.tdAttr,
        style: column.props.tdStyle
      };

      if (column.type !== _TableHeaderColumn2.default && _react2.default.isValidElement(column.props.children)) {
        columnDescription = _extends({}, columnDescription, this.getColumnDescription(_react2.default.Children.only(column.props.children)));
      }

      return columnDescription;
    }
  }, {
    key: 'reset',
    value: function reset() {
      var _this4 = this;

      var pageStartIndex = this.props.options.pageStartIndex;

      this.store.clean();
      this.setState(function () {
        return {
          data: _this4.getTableData(),
          currPage: _util2.default.getFirstPage(pageStartIndex),
          expanding: [],
          sizePerPage: _Const2.default.SIZE_PER_PAGE_LIST[0],
          selectedRowKeys: _this4.store.getSelectedRowKeys(),
          reset: true
        };
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.initTable(nextProps);
      var options = nextProps.options,
          selectRow = nextProps.selectRow;
      var replace = nextProps.replace;

      replace = replace || this.props.replace;

      if (!nextProps.data) {
        return;
      }
      this.store.setData(nextProps.data.slice());

      if (!replace) {
        // from #481
        var page = this.state.currPage;
        if (this.props.options.page !== options.page) {
          page = options.page;
        }
        // from #481
        var sizePerPage = this.state.sizePerPage;
        if (this.props.options.sizePerPage !== options.sizePerPage) {
          sizePerPage = options.sizePerPage;
        }

        if (this.isRemoteDataSource()) {
          var data = nextProps.data.slice();
          if (nextProps.pagination && !this.allowRemote(_Const2.default.REMOTE_PAGE)) {
            data = this.store.page(page, sizePerPage).get();
          }
          this.setState(function () {
            return {
              data: data,
              currPage: page,
              sizePerPage: sizePerPage,
              reset: false
            };
          });
        } else {
          // #125
          // remove !options.page for #709
          if (page > Math.ceil(nextProps.data.length / sizePerPage)) {
            page = 1;
          }
          var sortList = this.store.getSortInfo();
          var sortField = options.sortName;
          var sortOrder = options.sortOrder;
          if (sortField && sortOrder) {
            this.store.setSortInfo(sortOrder, sortField);
            this.store.sort();
          } else if (sortList.length > 0) {
            this.store.sort();
          }
          var _data = this.store.page(page, sizePerPage).get();
          this.setState(function () {
            return {
              data: _data,
              currPage: page,
              sizePerPage: sizePerPage,
              reset: false
            };
          });

          if (this.store.isSearching && options.afterSearch) {
            options.afterSearch(this.store.searchText, this.store.getDataIgnoringPagination());
          }

          if (this.store.isFiltering && options.afterColumnFilter) {
            options.afterColumnFilter(this.store.filterObj, this.store.getDataIgnoringPagination());
          }
        }

        // If setting the expanded rows is being handled externally
        // then overwrite the current expanded rows.
        if (this.props.options.expanding !== options.expanding) {
          this.setState(function () {
            return {
              expanding: options.expanding || []
            };
          });
        }

        if (selectRow && selectRow.selected) {
          // set default select rows to store.
          var copy = selectRow.selected.slice();
          this.store.setSelectedRowKey(copy);
          this.setState(function () {
            return {
              selectedRowKeys: copy,
              reset: false
            };
          });
        }
      } else {
        this.reset();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._adjustTable();
      window.addEventListener('resize', this._adjustTable);
      this.refs.body.refs.container.addEventListener('scroll', this._scrollHeader);
      if (this.props.scrollTop) {
        this._scrollTop();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this._adjustTable);
      if (this.refs && this.refs.body && this.refs.body.refs) {
        this.refs.body.refs.container.removeEventListener('scroll', this._scrollHeader);
      }
      if (this.filter) {
        this.filter.removeAllListeners('onFilterChange');
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._adjustTable();
      if (this.props.options.afterTableComplete) {
        this.props.options.afterTableComplete();
      }
    }

    /**
     * Returns true if in the current configuration,
     * the datagrid should load its data remotely.
     *
     * @param  {Object}  [props] Optional. If not given, this.props will be used
     * @return {Boolean}
     */

  }, {
    key: 'isRemoteDataSource',
    value: function isRemoteDataSource(props) {
      var _ref2 = props || this.props,
          remote = _ref2.remote;

      return remote === true || _util2.default.isFunction(remote);
    }

    /**
     * Returns true if this action can be handled remote store
     * From #990, Sometimes, we need some actions as remote, some actions are handled by default
     * so function will tell you the target action is can be handled as remote or not.
     * @param  {String}  [action] Required.
     * @param  {Object}  [props] Optional. If not given, this.props will be used
     * @return {Boolean}
     */

  }, {
    key: 'allowRemote',
    value: function allowRemote(action, props) {
      var _ref3 = props || this.props,
          remote = _ref3.remote;

      if (typeof remote === 'function') {
        var remoteObj = remote(_Const2.default.REMOTE);
        return remoteObj[action];
      } else {
        return remote;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var style = {
        height: this.props.height,
        maxHeight: this.props.maxHeight
      };

      var columns = this.getColumnsDescription(this.props);
      var sortList = this.store.getSortInfo();
      var pagination = this.renderPagination();
      var toolBar = this.renderToolBar();
      var tableFilter = this.renderTableFilter(columns);
      var isSelectAll = this.isSelectAll();
      var expandColumnOptions = this.props.expandColumnOptions;
      if (typeof expandColumnOptions.expandColumnBeforeSelectColumn === 'undefined') {
        expandColumnOptions.expandColumnBeforeSelectColumn = true;
      }
      var colGroups = _util2.default.renderColGroup(columns, this.props.selectRow, expandColumnOptions);
      var sortIndicator = this.props.options.sortIndicator;
      if (typeof this.props.options.sortIndicator === 'undefined') sortIndicator = true;
      var _props$options$pagina = this.props.options.paginationPosition,
          paginationPosition = _props$options$pagina === undefined ? _Const2.default.PAGINATION_POS_BOTTOM : _props$options$pagina;

      var showPaginationOnTop = paginationPosition !== _Const2.default.PAGINATION_POS_BOTTOM;
      var showPaginationOnBottom = paginationPosition !== _Const2.default.PAGINATION_POS_TOP;
      var selectRow = _extends({}, this.props.selectRow);
      if (this.props.cellEdit && this.props.cellEdit.mode !== _Const2.default.CELL_EDIT_NONE) {
        selectRow.clickToSelect = false;
      }

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('react-bs-table-container', this.props.className, this.props.containerClass),
          style: this.props.containerStyle },
        toolBar,
        showPaginationOnTop ? pagination : null,
        _react2.default.createElement(
          'div',
          { ref: 'table',
            className: (0, _classnames2.default)('react-bs-table', { 'react-bs-table-bordered': this.props.bordered }, this.props.tableContainerClass),
            style: _extends({}, style, this.props.tableStyle),
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave },
          _react2.default.createElement(
            _TableHeader2.default,
            {
              ref: 'header',
              colGroups: colGroups,
              headerContainerClass: this.props.headerContainerClass,
              tableHeaderClass: this.props.tableHeaderClass,
              style: this.props.headerStyle,
              rowSelectType: this.props.selectRow.mode,
              customComponent: this.props.selectRow.customComponent,
              hideSelectColumn: this.props.selectRow.hideSelectColumn,
              sortList: sortList,
              sortIndicator: sortIndicator,
              onSort: this.handleSort,
              onSelectAllRow: this.handleSelectAllRow,
              bordered: this.props.bordered,
              condensed: this.props.condensed,
              isFiltered: this.filter ? true : false,
              isSelectAll: isSelectAll,
              reset: this.state.reset,
              expandColumnVisible: expandColumnOptions.expandColumnVisible,
              expandColumnComponent: expandColumnOptions.expandColumnComponent,
              expandColumnBeforeSelectColumn: expandColumnOptions.expandColumnBeforeSelectColumn },
            this.props.children
          ),
          _react2.default.createElement(_TableBody2.default, { ref: 'body',
            bodyContainerClass: this.props.bodyContainerClass,
            tableBodyClass: this.props.tableBodyClass,
            style: _extends({}, style, this.props.bodyStyle),
            data: this.state.data,
            expandComponent: this.props.expandComponent,
            expandableRow: this.props.expandableRow,
            expandRowBgColor: this.props.options.expandRowBgColor,
            expandBy: this.props.options.expandBy || _Const2.default.EXPAND_BY_ROW,
            expandBodyClass: this.props.options.expandBodyClass,
            expandParentClass: this.props.options.expandParentClass,
            columns: columns,
            trClassName: this.props.trClassName,
            trStyle: this.props.trStyle,
            striped: this.props.striped,
            bordered: this.props.bordered,
            hover: this.props.hover,
            keyField: this.store.getKeyField(),
            condensed: this.props.condensed,
            selectRow: selectRow,
            expandColumnOptions: this.props.expandColumnOptions,
            cellEdit: this.props.cellEdit,
            selectedRowKeys: this.state.selectedRowKeys,
            onRowClick: this.handleRowClick,
            onRowDoubleClick: this.handleRowDoubleClick,
            onRowMouseOver: this.handleRowMouseOver,
            onRowMouseOut: this.handleRowMouseOut,
            onSelectRow: this.handleSelectRow,
            noDataText: this.props.options.noDataText,
            withoutNoDataText: this.props.options.withoutNoDataText,
            expanding: this.state.expanding,
            onExpand: this.handleExpandRow,
            onlyOneExpanding: this.props.options.onlyOneExpanding,
            beforeShowError: this.props.options.beforeShowError,
            keyBoardNav: this.props.keyBoardNav,
            onNavigateCell: this.handleNavigateCell,
            x: this.state.x,
            y: this.state.y,
            withoutTabIndex: this.props.withoutTabIndex,
            onEditCell: this.handleEditCell })
        ),
        tableFilter,
        showPaginationOnBottom ? pagination : null
      );
    }
  }, {
    key: 'isSelectAll',
    value: function isSelectAll() {
      if (this.store.isEmpty()) return false;
      var _props$selectRow = this.props.selectRow,
          unselectable = _props$selectRow.unselectable,
          onlyUnselectVisible = _props$selectRow.onlyUnselectVisible;

      var keyField = this.store.getKeyField();
      var allRowKeys = onlyUnselectVisible ? this.store.get().map(function (r) {
        return r[keyField];
      }) : this.store.getAllRowkey();
      var defaultSelectRowKeys = this.store.getSelectedRowKeys();

      if (onlyUnselectVisible) {
        defaultSelectRowKeys = defaultSelectRowKeys.filter(function (x) {
          return x !== allRowKeys;
        });
      }

      if (defaultSelectRowKeys.length === 0) return false;
      var match = 0;
      var noFound = 0;
      var unSelectableCnt = 0;
      defaultSelectRowKeys.forEach(function (selected) {
        if (allRowKeys.indexOf(selected) !== -1) match++;else noFound++;
        if (unselectable && unselectable.indexOf(selected) !== -1) unSelectableCnt++;
      });

      if (noFound === defaultSelectRowKeys.length) return false;
      if (match === allRowKeys.length) {
        return true;
      } else {
        if (unselectable && match <= unSelectableCnt && unSelectableCnt === unselectable.length) return false;else return 'indeterminate';
      }
      // return (match === allRowKeys.length) ? true : 'indeterminate';
    }
  }, {
    key: 'cleanSelected',
    value: function cleanSelected() {
      this.store.setSelectedRowKey([]);
      this.setState(function () {
        return {
          selectedRowKeys: [],
          reset: false
        };
      });
    }
  }, {
    key: 'cleanSort',
    value: function cleanSort() {
      this.store.cleanSortInfo();
      this.setState(function () {
        return {
          reset: false
        };
      });
    }
  }, {
    key: '__handleSort__REACT_HOT_LOADER__',
    value: function __handleSort__REACT_HOT_LOADER__(order, sortField) {
      if (this.props.options.onSortChange) {
        this.props.options.onSortChange(sortField, order, this.props);
      }
      this.store.setSortInfo(order, sortField);
      if (this.allowRemote(_Const2.default.REMOTE_SORT)) {
        return;
      }

      var result = this.store.sort().get();
      this.setState(function () {
        return {
          data: result,
          reset: false
        };
      });
    }
  }, {
    key: '__handleExpandRow__REACT_HOT_LOADER__',
    value: function __handleExpandRow__REACT_HOT_LOADER__(expanding, rowKey, isRowExpanding) {
      var _this5 = this;

      var onExpand = this.props.options.onExpand;

      if (onExpand) {
        onExpand(rowKey, !isRowExpanding);
      }
      this.setState(function () {
        return { expanding: expanding, reset: false };
      }, function () {
        _this5._adjustHeaderWidth();
      });
    }
  }, {
    key: '__handlePaginationData__REACT_HOT_LOADER__',
    value: function __handlePaginationData__REACT_HOT_LOADER__(page, sizePerPage) {
      var _props$options = this.props.options,
          onPageChange = _props$options.onPageChange,
          pageStartIndex = _props$options.pageStartIndex;

      var emptyTable = this.store.isEmpty();
      if (onPageChange) {
        onPageChange(page, sizePerPage);
      }

      var state = {
        sizePerPage: sizePerPage,
        reset: false
      };
      if (!emptyTable) state.currPage = page;
      this.setState(function () {
        return state;
      });

      if (this.allowRemote(_Const2.default.REMOTE_PAGE) || emptyTable) {
        return;
      }

      var result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex, page), sizePerPage).get();
      this.setState(function () {
        return { data: result, reset: false };
      });
    }
  }, {
    key: '__handleMouseLeave__REACT_HOT_LOADER__',
    value: function __handleMouseLeave__REACT_HOT_LOADER__() {
      if (this.props.options.onMouseLeave) {
        this.props.options.onMouseLeave();
      }
    }
  }, {
    key: '__handleMouseEnter__REACT_HOT_LOADER__',
    value: function __handleMouseEnter__REACT_HOT_LOADER__() {
      if (this.props.options.onMouseEnter) {
        this.props.options.onMouseEnter();
      }
    }
  }, {
    key: '__handleRowMouseOut__REACT_HOT_LOADER__',
    value: function __handleRowMouseOut__REACT_HOT_LOADER__(row, event) {
      if (this.props.options.onRowMouseOut) {
        this.props.options.onRowMouseOut(row, event);
      }
    }
  }, {
    key: '__handleRowMouseOver__REACT_HOT_LOADER__',
    value: function __handleRowMouseOver__REACT_HOT_LOADER__(row, event) {
      if (this.props.options.onRowMouseOver) {
        this.props.options.onRowMouseOver(row, event);
      }
    }
  }, {
    key: '__handleNavigateCell__REACT_HOT_LOADER__',
    value: function __handleNavigateCell__REACT_HOT_LOADER__(_ref4) {
      var offSetX = _ref4.x,
          offSetY = _ref4.y,
          lastEditCell = _ref4.lastEditCell;
      var pagination = this.props.pagination;
      var _state = this.state,
          x = _state.x,
          y = _state.y,
          currPage = _state.currPage;

      x += offSetX;
      y += offSetY;

      var columns = this.store.getColInfos();
      var visibleRowSize = this.state.data.length;
      var visibleColumnSize = Object.keys(columns).filter(function (k) {
        return !columns[k].hidden;
      }).length;

      if (y >= visibleRowSize) {
        currPage++;
        var lastPage = pagination ? this.refs.pagination.getLastPage() : -1;
        if (currPage <= lastPage) {
          this.handlePaginationData(currPage, this.state.sizePerPage);
        } else {
          return;
        }
        y = 0;
      } else if (y < 0) {
        currPage--;
        if (currPage > 0) {
          this.handlePaginationData(currPage, this.state.sizePerPage);
        } else {
          return;
        }
        y = visibleRowSize - 1;
      } else if (x >= visibleColumnSize) {
        if (y + 1 === visibleRowSize) {
          currPage++;
          var _lastPage = pagination ? this.refs.pagination.getLastPage() : -1;
          if (currPage <= _lastPage) {
            this.handlePaginationData(currPage, this.state.sizePerPage);
          } else {
            return;
          }
          y = 0;
        } else {
          y++;
        }
        x = lastEditCell ? 1 : 0;
      } else if (x < 0) {
        x = visibleColumnSize - 1;
        if (y === 0) {
          currPage--;
          if (currPage > 0) {
            this.handlePaginationData(currPage, this.state.sizePerPage);
          } else {
            return;
          }
          y = this.state.sizePerPage - 1;
        } else {
          y--;
        }
      }
      this.setState(function () {
        return {
          x: x, y: y, currPage: currPage, reset: false
        };
      });
    }
  }, {
    key: '__handleRowClick__REACT_HOT_LOADER__',
    value: function __handleRowClick__REACT_HOT_LOADER__(row, rowIndex, columnIndex) {
      var _props2 = this.props,
          options = _props2.options,
          keyBoardNav = _props2.keyBoardNav;

      if (options.onRowClick) {
        options.onRowClick(row, columnIndex, rowIndex);
      }
      if (keyBoardNav) {
        var _ref5 = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav : {},
            clickToNav = _ref5.clickToNav;

        clickToNav = clickToNav === false ? clickToNav : true;
        if (clickToNav) {
          this.setState(function () {
            return {
              x: columnIndex,
              y: rowIndex,
              reset: false
            };
          });
        }
      }
    }
  }, {
    key: '__handleRowDoubleClick__REACT_HOT_LOADER__',
    value: function __handleRowDoubleClick__REACT_HOT_LOADER__(row) {
      if (this.props.options.onRowDoubleClick) {
        this.props.options.onRowDoubleClick(row);
      }
    }
  }, {
    key: '__handleSelectAllRow__REACT_HOT_LOADER__',
    value: function __handleSelectAllRow__REACT_HOT_LOADER__(e) {
      var isSelected = e.currentTarget.checked;
      var keyField = this.store.getKeyField();
      var _props$selectRow2 = this.props.selectRow,
          onSelectAll = _props$selectRow2.onSelectAll,
          unselectable = _props$selectRow2.unselectable,
          selected = _props$selectRow2.selected,
          onlyUnselectVisible = _props$selectRow2.onlyUnselectVisible;

      var selectedRowKeys = onlyUnselectVisible ? this.state.selectedRowKeys : [];
      var result = true;
      var rows = this.store.get();

      // onlyUnselectVisible default is false, #1276
      if (!isSelected && !onlyUnselectVisible) {
        rows = this.store.getRowByKey(this.state.selectedRowKeys);
      }

      if (unselectable && unselectable.length > 0) {
        if (isSelected) {
          rows = rows.filter(function (r) {
            return unselectable.indexOf(r[keyField]) === -1 || selected && selected.indexOf(r[keyField]) !== -1;
          });
        } else {
          rows = rows.filter(function (r) {
            return unselectable.indexOf(r[keyField]) === -1;
          });
        }
      }

      if (onSelectAll) {
        result = this.props.selectRow.onSelectAll(isSelected, rows);
      }

      if (typeof result == 'undefined' || result !== false) {
        if (isSelected) {
          if (Array.isArray(result)) {
            selectedRowKeys = result;
          } else {
            var currentRowKeys = rows.map(function (r) {
              return r[keyField];
            });
            // onlyUnselectVisible default is false, #1276
            if (onlyUnselectVisible) {
              selectedRowKeys = selectedRowKeys.concat(currentRowKeys);
            } else {
              selectedRowKeys = currentRowKeys;
            }
          }
        } else {
          if (unselectable && selected) {
            selectedRowKeys = selected.filter(function (r) {
              return unselectable.indexOf(r) > -1;
            });
          } else if (onlyUnselectVisible) {
            var _currentRowKeys = rows.map(function (r) {
              return r[keyField];
            });
            selectedRowKeys = selectedRowKeys.filter(function (k) {
              return _currentRowKeys.indexOf(k) === -1;
            });
          }
        }

        this.store.setSelectedRowKey(selectedRowKeys);
        this.setState(function () {
          return { selectedRowKeys: selectedRowKeys, reset: false };
        });
      }
    }
  }, {
    key: '__handleShowOnlySelected__REACT_HOT_LOADER__',
    value: function __handleShowOnlySelected__REACT_HOT_LOADER__() {
      this.store.ignoreNonSelected();
      var pageStartIndex = this.props.options.pageStartIndex;

      var result = void 0;
      if (this.props.pagination) {
        result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex), this.state.sizePerPage).get();
      } else {
        result = this.store.get();
      }
      this.setState(function () {
        return {
          data: result,
          reset: false,
          currPage: _util2.default.getFirstPage(pageStartIndex)
        };
      });
    }
  }, {
    key: '__handleSelectRow__REACT_HOT_LOADER__',
    value: function __handleSelectRow__REACT_HOT_LOADER__(row, isSelected, e, rowIndex) {
      var result = true;
      var currSelected = this.store.getSelectedRowKeys();
      var rowKey = row[this.store.getKeyField()];
      var selectRow = this.props.selectRow;

      if (selectRow.onSelect) {
        result = selectRow.onSelect(row, isSelected, e, rowIndex);
      }

      if (typeof result === 'undefined' || result !== false) {
        if (selectRow.mode === _Const2.default.ROW_SELECT_SINGLE) {
          currSelected = isSelected ? [rowKey] : [];
        } else {
          if (isSelected) {
            currSelected.push(rowKey);
          } else {
            currSelected = currSelected.filter(function (key) {
              return rowKey !== key;
            });
          }
        }

        this.store.setSelectedRowKey(currSelected);
        this.setState(function () {
          return {
            selectedRowKeys: currSelected,
            reset: false
          };
        });
      }
    }
  }, {
    key: '__handleEditCell__REACT_HOT_LOADER__',
    value: function __handleEditCell__REACT_HOT_LOADER__(newVal, rowIndex, colIndex) {
      var _this6 = this;

      var beforeSaveCell = this.props.cellEdit.beforeSaveCell;

      var columns = this.getColumnsDescription(this.props);
      var fieldName = columns[colIndex].name;

      var invalid = function invalid() {
        _this6.setState(function () {
          return {
            data: _this6.store.get(),
            reset: false
          };
        });
        return;
      };

      if (beforeSaveCell) {
        var beforeSaveCellCB = function beforeSaveCellCB(result) {
          _this6.refs.body.cancelEditCell();
          if (result || result === undefined) {
            _this6.editCell(newVal, rowIndex, colIndex);
          } else {
            invalid();
          }
        };
        var isValid = beforeSaveCell(this.state.data[rowIndex], fieldName, newVal, beforeSaveCellCB);
        if (isValid === false && typeof isValid !== 'undefined') {
          return invalid();
        } else if (isValid === _Const2.default.AWAIT_BEFORE_CELL_EDIT) {
          /* eslint consistent-return: 0 */
          return isValid;
        }
      }
      this.editCell(newVal, rowIndex, colIndex);
    }
  }, {
    key: 'editCell',
    value: function editCell(newVal, rowIndex, colIndex) {
      var onCellEdit = this.props.options.onCellEdit;
      var afterSaveCell = this.props.cellEdit.afterSaveCell;

      var columns = this.getColumnsDescription(this.props);
      var fieldName = columns[colIndex].name;
      if (onCellEdit) {
        newVal = onCellEdit(this.state.data[rowIndex], fieldName, newVal);
      }

      if (this.allowRemote(_Const2.default.REMOTE_CELL_EDIT)) {
        if (afterSaveCell) {
          afterSaveCell(this.state.data[rowIndex], fieldName, newVal);
        }
        return;
      }

      var result = this.store.edit(newVal, rowIndex, fieldName).get();
      this.setState(function () {
        return {
          data: result,
          reset: false
        };
      });

      if (afterSaveCell) {
        afterSaveCell(this.state.data[rowIndex], fieldName, newVal);
      }
    }
  }, {
    key: 'handleAddRowAtBegin',
    value: function handleAddRowAtBegin(newObj) {
      try {
        this.store.addAtBegin(newObj);
      } catch (e) {
        return e;
      }
      this._handleAfterAddingRow(newObj, true);
    }
  }, {
    key: '__handleAddRow__REACT_HOT_LOADER__',
    value: function __handleAddRow__REACT_HOT_LOADER__(newObj) {
      var _this7 = this;

      var isAsync = false;
      var onAddRow = this.props.options.onAddRow;


      var afterHandleAddRow = function afterHandleAddRow(errMsg) {
        if (isAsync) {
          _this7.refs.toolbar.afterHandleSaveBtnClick(errMsg);
        } else {
          return errMsg;
        }
      };

      var afterAddRowCB = function afterAddRowCB(errMsg) {
        if (typeof errMsg !== 'undefined' && errMsg !== '') return afterHandleAddRow(errMsg);
        if (_this7.allowRemote(_Const2.default.REMOTE_INSERT_ROW)) {
          if (_this7.props.options.afterInsertRow) {
            _this7.props.options.afterInsertRow(newObj);
          }
          return afterHandleAddRow();
        }

        try {
          _this7.store.add(newObj);
        } catch (e) {
          return afterHandleAddRow(e.message);
        }
        _this7._handleAfterAddingRow(newObj, false);
        return afterHandleAddRow();
      };

      if (onAddRow) {
        var colInfos = this.store.getColInfos();
        var errMsg = onAddRow(newObj, colInfos, afterAddRowCB);

        if (errMsg !== '' && errMsg !== false) {
          return errMsg;
        } else if (typeof errMsg === 'undefined') {
          return afterAddRowCB();
        } else {
          isAsync = true;
          return !isAsync;
        }
      } else {
        return afterAddRowCB();
      }
    }
  }, {
    key: 'getSizePerPage',
    value: function getSizePerPage() {
      return this.state.sizePerPage;
    }
  }, {
    key: 'getCurrentPage',
    value: function getCurrentPage() {
      return this.state.currPage;
    }
  }, {
    key: 'getTableDataIgnorePaging',
    value: function getTableDataIgnorePaging() {
      return this.store.getCurrentDisplayData();
    }
  }, {
    key: '__getPageByRowKey__REACT_HOT_LOADER__',
    value: function __getPageByRowKey__REACT_HOT_LOADER__(rowKey) {
      var sizePerPage = this.state.sizePerPage;

      var currentData = this.store.getCurrentDisplayData();
      var keyField = this.store.getKeyField();
      var result = currentData.findIndex(function (x) {
        return x[keyField] === rowKey;
      });
      if (result > -1) {
        return parseInt(result / sizePerPage, 10) + 1;
      } else {
        return result;
      }
    }
  }, {
    key: '__handleDropRow__REACT_HOT_LOADER__',
    value: function __handleDropRow__REACT_HOT_LOADER__(rowKeys) {
      var _this8 = this;

      var dropRowKeys = rowKeys ? rowKeys : this.store.getSelectedRowKeys();
      // add confirm before the delete action if that option is set.
      if (dropRowKeys && dropRowKeys.length > 0) {
        if (this.props.options.handleConfirmDeleteRow) {
          this.props.options.handleConfirmDeleteRow(function () {
            _this8.deleteRow(dropRowKeys);
          }, dropRowKeys);
        } else if (confirm('Are you sure you want to delete?')) {
          this.deleteRow(dropRowKeys);
        }
      }
    }
  }, {
    key: 'deleteRow',
    value: function deleteRow(dropRowKeys) {
      var _this9 = this;

      var dropRow = this.store.getRowByKey(dropRowKeys);
      var _props$options2 = this.props.options,
          onDeleteRow = _props$options2.onDeleteRow,
          afterDeleteRow = _props$options2.afterDeleteRow;


      if (onDeleteRow) {
        onDeleteRow(dropRowKeys, dropRow);
      }

      this.store.setSelectedRowKey([]); // clear selected row key

      if (this.allowRemote(_Const2.default.REMOTE_DROP_ROW) && afterDeleteRow) {
        afterDeleteRow(dropRowKeys, dropRow);
        return;
      }

      this.store.remove(dropRowKeys); // remove selected Row
      var result = void 0;
      if (this.props.pagination) {
        var sizePerPage = this.state.sizePerPage;

        var currLastPage = Math.ceil(this.store.getDataNum() / sizePerPage);
        var currPage = this.state.currPage;

        if (currPage > currLastPage) currPage = currLastPage;
        result = this.store.page(_util2.default.getNormalizedPage(currPage), sizePerPage).get();
        this.setState(function () {
          return {
            data: result,
            selectedRowKeys: _this9.store.getSelectedRowKeys(),
            currPage: currPage,
            reset: false
          };
        });
      } else {
        result = this.store.get();
        this.setState(function () {
          return {
            data: result,
            reset: false,
            selectedRowKeys: _this9.store.getSelectedRowKeys()
          };
        });
      }
      if (afterDeleteRow) {
        afterDeleteRow(dropRowKeys, dropRow);
      }
    }
  }, {
    key: '__handleFilterData__REACT_HOT_LOADER__',
    value: function __handleFilterData__REACT_HOT_LOADER__(filterObj) {
      var _props$options3 = this.props.options,
          onFilterChange = _props$options3.onFilterChange,
          pageStartIndex = _props$options3.pageStartIndex;

      if (onFilterChange) {
        var colInfos = this.store.getColInfos();
        onFilterChange(filterObj, colInfos);
      }

      this.setState(function () {
        return {
          currPage: _util2.default.getFirstPage(pageStartIndex),
          reset: false
        };
      });

      if (this.allowRemote(_Const2.default.REMOTE_FILTER)) {
        if (this.props.options.afterColumnFilter) {
          this.props.options.afterColumnFilter(filterObj, this.store.getDataIgnoringPagination());
        }
        return;
      }

      this.store.filter(filterObj);

      var sortList = this.store.getSortInfo();

      if (sortList.length > 0) {
        this.store.sort();
      }

      var result = void 0;

      if (this.props.pagination) {
        var sizePerPage = this.state.sizePerPage;

        result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex), sizePerPage).get();
      } else {
        result = this.store.get();
      }
      if (this.props.options.afterColumnFilter) {
        this.props.options.afterColumnFilter(filterObj, this.store.getDataIgnoringPagination());
      }
      this.setState(function () {
        return {
          data: result,
          reset: false
        };
      });
    }
  }, {
    key: '__handleExportCSV__REACT_HOT_LOADER__',
    value: function __handleExportCSV__REACT_HOT_LOADER__() {
      var result = {};

      var csvFileName = this.props.csvFileName;
      var _props$options4 = this.props.options,
          onExportToCSV = _props$options4.onExportToCSV,
          exportCSVSeparator = _props$options4.exportCSVSeparator,
          noAutoBOM = _props$options4.noAutoBOM,
          excludeCSVHeader = _props$options4.excludeCSVHeader;

      if (onExportToCSV) {
        result = onExportToCSV();
      } else {
        result = this.store.getDataIgnoringPagination();
      }
      var separator = exportCSVSeparator || _Const2.default.DEFAULT_CSV_SEPARATOR;
      var keys = [];
      this.props.children.filter(function (_) {
        return _ != null;
      }).map(function (column) {
        if (column.props.export === true || typeof column.props.export === 'undefined' && column.props.hidden === false) {
          keys.push({
            field: column.props.dataField,
            format: column.props.csvFormat,
            extraData: column.props.csvFormatExtraData,
            header: column.props.csvHeader || column.props.dataField,
            row: Number(column.props.row) || 0,
            rowSpan: Number(column.props.rowSpan) || 1,
            colSpan: Number(column.props.colSpan) || 1
          });
        }
      });

      if (_util2.default.isFunction(csvFileName)) {
        csvFileName = csvFileName();
      }

      (0, _csv_export_util2.default)(result, keys, csvFileName, separator, noAutoBOM, excludeCSVHeader);
    }
  }, {
    key: '__handleSearch__REACT_HOT_LOADER__',
    value: function __handleSearch__REACT_HOT_LOADER__(searchText) {
      // Set search field if this function being called outside
      // but it's not necessary if calling fron inside.
      if (this.refs.toolbar) {
        this.refs.toolbar.setSearchInput(searchText);
      }
      var _props$options5 = this.props.options,
          onSearchChange = _props$options5.onSearchChange,
          pageStartIndex = _props$options5.pageStartIndex;

      if (onSearchChange) {
        var colInfos = this.store.getColInfos();
        onSearchChange(searchText, colInfos, this.props.multiColumnSearch);
      }

      this.setState(function () {
        return {
          currPage: _util2.default.getFirstPage(pageStartIndex),
          reset: false
        };
      });

      if (this.allowRemote(_Const2.default.REMOTE_SEARCH)) {
        if (this.props.options.afterSearch) {
          this.props.options.afterSearch(searchText, this.store.getDataIgnoringPagination());
        }
        return;
      }

      this.store.search(searchText);

      var sortList = this.store.getSortInfo();

      if (sortList.length > 0) {
        this.store.sort();
      }

      var result = void 0;
      if (this.props.pagination) {
        var sizePerPage = this.state.sizePerPage;

        result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex), sizePerPage).get();
      } else {
        result = this.store.get();
      }
      if (this.props.options.afterSearch) {
        this.props.options.afterSearch(searchText, this.store.getDataIgnoringPagination());
      }
      this.setState(function () {
        return {
          data: result,
          reset: false
        };
      });
    }
  }, {
    key: 'renderPagination',
    value: function renderPagination() {
      if (this.props.pagination) {
        var dataSize = void 0;
        if (this.allowRemote(_Const2.default.REMOTE_PAGE)) {
          dataSize = this.props.fetchInfo.dataTotalSize;
        } else {
          dataSize = this.store.getDataNum();
        }
        var options = this.props.options;

        var withFirstAndLast = options.withFirstAndLast === undefined ? true : options.withFirstAndLast;
        if (Math.ceil(dataSize / this.state.sizePerPage) <= 1 && this.props.ignoreSinglePage) return null;
        return _react2.default.createElement(
          'div',
          { className: 'react-bs-table-pagination' },
          _react2.default.createElement(_PaginationList2.default, {
            ref: 'pagination',
            withFirstAndLast: withFirstAndLast,
            alwaysShowAllBtns: options.alwaysShowAllBtns,
            currPage: this.state.currPage,
            changePage: this.handlePaginationData,
            sizePerPage: this.state.sizePerPage,
            sizePerPageList: options.sizePerPageList || _Const2.default.SIZE_PER_PAGE_LIST,
            pageStartIndex: options.pageStartIndex,
            paginationShowsTotal: options.paginationShowsTotal,
            paginationSize: options.paginationSize || _Const2.default.PAGINATION_SIZE,
            dataSize: dataSize,
            onSizePerPageList: options.onSizePerPageList,
            prePage: options.prePage || _Const2.default.PRE_PAGE,
            nextPage: options.nextPage || _Const2.default.NEXT_PAGE,
            firstPage: options.firstPage || _Const2.default.FIRST_PAGE,
            lastPage: options.lastPage || _Const2.default.LAST_PAGE,
            prePageTitle: options.prePageTitle || _Const2.default.PRE_PAGE_TITLE,
            nextPageTitle: options.nextPageTitle || _Const2.default.NEXT_PAGE_TITLE,
            firstPageTitle: options.firstPageTitle || _Const2.default.FIRST_PAGE_TITLE,
            lastPageTitle: options.lastPageTitle || _Const2.default.LAST_PAGE_TITLE,
            hideSizePerPage: options.hideSizePerPage,
            sizePerPageDropDown: options.sizePerPageDropDown,
            hidePageListOnlyOnePage: options.hidePageListOnlyOnePage,
            paginationPanel: options.paginationPanel,
            keepSizePerPageState: options.keepSizePerPageState,
            open: false })
        );
      }
      return null;
    }
  }, {
    key: 'renderToolBar',
    value: function renderToolBar() {
      var _props3 = this.props,
          exportCSV = _props3.exportCSV,
          selectRow = _props3.selectRow,
          insertRow = _props3.insertRow,
          deleteRow = _props3.deleteRow,
          search = _props3.search,
          children = _props3.children,
          keyField = _props3.keyField;

      var enableShowOnlySelected = selectRow && selectRow.showOnlySelected;
      var print = typeof this.props.options.printToolBar === 'undefined' ? true : this.props.options.printToolBar;
      if (enableShowOnlySelected || insertRow || deleteRow || search || exportCSV || this.props.options.searchPanel || this.props.options.btnGroup || this.props.options.toolBar) {
        var columns = void 0;
        if (Array.isArray(children)) {
          columns = children.filter(function (_) {
            return _ != null;
          }).map(function (column, r) {
            if (!column) return;
            var props = column.props;

            var isKey = props.isKey || keyField === props.dataField;
            return {
              isKey: isKey,
              name: props.headerText || props.children,
              field: props.dataField,
              hiddenOnInsert: props.hiddenOnInsert,
              keyValidator: props.keyValidator,
              customInsertEditor: props.customInsertEditor,
              // when you want same auto generate value and not allow edit, example ID field
              autoValue: props.autoValue || false,
              // for create editor, no params for column.editable() indicate that editor for new row
              editable: props.editable && _util2.default.isFunction(props.editable === 'function') ? props.editable() : props.editable,
              format: props.dataFormat ? function (value) {
                return props.dataFormat(value, null, props.formatExtraData, r).replace(/<.*?>/g, '');
              } : false
            };
          });
        } else {
          columns = [{
            name: children.props.headerText || children.props.children,
            field: children.props.dataField,
            editable: children.props.editable,
            customInsertEditor: children.props.customInsertEditor,
            hiddenOnInsert: children.props.hiddenOnInsert,
            keyValidator: children.props.keyValidator
          }];
        }
        return _react2.default.createElement(
          'div',
          { className: 'react-bs-table-tool-bar ' + (print ? '' : 'hidden-print') },
          _react2.default.createElement(_ToolBar2.default, {
            ref: 'toolbar',
            defaultSearch: this.props.options.defaultSearch,
            clearSearch: this.props.options.clearSearch,
            searchPosition: this.props.options.searchPosition,
            searchDelayTime: this.props.options.searchDelayTime,
            enableInsert: insertRow,
            enableDelete: deleteRow,
            enableSearch: search,
            enableExportCSV: exportCSV,
            enableShowOnlySelected: enableShowOnlySelected,
            columns: columns,
            searchPlaceholder: this.props.searchPlaceholder,
            exportCSVText: this.props.options.exportCSVText,
            insertText: this.props.options.insertText,
            deleteText: this.props.options.deleteText,
            saveText: this.props.options.saveText,
            closeText: this.props.options.closeText,
            ignoreEditable: this.props.options.ignoreEditable,
            onAddRow: this.handleAddRow,
            onDropRow: this.handleDropRow,
            onSearch: this.handleSearch,
            onExportCSV: this.handleExportCSV,
            onShowOnlySelected: this.handleShowOnlySelected,
            insertModalHeader: this.props.options.insertModalHeader,
            insertModalFooter: this.props.options.insertModalFooter,
            insertModalBody: this.props.options.insertModalBody,
            insertModal: this.props.options.insertModal,
            insertBtn: this.props.options.insertBtn,
            deleteBtn: this.props.options.deleteBtn,
            showSelectedOnlyBtn: this.props.options.showSelectedOnlyBtn,
            exportCSVBtn: this.props.options.exportCSVBtn,
            clearSearchBtn: this.props.options.clearSearchBtn,
            searchField: this.props.options.searchField,
            searchPanel: this.props.options.searchPanel,
            btnGroup: this.props.options.btnGroup,
            toolBar: this.props.options.toolBar,
            reset: this.state.reset,
            isValidKey: this.store.isValidKey })
        );
      } else {
        return null;
      }
    }
  }, {
    key: 'renderTableFilter',
    value: function renderTableFilter(columns) {
      if (this.props.columnFilter) {
        return _react2.default.createElement(_TableFilter2.default, { columns: columns,
          rowSelectType: this.props.selectRow.mode,
          onFilter: this.handleFilterData });
      } else {
        return null;
      }
    }
  }, {
    key: '___scrollTop__REACT_HOT_LOADER__',
    value: function ___scrollTop__REACT_HOT_LOADER__() {
      var scrollTop = this.props.scrollTop;

      if (scrollTop === _Const2.default.SCROLL_TOP) {
        this.refs.body.refs.container.scrollTop = 0;
      } else if (scrollTop === _Const2.default.SCROLL_BOTTOM) {
        this.refs.body.refs.container.scrollTop = this.refs.body.refs.container.scrollHeight;
      } else if (typeof scrollTop === 'number' && !isNaN(scrollTop)) {
        this.refs.body.refs.container.scrollTop = scrollTop;
      }
    }
  }, {
    key: '___scrollHeader__REACT_HOT_LOADER__',
    value: function ___scrollHeader__REACT_HOT_LOADER__(e) {
      this.refs.header.refs.container.scrollLeft = e.currentTarget.scrollLeft;
    }
  }, {
    key: '_adjustTable',
    value: function _adjustTable() {
      this._adjustHeight();
      if (!this.props.printable) {
        this._adjustHeaderWidth();
      }
    }
  }, {
    key: '_adjustHeaderWidth',
    value: function _adjustHeaderWidth() {
      var header = this.refs.header.getHeaderColGrouop();
      var tbody = this.refs.body.refs.tbody;
      var bodyHeader = this.refs.body.getHeaderColGrouop();
      var firstRow = tbody.childNodes[0];
      var isScroll = tbody.parentNode.getBoundingClientRect().height > tbody.parentNode.parentNode.getBoundingClientRect().height;

      var scrollBarWidth = isScroll ? _util2.default.getScrollBarWidth() : 0;
      if (firstRow && this.store.getDataNum()) {
        if (isScroll || this.isVerticalScroll !== isScroll) {
          var cells = firstRow.childNodes;
          for (var i = 0; i < cells.length; i++) {
            var cell = cells[i];
            var computedStyle = window.getComputedStyle(cell);
            var width = parseFloat(computedStyle.width.replace('px', ''));
            if (this.isIE) {
              var paddingLeftWidth = parseFloat(computedStyle.paddingLeft.replace('px', ''));
              var paddingRightWidth = parseFloat(computedStyle.paddingRight.replace('px', ''));
              var borderRightWidth = parseFloat(computedStyle.borderRightWidth.replace('px', ''));
              var borderLeftWidth = parseFloat(computedStyle.borderLeftWidth.replace('px', ''));
              width = width + paddingLeftWidth + paddingRightWidth + borderRightWidth + borderLeftWidth;
            }
            var lastPadding = cells.length - 1 === i ? scrollBarWidth : 0;
            if (width <= 0) {
              width = 120;
              cell.width = width + lastPadding + 'px';
            }
            var result = width + lastPadding + 'px';
            header[i].style.width = result;
            header[i].style.minWidth = result;
            if (cells.length - 1 === i) {
              bodyHeader[i].style.width = width + 'px';
              bodyHeader[i].style.minWidth = width + 'px';
            } else {
              bodyHeader[i].style.width = result;
              bodyHeader[i].style.minWidth = result;
            }
          }
        }
      } else {
        for (var _i in bodyHeader) {
          if (bodyHeader.hasOwnProperty(_i)) {
            var child = bodyHeader[_i];
            if (child.style) {
              if (child.style.width) {
                header[_i].style.width = child.style.width;
              }
              if (child.style.minWidth) {
                header[_i].style.minWidth = child.style.minWidth;
              }
            }
          }
        }
      }
      this.isVerticalScroll = isScroll;
    }
  }, {
    key: '_adjustHeight',
    value: function _adjustHeight() {
      var height = this.props.height;
      var maxHeight = this.props.maxHeight;

      if (typeof height === 'number' && !isNaN(height) || height.indexOf('%') === -1) {
        this.refs.body.refs.container.style.height = parseFloat(height, 10) - this.refs.header.refs.container.offsetHeight + 'px';
      }
      if (maxHeight) {
        maxHeight = typeof maxHeight === 'number' ? maxHeight : parseInt(maxHeight.replace('px', ''), 10);

        this.refs.body.refs.container.style.maxHeight = maxHeight - this.refs.header.refs.container.offsetHeight + 'px';
      }
    }
  }, {
    key: '_handleAfterAddingRow',
    value: function _handleAfterAddingRow(newObj, atTheBeginning) {
      var result = void 0;
      if (this.props.pagination) {
        // if pagination is enabled and inserting row at the end,
        // change page to the last page
        // otherwise, change it to the first page
        var sizePerPage = this.state.sizePerPage;


        if (atTheBeginning) {
          var pageStartIndex = this.props.options.pageStartIndex;

          result = this.store.page(_util2.default.getNormalizedPage(pageStartIndex), sizePerPage).get();
          this.setState(function () {
            return {
              data: result,
              currPage: _util2.default.getFirstPage(pageStartIndex),
              reset: false
            };
          });
        } else {
          var currLastPage = Math.ceil(this.store.getDataNum() / sizePerPage);
          result = this.store.page(currLastPage, sizePerPage).get();
          this.setState(function () {
            return {
              data: result,
              currPage: currLastPage,
              reset: false
            };
          });
        }
      } else {
        result = this.store.get();
        this.setState(function () {
          return {
            data: result,
            reset: false
          };
        });
      }

      if (this.props.options.afterInsertRow) {
        this.props.options.afterInsertRow(newObj);
      }
    }
  }]);

  return BootstrapTable;
}(_react.Component);

BootstrapTable.propTypes = {
  keyField: _react.PropTypes.string,
  height: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
  maxHeight: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
  data: _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.object]),
  remote: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.func]), // remote data, default is false
  replace: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.func]),
  scrollTop: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
  striped: _react.PropTypes.bool,
  bordered: _react.PropTypes.bool,
  hover: _react.PropTypes.bool,
  condensed: _react.PropTypes.bool,
  pagination: _react.PropTypes.bool,
  printable: _react.PropTypes.bool,
  withoutTabIndex: _react.PropTypes.bool,
  keyBoardNav: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.object]),
  searchPlaceholder: _react.PropTypes.string,
  selectRow: _react.PropTypes.shape({
    mode: _react.PropTypes.oneOf([_Const2.default.ROW_SELECT_NONE, _Const2.default.ROW_SELECT_SINGLE, _Const2.default.ROW_SELECT_MULTI]),
    customComponent: _react.PropTypes.func,
    bgColor: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
    selected: _react.PropTypes.array,
    onSelect: _react.PropTypes.func,
    onSelectAll: _react.PropTypes.func,
    clickToSelect: _react.PropTypes.bool,
    hideSelectColumn: _react.PropTypes.bool,
    clickToSelectAndEditCell: _react.PropTypes.bool,
    clickToExpand: _react.PropTypes.bool,
    showOnlySelected: _react.PropTypes.bool,
    unselectable: _react.PropTypes.array,
    columnWidth: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
    onlyUnselectVisible: _react.PropTypes.bool
  }),
  cellEdit: _react.PropTypes.shape({
    mode: _react.PropTypes.string,
    blurToSave: _react.PropTypes.bool,
    beforeSaveCell: _react.PropTypes.func,
    afterSaveCell: _react.PropTypes.func,
    nonEditableRows: _react.PropTypes.func
  }),
  insertRow: _react.PropTypes.bool,
  deleteRow: _react.PropTypes.bool,
  search: _react.PropTypes.bool,
  multiColumnSearch: _react.PropTypes.bool,
  strictSearch: _react.PropTypes.bool,
  columnFilter: _react.PropTypes.bool,
  trClassName: _react.PropTypes.any,
  trStyle: _react.PropTypes.any,
  tableStyle: _react.PropTypes.object,
  containerStyle: _react.PropTypes.object,
  headerStyle: _react.PropTypes.object,
  bodyStyle: _react.PropTypes.object,
  containerClass: _react.PropTypes.string,
  tableContainerClass: _react.PropTypes.string,
  headerContainerClass: _react.PropTypes.string,
  bodyContainerClass: _react.PropTypes.string,
  tableHeaderClass: _react.PropTypes.string,
  tableBodyClass: _react.PropTypes.string,
  options: _react.PropTypes.shape({
    clearSearch: _react.PropTypes.bool,
    sortName: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.array]),
    sortOrder: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.array]),
    defaultSortName: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.array]),
    defaultSortOrder: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.array]),
    sortIndicator: _react.PropTypes.bool,
    afterTableComplete: _react.PropTypes.func,
    afterDeleteRow: _react.PropTypes.func,
    afterInsertRow: _react.PropTypes.func,
    afterSearch: _react.PropTypes.func,
    afterColumnFilter: _react.PropTypes.func,
    onRowClick: _react.PropTypes.func,
    onRowDoubleClick: _react.PropTypes.func,
    page: _react.PropTypes.number,
    pageStartIndex: _react.PropTypes.number,
    paginationShowsTotal: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.func]),
    sizePerPageList: _react.PropTypes.array,
    sizePerPage: _react.PropTypes.number,
    paginationSize: _react.PropTypes.number,
    paginationPosition: _react.PropTypes.oneOf([_Const2.default.PAGINATION_POS_TOP, _Const2.default.PAGINATION_POS_BOTTOM, _Const2.default.PAGINATION_POS_BOTH]),
    hideSizePerPage: _react.PropTypes.bool,
    hidePageListOnlyOnePage: _react.PropTypes.bool,
    alwaysShowAllBtns: _react.PropTypes.bool,
    withFirstAndLast: _react.PropTypes.bool,
    keepSizePerPageState: _react.PropTypes.bool,
    onSortChange: _react.PropTypes.func,
    onPageChange: _react.PropTypes.func,
    onSizePerPageList: _react.PropTypes.func,
    onFilterChange: _react2.default.PropTypes.func,
    onSearchChange: _react2.default.PropTypes.func,
    onAddRow: _react2.default.PropTypes.func,
    onExportToCSV: _react2.default.PropTypes.func,
    onCellEdit: _react2.default.PropTypes.func,
    noDataText: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object]),
    withoutNoDataText: _react2.default.PropTypes.bool,
    handleConfirmDeleteRow: _react.PropTypes.func,
    prePage: _react.PropTypes.any,
    nextPage: _react.PropTypes.any,
    firstPage: _react.PropTypes.any,
    lastPage: _react.PropTypes.any,
    prePageTitle: _react.PropTypes.string,
    nextPageTitle: _react.PropTypes.string,
    firstPageTitle: _react.PropTypes.string,
    lastPageTitle: _react.PropTypes.string,
    searchDelayTime: _react.PropTypes.number,
    excludeCSVHeader: _react.PropTypes.bool,
    exportCSVText: _react.PropTypes.string,
    exportCSVSeparator: _react.PropTypes.string,
    insertText: _react.PropTypes.string,
    deleteText: _react.PropTypes.string,
    saveText: _react.PropTypes.string,
    closeText: _react.PropTypes.string,
    ignoreEditable: _react.PropTypes.bool,
    defaultSearch: _react.PropTypes.string,
    insertModalHeader: _react.PropTypes.func,
    insertModalBody: _react.PropTypes.func,
    insertModalFooter: _react.PropTypes.func,
    insertModal: _react.PropTypes.func,
    insertBtn: _react.PropTypes.func,
    deleteBtn: _react.PropTypes.func,
    showSelectedOnlyBtn: _react.PropTypes.func,
    exportCSVBtn: _react.PropTypes.func,
    clearSearchBtn: _react.PropTypes.func,
    searchField: _react.PropTypes.func,
    searchPanel: _react.PropTypes.func,
    btnGroup: _react.PropTypes.func,
    toolBar: _react.PropTypes.func,
    sizePerPageDropDown: _react.PropTypes.func,
    paginationPanel: _react.PropTypes.func,
    searchPosition: _react.PropTypes.string,
    expandRowBgColor: _react.PropTypes.string,
    expandBy: _react.PropTypes.string,
    expanding: _react.PropTypes.array,
    onExpand: _react.PropTypes.func,
    onlyOneExpanding: _react.PropTypes.bool,
    expandBodyClass: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
    expandParentClass: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
    beforeShowError: _react.PropTypes.func,
    printToolBar: _react.PropTypes.bool,
    noAutoBOM: _react.PropTypes.bool
  }),
  fetchInfo: _react.PropTypes.shape({
    dataTotalSize: _react.PropTypes.number
  }),
  exportCSV: _react.PropTypes.bool,
  csvFileName: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
  ignoreSinglePage: _react.PropTypes.bool,
  expandableRow: _react.PropTypes.func,
  expandComponent: _react.PropTypes.func,
  expandColumnOptions: _react.PropTypes.shape({
    columnWidth: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
    expandColumnVisible: _react.PropTypes.bool,
    expandColumnComponent: _react.PropTypes.func,
    expandColumnBeforeSelectColumn: _react.PropTypes.bool
  })
};
BootstrapTable.defaultProps = {
  replace: false,
  scrollTop: undefined,
  expandComponent: undefined,
  expandableRow: undefined,
  expandColumnOptions: {
    expandColumnVisible: false,
    expandColumnComponent: undefined,
    expandColumnBeforeSelectColumn: true
  },
  height: '100%',
  maxHeight: undefined,
  striped: false,
  bordered: true,
  hover: false,
  condensed: false,
  pagination: false,
  printable: false,
  withoutTabIndex: false,
  keyBoardNav: false,
  searchPlaceholder: undefined,
  selectRow: {
    mode: _Const2.default.ROW_SELECT_NONE,
    bgColor: _Const2.default.ROW_SELECT_BG_COLOR,
    selected: [],
    onSelect: undefined,
    onSelectAll: undefined,
    clickToSelect: false,
    hideSelectColumn: false,
    clickToSelectAndEditCell: false,
    clickToExpand: false,
    showOnlySelected: false,
    unselectable: [],
    customComponent: undefined,
    onlyUnselectVisible: false
  },
  cellEdit: {
    mode: _Const2.default.CELL_EDIT_NONE,
    blurToSave: false,
    beforeSaveCell: undefined,
    afterSaveCell: undefined,
    nonEditableRows: undefined
  },
  insertRow: false,
  deleteRow: false,
  search: false,
  multiColumnSearch: false,
  strictSearch: undefined,
  multiColumnSort: 1,
  columnFilter: false,
  trClassName: '',
  trStyle: undefined,
  tableStyle: undefined,
  containerStyle: undefined,
  headerStyle: undefined,
  bodyStyle: undefined,
  containerClass: null,
  tableContainerClass: null,
  headerContainerClass: null,
  bodyContainerClass: null,
  tableHeaderClass: null,
  tableBodyClass: null,
  options: {
    clearSearch: false,
    sortName: undefined,
    sortOrder: undefined,
    defaultSortName: undefined,
    defaultSortOrder: undefined,
    sortIndicator: true,
    afterTableComplete: undefined,
    afterDeleteRow: undefined,
    afterInsertRow: undefined,
    afterSearch: undefined,
    afterColumnFilter: undefined,
    onRowClick: undefined,
    onRowDoubleClick: undefined,
    onMouseLeave: undefined,
    onMouseEnter: undefined,
    onRowMouseOut: undefined,
    onRowMouseOver: undefined,
    page: undefined,
    paginationShowsTotal: false,
    sizePerPageList: _Const2.default.SIZE_PER_PAGE_LIST,
    sizePerPage: undefined,
    paginationSize: _Const2.default.PAGINATION_SIZE,
    paginationPosition: _Const2.default.PAGINATION_POS_BOTTOM,
    hideSizePerPage: false,
    hidePageListOnlyOnePage: false,
    alwaysShowAllBtns: false,
    withFirstAndLast: true,
    keepSizePerPageState: false,
    onSizePerPageList: undefined,
    noDataText: undefined,
    withoutNoDataText: false,
    handleConfirmDeleteRow: undefined,
    prePage: _Const2.default.PRE_PAGE,
    nextPage: _Const2.default.NEXT_PAGE,
    firstPage: _Const2.default.FIRST_PAGE,
    lastPage: _Const2.default.LAST_PAGE,
    prePageTitle: _Const2.default.PRE_PAGE_TITLE,
    nextPageTitle: _Const2.default.NEXT_PAGE_TITLE,
    firstPageTitle: _Const2.default.FIRST_PAGE_TITLE,
    lastPageTitle: _Const2.default.LAST_PAGE_TITLE,
    pageStartIndex: 1,
    searchDelayTime: undefined,
    excludeCSVHeader: false,
    exportCSVText: _Const2.default.EXPORT_CSV_TEXT,
    exportCSVSeparator: _Const2.default.DEFAULT_CSV_SEPARATOR,
    insertText: _Const2.default.INSERT_BTN_TEXT,
    deleteText: _Const2.default.DELETE_BTN_TEXT,
    saveText: _Const2.default.SAVE_BTN_TEXT,
    closeText: _Const2.default.CLOSE_BTN_TEXT,
    ignoreEditable: false,
    defaultSearch: '',
    insertModalHeader: undefined,
    insertModalBody: undefined,
    insertModalFooter: undefined,
    insertModal: undefined,
    insertBtn: undefined,
    deleteBtn: undefined,
    showSelectedOnlyBtn: undefined,
    exportCSVBtn: undefined,
    clearSearchBtn: undefined,
    searchField: undefined,
    searchPanel: undefined,
    btnGroup: undefined,
    toolBar: undefined,
    sizePerPageDropDown: undefined,
    paginationPanel: undefined,
    searchPosition: 'right',
    expandRowBgColor: undefined,
    expandBy: _Const2.default.EXPAND_BY_ROW,
    expanding: [],
    onExpand: undefined,
    onlyOneExpanding: false,
    expandBodyClass: null,
    expandParentClass: null,
    beforeShowError: undefined,
    printToolBar: true,
    noAutoBOM: true
  },
  fetchInfo: {
    dataTotalSize: 0
  },
  exportCSV: false,
  csvFileName: 'spreadsheet.csv',
  ignoreSinglePage: false
};

var _default = BootstrapTable;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(BootstrapTable, 'BootstrapTable', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/BootstrapTable.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/BootstrapTable.js');
}();

;

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint max-len: 0 */
/* eslint no-nested-ternary: 0 */


var ExpandComponent = function (_Component) {
  _inherits(ExpandComponent, _Component);

  function ExpandComponent() {
    _classCallCheck(this, ExpandComponent);

    return _possibleConstructorReturn(this, (ExpandComponent.__proto__ || Object.getPrototypeOf(ExpandComponent)).apply(this, arguments));
  }

  _createClass(ExpandComponent, [{
    key: 'render',
    value: function render() {
      var className = this.props.className;

      var trCss = {
        style: {
          backgroundColor: this.props.bgColor
        },
        className: (0, _classnames2.default)(className)
      };
      return _react2.default.createElement(
        'tr',
        _extends({ hidden: this.props.hidden, width: this.props.width }, trCss),
        _react2.default.createElement(
          'td',
          { colSpan: this.props.colSpan },
          this.props.children
        )
      );
    }
  }]);

  return ExpandComponent;
}(_react.Component);

var _default = ExpandComponent;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ExpandComponent, 'ExpandComponent', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/ExpandComponent.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/ExpandComponent.js');
}();

;

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExpandRowHeaderColumn = function (_Component) {
  _inherits(ExpandRowHeaderColumn, _Component);

  function ExpandRowHeaderColumn() {
    _classCallCheck(this, ExpandRowHeaderColumn);

    return _possibleConstructorReturn(this, (ExpandRowHeaderColumn.__proto__ || Object.getPrototypeOf(ExpandRowHeaderColumn)).apply(this, arguments));
  }

  _createClass(ExpandRowHeaderColumn, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'th',
        { rowSpan: this.props.rowCount, style: { textAlign: 'center' },
          className: 'react-bs-table-expand-cell',
          'data-is-only-head': false },
        this.props.children
      );
    }
  }]);

  return ExpandRowHeaderColumn;
}(_react.Component);

ExpandRowHeaderColumn.propTypes = {
  children: _react.PropTypes.node,
  rowCount: _react.PropTypes.number
};
var _default = ExpandRowHeaderColumn;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ExpandRowHeaderColumn, 'ExpandRowHeaderColumn', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/ExpandRowHeaderColumn.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/ExpandRowHeaderColumn.js');
}();

;

/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Filter = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Const = __webpack_require__(35);

var _Const2 = _interopRequireDefault(_Const);

var _events = __webpack_require__(513);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Filter = exports.Filter = function (_EventEmitter) {
  _inherits(Filter, _EventEmitter);

  function Filter(data) {
    _classCallCheck(this, Filter);

    var _this = _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).call(this, data));

    _this.currentFilter = {};
    return _this;
  }

  _createClass(Filter, [{
    key: 'handleFilter',
    value: function handleFilter(dataField, value, type, filterObj) {
      var filterType = type || _Const2.default.FILTER_TYPE.CUSTOM;

      var props = {
        cond: filterObj.condition // Only for select and text filter
      };

      if (value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
        // value of the filter is an object
        var hasValue = true;
        for (var prop in value) {
          if (!value[prop] || value[prop] === '') {
            hasValue = false;
            break;
          }
        }
        // if one of the object properties is undefined or empty, we remove the filter
        if (hasValue) {
          this.currentFilter[dataField] = { value: value, type: filterType, props: props };
        } else {
          delete this.currentFilter[dataField];
        }
      } else if (!value || value.trim() === '') {
        delete this.currentFilter[dataField];
      } else {
        this.currentFilter[dataField] = { value: value.trim(), type: filterType, props: props };
      }
      this.emit('onFilterChange', this.currentFilter);
    }
  }]);

  return Filter;
}(_events.EventEmitter);

;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Filter, 'Filter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/Filter.js');
}();

;

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectRowHeaderColumn = function (_Component) {
  _inherits(SelectRowHeaderColumn, _Component);

  function SelectRowHeaderColumn() {
    _classCallCheck(this, SelectRowHeaderColumn);

    return _possibleConstructorReturn(this, (SelectRowHeaderColumn.__proto__ || Object.getPrototypeOf(SelectRowHeaderColumn)).apply(this, arguments));
  }

  _createClass(SelectRowHeaderColumn, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'th',
        { rowSpan: this.props.rowCount, style: { textAlign: 'center' },
          'data-is-only-head': false },
        this.props.children
      );
    }
  }]);

  return SelectRowHeaderColumn;
}(_react.Component);

SelectRowHeaderColumn.propTypes = {
  children: _react.PropTypes.node,
  rowCount: _react.PropTypes.number
};
var _default = SelectRowHeaderColumn;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(SelectRowHeaderColumn, 'SelectRowHeaderColumn', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/SelectRowHeaderColumn.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/SelectRowHeaderColumn.js');
}();

;

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _util = __webpack_require__(87);

var _util2 = _interopRequireDefault(_util);

var _Const = __webpack_require__(35);

var _Const2 = _interopRequireDefault(_Const);

var _TableRow = __webpack_require__(1319);

var _TableRow2 = _interopRequireDefault(_TableRow);

var _TableColumn = __webpack_require__(1315);

var _TableColumn2 = _interopRequireDefault(_TableColumn);

var _TableEditColumn = __webpack_require__(1316);

var _TableEditColumn2 = _interopRequireDefault(_TableEditColumn);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _ExpandComponent = __webpack_require__(1310);

var _ExpandComponent2 = _interopRequireDefault(_ExpandComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableBody = function (_Component) {
  _inherits(TableBody, _Component);

  function TableBody(props) {
    _classCallCheck(this, TableBody);

    var _this = _possibleConstructorReturn(this, (TableBody.__proto__ || Object.getPrototypeOf(TableBody)).call(this, props));

    _this.handleCellKeyDown = function () {
      return _this.__handleCellKeyDown__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowMouseOut = function () {
      return _this.__handleRowMouseOut__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowMouseOver = function () {
      return _this.__handleRowMouseOver__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowClick = function () {
      return _this.__handleRowClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleRowDoubleClick = function () {
      return _this.__handleRowDoubleClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleSelectRow = function () {
      return _this.__handleSelectRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleSelectRowColumChange = function () {
      return _this.__handleSelectRowColumChange__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleClickCell = function () {
      return _this.__handleClickCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleEditCell = function () {
      return _this.__handleEditCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.nextEditableCell = function () {
      return _this.__nextEditableCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleCompleteEditCell = function () {
      return _this.__handleCompleteEditCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.cancelEditCell = function () {
      return _this.__cancelEditCell__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleClickonSelectColumn = function () {
      return _this.__handleClickonSelectColumn__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.getHeaderColGrouop = function () {
      return _this.__getHeaderColGrouop__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.state = {
      currEditCell: null
    };
    return _this;
  }

  _createClass(TableBody, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          cellEdit = _props.cellEdit,
          beforeShowError = _props.beforeShowError,
          x = _props.x,
          y = _props.y,
          keyBoardNav = _props.keyBoardNav,
          trStyle = _props.trStyle;

      var tableClasses = (0, _classnames2.default)('table', {
        'table-striped': this.props.striped,
        'table-bordered': this.props.bordered,
        'table-hover': this.props.hover,
        'table-condensed': this.props.condensed
      }, this.props.tableBodyClass);

      var noneditableRows = cellEdit.nonEditableRows && cellEdit.nonEditableRows() || [];
      var unselectable = this.props.selectRow.unselectable || [];
      var isSelectRowDefined = this._isSelectRowDefined();
      var tableHeader = _util2.default.renderColGroup(this.props.columns, this.props.selectRow, this.props.expandColumnOptions);
      var inputType = this.props.selectRow.mode === _Const2.default.ROW_SELECT_SINGLE ? 'radio' : 'checkbox';
      var CustomComponent = this.props.selectRow.customComponent;
      var enableKeyBoardNav = keyBoardNav === true || (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object';
      var customEditAndNavStyle = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav.customStyleOnEditCell : null;
      var customNavStyle = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav.customStyle : null;
      var ExpandColumnCustomComponent = this.props.expandColumnOptions.expandColumnComponent;
      var expandColSpan = this.props.columns.filter(function (col) {
        return col && !col.hidden;
      }).length;
      if (isSelectRowDefined && !this.props.selectRow.hideSelectColumn) {
        expandColSpan += 1;
      }
      var tabIndex = 1;
      if (this.props.expandColumnOptions.expandColumnVisible) {
        expandColSpan += 1;
      }

      var tableRows = this.props.data.map(function (data, r) {
        var tableColumns = this.props.columns.filter(function (_) {
          return _ != null;
        }).map(function (column, i) {
          var fieldValue = data[column.name];
          var isFocusCell = r === y && i === x;
          if (column.name !== this.props.keyField && // Key field can't be edit
          column.editable && // column is editable? default is true, user can set it false
          column.editable.readOnly !== true && this.state.currEditCell !== null && this.state.currEditCell.rid === r && this.state.currEditCell.cid === i && noneditableRows.indexOf(data[this.props.keyField]) === -1) {
            var editable = column.editable;
            var format = column.format ? function (value) {
              return column.format(value, data, column.formatExtraData, r).replace(/<.*?>/g, '');
            } : false;
            if (_util2.default.isFunction(column.editable)) {
              editable = column.editable(fieldValue, data, r, i);
            }

            return _react2.default.createElement(_TableEditColumn2.default, {
              completeEdit: this.handleCompleteEditCell
              // add by bluespring for column editor customize
              , editable: editable,
              customEditor: column.customEditor,
              format: column.format ? format : false,
              key: i,
              blurToSave: cellEdit.blurToSave,
              onTab: this.handleEditCell,
              rowIndex: r,
              colIndex: i,
              row: data,
              fieldValue: fieldValue,
              className: column.editClassName,
              invalidColumnClassName: column.invalidEditColumnClassName,
              beforeShowError: beforeShowError,
              isFocus: isFocusCell,
              customStyleWithNav: customEditAndNavStyle });
          } else {
            // add by bluespring for className customize
            var columnChild = fieldValue && fieldValue.toString();
            var columnTitle = null;
            var tdClassName = column.className;
            if (_util2.default.isFunction(column.className)) {
              tdClassName = column.className(fieldValue, data, r, i);
            }

            if (typeof column.format !== 'undefined') {
              var formattedValue = column.format(fieldValue, data, column.formatExtraData, r);
              if (!_react2.default.isValidElement(formattedValue)) {
                columnChild = _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: formattedValue } });
              } else {
                columnChild = formattedValue;
                columnTitle = column.columnTitle && formattedValue ? formattedValue.toString() : null;
              }
            } else {
              columnTitle = column.columnTitle && fieldValue ? fieldValue.toString() : null;
            }
            return _react2.default.createElement(
              _TableColumn2.default,
              { key: i,
                rIndex: r,
                dataAlign: column.align,
                className: tdClassName,
                columnTitle: columnTitle,
                cellEdit: cellEdit,
                hidden: column.hidden,
                onEdit: this.handleEditCell,
                width: column.width,
                onClick: this.handleClickCell,
                attrs: column.attrs,
                style: column.style,
                tabIndex: tabIndex++ + '',
                isFocus: isFocusCell,
                keyBoardNav: enableKeyBoardNav,
                onKeyDown: this.handleCellKeyDown,
                customNavStyle: customNavStyle,
                row: data,
                withoutTabIndex: this.props.withoutTabIndex },
              columnChild
            );
          }
        }, this);
        var key = data[this.props.keyField];
        var disable = unselectable.indexOf(key) !== -1;
        var selected = this.props.selectedRowKeys.indexOf(key) !== -1;
        var selectRowColumn = isSelectRowDefined && !this.props.selectRow.hideSelectColumn ? this.renderSelectRowColumn(selected, inputType, disable, CustomComponent, r, data) : null;
        var expandedRowColumn = this.renderExpandRowColumn(this.props.expandableRow && this.props.expandableRow(data), this.props.expanding.indexOf(key) > -1, ExpandColumnCustomComponent, r, data);
        var haveExpandContent = this.props.expandableRow && this.props.expandableRow(data);
        var isExpanding = haveExpandContent && this.props.expanding.indexOf(key) > -1;

        // add by bluespring for className customize
        var trClassName = this.props.trClassName;
        if (_util2.default.isFunction(this.props.trClassName)) {
          trClassName = this.props.trClassName(data, r);
        }
        if (isExpanding && this.props.expandParentClass) {
          trClassName += _util2.default.isFunction(this.props.expandParentClass) ? this.props.expandParentClass(data, r) : this.props.expandParentClass;
        }
        var result = [_react2.default.createElement(
          _TableRow2.default,
          { isSelected: selected, key: key, className: trClassName,
            index: r,
            row: data,
            selectRow: isSelectRowDefined ? this.props.selectRow : undefined,
            enableCellEdit: cellEdit.mode !== _Const2.default.CELL_EDIT_NONE,
            onRowClick: this.handleRowClick,
            onRowDoubleClick: this.handleRowDoubleClick,
            onRowMouseOver: this.handleRowMouseOver,
            onRowMouseOut: this.handleRowMouseOut,
            onSelectRow: this.handleSelectRow,
            onExpandRow: this.handleClickCell,
            unselectableRow: disable,
            style: trStyle },
          this.props.expandColumnOptions.expandColumnVisible && this.props.expandColumnOptions.expandColumnBeforeSelectColumn && expandedRowColumn,
          selectRowColumn,
          this.props.expandColumnOptions.expandColumnVisible && !this.props.expandColumnOptions.expandColumnBeforeSelectColumn && expandedRowColumn,
          tableColumns
        )];

        if (haveExpandContent) {
          var expandBodyClass = _util2.default.isFunction(this.props.expandBodyClass) ? this.props.expandBodyClass(data, r, isExpanding) : this.props.expandBodyClass;
          result.push(_react2.default.createElement(
            _ExpandComponent2.default,
            {
              key: key + '-expand',
              row: data,
              className: expandBodyClass,
              bgColor: this.props.expandRowBgColor || this.props.selectRow.bgColor || undefined,
              hidden: !isExpanding,
              colSpan: expandColSpan,
              width: "100%" },
            this.props.expandComponent(data)
          ));
        }
        return result;
      }, this);

      if (tableRows.length === 0 && !this.props.withoutNoDataText) {
        var colSpan = this.props.columns.filter(function (c) {
          return !c.hidden;
        }).length + (isSelectRowDefined && !this.props.selectRow.hideSelectColumn ? 1 : 0) + (this.props.expandColumnOptions.expandColumnVisible ? 1 : 0);
        tableRows = [_react2.default.createElement(
          _TableRow2.default,
          { key: '##table-empty##', style: trStyle },
          _react2.default.createElement(
            'td',
            { 'data-toggle': 'collapse',
              colSpan: colSpan,
              className: 'react-bs-table-no-data' },
            this.props.noDataText || _Const2.default.NO_DATA_TEXT
          )
        )];
      }

      return _react2.default.createElement(
        'div',
        { ref: 'container',
          className: (0, _classnames2.default)('react-bs-container-body', this.props.bodyContainerClass),
          style: this.props.style },
        _react2.default.createElement(
          'table',
          { className: tableClasses },
          _react2.default.cloneElement(tableHeader, { ref: 'header' }),
          _react2.default.createElement(
            'tbody',
            { ref: 'tbody' },
            tableRows
          )
        )
      );
    }
  }, {
    key: '__handleCellKeyDown__REACT_HOT_LOADER__',
    value: function __handleCellKeyDown__REACT_HOT_LOADER__(e, lastEditCell) {
      e.preventDefault();
      var _props2 = this.props,
          keyBoardNav = _props2.keyBoardNav,
          onNavigateCell = _props2.onNavigateCell,
          cellEdit = _props2.cellEdit;

      var offset = void 0;
      if (e.keyCode === 37) {
        offset = { x: -1, y: 0 };
      } else if (e.keyCode === 38) {
        offset = { x: 0, y: -1 };
      } else if (e.keyCode === 39 || e.keyCode === 9) {
        offset = { x: 1, y: 0 };
        if (e.keyCode === 9 && lastEditCell) {
          offset = _extends({}, offset, {
            lastEditCell: lastEditCell
          });
        }
      } else if (e.keyCode === 40) {
        offset = { x: 0, y: 1 };
      } else if (e.keyCode === 13) {
        var enterToEdit = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav.enterToEdit : false;
        var enterToExpand = (typeof keyBoardNav === 'undefined' ? 'undefined' : _typeof(keyBoardNav)) === 'object' ? keyBoardNav.enterToExpand : false;

        if (cellEdit && enterToEdit) {
          this.handleEditCell(e.target.parentElement.rowIndex + 1, e.currentTarget.cellIndex, '', e);
        }

        if (enterToExpand) {
          this.handleClickCell(this.props.y + 1, this.props.x);
        }
      }
      if (offset && keyBoardNav) {
        onNavigateCell(offset);
      }
    }
  }, {
    key: '__handleRowMouseOut__REACT_HOT_LOADER__',
    value: function __handleRowMouseOut__REACT_HOT_LOADER__(rowIndex, event) {
      var targetRow = this.props.data[rowIndex];
      this.props.onRowMouseOut(targetRow, event);
    }
  }, {
    key: '__handleRowMouseOver__REACT_HOT_LOADER__',
    value: function __handleRowMouseOver__REACT_HOT_LOADER__(rowIndex, event) {
      var targetRow = this.props.data[rowIndex];
      this.props.onRowMouseOver(targetRow, event);
    }
  }, {
    key: '__handleRowClick__REACT_HOT_LOADER__',
    value: function __handleRowClick__REACT_HOT_LOADER__(rowIndex, cellIndex) {
      var onRowClick = this.props.onRowClick;

      if (this._isSelectRowDefined()) cellIndex--;
      if (this._isExpandColumnVisible()) cellIndex--;
      onRowClick(this.props.data[rowIndex - 1], rowIndex - 1, cellIndex);
    }
  }, {
    key: '__handleRowDoubleClick__REACT_HOT_LOADER__',
    value: function __handleRowDoubleClick__REACT_HOT_LOADER__(rowIndex) {
      var onRowDoubleClick = this.props.onRowDoubleClick;

      var targetRow = this.props.data[rowIndex];
      onRowDoubleClick(targetRow);
    }
  }, {
    key: '__handleSelectRow__REACT_HOT_LOADER__',
    value: function __handleSelectRow__REACT_HOT_LOADER__(rowIndex, isSelected, e) {
      var selectedRow = void 0;
      var _props3 = this.props,
          data = _props3.data,
          onSelectRow = _props3.onSelectRow;

      data.forEach(function (row, i) {
        if (i === rowIndex - 1) {
          selectedRow = row;
          return false;
        }
      });
      onSelectRow(selectedRow, isSelected, e, rowIndex - 1);
    }
  }, {
    key: '__handleSelectRowColumChange__REACT_HOT_LOADER__',
    value: function __handleSelectRowColumChange__REACT_HOT_LOADER__(e, rowIndex) {
      if (!this.props.selectRow.clickToSelect || !this.props.selectRow.clickToSelectAndEditCell) {
        this.handleSelectRow(rowIndex + 1, e.currentTarget.checked, e);
      }
    }
  }, {
    key: '__handleClickCell__REACT_HOT_LOADER__',
    value: function __handleClickCell__REACT_HOT_LOADER__(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
      var _props4 = this.props,
          columns = _props4.columns,
          keyField = _props4.keyField,
          expandBy = _props4.expandBy,
          expandableRow = _props4.expandableRow,
          _props4$selectRow = _props4.selectRow,
          clickToExpand = _props4$selectRow.clickToExpand,
          hideSelectColumn = _props4$selectRow.hideSelectColumn,
          onlyOneExpanding = _props4.onlyOneExpanding;

      var selectRowAndExpand = this._isSelectRowDefined() && !clickToExpand ? false : true;
      columnIndex = this._isSelectRowDefined() && !hideSelectColumn ? columnIndex - 1 : columnIndex;
      columnIndex = this._isExpandColumnVisible() ? columnIndex - 1 : columnIndex;
      if (expandableRow && selectRowAndExpand && (expandBy === _Const2.default.EXPAND_BY_ROW ||
      /* Below will allow expanding trigger by clicking on selection column
      if configure as expanding by column */
      expandBy === _Const2.default.EXPAND_BY_COL && columnIndex < 0 || expandBy === _Const2.default.EXPAND_BY_COL && columns[columnIndex].expandable)) {
        var expanding = this.props.expanding;
        var rowKey = this.props.data[rowIndex - 1][keyField];
        var isRowExpanding = expanding.indexOf(rowKey) > -1;

        if (isRowExpanding) {
          // collapse
          expanding = expanding.filter(function (k) {
            return k !== rowKey;
          });
        } else {
          // expand
          if (onlyOneExpanding) expanding = [rowKey];else expanding.push(rowKey);
        }
        this.props.onExpand(expanding, rowKey, isRowExpanding);
      }
    }
  }, {
    key: '__handleEditCell__REACT_HOT_LOADER__',
    value: function __handleEditCell__REACT_HOT_LOADER__(rowIndex, columnIndex, action, e) {
      var selectRow = this.props.selectRow;

      var defineSelectRow = this._isSelectRowDefined();
      var expandColumnVisible = this._isExpandColumnVisible();
      if (defineSelectRow) {
        columnIndex--;
        if (selectRow.hideSelectColumn) columnIndex++;
      }
      if (expandColumnVisible) {
        columnIndex--;
      }
      rowIndex--;

      if (action === 'tab') {
        if (defineSelectRow && !selectRow.hideSelectColumn) columnIndex++;
        if (expandColumnVisible) columnIndex++;
        this.handleCompleteEditCell(e.target.value, rowIndex, columnIndex - 1);
        if (columnIndex >= this.props.columns.length) {
          this.handleCellKeyDown(e, true);
        } else {
          this.handleCellKeyDown(e);
        }

        var _nextEditableCell = this.nextEditableCell(rowIndex, columnIndex),
            nextRIndex = _nextEditableCell.nextRIndex,
            nextCIndex = _nextEditableCell.nextCIndex;

        rowIndex = nextRIndex;
        columnIndex = nextCIndex;
      }

      var stateObj = {
        currEditCell: {
          rid: rowIndex,
          cid: columnIndex
        }
      };

      if (this.props.selectRow.clickToSelectAndEditCell && this.props.cellEdit.mode !== _Const2.default.CELL_EDIT_DBCLICK) {
        var selected = this.props.selectedRowKeys.indexOf(this.props.data[rowIndex][this.props.keyField]) !== -1;
        this.handleSelectRow(rowIndex + 1, !selected, e);
      }
      this.setState(function () {
        return stateObj;
      });
    }
  }, {
    key: '__nextEditableCell__REACT_HOT_LOADER__',
    value: function __nextEditableCell__REACT_HOT_LOADER__(rIndex, cIndex) {
      var keyField = this.props.keyField;

      var nextRIndex = rIndex;
      var nextCIndex = cIndex;
      var row = void 0;
      var column = void 0;
      do {
        if (nextCIndex >= this.props.columns.length) {
          nextRIndex++;
          nextCIndex = 0;
        }
        row = this.props.data[nextRIndex];
        column = this.props.columns[nextCIndex];
        if (!row) break;
        var editable = column.editable;
        if (_util2.default.isFunction(column.editable)) {
          editable = column.editable(column, row, nextRIndex, nextCIndex);
        }
        if (editable && editable.readOnly !== true && !column.hidden && keyField !== column.name) {
          break;
        } else {
          nextCIndex++;
        }
      } while (row);
      return { nextRIndex: nextRIndex, nextCIndex: nextCIndex };
    }
  }, {
    key: '__handleCompleteEditCell__REACT_HOT_LOADER__',
    value: function __handleCompleteEditCell__REACT_HOT_LOADER__(newVal, rowIndex, columnIndex) {
      if (newVal !== null) {
        var result = this.props.onEditCell(newVal, rowIndex, columnIndex);
        if (result !== _Const2.default.AWAIT_BEFORE_CELL_EDIT) {
          this.setState(function () {
            return { currEditCell: null };
          });
        }
      } else {
        this.setState(function () {
          return { currEditCell: null };
        });
      }
    }
  }, {
    key: '__cancelEditCell__REACT_HOT_LOADER__',
    value: function __cancelEditCell__REACT_HOT_LOADER__() {
      this.setState(function () {
        return { currEditCell: null };
      });
    }
  }, {
    key: '__handleClickonSelectColumn__REACT_HOT_LOADER__',
    value: function __handleClickonSelectColumn__REACT_HOT_LOADER__(e, isSelect, rowIndex, row) {
      e.stopPropagation();
      if (e.target.tagName === 'TD' && (this.props.selectRow.clickToSelect || this.props.selectRow.clickToSelectAndEditCell)) {
        var unselectable = this.props.selectRow.unselectable || [];
        if (unselectable.indexOf(row[this.props.keyField]) === -1) {
          this.handleSelectRow(rowIndex + 1, isSelect, e);
          this.handleClickCell(rowIndex + 1);
        }
      }
    }
  }, {
    key: 'renderSelectRowColumn',
    value: function renderSelectRowColumn(selected, inputType, disabled) {
      var CustomComponent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      var _this2 = this;

      var rowIndex = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var row = arguments[5];

      return _react2.default.createElement(
        'td',
        { onClick: function onClick(e) {
            _this2.handleClickonSelectColumn(e, !selected, rowIndex, row);
          }, style: { textAlign: 'center' } },
        CustomComponent ? _react2.default.createElement(CustomComponent, { type: inputType, checked: selected, disabled: disabled,
          rowIndex: rowIndex,
          onChange: function onChange(e) {
            return _this2.handleSelectRowColumChange(e, rowIndex);
          } }) : _react2.default.createElement('input', { type: inputType, checked: selected, disabled: disabled,
          onChange: function onChange(e) {
            return _this2.handleSelectRowColumChange(e, rowIndex);
          } })
      );
    }
  }, {
    key: 'renderExpandRowColumn',
    value: function renderExpandRowColumn(isExpandableRow, isExpanded, CustomComponent) {
      var _this3 = this;

      var rowIndex = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      var content = null;
      if (CustomComponent) {
        content = _react2.default.createElement(CustomComponent, { isExpandableRow: isExpandableRow, isExpanded: isExpanded });
      } else if (isExpandableRow) {
        content = isExpanded ? _react2.default.createElement('span', { className: 'glyphicon glyphicon-minus' }) : _react2.default.createElement('span', { className: 'glyphicon glyphicon-plus' });
      } else {
        content = ' ';
      }

      return _react2.default.createElement(
        'td',
        {
          className: 'react-bs-table-expand-cell',
          onClick: function onClick() {
            return _this3.handleClickCell(rowIndex + 1);
          } },
        content
      );
    }
  }, {
    key: '_isSelectRowDefined',
    value: function _isSelectRowDefined() {
      return this.props.selectRow.mode === _Const2.default.ROW_SELECT_SINGLE || this.props.selectRow.mode === _Const2.default.ROW_SELECT_MULTI;
    }
  }, {
    key: '_isExpandColumnVisible',
    value: function _isExpandColumnVisible() {
      return this.props.expandColumnOptions.expandColumnVisible;
    }
  }, {
    key: '__getHeaderColGrouop__REACT_HOT_LOADER__',
    value: function __getHeaderColGrouop__REACT_HOT_LOADER__() {
      return this.refs.header.childNodes;
    }
  }]);

  return TableBody;
}(_react.Component);

TableBody.propTypes = {
  data: _react.PropTypes.array,
  columns: _react.PropTypes.array,
  striped: _react.PropTypes.bool,
  bordered: _react.PropTypes.bool,
  hover: _react.PropTypes.bool,
  condensed: _react.PropTypes.bool,
  keyField: _react.PropTypes.string,
  selectedRowKeys: _react.PropTypes.array,
  onRowClick: _react.PropTypes.func,
  onRowDoubleClick: _react.PropTypes.func,
  onSelectRow: _react.PropTypes.func,
  noDataText: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.object]),
  withoutNoDataText: _react.PropTypes.bool,
  style: _react.PropTypes.object,
  tableBodyClass: _react.PropTypes.string,
  bodyContainerClass: _react.PropTypes.string,
  expandableRow: _react.PropTypes.func,
  expandComponent: _react.PropTypes.func,
  expandRowBgColor: _react.PropTypes.string,
  expandBy: _react.PropTypes.string,
  expanding: _react.PropTypes.array,
  onExpand: _react.PropTypes.func,
  expandBodyClass: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
  expandParentClass: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
  onlyOneExpanding: _react.PropTypes.bool,
  beforeShowError: _react.PropTypes.func,
  keyBoardNav: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.object]),
  x: _react.PropTypes.number,
  y: _react.PropTypes.number,
  onNavigateCell: _react.PropTypes.func,
  withoutTabIndex: _react.PropTypes.bool
};
var _default = TableBody;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableBody, 'TableBody', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableBody.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableBody.js');
}();

;

/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(33);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Const = __webpack_require__(35);

var _Const2 = _interopRequireDefault(_Const);

var _util = __webpack_require__(87);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableColumn = function (_Component) {
  _inherits(TableColumn, _Component);

  function TableColumn(props) {
    _classCallCheck(this, TableColumn);

    var _this = _possibleConstructorReturn(this, (TableColumn.__proto__ || Object.getPrototypeOf(TableColumn)).call(this, props));

    _this.handleCellEdit = function () {
      return _this.__handleCellEdit__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleCellClick = function () {
      return _this.__handleCellClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleKeyDown = function () {
      return _this.__handleKeyDown__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    return _this;
  }
  /* eslint no-unused-vars: [0, { "args": "after-used" }] */


  _createClass(TableColumn, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var children = this.props.children;

      var shouldUpdated = this.props.width !== nextProps.width || this.props.className !== nextProps.className || this.props.hidden !== nextProps.hidden || this.props.dataAlign !== nextProps.dataAlign || this.props.isFocus !== nextProps.isFocus || (typeof children === 'undefined' ? 'undefined' : _typeof(children)) !== _typeof(nextProps.children) || ('' + this.props.onEdit).toString() !== ('' + nextProps.onEdit).toString();

      if (shouldUpdated) {
        return shouldUpdated;
      }

      if ((typeof children === 'undefined' ? 'undefined' : _typeof(children)) === 'object' && children !== null && children.props !== null) {
        if (children.props.type === 'checkbox' || children.props.type === 'radio') {
          shouldUpdated = shouldUpdated || children.props.type !== nextProps.children.props.type || children.props.checked !== nextProps.children.props.checked || children.props.disabled !== nextProps.children.props.disabled;
        } else {
          shouldUpdated = true;
        }
      } else {
        shouldUpdated = shouldUpdated || children !== nextProps.children;
      }

      if (shouldUpdated) {
        return shouldUpdated;
      }

      if (!(this.props.cellEdit && nextProps.cellEdit)) {
        return false;
      } else {
        return shouldUpdated || this.props.cellEdit.mode !== nextProps.cellEdit.mode;
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var dom = _reactDom2.default.findDOMNode(this);
      if (this.props.isFocus) {
        dom.focus();
      } else {
        dom.blur();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var dom = _reactDom2.default.findDOMNode(this);
      if (this.props.isFocus) {
        dom.focus();
      } else {
        dom.blur();
      }
    }
  }, {
    key: '__handleCellEdit__REACT_HOT_LOADER__',
    value: function __handleCellEdit__REACT_HOT_LOADER__(e) {
      if (this.props.cellEdit.mode === _Const2.default.CELL_EDIT_DBCLICK) {
        if (document.selection && document.selection.empty) {
          document.selection.empty();
        } else if (window.getSelection) {
          var sel = window.getSelection();
          sel.removeAllRanges();
        }
      }
      this.props.onEdit(this.props.rIndex + 1, e.currentTarget.cellIndex, e);
      if (this.props.cellEdit.mode !== _Const2.default.CELL_EDIT_DBCLICK) {
        this.props.onClick(this.props.rIndex + 1, e.currentTarget.cellIndex, e);
      }
    }
  }, {
    key: '__handleCellClick__REACT_HOT_LOADER__',
    value: function __handleCellClick__REACT_HOT_LOADER__(e) {
      var _props = this.props,
          onClick = _props.onClick,
          rIndex = _props.rIndex;

      if (onClick) {
        onClick(rIndex + 1, e.currentTarget.cellIndex, e);
      }
    }
  }, {
    key: '__handleKeyDown__REACT_HOT_LOADER__',
    value: function __handleKeyDown__REACT_HOT_LOADER__(e) {
      if (this.props.keyBoardNav) {
        this.props.onKeyDown(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          columnTitle = _props2.columnTitle,
          dataAlign = _props2.dataAlign,
          hidden = _props2.hidden,
          cellEdit = _props2.cellEdit,
          attrs = _props2.attrs,
          style = _props2.style,
          isFocus = _props2.isFocus,
          keyBoardNav = _props2.keyBoardNav,
          tabIndex = _props2.tabIndex,
          customNavStyle = _props2.customNavStyle,
          withoutTabIndex = _props2.withoutTabIndex,
          row = _props2.row;
      var className = this.props.className;


      var tdStyle = _extends({
        textAlign: dataAlign,
        display: hidden ? 'none' : null
      }, style);

      var opts = {};

      if (cellEdit) {
        if (cellEdit.mode === _Const2.default.CELL_EDIT_CLICK) {
          opts.onClick = this.handleCellEdit;
        } else if (cellEdit.mode === _Const2.default.CELL_EDIT_DBCLICK) {
          opts.onDoubleClick = this.handleCellEdit;
        } else {
          opts.onClick = this.handleCellClick;
        }
      }

      if (keyBoardNav && isFocus) {
        opts.onKeyDown = this.handleKeyDown;
      }

      if (isFocus) {
        if (customNavStyle) {
          var cusmtStyle = _util2.default.isFunction(customNavStyle) ? customNavStyle(children, row) : customNavStyle;
          tdStyle = _extends({}, tdStyle, cusmtStyle);
        } else {
          className = className + ' default-focus-cell';
        }
      }

      var attr = {};
      if (!withoutTabIndex) attr.tabIndex = tabIndex;
      return _react2.default.createElement(
        'td',
        _extends({}, attr, { style: tdStyle,
          title: columnTitle,
          className: className
        }, opts, attrs),
        typeof children === 'boolean' ? children.toString() : children
      );
    }
  }]);

  return TableColumn;
}(_react.Component);

TableColumn.propTypes = {
  rIndex: _react.PropTypes.number,
  dataAlign: _react.PropTypes.string,
  hidden: _react.PropTypes.bool,
  className: _react.PropTypes.string,
  columnTitle: _react.PropTypes.string,
  children: _react.PropTypes.node,
  onClick: _react.PropTypes.func,
  attrs: _react.PropTypes.object,
  style: _react.PropTypes.object,
  isFocus: _react.PropTypes.bool,
  onKeyDown: _react.PropTypes.func,
  tabIndex: _react.PropTypes.string,
  withoutTabIndex: _react.PropTypes.bool,
  keyBoardNav: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.object]),
  customNavStyle: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.object]),
  row: _react.PropTypes.any /* only used on custom styling for navigation */
};

TableColumn.defaultProps = {
  dataAlign: 'left',
  withoutTabIndex: false,
  hidden: false,
  className: '',
  isFocus: false,
  keyBoardNav: false
};
var _default = TableColumn;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableColumn, 'TableColumn', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableColumn.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableColumn.js');
}();

;

/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(33);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Editor = __webpack_require__(558);

var _Editor2 = _interopRequireDefault(_Editor);

var _Notification = __webpack_require__(559);

var _Notification2 = _interopRequireDefault(_Notification);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Const = __webpack_require__(35);

var _Const2 = _interopRequireDefault(_Const);

var _util = __webpack_require__(87);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableEditColumn = function (_Component) {
  _inherits(TableEditColumn, _Component);

  function TableEditColumn(props) {
    _classCallCheck(this, TableEditColumn);

    var _this = _possibleConstructorReturn(this, (TableEditColumn.__proto__ || Object.getPrototypeOf(TableEditColumn)).call(this, props));

    _this.handleKeyPress = function () {
      return _this.__handleKeyPress__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleBlur = function () {
      return _this.__handleBlur__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleCustomUpdate = function () {
      return _this.__handleCustomUpdate__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.notifyToastr = function () {
      return _this.__notifyToastr__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleClick = function () {
      return _this.__handleClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.timeouteClear = 0;
    var _this$props = _this.props,
        fieldValue = _this$props.fieldValue,
        row = _this$props.row,
        className = _this$props.className;

    _this.focusInEditor = _this.focusInEditor.bind(_this);
    _this.state = {
      shakeEditor: false,
      className: _util2.default.isFunction(className) ? className(fieldValue, row) : className
    };
    return _this;
  }

  _createClass(TableEditColumn, [{
    key: 'valueShortCircuit',
    value: function valueShortCircuit(value) {
      return value === null || typeof value === 'undefined' ? '' : value;
    }
  }, {
    key: '__handleKeyPress__REACT_HOT_LOADER__',
    value: function __handleKeyPress__REACT_HOT_LOADER__(e) {
      if (e.keyCode === 13 || e.keyCode === 9) {
        // Pressed ENTER
        var value = e.currentTarget.type === 'checkbox' ? this._getCheckBoxValue(e) : e.currentTarget.value;

        if (!this.validator(value)) {
          return;
        }
        if (e.keyCode === 13) {
          this.props.completeEdit(value, this.props.rowIndex, this.props.colIndex);
        } else {
          this.props.onTab(this.props.rowIndex + 1, this.props.colIndex + 1, 'tab', e);
          e.preventDefault();
        }
      } else if (e.keyCode === 27) {
        this.props.completeEdit(null, this.props.rowIndex, this.props.colIndex);
      } else if (e.type === 'click' && !this.props.blurToSave) {
        // textarea click save button
        var _value = e.target.parentElement.firstChild.value;
        if (!this.validator(_value)) {
          return;
        }
        this.props.completeEdit(_value, this.props.rowIndex, this.props.colIndex);
      }
    }
  }, {
    key: '__handleBlur__REACT_HOT_LOADER__',
    value: function __handleBlur__REACT_HOT_LOADER__(e) {
      e.stopPropagation();
      if (this.props.blurToSave) {
        var value = e.currentTarget.type === 'checkbox' ? this._getCheckBoxValue(e) : e.currentTarget.value;
        if (!this.validator(value)) {
          return false;
        }
        this.props.completeEdit(value, this.props.rowIndex, this.props.colIndex);
      }
    }
  }, {
    key: '__handleCustomUpdate__REACT_HOT_LOADER__',


    // modified by iuculanop
    // BEGIN
    value: function __handleCustomUpdate__REACT_HOT_LOADER__(value) {
      if (!this.validator(value)) {
        return;
      }
      this.props.completeEdit(value, this.props.rowIndex, this.props.colIndex);
    }
  }, {
    key: 'validator',
    value: function validator(value) {
      var ts = this;
      var valid = true;
      if (ts.props.editable.validator) {
        var checkVal = ts.props.editable.validator(value, this.props.row);
        var responseType = typeof checkVal === 'undefined' ? 'undefined' : _typeof(checkVal);
        if (responseType !== 'object' && checkVal !== true) {
          valid = false;
          this.notifyToastr('error', checkVal, _Const2.default.CANCEL_TOASTR);
        } else if (responseType === 'object' && checkVal.isValid !== true) {
          valid = false;
          this.notifyToastr(checkVal.notification.type, checkVal.notification.msg, checkVal.notification.title);
        }
        if (!valid) {
          // animate input
          ts.clearTimeout();
          var _props = this.props,
              invalidColumnClassName = _props.invalidColumnClassName,
              row = _props.row;

          var className = _util2.default.isFunction(invalidColumnClassName) ? invalidColumnClassName(value, row) : invalidColumnClassName;
          ts.setState({ shakeEditor: true, className: className });
          ts.timeouteClear = setTimeout(function () {
            ts.setState({ shakeEditor: false });
          }, 300);
          this.focusInEditor();
          return valid;
        }
      }
      return valid;
    }
    // END

  }, {
    key: '__notifyToastr__REACT_HOT_LOADER__',
    value: function __notifyToastr__REACT_HOT_LOADER__(type, message, title) {
      var toastr = true;
      var beforeShowError = this.props.beforeShowError;

      if (beforeShowError) {
        toastr = beforeShowError(type, message, title);
      }
      if (toastr) {
        this.refs.notifier.notice(type, message, title);
      }
    }
  }, {
    key: 'clearTimeout',
    value: function (_clearTimeout) {
      function clearTimeout() {
        return _clearTimeout.apply(this, arguments);
      }

      clearTimeout.toString = function () {
        return _clearTimeout.toString();
      };

      return clearTimeout;
    }(function () {
      if (this.timeouteClear !== 0) {
        clearTimeout(this.timeouteClear);
        this.timeouteClear = 0;
      }
    })
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.focusInEditor();
      var dom = _reactDom2.default.findDOMNode(this);
      if (this.props.isFocus) {
        dom.focus();
      } else {
        dom.blur();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var dom = _reactDom2.default.findDOMNode(this);
      if (this.props.isFocus) {
        dom.focus();
      } else {
        dom.blur();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearTimeout();
    }
  }, {
    key: 'focusInEditor',
    value: function focusInEditor() {
      if (_util2.default.isFunction(this.refs.inputRef.focus)) {
        this.refs.inputRef.focus();
      }
    }
  }, {
    key: '__handleClick__REACT_HOT_LOADER__',
    value: function __handleClick__REACT_HOT_LOADER__(e) {
      if (e.target.tagName !== 'TD') {
        e.stopPropagation();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          editable = _props2.editable,
          format = _props2.format,
          customEditor = _props2.customEditor,
          isFocus = _props2.isFocus,
          customStyleWithNav = _props2.customStyleWithNav,
          row = _props2.row;
      var shakeEditor = this.state.shakeEditor;

      var attr = {
        ref: 'inputRef',
        onKeyDown: this.handleKeyPress,
        onBlur: this.handleBlur
      };
      var style = { position: 'relative' };
      var fieldValue = this.props.fieldValue;
      var className = this.state.className;
      // put placeholder if exist

      editable.placeholder && (attr.placeholder = editable.placeholder);

      var editorClass = (0, _classnames2.default)({ 'animated': shakeEditor, 'shake': shakeEditor });
      fieldValue = fieldValue === 0 ? '0' : fieldValue;
      var cellEditor = void 0;
      if (customEditor) {
        var customEditorProps = _extends({
          row: row
        }, attr, {
          defaultValue: this.valueShortCircuit(fieldValue)
        }, customEditor.customEditorParameters);
        cellEditor = customEditor.getElement(this.handleCustomUpdate, customEditorProps);
      } else {
        cellEditor = (0, _Editor2.default)(editable, attr, format, editorClass, this.valueShortCircuit(fieldValue));
      }

      if (isFocus) {
        if (customStyleWithNav) {
          var customStyle = _util2.default.isFunction(customStyleWithNav) ? customStyleWithNav(fieldValue, row) : customStyleWithNav;
          style = _extends({}, style, customStyle);
        } else {
          className = className + ' default-focus-cell';
        }
      }

      return _react2.default.createElement(
        'td',
        { ref: 'td',
          style: style,
          className: className,
          onClick: this.handleClick },
        cellEditor,
        _react2.default.createElement(_Notification2.default, { ref: 'notifier' })
      );
    }
  }, {
    key: '_getCheckBoxValue',
    value: function _getCheckBoxValue(e) {
      var value = '';
      var values = e.currentTarget.value.split(':');
      value = e.currentTarget.checked ? values[0] : values[1];
      return value;
    }
  }]);

  return TableEditColumn;
}(_react.Component);

TableEditColumn.propTypes = {
  completeEdit: _react.PropTypes.func,
  rowIndex: _react.PropTypes.number,
  colIndex: _react.PropTypes.number,
  blurToSave: _react.PropTypes.bool,
  editable: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.object]),
  format: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.func]),
  row: _react.PropTypes.any,
  fieldValue: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.bool, _react.PropTypes.number, _react.PropTypes.array, _react.PropTypes.object]),
  className: _react.PropTypes.any,
  beforeShowError: _react.PropTypes.func,
  isFocus: _react.PropTypes.bool,
  customStyleWithNav: _react.PropTypes.oneOfType([_react.PropTypes.func, _react.PropTypes.object])
};

var _default = TableEditColumn;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableEditColumn, 'TableEditColumn', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableEditColumn.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableEditColumn.js');
}();

;

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Const = __webpack_require__(35);

var _Const2 = _interopRequireDefault(_Const);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TableFilter = function (_Component) {
  _inherits(TableFilter, _Component);

  function TableFilter(props) {
    _classCallCheck(this, TableFilter);

    var _this = _possibleConstructorReturn(this, (TableFilter.__proto__ || Object.getPrototypeOf(TableFilter)).call(this, props));

    _this.handleKeyUp = function () {
      return _this.__handleKeyUp__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.filterObj = {};
    return _this;
  }

  _createClass(TableFilter, [{
    key: '__handleKeyUp__REACT_HOT_LOADER__',
    value: function __handleKeyUp__REACT_HOT_LOADER__(e) {
      var _e$currentTarget = e.currentTarget,
          value = _e$currentTarget.value,
          name = _e$currentTarget.name;

      if (value.trim() === '') {
        delete this.filterObj[name];
      } else {
        this.filterObj[name] = value;
      }
      this.props.onFilter(this.filterObj);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          striped = _props.striped,
          condensed = _props.condensed,
          rowSelectType = _props.rowSelectType,
          columns = _props.columns;

      var tableClasses = (0, _classnames2.default)('table', {
        'table-striped': striped,
        'table-condensed': condensed
      });
      var selectRowHeader = null;

      if (rowSelectType === _Const2.default.ROW_SELECT_SINGLE || rowSelectType === _Const2.default.ROW_SELECT_MULTI) {
        var style = {
          width: 35,
          paddingLeft: 0,
          paddingRight: 0
        };
        selectRowHeader = _react2.default.createElement(
          'th',
          { style: style, key: -1 },
          'Filter'
        );
      }

      var filterField = columns.map(function (column) {
        var hidden = column.hidden,
            width = column.width,
            name = column.name;

        var thStyle = {
          display: hidden ? 'none' : null,
          width: width
        };
        return _react2.default.createElement(
          'th',
          { key: name, style: thStyle },
          _react2.default.createElement(
            'div',
            { className: 'th-inner table-header-column' },
            _react2.default.createElement('input', { size: '10', type: 'text',
              placeholder: name, name: name, onKeyUp: this.handleKeyUp })
          )
        );
      }, this);

      return _react2.default.createElement(
        'table',
        { className: tableClasses, style: { marginTop: 5 } },
        _react2.default.createElement(
          'thead',
          null,
          _react2.default.createElement(
            'tr',
            { style: { borderBottomStyle: 'hidden' } },
            selectRowHeader,
            filterField
          )
        )
      );
    }
  }]);

  return TableFilter;
}(_react.Component);

TableFilter.propTypes = {
  columns: _react.PropTypes.array,
  rowSelectType: _react.PropTypes.string,
  onFilter: _react.PropTypes.func
};
var _default = TableFilter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableFilter, 'TableFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableFilter.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableFilter.js');
}();

;

/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(33);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Const = __webpack_require__(35);

var _Const2 = _interopRequireDefault(_Const);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _SelectRowHeaderColumn = __webpack_require__(1313);

var _SelectRowHeaderColumn2 = _interopRequireDefault(_SelectRowHeaderColumn);

var _ExpandRowHeaderColumn = __webpack_require__(1311);

var _ExpandRowHeaderColumn2 = _interopRequireDefault(_ExpandRowHeaderColumn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Checkbox = function (_Component) {
  _inherits(Checkbox, _Component);

  function Checkbox() {
    _classCallCheck(this, Checkbox);

    return _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
  }

  _createClass(Checkbox, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.update(this.props.checked);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      this.update(props.checked);
    }
  }, {
    key: 'update',
    value: function update(checked) {
      _reactDom2.default.findDOMNode(this).indeterminate = checked === 'indeterminate';
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('input', { className: 'react-bs-select-all',
        type: 'checkbox',
        checked: this.props.checked,
        onChange: this.props.onChange });
    }
  }]);

  return Checkbox;
}(_react.Component);

function getSortOrder(sortList, field, enableSort) {
  if (!enableSort) return undefined;
  var result = sortList.filter(function (sortObj) {
    return sortObj.sortField === field;
  });
  if (result.length > 0) {
    return result[0].order;
  } else {
    return undefined;
  }
}

var TableHeader = function (_Component2) {
  _inherits(TableHeader, _Component2);

  function TableHeader() {
    var _ref;

    var _temp, _this2, _ret;

    _classCallCheck(this, TableHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = _possibleConstructorReturn(this, (_ref = TableHeader.__proto__ || Object.getPrototypeOf(TableHeader)).call.apply(_ref, [this].concat(args))), _this2), _this2.getHeaderColGrouop = function () {
      var _this3;

      return (_this3 = _this2).__getHeaderColGrouop__REACT_HOT_LOADER__.apply(_this3, arguments);
    }, _temp), _possibleConstructorReturn(_this2, _ret);
  }

  _createClass(TableHeader, [{
    key: 'render',
    value: function render() {
      var containerClasses = (0, _classnames2.default)('react-bs-container-header', 'table-header-wrapper', this.props.headerContainerClass);
      var tableClasses = (0, _classnames2.default)('table', 'table-hover', {
        'table-bordered': this.props.bordered,
        'table-condensed': this.props.condensed
      }, this.props.tableHeaderClass);

      var rowCount = Math.max.apply(Math, _toConsumableArray(_react2.default.Children.map(this.props.children, function (elm) {
        return elm && elm.props.row ? Number(elm.props.row) : 0;
      })));

      var rows = [];
      var rowKey = 0;

      rows[0] = [];
      rows[0].push([this.props.expandColumnVisible && this.props.expandColumnBeforeSelectColumn && _react2.default.createElement(_ExpandRowHeaderColumn2.default, { rowCount: rowCount + 1 })], [this.renderSelectRowHeader(rowCount + 1, rowKey++)], [this.props.expandColumnVisible && !this.props.expandColumnBeforeSelectColumn && _react2.default.createElement(_ExpandRowHeaderColumn2.default, { rowCount: rowCount + 1 })]);
      var _props = this.props,
          sortIndicator = _props.sortIndicator,
          sortList = _props.sortList,
          onSort = _props.onSort,
          reset = _props.reset;


      _react2.default.Children.forEach(this.props.children, function (elm) {
        if (elm === null || elm === undefined) {
          // Skip null or undefined elements.
          return;
        }
        var _elm$props = elm.props,
            dataField = _elm$props.dataField,
            dataSort = _elm$props.dataSort;

        var sort = getSortOrder(sortList, dataField, dataSort);
        var rowIndex = elm.props.row ? Number(elm.props.row) : 0;
        var rowSpan = elm.props.rowSpan ? Number(elm.props.rowSpan) : 1;
        if (rows[rowIndex] === undefined) {
          rows[rowIndex] = [];
        }
        if (rowSpan + rowIndex === rowCount + 1) {
          rows[rowIndex].push(_react2.default.cloneElement(elm, { reset: reset, key: rowKey++, onSort: onSort, sort: sort, sortIndicator: sortIndicator, isOnlyHead: false }));
        } else {
          rows[rowIndex].push(_react2.default.cloneElement(elm, { key: rowKey++, isOnlyHead: true }));
        }
      });

      var trs = rows.map(function (row, indexRow) {
        return _react2.default.createElement(
          'tr',
          { key: indexRow },
          row
        );
      });

      return _react2.default.createElement(
        'div',
        { ref: 'container', className: containerClasses, style: this.props.style },
        _react2.default.createElement(
          'table',
          { className: tableClasses },
          _react2.default.cloneElement(this.props.colGroups, { ref: 'headerGrp' }),
          _react2.default.createElement(
            'thead',
            { ref: 'header' },
            trs
          )
        )
      );
    }
  }, {
    key: '__getHeaderColGrouop__REACT_HOT_LOADER__',
    value: function __getHeaderColGrouop__REACT_HOT_LOADER__() {
      return this.refs.headerGrp.childNodes;
    }
  }, {
    key: 'renderSelectRowHeader',
    value: function renderSelectRowHeader(rowCount, rowKey) {
      if (this.props.hideSelectColumn) {
        return null;
      } else if (this.props.customComponent) {
        var CustomComponent = this.props.customComponent;
        return _react2.default.createElement(
          _SelectRowHeaderColumn2.default,
          { key: rowKey, rowCount: rowCount },
          _react2.default.createElement(CustomComponent, { type: 'checkbox', checked: this.props.isSelectAll,
            indeterminate: this.props.isSelectAll === 'indeterminate', disabled: false,
            onChange: this.props.onSelectAllRow, rowIndex: 'Header' })
        );
      } else if (this.props.rowSelectType === _Const2.default.ROW_SELECT_SINGLE) {
        return _react2.default.createElement(_SelectRowHeaderColumn2.default, { key: rowKey, rowCount: rowCount });
      } else if (this.props.rowSelectType === _Const2.default.ROW_SELECT_MULTI) {
        return _react2.default.createElement(
          _SelectRowHeaderColumn2.default,
          { key: rowKey, rowCount: rowCount },
          _react2.default.createElement(Checkbox, {
            onChange: this.props.onSelectAllRow,
            checked: this.props.isSelectAll })
        );
      } else {
        return null;
      }
    }
  }]);

  return TableHeader;
}(_react.Component);

TableHeader.propTypes = {
  headerContainerClass: _react.PropTypes.string,
  tableHeaderClass: _react.PropTypes.string,
  style: _react.PropTypes.object,
  rowSelectType: _react.PropTypes.string,
  onSort: _react.PropTypes.func,
  onSelectAllRow: _react.PropTypes.func,
  sortList: _react.PropTypes.array,
  hideSelectColumn: _react.PropTypes.bool,
  bordered: _react.PropTypes.bool,
  condensed: _react.PropTypes.bool,
  isFiltered: _react.PropTypes.bool,
  isSelectAll: _react.PropTypes.oneOf([true, 'indeterminate', false]),
  sortIndicator: _react.PropTypes.bool,
  customComponent: _react.PropTypes.func,
  colGroups: _react.PropTypes.element,
  reset: _react.PropTypes.bool,
  expandColumnVisible: _react.PropTypes.bool,
  expandColumnComponent: _react.PropTypes.func,
  expandColumnBeforeSelectColumn: _react.PropTypes.bool
};

var _default = TableHeader;
exports.default = _default;
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(Checkbox, 'Checkbox', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeader.js');

  __REACT_HOT_LOADER__.register(getSortOrder, 'getSortOrder', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeader.js');

  __REACT_HOT_LOADER__.register(TableHeader, 'TableHeader', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeader.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableHeader.js');
}();

;

/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _util = __webpack_require__(87);

var _util2 = _interopRequireDefault(_util);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-nested-ternary: 0 */


var TableRow = function (_Component) {
  _inherits(TableRow, _Component);

  function TableRow(props) {
    _classCallCheck(this, TableRow);

    var _this = _possibleConstructorReturn(this, (TableRow.__proto__ || Object.getPrototypeOf(TableRow)).call(this, props));

    _this.rowClick = function () {
      return _this.__rowClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.expandRow = function () {
      return _this.__expandRow__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.rowDoubleClick = function () {
      return _this.__rowDoubleClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.rowMouseOut = function () {
      return _this.__rowMouseOut__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.rowMouseOver = function () {
      return _this.__rowMouseOver__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.clickNum = 0;
    return _this;
  }

  _createClass(TableRow, [{
    key: '__rowClick__REACT_HOT_LOADER__',
    value: function __rowClick__REACT_HOT_LOADER__(e) {
      var _this2 = this;

      var rowIndex = this.props.index + 1;
      var cellIndex = e.target.cellIndex;
      if (this.props.onRowClick) this.props.onRowClick(rowIndex, cellIndex);
      var _props = this.props,
          selectRow = _props.selectRow,
          unselectableRow = _props.unselectableRow,
          isSelected = _props.isSelected,
          onSelectRow = _props.onSelectRow,
          onExpandRow = _props.onExpandRow;

      if (selectRow) {
        if (selectRow.clickToSelect && !unselectableRow) {
          onSelectRow(rowIndex, !isSelected, e);
        } else if (selectRow.clickToSelectAndEditCell && !unselectableRow) {
          this.clickNum++;
          /** if clickToSelectAndEditCell is enabled,
           *  there should be a delay to prevent a selection changed when
           *  user dblick to edit cell on same row but different cell
          **/
          setTimeout(function () {
            if (_this2.clickNum === 1) {
              onSelectRow(rowIndex, !isSelected, e);
              onExpandRow(rowIndex, cellIndex);
            }
            _this2.clickNum = 0;
          }, 200);
        } else {
          this.expandRow(rowIndex, cellIndex);
        }
      }
    }
  }, {
    key: '__expandRow__REACT_HOT_LOADER__',
    value: function __expandRow__REACT_HOT_LOADER__(rowIndex, cellIndex) {
      var _this3 = this;

      this.clickNum++;
      setTimeout(function () {
        if (_this3.clickNum === 1) {
          _this3.props.onExpandRow(rowIndex, cellIndex);
        }
        _this3.clickNum = 0;
      }, 200);
    }
  }, {
    key: '__rowDoubleClick__REACT_HOT_LOADER__',
    value: function __rowDoubleClick__REACT_HOT_LOADER__(e) {
      if (e.target.tagName !== 'INPUT' && e.target.tagName !== 'SELECT' && e.target.tagName !== 'TEXTAREA') {
        if (this.props.onRowDoubleClick) {
          this.props.onRowDoubleClick(this.props.index);
        }
      }
    }
  }, {
    key: '__rowMouseOut__REACT_HOT_LOADER__',
    value: function __rowMouseOut__REACT_HOT_LOADER__(e) {
      var rowIndex = this.props.index;
      if (this.props.onRowMouseOut) {
        this.props.onRowMouseOut(rowIndex, e);
      }
    }
  }, {
    key: '__rowMouseOver__REACT_HOT_LOADER__',
    value: function __rowMouseOver__REACT_HOT_LOADER__(e) {
      var rowIndex = this.props.index;
      if (this.props.onRowMouseOver) {
        this.props.onRowMouseOver(rowIndex, e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      this.clickNum = 0;
      var _props2 = this.props,
          selectRow = _props2.selectRow,
          row = _props2.row,
          isSelected = _props2.isSelected,
          className = _props2.className,
          index = _props2.index;
      var style = this.props.style;

      var backgroundColor = null;
      var selectRowClass = null;

      if (selectRow) {
        backgroundColor = _util2.default.isFunction(selectRow.bgColor) ? selectRow.bgColor(row, isSelected) : isSelected ? selectRow.bgColor : null;

        selectRowClass = _util2.default.isFunction(selectRow.className) ? selectRow.className(row, isSelected) : isSelected ? selectRow.className : null;
      }

      if (_util2.default.isFunction(style)) {
        style = style(row, index);
      } else {
        style = _extends({}, style) || {};
      }
      // the bgcolor of row selection always overwrite the bgcolor defined by global.
      if (style && backgroundColor && isSelected) {
        style.backgroundColor = backgroundColor;
      }
      var trCss = {
        style: _extends({}, style),
        className: (0, _classnames2.default)(selectRowClass, className)
      };

      return _react2.default.createElement(
        'tr',
        _extends({}, trCss, {
          onMouseOver: this.rowMouseOver,
          onMouseOut: this.rowMouseOut,
          onClick: this.rowClick,
          onDoubleClick: this.rowDoubleClick }),
        this.props.children
      );
    }
  }]);

  return TableRow;
}(_react.Component);

TableRow.propTypes = {
  index: _react.PropTypes.number,
  row: _react.PropTypes.any,
  style: _react.PropTypes.any,
  isSelected: _react.PropTypes.bool,
  enableCellEdit: _react.PropTypes.bool,
  onRowClick: _react.PropTypes.func,
  onRowDoubleClick: _react.PropTypes.func,
  onSelectRow: _react.PropTypes.func,
  onExpandRow: _react.PropTypes.func,
  onRowMouseOut: _react.PropTypes.func,
  onRowMouseOver: _react.PropTypes.func,
  unselectableRow: _react.PropTypes.bool
};
TableRow.defaultProps = {
  onRowClick: undefined,
  onRowDoubleClick: undefined
};
var _default = TableRow;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableRow, 'TableRow', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableRow.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/TableRow.js');
}();

;

/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(87);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (_util2.default.canUseDOM()) {
  var filesaver = __webpack_require__(1321);
  var saveAs = filesaver.saveAs;
} /* eslint block-scoped-var: 0 */
/* eslint vars-on-top: 0 */
/* eslint no-var: 0 */
/* eslint no-unused-vars: 0 */


function toString(data, keys, separator, excludeCSVHeader) {
  var dataString = '';
  if (data.length === 0) return dataString;

  var headCells = [];
  var rowCount = 0;
  keys.forEach(function (key) {
    if (key.row > rowCount) {
      rowCount = key.row;
    }
    // rowCount += (key.rowSpan + key.colSpan - 1);
    for (var index = 0; index < key.colSpan; index++) {
      headCells.push(key);
    }
  });

  var firstRow = excludeCSVHeader ? 1 : 0;

  var _loop = function _loop(i) {
    dataString += headCells.map(function (x) {
      if (x.row + (x.rowSpan - 1) === i) {
        return x.header;
      }
      if (x.row === i && x.rowSpan > 1) {
        return '';
      }
    }).filter(function (key) {
      return typeof key !== 'undefined';
    }).join(separator) + '\n';
  };

  for (var i = firstRow; i <= rowCount; i++) {
    _loop(i);
  }

  keys = keys.filter(function (key) {
    return key.field !== undefined;
  });

  data.map(function (row) {
    keys.map(function (col, i) {
      var field = col.field,
          format = col.format,
          extraData = col.extraData;

      var value = typeof format !== 'undefined' ? format(row[field], row, extraData) : row[field];
      var cell = typeof value !== 'undefined' ? '"' + value + '"' : '';
      dataString += cell;
      if (i + 1 < keys.length) dataString += separator;
    });

    dataString += '\n';
  });

  return dataString;
}

var exportCSV = function exportCSV(data, keys, filename, separator, noAutoBOM, excludeCSVHeader) {
  var dataString = toString(data, keys, separator, excludeCSVHeader);
  if (typeof window !== 'undefined') {
    noAutoBOM = noAutoBOM === undefined ? true : noAutoBOM;
    saveAs(new Blob([dataString], { type: 'text/plain;charset=utf-8' }), filename, noAutoBOM);
  }
};

var _default = exportCSV;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(saveAs, 'saveAs', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/csv_export_util.js');

  __REACT_HOT_LOADER__.register(toString, 'toString', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/csv_export_util.js');

  __REACT_HOT_LOADER__.register(exportCSV, 'exportCSV', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/csv_export_util.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/csv_export_util.js');
}();

;

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

var saveAs = saveAs || function (view) {
	"use strict";
	// IE <10 is explicitly unsupported

	if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
		return;
	}
	var doc = view.document
	// only get URL when necessary in case Blob.js hasn't overridden it yet
	,
	    get_URL = function get_URL() {
		return view.URL || view.webkitURL || view;
	},
	    save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a"),
	    can_use_save_link = "download" in save_link,
	    click = function click(node) {
		var event = new MouseEvent("click");
		node.dispatchEvent(event);
	},
	    is_safari = /constructor/i.test(view.HTMLElement) || view.safari,
	    is_chrome_ios = /CriOS\/[\d]+/.test(navigator.userAgent),
	    throw_outside = function throw_outside(ex) {
		(view.setImmediate || view.setTimeout)(function () {
			throw ex;
		}, 0);
	},
	    force_saveable_type = "application/octet-stream"
	// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
	,
	    arbitrary_revoke_timeout = 1000 * 40 // in ms
	,
	    revoke = function revoke(file) {
		var revoker = function revoker() {
			if (typeof file === "string") {
				// file is an object URL
				get_URL().revokeObjectURL(file);
			} else {
				// file is a File
				file.remove();
			}
		};
		setTimeout(revoker, arbitrary_revoke_timeout);
	},
	    dispatch = function dispatch(filesaver, event_types, event) {
		event_types = [].concat(event_types);
		var i = event_types.length;
		while (i--) {
			var listener = filesaver["on" + event_types[i]];
			if (typeof listener === "function") {
				try {
					listener.call(filesaver, event || filesaver);
				} catch (ex) {
					throw_outside(ex);
				}
			}
		}
	},
	    auto_bom = function auto_bom(blob) {
		// prepend BOM for UTF-8 XML and text/* types (including HTML)
		// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
		if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
			return new Blob([String.fromCharCode(0xFEFF), blob], { type: blob.type });
		}
		return blob;
	},
	    FileSaver = function FileSaver(blob, name, no_auto_bom) {
		if (!no_auto_bom) {
			blob = auto_bom(blob);
		}
		// First try a.download, then web filesystem, then object URLs
		var filesaver = this,
		    type = blob.type,
		    force = type === force_saveable_type,
		    object_url,
		    dispatch_all = function dispatch_all() {
			dispatch(filesaver, "writestart progress write writeend".split(" "));
		}
		// on any filesys errors revert to saving with object URLs
		,
		    fs_error = function fs_error() {
			if ((is_chrome_ios || force && is_safari) && view.FileReader) {
				// Safari doesn't allow downloading of blob urls
				var reader = new FileReader();
				reader.onloadend = function () {
					var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
					var popup = view.open(url, '_blank');
					if (!popup) view.location.href = url;
					url = undefined; // release reference before dispatching
					filesaver.readyState = filesaver.DONE;
					dispatch_all();
				};
				reader.readAsDataURL(blob);
				filesaver.readyState = filesaver.INIT;
				return;
			}
			// don't create more object URLs than needed
			if (!object_url) {
				object_url = get_URL().createObjectURL(blob);
			}
			if (force) {
				view.location.href = object_url;
			} else {
				var opened = view.open(object_url, "_blank");
				if (!opened) {
					// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
					view.location.href = object_url;
				}
			}
			filesaver.readyState = filesaver.DONE;
			dispatch_all();
			revoke(object_url);
		};
		filesaver.readyState = filesaver.INIT;

		if (can_use_save_link) {
			object_url = get_URL().createObjectURL(blob);
			setTimeout(function () {
				save_link.href = object_url;
				save_link.download = name;
				click(save_link);
				dispatch_all();
				revoke(object_url);
				filesaver.readyState = filesaver.DONE;
			});
			return;
		}

		fs_error();
	},
	    FS_proto = FileSaver.prototype,
	    saveAs = function saveAs(blob, name, no_auto_bom) {
		return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
	};
	// IE 10+ (native saveAs)
	if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
		return function (blob, name, no_auto_bom) {
			name = name || blob.name || "download";

			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			return navigator.msSaveOrOpenBlob(blob, name);
		};
	}

	FS_proto.abort = function () {};
	FS_proto.readyState = FS_proto.INIT = 0;
	FS_proto.WRITING = 1;
	FS_proto.DONE = 2;

	FS_proto.error = FS_proto.onwritestart = FS_proto.onprogress = FS_proto.onwrite = FS_proto.onabort = FS_proto.onerror = FS_proto.onwriteend = null;

	return saveAs;
}(typeof self !== "undefined" && self || typeof window !== "undefined" && window || undefined.content);
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window

if (typeof module !== "undefined" && module.exports) {
	module.exports.saveAs = saveAs;
} else if ("function" !== "undefined" && __webpack_require__(1769) !== null && __webpack_require__(1770) !== null) {
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
		return saveAs;
	}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(saveAs, "saveAs", "/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filesaver.js");
}();

;

/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Const = __webpack_require__(35);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint quotes: 0 */
/* eslint max-len: 0 */


var legalComparators = ['=', '>', '>=', '<', '<=', '!='];

function dateParser(d) {
  return d.getFullYear() + '-' + ("0" + (d.getMonth() + 1)).slice(-2) + '-' + ("0" + d.getDate()).slice(-2);
}

var DateFilter = function (_Component) {
  _inherits(DateFilter, _Component);

  function DateFilter(props) {
    _classCallCheck(this, DateFilter);

    var _this = _possibleConstructorReturn(this, (DateFilter.__proto__ || Object.getPrototypeOf(DateFilter)).call(this, props));

    _this.dateComparators = _this.props.dateComparators || legalComparators;
    _this.filter = _this.filter.bind(_this);
    _this.onChangeComparator = _this.onChangeComparator.bind(_this);
    return _this;
  }

  _createClass(DateFilter, [{
    key: 'setDefaultDate',
    value: function setDefaultDate() {
      var defaultDate = '';
      var defaultValue = this.props.defaultValue;

      if (defaultValue && defaultValue.date) {
        // Set the appropriate format for the input type=date, i.e. "YYYY-MM-DD"
        defaultDate = dateParser(new Date(defaultValue.date));
      }
      return defaultDate;
    }
  }, {
    key: 'onChangeComparator',
    value: function onChangeComparator(event) {
      var date = this.refs.inputDate.value;
      var comparator = event.target.value;
      if (date === '') {
        return;
      }
      date = new Date(date);
      this.props.filterHandler({ date: date, comparator: comparator }, _Const2.default.FILTER_TYPE.DATE);
    }
  }, {
    key: 'getComparatorOptions',
    value: function getComparatorOptions() {
      var optionTags = [];
      optionTags.push(_react2.default.createElement('option', { key: '-1' }));
      for (var i = 0; i < this.dateComparators.length; i++) {
        optionTags.push(_react2.default.createElement(
          'option',
          { key: i, value: this.dateComparators[i] },
          this.dateComparators[i]
        ));
      }
      return optionTags;
    }
  }, {
    key: 'filter',
    value: function filter(event) {
      var comparator = this.refs.dateFilterComparator.value;
      var dateValue = event.target.value;
      if (dateValue) {
        this.props.filterHandler({ date: new Date(dateValue), comparator: comparator }, _Const2.default.FILTER_TYPE.DATE);
      } else {
        this.props.filterHandler(null, _Const2.default.FILTER_TYPE.DATE);
      }
    }
  }, {
    key: 'cleanFiltered',
    value: function cleanFiltered() {
      var value = this.setDefaultDate();
      var comparator = this.props.defaultValue ? this.props.defaultValue.comparator : '';
      this.setState(function () {
        return { isPlaceholderSelected: value === '' };
      });
      this.refs.dateFilterComparator.value = comparator;
      this.refs.inputDate.value = value;
      this.props.filterHandler({ date: new Date(value), comparator: comparator }, _Const2.default.FILTER_TYPE.DATE);
    }
  }, {
    key: 'applyFilter',
    value: function applyFilter(filterDateObj) {
      var date = filterDateObj.date,
          comparator = filterDateObj.comparator;

      this.setState(function () {
        return { isPlaceholderSelected: date === '' };
      });
      this.refs.dateFilterComparator.value = comparator;
      this.refs.inputDate.value = dateParser(date);
      this.props.filterHandler({ date: date, comparator: comparator }, _Const2.default.FILTER_TYPE.DATE);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var comparator = this.refs.dateFilterComparator.value;
      var dateValue = this.refs.inputDate.value;
      if (comparator && dateValue) {
        this.props.filterHandler({ date: new Date(dateValue), comparator: comparator }, _Const2.default.FILTER_TYPE.DATE);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          defaultValue = _props.defaultValue,
          _props$style = _props.style,
          date = _props$style.date,
          comparator = _props$style.comparator;

      return _react2.default.createElement(
        'div',
        { className: 'filter date-filter' },
        _react2.default.createElement(
          'select',
          { ref: 'dateFilterComparator',
            style: comparator,
            className: 'date-filter-comparator form-control',
            onChange: this.onChangeComparator,
            defaultValue: defaultValue ? defaultValue.comparator : '' },
          this.getComparatorOptions()
        ),
        _react2.default.createElement('input', { ref: 'inputDate',
          className: 'filter date-filter-input form-control',
          style: date,
          type: 'date',
          onChange: this.filter,
          defaultValue: this.setDefaultDate() })
      );
    }
  }]);

  return DateFilter;
}(_react.Component);

DateFilter.propTypes = {
  filterHandler: _react.PropTypes.func.isRequired,
  defaultValue: _react.PropTypes.shape({
    date: _react.PropTypes.object,
    comparator: _react.PropTypes.oneOf(legalComparators)
  }),
  style: _react.PropTypes.shape({
    date: _react.PropTypes.oneOfType([_react.PropTypes.object]),
    comparator: _react.PropTypes.oneOfType([_react.PropTypes.object])
  }),
  /* eslint consistent-return: 0 */
  dateComparators: function dateComparators(props, propName) {
    if (!props[propName]) {
      return;
    }
    for (var i = 0; i < props[propName].length; i++) {
      var comparatorIsValid = false;
      for (var j = 0; j < legalComparators.length; j++) {
        if (legalComparators[j] === props[propName][i]) {
          comparatorIsValid = true;
          break;
        }
      }
      if (!comparatorIsValid) {
        return new Error('Date comparator provided is not supported.\n          Use only ' + legalComparators);
      }
    }
  },
  columnName: _react.PropTypes.string
};

DateFilter.defaultProps = {
  style: {
    date: null,
    comparator: null
  }
};

var _default = DateFilter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(legalComparators, 'legalComparators', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Date.js');

  __REACT_HOT_LOADER__.register(dateParser, 'dateParser', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Date.js');

  __REACT_HOT_LOADER__.register(DateFilter, 'DateFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Date.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Date.js');
}();

;

/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Const = __webpack_require__(35);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var legalComparators = ['=', '>', '>=', '<', '<=', '!='];

var NumberFilter = function (_Component) {
  _inherits(NumberFilter, _Component);

  function NumberFilter(props) {
    _classCallCheck(this, NumberFilter);

    var _this = _possibleConstructorReturn(this, (NumberFilter.__proto__ || Object.getPrototypeOf(NumberFilter)).call(this, props));

    _this.numberComparators = _this.props.numberComparators || legalComparators;
    _this.timeout = null;
    _this.state = {
      isPlaceholderSelected: _this.props.defaultValue === undefined || _this.props.defaultValue.number === undefined || _this.props.options && _this.props.options.indexOf(_this.props.defaultValue.number) === -1
    };
    _this.onChangeNumber = _this.onChangeNumber.bind(_this);
    _this.onChangeNumberSet = _this.onChangeNumberSet.bind(_this);
    _this.onChangeComparator = _this.onChangeComparator.bind(_this);
    return _this;
  }

  _createClass(NumberFilter, [{
    key: 'onChangeNumber',
    value: function onChangeNumber(event) {
      var _this2 = this;

      var comparator = this.refs.numberFilterComparator.value;
      if (comparator === '') {
        return;
      }
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      var filterValue = event.target.value;
      this.timeout = setTimeout(function () {
        _this2.props.filterHandler({ number: filterValue, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
      }, this.props.delay);
    }
  }, {
    key: 'onChangeNumberSet',
    value: function onChangeNumberSet(event) {
      var comparator = this.refs.numberFilterComparator.value;
      var value = event.target.value;

      this.setState(function () {
        return { isPlaceholderSelected: value === '' };
      });
      if (comparator === '') {
        return;
      }
      this.props.filterHandler({ number: value, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
    }
  }, {
    key: 'onChangeComparator',
    value: function onChangeComparator(event) {
      var value = this.refs.numberFilter.value;
      var comparator = event.target.value;
      if (value === '') {
        return;
      }
      this.props.filterHandler({ number: value, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
    }
  }, {
    key: 'cleanFiltered',
    value: function cleanFiltered() {
      var value = this.props.defaultValue ? this.props.defaultValue.number : '';
      var comparator = this.props.defaultValue ? this.props.defaultValue.comparator : '';
      this.setState(function () {
        return { isPlaceholderSelected: value === '' };
      });
      this.refs.numberFilterComparator.value = comparator;
      this.refs.numberFilter.value = value;
      this.props.filterHandler({ number: value, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
    }
  }, {
    key: 'applyFilter',
    value: function applyFilter(filterObj) {
      var number = filterObj.number,
          comparator = filterObj.comparator;

      this.setState(function () {
        return { isPlaceholderSelected: number === '' };
      });
      this.refs.numberFilterComparator.value = comparator;
      this.refs.numberFilter.value = number;
      this.props.filterHandler({ number: number, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
    }
  }, {
    key: 'getComparatorOptions',
    value: function getComparatorOptions() {
      var optionTags = [];
      var withoutEmptyComparatorOption = this.props.withoutEmptyComparatorOption;

      if (!withoutEmptyComparatorOption) {
        optionTags.push(_react2.default.createElement('option', { key: '-1' }));
      }
      for (var i = 0; i < this.numberComparators.length; i++) {
        optionTags.push(_react2.default.createElement(
          'option',
          { key: i, value: this.numberComparators[i] },
          this.numberComparators[i]
        ));
      }
      return optionTags;
    }
  }, {
    key: 'getNumberOptions',
    value: function getNumberOptions() {
      var optionTags = [];
      var _props = this.props,
          options = _props.options,
          withoutEmptyNumberOption = _props.withoutEmptyNumberOption;

      if (!withoutEmptyNumberOption) {
        optionTags.push(_react2.default.createElement(
          'option',
          { key: '-1', value: '' },
          this.props.placeholder || 'Select ' + this.props.columnName + '...'
        ));
      }
      for (var i = 0; i < options.length; i++) {
        optionTags.push(_react2.default.createElement(
          'option',
          { key: i, value: options[i] },
          options[i]
        ));
      }
      return optionTags;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var comparator = this.refs.numberFilterComparator.value;
      var number = this.refs.numberFilter.value;
      if (comparator && number) {
        this.props.filterHandler({ number: number, comparator: comparator }, _Const2.default.FILTER_TYPE.NUMBER);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var selectClass = (0, _classnames2.default)('select-filter', 'number-filter-input', 'form-control', { 'placeholder-selected': this.state.isPlaceholderSelected });

      return _react2.default.createElement(
        'div',
        { className: 'filter number-filter' },
        _react2.default.createElement(
          'select',
          { ref: 'numberFilterComparator',
            style: this.props.style.comparator,
            className: 'number-filter-comparator form-control',
            onChange: this.onChangeComparator,
            defaultValue: this.props.defaultValue ? this.props.defaultValue.comparator : '' },
          this.getComparatorOptions()
        ),
        this.props.options ? _react2.default.createElement(
          'select',
          { ref: 'numberFilter',
            className: selectClass,
            onChange: this.onChangeNumberSet,
            defaultValue: this.props.defaultValue ? this.props.defaultValue.number : '' },
          this.getNumberOptions()
        ) : _react2.default.createElement('input', { ref: 'numberFilter',
          type: 'number',
          style: this.props.style.number,
          className: 'number-filter-input form-control',
          placeholder: this.props.placeholder || 'Enter ' + this.props.columnName + '...',
          onChange: this.onChangeNumber,
          defaultValue: this.props.defaultValue ? this.props.defaultValue.number : '' })
      );
    }
  }]);

  return NumberFilter;
}(_react.Component);

NumberFilter.propTypes = {
  filterHandler: _react.PropTypes.func.isRequired,
  options: _react.PropTypes.arrayOf(_react.PropTypes.number),
  defaultValue: _react.PropTypes.shape({
    number: _react.PropTypes.number,
    comparator: _react.PropTypes.oneOf(legalComparators)
  }),
  style: _react.PropTypes.shape({
    number: _react.PropTypes.oneOfType([_react.PropTypes.object]),
    comparator: _react.PropTypes.oneOfType([_react.PropTypes.object])
  }),
  delay: _react.PropTypes.number,
  /* eslint consistent-return: 0 */
  numberComparators: function numberComparators(props, propName) {
    if (!props[propName]) {
      return;
    }
    for (var i = 0; i < props[propName].length; i++) {
      var comparatorIsValid = false;
      for (var j = 0; j < legalComparators.length; j++) {
        if (legalComparators[j] === props[propName][i]) {
          comparatorIsValid = true;
          break;
        }
      }
      if (!comparatorIsValid) {
        return new Error('Number comparator provided is not supported.\n          Use only ' + legalComparators);
      }
    }
  },
  placeholder: _react.PropTypes.string,
  columnName: _react.PropTypes.string,
  withoutEmptyComparatorOption: _react.PropTypes.bool,
  withoutEmptyNumberOption: _react.PropTypes.bool
};

NumberFilter.defaultProps = {
  delay: _Const2.default.FILTER_DELAY,
  withoutEmptyComparatorOption: false,
  withoutEmptyNumberOption: false,
  style: {
    number: null,
    comparator: null
  }
};

var _default = NumberFilter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(legalComparators, 'legalComparators', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Number.js');

  __REACT_HOT_LOADER__.register(NumberFilter, 'NumberFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Number.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Number.js');
}();

;

/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Const = __webpack_require__(35);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RegexFilter = function (_Component) {
  _inherits(RegexFilter, _Component);

  function RegexFilter(props) {
    _classCallCheck(this, RegexFilter);

    var _this = _possibleConstructorReturn(this, (RegexFilter.__proto__ || Object.getPrototypeOf(RegexFilter)).call(this, props));

    _this.filter = _this.filter.bind(_this);
    _this.timeout = null;
    return _this;
  }

  _createClass(RegexFilter, [{
    key: 'filter',
    value: function filter(event) {
      var _this2 = this;

      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      var filterValue = event.target.value;
      this.timeout = setTimeout(function () {
        _this2.props.filterHandler(filterValue, _Const2.default.FILTER_TYPE.REGEX);
      }, this.props.delay);
    }
  }, {
    key: 'cleanFiltered',
    value: function cleanFiltered() {
      var value = this.props.defaultValue ? this.props.defaultValue : '';
      this.refs.inputText.value = value;
      this.props.filterHandler(value, _Const2.default.FILTER_TYPE.TEXT);
    }
  }, {
    key: 'applyFilter',
    value: function applyFilter(filterRegx) {
      this.refs.inputText.value = filterRegx;
      this.props.filterHandler(filterRegx, _Const2.default.FILTER_TYPE.REGEX);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var value = this.refs.inputText.value;
      if (value) {
        this.props.filterHandler(value, _Const2.default.FILTER_TYPE.REGEX);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          defaultValue = _props.defaultValue,
          placeholder = _props.placeholder,
          columnName = _props.columnName,
          style = _props.style;

      return _react2.default.createElement('input', { ref: 'inputText',
        className: 'filter text-filter form-control',
        type: 'text',
        style: style,
        onChange: this.filter,
        placeholder: placeholder || 'Enter Regex for ' + columnName + '...',
        defaultValue: defaultValue ? defaultValue : '' });
    }
  }]);

  return RegexFilter;
}(_react.Component);

RegexFilter.propTypes = {
  filterHandler: _react.PropTypes.func.isRequired,
  defaultValue: _react.PropTypes.string,
  delay: _react.PropTypes.number,
  placeholder: _react.PropTypes.string,
  columnName: _react.PropTypes.string,
  style: _react.PropTypes.oneOfType([_react.PropTypes.object])
};

RegexFilter.defaultProps = {
  delay: _Const2.default.FILTER_DELAY
};

var _default = RegexFilter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(RegexFilter, 'RegexFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Regex.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Regex.js');
}();

;

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _Const = __webpack_require__(35);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function optionsEquals(options1, options2) {
  var keys = Object.keys(options1);
  for (var k in keys) {
    if (options1[k] !== options2[k]) {
      return false;
    }
  }
  return Object.keys(options1).length === Object.keys(options2).length;
}

var SelectFilter = function (_Component) {
  _inherits(SelectFilter, _Component);

  function SelectFilter(props) {
    _classCallCheck(this, SelectFilter);

    var _this = _possibleConstructorReturn(this, (SelectFilter.__proto__ || Object.getPrototypeOf(SelectFilter)).call(this, props));

    _this.filter = _this.filter.bind(_this);
    _this.state = {
      isPlaceholderSelected: _this.props.defaultValue === undefined || !_this.props.options.hasOwnProperty(_this.props.defaultValue)
    };
    return _this;
  }

  _createClass(SelectFilter, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var isPlaceholderSelected = nextProps.defaultValue === undefined || !nextProps.options.hasOwnProperty(nextProps.defaultValue);
      this.setState(function () {
        return {
          isPlaceholderSelected: isPlaceholderSelected
        };
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var needFilter = false;
      if (this.props.defaultValue !== prevProps.defaultValue) {
        needFilter = true;
      } else if (!optionsEquals(this.props.options, prevProps.options)) {
        needFilter = true;
      }
      if (needFilter) {
        var value = this.refs.selectInput.value;
        if (value) {
          this.props.filterHandler(value, _Const2.default.FILTER_TYPE.SELECT);
        }
      }
    }
  }, {
    key: 'filter',
    value: function filter(event) {
      var value = event.target.value;

      this.setState(function () {
        return { isPlaceholderSelected: value === '' };
      });
      this.props.filterHandler(value, _Const2.default.FILTER_TYPE.SELECT);
    }
  }, {
    key: 'cleanFiltered',
    value: function cleanFiltered() {
      var value = this.props.defaultValue !== undefined ? this.props.defaultValue : '';
      this.setState(function () {
        return { isPlaceholderSelected: value === '' };
      });
      this.refs.selectInput.value = value;
      this.props.filterHandler(value, _Const2.default.FILTER_TYPE.SELECT);
    }
  }, {
    key: 'applyFilter',
    value: function applyFilter(filterOption) {
      filterOption = filterOption + '';
      this.setState(function () {
        return { isPlaceholderSelected: filterOption === '' };
      });
      this.refs.selectInput.value = filterOption;
      this.props.filterHandler(filterOption, _Const2.default.FILTER_TYPE.SELECT);
    }
  }, {
    key: 'getOptions',
    value: function getOptions() {
      var optionTags = [];
      var _props = this.props,
          options = _props.options,
          placeholder = _props.placeholder,
          columnName = _props.columnName,
          selectText = _props.selectText,
          withoutEmptyOption = _props.withoutEmptyOption;

      var selectTextValue = selectText !== undefined ? selectText : 'Select';
      if (!withoutEmptyOption) {
        optionTags.push(_react2.default.createElement(
          'option',
          { key: '-1', value: '' },
          placeholder || selectTextValue + ' ' + columnName + '...'
        ));
      }
      Object.keys(options).map(function (key) {
        optionTags.push(_react2.default.createElement(
          'option',
          { key: key, value: key },
          options[key] + ''
        ));
      });
      return optionTags;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var value = this.refs.selectInput.value;
      if (value) {
        this.props.filterHandler(value, _Const2.default.FILTER_TYPE.SELECT);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var selectClass = (0, _classnames2.default)('filter', 'select-filter', 'form-control', { 'placeholder-selected': this.state.isPlaceholderSelected });

      return _react2.default.createElement(
        'select',
        { ref: 'selectInput',
          style: this.props.style,
          className: selectClass,
          onChange: this.filter,
          defaultValue: this.props.defaultValue !== undefined ? this.props.defaultValue : '' },
        this.getOptions()
      );
    }
  }]);

  return SelectFilter;
}(_react.Component);

SelectFilter.propTypes = {
  filterHandler: _react.PropTypes.func.isRequired,
  options: _react.PropTypes.object.isRequired,
  placeholder: _react.PropTypes.string,
  columnName: _react.PropTypes.string,
  style: _react.PropTypes.oneOfType([_react.PropTypes.object])
};

var _default = SelectFilter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(optionsEquals, 'optionsEquals', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Select.js');

  __REACT_HOT_LOADER__.register(SelectFilter, 'SelectFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Select.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Select.js');
}();

;

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Const = __webpack_require__(35);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextFilter = function (_Component) {
  _inherits(TextFilter, _Component);

  function TextFilter(props) {
    _classCallCheck(this, TextFilter);

    var _this = _possibleConstructorReturn(this, (TextFilter.__proto__ || Object.getPrototypeOf(TextFilter)).call(this, props));

    _this.filter = _this.filter.bind(_this);
    _this.timeout = null;
    _this.state = {
      value: _this.props.defaultValue || ''
    };
    return _this;
  }

  _createClass(TextFilter, [{
    key: 'filter',
    value: function filter(event) {
      var _this2 = this;

      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      var filterValue = event.target.value;
      this.setState(function () {
        return { value: filterValue };
      });
      this.timeout = setTimeout(function () {
        _this2.props.filterHandler(filterValue, _Const2.default.FILTER_TYPE.TEXT);
      }, this.props.delay);
    }
  }, {
    key: 'cleanFiltered',
    value: function cleanFiltered() {
      var value = this.props.defaultValue ? this.props.defaultValue : '';
      this.setState(function () {
        return { value: value };
      });
      this.props.filterHandler(value, _Const2.default.FILTER_TYPE.TEXT);
    }
  }, {
    key: 'applyFilter',
    value: function applyFilter(filterText) {
      this.setState(function () {
        return { value: filterText };
      });
      this.props.filterHandler(filterText, _Const2.default.FILTER_TYPE.TEXT);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var defaultValue = this.refs.inputText.value;
      if (defaultValue) {
        this.props.filterHandler(defaultValue, _Const2.default.FILTER_TYPE.TEXT);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.defaultValue !== this.props.defaultValue) {
        this.applyFilter(nextProps.defaultValue || '');
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          placeholder = _props.placeholder,
          columnName = _props.columnName,
          style = _props.style;

      return _react2.default.createElement('input', { ref: 'inputText',
        className: 'filter text-filter form-control',
        type: 'text',
        style: style,
        onChange: this.filter,
        placeholder: placeholder || 'Enter ' + columnName + '...',
        value: this.state.value });
    }
  }]);

  return TextFilter;
}(_react.Component);

TextFilter.propTypes = {
  filterHandler: _react.PropTypes.func.isRequired,
  defaultValue: _react.PropTypes.string,
  delay: _react.PropTypes.number,
  placeholder: _react.PropTypes.string,
  columnName: _react.PropTypes.string,
  style: _react.PropTypes.oneOfType([_react.PropTypes.object])
};

TextFilter.defaultProps = {
  delay: _Const2.default.FILTER_DELAY
};

var _default = TextFilter;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TextFilter, 'TextFilter', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Text.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/filters/Text.js');
}();

;

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PageButton = function (_Component) {
  _inherits(PageButton, _Component);

  function PageButton(props) {
    _classCallCheck(this, PageButton);

    var _this = _possibleConstructorReturn(this, (PageButton.__proto__ || Object.getPrototypeOf(PageButton)).call(this, props));

    _this.pageBtnClick = function () {
      return _this.__pageBtnClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    return _this;
  }

  _createClass(PageButton, [{
    key: '__pageBtnClick__REACT_HOT_LOADER__',
    value: function __pageBtnClick__REACT_HOT_LOADER__(e) {
      e.preventDefault();
      this.props.changePage(e.currentTarget.textContent);
    }
  }, {
    key: 'render',
    value: function render() {
      var classes = (0, _classnames2.default)({
        'active': this.props.active,
        'disabled': this.props.disable,
        'hidden': this.props.hidden,
        'page-item': true
      });
      return _react2.default.createElement(
        'li',
        { className: classes, title: this.props.title },
        _react2.default.createElement(
          'a',
          { href: '#', onClick: this.pageBtnClick, className: 'page-link' },
          this.props.children
        )
      );
    }
  }]);

  return PageButton;
}(_react.Component);

PageButton.propTypes = {
  title: _react.PropTypes.string,
  changePage: _react.PropTypes.func,
  active: _react.PropTypes.bool,
  disable: _react.PropTypes.bool,
  hidden: _react.PropTypes.bool,
  children: _react.PropTypes.node
};

var _default = PageButton;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PageButton, 'PageButton', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/PageButton.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/PageButton.js');
}();

;

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _PageButton = __webpack_require__(1327);

var _PageButton2 = _interopRequireDefault(_PageButton);

var _SizePerPageDropDown = __webpack_require__(561);

var _SizePerPageDropDown2 = _interopRequireDefault(_SizePerPageDropDown);

var _Const = __webpack_require__(35);

var _Const2 = _interopRequireDefault(_Const);

var _util = __webpack_require__(87);

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaginationList = function (_Component) {
  _inherits(PaginationList, _Component);

  function PaginationList(props) {
    _classCallCheck(this, PaginationList);

    var _this = _possibleConstructorReturn(this, (PaginationList.__proto__ || Object.getPrototypeOf(PaginationList)).call(this, props));

    _this.changePage = function () {
      return _this.__changePage__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.changeSizePerPage = function () {
      return _this.__changeSizePerPage__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.toggleDropDown = function () {
      return _this.__toggleDropDown__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.state = {
      open: _this.props.open
    };
    return _this;
  }

  _createClass(PaginationList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      var keepSizePerPageState = this.props.keepSizePerPageState;

      if (!keepSizePerPageState) {
        this.setState(function () {
          return { open: false };
        });
      }
    }
  }, {
    key: '__changePage__REACT_HOT_LOADER__',
    value: function __changePage__REACT_HOT_LOADER__(page) {
      var _props = this.props,
          pageStartIndex = _props.pageStartIndex,
          prePage = _props.prePage,
          currPage = _props.currPage,
          nextPage = _props.nextPage,
          lastPage = _props.lastPage,
          firstPage = _props.firstPage,
          sizePerPage = _props.sizePerPage,
          keepSizePerPageState = _props.keepSizePerPageState;


      if (page === prePage) {
        page = currPage - 1 < pageStartIndex ? pageStartIndex : currPage - 1;
      } else if (page === nextPage) {
        page = currPage + 1 > this.lastPage ? this.lastPage : currPage + 1;
      } else if (page === lastPage) {
        page = this.lastPage;
      } else if (page === firstPage) {
        page = pageStartIndex;
      } else {
        page = parseInt(page, 10);
      }

      if (keepSizePerPageState) {
        this.setState(function () {
          return { open: false };
        });
      }

      if (page !== currPage) {
        this.props.changePage(page, sizePerPage);
      }
    }
  }, {
    key: '__changeSizePerPage__REACT_HOT_LOADER__',
    value: function __changeSizePerPage__REACT_HOT_LOADER__(pageNum) {
      var selectSize = typeof pageNum === 'string' ? parseInt(pageNum, 10) : pageNum;
      var currPage = this.props.currPage;

      if (selectSize !== this.props.sizePerPage) {
        this.totalPages = Math.ceil(this.props.dataSize / selectSize);
        this.lastPage = this.props.pageStartIndex + this.totalPages - 1;
        if (currPage > this.lastPage) currPage = this.lastPage;
        this.props.changePage(currPage, selectSize);
        if (this.props.onSizePerPageList) {
          this.props.onSizePerPageList(selectSize);
        }
      }
      this.setState(function () {
        return { open: false };
      });
    }
  }, {
    key: '__toggleDropDown__REACT_HOT_LOADER__',
    value: function __toggleDropDown__REACT_HOT_LOADER__() {
      var _this2 = this;

      this.setState(function () {
        return {
          open: !_this2.state.open
        };
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          currPage = _props2.currPage,
          dataSize = _props2.dataSize,
          sizePerPage = _props2.sizePerPage,
          sizePerPageList = _props2.sizePerPageList,
          paginationShowsTotal = _props2.paginationShowsTotal,
          pageStartIndex = _props2.pageStartIndex,
          paginationPanel = _props2.paginationPanel,
          hidePageListOnlyOnePage = _props2.hidePageListOnlyOnePage;

      this.totalPages = Math.ceil(dataSize / sizePerPage);
      this.lastPage = this.props.pageStartIndex + this.totalPages - 1;
      var pageBtns = this.makePage(_util2.default.isFunction(paginationPanel));
      var dropdown = this.makeDropDown();

      var offset = Math.abs(_Const2.default.PAGE_START_INDEX - pageStartIndex);
      var start = (currPage - pageStartIndex) * sizePerPage;
      start = dataSize === 0 ? 0 : start + 1;
      var to = Math.min(sizePerPage * (currPage + offset) - 1, dataSize);
      if (to >= dataSize) to--;
      var total = paginationShowsTotal ? _react2.default.createElement(
        'span',
        null,
        'Showing rows ',
        start,
        ' to\xA0',
        to + 1,
        ' of\xA0',
        dataSize
      ) : null;

      if (_util2.default.isFunction(paginationShowsTotal)) {
        total = paginationShowsTotal(start, to + 1, dataSize);
      }

      var content = paginationPanel && paginationPanel({
        currPage: currPage,
        sizePerPage: sizePerPage,
        sizePerPageList: sizePerPageList,
        pageStartIndex: pageStartIndex,
        changePage: this.changePage,
        toggleDropDown: this.toggleDropDown,
        changeSizePerPage: this.changeSizePerPage,
        components: {
          totalText: total,
          sizePerPageDropdown: dropdown,
          pageList: pageBtns
        }
      });

      var hidePageList = hidePageListOnlyOnePage && this.totalPages === 1 ? 'none' : 'block';
      return _react2.default.createElement(
        'div',
        { className: 'row', style: { marginTop: 15 } },
        content || [_react2.default.createElement(
          'div',
          { key: 'paging-left', className: 'col-md-6 col-xs-6 col-sm-6 col-lg-6' },
          total,
          sizePerPageList.length > 1 ? dropdown : null
        ), _react2.default.createElement(
          'div',
          { key: 'paging-right', style: { display: hidePageList },
            className: 'col-md-6 col-xs-6 col-sm-6 col-lg-6' },
          pageBtns
        )]
      );
    }
  }, {
    key: 'makeDropDown',
    value: function makeDropDown() {
      var _this3 = this;

      var dropdown = void 0;
      var dropdownProps = void 0;
      var sizePerPageText = '';
      var _props3 = this.props,
          sizePerPageDropDown = _props3.sizePerPageDropDown,
          hideSizePerPage = _props3.hideSizePerPage,
          sizePerPage = _props3.sizePerPage,
          sizePerPageList = _props3.sizePerPageList;

      if (sizePerPageDropDown) {
        dropdown = sizePerPageDropDown({
          open: this.state.open,
          hideSizePerPage: hideSizePerPage,
          currSizePerPage: String(sizePerPage),
          sizePerPageList: sizePerPageList,
          toggleDropDown: this.toggleDropDown,
          changeSizePerPage: this.changeSizePerPage
        });
        if (dropdown.type.name === _SizePerPageDropDown2.default.name) {
          dropdownProps = dropdown.props;
        } else {
          return dropdown;
        }
      }

      if (dropdownProps || !dropdown) {
        var sizePerPageOptions = sizePerPageList.map(function (_sizePerPage) {
          var pageText = _sizePerPage.text || _sizePerPage;
          var pageNum = _sizePerPage.value || _sizePerPage;
          if (sizePerPage === pageNum) sizePerPageText = pageText;
          return _react2.default.createElement(
            'li',
            { key: pageText, role: 'presentation' },
            _react2.default.createElement(
              'a',
              { role: 'menuitem',
                tabIndex: '-1', href: '#',
                'data-page': pageNum,
                onClick: function onClick(e) {
                  e.preventDefault();
                  _this3.changeSizePerPage(pageNum);
                } },
              pageText
            )
          );
        });
        dropdown = _react2.default.createElement(_SizePerPageDropDown2.default, _extends({
          open: this.state.open,
          hidden: hideSizePerPage,
          currSizePerPage: String(sizePerPageText),
          options: sizePerPageOptions,
          onClick: this.toggleDropDown
        }, dropdownProps));
      }
      return dropdown;
    }
  }, {
    key: 'makePage',
    value: function makePage() {
      var _this4 = this;

      var isCustomPagingPanel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var pages = this.getPages();
      var isStart = function isStart(page, _ref) {
        var currPage = _ref.currPage,
            pageStartIndex = _ref.pageStartIndex,
            firstPage = _ref.firstPage,
            prePage = _ref.prePage;
        return currPage === pageStartIndex && (page === firstPage || page === prePage);
      };
      var isEnd = function isEnd(page, _ref2) {
        var currPage = _ref2.currPage,
            nextPage = _ref2.nextPage,
            lastPage = _ref2.lastPage;
        return currPage === _this4.lastPage && (page === nextPage || page === lastPage);
      };
      var pageBtns = pages.filter(function (page) {
        if (this.props.alwaysShowAllBtns) {
          return true;
        }
        return isStart(page, this.props) || isEnd(page, this.props) ? false : true;
      }, this).map(function (page) {
        var isActive = page === this.props.currPage;
        var isDisabled = isStart(page, this.props) || isEnd(page, this.props) ? true : false;
        var title = page + '';

        if (page === this.props.nextPage) {
          title = this.props.nextPageTitle;
        } else if (page === this.props.prePage) {
          title = this.props.prePageTitle;
        } else if (page === this.props.firstPage) {
          title = this.props.firstPageTitle;
        } else if (page === this.props.lastPage) {
          title = this.props.lastPageTitle;
        }

        return _react2.default.createElement(
          _PageButton2.default,
          { key: page,
            title: title,
            changePage: this.changePage,
            active: isActive,
            disable: isDisabled },
          page
        );
      }, this);
      var classname = (0, _classnames2.default)(isCustomPagingPanel ? null : 'react-bootstrap-table-page-btns-ul', 'pagination');
      return _react2.default.createElement(
        'ul',
        { className: classname },
        pageBtns
      );
    }
  }, {
    key: 'getLastPage',
    value: function getLastPage() {
      return this.lastPage;
    }
  }, {
    key: 'getPages',
    value: function getPages() {
      var pages = void 0;
      var endPage = this.totalPages;
      if (endPage <= 0) return [];
      var startPage = Math.max(this.props.currPage - Math.floor(this.props.paginationSize / 2), this.props.pageStartIndex);
      endPage = startPage + this.props.paginationSize - 1;

      if (endPage > this.lastPage) {
        endPage = this.lastPage;
        startPage = endPage - this.props.paginationSize + 1;
      }

      if (startPage !== this.props.pageStartIndex && this.totalPages > this.props.paginationSize && this.props.withFirstAndLast) {
        pages = [this.props.firstPage, this.props.prePage];
      } else if (this.totalPages > 1 || this.props.alwaysShowAllBtns) {
        pages = [this.props.prePage];
      } else {
        pages = [];
      }

      for (var i = startPage; i <= endPage; i++) {
        if (i >= this.props.pageStartIndex) pages.push(i);
      }

      if (endPage <= this.lastPage && pages.length > 1) {
        pages.push(this.props.nextPage);
      }
      if (endPage !== this.lastPage && this.props.withFirstAndLast) {
        pages.push(this.props.lastPage);
      }

      return pages;
    }
  }]);

  return PaginationList;
}(_react.Component);

PaginationList.propTypes = {
  currPage: _react.PropTypes.number,
  sizePerPage: _react.PropTypes.number,
  dataSize: _react.PropTypes.number,
  changePage: _react.PropTypes.func,
  sizePerPageList: _react.PropTypes.array,
  paginationShowsTotal: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.func]),
  paginationSize: _react.PropTypes.number,
  onSizePerPageList: _react.PropTypes.func,
  prePage: _react.PropTypes.string,
  pageStartIndex: _react.PropTypes.number,
  hideSizePerPage: _react.PropTypes.bool,
  alwaysShowAllBtns: _react.PropTypes.bool,
  withFirstAndLast: _react.PropTypes.bool,
  sizePerPageDropDown: _react.PropTypes.func,
  paginationPanel: _react.PropTypes.func,
  prePageTitle: _react.PropTypes.string,
  nextPageTitle: _react.PropTypes.string,
  firstPageTitle: _react.PropTypes.string,
  lastPageTitle: _react.PropTypes.string,
  hidePageListOnlyOnePage: _react.PropTypes.bool,
  keepSizePerPageState: _react.PropTypes.bool
};

PaginationList.defaultProps = {
  sizePerPage: _Const2.default.SIZE_PER_PAGE,
  pageStartIndex: _Const2.default.PAGE_START_INDEX
};

var _default = PaginationList;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(PaginationList, 'PaginationList', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/PaginationList.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/pagination/PaginationList.js');
}();

;

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableDataStore = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint no-nested-ternary: 0 */
/* eslint guard-for-in: 0 */
/* eslint no-console: 0 */
/* eslint eqeqeq: 0 */
/* eslint one-var: 0 */


var _Const = __webpack_require__(35);

var _Const2 = _interopRequireDefault(_Const);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TableDataStore = function () {
  function TableDataStore(data) {
    var _this = this;

    _classCallCheck(this, TableDataStore);

    this.isValidKey = function () {
      return _this.__isValidKey__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    this.data = data;
    this.filteredData = null;
    this.isOnFilter = false;
    this.filterObj = null;
    this.searchText = null;
    this.sortList = [];
    this.pageObj = {};
    this.selected = [];
    this.showOnlySelected = false;
  }

  _createClass(TableDataStore, [{
    key: 'setProps',
    value: function setProps(props) {
      this.keyField = props.keyField;
      this.enablePagination = props.isPagination;
      this.colInfos = props.colInfos;
      this.remote = props.remote;
      this.multiColumnSearch = props.multiColumnSearch;
      // default behaviour if strictSearch prop is not provided: !multiColumnSearch
      this.strictSearch = typeof props.strictSearch === 'undefined' ? !props.multiColumnSearch : props.strictSearch;
      this.multiColumnSort = props.multiColumnSort;
    }
  }, {
    key: 'clean',
    value: function clean() {
      this.filteredData = null;
      this.isOnFilter = false;
      this.filterObj = null;
      this.searchText = null;
      this.sortList = [];
      this.pageObj = {};
      this.selected = [];
    }
  }, {
    key: 'isSearching',
    value: function isSearching() {
      return this.searchText !== null;
    }
  }, {
    key: 'isFiltering',
    value: function isFiltering() {
      return this.filterObj !== null;
    }
  }, {
    key: 'setData',
    value: function setData(data) {
      this.data = data;
      if (this.remote) {
        return;
      }

      this._refresh(true);
    }
  }, {
    key: 'getColInfos',
    value: function getColInfos() {
      return this.colInfos;
    }
  }, {
    key: 'getSortInfo',
    value: function getSortInfo() {
      return this.sortList;
    }
  }, {
    key: 'setSortInfo',
    value: function setSortInfo(order, sortField) {
      if ((typeof order === 'undefined' ? 'undefined' : _typeof(order)) !== (typeof sortField === 'undefined' ? 'undefined' : _typeof(sortField))) {
        throw new Error('The type of sort field and order should be both with String or Array');
      }
      if (Array.isArray(order) && Array.isArray(sortField)) {
        if (order.length !== sortField.length) {
          throw new Error('The length of sort fields and orders should be equivalent');
        }
        order = order.slice().reverse();
        this.sortList = sortField.slice().reverse().map(function (field, i) {
          return {
            order: order[i],
            sortField: field
          };
        });
        this.sortList = this.sortList.slice(0, this.multiColumnSort);
      } else {
        var sortObj = {
          order: order,
          sortField: sortField
        };

        if (this.multiColumnSort > 1) {
          var i = this.sortList.length - 1;
          var sortFieldInHistory = false;

          for (; i >= 0; i--) {
            if (this.sortList[i].sortField === sortField) {
              sortFieldInHistory = true;
              break;
            }
          }

          if (sortFieldInHistory) {
            if (i > 0) {
              this.sortList = this.sortList.slice(0, i);
            } else {
              this.sortList = this.sortList.slice(1);
            }
          }

          this.sortList.unshift(sortObj);
          this.sortList = this.sortList.slice(0, this.multiColumnSort);
        } else {
          this.sortList = [sortObj];
        }
      }
    }
  }, {
    key: 'cleanSortInfo',
    value: function cleanSortInfo() {
      this.sortList = [];
    }
  }, {
    key: 'setSelectedRowKey',
    value: function setSelectedRowKey(selectedRowKeys) {
      this.selected = selectedRowKeys;
    }
  }, {
    key: 'getRowByKey',
    value: function getRowByKey(keys) {
      var _this2 = this;

      // Bad Performance #1164
      // return keys.map(key => {
      //   const result = this.data.filter(d => d[this.keyField] === key);
      //   if (result.length !== 0) return result[0];
      // });
      var result = [];
      if (!keys || keys.length === 0) {
        return result;
      }

      var _loop = function _loop(i) {
        var d = _this2.data[i];
        if (keys.indexOf(d[_this2.keyField]) > -1) {
          keys = keys.filter(function (k) {
            return k !== d[_this2.keyField];
          });
          result.push(d);
        }
      };

      for (var i = 0; i < this.data.length; i++) {
        _loop(i);
      }
      return result;
    }
  }, {
    key: 'getSelectedRowKeys',
    value: function getSelectedRowKeys() {
      return this.selected;
    }
  }, {
    key: 'getCurrentDisplayData',
    value: function getCurrentDisplayData() {
      if (this.isOnFilter) return this.filteredData;else return this.data;
    }
  }, {
    key: '_refresh',
    value: function _refresh(skipSorting) {
      if (this.isOnFilter) {
        if (this.filterObj !== null) this.filter(this.filterObj);
        if (this.searchText !== null) this.search(this.searchText);
      }
      if (!skipSorting && this.sortList.length > 0) {
        this.sort();
      }
    }
  }, {
    key: 'ignoreNonSelected',
    value: function ignoreNonSelected() {
      var _this3 = this;

      this.showOnlySelected = !this.showOnlySelected;
      if (this.showOnlySelected) {
        this.isOnFilter = true;
        this.filteredData = this.data.filter(function (row) {
          var result = _this3.selected.find(function (x) {
            return row[_this3.keyField] === x;
          });
          return typeof result !== 'undefined' ? true : false;
        });
      } else {
        this.isOnFilter = false;
      }
    }
  }, {
    key: 'sort',
    value: function sort() {
      var currentDisplayData = this.getCurrentDisplayData();

      currentDisplayData = this._sort(currentDisplayData);

      return this;
    }
  }, {
    key: 'page',
    value: function page(_page, sizePerPage) {
      this.pageObj.end = _page * sizePerPage - 1;
      this.pageObj.start = this.pageObj.end - (sizePerPage - 1);
      return this;
    }
  }, {
    key: 'edit',
    value: function edit(newVal, rowIndex, fieldName) {
      var currentDisplayData = this.getCurrentDisplayData();
      var rowKeyCache = void 0;
      if (!this.enablePagination) {
        currentDisplayData[rowIndex][fieldName] = newVal;
        rowKeyCache = currentDisplayData[rowIndex][this.keyField];
      } else {
        currentDisplayData[this.pageObj.start + rowIndex][fieldName] = newVal;
        rowKeyCache = currentDisplayData[this.pageObj.start + rowIndex][this.keyField];
      }
      if (this.isOnFilter) {
        this.data.forEach(function (row) {
          if (row[this.keyField] === rowKeyCache) {
            row[fieldName] = newVal;
          }
        }, this);
        if (this.filterObj !== null) this.filter(this.filterObj);
        if (this.searchText !== null) this.search(this.searchText);
      }
      return this;
    }
  }, {
    key: 'addAtBegin',
    value: function addAtBegin(newObj) {
      if (!newObj[this.keyField] || newObj[this.keyField].toString() === '') {
        throw new Error(this.keyField + ' can\'t be empty value.');
      }
      var currentDisplayData = this.getCurrentDisplayData();
      currentDisplayData.forEach(function (row) {
        if (row[this.keyField].toString() === newObj[this.keyField].toString()) {
          throw new Error(this.keyField + ' ' + newObj[this.keyField] + ' already exists');
        }
      }, this);
      currentDisplayData.unshift(newObj);
      if (this.isOnFilter) {
        this.data.unshift(newObj);
      }
      this._refresh(false);
    }
  }, {
    key: 'add',
    value: function add(newObj) {
      var e = this.isValidKey(newObj[this.keyField]);
      if (e) throw new Error(e);

      var currentDisplayData = this.getCurrentDisplayData();
      currentDisplayData.push(newObj);
      if (this.isOnFilter) {
        this.data.push(newObj);
      }
      this._refresh(false);
    }
  }, {
    key: '__isValidKey__REACT_HOT_LOADER__',
    value: function __isValidKey__REACT_HOT_LOADER__(key) {
      var _this4 = this;

      if (key === null || key === undefined || key.toString() === '') {
        return this.keyField + ' can\'t be empty value.';
      }
      var currentDisplayData = this.getCurrentDisplayData();
      var exist = currentDisplayData.find(function (row) {
        return row[_this4.keyField].toString() === key.toString();
      });
      if (exist) return this.keyField + ' ' + key + ' already exists';
    }
  }, {
    key: 'remove',
    value: function remove(rowKey) {
      var _this5 = this;

      var currentDisplayData = this.getCurrentDisplayData();
      var result = currentDisplayData.filter(function (row) {
        return rowKey.indexOf(row[_this5.keyField]) === -1;
      });

      if (this.isOnFilter) {
        this.data = this.data.filter(function (row) {
          return rowKey.indexOf(row[_this5.keyField]) === -1;
        });
        this.filteredData = result;
      } else {
        this.data = result;
      }
    }
  }, {
    key: 'filter',
    value: function filter(filterObj) {
      if (Object.keys(filterObj).length === 0) {
        this.filteredData = null;
        this.isOnFilter = false;
        this.filterObj = null;
        if (this.searchText) this._search(this.data);
      } else {
        var source = this.data;
        this.filterObj = filterObj;
        if (this.searchText) {
          this._search(source);
          source = this.filteredData;
        }
        this._filter(source);
      }
    }
  }, {
    key: 'filterNumber',
    value: function filterNumber(targetVal, filterVal, comparator) {
      var valid = true;
      switch (comparator) {
        case '=':
          {
            if (targetVal != filterVal) {
              valid = false;
            }
            break;
          }
        case '>':
          {
            if (targetVal <= filterVal) {
              valid = false;
            }
            break;
          }
        case '>=':
          {
            if (targetVal < filterVal) {
              valid = false;
            }
            break;
          }
        case '<':
          {
            if (targetVal >= filterVal) {
              valid = false;
            }
            break;
          }
        case '<=':
          {
            if (targetVal > filterVal) {
              valid = false;
            }
            break;
          }
        case '!=':
          {
            if (targetVal == filterVal) {
              valid = false;
            }
            break;
          }
        default:
          {
            console.error('Number comparator provided is not supported');
            break;
          }
      }
      return valid;
    }
  }, {
    key: 'filterDate',
    value: function filterDate(targetVal, filterVal, comparator) {
      if (!targetVal) return false;

      var filterDate = filterVal.getDate();
      var filterMonth = filterVal.getMonth();
      var filterYear = filterVal.getFullYear();

      if ((typeof targetVal === 'undefined' ? 'undefined' : _typeof(targetVal)) !== 'object') {
        targetVal = new Date(targetVal);
      }

      var targetDate = targetVal.getDate();
      var targetMonth = targetVal.getMonth();
      var targetYear = targetVal.getFullYear();

      var valid = true;
      switch (comparator) {
        case '=':
          {
            if (filterDate !== targetDate || filterMonth !== targetMonth || filterYear !== targetYear) {
              valid = false;
            }
            break;
          }
        case '>':
          {
            if (targetVal <= filterVal) {
              valid = false;
            }
            break;
          }
        case '>=':
          {
            if (targetYear < filterYear) {
              valid = false;
            } else if (targetYear === filterYear && targetMonth < filterMonth) {
              valid = false;
            } else if (targetYear === filterYear && targetMonth === filterMonth && targetDate < filterDate) {
              valid = false;
            }
            break;
          }
        case '<':
          {
            if (targetVal >= filterVal) {
              valid = false;
            }
            break;
          }
        case '<=':
          {
            if (targetYear > filterYear) {
              valid = false;
            } else if (targetYear === filterYear && targetMonth > filterMonth) {
              valid = false;
            } else if (targetYear === filterYear && targetMonth === filterMonth && targetDate > filterDate) {
              valid = false;
            }
            break;
          }
        case '!=':
          {
            if (filterDate === targetDate && filterMonth === targetMonth && filterYear === targetYear) {
              valid = false;
            }
            break;
          }
        default:
          {
            console.error('Date comparator provided is not supported');
            break;
          }
      }
      return valid;
    }
  }, {
    key: 'filterRegex',
    value: function filterRegex(targetVal, filterVal) {
      try {
        return new RegExp(filterVal, 'i').test(targetVal);
      } catch (e) {
        return true;
      }
    }
  }, {
    key: 'filterCustom',
    value: function filterCustom(targetVal, filterVal, callbackInfo, cond) {
      if (callbackInfo !== null && (typeof callbackInfo === 'undefined' ? 'undefined' : _typeof(callbackInfo)) === 'object') {
        return callbackInfo.callback(targetVal, callbackInfo.callbackParameters);
      }

      return this.filterText(targetVal, filterVal, cond);
    }
  }, {
    key: 'filterText',
    value: function filterText(targetVal, filterVal) {
      var cond = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _Const2.default.FILTER_COND_LIKE;

      targetVal = targetVal.toString();
      filterVal = filterVal.toString();
      if (cond === _Const2.default.FILTER_COND_EQ) {
        return targetVal === filterVal;
      } else {
        targetVal = targetVal.toLowerCase();
        filterVal = filterVal.toLowerCase();
        return !(targetVal.indexOf(filterVal) === -1);
      }
    }

    /* General search function
     * It will search for the text if the input includes that text;
     */

  }, {
    key: 'search',
    value: function search(searchText) {
      if (searchText.trim() === '') {
        this.filteredData = null;
        this.isOnFilter = false;
        this.searchText = null;
        if (this.filterObj) this._filter(this.data);
      } else {
        var source = this.data;
        this.searchText = searchText;
        if (this.filterObj) {
          this._filter(source);
          source = this.filteredData;
        }
        this._search(source);
      }
    }
  }, {
    key: '_filter',
    value: function _filter(source) {
      var _this6 = this;

      var filterObj = this.filterObj;
      this.filteredData = source.filter(function (row, r) {
        var valid = true;
        var filterVal = void 0;
        for (var key in filterObj) {
          var targetVal = row[key];
          if (targetVal === null || targetVal === undefined) {
            targetVal = '';
          }

          switch (filterObj[key].type) {
            case _Const2.default.FILTER_TYPE.NUMBER:
              {
                filterVal = filterObj[key].value.number;
                break;
              }
            case _Const2.default.FILTER_TYPE.CUSTOM:
              {
                filterVal = _typeof(filterObj[key].value) === 'object' ? undefined : typeof filterObj[key].value === 'string' ? filterObj[key].value.toLowerCase() : filterObj[key].value;
                break;
              }
            case _Const2.default.FILTER_TYPE.DATE:
              {
                filterVal = filterObj[key].value.date;
                break;
              }
            case _Const2.default.FILTER_TYPE.REGEX:
              {
                filterVal = filterObj[key].value;
                break;
              }
            default:
              {
                filterVal = filterObj[key].value;
                if (filterVal === undefined) {
                  // Support old filter
                  filterVal = filterObj[key];
                }
                break;
              }
          }
          var format = void 0,
              filterFormatted = void 0,
              formatExtraData = void 0,
              filterValue = void 0;
          if (_this6.colInfos[key]) {
            format = _this6.colInfos[key].format;
            filterFormatted = _this6.colInfos[key].filterFormatted;
            formatExtraData = _this6.colInfos[key].formatExtraData;
            filterValue = _this6.colInfos[key].filterValue;
            if (filterFormatted && format) {
              targetVal = format(row[key], row, formatExtraData, r);
            } else if (filterValue) {
              targetVal = filterValue(row[key], row);
            }
          }

          switch (filterObj[key].type) {
            case _Const2.default.FILTER_TYPE.NUMBER:
              {
                valid = _this6.filterNumber(targetVal, filterVal, filterObj[key].value.comparator);
                break;
              }
            case _Const2.default.FILTER_TYPE.DATE:
              {
                valid = _this6.filterDate(targetVal, filterVal, filterObj[key].value.comparator);
                break;
              }
            case _Const2.default.FILTER_TYPE.REGEX:
              {
                valid = _this6.filterRegex(targetVal, filterVal);
                break;
              }
            case _Const2.default.FILTER_TYPE.CUSTOM:
              {
                var cond = filterObj[key].props ? filterObj[key].props.cond : _Const2.default.FILTER_COND_LIKE;
                valid = _this6.filterCustom(targetVal, filterVal, filterObj[key].value, cond);
                break;
              }
            default:
              {
                if (filterObj[key].type === _Const2.default.FILTER_TYPE.SELECT && filterFormatted && filterFormatted && format) {
                  filterVal = format(filterVal, row, formatExtraData, r);
                }
                var _cond = filterObj[key].props ? filterObj[key].props.cond : _Const2.default.FILTER_COND_LIKE;
                valid = _this6.filterText(targetVal, filterVal, _cond);
                break;
              }
          }
          if (!valid) {
            break;
          }
        }
        return valid;
      });
      this.isOnFilter = true;
    }

    /*
     * Four different sort modes, all case insensitive:
     * (1) strictSearch && !multiColumnSearch
     *     search text must be contained as provided in a single column
     * (2) strictSearch && multiColumnSearch
     *     conjunction (AND combination) of whitespace separated terms over multiple columns
     * (3) !strictSearch && !multiColumnSearch
     *     conjunction (AND combination) of whitespace separated terms in a single column
     * (4) !strictSearch && multiColumnSearch
     *     any of the whitespace separated terms must be contained in any column
     */

  }, {
    key: '_search',
    value: function _search(source) {
      var _this7 = this;

      var searchTextArray = void 0;
      if (this.multiColumnSearch || !this.strictSearch) {
        // ignore leading and trailing whitespaces
        searchTextArray = this.searchText.trim().toLowerCase().split(/\s+/);
      } else {
        searchTextArray = [this.searchText.toLowerCase()];
      }
      var searchTermCount = searchTextArray.length;
      var multipleTerms = searchTermCount > 1;
      var nonStrictMultiCol = multipleTerms && !this.strictSearch && this.multiColumnSearch;
      var nonStrictSingleCol = multipleTerms && !this.strictSearch && !this.multiColumnSearch;
      this.filteredData = source.filter(function (row, r) {
        var keys = Object.keys(row);
        // only clone array if necessary
        var searchTerms = multipleTerms ? searchTextArray.slice() : searchTextArray;
        // for loops are ugly, but performance matters here.
        // And you cant break from a forEach.
        // http://jsperf.com/for-vs-foreach/66
        for (var i = 0, keysLength = keys.length; i < keysLength; i++) {
          var key = keys[i];
          var colInfo = _this7.colInfos[key];
          if (colInfo && colInfo.searchable) {
            var format = colInfo.format,
                filterFormatted = colInfo.filterFormatted,
                filterValue = colInfo.filterValue,
                formatExtraData = colInfo.formatExtraData;

            var targetVal = void 0;
            if (filterFormatted && format) {
              targetVal = format(row[key], row, formatExtraData, r);
            } else if (filterValue) {
              targetVal = filterValue(row[key], row);
            } else {
              targetVal = row[key];
            }
            if (targetVal !== null && typeof targetVal !== 'undefined') {
              targetVal = targetVal.toString().toLowerCase();
              if (nonStrictSingleCol && searchTermCount > searchTerms.length) {
                // reset search terms for single column search
                searchTerms = searchTextArray.slice();
              }
              for (var j = searchTerms.length - 1; j > -1; j--) {
                if (targetVal.indexOf(searchTerms[j]) !== -1) {
                  if (nonStrictMultiCol || searchTerms.length === 1) {
                    // match found: the last or only one
                    return true;
                  }
                  // match found: but there are more search terms to check for
                  searchTerms.splice(j, 1);
                } else if (!_this7.multiColumnSearch) {
                  // one of the search terms was not found in this column
                  break;
                }
              }
            }
          }
        }
        return false;
      });
      this.isOnFilter = true;
    }
  }, {
    key: '_sort',
    value: function _sort(arr) {
      var _this8 = this;

      if (this.sortList.length === 0 || typeof this.sortList[0] === 'undefined') {
        return arr;
      }

      arr.sort(function (a, b) {
        var result = 0;

        for (var i = 0; i < _this8.sortList.length; i++) {
          var sortDetails = _this8.sortList[i];
          var isDesc = sortDetails.order.toLowerCase() === _Const2.default.SORT_DESC;

          var _colInfos$sortDetails = _this8.colInfos[sortDetails.sortField],
              sortFunc = _colInfos$sortDetails.sortFunc,
              sortFuncExtraData = _colInfos$sortDetails.sortFuncExtraData;


          if (sortFunc) {
            result = sortFunc(a, b, sortDetails.order, sortDetails.sortField, sortFuncExtraData);
          } else {
            var valueA = a[sortDetails.sortField] === null ? '' : a[sortDetails.sortField];
            var valueB = b[sortDetails.sortField] === null ? '' : b[sortDetails.sortField];
            if (isDesc) {
              if (typeof valueB === 'string') {
                result = valueB.localeCompare(valueA);
              } else {
                result = valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
              }
            } else {
              if (typeof valueA === 'string') {
                result = valueA.localeCompare(valueB);
              } else {
                result = valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
              }
            }
          }

          if (result !== 0) {
            return result;
          }
        }

        return result;
      });

      return arr;
    }
  }, {
    key: 'getDataIgnoringPagination',
    value: function getDataIgnoringPagination() {
      return this.getCurrentDisplayData();
    }
  }, {
    key: 'get',
    value: function get() {
      var _data = this.getCurrentDisplayData();

      if (_data.length === 0) return _data;

      var remote = typeof this.remote === 'function' ? this.remote(_Const2.default.REMOTE)[_Const2.default.REMOTE_PAGE] : this.remote;

      if (remote || !this.enablePagination) {
        return _data;
      } else {
        var result = [];
        for (var i = this.pageObj.start; i <= this.pageObj.end; i++) {
          result.push(_data[i]);
          if (i + 1 === _data.length) break;
        }
        return result;
      }
    }
  }, {
    key: 'getKeyField',
    value: function getKeyField() {
      return this.keyField;
    }
  }, {
    key: 'getDataNum',
    value: function getDataNum() {
      return this.getCurrentDisplayData().length;
    }
  }, {
    key: 'isChangedPage',
    value: function isChangedPage() {
      return this.pageObj.start && this.pageObj.end ? true : false;
    }
  }, {
    key: 'isEmpty',
    value: function isEmpty() {
      return this.data.length === 0 || this.data === null || this.data === undefined;
    }
  }, {
    key: 'getAllRowkey',
    value: function getAllRowkey() {
      var _this9 = this;

      return this.data.map(function (row) {
        return row[_this9.keyField];
      });
    }
  }]);

  return TableDataStore;
}();

exports.TableDataStore = TableDataStore;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(TableDataStore, 'TableDataStore', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/store/TableDataStore.js');
}();

;

/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonGroup = function (_Component) {
  _inherits(ButtonGroup, _Component);

  function ButtonGroup() {
    _classCallCheck(this, ButtonGroup);

    return _possibleConstructorReturn(this, (ButtonGroup.__proto__ || Object.getPrototypeOf(ButtonGroup)).apply(this, arguments));
  }

  _createClass(ButtonGroup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          sizeClass = _props.sizeClass,
          children = _props.children,
          rest = _objectWithoutProperties(_props, ['className', 'sizeClass', 'children']);

      return _react2.default.createElement(
        'div',
        _extends({ className: 'btn-group ' + sizeClass + ' ' + className, role: 'group' }, rest),
        children
      );
    }
  }]);

  return ButtonGroup;
}(_react.Component);

ButtonGroup.propTypes = {
  sizeClass: _react.PropTypes.string,
  className: _react.PropTypes.string
};
ButtonGroup.defaultProps = {
  sizeClass: 'btn-group-sm',
  className: ''
};

var _default = ButtonGroup;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ButtonGroup, 'ButtonGroup', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ButtonGroup.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ButtonGroup.js');
}();

;

/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _InsertModalHeader = __webpack_require__(568);

var _InsertModalHeader2 = _interopRequireDefault(_InsertModalHeader);

var _InsertModalFooter = __webpack_require__(567);

var _InsertModalFooter2 = _interopRequireDefault(_InsertModalFooter);

var _InsertModalBody = __webpack_require__(566);

var _InsertModalBody2 = _interopRequireDefault(_InsertModalBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-console: 0 */

var defaultModalClassName = 'react-bs-table-insert-modal';

var InsertModal = function (_Component) {
  _inherits(InsertModal, _Component);

  function InsertModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InsertModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InsertModal.__proto__ || Object.getPrototypeOf(InsertModal)).call.apply(_ref, [this].concat(args))), _this), _this.handleSave = function () {
      var _this2;

      return (_this2 = _this).__handleSave__REACT_HOT_LOADER__.apply(_this2, arguments);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InsertModal, [{
    key: '__handleSave__REACT_HOT_LOADER__',
    value: function __handleSave__REACT_HOT_LOADER__() {
      var bodyRefs = this.refs.body;
      if (bodyRefs.getFieldValue) {
        this.props.onSave(bodyRefs.getFieldValue());
      } else {
        console.error('Custom InsertModalBody should implement getFieldValue function\n        and should return an object presented as the new row that user input.');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          headerComponent = _props.headerComponent,
          footerComponent = _props.footerComponent,
          bodyComponent = _props.bodyComponent;
      var _props2 = this.props,
          columns = _props2.columns,
          validateState = _props2.validateState,
          ignoreEditable = _props2.ignoreEditable,
          onModalClose = _props2.onModalClose;

      var bodyAttr = { columns: columns, validateState: validateState, ignoreEditable: ignoreEditable };

      bodyComponent = bodyComponent && bodyComponent(columns, validateState, ignoreEditable);

      headerComponent = headerComponent && headerComponent(onModalClose, this.handleSave);

      footerComponent = footerComponent && footerComponent(onModalClose, this.handleSave);

      if (bodyComponent) {
        bodyComponent = _react2.default.cloneElement(bodyComponent, { ref: 'body' });
      }

      if (headerComponent && headerComponent.type.name === _InsertModalHeader2.default.name) {
        var eventProps = {};
        if (!headerComponent.props.onModalClose) eventProps.onModalClose = onModalClose;
        if (!headerComponent.props.onSave) eventProps.onSave = this.handleSave;
        if (Object.keys(eventProps).length > 0) {
          headerComponent = _react2.default.cloneElement(headerComponent, eventProps);
        }
      } else if (headerComponent && headerComponent.type.name !== _InsertModalHeader2.default.name) {
        var className = headerComponent.props.className;

        if (typeof className === 'undefined' || className.indexOf('modal-header') === -1) {
          headerComponent = _react2.default.createElement(
            'div',
            { className: 'modal-header' },
            headerComponent
          );
        }
      }

      if (footerComponent && footerComponent.type.name === _InsertModalFooter2.default.name) {
        var _eventProps = {};
        if (!footerComponent.props.onModalClose) _eventProps.onModalClose = onModalClose;
        if (!footerComponent.props.onSave) _eventProps.onSave = this.handleSave;
        if (Object.keys(_eventProps).length > 0) {
          footerComponent = _react2.default.cloneElement(footerComponent, _eventProps);
        }
      } else if (footerComponent && footerComponent.type.name !== _InsertModalFooter2.default.name) {
        var _className = footerComponent.props.className;

        if (typeof _className === 'undefined' || _className.indexOf('modal-footer') === -1) {
          footerComponent = _react2.default.createElement(
            'div',
            { className: 'modal-footer' },
            footerComponent
          );
        }
      }

      return _react2.default.createElement(
        'div',
        { className: 'modal-content ' + defaultModalClassName },
        headerComponent || _react2.default.createElement(_InsertModalHeader2.default, {
          className: 'react-bs-table-inser-modal-header',
          onModalClose: onModalClose }),
        bodyComponent || _react2.default.createElement(_InsertModalBody2.default, _extends({ ref: 'body' }, bodyAttr)),
        footerComponent || _react2.default.createElement(_InsertModalFooter2.default, {
          className: 'react-bs-table-inser-modal-footer',
          onModalClose: onModalClose,
          onSave: this.handleSave })
      );
    }
  }]);

  return InsertModal;
}(_react.Component);

var _default = InsertModal;
exports.default = _default;

InsertModal.propTypes = {
  columns: _react.PropTypes.array.isRequired,
  validateState: _react.PropTypes.object.isRequired,
  ignoreEditable: _react.PropTypes.bool,
  headerComponent: _react.PropTypes.func,
  bodyComponent: _react.PropTypes.func,
  footerComponent: _react.PropTypes.func,
  onModalClose: _react.PropTypes.func,
  onSave: _react.PropTypes.func
};

InsertModal.defaultProps = {};
;

var _temp2 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(defaultModalClassName, 'defaultModalClassName', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModal.js');

  __REACT_HOT_LOADER__.register(InsertModal, 'InsertModal', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModal.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/InsertModal.js');
}();

;

/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactModal = __webpack_require__(1481);

var _reactModal2 = _interopRequireDefault(_reactModal);

var _Const = __webpack_require__(35);

var _Const2 = _interopRequireDefault(_Const);

var _Notification = __webpack_require__(559);

var _Notification2 = _interopRequireDefault(_Notification);

var _InsertModal = __webpack_require__(1331);

var _InsertModal2 = _interopRequireDefault(_InsertModal);

var _InsertButton = __webpack_require__(565);

var _InsertButton2 = _interopRequireDefault(_InsertButton);

var _DeleteButton = __webpack_require__(563);

var _DeleteButton2 = _interopRequireDefault(_DeleteButton);

var _ExportCSVButton = __webpack_require__(564);

var _ExportCSVButton2 = _interopRequireDefault(_ExportCSVButton);

var _ShowSelectedOnlyButton = __webpack_require__(570);

var _ShowSelectedOnlyButton2 = _interopRequireDefault(_ShowSelectedOnlyButton);

var _SearchField = __webpack_require__(569);

var _SearchField2 = _interopRequireDefault(_SearchField);

var _ClearSearchButton = __webpack_require__(562);

var _ClearSearchButton2 = _interopRequireDefault(_ClearSearchButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-console: 0 */

// import classSet from 'classnames';

// import editor from '../Editor';


var ToolBar = function (_Component) {
  _inherits(ToolBar, _Component);

  function ToolBar(props) {
    var _arguments = arguments;

    _classCallCheck(this, ToolBar);

    var _this = _possibleConstructorReturn(this, (ToolBar.__proto__ || Object.getPrototypeOf(ToolBar)).call(this, props));

    _this.displayCommonMessage = function () {
      return _this.__displayCommonMessage__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleSaveBtnClick = function () {
      return _this.__handleSaveBtnClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.afterHandleSaveBtnClick = function () {
      return _this.__afterHandleSaveBtnClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleModalClose = function () {
      return _this.__handleModalClose__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleModalOpen = function () {
      return _this.__handleModalOpen__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleShowOnlyToggle = function () {
      return _this.__handleShowOnlyToggle__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleDropRowBtnClick = function () {
      return _this.__handleDropRowBtnClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleDebounce = function (func, wait, immediate) {
      var timeout = void 0;

      return function () {
        var later = function later() {
          timeout = null;

          if (!immediate) {
            func.apply(_this, _arguments);
          }
        };

        var callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, wait || 0);

        if (callNow) {
          func.appy(_this, _arguments);
        }
      };
    };

    _this.handleKeyUp = function () {
      return _this.__handleKeyUp__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleExportCSV = function () {
      return _this.__handleExportCSV__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.handleClearBtnClick = function () {
      return _this.__handleClearBtnClick__REACT_HOT_LOADER__.apply(_this, arguments);
    };

    _this.timeouteClear = 0;
    _this.modalClassName;
    _this.state = {
      isInsertModalOpen: false,
      validateState: null,
      shakeEditor: false,
      showSelected: false
    };
    return _this;
  }

  _createClass(ToolBar, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var delay = this.props.searchDelayTime ? this.props.searchDelayTime : 0;
      this.debounceCallback = this.handleDebounce(function () {
        var seachInput = _this2.refs.seachInput;

        seachInput && _this2.props.onSearch(seachInput.getValue());
      }, delay);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.reset) {
        this.setSearchInput('');
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearTimeout();
    }
  }, {
    key: 'setSearchInput',
    value: function setSearchInput(text) {
      var seachInput = this.refs.seachInput;

      if (seachInput && seachInput.value !== text) {
        seachInput.value = text;
      }
    }
  }, {
    key: 'clearTimeout',
    value: function (_clearTimeout) {
      function clearTimeout() {
        return _clearTimeout.apply(this, arguments);
      }

      clearTimeout.toString = function () {
        return _clearTimeout.toString();
      };

      return clearTimeout;
    }(function () {
      if (this.timeouteClear) {
        clearTimeout(this.timeouteClear);
        this.timeouteClear = 0;
      }
    })
  }, {
    key: '__displayCommonMessage__REACT_HOT_LOADER__',
    value: function __displayCommonMessage__REACT_HOT_LOADER__() {
      this.refs.notifier.notice('error', 'Form validate errors, please checking!', 'Pressed ESC can cancel');
    }
  }, {
    key: 'validateNewRow',
    value: function validateNewRow(newRow) {
      var _this3 = this;

      var validateState = {};
      var isValid = true;
      var tempMsg = void 0;
      var responseType = void 0;

      this.props.columns.forEach(function (column) {
        if (column.isKey && column.keyValidator) {
          // key validator for checking exist key
          tempMsg = _this3.props.isValidKey(newRow[column.field]);
          if (tempMsg) {
            _this3.displayCommonMessage();
            isValid = false;
            validateState[column.field] = tempMsg;
          }
        } else if (column.editable && column.editable.validator) {
          // process validate
          tempMsg = column.editable.validator(newRow[column.field], newRow);
          responseType = typeof tempMsg === 'undefined' ? 'undefined' : _typeof(tempMsg);
          if (responseType !== 'object' && tempMsg !== true) {
            _this3.displayCommonMessage();
            isValid = false;
            validateState[column.field] = tempMsg;
          } else if (responseType === 'object' && tempMsg.isValid !== true) {
            _this3.refs.notifier.notice(tempMsg.notification.type, tempMsg.notification.msg, tempMsg.notification.title);
            isValid = false;
            validateState[column.field] = tempMsg.notification.msg;
          }
        }
      });

      if (isValid) {
        return true;
      } else {
        this.clearTimeout();
        // show error in form and shake it
        this.setState(function () {
          return { validateState: validateState, shakeEditor: true };
        });
        this.timeouteClear = setTimeout(function () {
          _this3.setState(function () {
            return { shakeEditor: false };
          });
        }, 300);
        return null;
      }
    }
  }, {
    key: '__handleSaveBtnClick__REACT_HOT_LOADER__',
    value: function __handleSaveBtnClick__REACT_HOT_LOADER__(newRow) {
      if (!this.validateNewRow(newRow)) {
        // validation fail
        return;
      }
      var msg = this.props.onAddRow(newRow);
      if (msg !== false) {
        this.afterHandleSaveBtnClick(msg);
      }
    }
  }, {
    key: '__afterHandleSaveBtnClick__REACT_HOT_LOADER__',
    value: function __afterHandleSaveBtnClick__REACT_HOT_LOADER__(msg) {
      var _this4 = this;

      if (msg) {
        this.refs.notifier.notice('error', msg, 'Pressed ESC can cancel');
        this.clearTimeout();
        // shake form and hack prevent modal hide
        this.setState(function () {
          return {
            shakeEditor: true,
            validateState: 'this is hack for prevent bootstrap modal hide'
          };
        });
        // clear animate class
        this.timeouteClear = setTimeout(function () {
          _this4.setState(function () {
            return { shakeEditor: false };
          });
        }, 300);
      } else {
        // reset state and hide modal hide
        this.setState(function () {
          return {
            validateState: null,
            shakeEditor: false,
            isInsertModalOpen: false
          };
        });
      }
    }
  }, {
    key: '__handleModalClose__REACT_HOT_LOADER__',
    value: function __handleModalClose__REACT_HOT_LOADER__() {
      this.setState(function () {
        return { isInsertModalOpen: false };
      });
    }
  }, {
    key: '__handleModalOpen__REACT_HOT_LOADER__',
    value: function __handleModalOpen__REACT_HOT_LOADER__() {
      this.setState(function () {
        return { isInsertModalOpen: true };
      });
    }
  }, {
    key: '__handleShowOnlyToggle__REACT_HOT_LOADER__',
    value: function __handleShowOnlyToggle__REACT_HOT_LOADER__() {
      var _this5 = this;

      this.setState(function () {
        return {
          showSelected: !_this5.state.showSelected
        };
      });
      this.props.onShowOnlySelected();
    }
  }, {
    key: '__handleDropRowBtnClick__REACT_HOT_LOADER__',
    value: function __handleDropRowBtnClick__REACT_HOT_LOADER__() {
      this.props.onDropRow();
    }
  }, {
    key: 'handleCloseBtn',
    value: function handleCloseBtn() {
      this.refs.warning.style.display = 'none';
    }
  }, {
    key: '__handleKeyUp__REACT_HOT_LOADER__',
    value: function __handleKeyUp__REACT_HOT_LOADER__(event) {
      event.persist();
      this.debounceCallback(event);
    }
  }, {
    key: '__handleExportCSV__REACT_HOT_LOADER__',
    value: function __handleExportCSV__REACT_HOT_LOADER__() {
      this.props.onExportCSV();
    }
  }, {
    key: '__handleClearBtnClick__REACT_HOT_LOADER__',
    value: function __handleClearBtnClick__REACT_HOT_LOADER__() {
      var seachInput = this.refs.seachInput;

      seachInput && seachInput.setValue('');
      this.props.onSearch('');
    }
  }, {
    key: 'render',
    value: function render() {
      this.modalClassName = 'bs-table-modal-sm' + ToolBar.modalSeq++;
      var toolbar = null;
      var btnGroup = null;
      var insertBtn = null;
      var deleteBtn = null;
      var exportCSVBtn = null;
      var showSelectedOnlyBtn = null;

      if (this.props.enableInsert) {
        if (this.props.insertBtn) {
          insertBtn = this.renderCustomBtn(this.props.insertBtn, [this.handleModalOpen], _InsertButton2.default.name, 'onClick', this.handleModalOpen);
        } else {
          insertBtn = _react2.default.createElement(_InsertButton2.default, { btnText: this.props.insertText,
            onClick: this.handleModalOpen });
        }
      }

      if (this.props.enableDelete) {
        if (this.props.deleteBtn) {
          deleteBtn = this.renderCustomBtn(this.props.deleteBtn, [this.handleDropRowBtnClick], _DeleteButton2.default.name, 'onClick', this.handleDropRowBtnClick);
        } else {
          deleteBtn = _react2.default.createElement(_DeleteButton2.default, { btnText: this.props.deleteText,
            onClick: this.handleDropRowBtnClick });
        }
      }

      if (this.props.enableShowOnlySelected) {
        if (this.props.showSelectedOnlyBtn) {
          showSelectedOnlyBtn = this.renderCustomBtn(this.props.showSelectedOnlyBtn, [this.handleShowOnlyToggle, this.state.showSelected], _ShowSelectedOnlyButton2.default.name, 'onClick', this.handleShowOnlyToggle);
        } else {
          showSelectedOnlyBtn = _react2.default.createElement(_ShowSelectedOnlyButton2.default, { toggle: this.state.showSelected,
            onClick: this.handleShowOnlyToggle });
        }
      }

      if (this.props.enableExportCSV) {
        if (this.props.exportCSVBtn) {
          exportCSVBtn = this.renderCustomBtn(this.props.exportCSVBtn, [this.handleExportCSV], _ExportCSVButton2.default.name, 'onClick', this.handleExportCSV);
        } else {
          exportCSVBtn = _react2.default.createElement(_ExportCSVButton2.default, { btnText: this.props.exportCSVText,
            onClick: this.handleExportCSV });
        }
      }

      if (this.props.btnGroup) {
        btnGroup = this.props.btnGroup({
          exportCSVBtn: exportCSVBtn,
          insertBtn: insertBtn,
          deleteBtn: deleteBtn,
          showSelectedOnlyBtn: showSelectedOnlyBtn
        });
      } else {
        btnGroup = _react2.default.createElement(
          'div',
          { className: 'btn-group btn-group-sm', role: 'group' },
          exportCSVBtn,
          insertBtn,
          deleteBtn,
          showSelectedOnlyBtn
        );
      }

      var _renderSearchPanel = this.renderSearchPanel(),
          _renderSearchPanel2 = _slicedToArray(_renderSearchPanel, 3),
          searchPanel = _renderSearchPanel2[0],
          searchField = _renderSearchPanel2[1],
          clearBtn = _renderSearchPanel2[2];

      var modal = this.props.enableInsert ? this.renderInsertRowModal() : null;

      if (this.props.toolBar) {
        toolbar = this.props.toolBar({
          components: {
            exportCSVBtn: exportCSVBtn,
            insertBtn: insertBtn,
            deleteBtn: deleteBtn,
            showSelectedOnlyBtn: showSelectedOnlyBtn,
            searchPanel: searchPanel,
            btnGroup: btnGroup,
            searchField: searchField,
            clearBtn: clearBtn
          },
          event: {
            openInsertModal: this.handleModalOpen,
            closeInsertModal: this.handleModalClose,
            dropRow: this.handleDropRowBtnClick,
            showOnlyToogle: this.handleShowOnlyToggle,
            exportCSV: this.handleExportCSV,
            search: this.props.onSearch
          }
        });
      } else {
        toolbar = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'col-xs-6 col-sm-6 col-md-6 col-lg-8' },
            this.props.searchPosition === 'left' ? searchPanel : btnGroup
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-xs-6 col-sm-6 col-md-6 col-lg-4' },
            this.props.searchPosition === 'left' ? btnGroup : searchPanel
          )
        );
      }

      return _react2.default.createElement(
        'div',
        { className: 'row' },
        toolbar,
        _react2.default.createElement(_Notification2.default, { ref: 'notifier' }),
        modal
      );
    }
  }, {
    key: 'renderSearchPanel',
    value: function renderSearchPanel() {
      if (this.props.enableSearch) {
        var classNames = 'form-group form-group-sm react-bs-table-search-form';
        var clearBtn = null;
        var searchField = null;
        var searchPanel = null;
        if (this.props.clearSearch) {
          if (this.props.clearSearchBtn) {
            clearBtn = this.renderCustomBtn(this.props.clearSearchBtn, [this.handleClearBtnClick], _ClearSearchButton2.default.name, 'onClick', this.handleClearBtnClick); /* eslint max-len: 0*/
          } else {
            clearBtn = _react2.default.createElement(_ClearSearchButton2.default, { onClick: this.handleClearBtnClick });
          }
          classNames += ' input-group input-group-sm';
        }

        if (this.props.searchField) {
          searchField = this.props.searchField({
            search: this.handleKeyUp,
            defaultValue: this.props.defaultSearch,
            placeholder: this.props.searchPlaceholder
          });
          if (searchField.type.name === _SearchField2.default.name) {
            searchField = _react2.default.cloneElement(searchField, {
              ref: 'seachInput',
              onKeyUp: this.handleKeyUp
            });
          } else {
            searchField = _react2.default.cloneElement(searchField, {
              ref: 'seachInput'
            });
          }
        } else {
          searchField = _react2.default.createElement(_SearchField2.default, { ref: 'seachInput',
            defaultValue: this.props.defaultSearch,
            placeholder: this.props.searchPlaceholder,
            onKeyUp: this.handleKeyUp });
        }
        if (this.props.searchPanel) {
          searchPanel = this.props.searchPanel({
            searchField: searchField, clearBtn: clearBtn,
            search: this.props.onSearch,
            defaultValue: this.props.defaultSearch,
            placeholder: this.props.searchPlaceholder,
            clearBtnClick: this.handleClearBtnClick
          });
        } else {
          searchPanel = _react2.default.createElement(
            'div',
            { className: classNames },
            searchField,
            _react2.default.createElement(
              'span',
              { className: 'input-group-btn' },
              clearBtn
            )
          );
        }
        return [searchPanel, searchField, clearBtn];
      } else {
        return [];
      }
    }
  }, {
    key: 'renderInsertRowModal',
    value: function renderInsertRowModal() {
      var validateState = this.state.validateState || {};
      var _props = this.props,
          columns = _props.columns,
          ignoreEditable = _props.ignoreEditable,
          insertModalHeader = _props.insertModalHeader,
          insertModalBody = _props.insertModalBody,
          insertModalFooter = _props.insertModalFooter,
          insertModal = _props.insertModal;


      var modal = void 0;
      modal = insertModal && insertModal(this.handleModalClose, this.handleSaveBtnClick, columns, validateState, ignoreEditable);

      if (!modal) {
        modal = _react2.default.createElement(_InsertModal2.default, {
          columns: columns,
          validateState: validateState,
          ignoreEditable: ignoreEditable,
          onModalClose: this.handleModalClose,
          onSave: this.handleSaveBtnClick,
          headerComponent: insertModalHeader,
          bodyComponent: insertModalBody,
          footerComponent: insertModalFooter });
      }

      return _react2.default.createElement(
        _reactModal2.default,
        { className: 'react-bs-insert-modal modal-dialog',
          isOpen: this.state.isInsertModalOpen,
          onRequestClose: this.handleModalClose,
          contentLabel: 'Modal' },
        modal
      );
    }
  }, {
    key: 'renderCustomBtn',
    value: function renderCustomBtn(cb, params, componentName, eventName, event) {
      var element = cb.apply(null, params);
      if (element.type.name === componentName && !element.props[eventName]) {
        var props = {};
        props[eventName] = event;
        element = _react2.default.cloneElement(element, props);
      }
      return element;
    }
  }]);

  return ToolBar;
}(_react.Component);

ToolBar.modalSeq = 0;


ToolBar.propTypes = {
  onAddRow: _react.PropTypes.func,
  onDropRow: _react.PropTypes.func,
  onShowOnlySelected: _react.PropTypes.func,
  enableInsert: _react.PropTypes.bool,
  enableDelete: _react.PropTypes.bool,
  enableSearch: _react.PropTypes.bool,
  enableShowOnlySelected: _react.PropTypes.bool,
  columns: _react.PropTypes.array,
  searchPlaceholder: _react.PropTypes.string,
  exportCSVText: _react.PropTypes.string,
  insertText: _react.PropTypes.string,
  deleteText: _react.PropTypes.string,
  saveText: _react.PropTypes.string,
  closeText: _react.PropTypes.string,
  clearSearch: _react.PropTypes.bool,
  ignoreEditable: _react.PropTypes.bool,
  defaultSearch: _react.PropTypes.string,
  insertModalHeader: _react.PropTypes.func,
  insertModalBody: _react.PropTypes.func,
  insertModalFooter: _react.PropTypes.func,
  insertModal: _react.PropTypes.func,
  insertBtn: _react.PropTypes.func,
  deleteBtn: _react.PropTypes.func,
  showSelectedOnlyBtn: _react.PropTypes.func,
  exportCSVBtn: _react.PropTypes.func,
  clearSearchBtn: _react.PropTypes.func,
  searchField: _react.PropTypes.func,
  searchPanel: _react.PropTypes.func,
  btnGroup: _react.PropTypes.func,
  toolBar: _react.PropTypes.func,
  searchPosition: _react.PropTypes.string,
  reset: _react.PropTypes.bool,
  isValidKey: _react.PropTypes.func
};

ToolBar.defaultProps = {
  reset: false,
  enableInsert: false,
  enableDelete: false,
  enableSearch: false,
  enableShowOnlySelected: false,
  clearSearch: false,
  ignoreEditable: false,
  exportCSVText: _Const2.default.EXPORT_CSV_TEXT,
  insertText: _Const2.default.INSERT_BTN_TEXT,
  deleteText: _Const2.default.DELETE_BTN_TEXT,
  saveText: _Const2.default.SAVE_BTN_TEXT,
  closeText: _Const2.default.CLOSE_BTN_TEXT
};

var _default = ToolBar;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(ToolBar, 'ToolBar', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ToolBar.js');

  __REACT_HOT_LOADER__.register(_default, 'default', '/Users/allen/Node/react-bootstrap-table-new/react-bootstrap-table/src/toolbar/ToolBar.js');
}();

;

/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PanelGroup__ = __webpack_require__(586);








var Accordion = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Accordion, _React$Component);

  function Accordion() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Accordion);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Accordion.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_5__PanelGroup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, { accordion: true }),
      this.props.children
    );
  };

  return Accordion;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Accordion);

/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CloseButton__ = __webpack_require__(325);














var propTypes = {
  onDismiss: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  closeLabel: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string
};

var defaultProps = {
  closeLabel: 'Close alert'
};

var Alert = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Alert, _React$Component);

  function Alert() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Alert);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Alert.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        onDismiss = _props.onDismiss,
        closeLabel = _props.closeLabel,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onDismiss', 'closeLabel', 'className', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var dismissable = !!onDismiss;
    var classes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'dismissable')] = dismissable, _extends2));

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'alert',
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes)
      }),
      dismissable && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__CloseButton__["a" /* default */], {
        onClick: onDismiss,
        label: closeLabel
      }),
      children
    );
  };

  return Alert;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Alert.propTypes = propTypes;
Alert.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["c" /* State */]), __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["c" /* State */].INFO, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('alert', Alert)));

/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(20);











// TODO: `pullRight` doesn't belong here. There's no special handling here.

var propTypes = {
  pullRight: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  pullRight: false
};

var Badge = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Badge, _React$Component);

  function Badge() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Badge);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Badge.prototype.hasContent = function hasContent(children) {
    var result = false;

    __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.forEach(children, function (child) {
      if (result) {
        return;
      }

      if (child || child === 0) {
        result = true;
      }
    });

    return result;
  };

  Badge.prototype.render = function render() {
    var _props = this.props,
        pullRight = _props.pullRight,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['pullRight', 'className', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), {
      'pull-right': pullRight,

      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'span',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      children
    );
  };

  return Badge;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Badge.propTypes = propTypes;
Badge.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('badge', Badge));

/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BreadcrumbItem__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(20);











var Breadcrumb = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Breadcrumb, _React$Component);

  function Breadcrumb() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Breadcrumb);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Breadcrumb.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('ol', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      role: 'navigation',
      'aria-label': 'breadcrumbs',
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Breadcrumb;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Breadcrumb.Item = __WEBPACK_IMPORTED_MODULE_7__BreadcrumbItem__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('breadcrumb', Breadcrumb));

/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(20);










var ButtonToolbar = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ButtonToolbar, _React$Component);

  function ButtonToolbar() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ButtonToolbar);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ButtonToolbar.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      role: 'toolbar',
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ButtonToolbar;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsClass */])('btn-toolbar', ButtonToolbar));

/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CarouselCaption__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CarouselItem__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Glyphicon__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SafeAnchor__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__ = __webpack_require__(46);
















// TODO: `slide` should be `animate`.

// TODO: Use uncontrollable.

var propTypes = {
  slide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  indicators: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * The amount of time to delay between automatically cycling an item.
   * If `null`, carousel will not automatically cycle.
   */
  interval: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  controls: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  pauseOnHover: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  wrap: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Callback fired when the active item changes.
   *
   * ```js
   * (eventKey: any) => any | (eventKey: any, event: Object) => any
   * ```
   *
   * If this callback takes two or more arguments, the second argument will
   * be a persisted event object with `direction` set to the direction of the
   * transition.
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onSlideEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  activeIndex: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  defaultActiveIndex: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  direction: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['prev', 'next']),
  prevIcon: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  /**
   * Label shown to screen readers only, can be used to show the previous element
   * in the carousel.
   * Set to null to deactivate.
   */
  prevLabel: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  nextIcon: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node,
  /**
   * Label shown to screen readers only, can be used to show the next element
   * in the carousel.
   * Set to null to deactivate.
   */
  nextLabel: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var defaultProps = {
  slide: true,
  interval: 5000,
  pauseOnHover: true,
  wrap: true,
  indicators: true,
  controls: true,
  prevIcon: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Glyphicon__["a" /* default */], { glyph: 'chevron-left' }),
  prevLabel: 'Previous',
  nextIcon: __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Glyphicon__["a" /* default */], { glyph: 'chevron-right' }),
  nextLabel: 'Next'
};

var Carousel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Carousel, _React$Component);

  function Carousel(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Carousel);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
    _this.handlePrev = _this.handlePrev.bind(_this);
    _this.handleNext = _this.handleNext.bind(_this);
    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind(_this);

    var defaultActiveIndex = props.defaultActiveIndex;


    _this.state = {
      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
      previousActiveIndex: null,
      direction: null
    };

    _this.isUnmounted = false;
    return _this;
  }

  Carousel.prototype.componentDidMount = function componentDidMount() {
    this.waitForNext();
  };

  Carousel.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var activeIndex = this.getActiveIndex();

    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
      clearTimeout(this.timeout);

      this.setState({
        previousActiveIndex: activeIndex,
        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
      });
    }

    if (nextProps.activeIndex == null && this.state.activeIndex >= nextProps.children.length) {
      this.setState({
        activeIndex: 0,
        previousActiveIndex: null,
        direction: null
      });
    }
  };

  Carousel.prototype.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.timeout);
    this.isUnmounted = true;
  };

  Carousel.prototype.getActiveIndex = function getActiveIndex() {
    var activeIndexProp = this.props.activeIndex;
    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
  };

  Carousel.prototype.getDirection = function getDirection(prevIndex, index) {
    if (prevIndex === index) {
      return null;
    }

    return prevIndex > index ? 'prev' : 'next';
  };

  Carousel.prototype.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
    var _this2 = this;

    this.setState({
      previousActiveIndex: null,
      direction: null
    }, function () {
      _this2.waitForNext();

      if (_this2.props.onSlideEnd) {
        _this2.props.onSlideEnd();
      }
    });
  };

  Carousel.prototype.handleMouseOut = function handleMouseOut() {
    if (this.isPaused) {
      this.play();
    }
  };

  Carousel.prototype.handleMouseOver = function handleMouseOver() {
    if (this.props.pauseOnHover) {
      this.pause();
    }
  };

  Carousel.prototype.handleNext = function handleNext(e) {
    var index = this.getActiveIndex() + 1;
    var count = __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].count(this.props.children);

    if (index > count - 1) {
      if (!this.props.wrap) {
        return;
      }
      index = 0;
    }

    this.select(index, e, 'next');
  };

  Carousel.prototype.handlePrev = function handlePrev(e) {
    var index = this.getActiveIndex() - 1;

    if (index < 0) {
      if (!this.props.wrap) {
        return;
      }
      index = __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].count(this.props.children) - 1;
    }

    this.select(index, e, 'prev');
  };

  // This might be a public API.


  Carousel.prototype.pause = function pause() {
    this.isPaused = true;
    clearTimeout(this.timeout);
  };

  // This might be a public API.


  Carousel.prototype.play = function play() {
    this.isPaused = false;
    this.waitForNext();
  };

  Carousel.prototype.select = function select(index, e, direction) {
    clearTimeout(this.timeout);

    // TODO: Is this necessary? Seems like the only risk is if the component
    // unmounts while handleItemAnimateOutEnd fires.
    if (this.isUnmounted) {
      return;
    }

    var previousActiveIndex = this.props.slide ? this.getActiveIndex() : null;
    direction = direction || this.getDirection(previousActiveIndex, index);

    var onSelect = this.props.onSelect;


    if (onSelect) {
      if (onSelect.length > 1) {
        // React SyntheticEvents are pooled, so we need to remove this event
        // from the pool to add a custom property. To avoid unnecessarily
        // removing objects from the pool, only do this when the listener
        // actually wants the event.
        if (e) {
          e.persist();
          e.direction = direction;
        } else {
          e = { direction: direction };
        }

        onSelect(index, e);
      } else {
        onSelect(index);
      }
    }

    if (this.props.activeIndex == null && index !== previousActiveIndex) {
      if (this.state.previousActiveIndex != null) {
        // If currently animating don't activate the new index.
        // TODO: look into queueing this canceled call and
        // animating after the current animation has ended.
        return;
      }

      this.setState({
        activeIndex: index,
        previousActiveIndex: previousActiveIndex,
        direction: direction
      });
    }
  };

  Carousel.prototype.waitForNext = function waitForNext() {
    var _props = this.props,
        slide = _props.slide,
        interval = _props.interval,
        activeIndexProp = _props.activeIndex;


    if (!this.isPaused && slide && interval && activeIndexProp == null) {
      this.timeout = setTimeout(this.handleNext, interval);
    }
  };

  Carousel.prototype.renderControls = function renderControls(properties) {
    var wrap = properties.wrap,
        children = properties.children,
        activeIndex = properties.activeIndex,
        prevIcon = properties.prevIcon,
        nextIcon = properties.nextIcon,
        bsProps = properties.bsProps,
        prevLabel = properties.prevLabel,
        nextLabel = properties.nextLabel;

    var controlClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'control');
    var count = __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].count(children);

    return [(wrap || activeIndex !== 0) && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__SafeAnchor__["a" /* default */],
      {
        key: 'prev',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(controlClassName, 'left'),
        onClick: this.handlePrev
      },
      prevIcon,
      prevLabel && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        prevLabel
      )
    ), (wrap || activeIndex !== count - 1) && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__SafeAnchor__["a" /* default */],
      {
        key: 'next',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(controlClassName, 'right'),
        onClick: this.handleNext
      },
      nextIcon,
      nextLabel && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        nextLabel
      )
    )];
  };

  Carousel.prototype.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
    var _this3 = this;

    var indicators = [];

    __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].forEach(children, function (child, index) {
      indicators.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', {
        key: index,
        className: index === activeIndex ? 'active' : null,
        onClick: function onClick(e) {
          return _this3.select(index, e);
        }
      }),

      // Force whitespace between indicator elements. Bootstrap requires
      // this for correct spacing of elements.
      ' ');
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'ol',
      { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'indicators') },
      indicators
    );
  };

  Carousel.prototype.render = function render() {
    var _this4 = this;

    var _props2 = this.props,
        slide = _props2.slide,
        indicators = _props2.indicators,
        controls = _props2.controls,
        wrap = _props2.wrap,
        prevIcon = _props2.prevIcon,
        prevLabel = _props2.prevLabel,
        nextIcon = _props2.nextIcon,
        nextLabel = _props2.nextLabel,
        className = _props2.className,
        children = _props2.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['slide', 'indicators', 'controls', 'wrap', 'prevIcon', 'prevLabel', 'nextIcon', 'nextLabel', 'className', 'children']);

    var _state = this.state,
        previousActiveIndex = _state.previousActiveIndex,
        direction = _state.direction;

    var _splitBsPropsAndOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
    'defaultActiveIndex', 'direction']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var activeIndex = this.getActiveIndex();

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), {
      slide: slide
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes),
        onMouseOver: this.handleMouseOver,
        onMouseOut: this.handleMouseOut
      }),
      indicators && this.renderIndicators(children, activeIndex, bsProps),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inner') },
        __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].map(children, function (child, index) {
          var active = index === activeIndex;
          var previousActive = slide && index === previousActiveIndex;

          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, {
            active: active,
            index: index,
            animateOut: previousActive,
            animateIn: active && previousActiveIndex != null && slide,
            direction: direction,
            onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
          });
        })
      ),
      controls && this.renderControls({
        wrap: wrap,
        children: children,
        activeIndex: activeIndex,
        prevIcon: prevIcon,
        prevLabel: prevLabel,
        nextIcon: nextIcon,
        nextLabel: nextLabel,
        bsProps: bsProps
      })
    );
  };

  return Carousel;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Carousel.propTypes = propTypes;
Carousel.defaultProps = defaultProps;

Carousel.Caption = __WEBPACK_IMPORTED_MODULE_8__CarouselCaption__["a" /* default */];
Carousel.Item = __WEBPACK_IMPORTED_MODULE_9__CarouselItem__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["c" /* bsClass */])('carousel', Carousel));

/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(20);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var CarouselCaption = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CarouselCaption, _React$Component);

  function CarouselCaption() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CarouselCaption);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  CarouselCaption.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return CarouselCaption;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

CarouselCaption.propTypes = propTypes;
CarouselCaption.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('carousel-caption', CarouselCaption));

/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(20);





/* eslint-disable jsx-a11y/label-has-for */








var propTypes = {
  inline: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * Only valid if `inline` is not set.
   */
  validationState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['success', 'warning', 'error', null]),
  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <Checkbox inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  inline: false,
  disabled: false,
  title: ''
};

var Checkbox = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Checkbox, _React$Component);

  function Checkbox() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Checkbox);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Checkbox.prototype.render = function render() {
    var _props = this.props,
        inline = _props.inline,
        disabled = _props.disabled,
        validationState = _props.validationState,
        inputRef = _props.inputRef,
        className = _props.className,
        style = _props.style,
        title = _props.title,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'title', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var input = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('input', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      ref: inputRef,
      type: 'checkbox',
      disabled: disabled
    }));

    if (inline) {
      var _classes2;

      var _classes = (_classes2 = {}, _classes2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);

      // Use a warning here instead of in propTypes to get better-looking
      // generated documentation.
       false ? warning(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'label',
        { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, _classes), style: style, title: title },
        input,
        children
      );
    }

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), {
      disabled: disabled
    });
    if (validationState) {
      classes['has-' + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes), style: style },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'label',
        { title: title },
        input,
        children
      )
    );
  };

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('checkbox', Checkbox));

/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_capitalize__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__ = __webpack_require__(42);














var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,

  /**
   * Apply clearfix
   *
   * on Extra small devices Phones
   *
   * adds class `visible-xs-block`
   */
  visibleXsBlock: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Apply clearfix
   *
   * on Small devices Tablets
   *
   * adds class `visible-sm-block`
   */
  visibleSmBlock: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Apply clearfix
   *
   * on Medium devices Desktops
   *
   * adds class `visible-md-block`
   */
  visibleMdBlock: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Apply clearfix
   *
   * on Large devices Desktops
   *
   * adds class `visible-lg-block`
   */
  visibleLgBlock: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  componentClass: 'div'
};

var Clearfix = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Clearfix, _React$Component);

  function Clearfix() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Clearfix);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Clearfix.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["e" /* DEVICE_SIZES */].forEach(function (size) {
      var propName = 'visible' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(size) + 'Block';
      if (elementProps[propName]) {
        classes['visible-' + size + '-block'] = true;
      }

      delete elementProps[propName];
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Clearfix;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Clearfix.propTypes = propTypes;
Clearfix.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('clearfix', Clearfix));

/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(42);













var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,

  /**
   * The number of columns you wish to span
   *
   * for Extra small devices Phones (<768px)
   *
   * class-prefix `col-xs-`
   */
  xs: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * The number of columns you wish to span
   *
   * for Small devices Tablets (≥768px)
   *
   * class-prefix `col-sm-`
   */
  sm: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * The number of columns you wish to span
   *
   * for Medium devices Desktops (≥992px)
   *
   * class-prefix `col-md-`
   */
  md: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * The number of columns you wish to span
   *
   * for Large devices Desktops (≥1200px)
   *
   * class-prefix `col-lg-`
   */
  lg: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Hide column
   *
   * on Extra small devices Phones
   *
   * adds class `hidden-xs`
   */
  xsHidden: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Hide column
   *
   * on Small devices Tablets
   *
   * adds class `hidden-sm`
   */
  smHidden: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Hide column
   *
   * on Medium devices Desktops
   *
   * adds class `hidden-md`
   */
  mdHidden: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Hide column
   *
   * on Large devices Desktops
   *
   * adds class `hidden-lg`
   */
  lgHidden: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Move columns to the right
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-offset-`
   */
  xsOffset: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Move columns to the right
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-offset-`
   */
  smOffset: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Move columns to the right
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-offset-`
   */
  mdOffset: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Move columns to the right
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-offset-`
   */
  lgOffset: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-push-`
   */
  xsPush: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-push-`
   */
  smPush: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-push-`
   */
  mdPush: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the right
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-push-`
   */
  lgPush: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-pull-`
   */
  xsPull: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-pull-`
   */
  smPull: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-pull-`
   */
  mdPull: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * Change the order of grid columns to the left
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-pull-`
   */
  lgPull: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number
};

var defaultProps = {
  componentClass: 'div'
};

var Col = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Col, _React$Component);

  function Col() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Col);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Col.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = [];

    __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["e" /* DEVICE_SIZES */].forEach(function (size) {
      function popProp(propSuffix, modifier) {
        var propName = '' + size + propSuffix;
        var propValue = elementProps[propName];

        if (propValue != null) {
          classes.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, '' + size + modifier + '-' + propValue));
        }

        delete elementProps[propName];
      }

      popProp('', '');
      popProp('Offset', '-offset');
      popProp('Push', '-push');
      popProp('Pull', '-pull');

      var hiddenPropName = size + 'Hidden';
      if (elementProps[hiddenPropName]) {
        classes.push('hidden-' + size);
      }
      delete elementProps[hiddenPropName];
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Col;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Col.propTypes = propTypes;
Col.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('col', Col));

/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(20);












var propTypes = {
  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  htmlFor: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  srOnly: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  srOnly: false
};

var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
};

var ControlLabel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ControlLabel, _React$Component);

  function ControlLabel() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ControlLabel);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ControlLabel.prototype.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;

    var _props = this.props,
        _props$htmlFor = _props.htmlFor,
        htmlFor = _props$htmlFor === undefined ? controlId : _props$htmlFor,
        srOnly = _props.srOnly,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['htmlFor', 'srOnly', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), {
      'sr-only': srOnly
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('label', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      htmlFor: htmlFor,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return ControlLabel;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ControlLabel.propTypes = propTypes;
ControlLabel.defaultProps = defaultProps;
ControlLabel.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('control-label', ControlLabel));

/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Dropdown__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_splitComponentProps__ = __webpack_require__(215);











var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */].propTypes, {

  // Toggle props.
  bsStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node.isRequired,
  noCaret: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  // Override generated docs from <Dropdown>.
  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node
});

var DropdownButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DropdownButton, _React$Component);

  function DropdownButton() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DropdownButton);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  DropdownButton.prototype.render = function render() {
    var _props = this.props,
        bsSize = _props.bsSize,
        bsStyle = _props.bsStyle,
        title = _props.title,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['bsSize', 'bsStyle', 'title', 'children']);

    var _splitComponentProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1];

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, dropdownProps, {
        bsSize: bsSize,
        bsStyle: bsStyle
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */].Toggle,
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, toggleProps, {
          bsSize: bsSize,
          bsStyle: bsStyle
        }),
        title
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__Dropdown__["a" /* default */].Menu,
        null,
        children
      )
    );
  };

  return DropdownButton;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

DropdownButton.propTypes = propTypes;

/* unused harmony default export */ var _unused_webpack_default_export = (DropdownButton);

/***/ }),
/* 1345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_keycode__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_overlays_lib_RootCloseWrapper__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_overlays_lib_RootCloseWrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_overlays_lib_RootCloseWrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__ = __webpack_require__(46);

















var propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  pullRight: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  onClose: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  labelledBy: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number]),
  onSelect: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  rootCloseEvent: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOf(['click', 'mousedown'])
};

var defaultProps = {
  bsRole: 'menu',
  pullRight: false
};

var DropdownMenu = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(DropdownMenu, _React$Component);

  function DropdownMenu(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, DropdownMenu);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _this.handleRootClose = _this.handleRootClose.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }

  DropdownMenu.prototype.getFocusableMenuItems = function getFocusableMenuItems() {
    var node = __WEBPACK_IMPORTED_MODULE_10_react_dom___default.a.findDOMNode(this);
    if (!node) {
      return [];
    }

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(node.querySelectorAll('[tabIndex="-1"]'));
  };

  DropdownMenu.prototype.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
    var items = this.getFocusableMenuItems();
    var activeIndex = items.indexOf(document.activeElement);

    return { items: items, activeIndex: activeIndex };
  };

  DropdownMenu.prototype.focusNext = function focusNext() {
    var _getItemsAndActiveInd = this.getItemsAndActiveIndex(),
        items = _getItemsAndActiveInd.items,
        activeIndex = _getItemsAndActiveInd.activeIndex;

    if (items.length === 0) {
      return;
    }

    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    items[nextIndex].focus();
  };

  DropdownMenu.prototype.focusPrevious = function focusPrevious() {
    var _getItemsAndActiveInd2 = this.getItemsAndActiveIndex(),
        items = _getItemsAndActiveInd2.items,
        activeIndex = _getItemsAndActiveInd2.activeIndex;

    if (items.length === 0) {
      return;
    }

    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    items[prevIndex].focus();
  };

  DropdownMenu.prototype.handleKeyDown = function handleKeyDown(event) {
    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.down:
        this.focusNext();
        event.preventDefault();
        break;
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.up:
        this.focusPrevious();
        event.preventDefault();
        break;
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.esc:
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.tab:
        this.props.onClose(event, { source: 'keydown' });
        break;
      default:
    }
  };

  DropdownMenu.prototype.handleRootClose = function handleRootClose(event) {
    this.props.onClose(event, { source: 'rootClose' });
  };

  DropdownMenu.prototype.render = function render() {
    var _extends2,
        _this2 = this;

    var _props = this.props,
        open = _props.open,
        pullRight = _props.pullRight,
        labelledBy = _props.labelledBy,
        onSelect = _props.onSelect,
        className = _props.className,
        rootCloseEvent = _props.rootCloseEvent,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['open', 'pullRight', 'labelledBy', 'onSelect', 'className', 'rootCloseEvent', 'children']);

    var _splitBsPropsAndOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['onClose']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'right')] = pullRight, _extends2));

    return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11_react_overlays_lib_RootCloseWrapper___default.a,
      {
        disabled: !open,
        onRootClose: this.handleRootClose,
        event: rootCloseEvent
      },
      __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        'ul',
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
          role: 'menu',
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes),
          'aria-labelledby': labelledBy
        }),
        __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
          return __WEBPACK_IMPORTED_MODULE_8_react___default.a.cloneElement(child, {
            onKeyDown: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__["a" /* default */])(child.props.onKeyDown, _this2.handleKeyDown),
            onSelect: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect)
          });
        })
      )
    );
  };

  return DropdownMenu;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);

DropdownMenu.propTypes = propTypes;
DropdownMenu.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["c" /* bsClass */])('dropdown-menu', DropdownMenu));

/***/ }),
/* 1346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(20);












var propTypes = {
  horizontal: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  horizontal: false,
  inline: false,
  componentClass: 'form'
};

var Form = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Form, _React$Component);

  function Form() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Form);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Form.prototype.render = function render() {
    var _props = this.props,
        horizontal = _props.horizontal,
        inline = _props.inline,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['horizontal', 'inline', 'componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = [];
    if (horizontal) {
      classes.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'horizontal'));
    }
    if (inline) {
      classes.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inline'));
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Form;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Form.propTypes = propTypes;
Form.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('form', Form));

/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FormControlFeedback__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FormControlStatic__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_StyleConfig__ = __webpack_require__(42);
















var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,
  /**
   * Only relevant if `componentClass` is `'input'`.
   */
  type: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  id: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <FormControl inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  componentClass: 'input'
};

var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
};

var FormControl = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FormControl, _React$Component);

  function FormControl() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormControl);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  FormControl.prototype.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;

    var _props = this.props,
        Component = _props.componentClass,
        type = _props.type,
        _props$id = _props.id,
        id = _props$id === undefined ? controlId : _props$id,
        inputRef = _props.inputRef,
        className = _props.className,
        bsSize = _props.bsSize,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'type', 'id', 'inputRef', 'className', 'bsSize']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0;

    // input[type="file"] should not have .form-control.
    var classes = void 0;
    if (type !== 'file') {
      classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);
    }

    // If user provides a size, make sure to append it to classes as input-
    // e.g. if bsSize is small, it will append input-sm
    if (bsSize) {
      var size = __WEBPACK_IMPORTED_MODULE_13__utils_StyleConfig__["a" /* SIZE_MAP */][bsSize] || bsSize;
      classes[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["e" /* prefix */])({ bsClass: 'input' }, size)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      type: type,
      id: id,
      ref: inputRef,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return FormControl;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

FormControl.propTypes = propTypes;
FormControl.defaultProps = defaultProps;
FormControl.contextTypes = contextTypes;

FormControl.Feedback = __WEBPACK_IMPORTED_MODULE_10__FormControlFeedback__["a" /* default */];
FormControl.Static = __WEBPACK_IMPORTED_MODULE_11__FormControlStatic__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["c" /* bsClass */])('form-control', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["d" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_13__utils_StyleConfig__["b" /* Size */].SMALL, __WEBPACK_IMPORTED_MODULE_13__utils_StyleConfig__["b" /* Size */].LARGE], FormControl)));

/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Glyphicon__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(20);












var defaultProps = {
  bsRole: 'feedback'
};

var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
};

var FormControlFeedback = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FormControlFeedback, _React$Component);

  function FormControlFeedback() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormControlFeedback);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  FormControlFeedback.prototype.getGlyph = function getGlyph(validationState) {
    switch (validationState) {
      case 'success':
        return 'ok';
      case 'warning':
        return 'warning-sign';
      case 'error':
        return 'remove';
      default:
        return null;
    }
  };

  FormControlFeedback.prototype.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
    var glyph = this.getGlyph(formGroup && formGroup.validationState);
    if (!glyph) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Glyphicon__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
      glyph: glyph,
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  FormControlFeedback.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    if (!children) {
      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
    }

    var child = __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.only(children);
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(child, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(child.props.className, className, classes)
    }));
  };

  return FormControlFeedback;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

FormControlFeedback.defaultProps = defaultProps;
FormControlFeedback.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('form-control-feedback', FormControlFeedback));

/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(20);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'p'
};

var FormControlStatic = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FormControlStatic, _React$Component);

  function FormControlStatic() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormControlStatic);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  FormControlStatic.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return FormControlStatic;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

FormControlStatic.propTypes = propTypes;
FormControlStatic.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('form-control-static', FormControlStatic));

/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__ = __webpack_require__(46);













var propTypes = {
  /**
   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
   */
  controlId: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  validationState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['success', 'warning', 'error', null])
};

var childContextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired
};

var FormGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(FormGroup, _React$Component);

  function FormGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, FormGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  FormGroup.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        controlId = _props.controlId,
        validationState = _props.validationState;


    return {
      $bs_formGroup: {
        controlId: controlId,
        validationState: validationState
      }
    };
  };

  FormGroup.prototype.hasFeedback = function hasFeedback(children) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].some(children, function (child) {
      return child.props.bsRole === 'feedback' || child.props.children && _this2.hasFeedback(child.props.children);
    });
  };

  FormGroup.prototype.render = function render() {
    var _props2 = this.props,
        validationState = _props2.validationState,
        className = _props2.className,
        children = _props2.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['validationState', 'className', 'children']);

    var _splitBsPropsAndOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['controlId']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), {
      'has-feedback': this.hasFeedback(children)
    });
    if (validationState) {
      classes['has-' + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      children
    );
  };

  return FormGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

FormGroup.propTypes = propTypes;
FormGroup.childContextTypes = childContextTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('form-group', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["b" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["b" /* Size */].SMALL], FormGroup)));

/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(20);










var HelpBlock = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(HelpBlock, _React$Component);

  function HelpBlock() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, HelpBlock);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  HelpBlock.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return HelpBlock;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsClass */])('help-block', HelpBlock));

/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(20);











var propTypes = {
  /**
   * Sets image as responsive image
   */
  responsive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Sets image shape as rounded
   */
  rounded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Sets image shape as circle
   */
  circle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Sets image shape as thumbnail
   */
  thumbnail: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  responsive: false,
  rounded: false,
  circle: false,
  thumbnail: false
};

var Image = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Image, _React$Component);

  function Image() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Image);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Image.prototype.render = function render() {
    var _classes;

    var _props = this.props,
        responsive = _props.responsive,
        rounded = _props.rounded,
        circle = _props.circle,
        thumbnail = _props.thumbnail,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['responsive', 'rounded', 'circle', 'thumbnail', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (_classes = {}, _classes[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'responsive')] = responsive, _classes[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'rounded')] = rounded, _classes[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'circle')] = circle, _classes[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'thumbnail')] = thumbnail, _classes);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Image;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Image.propTypes = propTypes;
Image.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('img', Image));

/***/ }),
/* 1353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InputGroupAddon__ = __webpack_require__(1354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__InputGroupButton__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(42);













var InputGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InputGroup, _React$Component);

  function InputGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InputGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  InputGroup.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return InputGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

InputGroup.Addon = __WEBPACK_IMPORTED_MODULE_7__InputGroupAddon__["a" /* default */];
InputGroup.Button = __WEBPACK_IMPORTED_MODULE_8__InputGroupButton__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('input-group', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["b" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["b" /* Size */].SMALL], InputGroup)));

/***/ }),
/* 1354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(20);










var InputGroupAddon = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InputGroupAddon, _React$Component);

  function InputGroupAddon() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InputGroupAddon);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  InputGroupAddon.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return InputGroupAddon;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsClass */])('input-group-addon', InputGroupAddon));

/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(20);










var InputGroupButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InputGroupButton, _React$Component);

  function InputGroupButton() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, InputGroupButton);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  InputGroupButton.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return InputGroupButton;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsClass */])('input-group-btn', InputGroupButton));

/***/ }),
/* 1356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(20);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var Jumbotron = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Jumbotron, _React$Component);

  function Jumbotron() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Jumbotron);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Jumbotron.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes)
    }));
  };

  return Jumbotron;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Jumbotron.propTypes = propTypes;
Jumbotron.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('jumbotron', Jumbotron));

/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__ = __webpack_require__(42);












var Label = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Label, _React$Component);

  function Label() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Label);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Label.prototype.hasContent = function hasContent(children) {
    var result = false;

    __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.forEach(children, function (child) {
      if (result) {
        return;
      }

      if (child || child === 0) {
        result = true;
      }
    });

    return result;
  };

  Label.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), {

      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    });

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'span',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes)
      }),
      children
    );
  };

  return Label;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('label', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* bsStyles */])([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["c" /* State */]), [__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["d" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["d" /* Style */].PRIMARY]), __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["d" /* Style */].DEFAULT, Label)));

/***/ }),
/* 1358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ListGroupItem__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__ = __webpack_require__(46);













var propTypes = {
  /**
   * You can use a custom element type for this component.
   *
   * If not specified, it will be treated as `'li'` if every child is a
   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

function getDefaultComponent(children) {
  if (!children) {
    // FIXME: This is the old behavior. Is this right?
    return 'div';
  }

  if (__WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].some(children, function (child) {
    return child.type !== __WEBPACK_IMPORTED_MODULE_8__ListGroupItem__["a" /* default */] || child.props.href || child.props.onClick;
  })) {
    return 'div';
  }

  return 'ul';
}

var ListGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ListGroup, _React$Component);

  function ListGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ListGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ListGroup.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        _props$componentClass = _props.componentClass,
        Component = _props$componentClass === undefined ? getDefaultComponent(children) : _props$componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['children', 'componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    var useListItem = Component === 'ul' && __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].every(children, function (child) {
      return child.type === __WEBPACK_IMPORTED_MODULE_8__ListGroupItem__["a" /* default */];
    });

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      useListItem ? __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, { listItem: true });
      }) : children
    );
  };

  return ListGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ListGroup.propTypes = propTypes;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('list-group', ListGroup));

/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Media__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(20);













var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'middle', 'bottom']),

  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var MediaBody = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaBody, _React$Component);

  function MediaBody() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaBody);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaBody.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        align = _props.align,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'align', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-left-top`.
      classes[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_9__Media__["a" /* default */].defaultProps, align)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return MediaBody;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MediaBody.propTypes = propTypes;
MediaBody.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["c" /* bsClass */])('media-body', MediaBody));

/***/ }),
/* 1360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(20);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'h4'
};

var MediaHeading = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaHeading, _React$Component);

  function MediaHeading() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaHeading);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaHeading.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return MediaHeading;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MediaHeading.propTypes = propTypes;
MediaHeading.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('media-heading', MediaHeading));

/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Media__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(20);












var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'middle', 'bottom'])
};

var MediaLeft = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaLeft, _React$Component);

  function MediaLeft() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaLeft);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaLeft.prototype.render = function render() {
    var _props = this.props,
        align = _props.align,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['align', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-left-top`.
      classes[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_8__Media__["a" /* default */].defaultProps, align)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return MediaLeft;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MediaLeft.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('media-left', MediaLeft));

/***/ }),
/* 1362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(20);










var MediaList = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaList, _React$Component);

  function MediaList() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaList);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaList.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('ul', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return MediaList;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsClass */])('media-list', MediaList));

/***/ }),
/* 1363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(20);










var MediaListItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaListItem, _React$Component);

  function MediaListItem() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaListItem);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaListItem.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return MediaListItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsClass */])('media', MediaListItem));

/***/ }),
/* 1364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Media__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(20);












var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'middle', 'bottom'])
};

var MediaRight = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MediaRight, _React$Component);

  function MediaRight() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MediaRight);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  MediaRight.prototype.render = function render() {
    var _props = this.props,
        align = _props.align,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['align', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-right-top`.
      classes[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_8__Media__["a" /* default */].defaultProps, align)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return MediaRight;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MediaRight.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('media-right', MediaRight));

/***/ }),
/* 1365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SafeAnchor__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(41);














var propTypes = {
  /**
   * Highlight the menu item as active.
   */
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Disable the menu item, making it unselectable.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Styles the menu item as a horizontal rule, providing visual separation between
   * groups of menu items.
   */
  divider: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default()(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, function (_ref) {
    var divider = _ref.divider,
        children = _ref.children;
    return divider && children ? new Error('Children will not be rendered for dividers') : null;
  }),

  /**
   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
   */
  eventKey: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,

  /**
   * Styles the menu item as a header label, useful for describing a group of menu items.
   */
  header: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * HTML `href` attribute corresponding to `a.href`.
   */
  href: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,

  /**
   * Callback fired when the menu item is clicked.
   */
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired when the menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  divider: false,
  disabled: false,
  header: false
};

var MenuItem = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(MenuItem, _React$Component);

  function MenuItem(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, MenuItem);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  MenuItem.prototype.handleClick = function handleClick(event) {
    var _props = this.props,
        href = _props.href,
        disabled = _props.disabled,
        onSelect = _props.onSelect,
        eventKey = _props.eventKey;


    if (!href || disabled) {
      event.preventDefault();
    }

    if (disabled) {
      return;
    }

    if (onSelect) {
      onSelect(eventKey, event);
    }
  };

  MenuItem.prototype.render = function render() {
    var _props2 = this.props,
        active = _props2.active,
        disabled = _props2.disabled,
        divider = _props2.divider,
        header = _props2.header,
        onClick = _props2.onClick,
        className = _props2.className,
        style = _props2.style,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['active', 'disabled', 'divider', 'header', 'onClick', 'className', 'style']);

    var _splitBsPropsAndOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['eventKey', 'onSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    if (divider) {
      // Forcibly blank out the children; separators shouldn't render any.
      elementProps.children = undefined;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'separator',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, 'divider'),
        style: style
      }));
    }

    if (header) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('li', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'heading',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'header')),
        style: style
      }));
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'li',
      {
        role: 'presentation',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active, disabled: disabled }),
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SafeAnchor__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'menuitem',
        tabIndex: '-1',
        onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(onClick, this.handleClick)
      }))
    );
  };

  return MenuItem;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

MenuItem.propTypes = propTypes;
MenuItem.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["c" /* bsClass */])('dropdown', MenuItem));

/***/ }),
/* 1366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_events__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_ownerDocument__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_ownerDocument___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_dom_helpers_ownerDocument__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_inDOM__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_inDOM___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_inDOM__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dom__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_overlays_lib_utils_isOverflowing__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_overlays_lib_utils_isOverflowing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_overlays_lib_utils_isOverflowing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types_extra_lib_elementType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Fade__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ModalBody__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ModalDialog__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ModalFooter__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ModalHeader__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ModalTitle__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_createChainedFunction__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_splitComponentProps__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_StyleConfig__ = __webpack_require__(42);




























var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a.propTypes, __WEBPACK_IMPORTED_MODULE_18__ModalDialog__["a" /* default */].propTypes, {

  /**
   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
   * trigger an "onHide" when clicked.
   */
  backdrop: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.oneOf(['static', true, false]),

  /**
   * Add an optional extra class name to .modal-backdrop
   * It could end up looking like class="modal-backdrop foo-modal-backdrop in".
   */
  backdropClassName: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.string,

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * Open and close the Modal with a slide and fade animation.
   */
  animation: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * A Component type that provides the modal content Markup. This is a useful
   * prop when you want to use your own styles and markup to create a custom
   * modal component.
   */
  dialogComponentClass: __WEBPACK_IMPORTED_MODULE_15_prop_types_extra_lib_elementType___default.a,

  /**
   * When `true` The modal will automatically shift focus to itself when it
   * opens, and replace it to the last focused element when it closes.
   * Generally this should never be set to false as it makes the Modal less
   * accessible to assistive technologies, like screen-readers.
   */
  autoFocus: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while
   * open. Consider leaving the default value here, as it is necessary to make
   * the Modal work well with assistive technologies, such as screen readers.
   */
  enforceFocus: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * When `true` The modal will show itself.
   */
  show: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.bool,

  /**
   * A callback fired when the header closeButton or non-static backdrop is
   * clicked. Required if either are specified.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func,

  /**
   * @private
   */
  container: __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a.propTypes.container
});

var defaultProps = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a.defaultProps, {
  animation: true,
  dialogComponentClass: __WEBPACK_IMPORTED_MODULE_18__ModalDialog__["a" /* default */]
});

var childContextTypes = {
  $bs_modal: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.shape({
    onHide: __WEBPACK_IMPORTED_MODULE_11_prop_types___default.a.func
  })
};

var Modal = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Modal, _React$Component);

  function Modal(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Modal);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleEntering = _this.handleEntering.bind(_this);
    _this.handleExited = _this.handleExited.bind(_this);
    _this.handleWindowResize = _this.handleWindowResize.bind(_this);
    _this.handleDialogClick = _this.handleDialogClick.bind(_this);
    _this.setModalRef = _this.setModalRef.bind(_this);

    _this.state = {
      style: {}
    };
    return _this;
  }

  Modal.prototype.getChildContext = function getChildContext() {
    return {
      $bs_modal: {
        onHide: this.props.onHide
      }
    };
  };

  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
    // Clean up the listener if we need to.
    this.handleExited();
  };

  Modal.prototype.setModalRef = function setModalRef(ref) {
    this._modal = ref;
  };

  Modal.prototype.handleDialogClick = function handleDialogClick(e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    this.props.onHide();
  };

  Modal.prototype.handleEntering = function handleEntering() {
    // FIXME: This should work even when animation is disabled.
    __WEBPACK_IMPORTED_MODULE_6_dom_helpers_events___default.a.on(window, 'resize', this.handleWindowResize);
    this.updateStyle();
  };

  Modal.prototype.handleExited = function handleExited() {
    // FIXME: This should work even when animation is disabled.
    __WEBPACK_IMPORTED_MODULE_6_dom_helpers_events___default.a.off(window, 'resize', this.handleWindowResize);
  };

  Modal.prototype.handleWindowResize = function handleWindowResize() {
    this.updateStyle();
  };

  Modal.prototype.updateStyle = function updateStyle() {
    if (!__WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_inDOM___default.a) {
      return;
    }

    var dialogNode = this._modal.getDialogElement();
    var dialogHeight = dialogNode.scrollHeight;

    var document = __WEBPACK_IMPORTED_MODULE_7_dom_helpers_ownerDocument___default()(dialogNode);
    var bodyIsOverflowing = __WEBPACK_IMPORTED_MODULE_14_react_overlays_lib_utils_isOverflowing___default()(__WEBPACK_IMPORTED_MODULE_12_react_dom___default.a.findDOMNode(this.props.container || document.body));
    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;

    this.setState({
      style: {
        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize___default()() : undefined,
        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize___default()() : undefined
      }
    });
  };

  Modal.prototype.render = function render() {
    var _props = this.props,
        backdrop = _props.backdrop,
        backdropClassName = _props.backdropClassName,
        animation = _props.animation,
        show = _props.show,
        Dialog = _props.dialogComponentClass,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        onEntering = _props.onEntering,
        onExited = _props.onExited,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['backdrop', 'backdropClassName', 'animation', 'show', 'dialogComponentClass', 'className', 'style', 'children', 'onEntering', 'onExited']);

    var _splitComponentProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a),
        baseModalProps = _splitComponentProps[0],
        dialogProps = _splitComponentProps[1];

    var inClassName = show && !animation && 'in';

    return __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_Modal___default.a,
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, baseModalProps, {
        ref: this.setModalRef,
        show: show,
        onEntering: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_createChainedFunction__["a" /* default */])(onEntering, this.handleEntering),
        onExited: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_23__utils_createChainedFunction__["a" /* default */])(onExited, this.handleExited),
        backdrop: backdrop,
        backdropClassName: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__["e" /* prefix */])(props, 'backdrop'), backdropClassName, inClassName),
        containerClassName: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__["e" /* prefix */])(props, 'open'),
        transition: animation ? __WEBPACK_IMPORTED_MODULE_16__Fade__["a" /* default */] : undefined,
        dialogTransitionTimeout: Modal.TRANSITION_DURATION,
        backdropTransitionTimeout: Modal.BACKDROP_TRANSITION_DURATION
      }),
      __WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(
        Dialog,
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, dialogProps, {
          style: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.state.style, style),
          className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, inClassName),
          onClick: backdrop === true ? this.handleDialogClick : null
        }),
        children
      )
    );
  };

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_10_react___default.a.Component);

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;
Modal.childContextTypes = childContextTypes;

Modal.Body = __WEBPACK_IMPORTED_MODULE_17__ModalBody__["a" /* default */];
Modal.Header = __WEBPACK_IMPORTED_MODULE_20__ModalHeader__["a" /* default */];
Modal.Title = __WEBPACK_IMPORTED_MODULE_21__ModalTitle__["a" /* default */];
Modal.Footer = __WEBPACK_IMPORTED_MODULE_19__ModalFooter__["a" /* default */];

Modal.Dialog = __WEBPACK_IMPORTED_MODULE_18__ModalDialog__["a" /* default */];

Modal.TRANSITION_DURATION = 300;
Modal.BACKDROP_TRANSITION_DURATION = 150;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__["c" /* bsClass */])('modal', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_22__utils_bootstrapUtils__["d" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_25__utils_StyleConfig__["b" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_25__utils_StyleConfig__["b" /* Size */].SMALL], Modal)));

/***/ }),
/* 1367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__ = __webpack_require__(42);












var propTypes = {
  /**
   * A css class to apply to the Modal dialog DOM node.
   */
  dialogClassName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var ModalDialog = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalDialog, _React$Component);

  function ModalDialog() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalDialog);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ModalDialog.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        dialogClassName = _props.dialogClassName,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['dialogClassName', 'className', 'style', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var bsClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps);

    var modalStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ display: 'block' }, style);

    var dialogClasses = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'dialog')] = true, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        tabIndex: '-1',
        role: 'dialog',
        style: modalStyle,
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, bsClassName)
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(dialogClassName, dialogClasses) },
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'content'), role: 'document' },
          children
        )
      )
    );
  };

  return ModalDialog;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ModalDialog.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('modal', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["b" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["b" /* Size */].SMALL], ModalDialog)));

/***/ }),
/* 1368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Dropdown__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_splitComponentProps__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__ = __webpack_require__(46);













var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].propTypes, {

  // Toggle props.
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node.isRequired,
  noCaret: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  // Override generated docs from <Dropdown>.
  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
});

var NavDropdown = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(NavDropdown, _React$Component);

  function NavDropdown() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, NavDropdown);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavDropdown.prototype.isActive = function isActive(_ref, activeKey, activeHref) {
    var props = _ref.props;

    var _this2 = this;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    if (__WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].some(props.children, function (child) {
      return _this2.isActive(child, activeKey, activeHref);
    })) {
      return true;
    }

    return props.active;
  };

  NavDropdown.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        title = _props.title,
        activeKey = _props.activeKey,
        activeHref = _props.activeHref,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['title', 'activeKey', 'activeHref', 'className', 'style', 'children']);

    var active = this.isActive(this, activeKey, activeHref);
    delete props.active; // Accessed via this.isActive().
    delete props.eventKey; // Accessed via this.isActive().

    var _splitComponentProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1];

    // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
    // rather than the `<Dropdown.Toggle>`.

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, dropdownProps, {
        componentClass: 'li',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, { active: active }),
        style: style
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].Toggle,
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, toggleProps, { useAnchor: true }),
        title
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].Menu,
        null,
        __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(child, {
            active: _this3.isActive(child, activeKey, activeHref)
          });
        })
      )
    );
  };

  return NavDropdown;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavDropdown.propTypes = propTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavDropdown);

/***/ }),
/* 1369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_uncontrollable__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Grid__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NavbarBrand__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__NavbarCollapse__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__NavbarHeader__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__NavbarToggle__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_createChainedFunction__ = __webpack_require__(41);





// TODO: Remove this pragma once we upgrade eslint-config-airbnb.
/* eslint-disable react/no-multi-comp */
















var propTypes = {
  /**
   * Create a fixed navbar along the top of the screen, that scrolls with the
   * page
   */
  fixedTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Create a fixed navbar along the bottom of the screen, that scrolls with
   * the page
   */
  fixedBottom: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Create a full-width navbar that scrolls away with the page
   */
  staticTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * An alternative dark visual style for the Navbar
   */
  inverse: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Allow the Navbar to fluidly adjust to the page or container width, instead
   * of at the predefined screen breakpoints
   */
  fluid: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Set a custom element for this component.
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,
  /**
   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
   * a `<Navbar.Toggle>` is clicked and called with the new `expanded`
   * boolean value.
   *
   * @controllable expanded
   */
  onToggle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * A callback fired when a descendant of a child `<Nav>` is selected. Should
   * be used to execute complex closing or other miscellaneous actions desired
   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
   * descendants exist. The callback is called with an eventKey, which is a
   * prop from the selected `<Nav>` descendant, and an event.
   *
   * ```js
   * function (
   *  Any eventKey,
   *  SyntheticEvent event?
   * )
   * ```
   *
   * For basic closing behavior after all `<Nav>` descendant onSelect events in
   * mobile viewports, try using collapseOnSelect.
   *
   * Note: If you are manually closing the navbar using this `OnSelect` prop,
   * ensure that you are setting `expanded` to false and not *toggling* between
   * true and false.
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * Sets `expanded` to `false` after the onSelect event of a descendant of a
   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
   *
   * The onSelect callback should be used instead for more complex operations
   * that need to be executed after the `select` event of `<Nav>` descendants.
   */
  collapseOnSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * Explicitly set the visiblity of the navbar body
   *
   * @controllable onToggle
   */
  expanded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  role: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};

var defaultProps = {
  componentClass: 'nav',
  fixedTop: false,
  fixedBottom: false,
  staticTop: false,
  inverse: false,
  fluid: false,
  collapseOnSelect: false
};

var childContextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    onToggle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
    onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
  })
};

var Navbar = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Navbar, _React$Component);

  function Navbar(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Navbar);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleToggle = _this.handleToggle.bind(_this);
    _this.handleCollapse = _this.handleCollapse.bind(_this);
    return _this;
  }

  Navbar.prototype.getChildContext = function getChildContext() {
    var _props = this.props,
        bsClass = _props.bsClass,
        expanded = _props.expanded,
        onSelect = _props.onSelect,
        collapseOnSelect = _props.collapseOnSelect;


    return {
      $bs_navbar: {
        bsClass: bsClass,
        expanded: expanded,
        onToggle: this.handleToggle,
        onSelect: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__utils_createChainedFunction__["a" /* default */])(onSelect, collapseOnSelect ? this.handleCollapse : null)
      }
    };
  };

  Navbar.prototype.handleCollapse = function handleCollapse() {
    var _props2 = this.props,
        onToggle = _props2.onToggle,
        expanded = _props2.expanded;


    if (expanded) {
      onToggle(false);
    }
  };

  Navbar.prototype.handleToggle = function handleToggle() {
    var _props3 = this.props,
        onToggle = _props3.onToggle,
        expanded = _props3.expanded;


    onToggle(!expanded);
  };

  Navbar.prototype.render = function render() {
    var _extends2;

    var _props4 = this.props,
        Component = _props4.componentClass,
        fixedTop = _props4.fixedTop,
        fixedBottom = _props4.fixedBottom,
        staticTop = _props4.staticTop,
        inverse = _props4.inverse,
        fluid = _props4.fluid,
        className = _props4.className,
        children = _props4.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props4, ['componentClass', 'fixedTop', 'fixedBottom', 'staticTop', 'inverse', 'fluid', 'className', 'children']);

    var _splitBsPropsAndOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one


    if (elementProps.role === undefined && Component !== 'nav') {
      elementProps.role = 'navigation';
    }

    if (inverse) {
      bsProps.bsStyle = __WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__["d" /* Style */].INVERSE;
    }

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'fixed-top')] = fixedTop, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'static-top')] = staticTop, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__Grid__["a" /* default */],
        { fluid: fluid },
        children
      )
    );
  };

  return Navbar;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Navbar.propTypes = propTypes;
Navbar.defaultProps = defaultProps;
Navbar.childContextTypes = childContextTypes;

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["c" /* bsClass */])('navbar', Navbar);

var UncontrollableNavbar = __WEBPACK_IMPORTED_MODULE_9_uncontrollable___default()(Navbar, { expanded: 'onToggle' });

function createSimpleWrapper(tag, suffix, displayName) {
  var Wrapper = function Wrapper(_ref, _ref2) {
    var _ref2$$bs_navbar = _ref2.$bs_navbar,
        navbarProps = _ref2$$bs_navbar === undefined ? { bsClass: 'navbar' } : _ref2$$bs_navbar;

    var Component = _ref.componentClass,
        className = _ref.className,
        pullRight = _ref.pullRight,
        pullLeft = _ref.pullLeft,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['componentClass', 'className', 'pullRight', 'pullLeft']);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, suffix), pullRight && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'right'), pullLeft && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'left'))
    }));
  };

  Wrapper.displayName = displayName;

  Wrapper.propTypes = {
    componentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a,
    pullRight: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    pullLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
  };

  Wrapper.defaultProps = {
    componentClass: tag,
    pullRight: false,
    pullLeft: false
  };

  Wrapper.contextTypes = {
    $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
      bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
    })
  };

  return Wrapper;
}

UncontrollableNavbar.Brand = __WEBPACK_IMPORTED_MODULE_11__NavbarBrand__["a" /* default */];
UncontrollableNavbar.Header = __WEBPACK_IMPORTED_MODULE_13__NavbarHeader__["a" /* default */];
UncontrollableNavbar.Toggle = __WEBPACK_IMPORTED_MODULE_14__NavbarToggle__["a" /* default */];
UncontrollableNavbar.Collapse = __WEBPACK_IMPORTED_MODULE_12__NavbarCollapse__["a" /* default */];

UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink');

// Set bsStyles here so they can be overridden.
/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__utils_bootstrapUtils__["f" /* bsStyles */])([__WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__["d" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__["d" /* Style */].INVERSE], __WEBPACK_IMPORTED_MODULE_16__utils_StyleConfig__["d" /* Style */].DEFAULT, UncontrollableNavbar));

/***/ }),
/* 1370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Collapse__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(20);











var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
  })
};

var NavbarCollapse = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavbarCollapse, _React$Component);

  function NavbarCollapse() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavbarCollapse);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavbarCollapse.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['children']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var bsClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'collapse');

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7__Collapse__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ 'in': navbarProps.expanded }, props),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: bsClassName },
        children
      )
    );
  };

  return NavbarCollapse;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

NavbarCollapse.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavbarCollapse);

/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(20);











var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
  })
};

var NavbarHeader = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavbarHeader, _React$Component);

  function NavbarHeader() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavbarHeader);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavbarHeader.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var bsClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'header');

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, bsClassName) }));
  };

  return NavbarHeader;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavbarHeader.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavbarHeader);

/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(41);












var propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * The toggle content, if left empty it will render the default toggle (seen above).
   */
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};

var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
    onToggle: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired
  })
};

var NavbarToggle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(NavbarToggle, _React$Component);

  function NavbarToggle() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, NavbarToggle);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  NavbarToggle.prototype.render = function render() {
    var _props = this.props,
        onClick = _props.onClick,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onClick', 'className', 'children']);

    var navbarProps = this.context.$bs_navbar || { bsClass: 'navbar' };

    var buttonProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      type: 'button'
    }, props, {
      onClick: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(onClick, navbarProps.onToggle),
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
    });

    if (children) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'button',
        buttonProps,
        children
      );
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'button',
      buttonProps,
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        'Toggle navigation'
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { className: 'icon-bar' }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { className: 'icon-bar' }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('span', { className: 'icon-bar' })
    );
  };

  return NavbarToggle;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

NavbarToggle.propTypes = propTypes;
NavbarToggle.contextTypes = contextTypes;

/* harmony default export */ __webpack_exports__["a"] = (NavbarToggle);

/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Overlay__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(41);















/**
 * Check if value one is inside or equal to the of value
 *
 * @param {string} one
 * @param {string|array} of
 * @returns {boolean}
 */
function isOneOf(one, of) {
  if (Array.isArray(of)) {
    return of.indexOf(one) >= 0;
  }
  return one === of;
}

var triggerType = __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['click', 'hover', 'focus']);

var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_10__Overlay__["a" /* default */].propTypes, {

  /**
   * Specify which action or actions trigger Overlay visibility
   */
  trigger: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([triggerType, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(triggerType)]),

  /**
   * A millisecond delay amount to show and hide the Overlay once triggered
   */
  delay: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * A millisecond delay amount before showing the Overlay once triggered.
   */
  delayShow: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  /**
   * A millisecond delay amount before hiding the Overlay once triggered.
   */
  delayHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,

  // FIXME: This should be `defaultShow`.
  /**
   * The initial visibility state of the Overlay. For more nuanced visibility
   * control, consider using the Overlay component directly.
   */
  defaultOverlayShown: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * An element or text to overlay next to the target.
   */
  overlay: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node.isRequired,

  /**
   * @private
   */
  onBlur: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * @private
   */
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * @private
   */
  onFocus: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * @private
   */
  onMouseOut: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * @private
   */
  onMouseOver: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  // Overridden props from `<Overlay>`.
  /**
   * @private
   */
  target: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null]),
  /**
   * @private
   */
  onHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null]),
  /**
   * @private
   */
  show: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null])
});

var defaultProps = {
  defaultOverlayShown: false,
  trigger: ['hover', 'focus']
};

var OverlayTrigger = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(OverlayTrigger, _React$Component);

  function OverlayTrigger(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, OverlayTrigger);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleToggle = _this.handleToggle.bind(_this);
    _this.handleDelayedShow = _this.handleDelayedShow.bind(_this);
    _this.handleDelayedHide = _this.handleDelayedHide.bind(_this);
    _this.handleHide = _this.handleHide.bind(_this);

    _this.handleMouseOver = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedShow, e);
    };
    _this.handleMouseOut = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedHide, e);
    };

    _this._mountNode = null;

    _this.state = {
      show: props.defaultOverlayShown
    };
    return _this;
  }

  OverlayTrigger.prototype.componentDidMount = function componentDidMount() {
    this._mountNode = document.createElement('div');
    this.renderOverlay();
  };

  OverlayTrigger.prototype.componentDidUpdate = function componentDidUpdate() {
    this.renderOverlay();
  };

  OverlayTrigger.prototype.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.unmountComponentAtNode(this._mountNode);
    this._mountNode = null;

    clearTimeout(this._hoverShowDelay);
    clearTimeout(this._hoverHideDelay);
  };

  OverlayTrigger.prototype.handleDelayedHide = function handleDelayedHide() {
    var _this2 = this;

    if (this._hoverShowDelay != null) {
      clearTimeout(this._hoverShowDelay);
      this._hoverShowDelay = null;
      return;
    }

    if (!this.state.show || this._hoverHideDelay != null) {
      return;
    }

    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;

    if (!delay) {
      this.hide();
      return;
    }

    this._hoverHideDelay = setTimeout(function () {
      _this2._hoverHideDelay = null;
      _this2.hide();
    }, delay);
  };

  OverlayTrigger.prototype.handleDelayedShow = function handleDelayedShow() {
    var _this3 = this;

    if (this._hoverHideDelay != null) {
      clearTimeout(this._hoverHideDelay);
      this._hoverHideDelay = null;
      return;
    }

    if (this.state.show || this._hoverShowDelay != null) {
      return;
    }

    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;

    if (!delay) {
      this.show();
      return;
    }

    this._hoverShowDelay = setTimeout(function () {
      _this3._hoverShowDelay = null;
      _this3.show();
    }, delay);
  };

  OverlayTrigger.prototype.handleHide = function handleHide() {
    this.hide();
  };

  // Simple implementation of mouseEnter and mouseLeave.
  // React's built version is broken: https://github.com/facebook/react/issues/4251
  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
  // moving from one child element to another.


  OverlayTrigger.prototype.handleMouseOverOut = function handleMouseOverOut(handler, e) {
    var target = e.currentTarget;
    var related = e.relatedTarget || e.nativeEvent.toElement;

    if ((!related || related !== target) && !__WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains___default()(target, related)) {
      handler(e);
    }
  };

  OverlayTrigger.prototype.handleToggle = function handleToggle() {
    if (this.state.show) {
      this.hide();
    } else {
      this.show();
    }
  };

  OverlayTrigger.prototype.hide = function hide() {
    this.setState({ show: false });
  };

  OverlayTrigger.prototype.makeOverlay = function makeOverlay(overlay, props) {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10__Overlay__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, props, {
        show: this.state.show,
        onHide: this.handleHide,
        target: this
      }),
      overlay
    );
  };

  OverlayTrigger.prototype.show = function show() {
    this.setState({ show: true });
  };

  OverlayTrigger.prototype.renderOverlay = function renderOverlay() {
    __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
  };

  OverlayTrigger.prototype.render = function render() {
    var _props = this.props,
        trigger = _props.trigger,
        overlay = _props.overlay,
        children = _props.children,
        onBlur = _props.onBlur,
        onClick = _props.onClick,
        onFocus = _props.onFocus,
        onMouseOut = _props.onMouseOut,
        onMouseOver = _props.onMouseOver,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['trigger', 'overlay', 'children', 'onBlur', 'onClick', 'onFocus', 'onMouseOut', 'onMouseOver']);

    delete props.delay;
    delete props.delayShow;
    delete props.delayHide;
    delete props.defaultOverlayShown;

    var child = __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.only(children);
    var childProps = child.props;
    var triggerProps = {};

    if (this.state.show) {
      triggerProps['aria-describedby'] = overlay.props.id;
    }

    // FIXME: The logic here for passing through handlers on this component is
    // inconsistent. We shouldn't be passing any of these props through.

    triggerProps.onClick = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onClick, onClick);

    if (isOneOf('click', trigger)) {
      triggerProps.onClick = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(triggerProps.onClick, this.handleToggle);
    }

    if (isOneOf('hover', trigger)) {
       false ? warning(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;

      triggerProps.onMouseOver = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
      triggerProps.onMouseOut = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
    }

    if (isOneOf('focus', trigger)) {
      triggerProps.onFocus = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onFocus, onFocus, this.handleDelayedShow);
      triggerProps.onBlur = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onBlur, onBlur, this.handleDelayedHide);
    }

    this._overlay = this.makeOverlay(overlay, props);

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, triggerProps);
  };

  return OverlayTrigger;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

OverlayTrigger.propTypes = propTypes;
OverlayTrigger.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (OverlayTrigger);

/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(20);










var PageHeader = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(PageHeader, _React$Component);

  function PageHeader() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PageHeader);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  PageHeader.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'h1',
        null,
        children
      )
    );
  };

  return PageHeader;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsClass */])('page-header', PageHeader));

/***/ }),
/* 1375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PagerItem__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_deprecationWarning__ = __webpack_require__(1395);



/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_1__utils_deprecationWarning__["a" /* default */].wrapper(__WEBPACK_IMPORTED_MODULE_0__PagerItem__["a" /* default */], '`<PageItem>`', '`<Pager.Item>`'));

/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PagerItem__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__ = __webpack_require__(46);














var propTypes = {
  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var Pager = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Pager, _React$Component);

  function Pager() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Pager);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Pager.prototype.render = function render() {
    var _props = this.props,
        onSelect = _props.onSelect,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['onSelect', 'className', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'ul',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, {
          onSelect: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect)
        });
      })
    );
  };

  return Pager;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Pager.propTypes = propTypes;

Pager.Item = __WEBPACK_IMPORTED_MODULE_8__PagerItem__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('pager', Pager));

/***/ }),
/* 1377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PaginationButton__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(20);













var propTypes = {
  activePage: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  items: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  maxButtons: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,

  /**
   * When `true`, will display the first and the last button page when
   * displaying ellipsis.
   */
  boundaryLinks: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * When `true`, will display the default node value ('&hellip;').
   * Otherwise, will display provided node (when specified).
   */
  ellipsis: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node]),

  /**
   * When `true`, will display the default node value ('&laquo;').
   * Otherwise, will display provided node (when specified).
   */
  first: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node]),

  /**
   * When `true`, will display the default node value ('&raquo;').
   * Otherwise, will display provided node (when specified).
   */
  last: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node]),

  /**
   * When `true`, will display the default node value ('&lsaquo;').
   * Otherwise, will display provided node (when specified).
   */
  prev: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node]),

  /**
   * When `true`, will display the default node value ('&rsaquo;').
   * Otherwise, will display provided node (when specified).
   */
  next: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node]),

  onSelect: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * You can use a custom element for the buttons
   */
  buttonComponentClass: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  activePage: 1,
  items: 1,
  maxButtons: 0,
  first: false,
  last: false,
  prev: false,
  next: false,
  ellipsis: true,
  boundaryLinks: false
};

var Pagination = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Pagination, _React$Component);

  function Pagination() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Pagination);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Pagination.prototype.renderPageButtons = function renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps) {
    var pageButtons = [];

    var startPage = void 0;
    var endPage = void 0;

    if (maxButtons && maxButtons < items) {
      startPage = Math.max(Math.min(activePage - Math.floor(maxButtons / 2, 10), items - maxButtons + 1), 1);
      endPage = startPage + maxButtons - 1;
    } else {
      startPage = 1;
      endPage = items;
    }

    for (var page = startPage; page <= endPage; ++page) {
      pageButtons.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
          key: page,
          eventKey: page,
          active: page === activePage
        }),
        page
      ));
    }

    if (ellipsis && boundaryLinks && startPage > 1) {
      if (startPage > 2) {
        pageButtons.unshift(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
          {
            key: 'ellipsisFirst',
            disabled: true,
            componentClass: buttonProps.componentClass
          },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'span',
            { 'aria-label': 'More' },
            ellipsis === true ? '\u2026' : ellipsis
          )
        ));
      }

      pageButtons.unshift(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
          key: 1,
          eventKey: 1,
          active: false
        }),
        '1'
      ));
    }

    if (ellipsis && endPage < items) {
      if (!boundaryLinks || endPage < items - 1) {
        pageButtons.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
          {
            key: 'ellipsis',
            disabled: true,
            componentClass: buttonProps.componentClass
          },
          __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            'span',
            { 'aria-label': 'More' },
            ellipsis === true ? '\u2026' : ellipsis
          )
        ));
      }

      if (boundaryLinks) {
        pageButtons.push(__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
            key: items,
            eventKey: items,
            active: false
          }),
          items
        ));
      }
    }

    return pageButtons;
  };

  Pagination.prototype.render = function render() {
    var _props = this.props,
        activePage = _props.activePage,
        items = _props.items,
        maxButtons = _props.maxButtons,
        boundaryLinks = _props.boundaryLinks,
        ellipsis = _props.ellipsis,
        first = _props.first,
        last = _props.last,
        prev = _props.prev,
        next = _props.next,
        onSelect = _props.onSelect,
        buttonComponentClass = _props.buttonComponentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['activePage', 'items', 'maxButtons', 'boundaryLinks', 'ellipsis', 'first', 'last', 'prev', 'next', 'onSelect', 'buttonComponentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    var buttonProps = {
      onSelect: onSelect,
      componentClass: buttonComponentClass
    };

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'ul',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      first && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
          eventKey: 1,
          disabled: activePage === 1
        }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'span',
          { 'aria-label': 'First' },
          first === true ? '\xAB' : first
        )
      ),
      prev && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
          eventKey: activePage - 1,
          disabled: activePage === 1
        }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'span',
          { 'aria-label': 'Previous' },
          prev === true ? '\u2039' : prev
        )
      ),
      this.renderPageButtons(activePage, items, maxButtons, boundaryLinks, ellipsis, buttonProps),
      next && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
          eventKey: activePage + 1,
          disabled: activePage >= items
        }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'span',
          { 'aria-label': 'Next' },
          next === true ? '\u203A' : next
        )
      ),
      last && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_9__PaginationButton__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, buttonProps, {
          eventKey: items,
          disabled: activePage >= items
        }),
        __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'span',
          { 'aria-label': 'Last' },
          last === true ? '\xBB' : last
        )
      )
    );
  };

  return Pagination;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Pagination.propTypes = propTypes;
Pagination.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["c" /* bsClass */])('pagination', Pagination));

/***/ }),
/* 1378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Collapse__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__ = __webpack_require__(42);














// TODO: Use uncontrollable.

var propTypes = {
  collapsible: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  header: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  id: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number]),
  footer: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  defaultExpanded: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  expanded: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  eventKey: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.any,
  headerRole: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  panelRole: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,

  // From Collapse.
  onEnter: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onEntering: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onEntered: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onExit: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onExiting: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  onExited: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func
};

var defaultProps = {
  defaultExpanded: false
};

var Panel = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Panel, _React$Component);

  function Panel(props, context) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Panel);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props, context));

    _this.handleClickTitle = _this.handleClickTitle.bind(_this);

    _this.state = {
      expanded: _this.props.defaultExpanded
    };
    return _this;
  }

  Panel.prototype.handleClickTitle = function handleClickTitle(e) {
    // FIXME: What the heck? This API is horrible. This needs to go away!
    e.persist();
    e.selected = true;

    if (this.props.onSelect) {
      this.props.onSelect(this.props.eventKey, e);
    } else {
      e.preventDefault();
    }

    if (e.selected) {
      this.setState({ expanded: !this.state.expanded });
    }
  };

  Panel.prototype.renderAnchor = function renderAnchor(header, id, role, expanded) {
    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'a',
      {
        role: role,
        href: id && '#' + id,
        onClick: this.handleClickTitle,
        'aria-controls': id,
        'aria-expanded': expanded,
        'aria-selected': expanded,
        className: expanded ? null : 'collapsed'
      },
      header
    );
  };

  Panel.prototype.renderBody = function renderBody(rawChildren, bsProps) {
    var children = [];
    var bodyChildren = [];

    var bodyClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'body');

    function maybeAddBody() {
      if (!bodyChildren.length) {
        return;
      }

      // Derive the key from the index here, since we need to make one up.
      children.push(__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { key: children.length, className: bodyClassName },
        bodyChildren
      ));

      bodyChildren = [];
    }

    // Convert to array so we can re-use keys.
    __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.toArray(rawChildren).forEach(function (child) {
      if (__WEBPACK_IMPORTED_MODULE_7_react___default.a.isValidElement(child) && child.props.fill) {
        maybeAddBody();

        // Remove the child's unknown `fill` prop.
        children.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(child, { fill: undefined }));

        return;
      }

      bodyChildren.push(child);
    });

    maybeAddBody();

    return children;
  };

  Panel.prototype.renderCollapsibleBody = function renderCollapsibleBody(id, expanded, role, children, bsProps, animationHooks) {
    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_9__Collapse__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({ 'in': expanded }, animationHooks),
      __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        {
          id: id,
          role: role,
          className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'collapse'),
          'aria-hidden': !expanded
        },
        this.renderBody(children, bsProps)
      )
    );
  };

  Panel.prototype.renderHeader = function renderHeader(collapsible, header, id, role, expanded, bsProps) {
    var titleClassName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'title');

    if (!collapsible) {
      if (!__WEBPACK_IMPORTED_MODULE_7_react___default.a.isValidElement(header)) {
        return header;
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(header, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(header.props.className, titleClassName)
      });
    }

    if (!__WEBPACK_IMPORTED_MODULE_7_react___default.a.isValidElement(header)) {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'h4',
        { role: 'presentation', className: titleClassName },
        this.renderAnchor(header, id, role, expanded)
      );
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(header, {
      className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(header.props.className, titleClassName),
      children: this.renderAnchor(header.props.children, id, role, expanded)
    });
  };

  Panel.prototype.render = function render() {
    var _props = this.props,
        collapsible = _props.collapsible,
        header = _props.header,
        id = _props.id,
        footer = _props.footer,
        propsExpanded = _props.expanded,
        headerRole = _props.headerRole,
        panelRole = _props.panelRole,
        className = _props.className,
        children = _props.children,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        onExited = _props.onExited,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['collapsible', 'header', 'id', 'footer', 'expanded', 'headerRole', 'panelRole', 'className', 'children', 'onEnter', 'onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited']);

    var _splitBsPropsAndOmit = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['defaultExpanded', 'eventKey', 'onSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var expanded = propsExpanded != null ? propsExpanded : this.state.expanded;

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes),
        id: collapsible ? null : id
      }),
      header && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'heading') },
        this.renderHeader(collapsible, header, id, headerRole, expanded, bsProps)
      ),
      collapsible ? this.renderCollapsibleBody(id, expanded, panelRole, children, bsProps, { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited }) : this.renderBody(children, bsProps),
      footer && __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'footer') },
        footer
      )
    );
  };

  return Panel;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Panel.propTypes = propTypes;
Panel.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["c" /* bsClass */])('panel', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["f" /* bsStyles */])([].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["c" /* State */]), [__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["d" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["d" /* Style */].PRIMARY]), __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["d" /* Style */].DEFAULT, Panel)));

/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(20);












var propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number])),

  /**
   * Sets the direction the Popover is positioned towards.
   */
  placement: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Popover.
   */
  positionTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),
  /**
   * The "left" position value for the Popover.
   */
  positionLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),

  /**
   * The "top" position value for the Popover arrow.
   */
  arrowOffsetTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),
  /**
   * The "left" position value for the Popover arrow.
   */
  arrowOffsetLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),

  /**
   * Title content
   */
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};

var defaultProps = {
  placement: 'right'
};

var Popover = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Popover, _React$Component);

  function Popover() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Popover);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Popover.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        placement = _props.placement,
        positionTop = _props.positionTop,
        positionLeft = _props.positionLeft,
        arrowOffsetTop = _props.arrowOffsetTop,
        arrowOffsetLeft = _props.arrowOffsetLeft,
        title = _props.title,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'title', 'className', 'style', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));

    var outerStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      display: 'block',
      top: positionTop,
      left: positionLeft
    }, style);

    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'tooltip',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes),
        style: outerStyle
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: 'arrow', style: arrowStyle }),
      title && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'h3',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'title') },
        title
      ),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'content') },
        children
      )
    );
  };

  return Popover;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Popover.propTypes = propTypes;
Popover.defaultProps = defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('popover', Popover));

/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__ = __webpack_require__(46);














var ROUND_PRECISION = 1000;

/**
 * Validate that children, if any, are instances of `<ProgressBar>`.
 */
function onlyProgressBar(props, propName, componentName) {
  var children = props[propName];
  if (!children) {
    return null;
  }

  var error = null;

  __WEBPACK_IMPORTED_MODULE_7_react___default.a.Children.forEach(children, function (child) {
    if (error) {
      return;
    }

    if (child.type === ProgressBar) {
      // eslint-disable-line no-use-before-define
      return;
    }

    var childIdentifier = __WEBPACK_IMPORTED_MODULE_7_react___default.a.isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
    error = new Error('Children of ' + componentName + ' can contain only ProgressBar ' + ('components. Found ' + childIdentifier + '.'));
  });

  return error;
}

var propTypes = {
  min: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  now: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  label: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.node,
  srOnly: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  children: onlyProgressBar,

  /**
   * @private
   */
  isChild: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool
};

var defaultProps = {
  min: 0,
  max: 100,
  active: false,
  isChild: false,
  srOnly: false,
  striped: false
};

function getPercentage(now, min, max) {
  var percentage = (now - min) / (max - min) * 100;
  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
}

var ProgressBar = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ProgressBar, _React$Component);

  function ProgressBar() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ProgressBar);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ProgressBar.prototype.renderProgressBar = function renderProgressBar(_ref) {
    var _extends2;

    var min = _ref.min,
        now = _ref.now,
        max = _ref.max,
        label = _ref.label,
        srOnly = _ref.srOnly,
        striped = _ref.striped,
        active = _ref.active,
        className = _ref.className,
        style = _ref.style,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'className', 'style']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), (_extends2 = {
      active: active
    }, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'striped')] = active || striped, _extends2));

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'progressbar',
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, classes),
        style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ width: getPercentage(now, min, max) + '%' }, style),
        'aria-valuenow': now,
        'aria-valuemin': min,
        'aria-valuemax': max
      }),
      srOnly ? __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'span',
        { className: 'sr-only' },
        label
      ) : label
    );
  };

  ProgressBar.prototype.render = function render() {
    var _props = this.props,
        isChild = _props.isChild,
        props = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['isChild']);

    if (isChild) {
      return this.renderProgressBar(props);
    }

    var min = props.min,
        now = props.now,
        max = props.max,
        label = props.label,
        srOnly = props.srOnly,
        striped = props.striped,
        active = props.active,
        bsClass = props.bsClass,
        bsStyle = props.bsStyle,
        className = props.className,
        children = props.children,
        wrapperProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(props, ['min', 'now', 'max', 'label', 'srOnly', 'striped', 'active', 'bsClass', 'bsStyle', 'className', 'children']);

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, wrapperProps, {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()(className, 'progress')
      }),
      children ? __WEBPACK_IMPORTED_MODULE_11__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["cloneElement"])(child, { isChild: true });
      }) : this.renderProgressBar({
        min: min, now: now, max: max, label: label, srOnly: srOnly, striped: striped, active: active, bsClass: bsClass, bsStyle: bsStyle
      })
    );
  };

  return ProgressBar;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

ProgressBar.propTypes = propTypes;
ProgressBar.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('progress-bar', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["f" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["c" /* State */]), ProgressBar)));

/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(20);





/* eslint-disable jsx-a11y/label-has-for */








var propTypes = {
  inline: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * Only valid if `inline` is not set.
   */
  validationState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['success', 'warning', 'error', null]),
  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <Radio inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var defaultProps = {
  inline: false,
  disabled: false,
  title: ''
};

var Radio = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Radio, _React$Component);

  function Radio() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Radio);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Radio.prototype.render = function render() {
    var _props = this.props,
        inline = _props.inline,
        disabled = _props.disabled,
        validationState = _props.validationState,
        inputRef = _props.inputRef,
        className = _props.className,
        style = _props.style,
        title = _props.title,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['inline', 'disabled', 'validationState', 'inputRef', 'className', 'style', 'title', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var input = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('input', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      ref: inputRef,
      type: 'radio',
      disabled: disabled
    }));

    if (inline) {
      var _classes2;

      var _classes = (_classes2 = {}, _classes2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2);

      // Use a warning here instead of in propTypes to get better-looking
      // generated documentation.
       false ? warning(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'label',
        { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, _classes), style: style, title: title },
        input,
        children
      );
    }

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), {
      disabled: disabled
    });
    if (validationState) {
      classes['has-' + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes), style: style },
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'label',
        { title: title },
        input,
        children
      )
    );
  };

  return Radio;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Radio.propTypes = propTypes;
Radio.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('radio', Radio));

/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(20);












// TODO: This should probably take a single `aspectRatio` prop.

var propTypes = {
  /**
   * This component requires a single child element
   */
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.element.isRequired,
  /**
   * 16by9 aspect ratio
   */
  a16by9: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  /**
   * 4by3 aspect ratio
   */
  a4by3: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  a16by9: false,
  a4by3: false
};

var ResponsiveEmbed = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ResponsiveEmbed, _React$Component);

  function ResponsiveEmbed() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ResponsiveEmbed);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ResponsiveEmbed.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        a16by9 = _props.a16by9,
        a4by3 = _props.a4by3,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['a16by9', 'a4by3', 'className', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
     false ? warning(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, '16by9')] = a16by9, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, '4by3')] = a4by3, _extends2));

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(classes) },
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(children, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'item'))
      }))
    );
  };

  return ResponsiveEmbed;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ResponsiveEmbed.propTypes = propTypes;
ResponsiveEmbed.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('embed-responsive', ResponsiveEmbed));

/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(20);











var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a
};

var defaultProps = {
  componentClass: 'div'
};

var Row = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Row, _React$Component);

  function Row() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Row);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Row.prototype.render = function render() {
    var _props = this.props,
        Component = _props.componentClass,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['componentClass', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Row;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Row.propTypes = propTypes;
Row.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('row', Row));

/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Button__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Dropdown__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SplitToggle__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_splitComponentProps__ = __webpack_require__(215);













var propTypes = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].propTypes, {

  // Toggle props.
  bsStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  /**
   * The content of the split button.
   */
  title: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node.isRequired,
  /**
   * Accessible label for the toggle; the value of `title` if not specified.
   */
  toggleLabel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  // Override generated docs from <Dropdown>.
  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node
});

var SplitButton = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SplitButton, _React$Component);

  function SplitButton() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SplitButton);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  SplitButton.prototype.render = function render() {
    var _props = this.props,
        bsSize = _props.bsSize,
        bsStyle = _props.bsStyle,
        title = _props.title,
        toggleLabel = _props.toggleLabel,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['bsSize', 'bsStyle', 'title', 'toggleLabel', 'children']);

    var _splitComponentProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        buttonProps = _splitComponentProps[1];

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, dropdownProps, {
        bsSize: bsSize,
        bsStyle: bsStyle
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7__Button__["a" /* default */],
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, buttonProps, {
          disabled: props.disabled,
          bsSize: bsSize,
          bsStyle: bsStyle
        }),
        title
      ),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__SplitToggle__["a" /* default */], {
        'aria-label': toggleLabel || title,
        bsSize: bsSize,
        bsStyle: bsStyle
      }),
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8__Dropdown__["a" /* default */].Menu,
        null,
        children
      )
    );
  };

  return SplitButton;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

SplitButton.propTypes = propTypes;

SplitButton.Toggle = __WEBPACK_IMPORTED_MODULE_9__SplitToggle__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (SplitButton);

/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DropdownToggle__ = __webpack_require__(573);








var SplitToggle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(SplitToggle, _React$Component);

  function SplitToggle() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SplitToggle);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  SplitToggle.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DropdownToggle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, {
      useAnchor: false,
      noCaret: false
    }));
  };

  return SplitToggle;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

SplitToggle.defaultProps = __WEBPACK_IMPORTED_MODULE_5__DropdownToggle__["a" /* default */].defaultProps;

/* harmony default export */ __webpack_exports__["a"] = (SplitToggle);

/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TabContainer__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TabContent__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TabPane__ = __webpack_require__(587);











var propTypes = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_8__TabPane__["a" /* default */].propTypes, {

  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,

  /**
   * tabClassName is used as className for the associated NavItem
   */
  tabClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
});

var Tab = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Tab, _React$Component);

  function Tab() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Tab);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Tab.prototype.render = function render() {
    var props = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.props);

    // These props are for the parent `<Tabs>` rather than the `<TabPane>`.
    delete props.title;
    delete props.disabled;
    delete props.tabClassName;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TabPane__["a" /* default */], props);
  };

  return Tab;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Tab.propTypes = propTypes;

Tab.Container = __WEBPACK_IMPORTED_MODULE_6__TabContainer__["a" /* default */];
Tab.Content = __WEBPACK_IMPORTED_MODULE_7__TabContent__["a" /* default */];
Tab.Pane = __WEBPACK_IMPORTED_MODULE_8__TabPane__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Tab);

/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(20);











var propTypes = {
  striped: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  bordered: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  condensed: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  hover: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  responsive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool
};

var defaultProps = {
  bordered: false,
  condensed: false,
  hover: false,
  responsive: false,
  striped: false
};

var Table = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Table, _React$Component);

  function Table() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Table);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Table.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        striped = _props.striped,
        bordered = _props.bordered,
        condensed = _props.condensed,
        hover = _props.hover,
        responsive = _props.responsive,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['striped', 'bordered', 'condensed', 'hover', 'responsive', 'className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'striped')] = striped, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'bordered')] = bordered, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'condensed')] = condensed, _extends2[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'hover')] = hover, _extends2));

    var table = __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('table', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));

    if (responsive) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'responsive') },
        table
      );
    }

    return table;
  };

  return Table;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Table.propTypes = propTypes;
Table.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsClass */])('table', Table));

/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Nav__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NavItem__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TabContainer__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TabContent__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_bootstrapUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__ = __webpack_require__(46);

















var TabContainer = __WEBPACK_IMPORTED_MODULE_11__TabContainer__["a" /* default */].ControlledComponent;

var propTypes = {
  /**
   * Mark the Tab with a matching `eventKey` as active.
   *
   * @controllable onSelect
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,

  /**
   * Navigation style
   */
  bsStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['tabs', 'pills']),

  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  id: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number])),

  /**
   * Callback fired when a Tab is selected.
   *
   * ```js
   * function (
   *   Any eventKey,
   *   SyntheticEvent event?
   * )
   * ```
   *
   * @controllable activeKey
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Unmount tabs (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};

var defaultProps = {
  bsStyle: 'tabs',
  animation: true,
  mountOnEnter: false,
  unmountOnExit: false
};

function getDefaultActiveKey(children) {
  var defaultActiveKey = void 0;
  __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].forEach(children, function (child) {
    if (defaultActiveKey == null) {
      defaultActiveKey = child.props.eventKey;
    }
  });

  return defaultActiveKey;
}

var Tabs = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tabs, _React$Component);

  function Tabs() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tabs);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Tabs.prototype.renderTab = function renderTab(child) {
    var _child$props = child.props,
        title = _child$props.title,
        eventKey = _child$props.eventKey,
        disabled = _child$props.disabled,
        tabClassName = _child$props.tabClassName;

    if (title == null) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_10__NavItem__["a" /* default */],
      {
        eventKey: eventKey,
        disabled: disabled,
        className: tabClassName
      },
      title
    );
  };

  Tabs.prototype.render = function render() {
    var _props = this.props,
        id = _props.id,
        onSelect = _props.onSelect,
        animation = _props.animation,
        mountOnEnter = _props.mountOnEnter,
        unmountOnExit = _props.unmountOnExit,
        bsClass = _props.bsClass,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        _props$activeKey = _props.activeKey,
        activeKey = _props$activeKey === undefined ? getDefaultActiveKey(children) : _props$activeKey,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['id', 'onSelect', 'animation', 'mountOnEnter', 'unmountOnExit', 'bsClass', 'className', 'style', 'children', 'activeKey']);

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      TabContainer,
      {
        id: id,
        activeKey: activeKey,
        onSelect: onSelect,
        className: className,
        style: style
      },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__Nav__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
            role: 'tablist'
          }),
          __WEBPACK_IMPORTED_MODULE_14__utils_ValidComponentChildren__["a" /* default */].map(children, this.renderTab)
        ),
        __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_12__TabContent__["a" /* default */],
          {
            bsClass: bsClass,
            animation: animation,
            mountOnEnter: mountOnEnter,
            unmountOnExit: unmountOnExit
          },
          children
        )
      )
    );
  };

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Tabs.propTypes = propTypes;
Tabs.defaultProps = defaultProps;

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_bootstrapUtils__["c" /* bsClass */])('tab', Tabs);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_8_uncontrollable___default()(Tabs, { activeKey: 'onSelect' }));

/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(20);





/* eslint-disable jsx-a11y/alt-text */








var propTypes = {
  /**
   * src property that is passed down to the image inside this component
   */
  src: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * alt property that is passed down to the image inside this component
   */
  alt: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * href property that is passed down to the image inside this component
   */
  href: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  /**
   * onError callback that is passed down to the image inside this component
   */
  onError: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  /**
   * onLoad callback that is passed down to the image inside this component
   */
  onLoad: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func
};

var Thumbnail = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Thumbnail, _React$Component);

  function Thumbnail() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Thumbnail);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Thumbnail.prototype.render = function render() {
    var _props = this.props,
        src = _props.src,
        alt = _props.alt,
        onError = _props.onError,
        onLoad = _props.onLoad,
        className = _props.className,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['src', 'alt', 'onError', 'onLoad', 'className', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var Component = elementProps.href ? __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */] : 'div';
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      Component,
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('img', { src: src, alt: alt, onError: onError, onLoad: onLoad }),
      children && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: 'caption' },
        children
      )
    );
  };

  return Thumbnail;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Thumbnail.propTypes = propTypes;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('thumbnail', Thumbnail));

/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_invariant__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ButtonGroup__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ToggleButton__ = __webpack_require__(588);















var propTypes = {
  /**
   * An HTML `<input>` name for each child button.
   *
   * __Required if `type` is set to `'radio'`__
   */
  name: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * The value, or array of values, of the active (pressed) buttons
   *
   * @controllable onChange
   */
  value: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,

  /**
   * Callback fired when a button is pressed, depending on whether the `type`
   * is `'radio'` or `'checkbox'`, `onChange` will be called with the value or
   * array of active values
   *
   * @controllable values
   */
  onChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * The input `type` of the rendered buttons, determines the toggle behavior
   * of the buttons
   */
  type: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['checkbox', 'radio']).isRequired
};

var defaultProps = {
  type: 'radio'
};

var ToggleButtonGroup = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ToggleButtonGroup, _React$Component);

  function ToggleButtonGroup() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ToggleButtonGroup);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ToggleButtonGroup.prototype.getValues = function getValues() {
    var value = this.props.value;

    return value == null ? [] : [].concat(value);
  };

  ToggleButtonGroup.prototype.handleToggle = function handleToggle(value) {
    var _props = this.props,
        type = _props.type,
        onChange = _props.onChange;

    var values = this.getValues();
    var isActive = values.indexOf(value) !== -1;

    if (type === 'radio') {
      if (!isActive) {
        onChange(value);
      }
      return;
    }

    if (isActive) {
      onChange(values.filter(function (n) {
        return n !== value;
      }));
    } else {
      onChange([].concat(values, [value]));
    }
  };

  ToggleButtonGroup.prototype.render = function render() {
    var _this2 = this;

    var _props2 = this.props,
        children = _props2.children,
        type = _props2.type,
        name = _props2.name,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['children', 'type', 'name']);

    var values = this.getValues();

    !(type !== 'radio' || !!name) ?  false ? invariant(false, 'A `name` is required to group the toggle buttons when the `type` ' + 'is set to "radio"') : __WEBPACK_IMPORTED_MODULE_7_invariant___default()(false) : void 0;

    delete props.onChange;
    delete props.value;

    // the data attribute is required b/c twbs css uses it in the selector
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_11__ButtonGroup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { 'data-toggle': 'buttons' }),
      __WEBPACK_IMPORTED_MODULE_10__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
        var _child$props = child.props,
            value = _child$props.value,
            onChange = _child$props.onChange;

        var handler = function handler() {
          return _this2.handleToggle(value);
        };

        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(child, {
          type: type,
          name: child.name || name,
          checked: values.indexOf(value) !== -1,
          onChange: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(onChange, handler)
        });
      })
    );
  };

  return ToggleButtonGroup;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

ToggleButtonGroup.propTypes = propTypes;
ToggleButtonGroup.defaultProps = defaultProps;

var UncontrolledToggleButtonGroup = __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default()(ToggleButtonGroup, {
  value: 'onChange'
});

UncontrolledToggleButtonGroup.Button = __WEBPACK_IMPORTED_MODULE_12__ToggleButton__["a" /* default */];

/* unused harmony default export */ var _unused_webpack_default_export = (UncontrolledToggleButtonGroup);

/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(20);












var propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string|number}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number])),

  /**
   * Sets the direction the Tooltip is positioned towards.
   */
  placement: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Tooltip.
   */
  positionTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),
  /**
   * The "left" position value for the Tooltip.
   */
  positionLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),

  /**
   * The "top" position value for the Tooltip arrow.
   */
  arrowOffsetTop: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string]),
  /**
   * The "left" position value for the Tooltip arrow.
   */
  arrowOffsetLeft: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string])
};

var defaultProps = {
  placement: 'right'
};

var Tooltip = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tooltip, _React$Component);

  function Tooltip() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tooltip);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Tooltip.prototype.render = function render() {
    var _extends2;

    var _props = this.props,
        placement = _props.placement,
        positionTop = _props.positionTop,
        positionLeft = _props.positionLeft,
        arrowOffsetTop = _props.arrowOffsetTop,
        arrowOffsetLeft = _props.arrowOffsetLeft,
        className = _props.className,
        style = _props.style,
        children = _props.children,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['placement', 'positionTop', 'positionLeft', 'arrowOffsetTop', 'arrowOffsetLeft', 'className', 'style', 'children']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));

    var outerStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
      top: positionTop,
      left: positionLeft
    }, style);

    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
      'div',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
        role: 'tooltip',
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes),
        style: outerStyle
      }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'arrow'), style: arrowStyle }),
      __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        { className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inner') },
        children
      )
    );
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsClass */])('tooltip', Tooltip));

/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__ = __webpack_require__(42);











var Well = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Well, _React$Component);

  function Well() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Well);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Well.prototype.render = function render() {
    var _props = this.props,
        className = _props.className,
        props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['className']);

    var _splitBsProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["b" /* getClassSet */])(bsProps);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes)
    }));
  };

  return Well;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsClass */])('well', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["b" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["b" /* Size */].SMALL], Well)));

/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = requiredRoles;
/* harmony export (immutable) */ __webpack_exports__["b"] = exclusiveRoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types_extra_lib_utils_createChainableTypeChecker__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types_extra_lib_utils_createChainableTypeChecker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types_extra_lib_utils_createChainableTypeChecker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ValidComponentChildren__ = __webpack_require__(46);




function requiredRoles() {
  for (var _len = arguments.length, roles = Array(_len), _key = 0; _key < _len; _key++) {
    roles[_key] = arguments[_key];
  }

  return __WEBPACK_IMPORTED_MODULE_0_prop_types_extra_lib_utils_createChainableTypeChecker___default()(function (props, propName, component) {
    var missing = void 0;

    roles.every(function (role) {
      if (!__WEBPACK_IMPORTED_MODULE_1__ValidComponentChildren__["a" /* default */].some(props.children, function (child) {
        return child.props.bsRole === role;
      })) {
        missing = role;
        return false;
      }

      return true;
    });

    if (missing) {
      return new Error('(children) ' + component + ' - Missing a required child with bsRole: ' + (missing + '. ' + component + ' must have at least one child of each of ') + ('the following bsRoles: ' + roles.join(', ')));
    }

    return null;
  });
}

function exclusiveRoles() {
  for (var _len2 = arguments.length, roles = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    roles[_key2] = arguments[_key2];
  }

  return __WEBPACK_IMPORTED_MODULE_0_prop_types_extra_lib_utils_createChainableTypeChecker___default()(function (props, propName, component) {
    var duplicate = void 0;

    roles.every(function (role) {
      var childrenWithRole = __WEBPACK_IMPORTED_MODULE_1__ValidComponentChildren__["a" /* default */].filter(props.children, function (child) {
        return child.props.bsRole === role;
      });

      if (childrenWithRole.length > 1) {
        duplicate = role;
        return false;
      }

      return true;
    });

    if (duplicate) {
      return new Error('(children) ' + component + ' - Duplicate children detected of bsRole: ' + (duplicate + '. Only one child each allowed with the following ') + ('bsRoles: ' + roles.join(', ')));
    }

    return null;
  });
}

/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 *
 * This file contains a modified version of:
 * https://github.com/facebook/react/blob/v0.12.0/src/addons/transitions/ReactTransitionEvents.js
 *
 * This source code is licensed under the BSD-style license found here:
 * https://github.com/facebook/react/blob/v0.12.0/LICENSE
 * An additional grant of patent rights can be found here:
 * https://github.com/facebook/react/blob/v0.12.0/PATENTS
 */

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * EVENT_NAME_MAP is used to determine which event fired when a
 * transition/animation ends, based on the style property used to
 * define that event.
 */
var EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are useable, and if not remove them
  // from the map
  if (!('AnimationEvent' in window)) {
    delete EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete EVENT_NAME_MAP.transitionend.transition;
  }

  for (var baseEventName in EVENT_NAME_MAP) {
    // eslint-disable-line guard-for-in
    var baseEvents = EVENT_NAME_MAP[baseEventName];
    for (var styleName in baseEvents) {
      // eslint-disable-line guard-for-in
      if (styleName in style) {
        endEvents.push(baseEvents[styleName]);
        break;
      }
    }
  }
}

if (canUseDOM) {
  detectEvents();
}

// We use the raw {add|remove}EventListener() call because EventListener
// does not know how to remove event listeners and we really should
// clean up. Also, these events are not triggered in older browsers
// so we should be A-OK here.

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var ReactTransitionEvents = {
  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      // If CSS transitions are not supported, trigger an "end animation"
      // event immediately.
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ReactTransitionEvents);

/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_warning__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_warning__);






var warned = {};

function deprecationWarning(oldname, newname, link) {
  var message = void 0;

  if ((typeof oldname === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(oldname)) === 'object') {
    message = oldname.message;
  } else {
    message = oldname + ' is deprecated. Use ' + newname + ' instead.';

    if (link) {
      message += '\nYou can read more about it at ' + link;
    }
  }

  if (warned[message]) {
    return;
  }

   false ? warning(false, message) : void 0;
  warned[message] = true;
}

deprecationWarning.wrapper = function (Component) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return function (_Component) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(DeprecatedComponent, _Component);

    function DeprecatedComponent() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DeprecatedComponent);

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
    }

    DeprecatedComponent.prototype.componentWillMount = function componentWillMount() {
      deprecationWarning.apply(undefined, args);

      if (_Component.prototype.componentWillMount) {
        var _Component$prototype$;

        for (var _len2 = arguments.length, methodArgs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          methodArgs[_key2] = arguments[_key2];
        }

        (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
      }
    };

    return DeprecatedComponent;
  }(Component);
};

/* harmony default export */ __webpack_exports__["a"] = (deprecationWarning);

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bootstrapUtils__ = __webpack_require__(20);
/* unused harmony reexport bootstrapUtils */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createChainedFunction__ = __webpack_require__(41);
/* unused harmony reexport createChainedFunction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__ = __webpack_require__(46);
/* unused harmony reexport ValidComponentChildren */







/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _year_dropdown = __webpack_require__(1406);

var _year_dropdown2 = _interopRequireDefault(_year_dropdown);

var _month_dropdown = __webpack_require__(1400);

var _month_dropdown2 = _interopRequireDefault(_month_dropdown);

var _month = __webpack_require__(1399);

var _month2 = _interopRequireDefault(_month);

var _time = __webpack_require__(1403);

var _time2 = _interopRequireDefault(_time);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _date_utils = __webpack_require__(88);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DROPDOWN_FOCUS_CLASSNAMES = ['react-datepicker__year-select', 'react-datepicker__month-select'];

var isDropdownSelect = function isDropdownSelect() {
  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var classNames = (element.className || '').split(/\s+/);
  return DROPDOWN_FOCUS_CLASSNAMES.some(function (testClassname) {
    return classNames.indexOf(testClassname) >= 0;
  });
};

var Calendar = function (_React$Component) {
  _inherits(Calendar, _React$Component);

  _createClass(Calendar, null, [{
    key: 'defaultProps',
    get: function get() {
      return {
        onDropdownFocus: function onDropdownFocus() {},
        monthsShown: 1,
        forceShowMonthNavigation: false
      };
    }
  }]);

  function Calendar(props) {
    _classCallCheck(this, Calendar);

    var _this = _possibleConstructorReturn(this, (Calendar.__proto__ || Object.getPrototypeOf(Calendar)).call(this, props));

    _this.handleClickOutside = function (event) {
      _this.props.onClickOutside(event);
    };

    _this.handleDropdownFocus = function (event) {
      if (isDropdownSelect(event.target)) {
        _this.props.onDropdownFocus();
      }
    };

    _this.getDateInView = function () {
      var _this$props = _this.props,
          preSelection = _this$props.preSelection,
          selected = _this$props.selected,
          openToDate = _this$props.openToDate,
          utcOffset = _this$props.utcOffset;

      var minDate = (0, _date_utils.getEffectiveMinDate)(_this.props);
      var maxDate = (0, _date_utils.getEffectiveMaxDate)(_this.props);
      var current = (0, _date_utils.now)(utcOffset);
      var initialDate = openToDate || selected || preSelection;
      if (initialDate) {
        return initialDate;
      } else {
        if (minDate && (0, _date_utils.isBefore)(current, minDate)) {
          return minDate;
        } else if (maxDate && (0, _date_utils.isAfter)(current, maxDate)) {
          return maxDate;
        }
      }
      return current;
    };

    _this.localizeDate = function (date) {
      return (0, _date_utils.localizeDate)(date, _this.props.locale);
    };

    _this.increaseMonth = function () {
      _this.setState({
        date: (0, _date_utils.addMonths)((0, _date_utils.cloneDate)(_this.state.date), 1)
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    };

    _this.decreaseMonth = function () {
      _this.setState({
        date: (0, _date_utils.subtractMonths)((0, _date_utils.cloneDate)(_this.state.date), 1)
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    };

    _this.handleDayClick = function (day, event) {
      return _this.props.onSelect(day, event);
    };

    _this.handleDayMouseEnter = function (day) {
      return _this.setState({ selectingDate: day });
    };

    _this.handleMonthMouseLeave = function () {
      return _this.setState({ selectingDate: null });
    };

    _this.handleMonthChange = function (date) {
      if (_this.props.onMonthChange) {
        _this.props.onMonthChange(date);
      }
    };

    _this.changeYear = function (year) {
      _this.setState({
        date: (0, _date_utils.setYear)((0, _date_utils.cloneDate)(_this.state.date), year)
      });
    };

    _this.changeMonth = function (month) {
      _this.setState({
        date: (0, _date_utils.setMonth)((0, _date_utils.cloneDate)(_this.state.date), month)
      }, function () {
        return _this.handleMonthChange(_this.state.date);
      });
    };

    _this.header = function () {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;

      var startOfWeek = (0, _date_utils.getStartOfWeek)((0, _date_utils.cloneDate)(date));
      var dayNames = [];
      if (_this.props.showWeekNumbers) {
        dayNames.push(_react2.default.createElement(
          'div',
          { key: 'W', className: 'react-datepicker__day-name' },
          _this.props.weekLabel || '#'
        ));
      }
      return dayNames.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
        var day = (0, _date_utils.addDays)((0, _date_utils.cloneDate)(startOfWeek), offset);
        var localeData = (0, _date_utils.getLocaleData)(day);
        var weekDayName = _this.props.useWeekdaysShort ? (0, _date_utils.getWeekdayShortInLocale)(localeData, day) : (0, _date_utils.getWeekdayMinInLocale)(localeData, day);
        return _react2.default.createElement(
          'div',
          { key: offset, className: 'react-datepicker__day-name' },
          weekDayName
        );
      }));
    };

    _this.renderPreviousMonthButton = function () {
      if (!_this.props.forceShowMonthNavigation && (0, _date_utils.allDaysDisabledBefore)(_this.state.date, 'month', _this.props)) {
        return;
      }
      return _react2.default.createElement('a', {
        className: 'react-datepicker__navigation react-datepicker__navigation--previous',
        onClick: _this.decreaseMonth });
    };

    _this.renderNextMonthButton = function () {
      if (!_this.props.forceShowMonthNavigation && (0, _date_utils.allDaysDisabledAfter)(_this.state.date, 'month', _this.props)) {
        return;
      }

      var classes = ['react-datepicker__navigation', 'react-datepicker__navigation--next'];
      if (_this.props.showTimeSelect) {
        classes.push('react-datepicker__navigation--next--with-time');
      }
      if (_this.props.todayButton) {
        classes.push('react-datepicker__navigation--next--with-today-button');
      }

      return _react2.default.createElement('a', {
        className: classes.join(' '),
        onClick: _this.increaseMonth });
    };

    _this.renderCurrentMonth = function () {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;

      var classes = ['react-datepicker__current-month'];

      if (_this.props.showYearDropdown) {
        classes.push('react-datepicker__current-month--hasYearDropdown');
      }
      if (_this.props.showMonthDropdown) {
        classes.push('react-datepicker__current-month--hasMonthDropdown');
      }
      return _react2.default.createElement(
        'div',
        { className: classes.join(' ') },
        (0, _date_utils.formatDate)(date, _this.props.dateFormat)
      );
    };

    _this.renderYearDropdown = function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this.props.showYearDropdown || overrideHide) {
        return;
      }
      return _react2.default.createElement(_year_dropdown2.default, {
        dropdownMode: _this.props.dropdownMode,
        onChange: _this.changeYear,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        year: (0, _date_utils.getYear)(_this.state.date),
        scrollableYearDropdown: _this.props.scrollableYearDropdown,
        yearDropdownItemNumber: _this.props.yearDropdownItemNumber });
    };

    _this.renderMonthDropdown = function () {
      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this.props.showMonthDropdown) {
        return;
      }
      return _react2.default.createElement(_month_dropdown2.default, {
        dropdownMode: _this.props.dropdownMode,
        locale: _this.props.locale,
        dateFormat: _this.props.dateFormat,
        onChange: _this.changeMonth,
        month: (0, _date_utils.getMonth)(_this.state.date) });
    };

    _this.renderTodayButton = function () {
      if (!_this.props.todayButton) {
        return;
      }
      return _react2.default.createElement(
        'div',
        {
          className: 'react-datepicker__today-button',
          onClick: function onClick(e) {
            return _this.props.onSelect((0, _date_utils.getStartOfDate)((0, _date_utils.now)(_this.props.utcOffset)), e);
          } },
        _this.props.todayButton
      );
    };

    _this.renderMonths = function () {
      var monthList = [];
      for (var i = 0; i < _this.props.monthsShown; ++i) {
        var monthDate = (0, _date_utils.addMonths)((0, _date_utils.cloneDate)(_this.state.date), i);
        var monthKey = 'month-' + i;
        monthList.push(_react2.default.createElement(
          'div',
          { key: monthKey, ref: function ref(div) {
              _this.monthContainer = div;
            }, className: 'react-datepicker__month-container' },
          _react2.default.createElement(
            'div',
            { className: 'react-datepicker__header' },
            _this.renderCurrentMonth(monthDate),
            _react2.default.createElement(
              'div',
              {
                className: 'react-datepicker__header__dropdown react-datepicker__header__dropdown--' + _this.props.dropdownMode,
                onFocus: _this.handleDropdownFocus },
              _this.renderMonthDropdown(i !== 0),
              _this.renderYearDropdown(i !== 0)
            ),
            _react2.default.createElement(
              'div',
              { className: 'react-datepicker__day-names' },
              _this.header(monthDate)
            )
          ),
          _react2.default.createElement(_month2.default, {
            day: monthDate,
            dayClassName: _this.props.dayClassName,
            onDayClick: _this.handleDayClick,
            onDayMouseEnter: _this.handleDayMouseEnter,
            onMouseLeave: _this.handleMonthMouseLeave,
            onWeekSelect: _this.props.onWeekSelect,
            formatWeekNumber: _this.props.formatWeekNumber,
            minDate: _this.props.minDate,
            maxDate: _this.props.maxDate,
            excludeDates: _this.props.excludeDates,
            highlightDates: _this.props.highlightDates,
            selectingDate: _this.state.selectingDate,
            includeDates: _this.props.includeDates,
            inline: _this.props.inline,
            fixedHeight: _this.props.fixedHeight,
            filterDate: _this.props.filterDate,
            preSelection: _this.props.preSelection,
            selected: _this.props.selected,
            selectsStart: _this.props.selectsStart,
            selectsEnd: _this.props.selectsEnd,
            showWeekNumbers: _this.props.showWeekNumbers,
            startDate: _this.props.startDate,
            endDate: _this.props.endDate,
            peekNextMonth: _this.props.peekNextMonth,
            utcOffset: _this.props.utcOffset })
        ));
      }
      return monthList;
    };

    _this.renderTimeSection = function () {
      if (_this.props.showTimeSelect) {
        return _react2.default.createElement(_time2.default, {
          selected: _this.props.selected,
          onChange: _this.props.onTimeChange,
          format: _this.props.timeFormat,
          intervals: _this.props.timeIntervals,
          minTime: _this.props.minTime,
          maxTime: _this.props.maxTime,
          excludeTimes: _this.props.excludeTimes,
          todayButton: _this.props.todayButton,
          showMonthDropdown: _this.props.showMonthDropdown,
          showYearDropdown: _this.props.showYearDropdown,
          withPortal: _this.props.withPortal,
          monthRef: _this.state.monthContainer });
      } else {
        return;
      }
    };

    _this.state = {
      date: _this.localizeDate(_this.getDateInView()),
      selectingDate: null,
      monthContainer: _this.monthContainer
    };
    return _this;
  }

  _createClass(Calendar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      /* monthContainer height is needed in time component to determine the height for the ul in the time component. setState here so height is given after final component layout is rendered */
      if (this.props.showTimeSelect) {
        this.assignMonthContainer = function () {
          _this2.setState({ monthContainer: _this2.monthContainer });
        }();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.preSelection && !(0, _date_utils.isSameDay)(nextProps.preSelection, this.props.preSelection)) {
        this.setState({
          date: this.localizeDate(nextProps.preSelection)
        });
      } else if (nextProps.openToDate && !(0, _date_utils.isSameDay)(nextProps.openToDate, this.props.openToDate)) {
        this.setState({
          date: this.localizeDate(nextProps.openToDate)
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('react-datepicker', this.props.className) },
        _react2.default.createElement('div', { className: 'react-datepicker__triangle' }),
        this.renderPreviousMonthButton(),
        this.renderNextMonthButton(),
        this.renderMonths(),
        this.renderTodayButton(),
        this.renderTimeSection(),
        this.props.children
      );
    }
  }]);

  return Calendar;
}(_react2.default.Component);

Calendar.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  dateFormat: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array]).isRequired,
  dayClassName: _propTypes2.default.func,
  dropdownMode: _propTypes2.default.oneOf(['scroll', 'select']).isRequired,
  endDate: _propTypes2.default.object,
  excludeDates: _propTypes2.default.array,
  filterDate: _propTypes2.default.func,
  fixedHeight: _propTypes2.default.bool,
  formatWeekNumber: _propTypes2.default.func,
  highlightDates: _propTypes2.default.array,
  includeDates: _propTypes2.default.array,
  inline: _propTypes2.default.bool,
  locale: _propTypes2.default.string,
  maxDate: _propTypes2.default.object,
  minDate: _propTypes2.default.object,
  monthsShown: _propTypes2.default.number,
  onClickOutside: _propTypes2.default.func.isRequired,
  onMonthChange: _propTypes2.default.func,
  forceShowMonthNavigation: _propTypes2.default.bool,
  onDropdownFocus: _propTypes2.default.func,
  onSelect: _propTypes2.default.func.isRequired,
  onWeekSelect: _propTypes2.default.func,
  showTimeSelect: _propTypes2.default.bool,
  timeFormat: _propTypes2.default.string,
  timeIntervals: _propTypes2.default.number,
  onTimeChange: _propTypes2.default.func,
  minTime: _propTypes2.default.object,
  maxTime: _propTypes2.default.object,
  excludeTimes: _propTypes2.default.array,
  openToDate: _propTypes2.default.object,
  peekNextMonth: _propTypes2.default.bool,
  scrollableYearDropdown: _propTypes2.default.bool,
  preSelection: _propTypes2.default.object,
  selected: _propTypes2.default.object,
  selectsEnd: _propTypes2.default.bool,
  selectsStart: _propTypes2.default.bool,
  showMonthDropdown: _propTypes2.default.bool,
  showWeekNumbers: _propTypes2.default.bool,
  showYearDropdown: _propTypes2.default.bool,
  startDate: _propTypes2.default.object,
  todayButton: _propTypes2.default.string,
  useWeekdaysShort: _propTypes2.default.bool,
  withPortal: _propTypes2.default.bool,
  utcOffset: _propTypes2.default.number,
  weekLabel: _propTypes2.default.string,
  yearDropdownItemNumber: _propTypes2.default.number
};
exports.default = Calendar;


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _date_utils = __webpack_require__(88);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Day = function (_React$Component) {
  _inherits(Day, _React$Component);

  function Day() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Day);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Day.__proto__ || Object.getPrototypeOf(Day)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (!_this.isDisabled() && _this.props.onClick) {
        _this.props.onClick(event);
      }
    }, _this.handleMouseEnter = function (event) {
      if (!_this.isDisabled() && _this.props.onMouseEnter) {
        _this.props.onMouseEnter(event);
      }
    }, _this.isSameDay = function (other) {
      return (0, _date_utils.isSameDay)(_this.props.day, other);
    }, _this.isKeyboardSelected = function () {
      return !_this.props.inline && !_this.isSameDay(_this.props.selected) && _this.isSameDay(_this.props.preSelection);
    }, _this.isDisabled = function () {
      return (0, _date_utils.isDayDisabled)(_this.props.day, _this.props);
    }, _this.getHighLightedClass = function (defaultClassName) {
      var _this$props = _this.props,
          day = _this$props.day,
          highlightDates = _this$props.highlightDates;


      if (!highlightDates) {
        return _defineProperty({}, defaultClassName, false);
      }

      var classNames = {};
      for (var i = 0, len = highlightDates.length; i < len; i++) {
        var obj = highlightDates[i];
        if ((0, _date_utils.isMoment)(obj)) {
          if ((0, _date_utils.isSameDay)(day, obj)) {
            classNames[defaultClassName] = true;
          }
        } else if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
          var keys = Object.keys(obj);
          var arr = obj[keys[0]];
          if (typeof keys[0] === 'string' && arr.constructor === Array) {
            for (var k = 0, _len2 = arr.length; k < _len2; k++) {
              if ((0, _date_utils.isSameDay)(day, arr[k])) {
                classNames[keys[0]] = true;
              }
            }
          }
        }
      }

      return classNames;
    }, _this.isInRange = function () {
      var _this$props2 = _this.props,
          day = _this$props2.day,
          startDate = _this$props2.startDate,
          endDate = _this$props2.endDate;

      if (!startDate || !endDate) {
        return false;
      }
      return (0, _date_utils.isDayInRange)(day, startDate, endDate);
    }, _this.isInSelectingRange = function () {
      var _this$props3 = _this.props,
          day = _this$props3.day,
          selectsStart = _this$props3.selectsStart,
          selectsEnd = _this$props3.selectsEnd,
          selectingDate = _this$props3.selectingDate,
          startDate = _this$props3.startDate,
          endDate = _this$props3.endDate;


      if (!(selectsStart || selectsEnd) || !selectingDate || _this.isDisabled()) {
        return false;
      }

      if (selectsStart && endDate && selectingDate.isSameOrBefore(endDate)) {
        return (0, _date_utils.isDayInRange)(day, selectingDate, endDate);
      }

      if (selectsEnd && startDate && selectingDate.isSameOrAfter(startDate)) {
        return (0, _date_utils.isDayInRange)(day, startDate, selectingDate);
      }

      return false;
    }, _this.isSelectingRangeStart = function () {
      if (!_this.isInSelectingRange()) {
        return false;
      }

      var _this$props4 = _this.props,
          day = _this$props4.day,
          selectingDate = _this$props4.selectingDate,
          startDate = _this$props4.startDate,
          selectsStart = _this$props4.selectsStart;


      if (selectsStart) {
        return (0, _date_utils.isSameDay)(day, selectingDate);
      } else {
        return (0, _date_utils.isSameDay)(day, startDate);
      }
    }, _this.isSelectingRangeEnd = function () {
      if (!_this.isInSelectingRange()) {
        return false;
      }

      var _this$props5 = _this.props,
          day = _this$props5.day,
          selectingDate = _this$props5.selectingDate,
          endDate = _this$props5.endDate,
          selectsEnd = _this$props5.selectsEnd;


      if (selectsEnd) {
        return (0, _date_utils.isSameDay)(day, selectingDate);
      } else {
        return (0, _date_utils.isSameDay)(day, endDate);
      }
    }, _this.isRangeStart = function () {
      var _this$props6 = _this.props,
          day = _this$props6.day,
          startDate = _this$props6.startDate,
          endDate = _this$props6.endDate;

      if (!startDate || !endDate) {
        return false;
      }
      return (0, _date_utils.isSameDay)(startDate, day);
    }, _this.isRangeEnd = function () {
      var _this$props7 = _this.props,
          day = _this$props7.day,
          startDate = _this$props7.startDate,
          endDate = _this$props7.endDate;

      if (!startDate || !endDate) {
        return false;
      }
      return (0, _date_utils.isSameDay)(endDate, day);
    }, _this.isWeekend = function () {
      var weekday = (0, _date_utils.getDay)(_this.props.day);
      return weekday === 0 || weekday === 6;
    }, _this.isOutsideMonth = function () {
      return _this.props.month !== undefined && _this.props.month !== (0, _date_utils.getMonth)(_this.props.day);
    }, _this.getClassNames = function (date) {
      var dayClassName = _this.props.dayClassName ? _this.props.dayClassName(date) : undefined;
      return (0, _classnames2.default)('react-datepicker__day', dayClassName, 'react-datepicker__day--' + (0, _date_utils.getDayOfWeekCode)(_this.props.day), {
        'react-datepicker__day--disabled': _this.isDisabled(),
        'react-datepicker__day--selected': _this.isSameDay(_this.props.selected),
        'react-datepicker__day--keyboard-selected': _this.isKeyboardSelected(),
        'react-datepicker__day--range-start': _this.isRangeStart(),
        'react-datepicker__day--range-end': _this.isRangeEnd(),
        'react-datepicker__day--in-range': _this.isInRange(),
        'react-datepicker__day--in-selecting-range': _this.isInSelectingRange(),
        'react-datepicker__day--selecting-range-start': _this.isSelectingRangeStart(),
        'react-datepicker__day--selecting-range-end': _this.isSelectingRangeEnd(),
        'react-datepicker__day--today': _this.isSameDay((0, _date_utils.now)(_this.props.utcOffset)),
        'react-datepicker__day--weekend': _this.isWeekend(),
        'react-datepicker__day--outside-month': _this.isOutsideMonth()
      }, _this.getHighLightedClass('react-datepicker__day--highlighted'));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Day, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        {
          className: this.getClassNames(this.props.day),
          onClick: this.handleClick,
          onMouseEnter: this.handleMouseEnter,
          'aria-label': 'day-' + (0, _date_utils.getDate)(this.props.day),
          role: 'option' },
        (0, _date_utils.getDate)(this.props.day)
      );
    }
  }]);

  return Day;
}(_react2.default.Component);

Day.propTypes = {
  day: _propTypes2.default.object.isRequired,
  dayClassName: _propTypes2.default.func,
  endDate: _propTypes2.default.object,
  highlightDates: _propTypes2.default.array,
  inline: _propTypes2.default.bool,
  month: _propTypes2.default.number,
  onClick: _propTypes2.default.func,
  onMouseEnter: _propTypes2.default.func,
  preSelection: _propTypes2.default.object,
  selected: _propTypes2.default.object,
  selectingDate: _propTypes2.default.object,
  selectsEnd: _propTypes2.default.bool,
  selectsStart: _propTypes2.default.bool,
  startDate: _propTypes2.default.object,
  utcOffset: _propTypes2.default.number
};
exports.default = Day;


/***/ }),
/* 1399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _week = __webpack_require__(1404);

var _week2 = _interopRequireDefault(_week);

var _date_utils = __webpack_require__(88);

var utils = _interopRequireWildcard(_date_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;

var Month = function (_React$Component) {
  _inherits(Month, _React$Component);

  function Month() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Month);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Month.__proto__ || Object.getPrototypeOf(Month)).call.apply(_ref, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, event);
      }
    }, _this.handleDayMouseEnter = function (day) {
      if (_this.props.onDayMouseEnter) {
        _this.props.onDayMouseEnter(day);
      }
    }, _this.handleMouseLeave = function () {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave();
      }
    }, _this.isWeekInMonth = function (startOfWeek) {
      var day = _this.props.day;
      var endOfWeek = utils.addDays(utils.cloneDate(startOfWeek), 6);
      return utils.isSameMonth(startOfWeek, day) || utils.isSameMonth(endOfWeek, day);
    }, _this.renderWeeks = function () {
      var weeks = [];
      var isFixedHeight = _this.props.fixedHeight;
      var currentWeekStart = utils.getStartOfWeek(utils.getStartOfMonth(utils.cloneDate(_this.props.day)));
      var i = 0;
      var breakAfterNextPush = false;

      while (true) {
        weeks.push(_react2.default.createElement(_week2.default, {
          key: i,
          day: currentWeekStart,
          month: utils.getMonth(_this.props.day),
          onDayClick: _this.handleDayClick,
          onDayMouseEnter: _this.handleDayMouseEnter,
          onWeekSelect: _this.props.onWeekSelect,
          formatWeekNumber: _this.props.formatWeekNumber,
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          excludeDates: _this.props.excludeDates,
          includeDates: _this.props.includeDates,
          inline: _this.props.inline,
          highlightDates: _this.props.highlightDates,
          selectingDate: _this.props.selectingDate,
          filterDate: _this.props.filterDate,
          preSelection: _this.props.preSelection,
          selected: _this.props.selected,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          showWeekNumber: _this.props.showWeekNumbers,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          dayClassName: _this.props.dayClassName,
          utcOffset: _this.props.utcOffset }));

        if (breakAfterNextPush) break;

        i++;
        currentWeekStart = utils.addWeeks(utils.cloneDate(currentWeekStart), 1);

        // If one of these conditions is true, we will either break on this week
        // or break on the next week
        var isFixedAndFinalWeek = isFixedHeight && i >= FIXED_HEIGHT_STANDARD_WEEK_COUNT;
        var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);

        if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
          if (_this.props.peekNextMonth) {
            breakAfterNextPush = true;
          } else {
            break;
          }
        }
      }

      return weeks;
    }, _this.getClassNames = function () {
      var _this$props = _this.props,
          selectingDate = _this$props.selectingDate,
          selectsStart = _this$props.selectsStart,
          selectsEnd = _this$props.selectsEnd;

      return (0, _classnames2.default)('react-datepicker__month', {
        'react-datepicker__month--selecting-range': selectingDate && (selectsStart || selectsEnd)
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Month, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: this.getClassNames(), onMouseLeave: this.handleMouseLeave, role: 'listbox' },
        this.renderWeeks()
      );
    }
  }]);

  return Month;
}(_react2.default.Component);

Month.propTypes = {
  day: _propTypes2.default.object.isRequired,
  dayClassName: _propTypes2.default.func,
  endDate: _propTypes2.default.object,
  excludeDates: _propTypes2.default.array,
  filterDate: _propTypes2.default.func,
  fixedHeight: _propTypes2.default.bool,
  formatWeekNumber: _propTypes2.default.func,
  highlightDates: _propTypes2.default.array,
  includeDates: _propTypes2.default.array,
  inline: _propTypes2.default.bool,
  maxDate: _propTypes2.default.object,
  minDate: _propTypes2.default.object,
  onDayClick: _propTypes2.default.func,
  onDayMouseEnter: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onWeekSelect: _propTypes2.default.func,
  peekNextMonth: _propTypes2.default.bool,
  preSelection: _propTypes2.default.object,
  selected: _propTypes2.default.object,
  selectingDate: _propTypes2.default.object,
  selectsEnd: _propTypes2.default.bool,
  selectsStart: _propTypes2.default.bool,
  showWeekNumbers: _propTypes2.default.bool,
  startDate: _propTypes2.default.object,
  utcOffset: _propTypes2.default.number
};
exports.default = Month;


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _month_dropdown_options = __webpack_require__(1401);

var _month_dropdown_options2 = _interopRequireDefault(_month_dropdown_options);

var _reactOnclickoutside = __webpack_require__(346);

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _date_utils = __webpack_require__(88);

var utils = _interopRequireWildcard(_date_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WrappedMonthDropdownOptions = (0, _reactOnclickoutside2.default)(_month_dropdown_options2.default);

var MonthDropdown = function (_React$Component) {
  _inherits(MonthDropdown, _React$Component);

  function MonthDropdown() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MonthDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MonthDropdown.__proto__ || Object.getPrototypeOf(MonthDropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      dropdownVisible: false
    }, _this.renderSelectOptions = function (monthNames) {
      return monthNames.map(function (M, i) {
        return _react2.default.createElement(
          'option',
          { key: i, value: i },
          M
        );
      });
    }, _this.renderSelectMode = function (monthNames) {
      return _react2.default.createElement(
        'select',
        { value: _this.props.month, className: 'react-datepicker__month-select', onChange: function onChange(e) {
            return _this.onChange(e.target.value);
          } },
        _this.renderSelectOptions(monthNames)
      );
    }, _this.renderReadView = function (visible, monthNames) {
      return _react2.default.createElement(
        'div',
        { key: 'read', style: { visibility: visible ? 'visible' : 'hidden' }, className: 'react-datepicker__month-read-view', onClick: _this.toggleDropdown },
        _react2.default.createElement(
          'span',
          { className: 'react-datepicker__month-read-view--selected-month' },
          monthNames[_this.props.month]
        ),
        _react2.default.createElement('span', { className: 'react-datepicker__month-read-view--down-arrow' })
      );
    }, _this.renderDropdown = function (monthNames) {
      return _react2.default.createElement(WrappedMonthDropdownOptions, {
        key: 'dropdown',
        ref: 'options',
        month: _this.props.month,
        monthNames: monthNames,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown });
    }, _this.renderScrollMode = function (monthNames) {
      var dropdownVisible = _this.state.dropdownVisible;

      var result = [_this.renderReadView(!dropdownVisible, monthNames)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown(monthNames));
      }
      return result;
    }, _this.onChange = function (month) {
      _this.toggleDropdown();
      if (month !== _this.props.month) {
        _this.props.onChange(month);
      }
    }, _this.toggleDropdown = function () {
      return _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MonthDropdown, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var localeData = utils.getLocaleDataForLocale(this.props.locale);
      var monthNames = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(function (M) {
        return utils.getMonthInLocale(localeData, utils.newDate({ M: M }), _this2.props.dateFormat);
      });

      var renderedDropdown = void 0;
      switch (this.props.dropdownMode) {
        case 'scroll':
          renderedDropdown = this.renderScrollMode(monthNames);
          break;
        case 'select':
          renderedDropdown = this.renderSelectMode(monthNames);
          break;
      }

      return _react2.default.createElement(
        'div',
        {
          className: 'react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--' + this.props.dropdownMode },
        renderedDropdown
      );
    }
  }]);

  return MonthDropdown;
}(_react2.default.Component);

MonthDropdown.propTypes = {
  dropdownMode: _propTypes2.default.oneOf(['scroll', 'select']).isRequired,
  locale: _propTypes2.default.string,
  dateFormat: _propTypes2.default.string.isRequired,
  month: _propTypes2.default.number.isRequired,
  onChange: _propTypes2.default.func.isRequired
};
exports.default = MonthDropdown;


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MonthDropdownOptions = function (_React$Component) {
  _inherits(MonthDropdownOptions, _React$Component);

  function MonthDropdownOptions() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MonthDropdownOptions);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MonthDropdownOptions.__proto__ || Object.getPrototypeOf(MonthDropdownOptions)).call.apply(_ref, [this].concat(args))), _this), _this.renderOptions = function () {
      return _this.props.monthNames.map(function (month, i) {
        return _react2.default.createElement(
          'div',
          { className: 'react-datepicker__month-option',
            key: month,
            ref: month,
            onClick: _this.onChange.bind(_this, i) },
          _this.props.month === i ? _react2.default.createElement(
            'span',
            { className: 'react-datepicker__month-option--selected' },
            '\u2713'
          ) : '',
          month
        );
      });
    }, _this.onChange = function (month) {
      return _this.props.onChange(month);
    }, _this.handleClickOutside = function () {
      return _this.props.onCancel();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MonthDropdownOptions, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'react-datepicker__month-dropdown' },
        this.renderOptions()
      );
    }
  }]);

  return MonthDropdownOptions;
}(_react2.default.Component);

MonthDropdownOptions.propTypes = {
  onCancel: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  month: _propTypes2.default.number.isRequired,
  monthNames: _propTypes2.default.arrayOf(_propTypes2.default.string.isRequired).isRequired
};
exports.default = MonthDropdownOptions;


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.popperPlacementPositions = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactPopper = __webpack_require__(1498);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var popperPlacementPositions = exports.popperPlacementPositions = ['auto', 'auto-left', 'auto-right', 'bottom', 'bottom-end', 'bottom-start', 'left', 'left-end', 'left-start', 'right', 'right-end', 'right-start', 'top', 'top-end', 'top-start'];

var PopperComponent = function (_React$Component) {
  _inherits(PopperComponent, _React$Component);

  function PopperComponent() {
    _classCallCheck(this, PopperComponent);

    return _possibleConstructorReturn(this, (PopperComponent.__proto__ || Object.getPrototypeOf(PopperComponent)).apply(this, arguments));
  }

  _createClass(PopperComponent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          hidePopper = _props.hidePopper,
          popperComponent = _props.popperComponent,
          popperModifiers = _props.popperModifiers,
          popperPlacement = _props.popperPlacement,
          targetComponent = _props.targetComponent;


      var popper = void 0;

      if (!hidePopper) {
        var classes = (0, _classnames2.default)('react-datepicker-popper', className);
        popper = _react2.default.createElement(
          _reactPopper.Popper,
          {
            className: classes,
            modifiers: popperModifiers,
            placement: popperPlacement },
          popperComponent
        );
      }

      if (this.props.popperContainer) {
        popper = _react2.default.createElement(this.props.popperContainer, {}, popper);
      }

      return _react2.default.createElement(
        _reactPopper.Manager,
        null,
        _react2.default.createElement(
          _reactPopper.Target,
          { className: 'react-datepicker-wrapper' },
          targetComponent
        ),
        popper
      );
    }
  }], [{
    key: 'defaultProps',
    get: function get() {
      return {
        hidePopper: true,
        popperModifiers: {
          preventOverflow: {
            enabled: true,
            escapeWithReference: true,
            boundariesElement: 'viewport'
          }
        },
        popperPlacement: 'bottom-start'
      };
    }
  }]);

  return PopperComponent;
}(_react2.default.Component);

PopperComponent.propTypes = {
  className: _propTypes2.default.string,
  hidePopper: _propTypes2.default.bool,
  popperComponent: _propTypes2.default.element,
  popperModifiers: _propTypes2.default.object, // <datepicker/> props
  popperPlacement: _propTypes2.default.oneOf(popperPlacementPositions), // <datepicker/> props
  popperContainer: _propTypes2.default.func,
  targetComponent: _propTypes2.default.element
};
exports.default = PopperComponent;


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _date_utils = __webpack_require__(88);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Time = function (_React$Component) {
  _inherits(Time, _React$Component);

  function Time() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Time);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Time.__proto__ || Object.getPrototypeOf(Time)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (time) {
      if ((_this.props.minTime || _this.props.maxTime) && (0, _date_utils.isTimeInDisabledRange)(time, _this.props) || _this.props.excludeTimes && (0, _date_utils.isTimeDisabled)(time, _this.props.excludeTimes)) {
        return;
      }

      _this.props.onChange(time);
    }, _this.liClasses = function (time, currH, currM) {
      var classes = ['react-datepicker__time-list-item'];

      if (currH === (0, _date_utils.getHour)(time) && currM === (0, _date_utils.getMinute)(time)) {
        classes.push('react-datepicker__time-list-item--selected');
      }
      if ((_this.props.minTime || _this.props.maxTime) && (0, _date_utils.isTimeInDisabledRange)(time, _this.props) || _this.props.excludeTimes && (0, _date_utils.isTimeDisabled)(time, _this.props.excludeTimes)) {
        classes.push('react-datepicker__time-list-item--disabled');
      }

      return classes.join(' ');
    }, _this.renderTimes = function () {
      var times = [];
      var format = _this.props.format ? _this.props.format : 'hh:mm A';
      var intervals = _this.props.intervals;
      var activeTime = _this.props.selected ? _this.props.selected : (0, _date_utils.newDate)();
      var currH = (0, _date_utils.getHour)(activeTime);
      var currM = (0, _date_utils.getMinute)(activeTime);
      var base = (0, _date_utils.getStartOfDay)((0, _date_utils.newDate)());
      var multiplier = 1440 / intervals;
      for (var i = 0; i < multiplier; i++) {
        times.push((0, _date_utils.addMinutes)((0, _date_utils.cloneDate)(base), i * intervals));
      }

      return times.map(function (time, i) {
        return _react2.default.createElement(
          'li',
          { key: i, onClick: _this.handleClick.bind(_this, time), className: _this.liClasses(time, currH, currM) },
          (0, _date_utils.formatDate)(time, format)
        );
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Time, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // code to ensure selected time will always be in focus within time window when it first appears
      var multiplier = 60 / this.props.intervals;
      var currH = this.props.selected ? (0, _date_utils.getHour)(this.props.selected) : (0, _date_utils.getHour)((0, _date_utils.newDate)());
      this.list.scrollTop = 30 * (multiplier * currH);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var height = null;
      if (this.props.monthRef) {
        height = this.props.monthRef.clientHeight - 39;
      }

      return _react2.default.createElement(
        'div',
        { className: 'react-datepicker__time-container ' + (this.props.todayButton ? 'react-datepicker__time-container--with-today-button' : '') },
        _react2.default.createElement(
          'div',
          { className: 'react-datepicker__header react-datepicker__header--time' },
          _react2.default.createElement(
            'div',
            { className: 'react-datepicker-time__header' },
            'Time'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'react-datepicker__time' },
          _react2.default.createElement(
            'div',
            { className: 'react-datepicker__time-box' },
            _react2.default.createElement(
              'ul',
              { className: 'react-datepicker__time-list', ref: function ref(list) {
                  _this2.list = list;
                }, style: height ? { height: height } : {} },
              this.renderTimes.bind(this)()
            )
          )
        )
      );
    }
  }], [{
    key: 'defaultProps',
    get: function get() {
      return {
        intervals: 30,
        onTimeChange: function onTimeChange() {},
        todayButton: null
      };
    }
  }]);

  return Time;
}(_react2.default.Component);

Time.propTypes = {
  format: _propTypes2.default.string,
  intervals: _propTypes2.default.number,
  selected: _propTypes2.default.object,
  onChange: _propTypes2.default.func,
  todayButton: _propTypes2.default.string,
  minTime: _propTypes2.default.object,
  maxTime: _propTypes2.default.object,
  excludeTimes: _propTypes2.default.array,
  monthRef: _propTypes2.default.object
};
exports.default = Time;


/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _day = __webpack_require__(1398);

var _day2 = _interopRequireDefault(_day);

var _week_number = __webpack_require__(1405);

var _week_number2 = _interopRequireDefault(_week_number);

var _date_utils = __webpack_require__(88);

var utils = _interopRequireWildcard(_date_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Week = function (_React$Component) {
  _inherits(Week, _React$Component);

  function Week() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Week);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Week.__proto__ || Object.getPrototypeOf(Week)).call.apply(_ref, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, event);
      }
    }, _this.handleDayMouseEnter = function (day) {
      if (_this.props.onDayMouseEnter) {
        _this.props.onDayMouseEnter(day);
      }
    }, _this.handleWeekClick = function (day, weekNumber, event) {
      if (typeof _this.props.onWeekSelect === 'function') {
        _this.props.onWeekSelect(day, weekNumber, event);
      }
    }, _this.formatWeekNumber = function (startOfWeek) {
      if (_this.props.formatWeekNumber) {
        return _this.props.formatWeekNumber(startOfWeek);
      }
      return utils.getWeek(startOfWeek);
    }, _this.renderDays = function () {
      var startOfWeek = utils.getStartOfWeek(utils.cloneDate(_this.props.day));
      var days = [];
      var weekNumber = _this.formatWeekNumber(startOfWeek);
      if (_this.props.showWeekNumber) {
        var onClickAction = _this.props.onWeekSelect ? _this.handleWeekClick.bind(_this, startOfWeek, weekNumber) : undefined;
        days.push(_react2.default.createElement(_week_number2.default, { key: 'W', weekNumber: weekNumber, onClick: onClickAction }));
      }
      return days.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
        var day = utils.addDays(utils.cloneDate(startOfWeek), offset);
        return _react2.default.createElement(_day2.default, {
          key: offset,
          day: day,
          month: _this.props.month,
          onClick: _this.handleDayClick.bind(_this, day),
          onMouseEnter: _this.handleDayMouseEnter.bind(_this, day),
          minDate: _this.props.minDate,
          maxDate: _this.props.maxDate,
          excludeDates: _this.props.excludeDates,
          includeDates: _this.props.includeDates,
          inline: _this.props.inline,
          highlightDates: _this.props.highlightDates,
          selectingDate: _this.props.selectingDate,
          filterDate: _this.props.filterDate,
          preSelection: _this.props.preSelection,
          selected: _this.props.selected,
          selectsStart: _this.props.selectsStart,
          selectsEnd: _this.props.selectsEnd,
          startDate: _this.props.startDate,
          endDate: _this.props.endDate,
          dayClassName: _this.props.dayClassName,
          utcOffset: _this.props.utcOffset });
      }));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Week, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'react-datepicker__week' },
        this.renderDays()
      );
    }
  }]);

  return Week;
}(_react2.default.Component);

Week.propTypes = {
  day: _propTypes2.default.object.isRequired,
  dayClassName: _propTypes2.default.func,
  endDate: _propTypes2.default.object,
  excludeDates: _propTypes2.default.array,
  filterDate: _propTypes2.default.func,
  formatWeekNumber: _propTypes2.default.func,
  highlightDates: _propTypes2.default.array,
  includeDates: _propTypes2.default.array,
  inline: _propTypes2.default.bool,
  maxDate: _propTypes2.default.object,
  minDate: _propTypes2.default.object,
  month: _propTypes2.default.number,
  onDayClick: _propTypes2.default.func,
  onDayMouseEnter: _propTypes2.default.func,
  onWeekSelect: _propTypes2.default.func,
  preSelection: _propTypes2.default.object,
  selected: _propTypes2.default.object,
  selectingDate: _propTypes2.default.object,
  selectsEnd: _propTypes2.default.bool,
  selectsStart: _propTypes2.default.bool,
  showWeekNumber: _propTypes2.default.bool,
  startDate: _propTypes2.default.object,
  utcOffset: _propTypes2.default.number
};
exports.default = Week;


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WeekNumber = function (_React$Component) {
  _inherits(WeekNumber, _React$Component);

  function WeekNumber() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, WeekNumber);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = WeekNumber.__proto__ || Object.getPrototypeOf(WeekNumber)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) {
        _this.props.onClick(event);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(WeekNumber, [{
    key: 'render',
    value: function render() {
      var weekNumberClasses = {
        'react-datepicker__week-number': true,
        'react-datepicker__week-number--clickable': !!this.props.onClick
      };
      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)(weekNumberClasses),
          'aria-label': 'week-' + this.props.weekNumber,
          onClick: this.handleClick },
        this.props.weekNumber
      );
    }
  }]);

  return WeekNumber;
}(_react2.default.Component);

WeekNumber.propTypes = {
  weekNumber: _propTypes2.default.number.isRequired,
  onClick: _propTypes2.default.func
};
exports.default = WeekNumber;


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _year_dropdown_options = __webpack_require__(1407);

var _year_dropdown_options2 = _interopRequireDefault(_year_dropdown_options);

var _reactOnclickoutside = __webpack_require__(346);

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _date_utils = __webpack_require__(88);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var WrappedYearDropdownOptions = (0, _reactOnclickoutside2.default)(_year_dropdown_options2.default);

var YearDropdown = function (_React$Component) {
  _inherits(YearDropdown, _React$Component);

  function YearDropdown() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, YearDropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = YearDropdown.__proto__ || Object.getPrototypeOf(YearDropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      dropdownVisible: false
    }, _this.renderSelectOptions = function () {
      var minYear = _this.props.minDate ? (0, _date_utils.getYear)(_this.props.minDate) : 1900;
      var maxYear = _this.props.maxDate ? (0, _date_utils.getYear)(_this.props.maxDate) : 2100;

      var options = [];
      for (var i = minYear; i <= maxYear; i++) {
        options.push(_react2.default.createElement(
          'option',
          { key: i, value: i },
          i
        ));
      }
      return options;
    }, _this.onSelectChange = function (e) {
      _this.onChange(e.target.value);
    }, _this.renderSelectMode = function () {
      return _react2.default.createElement(
        'select',
        {
          value: _this.props.year,
          className: 'react-datepicker__year-select',
          onChange: _this.onSelectChange },
        _this.renderSelectOptions()
      );
    }, _this.renderReadView = function (visible) {
      return _react2.default.createElement(
        'div',
        { key: 'read', style: { visibility: visible ? 'visible' : 'hidden' }, className: 'react-datepicker__year-read-view', onClick: _this.toggleDropdown },
        _react2.default.createElement('span', { className: 'react-datepicker__year-read-view--down-arrow' }),
        _react2.default.createElement(
          'span',
          { className: 'react-datepicker__year-read-view--selected-year' },
          _this.props.year
        )
      );
    }, _this.renderDropdown = function () {
      return _react2.default.createElement(WrappedYearDropdownOptions, {
        key: 'dropdown',
        ref: 'options',
        year: _this.props.year,
        onChange: _this.onChange,
        onCancel: _this.toggleDropdown,
        minDate: _this.props.minDate,
        maxDate: _this.props.maxDate,
        scrollableYearDropdown: _this.props.scrollableYearDropdown,
        yearDropdownItemNumber: _this.props.yearDropdownItemNumber });
    }, _this.renderScrollMode = function () {
      var dropdownVisible = _this.state.dropdownVisible;

      var result = [_this.renderReadView(!dropdownVisible)];
      if (dropdownVisible) {
        result.unshift(_this.renderDropdown());
      }
      return result;
    }, _this.onChange = function (year) {
      _this.toggleDropdown();
      if (year === _this.props.year) return;
      _this.props.onChange(year);
    }, _this.toggleDropdown = function () {
      _this.setState({
        dropdownVisible: !_this.state.dropdownVisible
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(YearDropdown, [{
    key: 'render',
    value: function render() {
      var renderedDropdown = void 0;
      switch (this.props.dropdownMode) {
        case 'scroll':
          renderedDropdown = this.renderScrollMode();
          break;
        case 'select':
          renderedDropdown = this.renderSelectMode();
          break;
      }

      return _react2.default.createElement(
        'div',
        {
          className: 'react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--' + this.props.dropdownMode },
        renderedDropdown
      );
    }
  }]);

  return YearDropdown;
}(_react2.default.Component);

YearDropdown.propTypes = {
  dropdownMode: _propTypes2.default.oneOf(['scroll', 'select']).isRequired,
  maxDate: _propTypes2.default.object,
  minDate: _propTypes2.default.object,
  onChange: _propTypes2.default.func.isRequired,
  scrollableYearDropdown: _propTypes2.default.bool,
  year: _propTypes2.default.number.isRequired,
  yearDropdownItemNumber: _propTypes2.default.number
};
exports.default = YearDropdown;


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function generateYears(year, noOfYear, minDate, maxDate) {
  var list = [];
  for (var i = 0; i < 2 * noOfYear + 1; i++) {
    var newYear = year + noOfYear - i;
    var isInRange = true;

    if (minDate) {
      isInRange = minDate.year() <= newYear;
    }

    if (maxDate && isInRange) {
      isInRange = maxDate.year() >= newYear;
    }

    if (isInRange) {
      list.push(newYear);
    }
  }

  return list;
}

var YearDropdownOptions = function (_React$Component) {
  _inherits(YearDropdownOptions, _React$Component);

  function YearDropdownOptions(props) {
    _classCallCheck(this, YearDropdownOptions);

    var _this = _possibleConstructorReturn(this, (YearDropdownOptions.__proto__ || Object.getPrototypeOf(YearDropdownOptions)).call(this, props));

    _this.renderOptions = function () {
      var selectedYear = _this.props.year;
      var options = _this.state.yearsList.map(function (year) {
        return _react2.default.createElement(
          'div',
          { className: 'react-datepicker__year-option',
            key: year,
            ref: year,
            onClick: _this.onChange.bind(_this, year) },
          selectedYear === year ? _react2.default.createElement(
            'span',
            { className: 'react-datepicker__year-option--selected' },
            '\u2713'
          ) : '',
          year
        );
      });

      var minYear = _this.props.minDate ? _this.props.minDate.year() : null;
      var maxYear = _this.props.maxDate ? _this.props.maxDate.year() : null;

      if (!maxYear || !_this.state.yearsList.find(function (year) {
        return year === maxYear;
      })) {
        options.unshift(_react2.default.createElement(
          'div',
          { className: 'react-datepicker__year-option',
            ref: 'upcoming',
            key: 'upcoming',
            onClick: _this.incrementYears },
          _react2.default.createElement('a', { className: 'react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming' })
        ));
      }

      if (!minYear || !_this.state.yearsList.find(function (year) {
        return year === minYear;
      })) {
        options.push(_react2.default.createElement(
          'div',
          { className: 'react-datepicker__year-option',
            ref: 'previous',
            key: 'previous',
            onClick: _this.decrementYears },
          _react2.default.createElement('a', { className: 'react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous' })
        ));
      }

      return options;
    };

    _this.onChange = function (year) {
      _this.props.onChange(year);
    };

    _this.handleClickOutside = function () {
      _this.props.onCancel();
    };

    _this.shiftYears = function (amount) {
      var years = _this.state.yearsList.map(function (year) {
        return year + amount;
      });

      _this.setState({
        yearsList: years
      });
    };

    _this.incrementYears = function () {
      return _this.shiftYears(1);
    };

    _this.decrementYears = function () {
      return _this.shiftYears(-1);
    };

    var yearDropdownItemNumber = props.yearDropdownItemNumber,
        scrollableYearDropdown = props.scrollableYearDropdown;

    var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);

    _this.state = {
      yearsList: generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate)
    };
    return _this;
  }

  _createClass(YearDropdownOptions, [{
    key: 'render',
    value: function render() {
      var dropdownClass = (0, _classnames2.default)({
        'react-datepicker__year-dropdown': true,
        'react-datepicker__year-dropdown--scrollable': this.props.scrollableYearDropdown
      });

      return _react2.default.createElement(
        'div',
        { className: dropdownClass },
        this.renderOptions()
      );
    }
  }]);

  return YearDropdownOptions;
}(_react2.default.Component);

YearDropdownOptions.propTypes = {
  minDate: _propTypes2.default.object,
  maxDate: _propTypes2.default.object,
  onCancel: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  scrollableYearDropdown: _propTypes2.default.bool,
  year: _propTypes2.default.number.isRequired,
  yearDropdownItemNumber: _propTypes2.default.number
};
exports.default = YearDropdownOptions;


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(38);

var focusNode = __webpack_require__(198);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(171);
var ExecutionEnvironment = __webpack_require__(31);
var FallbackCompositionState = __webpack_require__(1416);
var SyntheticCompositionEvent = __webpack_require__(1453);
var SyntheticInputEvent = __webpack_require__(1456);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(591);
var ExecutionEnvironment = __webpack_require__(31);
var ReactInstrumentation = __webpack_require__(53);

var camelizeStyleName = __webpack_require__(514);
var dangerousStyleValue = __webpack_require__(1462);
var hyphenateStyleName = __webpack_require__(518);
var memoizeStringOnly = __webpack_require__(519);
var warning = __webpack_require__(21);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(170);
var EventPropagators = __webpack_require__(171);
var ExecutionEnvironment = __webpack_require__(31);
var ReactDOMComponentTree = __webpack_require__(38);
var ReactUpdates = __webpack_require__(65);
var SyntheticEvent = __webpack_require__(72);

var inputValueTracking = __webpack_require__(607);
var getEventTarget = __webpack_require__(342);
var isEventSupported = __webpack_require__(343);
var isTextInputElement = __webpack_require__(609);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(26);

var DOMLazyTree = __webpack_require__(125);
var ExecutionEnvironment = __webpack_require__(31);

var createNodesFromMarkup = __webpack_require__(516);
var emptyFunction = __webpack_require__(37);
var invariant = __webpack_require__(17);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(171);
var ReactDOMComponentTree = __webpack_require__(38);
var SyntheticMouseEvent = __webpack_require__(217);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(22);

var PooledClass = __webpack_require__(103);

var getTextContentAccessor = __webpack_require__(606);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(126);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    controlsList: 0,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactReconciler = __webpack_require__(127);

var instantiateReactComponent = __webpack_require__(608);
var KeyEscapeUtils = __webpack_require__(334);
var shouldUpdateReactComponent = __webpack_require__(344);
var traverseAllChildren = __webpack_require__(611);
var warning = __webpack_require__(21);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":""}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(631);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(102)))

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(330);
var ReactDOMIDOperations = __webpack_require__(1426);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 1420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(26),
    _assign = __webpack_require__(22);

var React = __webpack_require__(131);
var ReactComponentEnvironment = __webpack_require__(336);
var ReactCurrentOwner = __webpack_require__(73);
var ReactErrorUtils = __webpack_require__(337);
var ReactInstanceMap = __webpack_require__(172);
var ReactInstrumentation = __webpack_require__(53);
var ReactNodeTypes = __webpack_require__(601);
var ReactReconciler = __webpack_require__(127);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(70);
var invariant = __webpack_require__(17);
var shallowEqual = __webpack_require__(120);
var shouldUpdateReactComponent = __webpack_require__(344);
var warning = __webpack_require__(21);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(38);
var ReactDefaultInjection = __webpack_require__(1434);
var ReactMount = __webpack_require__(600);
var ReactReconciler = __webpack_require__(127);
var ReactUpdates = __webpack_require__(65);
var ReactVersion = __webpack_require__(1447);

var findDOMNode = __webpack_require__(1463);
var getHostComponentFromComposite = __webpack_require__(605);
var renderSubtreeIntoContainer = __webpack_require__(1470);
var warning = __webpack_require__(21);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(26),
    _assign = __webpack_require__(22);

var AutoFocusUtils = __webpack_require__(1409);
var CSSPropertyOperations = __webpack_require__(1411);
var DOMLazyTree = __webpack_require__(125);
var DOMNamespaces = __webpack_require__(331);
var DOMProperty = __webpack_require__(126);
var DOMPropertyOperations = __webpack_require__(593);
var EventPluginHub = __webpack_require__(170);
var EventPluginRegistry = __webpack_require__(332);
var ReactBrowserEventEmitter = __webpack_require__(216);
var ReactDOMComponentFlags = __webpack_require__(594);
var ReactDOMComponentTree = __webpack_require__(38);
var ReactDOMInput = __webpack_require__(1427);
var ReactDOMOption = __webpack_require__(1428);
var ReactDOMSelect = __webpack_require__(595);
var ReactDOMTextarea = __webpack_require__(1431);
var ReactInstrumentation = __webpack_require__(53);
var ReactMultiChild = __webpack_require__(1440);
var ReactServerRenderingTransaction = __webpack_require__(1445);

var emptyFunction = __webpack_require__(37);
var escapeTextContentForBrowser = __webpack_require__(219);
var invariant = __webpack_require__(17);
var isEventSupported = __webpack_require__(343);
var shallowEqual = __webpack_require__(120);
var inputValueTracking = __webpack_require__(607);
var validateDOMNesting = __webpack_require__(345);
var warning = __webpack_require__(21);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);

        // We also check that we haven't missed a value update, such as a
        // Radio group shifting the checked value to another named radio input.
        inputValueTracking.updateValueIfChanged(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var validateDOMNesting = __webpack_require__(345);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(22);

var DOMLazyTree = __webpack_require__(125);
var ReactDOMComponentTree = __webpack_require__(38);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(330);
var ReactDOMComponentTree = __webpack_require__(38);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(26),
    _assign = __webpack_require__(22);

var DOMPropertyOperations = __webpack_require__(593);
var LinkedValueUtils = __webpack_require__(335);
var ReactDOMComponentTree = __webpack_require__(38);
var ReactUpdates = __webpack_require__(65);

var invariant = __webpack_require__(17);
var warning = __webpack_require__(21);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(22);

var React = __webpack_require__(131);
var ReactDOMComponentTree = __webpack_require__(38);
var ReactDOMSelect = __webpack_require__(595);

var warning = __webpack_require__(21);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(31);

var getNodeForCharacterOffset = __webpack_require__(1467);
var getTextContentAccessor = __webpack_require__(606);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(26),
    _assign = __webpack_require__(22);

var DOMChildrenOperations = __webpack_require__(330);
var DOMLazyTree = __webpack_require__(125);
var ReactDOMComponentTree = __webpack_require__(38);

var escapeTextContentForBrowser = __webpack_require__(219);
var invariant = __webpack_require__(17);
var validateDOMNesting = __webpack_require__(345);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(26),
    _assign = __webpack_require__(22);

var LinkedValueUtils = __webpack_require__(335);
var ReactDOMComponentTree = __webpack_require__(38);
var ReactUpdates = __webpack_require__(65);

var invariant = __webpack_require__(17);
var warning = __webpack_require__(21);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(26);

var invariant = __webpack_require__(17);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(22);

var ReactUpdates = __webpack_require__(65);
var Transaction = __webpack_require__(218);

var emptyFunction = __webpack_require__(37);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(1408);
var BeforeInputEventPlugin = __webpack_require__(1410);
var ChangeEventPlugin = __webpack_require__(1412);
var DefaultEventPluginOrder = __webpack_require__(1414);
var EnterLeaveEventPlugin = __webpack_require__(1415);
var HTMLDOMPropertyConfig = __webpack_require__(1417);
var ReactComponentBrowserEnvironment = __webpack_require__(1419);
var ReactDOMComponent = __webpack_require__(1422);
var ReactDOMComponentTree = __webpack_require__(38);
var ReactDOMEmptyComponent = __webpack_require__(1424);
var ReactDOMTreeTraversal = __webpack_require__(1432);
var ReactDOMTextComponent = __webpack_require__(1430);
var ReactDefaultBatchingStrategy = __webpack_require__(1433);
var ReactEventListener = __webpack_require__(1437);
var ReactInjection = __webpack_require__(1438);
var ReactReconcileTransaction = __webpack_require__(1443);
var SVGDOMPropertyConfig = __webpack_require__(1448);
var SelectEventPlugin = __webpack_require__(1449);
var SimpleEventPlugin = __webpack_require__(1450);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(170);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(22);

var EventListener = __webpack_require__(197);
var ExecutionEnvironment = __webpack_require__(31);
var PooledClass = __webpack_require__(103);
var ReactDOMComponentTree = __webpack_require__(38);
var ReactUpdates = __webpack_require__(65);

var getEventTarget = __webpack_require__(342);
var getUnboundedScrollPosition = __webpack_require__(517);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(126);
var EventPluginHub = __webpack_require__(170);
var EventPluginUtils = __webpack_require__(333);
var ReactComponentEnvironment = __webpack_require__(336);
var ReactEmptyComponent = __webpack_require__(596);
var ReactBrowserEventEmitter = __webpack_require__(216);
var ReactHostComponent = __webpack_require__(598);
var ReactUpdates = __webpack_require__(65);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var adler32 = __webpack_require__(1461);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(26);

var ReactComponentEnvironment = __webpack_require__(336);
var ReactInstanceMap = __webpack_require__(172);
var ReactInstrumentation = __webpack_require__(53);

var ReactCurrentOwner = __webpack_require__(73);
var ReactReconciler = __webpack_require__(127);
var ReactChildReconciler = __webpack_require__(1418);

var emptyFunction = __webpack_require__(37);
var flattenChildren = __webpack_require__(1464);
var invariant = __webpack_require__(17);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(26);

var invariant = __webpack_require__(17);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(22);

var CallbackQueue = __webpack_require__(592);
var PooledClass = __webpack_require__(103);
var ReactBrowserEventEmitter = __webpack_require__(216);
var ReactInputSelection = __webpack_require__(599);
var ReactInstrumentation = __webpack_require__(53);
var Transaction = __webpack_require__(218);
var ReactUpdateQueue = __webpack_require__(338);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactOwner = __webpack_require__(1441);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(22);

var PooledClass = __webpack_require__(103);
var Transaction = __webpack_require__(218);
var ReactInstrumentation = __webpack_require__(53);
var ReactServerUpdateQueue = __webpack_require__(1446);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(338);

var warning = __webpack_require__(21);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 1448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(171);
var ExecutionEnvironment = __webpack_require__(31);
var ReactDOMComponentTree = __webpack_require__(38);
var ReactInputSelection = __webpack_require__(599);
var SyntheticEvent = __webpack_require__(72);

var getActiveElement = __webpack_require__(199);
var isTextInputElement = __webpack_require__(609);
var shallowEqual = __webpack_require__(120);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 1450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(26);

var EventListener = __webpack_require__(197);
var EventPropagators = __webpack_require__(171);
var ReactDOMComponentTree = __webpack_require__(38);
var SyntheticAnimationEvent = __webpack_require__(1451);
var SyntheticClipboardEvent = __webpack_require__(1452);
var SyntheticEvent = __webpack_require__(72);
var SyntheticFocusEvent = __webpack_require__(1455);
var SyntheticKeyboardEvent = __webpack_require__(1457);
var SyntheticMouseEvent = __webpack_require__(217);
var SyntheticDragEvent = __webpack_require__(1454);
var SyntheticTouchEvent = __webpack_require__(1458);
var SyntheticTransitionEvent = __webpack_require__(1459);
var SyntheticUIEvent = __webpack_require__(173);
var SyntheticWheelEvent = __webpack_require__(1460);

var emptyFunction = __webpack_require__(37);
var getEventCharCode = __webpack_require__(340);
var invariant = __webpack_require__(17);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(72);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(72);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(72);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(217);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(173);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 1456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(72);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(173);

var getEventCharCode = __webpack_require__(340);
var getEventKey = __webpack_require__(1465);
var getEventModifierState = __webpack_require__(341);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(173);

var getEventModifierState = __webpack_require__(341);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(72);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(217);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(591);
var warning = __webpack_require__(21);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(26);

var ReactCurrentOwner = __webpack_require__(73);
var ReactDOMComponentTree = __webpack_require__(38);
var ReactInstanceMap = __webpack_require__(172);

var getHostComponentFromComposite = __webpack_require__(605);
var invariant = __webpack_require__(17);
var warning = __webpack_require__(21);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(334);
var traverseAllChildren = __webpack_require__(611);
var warning = __webpack_require__(21);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && __webpack_require__.i({"NODE_ENV":"production","PUBLIC_URL":""}) && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(631);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(102)))

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var getEventCharCode = __webpack_require__(340);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(31);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(219);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactMount = __webpack_require__(600);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.set = set;
exports.get = get;
exports.serialize = serialize;
exports.setEnvironment = setEnvironment;

var _objectAssign = _interopRequireDefault(__webpack_require__(22));

var _deepFreeze = _interopRequireDefault(__webpack_require__(1136));

var _serializeJavascript = _interopRequireDefault(__webpack_require__(1762));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var configuration = null;
var setOptions = {};
var currentEnvironment = null;
var validOptions = ['freeze', 'assign', 'environment'];
var booleanOptions = ['freeze', 'assign'];
var stringOptions = ['environment'];
var persistentOptions = ['freeze'];
var debugEnv = ['development', 'test'];

function set(newConfiguration) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (configuration && setOptions.freeze !== false) {
    throw new Error('react-global-configuration - Configuration is already set, the initial call should have \'freeze\' set to false to allow for this behaviour (e.g. in testing');
  }

  if (configuration == null) {
    configuration = {};
  }

  if (options) {
    for (var option in options) {
      //Check if is a valid option
      if (validOptions.indexOf(option) !== -1) {
        //Check value of option
        var value = options[option];

        if (stringOptions.indexOf(option) !== -1 && typeof value !== 'string') {
          throw new Error("react-global-configuration - Unexpected value type for ".concat(option, " : ").concat(_typeof(value), ", string expected"));
        }

        if (booleanOptions.indexOf(option) !== -1 && typeof value !== 'boolean') {
          throw new Error("react-global-configuration - Unexpected value type for ".concat(option, " : ").concat(_typeof(value), ", boolean expected"));
        }

        if (persistentOptions.indexOf(option) !== -1) {
          setOptions[option] = value;
        }
      } else {
        throw new Error("react-global-configuration - Unrecognised option '".concat(option, "' passed to set"));
      }
    }
  }

  var env = options.environment !== undefined ? options.environment : 'global';

  if (options.assign) {
    configuration[env] = (0, _objectAssign["default"])(getEnvironmentConfiguration(env), newConfiguration);
  } else {
    configuration[env] = newConfiguration;
  }

  if (setOptions.freeze !== false && Object.freeze && Object.getOwnPropertyNames) {
    configuration = (0, _deepFreeze["default"])(configuration);
  } else if (!Object.freeze || !Object.getOwnPropertyNames) {
    sayWarning('react-global-configuration - Could not call freeze as native functions arent\'t available');
  }
}

function get(key) {
  var fallbackValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!configuration) {
    sayWarning('react-global-configuration - Configuration has not been set.');
  }

  var value = fetchFromObject(getEnvironmentConfiguration(), key);

  if (currentEnvironment) {
    var config = getEnvironmentConfiguration(currentEnvironment);
    var envValue = fetchFromObject(config !== null ? config : {}, key);
    value = envValue !== undefined ? envValue : value;
  } //Fix to return null values


  if (value !== undefined) {
    return value;
  }

  if (key !== undefined) {
    value = fallbackValue;
  } else {
    sayWarning("react-global-configuration - There is no value with the key: ".concat(key));
    value = getEnvironmentConfiguration();
  }

  return value;
}

function serialize(env) {
  var configuration = getEnvironmentConfiguration(env);
  return (0, _serializeJavascript["default"])(configuration);
}

function setEnvironment(env) {
  if (env === undefined) {
    throw new Error('react-global-configuration - You have to define an environment');
  }

  if (env !== null && typeof env !== 'string') {
    throw new Error('react-global-configuration - Unexpected environment value, null or string expected');
  }

  return currentEnvironment = env;
}
/* **************************** */

/* Helpers
/* **************************** */


function getEnvironmentConfiguration(env) {
  env = env !== undefined ? env : 'global';
  return configuration && configuration[env] !== undefined ? configuration[env] : null;
}

function fetchFromObject(obj, key) {
  key = key !== undefined ? key : '';

  if (typeof obj === 'undefined') {
    return undefined;
  }

  var index = key.indexOf('.');

  if (index > -1) {
    return fetchFromObject(obj[key.substring(0, index)], key.substr(index + 1));
  }

  return obj[key];
}

function sayWarning(text) {
  if (debugEnv.indexOf("production")) {
    void 0;
  }
}

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'UNSAFE_componentWillReceiveProps',
		value: function UNSAFE_componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1473);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(33);
var DOMFactories = __webpack_require__(590);
var PropTypes = __webpack_require__(5);
var ExecutionEnvironment = __webpack_require__(1151);
var ModalPortal = React.createFactory(__webpack_require__(1476));
var ariaAppHider = __webpack_require__(1477);
var refCount = __webpack_require__(1479);
var elementClass = __webpack_require__(512);
var renderSubtreeIntoContainer = __webpack_require__(33).unstable_renderSubtreeIntoContainer;
var Assign = __webpack_require__(520);
var createReactClass = __webpack_require__(452);

var SafeHTMLElement = ExecutionEnvironment.canUseDOM ? window.HTMLElement : {};
var AppElement = ExecutionEnvironment.canUseDOM ? document.body : {appendChild: function() {}};

function getParentElement(parentSelector) {
  return parentSelector();
}

var Modal = createReactClass({

  displayName: 'Modal',
  statics: {
    setAppElement: function(element) {
        AppElement = ariaAppHider.setElement(element);
    },
    injectCSS: function() {
      "production" !== "production"
        && console.warn('React-Modal: injectCSS has been deprecated ' +
                        'and no longer has any effect. It will be removed in a later version');
    }
  },

  propTypes: {
    isOpen: PropTypes.bool.isRequired,
    style: PropTypes.shape({
      content: PropTypes.object,
      overlay: PropTypes.object
    }),
    portalClassName: PropTypes.string,
    bodyOpenClassName: PropTypes.string,
    appElement: PropTypes.instanceOf(SafeHTMLElement),
    onAfterOpen: PropTypes.func,
    onRequestClose: PropTypes.func,
    closeTimeoutMS: PropTypes.number,
    ariaHideApp: PropTypes.bool,
    shouldCloseOnOverlayClick: PropTypes.bool,
    parentSelector: PropTypes.func,
    role: PropTypes.string,
    contentLabel: PropTypes.string.isRequired
  },

  getDefaultProps: function () {
    return {
      isOpen: false,
      portalClassName: 'ReactModalPortal',
      bodyOpenClassName: 'ReactModal__Body--open',
      ariaHideApp: true,
      closeTimeoutMS: 0,
      shouldCloseOnOverlayClick: true,
      parentSelector: function () { return document.body; }
    };
  },

  componentDidMount: function() {
    this.node = document.createElement('div');
    this.node.className = this.props.portalClassName;

    if (this.props.isOpen) refCount.add(this);

    var parent = getParentElement(this.props.parentSelector);
    parent.appendChild(this.node);
    this.renderPortal(this.props);
  },

  componentWillUpdate: function(newProps) {
    if(newProps.portalClassName !== this.props.portalClassName) {
      this.node.className = newProps.portalClassName;
    }
  },

  componentWillReceiveProps: function(newProps) {
    if (newProps.isOpen) refCount.add(this);
    if (!newProps.isOpen) refCount.remove(this);
    var currentParent = getParentElement(this.props.parentSelector);
    var newParent = getParentElement(newProps.parentSelector);

    if(newParent !== currentParent) {
      currentParent.removeChild(this.node);
      newParent.appendChild(this.node);
    }

    this.renderPortal(newProps);
  },

  componentWillUnmount: function() {
    if (!this.node) return;

    refCount.remove(this);

    if (this.props.ariaHideApp) {
      ariaAppHider.show(this.props.appElement);
    }

    var state = this.portal.state;
    var now = Date.now();
    var closesAt = state.isOpen && this.props.closeTimeoutMS
      && (state.closesAt
        || now + this.props.closeTimeoutMS);

    if (closesAt) {
      if (!state.beforeClose) {
        this.portal.closeWithTimeout();
      }

      var that = this;
      setTimeout(function() { that.removePortal(); }, closesAt - now);
    } else {
      this.removePortal();
    }
  },

  removePortal: function() {
    ReactDOM.unmountComponentAtNode(this.node);
    var parent = getParentElement(this.props.parentSelector);
    parent.removeChild(this.node);

    if (refCount.count() === 0) {
      elementClass(document.body).remove(this.props.bodyOpenClassName);
    }
  },

  renderPortal: function(props) {
    if (props.isOpen || refCount.count() > 0) {
      elementClass(document.body).add(this.props.bodyOpenClassName);
    } else {
      elementClass(document.body).remove(this.props.bodyOpenClassName);
    }

    if (props.ariaHideApp) {
      ariaAppHider.toggle(props.isOpen, props.appElement);
    }

    this.portal = renderSubtreeIntoContainer(this, ModalPortal(Assign({}, props, {defaultStyles: Modal.defaultStyles})), this.node);
  },

  render: function () {
    return DOMFactories.noscript();
  }
});

Modal.defaultStyles = {
  overlay: {
    position        : 'fixed',
    top             : 0,
    left            : 0,
    right           : 0,
    bottom          : 0,
    backgroundColor : 'rgba(255, 255, 255, 0.75)'
  },
  content: {
    position                : 'absolute',
    top                     : '40px',
    left                    : '40px',
    right                   : '40px',
    bottom                  : '40px',
    border                  : '1px solid #ccc',
    background              : '#fff',
    overflow                : 'auto',
    WebkitOverflowScrolling : 'touch',
    borderRadius            : '4px',
    outline                 : 'none',
    padding                 : '20px'
  }
}

module.exports = Modal


/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

var React = __webpack_require__(0);
var DOMFactories = __webpack_require__(590);
var focusManager = __webpack_require__(1478);
var scopeTab = __webpack_require__(1480);
var Assign = __webpack_require__(520);
var createReactClass = __webpack_require__(452);

var div = DOMFactories.div;

// so that our CSS is statically analyzable
var CLASS_NAMES = {
  overlay: 'ReactModal__Overlay',
  content: 'ReactModal__Content'
};

var ModalPortal = module.exports = createReactClass({

  displayName: 'ModalPortal',
  shouldClose: null,

  getDefaultProps: function() {
    return {
      style: {
        overlay: {},
        content: {}
      }
    };
  },

  getInitialState: function() {
    return {
      afterOpen: false,
      beforeClose: false
    };
  },

  componentDidMount: function() {
    // Focus needs to be set when mounting and already open
    if (this.props.isOpen) {
      this.setFocusAfterRender(true);
      this.open();
    }
  },

  componentWillUnmount: function() {
    clearTimeout(this.closeTimer);
  },

  componentWillReceiveProps: function(newProps) {
    // Focus only needs to be set once when the modal is being opened
    if (!this.props.isOpen && newProps.isOpen) {
      this.setFocusAfterRender(true);
      this.open();
    } else if (this.props.isOpen && !newProps.isOpen) {
      this.close();
    }
  },

  componentDidUpdate: function () {
    if (this.focusAfterRender) {
      this.focusContent();
      this.setFocusAfterRender(false);
    }
  },

  setFocusAfterRender: function (focus) {
    this.focusAfterRender = focus;
  },

  afterClose: function () {
    focusManager.returnFocus();
    focusManager.teardownScopedFocus();
  },

  open: function () {
    if (this.state.afterOpen && this.state.beforeClose) {
      clearTimeout(this.closeTimer);
      this.setState({ beforeClose: false });
    } else {
      focusManager.setupScopedFocus(this.node);
      focusManager.markForFocusLater();
      this.setState({isOpen: true}, function() {
        this.setState({afterOpen: true});

        if (this.props.isOpen && this.props.onAfterOpen) {
          this.props.onAfterOpen();
        }
      }.bind(this));
    }
  },

  close: function() {
    if (this.props.closeTimeoutMS > 0)
      this.closeWithTimeout();
    else
      this.closeWithoutTimeout();
  },

  focusContent: function() {
    // Don't steal focus from inner elements
    if (!this.contentHasFocus()) {
      this.refs.content.focus();
    }
  },

  closeWithTimeout: function() {
    var closesAt = Date.now() + this.props.closeTimeoutMS;
    this.setState({beforeClose: true, closesAt: closesAt}, function() {
      this.closeTimer = setTimeout(this.closeWithoutTimeout, this.state.closesAt - Date.now());
    }.bind(this));
  },

  closeWithoutTimeout: function() {
    this.setState({
      beforeClose: false,
      isOpen: false,
      afterOpen: false,
      closesAt: null
    }, this.afterClose);
  },

  handleKeyDown: function(event) {
    if (event.keyCode == 9 /*tab*/) scopeTab(this.refs.content, event);
    if (event.keyCode == 27 /*esc*/) {
      event.preventDefault();
      this.requestClose(event);
    }
  },

  handleOverlayOnClick: function (event) {
    if (this.shouldClose === null) {
      this.shouldClose = true;
    }

    if (this.shouldClose && this.props.shouldCloseOnOverlayClick) {
      if (this.ownerHandlesClose())
        this.requestClose(event);
      else
        this.focusContent();
    }
    this.shouldClose = null;
  },

  handleContentOnClick: function () {
    this.shouldClose = false;
  },

  requestClose: function(event) {
    if (this.ownerHandlesClose())
      this.props.onRequestClose(event);
  },

  ownerHandlesClose: function() {
    return this.props.onRequestClose;
  },

  shouldBeClosed: function() {
    return !this.state.isOpen && !this.state.beforeClose;
  },

  contentHasFocus: function() {
    return document.activeElement === this.refs.content || this.refs.content.contains(document.activeElement);
  },

  buildClassName: function(which, additional) {
    var classNames = (typeof additional === 'object') ? additional : {
      base: CLASS_NAMES[which],
      afterOpen: CLASS_NAMES[which] + "--after-open",
      beforeClose: CLASS_NAMES[which] + "--before-close"
    };
    var className = classNames.base;
    if (this.state.afterOpen) { className += " " + classNames.afterOpen; }
    if (this.state.beforeClose) { className += " " + classNames.beforeClose; }
    return (typeof additional === 'string' && additional) ? [className, additional].join(" ") : className;
  },

  render: function() {
    var contentStyles = (this.props.className) ? {} : this.props.defaultStyles.content;
    var overlayStyles = (this.props.overlayClassName) ? {} : this.props.defaultStyles.overlay;

    return this.shouldBeClosed() ? div() : (
      div({
        ref: "overlay",
        className: this.buildClassName('overlay', this.props.overlayClassName),
        style: Assign({}, overlayStyles, this.props.style.overlay || {}),
        onClick: this.handleOverlayOnClick
      },
        div({
          ref: "content",
          style: Assign({}, contentStyles, this.props.style.content || {}),
          className: this.buildClassName('content', this.props.className),
          tabIndex: "-1",
          onKeyDown: this.handleKeyDown,
          onClick: this.handleContentOnClick,
          role: this.props.role,
          "aria-label": this.props.contentLabel
        },
          this.props.children
        )
      )
    );
  }
});


/***/ }),
/* 1477 */
/***/ (function(module, exports) {

var _element = typeof document !== 'undefined' ? document.body : null;

function setElement(element) {
  if (typeof element === 'string') {
    var el = document.querySelectorAll(element);
    element = 'length' in el ? el[0] : el;
  }
  _element = element || _element;
  return _element;
}

function hide(appElement) {
  validateElement(appElement);
  (appElement || _element).setAttribute('aria-hidden', 'true');
}

function show(appElement) {
  validateElement(appElement);
  (appElement || _element).removeAttribute('aria-hidden');
}

function toggle(shouldHide, appElement) {
  if (shouldHide)
    hide(appElement);
  else
    show(appElement);
}

function validateElement(appElement) {
  if (!appElement && !_element)
    throw new Error('react-modal: You must set an element with `Modal.setAppElement(el)` to make this accessible');
}

function resetForTesting() {
  _element = document.body;
}

exports.toggle = toggle;
exports.setElement = setElement;
exports.show = show;
exports.hide = hide;
exports.resetForTesting = resetForTesting;


/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

var findTabbable = __webpack_require__(613);
var focusLaterElements = [];
var modalElement = null;
var needToFocus = false;

function handleBlur(event) {
  needToFocus = true;
}

function handleFocus(event) {
  if (needToFocus) {
    needToFocus = false;
    if (!modalElement) {
      return;
    }
    // need to see how jQuery shims document.on('focusin') so we don't need the
    // setTimeout, firefox doesn't support focusin, if it did, we could focus
    // the element outside of a setTimeout. Side-effect of this implementation
    // is that the document.body gets focus, and then we focus our element right
    // after, seems fine.
    setTimeout(function() {
      if (modalElement.contains(document.activeElement))
        return;
      var el = (findTabbable(modalElement)[0] || modalElement);
      el.focus();
    }, 0);
  }
}

exports.markForFocusLater = function() {
  focusLaterElements.push(document.activeElement);
};

exports.returnFocus = function() {
  var toFocus = null;
  try {
    toFocus = focusLaterElements.pop();
    toFocus.focus();
    return;
  }
  catch (e) {
    console.warn('You tried to return focus to '+toFocus+' but it is not in the DOM anymore');
  }
};

exports.setupScopedFocus = function(element) {
  modalElement = element;

  if (window.addEventListener) {
    window.addEventListener('blur', handleBlur, false);
    document.addEventListener('focus', handleFocus, true);
  } else {
    window.attachEvent('onBlur', handleBlur);
    document.attachEvent('onFocus', handleFocus);
  }
};

exports.teardownScopedFocus = function() {
  modalElement = null;

  if (window.addEventListener) {
    window.removeEventListener('blur', handleBlur);
    document.removeEventListener('focus', handleFocus);
  } else {
    window.detachEvent('onBlur', handleBlur);
    document.detachEvent('onFocus', handleFocus);
  }
};


/***/ }),
/* 1479 */
/***/ (function(module, exports) {

var modals = [];

module.exports = {
  add: function (element) {
    if (modals.indexOf(element) === -1) {
      modals.push(element);
    }
  },
  remove: function (element) {
    var index = modals.indexOf(element);
    if (index === -1) {
      return;
    }
    modals.splice(index, 1);
  },
  count: function () {
    return modals.length;
  }
};


/***/ }),
/* 1480 */
/***/ (function(module, exports, __webpack_require__) {

var findTabbable = __webpack_require__(613);

module.exports = function(node, event) {
  var tabbable = findTabbable(node);
  if (!tabbable.length) {
      event.preventDefault();
      return;
  }
  var finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
  var leavingFinalTabbable = (
    finalTabbable === document.activeElement ||
    // handle immediate shift+tab after opening with mouse
    node === document.activeElement
  );
  if (!leavingFinalTabbable) return;
  event.preventDefault();
  var target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
  target.focus();
};


/***/ }),
/* 1481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1475);



/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return testPassiveEventSupport; });
// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;

  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);

  return passive;
};

/***/ }),
/* 1483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isNodeFound */
/* harmony export (immutable) */ __webpack_exports__["b"] = findHighest;
/* harmony export (immutable) */ __webpack_exports__["a"] = clickedScrollbar;
/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  }
  // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }
  return current.classList.contains(ignoreClass);
}

/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */
function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  }

  // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.
  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }
    current = current.parentNode;
  }
  return current;
}

/**
 * Check if the browser scrollbar was clicked
 */
function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

/***/ }),
/* 1484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function autoInc() {
  var seed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return function () {
    return ++seed;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (autoInc());

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(209);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(33);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(221);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(128);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
      if (!_this._overlayTarget) {
        _this._overlayTarget = document.createElement('div');
        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
        _this._portalContainerNode.appendChild(_this._overlayTarget);
      }
    }, _this._unmountOverlayTarget = function () {
      if (_this._overlayTarget) {
        _this._portalContainerNode.removeChild(_this._overlayTarget);
        _this._overlayTarget = null;
      }
      _this._portalContainerNode = null;
    }, _this._renderOverlay = function () {
      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);

      // Save reference for future access.
      if (overlay !== null) {
        _this._mountOverlayTarget();

        var initialRender = !_this._overlayInstance;

        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
          if (initialRender && _this.props.onRendered) {
            _this.props.onRendered();
          }
        });
      } else {
        // Unrender if the component is null for transitions to null
        _this._unrenderOverlay();
        _this._unmountOverlayTarget();
      }
    }, _this._unrenderOverlay = function () {
      if (_this._overlayTarget) {
        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
        _this._overlayInstance = null;
      }
    }, _this.getMountNode = function () {
      return _this._overlayTarget;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this._renderOverlay();
  };

  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
    this._renderOverlay();
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this._overlayTarget && nextProps.container !== this.props.container) {
      this._portalContainerNode.removeChild(this._overlayTarget);
      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
      this._portalContainerNode.appendChild(this._overlayTarget);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
    this._unrenderOverlay();
    this._unmountOverlayTarget();
  };

  Portal.prototype.render = function render() {
    return null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = Portal;
module.exports = exports['default'];

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _activeElement = __webpack_require__(503);

var _activeElement2 = _interopRequireDefault(_activeElement);

var _contains = __webpack_require__(119);

var _contains2 = _interopRequireDefault(_contains);

var _inDOM = __webpack_require__(84);

var _inDOM2 = _interopRequireDefault(_inDOM);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(209);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _deprecated = __webpack_require__(1304);

var _deprecated2 = _interopRequireDefault(_deprecated);

var _elementType = __webpack_require__(30);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(33);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _warning = __webpack_require__(57);

var _warning2 = _interopRequireDefault(_warning);

var _ModalManager = __webpack_require__(1487);

var _ModalManager2 = _interopRequireDefault(_ModalManager);

var _Portal = __webpack_require__(614);

var _Portal2 = _interopRequireDefault(_Portal);

var _RefHolder = __webpack_require__(1490);

var _RefHolder2 = _interopRequireDefault(_RefHolder);

var _addEventListener = __webpack_require__(617);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _addFocusListener = __webpack_require__(1491);

var _addFocusListener2 = _interopRequireDefault(_addFocusListener);

var _getContainer = __webpack_require__(221);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(128);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prop-types */

var modalManager = new _ModalManager2.default();

/**
 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
 * The Modal component renders its `children` node in front of a backdrop component.
 *
 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
 *
 * - Manages dialog stacking when one-at-a-time just isn't enough.
 * - Creates a backdrop, for disabling interaction below the modal.
 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
 * - It disables scrolling of the page content while open.
 * - Adds the appropriate ARIA roles are automatically.
 * - Easily pluggable animations via a `<Transition/>` component.
 *
 * Note that, in the same way the backdrop element prevents users from clicking or interacting
 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
 * interact with page content while the Modal is open. To do this, we use a common technique of applying
 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
 * React hierarchy (such as the default: document.body).
 */

var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  Modal.prototype.omitProps = function omitProps(props, propTypes) {

    var keys = Object.keys(props);
    var newProps = {};
    keys.map(function (prop) {
      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
        newProps[prop] = props[prop];
      }
    });

    return newProps;
  };

  Modal.prototype.render = function render() {
    var _props = this.props,
        show = _props.show,
        container = _props.container,
        children = _props.children,
        Transition = _props.transition,
        backdrop = _props.backdrop,
        dialogTransitionTimeout = _props.dialogTransitionTimeout,
        className = _props.className,
        style = _props.style,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered;


    var dialog = _react2.default.Children.only(children);
    var filteredProps = this.omitProps(this.props, Modal.propTypes);

    var mountModal = show || Transition && !this.state.exited;
    if (!mountModal) {
      return null;
    }

    var _dialog$props = dialog.props,
        role = _dialog$props.role,
        tabIndex = _dialog$props.tabIndex;


    if (role === undefined || tabIndex === undefined) {
      dialog = (0, _react.cloneElement)(dialog, {
        role: role === undefined ? 'document' : role,
        tabIndex: tabIndex == null ? '-1' : tabIndex
      });
    }

    if (Transition) {
      dialog = _react2.default.createElement(
        Transition,
        {
          transitionAppear: true,
          unmountOnExit: true,
          'in': show,
          timeout: dialogTransitionTimeout,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.handleHidden,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        },
        dialog
      );
    }

    return _react2.default.createElement(
      _Portal2.default,
      {
        ref: this.setMountNode,
        container: container,
        onRendered: this.onPortalRendered
      },
      _react2.default.createElement(
        'div',
        _extends({
          ref: this.setModalNodeRef,
          role: role || 'dialog'
        }, filteredProps, {
          style: style,
          className: className
        }),
        backdrop && this.renderBackdrop(),
        _react2.default.createElement(
          _RefHolder2.default,
          { ref: this.setDialogRef },
          dialog
        )
      )
    );
  };

  Modal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ exited: false });
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      this.setState({ exited: true });
    }
  };

  Modal.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    if (!this.props.show && nextProps.show) {
      this.checkForFocus();
    }
  };

  Modal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    if (this.props.show) {
      this.onShow();
    }
  };

  Modal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var transition = this.props.transition;


    if (prevProps.show && !this.props.show && !transition) {
      // Otherwise handleHidden will call this.
      this.onHide();
    } else if (!prevProps.show && this.props.show) {
      this.onShow();
    }
  };

  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
    var _props2 = this.props,
        show = _props2.show,
        transition = _props2.transition;


    this._isMounted = false;

    if (show || transition && !this.state.exited) {
      this.onHide();
    }
  };

  Modal.prototype.autoFocus = function autoFocus() {
    if (!this.props.autoFocus) {
      return;
    }

    var dialogElement = this.getDialogElement();
    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));

    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
      this.lastFocus = currentActiveElement;

      if (!dialogElement.hasAttribute('tabIndex')) {
        (0, _warning2.default)(false, 'The modal content node does not accept focus. For the benefit of ' + 'assistive technologies, the tabIndex of the node is being set ' + 'to "-1".');

        dialogElement.setAttribute('tabIndex', -1);
      }

      dialogElement.focus();
    }
  };

  Modal.prototype.restoreLastFocus = function restoreLastFocus() {
    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
    if (this.lastFocus && this.lastFocus.focus) {
      this.lastFocus.focus();
      this.lastFocus = null;
    }
  };

  Modal.prototype.getDialogElement = function getDialogElement() {
    return _reactDom2.default.findDOMNode(this.dialog);
  };

  Modal.prototype.isTopModal = function isTopModal() {
    return this.props.manager.isTopModal(this);
  };

  return Modal;
}(_react2.default.Component);

Modal.propTypes = _extends({}, _Portal2.default.propTypes, {

  /**
   * Set the visibility of the Modal
   */
  show: _propTypes2.default.bool,

  /**
   * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
   *
   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
   * page content can be placed behind a virtual backdrop as well as a visual one.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * A callback fired when the Modal is opening.
   */
  onShow: _propTypes2.default.func,

  /**
   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
   *
   * The `onHide` callback only signals intent from the Modal,
   * you must actually set the `show` prop to `false` for the Modal to close.
   */
  onHide: _propTypes2.default.func,

  /**
   * Include a backdrop component.
   */
  backdrop: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['static'])]),

  /**
   * A function that returns a backdrop component. Useful for custom
   * backdrop rendering.
   *
   * ```js
   *  renderBackdrop={props => <MyBackdrop {...props} />}
   * ```
   */
  renderBackdrop: _propTypes2.default.func,

  /**
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   */
  onEscapeKeyDown: _propTypes2.default.func,

  /**
   * Support for this function will be deprecated. Please use `onEscapeKeyDown` instead
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   * @deprecated
   */
  onEscapeKeyUp: (0, _deprecated2.default)(_propTypes2.default.func, 'Please use onEscapeKeyDown instead for consistency'),

  /**
   * A callback fired when the backdrop, if specified, is clicked.
   */
  onBackdropClick: _propTypes2.default.func,

  /**
   * A style object for the backdrop component.
   */
  backdropStyle: _propTypes2.default.object,

  /**
   * A css class or classes for the backdrop component.
   */
  backdropClassName: _propTypes2.default.string,

  /**
   * A css class or set of classes applied to the modal container when the modal is open,
   * and removed when it is closed.
   */
  containerClassName: _propTypes2.default.string,

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: _propTypes2.default.bool,

  /**
   * A `<Transition/>` component to use for the dialog and backdrop components.
   */
  transition: _elementType2.default,

  /**
   * The `timeout` of the dialog transition if specified. This number is used to ensure that
   * transition callbacks are always fired, even if browser transition events are canceled.
   *
   * See the Transition `timeout` prop for more infomation.
   */
  dialogTransitionTimeout: _propTypes2.default.number,

  /**
   * The `timeout` of the backdrop transition if specified. This number is used to
   * ensure that transition callbacks are always fired, even if browser transition events are canceled.
   *
   * See the Transition `timeout` prop for more infomation.
   */
  backdropTransitionTimeout: _propTypes2.default.number,

  /**
   * When `true` The modal will automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes. This also
   * works correctly with any Modal children that have the `autoFocus` prop.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  autoFocus: _propTypes2.default.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while open.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  enforceFocus: _propTypes2.default.bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: _propTypes2.default.bool,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: _propTypes2.default.func,

  /**
   * A ModalManager instance used to track and manage the state of open
   * Modals. Useful when customizing how modals interact within a container
   */
  manager: _propTypes2.default.object.isRequired
});
Modal.defaultProps = {
  show: false,
  backdrop: true,
  keyboard: true,
  autoFocus: true,
  enforceFocus: true,
  restoreFocus: true,
  onHide: function onHide() {},
  manager: modalManager,
  renderBackdrop: function renderBackdrop(props) {
    return _react2.default.createElement('div', props);
  }
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.state = { exited: !this.props.show };

  this.renderBackdrop = function () {
    var _props3 = _this2.props,
        backdropStyle = _props3.backdropStyle,
        backdropClassName = _props3.backdropClassName,
        renderBackdrop = _props3.renderBackdrop,
        Transition = _props3.transition,
        backdropTransitionTimeout = _props3.backdropTransitionTimeout;


    var backdropRef = function backdropRef(ref) {
      return _this2.backdrop = ref;
    };

    var backdrop = renderBackdrop({
      ref: backdropRef,
      style: backdropStyle,
      className: backdropClassName,
      onClick: _this2.handleBackdropClick
    });

    if (Transition) {
      backdrop = _react2.default.createElement(
        Transition,
        { transitionAppear: true,
          'in': _this2.props.show,
          timeout: backdropTransitionTimeout
        },
        backdrop
      );
    }

    return backdrop;
  };

  this.onPortalRendered = function () {
    _this2.autoFocus();

    if (_this2.props.onShow) {
      _this2.props.onShow();
    }
  };

  this.onShow = function () {
    var doc = (0, _ownerDocument2.default)(_this2);
    var container = (0, _getContainer2.default)(_this2.props.container, doc.body);

    _this2.props.manager.add(_this2, container, _this2.props.containerClassName);

    _this2._onDocumentKeydownListener = (0, _addEventListener2.default)(doc, 'keydown', _this2.handleDocumentKeyDown);

    _this2._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this2.handleDocumentKeyUp);

    _this2._onFocusinListener = (0, _addFocusListener2.default)(_this2.enforceFocus);
  };

  this.onHide = function () {
    _this2.props.manager.remove(_this2);

    _this2._onDocumentKeydownListener.remove();

    _this2._onDocumentKeyupListener.remove();

    _this2._onFocusinListener.remove();

    if (_this2.props.restoreFocus) {
      _this2.restoreLastFocus();
    }
  };

  this.setMountNode = function (ref) {
    _this2.mountNode = ref ? ref.getMountNode() : ref;
  };

  this.setModalNodeRef = function (ref) {
    _this2.modalNode = ref;
  };

  this.setDialogRef = function (ref) {
    _this2.dialog = ref;
  };

  this.handleHidden = function () {
    _this2.setState({ exited: true });
    _this2.onHide();

    if (_this2.props.onExited) {
      var _props4;

      (_props4 = _this2.props).onExited.apply(_props4, arguments);
    }
  };

  this.handleBackdropClick = function (e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    if (_this2.props.onBackdropClick) {
      _this2.props.onBackdropClick(e);
    }

    if (_this2.props.backdrop === true) {
      _this2.props.onHide();
    }
  };

  this.handleDocumentKeyDown = function (e) {
    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
      if (_this2.props.onEscapeKeyDown) {
        _this2.props.onEscapeKeyDown(e);
      }

      _this2.props.onHide();
    }
  };

  this.handleDocumentKeyUp = function (e) {
    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
      if (_this2.props.onEscapeKeyUp) {
        _this2.props.onEscapeKeyUp(e);
      }
    }
  };

  this.checkForFocus = function () {
    if (_inDOM2.default) {
      _this2.lastFocus = (0, _activeElement2.default)();
    }
  };

  this.enforceFocus = function () {
    if (!_this2.props.enforceFocus || !_this2._isMounted || !_this2.isTopModal()) {
      return;
    }

    var dialogElement = _this2.getDialogElement();
    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));

    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
      dialogElement.focus();
    }
  };
};

Modal.Manager = _ModalManager2.default;

exports.default = Modal;
module.exports = exports['default'];

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class = __webpack_require__(1137);

var _class2 = _interopRequireDefault(_class);

var _style = __webpack_require__(196);

var _style2 = _interopRequireDefault(_style);

var _scrollbarSize = __webpack_require__(511);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _isOverflowing = __webpack_require__(618);

var _isOverflowing2 = _interopRequireDefault(_isOverflowing);

var _manageAriaHidden = __webpack_require__(1493);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function findIndexOf(arr, cb) {
  var idx = -1;
  arr.some(function (d, i) {
    if (cb(d, i)) {
      idx = i;
      return true;
    }
  });
  return idx;
}

function findContainer(data, modal) {
  return findIndexOf(data, function (d) {
    return d.modals.indexOf(modal) !== -1;
  });
}

function setContainerStyle(state, container) {
  var style = { overflow: 'hidden' };

  // we are only interested in the actual `style` here
  // becasue we will override it
  state.style = {
    overflow: container.style.overflow,
    paddingRight: container.style.paddingRight
  };

  if (state.overflowing) {
    // use computed style, here to get the real padding
    // to add our scrollbar width
    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
  }

  (0, _style2.default)(container, style);
}

function removeContainerStyle(_ref, container) {
  var style = _ref.style;


  Object.keys(style).forEach(function (key) {
    return container.style[key] = style[key];
  });
}
/**
 * Proper state managment for containers and the modals in those containers.
 *
 * @internal Used by the Modal to ensure proper styling of containers.
 */

var ModalManager = function ModalManager() {
  var _this = this;

  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
      hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
      _ref2$handleContainer = _ref2.handleContainerOverflow,
      handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;

  _classCallCheck(this, ModalManager);

  this.add = function (modal, container, className) {
    var modalIdx = _this.modals.indexOf(modal);
    var containerIdx = _this.containers.indexOf(container);

    if (modalIdx !== -1) {
      return modalIdx;
    }

    modalIdx = _this.modals.length;
    _this.modals.push(modal);

    if (_this.hideSiblingNodes) {
      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
    }

    if (containerIdx !== -1) {
      _this.data[containerIdx].modals.push(modal);
      return modalIdx;
    }

    var data = {
      modals: [modal],
      //right now only the first modal of a container will have its classes applied
      classes: className ? className.split(/\s+/) : [],

      overflowing: (0, _isOverflowing2.default)(container)
    };

    if (_this.handleContainerOverflow) {
      setContainerStyle(data, container);
    }

    data.classes.forEach(_class2.default.addClass.bind(null, container));

    _this.containers.push(container);
    _this.data.push(data);

    return modalIdx;
  };

  this.remove = function (modal) {
    var modalIdx = _this.modals.indexOf(modal);

    if (modalIdx === -1) {
      return;
    }

    var containerIdx = findContainer(_this.data, modal);
    var data = _this.data[containerIdx];
    var container = _this.containers[containerIdx];

    data.modals.splice(data.modals.indexOf(modal), 1);

    _this.modals.splice(modalIdx, 1);

    // if that was the last modal in a container,
    // clean up the container
    if (data.modals.length === 0) {
      data.classes.forEach(_class2.default.removeClass.bind(null, container));

      if (_this.handleContainerOverflow) {
        removeContainerStyle(data, container);
      }

      if (_this.hideSiblingNodes) {
        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
      }
      _this.containers.splice(containerIdx, 1);
      _this.data.splice(containerIdx, 1);
    } else if (_this.hideSiblingNodes) {
      //otherwise make sure the next top modal is visible to a SR
      (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
    }
  };

  this.isTopModal = function (modal) {
    return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
  };

  this.hideSiblingNodes = hideSiblingNodes;
  this.handleContainerOverflow = handleContainerOverflow;
  this.modals = [];
  this.containers = [];
  this.data = [];
};

exports.default = ModalManager;
module.exports = exports['default'];

/***/ }),
/* 1488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elementType = __webpack_require__(30);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Portal = __webpack_require__(614);

var _Portal2 = _interopRequireDefault(_Portal);

var _Position = __webpack_require__(1489);

var _Position2 = _interopRequireDefault(_Position);

var _RootCloseWrapper = __webpack_require__(615);

var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
 */
var Overlay = function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay(props, context) {
    _classCallCheck(this, Overlay);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleHidden = function () {
      _this.setState({ exited: true });

      if (_this.props.onExited) {
        var _this$props;

        (_this$props = _this.props).onExited.apply(_this$props, arguments);
      }
    };

    _this.state = { exited: !props.show };
    _this.onHiddenListener = _this.handleHidden.bind(_this);
    return _this;
  }

  Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ exited: false });
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      this.setState({ exited: true });
    }
  };

  Overlay.prototype.render = function render() {
    var _props = this.props,
        container = _props.container,
        containerPadding = _props.containerPadding,
        target = _props.target,
        placement = _props.placement,
        shouldUpdatePosition = _props.shouldUpdatePosition,
        rootClose = _props.rootClose,
        children = _props.children,
        Transition = _props.transition,
        props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);

    // Don't un-render the overlay while it's transitioning out.


    var mountOverlay = props.show || Transition && !this.state.exited;
    if (!mountOverlay) {
      // Don't bother showing anything if we don't have to.
      return null;
    }

    var child = children;

    // Position is be inner-most because it adds inline styles into the child,
    // which the other wrappers don't forward correctly.
    child = _react2.default.createElement(
      _Position2.default,
      { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
      child
    );

    if (Transition) {
      var onExit = props.onExit,
          onExiting = props.onExiting,
          onEnter = props.onEnter,
          onEntering = props.onEntering,
          onEntered = props.onEntered;

      // This animates the child node by injecting props, so it must precede
      // anything that adds a wrapping div.

      child = _react2.default.createElement(
        Transition,
        {
          'in': props.show,
          transitionAppear: true,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.onHiddenListener,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        },
        child
      );
    }

    // This goes after everything else because it adds a wrapping div.
    if (rootClose) {
      child = _react2.default.createElement(
        _RootCloseWrapper2.default,
        { onRootClose: props.onHide },
        child
      );
    }

    return _react2.default.createElement(
      _Portal2.default,
      { container: container },
      child
    );
  };

  return Overlay;
}(_react2.default.Component);

Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {

  /**
   * Set the visibility of the Overlay
   */
  show: _propTypes2.default.bool,

  /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */
  rootClose: _propTypes2.default.bool,

  /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */
  onHide: function onHide(props) {
    var propType = _propTypes2.default.func;
    if (props.rootClose) {
      propType = propType.isRequired;
    }

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return propType.apply(undefined, [props].concat(args));
  },


  /**
   * A `<Transition/>` component used to animate the overlay changes visibility.
   */
  transition: _elementType2.default,

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: _propTypes2.default.func
});

exports.default = Overlay;
module.exports = exports['default'];

/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = __webpack_require__(7);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(209);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(33);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _calculatePosition = __webpack_require__(1492);

var _calculatePosition2 = _interopRequireDefault(_calculatePosition);

var _getContainer = __webpack_require__(221);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(128);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The Position component calculates the coordinates for its child, to position
 * it relative to a `target` component or node. Useful for creating callouts
 * and tooltips, the Position component injects a `style` props with `left` and
 * `top` values for positioning your component.
 *
 * It also injects "arrow" `left`, and `top` values for styling callout arrows
 * for giving your components a sense of directionality.
 */
var Position = function (_React$Component) {
  _inherits(Position, _React$Component);

  function Position(props, context) {
    _classCallCheck(this, Position);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.getTarget = function () {
      var target = _this.props.target;

      var targetElement = typeof target === 'function' ? target() : target;
      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
    };

    _this.maybeUpdatePosition = function (placementChanged) {
      var target = _this.getTarget();

      if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
        return;
      }

      _this.updatePosition(target);
    };

    _this.state = {
      positionLeft: 0,
      positionTop: 0,
      arrowOffsetLeft: null,
      arrowOffsetTop: null
    };

    _this._needsFlush = false;
    _this._lastTarget = null;
    return _this;
  }

  Position.prototype.componentDidMount = function componentDidMount() {
    this.updatePosition(this.getTarget());
  };

  Position.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
    this._needsFlush = true;
  };

  Position.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this._needsFlush) {
      this._needsFlush = false;
      this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
    }
  };

  Position.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        props = _objectWithoutProperties(_props, ['children', 'className']);

    var _state = this.state,
        positionLeft = _state.positionLeft,
        positionTop = _state.positionTop,
        arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);

    // These should not be forwarded to the child.


    delete props.target;
    delete props.container;
    delete props.containerPadding;
    delete props.shouldUpdatePosition;

    var child = _react2.default.Children.only(children);
    return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
      // FIXME: Don't forward `positionLeft` and `positionTop` via both props
      // and `props.style`.
      positionLeft: positionLeft,
      positionTop: positionTop,
      className: (0, _classnames2.default)(className, child.props.className),
      style: _extends({}, child.props.style, {
        left: positionLeft,
        top: positionTop
      })
    }));
  };

  Position.prototype.updatePosition = function updatePosition(target) {
    this._lastTarget = target;

    if (!target) {
      this.setState({
        positionLeft: 0,
        positionTop: 0,
        arrowOffsetLeft: null,
        arrowOffsetTop: null
      });

      return;
    }

    var overlay = _reactDom2.default.findDOMNode(this);
    var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);

    this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
  };

  return Position;
}(_react2.default.Component);

Position.propTypes = {
  /**
   * A node, element, or function that returns either. The child will be
   * be positioned next to the `target` specified.
   */
  target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * "offsetParent" of the component
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
  /**
   * Minimum spacing in pixels between container border and component border
   */
  containerPadding: _propTypes2.default.number,
  /**
   * How to position the component relative to the target
   */
  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
  /**
   * Whether the position should be changed on each update
   */
  shouldUpdatePosition: _propTypes2.default.bool
};

Position.displayName = 'Position';

Position.defaultProps = {
  containerPadding: 0,
  placement: 'right',
  shouldUpdatePosition: false
};

exports.default = Position;
module.exports = exports['default'];

/***/ }),
/* 1490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  children: _propTypes2.default.node
};

/**
 * Internal helper component to allow attaching a non-conflicting ref to a
 * child element that may not accept refs.
 */

var RefHolder = function (_React$Component) {
  _inherits(RefHolder, _React$Component);

  function RefHolder() {
    _classCallCheck(this, RefHolder);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  RefHolder.prototype.render = function render() {
    return this.props.children;
  };

  return RefHolder;
}(_react2.default.Component);

RefHolder.propTypes = propTypes;

exports.default = RefHolder;
module.exports = exports['default'];

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = addFocusListener;
/**
 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
 *
 * We only allow one Listener at a time to avoid stack overflows
 */
function addFocusListener(handler) {
  var useFocusin = !document.addEventListener;
  var remove = void 0;

  if (useFocusin) {
    document.attachEvent('onfocusin', handler);
    remove = function remove() {
      return document.detachEvent('onfocusin', handler);
    };
  } else {
    document.addEventListener('focus', handler, true);
    remove = function remove() {
      return document.removeEventListener('focus', handler, true);
    };
  }

  return { remove: remove };
}
module.exports = exports['default'];

/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = calculatePosition;

var _offset = __webpack_require__(507);

var _offset2 = _interopRequireDefault(_offset);

var _position = __webpack_require__(1142);

var _position2 = _interopRequireDefault(_position);

var _scrollTop = __webpack_require__(508);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _ownerDocument = __webpack_require__(128);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainerDimensions(containerNode) {
  var width = void 0,
      height = void 0,
      scroll = void 0;

  if (containerNode.tagName === 'BODY') {
    width = window.innerWidth;
    height = window.innerHeight;

    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
  } else {
    var _getOffset = (0, _offset2.default)(containerNode);

    width = _getOffset.width;
    height = _getOffset.height;

    scroll = (0, _scrollTop2.default)(containerNode);
  }

  return { width: width, height: height, scroll: scroll };
}

function getTopDelta(top, overlayHeight, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerScroll = containerDimensions.scroll;
  var containerHeight = containerDimensions.height;

  var topEdgeOffset = top - padding - containerScroll;
  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;

  if (topEdgeOffset < 0) {
    return -topEdgeOffset;
  } else if (bottomEdgeOffset > containerHeight) {
    return containerHeight - bottomEdgeOffset;
  } else {
    return 0;
  }
}

function getLeftDelta(left, overlayWidth, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerWidth = containerDimensions.width;

  var leftEdgeOffset = left - padding;
  var rightEdgeOffset = left + padding + overlayWidth;

  if (leftEdgeOffset < 0) {
    return -leftEdgeOffset;
  } else if (rightEdgeOffset > containerWidth) {
    return containerWidth - rightEdgeOffset;
  }

  return 0;
}

function calculatePosition(placement, overlayNode, target, container, padding) {
  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);

  var _getOffset2 = (0, _offset2.default)(overlayNode),
      overlayHeight = _getOffset2.height,
      overlayWidth = _getOffset2.width;

  var positionLeft = void 0,
      positionTop = void 0,
      arrowOffsetLeft = void 0,
      arrowOffsetTop = void 0;

  if (placement === 'left' || placement === 'right') {
    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;

    if (placement === 'left') {
      positionLeft = childOffset.left - overlayWidth;
    } else {
      positionLeft = childOffset.left + childOffset.width;
    }

    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);

    positionTop += topDelta;
    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
    arrowOffsetLeft = void 0;
  } else if (placement === 'top' || placement === 'bottom') {
    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;

    if (placement === 'top') {
      positionTop = childOffset.top - overlayHeight;
    } else {
      positionTop = childOffset.top + childOffset.height;
    }

    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);

    positionLeft += leftDelta;
    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
    arrowOffsetTop = void 0;
  } else {
    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
  }

  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
}
module.exports = exports['default'];

/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ariaHidden = ariaHidden;
exports.hideSiblings = hideSiblings;
exports.showSiblings = showSiblings;

var BLACKLIST = ['template', 'script', 'style'];

var isHidable = function isHidable(_ref) {
  var nodeType = _ref.nodeType,
      tagName = _ref.tagName;
  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
};

var siblings = function siblings(container, mount, cb) {
  mount = [].concat(mount);

  [].forEach.call(container.children, function (node) {
    if (mount.indexOf(node) === -1 && isHidable(node)) {
      cb(node);
    }
  });
};

function ariaHidden(show, node) {
  if (!node) {
    return;
  }
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function hideSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(true, node);
  });
}

function showSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(false, node);
  });
}

/***/ }),
/* 1494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Arrow = function Arrow(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'span' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popper = context.popper;

  var arrowRef = function arrowRef(node) {
    popper.setArrowNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };
  var arrowStyle = popper.getArrowStyle();

  if (typeof children === 'function') {
    var arrowProps = {
      ref: arrowRef,
      style: arrowStyle
    };
    return children({ arrowProps: arrowProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps, {
    style: _extends({}, arrowStyle, restProps.style)
  });

  if (typeof component === 'string') {
    componentProps.ref = arrowRef;
  } else {
    componentProps.innerRef = arrowRef;
  }

  return (0, _react.createElement)(component, componentProps, children);
};

Arrow.contextTypes = {
  popper: _propTypes2.default.object.isRequired
};

Arrow.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  innerRef: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};

exports.default = Arrow;

/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Manager = function (_Component) {
  _inherits(Manager, _Component);

  function Manager() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Manager);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manager.__proto__ || Object.getPrototypeOf(Manager)).call.apply(_ref, [this].concat(args))), _this), _this._setTargetNode = function (node) {
      _this._targetNode = node;
    }, _this._getTargetNode = function () {
      return _this._targetNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Manager, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popperManager: {
          setTargetNode: this._setTargetNode,
          getTargetNode: this._getTargetNode
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          tag = _props.tag,
          children = _props.children,
          restProps = _objectWithoutProperties(_props, ['tag', 'children']);

      if (tag !== false) {
        return (0, _react.createElement)(tag, restProps, children);
      } else {
        return children;
      }
    }
  }]);

  return Manager;
}(_react.Component);

Manager.childContextTypes = {
  popperManager: _propTypes2.default.object.isRequired
};
Manager.propTypes = {
  tag: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool])
};
Manager.defaultProps = {
  tag: 'div'
};
exports.default = Manager;

/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _popper = __webpack_require__(1301);

var _popper2 = _interopRequireDefault(_popper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var noop = function noop() {
  return null;
};

var Popper = function (_Component) {
  _inherits(Popper, _Component);

  function Popper() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popper.__proto__ || Object.getPrototypeOf(Popper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _this._setArrowNode = function (node) {
      _this._arrowNode = node;
    }, _this._getTargetNode = function () {
      return _this.context.popperManager.getTargetNode();
    }, _this._getOffsets = function (data) {
      return Object.keys(data.offsets).map(function (key) {
        return data.offsets[key];
      });
    }, _this._isDataDirty = function (data) {
      if (_this.state.data) {
        return JSON.stringify(_this._getOffsets(_this.state.data)) !== JSON.stringify(_this._getOffsets(data));
      } else {
        return true;
      }
    }, _this._updateStateModifier = {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        if (_this._isDataDirty(data)) {
          _this.setState({ data: data });
        }
        return data;
      }
    }, _this._getPopperStyle = function () {
      var data = _this.state.data;

      // If Popper isn't instantiated, hide the popperElement
      // to avoid flash of unstyled content

      if (!_this._popper || !data) {
        return {
          position: 'absolute',
          pointerEvents: 'none',
          opacity: 0
        };
      }

      var _data$offsets$popper = data.offsets.popper,
          top = _data$offsets$popper.top,
          left = _data$offsets$popper.left,
          position = _data$offsets$popper.position;


      return _extends({
        position: position
      }, data.styles);
    }, _this._getPopperPlacement = function () {
      return !!_this.state.data ? _this.state.data.placement : undefined;
    }, _this._getPopperHide = function () {
      return !!_this.state.data && _this.state.data.hide ? '' : undefined;
    }, _this._getArrowStyle = function () {
      if (!_this.state.data || !_this.state.data.offsets.arrow) {
        return {};
      } else {
        var _this$state$data$offs = _this.state.data.offsets.arrow,
            top = _this$state$data$offs.top,
            left = _this$state$data$offs.left;

        return { top: top, left: left };
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popper, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        popper: {
          setArrowNode: this._setArrowNode,
          getArrowStyle: this._getArrowStyle
        }
      };
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._updatePopper();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(lastProps) {
      if (lastProps.placement !== this.props.placement || lastProps.eventsEnabled !== this.props.eventsEnabled) {
        this._updatePopper();
      }

      if (this._popper && lastProps.children !== this.props.children) {
        this._popper.scheduleUpdate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._destroyPopper();
    }
  }, {
    key: '_updatePopper',
    value: function _updatePopper() {
      this._destroyPopper();
      if (this._node) {
        this._createPopper();
      }
    }
  }, {
    key: '_createPopper',
    value: function _createPopper() {
      var _props = this.props,
          placement = _props.placement,
          eventsEnabled = _props.eventsEnabled;

      var modifiers = _extends({}, this.props.modifiers, {
        applyStyle: { enabled: false },
        updateState: this._updateStateModifier
      });

      if (this._arrowNode) {
        modifiers.arrow = {
          element: this._arrowNode
        };
      }

      this._popper = new _popper2.default(this._getTargetNode(), this._node, {
        placement: placement,
        eventsEnabled: eventsEnabled,
        modifiers: modifiers
      });

      // schedule an update to make sure everything gets positioned correct
      // after being instantiated
      this._popper.scheduleUpdate();
    }
  }, {
    key: '_destroyPopper',
    value: function _destroyPopper() {
      if (this._popper) {
        this._popper.destroy();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          component = _props2.component,
          innerRef = _props2.innerRef,
          placement = _props2.placement,
          eventsEnabled = _props2.eventsEnabled,
          modifiers = _props2.modifiers,
          children = _props2.children,
          restProps = _objectWithoutProperties(_props2, ['component', 'innerRef', 'placement', 'eventsEnabled', 'modifiers', 'children']);

      var popperRef = function popperRef(node) {
        _this2._node = node;
        if (typeof innerRef === 'function') {
          innerRef(node);
        }
      };
      var popperStyle = this._getPopperStyle();
      var popperPlacement = this._getPopperPlacement();
      var popperHide = this._getPopperHide();

      if (typeof children === 'function') {
        var _popperProps;

        var popperProps = (_popperProps = {
          ref: popperRef,
          style: popperStyle
        }, _defineProperty(_popperProps, 'data-placement', popperPlacement), _defineProperty(_popperProps, 'data-x-out-of-boundaries', popperHide), _popperProps);
        return children({
          popperProps: popperProps,
          restProps: restProps,
          scheduleUpdate: this._popper && this._popper.scheduleUpdate
        });
      }

      var componentProps = _extends({}, restProps, {
        style: _extends({}, restProps.style, popperStyle),
        'data-placement': popperPlacement,
        'data-x-out-of-boundaries': popperHide
      });

      if (typeof component === 'string') {
        componentProps.ref = popperRef;
      } else {
        componentProps.innerRef = popperRef;
      }

      return (0, _react.createElement)(component, componentProps, children);
    }
  }]);

  return Popper;
}(_react.Component);

Popper.contextTypes = {
  popperManager: _propTypes2.default.object.isRequired
};
Popper.childContextTypes = {
  popper: _propTypes2.default.object.isRequired
};
Popper.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  innerRef: _propTypes2.default.func,
  placement: _propTypes2.default.oneOf(_popper2.default.placements),
  eventsEnabled: _propTypes2.default.bool,
  modifiers: _propTypes2.default.object,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};
Popper.defaultProps = {
  component: 'div',
  placement: 'bottom',
  eventsEnabled: true,
  modifiers: {}
};
exports.default = Popper;

/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Target = function Target(props, context) {
  var _props$component = props.component,
      component = _props$component === undefined ? 'div' : _props$component,
      innerRef = props.innerRef,
      children = props.children,
      restProps = _objectWithoutProperties(props, ['component', 'innerRef', 'children']);

  var popperManager = context.popperManager;

  var targetRef = function targetRef(node) {
    popperManager.setTargetNode(node);
    if (typeof innerRef === 'function') {
      innerRef(node);
    }
  };

  if (typeof children === 'function') {
    var targetProps = { ref: targetRef };
    return children({ targetProps: targetProps, restProps: restProps });
  }

  var componentProps = _extends({}, restProps);

  if (typeof component === 'string') {
    componentProps.ref = targetRef;
  } else {
    componentProps.innerRef = targetRef;
  }

  return (0, _react.createElement)(component, componentProps, children);
};

Target.contextTypes = {
  popperManager: _propTypes2.default.object.isRequired
};

Target.propTypes = {
  component: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  innerRef: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func])
};

exports.default = Target;

/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Arrow = exports.Popper = exports.Target = exports.Manager = undefined;

var _Manager2 = __webpack_require__(1495);

var _Manager3 = _interopRequireDefault(_Manager2);

var _Target2 = __webpack_require__(1497);

var _Target3 = _interopRequireDefault(_Target2);

var _Popper2 = __webpack_require__(1496);

var _Popper3 = _interopRequireDefault(_Popper2);

var _Arrow2 = __webpack_require__(1494);

var _Arrow3 = _interopRequireDefault(_Arrow2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Manager = _Manager3.default;
exports.Target = _Target3.default;
exports.Popper = _Popper3.default;
exports.Arrow = _Arrow3.default;

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _resizeObserverPolyfill = __webpack_require__(1759);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

var _lodash = __webpack_require__(1168);

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = __webpack_require__(1169);

var _lodash4 = _interopRequireDefault(_lodash3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var listMode = { debounce: _lodash2.default, throttle: _lodash4.default };

var styles = {
  position: 'absolute',
  width: 0,
  height: 0,
  visibility: 'hidden',
  display: 'none'
};

var ResizeDetector = function (_PureComponent) {
  _inherits(ResizeDetector, _PureComponent);

  function ResizeDetector(props) {
    _classCallCheck(this, ResizeDetector);

    var _this = _possibleConstructorReturn(this, (ResizeDetector.__proto__ || Object.getPrototypeOf(ResizeDetector)).call(this, props));

    _this.createResizeObserver = function (entries) {
      var _this$props = _this.props,
          handleWidth = _this$props.handleWidth,
          handleHeight = _this$props.handleHeight,
          onResize = _this$props.onResize;

      entries.forEach(function (entry) {
        var _entry$contentRect = entry.contentRect,
            width = _entry$contentRect.width,
            height = _entry$contentRect.height;

        var notifyWidth = handleWidth && _this.width !== width;
        var notifyHeight = handleHeight && _this.height !== height;
        if (!_this.skipOnMount && (notifyWidth || notifyHeight)) {
          onResize(width, height);
        }
        _this.width = width;
        _this.height = height;
        _this.skipOnMount = false;
      });
    };

    var skipOnMount = props.skipOnMount,
        refreshMode = props.refreshMode,
        refreshRate = props.refreshRate;


    _this.width = undefined;
    _this.height = undefined;
    _this.skipOnMount = skipOnMount;

    var resizeObserver = listMode[refreshMode] && listMode[refreshMode](_this.createResizeObserver, refreshRate) || _this.createResizeObserver;

    _this.ro = new _resizeObserverPolyfill2.default(resizeObserver);
    return _this;
  }

  _createClass(ResizeDetector, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var resizableElementId = this.props.resizableElementId;

      var resizableElement = resizableElementId ? document.getElementById(resizableElementId) : this.el.parentElement;
      this.ro.observe(resizableElement);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var resizableElementId = this.props.resizableElementId;

      var resizableElement = resizableElementId ? document.getElementById(resizableElementId) : this.el.parentElement;
      this.ro.unobserve(resizableElement);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement('div', {
        style: styles,
        ref: function ref(el) {
          _this2.el = el;
        }
      });
    }
  }]);

  return ResizeDetector;
}(_react.PureComponent);

exports.default = ResizeDetector;


ResizeDetector.propTypes = {
  handleWidth: _propTypes2.default.bool,
  handleHeight: _propTypes2.default.bool,
  skipOnMount: _propTypes2.default.bool,
  refreshRate: _propTypes2.default.number,
  refreshMode: _propTypes2.default.string,
  resizableElementId: _propTypes2.default.string,
  onResize: _propTypes2.default.func
};

ResizeDetector.defaultProps = {
  handleWidth: false,
  handleHeight: false,
  skipOnMount: false,
  refreshRate: 1000,
  refreshMode: undefined,
  resizableElementId: '',
  onResize: function onResize(e) {
    return e;
  }
};

/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ResizeDetector = __webpack_require__(1499);

var _ResizeDetector2 = _interopRequireDefault(_ResizeDetector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ResizeDetector2.default;

/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(347);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history__["f" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(347);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history__["e" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(1515);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(619);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 1505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(1516);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(1517);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 1507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(1518);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 1508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(1519);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(623);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 1510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(349);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 1511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(1520);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1514);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(348);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 1516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(623);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* createLocation */])(prevProps.to);
    var nextTo = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* createLocation */])(this.props.to);

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 1518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(348);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 1519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(349);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 1520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(622);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1522);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e(__webpack_require__(0)):"function"==typeof define&&define.amd?define(["react"],e):"object"==typeof exports?exports.SignaturePad=e(require("react")):t.SignaturePad=e(t.react)}(this,function(t){return function(t){function e(i){if(n[i])return n[i].exports;var o=n[i]={exports:{},id:i,loaded:!1};return t[i].call(o.exports,o,o.exports,e),o.loaded=!0,o.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){t.exports=n(2)},function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var i=function(){function t(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}return function(e,n,i){return n&&t(e.prototype,n),i&&t(e,i),e}}(),o=function(){function t(e,i,o,s){n(this,t),this.startPoint=e,this.control1=i,this.control2=o,this.endPoint=s}return i(t,[{key:"length",value:function e(){var t,n,i,o,s,a,r,u,h=10,e=0;for(t=0;h>=t;t++)n=t/h,i=this._point(n,this.startPoint.x,this.control1.x,this.control2.x,this.endPoint.x),o=this._point(n,this.startPoint.y,this.control1.y,this.control2.y,this.endPoint.y),t>0&&(r=i-s,u=o-a,e+=Math.sqrt(r*r+u*u)),s=i,a=o;return e}},{key:"_point",value:function(t,e,n,i,o){return e*(1-t)*(1-t)*(1-t)+3*n*(1-t)*(1-t)*t+3*i*(1-t)*t*t+o*t*t*t}}]),t}();e["default"]=o,t.exports=e["default"]},function(t,e,n){"use strict";function i(t){return t&&t.__esModule?t:{"default":t}}function o(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function s(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function, not "+typeof e);t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,enumerable:!1,writable:!0,configurable:!0}}),e&&(t.__proto__=e)}Object.defineProperty(e,"__esModule",{value:!0});var a=function(){function t(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}return function(e,n,i){return n&&t(e.prototype,n),i&&t(e,i),e}}(),r=function(t,e,n){for(var i=!0;i;){var o=t,s=e,a=n;r=h=u=void 0,i=!1,null===o&&(o=Function.prototype);var r=Object.getOwnPropertyDescriptor(o,s);if(void 0!==r){if("value"in r)return r.value;var u=r.get;return void 0===u?void 0:u.call(a)}var h=Object.getPrototypeOf(o);if(null===h)return void 0;t=h,e=s,n=a,i=!0}},u=n(4),h=i(u),c=n(1),l=i(c),d=n(3),v=i(d),f=function(t){function e(t){o(this,e),r(Object.getPrototypeOf(e.prototype),"constructor",this).call(this,t),this.velocityFilterWeight=this.props.velocityFilterWeight||.7,this.minWidth=this.props.minWidth||.5,this.maxWidth=this.props.maxWidth||2.5,this.dotSize=this.props.dotSize||function(){return(this.minWidth+this.maxWidth)/2},this.penColor=this.props.penColor||"black",this.backgroundColor=this.props.backgroundColor||"rgba(0,0,0,0)",this.onEnd=this.props.onEnd,this.onBegin=this.props.onBegin}return s(e,t),a(e,[{key:"componentDidMount",value:function(){this._canvas=this.refs.cv,this._ctx=this._canvas.getContext("2d"),this.clear(),this._handleMouseEvents(),this._handleTouchEvents(),this._resizeCanvas()}},{key:"componentWillUnmount",value:function(){this.off()}},{key:"clear",value:function(t){t&&t.preventDefault();var e=this._ctx,n=this._canvas;e.fillStyle=this.backgroundColor,e.clearRect(0,0,n.width,n.height),e.fillRect(0,0,n.width,n.height),this._reset()}},{key:"toDataURL",value:function(t,e){var n=this._canvas;return n.toDataURL.apply(n,arguments)}},{key:"fromDataURL",value:function(t){var e=this,n=new Image,i=window.devicePixelRatio||1,o=this._canvas.width/i,s=this._canvas.height/i;this._reset(),n.src=t,n.onload=function(){e._ctx.drawImage(n,0,0,o,s)},this._isEmpty=!1}},{key:"isEmpty",value:function(){return this._isEmpty}},{key:"_resizeCanvas",value:function(){var t=this._ctx,e=this._canvas,n=Math.max(window.devicePixelRatio||1,1);e.width=e.offsetWidth*n,e.height=e.offsetHeight*n,t.scale(n,n),this._isEmpty=!0}},{key:"_reset",value:function(){this.points=[],this._lastVelocity=0,this._lastWidth=(this.minWidth+this.maxWidth)/2,this._isEmpty=!0,this._ctx.fillStyle=this.penColor}},{key:"_handleMouseEvents",value:function(){this._mouseButtonDown=!1,this._canvas.addEventListener("mousedown",this._handleMouseDown.bind(this)),this._canvas.addEventListener("mousemove",this._handleMouseMove.bind(this)),document.addEventListener("mouseup",this._handleMouseUp.bind(this)),window.addEventListener("resize",this._resizeCanvas.bind(this))}},{key:"_handleTouchEvents",value:function(){this._canvas.style.msTouchAction="none",this._canvas.addEventListener("touchstart",this._handleTouchStart.bind(this)),this._canvas.addEventListener("touchmove",this._handleTouchMove.bind(this)),document.addEventListener("touchend",this._handleTouchEnd.bind(this))}},{key:"off",value:function(){this._canvas.removeEventListener("mousedown",this._handleMouseDown),this._canvas.removeEventListener("mousemove",this._handleMouseMove),document.removeEventListener("mouseup",this._handleMouseUp),this._canvas.removeEventListener("touchstart",this._handleTouchStart),this._canvas.removeEventListener("touchmove",this._handleTouchMove),document.removeEventListener("touchend",this._handleTouchEnd),window.removeEventListener("resize",this._resizeCanvas)}},{key:"_handleMouseDown",value:function(t){1===t.which&&(this._mouseButtonDown=!0,this._strokeBegin(t))}},{key:"_handleMouseMove",value:function(t){this._mouseButtonDown&&this._strokeUpdate(t)}},{key:"_handleMouseUp",value:function(t){1===t.which&&this._mouseButtonDown&&(this._mouseButtonDown=!1,this._strokeEnd(t))}},{key:"_handleTouchStart",value:function(t){var e=t.changedTouches[0];this._strokeBegin(e)}},{key:"_handleTouchMove",value:function(t){t.preventDefault();var e=t.changedTouches[0];this._strokeUpdate(e)}},{key:"_handleTouchEnd",value:function(t){var e=t.target===this._canvas;e&&this._strokeEnd(t)}},{key:"_strokeUpdate",value:function(t){var e=this._createPoint(t);this._addPoint(e)}},{key:"_strokeBegin",value:function(t){this._reset(),this._strokeUpdate(t),"function"==typeof this.onBegin&&this.onBegin(t)}},{key:"_strokeDraw",value:function(t){var e=this._ctx,n="function"==typeof this.dotSize?this.dotSize():this.dotSize;e.beginPath(),this._drawPoint(t.x,t.y,n),e.closePath(),e.fill()}},{key:"_strokeEnd",value:function(t){var e=this.points.length>2,n=this.points[0];!e&&n&&this._strokeDraw(n),"function"==typeof this.onEnd&&this.onEnd(t)}},{key:"_createPoint",value:function(t){var e=this._canvas.getBoundingClientRect();return new v["default"](t.clientX-e.left,t.clientY-e.top)}},{key:"_addPoint",value:function(t){var e,n,i,o,s=this.points;s.push(t),s.length>2&&(3===s.length&&s.unshift(s[0]),o=this._calculateCurveControlPoints(s[0],s[1],s[2]),e=o.c2,o=this._calculateCurveControlPoints(s[1],s[2],s[3]),n=o.c1,i=new l["default"](s[1],e,n,s[2]),this._addCurve(i),s.shift())}},{key:"_calculateCurveControlPoints",value:function(t,e,n){var i=t.x-e.x,o=t.y-e.y,s=e.x-n.x,a=e.y-n.y,r={x:(t.x+e.x)/2,y:(t.y+e.y)/2},u={x:(e.x+n.x)/2,y:(e.y+n.y)/2},h=Math.sqrt(i*i+o*o),c=Math.sqrt(s*s+a*a),l=r.x-u.x,d=r.y-u.y,f=c/(h+c),y={x:u.x+l*f,y:u.y+d*f},_=e.x-y.x,p=e.y-y.y;return{c1:new v["default"](r.x+_,r.y+p),c2:new v["default"](u.x+_,u.y+p)}}},{key:"_addCurve",value:function(t){var e,n,i=t.startPoint,o=t.endPoint;e=o.velocityFrom(i),e=this.velocityFilterWeight*e+(1-this.velocityFilterWeight)*this._lastVelocity,n=this._strokeWidth(e),this._drawCurve(t,this._lastWidth,n),this._lastVelocity=e,this._lastWidth=n}},{key:"_drawPoint",value:function(t,e,n){var i=this._ctx;i.moveTo(t,e),i.arc(t,e,n,0,2*Math.PI,!1),this._isEmpty=!1}},{key:"_drawCurve",value:function(t,e,n){var i,o,s,a,r,u,h,c,l,d,v,f=this._ctx,y=n-e;for(i=Math.floor(t.length()),f.beginPath(),s=0;i>s;s++)a=s/i,r=a*a,u=r*a,h=1-a,c=h*h,l=c*h,d=l*t.startPoint.x,d+=3*c*a*t.control1.x,d+=3*h*r*t.control2.x,d+=u*t.endPoint.x,v=l*t.startPoint.y,v+=3*c*a*t.control1.y,v+=3*h*r*t.control2.y,v+=u*t.endPoint.y,o=e+u*y,this._drawPoint(d,v,o);f.closePath(),f.fill()}},{key:"_strokeWidth",value:function(t){return Math.max(this.maxWidth/(t+1),this.minWidth)}},{key:"render",value:function(){return h["default"].createElement("div",{id:"signature-pad",className:"m-signature-pad"},h["default"].createElement("div",{className:"m-signature-pad--body"},h["default"].createElement("canvas",{ref:"cv"})),this.props.clearButton&&h["default"].createElement("div",{className:"m-signature-pad--footer"},h["default"].createElement("button",{className:"btn btn-default button clear",onClick:this.clear.bind(this)},"Clear")))}}]),e}(h["default"].Component);e["default"]=f,t.exports=e["default"]},function(t,e){"use strict";function n(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}Object.defineProperty(e,"__esModule",{value:!0});var i=function(){function t(t,e){for(var n=0;n<e.length;n++){var i=e[n];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(t,i.key,i)}}return function(e,n,i){return n&&t(e.prototype,n),i&&t(e,i),e}}(),o=function(){function t(e,i,o){n(this,t),this.x=e,this.y=i,this.time=o||(new Date).getTime()}return i(t,[{key:"velocityFrom",value:function(t){return this.time!==t.time?this.distanceTo(t)/(this.time-t.time):1}},{key:"distanceTo",value:function(t){return Math.sqrt(Math.pow(this.x-t.x,2)+Math.pow(this.y-t.y,2))}}]),t}();e["default"]=o,t.exports=e["default"]},function(e,n){e.exports=t}])});

/***/ }),
/* 1524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnimateGroupChild__ = __webpack_require__(1525);





function AnimateGroup(props) {
  var component = props.component,
      children = props.children,
      appear = props.appear,
      enter = props.enter,
      leave = props.leave;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_transition_group__["TransitionGroup"], {
    component: component
  }, __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (child, index) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AnimateGroupChild__["a" /* default */], {
      appearOptions: appear,
      enterOptions: enter,
      leaveOptions: leave,
      key: "child-".concat(index)
    }, child);
  }));
}

AnimateGroup.propTypes = {
  appear: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  enter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  leave: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element]),
  component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any
};
AnimateGroup.defaultProps = {
  component: 'span'
};
/* unused harmony default export */ var _unused_webpack_default_export = (AnimateGroup);

/***/ }),
/* 1525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNumber__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Animate__ = __webpack_require__(624);


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }






var parseDurationOfSingleTransition = function parseDurationOfSingleTransition() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var steps = options.steps,
      duration = options.duration;

  if (steps && steps.length) {
    return steps.reduce(function (result, entry) {
      return result + (__WEBPACK_IMPORTED_MODULE_0_lodash_isNumber___default()(entry.duration) && entry.duration > 0 ? entry.duration : 0);
    }, 0);
  }

  if (__WEBPACK_IMPORTED_MODULE_0_lodash_isNumber___default()(duration)) {
    return duration;
  }

  return 0;
};

var AnimateGroupChild =
/*#__PURE__*/
function (_Component) {
  _inherits(AnimateGroupChild, _Component);

  function AnimateGroupChild() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, AnimateGroupChild);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AnimateGroupChild)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      isActive: false
    };

    _this.handleEnter = function (node, isAppearing) {
      var _this$props = _this.props,
          appearOptions = _this$props.appearOptions,
          enterOptions = _this$props.enterOptions;

      _this.handleStyleActive(isAppearing ? appearOptions : enterOptions);
    };

    _this.handleExit = function () {
      _this.handleStyleActive(_this.props.leaveOptions);
    };

    return _this;
  }

  _createClass(AnimateGroupChild, [{
    key: "handleStyleActive",
    value: function handleStyleActive(style) {
      if (style) {
        var onAnimationEnd = style.onAnimationEnd ? function () {
          style.onAnimationEnd();
        } : null;
        this.setState(_objectSpread({}, style, {
          onAnimationEnd: onAnimationEnd,
          isActive: true
        }));
      }
    }
  }, {
    key: "parseTimeout",
    value: function parseTimeout() {
      var _this$props2 = this.props,
          appearOptions = _this$props2.appearOptions,
          enterOptions = _this$props2.enterOptions,
          leaveOptions = _this$props2.leaveOptions;
      return parseDurationOfSingleTransition(appearOptions) + parseDurationOfSingleTransition(enterOptions) + parseDurationOfSingleTransition(leaveOptions);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          children = _this$props3.children,
          appearOptions = _this$props3.appearOptions,
          enterOptions = _this$props3.enterOptions,
          leaveOptions = _this$props3.leaveOptions,
          props = _objectWithoutProperties(_this$props3, ["children", "appearOptions", "enterOptions", "leaveOptions"]);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_transition_group__["Transition"], _extends({}, props, {
        onEnter: this.handleEnter,
        onExit: this.handleExit,
        timeout: this.parseTimeout()
      }), function () {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Animate__["a" /* default */], _this2.state, __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(children));
      });
    }
  }]);

  return AnimateGroupChild;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

AnimateGroupChild.propTypes = {
  appearOptions: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  enterOptions: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  leaveOptions: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.element
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateGroupChild);

/***/ }),
/* 1526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createAnimateManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setRafTimeout__ = __webpack_require__(1528);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }


function createAnimateManager() {
  var currStyle = {};

  var handleChange = function handleChange() {
    return null;
  };

  var shouldStop = false;

  var setStyle = function setStyle(_style) {
    if (shouldStop) {
      return;
    }

    if (Array.isArray(_style)) {
      if (!_style.length) {
        return;
      }

      var styles = _style;

      var _styles = _toArray(styles),
          curr = _styles[0],
          restStyles = _styles.slice(1);

      if (typeof curr === 'number') {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__setRafTimeout__["a" /* default */])(setStyle.bind(null, restStyles), curr);
        return;
      }

      setStyle(curr);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__setRafTimeout__["a" /* default */])(setStyle.bind(null, restStyles));
      return;
    }

    if (_typeof(_style) === 'object') {
      currStyle = _style;
      handleChange(currStyle);
    }

    if (typeof _style === 'function') {
      _style();
    }
  };

  return {
    stop: function stop() {
      shouldStop = true;
    },
    start: function start(style) {
      shouldStop = false;
      setStyle(style);
    },
    subscribe: function subscribe(_handleChange) {
      handleChange = _handleChange;
      return function () {
        handleChange = function handleChange() {
          return null;
        };
      };
    }
  };
}

/***/ }),
/* 1527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_filter__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raf__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(223);


function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }




var alpha = function alpha(begin, end, k) {
  return begin + (end - begin) * k;
};

var needContinue = function needContinue(_ref) {
  var from = _ref.from,
      to = _ref.to;
  return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */


var calStepperVals = function calStepperVals(easing, preVals, steps) {
  var nextStepVals = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util__["e" /* mapObject */])(function (key, val) {
    if (needContinue(val)) {
      var _easing = easing(val.from, val.to, val.velocity),
          _easing2 = _slicedToArray(_easing, 2),
          newX = _easing2[0],
          newV = _easing2[1];

      return _objectSpread({}, val, {
        from: newX,
        velocity: newV
      });
    }

    return val;
  }, preVals);

  if (steps < 1) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util__["e" /* mapObject */])(function (key, val) {
      if (needContinue(val)) {
        return _objectSpread({}, val, {
          velocity: alpha(val.velocity, nextStepVals[key].velocity, steps),
          from: alpha(val.from, nextStepVals[key].from, steps)
        });
      }

      return val;
    }, preVals);
  }

  return calStepperVals(easing, nextStepVals, steps - 1);
}; // configure update function


/* harmony default export */ __webpack_exports__["a"] = (function (from, to, easing, duration, render) {
  var interKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util__["f" /* getIntersectionKeys */])(from, to);
  var timingStyle = interKeys.reduce(function (res, key) {
    return _objectSpread({}, res, _defineProperty({}, key, [from[key], to[key]]));
  }, {});
  var stepperStyle = interKeys.reduce(function (res, key) {
    return _objectSpread({}, res, _defineProperty({}, key, {
      from: from[key],
      velocity: 0,
      to: to[key]
    }));
  }, {});
  var cafId = -1;
  var preTime;
  var beginTime;

  var update = function update() {
    return null;
  };

  var getCurrStyle = function getCurrStyle() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util__["e" /* mapObject */])(function (key, val) {
      return val.from;
    }, stepperStyle);
  };

  var shouldStopAnimation = function shouldStopAnimation() {
    return !__WEBPACK_IMPORTED_MODULE_0_lodash_filter___default()(stepperStyle, needContinue).length;
  }; // stepper timing function like spring


  var stepperUpdate = function stepperUpdate(now) {
    if (!preTime) {
      preTime = now;
    }

    var deltaTime = now - preTime;
    var steps = deltaTime / easing.dt;
    stepperStyle = calStepperVals(easing, stepperStyle, steps); // get union set and add compatible prefix

    render(_objectSpread({}, from, to, getCurrStyle(stepperStyle)));
    preTime = now;

    if (!shouldStopAnimation()) {
      cafId = __WEBPACK_IMPORTED_MODULE_1_raf___default()(update);
    }
  }; // t => val timing function like cubic-bezier


  var timingUpdate = function timingUpdate(now) {
    if (!beginTime) {
      beginTime = now;
    }

    var t = (now - beginTime) / duration;
    var currStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util__["e" /* mapObject */])(function (key, val) {
      return alpha.apply(void 0, _toConsumableArray(val).concat([easing(t)]));
    }, timingStyle); // get union set and add compatible prefix

    render(_objectSpread({}, from, to, currStyle));

    if (t < 1) {
      cafId = __WEBPACK_IMPORTED_MODULE_1_raf___default()(update);
    } else {
      var finalStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util__["e" /* mapObject */])(function (key, val) {
        return alpha.apply(void 0, _toConsumableArray(val).concat([easing(1)]));
      }, timingStyle);
      render(_objectSpread({}, from, to, finalStyle));
    }
  };

  update = easing.isStepper ? stepperUpdate : timingUpdate; // return start animation method

  return function () {
    __WEBPACK_IMPORTED_MODULE_1_raf___default()(update); // return stop animation method

    return function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_raf__["cancel"])(cafId);
    };
  };
});

/***/ }),
/* 1528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setRafTimeout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raf__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raf__);

function setRafTimeout(callback) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var currTime = -1;

  var shouldUpdate = function shouldUpdate(now) {
    if (currTime < 0) {
      currTime = now;
    }

    if (now - currTime > timeout) {
      callback(now);
      currTime = -1;
    } else {
      __WEBPACK_IMPORTED_MODULE_0_raf___default()(shouldUpdate);
    }
  };

  __WEBPACK_IMPORTED_MODULE_0_raf___default()(shouldUpdate);
}

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    'svg',
    { width: '14', height: '11', viewBox: '0 0 14 11' },
    _react2.default.createElement('path', { d: 'M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0', fill: '#fff', fillRule: 'evenodd' })
  );
};

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pointerCoord = pointerCoord;
// Copyright 2015-present Drifty Co.
// http://drifty.com/
// from: https://github.com/driftyco/ionic/blob/master/src/util/dom.ts

function pointerCoord(event) {
  // get coordinates for either a mouse click
  // or a touch depending on the given event
  if (event) {
    var changedTouches = event.changedTouches;
    if (changedTouches && changedTouches.length > 0) {
      var touch = changedTouches[0];
      return { x: touch.clientX, y: touch.clientY };
    }
    var pageX = event.pageX;
    if (pageX !== undefined) {
      return { x: pageX, y: event.pageY };
    }
  }
  return { x: 0, y: 0 };
}

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    'svg',
    { width: '10', height: '10', viewBox: '0 0 10 10' },
    _react2.default.createElement('path', { d: 'M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12', fill: '#fff', fillRule: 'evenodd' })
  );
};

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(174));

var _addClass = _interopRequireDefault(__webpack_require__(504));

var _removeClass = _interopRequireDefault(__webpack_require__(506));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Transition = _interopRequireDefault(__webpack_require__(626));

var _PropTypes = __webpack_require__(629);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var appearClassName = _this.getClassNames('appear').doneClassName;

      var enterClassName = _this.getClassNames('enter').doneClassName;

      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames3 = _this.getClassNames('exit'),
          className = _this$getClassNames3.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames4.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames5.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
      var className = isStringClassNames ? prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames6 = this.getClassNames(type),
        className = _this$getClassNames6.className,
        activeClassName = _this$getClassNames6.activeClassName,
        doneClassName = _this$getClassNames6.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or
   * has finished the transition. A single name can be provided and it will be
   * suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
   *
   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
   * This allows you to define different behavior for when appearing is done and
   * when regular entering is done, using selectors like
   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
   * epic entrance animation when element first appears in the DOM using
   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   * simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(174));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(33);

var _TransitionGroup = _interopRequireDefault(__webpack_require__(627));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */
var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes =  false ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1535);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(133);

var invariant = __webpack_require__(17);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(1538);
var ReactElement = __webpack_require__(132);

var emptyFunction = __webpack_require__(37);
var traverseAllChildren = __webpack_require__(1548);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(132);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(132),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(554);

module.exports = factory(isValidElement);

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.7.0';


/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(630),
    Component = _require.Component;

var _require2 = __webpack_require__(132),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(633);
var factory = __webpack_require__(451);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(133);

var ReactElement = __webpack_require__(132);

var invariant = __webpack_require__(17);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(133);

var ReactCurrentOwner = __webpack_require__(73);
var REACT_ELEMENT_TYPE = __webpack_require__(632);

var getIteratorFn = __webpack_require__(1544);
var invariant = __webpack_require__(17);
var KeyEscapeUtils = __webpack_require__(1537);
var warning = __webpack_require__(21);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(133),
    _assign = __webpack_require__(22);

var invariant = __webpack_require__(17);
var hasOwnProperty = {}.hasOwnProperty;

function shallowCopy(x) {
  if (Array.isArray(x)) {
    return x.concat();
  } else if (x && typeof x === 'object') {
    return _assign(new x.constructor(), x);
  } else {
    return x;
  }
}

var COMMAND_PUSH = '$push';
var COMMAND_UNSHIFT = '$unshift';
var COMMAND_SPLICE = '$splice';
var COMMAND_SET = '$set';
var COMMAND_MERGE = '$merge';
var COMMAND_APPLY = '$apply';

var ALL_COMMANDS_LIST = [COMMAND_PUSH, COMMAND_UNSHIFT, COMMAND_SPLICE, COMMAND_SET, COMMAND_MERGE, COMMAND_APPLY];

var ALL_COMMANDS_SET = {};

ALL_COMMANDS_LIST.forEach(function (command) {
  ALL_COMMANDS_SET[command] = true;
});

function invariantArrayCase(value, spec, command) {
  !Array.isArray(value) ?  false ? invariant(false, 'update(): expected target of %s to be an array; got %s.', command, value) : _prodInvariant('1', command, value) : void 0;
  var specValue = spec[command];
  !Array.isArray(specValue) ?  false ? invariant(false, 'update(): expected spec of %s to be an array; got %s. Did you forget to wrap your parameter in an array?', command, specValue) : _prodInvariant('2', command, specValue) : void 0;
}

/**
 * Returns a updated shallow copy of an object without mutating the original.
 * See https://facebook.github.io/react/docs/update.html for details.
 */
function update(value, spec) {
  !(typeof spec === 'object') ?  false ? invariant(false, 'update(): You provided a key path to update() that did not contain one of %s. Did you forget to include {%s: ...}?', ALL_COMMANDS_LIST.join(', '), COMMAND_SET) : _prodInvariant('3', ALL_COMMANDS_LIST.join(', '), COMMAND_SET) : void 0;

  if (hasOwnProperty.call(spec, COMMAND_SET)) {
    !(Object.keys(spec).length === 1) ?  false ? invariant(false, 'Cannot have more than one key in an object with %s', COMMAND_SET) : _prodInvariant('4', COMMAND_SET) : void 0;

    return spec[COMMAND_SET];
  }

  var nextValue = shallowCopy(value);

  if (hasOwnProperty.call(spec, COMMAND_MERGE)) {
    var mergeObj = spec[COMMAND_MERGE];
    !(mergeObj && typeof mergeObj === 'object') ?  false ? invariant(false, 'update(): %s expects a spec of type \'object\'; got %s', COMMAND_MERGE, mergeObj) : _prodInvariant('5', COMMAND_MERGE, mergeObj) : void 0;
    !(nextValue && typeof nextValue === 'object') ?  false ? invariant(false, 'update(): %s expects a target of type \'object\'; got %s', COMMAND_MERGE, nextValue) : _prodInvariant('6', COMMAND_MERGE, nextValue) : void 0;
    _assign(nextValue, spec[COMMAND_MERGE]);
  }

  if (hasOwnProperty.call(spec, COMMAND_PUSH)) {
    invariantArrayCase(value, spec, COMMAND_PUSH);
    spec[COMMAND_PUSH].forEach(function (item) {
      nextValue.push(item);
    });
  }

  if (hasOwnProperty.call(spec, COMMAND_UNSHIFT)) {
    invariantArrayCase(value, spec, COMMAND_UNSHIFT);
    spec[COMMAND_UNSHIFT].forEach(function (item) {
      nextValue.unshift(item);
    });
  }

  if (hasOwnProperty.call(spec, COMMAND_SPLICE)) {
    !Array.isArray(value) ?  false ? invariant(false, 'Expected %s target to be an array; got %s', COMMAND_SPLICE, value) : _prodInvariant('7', COMMAND_SPLICE, value) : void 0;
    !Array.isArray(spec[COMMAND_SPLICE]) ?  false ? invariant(false, 'update(): expected spec of %s to be an array of arrays; got %s. Did you forget to wrap your parameters in an array?', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : _prodInvariant('8', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : void 0;
    spec[COMMAND_SPLICE].forEach(function (args) {
      !Array.isArray(args) ?  false ? invariant(false, 'update(): expected spec of %s to be an array of arrays; got %s. Did you forget to wrap your parameters in an array?', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : _prodInvariant('8', COMMAND_SPLICE, spec[COMMAND_SPLICE]) : void 0;
      nextValue.splice.apply(nextValue, args);
    });
  }

  if (hasOwnProperty.call(spec, COMMAND_APPLY)) {
    !(typeof spec[COMMAND_APPLY] === 'function') ?  false ? invariant(false, 'update(): expected spec of %s to be a function; got %s.', COMMAND_APPLY, spec[COMMAND_APPLY]) : _prodInvariant('9', COMMAND_APPLY, spec[COMMAND_APPLY]) : void 0;
    nextValue = spec[COMMAND_APPLY](nextValue);
  }

  for (var k in spec) {
    if (!(ALL_COMMANDS_SET.hasOwnProperty(k) && ALL_COMMANDS_SET[k])) {
      nextValue[k] = update(value[k], spec[k]);
    }
  }

  return nextValue;
}

module.exports = update;

/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getNiceTickValues; });
/* unused harmony export getTickValues */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getTickValuesFixedDomain; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_decimal_js_light__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_decimal_js_light__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_utils__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_arithmetic__ = __webpack_require__(1552);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * @fileOverview calculate tick values of scale
 * @author xile611, arcthur
 * @date 2015-09-17
 */



/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */

function getValidInterval(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      min = _ref2[0],
      max = _ref2[1];

  var validMin = min,
      validMax = max; // exchange

  if (min > max) {
    validMin = max;
    validMax = min;
  }

  return [validMin, validMax];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */


function getFormatStep(roughStep, allowDecimals, correctionFactor) {
  if (roughStep.lte(0)) {
    return new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(0);
  }

  var digitCount = __WEBPACK_IMPORTED_MODULE_2__util_arithmetic__["a" /* default */].getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
  // order of magnitudes than the rough step

  var digitCountValue = new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(10).pow(digitCount);
  var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong

  var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
  var amendStepRatio = new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
  var formatStep = amendStepRatio.mul(digitCountValue);
  return allowDecimals ? formatStep : new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */


function getTickOfSingleValue(value, tickCount, allowDecimals) {
  var step = 1; // calculate the middle value of ticks

  var middle = new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(value);

  if (!middle.isint() && allowDecimals) {
    var absVal = Math.abs(value);

    if (absVal < 1) {
      // The step should be a float number when the difference is smaller than 1
      step = new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(10).pow(__WEBPACK_IMPORTED_MODULE_2__util_arithmetic__["a" /* default */].getDigitCount(value) - 1);
      middle = new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(Math.floor(middle.div(step).toNumber())).mul(step);
    } else if (absVal > 1) {
      // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
      middle = new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(Math.floor(value));
    }
  } else if (value === 0) {
    middle = new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(Math.floor((tickCount - 1) / 2));
  } else if (!allowDecimals) {
    middle = new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(Math.floor(value));
  }

  var middleIndex = Math.floor((tickCount - 1) / 2);
  var fn = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_utils__["a" /* compose */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_utils__["b" /* map */])(function (n) {
    return middle.add(new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(n - middleIndex).mul(step)).toNumber();
  }), __WEBPACK_IMPORTED_MODULE_1__util_utils__["c" /* range */]);
  return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */


function calculateStep(min, max, tickCount, allowDecimals) {
  var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

  // dirty hack (for recharts' test)
  if (!Number.isFinite((max - min) / (tickCount - 1))) {
    return {
      step: new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(0),
      tickMin: new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(0),
      tickMax: new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(0)
    };
  } // The step which is easy to understand between two ticks


  var step = getFormatStep(new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks

  var middle; // When 0 is inside the interval, 0 should be a tick

  if (min <= 0 && max >= 0) {
    middle = new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(0);
  } else {
    // calculate the middle value
    middle = new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(min).add(max).div(2); // minus modulo value

    middle = middle.sub(new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(middle).mod(step));
  }

  var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
  var upCount = Math.ceil(new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(max).sub(middle).div(step).toNumber());
  var scaleCount = belowCount + upCount + 1;

  if (scaleCount > tickCount) {
    // When more ticks need to cover the interval, step should be bigger.
    return calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
  }

  if (scaleCount < tickCount) {
    // When less ticks can cover the interval, we should add some additional ticks
    upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
    belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
  }

  return {
    step: step,
    tickMin: middle.sub(new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(belowCount).mul(step)),
    tickMax: middle.add(new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(upCount).mul(step))
  };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */


function getNiceTickValuesFn(_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
      min = _ref4[0],
      max = _ref4[1];

  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  // More than two ticks should be return
  var count = Math.max(tickCount, 2);

  var _getValidInterval = getValidInterval([min, max]),
      _getValidInterval2 = _slicedToArray(_getValidInterval, 2),
      cormin = _getValidInterval2[0],
      cormax = _getValidInterval2[1];

  if (cormin === -Infinity || cormax === Infinity) {
    var _values = cormax === Infinity ? [cormin].concat(_toConsumableArray(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_utils__["c" /* range */])(0, tickCount - 1).map(function () {
      return Infinity;
    }))) : [].concat(_toConsumableArray(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_utils__["c" /* range */])(0, tickCount - 1).map(function () {
      return -Infinity;
    })), [cormax]);

    return min > max ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_utils__["d" /* reverse */])(_values) : _values;
  }

  if (cormin === cormax) {
    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
  } // Get the step between two ticks


  var _calculateStep = calculateStep(cormin, cormax, count, allowDecimals),
      step = _calculateStep.step,
      tickMin = _calculateStep.tickMin,
      tickMax = _calculateStep.tickMax;

  var values = __WEBPACK_IMPORTED_MODULE_2__util_arithmetic__["a" /* default */].rangeStep(tickMin, tickMax.add(new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(0.1).mul(step)), step);
  return min > max ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_utils__["d" /* reverse */])(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */


function getTickValuesFn(_ref5) {
  var _ref6 = _slicedToArray(_ref5, 2),
      min = _ref6[0],
      max = _ref6[1];

  var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  // More than two ticks should be return
  var count = Math.max(tickCount, 2);

  var _getValidInterval3 = getValidInterval([min, max]),
      _getValidInterval4 = _slicedToArray(_getValidInterval3, 2),
      cormin = _getValidInterval4[0],
      cormax = _getValidInterval4[1];

  if (cormin === -Infinity || cormax === Infinity) {
    return [min, max];
  }

  if (cormin === cormax) {
    return getTickOfSingleValue(cormin, tickCount, allowDecimals);
  }

  var step = getFormatStep(new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
  var fn = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_utils__["a" /* compose */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_utils__["b" /* map */])(function (n) {
    return new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(cormin).add(new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(n).mul(step)).toNumber();
  }), __WEBPACK_IMPORTED_MODULE_1__util_utils__["c" /* range */]);
  var values = fn(0, count).filter(function (entry) {
    return entry >= cormin && entry <= cormax;
  });
  return min > max ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_utils__["d" /* reverse */])(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */


function getTickValuesFixedDomainFn(_ref7, tickCount) {
  var _ref8 = _slicedToArray(_ref7, 2),
      min = _ref8[0],
      max = _ref8[1];

  var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  // More than two ticks should be return
  var _getValidInterval5 = getValidInterval([min, max]),
      _getValidInterval6 = _slicedToArray(_getValidInterval5, 2),
      cormin = _getValidInterval6[0],
      cormax = _getValidInterval6[1];

  if (cormin === -Infinity || cormax === Infinity) {
    return [min, max];
  }

  if (cormin === cormax) {
    return [cormin];
  }

  var count = Math.max(tickCount, 2);
  var step = getFormatStep(new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
  var values = [].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__util_arithmetic__["a" /* default */].rangeStep(new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(cormin), new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(cormax).sub(new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(0.99).mul(step)), step)), [cormax]);
  return min > max ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_utils__["d" /* reverse */])(values) : values;
}

var getNiceTickValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_utils__["e" /* memoize */])(getNiceTickValuesFn);
var getTickValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_utils__["e" /* memoize */])(getTickValuesFn);
var getTickValuesFixedDomain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util_utils__["e" /* memoize */])(getTickValuesFixedDomainFn);

/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNiceTickValues__ = __webpack_require__(1550);
/* unused harmony reexport getTickValues */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__getNiceTickValues__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__getNiceTickValues__["b"]; });


/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_decimal_js_light__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_decimal_js_light__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(635);
/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */


/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */

function getDigitCount(value) {
  var result;

  if (value === 0) {
    result = 1;
  } else {
    result = Math.floor(new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(value).abs().log(10).toNumber()) + 1;
  }

  return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */


function rangeStep(start, end, step) {
  var num = new __WEBPACK_IMPORTED_MODULE_0_decimal_js_light___default.a(start);
  var i = 0;
  var result = []; // magic number to prevent infinite loop

  while (num.lt(end) && i < 100000) {
    result.push(num.toNumber());
    num = num.add(step);
    i++;
  }

  return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */


var interpolateNumber = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* curry */])(function (a, b, t) {
  var newA = +a;
  var newB = +b;
  return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */

var uninterpolateNumber = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* curry */])(function (a, b, x) {
  var diff = b - +a;
  diff = diff || Infinity;
  return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */

var uninterpolateTruncation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["f" /* curry */])(function (a, b, x) {
  var diff = b - +a;
  diff = diff || Infinity;
  return Math.max(0, Math.min(1, (x - a) / diff));
});
/* harmony default export */ __webpack_exports__["a"] = ({
  rangeStep: rangeStep,
  getDigitCount: getDigitCount,
  interpolateNumber: interpolateNumber,
  uninterpolateNumber: uninterpolateNumber,
  uninterpolateTruncation: uninterpolateTruncation
});

/***/ }),
/* 1553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_DataUtils__ = __webpack_require__(27);


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Cartesian Grid
 */





var CartesianGrid =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(CartesianGrid, _PureComponent);

  function CartesianGrid() {
    _classCallCheck(this, CartesianGrid);

    return _possibleConstructorReturn(this, _getPrototypeOf(CartesianGrid).apply(this, arguments));
  }

  _createClass(CartesianGrid, [{
    key: "renderHorizontal",

    /**
     * Draw the horizontal grid lines
     * @param {Array} horizontalPoints either passed in as props or generated from function
     * @return {Group} Horizontal lines
     */
    value: function renderHorizontal(horizontalPoints) {
      var _this = this;

      var _this$props = this.props,
          x = _this$props.x,
          width = _this$props.width,
          horizontal = _this$props.horizontal;

      if (!horizontalPoints || !horizontalPoints.length) {
        return null;
      }

      var items = horizontalPoints.map(function (entry, i) {
        var props = _objectSpread({}, _this.props, {
          x1: x,
          y1: entry,
          x2: x + width,
          y2: entry,
          key: "line-".concat(i),
          index: i
        });

        return _this.constructor.renderLineItem(horizontal, props);
      });
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g", {
        className: "recharts-cartesian-grid-horizontal"
      }, items);
    }
    /**
     * Draw vertical grid lines
     * @param {Array} verticalPoints either passed in as props or generated from function
     * @return {Group} Vertical lines
     */

  }, {
    key: "renderVertical",
    value: function renderVertical(verticalPoints) {
      var _this2 = this;

      var _this$props2 = this.props,
          y = _this$props2.y,
          height = _this$props2.height,
          vertical = _this$props2.vertical;

      if (!verticalPoints || !verticalPoints.length) {
        return null;
      }

      var items = verticalPoints.map(function (entry, i) {
        var props = _objectSpread({}, _this2.props, {
          x1: entry,
          y1: y,
          x2: entry,
          y2: y + height,
          key: "line-".concat(i),
          index: i
        });

        return _this2.constructor.renderLineItem(vertical, props);
      });
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g", {
        className: "recharts-cartesian-grid-vertical"
      }, items);
    }
    /**
     * Draw vertical grid stripes filled by colors
     * @param {Array} verticalPoints either passed in as props or generated from function
     * @return {Group} Vertical stripes
     */

  }, {
    key: "renderVerticalStripes",
    value: function renderVerticalStripes(verticalPoints) {
      var verticalFill = this.props.verticalFill;

      if (!verticalFill || !verticalFill.length) {
        return null;
      }

      var _this$props3 = this.props,
          fillOpacity = _this$props3.fillOpacity,
          x = _this$props3.x,
          y = _this$props3.y,
          width = _this$props3.width,
          height = _this$props3.height;
      var verticalPointsUpdated = verticalPoints.slice().sort(function (a, b) {
        return a - b;
      });

      if (x !== verticalPointsUpdated[0]) {
        verticalPointsUpdated.unshift(0);
      }

      var items = verticalPointsUpdated.map(function (entry, i) {
        var lineWidth = verticalPointsUpdated[i + 1] ? verticalPointsUpdated[i + 1] - entry : x + width - entry;

        if (lineWidth <= 0) {
          return null;
        }

        var colorIndex = i % verticalFill.length;
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect", {
          key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
          ,
          x: Math.round(entry + x - x),
          y: y,
          width: lineWidth,
          height: height,
          stroke: "none",
          fill: verticalFill[colorIndex],
          fillOpacity: fillOpacity,
          className: "recharts-cartesian-grid-bg"
        });
      });
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g", {
        className: "recharts-cartesian-gridstripes-vertical"
      }, items);
    }
    /**
     * Draw horizontal grid stripes filled by colors
     * @param {Array} horizontalPoints either passed in as props or generated from function
     * @return {Group} Horizontal stripes
     */

  }, {
    key: "renderHorizontalStripes",
    value: function renderHorizontalStripes(horizontalPoints) {
      var horizontalFill = this.props.horizontalFill;

      if (!horizontalFill || !horizontalFill.length) {
        return null;
      }

      var _this$props4 = this.props,
          fillOpacity = _this$props4.fillOpacity,
          x = _this$props4.x,
          y = _this$props4.y,
          width = _this$props4.width,
          height = _this$props4.height;
      var horizontalPointsUpdated = horizontalPoints.slice().sort(function (a, b) {
        return a - b;
      });

      if (y !== horizontalPointsUpdated[0]) {
        horizontalPointsUpdated.unshift(0);
      }

      var items = horizontalPointsUpdated.map(function (entry, i) {
        var lineHeight = horizontalPointsUpdated[i + 1] ? horizontalPointsUpdated[i + 1] - entry : y + height - entry;

        if (lineHeight <= 0) {
          return null;
        }

        var colorIndex = i % horizontalFill.length;
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect", {
          key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
          ,
          y: Math.round(entry + y - y),
          x: x,
          height: lineHeight,
          width: width,
          stroke: "none",
          fill: horizontalFill[colorIndex],
          fillOpacity: fillOpacity,
          className: "recharts-cartesian-grid-bg"
        });
      });
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g", {
        className: "recharts-cartesian-gridstripes-horizontal"
      }, items);
    }
  }, {
    key: "renderBackground",
    value: function renderBackground() {
      var fill = this.props.fill;

      if (!fill || fill === 'none') {
        return null;
      }

      var _this$props5 = this.props,
          fillOpacity = _this$props5.fillOpacity,
          x = _this$props5.x,
          y = _this$props5.y,
          width = _this$props5.width,
          height = _this$props5.height;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect", {
        x: x,
        y: y,
        width: width,
        height: height,
        stroke: "none",
        fill: fill,
        fillOpacity: fillOpacity,
        className: "recharts-cartesian-grid-bg"
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          x = _this$props6.x,
          y = _this$props6.y,
          width = _this$props6.width,
          height = _this$props6.height,
          horizontal = _this$props6.horizontal,
          vertical = _this$props6.vertical,
          horizontalCoordinatesGenerator = _this$props6.horizontalCoordinatesGenerator,
          verticalCoordinatesGenerator = _this$props6.verticalCoordinatesGenerator,
          xAxis = _this$props6.xAxis,
          yAxis = _this$props6.yAxis,
          offset = _this$props6.offset,
          chartWidth = _this$props6.chartWidth,
          chartHeight = _this$props6.chartHeight;

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["a" /* isNumber */])(width) || width <= 0 || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["a" /* isNumber */])(height) || height <= 0 || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["a" /* isNumber */])(x) || x !== +x || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_DataUtils__["a" /* isNumber */])(y) || y !== +y) {
        return null;
      }

      var _this$props7 = this.props,
          horizontalPoints = _this$props7.horizontalPoints,
          verticalPoints = _this$props7.verticalPoints; // No horizontal points are specified

      if ((!horizontalPoints || !horizontalPoints.length) && __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(horizontalCoordinatesGenerator)) {
        horizontalPoints = horizontalCoordinatesGenerator({
          yAxis: yAxis,
          width: chartWidth,
          height: chartHeight,
          offset: offset
        });
      } // No vertical points are specified


      if ((!verticalPoints || !verticalPoints.length) && __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(verticalCoordinatesGenerator)) {
        verticalPoints = verticalCoordinatesGenerator({
          xAxis: xAxis,
          width: chartWidth,
          height: chartHeight,
          offset: offset
        });
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g", {
        className: "recharts-cartesian-grid"
      }, this.renderBackground(), horizontal && this.renderHorizontal(horizontalPoints), vertical && this.renderVertical(verticalPoints), horizontal && this.renderHorizontalStripes(horizontalPoints), vertical && this.renderVerticalStripes(verticalPoints));
    }
  }], [{
    key: "renderLineItem",
    value: function renderLineItem(option, props) {
      var lineItem;

      if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(option)) {
        lineItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(option, props);
      } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        lineItem = option(props);
      } else {
        var x1 = props.x1,
            y1 = props.y1,
            x2 = props.x2,
            y2 = props.y2,
            key = props.key,
            others = _objectWithoutProperties(props, ["x1", "y1", "x2", "y2", "key"]);

        lineItem = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line", _extends({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["a" /* getPresentationAttributes */])(others), {
          x1: x1,
          y1: y1,
          x2: x2,
          y2: y2,
          fill: "none",
          key: key
        }));
      }

      return lineItem;
    }
  }]);

  return CartesianGrid;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

CartesianGrid.displayName = 'CartesianGrid';
CartesianGrid.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  x: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  y: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  horizontal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool]),
  vertical: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool]),
  horizontalPoints: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number),
  verticalPoints: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number),
  horizontalCoordinatesGenerator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  verticalCoordinatesGenerator: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  xAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  yAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  offset: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
  chartWidth: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  chartHeight: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  verticalFill: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string),
  horizontalFill: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string)
});
CartesianGrid.defaultProps = {
  horizontal: true,
  vertical: true,
  // The ordinates of horizontal grid lines
  horizontalPoints: [],
  // The abscissas of vertical grid lines
  verticalPoints: [],
  stroke: '#ccc',
  fill: 'none',
  // The fill of colors of grid lines
  verticalFill: [],
  horizontalFill: []
};
/* harmony default export */ __webpack_exports__["a"] = (CartesianGrid);

/***/ }),
/* 1554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartesian_Area__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartesian_XAxis__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cartesian_YAxis__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_CartesianUtils__ = __webpack_require__(91);
/**
 * @fileOverview Area Chart
 */





/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__["a" /* default */])({
  chartName: 'AreaChart',
  GraphicalChild: __WEBPACK_IMPORTED_MODULE_1__cartesian_Area__["a" /* default */],
  axisComponents: [{
    axisType: 'xAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_2__cartesian_XAxis__["a" /* default */]
  }, {
    axisType: 'yAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_3__cartesian_YAxis__["a" /* default */]
  }],
  formatAxisMap: __WEBPACK_IMPORTED_MODULE_4__util_CartesianUtils__["d" /* formatAxisMap */]
}));

/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartesian_Bar__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartesian_XAxis__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cartesian_YAxis__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_CartesianUtils__ = __webpack_require__(91);
/**
 * @fileOverview Bar Chart
 */





/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__["a" /* default */])({
  chartName: 'BarChart',
  GraphicalChild: __WEBPACK_IMPORTED_MODULE_1__cartesian_Bar__["a" /* default */],
  axisComponents: [{
    axisType: 'xAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_2__cartesian_XAxis__["a" /* default */]
  }, {
    axisType: 'yAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_3__cartesian_YAxis__["a" /* default */]
  }],
  formatAxisMap: __WEBPACK_IMPORTED_MODULE_4__util_CartesianUtils__["d" /* formatAxisMap */]
}));

/***/ }),
/* 1556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartesian_Area__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartesian_Bar__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cartesian_Line__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cartesian_Scatter__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cartesian_XAxis__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cartesian_YAxis__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cartesian_ZAxis__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_CartesianUtils__ = __webpack_require__(91);
/**
 * @fileOverview Composed Chart
 */









/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__["a" /* default */])({
  chartName: 'ComposedChart',
  GraphicalChild: [__WEBPACK_IMPORTED_MODULE_3__cartesian_Line__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__cartesian_Area__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__cartesian_Bar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__cartesian_Scatter__["a" /* default */]],
  axisComponents: [{
    axisType: 'xAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_5__cartesian_XAxis__["a" /* default */]
  }, {
    axisType: 'yAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_6__cartesian_YAxis__["a" /* default */]
  }, {
    axisType: 'zAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_7__cartesian_ZAxis__["a" /* default */]
  }],
  formatAxisMap: __WEBPACK_IMPORTED_MODULE_8__util_CartesianUtils__["d" /* formatAxisMap */]
}));

/***/ }),
/* 1557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generateCategoricalChart__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__numberAxis_Funnel__ = __webpack_require__(641);
/**
 * @fileOverview Funnel Chart
 */



/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__generateCategoricalChart__["a" /* default */])({
  chartName: 'FunnelChart',
  GraphicalChild: __WEBPACK_IMPORTED_MODULE_2__numberAxis_Funnel__["a" /* default */],
  eventType: 'item',
  axisComponents: [],
  defaultProps: {
    layout: 'centric'
  },
  propTypes: {
    layout: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['centric'])
  }
}));

/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartesian_Line__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartesian_XAxis__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cartesian_YAxis__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_CartesianUtils__ = __webpack_require__(91);
/**
 * @fileOverview Line Chart
 */





/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__["a" /* default */])({
  chartName: 'LineChart',
  GraphicalChild: __WEBPACK_IMPORTED_MODULE_1__cartesian_Line__["a" /* default */],
  axisComponents: [{
    axisType: 'xAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_2__cartesian_XAxis__["a" /* default */]
  }, {
    axisType: 'yAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_3__cartesian_YAxis__["a" /* default */]
  }],
  formatAxisMap: __WEBPACK_IMPORTED_MODULE_4__util_CartesianUtils__["d" /* formatAxisMap */]
}));

/***/ }),
/* 1559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generateCategoricalChart__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__polar_PolarAngleAxis__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polar_PolarRadiusAxis__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__polar_Pie__ = __webpack_require__(642);
/**
 * @fileOverview Pie Chart
 */






/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__generateCategoricalChart__["a" /* default */])({
  chartName: 'PieChart',
  GraphicalChild: __WEBPACK_IMPORTED_MODULE_5__polar_Pie__["a" /* default */],
  eventType: 'item',
  legendContent: 'children',
  axisComponents: [{
    axisType: 'angleAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_2__polar_PolarAngleAxis__["a" /* default */]
  }, {
    axisType: 'radiusAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_3__polar_PolarRadiusAxis__["a" /* default */]
  }],
  formatAxisMap: __WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__["d" /* formatAxisMap */],
  defaultProps: {
    layout: 'centric',
    startAngle: 0,
    endAngle: 360,
    cx: '50%',
    cy: '50%',
    innerRadius: 0,
    outerRadius: '80%'
  },
  propTypes: {
    layout: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['centric']),
    startAngle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    endAngle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    cx: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    cy: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    innerRadius: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    outerRadius: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string])
  }
}));

/***/ }),
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generateCategoricalChart__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__polar_Radar__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polar_PolarAngleAxis__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__polar_PolarRadiusAxis__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_PolarUtils__ = __webpack_require__(54);
/**
 * @fileOverview Radar Chart
 */






/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__generateCategoricalChart__["a" /* default */])({
  chartName: 'RadarChart',
  GraphicalChild: __WEBPACK_IMPORTED_MODULE_2__polar_Radar__["a" /* default */],
  axisComponents: [{
    axisType: 'angleAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_3__polar_PolarAngleAxis__["a" /* default */]
  }, {
    axisType: 'radiusAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_4__polar_PolarRadiusAxis__["a" /* default */]
  }],
  formatAxisMap: __WEBPACK_IMPORTED_MODULE_5__util_PolarUtils__["d" /* formatAxisMap */],
  defaultProps: {
    layout: 'centric',
    startAngle: 90,
    endAngle: -270,
    cx: '50%',
    cy: '50%',
    innerRadius: 0,
    outerRadius: '80%'
  },
  propTypes: {
    layout: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['centric']),
    startAngle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    endAngle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    cx: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    cy: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    innerRadius: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    outerRadius: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string])
  }
}));

/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__generateCategoricalChart__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__polar_PolarAngleAxis__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polar_PolarRadiusAxis__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__polar_RadialBar__ = __webpack_require__(644);
/**
 * @fileOverview Radar Bar Chart
 */






/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__generateCategoricalChart__["a" /* default */])({
  chartName: 'RadialBarChart',
  GraphicalChild: __WEBPACK_IMPORTED_MODULE_5__polar_RadialBar__["a" /* default */],
  legendContent: 'children',
  axisComponents: [{
    axisType: 'angleAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_2__polar_PolarAngleAxis__["a" /* default */]
  }, {
    axisType: 'radiusAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_3__polar_PolarRadiusAxis__["a" /* default */]
  }],
  formatAxisMap: __WEBPACK_IMPORTED_MODULE_4__util_PolarUtils__["d" /* formatAxisMap */],
  defaultProps: {
    layout: 'radial',
    startAngle: 0,
    endAngle: 360,
    cx: '50%',
    cy: '50%',
    innerRadius: 0,
    outerRadius: '80%'
  },
  propTypes: {
    layout: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['radial']),
    startAngle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    endAngle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    cx: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    cy: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    innerRadius: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    outerRadius: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string])
  }
}));

/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__ = __webpack_require__(1749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_sumBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_min__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_maxBy__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_maxBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_maxBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__container_Surface__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__container_Layer__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__component_Tooltip__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shape_Rectangle__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_ShallowEqual__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__ = __webpack_require__(44);





function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @file TreemapChart
 */










var defaultCoordinateOfTooltip = {
  x: 0,
  y: 0
};

var interpolationGenerator = function interpolationGenerator(a, b) {
  var ka = +a;
  var kb = b - ka;
  return function (t) {
    return ka + kb * t;
  };
};

var centerY = function centerY(node) {
  return node.y + node.dy / 2;
};

var getValue = function getValue(entry) {
  return entry && entry.value || 0;
};

var getSumOfIds = function getSumOfIds(links, ids) {
  return ids.reduce(function (result, id) {
    return result + getValue(links[id]);
  }, 0);
};

var getSumWithWeightedSource = function getSumWithWeightedSource(tree, links, ids) {
  return ids.reduce(function (result, id) {
    var link = links[id];
    var sourceNode = tree[link.source];
    return result + centerY(sourceNode) * getValue(links[id]);
  }, 0);
};

var getSumWithWeightedTarget = function getSumWithWeightedTarget(tree, links, ids) {
  return ids.reduce(function (result, id) {
    var link = links[id];
    var targetNode = tree[link.target];
    return result + centerY(targetNode) * getValue(links[id]);
  }, 0);
};

var ascendingY = function ascendingY(a, b) {
  return a.y - b.y;
};

var searchTargetsAndSources = function searchTargetsAndSources(links, id) {
  var sourceNodes = [];
  var sourceLinks = [];
  var targetNodes = [];
  var targetLinks = [];

  for (var i = 0, len = links.length; i < len; i++) {
    var link = links[i];

    if (link.source === id) {
      targetNodes.push(link.target);
      targetLinks.push(i);
    }

    if (link.target === id) {
      sourceNodes.push(link.source);
      sourceLinks.push(i);
    }
  }

  return {
    sourceNodes: sourceNodes,
    sourceLinks: sourceLinks,
    targetLinks: targetLinks,
    targetNodes: targetNodes
  };
};

var updateDepthOfTargets = function updateDepthOfTargets(tree, curNode) {
  var targetNodes = curNode.targetNodes;

  for (var i = 0, len = targetNodes.length; i < len; i++) {
    var target = tree[targetNodes[i]];

    if (target) {
      target.depth = Math.max(curNode.depth + 1, target.depth);
      updateDepthOfTargets(tree, target);
    }
  }
};

var getNodesTree = function getNodesTree(_ref, width, nodeWidth) {
  var nodes = _ref.nodes,
      links = _ref.links;
  var tree = nodes.map(function (entry, index) {
    var result = searchTargetsAndSources(links, index);
    return _objectSpread({}, entry, {}, result, {
      value: Math.max(getSumOfIds(links, result.sourceLinks), getSumOfIds(links, result.targetLinks)),
      depth: 0
    });
  });

  for (var i = 0, len = tree.length; i < len; i++) {
    var node = tree[i];

    if (!node.sourceNodes.length) {
      updateDepthOfTargets(tree, node);
    }
  }

  var maxDepth = __WEBPACK_IMPORTED_MODULE_3_lodash_maxBy___default()(tree, function (entry) {
    return entry.depth;
  }).depth;

  if (maxDepth >= 1) {
    var childWidth = (width - nodeWidth) / maxDepth;

    for (var _i = 0, _len = tree.length; _i < _len; _i++) {
      var _node = tree[_i];

      if (!_node.targetNodes.length) {
        _node.depth = maxDepth;
      }

      _node.x = _node.depth * childWidth;
      _node.dx = nodeWidth;
    }
  }

  return {
    tree: tree,
    maxDepth: maxDepth
  };
};

var getDepthTree = function getDepthTree(tree) {
  var result = [];

  for (var i = 0, len = tree.length; i < len; i++) {
    var node = tree[i];

    if (!result[node.depth]) {
      result[node.depth] = [];
    }

    result[node.depth].push(node);
  }

  return result;
};

var updateYOfTree = function updateYOfTree(depthTree, height, nodePadding, links) {
  var yRatio = __WEBPACK_IMPORTED_MODULE_2_lodash_min___default()(depthTree.map(function (nodes) {
    return (height - (nodes.length - 1) * nodePadding) / __WEBPACK_IMPORTED_MODULE_1_lodash_sumBy___default()(nodes, getValue);
  }));

  for (var d = 0, maxDepth = depthTree.length; d < maxDepth; d++) {
    for (var i = 0, len = depthTree[d].length; i < len; i++) {
      var node = depthTree[d][i];
      node.y = i;
      node.dy = node.value * yRatio;
    }
  }

  return links.map(function (link) {
    return _objectSpread({}, link, {
      dy: getValue(link) * yRatio
    });
  });
};

var resolveCollisions = function resolveCollisions(depthTree, height, nodePadding) {
  for (var i = 0, len = depthTree.length; i < len; i++) {
    var nodes = depthTree[i];
    var n = nodes.length; // Sort by the value of y

    nodes.sort(ascendingY);
    var y0 = 0;

    for (var j = 0; j < n; j++) {
      var node = nodes[j];
      var dy = y0 - node.y;

      if (dy > 0) {
        node.y += dy;
      }

      y0 = node.y + node.dy + nodePadding;
    }

    y0 = height + nodePadding;

    for (var _j = n - 1; _j >= 0; _j--) {
      var _node2 = nodes[_j];

      var _dy = _node2.y + _node2.dy + nodePadding - y0;

      if (_dy > 0) {
        _node2.y -= _dy;
        y0 = _node2.y;
      } else {
        break;
      }
    }
  }
};

var relaxLeftToRight = function relaxLeftToRight(tree, depthTree, links, alpha) {
  for (var i = 0, maxDepth = depthTree.length; i < maxDepth; i++) {
    var nodes = depthTree[i];

    for (var j = 0, len = nodes.length; j < len; j++) {
      var node = nodes[j];

      if (node.sourceLinks.length) {
        var sourceSum = getSumOfIds(links, node.sourceLinks);
        var weightedSum = getSumWithWeightedSource(tree, links, node.sourceLinks);
        var y = weightedSum / sourceSum;
        node.y += (y - centerY(node)) * alpha;
      }
    }
  }
};

var relaxRightToLeft = function relaxRightToLeft(tree, depthTree, links, alpha) {
  for (var i = depthTree.length - 1; i >= 0; i--) {
    var nodes = depthTree[i];

    for (var j = 0, len = nodes.length; j < len; j++) {
      var node = nodes[j];

      if (node.targetLinks.length) {
        var targetSum = getSumOfIds(links, node.targetLinks);
        var weightedSum = getSumWithWeightedTarget(tree, links, node.targetLinks);
        var y = weightedSum / targetSum;
        node.y += (y - centerY(node)) * alpha;
      }
    }
  }
};

var updateYOfLinks = function updateYOfLinks(tree, links) {
  for (var i = 0, len = tree.length; i < len; i++) {
    var node = tree[i];
    var sy = 0;
    var ty = 0;
    node.targetLinks.sort(function (a, b) {
      return tree[links[a].target].y - tree[links[b].target].y;
    });
    node.sourceLinks.sort(function (a, b) {
      return tree[links[a].source].y - tree[links[b].source].y;
    });

    for (var j = 0, tLen = node.targetLinks.length; j < tLen; j++) {
      var link = links[node.targetLinks[j]];

      if (link) {
        link.sy = sy;
        sy += link.dy;
      }
    }

    for (var _j2 = 0, sLen = node.sourceLinks.length; _j2 < sLen; _j2++) {
      var _link = links[node.sourceLinks[_j2]];

      if (_link) {
        _link.ty = ty;
        ty += _link.dy;
      }
    }
  }
};

var computeData = function computeData(_ref2) {
  var data = _ref2.data,
      width = _ref2.width,
      height = _ref2.height,
      iterations = _ref2.iterations,
      nodeWidth = _ref2.nodeWidth,
      nodePadding = _ref2.nodePadding;
  var links = data.links;

  var _getNodesTree = getNodesTree(data, width, nodeWidth),
      tree = _getNodesTree.tree;

  var depthTree = getDepthTree(tree);
  var newLinks = updateYOfTree(depthTree, height, nodePadding, links);
  resolveCollisions(depthTree, height, nodePadding);
  var alpha = 1;

  for (var i = 1; i <= iterations; i++) {
    relaxRightToLeft(tree, depthTree, newLinks, alpha *= 0.99);
    resolveCollisions(depthTree, height, nodePadding);
    relaxLeftToRight(tree, depthTree, newLinks, alpha);
    resolveCollisions(depthTree, height, nodePadding);
  }

  updateYOfLinks(tree, newLinks);
  return {
    nodes: tree,
    links: newLinks
  };
};

var getCoordinateOfTooltip = function getCoordinateOfTooltip(el, type) {
  if (type === 'node') {
    return {
      x: el.x + el.width / 2,
      y: el.y + el.height / 2
    };
  }

  return {
    x: (el.sourceX + el.targetX) / 2,
    y: (el.sourceY + el.targetY) / 2
  };
};

var getPayloadOfTooltip = function getPayloadOfTooltip(el, type, nameKey) {
  var payload = el.payload;

  if (type === 'node') {
    return [{
      payload: el,
      name: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__["a" /* getValueByDataKey */])(payload, nameKey, ''),
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__["a" /* getValueByDataKey */])(payload, 'value')
    }];
  }

  if (payload.source && payload.target) {
    var sourceName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__["a" /* getValueByDataKey */])(payload.source, nameKey, '');
    var targetName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__["a" /* getValueByDataKey */])(payload.target, nameKey, '');
    return [{
      payload: el,
      name: "".concat(sourceName, " - ").concat(targetName),
      value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__util_ChartUtils__["a" /* getValueByDataKey */])(payload, 'value')
    }];
  }

  return [];
};

var Sankey =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Sankey, _PureComponent);

  function Sankey(props) {
    var _this;

    _classCallCheck(this, Sankey);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Sankey).call(this, props));
    _this.state = _this.constructor.createDefaultState(props);
    return _this;
  } // eslint-disable-next-line camelcase


  _createClass(Sankey, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this$props = this.props,
          data = _this$props.data,
          width = _this$props.width,
          height = _this$props.height,
          margin = _this$props.margin,
          iterations = _this$props.iterations,
          nodeWidth = _this$props.nodeWidth,
          nodePadding = _this$props.nodePadding,
          nameKey = _this$props.nameKey;

      if (nextProps.data !== data || nextProps.width !== width || nextProps.height !== height || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ShallowEqual__["a" /* shallowEqual */])(nextProps.margin, margin) || nextProps.iterations !== iterations || nextProps.nodeWidth !== nodeWidth || nextProps.nodePadding !== nodePadding || nextProps.nameKey !== nameKey) {
        this.setState(this.constructor.createDefaultState(nextProps));
      }
    }
    /**
     * Returns default, reset state for the sankey chart.
     * @param  {Object} props The latest props
     * @return {Object} Whole new state
     */

  }, {
    key: "handleMouseEnter",
    value: function handleMouseEnter(el, type, e) {
      var _this$props2 = this.props,
          onMouseEnter = _this$props2.onMouseEnter,
          children = _this$props2.children;
      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["j" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_9__component_Tooltip__["a" /* default */]);

      if (tooltipItem) {
        this.setState({
          activeElement: el,
          activeElementType: type,
          isTooltipActive: true
        }, function () {
          if (onMouseEnter) {
            onMouseEnter(el, type, e);
          }
        });
      } else if (onMouseEnter) {
        onMouseEnter(el, type, e);
      }
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave(el, type, e) {
      var _this$props3 = this.props,
          onMouseLeave = _this$props3.onMouseLeave,
          children = _this$props3.children;
      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["j" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_9__component_Tooltip__["a" /* default */]);

      if (tooltipItem) {
        this.setState({
          isTooltipActive: false
        }, function () {
          if (onMouseLeave) {
            onMouseLeave(el, type, e);
          }
        });
      } else if (onMouseLeave) {
        onMouseLeave(el, type, e);
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(el, type, e) {
      var onClick = this.props.onClick;
      if (onClick) onClick(el, type, e);
    }
  }, {
    key: "renderLinks",
    value: function renderLinks(links, nodes) {
      var _this2 = this;

      var _this$props4 = this.props,
          linkCurvature = _this$props4.linkCurvature,
          linkContent = _this$props4.link,
          margin = _this$props4.margin;
      var top = margin.top || 0;
      var left = margin.left || 0;
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */], {
        className: "recharts-sankey-links",
        key: "recharts-sankey-links"
      }, links.map(function (link, i) {
        var sourceRelativeY = link.sy,
            targetRelativeY = link.ty,
            linkWidth = link.dy;
        var source = nodes[link.source];
        var target = nodes[link.target];
        var sourceX = source.x + source.dx + left;
        var targetX = target.x + left;
        var interpolationFunc = interpolationGenerator(sourceX, targetX);
        var sourceControlX = interpolationFunc(linkCurvature);
        var targetControlX = interpolationFunc(1 - linkCurvature);
        var sourceY = source.y + sourceRelativeY + linkWidth / 2 + top;
        var targetY = target.y + targetRelativeY + linkWidth / 2 + top;

        var linkProps = _objectSpread({
          sourceX: sourceX,
          targetX: targetX,
          sourceY: sourceY,
          targetY: targetY,
          sourceControlX: sourceControlX,
          targetControlX: targetControlX,
          sourceRelativeY: sourceRelativeY,
          targetRelativeY: targetRelativeY,
          linkWidth: linkWidth,
          index: i,
          payload: _objectSpread({}, link, {
            source: source,
            target: target
          })
        }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["a" /* getPresentationAttributes */])(linkContent));

        var events = {
          onMouseEnter: _this2.handleMouseEnter.bind(_this2, linkProps, 'link'),
          onMouseLeave: _this2.handleMouseLeave.bind(_this2, linkProps, 'link'),
          onClick: _this2.handleClick.bind(_this2, linkProps, 'link')
        };
        return (// eslint-disable-next-line react/no-array-index-key
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */], _extends({
            key: "link".concat(i)
          }, events), _this2.constructor.renderLinkItem(linkContent, linkProps))
        );
      }));
    }
  }, {
    key: "renderNodes",
    value: function renderNodes(nodes) {
      var _this3 = this;

      var _this$props5 = this.props,
          nodeContent = _this$props5.node,
          margin = _this$props5.margin;
      var top = margin.top || 0;
      var left = margin.left || 0;
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */], {
        className: "recharts-sankey-nodes",
        key: "recharts-sankey-nodes"
      }, nodes.map(function (node, i) {
        var x = node.x,
            y = node.y,
            dx = node.dx,
            dy = node.dy;

        var nodeProps = _objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["a" /* getPresentationAttributes */])(nodeContent), {
          x: x + left,
          y: y + top,
          width: dx,
          height: dy,
          index: i,
          payload: node
        });

        var events = {
          onMouseEnter: _this3.handleMouseEnter.bind(_this3, nodeProps, 'node'),
          onMouseLeave: _this3.handleMouseLeave.bind(_this3, nodeProps, 'node'),
          onClick: _this3.handleClick.bind(_this3, nodeProps, 'node')
        };
        return (// eslint-disable-next-line react/no-array-index-key
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__container_Layer__["a" /* default */], _extends({
            key: "node".concat(i)
          }, events), _this3.constructor.renderNodeItem(nodeContent, nodeProps))
        );
      }));
    }
  }, {
    key: "renderTooltip",
    value: function renderTooltip() {
      var _this$props6 = this.props,
          children = _this$props6.children,
          width = _this$props6.width,
          height = _this$props6.height,
          nameKey = _this$props6.nameKey;
      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["j" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_9__component_Tooltip__["a" /* default */]);

      if (!tooltipItem) {
        return null;
      }

      var _this$state = this.state,
          isTooltipActive = _this$state.isTooltipActive,
          activeElement = _this$state.activeElement,
          activeElementType = _this$state.activeElementType;
      var viewBox = {
        x: 0,
        y: 0,
        width: width,
        height: height
      };
      var coordinate = activeElement ? getCoordinateOfTooltip(activeElement, activeElementType) : defaultCoordinateOfTooltip;
      var payload = activeElement ? getPayloadOfTooltip(activeElement, activeElementType, nameKey) : [];
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(tooltipItem, {
        viewBox: viewBox,
        active: isTooltipActive,
        coordinate: coordinate,
        label: '',
        payload: payload
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["o" /* validateWidthHeight */])(this)) {
        return null;
      }

      var _this$props7 = this.props,
          width = _this$props7.width,
          height = _this$props7.height,
          className = _this$props7.className,
          style = _this$props7.style,
          children = _this$props7.children,
          others = _objectWithoutProperties(_this$props7, ["width", "height", "className", "style", "children"]);

      var _this$state2 = this.state,
          links = _this$state2.links,
          nodes = _this$state2.nodes;
      var attrs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["a" /* getPresentationAttributes */])(others);
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('recharts-wrapper', className),
        style: _objectSpread({}, style, {
          position: 'relative',
          cursor: 'default',
          width: width,
          height: height
        })
      }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__container_Surface__["a" /* default */], _extends({}, attrs, {
        width: width,
        height: height
      }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["r" /* filterSvgElements */])(children), this.renderLinks(links, nodes), this.renderNodes(nodes)), this.renderTooltip());
    }
  }], [{
    key: "createDefaultState",
    value: function createDefaultState(props) {
      var data = props.data,
          width = props.width,
          height = props.height,
          margin = props.margin,
          iterations = props.iterations,
          nodeWidth = props.nodeWidth,
          nodePadding = props.nodePadding;
      var contentWidth = width - (margin && margin.left || 0) - (margin && margin.right || 0);
      var contentHeight = height - (margin && margin.top || 0) - (margin && margin.bottom || 0);

      var _computeData = computeData({
        data: data,
        width: contentWidth,
        height: contentHeight,
        iterations: iterations,
        nodeWidth: nodeWidth,
        nodePadding: nodePadding
      }),
          links = _computeData.links,
          nodes = _computeData.nodes;

      return {
        activeElement: null,
        activeElementType: null,
        isTooltipActive: false,
        nodes: nodes,
        links: links
      };
    }
  }, {
    key: "renderLinkItem",
    value: function renderLinkItem(option, props) {
      if (__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(option)) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(option, props);
      }

      if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        return option(props);
      }

      var sourceX = props.sourceX,
          sourceY = props.sourceY,
          sourceControlX = props.sourceControlX,
          targetX = props.targetX,
          targetY = props.targetY,
          targetControlX = props.targetControlX,
          linkWidth = props.linkWidth,
          others = _objectWithoutProperties(props, ["sourceX", "sourceY", "sourceControlX", "targetX", "targetY", "targetControlX", "linkWidth"]);

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path", _extends({
        className: "recharts-sankey-link",
        d: "\n          M".concat(sourceX, ",").concat(sourceY, "\n          C").concat(sourceControlX, ",").concat(sourceY, " ").concat(targetControlX, ",").concat(targetY, " ").concat(targetX, ",").concat(targetY, "\n        "),
        fill: "none",
        stroke: "#333",
        strokeWidth: linkWidth,
        strokeOpacity: "0.2"
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["a" /* getPresentationAttributes */])(others)));
    }
  }, {
    key: "renderNodeItem",
    value: function renderNodeItem(option, props) {
      if (__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(option)) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(option, props);
      }

      if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(option)) {
        return option(props);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shape_Rectangle__["a" /* default */], _extends({
        className: "recharts-sankey-node",
        fill: "#0088fe",
        fillOpacity: "0.8"
      }, props));
    }
  }]);

  return Sankey;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

Sankey.displayName = 'Sankey';
Sankey.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {}, __WEBPACK_IMPORTED_MODULE_12__util_ReactUtils__["d" /* EVENT_ATTRIBUTES */], {
  nameKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]),
  dataKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]),
  width: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  data: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    nodes: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array,
    links: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
      target: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
      source: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
      value: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
    }))
  }),
  nodePadding: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  nodeWidth: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  linkCurvature: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  iterations: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  node: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]),
  link: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]),
  style: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node]),
  margin: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    top: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    right: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    bottom: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    left: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })
});
Sankey.defaultProps = {
  nodePadding: 10,
  nodeWidth: 10,
  nameKey: 'name',
  dataKey: 'value',
  linkCurvature: 0.5,
  iterations: 32,
  margin: {
    top: 5,
    right: 5,
    bottom: 5,
    left: 5
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = (Sankey);

/***/ }),
/* 1563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartesian_Scatter__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartesian_XAxis__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cartesian_YAxis__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cartesian_ZAxis__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_CartesianUtils__ = __webpack_require__(91);
/**
 * @fileOverview Scatter Chart
 */






/* unused harmony default export */ var _unused_webpack_default_export = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__generateCategoricalChart__["a" /* default */])({
  chartName: 'ScatterChart',
  GraphicalChild: __WEBPACK_IMPORTED_MODULE_1__cartesian_Scatter__["a" /* default */],
  eventType: 'single',
  axisComponents: [{
    axisType: 'xAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_2__cartesian_XAxis__["a" /* default */]
  }, {
    axisType: 'yAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_3__cartesian_YAxis__["a" /* default */]
  }, {
    axisType: 'zAxis',
    AxisComp: __WEBPACK_IMPORTED_MODULE_4__cartesian_ZAxis__["a" /* default */]
  }],
  formatAxisMap: __WEBPACK_IMPORTED_MODULE_5__util_CartesianUtils__["d" /* formatAxisMap */]
}));

/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isFunction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNaN__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isNaN___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isNaN__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_smooth__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__container_Surface__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__container_Layer__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shape_Rectangle__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__component_Tooltip__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shape_Polygon__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__util_ChartUtils__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__util_Constants__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__util_DOMUtils__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__util_DataUtils__ = __webpack_require__(27);





function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable jsx-a11y/no-static-element-interactions */

/**
 * @fileOverview TreemapChart
 */















var computeNode = function computeNode(_ref) {
  var depth = _ref.depth,
      node = _ref.node,
      index = _ref.index,
      valueKey = _ref.valueKey;
  var children = node.children;
  var childDepth = depth + 1;
  var computedChildren = children && children.length ? children.map(function (child, i) {
    return computeNode({
      depth: childDepth,
      node: child,
      index: i,
      valueKey: valueKey
    });
  }) : null;
  var value;

  if (children && children.length) {
    value = computedChildren.reduce(function (result, child) {
      return result + child.value;
    }, 0);
  } else {
    value = __WEBPACK_IMPORTED_MODULE_3_lodash_isNaN___default()(node[valueKey]) || node[valueKey] <= 0 ? 0 : node[valueKey];
  }

  return _objectSpread({}, node, {
    children: computedChildren,
    value: value,
    depth: depth,
    index: index
  });
};

var filterRect = function filterRect(node) {
  return {
    x: node.x,
    y: node.y,
    width: node.width,
    height: node.height
  };
}; // Compute the area for each child based on value & scale.


var getAreaOfChildren = function getAreaOfChildren(children, areaValueRatio) {
  var ratio = areaValueRatio < 0 ? 0 : areaValueRatio;
  return children.map(function (child) {
    var area = child.value * ratio;
    return _objectSpread({}, child, {
      area: __WEBPACK_IMPORTED_MODULE_3_lodash_isNaN___default()(area) || area <= 0 ? 0 : area
    });
  });
}; // Computes the score for the specified row, as the worst aspect ratio.


var getWorstScore = function getWorstScore(row, parentSize, aspectRatio) {
  var parentArea = parentSize * parentSize;
  var rowArea = row.area * row.area;

  var _row$reduce = row.reduce(function (result, child) {
    return {
      min: Math.min(result.min, child.area),
      max: Math.max(result.max, child.area)
    };
  }, {
    min: Infinity,
    max: 0
  }),
      min = _row$reduce.min,
      max = _row$reduce.max;

  return rowArea ? Math.max(parentArea * max * aspectRatio / rowArea, rowArea / (parentArea * min * aspectRatio)) : Infinity;
};

var horizontalPosition = function horizontalPosition(row, parentSize, parentRect, isFlush) {
  var rowHeight = parentSize ? Math.round(row.area / parentSize) : 0;

  if (isFlush || rowHeight > parentRect.height) {
    rowHeight = parentRect.height;
  }

  var curX = parentRect.x;
  var child;

  for (var i = 0, len = row.length; i < len; i++) {
    child = row[i];
    child.x = curX;
    child.y = parentRect.y;
    child.height = rowHeight;
    child.width = Math.min(rowHeight ? Math.round(child.area / rowHeight) : 0, parentRect.x + parentRect.width - curX);
    curX += child.width;
  } // what's z


  child.z = true; // add the remain x to the last one of row

  child.width += parentRect.x + parentRect.width - curX;
  return _objectSpread({}, parentRect, {
    y: parentRect.y + rowHeight,
    height: parentRect.height - rowHeight
  });
};

var verticalPosition = function verticalPosition(row, parentSize, parentRect, isFlush) {
  var rowWidth = parentSize ? Math.round(row.area / parentSize) : 0;

  if (isFlush || rowWidth > parentRect.width) {
    rowWidth = parentRect.width;
  }

  var curY = parentRect.y;
  var child;

  for (var i = 0, len = row.length; i < len; i++) {
    child = row[i];
    child.x = parentRect.x;
    child.y = curY;
    child.width = rowWidth;
    child.height = Math.min(rowWidth ? Math.round(child.area / rowWidth) : 0, parentRect.y + parentRect.height - curY);
    curY += child.height;
  }

  child.z = false;
  child.height += parentRect.y + parentRect.height - curY;
  return _objectSpread({}, parentRect, {
    x: parentRect.x + rowWidth,
    width: parentRect.width - rowWidth
  });
};

var position = function position(row, parentSize, parentRect, isFlush) {
  if (parentSize === parentRect.width) {
    return horizontalPosition(row, parentSize, parentRect, isFlush);
  }

  return verticalPosition(row, parentSize, parentRect, isFlush);
}; // Recursively arranges the specified node's children into squarified rows.


var squarify = function squarify(node, aspectRatio) {
  var children = node.children;

  if (children && children.length) {
    var rect = filterRect(node);
    var row = [];
    var best = Infinity; // the best row score so far

    var child, score; // the current row score

    var size = Math.min(rect.width, rect.height); // initial orientation

    var scaleChildren = getAreaOfChildren(children, rect.width * rect.height / node.value);
    var tempChildren = scaleChildren.slice();
    row.area = 0;

    while (tempChildren.length > 0) {
      // row first
      // eslint-disable-next-line prefer-destructuring
      row.push(child = tempChildren[0]);
      row.area += child.area;
      score = getWorstScore(row, size, aspectRatio);

      if (score <= best) {
        // continue with this orientation
        tempChildren.shift();
        best = score;
      } else {
        // abort, and try a different orientation
        row.area -= row.pop().area;
        rect = position(row, size, rect, false);
        size = Math.min(rect.width, rect.height);
        row.length = row.area = 0;
        best = Infinity;
      }
    }

    if (row.length) {
      rect = position(row, size, rect, true);
      row.length = row.area = 0;
    }

    return _objectSpread({}, node, {
      children: scaleChildren.map(function (c) {
        return squarify(c, aspectRatio);
      })
    });
  }

  return node;
};

var Treemap =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Treemap, _PureComponent);

  function Treemap() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Treemap);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Treemap)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = _this.constructor.createDefaultState();

    _this.handleAnimationEnd = function () {
      var onAnimationEnd = _this.props.onAnimationEnd;

      _this.setState({
        isAnimationFinished: true
      });

      if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(onAnimationEnd)) {
        onAnimationEnd();
      }
    };

    _this.handleAnimationStart = function () {
      var onAnimationStart = _this.props.onAnimationStart;

      _this.setState({
        isAnimationFinished: false
      });

      if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(onAnimationStart)) {
        onAnimationStart();
      }
    };

    return _this;
  }

  _createClass(Treemap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          type = _this$props.type,
          width = _this$props.width,
          height = _this$props.height,
          data = _this$props.data,
          dataKey = _this$props.dataKey,
          aspectRatio = _this$props.aspectRatio;

      var _this$computeRoot = this.computeRoot({
        type: type,
        width: width,
        height: height,
        data: data,
        dataKey: dataKey,
        aspectRatio: aspectRatio
      }),
          formatRoot = _this$computeRoot.formatRoot,
          currentRoot = _this$computeRoot.currentRoot,
          nestIndex = _this$computeRoot.nestIndex;

      this.setState({
        formatRoot: formatRoot,
        currentRoot: currentRoot,
        nestIndex: nestIndex
      });
    }
  }, {
    key: "computeRoot",
    value: function computeRoot(_ref2) {
      var type = _ref2.type,
          width = _ref2.width,
          height = _ref2.height,
          data = _ref2.data,
          dataKey = _ref2.dataKey,
          aspectRatio = _ref2.aspectRatio;
      var root = computeNode({
        depth: 0,
        node: {
          children: data,
          x: 0,
          y: 0,
          width: width,
          height: height
        },
        index: 0,
        valueKey: dataKey
      });
      var formatRoot = squarify(root, aspectRatio);
      var nestIndex = this.state.nestIndex;

      if (type === 'nest') {
        nestIndex.push(root);
      }

      return {
        formatRoot: formatRoot,
        currentRoot: root,
        nestIndex: nestIndex
      };
    } // eslint-disable-next-line camelcase

  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var type = nextProps.type,
          width = nextProps.width,
          height = nextProps.height,
          data = nextProps.data,
          dataKey = nextProps.dataKey,
          aspectRatio = nextProps.aspectRatio;

      if (data !== this.props.data || type !== this.props.type || width !== this.props.width || height !== this.props.height || dataKey !== this.props.dataKey || aspectRatio !== this.props.aspectRatio) {
        var nextRoot = this.computeRoot({
          type: type,
          width: width,
          height: height,
          data: data,
          dataKey: dataKey,
          aspectRatio: aspectRatio
        });
        this.setState(_objectSpread({}, this.constructor.createDefaultState(), {}, nextRoot, {
          nestIndex: [nextRoot.currentRoot]
        }));
      }
    }
    /**
     * Returns default, reset state for the treemap chart.
     * @return {Object} Whole new state
     */

  }, {
    key: "handleMouseEnter",
    value: function handleMouseEnter(node, e) {
      var _this$props2 = this.props,
          onMouseEnter = _this$props2.onMouseEnter,
          children = _this$props2.children;
      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["j" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_12__component_Tooltip__["a" /* default */]);

      if (tooltipItem) {
        this.setState({
          isTooltipActive: true,
          activeNode: node
        }, function () {
          if (onMouseEnter) {
            onMouseEnter(node, e);
          }
        });
      } else if (onMouseEnter) {
        onMouseEnter(node, e);
      }
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave(node, e) {
      var _this$props3 = this.props,
          onMouseLeave = _this$props3.onMouseLeave,
          children = _this$props3.children;
      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["j" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_12__component_Tooltip__["a" /* default */]);

      if (tooltipItem) {
        this.setState({
          isTooltipActive: false,
          activeNode: null
        }, function () {
          if (onMouseLeave) {
            onMouseLeave(node, e);
          }
        });
      } else if (onMouseLeave) {
        onMouseLeave(node, e);
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(node) {
      var _this$props4 = this.props,
          onClick = _this$props4.onClick,
          type = _this$props4.type;

      if (type === 'nest' && node.children) {
        var _this$props5 = this.props,
            width = _this$props5.width,
            height = _this$props5.height,
            dataKey = _this$props5.dataKey,
            aspectRatio = _this$props5.aspectRatio;
        var root = computeNode({
          depth: 0,
          node: _objectSpread({}, node, {
            x: 0,
            y: 0,
            width: width,
            height: height
          }),
          index: 0,
          valueKey: dataKey
        });
        var formatRoot = squarify(root, aspectRatio);
        var nestIndex = this.state.nestIndex;
        nestIndex.push(node);
        this.setState({
          formatRoot: formatRoot,
          currentRoot: root,
          nestIndex: nestIndex
        });
      }

      if (onClick) {
        onClick(node);
      }
    }
  }, {
    key: "handleNestIndex",
    value: function handleNestIndex(node, i) {
      var nestIndex = this.state.nestIndex;
      var _this$props6 = this.props,
          width = _this$props6.width,
          height = _this$props6.height,
          dataKey = _this$props6.dataKey,
          aspectRatio = _this$props6.aspectRatio;
      var root = computeNode({
        depth: 0,
        node: _objectSpread({}, node, {
          x: 0,
          y: 0,
          width: width,
          height: height
        }),
        index: 0,
        valueKey: dataKey
      });
      var formatRoot = squarify(root, aspectRatio);
      nestIndex = nestIndex.slice(0, i + 1);
      this.setState({
        formatRoot: formatRoot,
        currentRoot: node,
        nestIndex: nestIndex
      });
    }
  }, {
    key: "renderItem",
    value: function renderItem(content, nodeProps, isLeaf) {
      var _this2 = this;

      var _this$props7 = this.props,
          isAnimationActive = _this$props7.isAnimationActive,
          animationBegin = _this$props7.animationBegin,
          animationDuration = _this$props7.animationDuration,
          animationEasing = _this$props7.animationEasing,
          isUpdateAnimationActive = _this$props7.isUpdateAnimationActive,
          type = _this$props7.type,
          animationId = _this$props7.animationId,
          colorPanel = _this$props7.colorPanel;
      var isAnimationFinished = this.state.isAnimationFinished;
      var width = nodeProps.width,
          height = nodeProps.height,
          x = nodeProps.x,
          y = nodeProps.y,
          depth = nodeProps.depth;
      var translateX = parseInt((Math.random() * 2 - 1) * width, 10);
      var event = {};

      if (isLeaf || type === 'nest') {
        event = {
          onMouseEnter: this.handleMouseEnter.bind(this, nodeProps),
          onMouseLeave: this.handleMouseLeave.bind(this, nodeProps),
          onClick: this.handleClick.bind(this, nodeProps)
        };
      }

      if (!isAnimationActive) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], event, this.constructor.renderContentItem(content, _objectSpread({}, nodeProps, {
          isAnimationActive: false,
          isUpdateAnimationActive: false,
          width: width,
          height: height,
          x: x,
          y: y
        }), type, colorPanel));
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_smooth__["a" /* default */], {
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        key: "treemap-".concat(animationId),
        from: {
          x: x,
          y: y,
          width: width,
          height: height
        },
        to: {
          x: x,
          y: y,
          width: width,
          height: height
        },
        onAnimationStart: this.handleAnimationStart,
        onAnimationEnd: this.handleAnimationEnd
      }, function (_ref3) {
        var currX = _ref3.x,
            currY = _ref3.y,
            currWidth = _ref3.width,
            currHeight = _ref3.height;
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_smooth__["a" /* default */], {
          from: "translate(".concat(translateX, "px, ").concat(translateX, "px)"),
          to: "translate(0, 0)",
          attributeName: "transform",
          begin: animationBegin,
          easing: animationEasing,
          isActive: isAnimationActive,
          duration: animationDuration
        }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], event, function () {
          // when animation Duration , only render depth=1 nodes
          if (depth > 2 && !isAnimationFinished) {
            return null;
          }

          return _this2.constructor.renderContentItem(content, _objectSpread({}, nodeProps, {
            isAnimationActive: isAnimationActive,
            isUpdateAnimationActive: !isUpdateAnimationActive,
            width: currWidth,
            height: currHeight,
            x: currX,
            y: currY
          }), type, colorPanel);
        }()));
      });
    }
  }, {
    key: "renderNode",
    value: function renderNode(root, node, i) {
      var _this3 = this;

      var _this$props8 = this.props,
          content = _this$props8.content,
          type = _this$props8.type;

      var nodeProps = _objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props), {}, node, {
        root: root
      });

      var isLeaf = !node.children || !node.children.length;
      var currentRoot = this.state.currentRoot;
      var isCurrentRootChild = (currentRoot.children || []).filter(function (item) {
        return item.depth === node.depth && item.name === node.name;
      });

      if (!isCurrentRootChild.length && root.depth && type === 'nest') {
        return null;
      }

      return (// eslint-disable-next-line react/no-array-index-key
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__container_Layer__["a" /* default */], {
          key: "recharts-treemap-node-".concat(i),
          className: "recharts-treemap-depth-".concat(node.depth)
        }, this.renderItem(content, nodeProps, isLeaf), node.children && node.children.length ? node.children.map(function (child, index) {
          return _this3.renderNode(node, child, index);
        }) : null)
      );
    }
  }, {
    key: "renderAllNodes",
    value: function renderAllNodes() {
      var formatRoot = this.state.formatRoot;

      if (!formatRoot) {
        return null;
      }

      return this.renderNode(formatRoot, formatRoot, 0);
    }
  }, {
    key: "renderTooltip",
    value: function renderTooltip() {
      var _this$props9 = this.props,
          children = _this$props9.children,
          nameKey = _this$props9.nameKey;
      var tooltipItem = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["j" /* findChildByType */])(children, __WEBPACK_IMPORTED_MODULE_12__component_Tooltip__["a" /* default */]);

      if (!tooltipItem) {
        return null;
      }

      var _this$props10 = this.props,
          width = _this$props10.width,
          height = _this$props10.height,
          dataKey = _this$props10.dataKey;
      var _this$state = this.state,
          isTooltipActive = _this$state.isTooltipActive,
          activeNode = _this$state.activeNode;
      var viewBox = {
        x: 0,
        y: 0,
        width: width,
        height: height
      };
      var coordinate = activeNode ? {
        x: activeNode.x + activeNode.width / 2,
        y: activeNode.y + activeNode.height / 2
      } : null;
      var payload = isTooltipActive && activeNode ? [{
        payload: activeNode,
        name: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_ChartUtils__["a" /* getValueByDataKey */])(activeNode, nameKey, ''),
        value: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__util_ChartUtils__["a" /* getValueByDataKey */])(activeNode, dataKey)
      }] : [];
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(tooltipItem, {
        viewBox: viewBox,
        active: isTooltipActive,
        coordinate: coordinate,
        label: '',
        payload: payload
      });
    } // render nest treemap

  }, {
    key: "renderNestIndex",
    value: function renderNestIndex() {
      var _this4 = this;

      var _this$props11 = this.props,
          nameKey = _this$props11.nameKey,
          nestIndexContent = _this$props11.nestIndexContent;
      var nestIndex = this.state.nestIndex;
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
        className: "recharts-treemap-nest-index-wrapper",
        style: {
          marginTop: '8px',
          textAlign: 'center'
        }
      }, nestIndex.map(function (item, i) {
        var name = __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(item, nameKey, 'root');

        var content = null;

        if (__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(nestIndexContent)) {
          content = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(nestIndexContent, item, i);
        }

        if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(nestIndexContent)) {
          content = nestIndexContent(item, i);
        } else {
          content = name;
        }

        return (// eslint-disable-next-line jsx-a11y/click-events-have-key-events
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
            onClick: _this4.handleNestIndex.bind(_this4, item, i),
            key: "nest-index-".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__util_DataUtils__["f" /* uniqueId */])()),
            className: "recharts-treemap-nest-index-box",
            style: {
              cursor: 'pointer',
              display: 'inline-block',
              padding: '0 7px',
              background: '#000',
              color: '#fff',
              marginRight: '3px'
            }
          }, content)
        );
      }));
    }
  }, {
    key: "render",
    value: function render() {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["o" /* validateWidthHeight */])(this)) {
        return null;
      }

      var _this$props12 = this.props,
          width = _this$props12.width,
          height = _this$props12.height,
          className = _this$props12.className,
          style = _this$props12.style,
          children = _this$props12.children,
          type = _this$props12.type,
          others = _objectWithoutProperties(_this$props12, ["width", "height", "className", "style", "children", "type"]);

      var attrs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["a" /* getPresentationAttributes */])(others);
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('recharts-wrapper', className),
        style: _objectSpread({}, style, {
          position: 'relative',
          cursor: 'default',
          width: width,
          height: height
        })
      }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__container_Surface__["a" /* default */], _extends({}, attrs, {
        width: width,
        height: type === 'nest' ? height - 30 : height
      }), this.renderAllNodes(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["r" /* filterSvgElements */])(children)), this.renderTooltip(), type === 'nest' && this.renderNestIndex());
    }
  }], [{
    key: "createDefaultState",
    value: function createDefaultState() {
      return {
        isTooltipActive: false,
        isAnimationFinished: false,
        activeNode: null,
        currentRoot: null,
        formatRoot: null,
        nestIndex: []
      };
    }
  }, {
    key: "renderContentItem",
    value: function renderContentItem(content, nodeProps, type, colorPanel) {
      if (__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(content)) {
        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(content, nodeProps);
      }

      if (__WEBPACK_IMPORTED_MODULE_2_lodash_isFunction___default()(content)) {
        return content(nodeProps);
      } // optimize default shape


      var x = nodeProps.x,
          y = nodeProps.y,
          width = nodeProps.width,
          height = nodeProps.height,
          index = nodeProps.index;
      var arrow = null;

      if (width > 10 && height > 10 && nodeProps.children && type === 'nest') {
        arrow = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__shape_Polygon__["a" /* default */], {
          points: [{
            x: x + 2,
            y: y + height / 2
          }, {
            x: x + 6,
            y: y + height / 2 + 3
          }, {
            x: x + 2,
            y: y + height / 2 + 6
          }]
        });
      }

      var text = null;
      var nameSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16__util_DOMUtils__["a" /* getStringSize */])(nodeProps.name);

      if (width > 20 && height > 20 && nameSize.width < width && nameSize.height < height) {
        text = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("text", {
          x: x + 8,
          y: y + height / 2 + 7,
          fontSize: 14
        }, nodeProps.name);
      }

      var colors = colorPanel || __WEBPACK_IMPORTED_MODULE_15__util_Constants__["a" /* COLOR_PANEL */];
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("g", null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__shape_Rectangle__["a" /* default */], _extends({
        fill: nodeProps.depth < 2 ? colors[index % colors.length] : 'rgba(255,255,255,0)',
        stroke: "#fff"
      }, __WEBPACK_IMPORTED_MODULE_1_lodash_omit___default()(nodeProps, 'children'))), arrow, text);
    }
  }]);

  return Treemap;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

Treemap.displayName = 'Treemap';
Treemap.propTypes = {
  width: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  height: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  data: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array,
  animationId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  style: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  aspectRatio: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  content: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]),
  fill: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  stroke: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  nameKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]),
  dataKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]),
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node]),
  // optional values flat/nest, flat show whole treemap, nest only show depth=1 node
  type: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['flat', 'nest']),
  colorPanel: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array,
  // customize nest index content
  nestIndexContent: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]),
  onAnimationStart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onAnimationEnd: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  isAnimationActive: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  isUpdateAnimationActive: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  animationBegin: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  animationDuration: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  animationEasing: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['ease', 'ease-in', 'ease-out', 'ease-in-out', 'linear'])
};
Treemap.defaultProps = {
  dataKey: 'value',
  aspectRatio: 0.5 * (1 + Math.sqrt(5)),
  isAnimationActive: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["h" /* isSsr */])(),
  isUpdateAnimationActive: !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__util_ReactUtils__["h" /* isSsr */])(),
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: 'linear',
  type: 'flat'
};
/* unused harmony default export */ var _unused_webpack_default_export = (Treemap);

/***/ }),
/* 1565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__container_Layer__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_LogUtils__ = __webpack_require__(140);


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * @fileOverview Customized
 */




/**
 * custom svg elements by rechart instance props and state.
 * @returns {Object}   svg elements
 */

function Customized(_ref) {
  var component = _ref.component,
      props = _objectWithoutProperties(_ref, ["component"]);

  var child;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["isValidElement"])(component)) {
    child = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(component, props);
  } else if (__WEBPACK_IMPORTED_MODULE_0_lodash_isFunction___default()(component)) {
    child = component(props);
  } else {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_LogUtils__["a" /* warn */])(false, 'Customized\'s props `component` must be React.element or Function, but got %s.', _typeof(component));
  }

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__container_Layer__["a" /* default */], {
    className: "recharts-customized-wrapper"
  }, child);
}
Customized.displayName = 'Customized';
Customized.propTypes = {
  component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func]).isRequired
};

/***/ }),
/* 1566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__container_Surface__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shape_Symbols__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__ = __webpack_require__(23);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Default Legend Content
 */






var SIZE = 32;
var ICON_TYPES = __WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["f" /* LEGEND_TYPES */].filter(function (type) {
  return type !== 'none';
});

var DefaultLegendContent =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DefaultLegendContent, _PureComponent);

  function DefaultLegendContent() {
    _classCallCheck(this, DefaultLegendContent);

    return _possibleConstructorReturn(this, _getPrototypeOf(DefaultLegendContent).apply(this, arguments));
  }

  _createClass(DefaultLegendContent, [{
    key: "renderIcon",

    /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */
    value: function renderIcon(data) {
      var inactiveColor = this.props.inactiveColor;
      var halfSize = SIZE / 2;
      var sixthSize = SIZE / 6;
      var thirdSize = SIZE / 3;
      var color = data.inactive ? inactiveColor : data.color;

      if (data.type === 'plainline') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line", {
          strokeWidth: 4,
          fill: "none",
          stroke: color,
          strokeDasharray: data.payload.strokeDasharray,
          x1: 0,
          y1: halfSize,
          x2: SIZE,
          y2: halfSize,
          className: "recharts-legend-icon"
        });
      }

      if (data.type === 'line') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          strokeWidth: 4,
          fill: "none",
          stroke: color,
          d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat(SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
          className: "recharts-legend-icon"
        });
      }

      if (data.type === 'rect') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
          stroke: "none",
          fill: color,
          d: "M0,".concat(SIZE / 8, "h").concat(SIZE, "v").concat(SIZE * 3 / 4, "h").concat(-SIZE, "z"),
          className: "recharts-legend-icon"
        });
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__shape_Symbols__["a" /* default */], {
        fill: color,
        cx: halfSize,
        cy: halfSize,
        size: SIZE,
        sizeType: "diameter",
        type: data.type
      });
    }
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */

  }, {
    key: "renderItems",
    value: function renderItems() {
      var _this = this;

      var _this$props = this.props,
          payload = _this$props.payload,
          iconSize = _this$props.iconSize,
          layout = _this$props.layout,
          formatter = _this$props.formatter;
      var viewBox = {
        x: 0,
        y: 0,
        width: SIZE,
        height: SIZE
      };
      var itemStyle = {
        display: layout === 'horizontal' ? 'inline-block' : 'block',
        marginRight: 10
      };
      var svgStyle = {
        display: 'inline-block',
        verticalAlign: 'middle',
        marginRight: 4
      };
      return payload.map(function (entry, i) {
        var _classNames;

        var finalFormatter = entry.formatter || formatter;
        var className = __WEBPACK_IMPORTED_MODULE_2_classnames___default()((_classNames = {
          'recharts-legend-item': true
        }, _defineProperty(_classNames, "legend-item-".concat(i), true), _defineProperty(_classNames, "inactive", entry.inactive), _classNames));

        if (entry.type === 'none') {
          return null;
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", _extends({
          className: className,
          style: itemStyle,
          key: "legend-item-".concat(i) // eslint-disable-line react/no-array-index-key

        }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["e" /* filterEventsOfChild */])(_this.props, entry, i)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__container_Surface__["a" /* default */], {
          width: iconSize,
          height: iconSize,
          viewBox: viewBox,
          style: svgStyle
        }, _this.renderIcon(entry)), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          className: "recharts-legend-item-text"
        }, finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          payload = _this$props2.payload,
          layout = _this$props2.layout,
          align = _this$props2.align;

      if (!payload || !payload.length) {
        return null;
      }

      var finalStyle = {
        padding: 0,
        margin: 0,
        textAlign: layout === 'horizontal' ? align : 'left'
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        className: "recharts-default-legend",
        style: finalStyle
      }, this.renderItems());
    }
  }]);

  return DefaultLegendContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

DefaultLegendContent.displayName = 'Legend';
DefaultLegendContent.propTypes = {
  content: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element,
  iconSize: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  iconType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(ICON_TYPES),
  layout: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['horizontal', 'vertical']),
  align: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['center', 'left', 'right']),
  verticalAlign: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['top', 'bottom', 'middle']),
  payload: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
    id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
    type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(__WEBPACK_IMPORTED_MODULE_5__util_ReactUtils__["f" /* LEGEND_TYPES */])
  })),
  inactiveColor: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  formatter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
DefaultLegendContent.defaultProps = {
  iconSize: 14,
  layout: 'horizontal',
  align: 'center',
  verticalAlign: 'middle',
  inactiveColor: '#ccc'
};
/* harmony default export */ __webpack_exports__["a"] = (DefaultLegendContent);

/***/ }),
/* 1567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isArray__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_DataUtils__ = __webpack_require__(27);



function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }






var defaultFormatter = function defaultFormatter(value) {
  return __WEBPACK_IMPORTED_MODULE_1_lodash_isArray___default()(value) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["c" /* isNumOrStr */])(value[0]) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["c" /* isNumOrStr */])(value[1]) ? value.join(' ~ ') : value;
};

var DefaultTooltipContent =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DefaultTooltipContent, _PureComponent);

  function DefaultTooltipContent() {
    _classCallCheck(this, DefaultTooltipContent);

    return _possibleConstructorReturn(this, _getPrototypeOf(DefaultTooltipContent).apply(this, arguments));
  }

  _createClass(DefaultTooltipContent, [{
    key: "renderContent",
    value: function renderContent() {
      var _this$props = this.props,
          payload = _this$props.payload,
          separator = _this$props.separator,
          formatter = _this$props.formatter,
          itemStyle = _this$props.itemStyle,
          itemSorter = _this$props.itemSorter;

      if (payload && payload.length) {
        var listStyle = {
          padding: 0,
          margin: 0
        };
        var items = (itemSorter ? __WEBPACK_IMPORTED_MODULE_0_lodash_sortBy___default()(payload, itemSorter) : payload).map(function (entry, i) {
          if (entry.type === 'none') {
            return null;
          }

          var finalItemStyle = _objectSpread({
            display: 'block',
            paddingTop: 4,
            paddingBottom: 4,
            color: entry.color || '#000'
          }, itemStyle);

          var finalFormatter = entry.formatter || formatter || defaultFormatter;
          var name = entry.name,
              value = entry.value;

          if (finalFormatter) {
            var formatted = finalFormatter(value, name, entry, i);

            if (Array.isArray(formatted)) {
              var _formatted = _slicedToArray(formatted, 2);

              value = _formatted[0];
              name = _formatted[1];
            } else {
              value = formatted;
            }
          }

          return (// eslint-disable-next-line react/no-array-index-key
            __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("li", {
              className: "recharts-tooltip-item",
              key: "tooltip-item-".concat(i),
              style: finalItemStyle
            }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["c" /* isNumOrStr */])(name) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
              className: "recharts-tooltip-item-name"
            }, name) : null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["c" /* isNumOrStr */])(name) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
              className: "recharts-tooltip-item-separator"
            }, separator) : null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
              className: "recharts-tooltip-item-value"
            }, value), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
              className: "recharts-tooltip-item-unit"
            }, entry.unit || ''))
          );
        });
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("ul", {
          className: "recharts-tooltip-item-list",
          style: listStyle
        }, items);
      }

      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          wrapperClassName = _this$props2.wrapperClassName,
          contentStyle = _this$props2.contentStyle,
          labelClassName = _this$props2.labelClassName,
          labelStyle = _this$props2.labelStyle,
          label = _this$props2.label,
          labelFormatter = _this$props2.labelFormatter;

      var finalStyle = _objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        whiteSpace: 'nowrap'
      }, contentStyle);

      var finalLabelStyle = _objectSpread({
        margin: 0
      }, labelStyle);

      var hasLabel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["c" /* isNumOrStr */])(label);
      var finalLabel = hasLabel ? label : '';
      var wrapperCN = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('recharts-default-tooltip', wrapperClassName);
      var labelCN = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('recharts-tooltip-label', labelClassName);

      if (hasLabel && labelFormatter) {
        finalLabel = labelFormatter(label);
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
        className: wrapperCN,
        style: finalStyle
      }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("p", {
        className: labelCN,
        style: finalLabelStyle
      }, finalLabel), this.renderContent());
    }
  }]);

  return DefaultTooltipContent;
}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]);

DefaultTooltipContent.displayName = 'DefaultTooltipContent';
DefaultTooltipContent.propTypes = {
  separator: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  wrapperClassName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  labelClassName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  formatter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  contentStyle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  itemStyle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  labelStyle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  labelFormatter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  label: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
  payload: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
    value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array]),
    unit: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any
  })),
  itemSorter: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};
DefaultTooltipContent.defaultProps = {
  separator: ' : ',
  contentStyle: {},
  itemStyle: {},
  labelStyle: {}
};
/* harmony default export */ __webpack_exports__["a"] = (DefaultTooltipContent);

/***/ }),
/* 1568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_resize_detector__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_resize_detector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_resize_detector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_DataUtils__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_LogUtils__ = __webpack_require__(140);


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Wrapper component to make charts adapt to the size of parent * DOM
 */







var ResponsiveContainer =
/*#__PURE__*/
function (_Component) {
  _inherits(ResponsiveContainer, _Component);

  function ResponsiveContainer(props) {
    var _this;

    _classCallCheck(this, ResponsiveContainer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResponsiveContainer).call(this, props));

    _this.updateDimensionsImmediate = function () {
      if (!_this.mounted) {
        return;
      }

      var newSize = _this.getContainerSize();

      if (newSize) {
        var _this$state = _this.state,
            oldWidth = _this$state.containerWidth,
            oldHeight = _this$state.containerHeight;
        var containerWidth = newSize.containerWidth,
            containerHeight = newSize.containerHeight;

        if (containerWidth !== oldWidth || containerHeight !== oldHeight) {
          _this.setState({
            containerWidth: containerWidth,
            containerHeight: containerHeight
          });
        }
      }
    };

    _this.state = {
      containerWidth: -1,
      containerHeight: -1
    };
    _this.handleResize = props.debounce > 0 ? __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(_this.updateDimensionsImmediate, props.debounce) : _this.updateDimensionsImmediate;
    return _this;
  }
  /* eslint-disable  react/no-did-mount-set-state */


  _createClass(ResponsiveContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      var size = this.getContainerSize();

      if (size) {
        this.setState(size);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "getContainerSize",
    value: function getContainerSize() {
      if (!this.container) {
        return null;
      }

      return {
        containerWidth: this.container.clientWidth,
        containerHeight: this.container.clientHeight
      };
    }
  }, {
    key: "renderChart",
    value: function renderChart() {
      var _this$state2 = this.state,
          containerWidth = _this$state2.containerWidth,
          containerHeight = _this$state2.containerHeight;

      if (containerWidth < 0 || containerHeight < 0) {
        return null;
      }

      var _this$props = this.props,
          aspect = _this$props.aspect,
          width = _this$props.width,
          height = _this$props.height,
          minWidth = _this$props.minWidth,
          minHeight = _this$props.minHeight,
          maxHeight = _this$props.maxHeight,
          children = _this$props.children;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_LogUtils__["a" /* warn */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["h" /* isPercent */])(width) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["h" /* isPercent */])(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_LogUtils__["a" /* warn */])(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
      var calculatedWidth = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["h" /* isPercent */])(width) ? containerWidth : width;
      var calculatedHeight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__util_DataUtils__["h" /* isPercent */])(height) ? containerHeight : height;

      if (aspect && aspect > 0) {
        // Preserve the desired aspect ratio
        if (calculatedWidth) {
          // Will default to using width for aspect ratio
          calculatedHeight = calculatedWidth / aspect;
        } else if (calculatedHeight) {
          // But we should also take height into consideration
          calculatedWidth = calculatedHeight * aspect;
        } // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight


        if (maxHeight && calculatedHeight > maxHeight) {
          calculatedHeight = maxHeight;
        }
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__util_LogUtils__["a" /* warn */])(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
        width: calculatedWidth,
        height: calculatedHeight
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          minWidth = _this$props2.minWidth,
          minHeight = _this$props2.minHeight,
          width = _this$props2.width,
          height = _this$props2.height,
          maxHeight = _this$props2.maxHeight,
          id = _this$props2.id,
          className = _this$props2.className;
      var style = {
        width: width,
        height: height,
        minWidth: minWidth,
        minHeight: minHeight,
        maxHeight: maxHeight
      };
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
        id: id,
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('recharts-responsive-container', className),
        style: style,
        ref: function ref(node) {
          _this2.container = node;
        }
      }, this.renderChart(), __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_resize_detector___default.a, {
        handleWidth: true,
        handleHeight: true,
        onResize: this.handleResize
      }));
    }
  }]);

  return ResponsiveContainer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ResponsiveContainer.displayName = 'ResponsiveContainer';
ResponsiveContainer.propTypes = {
  aspect: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  width: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  height: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  minHeight: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  minWidth: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  maxHeight: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,
  debounce: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  id: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),
  className: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number])
};
ResponsiveContainer.defaultProps = {
  width: '100%',
  height: '100%',
  debounce: 0
};
/* unused harmony default export */ var _unused_webpack_default_export = (ResponsiveContainer);

/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_PolarUtils__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__ = __webpack_require__(23);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @fileOverview Polar Grid
 */





var PolarGrid =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(PolarGrid, _PureComponent);

  function PolarGrid() {
    _classCallCheck(this, PolarGrid);

    return _possibleConstructorReturn(this, _getPrototypeOf(PolarGrid).apply(this, arguments));
  }

  _createClass(PolarGrid, [{
    key: "getPolygonPath",
    value: function getPolygonPath(radius) {
      var _this$props = this.props,
          cx = _this$props.cx,
          cy = _this$props.cy,
          polarAngles = _this$props.polarAngles;
      var path = '';
      polarAngles.forEach(function (angle, i) {
        var point = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, radius, angle);

        if (i) {
          path += "L ".concat(point.x, ",").concat(point.y);
        } else {
          path += "M ".concat(point.x, ",").concat(point.y);
        }
      });
      path += 'Z';
      return path;
    }
    /**
     * Draw axis of radial line
     * @return {[type]} The lines
     */

  }, {
    key: "renderPolarAngles",
    value: function renderPolarAngles() {
      var _this$props2 = this.props,
          cx = _this$props2.cx,
          cy = _this$props2.cy,
          innerRadius = _this$props2.innerRadius,
          outerRadius = _this$props2.outerRadius,
          polarAngles = _this$props2.polarAngles;

      if (!polarAngles || !polarAngles.length) {
        return null;
      }

      var props = _objectSpread({
        stroke: '#ccc'
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props));

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
        className: "recharts-polar-grid-angle"
      }, polarAngles.map(function (entry, i) {
        var start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, innerRadius, entry);
        var end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__util_PolarUtils__["a" /* polarToCartesian */])(cx, cy, outerRadius, entry);
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line", _extends({}, props, {
          key: "line-".concat(i) // eslint-disable-line react/no-array-index-key
          ,
          x1: start.x,
          y1: start.y,
          x2: end.x,
          y2: end.y
        }));
      }));
    }
    /**
     * Draw concentric circles
     * @param {Number} radius The radius of circle
     * @param {Number} index  The index of circle
     * @param {Object} extraProps Extra props
     * @return {ReactElement} circle
     */

  }, {
    key: "renderConcentricCircle",
    value: function renderConcentricCircle(radius, index, extraProps) {
      var _this$props3 = this.props,
          cx = _this$props3.cx,
          cy = _this$props3.cy;

      var props = _objectSpread({
        stroke: '#ccc'
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props), {
        fill: 'none'
      }, extraProps);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", _extends({}, props, {
        className: "recharts-polar-grid-concentric-circle",
        key: "circle-".concat(index),
        cx: cx,
        cy: cy,
        r: radius
      }));
    }
    /**
     * Draw concentric polygons
     * @param {Number} radius     The radius of polygon
     * @param {Number} index      The index of polygon
     * @param {Object} extraProps Extra props
     * @return {ReactElement} polygon
     */

  }, {
    key: "renderConcentricPolygon",
    value: function renderConcentricPolygon(radius, index, extraProps) {
      var props = _objectSpread({
        stroke: '#ccc'
      }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["a" /* getPresentationAttributes */])(this.props), {
        fill: 'none'
      }, extraProps);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", _extends({}, props, {
        className: "recharts-polar-grid-concentric-polygon",
        key: "path-".concat(index),
        d: this.getPolygonPath(radius)
      }));
    }
    /**
     * Draw concentric axis
     * @return {ReactElement} Concentric axis
     * @todo Optimize the name
     */

  }, {
    key: "renderConcentricPath",
    value: function renderConcentricPath() {
      var _this = this;

      var _this$props4 = this.props,
          polarRadius = _this$props4.polarRadius,
          gridType = _this$props4.gridType;

      if (!polarRadius || !polarRadius.length) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
        className: "recharts-polar-grid-concentric"
      }, polarRadius.map(function (entry, i) {
        return gridType === 'circle' ? _this.renderConcentricCircle(entry, i) : _this.renderConcentricPolygon(entry, i);
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var outerRadius = this.props.outerRadius;

      if (outerRadius <= 0) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g", {
        className: "recharts-polar-grid"
      }, this.renderPolarAngles(), this.renderConcentricPath());
    }
  }]);

  return PolarGrid;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

PolarGrid.displayName = 'PolarGrid';
PolarGrid.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_3__util_ReactUtils__["c" /* PRESENTATION_ATTRIBUTES */], {
  cx: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  cy: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  innerRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  outerRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  polarAngles: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),
  polarRadius: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number),
  gridType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['polygon', 'circle'])
});
PolarGrid.defaultProps = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  gridType: 'polygon'
};
/* unused harmony default export */ var _unused_webpack_default_export = (PolarGrid);

/***/ }),
/* 1570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6_math__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6_math___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_es6_math__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_es6_number__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_es6_number___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_es6_number__);


/* eslint no-proto: 0 */

var testObject = {};

if (!(Object.setPrototypeOf || testObject.__proto__)) {
  var nativeGetPrototypeOf = Object.getPrototypeOf;

  Object.getPrototypeOf = function (object) {
    if (object.__proto__) {
      return object.__proto__;
    }

    return nativeGetPrototypeOf.call(Object, object);
  };
}

/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COLOR_PANEL; });
var COLOR_PANEL = ['#1890FF', '#66B5FF', '#41D9C7', '#2FC25B', '#6EDB8F', '#9AE65C', '#FACC14', '#E6965C', '#57AD71', '#223273', '#738AE6', '#7564CC', '#8543E0', '#A877ED', '#5C8EE6', '#13C2C2', '#70E0E0', '#5CA3E6', '#3436C7', '#8082FF', '#DD81E6', '#F04864', '#FA7D92', '#D598D9'];

/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return generatePrefixStyle; });
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PREFIX_LIST = ['Webkit', 'Moz', 'O', 'ms'];
var generatePrefixStyle = function generatePrefixStyle(name, value) {
  if (!name) {
    return null;
  }

  var camelName = name.replace(/(\w)/, function (v) {
    return v.toUpperCase();
  });
  var result = PREFIX_LIST.reduce(function (res, entry) {
    return _objectSpread({}, res, _defineProperty({}, entry + camelName, value));
  }, {});
  result[name] = value;
  return result;
};

/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return detectReferenceElementsDomain; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cartesian_ReferenceDot__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cartesian_ReferenceLine__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cartesian_ReferenceArea__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__IfOverflowMatches__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReactUtils__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DataUtils__ = __webpack_require__(27);






var detectReferenceElementsDomain = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
  var lines = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__ReactUtils__["i" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_1__cartesian_ReferenceLine__["a" /* default */]);
  var dots = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__ReactUtils__["i" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_0__cartesian_ReferenceDot__["a" /* default */]);
  var elements = lines.concat(dots);
  var areas = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__ReactUtils__["i" /* findAllByType */])(children, __WEBPACK_IMPORTED_MODULE_2__cartesian_ReferenceArea__["a" /* default */]);
  var idKey = "".concat(axisType, "Id");
  var valueKey = axisType[0];
  var finalDomain = domain;

  if (elements.length) {
    finalDomain = elements.reduce(function (result, el) {
      if (el.props[idKey] === axisId && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__IfOverflowMatches__["a" /* ifOverflowMatches */])(el.props, 'extendDomain') && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DataUtils__["a" /* isNumber */])(el.props[valueKey])) {
        var value = el.props[valueKey];
        return [Math.min(result[0], value), Math.max(result[1], value)];
      }

      return result;
    }, finalDomain);
  }

  if (areas.length) {
    var key1 = "".concat(valueKey, "1");
    var key2 = "".concat(valueKey, "2");
    finalDomain = areas.reduce(function (result, el) {
      if (el.props[idKey] === axisId && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__IfOverflowMatches__["a" /* ifOverflowMatches */])(el.props, 'extendDomain') && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DataUtils__["a" /* isNumber */])(el.props[key1]) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DataUtils__["a" /* isNumber */])(el.props[key2])) {
        var value1 = el.props[key1];
        var value2 = el.props[key2];
        return [Math.min(result[0], value1, value2), Math.max(result[1], value1, value2)];
      }

      return result;
    }, finalDomain);
  }

  if (specifiedTicks && specifiedTicks.length) {
    finalDomain = specifiedTicks.reduce(function (result, tick) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__DataUtils__["a" /* isNumber */])(tick)) {
        return [Math.min(result[0], tick), Math.max(result[1], tick)];
      }

      return result;
    }, finalDomain);
  }

  return finalDomain;
};

/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return eventCenter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SYNC_EVENT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_events__);

var eventCenter = new __WEBPACK_IMPORTED_MODULE_0_events___default.a();

if (eventCenter.setMaxListeners) {
  eventCenter.setMaxListeners(10);
}


var SYNC_EVENT = 'recharts.syncMouseEvents';

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1596);
__webpack_require__(1597);
__webpack_require__(1598);
__webpack_require__(1599);
__webpack_require__(1600);
__webpack_require__(1601);
__webpack_require__(1602);
__webpack_require__(1603);
__webpack_require__(1604);
__webpack_require__(1605);
__webpack_require__(1606);
__webpack_require__(1607);
__webpack_require__(1608);
__webpack_require__(1609);
__webpack_require__(1610);
__webpack_require__(1611);
__webpack_require__(1612);
module.exports = __webpack_require__(177).Math;


/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1613);
__webpack_require__(1623);
__webpack_require__(1624);
__webpack_require__(1614);
__webpack_require__(1615);
__webpack_require__(1616);
__webpack_require__(1617);
__webpack_require__(1618);
__webpack_require__(1619);
__webpack_require__(1620);
__webpack_require__(1621);
__webpack_require__(1622);
module.exports = __webpack_require__(177).Number;


/***/ }),
/* 1577 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(364);
var toLength = __webpack_require__(1595);
var toAbsoluteIndex = __webpack_require__(1594);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(659)('native-function-to-string', Function.toString);


/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(76).document;
module.exports = document && document.documentElement;


/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(142);
var setPrototypeOf = __webpack_require__(1592).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(356);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 1583 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(360);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(233);
var dPs = __webpack_require__(1586);
var enumBugKeys = __webpack_require__(358);
var IE_PROTO = __webpack_require__(658)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(649)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(1580).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(361);
var anObject = __webpack_require__(233);
var getKeys = __webpack_require__(1588);

module.exports = __webpack_require__(141) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(655);
var hiddenKeys = __webpack_require__(358).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(655);
var enumBugKeys = __webpack_require__(358);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 1589 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(76).parseFloat;
var $trim = __webpack_require__(362).trim;

module.exports = 1 / $parseFloat(__webpack_require__(363) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(76).parseInt;
var $trim = __webpack_require__(362).trim;
var ws = __webpack_require__(363);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(142);
var anObject = __webpack_require__(233);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(648)(Function.call, __webpack_require__(654).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(235);
var defined = __webpack_require__(357);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(235);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(235);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(28);
var log1p = __webpack_require__(653);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(28);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(28);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(28);
var sign = __webpack_require__(360);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(28);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(28);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(28);
var $expm1 = __webpack_require__(359);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(28);

$export($export.S, 'Math', { fround: __webpack_require__(1584) });


/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(28);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(28);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(92)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(28);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(28);

$export($export.S, 'Math', { log1p: __webpack_require__(653) });


/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(28);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(28);

$export($export.S, 'Math', { sign: __webpack_require__(360) });


/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(28);
var expm1 = __webpack_require__(359);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(92)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(28);
var expm1 = __webpack_require__(359);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(28);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(76);
var has = __webpack_require__(234);
var cof = __webpack_require__(356);
var inheritIfRequired = __webpack_require__(1581);
var toPrimitive = __webpack_require__(365);
var fails = __webpack_require__(92);
var gOPN = __webpack_require__(1587).f;
var gOPD = __webpack_require__(654).f;
var dP = __webpack_require__(361).f;
var $trim = __webpack_require__(362).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(1585)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(141) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(657)(global, NUMBER, $Number);
}


/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(28);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(28);
var _isFinite = __webpack_require__(76).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(28);

$export($export.S, 'Number', { isInteger: __webpack_require__(652) });


/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(28);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(28);
var isInteger = __webpack_require__(652);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(28);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(28);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(28);
var $parseFloat = __webpack_require__(1590);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(28);
var $parseInt = __webpack_require__(1591);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(28);
var toInteger = __webpack_require__(235);
var aNumberValue = __webpack_require__(647);
var repeat = __webpack_require__(1593);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(92)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(28);
var $fails = __webpack_require__(92);
var aNumberValue = __webpack_require__(647);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(106),
    root = __webpack_require__(56);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1694),
    hashDelete = __webpack_require__(1695),
    hashGet = __webpack_require__(1696),
    hashHas = __webpack_require__(1697),
    hashSet = __webpack_require__(1698);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(106),
    root = __webpack_require__(56);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(106),
    root = __webpack_require__(56);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 1629 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 1630 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 1631 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

module.exports = arrayEvery;


/***/ }),
/* 1632 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(1642);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 1634 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(178),
    keys = __webpack_require__(148);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(178),
    keysIn = __webpack_require__(387);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(368),
    arrayEach = __webpack_require__(1630),
    assignValue = __webpack_require__(666),
    baseAssign = __webpack_require__(1635),
    baseAssignIn = __webpack_require__(1636),
    cloneBuffer = __webpack_require__(1670),
    copyArray = __webpack_require__(1677),
    copySymbols = __webpack_require__(1678),
    copySymbolsIn = __webpack_require__(1679),
    getAllKeys = __webpack_require__(677),
    getAllKeysIn = __webpack_require__(678),
    getTag = __webpack_require__(244),
    initCloneArray = __webpack_require__(1699),
    initCloneByTag = __webpack_require__(1700),
    initCloneObject = __webpack_require__(1701),
    isArray = __webpack_require__(34),
    isBuffer = __webpack_require__(383),
    isMap = __webpack_require__(1738),
    isObject = __webpack_require__(48),
    isSet = __webpack_require__(1739),
    keys = __webpack_require__(148),
    keysIn = __webpack_require__(387);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(48);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(371);

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  baseEach(collection, function(value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

module.exports = baseEvery;


/***/ }),
/* 1640 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1682);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 1641 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(667),
    baseIsNaN = __webpack_require__(1647),
    strictIndexOf = __webpack_require__(1729);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(93),
    isObjectLike = __webpack_require__(66);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(368),
    equalArrays = __webpack_require__(675),
    equalByTag = __webpack_require__(1687),
    equalObjects = __webpack_require__(1688),
    getTag = __webpack_require__(244),
    isArray = __webpack_require__(34),
    isBuffer = __webpack_require__(383),
    isTypedArray = __webpack_require__(688);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(244),
    isObjectLike = __webpack_require__(66);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(368),
    baseIsEqual = __webpack_require__(373);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 1647 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(29),
    isMasked = __webpack_require__(1704),
    isObject = __webpack_require__(48),
    toSource = __webpack_require__(685);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(244),
    isObjectLike = __webpack_require__(66);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(93),
    isLength = __webpack_require__(384),
    isObjectLike = __webpack_require__(66);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(379),
    nativeKeys = __webpack_require__(1717);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(48),
    isPrototype = __webpack_require__(379),
    nativeKeysIn = __webpack_require__(1718);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1646),
    getMatchData = __webpack_require__(1690),
    matchesStrictComparable = __webpack_require__(681);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(373),
    get = __webpack_require__(144),
    hasIn = __webpack_require__(1737),
    isKey = __webpack_require__(378),
    isStrictComparable = __webpack_require__(680),
    matchesStrictComparable = __webpack_require__(681),
    toKey = __webpack_require__(179);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(237),
    baseGet = __webpack_require__(240),
    baseIteratee = __webpack_require__(55),
    baseMap = __webpack_require__(672),
    baseSortBy = __webpack_require__(1663),
    baseUnary = __webpack_require__(241),
    compareMultiple = __webpack_require__(1676),
    identity = __webpack_require__(145),
    isArray = __webpack_require__(34);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),
/* 1656 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(240);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1658 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(145),
    overRest = __webpack_require__(683),
    setToString = __webpack_require__(684);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(1732),
    defineProperty = __webpack_require__(674),
    identity = __webpack_require__(145);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 1661 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(371);

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  baseEach(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

module.exports = baseSome;


/***/ }),
/* 1663 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),
/* 1664 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */
function baseSum(array, iteratee) {
  var result,
      index = -1,
      length = array.length;

  while (++index < length) {
    var current = iteratee(array[index]);
    if (current !== undefined) {
      result = result === undefined ? current : (result + current);
    }
  }
  return result;
}

module.exports = baseSum;


/***/ }),
/* 1665 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(143),
    arrayMap = __webpack_require__(237),
    isArray = __webpack_require__(34),
    isSymbol = __webpack_require__(147);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(1731);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(662),
    arrayIncludes = __webpack_require__(1633),
    arrayIncludesWith = __webpack_require__(1634),
    cacheHas = __webpack_require__(673),
    createSet = __webpack_require__(1685),
    setToArray = __webpack_require__(381);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(242),
    last = __webpack_require__(689),
    parent = __webpack_require__(1720),
    toKey = __webpack_require__(179);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(56);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(107)(module)))

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(374);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 1672 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(143);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(374);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(147);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(1675);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),
/* 1677 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(178),
    getSymbols = __webpack_require__(376);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(178),
    getSymbolsIn = __webpack_require__(679);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(56);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(146);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 1682 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(55),
    isArrayLike = __webpack_require__(146),
    keys = __webpack_require__(148);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

var baseRange = __webpack_require__(1658),
    isIterateeCall = __webpack_require__(245),
    toFinite = __webpack_require__(696);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(661),
    noop = __webpack_require__(1744),
    setToArray = __webpack_require__(381);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(386);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(143),
    Uint8Array = __webpack_require__(663),
    eq = __webpack_require__(247),
    equalArrays = __webpack_require__(675),
    mapToArray = __webpack_require__(1715),
    setToArray = __webpack_require__(381);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(677);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(1736),
    overRest = __webpack_require__(683),
    setToString = __webpack_require__(684);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(680),
    keys = __webpack_require__(148);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(143);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1692 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(242),
    isArguments = __webpack_require__(382),
    isArray = __webpack_require__(34),
    isIndex = __webpack_require__(377),
    isLength = __webpack_require__(384),
    toKey = __webpack_require__(179);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(246);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1695 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(246);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1697 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(246);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1698 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(246);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1699 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(374),
    cloneDataView = __webpack_require__(1671),
    cloneRegExp = __webpack_require__(1672),
    cloneSymbol = __webpack_require__(1673),
    cloneTypedArray = __webpack_require__(1674);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(1638),
    getPrototype = __webpack_require__(375),
    isPrototype = __webpack_require__(379);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(143),
    isArguments = __webpack_require__(382),
    isArray = __webpack_require__(34);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 1703 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1680);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1705 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(238);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(238);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(238);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(238);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1626),
    ListCache = __webpack_require__(236),
    Map = __webpack_require__(366);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(243);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(243);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(243);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(243);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1715 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(1742);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(682);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1718 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 1719 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(240),
    baseSlice = __webpack_require__(1661);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 1721 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1722 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1723 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(236);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1725 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1726 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1727 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(236),
    Map = __webpack_require__(366),
    MapCache = __webpack_require__(367);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1729 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 1730 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1716);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 1731 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 1732 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 1733 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(1683),
    findIndex = __webpack_require__(1734);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(667),
    baseIteratee = __webpack_require__(55),
    toInteger = __webpack_require__(1751);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(372),
    map = __webpack_require__(1740);

/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */
function flatMap(collection, iteratee) {
  return baseFlatten(map(collection, iteratee), 1);
}

module.exports = flatMap;


/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(372);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1641),
    hasPath = __webpack_require__(1693);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 1738 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(1645),
    baseUnary = __webpack_require__(241),
    nodeUtil = __webpack_require__(380);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(1649),
    baseUnary = __webpack_require__(241),
    nodeUtil = __webpack_require__(380);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(237),
    baseIteratee = __webpack_require__(55),
    baseMap = __webpack_require__(672),
    isArray = __webpack_require__(34);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 1741 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(370),
    baseForOwn = __webpack_require__(668),
    baseIteratee = __webpack_require__(55);

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, key, iteratee(value, key, object));
  });
  return result;
}

module.exports = mapValues;


/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(367);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 1743 */
/***/ (function(module, exports, __webpack_require__) {

var baseExtremum = __webpack_require__(239),
    baseIteratee = __webpack_require__(55),
    baseLt = __webpack_require__(671);

/**
 * This method is like `_.min` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * the value is ranked. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * var objects = [{ 'n': 1 }, { 'n': 2 }];
 *
 * _.minBy(objects, function(o) { return o.n; });
 * // => { 'n': 1 }
 *
 * // The `_.property` iteratee shorthand.
 * _.minBy(objects, 'n');
 * // => { 'n': 1 }
 */
function minBy(array, iteratee) {
  return (array && array.length)
    ? baseExtremum(array, baseIteratee(iteratee, 2), baseLt)
    : undefined;
}

module.exports = minBy;


/***/ }),
/* 1744 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 1745 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(56);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 1746 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1656),
    basePropertyDeep = __webpack_require__(1657),
    isKey = __webpack_require__(378),
    toKey = __webpack_require__(179);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

var arraySome = __webpack_require__(665),
    baseIteratee = __webpack_require__(55),
    baseSome = __webpack_require__(1662),
    isArray = __webpack_require__(34),
    isIterateeCall = __webpack_require__(245);

/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = isArray(collection) ? arraySome : baseSome;
  if (guard && isIterateeCall(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = some;


/***/ }),
/* 1748 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(55),
    baseSum = __webpack_require__(1664);

/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */
function sumBy(array, iteratee) {
  return (array && array.length)
    ? baseSum(array, baseIteratee(iteratee, 2))
    : 0;
}

module.exports = sumBy;


/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(686),
    isObject = __webpack_require__(48);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(696);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1666);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies
 */
var balanced = __webpack_require__(1754)
var reduceFunctionCall = __webpack_require__(1755)
var mexp = __webpack_require__(1295)

/**
 * Constantes
 */
var MAX_STACK = 100 // should be enough for a single calc()...
var NESTED_CALC_RE = /(\+|\-|\*|\\|[^a-z]|)(\s*)(\()/g

/**
 * Global variables
 */
var stack

/**
 * Expose reduceCSSCalc plugin
 *
 * @type {Function}
 */
module.exports = reduceCSSCalc

/**
 * Reduce CSS calc() in a string, whenever it's possible
 *
 * @param {String} value css input
 */
function reduceCSSCalc(value, decimalPrecision) {
  stack = 0
  decimalPrecision = Math.pow(10, decimalPrecision === undefined ? 5 : decimalPrecision)

  // Allow calc() on multiple lines
  value = value.replace(/\n+/g, " ")

  /**
   * Evaluates an expression
   *
   * @param {String} expression
   * @returns {String}
   */
  function evaluateExpression (expression, functionIdentifier, call) {
    if (stack++ > MAX_STACK) {
      stack = 0
      throw new Error("Call stack overflow for " + call)
    }

    if (expression === "") {
      throw new Error(functionIdentifier + "(): '" + call + "' must contain a non-whitespace string")
    }

    expression = evaluateNestedExpression(expression, call)

    var units = getUnitsInExpression(expression)

    // If the expression contains multiple units or CSS variables,
    // then let the expression be (i.e. browser calc())
    if (units.length > 1 || expression.indexOf("var(") > -1) {
      return functionIdentifier + "(" + expression + ")"
    }

    var unit = units[0] || ""

    if (unit === "%") {
      // Convert percentages to numbers, to handle expressions like: 50% * 50% (will become: 25%):
      // console.log(expression)
      expression = expression.replace(/\b[0-9\.]+%/g, function(percent) {
        return parseFloat(percent.slice(0, -1)) * 0.01
      })
    }

    // Remove units in expression:
    var toEvaluate = expression.replace(new RegExp(unit, "gi"), "")
    var result

    try {
      result = mexp.eval(toEvaluate)
    }
    catch (e) {
      return functionIdentifier + "(" + expression + ")"
    }

    // Transform back to a percentage result:
    if (unit === "%") {
      result *= 100
    }

    // adjust rounding shit
    // (0.1 * 0.2 === 0.020000000000000004)
    if (functionIdentifier.length || unit === "%") {
      result = Math.round(result * decimalPrecision) / decimalPrecision
    }

    // Add unit
    result += unit

    return result
  }

  /**
   * Evaluates nested expressions
   *
   * @param {String} expression
   * @returns {String}
   */
  function evaluateNestedExpression(expression, call) {
    // Remove the calc part from nested expressions to ensure
    // better browser compatibility
    expression = expression.replace(/((?:\-[a-z]+\-)?calc)/g, "")
    var evaluatedPart = ""
    var nonEvaluatedPart = expression
    var matches
    while ((matches = NESTED_CALC_RE.exec(nonEvaluatedPart))) {
      if (matches[0].index > 0) {
        evaluatedPart += nonEvaluatedPart.substring(0, matches[0].index)
      }

      var balancedExpr = balanced("(", ")", nonEvaluatedPart.substring([0].index))
      if (balancedExpr.body === "") {
        throw new Error("'" + expression + "' must contain a non-whitespace string")
      }

      var evaluated = evaluateExpression(balancedExpr.body, "", call)

      evaluatedPart += balancedExpr.pre + evaluated
      nonEvaluatedPart = balancedExpr.post
    }

    return evaluatedPart + nonEvaluatedPart
  }

  return reduceFunctionCall(value, /((?:\-[a-z]+\-)?calc)\(/, evaluateExpression)
}

/**
 * Checks what units are used in an expression
 *
 * @param {String} expression
 * @returns {Array}
 */

function getUnitsInExpression(expression) {
  var uniqueUnits = []
  var uniqueLowerCaseUnits = []
  var unitRegEx = /[\.0-9]([%a-z]+)/gi
  var matches = unitRegEx.exec(expression)

  while (matches) {
    if (!matches || !matches[1]) {
      continue
    }

    if (uniqueLowerCaseUnits.indexOf(matches[1].toLowerCase()) === -1) {
      uniqueUnits.push(matches[1])
      uniqueLowerCaseUnits.push(matches[1].toLowerCase())
    }

    matches = unitRegEx.exec(expression)
  }

  return uniqueUnits
}


/***/ }),
/* 1754 */
/***/ (function(module, exports) {

module.exports = balanced;
function balanced(a, b, str) {
  if (a instanceof RegExp) a = maybeMatch(a, str);
  if (b instanceof RegExp) b = maybeMatch(b, str);

  var r = range(a, b, str);

  return r && {
    start: r[0],
    end: r[1],
    pre: str.slice(0, r[0]),
    body: str.slice(r[0] + a.length, r[1]),
    post: str.slice(r[1] + b.length)
  };
}

function maybeMatch(reg, str) {
  var m = str.match(reg);
  return m ? m[0] : null;
}

balanced.range = range;
function range(a, b, str) {
  var begs, beg, left, right, result;
  var ai = str.indexOf(a);
  var bi = str.indexOf(b, ai + 1);
  var i = ai;

  if (ai >= 0 && bi > 0) {
    begs = [];
    left = str.length;

    while (i >= 0 && !result) {
      if (i == ai) {
        begs.push(i);
        ai = str.indexOf(a, i + 1);
      } else if (begs.length == 1) {
        result = [ begs.pop(), bi ];
      } else {
        beg = begs.pop();
        if (beg < left) {
          left = beg;
          right = bi;
        }

        bi = str.indexOf(b, i + 1);
      }

      i = ai < bi && ai >= 0 ? ai : bi;
    }

    if (begs.length) {
      result = [ left, right ];
    }
  }

  return result;
}


/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * Module dependencies
 */
var balanced = __webpack_require__(1756)

/**
 * Expose `reduceFunctionCall`
 *
 * @type {Function}
 */
module.exports = reduceFunctionCall

/**
 * Walkthrough all expressions, evaluate them and insert them into the declaration
 *
 * @param {Array} expressions
 * @param {Object} declaration
 */

function reduceFunctionCall(string, functionRE, callback) {
  var call = string
  return getFunctionCalls(string, functionRE).reduce(function(string, obj) {
    return string.replace(obj.functionIdentifier + "(" + obj.matches.body + ")", evalFunctionCall(obj.matches.body, obj.functionIdentifier, callback, call, functionRE))
  }, string)
}

/**
 * Parses expressions in a value
 *
 * @param {String} value
 * @returns {Array}
 * @api private
 */

function getFunctionCalls(call, functionRE) {
  var expressions = []

  var fnRE = typeof functionRE === "string" ? new RegExp("\\b(" + functionRE + ")\\(") : functionRE
  do {
    var searchMatch = fnRE.exec(call)
    if (!searchMatch) {
      return expressions
    }
    if (searchMatch[1] === undefined) {
      throw new Error("Missing the first couple of parenthesis to get the function identifier in " + functionRE)
    }
    var fn = searchMatch[1]
    var startIndex = searchMatch.index
    var matches = balanced("(", ")", call.substring(startIndex))

    if (!matches || matches.start !== searchMatch[0].length - 1) {
      throw new SyntaxError(fn + "(): missing closing ')' in the value '" + call + "'")
    }

    expressions.push({matches: matches, functionIdentifier: fn})
    call = matches.post
  }
  while (fnRE.test(call))

  return expressions
}

/**
 * Evaluates an expression
 *
 * @param {String} expression
 * @returns {String}
 * @api private
 */

function evalFunctionCall (string, functionIdentifier, callback, call, functionRE) {
  // allow recursivity
  return callback(reduceFunctionCall(string, functionRE, callback), functionIdentifier, call)
}


/***/ }),
/* 1756 */
/***/ (function(module, exports) {

module.exports = balanced;
function balanced(a, b, str) {
  if (a instanceof RegExp) a = maybeMatch(a, str);
  if (b instanceof RegExp) b = maybeMatch(b, str);

  var r = range(a, b, str);

  return r && {
    start: r[0],
    end: r[1],
    pre: str.slice(0, r[0]),
    body: str.slice(r[0] + a.length, r[1]),
    post: str.slice(r[1] + b.length)
  };
}

function maybeMatch(reg, str) {
  var m = str.match(reg);
  return m ? m[0] : null;
}

balanced.range = range;
function range(a, b, str) {
  var begs, beg, left, right, result;
  var ai = str.indexOf(a);
  var bi = str.indexOf(b, ai + 1);
  var i = ai;

  if (ai >= 0 && bi > 0) {
    begs = [];
    left = str.length;

    while (i >= 0 && !result) {
      if (i == ai) {
        begs.push(i);
        ai = str.indexOf(a, i + 1);
      } else if (begs.length == 1) {
        result = [ begs.pop(), bi ];
      } else {
        beg = begs.pop();
        if (beg < left) {
          left = beg;
          right = bi;
        }

        bi = str.indexOf(b, i + 1);
      }

      i = ai < bi && ai >= 0 ? ai : bi;
    }

    if (begs.length) {
      result = [ left, right ];
    }
  }

  return result;
}


/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(1758);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51)))

/***/ }),
/* 1759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(51)))

/***/ }),
/* 1760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(1035)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/



var randomBytes = __webpack_require__(1763);

// Generate an internal UID to make the regexp pattern harder to guess.
var UID_LENGTH          = 16;
var UID                 = generateUID();
var PLACE_HOLDER_REGEXP = new RegExp('(\\\\)?"@__(F|R|D|M|S|U|I|B)-' + UID + '-(\\d+)__@"', 'g');

var IS_NATIVE_CODE_REGEXP = /\{\s*\[native code\]\s*\}/g;
var IS_PURE_FUNCTION = /function.*?\(/;
var IS_ARROW_FUNCTION = /.*?=>.*?/;
var UNSAFE_CHARS_REGEXP   = /[<>\/\u2028\u2029]/g;

var RESERVED_SYMBOLS = ['*', 'async'];

// Mapping of unsafe HTML and invalid JavaScript line terminator chars to their
// Unicode char counterparts which are safe to use in JavaScript strings.
var ESCAPED_CHARS = {
    '<'     : '\\u003C',
    '>'     : '\\u003E',
    '/'     : '\\u002F',
    '\u2028': '\\u2028',
    '\u2029': '\\u2029'
};

function escapeUnsafeChars(unsafeChar) {
    return ESCAPED_CHARS[unsafeChar];
}

function generateUID() {
    var bytes = randomBytes(UID_LENGTH);
    var result = '';
    for(var i=0; i<UID_LENGTH; ++i) {
        result += bytes[i].toString(16);
    }
    return result;
}

function deleteFunctions(obj){
    var functionKeys = [];
    for (var key in obj) {
        if (typeof obj[key] === "function") {
            functionKeys.push(key);
        }
    }
    for (var i = 0; i < functionKeys.length; i++) {
        delete obj[functionKeys[i]];
    }
}

module.exports = function serialize(obj, options) {
    options || (options = {});

    // Backwards-compatibility for `space` as the second argument.
    if (typeof options === 'number' || typeof options === 'string') {
        options = {space: options};
    }

    var functions = [];
    var regexps   = [];
    var dates     = [];
    var maps      = [];
    var sets      = [];
    var undefs    = [];
    var infinities= [];
    var bigInts = [];

    // Returns placeholders for functions and regexps (identified by index)
    // which are later replaced by their string representation.
    function replacer(key, value) {

        // For nested function
        if(options.ignoreFunction){
            deleteFunctions(value);
        }

        if (!value && value !== undefined) {
            return value;
        }

        // If the value is an object w/ a toJSON method, toJSON is called before
        // the replacer runs, so we use this[key] to get the non-toJSONed value.
        var origValue = this[key];
        var type = typeof origValue;

        if (type === 'object') {
            if(origValue instanceof RegExp) {
                return '@__R-' + UID + '-' + (regexps.push(origValue) - 1) + '__@';
            }

            if(origValue instanceof Date) {
                return '@__D-' + UID + '-' + (dates.push(origValue) - 1) + '__@';
            }

            if(origValue instanceof Map) {
                return '@__M-' + UID + '-' + (maps.push(origValue) - 1) + '__@';
            }

            if(origValue instanceof Set) {
                return '@__S-' + UID + '-' + (sets.push(origValue) - 1) + '__@';
            }
        }

        if (type === 'function') {
            return '@__F-' + UID + '-' + (functions.push(origValue) - 1) + '__@';
        }

        if (type === 'undefined') {
            return '@__U-' + UID + '-' + (undefs.push(origValue) - 1) + '__@';
        }

        if (type === 'number' && !isNaN(origValue) && !isFinite(origValue)) {
            return '@__I-' + UID + '-' + (infinities.push(origValue) - 1) + '__@';
        }

        if (type === 'bigint') {
            return '@__B-' + UID + '-' + (bigInts.push(origValue) - 1) + '__@';
        }

        return value;
    }

    function serializeFunc(fn) {
      var serializedFn = fn.toString();
      if (IS_NATIVE_CODE_REGEXP.test(serializedFn)) {
          throw new TypeError('Serializing native function: ' + fn.name);
      }

      // pure functions, example: {key: function() {}}
      if(IS_PURE_FUNCTION.test(serializedFn)) {
          return serializedFn;
      }

      // arrow functions, example: arg1 => arg1+5
      if(IS_ARROW_FUNCTION.test(serializedFn)) {
          return serializedFn;
      }

      var argsStartsAt = serializedFn.indexOf('(');
      var def = serializedFn.substr(0, argsStartsAt)
        .trim()
        .split(' ')
        .filter(function(val) { return val.length > 0 });

      var nonReservedSymbols = def.filter(function(val) {
        return RESERVED_SYMBOLS.indexOf(val) === -1
      });

      // enhanced literal objects, example: {key() {}}
      if(nonReservedSymbols.length > 0) {
          return (def.indexOf('async') > -1 ? 'async ' : '') + 'function'
            + (def.join('').indexOf('*') > -1 ? '*' : '')
            + serializedFn.substr(argsStartsAt);
      }

      // arrow functions
      return serializedFn;
    }

    // Check if the parameter is function
    if (options.ignoreFunction && typeof obj === "function") {
        obj = undefined;
    }
    // Protects against `JSON.stringify()` returning `undefined`, by serializing
    // to the literal string: "undefined".
    if (obj === undefined) {
        return String(obj);
    }

    var str;

    // Creates a JSON string representation of the value.
    // NOTE: Node 0.12 goes into slow mode with extra JSON.stringify() args.
    if (options.isJSON && !options.space) {
        str = JSON.stringify(obj);
    } else {
        str = JSON.stringify(obj, options.isJSON ? null : replacer, options.space);
    }

    // Protects against `JSON.stringify()` returning `undefined`, by serializing
    // to the literal string: "undefined".
    if (typeof str !== 'string') {
        return String(str);
    }

    // Replace unsafe HTML and invalid JavaScript line terminator chars with
    // their safe Unicode char counterpart. This _must_ happen before the
    // regexps and functions are serialized and added back to the string.
    if (options.unsafe !== true) {
        str = str.replace(UNSAFE_CHARS_REGEXP, escapeUnsafeChars);
    }

    if (functions.length === 0 && regexps.length === 0 && dates.length === 0 && maps.length === 0 && sets.length === 0 && undefs.length === 0 && infinities.length === 0 && bigInts.length === 0) {
        return str;
    }

    // Replaces all occurrences of function, regexp, date, map and set placeholders in the
    // JSON string with their string representations. If the original value can
    // not be found, then `undefined` is used.
    return str.replace(PLACE_HOLDER_REGEXP, function (match, backSlash, type, valueIndex) {
        // The placeholder may not be preceded by a backslash. This is to prevent
        // replacing things like `"a\"@__R-<UID>-0__@"` and thus outputting
        // invalid JS.
        if (backSlash) {
            return match;
        }

        if (type === 'D') {
            return "new Date(\"" + dates[valueIndex].toISOString() + "\")";
        }

        if (type === 'R') {
            return "new RegExp(" + serialize(regexps[valueIndex].source) + ", \"" + regexps[valueIndex].flags + "\")";
        }

        if (type === 'M') {
            return "new Map(" + serialize(Array.from(maps[valueIndex].entries()), options) + ")";
        }

        if (type === 'S') {
            return "new Set(" + serialize(Array.from(sets[valueIndex].values()), options) + ")";
        }

        if (type === 'U') {
            return 'undefined'
        }

        if (type === 'I') {
            return infinities[valueIndex];
        }

        if (type === 'B') {
            return "BigInt(\"" + bigInts[valueIndex] + "\")";
        }

        var fn = functions[valueIndex];

        return serializeFunc(fn);
    });
}


/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var MAX_BYTES = 65536

// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var MAX_UINT32 = 4294967295

function oldBrowser () {
  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
}

var Buffer = __webpack_require__(1761).Buffer
var crypto = global.crypto || global.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > MAX_UINT32) throw new RangeError('requested too many random bytes')

  var bytes = Buffer.allocUnsafe(size)

  if (size > 0) {  // getRandomValues fails on IE if size == 0
    if (size > MAX_BYTES) { // this is the max bytes crypto.getRandomValues
      // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
      for (var generated = 0; generated < size; generated += MAX_BYTES) {
        // buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        crypto.getRandomValues(bytes.slice(generated, generated + MAX_BYTES))
      }
    } else {
      crypto.getRandomValues(bytes)
    }
  }

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(51), __webpack_require__(102)))

/***/ }),
/* 1764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invariant; });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? prefix + ": " + provided : prefix;
    throw new Error(value);
}




/***/ }),
/* 1765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createUncontrollable;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(201);

var _invariant2 = _interopRequireDefault(_invariant);

var _utils = __webpack_require__(1767);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function createUncontrollable(mixin, set) {

  return uncontrollable;

  function uncontrollable(Component, controlledValues) {
    var _class, _temp;

    var methods = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var displayName = Component.displayName || Component.name || 'Component',
        basePropTypes = utils.getType(Component).propTypes,
        isCompositeComponent = utils.isReactComponent(Component),
        controlledProps = Object.keys(controlledValues),
        propTypes;

    var OMIT_PROPS = ['valueLink', 'checkedLink'].concat(controlledProps.map(utils.defaultKey));

    propTypes = utils.uncontrolledPropTypes(controlledValues, basePropTypes, displayName);

    (0, _invariant2.default)(isCompositeComponent || !methods.length, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', '));

    methods = utils.transform(methods, function (obj, method) {
      obj[method] = function () {
        var _refs$inner;

        return (_refs$inner = this.refs.inner)[method].apply(_refs$inner, arguments);
      };
    }, {});

    var component = (_temp = _class = function (_React$Component) {
      _inherits(component, _React$Component);

      function component() {
        _classCallCheck(this, component);

        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
      }

      component.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return !mixin.shouldComponentUpdate || mixin.shouldComponentUpdate.apply(this, args);
      };

      component.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        var props = this.props;

        this._values = {};

        controlledProps.forEach(function (key) {
          _this2._values[key] = props[utils.defaultKey(key)];
        });
      };

      /**
       * If a prop switches from controlled to Uncontrolled
       * reset its value to the defaultValue
       */


      component.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var _this3 = this;

        var props = this.props;

        if (mixin.componentWillReceiveProps) {
          mixin.componentWillReceiveProps.call(this, nextProps);
        }

        controlledProps.forEach(function (key) {
          if (utils.getValue(nextProps, key) === undefined && utils.getValue(props, key) !== undefined) {
            _this3._values[key] = nextProps[utils.defaultKey(key)];
          }
        });
      };

      component.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unmounted = true;
      };

      component.prototype.getControlledInstance = function getControlledInstance() {
        return this.refs.inner;
      };

      component.prototype.render = function render() {
        var _this4 = this;

        var newProps = {},
            props = omitProps(this.props);

        utils.each(controlledValues, function (handle, propName) {
          var linkPropName = utils.getLinkName(propName),
              prop = _this4.props[propName];

          if (linkPropName && !isProp(_this4.props, propName) && isProp(_this4.props, linkPropName)) {
            prop = _this4.props[linkPropName].value;
          }

          newProps[propName] = prop !== undefined ? prop : _this4._values[propName];

          newProps[handle] = setAndNotify.bind(_this4, propName);
        });

        newProps = _extends({}, props, newProps, {
          ref: isCompositeComponent ? 'inner' : null
        });

        return _react2.default.createElement(Component, newProps);
      };

      return component;
    }(_react2.default.Component), _class.displayName = 'Uncontrolled(' + displayName + ')', _class.propTypes = propTypes, _temp);

    _extends(component.prototype, methods);

    component.ControlledComponent = Component;

    /**
     * useful when wrapping a Component and you want to control
     * everything
     */
    component.deferControlTo = function (newComponent) {
      var additions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var nextMethods = arguments[2];

      return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
    };

    return component;

    function setAndNotify(propName, value) {
      var linkName = utils.getLinkName(propName),
          handler = this.props[controlledValues[propName]];

      if (linkName && isProp(this.props, linkName) && !handler) {
        handler = this.props[linkName].requestChange;
      }

      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      set(this, propName, handler, value, args);
    }

    function isProp(props, prop) {
      return props[prop] !== undefined;
    }

    function omitProps(props) {
      var result = {};

      utils.each(props, function (value, key) {
        if (OMIT_PROPS.indexOf(key) === -1) result[key] = value;
      });

      return result;
    }
  }
}
module.exports = exports['default'];

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.version = undefined;
exports.uncontrolledPropTypes = uncontrolledPropTypes;
exports.getType = getType;
exports.getValue = getValue;
exports.getLinkName = getLinkName;
exports.defaultKey = defaultKey;
exports.chain = chain;
exports.transform = transform;
exports.each = each;
exports.has = has;
exports.isReactComponent = isReactComponent;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _invariant = __webpack_require__(201);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function readOnlyPropType(handler, name) {
  return function (props, propName) {
    if (props[propName] !== undefined) {
      if (!props[handler]) {
        return new Error('You have provided a `' + propName + '` prop to ' + '`' + name + '` without an `' + handler + '` handler. This will render a read-only field. ' + 'If the field should be mutable use `' + defaultKey(propName) + '`. Otherwise, set `' + handler + '`');
      }
    }
  };
}

function uncontrolledPropTypes(controlledValues, basePropTypes, displayName) {
  var propTypes = {};

  if (false) {
    transform(controlledValues, function (obj, handler, prop) {
      (0, _invariant2.default)(typeof handler === 'string' && handler.trim().length, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop);

      obj[prop] = readOnlyPropType(handler, displayName);
    }, propTypes);
  }

  return propTypes;
}

var version = exports.version = _react2.default.version.split('.').map(parseFloat);

function getType(component) {
  if (version[0] >= 15 || version[0] === 0 && version[1] >= 13) return component;

  return component.type;
}

function getValue(props, name) {
  var linkPropName = getLinkName(name);

  if (linkPropName && !isProp(props, name) && isProp(props, linkPropName)) return props[linkPropName].value;

  return props[name];
}

function isProp(props, prop) {
  return props[prop] !== undefined;
}

function getLinkName(name) {
  return name === 'value' ? 'valueLink' : name === 'checked' ? 'checkedLink' : null;
}

function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}

function chain(thisArg, a, b) {
  return function chainedFunction() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    a && a.call.apply(a, [thisArg].concat(args));
    b && b.call.apply(b, [thisArg].concat(args));
  };
}

function transform(obj, cb, seed) {
  each(obj, cb.bind(null, seed = seed || (Array.isArray(obj) ? [] : {})));
  return seed;
}

function each(obj, cb, thisArg) {
  if (Array.isArray(obj)) return obj.forEach(cb, thisArg);

  for (var key in obj) {
    if (has(obj, key)) cb.call(thisArg, obj[key], key, obj);
  }
}

function has(o, k) {
  return o ? Object.prototype.hasOwnProperty.call(o, k) : false;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
function isReactComponent(component) {
  return !!(component && component.prototype && component.prototype.isReactComponent);
}

/***/ }),
/* 1768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 1769 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 1770 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 1771 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(699);
module.exports = __webpack_require__(700);


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.96fa30ad.js